/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(153);
	module.exports = __webpack_require__(344);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};//! moment.js
	//! version : 2.10.6
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	(function(global,factory){( false?'undefined':_typeof(exports))==='object'&&typeof module!=='undefined'?module.exports=factory(): true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):global.moment=factory();})(undefined,function(){'use strict';var hookCallback;function utils_hooks__hooks(){return hookCallback.apply(null,arguments);}// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback(callback){hookCallback=callback;}function isArray(input){return Object.prototype.toString.call(input)==='[object Array]';}function isDate(input){return input instanceof Date||Object.prototype.toString.call(input)==='[object Date]';}function map(arr,fn){var res=[],i;for(i=0;i<arr.length;++i){res.push(fn(arr[i],i));}return res;}function hasOwnProp(a,b){return Object.prototype.hasOwnProperty.call(a,b);}function extend(a,b){for(var i in b){if(hasOwnProp(b,i)){a[i]=b[i];}}if(hasOwnProp(b,'toString')){a.toString=b.toString;}if(hasOwnProp(b,'valueOf')){a.valueOf=b.valueOf;}return a;}function create_utc__createUTC(input,format,locale,strict){return createLocalOrUTC(input,format,locale,strict,true).utc();}function defaultParsingFlags(){// We need to deep clone this object.
	return{empty:false,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:false,invalidMonth:null,invalidFormat:false,userInvalidated:false,iso:false};}function getParsingFlags(m){if(m._pf==null){m._pf=defaultParsingFlags();}return m._pf;}function valid__isValid(m){if(m._isValid==null){var flags=getParsingFlags(m);m._isValid=!isNaN(m._d.getTime())&&flags.overflow<0&&!flags.empty&&!flags.invalidMonth&&!flags.invalidWeekday&&!flags.nullInput&&!flags.invalidFormat&&!flags.userInvalidated;if(m._strict){m._isValid=m._isValid&&flags.charsLeftOver===0&&flags.unusedTokens.length===0&&flags.bigHour===undefined;}}return m._isValid;}function valid__createInvalid(flags){var m=create_utc__createUTC(NaN);if(flags!=null){extend(getParsingFlags(m),flags);}else{getParsingFlags(m).userInvalidated=true;}return m;}var momentProperties=utils_hooks__hooks.momentProperties=[];function copyConfig(to,from){var i,prop,val;if(typeof from._isAMomentObject!=='undefined'){to._isAMomentObject=from._isAMomentObject;}if(typeof from._i!=='undefined'){to._i=from._i;}if(typeof from._f!=='undefined'){to._f=from._f;}if(typeof from._l!=='undefined'){to._l=from._l;}if(typeof from._strict!=='undefined'){to._strict=from._strict;}if(typeof from._tzm!=='undefined'){to._tzm=from._tzm;}if(typeof from._isUTC!=='undefined'){to._isUTC=from._isUTC;}if(typeof from._offset!=='undefined'){to._offset=from._offset;}if(typeof from._pf!=='undefined'){to._pf=getParsingFlags(from);}if(typeof from._locale!=='undefined'){to._locale=from._locale;}if(momentProperties.length>0){for(i in momentProperties){prop=momentProperties[i];val=from[prop];if(typeof val!=='undefined'){to[prop]=val;}}}return to;}var updateInProgress=false;// Moment prototype object
	function Moment(config){copyConfig(this,config);this._d=new Date(config._d!=null?config._d.getTime():NaN);// Prevent infinite loop in case updateOffset creates new moment
	// objects.
	if(updateInProgress===false){updateInProgress=true;utils_hooks__hooks.updateOffset(this);updateInProgress=false;}}function isMoment(obj){return obj instanceof Moment||obj!=null&&obj._isAMomentObject!=null;}function absFloor(number){if(number<0){return Math.ceil(number);}else{return Math.floor(number);}}function toInt(argumentForCoercion){var coercedNumber=+argumentForCoercion,value=0;if(coercedNumber!==0&&isFinite(coercedNumber)){value=absFloor(coercedNumber);}return value;}function compareArrays(array1,array2,dontConvert){var len=Math.min(array1.length,array2.length),lengthDiff=Math.abs(array1.length-array2.length),diffs=0,i;for(i=0;i<len;i++){if(dontConvert&&array1[i]!==array2[i]||!dontConvert&&toInt(array1[i])!==toInt(array2[i])){diffs++;}}return diffs+lengthDiff;}function Locale(){}var locales={};var globalLocale;function normalizeLocale(key){return key?key.toLowerCase().replace('_','-'):key;}// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names){var i=0,j,next,locale,split;while(i<names.length){split=normalizeLocale(names[i]).split('-');j=split.length;next=normalizeLocale(names[i+1]);next=next?next.split('-'):null;while(j>0){locale=loadLocale(split.slice(0,j).join('-'));if(locale){return locale;}if(next&&next.length>=j&&compareArrays(split,next,true)>=j-1){//the next array item is better than a shallower substring of this one
	break;}j--;}i++;}return null;}function loadLocale(name){var oldLocale=null;// TODO: Find a better way to register and load all the locales in Node
	if(!locales[name]&&typeof module!=='undefined'&&module&&module.exports){try{oldLocale=globalLocale._abbr;__webpack_require__(361)("./"+name);// because defineLocale currently also sets the global locale, we
	// want to undo that for lazy loaded locales
	locale_locales__getSetGlobalLocale(oldLocale);}catch(e){}}return locales[name];}// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function locale_locales__getSetGlobalLocale(key,values){var data;if(key){if(typeof values==='undefined'){data=locale_locales__getLocale(key);}else{data=defineLocale(key,values);}if(data){// moment.duration._locale = moment._locale = data;
	globalLocale=data;}}return globalLocale._abbr;}function defineLocale(name,values){if(values!==null){values.abbr=name;locales[name]=locales[name]||new Locale();locales[name].set(values);// backwards compat for now: also set the locale
	locale_locales__getSetGlobalLocale(name);return locales[name];}else{// useful for testing
	delete locales[name];return null;}}// returns locale data
	function locale_locales__getLocale(key){var locale;if(key&&key._locale&&key._locale._abbr){key=key._locale._abbr;}if(!key){return globalLocale;}if(!isArray(key)){//short-circuit everything else
	locale=loadLocale(key);if(locale){return locale;}key=[key];}return chooseLocale(key);}var aliases={};function addUnitAlias(unit,shorthand){var lowerCase=unit.toLowerCase();aliases[lowerCase]=aliases[lowerCase+'s']=aliases[shorthand]=unit;}function normalizeUnits(units){return typeof units==='string'?aliases[units]||aliases[units.toLowerCase()]:undefined;}function normalizeObjectUnits(inputObject){var normalizedInput={},normalizedProp,prop;for(prop in inputObject){if(hasOwnProp(inputObject,prop)){normalizedProp=normalizeUnits(prop);if(normalizedProp){normalizedInput[normalizedProp]=inputObject[prop];}}}return normalizedInput;}function makeGetSet(unit,keepTime){return function(value){if(value!=null){get_set__set(this,unit,value);utils_hooks__hooks.updateOffset(this,keepTime);return this;}else{return get_set__get(this,unit);}};}function get_set__get(mom,unit){return mom._d['get'+(mom._isUTC?'UTC':'')+unit]();}function get_set__set(mom,unit,value){return mom._d['set'+(mom._isUTC?'UTC':'')+unit](value);}// MOMENTS
	function getSet(units,value){var unit;if((typeof units==='undefined'?'undefined':_typeof(units))==='object'){for(unit in units){this.set(unit,units[unit]);}}else{units=normalizeUnits(units);if(typeof this[units]==='function'){return this[units](value);}}return this;}function zeroFill(number,targetLength,forceSign){var absNumber=''+Math.abs(number),zerosToFill=targetLength-absNumber.length,sign=number>=0;return(sign?forceSign?'+':'':'-')+Math.pow(10,Math.max(0,zerosToFill)).toString().substr(1)+absNumber;}var formattingTokens=/(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;var localFormattingTokens=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;var formatFunctions={};var formatTokenFunctions={};// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken(token,padded,ordinal,callback){var func=callback;if(typeof callback==='string'){func=function func(){return this[callback]();};}if(token){formatTokenFunctions[token]=func;}if(padded){formatTokenFunctions[padded[0]]=function(){return zeroFill(func.apply(this,arguments),padded[1],padded[2]);};}if(ordinal){formatTokenFunctions[ordinal]=function(){return this.localeData().ordinal(func.apply(this,arguments),token);};}}function removeFormattingTokens(input){if(input.match(/\[[\s\S]/)){return input.replace(/^\[|\]$/g,'');}return input.replace(/\\/g,'');}function makeFormatFunction(format){var array=format.match(formattingTokens),i,length;for(i=0,length=array.length;i<length;i++){if(formatTokenFunctions[array[i]]){array[i]=formatTokenFunctions[array[i]];}else{array[i]=removeFormattingTokens(array[i]);}}return function(mom){var output='';for(i=0;i<length;i++){output+=array[i]instanceof Function?array[i].call(mom,format):array[i];}return output;};}// format date using native date object
	function formatMoment(m,format){if(!m.isValid()){return m.localeData().invalidDate();}format=expandFormat(format,m.localeData());formatFunctions[format]=formatFunctions[format]||makeFormatFunction(format);return formatFunctions[format](m);}function expandFormat(format,locale){var i=5;function replaceLongDateFormatTokens(input){return locale.longDateFormat(input)||input;}localFormattingTokens.lastIndex=0;while(i>=0&&localFormattingTokens.test(format)){format=format.replace(localFormattingTokens,replaceLongDateFormatTokens);localFormattingTokens.lastIndex=0;i-=1;}return format;}var match1=/\d/;//       0 - 9
	var match2=/\d\d/;//      00 - 99
	var match3=/\d{3}/;//     000 - 999
	var match4=/\d{4}/;//    0000 - 9999
	var match6=/[+-]?\d{6}/;// -999999 - 999999
	var match1to2=/\d\d?/;//       0 - 99
	var match1to3=/\d{1,3}/;//       0 - 999
	var match1to4=/\d{1,4}/;//       0 - 9999
	var match1to6=/[+-]?\d{1,6}/;// -999999 - 999999
	var matchUnsigned=/\d+/;//       0 - inf
	var matchSigned=/[+-]?\d+/;//    -inf - inf
	var matchOffset=/Z|[+-]\d\d:?\d\d/gi;// +00:00 -00:00 +0000 -0000 or Z
	var matchTimestamp=/[+-]?\d+(\.\d{1,3})?/;// 123456789 123456789.123
	// any word (or two) characters or numbers including two/three word month in arabic.
	var matchWord=/[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;var regexes={};function isFunction(sth){// https://github.com/moment/moment/issues/2325
	return typeof sth==='function'&&Object.prototype.toString.call(sth)==='[object Function]';}function addRegexToken(token,regex,strictRegex){regexes[token]=isFunction(regex)?regex:function(isStrict){return isStrict&&strictRegex?strictRegex:regex;};}function getParseRegexForToken(token,config){if(!hasOwnProp(regexes,token)){return new RegExp(unescapeFormat(token));}return regexes[token](config._strict,config._locale);}// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s){return s.replace('\\','').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(matched,p1,p2,p3,p4){return p1||p2||p3||p4;}).replace(/[-\/\\^$*+?.()|[\]{}]/g,'\\$&');}var tokens={};function addParseToken(token,callback){var i,func=callback;if(typeof token==='string'){token=[token];}if(typeof callback==='number'){func=function func(input,array){array[callback]=toInt(input);};}for(i=0;i<token.length;i++){tokens[token[i]]=func;}}function addWeekParseToken(token,callback){addParseToken(token,function(input,array,config,token){config._w=config._w||{};callback(input,config._w,config,token);});}function addTimeToArrayFromToken(token,input,config){if(input!=null&&hasOwnProp(tokens,token)){tokens[token](input,config._a,config,token);}}var YEAR=0;var MONTH=1;var DATE=2;var HOUR=3;var MINUTE=4;var SECOND=5;var MILLISECOND=6;function daysInMonth(year,month){return new Date(Date.UTC(year,month+1,0)).getUTCDate();}// FORMATTING
	addFormatToken('M',['MM',2],'Mo',function(){return this.month()+1;});addFormatToken('MMM',0,0,function(format){return this.localeData().monthsShort(this,format);});addFormatToken('MMMM',0,0,function(format){return this.localeData().months(this,format);});// ALIASES
	addUnitAlias('month','M');// PARSING
	addRegexToken('M',match1to2);addRegexToken('MM',match1to2,match2);addRegexToken('MMM',matchWord);addRegexToken('MMMM',matchWord);addParseToken(['M','MM'],function(input,array){array[MONTH]=toInt(input)-1;});addParseToken(['MMM','MMMM'],function(input,array,config,token){var month=config._locale.monthsParse(input,token,config._strict);// if we didn't find a month name, mark the date as invalid.
	if(month!=null){array[MONTH]=month;}else{getParsingFlags(config).invalidMonth=input;}});// LOCALES
	var defaultLocaleMonths='January_February_March_April_May_June_July_August_September_October_November_December'.split('_');function localeMonths(m){return this._months[m.month()];}var defaultLocaleMonthsShort='Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');function localeMonthsShort(m){return this._monthsShort[m.month()];}function localeMonthsParse(monthName,format,strict){var i,mom,regex;if(!this._monthsParse){this._monthsParse=[];this._longMonthsParse=[];this._shortMonthsParse=[];}for(i=0;i<12;i++){// make the regex if we don't have it already
	mom=create_utc__createUTC([2000,i]);if(strict&&!this._longMonthsParse[i]){this._longMonthsParse[i]=new RegExp('^'+this.months(mom,'').replace('.','')+'$','i');this._shortMonthsParse[i]=new RegExp('^'+this.monthsShort(mom,'').replace('.','')+'$','i');}if(!strict&&!this._monthsParse[i]){regex='^'+this.months(mom,'')+'|^'+this.monthsShort(mom,'');this._monthsParse[i]=new RegExp(regex.replace('.',''),'i');}// test the regex
	if(strict&&format==='MMMM'&&this._longMonthsParse[i].test(monthName)){return i;}else if(strict&&format==='MMM'&&this._shortMonthsParse[i].test(monthName)){return i;}else if(!strict&&this._monthsParse[i].test(monthName)){return i;}}}// MOMENTS
	function setMonth(mom,value){var dayOfMonth;// TODO: Move this out of here!
	if(typeof value==='string'){value=mom.localeData().monthsParse(value);// TODO: Another silent failure?
	if(typeof value!=='number'){return mom;}}dayOfMonth=Math.min(mom.date(),daysInMonth(mom.year(),value));mom._d['set'+(mom._isUTC?'UTC':'')+'Month'](value,dayOfMonth);return mom;}function getSetMonth(value){if(value!=null){setMonth(this,value);utils_hooks__hooks.updateOffset(this,true);return this;}else{return get_set__get(this,'Month');}}function getDaysInMonth(){return daysInMonth(this.year(),this.month());}function checkOverflow(m){var overflow;var a=m._a;if(a&&getParsingFlags(m).overflow===-2){overflow=a[MONTH]<0||a[MONTH]>11?MONTH:a[DATE]<1||a[DATE]>daysInMonth(a[YEAR],a[MONTH])?DATE:a[HOUR]<0||a[HOUR]>24||a[HOUR]===24&&(a[MINUTE]!==0||a[SECOND]!==0||a[MILLISECOND]!==0)?HOUR:a[MINUTE]<0||a[MINUTE]>59?MINUTE:a[SECOND]<0||a[SECOND]>59?SECOND:a[MILLISECOND]<0||a[MILLISECOND]>999?MILLISECOND:-1;if(getParsingFlags(m)._overflowDayOfYear&&(overflow<YEAR||overflow>DATE)){overflow=DATE;}getParsingFlags(m).overflow=overflow;}return m;}function warn(msg){if(utils_hooks__hooks.suppressDeprecationWarnings===false&&typeof console!=='undefined'&&console.warn){console.warn('Deprecation warning: '+msg);}}function deprecate(msg,fn){var firstTime=true;return extend(function(){if(firstTime){warn(msg+'\n'+new Error().stack);firstTime=false;}return fn.apply(this,arguments);},fn);}var deprecations={};function deprecateSimple(name,msg){if(!deprecations[name]){warn(msg);deprecations[name]=true;}}utils_hooks__hooks.suppressDeprecationWarnings=false;var from_string__isoRegex=/^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;var isoDates=[['YYYYYY-MM-DD',/[+-]\d{6}-\d{2}-\d{2}/],['YYYY-MM-DD',/\d{4}-\d{2}-\d{2}/],['GGGG-[W]WW-E',/\d{4}-W\d{2}-\d/],['GGGG-[W]WW',/\d{4}-W\d{2}/],['YYYY-DDD',/\d{4}-\d{3}/]];// iso time formats and regexes
	var isoTimes=[['HH:mm:ss.SSSS',/(T| )\d\d:\d\d:\d\d\.\d+/],['HH:mm:ss',/(T| )\d\d:\d\d:\d\d/],['HH:mm',/(T| )\d\d:\d\d/],['HH',/(T| )\d\d/]];var aspNetJsonRegex=/^\/?Date\((\-?\d+)/i;// date from iso format
	function configFromISO(config){var i,l,string=config._i,match=from_string__isoRegex.exec(string);if(match){getParsingFlags(config).iso=true;for(i=0,l=isoDates.length;i<l;i++){if(isoDates[i][1].exec(string)){config._f=isoDates[i][0];break;}}for(i=0,l=isoTimes.length;i<l;i++){if(isoTimes[i][1].exec(string)){// match[6] should be 'T' or space
	config._f+=(match[6]||' ')+isoTimes[i][0];break;}}if(string.match(matchOffset)){config._f+='Z';}configFromStringAndFormat(config);}else{config._isValid=false;}}// date from iso format or fallback
	function configFromString(config){var matched=aspNetJsonRegex.exec(config._i);if(matched!==null){config._d=new Date(+matched[1]);return;}configFromISO(config);if(config._isValid===false){delete config._isValid;utils_hooks__hooks.createFromInputFallback(config);}}utils_hooks__hooks.createFromInputFallback=deprecate('moment construction falls back to js Date. This is '+'discouraged and will be removed in upcoming major '+'release. Please refer to '+'https://github.com/moment/moment/issues/1407 for more info.',function(config){config._d=new Date(config._i+(config._useUTC?' UTC':''));});function createDate(y,m,d,h,M,s,ms){//can't just apply() to create a date:
	//http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	var date=new Date(y,m,d,h,M,s,ms);//the date constructor doesn't accept years < 1970
	if(y<1970){date.setFullYear(y);}return date;}function createUTCDate(y){var date=new Date(Date.UTC.apply(null,arguments));if(y<1970){date.setUTCFullYear(y);}return date;}addFormatToken(0,['YY',2],0,function(){return this.year()%100;});addFormatToken(0,['YYYY',4],0,'year');addFormatToken(0,['YYYYY',5],0,'year');addFormatToken(0,['YYYYYY',6,true],0,'year');// ALIASES
	addUnitAlias('year','y');// PARSING
	addRegexToken('Y',matchSigned);addRegexToken('YY',match1to2,match2);addRegexToken('YYYY',match1to4,match4);addRegexToken('YYYYY',match1to6,match6);addRegexToken('YYYYYY',match1to6,match6);addParseToken(['YYYYY','YYYYYY'],YEAR);addParseToken('YYYY',function(input,array){array[YEAR]=input.length===2?utils_hooks__hooks.parseTwoDigitYear(input):toInt(input);});addParseToken('YY',function(input,array){array[YEAR]=utils_hooks__hooks.parseTwoDigitYear(input);});// HELPERS
	function daysInYear(year){return isLeapYear(year)?366:365;}function isLeapYear(year){return year%4===0&&year%100!==0||year%400===0;}// HOOKS
	utils_hooks__hooks.parseTwoDigitYear=function(input){return toInt(input)+(toInt(input)>68?1900:2000);};// MOMENTS
	var getSetYear=makeGetSet('FullYear',false);function getIsLeapYear(){return isLeapYear(this.year());}addFormatToken('w',['ww',2],'wo','week');addFormatToken('W',['WW',2],'Wo','isoWeek');// ALIASES
	addUnitAlias('week','w');addUnitAlias('isoWeek','W');// PARSING
	addRegexToken('w',match1to2);addRegexToken('ww',match1to2,match2);addRegexToken('W',match1to2);addRegexToken('WW',match1to2,match2);addWeekParseToken(['w','ww','W','WW'],function(input,week,config,token){week[token.substr(0,1)]=toInt(input);});// HELPERS
	// firstDayOfWeek       0 = sun, 6 = sat
	//                      the day of the week that starts the week
	//                      (usually sunday or monday)
	// firstDayOfWeekOfYear 0 = sun, 6 = sat
	//                      the first week is the week that contains the first
	//                      of this day of the week
	//                      (eg. ISO weeks use thursday (4))
	function weekOfYear(mom,firstDayOfWeek,firstDayOfWeekOfYear){var end=firstDayOfWeekOfYear-firstDayOfWeek,daysToDayOfWeek=firstDayOfWeekOfYear-mom.day(),adjustedMoment;if(daysToDayOfWeek>end){daysToDayOfWeek-=7;}if(daysToDayOfWeek<end-7){daysToDayOfWeek+=7;}adjustedMoment=local__createLocal(mom).add(daysToDayOfWeek,'d');return{week:Math.ceil(adjustedMoment.dayOfYear()/7),year:adjustedMoment.year()};}// LOCALES
	function localeWeek(mom){return weekOfYear(mom,this._week.dow,this._week.doy).week;}var defaultLocaleWeek={dow:0,// Sunday is the first day of the week.
	doy:6// The week that contains Jan 1st is the first week of the year.
	};function localeFirstDayOfWeek(){return this._week.dow;}function localeFirstDayOfYear(){return this._week.doy;}// MOMENTS
	function getSetWeek(input){var week=this.localeData().week(this);return input==null?week:this.add((input-week)*7,'d');}function getSetISOWeek(input){var week=weekOfYear(this,1,4).week;return input==null?week:this.add((input-week)*7,'d');}addFormatToken('DDD',['DDDD',3],'DDDo','dayOfYear');// ALIASES
	addUnitAlias('dayOfYear','DDD');// PARSING
	addRegexToken('DDD',match1to3);addRegexToken('DDDD',match3);addParseToken(['DDD','DDDD'],function(input,array,config){config._dayOfYear=toInt(input);});// HELPERS
	//http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year,week,weekday,firstDayOfWeekOfYear,firstDayOfWeek){var week1Jan=6+firstDayOfWeek-firstDayOfWeekOfYear,janX=createUTCDate(year,0,1+week1Jan),d=janX.getUTCDay(),dayOfYear;if(d<firstDayOfWeek){d+=7;}weekday=weekday!=null?1*weekday:firstDayOfWeek;dayOfYear=1+week1Jan+7*(week-1)-d+weekday;return{year:dayOfYear>0?year:year-1,dayOfYear:dayOfYear>0?dayOfYear:daysInYear(year-1)+dayOfYear};}// MOMENTS
	function getSetDayOfYear(input){var dayOfYear=Math.round((this.clone().startOf('day')-this.clone().startOf('year'))/864e5)+1;return input==null?dayOfYear:this.add(input-dayOfYear,'d');}// Pick the first defined of two or three arguments.
	function defaults(a,b,c){if(a!=null){return a;}if(b!=null){return b;}return c;}function currentDateArray(config){var now=new Date();if(config._useUTC){return[now.getUTCFullYear(),now.getUTCMonth(),now.getUTCDate()];}return[now.getFullYear(),now.getMonth(),now.getDate()];}// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray(config){var i,date,input=[],currentDate,yearToUse;if(config._d){return;}currentDate=currentDateArray(config);//compute day of the year from weeks and weekdays
	if(config._w&&config._a[DATE]==null&&config._a[MONTH]==null){dayOfYearFromWeekInfo(config);}//if the day of the year is set, figure out what it is
	if(config._dayOfYear){yearToUse=defaults(config._a[YEAR],currentDate[YEAR]);if(config._dayOfYear>daysInYear(yearToUse)){getParsingFlags(config)._overflowDayOfYear=true;}date=createUTCDate(yearToUse,0,config._dayOfYear);config._a[MONTH]=date.getUTCMonth();config._a[DATE]=date.getUTCDate();}// Default to current date.
	// * if no year, month, day of month are given, default to today
	// * if day of month is given, default month and year
	// * if month is given, default only year
	// * if year is given, don't default anything
	for(i=0;i<3&&config._a[i]==null;++i){config._a[i]=input[i]=currentDate[i];}// Zero out whatever was not defaulted, including time
	for(;i<7;i++){config._a[i]=input[i]=config._a[i]==null?i===2?1:0:config._a[i];}// Check for 24:00:00.000
	if(config._a[HOUR]===24&&config._a[MINUTE]===0&&config._a[SECOND]===0&&config._a[MILLISECOND]===0){config._nextDay=true;config._a[HOUR]=0;}config._d=(config._useUTC?createUTCDate:createDate).apply(null,input);// Apply timezone offset from input. The actual utcOffset can be changed
	// with parseZone.
	if(config._tzm!=null){config._d.setUTCMinutes(config._d.getUTCMinutes()-config._tzm);}if(config._nextDay){config._a[HOUR]=24;}}function dayOfYearFromWeekInfo(config){var w,weekYear,week,weekday,dow,doy,temp;w=config._w;if(w.GG!=null||w.W!=null||w.E!=null){dow=1;doy=4;// TODO: We need to take the current isoWeekYear, but that depends on
	// how we interpret now (local, utc, fixed offset). So create
	// a now version of current config (take local/utc/offset flags, and
	// create now).
	weekYear=defaults(w.GG,config._a[YEAR],weekOfYear(local__createLocal(),1,4).year);week=defaults(w.W,1);weekday=defaults(w.E,1);}else{dow=config._locale._week.dow;doy=config._locale._week.doy;weekYear=defaults(w.gg,config._a[YEAR],weekOfYear(local__createLocal(),dow,doy).year);week=defaults(w.w,1);if(w.d!=null){// weekday -- low day numbers are considered next week
	weekday=w.d;if(weekday<dow){++week;}}else if(w.e!=null){// local weekday -- counting starts from begining of week
	weekday=w.e+dow;}else{// default to begining of week
	weekday=dow;}}temp=dayOfYearFromWeeks(weekYear,week,weekday,doy,dow);config._a[YEAR]=temp.year;config._dayOfYear=temp.dayOfYear;}utils_hooks__hooks.ISO_8601=function(){};// date from string and format string
	function configFromStringAndFormat(config){// TODO: Move this to another part of the creation flow to prevent circular deps
	if(config._f===utils_hooks__hooks.ISO_8601){configFromISO(config);return;}config._a=[];getParsingFlags(config).empty=true;// This array is used to make a Date, either with `new Date` or `Date.UTC`
	var string=''+config._i,i,parsedInput,tokens,token,skipped,stringLength=string.length,totalParsedInputLength=0;tokens=expandFormat(config._f,config._locale).match(formattingTokens)||[];for(i=0;i<tokens.length;i++){token=tokens[i];parsedInput=(string.match(getParseRegexForToken(token,config))||[])[0];if(parsedInput){skipped=string.substr(0,string.indexOf(parsedInput));if(skipped.length>0){getParsingFlags(config).unusedInput.push(skipped);}string=string.slice(string.indexOf(parsedInput)+parsedInput.length);totalParsedInputLength+=parsedInput.length;}// don't parse if it's not a known token
	if(formatTokenFunctions[token]){if(parsedInput){getParsingFlags(config).empty=false;}else{getParsingFlags(config).unusedTokens.push(token);}addTimeToArrayFromToken(token,parsedInput,config);}else if(config._strict&&!parsedInput){getParsingFlags(config).unusedTokens.push(token);}}// add remaining unparsed input length to the string
	getParsingFlags(config).charsLeftOver=stringLength-totalParsedInputLength;if(string.length>0){getParsingFlags(config).unusedInput.push(string);}// clear _12h flag if hour is <= 12
	if(getParsingFlags(config).bigHour===true&&config._a[HOUR]<=12&&config._a[HOUR]>0){getParsingFlags(config).bigHour=undefined;}// handle meridiem
	config._a[HOUR]=meridiemFixWrap(config._locale,config._a[HOUR],config._meridiem);configFromArray(config);checkOverflow(config);}function meridiemFixWrap(locale,hour,meridiem){var isPm;if(meridiem==null){// nothing to do
	return hour;}if(locale.meridiemHour!=null){return locale.meridiemHour(hour,meridiem);}else if(locale.isPM!=null){// Fallback
	isPm=locale.isPM(meridiem);if(isPm&&hour<12){hour+=12;}if(!isPm&&hour===12){hour=0;}return hour;}else{// this is not supposed to happen
	return hour;}}function configFromStringAndArray(config){var tempConfig,bestMoment,scoreToBeat,i,currentScore;if(config._f.length===0){getParsingFlags(config).invalidFormat=true;config._d=new Date(NaN);return;}for(i=0;i<config._f.length;i++){currentScore=0;tempConfig=copyConfig({},config);if(config._useUTC!=null){tempConfig._useUTC=config._useUTC;}tempConfig._f=config._f[i];configFromStringAndFormat(tempConfig);if(!valid__isValid(tempConfig)){continue;}// if there is any input that was not parsed add a penalty for that format
	currentScore+=getParsingFlags(tempConfig).charsLeftOver;//or tokens
	currentScore+=getParsingFlags(tempConfig).unusedTokens.length*10;getParsingFlags(tempConfig).score=currentScore;if(scoreToBeat==null||currentScore<scoreToBeat){scoreToBeat=currentScore;bestMoment=tempConfig;}}extend(config,bestMoment||tempConfig);}function configFromObject(config){if(config._d){return;}var i=normalizeObjectUnits(config._i);config._a=[i.year,i.month,i.day||i.date,i.hour,i.minute,i.second,i.millisecond];configFromArray(config);}function createFromConfig(config){var res=new Moment(checkOverflow(prepareConfig(config)));if(res._nextDay){// Adding is smart enough around DST
	res.add(1,'d');res._nextDay=undefined;}return res;}function prepareConfig(config){var input=config._i,format=config._f;config._locale=config._locale||locale_locales__getLocale(config._l);if(input===null||format===undefined&&input===''){return valid__createInvalid({nullInput:true});}if(typeof input==='string'){config._i=input=config._locale.preparse(input);}if(isMoment(input)){return new Moment(checkOverflow(input));}else if(isArray(format)){configFromStringAndArray(config);}else if(format){configFromStringAndFormat(config);}else if(isDate(input)){config._d=input;}else{configFromInput(config);}return config;}function configFromInput(config){var input=config._i;if(input===undefined){config._d=new Date();}else if(isDate(input)){config._d=new Date(+input);}else if(typeof input==='string'){configFromString(config);}else if(isArray(input)){config._a=map(input.slice(0),function(obj){return parseInt(obj,10);});configFromArray(config);}else if((typeof input==='undefined'?'undefined':_typeof(input))==='object'){configFromObject(config);}else if(typeof input==='number'){// from milliseconds
	config._d=new Date(input);}else{utils_hooks__hooks.createFromInputFallback(config);}}function createLocalOrUTC(input,format,locale,strict,isUTC){var c={};if(typeof locale==='boolean'){strict=locale;locale=undefined;}// object construction must be done this way.
	// https://github.com/moment/moment/issues/1423
	c._isAMomentObject=true;c._useUTC=c._isUTC=isUTC;c._l=locale;c._i=input;c._f=format;c._strict=strict;return createFromConfig(c);}function local__createLocal(input,format,locale,strict){return createLocalOrUTC(input,format,locale,strict,false);}var prototypeMin=deprecate('moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',function(){var other=local__createLocal.apply(null,arguments);return other<this?this:other;});var prototypeMax=deprecate('moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',function(){var other=local__createLocal.apply(null,arguments);return other>this?this:other;});// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn,moments){var res,i;if(moments.length===1&&isArray(moments[0])){moments=moments[0];}if(!moments.length){return local__createLocal();}res=moments[0];for(i=1;i<moments.length;++i){if(!moments[i].isValid()||moments[i][fn](res)){res=moments[i];}}return res;}// TODO: Use [].sort instead?
	function min(){var args=[].slice.call(arguments,0);return pickBy('isBefore',args);}function max(){var args=[].slice.call(arguments,0);return pickBy('isAfter',args);}function Duration(duration){var normalizedInput=normalizeObjectUnits(duration),years=normalizedInput.year||0,quarters=normalizedInput.quarter||0,months=normalizedInput.month||0,weeks=normalizedInput.week||0,days=normalizedInput.day||0,hours=normalizedInput.hour||0,minutes=normalizedInput.minute||0,seconds=normalizedInput.second||0,milliseconds=normalizedInput.millisecond||0;// representation for dateAddRemove
	this._milliseconds=+milliseconds+seconds*1e3+// 1000
	minutes*6e4+// 1000 * 60
	hours*36e5;// 1000 * 60 * 60
	// Because of dateAddRemove treats 24 hours as different from a
	// day when working around DST, we need to store them separately
	this._days=+days+weeks*7;// It is impossible translate months into days without knowing
	// which months you are are talking about, so we have to store
	// it separately.
	this._months=+months+quarters*3+years*12;this._data={};this._locale=locale_locales__getLocale();this._bubble();}function isDuration(obj){return obj instanceof Duration;}function offset(token,separator){addFormatToken(token,0,0,function(){var offset=this.utcOffset();var sign='+';if(offset<0){offset=-offset;sign='-';}return sign+zeroFill(~~(offset/60),2)+separator+zeroFill(~~offset%60,2);});}offset('Z',':');offset('ZZ','');// PARSING
	addRegexToken('Z',matchOffset);addRegexToken('ZZ',matchOffset);addParseToken(['Z','ZZ'],function(input,array,config){config._useUTC=true;config._tzm=offsetFromString(input);});// HELPERS
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset=/([\+\-]|\d\d)/gi;function offsetFromString(string){var matches=(string||'').match(matchOffset)||[];var chunk=matches[matches.length-1]||[];var parts=(chunk+'').match(chunkOffset)||['-',0,0];var minutes=+(parts[1]*60)+toInt(parts[2]);return parts[0]==='+'?minutes:-minutes;}// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input,model){var res,diff;if(model._isUTC){res=model.clone();diff=(isMoment(input)||isDate(input)?+input:+local__createLocal(input))-+res;// Use low-level api, because this fn is low-level api.
	res._d.setTime(+res._d+diff);utils_hooks__hooks.updateOffset(res,false);return res;}else{return local__createLocal(input).local();}}function getDateOffset(m){// On Firefox.24 Date#getTimezoneOffset returns a floating point.
	// https://github.com/moment/moment/pull/1871
	return-Math.round(m._d.getTimezoneOffset()/15)*15;}// HOOKS
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	utils_hooks__hooks.updateOffset=function(){};// MOMENTS
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset(input,keepLocalTime){var offset=this._offset||0,localAdjust;if(input!=null){if(typeof input==='string'){input=offsetFromString(input);}if(Math.abs(input)<16){input=input*60;}if(!this._isUTC&&keepLocalTime){localAdjust=getDateOffset(this);}this._offset=input;this._isUTC=true;if(localAdjust!=null){this.add(localAdjust,'m');}if(offset!==input){if(!keepLocalTime||this._changeInProgress){add_subtract__addSubtract(this,create__createDuration(input-offset,'m'),1,false);}else if(!this._changeInProgress){this._changeInProgress=true;utils_hooks__hooks.updateOffset(this,true);this._changeInProgress=null;}}return this;}else{return this._isUTC?offset:getDateOffset(this);}}function getSetZone(input,keepLocalTime){if(input!=null){if(typeof input!=='string'){input=-input;}this.utcOffset(input,keepLocalTime);return this;}else{return-this.utcOffset();}}function setOffsetToUTC(keepLocalTime){return this.utcOffset(0,keepLocalTime);}function setOffsetToLocal(keepLocalTime){if(this._isUTC){this.utcOffset(0,keepLocalTime);this._isUTC=false;if(keepLocalTime){this.subtract(getDateOffset(this),'m');}}return this;}function setOffsetToParsedOffset(){if(this._tzm){this.utcOffset(this._tzm);}else if(typeof this._i==='string'){this.utcOffset(offsetFromString(this._i));}return this;}function hasAlignedHourOffset(input){input=input?local__createLocal(input).utcOffset():0;return(this.utcOffset()-input)%60===0;}function isDaylightSavingTime(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset();}function isDaylightSavingTimeShifted(){if(typeof this._isDSTShifted!=='undefined'){return this._isDSTShifted;}var c={};copyConfig(c,this);c=prepareConfig(c);if(c._a){var other=c._isUTC?create_utc__createUTC(c._a):local__createLocal(c._a);this._isDSTShifted=this.isValid()&&compareArrays(c._a,other.toArray())>0;}else{this._isDSTShifted=false;}return this._isDSTShifted;}function isLocal(){return!this._isUTC;}function isUtcOffset(){return this._isUTC;}function isUtc(){return this._isUTC&&this._offset===0;}var aspNetRegex=/(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/;// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	var create__isoRegex=/^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;function create__createDuration(input,key){var duration=input,// matching against regexp is expensive, do it on demand
	match=null,sign,ret,diffRes;if(isDuration(input)){duration={ms:input._milliseconds,d:input._days,M:input._months};}else if(typeof input==='number'){duration={};if(key){duration[key]=input;}else{duration.milliseconds=input;}}else if(!!(match=aspNetRegex.exec(input))){sign=match[1]==='-'?-1:1;duration={y:0,d:toInt(match[DATE])*sign,h:toInt(match[HOUR])*sign,m:toInt(match[MINUTE])*sign,s:toInt(match[SECOND])*sign,ms:toInt(match[MILLISECOND])*sign};}else if(!!(match=create__isoRegex.exec(input))){sign=match[1]==='-'?-1:1;duration={y:parseIso(match[2],sign),M:parseIso(match[3],sign),d:parseIso(match[4],sign),h:parseIso(match[5],sign),m:parseIso(match[6],sign),s:parseIso(match[7],sign),w:parseIso(match[8],sign)};}else if(duration==null){// checks for null or undefined
	duration={};}else if((typeof duration==='undefined'?'undefined':_typeof(duration))==='object'&&('from'in duration||'to'in duration)){diffRes=momentsDifference(local__createLocal(duration.from),local__createLocal(duration.to));duration={};duration.ms=diffRes.milliseconds;duration.M=diffRes.months;}ret=new Duration(duration);if(isDuration(input)&&hasOwnProp(input,'_locale')){ret._locale=input._locale;}return ret;}create__createDuration.fn=Duration.prototype;function parseIso(inp,sign){// We'd normally use ~~inp for this, but unfortunately it also
	// converts floats to ints.
	// inp may be undefined, so careful calling replace on it.
	var res=inp&&parseFloat(inp.replace(',','.'));// apply sign while we're at it
	return(isNaN(res)?0:res)*sign;}function positiveMomentsDifference(base,other){var res={milliseconds:0,months:0};res.months=other.month()-base.month()+(other.year()-base.year())*12;if(base.clone().add(res.months,'M').isAfter(other)){--res.months;}res.milliseconds=+other-+base.clone().add(res.months,'M');return res;}function momentsDifference(base,other){var res;other=cloneWithOffset(other,base);if(base.isBefore(other)){res=positiveMomentsDifference(base,other);}else{res=positiveMomentsDifference(other,base);res.milliseconds=-res.milliseconds;res.months=-res.months;}return res;}function createAdder(direction,name){return function(val,period){var dur,tmp;//invert the arguments, but complain about it
	if(period!==null&&!isNaN(+period)){deprecateSimple(name,'moment().'+name+'(period, number) is deprecated. Please use moment().'+name+'(number, period).');tmp=val;val=period;period=tmp;}val=typeof val==='string'?+val:val;dur=create__createDuration(val,period);add_subtract__addSubtract(this,dur,direction);return this;};}function add_subtract__addSubtract(mom,duration,isAdding,updateOffset){var milliseconds=duration._milliseconds,days=duration._days,months=duration._months;updateOffset=updateOffset==null?true:updateOffset;if(milliseconds){mom._d.setTime(+mom._d+milliseconds*isAdding);}if(days){get_set__set(mom,'Date',get_set__get(mom,'Date')+days*isAdding);}if(months){setMonth(mom,get_set__get(mom,'Month')+months*isAdding);}if(updateOffset){utils_hooks__hooks.updateOffset(mom,days||months);}}var add_subtract__add=createAdder(1,'add');var add_subtract__subtract=createAdder(-1,'subtract');function moment_calendar__calendar(time,formats){// We want to compare the start of today, vs this.
	// Getting start-of-today depends on whether we're local/utc/offset or not.
	var now=time||local__createLocal(),sod=cloneWithOffset(now,this).startOf('day'),diff=this.diff(sod,'days',true),format=diff<-6?'sameElse':diff<-1?'lastWeek':diff<0?'lastDay':diff<1?'sameDay':diff<2?'nextDay':diff<7?'nextWeek':'sameElse';return this.format(formats&&formats[format]||this.localeData().calendar(format,this,local__createLocal(now)));}function clone(){return new Moment(this);}function isAfter(input,units){var inputMs;units=normalizeUnits(typeof units!=='undefined'?units:'millisecond');if(units==='millisecond'){input=isMoment(input)?input:local__createLocal(input);return+this>+input;}else{inputMs=isMoment(input)?+input:+local__createLocal(input);return inputMs<+this.clone().startOf(units);}}function isBefore(input,units){var inputMs;units=normalizeUnits(typeof units!=='undefined'?units:'millisecond');if(units==='millisecond'){input=isMoment(input)?input:local__createLocal(input);return+this<+input;}else{inputMs=isMoment(input)?+input:+local__createLocal(input);return+this.clone().endOf(units)<inputMs;}}function isBetween(from,to,units){return this.isAfter(from,units)&&this.isBefore(to,units);}function isSame(input,units){var inputMs;units=normalizeUnits(units||'millisecond');if(units==='millisecond'){input=isMoment(input)?input:local__createLocal(input);return+this===+input;}else{inputMs=+local__createLocal(input);return+this.clone().startOf(units)<=inputMs&&inputMs<=+this.clone().endOf(units);}}function diff(input,units,asFloat){var that=cloneWithOffset(input,this),zoneDelta=(that.utcOffset()-this.utcOffset())*6e4,delta,output;units=normalizeUnits(units);if(units==='year'||units==='month'||units==='quarter'){output=monthDiff(this,that);if(units==='quarter'){output=output/3;}else if(units==='year'){output=output/12;}}else{delta=this-that;output=units==='second'?delta/1e3:// 1000
	units==='minute'?delta/6e4:// 1000 * 60
	units==='hour'?delta/36e5:// 1000 * 60 * 60
	units==='day'?(delta-zoneDelta)/864e5:// 1000 * 60 * 60 * 24, negate dst
	units==='week'?(delta-zoneDelta)/6048e5:// 1000 * 60 * 60 * 24 * 7, negate dst
	delta;}return asFloat?output:absFloor(output);}function monthDiff(a,b){// difference in months
	var wholeMonthDiff=(b.year()-a.year())*12+(b.month()-a.month()),// b is in (anchor - 1 month, anchor + 1 month)
	anchor=a.clone().add(wholeMonthDiff,'months'),anchor2,adjust;if(b-anchor<0){anchor2=a.clone().add(wholeMonthDiff-1,'months');// linear across the month
	adjust=(b-anchor)/(anchor-anchor2);}else{anchor2=a.clone().add(wholeMonthDiff+1,'months');// linear across the month
	adjust=(b-anchor)/(anchor2-anchor);}return-(wholeMonthDiff+adjust);}utils_hooks__hooks.defaultFormat='YYYY-MM-DDTHH:mm:ssZ';function toString(){return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');}function moment_format__toISOString(){var m=this.clone().utc();if(0<m.year()&&m.year()<=9999){if('function'===typeof Date.prototype.toISOString){// native implementation is ~50x faster, use it when we can
	return this.toDate().toISOString();}else{return formatMoment(m,'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');}}else{return formatMoment(m,'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');}}function format(inputString){var output=formatMoment(this,inputString||utils_hooks__hooks.defaultFormat);return this.localeData().postformat(output);}function from(time,withoutSuffix){if(!this.isValid()){return this.localeData().invalidDate();}return create__createDuration({to:this,from:time}).locale(this.locale()).humanize(!withoutSuffix);}function fromNow(withoutSuffix){return this.from(local__createLocal(),withoutSuffix);}function to(time,withoutSuffix){if(!this.isValid()){return this.localeData().invalidDate();}return create__createDuration({from:this,to:time}).locale(this.locale()).humanize(!withoutSuffix);}function toNow(withoutSuffix){return this.to(local__createLocal(),withoutSuffix);}function locale(key){var newLocaleData;if(key===undefined){return this._locale._abbr;}else{newLocaleData=locale_locales__getLocale(key);if(newLocaleData!=null){this._locale=newLocaleData;}return this;}}var lang=deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',function(key){if(key===undefined){return this.localeData();}else{return this.locale(key);}});function localeData(){return this._locale;}function startOf(units){units=normalizeUnits(units);// the following switch intentionally omits break keywords
	// to utilize falling through the cases.
	switch(units){case'year':this.month(0);/* falls through */case'quarter':case'month':this.date(1);/* falls through */case'week':case'isoWeek':case'day':this.hours(0);/* falls through */case'hour':this.minutes(0);/* falls through */case'minute':this.seconds(0);/* falls through */case'second':this.milliseconds(0);}// weeks are a special case
	if(units==='week'){this.weekday(0);}if(units==='isoWeek'){this.isoWeekday(1);}// quarters are also special
	if(units==='quarter'){this.month(Math.floor(this.month()/3)*3);}return this;}function endOf(units){units=normalizeUnits(units);if(units===undefined||units==='millisecond'){return this;}return this.startOf(units).add(1,units==='isoWeek'?'week':units).subtract(1,'ms');}function to_type__valueOf(){return+this._d-(this._offset||0)*60000;}function unix(){return Math.floor(+this/1000);}function toDate(){return this._offset?new Date(+this):this._d;}function toArray(){var m=this;return[m.year(),m.month(),m.date(),m.hour(),m.minute(),m.second(),m.millisecond()];}function toObject(){var m=this;return{years:m.year(),months:m.month(),date:m.date(),hours:m.hours(),minutes:m.minutes(),seconds:m.seconds(),milliseconds:m.milliseconds()};}function moment_valid__isValid(){return valid__isValid(this);}function parsingFlags(){return extend({},getParsingFlags(this));}function invalidAt(){return getParsingFlags(this).overflow;}addFormatToken(0,['gg',2],0,function(){return this.weekYear()%100;});addFormatToken(0,['GG',2],0,function(){return this.isoWeekYear()%100;});function addWeekYearFormatToken(token,getter){addFormatToken(0,[token,token.length],0,getter);}addWeekYearFormatToken('gggg','weekYear');addWeekYearFormatToken('ggggg','weekYear');addWeekYearFormatToken('GGGG','isoWeekYear');addWeekYearFormatToken('GGGGG','isoWeekYear');// ALIASES
	addUnitAlias('weekYear','gg');addUnitAlias('isoWeekYear','GG');// PARSING
	addRegexToken('G',matchSigned);addRegexToken('g',matchSigned);addRegexToken('GG',match1to2,match2);addRegexToken('gg',match1to2,match2);addRegexToken('GGGG',match1to4,match4);addRegexToken('gggg',match1to4,match4);addRegexToken('GGGGG',match1to6,match6);addRegexToken('ggggg',match1to6,match6);addWeekParseToken(['gggg','ggggg','GGGG','GGGGG'],function(input,week,config,token){week[token.substr(0,2)]=toInt(input);});addWeekParseToken(['gg','GG'],function(input,week,config,token){week[token]=utils_hooks__hooks.parseTwoDigitYear(input);});// HELPERS
	function weeksInYear(year,dow,doy){return weekOfYear(local__createLocal([year,11,31+dow-doy]),dow,doy).week;}// MOMENTS
	function getSetWeekYear(input){var year=weekOfYear(this,this.localeData()._week.dow,this.localeData()._week.doy).year;return input==null?year:this.add(input-year,'y');}function getSetISOWeekYear(input){var year=weekOfYear(this,1,4).year;return input==null?year:this.add(input-year,'y');}function getISOWeeksInYear(){return weeksInYear(this.year(),1,4);}function getWeeksInYear(){var weekInfo=this.localeData()._week;return weeksInYear(this.year(),weekInfo.dow,weekInfo.doy);}addFormatToken('Q',0,0,'quarter');// ALIASES
	addUnitAlias('quarter','Q');// PARSING
	addRegexToken('Q',match1);addParseToken('Q',function(input,array){array[MONTH]=(toInt(input)-1)*3;});// MOMENTS
	function getSetQuarter(input){return input==null?Math.ceil((this.month()+1)/3):this.month((input-1)*3+this.month()%3);}addFormatToken('D',['DD',2],'Do','date');// ALIASES
	addUnitAlias('date','D');// PARSING
	addRegexToken('D',match1to2);addRegexToken('DD',match1to2,match2);addRegexToken('Do',function(isStrict,locale){return isStrict?locale._ordinalParse:locale._ordinalParseLenient;});addParseToken(['D','DD'],DATE);addParseToken('Do',function(input,array){array[DATE]=toInt(input.match(match1to2)[0],10);});// MOMENTS
	var getSetDayOfMonth=makeGetSet('Date',true);addFormatToken('d',0,'do','day');addFormatToken('dd',0,0,function(format){return this.localeData().weekdaysMin(this,format);});addFormatToken('ddd',0,0,function(format){return this.localeData().weekdaysShort(this,format);});addFormatToken('dddd',0,0,function(format){return this.localeData().weekdays(this,format);});addFormatToken('e',0,0,'weekday');addFormatToken('E',0,0,'isoWeekday');// ALIASES
	addUnitAlias('day','d');addUnitAlias('weekday','e');addUnitAlias('isoWeekday','E');// PARSING
	addRegexToken('d',match1to2);addRegexToken('e',match1to2);addRegexToken('E',match1to2);addRegexToken('dd',matchWord);addRegexToken('ddd',matchWord);addRegexToken('dddd',matchWord);addWeekParseToken(['dd','ddd','dddd'],function(input,week,config){var weekday=config._locale.weekdaysParse(input);// if we didn't get a weekday name, mark the date as invalid
	if(weekday!=null){week.d=weekday;}else{getParsingFlags(config).invalidWeekday=input;}});addWeekParseToken(['d','e','E'],function(input,week,config,token){week[token]=toInt(input);});// HELPERS
	function parseWeekday(input,locale){if(typeof input!=='string'){return input;}if(!isNaN(input)){return parseInt(input,10);}input=locale.weekdaysParse(input);if(typeof input==='number'){return input;}return null;}// LOCALES
	var defaultLocaleWeekdays='Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');function localeWeekdays(m){return this._weekdays[m.day()];}var defaultLocaleWeekdaysShort='Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');function localeWeekdaysShort(m){return this._weekdaysShort[m.day()];}var defaultLocaleWeekdaysMin='Su_Mo_Tu_We_Th_Fr_Sa'.split('_');function localeWeekdaysMin(m){return this._weekdaysMin[m.day()];}function localeWeekdaysParse(weekdayName){var i,mom,regex;this._weekdaysParse=this._weekdaysParse||[];for(i=0;i<7;i++){// make the regex if we don't have it already
	if(!this._weekdaysParse[i]){mom=local__createLocal([2000,1]).day(i);regex='^'+this.weekdays(mom,'')+'|^'+this.weekdaysShort(mom,'')+'|^'+this.weekdaysMin(mom,'');this._weekdaysParse[i]=new RegExp(regex.replace('.',''),'i');}// test the regex
	if(this._weekdaysParse[i].test(weekdayName)){return i;}}}// MOMENTS
	function getSetDayOfWeek(input){var day=this._isUTC?this._d.getUTCDay():this._d.getDay();if(input!=null){input=parseWeekday(input,this.localeData());return this.add(input-day,'d');}else{return day;}}function getSetLocaleDayOfWeek(input){var weekday=(this.day()+7-this.localeData()._week.dow)%7;return input==null?weekday:this.add(input-weekday,'d');}function getSetISODayOfWeek(input){// behaves the same as moment#day except
	// as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	// as a setter, sunday should belong to the previous week.
	return input==null?this.day()||7:this.day(this.day()%7?input:input-7);}addFormatToken('H',['HH',2],0,'hour');addFormatToken('h',['hh',2],0,function(){return this.hours()%12||12;});function meridiem(token,lowercase){addFormatToken(token,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),lowercase);});}meridiem('a',true);meridiem('A',false);// ALIASES
	addUnitAlias('hour','h');// PARSING
	function matchMeridiem(isStrict,locale){return locale._meridiemParse;}addRegexToken('a',matchMeridiem);addRegexToken('A',matchMeridiem);addRegexToken('H',match1to2);addRegexToken('h',match1to2);addRegexToken('HH',match1to2,match2);addRegexToken('hh',match1to2,match2);addParseToken(['H','HH'],HOUR);addParseToken(['a','A'],function(input,array,config){config._isPm=config._locale.isPM(input);config._meridiem=input;});addParseToken(['h','hh'],function(input,array,config){array[HOUR]=toInt(input);getParsingFlags(config).bigHour=true;});// LOCALES
	function localeIsPM(input){// IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	// Using charAt should be more compatible.
	return(input+'').toLowerCase().charAt(0)==='p';}var defaultLocaleMeridiemParse=/[ap]\.?m?\.?/i;function localeMeridiem(hours,minutes,isLower){if(hours>11){return isLower?'pm':'PM';}else{return isLower?'am':'AM';}}// MOMENTS
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour=makeGetSet('Hours',true);addFormatToken('m',['mm',2],0,'minute');// ALIASES
	addUnitAlias('minute','m');// PARSING
	addRegexToken('m',match1to2);addRegexToken('mm',match1to2,match2);addParseToken(['m','mm'],MINUTE);// MOMENTS
	var getSetMinute=makeGetSet('Minutes',false);addFormatToken('s',['ss',2],0,'second');// ALIASES
	addUnitAlias('second','s');// PARSING
	addRegexToken('s',match1to2);addRegexToken('ss',match1to2,match2);addParseToken(['s','ss'],SECOND);// MOMENTS
	var getSetSecond=makeGetSet('Seconds',false);addFormatToken('S',0,0,function(){return~~(this.millisecond()/100);});addFormatToken(0,['SS',2],0,function(){return~~(this.millisecond()/10);});addFormatToken(0,['SSS',3],0,'millisecond');addFormatToken(0,['SSSS',4],0,function(){return this.millisecond()*10;});addFormatToken(0,['SSSSS',5],0,function(){return this.millisecond()*100;});addFormatToken(0,['SSSSSS',6],0,function(){return this.millisecond()*1000;});addFormatToken(0,['SSSSSSS',7],0,function(){return this.millisecond()*10000;});addFormatToken(0,['SSSSSSSS',8],0,function(){return this.millisecond()*100000;});addFormatToken(0,['SSSSSSSSS',9],0,function(){return this.millisecond()*1000000;});// ALIASES
	addUnitAlias('millisecond','ms');// PARSING
	addRegexToken('S',match1to3,match1);addRegexToken('SS',match1to3,match2);addRegexToken('SSS',match1to3,match3);var token;for(token='SSSS';token.length<=9;token+='S'){addRegexToken(token,matchUnsigned);}function parseMs(input,array){array[MILLISECOND]=toInt(('0.'+input)*1000);}for(token='S';token.length<=9;token+='S'){addParseToken(token,parseMs);}// MOMENTS
	var getSetMillisecond=makeGetSet('Milliseconds',false);addFormatToken('z',0,0,'zoneAbbr');addFormatToken('zz',0,0,'zoneName');// MOMENTS
	function getZoneAbbr(){return this._isUTC?'UTC':'';}function getZoneName(){return this._isUTC?'Coordinated Universal Time':'';}var momentPrototype__proto=Moment.prototype;momentPrototype__proto.add=add_subtract__add;momentPrototype__proto.calendar=moment_calendar__calendar;momentPrototype__proto.clone=clone;momentPrototype__proto.diff=diff;momentPrototype__proto.endOf=endOf;momentPrototype__proto.format=format;momentPrototype__proto.from=from;momentPrototype__proto.fromNow=fromNow;momentPrototype__proto.to=to;momentPrototype__proto.toNow=toNow;momentPrototype__proto.get=getSet;momentPrototype__proto.invalidAt=invalidAt;momentPrototype__proto.isAfter=isAfter;momentPrototype__proto.isBefore=isBefore;momentPrototype__proto.isBetween=isBetween;momentPrototype__proto.isSame=isSame;momentPrototype__proto.isValid=moment_valid__isValid;momentPrototype__proto.lang=lang;momentPrototype__proto.locale=locale;momentPrototype__proto.localeData=localeData;momentPrototype__proto.max=prototypeMax;momentPrototype__proto.min=prototypeMin;momentPrototype__proto.parsingFlags=parsingFlags;momentPrototype__proto.set=getSet;momentPrototype__proto.startOf=startOf;momentPrototype__proto.subtract=add_subtract__subtract;momentPrototype__proto.toArray=toArray;momentPrototype__proto.toObject=toObject;momentPrototype__proto.toDate=toDate;momentPrototype__proto.toISOString=moment_format__toISOString;momentPrototype__proto.toJSON=moment_format__toISOString;momentPrototype__proto.toString=toString;momentPrototype__proto.unix=unix;momentPrototype__proto.valueOf=to_type__valueOf;// Year
	momentPrototype__proto.year=getSetYear;momentPrototype__proto.isLeapYear=getIsLeapYear;// Week Year
	momentPrototype__proto.weekYear=getSetWeekYear;momentPrototype__proto.isoWeekYear=getSetISOWeekYear;// Quarter
	momentPrototype__proto.quarter=momentPrototype__proto.quarters=getSetQuarter;// Month
	momentPrototype__proto.month=getSetMonth;momentPrototype__proto.daysInMonth=getDaysInMonth;// Week
	momentPrototype__proto.week=momentPrototype__proto.weeks=getSetWeek;momentPrototype__proto.isoWeek=momentPrototype__proto.isoWeeks=getSetISOWeek;momentPrototype__proto.weeksInYear=getWeeksInYear;momentPrototype__proto.isoWeeksInYear=getISOWeeksInYear;// Day
	momentPrototype__proto.date=getSetDayOfMonth;momentPrototype__proto.day=momentPrototype__proto.days=getSetDayOfWeek;momentPrototype__proto.weekday=getSetLocaleDayOfWeek;momentPrototype__proto.isoWeekday=getSetISODayOfWeek;momentPrototype__proto.dayOfYear=getSetDayOfYear;// Hour
	momentPrototype__proto.hour=momentPrototype__proto.hours=getSetHour;// Minute
	momentPrototype__proto.minute=momentPrototype__proto.minutes=getSetMinute;// Second
	momentPrototype__proto.second=momentPrototype__proto.seconds=getSetSecond;// Millisecond
	momentPrototype__proto.millisecond=momentPrototype__proto.milliseconds=getSetMillisecond;// Offset
	momentPrototype__proto.utcOffset=getSetOffset;momentPrototype__proto.utc=setOffsetToUTC;momentPrototype__proto.local=setOffsetToLocal;momentPrototype__proto.parseZone=setOffsetToParsedOffset;momentPrototype__proto.hasAlignedHourOffset=hasAlignedHourOffset;momentPrototype__proto.isDST=isDaylightSavingTime;momentPrototype__proto.isDSTShifted=isDaylightSavingTimeShifted;momentPrototype__proto.isLocal=isLocal;momentPrototype__proto.isUtcOffset=isUtcOffset;momentPrototype__proto.isUtc=isUtc;momentPrototype__proto.isUTC=isUtc;// Timezone
	momentPrototype__proto.zoneAbbr=getZoneAbbr;momentPrototype__proto.zoneName=getZoneName;// Deprecations
	momentPrototype__proto.dates=deprecate('dates accessor is deprecated. Use date instead.',getSetDayOfMonth);momentPrototype__proto.months=deprecate('months accessor is deprecated. Use month instead',getSetMonth);momentPrototype__proto.years=deprecate('years accessor is deprecated. Use year instead',getSetYear);momentPrototype__proto.zone=deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779',getSetZone);var momentPrototype=momentPrototype__proto;function moment__createUnix(input){return local__createLocal(input*1000);}function moment__createInZone(){return local__createLocal.apply(null,arguments).parseZone();}var defaultCalendar={sameDay:'[Today at] LT',nextDay:'[Tomorrow at] LT',nextWeek:'dddd [at] LT',lastDay:'[Yesterday at] LT',lastWeek:'[Last] dddd [at] LT',sameElse:'L'};function locale_calendar__calendar(key,mom,now){var output=this._calendar[key];return typeof output==='function'?output.call(mom,now):output;}var defaultLongDateFormat={LTS:'h:mm:ss A',LT:'h:mm A',L:'MM/DD/YYYY',LL:'MMMM D, YYYY',LLL:'MMMM D, YYYY h:mm A',LLLL:'dddd, MMMM D, YYYY h:mm A'};function longDateFormat(key){var format=this._longDateFormat[key],formatUpper=this._longDateFormat[key.toUpperCase()];if(format||!formatUpper){return format;}this._longDateFormat[key]=formatUpper.replace(/MMMM|MM|DD|dddd/g,function(val){return val.slice(1);});return this._longDateFormat[key];}var defaultInvalidDate='Invalid date';function invalidDate(){return this._invalidDate;}var defaultOrdinal='%d';var defaultOrdinalParse=/\d{1,2}/;function ordinal(number){return this._ordinal.replace('%d',number);}function preParsePostFormat(string){return string;}var defaultRelativeTime={future:'in %s',past:'%s ago',s:'a few seconds',m:'a minute',mm:'%d minutes',h:'an hour',hh:'%d hours',d:'a day',dd:'%d days',M:'a month',MM:'%d months',y:'a year',yy:'%d years'};function relative__relativeTime(number,withoutSuffix,string,isFuture){var output=this._relativeTime[string];return typeof output==='function'?output(number,withoutSuffix,string,isFuture):output.replace(/%d/i,number);}function pastFuture(diff,output){var format=this._relativeTime[diff>0?'future':'past'];return typeof format==='function'?format(output):format.replace(/%s/i,output);}function locale_set__set(config){var prop,i;for(i in config){prop=config[i];if(typeof prop==='function'){this[i]=prop;}else{this['_'+i]=prop;}}// Lenient ordinal parsing accepts just a number in addition to
	// number + (possibly) stuff coming from _ordinalParseLenient.
	this._ordinalParseLenient=new RegExp(this._ordinalParse.source+'|'+/\d{1,2}/.source);}var prototype__proto=Locale.prototype;prototype__proto._calendar=defaultCalendar;prototype__proto.calendar=locale_calendar__calendar;prototype__proto._longDateFormat=defaultLongDateFormat;prototype__proto.longDateFormat=longDateFormat;prototype__proto._invalidDate=defaultInvalidDate;prototype__proto.invalidDate=invalidDate;prototype__proto._ordinal=defaultOrdinal;prototype__proto.ordinal=ordinal;prototype__proto._ordinalParse=defaultOrdinalParse;prototype__proto.preparse=preParsePostFormat;prototype__proto.postformat=preParsePostFormat;prototype__proto._relativeTime=defaultRelativeTime;prototype__proto.relativeTime=relative__relativeTime;prototype__proto.pastFuture=pastFuture;prototype__proto.set=locale_set__set;// Month
	prototype__proto.months=localeMonths;prototype__proto._months=defaultLocaleMonths;prototype__proto.monthsShort=localeMonthsShort;prototype__proto._monthsShort=defaultLocaleMonthsShort;prototype__proto.monthsParse=localeMonthsParse;// Week
	prototype__proto.week=localeWeek;prototype__proto._week=defaultLocaleWeek;prototype__proto.firstDayOfYear=localeFirstDayOfYear;prototype__proto.firstDayOfWeek=localeFirstDayOfWeek;// Day of Week
	prototype__proto.weekdays=localeWeekdays;prototype__proto._weekdays=defaultLocaleWeekdays;prototype__proto.weekdaysMin=localeWeekdaysMin;prototype__proto._weekdaysMin=defaultLocaleWeekdaysMin;prototype__proto.weekdaysShort=localeWeekdaysShort;prototype__proto._weekdaysShort=defaultLocaleWeekdaysShort;prototype__proto.weekdaysParse=localeWeekdaysParse;// Hours
	prototype__proto.isPM=localeIsPM;prototype__proto._meridiemParse=defaultLocaleMeridiemParse;prototype__proto.meridiem=localeMeridiem;function lists__get(format,index,field,setter){var locale=locale_locales__getLocale();var utc=create_utc__createUTC().set(setter,index);return locale[field](utc,format);}function list(format,index,field,count,setter){if(typeof format==='number'){index=format;format=undefined;}format=format||'';if(index!=null){return lists__get(format,index,field,setter);}var i;var out=[];for(i=0;i<count;i++){out[i]=lists__get(format,i,field,setter);}return out;}function lists__listMonths(format,index){return list(format,index,'months',12,'month');}function lists__listMonthsShort(format,index){return list(format,index,'monthsShort',12,'month');}function lists__listWeekdays(format,index){return list(format,index,'weekdays',7,'day');}function lists__listWeekdaysShort(format,index){return list(format,index,'weekdaysShort',7,'day');}function lists__listWeekdaysMin(format,index){return list(format,index,'weekdaysMin',7,'day');}locale_locales__getSetGlobalLocale('en',{ordinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function ordinal(number){var b=number%10,output=toInt(number%100/10)===1?'th':b===1?'st':b===2?'nd':b===3?'rd':'th';return number+output;}});// Side effect imports
	utils_hooks__hooks.lang=deprecate('moment.lang is deprecated. Use moment.locale instead.',locale_locales__getSetGlobalLocale);utils_hooks__hooks.langData=deprecate('moment.langData is deprecated. Use moment.localeData instead.',locale_locales__getLocale);var mathAbs=Math.abs;function duration_abs__abs(){var data=this._data;this._milliseconds=mathAbs(this._milliseconds);this._days=mathAbs(this._days);this._months=mathAbs(this._months);data.milliseconds=mathAbs(data.milliseconds);data.seconds=mathAbs(data.seconds);data.minutes=mathAbs(data.minutes);data.hours=mathAbs(data.hours);data.months=mathAbs(data.months);data.years=mathAbs(data.years);return this;}function duration_add_subtract__addSubtract(duration,input,value,direction){var other=create__createDuration(input,value);duration._milliseconds+=direction*other._milliseconds;duration._days+=direction*other._days;duration._months+=direction*other._months;return duration._bubble();}// supports only 2.0-style add(1, 's') or add(duration)
	function duration_add_subtract__add(input,value){return duration_add_subtract__addSubtract(this,input,value,1);}// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function duration_add_subtract__subtract(input,value){return duration_add_subtract__addSubtract(this,input,value,-1);}function absCeil(number){if(number<0){return Math.floor(number);}else{return Math.ceil(number);}}function bubble(){var milliseconds=this._milliseconds;var days=this._days;var months=this._months;var data=this._data;var seconds,minutes,hours,years,monthsFromDays;// if we have a mix of positive and negative values, bubble down first
	// check: https://github.com/moment/moment/issues/2166
	if(!(milliseconds>=0&&days>=0&&months>=0||milliseconds<=0&&days<=0&&months<=0)){milliseconds+=absCeil(monthsToDays(months)+days)*864e5;days=0;months=0;}// The following code bubbles up values, see the tests for
	// examples of what that means.
	data.milliseconds=milliseconds%1000;seconds=absFloor(milliseconds/1000);data.seconds=seconds%60;minutes=absFloor(seconds/60);data.minutes=minutes%60;hours=absFloor(minutes/60);data.hours=hours%24;days+=absFloor(hours/24);// convert days to months
	monthsFromDays=absFloor(daysToMonths(days));months+=monthsFromDays;days-=absCeil(monthsToDays(monthsFromDays));// 12 months -> 1 year
	years=absFloor(months/12);months%=12;data.days=days;data.months=months;data.years=years;return this;}function daysToMonths(days){// 400 years have 146097 days (taking into account leap year rules)
	// 400 years have 12 months === 4800
	return days*4800/146097;}function monthsToDays(months){// the reverse of daysToMonths
	return months*146097/4800;}function as(units){var days;var months;var milliseconds=this._milliseconds;units=normalizeUnits(units);if(units==='month'||units==='year'){days=this._days+milliseconds/864e5;months=this._months+daysToMonths(days);return units==='month'?months:months/12;}else{// handle milliseconds separately because of floating point math errors (issue #1867)
	days=this._days+Math.round(monthsToDays(this._months));switch(units){case'week':return days/7+milliseconds/6048e5;case'day':return days+milliseconds/864e5;case'hour':return days*24+milliseconds/36e5;case'minute':return days*1440+milliseconds/6e4;case'second':return days*86400+milliseconds/1000;// Math.floor prevents floating point math errors here
	case'millisecond':return Math.floor(days*864e5)+milliseconds;default:throw new Error('Unknown unit '+units);}}}// TODO: Use this.as('ms')?
	function duration_as__valueOf(){return this._milliseconds+this._days*864e5+this._months%12*2592e6+toInt(this._months/12)*31536e6;}function makeAs(alias){return function(){return this.as(alias);};}var asMilliseconds=makeAs('ms');var asSeconds=makeAs('s');var asMinutes=makeAs('m');var asHours=makeAs('h');var asDays=makeAs('d');var asWeeks=makeAs('w');var asMonths=makeAs('M');var asYears=makeAs('y');function duration_get__get(units){units=normalizeUnits(units);return this[units+'s']();}function makeGetter(name){return function(){return this._data[name];};}var milliseconds=makeGetter('milliseconds');var seconds=makeGetter('seconds');var minutes=makeGetter('minutes');var hours=makeGetter('hours');var days=makeGetter('days');var months=makeGetter('months');var years=makeGetter('years');function weeks(){return absFloor(this.days()/7);}var round=Math.round;var thresholds={s:45,// seconds to minute
	m:45,// minutes to hour
	h:22,// hours to day
	d:26,// days to month
	M:11// months to year
	};// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string,number,withoutSuffix,isFuture,locale){return locale.relativeTime(number||1,!!withoutSuffix,string,isFuture);}function duration_humanize__relativeTime(posNegDuration,withoutSuffix,locale){var duration=create__createDuration(posNegDuration).abs();var seconds=round(duration.as('s'));var minutes=round(duration.as('m'));var hours=round(duration.as('h'));var days=round(duration.as('d'));var months=round(duration.as('M'));var years=round(duration.as('y'));var a=seconds<thresholds.s&&['s',seconds]||minutes===1&&['m']||minutes<thresholds.m&&['mm',minutes]||hours===1&&['h']||hours<thresholds.h&&['hh',hours]||days===1&&['d']||days<thresholds.d&&['dd',days]||months===1&&['M']||months<thresholds.M&&['MM',months]||years===1&&['y']||['yy',years];a[2]=withoutSuffix;a[3]=+posNegDuration>0;a[4]=locale;return substituteTimeAgo.apply(null,a);}// This function allows you to set a threshold for relative time strings
	function duration_humanize__getSetRelativeTimeThreshold(threshold,limit){if(thresholds[threshold]===undefined){return false;}if(limit===undefined){return thresholds[threshold];}thresholds[threshold]=limit;return true;}function humanize(withSuffix){var locale=this.localeData();var output=duration_humanize__relativeTime(this,!withSuffix,locale);if(withSuffix){output=locale.pastFuture(+this,output);}return locale.postformat(output);}var iso_string__abs=Math.abs;function iso_string__toISOString(){// for ISO strings we do not use the normal bubbling rules:
	//  * milliseconds bubble up until they become hours
	//  * days do not bubble at all
	//  * months bubble up until they become years
	// This is because there is no context-free conversion between hours and days
	// (think of clock changes)
	// and also not between days and months (28-31 days per month)
	var seconds=iso_string__abs(this._milliseconds)/1000;var days=iso_string__abs(this._days);var months=iso_string__abs(this._months);var minutes,hours,years;// 3600 seconds -> 60 minutes -> 1 hour
	minutes=absFloor(seconds/60);hours=absFloor(minutes/60);seconds%=60;minutes%=60;// 12 months -> 1 year
	years=absFloor(months/12);months%=12;// inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	var Y=years;var M=months;var D=days;var h=hours;var m=minutes;var s=seconds;var total=this.asSeconds();if(!total){// this is the same as C#'s (Noda) and python (isodate)...
	// but not other JS (goog.date)
	return'P0D';}return(total<0?'-':'')+'P'+(Y?Y+'Y':'')+(M?M+'M':'')+(D?D+'D':'')+(h||m||s?'T':'')+(h?h+'H':'')+(m?m+'M':'')+(s?s+'S':'');}var duration_prototype__proto=Duration.prototype;duration_prototype__proto.abs=duration_abs__abs;duration_prototype__proto.add=duration_add_subtract__add;duration_prototype__proto.subtract=duration_add_subtract__subtract;duration_prototype__proto.as=as;duration_prototype__proto.asMilliseconds=asMilliseconds;duration_prototype__proto.asSeconds=asSeconds;duration_prototype__proto.asMinutes=asMinutes;duration_prototype__proto.asHours=asHours;duration_prototype__proto.asDays=asDays;duration_prototype__proto.asWeeks=asWeeks;duration_prototype__proto.asMonths=asMonths;duration_prototype__proto.asYears=asYears;duration_prototype__proto.valueOf=duration_as__valueOf;duration_prototype__proto._bubble=bubble;duration_prototype__proto.get=duration_get__get;duration_prototype__proto.milliseconds=milliseconds;duration_prototype__proto.seconds=seconds;duration_prototype__proto.minutes=minutes;duration_prototype__proto.hours=hours;duration_prototype__proto.days=days;duration_prototype__proto.weeks=weeks;duration_prototype__proto.months=months;duration_prototype__proto.years=years;duration_prototype__proto.humanize=humanize;duration_prototype__proto.toISOString=iso_string__toISOString;duration_prototype__proto.toString=iso_string__toISOString;duration_prototype__proto.toJSON=iso_string__toISOString;duration_prototype__proto.locale=locale;duration_prototype__proto.localeData=localeData;// Deprecations
	duration_prototype__proto.toIsoString=deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',iso_string__toISOString);duration_prototype__proto.lang=lang;// Side effect imports
	addFormatToken('X',0,0,'unix');addFormatToken('x',0,0,'valueOf');// PARSING
	addRegexToken('x',matchSigned);addRegexToken('X',matchTimestamp);addParseToken('X',function(input,array,config){config._d=new Date(parseFloat(input,10)*1000);});addParseToken('x',function(input,array,config){config._d=new Date(toInt(input));});// Side effect imports
	utils_hooks__hooks.version='2.10.6';setHookCallback(local__createLocal);utils_hooks__hooks.fn=momentPrototype;utils_hooks__hooks.min=min;utils_hooks__hooks.max=max;utils_hooks__hooks.utc=create_utc__createUTC;utils_hooks__hooks.unix=moment__createUnix;utils_hooks__hooks.months=lists__listMonths;utils_hooks__hooks.isDate=isDate;utils_hooks__hooks.locale=locale_locales__getSetGlobalLocale;utils_hooks__hooks.invalid=valid__createInvalid;utils_hooks__hooks.duration=create__createDuration;utils_hooks__hooks.isMoment=isMoment;utils_hooks__hooks.weekdays=lists__listWeekdays;utils_hooks__hooks.parseZone=moment__createInZone;utils_hooks__hooks.localeData=locale_locales__getLocale;utils_hooks__hooks.isDuration=isDuration;utils_hooks__hooks.monthsShort=lists__listMonthsShort;utils_hooks__hooks.weekdaysMin=lists__listWeekdaysMin;utils_hooks__hooks.defineLocale=defineLocale;utils_hooks__hooks.weekdaysShort=lists__listWeekdaysShort;utils_hooks__hooks.normalizeUnits=normalizeUnits;utils_hooks__hooks.relativeTimeThreshold=duration_humanize__getSetRelativeTimeThreshold;var _moment=utils_hooks__hooks;return _moment;});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var _UtilsStringUtils = __webpack_require__(134);
	
	var _UtilsStringUtils2 = _interopRequireDefault(_UtilsStringUtils);
	
	var Field = function () {
	    function Field(name) {
	        _classCallCheck(this, Field);
	
	        this._name = name || Math.random().toString(36).substring(7);
	        this._detailLink = name === "id";
	        this._type = "string";
	        this._order = null;
	        this._label = null;
	        this._maps = [];
	        this._transforms = [];
	        this._attributes = {};
	        this._cssClasses = null;
	        this._validation = { required: false, minlength: 0, maxlength: 99999 };
	        this._defaultValue = null;
	        this._editable = true;
	        this._sortable = true;
	        this._detailLinkRoute = "edit";
	        this._pinned = false;
	        this._flattenable = true;
	        this.dashboard = true;
	        this.list = true;
	        this._template = function () {
	            return "";
	        };
	        this._templateIncludesLabel = false;
	    }
	
	    _createClass(Field, [{
	        key: "label",
	        value: function label() {
	            if (arguments.length) {
	                this._label = arguments[0];
	                return this;
	            }
	
	            if (this._label === null) {
	                return _UtilsStringUtils2["default"].camelCase(this._name);
	            }
	
	            return this._label;
	        }
	    }, {
	        key: "type",
	        value: function type() {
	            return this._type;
	        }
	    }, {
	        key: "name",
	        value: function name() {
	            if (arguments.length) {
	                this._name = arguments[0];
	                return this;
	            }
	
	            return this._name;
	        }
	    }, {
	        key: "order",
	        value: function order() {
	            if (arguments.length) {
	                if (arguments[1] !== true) {
	                    console.warn("Setting order with Field.order is deprecated, order directly in fields array");
	                }
	                this._order = arguments[0];
	                return this;
	            }
	
	            return this._order;
	        }
	    }, {
	        key: "isDetailLink",
	        value: function isDetailLink(detailLink) {
	            if (arguments.length) {
	                this._detailLink = arguments[0];
	                return this;
	            }
	
	            if (this._detailLink === null) {
	                return this._name === "id";
	            }
	
	            return this._detailLink;
	        }
	    }, {
	        key: "map",
	
	        /**
	         * Add a function to be applied to the response object to turn it into an entry
	         */
	        value: function map(fn) {
	            if (!fn) return this._maps;
	            if (typeof fn !== "function") {
	                var type = typeof fn === "undefined" ? "undefined" : _typeof(fn);
	                throw new Error("Map argument should be a function, " + type + " given.");
	            }
	
	            this._maps.push(fn);
	
	            return this;
	        }
	    }, {
	        key: "hasMaps",
	        value: function hasMaps() {
	            return !!this._maps.length;
	        }
	    }, {
	        key: "getMappedValue",
	        value: function getMappedValue(value, entry) {
	            for (var i in this._maps) {
	                value = this._maps[i](value, entry);
	            }
	
	            return value;
	        }
	    }, {
	        key: "transform",
	
	        /**
	         * Add a function to be applied to the entry to turn it into a response object
	         */
	        value: function transform(fn) {
	            if (!fn) return this._transforms;
	            if (typeof fn !== "function") {
	                var type = typeof fn === "undefined" ? "undefined" : _typeof(fn);
	                throw new Error("transform argument should be a function, " + type + " given.");
	            }
	
	            this._transforms.push(fn);
	
	            return this;
	        }
	    }, {
	        key: "hasTranforms",
	        value: function hasTranforms() {
	            return !!this._transforms.length;
	        }
	    }, {
	        key: "getTransformedValue",
	        value: function getTransformedValue(value, entry) {
	            for (var i in this._transforms) {
	                value = this._transforms[i](value, entry);
	            }
	
	            return value;
	        }
	    }, {
	        key: "attributes",
	        value: function attributes(_attributes) {
	            if (!arguments.length) {
	                return this._attributes;
	            }
	
	            this._attributes = _attributes;
	
	            return this;
	        }
	    }, {
	        key: "cssClasses",
	        value: function cssClasses(classes) {
	            if (!arguments.length) return this._cssClasses;
	            this._cssClasses = classes;
	            return this;
	        }
	    }, {
	        key: "getCssClasses",
	        value: function getCssClasses(entry) {
	            if (!this._cssClasses) {
	                return "";
	            }
	
	            if (this._cssClasses.constructor === Array) {
	                return this._cssClasses.join(" ");
	            }
	
	            if (typeof this._cssClasses === "function") {
	                return this._cssClasses(entry);
	            }
	
	            return this._cssClasses;
	        }
	    }, {
	        key: "validation",
	        value: function validation(_validation) {
	            if (!arguments.length) {
	                return this._validation;
	            }
	
	            for (var property in _validation) {
	                if (!_validation.hasOwnProperty(property)) continue;
	                if (_validation[property] === null) {
	                    delete this._validation[property];
	                } else {
	                    this._validation[property] = _validation[property];
	                }
	            }
	
	            return this;
	        }
	    }, {
	        key: "defaultValue",
	        value: function defaultValue(_defaultValue) {
	            if (!arguments.length) return this._defaultValue;
	            this._defaultValue = _defaultValue;
	            return this;
	        }
	    }, {
	        key: "editable",
	        value: function editable(_editable) {
	            if (!arguments.length) return this._editable;
	            this._editable = _editable;
	            return this;
	        }
	    }, {
	        key: "sortable",
	        value: function sortable(_sortable) {
	            if (!arguments.length) return this._sortable;
	            this._sortable = _sortable;
	            return this;
	        }
	    }, {
	        key: "detailLinkRoute",
	        value: function detailLinkRoute(route) {
	            if (!arguments.length) return this._detailLinkRoute;
	            this._detailLinkRoute = route;
	            return this;
	        }
	    }, {
	        key: "pinned",
	        value: function pinned(_pinned) {
	            if (!arguments.length) return this._pinned;
	            this._pinned = _pinned;
	            return this;
	        }
	    }, {
	        key: "flattenable",
	        value: function flattenable() {
	            return this._flattenable;
	        }
	    }, {
	        key: "getTemplateValue",
	        value: function getTemplateValue(data) {
	            if (typeof this._template === "function") {
	                return this._template(data);
	            }
	
	            return this._template;
	        }
	    }, {
	        key: "getTemplateValueWithLabel",
	        value: function getTemplateValueWithLabel(data) {
	            return this._templateIncludesLabel ? this.getTemplateValue(data) : false;
	        }
	    }, {
	        key: "templateIncludesLabel",
	        value: function templateIncludesLabel(_templateIncludesLabel) {
	            if (!arguments.length) return this._templateIncludesLabel;
	            this._templateIncludesLabel = _templateIncludesLabel;
	            return this;
	        }
	    }, {
	        key: "template",
	        value: function template(_template) {
	            var templateIncludesLabel = arguments[1] === undefined ? false : arguments[1];
	
	            if (!arguments.length) return this._template;
	            this._template = _template;
	            this._templateIncludesLabel = templateIncludesLabel;
	            return this;
	        }
	    }, {
	        key: "detailLink",
	        set: function set(isDetailLink) {
	            return this._detailLink = isDetailLink;
	        }
	    }]);
	
	    return Field;
	}();
	
	exports["default"] = Field;
	module.exports = exports["default"];
	//# sourceMappingURL=Field.js.map

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	// This is CodeMirror (http://codemirror.net), a code editor
	// implemented in JavaScript on top of the browser's DOM.
	//
	// You can find some technical background for some of the code below
	// at http://marijnhaverbeke.nl/blog/#cm-internals .
	(function(global,factory){( false?'undefined':_typeof(exports))==='object'&&typeof module!=='undefined'?module.exports=factory(): true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):global.CodeMirror=factory();})(undefined,function(){'use strict';// Kludges for bugs and behavior differences that can't be feature
	// detected are enabled based on userAgent etc sniffing.
	var userAgent=navigator.userAgent;var platform=navigator.platform;var gecko=/gecko\/\d/i.test(userAgent);var ie_upto10=/MSIE \d/.test(userAgent);var ie_11up=/Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);var ie=ie_upto10||ie_11up;var ie_version=ie&&(ie_upto10?document.documentMode||6:ie_11up[1]);var webkit=/WebKit\//.test(userAgent);var qtwebkit=webkit&&/Qt\/\d+\.\d+/.test(userAgent);var chrome=/Chrome\//.test(userAgent);var presto=/Opera\//.test(userAgent);var safari=/Apple Computer/.test(navigator.vendor);var mac_geMountainLion=/Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);var phantom=/PhantomJS/.test(userAgent);var ios=/AppleWebKit/.test(userAgent)&&/Mobile\/\w+/.test(userAgent);// This is woefully incomplete. Suggestions for alternative methods welcome.
	var mobile=ios||/Android|webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);var mac=ios||/Mac/.test(platform);var chromeOS=/\bCrOS\b/.test(userAgent);var windows=/win/i.test(platform);var presto_version=presto&&userAgent.match(/Version\/(\d*\.\d*)/);if(presto_version){presto_version=Number(presto_version[1]);}if(presto_version&&presto_version>=15){presto=false;webkit=true;}// Some browsers use the wrong event properties to signal cmd/ctrl on OS X
	var flipCtrlCmd=mac&&(qtwebkit||presto&&(presto_version==null||presto_version<12.11));var captureRightClick=gecko||ie&&ie_version>=9;function classTest(cls){return new RegExp("(^|\\s)"+cls+"(?:$|\\s)\\s*");}var rmClass=function rmClass(node,cls){var current=node.className;var match=classTest(cls).exec(current);if(match){var after=current.slice(match.index+match[0].length);node.className=current.slice(0,match.index)+(after?match[1]+after:"");}};function removeChildren(e){for(var count=e.childNodes.length;count>0;--count){e.removeChild(e.firstChild);}return e;}function removeChildrenAndAdd(parent,e){return removeChildren(parent).appendChild(e);}function elt(tag,content,className,style){var e=document.createElement(tag);if(className){e.className=className;}if(style){e.style.cssText=style;}if(typeof content=="string"){e.appendChild(document.createTextNode(content));}else if(content){for(var i=0;i<content.length;++i){e.appendChild(content[i]);}}return e;}var range;if(document.createRange){range=function range(node,start,end,endNode){var r=document.createRange();r.setEnd(endNode||node,end);r.setStart(node,start);return r;};}else{range=function range(node,start,end){var r=document.body.createTextRange();try{r.moveToElementText(node.parentNode);}catch(e){return r;}r.collapse(true);r.moveEnd("character",end);r.moveStart("character",start);return r;};}function contains(parent,child){if(child.nodeType==3)// Android browser always returns false when child is a textnode
	{child=child.parentNode;}if(parent.contains){return parent.contains(child);}do{if(child.nodeType==11){child=child.host;}if(child==parent){return true;}}while(child=child.parentNode);}function activeElt(){// IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
	// IE < 10 will throw when accessed while the page is loading or in an iframe.
	// IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
	var activeElement;try{activeElement=document.activeElement;}catch(e){activeElement=document.body||null;}while(activeElement&&activeElement.root&&activeElement.root.activeElement){activeElement=activeElement.root.activeElement;}return activeElement;}function addClass(node,cls){var current=node.className;if(!classTest(cls).test(current)){node.className+=(current?" ":"")+cls;}}function joinClasses(a,b){var as=a.split(" ");for(var i=0;i<as.length;i++){if(as[i]&&!classTest(as[i]).test(b)){b+=" "+as[i];}}return b;}var selectInput=function selectInput(node){node.select();};if(ios)// Mobile Safari apparently has a bug where select() is broken.
	{selectInput=function selectInput(node){node.selectionStart=0;node.selectionEnd=node.value.length;};}else if(ie)// Suppress mysterious IE10 errors
	{selectInput=function selectInput(node){try{node.select();}catch(_e){}};}function bind(f){var args=Array.prototype.slice.call(arguments,1);return function(){return f.apply(null,args);};}function copyObj(obj,target,overwrite){if(!target){target={};}for(var prop in obj){if(obj.hasOwnProperty(prop)&&(overwrite!==false||!target.hasOwnProperty(prop))){target[prop]=obj[prop];}}return target;}// Counts the column offset in a string, taking tabs into account.
	// Used mostly to find indentation.
	function countColumn(string,end,tabSize,startIndex,startValue){if(end==null){end=string.search(/[^\s\u00a0]/);if(end==-1){end=string.length;}}for(var i=startIndex||0,n=startValue||0;;){var nextTab=string.indexOf("\t",i);if(nextTab<0||nextTab>=end){return n+(end-i);}n+=nextTab-i;n+=tabSize-n%tabSize;i=nextTab+1;}}function Delayed(){this.id=null;}Delayed.prototype.set=function(ms,f){clearTimeout(this.id);this.id=setTimeout(f,ms);};function indexOf(array,elt){for(var i=0;i<array.length;++i){if(array[i]==elt){return i;}}return-1;}// Number of pixels added to scroller and sizer to hide scrollbar
	var scrollerGap=30;// Returned or thrown by various protocols to signal 'I'm not
	// handling this'.
	var Pass={toString:function toString(){return"CodeMirror.Pass";}};// Reused option objects for setSelection & friends
	var sel_dontScroll={scroll:false};var sel_mouse={origin:"*mouse"};var sel_move={origin:"+move"};// The inverse of countColumn -- find the offset that corresponds to
	// a particular column.
	function findColumn(string,goal,tabSize){for(var pos=0,col=0;;){var nextTab=string.indexOf("\t",pos);if(nextTab==-1){nextTab=string.length;}var skipped=nextTab-pos;if(nextTab==string.length||col+skipped>=goal){return pos+Math.min(skipped,goal-col);}col+=nextTab-pos;col+=tabSize-col%tabSize;pos=nextTab+1;if(col>=goal){return pos;}}}var spaceStrs=[""];function spaceStr(n){while(spaceStrs.length<=n){spaceStrs.push(lst(spaceStrs)+" ");}return spaceStrs[n];}function lst(arr){return arr[arr.length-1];}function map(array,f){var out=[];for(var i=0;i<array.length;i++){out[i]=f(array[i],i);}return out;}function insertSorted(array,value,score){var pos=0,priority=score(value);while(pos<array.length&&score(array[pos])<=priority){pos++;}array.splice(pos,0,value);}function nothing(){}function createObj(base,props){var inst;if(Object.create){inst=Object.create(base);}else{nothing.prototype=base;inst=new nothing();}if(props){copyObj(props,inst);}return inst;}var nonASCIISingleCaseWordChar=/[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;function isWordCharBasic(ch){return /\w/.test(ch)||ch>"\x80"&&(ch.toUpperCase()!=ch.toLowerCase()||nonASCIISingleCaseWordChar.test(ch));}function isWordChar(ch,helper){if(!helper){return isWordCharBasic(ch);}if(helper.source.indexOf("\\w")>-1&&isWordCharBasic(ch)){return true;}return helper.test(ch);}function isEmpty(obj){for(var n in obj){if(obj.hasOwnProperty(n)&&obj[n]){return false;}}return true;}// Extending unicode characters. A series of a non-extending char +
	// any number of extending chars is treated as a single unit as far
	// as editing and measuring is concerned. This is not fully correct,
	// since some scripts/fonts/browsers also treat other configurations
	// of code points as a group.
	var extendingChars=/[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;function isExtendingChar(ch){return ch.charCodeAt(0)>=768&&extendingChars.test(ch);}// The display handles the DOM integration, both for input reading
	// and content drawing. It holds references to DOM nodes and
	// display-related state.
	function Display(place,doc,input){var d=this;this.input=input;// Covers bottom-right square when both scrollbars are present.
	d.scrollbarFiller=elt("div",null,"CodeMirror-scrollbar-filler");d.scrollbarFiller.setAttribute("cm-not-content","true");// Covers bottom of gutter when coverGutterNextToScrollbar is on
	// and h scrollbar is present.
	d.gutterFiller=elt("div",null,"CodeMirror-gutter-filler");d.gutterFiller.setAttribute("cm-not-content","true");// Will contain the actual code, positioned to cover the viewport.
	d.lineDiv=elt("div",null,"CodeMirror-code");// Elements are added to these to represent selection and cursors.
	d.selectionDiv=elt("div",null,null,"position: relative; z-index: 1");d.cursorDiv=elt("div",null,"CodeMirror-cursors");// A visibility: hidden element used to find the size of things.
	d.measure=elt("div",null,"CodeMirror-measure");// When lines outside of the viewport are measured, they are drawn in this.
	d.lineMeasure=elt("div",null,"CodeMirror-measure");// Wraps everything that needs to exist inside the vertically-padded coordinate system
	d.lineSpace=elt("div",[d.measure,d.lineMeasure,d.selectionDiv,d.cursorDiv,d.lineDiv],null,"position: relative; outline: none");// Moved around its parent to cover visible view.
	d.mover=elt("div",[elt("div",[d.lineSpace],"CodeMirror-lines")],null,"position: relative");// Set to the height of the document, allowing scrolling.
	d.sizer=elt("div",[d.mover],"CodeMirror-sizer");d.sizerWidth=null;// Behavior of elts with overflow: auto and padding is
	// inconsistent across browsers. This is used to ensure the
	// scrollable area is big enough.
	d.heightForcer=elt("div",null,null,"position: absolute; height: "+scrollerGap+"px; width: 1px;");// Will contain the gutters, if any.
	d.gutters=elt("div",null,"CodeMirror-gutters");d.lineGutter=null;// Actual scrollable element.
	d.scroller=elt("div",[d.sizer,d.heightForcer,d.gutters],"CodeMirror-scroll");d.scroller.setAttribute("tabIndex","-1");// The element in which the editor lives.
	d.wrapper=elt("div",[d.scrollbarFiller,d.gutterFiller,d.scroller],"CodeMirror");// Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
	if(ie&&ie_version<8){d.gutters.style.zIndex=-1;d.scroller.style.paddingRight=0;}if(!webkit&&!(gecko&&mobile)){d.scroller.draggable=true;}if(place){if(place.appendChild){place.appendChild(d.wrapper);}else{place(d.wrapper);}}// Current rendered range (may be bigger than the view window).
	d.viewFrom=d.viewTo=doc.first;d.reportedViewFrom=d.reportedViewTo=doc.first;// Information about the rendered lines.
	d.view=[];d.renderedView=null;// Holds info about a single rendered line when it was rendered
	// for measurement, while not in view.
	d.externalMeasured=null;// Empty space (in pixels) above the view
	d.viewOffset=0;d.lastWrapHeight=d.lastWrapWidth=0;d.updateLineNumbers=null;d.nativeBarWidth=d.barHeight=d.barWidth=0;d.scrollbarsClipped=false;// Used to only resize the line number gutter when necessary (when
	// the amount of lines crosses a boundary that makes its width change)
	d.lineNumWidth=d.lineNumInnerWidth=d.lineNumChars=null;// Set to true when a non-horizontal-scrolling line widget is
	// added. As an optimization, line widget aligning is skipped when
	// this is false.
	d.alignWidgets=false;d.cachedCharWidth=d.cachedTextHeight=d.cachedPaddingH=null;// Tracks the maximum line length so that the horizontal scrollbar
	// can be kept static when scrolling.
	d.maxLine=null;d.maxLineLength=0;d.maxLineChanged=false;// Used for measuring wheel scrolling granularity
	d.wheelDX=d.wheelDY=d.wheelStartX=d.wheelStartY=null;// True when shift is held down.
	d.shift=false;// Used to track whether anything happened since the context menu
	// was opened.
	d.selForContextMenu=null;d.activeTouch=null;input.init(d);}// Find the line object corresponding to the given line number.
	function getLine(doc,n){n-=doc.first;if(n<0||n>=doc.size){throw new Error("There is no line "+(n+doc.first)+" in the document.");}var chunk=doc;while(!chunk.lines){for(var i=0;;++i){var child=chunk.children[i],sz=child.chunkSize();if(n<sz){chunk=child;break;}n-=sz;}}return chunk.lines[n];}// Get the part of a document between two positions, as an array of
	// strings.
	function getBetween(doc,start,end){var out=[],n=start.line;doc.iter(start.line,end.line+1,function(line){var text=line.text;if(n==end.line){text=text.slice(0,end.ch);}if(n==start.line){text=text.slice(start.ch);}out.push(text);++n;});return out;}// Get the lines between from and to, as array of strings.
	function getLines(doc,from,to){var out=[];doc.iter(from,to,function(line){out.push(line.text);});// iter aborts when callback returns truthy value
	return out;}// Update the height of a line, propagating the height change
	// upwards to parent nodes.
	function updateLineHeight(line,height){var diff=height-line.height;if(diff){for(var n=line;n;n=n.parent){n.height+=diff;}}}// Given a line object, find its line number by walking up through
	// its parent links.
	function lineNo(line){if(line.parent==null){return null;}var cur=line.parent,no=indexOf(cur.lines,line);for(var chunk=cur.parent;chunk;cur=chunk,chunk=chunk.parent){for(var i=0;;++i){if(chunk.children[i]==cur){break;}no+=chunk.children[i].chunkSize();}}return no+cur.first;}// Find the line at the given vertical position, using the height
	// information in the document tree.
	function _lineAtHeight(chunk,h){var n=chunk.first;outer:do{for(var i$1=0;i$1<chunk.children.length;++i$1){var child=chunk.children[i$1],ch=child.height;if(h<ch){chunk=child;continue outer;}h-=ch;n+=child.chunkSize();}return n;}while(!chunk.lines);var i=0;for(;i<chunk.lines.length;++i){var line=chunk.lines[i],lh=line.height;if(h<lh){break;}h-=lh;}return n+i;}function isLine(doc,l){return l>=doc.first&&l<doc.first+doc.size;}function lineNumberFor(options,i){return String(options.lineNumberFormatter(i+options.firstLineNumber));}// A Pos instance represents a position within the text.
	function Pos(line,ch){if(!(this instanceof Pos)){return new Pos(line,ch);}this.line=line;this.ch=ch;}// Compare two positions, return 0 if they are the same, a negative
	// number when a is less, and a positive number otherwise.
	function cmp(a,b){return a.line-b.line||a.ch-b.ch;}function copyPos(x){return Pos(x.line,x.ch);}function maxPos(a,b){return cmp(a,b)<0?b:a;}function minPos(a,b){return cmp(a,b)<0?a:b;}// Most of the external API clips given positions to make sure they
	// actually exist within the document.
	function clipLine(doc,n){return Math.max(doc.first,Math.min(n,doc.first+doc.size-1));}function _clipPos(doc,pos){if(pos.line<doc.first){return Pos(doc.first,0);}var last=doc.first+doc.size-1;if(pos.line>last){return Pos(last,getLine(doc,last).text.length);}return clipToLen(pos,getLine(doc,pos.line).text.length);}function clipToLen(pos,linelen){var ch=pos.ch;if(ch==null||ch>linelen){return Pos(pos.line,linelen);}else if(ch<0){return Pos(pos.line,0);}else{return pos;}}function clipPosArray(doc,array){var out=[];for(var i=0;i<array.length;i++){out[i]=_clipPos(doc,array[i]);}return out;}// Optimize some code when these features are not used.
	var sawReadOnlySpans=false;var sawCollapsedSpans=false;function seeReadOnlySpans(){sawReadOnlySpans=true;}function seeCollapsedSpans(){sawCollapsedSpans=true;}// TEXTMARKER SPANS
	function MarkedSpan(marker,from,to){this.marker=marker;this.from=from;this.to=to;}// Search an array of spans for a span matching the given marker.
	function getMarkedSpanFor(spans,marker){if(spans){for(var i=0;i<spans.length;++i){var span=spans[i];if(span.marker==marker){return span;}}}}// Remove a span from an array, returning undefined if no spans are
	// left (we don't store arrays for lines without spans).
	function removeMarkedSpan(spans,span){var r;for(var i=0;i<spans.length;++i){if(spans[i]!=span){(r||(r=[])).push(spans[i]);}}return r;}// Add a span to a line.
	function addMarkedSpan(line,span){line.markedSpans=line.markedSpans?line.markedSpans.concat([span]):[span];span.marker.attachLine(line);}// Used for the algorithm that adjusts markers for a change in the
	// document. These functions cut an array of spans at a given
	// character position, returning an array of remaining chunks (or
	// undefined if nothing remains).
	function markedSpansBefore(old,startCh,isInsert){var nw;if(old){for(var i=0;i<old.length;++i){var span=old[i],marker=span.marker;var startsBefore=span.from==null||(marker.inclusiveLeft?span.from<=startCh:span.from<startCh);if(startsBefore||span.from==startCh&&marker.type=="bookmark"&&(!isInsert||!span.marker.insertLeft)){var endsAfter=span.to==null||(marker.inclusiveRight?span.to>=startCh:span.to>startCh);(nw||(nw=[])).push(new MarkedSpan(marker,span.from,endsAfter?null:span.to));}}}return nw;}function markedSpansAfter(old,endCh,isInsert){var nw;if(old){for(var i=0;i<old.length;++i){var span=old[i],marker=span.marker;var endsAfter=span.to==null||(marker.inclusiveRight?span.to>=endCh:span.to>endCh);if(endsAfter||span.from==endCh&&marker.type=="bookmark"&&(!isInsert||span.marker.insertLeft)){var startsBefore=span.from==null||(marker.inclusiveLeft?span.from<=endCh:span.from<endCh);(nw||(nw=[])).push(new MarkedSpan(marker,startsBefore?null:span.from-endCh,span.to==null?null:span.to-endCh));}}}return nw;}// Given a change object, compute the new set of marker spans that
	// cover the line in which the change took place. Removes spans
	// entirely within the change, reconnects spans belonging to the
	// same marker that appear on both sides of the change, and cuts off
	// spans partially within the change. Returns an array of span
	// arrays with one element for each line in (after) the change.
	function stretchSpansOverChange(doc,change){if(change.full){return null;}var oldFirst=isLine(doc,change.from.line)&&getLine(doc,change.from.line).markedSpans;var oldLast=isLine(doc,change.to.line)&&getLine(doc,change.to.line).markedSpans;if(!oldFirst&&!oldLast){return null;}var startCh=change.from.ch,endCh=change.to.ch,isInsert=cmp(change.from,change.to)==0;// Get the spans that 'stick out' on both sides
	var first=markedSpansBefore(oldFirst,startCh,isInsert);var last=markedSpansAfter(oldLast,endCh,isInsert);// Next, merge those two ends
	var sameLine=change.text.length==1,offset=lst(change.text).length+(sameLine?startCh:0);if(first){// Fix up .to properties of first
	for(var i=0;i<first.length;++i){var span=first[i];if(span.to==null){var found=getMarkedSpanFor(last,span.marker);if(!found){span.to=startCh;}else if(sameLine){span.to=found.to==null?null:found.to+offset;}}}}if(last){// Fix up .from in last (or move them into first in case of sameLine)
	for(var i$1=0;i$1<last.length;++i$1){var span$1=last[i$1];if(span$1.to!=null){span$1.to+=offset;}if(span$1.from==null){var found$1=getMarkedSpanFor(first,span$1.marker);if(!found$1){span$1.from=offset;if(sameLine){(first||(first=[])).push(span$1);}}}else{span$1.from+=offset;if(sameLine){(first||(first=[])).push(span$1);}}}}// Make sure we didn't create any zero-length spans
	if(first){first=clearEmptySpans(first);}if(last&&last!=first){last=clearEmptySpans(last);}var newMarkers=[first];if(!sameLine){// Fill gap with whole-line-spans
	var gap=change.text.length-2,gapMarkers;if(gap>0&&first){for(var i$2=0;i$2<first.length;++i$2){if(first[i$2].to==null){(gapMarkers||(gapMarkers=[])).push(new MarkedSpan(first[i$2].marker,null,null));}}}for(var i$3=0;i$3<gap;++i$3){newMarkers.push(gapMarkers);}newMarkers.push(last);}return newMarkers;}// Remove spans that are empty and don't have a clearWhenEmpty
	// option of false.
	function clearEmptySpans(spans){for(var i=0;i<spans.length;++i){var span=spans[i];if(span.from!=null&&span.from==span.to&&span.marker.clearWhenEmpty!==false){spans.splice(i--,1);}}if(!spans.length){return null;}return spans;}// Used to 'clip' out readOnly ranges when making a change.
	function removeReadOnlyRanges(doc,from,to){var markers=null;doc.iter(from.line,to.line+1,function(line){if(line.markedSpans){for(var i=0;i<line.markedSpans.length;++i){var mark=line.markedSpans[i].marker;if(mark.readOnly&&(!markers||indexOf(markers,mark)==-1)){(markers||(markers=[])).push(mark);}}}});if(!markers){return null;}var parts=[{from:from,to:to}];for(var i=0;i<markers.length;++i){var mk=markers[i],m=mk.find(0);for(var j=0;j<parts.length;++j){var p=parts[j];if(cmp(p.to,m.from)<0||cmp(p.from,m.to)>0){continue;}var newParts=[j,1],dfrom=cmp(p.from,m.from),dto=cmp(p.to,m.to);if(dfrom<0||!mk.inclusiveLeft&&!dfrom){newParts.push({from:p.from,to:m.from});}if(dto>0||!mk.inclusiveRight&&!dto){newParts.push({from:m.to,to:p.to});}parts.splice.apply(parts,newParts);j+=newParts.length-1;}}return parts;}// Connect or disconnect spans from a line.
	function detachMarkedSpans(line){var spans=line.markedSpans;if(!spans){return;}for(var i=0;i<spans.length;++i){spans[i].marker.detachLine(line);}line.markedSpans=null;}function attachMarkedSpans(line,spans){if(!spans){return;}for(var i=0;i<spans.length;++i){spans[i].marker.attachLine(line);}line.markedSpans=spans;}// Helpers used when computing which overlapping collapsed span
	// counts as the larger one.
	function extraLeft(marker){return marker.inclusiveLeft?-1:0;}function extraRight(marker){return marker.inclusiveRight?1:0;}// Returns a number indicating which of two overlapping collapsed
	// spans is larger (and thus includes the other). Falls back to
	// comparing ids when the spans cover exactly the same range.
	function compareCollapsedMarkers(a,b){var lenDiff=a.lines.length-b.lines.length;if(lenDiff!=0){return lenDiff;}var aPos=a.find(),bPos=b.find();var fromCmp=cmp(aPos.from,bPos.from)||extraLeft(a)-extraLeft(b);if(fromCmp){return-fromCmp;}var toCmp=cmp(aPos.to,bPos.to)||extraRight(a)-extraRight(b);if(toCmp){return toCmp;}return b.id-a.id;}// Find out whether a line ends or starts in a collapsed span. If
	// so, return the marker for that span.
	function collapsedSpanAtSide(line,start){var sps=sawCollapsedSpans&&line.markedSpans,found;if(sps){for(var sp=void 0,i=0;i<sps.length;++i){sp=sps[i];if(sp.marker.collapsed&&(start?sp.from:sp.to)==null&&(!found||compareCollapsedMarkers(found,sp.marker)<0)){found=sp.marker;}}}return found;}function collapsedSpanAtStart(line){return collapsedSpanAtSide(line,true);}function collapsedSpanAtEnd(line){return collapsedSpanAtSide(line,false);}// Test whether there exists a collapsed span that partially
	// overlaps (covers the start or end, but not both) of a new span.
	// Such overlap is not allowed.
	function conflictingCollapsedRange(doc,lineNo,from,to,marker){var line=getLine(doc,lineNo);var sps=sawCollapsedSpans&&line.markedSpans;if(sps){for(var i=0;i<sps.length;++i){var sp=sps[i];if(!sp.marker.collapsed){continue;}var found=sp.marker.find(0);var fromCmp=cmp(found.from,from)||extraLeft(sp.marker)-extraLeft(marker);var toCmp=cmp(found.to,to)||extraRight(sp.marker)-extraRight(marker);if(fromCmp>=0&&toCmp<=0||fromCmp<=0&&toCmp>=0){continue;}if(fromCmp<=0&&(sp.marker.inclusiveRight&&marker.inclusiveLeft?cmp(found.to,from)>=0:cmp(found.to,from)>0)||fromCmp>=0&&(sp.marker.inclusiveRight&&marker.inclusiveLeft?cmp(found.from,to)<=0:cmp(found.from,to)<0)){return true;}}}}// A visual line is a line as drawn on the screen. Folding, for
	// example, can cause multiple logical lines to appear on the same
	// visual line. This finds the start of the visual line that the
	// given line is part of (usually that is the line itself).
	function visualLine(line){var merged;while(merged=collapsedSpanAtStart(line)){line=merged.find(-1,true).line;}return line;}// Returns an array of logical lines that continue the visual line
	// started by the argument, or undefined if there are no such lines.
	function visualLineContinued(line){var merged,lines;while(merged=collapsedSpanAtEnd(line)){line=merged.find(1,true).line;(lines||(lines=[])).push(line);}return lines;}// Get the line number of the start of the visual line that the
	// given line number is part of.
	function visualLineNo(doc,lineN){var line=getLine(doc,lineN),vis=visualLine(line);if(line==vis){return lineN;}return lineNo(vis);}// Get the line number of the start of the next visual line after
	// the given line.
	function visualLineEndNo(doc,lineN){if(lineN>doc.lastLine()){return lineN;}var line=getLine(doc,lineN),merged;if(!lineIsHidden(doc,line)){return lineN;}while(merged=collapsedSpanAtEnd(line)){line=merged.find(1,true).line;}return lineNo(line)+1;}// Compute whether a line is hidden. Lines count as hidden when they
	// are part of a visual line that starts with another line, or when
	// they are entirely covered by collapsed, non-widget span.
	function lineIsHidden(doc,line){var sps=sawCollapsedSpans&&line.markedSpans;if(sps){for(var sp=void 0,i=0;i<sps.length;++i){sp=sps[i];if(!sp.marker.collapsed){continue;}if(sp.from==null){return true;}if(sp.marker.widgetNode){continue;}if(sp.from==0&&sp.marker.inclusiveLeft&&lineIsHiddenInner(doc,line,sp)){return true;}}}}function lineIsHiddenInner(doc,line,span){if(span.to==null){var end=span.marker.find(1,true);return lineIsHiddenInner(doc,end.line,getMarkedSpanFor(end.line.markedSpans,span.marker));}if(span.marker.inclusiveRight&&span.to==line.text.length){return true;}for(var sp=void 0,i=0;i<line.markedSpans.length;++i){sp=line.markedSpans[i];if(sp.marker.collapsed&&!sp.marker.widgetNode&&sp.from==span.to&&(sp.to==null||sp.to!=span.from)&&(sp.marker.inclusiveLeft||span.marker.inclusiveRight)&&lineIsHiddenInner(doc,line,sp)){return true;}}}// Find the height above the given line.
	function _heightAtLine(lineObj){lineObj=visualLine(lineObj);var h=0,chunk=lineObj.parent;for(var i=0;i<chunk.lines.length;++i){var line=chunk.lines[i];if(line==lineObj){break;}else{h+=line.height;}}for(var p=chunk.parent;p;chunk=p,p=chunk.parent){for(var i$1=0;i$1<p.children.length;++i$1){var cur=p.children[i$1];if(cur==chunk){break;}else{h+=cur.height;}}}return h;}// Compute the character length of a line, taking into account
	// collapsed ranges (see markText) that might hide parts, and join
	// other lines onto it.
	function lineLength(line){if(line.height==0){return 0;}var len=line.text.length,merged,cur=line;while(merged=collapsedSpanAtStart(cur)){var found=merged.find(0,true);cur=found.from.line;len+=found.from.ch-found.to.ch;}cur=line;while(merged=collapsedSpanAtEnd(cur)){var found$1=merged.find(0,true);len-=cur.text.length-found$1.from.ch;cur=found$1.to.line;len+=cur.text.length-found$1.to.ch;}return len;}// Find the longest line in the document.
	function findMaxLine(cm){var d=cm.display,doc=cm.doc;d.maxLine=getLine(doc,doc.first);d.maxLineLength=lineLength(d.maxLine);d.maxLineChanged=true;doc.iter(function(line){var len=lineLength(line);if(len>d.maxLineLength){d.maxLineLength=len;d.maxLine=line;}});}// BIDI HELPERS
	function iterateBidiSections(order,from,to,f){if(!order){return f(from,to,"ltr");}var found=false;for(var i=0;i<order.length;++i){var part=order[i];if(part.from<to&&part.to>from||from==to&&part.to==from){f(Math.max(part.from,from),Math.min(part.to,to),part.level==1?"rtl":"ltr");found=true;}}if(!found){f(from,to,"ltr");}}function bidiLeft(part){return part.level%2?part.to:part.from;}function bidiRight(part){return part.level%2?part.from:part.to;}function lineLeft(line){var order=getOrder(line);return order?bidiLeft(order[0]):0;}function lineRight(line){var order=getOrder(line);if(!order){return line.text.length;}return bidiRight(lst(order));}function compareBidiLevel(order,a,b){var linedir=order[0].level;if(a==linedir){return true;}if(b==linedir){return false;}return a<b;}var bidiOther=null;function getBidiPartAt(order,pos){var found;bidiOther=null;for(var i=0;i<order.length;++i){var cur=order[i];if(cur.from<pos&&cur.to>pos){return i;}if(cur.from==pos||cur.to==pos){if(found==null){found=i;}else if(compareBidiLevel(order,cur.level,order[found].level)){if(cur.from!=cur.to){bidiOther=found;}return i;}else{if(cur.from!=cur.to){bidiOther=i;}return found;}}}return found;}function moveInLine(line,pos,dir,byUnit){if(!byUnit){return pos+dir;}do{pos+=dir;}while(pos>0&&isExtendingChar(line.text.charAt(pos)));return pos;}// This is needed in order to move 'visually' through bi-directional
	// text -- i.e., pressing left should make the cursor go left, even
	// when in RTL text. The tricky part is the 'jumps', where RTL and
	// LTR text touch each other. This often requires the cursor offset
	// to move more than one unit, in order to visually move one unit.
	function moveVisually(line,start,dir,byUnit){var bidi=getOrder(line);if(!bidi){return moveLogically(line,start,dir,byUnit);}var pos=getBidiPartAt(bidi,start),part=bidi[pos];var target=moveInLine(line,start,part.level%2?-dir:dir,byUnit);for(;;){if(target>part.from&&target<part.to){return target;}if(target==part.from||target==part.to){if(getBidiPartAt(bidi,target)==pos){return target;}part=bidi[pos+=dir];return dir>0==part.level%2?part.to:part.from;}else{part=bidi[pos+=dir];if(!part){return null;}if(dir>0==part.level%2){target=moveInLine(line,part.to,-1,byUnit);}else{target=moveInLine(line,part.from,1,byUnit);}}}}function moveLogically(line,start,dir,byUnit){var target=start+dir;if(byUnit){while(target>0&&isExtendingChar(line.text.charAt(target))){target+=dir;}}return target<0||target>line.text.length?null:target;}// Bidirectional ordering algorithm
	// See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
	// that this (partially) implements.
	// One-char codes used for character types:
	// L (L):   Left-to-Right
	// R (R):   Right-to-Left
	// r (AL):  Right-to-Left Arabic
	// 1 (EN):  European Number
	// + (ES):  European Number Separator
	// % (ET):  European Number Terminator
	// n (AN):  Arabic Number
	// , (CS):  Common Number Separator
	// m (NSM): Non-Spacing Mark
	// b (BN):  Boundary Neutral
	// s (B):   Paragraph Separator
	// t (S):   Segment Separator
	// w (WS):  Whitespace
	// N (ON):  Other Neutrals
	// Returns null if characters are ordered as they appear
	// (left-to-right), or an array of sections ({from, to, level}
	// objects) in the order in which they occur visually.
	var bidiOrdering=function(){// Character types for codepoints 0 to 0xff
	var lowTypes="bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";// Character types for codepoints 0x600 to 0x6f9
	var arabicTypes="nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";function charType(code){if(code<=0xf7){return lowTypes.charAt(code);}else if(0x590<=code&&code<=0x5f4){return"R";}else if(0x600<=code&&code<=0x6f9){return arabicTypes.charAt(code-0x600);}else if(0x6ee<=code&&code<=0x8ac){return"r";}else if(0x2000<=code&&code<=0x200b){return"w";}else if(code==0x200c){return"b";}else{return"L";}}var bidiRE=/[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;var isNeutral=/[stwN]/,isStrong=/[LRr]/,countsAsLeft=/[Lb1n]/,countsAsNum=/[1n]/;// Browsers seem to always treat the boundaries of block elements as being L.
	var outerType="L";function BidiSpan(level,from,to){this.level=level;this.from=from;this.to=to;}return function(str){if(!bidiRE.test(str)){return false;}var len=str.length,types=[];for(var i=0;i<len;++i){types.push(charType(str.charCodeAt(i)));}// W1. Examine each non-spacing mark (NSM) in the level run, and
	// change the type of the NSM to the type of the previous
	// character. If the NSM is at the start of the level run, it will
	// get the type of sor.
	for(var i$1=0,prev=outerType;i$1<len;++i$1){var type=types[i$1];if(type=="m"){types[i$1]=prev;}else{prev=type;}}// W2. Search backwards from each instance of a European number
	// until the first strong type (R, L, AL, or sor) is found. If an
	// AL is found, change the type of the European number to Arabic
	// number.
	// W3. Change all ALs to R.
	for(var i$2=0,cur=outerType;i$2<len;++i$2){var type$1=types[i$2];if(type$1=="1"&&cur=="r"){types[i$2]="n";}else if(isStrong.test(type$1)){cur=type$1;if(type$1=="r"){types[i$2]="R";}}}// W4. A single European separator between two European numbers
	// changes to a European number. A single common separator between
	// two numbers of the same type changes to that type.
	for(var i$3=1,prev$1=types[0];i$3<len-1;++i$3){var type$2=types[i$3];if(type$2=="+"&&prev$1=="1"&&types[i$3+1]=="1"){types[i$3]="1";}else if(type$2==","&&prev$1==types[i$3+1]&&(prev$1=="1"||prev$1=="n")){types[i$3]=prev$1;}prev$1=type$2;}// W5. A sequence of European terminators adjacent to European
	// numbers changes to all European numbers.
	// W6. Otherwise, separators and terminators change to Other
	// Neutral.
	for(var i$4=0;i$4<len;++i$4){var type$3=types[i$4];if(type$3==","){types[i$4]="N";}else if(type$3=="%"){var end=void 0;for(end=i$4+1;end<len&&types[end]=="%";++end){}var replace=i$4&&types[i$4-1]=="!"||end<len&&types[end]=="1"?"1":"N";for(var j=i$4;j<end;++j){types[j]=replace;}i$4=end-1;}}// W7. Search backwards from each instance of a European number
	// until the first strong type (R, L, or sor) is found. If an L is
	// found, then change the type of the European number to L.
	for(var i$5=0,cur$1=outerType;i$5<len;++i$5){var type$4=types[i$5];if(cur$1=="L"&&type$4=="1"){types[i$5]="L";}else if(isStrong.test(type$4)){cur$1=type$4;}}// N1. A sequence of neutrals takes the direction of the
	// surrounding strong text if the text on both sides has the same
	// direction. European and Arabic numbers act as if they were R in
	// terms of their influence on neutrals. Start-of-level-run (sor)
	// and end-of-level-run (eor) are used at level run boundaries.
	// N2. Any remaining neutrals take the embedding direction.
	for(var i$6=0;i$6<len;++i$6){if(isNeutral.test(types[i$6])){var end$1=void 0;for(end$1=i$6+1;end$1<len&&isNeutral.test(types[end$1]);++end$1){}var before=(i$6?types[i$6-1]:outerType)=="L";var after=(end$1<len?types[end$1]:outerType)=="L";var replace$1=before||after?"L":"R";for(var j$1=i$6;j$1<end$1;++j$1){types[j$1]=replace$1;}i$6=end$1-1;}}// Here we depart from the documented algorithm, in order to avoid
	// building up an actual levels array. Since there are only three
	// levels (0, 1, 2) in an implementation that doesn't take
	// explicit embedding into account, we can build up the order on
	// the fly, without following the level-based algorithm.
	var order=[],m;for(var i$7=0;i$7<len;){if(countsAsLeft.test(types[i$7])){var start=i$7;for(++i$7;i$7<len&&countsAsLeft.test(types[i$7]);++i$7){}order.push(new BidiSpan(0,start,i$7));}else{var pos=i$7,at=order.length;for(++i$7;i$7<len&&types[i$7]!="L";++i$7){}for(var j$2=pos;j$2<i$7;){if(countsAsNum.test(types[j$2])){if(pos<j$2){order.splice(at,0,new BidiSpan(1,pos,j$2));}var nstart=j$2;for(++j$2;j$2<i$7&&countsAsNum.test(types[j$2]);++j$2){}order.splice(at,0,new BidiSpan(2,nstart,j$2));pos=j$2;}else{++j$2;}}if(pos<i$7){order.splice(at,0,new BidiSpan(1,pos,i$7));}}}if(order[0].level==1&&(m=str.match(/^\s+/))){order[0].from=m[0].length;order.unshift(new BidiSpan(0,0,m[0].length));}if(lst(order).level==1&&(m=str.match(/\s+$/))){lst(order).to-=m[0].length;order.push(new BidiSpan(0,len-m[0].length,len));}if(order[0].level==2){order.unshift(new BidiSpan(1,order[0].to,order[0].to));}if(order[0].level!=lst(order).level){order.push(new BidiSpan(order[0].level,len,len));}return order;};}();// Get the bidi ordering for the given line (and cache it). Returns
	// false for lines that are fully left-to-right, and an array of
	// BidiSpan objects otherwise.
	function getOrder(line){var order=line.order;if(order==null){order=line.order=bidiOrdering(line.text);}return order;}// EVENT HANDLING
	// Lightweight event framework. on/off also work on DOM nodes,
	// registering native DOM handlers.
	var noHandlers=[];var on=function on(emitter,type,f){if(emitter.addEventListener){emitter.addEventListener(type,f,false);}else if(emitter.attachEvent){emitter.attachEvent("on"+type,f);}else{var map=emitter._handlers||(emitter._handlers={});map[type]=(map[type]||noHandlers).concat(f);}};function getHandlers(emitter,type){return emitter._handlers&&emitter._handlers[type]||noHandlers;}function off(emitter,type,f){if(emitter.removeEventListener){emitter.removeEventListener(type,f,false);}else if(emitter.detachEvent){emitter.detachEvent("on"+type,f);}else{var map=emitter._handlers,arr=map&&map[type];if(arr){var index=indexOf(arr,f);if(index>-1){map[type]=arr.slice(0,index).concat(arr.slice(index+1));}}}}function signal(emitter,type/*, values...*/){var handlers=getHandlers(emitter,type);if(!handlers.length){return;}var args=Array.prototype.slice.call(arguments,2);for(var i=0;i<handlers.length;++i){handlers[i].apply(null,args);}}// The DOM events that CodeMirror handles can be overridden by
	// registering a (non-DOM) handler on the editor for the event name,
	// and preventDefault-ing the event in that handler.
	function signalDOMEvent(cm,e,override){if(typeof e=="string"){e={type:e,preventDefault:function preventDefault(){this.defaultPrevented=true;}};}signal(cm,override||e.type,cm,e);return e_defaultPrevented(e)||e.codemirrorIgnore;}function signalCursorActivity(cm){var arr=cm._handlers&&cm._handlers.cursorActivity;if(!arr){return;}var set=cm.curOp.cursorActivityHandlers||(cm.curOp.cursorActivityHandlers=[]);for(var i=0;i<arr.length;++i){if(indexOf(set,arr[i])==-1){set.push(arr[i]);}}}function hasHandler(emitter,type){return getHandlers(emitter,type).length>0;}// Add on and off methods to a constructor's prototype, to make
	// registering events on such objects more convenient.
	function eventMixin(ctor){ctor.prototype.on=function(type,f){on(this,type,f);};ctor.prototype.off=function(type,f){off(this,type,f);};}// Due to the fact that we still support jurassic IE versions, some
	// compatibility wrappers are needed.
	function e_preventDefault(e){if(e.preventDefault){e.preventDefault();}else{e.returnValue=false;}}function e_stopPropagation(e){if(e.stopPropagation){e.stopPropagation();}else{e.cancelBubble=true;}}function e_defaultPrevented(e){return e.defaultPrevented!=null?e.defaultPrevented:e.returnValue==false;}function e_stop(e){e_preventDefault(e);e_stopPropagation(e);}function e_target(e){return e.target||e.srcElement;}function e_button(e){var b=e.which;if(b==null){if(e.button&1){b=1;}else if(e.button&2){b=3;}else if(e.button&4){b=2;}}if(mac&&e.ctrlKey&&b==1){b=3;}return b;}// Detect drag-and-drop
	var dragAndDrop=function(){// There is *some* kind of drag-and-drop support in IE6-8, but I
	// couldn't get it to work yet.
	if(ie&&ie_version<9){return false;}var div=elt('div');return"draggable"in div||"dragDrop"in div;}();var zwspSupported;function zeroWidthElement(measure){if(zwspSupported==null){var test=elt("span",'\u200B');removeChildrenAndAdd(measure,elt("span",[test,document.createTextNode("x")]));if(measure.firstChild.offsetHeight!=0){zwspSupported=test.offsetWidth<=1&&test.offsetHeight>2&&!(ie&&ie_version<8);}}var node=zwspSupported?elt("span",'\u200B'):elt("span",'\xA0',null,"display: inline-block; width: 1px; margin-right: -1px");node.setAttribute("cm-text","");return node;}// Feature-detect IE's crummy client rect reporting for bidi text
	var badBidiRects;function hasBadBidiRects(measure){if(badBidiRects!=null){return badBidiRects;}var txt=removeChildrenAndAdd(measure,document.createTextNode('A\u062EA'));var r0=range(txt,0,1).getBoundingClientRect();var r1=range(txt,1,2).getBoundingClientRect();removeChildren(measure);if(!r0||r0.left==r0.right){return false;}// Safari returns null in some cases (#2780)
	return badBidiRects=r1.right-r0.right<3;}// See if "".split is the broken IE version, if so, provide an
	// alternative way to split lines.
	var splitLinesAuto="\n\nb".split(/\n/).length!=3?function(string){var pos=0,result=[],l=string.length;while(pos<=l){var nl=string.indexOf("\n",pos);if(nl==-1){nl=string.length;}var line=string.slice(pos,string.charAt(nl-1)=="\r"?nl-1:nl);var rt=line.indexOf("\r");if(rt!=-1){result.push(line.slice(0,rt));pos+=rt+1;}else{result.push(line);pos=nl+1;}}return result;}:function(string){return string.split(/\r\n?|\n/);};var hasSelection=window.getSelection?function(te){try{return te.selectionStart!=te.selectionEnd;}catch(e){return false;}}:function(te){var range;try{range=te.ownerDocument.selection.createRange();}catch(e){}if(!range||range.parentElement()!=te){return false;}return range.compareEndPoints("StartToEnd",range)!=0;};var hasCopyEvent=function(){var e=elt("div");if("oncopy"in e){return true;}e.setAttribute("oncopy","return;");return typeof e.oncopy=="function";}();var badZoomedRects=null;function hasBadZoomedRects(measure){if(badZoomedRects!=null){return badZoomedRects;}var node=removeChildrenAndAdd(measure,elt("span","x"));var normal=node.getBoundingClientRect();var fromRange=range(node,0,1).getBoundingClientRect();return badZoomedRects=Math.abs(normal.left-fromRange.left)>1;}var modes={};var mimeModes={};// Extra arguments are stored as the mode's dependencies, which is
	// used by (legacy) mechanisms like loadmode.js to automatically
	// load a mode. (Preferred mechanism is the require/define calls.)
	function defineMode(name,mode){if(arguments.length>2){mode.dependencies=Array.prototype.slice.call(arguments,2);}modes[name]=mode;}function defineMIME(mime,spec){mimeModes[mime]=spec;}// Given a MIME type, a {name, ...options} config object, or a name
	// string, return a mode config object.
	function resolveMode(spec){if(typeof spec=="string"&&mimeModes.hasOwnProperty(spec)){spec=mimeModes[spec];}else if(spec&&typeof spec.name=="string"&&mimeModes.hasOwnProperty(spec.name)){var found=mimeModes[spec.name];if(typeof found=="string"){found={name:found};}spec=createObj(found,spec);spec.name=found.name;}else if(typeof spec=="string"&&/^[\w\-]+\/[\w\-]+\+xml$/.test(spec)){return resolveMode("application/xml");}else if(typeof spec=="string"&&/^[\w\-]+\/[\w\-]+\+json$/.test(spec)){return resolveMode("application/json");}if(typeof spec=="string"){return{name:spec};}else{return spec||{name:"null"};}}// Given a mode spec (anything that resolveMode accepts), find and
	// initialize an actual mode object.
	function getMode(options,spec){spec=resolveMode(spec);var mfactory=modes[spec.name];if(!mfactory){return getMode(options,"text/plain");}var modeObj=mfactory(options,spec);if(modeExtensions.hasOwnProperty(spec.name)){var exts=modeExtensions[spec.name];for(var prop in exts){if(!exts.hasOwnProperty(prop)){continue;}if(modeObj.hasOwnProperty(prop)){modeObj["_"+prop]=modeObj[prop];}modeObj[prop]=exts[prop];}}modeObj.name=spec.name;if(spec.helperType){modeObj.helperType=spec.helperType;}if(spec.modeProps){for(var prop$1 in spec.modeProps){modeObj[prop$1]=spec.modeProps[prop$1];}}return modeObj;}// This can be used to attach properties to mode objects from
	// outside the actual mode definition.
	var modeExtensions={};function extendMode(mode,properties){var exts=modeExtensions.hasOwnProperty(mode)?modeExtensions[mode]:modeExtensions[mode]={};copyObj(properties,exts);}function copyState(mode,state){if(state===true){return state;}if(mode.copyState){return mode.copyState(state);}var nstate={};for(var n in state){var val=state[n];if(val instanceof Array){val=val.concat([]);}nstate[n]=val;}return nstate;}// Given a mode and a state (for that mode), find the inner mode and
	// state at the position that the state refers to.
	function innerMode(mode,state){var info;while(mode.innerMode){info=mode.innerMode(state);if(!info||info.mode==mode){break;}state=info.state;mode=info.mode;}return info||{mode:mode,state:state};}function startState(mode,a1,a2){return mode.startState?mode.startState(a1,a2):true;}// STRING STREAM
	// Fed to the mode parsers, provides helper functions to make
	// parsers more succinct.
	var StringStream=function StringStream(string,tabSize){this.pos=this.start=0;this.string=string;this.tabSize=tabSize||8;this.lastColumnPos=this.lastColumnValue=0;this.lineStart=0;};StringStream.prototype={eol:function eol(){return this.pos>=this.string.length;},sol:function sol(){return this.pos==this.lineStart;},peek:function peek(){return this.string.charAt(this.pos)||undefined;},next:function next(){if(this.pos<this.string.length){return this.string.charAt(this.pos++);}},eat:function eat(match){var ch=this.string.charAt(this.pos);var ok;if(typeof match=="string"){ok=ch==match;}else{ok=ch&&(match.test?match.test(ch):match(ch));}if(ok){++this.pos;return ch;}},eatWhile:function eatWhile(match){var start=this.pos;while(this.eat(match)){}return this.pos>start;},eatSpace:function eatSpace(){var this$1=this;var start=this.pos;while(/[\s\u00a0]/.test(this.string.charAt(this.pos))){++this$1.pos;}return this.pos>start;},skipToEnd:function skipToEnd(){this.pos=this.string.length;},skipTo:function skipTo(ch){var found=this.string.indexOf(ch,this.pos);if(found>-1){this.pos=found;return true;}},backUp:function backUp(n){this.pos-=n;},column:function column(){if(this.lastColumnPos<this.start){this.lastColumnValue=countColumn(this.string,this.start,this.tabSize,this.lastColumnPos,this.lastColumnValue);this.lastColumnPos=this.start;}return this.lastColumnValue-(this.lineStart?countColumn(this.string,this.lineStart,this.tabSize):0);},indentation:function indentation(){return countColumn(this.string,null,this.tabSize)-(this.lineStart?countColumn(this.string,this.lineStart,this.tabSize):0);},match:function match(pattern,consume,caseInsensitive){if(typeof pattern=="string"){var cased=function cased(str){return caseInsensitive?str.toLowerCase():str;};var substr=this.string.substr(this.pos,pattern.length);if(cased(substr)==cased(pattern)){if(consume!==false){this.pos+=pattern.length;}return true;}}else{var match=this.string.slice(this.pos).match(pattern);if(match&&match.index>0){return null;}if(match&&consume!==false){this.pos+=match[0].length;}return match;}},current:function current(){return this.string.slice(this.start,this.pos);},hideFirstChars:function hideFirstChars(n,inner){this.lineStart+=n;try{return inner();}finally{this.lineStart-=n;}}};// Compute a style array (an array starting with a mode generation
	// -- for invalidation -- followed by pairs of end positions and
	// style strings), which is used to highlight the tokens on the
	// line.
	function highlightLine(cm,line,state,forceToEnd){// A styles array always starts with a number identifying the
	// mode/overlays that it is based on (for easy invalidation).
	var st=[cm.state.modeGen],lineClasses={};// Compute the base array of styles
	runMode(cm,line.text,cm.doc.mode,state,function(end,style){return st.push(end,style);},lineClasses,forceToEnd);// Run overlays, adjust style array.
	var loop=function loop(o){var overlay=cm.state.overlays[o],i=1,at=0;runMode(cm,line.text,overlay.mode,true,function(end,style){var start=i;// Ensure there's a token end at the current position, and that i points at it
	while(at<end){var i_end=st[i];if(i_end>end){st.splice(i,1,end,st[i+1],i_end);}i+=2;at=Math.min(end,i_end);}if(!style){return;}if(overlay.opaque){st.splice(start,i-start,end,"overlay "+style);i=start+2;}else{for(;start<i;start+=2){var cur=st[start+1];st[start+1]=(cur?cur+" ":"")+"overlay "+style;}}},lineClasses);};for(var o=0;o<cm.state.overlays.length;++o){loop(o);}return{styles:st,classes:lineClasses.bgClass||lineClasses.textClass?lineClasses:null};}function getLineStyles(cm,line,updateFrontier){if(!line.styles||line.styles[0]!=cm.state.modeGen){var state=getStateBefore(cm,lineNo(line));var result=highlightLine(cm,line,line.text.length>cm.options.maxHighlightLength?copyState(cm.doc.mode,state):state);line.stateAfter=state;line.styles=result.styles;if(result.classes){line.styleClasses=result.classes;}else if(line.styleClasses){line.styleClasses=null;}if(updateFrontier===cm.doc.frontier){cm.doc.frontier++;}}return line.styles;}function getStateBefore(cm,n,precise){var doc=cm.doc,display=cm.display;if(!doc.mode.startState){return true;}var pos=findStartLine(cm,n,precise),state=pos>doc.first&&getLine(doc,pos-1).stateAfter;if(!state){state=startState(doc.mode);}else{state=copyState(doc.mode,state);}doc.iter(pos,n,function(line){processLine(cm,line.text,state);var save=pos==n-1||pos%5==0||pos>=display.viewFrom&&pos<display.viewTo;line.stateAfter=save?copyState(doc.mode,state):null;++pos;});if(precise){doc.frontier=pos;}return state;}// Lightweight form of highlight -- proceed over this line and
	// update state, but don't save a style array. Used for lines that
	// aren't currently visible.
	function processLine(cm,text,state,startAt){var mode=cm.doc.mode;var stream=new StringStream(text,cm.options.tabSize);stream.start=stream.pos=startAt||0;if(text==""){callBlankLine(mode,state);}while(!stream.eol()){readToken(mode,stream,state);stream.start=stream.pos;}}function callBlankLine(mode,state){if(mode.blankLine){return mode.blankLine(state);}if(!mode.innerMode){return;}var inner=innerMode(mode,state);if(inner.mode.blankLine){return inner.mode.blankLine(inner.state);}}function readToken(mode,stream,state,inner){for(var i=0;i<10;i++){if(inner){inner[0]=innerMode(mode,state).mode;}var style=mode.token(stream,state);if(stream.pos>stream.start){return style;}}throw new Error("Mode "+mode.name+" failed to advance stream.");}// Utility for getTokenAt and getLineTokens
	function takeToken(cm,pos,precise,asArray){var getObj=function getObj(copy){return{start:stream.start,end:stream.pos,string:stream.current(),type:style||null,state:copy?copyState(doc.mode,state):state};};var doc=cm.doc,mode=doc.mode,style;pos=_clipPos(doc,pos);var line=getLine(doc,pos.line),state=getStateBefore(cm,pos.line,precise);var stream=new StringStream(line.text,cm.options.tabSize),tokens;if(asArray){tokens=[];}while((asArray||stream.pos<pos.ch)&&!stream.eol()){stream.start=stream.pos;style=readToken(mode,stream,state);if(asArray){tokens.push(getObj(true));}}return asArray?tokens:getObj();}function extractLineClasses(type,output){if(type){for(;;){var lineClass=type.match(/(?:^|\s+)line-(background-)?(\S+)/);if(!lineClass){break;}type=type.slice(0,lineClass.index)+type.slice(lineClass.index+lineClass[0].length);var prop=lineClass[1]?"bgClass":"textClass";if(output[prop]==null){output[prop]=lineClass[2];}else if(!new RegExp("(?:^|\s)"+lineClass[2]+"(?:$|\s)").test(output[prop])){output[prop]+=" "+lineClass[2];}}}return type;}// Run the given mode's parser over a line, calling f for each token.
	function runMode(cm,text,mode,state,f,lineClasses,forceToEnd){var flattenSpans=mode.flattenSpans;if(flattenSpans==null){flattenSpans=cm.options.flattenSpans;}var curStart=0,curStyle=null;var stream=new StringStream(text,cm.options.tabSize),style;var inner=cm.options.addModeClass&&[null];if(text==""){extractLineClasses(callBlankLine(mode,state),lineClasses);}while(!stream.eol()){if(stream.pos>cm.options.maxHighlightLength){flattenSpans=false;if(forceToEnd){processLine(cm,text,state,stream.pos);}stream.pos=text.length;style=null;}else{style=extractLineClasses(readToken(mode,stream,state,inner),lineClasses);}if(inner){var mName=inner[0].name;if(mName){style="m-"+(style?mName+" "+style:mName);}}if(!flattenSpans||curStyle!=style){while(curStart<stream.start){curStart=Math.min(stream.start,curStart+5000);f(curStart,curStyle);}curStyle=style;}stream.start=stream.pos;}while(curStart<stream.pos){// Webkit seems to refuse to render text nodes longer than 57444
	// characters, and returns inaccurate measurements in nodes
	// starting around 5000 chars.
	var pos=Math.min(stream.pos,curStart+5000);f(pos,curStyle);curStart=pos;}}// Finds the line to start with when starting a parse. Tries to
	// find a line with a stateAfter, so that it can start with a
	// valid state. If that fails, it returns the line with the
	// smallest indentation, which tends to need the least context to
	// parse correctly.
	function findStartLine(cm,n,precise){var minindent,minline,doc=cm.doc;var lim=precise?-1:n-(cm.doc.mode.innerMode?1000:100);for(var search=n;search>lim;--search){if(search<=doc.first){return doc.first;}var line=getLine(doc,search-1);if(line.stateAfter&&(!precise||search<=doc.frontier)){return search;}var indented=countColumn(line.text,null,cm.options.tabSize);if(minline==null||minindent>indented){minline=search-1;minindent=indented;}}return minline;}// LINE DATA STRUCTURE
	// Line objects. These hold state related to a line, including
	// highlighting info (the styles array).
	function Line(text,markedSpans,estimateHeight){this.text=text;attachMarkedSpans(this,markedSpans);this.height=estimateHeight?estimateHeight(this):1;}eventMixin(Line);Line.prototype.lineNo=function(){return lineNo(this);};// Change the content (text, markers) of a line. Automatically
	// invalidates cached information and tries to re-estimate the
	// line's height.
	function updateLine(line,text,markedSpans,estimateHeight){line.text=text;if(line.stateAfter){line.stateAfter=null;}if(line.styles){line.styles=null;}if(line.order!=null){line.order=null;}detachMarkedSpans(line);attachMarkedSpans(line,markedSpans);var estHeight=estimateHeight?estimateHeight(line):1;if(estHeight!=line.height){updateLineHeight(line,estHeight);}}// Detach a line from the document tree and its markers.
	function cleanUpLine(line){line.parent=null;detachMarkedSpans(line);}// Convert a style as returned by a mode (either null, or a string
	// containing one or more styles) to a CSS style. This is cached,
	// and also looks for line-wide styles.
	var styleToClassCache={};var styleToClassCacheWithMode={};function interpretTokenStyle(style,options){if(!style||/^\s*$/.test(style)){return null;}var cache=options.addModeClass?styleToClassCacheWithMode:styleToClassCache;return cache[style]||(cache[style]=style.replace(/\S+/g,"cm-$&"));}// Render the DOM representation of the text of a line. Also builds
	// up a 'line map', which points at the DOM nodes that represent
	// specific stretches of text, and is used by the measuring code.
	// The returned object contains the DOM node, this map, and
	// information about line-wide styles that were set by the mode.
	function buildLineContent(cm,lineView){// The padding-right forces the element to have a 'border', which
	// is needed on Webkit to be able to get line-level bounding
	// rectangles for it (in measureChar).
	var content=elt("span",null,null,webkit?"padding-right: .1px":null);var builder={pre:elt("pre",[content],"CodeMirror-line"),content:content,col:0,pos:0,cm:cm,trailingSpace:false,splitSpaces:(ie||webkit)&&cm.getOption("lineWrapping")};lineView.measure={};// Iterate over the logical lines that make up this visual line.
	for(var i=0;i<=(lineView.rest?lineView.rest.length:0);i++){var line=i?lineView.rest[i-1]:lineView.line,order=void 0;builder.pos=0;builder.addToken=buildToken;// Optionally wire in some hacks into the token-rendering
	// algorithm, to deal with browser quirks.
	if(hasBadBidiRects(cm.display.measure)&&(order=getOrder(line))){builder.addToken=buildTokenBadBidi(builder.addToken,order);}builder.map=[];var allowFrontierUpdate=lineView!=cm.display.externalMeasured&&lineNo(line);insertLineContent(line,builder,getLineStyles(cm,line,allowFrontierUpdate));if(line.styleClasses){if(line.styleClasses.bgClass){builder.bgClass=joinClasses(line.styleClasses.bgClass,builder.bgClass||"");}if(line.styleClasses.textClass){builder.textClass=joinClasses(line.styleClasses.textClass,builder.textClass||"");}}// Ensure at least a single node is present, for measuring.
	if(builder.map.length==0){builder.map.push(0,0,builder.content.appendChild(zeroWidthElement(cm.display.measure)));}// Store the map and a cache object for the current logical line
	if(i==0){lineView.measure.map=builder.map;lineView.measure.cache={};}else{;(lineView.measure.maps||(lineView.measure.maps=[])).push(builder.map);(lineView.measure.caches||(lineView.measure.caches=[])).push({});}}// See issue #2901
	if(webkit){var last=builder.content.lastChild;if(/\bcm-tab\b/.test(last.className)||last.querySelector&&last.querySelector(".cm-tab")){builder.content.className="cm-tab-wrap-hack";}}signal(cm,"renderLine",cm,lineView.line,builder.pre);if(builder.pre.className){builder.textClass=joinClasses(builder.pre.className,builder.textClass||"");}return builder;}function defaultSpecialCharPlaceholder(ch){var token=elt("span",'\u2022',"cm-invalidchar");token.title='\\u'+ch.charCodeAt(0).toString(16);token.setAttribute("aria-label",token.title);return token;}// Build up the DOM representation for a single token, and add it to
	// the line map. Takes care to render special characters separately.
	function buildToken(builder,text,style,startStyle,endStyle,title,css){if(!text){return;}var displayText=builder.splitSpaces?splitSpaces(text,builder.trailingSpace):text;var special=builder.cm.state.specialChars,mustWrap=false;var content;if(!special.test(text)){builder.col+=text.length;content=document.createTextNode(displayText);builder.map.push(builder.pos,builder.pos+text.length,content);if(ie&&ie_version<9){mustWrap=true;}builder.pos+=text.length;}else{content=document.createDocumentFragment();var pos=0;while(true){special.lastIndex=pos;var m=special.exec(text);var skipped=m?m.index-pos:text.length-pos;if(skipped){var txt=document.createTextNode(displayText.slice(pos,pos+skipped));if(ie&&ie_version<9){content.appendChild(elt("span",[txt]));}else{content.appendChild(txt);}builder.map.push(builder.pos,builder.pos+skipped,txt);builder.col+=skipped;builder.pos+=skipped;}if(!m){break;}pos+=skipped+1;var txt$1=void 0;if(m[0]=="\t"){var tabSize=builder.cm.options.tabSize,tabWidth=tabSize-builder.col%tabSize;txt$1=content.appendChild(elt("span",spaceStr(tabWidth),"cm-tab"));txt$1.setAttribute("role","presentation");txt$1.setAttribute("cm-text","\t");builder.col+=tabWidth;}else if(m[0]=="\r"||m[0]=="\n"){txt$1=content.appendChild(elt("span",m[0]=="\r"?'\u240D':'\u2424',"cm-invalidchar"));txt$1.setAttribute("cm-text",m[0]);builder.col+=1;}else{txt$1=builder.cm.options.specialCharPlaceholder(m[0]);txt$1.setAttribute("cm-text",m[0]);if(ie&&ie_version<9){content.appendChild(elt("span",[txt$1]));}else{content.appendChild(txt$1);}builder.col+=1;}builder.map.push(builder.pos,builder.pos+1,txt$1);builder.pos++;}}builder.trailingSpace=displayText.charCodeAt(text.length-1)==32;if(style||startStyle||endStyle||mustWrap||css){var fullStyle=style||"";if(startStyle){fullStyle+=startStyle;}if(endStyle){fullStyle+=endStyle;}var token=elt("span",[content],fullStyle,css);if(title){token.title=title;}return builder.content.appendChild(token);}builder.content.appendChild(content);}function splitSpaces(text,trailingBefore){if(text.length>1&&!/  /.test(text)){return text;}var spaceBefore=trailingBefore,result="";for(var i=0;i<text.length;i++){var ch=text.charAt(i);if(ch==" "&&spaceBefore&&(i==text.length-1||text.charCodeAt(i+1)==32)){ch='\xA0';}result+=ch;spaceBefore=ch==" ";}return result;}// Work around nonsense dimensions being reported for stretches of
	// right-to-left text.
	function buildTokenBadBidi(inner,order){return function(builder,text,style,startStyle,endStyle,title,css){style=style?style+" cm-force-border":"cm-force-border";var start=builder.pos,end=start+text.length;for(;;){// Find the part that overlaps with the start of this text
	var part=void 0;for(var i=0;i<order.length;i++){part=order[i];if(part.to>start&&part.from<=start){break;}}if(part.to>=end){return inner(builder,text,style,startStyle,endStyle,title,css);}inner(builder,text.slice(0,part.to-start),style,startStyle,null,title,css);startStyle=null;text=text.slice(part.to-start);start=part.to;}};}function buildCollapsedSpan(builder,size,marker,ignoreWidget){var widget=!ignoreWidget&&marker.widgetNode;if(widget){builder.map.push(builder.pos,builder.pos+size,widget);}if(!ignoreWidget&&builder.cm.display.input.needsContentAttribute){if(!widget){widget=builder.content.appendChild(document.createElement("span"));}widget.setAttribute("cm-marker",marker.id);}if(widget){builder.cm.display.input.setUneditable(widget);builder.content.appendChild(widget);}builder.pos+=size;builder.trailingSpace=false;}// Outputs a number of spans to make up a line, taking highlighting
	// and marked text into account.
	function insertLineContent(line,builder,styles){var spans=line.markedSpans,allText=line.text,at=0;if(!spans){for(var i$1=1;i$1<styles.length;i$1+=2){builder.addToken(builder,allText.slice(at,at=styles[i$1]),interpretTokenStyle(styles[i$1+1],builder.cm.options));}return;}var len=allText.length,pos=0,i=1,text="",style,css;var nextChange=0,spanStyle,spanEndStyle,spanStartStyle,title,collapsed;for(;;){if(nextChange==pos){// Update current marker set
	spanStyle=spanEndStyle=spanStartStyle=title=css="";collapsed=null;nextChange=Infinity;var foundBookmarks=[],endStyles=void 0;for(var j=0;j<spans.length;++j){var sp=spans[j],m=sp.marker;if(m.type=="bookmark"&&sp.from==pos&&m.widgetNode){foundBookmarks.push(m);}else if(sp.from<=pos&&(sp.to==null||sp.to>pos||m.collapsed&&sp.to==pos&&sp.from==pos)){if(sp.to!=null&&sp.to!=pos&&nextChange>sp.to){nextChange=sp.to;spanEndStyle="";}if(m.className){spanStyle+=" "+m.className;}if(m.css){css=(css?css+";":"")+m.css;}if(m.startStyle&&sp.from==pos){spanStartStyle+=" "+m.startStyle;}if(m.endStyle&&sp.to==nextChange){(endStyles||(endStyles=[])).push(m.endStyle,sp.to);}if(m.title&&!title){title=m.title;}if(m.collapsed&&(!collapsed||compareCollapsedMarkers(collapsed.marker,m)<0)){collapsed=sp;}}else if(sp.from>pos&&nextChange>sp.from){nextChange=sp.from;}}if(endStyles){for(var j$1=0;j$1<endStyles.length;j$1+=2){if(endStyles[j$1+1]==nextChange){spanEndStyle+=" "+endStyles[j$1];}}}if(!collapsed||collapsed.from==pos){for(var j$2=0;j$2<foundBookmarks.length;++j$2){buildCollapsedSpan(builder,0,foundBookmarks[j$2]);}}if(collapsed&&(collapsed.from||0)==pos){buildCollapsedSpan(builder,(collapsed.to==null?len+1:collapsed.to)-pos,collapsed.marker,collapsed.from==null);if(collapsed.to==null){return;}if(collapsed.to==pos){collapsed=false;}}}if(pos>=len){break;}var upto=Math.min(len,nextChange);while(true){if(text){var end=pos+text.length;if(!collapsed){var tokenText=end>upto?text.slice(0,upto-pos):text;builder.addToken(builder,tokenText,style?style+spanStyle:spanStyle,spanStartStyle,pos+tokenText.length==nextChange?spanEndStyle:"",title,css);}if(end>=upto){text=text.slice(upto-pos);pos=upto;break;}pos=end;spanStartStyle="";}text=allText.slice(at,at=styles[i++]);style=interpretTokenStyle(styles[i++],builder.cm.options);}}}// These objects are used to represent the visible (currently drawn)
	// part of the document. A LineView may correspond to multiple
	// logical lines, if those are connected by collapsed ranges.
	function LineView(doc,line,lineN){// The starting line
	this.line=line;// Continuing lines, if any
	this.rest=visualLineContinued(line);// Number of logical lines in this visual line
	this.size=this.rest?lineNo(lst(this.rest))-lineN+1:1;this.node=this.text=null;this.hidden=lineIsHidden(doc,line);}// Create a range of LineView objects for the given lines.
	function buildViewArray(cm,from,to){var array=[],nextPos;for(var pos=from;pos<to;pos=nextPos){var view=new LineView(cm.doc,getLine(cm.doc,pos),pos);nextPos=pos+view.size;array.push(view);}return array;}var operationGroup=null;function pushOperation(op){if(operationGroup){operationGroup.ops.push(op);}else{op.ownsGroup=operationGroup={ops:[op],delayedCallbacks:[]};}}function fireCallbacksForOps(group){// Calls delayed callbacks and cursorActivity handlers until no
	// new ones appear
	var callbacks=group.delayedCallbacks,i=0;do{for(;i<callbacks.length;i++){callbacks[i].call(null);}for(var j=0;j<group.ops.length;j++){var op=group.ops[j];if(op.cursorActivityHandlers){while(op.cursorActivityCalled<op.cursorActivityHandlers.length){op.cursorActivityHandlers[op.cursorActivityCalled++].call(null,op.cm);}}}}while(i<callbacks.length);}function finishOperation(op,endCb){var group=op.ownsGroup;if(!group){return;}try{fireCallbacksForOps(group);}finally{operationGroup=null;endCb(group);}}var orphanDelayedCallbacks=null;// Often, we want to signal events at a point where we are in the
	// middle of some work, but don't want the handler to start calling
	// other methods on the editor, which might be in an inconsistent
	// state or simply not expect any other events to happen.
	// signalLater looks whether there are any handlers, and schedules
	// them to be executed when the last operation ends, or, if no
	// operation is active, when a timeout fires.
	function signalLater(emitter,type/*, values...*/){var arr=getHandlers(emitter,type);if(!arr.length){return;}var args=Array.prototype.slice.call(arguments,2),list;if(operationGroup){list=operationGroup.delayedCallbacks;}else if(orphanDelayedCallbacks){list=orphanDelayedCallbacks;}else{list=orphanDelayedCallbacks=[];setTimeout(fireOrphanDelayed,0);}var loop=function loop(i){list.push(function(){return arr[i].apply(null,args);});};for(var i=0;i<arr.length;++i){loop(i);}}function fireOrphanDelayed(){var delayed=orphanDelayedCallbacks;orphanDelayedCallbacks=null;for(var i=0;i<delayed.length;++i){delayed[i]();}}// When an aspect of a line changes, a string is added to
	// lineView.changes. This updates the relevant part of the line's
	// DOM structure.
	function updateLineForChanges(cm,lineView,lineN,dims){for(var j=0;j<lineView.changes.length;j++){var type=lineView.changes[j];if(type=="text"){updateLineText(cm,lineView);}else if(type=="gutter"){updateLineGutter(cm,lineView,lineN,dims);}else if(type=="class"){updateLineClasses(lineView);}else if(type=="widget"){updateLineWidgets(cm,lineView,dims);}}lineView.changes=null;}// Lines with gutter elements, widgets or a background class need to
	// be wrapped, and have the extra elements added to the wrapper div
	function ensureLineWrapped(lineView){if(lineView.node==lineView.text){lineView.node=elt("div",null,null,"position: relative");if(lineView.text.parentNode){lineView.text.parentNode.replaceChild(lineView.node,lineView.text);}lineView.node.appendChild(lineView.text);if(ie&&ie_version<8){lineView.node.style.zIndex=2;}}return lineView.node;}function updateLineBackground(lineView){var cls=lineView.bgClass?lineView.bgClass+" "+(lineView.line.bgClass||""):lineView.line.bgClass;if(cls){cls+=" CodeMirror-linebackground";}if(lineView.background){if(cls){lineView.background.className=cls;}else{lineView.background.parentNode.removeChild(lineView.background);lineView.background=null;}}else if(cls){var wrap=ensureLineWrapped(lineView);lineView.background=wrap.insertBefore(elt("div",null,cls),wrap.firstChild);}}// Wrapper around buildLineContent which will reuse the structure
	// in display.externalMeasured when possible.
	function getLineContent(cm,lineView){var ext=cm.display.externalMeasured;if(ext&&ext.line==lineView.line){cm.display.externalMeasured=null;lineView.measure=ext.measure;return ext.built;}return buildLineContent(cm,lineView);}// Redraw the line's text. Interacts with the background and text
	// classes because the mode may output tokens that influence these
	// classes.
	function updateLineText(cm,lineView){var cls=lineView.text.className;var built=getLineContent(cm,lineView);if(lineView.text==lineView.node){lineView.node=built.pre;}lineView.text.parentNode.replaceChild(built.pre,lineView.text);lineView.text=built.pre;if(built.bgClass!=lineView.bgClass||built.textClass!=lineView.textClass){lineView.bgClass=built.bgClass;lineView.textClass=built.textClass;updateLineClasses(lineView);}else if(cls){lineView.text.className=cls;}}function updateLineClasses(lineView){updateLineBackground(lineView);if(lineView.line.wrapClass){ensureLineWrapped(lineView).className=lineView.line.wrapClass;}else if(lineView.node!=lineView.text){lineView.node.className="";}var textClass=lineView.textClass?lineView.textClass+" "+(lineView.line.textClass||""):lineView.line.textClass;lineView.text.className=textClass||"";}function updateLineGutter(cm,lineView,lineN,dims){if(lineView.gutter){lineView.node.removeChild(lineView.gutter);lineView.gutter=null;}if(lineView.gutterBackground){lineView.node.removeChild(lineView.gutterBackground);lineView.gutterBackground=null;}if(lineView.line.gutterClass){var wrap=ensureLineWrapped(lineView);lineView.gutterBackground=elt("div",null,"CodeMirror-gutter-background "+lineView.line.gutterClass,"left: "+(cm.options.fixedGutter?dims.fixedPos:-dims.gutterTotalWidth)+"px; width: "+dims.gutterTotalWidth+"px");wrap.insertBefore(lineView.gutterBackground,lineView.text);}var markers=lineView.line.gutterMarkers;if(cm.options.lineNumbers||markers){var wrap$1=ensureLineWrapped(lineView);var gutterWrap=lineView.gutter=elt("div",null,"CodeMirror-gutter-wrapper","left: "+(cm.options.fixedGutter?dims.fixedPos:-dims.gutterTotalWidth)+"px");cm.display.input.setUneditable(gutterWrap);wrap$1.insertBefore(gutterWrap,lineView.text);if(lineView.line.gutterClass){gutterWrap.className+=" "+lineView.line.gutterClass;}if(cm.options.lineNumbers&&(!markers||!markers["CodeMirror-linenumbers"])){lineView.lineNumber=gutterWrap.appendChild(elt("div",lineNumberFor(cm.options,lineN),"CodeMirror-linenumber CodeMirror-gutter-elt","left: "+dims.gutterLeft["CodeMirror-linenumbers"]+"px; width: "+cm.display.lineNumInnerWidth+"px"));}if(markers){for(var k=0;k<cm.options.gutters.length;++k){var id=cm.options.gutters[k],found=markers.hasOwnProperty(id)&&markers[id];if(found){gutterWrap.appendChild(elt("div",[found],"CodeMirror-gutter-elt","left: "+dims.gutterLeft[id]+"px; width: "+dims.gutterWidth[id]+"px"));}}}}}function updateLineWidgets(cm,lineView,dims){if(lineView.alignable){lineView.alignable=null;}for(var node=lineView.node.firstChild,next=void 0;node;node=next){next=node.nextSibling;if(node.className=="CodeMirror-linewidget"){lineView.node.removeChild(node);}}insertLineWidgets(cm,lineView,dims);}// Build a line's DOM representation from scratch
	function buildLineElement(cm,lineView,lineN,dims){var built=getLineContent(cm,lineView);lineView.text=lineView.node=built.pre;if(built.bgClass){lineView.bgClass=built.bgClass;}if(built.textClass){lineView.textClass=built.textClass;}updateLineClasses(lineView);updateLineGutter(cm,lineView,lineN,dims);insertLineWidgets(cm,lineView,dims);return lineView.node;}// A lineView may contain multiple logical lines (when merged by
	// collapsed spans). The widgets for all of them need to be drawn.
	function insertLineWidgets(cm,lineView,dims){insertLineWidgetsFor(cm,lineView.line,lineView,dims,true);if(lineView.rest){for(var i=0;i<lineView.rest.length;i++){insertLineWidgetsFor(cm,lineView.rest[i],lineView,dims,false);}}}function insertLineWidgetsFor(cm,line,lineView,dims,allowAbove){if(!line.widgets){return;}var wrap=ensureLineWrapped(lineView);for(var i=0,ws=line.widgets;i<ws.length;++i){var widget=ws[i],node=elt("div",[widget.node],"CodeMirror-linewidget");if(!widget.handleMouseEvents){node.setAttribute("cm-ignore-events","true");}positionLineWidget(widget,node,lineView,dims);cm.display.input.setUneditable(node);if(allowAbove&&widget.above){wrap.insertBefore(node,lineView.gutter||lineView.text);}else{wrap.appendChild(node);}signalLater(widget,"redraw");}}function positionLineWidget(widget,node,lineView,dims){if(widget.noHScroll){;(lineView.alignable||(lineView.alignable=[])).push(node);var width=dims.wrapperWidth;node.style.left=dims.fixedPos+"px";if(!widget.coverGutter){width-=dims.gutterTotalWidth;node.style.paddingLeft=dims.gutterTotalWidth+"px";}node.style.width=width+"px";}if(widget.coverGutter){node.style.zIndex=5;node.style.position="relative";if(!widget.noHScroll){node.style.marginLeft=-dims.gutterTotalWidth+"px";}}}function widgetHeight(widget){if(widget.height!=null){return widget.height;}var cm=widget.doc.cm;if(!cm){return 0;}if(!contains(document.body,widget.node)){var parentStyle="position: relative;";if(widget.coverGutter){parentStyle+="margin-left: -"+cm.display.gutters.offsetWidth+"px;";}if(widget.noHScroll){parentStyle+="width: "+cm.display.wrapper.clientWidth+"px;";}removeChildrenAndAdd(cm.display.measure,elt("div",[widget.node],null,parentStyle));}return widget.height=widget.node.parentNode.offsetHeight;}// Return true when the given mouse event happened in a widget
	function eventInWidget(display,e){for(var n=e_target(e);n!=display.wrapper;n=n.parentNode){if(!n||n.nodeType==1&&n.getAttribute("cm-ignore-events")=="true"||n.parentNode==display.sizer&&n!=display.mover){return true;}}}// POSITION MEASUREMENT
	function paddingTop(display){return display.lineSpace.offsetTop;}function paddingVert(display){return display.mover.offsetHeight-display.lineSpace.offsetHeight;}function paddingH(display){if(display.cachedPaddingH){return display.cachedPaddingH;}var e=removeChildrenAndAdd(display.measure,elt("pre","x"));var style=window.getComputedStyle?window.getComputedStyle(e):e.currentStyle;var data={left:parseInt(style.paddingLeft),right:parseInt(style.paddingRight)};if(!isNaN(data.left)&&!isNaN(data.right)){display.cachedPaddingH=data;}return data;}function scrollGap(cm){return scrollerGap-cm.display.nativeBarWidth;}function displayWidth(cm){return cm.display.scroller.clientWidth-scrollGap(cm)-cm.display.barWidth;}function displayHeight(cm){return cm.display.scroller.clientHeight-scrollGap(cm)-cm.display.barHeight;}// Ensure the lineView.wrapping.heights array is populated. This is
	// an array of bottom offsets for the lines that make up a drawn
	// line. When lineWrapping is on, there might be more than one
	// height.
	function ensureLineHeights(cm,lineView,rect){var wrapping=cm.options.lineWrapping;var curWidth=wrapping&&displayWidth(cm);if(!lineView.measure.heights||wrapping&&lineView.measure.width!=curWidth){var heights=lineView.measure.heights=[];if(wrapping){lineView.measure.width=curWidth;var rects=lineView.text.firstChild.getClientRects();for(var i=0;i<rects.length-1;i++){var cur=rects[i],next=rects[i+1];if(Math.abs(cur.bottom-next.bottom)>2){heights.push((cur.bottom+next.top)/2-rect.top);}}}heights.push(rect.bottom-rect.top);}}// Find a line map (mapping character offsets to text nodes) and a
	// measurement cache for the given line number. (A line view might
	// contain multiple lines when collapsed ranges are present.)
	function mapFromLineView(lineView,line,lineN){if(lineView.line==line){return{map:lineView.measure.map,cache:lineView.measure.cache};}for(var i=0;i<lineView.rest.length;i++){if(lineView.rest[i]==line){return{map:lineView.measure.maps[i],cache:lineView.measure.caches[i]};}}for(var i$1=0;i$1<lineView.rest.length;i$1++){if(lineNo(lineView.rest[i$1])>lineN){return{map:lineView.measure.maps[i$1],cache:lineView.measure.caches[i$1],before:true};}}}// Render a line into the hidden node display.externalMeasured. Used
	// when measurement is needed for a line that's not in the viewport.
	function updateExternalMeasurement(cm,line){line=visualLine(line);var lineN=lineNo(line);var view=cm.display.externalMeasured=new LineView(cm.doc,line,lineN);view.lineN=lineN;var built=view.built=buildLineContent(cm,view);view.text=built.pre;removeChildrenAndAdd(cm.display.lineMeasure,built.pre);return view;}// Get a {top, bottom, left, right} box (in line-local coordinates)
	// for a given character.
	function measureChar(cm,line,ch,bias){return measureCharPrepared(cm,prepareMeasureForLine(cm,line),ch,bias);}// Find a line view that corresponds to the given line number.
	function findViewForLine(cm,lineN){if(lineN>=cm.display.viewFrom&&lineN<cm.display.viewTo){return cm.display.view[findViewIndex(cm,lineN)];}var ext=cm.display.externalMeasured;if(ext&&lineN>=ext.lineN&&lineN<ext.lineN+ext.size){return ext;}}// Measurement can be split in two steps, the set-up work that
	// applies to the whole line, and the measurement of the actual
	// character. Functions like coordsChar, that need to do a lot of
	// measurements in a row, can thus ensure that the set-up work is
	// only done once.
	function prepareMeasureForLine(cm,line){var lineN=lineNo(line);var view=findViewForLine(cm,lineN);if(view&&!view.text){view=null;}else if(view&&view.changes){updateLineForChanges(cm,view,lineN,getDimensions(cm));cm.curOp.forceUpdate=true;}if(!view){view=updateExternalMeasurement(cm,line);}var info=mapFromLineView(view,line,lineN);return{line:line,view:view,rect:null,map:info.map,cache:info.cache,before:info.before,hasHeights:false};}// Given a prepared measurement object, measures the position of an
	// actual character (or fetches it from the cache).
	function measureCharPrepared(cm,prepared,ch,bias,varHeight){if(prepared.before){ch=-1;}var key=ch+(bias||""),found;if(prepared.cache.hasOwnProperty(key)){found=prepared.cache[key];}else{if(!prepared.rect){prepared.rect=prepared.view.text.getBoundingClientRect();}if(!prepared.hasHeights){ensureLineHeights(cm,prepared.view,prepared.rect);prepared.hasHeights=true;}found=measureCharInner(cm,prepared,ch,bias);if(!found.bogus){prepared.cache[key]=found;}}return{left:found.left,right:found.right,top:varHeight?found.rtop:found.top,bottom:varHeight?found.rbottom:found.bottom};}var nullRect={left:0,right:0,top:0,bottom:0};function nodeAndOffsetInLineMap(map,ch,bias){var node,start,end,collapse,mStart,mEnd;// First, search the line map for the text node corresponding to,
	// or closest to, the target character.
	for(var i=0;i<map.length;i+=3){mStart=map[i];mEnd=map[i+1];if(ch<mStart){start=0;end=1;collapse="left";}else if(ch<mEnd){start=ch-mStart;end=start+1;}else if(i==map.length-3||ch==mEnd&&map[i+3]>ch){end=mEnd-mStart;start=end-1;if(ch>=mEnd){collapse="right";}}if(start!=null){node=map[i+2];if(mStart==mEnd&&bias==(node.insertLeft?"left":"right")){collapse=bias;}if(bias=="left"&&start==0){while(i&&map[i-2]==map[i-3]&&map[i-1].insertLeft){node=map[(i-=3)+2];collapse="left";}}if(bias=="right"&&start==mEnd-mStart){while(i<map.length-3&&map[i+3]==map[i+4]&&!map[i+5].insertLeft){node=map[(i+=3)+2];collapse="right";}}break;}}return{node:node,start:start,end:end,collapse:collapse,coverStart:mStart,coverEnd:mEnd};}function getUsefulRect(rects,bias){var rect=nullRect;if(bias=="left"){for(var i=0;i<rects.length;i++){if((rect=rects[i]).left!=rect.right){break;}}}else{for(var i$1=rects.length-1;i$1>=0;i$1--){if((rect=rects[i$1]).left!=rect.right){break;}}}return rect;}function measureCharInner(cm,prepared,ch,bias){var place=nodeAndOffsetInLineMap(prepared.map,ch,bias);var node=place.node,start=place.start,end=place.end,collapse=place.collapse;var rect;if(node.nodeType==3){// If it is a text node, use a range to retrieve the coordinates.
	for(var i$1=0;i$1<4;i$1++){// Retry a maximum of 4 times when nonsense rectangles are returned
	while(start&&isExtendingChar(prepared.line.text.charAt(place.coverStart+start))){--start;}while(place.coverStart+end<place.coverEnd&&isExtendingChar(prepared.line.text.charAt(place.coverStart+end))){++end;}if(ie&&ie_version<9&&start==0&&end==place.coverEnd-place.coverStart){rect=node.parentNode.getBoundingClientRect();}else{rect=getUsefulRect(range(node,start,end).getClientRects(),bias);}if(rect.left||rect.right||start==0){break;}end=start;start=start-1;collapse="right";}if(ie&&ie_version<11){rect=maybeUpdateRectForZooming(cm.display.measure,rect);}}else{// If it is a widget, simply get the box for the whole widget.
	if(start>0){collapse=bias="right";}var rects;if(cm.options.lineWrapping&&(rects=node.getClientRects()).length>1){rect=rects[bias=="right"?rects.length-1:0];}else{rect=node.getBoundingClientRect();}}if(ie&&ie_version<9&&!start&&(!rect||!rect.left&&!rect.right)){var rSpan=node.parentNode.getClientRects()[0];if(rSpan){rect={left:rSpan.left,right:rSpan.left+charWidth(cm.display),top:rSpan.top,bottom:rSpan.bottom};}else{rect=nullRect;}}var rtop=rect.top-prepared.rect.top,rbot=rect.bottom-prepared.rect.top;var mid=(rtop+rbot)/2;var heights=prepared.view.measure.heights;var i=0;for(;i<heights.length-1;i++){if(mid<heights[i]){break;}}var top=i?heights[i-1]:0,bot=heights[i];var result={left:(collapse=="right"?rect.right:rect.left)-prepared.rect.left,right:(collapse=="left"?rect.left:rect.right)-prepared.rect.left,top:top,bottom:bot};if(!rect.left&&!rect.right){result.bogus=true;}if(!cm.options.singleCursorHeightPerLine){result.rtop=rtop;result.rbottom=rbot;}return result;}// Work around problem with bounding client rects on ranges being
	// returned incorrectly when zoomed on IE10 and below.
	function maybeUpdateRectForZooming(measure,rect){if(!window.screen||screen.logicalXDPI==null||screen.logicalXDPI==screen.deviceXDPI||!hasBadZoomedRects(measure)){return rect;}var scaleX=screen.logicalXDPI/screen.deviceXDPI;var scaleY=screen.logicalYDPI/screen.deviceYDPI;return{left:rect.left*scaleX,right:rect.right*scaleX,top:rect.top*scaleY,bottom:rect.bottom*scaleY};}function clearLineMeasurementCacheFor(lineView){if(lineView.measure){lineView.measure.cache={};lineView.measure.heights=null;if(lineView.rest){for(var i=0;i<lineView.rest.length;i++){lineView.measure.caches[i]={};}}}}function clearLineMeasurementCache(cm){cm.display.externalMeasure=null;removeChildren(cm.display.lineMeasure);for(var i=0;i<cm.display.view.length;i++){clearLineMeasurementCacheFor(cm.display.view[i]);}}function clearCaches(cm){clearLineMeasurementCache(cm);cm.display.cachedCharWidth=cm.display.cachedTextHeight=cm.display.cachedPaddingH=null;if(!cm.options.lineWrapping){cm.display.maxLineChanged=true;}cm.display.lineNumChars=null;}function pageScrollX(){return window.pageXOffset||(document.documentElement||document.body).scrollLeft;}function pageScrollY(){return window.pageYOffset||(document.documentElement||document.body).scrollTop;}// Converts a {top, bottom, left, right} box from line-local
	// coordinates into another coordinate system. Context may be one of
	// "line", "div" (display.lineDiv), "local"./null (editor), "window",
	// or "page".
	function intoCoordSystem(cm,lineObj,rect,context,includeWidgets){if(!includeWidgets&&lineObj.widgets){for(var i=0;i<lineObj.widgets.length;++i){if(lineObj.widgets[i].above){var size=widgetHeight(lineObj.widgets[i]);rect.top+=size;rect.bottom+=size;}}}if(context=="line"){return rect;}if(!context){context="local";}var yOff=_heightAtLine(lineObj);if(context=="local"){yOff+=paddingTop(cm.display);}else{yOff-=cm.display.viewOffset;}if(context=="page"||context=="window"){var lOff=cm.display.lineSpace.getBoundingClientRect();yOff+=lOff.top+(context=="window"?0:pageScrollY());var xOff=lOff.left+(context=="window"?0:pageScrollX());rect.left+=xOff;rect.right+=xOff;}rect.top+=yOff;rect.bottom+=yOff;return rect;}// Coverts a box from "div" coords to another coordinate system.
	// Context may be "window", "page", "div", or "local"./null.
	function fromCoordSystem(cm,coords,context){if(context=="div"){return coords;}var left=coords.left,top=coords.top;// First move into "page" coordinate system
	if(context=="page"){left-=pageScrollX();top-=pageScrollY();}else if(context=="local"||!context){var localBox=cm.display.sizer.getBoundingClientRect();left+=localBox.left;top+=localBox.top;}var lineSpaceBox=cm.display.lineSpace.getBoundingClientRect();return{left:left-lineSpaceBox.left,top:top-lineSpaceBox.top};}function _charCoords(cm,pos,context,lineObj,bias){if(!lineObj){lineObj=getLine(cm.doc,pos.line);}return intoCoordSystem(cm,lineObj,measureChar(cm,lineObj,pos.ch,bias),context);}// Returns a box for a given cursor position, which may have an
	// 'other' property containing the position of the secondary cursor
	// on a bidi boundary.
	function _cursorCoords(cm,pos,context,lineObj,preparedMeasure,varHeight){lineObj=lineObj||getLine(cm.doc,pos.line);if(!preparedMeasure){preparedMeasure=prepareMeasureForLine(cm,lineObj);}function get(ch,right){var m=measureCharPrepared(cm,preparedMeasure,ch,right?"right":"left",varHeight);if(right){m.left=m.right;}else{m.right=m.left;}return intoCoordSystem(cm,lineObj,m,context);}function getBidi(ch,partPos){var part=order[partPos],right=part.level%2;if(ch==bidiLeft(part)&&partPos&&part.level<order[partPos-1].level){part=order[--partPos];ch=bidiRight(part)-(part.level%2?0:1);right=true;}else if(ch==bidiRight(part)&&partPos<order.length-1&&part.level<order[partPos+1].level){part=order[++partPos];ch=bidiLeft(part)-part.level%2;right=false;}if(right&&ch==part.to&&ch>part.from){return get(ch-1);}return get(ch,right);}var order=getOrder(lineObj),ch=pos.ch;if(!order){return get(ch);}var partPos=getBidiPartAt(order,ch);var val=getBidi(ch,partPos);if(bidiOther!=null){val.other=getBidi(ch,bidiOther);}return val;}// Used to cheaply estimate the coordinates for a position. Used for
	// intermediate scroll updates.
	function estimateCoords(cm,pos){var left=0;pos=_clipPos(cm.doc,pos);if(!cm.options.lineWrapping){left=charWidth(cm.display)*pos.ch;}var lineObj=getLine(cm.doc,pos.line);var top=_heightAtLine(lineObj)+paddingTop(cm.display);return{left:left,right:left,top:top,bottom:top+lineObj.height};}// Positions returned by coordsChar contain some extra information.
	// xRel is the relative x position of the input coordinates compared
	// to the found position (so xRel > 0 means the coordinates are to
	// the right of the character position, for example). When outside
	// is true, that means the coordinates lie outside the line's
	// vertical range.
	function PosWithInfo(line,ch,outside,xRel){var pos=Pos(line,ch);pos.xRel=xRel;if(outside){pos.outside=true;}return pos;}// Compute the character position closest to the given coordinates.
	// Input must be lineSpace-local ("div" coordinate system).
	function _coordsChar(cm,x,y){var doc=cm.doc;y+=cm.display.viewOffset;if(y<0){return PosWithInfo(doc.first,0,true,-1);}var lineN=_lineAtHeight(doc,y),last=doc.first+doc.size-1;if(lineN>last){return PosWithInfo(doc.first+doc.size-1,getLine(doc,last).text.length,true,1);}if(x<0){x=0;}var lineObj=getLine(doc,lineN);for(;;){var found=coordsCharInner(cm,lineObj,lineN,x,y);var merged=collapsedSpanAtEnd(lineObj);var mergedPos=merged&&merged.find(0,true);if(merged&&(found.ch>mergedPos.from.ch||found.ch==mergedPos.from.ch&&found.xRel>0)){lineN=lineNo(lineObj=mergedPos.to.line);}else{return found;}}}function coordsCharInner(cm,lineObj,lineNo,x,y){var innerOff=y-_heightAtLine(lineObj);var wrongLine=false,adjust=2*cm.display.wrapper.clientWidth;var preparedMeasure=prepareMeasureForLine(cm,lineObj);function getX(ch){var sp=_cursorCoords(cm,Pos(lineNo,ch),"line",lineObj,preparedMeasure);wrongLine=true;if(innerOff>sp.bottom){return sp.left-adjust;}else if(innerOff<sp.top){return sp.left+adjust;}else{wrongLine=false;}return sp.left;}var bidi=getOrder(lineObj),dist=lineObj.text.length;var from=lineLeft(lineObj),to=lineRight(lineObj);var fromX=getX(from),fromOutside=wrongLine,toX=getX(to),toOutside=wrongLine;if(x>toX){return PosWithInfo(lineNo,to,toOutside,1);}// Do a binary search between these bounds.
	for(;;){if(bidi?to==from||to==moveVisually(lineObj,from,1):to-from<=1){var ch=x<fromX||x-fromX<=toX-x?from:to;var outside=ch==from?fromOutside:toOutside;var xDiff=x-(ch==from?fromX:toX);// This is a kludge to handle the case where the coordinates
	// are after a line-wrapped line. We should replace it with a
	// more general handling of cursor positions around line
	// breaks. (Issue #4078)
	if(toOutside&&!bidi&&!/\s/.test(lineObj.text.charAt(ch))&&xDiff>0&&ch<lineObj.text.length&&preparedMeasure.view.measure.heights.length>1){var charSize=measureCharPrepared(cm,preparedMeasure,ch,"right");if(innerOff<=charSize.bottom&&innerOff>=charSize.top&&Math.abs(x-charSize.right)<xDiff){outside=false;ch++;xDiff=x-charSize.right;}}while(isExtendingChar(lineObj.text.charAt(ch))){++ch;}var pos=PosWithInfo(lineNo,ch,outside,xDiff<-1?-1:xDiff>1?1:0);return pos;}var step=Math.ceil(dist/2),middle=from+step;if(bidi){middle=from;for(var i=0;i<step;++i){middle=moveVisually(lineObj,middle,1);}}var middleX=getX(middle);if(middleX>x){to=middle;toX=middleX;if(toOutside=wrongLine){toX+=1000;}dist=step;}else{from=middle;fromX=middleX;fromOutside=wrongLine;dist-=step;}}}var measureText;// Compute the default text height.
	function textHeight(display){if(display.cachedTextHeight!=null){return display.cachedTextHeight;}if(measureText==null){measureText=elt("pre");// Measure a bunch of lines, for browsers that compute
	// fractional heights.
	for(var i=0;i<49;++i){measureText.appendChild(document.createTextNode("x"));measureText.appendChild(elt("br"));}measureText.appendChild(document.createTextNode("x"));}removeChildrenAndAdd(display.measure,measureText);var height=measureText.offsetHeight/50;if(height>3){display.cachedTextHeight=height;}removeChildren(display.measure);return height||1;}// Compute the default character width.
	function charWidth(display){if(display.cachedCharWidth!=null){return display.cachedCharWidth;}var anchor=elt("span","xxxxxxxxxx");var pre=elt("pre",[anchor]);removeChildrenAndAdd(display.measure,pre);var rect=anchor.getBoundingClientRect(),width=(rect.right-rect.left)/10;if(width>2){display.cachedCharWidth=width;}return width||10;}// Do a bulk-read of the DOM positions and sizes needed to draw the
	// view, so that we don't interleave reading and writing to the DOM.
	function getDimensions(cm){var d=cm.display,left={},width={};var gutterLeft=d.gutters.clientLeft;for(var n=d.gutters.firstChild,i=0;n;n=n.nextSibling,++i){left[cm.options.gutters[i]]=n.offsetLeft+n.clientLeft+gutterLeft;width[cm.options.gutters[i]]=n.clientWidth;}return{fixedPos:compensateForHScroll(d),gutterTotalWidth:d.gutters.offsetWidth,gutterLeft:left,gutterWidth:width,wrapperWidth:d.wrapper.clientWidth};}// Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
	// but using getBoundingClientRect to get a sub-pixel-accurate
	// result.
	function compensateForHScroll(display){return display.scroller.getBoundingClientRect().left-display.sizer.getBoundingClientRect().left;}// Returns a function that estimates the height of a line, to use as
	// first approximation until the line becomes visible (and is thus
	// properly measurable).
	function estimateHeight(cm){var th=textHeight(cm.display),wrapping=cm.options.lineWrapping;var perLine=wrapping&&Math.max(5,cm.display.scroller.clientWidth/charWidth(cm.display)-3);return function(line){if(lineIsHidden(cm.doc,line)){return 0;}var widgetsHeight=0;if(line.widgets){for(var i=0;i<line.widgets.length;i++){if(line.widgets[i].height){widgetsHeight+=line.widgets[i].height;}}}if(wrapping){return widgetsHeight+(Math.ceil(line.text.length/perLine)||1)*th;}else{return widgetsHeight+th;}};}function estimateLineHeights(cm){var doc=cm.doc,est=estimateHeight(cm);doc.iter(function(line){var estHeight=est(line);if(estHeight!=line.height){updateLineHeight(line,estHeight);}});}// Given a mouse event, find the corresponding position. If liberal
	// is false, it checks whether a gutter or scrollbar was clicked,
	// and returns null if it was. forRect is used by rectangular
	// selections, and tries to estimate a character position even for
	// coordinates beyond the right of the text.
	function posFromMouse(cm,e,liberal,forRect){var display=cm.display;if(!liberal&&e_target(e).getAttribute("cm-not-content")=="true"){return null;}var x,y,space=display.lineSpace.getBoundingClientRect();// Fails unpredictably on IE[67] when mouse is dragged around quickly.
	try{x=e.clientX-space.left;y=e.clientY-space.top;}catch(e){return null;}var coords=_coordsChar(cm,x,y),line;if(forRect&&coords.xRel==1&&(line=getLine(cm.doc,coords.line).text).length==coords.ch){var colDiff=countColumn(line,line.length,cm.options.tabSize)-line.length;coords=Pos(coords.line,Math.max(0,Math.round((x-paddingH(cm.display).left)/charWidth(cm.display))-colDiff));}return coords;}// Find the view element corresponding to a given line. Return null
	// when the line isn't visible.
	function findViewIndex(cm,n){if(n>=cm.display.viewTo){return null;}n-=cm.display.viewFrom;if(n<0){return null;}var view=cm.display.view;for(var i=0;i<view.length;i++){n-=view[i].size;if(n<0){return i;}}}function updateSelection(cm){cm.display.input.showSelection(cm.display.input.prepareSelection());}function prepareSelection(cm,primary){var doc=cm.doc,result={};var curFragment=result.cursors=document.createDocumentFragment();var selFragment=result.selection=document.createDocumentFragment();for(var i=0;i<doc.sel.ranges.length;i++){if(primary===false&&i==doc.sel.primIndex){continue;}var range=doc.sel.ranges[i];if(range.from().line>=cm.display.viewTo||range.to().line<cm.display.viewFrom){continue;}var collapsed=range.empty();if(collapsed||cm.options.showCursorWhenSelecting){drawSelectionCursor(cm,range.head,curFragment);}if(!collapsed){drawSelectionRange(cm,range,selFragment);}}return result;}// Draws a cursor for the given range
	function drawSelectionCursor(cm,head,output){var pos=_cursorCoords(cm,head,"div",null,null,!cm.options.singleCursorHeightPerLine);var cursor=output.appendChild(elt("div",'\xA0',"CodeMirror-cursor"));cursor.style.left=pos.left+"px";cursor.style.top=pos.top+"px";cursor.style.height=Math.max(0,pos.bottom-pos.top)*cm.options.cursorHeight+"px";if(pos.other){// Secondary cursor, shown when on a 'jump' in bi-directional text
	var otherCursor=output.appendChild(elt("div",'\xA0',"CodeMirror-cursor CodeMirror-secondarycursor"));otherCursor.style.display="";otherCursor.style.left=pos.other.left+"px";otherCursor.style.top=pos.other.top+"px";otherCursor.style.height=(pos.other.bottom-pos.other.top)*.85+"px";}}// Draws the given range as a highlighted selection
	function drawSelectionRange(cm,range,output){var display=cm.display,doc=cm.doc;var fragment=document.createDocumentFragment();var padding=paddingH(cm.display),leftSide=padding.left;var rightSide=Math.max(display.sizerWidth,displayWidth(cm)-display.sizer.offsetLeft)-padding.right;function add(left,top,width,bottom){if(top<0){top=0;}top=Math.round(top);bottom=Math.round(bottom);fragment.appendChild(elt("div",null,"CodeMirror-selected","position: absolute; left: "+left+"px;\n                             top: "+top+"px; width: "+(width==null?rightSide-left:width)+"px;\n                             height: "+(bottom-top)+"px"));}function drawForLine(line,fromArg,toArg){var lineObj=getLine(doc,line);var lineLen=lineObj.text.length;var start,end;function coords(ch,bias){return _charCoords(cm,Pos(line,ch),"div",lineObj,bias);}iterateBidiSections(getOrder(lineObj),fromArg||0,toArg==null?lineLen:toArg,function(from,to,dir){var leftPos=coords(from,"left"),rightPos,left,right;if(from==to){rightPos=leftPos;left=right=leftPos.left;}else{rightPos=coords(to-1,"right");if(dir=="rtl"){var tmp=leftPos;leftPos=rightPos;rightPos=tmp;}left=leftPos.left;right=rightPos.right;}if(fromArg==null&&from==0){left=leftSide;}if(rightPos.top-leftPos.top>3){// Different lines, draw top part
	add(left,leftPos.top,null,leftPos.bottom);left=leftSide;if(leftPos.bottom<rightPos.top){add(left,leftPos.bottom,null,rightPos.top);}}if(toArg==null&&to==lineLen){right=rightSide;}if(!start||leftPos.top<start.top||leftPos.top==start.top&&leftPos.left<start.left){start=leftPos;}if(!end||rightPos.bottom>end.bottom||rightPos.bottom==end.bottom&&rightPos.right>end.right){end=rightPos;}if(left<leftSide+1){left=leftSide;}add(left,rightPos.top,right-left,rightPos.bottom);});return{start:start,end:end};}var sFrom=range.from(),sTo=range.to();if(sFrom.line==sTo.line){drawForLine(sFrom.line,sFrom.ch,sTo.ch);}else{var fromLine=getLine(doc,sFrom.line),toLine=getLine(doc,sTo.line);var singleVLine=visualLine(fromLine)==visualLine(toLine);var leftEnd=drawForLine(sFrom.line,sFrom.ch,singleVLine?fromLine.text.length+1:null).end;var rightStart=drawForLine(sTo.line,singleVLine?0:null,sTo.ch).start;if(singleVLine){if(leftEnd.top<rightStart.top-2){add(leftEnd.right,leftEnd.top,null,leftEnd.bottom);add(leftSide,rightStart.top,rightStart.left,rightStart.bottom);}else{add(leftEnd.right,leftEnd.top,rightStart.left-leftEnd.right,leftEnd.bottom);}}if(leftEnd.bottom<rightStart.top){add(leftSide,leftEnd.bottom,null,rightStart.top);}}output.appendChild(fragment);}// Cursor-blinking
	function restartBlink(cm){if(!cm.state.focused){return;}var display=cm.display;clearInterval(display.blinker);var on=true;display.cursorDiv.style.visibility="";if(cm.options.cursorBlinkRate>0){display.blinker=setInterval(function(){return display.cursorDiv.style.visibility=(on=!on)?"":"hidden";},cm.options.cursorBlinkRate);}else if(cm.options.cursorBlinkRate<0){display.cursorDiv.style.visibility="hidden";}}function ensureFocus(cm){if(!cm.state.focused){cm.display.input.focus();onFocus(cm);}}function delayBlurEvent(cm){cm.state.delayingBlurEvent=true;setTimeout(function(){if(cm.state.delayingBlurEvent){cm.state.delayingBlurEvent=false;onBlur(cm);}},100);}function onFocus(cm,e){if(cm.state.delayingBlurEvent){cm.state.delayingBlurEvent=false;}if(cm.options.readOnly=="nocursor"){return;}if(!cm.state.focused){signal(cm,"focus",cm,e);cm.state.focused=true;addClass(cm.display.wrapper,"CodeMirror-focused");// This test prevents this from firing when a context
	// menu is closed (since the input reset would kill the
	// select-all detection hack)
	if(!cm.curOp&&cm.display.selForContextMenu!=cm.doc.sel){cm.display.input.reset();if(webkit){setTimeout(function(){return cm.display.input.reset(true);},20);}// Issue #1730
	}cm.display.input.receivedFocus();}restartBlink(cm);}function onBlur(cm,e){if(cm.state.delayingBlurEvent){return;}if(cm.state.focused){signal(cm,"blur",cm,e);cm.state.focused=false;rmClass(cm.display.wrapper,"CodeMirror-focused");}clearInterval(cm.display.blinker);setTimeout(function(){if(!cm.state.focused){cm.display.shift=false;}},150);}// Re-align line numbers and gutter marks to compensate for
	// horizontal scrolling.
	function alignHorizontally(cm){var display=cm.display,view=display.view;if(!display.alignWidgets&&(!display.gutters.firstChild||!cm.options.fixedGutter)){return;}var comp=compensateForHScroll(display)-display.scroller.scrollLeft+cm.doc.scrollLeft;var gutterW=display.gutters.offsetWidth,left=comp+"px";for(var i=0;i<view.length;i++){if(!view[i].hidden){if(cm.options.fixedGutter){if(view[i].gutter){view[i].gutter.style.left=left;}if(view[i].gutterBackground){view[i].gutterBackground.style.left=left;}}var align=view[i].alignable;if(align){for(var j=0;j<align.length;j++){align[j].style.left=left;}}}}if(cm.options.fixedGutter){display.gutters.style.left=comp+gutterW+"px";}}// Used to ensure that the line number gutter is still the right
	// size for the current document size. Returns true when an update
	// is needed.
	function maybeUpdateLineNumberWidth(cm){if(!cm.options.lineNumbers){return false;}var doc=cm.doc,last=lineNumberFor(cm.options,doc.first+doc.size-1),display=cm.display;if(last.length!=display.lineNumChars){var test=display.measure.appendChild(elt("div",[elt("div",last)],"CodeMirror-linenumber CodeMirror-gutter-elt"));var innerW=test.firstChild.offsetWidth,padding=test.offsetWidth-innerW;display.lineGutter.style.width="";display.lineNumInnerWidth=Math.max(innerW,display.lineGutter.offsetWidth-padding)+1;display.lineNumWidth=display.lineNumInnerWidth+padding;display.lineNumChars=display.lineNumInnerWidth?last.length:-1;display.lineGutter.style.width=display.lineNumWidth+"px";updateGutterSpace(cm);return true;}return false;}// Read the actual heights of the rendered lines, and update their
	// stored heights to match.
	function updateHeightsInViewport(cm){var display=cm.display;var prevBottom=display.lineDiv.offsetTop;for(var i=0;i<display.view.length;i++){var cur=display.view[i],height=void 0;if(cur.hidden){continue;}if(ie&&ie_version<8){var bot=cur.node.offsetTop+cur.node.offsetHeight;height=bot-prevBottom;prevBottom=bot;}else{var box=cur.node.getBoundingClientRect();height=box.bottom-box.top;}var diff=cur.line.height-height;if(height<2){height=textHeight(display);}if(diff>.001||diff<-.001){updateLineHeight(cur.line,height);updateWidgetHeight(cur.line);if(cur.rest){for(var j=0;j<cur.rest.length;j++){updateWidgetHeight(cur.rest[j]);}}}}}// Read and store the height of line widgets associated with the
	// given line.
	function updateWidgetHeight(line){if(line.widgets){for(var i=0;i<line.widgets.length;++i){line.widgets[i].height=line.widgets[i].node.parentNode.offsetHeight;}}}// Compute the lines that are visible in a given viewport (defaults
	// the the current scroll position). viewport may contain top,
	// height, and ensure (see op.scrollToPos) properties.
	function visibleLines(display,doc,viewport){var top=viewport&&viewport.top!=null?Math.max(0,viewport.top):display.scroller.scrollTop;top=Math.floor(top-paddingTop(display));var bottom=viewport&&viewport.bottom!=null?viewport.bottom:top+display.wrapper.clientHeight;var from=_lineAtHeight(doc,top),to=_lineAtHeight(doc,bottom);// Ensure is a {from: {line, ch}, to: {line, ch}} object, and
	// forces those lines into the viewport (if possible).
	if(viewport&&viewport.ensure){var ensureFrom=viewport.ensure.from.line,ensureTo=viewport.ensure.to.line;if(ensureFrom<from){from=ensureFrom;to=_lineAtHeight(doc,_heightAtLine(getLine(doc,ensureFrom))+display.wrapper.clientHeight);}else if(Math.min(ensureTo,doc.lastLine())>=to){from=_lineAtHeight(doc,_heightAtLine(getLine(doc,ensureTo))-display.wrapper.clientHeight);to=ensureTo;}}return{from:from,to:Math.max(to,from+1)};}// Sync the scrollable area and scrollbars, ensure the viewport
	// covers the visible area.
	function setScrollTop(cm,val){if(Math.abs(cm.doc.scrollTop-val)<2){return;}cm.doc.scrollTop=val;if(!gecko){updateDisplaySimple(cm,{top:val});}if(cm.display.scroller.scrollTop!=val){cm.display.scroller.scrollTop=val;}cm.display.scrollbars.setScrollTop(val);if(gecko){updateDisplaySimple(cm);}startWorker(cm,100);}// Sync scroller and scrollbar, ensure the gutter elements are
	// aligned.
	function setScrollLeft(cm,val,isScroller){if(isScroller?val==cm.doc.scrollLeft:Math.abs(cm.doc.scrollLeft-val)<2){return;}val=Math.min(val,cm.display.scroller.scrollWidth-cm.display.scroller.clientWidth);cm.doc.scrollLeft=val;alignHorizontally(cm);if(cm.display.scroller.scrollLeft!=val){cm.display.scroller.scrollLeft=val;}cm.display.scrollbars.setScrollLeft(val);}// Since the delta values reported on mouse wheel events are
	// unstandardized between browsers and even browser versions, and
	// generally horribly unpredictable, this code starts by measuring
	// the scroll effect that the first few mouse wheel events have,
	// and, from that, detects the way it can convert deltas to pixel
	// offsets afterwards.
	//
	// The reason we want to know the amount a wheel event will scroll
	// is that it gives us a chance to update the display before the
	// actual scrolling happens, reducing flickering.
	var wheelSamples=0;var wheelPixelsPerUnit=null;// Fill in a browser-detected starting value on browsers where we
	// know one. These don't have to be accurate -- the result of them
	// being wrong would just be a slight flicker on the first wheel
	// scroll (if it is large enough).
	if(ie){wheelPixelsPerUnit=-.53;}else if(gecko){wheelPixelsPerUnit=15;}else if(chrome){wheelPixelsPerUnit=-.7;}else if(safari){wheelPixelsPerUnit=-1/3;}function wheelEventDelta(e){var dx=e.wheelDeltaX,dy=e.wheelDeltaY;if(dx==null&&e.detail&&e.axis==e.HORIZONTAL_AXIS){dx=e.detail;}if(dy==null&&e.detail&&e.axis==e.VERTICAL_AXIS){dy=e.detail;}else if(dy==null){dy=e.wheelDelta;}return{x:dx,y:dy};}function wheelEventPixels(e){var delta=wheelEventDelta(e);delta.x*=wheelPixelsPerUnit;delta.y*=wheelPixelsPerUnit;return delta;}function onScrollWheel(cm,e){var delta=wheelEventDelta(e),dx=delta.x,dy=delta.y;var display=cm.display,scroll=display.scroller;// Quit if there's nothing to scroll here
	var canScrollX=scroll.scrollWidth>scroll.clientWidth;var canScrollY=scroll.scrollHeight>scroll.clientHeight;if(!(dx&&canScrollX||dy&&canScrollY)){return;}// Webkit browsers on OS X abort momentum scrolls when the target
	// of the scroll event is removed from the scrollable element.
	// This hack (see related code in patchDisplay) makes sure the
	// element is kept around.
	if(dy&&mac&&webkit){outer:for(var cur=e.target,view=display.view;cur!=scroll;cur=cur.parentNode){for(var i=0;i<view.length;i++){if(view[i].node==cur){cm.display.currentWheelTarget=cur;break outer;}}}}// On some browsers, horizontal scrolling will cause redraws to
	// happen before the gutter has been realigned, causing it to
	// wriggle around in a most unseemly way. When we have an
	// estimated pixels/delta value, we just handle horizontal
	// scrolling entirely here. It'll be slightly off from native, but
	// better than glitching out.
	if(dx&&!gecko&&!presto&&wheelPixelsPerUnit!=null){if(dy&&canScrollY){setScrollTop(cm,Math.max(0,Math.min(scroll.scrollTop+dy*wheelPixelsPerUnit,scroll.scrollHeight-scroll.clientHeight)));}setScrollLeft(cm,Math.max(0,Math.min(scroll.scrollLeft+dx*wheelPixelsPerUnit,scroll.scrollWidth-scroll.clientWidth)));// Only prevent default scrolling if vertical scrolling is
	// actually possible. Otherwise, it causes vertical scroll
	// jitter on OSX trackpads when deltaX is small and deltaY
	// is large (issue #3579)
	if(!dy||dy&&canScrollY){e_preventDefault(e);}display.wheelStartX=null;// Abort measurement, if in progress
	return;}// 'Project' the visible viewport to cover the area that is being
	// scrolled into view (if we know enough to estimate it).
	if(dy&&wheelPixelsPerUnit!=null){var pixels=dy*wheelPixelsPerUnit;var top=cm.doc.scrollTop,bot=top+display.wrapper.clientHeight;if(pixels<0){top=Math.max(0,top+pixels-50);}else{bot=Math.min(cm.doc.height,bot+pixels+50);}updateDisplaySimple(cm,{top:top,bottom:bot});}if(wheelSamples<20){if(display.wheelStartX==null){display.wheelStartX=scroll.scrollLeft;display.wheelStartY=scroll.scrollTop;display.wheelDX=dx;display.wheelDY=dy;setTimeout(function(){if(display.wheelStartX==null){return;}var movedX=scroll.scrollLeft-display.wheelStartX;var movedY=scroll.scrollTop-display.wheelStartY;var sample=movedY&&display.wheelDY&&movedY/display.wheelDY||movedX&&display.wheelDX&&movedX/display.wheelDX;display.wheelStartX=display.wheelStartY=null;if(!sample){return;}wheelPixelsPerUnit=(wheelPixelsPerUnit*wheelSamples+sample)/(wheelSamples+1);++wheelSamples;},200);}else{display.wheelDX+=dx;display.wheelDY+=dy;}}}// SCROLLBARS
	// Prepare DOM reads needed to update the scrollbars. Done in one
	// shot to minimize update/measure roundtrips.
	function measureForScrollbars(cm){var d=cm.display,gutterW=d.gutters.offsetWidth;var docH=Math.round(cm.doc.height+paddingVert(cm.display));return{clientHeight:d.scroller.clientHeight,viewHeight:d.wrapper.clientHeight,scrollWidth:d.scroller.scrollWidth,clientWidth:d.scroller.clientWidth,viewWidth:d.wrapper.clientWidth,barLeft:cm.options.fixedGutter?gutterW:0,docHeight:docH,scrollHeight:docH+scrollGap(cm)+d.barHeight,nativeBarWidth:d.nativeBarWidth,gutterWidth:gutterW};}var NativeScrollbars=function NativeScrollbars(place,scroll,cm){this.cm=cm;var vert=this.vert=elt("div",[elt("div",null,null,"min-width: 1px")],"CodeMirror-vscrollbar");var horiz=this.horiz=elt("div",[elt("div",null,null,"height: 100%; min-height: 1px")],"CodeMirror-hscrollbar");place(vert);place(horiz);on(vert,"scroll",function(){if(vert.clientHeight){scroll(vert.scrollTop,"vertical");}});on(horiz,"scroll",function(){if(horiz.clientWidth){scroll(horiz.scrollLeft,"horizontal");}});this.checkedZeroWidth=false;// Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
	if(ie&&ie_version<8){this.horiz.style.minHeight=this.vert.style.minWidth="18px";}};NativeScrollbars.prototype.update=function(measure){var needsH=measure.scrollWidth>measure.clientWidth+1;var needsV=measure.scrollHeight>measure.clientHeight+1;var sWidth=measure.nativeBarWidth;if(needsV){this.vert.style.display="block";this.vert.style.bottom=needsH?sWidth+"px":"0";var totalHeight=measure.viewHeight-(needsH?sWidth:0);// A bug in IE8 can cause this value to be negative, so guard it.
	this.vert.firstChild.style.height=Math.max(0,measure.scrollHeight-measure.clientHeight+totalHeight)+"px";}else{this.vert.style.display="";this.vert.firstChild.style.height="0";}if(needsH){this.horiz.style.display="block";this.horiz.style.right=needsV?sWidth+"px":"0";this.horiz.style.left=measure.barLeft+"px";var totalWidth=measure.viewWidth-measure.barLeft-(needsV?sWidth:0);this.horiz.firstChild.style.width=measure.scrollWidth-measure.clientWidth+totalWidth+"px";}else{this.horiz.style.display="";this.horiz.firstChild.style.width="0";}if(!this.checkedZeroWidth&&measure.clientHeight>0){if(sWidth==0){this.zeroWidthHack();}this.checkedZeroWidth=true;}return{right:needsV?sWidth:0,bottom:needsH?sWidth:0};};NativeScrollbars.prototype.setScrollLeft=function(pos){if(this.horiz.scrollLeft!=pos){this.horiz.scrollLeft=pos;}if(this.disableHoriz){this.enableZeroWidthBar(this.horiz,this.disableHoriz);}};NativeScrollbars.prototype.setScrollTop=function(pos){if(this.vert.scrollTop!=pos){this.vert.scrollTop=pos;}if(this.disableVert){this.enableZeroWidthBar(this.vert,this.disableVert);}};NativeScrollbars.prototype.zeroWidthHack=function(){var w=mac&&!mac_geMountainLion?"12px":"18px";this.horiz.style.height=this.vert.style.width=w;this.horiz.style.pointerEvents=this.vert.style.pointerEvents="none";this.disableHoriz=new Delayed();this.disableVert=new Delayed();};NativeScrollbars.prototype.enableZeroWidthBar=function(bar,delay){bar.style.pointerEvents="auto";function maybeDisable(){// To find out whether the scrollbar is still visible, we
	// check whether the element under the pixel in the bottom
	// left corner of the scrollbar box is the scrollbar box
	// itself (when the bar is still visible) or its filler child
	// (when the bar is hidden). If it is still visible, we keep
	// it enabled, if it's hidden, we disable pointer events.
	var box=bar.getBoundingClientRect();var elt=document.elementFromPoint(box.left+1,box.bottom-1);if(elt!=bar){bar.style.pointerEvents="none";}else{delay.set(1000,maybeDisable);}}delay.set(1000,maybeDisable);};NativeScrollbars.prototype.clear=function(){var parent=this.horiz.parentNode;parent.removeChild(this.horiz);parent.removeChild(this.vert);};var NullScrollbars=function NullScrollbars(){};NullScrollbars.prototype.update=function(){return{bottom:0,right:0};};NullScrollbars.prototype.setScrollLeft=function(){};NullScrollbars.prototype.setScrollTop=function(){};NullScrollbars.prototype.clear=function(){};function updateScrollbars(cm,measure){if(!measure){measure=measureForScrollbars(cm);}var startWidth=cm.display.barWidth,startHeight=cm.display.barHeight;updateScrollbarsInner(cm,measure);for(var i=0;i<4&&startWidth!=cm.display.barWidth||startHeight!=cm.display.barHeight;i++){if(startWidth!=cm.display.barWidth&&cm.options.lineWrapping){updateHeightsInViewport(cm);}updateScrollbarsInner(cm,measureForScrollbars(cm));startWidth=cm.display.barWidth;startHeight=cm.display.barHeight;}}// Re-synchronize the fake scrollbars with the actual size of the
	// content.
	function updateScrollbarsInner(cm,measure){var d=cm.display;var sizes=d.scrollbars.update(measure);d.sizer.style.paddingRight=(d.barWidth=sizes.right)+"px";d.sizer.style.paddingBottom=(d.barHeight=sizes.bottom)+"px";d.heightForcer.style.borderBottom=sizes.bottom+"px solid transparent";if(sizes.right&&sizes.bottom){d.scrollbarFiller.style.display="block";d.scrollbarFiller.style.height=sizes.bottom+"px";d.scrollbarFiller.style.width=sizes.right+"px";}else{d.scrollbarFiller.style.display="";}if(sizes.bottom&&cm.options.coverGutterNextToScrollbar&&cm.options.fixedGutter){d.gutterFiller.style.display="block";d.gutterFiller.style.height=sizes.bottom+"px";d.gutterFiller.style.width=measure.gutterWidth+"px";}else{d.gutterFiller.style.display="";}}var scrollbarModel={"native":NativeScrollbars,"null":NullScrollbars};function initScrollbars(cm){if(cm.display.scrollbars){cm.display.scrollbars.clear();if(cm.display.scrollbars.addClass){rmClass(cm.display.wrapper,cm.display.scrollbars.addClass);}}cm.display.scrollbars=new scrollbarModel[cm.options.scrollbarStyle](function(node){cm.display.wrapper.insertBefore(node,cm.display.scrollbarFiller);// Prevent clicks in the scrollbars from killing focus
	on(node,"mousedown",function(){if(cm.state.focused){setTimeout(function(){return cm.display.input.focus();},0);}});node.setAttribute("cm-not-content","true");},function(pos,axis){if(axis=="horizontal"){setScrollLeft(cm,pos);}else{setScrollTop(cm,pos);}},cm);if(cm.display.scrollbars.addClass){addClass(cm.display.wrapper,cm.display.scrollbars.addClass);}}// SCROLLING THINGS INTO VIEW
	// If an editor sits on the top or bottom of the window, partially
	// scrolled out of view, this ensures that the cursor is visible.
	function maybeScrollWindow(cm,coords){if(signalDOMEvent(cm,"scrollCursorIntoView")){return;}var display=cm.display,box=display.sizer.getBoundingClientRect(),doScroll=null;if(coords.top+box.top<0){doScroll=true;}else if(coords.bottom+box.top>(window.innerHeight||document.documentElement.clientHeight)){doScroll=false;}if(doScroll!=null&&!phantom){var scrollNode=elt("div",'\u200B',null,"position: absolute;\n                         top: "+(coords.top-display.viewOffset-paddingTop(cm.display))+"px;\n                         height: "+(coords.bottom-coords.top+scrollGap(cm)+display.barHeight)+"px;\n                         left: "+coords.left+"px; width: 2px;");cm.display.lineSpace.appendChild(scrollNode);scrollNode.scrollIntoView(doScroll);cm.display.lineSpace.removeChild(scrollNode);}}// Scroll a given position into view (immediately), verifying that
	// it actually became visible (as line heights are accurately
	// measured, the position of something may 'drift' during drawing).
	function scrollPosIntoView(cm,pos,end,margin){if(margin==null){margin=0;}var coords;for(var limit=0;limit<5;limit++){var changed=false;coords=_cursorCoords(cm,pos);var endCoords=!end||end==pos?coords:_cursorCoords(cm,end);var scrollPos=calculateScrollPos(cm,Math.min(coords.left,endCoords.left),Math.min(coords.top,endCoords.top)-margin,Math.max(coords.left,endCoords.left),Math.max(coords.bottom,endCoords.bottom)+margin);var startTop=cm.doc.scrollTop,startLeft=cm.doc.scrollLeft;if(scrollPos.scrollTop!=null){setScrollTop(cm,scrollPos.scrollTop);if(Math.abs(cm.doc.scrollTop-startTop)>1){changed=true;}}if(scrollPos.scrollLeft!=null){setScrollLeft(cm,scrollPos.scrollLeft);if(Math.abs(cm.doc.scrollLeft-startLeft)>1){changed=true;}}if(!changed){break;}}return coords;}// Scroll a given set of coordinates into view (immediately).
	function scrollIntoView(cm,x1,y1,x2,y2){var scrollPos=calculateScrollPos(cm,x1,y1,x2,y2);if(scrollPos.scrollTop!=null){setScrollTop(cm,scrollPos.scrollTop);}if(scrollPos.scrollLeft!=null){setScrollLeft(cm,scrollPos.scrollLeft);}}// Calculate a new scroll position needed to scroll the given
	// rectangle into view. Returns an object with scrollTop and
	// scrollLeft properties. When these are undefined, the
	// vertical/horizontal position does not need to be adjusted.
	function calculateScrollPos(cm,x1,y1,x2,y2){var display=cm.display,snapMargin=textHeight(cm.display);if(y1<0){y1=0;}var screentop=cm.curOp&&cm.curOp.scrollTop!=null?cm.curOp.scrollTop:display.scroller.scrollTop;var screen=displayHeight(cm),result={};if(y2-y1>screen){y2=y1+screen;}var docBottom=cm.doc.height+paddingVert(display);var atTop=y1<snapMargin,atBottom=y2>docBottom-snapMargin;if(y1<screentop){result.scrollTop=atTop?0:y1;}else if(y2>screentop+screen){var newTop=Math.min(y1,(atBottom?docBottom:y2)-screen);if(newTop!=screentop){result.scrollTop=newTop;}}var screenleft=cm.curOp&&cm.curOp.scrollLeft!=null?cm.curOp.scrollLeft:display.scroller.scrollLeft;var screenw=displayWidth(cm)-(cm.options.fixedGutter?display.gutters.offsetWidth:0);var tooWide=x2-x1>screenw;if(tooWide){x2=x1+screenw;}if(x1<10){result.scrollLeft=0;}else if(x1<screenleft){result.scrollLeft=Math.max(0,x1-(tooWide?0:10));}else if(x2>screenw+screenleft-3){result.scrollLeft=x2+(tooWide?0:10)-screenw;}return result;}// Store a relative adjustment to the scroll position in the current
	// operation (to be applied when the operation finishes).
	function addToScrollPos(cm,left,top){if(left!=null||top!=null){resolveScrollToPos(cm);}if(left!=null){cm.curOp.scrollLeft=(cm.curOp.scrollLeft==null?cm.doc.scrollLeft:cm.curOp.scrollLeft)+left;}if(top!=null){cm.curOp.scrollTop=(cm.curOp.scrollTop==null?cm.doc.scrollTop:cm.curOp.scrollTop)+top;}}// Make sure that at the end of the operation the current cursor is
	// shown.
	function ensureCursorVisible(cm){resolveScrollToPos(cm);var cur=cm.getCursor(),from=cur,to=cur;if(!cm.options.lineWrapping){from=cur.ch?Pos(cur.line,cur.ch-1):cur;to=Pos(cur.line,cur.ch+1);}cm.curOp.scrollToPos={from:from,to:to,margin:cm.options.cursorScrollMargin,isCursor:true};}// When an operation has its scrollToPos property set, and another
	// scroll action is applied before the end of the operation, this
	// 'simulates' scrolling that position into view in a cheap way, so
	// that the effect of intermediate scroll commands is not ignored.
	function resolveScrollToPos(cm){var range=cm.curOp.scrollToPos;if(range){cm.curOp.scrollToPos=null;var from=estimateCoords(cm,range.from),to=estimateCoords(cm,range.to);var sPos=calculateScrollPos(cm,Math.min(from.left,to.left),Math.min(from.top,to.top)-range.margin,Math.max(from.right,to.right),Math.max(from.bottom,to.bottom)+range.margin);cm.scrollTo(sPos.scrollLeft,sPos.scrollTop);}}// Operations are used to wrap a series of changes to the editor
	// state in such a way that each change won't have to update the
	// cursor and display (which would be awkward, slow, and
	// error-prone). Instead, display updates are batched and then all
	// combined and executed at once.
	var nextOpId=0;// Start a new operation.
	function startOperation(cm){cm.curOp={cm:cm,viewChanged:false,// Flag that indicates that lines might need to be redrawn
	startHeight:cm.doc.height,// Used to detect need to update scrollbar
	forceUpdate:false,// Used to force a redraw
	updateInput:null,// Whether to reset the input textarea
	typing:false,// Whether this reset should be careful to leave existing text (for compositing)
	changeObjs:null,// Accumulated changes, for firing change events
	cursorActivityHandlers:null,// Set of handlers to fire cursorActivity on
	cursorActivityCalled:0,// Tracks which cursorActivity handlers have been called already
	selectionChanged:false,// Whether the selection needs to be redrawn
	updateMaxLine:false,// Set when the widest line needs to be determined anew
	scrollLeft:null,scrollTop:null,// Intermediate scroll position, not pushed to DOM yet
	scrollToPos:null,// Used to scroll to a specific position
	focus:false,id:++nextOpId// Unique ID
	};pushOperation(cm.curOp);}// Finish an operation, updating the display and signalling delayed events
	function endOperation(cm){var op=cm.curOp;finishOperation(op,function(group){for(var i=0;i<group.ops.length;i++){group.ops[i].cm.curOp=null;}endOperations(group);});}// The DOM updates done when an operation finishes are batched so
	// that the minimum number of relayouts are required.
	function endOperations(group){var ops=group.ops;for(var i=0;i<ops.length;i++)// Read DOM
	{endOperation_R1(ops[i]);}for(var i$1=0;i$1<ops.length;i$1++)// Write DOM (maybe)
	{endOperation_W1(ops[i$1]);}for(var i$2=0;i$2<ops.length;i$2++)// Read DOM
	{endOperation_R2(ops[i$2]);}for(var i$3=0;i$3<ops.length;i$3++)// Write DOM (maybe)
	{endOperation_W2(ops[i$3]);}for(var i$4=0;i$4<ops.length;i$4++)// Read DOM
	{endOperation_finish(ops[i$4]);}}function endOperation_R1(op){var cm=op.cm,display=cm.display;maybeClipScrollbars(cm);if(op.updateMaxLine){findMaxLine(cm);}op.mustUpdate=op.viewChanged||op.forceUpdate||op.scrollTop!=null||op.scrollToPos&&(op.scrollToPos.from.line<display.viewFrom||op.scrollToPos.to.line>=display.viewTo)||display.maxLineChanged&&cm.options.lineWrapping;op.update=op.mustUpdate&&new DisplayUpdate(cm,op.mustUpdate&&{top:op.scrollTop,ensure:op.scrollToPos},op.forceUpdate);}function endOperation_W1(op){op.updatedDisplay=op.mustUpdate&&updateDisplayIfNeeded(op.cm,op.update);}function endOperation_R2(op){var cm=op.cm,display=cm.display;if(op.updatedDisplay){updateHeightsInViewport(cm);}op.barMeasure=measureForScrollbars(cm);// If the max line changed since it was last measured, measure it,
	// and ensure the document's width matches it.
	// updateDisplay_W2 will use these properties to do the actual resizing
	if(display.maxLineChanged&&!cm.options.lineWrapping){op.adjustWidthTo=measureChar(cm,display.maxLine,display.maxLine.text.length).left+3;cm.display.sizerWidth=op.adjustWidthTo;op.barMeasure.scrollWidth=Math.max(display.scroller.clientWidth,display.sizer.offsetLeft+op.adjustWidthTo+scrollGap(cm)+cm.display.barWidth);op.maxScrollLeft=Math.max(0,display.sizer.offsetLeft+op.adjustWidthTo-displayWidth(cm));}if(op.updatedDisplay||op.selectionChanged){op.preparedSelection=display.input.prepareSelection(op.focus);}}function endOperation_W2(op){var cm=op.cm;if(op.adjustWidthTo!=null){cm.display.sizer.style.minWidth=op.adjustWidthTo+"px";if(op.maxScrollLeft<cm.doc.scrollLeft){setScrollLeft(cm,Math.min(cm.display.scroller.scrollLeft,op.maxScrollLeft),true);}cm.display.maxLineChanged=false;}var takeFocus=op.focus&&op.focus==activeElt()&&(!document.hasFocus||document.hasFocus());if(op.preparedSelection){cm.display.input.showSelection(op.preparedSelection,takeFocus);}if(op.updatedDisplay||op.startHeight!=cm.doc.height){updateScrollbars(cm,op.barMeasure);}if(op.updatedDisplay){setDocumentHeight(cm,op.barMeasure);}if(op.selectionChanged){restartBlink(cm);}if(cm.state.focused&&op.updateInput){cm.display.input.reset(op.typing);}if(takeFocus){ensureFocus(op.cm);}}function endOperation_finish(op){var cm=op.cm,display=cm.display,doc=cm.doc;if(op.updatedDisplay){postUpdateDisplay(cm,op.update);}// Abort mouse wheel delta measurement, when scrolling explicitly
	if(display.wheelStartX!=null&&(op.scrollTop!=null||op.scrollLeft!=null||op.scrollToPos)){display.wheelStartX=display.wheelStartY=null;}// Propagate the scroll position to the actual DOM scroller
	if(op.scrollTop!=null&&(display.scroller.scrollTop!=op.scrollTop||op.forceScroll)){doc.scrollTop=Math.max(0,Math.min(display.scroller.scrollHeight-display.scroller.clientHeight,op.scrollTop));display.scrollbars.setScrollTop(doc.scrollTop);display.scroller.scrollTop=doc.scrollTop;}if(op.scrollLeft!=null&&(display.scroller.scrollLeft!=op.scrollLeft||op.forceScroll)){doc.scrollLeft=Math.max(0,Math.min(display.scroller.scrollWidth-display.scroller.clientWidth,op.scrollLeft));display.scrollbars.setScrollLeft(doc.scrollLeft);display.scroller.scrollLeft=doc.scrollLeft;alignHorizontally(cm);}// If we need to scroll a specific position into view, do so.
	if(op.scrollToPos){var coords=scrollPosIntoView(cm,_clipPos(doc,op.scrollToPos.from),_clipPos(doc,op.scrollToPos.to),op.scrollToPos.margin);if(op.scrollToPos.isCursor&&cm.state.focused){maybeScrollWindow(cm,coords);}}// Fire events for markers that are hidden/unidden by editing or
	// undoing
	var hidden=op.maybeHiddenMarkers,unhidden=op.maybeUnhiddenMarkers;if(hidden){for(var i=0;i<hidden.length;++i){if(!hidden[i].lines.length){signal(hidden[i],"hide");}}}if(unhidden){for(var i$1=0;i$1<unhidden.length;++i$1){if(unhidden[i$1].lines.length){signal(unhidden[i$1],"unhide");}}}if(display.wrapper.offsetHeight){doc.scrollTop=cm.display.scroller.scrollTop;}// Fire change events, and delayed event handlers
	if(op.changeObjs){signal(cm,"changes",cm,op.changeObjs);}if(op.update){op.update.finish();}}// Run the given function in an operation
	function runInOp(cm,f){if(cm.curOp){return f();}startOperation(cm);try{return f();}finally{endOperation(cm);}}// Wraps a function in an operation. Returns the wrapped function.
	function operation(cm,f){return function(){if(cm.curOp){return f.apply(cm,arguments);}startOperation(cm);try{return f.apply(cm,arguments);}finally{endOperation(cm);}};}// Used to add methods to editor and doc instances, wrapping them in
	// operations.
	function methodOp(f){return function(){if(this.curOp){return f.apply(this,arguments);}startOperation(this);try{return f.apply(this,arguments);}finally{endOperation(this);}};}function docMethodOp(f){return function(){var cm=this.cm;if(!cm||cm.curOp){return f.apply(this,arguments);}startOperation(cm);try{return f.apply(this,arguments);}finally{endOperation(cm);}};}// Updates the display.view data structure for a given change to the
	// document. From and to are in pre-change coordinates. Lendiff is
	// the amount of lines added or subtracted by the change. This is
	// used for changes that span multiple lines, or change the way
	// lines are divided into visual lines. regLineChange (below)
	// registers single-line changes.
	function regChange(cm,from,to,lendiff){if(from==null){from=cm.doc.first;}if(to==null){to=cm.doc.first+cm.doc.size;}if(!lendiff){lendiff=0;}var display=cm.display;if(lendiff&&to<display.viewTo&&(display.updateLineNumbers==null||display.updateLineNumbers>from)){display.updateLineNumbers=from;}cm.curOp.viewChanged=true;if(from>=display.viewTo){// Change after
	if(sawCollapsedSpans&&visualLineNo(cm.doc,from)<display.viewTo){resetView(cm);}}else if(to<=display.viewFrom){// Change before
	if(sawCollapsedSpans&&visualLineEndNo(cm.doc,to+lendiff)>display.viewFrom){resetView(cm);}else{display.viewFrom+=lendiff;display.viewTo+=lendiff;}}else if(from<=display.viewFrom&&to>=display.viewTo){// Full overlap
	resetView(cm);}else if(from<=display.viewFrom){// Top overlap
	var cut=viewCuttingPoint(cm,to,to+lendiff,1);if(cut){display.view=display.view.slice(cut.index);display.viewFrom=cut.lineN;display.viewTo+=lendiff;}else{resetView(cm);}}else if(to>=display.viewTo){// Bottom overlap
	var cut$1=viewCuttingPoint(cm,from,from,-1);if(cut$1){display.view=display.view.slice(0,cut$1.index);display.viewTo=cut$1.lineN;}else{resetView(cm);}}else{// Gap in the middle
	var cutTop=viewCuttingPoint(cm,from,from,-1);var cutBot=viewCuttingPoint(cm,to,to+lendiff,1);if(cutTop&&cutBot){display.view=display.view.slice(0,cutTop.index).concat(buildViewArray(cm,cutTop.lineN,cutBot.lineN)).concat(display.view.slice(cutBot.index));display.viewTo+=lendiff;}else{resetView(cm);}}var ext=display.externalMeasured;if(ext){if(to<ext.lineN){ext.lineN+=lendiff;}else if(from<ext.lineN+ext.size){display.externalMeasured=null;}}}// Register a change to a single line. Type must be one of "text",
	// "gutter", "class", "widget"
	function regLineChange(cm,line,type){cm.curOp.viewChanged=true;var display=cm.display,ext=cm.display.externalMeasured;if(ext&&line>=ext.lineN&&line<ext.lineN+ext.size){display.externalMeasured=null;}if(line<display.viewFrom||line>=display.viewTo){return;}var lineView=display.view[findViewIndex(cm,line)];if(lineView.node==null){return;}var arr=lineView.changes||(lineView.changes=[]);if(indexOf(arr,type)==-1){arr.push(type);}}// Clear the view.
	function resetView(cm){cm.display.viewFrom=cm.display.viewTo=cm.doc.first;cm.display.view=[];cm.display.viewOffset=0;}function viewCuttingPoint(cm,oldN,newN,dir){var index=findViewIndex(cm,oldN),diff,view=cm.display.view;if(!sawCollapsedSpans||newN==cm.doc.first+cm.doc.size){return{index:index,lineN:newN};}var n=cm.display.viewFrom;for(var i=0;i<index;i++){n+=view[i].size;}if(n!=oldN){if(dir>0){if(index==view.length-1){return null;}diff=n+view[index].size-oldN;index++;}else{diff=n-oldN;}oldN+=diff;newN+=diff;}while(visualLineNo(cm.doc,newN)!=newN){if(index==(dir<0?0:view.length-1)){return null;}newN+=dir*view[index-(dir<0?1:0)].size;index+=dir;}return{index:index,lineN:newN};}// Force the view to cover a given range, adding empty view element
	// or clipping off existing ones as needed.
	function adjustView(cm,from,to){var display=cm.display,view=display.view;if(view.length==0||from>=display.viewTo||to<=display.viewFrom){display.view=buildViewArray(cm,from,to);display.viewFrom=from;}else{if(display.viewFrom>from){display.view=buildViewArray(cm,from,display.viewFrom).concat(display.view);}else if(display.viewFrom<from){display.view=display.view.slice(findViewIndex(cm,from));}display.viewFrom=from;if(display.viewTo<to){display.view=display.view.concat(buildViewArray(cm,display.viewTo,to));}else if(display.viewTo>to){display.view=display.view.slice(0,findViewIndex(cm,to));}}display.viewTo=to;}// Count the number of lines in the view whose DOM representation is
	// out of date (or nonexistent).
	function countDirtyView(cm){var view=cm.display.view,dirty=0;for(var i=0;i<view.length;i++){var lineView=view[i];if(!lineView.hidden&&(!lineView.node||lineView.changes)){++dirty;}}return dirty;}// HIGHLIGHT WORKER
	function startWorker(cm,time){if(cm.doc.mode.startState&&cm.doc.frontier<cm.display.viewTo){cm.state.highlight.set(time,bind(highlightWorker,cm));}}function highlightWorker(cm){var doc=cm.doc;if(doc.frontier<doc.first){doc.frontier=doc.first;}if(doc.frontier>=cm.display.viewTo){return;}var end=+new Date()+cm.options.workTime;var state=copyState(doc.mode,getStateBefore(cm,doc.frontier));var changedLines=[];doc.iter(doc.frontier,Math.min(doc.first+doc.size,cm.display.viewTo+500),function(line){if(doc.frontier>=cm.display.viewFrom){// Visible
	var oldStyles=line.styles,tooLong=line.text.length>cm.options.maxHighlightLength;var highlighted=highlightLine(cm,line,tooLong?copyState(doc.mode,state):state,true);line.styles=highlighted.styles;var oldCls=line.styleClasses,newCls=highlighted.classes;if(newCls){line.styleClasses=newCls;}else if(oldCls){line.styleClasses=null;}var ischange=!oldStyles||oldStyles.length!=line.styles.length||oldCls!=newCls&&(!oldCls||!newCls||oldCls.bgClass!=newCls.bgClass||oldCls.textClass!=newCls.textClass);for(var i=0;!ischange&&i<oldStyles.length;++i){ischange=oldStyles[i]!=line.styles[i];}if(ischange){changedLines.push(doc.frontier);}line.stateAfter=tooLong?state:copyState(doc.mode,state);}else{if(line.text.length<=cm.options.maxHighlightLength){processLine(cm,line.text,state);}line.stateAfter=doc.frontier%5==0?copyState(doc.mode,state):null;}++doc.frontier;if(+new Date()>end){startWorker(cm,cm.options.workDelay);return true;}});if(changedLines.length){runInOp(cm,function(){for(var i=0;i<changedLines.length;i++){regLineChange(cm,changedLines[i],"text");}});}}// DISPLAY DRAWING
	var DisplayUpdate=function DisplayUpdate(cm,viewport,force){var display=cm.display;this.viewport=viewport;// Store some values that we'll need later (but don't want to force a relayout for)
	this.visible=visibleLines(display,cm.doc,viewport);this.editorIsHidden=!display.wrapper.offsetWidth;this.wrapperHeight=display.wrapper.clientHeight;this.wrapperWidth=display.wrapper.clientWidth;this.oldDisplayWidth=displayWidth(cm);this.force=force;this.dims=getDimensions(cm);this.events=[];};DisplayUpdate.prototype.signal=function(emitter,type){if(hasHandler(emitter,type)){this.events.push(arguments);}};DisplayUpdate.prototype.finish=function(){var this$1=this;for(var i=0;i<this.events.length;i++){signal.apply(null,this$1.events[i]);}};function maybeClipScrollbars(cm){var display=cm.display;if(!display.scrollbarsClipped&&display.scroller.offsetWidth){display.nativeBarWidth=display.scroller.offsetWidth-display.scroller.clientWidth;display.heightForcer.style.height=scrollGap(cm)+"px";display.sizer.style.marginBottom=-display.nativeBarWidth+"px";display.sizer.style.borderRightWidth=scrollGap(cm)+"px";display.scrollbarsClipped=true;}}// Does the actual updating of the line display. Bails out
	// (returning false) when there is nothing to be done and forced is
	// false.
	function updateDisplayIfNeeded(cm,update){var display=cm.display,doc=cm.doc;if(update.editorIsHidden){resetView(cm);return false;}// Bail out if the visible area is already rendered and nothing changed.
	if(!update.force&&update.visible.from>=display.viewFrom&&update.visible.to<=display.viewTo&&(display.updateLineNumbers==null||display.updateLineNumbers>=display.viewTo)&&display.renderedView==display.view&&countDirtyView(cm)==0){return false;}if(maybeUpdateLineNumberWidth(cm)){resetView(cm);update.dims=getDimensions(cm);}// Compute a suitable new viewport (from & to)
	var end=doc.first+doc.size;var from=Math.max(update.visible.from-cm.options.viewportMargin,doc.first);var to=Math.min(end,update.visible.to+cm.options.viewportMargin);if(display.viewFrom<from&&from-display.viewFrom<20){from=Math.max(doc.first,display.viewFrom);}if(display.viewTo>to&&display.viewTo-to<20){to=Math.min(end,display.viewTo);}if(sawCollapsedSpans){from=visualLineNo(cm.doc,from);to=visualLineEndNo(cm.doc,to);}var different=from!=display.viewFrom||to!=display.viewTo||display.lastWrapHeight!=update.wrapperHeight||display.lastWrapWidth!=update.wrapperWidth;adjustView(cm,from,to);display.viewOffset=_heightAtLine(getLine(cm.doc,display.viewFrom));// Position the mover div to align with the current scroll position
	cm.display.mover.style.top=display.viewOffset+"px";var toUpdate=countDirtyView(cm);if(!different&&toUpdate==0&&!update.force&&display.renderedView==display.view&&(display.updateLineNumbers==null||display.updateLineNumbers>=display.viewTo)){return false;}// For big changes, we hide the enclosing element during the
	// update, since that speeds up the operations on most browsers.
	var focused=activeElt();if(toUpdate>4){display.lineDiv.style.display="none";}patchDisplay(cm,display.updateLineNumbers,update.dims);if(toUpdate>4){display.lineDiv.style.display="";}display.renderedView=display.view;// There might have been a widget with a focused element that got
	// hidden or updated, if so re-focus it.
	if(focused&&activeElt()!=focused&&focused.offsetHeight){focused.focus();}// Prevent selection and cursors from interfering with the scroll
	// width and height.
	removeChildren(display.cursorDiv);removeChildren(display.selectionDiv);display.gutters.style.height=display.sizer.style.minHeight=0;if(different){display.lastWrapHeight=update.wrapperHeight;display.lastWrapWidth=update.wrapperWidth;startWorker(cm,400);}display.updateLineNumbers=null;return true;}function postUpdateDisplay(cm,update){var viewport=update.viewport;for(var first=true;;first=false){if(!first||!cm.options.lineWrapping||update.oldDisplayWidth==displayWidth(cm)){// Clip forced viewport to actual scrollable area.
	if(viewport&&viewport.top!=null){viewport={top:Math.min(cm.doc.height+paddingVert(cm.display)-displayHeight(cm),viewport.top)};}// Updated line heights might result in the drawn area not
	// actually covering the viewport. Keep looping until it does.
	update.visible=visibleLines(cm.display,cm.doc,viewport);if(update.visible.from>=cm.display.viewFrom&&update.visible.to<=cm.display.viewTo){break;}}if(!updateDisplayIfNeeded(cm,update)){break;}updateHeightsInViewport(cm);var barMeasure=measureForScrollbars(cm);updateSelection(cm);updateScrollbars(cm,barMeasure);setDocumentHeight(cm,barMeasure);}update.signal(cm,"update",cm);if(cm.display.viewFrom!=cm.display.reportedViewFrom||cm.display.viewTo!=cm.display.reportedViewTo){update.signal(cm,"viewportChange",cm,cm.display.viewFrom,cm.display.viewTo);cm.display.reportedViewFrom=cm.display.viewFrom;cm.display.reportedViewTo=cm.display.viewTo;}}function updateDisplaySimple(cm,viewport){var update=new DisplayUpdate(cm,viewport);if(updateDisplayIfNeeded(cm,update)){updateHeightsInViewport(cm);postUpdateDisplay(cm,update);var barMeasure=measureForScrollbars(cm);updateSelection(cm);updateScrollbars(cm,barMeasure);setDocumentHeight(cm,barMeasure);update.finish();}}// Sync the actual display DOM structure with display.view, removing
	// nodes for lines that are no longer in view, and creating the ones
	// that are not there yet, and updating the ones that are out of
	// date.
	function patchDisplay(cm,updateNumbersFrom,dims){var display=cm.display,lineNumbers=cm.options.lineNumbers;var container=display.lineDiv,cur=container.firstChild;function rm(node){var next=node.nextSibling;// Works around a throw-scroll bug in OS X Webkit
	if(webkit&&mac&&cm.display.currentWheelTarget==node){node.style.display="none";}else{node.parentNode.removeChild(node);}return next;}var view=display.view,lineN=display.viewFrom;// Loop over the elements in the view, syncing cur (the DOM nodes
	// in display.lineDiv) with the view as we go.
	for(var i=0;i<view.length;i++){var lineView=view[i];if(lineView.hidden){}else if(!lineView.node||lineView.node.parentNode!=container){// Not drawn yet
	var node=buildLineElement(cm,lineView,lineN,dims);container.insertBefore(node,cur);}else{// Already drawn
	while(cur!=lineView.node){cur=rm(cur);}var updateNumber=lineNumbers&&updateNumbersFrom!=null&&updateNumbersFrom<=lineN&&lineView.lineNumber;if(lineView.changes){if(indexOf(lineView.changes,"gutter")>-1){updateNumber=false;}updateLineForChanges(cm,lineView,lineN,dims);}if(updateNumber){removeChildren(lineView.lineNumber);lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options,lineN)));}cur=lineView.node.nextSibling;}lineN+=lineView.size;}while(cur){cur=rm(cur);}}function updateGutterSpace(cm){var width=cm.display.gutters.offsetWidth;cm.display.sizer.style.marginLeft=width+"px";}function setDocumentHeight(cm,measure){cm.display.sizer.style.minHeight=measure.docHeight+"px";cm.display.heightForcer.style.top=measure.docHeight+"px";cm.display.gutters.style.height=measure.docHeight+cm.display.barHeight+scrollGap(cm)+"px";}// Rebuild the gutter elements, ensure the margin to the left of the
	// code matches their width.
	function updateGutters(cm){var gutters=cm.display.gutters,specs=cm.options.gutters;removeChildren(gutters);var i=0;for(;i<specs.length;++i){var gutterClass=specs[i];var gElt=gutters.appendChild(elt("div",null,"CodeMirror-gutter "+gutterClass));if(gutterClass=="CodeMirror-linenumbers"){cm.display.lineGutter=gElt;gElt.style.width=(cm.display.lineNumWidth||1)+"px";}}gutters.style.display=i?"":"none";updateGutterSpace(cm);}// Make sure the gutters options contains the element
	// "CodeMirror-linenumbers" when the lineNumbers option is true.
	function setGuttersForLineNumbers(options){var found=indexOf(options.gutters,"CodeMirror-linenumbers");if(found==-1&&options.lineNumbers){options.gutters=options.gutters.concat(["CodeMirror-linenumbers"]);}else if(found>-1&&!options.lineNumbers){options.gutters=options.gutters.slice(0);options.gutters.splice(found,1);}}// Selection objects are immutable. A new one is created every time
	// the selection changes. A selection is one or more non-overlapping
	// (and non-touching) ranges, sorted, and an integer that indicates
	// which one is the primary selection (the one that's scrolled into
	// view, that getCursor returns, etc).
	function Selection(ranges,primIndex){this.ranges=ranges;this.primIndex=primIndex;}Selection.prototype={primary:function primary(){return this.ranges[this.primIndex];},equals:function equals(other){var this$1=this;if(other==this){return true;}if(other.primIndex!=this.primIndex||other.ranges.length!=this.ranges.length){return false;}for(var i=0;i<this.ranges.length;i++){var here=this$1.ranges[i],there=other.ranges[i];if(cmp(here.anchor,there.anchor)!=0||cmp(here.head,there.head)!=0){return false;}}return true;},deepCopy:function deepCopy(){var this$1=this;var out=[];for(var i=0;i<this.ranges.length;i++){out[i]=new Range(copyPos(this$1.ranges[i].anchor),copyPos(this$1.ranges[i].head));}return new Selection(out,this.primIndex);},somethingSelected:function somethingSelected(){var this$1=this;for(var i=0;i<this.ranges.length;i++){if(!this$1.ranges[i].empty()){return true;}}return false;},contains:function contains(pos,end){var this$1=this;if(!end){end=pos;}for(var i=0;i<this.ranges.length;i++){var range=this$1.ranges[i];if(cmp(end,range.from())>=0&&cmp(pos,range.to())<=0){return i;}}return-1;}};function Range(anchor,head){this.anchor=anchor;this.head=head;}Range.prototype={from:function from(){return minPos(this.anchor,this.head);},to:function to(){return maxPos(this.anchor,this.head);},empty:function empty(){return this.head.line==this.anchor.line&&this.head.ch==this.anchor.ch;}};// Take an unsorted, potentially overlapping set of ranges, and
	// build a selection out of it. 'Consumes' ranges array (modifying
	// it).
	function normalizeSelection(ranges,primIndex){var prim=ranges[primIndex];ranges.sort(function(a,b){return cmp(a.from(),b.from());});primIndex=indexOf(ranges,prim);for(var i=1;i<ranges.length;i++){var cur=ranges[i],prev=ranges[i-1];if(cmp(prev.to(),cur.from())>=0){var from=minPos(prev.from(),cur.from()),to=maxPos(prev.to(),cur.to());var inv=prev.empty()?cur.from()==cur.head:prev.from()==prev.head;if(i<=primIndex){--primIndex;}ranges.splice(--i,2,new Range(inv?to:from,inv?from:to));}}return new Selection(ranges,primIndex);}function simpleSelection(anchor,head){return new Selection([new Range(anchor,head||anchor)],0);}// Compute the position of the end of a change (its 'to' property
	// refers to the pre-change end).
	function changeEnd(change){if(!change.text){return change.to;}return Pos(change.from.line+change.text.length-1,lst(change.text).length+(change.text.length==1?change.from.ch:0));}// Adjust a position to refer to the post-change position of the
	// same text, or the end of the change if the change covers it.
	function adjustForChange(pos,change){if(cmp(pos,change.from)<0){return pos;}if(cmp(pos,change.to)<=0){return changeEnd(change);}var line=pos.line+change.text.length-(change.to.line-change.from.line)-1,ch=pos.ch;if(pos.line==change.to.line){ch+=changeEnd(change).ch-change.to.ch;}return Pos(line,ch);}function computeSelAfterChange(doc,change){var out=[];for(var i=0;i<doc.sel.ranges.length;i++){var range=doc.sel.ranges[i];out.push(new Range(adjustForChange(range.anchor,change),adjustForChange(range.head,change)));}return normalizeSelection(out,doc.sel.primIndex);}function offsetPos(pos,old,nw){if(pos.line==old.line){return Pos(nw.line,pos.ch-old.ch+nw.ch);}else{return Pos(nw.line+(pos.line-old.line),pos.ch);}}// Used by replaceSelections to allow moving the selection to the
	// start or around the replaced test. Hint may be "start" or "around".
	function computeReplacedSel(doc,changes,hint){var out=[];var oldPrev=Pos(doc.first,0),newPrev=oldPrev;for(var i=0;i<changes.length;i++){var change=changes[i];var from=offsetPos(change.from,oldPrev,newPrev);var to=offsetPos(changeEnd(change),oldPrev,newPrev);oldPrev=change.to;newPrev=to;if(hint=="around"){var range=doc.sel.ranges[i],inv=cmp(range.head,range.anchor)<0;out[i]=new Range(inv?to:from,inv?from:to);}else{out[i]=new Range(from,from);}}return new Selection(out,doc.sel.primIndex);}// Used to get the editor into a consistent state again when options change.
	function loadMode(cm){cm.doc.mode=getMode(cm.options,cm.doc.modeOption);resetModeState(cm);}function resetModeState(cm){cm.doc.iter(function(line){if(line.stateAfter){line.stateAfter=null;}if(line.styles){line.styles=null;}});cm.doc.frontier=cm.doc.first;startWorker(cm,100);cm.state.modeGen++;if(cm.curOp){regChange(cm);}}// DOCUMENT DATA STRUCTURE
	// By default, updates that start and end at the beginning of a line
	// are treated specially, in order to make the association of line
	// widgets and marker elements with the text behave more intuitive.
	function isWholeLineUpdate(doc,change){return change.from.ch==0&&change.to.ch==0&&lst(change.text)==""&&(!doc.cm||doc.cm.options.wholeLineUpdateBefore);}// Perform a change on the document data structure.
	function updateDoc(doc,change,markedSpans,estimateHeight){function spansFor(n){return markedSpans?markedSpans[n]:null;}function update(line,text,spans){updateLine(line,text,spans,estimateHeight);signalLater(line,"change",line,change);}function linesFor(start,end){var result=[];for(var i=start;i<end;++i){result.push(new Line(text[i],spansFor(i),estimateHeight));}return result;}var from=change.from,to=change.to,text=change.text;var firstLine=getLine(doc,from.line),lastLine=getLine(doc,to.line);var lastText=lst(text),lastSpans=spansFor(text.length-1),nlines=to.line-from.line;// Adjust the line structure
	if(change.full){doc.insert(0,linesFor(0,text.length));doc.remove(text.length,doc.size-text.length);}else if(isWholeLineUpdate(doc,change)){// This is a whole-line replace. Treated specially to make
	// sure line objects move the way they are supposed to.
	var added=linesFor(0,text.length-1);update(lastLine,lastLine.text,lastSpans);if(nlines){doc.remove(from.line,nlines);}if(added.length){doc.insert(from.line,added);}}else if(firstLine==lastLine){if(text.length==1){update(firstLine,firstLine.text.slice(0,from.ch)+lastText+firstLine.text.slice(to.ch),lastSpans);}else{var added$1=linesFor(1,text.length-1);added$1.push(new Line(lastText+firstLine.text.slice(to.ch),lastSpans,estimateHeight));update(firstLine,firstLine.text.slice(0,from.ch)+text[0],spansFor(0));doc.insert(from.line+1,added$1);}}else if(text.length==1){update(firstLine,firstLine.text.slice(0,from.ch)+text[0]+lastLine.text.slice(to.ch),spansFor(0));doc.remove(from.line+1,nlines);}else{update(firstLine,firstLine.text.slice(0,from.ch)+text[0],spansFor(0));update(lastLine,lastText+lastLine.text.slice(to.ch),lastSpans);var added$2=linesFor(1,text.length-1);if(nlines>1){doc.remove(from.line+1,nlines-1);}doc.insert(from.line+1,added$2);}signalLater(doc,"change",doc,change);}// Call f for all linked documents.
	function linkedDocs(doc,f,sharedHistOnly){function propagate(doc,skip,sharedHist){if(doc.linked){for(var i=0;i<doc.linked.length;++i){var rel=doc.linked[i];if(rel.doc==skip){continue;}var shared=sharedHist&&rel.sharedHist;if(sharedHistOnly&&!shared){continue;}f(rel.doc,shared);propagate(rel.doc,doc,shared);}}}propagate(doc,null,true);}// Attach a document to an editor.
	function attachDoc(cm,doc){if(doc.cm){throw new Error("This document is already in use.");}cm.doc=doc;doc.cm=cm;estimateLineHeights(cm);loadMode(cm);if(!cm.options.lineWrapping){findMaxLine(cm);}cm.options.mode=doc.modeOption;regChange(cm);}function History(startGen){// Arrays of change events and selections. Doing something adds an
	// event to done and clears undo. Undoing moves events from done
	// to undone, redoing moves them in the other direction.
	this.done=[];this.undone=[];this.undoDepth=Infinity;// Used to track when changes can be merged into a single undo
	// event
	this.lastModTime=this.lastSelTime=0;this.lastOp=this.lastSelOp=null;this.lastOrigin=this.lastSelOrigin=null;// Used by the isClean() method
	this.generation=this.maxGeneration=startGen||1;}// Create a history change event from an updateDoc-style change
	// object.
	function historyChangeFromChange(doc,change){var histChange={from:copyPos(change.from),to:changeEnd(change),text:getBetween(doc,change.from,change.to)};attachLocalSpans(doc,histChange,change.from.line,change.to.line+1);linkedDocs(doc,function(doc){return attachLocalSpans(doc,histChange,change.from.line,change.to.line+1);},true);return histChange;}// Pop all selection events off the end of a history array. Stop at
	// a change event.
	function clearSelectionEvents(array){while(array.length){var last=lst(array);if(last.ranges){array.pop();}else{break;}}}// Find the top change event in the history. Pop off selection
	// events that are in the way.
	function lastChangeEvent(hist,force){if(force){clearSelectionEvents(hist.done);return lst(hist.done);}else if(hist.done.length&&!lst(hist.done).ranges){return lst(hist.done);}else if(hist.done.length>1&&!hist.done[hist.done.length-2].ranges){hist.done.pop();return lst(hist.done);}}// Register a change in the history. Merges changes that are within
	// a single operation, or are close together with an origin that
	// allows merging (starting with "+") into a single event.
	function addChangeToHistory(doc,change,selAfter,opId){var hist=doc.history;hist.undone.length=0;var time=+new Date(),cur;var last;if((hist.lastOp==opId||hist.lastOrigin==change.origin&&change.origin&&(change.origin.charAt(0)=="+"&&doc.cm&&hist.lastModTime>time-doc.cm.options.historyEventDelay||change.origin.charAt(0)=="*"))&&(cur=lastChangeEvent(hist,hist.lastOp==opId))){// Merge this change into the last event
	last=lst(cur.changes);if(cmp(change.from,change.to)==0&&cmp(change.from,last.to)==0){// Optimized case for simple insertion -- don't want to add
	// new changesets for every character typed
	last.to=changeEnd(change);}else{// Add new sub-event
	cur.changes.push(historyChangeFromChange(doc,change));}}else{// Can not be merged, start a new event.
	var before=lst(hist.done);if(!before||!before.ranges){pushSelectionToHistory(doc.sel,hist.done);}cur={changes:[historyChangeFromChange(doc,change)],generation:hist.generation};hist.done.push(cur);while(hist.done.length>hist.undoDepth){hist.done.shift();if(!hist.done[0].ranges){hist.done.shift();}}}hist.done.push(selAfter);hist.generation=++hist.maxGeneration;hist.lastModTime=hist.lastSelTime=time;hist.lastOp=hist.lastSelOp=opId;hist.lastOrigin=hist.lastSelOrigin=change.origin;if(!last){signal(doc,"historyAdded");}}function selectionEventCanBeMerged(doc,origin,prev,sel){var ch=origin.charAt(0);return ch=="*"||ch=="+"&&prev.ranges.length==sel.ranges.length&&prev.somethingSelected()==sel.somethingSelected()&&new Date()-doc.history.lastSelTime<=(doc.cm?doc.cm.options.historyEventDelay:500);}// Called whenever the selection changes, sets the new selection as
	// the pending selection in the history, and pushes the old pending
	// selection into the 'done' array when it was significantly
	// different (in number of selected ranges, emptiness, or time).
	function addSelectionToHistory(doc,sel,opId,options){var hist=doc.history,origin=options&&options.origin;// A new event is started when the previous origin does not match
	// the current, or the origins don't allow matching. Origins
	// starting with * are always merged, those starting with + are
	// merged when similar and close together in time.
	if(opId==hist.lastSelOp||origin&&hist.lastSelOrigin==origin&&(hist.lastModTime==hist.lastSelTime&&hist.lastOrigin==origin||selectionEventCanBeMerged(doc,origin,lst(hist.done),sel))){hist.done[hist.done.length-1]=sel;}else{pushSelectionToHistory(sel,hist.done);}hist.lastSelTime=+new Date();hist.lastSelOrigin=origin;hist.lastSelOp=opId;if(options&&options.clearRedo!==false){clearSelectionEvents(hist.undone);}}function pushSelectionToHistory(sel,dest){var top=lst(dest);if(!(top&&top.ranges&&top.equals(sel))){dest.push(sel);}}// Used to store marked span information in the history.
	function attachLocalSpans(doc,change,from,to){var existing=change["spans_"+doc.id],n=0;doc.iter(Math.max(doc.first,from),Math.min(doc.first+doc.size,to),function(line){if(line.markedSpans){(existing||(existing=change["spans_"+doc.id]={}))[n]=line.markedSpans;}++n;});}// When un/re-doing restores text containing marked spans, those
	// that have been explicitly cleared should not be restored.
	function removeClearedSpans(spans){if(!spans){return null;}var out;for(var i=0;i<spans.length;++i){if(spans[i].marker.explicitlyCleared){if(!out){out=spans.slice(0,i);}}else if(out){out.push(spans[i]);}}return!out?spans:out.length?out:null;}// Retrieve and filter the old marked spans stored in a change event.
	function getOldSpans(doc,change){var found=change["spans_"+doc.id];if(!found){return null;}var nw=[];for(var i=0;i<change.text.length;++i){nw.push(removeClearedSpans(found[i]));}return nw;}// Used for un/re-doing changes from the history. Combines the
	// result of computing the existing spans with the set of spans that
	// existed in the history (so that deleting around a span and then
	// undoing brings back the span).
	function mergeOldSpans(doc,change){var old=getOldSpans(doc,change);var stretched=stretchSpansOverChange(doc,change);if(!old){return stretched;}if(!stretched){return old;}for(var i=0;i<old.length;++i){var oldCur=old[i],stretchCur=stretched[i];if(oldCur&&stretchCur){spans:for(var j=0;j<stretchCur.length;++j){var span=stretchCur[j];for(var k=0;k<oldCur.length;++k){if(oldCur[k].marker==span.marker){continue spans;}}oldCur.push(span);}}else if(stretchCur){old[i]=stretchCur;}}return old;}// Used both to provide a JSON-safe object in .getHistory, and, when
	// detaching a document, to split the history in two
	function copyHistoryArray(events,newGroup,instantiateSel){var copy=[];for(var i=0;i<events.length;++i){var event=events[i];if(event.ranges){copy.push(instantiateSel?Selection.prototype.deepCopy.call(event):event);continue;}var changes=event.changes,newChanges=[];copy.push({changes:newChanges});for(var j=0;j<changes.length;++j){var change=changes[j],m=void 0;newChanges.push({from:change.from,to:change.to,text:change.text});if(newGroup){for(var prop in change){if(m=prop.match(/^spans_(\d+)$/)){if(indexOf(newGroup,Number(m[1]))>-1){lst(newChanges)[prop]=change[prop];delete change[prop];}}}}}}return copy;}// The 'scroll' parameter given to many of these indicated whether
	// the new cursor position should be scrolled into view after
	// modifying the selection.
	// If shift is held or the extend flag is set, extends a range to
	// include a given position (and optionally a second position).
	// Otherwise, simply returns the range between the given positions.
	// Used for cursor motion and such.
	function extendRange(doc,range,head,other){if(doc.cm&&doc.cm.display.shift||doc.extend){var anchor=range.anchor;if(other){var posBefore=cmp(head,anchor)<0;if(posBefore!=cmp(other,anchor)<0){anchor=head;head=other;}else if(posBefore!=cmp(head,other)<0){head=other;}}return new Range(anchor,head);}else{return new Range(other||head,head);}}// Extend the primary selection range, discard the rest.
	function extendSelection(doc,head,other,options){setSelection(doc,new Selection([extendRange(doc,doc.sel.primary(),head,other)],0),options);}// Extend all selections (pos is an array of selections with length
	// equal the number of selections)
	function extendSelections(doc,heads,options){var out=[];for(var i=0;i<doc.sel.ranges.length;i++){out[i]=extendRange(doc,doc.sel.ranges[i],heads[i],null);}var newSel=normalizeSelection(out,doc.sel.primIndex);setSelection(doc,newSel,options);}// Updates a single range in the selection.
	function replaceOneSelection(doc,i,range,options){var ranges=doc.sel.ranges.slice(0);ranges[i]=range;setSelection(doc,normalizeSelection(ranges,doc.sel.primIndex),options);}// Reset the selection to a single range.
	function setSimpleSelection(doc,anchor,head,options){setSelection(doc,simpleSelection(anchor,head),options);}// Give beforeSelectionChange handlers a change to influence a
	// selection update.
	function filterSelectionChange(doc,sel,options){var obj={ranges:sel.ranges,update:function update(ranges){var this$1=this;this.ranges=[];for(var i=0;i<ranges.length;i++){this$1.ranges[i]=new Range(_clipPos(doc,ranges[i].anchor),_clipPos(doc,ranges[i].head));}},origin:options&&options.origin};signal(doc,"beforeSelectionChange",doc,obj);if(doc.cm){signal(doc.cm,"beforeSelectionChange",doc.cm,obj);}if(obj.ranges!=sel.ranges){return normalizeSelection(obj.ranges,obj.ranges.length-1);}else{return sel;}}function setSelectionReplaceHistory(doc,sel,options){var done=doc.history.done,last=lst(done);if(last&&last.ranges){done[done.length-1]=sel;setSelectionNoUndo(doc,sel,options);}else{setSelection(doc,sel,options);}}// Set a new selection.
	function setSelection(doc,sel,options){setSelectionNoUndo(doc,sel,options);addSelectionToHistory(doc,doc.sel,doc.cm?doc.cm.curOp.id:NaN,options);}function setSelectionNoUndo(doc,sel,options){if(hasHandler(doc,"beforeSelectionChange")||doc.cm&&hasHandler(doc.cm,"beforeSelectionChange")){sel=filterSelectionChange(doc,sel,options);}var bias=options&&options.bias||(cmp(sel.primary().head,doc.sel.primary().head)<0?-1:1);setSelectionInner(doc,skipAtomicInSelection(doc,sel,bias,true));if(!(options&&options.scroll===false)&&doc.cm){ensureCursorVisible(doc.cm);}}function setSelectionInner(doc,sel){if(sel.equals(doc.sel)){return;}doc.sel=sel;if(doc.cm){doc.cm.curOp.updateInput=doc.cm.curOp.selectionChanged=true;signalCursorActivity(doc.cm);}signalLater(doc,"cursorActivity",doc);}// Verify that the selection does not partially select any atomic
	// marked ranges.
	function reCheckSelection(doc){setSelectionInner(doc,skipAtomicInSelection(doc,doc.sel,null,false),sel_dontScroll);}// Return a selection that does not partially select any atomic
	// ranges.
	function skipAtomicInSelection(doc,sel,bias,mayClear){var out;for(var i=0;i<sel.ranges.length;i++){var range=sel.ranges[i];var old=sel.ranges.length==doc.sel.ranges.length&&doc.sel.ranges[i];var newAnchor=skipAtomic(doc,range.anchor,old&&old.anchor,bias,mayClear);var newHead=skipAtomic(doc,range.head,old&&old.head,bias,mayClear);if(out||newAnchor!=range.anchor||newHead!=range.head){if(!out){out=sel.ranges.slice(0,i);}out[i]=new Range(newAnchor,newHead);}}return out?normalizeSelection(out,sel.primIndex):sel;}function skipAtomicInner(doc,pos,oldPos,dir,mayClear){var line=getLine(doc,pos.line);if(line.markedSpans){for(var i=0;i<line.markedSpans.length;++i){var sp=line.markedSpans[i],m=sp.marker;if((sp.from==null||(m.inclusiveLeft?sp.from<=pos.ch:sp.from<pos.ch))&&(sp.to==null||(m.inclusiveRight?sp.to>=pos.ch:sp.to>pos.ch))){if(mayClear){signal(m,"beforeCursorEnter");if(m.explicitlyCleared){if(!line.markedSpans){break;}else{--i;continue;}}}if(!m.atomic){continue;}if(oldPos){var near=m.find(dir<0?1:-1),diff=void 0;if(dir<0?m.inclusiveRight:m.inclusiveLeft){near=movePos(doc,near,-dir,near&&near.line==pos.line?line:null);}if(near&&near.line==pos.line&&(diff=cmp(near,oldPos))&&(dir<0?diff<0:diff>0)){return skipAtomicInner(doc,near,pos,dir,mayClear);}}var far=m.find(dir<0?-1:1);if(dir<0?m.inclusiveLeft:m.inclusiveRight){far=movePos(doc,far,dir,far.line==pos.line?line:null);}return far?skipAtomicInner(doc,far,pos,dir,mayClear):null;}}}return pos;}// Ensure a given position is not inside an atomic range.
	function skipAtomic(doc,pos,oldPos,bias,mayClear){var dir=bias||1;var found=skipAtomicInner(doc,pos,oldPos,dir,mayClear)||!mayClear&&skipAtomicInner(doc,pos,oldPos,dir,true)||skipAtomicInner(doc,pos,oldPos,-dir,mayClear)||!mayClear&&skipAtomicInner(doc,pos,oldPos,-dir,true);if(!found){doc.cantEdit=true;return Pos(doc.first,0);}return found;}function movePos(doc,pos,dir,line){if(dir<0&&pos.ch==0){if(pos.line>doc.first){return _clipPos(doc,Pos(pos.line-1));}else{return null;}}else if(dir>0&&pos.ch==(line||getLine(doc,pos.line)).text.length){if(pos.line<doc.first+doc.size-1){return Pos(pos.line+1,0);}else{return null;}}else{return new Pos(pos.line,pos.ch+dir);}}function selectAll(cm){cm.setSelection(Pos(cm.firstLine(),0),Pos(cm.lastLine()),sel_dontScroll);}// UPDATING
	// Allow "beforeChange" event handlers to influence a change
	function filterChange(doc,change,update){var obj={canceled:false,from:change.from,to:change.to,text:change.text,origin:change.origin,cancel:function cancel(){return obj.canceled=true;}};if(update){obj.update=function(from,to,text,origin){if(from){obj.from=_clipPos(doc,from);}if(to){obj.to=_clipPos(doc,to);}if(text){obj.text=text;}if(origin!==undefined){obj.origin=origin;}};}signal(doc,"beforeChange",doc,obj);if(doc.cm){signal(doc.cm,"beforeChange",doc.cm,obj);}if(obj.canceled){return null;}return{from:obj.from,to:obj.to,text:obj.text,origin:obj.origin};}// Apply a change to a document, and add it to the document's
	// history, and propagating it to all linked documents.
	function makeChange(doc,change,ignoreReadOnly){if(doc.cm){if(!doc.cm.curOp){return operation(doc.cm,makeChange)(doc,change,ignoreReadOnly);}if(doc.cm.state.suppressEdits){return;}}if(hasHandler(doc,"beforeChange")||doc.cm&&hasHandler(doc.cm,"beforeChange")){change=filterChange(doc,change,true);if(!change){return;}}// Possibly split or suppress the update based on the presence
	// of read-only spans in its range.
	var split=sawReadOnlySpans&&!ignoreReadOnly&&removeReadOnlyRanges(doc,change.from,change.to);if(split){for(var i=split.length-1;i>=0;--i){makeChangeInner(doc,{from:split[i].from,to:split[i].to,text:i?[""]:change.text});}}else{makeChangeInner(doc,change);}}function makeChangeInner(doc,change){if(change.text.length==1&&change.text[0]==""&&cmp(change.from,change.to)==0){return;}var selAfter=computeSelAfterChange(doc,change);addChangeToHistory(doc,change,selAfter,doc.cm?doc.cm.curOp.id:NaN);makeChangeSingleDoc(doc,change,selAfter,stretchSpansOverChange(doc,change));var rebased=[];linkedDocs(doc,function(doc,sharedHist){if(!sharedHist&&indexOf(rebased,doc.history)==-1){rebaseHist(doc.history,change);rebased.push(doc.history);}makeChangeSingleDoc(doc,change,null,stretchSpansOverChange(doc,change));});}// Revert a change stored in a document's history.
	function makeChangeFromHistory(doc,type,allowSelectionOnly){if(doc.cm&&doc.cm.state.suppressEdits&&!allowSelectionOnly){return;}var hist=doc.history,event,selAfter=doc.sel;var source=type=="undo"?hist.done:hist.undone,dest=type=="undo"?hist.undone:hist.done;// Verify that there is a useable event (so that ctrl-z won't
	// needlessly clear selection events)
	var i=0;for(;i<source.length;i++){event=source[i];if(allowSelectionOnly?event.ranges&&!event.equals(doc.sel):!event.ranges){break;}}if(i==source.length){return;}hist.lastOrigin=hist.lastSelOrigin=null;for(;;){event=source.pop();if(event.ranges){pushSelectionToHistory(event,dest);if(allowSelectionOnly&&!event.equals(doc.sel)){setSelection(doc,event,{clearRedo:false});return;}selAfter=event;}else{break;}}// Build up a reverse change object to add to the opposite history
	// stack (redo when undoing, and vice versa).
	var antiChanges=[];pushSelectionToHistory(selAfter,dest);dest.push({changes:antiChanges,generation:hist.generation});hist.generation=event.generation||++hist.maxGeneration;var filter=hasHandler(doc,"beforeChange")||doc.cm&&hasHandler(doc.cm,"beforeChange");var loop=function loop(i){var change=event.changes[i];change.origin=type;if(filter&&!filterChange(doc,change,false)){source.length=0;return{};}antiChanges.push(historyChangeFromChange(doc,change));var after=i?computeSelAfterChange(doc,change):lst(source);makeChangeSingleDoc(doc,change,after,mergeOldSpans(doc,change));if(!i&&doc.cm){doc.cm.scrollIntoView({from:change.from,to:changeEnd(change)});}var rebased=[];// Propagate to the linked documents
	linkedDocs(doc,function(doc,sharedHist){if(!sharedHist&&indexOf(rebased,doc.history)==-1){rebaseHist(doc.history,change);rebased.push(doc.history);}makeChangeSingleDoc(doc,change,null,mergeOldSpans(doc,change));});};for(var i$1=event.changes.length-1;i$1>=0;--i$1){var returned=loop(i$1);if(returned)return returned.v;}}// Sub-views need their line numbers shifted when text is added
	// above or below them in the parent document.
	function shiftDoc(doc,distance){if(distance==0){return;}doc.first+=distance;doc.sel=new Selection(map(doc.sel.ranges,function(range){return new Range(Pos(range.anchor.line+distance,range.anchor.ch),Pos(range.head.line+distance,range.head.ch));}),doc.sel.primIndex);if(doc.cm){regChange(doc.cm,doc.first,doc.first-distance,distance);for(var d=doc.cm.display,l=d.viewFrom;l<d.viewTo;l++){regLineChange(doc.cm,l,"gutter");}}}// More lower-level change function, handling only a single document
	// (not linked ones).
	function makeChangeSingleDoc(doc,change,selAfter,spans){if(doc.cm&&!doc.cm.curOp){return operation(doc.cm,makeChangeSingleDoc)(doc,change,selAfter,spans);}if(change.to.line<doc.first){shiftDoc(doc,change.text.length-1-(change.to.line-change.from.line));return;}if(change.from.line>doc.lastLine()){return;}// Clip the change to the size of this doc
	if(change.from.line<doc.first){var shift=change.text.length-1-(doc.first-change.from.line);shiftDoc(doc,shift);change={from:Pos(doc.first,0),to:Pos(change.to.line+shift,change.to.ch),text:[lst(change.text)],origin:change.origin};}var last=doc.lastLine();if(change.to.line>last){change={from:change.from,to:Pos(last,getLine(doc,last).text.length),text:[change.text[0]],origin:change.origin};}change.removed=getBetween(doc,change.from,change.to);if(!selAfter){selAfter=computeSelAfterChange(doc,change);}if(doc.cm){makeChangeSingleDocInEditor(doc.cm,change,spans);}else{updateDoc(doc,change,spans);}setSelectionNoUndo(doc,selAfter,sel_dontScroll);}// Handle the interaction of a change to a document with the editor
	// that this document is part of.
	function makeChangeSingleDocInEditor(cm,change,spans){var doc=cm.doc,display=cm.display,from=change.from,to=change.to;var recomputeMaxLength=false,checkWidthStart=from.line;if(!cm.options.lineWrapping){checkWidthStart=lineNo(visualLine(getLine(doc,from.line)));doc.iter(checkWidthStart,to.line+1,function(line){if(line==display.maxLine){recomputeMaxLength=true;return true;}});}if(doc.sel.contains(change.from,change.to)>-1){signalCursorActivity(cm);}updateDoc(doc,change,spans,estimateHeight(cm));if(!cm.options.lineWrapping){doc.iter(checkWidthStart,from.line+change.text.length,function(line){var len=lineLength(line);if(len>display.maxLineLength){display.maxLine=line;display.maxLineLength=len;display.maxLineChanged=true;recomputeMaxLength=false;}});if(recomputeMaxLength){cm.curOp.updateMaxLine=true;}}// Adjust frontier, schedule worker
	doc.frontier=Math.min(doc.frontier,from.line);startWorker(cm,400);var lendiff=change.text.length-(to.line-from.line)-1;// Remember that these lines changed, for updating the display
	if(change.full){regChange(cm);}else if(from.line==to.line&&change.text.length==1&&!isWholeLineUpdate(cm.doc,change)){regLineChange(cm,from.line,"text");}else{regChange(cm,from.line,to.line+1,lendiff);}var changesHandler=hasHandler(cm,"changes"),changeHandler=hasHandler(cm,"change");if(changeHandler||changesHandler){var obj={from:from,to:to,text:change.text,removed:change.removed,origin:change.origin};if(changeHandler){signalLater(cm,"change",cm,obj);}if(changesHandler){(cm.curOp.changeObjs||(cm.curOp.changeObjs=[])).push(obj);}}cm.display.selForContextMenu=null;}function _replaceRange(doc,code,from,to,origin){if(!to){to=from;}if(cmp(to,from)<0){var tmp=to;to=from;from=tmp;}if(typeof code=="string"){code=doc.splitLines(code);}makeChange(doc,{from:from,to:to,text:code,origin:origin});}// Rebasing/resetting history to deal with externally-sourced changes
	function rebaseHistSelSingle(pos,from,to,diff){if(to<pos.line){pos.line+=diff;}else if(from<pos.line){pos.line=from;pos.ch=0;}}// Tries to rebase an array of history events given a change in the
	// document. If the change touches the same lines as the event, the
	// event, and everything 'behind' it, is discarded. If the change is
	// before the event, the event's positions are updated. Uses a
	// copy-on-write scheme for the positions, to avoid having to
	// reallocate them all on every rebase, but also avoid problems with
	// shared position objects being unsafely updated.
	function rebaseHistArray(array,from,to,diff){for(var i=0;i<array.length;++i){var sub=array[i],ok=true;if(sub.ranges){if(!sub.copied){sub=array[i]=sub.deepCopy();sub.copied=true;}for(var j=0;j<sub.ranges.length;j++){rebaseHistSelSingle(sub.ranges[j].anchor,from,to,diff);rebaseHistSelSingle(sub.ranges[j].head,from,to,diff);}continue;}for(var j$1=0;j$1<sub.changes.length;++j$1){var cur=sub.changes[j$1];if(to<cur.from.line){cur.from=Pos(cur.from.line+diff,cur.from.ch);cur.to=Pos(cur.to.line+diff,cur.to.ch);}else if(from<=cur.to.line){ok=false;break;}}if(!ok){array.splice(0,i+1);i=0;}}}function rebaseHist(hist,change){var from=change.from.line,to=change.to.line,diff=change.text.length-(to-from)-1;rebaseHistArray(hist.done,from,to,diff);rebaseHistArray(hist.undone,from,to,diff);}// Utility for applying a change to a line by handle or number,
	// returning the number and optionally registering the line as
	// changed.
	function changeLine(doc,handle,changeType,op){var no=handle,line=handle;if(typeof handle=="number"){line=getLine(doc,clipLine(doc,handle));}else{no=lineNo(handle);}if(no==null){return null;}if(op(line,no)&&doc.cm){regLineChange(doc.cm,no,changeType);}return line;}// The document is represented as a BTree consisting of leaves, with
	// chunk of lines in them, and branches, with up to ten leaves or
	// other branch nodes below them. The top node is always a branch
	// node, and is the document object itself (meaning it has
	// additional methods and properties).
	//
	// All nodes have parent links. The tree is used both to go from
	// line numbers to line objects, and to go from objects to numbers.
	// It also indexes by height, and is used to convert between height
	// and line object, and to find the total height of the document.
	//
	// See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
	function LeafChunk(lines){var this$1=this;this.lines=lines;this.parent=null;var height=0;for(var i=0;i<lines.length;++i){lines[i].parent=this$1;height+=lines[i].height;}this.height=height;}LeafChunk.prototype={chunkSize:function chunkSize(){return this.lines.length;},// Remove the n lines at offset 'at'.
	removeInner:function removeInner(at,n){var this$1=this;for(var i=at,e=at+n;i<e;++i){var line=this$1.lines[i];this$1.height-=line.height;cleanUpLine(line);signalLater(line,"delete");}this.lines.splice(at,n);},// Helper used to collapse a small branch into a single leaf.
	collapse:function collapse(lines){lines.push.apply(lines,this.lines);},// Insert the given array of lines at offset 'at', count them as
	// having the given height.
	insertInner:function insertInner(at,lines,height){var this$1=this;this.height+=height;this.lines=this.lines.slice(0,at).concat(lines).concat(this.lines.slice(at));for(var i=0;i<lines.length;++i){lines[i].parent=this$1;}},// Used to iterate over a part of the tree.
	iterN:function iterN(at,n,op){var this$1=this;for(var e=at+n;at<e;++at){if(op(this$1.lines[at])){return true;}}}};function BranchChunk(children){var this$1=this;this.children=children;var size=0,height=0;for(var i=0;i<children.length;++i){var ch=children[i];size+=ch.chunkSize();height+=ch.height;ch.parent=this$1;}this.size=size;this.height=height;this.parent=null;}BranchChunk.prototype={chunkSize:function chunkSize(){return this.size;},removeInner:function removeInner(at,n){var this$1=this;this.size-=n;for(var i=0;i<this.children.length;++i){var child=this$1.children[i],sz=child.chunkSize();if(at<sz){var rm=Math.min(n,sz-at),oldHeight=child.height;child.removeInner(at,rm);this$1.height-=oldHeight-child.height;if(sz==rm){this$1.children.splice(i--,1);child.parent=null;}if((n-=rm)==0){break;}at=0;}else{at-=sz;}}// If the result is smaller than 25 lines, ensure that it is a
	// single leaf node.
	if(this.size-n<25&&(this.children.length>1||!(this.children[0]instanceof LeafChunk))){var lines=[];this.collapse(lines);this.children=[new LeafChunk(lines)];this.children[0].parent=this;}},collapse:function collapse(lines){var this$1=this;for(var i=0;i<this.children.length;++i){this$1.children[i].collapse(lines);}},insertInner:function insertInner(at,lines,height){var this$1=this;this.size+=lines.length;this.height+=height;for(var i=0;i<this.children.length;++i){var child=this$1.children[i],sz=child.chunkSize();if(at<=sz){child.insertInner(at,lines,height);if(child.lines&&child.lines.length>50){// To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
	// Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
	var remaining=child.lines.length%25+25;for(var pos=remaining;pos<child.lines.length;){var leaf=new LeafChunk(child.lines.slice(pos,pos+=25));child.height-=leaf.height;this$1.children.splice(++i,0,leaf);leaf.parent=this$1;}child.lines=child.lines.slice(0,remaining);this$1.maybeSpill();}break;}at-=sz;}},// When a node has grown, check whether it should be split.
	maybeSpill:function maybeSpill(){if(this.children.length<=10){return;}var me=this;do{var spilled=me.children.splice(me.children.length-5,5);var sibling=new BranchChunk(spilled);if(!me.parent){// Become the parent node
	var copy=new BranchChunk(me.children);copy.parent=me;me.children=[copy,sibling];me=copy;}else{me.size-=sibling.size;me.height-=sibling.height;var myIndex=indexOf(me.parent.children,me);me.parent.children.splice(myIndex+1,0,sibling);}sibling.parent=me.parent;}while(me.children.length>10);me.parent.maybeSpill();},iterN:function iterN(at,n,op){var this$1=this;for(var i=0;i<this.children.length;++i){var child=this$1.children[i],sz=child.chunkSize();if(at<sz){var used=Math.min(n,sz-at);if(child.iterN(at,used,op)){return true;}if((n-=used)==0){break;}at=0;}else{at-=sz;}}}};// Line widgets are block elements displayed above or below a line.
	function LineWidget(doc,node,options){var this$1=this;if(options){for(var opt in options){if(options.hasOwnProperty(opt)){this$1[opt]=options[opt];}}}this.doc=doc;this.node=node;}eventMixin(LineWidget);function adjustScrollWhenAboveVisible(cm,line,diff){if(_heightAtLine(line)<(cm.curOp&&cm.curOp.scrollTop||cm.doc.scrollTop)){addToScrollPos(cm,null,diff);}}LineWidget.prototype.clear=function(){var this$1=this;var cm=this.doc.cm,ws=this.line.widgets,line=this.line,no=lineNo(line);if(no==null||!ws){return;}for(var i=0;i<ws.length;++i){if(ws[i]==this$1){ws.splice(i--,1);}}if(!ws.length){line.widgets=null;}var height=widgetHeight(this);updateLineHeight(line,Math.max(0,line.height-height));if(cm){runInOp(cm,function(){adjustScrollWhenAboveVisible(cm,line,-height);regLineChange(cm,no,"widget");});}};LineWidget.prototype.changed=function(){var oldH=this.height,cm=this.doc.cm,line=this.line;this.height=null;var diff=widgetHeight(this)-oldH;if(!diff){return;}updateLineHeight(line,line.height+diff);if(cm){runInOp(cm,function(){cm.curOp.forceUpdate=true;adjustScrollWhenAboveVisible(cm,line,diff);});}};function addLineWidget(doc,handle,node,options){var widget=new LineWidget(doc,node,options);var cm=doc.cm;if(cm&&widget.noHScroll){cm.display.alignWidgets=true;}changeLine(doc,handle,"widget",function(line){var widgets=line.widgets||(line.widgets=[]);if(widget.insertAt==null){widgets.push(widget);}else{widgets.splice(Math.min(widgets.length-1,Math.max(0,widget.insertAt)),0,widget);}widget.line=line;if(cm&&!lineIsHidden(doc,line)){var aboveVisible=_heightAtLine(line)<doc.scrollTop;updateLineHeight(line,line.height+widgetHeight(widget));if(aboveVisible){addToScrollPos(cm,null,widget.height);}cm.curOp.forceUpdate=true;}return true;});return widget;}// TEXTMARKERS
	// Created with markText and setBookmark methods. A TextMarker is a
	// handle that can be used to clear or find a marked position in the
	// document. Line objects hold arrays (markedSpans) containing
	// {from, to, marker} object pointing to such marker objects, and
	// indicating that such a marker is present on that line. Multiple
	// lines may point to the same marker when it spans across lines.
	// The spans will have null for their from/to properties when the
	// marker continues beyond the start/end of the line. Markers have
	// links back to the lines they currently touch.
	// Collapsed markers have unique ids, in order to be able to order
	// them, which is needed for uniquely determining an outer marker
	// when they overlap (they may nest, but not partially overlap).
	var nextMarkerId=0;function TextMarker(doc,type){this.lines=[];this.type=type;this.doc=doc;this.id=++nextMarkerId;}eventMixin(TextMarker);// Clear the marker.
	TextMarker.prototype.clear=function(){var this$1=this;if(this.explicitlyCleared){return;}var cm=this.doc.cm,withOp=cm&&!cm.curOp;if(withOp){startOperation(cm);}if(hasHandler(this,"clear")){var found=this.find();if(found){signalLater(this,"clear",found.from,found.to);}}var min=null,max=null;for(var i=0;i<this.lines.length;++i){var line=this$1.lines[i];var span=getMarkedSpanFor(line.markedSpans,this$1);if(cm&&!this$1.collapsed){regLineChange(cm,lineNo(line),"text");}else if(cm){if(span.to!=null){max=lineNo(line);}if(span.from!=null){min=lineNo(line);}}line.markedSpans=removeMarkedSpan(line.markedSpans,span);if(span.from==null&&this$1.collapsed&&!lineIsHidden(this$1.doc,line)&&cm){updateLineHeight(line,textHeight(cm.display));}}if(cm&&this.collapsed&&!cm.options.lineWrapping){for(var i$1=0;i$1<this.lines.length;++i$1){var visual=visualLine(this$1.lines[i$1]),len=lineLength(visual);if(len>cm.display.maxLineLength){cm.display.maxLine=visual;cm.display.maxLineLength=len;cm.display.maxLineChanged=true;}}}if(min!=null&&cm&&this.collapsed){regChange(cm,min,max+1);}this.lines.length=0;this.explicitlyCleared=true;if(this.atomic&&this.doc.cantEdit){this.doc.cantEdit=false;if(cm){reCheckSelection(cm.doc);}}if(cm){signalLater(cm,"markerCleared",cm,this);}if(withOp){endOperation(cm);}if(this.parent){this.parent.clear();}};// Find the position of the marker in the document. Returns a {from,
	// to} object by default. Side can be passed to get a specific side
	// -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
	// Pos objects returned contain a line object, rather than a line
	// number (used to prevent looking up the same line twice).
	TextMarker.prototype.find=function(side,lineObj){var this$1=this;if(side==null&&this.type=="bookmark"){side=1;}var from,to;for(var i=0;i<this.lines.length;++i){var line=this$1.lines[i];var span=getMarkedSpanFor(line.markedSpans,this$1);if(span.from!=null){from=Pos(lineObj?line:lineNo(line),span.from);if(side==-1){return from;}}if(span.to!=null){to=Pos(lineObj?line:lineNo(line),span.to);if(side==1){return to;}}}return from&&{from:from,to:to};};// Signals that the marker's widget changed, and surrounding layout
	// should be recomputed.
	TextMarker.prototype.changed=function(){var pos=this.find(-1,true),widget=this,cm=this.doc.cm;if(!pos||!cm){return;}runInOp(cm,function(){var line=pos.line,lineN=lineNo(pos.line);var view=findViewForLine(cm,lineN);if(view){clearLineMeasurementCacheFor(view);cm.curOp.selectionChanged=cm.curOp.forceUpdate=true;}cm.curOp.updateMaxLine=true;if(!lineIsHidden(widget.doc,line)&&widget.height!=null){var oldHeight=widget.height;widget.height=null;var dHeight=widgetHeight(widget)-oldHeight;if(dHeight){updateLineHeight(line,line.height+dHeight);}}});};TextMarker.prototype.attachLine=function(line){if(!this.lines.length&&this.doc.cm){var op=this.doc.cm.curOp;if(!op.maybeHiddenMarkers||indexOf(op.maybeHiddenMarkers,this)==-1){(op.maybeUnhiddenMarkers||(op.maybeUnhiddenMarkers=[])).push(this);}}this.lines.push(line);};TextMarker.prototype.detachLine=function(line){this.lines.splice(indexOf(this.lines,line),1);if(!this.lines.length&&this.doc.cm){var op=this.doc.cm.curOp;(op.maybeHiddenMarkers||(op.maybeHiddenMarkers=[])).push(this);}};// Create a marker, wire it up to the right lines, and
	function _markText(doc,from,to,options,type){// Shared markers (across linked documents) are handled separately
	// (markTextShared will call out to this again, once per
	// document).
	if(options&&options.shared){return markTextShared(doc,from,to,options,type);}// Ensure we are in an operation.
	if(doc.cm&&!doc.cm.curOp){return operation(doc.cm,_markText)(doc,from,to,options,type);}var marker=new TextMarker(doc,type),diff=cmp(from,to);if(options){copyObj(options,marker,false);}// Don't connect empty markers unless clearWhenEmpty is false
	if(diff>0||diff==0&&marker.clearWhenEmpty!==false){return marker;}if(marker.replacedWith){// Showing up as a widget implies collapsed (widget replaces text)
	marker.collapsed=true;marker.widgetNode=elt("span",[marker.replacedWith],"CodeMirror-widget");if(!options.handleMouseEvents){marker.widgetNode.setAttribute("cm-ignore-events","true");}if(options.insertLeft){marker.widgetNode.insertLeft=true;}}if(marker.collapsed){if(conflictingCollapsedRange(doc,from.line,from,to,marker)||from.line!=to.line&&conflictingCollapsedRange(doc,to.line,from,to,marker)){throw new Error("Inserting collapsed marker partially overlapping an existing one");}seeCollapsedSpans();}if(marker.addToHistory){addChangeToHistory(doc,{from:from,to:to,origin:"markText"},doc.sel,NaN);}var curLine=from.line,cm=doc.cm,updateMaxLine;doc.iter(curLine,to.line+1,function(line){if(cm&&marker.collapsed&&!cm.options.lineWrapping&&visualLine(line)==cm.display.maxLine){updateMaxLine=true;}if(marker.collapsed&&curLine!=from.line){updateLineHeight(line,0);}addMarkedSpan(line,new MarkedSpan(marker,curLine==from.line?from.ch:null,curLine==to.line?to.ch:null));++curLine;});// lineIsHidden depends on the presence of the spans, so needs a second pass
	if(marker.collapsed){doc.iter(from.line,to.line+1,function(line){if(lineIsHidden(doc,line)){updateLineHeight(line,0);}});}if(marker.clearOnEnter){on(marker,"beforeCursorEnter",function(){return marker.clear();});}if(marker.readOnly){seeReadOnlySpans();if(doc.history.done.length||doc.history.undone.length){doc.clearHistory();}}if(marker.collapsed){marker.id=++nextMarkerId;marker.atomic=true;}if(cm){// Sync editor state
	if(updateMaxLine){cm.curOp.updateMaxLine=true;}if(marker.collapsed){regChange(cm,from.line,to.line+1);}else if(marker.className||marker.title||marker.startStyle||marker.endStyle||marker.css){for(var i=from.line;i<=to.line;i++){regLineChange(cm,i,"text");}}if(marker.atomic){reCheckSelection(cm.doc);}signalLater(cm,"markerAdded",cm,marker);}return marker;}// SHARED TEXTMARKERS
	// A shared marker spans multiple linked documents. It is
	// implemented as a meta-marker-object controlling multiple normal
	// markers.
	function SharedTextMarker(markers,primary){var this$1=this;this.markers=markers;this.primary=primary;for(var i=0;i<markers.length;++i){markers[i].parent=this$1;}}eventMixin(SharedTextMarker);SharedTextMarker.prototype.clear=function(){var this$1=this;if(this.explicitlyCleared){return;}this.explicitlyCleared=true;for(var i=0;i<this.markers.length;++i){this$1.markers[i].clear();}signalLater(this,"clear");};SharedTextMarker.prototype.find=function(side,lineObj){return this.primary.find(side,lineObj);};function markTextShared(doc,from,to,options,type){options=copyObj(options);options.shared=false;var markers=[_markText(doc,from,to,options,type)],primary=markers[0];var widget=options.widgetNode;linkedDocs(doc,function(doc){if(widget){options.widgetNode=widget.cloneNode(true);}markers.push(_markText(doc,_clipPos(doc,from),_clipPos(doc,to),options,type));for(var i=0;i<doc.linked.length;++i){if(doc.linked[i].isParent){return;}}primary=lst(markers);});return new SharedTextMarker(markers,primary);}function findSharedMarkers(doc){return doc.findMarks(Pos(doc.first,0),doc.clipPos(Pos(doc.lastLine())),function(m){return m.parent;});}function copySharedMarkers(doc,markers){for(var i=0;i<markers.length;i++){var marker=markers[i],pos=marker.find();var mFrom=doc.clipPos(pos.from),mTo=doc.clipPos(pos.to);if(cmp(mFrom,mTo)){var subMark=_markText(doc,mFrom,mTo,marker.primary,marker.primary.type);marker.markers.push(subMark);subMark.parent=marker;}}}function detachSharedMarkers(markers){var loop=function loop(i){var marker=markers[i],linked=[marker.primary.doc];linkedDocs(marker.primary.doc,function(d){return linked.push(d);});for(var j=0;j<marker.markers.length;j++){var subMarker=marker.markers[j];if(indexOf(linked,subMarker.doc)==-1){subMarker.parent=null;marker.markers.splice(j--,1);}}};for(var i=0;i<markers.length;i++){loop(i);}}var nextDocId=0;var Doc=function Doc(text,mode,firstLine,lineSep){if(!(this instanceof Doc)){return new Doc(text,mode,firstLine,lineSep);}if(firstLine==null){firstLine=0;}BranchChunk.call(this,[new LeafChunk([new Line("",null)])]);this.first=firstLine;this.scrollTop=this.scrollLeft=0;this.cantEdit=false;this.cleanGeneration=1;this.frontier=firstLine;var start=Pos(firstLine,0);this.sel=simpleSelection(start);this.history=new History(null);this.id=++nextDocId;this.modeOption=mode;this.lineSep=lineSep;this.extend=false;if(typeof text=="string"){text=this.splitLines(text);}updateDoc(this,{from:start,to:start,text:text});setSelection(this,simpleSelection(start),sel_dontScroll);};Doc.prototype=createObj(BranchChunk.prototype,{constructor:Doc,// Iterate over the document. Supports two forms -- with only one
	// argument, it calls that for each line in the document. With
	// three, it iterates over the range given by the first two (with
	// the second being non-inclusive).
	iter:function iter(from,to,op){if(op){this.iterN(from-this.first,to-from,op);}else{this.iterN(this.first,this.first+this.size,from);}},// Non-public interface for adding and removing lines.
	insert:function insert(at,lines){var height=0;for(var i=0;i<lines.length;++i){height+=lines[i].height;}this.insertInner(at-this.first,lines,height);},remove:function remove(at,n){this.removeInner(at-this.first,n);},// From here, the methods are part of the public interface. Most
	// are also available from CodeMirror (editor) instances.
	getValue:function getValue(lineSep){var lines=getLines(this,this.first,this.first+this.size);if(lineSep===false){return lines;}return lines.join(lineSep||this.lineSeparator());},setValue:docMethodOp(function(code){var top=Pos(this.first,0),last=this.first+this.size-1;makeChange(this,{from:top,to:Pos(last,getLine(this,last).text.length),text:this.splitLines(code),origin:"setValue",full:true},true);setSelection(this,simpleSelection(top));}),replaceRange:function replaceRange(code,from,to,origin){from=_clipPos(this,from);to=to?_clipPos(this,to):from;_replaceRange(this,code,from,to,origin);},getRange:function getRange(from,to,lineSep){var lines=getBetween(this,_clipPos(this,from),_clipPos(this,to));if(lineSep===false){return lines;}return lines.join(lineSep||this.lineSeparator());},getLine:function getLine(line){var l=this.getLineHandle(line);return l&&l.text;},getLineHandle:function getLineHandle(line){if(isLine(this,line)){return getLine(this,line);}},getLineNumber:function getLineNumber(line){return lineNo(line);},getLineHandleVisualStart:function getLineHandleVisualStart(line){if(typeof line=="number"){line=getLine(this,line);}return visualLine(line);},lineCount:function lineCount(){return this.size;},firstLine:function firstLine(){return this.first;},lastLine:function lastLine(){return this.first+this.size-1;},clipPos:function clipPos(pos){return _clipPos(this,pos);},getCursor:function getCursor(start){var range=this.sel.primary(),pos;if(start==null||start=="head"){pos=range.head;}else if(start=="anchor"){pos=range.anchor;}else if(start=="end"||start=="to"||start===false){pos=range.to();}else{pos=range.from();}return pos;},listSelections:function listSelections(){return this.sel.ranges;},somethingSelected:function somethingSelected(){return this.sel.somethingSelected();},setCursor:docMethodOp(function(line,ch,options){setSimpleSelection(this,_clipPos(this,typeof line=="number"?Pos(line,ch||0):line),null,options);}),setSelection:docMethodOp(function(anchor,head,options){setSimpleSelection(this,_clipPos(this,anchor),_clipPos(this,head||anchor),options);}),extendSelection:docMethodOp(function(head,other,options){extendSelection(this,_clipPos(this,head),other&&_clipPos(this,other),options);}),extendSelections:docMethodOp(function(heads,options){extendSelections(this,clipPosArray(this,heads),options);}),extendSelectionsBy:docMethodOp(function(f,options){var heads=map(this.sel.ranges,f);extendSelections(this,clipPosArray(this,heads),options);}),setSelections:docMethodOp(function(ranges,primary,options){var this$1=this;if(!ranges.length){return;}var out=[];for(var i=0;i<ranges.length;i++){out[i]=new Range(_clipPos(this$1,ranges[i].anchor),_clipPos(this$1,ranges[i].head));}if(primary==null){primary=Math.min(ranges.length-1,this.sel.primIndex);}setSelection(this,normalizeSelection(out,primary),options);}),addSelection:docMethodOp(function(anchor,head,options){var ranges=this.sel.ranges.slice(0);ranges.push(new Range(_clipPos(this,anchor),_clipPos(this,head||anchor)));setSelection(this,normalizeSelection(ranges,ranges.length-1),options);}),getSelection:function getSelection(lineSep){var this$1=this;var ranges=this.sel.ranges,lines;for(var i=0;i<ranges.length;i++){var sel=getBetween(this$1,ranges[i].from(),ranges[i].to());lines=lines?lines.concat(sel):sel;}if(lineSep===false){return lines;}else{return lines.join(lineSep||this.lineSeparator());}},getSelections:function getSelections(lineSep){var this$1=this;var parts=[],ranges=this.sel.ranges;for(var i=0;i<ranges.length;i++){var sel=getBetween(this$1,ranges[i].from(),ranges[i].to());if(lineSep!==false){sel=sel.join(lineSep||this$1.lineSeparator());}parts[i]=sel;}return parts;},replaceSelection:function replaceSelection(code,collapse,origin){var dup=[];for(var i=0;i<this.sel.ranges.length;i++){dup[i]=code;}this.replaceSelections(dup,collapse,origin||"+input");},replaceSelections:docMethodOp(function(code,collapse,origin){var this$1=this;var changes=[],sel=this.sel;for(var i=0;i<sel.ranges.length;i++){var range=sel.ranges[i];changes[i]={from:range.from(),to:range.to(),text:this$1.splitLines(code[i]),origin:origin};}var newSel=collapse&&collapse!="end"&&computeReplacedSel(this,changes,collapse);for(var i$1=changes.length-1;i$1>=0;i$1--){makeChange(this$1,changes[i$1]);}if(newSel){setSelectionReplaceHistory(this,newSel);}else if(this.cm){ensureCursorVisible(this.cm);}}),undo:docMethodOp(function(){makeChangeFromHistory(this,"undo");}),redo:docMethodOp(function(){makeChangeFromHistory(this,"redo");}),undoSelection:docMethodOp(function(){makeChangeFromHistory(this,"undo",true);}),redoSelection:docMethodOp(function(){makeChangeFromHistory(this,"redo",true);}),setExtending:function setExtending(val){this.extend=val;},getExtending:function getExtending(){return this.extend;},historySize:function historySize(){var hist=this.history,done=0,undone=0;for(var i=0;i<hist.done.length;i++){if(!hist.done[i].ranges){++done;}}for(var i$1=0;i$1<hist.undone.length;i$1++){if(!hist.undone[i$1].ranges){++undone;}}return{undo:done,redo:undone};},clearHistory:function clearHistory(){this.history=new History(this.history.maxGeneration);},markClean:function markClean(){this.cleanGeneration=this.changeGeneration(true);},changeGeneration:function changeGeneration(forceSplit){if(forceSplit){this.history.lastOp=this.history.lastSelOp=this.history.lastOrigin=null;}return this.history.generation;},isClean:function isClean(gen){return this.history.generation==(gen||this.cleanGeneration);},getHistory:function getHistory(){return{done:copyHistoryArray(this.history.done),undone:copyHistoryArray(this.history.undone)};},setHistory:function setHistory(histData){var hist=this.history=new History(this.history.maxGeneration);hist.done=copyHistoryArray(histData.done.slice(0),null,true);hist.undone=copyHistoryArray(histData.undone.slice(0),null,true);},setGutterMarker:docMethodOp(function(line,gutterID,value){return changeLine(this,line,"gutter",function(line){var markers=line.gutterMarkers||(line.gutterMarkers={});markers[gutterID]=value;if(!value&&isEmpty(markers)){line.gutterMarkers=null;}return true;});}),clearGutter:docMethodOp(function(gutterID){var this$1=this;var i=this.first;this.iter(function(line){if(line.gutterMarkers&&line.gutterMarkers[gutterID]){changeLine(this$1,line,"gutter",function(){line.gutterMarkers[gutterID]=null;if(isEmpty(line.gutterMarkers)){line.gutterMarkers=null;}return true;});}++i;});}),lineInfo:function lineInfo(line){var n;if(typeof line=="number"){if(!isLine(this,line)){return null;}n=line;line=getLine(this,line);if(!line){return null;}}else{n=lineNo(line);if(n==null){return null;}}return{line:n,handle:line,text:line.text,gutterMarkers:line.gutterMarkers,textClass:line.textClass,bgClass:line.bgClass,wrapClass:line.wrapClass,widgets:line.widgets};},addLineClass:docMethodOp(function(handle,where,cls){return changeLine(this,handle,where=="gutter"?"gutter":"class",function(line){var prop=where=="text"?"textClass":where=="background"?"bgClass":where=="gutter"?"gutterClass":"wrapClass";if(!line[prop]){line[prop]=cls;}else if(classTest(cls).test(line[prop])){return false;}else{line[prop]+=" "+cls;}return true;});}),removeLineClass:docMethodOp(function(handle,where,cls){return changeLine(this,handle,where=="gutter"?"gutter":"class",function(line){var prop=where=="text"?"textClass":where=="background"?"bgClass":where=="gutter"?"gutterClass":"wrapClass";var cur=line[prop];if(!cur){return false;}else if(cls==null){line[prop]=null;}else{var found=cur.match(classTest(cls));if(!found){return false;}var end=found.index+found[0].length;line[prop]=cur.slice(0,found.index)+(!found.index||end==cur.length?"":" ")+cur.slice(end)||null;}return true;});}),addLineWidget:docMethodOp(function(handle,node,options){return addLineWidget(this,handle,node,options);}),removeLineWidget:function removeLineWidget(widget){widget.clear();},markText:function markText(from,to,options){return _markText(this,_clipPos(this,from),_clipPos(this,to),options,options&&options.type||"range");},setBookmark:function setBookmark(pos,options){var realOpts={replacedWith:options&&(options.nodeType==null?options.widget:options),insertLeft:options&&options.insertLeft,clearWhenEmpty:false,shared:options&&options.shared,handleMouseEvents:options&&options.handleMouseEvents};pos=_clipPos(this,pos);return _markText(this,pos,pos,realOpts,"bookmark");},findMarksAt:function findMarksAt(pos){pos=_clipPos(this,pos);var markers=[],spans=getLine(this,pos.line).markedSpans;if(spans){for(var i=0;i<spans.length;++i){var span=spans[i];if((span.from==null||span.from<=pos.ch)&&(span.to==null||span.to>=pos.ch)){markers.push(span.marker.parent||span.marker);}}}return markers;},findMarks:function findMarks(from,to,filter){from=_clipPos(this,from);to=_clipPos(this,to);var found=[],lineNo=from.line;this.iter(from.line,to.line+1,function(line){var spans=line.markedSpans;if(spans){for(var i=0;i<spans.length;i++){var span=spans[i];if(!(span.to!=null&&lineNo==from.line&&from.ch>=span.to||span.from==null&&lineNo!=from.line||span.from!=null&&lineNo==to.line&&span.from>=to.ch)&&(!filter||filter(span.marker))){found.push(span.marker.parent||span.marker);}}}++lineNo;});return found;},getAllMarks:function getAllMarks(){var markers=[];this.iter(function(line){var sps=line.markedSpans;if(sps){for(var i=0;i<sps.length;++i){if(sps[i].from!=null){markers.push(sps[i].marker);}}}});return markers;},posFromIndex:function posFromIndex(off){var ch,lineNo=this.first,sepSize=this.lineSeparator().length;this.iter(function(line){var sz=line.text.length+sepSize;if(sz>off){ch=off;return true;}off-=sz;++lineNo;});return _clipPos(this,Pos(lineNo,ch));},indexFromPos:function indexFromPos(coords){coords=_clipPos(this,coords);var index=coords.ch;if(coords.line<this.first||coords.ch<0){return 0;}var sepSize=this.lineSeparator().length;this.iter(this.first,coords.line,function(line){// iter aborts when callback returns a truthy value
	index+=line.text.length+sepSize;});return index;},copy:function copy(copyHistory){var doc=new Doc(getLines(this,this.first,this.first+this.size),this.modeOption,this.first,this.lineSep);doc.scrollTop=this.scrollTop;doc.scrollLeft=this.scrollLeft;doc.sel=this.sel;doc.extend=false;if(copyHistory){doc.history.undoDepth=this.history.undoDepth;doc.setHistory(this.getHistory());}return doc;},linkedDoc:function linkedDoc(options){if(!options){options={};}var from=this.first,to=this.first+this.size;if(options.from!=null&&options.from>from){from=options.from;}if(options.to!=null&&options.to<to){to=options.to;}var copy=new Doc(getLines(this,from,to),options.mode||this.modeOption,from,this.lineSep);if(options.sharedHist){copy.history=this.history;}(this.linked||(this.linked=[])).push({doc:copy,sharedHist:options.sharedHist});copy.linked=[{doc:this,isParent:true,sharedHist:options.sharedHist}];copySharedMarkers(copy,findSharedMarkers(this));return copy;},unlinkDoc:function unlinkDoc(other){var this$1=this;if(other instanceof CodeMirror){other=other.doc;}if(this.linked){for(var i=0;i<this.linked.length;++i){var link=this$1.linked[i];if(link.doc!=other){continue;}this$1.linked.splice(i,1);other.unlinkDoc(this$1);detachSharedMarkers(findSharedMarkers(this$1));break;}}// If the histories were shared, split them again
	if(other.history==this.history){var splitIds=[other.id];linkedDocs(other,function(doc){return splitIds.push(doc.id);},true);other.history=new History(null);other.history.done=copyHistoryArray(this.history.done,splitIds);other.history.undone=copyHistoryArray(this.history.undone,splitIds);}},iterLinkedDocs:function iterLinkedDocs(f){linkedDocs(this,f);},getMode:function getMode(){return this.mode;},getEditor:function getEditor(){return this.cm;},splitLines:function splitLines(str){if(this.lineSep){return str.split(this.lineSep);}return splitLinesAuto(str);},lineSeparator:function lineSeparator(){return this.lineSep||"\n";}});// Public alias.
	Doc.prototype.eachLine=Doc.prototype.iter;// Kludge to work around strange IE behavior where it'll sometimes
	// re-fire a series of drag-related events right after the drop (#1551)
	var lastDrop=0;function onDrop(e){var cm=this;clearDragCursor(cm);if(signalDOMEvent(cm,e)||eventInWidget(cm.display,e)){return;}e_preventDefault(e);if(ie){lastDrop=+new Date();}var pos=posFromMouse(cm,e,true),files=e.dataTransfer.files;if(!pos||cm.isReadOnly()){return;}// Might be a file drop, in which case we simply extract the text
	// and insert it.
	if(files&&files.length&&window.FileReader&&window.File){var n=files.length,text=Array(n),read=0;var loadFile=function loadFile(file,i){if(cm.options.allowDropFileTypes&&indexOf(cm.options.allowDropFileTypes,file.type)==-1){return;}var reader=new FileReader();reader.onload=operation(cm,function(){var content=reader.result;if(/[\x00-\x08\x0e-\x1f]{2}/.test(content)){content="";}text[i]=content;if(++read==n){pos=_clipPos(cm.doc,pos);var change={from:pos,to:pos,text:cm.doc.splitLines(text.join(cm.doc.lineSeparator())),origin:"paste"};makeChange(cm.doc,change);setSelectionReplaceHistory(cm.doc,simpleSelection(pos,changeEnd(change)));}});reader.readAsText(file);};for(var i=0;i<n;++i){loadFile(files[i],i);}}else{// Normal drop
	// Don't do a replace if the drop happened inside of the selected text.
	if(cm.state.draggingText&&cm.doc.sel.contains(pos)>-1){cm.state.draggingText(e);// Ensure the editor is re-focused
	setTimeout(function(){return cm.display.input.focus();},20);return;}try{var text$1=e.dataTransfer.getData("Text");if(text$1){var selected;if(cm.state.draggingText&&!cm.state.draggingText.copy){selected=cm.listSelections();}setSelectionNoUndo(cm.doc,simpleSelection(pos,pos));if(selected){for(var i$1=0;i$1<selected.length;++i$1){_replaceRange(cm.doc,"",selected[i$1].anchor,selected[i$1].head,"drag");}}cm.replaceSelection(text$1,"around","paste");cm.display.input.focus();}}catch(e){}}}function onDragStart(cm,e){if(ie&&(!cm.state.draggingText||+new Date()-lastDrop<100)){e_stop(e);return;}if(signalDOMEvent(cm,e)||eventInWidget(cm.display,e)){return;}e.dataTransfer.setData("Text",cm.getSelection());e.dataTransfer.effectAllowed="copyMove";// Use dummy image instead of default browsers image.
	// Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
	if(e.dataTransfer.setDragImage&&!safari){var img=elt("img",null,null,"position: fixed; left: 0; top: 0;");img.src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";if(presto){img.width=img.height=1;cm.display.wrapper.appendChild(img);// Force a relayout, or Opera won't use our image for some obscure reason
	img._top=img.offsetTop;}e.dataTransfer.setDragImage(img,0,0);if(presto){img.parentNode.removeChild(img);}}}function onDragOver(cm,e){var pos=posFromMouse(cm,e);if(!pos){return;}var frag=document.createDocumentFragment();drawSelectionCursor(cm,pos,frag);if(!cm.display.dragCursor){cm.display.dragCursor=elt("div",null,"CodeMirror-cursors CodeMirror-dragcursors");cm.display.lineSpace.insertBefore(cm.display.dragCursor,cm.display.cursorDiv);}removeChildrenAndAdd(cm.display.dragCursor,frag);}function clearDragCursor(cm){if(cm.display.dragCursor){cm.display.lineSpace.removeChild(cm.display.dragCursor);cm.display.dragCursor=null;}}// These must be handled carefully, because naively registering a
	// handler for each editor will cause the editors to never be
	// garbage collected.
	function forEachCodeMirror(f){if(!document.body.getElementsByClassName){return;}var byClass=document.body.getElementsByClassName("CodeMirror");for(var i=0;i<byClass.length;i++){var cm=byClass[i].CodeMirror;if(cm){f(cm);}}}var globalsRegistered=false;function ensureGlobalHandlers(){if(globalsRegistered){return;}registerGlobalHandlers();globalsRegistered=true;}function registerGlobalHandlers(){// When the window resizes, we need to refresh active editors.
	var resizeTimer;on(window,"resize",function(){if(resizeTimer==null){resizeTimer=setTimeout(function(){resizeTimer=null;forEachCodeMirror(onResize);},100);}});// When the window loses focus, we want to show the editor as blurred
	on(window,"blur",function(){return forEachCodeMirror(onBlur);});}// Called when the window resizes
	function onResize(cm){var d=cm.display;if(d.lastWrapHeight==d.wrapper.clientHeight&&d.lastWrapWidth==d.wrapper.clientWidth){return;}// Might be a text scaling operation, clear size caches.
	d.cachedCharWidth=d.cachedTextHeight=d.cachedPaddingH=null;d.scrollbarsClipped=false;cm.setSize();}var keyNames={3:"Enter",8:"Backspace",9:"Tab",13:"Enter",16:"Shift",17:"Ctrl",18:"Alt",19:"Pause",20:"CapsLock",27:"Esc",32:"Space",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"Left",38:"Up",39:"Right",40:"Down",44:"PrintScrn",45:"Insert",46:"Delete",59:";",61:"=",91:"Mod",92:"Mod",93:"Mod",106:"*",107:"=",109:"-",110:".",111:"/",127:"Delete",173:"-",186:";",187:"=",188:",",189:"-",190:".",191:"/",192:"`",219:"[",220:"\\",221:"]",222:"'",63232:"Up",63233:"Down",63234:"Left",63235:"Right",63272:"Delete",63273:"Home",63275:"End",63276:"PageUp",63277:"PageDown",63302:"Insert"};// Number keys
	for(var i=0;i<10;i++){keyNames[i+48]=keyNames[i+96]=String(i);}// Alphabetic keys
	for(var i$1=65;i$1<=90;i$1++){keyNames[i$1]=String.fromCharCode(i$1);}// Function keys
	for(var i$2=1;i$2<=12;i$2++){keyNames[i$2+111]=keyNames[i$2+63235]="F"+i$2;}var keyMap={};keyMap.basic={"Left":"goCharLeft","Right":"goCharRight","Up":"goLineUp","Down":"goLineDown","End":"goLineEnd","Home":"goLineStartSmart","PageUp":"goPageUp","PageDown":"goPageDown","Delete":"delCharAfter","Backspace":"delCharBefore","Shift-Backspace":"delCharBefore","Tab":"defaultTab","Shift-Tab":"indentAuto","Enter":"newlineAndIndent","Insert":"toggleOverwrite","Esc":"singleSelection"};// Note that the save and find-related commands aren't defined by
	// default. User code or addons can define them. Unknown commands
	// are simply ignored.
	keyMap.pcDefault={"Ctrl-A":"selectAll","Ctrl-D":"deleteLine","Ctrl-Z":"undo","Shift-Ctrl-Z":"redo","Ctrl-Y":"redo","Ctrl-Home":"goDocStart","Ctrl-End":"goDocEnd","Ctrl-Up":"goLineUp","Ctrl-Down":"goLineDown","Ctrl-Left":"goGroupLeft","Ctrl-Right":"goGroupRight","Alt-Left":"goLineStart","Alt-Right":"goLineEnd","Ctrl-Backspace":"delGroupBefore","Ctrl-Delete":"delGroupAfter","Ctrl-S":"save","Ctrl-F":"find","Ctrl-G":"findNext","Shift-Ctrl-G":"findPrev","Shift-Ctrl-F":"replace","Shift-Ctrl-R":"replaceAll","Ctrl-[":"indentLess","Ctrl-]":"indentMore","Ctrl-U":"undoSelection","Shift-Ctrl-U":"redoSelection","Alt-U":"redoSelection",fallthrough:"basic"};// Very basic readline/emacs-style bindings, which are standard on Mac.
	keyMap.emacsy={"Ctrl-F":"goCharRight","Ctrl-B":"goCharLeft","Ctrl-P":"goLineUp","Ctrl-N":"goLineDown","Alt-F":"goWordRight","Alt-B":"goWordLeft","Ctrl-A":"goLineStart","Ctrl-E":"goLineEnd","Ctrl-V":"goPageDown","Shift-Ctrl-V":"goPageUp","Ctrl-D":"delCharAfter","Ctrl-H":"delCharBefore","Alt-D":"delWordAfter","Alt-Backspace":"delWordBefore","Ctrl-K":"killLine","Ctrl-T":"transposeChars","Ctrl-O":"openLine"};keyMap.macDefault={"Cmd-A":"selectAll","Cmd-D":"deleteLine","Cmd-Z":"undo","Shift-Cmd-Z":"redo","Cmd-Y":"redo","Cmd-Home":"goDocStart","Cmd-Up":"goDocStart","Cmd-End":"goDocEnd","Cmd-Down":"goDocEnd","Alt-Left":"goGroupLeft","Alt-Right":"goGroupRight","Cmd-Left":"goLineLeft","Cmd-Right":"goLineRight","Alt-Backspace":"delGroupBefore","Ctrl-Alt-Backspace":"delGroupAfter","Alt-Delete":"delGroupAfter","Cmd-S":"save","Cmd-F":"find","Cmd-G":"findNext","Shift-Cmd-G":"findPrev","Cmd-Alt-F":"replace","Shift-Cmd-Alt-F":"replaceAll","Cmd-[":"indentLess","Cmd-]":"indentMore","Cmd-Backspace":"delWrappedLineLeft","Cmd-Delete":"delWrappedLineRight","Cmd-U":"undoSelection","Shift-Cmd-U":"redoSelection","Ctrl-Up":"goDocStart","Ctrl-Down":"goDocEnd",fallthrough:["basic","emacsy"]};keyMap["default"]=mac?keyMap.macDefault:keyMap.pcDefault;// KEYMAP DISPATCH
	function normalizeKeyName(name){var parts=name.split(/-(?!$)/);name=parts[parts.length-1];var alt,ctrl,shift,cmd;for(var i=0;i<parts.length-1;i++){var mod=parts[i];if(/^(cmd|meta|m)$/i.test(mod)){cmd=true;}else if(/^a(lt)?$/i.test(mod)){alt=true;}else if(/^(c|ctrl|control)$/i.test(mod)){ctrl=true;}else if(/^s(hift)?$/i.test(mod)){shift=true;}else{throw new Error("Unrecognized modifier name: "+mod);}}if(alt){name="Alt-"+name;}if(ctrl){name="Ctrl-"+name;}if(cmd){name="Cmd-"+name;}if(shift){name="Shift-"+name;}return name;}// This is a kludge to keep keymaps mostly working as raw objects
	// (backwards compatibility) while at the same time support features
	// like normalization and multi-stroke key bindings. It compiles a
	// new normalized keymap, and then updates the old object to reflect
	// this.
	function normalizeKeyMap(keymap){var copy={};for(var keyname in keymap){if(keymap.hasOwnProperty(keyname)){var value=keymap[keyname];if(/^(name|fallthrough|(de|at)tach)$/.test(keyname)){continue;}if(value=="..."){delete keymap[keyname];continue;}var keys=map(keyname.split(" "),normalizeKeyName);for(var i=0;i<keys.length;i++){var val=void 0,name=void 0;if(i==keys.length-1){name=keys.join(" ");val=value;}else{name=keys.slice(0,i+1).join(" ");val="...";}var prev=copy[name];if(!prev){copy[name]=val;}else if(prev!=val){throw new Error("Inconsistent bindings for "+name);}}delete keymap[keyname];}}for(var prop in copy){keymap[prop]=copy[prop];}return keymap;}function lookupKey(key,map,handle,context){map=getKeyMap(map);var found=map.call?map.call(key,context):map[key];if(found===false){return"nothing";}if(found==="..."){return"multi";}if(found!=null&&handle(found)){return"handled";}if(map.fallthrough){if(Object.prototype.toString.call(map.fallthrough)!="[object Array]"){return lookupKey(key,map.fallthrough,handle,context);}for(var i=0;i<map.fallthrough.length;i++){var result=lookupKey(key,map.fallthrough[i],handle,context);if(result){return result;}}}}// Modifier key presses don't count as 'real' key presses for the
	// purpose of keymap fallthrough.
	function isModifierKey(value){var name=typeof value=="string"?value:keyNames[value.keyCode];return name=="Ctrl"||name=="Alt"||name=="Shift"||name=="Mod";}// Look up the name of a key as indicated by an event object.
	function keyName(event,noShift){if(presto&&event.keyCode==34&&event["char"]){return false;}var base=keyNames[event.keyCode],name=base;if(name==null||event.altGraphKey){return false;}if(event.altKey&&base!="Alt"){name="Alt-"+name;}if((flipCtrlCmd?event.metaKey:event.ctrlKey)&&base!="Ctrl"){name="Ctrl-"+name;}if((flipCtrlCmd?event.ctrlKey:event.metaKey)&&base!="Cmd"){name="Cmd-"+name;}if(!noShift&&event.shiftKey&&base!="Shift"){name="Shift-"+name;}return name;}function getKeyMap(val){return typeof val=="string"?keyMap[val]:val;}// Helper for deleting text near the selection(s), used to implement
	// backspace, delete, and similar functionality.
	function deleteNearSelection(cm,compute){var ranges=cm.doc.sel.ranges,kill=[];// Build up a set of ranges to kill first, merging overlapping
	// ranges.
	for(var i=0;i<ranges.length;i++){var toKill=compute(ranges[i]);while(kill.length&&cmp(toKill.from,lst(kill).to)<=0){var replaced=kill.pop();if(cmp(replaced.from,toKill.from)<0){toKill.from=replaced.from;break;}}kill.push(toKill);}// Next, remove those actual ranges.
	runInOp(cm,function(){for(var i=kill.length-1;i>=0;i--){_replaceRange(cm.doc,"",kill[i].from,kill[i].to,"+delete");}ensureCursorVisible(cm);});}// Commands are parameter-less actions that can be performed on an
	// editor, mostly used for keybindings.
	var commands={selectAll:selectAll,singleSelection:function singleSelection(cm){return cm.setSelection(cm.getCursor("anchor"),cm.getCursor("head"),sel_dontScroll);},killLine:function killLine(cm){return deleteNearSelection(cm,function(range){if(range.empty()){var len=getLine(cm.doc,range.head.line).text.length;if(range.head.ch==len&&range.head.line<cm.lastLine()){return{from:range.head,to:Pos(range.head.line+1,0)};}else{return{from:range.head,to:Pos(range.head.line,len)};}}else{return{from:range.from(),to:range.to()};}});},deleteLine:function deleteLine(cm){return deleteNearSelection(cm,function(range){return{from:Pos(range.from().line,0),to:_clipPos(cm.doc,Pos(range.to().line+1,0))};});},delLineLeft:function delLineLeft(cm){return deleteNearSelection(cm,function(range){return{from:Pos(range.from().line,0),to:range.from()};});},delWrappedLineLeft:function delWrappedLineLeft(cm){return deleteNearSelection(cm,function(range){var top=cm.charCoords(range.head,"div").top+5;var leftPos=cm.coordsChar({left:0,top:top},"div");return{from:leftPos,to:range.from()};});},delWrappedLineRight:function delWrappedLineRight(cm){return deleteNearSelection(cm,function(range){var top=cm.charCoords(range.head,"div").top+5;var rightPos=cm.coordsChar({left:cm.display.lineDiv.offsetWidth+100,top:top},"div");return{from:range.from(),to:rightPos};});},undo:function undo(cm){return cm.undo();},redo:function redo(cm){return cm.redo();},undoSelection:function undoSelection(cm){return cm.undoSelection();},redoSelection:function redoSelection(cm){return cm.redoSelection();},goDocStart:function goDocStart(cm){return cm.extendSelection(Pos(cm.firstLine(),0));},goDocEnd:function goDocEnd(cm){return cm.extendSelection(Pos(cm.lastLine()));},goLineStart:function goLineStart(cm){return cm.extendSelectionsBy(function(range){return lineStart(cm,range.head.line);},{origin:"+move",bias:1});},goLineStartSmart:function goLineStartSmart(cm){return cm.extendSelectionsBy(function(range){return lineStartSmart(cm,range.head);},{origin:"+move",bias:1});},goLineEnd:function goLineEnd(cm){return cm.extendSelectionsBy(function(range){return lineEnd(cm,range.head.line);},{origin:"+move",bias:-1});},goLineRight:function goLineRight(cm){return cm.extendSelectionsBy(function(range){var top=cm.charCoords(range.head,"div").top+5;return cm.coordsChar({left:cm.display.lineDiv.offsetWidth+100,top:top},"div");},sel_move);},goLineLeft:function goLineLeft(cm){return cm.extendSelectionsBy(function(range){var top=cm.charCoords(range.head,"div").top+5;return cm.coordsChar({left:0,top:top},"div");},sel_move);},goLineLeftSmart:function goLineLeftSmart(cm){return cm.extendSelectionsBy(function(range){var top=cm.charCoords(range.head,"div").top+5;var pos=cm.coordsChar({left:0,top:top},"div");if(pos.ch<cm.getLine(pos.line).search(/\S/)){return lineStartSmart(cm,range.head);}return pos;},sel_move);},goLineUp:function goLineUp(cm){return cm.moveV(-1,"line");},goLineDown:function goLineDown(cm){return cm.moveV(1,"line");},goPageUp:function goPageUp(cm){return cm.moveV(-1,"page");},goPageDown:function goPageDown(cm){return cm.moveV(1,"page");},goCharLeft:function goCharLeft(cm){return cm.moveH(-1,"char");},goCharRight:function goCharRight(cm){return cm.moveH(1,"char");},goColumnLeft:function goColumnLeft(cm){return cm.moveH(-1,"column");},goColumnRight:function goColumnRight(cm){return cm.moveH(1,"column");},goWordLeft:function goWordLeft(cm){return cm.moveH(-1,"word");},goGroupRight:function goGroupRight(cm){return cm.moveH(1,"group");},goGroupLeft:function goGroupLeft(cm){return cm.moveH(-1,"group");},goWordRight:function goWordRight(cm){return cm.moveH(1,"word");},delCharBefore:function delCharBefore(cm){return cm.deleteH(-1,"char");},delCharAfter:function delCharAfter(cm){return cm.deleteH(1,"char");},delWordBefore:function delWordBefore(cm){return cm.deleteH(-1,"word");},delWordAfter:function delWordAfter(cm){return cm.deleteH(1,"word");},delGroupBefore:function delGroupBefore(cm){return cm.deleteH(-1,"group");},delGroupAfter:function delGroupAfter(cm){return cm.deleteH(1,"group");},indentAuto:function indentAuto(cm){return cm.indentSelection("smart");},indentMore:function indentMore(cm){return cm.indentSelection("add");},indentLess:function indentLess(cm){return cm.indentSelection("subtract");},insertTab:function insertTab(cm){return cm.replaceSelection("\t");},insertSoftTab:function insertSoftTab(cm){var spaces=[],ranges=cm.listSelections(),tabSize=cm.options.tabSize;for(var i=0;i<ranges.length;i++){var pos=ranges[i].from();var col=countColumn(cm.getLine(pos.line),pos.ch,tabSize);spaces.push(spaceStr(tabSize-col%tabSize));}cm.replaceSelections(spaces);},defaultTab:function defaultTab(cm){if(cm.somethingSelected()){cm.indentSelection("add");}else{cm.execCommand("insertTab");}},// Swap the two chars left and right of each selection's head.
	// Move cursor behind the two swapped characters afterwards.
	//
	// Doesn't consider line feeds a character.
	// Doesn't scan more than one line above to find a character.
	// Doesn't do anything on an empty line.
	// Doesn't do anything with non-empty selections.
	transposeChars:function transposeChars(cm){return runInOp(cm,function(){var ranges=cm.listSelections(),newSel=[];for(var i=0;i<ranges.length;i++){if(!ranges[i].empty()){continue;}var cur=ranges[i].head,line=getLine(cm.doc,cur.line).text;if(line){if(cur.ch==line.length){cur=new Pos(cur.line,cur.ch-1);}if(cur.ch>0){cur=new Pos(cur.line,cur.ch+1);cm.replaceRange(line.charAt(cur.ch-1)+line.charAt(cur.ch-2),Pos(cur.line,cur.ch-2),cur,"+transpose");}else if(cur.line>cm.doc.first){var prev=getLine(cm.doc,cur.line-1).text;if(prev){cur=new Pos(cur.line,1);cm.replaceRange(line.charAt(0)+cm.doc.lineSeparator()+prev.charAt(prev.length-1),Pos(cur.line-1,prev.length-1),cur,"+transpose");}}}newSel.push(new Range(cur,cur));}cm.setSelections(newSel);});},newlineAndIndent:function newlineAndIndent(cm){return runInOp(cm,function(){var sels=cm.listSelections();for(var i=sels.length-1;i>=0;i--){cm.replaceRange(cm.doc.lineSeparator(),sels[i].anchor,sels[i].head,"+input");}sels=cm.listSelections();for(var i$1=0;i$1<sels.length;i$1++){cm.indentLine(sels[i$1].from().line,null,true);}ensureCursorVisible(cm);});},openLine:function openLine(cm){return cm.replaceSelection("\n","start");},toggleOverwrite:function toggleOverwrite(cm){return cm.toggleOverwrite();}};function lineStart(cm,lineN){var line=getLine(cm.doc,lineN);var visual=visualLine(line);if(visual!=line){lineN=lineNo(visual);}var order=getOrder(visual);var ch=!order?0:order[0].level%2?lineRight(visual):lineLeft(visual);return Pos(lineN,ch);}function lineEnd(cm,lineN){var merged,line=getLine(cm.doc,lineN);while(merged=collapsedSpanAtEnd(line)){line=merged.find(1,true).line;lineN=null;}var order=getOrder(line);var ch=!order?line.text.length:order[0].level%2?lineLeft(line):lineRight(line);return Pos(lineN==null?lineNo(line):lineN,ch);}function lineStartSmart(cm,pos){var start=lineStart(cm,pos.line);var line=getLine(cm.doc,start.line);var order=getOrder(line);if(!order||order[0].level==0){var firstNonWS=Math.max(0,line.text.search(/\S/));var inWS=pos.line==start.line&&pos.ch<=firstNonWS&&pos.ch;return Pos(start.line,inWS?0:firstNonWS);}return start;}// Run a handler that was bound to a key.
	function doHandleBinding(cm,bound,dropShift){if(typeof bound=="string"){bound=commands[bound];if(!bound){return false;}}// Ensure previous input has been read, so that the handler sees a
	// consistent view of the document
	cm.display.input.ensurePolled();var prevShift=cm.display.shift,done=false;try{if(cm.isReadOnly()){cm.state.suppressEdits=true;}if(dropShift){cm.display.shift=false;}done=bound(cm)!=Pass;}finally{cm.display.shift=prevShift;cm.state.suppressEdits=false;}return done;}function lookupKeyForEditor(cm,name,handle){for(var i=0;i<cm.state.keyMaps.length;i++){var result=lookupKey(name,cm.state.keyMaps[i],handle,cm);if(result){return result;}}return cm.options.extraKeys&&lookupKey(name,cm.options.extraKeys,handle,cm)||lookupKey(name,cm.options.keyMap,handle,cm);}var stopSeq=new Delayed();function dispatchKey(cm,name,e,handle){var seq=cm.state.keySeq;if(seq){if(isModifierKey(name)){return"handled";}stopSeq.set(50,function(){if(cm.state.keySeq==seq){cm.state.keySeq=null;cm.display.input.reset();}});name=seq+" "+name;}var result=lookupKeyForEditor(cm,name,handle);if(result=="multi"){cm.state.keySeq=name;}if(result=="handled"){signalLater(cm,"keyHandled",cm,name,e);}if(result=="handled"||result=="multi"){e_preventDefault(e);restartBlink(cm);}if(seq&&!result&&/\'$/.test(name)){e_preventDefault(e);return true;}return!!result;}// Handle a key from the keydown event.
	function handleKeyBinding(cm,e){var name=keyName(e,true);if(!name){return false;}if(e.shiftKey&&!cm.state.keySeq){// First try to resolve full name (including 'Shift-'). Failing
	// that, see if there is a cursor-motion command (starting with
	// 'go') bound to the keyname without 'Shift-'.
	return dispatchKey(cm,"Shift-"+name,e,function(b){return doHandleBinding(cm,b,true);})||dispatchKey(cm,name,e,function(b){if(typeof b=="string"?/^go[A-Z]/.test(b):b.motion){return doHandleBinding(cm,b);}});}else{return dispatchKey(cm,name,e,function(b){return doHandleBinding(cm,b);});}}// Handle a key from the keypress event
	function handleCharBinding(cm,e,ch){return dispatchKey(cm,"'"+ch+"'",e,function(b){return doHandleBinding(cm,b,true);});}var lastStoppedKey=null;function onKeyDown(e){var cm=this;cm.curOp.focus=activeElt();if(signalDOMEvent(cm,e)){return;}// IE does strange things with escape.
	if(ie&&ie_version<11&&e.keyCode==27){e.returnValue=false;}var code=e.keyCode;cm.display.shift=code==16||e.shiftKey;var handled=handleKeyBinding(cm,e);if(presto){lastStoppedKey=handled?code:null;// Opera has no cut event... we try to at least catch the key combo
	if(!handled&&code==88&&!hasCopyEvent&&(mac?e.metaKey:e.ctrlKey)){cm.replaceSelection("",null,"cut");}}// Turn mouse into crosshair when Alt is held on Mac.
	if(code==18&&!/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className)){showCrossHair(cm);}}function showCrossHair(cm){var lineDiv=cm.display.lineDiv;addClass(lineDiv,"CodeMirror-crosshair");function up(e){if(e.keyCode==18||!e.altKey){rmClass(lineDiv,"CodeMirror-crosshair");off(document,"keyup",up);off(document,"mouseover",up);}}on(document,"keyup",up);on(document,"mouseover",up);}function onKeyUp(e){if(e.keyCode==16){this.doc.sel.shift=false;}signalDOMEvent(this,e);}function onKeyPress(e){var cm=this;if(eventInWidget(cm.display,e)||signalDOMEvent(cm,e)||e.ctrlKey&&!e.altKey||mac&&e.metaKey){return;}var keyCode=e.keyCode,charCode=e.charCode;if(presto&&keyCode==lastStoppedKey){lastStoppedKey=null;e_preventDefault(e);return;}if(presto&&(!e.which||e.which<10)&&handleKeyBinding(cm,e)){return;}var ch=String.fromCharCode(charCode==null?keyCode:charCode);// Some browsers fire keypress events for backspace
	if(ch=="\x08"){return;}if(handleCharBinding(cm,e,ch)){return;}cm.display.input.onKeyPress(e);}// A mouse down can be a single click, double click, triple click,
	// start of selection drag, start of text drag, new cursor
	// (ctrl-click), rectangle drag (alt-drag), or xwin
	// middle-click-paste. Or it might be a click on something we should
	// not interfere with, such as a scrollbar or widget.
	function onMouseDown(e){var cm=this,display=cm.display;if(signalDOMEvent(cm,e)||display.activeTouch&&display.input.supportsTouch()){return;}display.input.ensurePolled();display.shift=e.shiftKey;if(eventInWidget(display,e)){if(!webkit){// Briefly turn off draggability, to allow widgets to do
	// normal dragging things.
	display.scroller.draggable=false;setTimeout(function(){return display.scroller.draggable=true;},100);}return;}if(clickInGutter(cm,e)){return;}var start=posFromMouse(cm,e);window.focus();switch(e_button(e)){case 1:// #3261: make sure, that we're not starting a second selection
	if(cm.state.selectingText){cm.state.selectingText(e);}else if(start){leftButtonDown(cm,e,start);}else if(e_target(e)==display.scroller){e_preventDefault(e);}break;case 2:if(webkit){cm.state.lastMiddleDown=+new Date();}if(start){extendSelection(cm.doc,start);}setTimeout(function(){return display.input.focus();},20);e_preventDefault(e);break;case 3:if(captureRightClick){onContextMenu(cm,e);}else{delayBlurEvent(cm);}break;}}var lastClick;var lastDoubleClick;function leftButtonDown(cm,e,start){if(ie){setTimeout(bind(ensureFocus,cm),0);}else{cm.curOp.focus=activeElt();}var now=+new Date(),type;if(lastDoubleClick&&lastDoubleClick.time>now-400&&cmp(lastDoubleClick.pos,start)==0){type="triple";}else if(lastClick&&lastClick.time>now-400&&cmp(lastClick.pos,start)==0){type="double";lastDoubleClick={time:now,pos:start};}else{type="single";lastClick={time:now,pos:start};}var sel=cm.doc.sel,modifier=mac?e.metaKey:e.ctrlKey,contained;if(cm.options.dragDrop&&dragAndDrop&&!cm.isReadOnly()&&type=="single"&&(contained=sel.contains(start))>-1&&(cmp((contained=sel.ranges[contained]).from(),start)<0||start.xRel>0)&&(cmp(contained.to(),start)>0||start.xRel<0)){leftButtonStartDrag(cm,e,start,modifier);}else{leftButtonSelect(cm,e,start,type,modifier);}}// Start a text drag. When it ends, see if any dragging actually
	// happen, and treat as a click if it didn't.
	function leftButtonStartDrag(cm,e,start,modifier){var display=cm.display,startTime=+new Date();var dragEnd=operation(cm,function(e2){if(webkit){display.scroller.draggable=false;}cm.state.draggingText=false;off(document,"mouseup",dragEnd);off(display.scroller,"drop",dragEnd);if(Math.abs(e.clientX-e2.clientX)+Math.abs(e.clientY-e2.clientY)<10){e_preventDefault(e2);if(!modifier&&+new Date()-200<startTime){extendSelection(cm.doc,start);}// Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
	if(webkit||ie&&ie_version==9){setTimeout(function(){document.body.focus();display.input.focus();},20);}else{display.input.focus();}}});// Let the drag handler handle this.
	if(webkit){display.scroller.draggable=true;}cm.state.draggingText=dragEnd;dragEnd.copy=mac?e.altKey:e.ctrlKey;// IE's approach to draggable
	if(display.scroller.dragDrop){display.scroller.dragDrop();}on(document,"mouseup",dragEnd);on(display.scroller,"drop",dragEnd);}// Normal selection, as opposed to text dragging.
	function leftButtonSelect(cm,e,start,type,addNew){var display=cm.display,doc=cm.doc;e_preventDefault(e);var ourRange,ourIndex,startSel=doc.sel,ranges=startSel.ranges;if(addNew&&!e.shiftKey){ourIndex=doc.sel.contains(start);if(ourIndex>-1){ourRange=ranges[ourIndex];}else{ourRange=new Range(start,start);}}else{ourRange=doc.sel.primary();ourIndex=doc.sel.primIndex;}if(chromeOS?e.shiftKey&&e.metaKey:e.altKey){type="rect";if(!addNew){ourRange=new Range(start,start);}start=posFromMouse(cm,e,true,true);ourIndex=-1;}else if(type=="double"){var word=cm.findWordAt(start);if(cm.display.shift||doc.extend){ourRange=extendRange(doc,ourRange,word.anchor,word.head);}else{ourRange=word;}}else if(type=="triple"){var line=new Range(Pos(start.line,0),_clipPos(doc,Pos(start.line+1,0)));if(cm.display.shift||doc.extend){ourRange=extendRange(doc,ourRange,line.anchor,line.head);}else{ourRange=line;}}else{ourRange=extendRange(doc,ourRange,start);}if(!addNew){ourIndex=0;setSelection(doc,new Selection([ourRange],0),sel_mouse);startSel=doc.sel;}else if(ourIndex==-1){ourIndex=ranges.length;setSelection(doc,normalizeSelection(ranges.concat([ourRange]),ourIndex),{scroll:false,origin:"*mouse"});}else if(ranges.length>1&&ranges[ourIndex].empty()&&type=="single"&&!e.shiftKey){setSelection(doc,normalizeSelection(ranges.slice(0,ourIndex).concat(ranges.slice(ourIndex+1)),0),{scroll:false,origin:"*mouse"});startSel=doc.sel;}else{replaceOneSelection(doc,ourIndex,ourRange,sel_mouse);}var lastPos=start;function extendTo(pos){if(cmp(lastPos,pos)==0){return;}lastPos=pos;if(type=="rect"){var ranges=[],tabSize=cm.options.tabSize;var startCol=countColumn(getLine(doc,start.line).text,start.ch,tabSize);var posCol=countColumn(getLine(doc,pos.line).text,pos.ch,tabSize);var left=Math.min(startCol,posCol),right=Math.max(startCol,posCol);for(var line=Math.min(start.line,pos.line),end=Math.min(cm.lastLine(),Math.max(start.line,pos.line));line<=end;line++){var text=getLine(doc,line).text,leftPos=findColumn(text,left,tabSize);if(left==right){ranges.push(new Range(Pos(line,leftPos),Pos(line,leftPos)));}else if(text.length>leftPos){ranges.push(new Range(Pos(line,leftPos),Pos(line,findColumn(text,right,tabSize))));}}if(!ranges.length){ranges.push(new Range(start,start));}setSelection(doc,normalizeSelection(startSel.ranges.slice(0,ourIndex).concat(ranges),ourIndex),{origin:"*mouse",scroll:false});cm.scrollIntoView(pos);}else{var oldRange=ourRange;var anchor=oldRange.anchor,head=pos;if(type!="single"){var range;if(type=="double"){range=cm.findWordAt(pos);}else{range=new Range(Pos(pos.line,0),_clipPos(doc,Pos(pos.line+1,0)));}if(cmp(range.anchor,anchor)>0){head=range.head;anchor=minPos(oldRange.from(),range.anchor);}else{head=range.anchor;anchor=maxPos(oldRange.to(),range.head);}}var ranges$1=startSel.ranges.slice(0);ranges$1[ourIndex]=new Range(_clipPos(doc,anchor),head);setSelection(doc,normalizeSelection(ranges$1,ourIndex),sel_mouse);}}var editorSize=display.wrapper.getBoundingClientRect();// Used to ensure timeout re-tries don't fire when another extend
	// happened in the meantime (clearTimeout isn't reliable -- at
	// least on Chrome, the timeouts still happen even when cleared,
	// if the clear happens after their scheduled firing time).
	var counter=0;function extend(e){var curCount=++counter;var cur=posFromMouse(cm,e,true,type=="rect");if(!cur){return;}if(cmp(cur,lastPos)!=0){cm.curOp.focus=activeElt();extendTo(cur);var visible=visibleLines(display,doc);if(cur.line>=visible.to||cur.line<visible.from){setTimeout(operation(cm,function(){if(counter==curCount){extend(e);}}),150);}}else{var outside=e.clientY<editorSize.top?-20:e.clientY>editorSize.bottom?20:0;if(outside){setTimeout(operation(cm,function(){if(counter!=curCount){return;}display.scroller.scrollTop+=outside;extend(e);}),50);}}}function done(e){cm.state.selectingText=false;counter=Infinity;e_preventDefault(e);display.input.focus();off(document,"mousemove",move);off(document,"mouseup",up);doc.history.lastSelOrigin=null;}var move=operation(cm,function(e){if(!e_button(e)){done(e);}else{extend(e);}});var up=operation(cm,done);cm.state.selectingText=up;on(document,"mousemove",move);on(document,"mouseup",up);}// Determines whether an event happened in the gutter, and fires the
	// handlers for the corresponding event.
	function gutterEvent(cm,e,type,prevent){var mX,mY;try{mX=e.clientX;mY=e.clientY;}catch(e){return false;}if(mX>=Math.floor(cm.display.gutters.getBoundingClientRect().right)){return false;}if(prevent){e_preventDefault(e);}var display=cm.display;var lineBox=display.lineDiv.getBoundingClientRect();if(mY>lineBox.bottom||!hasHandler(cm,type)){return e_defaultPrevented(e);}mY-=lineBox.top-display.viewOffset;for(var i=0;i<cm.options.gutters.length;++i){var g=display.gutters.childNodes[i];if(g&&g.getBoundingClientRect().right>=mX){var line=_lineAtHeight(cm.doc,mY);var gutter=cm.options.gutters[i];signal(cm,type,cm,line,gutter,e);return e_defaultPrevented(e);}}}function clickInGutter(cm,e){return gutterEvent(cm,e,"gutterClick",true);}// CONTEXT MENU HANDLING
	// To make the context menu work, we need to briefly unhide the
	// textarea (making it as unobtrusive as possible) to let the
	// right-click take effect on it.
	function onContextMenu(cm,e){if(eventInWidget(cm.display,e)||contextMenuInGutter(cm,e)){return;}if(signalDOMEvent(cm,e,"contextmenu")){return;}cm.display.input.onContextMenu(e);}function contextMenuInGutter(cm,e){if(!hasHandler(cm,"gutterContextMenu")){return false;}return gutterEvent(cm,e,"gutterContextMenu",false);}function themeChanged(cm){cm.display.wrapper.className=cm.display.wrapper.className.replace(/\s*cm-s-\S+/g,"")+cm.options.theme.replace(/(^|\s)\s*/g," cm-s-");clearCaches(cm);}var Init={toString:function toString(){return"CodeMirror.Init";}};var defaults={};var optionHandlers={};function defineOptions(CodeMirror){var optionHandlers=CodeMirror.optionHandlers;function option(name,deflt,handle,notOnInit){CodeMirror.defaults[name]=deflt;if(handle){optionHandlers[name]=notOnInit?function(cm,val,old){if(old!=Init){handle(cm,val,old);}}:handle;}}CodeMirror.defineOption=option;// Passed to option handlers when there is no old value.
	CodeMirror.Init=Init;// These two are, on init, called from the constructor because they
	// have to be initialized before the editor can start at all.
	option("value","",function(cm,val){return cm.setValue(val);},true);option("mode",null,function(cm,val){cm.doc.modeOption=val;loadMode(cm);},true);option("indentUnit",2,loadMode,true);option("indentWithTabs",false);option("smartIndent",true);option("tabSize",4,function(cm){resetModeState(cm);clearCaches(cm);regChange(cm);},true);option("lineSeparator",null,function(cm,val){cm.doc.lineSep=val;if(!val){return;}var newBreaks=[],lineNo=cm.doc.first;cm.doc.iter(function(line){for(var pos=0;;){var found=line.text.indexOf(val,pos);if(found==-1){break;}pos=found+val.length;newBreaks.push(Pos(lineNo,found));}lineNo++;});for(var i=newBreaks.length-1;i>=0;i--){_replaceRange(cm.doc,val,newBreaks[i],Pos(newBreaks[i].line,newBreaks[i].ch+val.length));}});option("specialChars",/[\u0000-\u001f\u007f\u00ad\u061c\u200b-\u200f\u2028\u2029\ufeff]/g,function(cm,val,old){cm.state.specialChars=new RegExp(val.source+(val.test("\t")?"":"|\t"),"g");if(old!=Init){cm.refresh();}});option("specialCharPlaceholder",defaultSpecialCharPlaceholder,function(cm){return cm.refresh();},true);option("electricChars",true);option("inputStyle",mobile?"contenteditable":"textarea",function(){throw new Error("inputStyle can not (yet) be changed in a running editor");// FIXME
	},true);option("spellcheck",false,function(cm,val){return cm.getInputField().spellcheck=val;},true);option("rtlMoveVisually",!windows);option("wholeLineUpdateBefore",true);option("theme","default",function(cm){themeChanged(cm);guttersChanged(cm);},true);option("keyMap","default",function(cm,val,old){var next=getKeyMap(val);var prev=old!=Init&&getKeyMap(old);if(prev&&prev.detach){prev.detach(cm,next);}if(next.attach){next.attach(cm,prev||null);}});option("extraKeys",null);option("lineWrapping",false,wrappingChanged,true);option("gutters",[],function(cm){setGuttersForLineNumbers(cm.options);guttersChanged(cm);},true);option("fixedGutter",true,function(cm,val){cm.display.gutters.style.left=val?compensateForHScroll(cm.display)+"px":"0";cm.refresh();},true);option("coverGutterNextToScrollbar",false,function(cm){return updateScrollbars(cm);},true);option("scrollbarStyle","native",function(cm){initScrollbars(cm);updateScrollbars(cm);cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);},true);option("lineNumbers",false,function(cm){setGuttersForLineNumbers(cm.options);guttersChanged(cm);},true);option("firstLineNumber",1,guttersChanged,true);option("lineNumberFormatter",function(integer){return integer;},guttersChanged,true);option("showCursorWhenSelecting",false,updateSelection,true);option("resetSelectionOnContextMenu",true);option("lineWiseCopyCut",true);option("readOnly",false,function(cm,val){if(val=="nocursor"){onBlur(cm);cm.display.input.blur();cm.display.disabled=true;}else{cm.display.disabled=false;}cm.display.input.readOnlyChanged(val);});option("disableInput",false,function(cm,val){if(!val){cm.display.input.reset();}},true);option("dragDrop",true,dragDropChanged);option("allowDropFileTypes",null);option("cursorBlinkRate",530);option("cursorScrollMargin",0);option("cursorHeight",1,updateSelection,true);option("singleCursorHeightPerLine",true,updateSelection,true);option("workTime",100);option("workDelay",100);option("flattenSpans",true,resetModeState,true);option("addModeClass",false,resetModeState,true);option("pollInterval",100);option("undoDepth",200,function(cm,val){return cm.doc.history.undoDepth=val;});option("historyEventDelay",1250);option("viewportMargin",10,function(cm){return cm.refresh();},true);option("maxHighlightLength",10000,resetModeState,true);option("moveInputWithCursor",true,function(cm,val){if(!val){cm.display.input.resetPosition();}});option("tabindex",null,function(cm,val){return cm.display.input.getField().tabIndex=val||"";});option("autofocus",null);}function guttersChanged(cm){updateGutters(cm);regChange(cm);alignHorizontally(cm);}function dragDropChanged(cm,value,old){var wasOn=old&&old!=Init;if(!value!=!wasOn){var funcs=cm.display.dragFunctions;var toggle=value?on:off;toggle(cm.display.scroller,"dragstart",funcs.start);toggle(cm.display.scroller,"dragenter",funcs.enter);toggle(cm.display.scroller,"dragover",funcs.over);toggle(cm.display.scroller,"dragleave",funcs.leave);toggle(cm.display.scroller,"drop",funcs.drop);}}function wrappingChanged(cm){if(cm.options.lineWrapping){addClass(cm.display.wrapper,"CodeMirror-wrap");cm.display.sizer.style.minWidth="";cm.display.sizerWidth=null;}else{rmClass(cm.display.wrapper,"CodeMirror-wrap");findMaxLine(cm);}estimateLineHeights(cm);regChange(cm);clearCaches(cm);setTimeout(function(){return updateScrollbars(cm);},100);}// A CodeMirror instance represents an editor. This is the object
	// that user code is usually dealing with.
	function CodeMirror(place,options){var this$1=this;if(!(this instanceof CodeMirror)){return new CodeMirror(place,options);}this.options=options=options?copyObj(options):{};// Determine effective options based on given values and defaults.
	copyObj(defaults,options,false);setGuttersForLineNumbers(options);var doc=options.value;if(typeof doc=="string"){doc=new Doc(doc,options.mode,null,options.lineSeparator);}this.doc=doc;var input=new CodeMirror.inputStyles[options.inputStyle](this);var display=this.display=new Display(place,doc,input);display.wrapper.CodeMirror=this;updateGutters(this);themeChanged(this);if(options.lineWrapping){this.display.wrapper.className+=" CodeMirror-wrap";}initScrollbars(this);this.state={keyMaps:[],// stores maps added by addKeyMap
	overlays:[],// highlighting overlays, as added by addOverlay
	modeGen:0,// bumped when mode/overlay changes, used to invalidate highlighting info
	overwrite:false,delayingBlurEvent:false,focused:false,suppressEdits:false,// used to disable editing during key handlers when in readOnly mode
	pasteIncoming:false,cutIncoming:false,// help recognize paste/cut edits in input.poll
	selectingText:false,draggingText:false,highlight:new Delayed(),// stores highlight worker timeout
	keySeq:null,// Unfinished key sequence
	specialChars:null};if(options.autofocus&&!mobile){display.input.focus();}// Override magic textarea content restore that IE sometimes does
	// on our hidden textarea on reload
	if(ie&&ie_version<11){setTimeout(function(){return this$1.display.input.reset(true);},20);}registerEventHandlers(this);ensureGlobalHandlers();startOperation(this);this.curOp.forceUpdate=true;attachDoc(this,doc);if(options.autofocus&&!mobile||this.hasFocus()){setTimeout(bind(onFocus,this),20);}else{onBlur(this);}for(var opt in optionHandlers){if(optionHandlers.hasOwnProperty(opt)){optionHandlers[opt](this$1,options[opt],Init);}}maybeUpdateLineNumberWidth(this);if(options.finishInit){options.finishInit(this);}for(var i=0;i<initHooks.length;++i){initHooks[i](this$1);}endOperation(this);// Suppress optimizelegibility in Webkit, since it breaks text
	// measuring on line wrapping boundaries.
	if(webkit&&options.lineWrapping&&getComputedStyle(display.lineDiv).textRendering=="optimizelegibility"){display.lineDiv.style.textRendering="auto";}}// The default configuration options.
	CodeMirror.defaults=defaults;// Functions to run when options are changed.
	CodeMirror.optionHandlers=optionHandlers;// Attach the necessary event handlers when initializing the editor
	function registerEventHandlers(cm){var d=cm.display;on(d.scroller,"mousedown",operation(cm,onMouseDown));// Older IE's will not fire a second mousedown for a double click
	if(ie&&ie_version<11){on(d.scroller,"dblclick",operation(cm,function(e){if(signalDOMEvent(cm,e)){return;}var pos=posFromMouse(cm,e);if(!pos||clickInGutter(cm,e)||eventInWidget(cm.display,e)){return;}e_preventDefault(e);var word=cm.findWordAt(pos);extendSelection(cm.doc,word.anchor,word.head);}));}else{on(d.scroller,"dblclick",function(e){return signalDOMEvent(cm,e)||e_preventDefault(e);});}// Some browsers fire contextmenu *after* opening the menu, at
	// which point we can't mess with it anymore. Context menu is
	// handled in onMouseDown for these browsers.
	if(!captureRightClick){on(d.scroller,"contextmenu",function(e){return onContextMenu(cm,e);});}// Used to suppress mouse event handling when a touch happens
	var touchFinished,prevTouch={end:0};function finishTouch(){if(d.activeTouch){touchFinished=setTimeout(function(){return d.activeTouch=null;},1000);prevTouch=d.activeTouch;prevTouch.end=+new Date();}}function isMouseLikeTouchEvent(e){if(e.touches.length!=1){return false;}var touch=e.touches[0];return touch.radiusX<=1&&touch.radiusY<=1;}function farAway(touch,other){if(other.left==null){return true;}var dx=other.left-touch.left,dy=other.top-touch.top;return dx*dx+dy*dy>20*20;}on(d.scroller,"touchstart",function(e){if(!signalDOMEvent(cm,e)&&!isMouseLikeTouchEvent(e)){d.input.ensurePolled();clearTimeout(touchFinished);var now=+new Date();d.activeTouch={start:now,moved:false,prev:now-prevTouch.end<=300?prevTouch:null};if(e.touches.length==1){d.activeTouch.left=e.touches[0].pageX;d.activeTouch.top=e.touches[0].pageY;}}});on(d.scroller,"touchmove",function(){if(d.activeTouch){d.activeTouch.moved=true;}});on(d.scroller,"touchend",function(e){var touch=d.activeTouch;if(touch&&!eventInWidget(d,e)&&touch.left!=null&&!touch.moved&&new Date()-touch.start<300){var pos=cm.coordsChar(d.activeTouch,"page"),range;if(!touch.prev||farAway(touch,touch.prev))// Single tap
	{range=new Range(pos,pos);}else if(!touch.prev.prev||farAway(touch,touch.prev.prev))// Double tap
	{range=cm.findWordAt(pos);}else// Triple tap
	{range=new Range(Pos(pos.line,0),_clipPos(cm.doc,Pos(pos.line+1,0)));}cm.setSelection(range.anchor,range.head);cm.focus();e_preventDefault(e);}finishTouch();});on(d.scroller,"touchcancel",finishTouch);// Sync scrolling between fake scrollbars and real scrollable
	// area, ensure viewport is updated when scrolling.
	on(d.scroller,"scroll",function(){if(d.scroller.clientHeight){setScrollTop(cm,d.scroller.scrollTop);setScrollLeft(cm,d.scroller.scrollLeft,true);signal(cm,"scroll",cm);}});// Listen to wheel events in order to try and update the viewport on time.
	on(d.scroller,"mousewheel",function(e){return onScrollWheel(cm,e);});on(d.scroller,"DOMMouseScroll",function(e){return onScrollWheel(cm,e);});// Prevent wrapper from ever scrolling
	on(d.wrapper,"scroll",function(){return d.wrapper.scrollTop=d.wrapper.scrollLeft=0;});d.dragFunctions={enter:function enter(e){if(!signalDOMEvent(cm,e)){e_stop(e);}},over:function over(e){if(!signalDOMEvent(cm,e)){onDragOver(cm,e);e_stop(e);}},start:function start(e){return onDragStart(cm,e);},drop:operation(cm,onDrop),leave:function leave(e){if(!signalDOMEvent(cm,e)){clearDragCursor(cm);}}};var inp=d.input.getField();on(inp,"keyup",function(e){return onKeyUp.call(cm,e);});on(inp,"keydown",operation(cm,onKeyDown));on(inp,"keypress",operation(cm,onKeyPress));on(inp,"focus",function(e){return onFocus(cm,e);});on(inp,"blur",function(e){return onBlur(cm,e);});}var initHooks=[];CodeMirror.defineInitHook=function(f){return initHooks.push(f);};// Indent the given line. The how parameter can be "smart",
	// "add"/null, "subtract", or "prev". When aggressive is false
	// (typically set to true for forced single-line indents), empty
	// lines are not indented, and places where the mode returns Pass
	// are left alone.
	function indentLine(cm,n,how,aggressive){var doc=cm.doc,state;if(how==null){how="add";}if(how=="smart"){// Fall back to "prev" when the mode doesn't have an indentation
	// method.
	if(!doc.mode.indent){how="prev";}else{state=getStateBefore(cm,n);}}var tabSize=cm.options.tabSize;var line=getLine(doc,n),curSpace=countColumn(line.text,null,tabSize);if(line.stateAfter){line.stateAfter=null;}var curSpaceString=line.text.match(/^\s*/)[0],indentation;if(!aggressive&&!/\S/.test(line.text)){indentation=0;how="not";}else if(how=="smart"){indentation=doc.mode.indent(state,line.text.slice(curSpaceString.length),line.text);if(indentation==Pass||indentation>150){if(!aggressive){return;}how="prev";}}if(how=="prev"){if(n>doc.first){indentation=countColumn(getLine(doc,n-1).text,null,tabSize);}else{indentation=0;}}else if(how=="add"){indentation=curSpace+cm.options.indentUnit;}else if(how=="subtract"){indentation=curSpace-cm.options.indentUnit;}else if(typeof how=="number"){indentation=curSpace+how;}indentation=Math.max(0,indentation);var indentString="",pos=0;if(cm.options.indentWithTabs){for(var i=Math.floor(indentation/tabSize);i;--i){pos+=tabSize;indentString+="\t";}}if(pos<indentation){indentString+=spaceStr(indentation-pos);}if(indentString!=curSpaceString){_replaceRange(doc,indentString,Pos(n,0),Pos(n,curSpaceString.length),"+input");line.stateAfter=null;return true;}else{// Ensure that, if the cursor was in the whitespace at the start
	// of the line, it is moved to the end of that space.
	for(var i$1=0;i$1<doc.sel.ranges.length;i$1++){var range=doc.sel.ranges[i$1];if(range.head.line==n&&range.head.ch<curSpaceString.length){var pos$1=Pos(n,curSpaceString.length);replaceOneSelection(doc,i$1,new Range(pos$1,pos$1));break;}}}}// This will be set to a {lineWise: bool, text: [string]} object, so
	// that, when pasting, we know what kind of selections the copied
	// text was made out of.
	var lastCopied=null;function setLastCopied(newLastCopied){lastCopied=newLastCopied;}function applyTextInput(cm,inserted,deleted,sel,origin){var doc=cm.doc;cm.display.shift=false;if(!sel){sel=doc.sel;}var paste=cm.state.pasteIncoming||origin=="paste";var textLines=splitLinesAuto(inserted),multiPaste=null;// When pasing N lines into N selections, insert one line per selection
	if(paste&&sel.ranges.length>1){if(lastCopied&&lastCopied.text.join("\n")==inserted){if(sel.ranges.length%lastCopied.text.length==0){multiPaste=[];for(var i=0;i<lastCopied.text.length;i++){multiPaste.push(doc.splitLines(lastCopied.text[i]));}}}else if(textLines.length==sel.ranges.length){multiPaste=map(textLines,function(l){return[l];});}}var updateInput;// Normal behavior is to insert the new text into every selection
	for(var i$1=sel.ranges.length-1;i$1>=0;i$1--){var range=sel.ranges[i$1];var from=range.from(),to=range.to();if(range.empty()){if(deleted&&deleted>0)// Handle deletion
	{from=Pos(from.line,from.ch-deleted);}else if(cm.state.overwrite&&!paste)// Handle overwrite
	{to=Pos(to.line,Math.min(getLine(doc,to.line).text.length,to.ch+lst(textLines).length));}else if(lastCopied&&lastCopied.lineWise&&lastCopied.text.join("\n")==inserted){from=to=Pos(from.line,0);}}updateInput=cm.curOp.updateInput;var changeEvent={from:from,to:to,text:multiPaste?multiPaste[i$1%multiPaste.length]:textLines,origin:origin||(paste?"paste":cm.state.cutIncoming?"cut":"+input")};makeChange(cm.doc,changeEvent);signalLater(cm,"inputRead",cm,changeEvent);}if(inserted&&!paste){triggerElectric(cm,inserted);}ensureCursorVisible(cm);cm.curOp.updateInput=updateInput;cm.curOp.typing=true;cm.state.pasteIncoming=cm.state.cutIncoming=false;}function handlePaste(e,cm){var pasted=e.clipboardData&&e.clipboardData.getData("Text");if(pasted){e.preventDefault();if(!cm.isReadOnly()&&!cm.options.disableInput){runInOp(cm,function(){return applyTextInput(cm,pasted,0,null,"paste");});}return true;}}function triggerElectric(cm,inserted){// When an 'electric' character is inserted, immediately trigger a reindent
	if(!cm.options.electricChars||!cm.options.smartIndent){return;}var sel=cm.doc.sel;for(var i=sel.ranges.length-1;i>=0;i--){var range=sel.ranges[i];if(range.head.ch>100||i&&sel.ranges[i-1].head.line==range.head.line){continue;}var mode=cm.getModeAt(range.head);var indented=false;if(mode.electricChars){for(var j=0;j<mode.electricChars.length;j++){if(inserted.indexOf(mode.electricChars.charAt(j))>-1){indented=indentLine(cm,range.head.line,"smart");break;}}}else if(mode.electricInput){if(mode.electricInput.test(getLine(cm.doc,range.head.line).text.slice(0,range.head.ch))){indented=indentLine(cm,range.head.line,"smart");}}if(indented){signalLater(cm,"electricInput",cm,range.head.line);}}}function copyableRanges(cm){var text=[],ranges=[];for(var i=0;i<cm.doc.sel.ranges.length;i++){var line=cm.doc.sel.ranges[i].head.line;var lineRange={anchor:Pos(line,0),head:Pos(line+1,0)};ranges.push(lineRange);text.push(cm.getRange(lineRange.anchor,lineRange.head));}return{text:text,ranges:ranges};}function disableBrowserMagic(field,spellcheck){field.setAttribute("autocorrect","off");field.setAttribute("autocapitalize","off");field.setAttribute("spellcheck",!!spellcheck);}function hiddenTextarea(){var te=elt("textarea",null,null,"position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none");var div=elt("div",[te],null,"overflow: hidden; position: relative; width: 3px; height: 0px;");// The textarea is kept positioned near the cursor to prevent the
	// fact that it'll be scrolled into view on input from scrolling
	// our fake cursor out of view. On webkit, when wrap=off, paste is
	// very slow. So make the area wide instead.
	if(webkit){te.style.width="1000px";}else{te.setAttribute("wrap","off");}// If border: 0; -- iOS fails to open keyboard (issue #1287)
	if(ios){te.style.border="1px solid black";}disableBrowserMagic(te);return div;}// The publicly visible API. Note that methodOp(f) means
	// 'wrap f in an operation, performed on its `this` parameter'.
	// This is not the complete set of editor methods. Most of the
	// methods defined on the Doc type are also injected into
	// CodeMirror.prototype, for backwards compatibility and
	// convenience.
	function addEditorMethods(CodeMirror){var optionHandlers=CodeMirror.optionHandlers;var helpers=CodeMirror.helpers={};CodeMirror.prototype={constructor:CodeMirror,focus:function focus(){window.focus();this.display.input.focus();},setOption:function setOption(option,value){var options=this.options,old=options[option];if(options[option]==value&&option!="mode"){return;}options[option]=value;if(optionHandlers.hasOwnProperty(option)){operation(this,optionHandlers[option])(this,value,old);}signal(this,"optionChange",this,option);},getOption:function getOption(option){return this.options[option];},getDoc:function getDoc(){return this.doc;},addKeyMap:function addKeyMap(map,bottom){this.state.keyMaps[bottom?"push":"unshift"](getKeyMap(map));},removeKeyMap:function removeKeyMap(map){var maps=this.state.keyMaps;for(var i=0;i<maps.length;++i){if(maps[i]==map||maps[i].name==map){maps.splice(i,1);return true;}}},addOverlay:methodOp(function(spec,options){var mode=spec.token?spec:CodeMirror.getMode(this.options,spec);if(mode.startState){throw new Error("Overlays may not be stateful.");}insertSorted(this.state.overlays,{mode:mode,modeSpec:spec,opaque:options&&options.opaque,priority:options&&options.priority||0},function(overlay){return overlay.priority;});this.state.modeGen++;regChange(this);}),removeOverlay:methodOp(function(spec){var this$1=this;var overlays=this.state.overlays;for(var i=0;i<overlays.length;++i){var cur=overlays[i].modeSpec;if(cur==spec||typeof spec=="string"&&cur.name==spec){overlays.splice(i,1);this$1.state.modeGen++;regChange(this$1);return;}}}),indentLine:methodOp(function(n,dir,aggressive){if(typeof dir!="string"&&typeof dir!="number"){if(dir==null){dir=this.options.smartIndent?"smart":"prev";}else{dir=dir?"add":"subtract";}}if(isLine(this.doc,n)){indentLine(this,n,dir,aggressive);}}),indentSelection:methodOp(function(how){var this$1=this;var ranges=this.doc.sel.ranges,end=-1;for(var i=0;i<ranges.length;i++){var range=ranges[i];if(!range.empty()){var from=range.from(),to=range.to();var start=Math.max(end,from.line);end=Math.min(this$1.lastLine(),to.line-(to.ch?0:1))+1;for(var j=start;j<end;++j){indentLine(this$1,j,how);}var newRanges=this$1.doc.sel.ranges;if(from.ch==0&&ranges.length==newRanges.length&&newRanges[i].from().ch>0){replaceOneSelection(this$1.doc,i,new Range(from,newRanges[i].to()),sel_dontScroll);}}else if(range.head.line>end){indentLine(this$1,range.head.line,how,true);end=range.head.line;if(i==this$1.doc.sel.primIndex){ensureCursorVisible(this$1);}}}}),// Fetch the parser token for a given character. Useful for hacks
	// that want to inspect the mode state (say, for completion).
	getTokenAt:function getTokenAt(pos,precise){return takeToken(this,pos,precise);},getLineTokens:function getLineTokens(line,precise){return takeToken(this,Pos(line),precise,true);},getTokenTypeAt:function getTokenTypeAt(pos){pos=_clipPos(this.doc,pos);var styles=getLineStyles(this,getLine(this.doc,pos.line));var before=0,after=(styles.length-1)/2,ch=pos.ch;var type;if(ch==0){type=styles[2];}else{for(;;){var mid=before+after>>1;if((mid?styles[mid*2-1]:0)>=ch){after=mid;}else if(styles[mid*2+1]<ch){before=mid+1;}else{type=styles[mid*2+2];break;}}}var cut=type?type.indexOf("overlay "):-1;return cut<0?type:cut==0?null:type.slice(0,cut-1);},getModeAt:function getModeAt(pos){var mode=this.doc.mode;if(!mode.innerMode){return mode;}return CodeMirror.innerMode(mode,this.getTokenAt(pos).state).mode;},getHelper:function getHelper(pos,type){return this.getHelpers(pos,type)[0];},getHelpers:function getHelpers(pos,type){var this$1=this;var found=[];if(!helpers.hasOwnProperty(type)){return found;}var help=helpers[type],mode=this.getModeAt(pos);if(typeof mode[type]=="string"){if(help[mode[type]]){found.push(help[mode[type]]);}}else if(mode[type]){for(var i=0;i<mode[type].length;i++){var val=help[mode[type][i]];if(val){found.push(val);}}}else if(mode.helperType&&help[mode.helperType]){found.push(help[mode.helperType]);}else if(help[mode.name]){found.push(help[mode.name]);}for(var i$1=0;i$1<help._global.length;i$1++){var cur=help._global[i$1];if(cur.pred(mode,this$1)&&indexOf(found,cur.val)==-1){found.push(cur.val);}}return found;},getStateAfter:function getStateAfter(line,precise){var doc=this.doc;line=clipLine(doc,line==null?doc.first+doc.size-1:line);return getStateBefore(this,line+1,precise);},cursorCoords:function cursorCoords(start,mode){var pos,range=this.doc.sel.primary();if(start==null){pos=range.head;}else if((typeof start==='undefined'?'undefined':_typeof(start))=="object"){pos=_clipPos(this.doc,start);}else{pos=start?range.from():range.to();}return _cursorCoords(this,pos,mode||"page");},charCoords:function charCoords(pos,mode){return _charCoords(this,_clipPos(this.doc,pos),mode||"page");},coordsChar:function coordsChar(coords,mode){coords=fromCoordSystem(this,coords,mode||"page");return _coordsChar(this,coords.left,coords.top);},lineAtHeight:function lineAtHeight(height,mode){height=fromCoordSystem(this,{top:height,left:0},mode||"page").top;return _lineAtHeight(this.doc,height+this.display.viewOffset);},heightAtLine:function heightAtLine(line,mode,includeWidgets){var end=false,lineObj;if(typeof line=="number"){var last=this.doc.first+this.doc.size-1;if(line<this.doc.first){line=this.doc.first;}else if(line>last){line=last;end=true;}lineObj=getLine(this.doc,line);}else{lineObj=line;}return intoCoordSystem(this,lineObj,{top:0,left:0},mode||"page",includeWidgets).top+(end?this.doc.height-_heightAtLine(lineObj):0);},defaultTextHeight:function defaultTextHeight(){return textHeight(this.display);},defaultCharWidth:function defaultCharWidth(){return charWidth(this.display);},getViewport:function getViewport(){return{from:this.display.viewFrom,to:this.display.viewTo};},addWidget:function addWidget(pos,node,scroll,vert,horiz){var display=this.display;pos=_cursorCoords(this,_clipPos(this.doc,pos));var top=pos.bottom,left=pos.left;node.style.position="absolute";node.setAttribute("cm-ignore-events","true");this.display.input.setUneditable(node);display.sizer.appendChild(node);if(vert=="over"){top=pos.top;}else if(vert=="above"||vert=="near"){var vspace=Math.max(display.wrapper.clientHeight,this.doc.height),hspace=Math.max(display.sizer.clientWidth,display.lineSpace.clientWidth);// Default to positioning above (if specified and possible); otherwise default to positioning below
	if((vert=='above'||pos.bottom+node.offsetHeight>vspace)&&pos.top>node.offsetHeight){top=pos.top-node.offsetHeight;}else if(pos.bottom+node.offsetHeight<=vspace){top=pos.bottom;}if(left+node.offsetWidth>hspace){left=hspace-node.offsetWidth;}}node.style.top=top+"px";node.style.left=node.style.right="";if(horiz=="right"){left=display.sizer.clientWidth-node.offsetWidth;node.style.right="0px";}else{if(horiz=="left"){left=0;}else if(horiz=="middle"){left=(display.sizer.clientWidth-node.offsetWidth)/2;}node.style.left=left+"px";}if(scroll){scrollIntoView(this,left,top,left+node.offsetWidth,top+node.offsetHeight);}},triggerOnKeyDown:methodOp(onKeyDown),triggerOnKeyPress:methodOp(onKeyPress),triggerOnKeyUp:onKeyUp,execCommand:function execCommand(cmd){if(commands.hasOwnProperty(cmd)){return commands[cmd].call(null,this);}},triggerElectric:methodOp(function(text){triggerElectric(this,text);}),findPosH:function findPosH(from,amount,unit,visually){var this$1=this;var dir=1;if(amount<0){dir=-1;amount=-amount;}var cur=_clipPos(this.doc,from);for(var i=0;i<amount;++i){cur=_findPosH(this$1.doc,cur,dir,unit,visually);if(cur.hitSide){break;}}return cur;},moveH:methodOp(function(dir,unit){var this$1=this;this.extendSelectionsBy(function(range){if(this$1.display.shift||this$1.doc.extend||range.empty()){return _findPosH(this$1.doc,range.head,dir,unit,this$1.options.rtlMoveVisually);}else{return dir<0?range.from():range.to();}},sel_move);}),deleteH:methodOp(function(dir,unit){var sel=this.doc.sel,doc=this.doc;if(sel.somethingSelected()){doc.replaceSelection("",null,"+delete");}else{deleteNearSelection(this,function(range){var other=_findPosH(doc,range.head,dir,unit,false);return dir<0?{from:other,to:range.head}:{from:range.head,to:other};});}}),findPosV:function findPosV(from,amount,unit,goalColumn){var this$1=this;var dir=1,x=goalColumn;if(amount<0){dir=-1;amount=-amount;}var cur=_clipPos(this.doc,from);for(var i=0;i<amount;++i){var coords=_cursorCoords(this$1,cur,"div");if(x==null){x=coords.left;}else{coords.left=x;}cur=_findPosV(this$1,coords,dir,unit);if(cur.hitSide){break;}}return cur;},moveV:methodOp(function(dir,unit){var this$1=this;var doc=this.doc,goals=[];var collapse=!this.display.shift&&!doc.extend&&doc.sel.somethingSelected();doc.extendSelectionsBy(function(range){if(collapse){return dir<0?range.from():range.to();}var headPos=_cursorCoords(this$1,range.head,"div");if(range.goalColumn!=null){headPos.left=range.goalColumn;}goals.push(headPos.left);var pos=_findPosV(this$1,headPos,dir,unit);if(unit=="page"&&range==doc.sel.primary()){addToScrollPos(this$1,null,_charCoords(this$1,pos,"div").top-headPos.top);}return pos;},sel_move);if(goals.length){for(var i=0;i<doc.sel.ranges.length;i++){doc.sel.ranges[i].goalColumn=goals[i];}}}),// Find the word at the given position (as returned by coordsChar).
	findWordAt:function findWordAt(pos){var doc=this.doc,line=getLine(doc,pos.line).text;var start=pos.ch,end=pos.ch;if(line){var helper=this.getHelper(pos,"wordChars");if((pos.xRel<0||end==line.length)&&start){--start;}else{++end;}var startChar=line.charAt(start);var check=isWordChar(startChar,helper)?function(ch){return isWordChar(ch,helper);}:/\s/.test(startChar)?function(ch){return /\s/.test(ch);}:function(ch){return!/\s/.test(ch)&&!isWordChar(ch);};while(start>0&&check(line.charAt(start-1))){--start;}while(end<line.length&&check(line.charAt(end))){++end;}}return new Range(Pos(pos.line,start),Pos(pos.line,end));},toggleOverwrite:function toggleOverwrite(value){if(value!=null&&value==this.state.overwrite){return;}if(this.state.overwrite=!this.state.overwrite){addClass(this.display.cursorDiv,"CodeMirror-overwrite");}else{rmClass(this.display.cursorDiv,"CodeMirror-overwrite");}signal(this,"overwriteToggle",this,this.state.overwrite);},hasFocus:function hasFocus(){return this.display.input.getField()==activeElt();},isReadOnly:function isReadOnly(){return!!(this.options.readOnly||this.doc.cantEdit);},scrollTo:methodOp(function(x,y){if(x!=null||y!=null){resolveScrollToPos(this);}if(x!=null){this.curOp.scrollLeft=x;}if(y!=null){this.curOp.scrollTop=y;}}),getScrollInfo:function getScrollInfo(){var scroller=this.display.scroller;return{left:scroller.scrollLeft,top:scroller.scrollTop,height:scroller.scrollHeight-scrollGap(this)-this.display.barHeight,width:scroller.scrollWidth-scrollGap(this)-this.display.barWidth,clientHeight:displayHeight(this),clientWidth:displayWidth(this)};},scrollIntoView:methodOp(function(range,margin){if(range==null){range={from:this.doc.sel.primary().head,to:null};if(margin==null){margin=this.options.cursorScrollMargin;}}else if(typeof range=="number"){range={from:Pos(range,0),to:null};}else if(range.from==null){range={from:range,to:null};}if(!range.to){range.to=range.from;}range.margin=margin||0;if(range.from.line!=null){resolveScrollToPos(this);this.curOp.scrollToPos=range;}else{var sPos=calculateScrollPos(this,Math.min(range.from.left,range.to.left),Math.min(range.from.top,range.to.top)-range.margin,Math.max(range.from.right,range.to.right),Math.max(range.from.bottom,range.to.bottom)+range.margin);this.scrollTo(sPos.scrollLeft,sPos.scrollTop);}}),setSize:methodOp(function(width,height){var this$1=this;var interpret=function interpret(val){return typeof val=="number"||/^\d+$/.test(String(val))?val+"px":val;};if(width!=null){this.display.wrapper.style.width=interpret(width);}if(height!=null){this.display.wrapper.style.height=interpret(height);}if(this.options.lineWrapping){clearLineMeasurementCache(this);}var lineNo=this.display.viewFrom;this.doc.iter(lineNo,this.display.viewTo,function(line){if(line.widgets){for(var i=0;i<line.widgets.length;i++){if(line.widgets[i].noHScroll){regLineChange(this$1,lineNo,"widget");break;}}}++lineNo;});this.curOp.forceUpdate=true;signal(this,"refresh",this);}),operation:function operation(f){return runInOp(this,f);},refresh:methodOp(function(){var oldHeight=this.display.cachedTextHeight;regChange(this);this.curOp.forceUpdate=true;clearCaches(this);this.scrollTo(this.doc.scrollLeft,this.doc.scrollTop);updateGutterSpace(this);if(oldHeight==null||Math.abs(oldHeight-textHeight(this.display))>.5){estimateLineHeights(this);}signal(this,"refresh",this);}),swapDoc:methodOp(function(doc){var old=this.doc;old.cm=null;attachDoc(this,doc);clearCaches(this);this.display.input.reset();this.scrollTo(doc.scrollLeft,doc.scrollTop);this.curOp.forceScroll=true;signalLater(this,"swapDoc",this,old);return old;}),getInputField:function getInputField(){return this.display.input.getField();},getWrapperElement:function getWrapperElement(){return this.display.wrapper;},getScrollerElement:function getScrollerElement(){return this.display.scroller;},getGutterElement:function getGutterElement(){return this.display.gutters;}};eventMixin(CodeMirror);CodeMirror.registerHelper=function(type,name,value){if(!helpers.hasOwnProperty(type)){helpers[type]=CodeMirror[type]={_global:[]};}helpers[type][name]=value;};CodeMirror.registerGlobalHelper=function(type,name,predicate,value){CodeMirror.registerHelper(type,name,value);helpers[type]._global.push({pred:predicate,val:value});};}// Used for horizontal relative motion. Dir is -1 or 1 (left or
	// right), unit can be "char", "column" (like char, but doesn't
	// cross line boundaries), "word" (across next word), or "group" (to
	// the start of next group of word or non-word-non-whitespace
	// chars). The visually param controls whether, in right-to-left
	// text, direction 1 means to move towards the next index in the
	// string, or towards the character to the right of the current
	// position. The resulting position will have a hitSide=true
	// property if it reached the end of the document.
	function _findPosH(doc,pos,dir,unit,visually){var line=pos.line,ch=pos.ch,origDir=dir;var lineObj=getLine(doc,line);function findNextLine(){var l=line+dir;if(l<doc.first||l>=doc.first+doc.size){return false;}line=l;return lineObj=getLine(doc,l);}function moveOnce(boundToLine){var next=(visually?moveVisually:moveLogically)(lineObj,ch,dir,true);if(next==null){if(!boundToLine&&findNextLine()){if(visually){ch=(dir<0?lineRight:lineLeft)(lineObj);}else{ch=dir<0?lineObj.text.length:0;}}else{return false;}}else{ch=next;}return true;}if(unit=="char"){moveOnce();}else if(unit=="column"){moveOnce(true);}else if(unit=="word"||unit=="group"){var sawType=null,group=unit=="group";var helper=doc.cm&&doc.cm.getHelper(pos,"wordChars");for(var first=true;;first=false){if(dir<0&&!moveOnce(!first)){break;}var cur=lineObj.text.charAt(ch)||"\n";var type=isWordChar(cur,helper)?"w":group&&cur=="\n"?"n":!group||/\s/.test(cur)?null:"p";if(group&&!first&&!type){type="s";}if(sawType&&sawType!=type){if(dir<0){dir=1;moveOnce();}break;}if(type){sawType=type;}if(dir>0&&!moveOnce(!first)){break;}}}var result=skipAtomic(doc,Pos(line,ch),pos,origDir,true);if(!cmp(pos,result)){result.hitSide=true;}return result;}// For relative vertical movement. Dir may be -1 or 1. Unit can be
	// "page" or "line". The resulting position will have a hitSide=true
	// property if it reached the end of the document.
	function _findPosV(cm,pos,dir,unit){var doc=cm.doc,x=pos.left,y;if(unit=="page"){var pageSize=Math.min(cm.display.wrapper.clientHeight,window.innerHeight||document.documentElement.clientHeight);var moveAmount=Math.max(pageSize-.5*textHeight(cm.display),3);y=(dir>0?pos.bottom:pos.top)+dir*moveAmount;}else if(unit=="line"){y=dir>0?pos.bottom+3:pos.top-3;}var target;for(;;){target=_coordsChar(cm,x,y);if(!target.outside){break;}if(dir<0?y<=0:y>=doc.height){target.hitSide=true;break;}y+=dir*5;}return target;}// CONTENTEDITABLE INPUT STYLE
	var ContentEditableInput=function ContentEditableInput(cm){this.cm=cm;this.lastAnchorNode=this.lastAnchorOffset=this.lastFocusNode=this.lastFocusOffset=null;this.polling=new Delayed();this.composing=null;this.gracePeriod=false;this.readDOMTimeout=null;};ContentEditableInput.prototype.init=function(display){var this$1=this;var input=this,cm=input.cm;var div=input.div=display.lineDiv;disableBrowserMagic(div,cm.options.spellcheck);on(div,"paste",function(e){if(signalDOMEvent(cm,e)||handlePaste(e,cm)){return;}// IE doesn't fire input events, so we schedule a read for the pasted content in this way
	if(ie_version<=11){setTimeout(operation(cm,function(){if(!input.pollContent()){regChange(cm);}}),20);}});on(div,"compositionstart",function(e){this$1.composing={data:e.data,done:false};});on(div,"compositionupdate",function(e){if(!this$1.composing){this$1.composing={data:e.data,done:false};}});on(div,"compositionend",function(e){if(this$1.composing){if(e.data!=this$1.composing.data){this$1.readFromDOMSoon();}this$1.composing.done=true;}});on(div,"touchstart",function(){return input.forceCompositionEnd();});on(div,"input",function(){if(!this$1.composing){this$1.readFromDOMSoon();}});function onCopyCut(e){if(signalDOMEvent(cm,e)){return;}if(cm.somethingSelected()){setLastCopied({lineWise:false,text:cm.getSelections()});if(e.type=="cut"){cm.replaceSelection("",null,"cut");}}else if(!cm.options.lineWiseCopyCut){return;}else{var ranges=copyableRanges(cm);setLastCopied({lineWise:true,text:ranges.text});if(e.type=="cut"){cm.operation(function(){cm.setSelections(ranges.ranges,0,sel_dontScroll);cm.replaceSelection("",null,"cut");});}}if(e.clipboardData){e.clipboardData.clearData();var content=lastCopied.text.join("\n");// iOS exposes the clipboard API, but seems to discard content inserted into it
	e.clipboardData.setData("Text",content);if(e.clipboardData.getData("Text")==content){e.preventDefault();return;}}// Old-fashioned briefly-focus-a-textarea hack
	var kludge=hiddenTextarea(),te=kludge.firstChild;cm.display.lineSpace.insertBefore(kludge,cm.display.lineSpace.firstChild);te.value=lastCopied.text.join("\n");var hadFocus=document.activeElement;selectInput(te);setTimeout(function(){cm.display.lineSpace.removeChild(kludge);hadFocus.focus();if(hadFocus==div){input.showPrimarySelection();}},50);}on(div,"copy",onCopyCut);on(div,"cut",onCopyCut);};ContentEditableInput.prototype.prepareSelection=function(){var result=prepareSelection(this.cm,false);result.focus=this.cm.state.focused;return result;};ContentEditableInput.prototype.showSelection=function(info,takeFocus){if(!info||!this.cm.display.view.length){return;}if(info.focus||takeFocus){this.showPrimarySelection();}this.showMultipleSelections(info);};ContentEditableInput.prototype.showPrimarySelection=function(){var sel=window.getSelection(),prim=this.cm.doc.sel.primary();var curAnchor=domToPos(this.cm,sel.anchorNode,sel.anchorOffset);var curFocus=domToPos(this.cm,sel.focusNode,sel.focusOffset);if(curAnchor&&!curAnchor.bad&&curFocus&&!curFocus.bad&&cmp(minPos(curAnchor,curFocus),prim.from())==0&&cmp(maxPos(curAnchor,curFocus),prim.to())==0){return;}var start=posToDOM(this.cm,prim.from());var end=posToDOM(this.cm,prim.to());if(!start&&!end){return;}var view=this.cm.display.view;var old=sel.rangeCount&&sel.getRangeAt(0);if(!start){start={node:view[0].measure.map[2],offset:0};}else if(!end){// FIXME dangerously hacky
	var measure=view[view.length-1].measure;var map=measure.maps?measure.maps[measure.maps.length-1]:measure.map;end={node:map[map.length-1],offset:map[map.length-2]-map[map.length-3]};}var rng;try{rng=range(start.node,start.offset,end.offset,end.node);}catch(e){}// Our model of the DOM might be outdated, in which case the range we try to set can be impossible
	if(rng){if(!gecko&&this.cm.state.focused){sel.collapse(start.node,start.offset);if(!rng.collapsed){sel.removeAllRanges();sel.addRange(rng);}}else{sel.removeAllRanges();sel.addRange(rng);}if(old&&sel.anchorNode==null){sel.addRange(old);}else if(gecko){this.startGracePeriod();}}this.rememberSelection();};ContentEditableInput.prototype.startGracePeriod=function(){var this$1=this;clearTimeout(this.gracePeriod);this.gracePeriod=setTimeout(function(){this$1.gracePeriod=false;if(this$1.selectionChanged()){this$1.cm.operation(function(){return this$1.cm.curOp.selectionChanged=true;});}},20);};ContentEditableInput.prototype.showMultipleSelections=function(info){removeChildrenAndAdd(this.cm.display.cursorDiv,info.cursors);removeChildrenAndAdd(this.cm.display.selectionDiv,info.selection);};ContentEditableInput.prototype.rememberSelection=function(){var sel=window.getSelection();this.lastAnchorNode=sel.anchorNode;this.lastAnchorOffset=sel.anchorOffset;this.lastFocusNode=sel.focusNode;this.lastFocusOffset=sel.focusOffset;};ContentEditableInput.prototype.selectionInEditor=function(){var sel=window.getSelection();if(!sel.rangeCount){return false;}var node=sel.getRangeAt(0).commonAncestorContainer;return contains(this.div,node);};ContentEditableInput.prototype.focus=function(){if(this.cm.options.readOnly!="nocursor"){if(!this.selectionInEditor()){this.showSelection(this.prepareSelection(),true);}this.div.focus();}};ContentEditableInput.prototype.blur=function(){this.div.blur();};ContentEditableInput.prototype.getField=function(){return this.div;};ContentEditableInput.prototype.supportsTouch=function(){return true;};ContentEditableInput.prototype.receivedFocus=function(){var input=this;if(this.selectionInEditor()){this.pollSelection();}else{runInOp(this.cm,function(){return input.cm.curOp.selectionChanged=true;});}function poll(){if(input.cm.state.focused){input.pollSelection();input.polling.set(input.cm.options.pollInterval,poll);}}this.polling.set(this.cm.options.pollInterval,poll);};ContentEditableInput.prototype.selectionChanged=function(){var sel=window.getSelection();return sel.anchorNode!=this.lastAnchorNode||sel.anchorOffset!=this.lastAnchorOffset||sel.focusNode!=this.lastFocusNode||sel.focusOffset!=this.lastFocusOffset;};ContentEditableInput.prototype.pollSelection=function(){if(!this.composing&&this.readDOMTimeout==null&&!this.gracePeriod&&this.selectionChanged()){var sel=window.getSelection(),cm=this.cm;this.rememberSelection();var anchor=domToPos(cm,sel.anchorNode,sel.anchorOffset);var head=domToPos(cm,sel.focusNode,sel.focusOffset);if(anchor&&head){runInOp(cm,function(){setSelection(cm.doc,simpleSelection(anchor,head),sel_dontScroll);if(anchor.bad||head.bad){cm.curOp.selectionChanged=true;}});}}};ContentEditableInput.prototype.pollContent=function(){if(this.readDOMTimeout!=null){clearTimeout(this.readDOMTimeout);this.readDOMTimeout=null;}var cm=this.cm,display=cm.display,sel=cm.doc.sel.primary();var from=sel.from(),to=sel.to();if(from.ch==0&&from.line>cm.firstLine()){from=Pos(from.line-1,getLine(cm.doc,from.line-1).length);}if(to.ch==getLine(cm.doc,to.line).text.length&&to.line<cm.lastLine()){to=Pos(to.line+1,0);}if(from.line<display.viewFrom||to.line>display.viewTo-1){return false;}var fromIndex,fromLine,fromNode;if(from.line==display.viewFrom||(fromIndex=findViewIndex(cm,from.line))==0){fromLine=lineNo(display.view[0].line);fromNode=display.view[0].node;}else{fromLine=lineNo(display.view[fromIndex].line);fromNode=display.view[fromIndex-1].node.nextSibling;}var toIndex=findViewIndex(cm,to.line);var toLine,toNode;if(toIndex==display.view.length-1){toLine=display.viewTo-1;toNode=display.lineDiv.lastChild;}else{toLine=lineNo(display.view[toIndex+1].line)-1;toNode=display.view[toIndex+1].node.previousSibling;}if(!fromNode){return false;}var newText=cm.doc.splitLines(domTextBetween(cm,fromNode,toNode,fromLine,toLine));var oldText=getBetween(cm.doc,Pos(fromLine,0),Pos(toLine,getLine(cm.doc,toLine).text.length));while(newText.length>1&&oldText.length>1){if(lst(newText)==lst(oldText)){newText.pop();oldText.pop();toLine--;}else if(newText[0]==oldText[0]){newText.shift();oldText.shift();fromLine++;}else{break;}}var cutFront=0,cutEnd=0;var newTop=newText[0],oldTop=oldText[0],maxCutFront=Math.min(newTop.length,oldTop.length);while(cutFront<maxCutFront&&newTop.charCodeAt(cutFront)==oldTop.charCodeAt(cutFront)){++cutFront;}var newBot=lst(newText),oldBot=lst(oldText);var maxCutEnd=Math.min(newBot.length-(newText.length==1?cutFront:0),oldBot.length-(oldText.length==1?cutFront:0));while(cutEnd<maxCutEnd&&newBot.charCodeAt(newBot.length-cutEnd-1)==oldBot.charCodeAt(oldBot.length-cutEnd-1)){++cutEnd;}newText[newText.length-1]=newBot.slice(0,newBot.length-cutEnd).replace(/^\u200b+/,"");newText[0]=newText[0].slice(cutFront).replace(/\u200b+$/,"");var chFrom=Pos(fromLine,cutFront);var chTo=Pos(toLine,oldText.length?lst(oldText).length-cutEnd:0);if(newText.length>1||newText[0]||cmp(chFrom,chTo)){_replaceRange(cm.doc,newText,chFrom,chTo,"+input");return true;}};ContentEditableInput.prototype.ensurePolled=function(){this.forceCompositionEnd();};ContentEditableInput.prototype.reset=function(){this.forceCompositionEnd();};ContentEditableInput.prototype.forceCompositionEnd=function(){if(!this.composing){return;}clearTimeout(this.readDOMTimeout);this.composing=null;if(!this.pollContent()){regChange(this.cm);}this.div.blur();this.div.focus();};ContentEditableInput.prototype.readFromDOMSoon=function(){var this$1=this;if(this.readDOMTimeout!=null){return;}this.readDOMTimeout=setTimeout(function(){this$1.readDOMTimeout=null;if(this$1.composing){if(this$1.composing.done){this$1.composing=null;}else{return;}}if(this$1.cm.isReadOnly()||!this$1.pollContent()){runInOp(this$1.cm,function(){return regChange(this$1.cm);});}},80);};ContentEditableInput.prototype.setUneditable=function(node){node.contentEditable="false";};ContentEditableInput.prototype.onKeyPress=function(e){e.preventDefault();if(!this.cm.isReadOnly()){operation(this.cm,applyTextInput)(this.cm,String.fromCharCode(e.charCode==null?e.keyCode:e.charCode),0);}};ContentEditableInput.prototype.readOnlyChanged=function(val){this.div.contentEditable=String(val!="nocursor");};ContentEditableInput.prototype.onContextMenu=function(){};ContentEditableInput.prototype.resetPosition=function(){};ContentEditableInput.prototype.needsContentAttribute=true;function posToDOM(cm,pos){var view=findViewForLine(cm,pos.line);if(!view||view.hidden){return null;}var line=getLine(cm.doc,pos.line);var info=mapFromLineView(view,line,pos.line);var order=getOrder(line),side="left";if(order){var partPos=getBidiPartAt(order,pos.ch);side=partPos%2?"right":"left";}var result=nodeAndOffsetInLineMap(info.map,pos.ch,side);result.offset=result.collapse=="right"?result.end:result.start;return result;}function badPos(pos,bad){if(bad){pos.bad=true;}return pos;}function domTextBetween(cm,from,to,fromLine,toLine){var text="",closing=false,lineSep=cm.doc.lineSeparator();function recognizeMarker(id){return function(marker){return marker.id==id;};}function walk(node){if(node.nodeType==1){var cmText=node.getAttribute("cm-text");if(cmText!=null){if(cmText==""){text+=node.textContent.replace(/\u200b/g,"");}else{text+=cmText;}return;}var markerID=node.getAttribute("cm-marker"),range;if(markerID){var found=cm.findMarks(Pos(fromLine,0),Pos(toLine+1,0),recognizeMarker(+markerID));if(found.length&&(range=found[0].find())){text+=getBetween(cm.doc,range.from,range.to).join(lineSep);}return;}if(node.getAttribute("contenteditable")=="false"){return;}for(var i=0;i<node.childNodes.length;i++){walk(node.childNodes[i]);}if(/^(pre|div|p)$/i.test(node.nodeName)){closing=true;}}else if(node.nodeType==3){var val=node.nodeValue;if(!val){return;}if(closing){text+=lineSep;closing=false;}text+=val;}}for(;;){walk(from);if(from==to){break;}from=from.nextSibling;}return text;}function domToPos(cm,node,offset){var lineNode;if(node==cm.display.lineDiv){lineNode=cm.display.lineDiv.childNodes[offset];if(!lineNode){return badPos(cm.clipPos(Pos(cm.display.viewTo-1)),true);}node=null;offset=0;}else{for(lineNode=node;;lineNode=lineNode.parentNode){if(!lineNode||lineNode==cm.display.lineDiv){return null;}if(lineNode.parentNode&&lineNode.parentNode==cm.display.lineDiv){break;}}}for(var i=0;i<cm.display.view.length;i++){var lineView=cm.display.view[i];if(lineView.node==lineNode){return locateNodeInLineView(lineView,node,offset);}}}function locateNodeInLineView(lineView,node,offset){var wrapper=lineView.text.firstChild,bad=false;if(!node||!contains(wrapper,node)){return badPos(Pos(lineNo(lineView.line),0),true);}if(node==wrapper){bad=true;node=wrapper.childNodes[offset];offset=0;if(!node){var line=lineView.rest?lst(lineView.rest):lineView.line;return badPos(Pos(lineNo(line),line.text.length),bad);}}var textNode=node.nodeType==3?node:null,topNode=node;if(!textNode&&node.childNodes.length==1&&node.firstChild.nodeType==3){textNode=node.firstChild;if(offset){offset=textNode.nodeValue.length;}}while(topNode.parentNode!=wrapper){topNode=topNode.parentNode;}var measure=lineView.measure,maps=measure.maps;function find(textNode,topNode,offset){for(var i=-1;i<(maps?maps.length:0);i++){var map=i<0?measure.map:maps[i];for(var j=0;j<map.length;j+=3){var curNode=map[j+2];if(curNode==textNode||curNode==topNode){var line=lineNo(i<0?lineView.line:lineView.rest[i]);var ch=map[j]+offset;if(offset<0||curNode!=textNode){ch=map[j+(offset?1:0)];}return Pos(line,ch);}}}}var found=find(textNode,topNode,offset);if(found){return badPos(found,bad);}// FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
	for(var after=topNode.nextSibling,dist=textNode?textNode.nodeValue.length-offset:0;after;after=after.nextSibling){found=find(after,after.firstChild,0);if(found){return badPos(Pos(found.line,found.ch-dist),bad);}else{dist+=after.textContent.length;}}for(var before=topNode.previousSibling,dist$1=offset;before;before=before.previousSibling){found=find(before,before.firstChild,-1);if(found){return badPos(Pos(found.line,found.ch+dist$1),bad);}else{dist$1+=before.textContent.length;}}}// TEXTAREA INPUT STYLE
	var TextareaInput=function TextareaInput(cm){this.cm=cm;// See input.poll and input.reset
	this.prevInput="";// Flag that indicates whether we expect input to appear real soon
	// now (after some event like 'keypress' or 'input') and are
	// polling intensively.
	this.pollingFast=false;// Self-resetting timeout for the poller
	this.polling=new Delayed();// Tracks when input.reset has punted to just putting a short
	// string into the textarea instead of the full selection.
	this.inaccurateSelection=false;// Used to work around IE issue with selection being forgotten when focus moves away from textarea
	this.hasSelection=false;this.composing=null;};TextareaInput.prototype.init=function(display){var this$1=this;var input=this,cm=this.cm;// Wraps and hides input textarea
	var div=this.wrapper=hiddenTextarea();// The semihidden textarea that is focused when the editor is
	// focused, and receives input.
	var te=this.textarea=div.firstChild;display.wrapper.insertBefore(div,display.wrapper.firstChild);// Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
	if(ios){te.style.width="0px";}on(te,"input",function(){if(ie&&ie_version>=9&&this$1.hasSelection){this$1.hasSelection=null;}input.poll();});on(te,"paste",function(e){if(signalDOMEvent(cm,e)||handlePaste(e,cm)){return;}cm.state.pasteIncoming=true;input.fastPoll();});function prepareCopyCut(e){if(signalDOMEvent(cm,e)){return;}if(cm.somethingSelected()){setLastCopied({lineWise:false,text:cm.getSelections()});if(input.inaccurateSelection){input.prevInput="";input.inaccurateSelection=false;te.value=lastCopied.text.join("\n");selectInput(te);}}else if(!cm.options.lineWiseCopyCut){return;}else{var ranges=copyableRanges(cm);setLastCopied({lineWise:true,text:ranges.text});if(e.type=="cut"){cm.setSelections(ranges.ranges,null,sel_dontScroll);}else{input.prevInput="";te.value=ranges.text.join("\n");selectInput(te);}}if(e.type=="cut"){cm.state.cutIncoming=true;}}on(te,"cut",prepareCopyCut);on(te,"copy",prepareCopyCut);on(display.scroller,"paste",function(e){if(eventInWidget(display,e)||signalDOMEvent(cm,e)){return;}cm.state.pasteIncoming=true;input.focus();});// Prevent normal selection in the editor (we handle our own)
	on(display.lineSpace,"selectstart",function(e){if(!eventInWidget(display,e)){e_preventDefault(e);}});on(te,"compositionstart",function(){var start=cm.getCursor("from");if(input.composing){input.composing.range.clear();}input.composing={start:start,range:cm.markText(start,cm.getCursor("to"),{className:"CodeMirror-composing"})};});on(te,"compositionend",function(){if(input.composing){input.poll();input.composing.range.clear();input.composing=null;}});};TextareaInput.prototype.prepareSelection=function(){// Redraw the selection and/or cursor
	var cm=this.cm,display=cm.display,doc=cm.doc;var result=prepareSelection(cm);// Move the hidden textarea near the cursor to prevent scrolling artifacts
	if(cm.options.moveInputWithCursor){var headPos=_cursorCoords(cm,doc.sel.primary().head,"div");var wrapOff=display.wrapper.getBoundingClientRect(),lineOff=display.lineDiv.getBoundingClientRect();result.teTop=Math.max(0,Math.min(display.wrapper.clientHeight-10,headPos.top+lineOff.top-wrapOff.top));result.teLeft=Math.max(0,Math.min(display.wrapper.clientWidth-10,headPos.left+lineOff.left-wrapOff.left));}return result;};TextareaInput.prototype.showSelection=function(drawn){var cm=this.cm,display=cm.display;removeChildrenAndAdd(display.cursorDiv,drawn.cursors);removeChildrenAndAdd(display.selectionDiv,drawn.selection);if(drawn.teTop!=null){this.wrapper.style.top=drawn.teTop+"px";this.wrapper.style.left=drawn.teLeft+"px";}};// Reset the input to correspond to the selection (or to be empty,
	// when not typing and nothing is selected)
	TextareaInput.prototype.reset=function(typing){if(this.contextMenuPending){return;}var minimal,selected,cm=this.cm,doc=cm.doc;if(cm.somethingSelected()){this.prevInput="";var range=doc.sel.primary();minimal=hasCopyEvent&&(range.to().line-range.from().line>100||(selected=cm.getSelection()).length>1000);var content=minimal?"-":selected||cm.getSelection();this.textarea.value=content;if(cm.state.focused){selectInput(this.textarea);}if(ie&&ie_version>=9){this.hasSelection=content;}}else if(!typing){this.prevInput=this.textarea.value="";if(ie&&ie_version>=9){this.hasSelection=null;}}this.inaccurateSelection=minimal;};TextareaInput.prototype.getField=function(){return this.textarea;};TextareaInput.prototype.supportsTouch=function(){return false;};TextareaInput.prototype.focus=function(){if(this.cm.options.readOnly!="nocursor"&&(!mobile||activeElt()!=this.textarea)){try{this.textarea.focus();}catch(e){}// IE8 will throw if the textarea is display: none or not in DOM
	}};TextareaInput.prototype.blur=function(){this.textarea.blur();};TextareaInput.prototype.resetPosition=function(){this.wrapper.style.top=this.wrapper.style.left=0;};TextareaInput.prototype.receivedFocus=function(){this.slowPoll();};// Poll for input changes, using the normal rate of polling. This
	// runs as long as the editor is focused.
	TextareaInput.prototype.slowPoll=function(){var this$1=this;if(this.pollingFast){return;}this.polling.set(this.cm.options.pollInterval,function(){this$1.poll();if(this$1.cm.state.focused){this$1.slowPoll();}});};// When an event has just come in that is likely to add or change
	// something in the input textarea, we poll faster, to ensure that
	// the change appears on the screen quickly.
	TextareaInput.prototype.fastPoll=function(){var missed=false,input=this;input.pollingFast=true;function p(){var changed=input.poll();if(!changed&&!missed){missed=true;input.polling.set(60,p);}else{input.pollingFast=false;input.slowPoll();}}input.polling.set(20,p);};// Read input from the textarea, and update the document to match.
	// When something is selected, it is present in the textarea, and
	// selected (unless it is huge, in which case a placeholder is
	// used). When nothing is selected, the cursor sits after previously
	// seen text (can be empty), which is stored in prevInput (we must
	// not reset the textarea when typing, because that breaks IME).
	TextareaInput.prototype.poll=function(){var this$1=this;var cm=this.cm,input=this.textarea,prevInput=this.prevInput;// Since this is called a *lot*, try to bail out as cheaply as
	// possible when it is clear that nothing happened. hasSelection
	// will be the case when there is a lot of text in the textarea,
	// in which case reading its value would be expensive.
	if(this.contextMenuPending||!cm.state.focused||hasSelection(input)&&!prevInput&&!this.composing||cm.isReadOnly()||cm.options.disableInput||cm.state.keySeq){return false;}var text=input.value;// If nothing changed, bail.
	if(text==prevInput&&!cm.somethingSelected()){return false;}// Work around nonsensical selection resetting in IE9/10, and
	// inexplicable appearance of private area unicode characters on
	// some key combos in Mac (#2689).
	if(ie&&ie_version>=9&&this.hasSelection===text||mac&&/[\uf700-\uf7ff]/.test(text)){cm.display.input.reset();return false;}if(cm.doc.sel==cm.display.selForContextMenu){var first=text.charCodeAt(0);if(first==0x200b&&!prevInput){prevInput='\u200B';}if(first==0x21da){this.reset();return this.cm.execCommand("undo");}}// Find the part of the input that is actually new
	var same=0,l=Math.min(prevInput.length,text.length);while(same<l&&prevInput.charCodeAt(same)==text.charCodeAt(same)){++same;}runInOp(cm,function(){applyTextInput(cm,text.slice(same),prevInput.length-same,null,this$1.composing?"*compose":null);// Don't leave long text in the textarea, since it makes further polling slow
	if(text.length>1000||text.indexOf("\n")>-1){input.value=this$1.prevInput="";}else{this$1.prevInput=text;}if(this$1.composing){this$1.composing.range.clear();this$1.composing.range=cm.markText(this$1.composing.start,cm.getCursor("to"),{className:"CodeMirror-composing"});}});return true;};TextareaInput.prototype.ensurePolled=function(){if(this.pollingFast&&this.poll()){this.pollingFast=false;}};TextareaInput.prototype.onKeyPress=function(){if(ie&&ie_version>=9){this.hasSelection=null;}this.fastPoll();};TextareaInput.prototype.onContextMenu=function(e){var input=this,cm=input.cm,display=cm.display,te=input.textarea;var pos=posFromMouse(cm,e),scrollPos=display.scroller.scrollTop;if(!pos||presto){return;}// Opera is difficult.
	// Reset the current text selection only if the click is done outside of the selection
	// and 'resetSelectionOnContextMenu' option is true.
	var reset=cm.options.resetSelectionOnContextMenu;if(reset&&cm.doc.sel.contains(pos)==-1){operation(cm,setSelection)(cm.doc,simpleSelection(pos),sel_dontScroll);}var oldCSS=te.style.cssText,oldWrapperCSS=input.wrapper.style.cssText;input.wrapper.style.cssText="position: absolute";var wrapperBox=input.wrapper.getBoundingClientRect();te.style.cssText="position: absolute; width: 30px; height: 30px;\n      top: "+(e.clientY-wrapperBox.top-5)+"px; left: "+(e.clientX-wrapperBox.left-5)+"px;\n      z-index: 1000; background: "+(ie?"rgba(255, 255, 255, .05)":"transparent")+";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";var oldScrollY;if(webkit){oldScrollY=window.scrollY;}// Work around Chrome issue (#2712)
	display.input.focus();if(webkit){window.scrollTo(null,oldScrollY);}display.input.reset();// Adds "Select all" to context menu in FF
	if(!cm.somethingSelected()){te.value=input.prevInput=" ";}input.contextMenuPending=true;display.selForContextMenu=cm.doc.sel;clearTimeout(display.detectingSelectAll);// Select-all will be greyed out if there's nothing to select, so
	// this adds a zero-width space so that we can later check whether
	// it got selected.
	function prepareSelectAllHack(){if(te.selectionStart!=null){var selected=cm.somethingSelected();var extval='\u200B'+(selected?te.value:"");te.value='\u21DA';// Used to catch context-menu undo
	te.value=extval;input.prevInput=selected?"":'\u200B';te.selectionStart=1;te.selectionEnd=extval.length;// Re-set this, in case some other handler touched the
	// selection in the meantime.
	display.selForContextMenu=cm.doc.sel;}}function rehide(){input.contextMenuPending=false;input.wrapper.style.cssText=oldWrapperCSS;te.style.cssText=oldCSS;if(ie&&ie_version<9){display.scrollbars.setScrollTop(display.scroller.scrollTop=scrollPos);}// Try to detect the user choosing select-all
	if(te.selectionStart!=null){if(!ie||ie&&ie_version<9){prepareSelectAllHack();}var i=0,poll=function poll(){if(display.selForContextMenu==cm.doc.sel&&te.selectionStart==0&&te.selectionEnd>0&&input.prevInput=='\u200B'){operation(cm,selectAll)(cm);}else if(i++<10){display.detectingSelectAll=setTimeout(poll,500);}else{display.input.reset();}};display.detectingSelectAll=setTimeout(poll,200);}}if(ie&&ie_version>=9){prepareSelectAllHack();}if(captureRightClick){e_stop(e);var mouseup=function mouseup(){off(window,"mouseup",mouseup);setTimeout(rehide,20);};on(window,"mouseup",mouseup);}else{setTimeout(rehide,50);}};TextareaInput.prototype.readOnlyChanged=function(val){if(!val){this.reset();}};TextareaInput.prototype.setUneditable=function(){};TextareaInput.prototype.needsContentAttribute=false;function fromTextArea(textarea,options){options=options?copyObj(options):{};options.value=textarea.value;if(!options.tabindex&&textarea.tabIndex){options.tabindex=textarea.tabIndex;}if(!options.placeholder&&textarea.placeholder){options.placeholder=textarea.placeholder;}// Set autofocus to true if this textarea is focused, or if it has
	// autofocus and no other element is focused.
	if(options.autofocus==null){var hasFocus=activeElt();options.autofocus=hasFocus==textarea||textarea.getAttribute("autofocus")!=null&&hasFocus==document.body;}function save(){textarea.value=cm.getValue();}var realSubmit;if(textarea.form){on(textarea.form,"submit",save);// Deplorable hack to make the submit method do the right thing.
	if(!options.leaveSubmitMethodAlone){var form=textarea.form;realSubmit=form.submit;try{var wrappedSubmit=form.submit=function(){save();form.submit=realSubmit;form.submit();form.submit=wrappedSubmit;};}catch(e){}}}options.finishInit=function(cm){cm.save=save;cm.getTextArea=function(){return textarea;};cm.toTextArea=function(){cm.toTextArea=isNaN;// Prevent this from being ran twice
	save();textarea.parentNode.removeChild(cm.getWrapperElement());textarea.style.display="";if(textarea.form){off(textarea.form,"submit",save);if(typeof textarea.form.submit=="function"){textarea.form.submit=realSubmit;}}};};textarea.style.display="none";var cm=CodeMirror(function(node){return textarea.parentNode.insertBefore(node,textarea.nextSibling);},options);return cm;}function addLegacyProps(CodeMirror){CodeMirror.off=off;CodeMirror.on=on;CodeMirror.wheelEventPixels=wheelEventPixels;CodeMirror.Doc=Doc;CodeMirror.splitLines=splitLinesAuto;CodeMirror.countColumn=countColumn;CodeMirror.findColumn=findColumn;CodeMirror.isWordChar=isWordCharBasic;CodeMirror.Pass=Pass;CodeMirror.signal=signal;CodeMirror.Line=Line;CodeMirror.changeEnd=changeEnd;CodeMirror.scrollbarModel=scrollbarModel;CodeMirror.Pos=Pos;CodeMirror.cmpPos=cmp;CodeMirror.modes=modes;CodeMirror.mimeModes=mimeModes;CodeMirror.resolveMode=resolveMode;CodeMirror.getMode=getMode;CodeMirror.modeExtensions=modeExtensions;CodeMirror.extendMode=extendMode;CodeMirror.copyState=copyState;CodeMirror.startState=startState;CodeMirror.innerMode=innerMode;CodeMirror.commands=commands;CodeMirror.keyMap=keyMap;CodeMirror.keyName=keyName;CodeMirror.isModifierKey=isModifierKey;CodeMirror.lookupKey=lookupKey;CodeMirror.normalizeKeyMap=normalizeKeyMap;CodeMirror.StringStream=StringStream;CodeMirror.SharedTextMarker=SharedTextMarker;CodeMirror.TextMarker=TextMarker;CodeMirror.LineWidget=LineWidget;CodeMirror.e_preventDefault=e_preventDefault;CodeMirror.e_stopPropagation=e_stopPropagation;CodeMirror.e_stop=e_stop;CodeMirror.addClass=addClass;CodeMirror.contains=contains;CodeMirror.rmClass=rmClass;CodeMirror.keyNames=keyNames;}// EDITOR CONSTRUCTOR
	defineOptions(CodeMirror);addEditorMethods(CodeMirror);// Set up methods on CodeMirror's prototype to redirect to the editor's document.
	var dontDelegate="iter insert remove copy getEditor constructor".split(" ");for(var prop in Doc.prototype){if(Doc.prototype.hasOwnProperty(prop)&&indexOf(dontDelegate,prop)<0){CodeMirror.prototype[prop]=function(method){return function(){return method.apply(this.doc,arguments);};}(Doc.prototype[prop]);}}eventMixin(Doc);// INPUT HANDLING
	CodeMirror.inputStyles={"textarea":TextareaInput,"contenteditable":ContentEditableInput};// MODE DEFINITION AND QUERYING
	// Extra arguments are stored as the mode's dependencies, which is
	// used by (legacy) mechanisms like loadmode.js to automatically
	// load a mode. (Preferred mechanism is the require/define calls.)
	CodeMirror.defineMode=function(name/*, mode, …*/){if(!CodeMirror.defaults.mode&&name!="null"){CodeMirror.defaults.mode=name;}defineMode.apply(this,arguments);};CodeMirror.defineMIME=defineMIME;// Minimal default mode.
	CodeMirror.defineMode("null",function(){return{token:function token(stream){return stream.skipToEnd();}};});CodeMirror.defineMIME("text/plain","null");// EXTENSIONS
	CodeMirror.defineExtension=function(name,func){CodeMirror.prototype[name]=func;};CodeMirror.defineDocExtension=function(name,func){Doc.prototype[name]=func;};CodeMirror.fromTextArea=fromTextArea;addLegacyProps(CodeMirror);CodeMirror.version="5.22.0";return CodeMirror;});

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (module) {
		if (!module.webpackPolyfill) {
			module.deprecate = function () {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	
	// Adapted from https://developer.mozilla.org/en/docs/ECMAScript_DontEnum_attribute#JScript_DontEnum_Bug
	
	var hasDontEnumBug = function () {
	    var obj = {
	        constructor: function constructor() {
	            return "0";
	        },
	        toString: function toString() {
	            return "1";
	        },
	        valueOf: function valueOf() {
	            return "2";
	        },
	        toLocaleString: function toLocaleString() {
	            return "3";
	        },
	        prototype: function prototype() {
	            return "4";
	        },
	        isPrototypeOf: function isPrototypeOf() {
	            return "5";
	        },
	        propertyIsEnumerable: function propertyIsEnumerable() {
	            return "6";
	        },
	        hasOwnProperty: function hasOwnProperty() {
	            return "7";
	        },
	        length: function length() {
	            return "8";
	        },
	        unique: function unique() {
	            return "9";
	        }
	    };
	
	    var result = [];
	    for (var prop in obj) {
	        if (obj.hasOwnProperty(prop)) {
	            result.push(obj[prop]());
	        }
	    }
	    return result.join("") !== "0123456789";
	}();
	
	/* Public: Extend target in place with all (own) properties from sources in-order. Thus, last source will
	 *         override properties in previous sources.
	 *
	 * target - The Object to extend
	 * sources - Objects to copy properties from.
	 *
	 * Returns the extended target
	 */
	module.exports = function extend(target /*, sources */) {
	    var sources = Array.prototype.slice.call(arguments, 1);
	    var source, i, prop;
	
	    for (i = 0; i < sources.length; i++) {
	        source = sources[i];
	
	        for (prop in source) {
	            if (source.hasOwnProperty(prop)) {
	                target[prop] = source[prop];
	            }
	        }
	
	        // Make sure we copy (own) toString method even when in JScript with DontEnum bug
	        // See https://developer.mozilla.org/en/docs/ECMAScript_DontEnum_attribute#JScript_DontEnum_Bug
	        if (hasDontEnumBug && source.hasOwnProperty("toString") && source.toString !== target.toString) {
	            target.toString = source.toString;
	        }
	    }
	
	    return target;
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(172);
	module.exports = angular;

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (value) {
	    if (value && value.toString) {
	        return value.toString();
	    }
	    return String(value);
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	var _UtilsObjectProperties = __webpack_require__(132);
	
	var Entry = function () {
	    function Entry(entityName, values, identifierValue) {
	        _classCallCheck(this, Entry);
	
	        this._entityName = entityName;
	        this.values = values || {};
	        this._identifierValue = identifierValue;
	        this.listValues = {};
	    }
	
	    _createClass(Entry, [{
	        key: 'transformToRest',
	
	        /**
	         * Transform an Entry to a JS object for the REST API Request
	         *
	         * @return {Object}
	         */
	        value: function transformToRest(fields) {
	
	            var restEntry = (0, _UtilsObjectProperties.clone)(this.values);
	            fields.forEach(function (field) {
	                var fieldName = field.name();
	                if (fieldName in restEntry) {
	                    restEntry[fieldName] = field.getTransformedValue(restEntry[fieldName], restEntry);
	                }
	            });
	
	            return (0, _UtilsObjectProperties.cloneAndNest)(restEntry);
	        }
	    }, {
	        key: 'entityName',
	        get: function get() {
	            return this._entityName;
	        }
	    }, {
	        key: 'identifierValue',
	        get: function get() {
	            return this._identifierValue;
	        }
	    }], [{
	        key: 'createForFields',
	        value: function createForFields(fields, entityName) {
	            var entry = new Entry(entityName);
	            fields.forEach(function (field) {
	                entry.values[field.name()] = field.defaultValue();
	            });
	            return entry;
	        }
	    }, {
	        key: 'createFromRest',
	
	        /**
	         * Map a JS object from the REST API Response to an Entry
	         *
	         * @return {Entry}
	         */
	        value: function createFromRest(restEntry) {
	            var fields = arguments[1] === undefined ? [] : arguments[1];
	            var entityName = arguments[2] === undefined ? '' : arguments[2];
	            var identifierName = arguments[3] === undefined ? 'id' : arguments[3];
	
	            if (!restEntry || Object.keys(restEntry).length == 0) {
	                return Entry.createForFields(fields, entityName);
	            }
	            var excludedFields = fields.filter(function (f) {
	                return !f.flattenable();
	            }).map(function (f) {
	                return f.name();
	            });
	
	            var values = (0, _UtilsObjectProperties.cloneAndFlatten)(restEntry, excludedFields);
	
	            fields.forEach(function (field) {
	                var fieldName = field.name();
	                values[fieldName] = field.getMappedValue(values[fieldName], values);
	            });
	
	            return new Entry(entityName, values, values[identifierName]);
	        }
	    }, {
	        key: 'createArrayFromRest',
	
	        /**
	         * Map an array of JS objects from the REST API Response to an array of Entries
	         *
	         * @return {Array[Entry]}
	         */
	        value: function createArrayFromRest(restEntries, fields, entityName, identifierName) {
	            return restEntries.map(function (e) {
	                return Entry.createFromRest(e, fields, entityName, identifierName);
	            });
	        }
	    }]);
	
	    return Entry;
	}();
	
	exports['default'] = Entry;
	module.exports = exports['default'];
	//# sourceMappingURL=Entry.js.map

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	var _Entry = __webpack_require__(8);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	var _UtilsReferenceExtractor = __webpack_require__(30);
	
	var _UtilsReferenceExtractor2 = _interopRequireDefault(_UtilsReferenceExtractor);
	
	var _UtilsObjectProperties = __webpack_require__(132);
	
	var View = function () {
	    function View(name) {
	        _classCallCheck(this, View);
	
	        this.entity = null;
	        this._actions = null;
	        this._title = false;
	        this._description = '';
	        this._template = null;
	
	        this._enabled = false;
	        this._fields = [];
	        this._type = null;
	        this._name = name;
	        this._order = 0;
	        this._errorMessage = null;
	        this._url = null;
	        this._prepare = null;
	    }
	
	    _createClass(View, [{
	        key: 'title',
	        value: function title(_title) {
	            if (!arguments.length) return this._title;
	            this._title = _title;
	            return this;
	        }
	    }, {
	        key: 'description',
	        value: function description() {
	            if (arguments.length) {
	                this._description = arguments[0];
	                return this;
	            }
	
	            return this._description;
	        }
	    }, {
	        key: 'name',
	        value: function name(_name) {
	            if (!arguments.length) {
	                return this._name || this.entity.name() + '_' + this._type;
	            }
	
	            this._name = _name;
	            return this;
	        }
	    }, {
	        key: 'disable',
	        value: function disable() {
	            this._enabled = false;
	
	            return this;
	        }
	    }, {
	        key: 'enable',
	        value: function enable() {
	            this._enabled = true;
	
	            return this;
	        }
	    }, {
	        key: 'isEnabled',
	
	        /**
	         * @deprecated Use getter "enabled" instead
	         */
	        value: function isEnabled() {
	            return this.enabled;
	        }
	    }, {
	        key: 'getEntity',
	
	        /**
	         * @deprecated Use getter "entity" instead
	         */
	        value: function getEntity() {
	            return this.entity;
	        }
	    }, {
	        key: 'setEntity',
	
	        /**
	         * @deprecated Specify entity at view creation or use "entity" setter instead
	         */
	        value: function setEntity(entity) {
	            this.entity = entity;
	            if (!this._name) {
	                this._name = entity.name() + '_' + this._type;
	            }
	
	            return this;
	        }
	    }, {
	        key: 'fields',
	
	        /*
	         * Supports various syntax
	         * fields([ Field1, Field2 ])
	         * fields(Field1, Field2)
	         * fields([Field1, {Field2, Field3}])
	         * fields(Field1, {Field2, Field3})
	         * fields({Field2, Field3})
	         */
	        value: function fields() {
	            if (!arguments.length) return this._fields;
	
	            [].slice.call(arguments).map(function (argument) {
	                var _this = this;
	
	                View.flatten(argument).map(function (arg) {
	                    return _this.addField(arg);
	                });
	            }, this);
	
	            return this;
	        }
	    }, {
	        key: 'hasFields',
	        value: function hasFields() {
	            return this.fields.length > 0;
	        }
	    }, {
	        key: 'removeFields',
	        value: function removeFields() {
	            this._fields = [];
	            return this;
	        }
	    }, {
	        key: 'getFields',
	        value: function getFields() {
	            return this._fields;
	        }
	    }, {
	        key: 'getField',
	        value: function getField(fieldName) {
	            return this._fields.filter(function (f) {
	                return f.name() === fieldName;
	            })[0];
	        }
	    }, {
	        key: 'getFieldsOfType',
	        value: function getFieldsOfType(type) {
	            return this._fields.filter(function (f) {
	                return f.type() === type;
	            });
	        }
	    }, {
	        key: 'addField',
	        value: function addField(field) {
	            if (field.order() === null) {
	                field.order(this._fields.length, true);
	            }
	            this._fields.push(field);
	            this._fields = this._fields.sort(function (a, b) {
	                return a.order() - b.order();
	            });
	
	            return this;
	        }
	    }, {
	        key: 'order',
	        value: function order(_order) {
	            if (!arguments.length) return this._order;
	            this._order = _order;
	            return this;
	        }
	    }, {
	        key: 'getReferences',
	        value: function getReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getReferences(this._fields, withRemoteComplete);
	        }
	    }, {
	        key: 'getNonOptimizedReferences',
	        value: function getNonOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getNonOptimizedReferences(this._fields, withRemoteComplete);
	        }
	    }, {
	        key: 'getOptimizedReferences',
	        value: function getOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getOptimizedReferences(this._fields, withRemoteComplete);
	        }
	    }, {
	        key: 'getReferencedLists',
	        value: function getReferencedLists() {
	            return _UtilsReferenceExtractor2['default'].getReferencedLists(this._fields);
	        }
	    }, {
	        key: 'template',
	        value: function template(_template) {
	            if (!arguments.length) {
	                return this._template;
	            }
	
	            this._template = _template;
	
	            return this;
	        }
	    }, {
	        key: 'identifier',
	        value: function identifier() {
	            return this.entity.identifier();
	        }
	    }, {
	        key: 'actions',
	        value: function actions(_actions) {
	            if (!arguments.length) return this._actions;
	            this._actions = _actions;
	            return this;
	        }
	    }, {
	        key: 'getErrorMessage',
	        value: function getErrorMessage(response) {
	            if (typeof this._errorMessage === 'function') {
	                return this._errorMessage(response);
	            }
	
	            return this._errorMessage;
	        }
	    }, {
	        key: 'errorMessage',
	        value: function errorMessage(_errorMessage) {
	            if (!arguments.length) return this._errorMessage;
	            this._errorMessage = _errorMessage;
	            return this;
	        }
	    }, {
	        key: 'url',
	        value: function url(_url) {
	            if (!arguments.length) return this._url;
	            this._url = _url;
	            return this;
	        }
	    }, {
	        key: 'getUrl',
	        value: function getUrl(identifierValue) {
	            if (typeof this._url === 'function') {
	                return this._url(identifierValue);
	            }
	
	            return this._url;
	        }
	    }, {
	        key: 'validate',
	        value: function validate(entry) {
	            this._fields.map(function (field) {
	                var validation = field.validation();
	
	                if (typeof validation.validator === 'function') {
	                    validation.validator(entry.values[field.name()], entry.values);
	                }
	            });
	        }
	    }, {
	        key: 'mapEntry',
	
	        /**
	         * Map a JS object from the REST API Response to an Entry
	         */
	        value: function mapEntry(restEntry) {
	            return _Entry2['default'].createFromRest(restEntry, this._fields, this.entity.name(), this.entity.identifier().name());
	        }
	    }, {
	        key: 'mapEntries',
	        value: function mapEntries(restEntries) {
	            return _Entry2['default'].createArrayFromRest(restEntries, this._fields, this.entity.name(), this.entity.identifier().name());
	        }
	    }, {
	        key: 'transformEntry',
	
	        /**
	         * Transform an Entry to a JS object for the REST API Request
	         */
	        value: function transformEntry(entry) {
	            return entry.transformToRest(this._fields);
	        }
	    }, {
	        key: 'prepare',
	
	        /**
	         * Add a function to be executed before the view renders
	         *
	         * This is the ideal place to prefetch related entities and manipulate
	         * the dataStore.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - query: the query object (an object representation of the main request
	         *    query string)
	         *  - datastore: where the Entries are stored. The dataStore is accessible
	         *    during rendering
	         *  - view: the current View object
	         *  - entry: the current Entry instance (except in listView)
	         *  - Entry: the Entry constructor (required to transform an object from
	         *    the REST response to an Entry)
	         *  - window: the window object. If you need to fetch anything other than an
	         *    entry and pass it to the view layer, it's the only way.
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.listView().prepare(['datastore', 'view', 'Entry', function(datastore, view, Entry) {
	         *       const posts = datastore.getEntries(view.getEntity().uniqueId);
	         *       const authorIds = posts.map(post => post.values.authorId).join(',');
	         *       return fetch('http://myapi.com/authors?id[]=' + authorIds)
	         *          .then(response => response.json())
	         *          .then(authors => Entry.createArrayFromRest(
	         *              authors,
	         *              [new Field('first_name'), new Field('last_name')],
	         *              'author'
	         *          ))
	         *          .then(authorEntries => datastore.setEntries('authors', authorEntries));
	         *     }]);
	         */
	        value: function prepare(_prepare) {
	            if (!arguments.length) return this._prepare;
	            this._prepare = _prepare;
	            return this;
	        }
	    }, {
	        key: 'doPrepare',
	        value: function doPrepare() {
	            return this._prepare.apply(this, arguments);
	        }
	    }, {
	        key: 'enabled',
	        get: function get() {
	            return this._enabled || !!this._fields.length;
	        }
	    }, {
	        key: 'type',
	        get: function get() {
	            return this._type;
	        }
	    }], [{
	        key: 'flatten',
	        value: function flatten(arg) {
	            if (arg.constructor.name === 'Object') {
	                console.warn('Passing literal of Field to fields method is deprecated use array instead');
	                var result = [];
	                for (var fieldName in arg) {
	                    result = result.concat(View.flatten(arg[fieldName]));
	                }
	                return result;
	            }
	            if (Array.isArray(arg)) {
	                return arg.reduce(function (previous, current) {
	                    return previous.concat(View.flatten(current));
	                }, []);
	            }
	            // arg is a scalar
	            return [arg];
	        }
	    }]);
	
	    return View;
	}();
	
	exports['default'] = View;
	module.exports = exports['default'];
	//# sourceMappingURL=View.js.map

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Match functions
	 *
	 * @author Maximilian Antoni (mail@maxantoni.de)
	 * @license BSD
	 *
	 * Copyright (c) 2012 Maximilian Antoni
	 */
	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var create = __webpack_require__(11);
	var deepEqual = __webpack_require__(12).use(match); // eslint-disable-line no-use-before-define
	var functionName = __webpack_require__(15);
	var typeOf = __webpack_require__(138);
	var valueToString = __webpack_require__(7);
	
	function assertType(value, type, name) {
	    var actual = typeOf(value);
	    if (actual !== type) {
	        throw new TypeError("Expected type of " + name + " to be " + type + ", but was " + actual);
	    }
	}
	
	var matcher = {
	    toString: function toString() {
	        return this.message;
	    }
	};
	
	function isMatcher(object) {
	    return matcher.isPrototypeOf(object);
	}
	
	function matchObject(expectation, actual) {
	    if (actual === null || actual === undefined) {
	        return false;
	    }
	    for (var key in expectation) {
	        if (expectation.hasOwnProperty(key)) {
	            var exp = expectation[key];
	            var act = actual[key];
	            if (isMatcher(exp)) {
	                if (!exp.test(act)) {
	                    return false;
	                }
	            } else if (typeOf(exp) === "object") {
	                if (!matchObject(exp, act)) {
	                    return false;
	                }
	            } else if (!deepEqual(exp, act)) {
	                return false;
	            }
	        }
	    }
	    return true;
	}
	
	var TYPE_MAP = {
	    "function": function _function(m, expectation, message) {
	        m.test = expectation;
	        m.message = message || "match(" + functionName(expectation) + ")";
	    },
	    number: function number(m, expectation) {
	        m.test = function (actual) {
	            // we need type coercion here
	            return expectation == actual; // eslint-disable-line eqeqeq
	        };
	    },
	    object: function object(m, expectation) {
	        var array = [];
	        var key;
	
	        if (typeof expectation.test === "function") {
	            m.test = function (actual) {
	                return expectation.test(actual) === true;
	            };
	            m.message = "match(" + functionName(expectation.test) + ")";
	            return m;
	        }
	
	        for (key in expectation) {
	            if (expectation.hasOwnProperty(key)) {
	                array.push(key + ": " + valueToString(expectation[key]));
	            }
	        }
	        m.test = function (actual) {
	            return matchObject(expectation, actual);
	        };
	        m.message = "match(" + array.join(", ") + ")";
	    },
	    regexp: function regexp(m, expectation) {
	        m.test = function (actual) {
	            return typeof actual === "string" && expectation.test(actual);
	        };
	    },
	    string: function string(m, expectation) {
	        m.test = function (actual) {
	            return typeof actual === "string" && actual.indexOf(expectation) !== -1;
	        };
	        m.message = "match(\"" + expectation + "\")";
	    }
	};
	
	function match(expectation, message) {
	    var m = create(matcher);
	    var type = typeOf(expectation);
	
	    if (type in TYPE_MAP) {
	        TYPE_MAP[type](m, expectation, message);
	    } else {
	        m.test = function (actual) {
	            return deepEqual(expectation, actual);
	        };
	    }
	
	    if (!m.message) {
	        m.message = "match(" + valueToString(expectation) + ")";
	    }
	
	    return m;
	}
	
	matcher.or = function (m2) {
	    if (!arguments.length) {
	        throw new TypeError("Matcher expected");
	    } else if (!isMatcher(m2)) {
	        m2 = match(m2);
	    }
	    var m1 = this;
	    var or = create(matcher);
	    or.test = function (actual) {
	        return m1.test(actual) || m2.test(actual);
	    };
	    or.message = m1.message + ".or(" + m2.message + ")";
	    return or;
	};
	
	matcher.and = function (m2) {
	    if (!arguments.length) {
	        throw new TypeError("Matcher expected");
	    } else if (!isMatcher(m2)) {
	        m2 = match(m2);
	    }
	    var m1 = this;
	    var and = create(matcher);
	    and.test = function (actual) {
	        return m1.test(actual) && m2.test(actual);
	    };
	    and.message = m1.message + ".and(" + m2.message + ")";
	    return and;
	};
	
	match.isMatcher = isMatcher;
	
	match.any = match(function () {
	    return true;
	}, "any");
	
	match.defined = match(function (actual) {
	    return actual !== null && actual !== undefined;
	}, "defined");
	
	match.truthy = match(function (actual) {
	    return !!actual;
	}, "truthy");
	
	match.falsy = match(function (actual) {
	    return !actual;
	}, "falsy");
	
	match.same = function (expectation) {
	    return match(function (actual) {
	        return expectation === actual;
	    }, "same(" + valueToString(expectation) + ")");
	};
	
	match.typeOf = function (type) {
	    assertType(type, "string", "type");
	    return match(function (actual) {
	        return typeOf(actual) === type;
	    }, "typeOf(\"" + type + "\")");
	};
	
	match.instanceOf = function (type) {
	    assertType(type, "function", "type");
	    return match(function (actual) {
	        return actual instanceof type;
	    }, "instanceOf(" + functionName(type) + ")");
	};
	
	function createPropertyMatcher(propertyTest, messagePrefix) {
	    return function (property, value) {
	        assertType(property, "string", "property");
	        var onlyProperty = arguments.length === 1;
	        var message = messagePrefix + "(\"" + property + "\"";
	        if (!onlyProperty) {
	            message += ", " + valueToString(value);
	        }
	        message += ")";
	        return match(function (actual) {
	            if (actual === undefined || actual === null || !propertyTest(actual, property)) {
	                return false;
	            }
	            return onlyProperty || deepEqual(value, actual[property]);
	        }, message);
	    };
	}
	
	match.has = createPropertyMatcher(function (actual, property) {
	    if ((typeof actual === "undefined" ? "undefined" : _typeof(actual)) === "object") {
	        return property in actual;
	    }
	    return actual[property] !== undefined;
	}, "has");
	
	match.hasOwn = createPropertyMatcher(function (actual, property) {
	    return actual.hasOwnProperty(property);
	}, "hasOwn");
	
	match.bool = match.typeOf("boolean");
	match.number = match.typeOf("number");
	match.string = match.typeOf("string");
	match.object = match.typeOf("object");
	match.func = match.typeOf("function");
	match.array = match.typeOf("array");
	match.regexp = match.typeOf("regexp");
	match.date = match.typeOf("date");
	match.symbol = match.typeOf("symbol");
	
	module.exports = match;

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	var Klass = function Klass() {};
	
	module.exports = function create(proto) {
	    Klass.prototype = proto;
	    return new Klass();
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var div = typeof document !== "undefined" && document.createElement("div");
	
	function isReallyNaN(val) {
	    return val !== val;
	}
	
	function isDOMNode(obj) {
	    var success = false;
	
	    try {
	        obj.appendChild(div);
	        success = div.parentNode === obj;
	    } catch (e) {
	        return false;
	    } finally {
	        try {
	            obj.removeChild(div);
	        } catch (e) {
	            // Remove failed, not much we can do about that
	        }
	    }
	
	    return success;
	}
	
	function isElement(obj) {
	    return div && obj && obj.nodeType === 1 && isDOMNode(obj);
	}
	
	var deepEqual = module.exports = function deepEqual(a, b) {
	    if ((typeof a === "undefined" ? "undefined" : _typeof(a)) !== "object" || (typeof b === "undefined" ? "undefined" : _typeof(b)) !== "object") {
	        return isReallyNaN(a) && isReallyNaN(b) || a === b;
	    }
	
	    if (isElement(a) || isElement(b)) {
	        return a === b;
	    }
	
	    if (a === b) {
	        return true;
	    }
	
	    if (a === null && b !== null || a !== null && b === null) {
	        return false;
	    }
	
	    if (a instanceof RegExp && b instanceof RegExp) {
	        return a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline;
	    }
	
	    var aString = Object.prototype.toString.call(a);
	    if (aString !== Object.prototype.toString.call(b)) {
	        return false;
	    }
	
	    if (aString === "[object Date]") {
	        return a.valueOf() === b.valueOf();
	    }
	
	    var prop;
	    var aLength = 0;
	    var bLength = 0;
	
	    if (aString === "[object Array]" && a.length !== b.length) {
	        return false;
	    }
	
	    for (prop in a) {
	        if (Object.prototype.hasOwnProperty.call(a, prop)) {
	            aLength += 1;
	
	            if (!(prop in b)) {
	                return false;
	            }
	
	            // allow alternative function for recursion
	            if (!(arguments[2] || deepEqual)(a[prop], b[prop])) {
	                return false;
	            }
	        }
	    }
	
	    for (prop in b) {
	        if (Object.prototype.hasOwnProperty.call(b, prop)) {
	            bLength += 1;
	        }
	    }
	
	    return aLength === bLength;
	};
	
	deepEqual.use = function (match) {
	    return function deepEqual$matcher(a, b) {
	        if (match.isMatcher(a)) {
	            return a.test(b);
	        }
	
	        return deepEqual(a, b, deepEqual$matcher);
	    };
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Format functions
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2014 Christian Johansen
	 */
	"use strict";
	
	var formatio = __webpack_require__(181);
	
	var formatter = formatio.configure({
	    quoteStrings: false,
	    limitChildrenCount: 250
	});
	
	module.exports = function format() {
	    return formatter.ascii.apply(formatter, arguments);
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {"use strict";
	
	var nextTick = __webpack_require__(18).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function () {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function () {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout = exports.clearInterval = function (timeout) {
	  timeout.close();
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function () {};
	Timeout.prototype.close = function () {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function (item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function (item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function (item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout) item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function (fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function (id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14).setImmediate, __webpack_require__(14).clearImmediate))

/***/ },
/* 15 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function functionName(func) {
	    var name = func.displayName || func.name;
	    var matches;
	
	    // Use function decomposition as a last resort to get function
	    // name. Does not rely on function decomposition to work - if it
	    // doesn't debugging will be slightly less informative
	    // (i.e. toString will say 'spy' rather than 'myFunc').
	    if (!name && (matches = func.toString().match(/function ([^\s\(]+)/))) {
	        name = matches[1];
	    }
	
	    return name;
	};

/***/ },
/* 16 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function getPropertyDescriptor(object, property) {
	    var proto = object;
	    var descriptor;
	
	    while (proto && !(descriptor = Object.getOwnPropertyDescriptor(proto, property))) {
	        proto = Object.getPrototypeOf(proto);
	    }
	    return descriptor;
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _View2 = __webpack_require__(9);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var _UtilsOrderElement = __webpack_require__(133);
	
	var _UtilsOrderElement2 = _interopRequireDefault(_UtilsOrderElement);
	
	var ListView = function (_View) {
	    function ListView(name) {
	        _classCallCheck(this, ListView);
	
	        _get(Object.getPrototypeOf(ListView.prototype), 'constructor', this).call(this, name);
	
	        this._type = 'ListView';
	        this._perPage = 30;
	        this._infinitePagination = false;
	        this._listActions = [];
	        this._batchActions = ['delete'];
	        this._filters = [];
	        this._permanentFilters = {};
	        this._exportFields = null;
	        this._exportOptions = {};
	        this._entryCssClasses = null;
	
	        this._sortField = 'id';
	        this._sortDir = 'DESC';
	    }
	
	    _inherits(ListView, _View);
	
	    _createClass(ListView, [{
	        key: 'perPage',
	        value: function perPage() {
	            if (!arguments.length) {
	                return this._perPage;
	            }
	            this._perPage = arguments[0];
	            return this;
	        }
	    }, {
	        key: 'limit',
	
	        /** @deprecated Use perPage instead */
	        value: function limit() {
	            if (!arguments.length) {
	                return this.perPage();
	            }
	            return this.perPage(arguments[0]);
	        }
	    }, {
	        key: 'sortField',
	        value: function sortField() {
	            if (arguments.length) {
	                this._sortField = arguments[0];
	                return this;
	            }
	
	            return this._sortField;
	        }
	    }, {
	        key: 'sortDir',
	        value: function sortDir() {
	            if (arguments.length) {
	                this._sortDir = arguments[0];
	                return this;
	            }
	
	            return this._sortDir;
	        }
	    }, {
	        key: 'getSortFieldName',
	        value: function getSortFieldName() {
	            return this.name() + '.' + this._sortField;
	        }
	    }, {
	        key: 'infinitePagination',
	        value: function infinitePagination() {
	            if (arguments.length) {
	                this._infinitePagination = arguments[0];
	                return this;
	            }
	
	            return this._infinitePagination;
	        }
	    }, {
	        key: 'actions',
	        value: function actions(_actions) {
	            if (!arguments.length) {
	                return this._actions;
	            }
	
	            this._actions = _actions;
	
	            return this;
	        }
	    }, {
	        key: 'exportFields',
	        value: function exportFields(_exportFields) {
	            if (!arguments.length) {
	                return this._exportFields;
	            }
	
	            this._exportFields = _exportFields;
	
	            return this;
	        }
	    }, {
	        key: 'exportOptions',
	        value: function exportOptions(_exportOptions) {
	            if (!arguments.length) {
	                return this._exportOptions;
	            }
	
	            this._exportOptions = _exportOptions;
	
	            return this;
	        }
	    }, {
	        key: 'batchActions',
	        value: function batchActions(actions) {
	            if (!arguments.length) {
	                return this._batchActions;
	            }
	
	            this._batchActions = actions;
	
	            return this;
	        }
	    }, {
	        key: 'permanentFilters',
	
	        /**
	         * Define permanent filters to be added to the REST API calls
	         *
	         *     posts.listView().permanentFilters({
	         *        published: true
	         *     });
	         *     // related API call will be /posts?published=true
	         *
	         * @param {Object} filters list of filters to apply to the call
	         */
	        value: function permanentFilters(filters) {
	            if (!arguments.length) {
	                return this._permanentFilters;
	            }
	
	            this._permanentFilters = filters;
	
	            return this;
	        }
	    }, {
	        key: 'filters',
	
	        /**
	         * Define filters the user can add to the datagrid
	         *
	         *     posts.listView().filters([
	         *       nga.field('title'),
	         *       nga.field('age', 'number')
	         *     ]);
	         *
	         * @param {Field[]} filters list of filters to add to the GUI
	         */
	        value: function filters(_filters) {
	            if (!arguments.length) {
	                return this._filters;
	            }
	
	            this._filters = _UtilsOrderElement2['default'].order(_filters);
	
	            return this;
	        }
	    }, {
	        key: 'getFilterReferences',
	        value: function getFilterReferences(withRemoteComplete) {
	            var result = {};
	            var lists = this._filters.filter(function (f) {
	                return f.type() === 'reference';
	            });
	
	            var filterFunction = null;
	            if (withRemoteComplete === true) {
	                filterFunction = function filterFunction(f) {
	                    return f.remoteComplete();
	                };
	            } else if (withRemoteComplete === false) {
	                filterFunction = function filterFunction(f) {
	                    return !f.remoteComplete();
	                };
	            }
	
	            if (filterFunction !== null) {
	                lists = lists.filter(filterFunction);
	            }
	
	            for (var i = 0, c = lists.length; i < c; i++) {
	                var list = lists[i];
	                result[list.name()] = list;
	            }
	
	            return result;
	        }
	    }, {
	        key: 'listActions',
	        value: function listActions(actions) {
	            if (!arguments.length) {
	                return this._listActions;
	            }
	
	            this._listActions = actions;
	
	            return this;
	        }
	    }, {
	        key: 'entryCssClasses',
	        value: function entryCssClasses(classes) {
	            if (!arguments.length) {
	                return this._entryCssClasses;
	            }
	
	            this._entryCssClasses = classes;
	
	            return this;
	        }
	    }, {
	        key: 'getEntryCssClasses',
	        value: function getEntryCssClasses(entry) {
	            if (!this._entryCssClasses) {
	                return '';
	            }
	
	            if (this._entryCssClasses.constructor === Array) {
	                return this._entryCssClasses.join(' ');
	            }
	
	            if (typeof this._entryCssClasses === 'function') {
	                return this._entryCssClasses(entry);
	            }
	
	            return this._entryCssClasses;
	        }
	    }]);
	
	    return ListView;
	}(_View3['default']);
	
	exports['default'] = ListView;
	module.exports = exports['default'];
	//# sourceMappingURL=ListView.js.map

/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout() {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	})();
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while (len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () {
	    return '/';
	};
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function () {
	    return 0;
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	  * Spy calls
	  *
	  * @author Christian Johansen (christian@cjohansen.no)
	  * @author Maximilian Antoni (mail@maxantoni.de)
	  * @license BSD
	  *
	  * Copyright (c) 2010-2013 Christian Johansen
	  * Copyright (c) 2013 Maximilian Antoni
	  */
	"use strict";
	
	var sinonMatch = __webpack_require__(10);
	var deepEqual = __webpack_require__(12).use(sinonMatch);
	var functionName = __webpack_require__(15);
	var createInstance = __webpack_require__(11);
	var sinonFormat = __webpack_require__(13);
	var valueToString = __webpack_require__(7);
	var slice = Array.prototype.slice;
	
	function throwYieldError(proxy, text, args) {
	    var msg = functionName(proxy) + text;
	    if (args.length) {
	        msg += " Received [" + slice.call(args).join(", ") + "]";
	    }
	    throw new Error(msg);
	}
	
	var callProto = {
	    calledOn: function calledOn(thisValue) {
	        if (sinonMatch && sinonMatch.isMatcher(thisValue)) {
	            return thisValue.test(this.thisValue);
	        }
	        return this.thisValue === thisValue;
	    },
	
	    calledWith: function calledWith() {
	        var l = arguments.length;
	        if (l > this.args.length) {
	            return false;
	        }
	        for (var i = 0; i < l; i += 1) {
	            if (!deepEqual(arguments[i], this.args[i])) {
	                return false;
	            }
	        }
	
	        return true;
	    },
	
	    calledWithMatch: function calledWithMatch() {
	        var l = arguments.length;
	        if (l > this.args.length) {
	            return false;
	        }
	        for (var i = 0; i < l; i += 1) {
	            var actual = this.args[i];
	            var expectation = arguments[i];
	            if (!sinonMatch || !sinonMatch(expectation).test(actual)) {
	                return false;
	            }
	        }
	        return true;
	    },
	
	    calledWithExactly: function calledWithExactly() {
	        return arguments.length === this.args.length && this.calledWith.apply(this, arguments);
	    },
	
	    notCalledWith: function notCalledWith() {
	        return !this.calledWith.apply(this, arguments);
	    },
	
	    notCalledWithMatch: function notCalledWithMatch() {
	        return !this.calledWithMatch.apply(this, arguments);
	    },
	
	    returned: function returned(value) {
	        return deepEqual(value, this.returnValue);
	    },
	
	    threw: function threw(error) {
	        if (typeof error === "undefined" || !this.exception) {
	            return !!this.exception;
	        }
	
	        return this.exception === error || this.exception.name === error;
	    },
	
	    calledWithNew: function calledWithNew() {
	        return this.proxy.prototype && this.thisValue instanceof this.proxy;
	    },
	
	    calledBefore: function calledBefore(other) {
	        return this.callId < other.callId;
	    },
	
	    calledAfter: function calledAfter(other) {
	        return this.callId > other.callId;
	    },
	
	    callArg: function callArg(pos) {
	        this.args[pos]();
	    },
	
	    callArgOn: function callArgOn(pos, thisValue) {
	        this.args[pos].apply(thisValue);
	    },
	
	    callArgWith: function callArgWith(pos) {
	        this.callArgOnWith.apply(this, [pos, null].concat(slice.call(arguments, 1)));
	    },
	
	    callArgOnWith: function callArgOnWith(pos, thisValue) {
	        var args = slice.call(arguments, 2);
	        this.args[pos].apply(thisValue, args);
	    },
	
	    "yield": function _yield() {
	        this.yieldOn.apply(this, [null].concat(slice.call(arguments, 0)));
	    },
	
	    yieldOn: function yieldOn(thisValue) {
	        var args = this.args;
	        for (var i = 0, l = args.length; i < l; ++i) {
	            if (typeof args[i] === "function") {
	                args[i].apply(thisValue, slice.call(arguments, 1));
	                return;
	            }
	        }
	        throwYieldError(this.proxy, " cannot yield since no callback was passed.", args);
	    },
	
	    yieldTo: function yieldTo(prop) {
	        this.yieldToOn.apply(this, [prop, null].concat(slice.call(arguments, 1)));
	    },
	
	    yieldToOn: function yieldToOn(prop, thisValue) {
	        var args = this.args;
	        for (var i = 0, l = args.length; i < l; ++i) {
	            if (args[i] && typeof args[i][prop] === "function") {
	                args[i][prop].apply(thisValue, slice.call(arguments, 2));
	                return;
	            }
	        }
	        throwYieldError(this.proxy, " cannot yield to '" + valueToString(prop) + "' since no callback was passed.", args);
	    },
	
	    getStackFrames: function getStackFrames() {
	        // Omit the error message and the two top stack frames in sinon itself:
	        return this.stack && this.stack.split("\n").slice(3);
	    },
	
	    toString: function toString() {
	        var callStr = this.proxy ? this.proxy.toString() + "(" : "";
	        var args = [];
	
	        if (!this.args) {
	            return ":(";
	        }
	
	        for (var i = 0, l = this.args.length; i < l; ++i) {
	            args.push(sinonFormat(this.args[i]));
	        }
	
	        callStr = callStr + args.join(", ") + ")";
	
	        if (typeof this.returnValue !== "undefined") {
	            callStr += " => " + sinonFormat(this.returnValue);
	        }
	
	        if (this.exception) {
	            callStr += " !" + this.exception.name;
	
	            if (this.exception.message) {
	                callStr += "(" + this.exception.message + ")";
	            }
	        }
	        if (this.stack) {
	            callStr += this.getStackFrames()[0].replace(/^\s*(?:at\s+|@)?/, " at ");
	        }
	
	        return callStr;
	    }
	};
	
	callProto.invokeCallback = callProto.yield;
	
	function createSpyCall(spy, thisValue, args, returnValue, exception, id, stack) {
	    if (typeof id !== "number") {
	        throw new TypeError("Call id is not a number");
	    }
	    var proxyCall = createInstance(callProto);
	    proxyCall.proxy = spy;
	    proxyCall.thisValue = thisValue;
	    proxyCall.args = args;
	    proxyCall.returnValue = returnValue;
	    proxyCall.exception = exception;
	    proxyCall.callId = id;
	    proxyCall.stack = stack;
	
	    return proxyCall;
	}
	createSpyCall.toString = callProto.toString; // used by mocks
	
	module.exports = createSpyCall;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	  * Spy functions
	  *
	  * @author Christian Johansen (christian@cjohansen.no)
	  * @license BSD
	  *
	  * Copyright (c) 2010-2013 Christian Johansen
	  */
	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var extend = __webpack_require__(5);
	var functionName = __webpack_require__(15);
	var functionToString = __webpack_require__(34);
	var getPropertyDescriptor = __webpack_require__(16);
	var sinonMatch = __webpack_require__(10);
	var deepEqual = __webpack_require__(12).use(sinonMatch);
	var spyCall = __webpack_require__(19);
	var timesInWords = __webpack_require__(23);
	var wrapMethod = __webpack_require__(25);
	var sinonFormat = __webpack_require__(13);
	var valueToString = __webpack_require__(7);
	
	var push = Array.prototype.push;
	var slice = Array.prototype.slice;
	var callId = 0;
	
	function spy(object, property, types) {
	    var descriptor, i, methodDesc;
	
	    if (!property && typeof object === "function") {
	        return spy.create(object);
	    }
	
	    if (!object && !property) {
	        return spy.create(function () {});
	    }
	
	    if (types) {
	        descriptor = {};
	        methodDesc = getPropertyDescriptor(object, property);
	
	        for (i = 0; i < types.length; i++) {
	            descriptor[types[i]] = spy.create(methodDesc[types[i]]);
	        }
	        return wrapMethod(object, property, descriptor);
	    }
	
	    return wrapMethod(object, property, spy.create(object[property]));
	}
	
	function matchingFake(fakes, args, strict) {
	    if (!fakes) {
	        return undefined;
	    }
	
	    for (var i = 0, l = fakes.length; i < l; i++) {
	        if (fakes[i].matches(args, strict)) {
	            return fakes[i];
	        }
	    }
	}
	
	function incrementCallCount() {
	    this.called = true;
	    this.callCount += 1;
	    this.notCalled = false;
	    this.calledOnce = this.callCount === 1;
	    this.calledTwice = this.callCount === 2;
	    this.calledThrice = this.callCount === 3;
	}
	
	function createCallProperties() {
	    this.firstCall = this.getCall(0);
	    this.secondCall = this.getCall(1);
	    this.thirdCall = this.getCall(2);
	    this.lastCall = this.getCall(this.callCount - 1);
	}
	
	function createProxy(func, proxyLength) {
	    // Retain the function length:
	    var p;
	    if (proxyLength) {
	        // Do not change this to use an eval. Projects that depend on sinon block the use of eval.
	        // ref: https://github.com/sinonjs/sinon/issues/710
	        switch (proxyLength) {
	            /*eslint-disable no-unused-vars, max-len*/
	            case 1:
	                p = function proxy(a) {
	                    return p.invoke(func, this, slice.call(arguments));
	                };break;
	            case 2:
	                p = function proxy(a, b) {
	                    return p.invoke(func, this, slice.call(arguments));
	                };break;
	            case 3:
	                p = function proxy(a, b, c) {
	                    return p.invoke(func, this, slice.call(arguments));
	                };break;
	            case 4:
	                p = function proxy(a, b, c, d) {
	                    return p.invoke(func, this, slice.call(arguments));
	                };break;
	            case 5:
	                p = function proxy(a, b, c, d, e) {
	                    return p.invoke(func, this, slice.call(arguments));
	                };break;
	            case 6:
	                p = function proxy(a, b, c, d, e, f) {
	                    return p.invoke(func, this, slice.call(arguments));
	                };break;
	            case 7:
	                p = function proxy(a, b, c, d, e, f, g) {
	                    return p.invoke(func, this, slice.call(arguments));
	                };break;
	            case 8:
	                p = function proxy(a, b, c, d, e, f, g, h) {
	                    return p.invoke(func, this, slice.call(arguments));
	                };break;
	            case 9:
	                p = function proxy(a, b, c, d, e, f, g, h, i) {
	                    return p.invoke(func, this, slice.call(arguments));
	                };break;
	            case 10:
	                p = function proxy(a, b, c, d, e, f, g, h, i, j) {
	                    return p.invoke(func, this, slice.call(arguments));
	                };break;
	            case 11:
	                p = function proxy(a, b, c, d, e, f, g, h, i, j, k) {
	                    return p.invoke(func, this, slice.call(arguments));
	                };break;
	            case 12:
	                p = function proxy(a, b, c, d, e, f, g, h, i, j, k, l) {
	                    return p.invoke(func, this, slice.call(arguments));
	                };break;
	            default:
	                p = function proxy() {
	                    return p.invoke(func, this, slice.call(arguments));
	                };break;
	            /*eslint-enable*/
	        }
	    } else {
	        p = function proxy() {
	            return p.invoke(func, this, slice.call(arguments));
	        };
	    }
	    p.isSinonProxy = true;
	    return p;
	}
	
	var uuid = 0;
	
	// Public API
	var spyApi = {
	    reset: function reset() {
	        if (this.invoking) {
	            var err = new Error("Cannot reset Sinon function while invoking it. " + "Move the call to .reset outside of the callback.");
	            err.name = "InvalidResetException";
	            throw err;
	        }
	
	        this.called = false;
	        this.notCalled = true;
	        this.calledOnce = false;
	        this.calledTwice = false;
	        this.calledThrice = false;
	        this.callCount = 0;
	        this.firstCall = null;
	        this.secondCall = null;
	        this.thirdCall = null;
	        this.lastCall = null;
	        this.args = [];
	        this.returnValues = [];
	        this.thisValues = [];
	        this.exceptions = [];
	        this.callIds = [];
	        this.stacks = [];
	        if (this.fakes) {
	            for (var i = 0; i < this.fakes.length; i++) {
	                this.fakes[i].reset();
	            }
	        }
	
	        return this;
	    },
	
	    create: function create(func, spyLength) {
	        var name;
	
	        if (typeof func !== "function") {
	            func = function func() {};
	        } else {
	            name = functionName(func);
	        }
	
	        if (!spyLength) {
	            spyLength = func.length;
	        }
	
	        var proxy = createProxy(func, spyLength);
	
	        extend(proxy, spy);
	        delete proxy.create;
	        extend(proxy, func);
	
	        proxy.reset();
	        proxy.prototype = func.prototype;
	        proxy.displayName = name || "spy";
	        proxy.toString = functionToString;
	        proxy.instantiateFake = spy.create;
	        proxy.id = "spy#" + uuid++;
	
	        return proxy;
	    },
	
	    invoke: function invoke(func, thisValue, args) {
	        var matching = matchingFake(this.fakes, args);
	        var exception, returnValue;
	
	        incrementCallCount.call(this);
	        push.call(this.thisValues, thisValue);
	        push.call(this.args, args);
	        push.call(this.callIds, callId++);
	
	        // Make call properties available from within the spied function:
	        createCallProperties.call(this);
	
	        try {
	            this.invoking = true;
	
	            if (matching) {
	                returnValue = matching.invoke(func, thisValue, args);
	            } else {
	                returnValue = (this.func || func).apply(thisValue, args);
	            }
	
	            var thisCall = this.getCall(this.callCount - 1);
	            if (thisCall.calledWithNew() && (typeof returnValue === "undefined" ? "undefined" : _typeof(returnValue)) !== "object") {
	                returnValue = thisValue;
	            }
	        } catch (e) {
	            exception = e;
	        } finally {
	            delete this.invoking;
	        }
	
	        push.call(this.exceptions, exception);
	        push.call(this.returnValues, returnValue);
	        var err = new Error();
	        var stack = err.stack;
	        if (!stack) {
	            // PhantomJS does not serialize the stack trace until the error has been thrown:
	            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/Stack
	            try {
	                throw err;
	            } catch (e) {/* empty */}
	        }
	        push.call(this.stacks, err.stack);
	
	        // Make return value and exception available in the calls:
	        createCallProperties.call(this);
	
	        if (exception !== undefined) {
	            throw exception;
	        }
	
	        return returnValue;
	    },
	
	    named: function named(name) {
	        this.displayName = name;
	        return this;
	    },
	
	    getCall: function getCall(i) {
	        if (i < 0 || i >= this.callCount) {
	            return null;
	        }
	
	        return spyCall(this, this.thisValues[i], this.args[i], this.returnValues[i], this.exceptions[i], this.callIds[i], this.stacks[i]);
	    },
	
	    getCalls: function getCalls() {
	        var calls = [];
	        var i;
	
	        for (i = 0; i < this.callCount; i++) {
	            calls.push(this.getCall(i));
	        }
	
	        return calls;
	    },
	
	    calledBefore: function calledBefore(spyFn) {
	        if (!this.called) {
	            return false;
	        }
	
	        if (!spyFn.called) {
	            return true;
	        }
	
	        return this.callIds[0] < spyFn.callIds[spyFn.callIds.length - 1];
	    },
	
	    calledAfter: function calledAfter(spyFn) {
	        if (!this.called || !spyFn.called) {
	            return false;
	        }
	
	        return this.callIds[this.callCount - 1] > spyFn.callIds[spyFn.callCount - 1];
	    },
	
	    withArgs: function withArgs() {
	        var args = slice.call(arguments);
	
	        if (this.fakes) {
	            var match = matchingFake(this.fakes, args, true);
	
	            if (match) {
	                return match;
	            }
	        } else {
	            this.fakes = [];
	        }
	
	        var original = this;
	        var fake = this.instantiateFake();
	        fake.matchingAguments = args;
	        fake.parent = this;
	        push.call(this.fakes, fake);
	
	        fake.withArgs = function () {
	            return original.withArgs.apply(original, arguments);
	        };
	
	        for (var i = 0; i < this.args.length; i++) {
	            if (fake.matches(this.args[i])) {
	                incrementCallCount.call(fake);
	                push.call(fake.thisValues, this.thisValues[i]);
	                push.call(fake.args, this.args[i]);
	                push.call(fake.returnValues, this.returnValues[i]);
	                push.call(fake.exceptions, this.exceptions[i]);
	                push.call(fake.callIds, this.callIds[i]);
	            }
	        }
	        createCallProperties.call(fake);
	
	        return fake;
	    },
	
	    matches: function matches(args, strict) {
	        var margs = this.matchingAguments;
	
	        if (margs.length <= args.length && deepEqual(margs, args.slice(0, margs.length))) {
	            return !strict || margs.length === args.length;
	        }
	    },
	
	    printf: function printf(format) {
	        var spyInstance = this;
	        var args = slice.call(arguments, 1);
	        var formatter;
	
	        return (format || "").replace(/%(.)/g, function (match, specifyer) {
	            formatter = spyApi.formatters[specifyer];
	
	            if (typeof formatter === "function") {
	                return formatter.call(null, spyInstance, args);
	            } else if (!isNaN(parseInt(specifyer, 10))) {
	                return sinonFormat(args[specifyer - 1]);
	            }
	
	            return "%" + specifyer;
	        });
	    }
	};
	
	function delegateToCalls(method, matchAny, actual, notCalled) {
	    spyApi[method] = function () {
	        if (!this.called) {
	            if (notCalled) {
	                return notCalled.apply(this, arguments);
	            }
	            return false;
	        }
	
	        var currentCall;
	        var matches = 0;
	
	        for (var i = 0, l = this.callCount; i < l; i += 1) {
	            currentCall = this.getCall(i);
	
	            if (currentCall[actual || method].apply(currentCall, arguments)) {
	                matches += 1;
	
	                if (matchAny) {
	                    return true;
	                }
	            }
	        }
	
	        return matches === this.callCount;
	    };
	}
	
	delegateToCalls("calledOn", true);
	delegateToCalls("alwaysCalledOn", false, "calledOn");
	delegateToCalls("calledWith", true);
	delegateToCalls("calledWithMatch", true);
	delegateToCalls("alwaysCalledWith", false, "calledWith");
	delegateToCalls("alwaysCalledWithMatch", false, "calledWithMatch");
	delegateToCalls("calledWithExactly", true);
	delegateToCalls("alwaysCalledWithExactly", false, "calledWithExactly");
	delegateToCalls("neverCalledWith", false, "notCalledWith", function () {
	    return true;
	});
	delegateToCalls("neverCalledWithMatch", false, "notCalledWithMatch", function () {
	    return true;
	});
	delegateToCalls("threw", true);
	delegateToCalls("alwaysThrew", false, "threw");
	delegateToCalls("returned", true);
	delegateToCalls("alwaysReturned", false, "returned");
	delegateToCalls("calledWithNew", true);
	delegateToCalls("alwaysCalledWithNew", false, "calledWithNew");
	delegateToCalls("callArg", false, "callArgWith", function () {
	    throw new Error(this.toString() + " cannot call arg since it was not yet invoked.");
	});
	spyApi.callArgWith = spyApi.callArg;
	delegateToCalls("callArgOn", false, "callArgOnWith", function () {
	    throw new Error(this.toString() + " cannot call arg since it was not yet invoked.");
	});
	spyApi.callArgOnWith = spyApi.callArgOn;
	delegateToCalls("yield", false, "yield", function () {
	    throw new Error(this.toString() + " cannot yield since it was not yet invoked.");
	});
	// "invokeCallback" is an alias for "yield" since "yield" is invalid in strict mode.
	spyApi.invokeCallback = spyApi.yield;
	delegateToCalls("yieldOn", false, "yieldOn", function () {
	    throw new Error(this.toString() + " cannot yield since it was not yet invoked.");
	});
	delegateToCalls("yieldTo", false, "yieldTo", function (property) {
	    throw new Error(this.toString() + " cannot yield to '" + valueToString(property) + "' since it was not yet invoked.");
	});
	delegateToCalls("yieldToOn", false, "yieldToOn", function (property) {
	    throw new Error(this.toString() + " cannot yield to '" + valueToString(property) + "' since it was not yet invoked.");
	});
	
	spyApi.formatters = {
	    c: function c(spyInstance) {
	        return timesInWords(spyInstance.callCount);
	    },
	
	    n: function n(spyInstance) {
	        return spyInstance.toString();
	    },
	
	    C: function C(spyInstance) {
	        var calls = [];
	
	        for (var i = 0, l = spyInstance.callCount; i < l; ++i) {
	            var stringifiedCall = "    " + spyInstance.getCall(i).toString();
	            if (/\n/.test(calls[i - 1])) {
	                stringifiedCall = "\n" + stringifiedCall;
	            }
	            push.call(calls, stringifiedCall);
	        }
	
	        return calls.length > 0 ? "\n" + calls.join("\n") : "";
	    },
	
	    t: function t(spyInstance) {
	        var objects = [];
	
	        for (var i = 0, l = spyInstance.callCount; i < l; ++i) {
	            push.call(objects, sinonFormat(spyInstance.thisValues[i]));
	        }
	
	        return objects.join(", ");
	    },
	
	    "*": function _(spyInstance, args) {
	        var formatted = [];
	
	        for (var i = 0, l = args.length; i < l; ++i) {
	            push.call(formatted, sinonFormat(args[i]));
	        }
	
	        return formatted.join(", ");
	    }
	};
	
	extend(spy, spyApi);
	
	spy.spyCall = spyCall;
	
	module.exports = spy;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Sinon core utilities. For internal use only.
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2013 Christian Johansen
	 */
	"use strict";
	
	exports.wrapMethod = __webpack_require__(25);
	
	exports.create = __webpack_require__(11);
	
	exports.deepEqual = __webpack_require__(12);
	
	exports.format = __webpack_require__(13);
	
	exports.functionName = __webpack_require__(15);
	
	exports.functionToString = __webpack_require__(34);
	
	exports.objectKeys = __webpack_require__(35);
	
	exports.getPropertyDescriptor = __webpack_require__(16);
	
	exports.getConfig = __webpack_require__(334);
	
	exports.defaultConfig = __webpack_require__(140);
	
	exports.timesInWords = __webpack_require__(23);
	
	exports.calledInOrder = __webpack_require__(139);
	
	exports.orderByFirstCall = __webpack_require__(141);
	
	exports.walk = __webpack_require__(24);
	
	exports.restore = __webpack_require__(335);
	
	exports.configureLogError = __webpack_require__(22);

/***/ },
/* 22 */
/***/ function(module, exports) {

	/**
	 * Logs errors
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2014 Christian Johansen
	 */
	"use strict";
	
	// cache a reference to setTimeout, so that our reference won't be stubbed out
	// when using fake timers and errors will still get logged
	// https://github.com/cjohansen/Sinon.JS/issues/381
	
	var realSetTimeout = setTimeout;
	
	function configure(config) {
	    config = config || {};
	    // Function which prints errors.
	    if (!config.hasOwnProperty("logger")) {
	        config.logger = function () {};
	    }
	    // When set to true, any errors logged will be thrown immediately;
	    // If set to false, the errors will be thrown in separate execution frame.
	    if (!config.hasOwnProperty("useImmediateExceptions")) {
	        config.useImmediateExceptions = true;
	    }
	    // wrap realSetTimeout with something we can stub in tests
	    if (!config.hasOwnProperty("setTimeout")) {
	        config.setTimeout = realSetTimeout;
	    }
	
	    return function logError(label, e) {
	        var msg = label + " threw exception: ";
	        var err = { name: e.name || label, message: e.message || e.toString(), stack: e.stack };
	
	        function throwLoggedError() {
	            err.message = msg + err.message;
	            throw err;
	        }
	
	        config.logger(msg + "[" + err.name + "] " + err.message);
	
	        if (err.stack) {
	            config.logger(err.stack);
	        }
	
	        if (config.useImmediateExceptions) {
	            throwLoggedError();
	        } else {
	            config.setTimeout(throwLoggedError, 0);
	        }
	    };
	}
	
	module.exports = configure;

/***/ },
/* 23 */
/***/ function(module, exports) {

	"use strict";
	
	var array = [null, "once", "twice", "thrice"];
	
	module.exports = function timesInWords(count) {
	    return array[count] || (count || 0) + " times";
	};

/***/ },
/* 24 */
/***/ function(module, exports) {

	"use strict";
	
	function walkInternal(obj, iterator, context, originalObj, seen) {
	    var proto, prop;
	
	    if (typeof Object.getOwnPropertyNames !== "function") {
	        // We explicitly want to enumerate through all of the prototype's properties
	        // in this case, therefore we deliberately leave out an own property check.
	        /* eslint-disable guard-for-in */
	        for (prop in obj) {
	            iterator.call(context, obj[prop], prop, obj);
	        }
	        /* eslint-enable guard-for-in */
	
	        return;
	    }
	
	    Object.getOwnPropertyNames(obj).forEach(function (k) {
	        if (!seen[k]) {
	            seen[k] = true;
	            var target = typeof Object.getOwnPropertyDescriptor(obj, k).get === "function" ? originalObj : obj;
	            iterator.call(context, k, target);
	        }
	    });
	
	    proto = Object.getPrototypeOf(obj);
	    if (proto) {
	        walkInternal(proto, iterator, context, originalObj, seen);
	    }
	}
	
	/* Walks the prototype chain of an object and iterates over every own property
	 * name encountered. The iterator is called in the same fashion that Array.prototype.forEach
	 * works, where it is passed the value, key, and own object as the 1st, 2nd, and 3rd positional
	 * argument, respectively. In cases where Object.getOwnPropertyNames is not available, walk will
	 * default to using a simple for..in loop.
	 *
	 * obj - The object to walk the prototype chain for.
	 * iterator - The function to be called on each pass of the walk.
	 * context - (Optional) When given, the iterator will be called with this object as the receiver.
	 */
	module.exports = function walk(obj, iterator, context) {
	    return walkInternal(obj, iterator, context, obj, {});
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var getPropertyDescriptor = __webpack_require__(16);
	var objectKeys = __webpack_require__(35);
	var valueToString = __webpack_require__(7);
	
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function isFunction(obj) {
	    return typeof obj === "function" || !!(obj && obj.constructor && obj.call && obj.apply);
	}
	
	function mirrorProperties(target, source) {
	    for (var prop in source) {
	        if (!hasOwn.call(target, prop)) {
	            target[prop] = source[prop];
	        }
	    }
	}
	
	// Cheap way to detect if we have ES5 support.
	var hasES5Support = "keys" in Object;
	
	module.exports = function wrapMethod(object, property, method) {
	    if (!object) {
	        throw new TypeError("Should wrap property of object");
	    }
	
	    if (typeof method !== "function" && (typeof method === "undefined" ? "undefined" : _typeof(method)) !== "object") {
	        throw new TypeError("Method wrapper should be a function or a property descriptor");
	    }
	
	    function checkWrappedMethod(wrappedMethod) {
	        var error;
	
	        if (!isFunction(wrappedMethod)) {
	            error = new TypeError("Attempted to wrap " + (typeof wrappedMethod === "undefined" ? "undefined" : _typeof(wrappedMethod)) + " property " + valueToString(property) + " as function");
	        } else if (wrappedMethod.restore && wrappedMethod.restore.sinon) {
	            error = new TypeError("Attempted to wrap " + valueToString(property) + " which is already wrapped");
	        } else if (wrappedMethod.calledBefore) {
	            var verb = wrappedMethod.returns ? "stubbed" : "spied on";
	            error = new TypeError("Attempted to wrap " + valueToString(property) + " which is already " + verb);
	        }
	
	        if (error) {
	            if (wrappedMethod && wrappedMethod.stackTrace) {
	                error.stack += "\n--------------\n" + wrappedMethod.stackTrace;
	            }
	            throw error;
	        }
	    }
	
	    var error, wrappedMethod, i;
	
	    // IE 8 does not support hasOwnProperty on the window object and Firefox has a problem
	    // when using hasOwn.call on objects from other frames.
	    var owned = object.hasOwnProperty ? object.hasOwnProperty(property) : hasOwn.call(object, property);
	
	    if (hasES5Support) {
	        var methodDesc = typeof method === "function" ? { value: method } : method;
	        var wrappedMethodDesc = getPropertyDescriptor(object, property);
	
	        if (!wrappedMethodDesc) {
	            error = new TypeError("Attempted to wrap " + (typeof wrappedMethod === "undefined" ? "undefined" : _typeof(wrappedMethod)) + " property " + property + " as function");
	        } else if (wrappedMethodDesc.restore && wrappedMethodDesc.restore.sinon) {
	            error = new TypeError("Attempted to wrap " + property + " which is already wrapped");
	        }
	        if (error) {
	            if (wrappedMethodDesc && wrappedMethodDesc.stackTrace) {
	                error.stack += "\n--------------\n" + wrappedMethodDesc.stackTrace;
	            }
	            throw error;
	        }
	
	        var types = objectKeys(methodDesc);
	        for (i = 0; i < types.length; i++) {
	            wrappedMethod = wrappedMethodDesc[types[i]];
	            checkWrappedMethod(wrappedMethod);
	        }
	
	        mirrorProperties(methodDesc, wrappedMethodDesc);
	        for (i = 0; i < types.length; i++) {
	            mirrorProperties(methodDesc[types[i]], wrappedMethodDesc[types[i]]);
	        }
	        Object.defineProperty(object, property, methodDesc);
	    } else {
	        wrappedMethod = object[property];
	        checkWrappedMethod(wrappedMethod);
	        object[property] = method;
	        method.displayName = property;
	    }
	
	    method.displayName = property;
	
	    // Set up a stack trace which can be used later to find what line of
	    // code the original method was created on.
	    method.stackTrace = new Error("Stack Trace for original").stack;
	
	    method.restore = function () {
	        // For prototype properties try to reset by delete first.
	        // If this fails (ex: localStorage on mobile safari) then force a reset
	        // via direct assignment.
	        if (!owned) {
	            // In some cases `delete` may throw an error
	            try {
	                delete object[property];
	            } catch (e) {} // eslint-disable-line no-empty
	            // For native code functions `delete` fails without throwing an error
	            // on Chrome < 43, PhantomJS, etc.
	        } else if (hasES5Support) {
	            Object.defineProperty(object, property, wrappedMethodDesc);
	        }
	
	        if (hasES5Support) {
	            var descriptor = getPropertyDescriptor(object, property);
	            if (descriptor && descriptor.value === method) {
	                object[property] = wrappedMethod;
	            }
	        } else {
	            // Use strict equality comparison to check failures then force a reset
	            // via direct assignment.
	            if (object[property] === method) {
	                object[property] = wrappedMethod;
	            }
	        }
	    };
	
	    method.restore.sinon = true;
	
	    if (!hasES5Support) {
	        mirrorProperties(method, wrappedMethod);
	    }
	
	    return method;
	};

/***/ },
/* 26 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var _UtilsStringUtils = __webpack_require__(134);
	
	var _UtilsStringUtils2 = _interopRequireDefault(_UtilsStringUtils);
	
	var _FieldField = __webpack_require__(2);
	
	var _FieldField2 = _interopRequireDefault(_FieldField);
	
	var _ViewDashboardView = __webpack_require__(317);
	
	var _ViewDashboardView2 = _interopRequireDefault(_ViewDashboardView);
	
	var _ViewMenuView = __webpack_require__(321);
	
	var _ViewMenuView2 = _interopRequireDefault(_ViewMenuView);
	
	var _ViewListView = __webpack_require__(17);
	
	var _ViewListView2 = _interopRequireDefault(_ViewListView);
	
	var _ViewCreateView = __webpack_require__(316);
	
	var _ViewCreateView2 = _interopRequireDefault(_ViewCreateView);
	
	var _ViewEditView = __webpack_require__(319);
	
	var _ViewEditView2 = _interopRequireDefault(_ViewEditView);
	
	var _ViewDeleteView = __webpack_require__(318);
	
	var _ViewDeleteView2 = _interopRequireDefault(_ViewDeleteView);
	
	var _ViewShowView = __webpack_require__(322);
	
	var _ViewShowView2 = _interopRequireDefault(_ViewShowView);
	
	var _ViewBatchDeleteView = __webpack_require__(315);
	
	var _ViewBatchDeleteView2 = _interopRequireDefault(_ViewBatchDeleteView);
	
	var _ViewExportView = __webpack_require__(320);
	
	var _ViewExportView2 = _interopRequireDefault(_ViewExportView);
	
	var index = 0;
	
	var Entity = function () {
	    function Entity(name) {
	        _classCallCheck(this, Entity);
	
	        this._name = name;
	        this._uniqueId = this._name + "_" + index++;
	        this._baseApiUrl = null;
	        this._label = null;
	        this._identifierField = new _FieldField2["default"]("id");
	        this._isReadOnly = false;
	        this._errorMessage = null;
	        this._order = 0;
	        this._url = null;
	        this._createMethod = null; // manually set the HTTP-method for create operation, defaults to post
	        this._updateMethod = null; // manually set the HTTP-method for update operation, defaults to put
	        this._retrieveMethod = null; // manually set the HTTP-method for the get operation, defaults to get
	        this._deleteMethod = null; // manually set the HTTP-method for the delete operation, defaults to delete
	
	        this._initViews();
	    }
	
	    _createClass(Entity, [{
	        key: "label",
	        value: function label() {
	            if (arguments.length) {
	                this._label = arguments[0];
	                return this;
	            }
	
	            if (this._label === null) {
	                return _UtilsStringUtils2["default"].camelCase(this._name);
	            }
	
	            return this._label;
	        }
	    }, {
	        key: "name",
	        value: function name() {
	            if (arguments.length) {
	                this._name = arguments[0];
	                return this;
	            }
	
	            return this._name;
	        }
	    }, {
	        key: "menuView",
	        value: function menuView() {
	            return this._views["MenuView"];
	        }
	    }, {
	        key: "dashboardView",
	        value: function dashboardView() {
	            return this._views["DashboardView"];
	        }
	    }, {
	        key: "listView",
	        value: function listView() {
	            return this._views["ListView"];
	        }
	    }, {
	        key: "creationView",
	        value: function creationView() {
	            return this._views["CreateView"];
	        }
	    }, {
	        key: "editionView",
	        value: function editionView() {
	            return this._views["EditView"];
	        }
	    }, {
	        key: "deletionView",
	        value: function deletionView() {
	            return this._views["DeleteView"];
	        }
	    }, {
	        key: "batchDeleteView",
	        value: function batchDeleteView() {
	            return this._views["BatchDeleteView"];
	        }
	    }, {
	        key: "exportView",
	        value: function exportView() {
	            return this._views["ExportView"];
	        }
	    }, {
	        key: "showView",
	        value: function showView() {
	            return this._views["ShowView"];
	        }
	    }, {
	        key: "baseApiUrl",
	        value: function baseApiUrl(_baseApiUrl) {
	            if (!arguments.length) return this._baseApiUrl;
	            this._baseApiUrl = _baseApiUrl;
	            return this;
	        }
	    }, {
	        key: "_initViews",
	        value: function _initViews() {
	            this._views = {
	                "DashboardView": new _ViewDashboardView2["default"]().setEntity(this),
	                "MenuView": new _ViewMenuView2["default"]().setEntity(this),
	                "ListView": new _ViewListView2["default"]().setEntity(this),
	                "CreateView": new _ViewCreateView2["default"]().setEntity(this),
	                "EditView": new _ViewEditView2["default"]().setEntity(this),
	                "DeleteView": new _ViewDeleteView2["default"]().setEntity(this),
	                "BatchDeleteView": new _ViewBatchDeleteView2["default"]().setEntity(this),
	                "ExportView": new _ViewExportView2["default"]().setEntity(this),
	                "ShowView": new _ViewShowView2["default"]().setEntity(this)
	            };
	        }
	    }, {
	        key: "identifier",
	        value: function identifier(value) {
	            if (!arguments.length) return this._identifierField;
	            if (!(value instanceof _FieldField2["default"])) {
	                throw new Error("Entity " + this.name() + ": identifier must be an instance of Field.");
	            }
	            this._identifierField = value;
	            return this;
	        }
	    }, {
	        key: "readOnly",
	        value: function readOnly() {
	            this._isReadOnly = true;
	
	            this._views["CreateView"].disable();
	            this._views["EditView"].disable();
	            this._views["DeleteView"].disable();
	            this._views["BatchDeleteView"].disable();
	
	            return this;
	        }
	    }, {
	        key: "getErrorMessage",
	        value: function getErrorMessage(response) {
	            if (typeof this._errorMessage === "function") {
	                return this._errorMessage(response);
	            }
	
	            return this._errorMessage;
	        }
	    }, {
	        key: "errorMessage",
	        value: function errorMessage(_errorMessage) {
	            if (!arguments.length) return this._errorMessage;
	            this._errorMessage = _errorMessage;
	            return this;
	        }
	    }, {
	        key: "order",
	        value: function order(_order) {
	            if (!arguments.length) return this._order;
	            this._order = _order;
	            return this;
	        }
	    }, {
	        key: "url",
	        value: function url(_url) {
	            if (!arguments.length) return this._url;
	            this._url = _url;
	            return this;
	        }
	    }, {
	        key: "getUrl",
	        value: function getUrl(viewType, identifierValue, identifierName) {
	            if (typeof this._url === "function") {
	                return this._url(this.name(), viewType, identifierValue, identifierName);
	            }
	
	            return this._url;
	        }
	    }, {
	        key: "createMethod",
	        value: function createMethod(_createMethod) {
	            if (!arguments.length) return this._createMethod;
	            this._createMethod = _createMethod;
	            return this;
	        }
	    }, {
	        key: "updateMethod",
	        value: function updateMethod(_updateMethod) {
	            if (!arguments.length) return this._updateMethod;
	            this._updateMethod = _updateMethod;
	            return this;
	        }
	    }, {
	        key: "retrieveMethod",
	        value: function retrieveMethod(_retrieveMethod) {
	            if (!arguments.length) return this._retrieveMethod;
	            this._retrieveMethod = _retrieveMethod;
	            return this;
	        }
	    }, {
	        key: "deleteMethod",
	        value: function deleteMethod(_deleteMethod) {
	            if (!arguments.length) return this._deleteMethod;
	            this._deleteMethod = _deleteMethod;
	            return this;
	        }
	    }, {
	        key: "uniqueId",
	        get: function get() {
	            return this._uniqueId;
	        }
	    }, {
	        key: "views",
	        get: function get() {
	            return this._views;
	        }
	    }, {
	        key: "isReadOnly",
	        get: function get() {
	            return this._isReadOnly;
	        }
	    }]);
	
	    return Entity;
	}();
	
	exports["default"] = Entity;
	module.exports = exports["default"];
	//# sourceMappingURL=Entity.js.map

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var ChoiceField = function (_Field) {
	    function ChoiceField(name) {
	        _classCallCheck(this, ChoiceField);
	
	        _get(Object.getPrototypeOf(ChoiceField.prototype), "constructor", this).call(this, name);
	        this._type = "choice";
	        this._choices = [];
	    }
	
	    _inherits(ChoiceField, _Field);
	
	    _createClass(ChoiceField, [{
	        key: "choices",
	        value: function choices(_choices) {
	            if (!arguments.length) return this._choices;
	            this._choices = _choices;
	
	            return this;
	        }
	    }, {
	        key: "getLabelForChoice",
	        value: function getLabelForChoice(value, entry) {
	            var choices = typeof this._choices === "function" ? this._choices(entry) : this._choices;
	            var choice = choices.filter(function (c) {
	                return c.value == value;
	            }).pop();
	            return choice ? choice.label : null;
	        }
	    }]);
	
	    return ChoiceField;
	}(_Field3["default"]);
	
	exports["default"] = ChoiceField;
	module.exports = exports["default"];
	//# sourceMappingURL=ChoiceField.js.map

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var ReferenceField = function (_Field) {
	    function ReferenceField(name) {
	        _classCallCheck(this, ReferenceField);
	
	        _get(Object.getPrototypeOf(ReferenceField.prototype), 'constructor', this).call(this, name);
	        this._type = 'reference';
	        this._targetEntity = null;
	        this._targetField = null;
	        this._perPage = 30;
	        this._permanentFilters = null;
	        this._sortField = null;
	        this._sortDir = null;
	        this._singleApiCall = false;
	        this._detailLink = true;
	        this._remoteComplete = false;
	        this._remoteCompleteOptions = {
	            refreshDelay: 500
	        };
	    }
	
	    _inherits(ReferenceField, _Field);
	
	    _createClass(ReferenceField, [{
	        key: 'perPage',
	        value: function perPage(_perPage) {
	            if (!arguments.length) return this._perPage;
	            this._perPage = _perPage;
	            return this;
	        }
	    }, {
	        key: 'datagridName',
	        value: function datagridName() {
	            return this._targetEntity.name() + '_ListView';
	        }
	    }, {
	        key: 'targetEntity',
	        value: function targetEntity(entity) {
	            if (!arguments.length) {
	                return this._targetEntity;
	            }
	            this._targetEntity = entity;
	
	            return this;
	        }
	    }, {
	        key: 'targetField',
	        value: function targetField(field) {
	            if (!arguments.length) return this._targetField;
	            this._targetField = field;
	
	            return this;
	        }
	    }, {
	        key: 'permanentFilters',
	
	        /**
	         * Define permanent filters to be added to the REST API calls
	         *
	         *     nga.field('post_id', 'reference').permanentFilters({
	         *        published: true
	         *     });
	         *     // related API call will be /posts/:id?published=true
	         *
	         * @param {Object} filters list of filters to apply to the call
	         */
	        value: function permanentFilters(filters) {
	            if (!arguments.length) {
	                return this._permanentFilters;
	            }
	
	            this._permanentFilters = filters;
	
	            return this;
	        }
	    }, {
	        key: 'filters',
	
	        /**
	         * @deprecated use permanentFilters() instead
	         */
	        value: function filters(_filters) {
	            console.warn('ReferenceField.filters() is deprecated, please use ReferenceField.permanentFilters() instead');
	            return this.permanentFilters(_filters);
	        }
	    }, {
	        key: 'sortField',
	        value: function sortField() {
	            if (arguments.length) {
	                this._sortField = arguments[0];
	                return this;
	            }
	
	            return this._sortField;
	        }
	    }, {
	        key: 'sortDir',
	        value: function sortDir() {
	            if (arguments.length) {
	                this._sortDir = arguments[0];
	                return this;
	            }
	
	            return this._sortDir;
	        }
	    }, {
	        key: 'singleApiCall',
	        value: function singleApiCall(_singleApiCall) {
	            if (!arguments.length) return this._singleApiCall;
	            this._singleApiCall = _singleApiCall;
	            return this;
	        }
	    }, {
	        key: 'hasSingleApiCall',
	        value: function hasSingleApiCall() {
	            return typeof this._singleApiCall === 'function';
	        }
	    }, {
	        key: 'getSingleApiCall',
	        value: function getSingleApiCall(identifiers) {
	            return this.hasSingleApiCall() ? this._singleApiCall(identifiers) : this._singleApiCall;
	        }
	    }, {
	        key: 'getIdentifierValues',
	        value: function getIdentifierValues(rawValues) {
	            var results = {};
	            var identifierName = this._name;
	            for (var i = 0, l = rawValues.length; i < l; i++) {
	                var identifier = rawValues[i][identifierName];
	                if (identifier == null) {
	                    continue;
	                }
	
	                if (identifier instanceof Array) {
	                    for (var j in identifier) {
	                        results[identifier[j]] = true;
	                    }
	                    continue;
	                }
	
	                results[identifier] = true;
	            }
	
	            return Object.keys(results);
	        }
	    }, {
	        key: 'getSortFieldName',
	        value: function getSortFieldName() {
	            if (!this.sortField()) {
	                return null;
	            }
	
	            return this._targetEntity.name() + '_ListView.' + this.sortField();
	        }
	    }, {
	        key: 'remoteComplete',
	
	        /**
	         * Enable autocompletion using REST API for choices.
	         *
	         * Available options are:
	         *
	         * * `refreshDelay`: minimal delay between two API calls in milliseconds. By default: 500.
	         * * `searchQuery`: a function returning the parameters to add to the query string basd on the input string.
	         *
	         *       new ReferenceField('authors')
	         *           .targetEntity(author)
	         *           .targetField(new Field('name'))
	         *           .remoteComplete(true, {
	         *               refreshDelay: 300,
	         *               // populate choices from the response of GET /tags?q=XXX
	         *               searchQuery: function(search) { return { q: search }; }
	         *           })
	         *           .perPage(10) // limit the number of results to 10
	         *
	         * @param {Boolean} remoteComplete true to enable remote complete. False by default
	         * @param {Object} options Remote completion options (optional)
	         */
	        value: function remoteComplete(_remoteComplete, options) {
	            if (!arguments.length) return this._remoteComplete;
	            this._remoteComplete = _remoteComplete;
	            if (options) {
	                this.remoteCompleteOptions(options);
	            }
	            return this;
	        }
	    }, {
	        key: 'remoteCompleteOptions',
	        value: function remoteCompleteOptions(options) {
	            if (!arguments.length) return this._remoteCompleteOptions;
	            this._remoteCompleteOptions = options;
	            return this;
	        }
	    }]);
	
	    return ReferenceField;
	}(_Field3['default']);
	
	exports['default'] = ReferenceField;
	module.exports = exports['default'];
	//# sourceMappingURL=ReferenceField.js.map

/***/ },
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	
	    getReferencedLists: function getReferencedLists(fields) {
	        return this.indexByName(fields.filter(function (f) {
	            return f.type() === 'referenced_list';
	        }));
	    },
	    getReferences: function getReferences(fields, withRemoteComplete) {
	        var optimized = arguments[2] === undefined ? null : arguments[2];
	
	        var references = fields.filter(function (f) {
	            return f.type() === 'reference' || f.type() === 'reference_many';
	        });
	        if (withRemoteComplete === true) {
	            references = references.filter(function (r) {
	                return r.remoteComplete();
	            });
	        } else if (withRemoteComplete === false) {
	            references = references.filter(function (r) {
	                return !r.remoteComplete();
	            });
	        }
	        if (optimized !== null) {
	            references = references.filter(function (r) {
	                return r.hasSingleApiCall() === optimized;
	            });
	        }
	        return this.indexByName(references);
	    },
	    getNonOptimizedReferences: function getNonOptimizedReferences(fields, withRemoteComplete) {
	        return this.getReferences(fields, withRemoteComplete, false);
	    },
	    getOptimizedReferences: function getOptimizedReferences(fields, withRemoteComplete) {
	        return this.getReferences(fields, withRemoteComplete, true);
	    },
	    indexByName: function indexByName(references) {
	        return references.reduce(function (referencesByName, reference) {
	            referencesByName[reference.name()] = reference;
	            return referencesByName;
	        }, {});
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=ReferenceExtractor.js.map

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/*! @preserve
	 * numeral.js
	 * version : 1.5.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function () {
	
	    /************************************
	        Variables
	    ************************************/
	
	    var _numeral,
	        VERSION = '1.5.6',
	
	    // internal storage for language config files
	    languages = {},
	        defaults = {
	        currentLanguage: 'en',
	        zeroFormat: null,
	        nullFormat: null,
	        defaultFormat: '0,0'
	    },
	        options = {
	        currentLanguage: defaults.currentLanguage,
	        zeroFormat: defaults.zeroFormat,
	        nullFormat: defaults.nullFormat,
	        defaultFormat: defaults.defaultFormat
	    },
	        byteSuffixes = {
	        bytes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
	        iec: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	    };
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(number) {
	        this._value = number;
	    }
	
	    /**
	     * Implementation of toFixed() that treats floats more like decimals
	     *
	     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	     * problems for accounting- and finance-related software.
	     */
	    function toFixed(value, maxDecimals, roundingFunction, optionals) {
	        var splitValue = value.toString().split('.'),
	            minDecimals = maxDecimals - (optionals || 0),
	            boundedPrecision,
	            optionalsRegExp,
	            power,
	            output;
	
	        // Use the smallest precision value possible to avoid errors from floating point representation
	        if (splitValue.length === 2) {
	            boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	        } else {
	            boundedPrecision = minDecimals;
	        }
	
	        power = Math.pow(10, boundedPrecision);
	
	        //roundingFunction = (roundingFunction !== undefined ? roundingFunction : Math.round);
	        // Multiply up by precision, round accurately, then divide and use native toFixed():
	        output = (roundingFunction(value * power) / power).toFixed(boundedPrecision);
	
	        if (optionals > maxDecimals - boundedPrecision) {
	            optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	            output = output.replace(optionalsRegExp, '');
	        }
	
	        return output;
	    }
	
	    /************************************
	        Formatting
	    ************************************/
	
	    // determine what type of formatting we need to do
	    function formatNumeral(n, format, roundingFunction) {
	        var output;
	
	        if (n._value === 0 && options.zeroFormat !== null) {
	            output = options.zeroFormat;
	        } else if (n._value === null && options.nullFormat !== null) {
	            output = options.nullFormat;
	        } else {
	            // figure out what kind of format we are dealing with
	            if (format.indexOf('$') > -1) {
	                output = formatCurrency(n, format, roundingFunction);
	            } else if (format.indexOf('%') > -1) {
	                output = formatPercentage(n, format, roundingFunction);
	            } else if (format.indexOf(':') > -1) {
	                output = formatTime(n, format);
	            } else if (format.indexOf('b') > -1 || format.indexOf('ib') > -1) {
	                output = formatBytes(n, format, roundingFunction);
	            } else if (format.indexOf('o') > -1) {
	                output = formatOrdinal(n, format, roundingFunction);
	            } else {
	                output = formatNumber(n._value, format, roundingFunction);
	            }
	        }
	
	        return output;
	    }
	
	    function formatCurrency(n, format, roundingFunction) {
	        var symbolIndex = format.indexOf('$'),
	            openParenIndex = format.indexOf('('),
	            minusSignIndex = format.indexOf('-'),
	            space = '',
	            spliceIndex,
	            output;
	
	        // check for space before or after currency
	        if (format.indexOf(' $') > -1) {
	            space = ' ';
	            format = format.replace(' $', '');
	        } else if (format.indexOf('$ ') > -1) {
	            space = ' ';
	            format = format.replace('$ ', '');
	        } else {
	            format = format.replace('$', '');
	        }
	
	        // format the number
	        output = formatNumber(n._value, format, roundingFunction, false);
	
	        // position the symbol
	        if (symbolIndex <= 1) {
	            if (output.indexOf('(') > -1 || output.indexOf('-') > -1) {
	                output = output.split('');
	                spliceIndex = 1;
	                if (symbolIndex < openParenIndex || symbolIndex < minusSignIndex) {
	                    // the symbol appears before the "(" or "-"
	                    spliceIndex = 0;
	                }
	                output.splice(spliceIndex, 0, languages[options.currentLanguage].currency.symbol + space);
	                output = output.join('');
	            } else {
	                output = languages[options.currentLanguage].currency.symbol + space + output;
	            }
	        } else {
	            if (output.indexOf(')') > -1) {
	                output = output.split('');
	                output.splice(-1, 0, space + languages[options.currentLanguage].currency.symbol);
	                output = output.join('');
	            } else {
	                output = output + space + languages[options.currentLanguage].currency.symbol;
	            }
	        }
	
	        return output;
	    }
	
	    function formatPercentage(n, format, roundingFunction) {
	        var space = '',
	            output,
	            value = n._value * 100;
	
	        // check for space before %
	        if (format.indexOf(' %') > -1) {
	            space = ' ';
	            format = format.replace(' %', '');
	        } else {
	            format = format.replace('%', '');
	        }
	
	        output = formatNumber(value, format, roundingFunction);
	
	        if (output.indexOf(')') > -1) {
	            output = output.split('');
	            output.splice(-1, 0, space + '%');
	            output = output.join('');
	        } else {
	            output = output + space + '%';
	        }
	
	        return output;
	    }
	
	    function formatBytes(n, format, roundingFunction) {
	        var output,
	            suffixes = format.indexOf('ib') > -1 ? byteSuffixes.iec : byteSuffixes.bytes,
	            value = n._value,
	            suffix = '',
	            power,
	            min,
	            max;
	
	        // check for space before
	        if (format.indexOf(' b') > -1 || format.indexOf(' ib') > -1) {
	            suffix = ' ';
	            format = format.replace(' ib', '').replace(' b', '');
	        } else {
	            format = format.replace('ib', '').replace('b', '');
	        }
	
	        for (power = 0; power <= suffixes.length; power++) {
	            min = Math.pow(1024, power);
	            max = Math.pow(1024, power + 1);
	
	            if (value === null || value === 0 || value >= min && value < max) {
	                suffix += suffixes[power];
	
	                if (min > 0) {
	                    value = value / min;
	                }
	
	                break;
	            }
	        }
	
	        output = formatNumber(value, format, roundingFunction);
	
	        return output + suffix;
	    }
	
	    function formatOrdinal(n, format, roundingFunction) {
	        var output,
	            ordinal = '';
	
	        // check for space before
	        if (format.indexOf(' o') > -1) {
	            ordinal = ' ';
	            format = format.replace(' o', '');
	        } else {
	            format = format.replace('o', '');
	        }
	
	        ordinal += languages[options.currentLanguage].ordinal(n._value);
	
	        output = formatNumber(n._value, format, roundingFunction);
	
	        return output + ordinal;
	    }
	
	    function formatTime(n) {
	        var hours = Math.floor(n._value / 60 / 60),
	            minutes = Math.floor((n._value - hours * 60 * 60) / 60),
	            seconds = Math.round(n._value - hours * 60 * 60 - minutes * 60);
	
	        return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	    }
	
	    function formatNumber(value, format, roundingFunction) {
	        var negP = false,
	            signed = false,
	            optDec = false,
	            abbr = '',
	            abbrK = false,
	            // force abbreviation to thousands
	        abbrM = false,
	            // force abbreviation to millions
	        abbrB = false,
	            // force abbreviation to billions
	        abbrT = false,
	            // force abbreviation to trillions
	        abbrForce = false,
	            // force abbreviation
	        abs,
	            min,
	            max,
	            power,
	            w,
	            precision,
	            thousands,
	            d = '',
	            neg = false;
	
	        if (value === null) {
	            value = 0;
	        }
	
	        abs = Math.abs(value);
	
	        // see if we should use parentheses for negative number or if we should prefix with a sign
	        // if both are present we default to parentheses
	        if (format.indexOf('(') > -1) {
	            negP = true;
	            format = format.slice(1, -1);
	        } else if (format.indexOf('+') > -1) {
	            signed = true;
	            format = format.replace(/\+/g, '');
	        }
	
	        // see if abbreviation is wanted
	        if (format.indexOf('a') > -1) {
	            // check if abbreviation is specified
	            abbrK = format.indexOf('aK') >= 0;
	            abbrM = format.indexOf('aM') >= 0;
	            abbrB = format.indexOf('aB') >= 0;
	            abbrT = format.indexOf('aT') >= 0;
	            abbrForce = abbrK || abbrM || abbrB || abbrT;
	
	            // check for space before abbreviation
	            if (format.indexOf(' a') > -1) {
	                abbr = ' ';
	            }
	
	            format = format.replace(new RegExp(abbr + 'a[KMBT]?'), '');
	
	            if (abs >= Math.pow(10, 12) && !abbrForce || abbrT) {
	                // trillion
	                abbr = abbr + languages[options.currentLanguage].abbreviations.trillion;
	                value = value / Math.pow(10, 12);
	            } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9) && !abbrForce || abbrB) {
	                // billion
	                abbr = abbr + languages[options.currentLanguage].abbreviations.billion;
	                value = value / Math.pow(10, 9);
	            } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6) && !abbrForce || abbrM) {
	                // million
	                abbr = abbr + languages[options.currentLanguage].abbreviations.million;
	                value = value / Math.pow(10, 6);
	            } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3) && !abbrForce || abbrK) {
	                // thousand
	                abbr = abbr + languages[options.currentLanguage].abbreviations.thousand;
	                value = value / Math.pow(10, 3);
	            }
	        }
	
	        if (format.indexOf('[.]') > -1) {
	            optDec = true;
	            format = format.replace('[.]', '.');
	        }
	
	        w = value.toString().split('.')[0];
	        precision = format.split('.')[1];
	        thousands = format.indexOf(',');
	
	        if (precision) {
	            if (precision.indexOf('[') > -1) {
	                precision = precision.replace(']', '');
	                precision = precision.split('[');
	                d = toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
	            } else {
	                d = toFixed(value, precision.length, roundingFunction);
	            }
	
	            w = d.split('.')[0];
	
	            if (d.indexOf('.') > -1) {
	                d = languages[options.currentLanguage].delimiters.decimal + d.split('.')[1];
	            } else {
	                d = '';
	            }
	
	            if (optDec && Number(d.slice(1)) === 0) {
	                d = '';
	            }
	        } else {
	            w = toFixed(value, null, roundingFunction);
	        }
	
	        // format number
	        if (w.indexOf('-') > -1) {
	            w = w.slice(1);
	            neg = true;
	        }
	
	        if (thousands > -1) {
	            w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + languages[options.currentLanguage].delimiters.thousands);
	        }
	
	        if (format.indexOf('.') === 0) {
	            w = '';
	        }
	
	        return (negP && neg ? '(' : '') + (!negP && neg ? '-' : '') + (!neg && signed ? '+' : '') + w + d + (abbr ? abbr : '') + (negP && neg ? ')' : '');
	    }
	
	    /************************************
	        Unformatting
	    ************************************/
	
	    // revert to number
	    function unformatNumeral(n, string) {
	        var stringOriginal = string,
	            thousandRegExp,
	            millionRegExp,
	            billionRegExp,
	            trillionRegExp,
	            bytesMultiplier = false,
	            power,
	            value;
	
	        if (string.indexOf(':') > -1) {
	            value = unformatTime(string);
	        } else {
	            if (string === options.zeroFormat || string === options.nullFormat) {
	                value = 0;
	            } else {
	                if (languages[options.currentLanguage].delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(languages[options.currentLanguage].delimiters.decimal, '.');
	                }
	
	                // see if abbreviations are there so that we can multiply to the correct number
	                thousandRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.thousand + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                millionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.million + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                billionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.billion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                trillionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.trillion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	
	                // see if bytes are there so that we can multiply to the correct number
	                for (power = 1; power <= byteSuffixes.bytes.length; power++) {
	                    bytesMultiplier = string.indexOf(byteSuffixes.bytes[power]) > -1 || string.indexOf(byteSuffixes.iec[power]) > -1 ? Math.pow(1024, power) : false;
	
	                    if (bytesMultiplier) {
	                        break;
	                    }
	                }
	
	                // do some math to create our number
	                value = bytesMultiplier ? bytesMultiplier : 1;
	                value *= stringOriginal.match(thousandRegExp) ? Math.pow(10, 3) : 1;
	                value *= stringOriginal.match(millionRegExp) ? Math.pow(10, 6) : 1;
	                value *= stringOriginal.match(billionRegExp) ? Math.pow(10, 9) : 1;
	                value *= stringOriginal.match(trillionRegExp) ? Math.pow(10, 12) : 1;
	                // check for percentage
	                value *= string.indexOf('%') > -1 ? 0.01 : 1;
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	                // remove non numbers
	                value *= Number(string.replace(/[^0-9\.]+/g, ''));
	                // round if we are talking about bytes
	                value = bytesMultiplier ? Math.ceil(value) : value;
	            }
	        }
	
	        n._value = value;
	
	        return n._value;
	    }
	    function unformatTime(string) {
	        var timeArray = string.split(':'),
	            seconds = 0;
	        // turn hours and minutes into seconds and add them all up
	        if (timeArray.length === 3) {
	            // hours
	            seconds = seconds + Number(timeArray[0]) * 60 * 60;
	            // minutes
	            seconds = seconds + Number(timeArray[1]) * 60;
	            // seconds
	            seconds = seconds + Number(timeArray[2]);
	        } else if (timeArray.length === 2) {
	            // minutes
	            seconds = seconds + Number(timeArray[0]) * 60;
	            // seconds
	            seconds = seconds + Number(timeArray[1]);
	        }
	        return Number(seconds);
	    }
	
	    /************************************
	        Top Level Functions
	    ************************************/
	
	    _numeral = function numeral(input) {
	        if (_numeral.isNumeral(input)) {
	            input = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            input = 0;
	        } else if (input === null) {
	            input = null;
	        } else if (!Number(input)) {
	            input = _numeral.fn.unformat(input);
	        } else {
	            input = Number(input);
	        }
	
	        return new Numeral(input);
	    };
	
	    // version number
	    _numeral.version = VERSION;
	
	    // compare numeral object
	    _numeral.isNumeral = function (obj) {
	        return obj instanceof Numeral;
	    };
	
	    // This function will load languages and then set the global language.  If
	    // no arguments are passed in, it will simply return the current global
	    // language key.
	    _numeral.language = function (key, values) {
	        if (!key) {
	            return options.currentLanguage;
	        }
	
	        key = key.toLowerCase();
	
	        if (key && !values) {
	            if (!languages[key]) {
	                throw new Error('Unknown language : ' + key);
	            }
	
	            options.currentLanguage = key;
	        }
	
	        if (values || !languages[key]) {
	            loadLanguage(key, values);
	        }
	
	        return _numeral;
	    };
	
	    _numeral.reset = function () {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    // This function provides access to the loaded language data.  If
	    // no arguments are passed in, it will simply return the current
	    // global language object.
	    _numeral.languageData = function (key) {
	        if (!key) {
	            return languages[options.currentLanguage];
	        }
	
	        if (!languages[key]) {
	            throw new Error('Unknown language : ' + key);
	        }
	
	        return languages[key];
	    };
	
	    _numeral.language('en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function ordinal(number) {
	            var b = number % 10;
	            return ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    _numeral.zeroFormat = function (format) {
	        options.zeroFormat = typeof format === 'string' ? format : null;
	    };
	
	    _numeral.nullFormat = function (format) {
	        options.nullFormat = typeof format === 'string' ? format : null;
	    };
	
	    _numeral.defaultFormat = function (format) {
	        options.defaultFormat = typeof format === 'string' ? format : '0.0';
	    };
	
	    _numeral.validate = function (val, culture) {
	        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, languageData, temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.languageData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current language
	            languageData = _numeral.languageData(culture);
	        } catch (e) {
	            languageData = _numeral.languageData(_numeral.language());
	        }
	
	        //setup the delimiters and currency symbol based on culture/language
	        _currSymbol = languageData.currency.symbol;
	        _abbrObj = languageData.abbreviations;
	        _decimalSep = languageData.delimiters.decimal;
	        if (languageData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = languageData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
	                    } else {
	                        return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	    /************************************
	        Helpers
	    ************************************/
	
	    function loadLanguage(key, values) {
	        languages[key] = values;
	    }
	
	    /************************************
	        Floating-point helpers
	    ************************************/
	
	    // The floating-point helper functions and implementation
	    // borrows heavily from sinful.js: http://guipn.github.io/sinful.js/
	
	    // Production steps of ECMA-262, Edition 5, 15.4.4.21
	    // Reference: http://es5.github.io/#x15.4.4.21
	    if (!Array.prototype.reduce) {
	        Array.prototype.reduce = function (callback /*, initialValue*/) {
	            'use strict';
	
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(this),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 2) {
	                value = arguments[1];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        };
	    }
	
	    /**
	     * Computes the multiplier necessary to make x >= 1,
	     * effectively eliminating miscalculations caused by
	     * finite precision.
	     */
	    function multiplier(x) {
	        var parts = x.toString().split('.');
	        if (parts.length < 2) {
	            return 1;
	        }
	        return Math.pow(10, parts[1].length);
	    }
	
	    /**
	     * Given a variable number of arguments, returns the maximum
	     * multiplier that must be used to normalize an operation involving
	     * all of them.
	     */
	    function correctionFactor() {
	        var args = Array.prototype.slice.call(arguments);
	        return args.reduce(function (prev, next) {
	            var mp = multiplier(prev),
	                mn = multiplier(next);
	            return mp > mn ? mp : mn;
	        }, -Infinity);
	    }
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    _numeral.fn = Numeral.prototype = {
	
	        clone: function clone() {
	            return _numeral(this);
	        },
	
	        format: function format(inputString, roundingFunction) {
	            return formatNumeral(this, inputString ? inputString : options.defaultFormat, roundingFunction !== undefined ? roundingFunction : Math.round);
	        },
	
	        unformat: function unformat(inputString) {
	            if (Object.prototype.toString.call(inputString) === '[object Number]') {
	                return inputString;
	            }
	
	            return unformatNumeral(this, inputString ? inputString : options.defaultFormat);
	        },
	
	        value: function value() {
	            return this._value;
	        },
	
	        valueOf: function valueOf() {
	            return this._value;
	        },
	
	        set: function set(value) {
	            this._value = Number(value);
	            return this;
	        },
	
	        add: function add(value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + corrFactor * curr;
	            }
	            this._value = [this._value, value].reduce(cback, 0) / corrFactor;
	            return this;
	        },
	
	        subtract: function subtract(value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - corrFactor * curr;
	            }
	            this._value = [value].reduce(cback, this._value * corrFactor) / corrFactor;
	            return this;
	        },
	
	        multiply: function multiply(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = correctionFactor(accum, curr);
	                return accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback, 1);
	            return this;
	        },
	
	        divide: function divide(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = correctionFactor(accum, curr);
	                return accum * corrFactor / (curr * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback);
	            return this;
	        },
	
	        difference: function difference(value) {
	            return Math.abs(_numeral(this._value).subtract(value).value());
	        }
	
	    };
	
	    /************************************
	        Exposing Numeral
	    ************************************/
	
	    // CommonJS module is defined
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = _numeral;
	    }
	
	    /*global ender:false */
	    if (typeof ender === 'undefined') {
	        // here, `this` means `window` in the browser, or `global` on the server
	        // add `numeral` as a global object via a string identifier,
	        // for Closure Compiler 'advanced' mode
	        this['numeral'] = _numeral;
	    }
	
	    /*global define:false */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return _numeral;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}).call(undefined);

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Assertions matching the test spy retrieval interface.
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2013 Christian Johansen
	 */
	"use strict";
	
	var calledInOrder = __webpack_require__(139);
	var orderByFirstCall = __webpack_require__(141);
	var timesInWords = __webpack_require__(23);
	var format = __webpack_require__(13);
	var sinonMatch = __webpack_require__(10);
	
	var slice = Array.prototype.slice;
	
	var assert;
	
	function verifyIsStub() {
	    var method;
	
	    for (var i = 0, l = arguments.length; i < l; ++i) {
	        method = arguments[i];
	
	        if (!method) {
	            assert.fail("fake is not a spy");
	        }
	
	        if (method.proxy && method.proxy.isSinonProxy) {
	            verifyIsStub(method.proxy);
	        } else {
	            if (typeof method !== "function") {
	                assert.fail(method + " is not a function");
	            }
	
	            if (typeof method.getCall !== "function") {
	                assert.fail(method + " is not stubbed");
	            }
	        }
	    }
	}
	
	function failAssertion(object, msg) {
	    object = object || global;
	    var failMethod = object.fail || assert.fail;
	    failMethod.call(object, msg);
	}
	
	function mirrorPropAsAssertion(name, method, message) {
	    if (arguments.length === 2) {
	        message = method;
	        method = name;
	    }
	
	    assert[name] = function (fake) {
	        verifyIsStub(fake);
	
	        var args = slice.call(arguments, 1);
	        var failed = false;
	
	        if (typeof method === "function") {
	            failed = !method(fake);
	        } else {
	            failed = typeof fake[method] === "function" ? !fake[method].apply(fake, args) : !fake[method];
	        }
	
	        if (failed) {
	            failAssertion(this, (fake.printf || fake.proxy.printf).apply(fake, [message].concat(args)));
	        } else {
	            assert.pass(name);
	        }
	    };
	}
	
	function exposedName(prefix, prop) {
	    return !prefix || /^fail/.test(prop) ? prop : prefix + prop.slice(0, 1).toUpperCase() + prop.slice(1);
	}
	
	assert = {
	    failException: "AssertError",
	
	    fail: function fail(message) {
	        var error = new Error(message);
	        error.name = this.failException || assert.failException;
	
	        throw error;
	    },
	
	    pass: function pass() {},
	
	    callOrder: function assertCallOrder() {
	        verifyIsStub.apply(null, arguments);
	        var expected = "";
	        var actual = "";
	
	        if (!calledInOrder(arguments)) {
	            try {
	                expected = [].join.call(arguments, ", ");
	                var calls = slice.call(arguments);
	                var i = calls.length;
	                while (i) {
	                    if (!calls[--i].called) {
	                        calls.splice(i, 1);
	                    }
	                }
	                actual = orderByFirstCall(calls).join(", ");
	            } catch (e) {
	                // If this fails, we'll just fall back to the blank string
	            }
	
	            failAssertion(this, "expected " + expected + " to be " + "called in order but were called as " + actual);
	        } else {
	            assert.pass("callOrder");
	        }
	    },
	
	    callCount: function assertCallCount(method, count) {
	        verifyIsStub(method);
	
	        if (method.callCount !== count) {
	            var msg = "expected %n to be called " + timesInWords(count) + " but was called %c%C";
	            failAssertion(this, method.printf(msg));
	        } else {
	            assert.pass("callCount");
	        }
	    },
	
	    expose: function expose(target, options) {
	        if (!target) {
	            throw new TypeError("target is null or undefined");
	        }
	
	        var o = options || {};
	        var prefix = typeof o.prefix === "undefined" && "assert" || o.prefix;
	        var includeFail = typeof o.includeFail === "undefined" || !!o.includeFail;
	
	        for (var method in this) {
	            if (method !== "expose" && (includeFail || !/^(fail)/.test(method))) {
	                target[exposedName(prefix, method)] = this[method];
	            }
	        }
	
	        return target;
	    },
	
	    match: function match(actual, expectation) {
	        var matcher = sinonMatch(expectation);
	        if (matcher.test(actual)) {
	            assert.pass("match");
	        } else {
	            var formatted = ["expected value to match", "    expected = " + format(expectation), "    actual = " + format(actual)];
	
	            failAssertion(this, formatted.join("\n"));
	        }
	    }
	};
	
	mirrorPropAsAssertion("called", "expected %n to have been called at least once but was never called");
	mirrorPropAsAssertion("notCalled", function (spy) {
	    return !spy.called;
	}, "expected %n to not have been called but was called %c%C");
	mirrorPropAsAssertion("calledOnce", "expected %n to be called once but was called %c%C");
	mirrorPropAsAssertion("calledTwice", "expected %n to be called twice but was called %c%C");
	mirrorPropAsAssertion("calledThrice", "expected %n to be called thrice but was called %c%C");
	mirrorPropAsAssertion("calledOn", "expected %n to be called with %1 as this but was called with %t");
	mirrorPropAsAssertion("alwaysCalledOn", "expected %n to always be called with %1 as this but was called with %t");
	mirrorPropAsAssertion("calledWithNew", "expected %n to be called with new");
	mirrorPropAsAssertion("alwaysCalledWithNew", "expected %n to always be called with new");
	mirrorPropAsAssertion("calledWith", "expected %n to be called with arguments %*%C");
	mirrorPropAsAssertion("calledWithMatch", "expected %n to be called with match %*%C");
	mirrorPropAsAssertion("alwaysCalledWith", "expected %n to always be called with arguments %*%C");
	mirrorPropAsAssertion("alwaysCalledWithMatch", "expected %n to always be called with match %*%C");
	mirrorPropAsAssertion("calledWithExactly", "expected %n to be called with exact arguments %*%C");
	mirrorPropAsAssertion("alwaysCalledWithExactly", "expected %n to always be called with exact arguments %*%C");
	mirrorPropAsAssertion("neverCalledWith", "expected %n to never be called with arguments %*%C");
	mirrorPropAsAssertion("neverCalledWithMatch", "expected %n to never be called with match %*%C");
	mirrorPropAsAssertion("threw", "%n did not throw exception%C");
	mirrorPropAsAssertion("alwaysThrew", "%n did not always throw exception%C");
	
	module.exports = assert;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Stub functions
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2013 Christian Johansen
	 */
	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var behavior = __webpack_require__(331);
	var spy = __webpack_require__(20);
	var extend = __webpack_require__(5);
	var walk = __webpack_require__(24);
	var objectKeys = __webpack_require__(35);
	var getPropertyDescriptor = __webpack_require__(16);
	var createInstance = __webpack_require__(11);
	var functionToString = __webpack_require__(34);
	var valueToString = __webpack_require__(7);
	var wrapMethod = __webpack_require__(25);
	
	function stub(object, property, func) {
	    if (!!func && typeof func !== "function" && (typeof func === "undefined" ? "undefined" : _typeof(func)) !== "object") {
	        throw new TypeError("Custom stub should be a function or a property descriptor");
	    }
	
	    if (property && !object) {
	        var type = object === null ? "null" : "undefined";
	        throw new Error("Trying to stub property '" + valueToString(property) + "' of " + type);
	    }
	
	    var wrapper;
	
	    if (func) {
	        if (typeof func === "function") {
	            wrapper = spy && spy.create ? spy.create(func) : func;
	        } else {
	            wrapper = func;
	            if (spy && spy.create) {
	                var types = objectKeys(wrapper);
	                for (var i = 0; i < types.length; i++) {
	                    wrapper[types[i]] = spy.create(wrapper[types[i]]);
	                }
	            }
	        }
	    } else {
	        var stubLength = 0;
	        if ((typeof object === "undefined" ? "undefined" : _typeof(object)) === "object" && typeof object[property] === "function") {
	            stubLength = object[property].length;
	        }
	        wrapper = stub.create(stubLength);
	    }
	
	    if (!object && typeof property === "undefined") {
	        return stub.create();
	    }
	
	    if (typeof property === "undefined" && (typeof object === "undefined" ? "undefined" : _typeof(object)) === "object") {
	        walk(object || {}, function (prop, propOwner) {
	            // we don't want to stub things like toString(), valueOf(), etc. so we only stub if the object
	            // is not Object.prototype
	            if (propOwner !== Object.prototype && prop !== "constructor" && typeof getPropertyDescriptor(propOwner, prop).value === "function") {
	                stub(object, prop);
	            }
	        });
	
	        return object;
	    }
	
	    return wrapMethod(object, property, wrapper);
	}
	
	stub.createStubInstance = function (constructor) {
	    if (typeof constructor !== "function") {
	        throw new TypeError("The constructor should be a function.");
	    }
	    return stub(createInstance(constructor.prototype));
	};
	
	/*eslint-disable no-use-before-define*/
	function getParentBehaviour(stubInstance) {
	    return stubInstance.parent && getCurrentBehavior(stubInstance.parent);
	}
	
	function getDefaultBehavior(stubInstance) {
	    return stubInstance.defaultBehavior || getParentBehaviour(stubInstance) || behavior.create(stubInstance);
	}
	
	function getCurrentBehavior(stubInstance) {
	    var currentBehavior = stubInstance.behaviors[stubInstance.callCount - 1];
	    return currentBehavior && currentBehavior.isPresent() ? currentBehavior : getDefaultBehavior(stubInstance);
	}
	/*eslint-enable no-use-before-define*/
	
	var uuid = 0;
	
	var proto = {
	    create: function create(stubLength) {
	        var _functionStub = function functionStub() {
	            return getCurrentBehavior(_functionStub).invoke(this, arguments);
	        };
	
	        _functionStub.id = "stub#" + uuid++;
	        var orig = _functionStub;
	        _functionStub = spy.create(_functionStub, stubLength);
	        _functionStub.func = orig;
	
	        extend(_functionStub, stub);
	        _functionStub.instantiateFake = stub.create;
	        _functionStub.displayName = "stub";
	        _functionStub.toString = functionToString;
	
	        _functionStub.defaultBehavior = null;
	        _functionStub.behaviors = [];
	
	        return _functionStub;
	    },
	
	    resetBehavior: function resetBehavior() {
	        var i;
	
	        this.defaultBehavior = null;
	        this.behaviors = [];
	
	        delete this.returnValue;
	        delete this.returnArgAt;
	        this.returnThis = false;
	
	        if (this.fakes) {
	            for (i = 0; i < this.fakes.length; i++) {
	                this.fakes[i].resetBehavior();
	            }
	        }
	    },
	
	    resetHistory: spy.reset,
	
	    reset: function reset() {
	        this.resetHistory();
	        this.resetBehavior();
	    },
	
	    onCall: function onCall(index) {
	        if (!this.behaviors[index]) {
	            this.behaviors[index] = behavior.create(this);
	        }
	
	        return this.behaviors[index];
	    },
	
	    onFirstCall: function onFirstCall() {
	        return this.onCall(0);
	    },
	
	    onSecondCall: function onSecondCall() {
	        return this.onCall(1);
	    },
	
	    onThirdCall: function onThirdCall() {
	        return this.onCall(2);
	    }
	};
	
	function createBehavior(behaviorMethod) {
	    return function () {
	        this.defaultBehavior = this.defaultBehavior || behavior.create(this);
	        this.defaultBehavior[behaviorMethod].apply(this.defaultBehavior, arguments);
	        return this;
	    };
	}
	
	for (var method in behavior) {
	    if (behavior.hasOwnProperty(method) && !proto.hasOwnProperty(method) && method !== "create" && method !== "withArgs" && method !== "invoke") {
	        proto[method] = createBehavior(method);
	    }
	}
	
	extend(stub, proto);
	
	module.exports = stub;

/***/ },
/* 34 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function toString() {
	    var i, prop, thisValue;
	    if (this.getCall && this.callCount) {
	        i = this.callCount;
	
	        while (i--) {
	            thisValue = this.getCall(i).thisValue;
	
	            for (prop in thisValue) {
	                if (thisValue[prop] === this) {
	                    return prop;
	                }
	            }
	        }
	    }
	
	    return this.displayName || "sinon fake";
	};

/***/ },
/* 35 */
/***/ function(module, exports) {

	"use strict";
	
	var hasOwn = Object.prototype.hasOwnProperty;
	
	module.exports = function objectKeys(obj) {
	    if (obj !== Object(obj)) {
	        throw new TypeError("sinon.objectKeys called on a non-object");
	    }
	
	    var keys = [];
	    var key;
	    for (key in obj) {
	        if (hasOwn.call(obj, key)) {
	            keys.push(key);
	        }
	    }
	
	    return keys;
	};

/***/ },
/* 36 */
/***/ function(module, exports) {

	/**
	 * Minimal Event interface implementation
	 *
	 * Original implementation by Sven Fuchs: https://gist.github.com/995028
	 * Modifications and tests by Christian Johansen.
	 *
	 * @author Sven Fuchs (svenfuchs@artweb-design.de)
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2011 Sven Fuchs, Christian Johansen
	 */
	"use strict";
	
	var push = [].push;
	
	function Event(type, bubbles, cancelable, target) {
	    this.initEvent(type, bubbles, cancelable, target);
	}
	
	Event.prototype = {
	    initEvent: function initEvent(type, bubbles, cancelable, target) {
	        this.type = type;
	        this.bubbles = bubbles;
	        this.cancelable = cancelable;
	        this.target = target;
	    },
	
	    stopPropagation: function stopPropagation() {},
	
	    preventDefault: function preventDefault() {
	        this.defaultPrevented = true;
	    }
	};
	
	function ProgressEvent(type, progressEventRaw, target) {
	    this.initEvent(type, false, false, target);
	    this.loaded = typeof progressEventRaw.loaded === "number" ? progressEventRaw.loaded : null;
	    this.total = typeof progressEventRaw.total === "number" ? progressEventRaw.total : null;
	    this.lengthComputable = !!progressEventRaw.total;
	}
	
	ProgressEvent.prototype = new Event();
	
	ProgressEvent.prototype.constructor = ProgressEvent;
	
	function CustomEvent(type, customData, target) {
	    this.initEvent(type, false, false, target);
	    this.detail = customData.detail || null;
	}
	
	CustomEvent.prototype = new Event();
	
	CustomEvent.prototype.constructor = CustomEvent;
	
	var EventTarget = {
	    addEventListener: function addEventListener(event, listener) {
	        this.eventListeners = this.eventListeners || {};
	        this.eventListeners[event] = this.eventListeners[event] || [];
	        push.call(this.eventListeners[event], listener);
	    },
	
	    removeEventListener: function removeEventListener(event, listener) {
	        var listeners = this.eventListeners && this.eventListeners[event] || [];
	
	        for (var i = 0, l = listeners.length; i < l; ++i) {
	            if (listeners[i] === listener) {
	                return listeners.splice(i, 1);
	            }
	        }
	    },
	
	    dispatchEvent: function dispatchEvent(event) {
	        var type = event.type;
	        var listeners = this.eventListeners && this.eventListeners[type] || [];
	
	        for (var i = 0; i < listeners.length; i++) {
	            if (typeof listeners[i] === "function") {
	                listeners[i].call(this, event);
	            } else {
	                listeners[i].handleEvent(event);
	            }
	        }
	
	        return !!event.defaultPrevented;
	    }
	};
	
	module.exports = {
	    Event: Event,
	    ProgressEvent: ProgressEvent,
	    CustomEvent: CustomEvent,
	    EventTarget: EventTarget
	};

/***/ },
/* 37 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var segments = ['compulsive', 'collector', 'ordered_once', 'regular', 'returns', 'reviewer'];
	
	exports.default = {
		values: segments,
		choices: segments.map(function (segment) {
			return { label: segment, value: segment };
		})
	};
	module.exports = exports['default'];

/***/ },
/* 38 */
/***/ function(module, exports) {

	"use strict";/**
	 * State-based routing for AngularJS
	 * @version v0.2.18
	 * @link http://angular-ui.github.com/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 *//* commonjs package manager support (eg componentjs) */if(typeof module!=="undefined"&&typeof exports!=="undefined"&&module.exports===exports){module.exports='ui.router';}(function(window,angular,undefined){/*jshint globalstrict:true*//*global angular:false*/'use strict';var isDefined=angular.isDefined,isFunction=angular.isFunction,isString=angular.isString,isObject=angular.isObject,isArray=angular.isArray,forEach=angular.forEach,extend=angular.extend,copy=angular.copy,toJson=angular.toJson;function inherit(parent,extra){return extend(new(extend(function(){},{prototype:parent}))(),extra);}function merge(dst){forEach(arguments,function(obj){if(obj!==dst){forEach(obj,function(value,key){if(!dst.hasOwnProperty(key))dst[key]=value;});}});return dst;}/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */function ancestors(first,second){var path=[];for(var n in first.path){if(first.path[n]!==second.path[n])break;path.push(first.path[n]);}return path;}/**
	 * IE8-safe wrapper for `Object.keys()`.
	 *
	 * @param {Object} object A JavaScript object.
	 * @return {Array} Returns the keys of the object as an array.
	 */function objectKeys(object){if(Object.keys){return Object.keys(object);}var result=[];forEach(object,function(val,key){result.push(key);});return result;}/**
	 * IE8-safe wrapper for `Array.prototype.indexOf()`.
	 *
	 * @param {Array} array A JavaScript array.
	 * @param {*} value A value to search the array for.
	 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
	 */function indexOf(array,value){if(Array.prototype.indexOf){return array.indexOf(value,Number(arguments[2])||0);}var len=array.length>>>0,from=Number(arguments[2])||0;from=from<0?Math.ceil(from):Math.floor(from);if(from<0)from+=len;for(;from<len;from++){if(from in array&&array[from]===value)return from;}return-1;}/**
	 * Merges a set of parameters with all parameters inherited between the common parents of the
	 * current state and a given destination state.
	 *
	 * @param {Object} currentParams The value of the current state parameters ($stateParams).
	 * @param {Object} newParams The set of parameters which will be composited with inherited params.
	 * @param {Object} $current Internal definition of object representing the current state.
	 * @param {Object} $to Internal definition of object representing state to transition to.
	 */function inheritParams(currentParams,newParams,$current,$to){var parents=ancestors($current,$to),parentParams,inherited={},inheritList=[];for(var i in parents){if(!parents[i]||!parents[i].params)continue;parentParams=objectKeys(parents[i].params);if(!parentParams.length)continue;for(var j in parentParams){if(indexOf(inheritList,parentParams[j])>=0)continue;inheritList.push(parentParams[j]);inherited[parentParams[j]]=currentParams[parentParams[j]];}}return extend({},inherited,newParams);}/**
	 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
	 *
	 * @param {Object} a The first object.
	 * @param {Object} b The second object.
	 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
	 *                     it defaults to the list of keys in `a`.
	 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
	 */function equalForKeys(a,b,keys){if(!keys){keys=[];for(var n in a){keys.push(n);}// Used instead of Object.keys() for IE8 compatibility
	}for(var i=0;i<keys.length;i++){var k=keys[i];if(a[k]!=b[k])return false;// Not '===', values aren't necessarily normalized
	}return true;}/**
	 * Returns the subset of an object, based on a list of keys.
	 *
	 * @param {Array} keys
	 * @param {Object} values
	 * @return {Boolean} Returns a subset of `values`.
	 */function filterByKeys(keys,values){var filtered={};forEach(keys,function(name){filtered[name]=values[name];});return filtered;}// like _.indexBy
	// when you know that your index values will be unique, or you want last-one-in to win
	function indexBy(array,propName){var result={};forEach(array,function(item){result[item[propName]]=item;});return result;}// extracted from underscore.js
	// Return a copy of the object only containing the whitelisted properties.
	function pick(obj){var copy={};var keys=Array.prototype.concat.apply(Array.prototype,Array.prototype.slice.call(arguments,1));forEach(keys,function(key){if(key in obj)copy[key]=obj[key];});return copy;}// extracted from underscore.js
	// Return a copy of the object omitting the blacklisted properties.
	function omit(obj){var copy={};var keys=Array.prototype.concat.apply(Array.prototype,Array.prototype.slice.call(arguments,1));for(var key in obj){if(indexOf(keys,key)==-1)copy[key]=obj[key];}return copy;}function pluck(collection,key){var result=isArray(collection)?[]:{};forEach(collection,function(val,i){result[i]=isFunction(key)?key(val):val[key];});return result;}function filter(collection,callback){var array=isArray(collection);var result=array?[]:{};forEach(collection,function(val,i){if(callback(val,i)){result[array?result.length:i]=val;}});return result;}function map(collection,callback){var result=isArray(collection)?[]:{};forEach(collection,function(val,i){result[i]=callback(val,i);});return result;}/**
	 * @ngdoc overview
	 * @name ui.router.util
	 *
	 * @description
	 * # ui.router.util sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 *
	 */angular.module('ui.router.util',['ng']);/**
	 * @ngdoc overview
	 * @name ui.router.router
	 * 
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.router sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 */angular.module('ui.router.router',['ui.router.util']);/**
	 * @ngdoc overview
	 * @name ui.router.state
	 * 
	 * @requires ui.router.router
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.state sub-module
	 *
	 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 * 
	 */angular.module('ui.router.state',['ui.router.router','ui.router.util']);/**
	 * @ngdoc overview
	 * @name ui.router
	 *
	 * @requires ui.router.state
	 *
	 * @description
	 * # ui.router
	 * 
	 * ## The main module for ui.router 
	 * There are several sub-modules included with the ui.router module, however only this module is needed
	 * as a dependency within your angular app. The other modules are for organization purposes. 
	 *
	 * The modules are:
	 * * ui.router - the main "umbrella" module
	 * * ui.router.router - 
	 * 
	 * *You'll need to include **only** this module as the dependency within your angular app.*
	 * 
	 * <pre>
	 * <!doctype html>
	 * <html ng-app="myApp">
	 * <head>
	 *   <script src="js/angular.js"></script>
	 *   <!-- Include the ui-router script -->
	 *   <script src="js/angular-ui-router.min.js"></script>
	 *   <script>
	 *     // ...and add 'ui.router' as a dependency
	 *     var myApp = angular.module('myApp', ['ui.router']);
	 *   </script>
	 * </head>
	 * <body>
	 * </body>
	 * </html>
	 * </pre>
	 */angular.module('ui.router',['ui.router.state']);angular.module('ui.router.compat',['ui.router']);/**
	 * @ngdoc object
	 * @name ui.router.util.$resolve
	 *
	 * @requires $q
	 * @requires $injector
	 *
	 * @description
	 * Manages resolution of (acyclic) graphs of promises.
	 */$Resolve.$inject=['$q','$injector'];function $Resolve($q,$injector){var VISIT_IN_PROGRESS=1,VISIT_DONE=2,NOTHING={},NO_DEPENDENCIES=[],NO_LOCALS=NOTHING,NO_PARENT=extend($q.when(NOTHING),{$$promises:NOTHING,$$values:NOTHING});/**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#study
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Studies a set of invocables that are likely to be used multiple times.
	   * <pre>
	   * $resolve.study(invocables)(locals, parent, self)
	   * </pre>
	   * is equivalent to
	   * <pre>
	   * $resolve.resolve(invocables, locals, parent, self)
	   * </pre>
	   * but the former is more efficient (in fact `resolve` just calls `study` 
	   * internally).
	   *
	   * @param {object} invocables Invocable objects
	   * @return {function} a function to pass in locals, parent and self
	   */this.study=function(invocables){if(!isObject(invocables))throw new Error("'invocables' must be an object");var invocableKeys=objectKeys(invocables||{});// Perform a topological sort of invocables to build an ordered plan
	var plan=[],cycle=[],visited={};function visit(value,key){if(visited[key]===VISIT_DONE)return;cycle.push(key);if(visited[key]===VISIT_IN_PROGRESS){cycle.splice(0,indexOf(cycle,key));throw new Error("Cyclic dependency: "+cycle.join(" -> "));}visited[key]=VISIT_IN_PROGRESS;if(isString(value)){plan.push(key,[function(){return $injector.get(value);}],NO_DEPENDENCIES);}else{var params=$injector.annotate(value);forEach(params,function(param){if(param!==key&&invocables.hasOwnProperty(param))visit(invocables[param],param);});plan.push(key,value,params);}cycle.pop();visited[key]=VISIT_DONE;}forEach(invocables,visit);invocables=cycle=visited=null;// plan is all that's required
	function isResolve(value){return isObject(value)&&value.then&&value.$$promises;}return function(locals,parent,self){if(isResolve(locals)&&self===undefined){self=parent;parent=locals;locals=null;}if(!locals)locals=NO_LOCALS;else if(!isObject(locals)){throw new Error("'locals' must be an object");}if(!parent)parent=NO_PARENT;else if(!isResolve(parent)){throw new Error("'parent' must be a promise returned by $resolve.resolve()");}// To complete the overall resolution, we have to wait for the parent
	// promise and for the promise for each invokable in our plan.
	var resolution=$q.defer(),result=resolution.promise,promises=result.$$promises={},values=extend({},locals),wait=1+plan.length/3,merged=false;function done(){// Merge parent values we haven't got yet and publish our own $$values
	if(! --wait){if(!merged)merge(values,parent.$$values);result.$$values=values;result.$$promises=result.$$promises||true;// keep for isResolve()
	delete result.$$inheritedValues;resolution.resolve(values);}}function fail(reason){result.$$failure=reason;resolution.reject(reason);}// Short-circuit if parent has already failed
	if(isDefined(parent.$$failure)){fail(parent.$$failure);return result;}if(parent.$$inheritedValues){merge(values,omit(parent.$$inheritedValues,invocableKeys));}// Merge parent values if the parent has already resolved, or merge
	// parent promises and wait if the parent resolve is still in progress.
	extend(promises,parent.$$promises);if(parent.$$values){merged=merge(values,omit(parent.$$values,invocableKeys));result.$$inheritedValues=omit(parent.$$values,invocableKeys);done();}else{if(parent.$$inheritedValues){result.$$inheritedValues=omit(parent.$$inheritedValues,invocableKeys);}parent.then(done,fail);}// Process each invocable in the plan, but ignore any where a local of the same name exists.
	for(var i=0,ii=plan.length;i<ii;i+=3){if(locals.hasOwnProperty(plan[i]))done();else invoke(plan[i],plan[i+1],plan[i+2]);}function invoke(key,invocable,params){// Create a deferred for this invocation. Failures will propagate to the resolution as well.
	var invocation=$q.defer(),waitParams=0;function onfailure(reason){invocation.reject(reason);fail(reason);}// Wait for any parameter that we have a promise for (either from parent or from this
	// resolve; in that case study() will have made sure it's ordered before us in the plan).
	forEach(params,function(dep){if(promises.hasOwnProperty(dep)&&!locals.hasOwnProperty(dep)){waitParams++;promises[dep].then(function(result){values[dep]=result;if(! --waitParams)proceed();},onfailure);}});if(!waitParams)proceed();function proceed(){if(isDefined(result.$$failure))return;try{invocation.resolve($injector.invoke(invocable,self,values));invocation.promise.then(function(result){values[key]=result;done();},onfailure);}catch(e){onfailure(e);}}// Publish promise synchronously; invocations further down in the plan may depend on it.
	promises[key]=invocation.promise;}return result;};};/**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#resolve
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Resolves a set of invocables. An invocable is a function to be invoked via 
	   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
	   * An invocable can either return a value directly,
	   * or a `$q` promise. If a promise is returned it will be resolved and the 
	   * resulting value will be used instead. Dependencies of invocables are resolved 
	   * (in this order of precedence)
	   *
	   * - from the specified `locals`
	   * - from another invocable that is part of this `$resolve` call
	   * - from an invocable that is inherited from a `parent` call to `$resolve` 
	   *   (or recursively
	   * - from any ancestor `$resolve` of that parent).
	   *
	   * The return value of `$resolve` is a promise for an object that contains 
	   * (in this order of precedence)
	   *
	   * - any `locals` (if specified)
	   * - the resolved return values of all injectables
	   * - any values inherited from a `parent` call to `$resolve` (if specified)
	   *
	   * The promise will resolve after the `parent` promise (if any) and all promises 
	   * returned by injectables have been resolved. If any invocable 
	   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
	   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
	   * same error. A rejection of a `parent` promise (if specified) will likewise be 
	   * propagated immediately. Once the `$resolve` promise has been rejected, no 
	   * further invocables will be called.
	   * 
	   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
	   * to throw an error. As a special case, an injectable can depend on a parameter 
	   * with the same name as the injectable, which will be fulfilled from the `parent` 
	   * injectable of the same name. This allows inherited values to be decorated. 
	   * Note that in this case any other injectable in the same `$resolve` with the same
	   * dependency would see the decorated value, not the inherited value.
	   *
	   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
	   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
	   * exception.
	   *
	   * Invocables are invoked eagerly as soon as all dependencies are available. 
	   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
	   *
	   * As a special case, an invocable can be a string, in which case it is taken to 
	   * be a service name to be passed to `$injector.get()`. This is supported primarily 
	   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
	   * routes.
	   *
	   * @param {object} invocables functions to invoke or 
	   * `$injector` services to fetch.
	   * @param {object} locals  values to make available to the injectables
	   * @param {object} parent  a promise returned by another call to `$resolve`.
	   * @param {object} self  the `this` for the invoked methods
	   * @return {object} Promise for an object that contains the resolved return value
	   * of all invocables, as well as any inherited and local values.
	   */this.resolve=function(invocables,locals,parent,self){return this.study(invocables)(locals,parent,self);};}angular.module('ui.router.util').service('$resolve',$Resolve);/**
	 * @ngdoc object
	 * @name ui.router.util.$templateFactory
	 *
	 * @requires $http
	 * @requires $templateCache
	 * @requires $injector
	 *
	 * @description
	 * Service. Manages loading of templates.
	 */$TemplateFactory.$inject=['$http','$templateCache','$injector'];function $TemplateFactory($http,$templateCache,$injector){/**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromConfig
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a configuration object. 
	   *
	   * @param {object} config Configuration object for which to load a template. 
	   * The following properties are search in the specified order, and the first one 
	   * that is defined is used to create the template:
	   *
	   * @param {string|object} config.template html string template or function to 
	   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
	   * @param {string|object} config.templateUrl url to load or a function returning 
	   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
	   * @param {Function} config.templateProvider function to invoke via 
	   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
	   * @param {object} params  Parameters to pass to the template function.
	   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
	   * via a `templateProvider`. Defaults to `{ params: params }`.
	   *
	   * @return {string|object}  The template html as a string, or a promise for 
	   * that string,or `null` if no template is configured.
	   */this.fromConfig=function(config,params,locals){return isDefined(config.template)?this.fromString(config.template,params):isDefined(config.templateUrl)?this.fromUrl(config.templateUrl,params):isDefined(config.templateProvider)?this.fromProvider(config.templateProvider,params,locals):null;};/**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromString
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a string or a function returning a string.
	   *
	   * @param {string|object} template html template as a string or function that 
	   * returns an html template as a string.
	   * @param {object} params Parameters to pass to the template function.
	   *
	   * @return {string|object} The template html as a string, or a promise for that 
	   * string.
	   */this.fromString=function(template,params){return isFunction(template)?template(params):template;};/**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromUrl
	   * @methodOf ui.router.util.$templateFactory
	   * 
	   * @description
	   * Loads a template from the a URL via `$http` and `$templateCache`.
	   *
	   * @param {string|Function} url url of the template to load, or a function 
	   * that returns a url.
	   * @param {Object} params Parameters to pass to the url function.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */this.fromUrl=function(url,params){if(isFunction(url))url=url(params);if(url==null)return null;else return $http.get(url,{cache:$templateCache,headers:{Accept:'text/html'}}).then(function(response){return response.data;});};/**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromProvider
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template by invoking an injectable provider function.
	   *
	   * @param {Function} provider Function to invoke via `$injector.invoke`
	   * @param {Object} params Parameters for the template.
	   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
	   * `{ params: params }`.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */this.fromProvider=function(provider,params,locals){return $injector.invoke(provider,null,locals||{params:params});};}angular.module('ui.router.util').service('$templateFactory',$TemplateFactory);var $$UMFP;// reference to $UrlMatcherFactoryProvider
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
	 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
	 *
	 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
	 * syntax, which optionally allows a regular expression for the parameter to be specified:
	 *
	 * * `':'` name - colon placeholder
	 * * `'*'` name - catch-all placeholder
	 * * `'{' name '}'` - curly placeholder
	 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
	 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters). For colon
	 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
	 * number of characters other than '/'. For catch-all placeholders the path parameter matches
	 * any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 * @param {string} pattern  The pattern to compile into a matcher.
	 * @param {Object} config  A configuration object hash:
	 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
	 *   an existing UrlMatcher
	 *
	 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
	 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
	 *
	 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
	 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
	 *   non-null) will start with this prefix.
	 *
	 * @property {string} source  The pattern that was passed into the constructor
	 *
	 * @property {string} sourcePath  The path portion of the source property
	 *
	 * @property {string} sourceSearch  The search portion of the source property
	 *
	 * @property {string} regex  The constructed regex that will be used to match against the url when
	 *   it is time to determine which url will match.
	 *
	 * @returns {Object}  New `UrlMatcher` object
	 */function UrlMatcher(pattern,config,parentMatcher){config=extend({params:{}},isObject(config)?config:{});// Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	//   '*' name
	//   ':' name
	//   '{' name '}'
	//   '{' name ':' regexp '}'
	// The regular expression is somewhat complicated due to the need to allow curly braces
	// inside the regular expression. The placeholder regexp breaks down as follows:
	//    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	//    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	//    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	//    [^{}\\]+                       - anything other than curly braces or backslash
	//    \\.                            - a backslash escape
	//    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	var placeholder=/([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,searchPlaceholder=/([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,compiled='^',last=0,m,segments=this.segments=[],parentParams=parentMatcher?parentMatcher.params:{},params=this.params=parentMatcher?parentMatcher.params.$$new():new $$UMFP.ParamSet(),paramNames=[];function addParameter(id,type,config,location){paramNames.push(id);if(parentParams[id])return parentParams[id];if(!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id))throw new Error("Invalid parameter name '"+id+"' in pattern '"+pattern+"'");if(params[id])throw new Error("Duplicate parameter name '"+id+"' in pattern '"+pattern+"'");params[id]=new $$UMFP.Param(id,type,config,location);return params[id];}function quoteRegExp(string,pattern,squash,optional){var surroundPattern=['',''],result=string.replace(/[\\\[\]\^$*+?.()|{}]/g,"\\$&");if(!pattern)return result;switch(squash){case false:surroundPattern=['(',')'+(optional?"?":"")];break;case true:result=result.replace(/\/$/,'');surroundPattern=['(?:\/(',')|\/)?'];break;default:surroundPattern=['('+squash+"|",')?'];break;}return result+surroundPattern[0]+pattern+surroundPattern[1];}this.source=pattern;// Split into static segments separated by path parameter placeholders.
	// The number of segments is always 1 more than the number of parameters.
	function matchDetails(m,isSearch){var id,regexp,segment,type,cfg,arrayMode;id=m[2]||m[3];// IE[78] returns '' for unmatched groups instead of null
	cfg=config.params[id];segment=pattern.substring(last,m.index);regexp=isSearch?m[4]:m[4]||(m[1]=='*'?'.*':null);if(regexp){type=$$UMFP.type(regexp)||inherit($$UMFP.type("string"),{pattern:new RegExp(regexp,config.caseInsensitive?'i':undefined)});}return{id:id,regexp:regexp,segment:segment,type:type,cfg:cfg};}var p,param,segment;while(m=placeholder.exec(pattern)){p=matchDetails(m,false);if(p.segment.indexOf('?')>=0)break;// we're into the search part
	param=addParameter(p.id,p.type,p.cfg,"path");compiled+=quoteRegExp(p.segment,param.type.pattern.source,param.squash,param.isOptional);segments.push(p.segment);last=placeholder.lastIndex;}segment=pattern.substring(last);// Find any search parameter names and remove them from the last segment
	var i=segment.indexOf('?');if(i>=0){var search=this.sourceSearch=segment.substring(i);segment=segment.substring(0,i);this.sourcePath=pattern.substring(0,last+i);if(search.length>0){last=0;while(m=searchPlaceholder.exec(search)){p=matchDetails(m,true);param=addParameter(p.id,p.type,p.cfg,"search");last=placeholder.lastIndex;// check if ?&
	}}}else{this.sourcePath=pattern;this.sourceSearch='';}compiled+=quoteRegExp(segment)+(config.strict===false?'\/?':'')+'$';segments.push(segment);this.regexp=new RegExp(compiled,config.caseInsensitive?'i':undefined);this.prefix=segments[0];this.$$paramNames=paramNames;}/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#concat
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns a new matcher for a pattern constructed by appending the path part and adding the
	 * search parameters of the specified pattern to this pattern. The current pattern is not
	 * modified. This can be understood as creating a pattern for URLs that are relative to (or
	 * suffixes of) the current pattern.
	 *
	 * @example
	 * The following two matchers are equivalent:
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').concat('/details?date');
	 * new UrlMatcher('/user/{id}/details?q&date');
	 * </pre>
	 *
	 * @param {string} pattern  The pattern to append.
	 * @param {Object} config  An object hash of the configuration for the matcher.
	 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
	 */UrlMatcher.prototype.concat=function(pattern,config){// Because order of search parameters is irrelevant, we can add our own search
	// parameters to the end of the new pattern. Parse the new pattern by itself
	// and then join the bits together, but it's much easier to do this on a string level.
	var defaultConfig={caseInsensitive:$$UMFP.caseInsensitive(),strict:$$UMFP.strictMode(),squash:$$UMFP.defaultSquashPolicy()};return new UrlMatcher(this.sourcePath+pattern+this.sourceSearch,extend(defaultConfig,config),this);};UrlMatcher.prototype.toString=function(){return this.source;};/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#exec
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Tests the specified path against this matcher, and returns an object containing the captured
	 * parameter values, or null if the path does not match. The returned object contains the values
	 * of any search parameters that are mentioned in the pattern, but their value may be null if
	 * they are not present in `searchParams`. This means that search parameters are always treated
	 * as optional.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	 *   x: '1', q: 'hello'
	 * });
	 * // returns { id: 'bob', q: 'hello', r: null }
	 * </pre>
	 *
	 * @param {string} path  The URL path to match, e.g. `$location.path()`.
	 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
	 * @returns {Object}  The captured parameter values.
	 */UrlMatcher.prototype.exec=function(path,searchParams){var m=this.regexp.exec(path);if(!m)return null;searchParams=searchParams||{};var paramNames=this.parameters(),nTotal=paramNames.length,nPath=this.segments.length-1,values={},i,j,cfg,paramName;if(nPath!==m.length-1)throw new Error("Unbalanced capture group in route '"+this.source+"'");function decodePathArray(string){function reverseString(str){return str.split("").reverse().join("");}function unquoteDashes(str){return str.replace(/\\-/g,"-");}var split=reverseString(string).split(/-(?!\\)/);var allReversed=map(split,reverseString);return map(allReversed,unquoteDashes).reverse();}var param,paramVal;for(i=0;i<nPath;i++){paramName=paramNames[i];param=this.params[paramName];paramVal=m[i+1];// if the param value matches a pre-replace pair, replace the value before decoding.
	for(j=0;j<param.replace.length;j++){if(param.replace[j].from===paramVal)paramVal=param.replace[j].to;}if(paramVal&&param.array===true)paramVal=decodePathArray(paramVal);if(isDefined(paramVal))paramVal=param.type.decode(paramVal);values[paramName]=param.value(paramVal);}for(;/**/i<nTotal;i++){paramName=paramNames[i];values[paramName]=this.params[paramName].value(searchParams[paramName]);param=this.params[paramName];paramVal=searchParams[paramName];for(j=0;j<param.replace.length;j++){if(param.replace[j].from===paramVal)paramVal=param.replace[j].to;}if(isDefined(paramVal))paramVal=param.type.decode(paramVal);values[paramName]=param.value(paramVal);}return values;};/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#parameters
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns the names of all path and search parameters of this pattern in an unspecified order.
	 *
	 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
	 *    pattern has no parameters, an empty array is returned.
	 */UrlMatcher.prototype.parameters=function(param){if(!isDefined(param))return this.$$paramNames;return this.params[param]||null;};/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#validates
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Checks an object hash of parameters to validate their correctness according to the parameter
	 * types of this `UrlMatcher`.
	 *
	 * @param {Object} params The object hash of parameters to validate.
	 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
	 */UrlMatcher.prototype.validates=function(params){return this.params.$$validates(params);};/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#format
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Creates a URL that matches this pattern by substituting the specified values
	 * for the path and search parameters. Null values for path parameters are
	 * treated as empty strings.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	 * // returns '/user/bob?q=yes'
	 * </pre>
	 *
	 * @param {Object} values  the values to substitute for the parameters in this pattern.
	 * @returns {string}  the formatted URL (path and optionally search part).
	 */UrlMatcher.prototype.format=function(values){values=values||{};var segments=this.segments,params=this.parameters(),paramset=this.params;if(!this.validates(values))return null;var i,search=false,nPath=segments.length-1,nTotal=params.length,result=segments[0];function encodeDashes(str){// Replace dashes with encoded "\-"
	return encodeURIComponent(str).replace(/-/g,function(c){return'%5C%'+c.charCodeAt(0).toString(16).toUpperCase();});}for(i=0;i<nTotal;i++){var isPathParam=i<nPath;var name=params[i],param=paramset[name],value=param.value(values[name]);var isDefaultValue=param.isOptional&&param.type.equals(param.value(),value);var squash=isDefaultValue?param.squash:false;var encoded=param.type.encode(value);if(isPathParam){var nextSegment=segments[i+1];var isFinalPathParam=i+1===nPath;if(squash===false){if(encoded!=null){if(isArray(encoded)){result+=map(encoded,encodeDashes).join("-");}else{result+=encodeURIComponent(encoded);}}result+=nextSegment;}else if(squash===true){var capture=result.match(/\/$/)?/\/?(.*)/:/(.*)/;result+=nextSegment.match(capture)[1];}else if(isString(squash)){result+=squash+nextSegment;}if(isFinalPathParam&&param.squash===true&&result.slice(-1)==='/')result=result.slice(0,-1);}else{if(encoded==null||isDefaultValue&&squash!==false)continue;if(!isArray(encoded))encoded=[encoded];if(encoded.length===0)continue;encoded=map(encoded,encodeURIComponent).join('&'+name+'=');result+=(search?'&':'?')+(name+'='+encoded);search=true;}}return result;};/**
	 * @ngdoc object
	 * @name ui.router.util.type:Type
	 *
	 * @description
	 * Implements an interface to define custom parameter types that can be decoded from and encoded to
	 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
	 * objects when matching or formatting URLs, or comparing or validating parameter values.
	 *
	 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
	 * information on registering custom types.
	 *
	 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
	 *        properties will override the default methods and/or pattern in `Type`'s public interface.
	 * @example
	 * <pre>
	 * {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 * </pre>
	 *
	 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
	 *           coming from a substring of a URL.
	 *
	 * @returns {Object}  Returns a new `Type` object.
	 */function Type(config){extend(this,config);}/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#is
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Detects whether a value is of a particular type. Accepts a native (decoded) value
	 * and determines whether it matches the current `Type` object.
	 *
	 * @param {*} val  The value to check.
	 * @param {string} key  Optional. If the type check is happening in the context of a specific
	 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
	 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
	 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
	 */Type.prototype.is=function(val,key){return true;};/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#encode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
	 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
	 * only needs to be a representation of `val` that has been coerced to a string.
	 *
	 * @param {*} val  The value to encode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
	 */Type.prototype.encode=function(val,key){return val;};/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#decode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Converts a parameter value (from URL string or transition param) to a custom/native value.
	 *
	 * @param {string} val  The URL parameter value to decode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {*}  Returns a custom representation of the URL parameter value.
	 */Type.prototype.decode=function(val,key){return val;};/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#equals
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Determines whether two decoded values are equivalent.
	 *
	 * @param {*} a  A value to compare against.
	 * @param {*} b  A value to compare against.
	 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
	 */Type.prototype.equals=function(a,b){return a==b;};Type.prototype.$subPattern=function(){var sub=this.pattern.toString();return sub.substr(1,sub.length-2);};Type.prototype.pattern=/.*/;Type.prototype.toString=function(){return"{Type:"+this.name+"}";};/** Given an encoded string, or a decoded object, returns a decoded object */Type.prototype.$normalize=function(val){return this.is(val)?val:this.decode(val);};/*
	 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
	 * e.g.:
	 * - urlmatcher pattern "/path?{queryParam[]:int}"
	 * - url: "/path?queryParam=1&queryParam=2
	 * - $stateParams.queryParam will be [1, 2]
	 * if `mode` is "auto", then
	 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	 */Type.prototype.$asArray=function(mode,isSearch){if(!mode)return this;if(mode==="auto"&&!isSearch)throw new Error("'auto' array mode is for query parameters only");function ArrayType(type,mode){function bindTo(type,callbackName){return function(){return type[callbackName].apply(type,arguments);};}// Wrap non-array value as array
	function arrayWrap(val){return isArray(val)?val:isDefined(val)?[val]:[];}// Unwrap array value for "auto" mode. Return undefined for empty array.
	function arrayUnwrap(val){switch(val.length){case 0:return undefined;case 1:return mode==="auto"?val[0]:val;default:return val;}}function falsey(val){return!val;}// Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	function arrayHandler(callback,allTruthyMode){return function handleArray(val){if(isArray(val)&&val.length===0)return val;val=arrayWrap(val);var result=map(val,callback);if(allTruthyMode===true)return filter(result,falsey).length===0;return arrayUnwrap(result);};}// Wraps type (.equals) functions to operate on each value of an array
	function arrayEqualsHandler(callback){return function handleArray(val1,val2){var left=arrayWrap(val1),right=arrayWrap(val2);if(left.length!==right.length)return false;for(var i=0;i<left.length;i++){if(!callback(left[i],right[i]))return false;}return true;};}this.encode=arrayHandler(bindTo(type,'encode'));this.decode=arrayHandler(bindTo(type,'decode'));this.is=arrayHandler(bindTo(type,'is'),true);this.equals=arrayEqualsHandler(bindTo(type,'equals'));this.pattern=type.pattern;this.$normalize=arrayHandler(bindTo(type,'$normalize'));this.name=type.name;this.$arrayMode=mode;}return new ArrayType(this,mode);};/**
	 * @ngdoc object
	 * @name ui.router.util.$urlMatcherFactory
	 *
	 * @description
	 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
	 * is also available to providers under the name `$urlMatcherFactoryProvider`.
	 */function $UrlMatcherFactory(){$$UMFP=this;var isCaseInsensitive=false,isStrictMode=true,defaultSquashPolicy=false;// Use tildes to pre-encode slashes.
	// If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
	// and bidirectional encoding/decoding fails.
	// Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
	function valToString(val){return val!=null?val.toString().replace(/~/g,"~~").replace(/\//g,"~2F"):val;}function valFromString(val){return val!=null?val.toString().replace(/~2F/g,"/").replace(/~~/g,"~"):val;}var $types={},enqueue=true,typeQueue=[],injector,defaultTypes={"string":{encode:valToString,decode:valFromString,// TODO: in 1.0, make string .is() return false if value is undefined/null by default.
	// In 0.2.x, string params are optional by default for backwards compat
	is:function is(val){return val==null||!isDefined(val)||typeof val==="string";},pattern:/[^/]*/},"int":{encode:valToString,decode:function decode(val){return parseInt(val,10);},is:function is(val){return isDefined(val)&&this.decode(val.toString())===val;},pattern:/\d+/},"bool":{encode:function encode(val){return val?1:0;},decode:function decode(val){return parseInt(val,10)!==0;},is:function is(val){return val===true||val===false;},pattern:/0|1/},"date":{encode:function encode(val){if(!this.is(val))return undefined;return[val.getFullYear(),('0'+(val.getMonth()+1)).slice(-2),('0'+val.getDate()).slice(-2)].join("-");},decode:function decode(val){if(this.is(val))return val;var match=this.capture.exec(val);return match?new Date(match[1],match[2]-1,match[3]):undefined;},is:function is(val){return val instanceof Date&&!isNaN(val.valueOf());},equals:function equals(a,b){return this.is(a)&&this.is(b)&&a.toISOString()===b.toISOString();},pattern:/[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,capture:/([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/},"json":{encode:angular.toJson,decode:angular.fromJson,is:angular.isObject,equals:angular.equals,pattern:/[^/]*/},"any":{// does not encode/decode
	encode:angular.identity,decode:angular.identity,equals:angular.equals,pattern:/.*/}};function getDefaultConfig(){return{strict:isStrictMode,caseInsensitive:isCaseInsensitive};}function isInjectable(value){return isFunction(value)||isArray(value)&&isFunction(value[value.length-1]);}/**
	   * [Internal] Get the default value of a parameter, which may be an injectable function.
	   */$UrlMatcherFactory.$$getDefaultValue=function(config){if(!isInjectable(config.value))return config.value;if(!injector)throw new Error("Injectable functions cannot be called at configuration time");return injector.invoke(config.value);};/**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URL matching should be case sensitive (the default behavior), or not.
	   *
	   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
	   * @returns {boolean} the current value of caseInsensitive
	   */this.caseInsensitive=function(value){if(isDefined(value))isCaseInsensitive=value;return isCaseInsensitive;};/**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#strictMode
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URLs should match trailing slashes, or not (the default behavior).
	   *
	   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
	   * @returns {boolean} the current value of strictMode
	   */this.strictMode=function(value){if(isDefined(value))isStrictMode=value;return isStrictMode;};/**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Sets the default behavior when generating or matching URLs with default parameter values.
	   *
	   * @param {string} value A string that defines the default parameter URL squashing behavior.
	   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
	   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	   *             the parameter value from the URL and replace it with this string.
	   */this.defaultSquashPolicy=function(value){if(!isDefined(value))return defaultSquashPolicy;if(value!==true&&value!==false&&!isString(value))throw new Error("Invalid squash policy: "+value+". Valid policies: false, true, arbitrary-string");defaultSquashPolicy=value;return value;};/**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#compile
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
	   *
	   * @param {string} pattern  The URL pattern.
	   * @param {Object} config  The config object hash.
	   * @returns {UrlMatcher}  The UrlMatcher.
	   */this.compile=function(pattern,config){return new UrlMatcher(pattern,extend(getDefaultConfig(),config));};/**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#isMatcher
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
	   *
	   * @param {Object} object  The object to perform the type check against.
	   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
	   *          implementing all the same methods.
	   */this.isMatcher=function(o){if(!isObject(o))return false;var result=true;forEach(UrlMatcher.prototype,function(val,name){if(isFunction(val)){result=result&&isDefined(o[name])&&isFunction(o[name]);}});return result;};/**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#type
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
	   * generate URLs with typed parameters.
	   *
	   * @param {string} name  The type name.
	   * @param {Object|Function} definition   The type definition. See
	   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
	   *        runtime starts.  The result of this function is merged into the existing `definition`.
	   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   *
	   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
	   *
	   * @example
	   * This is a simple example of a custom type that encodes and decodes items from an
	   * array, using the array index as the URL-encoded value:
	   *
	   * <pre>
	   * var list = ['John', 'Paul', 'George', 'Ringo'];
	   *
	   * $urlMatcherFactoryProvider.type('listItem', {
	   *   encode: function(item) {
	   *     // Represent the list item in the URL using its corresponding index
	   *     return list.indexOf(item);
	   *   },
	   *   decode: function(item) {
	   *     // Look up the list item by index
	   *     return list[parseInt(item, 10)];
	   *   },
	   *   is: function(item) {
	   *     // Ensure the item is valid by checking to see that it appears
	   *     // in the list
	   *     return list.indexOf(item) > -1;
	   *   }
	   * });
	   *
	   * $stateProvider.state('list', {
	   *   url: "/list/{item:listItem}",
	   *   controller: function($scope, $stateParams) {
	   *     console.log($stateParams.item);
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * // Changes URL to '/list/3', logs "Ringo" to the console
	   * $state.go('list', { item: "Ringo" });
	   * </pre>
	   *
	   * This is a more complex example of a type that relies on dependency injection to
	   * interact with services, and uses the parameter name from the URL to infer how to
	   * handle encoding and decoding parameter values:
	   *
	   * <pre>
	   * // Defines a custom type that gets a value from a service,
	   * // where each service gets different types of values from
	   * // a backend API:
	   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
	   *
	   *   // Matches up services to URL parameter names
	   *   var services = {
	   *     user: Users,
	   *     post: Posts
	   *   };
	   *
	   *   return {
	   *     encode: function(object) {
	   *       // Represent the object in the URL using its unique ID
	   *       return object.id;
	   *     },
	   *     decode: function(value, key) {
	   *       // Look up the object by ID, using the parameter
	   *       // name (key) to call the correct service
	   *       return services[key].findById(value);
	   *     },
	   *     is: function(object, key) {
	   *       // Check that object is a valid dbObject
	   *       return angular.isObject(object) && object.id && services[key];
	   *     }
	   *     equals: function(a, b) {
	   *       // Check the equality of decoded objects by comparing
	   *       // their unique IDs
	   *       return a.id === b.id;
	   *     }
	   *   };
	   * });
	   *
	   * // In a config() block, you can then attach URLs with
	   * // type-annotated parameters:
	   * $stateProvider.state('users', {
	   *   url: "/users",
	   *   // ...
	   * }).state('users.item', {
	   *   url: "/{user:dbObject}",
	   *   controller: function($scope, $stateParams) {
	   *     // $stateParams.user will now be an object returned from
	   *     // the Users service
	   *   },
	   *   // ...
	   * });
	   * </pre>
	   */this.type=function(name,definition,definitionFn){if(!isDefined(definition))return $types[name];if($types.hasOwnProperty(name))throw new Error("A type named '"+name+"' has already been defined.");$types[name]=new Type(extend({name:name},definition));if(definitionFn){typeQueue.push({name:name,def:definitionFn});if(!enqueue)flushTypeQueue();}return this;};// `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
	function flushTypeQueue(){while(typeQueue.length){var type=typeQueue.shift();if(type.pattern)throw new Error("You cannot override a type's .pattern at runtime.");angular.extend($types[type.name],injector.invoke(type.def));}}// Register default types. Store them in the prototype of $types.
	forEach(defaultTypes,function(type,name){$types[name]=new Type(extend({name:name},type));});$types=inherit($types,{});/* No need to document $get, since it returns this */this.$get=['$injector',function($injector){injector=$injector;enqueue=false;flushTypeQueue();forEach(defaultTypes,function(type,name){if(!$types[name])$types[name]=new Type(type);});return this;}];this.Param=function Param(id,type,config,location){var self=this;config=unwrapShorthand(config);type=getType(config,type,location);var arrayMode=getArrayMode();type=arrayMode?type.$asArray(arrayMode,location==="search"):type;if(type.name==="string"&&!arrayMode&&location==="path"&&config.value===undefined)config.value="";// for 0.2.x; in 0.3.0+ do not automatically default to ""
	var isOptional=config.value!==undefined;var squash=getSquashPolicy(config,isOptional);var replace=getReplace(config,arrayMode,isOptional,squash);function unwrapShorthand(config){var keys=isObject(config)?objectKeys(config):[];var isShorthand=indexOf(keys,"value")===-1&&indexOf(keys,"type")===-1&&indexOf(keys,"squash")===-1&&indexOf(keys,"array")===-1;if(isShorthand)config={value:config};config.$$fn=isInjectable(config.value)?config.value:function(){return config.value;};return config;}function getType(config,urlType,location){if(config.type&&urlType)throw new Error("Param '"+id+"' has two type configurations.");if(urlType)return urlType;if(!config.type)return location==="config"?$types.any:$types.string;if(angular.isString(config.type))return $types[config.type];if(config.type instanceof Type)return config.type;return new Type(config.type);}// array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	function getArrayMode(){var arrayDefaults={array:location==="search"?"auto":false};var arrayParamNomenclature=id.match(/\[\]$/)?{array:true}:{};return extend(arrayDefaults,arrayParamNomenclature,config).array;}/**
	     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	     */function getSquashPolicy(config,isOptional){var squash=config.squash;if(!isOptional||squash===false)return false;if(!isDefined(squash)||squash==null)return defaultSquashPolicy;if(squash===true||isString(squash))return squash;throw new Error("Invalid squash policy: '"+squash+"'. Valid policies: false, true, or arbitrary string");}function getReplace(config,arrayMode,isOptional,squash){var replace,configuredKeys,defaultPolicy=[{from:"",to:isOptional||arrayMode?undefined:""},{from:null,to:isOptional||arrayMode?undefined:""}];replace=isArray(config.replace)?config.replace:[];if(isString(squash))replace.push({from:squash,to:undefined});configuredKeys=map(replace,function(item){return item.from;});return filter(defaultPolicy,function(item){return indexOf(configuredKeys,item.from)===-1;}).concat(replace);}/**
	     * [Internal] Get the default value of a parameter, which may be an injectable function.
	     */function $$getDefaultValue(){if(!injector)throw new Error("Injectable functions cannot be called at configuration time");var defaultValue=injector.invoke(config.$$fn);if(defaultValue!==null&&defaultValue!==undefined&&!self.type.is(defaultValue))throw new Error("Default value ("+defaultValue+") for parameter '"+self.id+"' is not an instance of Type ("+self.type.name+")");return defaultValue;}/**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */function $value(value){function hasReplaceVal(val){return function(obj){return obj.from===val;};}function $replace(value){var replacement=map(filter(self.replace,hasReplaceVal(value)),function(obj){return obj.to;});return replacement.length?replacement[0]:value;}value=$replace(value);return!isDefined(value)?$$getDefaultValue():self.type.$normalize(value);}function toString(){return"{Param:"+id+" "+type+" squash: '"+squash+"' optional: "+isOptional+"}";}extend(this,{id:id,type:type,location:location,array:arrayMode,squash:squash,replace:replace,isOptional:isOptional,value:$value,dynamic:undefined,config:config,toString:toString});};function ParamSet(params){extend(this,params||{});}ParamSet.prototype={$$new:function $$new(){return inherit(this,extend(new ParamSet(),{$$parent:this}));},$$keys:function $$keys(){var keys=[],chain=[],parent=this,ignore=objectKeys(ParamSet.prototype);while(parent){chain.push(parent);parent=parent.$$parent;}chain.reverse();forEach(chain,function(paramset){forEach(objectKeys(paramset),function(key){if(indexOf(keys,key)===-1&&indexOf(ignore,key)===-1)keys.push(key);});});return keys;},$$values:function $$values(paramValues){var values={},self=this;forEach(self.$$keys(),function(key){values[key]=self[key].value(paramValues&&paramValues[key]);});return values;},$$equals:function $$equals(paramValues1,paramValues2){var equal=true,self=this;forEach(self.$$keys(),function(key){var left=paramValues1&&paramValues1[key],right=paramValues2&&paramValues2[key];if(!self[key].type.equals(left,right))equal=false;});return equal;},$$validates:function $$validate(paramValues){var keys=this.$$keys(),i,param,rawVal,normalized,encoded;for(i=0;i<keys.length;i++){param=this[keys[i]];rawVal=paramValues[keys[i]];if((rawVal===undefined||rawVal===null)&&param.isOptional)break;// There was no parameter value, but the param is optional
	normalized=param.type.$normalize(rawVal);if(!param.type.is(normalized))return false;// The value was not of the correct Type, and could not be decoded to the correct Type
	encoded=param.type.encode(normalized);if(angular.isString(encoded)&&!param.type.pattern.exec(encoded))return false;// The value was of the correct type, but when encoded, did not match the Type's regexp
	}return true;},$$parent:undefined};this.ParamSet=ParamSet;}// Register as a provider so it's available to other providers
	angular.module('ui.router.util').provider('$urlMatcherFactory',$UrlMatcherFactory);angular.module('ui.router.util').run(['$urlMatcherFactory',function($urlMatcherFactory){}]);/**
	 * @ngdoc object
	 * @name ui.router.router.$urlRouterProvider
	 *
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 * @requires $locationProvider
	 *
	 * @description
	 * `$urlRouterProvider` has the responsibility of watching `$location`. 
	 * When `$location` changes it runs through a list of rules one by one until a 
	 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
	 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
	 *
	 * There are several methods on `$urlRouterProvider` that make it useful to use directly
	 * in your module config.
	 */$UrlRouterProvider.$inject=['$locationProvider','$urlMatcherFactoryProvider'];function $UrlRouterProvider($locationProvider,$urlMatcherFactory){var rules=[],otherwise=null,interceptDeferred=false,listener;// Returns a string that is a prefix of all strings matching the RegExp
	function regExpPrefix(re){var prefix=/^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);return prefix!=null?prefix[1].replace(/\\(.)/g,"$1"):'';}// Interpolates matched values into a String.replace()-style pattern
	function interpolate(pattern,match){return pattern.replace(/\$(\$|\d{1,2})/,function(m,what){return match[what==='$'?0:Number(what)];});}/**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#rule
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines rules that are used by `$urlRouterProvider` to find matches for
	   * specific URLs.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // Here's an example of how you might allow case insensitive urls
	   *   $urlRouterProvider.rule(function ($injector, $location) {
	   *     var path = $location.path(),
	   *         normalized = path.toLowerCase();
	   *
	   *     if (path !== normalized) {
	   *       return normalized;
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {function} rule Handler function that takes `$injector` and `$location`
	   * services as arguments. You can use them to return a valid path as a string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */this.rule=function(rule){if(!isFunction(rule))throw new Error("'rule' must be a function");rules.push(rule);return this;};/**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouterProvider#otherwise
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines a path that is used when an invalid route is requested.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // if the path doesn't match any of the urls you configured
	   *   // otherwise will take care of routing the user to the
	   *   // specified url
	   *   $urlRouterProvider.otherwise('/index');
	   *
	   *   // Example of using function rule as param
	   *   $urlRouterProvider.otherwise(function ($injector, $location) {
	   *     return '/a/valid/url';
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|function} rule The url path you want to redirect to or a function 
	   * rule that returns the url path. The function version is passed two params: 
	   * `$injector` and `$location` services, and must return a url string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */this.otherwise=function(rule){if(isString(rule)){var redirect=rule;rule=function rule(){return redirect;};}else if(!isFunction(rule))throw new Error("'rule' must be a function");otherwise=rule;return this;};function handleIfMatch($injector,handler,match){if(!match)return false;var result=$injector.invoke(handler,handler,{$match:match});return isDefined(result)?result:true;}/**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#when
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Registers a handler for a given url matching. 
	   * 
	   * If the handler is a string, it is
	   * treated as a redirect, and is interpolated according to the syntax of match
	   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	   *
	   * If the handler is a function, it is injectable. It gets invoked if `$location`
	   * matches. You have the option of inject the match object as `$match`.
	   *
	   * The handler can return
	   *
	   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	   *   will continue trying to find another one that matches.
	   * - **string** which is treated as a redirect and passed to `$location.url()`
	   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	   *     if ($state.$current.navigable !== state ||
	   *         !equalForKeys($match, $stateParams) {
	   *      $state.transitionTo(state, $match, false);
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|object} what The incoming path that you want to redirect.
	   * @param {string|function} handler The path you want to redirect your user to.
	   */this.when=function(what,handler){var redirect,handlerIsString=isString(handler);if(isString(what))what=$urlMatcherFactory.compile(what);if(!handlerIsString&&!isFunction(handler)&&!isArray(handler))throw new Error("invalid 'handler' in when()");var strategies={matcher:function matcher(what,handler){if(handlerIsString){redirect=$urlMatcherFactory.compile(handler);handler=['$match',function($match){return redirect.format($match);}];}return extend(function($injector,$location){return handleIfMatch($injector,handler,what.exec($location.path(),$location.search()));},{prefix:isString(what.prefix)?what.prefix:''});},regex:function regex(what,handler){if(what.global||what.sticky)throw new Error("when() RegExp must not be global or sticky");if(handlerIsString){redirect=handler;handler=['$match',function($match){return interpolate(redirect,$match);}];}return extend(function($injector,$location){return handleIfMatch($injector,handler,what.exec($location.path()));},{prefix:regExpPrefix(what)});}};var check={matcher:$urlMatcherFactory.isMatcher(what),regex:what instanceof RegExp};for(var n in check){if(check[n])return this.rule(strategies[n](what,handler));}throw new Error("invalid 'what' in when()");};/**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#deferIntercept
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Disables (or enables) deferring location change interception.
	   *
	   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
	   * defer a transition but maintain the current URL), call this method at configuration time.
	   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
	   * `$locationChangeSuccess` event handler.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *
	   *   // Prevent $urlRouter from automatically intercepting URL changes;
	   *   // this allows you to configure custom behavior in between
	   *   // location changes and route synchronization:
	   *   $urlRouterProvider.deferIntercept();
	   *
	   * }).run(function ($rootScope, $urlRouter, UserService) {
	   *
	   *   $rootScope.$on('$locationChangeSuccess', function(e) {
	   *     // UserService is an example service for managing user state
	   *     if (UserService.isLoggedIn()) return;
	   *
	   *     // Prevent $urlRouter's default handler from firing
	   *     e.preventDefault();
	   *
	   *     UserService.handleLogin().then(function() {
	   *       // Once the user has logged in, sync the current URL
	   *       // to the router:
	   *       $urlRouter.sync();
	   *     });
	   *   });
	   *
	   *   // Configures $urlRouter's listener *after* your custom listener
	   *   $urlRouter.listen();
	   * });
	   * </pre>
	   *
	   * @param {boolean} defer Indicates whether to defer location change interception. Passing
	            no parameter is equivalent to `true`.
	   */this.deferIntercept=function(defer){if(defer===undefined)defer=true;interceptDeferred=defer;};/**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouter
	   *
	   * @requires $location
	   * @requires $rootScope
	   * @requires $injector
	   * @requires $browser
	   *
	   * @description
	   *
	   */this.$get=$get;$get.$inject=['$location','$rootScope','$injector','$browser','$sniffer'];function $get($location,$rootScope,$injector,$browser,$sniffer){var baseHref=$browser.baseHref(),location=$location.url(),lastPushedUrl;function appendBasePath(url,isHtml5,absolute){if(baseHref==='/')return url;if(isHtml5)return baseHref.slice(0,-1)+url;if(absolute)return baseHref.slice(1)+url;return url;}// TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
	function update(evt){if(evt&&evt.defaultPrevented)return;var ignoreUpdate=lastPushedUrl&&$location.url()===lastPushedUrl;lastPushedUrl=undefined;// TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
	//if (ignoreUpdate) return true;
	function check(rule){var handled=rule($injector,$location);if(!handled)return false;if(isString(handled))$location.replace().url(handled);return true;}var n=rules.length,i;for(i=0;i<n;i++){if(check(rules[i]))return;}// always check otherwise last to allow dynamic updates to the set of rules
	if(otherwise)check(otherwise);}function _listen(){listener=listener||$rootScope.$on('$locationChangeSuccess',update);return listener;}if(!interceptDeferred)_listen();return{/**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#sync
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
	       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
	       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
	       * with the transition by calling `$urlRouter.sync()`.
	       *
	       * @example
	       * <pre>
	       * angular.module('app', ['ui.router'])
	       *   .run(function($rootScope, $urlRouter) {
	       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
	       *       // Halt state change from even starting
	       *       evt.preventDefault();
	       *       // Perform custom logic
	       *       var meetsRequirement = ...
	       *       // Continue with the update and state transition if logic allows
	       *       if (meetsRequirement) $urlRouter.sync();
	       *     });
	       * });
	       * </pre>
	       */sync:function sync(){update();},listen:function listen(){return _listen();},update:function update(read){if(read){location=$location.url();return;}if($location.url()===location)return;$location.url(location);$location.replace();},push:function push(urlMatcher,params,options){var url=urlMatcher.format(params||{});// Handle the special hash param, if needed
	if(url!==null&&params&&params['#']){url+='#'+params['#'];}$location.url(url);lastPushedUrl=options&&options.$$avoidResync?$location.url():undefined;if(options&&options.replace)$location.replace();},/**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#href
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * A URL generation method that returns the compiled URL for a given
	       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
	       *
	       * @example
	       * <pre>
	       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
	       *   person: "bob"
	       * });
	       * // $bob == "/about/bob";
	       * </pre>
	       *
	       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
	       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	       *
	       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	       */href:function href(urlMatcher,params,options){if(!urlMatcher.validates(params))return null;var isHtml5=$locationProvider.html5Mode();if(angular.isObject(isHtml5)){isHtml5=isHtml5.enabled;}isHtml5=isHtml5&&$sniffer.history;var url=urlMatcher.format(params);options=options||{};if(!isHtml5&&url!==null){url="#"+$locationProvider.hashPrefix()+url;}// Handle special hash param, if needed
	if(url!==null&&params&&params['#']){url+='#'+params['#'];}url=appendBasePath(url,isHtml5,options.absolute);if(!options.absolute||!url){return url;}var slash=!isHtml5&&url?'/':'',port=$location.port();port=port===80||port===443?'':':'+port;return[$location.protocol(),'://',$location.host(),port,slash,url].join('');}};}}angular.module('ui.router.router').provider('$urlRouter',$UrlRouterProvider);/**
	 * @ngdoc object
	 * @name ui.router.state.$stateProvider
	 *
	 * @requires ui.router.router.$urlRouterProvider
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 *
	 * @description
	 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	 * on state.
	 *
	 * A state corresponds to a "place" in the application in terms of the overall UI and
	 * navigation. A state describes (via the controller / template / view properties) what
	 * the UI looks like and does at that place.
	 *
	 * States often have things in common, and the primary way of factoring out these
	 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	 * nested states.
	 *
	 * The `$stateProvider` provides interfaces to declare these states for your app.
	 */$StateProvider.$inject=['$urlRouterProvider','$urlMatcherFactoryProvider'];function $StateProvider($urlRouterProvider,$urlMatcherFactory){var root,states={},$state,queue={},abstractKey='abstract';// Builds state properties from definition passed to registerState()
	var stateBuilder={// Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
	// state.children = [];
	// if (parent) parent.children.push(state);
	parent:function parent(state){if(isDefined(state.parent)&&state.parent)return findState(state.parent);// regex matches any valid composite state name
	// would match "contact.list" but not "contacts"
	var compositeName=/^(.+)\.[^.]+$/.exec(state.name);return compositeName?findState(compositeName[1]):root;},// inherit 'data' from parent and override by own values (if any)
	data:function data(state){if(state.parent&&state.parent.data){state.data=state.self.data=inherit(state.parent.data,state.data);}return state.data;},// Build a URLMatcher if necessary, either via a relative or absolute URL
	url:function url(state){var url=state.url,config={params:state.params||{}};if(isString(url)){if(url.charAt(0)=='^')return $urlMatcherFactory.compile(url.substring(1),config);return(state.parent.navigable||root).url.concat(url,config);}if(!url||$urlMatcherFactory.isMatcher(url))return url;throw new Error("Invalid url '"+url+"' in state '"+state+"'");},// Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	navigable:function navigable(state){return state.url?state:state.parent?state.parent.navigable:null;},// Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
	ownParams:function ownParams(state){var params=state.url&&state.url.params||new $$UMFP.ParamSet();forEach(state.params||{},function(config,id){if(!params[id])params[id]=new $$UMFP.Param(id,null,config,"config");});return params;},// Derive parameters for this state and ensure they're a super-set of parent's parameters
	params:function params(state){var ownParams=pick(state.ownParams,state.ownParams.$$keys());return state.parent&&state.parent.params?extend(state.parent.params.$$new(),ownParams):new $$UMFP.ParamSet();},// If there is no explicit multi-view configuration, make one up so we don't have
	// to handle both cases in the view directive later. Note that having an explicit
	// 'views' property will mean the default unnamed view properties are ignored. This
	// is also a good time to resolve view names to absolute names, so everything is a
	// straight lookup at link time.
	views:function views(state){var views={};forEach(isDefined(state.views)?state.views:{'':state},function(view,name){if(name.indexOf('@')<0)name+='@'+state.parent.name;views[name]=view;});return views;},// Keep a full path from the root down to this state as this is needed for state activation.
	path:function path(state){return state.parent?state.parent.path.concat(state):[];// exclude root from path
	},// Speed up $state.contains() as it's used a lot
	includes:function includes(state){var includes=state.parent?extend({},state.parent.includes):{};includes[state.name]=true;return includes;},$delegates:{}};function isRelative(stateName){return stateName.indexOf(".")===0||stateName.indexOf("^")===0;}function findState(stateOrName,base){if(!stateOrName)return undefined;var isStr=isString(stateOrName),name=isStr?stateOrName:stateOrName.name,path=isRelative(name);if(path){if(!base)throw new Error("No reference point given for path '"+name+"'");base=findState(base);var rel=name.split("."),i=0,pathLength=rel.length,current=base;for(;i<pathLength;i++){if(rel[i]===""&&i===0){current=base;continue;}if(rel[i]==="^"){if(!current.parent)throw new Error("Path '"+name+"' not valid for state '"+base.name+"'");current=current.parent;continue;}break;}rel=rel.slice(i).join(".");name=current.name+(current.name&&rel?".":"")+rel;}var state=states[name];if(state&&(isStr||!isStr&&(state===stateOrName||state.self===stateOrName))){return state;}return undefined;}function queueState(parentName,state){if(!queue[parentName]){queue[parentName]=[];}queue[parentName].push(state);}function flushQueuedChildren(parentName){var queued=queue[parentName]||[];while(queued.length){registerState(queued.shift());}}function registerState(state){// Wrap a new object around the state so we can store our private details easily.
	state=inherit(state,{self:state,resolve:state.resolve||{},toString:function toString(){return this.name;}});var name=state.name;if(!isString(name)||name.indexOf('@')>=0)throw new Error("State must have a valid name");if(states.hasOwnProperty(name))throw new Error("State '"+name+"' is already defined");// Get parent name
	var parentName=name.indexOf('.')!==-1?name.substring(0,name.lastIndexOf('.')):isString(state.parent)?state.parent:isObject(state.parent)&&isString(state.parent.name)?state.parent.name:'';// If parent is not registered yet, add state to queue and register later
	if(parentName&&!states[parentName]){return queueState(parentName,state.self);}for(var key in stateBuilder){if(isFunction(stateBuilder[key]))state[key]=stateBuilder[key](state,stateBuilder.$delegates[key]);}states[name]=state;// Register the state in the global state list and with $urlRouter if necessary.
	if(!state[abstractKey]&&state.url){$urlRouterProvider.when(state.url,['$match','$stateParams',function($match,$stateParams){if($state.$current.navigable!=state||!equalForKeys($match,$stateParams)){$state.transitionTo(state,$match,{inherit:true,location:false});}}]);}// Register any queued children
	flushQueuedChildren(name);return state;}// Checks text to see if it looks like a glob.
	function isGlob(text){return text.indexOf('*')>-1;}// Returns true if glob matches current $state name.
	function doesStateMatchGlob(glob){var globSegments=glob.split('.'),segments=$state.$current.name.split('.');//match single stars
	for(var i=0,l=globSegments.length;i<l;i++){if(globSegments[i]==='*'){segments[i]='*';}}//match greedy starts
	if(globSegments[0]==='**'){segments=segments.slice(indexOf(segments,globSegments[1]));segments.unshift('**');}//match greedy ends
	if(globSegments[globSegments.length-1]==='**'){segments.splice(indexOf(segments,globSegments[globSegments.length-2])+1,Number.MAX_VALUE);segments.push('**');}if(globSegments.length!=segments.length){return false;}return segments.join('')===globSegments.join('');}// Implicit root state that is always active
	root=registerState({name:'',url:'^',views:null,'abstract':true});root.navigable=null;/**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#decorator
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Allows you to extend (carefully) or override (at your own peril) the 
	   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
	   * to add custom functionality to ui-router, for example inferring templateUrl 
	   * based on the state name.
	   *
	   * When passing only a name, it returns the current (original or decorated) builder
	   * function that matches `name`.
	   *
	   * The builder functions that can be decorated are listed below. Though not all
	   * necessarily have a good use case for decoration, that is up to you to decide.
	   *
	   * In addition, users can attach custom decorators, which will generate new 
	   * properties within the state's internal definition. There is currently no clear 
	   * use-case for this beyond accessing internal states (i.e. $state.$current), 
	   * however, expect this to become increasingly relevant as we introduce additional 
	   * meta-programming features.
	   *
	   * **Warning**: Decorators should not be interdependent because the order of 
	   * execution of the builder functions in non-deterministic. Builder functions 
	   * should only be dependent on the state definition object and super function.
	   *
	   *
	   * Existing builder functions and current return values:
	   *
	   * - **parent** `{object}` - returns the parent state object.
	   * - **data** `{object}` - returns state data, including any inherited data that is not
	   *   overridden by own values (if any).
	   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	   *   or `null`.
	   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
	   *   navigable).
	   * - **params** `{object}` - returns an array of state params that are ensured to 
	   *   be a super-set of parent's params.
	   * - **views** `{object}` - returns a views object where each key is an absolute view 
	   *   name (i.e. "viewName@stateName") and each value is the config object 
	   *   (template, controller) for the view. Even when you don't use the views object 
	   *   explicitly on a state config, one is still created for you internally.
	   *   So by decorating this builder function you have access to decorating template 
	   *   and controller properties.
	   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
	   *   not including any params defined by ancestor states.
	   * - **path** `{string}` - returns the full path from the root down to this state. 
	   *   Needed for state activation.
	   * - **includes** `{object}` - returns an object that includes every state that 
	   *   would pass a `$state.includes()` test.
	   *
	   * @example
	   * <pre>
	   * // Override the internal 'views' builder with a function that takes the state
	   * // definition, and a reference to the internal function being overridden:
	   * $stateProvider.decorator('views', function (state, parent) {
	   *   var result = {},
	   *       views = parent(state);
	   *
	   *   angular.forEach(views, function (config, name) {
	   *     var autoName = (state.name + '.' + name).replace('.', '/');
	   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	   *     result[name] = config;
	   *   });
	   *   return result;
	   * });
	   *
	   * $stateProvider.state('home', {
	   *   views: {
	   *     'contact.list': { controller: 'ListController' },
	   *     'contact.item': { controller: 'ItemController' }
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * $state.go('home');
	   * // Auto-populates list and item views with /partials/home/contact/list.html,
	   * // and /partials/home/contact/item.html, respectively.
	   * </pre>
	   *
	   * @param {string} name The name of the builder function to decorate. 
	   * @param {object} func A function that is responsible for decorating the original 
	   * builder function. The function receives two parameters:
	   *
	   *   - `{object}` - state - The state config object.
	   *   - `{object}` - super - The original builder function.
	   *
	   * @return {object} $stateProvider - $stateProvider instance
	   */this.decorator=decorator;function decorator(name,func){/*jshint validthis: true */if(isString(name)&&!isDefined(func)){return stateBuilder[name];}if(!isFunction(func)||!isString(name)){return this;}if(stateBuilder[name]&&!stateBuilder.$delegates[name]){stateBuilder.$delegates[name]=stateBuilder[name];}stateBuilder[name]=func;return this;}/**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#state
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Registers a state configuration under a given state name. The stateConfig object
	   * has the following acceptable properties.
	   *
	   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
	   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
	   * @param {object} stateConfig State configuration object.
	   * @param {string|function=} stateConfig.template
	   * <a id='template'></a>
	   *   html template as a string or a function that returns
	   *   an html template as a string which should be used by the uiView directives. This property 
	   *   takes precedence over templateUrl.
	   *   
	   *   If `template` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
	   *     applying the current state
	   *
	   * <pre>template:
	   *   "<h1>inline template definition</h1>" +
	   *   "<div ui-view></div>"</pre>
	   * <pre>template: function(params) {
	   *       return "<h1>generated template</h1>"; }</pre>
	   * </div>
	   *
	   * @param {string|function=} stateConfig.templateUrl
	   * <a id='templateUrl'></a>
	   *
	   *   path or function that returns a path to an html
	   *   template that should be used by uiView.
	   *   
	   *   If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
	   *     applying the current state
	   *
	   * <pre>templateUrl: "home.html"</pre>
	   * <pre>templateUrl: function(params) {
	   *     return myTemplates[params.pageId]; }</pre>
	   *
	   * @param {function=} stateConfig.templateProvider
	   * <a id='templateProvider'></a>
	   *    Provider function that returns HTML content string.
	   * <pre> templateProvider:
	   *       function(MyTemplateService, params) {
	   *         return MyTemplateService.getTemplate(params.pageId);
	   *       }</pre>
	   *
	   * @param {string|function=} stateConfig.controller
	   * <a id='controller'></a>
	   *
	   *  Controller fn that should be associated with newly
	   *   related scope or the name of a registered controller if passed as a string.
	   *   Optionally, the ControllerAs may be declared here.
	   * <pre>controller: "MyRegisteredController"</pre>
	   * <pre>controller:
	   *     "MyRegisteredController as fooCtrl"}</pre>
	   * <pre>controller: function($scope, MyService) {
	   *     $scope.data = MyService.getData(); }</pre>
	   *
	   * @param {function=} stateConfig.controllerProvider
	   * <a id='controllerProvider'></a>
	   *
	   * Injectable provider function that returns the actual controller or string.
	   * <pre>controllerProvider:
	   *   function(MyResolveData) {
	   *     if (MyResolveData.foo)
	   *       return "FooCtrl"
	   *     else if (MyResolveData.bar)
	   *       return "BarCtrl";
	   *     else return function($scope) {
	   *       $scope.baz = "Qux";
	   *     }
	   *   }</pre>
	   *
	   * @param {string=} stateConfig.controllerAs
	   * <a id='controllerAs'></a>
	   * 
	   * A controller alias name. If present the controller will be
	   *   published to scope under the controllerAs name.
	   * <pre>controllerAs: "myCtrl"</pre>
	   *
	   * @param {string|object=} stateConfig.parent
	   * <a id='parent'></a>
	   * Optionally specifies the parent state of this state.
	   *
	   * <pre>parent: 'parentState'</pre>
	   * <pre>parent: parentState // JS variable</pre>
	   *
	   * @param {object=} stateConfig.resolve
	   * <a id='resolve'></a>
	   *
	   * An optional map&lt;string, function&gt; of dependencies which
	   *   should be injected into the controller. If any of these dependencies are promises, 
	   *   the router will wait for them all to be resolved before the controller is instantiated.
	   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
	   *   and the values of the resolved promises are injected into any controllers that reference them.
	   *   If any  of the promises are rejected the $stateChangeError event is fired.
	   *
	   *   The map object is:
	   *   
	   *   - key - {string}: name of dependency to be injected into controller
	   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
	   *     it is injected and return value it treated as dependency. If result is a promise, it is 
	   *     resolved before its value is injected into controller.
	   *
	   * <pre>resolve: {
	   *     myResolve1:
	   *       function($http, $stateParams) {
	   *         return $http.get("/api/foos/"+stateParams.fooID);
	   *       }
	   *     }</pre>
	   *
	   * @param {string=} stateConfig.url
	   * <a id='url'></a>
	   *
	   *   A url fragment with optional parameters. When a state is navigated or
	   *   transitioned to, the `$stateParams` service will be populated with any 
	   *   parameters that were passed.
	   *
	   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
	   *   more details on acceptable patterns )
	   *
	   * examples:
	   * <pre>url: "/home"
	   * url: "/users/:userid"
	   * url: "/books/{bookid:[a-zA-Z_-]}"
	   * url: "/books/{categoryid:int}"
	   * url: "/books/{publishername:string}/{categoryid:int}"
	   * url: "/messages?before&after"
	   * url: "/messages?{before:date}&{after:date}"
	   * url: "/messages/:mailboxid?{before:date}&{after:date}"
	   * </pre>
	   *
	   * @param {object=} stateConfig.views
	   * <a id='views'></a>
	   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
	   * manually/explicitly.
	   *
	   * Examples:
	   *
	   * Targets three named `ui-view`s in the parent state's template
	   * <pre>views: {
	   *     header: {
	   *       controller: "headerCtrl",
	   *       templateUrl: "header.html"
	   *     }, body: {
	   *       controller: "bodyCtrl",
	   *       templateUrl: "body.html"
	   *     }, footer: {
	   *       controller: "footCtrl",
	   *       templateUrl: "footer.html"
	   *     }
	   *   }</pre>
	   *
	   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
	   * <pre>views: {
	   *     'header@top': {
	   *       controller: "msgHeaderCtrl",
	   *       templateUrl: "msgHeader.html"
	   *     }, 'body': {
	   *       controller: "messagesCtrl",
	   *       templateUrl: "messages.html"
	   *     }
	   *   }</pre>
	   *
	   * @param {boolean=} [stateConfig.abstract=false]
	   * <a id='abstract'></a>
	   * An abstract state will never be directly activated,
	   *   but can provide inherited properties to its common children states.
	   * <pre>abstract: true</pre>
	   *
	   * @param {function=} stateConfig.onEnter
	   * <a id='onEnter'></a>
	   *
	   * Callback function for when a state is entered. Good way
	   *   to trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onEnter: function(MyService, $stateParams) {
	   *     MyService.foo($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {function=} stateConfig.onExit
	   * <a id='onExit'></a>
	   *
	   * Callback function for when a state is exited. Good way to
	   *   trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onExit: function(MyService, $stateParams) {
	   *     MyService.cleanup($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {boolean=} [stateConfig.reloadOnSearch=true]
	   * <a id='reloadOnSearch'></a>
	   *
	   * If `false`, will not retrigger the same state
	   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
	   *   Useful for when you'd like to modify $location.search() without triggering a reload.
	   * <pre>reloadOnSearch: false</pre>
	   *
	   * @param {object=} stateConfig.data
	   * <a id='data'></a>
	   *
	   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
	   *   prototypally inherited.  In other words, adding a data property to a state adds it to
	   *   the entire subtree via prototypal inheritance.
	   *
	   * <pre>data: {
	   *     requiredRole: 'foo'
	   * } </pre>
	   *
	   * @param {object=} stateConfig.params
	   * <a id='params'></a>
	   *
	   * A map which optionally configures parameters declared in the `url`, or
	   *   defines additional non-url parameters.  For each parameter being
	   *   configured, add a configuration object keyed to the name of the parameter.
	   *
	   *   Each parameter configuration object may contain the following properties:
	   *
	   *   - ** value ** - {object|function=}: specifies the default value for this
	   *     parameter.  This implicitly sets this parameter as optional.
	   *
	   *     When UI-Router routes to a state and no value is
	   *     specified for this parameter in the URL or transition, the
	   *     default value will be used instead.  If `value` is a function,
	   *     it will be injected and invoked, and the return value used.
	   *
	   *     *Note*: `undefined` is treated as "no default value" while `null`
	   *     is treated as "the default value is `null`".
	   *
	   *     *Shorthand*: If you only need to configure the default value of the
	   *     parameter, you may use a shorthand syntax.   In the **`params`**
	   *     map, instead mapping the param name to a full parameter configuration
	   *     object, simply set map it to the default parameter value, e.g.:
	   *
	   * <pre>// define a parameter's default value
	   * params: {
	   *     param1: { value: "defaultValue" }
	   * }
	   * // shorthand default values
	   * params: {
	   *     param1: "defaultValue",
	   *     param2: "param2Default"
	   * }</pre>
	   *
	   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
	   *     treated as an array of values.  If you specified a Type, the value will be
	   *     treated as an array of the specified Type.  Note: query parameter values
	   *     default to a special `"auto"` mode.
	   *
	   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
	   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
	   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
	   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
	   *     value (e.g.: `{ foo: '1' }`).
	   *
	   * <pre>params: {
	   *     param1: { array: true }
	   * }</pre>
	   *
	   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
	   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
	   *     configured default squash policy.
	   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
	   *
	   *   There are three squash settings:
	   *
	   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
	   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
	   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
	   *       This can allow for cleaner looking URLs.
	   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
	   *
	   * <pre>params: {
	   *     param1: {
	   *       value: "defaultId",
	   *       squash: true
	   * } }
	   * // squash "defaultValue" to "~"
	   * params: {
	   *     param1: {
	   *       value: "defaultValue",
	   *       squash: "~"
	   * } }
	   * </pre>
	   *
	   *
	   * @example
	   * <pre>
	   * // Some state name examples
	   *
	   * // stateName can be a single top-level name (must be unique).
	   * $stateProvider.state("home", {});
	   *
	   * // Or it can be a nested state name. This state is a child of the
	   * // above "home" state.
	   * $stateProvider.state("home.newest", {});
	   *
	   * // Nest states as deeply as needed.
	   * $stateProvider.state("home.newest.abc.xyz.inception", {});
	   *
	   * // state() returns $stateProvider, so you can chain state declarations.
	   * $stateProvider
	   *   .state("home", {})
	   *   .state("about", {})
	   *   .state("contacts", {});
	   * </pre>
	   *
	   */this.state=state;function state(name,definition){/*jshint validthis: true */if(isObject(name))definition=name;else definition.name=name;registerState(definition);return this;}/**
	   * @ngdoc object
	   * @name ui.router.state.$state
	   *
	   * @requires $rootScope
	   * @requires $q
	   * @requires ui.router.state.$view
	   * @requires $injector
	   * @requires ui.router.util.$resolve
	   * @requires ui.router.state.$stateParams
	   * @requires ui.router.router.$urlRouter
	   *
	   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
	   * you'd like to test against the current active state.
	   * @property {object} current A reference to the state's config object. However 
	   * you passed it in. Useful for accessing custom data.
	   * @property {object} transition Currently pending transition. A promise that'll 
	   * resolve or reject.
	   *
	   * @description
	   * `$state` service is responsible for representing states as well as transitioning
	   * between them. It also provides interfaces to ask for current state or even states
	   * you're coming from.
	   */this.$get=$get;$get.$inject=['$rootScope','$q','$view','$injector','$resolve','$stateParams','$urlRouter','$location','$urlMatcherFactory'];function $get($rootScope,$q,$view,$injector,$resolve,$stateParams,$urlRouter,$location,$urlMatcherFactory){var TransitionSuperseded=$q.reject(new Error('transition superseded'));var TransitionPrevented=$q.reject(new Error('transition prevented'));var TransitionAborted=$q.reject(new Error('transition aborted'));var TransitionFailed=$q.reject(new Error('transition failed'));// Handles the case where a state which is the target of a transition is not found, and the user
	// can optionally retry or defer the transition
	function handleRedirect(redirect,state,params,options){/**
	       * @ngdoc event
	       * @name ui.router.state.$state#$stateNotFound
	       * @eventOf ui.router.state.$state
	       * @eventType broadcast on root scope
	       * @description
	       * Fired when a requested state **cannot be found** using the provided state name during transition.
	       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
	       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
	       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
	       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
	       *
	       * @param {Object} event Event object.
	       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
	       * @param {State} fromState Current state object.
	       * @param {Object} fromParams Current state params.
	       *
	       * @example
	       *
	       * <pre>
	       * // somewhere, assume lazy.state has not been defined
	       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
	       *
	       * // somewhere else
	       * $scope.$on('$stateNotFound',
	       * function(event, unfoundState, fromState, fromParams){
	       *     console.log(unfoundState.to); // "lazy.state"
	       *     console.log(unfoundState.toParams); // {a:1, b:2}
	       *     console.log(unfoundState.options); // {inherit:false} + default options
	       * })
	       * </pre>
	       */var evt=$rootScope.$broadcast('$stateNotFound',redirect,state,params);if(evt.defaultPrevented){$urlRouter.update();return TransitionAborted;}if(!evt.retry){return null;}// Allow the handler to return a promise to defer state lookup retry
	if(options.$retry){$urlRouter.update();return TransitionFailed;}var retryTransition=$state.transition=$q.when(evt.retry);retryTransition.then(function(){if(retryTransition!==$state.transition)return TransitionSuperseded;redirect.options.$retry=true;return $state.transitionTo(redirect.to,redirect.toParams,redirect.options);},function(){return TransitionAborted;});$urlRouter.update();return retryTransition;}root.locals={resolve:null,globals:{$stateParams:{}}};$state={params:{},current:root.self,$current:root,transition:null};/**
	     * @ngdoc function
	     * @name ui.router.state.$state#reload
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method that force reloads the current state. All resolves are re-resolved,
	     * controllers reinstantiated, and events re-fired.
	     *
	     * @example
	     * <pre>
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	     *
	     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
	     * @example
	     * <pre>
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
	     * //and current state is 'contacts.detail.item'
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */$state.reload=function reload(state){return $state.transitionTo($state.current,$stateParams,{reload:state||true,inherit:false,notify:true});};/**
	     * @ngdoc function
	     * @name ui.router.state.$state#go
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Convenience method for transitioning to a new state. `$state.go` calls 
	     * `$state.transitionTo` internally but automatically sets options to 
	     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
	     * This allows you to easily use an absolute or relative to path and specify 
	     * only the parameters you'd like to update (while letting unspecified parameters 
	     * inherit from the currently active ancestor states).
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * </pre>
	     * <img src='../ngdoc_assets/StateGoExamples.png'/>
	     *
	     * @param {string} to Absolute state name or relative state path. Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to a parent state
	     * - `$state.go('^.sibling')` - will go to a sibling state
	     * - `$state.go('.child.grandchild')` - will go to grandchild state
	     *
	     * @param {object=} params A map of the parameters that will be sent to the state, 
	     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
	     * defined parameters. Only parameters specified in the state definition can be overridden, new 
	     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
	     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
	     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
	     * will get you all current parameters, etc.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
	     *    have changed.  It will reload the resolves and views of the current state and parent states.
	     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
	     *    the transition reloads the resolves and views for that matched state, and all its children states.
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     *
	     * Possible success values:
	     *
	     * - $state.current
	     *
	     * <br/>Possible rejection values:
	     *
	     * - 'transition superseded' - when a newer transition has been started after this one
	     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
	     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
	     *   when a `$stateNotFound` `event.retry` promise errors.
	     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
	     * - *resolve error* - when an error has occurred with a `resolve`
	     *
	     */$state.go=function go(to,params,options){return $state.transitionTo(to,params,extend({inherit:true,relative:$state.$current},options));};/**
	     * @ngdoc function
	     * @name ui.router.state.$state#transitionTo
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
	     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * </pre>
	     *
	     * @param {string} to State name.
	     * @param {object=} toParams A map of the parameters that will be sent to the state,
	     * will populate $stateParams.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
	     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
	     *    use this when you want to force a reload when *everything* is the same, including search params.
	     *    if String, then will reload the state with the name given in reload, and any children.
	     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
	     *
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */$state.transitionTo=function transitionTo(to,toParams,options){toParams=toParams||{};options=extend({location:true,inherit:false,relative:null,notify:true,reload:false,$retry:false},options||{});var from=$state.$current,fromParams=$state.params,fromPath=from.path;var evt,toState=findState(to,options.relative);// Store the hash param for later (since it will be stripped out by various methods)
	var hash=toParams['#'];if(!isDefined(toState)){var redirect={to:to,toParams:toParams,options:options};var redirectResult=handleRedirect(redirect,from.self,fromParams,options);if(redirectResult){return redirectResult;}// Always retry once if the $stateNotFound was not prevented
	// (handles either redirect changed or state lazy-definition)
	to=redirect.to;toParams=redirect.toParams;options=redirect.options;toState=findState(to,options.relative);if(!isDefined(toState)){if(!options.relative)throw new Error("No such state '"+to+"'");throw new Error("Could not resolve '"+to+"' from state '"+options.relative+"'");}}if(toState[abstractKey])throw new Error("Cannot transition to abstract state '"+to+"'");if(options.inherit)toParams=inheritParams($stateParams,toParams||{},$state.$current,toState);if(!toState.params.$$validates(toParams))return TransitionFailed;toParams=toState.params.$$values(toParams);to=toState;var toPath=to.path;// Starting from the root of the path, keep all levels that haven't changed
	var keep=0,state=toPath[keep],locals=root.locals,toLocals=[];if(!options.reload){while(state&&state===fromPath[keep]&&state.ownParams.$$equals(toParams,fromParams)){locals=toLocals[keep]=state.locals;keep++;state=toPath[keep];}}else if(isString(options.reload)||isObject(options.reload)){if(isObject(options.reload)&&!options.reload.name){throw new Error('Invalid reload state object');}var reloadState=options.reload===true?fromPath[0]:findState(options.reload);if(options.reload&&!reloadState){throw new Error("No such reload state '"+(isString(options.reload)?options.reload:options.reload.name)+"'");}while(state&&state===fromPath[keep]&&state!==reloadState){locals=toLocals[keep]=state.locals;keep++;state=toPath[keep];}}// If we're going to the same state and all locals are kept, we've got nothing to do.
	// But clear 'transition', as we still want to cancel any other pending transitions.
	// TODO: We may not want to bump 'transition' if we're called from a location change
	// that we've initiated ourselves, because we might accidentally abort a legitimate
	// transition initiated from code?
	if(shouldSkipReload(to,toParams,from,fromParams,locals,options)){if(hash)toParams['#']=hash;$state.params=toParams;copy($state.params,$stateParams);copy(filterByKeys(to.params.$$keys(),$stateParams),to.locals.globals.$stateParams);if(options.location&&to.navigable&&to.navigable.url){$urlRouter.push(to.navigable.url,toParams,{$$avoidResync:true,replace:options.location==='replace'});$urlRouter.update(true);}$state.transition=null;return $q.when($state.current);}// Filter parameters before we pass them to event handlers etc.
	toParams=filterByKeys(to.params.$$keys(),toParams||{});// Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
	if(hash)toParams['#']=hash;// Broadcast start event and cancel the transition if requested
	if(options.notify){/**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeStart
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when the state transition **begins**. You can use `event.preventDefault()`
	         * to prevent the transition from happening and then the transition promise will be
	         * rejected with a `'transition prevented'` value.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         *
	         * @example
	         *
	         * <pre>
	         * $rootScope.$on('$stateChangeStart',
	         * function(event, toState, toParams, fromState, fromParams){
	         *     event.preventDefault();
	         *     // transitionTo() promise will be rejected with
	         *     // a 'transition prevented' error
	         * })
	         * </pre>
	         */if($rootScope.$broadcast('$stateChangeStart',to.self,toParams,from.self,fromParams,options).defaultPrevented){$rootScope.$broadcast('$stateChangeCancel',to.self,toParams,from.self,fromParams);//Don't update and resync url if there's been a new transition started. see issue #2238, #600
	if($state.transition==null)$urlRouter.update();return TransitionPrevented;}}// Resolve locals for the remaining states, but don't update any global state just
	// yet -- if anything fails to resolve the current state needs to remain untouched.
	// We also set up an inheritance chain for the locals here. This allows the view directive
	// to quickly look up the correct definition for each view in the current state. Even
	// though we create the locals object itself outside resolveState(), it is initially
	// empty and gets filled asynchronously. We need to keep track of the promise for the
	// (fully resolved) current locals, and pass this down the chain.
	var resolved=$q.when(locals);for(var l=keep;l<toPath.length;l++,state=toPath[l]){locals=toLocals[l]=inherit(locals);resolved=resolveState(state,toParams,state===to,resolved,locals,options);}// Once everything is resolved, we are ready to perform the actual transition
	// and return a promise for the new state. We also keep track of what the
	// current promise is, so that we can detect overlapping transitions and
	// keep only the outcome of the last transition.
	var transition=$state.transition=resolved.then(function(){var l,entering,exiting;if($state.transition!==transition)return TransitionSuperseded;// Exit 'from' states not kept
	for(l=fromPath.length-1;l>=keep;l--){exiting=fromPath[l];if(exiting.self.onExit){$injector.invoke(exiting.self.onExit,exiting.self,exiting.locals.globals);}exiting.locals=null;}// Enter 'to' states not kept
	for(l=keep;l<toPath.length;l++){entering=toPath[l];entering.locals=toLocals[l];if(entering.self.onEnter){$injector.invoke(entering.self.onEnter,entering.self,entering.locals.globals);}}// Run it again, to catch any transitions in callbacks
	if($state.transition!==transition)return TransitionSuperseded;// Update globals in $state
	$state.$current=to;$state.current=to.self;$state.params=toParams;copy($state.params,$stateParams);$state.transition=null;if(options.location&&to.navigable){$urlRouter.push(to.navigable.url,to.navigable.locals.globals.$stateParams,{$$avoidResync:true,replace:options.location==='replace'});}if(options.notify){/**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeSuccess
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired once the state transition is **complete**.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         */$rootScope.$broadcast('$stateChangeSuccess',to.self,toParams,from.self,fromParams);}$urlRouter.update(true);return $state.current;},function(error){if($state.transition!==transition)return TransitionSuperseded;$state.transition=null;/**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeError
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when an **error occurs** during transition. It's important to note that if you
	         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
	         * they will not throw traditionally. You must listen for this $stateChangeError event to
	         * catch **ALL** errors.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         * @param {Error} error The resolve error object.
	         */evt=$rootScope.$broadcast('$stateChangeError',to.self,toParams,from.self,fromParams,error);if(!evt.defaultPrevented){$urlRouter.update();}return $q.reject(error);});return transition;};/**
	     * @ngdoc function
	     * @name ui.router.state.$state#is
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
	     * but only checks for the full state name. If params is supplied then it will be
	     * tested for strict equality against the current active params object, so all params
	     * must match with none missing and no extras.
	     *
	     * @example
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     * test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it is the state.
	     */$state.is=function is(stateOrName,params,options){options=extend({relative:$state.$current},options||{});var state=findState(stateOrName,options.relative);if(!isDefined(state)){return undefined;}if($state.$current!==state){return false;}return params?equalForKeys(state.params.$$values(params),$stateParams):true;};/**
	     * @ngdoc function
	     * @name ui.router.state.$state#includes
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * @example
	     * Partial and relative names
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     *
	     * // Using relative names (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
	     * </pre>
	     *
	     * Basic globbing patterns
	     * <pre>
	     * $state.$current.name = 'contacts.details.item.url';
	     *
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * </pre>
	     *
	     * @param {string} stateOrName A partial name, relative name, or glob pattern
	     * to be searched for within the current state name.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
	     * that you'd like to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
	     * .includes will test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */$state.includes=function includes(stateOrName,params,options){options=extend({relative:$state.$current},options||{});if(isString(stateOrName)&&isGlob(stateOrName)){if(!doesStateMatchGlob(stateOrName)){return false;}stateOrName=$state.$current.name;}var state=findState(stateOrName,options.relative);if(!isDefined(state)){return undefined;}if(!isDefined($state.$current.includes[state.name])){return false;}return params?equalForKeys(state.params.$$values(params),$stateParams,objectKeys(params)):true;};/**
	     * @ngdoc function
	     * @name ui.router.state.$state#href
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A url generation method that returns the compiled url for the given state populated with the given params.
	     *
	     * @example
	     * <pre>
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
	     * @param {object=} params An object of parameter values to fill the state's required parameters.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
	     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
	     *    ancestor with a valid url).
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     * 
	     * @returns {string} compiled state url
	     */$state.href=function href(stateOrName,params,options){options=extend({lossy:true,inherit:true,absolute:false,relative:$state.$current},options||{});var state=findState(stateOrName,options.relative);if(!isDefined(state))return null;if(options.inherit)params=inheritParams($stateParams,params||{},$state.$current,state);var nav=state&&options.lossy?state.navigable:state;if(!nav||nav.url===undefined||nav.url===null){return null;}return $urlRouter.href(nav.url,filterByKeys(state.params.$$keys().concat('#'),params||{}),{absolute:options.absolute});};/**
	     * @ngdoc function
	     * @name ui.router.state.$state#get
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Returns the state configuration object for any specific state or all states.
	     *
	     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
	     * the requested state. If not provided, returns an array of ALL state configs.
	     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
	     * @returns {Object|Array} State configuration object or array of all objects.
	     */$state.get=function(stateOrName,context){if(arguments.length===0)return map(objectKeys(states),function(name){return states[name].self;});var state=findState(stateOrName,context||$state.$current);return state&&state.self?state.self:null;};function resolveState(state,params,paramsAreFiltered,inherited,dst,options){// Make a restricted $stateParams with only the parameters that apply to this state if
	// necessary. In addition to being available to the controller and onEnter/onExit callbacks,
	// we also need $stateParams to be available for any $injector calls we make during the
	// dependency resolution process.
	var $stateParams=paramsAreFiltered?params:filterByKeys(state.params.$$keys(),params);var locals={$stateParams:$stateParams};// Resolve 'global' dependencies for the state, i.e. those not specific to a view.
	// We're also including $stateParams in this; that way the parameters are restricted
	// to the set that should be visible to the state, and are independent of when we update
	// the global $state and $stateParams values.
	dst.resolve=$resolve.resolve(state.resolve,locals,dst.resolve,state);var promises=[dst.resolve.then(function(globals){dst.globals=globals;})];if(inherited)promises.push(inherited);function resolveViews(){var viewsPromises=[];// Resolve template and dependencies for all views.
	forEach(state.views,function(view,name){var injectables=view.resolve&&view.resolve!==state.resolve?view.resolve:{};injectables.$template=[function(){return $view.load(name,{view:view,locals:dst.globals,params:$stateParams,notify:options.notify})||'';}];viewsPromises.push($resolve.resolve(injectables,dst.globals,dst.resolve,state).then(function(result){// References to the controller (only instantiated at link time)
	if(isFunction(view.controllerProvider)||isArray(view.controllerProvider)){var injectLocals=angular.extend({},injectables,dst.globals);result.$$controller=$injector.invoke(view.controllerProvider,null,injectLocals);}else{result.$$controller=view.controller;}// Provide access to the state itself for internal use
	result.$$state=state;result.$$controllerAs=view.controllerAs;dst[name]=result;}));});return $q.all(viewsPromises).then(function(){return dst.globals;});}// Wait for all the promises and then return the activation object
	return $q.all(promises).then(resolveViews).then(function(values){return dst;});}return $state;}function shouldSkipReload(to,toParams,from,fromParams,locals,options){// Return true if there are no differences in non-search (path/object) params, false if there are differences
	function nonSearchParamsEqual(fromAndToState,fromParams,toParams){// Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
	function notSearchParam(key){return fromAndToState.params[key].location!="search";}var nonQueryParamKeys=fromAndToState.params.$$keys().filter(notSearchParam);var nonQueryParams=pick.apply({},[fromAndToState.params].concat(nonQueryParamKeys));var nonQueryParamSet=new $$UMFP.ParamSet(nonQueryParams);return nonQueryParamSet.$$equals(fromParams,toParams);}// If reload was not explicitly requested
	// and we're transitioning to the same state we're already in
	// and    the locals didn't change
	//     or they changed in a way that doesn't merit reloading
	//        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
	// Then return true.
	if(!options.reload&&to===from&&(locals===from.locals||to.self.reloadOnSearch===false&&nonSearchParamsEqual(from,fromParams,toParams))){return true;}}}angular.module('ui.router.state').factory('$stateParams',function(){return{};}).provider('$state',$StateProvider);$ViewProvider.$inject=[];function $ViewProvider(){this.$get=$get;/**
	   * @ngdoc object
	   * @name ui.router.state.$view
	   *
	   * @requires ui.router.util.$templateFactory
	   * @requires $rootScope
	   *
	   * @description
	   *
	   */$get.$inject=['$rootScope','$templateFactory'];function $get($rootScope,$templateFactory){return{// $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
	/**
	       * @ngdoc function
	       * @name ui.router.state.$view#load
	       * @methodOf ui.router.state.$view
	       *
	       * @description
	       *
	       * @param {string} name name
	       * @param {object} options option object.
	       */load:function load(name,options){var result,defaults={template:null,controller:null,view:null,locals:null,notify:true,async:true,params:{}};options=extend(defaults,options);if(options.view){result=$templateFactory.fromConfig(options.view,options.params,options.locals);}return result;}};}}angular.module('ui.router.state').provider('$view',$ViewProvider);/**
	 * @ngdoc object
	 * @name ui.router.state.$uiViewScrollProvider
	 *
	 * @description
	 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
	 */function $ViewScrollProvider(){var useAnchorScroll=false;/**
	   * @ngdoc function
	   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
	   * @methodOf ui.router.state.$uiViewScrollProvider
	   *
	   * @description
	   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
	   * scrolling based on the url anchor.
	   */this.useAnchorScroll=function(){useAnchorScroll=true;};/**
	   * @ngdoc object
	   * @name ui.router.state.$uiViewScroll
	   *
	   * @requires $anchorScroll
	   * @requires $timeout
	   *
	   * @description
	   * When called with a jqLite element, it scrolls the element into view (after a
	   * `$timeout` so the DOM has time to refresh).
	   *
	   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
	   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
	   */this.$get=['$anchorScroll','$timeout',function($anchorScroll,$timeout){if(useAnchorScroll){return $anchorScroll;}return function($element){return $timeout(function(){$element[0].scrollIntoView();},0,false);};}];}angular.module('ui.router.state').provider('$uiViewScroll',$ViewScrollProvider);var ngMajorVer=angular.version.major;var ngMinorVer=angular.version.minor;/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-view
	 *
	 * @requires ui.router.state.$state
	 * @requires $compile
	 * @requires $controller
	 * @requires $injector
	 * @requires ui.router.state.$uiViewScroll
	 * @requires $document
	 *
	 * @restrict ECA
	 *
	 * @description
	 * The ui-view directive tells $state where to place your templates.
	 *
	 * @param {string=} name A view name. The name should be unique amongst the other views in the
	 * same state. You can have views of the same name that live in different states.
	 *
	 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
	 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
	 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
	 * scroll ui-view elements into view when they are populated during a state activation.
	 *
	 * @param {string=} noanimation If truthy, the non-animated renderer will be selected (no animations
	 * will be applied to the ui-view)
	 *
	 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
	 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
	 *
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 * 
	 * @example
	 * A view can be unnamed or named. 
	 * <pre>
	 * <!-- Unnamed -->
	 * <div ui-view></div> 
	 * 
	 * <!-- Named -->
	 * <div ui-view="viewName"></div>
	 * </pre>
	 *
	 * You can only have one unnamed view within any template (or root html). If you are only using a 
	 * single view and it is unnamed then you can populate it like so:
	 * <pre>
	 * <div ui-view></div> 
	 * $stateProvider.state("home", {
	 *   template: "<h1>HELLO!</h1>"
	 * })
	 * </pre>
	 * 
	 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#views `views`}
	 * config property, by name, in this case an empty name:
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 * 
	 * But typically you'll only use the views property if you name your view or have more than one view 
	 * in the same template. There's not really a compelling reason to name a view if its the only one, 
	 * but you could if you wanted, like so:
	 * <pre>
	 * <div ui-view="main"></div>
	 * </pre> 
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "main": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 * 
	 * Really though, you'll use views to set up multiple views:
	 * <pre>
	 * <div ui-view></div>
	 * <div ui-view="chart"></div> 
	 * <div ui-view="data"></div> 
	 * </pre>
	 * 
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     },
	 *     "chart": {
	 *       template: "<chart_thing/>"
	 *     },
	 *     "data": {
	 *       template: "<data_thing/>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Examples for `autoscroll`:
	 *
	 * <pre>
	 * <!-- If autoscroll present with no expression,
	 *      then scroll ui-view into view -->
	 * <ui-view autoscroll/>
	 *
	 * <!-- If autoscroll present with valid expression,
	 *      then scroll ui-view into view if expression evaluates to true -->
	 * <ui-view autoscroll='true'/>
	 * <ui-view autoscroll='false'/>
	 * <ui-view autoscroll='scopeVariable'/>
	 * </pre>
	 */$ViewDirective.$inject=['$state','$injector','$uiViewScroll','$interpolate'];function $ViewDirective($state,$injector,$uiViewScroll,$interpolate){function getService(){return $injector.has?function(service){return $injector.has(service)?$injector.get(service):null;}:function(service){try{return $injector.get(service);}catch(e){return null;}};}var service=getService(),$animator=service('$animator'),$animate=service('$animate');// Returns a set of DOM manipulation functions based on which Angular version
	// it should use
	function getRenderer(attrs,scope){var statics={enter:function enter(element,target,cb){target.after(element);cb();},leave:function leave(element,cb){element.remove();cb();}};if(!!attrs.noanimation)return statics;function animEnabled(element){if(ngMajorVer===1&&ngMinorVer>=4)return!!$animate.enabled(element);if(ngMajorVer===1&&ngMinorVer>=2)return!!$animate.enabled();return!!$animator;}// ng 1.2+
	if($animate){return{enter:function enter(element,target,cb){if(!animEnabled(element)){statics.enter(element,target,cb);}else if(angular.version.minor>2){$animate.enter(element,null,target).then(cb);}else{$animate.enter(element,null,target,cb);}},leave:function leave(element,cb){if(!animEnabled(element)){statics.leave(element,cb);}else if(angular.version.minor>2){$animate.leave(element).then(cb);}else{$animate.leave(element,cb);}}};}// ng 1.1.5
	if($animator){var animate=$animator&&$animator(scope,attrs);return{enter:function enter(element,target,cb){animate.enter(element,null,target);cb();},leave:function leave(element,cb){animate.leave(element);cb();}};}return statics;}var directive={restrict:'ECA',terminal:true,priority:400,transclude:'element',compile:function compile(tElement,tAttrs,$transclude){return function(scope,$element,attrs){var previousEl,currentEl,currentScope,latestLocals,onloadExp=attrs.onload||'',autoScrollExp=attrs.autoscroll,renderer=getRenderer(attrs,scope);scope.$on('$stateChangeSuccess',function(){updateView(false);});updateView(true);function cleanupLastView(){var _previousEl=previousEl;var _currentScope=currentScope;if(_currentScope){_currentScope._willBeDestroyed=true;}function cleanOld(){if(_previousEl){_previousEl.remove();}if(_currentScope){_currentScope.$destroy();}}if(currentEl){renderer.leave(currentEl,function(){cleanOld();previousEl=null;});previousEl=currentEl;}else{cleanOld();previousEl=null;}currentEl=null;currentScope=null;}function updateView(firstTime){var newScope,name=getUiViewName(scope,attrs,$element,$interpolate),previousLocals=name&&$state.$current&&$state.$current.locals[name];if(!firstTime&&previousLocals===latestLocals||scope._willBeDestroyed)return;// nothing to do
	newScope=scope.$new();latestLocals=$state.$current.locals[name];/**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoading
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           *
	           * Fired once the view **begins loading**, *before* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */newScope.$emit('$viewContentLoading',name);var clone=$transclude(newScope,function(clone){renderer.enter(clone,$element,function onUiViewEnter(){if(currentScope){currentScope.$emit('$viewContentAnimationEnded');}if(angular.isDefined(autoScrollExp)&&!autoScrollExp||scope.$eval(autoScrollExp)){$uiViewScroll(clone);}});cleanupLastView();});currentEl=clone;currentScope=newScope;/**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoaded
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           * Fired once the view is **loaded**, *after* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */currentScope.$emit('$viewContentLoaded',name);currentScope.$eval(onloadExp);}};}};return directive;}$ViewDirectiveFill.$inject=['$compile','$controller','$state','$interpolate'];function $ViewDirectiveFill($compile,$controller,$state,$interpolate){return{restrict:'ECA',priority:-400,compile:function compile(tElement){var initial=tElement.html();return function(scope,$element,attrs){var current=$state.$current,name=getUiViewName(scope,attrs,$element,$interpolate),locals=current&&current.locals[name];if(!locals){return;}$element.data('$uiView',{name:name,state:locals.$$state});$element.html(locals.$template?locals.$template:initial);var link=$compile($element.contents());if(locals.$$controller){locals.$scope=scope;locals.$element=$element;var controller=$controller(locals.$$controller,locals);if(locals.$$controllerAs){scope[locals.$$controllerAs]=controller;}$element.data('$ngControllerController',controller);$element.children().data('$ngControllerController',controller);}link(scope);};}};}/**
	 * Shared ui-view code for both directives:
	 * Given scope, element, and its attributes, return the view's name
	 */function getUiViewName(scope,attrs,element,$interpolate){var name=$interpolate(attrs.uiView||attrs.name||'')(scope);var inherited=element.inheritedData('$uiView');return name.indexOf('@')>=0?name:name+'@'+(inherited?inherited.state.name:'');}angular.module('ui.router.state').directive('uiView',$ViewDirective);angular.module('ui.router.state').directive('uiView',$ViewDirectiveFill);function parseStateRef(ref,current){var preparsed=ref.match(/^\s*({[^}]*})\s*$/),parsed;if(preparsed)ref=current+'('+preparsed[1]+')';parsed=ref.replace(/\n/g," ").match(/^([^(]+?)\s*(\((.*)\))?$/);if(!parsed||parsed.length!==4)throw new Error("Invalid state ref '"+ref+"'");return{state:parsed[1],paramExpr:parsed[3]||null};}function stateContext(el){var stateData=el.parent().inheritedData('$uiView');if(stateData&&stateData.state&&stateData.state.name){return stateData.state;}}function getTypeInfo(el){// SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	var isSvg=Object.prototype.toString.call(el.prop('href'))==='[object SVGAnimatedString]';var isForm=el[0].nodeName==="FORM";return{attr:isForm?"action":isSvg?'xlink:href':'href',isAnchor:el.prop("tagName").toUpperCase()==="A",clickable:!isForm};}function clickHook(el,$state,$timeout,type,current){return function(e){var button=e.which||e.button,target=current();if(!(button>1||e.ctrlKey||e.metaKey||e.shiftKey||el.attr('target'))){// HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	var transition=$timeout(function(){$state.go(target.state,target.params,target.options);});e.preventDefault();// if the state has no URL, ignore one preventDefault from the <a> directive.
	var ignorePreventDefaultCount=type.isAnchor&&!target.href?1:0;e.preventDefault=function(){if(ignorePreventDefaultCount--<=0)$timeout.cancel(transition);};}};}function defaultOpts(el,$state){return{relative:stateContext(el)||$state.$current,inherit:true};}/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref
	 *
	 * @requires ui.router.state.$state
	 * @requires $timeout
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
	 * URL, the directive will automatically generate & update the `href` attribute via
	 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
	 * the link will trigger a state transition with optional parameters.
	 *
	 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
	 * handled natively by the browser.
	 *
	 * You can also use relative state paths within ui-sref, just like the relative
	 * paths passed to `$state.go()`. You just need to be aware that the path is relative
	 * to the state that the link lives in, in other words the state that loaded the
	 * template containing the link.
	 *
	 * You can specify options to pass to {@link ui.router.state.$state#go $state.go()}
	 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
	 * and `reload`.
	 *
	 * @example
	 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
	 * following template:
	 * <pre>
	 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	 *     </li>
	 * </ul>
	 * </pre>
	 *
	 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
	 * <pre>
	 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	 *     </li>
	 * </ul>
	 *
	 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	 * </pre>
	 *
	 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#go $state.go()}
	 */$StateRefDirective.$inject=['$state','$timeout'];function $StateRefDirective($state,$timeout){return{restrict:'A',require:['?^uiSrefActive','?^uiSrefActiveEq'],link:function link(scope,element,attrs,uiSrefActive){var ref=parseStateRef(attrs.uiSref,$state.current.name);var def={state:ref.state,href:null,params:null};var type=getTypeInfo(element);var active=uiSrefActive[1]||uiSrefActive[0];def.options=extend(defaultOpts(element,$state),attrs.uiSrefOpts?scope.$eval(attrs.uiSrefOpts):{});var update=function update(val){if(val)def.params=angular.copy(val);def.href=$state.href(ref.state,def.params,def.options);if(active)active.$$addStateInfo(ref.state,def.params);if(def.href!==null)attrs.$set(type.attr,def.href);};if(ref.paramExpr){scope.$watch(ref.paramExpr,function(val){if(val!==def.params)update(val);},true);def.params=angular.copy(scope.$eval(ref.paramExpr));}update();if(!type.clickable)return;element.bind("click",clickHook(element,$state,$timeout,type,function(){return def;}));}};}/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-state
	 *
	 * @requires ui.router.state.uiSref
	 *
	 * @restrict A
	 *
	 * @description
	 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
	 * params and override options.
	 *
	 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#href $state.href()}
	 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#go $state.go()}
	 */$StateRefDynamicDirective.$inject=['$state','$timeout'];function $StateRefDynamicDirective($state,$timeout){return{restrict:'A',require:['?^uiSrefActive','?^uiSrefActiveEq'],link:function link(scope,element,attrs,uiSrefActive){var type=getTypeInfo(element);var active=uiSrefActive[1]||uiSrefActive[0];var group=[attrs.uiState,attrs.uiStateParams||null,attrs.uiStateOpts||null];var watch='['+group.map(function(val){return val||'null';}).join(', ')+']';var def={state:null,params:null,options:null,href:null};function runStateRefLink(group){def.state=group[0];def.params=group[1];def.options=group[2];def.href=$state.href(def.state,def.params,def.options);if(active)active.$$addStateInfo(def.state,def.params);if(def.href)attrs.$set(type.attr,def.href);}scope.$watch(watch,runStateRefLink,true);runStateRefLink(scope.$eval(watch));if(!type.clickable)return;element.bind("click",clickHook(element,$state,$timeout,type,function(){return def;}));}};}/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive working alongside ui-sref to add classes to an element when the
	 * related ui-sref directive's state is active, and removing them when it is inactive.
	 * The primary use-case is to simplify the special appearance of navigation menus
	 * relying on `ui-sref`, by having the "active" state's menu button appear different,
	 * distinguishing it from the inactive menu items.
	 *
	 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
	 * ui-sref-active found at the same level or above the ui-sref will be used.
	 *
	 * Will activate when the ui-sref's target state or any child state is active. If you
	 * need to activate only when the ui-sref target state is active and *not* any of
	 * it's children, then you will use
	 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
	 *
	 * @example
	 * Given the following template:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item">
	 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 *
	 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
	 * the resulting HTML will appear as (note the 'active' class):
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item active">
	 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * The class name is interpolated **once** during the directives link time (any further changes to the
	 * interpolated value are ignored).
	 *
	 * Multiple classes may be specified in a space-separated format:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active='class1 class2 class3'>
	 *     <a ui-sref="app.user">link</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * It is also possible to pass ui-sref-active an expression that evaluates
	 * to an object hash, whose keys represent active class names and whose
	 * values represent the respective state names/globs.
	 * ui-sref-active will match if the current active state **includes** any of
	 * the specified state names/globs, even the abstract ones.
	 *
	 * @Example
	 * Given the following template, with "admin" being an abstract state:
	 * <pre>
	 * <div ui-sref-active="{'active': 'admin.*'}">
	 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	 * </div>
	 * </pre>
	 *
	 * When the current state is "admin.roles" the "active" class will be applied
	 * to both the <div> and <a> elements. It is important to note that the state
	 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
	 *//**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active-eq
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
	 * when the exact target state used in the `ui-sref` is active; no child states.
	 *
	 */$StateRefActiveDirective.$inject=['$state','$stateParams','$interpolate'];function $StateRefActiveDirective($state,$stateParams,$interpolate){return{restrict:"A",controller:['$scope','$element','$attrs','$timeout',function($scope,$element,$attrs,$timeout){var states=[],activeClasses={},activeEqClass,uiSrefActive;// There probably isn't much point in $observing this
	// uiSrefActive and uiSrefActiveEq share the same directive object with some
	// slight difference in logic routing
	activeEqClass=$interpolate($attrs.uiSrefActiveEq||'',false)($scope);try{uiSrefActive=$scope.$eval($attrs.uiSrefActive);}catch(e){// Do nothing. uiSrefActive is not a valid expression.
	// Fall back to using $interpolate below
	}uiSrefActive=uiSrefActive||$interpolate($attrs.uiSrefActive||'',false)($scope);if(isObject(uiSrefActive)){forEach(uiSrefActive,function(stateOrName,activeClass){if(isString(stateOrName)){var ref=parseStateRef(stateOrName,$state.current.name);addState(ref.state,$scope.$eval(ref.paramExpr),activeClass);}});}// Allow uiSref to communicate with uiSrefActive[Equals]
	this.$$addStateInfo=function(newState,newParams){// we already got an explicit state provided by ui-sref-active, so we
	// shadow the one that comes from ui-sref
	if(isObject(uiSrefActive)&&states.length>0){return;}addState(newState,newParams,uiSrefActive);update();};$scope.$on('$stateChangeSuccess',update);function addState(stateName,stateParams,activeClass){var state=$state.get(stateName,stateContext($element));var stateHash=createStateHash(stateName,stateParams);states.push({state:state||{name:stateName},params:stateParams,hash:stateHash});activeClasses[stateHash]=activeClass;}/**
	       * @param {string} state
	       * @param {Object|string} [params]
	       * @return {string}
	       */function createStateHash(state,params){if(!isString(state)){throw new Error('state should be a string');}if(isObject(params)){return state+toJson(params);}params=$scope.$eval(params);if(isObject(params)){return state+toJson(params);}return state;}// Update route state
	function update(){for(var i=0;i<states.length;i++){if(anyMatch(states[i].state,states[i].params)){addClass($element,activeClasses[states[i].hash]);}else{removeClass($element,activeClasses[states[i].hash]);}if(exactMatch(states[i].state,states[i].params)){addClass($element,activeEqClass);}else{removeClass($element,activeEqClass);}}}function addClass(el,className){$timeout(function(){el.addClass(className);});}function removeClass(el,className){el.removeClass(className);}function anyMatch(state,params){return $state.includes(state.name,params);}function exactMatch(state,params){return $state.is(state.name,params);}update();}]};}angular.module('ui.router.state').directive('uiSref',$StateRefDirective).directive('uiSrefActive',$StateRefActiveDirective).directive('uiSrefActiveEq',$StateRefActiveDirective).directive('uiState',$StateRefDynamicDirective);/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:isState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
	 */$IsStateFilter.$inject=['$state'];function $IsStateFilter($state){var isFilter=function isFilter(state,params){return $state.is(state,params);};isFilter.$stateful=true;return isFilter;}/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:includedByState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
	 */$IncludedByStateFilter.$inject=['$state'];function $IncludedByStateFilter($state){var includesFilter=function includesFilter(state,params,options){return $state.includes(state,params,options);};includesFilter.$stateful=true;return includesFilter;}angular.module('ui.router.state').filter('isState',$IsStateFilter).filter('includedByState',$IncludedByStateFilter);})(window,window.angular);

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	("function" === "function" && __webpack_require__(26) && function (m) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (m), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} || ( false ? "undefined" : _typeof(module)) === "object" && function (m) {
	    module.exports = m();
	} || // Node
	function (m) {
	    this.samsam = m();
	} // Browser globals
	)(function () {
	    var o = Object.prototype;
	    var div = typeof document !== "undefined" && document.createElement("div");
	
	    function isNaN(value) {
	        // Unlike global isNaN, this avoids type coercion
	        // typeof check avoids IE host object issues, hat tip to
	        // lodash
	        var val = value; // JsLint thinks value !== value is "weird"
	        return typeof value === "number" && value !== val;
	    }
	
	    function getClass(value) {
	        // Returns the internal [[Class]] by calling Object.prototype.toString
	        // with the provided value as this. Return value is a string, naming the
	        // internal class, e.g. "Array"
	        return o.toString.call(value).split(/[ \]]/)[1];
	    }
	
	    /**
	     * @name samsam.isArguments
	     * @param Object object
	     *
	     * Returns ``true`` if ``object`` is an ``arguments`` object,
	     * ``false`` otherwise.
	     */
	    function isArguments(object) {
	        if (getClass(object) === 'Arguments') {
	            return true;
	        }
	        if ((typeof object === "undefined" ? "undefined" : _typeof(object)) !== "object" || typeof object.length !== "number" || getClass(object) === "Array") {
	            return false;
	        }
	        if (typeof object.callee == "function") {
	            return true;
	        }
	        try {
	            object[object.length] = 6;
	            delete object[object.length];
	        } catch (e) {
	            return true;
	        }
	        return false;
	    }
	
	    /**
	     * @name samsam.isElement
	     * @param Object object
	     *
	     * Returns ``true`` if ``object`` is a DOM element node. Unlike
	     * Underscore.js/lodash, this function will return ``false`` if ``object``
	     * is an *element-like* object, i.e. a regular object with a ``nodeType``
	     * property that holds the value ``1``.
	     */
	    function isElement(object) {
	        if (!object || object.nodeType !== 1 || !div) {
	            return false;
	        }
	        try {
	            object.appendChild(div);
	            object.removeChild(div);
	        } catch (e) {
	            return false;
	        }
	        return true;
	    }
	
	    /**
	     * @name samsam.keys
	     * @param Object object
	     *
	     * Return an array of own property names.
	     */
	    function keys(object) {
	        var ks = [],
	            prop;
	        for (prop in object) {
	            if (o.hasOwnProperty.call(object, prop)) {
	                ks.push(prop);
	            }
	        }
	        return ks;
	    }
	
	    /**
	     * @name samsam.isDate
	     * @param Object value
	     *
	     * Returns true if the object is a ``Date``, or *date-like*. Duck typing
	     * of date objects work by checking that the object has a ``getTime``
	     * function whose return value equals the return value from the object's
	     * ``valueOf``.
	     */
	    function isDate(value) {
	        return typeof value.getTime == "function" && value.getTime() == value.valueOf();
	    }
	
	    /**
	     * @name samsam.isNegZero
	     * @param Object value
	     *
	     * Returns ``true`` if ``value`` is ``-0``.
	     */
	    function isNegZero(value) {
	        return value === 0 && 1 / value === -Infinity;
	    }
	
	    /**
	     * @name samsam.equal
	     * @param Object obj1
	     * @param Object obj2
	     *
	     * Returns ``true`` if two objects are strictly equal. Compared to
	     * ``===`` there are two exceptions:
	     *
	     *   - NaN is considered equal to NaN
	     *   - -0 and +0 are not considered equal
	     */
	    function identical(obj1, obj2) {
	        if (obj1 === obj2 || isNaN(obj1) && isNaN(obj2)) {
	            return obj1 !== 0 || isNegZero(obj1) === isNegZero(obj2);
	        }
	    }
	
	    /**
	     * @name samsam.deepEqual
	     * @param Object obj1
	     * @param Object obj2
	     *
	     * Deep equal comparison. Two values are "deep equal" if:
	     *
	     *   - They are equal, according to samsam.identical
	     *   - They are both date objects representing the same time
	     *   - They are both arrays containing elements that are all deepEqual
	     *   - They are objects with the same set of properties, and each property
	     *     in ``obj1`` is deepEqual to the corresponding property in ``obj2``
	     *
	     * Supports cyclic objects.
	     */
	    function deepEqualCyclic(obj1, obj2) {
	
	        // used for cyclic comparison
	        // contain already visited objects
	        var objects1 = [],
	            objects2 = [],
	
	        // contain pathes (position in the object structure)
	        // of the already visited objects
	        // indexes same as in objects arrays
	        paths1 = [],
	            paths2 = [],
	
	        // contains combinations of already compared objects
	        // in the manner: { "$1['ref']$2['ref']": true }
	        compared = {};
	
	        /**
	         * used to check, if the value of a property is an object
	         * (cyclic logic is only needed for objects)
	         * only needed for cyclic logic
	         */
	        function isObject(value) {
	
	            if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && value !== null && !(value instanceof Boolean) && !(value instanceof Date) && !(value instanceof Number) && !(value instanceof RegExp) && !(value instanceof String)) {
	
	                return true;
	            }
	
	            return false;
	        }
	
	        /**
	         * returns the index of the given object in the
	         * given objects array, -1 if not contained
	         * only needed for cyclic logic
	         */
	        function getIndex(objects, obj) {
	
	            var i;
	            for (i = 0; i < objects.length; i++) {
	                if (objects[i] === obj) {
	                    return i;
	                }
	            }
	
	            return -1;
	        }
	
	        // does the recursion for the deep equal check
	        return function deepEqual(obj1, obj2, path1, path2) {
	            var type1 = typeof obj1 === "undefined" ? "undefined" : _typeof(obj1);
	            var type2 = typeof obj2 === "undefined" ? "undefined" : _typeof(obj2);
	
	            // == null also matches undefined
	            if (obj1 === obj2 || isNaN(obj1) || isNaN(obj2) || obj1 == null || obj2 == null || type1 !== "object" || type2 !== "object") {
	
	                return identical(obj1, obj2);
	            }
	
	            // Elements are only equal if identical(expected, actual)
	            if (isElement(obj1) || isElement(obj2)) {
	                return false;
	            }
	
	            var isDate1 = isDate(obj1),
	                isDate2 = isDate(obj2);
	            if (isDate1 || isDate2) {
	                if (!isDate1 || !isDate2 || obj1.getTime() !== obj2.getTime()) {
	                    return false;
	                }
	            }
	
	            if (obj1 instanceof RegExp && obj2 instanceof RegExp) {
	                if (obj1.toString() !== obj2.toString()) {
	                    return false;
	                }
	            }
	
	            var class1 = getClass(obj1);
	            var class2 = getClass(obj2);
	            var keys1 = keys(obj1);
	            var keys2 = keys(obj2);
	
	            if (isArguments(obj1) || isArguments(obj2)) {
	                if (obj1.length !== obj2.length) {
	                    return false;
	                }
	            } else {
	                if (type1 !== type2 || class1 !== class2 || keys1.length !== keys2.length) {
	                    return false;
	                }
	            }
	
	            var key, i, l,
	            // following vars are used for the cyclic logic
	            value1, value2, isObject1, isObject2, index1, index2, newPath1, newPath2;
	
	            for (i = 0, l = keys1.length; i < l; i++) {
	                key = keys1[i];
	                if (!o.hasOwnProperty.call(obj2, key)) {
	                    return false;
	                }
	
	                // Start of the cyclic logic
	
	                value1 = obj1[key];
	                value2 = obj2[key];
	
	                isObject1 = isObject(value1);
	                isObject2 = isObject(value2);
	
	                // determine, if the objects were already visited
	                // (it's faster to check for isObject first, than to
	                // get -1 from getIndex for non objects)
	                index1 = isObject1 ? getIndex(objects1, value1) : -1;
	                index2 = isObject2 ? getIndex(objects2, value2) : -1;
	
	                // determine the new pathes of the objects
	                // - for non cyclic objects the current path will be extended
	                //   by current property name
	                // - for cyclic objects the stored path is taken
	                newPath1 = index1 !== -1 ? paths1[index1] : path1 + '[' + JSON.stringify(key) + ']';
	                newPath2 = index2 !== -1 ? paths2[index2] : path2 + '[' + JSON.stringify(key) + ']';
	
	                // stop recursion if current objects are already compared
	                if (compared[newPath1 + newPath2]) {
	                    return true;
	                }
	
	                // remember the current objects and their pathes
	                if (index1 === -1 && isObject1) {
	                    objects1.push(value1);
	                    paths1.push(newPath1);
	                }
	                if (index2 === -1 && isObject2) {
	                    objects2.push(value2);
	                    paths2.push(newPath2);
	                }
	
	                // remember that the current objects are already compared
	                if (isObject1 && isObject2) {
	                    compared[newPath1 + newPath2] = true;
	                }
	
	                // End of cyclic logic
	
	                // neither value1 nor value2 is a cycle
	                // continue with next level
	                if (!deepEqual(value1, value2, newPath1, newPath2)) {
	                    return false;
	                }
	            }
	
	            return true;
	        }(obj1, obj2, '$1', '$2');
	    }
	
	    var match;
	
	    function arrayContains(array, subset) {
	        if (subset.length === 0) {
	            return true;
	        }
	        var i, l, j, k;
	        for (i = 0, l = array.length; i < l; ++i) {
	            if (match(array[i], subset[0])) {
	                for (j = 0, k = subset.length; j < k; ++j) {
	                    if (!match(array[i + j], subset[j])) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	        }
	        return false;
	    }
	
	    /**
	     * @name samsam.match
	     * @param Object object
	     * @param Object matcher
	     *
	     * Compare arbitrary value ``object`` with matcher.
	     */
	    match = function match(object, matcher) {
	        if (matcher && typeof matcher.test === "function") {
	            return matcher.test(object);
	        }
	
	        if (typeof matcher === "function") {
	            return matcher(object) === true;
	        }
	
	        if (typeof matcher === "string") {
	            matcher = matcher.toLowerCase();
	            var notNull = typeof object === "string" || !!object;
	            return notNull && String(object).toLowerCase().indexOf(matcher) >= 0;
	        }
	
	        if (typeof matcher === "number") {
	            return matcher === object;
	        }
	
	        if (typeof matcher === "boolean") {
	            return matcher === object;
	        }
	
	        if (typeof matcher === "undefined") {
	            return typeof object === "undefined";
	        }
	
	        if (matcher === null) {
	            return object === null;
	        }
	
	        if (getClass(object) === "Array" && getClass(matcher) === "Array") {
	            return arrayContains(object, matcher);
	        }
	
	        if (matcher && (typeof matcher === "undefined" ? "undefined" : _typeof(matcher)) === "object") {
	            if (matcher === object) {
	                return true;
	            }
	            var prop;
	            for (prop in matcher) {
	                var value = object[prop];
	                if (typeof value === "undefined" && typeof object.getAttribute === "function") {
	                    value = object.getAttribute(prop);
	                }
	                if (matcher[prop] === null || typeof matcher[prop] === 'undefined') {
	                    if (value !== matcher[prop]) {
	                        return false;
	                    }
	                } else if (typeof value === "undefined" || !match(value, matcher[prop])) {
	                    return false;
	                }
	            }
	            return true;
	        }
	
	        throw new Error("Matcher was not a string, a number, a " + "function, a boolean or an object");
	    };
	
	    return {
	        isArguments: isArguments,
	        isElement: isElement,
	        isDate: isDate,
	        isNegZero: isNegZero,
	        identical: identical,
	        deepEqual: deepEqualCyclic,
	        match: match,
	        keys: keys
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : afrikaans (af)
	//! author : Werner Mollentze : https://github.com/wernerm
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function isPM(input) {
	            return (/^nm$/i.test(input)
	            );
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: '\'n paar sekondes',
	            m: '\'n minuut',
	            mm: '%d minute',
	            h: '\'n uur',
	            hh: '%d ure',
	            d: '\'n dag',
	            dd: '%d dae',
	            M: '\'n maand',
	            MM: '%d maande',
	            y: '\'n jaar',
	            yy: '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function ordinal(number) {
	            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4 // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	});

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Moroccan Arabic (ar-ma)
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ar_ma = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ma;
	});

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Arabic Saudi Arabia (ar-sa)
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    },
	        numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var ar_sa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM: function isPM(input) {
	            return 'م' === input;
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_sa;
	});

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale  : Tunisian Arabic (ar-tn)
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ar_tn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ar_tn;
	});

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! Locale: Arabic (ar)
	//! Author: Abdel Said: https://github.com/abdelsaid
	//! Changes in months, weekdays: Ahmed Elkhatib
	//! Native plural forms: forabi https://github.com/forabi
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    },
	        numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	        pluralForm = function pluralForm(n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    },
	        plurals = {
	        s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    },
	        pluralize = function pluralize(u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    },
	        months = ['كانون الثاني يناير', 'شباط فبراير', 'آذار مارس', 'نيسان أبريل', 'أيار مايو', 'حزيران يونيو', 'تموز يوليو', 'آب أغسطس', 'أيلول سبتمبر', 'تشرين الأول أكتوبر', 'تشرين الثاني نوفمبر', 'كانون الأول ديسمبر'];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM: function isPM(input) {
	            return 'م' === input;
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y')
	        },
	        preparse: function preparse(string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	});

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : azerbaijani (az)
	//! author : topchiyev : https://github.com/topchiyev
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'birneçə saniyyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function isPM(input) {
	            return (/^(gündüz|axşam)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function ordinal(number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	});

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : belarusian (be)
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_'),
	            'accusative': 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_')
	        },
	            nounCase = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/.test(format) ? 'accusative' : 'nominative';
	        return months[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            'accusative': 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_')
	        },
	            nounCase = /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/.test(format) ? 'accusative' : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var be = moment.defineLocale('be', {
	        months: monthsCaseReplace,
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function nextWeek() {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function isPM(input) {
	            return (/^(дня|вечара)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        ordinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	});

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : bulgarian (bg)
	//! author : Krasen Borisov : https://github.com/kraz
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort: 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дни',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function ordinal(number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	});

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Bengali (bn)
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	        numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort: 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রুবার_শনিবার'.split('_'),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্রু_শনি'.split('_'),
	        weekdaysMin: 'রব_সম_মঙ্গ_বু_ব্রিহ_শু_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কএক সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকেল|রাত/,
	        isPM: function isPM(input) {
	            return (/^(দুপুর|বিকেল|রাত)$/.test(input)
	            );
	        },
	        //Bengali is a vast language its spoken
	        //in different forms in various parts of the world.
	        //I have just generalized with most common one used
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকেল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	});

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : tibetan (bo)
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	        numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        isPM: function isPM(input) {
	            return (/^(ཉིན་གུང|དགོང་དག|མཚན་མོ)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	});

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : breton (br)
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort: 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h[e]mm A',
	            LTS: 'h[e]mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL: 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warc\'hoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Dec\'h da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s \'zo',
	            s: 'un nebeud segondennoù',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears
	        },
	        ordinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function ordinal(number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	});

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : bosnian (bs)
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	});

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : catalan (ca)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ca = moment.defineLocale('ca', {
	        months: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        monthsShort: 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'LT:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd D MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: function sameDay() {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function nextDay() {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function nextWeek() {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function lastDay() {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function lastWeek() {
	                return '[el] dddd [passat a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'fa %s',
	            s: 'uns segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys'
	        },
	        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function ordinal(number, period) {
	            var output = number === 1 ? 'r' : number === 2 ? 'n' : number === 3 ? 'r' : number === 4 ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	});

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : czech (cs)
	//! author : petrbela : https://github.com/petrbela
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'm':
	                // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm':
	                // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':
	                // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh':
	                // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':
	                // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd':
	                // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':
	                // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM':
	                // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':
	                // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy':
	                // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParse: function (months, monthsShort) {
	            var i,
	                _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort),
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	});

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : chuvash (cv)
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: function future(output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул'
	        },
	        ordinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	});

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Welsh (cy)
	//! author : Robert Allen
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function ordinal(number) {
	            var b = number,
	                output = '',
	                lookup = ['', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	            'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	});

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : danish (da)
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[I dag kl.] LT',
	            nextDay: '[I morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[I går kl.] LT',
	            lastWeek: '[sidste] dddd [kl] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	});

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : austrian german (de-at)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de_at = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[Morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[Gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de_at;
	});

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : german (de)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[Morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[Gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	});

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : modern greek (el)
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months: function months(momentToFormat, format) {
	            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function isPM(input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        calendar: function calendar(key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (typeof output === 'function') {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια'
	        },
	        ordinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	});

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : australian english (en-au)
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var en_au = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_au;
	});

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : canadian english (en-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var en_ca = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM, YYYY',
	            LLL: 'D MMMM, YYYY h:mm A',
	            LLLL: 'dddd, D MMMM, YYYY h:mm A'
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return en_ca;
	});

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : great britain english (en-gb)
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var en_gb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_gb;
	});

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : esperanto (eo)
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays: 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	        weekdaysShort: 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	        weekdaysMin: 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D[-an de] MMMM, YYYY',
	            LLL: 'D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function isPM(input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd [je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasinta] dddd [je] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'je %s',
	            past: 'antaŭ %s',
	            s: 'sekundoj',
	            m: 'minuto',
	            mm: '%d minutoj',
	            h: 'horo',
	            hh: '%d horoj',
	            d: 'tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'monato',
	            MM: '%d monatoj',
	            y: 'jaro',
	            yy: '%d jaroj'
	        },
	        ordinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	});

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : spanish (es)
	//! author : Julio Napurí : https://github.com/julionc
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var monthsShortDot = 'Ene._Feb._Mar._Abr._May._Jun._Jul._Ago._Sep._Oct._Nov._Dic.'.split('_'),
	        _monthsShort = 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_');
	
	    var es = moment.defineLocale('es', {
	        months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
	        monthsShort: function monthsShort(m, format) {
	            if (/-MMM-/.test(format)) {
	                return _monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        weekdays: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
	        weekdaysShort: 'Dom._Lun._Mar._Mié._Jue._Vie._Sáb.'.split('_'),
	        weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar: {
	            sameDay: function sameDay() {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function nextDay() {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function nextWeek() {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function lastDay() {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function lastWeek() {
	                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	});

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : estonian (et)
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm': ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h': ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd': ['ühe päeva', 'üks päev'],
	            'M': ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y': ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	});

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : euskara (eu)
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	});

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Persian (fa)
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    },
	        numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays: '\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647'.split('_'),
	        weekdaysShort: '\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function isPM(input) {
	            return (/بعد از ظهر/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چندین ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        ordinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	});

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : finnish (fi)
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = ['nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden', numbersPast[7], numbersPast[8], numbersPast[9]];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? isFuture ? numbersFuture[number] : numbersPast[number] : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	});

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : faroese (fo)
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            m: 'ein minutt',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaði',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	});

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : canadian french (fr-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var fr_ca = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal: function ordinal(number) {
	            return number + (number === 1 ? 'er' : 'e');
	        }
	    });
	
	    return fr_ca;
	});

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : french (fr)
	//! author : John Fischer : https://github.com/jfroffice
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal: function ordinal(number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	});

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : frisian (fy)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort: function monthsShort(m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function ordinal(number) {
	            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	});

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : galician (gl)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var gl = moment.defineLocale('gl', {
	        months: 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
	        monthsShort: 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
	        weekdays: 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
	        weekdaysShort: 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
	        weekdaysMin: 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd D MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: function sameDay() {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function nextDay() {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function nextWeek() {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function lastDay() {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function lastWeek() {
	                return '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: function future(str) {
	                if (str === 'uns segundos') {
	                    return 'nuns segundos';
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gl;
	});

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Hebrew (he)
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function hh(number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function dd(number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function MM(number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function yy(number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        }
	    });
	
	    return he;
	});

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : hindi (hi)
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	        numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	});

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : hrvatski (hr)
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_'),
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	});

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : hungarian (hu)
	//! author : Adam Brunner : https://github.com/adambrunner
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix ? 'néhány másodperc' : 'néhány másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort: 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function isPM(input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function nextWeek() {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function lastWeek() {
	                return week.call(this, false);
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hu;
	});

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Armenian (hy-am)
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_'),
	            'accusative': 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_')
	        },
	            nounCase = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/.test(format) ? 'accusative' : 'nominative';
	        return months[nounCase][m.month()];
	    }
	    function monthsShortCaseReplace(m, format) {
	        var monthsShort = 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_');
	        return monthsShort[m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_');
	        return weekdays[m.day()];
	    }
	
	    var hy_am = moment.defineLocale('hy-am', {
	        months: monthsCaseReplace,
	        monthsShort: monthsShortCaseReplace,
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function nextWeek() {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function lastWeek() {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function isPM(input) {
	            return (/^(ցերեկվա|երեկոյան)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hy_am;
	});

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Bahasa Indonesia (id)
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	});

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : icelandic (is)
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	});

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : italian (it)
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	        weekdaysShort: 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	        weekdaysMin: 'D_L_Ma_Me_G_V_S'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: function future(s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: 'un\'ora',
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	});

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : japanese (ja)
	//! author : LI Long : https://github.com/baryon
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ja = moment.defineLocale('ja', {
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'Ah時m分',
	            LTS: 'Ah時m分s秒',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah時m分',
	            LLLL: 'YYYY年M月D日Ah時m分 dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function isPM(input) {
	            return input === '午後';
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: '[来週]dddd LT',
	            lastDay: '[昨日] LT',
	            lastWeek: '[前週]dddd LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年'
	        }
	    });
	
	    return ja;
	});

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Boso Jowo (jv)
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	});

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Georgian (ka)
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            'accusative': 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	            nounCase = /D[oD] *MMMM?/.test(format) ? 'accusative' : 'nominative';
	        return months[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            'accusative': 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_')
	        },
	            nounCase = /(წინა|შემდეგ)/.test(format) ? 'accusative' : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var ka = moment.defineLocale('ka', {
	        months: monthsCaseReplace,
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: function future(s) {
	                return (/(წამი|წუთი|საათი|წელი)/.test(s) ? s.replace(/ი$/, 'ში') : s + 'ში'
	                );
	            },
	            past: function past(s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s: 'რამდენიმე წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი'
	        },
	        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function ordinal(number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (number < 20 || number <= 100 && number % 20 === 0 || number % 100 === 0) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7
	        }
	    });
	
	    return ka;
	});

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : khmer (km)
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនៈ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	});

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : korean (ko)
	//!
	//! authors
	//!
	//! - Kyungwook, Park : https://github.com/kyungw00k
	//! - Jeeeyul Lee <jeeeyul@gmail.com>
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h시 m분',
	            LTS: 'A h시 m분 s초',
	            L: 'YYYY.MM.DD',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h시 m분',
	            LLLL: 'YYYY년 MMMM D일 dddd A h시 m분'
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇초',
	            ss: '%d초',
	            m: '일분',
	            mm: '%d분',
	            h: '한시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한달',
	            MM: '%d달',
	            y: '일년',
	            yy: '%d년'
	        },
	        ordinalParse: /\d{1,2}일/,
	        ordinal: '%d일',
	        meridiemParse: /오전|오후/,
	        isPM: function isPM(token) {
	            return token === '오후';
	        },
	        meridiem: function meridiem(hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	});

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Luxembourgish (lb)
	//! author : mweimerskirch : https://github.com/mweimerskirch, David Raison : https://github.com/kwisatz
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function lastWeek() {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	});

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Lithuanian (lt)
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var units = {
	        'm': 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h': 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd': 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M': 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y': 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    },
	        weekDays = 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_');
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            'accusative': 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_')
	        },
	            nounCase = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/.test(format) ? 'accusative' : 'nominative';
	        return months[nounCase][m.month()];
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || number > 10 && number < 20;
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    function relativeWeekDay(moment, format) {
	        var nominative = format.indexOf('dddd HH:mm') === -1,
	            weekDay = weekDays[moment.day()];
	        return nominative ? weekDay : weekDay.substring(0, weekDay.length - 2) + 'į';
	    }
	
	    var lt = moment.defineLocale('lt', {
	        months: monthsCaseReplace,
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: relativeWeekDay,
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}-oji/,
	        ordinal: function ordinal(number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	});

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : latvian (lv)
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	});

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Montenegrin (me)
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
	            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
	        },
	        translate: function translate(number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
	        monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
	        weekdays: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota'],
	        weekdaysShort: ['ned.', 'pon.', 'uto.', 'sri.', 'čet.', 'pet.', 'sub.'],
	        weekdaysMin: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function lastWeek() {
	                var lastWeekDays = ['[prošle] [nedjelje] [u] LT', '[prošlog] [ponedjeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srijede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	});

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : macedonian (mk)
	//! author : Borislav Mickov : https://github.com/B0k0
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: 'dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Во изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Во изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'после %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            M: 'месец',
	            MM: '%d месеци',
	            y: 'година',
	            yy: '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function ordinal(number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	});

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : malayalam (ml)
	//! author : Floyd Pink : https://github.com/floydpink
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        isPM: function isPM(input) {
	            return (/^(ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	});

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Marathi (mr)
	//! author : Harshad Kale : https://github.com/kalehv
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	        numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s नंतर',
	            past: '%s पूर्वी',
	            s: 'सेकंद',
	            m: 'एक मिनिट',
	            mm: '%d मिनिटे',
	            h: 'एक तास',
	            hh: '%d तास',
	            d: 'एक दिवस',
	            dd: '%d दिवस',
	            M: 'एक महिना',
	            MM: '%d महिने',
	            y: 'एक वर्ष',
	            yy: '%d वर्षे'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	});

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ms_my = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms_my;
	});

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	});

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Burmese (my)
	//! author : Squar team, mysquar.com
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    },
	        numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	});

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : norwegian bokmål (nb)
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tirs_ons_tors_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'H.mm',
	            LTS: 'H.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H.mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] H.mm'
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'for %s siden',
	            s: 'noen sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	});

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : nepali/nepalese
	//! author : suvash : https://github.com/suvash
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	        numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आइ._सो._मङ्_बु._बि._शु._श.'.split('_'),
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राती|बिहान|दिउँसो|बेलुका|साँझ|राती/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 3 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'बेलुका' || meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राती';
	            } else if (hour < 10) {
	                return 'बिहान';
	            } else if (hour < 15) {
	                return 'दिउँसो';
	            } else if (hour < 18) {
	                return 'बेलुका';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राती';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोली] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडी',
	            s: 'केही समय',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	});

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : dutch (nl)
	//! author : Joris Röling : https://github.com/jjupiter
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort: function monthsShort(m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function ordinal(number) {
	            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	});

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : norwegian nynorsk (nn)
	//! author : https://github.com/mechuwind
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'for %s sidan',
	            s: 'nokre sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	});

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : polish (pl)
	//! author : Rafal Hirsz : https://github.com/evoL
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function months(momentToFormat, format) {
	            if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
	        weekdaysMin: 'N_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	});

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : brazilian portuguese (pt-br)
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var pt_br = moment.defineLocale('pt-br', {
	        months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function lastWeek() {
	                return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: '%s atrás',
	            s: 'poucos segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal: '%dº'
	    });
	
	    return pt_br;
	});

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : portuguese (pt)
	//! author : Jefferson : https://github.com/jalex79
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var pt = moment.defineLocale('pt', {
	        months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function lastWeek() {
	                return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	});

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : romanian (ro)
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	            separator = ' ';
	        if (number % 100 >= 20 || number >= 100 && number % 100 === 0) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort: 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	});

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : russian (ru)
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	            'accusative': 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_')
	        },
	            nounCase = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/.test(format) ? 'accusative' : 'nominative';
	        return months[nounCase][m.month()];
	    }
	    function monthsShortCaseReplace(m, format) {
	        var monthsShort = {
	            'nominative': 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	            'accusative': 'янв_фев_мар_апр_мая_июня_июля_авг_сен_окт_ноя_дек'.split('_')
	        },
	            nounCase = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/.test(format) ? 'accusative' : 'nominative';
	        return monthsShort[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            'accusative': 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_')
	        },
	            nounCase = /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/.test(format) ? 'accusative' : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var ru = moment.defineLocale('ru', {
	        months: monthsCaseReplace,
	        monthsShort: monthsShortCaseReplace,
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[й|я]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i],
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar: {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function nextWeek() {
	                return this.day() === 2 ? '[Во] dddd [в] LT' : '[В] dddd [в] LT';
	            },
	            lastWeek: function lastWeek(now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function isPM(input) {
	            return (/^(дня|вечера)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ru;
	});

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Sinhalese (si)
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d'
	        },
	        ordinalParse: /\d{1,2} වැනි/,
	        ordinal: function ordinal(number) {
	            return number + ' වැනි';
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	});

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : slovak (sk)
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'm':
	                // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm':
	                // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':
	                // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh':
	                // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':
	                // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd':
	                // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':
	                // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM':
	                // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':
	                // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy':
	                // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParse: function (months, monthsShort) {
	            var i,
	                _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort),
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	});

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : slovenian (sl)
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	});

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Albanian (sq)
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author: Menelion Elensúle: https://github.com/Oire (tests)
	//! author : Oerd Cukalla : https://github.com/oerd (fixes)
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        meridiemParse: /PD|MD/,
	        isPM: function isPM(input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	});

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Serbian-cyrillic (sr-cyrl)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
	            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
	        },
	        translate: function translate(number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr_cyrl = moment.defineLocale('sr-cyrl', {
	        months: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар'],
	        monthsShort: ['јан.', 'феб.', 'мар.', 'апр.', 'мај', 'јун', 'јул', 'авг.', 'сеп.', 'окт.', 'нов.', 'дец.'],
	        weekdays: ['недеља', 'понедељак', 'уторак', 'среда', 'четвртак', 'петак', 'субота'],
	        weekdaysShort: ['нед.', 'пон.', 'уто.', 'сре.', 'чет.', 'пет.', 'суб.'],
	        weekdaysMin: ['не', 'по', 'ут', 'ср', 'че', 'пе', 'су'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function lastWeek() {
	                var lastWeekDays = ['[прошле] [недеље] [у] LT', '[прошлог] [понедељка] [у] LT', '[прошлог] [уторка] [у] LT', '[прошле] [среде] [у] LT', '[прошлог] [четвртка] [у] LT', '[прошлог] [петка] [у] LT', '[прошле] [суботе] [у] LT'];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr_cyrl;
	});

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Serbian-latin (sr)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
	            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
	        },
	        translate: function translate(number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
	        monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
	        weekdays: ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota'],
	        weekdaysShort: ['ned.', 'pon.', 'uto.', 'sre.', 'čet.', 'pet.', 'sub.'],
	        weekdaysMin: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function lastWeek() {
	                var lastWeekDays = ['[prošle] [nedelje] [u] LT', '[prošlog] [ponedeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	});

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : swedish (sv)
	//! author : Jens Alm : https://github.com/ulmus
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år'
	        },
	        ordinalParse: /\d{1,2}(e|a)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'e' : b === 1 ? 'a' : b === 2 ? 'a' : b === 3 ? 'e' : 'e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	});

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : tamil (ta)
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்'
	        },
	        ordinalParse: /\d{1,2}வது/,
	        ordinal: function ordinal(number) {
	            return number + 'வது';
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	});

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : thai (th)
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort: 'มกรา_กุมภา_มีนา_เมษา_พฤษภา_มิถุนา_กรกฎา_สิงหา_กันยา_ตุลา_พฤศจิกา_ธันวา'.split('_'),
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        longDateFormat: {
	            LT: 'H นาฬิกา m นาที',
	            LTS: 'H นาฬิกา m นาที s วินาที',
	            L: 'YYYY/MM/DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H นาฬิกา m นาที',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H นาฬิกา m นาที'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function isPM(input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี'
	        }
	    });
	
	    return th;
	});

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Tagalog/Filipino (tl-ph)
	//! author : Dan Hagman
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var tl_ph = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Ngayon sa] LT',
	            nextDay: '[Bukas sa] LT',
	            nextWeek: 'dddd [sa] LT',
	            lastDay: '[Kahapon sa] LT',
	            lastWeek: 'dddd [huling linggo] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal: function ordinal(number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tl_ph;
	});

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : turkish (tr)
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[haftaya] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen hafta] dddd [saat] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl'
	        },
	        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal: function ordinal(number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	});

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : talossan (tzl)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v with the help of Iustì Canun
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'LT.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY LT',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY LT'
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', ' ' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', ' ' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', ' ' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', ' ' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', ' ' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : withoutSuffix ? format[key][0] : format[key][1].trim();
	    }
	
	    return tzl;
	});

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt in Latin (tzm-latn)
	//! author : Abdel Said : https://github.com/abdelsaid
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var tzm_latn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn'
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm_latn;
	});

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt (tzm)
	//! author : Abdel Said : https://github.com/abdelsaid
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	});

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : ukrainian (uk)
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'хвилина_хвилини_хвилин',
	            'hh': 'година_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_'),
	            'accusative': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_')
	        },
	            nounCase = /D[oD]? *MMMM?/.test(format) ? 'accusative' : 'nominative';
	        return months[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        },
	            nounCase = /(\[[ВвУу]\]) ?dddd/.test(format) ? 'accusative' : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format) ? 'genitive' : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: monthsCaseReplace,
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function isPM(input) {
	            return (/^(дня|вечора)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	});

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : uzbek (uz)
	//! author : Sardor Muminov : https://github.com/muminoff
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	});

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : vietnamese (vi)
	//! author : Bang Nguyen : https://github.com/bangnk
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort: 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal: function ordinal(number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	});

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : chinese (zh-cn)
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var zh_cn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'Ah点mm分',
	            LTS: 'Ah点m分s秒',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY年MMMD日',
	            LLL: 'YYYY年MMMD日Ah点mm分',
	            LLLL: 'YYYY年MMMD日ddddAh点mm分',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY年MMMD日',
	            lll: 'YYYY年MMMD日Ah点mm分',
	            llll: 'YYYY年MMMD日ddddAh点mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: function sameDay() {
	                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	            },
	            nextDay: function nextDay() {
	                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	            },
	            lastDay: function lastDay() {
	                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	            },
	            nextWeek: function nextWeek() {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() - startOfWeek.unix() >= 7 * 24 * 3600 ? '[下]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            lastWeek: function lastWeek() {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() < startOfWeek.unix() ? '[上]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            sameElse: 'LL'
	        },
	        ordinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s内',
	            past: '%s前',
	            s: '几秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年'
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zh_cn;
	});

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : traditional chinese (zh-tw)
	//! author : Ben : https://github.com/ben-lin
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var zh_tw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'Ah點mm分',
	            LTS: 'Ah點m分s秒',
	            L: 'YYYY年MMMD日',
	            LL: 'YYYY年MMMD日',
	            LLL: 'YYYY年MMMD日Ah點mm分',
	            LLLL: 'YYYY年MMMD日ddddAh點mm分',
	            l: 'YYYY年MMMD日',
	            ll: 'YYYY年MMMD日',
	            lll: 'YYYY年MMMD日Ah點mm分',
	            llll: 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /早上|上午|中午|下午|晚上/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            m: '一分鐘',
	            mm: '%d分鐘',
	            h: '一小時',
	            hh: '%d小時',
	            d: '一天',
	            dd: '%d天',
	            M: '一個月',
	            MM: '%d個月',
	            y: '一年',
	            yy: '%d年'
	        }
	    });
	
	    return zh_tw;
	});

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _ViewListView = __webpack_require__(17);
	
	var _ViewListView2 = _interopRequireDefault(_ViewListView);
	
	var Collection = function (_ListView) {
	    function Collection() {
	        _classCallCheck(this, Collection);
	
	        if (_ListView != null) {
	            _ListView.apply(this, arguments);
	        }
	    }
	
	    _inherits(Collection, _ListView);
	
	    _createClass(Collection, [{
	        key: 'setEntity',
	        value: function setEntity(entity) {
	            this.entity = entity;
	            if (!this._name) {
	                this._name = entity.name();
	            }
	            return this;
	        }
	    }]);
	
	    return Collection;
	}(_ViewListView2['default']);
	
	exports['default'] = Collection;
	module.exports = exports['default'];
	//# sourceMappingURL=Collection.js.map

/***/ },
/* 126 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var Dashboard = function () {
	    function Dashboard() {
	        _classCallCheck(this, Dashboard);
	
	        this._collections = {};
	        this._template = null;
	    }
	
	    _createClass(Dashboard, [{
	        key: "addCollection",
	        value: function addCollection(collection) {
	            this._collections[collection.name()] = collection;
	            return this;
	        }
	    }, {
	        key: "collections",
	        value: function collections(_collections) {
	            if (arguments.length) {
	                this._collections = _collections;
	                return this;
	            }
	            return this._collections;
	        }
	    }, {
	        key: "hasCollections",
	        value: function hasCollections() {
	            return Object.keys(this._collections).length > 0;
	        }
	    }, {
	        key: "template",
	        value: function template(_template) {
	            if (arguments.length) {
	                this._template = _template;
	                return this;
	            }
	            return this._template;
	        }
	    }]);
	
	    return Dashboard;
	}();
	
	exports["default"] = Dashboard;
	module.exports = exports["default"];
	//# sourceMappingURL=Dashboard.js.map

/***/ },
/* 127 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	var DataStore = function () {
	    function DataStore() {
	        _classCallCheck(this, DataStore);
	
	        this._entries = {};
	    }
	
	    _createClass(DataStore, [{
	        key: 'setEntries',
	        value: function setEntries(name, entries) {
	            this._entries[name] = entries;
	
	            return this;
	        }
	    }, {
	        key: 'addEntry',
	        value: function addEntry(name, entry) {
	            if (!(name in this._entries)) {
	                this._entries[name] = [];
	            }
	
	            this._entries[name].push(entry);
	        }
	    }, {
	        key: 'getEntries',
	        value: function getEntries(name) {
	            return this._entries[name] || [];
	        }
	    }, {
	        key: 'getFirstEntry',
	
	        /**
	         * Get first entry satisfying a filter function
	         *
	         * @example datastore.getEntry('books', book => book.title === 'War and Peace');
	         */
	        value: function getFirstEntry(name) {
	            var filter = arguments[1] === undefined ? function () {
	                return true;
	            } : arguments[1];
	
	            return this.getEntries(name).filter(filter).shift();
	        }
	    }, {
	        key: 'getChoices',
	        value: function getChoices(field) {
	            var identifier = field.targetEntity().identifier().name();
	            var name = field.targetField().name();
	
	            return this.getEntries(field.targetEntity().uniqueId + '_choices').map(function (entry) {
	                return {
	                    value: entry.values[identifier],
	                    label: entry.values[name]
	                };
	            });
	        }
	    }, {
	        key: 'fillReferencesValuesFromCollection',
	        value: function fillReferencesValuesFromCollection(collection, referencedValues, fillSimpleReference) {
	            fillSimpleReference = typeof fillSimpleReference === 'undefined' ? false : fillSimpleReference;
	
	            for (var i = 0, l = collection.length; i < l; i++) {
	                collection[i] = this.fillReferencesValuesFromEntry(collection[i], referencedValues, fillSimpleReference);
	            }
	
	            return collection;
	        }
	    }, {
	        key: 'fillReferencesValuesFromEntry',
	        value: function fillReferencesValuesFromEntry(entry, referencedValues, fillSimpleReference) {
	            for (var referenceField in referencedValues) {
	                var reference = referencedValues[referenceField],
	                    choices = this.getReferenceChoicesById(reference),
	                    entries = [],
	                    identifier = reference.getMappedValue(entry.values[referenceField], entry.values);
	
	                if (reference.type() === 'reference_many') {
	                    for (var i in identifier) {
	                        var id = identifier[i];
	                        entries.push(choices[id]);
	                    }
	
	                    entry.listValues[referenceField] = entries;
	                } else if (fillSimpleReference && identifier != null && identifier in choices) {
	                    entry.listValues[referenceField] = reference.getMappedValue(choices[identifier], entry.values);
	                }
	            }
	
	            return entry;
	        }
	    }, {
	        key: 'getReferenceChoicesById',
	        value: function getReferenceChoicesById(field) {
	            var result = {},
	                targetField = field.targetField().name(),
	                targetIdentifier = field.targetEntity().identifier().name(),
	                entries = this.getEntries(field.targetEntity().uniqueId + '_values');
	
	            for (var i = 0, l = entries.length; i < l; i++) {
	                var entry = entries[i];
	                result[entry.values[targetIdentifier]] = entry.values[targetField];
	            }
	
	            return result;
	        }
	    }]);
	
	    return DataStore;
	}();
	
	exports['default'] = DataStore;
	module.exports = exports['default'];
	//# sourceMappingURL=DataStore.js.map

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var DateField = function (_Field) {
	    function DateField(name) {
	        _classCallCheck(this, DateField);
	
	        _get(Object.getPrototypeOf(DateField.prototype), "constructor", this).call(this, name);
	
	        this._format = null;
	        this._parse = function (date) {
	            if (date instanceof Date) {
	                // the datepicker returns a JS Date object, with hours, minutes and timezone
	                // in order to convert it back to date, we must remove the timezone, then
	                // remove hours and minutes
	                date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
	
	                var dateString = date.toJSON();
	                return dateString ? dateString.substr(0, 10) : null;
	            }
	            return date;
	        };
	        this._type = "date";
	    }
	
	    _inherits(DateField, _Field);
	
	    _createClass(DateField, [{
	        key: "format",
	        value: function format(value) {
	            if (!arguments.length) return this._format;
	            this._format = value;
	            return this;
	        }
	    }, {
	        key: "parse",
	        value: function parse(value) {
	            if (!arguments.length) return this._parse;
	            this._parse = value;
	            return this;
	        }
	    }]);
	
	    return DateField;
	}(_Field3["default"]);
	
	exports["default"] = DateField;
	module.exports = exports["default"];
	//# sourceMappingURL=DateField.js.map

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var NumberField = function (_Field) {
	    function NumberField(name) {
	        _classCallCheck(this, NumberField);
	
	        _get(Object.getPrototypeOf(NumberField.prototype), "constructor", this).call(this, name);
	        this._type = "number";
	        this._format = undefined;
	    }
	
	    _inherits(NumberField, _Field);
	
	    _createClass(NumberField, [{
	        key: "format",
	
	        /**
	         * Specify format pattern for number to string conversion. 
	         *
	         * Based on NumeralJs, which uses a syntax similar to Excel.
	         *
	         * {@link} http://numeraljs.com/
	         * {@link} https://github.com/baumandm/angular-numeraljs
	         * {@example}
	         *
	         *     nga.field('height', 'number').format('$0,0.00');
	         */
	        value: function format(value) {
	            if (!arguments.length) return this._format;
	            this._format = value;
	            return this;
	        }
	    }, {
	        key: "fractionSize",
	        value: function fractionSize(decimals) {
	            console.warn("NumberField.fractionSize() is deprecated, use NumberField.format() instead");
	            this.format("0." + "0".repeat(decimals));
	            return this;
	        }
	    }]);
	
	    return NumberField;
	}(_Field3["default"]);
	
	exports["default"] = NumberField;
	module.exports = exports["default"];
	//# sourceMappingURL=NumberField.js.map

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	var _EntityEntity = __webpack_require__(27);
	
	var _EntityEntity2 = _interopRequireDefault(_EntityEntity);
	
	function alwaysFalse() {
	    return false;
	}
	
	var uuid = 0;
	var _autoClose = true;
	
	var Menu = function () {
	    function Menu() {
	        _classCallCheck(this, Menu);
	
	        this._link = null;
	        this._activeFunc = alwaysFalse;
	        this._title = null;
	        this._icon = false;
	        this._children = [];
	        this._template = false;
	        this._autoClose = true;
	        this.uuid = uuid++;
	    }
	
	    _createClass(Menu, [{
	        key: 'title',
	        value: function title() {
	            if (arguments.length) {
	                this._title = arguments[0];
	                return this;
	            }
	            return this._title;
	        }
	    }, {
	        key: 'isLink',
	        value: function isLink() {
	            return !!this._link;
	        }
	    }, {
	        key: 'link',
	        value: function link() {
	            var _this = this;
	
	            if (arguments.length) {
	                this._link = arguments[0];
	                if (this._activeFunc == alwaysFalse) {
	                    this._activeFunc = function (url) {
	                        return url.indexOf(_this._link) === 0;
	                    };
	                }
	                return this;
	            }
	            return this._link;
	        }
	    }, {
	        key: 'autoClose',
	        value: function autoClose() {
	            if (arguments.length) {
	                _autoClose = arguments[0];
	                return this;
	            }
	            return _autoClose;
	        }
	    }, {
	        key: 'active',
	        value: function active(activeFunc) {
	            if (arguments.length) {
	                this._activeFunc = arguments[0];
	                return this;
	            }
	            return this._activeFunc;
	        }
	    }, {
	        key: 'isActive',
	        value: function isActive(url) {
	            return this._activeFunc(url);
	        }
	    }, {
	        key: 'isChildActive',
	        value: function isChildActive(url) {
	            return this.isActive(url) || this.children().filter(function (menu) {
	                return menu.isChildActive(url);
	            }).length > 0;
	        }
	    }, {
	        key: 'addChild',
	        value: function addChild(child) {
	            if (!(child instanceof Menu)) {
	                throw new Error('Only Menu instances are accepted as children of a Menu');
	            }
	            this._children.push(child);
	            return this;
	        }
	    }, {
	        key: 'hasChild',
	        value: function hasChild() {
	            return this._children.length > 0;
	        }
	    }, {
	        key: 'getChildByTitle',
	        value: function getChildByTitle(title) {
	            return this.children().filter(function (child) {
	                return child.title() == title;
	            }).pop();
	        }
	    }, {
	        key: 'children',
	        value: function children() {
	            if (arguments.length) {
	                this._children = arguments[0];
	                return this;
	            }
	            return this._children;
	        }
	    }, {
	        key: 'icon',
	        value: function icon() {
	            if (arguments.length) {
	                this._icon = arguments[0];
	                return this;
	            }
	            return this._icon;
	        }
	    }, {
	        key: 'template',
	        value: function template() {
	            if (arguments.length) {
	                this._template = arguments[0];
	                return this;
	            }
	            return this._template;
	        }
	    }, {
	        key: 'populateFromEntity',
	        value: function populateFromEntity(entity) {
	            if (!(entity instanceof _EntityEntity2['default'])) {
	                throw new Error('populateFromEntity() only accepts an Entity parameter');
	            }
	            this.title(entity.label());
	            this.active(function (path) {
	                return path.indexOf('/' + entity.name() + '/') === 0;
	            });
	            this.link('/' + entity.name() + '/list');
	            // deprecated
	            this.icon(entity.menuView().icon());
	            return this;
	        }
	    }]);
	
	    return Menu;
	}();
	
	exports['default'] = Menu;
	module.exports = exports['default'];
	//# sourceMappingURL=Menu.js.map

/***/ },
/* 131 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var Queries = function Queries(RestWrapper, PromisesResolver, Application) {
	    _classCallCheck(this, Queries);
	
	    this._restWrapper = RestWrapper;
	    this._promisesResolver = PromisesResolver;
	    this._application = Application;
	};
	
	exports["default"] = Queries;
	module.exports = exports["default"];
	//# sourceMappingURL=Queries.js.map

/***/ },
/* 132 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.clone = clone;
	exports.cloneAndFlatten = cloneAndFlatten;
	exports.cloneAndNest = cloneAndNest;
	function isObject(value) {
	    if (value === null) return false;
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') return false;
	    if (Array.isArray(value)) return false;
	    if (Object.prototype.toString.call(value) === '[object Date]') return false;
	    return true;
	}
	
	function clone(object) {
	    return Object.keys(object).reduce(function (values, name) {
	        if (object.hasOwnProperty(name)) {
	            values[name] = object[name];
	        }
	        return values;
	    }, {});
	}
	
	/*
	 * Flatten nested object into a single level object with 'foo.bar' property names
	 *
	 * The parameter object is left unchanged. All values in the returned object are scalar.
	 *
	 *     cloneAndFlatten({ a: 1, b: { c: 2 }, d: { e: 3, f: { g: 4, h: 5 } }, i: { j: 6 } }, ['i'])
	 *     // { a: 1, 'b.c': 2, 'd.e': 3, 'd.f.g': 4, 'd.f.h': 5, i: { j: 6 } } }
	 *
	 * @param {Object} object
	 * @param {String[]} excludedProperties
	 * @return {Object}
	 */
	
	function cloneAndFlatten(object) {
	    var excludedProperties = arguments[1] === undefined ? [] : arguments[1];
	
	    if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') {
	        throw new Error('Expecting an object parameter');
	    }
	    return Object.keys(object).reduce(function (values, name) {
	        if (!object.hasOwnProperty(name)) return values;
	        if (isObject(object[name])) {
	            if (excludedProperties.indexOf(name) === -1) {
	                (function () {
	                    var flatObject = cloneAndFlatten(object[name]);
	                    Object.keys(flatObject).forEach(function (flatObjectKey) {
	                        if (!flatObject.hasOwnProperty(flatObjectKey)) return;
	                        values[name + '.' + flatObjectKey] = flatObject[flatObjectKey];
	                    });
	                })();
	            } else {
	                values[name] = clone(object[name]);
	            }
	        } else {
	            values[name] = object[name];
	        }
	        return values;
	    }, {});
	}
	
	;
	
	/*
	 * Clone flattened object into a nested object
	 *
	 * The parameter object is left unchanged.
	 *
	 *     cloneAndNest({ a: 1, 'b.c': 2, 'd.e': 3, 'd.f.g': 4, 'd.f.h': 5 } )
	 *     // { a: 1, b: { c: 2 }, d: { e: 3, f: { g: 4, h: 5 } } }
	 *
	 * @param {Object} object
	 * @return {Object}
	 */
	
	function cloneAndNest(object) {
	    if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') {
	        throw new Error('Expecting an object parameter');
	    }
	    return Object.keys(object).reduce(function (values, name) {
	        if (!object.hasOwnProperty(name)) return values;
	        name.split('.').reduce(function (previous, current, index, list) {
	            if (previous != null) {
	                if (typeof previous[current] === 'undefined') previous[current] = {};
	                if (index < list.length - 1) {
	                    return previous[current];
	                };
	                previous[current] = object[name];
	            }
	        }, values);
	        return values;
	    }, {});
	}
	//# sourceMappingURL=objectProperties.js.map

/***/ },
/* 133 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = {
	    order: function order(input) {
	        var results = [],
	            objectKey;
	
	        for (objectKey in input) {
	            results.push(input[objectKey]);
	        }
	
	        return results.sort(function (e1, e2) {
	            return e1.order() - e2.order();
	        });
	    }
	};
	module.exports = exports["default"];
	//# sourceMappingURL=orderElement.js.map

/***/ },
/* 134 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    /**
	     * @see http://stackoverflow.com/questions/10425287/convert-string-to-camelcase-with-regular-expression
	     * @see http://phpjs.org/functions/ucfirst/
	     */
	    camelCase: function camelCase(text) {
	        if (!text) {
	            return text;
	        }
	
	        var f = text.charAt(0).toUpperCase();
	        text = f + text.substr(1);
	
	        return text.replace(/[-_.\s](.)/g, function (match, group1) {
	            return ' ' + group1.toUpperCase();
	        });
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=stringUtils.js.map

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/**
	 * Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Copyright 2015, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.0
	 * Build date: 10 May 2015
	 */(function(factory,root){if(true){// AMD. Register as an anonymous module.
	!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else if(typeof module!="undefined"&&(typeof exports==="undefined"?"undefined":_typeof(exports))=="object"){// Node/CommonJS style
	module.exports=factory();}else{// No AMD or CommonJS support so we place Rangy in (probably) the global variable
	root.rangy=factory();}})(function(){var OBJECT="object",FUNCTION="function",UNDEFINED="undefined";// Minimal set of properties required for DOM Level 2 Range compliance. Comparison constants such as START_TO_START
	// are omitted because ranges in KHTML do not have them but otherwise work perfectly well. See issue 113.
	var domRangeProperties=["startContainer","startOffset","endContainer","endOffset","collapsed","commonAncestorContainer"];// Minimal set of methods required for DOM Level 2 Range compliance
	var domRangeMethods=["setStart","setStartBefore","setStartAfter","setEnd","setEndBefore","setEndAfter","collapse","selectNode","selectNodeContents","compareBoundaryPoints","deleteContents","extractContents","cloneContents","insertNode","surroundContents","cloneRange","toString","detach"];var textRangeProperties=["boundingHeight","boundingLeft","boundingTop","boundingWidth","htmlText","text"];// Subset of TextRange's full set of methods that we're interested in
	var textRangeMethods=["collapse","compareEndPoints","duplicate","moveToElementText","parentElement","select","setEndPoint","getBoundingClientRect"];/*----------------------------------------------------------------------------------------------------------------*/// Trio of functions taken from Peter Michaux's article:
	// http://peter.michaux.ca/articles/feature-detection-state-of-the-art-browser-scripting
	function isHostMethod(o,p){var t=_typeof(o[p]);return t==FUNCTION||!!(t==OBJECT&&o[p])||t=="unknown";}function isHostObject(o,p){return!!(_typeof(o[p])==OBJECT&&o[p]);}function isHostProperty(o,p){return _typeof(o[p])!=UNDEFINED;}// Creates a convenience function to save verbose repeated calls to tests functions
	function createMultiplePropertyTest(testFunc){return function(o,props){var i=props.length;while(i--){if(!testFunc(o,props[i])){return false;}}return true;};}// Next trio of functions are a convenience to save verbose repeated calls to previous two functions
	var areHostMethods=createMultiplePropertyTest(isHostMethod);var areHostObjects=createMultiplePropertyTest(isHostObject);var areHostProperties=createMultiplePropertyTest(isHostProperty);function isTextRange(range){return range&&areHostMethods(range,textRangeMethods)&&areHostProperties(range,textRangeProperties);}function getBody(doc){return isHostObject(doc,"body")?doc.body:doc.getElementsByTagName("body")[0];}var forEach=[].forEach?function(arr,func){arr.forEach(func);}:function(arr,func){for(var i=0,len=arr.length;i<len;++i){func(arr[i],i);}};var modules={};var isBrowser=(typeof window==="undefined"?"undefined":_typeof(window))!=UNDEFINED&&(typeof document==="undefined"?"undefined":_typeof(document))!=UNDEFINED;var util={isHostMethod:isHostMethod,isHostObject:isHostObject,isHostProperty:isHostProperty,areHostMethods:areHostMethods,areHostObjects:areHostObjects,areHostProperties:areHostProperties,isTextRange:isTextRange,getBody:getBody,forEach:forEach};var api={version:"1.3.0",initialized:false,isBrowser:isBrowser,supported:true,util:util,features:{},modules:modules,config:{alertOnFail:false,alertOnWarn:false,preferTextRange:false,autoInitialize:(typeof rangyAutoInitialize==="undefined"?"undefined":_typeof(rangyAutoInitialize))==UNDEFINED?true:rangyAutoInitialize}};function consoleLog(msg){if((typeof console==="undefined"?"undefined":_typeof(console))!=UNDEFINED&&isHostMethod(console,"log")){console.log(msg);}}function alertOrLog(msg,shouldAlert){if(isBrowser&&shouldAlert){alert(msg);}else{consoleLog(msg);}}function fail(reason){api.initialized=true;api.supported=false;alertOrLog("Rangy is not supported in this environment. Reason: "+reason,api.config.alertOnFail);}api.fail=fail;function warn(msg){alertOrLog("Rangy warning: "+msg,api.config.alertOnWarn);}api.warn=warn;// Add utility extend() method
	var _extend;if({}.hasOwnProperty){util.extend=_extend=function extend(obj,props,deep){var o,p;for(var i in props){if(props.hasOwnProperty(i)){o=obj[i];p=props[i];if(deep&&o!==null&&(typeof o==="undefined"?"undefined":_typeof(o))=="object"&&p!==null&&(typeof p==="undefined"?"undefined":_typeof(p))=="object"){_extend(o,p,true);}obj[i]=p;}}// Special case for toString, which does not show up in for...in loops in IE <= 8
	if(props.hasOwnProperty("toString")){obj.toString=props.toString;}return obj;};util.createOptions=function(optionsParam,defaults){var options={};_extend(options,defaults);if(optionsParam){_extend(options,optionsParam);}return options;};}else{fail("hasOwnProperty not supported");}// Test whether we're in a browser and bail out if not
	if(!isBrowser){fail("Rangy can only run in a browser");}// Test whether Array.prototype.slice can be relied on for NodeLists and use an alternative toArray() if not
	(function(){var toArray;if(isBrowser){var el=document.createElement("div");el.appendChild(document.createElement("span"));var slice=[].slice;try{if(slice.call(el.childNodes,0)[0].nodeType==1){toArray=function toArray(arrayLike){return slice.call(arrayLike,0);};}}catch(e){}}if(!toArray){toArray=function toArray(arrayLike){var arr=[];for(var i=0,len=arrayLike.length;i<len;++i){arr[i]=arrayLike[i];}return arr;};}util.toArray=toArray;})();// Very simple event handler wrapper function that doesn't attempt to solve issues such as "this" handling or
	// normalization of event properties
	var addListener;if(isBrowser){if(isHostMethod(document,"addEventListener")){addListener=function addListener(obj,eventType,listener){obj.addEventListener(eventType,listener,false);};}else if(isHostMethod(document,"attachEvent")){addListener=function addListener(obj,eventType,listener){obj.attachEvent("on"+eventType,listener);};}else{fail("Document does not have required addEventListener or attachEvent method");}util.addListener=addListener;}var initListeners=[];function getErrorDesc(ex){return ex.message||ex.description||String(ex);}// Initialization
	function init(){if(!isBrowser||api.initialized){return;}var testRange;var implementsDomRange=false,implementsTextRange=false;// First, perform basic feature tests
	if(isHostMethod(document,"createRange")){testRange=document.createRange();if(areHostMethods(testRange,domRangeMethods)&&areHostProperties(testRange,domRangeProperties)){implementsDomRange=true;}}var body=getBody(document);if(!body||body.nodeName.toLowerCase()!="body"){fail("No body element found");return;}if(body&&isHostMethod(body,"createTextRange")){testRange=body.createTextRange();if(isTextRange(testRange)){implementsTextRange=true;}}if(!implementsDomRange&&!implementsTextRange){fail("Neither Range nor TextRange are available");return;}api.initialized=true;api.features={implementsDomRange:implementsDomRange,implementsTextRange:implementsTextRange};// Initialize modules
	var module,errorMessage;for(var moduleName in modules){if((module=modules[moduleName])instanceof Module){module.init(module,api);}}// Call init listeners
	for(var i=0,len=initListeners.length;i<len;++i){try{initListeners[i](api);}catch(ex){errorMessage="Rangy init listener threw an exception. Continuing. Detail: "+getErrorDesc(ex);consoleLog(errorMessage);}}}function deprecationNotice(deprecated,replacement,module){if(module){deprecated+=" in module "+module.name;}api.warn("DEPRECATED: "+deprecated+" is deprecated. Please use "+replacement+" instead.");}function createAliasForDeprecatedMethod(owner,deprecated,replacement,module){owner[deprecated]=function(){deprecationNotice(deprecated,replacement,module);return owner[replacement].apply(owner,util.toArray(arguments));};}util.deprecationNotice=deprecationNotice;util.createAliasForDeprecatedMethod=createAliasForDeprecatedMethod;// Allow external scripts to initialize this library in case it's loaded after the document has loaded
	api.init=init;// Execute listener immediately if already initialized
	api.addInitListener=function(listener){if(api.initialized){listener(api);}else{initListeners.push(listener);}};var shimListeners=[];api.addShimListener=function(listener){shimListeners.push(listener);};function shim(win){win=win||window;init();// Notify listeners
	for(var i=0,len=shimListeners.length;i<len;++i){shimListeners[i](win);}}if(isBrowser){api.shim=api.createMissingNativeApi=shim;createAliasForDeprecatedMethod(api,"createMissingNativeApi","shim");}function Module(name,dependencies,initializer){this.name=name;this.dependencies=dependencies;this.initialized=false;this.supported=false;this.initializer=initializer;}Module.prototype={init:function init(){var requiredModuleNames=this.dependencies||[];for(var i=0,len=requiredModuleNames.length,requiredModule,moduleName;i<len;++i){moduleName=requiredModuleNames[i];requiredModule=modules[moduleName];if(!requiredModule||!(requiredModule instanceof Module)){throw new Error("required module '"+moduleName+"' not found");}requiredModule.init();if(!requiredModule.supported){throw new Error("required module '"+moduleName+"' not supported");}}// Now run initializer
	this.initializer(this);},fail:function fail(reason){this.initialized=true;this.supported=false;throw new Error(reason);},warn:function warn(msg){api.warn("Module "+this.name+": "+msg);},deprecationNotice:function deprecationNotice(deprecated,replacement){api.warn("DEPRECATED: "+deprecated+" in module "+this.name+" is deprecated. Please use "+replacement+" instead");},createError:function createError(msg){return new Error("Error in Rangy "+this.name+" module: "+msg);}};function createModule(name,dependencies,initFunc){var newModule=new Module(name,dependencies,function(module){if(!module.initialized){module.initialized=true;try{initFunc(api,module);module.supported=true;}catch(ex){var errorMessage="Module '"+name+"' failed to load: "+getErrorDesc(ex);consoleLog(errorMessage);if(ex.stack){consoleLog(ex.stack);}}}});modules[name]=newModule;return newModule;}api.createModule=function(name){// Allow 2 or 3 arguments (second argument is an optional array of dependencies)
	var initFunc,dependencies;if(arguments.length==2){initFunc=arguments[1];dependencies=[];}else{initFunc=arguments[2];dependencies=arguments[1];}var module=createModule(name,dependencies,initFunc);// Initialize the module immediately if the core is already initialized
	if(api.initialized&&api.supported){module.init();}};api.createCoreModule=function(name,dependencies,initFunc){createModule(name,dependencies,initFunc);};/*----------------------------------------------------------------------------------------------------------------*/// Ensure rangy.rangePrototype and rangy.selectionPrototype are available immediately
	function RangePrototype(){}api.RangePrototype=RangePrototype;api.rangePrototype=new RangePrototype();function SelectionPrototype(){}api.selectionPrototype=new SelectionPrototype();/*----------------------------------------------------------------------------------------------------------------*/// DOM utility methods used by Rangy
	api.createCoreModule("DomUtil",[],function(api,module){var UNDEF="undefined";var util=api.util;var getBody=util.getBody;// Perform feature tests
	if(!util.areHostMethods(document,["createDocumentFragment","createElement","createTextNode"])){module.fail("document missing a Node creation method");}if(!util.isHostMethod(document,"getElementsByTagName")){module.fail("document missing getElementsByTagName method");}var el=document.createElement("div");if(!util.areHostMethods(el,["insertBefore","appendChild","cloneNode"]||!util.areHostObjects(el,["previousSibling","nextSibling","childNodes","parentNode"]))){module.fail("Incomplete Element implementation");}// innerHTML is required for Range's createContextualFragment method
	if(!util.isHostProperty(el,"innerHTML")){module.fail("Element is missing innerHTML property");}var textNode=document.createTextNode("test");if(!util.areHostMethods(textNode,["splitText","deleteData","insertData","appendData","cloneNode"]||!util.areHostObjects(el,["previousSibling","nextSibling","childNodes","parentNode"])||!util.areHostProperties(textNode,["data"]))){module.fail("Incomplete Text Node implementation");}/*----------------------------------------------------------------------------------------------------------------*/// Removed use of indexOf because of a bizarre bug in Opera that is thrown in one of the Acid3 tests. I haven't been
	// able to replicate it outside of the test. The bug is that indexOf returns -1 when called on an Array that
	// contains just the document as a single element and the value searched for is the document.
	var arrayContains=/*Array.prototype.indexOf ?
	            function(arr, val) {
	                return arr.indexOf(val) > -1;
	            }:*/function arrayContains(arr,val){var i=arr.length;while(i--){if(arr[i]===val){return true;}}return false;};// Opera 11 puts HTML elements in the null namespace, it seems, and IE 7 has undefined namespaceURI
	function isHtmlNamespace(node){var ns;return _typeof(node.namespaceURI)==UNDEF||(ns=node.namespaceURI)===null||ns=="http://www.w3.org/1999/xhtml";}function parentElement(node){var parent=node.parentNode;return parent.nodeType==1?parent:null;}function getNodeIndex(node){var i=0;while(node=node.previousSibling){++i;}return i;}function getNodeLength(node){switch(node.nodeType){case 7:case 10:return 0;case 3:case 8:return node.length;default:return node.childNodes.length;}}function getCommonAncestor(node1,node2){var ancestors=[],n;for(n=node1;n;n=n.parentNode){ancestors.push(n);}for(n=node2;n;n=n.parentNode){if(arrayContains(ancestors,n)){return n;}}return null;}function isAncestorOf(ancestor,descendant,selfIsAncestor){var n=selfIsAncestor?descendant:descendant.parentNode;while(n){if(n===ancestor){return true;}else{n=n.parentNode;}}return false;}function isOrIsAncestorOf(ancestor,descendant){return isAncestorOf(ancestor,descendant,true);}function getClosestAncestorIn(node,ancestor,selfIsAncestor){var p,n=selfIsAncestor?node:node.parentNode;while(n){p=n.parentNode;if(p===ancestor){return n;}n=p;}return null;}function isCharacterDataNode(node){var t=node.nodeType;return t==3||t==4||t==8;// Text, CDataSection or Comment
	}function isTextOrCommentNode(node){if(!node){return false;}var t=node.nodeType;return t==3||t==8;// Text or Comment
	}function insertAfter(node,precedingNode){var nextNode=precedingNode.nextSibling,parent=precedingNode.parentNode;if(nextNode){parent.insertBefore(node,nextNode);}else{parent.appendChild(node);}return node;}// Note that we cannot use splitText() because it is bugridden in IE 9.
	function splitDataNode(node,index,positionsToPreserve){var newNode=node.cloneNode(false);newNode.deleteData(0,index);node.deleteData(index,node.length-index);insertAfter(newNode,node);// Preserve positions
	if(positionsToPreserve){for(var i=0,position;position=positionsToPreserve[i++];){// Handle case where position was inside the portion of node after the split point
	if(position.node==node&&position.offset>index){position.node=newNode;position.offset-=index;}// Handle the case where the position is a node offset within node's parent
	else if(position.node==node.parentNode&&position.offset>getNodeIndex(node)){++position.offset;}}}return newNode;}function getDocument(node){if(node.nodeType==9){return node;}else if(_typeof(node.ownerDocument)!=UNDEF){return node.ownerDocument;}else if(_typeof(node.document)!=UNDEF){return node.document;}else if(node.parentNode){return getDocument(node.parentNode);}else{throw module.createError("getDocument: no document found for node");}}function getWindow(node){var doc=getDocument(node);if(_typeof(doc.defaultView)!=UNDEF){return doc.defaultView;}else if(_typeof(doc.parentWindow)!=UNDEF){return doc.parentWindow;}else{throw module.createError("Cannot get a window object for node");}}function getIframeDocument(iframeEl){if(_typeof(iframeEl.contentDocument)!=UNDEF){return iframeEl.contentDocument;}else if(_typeof(iframeEl.contentWindow)!=UNDEF){return iframeEl.contentWindow.document;}else{throw module.createError("getIframeDocument: No Document object found for iframe element");}}function getIframeWindow(iframeEl){if(_typeof(iframeEl.contentWindow)!=UNDEF){return iframeEl.contentWindow;}else if(_typeof(iframeEl.contentDocument)!=UNDEF){return iframeEl.contentDocument.defaultView;}else{throw module.createError("getIframeWindow: No Window object found for iframe element");}}// This looks bad. Is it worth it?
	function isWindow(obj){return obj&&util.isHostMethod(obj,"setTimeout")&&util.isHostObject(obj,"document");}function getContentDocument(obj,module,methodName){var doc;if(!obj){doc=document;}// Test if a DOM node has been passed and obtain a document object for it if so
	else if(util.isHostProperty(obj,"nodeType")){doc=obj.nodeType==1&&obj.tagName.toLowerCase()=="iframe"?getIframeDocument(obj):getDocument(obj);}// Test if the doc parameter appears to be a Window object
	else if(isWindow(obj)){doc=obj.document;}if(!doc){throw module.createError(methodName+"(): Parameter must be a Window object or DOM node");}return doc;}function getRootContainer(node){var parent;while(parent=node.parentNode){node=parent;}return node;}function comparePoints(nodeA,offsetA,nodeB,offsetB){// See http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Comparing
	var nodeC,root,childA,childB,n;if(nodeA==nodeB){// Case 1: nodes are the same
	return offsetA===offsetB?0:offsetA<offsetB?-1:1;}else if(nodeC=getClosestAncestorIn(nodeB,nodeA,true)){// Case 2: node C (container B or an ancestor) is a child node of A
	return offsetA<=getNodeIndex(nodeC)?-1:1;}else if(nodeC=getClosestAncestorIn(nodeA,nodeB,true)){// Case 3: node C (container A or an ancestor) is a child node of B
	return getNodeIndex(nodeC)<offsetB?-1:1;}else{root=getCommonAncestor(nodeA,nodeB);if(!root){throw new Error("comparePoints error: nodes have no common ancestor");}// Case 4: containers are siblings or descendants of siblings
	childA=nodeA===root?root:getClosestAncestorIn(nodeA,root,true);childB=nodeB===root?root:getClosestAncestorIn(nodeB,root,true);if(childA===childB){// This shouldn't be possible
	throw module.createError("comparePoints got to case 4 and childA and childB are the same!");}else{n=root.firstChild;while(n){if(n===childA){return-1;}else if(n===childB){return 1;}n=n.nextSibling;}}}}/*----------------------------------------------------------------------------------------------------------------*/// Test for IE's crash (IE 6/7) or exception (IE >= 8) when a reference to garbage-collected text node is queried
	var crashyTextNodes=false;function isBrokenNode(node){var n;try{n=node.parentNode;return false;}catch(e){return true;}}(function(){var el=document.createElement("b");el.innerHTML="1";var textNode=el.firstChild;el.innerHTML="<br />";crashyTextNodes=isBrokenNode(textNode);api.features.crashyTextNodes=crashyTextNodes;})();/*----------------------------------------------------------------------------------------------------------------*/function inspectNode(node){if(!node){return"[No node]";}if(crashyTextNodes&&isBrokenNode(node)){return"[Broken node]";}if(isCharacterDataNode(node)){return'"'+node.data+'"';}if(node.nodeType==1){var idAttr=node.id?' id="'+node.id+'"':"";return"<"+node.nodeName+idAttr+">[index:"+getNodeIndex(node)+",length:"+node.childNodes.length+"]["+(node.innerHTML||"[innerHTML not supported]").slice(0,25)+"]";}return node.nodeName;}function fragmentFromNodeChildren(node){var fragment=getDocument(node).createDocumentFragment(),child;while(child=node.firstChild){fragment.appendChild(child);}return fragment;}var getComputedStyleProperty;if(_typeof(window.getComputedStyle)!=UNDEF){getComputedStyleProperty=function getComputedStyleProperty(el,propName){return getWindow(el).getComputedStyle(el,null)[propName];};}else if(_typeof(document.documentElement.currentStyle)!=UNDEF){getComputedStyleProperty=function getComputedStyleProperty(el,propName){return el.currentStyle?el.currentStyle[propName]:"";};}else{module.fail("No means of obtaining computed style properties found");}function createTestElement(doc,html,contentEditable){var body=getBody(doc);var el=doc.createElement("div");el.contentEditable=""+!!contentEditable;if(html){el.innerHTML=html;}// Insert the test element at the start of the body to prevent scrolling to the bottom in iOS (issue #292)
	var bodyFirstChild=body.firstChild;if(bodyFirstChild){body.insertBefore(el,bodyFirstChild);}else{body.appendChild(el);}return el;}function removeNode(node){return node.parentNode.removeChild(node);}function NodeIterator(root){this.root=root;this._next=root;}NodeIterator.prototype={_current:null,hasNext:function hasNext(){return!!this._next;},next:function next(){var n=this._current=this._next;var child,next;if(this._current){child=n.firstChild;if(child){this._next=child;}else{next=null;while(n!==this.root&&!(next=n.nextSibling)){n=n.parentNode;}this._next=next;}}return this._current;},detach:function detach(){this._current=this._next=this.root=null;}};function createIterator(root){return new NodeIterator(root);}function DomPosition(node,offset){this.node=node;this.offset=offset;}DomPosition.prototype={equals:function equals(pos){return!!pos&&this.node===pos.node&&this.offset==pos.offset;},inspect:function inspect(){return"[DomPosition("+inspectNode(this.node)+":"+this.offset+")]";},toString:function toString(){return this.inspect();}};function DOMException(codeName){this.code=this[codeName];this.codeName=codeName;this.message="DOMException: "+this.codeName;}DOMException.prototype={INDEX_SIZE_ERR:1,HIERARCHY_REQUEST_ERR:3,WRONG_DOCUMENT_ERR:4,NO_MODIFICATION_ALLOWED_ERR:7,NOT_FOUND_ERR:8,NOT_SUPPORTED_ERR:9,INVALID_STATE_ERR:11,INVALID_NODE_TYPE_ERR:24};DOMException.prototype.toString=function(){return this.message;};api.dom={arrayContains:arrayContains,isHtmlNamespace:isHtmlNamespace,parentElement:parentElement,getNodeIndex:getNodeIndex,getNodeLength:getNodeLength,getCommonAncestor:getCommonAncestor,isAncestorOf:isAncestorOf,isOrIsAncestorOf:isOrIsAncestorOf,getClosestAncestorIn:getClosestAncestorIn,isCharacterDataNode:isCharacterDataNode,isTextOrCommentNode:isTextOrCommentNode,insertAfter:insertAfter,splitDataNode:splitDataNode,getDocument:getDocument,getWindow:getWindow,getIframeWindow:getIframeWindow,getIframeDocument:getIframeDocument,getBody:getBody,isWindow:isWindow,getContentDocument:getContentDocument,getRootContainer:getRootContainer,comparePoints:comparePoints,isBrokenNode:isBrokenNode,inspectNode:inspectNode,getComputedStyleProperty:getComputedStyleProperty,createTestElement:createTestElement,removeNode:removeNode,fragmentFromNodeChildren:fragmentFromNodeChildren,createIterator:createIterator,DomPosition:DomPosition};api.DOMException=DOMException;});/*----------------------------------------------------------------------------------------------------------------*/// Pure JavaScript implementation of DOM Range
	api.createCoreModule("DomRange",["DomUtil"],function(api,module){var dom=api.dom;var util=api.util;var DomPosition=dom.DomPosition;var DOMException=api.DOMException;var isCharacterDataNode=dom.isCharacterDataNode;var getNodeIndex=dom.getNodeIndex;var isOrIsAncestorOf=dom.isOrIsAncestorOf;var getDocument=dom.getDocument;var comparePoints=dom.comparePoints;var splitDataNode=dom.splitDataNode;var getClosestAncestorIn=dom.getClosestAncestorIn;var getNodeLength=dom.getNodeLength;var arrayContains=dom.arrayContains;var getRootContainer=dom.getRootContainer;var crashyTextNodes=api.features.crashyTextNodes;var removeNode=dom.removeNode;/*----------------------------------------------------------------------------------------------------------------*/// Utility functions
	function isNonTextPartiallySelected(node,range){return node.nodeType!=3&&(isOrIsAncestorOf(node,range.startContainer)||isOrIsAncestorOf(node,range.endContainer));}function getRangeDocument(range){return range.document||getDocument(range.startContainer);}function getRangeRoot(range){return getRootContainer(range.startContainer);}function getBoundaryBeforeNode(node){return new DomPosition(node.parentNode,getNodeIndex(node));}function getBoundaryAfterNode(node){return new DomPosition(node.parentNode,getNodeIndex(node)+1);}function insertNodeAtPosition(node,n,o){var firstNodeInserted=node.nodeType==11?node.firstChild:node;if(isCharacterDataNode(n)){if(o==n.length){dom.insertAfter(node,n);}else{n.parentNode.insertBefore(node,o==0?n:splitDataNode(n,o));}}else if(o>=n.childNodes.length){n.appendChild(node);}else{n.insertBefore(node,n.childNodes[o]);}return firstNodeInserted;}function rangesIntersect(rangeA,rangeB,touchingIsIntersecting){assertRangeValid(rangeA);assertRangeValid(rangeB);if(getRangeDocument(rangeB)!=getRangeDocument(rangeA)){throw new DOMException("WRONG_DOCUMENT_ERR");}var startComparison=comparePoints(rangeA.startContainer,rangeA.startOffset,rangeB.endContainer,rangeB.endOffset),endComparison=comparePoints(rangeA.endContainer,rangeA.endOffset,rangeB.startContainer,rangeB.startOffset);return touchingIsIntersecting?startComparison<=0&&endComparison>=0:startComparison<0&&endComparison>0;}function cloneSubtree(iterator){var partiallySelected;for(var node,frag=getRangeDocument(iterator.range).createDocumentFragment(),subIterator;node=iterator.next();){partiallySelected=iterator.isPartiallySelectedSubtree();node=node.cloneNode(!partiallySelected);if(partiallySelected){subIterator=iterator.getSubtreeIterator();node.appendChild(cloneSubtree(subIterator));subIterator.detach();}if(node.nodeType==10){// DocumentType
	throw new DOMException("HIERARCHY_REQUEST_ERR");}frag.appendChild(node);}return frag;}function iterateSubtree(rangeIterator,func,iteratorState){var it,n;iteratorState=iteratorState||{stop:false};for(var node,subRangeIterator;node=rangeIterator.next();){if(rangeIterator.isPartiallySelectedSubtree()){if(func(node)===false){iteratorState.stop=true;return;}else{// The node is partially selected by the Range, so we can use a new RangeIterator on the portion of
	// the node selected by the Range.
	subRangeIterator=rangeIterator.getSubtreeIterator();iterateSubtree(subRangeIterator,func,iteratorState);subRangeIterator.detach();if(iteratorState.stop){return;}}}else{// The whole node is selected, so we can use efficient DOM iteration to iterate over the node and its
	// descendants
	it=dom.createIterator(node);while(n=it.next()){if(func(n)===false){iteratorState.stop=true;return;}}}}}function deleteSubtree(iterator){var subIterator;while(iterator.next()){if(iterator.isPartiallySelectedSubtree()){subIterator=iterator.getSubtreeIterator();deleteSubtree(subIterator);subIterator.detach();}else{iterator.remove();}}}function extractSubtree(iterator){for(var node,frag=getRangeDocument(iterator.range).createDocumentFragment(),subIterator;node=iterator.next();){if(iterator.isPartiallySelectedSubtree()){node=node.cloneNode(false);subIterator=iterator.getSubtreeIterator();node.appendChild(extractSubtree(subIterator));subIterator.detach();}else{iterator.remove();}if(node.nodeType==10){// DocumentType
	throw new DOMException("HIERARCHY_REQUEST_ERR");}frag.appendChild(node);}return frag;}function getNodesInRange(range,nodeTypes,filter){var filterNodeTypes=!!(nodeTypes&&nodeTypes.length),regex;var filterExists=!!filter;if(filterNodeTypes){regex=new RegExp("^("+nodeTypes.join("|")+")$");}var nodes=[];iterateSubtree(new RangeIterator(range,false),function(node){if(filterNodeTypes&&!regex.test(node.nodeType)){return;}if(filterExists&&!filter(node)){return;}// Don't include a boundary container if it is a character data node and the range does not contain any
	// of its character data. See issue 190.
	var sc=range.startContainer;if(node==sc&&isCharacterDataNode(sc)&&range.startOffset==sc.length){return;}var ec=range.endContainer;if(node==ec&&isCharacterDataNode(ec)&&range.endOffset==0){return;}nodes.push(node);});return nodes;}function _inspect(range){var name=typeof range.getName=="undefined"?"Range":range.getName();return"["+name+"("+dom.inspectNode(range.startContainer)+":"+range.startOffset+", "+dom.inspectNode(range.endContainer)+":"+range.endOffset+")]";}/*----------------------------------------------------------------------------------------------------------------*/// RangeIterator code partially borrows from IERange by Tim Ryan (http://github.com/timcameronryan/IERange)
	function RangeIterator(range,clonePartiallySelectedTextNodes){this.range=range;this.clonePartiallySelectedTextNodes=clonePartiallySelectedTextNodes;if(!range.collapsed){this.sc=range.startContainer;this.so=range.startOffset;this.ec=range.endContainer;this.eo=range.endOffset;var root=range.commonAncestorContainer;if(this.sc===this.ec&&isCharacterDataNode(this.sc)){this.isSingleCharacterDataNode=true;this._first=this._last=this._next=this.sc;}else{this._first=this._next=this.sc===root&&!isCharacterDataNode(this.sc)?this.sc.childNodes[this.so]:getClosestAncestorIn(this.sc,root,true);this._last=this.ec===root&&!isCharacterDataNode(this.ec)?this.ec.childNodes[this.eo-1]:getClosestAncestorIn(this.ec,root,true);}}}RangeIterator.prototype={_current:null,_next:null,_first:null,_last:null,isSingleCharacterDataNode:false,reset:function reset(){this._current=null;this._next=this._first;},hasNext:function hasNext(){return!!this._next;},next:function next(){// Move to next node
	var current=this._current=this._next;if(current){this._next=current!==this._last?current.nextSibling:null;// Check for partially selected text nodes
	if(isCharacterDataNode(current)&&this.clonePartiallySelectedTextNodes){if(current===this.ec){(current=current.cloneNode(true)).deleteData(this.eo,current.length-this.eo);}if(this._current===this.sc){(current=current.cloneNode(true)).deleteData(0,this.so);}}}return current;},remove:function remove(){var current=this._current,start,end;if(isCharacterDataNode(current)&&(current===this.sc||current===this.ec)){start=current===this.sc?this.so:0;end=current===this.ec?this.eo:current.length;if(start!=end){current.deleteData(start,end-start);}}else{if(current.parentNode){removeNode(current);}else{}}},// Checks if the current node is partially selected
	isPartiallySelectedSubtree:function isPartiallySelectedSubtree(){var current=this._current;return isNonTextPartiallySelected(current,this.range);},getSubtreeIterator:function getSubtreeIterator(){var subRange;if(this.isSingleCharacterDataNode){subRange=this.range.cloneRange();subRange.collapse(false);}else{subRange=new Range(getRangeDocument(this.range));var current=this._current;var startContainer=current,startOffset=0,endContainer=current,endOffset=getNodeLength(current);if(isOrIsAncestorOf(current,this.sc)){startContainer=this.sc;startOffset=this.so;}if(isOrIsAncestorOf(current,this.ec)){endContainer=this.ec;endOffset=this.eo;}updateBoundaries(subRange,startContainer,startOffset,endContainer,endOffset);}return new RangeIterator(subRange,this.clonePartiallySelectedTextNodes);},detach:function detach(){this.range=this._current=this._next=this._first=this._last=this.sc=this.so=this.ec=this.eo=null;}};/*----------------------------------------------------------------------------------------------------------------*/var beforeAfterNodeTypes=[1,3,4,5,7,8,10];var rootContainerNodeTypes=[2,9,11];var readonlyNodeTypes=[5,6,10,12];var insertableNodeTypes=[1,3,4,5,7,8,10,11];var surroundNodeTypes=[1,3,4,5,7,8];function createAncestorFinder(nodeTypes){return function(node,selfIsAncestor){var t,n=selfIsAncestor?node:node.parentNode;while(n){t=n.nodeType;if(arrayContains(nodeTypes,t)){return n;}n=n.parentNode;}return null;};}var getDocumentOrFragmentContainer=createAncestorFinder([9,11]);var getReadonlyAncestor=createAncestorFinder(readonlyNodeTypes);var getDocTypeNotationEntityAncestor=createAncestorFinder([6,10,12]);function assertNoDocTypeNotationEntityAncestor(node,allowSelf){if(getDocTypeNotationEntityAncestor(node,allowSelf)){throw new DOMException("INVALID_NODE_TYPE_ERR");}}function assertValidNodeType(node,invalidTypes){if(!arrayContains(invalidTypes,node.nodeType)){throw new DOMException("INVALID_NODE_TYPE_ERR");}}function assertValidOffset(node,offset){if(offset<0||offset>(isCharacterDataNode(node)?node.length:node.childNodes.length)){throw new DOMException("INDEX_SIZE_ERR");}}function assertSameDocumentOrFragment(node1,node2){if(getDocumentOrFragmentContainer(node1,true)!==getDocumentOrFragmentContainer(node2,true)){throw new DOMException("WRONG_DOCUMENT_ERR");}}function assertNodeNotReadOnly(node){if(getReadonlyAncestor(node,true)){throw new DOMException("NO_MODIFICATION_ALLOWED_ERR");}}function assertNode(node,codeName){if(!node){throw new DOMException(codeName);}}function isValidOffset(node,offset){return offset<=(isCharacterDataNode(node)?node.length:node.childNodes.length);}function isRangeValid(range){return!!range.startContainer&&!!range.endContainer&&!(crashyTextNodes&&(dom.isBrokenNode(range.startContainer)||dom.isBrokenNode(range.endContainer)))&&getRootContainer(range.startContainer)==getRootContainer(range.endContainer)&&isValidOffset(range.startContainer,range.startOffset)&&isValidOffset(range.endContainer,range.endOffset);}function assertRangeValid(range){if(!isRangeValid(range)){throw new Error("Range error: Range is not valid. This usually happens after DOM mutation. Range: ("+range.inspect()+")");}}/*----------------------------------------------------------------------------------------------------------------*/// Test the browser's innerHTML support to decide how to implement createContextualFragment
	var styleEl=document.createElement("style");var htmlParsingConforms=false;try{styleEl.innerHTML="<b>x</b>";htmlParsingConforms=styleEl.firstChild.nodeType==3;// Opera incorrectly creates an element node
	}catch(e){// IE 6 and 7 throw
	}api.features.htmlParsingConforms=htmlParsingConforms;var createContextualFragment=htmlParsingConforms?// Implementation as per HTML parsing spec, trusting in the browser's implementation of innerHTML. See
	// discussion and base code for this implementation at issue 67.
	// Spec: http://html5.org/specs/dom-parsing.html#extensions-to-the-range-interface
	// Thanks to Aleks Williams.
	function(fragmentStr){// "Let node the context object's start's node."
	var node=this.startContainer;var doc=getDocument(node);// "If the context object's start's node is null, raise an INVALID_STATE_ERR
	// exception and abort these steps."
	if(!node){throw new DOMException("INVALID_STATE_ERR");}// "Let element be as follows, depending on node's interface:"
	// Document, Document Fragment: null
	var el=null;// "Element: node"
	if(node.nodeType==1){el=node;// "Text, Comment: node's parentElement"
	}else if(isCharacterDataNode(node)){el=dom.parentElement(node);}// "If either element is null or element's ownerDocument is an HTML document
	// and element's local name is "html" and element's namespace is the HTML
	// namespace"
	if(el===null||el.nodeName=="HTML"&&dom.isHtmlNamespace(getDocument(el).documentElement)&&dom.isHtmlNamespace(el)){// "let element be a new Element with "body" as its local name and the HTML
	// namespace as its namespace.""
	el=doc.createElement("body");}else{el=el.cloneNode(false);}// "If the node's document is an HTML document: Invoke the HTML fragment parsing algorithm."
	// "If the node's document is an XML document: Invoke the XML fragment parsing algorithm."
	// "In either case, the algorithm must be invoked with fragment as the input
	// and element as the context element."
	el.innerHTML=fragmentStr;// "If this raises an exception, then abort these steps. Otherwise, let new
	// children be the nodes returned."
	// "Let fragment be a new DocumentFragment."
	// "Append all new children to fragment."
	// "Return fragment."
	return dom.fragmentFromNodeChildren(el);}:// In this case, innerHTML cannot be trusted, so fall back to a simpler, non-conformant implementation that
	// previous versions of Rangy used (with the exception of using a body element rather than a div)
	function(fragmentStr){var doc=getRangeDocument(this);var el=doc.createElement("body");el.innerHTML=fragmentStr;return dom.fragmentFromNodeChildren(el);};function splitRangeBoundaries(range,positionsToPreserve){assertRangeValid(range);var sc=range.startContainer,so=range.startOffset,ec=range.endContainer,eo=range.endOffset;var startEndSame=sc===ec;if(isCharacterDataNode(ec)&&eo>0&&eo<ec.length){splitDataNode(ec,eo,positionsToPreserve);}if(isCharacterDataNode(sc)&&so>0&&so<sc.length){sc=splitDataNode(sc,so,positionsToPreserve);if(startEndSame){eo-=so;ec=sc;}else if(ec==sc.parentNode&&eo>=getNodeIndex(sc)){eo++;}so=0;}range.setStartAndEnd(sc,so,ec,eo);}function rangeToHtml(range){assertRangeValid(range);var container=range.commonAncestorContainer.parentNode.cloneNode(false);container.appendChild(range.cloneContents());return container.innerHTML;}/*----------------------------------------------------------------------------------------------------------------*/var rangeProperties=["startContainer","startOffset","endContainer","endOffset","collapsed","commonAncestorContainer"];var s2s=0,s2e=1,e2e=2,e2s=3;var n_b=0,n_a=1,n_b_a=2,n_i=3;util.extend(api.rangePrototype,{compareBoundaryPoints:function compareBoundaryPoints(how,range){assertRangeValid(this);assertSameDocumentOrFragment(this.startContainer,range.startContainer);var nodeA,offsetA,nodeB,offsetB;var prefixA=how==e2s||how==s2s?"start":"end";var prefixB=how==s2e||how==s2s?"start":"end";nodeA=this[prefixA+"Container"];offsetA=this[prefixA+"Offset"];nodeB=range[prefixB+"Container"];offsetB=range[prefixB+"Offset"];return comparePoints(nodeA,offsetA,nodeB,offsetB);},insertNode:function insertNode(node){assertRangeValid(this);assertValidNodeType(node,insertableNodeTypes);assertNodeNotReadOnly(this.startContainer);if(isOrIsAncestorOf(node,this.startContainer)){throw new DOMException("HIERARCHY_REQUEST_ERR");}// No check for whether the container of the start of the Range is of a type that does not allow
	// children of the type of node: the browser's DOM implementation should do this for us when we attempt
	// to add the node
	var firstNodeInserted=insertNodeAtPosition(node,this.startContainer,this.startOffset);this.setStartBefore(firstNodeInserted);},cloneContents:function cloneContents(){assertRangeValid(this);var clone,frag;if(this.collapsed){return getRangeDocument(this).createDocumentFragment();}else{if(this.startContainer===this.endContainer&&isCharacterDataNode(this.startContainer)){clone=this.startContainer.cloneNode(true);clone.data=clone.data.slice(this.startOffset,this.endOffset);frag=getRangeDocument(this).createDocumentFragment();frag.appendChild(clone);return frag;}else{var iterator=new RangeIterator(this,true);clone=cloneSubtree(iterator);iterator.detach();}return clone;}},canSurroundContents:function canSurroundContents(){assertRangeValid(this);assertNodeNotReadOnly(this.startContainer);assertNodeNotReadOnly(this.endContainer);// Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	// no non-text nodes.
	var iterator=new RangeIterator(this,true);var boundariesInvalid=iterator._first&&isNonTextPartiallySelected(iterator._first,this)||iterator._last&&isNonTextPartiallySelected(iterator._last,this);iterator.detach();return!boundariesInvalid;},surroundContents:function surroundContents(node){assertValidNodeType(node,surroundNodeTypes);if(!this.canSurroundContents()){throw new DOMException("INVALID_STATE_ERR");}// Extract the contents
	var content=this.extractContents();// Clear the children of the node
	if(node.hasChildNodes()){while(node.lastChild){node.removeChild(node.lastChild);}}// Insert the new node and add the extracted contents
	insertNodeAtPosition(node,this.startContainer,this.startOffset);node.appendChild(content);this.selectNode(node);},cloneRange:function cloneRange(){assertRangeValid(this);var range=new Range(getRangeDocument(this));var i=rangeProperties.length,prop;while(i--){prop=rangeProperties[i];range[prop]=this[prop];}return range;},toString:function toString(){assertRangeValid(this);var sc=this.startContainer;if(sc===this.endContainer&&isCharacterDataNode(sc)){return sc.nodeType==3||sc.nodeType==4?sc.data.slice(this.startOffset,this.endOffset):"";}else{var textParts=[],iterator=new RangeIterator(this,true);iterateSubtree(iterator,function(node){// Accept only text or CDATA nodes, not comments
	if(node.nodeType==3||node.nodeType==4){textParts.push(node.data);}});iterator.detach();return textParts.join("");}},// The methods below are all non-standard. The following batch were introduced by Mozilla but have since
	// been removed from Mozilla.
	compareNode:function compareNode(node){assertRangeValid(this);var parent=node.parentNode;var nodeIndex=getNodeIndex(node);if(!parent){throw new DOMException("NOT_FOUND_ERR");}var startComparison=this.comparePoint(parent,nodeIndex),endComparison=this.comparePoint(parent,nodeIndex+1);if(startComparison<0){// Node starts before
	return endComparison>0?n_b_a:n_b;}else{return endComparison>0?n_a:n_i;}},comparePoint:function comparePoint(node,offset){assertRangeValid(this);assertNode(node,"HIERARCHY_REQUEST_ERR");assertSameDocumentOrFragment(node,this.startContainer);if(comparePoints(node,offset,this.startContainer,this.startOffset)<0){return-1;}else if(comparePoints(node,offset,this.endContainer,this.endOffset)>0){return 1;}return 0;},createContextualFragment:createContextualFragment,toHtml:function toHtml(){return rangeToHtml(this);},// touchingIsIntersecting determines whether this method considers a node that borders a range intersects
	// with it (as in WebKit) or not (as in Gecko pre-1.9, and the default)
	intersectsNode:function intersectsNode(node,touchingIsIntersecting){assertRangeValid(this);if(getRootContainer(node)!=getRangeRoot(this)){return false;}var parent=node.parentNode,offset=getNodeIndex(node);if(!parent){return true;}var startComparison=comparePoints(parent,offset,this.endContainer,this.endOffset),endComparison=comparePoints(parent,offset+1,this.startContainer,this.startOffset);return touchingIsIntersecting?startComparison<=0&&endComparison>=0:startComparison<0&&endComparison>0;},isPointInRange:function isPointInRange(node,offset){assertRangeValid(this);assertNode(node,"HIERARCHY_REQUEST_ERR");assertSameDocumentOrFragment(node,this.startContainer);return comparePoints(node,offset,this.startContainer,this.startOffset)>=0&&comparePoints(node,offset,this.endContainer,this.endOffset)<=0;},// The methods below are non-standard and invented by me.
	// Sharing a boundary start-to-end or end-to-start does not count as intersection.
	intersectsRange:function intersectsRange(range){return rangesIntersect(this,range,false);},// Sharing a boundary start-to-end or end-to-start does count as intersection.
	intersectsOrTouchesRange:function intersectsOrTouchesRange(range){return rangesIntersect(this,range,true);},intersection:function intersection(range){if(this.intersectsRange(range)){var startComparison=comparePoints(this.startContainer,this.startOffset,range.startContainer,range.startOffset),endComparison=comparePoints(this.endContainer,this.endOffset,range.endContainer,range.endOffset);var intersectionRange=this.cloneRange();if(startComparison==-1){intersectionRange.setStart(range.startContainer,range.startOffset);}if(endComparison==1){intersectionRange.setEnd(range.endContainer,range.endOffset);}return intersectionRange;}return null;},union:function union(range){if(this.intersectsOrTouchesRange(range)){var unionRange=this.cloneRange();if(comparePoints(range.startContainer,range.startOffset,this.startContainer,this.startOffset)==-1){unionRange.setStart(range.startContainer,range.startOffset);}if(comparePoints(range.endContainer,range.endOffset,this.endContainer,this.endOffset)==1){unionRange.setEnd(range.endContainer,range.endOffset);}return unionRange;}else{throw new DOMException("Ranges do not intersect");}},containsNode:function containsNode(node,allowPartial){if(allowPartial){return this.intersectsNode(node,false);}else{return this.compareNode(node)==n_i;}},containsNodeContents:function containsNodeContents(node){return this.comparePoint(node,0)>=0&&this.comparePoint(node,getNodeLength(node))<=0;},containsRange:function containsRange(range){var intersection=this.intersection(range);return intersection!==null&&range.equals(intersection);},containsNodeText:function containsNodeText(node){var nodeRange=this.cloneRange();nodeRange.selectNode(node);var textNodes=nodeRange.getNodes([3]);if(textNodes.length>0){nodeRange.setStart(textNodes[0],0);var lastTextNode=textNodes.pop();nodeRange.setEnd(lastTextNode,lastTextNode.length);return this.containsRange(nodeRange);}else{return this.containsNodeContents(node);}},getNodes:function getNodes(nodeTypes,filter){assertRangeValid(this);return getNodesInRange(this,nodeTypes,filter);},getDocument:function getDocument(){return getRangeDocument(this);},collapseBefore:function collapseBefore(node){this.setEndBefore(node);this.collapse(false);},collapseAfter:function collapseAfter(node){this.setStartAfter(node);this.collapse(true);},getBookmark:function getBookmark(containerNode){var doc=getRangeDocument(this);var preSelectionRange=api.createRange(doc);containerNode=containerNode||dom.getBody(doc);preSelectionRange.selectNodeContents(containerNode);var range=this.intersection(preSelectionRange);var start=0,end=0;if(range){preSelectionRange.setEnd(range.startContainer,range.startOffset);start=preSelectionRange.toString().length;end=start+range.toString().length;}return{start:start,end:end,containerNode:containerNode};},moveToBookmark:function moveToBookmark(bookmark){var containerNode=bookmark.containerNode;var charIndex=0;this.setStart(containerNode,0);this.collapse(true);var nodeStack=[containerNode],node,foundStart=false,stop=false;var nextCharIndex,i,childNodes;while(!stop&&(node=nodeStack.pop())){if(node.nodeType==3){nextCharIndex=charIndex+node.length;if(!foundStart&&bookmark.start>=charIndex&&bookmark.start<=nextCharIndex){this.setStart(node,bookmark.start-charIndex);foundStart=true;}if(foundStart&&bookmark.end>=charIndex&&bookmark.end<=nextCharIndex){this.setEnd(node,bookmark.end-charIndex);stop=true;}charIndex=nextCharIndex;}else{childNodes=node.childNodes;i=childNodes.length;while(i--){nodeStack.push(childNodes[i]);}}}},getName:function getName(){return"DomRange";},equals:function equals(range){return Range.rangesEqual(this,range);},isValid:function isValid(){return isRangeValid(this);},inspect:function inspect(){return _inspect(this);},detach:function detach(){// In DOM4, detach() is now a no-op.
	}});function copyComparisonConstantsToObject(obj){obj.START_TO_START=s2s;obj.START_TO_END=s2e;obj.END_TO_END=e2e;obj.END_TO_START=e2s;obj.NODE_BEFORE=n_b;obj.NODE_AFTER=n_a;obj.NODE_BEFORE_AND_AFTER=n_b_a;obj.NODE_INSIDE=n_i;}function copyComparisonConstants(constructor){copyComparisonConstantsToObject(constructor);copyComparisonConstantsToObject(constructor.prototype);}function createRangeContentRemover(remover,boundaryUpdater){return function(){assertRangeValid(this);var sc=this.startContainer,so=this.startOffset,root=this.commonAncestorContainer;var iterator=new RangeIterator(this,true);// Work out where to position the range after content removal
	var node,boundary;if(sc!==root){node=getClosestAncestorIn(sc,root,true);boundary=getBoundaryAfterNode(node);sc=boundary.node;so=boundary.offset;}// Check none of the range is read-only
	iterateSubtree(iterator,assertNodeNotReadOnly);iterator.reset();// Remove the content
	var returnValue=remover(iterator);iterator.detach();// Move to the new position
	boundaryUpdater(this,sc,so,sc,so);return returnValue;};}function createPrototypeRange(constructor,boundaryUpdater){function createBeforeAfterNodeSetter(isBefore,isStart){return function(node){assertValidNodeType(node,beforeAfterNodeTypes);assertValidNodeType(getRootContainer(node),rootContainerNodeTypes);var boundary=(isBefore?getBoundaryBeforeNode:getBoundaryAfterNode)(node);(isStart?setRangeStart:setRangeEnd)(this,boundary.node,boundary.offset);};}function setRangeStart(range,node,offset){var ec=range.endContainer,eo=range.endOffset;if(node!==range.startContainer||offset!==range.startOffset){// Check the root containers of the range and the new boundary, and also check whether the new boundary
	// is after the current end. In either case, collapse the range to the new position
	if(getRootContainer(node)!=getRootContainer(ec)||comparePoints(node,offset,ec,eo)==1){ec=node;eo=offset;}boundaryUpdater(range,node,offset,ec,eo);}}function setRangeEnd(range,node,offset){var sc=range.startContainer,so=range.startOffset;if(node!==range.endContainer||offset!==range.endOffset){// Check the root containers of the range and the new boundary, and also check whether the new boundary
	// is after the current end. In either case, collapse the range to the new position
	if(getRootContainer(node)!=getRootContainer(sc)||comparePoints(node,offset,sc,so)==-1){sc=node;so=offset;}boundaryUpdater(range,sc,so,node,offset);}}// Set up inheritance
	var F=function F(){};F.prototype=api.rangePrototype;constructor.prototype=new F();util.extend(constructor.prototype,{setStart:function setStart(node,offset){assertNoDocTypeNotationEntityAncestor(node,true);assertValidOffset(node,offset);setRangeStart(this,node,offset);},setEnd:function setEnd(node,offset){assertNoDocTypeNotationEntityAncestor(node,true);assertValidOffset(node,offset);setRangeEnd(this,node,offset);},/**
	                 * Convenience method to set a range's start and end boundaries. Overloaded as follows:
	                 * - Two parameters (node, offset) creates a collapsed range at that position
	                 * - Three parameters (node, startOffset, endOffset) creates a range contained with node starting at
	                 *   startOffset and ending at endOffset
	                 * - Four parameters (startNode, startOffset, endNode, endOffset) creates a range starting at startOffset in
	                 *   startNode and ending at endOffset in endNode
	                 */setStartAndEnd:function setStartAndEnd(){var args=arguments;var sc=args[0],so=args[1],ec=sc,eo=so;switch(args.length){case 3:eo=args[2];break;case 4:ec=args[2];eo=args[3];break;}boundaryUpdater(this,sc,so,ec,eo);},setBoundary:function setBoundary(node,offset,isStart){this["set"+(isStart?"Start":"End")](node,offset);},setStartBefore:createBeforeAfterNodeSetter(true,true),setStartAfter:createBeforeAfterNodeSetter(false,true),setEndBefore:createBeforeAfterNodeSetter(true,false),setEndAfter:createBeforeAfterNodeSetter(false,false),collapse:function collapse(isStart){assertRangeValid(this);if(isStart){boundaryUpdater(this,this.startContainer,this.startOffset,this.startContainer,this.startOffset);}else{boundaryUpdater(this,this.endContainer,this.endOffset,this.endContainer,this.endOffset);}},selectNodeContents:function selectNodeContents(node){assertNoDocTypeNotationEntityAncestor(node,true);boundaryUpdater(this,node,0,node,getNodeLength(node));},selectNode:function selectNode(node){assertNoDocTypeNotationEntityAncestor(node,false);assertValidNodeType(node,beforeAfterNodeTypes);var start=getBoundaryBeforeNode(node),end=getBoundaryAfterNode(node);boundaryUpdater(this,start.node,start.offset,end.node,end.offset);},extractContents:createRangeContentRemover(extractSubtree,boundaryUpdater),deleteContents:createRangeContentRemover(deleteSubtree,boundaryUpdater),canSurroundContents:function canSurroundContents(){assertRangeValid(this);assertNodeNotReadOnly(this.startContainer);assertNodeNotReadOnly(this.endContainer);// Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	// no non-text nodes.
	var iterator=new RangeIterator(this,true);var boundariesInvalid=iterator._first&&isNonTextPartiallySelected(iterator._first,this)||iterator._last&&isNonTextPartiallySelected(iterator._last,this);iterator.detach();return!boundariesInvalid;},splitBoundaries:function splitBoundaries(){splitRangeBoundaries(this);},splitBoundariesPreservingPositions:function splitBoundariesPreservingPositions(positionsToPreserve){splitRangeBoundaries(this,positionsToPreserve);},normalizeBoundaries:function normalizeBoundaries(){assertRangeValid(this);var sc=this.startContainer,so=this.startOffset,ec=this.endContainer,eo=this.endOffset;var mergeForward=function mergeForward(node){var sibling=node.nextSibling;if(sibling&&sibling.nodeType==node.nodeType){ec=node;eo=node.length;node.appendData(sibling.data);removeNode(sibling);}};var mergeBackward=function mergeBackward(node){var sibling=node.previousSibling;if(sibling&&sibling.nodeType==node.nodeType){sc=node;var nodeLength=node.length;so=sibling.length;node.insertData(0,sibling.data);removeNode(sibling);if(sc==ec){eo+=so;ec=sc;}else if(ec==node.parentNode){var nodeIndex=getNodeIndex(node);if(eo==nodeIndex){ec=node;eo=nodeLength;}else if(eo>nodeIndex){eo--;}}}};var normalizeStart=true;var sibling;if(isCharacterDataNode(ec)){if(eo==ec.length){mergeForward(ec);}else if(eo==0){sibling=ec.previousSibling;if(sibling&&sibling.nodeType==ec.nodeType){eo=sibling.length;if(sc==ec){normalizeStart=false;}sibling.appendData(ec.data);removeNode(ec);ec=sibling;}}}else{if(eo>0){var endNode=ec.childNodes[eo-1];if(endNode&&isCharacterDataNode(endNode)){mergeForward(endNode);}}normalizeStart=!this.collapsed;}if(normalizeStart){if(isCharacterDataNode(sc)){if(so==0){mergeBackward(sc);}else if(so==sc.length){sibling=sc.nextSibling;if(sibling&&sibling.nodeType==sc.nodeType){if(ec==sibling){ec=sc;eo+=sc.length;}sc.appendData(sibling.data);removeNode(sibling);}}}else{if(so<sc.childNodes.length){var startNode=sc.childNodes[so];if(startNode&&isCharacterDataNode(startNode)){mergeBackward(startNode);}}}}else{sc=ec;so=eo;}boundaryUpdater(this,sc,so,ec,eo);},collapseToPoint:function collapseToPoint(node,offset){assertNoDocTypeNotationEntityAncestor(node,true);assertValidOffset(node,offset);this.setStartAndEnd(node,offset);}});copyComparisonConstants(constructor);}/*----------------------------------------------------------------------------------------------------------------*/// Updates commonAncestorContainer and collapsed after boundary change
	function updateCollapsedAndCommonAncestor(range){range.collapsed=range.startContainer===range.endContainer&&range.startOffset===range.endOffset;range.commonAncestorContainer=range.collapsed?range.startContainer:dom.getCommonAncestor(range.startContainer,range.endContainer);}function updateBoundaries(range,startContainer,startOffset,endContainer,endOffset){range.startContainer=startContainer;range.startOffset=startOffset;range.endContainer=endContainer;range.endOffset=endOffset;range.document=dom.getDocument(startContainer);updateCollapsedAndCommonAncestor(range);}function Range(doc){this.startContainer=doc;this.startOffset=0;this.endContainer=doc;this.endOffset=0;this.document=doc;updateCollapsedAndCommonAncestor(this);}createPrototypeRange(Range,updateBoundaries);util.extend(Range,{rangeProperties:rangeProperties,RangeIterator:RangeIterator,copyComparisonConstants:copyComparisonConstants,createPrototypeRange:createPrototypeRange,inspect:_inspect,toHtml:rangeToHtml,getRangeDocument:getRangeDocument,rangesEqual:function rangesEqual(r1,r2){return r1.startContainer===r2.startContainer&&r1.startOffset===r2.startOffset&&r1.endContainer===r2.endContainer&&r1.endOffset===r2.endOffset;}});api.DomRange=Range;});/*----------------------------------------------------------------------------------------------------------------*/// Wrappers for the browser's native DOM Range and/or TextRange implementation
	api.createCoreModule("WrappedRange",["DomRange"],function(api,module){var WrappedRange,WrappedTextRange;var dom=api.dom;var util=api.util;var DomPosition=dom.DomPosition;var DomRange=api.DomRange;var getBody=dom.getBody;var getContentDocument=dom.getContentDocument;var isCharacterDataNode=dom.isCharacterDataNode;/*----------------------------------------------------------------------------------------------------------------*/if(api.features.implementsDomRange){// This is a wrapper around the browser's native DOM Range. It has two aims:
	// - Provide workarounds for specific browser bugs
	// - provide convenient extensions, which are inherited from Rangy's DomRange
	(function(){var rangeProto;var rangeProperties=DomRange.rangeProperties;function updateRangeProperties(range){var i=rangeProperties.length,prop;while(i--){prop=rangeProperties[i];range[prop]=range.nativeRange[prop];}// Fix for broken collapsed property in IE 9.
	range.collapsed=range.startContainer===range.endContainer&&range.startOffset===range.endOffset;}function updateNativeRange(range,startContainer,startOffset,endContainer,endOffset){var startMoved=range.startContainer!==startContainer||range.startOffset!=startOffset;var endMoved=range.endContainer!==endContainer||range.endOffset!=endOffset;var nativeRangeDifferent=!range.equals(range.nativeRange);// Always set both boundaries for the benefit of IE9 (see issue 35)
	if(startMoved||endMoved||nativeRangeDifferent){range.setEnd(endContainer,endOffset);range.setStart(startContainer,startOffset);}}var createBeforeAfterNodeSetter;WrappedRange=function WrappedRange(range){if(!range){throw module.createError("WrappedRange: Range must be specified");}this.nativeRange=range;updateRangeProperties(this);};DomRange.createPrototypeRange(WrappedRange,updateNativeRange);rangeProto=WrappedRange.prototype;rangeProto.selectNode=function(node){this.nativeRange.selectNode(node);updateRangeProperties(this);};rangeProto.cloneContents=function(){return this.nativeRange.cloneContents();};// Due to a long-standing Firefox bug that I have not been able to find a reliable way to detect,
	// insertNode() is never delegated to the native range.
	rangeProto.surroundContents=function(node){this.nativeRange.surroundContents(node);updateRangeProperties(this);};rangeProto.collapse=function(isStart){this.nativeRange.collapse(isStart);updateRangeProperties(this);};rangeProto.cloneRange=function(){return new WrappedRange(this.nativeRange.cloneRange());};rangeProto.refresh=function(){updateRangeProperties(this);};rangeProto.toString=function(){return this.nativeRange.toString();};// Create test range and node for feature detection
	var testTextNode=document.createTextNode("test");getBody(document).appendChild(testTextNode);var range=document.createRange();/*--------------------------------------------------------------------------------------------------------*/// Test for Firefox 2 bug that prevents moving the start of a Range to a point after its current end and
	// correct for it
	range.setStart(testTextNode,0);range.setEnd(testTextNode,0);try{range.setStart(testTextNode,1);rangeProto.setStart=function(node,offset){this.nativeRange.setStart(node,offset);updateRangeProperties(this);};rangeProto.setEnd=function(node,offset){this.nativeRange.setEnd(node,offset);updateRangeProperties(this);};createBeforeAfterNodeSetter=function createBeforeAfterNodeSetter(name){return function(node){this.nativeRange[name](node);updateRangeProperties(this);};};}catch(ex){rangeProto.setStart=function(node,offset){try{this.nativeRange.setStart(node,offset);}catch(ex){this.nativeRange.setEnd(node,offset);this.nativeRange.setStart(node,offset);}updateRangeProperties(this);};rangeProto.setEnd=function(node,offset){try{this.nativeRange.setEnd(node,offset);}catch(ex){this.nativeRange.setStart(node,offset);this.nativeRange.setEnd(node,offset);}updateRangeProperties(this);};createBeforeAfterNodeSetter=function createBeforeAfterNodeSetter(name,oppositeName){return function(node){try{this.nativeRange[name](node);}catch(ex){this.nativeRange[oppositeName](node);this.nativeRange[name](node);}updateRangeProperties(this);};};}rangeProto.setStartBefore=createBeforeAfterNodeSetter("setStartBefore","setEndBefore");rangeProto.setStartAfter=createBeforeAfterNodeSetter("setStartAfter","setEndAfter");rangeProto.setEndBefore=createBeforeAfterNodeSetter("setEndBefore","setStartBefore");rangeProto.setEndAfter=createBeforeAfterNodeSetter("setEndAfter","setStartAfter");/*--------------------------------------------------------------------------------------------------------*/// Always use DOM4-compliant selectNodeContents implementation: it's simpler and less code than testing
	// whether the native implementation can be trusted
	rangeProto.selectNodeContents=function(node){this.setStartAndEnd(node,0,dom.getNodeLength(node));};/*--------------------------------------------------------------------------------------------------------*/// Test for and correct WebKit bug that has the behaviour of compareBoundaryPoints round the wrong way for
	// constants START_TO_END and END_TO_START: https://bugs.webkit.org/show_bug.cgi?id=20738
	range.selectNodeContents(testTextNode);range.setEnd(testTextNode,3);var range2=document.createRange();range2.selectNodeContents(testTextNode);range2.setEnd(testTextNode,4);range2.setStart(testTextNode,2);if(range.compareBoundaryPoints(range.START_TO_END,range2)==-1&&range.compareBoundaryPoints(range.END_TO_START,range2)==1){// This is the wrong way round, so correct for it
	rangeProto.compareBoundaryPoints=function(type,range){range=range.nativeRange||range;if(type==range.START_TO_END){type=range.END_TO_START;}else if(type==range.END_TO_START){type=range.START_TO_END;}return this.nativeRange.compareBoundaryPoints(type,range);};}else{rangeProto.compareBoundaryPoints=function(type,range){return this.nativeRange.compareBoundaryPoints(type,range.nativeRange||range);};}/*--------------------------------------------------------------------------------------------------------*/// Test for IE deleteContents() and extractContents() bug and correct it. See issue 107.
	var el=document.createElement("div");el.innerHTML="123";var textNode=el.firstChild;var body=getBody(document);body.appendChild(el);range.setStart(textNode,1);range.setEnd(textNode,2);range.deleteContents();if(textNode.data=="13"){// Behaviour is correct per DOM4 Range so wrap the browser's implementation of deleteContents() and
	// extractContents()
	rangeProto.deleteContents=function(){this.nativeRange.deleteContents();updateRangeProperties(this);};rangeProto.extractContents=function(){var frag=this.nativeRange.extractContents();updateRangeProperties(this);return frag;};}else{}body.removeChild(el);body=null;/*--------------------------------------------------------------------------------------------------------*/// Test for existence of createContextualFragment and delegate to it if it exists
	if(util.isHostMethod(range,"createContextualFragment")){rangeProto.createContextualFragment=function(fragmentStr){return this.nativeRange.createContextualFragment(fragmentStr);};}/*--------------------------------------------------------------------------------------------------------*/// Clean up
	getBody(document).removeChild(testTextNode);rangeProto.getName=function(){return"WrappedRange";};api.WrappedRange=WrappedRange;api.createNativeRange=function(doc){doc=getContentDocument(doc,module,"createNativeRange");return doc.createRange();};})();}if(api.features.implementsTextRange){/*
	            This is a workaround for a bug where IE returns the wrong container element from the TextRange's parentElement()
	            method. For example, in the following (where pipes denote the selection boundaries):
	
	            <ul id="ul"><li id="a">| a </li><li id="b"> b |</li></ul>
	
	            var range = document.selection.createRange();
	            alert(range.parentElement().id); // Should alert "ul" but alerts "b"
	
	            This method returns the common ancestor node of the following:
	            - the parentElement() of the textRange
	            - the parentElement() of the textRange after calling collapse(true)
	            - the parentElement() of the textRange after calling collapse(false)
	            */var getTextRangeContainerElement=function getTextRangeContainerElement(textRange){var parentEl=textRange.parentElement();var range=textRange.duplicate();range.collapse(true);var startEl=range.parentElement();range=textRange.duplicate();range.collapse(false);var endEl=range.parentElement();var startEndContainer=startEl==endEl?startEl:dom.getCommonAncestor(startEl,endEl);return startEndContainer==parentEl?startEndContainer:dom.getCommonAncestor(parentEl,startEndContainer);};var textRangeIsCollapsed=function textRangeIsCollapsed(textRange){return textRange.compareEndPoints("StartToEnd",textRange)==0;};// Gets the boundary of a TextRange expressed as a node and an offset within that node. This function started
	// out as an improved version of code found in Tim Cameron Ryan's IERange (http://code.google.com/p/ierange/)
	// but has grown, fixing problems with line breaks in preformatted text, adding workaround for IE TextRange
	// bugs, handling for inputs and images, plus optimizations.
	var getTextRangeBoundaryPosition=function getTextRangeBoundaryPosition(textRange,wholeRangeContainerElement,isStart,isCollapsed,startInfo){var workingRange=textRange.duplicate();workingRange.collapse(isStart);var containerElement=workingRange.parentElement();// Sometimes collapsing a TextRange that's at the start of a text node can move it into the previous node, so
	// check for that
	if(!dom.isOrIsAncestorOf(wholeRangeContainerElement,containerElement)){containerElement=wholeRangeContainerElement;}// Deal with nodes that cannot "contain rich HTML markup". In practice, this means form inputs, images and
	// similar. See http://msdn.microsoft.com/en-us/library/aa703950%28VS.85%29.aspx
	if(!containerElement.canHaveHTML){var pos=new DomPosition(containerElement.parentNode,dom.getNodeIndex(containerElement));return{boundaryPosition:pos,nodeInfo:{nodeIndex:pos.offset,containerElement:pos.node}};}var workingNode=dom.getDocument(containerElement).createElement("span");// Workaround for HTML5 Shiv's insane violation of document.createElement(). See Rangy issue 104 and HTML5
	// Shiv issue 64: https://github.com/aFarkas/html5shiv/issues/64
	if(workingNode.parentNode){dom.removeNode(workingNode);}var comparison,workingComparisonType=isStart?"StartToStart":"StartToEnd";var previousNode,nextNode,boundaryPosition,boundaryNode;var start=startInfo&&startInfo.containerElement==containerElement?startInfo.nodeIndex:0;var childNodeCount=containerElement.childNodes.length;var end=childNodeCount;// Check end first. Code within the loop assumes that the endth child node of the container is definitely
	// after the range boundary.
	var nodeIndex=end;while(true){if(nodeIndex==childNodeCount){containerElement.appendChild(workingNode);}else{containerElement.insertBefore(workingNode,containerElement.childNodes[nodeIndex]);}workingRange.moveToElementText(workingNode);comparison=workingRange.compareEndPoints(workingComparisonType,textRange);if(comparison==0||start==end){break;}else if(comparison==-1){if(end==start+1){// We know the endth child node is after the range boundary, so we must be done.
	break;}else{start=nodeIndex;}}else{end=end==start+1?start:nodeIndex;}nodeIndex=Math.floor((start+end)/2);containerElement.removeChild(workingNode);}// We've now reached or gone past the boundary of the text range we're interested in
	// so have identified the node we want
	boundaryNode=workingNode.nextSibling;if(comparison==-1&&boundaryNode&&isCharacterDataNode(boundaryNode)){// This is a character data node (text, comment, cdata). The working range is collapsed at the start of
	// the node containing the text range's boundary, so we move the end of the working range to the
	// boundary point and measure the length of its text to get the boundary's offset within the node.
	workingRange.setEndPoint(isStart?"EndToStart":"EndToEnd",textRange);var offset;if(/[\r\n]/.test(boundaryNode.data)){/*
	                        For the particular case of a boundary within a text node containing rendered line breaks (within a
	                        <pre> element, for example), we need a slightly complicated approach to get the boundary's offset in
	                        IE. The facts:
	
	                        - Each line break is represented as \r in the text node's data/nodeValue properties
	                        - Each line break is represented as \r\n in the TextRange's 'text' property
	                        - The 'text' property of the TextRange does not contain trailing line breaks
	
	                        To get round the problem presented by the final fact above, we can use the fact that TextRange's
	                        moveStart() and moveEnd() methods return the actual number of characters moved, which is not
	                        necessarily the same as the number of characters it was instructed to move. The simplest approach is
	                        to use this to store the characters moved when moving both the start and end of the range to the
	                        start of the document body and subtracting the start offset from the end offset (the
	                        "move-negative-gazillion" method). However, this is extremely slow when the document is large and
	                        the range is near the end of it. Clearly doing the mirror image (i.e. moving the range boundaries to
	                        the end of the document) has the same problem.
	
	                        Another approach that works is to use moveStart() to move the start boundary of the range up to the
	                        end boundary one character at a time and incrementing a counter with the value returned by the
	                        moveStart() call. However, the check for whether the start boundary has reached the end boundary is
	                        expensive, so this method is slow (although unlike "move-negative-gazillion" is largely unaffected
	                        by the location of the range within the document).
	
	                        The approach used below is a hybrid of the two methods above. It uses the fact that a string
	                        containing the TextRange's 'text' property with each \r\n converted to a single \r character cannot
	                        be longer than the text of the TextRange, so the start of the range is moved that length initially
	                        and then a character at a time to make up for any trailing line breaks not contained in the 'text'
	                        property. This has good performance in most situations compared to the previous two methods.
	                        */var tempRange=workingRange.duplicate();var rangeLength=tempRange.text.replace(/\r\n/g,"\r").length;offset=tempRange.moveStart("character",rangeLength);while((comparison=tempRange.compareEndPoints("StartToEnd",tempRange))==-1){offset++;tempRange.moveStart("character",1);}}else{offset=workingRange.text.length;}boundaryPosition=new DomPosition(boundaryNode,offset);}else{// If the boundary immediately follows a character data node and this is the end boundary, we should favour
	// a position within that, and likewise for a start boundary preceding a character data node
	previousNode=(isCollapsed||!isStart)&&workingNode.previousSibling;nextNode=(isCollapsed||isStart)&&workingNode.nextSibling;if(nextNode&&isCharacterDataNode(nextNode)){boundaryPosition=new DomPosition(nextNode,0);}else if(previousNode&&isCharacterDataNode(previousNode)){boundaryPosition=new DomPosition(previousNode,previousNode.data.length);}else{boundaryPosition=new DomPosition(containerElement,dom.getNodeIndex(workingNode));}}// Clean up
	dom.removeNode(workingNode);return{boundaryPosition:boundaryPosition,nodeInfo:{nodeIndex:nodeIndex,containerElement:containerElement}};};// Returns a TextRange representing the boundary of a TextRange expressed as a node and an offset within that
	// node. This function started out as an optimized version of code found in Tim Cameron Ryan's IERange
	// (http://code.google.com/p/ierange/)
	var createBoundaryTextRange=function createBoundaryTextRange(boundaryPosition,isStart){var boundaryNode,boundaryParent,boundaryOffset=boundaryPosition.offset;var doc=dom.getDocument(boundaryPosition.node);var workingNode,childNodes,workingRange=getBody(doc).createTextRange();var nodeIsDataNode=isCharacterDataNode(boundaryPosition.node);if(nodeIsDataNode){boundaryNode=boundaryPosition.node;boundaryParent=boundaryNode.parentNode;}else{childNodes=boundaryPosition.node.childNodes;boundaryNode=boundaryOffset<childNodes.length?childNodes[boundaryOffset]:null;boundaryParent=boundaryPosition.node;}// Position the range immediately before the node containing the boundary
	workingNode=doc.createElement("span");// Making the working element non-empty element persuades IE to consider the TextRange boundary to be within
	// the element rather than immediately before or after it
	workingNode.innerHTML="&#feff;";// insertBefore is supposed to work like appendChild if the second parameter is null. However, a bug report
	// for IERange suggests that it can crash the browser: http://code.google.com/p/ierange/issues/detail?id=12
	if(boundaryNode){boundaryParent.insertBefore(workingNode,boundaryNode);}else{boundaryParent.appendChild(workingNode);}workingRange.moveToElementText(workingNode);workingRange.collapse(!isStart);// Clean up
	boundaryParent.removeChild(workingNode);// Move the working range to the text offset, if required
	if(nodeIsDataNode){workingRange[isStart?"moveStart":"moveEnd"]("character",boundaryOffset);}return workingRange;};/*------------------------------------------------------------------------------------------------------------*/// This is a wrapper around a TextRange, providing full DOM Range functionality using rangy's DomRange as a
	// prototype
	WrappedTextRange=function WrappedTextRange(textRange){this.textRange=textRange;this.refresh();};WrappedTextRange.prototype=new DomRange(document);WrappedTextRange.prototype.refresh=function(){var start,end,startBoundary;// TextRange's parentElement() method cannot be trusted. getTextRangeContainerElement() works around that.
	var rangeContainerElement=getTextRangeContainerElement(this.textRange);if(textRangeIsCollapsed(this.textRange)){end=start=getTextRangeBoundaryPosition(this.textRange,rangeContainerElement,true,true).boundaryPosition;}else{startBoundary=getTextRangeBoundaryPosition(this.textRange,rangeContainerElement,true,false);start=startBoundary.boundaryPosition;// An optimization used here is that if the start and end boundaries have the same parent element, the
	// search scope for the end boundary can be limited to exclude the portion of the element that precedes
	// the start boundary
	end=getTextRangeBoundaryPosition(this.textRange,rangeContainerElement,false,false,startBoundary.nodeInfo).boundaryPosition;}this.setStart(start.node,start.offset);this.setEnd(end.node,end.offset);};WrappedTextRange.prototype.getName=function(){return"WrappedTextRange";};DomRange.copyComparisonConstants(WrappedTextRange);var rangeToTextRange=function rangeToTextRange(range){if(range.collapsed){return createBoundaryTextRange(new DomPosition(range.startContainer,range.startOffset),true);}else{var startRange=createBoundaryTextRange(new DomPosition(range.startContainer,range.startOffset),true);var endRange=createBoundaryTextRange(new DomPosition(range.endContainer,range.endOffset),false);var textRange=getBody(DomRange.getRangeDocument(range)).createTextRange();textRange.setEndPoint("StartToStart",startRange);textRange.setEndPoint("EndToEnd",endRange);return textRange;}};WrappedTextRange.rangeToTextRange=rangeToTextRange;WrappedTextRange.prototype.toTextRange=function(){return rangeToTextRange(this);};api.WrappedTextRange=WrappedTextRange;// IE 9 and above have both implementations and Rangy makes both available. The next few lines sets which
	// implementation to use by default.
	if(!api.features.implementsDomRange||api.config.preferTextRange){// Add WrappedTextRange as the Range property of the global object to allow expression like Range.END_TO_END to work
	var globalObj=function(f){return f("return this;")();}(Function);if(typeof globalObj.Range=="undefined"){globalObj.Range=WrappedTextRange;}api.createNativeRange=function(doc){doc=getContentDocument(doc,module,"createNativeRange");return getBody(doc).createTextRange();};api.WrappedRange=WrappedTextRange;}}api.createRange=function(doc){doc=getContentDocument(doc,module,"createRange");return new api.WrappedRange(api.createNativeRange(doc));};api.createRangyRange=function(doc){doc=getContentDocument(doc,module,"createRangyRange");return new DomRange(doc);};util.createAliasForDeprecatedMethod(api,"createIframeRange","createRange");util.createAliasForDeprecatedMethod(api,"createIframeRangyRange","createRangyRange");api.addShimListener(function(win){var doc=win.document;if(typeof doc.createRange=="undefined"){doc.createRange=function(){return api.createRange(doc);};}doc=win=null;});});/*----------------------------------------------------------------------------------------------------------------*/// This module creates a selection object wrapper that conforms as closely as possible to the Selection specification
	// in the HTML Editing spec (http://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#selections)
	api.createCoreModule("WrappedSelection",["DomRange","WrappedRange"],function(api,module){api.config.checkSelectionRanges=true;var BOOLEAN="boolean";var NUMBER="number";var dom=api.dom;var util=api.util;var isHostMethod=util.isHostMethod;var DomRange=api.DomRange;var WrappedRange=api.WrappedRange;var DOMException=api.DOMException;var DomPosition=dom.DomPosition;var getNativeSelection;var selectionIsCollapsed;var features=api.features;var CONTROL="Control";var getDocument=dom.getDocument;var getBody=dom.getBody;var rangesEqual=DomRange.rangesEqual;// Utility function to support direction parameters in the API that may be a string ("backward", "backwards",
	// "forward" or "forwards") or a Boolean (true for backwards).
	function isDirectionBackward(dir){return typeof dir=="string"?/^backward(s)?$/i.test(dir):!!dir;}function getWindow(win,methodName){if(!win){return window;}else if(dom.isWindow(win)){return win;}else if(win instanceof WrappedSelection){return win.win;}else{var doc=dom.getContentDocument(win,module,methodName);return dom.getWindow(doc);}}function getWinSelection(winParam){return getWindow(winParam,"getWinSelection").getSelection();}function getDocSelection(winParam){return getWindow(winParam,"getDocSelection").document.selection;}function winSelectionIsBackward(sel){var backward=false;if(sel.anchorNode){backward=dom.comparePoints(sel.anchorNode,sel.anchorOffset,sel.focusNode,sel.focusOffset)==1;}return backward;}// Test for the Range/TextRange and Selection features required
	// Test for ability to retrieve selection
	var implementsWinGetSelection=isHostMethod(window,"getSelection"),implementsDocSelection=util.isHostObject(document,"selection");features.implementsWinGetSelection=implementsWinGetSelection;features.implementsDocSelection=implementsDocSelection;var useDocumentSelection=implementsDocSelection&&(!implementsWinGetSelection||api.config.preferTextRange);if(useDocumentSelection){getNativeSelection=getDocSelection;api.isSelectionValid=function(winParam){var doc=getWindow(winParam,"isSelectionValid").document,nativeSel=doc.selection;// Check whether the selection TextRange is actually contained within the correct document
	return nativeSel.type!="None"||getDocument(nativeSel.createRange().parentElement())==doc;};}else if(implementsWinGetSelection){getNativeSelection=getWinSelection;api.isSelectionValid=function(){return true;};}else{module.fail("Neither document.selection or window.getSelection() detected.");return false;}api.getNativeSelection=getNativeSelection;var testSelection=getNativeSelection();// In Firefox, the selection is null in an iframe with display: none. See issue #138.
	if(!testSelection){module.fail("Native selection was null (possibly issue 138?)");return false;}var testRange=api.createNativeRange(document);var body=getBody(document);// Obtaining a range from a selection
	var selectionHasAnchorAndFocus=util.areHostProperties(testSelection,["anchorNode","focusNode","anchorOffset","focusOffset"]);features.selectionHasAnchorAndFocus=selectionHasAnchorAndFocus;// Test for existence of native selection extend() method
	var selectionHasExtend=isHostMethod(testSelection,"extend");features.selectionHasExtend=selectionHasExtend;// Test if rangeCount exists
	var selectionHasRangeCount=_typeof(testSelection.rangeCount)==NUMBER;features.selectionHasRangeCount=selectionHasRangeCount;var selectionSupportsMultipleRanges=false;var collapsedNonEditableSelectionsSupported=true;var addRangeBackwardToNative=selectionHasExtend?function(nativeSelection,range){var doc=DomRange.getRangeDocument(range);var endRange=api.createRange(doc);endRange.collapseToPoint(range.endContainer,range.endOffset);nativeSelection.addRange(getNativeRange(endRange));nativeSelection.extend(range.startContainer,range.startOffset);}:null;if(util.areHostMethods(testSelection,["addRange","getRangeAt","removeAllRanges"])&&_typeof(testSelection.rangeCount)==NUMBER&&features.implementsDomRange){(function(){// Previously an iframe was used but this caused problems in some circumstances in IE, so tests are
	// performed on the current document's selection. See issue 109.
	// Note also that if a selection previously existed, it is wiped and later restored by these tests. This
	// will result in the selection direction begin reversed if the original selection was backwards and the
	// browser does not support setting backwards selections (Internet Explorer, I'm looking at you).
	var sel=window.getSelection();if(sel){// Store the current selection
	var originalSelectionRangeCount=sel.rangeCount;var selectionHasMultipleRanges=originalSelectionRangeCount>1;var originalSelectionRanges=[];var originalSelectionBackward=winSelectionIsBackward(sel);for(var i=0;i<originalSelectionRangeCount;++i){originalSelectionRanges[i]=sel.getRangeAt(i);}// Create some test elements
	var testEl=dom.createTestElement(document,"",false);var textNode=testEl.appendChild(document.createTextNode("\xA0\xA0\xA0"));// Test whether the native selection will allow a collapsed selection within a non-editable element
	var r1=document.createRange();r1.setStart(textNode,1);r1.collapse(true);sel.removeAllRanges();sel.addRange(r1);collapsedNonEditableSelectionsSupported=sel.rangeCount==1;sel.removeAllRanges();// Test whether the native selection is capable of supporting multiple ranges.
	if(!selectionHasMultipleRanges){// Doing the original feature test here in Chrome 36 (and presumably later versions) prints a
	// console error of "Discontiguous selection is not supported." that cannot be suppressed. There's
	// nothing we can do about this while retaining the feature test so we have to resort to a browser
	// sniff. I'm not happy about it. See
	// https://code.google.com/p/chromium/issues/detail?id=399791
	var chromeMatch=window.navigator.appVersion.match(/Chrome\/(.*?) /);if(chromeMatch&&parseInt(chromeMatch[1])>=36){selectionSupportsMultipleRanges=false;}else{var r2=r1.cloneRange();r1.setStart(textNode,0);r2.setEnd(textNode,3);r2.setStart(textNode,2);sel.addRange(r1);sel.addRange(r2);selectionSupportsMultipleRanges=sel.rangeCount==2;}}// Clean up
	dom.removeNode(testEl);sel.removeAllRanges();for(i=0;i<originalSelectionRangeCount;++i){if(i==0&&originalSelectionBackward){if(addRangeBackwardToNative){addRangeBackwardToNative(sel,originalSelectionRanges[i]);}else{api.warn("Rangy initialization: original selection was backwards but selection has been restored forwards because the browser does not support Selection.extend");sel.addRange(originalSelectionRanges[i]);}}else{sel.addRange(originalSelectionRanges[i]);}}}})();}features.selectionSupportsMultipleRanges=selectionSupportsMultipleRanges;features.collapsedNonEditableSelectionsSupported=collapsedNonEditableSelectionsSupported;// ControlRanges
	var implementsControlRange=false,testControlRange;if(body&&isHostMethod(body,"createControlRange")){testControlRange=body.createControlRange();if(util.areHostProperties(testControlRange,["item","add"])){implementsControlRange=true;}}features.implementsControlRange=implementsControlRange;// Selection collapsedness
	if(selectionHasAnchorAndFocus){selectionIsCollapsed=function selectionIsCollapsed(sel){return sel.anchorNode===sel.focusNode&&sel.anchorOffset===sel.focusOffset;};}else{selectionIsCollapsed=function selectionIsCollapsed(sel){return sel.rangeCount?sel.getRangeAt(sel.rangeCount-1).collapsed:false;};}function updateAnchorAndFocusFromRange(sel,range,backward){var anchorPrefix=backward?"end":"start",focusPrefix=backward?"start":"end";sel.anchorNode=range[anchorPrefix+"Container"];sel.anchorOffset=range[anchorPrefix+"Offset"];sel.focusNode=range[focusPrefix+"Container"];sel.focusOffset=range[focusPrefix+"Offset"];}function updateAnchorAndFocusFromNativeSelection(sel){var nativeSel=sel.nativeSelection;sel.anchorNode=nativeSel.anchorNode;sel.anchorOffset=nativeSel.anchorOffset;sel.focusNode=nativeSel.focusNode;sel.focusOffset=nativeSel.focusOffset;}function updateEmptySelection(sel){sel.anchorNode=sel.focusNode=null;sel.anchorOffset=sel.focusOffset=0;sel.rangeCount=0;sel.isCollapsed=true;sel._ranges.length=0;}function getNativeRange(range){var nativeRange;if(range instanceof DomRange){nativeRange=api.createNativeRange(range.getDocument());nativeRange.setEnd(range.endContainer,range.endOffset);nativeRange.setStart(range.startContainer,range.startOffset);}else if(range instanceof WrappedRange){nativeRange=range.nativeRange;}else if(features.implementsDomRange&&range instanceof dom.getWindow(range.startContainer).Range){nativeRange=range;}return nativeRange;}function rangeContainsSingleElement(rangeNodes){if(!rangeNodes.length||rangeNodes[0].nodeType!=1){return false;}for(var i=1,len=rangeNodes.length;i<len;++i){if(!dom.isAncestorOf(rangeNodes[0],rangeNodes[i])){return false;}}return true;}function getSingleElementFromRange(range){var nodes=range.getNodes();if(!rangeContainsSingleElement(nodes)){throw module.createError("getSingleElementFromRange: range "+range.inspect()+" did not consist of a single element");}return nodes[0];}// Simple, quick test which only needs to distinguish between a TextRange and a ControlRange
	function isTextRange(range){return!!range&&typeof range.text!="undefined";}function updateFromTextRange(sel,range){// Create a Range from the selected TextRange
	var wrappedRange=new WrappedRange(range);sel._ranges=[wrappedRange];updateAnchorAndFocusFromRange(sel,wrappedRange,false);sel.rangeCount=1;sel.isCollapsed=wrappedRange.collapsed;}function updateControlSelection(sel){// Update the wrapped selection based on what's now in the native selection
	sel._ranges.length=0;if(sel.docSelection.type=="None"){updateEmptySelection(sel);}else{var controlRange=sel.docSelection.createRange();if(isTextRange(controlRange)){// This case (where the selection type is "Control" and calling createRange() on the selection returns
	// a TextRange) can happen in IE 9. It happens, for example, when all elements in the selected
	// ControlRange have been removed from the ControlRange and removed from the document.
	updateFromTextRange(sel,controlRange);}else{sel.rangeCount=controlRange.length;var range,doc=getDocument(controlRange.item(0));for(var i=0;i<sel.rangeCount;++i){range=api.createRange(doc);range.selectNode(controlRange.item(i));sel._ranges.push(range);}sel.isCollapsed=sel.rangeCount==1&&sel._ranges[0].collapsed;updateAnchorAndFocusFromRange(sel,sel._ranges[sel.rangeCount-1],false);}}}function addRangeToControlSelection(sel,range){var controlRange=sel.docSelection.createRange();var rangeElement=getSingleElementFromRange(range);// Create a new ControlRange containing all the elements in the selected ControlRange plus the element
	// contained by the supplied range
	var doc=getDocument(controlRange.item(0));var newControlRange=getBody(doc).createControlRange();for(var i=0,len=controlRange.length;i<len;++i){newControlRange.add(controlRange.item(i));}try{newControlRange.add(rangeElement);}catch(ex){throw module.createError("addRange(): Element within the specified Range could not be added to control selection (does it have layout?)");}newControlRange.select();// Update the wrapped selection based on what's now in the native selection
	updateControlSelection(sel);}var getSelectionRangeAt;if(isHostMethod(testSelection,"getRangeAt")){// try/catch is present because getRangeAt() must have thrown an error in some browser and some situation.
	// Unfortunately, I didn't write a comment about the specifics and am now scared to take it out. Let that be a
	// lesson to us all, especially me.
	getSelectionRangeAt=function getSelectionRangeAt(sel,index){try{return sel.getRangeAt(index);}catch(ex){return null;}};}else if(selectionHasAnchorAndFocus){getSelectionRangeAt=function getSelectionRangeAt(sel){var doc=getDocument(sel.anchorNode);var range=api.createRange(doc);range.setStartAndEnd(sel.anchorNode,sel.anchorOffset,sel.focusNode,sel.focusOffset);// Handle the case when the selection was selected backwards (from the end to the start in the
	// document)
	if(range.collapsed!==this.isCollapsed){range.setStartAndEnd(sel.focusNode,sel.focusOffset,sel.anchorNode,sel.anchorOffset);}return range;};}function WrappedSelection(selection,docSelection,win){this.nativeSelection=selection;this.docSelection=docSelection;this._ranges=[];this.win=win;this.refresh();}WrappedSelection.prototype=api.selectionPrototype;function deleteProperties(sel){sel.win=sel.anchorNode=sel.focusNode=sel._ranges=null;sel.rangeCount=sel.anchorOffset=sel.focusOffset=0;sel.detached=true;}var cachedRangySelections=[];function actOnCachedSelection(win,action){var i=cachedRangySelections.length,cached,sel;while(i--){cached=cachedRangySelections[i];sel=cached.selection;if(action=="deleteAll"){deleteProperties(sel);}else if(cached.win==win){if(action=="delete"){cachedRangySelections.splice(i,1);return true;}else{return sel;}}}if(action=="deleteAll"){cachedRangySelections.length=0;}return null;}var getSelection=function getSelection(win){// Check if the parameter is a Rangy Selection object
	if(win&&win instanceof WrappedSelection){win.refresh();return win;}win=getWindow(win,"getNativeSelection");var sel=actOnCachedSelection(win);var nativeSel=getNativeSelection(win),docSel=implementsDocSelection?getDocSelection(win):null;if(sel){sel.nativeSelection=nativeSel;sel.docSelection=docSel;sel.refresh();}else{sel=new WrappedSelection(nativeSel,docSel,win);cachedRangySelections.push({win:win,selection:sel});}return sel;};api.getSelection=getSelection;util.createAliasForDeprecatedMethod(api,"getIframeSelection","getSelection");var selProto=WrappedSelection.prototype;function createControlSelection(sel,ranges){// Ensure that the selection becomes of type "Control"
	var doc=getDocument(ranges[0].startContainer);var controlRange=getBody(doc).createControlRange();for(var i=0,el,len=ranges.length;i<len;++i){el=getSingleElementFromRange(ranges[i]);try{controlRange.add(el);}catch(ex){throw module.createError("setRanges(): Element within one of the specified Ranges could not be added to control selection (does it have layout?)");}}controlRange.select();// Update the wrapped selection based on what's now in the native selection
	updateControlSelection(sel);}// Selecting a range
	if(!useDocumentSelection&&selectionHasAnchorAndFocus&&util.areHostMethods(testSelection,["removeAllRanges","addRange"])){selProto.removeAllRanges=function(){this.nativeSelection.removeAllRanges();updateEmptySelection(this);};var addRangeBackward=function addRangeBackward(sel,range){addRangeBackwardToNative(sel.nativeSelection,range);sel.refresh();};if(selectionHasRangeCount){selProto.addRange=function(range,direction){if(implementsControlRange&&implementsDocSelection&&this.docSelection.type==CONTROL){addRangeToControlSelection(this,range);}else{if(isDirectionBackward(direction)&&selectionHasExtend){addRangeBackward(this,range);}else{var previousRangeCount;if(selectionSupportsMultipleRanges){previousRangeCount=this.rangeCount;}else{this.removeAllRanges();previousRangeCount=0;}// Clone the native range so that changing the selected range does not affect the selection.
	// This is contrary to the spec but is the only way to achieve consistency between browsers. See
	// issue 80.
	var clonedNativeRange=getNativeRange(range).cloneRange();try{this.nativeSelection.addRange(clonedNativeRange);}catch(ex){}// Check whether adding the range was successful
	this.rangeCount=this.nativeSelection.rangeCount;if(this.rangeCount==previousRangeCount+1){// The range was added successfully
	// Check whether the range that we added to the selection is reflected in the last range extracted from
	// the selection
	if(api.config.checkSelectionRanges){var nativeRange=getSelectionRangeAt(this.nativeSelection,this.rangeCount-1);if(nativeRange&&!rangesEqual(nativeRange,range)){// Happens in WebKit with, for example, a selection placed at the start of a text node
	range=new WrappedRange(nativeRange);}}this._ranges[this.rangeCount-1]=range;updateAnchorAndFocusFromRange(this,range,selectionIsBackward(this.nativeSelection));this.isCollapsed=selectionIsCollapsed(this);}else{// The range was not added successfully. The simplest thing is to refresh
	this.refresh();}}}};}else{selProto.addRange=function(range,direction){if(isDirectionBackward(direction)&&selectionHasExtend){addRangeBackward(this,range);}else{this.nativeSelection.addRange(getNativeRange(range));this.refresh();}};}selProto.setRanges=function(ranges){if(implementsControlRange&&implementsDocSelection&&ranges.length>1){createControlSelection(this,ranges);}else{this.removeAllRanges();for(var i=0,len=ranges.length;i<len;++i){this.addRange(ranges[i]);}}};}else if(isHostMethod(testSelection,"empty")&&isHostMethod(testRange,"select")&&implementsControlRange&&useDocumentSelection){selProto.removeAllRanges=function(){// Added try/catch as fix for issue #21
	try{this.docSelection.empty();// Check for empty() not working (issue #24)
	if(this.docSelection.type!="None"){// Work around failure to empty a control selection by instead selecting a TextRange and then
	// calling empty()
	var doc;if(this.anchorNode){doc=getDocument(this.anchorNode);}else if(this.docSelection.type==CONTROL){var controlRange=this.docSelection.createRange();if(controlRange.length){doc=getDocument(controlRange.item(0));}}if(doc){var textRange=getBody(doc).createTextRange();textRange.select();this.docSelection.empty();}}}catch(ex){}updateEmptySelection(this);};selProto.addRange=function(range){if(this.docSelection.type==CONTROL){addRangeToControlSelection(this,range);}else{api.WrappedTextRange.rangeToTextRange(range).select();this._ranges[0]=range;this.rangeCount=1;this.isCollapsed=this._ranges[0].collapsed;updateAnchorAndFocusFromRange(this,range,false);}};selProto.setRanges=function(ranges){this.removeAllRanges();var rangeCount=ranges.length;if(rangeCount>1){createControlSelection(this,ranges);}else if(rangeCount){this.addRange(ranges[0]);}};}else{module.fail("No means of selecting a Range or TextRange was found");return false;}selProto.getRangeAt=function(index){if(index<0||index>=this.rangeCount){throw new DOMException("INDEX_SIZE_ERR");}else{// Clone the range to preserve selection-range independence. See issue 80.
	return this._ranges[index].cloneRange();}};var refreshSelection;if(useDocumentSelection){refreshSelection=function refreshSelection(sel){var range;if(api.isSelectionValid(sel.win)){range=sel.docSelection.createRange();}else{range=getBody(sel.win.document).createTextRange();range.collapse(true);}if(sel.docSelection.type==CONTROL){updateControlSelection(sel);}else if(isTextRange(range)){updateFromTextRange(sel,range);}else{updateEmptySelection(sel);}};}else if(isHostMethod(testSelection,"getRangeAt")&&_typeof(testSelection.rangeCount)==NUMBER){refreshSelection=function refreshSelection(sel){if(implementsControlRange&&implementsDocSelection&&sel.docSelection.type==CONTROL){updateControlSelection(sel);}else{sel._ranges.length=sel.rangeCount=sel.nativeSelection.rangeCount;if(sel.rangeCount){for(var i=0,len=sel.rangeCount;i<len;++i){sel._ranges[i]=new api.WrappedRange(sel.nativeSelection.getRangeAt(i));}updateAnchorAndFocusFromRange(sel,sel._ranges[sel.rangeCount-1],selectionIsBackward(sel.nativeSelection));sel.isCollapsed=selectionIsCollapsed(sel);}else{updateEmptySelection(sel);}}};}else if(selectionHasAnchorAndFocus&&_typeof(testSelection.isCollapsed)==BOOLEAN&&_typeof(testRange.collapsed)==BOOLEAN&&features.implementsDomRange){refreshSelection=function refreshSelection(sel){var range,nativeSel=sel.nativeSelection;if(nativeSel.anchorNode){range=getSelectionRangeAt(nativeSel,0);sel._ranges=[range];sel.rangeCount=1;updateAnchorAndFocusFromNativeSelection(sel);sel.isCollapsed=selectionIsCollapsed(sel);}else{updateEmptySelection(sel);}};}else{module.fail("No means of obtaining a Range or TextRange from the user's selection was found");return false;}selProto.refresh=function(checkForChanges){var oldRanges=checkForChanges?this._ranges.slice(0):null;var oldAnchorNode=this.anchorNode,oldAnchorOffset=this.anchorOffset;refreshSelection(this);if(checkForChanges){// Check the range count first
	var i=oldRanges.length;if(i!=this._ranges.length){return true;}// Now check the direction. Checking the anchor position is the same is enough since we're checking all the
	// ranges after this
	if(this.anchorNode!=oldAnchorNode||this.anchorOffset!=oldAnchorOffset){return true;}// Finally, compare each range in turn
	while(i--){if(!rangesEqual(oldRanges[i],this._ranges[i])){return true;}}return false;}};// Removal of a single range
	var removeRangeManually=function removeRangeManually(sel,range){var ranges=sel.getAllRanges();sel.removeAllRanges();for(var i=0,len=ranges.length;i<len;++i){if(!rangesEqual(range,ranges[i])){sel.addRange(ranges[i]);}}if(!sel.rangeCount){updateEmptySelection(sel);}};if(implementsControlRange&&implementsDocSelection){selProto.removeRange=function(range){if(this.docSelection.type==CONTROL){var controlRange=this.docSelection.createRange();var rangeElement=getSingleElementFromRange(range);// Create a new ControlRange containing all the elements in the selected ControlRange minus the
	// element contained by the supplied range
	var doc=getDocument(controlRange.item(0));var newControlRange=getBody(doc).createControlRange();var el,removed=false;for(var i=0,len=controlRange.length;i<len;++i){el=controlRange.item(i);if(el!==rangeElement||removed){newControlRange.add(controlRange.item(i));}else{removed=true;}}newControlRange.select();// Update the wrapped selection based on what's now in the native selection
	updateControlSelection(this);}else{removeRangeManually(this,range);}};}else{selProto.removeRange=function(range){removeRangeManually(this,range);};}// Detecting if a selection is backward
	var selectionIsBackward;if(!useDocumentSelection&&selectionHasAnchorAndFocus&&features.implementsDomRange){selectionIsBackward=winSelectionIsBackward;selProto.isBackward=function(){return selectionIsBackward(this);};}else{selectionIsBackward=selProto.isBackward=function(){return false;};}// Create an alias for backwards compatibility. From 1.3, everything is "backward" rather than "backwards"
	selProto.isBackwards=selProto.isBackward;// Selection stringifier
	// This is conformant to the old HTML5 selections draft spec but differs from WebKit and Mozilla's implementation.
	// The current spec does not yet define this method.
	selProto.toString=function(){var rangeTexts=[];for(var i=0,len=this.rangeCount;i<len;++i){rangeTexts[i]=""+this._ranges[i];}return rangeTexts.join("");};function assertNodeInSameDocument(sel,node){if(sel.win.document!=getDocument(node)){throw new DOMException("WRONG_DOCUMENT_ERR");}}// No current browser conforms fully to the spec for this method, so Rangy's own method is always used
	selProto.collapse=function(node,offset){assertNodeInSameDocument(this,node);var range=api.createRange(node);range.collapseToPoint(node,offset);this.setSingleRange(range);this.isCollapsed=true;};selProto.collapseToStart=function(){if(this.rangeCount){var range=this._ranges[0];this.collapse(range.startContainer,range.startOffset);}else{throw new DOMException("INVALID_STATE_ERR");}};selProto.collapseToEnd=function(){if(this.rangeCount){var range=this._ranges[this.rangeCount-1];this.collapse(range.endContainer,range.endOffset);}else{throw new DOMException("INVALID_STATE_ERR");}};// The spec is very specific on how selectAllChildren should be implemented and not all browsers implement it as
	// specified so the native implementation is never used by Rangy.
	selProto.selectAllChildren=function(node){assertNodeInSameDocument(this,node);var range=api.createRange(node);range.selectNodeContents(node);this.setSingleRange(range);};selProto.deleteFromDocument=function(){// Sepcial behaviour required for IE's control selections
	if(implementsControlRange&&implementsDocSelection&&this.docSelection.type==CONTROL){var controlRange=this.docSelection.createRange();var element;while(controlRange.length){element=controlRange.item(0);controlRange.remove(element);dom.removeNode(element);}this.refresh();}else if(this.rangeCount){var ranges=this.getAllRanges();if(ranges.length){this.removeAllRanges();for(var i=0,len=ranges.length;i<len;++i){ranges[i].deleteContents();}// The spec says nothing about what the selection should contain after calling deleteContents on each
	// range. Firefox moves the selection to where the final selected range was, so we emulate that
	this.addRange(ranges[len-1]);}}};// The following are non-standard extensions
	selProto.eachRange=function(func,returnValue){for(var i=0,len=this._ranges.length;i<len;++i){if(func(this.getRangeAt(i))){return returnValue;}}};selProto.getAllRanges=function(){var ranges=[];this.eachRange(function(range){ranges.push(range);});return ranges;};selProto.setSingleRange=function(range,direction){this.removeAllRanges();this.addRange(range,direction);};selProto.callMethodOnEachRange=function(methodName,params){var results=[];this.eachRange(function(range){results.push(range[methodName].apply(range,params||[]));});return results;};function createStartOrEndSetter(isStart){return function(node,offset){var range;if(this.rangeCount){range=this.getRangeAt(0);range["set"+(isStart?"Start":"End")](node,offset);}else{range=api.createRange(this.win.document);range.setStartAndEnd(node,offset);}this.setSingleRange(range,this.isBackward());};}selProto.setStart=createStartOrEndSetter(true);selProto.setEnd=createStartOrEndSetter(false);// Add select() method to Range prototype. Any existing selection will be removed.
	api.rangePrototype.select=function(direction){getSelection(this.getDocument()).setSingleRange(this,direction);};selProto.changeEachRange=function(func){var ranges=[];var backward=this.isBackward();this.eachRange(function(range){func(range);ranges.push(range);});this.removeAllRanges();if(backward&&ranges.length==1){this.addRange(ranges[0],"backward");}else{this.setRanges(ranges);}};selProto.containsNode=function(node,allowPartial){return this.eachRange(function(range){return range.containsNode(node,allowPartial);},true)||false;};selProto.getBookmark=function(containerNode){return{backward:this.isBackward(),rangeBookmarks:this.callMethodOnEachRange("getBookmark",[containerNode])};};selProto.moveToBookmark=function(bookmark){var selRanges=[];for(var i=0,rangeBookmark,range;rangeBookmark=bookmark.rangeBookmarks[i++];){range=api.createRange(this.win);range.moveToBookmark(rangeBookmark);selRanges.push(range);}if(bookmark.backward){this.setSingleRange(selRanges[0],"backward");}else{this.setRanges(selRanges);}};selProto.saveRanges=function(){return{backward:this.isBackward(),ranges:this.callMethodOnEachRange("cloneRange")};};selProto.restoreRanges=function(selRanges){this.removeAllRanges();for(var i=0,range;range=selRanges.ranges[i];++i){this.addRange(range,selRanges.backward&&i==0);}};selProto.toHtml=function(){var rangeHtmls=[];this.eachRange(function(range){rangeHtmls.push(DomRange.toHtml(range));});return rangeHtmls.join("");};if(features.implementsTextRange){selProto.getNativeTextRange=function(){var sel,textRange;if(sel=this.docSelection){var range=sel.createRange();if(isTextRange(range)){return range;}else{throw module.createError("getNativeTextRange: selection is a control selection");}}else if(this.rangeCount>0){return api.WrappedTextRange.rangeToTextRange(this.getRangeAt(0));}else{throw module.createError("getNativeTextRange: selection contains no range");}};}function inspect(sel){var rangeInspects=[];var anchor=new DomPosition(sel.anchorNode,sel.anchorOffset);var focus=new DomPosition(sel.focusNode,sel.focusOffset);var name=typeof sel.getName=="function"?sel.getName():"Selection";if(typeof sel.rangeCount!="undefined"){for(var i=0,len=sel.rangeCount;i<len;++i){rangeInspects[i]=DomRange.inspect(sel.getRangeAt(i));}}return"["+name+"(Ranges: "+rangeInspects.join(", ")+")(anchor: "+anchor.inspect()+", focus: "+focus.inspect()+"]";}selProto.getName=function(){return"WrappedSelection";};selProto.inspect=function(){return inspect(this);};selProto.detach=function(){actOnCachedSelection(this.win,"delete");deleteProperties(this);};WrappedSelection.detachAll=function(){actOnCachedSelection(null,"deleteAll");};WrappedSelection.inspect=inspect;WrappedSelection.isDirectionBackward=isDirectionBackward;api.Selection=WrappedSelection;api.selectionPrototype=selProto;api.addShimListener(function(win){if(typeof win.getSelection=="undefined"){win.getSelection=function(){return getSelection(win);};}win=null;});});/*----------------------------------------------------------------------------------------------------------------*/// Wait for document to load before initializing
	var docReady=false;var loadHandler=function loadHandler(e){if(!docReady){docReady=true;if(!api.initialized&&api.config.autoInitialize){init();}}};if(isBrowser){// Test whether the document has already been loaded and initialize immediately if so
	if(document.readyState=="complete"){loadHandler();}else{if(isHostMethod(document,"addEventListener")){document.addEventListener("DOMContentLoaded",loadHandler,false);}// Add a fallback in case the DOMContentLoaded event isn't supported
	addListener(window,"load",loadHandler);}}return api;},undefined);

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Collections of stubs, spies and mocks.
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2013 Christian Johansen
	 */
	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var sinon = __webpack_require__(21);
	var sinonSpy = __webpack_require__(20);
	var walk = __webpack_require__(24);
	var getPropertyDescriptor = __webpack_require__(16);
	var valueToString = __webpack_require__(7);
	
	var push = [].push;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function getFakes(fakeCollection) {
	    if (!fakeCollection.fakes) {
	        fakeCollection.fakes = [];
	    }
	
	    return fakeCollection.fakes;
	}
	
	function each(fakeCollection, method) {
	    var fakes = getFakes(fakeCollection);
	
	    for (var i = 0, l = fakes.length; i < l; i += 1) {
	        if (typeof fakes[i][method] === "function") {
	            fakes[i][method]();
	        }
	    }
	}
	
	function compact(fakeCollection) {
	    var fakes = getFakes(fakeCollection);
	    var i = 0;
	    while (i < fakes.length) {
	        fakes.splice(i, 1);
	    }
	}
	
	var collection = {
	    verify: function verify() {
	        each(this, "verify");
	    },
	
	    restore: function restore() {
	        each(this, "restore");
	        compact(this);
	    },
	
	    reset: function reset() {
	        each(this, "reset");
	    },
	
	    resetBehavior: function resetBehavior() {
	        each(this, "resetBehavior");
	    },
	
	    resetHistory: function resetHistory() {
	        each(this, "resetHistory");
	    },
	
	    verifyAndRestore: function verifyAndRestore() {
	        var exception;
	
	        try {
	            this.verify();
	        } catch (e) {
	            exception = e;
	        }
	
	        this.restore();
	
	        if (exception) {
	            throw exception;
	        }
	    },
	
	    add: function add(fake) {
	        push.call(getFakes(this), fake);
	        return fake;
	    },
	
	    spy: function spy() {
	        return this.add(sinonSpy.apply(sinonSpy, arguments));
	    },
	
	    stub: function stub(object, property, value) {
	        if (property) {
	            if (!object) {
	                var type = object === null ? "null" : "undefined";
	                throw new Error("Trying to stub property '" + valueToString(property) + "' of " + type);
	            }
	
	            var original = object[property];
	
	            if (typeof original !== "function") {
	                if (!hasOwnProperty.call(object, property)) {
	                    throw new TypeError("Cannot stub non-existent own property " + valueToString(property));
	                }
	
	                object[property] = value;
	
	                return this.add({
	                    restore: function restore() {
	                        object[property] = original;
	                    }
	                });
	            }
	        }
	        if (!property && !!object && (typeof object === "undefined" ? "undefined" : _typeof(object)) === "object") {
	            var col = this;
	            var stubbedObj = sinon.stub.apply(sinon, arguments);
	
	            walk(stubbedObj, function (prop, propOwner) {
	                if (typeof getPropertyDescriptor(propOwner, prop).value === "function") {
	                    col.add(stubbedObj[prop]);
	                }
	            });
	
	            return stubbedObj;
	        }
	
	        return this.add(sinon.stub.apply(sinon, arguments));
	    },
	
	    mock: function mock() {
	        return this.add(sinon.mock.apply(sinon, arguments));
	    },
	
	    inject: function inject(obj) {
	        var col = this;
	
	        obj.spy = function () {
	            return col.spy.apply(col, arguments);
	        };
	
	        obj.stub = function () {
	            return col.stub.apply(col, arguments);
	        };
	
	        obj.mock = function () {
	            return col.mock.apply(col, arguments);
	        };
	
	        return obj;
	    }
	};
	
	module.exports = collection;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Mock expecations
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2013 Christian Johansen
	 */
	"use strict";
	
	var spyInvoke = __webpack_require__(20).invoke;
	var spyCallToString = __webpack_require__(19).toString;
	var timesInWords = __webpack_require__(23);
	var extend = __webpack_require__(5);
	var match = __webpack_require__(10);
	var stub = __webpack_require__(33);
	var assert = __webpack_require__(32);
	var deepEqual = __webpack_require__(12).use(match);
	var format = __webpack_require__(13);
	var valueToString = __webpack_require__(7);
	
	var slice = Array.prototype.slice;
	var push = Array.prototype.push;
	
	function callCountInWords(callCount) {
	    if (callCount === 0) {
	        return "never called";
	    }
	
	    return "called " + timesInWords(callCount);
	}
	
	function expectedCallCountInWords(expectation) {
	    var min = expectation.minCalls;
	    var max = expectation.maxCalls;
	
	    if (typeof min === "number" && typeof max === "number") {
	        var str = timesInWords(min);
	
	        if (min !== max) {
	            str = "at least " + str + " and at most " + timesInWords(max);
	        }
	
	        return str;
	    }
	
	    if (typeof min === "number") {
	        return "at least " + timesInWords(min);
	    }
	
	    return "at most " + timesInWords(max);
	}
	
	function receivedMinCalls(expectation) {
	    var hasMinLimit = typeof expectation.minCalls === "number";
	    return !hasMinLimit || expectation.callCount >= expectation.minCalls;
	}
	
	function receivedMaxCalls(expectation) {
	    if (typeof expectation.maxCalls !== "number") {
	        return false;
	    }
	
	    return expectation.callCount === expectation.maxCalls;
	}
	
	function verifyMatcher(possibleMatcher, arg) {
	    var isMatcher = match && match.isMatcher(possibleMatcher);
	
	    return isMatcher && possibleMatcher.test(arg) || true;
	}
	
	var mockExpectation = {
	    minCalls: 1,
	    maxCalls: 1,
	
	    create: function create(methodName) {
	        var expectation = extend(stub.create(), mockExpectation);
	        delete expectation.create;
	        expectation.method = methodName;
	
	        return expectation;
	    },
	
	    invoke: function invoke(func, thisValue, args) {
	        this.verifyCallAllowed(thisValue, args);
	
	        return spyInvoke.apply(this, arguments);
	    },
	
	    atLeast: function atLeast(num) {
	        if (typeof num !== "number") {
	            throw new TypeError("'" + valueToString(num) + "' is not number");
	        }
	
	        if (!this.limitsSet) {
	            this.maxCalls = null;
	            this.limitsSet = true;
	        }
	
	        this.minCalls = num;
	
	        return this;
	    },
	
	    atMost: function atMost(num) {
	        if (typeof num !== "number") {
	            throw new TypeError("'" + valueToString(num) + "' is not number");
	        }
	
	        if (!this.limitsSet) {
	            this.minCalls = null;
	            this.limitsSet = true;
	        }
	
	        this.maxCalls = num;
	
	        return this;
	    },
	
	    never: function never() {
	        return this.exactly(0);
	    },
	
	    once: function once() {
	        return this.exactly(1);
	    },
	
	    twice: function twice() {
	        return this.exactly(2);
	    },
	
	    thrice: function thrice() {
	        return this.exactly(3);
	    },
	
	    exactly: function exactly(num) {
	        if (typeof num !== "number") {
	            throw new TypeError("'" + valueToString(num) + "' is not a number");
	        }
	
	        this.atLeast(num);
	        return this.atMost(num);
	    },
	
	    met: function met() {
	        return !this.failed && receivedMinCalls(this);
	    },
	
	    verifyCallAllowed: function verifyCallAllowed(thisValue, args) {
	        if (receivedMaxCalls(this)) {
	            this.failed = true;
	            mockExpectation.fail(this.method + " already called " + timesInWords(this.maxCalls));
	        }
	
	        if ("expectedThis" in this && this.expectedThis !== thisValue) {
	            mockExpectation.fail(this.method + " called with " + valueToString(thisValue) + " as thisValue, expected " + valueToString(this.expectedThis));
	        }
	
	        if (!("expectedArguments" in this)) {
	            return;
	        }
	
	        if (!args) {
	            mockExpectation.fail(this.method + " received no arguments, expected " + format(this.expectedArguments));
	        }
	
	        if (args.length < this.expectedArguments.length) {
	            mockExpectation.fail(this.method + " received too few arguments (" + format(args) + "), expected " + format(this.expectedArguments));
	        }
	
	        if (this.expectsExactArgCount && args.length !== this.expectedArguments.length) {
	            mockExpectation.fail(this.method + " received too many arguments (" + format(args) + "), expected " + format(this.expectedArguments));
	        }
	
	        for (var i = 0, l = this.expectedArguments.length; i < l; i += 1) {
	
	            if (!verifyMatcher(this.expectedArguments[i], args[i])) {
	                mockExpectation.fail(this.method + " received wrong arguments " + format(args) + ", didn't match " + this.expectedArguments.toString());
	            }
	
	            if (!deepEqual(this.expectedArguments[i], args[i])) {
	                mockExpectation.fail(this.method + " received wrong arguments " + format(args) + ", expected " + format(this.expectedArguments));
	            }
	        }
	    },
	
	    allowsCall: function allowsCall(thisValue, args) {
	        if (this.met() && receivedMaxCalls(this)) {
	            return false;
	        }
	
	        if ("expectedThis" in this && this.expectedThis !== thisValue) {
	            return false;
	        }
	
	        if (!("expectedArguments" in this)) {
	            return true;
	        }
	
	        args = args || [];
	
	        if (args.length < this.expectedArguments.length) {
	            return false;
	        }
	
	        if (this.expectsExactArgCount && args.length !== this.expectedArguments.length) {
	            return false;
	        }
	
	        for (var i = 0, l = this.expectedArguments.length; i < l; i += 1) {
	            if (!verifyMatcher(this.expectedArguments[i], args[i])) {
	                return false;
	            }
	
	            if (!deepEqual(this.expectedArguments[i], args[i])) {
	                return false;
	            }
	        }
	
	        return true;
	    },
	
	    withArgs: function withArgs() {
	        this.expectedArguments = slice.call(arguments);
	        return this;
	    },
	
	    withExactArgs: function withExactArgs() {
	        this.withArgs.apply(this, arguments);
	        this.expectsExactArgCount = true;
	        return this;
	    },
	
	    on: function on(thisValue) {
	        this.expectedThis = thisValue;
	        return this;
	    },
	
	    toString: function toString() {
	        var args = (this.expectedArguments || []).slice();
	
	        if (!this.expectsExactArgCount) {
	            push.call(args, "[...]");
	        }
	
	        var callStr = spyCallToString.call({
	            proxy: this.method || "anonymous mock expectation",
	            args: args
	        });
	
	        var message = callStr.replace(", [...", "[, ...") + " " + expectedCallCountInWords(this);
	
	        if (this.met()) {
	            return "Expectation met: " + message;
	        }
	
	        return "Expected " + message + " (" + callCountInWords(this.callCount) + ")";
	    },
	
	    verify: function verify() {
	        if (!this.met()) {
	            mockExpectation.fail(this.toString());
	        } else {
	            mockExpectation.pass(this.toString());
	        }
	
	        return true;
	    },
	
	    pass: function pass(message) {
	        assert.pass(message);
	    },
	
	    fail: function fail(message) {
	        var exception = new Error(message);
	        exception.name = "ExpectationError";
	
	        throw exception;
	    }
	};
	
	module.exports = mockExpectation;

/***/ },
/* 138 */
/***/ function(module, exports) {

	/**
	 * Format functions
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2014 Christian Johansen
	 */
	"use strict";
	
	module.exports = function typeOf(value) {
	    if (value === null) {
	        return "null";
	    } else if (value === undefined) {
	        return "undefined";
	    }
	    var string = Object.prototype.toString.call(value);
	    return string.substring(8, string.length - 1).toLowerCase();
	};

/***/ },
/* 139 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function calledInOrder(spies) {
	    if (arguments.length > 1) {
	        spies = arguments;
	    }
	
	    for (var i = 1, l = spies.length; i < l; i++) {
	        if (!spies[i - 1].calledBefore(spies[i]) || !spies[i].called) {
	            return false;
	        }
	    }
	
	    return true;
	};

/***/ },
/* 140 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	    injectIntoThis: true,
	    injectInto: null,
	    properties: ["spy", "stub", "mock", "clock", "server", "requests"],
	    useFakeTimers: true,
	    useFakeServer: true
	};

/***/ },
/* 141 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function orderByFirstCall(spies) {
	    return spies.sort(function (a, b) {
	        // uuid, won't ever be equal
	        var aCall = a.getCall(0);
	        var bCall = b.getCall(0);
	        var aId = aCall && aCall.callId || -1;
	        var bId = bCall && bCall.callId || -1;
	
	        return aId < bId ? -1 : 1;
	    });
	};

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The Sinon "server" mimics a web server that receives requests from
	 * sinon.FakeXMLHttpRequest and provides an API to respond to those requests,
	 * both synchronously and asynchronously. To respond synchronuously, canned
	 * answers have to be provided upfront.
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2013 Christian Johansen
	 */
	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var push = [].push;
	var sinon = __webpack_require__(21);
	var createInstance = __webpack_require__(11);
	var format = __webpack_require__(13);
	var configureLogError = __webpack_require__(22);
	
	function responseArray(handler) {
	    var response = handler;
	
	    if (Object.prototype.toString.call(handler) !== "[object Array]") {
	        response = [200, {}, handler];
	    }
	
	    if (typeof response[2] !== "string") {
	        throw new TypeError("Fake server response body should be string, but was " + _typeof(response[2]));
	    }
	
	    return response;
	}
	
	var wloc = typeof window !== "undefined" ? window.location : { "host": "localhost", "protocol": "http" };
	var rCurrLoc = new RegExp("^" + wloc.protocol + "//" + wloc.host);
	
	function matchOne(response, reqMethod, reqUrl) {
	    var rmeth = response.method;
	    var matchMethod = !rmeth || rmeth.toLowerCase() === reqMethod.toLowerCase();
	    var url = response.url;
	    var matchUrl = !url || url === reqUrl || typeof url.test === "function" && url.test(reqUrl);
	
	    return matchMethod && matchUrl;
	}
	
	function match(response, request) {
	    var requestUrl = request.url;
	
	    if (!/^https?:\/\//.test(requestUrl) || rCurrLoc.test(requestUrl)) {
	        requestUrl = requestUrl.replace(rCurrLoc, "");
	    }
	
	    if (matchOne(response, this.getHTTPMethod(request), requestUrl)) {
	        if (typeof response.response === "function") {
	            var ru = response.url;
	            var args = [request].concat(ru && typeof ru.exec === "function" ? ru.exec(requestUrl).slice(1) : []);
	            return response.response.apply(response, args);
	        }
	
	        return true;
	    }
	
	    return false;
	}
	
	var fakeServer = {
	    create: function create(config) {
	        var server = createInstance(this);
	        server.configure(config);
	        if (!sinon.xhr.supportsCORS) {
	            this.xhr = sinon.useFakeXDomainRequest();
	        } else {
	            this.xhr = sinon.useFakeXMLHttpRequest();
	        }
	        server.requests = [];
	
	        this.xhr.onCreate = function (xhrObj) {
	            server.addRequest(xhrObj);
	        };
	
	        return server;
	    },
	
	    configure: function configure(config) {
	        var whitelist = {
	            "autoRespond": true,
	            "autoRespondAfter": true,
	            "respondImmediately": true,
	            "fakeHTTPMethods": true,
	            "logger": true
	        };
	        var setting;
	
	        config = config || {};
	        for (setting in config) {
	            if (whitelist.hasOwnProperty(setting) && config.hasOwnProperty(setting)) {
	                this[setting] = config[setting];
	            }
	        }
	        this.logError = configureLogError(config);
	    },
	
	    addRequest: function addRequest(xhrObj) {
	        var server = this;
	        push.call(this.requests, xhrObj);
	
	        xhrObj.onSend = function () {
	            server.handleRequest(this);
	
	            if (server.respondImmediately) {
	                server.respond();
	            } else if (server.autoRespond && !server.responding) {
	                setTimeout(function () {
	                    server.responding = false;
	                    server.respond();
	                }, server.autoRespondAfter || 10);
	
	                server.responding = true;
	            }
	        };
	    },
	
	    getHTTPMethod: function getHTTPMethod(request) {
	        if (this.fakeHTTPMethods && /post/i.test(request.method)) {
	            var matches = (request.requestBody || "").match(/_method=([^\b;]+)/);
	            return matches ? matches[1] : request.method;
	        }
	
	        return request.method;
	    },
	
	    handleRequest: function handleRequest(xhr) {
	        if (xhr.async) {
	            if (!this.queue) {
	                this.queue = [];
	            }
	
	            push.call(this.queue, xhr);
	        } else {
	            this.processRequest(xhr);
	        }
	    },
	
	    logger: function logger() {
	        // no-op; override via configure()
	    },
	
	    logError: configureLogError({}),
	
	    log: function log(response, request) {
	        var str;
	
	        str = "Request:\n" + format(request) + "\n\n";
	        str += "Response:\n" + format(response) + "\n\n";
	
	        if (typeof this.logger === "function") {
	            this.logger(str);
	        }
	    },
	
	    respondWith: function respondWith(method, url, body) {
	        if (arguments.length === 1 && typeof method !== "function") {
	            this.response = responseArray(method);
	            return;
	        }
	
	        if (!this.responses) {
	            this.responses = [];
	        }
	
	        if (arguments.length === 1) {
	            body = method;
	            url = method = null;
	        }
	
	        if (arguments.length === 2) {
	            body = url;
	            url = method;
	            method = null;
	        }
	
	        push.call(this.responses, {
	            method: method,
	            url: url,
	            response: typeof body === "function" ? body : responseArray(body)
	        });
	    },
	
	    respond: function respond() {
	        if (arguments.length > 0) {
	            this.respondWith.apply(this, arguments);
	        }
	
	        var queue = this.queue || [];
	        var requests = queue.splice(0, queue.length);
	
	        for (var i = 0; i < requests.length; i++) {
	            this.processRequest(requests[i]);
	        }
	    },
	
	    processRequest: function processRequest(request) {
	        try {
	            if (request.aborted) {
	                return;
	            }
	
	            var response = this.response || [404, {}, ""];
	
	            if (this.responses) {
	                for (var l = this.responses.length, i = l - 1; i >= 0; i--) {
	                    if (match.call(this, this.responses[i], request)) {
	                        response = this.responses[i].response;
	                        break;
	                    }
	                }
	            }
	
	            if (request.readyState !== 4) {
	                this.log(response, request);
	
	                request.respond(response[0], response[1], response[2]);
	            }
	        } catch (e) {
	            this.logError("Fake server request processing", e);
	        }
	    },
	
	    restore: function restore() {
	        return this.xhr.restore && this.xhr.restore.apply(this.xhr, arguments);
	    }
	};
	
	module.exports = fakeServer;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {/**
	 * Fake timer API
	 * setTimeout
	 * setInterval
	 * clearTimeout
	 * clearInterval
	 * tick
	 * reset
	 * Date
	 *
	 * Inspired by jsUnitMockTimeOut from JsUnit
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2013 Christian Johansen
	 */
	"use strict";
	
	var llx = __webpack_require__(187);
	
	exports.useFakeTimers = function () {
	    var now;
	    var methods = Array.prototype.slice.call(arguments);
	
	    if (typeof methods[0] === "string") {
	        now = 0;
	    } else {
	        now = methods.shift();
	    }
	
	    var clock = llx.install(now || 0, methods);
	    clock.restore = clock.uninstall;
	    return clock;
	};
	
	exports.clock = {
	    create: function create(now) {
	        return llx.createClock(now);
	    }
	};
	
	exports.timers = {
	    setTimeout: setTimeout,
	    clearTimeout: clearTimeout,
	    setImmediate: typeof setImmediate !== "undefined" ? setImmediate : undefined,
	    clearImmediate: typeof clearImmediate !== "undefined" ? clearImmediate : undefined,
	    setInterval: setInterval,
	    clearInterval: clearInterval,
	    Date: Date
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14).setImmediate, __webpack_require__(14).clearImmediate))

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _fakerest = __webpack_require__(180);
	
	var _fakerest2 = _interopRequireDefault(_fakerest);
	
	var _sinon = __webpack_require__(330);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var restServer = new _fakerest2.default.Server();
	restServer.toggleLogging();
	restServer.init(__webpack_require__(152));
	
	_sinon.FakeXMLHttpRequest.useFilters = true;
	_sinon.FakeXMLHttpRequest.addFilter(function (method, url) {
	    // Do not catch webpack sync, config.js transformation but catch /upload in test env
	    return url.indexOf('/socket.io/') !== -1 || url.indexOf('config.js') !== -1;
	});
	(0, _sinon.useFakeXMLHttpRequest)();
	
	var server = _sinon.fakeServer.create();
	_sinon.fakeServer.autoRespond = true;
	_sinon.fakeServer.autoRespondAfter = 0; // answer immediately
	_sinon.fakeServer.respondWith(restServer.getHandler());

/***/ },
/* 145 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function requestInterceptor(RestangularProvider) {
	    // use the custom query parameters function to format the API request correctly
	    RestangularProvider.addFullRequestInterceptor(function (element, operation, what, url, headers, params) {
	        if (operation == "getList") {
	            // custom pagination params
	            if (params._page) {
	                var start = (params._page - 1) * params._perPage;
	                var end = params._page * params._perPage - 1;
	                params.range = "[" + start + "," + end + "]";
	                delete params._page;
	                delete params._perPage;
	            }
	            // custom sort params
	            if (params._sortField) {
	                params.sort = '["' + params._sortField + '","' + params._sortDir + '"]';
	                delete params._sortField;
	                delete params._sortDir;
	            }
	            // custom filters
	            if (params._filters) {
	                params.filter = params._filters;
	                delete params._filters;
	            }
	            if (headers['Content-Range']) {
	                headers['X-Total-Count'] = headers['Content-Range'].split('/').pop();
	            }
	        }
	        return { params: params, headers: headers };
	    });
	}
	
	function responseInterceptor(RestangularProvider) {
	    RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response) {
	        if (operation == "getList") {
	            var contentRange = response.headers('Content-Range');
	            response.totalCount = contentRange.split('/')[1];
	        }
	        return data;
	    });
	}
	
	exports.default = { requestInterceptor: requestInterceptor, responseInterceptor: responseInterceptor };
	module.exports = exports["default"];

/***/ },
/* 146 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	
	    var categories = admin.getEntity('categories');
	    categories.listView().fields([nga.field('name')]).listActions(['<ma-filtered-list-button entity-name="products" filter="{ category_id: entry.values.id }" size="xs" label="Related products"></ma-filtered-list-button>', 'edit', 'delete']);
	    categories.creationView().fields([nga.field('name').validation({ required: true }), nga.field('', 'template').label('').editable(false).template('<span class="pull-right"><ma-filtered-list-button entity-name="products" filter="{ category_id: entry.values.id }" size="sm"></ma-filtered-list-button></span>')]);
	    categories.editionView().fields(categories.creationView().fields());
	
	    return categories;
	};
	
	module.exports = exports['default'];

/***/ },
/* 147 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function basket(Restangular, $q) {
	    'use strict';
	
	    return {
	        restrict: 'E',
	        scope: {
	            command: '='
	        },
	        controller: ['$scope', function ($scope) {
	            $scope.productsById = {};
	            var productIds = $scope.command.basket.map(function (item) {
	                return item.product_id;
	            }).reduce(function (previous, current) {
	                if (previous.indexOf(current) === -1) previous.push(current);
	                return previous;
	            }, []);
	            var promises = productIds.map(function (product_id) {
	                return Restangular.one('products', product_id).get();
	            });
	            $q.all(promises).then(function (products) {
	                var productsById = {};
	                products.forEach(function (product) {
	                    productsById[product.data.id] = product.data;
	                });
	                $scope.productsById = productsById;
	            });
	            $scope.$watch('command', function (command) {
	                if (Object.keys($scope.productsById).length === 0) return;
	                command.basket = command.basket.filter(function (item) {
	                    return item.quantity > 0;
	                });
	                command.total_ex_taxes = command.basket.reduce(function (total, item) {
	                    total += $scope.productsById[item.product_id].price * item.quantity;
	                    return parseFloat(total.toFixed(2));
	                }, 0);
	                command.taxes = command.tax_rate * (command.total_ex_taxes + command.delivery_fees);
	                var total = command.total_ex_taxes + command.delivery_fees + command.taxes;
	                command.total = parseFloat(total.toFixed(2));
	            }, true);
	        }],
	        template: '\n<table class="grid table table-condensed img-thumbnail items">\n<thead>\n<tr>\n    <th class="col-md-1"></th>\n    <th class="col-md-3">Reference</th>\n    <th class="col-md-2 ng-admin-type-amount">Unit Price</th>\n    <th class="col-md-3">Quantity</th>\n    <th class="col-md-3 ng-admin-type-amount">Total</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat="item in command.basket">\n    <td><img src="{{ productsById[item.product_id].thumbnail }}" class="poster_mini_thumbnail" /></td>\n    <td><a ui-sref="edit({entity: \'products\', id: item.product_id })"> {{ productsById[item.product_id].reference }}</a></td>\n    <td class="ng-admin-type-amount">${{ productsById[item.product_id].price }}</td>\n    <td><input class="form-control input-sm" type="number" min="0" ng-model="item.quantity"/></td>\n    <td class="ng-admin-type-amount">${{ productsById[item.product_id].price * item.quantity | number: 2 }}</td>\n</td>\n<tr>\n    <td colspan="3"></td>\n    <td>Sum</td>\n    <td class="ng-admin-type-amount">${{ command.total_ex_taxes }}</td>\n</tr>\n<tr>\n    <td colspan="3"></td>\n    <td>Delivery</td>\n    <td class="ng-admin-type-amount"><div class="input-group"><span class="input-group-addon ng-binding">$</span><input class="form-control delivery_fees input-sm" type="number" min="0" step="any" ng-model="command.delivery_fees"/></div></td>\n</tr>\n<tr>\n    <td colspan="3"></td>\n    <td>Tax rate</td>\n    <td class="ng-admin-type-number">{{ command.tax_rate * 100}}%</td>\n</tr>\n<tr>\n    <td colspan="3"></td>\n    <td><strong>Total</strong></td>\n    <td class="ng-admin-type-amount"><strong>${{ command.total }}</strong></td>\n</tr>\n</tbody>\n</table>\n'
	    };
	}
	
	basket.$inject = ['Restangular', '$q'];
	
	exports.default = basket;
	module.exports = exports['default'];

/***/ },
/* 148 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	
	    var commands = admin.getEntity('commands');
	    commands.listView().sortField('date').sortDir('DESC').fields([nga.field('date', 'datetime'), nga.field('reference').isDetailLink(true), nga.field('customer_id', 'reference').label('Customer').targetEntity(admin.getEntity('customers')).targetField(nga.field('last_name').map(function (v, e) {
	        return e.first_name + ' ' + e.last_name;
	    })).singleApiCall(function (ids) {
	        return { 'id': ids };
	    }).cssClasses('hidden-xs'), nga.field('nb_items').map(function (v, e) {
	        return e.basket.length;
	    }).cssClasses('hidden-xs'), nga.field('total', 'amount').cssClasses('hidden-xs'), nga.field('status'), nga.field('returned', 'boolean').cssClasses('hidden-xs')]).filters([nga.field('q', 'template').label('').pinned(true).template('<div class="input-group"><input type="text" ng-model="value" placeholder="Search" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>'), nga.field('customer_id', 'reference').label('Customer').targetEntity(admin.getEntity('customers')).targetField(nga.field('last_name').map(function (v, e) {
	        return e.first_name + ' ' + e.last_name;
	    })).remoteComplete(true, {
	        searchQuery: function searchQuery(search) {
	            return { q: search };
	        }
	    }), nga.field('status', 'choice').choices([{ label: 'ordered', value: 'ordered' }, { label: 'delivered', value: 'delivered' }, { label: 'cancelled', value: 'cancelled' }]), nga.field('date_gte', 'datetime').label('Passed since'), nga.field('date_lte', 'datetime').label('Passed before'), nga.field('total_gte', 'amount').label('Min amount'), nga.field('returned', 'boolean')]).listActions(['<ma-edit-button entry="::entry" entity="::entity" size="xs" label="Details"></ma-edit-button>']);
	    commands.editionView().title('Command #{{ entry.values.reference }}').fields([nga.field('date', 'datetime').editable(false), nga.field('customer_id', 'reference').label('Customer').targetEntity(admin.getEntity('customers')).targetField(nga.field('last_name').map(function (v, e) {
	        return e.first_name + ' ' + e.last_name;
	    })).editable(false), nga.field('Items', 'template').template('<basket command="entry.values"></basket>'), nga.field('status', 'choice').choices([{ label: 'ordered', value: 'ordered' }, { label: 'delivered', value: 'delivered' }, { label: 'cancelled', value: 'cancelled' }]).cssClasses('col-sm-4 col-lg-2'), nga.field('returned', 'boolean')]);
	
	    return commands;
	};
	
	module.exports = exports['default'];

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	
	    var customer = admin.getEntity('customers');
	    customer.listView().title('Visitors').fields([nga.field('avatar', 'template').label('').template(function (entry) {
	        return '<img src="' + entry.values.avatar + '" width="25" style="margin-top:-5px" />';
	    }), nga.field('last_name', 'template') // use last_name for sorting
	    .label('Name').isDetailLink(true).template('{{ entry.values.first_name }} {{ entry.values.last_name }}'), nga.field('last_seen', 'datetime').map(fromNow).cssClasses('hidden-xs'), nga.field('nb_commands', 'number').label('Commands').cssClasses(function (entry) {
	        return entry && entry.values.nb_commands ? 'hidden-xs' : 'transparent hidden-xs';
	    }), nga.field('total_spent', 'amount').cssClasses(function (entry) {
	        return entry && entry.values.total_spent ? 'hidden-xs' : 'transparent hidden-xs';
	    }), nga.field('latest_purchase', 'datetime').cssClasses('hidden-xs'), nga.field('has_newsletter', 'boolean').label('Newsletter').cssClasses('hidden-xs'), nga.field('segments', 'template').template('<span ng-repeat="group in entry.values.groups track by $index" class="label label-default">{{ group }}</span>').cssClasses('hidden-xs')]).filters([nga.field('q', 'template').label('').pinned(true).template('<div class="input-group"><input type="text" ng-model="value" placeholder="Search" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>'), nga.field('groups', 'choice').label('Segment').choices(segments), nga.field('last_seen_gte', 'datetime').label('Visited since'), nga.field('has_ordered', 'boolean'), nga.field('has_newsletter', 'boolean')]).sortField('first_seen').sortDir('DESC').listActions(['edit']).exportFields([nga.field('avatar', 'text'), nga.field('last_name', 'template').label('Name').template(function (entry) {
	        return entry.values.first_name + ' ' + entry.values.last_name;
	    }), nga.field('last_seen', 'datetime'), nga.field('nb_commands', 'number').label('Commands'), nga.field('total_spent', 'amount'), nga.field('latest_purchase', 'datetime'), nga.field('has_newsletter', 'boolean').label('Newsletter'), nga.field('segments', 'template').template(function (entry) {
	        return '' + entry.values.groups;
	    })]);
	    customer.editionView().title('<img src="{{ entry.values.avatar }}" width="50" style="vertical-align: text-bottom"/> {{ entry.values.first_name }} {{ entry.values.last_name }}\'s details').fields([nga.field('first_name'), nga.field('last_name'), nga.field('email', 'email'), nga.field('address', 'text'), nga.field('zipcode'), nga.field('city'), nga.field('birthday', 'date'), nga.field('first_seen', 'datetime').editable(false), nga.field('latest_purchase', 'datetime').editable(false), nga.field('last_seen', 'datetime').editable(false), nga.field('has_newsletter', 'boolean'), nga.field('groups', 'choices').choices(segments), nga.field('commands', 'referenced_list').label('Latest commands').targetEntity(admin.getEntity('commands')).targetReferenceField('customer_id').targetFields([nga.field('date').map(fromNow), nga.field('reference').isDetailLink(true), nga.field('nb_items').map(function (v, e) {
	        return e.basket.length;
	    }), nga.field('total', 'amount'), nga.field('status')]).listActions(['<ma-edit-button entry="::entry" entity="::entity" size="xs" label="Details"></ma-edit-button>']).perPage(5).sortField('date').sortDir('DESC'), nga.field('commands button', 'template').label('').template('<ma-filtered-list-button entity-name="commands" filter="{ customer_id: entry.values.id }"></ma-filtered-list-button>'), nga.field('reviews', 'referenced_list').label('Latest reviews').targetEntity(admin.getEntity('reviews')).targetReferenceField('customer_id').targetFields([nga.field('date').label('Posted').map(fromNow).isDetailLink(true), nga.field('product_id', 'reference').label('Product').targetEntity(admin.getEntity('products')).targetField(nga.field('reference')), nga.field('rating', 'template').template('<star-rating stars="{{ entry.values.rating }}"></star-rating>'), nga.field('comment').map(function truncate(value) {
	        if (!value) {
	            return '';
	        }
	        return value.length > 50 ? value.substr(0, 50) + '...' : value;
	    }), nga.field('status', 'choice').choices([{ label: 'accepted', value: 'accepted' }, { label: 'rejected', value: 'rejected' }, { label: 'pending', value: 'pending' }]).cssClasses(function (entry) {
	        // add custom CSS classes to inputs and columns
	        if (!entry) return;
	        if (entry.values.status == 'accepted') {
	            return 'text-center bg-success';
	        }
	        if (entry.values.status == 'rejected') {
	            return 'text-center bg-danger';
	        }
	        return 'text-center bg-warning';
	    })]).listActions(['<ma-edit-button entry="::entry" entity="::entity" size="xs" label="Details"></ma-edit-button>']).perPage(5).sortField('date').sortDir('DESC'), nga.field('reviews button', 'template').label('').template('<ma-filtered-list-button entity-name="reviews" filter="{ customer_id: entry.values.id }"></ma-filtered-list-button>')]);
	
	    return customer;
	};
	
	var moment = __webpack_require__(1);
	var fromNow = function fromNow(v) {
	    return moment(v).fromNow();
	};
	
	var segments = __webpack_require__(37).choices;
	
	module.exports = exports['default'];

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	
	    return nga.dashboard().addCollection(nga.collection(admin.getEntity('commands')).name('monthly_revenue').title('Monthly revenue')
	    //.permanentFilters({ date: { gte: moment().substract(1, 'months').toDate() } })
	    .fields([nga.field('date', 'datetime'), nga.field('total', 'amount')]).sortField('date').sortDir('ASC').perPage(100)).addCollection(nga.collection(admin.getEntity('commands')).name('pending_orders').title('Pending orders').fields([nga.field('date', 'datetime').isDetailLink(true), nga.field('reference'), nga.field('customer_id', 'reference').label('Customer').targetEntity(admin.getEntity('customers')).targetField(nga.field('last_name').map(function (v, e) {
	        return e.first_name + ' ' + e.last_name;
	    })).singleApiCall(function (ids) {
	        return { 'id': ids };
	    }).cssClasses('hidden-xs'), nga.field('nb_items').map(function (v, e) {
	        return e.basket.length;
	    }), nga.field('total', 'amount').cssClasses('amount')]).permanentFilters({ status: 'ordered' }).sortField('date').sortDir('DESC')).addCollection(nga.collection(admin.getEntity('reviews')).name('latest_reviews').title('Latest reviews').fields([nga.field('customer_id', 'reference').label('Customer').targetEntity(admin.getEntity('customers')).targetField(nga.field('last_name').map(function (v, e) {
	        return e.first_name + ' ' + e.last_name;
	    })).singleApiCall(function (ids) {
	        return { 'id': ids };
	    }),, nga.field('product_id', 'reference').label('Product').targetEntity(admin.getEntity('products')).targetField(nga.field('reference')).singleApiCall(function (ids) {
	        return { 'id': ids };
	    }),, nga.field('rating', 'template').template('<star-rating stars="{{ entry.values.rating }}"></star-rating>')]).sortField('date').sortDir('DESC').perPage(10)).addCollection(nga.collection(admin.getEntity('customers')).name('new_customers').title('New customers').fields([nga.field('avatar', 'template').label('').template('<img src="{{ entry.values.avatar }}" width="25" />'), nga.field('last_name', 'template') // use last_name for sorting
	    .label('Name').isDetailLink(true).template('{{ entry.values.first_name }} {{ entry.values.last_name }}'), nga.field('last_seen', 'datetime').map(fromNow)]).permanentFilters({ has_ordered: true }).sortField('first_seen').sortDir('DESC').perPage(10)).template('\n<div class="row dashboard-starter"></div>\n<dashboard-summary></dashboard-summary>\n<div class="row dashboard-content">\n    <div class="col-lg-6">\n        <div class="panel panel-default">\n            <ma-dashboard-panel collection="dashboardController.collections.pending_orders" entries="dashboardController.entries.pending_orders" datastore="dashboardController.datastore"></ma-dashboard-panel>\n        </div>\n    </div>\n    <div class="col-lg-6">\n        <div class="panel panel-default">\n            <ma-dashboard-panel collection="dashboardController.collections.latest_reviews" entries="dashboardController.entries.latest_reviews" datastore="dashboardController.datastore"></ma-dashboard-panel>\n        </div>\n        <div class="panel panel-default">\n            <ma-dashboard-panel collection="dashboardController.collections.new_customers" entries="dashboardController.entries.new_customers" datastore="dashboardController.datastore"></ma-dashboard-panel>\n        </div>\n    </div>\n</div>\n');
	};
	
	var moment = __webpack_require__(1);
	var fromNow = function fromNow(v) {
	    return moment(v).fromNow();
	};
	
	module.exports = exports['default'];

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dashboardSummary = __webpack_require__(345);
	
	var _dashboardSummary2 = _interopRequireDefault(_dashboardSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneMonthAgo = (0, _moment2.default)().subtract(1, 'months').toDate();
	
	var has_seen_alert = false;
	
	function dashboardSummary(Restangular) {
	    'use strict';
	
	    return {
	        restrict: 'E',
	        scope: {},
	        controller: ['$scope', function ($scope) {
	            $scope.stats = {};
	            $scope.has_seen_alert = has_seen_alert;
	            $scope.dismissAlert = function () {
	                has_seen_alert = true;
	                $scope.has_seen_alert = true;
	            };
	            Restangular.all('commands').getList({ filter: '{"date_gte":"' + oneMonthAgo.toISOString() + '"}', sort: '["date","DESC"]' }).then(function (commands) {
	                $scope.stats.commands = commands.data.reduce(function (stats, command) {
	                    if (command.status != 'cancelled') stats.revenue += command.total;
	                    if (command.status == 'ordered') stats.pending_orders++;
	                    return stats;
	                }, { revenue: 0, pending_orders: 0 });
	            });
	            Restangular.all('customers').getList({ range: '[1,100]', sort: '["first_seen","DESC"]', filter: '{"has_ordered":true,"first_seen_gte":"' + oneMonthAgo.toISOString() + '"}' }).then(function (customers) {
	                $scope.stats.customers = customers.data.reduce(function (nb) {
	                    return ++nb;
	                }, 0);
	            });
	            Restangular.all('reviews').getList({ range: '[1,100]', sort: '["date","DESC"]', filter: '{"status":"pending"}' }).then(function (reviews) {
	                $scope.stats.reviews = reviews.data.reduce(function (nb) {
	                    return ++nb;
	                }, 0);
	            });
	        }],
	        template: _dashboardSummary2.default
	    };
	}
	
	dashboardSummary.$inject = ['Restangular'];
	
	exports.default = dashboardSummary;
	module.exports = exports['default'];

/***/ },
/* 152 */
/***/ function(module, exports) {

	"use strict";module.exports={"customers":[{"id":0,"first_name":"Amy","last_name":"Matthews","email":"mufja@cuzugri.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/9176d6c6efdca89531f6a79f2deeb113.png","birthday":null,"first_seen":"2016-01-30T14:18:02.873Z","last_seen":"2016-05-26T05:25:27.815Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":1,"first_name":"Rhoda","last_name":"Fitzgerald","email":"lav@cefzizoz.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8c493442afccc22e7f7d908597052368.png","birthday":null,"first_seen":"2016-05-09T00:02:19.205Z","last_seen":"2016-10-15T01:06:53.000Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":2,"first_name":"Nicholas","last_name":"Stevenson","email":"leugage@hudaki.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0be29959872efeab5cfe9eaefcdc3da5.png","birthday":null,"first_seen":"2013-03-31T03:11:19.732Z","last_seen":"2015-02-06T07:46:07.462Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":3,"first_name":"Craig","last_name":"Ball","email":"ti@ro.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d697871841825cb3ee77f4d1b01a9cec.png","birthday":null,"first_seen":"2016-08-01T10:08:31.258Z","last_seen":"2016-12-28T01:01:08.536Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":4,"first_name":"Melvin","last_name":"Cobb","email":"fuphonref@te.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/75eaba9557f9e0911d3c918d45ef4b70.png","birthday":null,"first_seen":"2016-12-08T20:30:37.826Z","last_seen":"2016-12-20T20:54:47.664Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":5,"first_name":"Rosie","last_name":"Diaz","email":"igoeh@to.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d2367508c980aba686653657c28b494c.png","birthday":null,"first_seen":"2014-09-10T11:44:11.178Z","last_seen":"2016-08-28T04:03:11.061Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":6,"first_name":"Travis","last_name":"Jones","email":"izamimo@vasemim.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ea99e97442592294ac7a2668ae0fa04e.png","birthday":null,"first_seen":"2012-12-13T01:27:46.979Z","last_seen":"2014-01-17T23:36:59.406Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":7,"first_name":"Russell","last_name":"Gregory","email":"nadaw@jepozka.co.uk","address":"735 Sorsi Court","zipcode":"57106","city":"Owdavci","avatar":"https://robohash.org/535b5979ec2258d9b89321f5868f34b1.png","birthday":"1998-02-27T00:18:43.769Z","first_seen":"2015-01-10T10:53:59.051Z","last_seen":"2016-09-15T02:22:36.179Z","has_ordered":true,"latest_purchase":"2016-02-23T17:27:15.163Z","has_newsletter":false,"groups":["ordered_once","regular"],"nb_commands":1,"total_spent":173.31},{"id":8,"first_name":"Olga","last_name":"Cook","email":"rege@biculone.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f4f762af9f4f881b748b7847000e93a4.png","birthday":null,"first_seen":"2016-05-19T23:05:37.866Z","last_seen":"2016-12-01T10:53:59.248Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":9,"first_name":"Rosalie","last_name":"Chambers","email":"hagijiga@dazohjun.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a907733bdcab97fa869ae552aa494422.png","birthday":null,"first_seen":"2013-09-09T12:44:57.726Z","last_seen":"2015-04-13T19:41:46.942Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":10,"first_name":"Estelle","last_name":"Brewer","email":"niwure@ro.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/69cbe3e0fd2f81ccca21d3a452f6bdf6.png","birthday":null,"first_seen":"2016-03-21T08:56:57.938Z","last_seen":"2016-05-20T05:17:29.746Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":11,"first_name":"William","last_name":"Hammond","email":"ozheiv@hat.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f7b79fbe180476669a0e8baeda24d3b7.png","birthday":null,"first_seen":"2013-10-06T12:59:51.783Z","last_seen":"2016-10-14T09:13:50.232Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":12,"first_name":"Lillian","last_name":"Chavez","email":"alvozega@sicus.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a3657a646ebd6d584ebe80b99378f77e.png","birthday":null,"first_seen":"2014-03-24T02:51:59.819Z","last_seen":"2015-11-01T22:56:14.816Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":13,"first_name":"Lois","last_name":"Marshall","email":"len@igfo.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/302a2df0fb68df84dea5253bdcb115c5.png","birthday":null,"first_seen":"2015-04-24T18:32:31.852Z","last_seen":"2015-10-12T10:38:32.747Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":14,"first_name":"Marian","last_name":"Clayton","email":"culat@kunzohuj.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/03e4c9ebd0f16c9b74413e75f4ac5684.png","birthday":null,"first_seen":"2015-10-15T06:01:47.472Z","last_seen":"2016-01-22T16:15:15.941Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":15,"first_name":"Luke","last_name":"Byrd","email":"fodok@pohpe.com","address":"804 Taza Lane","zipcode":"31279","city":"Tumaguira","avatar":"https://robohash.org/10483d122ff271dfcdd731b1de5090e9.png","birthday":"1974-11-21T03:13:27.084Z","first_seen":"2013-09-13T15:29:17.028Z","last_seen":"2014-04-01T10:21:09.849Z","has_ordered":true,"latest_purchase":null,"has_newsletter":false,"groups":[],"nb_commands":0,"total_spent":0},{"id":16,"first_name":"Jerry","last_name":"Lewis","email":"bebadsik@nassa.io","address":"445 Conjus Court","zipcode":"67241","city":"Kizcoscu","avatar":"https://robohash.org/3e6d1d1fff2fbf8763196f55b5724606.png","birthday":"1991-01-02T09:01:05.570Z","first_seen":"2016-01-20T10:45:39.485Z","last_seen":"2016-10-22T15:29:34.559Z","has_ordered":true,"latest_purchase":"2016-09-29T03:17:05.267Z","has_newsletter":false,"groups":["regular"],"nb_commands":2,"total_spent":205.05},{"id":17,"first_name":"Milton","last_name":"Walsh","email":"zohewcow@ripcim.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/932b2e8e7934d984bc3f26bd040ac8ab.png","birthday":null,"first_seen":"2015-03-10T20:22:11.527Z","last_seen":"2016-10-13T03:53:56.450Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":18,"first_name":"Elva","last_name":"Barker","email":"paseiju@beapi.com","address":"377 Vewiko Park","zipcode":"83913","city":"Ecokuev","avatar":"https://robohash.org/75f6dbdfa09cb8cc94d031bb9731c202.png","birthday":"1958-11-13T08:39:07.062Z","first_seen":"2016-06-18T19:05:52.985Z","last_seen":"2016-11-12T05:31:36.688Z","has_ordered":true,"latest_purchase":"2016-10-22T13:19:00.734Z","has_newsletter":false,"groups":["ordered_once","reviewer"],"nb_commands":1,"total_spent":349.9},{"id":19,"first_name":"Hettie","last_name":"Porter","email":"ri@nihful.io","address":"129 Vebus Key","zipcode":"66732","city":"Hiijazo","avatar":"https://robohash.org/bd3c3fefd7c59b34400711988000d8c7.png","birthday":"1979-02-13T08:46:24.976Z","first_seen":"2014-05-29T23:35:29.261Z","last_seen":"2017-01-03T20:14:47.303Z","has_ordered":true,"latest_purchase":"2016-02-16T01:50:09.146Z","has_newsletter":true,"groups":["ordered_once"],"nb_commands":1,"total_spent":185.38},{"id":20,"first_name":"Eunice","last_name":"Reed","email":"cugza@mejuc.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2614885178db123ddac5ce6832b64ef2.png","birthday":null,"first_seen":"2015-07-14T21:13:46.373Z","last_seen":"2016-05-26T02:41:15.172Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":21,"first_name":"Franklin","last_name":"Hicks","email":"ce@azpe.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/887fbb0bce71666c4131e002b2b4e4b0.png","birthday":null,"first_seen":"2016-01-24T05:19:22.391Z","last_seen":"2016-11-19T10:09:33.519Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":22,"first_name":"Frances","last_name":"Harris","email":"hemo@ku.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5a1b1b63008c6a07d3e9b2e1f377d51b.png","birthday":null,"first_seen":"2016-11-14T18:25:24.676Z","last_seen":"2017-01-03T15:33:19.096Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":23,"first_name":"Sally","last_name":"Warren","email":"was@fedu.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1a5c444d83f21bbd1d570cf76bad9da8.png","birthday":null,"first_seen":"2015-07-09T06:35:25.045Z","last_seen":"2016-03-05T02:16:32.577Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":24,"first_name":"Connor","last_name":"Horton","email":"dikalo@dizepive.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ba4b2cb93ff63ef2bf84df81bf6c802f.png","birthday":null,"first_seen":"2013-03-17T19:25:10.523Z","last_seen":"2013-09-20T22:24:45.268Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":25,"first_name":"Ora","last_name":"Rhodes","email":"wadgujig@hohidez.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5a595b1ee7bfde290caa9c90b6ce9e41.png","birthday":null,"first_seen":"2016-11-15T13:30:13.229Z","last_seen":"2016-11-26T09:49:46.260Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":26,"first_name":"Margaret","last_name":"Ford","email":"nuvod@janesit.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d66bed33cd47ff995c1278bc78b3c973.png","birthday":null,"first_seen":"2016-06-04T01:14:25.298Z","last_seen":"2016-12-16T17:16:36.144Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":27,"first_name":"Paul","last_name":"Fox","email":"tobititod@wuf.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/29af44605e77194f3f0dba565be02f7a.png","birthday":null,"first_seen":"2016-07-09T01:37:52.038Z","last_seen":"2016-11-23T14:19:46.248Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":28,"first_name":"Herbert","last_name":"Peterson","email":"zulsutot@aheco.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/631a8ca2f6f5a6ecf54a5f9bc5c56e81.png","birthday":null,"first_seen":"2014-07-27T03:09:38.527Z","last_seen":"2014-09-16T14:25:19.550Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":29,"first_name":"Katharine","last_name":"Cortez","email":"dorbovi@mocuv.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/432bb7241508346c37d811a064f1a6b1.png","birthday":null,"first_seen":"2014-03-03T21:32:55.296Z","last_seen":"2015-10-14T19:25:36.744Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":30,"first_name":"Sarah","last_name":"Casey","email":"evadopzug@mofuwvuz.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5ebeb6363bbd462a166ded34407d285e.png","birthday":null,"first_seen":"2015-03-08T16:56:17.051Z","last_seen":"2016-01-28T10:04:59.532Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":31,"first_name":"Virgie","last_name":"Goodwin","email":"ladwezuf@ilolubih.co.uk","address":"170 Ugone Street","zipcode":"47469","city":"Rihevvoh","avatar":"https://robohash.org/2a12144cf7da5bc712d584cf185f6152.png","birthday":"1981-03-20T08:56:08.900Z","first_seen":"2016-09-11T20:08:37.008Z","last_seen":"2016-12-15T19:37:53.957Z","has_ordered":true,"latest_purchase":"2016-12-09T13:11:35.436Z","has_newsletter":false,"groups":["returns","reviewer"],"nb_commands":6,"total_spent":929.87},{"id":32,"first_name":"Joshua","last_name":"Peters","email":"amjiv@tu.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/eeeb46c2d5f7b250dbe7a7e80895ff62.png","birthday":null,"first_seen":"2014-08-05T00:45:25.429Z","last_seen":"2016-04-27T12:42:44.908Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":33,"first_name":"Victoria","last_name":"Potter","email":"bawivsid@lirerew.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0fc4ebdd0408ed8524f673c1250f6556.png","birthday":null,"first_seen":"2014-05-15T21:12:05.499Z","last_seen":"2016-07-28T21:33:59.641Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":34,"first_name":"Jay","last_name":"Benson","email":"newi@lal.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c3474a63747b39eb59dcaffd0a428464.png","birthday":null,"first_seen":"2016-08-03T09:51:14.879Z","last_seen":"2016-12-08T06:43:40.516Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":35,"first_name":"Matthew","last_name":"Kelly","email":"ic@tipdeg.io","address":"1484 Doluse Court","zipcode":"19989","city":"Kekcirpa","avatar":"https://robohash.org/6bf7d3a244431cc5ce82d91e422fd551.png","birthday":"1974-02-27T04:28:55.998Z","first_seen":"2016-04-21T04:27:36.666Z","last_seen":"2016-09-28T06:42:02.510Z","has_ordered":true,"latest_purchase":"2016-08-10T06:24:15.057Z","has_newsletter":true,"groups":["collector","reviewer"],"nb_commands":4,"total_spent":1294.39},{"id":36,"first_name":"Cory","last_name":"George","email":"erruug@ipo.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/04943510b4c246c8497fcddeb50549de.png","birthday":null,"first_seen":"2016-01-17T07:13:47.497Z","last_seen":"2016-06-08T17:03:26.978Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":37,"first_name":"Tommy","last_name":"Howell","email":"detco@dirfejmen.net","address":"1882 Isidi Lane","zipcode":"38174","city":"Jizitic","avatar":"https://robohash.org/bb0045fd7a3624621bc118f31074dfa6.png","birthday":"1960-07-23T01:52:58.039Z","first_seen":"2014-05-26T17:03:02.594Z","last_seen":"2014-08-24T15:58:56.677Z","has_ordered":true,"latest_purchase":"2014-08-14T19:11:35.143Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":2,"total_spent":512.3199999999999},{"id":38,"first_name":"Albert","last_name":"Lindsey","email":"lon@tug.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6e35a14d6b028ee4d0307646fae3070a.png","birthday":null,"first_seen":"2016-05-30T09:59:09.181Z","last_seen":"2017-01-03T09:03:30.178Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":39,"first_name":"Darrell","last_name":"Long","email":"awokuese@atued.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b0ab3af86c694771fd88a724a185f123.png","birthday":null,"first_seen":"2015-10-12T20:40:51.391Z","last_seen":"2016-07-13T00:35:12.067Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":40,"first_name":"Benjamin","last_name":"Reed","email":"zaezvit@higeghit.com","address":"1730 Hakni Turnpike","zipcode":"17968","city":"Vovarap","avatar":"https://robohash.org/52f8d57123468ba74c7c09be799a16ea.png","birthday":"1983-02-10T02:03:06.024Z","first_seen":"2014-01-08T14:04:32.538Z","last_seen":"2015-01-08T15:30:51.902Z","has_ordered":true,"latest_purchase":"2014-11-16T12:22:40.345Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":868.71},{"id":41,"first_name":"Douglas","last_name":"Malone","email":"roztebvu@julbo.com","address":"1292 Gaok Avenue","zipcode":"31739","city":"Kollitat","avatar":"https://robohash.org/3c23ad428d50e4a036e8825ff5f19339.png","birthday":"1957-01-25T10:54:47.356Z","first_seen":"2016-02-24T03:20:01.018Z","last_seen":"2016-07-28T05:24:55.772Z","has_ordered":true,"latest_purchase":"2016-06-24T19:33:35.444Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":5,"total_spent":300.13},{"id":42,"first_name":"Maurice","last_name":"Bates","email":"vomviazo@watesopeb.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/9d00d8bcd0dcb7aea17dd120d54c7aee.png","birthday":null,"first_seen":"2013-10-23T18:51:06.312Z","last_seen":"2016-06-10T03:17:48.297Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":43,"first_name":"Susan","last_name":"Steele","email":"tefroero@magik.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/76c3c38f612ec6ee501a1fa6005b7bd6.png","birthday":null,"first_seen":"2014-07-26T11:17:58.556Z","last_seen":"2016-12-23T05:35:42.822Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":44,"first_name":"Winifred","last_name":"Poole","email":"vu@kolor.co.uk","address":"672 Ikugas Boulevard","zipcode":"13433","city":"Atodecus","avatar":"https://robohash.org/d0149a20fbb642a1c2fb013aa733a611.png","birthday":"1991-07-31T06:31:38.600Z","first_seen":"2013-12-03T23:39:11.772Z","last_seen":"2016-10-02T16:44:39.396Z","has_ordered":true,"latest_purchase":"2015-04-01T05:51:10.718Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":2,"total_spent":207.38},{"id":45,"first_name":"Maude","last_name":"Matthews","email":"doclatuw@sib.gov","address":"94 Alke Loop","zipcode":"34546","city":"Zesaopo","avatar":"https://robohash.org/3b7303072a6dbcf699dbef56655038b5.png","birthday":"1963-01-05T02:51:22.147Z","first_seen":"2013-09-26T09:02:22.934Z","last_seen":"2016-03-25T22:05:20.788Z","has_ordered":true,"latest_purchase":"2016-01-10T23:15:47.092Z","has_newsletter":false,"groups":["regular","returns"],"nb_commands":5,"total_spent":505.44},{"id":46,"first_name":"Johnny","last_name":"Quinn","email":"ij@ecabu.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d4615ba81a87b6c7d077b25bb32087a9.png","birthday":null,"first_seen":"2015-09-21T03:54:38.211Z","last_seen":"2016-07-28T04:00:20.605Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":47,"first_name":"Lulu","last_name":"McDonald","email":"gizkihu@gunizi.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b4c2e79c69eca58726ab63b3dc399fb8.png","birthday":null,"first_seen":"2016-06-29T04:53:24.578Z","last_seen":"2016-08-27T19:27:11.459Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":48,"first_name":"Melvin","last_name":"Cain","email":"tor@weza.com","address":"1088 Moso Heights","zipcode":"42457","city":"Gagjejbi","avatar":"https://robohash.org/52784182756fb536484c6b64b6948318.png","birthday":"1975-06-16T02:53:47.669Z","first_seen":"2014-08-16T16:37:17.173Z","last_seen":"2015-12-13T16:04:25.163Z","has_ordered":true,"latest_purchase":null,"has_newsletter":false,"groups":[],"nb_commands":0,"total_spent":0},{"id":49,"first_name":"Helen","last_name":"Hunt","email":"bago@ahfuro.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/32dfa2c04783a0dc65bd1407f915955a.png","birthday":null,"first_seen":"2016-10-24T02:35:20.086Z","last_seen":"2016-12-21T06:06:40.272Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":50,"first_name":"Lydia","last_name":"Ramos","email":"hahdipfo@wokfazeme.edu","address":"845 Hukbir Terrace","zipcode":"00563","city":"Vikeruda","avatar":"https://robohash.org/61ef7d29693d74233663864439e877b9.png","birthday":"1999-02-06T05:04:24.867Z","first_seen":"2013-08-09T22:32:08.004Z","last_seen":"2015-12-03T23:38:11.172Z","has_ordered":true,"latest_purchase":"2015-11-17T09:13:08.637Z","has_newsletter":true,"groups":["ordered_once","reviewer"],"nb_commands":1,"total_spent":92.36},{"id":51,"first_name":"Joseph","last_name":"Roberts","email":"leghik@ibuseah.io","address":"1753 Samove Glen","zipcode":"56362","city":"Loeliz","avatar":"https://robohash.org/86581827cc979a3ffb9c9bca92676208.png","birthday":"1993-06-11T23:02:01.499Z","first_seen":"2013-10-28T22:04:42.654Z","last_seen":"2016-10-10T19:22:07.580Z","has_ordered":true,"latest_purchase":"2015-08-19T08:27:08.209Z","has_newsletter":false,"groups":[],"nb_commands":2,"total_spent":225.32},{"id":52,"first_name":"Rose","last_name":"Kelly","email":"ivezijen@oli.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4eb67c3fd0076477061b459bfe21d5fe.png","birthday":null,"first_seen":"2014-11-18T17:50:10.266Z","last_seen":"2016-02-05T08:07:17.068Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":53,"first_name":"Johanna","last_name":"Rhodes","email":"makuv@teiguwi.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f0c58b634254b6e83e25b29deb14d8c3.png","birthday":null,"first_seen":"2014-03-03T21:43:10.678Z","last_seen":"2015-04-27T14:55:22.297Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":54,"first_name":"Cornelia","last_name":"Martin","email":"waaz@bugnici.org","address":"1962 Nijjit View","zipcode":"13870","city":"Pedawara","avatar":"https://robohash.org/89368cb9dd0fce0abae35425631ad9ea.png","birthday":"1998-12-24T09:41:48.345Z","first_seen":"2014-12-31T03:11:33.664Z","last_seen":"2016-12-28T14:31:28.027Z","has_ordered":true,"latest_purchase":"2016-03-08T19:34:42.412Z","has_newsletter":true,"groups":[],"nb_commands":2,"total_spent":174.66},{"id":55,"first_name":"Garrett","last_name":"Anderson","email":"umigil@doatodib.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/75b98038a5a83d8a222977b4a4e0764a.png","birthday":null,"first_seen":"2013-06-18T15:40:10.451Z","last_seen":"2016-03-05T03:42:29.199Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":56,"first_name":"Mike","last_name":"Ward","email":"akubi@sajceze.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a750bd40cd351cc833d82e4bed2b3ccd.png","birthday":null,"first_seen":"2015-08-13T03:23:53.939Z","last_seen":"2016-04-14T14:44:53.162Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":57,"first_name":"Brent","last_name":"Foster","email":"cektavco@okahe.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b11aeb15d312c522338216169bc26347.png","birthday":null,"first_seen":"2016-03-12T17:27:44.468Z","last_seen":"2016-09-27T05:45:15.806Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":58,"first_name":"Georgie","last_name":"Hudson","email":"haho@zutliwaf.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5fd22a085aa3f7c49b3f46ad0b6fc5a4.png","birthday":null,"first_seen":"2016-03-27T23:51:51.962Z","last_seen":"2016-09-19T22:44:38.731Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":59,"first_name":"Luis","last_name":"Huff","email":"bokepi@wipuh.edu","address":"669 Lube Pike","zipcode":"01989","city":"Purtafmi","avatar":"https://robohash.org/1c852eadb1ab44673b426defb6249b44.png","birthday":"1981-08-03T05:07:32.304Z","first_seen":"2014-03-06T05:13:52.251Z","last_seen":"2015-06-01T19:59:56.015Z","has_ordered":true,"latest_purchase":"2015-05-07T22:24:19.669Z","has_newsletter":false,"groups":["collector"],"nb_commands":3,"total_spent":1201.81},{"id":60,"first_name":"Clyde","last_name":"Hanson","email":"nis@iwcino.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/13d6927a2c298c11a97f72ab0fd6b341.png","birthday":null,"first_seen":"2016-11-16T20:47:53.874Z","last_seen":"2016-12-13T02:04:57.802Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":61,"first_name":"Kathryn","last_name":"Cooper","email":"reg@abarelziw.io","address":"1154 Pieni Boulevard","zipcode":"06136","city":"Oviopnan","avatar":"https://robohash.org/cec001137313f33a0f22eb8f78d61204.png","birthday":"1964-06-02T05:55:08.117Z","first_seen":"2016-10-18T13:51:50.944Z","last_seen":"2016-12-29T20:28:08.901Z","has_ordered":true,"latest_purchase":"2016-12-13T13:26:25.524Z","has_newsletter":true,"groups":["reviewer"],"nb_commands":4,"total_spent":710.3199999999999},{"id":62,"first_name":"Philip","last_name":"Hughes","email":"omta@inzipgar.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/9bda51db8ddc16ab3d44b9a6b899845a.png","birthday":null,"first_seen":"2015-10-05T13:43:37.432Z","last_seen":"2016-09-18T01:49:55.300Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":63,"first_name":"Lilly","last_name":"Banks","email":"cejfih@bavkofah.org","address":"1007 Lowa Grove","zipcode":"99222","city":"Zimningo","avatar":"https://robohash.org/69c4389d33b64c057b5c4df699ff834c.png","birthday":"1972-02-10T00:31:52.897Z","first_seen":"2015-05-26T11:48:55.261Z","last_seen":"2016-08-05T14:24:05.946Z","has_ordered":true,"latest_purchase":"2016-08-02T07:28:37.975Z","has_newsletter":true,"groups":["collector","compulsive"],"nb_commands":6,"total_spent":1582.56},{"id":64,"first_name":"Jesse","last_name":"Norris","email":"gobiw@gagibu.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/28f3a057077269cf8c9e50d85c33e52f.png","birthday":null,"first_seen":"2015-03-22T05:59:48.433Z","last_seen":"2016-12-18T13:34:26.414Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":65,"first_name":"Mark","last_name":"Henderson","email":"ko@kejgik.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f52a82c29765002a0960efc1485791c5.png","birthday":null,"first_seen":"2015-03-28T03:57:04.665Z","last_seen":"2015-12-06T16:50:25.345Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":66,"first_name":"Sam","last_name":"Miles","email":"igakij@ownam.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f47321a6955f2506b83afbf7658a2e6f.png","birthday":null,"first_seen":"2016-01-26T01:06:31.416Z","last_seen":"2016-08-15T18:16:18.797Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":67,"first_name":"Don","last_name":"Hamilton","email":"cor@gohjegki.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/098775bcc34cf70fabaceb166eeb4f19.png","birthday":null,"first_seen":"2013-10-27T13:16:04.003Z","last_seen":"2014-12-09T10:25:50.781Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":68,"first_name":"Rena","last_name":"Coleman","email":"ba@mubi.co.uk","address":"1053 Heaz River","zipcode":"88778","city":"Dilpehge","avatar":"https://robohash.org/09f61abae545b31c781984f97f12f425.png","birthday":"1974-05-21T03:42:21.714Z","first_seen":"2016-01-17T06:19:44.523Z","last_seen":"2016-11-20T00:43:30.948Z","has_ordered":true,"latest_purchase":null,"has_newsletter":false,"groups":[],"nb_commands":0,"total_spent":0},{"id":69,"first_name":"Bertie","last_name":"Saunders","email":"bizomke@tezpesrur.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8f8a3c6a78c7c9f9b756324c0335eed3.png","birthday":null,"first_seen":"2015-05-16T03:17:15.065Z","last_seen":"2016-01-04T23:54:00.691Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":70,"first_name":"Edith","last_name":"Davidson","email":"giodja@reoj.com","address":"612 Fibav Parkway","zipcode":"58098","city":"Tukasibi","avatar":"https://robohash.org/640e36f4ee0e602bc9348a7e8801b6ba.png","birthday":"1969-06-07T09:31:47.549Z","first_seen":"2015-04-02T23:09:04.754Z","last_seen":"2016-10-01T11:59:29.045Z","has_ordered":true,"latest_purchase":"2016-03-22T13:05:19.618Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":77.05},{"id":71,"first_name":"Martha","last_name":"Warren","email":"vosmen@an.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/806a8afca66f8064f2fc1d823c9d0e23.png","birthday":null,"first_seen":"2013-02-17T21:55:32.361Z","last_seen":"2017-01-01T16:44:50.356Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":72,"first_name":"Alexander","last_name":"Myers","email":"tubuho@ononiv.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7d5e44b3b3f87e5bcf2ffc69293ed7a1.png","birthday":null,"first_seen":"2013-03-03T01:50:00.160Z","last_seen":"2015-12-24T23:55:09.530Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":73,"first_name":"Rosalie","last_name":"Delgado","email":"wicgaf@rol.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/91c8947eca125a7ccd011318dcb0a961.png","birthday":null,"first_seen":"2016-12-18T08:18:47.963Z","last_seen":"2016-12-29T19:46:26.562Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":74,"first_name":"Jerry","last_name":"Washington","email":"vualpu@ponhi.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/acebea60bd012d501dc2d1254b5331bd.png","birthday":null,"first_seen":"2016-07-07T05:50:14.480Z","last_seen":"2016-11-25T15:27:18.475Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":75,"first_name":"Rhoda","last_name":"Gibson","email":"pukpoditu@gaemdo.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4358c809d60eff68769c0e1812f4e693.png","birthday":null,"first_seen":"2016-03-12T10:33:17.344Z","last_seen":"2016-07-26T13:49:03.070Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":76,"first_name":"May","last_name":"Barton","email":"cumso@uwem.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a6d6a74942fc555201985a0f7c080a84.png","birthday":null,"first_seen":"2013-06-01T17:34:39.604Z","last_seen":"2016-07-10T02:04:18.131Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":77,"first_name":"Alma","last_name":"Cunningham","email":"vi@os.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d711d13b5ee7b790bf25eb9101496e1d.png","birthday":null,"first_seen":"2015-06-03T00:57:08.307Z","last_seen":"2016-05-05T17:59:41.241Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":78,"first_name":"Clarence","last_name":"Massey","email":"ni@codufoaso.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2ce2ffa4ed1ae43e27cfa5d3e770a0ca.png","birthday":null,"first_seen":"2014-02-04T03:54:41.105Z","last_seen":"2015-05-25T10:55:20.858Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":79,"first_name":"Elsie","last_name":"Brown","email":"ru@tuk.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/803e53912e4a94803b342acd9d96fa7d.png","birthday":null,"first_seen":"2014-07-25T10:27:36.103Z","last_seen":"2016-10-12T11:16:13.834Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":80,"first_name":"Georgie","last_name":"Colon","email":"cuzegi@jocage.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/681f96df5c9aee66cd4cc622ed25391a.png","birthday":null,"first_seen":"2016-05-06T17:49:54.028Z","last_seen":"2016-11-03T20:18:45.237Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":81,"first_name":"Sarah","last_name":"Sanders","email":"li@buzcevu.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/02343c8f5bdcb53223a2a96cfcefa5bd.png","birthday":null,"first_seen":"2016-06-27T15:01:26.605Z","last_seen":"2016-12-30T00:47:39.861Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":82,"first_name":"Glenn","last_name":"Gray","email":"itu@japkekrun.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c84730b5f54488d1585839840c86e2b4.png","birthday":null,"first_seen":"2016-10-22T09:58:09.568Z","last_seen":"2016-12-05T22:34:43.698Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":83,"first_name":"Ivan","last_name":"Simmons","email":"wup@hi.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3ea92ee2de8c483c5756e9b0bc1204a2.png","birthday":null,"first_seen":"2016-12-30T08:24:30.175Z","last_seen":"2017-01-05T03:58:52.353Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":84,"first_name":"Myrtie","last_name":"Neal","email":"zijjuko@ip.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/79051b28b41160b636875ed8ba54fdab.png","birthday":null,"first_seen":"2014-09-23T11:21:38.465Z","last_seen":"2015-11-18T22:35:52.444Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":85,"first_name":"Alexander","last_name":"Bradley","email":"vi@javjab.gov","address":"1145 Kehoj Manor","zipcode":"38667","city":"Fewposoz","avatar":"https://robohash.org/9a4d04e92ded71c6e7b6bc7d9920edf8.png","birthday":"1959-05-07T05:22:41.462Z","first_seen":"2016-11-24T18:10:16.855Z","last_seen":"2016-12-22T19:36:35.635Z","has_ordered":true,"latest_purchase":"2016-12-20T11:02:00.526Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":2,"total_spent":517.49},{"id":86,"first_name":"Ann","last_name":"Reynolds","email":"huzu@onumiw.org","address":"1688 Dutu Manor","zipcode":"46981","city":"Nuguhlic","avatar":"https://robohash.org/f88a932d4dda746f8deecc0183630f50.png","birthday":"1954-02-26T10:21:27.218Z","first_seen":"2013-06-17T14:34:21.280Z","last_seen":"2015-09-06T00:21:07.184Z","has_ordered":true,"latest_purchase":"2014-10-10T20:22:32.910Z","has_newsletter":true,"groups":[],"nb_commands":3,"total_spent":563.26},{"id":87,"first_name":"Tyler","last_name":"Curtis","email":"mizat@nehenoce.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a9634fcb9abf601a8830d986c9f1955f.png","birthday":null,"first_seen":"2016-03-24T21:56:01.079Z","last_seen":"2016-10-13T03:51:36.648Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":88,"first_name":"Bernice","last_name":"Boone","email":"likof@vufniwdib.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e934fa57ecace7b82b543748e25674c3.png","birthday":null,"first_seen":"2014-05-17T13:26:00.540Z","last_seen":"2014-12-22T20:34:21.640Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":89,"first_name":"Frederick","last_name":"Fuller","email":"mo@del.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/90f823db6c7511bc1dfc798fd352e280.png","birthday":null,"first_seen":"2014-10-11T06:04:26.126Z","last_seen":"2015-06-24T18:33:15.626Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":90,"first_name":"Jason","last_name":"Poole","email":"alu@gumobi.gov","address":"430 Robtom Junction","zipcode":"65640","city":"Ijjaldiv","avatar":"https://robohash.org/98ba5f6469b7989b6a8af0d0f15540ff.png","birthday":"1997-10-03T02:38:17.005Z","first_seen":"2016-08-05T22:45:09.382Z","last_seen":"2016-10-14T20:33:53.555Z","has_ordered":true,"latest_purchase":"2016-10-10T04:26:53.160Z","has_newsletter":false,"groups":["collector","compulsive","regular","reviewer"],"nb_commands":8,"total_spent":2317.82},{"id":91,"first_name":"Brandon","last_name":"Ryan","email":"buluwam@iju.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8f0f07c7deac3e1f7922db16e9d9c44e.png","birthday":null,"first_seen":"2015-06-20T09:20:32.213Z","last_seen":"2016-09-12T09:00:55.854Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":92,"first_name":"Ricky","last_name":"Brown","email":"izuaronu@irmelaz.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/926de62989132b7ecf2c8a5886a8aa03.png","birthday":null,"first_seen":"2012-06-09T15:46:42.170Z","last_seen":"2013-10-10T22:35:09.838Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":93,"first_name":"Randy","last_name":"McDaniel","email":"bof@wakmuk.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7bbe5790df792796fa6adb2ed31aa992.png","birthday":null,"first_seen":"2015-12-03T15:00:28.314Z","last_seen":"2016-10-14T10:57:15.726Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":94,"first_name":"Theodore","last_name":"Owens","email":"af@fihun.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/dbf16ee2f25bbdcfb950ff818a711dc7.png","birthday":null,"first_seen":"2013-11-06T17:48:12.751Z","last_seen":"2014-09-21T01:33:30.133Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":95,"first_name":"Douglas","last_name":"Lucas","email":"abliw@sol.org","address":"207 Monen Grove","zipcode":"69065","city":"Cimubtum","avatar":"https://robohash.org/9b1e9212f1d602f4fdff61e003600aeb.png","birthday":"1961-03-24T08:28:13.006Z","first_seen":"2015-06-08T15:31:24.656Z","last_seen":"2016-09-05T02:47:01.107Z","has_ordered":true,"latest_purchase":"2016-07-19T15:13:21.450Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":820.4200000000001},{"id":96,"first_name":"Betty","last_name":"Ruiz","email":"ke@ewvewfet.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d814e046bb62b15b2a97051e8ec96333.png","birthday":null,"first_seen":"2013-01-10T06:28:34.665Z","last_seen":"2016-07-14T07:26:30.912Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":97,"first_name":"Lawrence","last_name":"Reeves","email":"ruggopujo@zi.org","address":"1936 Uhec Drive","zipcode":"12191","city":"Nefubko","avatar":"https://robohash.org/08aa8e86527952ead28c1a43eae58c95.png","birthday":"1959-03-10T02:00:25.027Z","first_seen":"2016-02-08T21:23:51.101Z","last_seen":"2016-09-26T01:59:41.514Z","has_ordered":true,"latest_purchase":"2016-07-12T04:12:01.246Z","has_newsletter":false,"groups":["collector","reviewer"],"nb_commands":2,"total_spent":831.9},{"id":98,"first_name":"Matthew","last_name":"Hughes","email":"livkagew@duvujub.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/38fada62f212a125992970d42cb8cba0.png","birthday":null,"first_seen":"2015-07-06T11:33:51.794Z","last_seen":"2016-11-29T20:32:01.161Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":99,"first_name":"Helen","last_name":"Dawson","email":"jew@ko.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/00a0d26b7afc83ad3fce549d28d93781.png","birthday":null,"first_seen":"2016-04-01T21:26:17.903Z","last_seen":"2016-12-08T16:03:41.096Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":100,"first_name":"Louise","last_name":"Day","email":"su@waelvi.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/199649e66d866bcea7bfabc364a64172.png","birthday":null,"first_seen":"2014-10-22T16:35:36.458Z","last_seen":"2016-07-23T04:13:23.530Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":101,"first_name":"Rose","last_name":"Thompson","email":"acemeus@lasaworo.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/711f713391d8025cb1d120d73e0297ab.png","birthday":null,"first_seen":"2013-12-13T21:17:35.133Z","last_seen":"2016-03-02T05:19:49.063Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":102,"first_name":"Frank","last_name":"Bass","email":"wahaz@lihuw.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4f4f11b3080d8edf583c390521fe9085.png","birthday":null,"first_seen":"2013-07-28T06:50:16.101Z","last_seen":"2016-01-05T15:52:04.212Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":103,"first_name":"Sophia","last_name":"Evans","email":"abimfu@gubmu.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/55469e60522b85124053d2ca13994ef9.png","birthday":null,"first_seen":"2016-10-15T18:29:17.990Z","last_seen":"2016-11-24T07:07:44.630Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":104,"first_name":"Justin","last_name":"Schneider","email":"ga@ekhonka.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6eef12f6c6ed321a042c33f4c4e77e1c.png","birthday":null,"first_seen":"2014-05-15T02:26:38.388Z","last_seen":"2015-03-23T21:11:45.180Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":105,"first_name":"John","last_name":"Roy","email":"saiduad@je.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/dba402bf806e39e51a3ea2e0f594c45f.png","birthday":null,"first_seen":"2015-05-23T03:16:21.921Z","last_seen":"2016-07-23T09:51:22.784Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":106,"first_name":"Brandon","last_name":"Carroll","email":"sutoli@epa.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ebb386638b5c2d945c8bf47e69c8c2fe.png","birthday":null,"first_seen":"2016-12-06T19:21:43.240Z","last_seen":"2016-12-26T09:10:26.567Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":107,"first_name":"Sally","last_name":"Holland","email":"ifo@kegoj.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/73332fcd86b73aa434a49f7ad7f7ab3e.png","birthday":null,"first_seen":"2015-07-18T09:43:10.219Z","last_seen":"2016-08-29T19:18:55.119Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":108,"first_name":"Nell","last_name":"Strickland","email":"imaejto@medoc.io","address":"1907 Fuic Parkway","zipcode":"61309","city":"Gujtubu","avatar":"https://robohash.org/1e28427669b58d85ebeef59b6c0ede57.png","birthday":"1987-01-19T11:45:27.840Z","first_seen":"2014-04-20T20:41:28.555Z","last_seen":"2014-11-30T18:56:36.899Z","has_ordered":true,"latest_purchase":"2014-11-14T06:34:46.234Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":4,"total_spent":355.21000000000004},{"id":109,"first_name":"Charles","last_name":"Kennedy","email":"woihpa@kuwibbe.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a02f2aa973e67396b11be93e21afaf32.png","birthday":null,"first_seen":"2016-05-21T04:31:45.134Z","last_seen":"2016-10-28T20:33:56.928Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":110,"first_name":"Ella","last_name":"Thompson","email":"arlengo@derida.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1231ff61d25f52734a8a91d88d99b0bb.png","birthday":null,"first_seen":"2015-08-20T00:34:26.278Z","last_seen":"2016-12-20T01:56:17.503Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":111,"first_name":"Patrick","last_name":"Wright","email":"agakup@iwaar.co.uk","address":"1464 Cugib Place","zipcode":"04418","city":"Kuhizokap","avatar":"https://robohash.org/e6e30e1228cac475b46ddcecd53404df.png","birthday":"1988-05-06T03:59:52.863Z","first_seen":"2015-08-28T15:14:33.299Z","last_seen":"2016-12-22T22:43:45.946Z","has_ordered":true,"latest_purchase":"2016-08-24T15:03:03.642Z","has_newsletter":false,"groups":["collector"],"nb_commands":3,"total_spent":1379.4699999999998},{"id":112,"first_name":"Rose","last_name":"Andrews","email":"tafa@javelfib.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e482a28ad194ba15a43dfcb3c50f7eed.png","birthday":null,"first_seen":"2016-12-31T12:43:38.222Z","last_seen":"2017-01-03T23:52:53.003Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":113,"first_name":"Ralph","last_name":"Carter","email":"jojtitre@za.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2a53de783d7eb43e8fda9af4cde50445.png","birthday":null,"first_seen":"2015-08-20T16:20:12.328Z","last_seen":"2016-10-19T14:50:55.124Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":114,"first_name":"Brett","last_name":"Gomez","email":"jabvoprij@anjucku.io","address":"797 Jesaf Key","zipcode":"29891","city":"Tikroman","avatar":"https://robohash.org/f20152e48727d9a95779108daf40e14e.png","birthday":"1957-03-21T10:09:28.675Z","first_seen":"2014-02-24T01:09:43.809Z","last_seen":"2014-07-14T10:12:32.282Z","has_ordered":true,"latest_purchase":"2014-06-24T22:44:26.272Z","has_newsletter":false,"groups":["collector","regular","returns","reviewer"],"nb_commands":5,"total_spent":1352.77},{"id":115,"first_name":"Harriet","last_name":"Vega","email":"azovawa@culcazo.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/806d53154dc6dd80e624b9d7896a456b.png","birthday":null,"first_seen":"2015-04-07T20:59:13.804Z","last_seen":"2016-08-22T09:13:18.591Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":116,"first_name":"Mark","last_name":"Sims","email":"atejarrut@cejkeli.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f6a4b3d614ac08523f01a0aa25347b1b.png","birthday":null,"first_seen":"2016-07-23T00:13:40.523Z","last_seen":"2016-10-07T08:58:53.631Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":117,"first_name":"Augusta","last_name":"Lucas","email":"gezip@uk.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d6933d9a4d7f5d1262bd6332685060da.png","birthday":null,"first_seen":"2016-10-15T12:23:55.595Z","last_seen":"2017-01-01T16:37:00.266Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":118,"first_name":"Lula","last_name":"Holt","email":"gufzem@esi.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e378213e05a12c160550d8dd327c3a77.png","birthday":null,"first_seen":"2015-11-24T12:23:57.023Z","last_seen":"2016-12-31T11:46:43.498Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":119,"first_name":"Cora","last_name":"French","email":"he@wesonih.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3dc8c2a7b71d8d1eb7b41b4e2ae0c451.png","birthday":null,"first_seen":"2016-01-29T11:27:36.253Z","last_seen":"2016-08-26T13:08:15.078Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":120,"first_name":"Christine","last_name":"Bailey","email":"waeci@us.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/9b71ccbd62e152b2cc5ce2ca30e1f1f1.png","birthday":null,"first_seen":"2015-03-10T00:32:54.736Z","last_seen":"2016-11-30T10:09:10.811Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":121,"first_name":"Isabel","last_name":"Barber","email":"jap@kevod.edu","address":"665 Vodi River","zipcode":"68941","city":"Momzoec","avatar":"https://robohash.org/d3c46685321414dee9eb5fbcdfe1c6f5.png","birthday":"1970-10-03T08:08:40.878Z","first_seen":"2015-06-17T18:09:46.444Z","last_seen":"2016-08-29T18:14:48.034Z","has_ordered":true,"latest_purchase":"2016-05-29T09:54:30.126Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":339.85},{"id":122,"first_name":"Maud","last_name":"Weber","email":"fihi@jelha.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/017cbbe60ddc9c53d33b16c893f7d37d.png","birthday":null,"first_seen":"2016-01-12T03:46:04.877Z","last_seen":"2016-09-10T07:33:01.248Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":123,"first_name":"Mary","last_name":"Flores","email":"su@joto.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/72a8f9dd3a375e77a6ad5b6f145954d0.png","birthday":null,"first_seen":"2015-12-18T03:28:54.392Z","last_seen":"2016-05-23T10:24:48.426Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":124,"first_name":"Douglas","last_name":"Houston","email":"zarelo@ri.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7befc1c2fdae95bac23e1fddc5b8a9e3.png","birthday":null,"first_seen":"2013-12-12T16:32:25.762Z","last_seen":"2015-07-05T19:28:06.203Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":125,"first_name":"Martin","last_name":"Beck","email":"da@dejwew.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/71ce9e278bd70bf4108e196354864a6b.png","birthday":null,"first_seen":"2014-12-23T08:31:46.378Z","last_seen":"2016-11-14T18:52:12.951Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":126,"first_name":"Barry","last_name":"Benson","email":"weug@hu.net","address":"1562 Acvaw Drive","zipcode":"14018","city":"Bakwadfal","avatar":"https://robohash.org/f38c11e7434ea901630038ed1e3be0f5.png","birthday":"1975-01-19T09:22:30.020Z","first_seen":"2015-08-31T18:48:39.417Z","last_seen":"2016-01-20T04:31:26.449Z","has_ordered":true,"latest_purchase":"2015-12-30T01:23:42.961Z","has_newsletter":false,"groups":[],"nb_commands":2,"total_spent":372.77},{"id":127,"first_name":"Ronald","last_name":"James","email":"eja@maj.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/80f1fc500a7dd615425ef71764482609.png","birthday":null,"first_seen":"2015-08-27T21:38:54.334Z","last_seen":"2016-07-11T20:59:18.900Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":128,"first_name":"Jason","last_name":"King","email":"ezzer@umaradnit.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8a399c55380425c8d1ef36b6995167a5.png","birthday":null,"first_seen":"2016-10-11T05:39:03.980Z","last_seen":"2016-12-17T03:37:14.978Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":129,"first_name":"Jon","last_name":"Diaz","email":"jokkob@leblik.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/88d006f187f065a17dcb3d6f925ffda4.png","birthday":null,"first_seen":"2014-05-15T15:56:33.459Z","last_seen":"2014-12-08T08:44:16.934Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":130,"first_name":"Andrew","last_name":"McCormick","email":"dam@huwahra.net","address":"33 Nakip Extension","zipcode":"47937","city":"Bilhelluh","avatar":"https://robohash.org/0fad870c0140cd021af972e512156749.png","birthday":"1987-12-17T03:05:47.423Z","first_seen":"2015-06-08T01:23:13.994Z","last_seen":"2015-11-01T18:04:32.994Z","has_ordered":true,"latest_purchase":"2015-09-24T10:43:39.893Z","has_newsletter":true,"groups":["collector","regular"],"nb_commands":3,"total_spent":1119.99},{"id":131,"first_name":"Austin","last_name":"McCormick","email":"wa@bazajzac.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/cf22848f77a4e7c1515e352f3f02551c.png","birthday":null,"first_seen":"2016-11-02T02:55:40.291Z","last_seen":"2016-12-19T11:40:22.885Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":132,"first_name":"Jackson","last_name":"Moreno","email":"walevne@mif.org","address":"905 Ikito Square","zipcode":"65172","city":"Uzsilnod","avatar":"https://robohash.org/3088e2529283f020fe96f6d7e99360e4.png","birthday":"1958-12-14T08:19:28.045Z","first_seen":"2015-05-24T06:32:06.275Z","last_seen":"2016-02-24T22:53:39.230Z","has_ordered":true,"latest_purchase":"2016-01-28T09:02:22.769Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":2,"total_spent":107.13000000000001},{"id":133,"first_name":"Gerald","last_name":"Vega","email":"podsaz@zibaso.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6d24fc6920ef6fad469393d489ba884e.png","birthday":null,"first_seen":"2015-11-15T13:44:57.374Z","last_seen":"2016-10-30T07:00:20.464Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":134,"first_name":"Bessie","last_name":"Watts","email":"umopabe@pujwoc.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/344f49bf2ff551320d7b09d1a2218ee9.png","birthday":null,"first_seen":"2016-12-07T14:52:41.625Z","last_seen":"2016-12-27T16:56:34.737Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":135,"first_name":"Marguerite","last_name":"Franklin","email":"cibusel@veg.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/bcb76a88105d7589f395f13479b7cd34.png","birthday":null,"first_seen":"2014-06-09T18:05:29.810Z","last_seen":"2015-11-08T20:58:05.516Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":136,"first_name":"Rosie","last_name":"Hall","email":"mot@epwe.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c5515edcb8182d0aa7176e795170af86.png","birthday":null,"first_seen":"2016-08-21T16:42:59.787Z","last_seen":"2016-12-02T10:22:55.227Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":137,"first_name":"Shane","last_name":"Delgado","email":"gubonuuw@ahpab.io","address":"1372 Opaduj Square","zipcode":"17988","city":"Ovabiwe","avatar":"https://robohash.org/ad2e66c3601027921ff50036ab6d808b.png","birthday":"1977-10-05T07:57:21.037Z","first_seen":"2016-09-17T10:17:54.125Z","last_seen":"2016-11-16T21:09:23.815Z","has_ordered":true,"latest_purchase":"2016-11-16T19:30:53.697Z","has_newsletter":true,"groups":[],"nb_commands":3,"total_spent":219.44000000000003},{"id":138,"first_name":"Curtis","last_name":"Carlson","email":"wezbo@mah.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/608fc46150151f67ee0ac7ecc400fd14.png","birthday":null,"first_seen":"2012-09-03T01:31:06.920Z","last_seen":"2014-10-10T03:57:36.144Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":139,"first_name":"Brett","last_name":"Ray","email":"tifehe@regacpaz.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c538411f57d2f3e8068c634f1dc13f82.png","birthday":null,"first_seen":"2013-05-23T14:16:20.177Z","last_seen":"2015-09-28T07:54:00.971Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":140,"first_name":"Leonard","last_name":"Reynolds","email":"hoptahbo@rovetsa.gov","address":"1987 Jabiw Road","zipcode":"76234","city":"Dozanok","avatar":"https://robohash.org/a31900a5336aa23c351c39d6467b5e11.png","birthday":"1956-10-24T07:42:19.883Z","first_seen":"2014-12-28T13:43:06.113Z","last_seen":"2016-08-14T06:06:02.022Z","has_ordered":true,"latest_purchase":"2015-12-31T21:47:50.148Z","has_newsletter":true,"groups":["ordered_once"],"nb_commands":1,"total_spent":58.56},{"id":141,"first_name":"Mario","last_name":"Mendoza","email":"kuvgo@doszukcoz.org","address":"1784 Poik Pass","zipcode":"86260","city":"Nawfouve","avatar":"https://robohash.org/0bab898158c7004558ccd51651dff32e.png","birthday":"1974-01-05T07:26:14.815Z","first_seen":"2016-12-28T21:56:19.617Z","last_seen":"2017-01-01T23:32:47.342Z","has_ordered":true,"latest_purchase":"2017-01-01T02:43:00.547Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":127.72},{"id":142,"first_name":"Elva","last_name":"Mendoza","email":"hertomku@camiz.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8a9659af884905324d9513160d64951f.png","birthday":null,"first_seen":"2013-05-27T15:44:22.511Z","last_seen":"2016-03-26T11:47:17.069Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":143,"first_name":"Lola","last_name":"Evans","email":"ju@ib.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/93fe6f1dfd1c48a2cf8d1e1db4c5a1aa.png","birthday":null,"first_seen":"2015-12-31T00:19:13.825Z","last_seen":"2016-10-14T16:53:48.247Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":144,"first_name":"Adrian","last_name":"Palmer","email":"ceravobiv@sepfe.org","address":"671 Fuzwa Road","zipcode":"75872","city":"Wuuwguk","avatar":"https://robohash.org/60388ee217061dfabcdc46ab6e137857.png","birthday":"1960-11-16T07:54:40.997Z","first_seen":"2016-04-15T16:45:07.243Z","last_seen":"2016-12-18T05:45:50.418Z","has_ordered":true,"latest_purchase":"2016-12-09T04:33:36.952Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":4,"total_spent":1322.1100000000001},{"id":145,"first_name":"Lucille","last_name":"Norton","email":"do@lob.edu","address":"631 Deva Junction","zipcode":"29200","city":"Taejkad","avatar":"https://robohash.org/954a865593adbf686b5df6a9c6f6c370.png","birthday":"1990-01-11T03:21:41.008Z","first_seen":"2014-07-19T03:18:10.145Z","last_seen":"2016-09-28T20:00:43.307Z","has_ordered":true,"latest_purchase":"2016-03-20T06:26:22.349Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":47.23},{"id":146,"first_name":"Owen","last_name":"Crawford","email":"pa@jigor.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e108881e344a2b66aeba99e96b2489f1.png","birthday":null,"first_seen":"2015-10-29T09:52:00.715Z","last_seen":"2016-04-11T19:14:08.822Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":147,"first_name":"Owen","last_name":"Snyder","email":"veckauv@uveabieji.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e69f5339e54b096fcffd8fcab73c3827.png","birthday":null,"first_seen":"2015-09-25T09:58:27.123Z","last_seen":"2016-03-05T21:50:29.166Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":148,"first_name":"Stanley","last_name":"Ingram","email":"iwe@oslok.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ed3cd0dbcc695d7d144741016cea1c5e.png","birthday":null,"first_seen":"2013-09-13T12:08:31.025Z","last_seen":"2016-12-06T16:09:35.105Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":149,"first_name":"Chris","last_name":"Payne","email":"rizefte@sadohro.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/9c88523a2619893177f5d3c93f0b548f.png","birthday":null,"first_seen":"2016-11-26T14:30:31.037Z","last_seen":"2016-12-25T14:09:11.020Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":150,"first_name":"Roxie","last_name":"Sparks","email":"nir@zoc.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/acace8fa64c00eaffcee98f43ccf00a9.png","birthday":null,"first_seen":"2015-11-04T22:35:13.781Z","last_seen":"2017-01-02T11:35:41.615Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":151,"first_name":"Hester","last_name":"Reese","email":"vilib@enevil.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0b98cd62f7d76929497363738377d5e1.png","birthday":null,"first_seen":"2015-05-01T22:26:07.615Z","last_seen":"2016-06-16T11:14:02.613Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":152,"first_name":"Elmer","last_name":"Jordan","email":"hicsudre@horire.org","address":"53 Cigeh Plaza","zipcode":"27423","city":"Kelluwam","avatar":"https://robohash.org/b76224197da54f1c26a434533415de01.png","birthday":"1962-05-21T10:23:52.219Z","first_seen":"2013-02-16T09:45:25.835Z","last_seen":"2016-04-25T21:32:01.146Z","has_ordered":true,"latest_purchase":"2016-03-24T00:18:47.769Z","has_newsletter":true,"groups":["regular","reviewer"],"nb_commands":3,"total_spent":268.77},{"id":153,"first_name":"Millie","last_name":"Cohen","email":"hij@hiwcad.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/69a37c8a89d713d8d48b39a6662c762f.png","birthday":null,"first_seen":"2016-01-29T00:52:07.035Z","last_seen":"2016-12-20T21:16:05.467Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":154,"first_name":"Della","last_name":"Colon","email":"itaijo@nomiwe.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1cd2e7f2991a2e47c655a2b493529cdb.png","birthday":null,"first_seen":"2014-05-26T18:55:57.509Z","last_seen":"2016-10-31T04:36:17.170Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":155,"first_name":"Ann","last_name":"Dawson","email":"rokufho@me.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f0bf8b6850416935ac7a8d639930caa9.png","birthday":null,"first_seen":"2016-07-22T19:24:51.452Z","last_seen":"2017-01-02T02:06:59.700Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":156,"first_name":"Billy","last_name":"Smith","email":"nicera@uwatendu.org","address":"295 Hijsu Boulevard","zipcode":"47290","city":"Karwuko","avatar":"https://robohash.org/b890194a483c9e3ee23db8d9329e00a7.png","birthday":"1966-09-15T03:52:20.425Z","first_seen":"2014-03-09T03:01:33.010Z","last_seen":"2016-09-08T16:20:44.189Z","has_ordered":true,"latest_purchase":"2016-07-05T01:03:36.492Z","has_newsletter":true,"groups":["reviewer"],"nb_commands":3,"total_spent":321.71000000000004},{"id":157,"first_name":"Carolyn","last_name":"Yates","email":"vicunub@laze.edu","address":"777 Vieto Point","zipcode":"58095","city":"Mecukki","avatar":"https://robohash.org/a47e8010d5d3edc69ef6ed6727c62584.png","birthday":"1971-03-28T02:37:05.101Z","first_seen":"2013-02-09T00:40:43.052Z","last_seen":"2015-10-22T22:11:11.439Z","has_ordered":true,"latest_purchase":"2015-09-15T02:08:11.091Z","has_newsletter":false,"groups":["collector","reviewer"],"nb_commands":6,"total_spent":1177.2900000000002},{"id":158,"first_name":"Roy","last_name":"Ramos","email":"muso@pe.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/45ecfa96bd8771b20a8957457f24e9dd.png","birthday":null,"first_seen":"2016-05-04T20:55:20.068Z","last_seen":"2016-11-28T14:31:14.173Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":159,"first_name":"Nannie","last_name":"Larson","email":"cam@jifusuwal.co.uk","address":"952 Inoliw Drive","zipcode":"11663","city":"Zejerdan","avatar":"https://robohash.org/6767ddf0e5a5b47c5929e3af0f488b02.png","birthday":"1955-02-22T09:47:50.873Z","first_seen":"2013-11-30T09:36:45.807Z","last_seen":"2016-12-07T06:38:04.490Z","has_ordered":true,"latest_purchase":"2016-10-09T20:47:23.592Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":4,"total_spent":596.81},{"id":160,"first_name":"Leroy","last_name":"Collier","email":"meptozcus@najbior.io","address":"931 Sorir Manor","zipcode":"84203","city":"Ewogahvu","avatar":"https://robohash.org/b4807edac4c810440108f979fce33273.png","birthday":"1966-09-16T05:08:00.283Z","first_seen":"2015-11-01T06:06:46.791Z","last_seen":"2016-08-30T09:20:58.107Z","has_ordered":true,"latest_purchase":"2016-03-28T21:53:36.733Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":37.85},{"id":161,"first_name":"Bertha","last_name":"Griffin","email":"tiuv@iwke.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3f5e99552580370d00f201991182b27c.png","birthday":null,"first_seen":"2015-09-25T15:15:03.875Z","last_seen":"2016-10-22T00:52:11.296Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":162,"first_name":"Dora","last_name":"Hardy","email":"bohuuh@fusoje.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7761d0d88c956a5386ce7dca34f64519.png","birthday":null,"first_seen":"2016-10-13T02:50:21.090Z","last_seen":"2016-11-25T11:31:30.883Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":163,"first_name":"Curtis","last_name":"Nash","email":"gez@usmope.co.uk","address":"1587 Roba Ridge","zipcode":"52057","city":"Lezisdor","avatar":"https://robohash.org/da6180a373a043f6a28a83f5a2f8448a.png","birthday":"1981-10-21T09:21:06.125Z","first_seen":"2015-05-11T02:00:06.886Z","last_seen":"2016-11-16T17:23:29.934Z","has_ordered":true,"latest_purchase":"2016-10-11T05:05:24.133Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":33.42},{"id":164,"first_name":"Joel","last_name":"Collins","email":"keem@itojiv.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/305158f5a542d1790cd890fdb79fc5eb.png","birthday":null,"first_seen":"2015-08-12T02:10:52.773Z","last_seen":"2016-10-03T17:52:59.589Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":165,"first_name":"Alvin","last_name":"Byrd","email":"ezi@pouli.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3a486d313d1bfd83f1462bb12a5d7c24.png","birthday":null,"first_seen":"2016-01-09T18:45:37.789Z","last_seen":"2016-11-26T02:06:17.200Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":166,"first_name":"Vera","last_name":"Hansen","email":"fanit@tufnar.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/43dcc64c525438d16a98b9e3c9fbb69d.png","birthday":null,"first_seen":"2013-11-19T05:21:59.577Z","last_seen":"2016-11-26T16:13:21.918Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":167,"first_name":"Bertie","last_name":"Gibson","email":"nal@ked.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f49be4f6ab55b7fce9379441e20db324.png","birthday":null,"first_seen":"2016-09-01T23:17:24.950Z","last_seen":"2016-12-02T02:03:00.119Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":168,"first_name":"Julian","last_name":"Potter","email":"lecuko@todul.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/26cde0281b6c6029b78c8e12b4ad35ef.png","birthday":null,"first_seen":"2014-04-27T12:47:16.603Z","last_seen":"2016-09-04T10:17:06.063Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":169,"first_name":"Micheal","last_name":"Rose","email":"wu@nus.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/363e06daf1a0bdf9bcf5435b6c3aa70c.png","birthday":null,"first_seen":"2015-06-13T03:04:44.291Z","last_seen":"2016-10-20T01:43:23.494Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":170,"first_name":"Lucy","last_name":"Hogan","email":"no@efpe.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2515129b3aaa61e5214ebb9f5adf2706.png","birthday":null,"first_seen":"2016-12-12T14:16:15.493Z","last_seen":"2016-12-28T09:00:06.010Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":171,"first_name":"Cynthia","last_name":"Dawson","email":"ohru@ukpafa.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d222ad011332403b2d102c60a7c54795.png","birthday":null,"first_seen":"2014-11-21T20:58:12.861Z","last_seen":"2016-12-28T13:33:49.093Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":172,"first_name":"Ricardo","last_name":"Curtis","email":"zewolrug@rasbodteh.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0940344f4dac9222b9d260233124009a.png","birthday":null,"first_seen":"2015-11-14T10:54:43.347Z","last_seen":"2016-02-29T21:46:04.639Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":173,"first_name":"Barbara","last_name":"Maldonado","email":"todic@abohag.co.uk","address":"720 Juczaw Boulevard","zipcode":"89523","city":"Locmurhob","avatar":"https://robohash.org/c8197512edf01b52a0c139545a280ed5.png","birthday":"1992-01-20T00:57:02.544Z","first_seen":"2015-09-22T17:09:13.643Z","last_seen":"2015-12-26T06:15:43.714Z","has_ordered":true,"latest_purchase":null,"has_newsletter":false,"groups":[],"nb_commands":0,"total_spent":0},{"id":174,"first_name":"Jimmy","last_name":"George","email":"iw@rizgaz.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ff9261248549c72c0655ed00f30216cd.png","birthday":null,"first_seen":"2014-07-07T11:26:46.242Z","last_seen":"2015-01-05T15:14:35.307Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":175,"first_name":"Olga","last_name":"Graves","email":"emucedu@watgoh.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6cebbe140b7ab399e0fa6663717f5ef3.png","birthday":null,"first_seen":"2016-03-18T23:41:39.625Z","last_seen":"2016-11-18T00:58:20.381Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":176,"first_name":"Augusta","last_name":"Walters","email":"tu@saldihka.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/dafa8f04e03866877df20c21b16ebd0e.png","birthday":null,"first_seen":"2015-06-19T04:18:05.236Z","last_seen":"2016-01-18T04:57:05.117Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":177,"first_name":"Gabriel","last_name":"Parks","email":"vujejbah@nolgob.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8434a19fb58c93e04e91686179eed599.png","birthday":null,"first_seen":"2014-07-06T03:15:02.136Z","last_seen":"2016-11-19T01:44:36.434Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":178,"first_name":"Harvey","last_name":"Valdez","email":"ebacikib@laphev.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/34aa5e7382f0d2f4dac3a2ffe8ec98de.png","birthday":null,"first_seen":"2016-01-19T17:34:32.222Z","last_seen":"2016-10-07T13:13:33.933Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":179,"first_name":"Adam","last_name":"Rhodes","email":"fe@zijak.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0a0cf1a543e76b646152039b38e061c2.png","birthday":null,"first_seen":"2015-07-10T18:21:36.167Z","last_seen":"2016-12-03T23:16:19.279Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":180,"first_name":"Roger","last_name":"Berry","email":"omwa@puviv.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fb08d4907877fd11fe9764adadcbabeb.png","birthday":null,"first_seen":"2013-11-03T20:33:08.917Z","last_seen":"2016-07-30T07:16:38.550Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":181,"first_name":"Rosie","last_name":"Blair","email":"voz@witatrel.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6134f9934175856b3aa9dcab06f4bfa1.png","birthday":null,"first_seen":"2016-11-28T11:28:15.298Z","last_seen":"2016-12-22T12:14:40.881Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":182,"first_name":"Jeremiah","last_name":"Adkins","email":"iha@uj.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/92c980f1e267d4b4ff8187c5de4e348c.png","birthday":null,"first_seen":"2016-09-18T07:11:40.509Z","last_seen":"2016-11-28T03:41:48.360Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":183,"first_name":"Alex","last_name":"Bowen","email":"ledarrac@nude.gov","address":"1988 Leldo Way","zipcode":"54372","city":"Nimamali","avatar":"https://robohash.org/34149c34b893fd4f3cec18b4e9c27d28.png","birthday":"1994-02-18T06:37:49.501Z","first_seen":"2016-07-16T07:04:19.013Z","last_seen":"2016-11-05T18:51:51.556Z","has_ordered":true,"latest_purchase":"2016-10-31T15:16:48.779Z","has_newsletter":true,"groups":["reviewer"],"nb_commands":3,"total_spent":1017.5900000000001},{"id":184,"first_name":"Susan","last_name":"Bowers","email":"kires@sablucan.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0431b1e0bccd14c7ed3a65c0488520c1.png","birthday":null,"first_seen":"2016-12-03T14:39:31.851Z","last_seen":"2017-01-02T03:46:24.009Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":185,"first_name":"Carolyn","last_name":"Doyle","email":"kutas@dis.org","address":"1329 Wuzjok River","zipcode":"69719","city":"Kecanti","avatar":"https://robohash.org/0d2d779819c29f99ac6f814cd53db1b5.png","birthday":"1961-02-07T03:04:36.910Z","first_seen":"2014-02-09T11:24:55.796Z","last_seen":"2016-06-26T11:32:47.425Z","has_ordered":true,"latest_purchase":"2016-04-18T11:31:48.440Z","has_newsletter":false,"groups":["returns","reviewer"],"nb_commands":3,"total_spent":216.36},{"id":186,"first_name":"Nell","last_name":"Armstrong","email":"rodil@caemaguc.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7d837518c0826b1b380e4faf4388d3a7.png","birthday":null,"first_seen":"2016-02-21T15:28:25.229Z","last_seen":"2016-08-28T01:19:32.413Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":187,"first_name":"Gilbert","last_name":"Torres","email":"ku@ceba.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/21765453d8ab91b31e63055c69ac6e72.png","birthday":null,"first_seen":"2014-06-29T10:44:28.227Z","last_seen":"2016-03-16T05:09:03.241Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":188,"first_name":"Bradley","last_name":"Sharp","email":"wac@cuvleluj.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3bc42b278c246a32a37cd821bc5de01f.png","birthday":null,"first_seen":"2016-03-21T02:02:23.563Z","last_seen":"2016-10-08T19:13:18.242Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":189,"first_name":"Olga","last_name":"Hubbard","email":"ika@gi.net","address":"512 Repiv Heights","zipcode":"95563","city":"Liewiil","avatar":"https://robohash.org/1ea6c27240435ac7c100b9e4b9dc01e5.png","birthday":"1971-02-20T03:01:26.707Z","first_seen":"2013-12-30T08:25:40.965Z","last_seen":"2015-10-06T15:09:31.884Z","has_ordered":true,"latest_purchase":"2015-09-17T04:54:48.976Z","has_newsletter":false,"groups":["collector","regular","reviewer"],"nb_commands":4,"total_spent":1304.2199999999998},{"id":190,"first_name":"Michael","last_name":"Horton","email":"susujhab@keibkot.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/72a3ec9a5787dc772324376772d5fe47.png","birthday":null,"first_seen":"2016-08-02T21:30:58.563Z","last_seen":"2016-12-11T18:06:52.817Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":191,"first_name":"Tillie","last_name":"Abbott","email":"kace@lanewto.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/182a4efb95901c912cd1c9bf3291ccf8.png","birthday":null,"first_seen":"2014-11-14T03:35:54.942Z","last_seen":"2016-04-23T09:54:52.722Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":192,"first_name":"Antonio","last_name":"Hamilton","email":"sazwor@wig.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/605b4e165d191ea0216b27a00c9d8aa8.png","birthday":null,"first_seen":"2015-12-01T01:22:33.562Z","last_seen":"2016-12-21T07:50:07.257Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":193,"first_name":"Oscar","last_name":"Phelps","email":"cudweate@mes.com","address":"846 Rifopa River","zipcode":"38479","city":"Gulfohed","avatar":"https://robohash.org/3c090ed3346cb9b5918e237e2cde3490.png","birthday":"1967-02-21T07:29:32.986Z","first_seen":"2016-08-05T09:30:29.084Z","last_seen":"2016-12-25T01:08:52.689Z","has_ordered":true,"latest_purchase":"2016-10-08T18:18:42.774Z","has_newsletter":true,"groups":["ordered_once"],"nb_commands":1,"total_spent":140.56},{"id":194,"first_name":"Erik","last_name":"Morris","email":"kogcawgop@miw.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/19792cc3fd6ae61c81cdab6f85d3b975.png","birthday":null,"first_seen":"2016-06-15T15:31:34.084Z","last_seen":"2016-07-30T18:34:24.366Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":195,"first_name":"Walter","last_name":"Russell","email":"bec@seviruvet.net","address":"1738 Jisaf Square","zipcode":"55840","city":"Ziclahzuf","avatar":"https://robohash.org/d258a3aa5048a5c57dbeb9d093209e6e.png","birthday":"1990-02-16T02:59:01.302Z","first_seen":"2016-02-22T19:13:55.864Z","last_seen":"2016-07-04T10:40:05.850Z","has_ordered":true,"latest_purchase":"2016-06-11T06:17:51.010Z","has_newsletter":false,"groups":[],"nb_commands":2,"total_spent":427.27000000000004},{"id":196,"first_name":"Seth","last_name":"Bennett","email":"je@cevu.org","address":"1620 Woeko Plaza","zipcode":"41704","city":"Fapjuuvi","avatar":"https://robohash.org/d995e71563c51c2b5b8b70b28ea0ac15.png","birthday":"1953-11-24T10:12:32.104Z","first_seen":"2016-12-15T07:02:57.753Z","last_seen":"2016-12-31T08:30:34.244Z","has_ordered":true,"latest_purchase":"2016-12-28T23:38:06.472Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":2,"total_spent":737.2},{"id":197,"first_name":"Mark","last_name":"Powell","email":"reb@dujfufut.io","address":"1925 Hasa Point","zipcode":"63840","city":"Mujawogi","avatar":"https://robohash.org/dbb97db3057c88f50e733b754f3da25c.png","birthday":"1954-05-21T03:38:20.387Z","first_seen":"2016-10-09T04:01:26.104Z","last_seen":"2016-12-19T18:35:36.354Z","has_ordered":true,"latest_purchase":"2016-12-16T15:27:45.430Z","has_newsletter":false,"groups":[],"nb_commands":4,"total_spent":687.16},{"id":198,"first_name":"Craig","last_name":"Rodriquez","email":"veneg@uvkohgig.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7e705e0613c2b57a044893fe9bd99038.png","birthday":null,"first_seen":"2015-08-20T00:09:38.514Z","last_seen":"2016-05-20T15:04:33.514Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":199,"first_name":"Steven","last_name":"Hodges","email":"rileno@ajeapahe.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3d07a7b02031a458b8e27d0f76183b90.png","birthday":null,"first_seen":"2015-08-28T13:35:33.103Z","last_seen":"2016-12-01T16:04:00.542Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":200,"first_name":"Leroy","last_name":"Perkins","email":"serrawij@upo.gov","address":"1859 Aparo Glen","zipcode":"66526","city":"Piirozul","avatar":"https://robohash.org/f2ec4b949fc85576c8fe709adefc0711.png","birthday":"1961-06-17T07:23:00.853Z","first_seen":"2014-08-30T06:47:38.163Z","last_seen":"2016-01-27T13:39:19.814Z","has_ordered":true,"latest_purchase":"2016-01-09T13:16:45.139Z","has_newsletter":true,"groups":[],"nb_commands":2,"total_spent":298.69},{"id":201,"first_name":"Russell","last_name":"Sims","email":"kotikur@zunul.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/bbbb59443ebdc255f2ff42825341a052.png","birthday":null,"first_seen":"2015-08-21T00:14:27.263Z","last_seen":"2016-12-11T15:46:18.394Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":202,"first_name":"Lula","last_name":"Luna","email":"jolo@wo.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/65b023bc41cc4f1867d5d75fbf359d1e.png","birthday":null,"first_seen":"2015-06-02T08:42:01.508Z","last_seen":"2016-02-20T20:09:57.823Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":203,"first_name":"Lena","last_name":"Welch","email":"taj@su.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4ea55b97042a6a4d755a74e17051886f.png","birthday":null,"first_seen":"2016-09-23T23:43:21.416Z","last_seen":"2016-12-26T19:46:09.963Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":204,"first_name":"Gabriel","last_name":"George","email":"koce@sok.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5b27fdfc4595f8e7239b4a3aeba0e3fc.png","birthday":null,"first_seen":"2014-05-25T09:07:27.276Z","last_seen":"2016-10-12T17:44:05.434Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":205,"first_name":"Madge","last_name":"Grant","email":"re@migaw.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/05cd0900d0ce023709651f58c61890a5.png","birthday":null,"first_seen":"2016-07-30T03:04:31.725Z","last_seen":"2016-08-25T16:02:46.968Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":206,"first_name":"Mitchell","last_name":"Grant","email":"lirhiz@pim.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b40318500334e5f4dd1c26ec719ed597.png","birthday":null,"first_seen":"2016-04-15T14:58:18.353Z","last_seen":"2016-09-30T15:38:24.024Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":207,"first_name":"Gordon","last_name":"Park","email":"vew@japjaj.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b340d8ce9c312ebc5d6f54f0b25be38d.png","birthday":null,"first_seen":"2015-04-22T05:54:32.804Z","last_seen":"2016-07-31T00:55:42.254Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":208,"first_name":"Dora","last_name":"Wagner","email":"cotpeti@nacide.edu","address":"1548 Nalif Key","zipcode":"34977","city":"Isidaho","avatar":"https://robohash.org/c76ff6583a67f0c63a0baf2b8577d783.png","birthday":"1994-03-25T08:59:40.141Z","first_seen":"2013-04-11T21:37:25.629Z","last_seen":"2015-06-08T10:50:10.176Z","has_ordered":true,"latest_purchase":"2014-09-26T15:09:16.744Z","has_newsletter":false,"groups":["regular"],"nb_commands":2,"total_spent":121.87},{"id":209,"first_name":"Garrett","last_name":"Morrison","email":"igosefdan@iw.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/49052eadb3627d33c56529a134a1e989.png","birthday":null,"first_seen":"2014-06-03T07:43:42.346Z","last_seen":"2016-06-27T08:36:16.004Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":210,"first_name":"Iva","last_name":"Swanson","email":"rowonah@vow.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/88d16b4894790855b876f28853031764.png","birthday":null,"first_seen":"2016-02-01T11:13:52.353Z","last_seen":"2016-08-26T00:52:12.149Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":211,"first_name":"Lily","last_name":"Bridges","email":"lushobe@mizeb.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/affb1339444269934e3798dfc8f81c69.png","birthday":null,"first_seen":"2015-07-29T01:57:51.064Z","last_seen":"2016-05-02T03:29:46.927Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":212,"first_name":"Melvin","last_name":"Williamson","email":"faajeal@hul.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6ffe0c39c5a4ad355a9da017c5f0e56b.png","birthday":null,"first_seen":"2016-05-24T14:54:24.688Z","last_seen":"2016-11-25T08:50:04.389Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":213,"first_name":"Daisy","last_name":"Curtis","email":"igdap@hucew.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4302824fefdde301f9abb489b6061161.png","birthday":null,"first_seen":"2015-09-01T08:42:42.107Z","last_seen":"2016-11-01T20:47:39.775Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":214,"first_name":"Maurice","last_name":"Morrison","email":"kakazehin@pubsa.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ac7c7efa3ec2a12d18c3f9beeacdeef6.png","birthday":null,"first_seen":"2016-11-15T02:39:56.486Z","last_seen":"2017-01-03T23:17:17.381Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":215,"first_name":"Alan","last_name":"Wilkerson","email":"wiepelo@mube.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1d659f6ababf3203116b463cf9c293ac.png","birthday":null,"first_seen":"2016-11-03T13:16:21.354Z","last_seen":"2016-12-08T05:43:44.863Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":216,"first_name":"Leah","last_name":"Fowler","email":"paktu@ec.org","address":"1188 Aravu Place","zipcode":"06009","city":"Ciwowpa","avatar":"https://robohash.org/80c41edbe1caf1be83ab58100ec320b4.png","birthday":"1962-11-15T11:41:43.889Z","first_seen":"2015-12-04T06:44:53.519Z","last_seen":"2016-11-03T23:11:36.742Z","has_ordered":true,"latest_purchase":"2016-03-27T10:40:53.550Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":313.34},{"id":217,"first_name":"Maggie","last_name":"Moran","email":"efari@mihgapup.io","address":"325 Navso Path","zipcode":"98573","city":"Posufbij","avatar":"https://robohash.org/9ace6a7657521d1ba06e8f027ffe9673.png","birthday":"1972-12-28T06:30:36.651Z","first_seen":"2015-10-21T04:54:38.596Z","last_seen":"2016-09-19T21:03:30.882Z","has_ordered":true,"latest_purchase":"2016-09-03T14:58:35.077Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":207.19},{"id":218,"first_name":"Augusta","last_name":"Vasquez","email":"weznoz@pac.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/24ddd2598361a84bbade21b59bfd410a.png","birthday":null,"first_seen":"2016-12-24T12:27:52.806Z","last_seen":"2016-12-30T01:41:30.800Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":219,"first_name":"Dora","last_name":"Owen","email":"gib@simpoaf.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0b0a9c04276c3245280c641f87808bc6.png","birthday":null,"first_seen":"2013-10-13T04:37:51.523Z","last_seen":"2015-12-01T14:36:26.646Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":220,"first_name":"Martha","last_name":"Clark","email":"unagigze@kolinvut.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/18a17d432f6ee2c2c56d0adb36616679.png","birthday":null,"first_seen":"2016-10-01T16:35:01.910Z","last_seen":"2016-12-06T17:10:37.249Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":221,"first_name":"Connor","last_name":"Rodriguez","email":"toj@hedcimde.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ecb91bad7f000474cdb4610f3f0ff0b4.png","birthday":null,"first_seen":"2016-09-28T11:53:58.421Z","last_seen":"2017-01-05T11:16:46.040Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":222,"first_name":"Mabel","last_name":"Delgado","email":"viifi@hoehba.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a23052eaf15fc65dbbd59554d729bdee.png","birthday":null,"first_seen":"2015-12-26T16:20:23.194Z","last_seen":"2016-10-21T16:47:02.508Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":223,"first_name":"Catherine","last_name":"Cross","email":"on@jilrumpaw.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/55f1c12bf97ed7f7bfd863da93752c01.png","birthday":null,"first_seen":"2013-11-10T16:57:53.192Z","last_seen":"2015-09-07T08:47:21.526Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":224,"first_name":"Lettie","last_name":"Meyer","email":"uvrojem@kanrusi.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ad12ccbd3059bbb676f7fe91b0034999.png","birthday":null,"first_seen":"2013-12-12T03:56:28.618Z","last_seen":"2014-08-12T09:12:14.720Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":225,"first_name":"Ricardo","last_name":"Boyd","email":"ok@wijsuhrok.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d44530521fbebef4a1a50147e43c1881.png","birthday":null,"first_seen":"2014-05-23T02:56:36.343Z","last_seen":"2016-12-23T23:29:21.778Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":226,"first_name":"Lucille","last_name":"Holt","email":"betisigo@ovrisi.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ef78c02189d136169ffd29eb4d2cbb6e.png","birthday":null,"first_seen":"2012-07-04T12:27:46.779Z","last_seen":"2015-10-10T05:46:20.586Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":227,"first_name":"Loretta","last_name":"Cobb","email":"tejtowicu@kuc.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/37a1a26f295fb7285b9064a13f41f3ce.png","birthday":null,"first_seen":"2016-11-12T14:31:54.980Z","last_seen":"2016-12-15T20:47:37.600Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":228,"first_name":"Lola","last_name":"Evans","email":"was@vaniuv.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/9ccdcff780fad9c2fb10def48bfcbdd2.png","birthday":null,"first_seen":"2016-02-04T05:33:12.305Z","last_seen":"2016-08-03T16:01:33.819Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":229,"first_name":"Henrietta","last_name":"Miles","email":"caihofah@rikbul.io","address":"1929 Pivno Glen","zipcode":"50937","city":"Comazama","avatar":"https://robohash.org/073b8810f87292313ff55dc428e08033.png","birthday":"1958-10-15T03:55:06.424Z","first_seen":"2015-07-13T00:35:38.966Z","last_seen":"2015-12-18T12:55:45.086Z","has_ordered":true,"latest_purchase":"2015-11-23T00:57:49.741Z","has_newsletter":true,"groups":["collector","reviewer"],"nb_commands":3,"total_spent":1315.99},{"id":230,"first_name":"Theresa","last_name":"Hudson","email":"ibi@nub.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8b30227aef56f0dd71d03ee8ce44879c.png","birthday":null,"first_seen":"2016-12-28T23:47:20.804Z","last_seen":"2017-01-03T20:40:34.486Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":231,"first_name":"Theodore","last_name":"Ortega","email":"ulful@lapajwa.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0bb9846e5d14188b24711c06af9c1575.png","birthday":null,"first_seen":"2015-04-25T03:54:21.890Z","last_seen":"2016-12-29T15:07:57.733Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":232,"first_name":"Roy","last_name":"Oliver","email":"femtuslu@nama.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/89d9798a3ff530fd5ba2412d65d86946.png","birthday":null,"first_seen":"2015-10-04T07:50:49.024Z","last_seen":"2015-11-26T05:45:12.476Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":233,"first_name":"Vincent","last_name":"Reid","email":"ucu@cujfe.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4e17f0ea7941610fc76fb3f941d07bd1.png","birthday":null,"first_seen":"2016-09-26T17:43:54.641Z","last_seen":"2016-12-09T02:48:25.033Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":234,"first_name":"Franklin","last_name":"Foster","email":"izpot@fopcef.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/02dbec9f6491725102b683878f2dbcdd.png","birthday":null,"first_seen":"2016-10-31T03:48:30.530Z","last_seen":"2016-12-29T05:20:28.991Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":235,"first_name":"Ivan","last_name":"Crawford","email":"ru@tu.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8a1fa4fa279132f0e0a0060f264fa4a8.png","birthday":null,"first_seen":"2015-05-17T22:00:03.530Z","last_seen":"2016-07-11T19:08:43.031Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":236,"first_name":"Jeffrey","last_name":"Marshall","email":"ra@seza.gov","address":"1501 Ganze Extension","zipcode":"76219","city":"Utasiren","avatar":"https://robohash.org/f3e076c4b3aeb0e14d68ed93e8e6a643.png","birthday":"1998-10-05T00:19:59.237Z","first_seen":"2016-07-05T11:09:50.251Z","last_seen":"2016-12-27T06:59:13.650Z","has_ordered":true,"latest_purchase":"2016-12-19T06:04:09.313Z","has_newsletter":true,"groups":["collector"],"nb_commands":6,"total_spent":1444.54},{"id":237,"first_name":"Louise","last_name":"Collins","email":"ohtokjo@zunlozbil.gov","address":"603 Apsa Extension","zipcode":"67884","city":"Lucuto","avatar":"https://robohash.org/907a8ad4391f34d45cb0640f832e42bc.png","birthday":"1992-01-31T05:30:22.559Z","first_seen":"2016-10-03T23:51:29.941Z","last_seen":"2016-12-19T01:59:16.375Z","has_ordered":true,"latest_purchase":"2016-11-14T10:39:06.884Z","has_newsletter":false,"groups":["returns"],"nb_commands":3,"total_spent":312.82},{"id":238,"first_name":"Derrick","last_name":"Butler","email":"vaslap@ziptencar.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/71feab2af75c5681bdf986a01abb59d5.png","birthday":null,"first_seen":"2014-07-11T23:12:36.504Z","last_seen":"2016-10-24T09:10:22.137Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":239,"first_name":"Cecelia","last_name":"Bowers","email":"butaj@ki.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e6bb85c51832ab73d861a57bd336b39a.png","birthday":null,"first_seen":"2016-12-21T19:51:47.160Z","last_seen":"2017-01-04T07:34:25.401Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":240,"first_name":"Dominic","last_name":"Garrett","email":"si@soipoco.com","address":"757 Nuja Trail","zipcode":"15029","city":"Juvmene","avatar":"https://robohash.org/f3fc9329d20cd2795833f254c5bbbcb1.png","birthday":"1961-08-05T09:47:45.104Z","first_seen":"2014-10-27T16:48:59.292Z","last_seen":"2015-09-08T05:06:16.490Z","has_ordered":true,"latest_purchase":"2015-09-01T05:20:33.938Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":675.77},{"id":241,"first_name":"Vincent","last_name":"Bush","email":"hab@firice.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e67c8bfbcd07390fe2c4ef6fa7400a2d.png","birthday":null,"first_seen":"2015-08-26T21:04:25.451Z","last_seen":"2016-08-05T00:35:07.043Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":242,"first_name":"Brent","last_name":"Riley","email":"ozalire@wivoza.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a4e202d002937071897dcbbda606f4c6.png","birthday":null,"first_seen":"2016-06-08T05:23:55.874Z","last_seen":"2016-12-22T10:45:03.081Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":243,"first_name":"Lou","last_name":"Stephens","email":"biw@coek.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a0e8e8399420f8b5ce440e2f201ecfb2.png","birthday":null,"first_seen":"2016-12-18T21:48:11.853Z","last_seen":"2017-01-05T00:30:41.552Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":244,"first_name":"Dorothy","last_name":"Jenkins","email":"vuw@ekomijeb.org","address":"918 Taslok Road","zipcode":"99261","city":"Epabesek","avatar":"https://robohash.org/53585d3133a44ce69c2f1f81787b921e.png","birthday":"1997-04-15T04:34:16.756Z","first_seen":"2014-12-08T16:58:14.733Z","last_seen":"2016-10-30T05:56:40.699Z","has_ordered":true,"latest_purchase":"2016-06-26T15:07:38.655Z","has_newsletter":false,"groups":[],"nb_commands":4,"total_spent":391.95},{"id":245,"first_name":"Gabriel","last_name":"Porter","email":"ka@vem.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/02a364057aea7ae91d8f31fe79865b28.png","birthday":null,"first_seen":"2014-05-18T23:07:46.675Z","last_seen":"2016-08-24T01:04:33.141Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":246,"first_name":"Christine","last_name":"Graham","email":"badil@atdav.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/43fd0527d43f3105b90ababc3c6491f4.png","birthday":null,"first_seen":"2014-05-29T14:33:58.031Z","last_seen":"2016-02-13T03:56:48.604Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":247,"first_name":"Vernon","last_name":"Graves","email":"siveli@hokagid.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2f535792a1362d63c3f1e9f362f4a474.png","birthday":null,"first_seen":"2015-01-27T13:47:53.730Z","last_seen":"2016-09-29T01:35:27.561Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":248,"first_name":"Etta","last_name":"Washington","email":"rozli@siwupgew.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ece5ddf7875fd30db8f129213563b1d6.png","birthday":null,"first_seen":"2015-06-05T08:23:44.464Z","last_seen":"2016-09-14T12:40:18.738Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":249,"first_name":"Lillian","last_name":"Woods","email":"jefid@no.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/dd00ec8905089fdce547e02fc2c5194e.png","birthday":null,"first_seen":"2014-05-17T19:00:21.929Z","last_seen":"2016-12-29T06:50:34.396Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":250,"first_name":"Nicholas","last_name":"Lowe","email":"ogi@mew.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ad6c6b8ff5bfd84f5abf187a122bdc51.png","birthday":null,"first_seen":"2015-07-28T06:20:01.831Z","last_seen":"2016-01-01T10:39:42.887Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":251,"first_name":"Carl","last_name":"Strickland","email":"rukciola@ler.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2f20639310b0a9f8a3a4d5000b74a722.png","birthday":null,"first_seen":"2013-07-26T04:14:44.488Z","last_seen":"2014-09-18T21:06:24.744Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":252,"first_name":"Cecilia","last_name":"Gonzales","email":"mudos@pajhuksim.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c7f9840632f227ce1f242a1b8081900c.png","birthday":null,"first_seen":"2013-03-31T14:02:02.820Z","last_seen":"2015-11-14T08:50:19.110Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":253,"first_name":"Max","last_name":"Doyle","email":"fombijdej@uti.net","address":"708 Esuson Drive","zipcode":"24301","city":"Vahwohneg","avatar":"https://robohash.org/e41fc0f3b7a0f19a5389a4bebd4271d6.png","birthday":"1977-08-18T04:55:23.176Z","first_seen":"2016-08-05T12:50:11.757Z","last_seen":"2016-10-02T17:58:59.606Z","has_ordered":true,"latest_purchase":"2016-10-02T02:24:25.222Z","has_newsletter":true,"groups":[],"nb_commands":4,"total_spent":352.27},{"id":254,"first_name":"Victoria","last_name":"Wright","email":"de@dirpe.org","address":"1406 Gonde Pike","zipcode":"86823","city":"Cagartom","avatar":"https://robohash.org/9c0e0f1e2074c20d7cda636c07feef62.png","birthday":"1982-12-18T10:53:50.017Z","first_seen":"2012-11-11T03:23:06.354Z","last_seen":"2014-09-16T00:47:49.590Z","has_ordered":true,"latest_purchase":"2013-11-11T11:04:45.570Z","has_newsletter":false,"groups":["returns"],"nb_commands":2,"total_spent":291.54},{"id":255,"first_name":"Nina","last_name":"Barton","email":"tegud@mo.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b4e21bcb296c92c5e11f414666071bd2.png","birthday":null,"first_seen":"2015-03-15T17:15:22.175Z","last_seen":"2016-07-10T07:49:12.817Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":256,"first_name":"Chase","last_name":"Perkins","email":"vohera@wel.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/dced04a395860f2765cf59d7318df38d.png","birthday":null,"first_seen":"2016-10-17T06:20:00.170Z","last_seen":"2016-12-28T18:31:08.715Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":257,"first_name":"Polly","last_name":"Drake","email":"sa@upefi.co.uk","address":"1472 Wimbi Lane","zipcode":"48648","city":"Damjuot","avatar":"https://robohash.org/85dfe17ce7f5d62491bc92994285aefd.png","birthday":"1973-12-25T05:46:02.452Z","first_seen":"2016-12-17T12:15:03.555Z","last_seen":"2017-01-01T20:35:33.319Z","has_ordered":true,"latest_purchase":"2016-12-31T21:32:58.956Z","has_newsletter":false,"groups":["regular"],"nb_commands":3,"total_spent":634.3100000000001},{"id":258,"first_name":"Marian","last_name":"Collier","email":"jitu@dabe.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a3dd053e31d578f13f4ef99331d8ae95.png","birthday":null,"first_seen":"2015-08-22T19:39:09.554Z","last_seen":"2016-10-09T09:07:41.095Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":259,"first_name":"Mamie","last_name":"Malone","email":"jek@jodpi.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5b131fb6872370c408f23fa81b3f0d4c.png","birthday":null,"first_seen":"2014-03-12T00:42:19.307Z","last_seen":"2016-11-15T22:01:36.401Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":260,"first_name":"Sylvia","last_name":"Medina","email":"zirev@ogtiwhub.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e83216760c72394ba7b04c943176a695.png","birthday":null,"first_seen":"2013-09-08T16:09:27.843Z","last_seen":"2016-12-19T21:09:12.012Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":261,"first_name":"Austin","last_name":"Wilkins","email":"mol@udebosjit.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fe03fab2ba6b5e128a0f0670d6167f9a.png","birthday":null,"first_seen":"2015-04-10T09:22:38.897Z","last_seen":"2016-08-29T09:48:51.134Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":262,"first_name":"Donald","last_name":"Byrd","email":"raup@vet.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e6572d7457abad66e40e4caf5d21ac52.png","birthday":null,"first_seen":"2016-12-29T10:50:23.630Z","last_seen":"2017-01-04T05:33:35.321Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":263,"first_name":"Jonathan","last_name":"Thomas","email":"faw@padfu.edu","address":"504 Cacav Court","zipcode":"68971","city":"Inifamic","avatar":"https://robohash.org/d489f9b5c2e652bc558cf225c29fb0fc.png","birthday":"1963-07-29T00:16:33.396Z","first_seen":"2016-03-31T20:39:19.284Z","last_seen":"2016-06-20T09:41:37.725Z","has_ordered":true,"latest_purchase":"2016-05-06T21:52:57.514Z","has_newsletter":false,"groups":["ordered_once","regular","reviewer"],"nb_commands":1,"total_spent":71.2},{"id":264,"first_name":"Dean","last_name":"Moran","email":"ka@niher.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/51850a9b881d9d18ba2394850fc24e19.png","birthday":null,"first_seen":"2015-04-25T07:48:09.276Z","last_seen":"2016-10-29T20:27:53.142Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":265,"first_name":"Randy","last_name":"Jackson","email":"mahfedleb@sat.edu","address":"865 Eclag Loop","zipcode":"57536","city":"Moszasic","avatar":"https://robohash.org/acb7c3c5669c157e6ad7f0c382bb0a30.png","birthday":"1962-12-20T01:19:25.223Z","first_seen":"2014-11-17T16:14:38.572Z","last_seen":"2016-05-09T16:36:44.446Z","has_ordered":true,"latest_purchase":"2016-04-02T19:10:57.997Z","has_newsletter":false,"groups":[],"nb_commands":3,"total_spent":621.03},{"id":266,"first_name":"Mayme","last_name":"Poole","email":"zabeco@mufuvuca.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c2364f320d455ecb1806260febac005c.png","birthday":null,"first_seen":"2013-12-12T05:41:14.380Z","last_seen":"2016-03-22T14:48:47.495Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":267,"first_name":"Ray","last_name":"Gomez","email":"va@esgo.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2ffa84e680cb88ee4411ebf012605200.png","birthday":null,"first_seen":"2016-10-19T20:27:01.238Z","last_seen":"2016-10-24T17:13:33.142Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":268,"first_name":"Adrian","last_name":"Rodriguez","email":"ujvuknih@vefek.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0c63e0e491cc79851a061b2659b2fda4.png","birthday":null,"first_seen":"2016-08-29T00:40:20.168Z","last_seen":"2016-12-31T05:18:04.955Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":269,"first_name":"Miguel","last_name":"Poole","email":"bom@sal.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0edbbdd5f56f9154cb271a8f1a610c36.png","birthday":null,"first_seen":"2015-12-29T16:51:10.617Z","last_seen":"2016-05-21T00:58:59.972Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":270,"first_name":"Nannie","last_name":"Chambers","email":"enfod@ebitontu.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a4664fa8b4ce4bda1e8dad12da011e49.png","birthday":null,"first_seen":"2014-04-30T00:55:52.603Z","last_seen":"2015-01-13T21:52:40.982Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":271,"first_name":"Hallie","last_name":"Morrison","email":"tok@cer.io","address":"1384 Pekgi Junction","zipcode":"51020","city":"Ehujedcam","avatar":"https://robohash.org/05ff98df9752f88f2e35861ba0df5b70.png","birthday":"1977-03-27T10:24:15.460Z","first_seen":"2014-08-24T21:42:07.663Z","last_seen":"2016-04-19T10:19:55.805Z","has_ordered":true,"latest_purchase":"2015-09-04T04:06:10.283Z","has_newsletter":true,"groups":[],"nb_commands":3,"total_spent":664.58},{"id":272,"first_name":"Winnie","last_name":"Ramirez","email":"nucigih@beggo.edu","address":"696 Uliz Park","zipcode":"55061","city":"Kazazda","avatar":"https://robohash.org/a38f2920d43d4c52e6281da65b91b274.png","birthday":"1995-11-04T08:38:18.128Z","first_seen":"2015-03-29T16:11:19.973Z","last_seen":"2016-11-30T14:59:51.472Z","has_ordered":true,"latest_purchase":"2015-08-28T14:03:54.698Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":56.93},{"id":273,"first_name":"Milton","last_name":"Gutierrez","email":"favaat@wijeor.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/763c93a8171f572a5616728e710b36de.png","birthday":null,"first_seen":"2016-11-27T18:02:10.058Z","last_seen":"2016-12-20T18:52:59.993Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":274,"first_name":"Todd","last_name":"Baldwin","email":"ba@ozij.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0feeee1b77c924ca1b67efadae233e24.png","birthday":null,"first_seen":"2016-03-07T12:45:28.947Z","last_seen":"2017-01-03T17:58:46.049Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":275,"first_name":"Victoria","last_name":"Obrien","email":"hi@ciljacba.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0c3b8e499128b874571138d72c63f70a.png","birthday":null,"first_seen":"2016-09-24T01:15:00.929Z","last_seen":"2016-11-22T07:19:37.042Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":276,"first_name":"Esther","last_name":"Bennett","email":"musrib@jahuraka.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/43c72f83e7c212ce2e7c08c336fdb459.png","birthday":null,"first_seen":"2016-08-01T10:12:47.879Z","last_seen":"2017-01-02T08:30:39.649Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":277,"first_name":"Julian","last_name":"Clark","email":"ireeka@zar.net","address":"1789 Enajoc Terrace","zipcode":"62096","city":"Mowohohed","avatar":"https://robohash.org/ae46ad9d6a09b5bf3e3cc94e299319ec.png","birthday":"1996-12-08T00:42:46.988Z","first_seen":"2016-11-15T13:11:13.995Z","last_seen":"2017-01-02T11:00:04.182Z","has_ordered":true,"latest_purchase":"2016-12-29T09:55:59.976Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":400.25},{"id":278,"first_name":"Elmer","last_name":"Stone","email":"dovlur@fak.org","address":"585 Pozej Drive","zipcode":"05972","city":"Nudmikga","avatar":"https://robohash.org/26e3ffa60349f49b625c4e77cd4a87e4.png","birthday":"1971-07-16T06:01:20.194Z","first_seen":"2013-12-24T03:36:10.732Z","last_seen":"2016-06-05T07:19:42.408Z","has_ordered":true,"latest_purchase":"2016-03-18T14:00:07.978Z","has_newsletter":true,"groups":["ordered_once"],"nb_commands":1,"total_spent":54.17},{"id":279,"first_name":"Elijah","last_name":"Hicks","email":"ku@kofki.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6468e135d506aa5660e9d911c90b5da8.png","birthday":null,"first_seen":"2015-03-08T10:56:46.206Z","last_seen":"2016-10-14T11:39:31.973Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":280,"first_name":"Raymond","last_name":"Little","email":"ecocec@omuhidob.edu","address":"1539 Goje Park","zipcode":"57770","city":"Gapizup","avatar":"https://robohash.org/dbb3476b91e9e8024a16a112b3f4122c.png","birthday":"1958-09-25T08:17:02.700Z","first_seen":"2014-06-28T00:37:00.343Z","last_seen":"2016-09-30T04:02:33.542Z","has_ordered":true,"latest_purchase":"2016-08-16T19:21:58.060Z","has_newsletter":false,"groups":["collector","compulsive","reviewer"],"nb_commands":4,"total_spent":1792.51},{"id":281,"first_name":"Derek","last_name":"Holloway","email":"deji@fataduf.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/714dfb31495d59799ca31c6953752bbb.png","birthday":null,"first_seen":"2016-05-20T01:00:58.313Z","last_seen":"2017-01-04T18:41:23.936Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":282,"first_name":"Lulu","last_name":"Harrington","email":"lehzekuw@nil.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c89f6d7b8b874e0a477013b35d903318.png","birthday":null,"first_seen":"2015-10-17T18:49:48.642Z","last_seen":"2016-12-23T18:12:45.838Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":283,"first_name":"Lura","last_name":"Boone","email":"zangoebe@meuti.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/57ccf50d2080e20f8669f184c0a4c761.png","birthday":null,"first_seen":"2014-10-13T15:37:15.571Z","last_seen":"2016-11-10T12:26:16.661Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":284,"first_name":"Zachary","last_name":"Reynolds","email":"vahunwil@gutis.com","address":"426 Tupmaj Way","zipcode":"04528","city":"Makfofes","avatar":"https://robohash.org/a57a158903a7151813e88969bef663fa.png","birthday":"1970-01-20T03:02:56.760Z","first_seen":"2015-10-14T08:37:25.007Z","last_seen":"2016-12-09T08:49:14.196Z","has_ordered":true,"latest_purchase":"2016-10-14T15:18:00.221Z","has_newsletter":false,"groups":[],"nb_commands":2,"total_spent":341.76},{"id":285,"first_name":"Jorge","last_name":"Phelps","email":"negsictu@fikun.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f43572c6ac16425e9ce9b103bdb02e4c.png","birthday":null,"first_seen":"2012-10-02T17:03:07.033Z","last_seen":"2014-01-13T15:24:25.768Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":286,"first_name":"Ollie","last_name":"Wolfe","email":"awocarhub@gioh.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/277e782297655a5f01e10c944abf888c.png","birthday":null,"first_seen":"2014-03-13T17:16:04.542Z","last_seen":"2016-01-17T05:33:51.876Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":287,"first_name":"Dorothy","last_name":"Day","email":"ne@nu.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/eb204992a380a266d8fcf83230f6e54d.png","birthday":null,"first_seen":"2016-06-04T15:58:14.092Z","last_seen":"2016-10-01T12:53:25.073Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":288,"first_name":"Jerry","last_name":"Morris","email":"madah@fizolvol.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ff8656ede6b3d3905b6718aee7cedf8f.png","birthday":null,"first_seen":"2015-09-11T03:49:51.438Z","last_seen":"2016-10-30T06:33:56.491Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":289,"first_name":"Connor","last_name":"Massey","email":"noza@zitwef.co.uk","address":"241 Wutom Plaza","zipcode":"87803","city":"Nouviah","avatar":"https://robohash.org/7a4b21635b5d27bbc51d10be249e9af3.png","birthday":"1982-05-06T03:21:41.200Z","first_seen":"2016-01-26T06:14:04.783Z","last_seen":"2016-08-27T02:38:49.932Z","has_ordered":true,"latest_purchase":"2016-07-26T06:34:35.627Z","has_newsletter":false,"groups":["regular","reviewer"],"nb_commands":4,"total_spent":513.5699999999999},{"id":290,"first_name":"Henrietta","last_name":"White","email":"ofuhokmo@izefo.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e08be520d5e69b33b1943900c56d8d0f.png","birthday":null,"first_seen":"2015-06-13T09:36:34.611Z","last_seen":"2016-08-08T03:43:41.388Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":291,"first_name":"Nicholas","last_name":"Dunn","email":"base@mincurfaf.co.uk","address":"193 Fatbu Turnpike","zipcode":"42447","city":"Fearabe","avatar":"https://robohash.org/854cfad4a62a5d57923dd522ea7ae221.png","birthday":"1986-09-12T06:52:41.581Z","first_seen":"2016-11-22T18:05:47.120Z","last_seen":"2017-01-03T11:07:29.453Z","has_ordered":true,"latest_purchase":"2016-12-25T21:06:49.386Z","has_newsletter":true,"groups":["ordered_once"],"nb_commands":1,"total_spent":81.35},{"id":292,"first_name":"Susan","last_name":"Carson","email":"bok@biari.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/aa4d12f30e35b42386129dc42e18c7b0.png","birthday":null,"first_seen":"2016-12-02T07:45:18.549Z","last_seen":"2016-12-30T17:12:54.960Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":293,"first_name":"John","last_name":"Green","email":"wuska@fubem.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/72838278538190371d553cdd23324089.png","birthday":null,"first_seen":"2014-12-23T13:19:29.632Z","last_seen":"2016-02-04T12:36:29.322Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":294,"first_name":"Herman","last_name":"Rodgers","email":"lutrer@jibo.co.uk","address":"97 Dizga Drive","zipcode":"36313","city":"Avfevute","avatar":"https://robohash.org/157b41a14d21077f3b3c33ca490e7906.png","birthday":"1998-07-16T06:59:02.372Z","first_seen":"2015-12-18T16:24:17.542Z","last_seen":"2016-02-18T22:08:40.709Z","has_ordered":true,"latest_purchase":"2016-02-16T22:34:42.801Z","has_newsletter":true,"groups":["reviewer"],"nb_commands":4,"total_spent":269.8},{"id":295,"first_name":"Gavin","last_name":"Christensen","email":"zip@wuar.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c77a3b74580e4fc38bac8c0048a1a8ab.png","birthday":null,"first_seen":"2016-08-22T14:32:18.461Z","last_seen":"2016-11-19T02:12:50.663Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":296,"first_name":"Charlotte","last_name":"Weaver","email":"egilolbut@sucupa.com","address":"199 Jawde Manor","zipcode":"16215","city":"Zehnizotu","avatar":"https://robohash.org/cb2cedb2626f11f096903a90be2c9624.png","birthday":"1982-06-06T01:03:49.808Z","first_seen":"2016-03-28T18:51:41.600Z","last_seen":"2016-12-24T11:37:53.035Z","has_ordered":true,"latest_purchase":"2016-12-23T03:05:04.412Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":4,"total_spent":545.5099999999999},{"id":297,"first_name":"Adam","last_name":"Davidson","email":"dezedfod@ti.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c59d139b5f00801f27752e5297f6f884.png","birthday":null,"first_seen":"2013-11-19T03:43:47.032Z","last_seen":"2016-07-16T13:35:06.199Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":298,"first_name":"Iva","last_name":"Berry","email":"najuomi@giowam.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2ff0b0d5df22c929f69d946442284574.png","birthday":null,"first_seen":"2016-12-06T05:00:38.187Z","last_seen":"2016-12-30T00:04:20.042Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":299,"first_name":"Joe","last_name":"Watson","email":"vodod@towcul.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f0fd88033db63f49d7abe489621d5e0e.png","birthday":null,"first_seen":"2013-01-06T02:39:00.091Z","last_seen":"2014-05-03T04:32:59.895Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":300,"first_name":"Minnie","last_name":"Steele","email":"fominefus@vom.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1d18cc334ded4edebf49b3b0d3ad4065.png","birthday":null,"first_seen":"2015-11-12T00:01:59.933Z","last_seen":"2016-07-20T09:55:33.422Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":301,"first_name":"Warren","last_name":"Lloyd","email":"samif@humkevup.org","address":"1805 Nelsak Boulevard","zipcode":"59649","city":"Rimwomvo","avatar":"https://robohash.org/d6c2655f8ea3768a5c03838a9718f097.png","birthday":"1998-06-30T09:55:39.242Z","first_seen":"2015-05-31T19:40:54.753Z","last_seen":"2016-06-24T08:44:51.630Z","has_ordered":true,"latest_purchase":"2016-06-13T12:31:01.220Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":819.83},{"id":302,"first_name":"Clyde","last_name":"Cannon","email":"balile@ehavat.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4eebcb7bbccc3ce6d1f8870aee9d5f62.png","birthday":null,"first_seen":"2016-02-01T08:49:56.228Z","last_seen":"2016-09-16T02:02:20.485Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":303,"first_name":"Bess","last_name":"Jensen","email":"ir@ec.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/05bc70eaa9fef3123eee2cbce2481a8b.png","birthday":null,"first_seen":"2013-07-22T11:06:29.470Z","last_seen":"2016-06-19T16:08:42.188Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":304,"first_name":"Donald","last_name":"Bridges","email":"uwied@rohcipka.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/833afe0f984958d77023229fd4f9267f.png","birthday":null,"first_seen":"2014-06-26T23:58:58.821Z","last_seen":"2016-10-06T07:57:15.300Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":305,"first_name":"Jeremiah","last_name":"Anderson","email":"jaci@ih.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/bc57cc6ed6defc726c026016a9522c2d.png","birthday":null,"first_seen":"2016-11-04T08:13:26.666Z","last_seen":"2016-11-13T23:46:08.282Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":306,"first_name":"Lettie","last_name":"Hampton","email":"oladelu@cinisi.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ebc9e0c21ba8578b8bcba13e260846bb.png","birthday":null,"first_seen":"2016-03-20T07:40:47.251Z","last_seen":"2016-11-02T09:35:05.110Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":307,"first_name":"Albert","last_name":"Lyons","email":"pap@dozat.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5fc72feab3cfb7198559e6d7e6e8270e.png","birthday":null,"first_seen":"2014-04-11T00:27:52.146Z","last_seen":"2015-02-28T13:19:07.245Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":308,"first_name":"Louise","last_name":"Morris","email":"zuuma@ivolo.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1da94b70613283445aeac14f10850b12.png","birthday":null,"first_seen":"2014-06-30T14:11:00.123Z","last_seen":"2016-02-07T23:29:30.967Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":309,"first_name":"Nellie","last_name":"Maxwell","email":"irauho@jut.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7d759fe5055cf592be8734567b31ab4b.png","birthday":null,"first_seen":"2016-03-07T02:33:37.972Z","last_seen":"2016-09-22T00:16:13.011Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":310,"first_name":"Dylan","last_name":"Richards","email":"tasva@mewba.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3d422da80cba6663a2e325399a322bda.png","birthday":null,"first_seen":"2013-07-14T14:30:15.196Z","last_seen":"2016-08-26T18:32:41.400Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":311,"first_name":"Scott","last_name":"Neal","email":"ini@mivrimle.net","address":"1996 Jibig Court","zipcode":"38741","city":"Kebupema","avatar":"https://robohash.org/a0175734272f6ded9eed3e2d7ee0c286.png","birthday":"1968-05-30T08:36:12.405Z","first_seen":"2015-01-19T07:42:00.433Z","last_seen":"2016-10-22T18:53:22.341Z","has_ordered":true,"latest_purchase":"2016-06-05T06:34:06.036Z","has_newsletter":true,"groups":[],"nb_commands":3,"total_spent":879.4499999999999},{"id":312,"first_name":"Myrtle","last_name":"Morgan","email":"vipatu@ot.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/86b09081f76f98531567839ed28aad79.png","birthday":null,"first_seen":"2016-08-08T23:10:26.446Z","last_seen":"2016-11-14T11:22:30.512Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":313,"first_name":"Millie","last_name":"Sparks","email":"ceut@ca.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/80d5bf23bf88ebfee362a03f73288c87.png","birthday":null,"first_seen":"2016-05-28T07:36:13.198Z","last_seen":"2016-12-11T23:51:32.646Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":314,"first_name":"Matilda","last_name":"Thornton","email":"kaputhuz@zom.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f0f58676c005ad68a7e5d9ffb20b26b3.png","birthday":null,"first_seen":"2016-04-22T11:51:15.925Z","last_seen":"2016-07-26T16:41:27.268Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":315,"first_name":"Benjamin","last_name":"Diaz","email":"ivuwas@to.net","address":"69 Dumvoh Highway","zipcode":"09186","city":"Kuicuupi","avatar":"https://robohash.org/96e52d6494b4cab337e3cd782ab6f584.png","birthday":"1960-05-05T03:36:47.041Z","first_seen":"2013-07-08T12:24:53.098Z","last_seen":"2016-06-06T19:11:24.035Z","has_ordered":true,"latest_purchase":"2016-05-31T13:21:41.023Z","has_newsletter":false,"groups":["collector","returns","reviewer"],"nb_commands":7,"total_spent":1410.44},{"id":316,"first_name":"Glen","last_name":"Graham","email":"kikmubun@pot.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/56ab8cfbfb7ba6b44b817c6e8c33c6af.png","birthday":null,"first_seen":"2016-05-14T04:15:43.296Z","last_seen":"2016-11-17T08:43:39.467Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":317,"first_name":"Henrietta","last_name":"Gregory","email":"bu@iveoz.org","address":"1854 Ziclu Mill","zipcode":"19265","city":"Cuotli","avatar":"https://robohash.org/2256e57b58f21cb7f0fca41b8d9203af.png","birthday":"1965-07-28T09:19:25.520Z","first_seen":"2014-05-13T06:25:53.483Z","last_seen":"2015-02-07T19:22:23.203Z","has_ordered":true,"latest_purchase":"2015-01-19T04:31:00.957Z","has_newsletter":false,"groups":["collector","reviewer"],"nb_commands":5,"total_spent":1005.76},{"id":318,"first_name":"Anthony","last_name":"Powell","email":"pajfurrib@heg.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6daa4fc8d1eaef1656d49e40fd608a70.png","birthday":null,"first_seen":"2016-08-26T03:43:56.402Z","last_seen":"2016-09-16T20:12:48.253Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":319,"first_name":"Ophelia","last_name":"Patrick","email":"fiduzwu@wal.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b8b518b754ab459ababe0075b4672c2f.png","birthday":null,"first_seen":"2016-05-25T16:08:36.922Z","last_seen":"2016-11-08T05:54:16.322Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":320,"first_name":"Jeffery","last_name":"Greer","email":"ceezu@roho.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8058cb4ffd1b069b605835fd92ce09e9.png","birthday":null,"first_seen":"2015-09-18T07:53:07.524Z","last_seen":"2016-11-06T17:17:07.872Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":321,"first_name":"Tom","last_name":"Pratt","email":"iwu@esad.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7c28a795c0e865124c8dba57df275591.png","birthday":null,"first_seen":"2016-06-30T00:42:09.929Z","last_seen":"2016-11-30T03:56:22.927Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":322,"first_name":"Alvin","last_name":"Wood","email":"wa@jaotedov.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/690af237f93ae3b2a51ef1ab976883ee.png","birthday":null,"first_seen":"2014-03-08T00:22:27.056Z","last_seen":"2016-02-09T20:09:22.743Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":323,"first_name":"Bill","last_name":"Lynch","email":"mogfatod@diwnezus.edu","address":"1199 Buhta Court","zipcode":"68340","city":"Midreota","avatar":"https://robohash.org/eea3c7241827966ff9083f30f3a6b6a8.png","birthday":"1955-12-03T07:54:22.056Z","first_seen":"2015-12-22T13:05:09.575Z","last_seen":"2016-09-14T23:53:52.760Z","has_ordered":true,"latest_purchase":"2016-07-17T10:33:04.235Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":2,"total_spent":153.46},{"id":324,"first_name":"Trevor","last_name":"Watson","email":"fihmu@tevujbek.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4ca784618a08aa30ae90a7cc2547eabe.png","birthday":null,"first_seen":"2015-12-31T07:33:04.328Z","last_seen":"2016-11-23T12:39:00.655Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":325,"first_name":"Etta","last_name":"Lane","email":"wi@ji.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3449f882ebf3563992938d7a836347d1.png","birthday":null,"first_seen":"2015-04-08T01:01:32.069Z","last_seen":"2016-02-25T02:53:17.408Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":326,"first_name":"Amy","last_name":"Bailey","email":"kaiw@fukoped.net","address":"111 Alvi Highway","zipcode":"52446","city":"Zeosbat","avatar":"https://robohash.org/52dbece0b2f654d56f1556f9994b37e3.png","birthday":"1957-01-01T05:37:25.222Z","first_seen":"2015-08-18T02:10:16.688Z","last_seen":"2016-08-15T04:26:28.167Z","has_ordered":true,"latest_purchase":"2016-01-23T17:31:22.105Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":43.05},{"id":327,"first_name":"Mollie","last_name":"Myers","email":"garododu@na.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8f4c037c3ac50e7030433f3072684371.png","birthday":null,"first_seen":"2015-02-05T06:24:32.114Z","last_seen":"2016-07-29T10:54:19.262Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":328,"first_name":"Don","last_name":"Salazar","email":"dem@sihuznaj.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d33445e380e19a46cff8cb5bb9eab63f.png","birthday":null,"first_seen":"2016-07-21T23:27:46.992Z","last_seen":"2016-10-04T05:39:05.241Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":329,"first_name":"Cecilia","last_name":"Delgado","email":"oweva@nugpuksuj.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ad0538878dc6f65c4a0df1bc1a688b76.png","birthday":null,"first_seen":"2015-07-01T05:04:00.060Z","last_seen":"2016-09-30T07:25:46.225Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":330,"first_name":"Nina","last_name":"Boone","email":"wuweg@ewelezi.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0c7614c3bf8aeec32251aba0febe9a3f.png","birthday":null,"first_seen":"2016-02-09T17:17:56.993Z","last_seen":"2016-10-22T14:43:06.812Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":331,"first_name":"Raymond","last_name":"Howard","email":"mozivdo@ced.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c4e9c96b2813f8865ab42e47eaac6051.png","birthday":null,"first_seen":"2016-05-28T17:28:49.810Z","last_seen":"2016-08-18T02:36:36.020Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":332,"first_name":"Craig","last_name":"Gill","email":"zapeslal@mi.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7be26d75673a3e22699637f3dd6e8280.png","birthday":null,"first_seen":"2016-12-25T19:58:02.136Z","last_seen":"2016-12-30T06:50:24.951Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":333,"first_name":"John","last_name":"Walton","email":"jenve@jak.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/214727663a8c2006b8efad9167768157.png","birthday":null,"first_seen":"2013-07-26T18:58:34.374Z","last_seen":"2016-08-31T21:27:51.741Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":334,"first_name":"Emily","last_name":"Keller","email":"cuh@gikwo.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/399bf1a60a232c986129d1158c9a89ce.png","birthday":null,"first_seen":"2017-01-02T14:34:45.435Z","last_seen":"2017-01-05T00:24:50.149Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":335,"first_name":"Jesus","last_name":"McGee","email":"cu@bittihro.co.uk","address":"1435 Biog Plaza","zipcode":"02575","city":"Cashorkom","avatar":"https://robohash.org/42c405fbed4cb23d8b5cd3dff7db14cc.png","birthday":"1995-11-22T07:09:14.377Z","first_seen":"2016-01-19T16:59:01.275Z","last_seen":"2016-03-09T06:01:03.840Z","has_ordered":true,"latest_purchase":"2016-03-07T05:33:52.096Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":4,"total_spent":922.76},{"id":336,"first_name":"Kevin","last_name":"Erickson","email":"jilodo@wen.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e23a471bb4135a1457226db1270a7d74.png","birthday":null,"first_seen":"2016-05-01T00:03:49.499Z","last_seen":"2016-11-02T12:30:50.707Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":337,"first_name":"Brett","last_name":"Rhodes","email":"ezgidi@rogapef.gov","address":"337 Tiojo Glen","zipcode":"02948","city":"Mojisri","avatar":"https://robohash.org/eb862dd2b317a8ff79e989d2131d5b56.png","birthday":"1991-07-01T08:14:51.416Z","first_seen":"2016-05-04T09:21:00.515Z","last_seen":"2016-11-20T07:35:28.539Z","has_ordered":true,"latest_purchase":"2016-09-18T09:59:46.874Z","has_newsletter":false,"groups":["ordered_once","regular","reviewer"],"nb_commands":1,"total_spent":921.84},{"id":338,"first_name":"John","last_name":"Cook","email":"gujoru@upidi.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/bb94792546b12f228ff6b99206725047.png","birthday":null,"first_seen":"2016-03-07T19:15:16.844Z","last_seen":"2016-09-25T02:02:09.118Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":339,"first_name":"Esther","last_name":"Morrison","email":"ciboz@cod.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c4649b93f24b1a44eafdecb12c91c682.png","birthday":null,"first_seen":"2016-02-19T11:50:45.921Z","last_seen":"2016-12-22T15:15:15.109Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":340,"first_name":"Mayme","last_name":"Terry","email":"vav@jokijadu.edu","address":"1124 Urmo Square","zipcode":"24060","city":"Pepnecoje","avatar":"https://robohash.org/ce1ee16b4f74c3d52ebbc7830efc201f.png","birthday":"1962-02-16T02:27:50.301Z","first_seen":"2014-04-11T01:31:18.224Z","last_seen":"2015-11-22T02:34:19.595Z","has_ordered":true,"latest_purchase":"2015-09-02T05:32:33.051Z","has_newsletter":false,"groups":["returns"],"nb_commands":3,"total_spent":467.23},{"id":341,"first_name":"Joel","last_name":"Fox","email":"ni@wiabu.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d42f9c0750d6f0b2067953379459c254.png","birthday":null,"first_seen":"2016-06-09T22:17:49.400Z","last_seen":"2016-12-17T00:02:06.794Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":342,"first_name":"Iva","last_name":"Neal","email":"zed@okwopiz.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d91d40982d773c7ba2608e7113b2f1ad.png","birthday":null,"first_seen":"2016-12-12T09:55:35.195Z","last_seen":"2017-01-04T06:34:01.395Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":343,"first_name":"Caleb","last_name":"Rice","email":"nafewa@naf.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a5d502bfff56fed761508c3eb6ba2e4a.png","birthday":null,"first_seen":"2016-05-06T18:43:47.275Z","last_seen":"2016-09-05T21:23:01.309Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":344,"first_name":"Carrie","last_name":"Manning","email":"wu@winezoju.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d84b5634a933e756972faf74a15689bc.png","birthday":null,"first_seen":"2015-03-27T12:04:38.756Z","last_seen":"2016-02-23T14:03:39.645Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":345,"first_name":"Eula","last_name":"Mendez","email":"vilso@zun.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/616db360e415324fb72881033c2579e6.png","birthday":null,"first_seen":"2016-11-16T00:01:25.410Z","last_seen":"2016-12-25T14:13:42.690Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":346,"first_name":"Robert","last_name":"Reed","email":"cif@otutgi.edu","address":"1213 Nuhe Trail","zipcode":"90025","city":"Zatetoda","avatar":"https://robohash.org/181b71c8075cb3b1a8fe92d3b4e2ad96.png","birthday":"1970-01-17T11:52:12.579Z","first_seen":"2012-04-06T22:47:01.099Z","last_seen":"2015-03-31T13:49:51.873Z","has_ordered":true,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":347,"first_name":"Martha","last_name":"Miller","email":"fofe@poczago.edu","address":"811 Joupi Glen","zipcode":"02401","city":"Jaitjoc","avatar":"https://robohash.org/acf82ca2110aad821de80d5df6df512f.png","birthday":"1988-10-07T10:18:43.439Z","first_seen":"2016-10-21T18:14:26.983Z","last_seen":"2016-12-10T00:58:51.411Z","has_ordered":true,"latest_purchase":"2016-11-01T15:10:10.350Z","has_newsletter":true,"groups":["ordered_once"],"nb_commands":1,"total_spent":217.34},{"id":348,"first_name":"Eugene","last_name":"Henderson","email":"pomraji@gaelfor.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2835f4fea1a8d857afea13d5e12b19fd.png","birthday":null,"first_seen":"2013-06-22T01:01:39.585Z","last_seen":"2014-11-28T10:58:18.563Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":349,"first_name":"Logan","last_name":"Young","email":"kereula@buapado.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/87282ca1e0cf653754cc64bfa48454af.png","birthday":null,"first_seen":"2015-11-28T17:05:30.536Z","last_seen":"2016-07-24T00:21:14.694Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":350,"first_name":"Lida","last_name":"Walker","email":"egejov@lu.gov","address":"245 Tamah Glen","zipcode":"97847","city":"Siwugpek","avatar":"https://robohash.org/bccd0d64c4f8fd16b0791fa861737c86.png","birthday":"1964-05-20T07:47:46.726Z","first_seen":"2016-10-20T08:43:51.099Z","last_seen":"2016-12-29T22:39:46.325Z","has_ordered":true,"latest_purchase":"2016-12-26T05:52:37.574Z","has_newsletter":false,"groups":["collector"],"nb_commands":5,"total_spent":654.51},{"id":351,"first_name":"Lydia","last_name":"Schmidt","email":"bovonu@towop.net","address":"1869 Abdu Loop","zipcode":"28724","city":"Getabo","avatar":"https://robohash.org/7351c02a68f5c9de0669251a6d8069eb.png","birthday":"1997-07-09T03:25:20.487Z","first_seen":"2015-04-05T09:18:26.054Z","last_seen":"2016-10-30T22:16:50.138Z","has_ordered":true,"latest_purchase":"2016-10-12T21:28:24.599Z","has_newsletter":true,"groups":["regular","returns","reviewer"],"nb_commands":3,"total_spent":160.35999999999999},{"id":352,"first_name":"Fanny","last_name":"Hogan","email":"buzacadi@ze.org","address":"355 Osaoh Plaza","zipcode":"25129","city":"Riwecuru","avatar":"https://robohash.org/61d38093c1b8a58734663ce6e764e06b.png","birthday":"1954-09-28T03:38:44.837Z","first_seen":"2015-06-29T16:31:40.019Z","last_seen":"2016-01-30T22:16:26.451Z","has_ordered":true,"latest_purchase":"2015-12-09T17:36:22.658Z","has_newsletter":true,"groups":["ordered_once"],"nb_commands":1,"total_spent":1346.9},{"id":353,"first_name":"Georgia","last_name":"Fisher","email":"kew@zep.org","address":"1495 Vugeg Avenue","zipcode":"44591","city":"Wuwujonu","avatar":"https://robohash.org/d5de837c934a7a5bd765d112dda0e585.png","birthday":"1971-12-10T02:19:08.156Z","first_seen":"2013-11-25T16:51:29.204Z","last_seen":"2015-04-18T08:45:52.726Z","has_ordered":true,"latest_purchase":"2014-05-01T01:50:24.358Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":52.8},{"id":354,"first_name":"Theodore","last_name":"Thornton","email":"ve@cirojet.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/eaddb106ba9967886586b32df3276b2a.png","birthday":null,"first_seen":"2014-03-28T14:30:38.911Z","last_seen":"2016-04-22T08:24:24.753Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":355,"first_name":"Blanche","last_name":"Massey","email":"pezi@hig.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1deee59815a68498658571d2fe708aa3.png","birthday":null,"first_seen":"2014-04-09T05:13:25.669Z","last_seen":"2014-12-27T02:45:28.849Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":356,"first_name":"Dustin","last_name":"Wise","email":"bugebjos@jizod.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f26074d455b19ec1025dec5981b2f7a0.png","birthday":null,"first_seen":"2013-07-31T02:16:14.451Z","last_seen":"2016-04-01T23:59:07.447Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":357,"first_name":"Ethel","last_name":"Robinson","email":"ruavvof@dir.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a6a0825613692cb1f9a01ce3e2ccc995.png","birthday":null,"first_seen":"2016-10-28T22:51:17.321Z","last_seen":"2016-12-22T10:56:48.147Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":358,"first_name":"Alberta","last_name":"Sharp","email":"oknow@weeb.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/cdc220a6f1b1a434296220607701b66b.png","birthday":null,"first_seen":"2015-09-08T22:58:26.952Z","last_seen":"2016-05-27T17:01:38.931Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":359,"first_name":"Shawn","last_name":"Gregory","email":"da@namba.io","address":"459 Kejmi Lane","zipcode":"49102","city":"Lahbomiz","avatar":"https://robohash.org/42014a685d9e0a126ef46a90ab481445.png","birthday":"1968-06-28T23:37:33.152Z","first_seen":"2014-06-22T23:49:31.653Z","last_seen":"2016-12-26T08:12:47.373Z","has_ordered":true,"latest_purchase":"2016-12-16T08:46:26.976Z","has_newsletter":false,"groups":[],"nb_commands":5,"total_spent":951.33},{"id":360,"first_name":"Eugenia","last_name":"Bridges","email":"rokvec@hamonik.org","address":"737 Fuzsu Pike","zipcode":"52591","city":"Nojethip","avatar":"https://robohash.org/813f9bb08c56a1e2aa9a44c3531b76f3.png","birthday":"1998-10-24T23:22:45.736Z","first_seen":"2016-10-11T00:43:57.031Z","last_seen":"2017-01-04T11:00:17.114Z","has_ordered":true,"latest_purchase":"2016-12-22T10:10:06.261Z","has_newsletter":false,"groups":["collector","compulsive"],"nb_commands":6,"total_spent":2986.4500000000003},{"id":361,"first_name":"Connor","last_name":"McKenzie","email":"bimjod@rucfijgu.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/bfd4d475321a3d0dbe03182b1fe233d9.png","birthday":null,"first_seen":"2016-03-17T14:49:54.421Z","last_seen":"2016-12-06T16:08:43.941Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":362,"first_name":"Curtis","last_name":"Lawrence","email":"nilevu@zazfo.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f4157d5b77056ddb97bd5b0786869247.png","birthday":null,"first_seen":"2016-11-02T11:33:47.394Z","last_seen":"2016-12-30T14:42:57.036Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":363,"first_name":"Virginia","last_name":"Frank","email":"muopovot@ocduzbo.org","address":"1068 Juppa Trail","zipcode":"29010","city":"Jechufuz","avatar":"https://robohash.org/ba85542791d2d14ac0afa277f3779695.png","birthday":"1980-01-05T08:25:14.137Z","first_seen":"2015-01-08T22:38:26.731Z","last_seen":"2015-08-24T04:03:30.757Z","has_ordered":true,"latest_purchase":"2015-08-17T17:18:30.992Z","has_newsletter":true,"groups":["collector","regular","reviewer"],"nb_commands":6,"total_spent":681.1499999999999},{"id":364,"first_name":"Delia","last_name":"Cobb","email":"vamme@ozome.net","address":"744 Omge Junction","zipcode":"54454","city":"Rogicsap","avatar":"https://robohash.org/40e37341b853ae14340862c0a674a3c0.png","birthday":"1960-09-08T09:18:20.185Z","first_seen":"2013-12-18T10:26:34.462Z","last_seen":"2015-10-31T12:28:47.074Z","has_ordered":true,"latest_purchase":"2015-10-07T13:43:16.465Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":729.22},{"id":365,"first_name":"Clarence","last_name":"Hamilton","email":"apuhep@se.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/998524c271866688ee3540b65e00a2be.png","birthday":null,"first_seen":"2014-07-03T09:38:27.320Z","last_seen":"2016-06-22T13:30:35.814Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":366,"first_name":"Lora","last_name":"Colon","email":"irehoc@faal.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5cbfd128dc8dd6dbb69d557108614f9a.png","birthday":null,"first_seen":"2015-11-29T19:35:48.686Z","last_seen":"2016-11-30T01:16:26.805Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":367,"first_name":"Sallie","last_name":"Goodwin","email":"uweoz@tusfu.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d8e42114a89b510476fab692fdcaaf27.png","birthday":null,"first_seen":"2015-05-18T08:56:54.645Z","last_seen":"2016-05-23T09:55:49.073Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":368,"first_name":"Ina","last_name":"Hansen","email":"pokwir@imevegi.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/12eb1a9120a29e8773d0e1c2291ce28c.png","birthday":null,"first_seen":"2012-08-26T15:20:04.902Z","last_seen":"2013-09-19T14:26:21.341Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":369,"first_name":"Cory","last_name":"Washington","email":"naop@jim.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f4e6263d2bc3e2c0ea5e673bc121d020.png","birthday":null,"first_seen":"2016-12-06T23:47:56.400Z","last_seen":"2017-01-04T23:19:19.020Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":370,"first_name":"Roxie","last_name":"Cannon","email":"lanowi@mu.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/80a761c9ebdb76b9a377b27f612c0cc0.png","birthday":null,"first_seen":"2015-05-09T01:29:28.985Z","last_seen":"2016-08-19T12:21:36.938Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":371,"first_name":"Marc","last_name":"Burke","email":"gow@efowo.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/74137f729e3b29f52ad1f4ae476efda8.png","birthday":null,"first_seen":"2016-01-01T18:06:10.744Z","last_seen":"2016-10-31T09:11:08.569Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":372,"first_name":"Jose","last_name":"Rice","email":"pup@opimu.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/21523ac6cfb4511aa5bff5b3260cddc0.png","birthday":null,"first_seen":"2016-04-06T21:31:08.971Z","last_seen":"2016-06-29T22:05:23.595Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":373,"first_name":"Kyle","last_name":"Floyd","email":"hevuj@socka.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4605894164ca27aa764ef5d8017b36dc.png","birthday":null,"first_seen":"2014-08-09T06:45:25.223Z","last_seen":"2016-12-26T23:39:19.991Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":374,"first_name":"Elva","last_name":"Wright","email":"apu@pivob.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7621e5558a35e95db21d18f26711bb41.png","birthday":null,"first_seen":"2016-10-09T06:54:38.447Z","last_seen":"2016-12-26T18:16:00.084Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":375,"first_name":"Dean","last_name":"McCoy","email":"ja@vusad.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/69d3d0dcb793bf94fa75cec861ba1aa4.png","birthday":null,"first_seen":"2014-11-03T11:35:29.837Z","last_seen":"2016-10-17T12:04:39.815Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":376,"first_name":"Noah","last_name":"Gregory","email":"bagiwih@jedip.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2fd74e2c9f9d57ab33e87247726d63b5.png","birthday":null,"first_seen":"2013-10-04T07:05:41.715Z","last_seen":"2015-11-11T23:37:12.247Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":377,"first_name":"Nathan","last_name":"Buchanan","email":"badzesar@sad.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/73d7f9f14fffcfa4ac30ba072a94dc03.png","birthday":null,"first_seen":"2016-04-15T06:36:32.540Z","last_seen":"2016-11-23T00:36:36.918Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":378,"first_name":"Mollie","last_name":"Bryant","email":"eb@ruwbukgo.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/78ad809c5cf0c8fc7ddb7c8c47e5470d.png","birthday":null,"first_seen":"2016-03-05T09:23:11.026Z","last_seen":"2016-10-22T07:46:18.296Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":379,"first_name":"Thomas","last_name":"Frank","email":"we@nabdut.edu","address":"206 Upoudi Grove","zipcode":"03154","city":"Reptigej","avatar":"https://robohash.org/0e6c70b5479b60326cec93b950262270.png","birthday":"1973-05-09T03:05:24.226Z","first_seen":"2015-12-24T16:22:24.336Z","last_seen":"2016-04-29T08:14:58.519Z","has_ordered":true,"latest_purchase":"2016-03-22T19:59:36.385Z","has_newsletter":false,"groups":[],"nb_commands":2,"total_spent":426.73},{"id":380,"first_name":"Dollie","last_name":"Gonzales","email":"bat@lenbage.org","address":"1506 Zore Grove","zipcode":"43820","city":"Delued","avatar":"https://robohash.org/75f1334cf633b4af1d6eb0579dd7303a.png","birthday":"1991-08-12T04:23:11.925Z","first_seen":"2014-04-12T05:15:23.609Z","last_seen":"2016-09-02T13:04:13.630Z","has_ordered":true,"latest_purchase":"2016-06-02T11:22:04.934Z","has_newsletter":true,"groups":[],"nb_commands":2,"total_spent":162.78},{"id":381,"first_name":"Adelaide","last_name":"Newton","email":"ru@wuk.co.uk","address":"1625 Nonow Heights","zipcode":"99715","city":"Zoetson","avatar":"https://robohash.org/22e60f4a8d49fbb41732b7adf9c6efdb.png","birthday":"1982-03-04T05:59:01.420Z","first_seen":"2015-05-22T03:11:42.206Z","last_seen":"2015-09-21T17:39:26.348Z","has_ordered":true,"latest_purchase":"2015-08-06T09:09:57.367Z","has_newsletter":false,"groups":["ordered_once","reviewer"],"nb_commands":1,"total_spent":207.51},{"id":382,"first_name":"Marguerite","last_name":"Greer","email":"lol@jompo.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fc9cc1598eee0bddbc7449ef99b78c62.png","birthday":null,"first_seen":"2016-12-21T16:37:51.452Z","last_seen":"2016-12-29T09:56:41.561Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":383,"first_name":"George","last_name":"Perkins","email":"uw@saemco.gov","address":"114 Fihca Glen","zipcode":"41769","city":"Umvefat","avatar":"https://robohash.org/f6da589cee26d93f3069587149b55e8e.png","birthday":"1998-04-03T01:34:20.036Z","first_seen":"2016-03-10T07:43:06.187Z","last_seen":"2016-08-17T12:37:40.703Z","has_ordered":true,"latest_purchase":"2016-07-18T00:18:03.146Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":913.21},{"id":384,"first_name":"Frances","last_name":"Powers","email":"ituza@nivowapa.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/cbcbd94dcc8309c7929377547a148120.png","birthday":null,"first_seen":"2015-11-29T01:18:42.170Z","last_seen":"2016-09-15T15:14:11.342Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":385,"first_name":"Nathan","last_name":"Luna","email":"jisurak@bib.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/64ab9af146eb6de9d5113b9d4e74d1fc.png","birthday":null,"first_seen":"2014-12-29T21:54:06.322Z","last_seen":"2016-11-26T20:59:13.381Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":386,"first_name":"Randall","last_name":"Burgess","email":"lagpe@mepal.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/64ec351b86cc16c1681a2f561f189eed.png","birthday":null,"first_seen":"2014-12-01T00:58:19.323Z","last_seen":"2016-04-13T06:36:59.753Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":387,"first_name":"Iva","last_name":"Gibbs","email":"hec@urtigsim.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/beaff194ef456a6121c4b2d37f31c256.png","birthday":null,"first_seen":"2016-06-03T14:06:51.210Z","last_seen":"2016-10-21T08:14:58.813Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":388,"first_name":"Eugenia","last_name":"Cain","email":"hokros@mecotwec.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/bc90df9e8754876cca68504e1e7f9315.png","birthday":null,"first_seen":"2016-02-01T15:52:53.113Z","last_seen":"2016-12-04T23:28:33.383Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":389,"first_name":"Edward","last_name":"Perry","email":"dugbope@mi.edu","address":"930 Ehze Drive","zipcode":"95693","city":"Wotjego","avatar":"https://robohash.org/ae13641b1dd171651a096113127e3724.png","birthday":"1956-07-06T05:22:35.477Z","first_seen":"2016-08-12T08:35:30.297Z","last_seen":"2016-12-24T22:23:15.170Z","has_ordered":true,"latest_purchase":"2016-12-08T20:53:56.431Z","has_newsletter":true,"groups":["collector","regular","reviewer"],"nb_commands":3,"total_spent":1258.1},{"id":390,"first_name":"Genevieve","last_name":"Hughes","email":"wusad@pani.org","address":"443 Melnot Extension","zipcode":"78440","city":"Veapeluv","avatar":"https://robohash.org/779b7846e59da29f0a2433983c34d1ad.png","birthday":"1998-05-13T00:16:53.242Z","first_seen":"2015-08-25T21:46:46.904Z","last_seen":"2016-10-15T19:31:29.976Z","has_ordered":true,"latest_purchase":"2016-10-02T10:54:04.150Z","has_newsletter":true,"groups":["collector","regular"],"nb_commands":5,"total_spent":1137.61},{"id":391,"first_name":"Earl","last_name":"Parsons","email":"du@ririd.com","address":"564 Imke Plaza","zipcode":"40824","city":"Losgagogu","avatar":"https://robohash.org/d36c1ea81fdaec39eb5ec6d309641f8d.png","birthday":"1987-12-31T01:00:12.721Z","first_seen":"2012-10-09T22:46:29.832Z","last_seen":"2014-12-24T12:21:42.130Z","has_ordered":true,"latest_purchase":"2014-09-23T16:09:22.074Z","has_newsletter":false,"groups":["regular","reviewer"],"nb_commands":3,"total_spent":478.91},{"id":392,"first_name":"Violet","last_name":"Wong","email":"dib@olego.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/13ce575b181f87d41f0b37018f51d819.png","birthday":null,"first_seen":"2016-11-02T10:51:56.163Z","last_seen":"2016-12-27T11:45:45.535Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":393,"first_name":"Violet","last_name":"Thomas","email":"gabe@osuc.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b5529c5c9fb6a1ef99542031d7aa99bf.png","birthday":null,"first_seen":"2016-08-18T09:43:25.653Z","last_seen":"2016-11-09T03:39:49.773Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":394,"first_name":"Keith","last_name":"Farmer","email":"etawon@onfu.gov","address":"993 Ocared Manor","zipcode":"05387","city":"Afejeno","avatar":"https://robohash.org/525874be1ee8b2446ac0531345c0d57b.png","birthday":"1955-09-04T08:00:53.223Z","first_seen":"2015-06-20T09:08:14.140Z","last_seen":"2016-07-23T02:21:49.924Z","has_ordered":true,"latest_purchase":"2016-01-31T19:09:25.390Z","has_newsletter":false,"groups":["ordered_once","reviewer"],"nb_commands":1,"total_spent":31.05},{"id":395,"first_name":"Phoebe","last_name":"Carlson","email":"ogra@losugda.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3c8de60d903dc80235324d2aa78d6da2.png","birthday":null,"first_seen":"2016-03-12T21:31:30.756Z","last_seen":"2016-09-10T18:46:09.499Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":396,"first_name":"Evan","last_name":"Todd","email":"dih@wocikuafa.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5369002682f1daea3d9196d929248cb3.png","birthday":null,"first_seen":"2015-08-17T01:48:29.087Z","last_seen":"2016-08-01T02:22:10.350Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":397,"first_name":"Bill","last_name":"Wilson","email":"bid@dimtinmi.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e9936edd7aebb3b2e62234f4ce0499d0.png","birthday":null,"first_seen":"2016-07-12T11:05:51.000Z","last_seen":"2016-11-09T05:10:08.887Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":398,"first_name":"Bernice","last_name":"Chapman","email":"lewete@fegzebme.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/894ae6012e7918e747d0e2ee1a7da5a8.png","birthday":null,"first_seen":"2013-07-11T20:28:18.041Z","last_seen":"2014-08-28T17:04:08.529Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":399,"first_name":"Bradley","last_name":"Wells","email":"wapesac@eb.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e6cafcdfd1234669b2a8b49f018ba7fc.png","birthday":null,"first_seen":"2014-11-26T18:26:30.013Z","last_seen":"2016-05-13T09:59:36.756Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":400,"first_name":"Ada","last_name":"Bailey","email":"duvud@da.edu","address":"1308 Idzis Pass","zipcode":"20393","city":"Racewrew","avatar":"https://robohash.org/cc787b918ba255011a9c66f19a51d424.png","birthday":"1986-10-28T03:52:20.458Z","first_seen":"2013-06-19T02:33:36.168Z","last_seen":"2015-08-15T23:40:26.941Z","has_ordered":true,"latest_purchase":"2015-05-03T22:18:19.513Z","has_newsletter":false,"groups":["regular","returns","reviewer"],"nb_commands":2,"total_spent":213.73},{"id":401,"first_name":"Winnie","last_name":"Moran","email":"caco@nule.gov","address":"1883 Bomgu Parkway","zipcode":"80257","city":"Nefdicih","avatar":"https://robohash.org/cdf958390864204cfe1aba9bf3e27e5a.png","birthday":"1993-12-27T02:45:06.787Z","first_seen":"2015-07-29T09:35:30.725Z","last_seen":"2015-10-16T18:24:19.178Z","has_ordered":true,"latest_purchase":"2015-10-01T23:23:35.581Z","has_newsletter":false,"groups":["returns"],"nb_commands":2,"total_spent":213.08999999999997},{"id":402,"first_name":"Maude","last_name":"Morales","email":"aji@od.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c6c317ec3325d726a710f236196db7a5.png","birthday":null,"first_seen":"2014-11-17T18:07:59.754Z","last_seen":"2016-09-12T21:53:25.854Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":403,"first_name":"Keith","last_name":"Robinson","email":"ivoirasob@godebwur.net","address":"905 Ritki Court","zipcode":"24317","city":"Vajolika","avatar":"https://robohash.org/0f10aa0993356e3f73833fa26ac333af.png","birthday":"1994-01-02T01:40:58.940Z","first_seen":"2015-02-25T11:11:46.962Z","last_seen":"2016-04-23T01:16:32.114Z","has_ordered":true,"latest_purchase":"2015-09-14T01:28:47.654Z","has_newsletter":false,"groups":["ordered_once","returns"],"nb_commands":1,"total_spent":221.43},{"id":404,"first_name":"Olivia","last_name":"Fox","email":"pazsamit@uweriaza.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/94236abc64e42031a8db538eab892061.png","birthday":null,"first_seen":"2015-12-13T10:33:06.254Z","last_seen":"2016-09-13T16:37:09.718Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":405,"first_name":"Lelia","last_name":"Wong","email":"se@sijod.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3f09cd2ccefa1087bc2de8e8e4c8d8d2.png","birthday":null,"first_seen":"2014-10-21T18:26:00.562Z","last_seen":"2016-05-25T09:11:37.718Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":406,"first_name":"Eddie","last_name":"Burns","email":"cumu@nowu.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/817960ab97899cc3ad389c69e905a835.png","birthday":null,"first_seen":"2016-06-04T07:18:01.866Z","last_seen":"2016-09-18T21:39:12.615Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":407,"first_name":"Eva","last_name":"Gross","email":"pe@sorih.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b60374eb67730ece732b0d960bf5ecb6.png","birthday":null,"first_seen":"2013-02-18T12:26:17.097Z","last_seen":"2014-02-22T11:25:01.370Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":408,"first_name":"Mabelle","last_name":"Fields","email":"voazomu@ene.com","address":"1720 Icodad Road","zipcode":"23409","city":"Ruwisa","avatar":"https://robohash.org/0327ceef40b911808ff321839bae24f9.png","birthday":"1973-09-08T08:52:47.155Z","first_seen":"2014-10-02T19:19:51.869Z","last_seen":"2014-12-05T02:30:08.249Z","has_ordered":true,"latest_purchase":"2014-12-03T17:54:54.632Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":89.99},{"id":409,"first_name":"Marc","last_name":"James","email":"hinoc@horik.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b84f10e1a774905855330bfdee3a62f5.png","birthday":null,"first_seen":"2013-02-28T07:04:35.512Z","last_seen":"2016-11-12T11:46:31.723Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":410,"first_name":"Ryan","last_name":"Sherman","email":"zu@vu.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3d10d46488cb03aca9233c29da857830.png","birthday":null,"first_seen":"2016-07-23T00:49:48.961Z","last_seen":"2016-11-18T17:35:24.405Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":411,"first_name":"Jacob","last_name":"Lamb","email":"sona@lu.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/bfb9f96777ce02962d2cd6c8c76d02fb.png","birthday":null,"first_seen":"2012-05-17T18:14:32.686Z","last_seen":"2016-02-13T06:18:14.044Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":412,"first_name":"Allie","last_name":"Larson","email":"fet@sacu.gov","address":"1732 Ejabe Drive","zipcode":"19263","city":"Junzowsi","avatar":"https://robohash.org/360d0a6d288c9f9b5b9704709689545c.png","birthday":"1975-06-30T00:25:54.390Z","first_seen":"2014-08-21T02:01:08.955Z","last_seen":"2016-02-12T10:22:49.160Z","has_ordered":true,"latest_purchase":"2015-12-28T07:38:27.001Z","has_newsletter":false,"groups":[],"nb_commands":2,"total_spent":296.79},{"id":413,"first_name":"Curtis","last_name":"Newman","email":"pejvid@uzbivon.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d8cb04faa98950f2781c6a903682d154.png","birthday":null,"first_seen":"2012-10-04T22:12:54.548Z","last_seen":"2015-11-06T08:07:44.400Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":414,"first_name":"Jane","last_name":"Chapman","email":"lanzufic@apvumwi.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d111ebc2807b7c53f56871bb4360a1a1.png","birthday":null,"first_seen":"2016-04-23T06:25:31.904Z","last_seen":"2016-12-08T02:38:37.324Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":415,"first_name":"Bill","last_name":"Hines","email":"co@zuhujuf.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c1405fb42e6cb0f6e4ef6beb7a1361a8.png","birthday":null,"first_seen":"2016-11-12T07:27:24.882Z","last_seen":"2016-12-20T19:56:55.774Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":416,"first_name":"Mike","last_name":"Delgado","email":"eg@lekzoc.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6dc536564d66b3e11b34ae38687640ad.png","birthday":null,"first_seen":"2016-09-11T08:28:02.645Z","last_seen":"2016-10-23T08:28:28.665Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":417,"first_name":"Winnie","last_name":"Chandler","email":"aj@ba.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/48536862bc7f10243ed2c794001f6fe0.png","birthday":null,"first_seen":"2016-05-31T08:39:22.839Z","last_seen":"2016-11-09T22:34:39.023Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":418,"first_name":"Rebecca","last_name":"Woods","email":"vepu@memhikoto.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d4858c7975fb936c8175ef23a64a93b3.png","birthday":null,"first_seen":"2012-08-11T13:11:07.461Z","last_seen":"2015-03-20T15:40:42.210Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":419,"first_name":"Wayne","last_name":"Sanchez","email":"imgucu@tuwaev.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fd094371339a4301d1a79ae142a00123.png","birthday":null,"first_seen":"2016-05-21T17:31:07.056Z","last_seen":"2016-11-22T07:58:15.099Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":420,"first_name":"Gavin","last_name":"Bryant","email":"kadni@temser.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/9bf85456ded43e86af4d16b82267257e.png","birthday":null,"first_seen":"2015-09-25T06:55:57.035Z","last_seen":"2016-06-13T13:08:04.849Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":421,"first_name":"Flora","last_name":"Willis","email":"gidan@betijboh.org","address":"206 Kail Pike","zipcode":"35874","city":"Dotobbez","avatar":"https://robohash.org/5cd57c85cb618e9552d1a29c394c78f9.png","birthday":"1955-12-13T10:13:18.383Z","first_seen":"2016-07-22T05:45:56.099Z","last_seen":"2016-11-23T19:53:03.028Z","has_ordered":true,"latest_purchase":"2016-11-10T16:16:41.343Z","has_newsletter":true,"groups":[],"nb_commands":4,"total_spent":691.97},{"id":422,"first_name":"Noah","last_name":"Collins","email":"nakiso@onieji.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/82d97501e4979876b0afad8b6fdbdf86.png","birthday":null,"first_seen":"2014-09-22T21:11:10.332Z","last_seen":"2016-12-23T09:47:41.756Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":423,"first_name":"Dollie","last_name":"Wolfe","email":"owenolre@foznajo.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/37b5ca65248c8ddd4b4025f32484a9ec.png","birthday":null,"first_seen":"2015-04-21T23:58:51.505Z","last_seen":"2016-11-30T07:31:37.375Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":424,"first_name":"Isabella","last_name":"Banks","email":"tutukpe@nupela.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0cf35349467e53da4b4ef81a1878a101.png","birthday":null,"first_seen":"2015-09-24T04:25:10.747Z","last_seen":"2016-01-22T07:28:40.911Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":425,"first_name":"Scott","last_name":"Reese","email":"ace@der.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/935515abff143f23dde27bad8021f667.png","birthday":null,"first_seen":"2013-12-10T08:44:10.555Z","last_seen":"2015-07-19T23:11:06.386Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":426,"first_name":"Richard","last_name":"Sherman","email":"apwicum@vi.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b482fa25506a9e26ea5953776f23d83b.png","birthday":null,"first_seen":"2015-12-27T00:04:56.893Z","last_seen":"2016-09-03T14:32:29.799Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":427,"first_name":"Ronnie","last_name":"Wilkins","email":"rifni@jo.edu","address":"1229 Owivi Junction","zipcode":"58111","city":"Lawonkem","avatar":"https://robohash.org/d15ae4a11e6de5c7ca43b60699fe98e2.png","birthday":"1964-10-30T09:02:05.617Z","first_seen":"2016-04-30T07:19:38.289Z","last_seen":"2016-12-21T18:00:23.780Z","has_ordered":true,"latest_purchase":"2016-10-27T01:31:05.651Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":92.63},{"id":428,"first_name":"Russell","last_name":"Gonzales","email":"we@go.co.uk","address":"1124 Meges Junction","zipcode":"19735","city":"Sogedne","avatar":"https://robohash.org/ca71bc603ae5efd8f5000be325d2d8d6.png","birthday":"1978-11-11T04:59:14.675Z","first_seen":"2015-09-15T00:23:55.215Z","last_seen":"2016-09-21T04:50:06.454Z","has_ordered":true,"latest_purchase":"2016-09-19T23:32:46.135Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":590},{"id":429,"first_name":"Mitchell","last_name":"Reynolds","email":"horin@jacte.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fec26dccb30e1ec30053abbbc26315a4.png","birthday":null,"first_seen":"2016-02-19T17:27:23.219Z","last_seen":"2016-11-13T12:59:13.811Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":430,"first_name":"Vincent","last_name":"Copeland","email":"vuhlis@ralvogca.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/05deed6cdb6dc47317c3fa1bb107fce5.png","birthday":null,"first_seen":"2015-08-18T08:23:50.682Z","last_seen":"2016-09-02T14:44:10.874Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":431,"first_name":"Lulu","last_name":"Henry","email":"mo@upiaro.com","address":"1488 Kowul Grove","zipcode":"62982","city":"Savisbav","avatar":"https://robohash.org/60449ea1cf19e628c8898b02886b6d43.png","birthday":"1956-12-26T03:45:59.394Z","first_seen":"2015-11-14T12:26:08.706Z","last_seen":"2016-12-26T19:14:04.220Z","has_ordered":true,"latest_purchase":"2016-04-23T06:26:36.428Z","has_newsletter":true,"groups":["regular","returns"],"nb_commands":3,"total_spent":296.89},{"id":432,"first_name":"Mason","last_name":"Mendoza","email":"egeciwza@rasic.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a675c5b4f33a47f461e0d16d6e0627fd.png","birthday":null,"first_seen":"2012-07-28T10:09:29.331Z","last_seen":"2016-02-02T14:40:12.699Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":433,"first_name":"Martha","last_name":"Harper","email":"vozro@vusum.org","address":"213 Sufbib Key","zipcode":"80444","city":"Cuzdomu","avatar":"https://robohash.org/c9dbe7cb0bb2ac5b2747a23225e7c4d0.png","birthday":"1961-10-01T09:23:56.244Z","first_seen":"2016-03-20T12:03:31.709Z","last_seen":"2016-11-24T00:35:52.474Z","has_ordered":true,"latest_purchase":"2016-10-13T08:19:57.791Z","has_newsletter":false,"groups":[],"nb_commands":2,"total_spent":100.28999999999999},{"id":434,"first_name":"Douglas","last_name":"Green","email":"dufgut@jiv.org","address":"865 Lirog Terrace","zipcode":"22197","city":"Redikpom","avatar":"https://robohash.org/ce455debed67abfeed86e14b2ac6f7a8.png","birthday":"1995-12-18T00:59:49.871Z","first_seen":"2015-11-29T13:41:49.599Z","last_seen":"2016-05-21T07:53:40.751Z","has_ordered":true,"latest_purchase":"2016-04-02T13:43:50.189Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":225.57},{"id":435,"first_name":"Lora","last_name":"Doyle","email":"pez@da.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/010a1b7efd45cb497e5a9c6f28146b0e.png","birthday":null,"first_seen":"2014-04-24T16:45:10.826Z","last_seen":"2016-09-18T23:51:30.168Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":436,"first_name":"Etta","last_name":"Barker","email":"dizope@rir.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0e8d43ae6cbe74acbd1e7fbf69b8c7cd.png","birthday":null,"first_seen":"2016-10-07T23:17:07.919Z","last_seen":"2016-11-08T20:37:07.931Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":437,"first_name":"Zachary","last_name":"Morales","email":"ivoko@vejjomeb.io","address":"816 Orsi Place","zipcode":"83040","city":"Banevage","avatar":"https://robohash.org/29fe47e2301f6d05633274945bbbb2b5.png","birthday":"1998-01-16T10:40:48.029Z","first_seen":"2014-07-16T08:22:43.772Z","last_seen":"2015-12-31T10:36:15.307Z","has_ordered":true,"latest_purchase":"2014-10-12T23:19:23.205Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":75.22},{"id":438,"first_name":"Rosetta","last_name":"Nash","email":"owa@olvu.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c835433f426503ca03b285ae480a2f5e.png","birthday":null,"first_seen":"2012-10-01T05:38:48.348Z","last_seen":"2014-03-28T18:07:03.287Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":439,"first_name":"Emily","last_name":"Richardson","email":"benusgam@ec.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/21913c870b8fa50703635cd4fc7f5143.png","birthday":null,"first_seen":"2015-01-30T08:29:27.969Z","last_seen":"2016-01-20T15:53:18.149Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":440,"first_name":"Norman","last_name":"Goodwin","email":"zehu@epeemoam.gov","address":"1529 Eciri Highway","zipcode":"57766","city":"Izbodub","avatar":"https://robohash.org/6a951582645c9db1eb63b7cd0fb2f29a.png","birthday":"1987-11-29T11:03:17.187Z","first_seen":"2015-12-16T12:35:43.791Z","last_seen":"2016-09-22T19:52:42.659Z","has_ordered":true,"latest_purchase":"2016-09-17T09:10:11.557Z","has_newsletter":false,"groups":["returns","reviewer"],"nb_commands":2,"total_spent":238.93},{"id":441,"first_name":"Hulda","last_name":"Simmons","email":"gajzotidi@rujkuzib.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/53d50f0f83e8684784c79d466ca4bf9c.png","birthday":null,"first_seen":"2015-08-27T18:33:18.645Z","last_seen":"2016-10-28T19:01:53.916Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":442,"first_name":"Elva","last_name":"Ferguson","email":"sole@walgi.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ea08083f7a20c6e9a8bdf99b37f25d2e.png","birthday":null,"first_seen":"2015-11-23T14:12:51.972Z","last_seen":"2016-12-26T19:32:56.887Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":443,"first_name":"Eula","last_name":"Bates","email":"gi@apa.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/841ac5f245a2b13713c3388cc91790d5.png","birthday":null,"first_seen":"2015-12-30T21:58:00.625Z","last_seen":"2016-08-08T19:12:56.277Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":444,"first_name":"Don","last_name":"Johnston","email":"go@ebo.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/dd91c5c594b69660a52a1eab6fd5e01b.png","birthday":null,"first_seen":"2014-11-12T03:36:08.198Z","last_seen":"2016-06-08T11:07:23.896Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":445,"first_name":"Elnora","last_name":"Foster","email":"uc@worebme.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e0d7b57230cffaebc3d9340b5d85795f.png","birthday":null,"first_seen":"2015-11-03T12:39:34.642Z","last_seen":"2016-11-29T06:00:04.295Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":446,"first_name":"Beulah","last_name":"Abbott","email":"lesirse@pud.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/bd3d337530a458ec65999af2fefbd4f5.png","birthday":null,"first_seen":"2015-07-18T02:30:20.978Z","last_seen":"2016-12-04T05:37:47.948Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":447,"first_name":"Millie","last_name":"Ballard","email":"fefedidez@ogle.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3900e5b8065bb2404a5240347c332f70.png","birthday":null,"first_seen":"2016-03-16T17:05:05.119Z","last_seen":"2017-01-01T13:34:25.515Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":448,"first_name":"Alice","last_name":"Vargas","email":"ade@pa.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e6ef5fdc87d71b4fff7662894c7b54c8.png","birthday":null,"first_seen":"2014-12-08T12:28:38.673Z","last_seen":"2016-09-13T18:47:00.319Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":449,"first_name":"Emma","last_name":"Pope","email":"hiwupcu@eriluuze.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0b8ed8fe8374ca8d4a5dc007d00db1cb.png","birthday":null,"first_seen":"2015-06-14T16:17:24.742Z","last_seen":"2015-10-06T13:12:29.039Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":450,"first_name":"Sophia","last_name":"Carlson","email":"fuzbu@ked.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0e61546bfdab3264537a35f6c9642c9a.png","birthday":null,"first_seen":"2015-10-27T19:25:45.952Z","last_seen":"2016-09-21T12:14:07.024Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":451,"first_name":"Christian","last_name":"Carr","email":"jave@bo.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5c7ef67be49418cd94b3068289d79ac6.png","birthday":null,"first_seen":"2014-05-04T10:31:11.565Z","last_seen":"2015-03-02T16:26:59.191Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":452,"first_name":"Lettie","last_name":"Moreno","email":"hah@azvaeh.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/935467054d6d860cd08a3c24d53a1d14.png","birthday":null,"first_seen":"2015-12-19T07:58:17.384Z","last_seen":"2016-10-29T01:56:03.331Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":453,"first_name":"Bernard","last_name":"Carson","email":"suj@larotozu.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e6ebfdc041d3b6ad5599fbaca2c7ede0.png","birthday":null,"first_seen":"2016-01-04T14:59:46.536Z","last_seen":"2016-03-29T13:01:07.272Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":454,"first_name":"Nancy","last_name":"Terry","email":"pilimib@veiro.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fad6a740caa44ceb71deec306f8466c3.png","birthday":null,"first_seen":"2013-08-20T20:16:49.053Z","last_seen":"2014-06-08T09:26:01.733Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":455,"first_name":"Jack","last_name":"Gomez","email":"vus@fupvotli.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2d62f5c5eabb91d8aa4b7ffeb0726464.png","birthday":null,"first_seen":"2015-11-27T16:04:31.195Z","last_seen":"2016-03-24T09:46:00.396Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":456,"first_name":"Wayne","last_name":"Carr","email":"nakneiti@de.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/219ef8172e70f6bc9150db76e5d953e9.png","birthday":null,"first_seen":"2013-11-12T17:18:45.794Z","last_seen":"2016-05-14T02:21:49.203Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":457,"first_name":"Sadie","last_name":"Vargas","email":"acola@wovaruuc.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fdd8f831ddd4bb3cd008a19bad18d498.png","birthday":null,"first_seen":"2014-04-30T03:18:20.119Z","last_seen":"2016-02-21T19:40:45.965Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":458,"first_name":"Rose","last_name":"Higgins","email":"kuonaeka@ro.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f09ee574c6f6f9d08643a5c369a95d4a.png","birthday":null,"first_seen":"2016-01-01T07:33:55.125Z","last_seen":"2016-12-31T11:59:26.927Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":459,"first_name":"Wesley","last_name":"Summers","email":"bakesam@mow.org","address":"1607 Bopa Manor","zipcode":"90010","city":"Cibrivu","avatar":"https://robohash.org/f6cd24681e471bb25fffce4b2b360fd0.png","birthday":"1961-12-05T11:56:33.691Z","first_seen":"2016-04-25T22:58:29.546Z","last_seen":"2016-12-17T07:54:42.143Z","has_ordered":true,"latest_purchase":"2016-12-09T15:05:45.131Z","has_newsletter":true,"groups":["returns","reviewer"],"nb_commands":3,"total_spent":523.5699999999999},{"id":460,"first_name":"Keith","last_name":"Warner","email":"rosrehi@mafor.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b598eb3ac1b71eb5b163bc89ed14d252.png","birthday":null,"first_seen":"2016-12-11T15:53:08.235Z","last_seen":"2017-01-02T04:13:18.632Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":461,"first_name":"Ronald","last_name":"Bell","email":"cagi@mustolig.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d25996853511e40f10c0be0aa2134781.png","birthday":null,"first_seen":"2013-09-23T08:29:57.543Z","last_seen":"2016-05-20T07:42:44.971Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":462,"first_name":"Sadie","last_name":"Maldonado","email":"zihfa@vuvfadten.edu","address":"1574 Fiun Park","zipcode":"80753","city":"Lujeret","avatar":"https://robohash.org/79f8751e44b0d8208089fcaa3669b94a.png","birthday":"1990-09-29T04:20:35.009Z","first_seen":"2012-02-26T22:33:47.570Z","last_seen":"2015-03-08T19:34:16.753Z","has_ordered":true,"latest_purchase":"2014-12-12T21:54:41.682Z","has_newsletter":true,"groups":["reviewer"],"nb_commands":3,"total_spent":714.5699999999999},{"id":463,"first_name":"Carrie","last_name":"Bailey","email":"hiivo@eja.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2542089895b543ad5187e99bf620b302.png","birthday":null,"first_seen":"2014-09-19T20:16:43.395Z","last_seen":"2016-07-18T05:14:42.881Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":464,"first_name":"Gussie","last_name":"Newton","email":"sub@copoc.gov","address":"1282 Pagam Pike","zipcode":"98749","city":"Kowedet","avatar":"https://robohash.org/43ca2d0e1f23cf104734dafb875a6ac2.png","birthday":"1971-02-14T08:55:29.091Z","first_seen":"2013-03-27T21:05:58.666Z","last_seen":"2016-05-29T08:13:03.287Z","has_ordered":true,"latest_purchase":"2015-10-13T00:46:10.009Z","has_newsletter":true,"groups":[],"nb_commands":2,"total_spent":120.19},{"id":465,"first_name":"Winifred","last_name":"Boone","email":"tigpumin@rof.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6be651b9dad0b5d3cabd4e291656d1c2.png","birthday":null,"first_seen":"2016-01-20T15:41:06.911Z","last_seen":"2016-12-28T10:21:30.150Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":466,"first_name":"Marie","last_name":"Buchanan","email":"wikujo@eku.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/528770757a61d920e55dd59eba4ae8d4.png","birthday":null,"first_seen":"2014-06-30T16:38:20.275Z","last_seen":"2016-12-19T05:53:52.674Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":467,"first_name":"Benjamin","last_name":"Matthews","email":"ersakore@zizzad.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/bc8a1a5e03771b86a6d6a6a4550a5172.png","birthday":null,"first_seen":"2014-03-27T20:32:29.091Z","last_seen":"2016-05-05T14:56:17.646Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":468,"first_name":"Cora","last_name":"Francis","email":"fodretce@jipul.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/dfd0b4abc1f4dbd5c88eb6634d3e49f2.png","birthday":null,"first_seen":"2015-09-10T20:06:51.872Z","last_seen":"2016-03-19T19:40:51.051Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":469,"first_name":"Chad","last_name":"Fleming","email":"gic@itpava.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1a2209bb86f5f51861b0f06da5ba65b4.png","birthday":null,"first_seen":"2015-06-17T17:20:53.819Z","last_seen":"2016-12-26T20:35:45.248Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":470,"first_name":"Jessie","last_name":"Brown","email":"kakip@iwotoc.net","address":"371 Junon Lane","zipcode":"45661","city":"Totzakil","avatar":"https://robohash.org/5f4a7da62dd03cbdeb85b15b5b0cd915.png","birthday":"1992-08-03T05:48:59.912Z","first_seen":"2016-12-28T16:25:14.376Z","last_seen":"2017-01-02T18:59:28.106Z","has_ordered":true,"latest_purchase":"2017-01-02T06:04:23.301Z","has_newsletter":false,"groups":[],"nb_commands":3,"total_spent":255.03000000000003},{"id":471,"first_name":"Tommy","last_name":"Richards","email":"tem@racrihzen.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c8fd149d68b5f89edf79a4051f194ecc.png","birthday":null,"first_seen":"2016-08-20T05:41:53.523Z","last_seen":"2016-10-11T04:52:07.352Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":472,"first_name":"Matilda","last_name":"Armstrong","email":"cucku@cej.gov","address":"378 Busi Grove","zipcode":"12844","city":"Kitonfa","avatar":"https://robohash.org/fa02e55b5c4f9ed2bcd94f35a473237e.png","birthday":"1995-01-09T07:50:24.597Z","first_seen":"2012-06-20T04:02:18.815Z","last_seen":"2015-10-01T18:12:08.427Z","has_ordered":true,"latest_purchase":"2015-09-11T18:58:19.500Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":136.51},{"id":473,"first_name":"Callie","last_name":"Garrett","email":"evaneucu@jep.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/cb9e43e7000e29abaf12dc4b03a15eb8.png","birthday":null,"first_seen":"2014-10-09T05:58:48.756Z","last_seen":"2016-10-23T03:15:46.946Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":474,"first_name":"Dustin","last_name":"Cunningham","email":"uh@butazebib.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6be111ce6f068f2e0b2ccd81b851a9e9.png","birthday":null,"first_seen":"2014-02-06T00:41:49.967Z","last_seen":"2016-09-02T12:59:42.899Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":475,"first_name":"Jeffrey","last_name":"Kelly","email":"za@zibu.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/dd62b5c441ac7a6e8f7f76ea9b43037b.png","birthday":null,"first_seen":"2014-09-11T21:58:24.815Z","last_seen":"2016-12-29T03:37:31.175Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":476,"first_name":"Bertie","last_name":"Alexander","email":"ac@kicroni.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/492975f20ef13ea11e255dfba2f7607d.png","birthday":null,"first_seen":"2016-02-26T03:26:38.551Z","last_seen":"2016-12-06T17:13:00.481Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":477,"first_name":"Lena","last_name":"Campbell","email":"wav@gusa.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f233025d0af8385b0e6cbfbeca7d48d0.png","birthday":null,"first_seen":"2016-09-06T18:35:10.733Z","last_seen":"2017-01-05T01:54:31.289Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":478,"first_name":"Oscar","last_name":"Estrada","email":"zutih@omtuh.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2b04763e951e23c1788b938c03ce2104.png","birthday":null,"first_seen":"2013-01-13T00:07:36.329Z","last_seen":"2015-08-17T02:54:19.876Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":479,"first_name":"Jerome","last_name":"Fitzgerald","email":"depo@orfa.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f1f8bd8b51c9291da747f7ad5fd7e359.png","birthday":null,"first_seen":"2014-08-20T08:12:06.106Z","last_seen":"2015-05-21T19:11:20.724Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":480,"first_name":"Rose","last_name":"Parks","email":"ufonow@ogili.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/580051368e27a15774941e5dbfd5f4fd.png","birthday":null,"first_seen":"2016-07-07T02:42:15.475Z","last_seen":"2016-12-20T20:51:51.827Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":481,"first_name":"Melvin","last_name":"Parsons","email":"johan@cenu.io","address":"384 Haiwo Highway","zipcode":"98139","city":"Sehbener","avatar":"https://robohash.org/b3d61c7f2f1f0c9e1a11f5b62b803291.png","birthday":"1988-12-21T11:59:30.700Z","first_seen":"2016-01-03T20:52:09.231Z","last_seen":"2016-11-04T07:51:33.504Z","has_ordered":true,"latest_purchase":"2016-10-06T22:10:46.933Z","has_newsletter":false,"groups":["collector","reviewer"],"nb_commands":3,"total_spent":1435.17},{"id":482,"first_name":"Eliza","last_name":"Abbott","email":"usekuz@zedijis.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2e6676a19d1156beabf80ac5c2c4ce5d.png","birthday":null,"first_seen":"2014-09-24T11:29:51.989Z","last_seen":"2015-11-29T20:26:33.192Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":483,"first_name":"Etta","last_name":"Barrett","email":"kofi@katmi.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c5e2dcddbec4028243bc234c7e1c109f.png","birthday":null,"first_seen":"2016-10-04T07:30:40.686Z","last_seen":"2016-12-01T02:42:44.307Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":484,"first_name":"Phoebe","last_name":"Reynolds","email":"porci@set.io","address":"1992 Ilriv Manor","zipcode":"22583","city":"Ramepta","avatar":"https://robohash.org/bdf58516f43473bdaffdb9b0b0471bf1.png","birthday":"1978-01-02T08:22:16.789Z","first_seen":"2016-04-01T04:21:09.790Z","last_seen":"2016-11-26T21:43:35.822Z","has_ordered":true,"latest_purchase":"2016-08-15T07:04:17.766Z","has_newsletter":true,"groups":["ordered_once"],"nb_commands":1,"total_spent":324.58},{"id":485,"first_name":"Maria","last_name":"Murphy","email":"ubirane@ovej.io","address":"1193 Ugan Key","zipcode":"64525","city":"Tosowez","avatar":"https://robohash.org/a7cfedd3014f29e8185dc92362cbfd96.png","birthday":"1953-10-27T05:39:17.595Z","first_seen":"2016-12-17T02:26:09.824Z","last_seen":"2017-01-02T11:01:48.672Z","has_ordered":true,"latest_purchase":"2016-12-31T19:33:55.136Z","has_newsletter":true,"groups":["collector","compulsive"],"nb_commands":6,"total_spent":2101.65},{"id":486,"first_name":"Catherine","last_name":"Ballard","email":"racuna@tosukde.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/170d42a90144472f2e43cfe9f1a9de40.png","birthday":null,"first_seen":"2014-05-03T13:42:31.754Z","last_seen":"2016-10-01T05:14:48.316Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":487,"first_name":"Willie","last_name":"Steele","email":"iruj@huwiic.org","address":"15 Elkog Manor","zipcode":"00403","city":"Hehatad","avatar":"https://robohash.org/76f1d1fd45720ad2e5207c253420545e.png","birthday":"1972-03-12T11:34:41.610Z","first_seen":"2016-08-25T22:06:26.444Z","last_seen":"2016-12-07T11:00:56.170Z","has_ordered":true,"latest_purchase":"2016-11-20T08:23:43.217Z","has_newsletter":false,"groups":["regular","reviewer"],"nb_commands":2,"total_spent":136.76},{"id":488,"first_name":"Patrick","last_name":"Harrison","email":"ofiho@kol.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e266bd1844fbf0ccf04cb180ecc62cd1.png","birthday":null,"first_seen":"2016-12-25T06:18:24.167Z","last_seen":"2016-12-29T20:57:10.798Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":489,"first_name":"Christina","last_name":"Ortega","email":"wefzove@egi.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3f83f2688f044878fbe16a146ce52e03.png","birthday":null,"first_seen":"2016-02-26T10:22:24.257Z","last_seen":"2016-09-05T13:33:57.797Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":490,"first_name":"Frank","last_name":"Olson","email":"kukfeg@ijahuema.net","address":"783 Jufir Loop","zipcode":"10838","city":"Wiwhemor","avatar":"https://robohash.org/f2ef55f527cb541219eed35235f1751f.png","birthday":"1984-03-22T04:53:12.133Z","first_seen":"2015-11-11T12:04:55.403Z","last_seen":"2016-08-09T14:25:25.596Z","has_ordered":true,"latest_purchase":"2016-06-21T20:43:42.866Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":908.76},{"id":491,"first_name":"Marguerite","last_name":"Robertson","email":"nubukawo@zitik.edu","address":"187 Raoh Extension","zipcode":"80744","city":"Awinupu","avatar":"https://robohash.org/9cf7b1615d2deaf2b770f23cb62bb781.png","birthday":"1953-09-25T08:01:47.987Z","first_seen":"2013-12-26T13:42:04.658Z","last_seen":"2016-09-23T01:28:11.446Z","has_ordered":true,"latest_purchase":"2016-08-19T22:25:40.065Z","has_newsletter":false,"groups":[],"nb_commands":4,"total_spent":316},{"id":492,"first_name":"Calvin","last_name":"Martinez","email":"omdegi@defujab.net","address":"1559 Uzid Road","zipcode":"91877","city":"Kebneud","avatar":"https://robohash.org/79611bad4db7daf7b0c20331840e9632.png","birthday":"1972-12-26T02:10:59.029Z","first_seen":"2013-02-27T12:53:00.080Z","last_seen":"2016-07-11T09:11:41.636Z","has_ordered":true,"latest_purchase":"2016-02-11T12:42:02.413Z","has_newsletter":true,"groups":["collector","reviewer"],"nb_commands":4,"total_spent":731.45},{"id":493,"first_name":"Ivan","last_name":"Moore","email":"wa@eka.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f6a71045f8a9f3abb3dd66accc219e2a.png","birthday":null,"first_seen":"2015-10-14T01:09:35.332Z","last_seen":"2016-11-26T11:15:22.216Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":494,"first_name":"Myrtle","last_name":"Jensen","email":"vaure@ihu.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1c72b55208307ae1f925ce97821e089c.png","birthday":null,"first_seen":"2014-03-25T03:40:06.997Z","last_seen":"2016-08-19T06:42:44.898Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":495,"first_name":"Rose","last_name":"Porter","email":"efabat@upjiuwe.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a315fe83c3b4c54faf92b9d4f840431c.png","birthday":null,"first_seen":"2013-04-06T11:36:20.523Z","last_seen":"2014-12-21T20:12:57.365Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":496,"first_name":"Addie","last_name":"Fleming","email":"ri@venhulcuw.com","address":"1823 Sagmu Drive","zipcode":"77631","city":"Lapvuora","avatar":"https://robohash.org/13a685b573aa93e10cfaec91f19fd57b.png","birthday":"1979-01-02T10:03:58.369Z","first_seen":"2014-11-08T11:02:37.950Z","last_seen":"2016-11-18T23:23:54.343Z","has_ordered":true,"latest_purchase":"2016-09-17T15:22:20.493Z","has_newsletter":true,"groups":[],"nb_commands":3,"total_spent":365.79},{"id":497,"first_name":"Gilbert","last_name":"Thornton","email":"eti@to.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1c9e7625658bee5eb41da885f3c706cd.png","birthday":null,"first_seen":"2016-11-20T15:03:16.505Z","last_seen":"2016-12-13T01:39:00.900Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":498,"first_name":"Bobby","last_name":"Price","email":"jira@fi.org","address":"179 Valze Avenue","zipcode":"65007","city":"Nuraeci","avatar":"https://robohash.org/e8c96a4e68e50567df17f68f15fd344e.png","birthday":"1960-12-05T08:20:33.553Z","first_seen":"2012-08-31T08:22:56.873Z","last_seen":"2014-10-30T01:15:12.518Z","has_ordered":true,"latest_purchase":"2013-01-11T12:47:18.123Z","has_newsletter":false,"groups":["ordered_once","regular"],"nb_commands":1,"total_spent":180.92},{"id":499,"first_name":"Victoria","last_name":"Hughes","email":"kijfib@boz.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b9524468631a6c164c083b74218c238e.png","birthday":null,"first_seen":"2016-07-14T16:36:01.641Z","last_seen":"2016-12-21T18:36:42.816Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":500,"first_name":"Mabelle","last_name":"Yates","email":"huverak@hamiw.com","address":"1540 Wuba Lane","zipcode":"10529","city":"Jazaften","avatar":"https://robohash.org/0442ccc158a96a6f2279b428294af9d9.png","birthday":"1989-09-25T05:47:14.700Z","first_seen":"2016-01-03T11:35:33.973Z","last_seen":"2016-12-13T03:58:42.604Z","has_ordered":true,"latest_purchase":"2016-11-30T21:51:57.757Z","has_newsletter":true,"groups":["returns","reviewer"],"nb_commands":4,"total_spent":1063.75},{"id":501,"first_name":"Patrick","last_name":"Underwood","email":"zouwra@wenam.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/020f6175f8f39030b9c0ec4e9e242a9d.png","birthday":null,"first_seen":"2014-09-13T11:10:55.316Z","last_seen":"2015-10-18T23:44:50.208Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":502,"first_name":"Christina","last_name":"Walton","email":"haj@keijiar.edu","address":"556 Tena Pass","zipcode":"49930","city":"Wobveze","avatar":"https://robohash.org/3a5790d5e684442379c00e699545b5b4.png","birthday":"1987-11-16T10:21:08.311Z","first_seen":"2016-09-02T06:29:26.506Z","last_seen":"2016-12-22T11:59:16.726Z","has_ordered":true,"latest_purchase":"2016-12-12T12:13:27.839Z","has_newsletter":false,"groups":["returns"],"nb_commands":4,"total_spent":657.8600000000001},{"id":503,"first_name":"Kyle","last_name":"Peters","email":"cumomhaz@vuleba.edu","address":"824 Nibso Trail","zipcode":"61911","city":"Vibofifi","avatar":"https://robohash.org/ca9f7de2d70152f31d451ddb9a41854d.png","birthday":"1972-05-13T11:40:04.552Z","first_seen":"2012-11-21T00:59:56.127Z","last_seen":"2016-01-29T22:04:11.057Z","has_ordered":true,"latest_purchase":"2015-11-27T04:37:42.573Z","has_newsletter":false,"groups":["collector"],"nb_commands":3,"total_spent":1260.98},{"id":504,"first_name":"Viola","last_name":"Medina","email":"vizcuvho@siw.com","address":"1397 Tosbi Street","zipcode":"17602","city":"Woflile","avatar":"https://robohash.org/ed7d777f5054e41ab59b6d43d2c4371f.png","birthday":"1973-12-31T05:52:53.981Z","first_seen":"2015-09-03T06:23:48.658Z","last_seen":"2016-06-03T12:41:41.164Z","has_ordered":true,"latest_purchase":"2016-05-27T10:13:44.206Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":31.92},{"id":505,"first_name":"Pauline","last_name":"Fowler","email":"gean@ud.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/695e36b406e5b8c39f38cc31ab3251d7.png","birthday":null,"first_seen":"2016-01-09T12:06:06.963Z","last_seen":"2016-11-06T23:42:34.192Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":506,"first_name":"Amy","last_name":"Webster","email":"ju@kis.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/146c014259593520e88b2bc7848300f7.png","birthday":null,"first_seen":"2013-05-28T23:53:38.716Z","last_seen":"2016-12-01T20:06:49.525Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":507,"first_name":"Stella","last_name":"Warren","email":"hipci@cooluwej.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c5dd3f7df8f7fb53354c2018026ac36c.png","birthday":null,"first_seen":"2015-08-31T15:56:18.746Z","last_seen":"2015-12-27T08:25:00.225Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":508,"first_name":"Delia","last_name":"Walsh","email":"tos@po.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e537bdcd731eee5fa4c150aa9a671222.png","birthday":null,"first_seen":"2015-11-02T14:56:18.739Z","last_seen":"2016-10-10T07:14:06.608Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":509,"first_name":"Christina","last_name":"James","email":"rolhuhili@muk.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d2563de6cc5314d04ba13c28d0b2e38b.png","birthday":null,"first_seen":"2015-12-30T12:50:50.397Z","last_seen":"2016-09-12T03:35:41.674Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":510,"first_name":"Luis","last_name":"Lopez","email":"berufcuw@sago.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5575b79e1fb1cd460387ee37b8980f70.png","birthday":null,"first_seen":"2014-08-06T08:18:09.426Z","last_seen":"2016-06-18T16:24:58.941Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":511,"first_name":"Max","last_name":"Robertson","email":"uva@du.io","address":"956 Juvpez River","zipcode":"27324","city":"Nopipaz","avatar":"https://robohash.org/19a456487697c9466dc23ebe63f3d651.png","birthday":"1962-07-19T00:27:29.625Z","first_seen":"2016-05-09T19:01:24.624Z","last_seen":"2016-12-04T04:29:50.123Z","has_ordered":true,"latest_purchase":"2016-11-08T22:03:37.148Z","has_newsletter":false,"groups":[],"nb_commands":3,"total_spent":479.83000000000004},{"id":512,"first_name":"Myrtie","last_name":"Delgado","email":"ali@dubgac.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f59cb70fe93614cf106732bba89ace2f.png","birthday":null,"first_seen":"2016-08-22T21:38:22.071Z","last_seen":"2016-10-05T08:54:02.851Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":513,"first_name":"Erik","last_name":"Pope","email":"efruhef@todtapic.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fc038ee2acfee59ec143b60c26bdda36.png","birthday":null,"first_seen":"2014-10-09T13:28:48.034Z","last_seen":"2016-11-02T16:56:51.313Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":514,"first_name":"Lula","last_name":"Hopkins","email":"hof@niniru.net","address":"1258 Sajso Key","zipcode":"13343","city":"Vifijari","avatar":"https://robohash.org/cfea3c8c6879a45c26c2b3be4f1c6acc.png","birthday":"1989-09-23T00:10:01.268Z","first_seen":"2014-03-14T14:49:10.647Z","last_seen":"2016-10-12T12:26:35.375Z","has_ordered":true,"latest_purchase":"2016-09-20T01:50:37.808Z","has_newsletter":true,"groups":["reviewer"],"nb_commands":4,"total_spent":767.23},{"id":515,"first_name":"Verna","last_name":"Rose","email":"molo@kejipuc.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a0f477e32b491087fb08eb64f276cc03.png","birthday":null,"first_seen":"2016-02-12T21:07:33.737Z","last_seen":"2016-11-06T05:05:44.934Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":516,"first_name":"Winnie","last_name":"Turner","email":"ta@taago.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a3564d01071c5a9d52745e9b9d1b14a7.png","birthday":null,"first_seen":"2014-06-27T01:49:05.889Z","last_seen":"2016-11-04T03:51:47.158Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":517,"first_name":"Louis","last_name":"Kelley","email":"ufe@cufgeh.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5b3f9b98c593c593e09125ab34d55e6a.png","birthday":null,"first_seen":"2014-12-06T08:25:33.454Z","last_seen":"2016-04-30T23:47:30.281Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":518,"first_name":"Estelle","last_name":"Steele","email":"gifjavfev@zem.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1c922e9045e2afc952b18240c4cb6cd5.png","birthday":null,"first_seen":"2016-08-31T14:22:19.563Z","last_seen":"2016-12-23T15:36:42.497Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":519,"first_name":"Callie","last_name":"Howell","email":"udujo@ihrari.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2b6e36e7016d13299ec0490459efc23c.png","birthday":null,"first_seen":"2016-12-06T14:51:11.297Z","last_seen":"2016-12-16T07:52:09.731Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":520,"first_name":"Ernest","last_name":"Griffin","email":"gidzo@lo.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/dabd2dce17b00ff0c35b9a5b0e4278b9.png","birthday":null,"first_seen":"2015-08-11T11:46:54.118Z","last_seen":"2016-11-02T15:37:48.677Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":521,"first_name":"Frederick","last_name":"Zimmerman","email":"hoh@re.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/df8b6be04628f858dd1dfb2ff5b96c12.png","birthday":null,"first_seen":"2016-05-10T10:38:47.527Z","last_seen":"2016-12-04T05:57:06.692Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":522,"first_name":"Lena","last_name":"Robbins","email":"kubre@vucazop.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d597ddcd0d31b13e234442c781641b7b.png","birthday":null,"first_seen":"2014-12-14T15:34:48.106Z","last_seen":"2016-04-27T21:24:13.630Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":523,"first_name":"Leon","last_name":"Moss","email":"wivtavsiw@muwawor.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/666655e8fdf9ce4e49a762dba425ab66.png","birthday":null,"first_seen":"2014-01-25T03:51:48.113Z","last_seen":"2016-07-08T07:47:00.930Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":524,"first_name":"Rodney","last_name":"Daniel","email":"aduipomi@ok.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/99bb655733759a3a0b765ed241f7306e.png","birthday":null,"first_seen":"2014-08-13T01:30:57.265Z","last_seen":"2016-08-10T01:12:23.434Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":525,"first_name":"David","last_name":"Massey","email":"egcuwtu@fel.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/bb7efeb3f6c1957e88e7f13167541eab.png","birthday":null,"first_seen":"2016-09-23T05:26:18.350Z","last_seen":"2016-12-06T14:50:51.771Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":526,"first_name":"Millie","last_name":"Crawford","email":"fetucebo@nectuzjuj.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8b6463c4e338071b03366aa045343299.png","birthday":null,"first_seen":"2016-03-13T22:22:59.613Z","last_seen":"2016-06-12T10:04:17.713Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":527,"first_name":"Bettie","last_name":"Dawson","email":"tavakkat@go.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e582c9c0cee8797aa85eb881209bc44a.png","birthday":null,"first_seen":"2015-01-19T00:32:52.209Z","last_seen":"2016-09-08T07:18:49.670Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":528,"first_name":"Sophie","last_name":"Bishop","email":"ic@wejis.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/83dda445fbc2624383996ce21ced1cd5.png","birthday":null,"first_seen":"2013-07-16T05:31:19.506Z","last_seen":"2015-08-28T07:50:55.924Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":529,"first_name":"Bertha","last_name":"Simpson","email":"zoekiri@kuc.co.uk","address":"1901 Owfo River","zipcode":"79640","city":"Ucapokdit","avatar":"https://robohash.org/60b13479ca5c6cbcc0a539dd5a6feef8.png","birthday":"1974-09-15T01:18:03.295Z","first_seen":"2015-03-21T09:21:40.977Z","last_seen":"2015-09-29T11:14:38.305Z","has_ordered":true,"latest_purchase":"2015-08-11T14:22:26.284Z","has_newsletter":true,"groups":["returns"],"nb_commands":2,"total_spent":150.85},{"id":530,"first_name":"Wayne","last_name":"Carson","email":"vi@uca.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/01cf0eb0b6a90bb82ce532bc62412947.png","birthday":null,"first_seen":"2014-09-10T07:14:23.710Z","last_seen":"2016-09-25T10:13:07.661Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":531,"first_name":"Ricardo","last_name":"Johnston","email":"ji@fipce.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b886beab8af9665619aeda117d259b2d.png","birthday":null,"first_seen":"2014-09-27T07:11:11.047Z","last_seen":"2016-04-18T11:11:12.679Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":532,"first_name":"Jacob","last_name":"Wise","email":"vacrepsi@zotuti.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/57450580512859a393e90d1dcbbf3db5.png","birthday":null,"first_seen":"2014-07-12T07:23:53.936Z","last_seen":"2017-01-02T01:35:37.520Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":533,"first_name":"Evan","last_name":"Chambers","email":"zawob@wi.org","address":"752 Here Center","zipcode":"47179","city":"Tahubedu","avatar":"https://robohash.org/659ae344c4ad8c18a229bd453f15145f.png","birthday":"1972-03-06T11:06:19.168Z","first_seen":"2016-09-21T04:55:15.389Z","last_seen":"2016-11-14T15:51:29.591Z","has_ordered":true,"latest_purchase":"2016-11-11T14:48:23.498Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":627.64},{"id":534,"first_name":"Nathaniel","last_name":"Hale","email":"fezmiba@kos.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6d4cfbbff3e57503c094d4b5eef4a5d8.png","birthday":null,"first_seen":"2015-04-06T18:44:26.195Z","last_seen":"2016-12-06T03:55:18.269Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":535,"first_name":"Lettie","last_name":"Moody","email":"cov@sub.gov","address":"764 Ofri Way","zipcode":"74320","city":"Putpatan","avatar":"https://robohash.org/42b2263f8348013f33ecfad878141e0f.png","birthday":"1980-09-29T08:50:40.410Z","first_seen":"2013-09-26T08:26:02.016Z","last_seen":"2015-09-30T06:55:02.247Z","has_ordered":true,"latest_purchase":"2014-08-23T04:24:32.782Z","has_newsletter":false,"groups":["ordered_once","regular"],"nb_commands":1,"total_spent":102.87},{"id":536,"first_name":"Genevieve","last_name":"Harrington","email":"fu@jusefa.edu","address":"435 Kuhu Place","zipcode":"58492","city":"Gibiba","avatar":"https://robohash.org/07a7a4eb12988d2bc22e0c60bbc4cc7a.png","birthday":"1970-02-11T02:17:58.985Z","first_seen":"2016-05-20T03:19:47.181Z","last_seen":"2016-12-21T13:47:13.905Z","has_ordered":true,"latest_purchase":null,"has_newsletter":false,"groups":[],"nb_commands":0,"total_spent":0},{"id":537,"first_name":"Lucinda","last_name":"Campbell","email":"hog@iwoajlid.co.uk","address":"1531 Nicnuh Boulevard","zipcode":"73603","city":"Omuadur","avatar":"https://robohash.org/6f29391e43b8335fc166324dbe2fcd27.png","birthday":"1959-01-02T00:45:40.060Z","first_seen":"2016-03-12T05:55:52.081Z","last_seen":"2016-07-04T21:29:49.667Z","has_ordered":true,"latest_purchase":"2016-06-11T20:02:43.409Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":2,"total_spent":554.66},{"id":538,"first_name":"Rena","last_name":"McLaughlin","email":"welva@re.net","address":"1496 Timom Heights","zipcode":"26887","city":"Rotahsur","avatar":"https://robohash.org/bc33e655bd972e4d5f5586e2ff152949.png","birthday":"1993-06-05T06:37:52.687Z","first_seen":"2016-06-03T07:37:01.083Z","last_seen":"2016-09-26T19:02:46.285Z","has_ordered":true,"latest_purchase":"2016-09-20T19:00:36.242Z","has_newsletter":true,"groups":["returns","reviewer"],"nb_commands":3,"total_spent":423.17},{"id":539,"first_name":"Jacob","last_name":"Long","email":"zehfi@cerufkun.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c428752f5b0e3df43e93e10f26bf599c.png","birthday":null,"first_seen":"2015-05-14T22:11:50.680Z","last_seen":"2016-12-16T05:01:06.329Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":540,"first_name":"Earl","last_name":"Lee","email":"an@messig.edu","address":"1952 Nijgi Parkway","zipcode":"45702","city":"Pimokem","avatar":"https://robohash.org/2bdf852342fe3606a962e36591b70a78.png","birthday":"1973-12-20T01:27:25.469Z","first_seen":"2014-08-09T09:29:09.383Z","last_seen":"2016-06-29T04:34:30.756Z","has_ordered":true,"latest_purchase":"2016-04-20T05:21:48.628Z","has_newsletter":false,"groups":["returns","reviewer"],"nb_commands":3,"total_spent":248.82999999999998},{"id":541,"first_name":"Erik","last_name":"Curtis","email":"gol@laj.io","address":"271 Otokaj Way","zipcode":"46455","city":"Rorugov","avatar":"https://robohash.org/7334bfe843757c29901870f976413e74.png","birthday":"1980-08-30T00:52:54.625Z","first_seen":"2014-09-01T08:34:48.065Z","last_seen":"2016-12-29T22:06:11.616Z","has_ordered":true,"latest_purchase":"2016-12-20T03:35:28.106Z","has_newsletter":true,"groups":["regular","reviewer"],"nb_commands":4,"total_spent":649.04},{"id":542,"first_name":"Keith","last_name":"Guerrero","email":"jesuk@uhagu.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/892315ecc9437368add4e4ec287064dd.png","birthday":null,"first_seen":"2016-07-26T13:34:15.379Z","last_seen":"2016-12-03T12:21:25.242Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":543,"first_name":"Patrick","last_name":"Powell","email":"mijabdo@rapokiwo.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a12d0d6b1a9610138e677401d33566ac.png","birthday":null,"first_seen":"2014-04-23T16:11:19.526Z","last_seen":"2015-07-11T19:18:41.048Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":544,"first_name":"Lucinda","last_name":"Patton","email":"afa@adfothus.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8bc2c1d3ff8cdd946f7127f7ee4cfa1d.png","birthday":null,"first_seen":"2013-10-06T08:49:05.537Z","last_seen":"2016-03-21T22:40:25.914Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":545,"first_name":"Benjamin","last_name":"Lindsey","email":"abeje@lujwad.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/126beb04b01eb6e8bdefc50ca7f5f3ec.png","birthday":null,"first_seen":"2016-04-26T15:11:14.924Z","last_seen":"2016-12-28T00:32:16.077Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":546,"first_name":"Nannie","last_name":"Curtis","email":"losdolis@odoadic.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7b5ca6c2e47b57c8f5ba81eef2455453.png","birthday":null,"first_seen":"2014-11-13T15:58:12.077Z","last_seen":"2016-12-01T22:42:08.343Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":547,"first_name":"Glenn","last_name":"Garner","email":"wukencas@kojzi.edu","address":"1653 Zetzig Mill","zipcode":"78064","city":"Butakol","avatar":"https://robohash.org/75a0166446ab99aceecf84668868f558.png","birthday":"1958-05-31T05:20:15.946Z","first_seen":"2014-03-22T11:18:02.588Z","last_seen":"2015-07-01T15:21:07.520Z","has_ordered":true,"latest_purchase":"2015-06-28T15:20:46.754Z","has_newsletter":false,"groups":["collector","regular","returns"],"nb_commands":6,"total_spent":1089.53},{"id":548,"first_name":"Hallie","last_name":"Stevenson","email":"cemev@bidza.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/884d7143c6d84466c8868e3bc471a778.png","birthday":null,"first_seen":"2015-09-13T07:02:08.999Z","last_seen":"2017-01-02T14:47:41.200Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":549,"first_name":"Ivan","last_name":"Ryan","email":"ab@jirmi.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/aff1204637eb496ec8e102fb5c31a9f4.png","birthday":null,"first_seen":"2016-04-21T13:31:38.736Z","last_seen":"2016-12-29T07:14:18.258Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":550,"first_name":"Jesse","last_name":"Norris","email":"zokar@divipbut.net","address":"447 Amowir Path","zipcode":"00613","city":"Riljordi","avatar":"https://robohash.org/6f936690551899f71ce5041142928ead.png","birthday":"1972-04-18T06:04:38.493Z","first_seen":"2014-08-09T04:03:57.510Z","last_seen":"2016-02-08T01:40:18.920Z","has_ordered":true,"latest_purchase":"2015-12-02T00:06:45.713Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":2,"total_spent":370.59},{"id":551,"first_name":"Maurice","last_name":"Woods","email":"asube@ij.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b55f30e750e2b7f66128716e02989964.png","birthday":null,"first_seen":"2013-03-28T13:37:32.931Z","last_seen":"2016-05-04T11:38:57.979Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":552,"first_name":"Dorothy","last_name":"Jacobs","email":"dalrem@oli.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fe969a9dede7c65681f5932ab9d3c4e4.png","birthday":null,"first_seen":"2012-03-29T19:12:21.023Z","last_seen":"2014-02-04T13:44:19.800Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":553,"first_name":"Jerome","last_name":"Lowe","email":"najehli@jonahci.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7bdcdccb60329bcd10ba99e44239bed9.png","birthday":null,"first_seen":"2015-09-18T17:46:55.267Z","last_seen":"2016-04-03T02:45:31.765Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":554,"first_name":"Jerry","last_name":"Douglas","email":"kuwetioho@novwaer.io","address":"441 Lilwil Highway","zipcode":"83822","city":"Fogbupat","avatar":"https://robohash.org/c6ea2fce1c7073d10c0ba94f00d5b0b2.png","birthday":"1956-04-13T01:04:58.551Z","first_seen":"2016-11-25T13:05:10.377Z","last_seen":"2017-01-04T22:18:24.844Z","has_ordered":true,"latest_purchase":"2017-01-03T14:23:41.115Z","has_newsletter":true,"groups":["collector","returns","reviewer"],"nb_commands":5,"total_spent":932.71},{"id":555,"first_name":"Stanley","last_name":"Nash","email":"gof@miko.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b2a906c242c89cb9c1ccaf07ef4a9db6.png","birthday":null,"first_seen":"2016-06-06T06:39:58.710Z","last_seen":"2016-09-24T04:46:41.473Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":556,"first_name":"Michael","last_name":"Becker","email":"wa@uvojo.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d82a0338ac0944c326414975c5ddf739.png","birthday":null,"first_seen":"2013-05-29T21:51:26.749Z","last_seen":"2015-12-25T08:37:59.974Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":557,"first_name":"Marie","last_name":"Owens","email":"gefus@retwizeti.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/dcc553808fd2a856c66355acc4e7054d.png","birthday":null,"first_seen":"2016-09-07T15:12:36.670Z","last_seen":"2016-10-25T22:53:21.700Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":558,"first_name":"Lucas","last_name":"Price","email":"oke@kih.co.uk","address":"1817 Miuwe Terrace","zipcode":"01246","city":"Begube","avatar":"https://robohash.org/9a97a50533e7912b704c8f41e3ef7310.png","birthday":"1973-02-04T05:03:32.077Z","first_seen":"2013-12-08T09:21:59.485Z","last_seen":"2016-09-05T12:53:38.668Z","has_ordered":true,"latest_purchase":"2016-08-20T23:42:48.289Z","has_newsletter":false,"groups":["regular","reviewer"],"nb_commands":4,"total_spent":419.59000000000003},{"id":559,"first_name":"Lora","last_name":"Morrison","email":"wecpana@ano.co.uk","address":"1845 Ruar Drive","zipcode":"56279","city":"Rabgerag","avatar":"https://robohash.org/272e6c6c68135370f91a43484c8c8239.png","birthday":"1969-02-26T04:21:40.336Z","first_seen":"2016-12-23T00:05:18.384Z","last_seen":"2017-01-03T01:56:21.965Z","has_ordered":true,"latest_purchase":"2016-12-31T14:52:25.459Z","has_newsletter":false,"groups":["regular","reviewer"],"nb_commands":2,"total_spent":83.28},{"id":560,"first_name":"Antonio","last_name":"Harris","email":"igeibmet@odu.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/99bc50170c4fd0067364f1ea07e206de.png","birthday":null,"first_seen":"2016-06-13T13:44:01.301Z","last_seen":"2016-10-21T22:01:26.299Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":561,"first_name":"Loretta","last_name":"Bryant","email":"lasirtan@tut.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fb2d47a90da893782f9feb793a518f4a.png","birthday":null,"first_seen":"2015-08-30T04:05:50.554Z","last_seen":"2016-05-22T14:39:14.211Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":562,"first_name":"Lucy","last_name":"Matthews","email":"pivosejuz@ji.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c3660352f6b0e8e249697bf23faa0181.png","birthday":null,"first_seen":"2016-03-13T07:29:03.605Z","last_seen":"2016-09-04T07:39:02.538Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":563,"first_name":"Noah","last_name":"Vega","email":"deuk@juhahso.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a24f4ed3c024badbf8620a27cf0fd690.png","birthday":null,"first_seen":"2015-11-06T06:25:44.038Z","last_seen":"2016-04-05T08:40:54.334Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":564,"first_name":"Melvin","last_name":"Hammond","email":"mopujozu@tajun.edu","address":"1889 Wagefu Grove","zipcode":"78193","city":"Uzjiru","avatar":"https://robohash.org/01f02be8d538807fa8aff0f690692957.png","birthday":"1974-05-28T11:02:35.951Z","first_seen":"2016-05-27T21:10:34.069Z","last_seen":"2016-11-18T10:16:20.273Z","has_ordered":true,"latest_purchase":"2016-10-27T17:05:47.265Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":567.26},{"id":565,"first_name":"Myra","last_name":"Ortiz","email":"linenput@mec.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/171d381767834a85ae2fbf6acc659df5.png","birthday":null,"first_seen":"2013-11-03T00:07:26.766Z","last_seen":"2016-12-02T09:52:31.928Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":566,"first_name":"Jorge","last_name":"Black","email":"zerahad@zocbu.edu","address":"1600 Arges Center","zipcode":"63193","city":"Fijuja","avatar":"https://robohash.org/61c07fde78047abe33b5490661e4871c.png","birthday":"1957-04-03T01:27:19.640Z","first_seen":"2015-04-20T23:59:37.951Z","last_seen":"2016-10-11T10:50:10.974Z","has_ordered":true,"latest_purchase":"2016-07-07T12:08:32.854Z","has_newsletter":false,"groups":["returns"],"nb_commands":3,"total_spent":979.9099999999999},{"id":567,"first_name":"Christina","last_name":"Matthews","email":"alaro@zo.net","address":"1869 Ibum Pass","zipcode":"24304","city":"Tuzizig","avatar":"https://robohash.org/8f2791ac9799d429c973fde6cc419967.png","birthday":"1978-09-26T02:29:58.503Z","first_seen":"2014-02-18T15:19:41.996Z","last_seen":"2016-09-10T03:44:41.941Z","has_ordered":true,"latest_purchase":"2016-05-21T18:00:42.670Z","has_newsletter":false,"groups":["collector","compulsive","regular","reviewer"],"nb_commands":5,"total_spent":1507.09},{"id":568,"first_name":"Emilie","last_name":"Hoffman","email":"rik@tuatnu.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2ea3193310b0db77d0afb6cf7c47b569.png","birthday":null,"first_seen":"2016-08-07T05:05:49.835Z","last_seen":"2017-01-03T13:16:06.397Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":569,"first_name":"Minerva","last_name":"Bowen","email":"cowbita@damcozreh.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/108875233a218985230636f9575cb31f.png","birthday":null,"first_seen":"2016-10-22T03:05:27.007Z","last_seen":"2016-12-26T17:27:32.683Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":570,"first_name":"Gene","last_name":"Richards","email":"sasi@jivcuwiw.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d027292c2775bf44ce7ac692e4de0f09.png","birthday":null,"first_seen":"2014-04-03T12:56:19.085Z","last_seen":"2016-11-26T17:13:12.333Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":571,"first_name":"Sylvia","last_name":"Guzman","email":"hunvo@taffog.edu","address":"1787 Pucpa Grove","zipcode":"27785","city":"Nahtidge","avatar":"https://robohash.org/c0434732c0b1594b1a20318874cdc655.png","birthday":"1995-06-12T00:45:31.147Z","first_seen":"2014-12-27T13:15:06.911Z","last_seen":"2016-05-28T05:44:32.988Z","has_ordered":true,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":572,"first_name":"Jeremiah","last_name":"Briggs","email":"uhsu@ti.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/03a5f650d429c4415a712224ae779192.png","birthday":null,"first_seen":"2013-02-09T23:40:49.168Z","last_seen":"2015-04-04T02:49:20.905Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":573,"first_name":"Hettie","last_name":"Moody","email":"ecje@muhol.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/328dbd4b910a3658956a746532f74cad.png","birthday":null,"first_seen":"2015-05-04T08:46:59.110Z","last_seen":"2016-09-21T00:31:49.428Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":574,"first_name":"Marian","last_name":"Cross","email":"re@voz.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/cf91f4e9035c2f945da6c2560d736f5d.png","birthday":null,"first_seen":"2014-02-15T09:31:19.332Z","last_seen":"2016-07-20T22:45:49.842Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":575,"first_name":"Chad","last_name":"Pena","email":"lazmizuhi@jopja.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a3e3bf416a00e3cac65d6ec94d558847.png","birthday":null,"first_seen":"2015-09-23T23:19:02.500Z","last_seen":"2016-11-03T15:48:33.156Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":576,"first_name":"Isaac","last_name":"Gregory","email":"ru@gir.com","address":"1302 Johkac Key","zipcode":"21305","city":"Bupokuc","avatar":"https://robohash.org/56900af06d97161b92855b56c03e9646.png","birthday":"1974-01-06T00:34:47.719Z","first_seen":"2015-09-22T08:52:04.156Z","last_seen":"2016-12-29T05:19:14.174Z","has_ordered":true,"latest_purchase":"2016-11-24T12:03:31.048Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":2,"total_spent":451.34999999999997},{"id":577,"first_name":"Milton","last_name":"Thornton","email":"cehziv@nodjidhom.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1d67a8ea01e452bb7abdb954715632d6.png","birthday":null,"first_seen":"2016-11-24T23:32:37.258Z","last_seen":"2017-01-02T12:27:58.274Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":578,"first_name":"Antonio","last_name":"Cain","email":"hupieko@vaculma.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fef6be9fcdd4502ab3d397496a6d58e6.png","birthday":null,"first_seen":"2016-01-01T00:41:53.389Z","last_seen":"2016-09-28T22:47:20.022Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":579,"first_name":"Brandon","last_name":"Tucker","email":"heko@terec.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e7368607c5767545f3c192f3441aac52.png","birthday":null,"first_seen":"2013-07-19T07:45:14.038Z","last_seen":"2016-05-24T18:56:07.692Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":580,"first_name":"Richard","last_name":"Walters","email":"rezdu@jini.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e81927f787d58740ae3be1f516513386.png","birthday":null,"first_seen":"2013-12-29T05:39:16.668Z","last_seen":"2015-08-27T00:19:27.088Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":581,"first_name":"Mitchell","last_name":"Gibson","email":"suj@beggel.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/75d47c0301bd93bc1e0ac936dc279ed4.png","birthday":null,"first_seen":"2013-06-04T20:34:27.021Z","last_seen":"2014-05-14T05:26:29.992Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":582,"first_name":"Johanna","last_name":"Rose","email":"nekav@hod.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0e458e172196f58b3cac4345922c8af5.png","birthday":null,"first_seen":"2012-03-30T17:46:11.698Z","last_seen":"2016-01-27T10:40:05.451Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":583,"first_name":"Brandon","last_name":"Perez","email":"don@saj.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/013fad23ffed38be129fc96c123a976c.png","birthday":null,"first_seen":"2016-08-06T14:47:07.842Z","last_seen":"2016-11-21T06:34:23.523Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":584,"first_name":"Gene","last_name":"Griffin","email":"zukmu@ikiwoepo.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4bac6bdf3bba1fd5e9082d63b5e26384.png","birthday":null,"first_seen":"2013-10-27T22:25:19.372Z","last_seen":"2014-06-23T17:28:43.187Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":585,"first_name":"Millie","last_name":"Johnston","email":"pe@bu.io","address":"866 Ocico Avenue","zipcode":"79769","city":"Zocmube","avatar":"https://robohash.org/844cd6118aacee95e7e4aa8b655c12cf.png","birthday":"1991-02-25T03:27:40.308Z","first_seen":"2016-12-18T04:18:13.180Z","last_seen":"2016-12-30T16:51:28.688Z","has_ordered":true,"latest_purchase":"2016-12-24T03:16:43.802Z","has_newsletter":false,"groups":["collector"],"nb_commands":3,"total_spent":1020.78},{"id":586,"first_name":"Aaron","last_name":"Wilkins","email":"saepza@kiic.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e58edce615d94d3b6c198d054dcab842.png","birthday":null,"first_seen":"2016-04-09T11:32:54.893Z","last_seen":"2016-11-04T21:22:35.654Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":587,"first_name":"Annie","last_name":"Day","email":"bo@litpun.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/31c5af858a55ca6e4de23cf0691686f5.png","birthday":null,"first_seen":"2013-05-10T13:01:52.670Z","last_seen":"2015-06-22T23:46:35.523Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":588,"first_name":"Irene","last_name":"Evans","email":"gawebum@pacunujod.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ec3fb05a20e90b20c48e49b5a48d40c5.png","birthday":null,"first_seen":"2015-09-19T15:52:42.599Z","last_seen":"2016-08-04T10:52:47.406Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":589,"first_name":"Howard","last_name":"Bush","email":"gur@wakku.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e6dba2051590dcc9af4a4ebf5a03e25e.png","birthday":null,"first_seen":"2016-03-26T08:55:32.724Z","last_seen":"2016-12-30T00:58:58.479Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":590,"first_name":"Eugenia","last_name":"Palmer","email":"jerhuf@si.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6fa4d3183302d56c0ca4fe72cab210d0.png","birthday":null,"first_seen":"2015-06-07T03:44:29.676Z","last_seen":"2016-07-10T07:25:26.629Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":591,"first_name":"Lilly","last_name":"Carson","email":"biscevpak@ninabebam.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6e59f23b7b5ccae9b0854804891a9758.png","birthday":null,"first_seen":"2014-04-15T20:05:52.096Z","last_seen":"2015-08-13T04:58:50.614Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":592,"first_name":"Jack","last_name":"Abbott","email":"iwnoiru@uva.io","address":"1602 Duzpog Way","zipcode":"12769","city":"Ropimcic","avatar":"https://robohash.org/19753d1bc851c591735c53c88bed102c.png","birthday":"1955-01-18T00:45:03.096Z","first_seen":"2014-03-03T14:59:02.534Z","last_seen":"2015-04-16T01:49:16.419Z","has_ordered":true,"latest_purchase":"2014-12-31T22:28:34.877Z","has_newsletter":false,"groups":["regular","reviewer"],"nb_commands":3,"total_spent":356.71000000000004},{"id":593,"first_name":"Arthur","last_name":"Adams","email":"corwit@acese.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/81f21e8a457b0124b34e376e27691b8b.png","birthday":null,"first_seen":"2016-01-04T18:20:25.636Z","last_seen":"2016-12-27T07:26:49.087Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":594,"first_name":"Jeremy","last_name":"Bryan","email":"bo@avavo.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/bec49055e5e68b97c33a46d1f74a3044.png","birthday":null,"first_seen":"2016-07-21T09:22:45.534Z","last_seen":"2016-12-10T05:21:50.028Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":595,"first_name":"Rachel","last_name":"Brewer","email":"wubdelub@tamol.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/197078530cc494036db5a1acf24d1520.png","birthday":null,"first_seen":"2014-11-11T10:08:55.296Z","last_seen":"2016-09-08T07:34:47.259Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":596,"first_name":"Olive","last_name":"Spencer","email":"ha@cobtak.io","address":"905 Zuam Circle","zipcode":"55043","city":"Sucopuw","avatar":"https://robohash.org/2e46ca995258495ef4f9b1f28448bb61.png","birthday":"1974-05-01T00:19:22.293Z","first_seen":"2015-04-25T14:39:48.167Z","last_seen":"2016-11-27T20:03:20.933Z","has_ordered":true,"latest_purchase":"2016-11-23T13:44:23.987Z","has_newsletter":true,"groups":["regular","reviewer"],"nb_commands":3,"total_spent":788.24},{"id":597,"first_name":"Rosalie","last_name":"Berry","email":"womued@wu.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c95b3b4ef9bf9f550de7dca5ee95e715.png","birthday":null,"first_seen":"2014-02-11T19:52:20.512Z","last_seen":"2016-08-01T02:42:53.676Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":598,"first_name":"Troy","last_name":"Carr","email":"emi@ku.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ae928c17b5de263e9ae82060cd1f63e3.png","birthday":null,"first_seen":"2014-05-23T02:05:20.816Z","last_seen":"2016-02-04T02:28:57.098Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":599,"first_name":"Ruby","last_name":"Munoz","email":"ot@ako.edu","address":"1628 Tiut Place","zipcode":"19390","city":"Wicenah","avatar":"https://robohash.org/5e84b82d74a4338097b5f69ea0719098.png","birthday":"1993-01-17T04:44:28.485Z","first_seen":"2015-10-22T23:59:28.840Z","last_seen":"2016-05-12T07:11:34.478Z","has_ordered":true,"latest_purchase":"2016-04-25T02:43:45.226Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":768.4300000000001},{"id":600,"first_name":"John","last_name":"Barker","email":"beibafip@murjirep.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/28bf73fb107097e0ce38d0ae0814416d.png","birthday":null,"first_seen":"2016-11-14T20:13:37.743Z","last_seen":"2016-11-19T00:16:26.265Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":601,"first_name":"Olivia","last_name":"Lucas","email":"za@ti.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/78ac1c28418c001e5f48a79e3151128b.png","birthday":null,"first_seen":"2015-05-18T16:22:44.701Z","last_seen":"2016-12-25T04:18:17.626Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":602,"first_name":"Chase","last_name":"Allison","email":"ivotedin@lerlon.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e8fc8252aae6d2e004fb71694d6fc546.png","birthday":null,"first_seen":"2014-11-30T10:07:07.208Z","last_seen":"2016-12-08T14:52:29.113Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":603,"first_name":"Nicholas","last_name":"Frank","email":"taj@asoere.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/66ede701b3614ff13cd23ce416195349.png","birthday":null,"first_seen":"2016-05-03T20:56:11.681Z","last_seen":"2016-09-17T03:09:06.851Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":604,"first_name":"Lulu","last_name":"Pearson","email":"emcabi@ciweclu.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ff6baaad6b43909b3f68cdc0fae2b31e.png","birthday":null,"first_seen":"2016-12-17T04:48:49.234Z","last_seen":"2017-01-05T03:39:36.045Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":605,"first_name":"Aaron","last_name":"Casey","email":"mef@ohi.co.uk","address":"1241 Etuow Heights","zipcode":"50216","city":"Kuperaf","avatar":"https://robohash.org/e031105a729e2f564d1135a1c166c685.png","birthday":"1960-10-15T05:23:53.738Z","first_seen":"2015-02-25T20:13:54.470Z","last_seen":"2016-09-24T17:54:00.944Z","has_ordered":true,"latest_purchase":"2016-09-23T02:12:22.862Z","has_newsletter":false,"groups":[],"nb_commands":2,"total_spent":489.88},{"id":606,"first_name":"Andre","last_name":"McKenzie","email":"hopwik@uv.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3fed87ae215c7fc1e0ea8d285aa89885.png","birthday":null,"first_seen":"2016-05-28T21:55:25.879Z","last_seen":"2016-12-05T16:17:35.331Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":607,"first_name":"Jennie","last_name":"Logan","email":"ijuucga@timlihe.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f7f28b657804c8329a5c4418ea9f65f2.png","birthday":null,"first_seen":"2015-10-11T20:58:37.274Z","last_seen":"2016-05-22T20:11:46.460Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":608,"first_name":"Stephen","last_name":"Roberts","email":"dahjazaci@ebcu.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/842edbea6e44c99f0b4ae24756044a37.png","birthday":null,"first_seen":"2016-01-10T22:02:59.243Z","last_seen":"2016-12-04T12:49:49.168Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":609,"first_name":"Mary","last_name":"Houston","email":"iwcaki@coc.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/add56e3a57a661c6ac5eab6f578ab15c.png","birthday":null,"first_seen":"2015-07-02T16:09:36.288Z","last_seen":"2016-09-23T06:05:29.647Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":610,"first_name":"Lydia","last_name":"Blake","email":"li@jal.net","address":"154 Jafmu Trail","zipcode":"91150","city":"Adbejes","avatar":"https://robohash.org/ef1e20418a76c0a52168311e684ac7a6.png","birthday":"1990-06-07T05:16:50.658Z","first_seen":"2016-05-28T08:37:56.989Z","last_seen":"2016-12-14T07:15:05.038Z","has_ordered":true,"latest_purchase":"2016-12-10T17:22:25.691Z","has_newsletter":false,"groups":["collector"],"nb_commands":5,"total_spent":750.03},{"id":611,"first_name":"Erik","last_name":"Long","email":"suwsabur@reag.edu","address":"520 Uljub Terrace","zipcode":"87906","city":"Hievvoc","avatar":"https://robohash.org/6b17739771c7b38e5e036c19229168f9.png","birthday":"1984-04-25T07:20:05.090Z","first_seen":"2015-08-07T18:00:33.487Z","last_seen":"2016-05-09T20:38:16.588Z","has_ordered":true,"latest_purchase":null,"has_newsletter":false,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":612,"first_name":"Nina","last_name":"Townsend","email":"jape@huzgid.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/40477b439abe3c1b46e3b31388805f92.png","birthday":null,"first_seen":"2015-05-02T00:16:46.756Z","last_seen":"2016-06-28T16:03:25.360Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":613,"first_name":"Claudia","last_name":"Tucker","email":"ubavi@vejte.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/52aded6fa8a7dd1b994b3b6cb6824448.png","birthday":null,"first_seen":"2014-06-23T07:17:40.513Z","last_seen":"2016-09-19T06:40:00.071Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":614,"first_name":"Mittie","last_name":"Medina","email":"zajaj@hobet.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/86e1bd6e0777af13f88eee4c726b3774.png","birthday":null,"first_seen":"2014-09-20T19:02:01.675Z","last_seen":"2016-09-21T06:08:55.488Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":615,"first_name":"Lucile","last_name":"Wallace","email":"esgeh@tim.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f3dd86f2c2c2b854025a7dd92b211744.png","birthday":null,"first_seen":"2016-03-11T16:38:09.937Z","last_seen":"2016-10-05T20:31:22.277Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":616,"first_name":"Jonathan","last_name":"McCarthy","email":"kelorir@jozbusal.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/38c7e14d1cd9198ce83c2cea5139e053.png","birthday":null,"first_seen":"2014-06-22T00:42:29.429Z","last_seen":"2016-12-20T01:53:01.619Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":617,"first_name":"Sadie","last_name":"Warren","email":"ecvih@foblic.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d1ae4c476104bd1cb9b1cc5e2dee6dd7.png","birthday":null,"first_seen":"2015-01-14T16:57:29.147Z","last_seen":"2016-02-22T11:41:31.318Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":618,"first_name":"Brandon","last_name":"Figueroa","email":"judpog@jokgup.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/887e981152c3ed68cce39d248a2a6f38.png","birthday":null,"first_seen":"2016-05-09T00:40:04.755Z","last_seen":"2016-12-13T11:20:11.170Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":619,"first_name":"Luis","last_name":"Dixon","email":"wudu@tofijos.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2df2676760beb873e0ebd7017dc0989c.png","birthday":null,"first_seen":"2016-07-21T07:23:49.882Z","last_seen":"2016-11-30T17:20:24.994Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":620,"first_name":"Ina","last_name":"Edwards","email":"moja@juw.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a47ac322596a83d48d09946d3e38e43a.png","birthday":null,"first_seen":"2014-03-16T00:38:34.404Z","last_seen":"2015-10-03T06:14:18.524Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":621,"first_name":"Eva","last_name":"McGee","email":"apor@be.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b6e0542f70aa7d50a949167ec7b558fb.png","birthday":null,"first_seen":"2014-10-02T06:26:27.017Z","last_seen":"2016-11-06T20:57:46.550Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":622,"first_name":"Alfred","last_name":"Thompson","email":"no@celbe.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/46df86013afa3b38f8df62a4eb2ff821.png","birthday":null,"first_seen":"2015-11-13T03:01:36.294Z","last_seen":"2016-05-31T04:29:26.083Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":623,"first_name":"Connor","last_name":"Howell","email":"laljuhiju@tam.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0f059a3b2c9f18e9e6ad3b7b3a0a9c5e.png","birthday":null,"first_seen":"2015-10-11T15:19:05.391Z","last_seen":"2016-11-02T19:29:02.907Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":624,"first_name":"Katherine","last_name":"Dixon","email":"ha@nudunuf.com","address":"1123 Wanut Parkway","zipcode":"79511","city":"Ozepatup","avatar":"https://robohash.org/8054a8e498dde172c810be2216123a59.png","birthday":"1954-07-26T03:54:46.929Z","first_seen":"2013-08-11T00:01:52.713Z","last_seen":"2016-08-22T12:25:14.806Z","has_ordered":true,"latest_purchase":"2015-05-22T08:16:50.685Z","has_newsletter":false,"groups":[],"nb_commands":2,"total_spent":589.99},{"id":625,"first_name":"Phoebe","last_name":"Howard","email":"nozob@fid.org","address":"720 Gokki Trail","zipcode":"95431","city":"Dedafekuw","avatar":"https://robohash.org/2ec09b7889ecfddbf7fbcf867119d8b1.png","birthday":"1956-03-15T06:12:44.961Z","first_seen":"2015-03-05T15:01:23.820Z","last_seen":"2015-10-18T23:46:22.018Z","has_ordered":true,"latest_purchase":"2015-06-07T16:11:13.413Z","has_newsletter":false,"groups":["ordered_once","returns","reviewer"],"nb_commands":1,"total_spent":300.56},{"id":626,"first_name":"William","last_name":"Cruz","email":"piup@naw.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1bb80f1787dadb10dde89611fdc12df9.png","birthday":null,"first_seen":"2016-06-23T03:39:38.249Z","last_seen":"2016-12-03T13:35:51.558Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":627,"first_name":"Rena","last_name":"Clayton","email":"atle@edihegpa.edu","address":"312 Togetu Turnpike","zipcode":"18511","city":"Zamfuggu","avatar":"https://robohash.org/9d1be1011aadf0128e7e360d035127aa.png","birthday":"1957-08-21T06:53:37.943Z","first_seen":"2015-02-24T12:01:20.676Z","last_seen":"2016-09-04T06:46:07.533Z","has_ordered":true,"latest_purchase":"2016-05-22T18:37:09.978Z","has_newsletter":false,"groups":["collector","reviewer"],"nb_commands":4,"total_spent":1441.3600000000001},{"id":628,"first_name":"Michael","last_name":"Hernandez","email":"gotlicwaf@ho.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c193fef9d54a7e4f63ab6ed4b5c82943.png","birthday":null,"first_seen":"2016-12-28T08:59:18.759Z","last_seen":"2016-12-30T16:45:46.409Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":629,"first_name":"Luke","last_name":"Taylor","email":"tum@em.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8843966a7af74d4d790e5348def136de.png","birthday":null,"first_seen":"2015-08-03T10:04:53.660Z","last_seen":"2016-05-12T06:29:47.180Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":630,"first_name":"Lloyd","last_name":"Joseph","email":"jewbah@vitjan.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b8865bb04cb7c932e060aac4cb94ff13.png","birthday":null,"first_seen":"2013-12-23T14:31:31.720Z","last_seen":"2016-07-17T15:02:56.908Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":631,"first_name":"Jordan","last_name":"Wallace","email":"bios@jolu.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/cf1fb58b5ecf0b4f07382b6661d26bce.png","birthday":null,"first_seen":"2014-10-20T06:03:10.454Z","last_seen":"2016-12-18T16:33:45.325Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":632,"first_name":"Dollie","last_name":"Nunez","email":"gogasnub@tap.net","address":"1959 Mufa Parkway","zipcode":"80415","city":"Ahesasde","avatar":"https://robohash.org/e8c33cf39c65dbea346577d853c59c33.png","birthday":"1964-01-29T07:40:27.154Z","first_seen":"2015-06-24T23:44:06.250Z","last_seen":"2016-12-23T22:04:24.791Z","has_ordered":true,"latest_purchase":null,"has_newsletter":false,"groups":[],"nb_commands":0,"total_spent":0},{"id":633,"first_name":"Steve","last_name":"Reyes","email":"fejkemsi@pam.io","address":"1133 Jejob Grove","zipcode":"90633","city":"Icasmo","avatar":"https://robohash.org/46b3539ae1dd3968bf8ae449f82c8070.png","birthday":"1990-05-04T03:48:48.980Z","first_seen":"2016-10-31T02:39:18.923Z","last_seen":"2016-12-27T02:12:25.755Z","has_ordered":true,"latest_purchase":"2016-12-11T19:57:43.762Z","has_newsletter":false,"groups":["ordered_once","reviewer"],"nb_commands":1,"total_spent":70.13},{"id":634,"first_name":"Myrtle","last_name":"Barber","email":"coz@tat.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8eb1d99cb976ac142a3bc865db89eed7.png","birthday":null,"first_seen":"2016-01-17T15:10:02.819Z","last_seen":"2016-09-04T22:53:38.243Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":635,"first_name":"Minnie","last_name":"Wilkins","email":"zal@kulado.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/015bfa06776bc58c3c502fbdbc0ff46c.png","birthday":null,"first_seen":"2016-03-18T08:22:35.836Z","last_seen":"2016-10-16T12:20:09.787Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":636,"first_name":"Earl","last_name":"Jones","email":"gat@ecihawfat.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/000636e104565b960c9e57cb95c91053.png","birthday":null,"first_seen":"2016-03-18T21:20:36.321Z","last_seen":"2016-08-22T07:10:13.632Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":637,"first_name":"Minnie","last_name":"Baldwin","email":"dag@cobikzoh.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/62291e7cff683ffd44b0ae5a9abd56e1.png","birthday":null,"first_seen":"2013-04-09T14:41:02.270Z","last_seen":"2016-09-21T10:37:09.317Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":638,"first_name":"Minnie","last_name":"Jenkins","email":"lim@loruvi.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0d1c1a718b2272d7f892e73b3db4fe1b.png","birthday":null,"first_seen":"2016-12-25T07:47:29.046Z","last_seen":"2017-01-03T20:40:43.527Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":639,"first_name":"Anne","last_name":"Morrison","email":"ukuca@naboz.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2ded4f1ae47abeec31b49818da00053e.png","birthday":null,"first_seen":"2015-04-22T15:34:03.819Z","last_seen":"2016-07-19T14:36:43.141Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":640,"first_name":"Louise","last_name":"Ellis","email":"gizvu@paef.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/9b1be302d58d11428594b65f17ade57f.png","birthday":null,"first_seen":"2016-01-21T23:41:37.152Z","last_seen":"2016-12-27T06:04:22.287Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":641,"first_name":"Isaiah","last_name":"King","email":"tenazzig@boza.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d8c192af40f43b897920d4b703bd0c21.png","birthday":null,"first_seen":"2014-01-05T18:14:38.994Z","last_seen":"2016-11-26T21:20:48.130Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":642,"first_name":"Paul","last_name":"Sanders","email":"favu@bekjurohi.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2802dbad25c1ca4242373f2c3561668b.png","birthday":null,"first_seen":"2016-08-03T09:57:25.774Z","last_seen":"2016-12-15T15:26:31.792Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":643,"first_name":"Hannah","last_name":"Knight","email":"rec@wev.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d5e1191a94318cf132c0e0fca081d3ed.png","birthday":null,"first_seen":"2014-10-12T09:08:52.111Z","last_seen":"2016-10-21T18:14:06.016Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":644,"first_name":"Devin","last_name":"Robbins","email":"wefegja@kaw.com","address":"169 Itfep Road","zipcode":"00880","city":"Igovermap","avatar":"https://robohash.org/953eb65fa73a812f6fefd334cfc8d89b.png","birthday":"1954-10-21T23:35:47.117Z","first_seen":"2014-01-14T23:51:52.570Z","last_seen":"2014-06-12T14:39:09.700Z","has_ordered":true,"latest_purchase":"2014-06-11T07:05:44.507Z","has_newsletter":false,"groups":["returns","reviewer"],"nb_commands":3,"total_spent":342.05},{"id":645,"first_name":"Erik","last_name":"Chandler","email":"virkim@ufiwa.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/94665dfe597161b104923edb27102e89.png","birthday":null,"first_seen":"2016-05-03T06:48:08.812Z","last_seen":"2016-10-23T00:02:00.143Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":646,"first_name":"Philip","last_name":"Jimenez","email":"uzjet@veihine.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/53a2eca5e0bea69f33b3183204decdd3.png","birthday":null,"first_seen":"2015-09-16T06:52:29.372Z","last_seen":"2016-11-22T20:12:43.078Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":647,"first_name":"Adam","last_name":"Potter","email":"okobo@wi.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1d3f929ff3252bf5b767bbd1c6a4c1c5.png","birthday":null,"first_seen":"2015-01-26T11:49:52.677Z","last_seen":"2016-08-11T22:39:13.931Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":648,"first_name":"Alex","last_name":"McKenzie","email":"mefku@tejapsoj.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2f54b67e1fab02b76f16def30c0c4b2e.png","birthday":null,"first_seen":"2014-07-18T12:24:22.088Z","last_seen":"2016-11-17T14:55:50.264Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":649,"first_name":"Susie","last_name":"Floyd","email":"hevahu@ijowec.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/616e8a32dbb8277fc054f5ed1a27fabd.png","birthday":null,"first_seen":"2015-07-31T21:44:22.637Z","last_seen":"2016-12-03T22:13:49.133Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":650,"first_name":"Zachary","last_name":"Warren","email":"wujzunro@dika.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7bfe5e30f849a9fd12cd6383fab5a172.png","birthday":null,"first_seen":"2014-09-30T07:07:28.671Z","last_seen":"2015-09-02T02:08:08.811Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":651,"first_name":"Ethan","last_name":"Conner","email":"ujuoho@wom.io","address":"939 Zekci Circle","zipcode":"72977","city":"Polramov","avatar":"https://robohash.org/1762effbe0f752ef770170411ef5f6ef.png","birthday":"1968-03-06T07:03:43.365Z","first_seen":"2016-08-16T22:46:46.200Z","last_seen":"2016-12-17T03:28:35.624Z","has_ordered":true,"latest_purchase":"2016-12-01T04:32:23.309Z","has_newsletter":false,"groups":["regular","returns","reviewer"],"nb_commands":3,"total_spent":387.09},{"id":652,"first_name":"Christopher","last_name":"Day","email":"pat@nucidiv.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fd8af829ab1949381a0db7c3c269c21a.png","birthday":null,"first_seen":"2016-10-29T04:55:21.511Z","last_seen":"2016-12-13T01:28:49.243Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":653,"first_name":"Emilie","last_name":"Arnold","email":"hagiedi@tahse.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/67760110e51aee75b23ecfeb89ed7de7.png","birthday":null,"first_seen":"2014-05-20T03:11:31.718Z","last_seen":"2015-06-05T13:47:22.048Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":654,"first_name":"Esther","last_name":"Greene","email":"ipgiip@wikah.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1d40021129fab6c607092f612cef508a.png","birthday":null,"first_seen":"2016-08-19T13:54:38.669Z","last_seen":"2016-12-22T20:37:36.348Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":655,"first_name":"Margaret","last_name":"Thomas","email":"subak@jat.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fb6679b1dc475894abc37dd081be5855.png","birthday":null,"first_seen":"2015-01-16T18:49:14.143Z","last_seen":"2016-11-15T00:24:47.253Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":656,"first_name":"Rosie","last_name":"Salazar","email":"ifesinbuj@zen.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f09b214e76b1d288504bb8857f84fa03.png","birthday":null,"first_seen":"2014-02-06T01:35:56.988Z","last_seen":"2015-09-19T11:04:15.170Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":657,"first_name":"Alvin","last_name":"Gonzales","email":"hiwipu@soiwimu.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e6ce22579a76a44a2a6fb6bd50f839b4.png","birthday":null,"first_seen":"2016-04-01T00:56:45.383Z","last_seen":"2016-05-11T00:59:15.431Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":658,"first_name":"Shawn","last_name":"Wallace","email":"nawvub@fuddihih.com","address":"1370 Fomov Avenue","zipcode":"65129","city":"Pecudhut","avatar":"https://robohash.org/482a5d8e09311a98ea6fddf21b39aad7.png","birthday":"1990-04-19T02:33:03.868Z","first_seen":"2013-08-03T10:23:56.137Z","last_seen":"2015-10-23T07:24:39.098Z","has_ordered":true,"latest_purchase":"2015-01-09T16:20:59.034Z","has_newsletter":false,"groups":["ordered_once","reviewer"],"nb_commands":1,"total_spent":272.87},{"id":659,"first_name":"Sara","last_name":"Wheeler","email":"red@vaobgo.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c8d45d47a4c581cffae951c66e03a56e.png","birthday":null,"first_seen":"2015-04-20T08:41:13.767Z","last_seen":"2016-07-29T08:29:00.103Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":660,"first_name":"Tillie","last_name":"Wood","email":"wojmocavi@segegoum.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7fda30dc87abeeca595a16e7798a4daf.png","birthday":null,"first_seen":"2015-02-12T20:45:44.245Z","last_seen":"2016-09-01T18:47:00.692Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":661,"first_name":"Matthew","last_name":"Alexander","email":"ineive@picnovoj.co.uk","address":"1823 Lenbo Park","zipcode":"03041","city":"Izubetet","avatar":"https://robohash.org/ddb1d483d62766e5ca59b17e059ea72c.png","birthday":"1996-09-14T02:32:39.347Z","first_seen":"2014-04-19T13:27:18.485Z","last_seen":"2015-07-04T04:29:50.862Z","has_ordered":true,"latest_purchase":"2015-05-18T14:42:16.279Z","has_newsletter":false,"groups":["collector","returns"],"nb_commands":4,"total_spent":854.19},{"id":662,"first_name":"Sam","last_name":"Sanchez","email":"wipdih@do.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7622f4bef341238d3286d124f0ee8f28.png","birthday":null,"first_seen":"2015-04-17T07:48:12.697Z","last_seen":"2016-03-25T23:30:42.137Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":663,"first_name":"Daisy","last_name":"Lamb","email":"ci@falpe.edu","address":"533 Hehug Court","zipcode":"11340","city":"Usfenju","avatar":"https://robohash.org/01a5ce281b07785d6c6c0506959280f4.png","birthday":"1984-10-21T06:00:27.299Z","first_seen":"2014-12-22T21:49:46.638Z","last_seen":"2016-07-12T16:23:26.508Z","has_ordered":true,"latest_purchase":"2015-10-12T09:12:24.888Z","has_newsletter":true,"groups":["ordered_once","returns"],"nb_commands":1,"total_spent":153.64},{"id":664,"first_name":"Mabel","last_name":"Santiago","email":"di@looki.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f2f5715c3ed509912c5fbd252d4f4206.png","birthday":null,"first_seen":"2016-12-29T08:41:16.808Z","last_seen":"2017-01-03T03:08:33.648Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":665,"first_name":"Shawn","last_name":"Watson","email":"sezniv@addiuzi.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e49b003267809b406cb5d456146bf164.png","birthday":null,"first_seen":"2015-04-19T00:40:15.352Z","last_seen":"2016-09-30T09:08:23.205Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":666,"first_name":"Juan","last_name":"Sutton","email":"coka@mepci.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b6723b6adcd052d98e7a51d3c6524778.png","birthday":null,"first_seen":"2016-05-25T10:04:19.728Z","last_seen":"2016-08-27T10:49:38.513Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":667,"first_name":"Alan","last_name":"Mendez","email":"lesate@jil.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/110f655b3d9c26ea960df5b66297b470.png","birthday":null,"first_seen":"2014-05-13T10:08:50.050Z","last_seen":"2016-06-08T02:48:30.119Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":668,"first_name":"Matilda","last_name":"Sullivan","email":"tipefir@cacjoclu.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/47273a07c72214d0338f3fca0e898726.png","birthday":null,"first_seen":"2016-02-29T02:03:18.676Z","last_seen":"2016-11-20T13:19:25.849Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":669,"first_name":"Maud","last_name":"McKinney","email":"urowwo@je.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e8a41af5e36d5367437f4253a92b5761.png","birthday":null,"first_seen":"2015-10-19T15:21:39.298Z","last_seen":"2016-09-11T12:09:20.823Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":670,"first_name":"Harold","last_name":"Dawson","email":"piozu@etusuce.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/14ac20a33e7df39cab720ec967e2b523.png","birthday":null,"first_seen":"2014-02-28T18:28:23.247Z","last_seen":"2016-05-30T09:13:44.692Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":671,"first_name":"Cecilia","last_name":"Hines","email":"sivdi@zole.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fa5c0e954a38fde22aa349e55a968a05.png","birthday":null,"first_seen":"2016-07-14T01:18:25.130Z","last_seen":"2016-11-25T02:55:07.980Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":672,"first_name":"Elva","last_name":"Grant","email":"ni@pesobok.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a5d16ebc2a7d30a3bb8fddf3f72e096a.png","birthday":null,"first_seen":"2015-03-15T10:47:24.984Z","last_seen":"2016-06-14T15:44:59.451Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":673,"first_name":"Bettie","last_name":"Paul","email":"lutmekloz@kebmezad.com","address":"1702 Kipbi Street","zipcode":"73843","city":"Vovnupor","avatar":"https://robohash.org/e0a1798a627edce803f53e1ec7b1e457.png","birthday":"1978-12-12T08:20:24.199Z","first_seen":"2015-04-12T01:46:52.438Z","last_seen":"2016-07-20T06:52:07.142Z","has_ordered":true,"latest_purchase":"2016-02-18T22:34:05.368Z","has_newsletter":false,"groups":[],"nb_commands":2,"total_spent":321.55},{"id":674,"first_name":"Beatrice","last_name":"Caldwell","email":"ginnobib@jozofuh.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d261d607703e1370dde0fdd05ab5f2e4.png","birthday":null,"first_seen":"2016-07-05T02:37:35.679Z","last_seen":"2016-11-29T04:43:48.277Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":675,"first_name":"Emily","last_name":"Foster","email":"cem@ow.gov","address":"1107 Atnis Way","zipcode":"68552","city":"Jimevke","avatar":"https://robohash.org/274c73105d218d8544255d6806aaa7ac.png","birthday":"1980-01-16T10:57:49.431Z","first_seen":"2015-05-11T15:10:45.281Z","last_seen":"2016-11-20T09:31:37.170Z","has_ordered":true,"latest_purchase":"2016-09-19T13:29:25.624Z","has_newsletter":false,"groups":[],"nb_commands":3,"total_spent":340.7},{"id":676,"first_name":"Jennie","last_name":"Medina","email":"acivoz@pevipi.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/11dfe15a917ced710170d0186b756dfa.png","birthday":null,"first_seen":"2015-11-10T09:04:27.508Z","last_seen":"2016-01-11T23:56:34.578Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":677,"first_name":"Mildred","last_name":"Massey","email":"cibnauv@nalava.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/cf88230ae2bbd41f81fa8f7dd66fb4f9.png","birthday":null,"first_seen":"2016-11-05T07:34:39.614Z","last_seen":"2016-12-28T09:48:07.876Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":678,"first_name":"Evan","last_name":"Aguilar","email":"limlu@eludlol.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b6a272945df664c0f654dce89e3f2f93.png","birthday":null,"first_seen":"2014-07-09T03:08:39.183Z","last_seen":"2014-12-18T05:16:11.301Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":679,"first_name":"Mildred","last_name":"Bryant","email":"ketveznoc@filovu.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e0d295e5a3f5497fa567485d8985b3ee.png","birthday":null,"first_seen":"2014-07-21T15:52:42.453Z","last_seen":"2015-05-19T12:15:28.426Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":680,"first_name":"Emily","last_name":"Greene","email":"vab@met.io","address":"847 Ucig Junction","zipcode":"90911","city":"Vofimje","avatar":"https://robohash.org/60a0a4a939092ed4dc8a8421f634fb4d.png","birthday":"1975-03-18T08:03:45.867Z","first_seen":"2016-09-17T03:59:16.120Z","last_seen":"2016-12-22T10:19:26.603Z","has_ordered":true,"latest_purchase":"2016-12-18T21:46:24.252Z","has_newsletter":true,"groups":["ordered_once"],"nb_commands":1,"total_spent":125.2},{"id":681,"first_name":"Edwin","last_name":"Owen","email":"dahupa@emogive.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6dbf015e02536e2d991e8d49ab309209.png","birthday":null,"first_seen":"2016-11-18T15:24:17.572Z","last_seen":"2017-01-02T15:12:22.505Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":682,"first_name":"Randall","last_name":"Holloway","email":"dodhe@ano.edu","address":"1324 Mowda Loop","zipcode":"66452","city":"Lucikajeb","avatar":"https://robohash.org/98c7b760d7f9e5fae33c2977eedb7043.png","birthday":"1984-01-02T11:34:44.928Z","first_seen":"2013-12-04T10:45:21.065Z","last_seen":"2015-12-19T19:19:09.957Z","has_ordered":true,"latest_purchase":"2014-08-24T07:56:40.763Z","has_newsletter":false,"groups":["ordered_once","regular"],"nb_commands":1,"total_spent":299.92},{"id":683,"first_name":"Adele","last_name":"Edwards","email":"uw@av.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/9f62ab06218bf5c2068648cc98cbab6f.png","birthday":null,"first_seen":"2016-03-15T07:36:10.090Z","last_seen":"2016-12-14T23:02:17.462Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":684,"first_name":"Chester","last_name":"Fowler","email":"cangazpo@bu.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7c85cd449610a60c6b3ea246f81c7cff.png","birthday":null,"first_seen":"2015-01-11T03:32:33.645Z","last_seen":"2016-11-25T02:11:16.133Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":685,"first_name":"Adele","last_name":"Ramos","email":"cuovjol@im.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2d4b262ef80ba63baf366774a26e931d.png","birthday":null,"first_seen":"2016-10-18T19:44:34.315Z","last_seen":"2016-12-28T01:24:34.461Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":686,"first_name":"Ophelia","last_name":"Payne","email":"lupiv@detwo.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5c280a5d5578a516c1d0a9a77b47f1af.png","birthday":null,"first_seen":"2015-10-16T00:48:53.702Z","last_seen":"2016-12-18T22:48:12.355Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":687,"first_name":"Dylan","last_name":"Armstrong","email":"igtab@tak.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3a32394211a493e64d006036bd4084f4.png","birthday":null,"first_seen":"2016-12-15T05:52:58.371Z","last_seen":"2016-12-28T10:31:46.905Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":688,"first_name":"Benjamin","last_name":"Walker","email":"up@zi.gov","address":"1034 Favap Boulevard","zipcode":"52474","city":"Kootmid","avatar":"https://robohash.org/37db6114288b4716a83a16638dcd8cfe.png","birthday":"1975-12-17T08:43:37.818Z","first_seen":"2013-04-25T23:07:57.325Z","last_seen":"2014-11-12T09:25:29.288Z","has_ordered":true,"latest_purchase":"2014-11-02T18:43:15.887Z","has_newsletter":false,"groups":["ordered_once","reviewer"],"nb_commands":1,"total_spent":95.86},{"id":689,"first_name":"David","last_name":"Soto","email":"aroazideg@kemzu.gov","address":"396 Dubiwi Highway","zipcode":"72355","city":"Nusoca","avatar":"https://robohash.org/1d181fee506638b3de78c698c7230879.png","birthday":"1970-09-01T00:40:07.234Z","first_seen":"2015-04-19T21:07:02.639Z","last_seen":"2016-07-22T15:53:30.004Z","has_ordered":true,"latest_purchase":"2016-04-10T16:57:12.250Z","has_newsletter":false,"groups":[],"nb_commands":2,"total_spent":142.32},{"id":690,"first_name":"Ruby","last_name":"Banks","email":"dacu@nu.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7e8a2e6f236ea46d6c11c533b82c8976.png","birthday":null,"first_seen":"2016-05-18T12:31:00.754Z","last_seen":"2016-12-08T14:58:50.868Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":691,"first_name":"Aaron","last_name":"Marshall","email":"raldesa@pidtun.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5ce455b5bdb724881959323d59a6ce0f.png","birthday":null,"first_seen":"2015-06-08T19:40:51.740Z","last_seen":"2015-11-07T20:48:16.704Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":692,"first_name":"Millie","last_name":"Guzman","email":"lapmo@lossilvuw.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3d414b09586ef3a643b9bbcd8dabc1ea.png","birthday":null,"first_seen":"2014-07-26T14:50:00.354Z","last_seen":"2014-10-17T02:50:00.437Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":693,"first_name":"Max","last_name":"Bryant","email":"pagsahin@er.io","address":"44 Loud Turnpike","zipcode":"28787","city":"Bulpado","avatar":"https://robohash.org/14b3933e0053435012be4508dab1857b.png","birthday":"1985-04-06T04:23:36.578Z","first_seen":"2015-07-30T15:07:08.512Z","last_seen":"2016-06-22T20:59:06.822Z","has_ordered":true,"latest_purchase":"2016-06-18T00:40:04.332Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":6,"total_spent":1194.1599999999999},{"id":694,"first_name":"Cornelia","last_name":"Craig","email":"saz@rajagu.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8de6ec3624aef0696954a1eec1333c0d.png","birthday":null,"first_seen":"2014-11-15T14:42:01.382Z","last_seen":"2015-06-12T10:15:43.275Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":695,"first_name":"Tillie","last_name":"Rodgers","email":"zuslifi@raned.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2281d235b54fb4bf3373ef7eb55161a3.png","birthday":null,"first_seen":"2014-12-05T08:42:13.578Z","last_seen":"2016-10-28T12:18:31.276Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":696,"first_name":"Sam","last_name":"Bowers","email":"lawudju@bovevti.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c6b040e3f8b1f4df0f5da7f20676a27f.png","birthday":null,"first_seen":"2016-09-12T04:18:53.047Z","last_seen":"2016-12-25T14:27:17.528Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":697,"first_name":"Minerva","last_name":"Hopkins","email":"caje@wuozu.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6f5a88f0382159ac27fbfd49df9d683a.png","birthday":null,"first_seen":"2013-04-04T13:45:18.510Z","last_seen":"2014-09-23T06:15:39.146Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":698,"first_name":"Lucille","last_name":"Kim","email":"wi@nuh.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4971563266e41e8b689a373600d269c2.png","birthday":null,"first_seen":"2013-09-30T03:55:51.683Z","last_seen":"2016-04-25T18:09:42.686Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":699,"first_name":"Elva","last_name":"Peters","email":"azecopic@tar.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d5157b0995ec970dbd202839cf126e19.png","birthday":null,"first_seen":"2015-12-08T03:38:30.791Z","last_seen":"2016-12-09T00:45:50.401Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":700,"first_name":"Mason","last_name":"Lopez","email":"gud@tis.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a1bb42d0986406bb52e212066fc6b9b1.png","birthday":null,"first_seen":"2016-01-27T04:57:20.119Z","last_seen":"2016-10-05T10:27:38.749Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":701,"first_name":"Bobby","last_name":"Meyer","email":"ivelu@mupigzen.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1dd00127761998312d69a5ef501c6227.png","birthday":null,"first_seen":"2016-01-24T17:48:13.114Z","last_seen":"2016-07-02T09:30:26.083Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":702,"first_name":"Larry","last_name":"Flores","email":"remocgi@meb.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ed7f3ba5cb594898c5c89538a1c6fb4e.png","birthday":null,"first_seen":"2014-03-09T00:28:37.231Z","last_seen":"2015-10-04T15:50:02.761Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":703,"first_name":"Ophelia","last_name":"Gonzalez","email":"udwor@me.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0d954ccdf83b9bdf24a60a680cdaf7ed.png","birthday":null,"first_seen":"2015-04-30T20:15:01.250Z","last_seen":"2016-03-06T11:45:56.861Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":704,"first_name":"Gerald","last_name":"Ruiz","email":"cumasje@sedkampom.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8fb6ce9afb0a4045aeebf461890bbddb.png","birthday":null,"first_seen":"2015-03-02T22:04:51.476Z","last_seen":"2015-11-20T07:21:08.666Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":705,"first_name":"Victor","last_name":"Sullivan","email":"bin@nakra.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ea6833e2bfd738197b7fdebc97465bc5.png","birthday":null,"first_seen":"2016-08-10T07:23:33.271Z","last_seen":"2016-11-24T08:27:06.228Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":706,"first_name":"Mamie","last_name":"Scott","email":"pecrugek@mojuhmob.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4b0974d83925fd4c87889ff95df54904.png","birthday":null,"first_seen":"2014-10-17T14:20:08.798Z","last_seen":"2016-07-27T12:04:50.224Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":707,"first_name":"Sean","last_name":"Norton","email":"sogu@cejbo.com","address":"945 Etra Pass","zipcode":"66559","city":"Jihuvgak","avatar":"https://robohash.org/1803fafa953be79fc2d9c664668ae61c.png","birthday":"1969-02-12T08:09:16.333Z","first_seen":"2016-07-02T22:36:08.122Z","last_seen":"2016-11-08T13:51:13.247Z","has_ordered":true,"latest_purchase":"2016-11-02T17:45:16.472Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":156.20999999999998},{"id":708,"first_name":"Bertha","last_name":"West","email":"zisukifi@rofno.io","address":"1699 Beba Heights","zipcode":"94935","city":"Benamu","avatar":"https://robohash.org/f45a741924e376b262959aa33b03e09b.png","birthday":"1968-04-16T00:27:56.610Z","first_seen":"2016-03-30T22:56:12.997Z","last_seen":"2016-08-06T06:00:56.575Z","has_ordered":true,"latest_purchase":"2016-08-03T00:23:23.117Z","has_newsletter":false,"groups":["collector","returns"],"nb_commands":8,"total_spent":1106.27},{"id":709,"first_name":"Dean","last_name":"Hall","email":"coc@zitir.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2a88f19568fa9c7fbec5eac11c95bac4.png","birthday":null,"first_seen":"2016-03-17T14:53:06.041Z","last_seen":"2016-12-19T23:07:08.858Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":710,"first_name":"Ada","last_name":"French","email":"kekhikec@murlisu.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/50f40e08f63b37e5218931384c6abaaa.png","birthday":null,"first_seen":"2016-10-08T13:52:44.199Z","last_seen":"2016-12-20T09:32:15.741Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":711,"first_name":"Annie","last_name":"Bennett","email":"foajbo@vo.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e4edebf6cf3b62107f190bad2499e710.png","birthday":null,"first_seen":"2014-09-21T17:13:36.745Z","last_seen":"2016-04-06T12:49:26.340Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":712,"first_name":"Leila","last_name":"Ford","email":"fe@idcoihi.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/cff36a92035579cce8b90ed1011a9ccc.png","birthday":null,"first_seen":"2013-02-03T02:11:12.572Z","last_seen":"2015-10-18T20:37:47.478Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":713,"first_name":"Virgie","last_name":"Ortiz","email":"jaduuje@dagenez.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3f00f41618ed1ec3edab8639a9aa158f.png","birthday":null,"first_seen":"2016-10-22T01:04:42.024Z","last_seen":"2016-12-19T20:13:00.802Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":714,"first_name":"Lester","last_name":"Clark","email":"woesze@ahge.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d6c2820ff533c34ade7d88de5558e3ea.png","birthday":null,"first_seen":"2015-01-23T11:50:05.665Z","last_seen":"2016-11-12T02:13:14.443Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":715,"first_name":"Jerome","last_name":"Hernandez","email":"jacimu@nab.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/47d89559916a67af494ccb7b0bf83fd6.png","birthday":null,"first_seen":"2014-06-15T00:50:47.088Z","last_seen":"2015-12-10T10:11:44.910Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":716,"first_name":"Maud","last_name":"Swanson","email":"kekov@rahiv.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/57cb11274fb82720eabee71e35f6fc82.png","birthday":null,"first_seen":"2014-08-08T00:56:12.002Z","last_seen":"2015-03-08T04:06:48.395Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":717,"first_name":"Elnora","last_name":"Cross","email":"idi@pupoghur.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1d174ad891ceec03e8bc0d64db6125c9.png","birthday":null,"first_seen":"2013-04-23T12:36:58.634Z","last_seen":"2015-12-24T01:29:16.149Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":718,"first_name":"Violet","last_name":"Lopez","email":"ziktuc@fav.org","address":"1085 Uksip Pike","zipcode":"95245","city":"Wejeavo","avatar":"https://robohash.org/35975fa86c7588497ef728770955cd52.png","birthday":"1989-08-04T09:01:22.588Z","first_seen":"2015-11-29T16:54:58.282Z","last_seen":"2017-01-01T09:30:34.443Z","has_ordered":true,"latest_purchase":"2016-12-26T14:55:59.136Z","has_newsletter":true,"groups":["collector","returns","reviewer"],"nb_commands":7,"total_spent":778.55},{"id":719,"first_name":"Landon","last_name":"Stevenson","email":"ve@gefol.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d1eb6b67ce9c58b208e56ce36e6db9cd.png","birthday":null,"first_seen":"2015-10-06T16:59:31.217Z","last_seen":"2016-12-28T21:05:07.972Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":720,"first_name":"Adele","last_name":"Gray","email":"podo@dug.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4d4d004a3b5e6f453b4da8e8f3399959.png","birthday":null,"first_seen":"2015-01-12T16:36:49.971Z","last_seen":"2016-09-07T12:45:28.137Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":721,"first_name":"Henry","last_name":"Nunez","email":"jep@ivefadge.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fb24b15fc6f05016cbfddaacaee86f02.png","birthday":null,"first_seen":"2016-04-15T20:15:57.398Z","last_seen":"2016-08-20T13:20:04.304Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":722,"first_name":"Olive","last_name":"Henderson","email":"riwi@zek.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b030207b2946918965203bfb78ddfc97.png","birthday":null,"first_seen":"2016-05-29T12:48:08.883Z","last_seen":"2016-08-09T23:28:54.800Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":723,"first_name":"Jennie","last_name":"Jimenez","email":"ereba@kid.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/eaef8113a4119179f349251a32b1f303.png","birthday":null,"first_seen":"2016-10-27T16:27:40.319Z","last_seen":"2016-12-30T14:44:22.506Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":724,"first_name":"Allen","last_name":"Benson","email":"vero@debjotso.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ff5e404f5e3d527519342f3acc64a46a.png","birthday":null,"first_seen":"2015-04-14T21:38:41.865Z","last_seen":"2016-03-18T13:22:50.376Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":725,"first_name":"Lilly","last_name":"Erickson","email":"ivise@tud.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c67301a0cb42c22895e40b3a933315db.png","birthday":null,"first_seen":"2014-03-31T15:35:40.802Z","last_seen":"2016-02-24T11:33:50.085Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":726,"first_name":"Melvin","last_name":"Morales","email":"fifac@upe.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e86a7d352edea9395c5c6fd034a7b087.png","birthday":null,"first_seen":"2016-10-24T17:03:38.212Z","last_seen":"2016-11-25T04:46:21.158Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":727,"first_name":"Matilda","last_name":"Parker","email":"ruc@peb.edu","address":"57 Lutloz Center","zipcode":"10041","city":"Udelevhe","avatar":"https://robohash.org/f52a81e5097f24397f260cfe011039eb.png","birthday":"1984-05-29T03:13:19.726Z","first_seen":"2015-06-01T22:32:27.961Z","last_seen":"2016-06-09T20:21:33.642Z","has_ordered":true,"latest_purchase":"2016-03-21T11:46:44.014Z","has_newsletter":false,"groups":["collector","compulsive","regular"],"nb_commands":5,"total_spent":1714.12},{"id":728,"first_name":"Gabriel","last_name":"Fields","email":"opisuso@zikeri.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a05d919ef7bc8f383a774fca9dbe2998.png","birthday":null,"first_seen":"2015-11-09T06:05:00.882Z","last_seen":"2016-10-24T23:46:36.328Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":729,"first_name":"Ann","last_name":"Johnson","email":"heowsiz@biznigedo.io","address":"1037 Vipok Court","zipcode":"39334","city":"Vedluco","avatar":"https://robohash.org/57ccdfef016f9a9346ae4124aaa22ca5.png","birthday":"1978-06-29T10:06:56.164Z","first_seen":"2013-04-20T11:35:46.913Z","last_seen":"2015-08-23T18:37:27.255Z","has_ordered":true,"latest_purchase":"2014-01-01T18:05:10.836Z","has_newsletter":false,"groups":["ordered_once"],"nb_commands":1,"total_spent":54.76},{"id":730,"first_name":"Anne","last_name":"Hanson","email":"wu@bifuszo.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/950fd38802a20646a1a9d170343bb0c7.png","birthday":null,"first_seen":"2016-08-14T15:02:50.187Z","last_seen":"2016-12-15T08:22:42.974Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":731,"first_name":"Bertie","last_name":"Williams","email":"dibomi@zedujjig.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/016e24725f29e5b6e7417acd76d3065f.png","birthday":null,"first_seen":"2016-11-15T15:26:22.191Z","last_seen":"2016-11-23T02:13:22.219Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":732,"first_name":"Victor","last_name":"Williams","email":"jetnuji@uh.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f4ee81abca176ae669b42a10dcb7542f.png","birthday":null,"first_seen":"2013-08-05T02:01:40.419Z","last_seen":"2016-04-21T09:27:57.018Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":733,"first_name":"Lelia","last_name":"Webb","email":"razriena@oji.com","address":"43 Gako Pike","zipcode":"34568","city":"Kupeco","avatar":"https://robohash.org/4bfd34da919c2d00d34f1c922be58180.png","birthday":"1991-06-11T05:24:59.896Z","first_seen":"2016-12-31T11:29:16.020Z","last_seen":"2017-01-04T13:37:32.881Z","has_ordered":true,"latest_purchase":"2017-01-01T23:48:57.684Z","has_newsletter":true,"groups":["ordered_once","returns","reviewer"],"nb_commands":1,"total_spent":797.04},{"id":734,"first_name":"Ethel","last_name":"Carson","email":"bo@um.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6f4e64dc83691b37278c35b6f960656b.png","birthday":null,"first_seen":"2016-09-24T11:57:51.382Z","last_seen":"2016-11-18T21:36:28.085Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":735,"first_name":"Troy","last_name":"Campbell","email":"obi@zedji.io","address":"70 Movil Grove","zipcode":"48282","city":"Kopubzej","avatar":"https://robohash.org/fe4c5cc049294eaa91d06c086b24211a.png","birthday":"1967-04-22T10:02:37.356Z","first_seen":"2013-12-04T02:49:23.290Z","last_seen":"2014-10-31T22:16:45.329Z","has_ordered":true,"latest_purchase":"2014-08-08T08:45:35.199Z","has_newsletter":false,"groups":["ordered_once","reviewer"],"nb_commands":1,"total_spent":361.6},{"id":736,"first_name":"Kyle","last_name":"Steele","email":"bot@tirifope.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a56f06f7f5a11fa3bdecb9dfe0564127.png","birthday":null,"first_seen":"2013-11-17T02:39:08.500Z","last_seen":"2016-07-17T21:49:04.217Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":737,"first_name":"Mina","last_name":"Higgins","email":"zuhtugo@zatzu.net","address":"660 Mujlu Ridge","zipcode":"98087","city":"Zarorhu","avatar":"https://robohash.org/4b2790eabe9a60c3f2785bb968d79dd6.png","birthday":"1995-01-20T08:47:31.944Z","first_seen":"2016-02-06T09:37:53.650Z","last_seen":"2016-10-28T02:03:47.200Z","has_ordered":true,"latest_purchase":"2016-10-25T06:27:42.062Z","has_newsletter":true,"groups":["ordered_once","regular"],"nb_commands":1,"total_spent":105.09},{"id":738,"first_name":"Lucille","last_name":"Thompson","email":"iciej@jepe.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1d2559d71f8dbc1f9be50e5ba6fbd4cd.png","birthday":null,"first_seen":"2016-05-21T03:00:03.934Z","last_seen":"2016-07-15T23:04:33.919Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":739,"first_name":"Seth","last_name":"Montgomery","email":"ro@ki.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/24adc7a1eb993e862017db071740ce68.png","birthday":null,"first_seen":"2015-12-22T19:45:00.171Z","last_seen":"2016-10-18T09:12:16.312Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":740,"first_name":"Jacob","last_name":"Boyd","email":"luadohas@muw.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/9a700b05ee175843eaf97acb8bc635b7.png","birthday":null,"first_seen":"2016-09-09T09:59:51.721Z","last_seen":"2016-11-06T20:04:45.614Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":741,"first_name":"Ricardo","last_name":"Valdez","email":"bazi@nafbubub.io","address":"222 Hukron Court","zipcode":"97991","city":"Cahcoop","avatar":"https://robohash.org/6e85d9dcf65ffa69544db9f6637f087a.png","birthday":"1988-08-16T09:44:10.846Z","first_seen":"2016-02-25T15:14:10.394Z","last_seen":"2016-11-27T20:53:44.058Z","has_ordered":true,"latest_purchase":"2016-10-11T02:46:25.517Z","has_newsletter":false,"groups":[],"nb_commands":4,"total_spent":630.6800000000001},{"id":742,"first_name":"Caroline","last_name":"Mendez","email":"asnosfip@tonev.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d606c6b264a8e1e914dd5457f5dc41ad.png","birthday":null,"first_seen":"2015-12-29T20:53:09.223Z","last_seen":"2016-09-20T19:24:53.911Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":743,"first_name":"Derek","last_name":"Flores","email":"bin@vadma.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/596050cc67502af355d9329b7ef2a89c.png","birthday":null,"first_seen":"2016-02-06T22:44:18.881Z","last_seen":"2016-03-18T18:01:29.616Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":744,"first_name":"Pearl","last_name":"Nguyen","email":"welenwah@ameeranap.io","address":"1544 Pefeno Point","zipcode":"26277","city":"Irgihet","avatar":"https://robohash.org/7e314756b6493e917462dcd62daf0989.png","birthday":"1975-03-29T01:18:43.518Z","first_seen":"2016-05-17T00:58:07.491Z","last_seen":"2016-12-08T11:03:39.618Z","has_ordered":true,"latest_purchase":"2016-12-01T03:05:02.293Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":2,"total_spent":487.78},{"id":745,"first_name":"Johnny","last_name":"Zimmerman","email":"zu@wi.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e72eef64cadd890023851a654c919945.png","birthday":null,"first_seen":"2016-03-02T02:05:58.724Z","last_seen":"2016-07-28T12:50:00.063Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":746,"first_name":"Ivan","last_name":"Powell","email":"du@jamahzo.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a1ade2954996bd7c2ce5e56b3b1974d9.png","birthday":null,"first_seen":"2014-02-11T03:14:21.780Z","last_seen":"2016-10-25T03:58:25.097Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":747,"first_name":"Elnora","last_name":"Watkins","email":"geg@ipri.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/21c301a888cb5ee875fdd86c4b7df962.png","birthday":null,"first_seen":"2015-02-02T01:49:15.191Z","last_seen":"2016-07-22T23:12:45.366Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":748,"first_name":"Helena","last_name":"Copeland","email":"fuminwuv@buglu.edu","address":"181 Cawle Park","zipcode":"41331","city":"Etoreman","avatar":"https://robohash.org/2555b563e265794ac0a4d3a95a5631c6.png","birthday":"1974-02-17T10:16:21.504Z","first_seen":"2015-04-22T12:32:12.916Z","last_seen":"2015-12-01T09:33:03.306Z","has_ordered":true,"latest_purchase":"2015-10-15T11:28:22.101Z","has_newsletter":false,"groups":["regular","reviewer"],"nb_commands":2,"total_spent":680.1700000000001},{"id":749,"first_name":"Angel","last_name":"Rowe","email":"bupvuli@lofop.gov","address":"591 Vepgum Highway","zipcode":"60342","city":"Giwihgu","avatar":"https://robohash.org/ac7586d8f0aa8abf604b666bf9fcf413.png","birthday":"1983-02-19T01:45:05.490Z","first_seen":"2013-11-10T20:37:35.630Z","last_seen":"2015-07-02T05:18:25.048Z","has_ordered":true,"latest_purchase":null,"has_newsletter":false,"groups":[],"nb_commands":0,"total_spent":0},{"id":750,"first_name":"Rebecca","last_name":"Wise","email":"re@jac.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6854a795da550d0bec8b6cbfdd7a8bc9.png","birthday":null,"first_seen":"2016-09-19T10:27:20.401Z","last_seen":"2016-11-08T00:56:12.839Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":751,"first_name":"Luke","last_name":"Patton","email":"botgor@set.net","address":"617 Kibto Avenue","zipcode":"89558","city":"Viwrileg","avatar":"https://robohash.org/113b4d0d0c454b97fa55599ee42ed51a.png","birthday":"1989-10-15T03:07:55.524Z","first_seen":"2015-10-11T06:05:22.803Z","last_seen":"2016-12-15T22:49:38.662Z","has_ordered":true,"latest_purchase":null,"has_newsletter":false,"groups":[],"nb_commands":0,"total_spent":0},{"id":752,"first_name":"Ricardo","last_name":"Wolfe","email":"acara@rogewaz.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fe0cb87464ae8cb08ed51b7bf4d22563.png","birthday":null,"first_seen":"2015-12-17T05:31:59.892Z","last_seen":"2016-11-27T02:21:02.017Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":753,"first_name":"Madge","last_name":"Dean","email":"fe@bu.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/14893514672cd23a44d3f64c78e82e30.png","birthday":null,"first_seen":"2016-10-05T01:23:15.672Z","last_seen":"2016-10-29T08:46:28.019Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":754,"first_name":"Nora","last_name":"Bass","email":"beb@perazajut.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/af0945d96346cace725e4fff63c83975.png","birthday":null,"first_seen":"2014-08-05T12:28:41.086Z","last_seen":"2015-12-04T14:48:20.265Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":755,"first_name":"Ida","last_name":"Guzman","email":"el@bu.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e37aa8944a6427a882d7f371d1a5a6ae.png","birthday":null,"first_seen":"2016-12-02T21:04:30.113Z","last_seen":"2016-12-27T20:59:28.515Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":756,"first_name":"Cody","last_name":"Brooks","email":"mu@has.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f1455d2e53180342be19fc12bbce4006.png","birthday":null,"first_seen":"2014-06-21T09:45:30.945Z","last_seen":"2014-12-09T15:10:59.168Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":757,"first_name":"Kevin","last_name":"Bell","email":"je@moner.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/60218f1a5cfdd78ca194c8930582991c.png","birthday":null,"first_seen":"2015-06-24T03:42:28.715Z","last_seen":"2016-04-28T03:34:29.562Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":758,"first_name":"Lucille","last_name":"Carter","email":"juvmet@pag.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/86d4b65903abe6b8ceaa466877576897.png","birthday":null,"first_seen":"2015-09-02T19:13:26.287Z","last_seen":"2016-11-16T23:08:26.945Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":759,"first_name":"Don","last_name":"May","email":"mi@ca.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/710c230b167da1c624b0f936ab9a0104.png","birthday":null,"first_seen":"2016-12-05T09:56:27.417Z","last_seen":"2016-12-26T13:16:06.887Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":760,"first_name":"Mittie","last_name":"Hart","email":"fohejasu@ru.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/eb9821e9172be9b003d36cba2e536177.png","birthday":null,"first_seen":"2014-09-26T00:48:48.907Z","last_seen":"2016-11-20T11:05:13.091Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":761,"first_name":"Charles","last_name":"Coleman","email":"golowe@leclocu.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/995e4839334cdae07942a562ff93281c.png","birthday":null,"first_seen":"2014-04-05T07:30:19.331Z","last_seen":"2016-07-04T09:58:33.951Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":762,"first_name":"Hallie","last_name":"Casey","email":"hijacaha@wobogoc.co.uk","address":"1344 Hiras Parkway","zipcode":"25300","city":"Kodgovu","avatar":"https://robohash.org/162ed6c6222dc4b48afba68ec6e5cc96.png","birthday":"1962-08-30T05:22:05.152Z","first_seen":"2015-09-30T13:27:25.165Z","last_seen":"2016-12-09T00:54:39.041Z","has_ordered":true,"latest_purchase":"2016-11-12T08:09:29.268Z","has_newsletter":false,"groups":["collector","compulsive","reviewer"],"nb_commands":3,"total_spent":1794.62},{"id":763,"first_name":"Daisy","last_name":"Malone","email":"ag@kanido.edu","address":"1679 Natsa Loop","zipcode":"25946","city":"Teedioc","avatar":"https://robohash.org/c626bfd5b29cfadae439e74559d9fe4f.png","birthday":"1964-08-22T09:20:50.669Z","first_seen":"2015-05-07T15:55:39.792Z","last_seen":"2016-08-29T15:10:24.454Z","has_ordered":true,"latest_purchase":"2016-07-19T01:11:05.729Z","has_newsletter":true,"groups":["reviewer"],"nb_commands":4,"total_spent":379.15000000000003},{"id":764,"first_name":"Lena","last_name":"Alexander","email":"fus@tumnam.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/914315abc720c0ad5d1b4ec831c3f46e.png","birthday":null,"first_seen":"2014-05-01T14:48:09.689Z","last_seen":"2015-06-19T03:06:03.631Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":765,"first_name":"Lura","last_name":"Bishop","email":"vih@iwgor.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/00f3ef57ebba264c232b5734d8798f15.png","birthday":null,"first_seen":"2015-08-17T14:58:24.585Z","last_seen":"2016-12-24T06:01:27.971Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":766,"first_name":"Pauline","last_name":"Norman","email":"id@idewez.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e59430d3fa5a6f82ec14b8c95891a27a.png","birthday":null,"first_seen":"2015-02-16T08:26:35.932Z","last_seen":"2016-01-03T00:23:27.417Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":767,"first_name":"Mildred","last_name":"Ingram","email":"hahemsu@korniwazi.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c4f46cd2fd4a94822445914ac8c93d83.png","birthday":null,"first_seen":"2013-07-25T11:50:08.322Z","last_seen":"2016-07-11T23:13:18.471Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":768,"first_name":"Lottie","last_name":"Mathis","email":"lavzon@it.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/00c27d7f081ac26f42828166cc2a60e8.png","birthday":null,"first_seen":"2014-05-01T05:10:21.963Z","last_seen":"2016-01-01T13:54:20.082Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":769,"first_name":"Jayden","last_name":"Maxwell","email":"rid@zogi.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fb9e683f889fc132121e5baf3f9d6242.png","birthday":null,"first_seen":"2013-09-14T19:43:58.565Z","last_seen":"2014-04-10T22:10:21.225Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":770,"first_name":"Don","last_name":"Schmidt","email":"puhojod@usoazuruv.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/6c0daaf960c88097d60845163d28e58a.png","birthday":null,"first_seen":"2013-10-12T06:44:04.524Z","last_seen":"2016-07-30T07:57:47.001Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":771,"first_name":"Herman","last_name":"Stevens","email":"da@ma.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d01ea15fb207b00f5622e19db9448f5f.png","birthday":null,"first_seen":"2016-11-11T03:53:27.223Z","last_seen":"2016-12-24T02:32:59.863Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":772,"first_name":"Lottie","last_name":"Cain","email":"ja@kagcojzu.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/db58266f20e7de8c11f46396383d8f60.png","birthday":null,"first_seen":"2015-03-18T21:26:25.696Z","last_seen":"2015-11-22T23:12:34.646Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":773,"first_name":"Katherine","last_name":"Tucker","email":"few@ola.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f06216529e28af54e45c5ff112b2bb0a.png","birthday":null,"first_seen":"2015-03-04T12:01:59.527Z","last_seen":"2015-05-15T01:09:32.084Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":774,"first_name":"Rosie","last_name":"Logan","email":"fa@vo.co.uk","address":"1752 Ikca Loop","zipcode":"05140","city":"Zanuruh","avatar":"https://robohash.org/b4407ef4e5b2b6984db7c60d7aff5c52.png","birthday":"1973-06-27T08:46:28.319Z","first_seen":"2016-05-16T18:42:50.379Z","last_seen":"2017-01-01T18:17:07.783Z","has_ordered":true,"latest_purchase":"2016-12-21T17:15:27.904Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":316.29},{"id":775,"first_name":"Steven","last_name":"Jackson","email":"ijeebha@mo.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/81b94bb992e36b6a686a4116b59415d7.png","birthday":null,"first_seen":"2014-08-12T11:06:14.940Z","last_seen":"2016-05-12T08:51:38.997Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":776,"first_name":"Minnie","last_name":"West","email":"mad@revpi.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f0cbb52a932b96d00a1bc57c1bbebb5c.png","birthday":null,"first_seen":"2016-09-10T19:18:34.916Z","last_seen":"2016-11-06T18:32:42.038Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":777,"first_name":"Caroline","last_name":"Carpenter","email":"rasaz@govla.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0583f37b804f823602bf30b69bb53f31.png","birthday":null,"first_seen":"2015-08-04T00:23:10.371Z","last_seen":"2016-03-12T19:43:11.501Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":778,"first_name":"Lloyd","last_name":"Butler","email":"mom@ravkumpad.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/aa938de68b1ea3258be42e83e5cb17fd.png","birthday":null,"first_seen":"2012-08-24T14:19:37.937Z","last_seen":"2013-06-07T13:50:22.254Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":779,"first_name":"Ora","last_name":"Floyd","email":"olivuuda@obeop.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8fcece5a433cf490d8debbe0718a2d6e.png","birthday":null,"first_seen":"2015-04-14T12:04:02.334Z","last_seen":"2016-09-03T04:55:04.696Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":780,"first_name":"Esther","last_name":"Swanson","email":"leb@zatlair.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/891b2fe640ceda73868e453ef74c2a6b.png","birthday":null,"first_seen":"2014-05-01T15:48:45.900Z","last_seen":"2016-10-29T05:55:39.740Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":781,"first_name":"Nelle","last_name":"Klein","email":"miker@sobbe.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/742ee8e5fb2dc5fb751f1acd6a329cb1.png","birthday":null,"first_seen":"2016-12-13T11:03:27.382Z","last_seen":"2016-12-25T17:00:49.037Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":782,"first_name":"Linnie","last_name":"Page","email":"tuamgob@ihuwokli.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5639fe1f24ba5f4817799bb35f960c14.png","birthday":null,"first_seen":"2014-06-05T10:06:21.744Z","last_seen":"2015-02-04T20:26:33.682Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":783,"first_name":"Florence","last_name":"Evans","email":"jor@sec.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d146d82c7501dcabd49e8a14000beb1f.png","birthday":null,"first_seen":"2015-09-06T06:56:48.365Z","last_seen":"2016-10-02T21:47:16.519Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":784,"first_name":"Rachel","last_name":"Roberson","email":"nopvoz@wolgi.gov","address":"363 Rigu View","zipcode":"89732","city":"Bahoggek","avatar":"https://robohash.org/b1d1ba78066cad3a5e85482c9eb20815.png","birthday":"1968-12-21T00:24:20.277Z","first_seen":"2016-04-03T10:08:38.022Z","last_seen":"2016-09-09T01:00:04.894Z","has_ordered":true,"latest_purchase":"2016-08-22T19:11:21.081Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":464.88},{"id":785,"first_name":"Dennis","last_name":"Baldwin","email":"ges@nidgiso.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8eb588cad288cd124debc806bd384191.png","birthday":null,"first_seen":"2015-06-11T03:01:16.228Z","last_seen":"2016-11-19T05:24:59.790Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":786,"first_name":"Mamie","last_name":"Sherman","email":"rin@sucemev.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/166e30f85ee1b1448110fbaa17d32cb6.png","birthday":null,"first_seen":"2016-12-08T14:08:36.179Z","last_seen":"2016-12-25T08:28:34.797Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":787,"first_name":"Leon","last_name":"Baker","email":"lavemew@lew.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/24e6f955a10338272648f354d34f8a82.png","birthday":null,"first_seen":"2016-08-14T05:36:57.224Z","last_seen":"2016-10-27T08:43:25.427Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":788,"first_name":"Olive","last_name":"Greer","email":"po@vab.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/073a49f74320db8d2def4e2e007b2770.png","birthday":null,"first_seen":"2016-05-19T20:49:48.113Z","last_seen":"2016-12-25T13:47:31.059Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":789,"first_name":"Ellen","last_name":"Owen","email":"ure@tuada.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/49f9545b26eae3696d70d49dfde56500.png","birthday":null,"first_seen":"2015-06-21T11:17:31.430Z","last_seen":"2016-07-17T03:01:02.377Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":790,"first_name":"Matilda","last_name":"Johnston","email":"zov@wefege.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5b5803245be61fc58b1a13a18055e884.png","birthday":null,"first_seen":"2013-12-25T16:33:19.662Z","last_seen":"2016-07-30T09:25:35.555Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":791,"first_name":"Nathaniel","last_name":"Sanchez","email":"ab@gijuzjuw.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f3bdfa8459e91613a8be2dc8bbbc903e.png","birthday":null,"first_seen":"2015-02-18T12:08:34.027Z","last_seen":"2016-06-01T21:45:02.853Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":792,"first_name":"Derrick","last_name":"Lowe","email":"jefehwat@aha.edu","address":"1639 Zerik Circle","zipcode":"87720","city":"Voguuf","avatar":"https://robohash.org/02d410362c2eb3b76fc68e66acfcfc9c.png","birthday":"1955-02-20T10:56:56.596Z","first_seen":"2016-07-28T08:40:55.814Z","last_seen":"2016-10-30T06:02:55.670Z","has_ordered":true,"latest_purchase":"2016-10-16T05:08:50.510Z","has_newsletter":true,"groups":["collector","compulsive","reviewer"],"nb_commands":3,"total_spent":2360.71},{"id":793,"first_name":"Wesley","last_name":"Walters","email":"julvelmu@ritmad.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8a4a6b92798abc2a9e15cc78ecb6126c.png","birthday":null,"first_seen":"2016-12-08T17:07:02.618Z","last_seen":"2016-12-31T10:32:25.902Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":794,"first_name":"Seth","last_name":"Strickland","email":"vodpihasu@losa.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7cac26d5d35dac10ae7c15b97cb68e7f.png","birthday":null,"first_seen":"2016-01-20T00:52:37.208Z","last_seen":"2016-10-24T10:20:46.483Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":795,"first_name":"Andrew","last_name":"Cohen","email":"gahiv@pu.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1d6e262066f1e7eac0f57b64ac5ea19f.png","birthday":null,"first_seen":"2016-01-05T18:36:23.878Z","last_seen":"2016-11-12T09:31:11.024Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":796,"first_name":"Ralph","last_name":"Hudson","email":"di@le.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/9be06b80ae7405a88df12a4802e207d8.png","birthday":null,"first_seen":"2015-04-18T00:44:18.292Z","last_seen":"2016-03-14T22:23:36.178Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":797,"first_name":"John","last_name":"Klein","email":"ahrubli@cu.gov","address":"1283 Corwum Pass","zipcode":"22309","city":"Komwoja","avatar":"https://robohash.org/cb6de64f6b70d967226567817ffc6438.png","birthday":"1996-09-22T06:46:14.943Z","first_seen":"2014-02-15T19:07:20.968Z","last_seen":"2015-06-08T00:20:44.058Z","has_ordered":true,"latest_purchase":"2015-01-14T22:24:55.940Z","has_newsletter":true,"groups":["reviewer"],"nb_commands":2,"total_spent":590},{"id":798,"first_name":"Tom","last_name":"Carpenter","email":"pemo@he.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/94ead14749b68a755069507d23cd1eb5.png","birthday":null,"first_seen":"2016-11-15T14:08:10.758Z","last_seen":"2017-01-04T01:45:09.780Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":799,"first_name":"Jon","last_name":"James","email":"log@apidas.org","address":"492 Gaciw View","zipcode":"62474","city":"Ejaborri","avatar":"https://robohash.org/0eb89b1e9873e0954277066ac2eb3a6f.png","birthday":"1968-01-13T04:34:21.816Z","first_seen":"2013-08-06T21:46:19.417Z","last_seen":"2016-02-14T22:53:12.501Z","has_ordered":true,"latest_purchase":"2016-01-06T09:15:58.064Z","has_newsletter":false,"groups":["collector","reviewer"],"nb_commands":4,"total_spent":959.15},{"id":800,"first_name":"Margaret","last_name":"Wright","email":"sebihe@jifaha.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/548a6b771420f93e4636778cf7dde814.png","birthday":null,"first_seen":"2016-05-29T03:12:14.486Z","last_seen":"2016-11-23T07:01:59.149Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":801,"first_name":"Ola","last_name":"May","email":"bicim@nihpem.edu","address":"194 Sojim Point","zipcode":"18093","city":"Mozbejec","avatar":"https://robohash.org/0dd18ae834ca8b6bc189efdafeaa258d.png","birthday":"1999-03-28T03:46:49.614Z","first_seen":"2016-09-23T19:53:59.794Z","last_seen":"2016-11-07T08:11:33.132Z","has_ordered":true,"latest_purchase":"2016-11-05T17:14:10.479Z","has_newsletter":false,"groups":["collector","compulsive","returns","reviewer"],"nb_commands":7,"total_spent":1796.1599999999999},{"id":802,"first_name":"Mitchell","last_name":"Ramirez","email":"dod@jim.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c3d502e5a8c1f04eea03693d604d2736.png","birthday":null,"first_seen":"2016-06-21T07:55:12.745Z","last_seen":"2016-09-14T14:09:02.398Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":803,"first_name":"Alice","last_name":"Fuller","email":"upu@velu.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/056f5e37e28541826db9dcadeaadf768.png","birthday":null,"first_seen":"2012-09-14T13:05:08.417Z","last_seen":"2016-05-25T06:51:34.690Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":804,"first_name":"Duane","last_name":"Vaughn","email":"pofbevham@fojmek.org","address":"1199 Lemsuw Key","zipcode":"14593","city":"Tatbuvi","avatar":"https://robohash.org/1869db3d4631b2370d702be22d5d4e51.png","birthday":"1989-05-08T00:47:32.954Z","first_seen":"2015-09-03T15:57:48.110Z","last_seen":"2016-12-27T01:30:39.729Z","has_ordered":true,"latest_purchase":"2016-12-04T07:12:54.723Z","has_newsletter":false,"groups":["returns"],"nb_commands":3,"total_spent":119.11},{"id":805,"first_name":"Eleanor","last_name":"Warren","email":"hipgoat@tudbu.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/496fd7e22695682bfa1deac0c9f8a760.png","birthday":null,"first_seen":"2016-06-03T06:42:11.935Z","last_seen":"2016-12-14T00:36:15.092Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":806,"first_name":"Justin","last_name":"Rogers","email":"jolihhid@inu.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3774fff6de62a0b1411ee45f5c103cbf.png","birthday":null,"first_seen":"2016-10-17T05:15:26.588Z","last_seen":"2016-11-06T18:08:51.946Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":807,"first_name":"Cameron","last_name":"Hawkins","email":"feb@vu.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/13de39c9200940b1dda033ca6403ecbf.png","birthday":null,"first_seen":"2016-06-17T15:44:23.410Z","last_seen":"2016-08-06T07:07:20.029Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":808,"first_name":"Douglas","last_name":"Reynolds","email":"hub@dummafkek.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/bf62e49ad93cc93a13886df024c40118.png","birthday":null,"first_seen":"2016-03-23T18:20:38.164Z","last_seen":"2016-09-02T22:35:03.754Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":809,"first_name":"Nelle","last_name":"Berry","email":"bigibav@tuvpejev.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/caad13dc77bb7b00334c21e32b4bf936.png","birthday":null,"first_seen":"2014-12-22T03:09:42.113Z","last_seen":"2016-06-25T21:56:08.020Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":810,"first_name":"Isaac","last_name":"Cummings","email":"oci@cu.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7670979dfafb7b9a376249328ce699f1.png","birthday":null,"first_seen":"2015-11-27T22:49:21.639Z","last_seen":"2016-09-27T08:28:58.796Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":811,"first_name":"Bernard","last_name":"Brewer","email":"cipenkup@os.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/fa34c7fe245b198b495f6ce99dd63e1d.png","birthday":null,"first_seen":"2016-05-06T09:46:58.638Z","last_seen":"2016-08-13T00:47:15.123Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":812,"first_name":"Rosa","last_name":"Barber","email":"coru@lejpagmom.org","address":"1735 Teegu Trail","zipcode":"16812","city":"Waoguloz","avatar":"https://robohash.org/a641e94886194911b0f1cd4b73e80de7.png","birthday":"1975-12-18T00:26:18.608Z","first_seen":"2014-02-12T08:35:51.218Z","last_seen":"2016-10-01T20:08:38.660Z","has_ordered":true,"latest_purchase":null,"has_newsletter":false,"groups":[],"nb_commands":0,"total_spent":0},{"id":813,"first_name":"Gavin","last_name":"Shelton","email":"dif@bopwu.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1642b29ef7c042b3c862f3627022dc0c.png","birthday":null,"first_seen":"2016-07-20T11:36:33.839Z","last_seen":"2016-12-18T09:56:30.556Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":814,"first_name":"Bertie","last_name":"Lambert","email":"hofipaw@dujlug.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/86e6a717fac7b429ca71b80e5065e04e.png","birthday":null,"first_seen":"2015-10-05T15:44:48.889Z","last_seen":"2016-05-23T02:31:29.426Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":815,"first_name":"Mason","last_name":"Glover","email":"tajol@ril.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8ce3ea5a3d4f6653705b4c04657422b9.png","birthday":null,"first_seen":"2014-02-11T10:08:48.380Z","last_seen":"2016-04-06T01:45:18.584Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":816,"first_name":"Rodney","last_name":"Mendoza","email":"rulezlim@zi.io","address":"956 Oninom Extension","zipcode":"74782","city":"Fopavkib","avatar":"https://robohash.org/457ca1ff11c2f5bbd106ec7b0470b5ed.png","birthday":"1966-03-21T10:02:31.992Z","first_seen":"2015-08-06T21:42:32.248Z","last_seen":"2016-06-20T04:34:12.029Z","has_ordered":true,"latest_purchase":"2016-05-07T14:22:28.800Z","has_newsletter":false,"groups":[],"nb_commands":2,"total_spent":459.97},{"id":817,"first_name":"Derrick","last_name":"Gray","email":"belrobjec@sewwus.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c0795b9bca587100628d5df6d3f6dfa0.png","birthday":null,"first_seen":"2015-01-06T15:29:21.894Z","last_seen":"2017-01-02T03:20:34.860Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":818,"first_name":"Harold","last_name":"Quinn","email":"wogeho@suhri.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/8afb28c21c971440e5e0ae5899acaa2f.png","birthday":null,"first_seen":"2015-03-18T19:19:59.227Z","last_seen":"2016-08-06T23:32:39.190Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":819,"first_name":"Lottie","last_name":"Warren","email":"odo@bat.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ac3241974cbdedd470b918cde34fe8b5.png","birthday":null,"first_seen":"2015-10-07T11:57:10.193Z","last_seen":"2016-11-27T23:02:06.530Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":820,"first_name":"Theodore","last_name":"Keller","email":"sumvo@salpovo.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/452a4e59b7bc7c1ef162e676169aceff.png","birthday":null,"first_seen":"2015-11-09T07:40:52.813Z","last_seen":"2016-08-11T18:57:14.196Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":821,"first_name":"Mollie","last_name":"Palmer","email":"agve@ocesejde.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c7c86474af9b189089c6616bee59c339.png","birthday":null,"first_seen":"2015-07-27T12:21:03.261Z","last_seen":"2016-09-22T04:37:38.581Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":822,"first_name":"Aaron","last_name":"Bailey","email":"ke@cel.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b6bfb3f8374d5361fbc569cacb4330c1.png","birthday":null,"first_seen":"2015-06-27T20:22:21.189Z","last_seen":"2016-09-22T20:45:05.347Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":823,"first_name":"Chris","last_name":"Ford","email":"wiltocal@rithof.com","address":"770 Jeso Mill","zipcode":"63977","city":"Cucejvow","avatar":"https://robohash.org/6f953a1ad8145459ac90730b8b962970.png","birthday":"1961-08-22T04:38:00.017Z","first_seen":"2014-01-29T06:22:56.324Z","last_seen":"2016-03-17T13:12:28.045Z","has_ordered":true,"latest_purchase":"2016-03-01T19:24:06.908Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":2,"total_spent":400.78},{"id":824,"first_name":"Harvey","last_name":"Stephens","email":"tobom@epvaw.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/bb37021d994fee8ebe7a44d18a1cfe78.png","birthday":null,"first_seen":"2015-05-31T18:33:44.539Z","last_seen":"2016-03-26T14:59:09.938Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":825,"first_name":"Etta","last_name":"Atkins","email":"saz@wife.net","address":"1150 Mabo Pike","zipcode":"29902","city":"Femine","avatar":"https://robohash.org/4b1044f57a9ab10222dce9ebd76b6041.png","birthday":"1958-12-19T07:44:08.968Z","first_seen":"2013-02-13T22:20:37.246Z","last_seen":"2016-03-15T21:32:33.239Z","has_ordered":true,"latest_purchase":"2015-11-08T05:37:53.829Z","has_newsletter":true,"groups":["reviewer"],"nb_commands":2,"total_spent":283.44},{"id":826,"first_name":"Glen","last_name":"Benson","email":"zapapopo@targipel.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2a4d00d13d183fb5b61b3c7f480293be.png","birthday":null,"first_seen":"2014-11-15T22:30:42.033Z","last_seen":"2016-10-25T18:26:04.673Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":827,"first_name":"Isaac","last_name":"Garrett","email":"deol@coba.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/7164d237dbb1e1083121df334978abfc.png","birthday":null,"first_seen":"2014-06-13T06:31:46.796Z","last_seen":"2016-04-26T23:00:54.475Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":828,"first_name":"Augusta","last_name":"Murray","email":"goawmi@vaja.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/73102b9b234ba3dc7cb932966a52f7e0.png","birthday":null,"first_seen":"2014-01-25T01:34:48.694Z","last_seen":"2016-10-08T15:59:49.567Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":829,"first_name":"Jessie","last_name":"Coleman","email":"dis@maluj.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/769bbed3061d895fbcd07d6707fb4e31.png","birthday":null,"first_seen":"2016-02-28T04:41:35.694Z","last_seen":"2016-11-06T12:41:20.423Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":830,"first_name":"Fred","last_name":"Clarke","email":"virto@kam.edu","address":"586 Otilo Extension","zipcode":"81555","city":"Kojjomfa","avatar":"https://robohash.org/4dd8681be1cae38654e166c1fb886b63.png","birthday":"1983-10-15T00:22:02.294Z","first_seen":"2016-12-02T00:09:46.070Z","last_seen":"2016-12-12T12:23:01.782Z","has_ordered":true,"latest_purchase":"2016-12-11T12:48:36.947Z","has_newsletter":false,"groups":["collector","reviewer"],"nb_commands":3,"total_spent":1232.33},{"id":831,"first_name":"Norman","last_name":"Rogers","email":"fohwef@kanmenac.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/25c312525b2e7627cd87fee8800c9e8a.png","birthday":null,"first_seen":"2014-11-28T08:47:34.058Z","last_seen":"2016-05-17T13:58:19.146Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":832,"first_name":"Elsie","last_name":"Burton","email":"epivekzi@erisiwi.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/9dfeea11dca10e03ecf3de20b488d859.png","birthday":null,"first_seen":"2014-03-24T19:43:10.914Z","last_seen":"2016-02-20T02:20:12.973Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":833,"first_name":"Edna","last_name":"Rice","email":"tolrezuz@unam.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/46dce83e92a9f625cec99f00cc63a30e.png","birthday":null,"first_seen":"2014-01-18T04:10:54.815Z","last_seen":"2014-07-18T19:06:46.518Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":834,"first_name":"Claudia","last_name":"Houston","email":"liram@saocu.co.uk","address":"1045 Corka Lane","zipcode":"32348","city":"Regovuw","avatar":"https://robohash.org/56ff24e310f52a3efb3b50f1f9bd2969.png","birthday":"1999-02-16T11:07:37.874Z","first_seen":"2015-07-04T03:12:18.210Z","last_seen":"2016-07-01T23:43:28.644Z","has_ordered":true,"latest_purchase":"2015-10-14T18:55:31.454Z","has_newsletter":true,"groups":["ordered_once","reviewer"],"nb_commands":1,"total_spent":857.32},{"id":835,"first_name":"Ruth","last_name":"Simpson","email":"ahu@avnam.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/1e64df3f36b848c312ff3f13af67759a.png","birthday":null,"first_seen":"2015-09-12T18:24:26.680Z","last_seen":"2016-01-22T01:39:05.671Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":836,"first_name":"Paul","last_name":"Daniel","email":"vootfit@sareshas.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/96447737d6fa97a9231c2089fa706fac.png","birthday":null,"first_seen":"2014-09-17T17:32:50.361Z","last_seen":"2015-10-18T10:26:38.813Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":837,"first_name":"Bernard","last_name":"Weaver","email":"ce@nehi.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e6a8d7061962e2e77a954126a622e315.png","birthday":null,"first_seen":"2016-09-19T16:13:17.543Z","last_seen":"2016-12-21T07:12:39.450Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":838,"first_name":"James","last_name":"Cobb","email":"neeh@amabge.org","address":"681 Funeg Point","zipcode":"64335","city":"Hivozab","avatar":"https://robohash.org/6b705d4ca9fa8bb7e03c4d325f782fb3.png","birthday":"1966-08-10T00:06:01.780Z","first_seen":"2016-04-24T15:26:14.956Z","last_seen":"2016-12-22T09:21:27.144Z","has_ordered":true,"latest_purchase":"2016-10-30T03:07:28.032Z","has_newsletter":true,"groups":["ordered_once"],"nb_commands":1,"total_spent":216.71},{"id":839,"first_name":"Etta","last_name":"Caldwell","email":"ke@mus.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f674254d1732256e92d1d6011c08fade.png","birthday":null,"first_seen":"2016-10-29T17:50:36.846Z","last_seen":"2016-12-04T00:42:35.409Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":840,"first_name":"Antonio","last_name":"Powell","email":"zomicluh@julzas.net","address":"237 Uleca Key","zipcode":"42982","city":"Jetise","avatar":"https://robohash.org/d51b01d9cebdb4dcd91e5420f5b442b9.png","birthday":"1964-09-09T08:31:13.549Z","first_seen":"2016-08-13T05:47:25.846Z","last_seen":"2016-12-29T00:51:45.573Z","has_ordered":true,"latest_purchase":"2016-12-28T13:06:38.409Z","has_newsletter":false,"groups":["returns"],"nb_commands":3,"total_spent":410.59999999999997},{"id":841,"first_name":"Shane","last_name":"Ellis","email":"us@gov.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/88a8667a8cf5d764b3e4ede5710283e3.png","birthday":null,"first_seen":"2016-02-13T04:59:03.977Z","last_seen":"2016-04-03T12:07:10.294Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":842,"first_name":"Derrick","last_name":"Ingram","email":"vol@givli.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0918955e59d86e9c5900280825b9379e.png","birthday":null,"first_seen":"2016-06-14T02:07:13.000Z","last_seen":"2016-08-17T01:32:13.387Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":843,"first_name":"Jeffrey","last_name":"Poole","email":"avofepev@gurehe.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/339c009e0f41329f21407cf58401f628.png","birthday":null,"first_seen":"2013-12-10T02:27:37.574Z","last_seen":"2016-06-10T09:49:53.021Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":844,"first_name":"Mamie","last_name":"Day","email":"se@ge.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4da022b130bd0e7e2654d95217534b16.png","birthday":null,"first_seen":"2014-10-29T06:44:42.715Z","last_seen":"2016-01-15T22:23:26.553Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":845,"first_name":"Ruth","last_name":"Baker","email":"ejoahhis@det.gov","address":"756 Hatcut Extension","zipcode":"96703","city":"Rokarram","avatar":"https://robohash.org/be6526514dc3c8e6b8a2c38da1a10e98.png","birthday":"1974-05-01T06:02:41.236Z","first_seen":"2014-05-04T07:11:48.259Z","last_seen":"2016-02-23T07:15:34.266Z","has_ordered":true,"latest_purchase":"2016-01-08T03:42:07.274Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":4,"total_spent":485.78},{"id":846,"first_name":"Mildred","last_name":"Casey","email":"vul@onuwusin.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/133da9adfb98c5ce3aaab5961d237234.png","birthday":null,"first_seen":"2015-01-20T00:13:47.107Z","last_seen":"2015-07-29T21:31:46.073Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":847,"first_name":"Carrie","last_name":"Bennett","email":"sahumi@daon.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/40ee761472b6eeffdb3f4224dbfe2d50.png","birthday":null,"first_seen":"2015-02-19T02:55:24.561Z","last_seen":"2016-01-26T17:27:35.043Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":848,"first_name":"Roger","last_name":"Davidson","email":"ozuku@tod.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c38339b1bc89a91f402eb83bb14364f1.png","birthday":null,"first_seen":"2015-04-10T22:56:20.580Z","last_seen":"2016-10-21T16:57:48.070Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":849,"first_name":"Lola","last_name":"Wilkins","email":"kevgibif@fiahnuf.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ed57455999b8cd6e15f0099af99eb94b.png","birthday":null,"first_seen":"2016-07-19T22:27:24.878Z","last_seen":"2016-08-23T23:03:21.010Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":850,"first_name":"Genevieve","last_name":"Austin","email":"ebi@udeegsa.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c46d09351a18ce5686c5c4467d49093f.png","birthday":null,"first_seen":"2016-04-14T06:52:03.959Z","last_seen":"2016-10-13T08:57:18.614Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":851,"first_name":"Franklin","last_name":"Herrera","email":"sa@gios.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/cc4d036afdee23729a396dbef16e6412.png","birthday":null,"first_seen":"2016-09-03T05:57:13.211Z","last_seen":"2016-12-03T01:45:50.518Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":852,"first_name":"Minerva","last_name":"Romero","email":"evija@av.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c4d6fc20689a1197598c200c95c7d671.png","birthday":null,"first_seen":"2015-06-08T13:00:06.770Z","last_seen":"2016-02-04T17:35:57.281Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":853,"first_name":"Peter","last_name":"Hernandez","email":"zecgej@gozveswot.gov","address":"1033 Fukod Key","zipcode":"51448","city":"Haahul","avatar":"https://robohash.org/f64d60092aa9fc0410b97f600284b8ee.png","birthday":"1974-11-27T09:37:43.050Z","first_seen":"2015-09-13T01:51:57.957Z","last_seen":"2016-01-26T19:05:55.550Z","has_ordered":true,"latest_purchase":"2016-01-21T15:32:59.749Z","has_newsletter":false,"groups":[],"nb_commands":4,"total_spent":528.24},{"id":854,"first_name":"Violet","last_name":"Goodman","email":"apnetus@suj.co.uk","address":"190 Ijwuz Glen","zipcode":"33289","city":"Nuupeune","avatar":"https://robohash.org/a3818d954eb1aa95c828cb2000cd3d7c.png","birthday":"1962-05-09T04:15:13.407Z","first_seen":"2014-04-25T10:34:00.630Z","last_seen":"2015-02-10T05:04:01.383Z","has_ordered":true,"latest_purchase":"2014-12-24T17:27:59.291Z","has_newsletter":true,"groups":["reviewer"],"nb_commands":2,"total_spent":354.3},{"id":855,"first_name":"Olga","last_name":"James","email":"kegik@bozat.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/a87a27fb1207d2df2863867a567fa1f3.png","birthday":null,"first_seen":"2015-06-15T05:57:27.463Z","last_seen":"2015-08-30T11:48:06.973Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":856,"first_name":"Emily","last_name":"Stephens","email":"ite@bej.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/440278879383ac80c036b04bd485ae54.png","birthday":null,"first_seen":"2015-07-16T18:01:14.503Z","last_seen":"2016-01-08T02:49:03.528Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":857,"first_name":"Dora","last_name":"Davidson","email":"la@heciv.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/3288b27f2a9183d60b2d12281ca28673.png","birthday":null,"first_seen":"2016-02-21T03:18:24.766Z","last_seen":"2016-12-01T22:28:49.529Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":858,"first_name":"Celia","last_name":"Miles","email":"ku@oto.edu","address":"1884 Puel Plaza","zipcode":"95864","city":"Neteoge","avatar":"https://robohash.org/4a80057ffa7c9d3ba1b5bafc586b1133.png","birthday":"1992-08-12T08:13:47.364Z","first_seen":"2016-07-13T23:09:30.011Z","last_seen":"2017-01-04T15:25:18.973Z","has_ordered":true,"latest_purchase":"2016-12-04T08:38:48.657Z","has_newsletter":false,"groups":[],"nb_commands":2,"total_spent":432.90000000000003},{"id":859,"first_name":"Esther","last_name":"Rivera","email":"apa@nas.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/92b910922df067fd53448298a79b8e60.png","birthday":null,"first_seen":"2016-10-19T04:33:24.481Z","last_seen":"2016-11-21T13:57:15.747Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":860,"first_name":"Eleanor","last_name":"Fox","email":"gibuknu@ogepesvu.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ae12e063abd4bd9a1a1ad94b57ed7644.png","birthday":null,"first_seen":"2016-07-26T18:42:10.730Z","last_seen":"2016-10-08T12:24:22.885Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":861,"first_name":"Jackson","last_name":"Cruz","email":"suer@ved.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f21c17828b614b94faee468b41180db8.png","birthday":null,"first_seen":"2015-11-22T21:43:48.101Z","last_seen":"2016-02-20T23:17:38.939Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":862,"first_name":"Bernard","last_name":"Hampton","email":"wevewic@zi.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/59e4a6c46e9d983a84fd39513155d9f1.png","birthday":null,"first_seen":"2016-10-30T12:19:46.796Z","last_seen":"2017-01-05T13:35:55.416Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":863,"first_name":"Emma","last_name":"Jordan","email":"simob@gupebce.edu","address":"1382 Heolu Circle","zipcode":"47517","city":"Ziobunu","avatar":"https://robohash.org/f5162a12e790c81498ae4dd292461c7f.png","birthday":"1982-08-27T01:44:24.457Z","first_seen":"2015-08-18T05:43:03.877Z","last_seen":"2016-08-18T13:19:46.349Z","has_ordered":true,"latest_purchase":"2016-07-28T20:28:02.872Z","has_newsletter":true,"groups":["returns","reviewer"],"nb_commands":5,"total_spent":562.09},{"id":864,"first_name":"Kevin","last_name":"Owens","email":"uvaje@sa.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e974169c868b20a41648a170317db077.png","birthday":null,"first_seen":"2014-02-16T10:31:18.241Z","last_seen":"2015-05-29T11:12:22.875Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":865,"first_name":"Beulah","last_name":"Cruz","email":"wobpooh@votul.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/36cbbb1075b1517892d0800896f35e75.png","birthday":null,"first_seen":"2014-07-10T17:00:56.070Z","last_seen":"2015-04-27T16:21:45.152Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":866,"first_name":"Jackson","last_name":"Herrera","email":"dola@uksur.net","address":"380 Batzow Path","zipcode":"94273","city":"Pubwavim","avatar":"https://robohash.org/8cc988df71cc918d7c8a711947c9c9c3.png","birthday":"1991-06-05T08:06:07.476Z","first_seen":"2014-03-05T21:56:37.133Z","last_seen":"2016-03-18T09:06:06.588Z","has_ordered":true,"latest_purchase":"2015-12-06T04:55:49.686Z","has_newsletter":true,"groups":["collector","regular","reviewer"],"nb_commands":4,"total_spent":1315.5},{"id":867,"first_name":"Jared","last_name":"Burgess","email":"wik@caasurap.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/258aeed315d1d058dd54b822e630ce00.png","birthday":null,"first_seen":"2013-02-28T02:31:04.209Z","last_seen":"2014-07-26T17:47:02.909Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":868,"first_name":"Travis","last_name":"Wheeler","email":"sivece@faaseon.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/cf1541d084126c3267fe1be7368c2124.png","birthday":null,"first_seen":"2015-01-15T14:17:08.019Z","last_seen":"2016-05-28T00:26:07.513Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":869,"first_name":"Lelia","last_name":"McDaniel","email":"dojtu@sif.edu","address":"1279 Deed Key","zipcode":"30307","city":"Begefuv","avatar":"https://robohash.org/2f70afa508b3a18fe6312d00d00efda0.png","birthday":"1995-02-15T09:08:01.797Z","first_seen":"2014-10-21T14:34:27.865Z","last_seen":"2016-04-04T17:10:53.987Z","has_ordered":true,"latest_purchase":"2015-12-31T01:03:18.963Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":3,"total_spent":1053.8400000000001},{"id":870,"first_name":"Hallie","last_name":"Lopez","email":"cidlafsij@ozdi.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/0cbc59e835aa7801232896d8d251544f.png","birthday":null,"first_seen":"2015-10-15T08:37:23.113Z","last_seen":"2016-11-10T07:56:48.743Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":871,"first_name":"Jonathan","last_name":"Harmon","email":"zizki@ti.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/085f271c2e00b35a010c91edff508b78.png","birthday":null,"first_seen":"2015-03-17T22:39:29.602Z","last_seen":"2016-06-27T06:21:49.218Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":872,"first_name":"Victor","last_name":"Gilbert","email":"fisdiz@jojusem.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/58d22901d0da3c9525b45f298c2729a7.png","birthday":null,"first_seen":"2014-04-04T20:36:13.742Z","last_seen":"2016-05-29T17:39:54.350Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":873,"first_name":"Betty","last_name":"Barton","email":"ivoupuve@bibuek.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/23e365bed398d34ce6becef691cd7d5c.png","birthday":null,"first_seen":"2016-06-21T09:39:23.329Z","last_seen":"2016-11-04T09:34:17.068Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":874,"first_name":"Ruby","last_name":"Summers","email":"fak@rehuil.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/874fbc467c05eb0e8aefe25f271fb7a0.png","birthday":null,"first_seen":"2014-04-05T05:38:35.878Z","last_seen":"2014-05-11T11:31:27.969Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":875,"first_name":"Beulah","last_name":"Montgomery","email":"cuvur@sinu.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/aab85aa8942e245ac774a64188754915.png","birthday":null,"first_seen":"2016-11-13T01:20:56.631Z","last_seen":"2016-12-28T10:23:34.718Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":876,"first_name":"Grace","last_name":"Patrick","email":"zezek@uzogi.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/f97f808647f8e88e7efc9488df15fa42.png","birthday":null,"first_seen":"2013-03-30T07:00:42.060Z","last_seen":"2015-03-16T02:54:53.489Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":877,"first_name":"Blake","last_name":"Moran","email":"juwubiv@furoti.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4c361c0a8279616885f57cd293fcd647.png","birthday":null,"first_seen":"2014-03-22T20:21:56.988Z","last_seen":"2016-04-16T02:35:02.765Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":878,"first_name":"Viola","last_name":"Wade","email":"gapoweco@urwubof.io","address":"678 Hoosa Heights","zipcode":"65130","city":"Uzjeule","avatar":"https://robohash.org/953ab470c40697cc806f789320701251.png","birthday":"1965-12-21T06:37:45.547Z","first_seen":"2014-07-13T10:58:33.398Z","last_seen":"2016-08-11T20:22:25.779Z","has_ordered":true,"latest_purchase":"2016-05-28T04:00:18.635Z","has_newsletter":false,"groups":[],"nb_commands":3,"total_spent":596.4000000000001},{"id":879,"first_name":"Roger","last_name":"Cunningham","email":"pe@giznumo.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/2fc597f2d6e11856506745da6eb6aa50.png","birthday":null,"first_seen":"2016-02-03T17:54:33.231Z","last_seen":"2016-11-27T04:53:15.469Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":880,"first_name":"Katie","last_name":"Crawford","email":"it@hovul.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/ecaf3c31d53091370b2d5f3996e55d9c.png","birthday":null,"first_seen":"2015-01-19T04:38:42.989Z","last_seen":"2016-04-22T12:33:03.028Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":881,"first_name":"Leona","last_name":"Mills","email":"wadartaf@ivajas.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/25aef23d92c5321ddaec23c6caa74351.png","birthday":null,"first_seen":"2016-06-18T08:49:38.067Z","last_seen":"2016-12-27T00:04:07.360Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":882,"first_name":"Alberta","last_name":"Roberts","email":"muvhu@agosusuv.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/4c3f470267a097bd30fac10ee536c324.png","birthday":null,"first_seen":"2016-07-28T06:54:42.686Z","last_seen":"2016-12-18T12:56:59.621Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":883,"first_name":"Sophia","last_name":"Bowman","email":"ewe@tep.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/e98c8395b4b91ea39985c4b9b49c8e3e.png","birthday":null,"first_seen":"2013-10-05T23:41:45.926Z","last_seen":"2016-08-08T13:52:11.284Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":884,"first_name":"Ruth","last_name":"Williams","email":"ho@kikuzas.net","address":"1815 Vobu Highway","zipcode":"15605","city":"Zuikza","avatar":"https://robohash.org/dbdca3a8e425e93cab0fabcab466a568.png","birthday":"1963-11-16T00:18:43.184Z","first_seen":"2013-06-04T07:36:25.695Z","last_seen":"2015-06-19T15:23:40.083Z","has_ordered":true,"latest_purchase":"2015-05-28T13:23:17.264Z","has_newsletter":true,"groups":["collector","reviewer"],"nb_commands":4,"total_spent":1207.7199999999998},{"id":885,"first_name":"Angel","last_name":"Munoz","email":"lib@to.co.uk","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/b3b908a6eb3139643354dac7865c1fc8.png","birthday":null,"first_seen":"2015-08-29T14:41:04.938Z","last_seen":"2016-10-28T01:43:41.239Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":886,"first_name":"Caleb","last_name":"Hoffman","email":"dekwilto@zubiba.edu","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/c7d093e9577356299aac48da086bf491.png","birthday":null,"first_seen":"2016-04-21T20:47:01.486Z","last_seen":"2016-08-29T08:41:31.974Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":887,"first_name":"Jon","last_name":"Willis","email":"ulagozki@wim.co.uk","address":"769 Zuggem Key","zipcode":"22536","city":"Ipiuzodis","avatar":"https://robohash.org/ce9b1cf67898366ac2a4861464d9dcf3.png","birthday":"1969-04-13T05:38:24.355Z","first_seen":"2014-07-27T10:49:47.263Z","last_seen":"2015-09-27T08:07:17.575Z","has_ordered":true,"latest_purchase":"2015-09-06T19:05:50.265Z","has_newsletter":true,"groups":["collector"],"nb_commands":3,"total_spent":570.95},{"id":888,"first_name":"Lucy","last_name":"Richards","email":"tu@owmuk.net","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/9bef208b05b47bb5c8bf023a7bac4e6e.png","birthday":null,"first_seen":"2016-02-03T20:12:57.470Z","last_seen":"2016-12-15T10:08:37.209Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":889,"first_name":"Glen","last_name":"Matthews","email":"feg@ciwu.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/389b59b89410402499b59722dc012191.png","birthday":null,"first_seen":"2013-06-11T20:37:39.345Z","last_seen":"2015-12-22T17:14:15.793Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":890,"first_name":"Stella","last_name":"Vasquez","email":"venizuh@het.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/d09ab04f957d2237b7dad7f2ae6e0f71.png","birthday":null,"first_seen":"2015-11-29T09:06:13.078Z","last_seen":"2016-03-30T15:32:58.257Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":["regular"],"nb_commands":0,"total_spent":0},{"id":891,"first_name":"Gene","last_name":"Gibson","email":"go@cijkut.gov","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/51246143a5626bd4803b2bbc45fc03ad.png","birthday":null,"first_seen":"2014-07-09T00:49:10.394Z","last_seen":"2016-05-10T18:31:27.663Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":892,"first_name":"Alexander","last_name":"Boone","email":"weheptin@hinutuvo.gov","address":"25 Tansor Path","zipcode":"76835","city":"Ecesilteg","avatar":"https://robohash.org/7783647296780b1139ab84fd64fde4ee.png","birthday":"1978-01-03T02:03:39.721Z","first_seen":"2014-02-10T11:37:39.894Z","last_seen":"2016-11-15T03:37:13.557Z","has_ordered":true,"latest_purchase":"2016-10-29T03:22:42.127Z","has_newsletter":false,"groups":["returns","reviewer"],"nb_commands":4,"total_spent":959.45},{"id":893,"first_name":"Clifford","last_name":"Washington","email":"olwe@ini.net","address":"1028 Cedse Turnpike","zipcode":"07343","city":"Binerad","avatar":"https://robohash.org/2a53358dbf5a73cce2c3b0dee50b3e9a.png","birthday":"1955-04-22T00:59:57.102Z","first_seen":"2016-10-09T18:23:09.469Z","last_seen":"2017-01-01T12:37:06.413Z","has_ordered":true,"latest_purchase":"2016-12-27T01:40:25.286Z","has_newsletter":false,"groups":["reviewer"],"nb_commands":5,"total_spent":697.27},{"id":894,"first_name":"Virginia","last_name":"Collier","email":"fascuh@loeji.io","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/867af4292400750ba002547c18188a1e.png","birthday":null,"first_seen":"2015-03-15T21:49:35.736Z","last_seen":"2015-09-01T12:17:50.303Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":895,"first_name":"Stella","last_name":"Brown","email":"tumpu@jetudi.edu","address":"603 Akfiw Turnpike","zipcode":"80819","city":"Haehgam","avatar":"https://robohash.org/82791b5fe0aae81ae4fbe0717a0f225b.png","birthday":"1962-04-09T23:05:20.385Z","first_seen":"2013-11-19T13:12:51.009Z","last_seen":"2015-07-26T21:48:25.611Z","has_ordered":true,"latest_purchase":"2015-02-18T02:03:53.017Z","has_newsletter":false,"groups":[],"nb_commands":2,"total_spent":241.29000000000002},{"id":896,"first_name":"Brent","last_name":"McKenzie","email":"mu@sajcal.edu","address":"1585 Ijeb Place","zipcode":"75633","city":"Cegfoziw","avatar":"https://robohash.org/8f65b7003683f58fc3396c7e9bfa0065.png","birthday":"1990-02-08T02:09:48.902Z","first_seen":"2014-10-21T03:53:28.260Z","last_seen":"2015-10-21T18:48:09.904Z","has_ordered":true,"latest_purchase":null,"has_newsletter":false,"groups":[],"nb_commands":0,"total_spent":0},{"id":897,"first_name":"Augusta","last_name":"Ramos","email":"wangobde@vaflel.org","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/5624a46dcfa74b33ad12dd2ba475cc28.png","birthday":null,"first_seen":"2014-06-01T11:59:22.820Z","last_seen":"2016-09-24T06:20:50.242Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0},{"id":898,"first_name":"Scott","last_name":"Montgomery","email":"pec@miclalihe.co.uk","address":"446 Wovtuh Court","zipcode":"63391","city":"Olzaal","avatar":"https://robohash.org/99f4803c064671043da4a9adc881155f.png","birthday":"1954-08-18T07:43:11.211Z","first_seen":"2016-04-28T10:58:49.686Z","last_seen":"2016-05-17T02:05:06.707Z","has_ordered":true,"latest_purchase":"2016-05-17T01:06:31.953Z","has_newsletter":false,"groups":[],"nb_commands":5,"total_spent":661.72},{"id":899,"first_name":"Calvin","last_name":"Gomez","email":"na@fabe.com","address":null,"zipcode":null,"city":null,"avatar":"https://robohash.org/14a67a5db11d22f10e3c82923d632741.png","birthday":null,"first_seen":"2016-12-15T13:31:21.078Z","last_seen":"2017-01-03T15:24:43.982Z","has_ordered":false,"latest_purchase":null,"has_newsletter":true,"groups":[],"nb_commands":0,"total_spent":0}],"categories":[{"id":0,"name":"abstract"},{"id":1,"name":"animals"},{"id":2,"name":"business"},{"id":3,"name":"cats"},{"id":4,"name":"city"},{"id":5,"name":"food"},{"id":6,"name":"nightlife"},{"id":7,"name":"fashion"},{"id":8,"name":"people"},{"id":9,"name":"nature"},{"id":10,"name":"sports"},{"id":11,"name":"technics"},{"id":12,"name":"transport"}],"products":[{"id":0,"category_id":0,"reference":"ab-u2dg6-A","width":291.23,"height":182.78,"price":28.65,"thumbnail":"http://lorempixel.com/97/61/abstract/1","image":"http://lorempixel.com/1456/914/abstract/1","description":"Kunol vak lame nacev zinsaj gokwel wuocu fomowa moneh gutvuf levah wuatce mobug memhu fomtuve liroegu raculah epebeblo. Lu jorom nimfap gozzaig fa pos on beurufo if owa micul tonkudol zif degoferuz ibi. Pun wumma masje cacpivo noni zebu dortaic cu sobrufhim jibigaeku oliogu dubseb cuv. Ja hi tecuj jicfajsi oni zi ihazaseg awwecso odug de ko giv. Gi gewa laz asoirive tebuzu ew enpoumi woohpu manzipvu dahargow ked hadalewu. Bisbiju povut muzoew rocieli uboiro mut notkieb afira decomno tavvab bir vofev cogobahef awanasni idvud. Nur orefuddu tonul ehujohra aco jaja gaeti ruwromid jed sidaznol jotur eke je.","stock":0},{"id":1,"category_id":0,"reference":"ab-naa18-X","width":373.78,"height":254.83,"price":56.23,"thumbnail":"http://lorempixel.com/125/85/abstract/2","image":"http://lorempixel.com/1869/1274/abstract/2","description":"Mijwisgo mup urla ig upba edatiufe sikic osaofmew nufuvdeh jek pemehpum jo iv ava gujzoni hod roswi. Jew ha comsawa boasa daegu riw veja suwewa kuj miceh agu kasosguf fiodahe gulaces. Juvovfa rek lozoruc zaiffoz awatalec tu kivim vapmu su fiog gom jognun riror. Kohkab gegcup hahip ukenopci isuisi ma ki foffi vufe noro fes ho golwabjiw banmuw. Ridupo rube di hizuhate non sus we enacuuso gehwalpin kiw kiaphu gukwewfob til gopib cu focpom mo ipupepan. Dezed nom ju ik socpubij des hi zekup do roani du gowzezas zivaji gasu boremu. Rag vomo bi budrofgug ikenas dewuf bo pifezu bodhiza er galir irepuvoz ivebar tapupgu kowin.","stock":31},{"id":2,"category_id":0,"reference":"ab-gyny5-H","width":384.53,"height":233.79,"price":58.81,"thumbnail":"http://lorempixel.com/128/78/abstract/3","image":"http://lorempixel.com/1923/1169/abstract/3","description":"Wazinra alroh kutu poza ciloga tosuz donji febmaami hed redpada ahmuceh pi zuwe apetug. Ejuud mavsesi wujet pocjuwilo dowgawtul ehu fivudebu hamod ci lomzakcil kelzen balavit da de len ko. Mofazum idizuowe ceftok fug wuwatule wekafon upoco gijapafi ma sedibti wuona efa kujizduj infoj fim zinosmo. Teihu weje uli gilwa motok somop gikho luspi iwu icuwgoz oco biwaneuz leg vocar ohfozafu lucid. Jafhe dobcem ja kevjit inakow igtokud saf zusigge il mutod hizjibah age jo egtuh acu bikumu magfow suwbambuf.","stock":0},{"id":3,"category_id":0,"reference":"ab-5frbf-R","width":169.62,"height":151.48,"price":13.43,"thumbnail":"http://lorempixel.com/57/50/abstract/4","image":"http://lorempixel.com/848/757/abstract/4","description":"Eduozo amuro fe ajalu co zarir vaw nak edaga tupe kiwnod elofu ka hacvav. Omutariz lubtusri law ijtunji di bokudti da upkaoba bujpizte peso idduplod jegot. Kus zirpu fe tok epvaseh lonola di penwos evisirfek mu vu gano foejuus. Nelaste tik saf pa oksec mohadfu bogge ohlu fivufi ute usborce umowaike todip api.","stock":154},{"id":4,"category_id":0,"reference":"ab-vcxa8-Q","width":295.85,"height":233.61,"price":37.06,"thumbnail":"http://lorempixel.com/99/78/abstract/5","image":"http://lorempixel.com/1479/1168/abstract/5","description":"Ogju wajzuci tegjosu suehiuzu fer po ditjocgej imzel pa lafilko wenafu hudefudu bedica hamric riged not nup. Nu ce ijoiba ru liwavlef uhfuow beppe vafovmo jab pidevaw loc ospa ga ejwuk suih ekwuus. Wobweg oh ukuta cisduupi avkin uvriubo os zonin buzat cejetu bevzow galek. Vajol daj hewpepdah ho pucos rajjigaj mez evekocaw lodomoz irokiuf len lijalrah toba duntoiw nuifiwe ec. Wibjuwaz vimitihu giplefa ehmo lejate ogsudoh higopu vozku ewfemoc mutas femoh getmic weuho vo wahfoez dit nupicaha. Sois im og ojgihze raboge oloweik kirdamu ese ceece nufawa hihja ordijag amu ev pu.","stock":236},{"id":5,"category_id":0,"reference":"ab-uog9b-U","width":204.85,"height":374.69,"price":39.23,"thumbnail":"http://lorempixel.com/68/125/abstract/6","image":"http://lorempixel.com/1024/1873/abstract/6","description":"Um nok veddu zalelmi pabowud rongima heglodim teraz facosaf lejtadte hese fa do riwjuzhek iku ahaul ga. Love mi tucru mu sofkobob kusove cudmohis ganaise hi fi bodwo izatom ca rohtorev basesoz. Jag kak hozjoho zajef salvo ac ecbid uto cizebaw pova hij mutci pesihleb wut funos adkijfu run. Topfozrik fiaho jafo bit bahim ber tiwbumen gul om res bewe boromku ekifimfuw ji kuj. Jac li ihi helwive zuma fohri po fa he jakin zi raihi nozva umokoevu akeibezu bifince.","stock":196},{"id":6,"category_id":0,"reference":"ab-1576b-B","width":371.02,"height":317.91,"price":59.24,"thumbnail":"http://lorempixel.com/124/106/abstract/7","image":"http://lorempixel.com/1855/1590/abstract/7","description":"Tes nasof macerbu tafu tafob watsovi ehevaabe irazi agine sekda liveptiv ugce kenogod cafegber don onigijo jupca. Sudmuwcir reehsot pe em tihapcu koopo jibpa omaheston puproj rombovip pa ubezaz hu he. Zehoj ertaj vip pouv gi cemfaho cumadow hi bovseg ovatek pipoweg cus utjugo ofwezje doc pitujmug. Fepolpon dek daav su pu bozimse veimfur nu juki faj ga mikedu zaomiti geov.","stock":108},{"id":7,"category_id":0,"reference":"ab-b1ip8-V","width":122.44,"height":150.5,"price":11.5,"thumbnail":"http://lorempixel.com/41/50/abstract/8","image":"http://lorempixel.com/612/753/abstract/8","description":"Ji duicamel ka liozip atarim voafagod pafodas inpic bukije mazoh guwkefte ci diluw fi. Ro ewote movgume gu zekowa geozisu canhauz galez sewzo izjozi ko ra rew. Loeh ko ro ko luhgote kuwu eku luwuj tinmegmos suna gotudu fevile ewa rorvu lilew zunhase rup. Orivo af icpo muw zat wujofot bihbobek nog gopkujaf ufsug zeniz rezic tachigcop zij ditgehu rila eda.","stock":196},{"id":8,"category_id":0,"reference":"ab-ht9w1-H","width":350.8,"height":171.72,"price":30.73,"thumbnail":"http://lorempixel.com/117/57/abstract/9","image":"http://lorempixel.com/1754/859/abstract/9","description":"Futi mow cas wad wit muep diwu zegidfe kudkan cul dehgog al ifevi jikzoz ose zecu sebvogob. Kolheban mozel poow ma remiswil ja deeh nedoklo jutjo tauz ohob ro momodre tepho evesime apuhug. Hevgu benzihi huve uvufe lor aboocofaf iro rucgivep jom hi wiwud polomaja fulin nuasdu gehifew. Do mat pod ogoutpu kotuhne selurewer ri anjemez vanab ahowe baszunuc dijwaplik vagwadav uherid suso ciche. Dakpaw cohnuum licuhfa wavizo na rusbaslu jibecib pehsorize fiuri idu kunwo ibini.","stock":208},{"id":9,"category_id":0,"reference":"ab-tsp5h-V","width":289.14,"height":205.88,"price":39.65,"thumbnail":"http://lorempixel.com/96/69/abstract/10","image":"http://lorempixel.com/1446/1029/abstract/10","description":"Wenotme mit suekriz tat renujeobu hiwih vut pivluuta jaljibal sakwe uldu oduw rev nuru nojoghow sapwelfa evlapidu tunnaiz. Ahfe co uz kesopkul omilit cukhet liv gopmu irrukos etogi wa da rurreti harol pojfo. Jef egheg nirtef ifezof pu puamav nuptem hi wasuto ranezda fakojzop agpu bilo piwi cunso otiho wepi koklov. Becuta owanawtu pe lehatu wuoco hozsi cibivco jujiklag pab vof uhco cuvpef revovmew. Gajuuli reg dabdevet pole douse ofi jices ufo lotdizvab wuol momgu wurup sijeh.","stock":20},{"id":10,"category_id":1,"reference":"an-n300o-K","width":296.43,"height":142.84,"price":22.02,"thumbnail":"http://lorempixel.com/99/48/animals/1","image":"http://lorempixel.com/1482/714/animals/1","description":"Rorer sut vepguiwi zahus idupewef onobekbut vaj ci tuguja efisuzo amourimo riesuvu. Jiz cuk ror tegopit kanitul fegadho ofke jabnilu ug lupakenas liggoza camdulvad ofwozod fubwu ki viso. So getacapu ajozopek hoplagmow ces saramaj how tejnevet ineto lah gupa doihame pov ci jipovudot wogati iciw hi. Hub rajti dogtumi rosbagto hodhu ne zus riemga ikepi ilku tivgafo secsor. Sistimpa wa wativi guhugem caon zutuj do tu zawiz niolakeg wo ba mav.","stock":0},{"id":11,"category_id":1,"reference":"an-9x79z-E","width":106.69,"height":114.99,"price":8.1,"thumbnail":"http://lorempixel.com/36/38/animals/2","image":"http://lorempixel.com/533/575/animals/2","description":"Mibkop puh fo ta reni reco tajab ukpeuk barabda efu danzu jiktig vedaw koolam edu sojuzo. Nuvcesuje ucevfe cu ajatuk pijof tezu doh otiliun ovapih bewubvap lougi opodiaba ometig meztika es uzconroj. Mulak vesdoeti meribdoj muzisez pejuh seb ibije muscug powfe golrowbu majvufeb uva. Iweos sof tizati tu fehger ha bot vewgecki bu leate ta ohhuek va wofruhti otomez uv siec ib. Pozcaafo nab uh awzeczag ukuri sinagi ponfe gilo ujeba nubbih ga lurorit do kep jukniip mope kowu. Bat ezicojab cowimhoh ta sarfiw dum ivuz bajuju nivuz oz wadsekda jo. Mojuf bat jovjag padar hudadmo pakcu lol hef edfuzkik iboetriv jofeminob loj lunpaj itridic fe habfo.","stock":148},{"id":12,"category_id":1,"reference":"an-qbdqa-V","width":253.91,"height":349.7,"price":52.56,"thumbnail":"http://lorempixel.com/85/117/animals/3","image":"http://lorempixel.com/1270/1749/animals/3","description":"Gadnuz tek ha heop sufatesu rokaju duwneot fo beelo ta mebcomco lakus acpupci mer zagici emomuube hukvuzaj. Amahus wunza bi mumejib razmaik lunigu luta jib mumwofer arcesig sewet ighokci nebjecov koz zum remibu. Goage bina pul hed nen dovmog kagifapek rop esri wana net tumomu paga jawrer ve dupa zepvip himi. Wafad emebire go kiki ho op nes baufosed wosgogu bug olilos evokobut codap hisrujhab ak gur cakim su. Wirubom pov pal udumo hulca tubit kiuh iwolab fut obilonug ad ecziljid an no cubhez. Tuhsigke esto nucmov agso ar putpile ezu gepbi velmodme piate nen nu.","stock":0},{"id":13,"category_id":1,"reference":"an-xx0t3-F","width":362.47,"height":262.47,"price":62.69,"thumbnail":"http://lorempixel.com/121/87/animals/4","image":"http://lorempixel.com/1812/1312/animals/4","description":"Eg neffo gerame zow mig zu pecsowem wejsis mec opu sideb ecpigrit tiwif. Cojiso med ruse nuka fif joziz kerip gepduv upa ridiv emlufdi cog emu cuema hobebe je ciwafe. Hejkajit jajan wojwunez coj felvid gu zikal ge ermamav buamte ofusa ruf huga.","stock":240},{"id":14,"category_id":1,"reference":"an-dbfnz-G","width":145.8,"height":385.98,"price":30.62,"thumbnail":"http://lorempixel.com/49/129/animals/5","image":"http://lorempixel.com/729/1930/animals/5","description":"Wektitze poceme muomugu unu so jibighib zecuko da eg wi isotoploj ogoga omorip. Seewejo oz zilfum co soabu secot regovov hujcul nugu nisawi mi uredi wis hudadi dejegebi. Uhoran tib wujdap bolepe suj be ijjo bokneksiw jusa mo nueste otuse maruvdo law nunutat aza. Av kus di ha cod so icuzisom nihez luw upolen no hugipgob. Ezobenef roogaco hifi ja pi obave onohu ham bi aci no dil ica belfuz fi. Vi lafoc dem jifebzu gopo tecaju pom sal sufafhu jenvunez wem ivsaz cekib ker cunofaco uhedu lin wubew. Orimi iz wicosdu sev deutolip usu guj jofboz gev fisiwe wefmavmig hazeljuh ucood kajev ku.","stock":149},{"id":15,"category_id":1,"reference":"an-h0m9y-L","width":356.43,"height":157.76,"price":36.31,"thumbnail":"http://lorempixel.com/119/53/animals/6","image":"http://lorempixel.com/1782/789/animals/6","description":"Wiprijpiv fezbuigu wub bakumza pom rukebfi zek ruduzen cekner zo zuibupuh jauhif kutwac natobtu bulezic sov lul. Zibra upeta gekrab ib niifu sogepki usuwi samusij mozopaza weremiv pofav sah. Lug folhel aroelodu meba icpu imeer ra jez hugifpu nefufcab zoazize je huhok. Tewighal anlazib tori nimeji vuzbavun vuk legutaj fuw rufeup fewjumek attagah ubonu fi. Cofva enu nof meve arcag rowu kid gemajdar aciheawe vidar coruka oto wati.","stock":24},{"id":16,"category_id":1,"reference":"an-ilo1o-S","width":227.78,"height":220.45,"price":29.17,"thumbnail":"http://lorempixel.com/76/73/animals/7","image":"http://lorempixel.com/1139/1102/animals/7","description":"Amo gecdif pehubiwo so gajum epno viz ka gi sinkaddov kac ebi mi juzhafcaz. Pa upiwiaf sacir hek uhiez izoluk wufuljov zij rawsen kubasat zot awe su uzu suse ritbepit nuujga unig. Keheru si pimadu anupo rod mugevci juswuvehu cad fiojcu galhek lajneod suicboj sumwov duc pon. Ozukait ohlonkad jorusobo panbezej jefuw waseev wenagut wacbingas favagut tedwupu cepo bumdaza ubouzuhah coma ramhuike co orvo sor. Vobak fu viroiva wupno wufki suido gipisa wob dof dogefowe miufial ma catisugo vivomugu hutoliil nodhe fukjekgac jin. Vucek lap keb wujothor wubni piva diw lu nedewo ufu wurnit ni begovev lut koemu me kimocwe pibser.","stock":40},{"id":17,"category_id":1,"reference":"an-grj9n-V","width":329.56,"height":304.42,"price":60.12,"thumbnail":"http://lorempixel.com/110/101/animals/8","image":"http://lorempixel.com/1648/1522/animals/8","description":"Za wincej cu votfe kanev wudi tulwojego no guovuwo vuboh ile dicatha owfoz. Oge bi ubgiv wudegor uni ges kilge pukefom tidvap je piwekuc fosacfof ra ipid van runigu. Tecfiwwo lazowac ad urwem nokige fazdiraj fujhore ejeiva cindel pa covtuf ceb ro pagjifeb rovzela.","stock":0},{"id":18,"category_id":1,"reference":"an-zsmcn-U","width":377.66,"height":249.71,"price":50.73,"thumbnail":"http://lorempixel.com/126/83/animals/9","image":"http://lorempixel.com/1888/1249/animals/9","description":"Nupho ihezeeja ekono zuwabuta le gihi ta pecireba girmajo atvugwa toknigi gaomvi bak tuhsuh. Gere wusge ijbafdeg fobren naakpir afuhhav eku fuztojut dimovur lo luwod zi kuket. Vucogzab donoal okudoh decle wida motremi awjuec zuocko vincucip vo mariv zazuben hagedif wudugfa cih zaprubvit tasiman fobbod.","stock":6},{"id":19,"category_id":1,"reference":"an-f0y3x-F","width":352.7,"height":219.94,"price":47.12,"thumbnail":"http://lorempixel.com/118/73/animals/10","image":"http://lorempixel.com/1764/1100/animals/10","description":"Vuwus womwodpin vot vabufi ikude og wezow nultu cata el di nawadiego niapeke noh da codnibsu. Lah civu ciaze paagapos woahkes ikja fognihwi nuocta viwmamfa ce riwgo afhurido wapowcog tetbos. Seb tuvremo lof iwu acuboh ape gebu kav tofug zupfeoko taskaho lu gir calgi woticpu puod zoz vahudor.","stock":219},{"id":20,"category_id":2,"reference":"bu-87nz6-J","width":156.85,"height":216.6,"price":19.79,"thumbnail":"http://lorempixel.com/52/72/business/1","image":"http://lorempixel.com/784/1083/business/1","description":"Kef zulez nij powke ahu othu ja puwip uzlor atouwiuv sel movorih zif. Suev uka zacapze jif nikjeb ele ef ujo paho gos efena ihakobwiv sut hadal wim icair kog. Rebcahho lozfur ucsios rivkak ojuhi zuwezbi pecnoec cunuoj kawjojo lehow vigovad cadupu toivehiw mivaj ojetin bo. Ronkubce lo hocik kuhnelnus owsenuc cibut mizamusa hokumev lejuscog ufteb jobomic tejof ovasikcet ba ponwuzeb. Fouczo gembim pat ogudi itavu jewsi lolnefmaz ju mej sez kik sozuz. Am ileoci semanza som zit vuuj jilof salojal pevidog rofkih ziwfek sadcel fuked bolon on.","stock":69},{"id":21,"category_id":2,"reference":"bu-3jle3-Y","width":364.41,"height":241.17,"price":49.73,"thumbnail":"http://lorempixel.com/121/80/business/2","image":"http://lorempixel.com/1822/1206/business/2","description":"Vab fenesi butaemi jaomwe setjekji te mimkeku lelebri wumwidin udi lankuro civ ip epazob ce pir. Tormeaw suj we vek tezigrij wif beokamof pid jaztefu uwusebje vukev jubu buwgoap cikid juwuba. Fiko ucivo izhot udlikac vurfumpi jockafhec rowum si gezlur furolil gefaf nejceof to. Kucubuhi sej ukbu ulu afuham dawoih bu nitemoh bi lawafezun nij osuwidja ci pafbeiz etinowa ejhovfo hoasvuw ni.","stock":145},{"id":22,"category_id":2,"reference":"bu-4orja-F","width":261.12,"height":300.94,"price":51.44,"thumbnail":"http://lorempixel.com/87/100/business/3","image":"http://lorempixel.com/1306/1505/business/3","description":"Nek pemis judzu sansal vit obuguja elefu covovi gojueb dakecu ritjune bud. Pajune afhik kep het up dacco viibimi vif ovbem gir kusekew efoluj hub. Gudev go pozjiklo hel melorroh bi agamumo linabadoc mabulzab sifag menas dalma uno govu iv lo cu. Du josu ogazani da ne kapmo tin afgitku vutsatbad uzpid cun su zen lavpitu fucso saziimi sa. Locepek at fewap gu ewimoh hegaz egwipaw ezu benatjas dobduzvat zapib ef tufa. Mom behwasat ha datkiva ajotici somen osgaza kecepi weka he nulu go kas bavlicluj.","stock":0},{"id":23,"category_id":2,"reference":"bu-h2d88-T","width":291.48,"height":350.67,"price":52.18,"thumbnail":"http://lorempixel.com/97/117/business/4","image":"http://lorempixel.com/1457/1753/business/4","description":"Huz fowirpem limah diguzo cubo puhrur nirko jog rurgif zok sujuga nout nosaj. En fom wolvuvze ofu ijorofu ji odo ikosucik capimba siz zaw topobled buto mu kajalim rutiz jol. Ejgucibo suget nowuvgov me opi zape japu hokomco bik erlitec vipiliv lamowim ba mofjutbo luhiume pak lihi tedco.","stock":0},{"id":24,"category_id":2,"reference":"bu-k1lb8-R","width":209.87,"height":302.18,"price":35.34,"thumbnail":"http://lorempixel.com/70/101/business/5","image":"http://lorempixel.com/1049/1511/business/5","description":"Mi mod tekdudin cofolhun busnatjoc paf can tohzuse gum bauta piikni ida wov kijev masjal ze eduhoco hahkubge. Coctavcij womijip tepzowdaf bu ri tujiez wo surge lehbaeh bu efe mimrow. Bekliak cujnu rubdel nowruz ha ono kamti nisim keba asa bubdi moncori radiw em obesacil wup. Macil lupade cibdek wihatre rignab abuse etieb fafi nudo telipo buron elumcub jilkoz. Pagpigi okekoj no lofpencoh zudap idsom fidakra hicimmo muzgahrez umwapifu opobo be vir fak etujo ov selim. Dami zeije fobcici lopada vosohote kiki hew muuvu jijcuf demfi jeta gid zeunbil upowu.","stock":0},{"id":25,"category_id":2,"reference":"bu-kp5nb-W","width":393.82,"height":125.49,"price":30.65,"thumbnail":"http://lorempixel.com/131/42/business/6","image":"http://lorempixel.com/1969/627/business/6","description":"Hanpot ahauctar foelcu vateso fe haglaf gusoat kebcowic kaf duwusi ag wi do fuwo zosnuk gozed adpit. Velatik kalujrum ab ko ezoofo alifi sa ig tejot iwju tanpes kat kesiglak mus eg zosuidu. Oj wila cocajdi neuji sufzeza ivariva catakdom bi favsasu igulofoj ezol fe. Ugo fu pep bu birrun wav le zohojoci re dijva jatazadud dihtoklo hijhur cor kula ecuritcod uhca enanbi. Pezbi ihu nep wuk ratifigov ejo hus egojivaj viwez daw urfohafi ez poguho mug luzod ajetaho. Hakuzit otikeweg kenepi joofuja kak cu rejize koopi cauf oda maciaju redgimaf zavgak rof ho aku bub wozsazdug. Funiktor fige fogi temwojne wodidec kuil lik huzusju rijguk cavfubkow cal zotnu wifma jonsug rismotiv cugel lon.","stock":0},{"id":26,"category_id":2,"reference":"bu-t8cc3-S","width":267.72,"height":229.28,"price":33.16,"thumbnail":"http://lorempixel.com/89/76/business/7","image":"http://lorempixel.com/1339/1146/business/7","description":"Jumap neveg ecutiv tuzaktib fawi muwirin uc netze rakloc roti womo nuj otkol ivarimle vazol bi ifocte. Jalti dog gaslugu teowpu suw mu seveda mubijaofu ikedo hacitruz zara azihurbi oparin pi. Tat zallile cekzo seza azu getgeru ser ebkagbor rer asoropa dig uvikig cinavju ikfacon. Codna wuzoddi ges ofajinov jalra kefaz ije bovjurfo wo winfu mifidef dan niztelec. Wapna bokvomo gigbaace ki bo zuew obfe maspemop rugbol nofuh bog vor nowew utja. Zet era tokiwo gacdid malogugaf izkan romluke wa dirmok banuberod iki obe ba pesafugez sutjerfo. Go aro acalaheri gimmab mo juze nagbepji tezocaoj ocowema wir ode iraso wizawih obosevol fenesko avaunwa cecodo.","stock":0},{"id":27,"category_id":2,"reference":"bu-1icfv-C","width":192.69,"height":111.35,"price":13.58,"thumbnail":"http://lorempixel.com/64/37/business/8","image":"http://lorempixel.com/963/557/business/8","description":"Liriw mov ufefi kuwcu iraka dogamo gasceb aswasod vomuclaw mitguog insam kiirdiw zicez. Koibooz ohsu kuntigi lalaz vojo ze lovjuc ona dagut lih lozowa nogol. Bi wopu ahico hirej hortigiz oje zapi zindu po rarheg ranpejha cafba. As unlumupu catuspih mimow se ku ra ukjug me akgikhur mupzugpa aj zejde. Buvfuk ho jitukun col rigtefni bisi daflocno ukwojgug foslak nar deceuz ho ugvihwas nencibil saip jo dazidwor ju. Geadne jihen bu be ripas lep wokfavak edi su ga hemahe nadik jocgi lona. Lilekjuw nunpobo fodcorsul foj ledgucum caf avoko nololor ri meg riseko varbeha revne.","stock":20},{"id":28,"category_id":2,"reference":"bu-f0241-Z","width":184.2,"height":177.44,"price":20.37,"thumbnail":"http://lorempixel.com/61/59/business/9","image":"http://lorempixel.com/921/887/business/9","description":"Bonoh nekge nublin bizvi be ik ijivog rotwak marugeco rata seztobfe maru. Ajujepne limauke letojo rumem jof ehe ju cukab ravsij fisnuduto ogitacap oglocbif vaiwe jihrifge. Utopan cow mecfiv ra nawihip zo iveli jinzu mir fircem ve buuko kikha.","stock":0},{"id":29,"category_id":2,"reference":"bu-62l11-L","width":229.04,"height":257.76,"price":34.83,"thumbnail":"http://lorempixel.com/76/86/business/10","image":"http://lorempixel.com/1145/1289/business/10","description":"Ce row tu wa iz umcacuhu lepuz avaudcej kuz kofah ebuen bumomfu lihjisce li. Beto biwosu ciwip ovoteb fujmad sus kadsadre jiw nanozcic wawriwbu duciw kiplozmin vongulu gud. Tudibo musowte kef mim re ej bos ofsab cu kol ujoj bufjif. Losahaz jutmuci at guwziid me kenoono rovo vo cenpu fezedsi wip uh dakrabu be cekdeh ofaasuh bosof re. Go ji moaselu minev gisgokar gorceg zokuzeg kibet iwutacub os atadodiz ivi balegu wi las ruc up. Pab iwe semasga gaeguh wow koiw bigjez ravjusira oje tatan pice wag majebiufi le uplebef po. Mihbujluf gimuvu huokazo jupeg unik pozak soz tocgoopu medwit cikfow ehpepa mucor toz piel.","stock":0},{"id":30,"category_id":3,"reference":"ca-5libj-U","width":220.88,"height":155.78,"price":20.19,"thumbnail":"http://lorempixel.com/74/52/cats/1","image":"http://lorempixel.com/1104/779/cats/1","description":"Ucmedan niadgeb apahom deluazu bafu jusuzier ru ruz zuhwisi ojivuaja vi lev. Mipsajbi vebme laabfu fid vebbemzi rekub du farecudi hiehocic copco vu bahnuik gopuf ni cote. Iwuzigam jo wejmiwop josde ewetawwod nawi sopuj kos karois canig mavmivbe joemuw kalacad wu. Ofoviiza lo ze zufuref itowac gefmilfe te les potogvu anhe mimieb evpeki dih siple ewac ceprav jowlo. Sipov rok zutauw orerev boeh jefuduk buprepa kacozib af mizah vasduphab mididrez goju. Gokiwo hiljufpim biwiftof ipi bir taf ciel ewemoncok oblagruj oze ez raftedu uwiefaze ocoofu culu les ruraego. Zirgulub so fothib fabig uwdib ze ajo kobnafe ere coz nubmal mimmel citkogit bin zudif erfeglal naz capot.","stock":14},{"id":31,"category_id":3,"reference":"ca-6yqoa-R","width":373.18,"height":381.03,"price":75.27,"thumbnail":"http://lorempixel.com/124/127/cats/2","image":"http://lorempixel.com/1866/1905/cats/2","description":"Okzergo nosoh borvahu vibgot nuluffas sivok wusreac joewjap taz olisi pavu vijijara eluju. Ezeos noh te pe habtab ujo do fadsi canato zabekam edzu cuno cesweju apdiwok. Zu mup zeewa eh kebbovopi ta wovdehpe jetifapug fop fo gugut gogi cova. Ne akuru vufcago cavirwo ima wiwguj upomoda obo bugu pavnur gudno gepunu eh limimfam il koz. Tenut vudebza zi ado hadalcul guzu alep mikiob jisipug diav mozad hewbaviz kugumis ucojicjep nak.","stock":0},{"id":32,"category_id":3,"reference":"ca-gg5ke-W","width":123.45,"height":397.91,"price":25.76,"thumbnail":"http://lorempixel.com/41/133/cats/3","image":"http://lorempixel.com/617/1990/cats/3","description":"Jegel ohi jimcicdej ga mat aveso idu dev mav as so refowih weuf vusirlu et. Caiweaf afcij ehanatip fello humaf nogefah od ohruv sin imu rojigid ogu. Sagjunu si ko dal wama kigupo fu tanhocna vif ve diwi ro rurjo juumjad fug tiko ac. Cuv runadhov uti vavwuok pekduhhaf suupuzu so duba go uvaf casusemup ifo ate dade. Dimep wijejbur er guj emidemri cujhopu demi sik lastaknof tidkuegi soluvko mal dac nowruica. Oze ru molo edvug ribcefe juihje mi hamip itazim lu uwuwu si se no za.","stock":0},{"id":33,"category_id":3,"reference":"ca-5bswi-G","width":290.47,"height":103.75,"price":18.66,"thumbnail":"http://lorempixel.com/97/35/cats/4","image":"http://lorempixel.com/1452/519/cats/4","description":"Junossir wulguz hejawto hu voakodob ripun nunidi vu ifpo gon lucdoso ruligudij reiz get caeffac ba pu. Bobed vurbe dekurugup dec bi gon onedob rotisep vomlenmed bivvofo ice jikasor mezfode ewu. Oci nabubem sow fef ezairu jimbi du fajod zi pu fu bej hur ogkutfa hobi pe tog asi. Pervaf tiujga duojo mabir fes tinomcu woipuut voermak vaaci wagewbo celwagfok kaku gehewnen. Jubzic mej noz jevu rakbinvos wivlese mojebbuj gidzophev pi pas bebubhiw koscup pegjoh. Ulagot enwe vupoc apemi gis de uce abjig gakik argar wo vuujnim lamteb idu sumgu.","stock":0},{"id":34,"category_id":3,"reference":"ca-ugjk6-N","width":196.26,"height":321.42,"price":31.76,"thumbnail":"http://lorempixel.com/65/107/cats/5","image":"http://lorempixel.com/981/1607/cats/5","description":"Ic ekrat oga foz mulim namu cefbuv foafu fevkic tudpikiw jekiwfih pemiragih daci rukake mupic poro. Lerzemaj pibre bupavru okiz gokurhas icetijpu woplul id toharsa ov map tob mieho kaj zophem femta hivdog ataucipug. Okeudoneb pocacuj kiwid jod ziswi je il ved toc akujbub hupu kameko ditali rag dikkemor vuve kimutlis. Hufo iksom pugfaad igwofti bimru geb logsew za re kisol sehansud haeca zekaw cebwi ajba lagu kudnurhu munu. Tak madepmes ralver doj le zawirwa bec ifagiswi wobheg cuncug sug ahe wisi fifiz usoap zid eno tilmabajo.","stock":98},{"id":35,"category_id":3,"reference":"ca-i9o7y-T","width":358.37,"height":124.52,"price":25.63,"thumbnail":"http://lorempixel.com/119/42/cats/6","image":"http://lorempixel.com/1792/623/cats/6","description":"Juagbed munhafun siivuke zubije kaf don lus vak guvmumes oke mihoj lita cehi awwuwrug sar. Lo gew guni odu gur zed ga ibuko adwom mop wuszoow weco jabne liluzog su wimul. Dusvoeho lewu ozcuwfic denwu isi nuibuzuj dudijusi jupubgu kuune parrubeg pet osku seoc opuwod. Apagahu lemwaf ejisetes hoczode rug puraf lukkaove gokru fafu mamatak mehfa fetfag ta. Mevjot mo boleli daka kaece sokbus dojofhad wubize caur kopef avuseapo sampidu kavbehe bahi mounta ucesoni.","stock":13},{"id":36,"category_id":3,"reference":"ca-6yjrj-W","width":240.42,"height":334.53,"price":41.9,"thumbnail":"http://lorempixel.com/80/112/cats/7","image":"http://lorempixel.com/1202/1673/cats/7","description":"Ged ken mevna ulza zehi ivemek asbupsi labeca jakokwo ni narem en. Heohofe asunugnuv menotla po pe kuhuhaw baveji ukved uwkokha borrok kofed muptepen teoto mawec kewimojek awo fitza futiis. Hoz id puvez boc ozucuda hofpukna wumamape mumricu uwtar dejo ogmaw funo har muveh niwidti batip ruog zukdato. Ikino dopaguegu mukbavimo sodwicu wehbo epze wecigofo agibu boscuk wu on fibus rolmuslo. Wugosos samobi liv cubrokej najoha novpesof usi ecu opasem bek wute pitki. Emlogo nin ficoti ku muv usirippu so webna coh geklevjew kocfoeku aro rev cigug zeruwsic. Lafmo livuzzaz peri si abolesif dot oheluk jibja fefuterel gaboci hohewdo ce gopwinki ciso difmut ti ce.","stock":98},{"id":37,"category_id":3,"reference":"ca-1wk3o-W","width":186.87,"height":104.71,"price":10.07,"thumbnail":"http://lorempixel.com/62/35/cats/8","image":"http://lorempixel.com/934/524/cats/8","description":"Awapnu ru col ru abiozlu zu wuzadlov acitobga nelof cepzibsup fitimhij bupar garcuj tihuhhat ruf zofapij jaisiko icvo. Far kicbohif leofike mitzo ti hamelri babas taj somif bumop ow jilfewnij bemahu ah ruhje. Vu vevre toamdar vivpim bokele rihimapu folsa te hope luhu newosolar gugolumo nu su.","stock":0},{"id":38,"category_id":3,"reference":"ca-jejy6-N","width":316.92,"height":323.49,"price":51.79,"thumbnail":"http://lorempixel.com/106/108/cats/9","image":"http://lorempixel.com/1585/1617/cats/9","description":"Bi awo ki fobih kukaf oc jusezjeh ise ibukun wealelo zubgefiw nakgesus mukkir. Jah bo cuckekoj bahumazim dadambon tugni notco huacu cesibho ukeeg aka luor. Nilez sip wi sehwa bapjut pagnic opemaflit puehibez osvom ormorim alpatiz ra lufja wilweijo jeroseopi rijbib. Enrohi wew te iwo eb nezkohi laamo tipezow jiowu ju ginmis us wawgola web aflocu lonacru. Durokcu tucuvun tallec jegubnem varipu ide rewu epu nakguk tajho row gi. Ruwir an buscugcuh eb hogka kuv kom gipepa co vibegze higte okluz.","stock":200},{"id":39,"category_id":3,"reference":"ca-c539s-O","width":155.96,"height":388.33,"price":32.9,"thumbnail":"http://lorempixel.com/52/129/cats/10","image":"http://lorempixel.com/780/1942/cats/10","description":"Omdeoh iku agozelvat tef ben fohecez dosufocuf daaga vihak dowujo zu cibvi coh bader. Dohef ca obbo roefaci vet hum raglimib leacapo su wof noklavve ge tusaku. Efafubo ivemogfe eheebuzu pa vugaghu mogor id naptun tok sore vehuci li rac. Canutibi usikaac mawho namjuz zaza hocichom lu fo ram ni jenodanig jujuf ruvu in daame efluf datfo. Oro ge sipubuw abase liwpeh te edeno ce fir vifaw eceehabe duugomiw fav lolop tuz aba.","stock":11},{"id":40,"category_id":4,"reference":"ci-hw3lp-E","width":134.56,"height":228.18,"price":18.49,"thumbnail":"http://lorempixel.com/45/76/city/1","image":"http://lorempixel.com/673/1141/city/1","description":"Oklepci afru unabiata ripura ukug no ko temop dep wuci pebka ad. Pidmof apuragej oridu efopla ih utrufez tuv epjitvi sezgibiw idmuk gif zotep nalaha acep resi kumihe ari toawlub. Desan lob zut ro ja ro delerem tubigter fegu riv lefu sag nufca hunci pofico huh toh ver. Ga pikki usfe gur vogmaga kiseg ladulteg dewutuc fofekfis ilo jeh ofoonavo eni gose sowo wakok ecfufa kime. Uku ujtek behehnu kijsedom ha dambu odenomzu guten vitohwi gud on veckuc ra acaomutuz.","stock":206},{"id":41,"category_id":4,"reference":"ci-m03zc-U","width":344.87,"height":213.48,"price":41.94,"thumbnail":"http://lorempixel.com/115/71/city/2","image":"http://lorempixel.com/1724/1067/city/2","description":"Ozcawum pevruv vokuca zof joza bezow ti vi josije ralgoz fidug ebjiri efape bi huc ugouju fobuvi iriifo. Nusjuncop nicop ihapifdu ani ikemiw ga fogu katkopuw kerujo lol tit caavjo. Izota fu sel luzsateb mekzomjep ud reb ticu fupafori heme in cagi zathiik.","stock":241},{"id":42,"category_id":4,"reference":"ci-z37jl-F","width":191.64,"height":302.21,"price":36.33,"thumbnail":"http://lorempixel.com/64/101/city/3","image":"http://lorempixel.com/958/1511/city/3","description":"Ejupu nuzigo toud megibar mojishet mimvabceb il jeg puso isautsu ci kasofomut foces ibbapem pecmisuc kudale. Jacugu leere jiepe fuh azgi bogboc ta fitiwa ginizi dureghel mobbavtor uv zakte ofimumhav obu. Te jaheco kuc bug dovpew zidse vuwi hiz sobosec botnuma lefo iz.","stock":91},{"id":43,"category_id":4,"reference":"ci-iurgo-Q","width":208.53,"height":123.22,"price":16.14,"thumbnail":"http://lorempixel.com/70/41/city/4","image":"http://lorempixel.com/1043/616/city/4","description":"Jinibo lun uh jibedig tego lohomen ralut vaz nu ereeko fap boaroij. Zezsi ra vauvilo vunifpat tes otbizevo esi pezipe lusi vulhagev ogivew conu zuro urere mi sa dolvoc vuhku. Mimkevcu zehdu cehaploc ibada oji gi kohat venucni howka fe ivrajde simibahun ob ceocoifa gafuces pewa zid. Segusiv otu mihjap nuc ceumni lipid ho ritbu sof biuto fajdubun uj jifjij. Jeuwimer eltupu sudsa ov gialo kaosuwe hociv wear riwjob oz avisuk uguferi lig zumsauma horse efpa abazu zup. Muma kifermu fo ho ehipi sako osbi tolehu be wu emege mejtew romtu juoje ig co bidafo powo. Wommi av afoki agopej le go koju vozeka zelu kor mabomjo niso rupnet gu jamoet.","stock":108},{"id":44,"category_id":4,"reference":"ci-c05iw-U","width":368.53,"height":392.05,"price":81.11,"thumbnail":"http://lorempixel.com/123/131/city/5","image":"http://lorempixel.com/1843/1960/city/5","description":"Rucamuuc itsuf jidgoj oheepedow ib dik otesiul anfi zi kerokvaw fazaric ole foj. Da albig zure je zicreref jiiseiw otkuh buf upevo noneke okekowor kocko usnu cuvtuf ajina ca figa. Vazoj inlug ke givbovaf imegis fu rib la sa ehavad vatipafih heetobak eduma.","stock":0},{"id":45,"category_id":4,"reference":"ci-28vsy-G","width":189.96,"height":179.94,"price":19.79,"thumbnail":"http://lorempixel.com/63/60/city/6","image":"http://lorempixel.com/950/900/city/6","description":"Sed gantaf tatute roahedo ewogew kafempap cegici ohi caz wuz eji joc dogankuh pijnueso tuc. Fu tasdajgi pupvic lujakno rifoto filme zusmuil mecfe tusbet uwgale aliroh weerugu turul evurevo fipulrow wun. Ujuga otusibut zuceihi rab usiaf ciuz ga viabi awfiibo gopfuh nu vo. Azukoz ma wovsulfi jubtotab og surwav supgot liskivkef cijvede bijuot vala oheub gejisom nuem rikubezi pumalnob disluj donug. Uhulihmo eco be ko iz ovsor oppop ifebala ji litwi hitevla fum osiuvoul wotoag zumhe oknihzon vasweak valze.","stock":181},{"id":46,"category_id":4,"reference":"ci-7413r-M","width":321.06,"height":373.93,"price":65.21,"thumbnail":"http://lorempixel.com/107/125/city/7","image":"http://lorempixel.com/1605/1870/city/7","description":"Mek nusidmop cosu igi afzudda tukulzig zoluwhi fuitakeh ko gevit mu gid reihinuk goidoto vucgimwa. Nutezur keubucoc jewakij vovjout emir kifzad por goti fuofilag ajo hiri hedpolpes tebharsar jaspulab mivduwo pavawnap dojlehja zizapirun. Kiudubu ewkamo hupaju fom zabima ce bor ibikezko tiv puk jiksadef mouvu. Rageduk rulcanic icogo zukoja obsib kiv lekazi iweudu fezumi tul kemu bakep sudwehi gihnu pujsotba. Keedawoc roizuco wobor beples ici mehsoc suve uvikucneg ecaci fab ub fi ab uf.","stock":11},{"id":47,"category_id":4,"reference":"ci-wskev-V","width":171.16,"height":392.91,"price":34.25,"thumbnail":"http://lorempixel.com/57/131/city/8","image":"http://lorempixel.com/856/1965/city/8","description":"Azibavde varuuv zug or sauz gigapbo di nabazu motis on tubleuda izefe. Egzooki biusgit fir goh evkoko su gi eb epci am mifsuz laurate diw eva wugubi ajfaike rajor giwej. Vuhbaclam onevom timzanoc imo va odte cab zauhav aneh dabraave sabo puppatnu tawsaog finnabis aholeji. Zazijwin pulifowal ogga ba gelu peksudaf ridaci itfob nuk nelhosow zu azo.","stock":0},{"id":48,"category_id":4,"reference":"ci-b5o42-D","width":363.45,"height":343.97,"price":64.57,"thumbnail":"http://lorempixel.com/121/115/city/9","image":"http://lorempixel.com/1817/1720/city/9","description":"Uwli hasetojut daf imdaptij kot obuehhop jijik weub pohu vu tulirda nu beosnon wevniedo jaljogur umuisepe rebvohkej. Kan musuduja jil dijdefbo mafuanu molic hamemjic emivuas deja ejma di hez lobampig jowiw. Wegmig mulu ze anedu bej judo fomub jo vok zugju raemi uji jojhir.","stock":204},{"id":49,"category_id":4,"reference":"ci-b1g2e-Z","width":201.66,"height":101.95,"price":13.08,"thumbnail":"http://lorempixel.com/67/34/city/10","image":"http://lorempixel.com/1008/510/city/10","description":"Ipuzes gu dohel pokbatub te horfu upci nu ala caam rujkufgij fudupinen wavvogube anozip ecalano. Nubte zusavhom gi idulela dotjel bu abeasso epe fucmu wuwsa gowmeg we etima gus hubnezweh aradolpez. Sa bawi elu pauda facnebok tulvuhmah cic sede caikfiv nec iz zor ahafebuva. Efitip ve fiij lu ta sapmi jiv otpoz dijfuse leur codhik atuwimir umlohu cemkapo ek bofeive no adewo. Rekuzpo pij ok pumkagdig hum du ugpe hofce fefjen vikfukemi mitcoges wipul sivguwsih vi gigo aknachu. Emi mibuluuc mo kilpap zuwov dagoze ede bevvakato jog ma kud kosec.","stock":122},{"id":50,"category_id":5,"reference":"fo-71k4e-C","width":326.62,"height":299.43,"price":49.36,"thumbnail":"http://lorempixel.com/109/100/food/1","image":"http://lorempixel.com/1633/1497/food/1","description":"Je tukuvuv lodbavo fanij vubom vefotni lobkobit zipoda dapmap dumas ike duiwuca ze. Fimuki lep pejobi sosihak bohvoril towmiv hewucte amusete ice voawzol omo cav dubiuza ta bog jih jo. Lomutu rikucne ekupaod vekpe it im vavnir atipu gop loveuga eltus wekog ukfehwu ne. Joino jaho tihbifnag miwwaamo li ahur okobicpi hubafho ovocanas tizaoh sudu becotu ek weg. Jadta nogob luzo wehfa livohel jo les vofocli owi gozufi zat lolmuhuh. Vet lerovsij gucomef soviseul so tu rizuh net bumofso tuvral povor ug. Jad daw odahu jivpimso ijbepgo tuv mefag ambow gadope evidekje lesa juf abaza or.","stock":42},{"id":51,"category_id":5,"reference":"fo-gi8ns-E","width":372.8,"height":217.55,"price":53.38,"thumbnail":"http://lorempixel.com/124/73/food/2","image":"http://lorempixel.com/1864/1088/food/2","description":"Rom wiufoji kohko tob reale ju fav bevpepvaj zueho wipow ot aldaoc. Zervo webfufec bi vefnup coz pom gilmovup guc jeiriwog rebluj wihfekip kaje. Gom leji ublu ado icjogsiz rih witimo diwku gotcaede fi hucrib za uhpor. Litpu wen tun diew dibaz tufofed gihorpo eb cotna mog tebbebna mal igo kasag kukut meamu zisusguh omoheje.","stock":0},{"id":52,"category_id":5,"reference":"fo-zi2gt-N","width":129.24,"height":100.47,"price":7.42,"thumbnail":"http://lorempixel.com/43/33/food/3","image":"http://lorempixel.com/646/502/food/3","description":"Lirvaev kadjib wawaif se ab taz pof vel fopra foz gu bej go oma muen. Temgahlu lo fopik juc uwiba moniumi ripeb ovvat cokpifita ci niz mapcu awe obidho. Mijrep ga cu ros zigru ifpog pi wa nimuc joz ivatebe ig winjooma we tonug edaitu majaltim. Pelara juce fa newada om afisumot werada lem raibege in wa geciscot ca. Raagu abimo ge vehfuheci lunselni biajupib pe nophug todno fofol vor oga ohab. Voperit kufeg idaweb zo wezluc mug be uziwap pama pajuvovus joazagal zoji. Huhe huccijzo cico kob cupo to sisa cuwwuji susto uc jid mepegko vohsaafe titselbuf pe.","stock":0},{"id":53,"category_id":5,"reference":"fo-uodqd-X","width":251.58,"height":261.87,"price":41.17,"thumbnail":"http://lorempixel.com/84/87/food/4","image":"http://lorempixel.com/1258/1309/food/4","description":"Igpoca somaki ewuece iro zazo raz kup do ellot vahu zozwa avauju izune bawda dabahari zicjifi lo. Esala urhodkuk kujru nuf ceorna acudojun moigigef zeiruzip ge pebijhu nef cautiuji dis ovji inobarlur. Sogge bev dinzuloj ic be pa zewzavpe wubwe ih uz ta te kopsoice wu. Sum bojpeze luwal sub olezo zutkuweb cogo sag matlup kakluhhi hafpoci no fodegref ju hu evi.","stock":106},{"id":54,"category_id":5,"reference":"fo-a0b21-H","width":284.62,"height":328.46,"price":58.92,"thumbnail":"http://lorempixel.com/95/109/food/5","image":"http://lorempixel.com/1423/1642/food/5","description":"Va cohhudej jumpa cestah belila jiloju geg wan pelsesi akuet zeb up wahu foun. Kinkavaf vekigil pop wuawetiv fuvijti za bafeh it makible cogezze rovtu mogec. Ulopo tog si kerzis cugusmu vakos hoev retiuf jatdoguh vuifhod ha niuw ce oz lokeho. Lo haka dis or bi akrowi kef alilapo filfov gorma rowtud ucgo somro gihicpij tog im jehuma ado.","stock":228},{"id":55,"category_id":5,"reference":"fo-j3kni-L","width":203.08,"height":383.98,"price":46.97,"thumbnail":"http://lorempixel.com/68/128/food/6","image":"http://lorempixel.com/1015/1920/food/6","description":"Tuawaweh aniwas nikal fekowom besudze punun ka er mak wuokguh gudwo va evogal. Rawapo ta lafo kobhu tib odkic jaj pe sid sade pok bahopca idi boso. Ukafudop uza jondov ga lowemibo se ju miw fimre far opa mikpavwuc jivtot vuc mabfioni. Lap nunu ju busbo juk ro ferboljog pauf kuboru owdujbi janew uju jotlofub ugubovik izuzidham ehwanes ziopa. Senofe jeavo kof ucihiw wiw pitog ubozidir amcobfu zerma vuono sosfebit tor nacwuw likfoc kuligze horned geplose daitewi.","stock":103},{"id":56,"category_id":5,"reference":"fo-xw9ff-X","width":202.79,"height":184.44,"price":22.41,"thumbnail":"http://lorempixel.com/68/61/food/7","image":"http://lorempixel.com/1014/922/food/7","description":"Kis rulcag jadluuro gef giz heg arzevuz ron remileni huba nef ziwekmi kiwaluv. Unusa cirfaha giwzepwij zuh bac va ave mipaji enec awpomo huh ruiczaz. Moscetdib ruhsuf orzuwgi efaveg lowebore cep se dofe tegpidzuw hed gen hucatat gemwava joficar.","stock":0},{"id":57,"category_id":5,"reference":"fo-v1etf-Z","width":250.71,"height":218.08,"price":29.51,"thumbnail":"http://lorempixel.com/84/73/food/8","image":"http://lorempixel.com/1254/1090/food/8","description":"Ne bavecda lomfu iditutoj mureube feg pac bav fam tuvo pi ujimu. Ahtohi vipwu ema ewbir watih dukwidju ifke akhaufa mewewemun vicogiam gu idveimi raf fa lefe jewaj. Amo mu ul rigodo wafsir avfevsi abbarla en tojakre rizemuz roktu keuli ecebikamu. Rebi dirdaf reb ca kabanko vac wecrunbe re jamwosa nic muhupfa mogijova ub pomlebiv mopzedjob. Ufewubem nehovadi zogefi me todaki ma pok ackoos doevi kernufaru gimvovos jud ur firu fivos oko. Hi odiukcim rilujicam ivinoddu ve awij eb va bajbirkad ziepigam zuiz pub hogsu la pulowo webokat. Zawu afi rane pem timapfu sakpube cadu ris rof ezirse wigsifus azogu keshogul ke rasapew tam us jowiori.","stock":36},{"id":58,"category_id":5,"reference":"fo-1nu1o-P","width":335.82,"height":399.57,"price":70.32,"thumbnail":"http://lorempixel.com/112/133/food/9","image":"http://lorempixel.com/1679/1998/food/9","description":"Akmozmej kovle kivow ka rojoc ow mecgiwo leszav arje moknokja borordo ke fonoor. Navpiwi hun ogaguw bonsojelo ah ejohinor mepucpar iruakte dignop ham tahbogi hel sabesiuf diohwab zo ukideb. Foj alorab vor ruwpisug cike ampuzihi aturjo telbesa po ecluhe ne bidki katonim orticena. Sebjoaf cuizi li gelopni joko to miwuf ukiate seklo daf uze uverido ajewe bab witvar ne zulavum.","stock":172},{"id":59,"category_id":5,"reference":"fo-mxolp-A","width":236.08,"height":265.55,"price":38.08,"thumbnail":"http://lorempixel.com/79/89/food/10","image":"http://lorempixel.com/1180/1328/food/10","description":"Vuzirlu jolleub boptooju dif navi sadaw jupataz jorvi nigac puzepi pazi ifohe wol rufgo ogniwam efwisbu nu il. Ju hatewer ajol ruuguko atlozte vinunfa wu zugi wah nuw rojneb etpijom zama wic. Huhlar witokorer no or suiva kur anidieco nanijpo cipap cen bofnu biogmac om ajigaton. Noh ogo jes ha ipda de kahipwuh egfolpa pivunim devozkaz eboruc bofmu ru emvet tasnuuf de.","stock":232},{"id":60,"category_id":6,"reference":"ni-zpjxy-P","width":239.88,"height":175.55,"price":23.66,"thumbnail":"http://lorempixel.com/80/59/nightlife/1","image":"http://lorempixel.com/1199/878/nightlife/1","description":"Vi kazjo me bezge focma zi futojo defto wozunab tiwsius mev bejmuvoz samsi. Meimu oc fiw begaho nohazuuno eloz li wobod fe setar lapu ne absapuc do mo voodadot. Cis mog lehu sejuvulob fisi ab kevjebefu jeova fodcev amedago to cab togpaktav muw bajog ga julu gez.","stock":194},{"id":61,"category_id":6,"reference":"ni-0pxfp-I","width":193,"height":299.72,"price":35.06,"thumbnail":"http://lorempixel.com/64/100/nightlife/2","image":"http://lorempixel.com/965/1499/nightlife/2","description":"Buba gieboca mapek coosbil mu vu rofuliroj cuepe sukupe gur egbib uzioji es sizfahket sudgicrer ne gadicje hozjas. Uhigosi fana luv pil uki ebuizeve fopjulen ememipji norerje zope meb kiw sel segow fu gomi. Tozmoap nedir cejko locipeb osalo os cajsikdec nizsi ki hiwge izika tanana zoj hokre joha. Juz takis fap pozhuzari huruc vace cawri fucos satihke uhe uk po vutgosi anuba coelo.","stock":142},{"id":62,"category_id":6,"reference":"ni-f3173-K","width":236.84,"height":361.88,"price":50.63,"thumbnail":"http://lorempixel.com/79/121/nightlife/3","image":"http://lorempixel.com/1184/1809/nightlife/3","description":"Mo tujab perawes awrahrew ge joago tiiri no an covu gotejso ilu fosefwi uf mu. Jo ralitna di ise huvma ziwrahluj cuhpitev izzov wum gafcu gakuda icuku. Be wekove egarer ro vug lup ta cogja serla lardufojo jahomabed museha mu jajebma nipzun un.","stock":96},{"id":63,"category_id":6,"reference":"ni-hp1kg-T","width":144.32,"height":368.6,"price":30.32,"thumbnail":"http://lorempixel.com/48/123/nightlife/4","image":"http://lorempixel.com/722/1843/nightlife/4","description":"Gizvo uhje luog zikvodile zuwisu han disite be beupo gibuefo bew cikigo ko amha. Ecufiva him buvdolap rizled veberim agu foriju upusaic balopo ker go do zid azaifdun suhopi reb radsehjuw. Cowi nuvsurehi jaku damedal amti tuthiwci heso walozvot ohi uz dil zorek afoga mug lofni ahri. Bi po kabvikgeg dowuto nut ra zuja nuf hejnu jod tajnutkeh bi galimu mim ren vapu. Folripcu vuf kirva no voburki gab ra ruj junwu tiehetu ariti boctumcet kafot. Davgoroc jita fiwa oj azeatjeg mut piwuro adsepid jodjitzi ijakorum zokago zi jutjoj vowa few jupogude.","stock":49},{"id":64,"category_id":6,"reference":"ni-5zwrh-X","width":215.04,"height":320.71,"price":41.19,"thumbnail":"http://lorempixel.com/72/107/nightlife/5","image":"http://lorempixel.com/1075/1604/nightlife/5","description":"Huki fafwo ciulu aceb rev co dulo odbas jegewje ac nejuwij haba nof azofozbaj zug. Mofe cesigeve dov gaafojih hirpefba teh zug unimavnic ocrole fihtavu lupdov keewi mo nudob cumu se up jo. Oc ollalef joboba ado po tujna li lupujhil azpabos rut otubi cem. Tobutiz jadlacok idipaf guknizric ziin nuh ow as makpahlib ted nezbi lurif dowmisco cemti.","stock":113},{"id":65,"category_id":6,"reference":"ni-y8ft4-H","width":170.96,"height":117.02,"price":12.24,"thumbnail":"http://lorempixel.com/57/39/nightlife/6","image":"http://lorempixel.com/855/585/nightlife/6","description":"Jowtuk jogrebol wih fuvtukrim la nada wugev tis lodenzaf wermubro ge ve memi etos. Pel eti iw aco pokepni vipi uzhaati sa zasdidi luew feefgef el. Woc hosber cez aho jag vah hovusa ci ok luf zahfu om aho tucler ahader tusi kormobmer. Botoc wop nut ki ko fapu kodi co wi obalnol naj ohejez. Zasfum suc nim fa wi ji mebze bemeduze as fajuhdek id roszu iga rov. Ar ulguslu ameinseh karajdu os uge uhowic cerespab oga suj tufiduzo tebo caag fu. Okasi fowbefuk ni to soifi duz car valo aza pemara iwoloh fe tedogzo mak vulib.","stock":97},{"id":66,"category_id":6,"reference":"ni-wfnsm-I","width":150.12,"height":320.34,"price":27.05,"thumbnail":"http://lorempixel.com/50/107/nightlife/7","image":"http://lorempixel.com/751/1602/nightlife/7","description":"Pijpikut morpe jol fotsawa wa ser ivepil topafvaj mubgoj regfuk zet sug uhozi. Mavru jotubuz bite ti zuusomo ta zow leh et ha al ki wodudu mibawi. Ehurujom dosunup zujze hejauz lo aticutiw cehit wifiz ikaohisoz vepzo bezonsul ezavebe itlubsi he ne bousase dozcok. Okabaj gos goroj va lilsebaw agcu lajpigca etulot moduzu dibarbo uza kanpihli ag jatul renodol si cuuv. Te ag kucufi canhihad dadda rune zov howomule fuvditba lol up omu omegitu. Da dafune bakolu puju epemip run fuatehu et zolavves rabice ebib cagon nis vuze ra gin va. Ihdovod zum panaih unkim naanfo cat litis zi lolhe lahwe goj fi ohkacmu ewaduf vus gaza.","stock":137},{"id":67,"category_id":6,"reference":"ni-lvpbm-S","width":130.88,"height":133.24,"price":9.22,"thumbnail":"http://lorempixel.com/44/44/nightlife/8","image":"http://lorempixel.com/654/666/nightlife/8","description":"Vo cik muwiz dawebnab da urwa su cig ojeke gijca si gecaw uro icu sabpindo wubla gekuw. Ilcudir tizzet gid ka vodlobli age kaflaevu foda wefo pumvabse zah ce co muifaes. Sibraw saforri le nu pakechi gojdepoj deuco jecsod hodop of recka jukulpa uwkodan cohrebtej iji hormaddo.","stock":31},{"id":68,"category_id":6,"reference":"ni-zloe1-U","width":380.1,"height":193.34,"price":39.55,"thumbnail":"http://lorempixel.com/127/64/nightlife/9","image":"http://lorempixel.com/1901/967/nightlife/9","description":"Opelutovi rordegil gubo pamjina juwojem judraij tezgazkif uf ce vosag to ji omredof civvu. Li buvzaow luhve itvoto timrat kipja zuhzog wuh faadefe forka icruzij melak. Dub zaftij ikuun omodi mebdu veej hur ef pumwab wi keufijo sin tikudosa. Jekrus sijitu zovti mih okse mik sahluwo papeuk vefeh ukila welo ozuet.","stock":31},{"id":69,"category_id":6,"reference":"ni-9z2br-E","width":233.41,"height":109.02,"price":12.81,"thumbnail":"http://lorempixel.com/78/36/nightlife/10","image":"http://lorempixel.com/1167/545/nightlife/10","description":"Rebseovo ufofobfic tev vomin vut janvidziv gore cokel fohzulke doc fimna egu. Jamecka kuzvos jenezco citepca wedoti comimav ga sujekwi ke zejzefcic goruv vel wup duf ko ovaceiji cajopu ekiwokti. Zuweg guc sufsa ze ebu liivoib um kogi wopfa ta fofos ci pukone aglu fesde urajahlok.","stock":141},{"id":70,"category_id":7,"reference":"fa-z9rnm-T","width":388.61,"height":365.9,"price":84.33,"thumbnail":"http://lorempixel.com/130/122/fashion/1","image":"http://lorempixel.com/1943/1830/fashion/1","description":"Bur gude ihukek ortioj gohabe ojjek jeobu pikzuni cel hem god demateh katzos amzof. Dibcerun hewhum halevgo hegfisdi pa ipu vubi megoki ikkila agod uw cug ra iwu ka bobaslo ifesuj jolar. Ugcipuk noocfif jag wesgu iredopku sop eloco orsut alozos naclukim ose sof. Zi zigji vowesnar jam ijlo hukun tov rofiven mal vil zad fenowgi. Uriili asececid gu kaive igovu uwu hag migabej tarawhir piubocu liluh pu owpow ro rema iki sejic. Withibo dowod kakev monirho vuveg defamegu hod icrit wognairi ni powfozoge devnaip la paari ohaceobu.","stock":22},{"id":71,"category_id":7,"reference":"fa-n894d-Y","width":230.16,"height":170.28,"price":21.81,"thumbnail":"http://lorempixel.com/77/57/fashion/2","image":"http://lorempixel.com/1151/851/fashion/2","description":"Di atu suciz vaibolud zeg tus direfnuh danfe cic mofopup sopab koffeoko za cumofota ga. Zibahgaj ipite jego mij row ro uzebu nob vu ahu figdejdo rufubhec huz anigokune dege ce. Vigse ita nubam co alulijsis huuna hekbojo geeb haija tez ri zabri bazeofi iwi bed taira. Ijifku zejlak iloejgoz ekipe suore wu hi joewu erewu co caloado jahakhes. Zompagec row ohaugu ozvirsa gatozisa tuv zedsaz va mumebuome joluce hozegojih tugdid varagcuj bo jogih. Tepzalij pufa povwaj hac oma mus faliluko josupzu awiug avina furcouzo idicijde docvu pif uve meemlaz mageav lofsikrog. Eb digon hemel ziphope si virefse zirahoj baronrov gajlap ji of rivec faom era.","stock":182},{"id":72,"category_id":7,"reference":"fa-jxwpo-O","width":146,"height":195.53,"price":16.78,"thumbnail":"http://lorempixel.com/49/65/fashion/3","image":"http://lorempixel.com/730/978/fashion/3","description":"Sodvuj le eno as aczo joz bocub febuzo ulurada ane hojedva topudkef jibaktej heluhbik bew. Ajbiwfab dowlavuji to okiwado birbaip jerlufo cuhmi di fej fijmoohe wi sam geb bomjam. Iga va rujivekon luhah wuchuimu osvi megelka cu opebauk vo uvi tilra. Pit afivufap jud becun suibfa zekpedsu korto lukce usosulke illuki kuubpu mufzev bimeuhi enu suptooja ho wukcig gibu. Dudkahwop dum em iv hosbopaf enmuvij jagaw hivul idvavviw ana kij nojbe le pezrunu bi uw lu.","stock":14},{"id":73,"category_id":7,"reference":"fa-t6j64-U","width":385.03,"height":306.31,"price":68.76,"thumbnail":"http://lorempixel.com/128/102/fashion/4","image":"http://lorempixel.com/1925/1532/fashion/4","description":"Sikdu vuk ho ge baprusgaw pojola fim gabmapip lakadut lem ran tup sa uda tan. Akudik lo goalo wuw uda pir zotmu losruk lengor cij bub maejtiv dej uc ajdodof geju lip. Hurden mahgoj mofuate nidjoez simdo iseraf iticarij cod mujbolpaw ha kari suwo wukuko nihva pesvu jih. Meru lu opepewuvu so jujgetni sotag va lewwona dulbuprem cen udiohwu seil ticahpon.","stock":186},{"id":74,"category_id":7,"reference":"fa-kwvza-H","width":183.89,"height":339.98,"price":35.57,"thumbnail":"http://lorempixel.com/61/113/fashion/5","image":"http://lorempixel.com/919/1700/fashion/5","description":"Futcev muidibi wedanhap hamitre cuil wazizwus lor wuufasam hadvafsi kus ukpe fovramte omimob jih hop. Orvafa bentu zos vugeoju huhori fumnorhig jenus fukuke acazi wamo cowec rah po uho av wipge ucaraf nulut. Kar gebpum git hum liv bupvu cumtugu koztemog favji diluimo mamucad kijfumcap ribkip revwosini bojfu. Riil reb kiciv moltuz afijo mepte wa oh otufuw koz hu tu igogaw waikpu jo urawo. Uvenigca kufotu jusivdeh iz vihijule muwsip vekgugjuw hutadce taeb kuri vep zew judupe.","stock":123},{"id":75,"category_id":7,"reference":"fa-rsf9f-W","width":139.83,"height":210.3,"price":16.23,"thumbnail":"http://lorempixel.com/47/70/fashion/6","image":"http://lorempixel.com/699/1052/fashion/6","description":"Ne mojiwpu towuv pihva zih wuczeta ranvatu hef lerira si ofves izucuwu boredik gagune cic ig funmizhe. Ehapo maknuimi hug arcafa icaduv ifemaliz jargad rel du hetgavfu azumimfil herul pipwe ejgi. Moljeslo litelohon ivu pamemmos ukmaj vepleci onalci jiw geiphe wohehon amaguhi cesrahok nati dedatoazu cekejil. Anudojfa ude lubsuk aw pupaip jihjojta joncac azpul pojid cu ti ehaemi go cuseni dum jewka. Iwcud bi vauk ici varebja vol mafen nunjekal oruhe ja nankowus vaerhe ra cutvi.","stock":105},{"id":76,"category_id":7,"reference":"fa-zmp4x-Y","width":183.35,"height":286.3,"price":33.66,"thumbnail":"http://lorempixel.com/61/95/fashion/7","image":"http://lorempixel.com/917/1432/fashion/7","description":"Dalhidwiz taezkaj cazti ike dolgub rowub nek unegupve nefene ofoeme kosgovec buak awuanosan hil. Kejej vo ugdifo mosus fojjodhec kutehava bajtuwug up abece fuzipka kiso hoij huamho fukezviz. Por lauz mub va sa zeb anefol rozsijzo devniw ilca wejak razegza memhew fal nehmolfob.","stock":48},{"id":77,"category_id":7,"reference":"fa-7wbbt-Q","width":274.79,"height":121.91,"price":17.43,"thumbnail":"http://lorempixel.com/92/41/fashion/8","image":"http://lorempixel.com/1374/610/fashion/8","description":"Fiddohico nos sozovza fuh conewa cukguckuc hat sape wabisu vimnifa tafwam calaz gautieb gavovkum. Siwud wibizaw kugorge anajiako pu ethaj ret fore kiwiso fapmo caj toranfe moz tud nef kazrohob kuwen. Kacekog zosurdol venogah do inienitid piuzo reh fidodev nudodu pamku puileho pew budezha busruzgig uv bu uvfeodi.","stock":17},{"id":78,"category_id":7,"reference":"fa-i8ahq-U","width":324.13,"height":305.3,"price":50.15,"thumbnail":"http://lorempixel.com/108/102/fashion/9","image":"http://lorempixel.com/1621/1527/fashion/9","description":"Litunmu aneku bestun ge ahedu iva jamkuwi lalena hahlajiz abe ukieno tudo hi. Du zocvare do muw jetpabaj veoki lu cabi cegrejo disiwi ijmud dat oze jukuv ra elosos. Uwejuam nabral bizotwa git maref vamav ref kirur sur nul leseke ibecob. Bagtuv kakorvo wab ihti evo cumvus esfah cez owado weve lu zu naborif.","stock":0},{"id":79,"category_id":7,"reference":"fa-tbuvu-I","width":148.43,"height":150.92,"price":14.14,"thumbnail":"http://lorempixel.com/49/50/fashion/10","image":"http://lorempixel.com/742/755/fashion/10","description":"Goseh moh ela licgunlam dokaf mi bi niozudo zewtus gohecfoz egzoh lesezli sevdolip suf pebabum. Us icretice usera at pinoce jut soz pier run halos ub kawan kukjifehi sa wemnu soce letuhoga lewdohtu. Uwewilar ludgovudo rimdeczid onadugdoc wezugpu paeg zun difro divhu kuci an mu tejupoac sizuh volmac woas kulapnu olorahe. Riv sarmiwi kuna uh nezasmuv ze nibovo dotez keas gonuav paktenehe nar hompih ehefev zufo eho go of. Ti ufunrer denofcoj ducu di sop zoaw ugolob mec pucfu vukze fafokap ibul.","stock":226},{"id":80,"category_id":8,"reference":"pe-08ill-N","width":323.24,"height":332.38,"price":70.05,"thumbnail":"http://lorempixel.com/108/111/people/1","image":"http://lorempixel.com/1616/1662/people/1","description":"Urefiskik nuetu omvuc podles taji cacnufzag tiki novre udkuetu foujace poeba ru jin ujja uw wepge. Hole hiz pojajogub ti fo hef rihusla buzruzter pupu iba ig anzeci. Eljid anuzabiru vapeeb ticciuko za pufite gagevi pewouke wu mokpoz ovizu cer. Jez tetite kovwu zik fezpelo meuv pazuwmof zu ew heced tis etohir zomvopdo wagruc reeha.","stock":0},{"id":81,"category_id":8,"reference":"pe-rtpmi-V","width":392.5,"height":207.84,"price":49.46,"thumbnail":"http://lorempixel.com/131/69/people/2","image":"http://lorempixel.com/1963/1039/people/2","description":"Azkuf biicci jukok bikhuan kutlejro omuco pis pijep keuk vuz vuzeba akbu ge urbe botoboj notofaw zeebuw om. Usarobho iscu ikhil fifegi ir ji rulazi woowho litdamap nuitla omezi tozsiek for jikutwe ivca tihe. Jewwaj hobugek favo vadurjir picuvgaw uwoedebe gi devuc zeot natpuzzik zipadocuc hu gu kaefi mepemwev lihko hovuv. Ubesa siw de jedhikav tu tocupiwi av hid zifkowofo uwle pa dijhan fujteje zetelu digobwi. Kavzenba pirob andalcow he tes fe mezdis kov lop bucig new be ipejac gawep bin vuv nidbac vumem. Mo rirri ribote gacowi zu tawecof ludtotja wizkas gojokme etjabopi fah sapcov. Belnutga rarwu ceoli hivop zu aso solsatjap ra rew zak tirwape cuhviziwo olodoigo nozliz ru vodof uzpog.","stock":75},{"id":82,"category_id":8,"reference":"pe-abqgs-R","width":263.34,"height":165.58,"price":28.71,"thumbnail":"http://lorempixel.com/88/55/people/3","image":"http://lorempixel.com/1317/828/people/3","description":"Vu tewzim ofazucmo beve toigajap nodnug zic riwuteto wi evipesah ke foir immo kagezner nakik kivo jo. Rubear jekezi epzise molis lic zoj vowrofo ti zoha juvok jaepi ta dekrisuw rigbap ni. Ra bauz koari wuj mudrovur ge kahfeko memzoreg ni sojgompom jolwolduk ba sahuj ajtilda je atefoiwa ziusi. Bu cakme solki benapoc jofit domipo abdihaj tugoromep foludo ror ozecjo gunucag pesmu pip sube ofiralob.","stock":0},{"id":83,"category_id":8,"reference":"pe-1g025-B","width":201.22,"height":236.83,"price":25.49,"thumbnail":"http://lorempixel.com/67/79/people/4","image":"http://lorempixel.com/1006/1184/people/4","description":"Oriso sog beehevo oriul uw pudgovce raszor hi ge inposse beluj got. Tofdej iw uhajih bo dawuso dom lolefe tituz ce tec sipu viziw zamip ti. Fazkewa bunakeus renpafnu vema kumabula womu kanso fit gerodlug lidcu ceba muhel lonveda ute zumjubses. Vucmet anaubpi rahel ba gaep kilsir zarse izorad lokanup worsomu fihbe nu. Majirap hufuj wuh deb ludafco bozebrow tuh osnep goz webmus mu eno sekule ca.","stock":68},{"id":84,"category_id":8,"reference":"pe-3wmc1-L","width":239.72,"height":190.02,"price":23.48,"thumbnail":"http://lorempixel.com/80/63/people/5","image":"http://lorempixel.com/1199/950/people/5","description":"Golezubo kiw ginuk ivu kikecmah divuc coaf do warodve necif to kafahva anbu ejuubhol ija gamduuj fewejhas. Jizekre bit zuvazvu faju du fituw olo zear adapitwa zehpo elzed vubiwfi didku sidgeblu abros ulhifim se idjen. Duffav vefuf sor be uligab rocmecod vitfu bitirul dikaepa cunfop ol ribeh nen ima tu vohok ca hi. Uku bub iv pekbu irhiek vomzote mogocbef riled gahona aze cawlehem lusfugbof cukabej hifuv. Kewu kig birudno goelivom zokij kotadi fifor ope jepace min ira ruwdaclig mekkoto was. Kucunazuk bi ob dapnuke dam wewren ava huzmut behriw oksufmi megava hadoori vidiwo delfuj. Bukaju ewkesip vefwutpem culbim tewdet ded goeja taranbuv ojdo ba ugasul uro.","stock":6},{"id":85,"category_id":8,"reference":"pe-dm7dm-N","width":244.23,"height":380.34,"price":56.64,"thumbnail":"http://lorempixel.com/81/127/people/6","image":"http://lorempixel.com/1221/1902/people/6","description":"Siri ric erinumo iho tisafar rota waiba ducro zu vizbumfif aji malufode vor hewuvdes oso muf zuh. Ruc kec daho migho god gu riw jo okifuz akawaz armeb rofu we apo vuz mafohajik lis zilehnew. Dewanu mohkak fi tomka muhegef pe otzo cekudgew cobinan rub lavag lat woliffug el. Izpum pivaklu ca jepjuhpi woriehu wizvilbog puljasun fodum vucluho ke natzuvi uragorbu baphe. Uwimutkop iluloddij weepwum taiwunad ocnurem so habdi lo dooroti lekezuz ujmejoj eme mo gu zatiriv varkekab. Ticujelah niidsej wawni kepaligi iki hit zabfos vuzkakzaw gul rok mofbekju sijuhe helgu. Egje fe ohuave vasa uc ho wewrukib mo peedada tu eta pu woh tuh wehe.","stock":246},{"id":86,"category_id":8,"reference":"pe-lg8uq-S","width":288.35,"height":308.79,"price":44.54,"thumbnail":"http://lorempixel.com/96/103/people/7","image":"http://lorempixel.com/1442/1544/people/7","description":"Cemjim ajagu ihjighev resnav duos oc uvajaj pif pilid hug taarfag iru. Rakal esgi mivbogi rantiv upjo ri hupbefe zi janul baid tip darih epwunij nosoc bivzo vazi kasjuwik ni. Ora userafe huohecej ecojin geose bam giisi zutepohe kibicib melikge pofhu guponij sizvin so. Fozfabed tikoci dem zolmow jeran utevetig ehezawo mi suv ramre keewugi kagudja voakto. Ceube ku ege baugu be agevo cojge niguzvin saijigu aple uh sarob cer ow cij gebtedsow. Mef ifilogsum wuz wi rerjianu voj opsawja liffol tokomjus zusebhe tus lofrekgud mizgafov. Kujiut jozvoip diihnur lut re etsih dakirasec millena udiwi golefaari jow po hizugu ge.","stock":250},{"id":87,"category_id":8,"reference":"pe-y2qo5-T","width":371.94,"height":218.79,"price":52.03,"thumbnail":"http://lorempixel.com/124/73/people/8","image":"http://lorempixel.com/1860/1094/people/8","description":"Womuz liwsih jut sizgepa jupoddu todnodfi womo to nar rajic cefa uz nutadoji in hadvet fesoviw. Ci id lo duba inuvda vi go icuufda dem li lut izban. Ukuamami uvudebnem nokumde jedwit lupapsul rude tize hav weaje noca bilagpu kiwo. Dahepe uhno epeutvuf ajaevu sebnoaca he zedimip azimu midtomuze da virug suzi gawic how bubkoz.","stock":0},{"id":88,"category_id":8,"reference":"pe-3upb2-Q","width":244.19,"height":272.4,"price":41.95,"thumbnail":"http://lorempixel.com/81/91/people/9","image":"http://lorempixel.com/1221/1362/people/9","description":"Ufukaka deohe bek tuzfo ak parvagog todni dozika monneoce wodvok dihwen woro nivre du dan ovusiwme kerelki. Zus vanuik hukdosfal le mowjik heajel zupatwa beg fof kazuror igowabif zinut tujjedzi tenaj ju ana elkito okbonib. Ocrase eputuaza ilaucci vilecbik dodosoh okkifme ohuvikhi melhasda abpo wazawuk iz ger vomomisi ab befta tapdimuc resa. Maazuri wujtup wetmutah roiguvoj suvegto fofevo vaat etivsid vof odo umfeg ise widac ebuh figatap dosrajo. Ev soofloh civfuwwor dulep cetuvba saare mag rimwagjam mo ijazilu ru pulku lozkik vowoze jaf. Fizsi coj gofpo muj hawwaz peweb bis hu wopinni anacajfa uliemwe banmal methuz lavuz iluwi hu doreoge lufehjew.","stock":28},{"id":89,"category_id":8,"reference":"pe-7rhe3-V","width":321.7,"height":117.9,"price":23.36,"thumbnail":"http://lorempixel.com/107/39/people/10","image":"http://lorempixel.com/1609/590/people/10","description":"Oruzel fe metgak mefremkeb uzjuvto wocu aramle culnizeza ucuji fotiibo zokre nif hi gobjivtor. Donoki awumo fowo odi ah zekwu pado raemu nos ofa wud soalimal. Jab memassav ba ocsime uf ohducoj paludwa fuvuko vonefrid majhior viv latze zebfogi seke be. Hir has zi rif fu ova nuhroher ibhe ono re dumele fop pizomu zad bod ojilankid de hot. Zunwecika hifdibug raseije ho baumuwof heljajaz ivcoc kac wubup cuthu juro zokkom imirefnor dafohi rehja. Upeguf wejne bazten nogedi wetof kupavdog cuj anugobana san ik gejawno niwzazdij idjam ivaala id falwob dagojiuza kit.","stock":150},{"id":90,"category_id":9,"reference":"na-84ddc-M","width":216.83,"height":303.06,"price":39.91,"thumbnail":"http://lorempixel.com/72/101/nature/1","image":"http://lorempixel.com/1084/1515/nature/1","description":"Sifajeri pavwero do ihtuge av hunul zusbahar ehduw rahcad zeekli mainoan usde as uzduwoz. Iw gan zofuz favuvno lakili ja fapsem loj beh fakegelez ik kozas bivamu hazholo fo. Lacin pubi inutih ja mackem ojaduvica ok nutiluse za in haw luediho dapliwec duf efida how.","stock":97},{"id":91,"category_id":9,"reference":"na-7nqjx-C","width":266.32,"height":292.2,"price":42.38,"thumbnail":"http://lorempixel.com/89/97/nature/2","image":"http://lorempixel.com/1332/1461/nature/2","description":"Tako katceju hop zep ne zuuza fa vecwijule zer menzeskoh caci de ige mane loru waf gi tes. Gepa biki fa fe segku takeni pemagku lersa da zejnesba fe cac tulavole tuhara ogu irov woenegod. Ufibu hofdotu bujuwoja de junisa nar azrukke eheoj jesif mi lip gat mifuho. Daoga guzig jib pa ban ripzoige komu ude icopo luzid nope wiv oto jiz abkub.","stock":105},{"id":92,"category_id":9,"reference":"na-84f1i-M","width":163.99,"height":271.04,"price":22.68,"thumbnail":"http://lorempixel.com/55/90/nature/3","image":"http://lorempixel.com/820/1355/nature/3","description":"Ge atpojje damom sah licu acpatti iwecapduh keaviza uja wi likuv af tikili nokju kumnefbi ro cesfa lawlovku. Pe izuosi ijeev tanumoac mate pitveko uhnu tan hoesienu ho li uga. Pecimco boij caudetug ucerima sig defgavci amfuima tuf dedmo ininirum wohat itadit kisu cuhil bine. Upefogac bos fisfaf viwdul bajo enuv co dahzil worhizat vaf ketcaac guha piifucuc. Wuihar vem hi iccezona gondem hukanab nit umu wan mo kavza ep fude zepe huknotwak pes le ar. Ze righod silwulde fusezi popebu awe laiciva puhe pocso vokahi bolateadi ora felov.","stock":120},{"id":93,"category_id":9,"reference":"na-02odt-A","width":355.14,"height":376.21,"price":77.92,"thumbnail":"http://lorempixel.com/118/125/nature/4","image":"http://lorempixel.com/1776/1881/nature/4","description":"Fesugju ju nilbaf peji eve kuso ogogomse jud wi tilu cu ildata nohavbu behago durlip agwem. Ado ofierje wudge jezevzoc dehaf ri pigdedeju vuwce zukude heabowa umo majawotu uc ejatilwis osoet ibifavava seb wu. Pov nepe ze oraac jevubi zo zed utooderi pimbe iduozge satonepaw ek bu kut ig let. Sopos soota bawjoti ta ufhehi duga ru ne zuceju degzudu carwekob vamse juwmanho cec. Ide bopwo rugjamek guvdodip penoksig afurigaz hovmav mijofbi gac mavon virfizur leb utamicmup culre wi hefodunab.","stock":56},{"id":94,"category_id":9,"reference":"na-dzvpz-O","width":286.98,"height":248.25,"price":39.88,"thumbnail":"http://lorempixel.com/96/83/nature/5","image":"http://lorempixel.com/1435/1241/nature/5","description":"Votriij anulu ej miludi ewdaba aronagle tadcuwis honobmuk oltovzef sis ijoz idoburog ode sauci na. Erezedwi fopanuh cu bof wis horeiw camteg ralufdi bes te guvzem wid zakohako naev. Luj cihuzi tuj tupahelo dirpu led farhil ke ahogebcos kugikujo lamiwe sip fatdujipe lu barpoki ciwjis. Jejaveg izabo pomizdo rizriv azi sacgekpo gepze isomew canuhe ef abji banreepa gov uwhacip iwelam apdu.","stock":87},{"id":95,"category_id":9,"reference":"na-r4cxc-U","width":282.34,"height":164,"price":26.37,"thumbnail":"http://lorempixel.com/94/55/nature/6","image":"http://lorempixel.com/1412/820/nature/6","description":"Cate ucji jerpimiw digen butaj se sigipmes racfebe zivvegel ju eso vu. Besomot pak mulig fir olibeb huwuved hid ejekepzub gofugwik toduggo rifmudve vaombu du ite egocunho lek odeegir pel. Aci zoefawe fac funnuzja meem sacmem degkat ma gasel akufa pigon juwenno zalsatad punbusnam rorme. Gapsugi si jozbo kagiwho gafobfu liwappa hu korpigjo da poz ajvorur mihocew gipufaheh lewikbo. Raiguozo be egzacvip ziwugfah bottu puceb ufajito cewevned tengip ul fowciwci eno cispagna kepif.","stock":0},{"id":96,"category_id":9,"reference":"na-ypvo6-F","width":263.99,"height":246.05,"price":38.08,"thumbnail":"http://lorempixel.com/88/82/nature/7","image":"http://lorempixel.com/1320/1230/nature/7","description":"Os cel asigilno gidul vunogi peggew ovwiwror ga wuga junhiuv enu bos at ejonohe cuorivet kamib. Lifejup louru bu ca kido din bodu turjofca wifjudul uhu inaessi mibra taobu. Lid sivozcu fiwugno isas datow luil ti ug puugwa pet satuwat bapep juzgi hapu obokakab hi lejma zad. Fabgisuj wuihu tu bahturnu sag ewu rovgaw oto zenvut dosoz ba vaol korne dopati. Egtiljar setol jiw pa jesiuhi fu zastalte asuna pizwo vevev mesifew lube fi. Gur ec opzeif not wutif abrihdew hula ret les zofvamop ag madnuhhu. Re bocupu afoworeb zah po ih nezze zoprer bisdo gariw widpak no gupal kif nimbitwu halwursa.","stock":61},{"id":97,"category_id":9,"reference":"na-w6k2c-H","width":249.43,"height":367.86,"price":53.17,"thumbnail":"http://lorempixel.com/83/123/nature/8","image":"http://lorempixel.com/1247/1839/nature/8","description":"Ezfefci wamhentu diki cu jilo nu civudnop na zewpic tif go zoikisa rodavi dadbud dab. Tuimadi asuflit pifunpo weno abti nij bunkoj fozu hirfeb si emog cok wu jasgikave win waadkef emulihnis oto. Kajedu zieje suoz alihuc gaahe pi jublik mapev ber jipjuka fise wu huhepud upewuma aliiku nercat. Zukbu ga catdovo gur ejido ijeru gagdor merzodam guvo budta fuas tirajozo tawigoto ne rejetper leka.","stock":233},{"id":98,"category_id":9,"reference":"na-k62j0-S","width":106.48,"height":119.82,"price":8.32,"thumbnail":"http://lorempixel.com/35/40/nature/9","image":"http://lorempixel.com/532/599/nature/9","description":"Huuhemim lefpos buwab ra bis is ropcigub daw uc afimu ca tabwo causi peg ecgaile. Eduecme delhighuz wonovo icce mokrowdu ipegiji zipra nuv rimjev wa gad ow ici fiepaca pod wepil ecra. Usludhas kocguggof jir ba adki modi job covazjok biv luadum detujo eciud rusikalu gingodipa rog ra. Fuhuci oswar iv jacvo vu bo zah mawinnaj duoc ot nesana suwfa ruwosle puwemago afe. Joz ihij rakmok sebe osu pudit evolotik wafmo romgakib in karwad ve kemzap wupduv. Hekgun tatibzus tocawe eh kaswolne dedov ozugu dof abaafopa dutofjel jamre ih. Zoretme kugfidav ow cokig helti ut retgocwe oj ozejo nogdasnoj gum dec ecbabgo.","stock":247},{"id":99,"category_id":9,"reference":"na-v0n6d-L","width":276.44,"height":292.09,"price":43.85,"thumbnail":"http://lorempixel.com/92/97/nature/10","image":"http://lorempixel.com/1382/1460/nature/10","description":"Dasuhzec keg ja useiwer cuweh uk pur lif fahur uboket migezo maggum denlascu ka afoli focmuiva. Jowzoca gojeco pohatsos toijpi oradeak gu milhujgi wim kogeluco zeji giltom mireh tezita nigapiano tedi jiv zinjani donfusup. Pudoiwo mewkucav te demeseme ilduuja dazijo pujzep cisap oripfeg okwuz posa cep su loapen sozih daniruoz fanoaz upog. Mebuheef vuja eduek balbaju ite mopozit nepcoimu pe tatramze jeepu jup onuis. Agerovvif jar nu giw pobezi besda ot osvam eg je gimet miral woilepe isvik nen. Kavoak fu larpor wakiihi jidavepo siv ethec reh ilga zuvlabaz iwuda ictaaru hatadmit okna suseppus of fi ocifohram. Caheloga wob muz id be cejam fujlocle kizsif ecevaki ozuofu wu uhuzor.","stock":0},{"id":100,"category_id":10,"reference":"sp-c6sgi-E","width":350.11,"height":213.03,"price":46.83,"thumbnail":"http://lorempixel.com/117/71/sports/1","image":"http://lorempixel.com/1751/1065/sports/1","description":"Ze ga ukifi ciuro uje ritin jod me do setoco ke cepas zi tilkelep mosiz vetdaveh sal. Navpocav ba ret kuli utucif tewekec cano ilibiumo vewoh ku ripjic ji ne sekazju. Wu be lan fowah pigewic usu sij naoh enofajpi sel po dir zahaplo.","stock":0},{"id":101,"category_id":10,"reference":"sp-9g7z7-T","width":272.36,"height":264.6,"price":46.72,"thumbnail":"http://lorempixel.com/91/88/sports/2","image":"http://lorempixel.com/1362/1323/sports/2","description":"Fiafog bupe tibwu duuvgel oge ceg eztac do laz vo uhapufa ad bodi nudsip. Seh tido garguc do janhel tefap jatecda nozok vovazze cew nipecu hi ifci ceto mepuwi gi kaop. Hinjuton sip edozan nelabe uvali tu biwaup si ca lo dunuka wu ec papsira ibvis. Nawewo jij tewpos uj apaapam caf hot masozkos napic wiserotok pad efoofahac netka bub cevfe.","stock":0},{"id":102,"category_id":10,"reference":"sp-yyd6t-J","width":109.98,"height":165.78,"price":11.03,"thumbnail":"http://lorempixel.com/37/55/sports/3","image":"http://lorempixel.com/550/829/sports/3","description":"Fi epmu hatah ho nuom jejosagad uspu efi ep bevorep jef ura naos zo. Etnote kisacu gi jebesa ojo fak sutze rev vin iciarju rosec sip zigdapwop diciov maf om fawaep lamo. Kiwmekor pe ino ekukon mow wovib kid ibde pupten zehosuw tihiga waci ubetop. Ebu eveabujos kedopa rumeso behuk uj goajulef judoco bugke funajek cehiw cojajul jakfikib nukho epu botleah poc furizese. Utteumo bacna zicvefi mip poor notifmo umrum none ec ojegonol ulta afimata owawudvek. Juwjinzi labpijsu ci zan nokwoweni of davivi wojhuz awifegdo davmailu jaigtog bik curgoncad azdi nihuglaj ug.","stock":0},{"id":103,"category_id":10,"reference":"sp-t39ma-I","width":231.39,"height":115.45,"price":15.86,"thumbnail":"http://lorempixel.com/77/38/sports/4","image":"http://lorempixel.com/1157/577/sports/4","description":"Duodaave fum pippe senu wew gad ada nuvcoc pow vilwojva guj pepco vetidca vinuve. Jakone tebuira bamati rifota va omewsor lehip feknadiv gov neri awejeta degimit wes kepami. Palic sizvehum loci mektepsed odvuw lijpalez in duh wih hofopom jofkezak ho. Ahi juhi ussabo wesukif to hamios ek ili lehal sezja funesaza bag. Gug ucataof lewdaw esi zites feojnor wigse nicnoh mouke wacri ibeuk vuzgad adicozpol jokuad teluhve.","stock":89},{"id":104,"category_id":10,"reference":"sp-iqgwu-Q","width":321.06,"height":399.53,"price":75.96,"thumbnail":"http://lorempixel.com/107/133/sports/5","image":"http://lorempixel.com/1605/1998/sports/5","description":"Dejebwi nad hos lo levcabavu wanatedi wid pusov botlipri ap rejwut orotu. Fobbosoj mokhupva guzno cozfa difune nofada pisih aguwiz ezueh won bik jo rozat muig tovcel karsaga kudagho. Oce amokvo gifuwaso sitelo jebe zinzo numi sufiv solsof sopalrig hagi tojor eputal. Nujbew ho lajre vi jorhotfas bem gere puat horabhim mocvulje kukgefiw abi ozpu sut. Jiphatici ucvuowu ni ek wufaw acoivakah satuf weumero fuwjef top tasip vutiza hintezu ge etavacuj. Toohsi idriruf ujhom va rinozru zuicba fovjut wufaw iviazu mudgavje ogo tekif zit ganoja ij.","stock":236},{"id":105,"category_id":10,"reference":"sp-910iw-K","width":124.47,"height":267.79,"price":21.65,"thumbnail":"http://lorempixel.com/41/89/sports/6","image":"http://lorempixel.com/622/1339/sports/6","description":"Tarhe sa suegi nadap jeb ro fe uh du fifokub umagowo ihpecif. Alup fawuhbu ate lotagvip cuz omosok orige adoaciw rovuvra nunuwiz cithumat dotus juvi cujioc dok. Ulaciati wanejar han hevgaditu ja lesvoin upura hahe mimipnu nirfulgof iwcu ojjafa zu goguw hicbusah jos donco patni. Mafil na butew cipalsun zogueja na jonjap hursor reufe samekhib samaz pere uz nubo uvuguji pete te. Hiidpu ij libade visjac dugavboz batwu gugzum va buin ehaib rohnicras kikeubu gallehi. Kawbow enfobse en jib cizapew zo kisocun fiftanez givce hazlapag dumaku ozza. Bugog du la jugoh wuwa akezo teffib bicoh enmidbil we ke zim zozemaho akabuus dufuz zetsi paz go.","stock":106},{"id":106,"category_id":10,"reference":"sp-prlax-D","width":355.18,"height":305.62,"price":65.33,"thumbnail":"http://lorempixel.com/118/102/sports/7","image":"http://lorempixel.com/1776/1528/sports/7","description":"Sogihhig fojafek fimit zi ewa opu ajelocva wueno muhecwi miji sukocac fu keid fapeg huhwun. Fof zecbi dinunwu du open amju arocikris sus ifwi tup zilipna wuvkuben mi dukattu ozawabeg kocozu no. Omuseshaj udo haj avcuhke univje inha kez zetzomtu rit kakemhiz jetwil gu talfus abibmoj surmab uclipim ka pin.","stock":0},{"id":107,"category_id":10,"reference":"sp-xxm14-N","width":351.24,"height":376.23,"price":82.94,"thumbnail":"http://lorempixel.com/117/125/sports/8","image":"http://lorempixel.com/1756/1881/sports/8","description":"Pizcuz ror odi suli mecuffi sas ila vabkegufu kuzman godo zienjed pomcah or defka igwemadi gi limcaevi. Vomu nijgehet jizi givpafvad oc piv tajogozog vigkeli moado povahho vamucin jeb so. Okarivi hes wu padfava jap tu gitnu zar atifeti to relikwi roc tavowu ujate mis ofi.","stock":0},{"id":108,"category_id":10,"reference":"sp-7zllw-J","width":186.8,"height":286.67,"price":32.04,"thumbnail":"http://lorempixel.com/62/96/sports/9","image":"http://lorempixel.com/934/1433/sports/9","description":"Huka radbin odge ba icrepma jeizu ma anu gaf fefmogu tides es. Nenocaure ebgek nok re jirimfi vuktem huvnom umu wohfoiju nak una rofil sim keoho kuhenwal jermotzi anukuid. Tol ez ip ebalupo dudruh agzo ki dihazwup basiwso var ukocipa joj wugov. Uslewusa jumuko dodidmug ivefabwo taerge wo buunal cunhov wu dusojag jujirpa ti. Vofvuw namdinad ico pajhumwe uhfuj we heef roesiwe pe zi bi kofvam.","stock":0},{"id":109,"category_id":10,"reference":"sp-29wl9-N","width":365.43,"height":216.42,"price":45.2,"thumbnail":"http://lorempixel.com/122/72/sports/10","image":"http://lorempixel.com/1827/1082/sports/10","description":"Fod olkusoz nobu ojipebi roila nijizu mibar fuosrec noblagto abi ze bi. Sis jimi bovcuri olfidoro wawefuj limcanso wojucu nik gej fusuritaz go umo pi ev gicwi ruzawew zuhaje. Ma dawpufup deegli be ran viojun coavuvu mer de teribihi bes ozo dej ukara ra ba. Luwdom fike wewel popur botdu awa zipjer na wip vim caw insuov ricsisgo nenunec ji okazettu. Mecehgiz amkif daitvoh viphebeg pec mahcobi fetuzec lippom cepas owded du lin ije.","stock":160},{"id":110,"category_id":11,"reference":"te-pvgxo-V","width":274.96,"height":268.18,"price":44.52,"thumbnail":"http://lorempixel.com/92/89/technics/1","image":"http://lorempixel.com/1375/1341/technics/1","description":"Feclazil hoz jofesa raanika imwi nizave ibigom amekamuz jozaweane tukivgub cenip bapdi. Ildu ufonasjo anizolba sa sekew but cin zadibbor jiadiewo zauftop jugezug vosodac ojmolmid notuv pup. Vi rozuhze luh lahudlir iwicinkac editi tamag dakgudhar opa nat nedima ola ezemev iftujo holafvi vapaoma vurwo. Lukhan vij gicun fevufrac ruev rokutsop sipiwjif jotig citebe av kauhu sehur wec wawgugege ivlag teha cidigsod junhisa.","stock":0},{"id":111,"category_id":11,"reference":"te-1uywd-R","width":109.29,"height":261.76,"price":18.5,"thumbnail":"http://lorempixel.com/36/87/technics/2","image":"http://lorempixel.com/546/1309/technics/2","description":"Gecho tor besar iwfik pe basenve hunim wik toor lioze elahowez kokfum. Pazat ke seg iz won ti wacda mu wuokane daczezrav occigcoj ceuniso vupcaba danriz it kabu. Onwid amaeti efkuw puc daida izaro uv dic wig car ja emepu rirowlod mubgo. Lilip sorkefcok hebrek miz ceze zu hijwezedo bo wudoh oziokap vesmi atomimag vanijedi kahrido fowfaop ajagu sujveep dizuhezu. La sehoze kes fujozu josviv fibi oto leufme zij zeffoewe gurtig sobbodep.","stock":236},{"id":112,"category_id":11,"reference":"te-0lwxp-Q","width":157.99,"height":358.21,"price":35.36,"thumbnail":"http://lorempixel.com/53/119/technics/3","image":"http://lorempixel.com/790/1791/technics/3","description":"Sime sok ajeni hifpapha apamuiw ka pe zefaw roovuila ficgimut jihrudban ob gohe. Vire ib havew vi ve ke luhakeve wozeh fisiwhoz zohajeb pad damtob zo. Od bin ubkedobo ugdos jebres ih cisag hod ij wuhakfab be ne tuhodupa jofgebe derzinmuw vugit li dadan. Ih rug put dohgiwi bepin pucfut te uwnul od luvsiwwid zan elu re agho. Sohobno ja mokzovmus bizkownad nuzvam loh samu go kewejji vu ha mi eku wijpapmoh. Dalzigrat sefji vodko nalke rerenu zohsepma oviolu arunja be ug rir na nef fi kavocmum godriuje obekout hu. Ukvilu jo woslirme fovadin cewejfeg cuvmedni zog ja luluha zo atkeset ti em jecjeb navbidjug.","stock":136},{"id":113,"category_id":11,"reference":"te-1hs6g-A","width":226.17,"height":387.49,"price":56.94,"thumbnail":"http://lorempixel.com/75/129/technics/4","image":"http://lorempixel.com/1131/1937/technics/4","description":"Vopid ti hongoc si suvis awigo solafceb nuzot fad mul dabjilah asuhe nakjuvik nuiho avojnu wiledi merve nesozbi. Uwewuse nuj ewi hin jojas kiveb talas teek vaafo baku sisuflus pojliheh to. Zap lezsa fujofwa gu golelube ohe bajlu lo zego ludaf woudiemo himgisoc belfoipa amjawo. Rag lecpak him ubu co cuf ibuisafa calat hir va si tozer.","stock":0},{"id":114,"category_id":11,"reference":"te-a2h4h-M","width":161.03,"height":321.56,"price":26.76,"thumbnail":"http://lorempixel.com/54/107/technics/5","image":"http://lorempixel.com/805/1608/technics/5","description":"Poaz rov fuci madtazgan opo ane ahiemohiv uzro pa odorez teecumu dez doajodem kaelcun nuznow linmigig. Za ral gorenefen curawiju juug cin ta ci mopi cib sivde rusre jeh judapko ojubepi. Denromlo zalfutsuk menjovliz widpuvse ufozasup ha zew tekbuglew ufunidiw gapta vawi tutukmo rounoha iwzeguv facturma iwfaudi. Uni codiluj zal lute vavhi jup zog zajweh owji buzhevca guj kumamcij ca neihof feptedi zufi soin.","stock":0},{"id":115,"category_id":11,"reference":"te-lng9l-E","width":109.08,"height":210.16,"price":13.05,"thumbnail":"http://lorempixel.com/36/70/technics/6","image":"http://lorempixel.com/545/1051/technics/6","description":"Betapabi zojaluvo cet mawup boruc ba sok etcu zuze mar mukcac ta sigul golwezu. Gucacok pajzub rep guseta jeke red la gap kisako somirgut wor ve niubwab. Zaz ovo iwobojo ko tuozma litu kutsah ilmehan minuw tahze maz fo tiwi. Bac hek con uhinone uzla jegodak bucsup abes leun obaj coufwil agakurva bo fe hav. Kamehso afe paz sarburmo gibu cacof mice sug liwvigkor rigu kas ponugoun gegbo. Raron huosowa beshuddur tij mortaz amurip ra dahni pup fepbinhu re sa gejeg. Tajonedo rusre urirodve oraepip pe fogcohlov pajissuc ruwedi sonzanud rimagvos cofvi jes pot vuliti farbazcac.","stock":180},{"id":116,"category_id":11,"reference":"te-gitfg-Y","width":372.53,"height":347.29,"price":66.46,"thumbnail":"http://lorempixel.com/124/116/technics/7","image":"http://lorempixel.com/1863/1736/technics/7","description":"Kefaen je ne gez dolaco evtucej war putijal pepop opefu si gislusudi onucudtap dumpodpub gezpu tarfogwa igoud. Jabsil nocdundu tepda sufid nimogvif sor fiv tafposniv huvinru izezuwsuv lag hen wuvhamap mipcuce lorud zoljoj nogni. Pez lufelze tuijipof jejuc gur aniogvu zievi voizsu sovaw ba pal volpu. Japopo melamdid eg ozojitsi cupnom vuljiwba voumgul ga evcezta zo zu besepu wozi wu sasmer co iju.","stock":0},{"id":117,"category_id":11,"reference":"te-gpe6t-B","width":171.34,"height":137.6,"price":12.7,"thumbnail":"http://lorempixel.com/57/46/technics/8","image":"http://lorempixel.com/857/688/technics/8","description":"Ron elroghoz polju fuj rujucu eno le jit cajug uho li nupiwero sonen suomohu tinlavgi wa zovuhobi. Pibe mole cumnekne kitop vehjuhafe ogecap te ow jo sulofek bebkun judfe nihiwu juftekas iturenir orogibog mizmob cumo. Li ese isazimoj aloetonud cicolufek ra ik kuf ubzaj afi de izpe mappu asi uba ulowedim iscutuzi. Ose tiruddes aci zuhus herafom to wilit hevag culac ma si vihpe raum to naune vasme igodu ceohrah. Jezwa vadoh hecuf wapdim tulceru si vogate pe fawouga tagiwi lozzaji zudbon fa. Havtitas mi wa wavira jibu iniviedu asrevda meace piv conje lojiaj caothe zolhekes umkiw ce ufkatjo orkesvi fo.","stock":239},{"id":118,"category_id":11,"reference":"te-kppnb-Z","width":144.93,"height":367.14,"price":27.43,"thumbnail":"http://lorempixel.com/48/122/technics/9","image":"http://lorempixel.com/725/1836/technics/9","description":"Urfucuk migag dujranbev hiw havepo vu jo jow wiv ba kasmem nogcahize gazgopis caigete fe kobuago. Apepuz ivdib javkazpe vikhej cac diw ipiko piclel mof fud uk fatmisfu cuz jub po gif tubur. Ta hasulfew uzose eso wegtuvna mebesmu bafantop tanes rot du ohpuhkoj urekot oh buf tuz welot. Isifa zorin pa hubof vizazu loweav lowispoj ci ejap duohmom hifpifol ahha ujukokwi cunu ufehali gijus urugal ul. Rafgavar vigdoj ezavi wiir pogmu besvuil zi epmo timuz ob ji pe kec dizsadrik ubera follov. Sig vesi wov ozsegov vet nitveknum el voruh mikmerase hubit dir kofji umi kun had icdahva.","stock":49},{"id":119,"category_id":11,"reference":"te-5y5fi-O","width":346.59,"height":148.43,"price":26.93,"thumbnail":"http://lorempixel.com/116/49/technics/10","image":"http://lorempixel.com/1733/742/technics/10","description":"Voces tijcuc vusemot uni dawibhet kikke ev ipdut hag zewe hoohi fo. Bogsog erubis embaz tit ta veifoba bihoj kiped pon robigwet cufhij ca. Ez wur watat urijojak mib puleas riz ki zakruh lig nodupfos mezoc peuneuj begvo makakwo.","stock":177},{"id":120,"category_id":12,"reference":"tr-uykot-E","width":127.86,"height":258.01,"price":20.71,"thumbnail":"http://lorempixel.com/43/86/transport/1","image":"http://lorempixel.com/639/1290/transport/1","description":"Miguwu oruca egvido ik er liw satkopbob vu perbi ogsiltac fiehihur basva gimfac. Ematiwab taj ewibat taruhir feapu fufpiula so fan nimazok ce ewuefuv bo. Afi witanfo hujivpi biz fufjad kafupwu hi ado bofpin ucava penzuhko vaul ravijic kodno mownil. Posbo jaggok az aboohoric ca ropvun nodiroh kijgedaka cer biin bem ji voif licrahe. Ehogali gibor vegapiguf wozohewi gunulu fago cakiji remupe unepiz omduhop uri nag. Nazabo jasivov lovso reoda vudseh hunemo wu upgu karha sesuk ciduuho vorjegcum cizfo kazneri lonrudzel zek. To fi hievlu cevmeifo tu oti rawac vo jisomboz wiwra kuddenne wube voela heh cihze legdi.","stock":42},{"id":121,"category_id":12,"reference":"tr-k7r5k-V","width":128.64,"height":181.86,"price":15.53,"thumbnail":"http://lorempixel.com/43/61/transport/2","image":"http://lorempixel.com/643/909/transport/2","description":"Lenepni kogiel ho ejlula guapo edrual vituf roj cokom kow sima pehe jigzug acuhos femirtaj alepuhha. No awcodca icerij zu kuhu fuvfusme kijizom timuhusa nehos po weatja ha omufo. Ugasah biespup fa ne bohuf vez turmonu lop zoh juzov wige cepohwi ezoogo. Ped doltenbom pazhone hulup uz gofe epoha gulrihaj oda womfe vit muzi ihozo lot.","stock":0},{"id":122,"category_id":12,"reference":"tr-9f8ur-N","width":376.81,"height":292.46,"price":59.58,"thumbnail":"http://lorempixel.com/126/97/transport/3","image":"http://lorempixel.com/1884/1462/transport/3","description":"Zickuhde evto go luwku wo vowku zor hitiwi kawid didu si puvpere weh nufelaf wihow. Na burinejoj jepivpa weh cepojdih luda sek borroen ec rekerug fu zalifo iti aze danva demadi. Ve zuwirsav rodcek egrocta sa givi foze gicdogtig movado zur gog vohduezo fofeghi esnu.","stock":230},{"id":123,"category_id":12,"reference":"tr-tcdbu-N","width":383.01,"height":189.8,"price":47.46,"thumbnail":"http://lorempixel.com/128/63/transport/4","image":"http://lorempixel.com/1915/949/transport/4","description":"Oh erovukeme tic vooke hellozoj ifnokwu uvif pe ticimed ficil pibure zolufi zus kocvecvo ruveggif tagju leewu. Kioko rod is je mok laelwef umifuofo ohcap ruz gas ogta jubuwu na falfoeti pal. Ih uwi emuwwo ka guvatna opcat kobodde izinu patun ucu serjor cah zigufov. Ji bonon iwu pe tuugokod co ojlaaw guwi hi onagelawe kog soh ze gi febgo zo vi rek. Te unisaw duf vustosnej wil vujiiki facce lidhit imhutwe ta owu do fuc. Es fi diglewah nassuc jug zit didfandur miwadif vu ile ituri wuulinus sililac hul geh etwas.","stock":226},{"id":124,"category_id":12,"reference":"tr-g4zp4-L","width":371.88,"height":112,"price":21.33,"thumbnail":"http://lorempixel.com/124/37/transport/5","image":"http://lorempixel.com/1859/560/transport/5","description":"Lemij solso ozvoapo riszab pomtokos cufhaw piugroh nefta nosibkal ebupulru ribap oftih vamop ha is eg. Gelos ojafaer on fi resdili iwamukwu ipji pinuva zivvu jofos idisuwfu zaboesu wu moac ulu. Koasi wu gava meh netok ejocorfoj kum tivinge jajijoor upiat luw me jujobaib. Nacuwo zek rar su ziztat becowfo ajihof rit buwna opa bazit jegervi.","stock":167},{"id":125,"category_id":12,"reference":"tr-jdooa-D","width":208.45,"height":150.21,"price":17.34,"thumbnail":"http://lorempixel.com/69/50/transport/6","image":"http://lorempixel.com/1042/751/transport/6","description":"Kenmof jiuv buta ga zuhefnav avpu zebew me eza zunro licafo vutem hotiluz ku wullefom vabun. Go ra ho tekwano zimrod haw an wolci ke joec pug epe. Jalihas mecsahes kojun pisup anamov cizluwlo ibsuwaz nouz vu pidoki mos pifewere ire uzo ibiomueze ni ofi. Fekum pav so retpujmi rukoh bo roje vemic ujdekpez mor tag nes wul me subowsas fodecen jaap. Bacagfuv ibo asra rec uf duihocol bewga ruupako ul utorizen upicomcor luzagecu fujro ji. Ugiri kejuf kojun aducusat arusise watijuk jucecomo bucebuc ugu lilcari zuokji nenwagun waguf ebfofjo dobuco. Ren lolous lupe bugwe cirve pelvu covuh ku biha eciju leziba jo sosoh wezkabo samen iku jige.","stock":175},{"id":126,"category_id":12,"reference":"tr-ad0um-E","width":223.46,"height":366.56,"price":42.1,"thumbnail":"http://lorempixel.com/74/122/transport/7","image":"http://lorempixel.com/1117/1833/transport/7","description":"Colofo tibbop roswefuh cibcaiku ri egunorhu vinluv ejiog za etojiseri sekzu hezziba ku sihultod. Enudonop sitrafu tesgug teaj pagew levibho bavofo nesoncun viduh zedutbi wiwew ob enificdi koj avdi mowe ceola tihkalir. Iducutpe hodmevor widohu ejulu zukor zar neluzva jeulu go uvaak bonnu oliehhes ip iziplon attid ajuz. Jifecdi wa devik er hioni memratcab mi demcut otu lu ak balimo zedes anuteki ne ablu fu.","stock":37},{"id":127,"category_id":12,"reference":"tr-qjreb-T","width":294.82,"height":130.78,"price":24.2,"thumbnail":"http://lorempixel.com/98/44/transport/8","image":"http://lorempixel.com/1474/654/transport/8","description":"Olahihda ziojaci gamwal uwametinu tu fizjop git eblonese uk zohoep tut cekoc eco fogor oriilkup uf. Zos peske guezga fujaw sab giumeegi weegu ga ga ofomorbew bi hi totife soktah. Agsugij gakemlop iheoz ceappo ipuzu bihashi ezu bifluhol napod cacomab pun rogiw oma ces om. Wokitpez ar rav cahjono hulahe cosilebu odgoja foolbir rifcecu avati fe al poj co daje.","stock":117},{"id":128,"category_id":12,"reference":"tr-y9et2-Y","width":329.19,"height":374.32,"price":78.63,"thumbnail":"http://lorempixel.com/110/125/transport/9","image":"http://lorempixel.com/1646/1872/transport/9","description":"Tobe hetputek sulged gu ju nigac vociza zemema duk gov bi lanum. Jivgomisa epgop nes hiad na nol if ova tego abfiwbam ja lo ine ommor wavuhi hunurhu. Vuduhi adasek daojzeb muju eba fe tede ikgerac zevi ikoujevam fozlusu widifuhim mefginoja dob dugzap. Leh wi bov lofaki sopvela si asiev lowwi ajodebeh ak fawluaw zo sihewjo jojjewic hagis pumpob kogupiune. Neskup emuwu peniha cu kajwona oko dolo ivesuule wo wiva poltod kumzo rizdovhoj.","stock":0},{"id":129,"category_id":12,"reference":"tr-6d6df-X","width":221.14,"height":228.77,"price":25.68,"thumbnail":"http://lorempixel.com/74/76/transport/10","image":"http://lorempixel.com/1106/1144/transport/10","description":"Obvide huowu wofripoc tef fibhiwi ojram hom agzogsu inuuwo zaco bezruhe nulva wer aze korol riok futazaf wazag. Wo rimiuz iffog vo aboimabog ace adizofik loec bed jeonje zetaw ideri dar ne dun incuf elile. Gucip elti wijmeg cozomi gucdiddeg ni ec ozo wan bo muh zun tido juw. Okuf ukineh sucac epraha cu jeh ojjunez tivihsoc vu haftahoj pabroju bivipic wac sak na ribcir darofeh des. Few titpofas ujgog kubwo adagi vajocin et acjofuwo vafmudi natsef finemal lepfa maoba ekucvor golucawit. Pacig utzep cowamhet tu napkuvfom okamel lulbo wazcimita gowrukeko carsuv isgaoka ba utmu tishepaga go. Wuveh jiud ko kozitek kiftariv numcetod ce viciglo vire azekopcek oge funaj kumow jiskitoba reduhcil cakgusro upe.","stock":0}],"commands":[{"id":0,"reference":"j7klcv","date":"2014-04-07T12:20:39.044Z","customer_id":114,"basket":[{"product_id":57,"quantity":1}],"total_ex_taxes":29.51,"delivery_fees":3.21,"tax_rate":0.17,"taxes":5.56,"total":38.28,"status":"delivered","returned":true},{"id":1,"reference":"yiud4x","date":"2016-02-18T22:34:05.368Z","customer_id":673,"basket":[{"product_id":66,"quantity":5},{"product_id":76,"quantity":1},{"product_id":76,"quantity":1}],"total_ex_taxes":202.57,"delivery_fees":7.02,"tax_rate":0.12,"taxes":25.15,"total":234.74,"status":"delivered","returned":false},{"id":2,"reference":"thtt63","date":"2016-09-26T09:03:21.021Z","customer_id":421,"basket":[{"product_id":24,"quantity":1},{"product_id":116,"quantity":2}],"total_ex_taxes":168.26,"delivery_fees":6.53,"tax_rate":0.2,"taxes":34.96,"total":209.75,"status":"delivered","returned":false},{"id":3,"reference":"225pgx","date":"2014-11-02T18:43:15.887Z","customer_id":688,"basket":[{"product_id":31,"quantity":1}],"total_ex_taxes":75.27,"delivery_fees":4.61,"tax_rate":0.2,"taxes":15.98,"total":95.86,"status":"delivered","returned":false},{"id":4,"reference":"9f2afa","date":"2016-02-08T18:33:18.006Z","customer_id":294,"basket":[{"product_id":45,"quantity":1},{"product_id":98,"quantity":3}],"total_ex_taxes":44.75,"delivery_fees":5.32,"tax_rate":0.17,"taxes":8.51,"total":58.58,"status":"delivered","returned":false},{"id":5,"reference":"tvaad2","date":"2015-11-06T11:03:41.839Z","customer_id":567,"basket":[{"product_id":74,"quantity":2}],"total_ex_taxes":71.14,"delivery_fees":4.71,"tax_rate":0.12,"taxes":9.1,"total":84.95,"status":"delivered","returned":false},{"id":6,"reference":"m6526w","date":"2016-02-11T12:42:02.413Z","customer_id":492,"basket":[{"product_id":13,"quantity":2}],"total_ex_taxes":125.38,"delivery_fees":7.93,"tax_rate":0.12,"taxes":16,"total":149.31,"status":"delivered","returned":false},{"id":7,"reference":"76ykac","date":"2016-12-08T16:01:55.596Z","customer_id":830,"basket":[{"product_id":95,"quantity":2},{"product_id":42,"quantity":2}],"total_ex_taxes":125.4,"delivery_fees":5.52,"tax_rate":0.17,"taxes":22.26,"total":153.18,"status":"delivered","returned":false},{"id":8,"reference":"9guw6j","date":"2016-10-14T15:30:00.154Z","customer_id":804,"basket":[{"product_id":43,"quantity":2}],"total_ex_taxes":32.28,"delivery_fees":6.6,"tax_rate":0.12,"taxes":4.67,"total":43.55,"status":"delivered","returned":true},{"id":9,"reference":"fe1j9d","date":"2016-08-13T11:21:08.760Z","customer_id":217,"basket":[{"product_id":126,"quantity":1}],"total_ex_taxes":42.1,"delivery_fees":5.71,"tax_rate":0.17,"taxes":8.13,"total":55.94,"status":"cancelled","returned":false},{"id":10,"reference":"0gvfvk","date":"2016-06-03T01:23:37.125Z","customer_id":41,"basket":[{"product_id":69,"quantity":1}],"total_ex_taxes":12.81,"delivery_fees":6.81,"tax_rate":0.17,"taxes":3.34,"total":22.96,"status":"delivered","returned":false},{"id":11,"reference":"dv7tqy","date":"2016-10-15T12:09:42.375Z","customer_id":801,"basket":[{"product_id":100,"quantity":2},{"product_id":71,"quantity":2},{"product_id":97,"quantity":1},{"product_id":101,"quantity":1}],"total_ex_taxes":237.17,"delivery_fees":5.61,"tax_rate":0.2,"taxes":48.56,"total":291.34,"status":"delivered","returned":false},{"id":12,"reference":"56qu6q","date":"2016-07-18T17:14:54.668Z","customer_id":144,"basket":[{"product_id":55,"quantity":5},{"product_id":50,"quantity":1}],"total_ex_taxes":284.21,"delivery_fees":7.22,"tax_rate":0.12,"taxes":34.97,"total":326.4,"status":"delivered","returned":false},{"id":13,"reference":"7dwq5q","date":"2015-10-14T09:24:20.488Z","customer_id":380,"basket":[{"product_id":45,"quantity":4}],"total_ex_taxes":79.16,"delivery_fees":6.32,"tax_rate":0.17,"taxes":14.53,"total":100.01,"status":"delivered","returned":false},{"id":14,"reference":"u9gf2n","date":"2014-04-08T14:24:37.712Z","customer_id":114,"basket":[{"product_id":96,"quantity":1}],"total_ex_taxes":38.08,"delivery_fees":4.31,"tax_rate":0.2,"taxes":8.48,"total":50.87,"status":"delivered","returned":false},{"id":15,"reference":"ies9uc","date":"2016-09-05T14:08:25.463Z","customer_id":90,"basket":[{"product_id":101,"quantity":1}],"total_ex_taxes":46.72,"delivery_fees":4.22,"tax_rate":0.17,"taxes":8.66,"total":59.6,"status":"delivered","returned":false},{"id":16,"reference":"k06ue7","date":"2014-11-26T19:36:31.576Z","customer_id":157,"basket":[{"product_id":84,"quantity":2},{"product_id":62,"quantity":1},{"product_id":128,"quantity":3}],"total_ex_taxes":333.48,"delivery_fees":7.24,"tax_rate":0.2,"taxes":68.14,"total":408.86,"status":"delivered","returned":false},{"id":17,"reference":"65xkiy","date":"2016-03-04T23:55:18.594Z","customer_id":599,"basket":[{"product_id":46,"quantity":1}],"total_ex_taxes":65.21,"delivery_fees":4.98,"tax_rate":0.2,"taxes":14.04,"total":84.23,"status":"delivered","returned":false},{"id":18,"reference":"n7djys","date":"2016-12-04T08:38:48.657Z","customer_id":858,"basket":[{"product_id":39,"quantity":3},{"product_id":22,"quantity":3}],"total_ex_taxes":253.01999999999998,"delivery_fees":7.91,"tax_rate":0.17,"taxes":44.36,"total":305.29,"status":"delivered","returned":false},{"id":19,"reference":"x00le3","date":"2016-03-12T10:06:57.938Z","customer_id":63,"basket":[{"product_id":47,"quantity":4},{"product_id":38,"quantity":1},{"product_id":77,"quantity":1}],"total_ex_taxes":206.22,"delivery_fees":7.86,"tax_rate":0.2,"taxes":42.82,"total":256.9,"status":"delivered","returned":false},{"id":20,"reference":"3u9ki7","date":"2016-12-11T12:48:36.947Z","customer_id":830,"basket":[{"product_id":61,"quantity":2},{"product_id":75,"quantity":5},{"product_id":35,"quantity":5},{"product_id":24,"quantity":1},{"product_id":38,"quantity":4},{"product_id":113,"quantity":1}],"total_ex_taxes":578.8599999999999,"delivery_fees":7.62,"tax_rate":0.17,"taxes":99.7,"total":686.18,"status":"delivered","returned":false},{"id":21,"reference":"qikwn9","date":"2014-08-16T17:55:55.820Z","customer_id":108,"basket":[{"product_id":61,"quantity":2}],"total_ex_taxes":70.12,"delivery_fees":7.62,"tax_rate":0.2,"taxes":15.55,"total":93.29,"status":"delivered","returned":false},{"id":22,"reference":"bekyve","date":"2015-11-23T06:22:40.465Z","customer_id":869,"basket":[{"product_id":96,"quantity":3}],"total_ex_taxes":114.24,"delivery_fees":3.08,"tax_rate":0.17,"taxes":19.94,"total":137.26,"status":"delivered","returned":false},{"id":23,"reference":"t5hfve","date":"2014-12-19T02:26:44.060Z","customer_id":317,"basket":[{"product_id":40,"quantity":1}],"total_ex_taxes":18.49,"delivery_fees":7.34,"tax_rate":0.12,"taxes":3.1,"total":28.93,"status":"delivered","returned":false},{"id":24,"reference":"k1w6ug","date":"2016-05-09T13:44:10.164Z","customer_id":898,"basket":[{"product_id":0,"quantity":1},{"product_id":92,"quantity":1}],"total_ex_taxes":51.33,"delivery_fees":4.07,"tax_rate":0.2,"taxes":11.08,"total":66.48,"status":"cancelled","returned":false},{"id":25,"reference":"ctwouk","date":"2016-12-10T20:12:36.862Z","customer_id":360,"basket":[{"product_id":51,"quantity":1}],"total_ex_taxes":53.38,"delivery_fees":5.83,"tax_rate":0.2,"taxes":11.84,"total":71.05,"status":"delivered","returned":false},{"id":26,"reference":"b6rpii","date":"2016-07-28T08:37:45.944Z","customer_id":741,"basket":[{"product_id":52,"quantity":5},{"product_id":44,"quantity":1}],"total_ex_taxes":118.21000000000001,"delivery_fees":7.15,"tax_rate":0.2,"taxes":25.07,"total":150.43,"status":"delivered","returned":false},{"id":27,"reference":"1ju8ii","date":"2016-06-19T01:24:25.345Z","customer_id":708,"basket":[{"product_id":116,"quantity":2},{"product_id":95,"quantity":3}],"total_ex_taxes":212.02999999999997,"delivery_fees":5.54,"tax_rate":0.17,"taxes":36.99,"total":254.56,"status":"delivered","returned":false},{"id":28,"reference":"wvt9sk","date":"2014-05-05T12:31:14.419Z","customer_id":644,"basket":[{"product_id":5,"quantity":1}],"total_ex_taxes":39.23,"delivery_fees":4.97,"tax_rate":0.17,"taxes":7.51,"total":51.71,"status":"delivered","returned":true},{"id":29,"reference":"32rt1y","date":"2016-10-02T02:24:25.222Z","customer_id":253,"basket":[{"product_id":117,"quantity":3}],"total_ex_taxes":38.099999999999994,"delivery_fees":7.52,"tax_rate":0.12,"taxes":5.47,"total":51.09,"status":"delivered","returned":false},{"id":30,"reference":"6l9xcv","date":"2015-09-14T01:28:47.654Z","customer_id":403,"basket":[{"product_id":16,"quantity":2},{"product_id":68,"quantity":1},{"product_id":0,"quantity":3}],"total_ex_taxes":183.83999999999997,"delivery_fees":5.42,"tax_rate":0.17,"taxes":32.17,"total":221.43,"status":"delivered","returned":true},{"id":31,"reference":"3urm6r","date":"2014-10-31T06:28:22.907Z","customer_id":464,"basket":[{"product_id":13,"quantity":1}],"total_ex_taxes":62.69,"delivery_fees":4.43,"tax_rate":0.17,"taxes":11.41,"total":78.53,"status":"delivered","returned":false},{"id":32,"reference":"8dhfnf","date":"2016-10-19T18:25:21.101Z","customer_id":651,"basket":[{"product_id":47,"quantity":4},{"product_id":73,"quantity":1}],"total_ex_taxes":205.76,"delivery_fees":3.88,"tax_rate":0.2,"taxes":41.93,"total":251.57,"status":"delivered","returned":true},{"id":33,"reference":"r8tplw","date":"2016-06-05T06:34:06.036Z","customer_id":311,"basket":[{"product_id":73,"quantity":3},{"product_id":62,"quantity":1}],"total_ex_taxes":256.91,"delivery_fees":5.6,"tax_rate":0.17,"taxes":44.63,"total":307.14,"status":"cancelled","returned":false},{"id":34,"reference":"kf62zc","date":"2015-11-30T10:09:01.795Z","customer_id":45,"basket":[{"product_id":70,"quantity":1}],"total_ex_taxes":84.33,"delivery_fees":3.72,"tax_rate":0.17,"taxes":14.97,"total":103.02,"status":"delivered","returned":false},{"id":35,"reference":"u5r939","date":"2016-09-22T06:10:32.244Z","customer_id":741,"basket":[{"product_id":23,"quantity":3}],"total_ex_taxes":156.54,"delivery_fees":6.42,"tax_rate":0.17,"taxes":27.7,"total":190.66,"status":"delivered","returned":false},{"id":36,"reference":"qn6mtm","date":"2016-11-23T10:44:35.494Z","customer_id":360,"basket":[{"product_id":107,"quantity":2},{"product_id":20,"quantity":4}],"total_ex_taxes":245.04,"delivery_fees":4.72,"tax_rate":0.2,"taxes":49.95,"total":299.71,"status":"delivered","returned":false},{"id":37,"reference":"fe0gjq","date":"2016-04-01T18:17:16.785Z","customer_id":185,"basket":[{"product_id":96,"quantity":1}],"total_ex_taxes":38.08,"delivery_fees":4.66,"tax_rate":0.17,"taxes":7.27,"total":50.01,"status":"delivered","returned":false},{"id":38,"reference":"tmqehd","date":"2014-06-20T05:16:49.373Z","customer_id":152,"basket":[{"product_id":109,"quantity":2}],"total_ex_taxes":90.4,"delivery_fees":6.99,"tax_rate":0.12,"taxes":11.69,"total":109.08,"status":"delivered","returned":false},{"id":39,"reference":"k3xkyh","date":"2016-10-08T07:15:57.616Z","customer_id":90,"basket":[{"product_id":46,"quantity":2},{"product_id":36,"quantity":3}],"total_ex_taxes":256.12,"delivery_fees":5.92,"tax_rate":0.17,"taxes":44.55,"total":306.59,"status":"delivered","returned":false},{"id":40,"reference":"s9hijv","date":"2015-07-16T15:49:18.753Z","customer_id":541,"basket":[{"product_id":52,"quantity":1}],"total_ex_taxes":7.42,"delivery_fees":4.8,"tax_rate":0.2,"taxes":2.44,"total":14.66,"status":"delivered","returned":false},{"id":41,"reference":"hmvofn","date":"2016-01-26T14:19:32.049Z","customer_id":335,"basket":[{"product_id":107,"quantity":3}],"total_ex_taxes":248.82,"delivery_fees":3.35,"tax_rate":0.17,"taxes":42.87,"total":295.04,"status":"delivered","returned":false},{"id":42,"reference":"gpj5z4","date":"2016-02-06T10:44:55.416Z","customer_id":335,"basket":[{"product_id":124,"quantity":2},{"product_id":32,"quantity":4}],"total_ex_taxes":145.7,"delivery_fees":7.1,"tax_rate":0.17,"taxes":25.98,"total":178.78,"status":"delivered","returned":false},{"id":43,"reference":"5qadm9","date":"2016-03-21T17:11:10.926Z","customer_id":718,"basket":[{"product_id":78,"quantity":1}],"total_ex_taxes":50.15,"delivery_fees":6.03,"tax_rate":0.12,"taxes":6.74,"total":62.92,"status":"delivered","returned":true},{"id":44,"reference":"lbo4oy","date":"2016-06-02T04:47:35.959Z","customer_id":784,"basket":[{"product_id":13,"quantity":3}],"total_ex_taxes":188.07,"delivery_fees":7.86,"tax_rate":0.17,"taxes":33.31,"total":229.24,"status":"delivered","returned":false},{"id":45,"reference":"5dhwgt","date":"2015-01-19T04:31:00.957Z","customer_id":317,"basket":[{"product_id":103,"quantity":1},{"product_id":120,"quantity":1},{"product_id":126,"quantity":3},{"product_id":69,"quantity":1},{"product_id":35,"quantity":3},{"product_id":122,"quantity":2},{"product_id":57,"quantity":2},{"product_id":49,"quantity":5},{"product_id":112,"quantity":2}],"total_ex_taxes":566.87,"delivery_fees":7.66,"tax_rate":0.17,"taxes":97.67,"total":672.2,"status":"cancelled","returned":false},{"id":46,"reference":"2k07l7","date":"2016-12-01T04:32:23.309Z","customer_id":651,"basket":[{"product_id":51,"quantity":1}],"total_ex_taxes":53.38,"delivery_fees":4.23,"tax_rate":0.2,"taxes":11.52,"total":69.13,"status":"delivered","returned":false},{"id":47,"reference":"7erblg","date":"2016-08-31T18:08:50.043Z","customer_id":564,"basket":[{"product_id":120,"quantity":1},{"product_id":51,"quantity":1}],"total_ex_taxes":74.09,"delivery_fees":5.6,"tax_rate":0.17,"taxes":13.55,"total":93.24,"status":"delivered","returned":false},{"id":48,"reference":"i389i5","date":"2017-01-02T12:33:58.744Z","customer_id":554,"basket":[{"product_id":118,"quantity":1}],"total_ex_taxes":27.43,"delivery_fees":6.07,"tax_rate":0.2,"taxes":6.7,"total":40.2,"status":"delivered","returned":false},{"id":49,"reference":"rkthqz","date":"2016-09-28T02:15:28.819Z","customer_id":610,"basket":[{"product_id":85,"quantity":1}],"total_ex_taxes":56.64,"delivery_fees":3.72,"tax_rate":0.12,"taxes":7.24,"total":67.6,"status":"delivered","returned":false},{"id":50,"reference":"ficicu","date":"2015-06-27T14:27:17.614Z","customer_id":152,"basket":[{"product_id":128,"quantity":1}],"total_ex_taxes":78.63,"delivery_fees":5.18,"tax_rate":0.12,"taxes":10.06,"total":93.87,"status":"delivered","returned":false},{"id":51,"reference":"2564ek","date":"2016-01-28T06:10:31.684Z","customer_id":244,"basket":[{"product_id":98,"quantity":1},{"product_id":45,"quantity":2}],"total_ex_taxes":47.9,"delivery_fees":3.28,"tax_rate":0.12,"taxes":6.14,"total":57.32,"status":"delivered","returned":false},{"id":52,"reference":"tdcz6c","date":"2016-08-22T19:11:21.081Z","customer_id":784,"basket":[{"product_id":42,"quantity":1}],"total_ex_taxes":36.33,"delivery_fees":5.06,"tax_rate":0.17,"taxes":7.04,"total":48.43,"status":"cancelled","returned":false},{"id":53,"reference":"vvknz7","date":"2016-04-23T14:42:18.809Z","customer_id":762,"basket":[{"product_id":70,"quantity":3},{"product_id":50,"quantity":5},{"product_id":107,"quantity":2}],"total_ex_taxes":665.6700000000001,"delivery_fees":3.46,"tax_rate":0.12,"taxes":80.3,"total":749.43,"status":"delivered","returned":false},{"id":54,"reference":"n3tyeu","date":"2016-10-16T23:46:06.583Z","customer_id":137,"basket":[{"product_id":65,"quantity":2}],"total_ex_taxes":24.48,"delivery_fees":3.27,"tax_rate":0.2,"taxes":5.55,"total":33.3,"status":"delivered","returned":false},{"id":55,"reference":"syzhas","date":"2015-09-24T04:33:54.963Z","customer_id":866,"basket":[{"product_id":20,"quantity":1}],"total_ex_taxes":19.79,"delivery_fees":6.86,"tax_rate":0.17,"taxes":4.53,"total":31.18,"status":"delivered","returned":false},{"id":56,"reference":"6tr5s3","date":"2016-10-21T00:06:51.174Z","customer_id":801,"basket":[{"product_id":82,"quantity":4},{"product_id":91,"quantity":1},{"product_id":95,"quantity":2},{"product_id":89,"quantity":4},{"product_id":76,"quantity":1},{"product_id":16,"quantity":1},{"product_id":13,"quantity":1},{"product_id":31,"quantity":3},{"product_id":114,"quantity":2}],"total_ex_taxes":708.25,"delivery_fees":4.36,"tax_rate":0.12,"taxes":85.51,"total":798.12,"status":"delivered","returned":false},{"id":57,"reference":"dz198h","date":"2016-07-26T09:12:58.552Z","customer_id":576,"basket":[{"product_id":90,"quantity":4},{"product_id":129,"quantity":5},{"product_id":84,"quantity":2}],"total_ex_taxes":334.99999999999994,"delivery_fees":5.69,"tax_rate":0.2,"taxes":68.14,"total":408.83,"status":"delivered","returned":false},{"id":58,"reference":"btcuk6","date":"2016-12-20T11:02:00.526Z","customer_id":85,"basket":[{"product_id":64,"quantity":1}],"total_ex_taxes":41.19,"delivery_fees":5.9,"tax_rate":0.12,"taxes":5.65,"total":52.74,"status":"ordered","returned":false},{"id":59,"reference":"6pcjj8","date":"2016-03-21T11:46:44.014Z","customer_id":727,"basket":[{"product_id":38,"quantity":1},{"product_id":93,"quantity":1},{"product_id":88,"quantity":2}],"total_ex_taxes":213.61,"delivery_fees":3.59,"tax_rate":0.17,"taxes":36.92,"total":254.12,"status":"delivered","returned":false},{"id":60,"reference":"sqfs1y","date":"2016-12-12T14:07:56.272Z","customer_id":774,"basket":[{"product_id":16,"quantity":1}],"total_ex_taxes":29.17,"delivery_fees":5.95,"tax_rate":0.17,"taxes":5.97,"total":41.09,"status":"delivered","returned":false},{"id":61,"reference":"dxkbeh","date":"2016-10-19T20:20:43.017Z","customer_id":610,"basket":[{"product_id":38,"quantity":1}],"total_ex_taxes":51.79,"delivery_fees":6.41,"tax_rate":0.17,"taxes":9.89,"total":68.09,"status":"delivered","returned":false},{"id":62,"reference":"b5ui7e","date":"2016-08-20T23:42:48.289Z","customer_id":558,"basket":[{"product_id":56,"quantity":1}],"total_ex_taxes":22.41,"delivery_fees":3.07,"tax_rate":0.2,"taxes":5.1,"total":30.58,"status":"delivered","returned":false},{"id":63,"reference":"zbp4pv","date":"2015-10-24T16:03:57.270Z","customer_id":727,"basket":[{"product_id":46,"quantity":1},{"product_id":25,"quantity":1}],"total_ex_taxes":95.85999999999999,"delivery_fees":5.35,"tax_rate":0.2,"taxes":20.24,"total":121.45,"status":"cancelled","returned":false},{"id":64,"reference":"2ywd2m","date":"2016-04-27T07:52:11.437Z","customer_id":41,"basket":[{"product_id":89,"quantity":1}],"total_ex_taxes":23.36,"delivery_fees":4.2,"tax_rate":0.2,"taxes":5.51,"total":33.07,"status":"cancelled","returned":false},{"id":65,"reference":"2ox1yd","date":"2015-01-30T01:14:24.130Z","customer_id":364,"basket":[{"product_id":57,"quantity":5},{"product_id":21,"quantity":2}],"total_ex_taxes":247.01,"delivery_fees":7.69,"tax_rate":0.2,"taxes":50.94,"total":305.64,"status":"delivered","returned":false},{"id":66,"reference":"tlwgwh","date":"2016-09-19T13:29:25.624Z","customer_id":675,"basket":[{"product_id":26,"quantity":2},{"product_id":116,"quantity":2}],"total_ex_taxes":199.23999999999998,"delivery_fees":5.51,"tax_rate":0.12,"taxes":24.57,"total":229.32,"status":"delivered","returned":false},{"id":67,"reference":"7f6320","date":"2016-09-03T14:58:35.077Z","customer_id":217,"basket":[{"product_id":36,"quantity":2}],"total_ex_taxes":83.8,"delivery_fees":4.74,"tax_rate":0.2,"taxes":17.71,"total":106.25,"status":"delivered","returned":false},{"id":68,"reference":"sr3bu8","date":"2015-12-02T17:43:33.206Z","customer_id":280,"basket":[{"product_id":129,"quantity":4},{"product_id":36,"quantity":1}],"total_ex_taxes":144.62,"delivery_fees":6,"tax_rate":0.12,"taxes":18.07,"total":168.69,"status":"cancelled","returned":false},{"id":69,"reference":"z1da31","date":"2015-06-22T09:58:01.158Z","customer_id":675,"basket":[{"product_id":113,"quantity":1}],"total_ex_taxes":56.94,"delivery_fees":4.62,"tax_rate":0.2,"taxes":12.31,"total":73.87,"status":"delivered","returned":false},{"id":70,"reference":"kjis36","date":"2016-11-30T23:57:16.741Z","customer_id":197,"basket":[{"product_id":56,"quantity":1}],"total_ex_taxes":22.41,"delivery_fees":5.54,"tax_rate":0.12,"taxes":3.35,"total":31.3,"status":"delivered","returned":false},{"id":71,"reference":"8uv47p","date":"2016-10-02T10:54:04.150Z","customer_id":390,"basket":[{"product_id":67,"quantity":1},{"product_id":86,"quantity":1},{"product_id":1,"quantity":1}],"total_ex_taxes":109.99,"delivery_fees":6.87,"tax_rate":0.2,"taxes":23.37,"total":140.23,"status":"delivered","returned":false},{"id":72,"reference":"4zp2w3","date":"2016-11-15T11:15:43.852Z","customer_id":350,"basket":[{"product_id":17,"quantity":1}],"total_ex_taxes":60.12,"delivery_fees":3.19,"tax_rate":0.12,"taxes":7.6,"total":70.91,"status":"cancelled","returned":false},{"id":73,"reference":"tuutp4","date":"2016-05-11T10:23:09.180Z","customer_id":898,"basket":[{"product_id":123,"quantity":1},{"product_id":22,"quantity":5}],"total_ex_taxes":304.65999999999997,"delivery_fees":6.91,"tax_rate":0.2,"taxes":62.31,"total":373.88,"status":"cancelled","returned":false},{"id":74,"reference":"po8na2","date":"2015-08-21T20:15:32.502Z","customer_id":869,"basket":[{"product_id":1,"quantity":1}],"total_ex_taxes":56.23,"delivery_fees":4.82,"tax_rate":0.12,"taxes":7.33,"total":68.38,"status":"cancelled","returned":false},{"id":75,"reference":"2cks8o","date":"2016-09-19T23:32:46.135Z","customer_id":428,"basket":[{"product_id":26,"quantity":2},{"product_id":89,"quantity":4},{"product_id":9,"quantity":1},{"product_id":2,"quantity":1},{"product_id":38,"quantity":2},{"product_id":4,"quantity":2}],"total_ex_taxes":435.92,"delivery_fees":4.14,"tax_rate":0.12,"taxes":52.81,"total":492.87,"status":"delivered","returned":false},{"id":76,"reference":"gd0e5z","date":"2015-08-06T09:09:57.367Z","customer_id":381,"basket":[{"product_id":26,"quantity":2},{"product_id":74,"quantity":3}],"total_ex_taxes":173.03,"delivery_fees":4.33,"tax_rate":0.17,"taxes":30.15,"total":207.51,"status":"delivered","returned":false},{"id":77,"reference":"pdg1eh","date":"2016-01-31T19:09:25.390Z","customer_id":394,"basket":[{"product_id":20,"quantity":1}],"total_ex_taxes":19.79,"delivery_fees":6.75,"tax_rate":0.17,"taxes":4.51,"total":31.05,"status":"cancelled","returned":false},{"id":78,"reference":"r7pqj2","date":"2016-05-20T06:05:11.154Z","customer_id":718,"basket":[{"product_id":39,"quantity":1},{"product_id":77,"quantity":1},{"product_id":122,"quantity":1},{"product_id":99,"quantity":1}],"total_ex_taxes":153.76,"delivery_fees":7.04,"tax_rate":0.17,"taxes":27.34,"total":188.14,"status":"delivered","returned":false},{"id":79,"reference":"hnq3kk","date":"2013-07-25T01:12:12.410Z","customer_id":254,"basket":[{"product_id":74,"quantity":1},{"product_id":57,"quantity":5}],"total_ex_taxes":183.12,"delivery_fees":3.7,"tax_rate":0.17,"taxes":31.76,"total":218.58,"status":"delivered","returned":false},{"id":80,"reference":"tmn9q3","date":"2016-04-18T11:31:48.440Z","customer_id":185,"basket":[{"product_id":74,"quantity":2},{"product_id":7,"quantity":1}],"total_ex_taxes":82.64,"delivery_fees":5.1,"tax_rate":0.12,"taxes":10.53,"total":98.27,"status":"delivered","returned":true},{"id":81,"reference":"q2fbz5","date":"2016-05-07T14:22:28.800Z","customer_id":816,"basket":[{"product_id":21,"quantity":3}],"total_ex_taxes":149.19,"delivery_fees":5.3,"tax_rate":0.17,"taxes":26.26,"total":180.75,"status":"delivered","returned":false},{"id":82,"reference":"j3orb0","date":"2016-05-09T23:16:47.258Z","customer_id":159,"basket":[{"product_id":109,"quantity":2},{"product_id":118,"quantity":1}],"total_ex_taxes":117.83000000000001,"delivery_fees":4.27,"tax_rate":0.2,"taxes":24.42,"total":146.52,"status":"delivered","returned":false},{"id":83,"reference":"mrwtzw","date":"2015-12-28T07:38:27.001Z","customer_id":412,"basket":[{"product_id":36,"quantity":5}],"total_ex_taxes":209.5,"delivery_fees":3.39,"tax_rate":0.12,"taxes":25.55,"total":238.44,"status":"delivered","returned":false},{"id":84,"reference":"95tz85","date":"2016-02-16T01:50:09.146Z","customer_id":19,"basket":[{"product_id":12,"quantity":2},{"product_id":109,"quantity":1}],"total_ex_taxes":150.32,"delivery_fees":4.16,"tax_rate":0.2,"taxes":30.9,"total":185.38,"status":"delivered","returned":false},{"id":85,"reference":"fjbtkx","date":"2016-08-26T01:37:08.567Z","customer_id":538,"basket":[{"product_id":54,"quantity":2},{"product_id":83,"quantity":1}],"total_ex_taxes":143.33,"delivery_fees":3.84,"tax_rate":0.2,"taxes":29.43,"total":176.6,"status":"delivered","returned":false},{"id":86,"reference":"py0j5s","date":"2016-08-07T11:36:08.990Z","customer_id":481,"basket":[{"product_id":9,"quantity":1},{"product_id":31,"quantity":4},{"product_id":12,"quantity":1},{"product_id":90,"quantity":1},{"product_id":59,"quantity":1},{"product_id":24,"quantity":5}],"total_ex_taxes":647.9799999999999,"delivery_fees":5.76,"tax_rate":0.12,"taxes":78.45,"total":732.19,"status":"delivered","returned":false},{"id":87,"reference":"yroh7q","date":"2016-03-20T00:29:48.625Z","customer_id":289,"basket":[{"product_id":46,"quantity":1}],"total_ex_taxes":65.21,"delivery_fees":5.2,"tax_rate":0.12,"taxes":8.45,"total":78.86,"status":"delivered","returned":false},{"id":88,"reference":"0qqxnj","date":"2016-12-16T15:27:45.430Z","customer_id":197,"basket":[{"product_id":71,"quantity":2},{"product_id":56,"quantity":1}],"total_ex_taxes":66.03,"delivery_fees":6.29,"tax_rate":0.2,"taxes":14.46,"total":86.78,"status":"delivered","returned":false},{"id":89,"reference":"dqh6qm","date":"2016-11-04T06:02:19.458Z","customer_id":31,"basket":[{"product_id":56,"quantity":2}],"total_ex_taxes":44.82,"delivery_fees":4.26,"tax_rate":0.2,"taxes":9.82,"total":58.9,"status":"delivered","returned":false},{"id":90,"reference":"gcde81","date":"2016-02-29T02:32:11.445Z","customer_id":280,"basket":[{"product_id":119,"quantity":1},{"product_id":59,"quantity":2}],"total_ex_taxes":103.09,"delivery_fees":6.1,"tax_rate":0.17,"taxes":18.56,"total":127.75,"status":"delivered","returned":false},{"id":91,"reference":"aw6k11","date":"2016-10-05T19:36:15.081Z","customer_id":90,"basket":[{"product_id":46,"quantity":2},{"product_id":107,"quantity":2}],"total_ex_taxes":296.29999999999995,"delivery_fees":4.61,"tax_rate":0.12,"taxes":36.11,"total":337.02,"status":"delivered","returned":false},{"id":92,"reference":"ur529w","date":"2015-08-17T17:18:30.992Z","customer_id":363,"basket":[{"product_id":116,"quantity":1},{"product_id":9,"quantity":1}],"total_ex_taxes":106.10999999999999,"delivery_fees":5.37,"tax_rate":0.2,"taxes":22.3,"total":133.78,"status":"delivered","returned":false},{"id":93,"reference":"8ty1mn","date":"2015-01-27T21:21:58.063Z","customer_id":491,"basket":[{"product_id":86,"quantity":1}],"total_ex_taxes":44.54,"delivery_fees":7.63,"tax_rate":0.17,"taxes":8.87,"total":61.04,"status":"delivered","returned":false},{"id":94,"reference":"1u9zuc","date":"2016-11-11T14:48:23.498Z","customer_id":533,"basket":[{"product_id":33,"quantity":2},{"product_id":54,"quantity":4}],"total_ex_taxes":273,"delivery_fees":7.47,"tax_rate":0.17,"taxes":47.68,"total":328.15,"status":"delivered","returned":false},{"id":95,"reference":"1tmet7","date":"2016-03-24T00:18:47.769Z","customer_id":152,"basket":[{"product_id":97,"quantity":1}],"total_ex_taxes":53.17,"delivery_fees":3.09,"tax_rate":0.17,"taxes":9.56,"total":65.82,"status":"delivered","returned":false},{"id":96,"reference":"marhjz","date":"2016-10-09T03:13:03.188Z","customer_id":351,"basket":[{"product_id":43,"quantity":2}],"total_ex_taxes":32.28,"delivery_fees":6.57,"tax_rate":0.12,"taxes":4.66,"total":43.51,"status":"delivered","returned":false},{"id":97,"reference":"oh5wle","date":"2016-08-02T07:28:37.975Z","customer_id":63,"basket":[{"product_id":100,"quantity":1},{"product_id":94,"quantity":1},{"product_id":54,"quantity":4},{"product_id":94,"quantity":2},{"product_id":90,"quantity":2},{"product_id":1,"quantity":2},{"product_id":86,"quantity":2}],"total_ex_taxes":683.51,"delivery_fees":3.04,"tax_rate":0.17,"taxes":116.71,"total":803.26,"status":"delivered","returned":false},{"id":98,"reference":"mqkath","date":"2016-11-26T04:54:47.324Z","customer_id":610,"basket":[{"product_id":121,"quantity":1}],"total_ex_taxes":15.53,"delivery_fees":5.62,"tax_rate":0.17,"taxes":3.6,"total":24.75,"status":"delivered","returned":false},{"id":99,"reference":"140yp4","date":"2014-06-14T15:51:21.758Z","customer_id":114,"basket":[{"product_id":70,"quantity":3},{"product_id":82,"quantity":2},{"product_id":41,"quantity":1},{"product_id":68,"quantity":1},{"product_id":90,"quantity":1}],"total_ex_taxes":431.81000000000006,"delivery_fees":3.62,"tax_rate":0.17,"taxes":74.02,"total":509.45,"status":"delivered","returned":false},{"id":100,"reference":"7o1mgm","date":"2016-01-09T13:16:45.139Z","customer_id":200,"basket":[{"product_id":127,"quantity":5}],"total_ex_taxes":121,"delivery_fees":5.59,"tax_rate":0.2,"taxes":25.32,"total":151.91,"status":"delivered","returned":false},{"id":101,"reference":"r4mh9i","date":"2015-01-01T08:37:11.008Z","customer_id":44,"basket":[{"product_id":105,"quantity":4}],"total_ex_taxes":86.6,"delivery_fees":7.99,"tax_rate":0.12,"taxes":11.35,"total":105.94,"status":"delivered","returned":false},{"id":102,"reference":"pi9pcg","date":"2016-09-27T15:22:32.112Z","customer_id":792,"basket":[{"product_id":33,"quantity":1}],"total_ex_taxes":18.66,"delivery_fees":3.25,"tax_rate":0.17,"taxes":3.72,"total":25.63,"status":"delivered","returned":false},{"id":103,"reference":"nejocc","date":"2014-11-01T17:13:12.441Z","customer_id":108,"basket":[{"product_id":45,"quantity":3}],"total_ex_taxes":59.37,"delivery_fees":3.51,"tax_rate":0.2,"taxes":12.58,"total":75.46,"status":"delivered","returned":false},{"id":104,"reference":"zgmb31","date":"2015-10-02T02:16:44.190Z","customer_id":496,"basket":[{"product_id":70,"quantity":1}],"total_ex_taxes":84.33,"delivery_fees":4.74,"tax_rate":0.17,"taxes":15.14,"total":104.21,"status":"cancelled","returned":false},{"id":105,"reference":"241wv4","date":"2016-11-11T15:57:52.385Z","customer_id":502,"basket":[{"product_id":64,"quantity":1}],"total_ex_taxes":41.19,"delivery_fees":7.01,"tax_rate":0.12,"taxes":5.78,"total":53.98,"status":"delivered","returned":false},{"id":106,"reference":"5y68x6","date":"2014-11-08T13:41:26.201Z","customer_id":462,"basket":[{"product_id":118,"quantity":1},{"product_id":89,"quantity":1},{"product_id":86,"quantity":2},{"product_id":6,"quantity":4}],"total_ex_taxes":376.83000000000004,"delivery_fees":3.65,"tax_rate":0.2,"taxes":76.1,"total":456.58,"status":"delivered","returned":false},{"id":107,"reference":"kf4v11","date":"2015-12-21T23:23:35.293Z","customer_id":359,"basket":[{"product_id":62,"quantity":2},{"product_id":87,"quantity":1}],"total_ex_taxes":153.29000000000002,"delivery_fees":4.76,"tax_rate":0.17,"taxes":26.87,"total":184.92,"status":"delivered","returned":false},{"id":108,"reference":"863yh7","date":"2016-11-22T18:22:23.598Z","customer_id":502,"basket":[{"product_id":46,"quantity":2},{"product_id":6,"quantity":4}],"total_ex_taxes":367.38,"delivery_fees":4.15,"tax_rate":0.12,"taxes":44.58,"total":416.11,"status":"delivered","returned":false},{"id":109,"reference":"j122ib","date":"2016-01-15T19:25:47.691Z","customer_id":54,"basket":[{"product_id":116,"quantity":2}],"total_ex_taxes":132.92,"delivery_fees":4.66,"tax_rate":0.12,"taxes":16.51,"total":154.09,"status":"delivered","returned":false},{"id":110,"reference":"mt8bjr","date":"2016-12-06T01:05:47.331Z","customer_id":61,"basket":[{"product_id":123,"quantity":1},{"product_id":104,"quantity":3}],"total_ex_taxes":275.34,"delivery_fees":4.11,"tax_rate":0.2,"taxes":55.89,"total":335.34,"status":"delivered","returned":false},{"id":111,"reference":"qqylmm","date":"2014-10-10T20:22:32.910Z","customer_id":86,"basket":[{"product_id":113,"quantity":2}],"total_ex_taxes":113.88,"delivery_fees":5.6,"tax_rate":0.12,"taxes":14.34,"total":133.82,"status":"delivered","returned":false},{"id":112,"reference":"egyelj","date":"2016-11-14T10:39:06.884Z","customer_id":237,"basket":[{"product_id":127,"quantity":1},{"product_id":109,"quantity":1}],"total_ex_taxes":69.4,"delivery_fees":6,"tax_rate":0.2,"taxes":15.08,"total":90.48,"status":"delivered","returned":false},{"id":113,"reference":"k485xe","date":"2016-05-08T19:02:55.881Z","customer_id":195,"basket":[{"product_id":38,"quantity":2}],"total_ex_taxes":103.58,"delivery_fees":5,"tax_rate":0.17,"taxes":18.46,"total":127.04,"status":"delivered","returned":false},{"id":114,"reference":"rhmgcb","date":"2016-10-18T10:51:12.355Z","customer_id":237,"basket":[{"product_id":49,"quantity":1},{"product_id":38,"quantity":1}],"total_ex_taxes":64.87,"delivery_fees":7.49,"tax_rate":0.17,"taxes":12.3,"total":84.66,"status":"cancelled","returned":false},{"id":115,"reference":"h6hmbo","date":"2016-02-16T22:34:42.801Z","customer_id":294,"basket":[{"product_id":40,"quantity":2}],"total_ex_taxes":36.98,"delivery_fees":4.48,"tax_rate":0.2,"taxes":8.29,"total":49.75,"status":"delivered","returned":false},{"id":116,"reference":"o8hf53","date":"2016-06-12T04:07:09.380Z","customer_id":296,"basket":[{"product_id":63,"quantity":2},{"product_id":94,"quantity":1},{"product_id":72,"quantity":2},{"product_id":94,"quantity":3}],"total_ex_taxes":253.72000000000003,"delivery_fees":5.88,"tax_rate":0.2,"taxes":51.92,"total":311.52,"status":"delivered","returned":false},{"id":117,"reference":"mujag4","date":"2015-09-11T18:58:19.500Z","customer_id":472,"basket":[{"product_id":57,"quantity":1},{"product_id":44,"quantity":1}],"total_ex_taxes":110.62,"delivery_fees":3.14,"tax_rate":0.2,"taxes":22.75,"total":136.51,"status":"delivered","returned":false},{"id":118,"reference":"3kns8x","date":"2016-09-20T01:50:37.808Z","customer_id":514,"basket":[{"product_id":12,"quantity":2}],"total_ex_taxes":105.12,"delivery_fees":3.38,"tax_rate":0.2,"taxes":21.7,"total":130.2,"status":"delivered","returned":false},{"id":119,"reference":"98j83x","date":"2016-05-05T01:02:45.472Z","customer_id":159,"basket":[{"product_id":56,"quantity":3},{"product_id":129,"quantity":1}],"total_ex_taxes":92.91,"delivery_fees":5.98,"tax_rate":0.17,"taxes":16.81,"total":115.7,"status":"delivered","returned":false},{"id":120,"reference":"is2ab5","date":"2015-10-07T13:43:16.465Z","customer_id":364,"basket":[{"product_id":10,"quantity":1},{"product_id":95,"quantity":3},{"product_id":62,"quantity":3}],"total_ex_taxes":253.02,"delivery_fees":3.25,"tax_rate":0.12,"taxes":30.75,"total":287.02,"status":"delivered","returned":false},{"id":121,"reference":"wx9tuj","date":"2016-12-20T14:27:41.954Z","customer_id":485,"basket":[{"product_id":61,"quantity":2},{"product_id":17,"quantity":3}],"total_ex_taxes":250.48,"delivery_fees":6.01,"tax_rate":0.17,"taxes":43.6,"total":300.09,"status":"ordered","returned":false},{"id":122,"reference":"4g1tjl","date":"2016-08-31T23:03:38.704Z","customer_id":90,"basket":[{"product_id":40,"quantity":4}],"total_ex_taxes":73.96,"delivery_fees":4.06,"tax_rate":0.12,"taxes":9.36,"total":87.38,"status":"cancelled","returned":false},{"id":123,"reference":"6ssf4q","date":"2016-12-24T03:16:43.802Z","customer_id":585,"basket":[{"product_id":64,"quantity":5}],"total_ex_taxes":205.95,"delivery_fees":4.3,"tax_rate":0.12,"taxes":25.23,"total":235.48,"status":"delivered","returned":false},{"id":124,"reference":"nsxoa2","date":"2016-09-28T05:44:40.113Z","customer_id":253,"basket":[{"product_id":57,"quantity":1}],"total_ex_taxes":29.51,"delivery_fees":3.08,"tax_rate":0.17,"taxes":5.54,"total":38.13,"status":"delivered","returned":false},{"id":125,"reference":"em9t8z","date":"2016-08-16T19:21:58.060Z","customer_id":280,"basket":[{"product_id":47,"quantity":3},{"product_id":33,"quantity":3},{"product_id":81,"quantity":2},{"product_id":1,"quantity":2},{"product_id":84,"quantity":1},{"product_id":127,"quantity":2},{"product_id":89,"quantity":2},{"product_id":54,"quantity":3},{"product_id":62,"quantity":1},{"product_id":104,"quantity":3}],"total_ex_taxes":943.98,"delivery_fees":4.55,"tax_rate":0.12,"taxes":113.82,"total":1062.35,"status":"delivered","returned":false},{"id":126,"reference":"d0iv8r","date":"2015-07-14T04:39:29.433Z","customer_id":271,"basket":[{"product_id":105,"quantity":4},{"product_id":52,"quantity":1},{"product_id":23,"quantity":2}],"total_ex_taxes":198.38,"delivery_fees":5.78,"tax_rate":0.12,"taxes":24.5,"total":228.66,"status":"delivered","returned":false},{"id":127,"reference":"ltiyj6","date":"2015-09-17T04:54:48.976Z","customer_id":189,"basket":[{"product_id":21,"quantity":5}],"total_ex_taxes":248.64999999999998,"delivery_fees":3.62,"tax_rate":0.12,"taxes":30.27,"total":282.54,"status":"cancelled","returned":false},{"id":128,"reference":"yb8c3g","date":"2015-05-18T14:42:16.279Z","customer_id":661,"basket":[{"product_id":56,"quantity":1},{"product_id":124,"quantity":3},{"product_id":26,"quantity":1},{"product_id":116,"quantity":1},{"product_id":127,"quantity":2},{"product_id":71,"quantity":1},{"product_id":58,"quantity":1},{"product_id":56,"quantity":1}],"total_ex_taxes":348.96,"delivery_fees":4.77,"tax_rate":0.2,"taxes":70.75,"total":424.48,"status":"delivered","returned":false},{"id":129,"reference":"fg1lje","date":"2016-12-26T14:55:59.136Z","customer_id":718,"basket":[{"product_id":49,"quantity":1},{"product_id":27,"quantity":4}],"total_ex_taxes":67.4,"delivery_fees":3.83,"tax_rate":0.17,"taxes":12.11,"total":83.34,"status":"delivered","returned":false},{"id":130,"reference":"9vzwfb","date":"2016-12-10T17:22:25.691Z","customer_id":610,"basket":[{"product_id":7,"quantity":1},{"product_id":94,"quantity":3},{"product_id":92,"quantity":1},{"product_id":36,"quantity":1},{"product_id":63,"quantity":1},{"product_id":106,"quantity":3}],"total_ex_taxes":422.03000000000003,"delivery_fees":7.49,"tax_rate":0.12,"taxes":51.54,"total":481.06,"status":"ordered","returned":false},{"id":131,"reference":"gqykd3","date":"2016-01-21T15:32:59.749Z","customer_id":853,"basket":[{"product_id":27,"quantity":1},{"product_id":66,"quantity":4}],"total_ex_taxes":121.78,"delivery_fees":3.65,"tax_rate":0.2,"taxes":25.09,"total":150.52,"status":"delivered","returned":false},{"id":132,"reference":"azwxza","date":"2016-07-08T12:10:04.801Z","customer_id":892,"basket":[{"product_id":75,"quantity":1},{"product_id":57,"quantity":2}],"total_ex_taxes":75.25,"delivery_fees":4.91,"tax_rate":0.2,"taxes":16.03,"total":96.19,"status":"delivered","returned":true},{"id":133,"reference":"qmrtn0","date":"2016-12-23T03:05:04.412Z","customer_id":296,"basket":[{"product_id":66,"quantity":1}],"total_ex_taxes":27.05,"delivery_fees":6.83,"tax_rate":0.2,"taxes":6.78,"total":40.66,"status":"ordered","returned":false},{"id":134,"reference":"kq9lyr","date":"2016-12-09T19:29:07.232Z","customer_id":830,"basket":[{"product_id":51,"quantity":4},{"product_id":96,"quantity":1},{"product_id":102,"quantity":1},{"product_id":64,"quantity":2}],"total_ex_taxes":345.01,"delivery_fees":5.86,"tax_rate":0.12,"taxes":42.1,"total":392.97,"status":"ordered","returned":false},{"id":135,"reference":"y5a1pu","date":"2016-03-03T20:54:58.626Z","customer_id":727,"basket":[{"product_id":74,"quantity":3}],"total_ex_taxes":106.71000000000001,"delivery_fees":6.26,"tax_rate":0.2,"taxes":22.59,"total":135.56,"status":"delivered","returned":false},{"id":136,"reference":"98l89c","date":"2016-10-11T05:05:57.907Z","customer_id":801,"basket":[{"product_id":120,"quantity":1},{"product_id":11,"quantity":3}],"total_ex_taxes":45.01,"delivery_fees":3.12,"tax_rate":0.17,"taxes":8.18,"total":56.31,"status":"delivered","returned":false},{"id":137,"reference":"v5t3el","date":"2016-04-28T04:52:08.730Z","customer_id":863,"basket":[{"product_id":20,"quantity":1}],"total_ex_taxes":19.79,"delivery_fees":7.24,"tax_rate":0.2,"taxes":5.41,"total":32.44,"status":"cancelled","returned":false},{"id":138,"reference":"1nfwkd","date":"2015-02-26T16:38:58.582Z","customer_id":661,"basket":[{"product_id":96,"quantity":1}],"total_ex_taxes":38.08,"delivery_fees":3.36,"tax_rate":0.17,"taxes":7.04,"total":48.48,"status":"delivered","returned":false},{"id":139,"reference":"sz2y5w","date":"2016-03-18T14:00:07.978Z","customer_id":278,"basket":[{"product_id":117,"quantity":3}],"total_ex_taxes":38.099999999999994,"delivery_fees":7.04,"tax_rate":0.2,"taxes":9.03,"total":54.17,"status":"delivered","returned":false},{"id":140,"reference":"o56aln","date":"2014-06-27T22:42:39.085Z","customer_id":592,"basket":[{"product_id":96,"quantity":1}],"total_ex_taxes":38.08,"delivery_fees":5.75,"tax_rate":0.12,"taxes":5.26,"total":49.09,"status":"delivered","returned":false},{"id":141,"reference":"nltyrb","date":"2016-04-20T05:21:48.628Z","customer_id":540,"basket":[{"product_id":36,"quantity":2},{"product_id":108,"quantity":1},{"product_id":1,"quantity":1}],"total_ex_taxes":172.07,"delivery_fees":5.05,"tax_rate":0.12,"taxes":21.25,"total":198.37,"status":"delivered","returned":false},{"id":142,"reference":"oq9c98","date":"2016-04-01T08:16:38.814Z","customer_id":323,"basket":[{"product_id":47,"quantity":1},{"product_id":112,"quantity":1}],"total_ex_taxes":69.61,"delivery_fees":6.89,"tax_rate":0.12,"taxes":9.18,"total":85.68,"status":"delivered","returned":false},{"id":143,"reference":"jbvwn7","date":"2016-03-07T05:33:52.096Z","customer_id":335,"basket":[{"product_id":112,"quantity":1},{"product_id":91,"quantity":5}],"total_ex_taxes":247.26,"delivery_fees":5.73,"tax_rate":0.17,"taxes":43.01,"total":296,"status":"delivered","returned":false},{"id":144,"reference":"qbg8os","date":"2015-11-30T12:18:13.038Z","customer_id":853,"basket":[{"product_id":68,"quantity":3}],"total_ex_taxes":118.64999999999999,"delivery_fees":7.41,"tax_rate":0.12,"taxes":15.13,"total":141.19,"status":"delivered","returned":false},{"id":145,"reference":"a326du","date":"2016-07-19T01:11:05.729Z","customer_id":763,"basket":[{"product_id":89,"quantity":2}],"total_ex_taxes":46.72,"delivery_fees":3.31,"tax_rate":0.12,"taxes":6,"total":56.03,"status":"delivered","returned":false},{"id":146,"reference":"g9m3ug","date":"2016-08-12T12:17:51.058Z","customer_id":707,"basket":[{"product_id":33,"quantity":2}],"total_ex_taxes":37.32,"delivery_fees":7.48,"tax_rate":0.2,"taxes":8.96,"total":53.76,"status":"delivered","returned":false},{"id":147,"reference":"mdu7n7","date":"2016-07-18T00:18:03.146Z","customer_id":383,"basket":[{"product_id":97,"quantity":5}],"total_ex_taxes":265.85,"delivery_fees":3.85,"tax_rate":0.2,"taxes":53.94,"total":323.64,"status":"delivered","returned":false},{"id":148,"reference":"6t15wq","date":"2016-10-08T18:18:42.774Z","customer_id":193,"basket":[{"product_id":122,"quantity":2}],"total_ex_taxes":119.16,"delivery_fees":6.34,"tax_rate":0.12,"taxes":15.06,"total":140.56,"status":"delivered","returned":false},{"id":149,"reference":"ez06cg","date":"2015-12-31T01:03:18.963Z","customer_id":869,"basket":[{"product_id":106,"quantity":3},{"product_id":35,"quantity":1},{"product_id":69,"quantity":1},{"product_id":128,"quantity":3},{"product_id":6,"quantity":4},{"product_id":69,"quantity":1}],"total_ex_taxes":720.0899999999999,"delivery_fees":4.87,"tax_rate":0.17,"taxes":123.24,"total":848.2,"status":"delivered","returned":false},{"id":150,"reference":"ubnjs6","date":"2016-06-13T12:31:01.220Z","customer_id":301,"basket":[{"product_id":41,"quantity":5}],"total_ex_taxes":209.7,"delivery_fees":5.84,"tax_rate":0.17,"taxes":36.64,"total":252.18,"status":"delivered","returned":false},{"id":151,"reference":"jd0m8e","date":"2015-02-18T02:03:53.017Z","customer_id":895,"basket":[{"product_id":89,"quantity":2},{"product_id":52,"quantity":1},{"product_id":39,"quantity":1}],"total_ex_taxes":87.03999999999999,"delivery_fees":3.49,"tax_rate":0.2,"taxes":18.11,"total":108.64,"status":"delivered","returned":false},{"id":152,"reference":"b20yr4","date":"2016-09-17T22:48:35.496Z","customer_id":236,"basket":[{"product_id":117,"quantity":1}],"total_ex_taxes":12.7,"delivery_fees":7.15,"tax_rate":0.2,"taxes":3.97,"total":23.82,"status":"delivered","returned":false},{"id":153,"reference":"yab29p","date":"2014-11-14T06:34:46.234Z","customer_id":108,"basket":[{"product_id":126,"quantity":1},{"product_id":58,"quantity":1}],"total_ex_taxes":112.41999999999999,"delivery_fees":6.6,"tax_rate":0.12,"taxes":14.28,"total":133.3,"status":"delivered","returned":false},{"id":154,"reference":"k624uu","date":"2013-09-03T17:10:19.185Z","customer_id":492,"basket":[{"product_id":5,"quantity":1},{"product_id":2,"quantity":1}],"total_ex_taxes":98.03999999999999,"delivery_fees":6.86,"tax_rate":0.12,"taxes":12.59,"total":117.49,"status":"delivered","returned":false},{"id":155,"reference":"nhv8qp","date":"2016-12-31T14:52:25.459Z","customer_id":559,"basket":[{"product_id":56,"quantity":2}],"total_ex_taxes":44.82,"delivery_fees":6.83,"tax_rate":0.2,"taxes":10.33,"total":61.98,"status":"cancelled","returned":false},{"id":156,"reference":"zmr0hl","date":"2016-07-17T10:33:04.235Z","customer_id":323,"basket":[{"product_id":97,"quantity":1}],"total_ex_taxes":53.17,"delivery_fees":7.35,"tax_rate":0.12,"taxes":7.26,"total":67.78,"status":"delivered","returned":false},{"id":157,"reference":"je68kb","date":"2015-12-09T03:22:52.146Z","customer_id":673,"basket":[{"product_id":58,"quantity":1}],"total_ex_taxes":70.32,"delivery_fees":7.19,"tax_rate":0.12,"taxes":9.3,"total":86.81,"status":"delivered","returned":false},{"id":158,"reference":"kxphyf","date":"2014-10-26T22:13:50.061Z","customer_id":359,"basket":[{"product_id":80,"quantity":4},{"product_id":102,"quantity":2}],"total_ex_taxes":302.26,"delivery_fees":7.38,"tax_rate":0.2,"taxes":61.93,"total":371.57,"status":"delivered","returned":false},{"id":159,"reference":"3nxwmv","date":"2016-12-27T01:40:25.286Z","customer_id":893,"basket":[{"product_id":106,"quantity":1},{"product_id":101,"quantity":1}],"total_ex_taxes":112.05,"delivery_fees":6.37,"tax_rate":0.2,"taxes":23.68,"total":142.1,"status":"ordered","returned":false},{"id":160,"reference":"jxr5jr","date":"2016-11-05T17:14:10.479Z","customer_id":801,"basket":[{"product_id":36,"quantity":1}],"total_ex_taxes":41.9,"delivery_fees":7.61,"tax_rate":0.17,"taxes":8.42,"total":57.93,"status":"cancelled","returned":false},{"id":161,"reference":"wpwhnl","date":"2016-09-17T15:22:20.493Z","customer_id":496,"basket":[{"product_id":127,"quantity":1},{"product_id":120,"quantity":4},{"product_id":30,"quantity":3}],"total_ex_taxes":167.61,"delivery_fees":3.77,"tax_rate":0.2,"taxes":34.28,"total":205.66,"status":"delivered","returned":false},{"id":162,"reference":"ch1ibv","date":"2015-06-28T15:20:46.754Z","customer_id":547,"basket":[{"product_id":28,"quantity":1},{"product_id":107,"quantity":2}],"total_ex_taxes":186.25,"delivery_fees":6.03,"tax_rate":0.2,"taxes":38.46,"total":230.74,"status":"delivered","returned":false},{"id":163,"reference":"br4xzu","date":"2013-12-17T03:06:53.693Z","customer_id":157,"basket":[{"product_id":110,"quantity":1},{"product_id":100,"quantity":4}],"total_ex_taxes":231.84,"delivery_fees":5.65,"tax_rate":0.17,"taxes":40.37,"total":277.86,"status":"delivered","returned":false},{"id":164,"reference":"uvqwtq","date":"2015-10-26T05:50:51.831Z","customer_id":503,"basket":[{"product_id":61,"quantity":1},{"product_id":33,"quantity":2},{"product_id":7,"quantity":1},{"product_id":49,"quantity":1},{"product_id":55,"quantity":1},{"product_id":71,"quantity":4},{"product_id":29,"quantity":4}],"total_ex_taxes":370.49,"delivery_fees":5.26,"tax_rate":0.12,"taxes":45.09,"total":420.84,"status":"cancelled","returned":false},{"id":165,"reference":"1d2dvc","date":"2014-05-01T01:50:24.358Z","customer_id":353,"basket":[{"product_id":96,"quantity":1}],"total_ex_taxes":38.08,"delivery_fees":5.92,"tax_rate":0.2,"taxes":8.8,"total":52.8,"status":"cancelled","returned":false},{"id":166,"reference":"8520th","date":"2014-12-03T17:54:54.632Z","customer_id":408,"basket":[{"product_id":51,"quantity":1},{"product_id":77,"quantity":1}],"total_ex_taxes":70.81,"delivery_fees":4.18,"tax_rate":0.2,"taxes":15,"total":89.99,"status":"delivered","returned":false},{"id":167,"reference":"1veuvn","date":"2014-01-11T12:57:22.245Z","customer_id":208,"basket":[{"product_id":19,"quantity":1}],"total_ex_taxes":47.12,"delivery_fees":3.26,"tax_rate":0.12,"taxes":6.05,"total":56.43,"status":"delivered","returned":false},{"id":168,"reference":"y5pdku","date":"2016-12-25T21:06:49.386Z","customer_id":291,"basket":[{"product_id":116,"quantity":1}],"total_ex_taxes":66.46,"delivery_fees":3.07,"tax_rate":0.17,"taxes":11.82,"total":81.35,"status":"ordered","returned":false},{"id":169,"reference":"j44ip0","date":"2016-10-12T21:28:24.599Z","customer_id":351,"basket":[{"product_id":117,"quantity":1},{"product_id":65,"quantity":2}],"total_ex_taxes":37.18,"delivery_fees":3.67,"tax_rate":0.12,"taxes":4.9,"total":45.75,"status":"delivered","returned":true},{"id":170,"reference":"k4jzb3","date":"2016-03-08T19:34:42.412Z","customer_id":54,"basket":[{"product_id":102,"quantity":1}],"total_ex_taxes":11.03,"delivery_fees":6.11,"tax_rate":0.2,"taxes":3.43,"total":20.57,"status":"delivered","returned":false},{"id":171,"reference":"k8j1rt","date":"2014-05-01T16:47:31.317Z","customer_id":644,"basket":[{"product_id":32,"quantity":1}],"total_ex_taxes":25.76,"delivery_fees":3.97,"tax_rate":0.12,"taxes":3.57,"total":33.3,"status":"delivered","returned":false},{"id":172,"reference":"6gn7zg","date":"2016-05-12T14:30:48.771Z","customer_id":708,"basket":[{"product_id":95,"quantity":1}],"total_ex_taxes":26.37,"delivery_fees":4.9,"tax_rate":0.12,"taxes":3.75,"total":35.02,"status":"delivered","returned":false},{"id":173,"reference":"6pjgzd","date":"2016-12-29T05:43:06.690Z","customer_id":559,"basket":[{"product_id":115,"quantity":1}],"total_ex_taxes":13.05,"delivery_fees":4.7,"tax_rate":0.2,"taxes":3.55,"total":21.3,"status":"ordered","returned":false},{"id":174,"reference":"g1esad","date":"2016-12-09T13:11:35.436Z","customer_id":31,"basket":[{"product_id":27,"quantity":4},{"product_id":87,"quantity":2}],"total_ex_taxes":158.38,"delivery_fees":5.79,"tax_rate":0.12,"taxes":19.7,"total":183.87,"status":"delivered","returned":false},{"id":175,"reference":"6myblf","date":"2016-01-06T09:15:58.064Z","customer_id":799,"basket":[{"product_id":31,"quantity":2},{"product_id":68,"quantity":1},{"product_id":7,"quantity":4},{"product_id":41,"quantity":1},{"product_id":41,"quantity":1},{"product_id":15,"quantity":1},{"product_id":113,"quantity":1},{"product_id":78,"quantity":1},{"product_id":78,"quantity":2},{"product_id":90,"quantity":1}],"total_ex_taxes":603.5799999999999,"delivery_fees":5.96,"tax_rate":0.12,"taxes":73.14,"total":682.68,"status":"delivered","returned":false},{"id":176,"reference":"6nasuh","date":"2016-05-10T10:10:35.012Z","customer_id":111,"basket":[{"product_id":87,"quantity":4},{"product_id":55,"quantity":1}],"total_ex_taxes":255.09,"delivery_fees":6.92,"tax_rate":0.17,"taxes":44.54,"total":306.55,"status":"delivered","returned":false},{"id":177,"reference":"r4pyfl","date":"2014-11-03T02:36:15.461Z","customer_id":340,"basket":[{"product_id":45,"quantity":2}],"total_ex_taxes":39.58,"delivery_fees":6.98,"tax_rate":0.2,"taxes":9.31,"total":55.87,"status":"delivered","returned":true},{"id":178,"reference":"5p3nr9","date":"2016-11-03T04:04:20.940Z","customer_id":31,"basket":[{"product_id":110,"quantity":1},{"product_id":34,"quantity":2}],"total_ex_taxes":108.04,"delivery_fees":3.38,"tax_rate":0.12,"taxes":13.37,"total":124.79,"status":"delivered","returned":false},{"id":179,"reference":"yk7l2w","date":"2016-02-07T22:57:26.432Z","customer_id":294,"basket":[{"product_id":82,"quantity":1},{"product_id":36,"quantity":1}],"total_ex_taxes":70.61,"delivery_fees":5.85,"tax_rate":0.17,"taxes":13,"total":89.46,"status":"delivered","returned":false},{"id":180,"reference":"fuo9hf","date":"2015-06-27T16:29:17.023Z","customer_id":547,"basket":[{"product_id":19,"quantity":1}],"total_ex_taxes":47.12,"delivery_fees":4.34,"tax_rate":0.2,"taxes":10.29,"total":61.75,"status":"delivered","returned":true},{"id":181,"reference":"4bfbke","date":"2016-06-13T03:34:52.741Z","customer_id":500,"basket":[{"product_id":2,"quantity":5},{"product_id":67,"quantity":1}],"total_ex_taxes":303.27000000000004,"delivery_fees":3.97,"tax_rate":0.12,"taxes":36.87,"total":344.11,"status":"delivered","returned":false},{"id":182,"reference":"il5u8m","date":"2016-07-26T01:38:54.665Z","customer_id":236,"basket":[{"product_id":73,"quantity":2}],"total_ex_taxes":137.52,"delivery_fees":4.31,"tax_rate":0.17,"taxes":24.11,"total":165.94,"status":"delivered","returned":false},{"id":183,"reference":"nzlnul","date":"2015-12-04T04:33:58.203Z","customer_id":693,"basket":[{"product_id":91,"quantity":4}],"total_ex_taxes":169.52,"delivery_fees":5.76,"tax_rate":0.12,"taxes":21.03,"total":196.31,"status":"delivered","returned":false},{"id":184,"reference":"6nd5kr","date":"2014-04-13T02:37:00.193Z","customer_id":59,"basket":[{"product_id":121,"quantity":2}],"total_ex_taxes":31.06,"delivery_fees":4.72,"tax_rate":0.2,"taxes":7.16,"total":42.94,"status":"delivered","returned":false},{"id":185,"reference":"dl98ay","date":"2016-03-05T23:22:21.454Z","customer_id":335,"basket":[{"product_id":57,"quantity":3},{"product_id":24,"quantity":1}],"total_ex_taxes":123.87,"delivery_fees":6.85,"tax_rate":0.17,"taxes":22.22,"total":152.94,"status":"delivered","returned":false},{"id":186,"reference":"r7vkgr","date":"2016-12-29T09:55:59.976Z","customer_id":277,"basket":[{"product_id":112,"quantity":3},{"product_id":51,"quantity":1}],"total_ex_taxes":159.46,"delivery_fees":3.54,"tax_rate":0.2,"taxes":32.6,"total":195.6,"status":"delivered","returned":false},{"id":187,"reference":"n4xhhs","date":"2016-11-11T10:29:41.692Z","customer_id":893,"basket":[{"product_id":33,"quantity":1}],"total_ex_taxes":18.66,"delivery_fees":3.55,"tax_rate":0.17,"taxes":3.78,"total":25.99,"status":"delivered","returned":false},{"id":188,"reference":"teb1kv","date":"2016-10-31T15:16:48.779Z","customer_id":183,"basket":[{"product_id":13,"quantity":3},{"product_id":65,"quantity":1},{"product_id":70,"quantity":2},{"product_id":35,"quantity":3},{"product_id":5,"quantity":5},{"product_id":50,"quantity":1}],"total_ex_taxes":691.37,"delivery_fees":6.5,"tax_rate":0.2,"taxes":139.57,"total":837.44,"status":"delivered","returned":false},{"id":189,"reference":"p87k69","date":"2016-10-03T18:31:47.460Z","customer_id":90,"basket":[{"product_id":36,"quantity":2},{"product_id":20,"quantity":1}],"total_ex_taxes":103.59,"delivery_fees":3.74,"tax_rate":0.12,"taxes":12.88,"total":120.21,"status":"cancelled","returned":false},{"id":190,"reference":"7w5zix","date":"2016-01-27T15:39:07.315Z","customer_id":596,"basket":[{"product_id":39,"quantity":1},{"product_id":110,"quantity":4}],"total_ex_taxes":210.98000000000002,"delivery_fees":5.18,"tax_rate":0.12,"taxes":25.94,"total":242.1,"status":"delivered","returned":false},{"id":191,"reference":"hluds9","date":"2016-12-19T06:04:09.313Z","customer_id":236,"basket":[{"product_id":80,"quantity":2},{"product_id":101,"quantity":2}],"total_ex_taxes":233.54,"delivery_fees":7.24,"tax_rate":0.17,"taxes":40.93,"total":281.71,"status":"delivered","returned":false},{"id":192,"reference":"wbizfa","date":"2016-06-06T19:03:43.388Z","customer_id":718,"basket":[{"product_id":91,"quantity":1}],"total_ex_taxes":42.38,"delivery_fees":5.27,"tax_rate":0.12,"taxes":5.72,"total":53.37,"status":"delivered","returned":false},{"id":193,"reference":"9aumrx","date":"2015-10-22T02:01:32.978Z","customer_id":63,"basket":[{"product_id":55,"quantity":3},{"product_id":24,"quantity":1}],"total_ex_taxes":176.25,"delivery_fees":4.18,"tax_rate":0.2,"taxes":36.09,"total":216.52,"status":"delivered","returned":false},{"id":194,"reference":"jbr4kw","date":"2016-05-27T10:13:44.206Z","customer_id":504,"basket":[{"product_id":60,"quantity":1}],"total_ex_taxes":23.66,"delivery_fees":3.62,"tax_rate":0.17,"taxes":4.64,"total":31.92,"status":"delivered","returned":false},{"id":195,"reference":"enwcd1","date":"2016-10-06T22:10:46.933Z","customer_id":481,"basket":[{"product_id":21,"quantity":2},{"product_id":32,"quantity":1}],"total_ex_taxes":125.22,"delivery_fees":5.44,"tax_rate":0.12,"taxes":15.68,"total":146.34,"status":"delivered","returned":false},{"id":196,"reference":"agb2r6","date":"2016-08-11T22:09:57.364Z","customer_id":428,"basket":[{"product_id":9,"quantity":1}],"total_ex_taxes":39.65,"delivery_fees":3.45,"tax_rate":0.17,"taxes":7.33,"total":50.43,"status":"delivered","returned":false},{"id":197,"reference":"cu44sm","date":"2016-04-29T01:48:14.538Z","customer_id":383,"basket":[{"product_id":47,"quantity":3},{"product_id":7,"quantity":2},{"product_id":101,"quantity":5}],"total_ex_taxes":359.35,"delivery_fees":7,"tax_rate":0.12,"taxes":43.96,"total":410.31,"status":"delivered","returned":false},{"id":198,"reference":"n29fl7","date":"2016-07-26T06:34:35.627Z","customer_id":289,"basket":[{"product_id":114,"quantity":1},{"product_id":65,"quantity":1}],"total_ex_taxes":39,"delivery_fees":4.43,"tax_rate":0.12,"taxes":5.21,"total":48.64,"status":"delivered","returned":false},{"id":199,"reference":"cw413m","date":"2015-03-19T04:41:34.020Z","customer_id":492,"basket":[{"product_id":16,"quantity":4}],"total_ex_taxes":116.68,"delivery_fees":4.26,"tax_rate":0.12,"taxes":14.51,"total":135.45,"status":"delivered","returned":false},{"id":200,"reference":"vrxvwp","date":"2016-02-25T05:00:27.007Z","customer_id":63,"basket":[{"product_id":86,"quantity":1},{"product_id":36,"quantity":1},{"product_id":50,"quantity":1}],"total_ex_taxes":135.8,"delivery_fees":4.56,"tax_rate":0.2,"taxes":28.07,"total":168.43,"status":"delivered","returned":false},{"id":201,"reference":"2hf5ur","date":"2016-03-27T10:40:53.550Z","customer_id":216,"basket":[{"product_id":33,"quantity":2},{"product_id":99,"quantity":3},{"product_id":79,"quantity":2},{"product_id":2,"quantity":1}],"total_ex_taxes":255.96,"delivery_fees":5.16,"tax_rate":0.2,"taxes":52.22,"total":313.34,"status":"delivered","returned":false},{"id":202,"reference":"lc99ud","date":"2016-12-11T19:57:43.762Z","customer_id":633,"basket":[{"product_id":113,"quantity":1}],"total_ex_taxes":56.94,"delivery_fees":5.68,"tax_rate":0.12,"taxes":7.51,"total":70.13,"status":"delivered","returned":false},{"id":203,"reference":"vvzyjy","date":"2016-12-21T07:08:59.833Z","customer_id":554,"basket":[{"product_id":15,"quantity":2}],"total_ex_taxes":72.62,"delivery_fees":5.94,"tax_rate":0.12,"taxes":9.43,"total":87.99,"status":"delivered","returned":true},{"id":204,"reference":"pm30oe","date":"2016-07-07T08:03:37.465Z","customer_id":708,"basket":[{"product_id":83,"quantity":1},{"product_id":68,"quantity":2}],"total_ex_taxes":104.58999999999999,"delivery_fees":4.26,"tax_rate":0.17,"taxes":18.5,"total":127.35,"status":"delivered","returned":false},{"id":205,"reference":"2pstzr","date":"2015-12-09T17:36:22.658Z","customer_id":352,"basket":[{"product_id":100,"quantity":1},{"product_id":18,"quantity":4},{"product_id":84,"quantity":4},{"product_id":50,"quantity":1},{"product_id":109,"quantity":5},{"product_id":62,"quantity":5},{"product_id":14,"quantity":3},{"product_id":23,"quantity":1},{"product_id":22,"quantity":2}],"total_ex_taxes":1119.1,"delivery_fees":3.32,"tax_rate":0.2,"taxes":224.48,"total":1346.9,"status":"delivered","returned":false},{"id":206,"reference":"yca7g8","date":"2016-05-06T21:52:57.514Z","customer_id":263,"basket":[{"product_id":8,"quantity":1},{"product_id":117,"quantity":2}],"total_ex_taxes":56.129999999999995,"delivery_fees":7.44,"tax_rate":0.12,"taxes":7.63,"total":71.2,"status":"delivered","returned":false},{"id":207,"reference":"h7lfb3","date":"2015-09-02T05:32:33.051Z","customer_id":340,"basket":[{"product_id":48,"quantity":1}],"total_ex_taxes":64.57,"delivery_fees":7.83,"tax_rate":0.2,"taxes":14.48,"total":86.88,"status":"delivered","returned":false},{"id":208,"reference":"lym0jk","date":"2016-07-13T15:38:51.742Z","customer_id":863,"basket":[{"product_id":97,"quantity":1}],"total_ex_taxes":53.17,"delivery_fees":6.81,"tax_rate":0.17,"taxes":10.2,"total":70.18,"status":"delivered","returned":true},{"id":209,"reference":"hd5hwj","date":"2016-12-21T09:51:53.060Z","customer_id":196,"basket":[{"product_id":30,"quantity":2},{"product_id":112,"quantity":2},{"product_id":3,"quantity":3}],"total_ex_taxes":151.39,"delivery_fees":6.11,"tax_rate":0.2,"taxes":31.5,"total":189,"status":"delivered","returned":false},{"id":210,"reference":"sjwbyj","date":"2016-12-23T10:07:22.014Z","customer_id":350,"basket":[{"product_id":109,"quantity":1},{"product_id":18,"quantity":2}],"total_ex_taxes":146.66,"delivery_fees":3.25,"tax_rate":0.17,"taxes":25.48,"total":175.39,"status":"delivered","returned":false},{"id":211,"reference":"fepnpo","date":"2014-09-10T10:17:55.140Z","customer_id":884,"basket":[{"product_id":19,"quantity":1}],"total_ex_taxes":47.12,"delivery_fees":6.03,"tax_rate":0.2,"taxes":10.63,"total":63.78,"status":"cancelled","returned":false},{"id":212,"reference":"i7ovw9","date":"2015-06-06T09:08:45.574Z","customer_id":244,"basket":[{"product_id":11,"quantity":1}],"total_ex_taxes":8.1,"delivery_fees":7.52,"tax_rate":0.17,"taxes":2.66,"total":18.28,"status":"delivered","returned":false},{"id":213,"reference":"byx0qp","date":"2016-08-31T16:02:19.126Z","customer_id":481,"basket":[{"product_id":61,"quantity":1},{"product_id":8,"quantity":2},{"product_id":22,"quantity":1},{"product_id":46,"quantity":1},{"product_id":20,"quantity":4},{"product_id":65,"quantity":1},{"product_id":34,"quantity":4},{"product_id":35,"quantity":1}],"total_ex_taxes":457.24000000000007,"delivery_fees":6.63,"tax_rate":0.2,"taxes":92.77,"total":556.64,"status":"delivered","returned":false},{"id":214,"reference":"8r4293","date":"2015-03-25T13:33:51.189Z","customer_id":661,"basket":[{"product_id":121,"quantity":1}],"total_ex_taxes":15.53,"delivery_fees":4.89,"tax_rate":0.17,"taxes":3.47,"total":23.89,"status":"delivered","returned":true},{"id":215,"reference":"icmjuz","date":"2015-03-21T22:56:04.839Z","customer_id":400,"basket":[{"product_id":102,"quantity":3},{"product_id":14,"quantity":4}],"total_ex_taxes":155.57,"delivery_fees":5.35,"tax_rate":0.17,"taxes":27.36,"total":188.28,"status":"delivered","returned":true},{"id":216,"reference":"dumavq","date":"2016-05-22T18:37:09.978Z","customer_id":627,"basket":[{"product_id":93,"quantity":1}],"total_ex_taxes":77.92,"delivery_fees":4.88,"tax_rate":0.2,"taxes":16.56,"total":99.36,"status":"cancelled","returned":false},{"id":217,"reference":"12qejv","date":"2016-11-01T15:10:10.350Z","customer_id":347,"basket":[{"product_id":84,"quantity":1},{"product_id":38,"quantity":3}],"total_ex_taxes":178.85,"delivery_fees":6.91,"tax_rate":0.17,"taxes":31.58,"total":217.34,"status":"delivered","returned":false},{"id":218,"reference":"lnwm3p","date":"2016-09-19T08:57:57.478Z","customer_id":390,"basket":[{"product_id":45,"quantity":2}],"total_ex_taxes":39.58,"delivery_fees":4.05,"tax_rate":0.2,"taxes":8.73,"total":52.36,"status":"delivered","returned":false},{"id":219,"reference":"dqi6s0","date":"2014-09-18T00:22:51.175Z","customer_id":157,"basket":[{"product_id":65,"quantity":4},{"product_id":32,"quantity":1}],"total_ex_taxes":74.72,"delivery_fees":7.67,"tax_rate":0.17,"taxes":14.01,"total":96.4,"status":"delivered","returned":false},{"id":220,"reference":"faymke","date":"2015-10-05T16:43:51.721Z","customer_id":491,"basket":[{"product_id":88,"quantity":2},{"product_id":113,"quantity":1}],"total_ex_taxes":140.84,"delivery_fees":3.82,"tax_rate":0.2,"taxes":28.93,"total":173.59,"status":"delivered","returned":false},{"id":221,"reference":"g3kvlm","date":"2016-04-19T14:10:59.037Z","customer_id":878,"basket":[{"product_id":91,"quantity":2},{"product_id":90,"quantity":2},{"product_id":129,"quantity":1},{"product_id":73,"quantity":1},{"product_id":29,"quantity":1},{"product_id":91,"quantity":3}],"total_ex_taxes":420.99,"delivery_fees":3.28,"tax_rate":0.12,"taxes":50.91,"total":475.18,"status":"delivered","returned":false},{"id":222,"reference":"c6871k","date":"2015-04-21T20:56:29.317Z","customer_id":412,"basket":[{"product_id":109,"quantity":1}],"total_ex_taxes":45.2,"delivery_fees":4.67,"tax_rate":0.17,"taxes":8.48,"total":58.35,"status":"delivered","returned":false},{"id":223,"reference":"kzwr8q","date":"2015-10-30T10:28:16.364Z","customer_id":823,"basket":[{"product_id":19,"quantity":2},{"product_id":8,"quantity":3}],"total_ex_taxes":186.43,"delivery_fees":5.44,"tax_rate":0.2,"taxes":38.37,"total":230.24,"status":"cancelled","returned":false},{"id":224,"reference":"y3kcpq","date":"2016-07-15T13:36:17.992Z","customer_id":708,"basket":[{"product_id":15,"quantity":1},{"product_id":66,"quantity":1}],"total_ex_taxes":63.36,"delivery_fees":7.15,"tax_rate":0.2,"taxes":14.1,"total":84.61,"status":"delivered","returned":false},{"id":225,"reference":"ja782l","date":"2016-06-15T02:48:45.918Z","customer_id":784,"basket":[{"product_id":87,"quantity":3}],"total_ex_taxes":156.09,"delivery_fees":3.92,"tax_rate":0.17,"taxes":27.2,"total":187.21,"status":"delivered","returned":false},{"id":226,"reference":"hobouv","date":"2015-08-27T12:38:48.299Z","customer_id":627,"basket":[{"product_id":8,"quantity":1},{"product_id":92,"quantity":2},{"product_id":119,"quantity":1},{"product_id":1,"quantity":3},{"product_id":124,"quantity":5},{"product_id":82,"quantity":1},{"product_id":75,"quantity":1}],"total_ex_taxes":423.3,"delivery_fees":3.41,"tax_rate":0.2,"taxes":85.34,"total":512.05,"status":"cancelled","returned":false},{"id":227,"reference":"5w97b0","date":"2015-09-06T19:05:50.265Z","customer_id":887,"basket":[{"product_id":76,"quantity":1},{"product_id":71,"quantity":1}],"total_ex_taxes":55.47,"delivery_fees":7.33,"tax_rate":0.12,"taxes":7.54,"total":70.34,"status":"cancelled","returned":false},{"id":228,"reference":"bjowqb","date":"2016-09-11T17:07:39.371Z","customer_id":541,"basket":[{"product_id":109,"quantity":4},{"product_id":13,"quantity":1},{"product_id":11,"quantity":2},{"product_id":83,"quantity":3}],"total_ex_taxes":336.15999999999997,"delivery_fees":3.42,"tax_rate":0.12,"taxes":40.75,"total":380.33,"status":"cancelled","returned":false},{"id":229,"reference":"i65t86","date":"2016-06-21T20:43:42.866Z","customer_id":490,"basket":[{"product_id":40,"quantity":3},{"product_id":91,"quantity":2},{"product_id":61,"quantity":1},{"product_id":25,"quantity":1},{"product_id":18,"quantity":4},{"product_id":58,"quantity":3},{"product_id":19,"quantity":2},{"product_id":5,"quantity":1}],"total_ex_taxes":753.29,"delivery_fees":4.01,"tax_rate":0.2,"taxes":151.46,"total":908.76,"status":"delivered","returned":false},{"id":230,"reference":"m24zgx","date":"2014-08-23T18:57:22.347Z","customer_id":156,"basket":[{"product_id":119,"quantity":1}],"total_ex_taxes":26.93,"delivery_fees":7.11,"tax_rate":0.17,"taxes":5.79,"total":39.83,"status":"delivered","returned":false},{"id":231,"reference":"yjivtt","date":"2016-03-14T07:07:05.498Z","customer_id":156,"basket":[{"product_id":51,"quantity":2}],"total_ex_taxes":106.76,"delivery_fees":3.3,"tax_rate":0.17,"taxes":18.71,"total":128.77,"status":"delivered","returned":false},{"id":232,"reference":"7ay4l7","date":"2015-09-07T10:36:27.371Z","customer_id":244,"basket":[{"product_id":111,"quantity":1},{"product_id":90,"quantity":2},{"product_id":4,"quantity":3}],"total_ex_taxes":209.5,"delivery_fees":4.68,"tax_rate":0.17,"taxes":36.41,"total":250.59,"status":"delivered","returned":false},{"id":233,"reference":"rmcyo9","date":"2016-02-11T13:56:12.939Z","customer_id":294,"basket":[{"product_id":102,"quantity":5}],"total_ex_taxes":55.15,"delivery_fees":6.4,"tax_rate":0.17,"taxes":10.46,"total":72.01,"status":"delivered","returned":false},{"id":234,"reference":"deyffg","date":"2016-09-18T09:59:46.874Z","customer_id":337,"basket":[{"product_id":119,"quantity":3},{"product_id":59,"quantity":2},{"product_id":4,"quantity":1},{"product_id":28,"quantity":1},{"product_id":24,"quantity":3},{"product_id":85,"quantity":1},{"product_id":110,"quantity":2},{"product_id":16,"quantity":3},{"product_id":47,"quantity":1},{"product_id":2,"quantity":3}],"total_ex_taxes":764.27,"delivery_fees":3.93,"tax_rate":0.2,"taxes":153.64,"total":921.84,"status":"delivered","returned":false},{"id":235,"reference":"zb2xvb","date":"2016-02-07T08:33:22.190Z","customer_id":627,"basket":[{"product_id":85,"quantity":1}],"total_ex_taxes":56.64,"delivery_fees":6.38,"tax_rate":0.2,"taxes":12.6,"total":75.62,"status":"delivered","returned":false},{"id":236,"reference":"oshi8l","date":"2016-06-02T23:50:06.489Z","customer_id":537,"basket":[{"product_id":22,"quantity":5},{"product_id":54,"quantity":1},{"product_id":20,"quantity":1},{"product_id":128,"quantity":1}],"total_ex_taxes":414.54,"delivery_fees":7.51,"tax_rate":0.17,"taxes":71.75,"total":493.8,"status":"delivered","returned":false},{"id":237,"reference":"7rij01","date":"2016-08-30T15:30:25.843Z","customer_id":236,"basket":[{"product_id":32,"quantity":1}],"total_ex_taxes":25.76,"delivery_fees":5.9,"tax_rate":0.2,"taxes":6.33,"total":37.99,"status":"delivered","returned":false},{"id":238,"reference":"kro69o","date":"2015-09-04T04:06:10.283Z","customer_id":271,"basket":[{"product_id":12,"quantity":4}],"total_ex_taxes":210.24,"delivery_fees":4.31,"tax_rate":0.17,"taxes":36.47,"total":251.02,"status":"delivered","returned":false},{"id":239,"reference":"bia840","date":"2013-11-11T11:04:45.570Z","customer_id":254,"basket":[{"product_id":79,"quantity":4}],"total_ex_taxes":56.56,"delivery_fees":5.8,"tax_rate":0.17,"taxes":10.6,"total":72.96,"status":"delivered","returned":true},{"id":240,"reference":"y3rd63","date":"2014-11-10T20:11:02.909Z","customer_id":317,"basket":[{"product_id":127,"quantity":1},{"product_id":82,"quantity":2}],"total_ex_taxes":81.62,"delivery_fees":3.8,"tax_rate":0.12,"taxes":10.25,"total":95.67,"status":"delivered","returned":false},{"id":241,"reference":"zgnttv","date":"2016-11-04T08:10:33.500Z","customer_id":360,"basket":[{"product_id":52,"quantity":1},{"product_id":49,"quantity":1},{"product_id":28,"quantity":3},{"product_id":128,"quantity":4},{"product_id":60,"quantity":1},{"product_id":91,"quantity":1},{"product_id":13,"quantity":1},{"product_id":11,"quantity":3},{"product_id":66,"quantity":2}],"total_ex_taxes":603.26,"delivery_fees":3.74,"tax_rate":0.17,"taxes":103.19,"total":710.19,"status":"delivered","returned":false},{"id":242,"reference":"9tmw1c","date":"2015-06-27T18:06:05.322Z","customer_id":748,"basket":[{"product_id":95,"quantity":1},{"product_id":107,"quantity":5}],"total_ex_taxes":441.07,"delivery_fees":7.2,"tax_rate":0.12,"taxes":53.79,"total":502.06,"status":"delivered","returned":false},{"id":243,"reference":"lyb7uf","date":"2015-05-01T21:18:00.128Z","customer_id":567,"basket":[{"product_id":29,"quantity":2},{"product_id":88,"quantity":2}],"total_ex_taxes":153.56,"delivery_fees":4.15,"tax_rate":0.17,"taxes":26.81,"total":184.52,"status":"delivered","returned":false},{"id":244,"reference":"adxcsj","date":"2016-05-11T20:43:32.892Z","customer_id":898,"basket":[{"product_id":36,"quantity":2}],"total_ex_taxes":83.8,"delivery_fees":5.47,"tax_rate":0.12,"taxes":10.71,"total":99.98,"status":"delivered","returned":false},{"id":245,"reference":"zts17w","date":"2016-09-29T03:17:05.267Z","customer_id":16,"basket":[{"product_id":127,"quantity":2}],"total_ex_taxes":48.4,"delivery_fees":6.33,"tax_rate":0.12,"taxes":6.57,"total":61.3,"status":"delivered","returned":false},{"id":246,"reference":"yivjyx","date":"2016-10-21T07:28:58.689Z","customer_id":801,"basket":[{"product_id":110,"quantity":2},{"product_id":48,"quantity":5}],"total_ex_taxes":411.89,"delivery_fees":5.01,"tax_rate":0.17,"taxes":70.87,"total":487.77,"status":"delivered","returned":true},{"id":247,"reference":"adaqju","date":"2015-12-26T15:28:59.712Z","customer_id":763,"basket":[{"product_id":105,"quantity":4}],"total_ex_taxes":86.6,"delivery_fees":4.26,"tax_rate":0.12,"taxes":10.9,"total":101.76,"status":"delivered","returned":false},{"id":248,"reference":"jba3d9","date":"2015-11-23T05:09:45.830Z","customer_id":95,"basket":[{"product_id":49,"quantity":1}],"total_ex_taxes":13.08,"delivery_fees":3.67,"tax_rate":0.12,"taxes":2.01,"total":18.76,"status":"delivered","returned":false},{"id":249,"reference":"98kn9x","date":"2016-03-20T06:26:22.349Z","customer_id":145,"basket":[{"product_id":112,"quantity":1}],"total_ex_taxes":35.36,"delivery_fees":5.01,"tax_rate":0.17,"taxes":6.86,"total":47.23,"status":"delivered","returned":false},{"id":250,"reference":"7laqau","date":"2016-01-01T17:33:29.608Z","customer_id":315,"basket":[{"product_id":113,"quantity":2}],"total_ex_taxes":113.88,"delivery_fees":7.58,"tax_rate":0.2,"taxes":24.29,"total":145.75,"status":"delivered","returned":false},{"id":251,"reference":"artzmb","date":"2015-03-20T09:38:50.960Z","customer_id":45,"basket":[{"product_id":9,"quantity":2}],"total_ex_taxes":79.3,"delivery_fees":3.02,"tax_rate":0.17,"taxes":13.99,"total":96.31,"status":"delivered","returned":false},{"id":252,"reference":"7y2hhg","date":"2014-11-16T12:22:40.345Z","customer_id":40,"basket":[{"product_id":54,"quantity":5},{"product_id":109,"quantity":1}],"total_ex_taxes":339.8,"delivery_fees":3.72,"tax_rate":0.2,"taxes":68.7,"total":412.22,"status":"delivered","returned":false},{"id":253,"reference":"v510p4","date":"2014-08-24T07:56:40.763Z","customer_id":682,"basket":[{"product_id":70,"quantity":3}],"total_ex_taxes":252.99,"delivery_fees":3.35,"tax_rate":0.17,"taxes":43.58,"total":299.92,"status":"cancelled","returned":false},{"id":254,"reference":"qsxfg5","date":"2016-06-19T05:41:04.915Z","customer_id":383,"basket":[{"product_id":62,"quantity":1},{"product_id":95,"quantity":4}],"total_ex_taxes":156.11,"delivery_fees":3.94,"tax_rate":0.12,"taxes":19.21,"total":179.26,"status":"cancelled","returned":false},{"id":255,"reference":"ce7idr","date":"2016-08-13T18:20:07.018Z","customer_id":433,"basket":[{"product_id":72,"quantity":2}],"total_ex_taxes":33.56,"delivery_fees":4.15,"tax_rate":0.17,"taxes":6.41,"total":44.12,"status":"delivered","returned":false},{"id":256,"reference":"vwife7","date":"2015-12-25T17:23:08.717Z","customer_id":799,"basket":[{"product_id":71,"quantity":2}],"total_ex_taxes":43.62,"delivery_fees":5.15,"tax_rate":0.2,"taxes":9.75,"total":58.52,"status":"delivered","returned":false},{"id":257,"reference":"d9jmui","date":"2016-09-23T02:12:22.862Z","customer_id":605,"basket":[{"product_id":128,"quantity":3},{"product_id":76,"quantity":4}],"total_ex_taxes":370.53,"delivery_fees":7.86,"tax_rate":0.17,"taxes":64.33,"total":442.72,"status":"delivered","returned":false},{"id":258,"reference":"54097b","date":"2016-07-17T21:44:31.923Z","customer_id":863,"basket":[{"product_id":26,"quantity":1}],"total_ex_taxes":33.16,"delivery_fees":6.19,"tax_rate":0.2,"taxes":7.87,"total":47.22,"status":"delivered","returned":false},{"id":259,"reference":"4ya0bu","date":"2016-09-08T13:45:54.613Z","customer_id":538,"basket":[{"product_id":127,"quantity":5}],"total_ex_taxes":121,"delivery_fees":3.97,"tax_rate":0.2,"taxes":24.99,"total":149.96,"status":"delivered","returned":true},{"id":260,"reference":"nr9zsa","date":"2014-07-20T20:11:28.514Z","customer_id":157,"basket":[{"product_id":60,"quantity":1},{"product_id":21,"quantity":1}],"total_ex_taxes":73.39,"delivery_fees":4.46,"tax_rate":0.17,"taxes":13.23,"total":91.08,"status":"delivered","returned":false},{"id":261,"reference":"qji2fb","date":"2017-01-01T16:58:45.129Z","customer_id":470,"basket":[{"product_id":74,"quantity":2},{"product_id":99,"quantity":1}],"total_ex_taxes":114.99000000000001,"delivery_fees":7.35,"tax_rate":0.12,"taxes":14.68,"total":137.02,"status":"delivered","returned":false},{"id":262,"reference":"609ikx","date":"2016-11-18T20:41:17.904Z","customer_id":500,"basket":[{"product_id":32,"quantity":1},{"product_id":128,"quantity":3},{"product_id":76,"quantity":2}],"total_ex_taxes":328.96999999999997,"delivery_fees":5.61,"tax_rate":0.2,"taxes":66.92,"total":401.5,"status":"delivered","returned":true},{"id":263,"reference":"a8qggg","date":"2016-07-10T13:15:29.372Z","customer_id":16,"basket":[{"product_id":90,"quantity":3}],"total_ex_taxes":119.72999999999999,"delivery_fees":3.13,"tax_rate":0.17,"taxes":20.89,"total":143.75,"status":"delivered","returned":false},{"id":264,"reference":"uztdvr","date":"2016-11-30T21:51:57.757Z","customer_id":500,"basket":[{"product_id":119,"quantity":3},{"product_id":104,"quantity":1}],"total_ex_taxes":156.75,"delivery_fees":7.55,"tax_rate":0.17,"taxes":27.93,"total":192.23,"status":"delivered","returned":false},{"id":265,"reference":"ucfz1j","date":"2015-09-27T14:57:00.118Z","customer_id":315,"basket":[{"product_id":125,"quantity":1}],"total_ex_taxes":17.34,"delivery_fees":3.84,"tax_rate":0.12,"taxes":2.54,"total":23.72,"status":"delivered","returned":false},{"id":266,"reference":"307628","date":"2016-06-18T18:10:09.696Z","customer_id":111,"basket":[{"product_id":40,"quantity":1},{"product_id":61,"quantity":2},{"product_id":58,"quantity":3},{"product_id":92,"quantity":1},{"product_id":96,"quantity":2}],"total_ex_taxes":398.40999999999997,"delivery_fees":4.5,"tax_rate":0.12,"taxes":48.35,"total":451.26,"status":"delivered","returned":false},{"id":267,"reference":"9n4u6d","date":"2014-12-12T21:54:41.682Z","customer_id":462,"basket":[{"product_id":127,"quantity":2},{"product_id":105,"quantity":1}],"total_ex_taxes":70.05,"delivery_fees":7.03,"tax_rate":0.12,"taxes":9.25,"total":86.33,"status":"delivered","returned":false},{"id":268,"reference":"ekmj3d","date":"2016-12-12T12:13:27.839Z","customer_id":502,"basket":[{"product_id":100,"quantity":2}],"total_ex_taxes":93.66,"delivery_fees":4.53,"tax_rate":0.2,"taxes":19.64,"total":117.83,"status":"delivered","returned":true},{"id":269,"reference":"a2kl3s","date":"2015-01-10T04:21:16.294Z","customer_id":558,"basket":[{"product_id":95,"quantity":1}],"total_ex_taxes":26.37,"delivery_fees":5.4,"tax_rate":0.17,"taxes":5.4,"total":37.17,"status":"delivered","returned":false},{"id":270,"reference":"vx8vwd","date":"2014-12-24T17:27:59.291Z","customer_id":854,"basket":[{"product_id":114,"quantity":4}],"total_ex_taxes":107.04,"delivery_fees":3.94,"tax_rate":0.12,"taxes":13.32,"total":124.3,"status":"delivered","returned":false},{"id":271,"reference":"ltcbpe","date":"2017-01-02T06:04:23.301Z","customer_id":470,"basket":[{"product_id":48,"quantity":1}],"total_ex_taxes":64.57,"delivery_fees":5.91,"tax_rate":0.2,"taxes":14.1,"total":84.58,"status":"ordered","returned":false},{"id":272,"reference":"ryecrk","date":"2016-10-18T15:35:07.774Z","customer_id":236,"basket":[{"product_id":38,"quantity":5},{"product_id":120,"quantity":2},{"product_id":107,"quantity":3},{"product_id":60,"quantity":1},{"product_id":18,"quantity":1},{"product_id":74,"quantity":1}],"total_ex_taxes":659.1500000000001,"delivery_fees":5.55,"tax_rate":0.17,"taxes":113,"total":777.7,"status":"delivered","returned":false},{"id":273,"reference":"ydtcg1","date":"2016-12-28T17:39:19.743Z","customer_id":485,"basket":[{"product_id":7,"quantity":1},{"product_id":75,"quantity":2}],"total_ex_taxes":43.96,"delivery_fees":5.57,"tax_rate":0.2,"taxes":9.91,"total":59.44,"status":"ordered","returned":false},{"id":274,"reference":"7h694o","date":"2016-12-18T21:46:24.252Z","customer_id":680,"basket":[{"product_id":21,"quantity":2}],"total_ex_taxes":99.46,"delivery_fees":4.87,"tax_rate":0.2,"taxes":20.87,"total":125.2,"status":"ordered","returned":false},{"id":275,"reference":"23nrt9","date":"2015-04-26T06:35:16.788Z","customer_id":884,"basket":[{"product_id":119,"quantity":1},{"product_id":122,"quantity":4}],"total_ex_taxes":265.25,"delivery_fees":7.65,"tax_rate":0.12,"taxes":32.75,"total":305.65,"status":"delivered","returned":false},{"id":276,"reference":"eqpuhy","date":"2015-08-27T12:13:09.817Z","customer_id":566,"basket":[{"product_id":35,"quantity":1},{"product_id":31,"quantity":1},{"product_id":32,"quantity":1}],"total_ex_taxes":126.66,"delivery_fees":3.39,"tax_rate":0.12,"taxes":15.61,"total":145.66,"status":"delivered","returned":true},{"id":277,"reference":"x1akhb","date":"2015-01-29T05:00:44.758Z","customer_id":624,"basket":[{"product_id":41,"quantity":2},{"product_id":58,"quantity":4},{"product_id":81,"quantity":1}],"total_ex_taxes":414.61999999999995,"delivery_fees":6.69,"tax_rate":0.2,"taxes":84.26,"total":505.57,"status":"delivered","returned":false},{"id":278,"reference":"nmpude","date":"2014-08-13T01:16:38.228Z","customer_id":189,"basket":[{"product_id":32,"quantity":3},{"product_id":48,"quantity":2},{"product_id":102,"quantity":4},{"product_id":60,"quantity":1},{"product_id":14,"quantity":4},{"product_id":115,"quantity":2},{"product_id":52,"quantity":1},{"product_id":72,"quantity":1},{"product_id":32,"quantity":1},{"product_id":53,"quantity":1}],"total_ex_taxes":513.91,"delivery_fees":3.97,"tax_rate":0.12,"taxes":62.15,"total":580.03,"status":"delivered","returned":false},{"id":279,"reference":"v3ytxn","date":"2015-05-08T16:30:51.410Z","customer_id":845,"basket":[{"product_id":120,"quantity":1},{"product_id":79,"quantity":3}],"total_ex_taxes":63.13,"delivery_fees":5.75,"tax_rate":0.17,"taxes":11.71,"total":80.59,"status":"delivered","returned":false},{"id":280,"reference":"icff2v","date":"2016-12-31T19:33:55.136Z","customer_id":485,"basket":[{"product_id":26,"quantity":5},{"product_id":102,"quantity":1},{"product_id":91,"quantity":3},{"product_id":8,"quantity":1},{"product_id":112,"quantity":1},{"product_id":109,"quantity":1}],"total_ex_taxes":415.26000000000005,"delivery_fees":5.45,"tax_rate":0.12,"taxes":50.49,"total":471.2,"status":"ordered","returned":false},{"id":281,"reference":"669kw5","date":"2016-06-14T04:23:00.768Z","customer_id":511,"basket":[{"product_id":64,"quantity":3}],"total_ex_taxes":123.57,"delivery_fees":7.53,"tax_rate":0.12,"taxes":15.73,"total":146.83,"status":"delivered","returned":false},{"id":282,"reference":"t9qseo","date":"2016-09-20T19:00:36.242Z","customer_id":538,"basket":[{"product_id":82,"quantity":1},{"product_id":18,"quantity":1}],"total_ex_taxes":79.44,"delivery_fees":6.82,"tax_rate":0.12,"taxes":10.35,"total":96.61,"status":"delivered","returned":false},{"id":283,"reference":"5brkof","date":"2016-12-22T10:10:06.261Z","customer_id":360,"basket":[{"product_id":35,"quantity":3},{"product_id":2,"quantity":4},{"product_id":129,"quantity":4},{"product_id":91,"quantity":2},{"product_id":108,"quantity":3},{"product_id":73,"quantity":1},{"product_id":109,"quantity":3}],"total_ex_taxes":800.09,"delivery_fees":7.88,"tax_rate":0.12,"taxes":96.96,"total":904.93,"status":"delivered","returned":false},{"id":284,"reference":"sayftk","date":"2015-06-07T16:11:13.413Z","customer_id":625,"basket":[{"product_id":6,"quantity":3},{"product_id":88,"quantity":2}],"total_ex_taxes":261.62,"delivery_fees":6.74,"tax_rate":0.12,"taxes":32.2,"total":300.56,"status":"delivered","returned":true},{"id":285,"reference":"ro56n6","date":"2015-10-15T11:28:22.101Z","customer_id":748,"basket":[{"product_id":27,"quantity":1},{"product_id":58,"quantity":2}],"total_ex_taxes":154.22,"delivery_fees":4.81,"tax_rate":0.12,"taxes":19.08,"total":178.11,"status":"delivered","returned":false},{"id":286,"reference":"3uzh9v","date":"2014-06-24T22:44:26.272Z","customer_id":114,"basket":[{"product_id":48,"quantity":4},{"product_id":111,"quantity":3}],"total_ex_taxes":313.78,"delivery_fees":6.62,"tax_rate":0.17,"taxes":54.47,"total":374.87,"status":"delivered","returned":true},{"id":287,"reference":"n2b9hr","date":"2015-11-02T03:51:30.172Z","customer_id":845,"basket":[{"product_id":2,"quantity":1}],"total_ex_taxes":58.81,"delivery_fees":7.21,"tax_rate":0.17,"taxes":11.22,"total":77.24,"status":"delivered","returned":false},{"id":288,"reference":"cvzdp3","date":"2015-05-23T21:05:39.016Z","customer_id":240,"basket":[{"product_id":101,"quantity":2},{"product_id":63,"quantity":2},{"product_id":64,"quantity":1}],"total_ex_taxes":195.26999999999998,"delivery_fees":4.38,"tax_rate":0.12,"taxes":23.96,"total":223.61,"status":"delivered","returned":false},{"id":289,"reference":"fw1jrv","date":"2016-09-17T09:10:11.557Z","customer_id":440,"basket":[{"product_id":4,"quantity":3}],"total_ex_taxes":111.18,"delivery_fees":5,"tax_rate":0.17,"taxes":19.75,"total":135.93,"status":"delivered","returned":false},{"id":290,"reference":"tnny4w","date":"2015-09-23T22:56:00.788Z","customer_id":727,"basket":[{"product_id":108,"quantity":4}],"total_ex_taxes":128.16,"delivery_fees":5.22,"tax_rate":0.12,"taxes":16.01,"total":149.39,"status":"delivered","returned":false},{"id":291,"reference":"6oe7z2","date":"2016-08-28T06:31:27.306Z","customer_id":428,"basket":[{"product_id":67,"quantity":1},{"product_id":117,"quantity":2}],"total_ex_taxes":34.62,"delivery_fees":4.3,"tax_rate":0.2,"taxes":7.78,"total":46.7,"status":"delivered","returned":false},{"id":292,"reference":"lhh9hm","date":"2016-11-23T13:44:23.987Z","customer_id":596,"basket":[{"product_id":63,"quantity":3},{"product_id":65,"quantity":3},{"product_id":9,"quantity":1},{"product_id":40,"quantity":3}],"total_ex_taxes":222.8,"delivery_fees":6.53,"tax_rate":0.2,"taxes":45.87,"total":275.2,"status":"delivered","returned":false},{"id":293,"reference":"1b18ee","date":"2016-05-18T03:25:42.586Z","customer_id":693,"basket":[{"product_id":98,"quantity":3},{"product_id":65,"quantity":4}],"total_ex_taxes":73.92,"delivery_fees":3.97,"tax_rate":0.17,"taxes":13.24,"total":91.13,"status":"delivered","returned":false},{"id":294,"reference":"a285xi","date":"2017-01-01T23:48:57.684Z","customer_id":733,"basket":[{"product_id":68,"quantity":1},{"product_id":128,"quantity":1},{"product_id":42,"quantity":3},{"product_id":54,"quantity":3},{"product_id":72,"quantity":1},{"product_id":76,"quantity":4},{"product_id":69,"quantity":1},{"product_id":80,"quantity":2}],"total_ex_taxes":708.2599999999999,"delivery_fees":3.38,"tax_rate":0.12,"taxes":85.4,"total":797.04,"status":"delivered","returned":true},{"id":295,"reference":"5zx4ys","date":"2015-08-28T14:03:54.698Z","customer_id":272,"basket":[{"product_id":94,"quantity":1}],"total_ex_taxes":39.88,"delivery_fees":7.56,"tax_rate":0.2,"taxes":9.49,"total":56.93,"status":"delivered","returned":false},{"id":296,"reference":"mjsrll","date":"2016-11-03T19:43:05.861Z","customer_id":421,"basket":[{"product_id":110,"quantity":3},{"product_id":47,"quantity":1},{"product_id":9,"quantity":2},{"product_id":90,"quantity":1}],"total_ex_taxes":287.02,"delivery_fees":3.1,"tax_rate":0.17,"taxes":49.32,"total":339.44,"status":"delivered","returned":false},{"id":297,"reference":"kpnnvm","date":"2016-10-25T06:27:42.062Z","customer_id":737,"basket":[{"product_id":36,"quantity":2}],"total_ex_taxes":83.8,"delivery_fees":6.02,"tax_rate":0.17,"taxes":15.27,"total":105.09,"status":"delivered","returned":false},{"id":298,"reference":"rtgr4z","date":"2015-07-10T01:00:59.354Z","customer_id":887,"basket":[{"product_id":20,"quantity":3}],"total_ex_taxes":59.37,"delivery_fees":3.81,"tax_rate":0.2,"taxes":12.64,"total":75.82,"status":"cancelled","returned":false},{"id":299,"reference":"tyxs4l","date":"2015-10-13T00:46:10.009Z","customer_id":464,"basket":[{"product_id":34,"quantity":1}],"total_ex_taxes":31.76,"delivery_fees":3.85,"tax_rate":0.17,"taxes":6.05,"total":41.66,"status":"delivered","returned":false},{"id":300,"reference":"hfn7ko","date":"2016-09-21T10:28:09.843Z","customer_id":744,"basket":[{"product_id":87,"quantity":3}],"total_ex_taxes":156.09,"delivery_fees":4.84,"tax_rate":0.17,"taxes":27.36,"total":188.29,"status":"delivered","returned":false},{"id":301,"reference":"r5rudu","date":"2016-10-27T01:31:05.651Z","customer_id":427,"basket":[{"product_id":42,"quantity":2}],"total_ex_taxes":72.66,"delivery_fees":6.51,"tax_rate":0.17,"taxes":13.46,"total":92.63,"status":"cancelled","returned":false},{"id":302,"reference":"4r4s4x","date":"2016-06-11T20:02:43.409Z","customer_id":537,"basket":[{"product_id":19,"quantity":1}],"total_ex_taxes":47.12,"delivery_fees":7.22,"tax_rate":0.12,"taxes":6.52,"total":60.86,"status":"delivered","returned":false},{"id":303,"reference":"1gn0nc","date":"2014-10-07T14:10:27.748Z","customer_id":317,"basket":[{"product_id":46,"quantity":1},{"product_id":77,"quantity":1}],"total_ex_taxes":82.63999999999999,"delivery_fees":3.89,"tax_rate":0.17,"taxes":14.71,"total":101.24,"status":"delivered","returned":false},{"id":304,"reference":"wjgviy","date":"2016-09-25T16:36:40.510Z","customer_id":159,"basket":[{"product_id":51,"quantity":1},{"product_id":68,"quantity":3}],"total_ex_taxes":172.03,"delivery_fees":5.61,"tax_rate":0.2,"taxes":35.53,"total":213.17,"status":"delivered","returned":false},{"id":305,"reference":"o7o5sa","date":"2016-07-24T16:10:12.959Z","customer_id":35,"basket":[{"product_id":93,"quantity":1}],"total_ex_taxes":77.92,"delivery_fees":6.16,"tax_rate":0.12,"taxes":10.09,"total":94.17,"status":"delivered","returned":false},{"id":306,"reference":"ncz8uk","date":"2016-02-14T16:38:43.379Z","customer_id":718,"basket":[{"product_id":18,"quantity":2},{"product_id":29,"quantity":1}],"total_ex_taxes":136.29,"delivery_fees":7.21,"tax_rate":0.2,"taxes":28.7,"total":172.2,"status":"cancelled","returned":false},{"id":307,"reference":"fu2192","date":"2016-11-20T12:46:31.738Z","customer_id":31,"basket":[{"product_id":92,"quantity":4}],"total_ex_taxes":90.72,"delivery_fees":4.26,"tax_rate":0.12,"taxes":11.4,"total":106.38,"status":"delivered","returned":true},{"id":308,"reference":"gfs9vj","date":"2014-06-21T04:22:21.182Z","customer_id":854,"basket":[{"product_id":55,"quantity":3},{"product_id":72,"quantity":3}],"total_ex_taxes":191.25,"delivery_fees":5.33,"tax_rate":0.17,"taxes":33.42,"total":230,"status":"delivered","returned":false},{"id":309,"reference":"frd2z3","date":"2016-12-18T12:47:10.219Z","customer_id":893,"basket":[{"product_id":42,"quantity":2},{"product_id":114,"quantity":2}],"total_ex_taxes":126.18,"delivery_fees":6.38,"tax_rate":0.12,"taxes":15.91,"total":148.47,"status":"ordered","returned":false},{"id":310,"reference":"j5kijd","date":"2014-05-11T12:00:09.038Z","customer_id":592,"basket":[{"product_id":59,"quantity":3},{"product_id":66,"quantity":2}],"total_ex_taxes":168.34,"delivery_fees":5.11,"tax_rate":0.17,"taxes":29.49,"total":202.94,"status":"delivered","returned":false},{"id":311,"reference":"5mit54","date":"2015-11-15T12:32:30.233Z","customer_id":95,"basket":[{"product_id":27,"quantity":1},{"product_id":112,"quantity":1}],"total_ex_taxes":48.94,"delivery_fees":3.72,"tax_rate":0.2,"taxes":10.53,"total":63.19,"status":"delivered","returned":false},{"id":312,"reference":"a1jmsi","date":"2015-04-01T05:51:10.718Z","customer_id":44,"basket":[{"product_id":44,"quantity":1}],"total_ex_taxes":81.11,"delivery_fees":5.59,"tax_rate":0.17,"taxes":14.74,"total":101.44,"status":"delivered","returned":false},{"id":313,"reference":"iqwcjl","date":"2016-10-17T00:20:55.273Z","customer_id":183,"basket":[{"product_id":25,"quantity":1},{"product_id":17,"quantity":1}],"total_ex_taxes":90.77,"delivery_fees":6.5,"tax_rate":0.12,"taxes":11.67,"total":108.94,"status":"delivered","returned":false},{"id":314,"reference":"at8g0b","date":"2016-12-21T20:04:42.169Z","customer_id":585,"basket":[{"product_id":62,"quantity":2},{"product_id":67,"quantity":1},{"product_id":39,"quantity":1}],"total_ex_taxes":143.38,"delivery_fees":4.18,"tax_rate":0.17,"taxes":25.09,"total":172.65,"status":"ordered","returned":false},{"id":315,"reference":"li7tv5","date":"2016-12-25T07:47:34.745Z","customer_id":257,"basket":[{"product_id":13,"quantity":2}],"total_ex_taxes":125.38,"delivery_fees":5.73,"tax_rate":0.2,"taxes":26.22,"total":157.33,"status":"ordered","returned":false},{"id":316,"reference":"l3g7il","date":"2016-07-05T01:03:36.492Z","customer_id":156,"basket":[{"product_id":97,"quantity":1},{"product_id":24,"quantity":2}],"total_ex_taxes":123.85000000000001,"delivery_fees":7.01,"tax_rate":0.17,"taxes":22.25,"total":153.11,"status":"delivered","returned":false},{"id":317,"reference":"sxsqtl","date":"2016-08-19T22:25:40.065Z","customer_id":491,"basket":[{"product_id":78,"quantity":1}],"total_ex_taxes":50.15,"delivery_fees":5.93,"tax_rate":0.17,"taxes":9.53,"total":65.61,"status":"delivered","returned":false},{"id":318,"reference":"jvm44o","date":"2014-02-19T15:50:30.429Z","customer_id":86,"basket":[{"product_id":124,"quantity":5}],"total_ex_taxes":106.64999999999999,"delivery_fees":6.37,"tax_rate":0.12,"taxes":13.56,"total":126.58,"status":"delivered","returned":false},{"id":319,"reference":"dhmdr6","date":"2016-11-27T05:31:50.645Z","customer_id":350,"basket":[{"product_id":57,"quantity":1}],"total_ex_taxes":29.51,"delivery_fees":7.68,"tax_rate":0.17,"taxes":6.32,"total":43.51,"status":"delivered","returned":false},{"id":320,"reference":"nty9ia","date":"2014-11-05T00:51:05.144Z","customer_id":547,"basket":[{"product_id":3,"quantity":2},{"product_id":124,"quantity":1}],"total_ex_taxes":48.19,"delivery_fees":7.79,"tax_rate":0.12,"taxes":6.72,"total":62.7,"status":"cancelled","returned":false},{"id":321,"reference":"9yynxh","date":"2015-05-18T11:34:33.124Z","customer_id":514,"basket":[{"product_id":68,"quantity":3},{"product_id":16,"quantity":1}],"total_ex_taxes":147.82,"delivery_fees":6.46,"tax_rate":0.2,"taxes":30.86,"total":185.14,"status":"delivered","returned":false},{"id":322,"reference":"8g9mdo","date":"2015-03-19T17:01:37.657Z","customer_id":866,"basket":[{"product_id":84,"quantity":5}],"total_ex_taxes":117.4,"delivery_fees":5.69,"tax_rate":0.2,"taxes":24.62,"total":147.71,"status":"delivered","returned":false},{"id":323,"reference":"unakag","date":"2016-08-22T21:54:02.883Z","customer_id":858,"basket":[{"product_id":50,"quantity":2}],"total_ex_taxes":98.72,"delivery_fees":7.62,"tax_rate":0.2,"taxes":21.27,"total":127.61,"status":"delivered","returned":false},{"id":324,"reference":"atyq5k","date":"2016-08-10T06:24:15.057Z","customer_id":35,"basket":[{"product_id":59,"quantity":5},{"product_id":129,"quantity":1},{"product_id":124,"quantity":1},{"product_id":59,"quantity":1},{"product_id":125,"quantity":2},{"product_id":108,"quantity":1}],"total_ex_taxes":342.21,"delivery_fees":6.64,"tax_rate":0.2,"taxes":69.77,"total":418.62,"status":"delivered","returned":false},{"id":325,"reference":"mgte6l","date":"2015-04-26T07:29:27.284Z","customer_id":547,"basket":[{"product_id":99,"quantity":1},{"product_id":100,"quantity":3},{"product_id":35,"quantity":5},{"product_id":76,"quantity":3},{"product_id":90,"quantity":1}],"total_ex_taxes":453.38,"delivery_fees":4.06,"tax_rate":0.2,"taxes":91.49,"total":548.93,"status":"delivered","returned":false},{"id":326,"reference":"lg873d","date":"2016-01-10T23:15:47.092Z","customer_id":45,"basket":[{"product_id":108,"quantity":1}],"total_ex_taxes":32.04,"delivery_fees":4.87,"tax_rate":0.2,"taxes":7.38,"total":44.29,"status":"delivered","returned":false},{"id":327,"reference":"4rsm9w","date":"2015-12-20T01:48:12.473Z","customer_id":853,"basket":[{"product_id":109,"quantity":2}],"total_ex_taxes":90.4,"delivery_fees":4.73,"tax_rate":0.12,"taxes":11.42,"total":106.55,"status":"delivered","returned":false},{"id":328,"reference":"77egxn","date":"2016-07-28T20:28:02.872Z","customer_id":863,"basket":[{"product_id":55,"quantity":1},{"product_id":12,"quantity":1}],"total_ex_taxes":99.53,"delivery_fees":4.43,"tax_rate":0.2,"taxes":20.79,"total":124.75,"status":"cancelled","returned":false},{"id":329,"reference":"wdvt12","date":"2014-06-19T06:56:59.967Z","customer_id":37,"basket":[{"product_id":53,"quantity":3}],"total_ex_taxes":123.51,"delivery_fees":5.21,"tax_rate":0.12,"taxes":15.45,"total":144.17,"status":"delivered","returned":false},{"id":330,"reference":"7yf35l","date":"2016-03-13T05:00:47.549Z","customer_id":359,"basket":[{"product_id":24,"quantity":1}],"total_ex_taxes":35.34,"delivery_fees":6.22,"tax_rate":0.17,"taxes":7.07,"total":48.63,"status":"delivered","returned":false},{"id":331,"reference":"ne80ov","date":"2016-07-13T12:17:53.505Z","customer_id":440,"basket":[{"product_id":96,"quantity":1},{"product_id":91,"quantity":1}],"total_ex_taxes":80.46000000000001,"delivery_fees":5.37,"tax_rate":0.2,"taxes":17.17,"total":103,"status":"delivered","returned":true},{"id":332,"reference":"5czk1t","date":"2016-03-22T13:05:19.618Z","customer_id":70,"basket":[{"product_id":63,"quantity":2}],"total_ex_taxes":60.64,"delivery_fees":3.57,"tax_rate":0.2,"taxes":12.84,"total":77.05,"status":"delivered","returned":false},{"id":333,"reference":"a45fgf","date":"2016-09-02T03:00:04.747Z","customer_id":762,"basket":[{"product_id":9,"quantity":1},{"product_id":111,"quantity":2}],"total_ex_taxes":76.65,"delivery_fees":6.69,"tax_rate":0.17,"taxes":14.17,"total":97.51,"status":"delivered","returned":false},{"id":334,"reference":"dicj9t","date":"2016-10-10T22:14:11.960Z","customer_id":296,"basket":[{"product_id":14,"quantity":1},{"product_id":16,"quantity":3}],"total_ex_taxes":118.13000000000001,"delivery_fees":4.51,"tax_rate":0.2,"taxes":24.53,"total":147.17,"status":"delivered","returned":false},{"id":335,"reference":"5cc7s8","date":"2015-10-08T14:58:31.051Z","customer_id":492,"basket":[{"product_id":22,"quantity":1},{"product_id":27,"quantity":1},{"product_id":39,"quantity":1},{"product_id":105,"quantity":2},{"product_id":23,"quantity":1},{"product_id":65,"quantity":2},{"product_id":127,"quantity":3}],"total_ex_taxes":290.47999999999996,"delivery_fees":3.45,"tax_rate":0.12,"taxes":35.27,"total":329.2,"status":"delivered","returned":false},{"id":336,"reference":"dj7rbl","date":"2016-11-24T12:03:31.048Z","customer_id":576,"basket":[{"product_id":63,"quantity":1}],"total_ex_taxes":30.32,"delivery_fees":7.64,"tax_rate":0.12,"taxes":4.56,"total":42.52,"status":"delivered","returned":false},{"id":337,"reference":"5xlfm8","date":"2016-12-24T13:29:48.390Z","customer_id":485,"basket":[{"product_id":68,"quantity":1},{"product_id":123,"quantity":1},{"product_id":96,"quantity":1}],"total_ex_taxes":125.08999999999999,"delivery_fees":6.85,"tax_rate":0.2,"taxes":26.39,"total":158.33,"status":"ordered","returned":false},{"id":338,"reference":"jaw1ks","date":"2015-04-05T10:26:50.812Z","customer_id":189,"basket":[{"product_id":53,"quantity":1}],"total_ex_taxes":41.17,"delivery_fees":6.96,"tax_rate":0.17,"taxes":8.18,"total":56.31,"status":"delivered","returned":false},{"id":339,"reference":"vaxc74","date":"2014-11-20T16:11:06.107Z","customer_id":547,"basket":[{"product_id":89,"quantity":1},{"product_id":100,"quantity":1}],"total_ex_taxes":70.19,"delivery_fees":5.25,"tax_rate":0.12,"taxes":9.05,"total":84.49,"status":"delivered","returned":false},{"id":340,"reference":"1ddcpw","date":"2016-11-10T01:18:51.090Z","customer_id":360,"basket":[{"product_id":35,"quantity":4},{"product_id":7,"quantity":5},{"product_id":39,"quantity":1},{"product_id":96,"quantity":1},{"product_id":73,"quantity":1},{"product_id":2,"quantity":2},{"product_id":20,"quantity":2},{"product_id":73,"quantity":3},{"product_id":76,"quantity":1},{"product_id":10,"quantity":3}],"total_ex_taxes":762.96,"delivery_fees":3.59,"tax_rate":0.12,"taxes":91.99,"total":858.54,"status":"delivered","returned":false},{"id":341,"reference":"34wauk","date":"2016-10-14T15:18:00.221Z","customer_id":284,"basket":[{"product_id":110,"quantity":4}],"total_ex_taxes":178.08,"delivery_fees":5.49,"tax_rate":0.2,"taxes":36.71,"total":220.28,"status":"delivered","returned":false},{"id":342,"reference":"nr0zvz","date":"2016-03-01T11:39:42.485Z","customer_id":379,"basket":[{"product_id":26,"quantity":1},{"product_id":9,"quantity":2},{"product_id":56,"quantity":1}],"total_ex_taxes":134.87,"delivery_fees":4.44,"tax_rate":0.17,"taxes":23.68,"total":162.99,"status":"delivered","returned":false},{"id":343,"reference":"9wr8ua","date":"2014-06-11T07:05:44.507Z","customer_id":644,"basket":[{"product_id":26,"quantity":5},{"product_id":11,"quantity":2},{"product_id":90,"quantity":1}],"total_ex_taxes":221.90999999999997,"delivery_fees":7.59,"tax_rate":0.12,"taxes":27.54,"total":257.04,"status":"delivered","returned":false},{"id":344,"reference":"6zcfx8","date":"2016-12-26T05:52:37.574Z","customer_id":350,"basket":[{"product_id":128,"quantity":1},{"product_id":119,"quantity":2},{"product_id":66,"quantity":1},{"product_id":57,"quantity":1},{"product_id":46,"quantity":1},{"product_id":42,"quantity":1}],"total_ex_taxes":290.59,"delivery_fees":3.89,"tax_rate":0.17,"taxes":50.06,"total":344.54,"status":"ordered","returned":false},{"id":345,"reference":"w2bejf","date":"2015-09-11T06:54:25.379Z","customer_id":130,"basket":[{"product_id":4,"quantity":1},{"product_id":14,"quantity":1},{"product_id":75,"quantity":1},{"product_id":126,"quantity":1},{"product_id":46,"quantity":2},{"product_id":74,"quantity":5},{"product_id":115,"quantity":1},{"product_id":1,"quantity":2},{"product_id":115,"quantity":1},{"product_id":16,"quantity":1}],"total_ex_taxes":602.0099999999999,"delivery_fees":5.14,"tax_rate":0.12,"taxes":72.86,"total":680.01,"status":"delivered","returned":false},{"id":346,"reference":"gpdmlh","date":"2016-10-22T13:19:00.734Z","customer_id":18,"basket":[{"product_id":26,"quantity":2},{"product_id":55,"quantity":3},{"product_id":80,"quantity":1},{"product_id":67,"quantity":1}],"total_ex_taxes":286.5,"delivery_fees":5.08,"tax_rate":0.2,"taxes":58.32,"total":349.9,"status":"delivered","returned":false},{"id":347,"reference":"p71byg","date":"2016-11-22T17:19:15.708Z","customer_id":197,"basket":[{"product_id":102,"quantity":1},{"product_id":127,"quantity":4}],"total_ex_taxes":107.83,"delivery_fees":5.84,"tax_rate":0.17,"taxes":19.32,"total":132.99,"status":"delivered","returned":false},{"id":348,"reference":"wezcwd","date":"2015-11-08T05:37:53.829Z","customer_id":825,"basket":[{"product_id":121,"quantity":2}],"total_ex_taxes":31.06,"delivery_fees":7.41,"tax_rate":0.2,"taxes":7.69,"total":46.16,"status":"cancelled","returned":false},{"id":349,"reference":"7cu4a9","date":"2015-08-20T13:51:29.985Z","customer_id":271,"basket":[{"product_id":11,"quantity":2},{"product_id":109,"quantity":1},{"product_id":14,"quantity":3}],"total_ex_taxes":153.26,"delivery_fees":4.77,"tax_rate":0.17,"taxes":26.87,"total":184.9,"status":"delivered","returned":false},{"id":350,"reference":"o5ua15","date":"2016-10-09T20:47:23.592Z","customer_id":159,"basket":[{"product_id":21,"quantity":2}],"total_ex_taxes":99.46,"delivery_fees":4.32,"tax_rate":0.17,"taxes":17.64,"total":121.42,"status":"delivered","returned":false},{"id":351,"reference":"xr5tbd","date":"2015-04-08T18:07:18.762Z","customer_id":315,"basket":[{"product_id":53,"quantity":2},{"product_id":108,"quantity":2},{"product_id":66,"quantity":1},{"product_id":10,"quantity":2},{"product_id":64,"quantity":3}],"total_ex_taxes":341.08000000000004,"delivery_fees":5.81,"tax_rate":0.12,"taxes":41.63,"total":388.52,"status":"delivered","returned":true},{"id":352,"reference":"4biqjt","date":"2015-08-11T14:22:26.284Z","customer_id":529,"basket":[{"product_id":64,"quantity":1},{"product_id":71,"quantity":2}],"total_ex_taxes":84.81,"delivery_fees":6.12,"tax_rate":0.17,"taxes":15.46,"total":106.39,"status":"delivered","returned":false},{"id":353,"reference":"r06rhz","date":"2015-09-24T10:43:39.893Z","customer_id":130,"basket":[{"product_id":50,"quantity":1},{"product_id":60,"quantity":1}],"total_ex_taxes":73.02,"delivery_fees":6.01,"tax_rate":0.12,"taxes":9.48,"total":88.51,"status":"cancelled","returned":false},{"id":354,"reference":"zke34r","date":"2016-11-12T08:09:29.268Z","customer_id":762,"basket":[{"product_id":48,"quantity":2},{"product_id":126,"quantity":3},{"product_id":108,"quantity":3},{"product_id":94,"quantity":1},{"product_id":6,"quantity":4},{"product_id":106,"quantity":1},{"product_id":28,"quantity":1},{"product_id":13,"quantity":1},{"product_id":79,"quantity":2},{"product_id":76,"quantity":1}],"total_ex_taxes":838.7299999999999,"delivery_fees":7.41,"tax_rate":0.12,"taxes":101.54,"total":947.68,"status":"delivered","returned":false},{"id":355,"reference":"hixyez","date":"2016-02-22T13:58:24.453Z","customer_id":63,"basket":[{"product_id":26,"quantity":3}],"total_ex_taxes":99.47999999999999,"delivery_fees":5.78,"tax_rate":0.12,"taxes":12.63,"total":117.89,"status":"delivered","returned":false},{"id":356,"reference":"3newc7","date":"2015-01-01T20:36:30.011Z","customer_id":265,"basket":[{"product_id":50,"quantity":3},{"product_id":115,"quantity":1}],"total_ex_taxes":161.13,"delivery_fees":4.38,"tax_rate":0.2,"taxes":33.1,"total":198.61,"status":"delivered","returned":false},{"id":357,"reference":"5vekq9","date":"2016-09-04T05:47:29.171Z","customer_id":253,"basket":[{"product_id":47,"quantity":2},{"product_id":105,"quantity":1},{"product_id":53,"quantity":1},{"product_id":10,"quantity":3}],"total_ex_taxes":197.38,"delivery_fees":3.09,"tax_rate":0.2,"taxes":40.09,"total":240.56,"status":"delivered","returned":false},{"id":358,"reference":"n461f1","date":"2016-11-01T10:49:02.561Z","customer_id":707,"basket":[{"product_id":96,"quantity":1}],"total_ex_taxes":38.08,"delivery_fees":5.55,"tax_rate":0.12,"taxes":5.24,"total":48.87,"status":"delivered","returned":false},{"id":359,"reference":"egsojg","date":"2015-05-28T13:23:17.264Z","customer_id":884,"basket":[{"product_id":63,"quantity":2},{"product_id":86,"quantity":2}],"total_ex_taxes":149.72,"delivery_fees":7.14,"tax_rate":0.17,"taxes":26.67,"total":183.53,"status":"delivered","returned":false},{"id":360,"reference":"61gdqx","date":"2016-03-04T21:46:54.624Z","customer_id":727,"basket":[{"product_id":89,"quantity":4},{"product_id":19,"quantity":2},{"product_id":97,"quantity":3},{"product_id":50,"quantity":1},{"product_id":106,"quantity":1},{"product_id":21,"quantity":1},{"product_id":13,"quantity":1},{"product_id":104,"quantity":4},{"product_id":40,"quantity":1}],"total_ex_taxes":896.6299999999999,"delivery_fees":3.88,"tax_rate":0.17,"taxes":153.09,"total":1053.6,"status":"delivered","returned":false},{"id":361,"reference":"i23xp8","date":"2016-12-21T17:15:27.904Z","customer_id":774,"basket":[{"product_id":5,"quantity":2},{"product_id":110,"quantity":1}],"total_ex_taxes":122.97999999999999,"delivery_fees":6.55,"tax_rate":0.17,"taxes":22.02,"total":151.55,"status":"ordered","returned":false},{"id":362,"reference":"9tlnhf","date":"2016-06-18T05:36:04.469Z","customer_id":708,"basket":[{"product_id":100,"quantity":3},{"product_id":31,"quantity":1}],"total_ex_taxes":215.76,"delivery_fees":7.98,"tax_rate":0.17,"taxes":38.04,"total":261.78,"status":"delivered","returned":false},{"id":363,"reference":"jffmxe","date":"2016-03-28T21:53:36.733Z","customer_id":160,"basket":[{"product_id":0,"quantity":1}],"total_ex_taxes":28.65,"delivery_fees":3.7,"tax_rate":0.17,"taxes":5.5,"total":37.85,"status":"delivered","returned":false},{"id":364,"reference":"e9qbxl","date":"2016-10-20T05:07:05.008Z","customer_id":774,"basket":[{"product_id":5,"quantity":1},{"product_id":2,"quantity":1}],"total_ex_taxes":98.03999999999999,"delivery_fees":7.64,"tax_rate":0.17,"taxes":17.97,"total":123.65,"status":"delivered","returned":false},{"id":365,"reference":"hh7ajc","date":"2016-12-30T18:43:48.744Z","customer_id":470,"basket":[{"product_id":95,"quantity":1}],"total_ex_taxes":26.37,"delivery_fees":3.48,"tax_rate":0.12,"taxes":3.58,"total":33.43,"status":"delivered","returned":false},{"id":366,"reference":"chxvn3","date":"2015-06-01T14:45:10.188Z","customer_id":51,"basket":[{"product_id":20,"quantity":1},{"product_id":63,"quantity":3},{"product_id":109,"quantity":1}],"total_ex_taxes":155.95,"delivery_fees":6.37,"tax_rate":0.2,"taxes":32.46,"total":194.78,"status":"delivered","returned":false},{"id":367,"reference":"awle97","date":"2016-03-24T04:29:11.426Z","customer_id":431,"basket":[{"product_id":42,"quantity":1},{"product_id":79,"quantity":1}],"total_ex_taxes":50.47,"delivery_fees":4.86,"tax_rate":0.2,"taxes":11.07,"total":66.4,"status":"delivered","returned":true},{"id":368,"reference":"29ooja","date":"2014-06-18T09:45:58.501Z","customer_id":547,"basket":[{"product_id":91,"quantity":2}],"total_ex_taxes":84.76,"delivery_fees":5.35,"tax_rate":0.12,"taxes":10.81,"total":100.92,"status":"delivered","returned":false},{"id":369,"reference":"icg75b","date":"2014-09-23T16:09:22.074Z","customer_id":391,"basket":[{"product_id":34,"quantity":5}],"total_ex_taxes":158.8,"delivery_fees":4.23,"tax_rate":0.2,"taxes":32.61,"total":195.64,"status":"delivered","returned":false},{"id":370,"reference":"lyh4aa","date":"2016-11-29T20:55:30.993Z","customer_id":893,"basket":[{"product_id":116,"quantity":4}],"total_ex_taxes":265.84,"delivery_fees":6.39,"tax_rate":0.17,"taxes":46.28,"total":318.51,"status":"delivered","returned":false},{"id":371,"reference":"ix98lx","date":"2015-11-10T09:38:46.283Z","customer_id":866,"basket":[{"product_id":119,"quantity":1},{"product_id":92,"quantity":3},{"product_id":58,"quantity":1}],"total_ex_taxes":165.29,"delivery_fees":4.63,"tax_rate":0.12,"taxes":20.39,"total":190.31,"status":"delivered","returned":false},{"id":372,"reference":"ghmdff","date":"2016-01-11T08:47:15.488Z","customer_id":689,"basket":[{"product_id":2,"quantity":1}],"total_ex_taxes":58.81,"delivery_fees":5.78,"tax_rate":0.12,"taxes":7.75,"total":72.34,"status":"delivered","returned":false},{"id":373,"reference":"8wj5s4","date":"2016-11-16T19:30:53.697Z","customer_id":137,"basket":[{"product_id":27,"quantity":4},{"product_id":59,"quantity":1},{"product_id":127,"quantity":1}],"total_ex_taxes":116.60000000000001,"delivery_fees":6.72,"tax_rate":0.12,"taxes":14.8,"total":138.12,"status":"delivered","returned":false},{"id":374,"reference":"ggmbc4","date":"2015-12-03T00:56:30.243Z","customer_id":892,"basket":[{"product_id":93,"quantity":3}],"total_ex_taxes":233.76,"delivery_fees":5.26,"tax_rate":0.2,"taxes":47.8,"total":286.82,"status":"delivered","returned":false},{"id":375,"reference":"0lu005","date":"2016-11-08T22:03:37.148Z","customer_id":511,"basket":[{"product_id":39,"quantity":1}],"total_ex_taxes":32.9,"delivery_fees":5.68,"tax_rate":0.12,"taxes":4.63,"total":43.21,"status":"delivered","returned":false},{"id":376,"reference":"bu5jnx","date":"2014-10-23T13:31:06.751Z","customer_id":340,"basket":[{"product_id":78,"quantity":1},{"product_id":93,"quantity":3}],"total_ex_taxes":283.90999999999997,"delivery_fees":5.8,"tax_rate":0.12,"taxes":34.77,"total":324.48,"status":"delivered","returned":true},{"id":377,"reference":"j7xobi","date":"2014-10-26T07:33:31.548Z","customer_id":895,"basket":[{"product_id":55,"quantity":2},{"product_id":30,"quantity":1}],"total_ex_taxes":114.13,"delivery_fees":4.31,"tax_rate":0.12,"taxes":14.21,"total":132.65,"status":"delivered","returned":false},{"id":378,"reference":"jj169y","date":"2016-02-01T14:38:31.853Z","customer_id":390,"basket":[{"product_id":64,"quantity":2}],"total_ex_taxes":82.38,"delivery_fees":7.98,"tax_rate":0.17,"taxes":15.36,"total":105.72,"status":"delivered","returned":false},{"id":379,"reference":"rfrio4","date":"2016-12-28T23:23:07.378Z","customer_id":257,"basket":[{"product_id":1,"quantity":3},{"product_id":19,"quantity":3}],"total_ex_taxes":310.04999999999995,"delivery_fees":6.93,"tax_rate":0.12,"taxes":38.04,"total":355.02,"status":"delivered","returned":false},{"id":380,"reference":"q2ig9l","date":"2016-12-29T03:28:48.923Z","customer_id":485,"basket":[{"product_id":80,"quantity":2}],"total_ex_taxes":140.1,"delivery_fees":3.94,"tax_rate":0.17,"taxes":24.49,"total":168.53,"status":"delivered","returned":false},{"id":381,"reference":"5akzyl","date":"2014-07-16T02:25:26.480Z","customer_id":661,"basket":[{"product_id":27,"quantity":2},{"product_id":51,"quantity":1},{"product_id":10,"quantity":4},{"product_id":106,"quantity":2}],"total_ex_taxes":299.28,"delivery_fees":6.14,"tax_rate":0.17,"taxes":51.92,"total":357.34,"status":"delivered","returned":true},{"id":382,"reference":"53sc8f","date":"2016-12-29T17:57:41.857Z","customer_id":554,"basket":[{"product_id":66,"quantity":5}],"total_ex_taxes":135.25,"delivery_fees":3.73,"tax_rate":0.12,"taxes":16.68,"total":155.66,"status":"ordered","returned":false},{"id":383,"reference":"a15qc1","date":"2016-12-11T02:34:03.007Z","customer_id":277,"basket":[{"product_id":16,"quantity":1},{"product_id":120,"quantity":2}],"total_ex_taxes":70.59,"delivery_fees":4.13,"tax_rate":0.17,"taxes":12.7,"total":87.42,"status":"delivered","returned":false},{"id":384,"reference":"mk7cqo","date":"2016-10-25T08:19:58.582Z","customer_id":459,"basket":[{"product_id":93,"quantity":2},{"product_id":25,"quantity":1}],"total_ex_taxes":186.49,"delivery_fees":5.62,"tax_rate":0.2,"taxes":38.42,"total":230.53,"status":"delivered","returned":false},{"id":385,"reference":"tzanip","date":"2016-01-28T09:02:22.769Z","customer_id":132,"basket":[{"product_id":81,"quantity":1}],"total_ex_taxes":49.46,"delivery_fees":6.25,"tax_rate":0.17,"taxes":9.47,"total":65.18,"status":"cancelled","returned":false},{"id":386,"reference":"44gr88","date":"2016-04-23T06:26:36.428Z","customer_id":431,"basket":[{"product_id":81,"quantity":3},{"product_id":103,"quantity":1}],"total_ex_taxes":164.24,"delivery_fees":6.63,"tax_rate":0.12,"taxes":20.5,"total":191.37,"status":"cancelled","returned":false},{"id":387,"reference":"bb465p","date":"2014-09-26T15:09:16.744Z","customer_id":208,"basket":[{"product_id":117,"quantity":4}],"total_ex_taxes":50.8,"delivery_fees":5.13,"tax_rate":0.17,"taxes":9.51,"total":65.44,"status":"delivered","returned":false},{"id":388,"reference":"myt69s","date":"2016-03-22T19:59:36.385Z","customer_id":379,"basket":[{"product_id":96,"quantity":3},{"product_id":45,"quantity":5}],"total_ex_taxes":213.19,"delivery_fees":6.59,"tax_rate":0.2,"taxes":43.96,"total":263.74,"status":"delivered","returned":false},{"id":389,"reference":"pkn74n","date":"2016-08-03T00:23:23.117Z","customer_id":708,"basket":[{"product_id":83,"quantity":3}],"total_ex_taxes":76.47,"delivery_fees":5.27,"tax_rate":0.17,"taxes":13.9,"total":95.64,"status":"delivered","returned":true},{"id":390,"reference":"l8mnsp","date":"2015-07-19T20:46:56.296Z","customer_id":240,"basket":[{"product_id":75,"quantity":3},{"product_id":73,"quantity":1},{"product_id":34,"quantity":2},{"product_id":63,"quantity":4}],"total_ex_taxes":302.25,"delivery_fees":4.44,"tax_rate":0.2,"taxes":61.34,"total":368.03,"status":"delivered","returned":false},{"id":391,"reference":"3zx64f","date":"2016-07-09T09:49:10.183Z","customer_id":35,"basket":[{"product_id":106,"quantity":1},{"product_id":31,"quantity":2},{"product_id":57,"quantity":1},{"product_id":56,"quantity":1},{"product_id":118,"quantity":1},{"product_id":129,"quantity":1},{"product_id":83,"quantity":4},{"product_id":46,"quantity":1},{"product_id":61,"quantity":3}],"total_ex_taxes":593.25,"delivery_fees":5.65,"tax_rate":0.17,"taxes":101.81,"total":700.71,"status":"delivered","returned":false},{"id":392,"reference":"h43pb0","date":"2015-04-05T23:25:45.539Z","customer_id":45,"basket":[{"product_id":102,"quantity":1}],"total_ex_taxes":11.03,"delivery_fees":4.39,"tax_rate":0.12,"taxes":1.85,"total":17.27,"status":"delivered","returned":true},{"id":393,"reference":"on4797","date":"2014-11-29T01:05:43.961Z","customer_id":200,"basket":[{"product_id":10,"quantity":1},{"product_id":113,"quantity":1},{"product_id":64,"quantity":1}],"total_ex_taxes":120.14999999999999,"delivery_fees":5.3,"tax_rate":0.17,"taxes":21.33,"total":146.78,"status":"delivered","returned":false},{"id":394,"reference":"6bhbns","date":"2016-05-10T01:42:41.940Z","customer_id":898,"basket":[{"product_id":72,"quantity":3}],"total_ex_taxes":50.34,"delivery_fees":5.41,"tax_rate":0.17,"taxes":9.48,"total":65.23,"status":"delivered","returned":false},{"id":395,"reference":"tsx262","date":"2014-08-23T04:24:32.782Z","customer_id":535,"basket":[{"product_id":42,"quantity":1},{"product_id":32,"quantity":2}],"total_ex_taxes":87.85,"delivery_fees":4,"tax_rate":0.12,"taxes":11.02,"total":102.87,"status":"delivered","returned":false},{"id":396,"reference":"ty9yll","date":"2015-11-19T17:55:28.400Z","customer_id":311,"basket":[{"product_id":70,"quantity":2},{"product_id":76,"quantity":2},{"product_id":23,"quantity":1},{"product_id":61,"quantity":1}],"total_ex_taxes":323.21999999999997,"delivery_fees":5.96,"tax_rate":0.2,"taxes":65.84,"total":395.02,"status":"delivered","returned":false},{"id":397,"reference":"hzj0qw","date":"2016-11-20T08:23:43.217Z","customer_id":487,"basket":[{"product_id":96,"quantity":1}],"total_ex_taxes":38.08,"delivery_fees":6.02,"tax_rate":0.17,"taxes":7.5,"total":51.6,"status":"delivered","returned":false},{"id":398,"reference":"k5q108","date":"2016-12-04T07:12:54.723Z","customer_id":804,"basket":[{"product_id":117,"quantity":1}],"total_ex_taxes":12.7,"delivery_fees":6.84,"tax_rate":0.17,"taxes":3.32,"total":22.86,"status":"delivered","returned":false},{"id":399,"reference":"p1drqy","date":"2016-01-23T11:57:38.349Z","customer_id":351,"basket":[{"product_id":119,"quantity":2}],"total_ex_taxes":53.86,"delivery_fees":6.91,"tax_rate":0.17,"taxes":10.33,"total":71.1,"status":"delivered","returned":false},{"id":400,"reference":"iva73u","date":"2016-05-21T18:00:42.670Z","customer_id":567,"basket":[{"product_id":126,"quantity":3},{"product_id":117,"quantity":4},{"product_id":17,"quantity":2},{"product_id":119,"quantity":2},{"product_id":94,"quantity":1},{"product_id":96,"quantity":3},{"product_id":48,"quantity":4},{"product_id":31,"quantity":1},{"product_id":104,"quantity":1}],"total_ex_taxes":914.83,"delivery_fees":5.54,"tax_rate":0.17,"taxes":156.46,"total":1076.83,"status":"delivered","returned":false},{"id":401,"reference":"tp9vm3","date":"2015-05-03T22:18:19.513Z","customer_id":400,"basket":[{"product_id":3,"quantity":1}],"total_ex_taxes":13.43,"delivery_fees":7.78,"tax_rate":0.2,"taxes":4.24,"total":25.45,"status":"delivered","returned":false},{"id":402,"reference":"nxnu41","date":"2014-05-17T07:12:45.156Z","customer_id":567,"basket":[{"product_id":116,"quantity":1}],"total_ex_taxes":66.46,"delivery_fees":7.52,"tax_rate":0.17,"taxes":12.58,"total":86.56,"status":"delivered","returned":false},{"id":403,"reference":"5uf3oz","date":"2016-03-01T20:35:14.681Z","customer_id":217,"basket":[{"product_id":98,"quantity":4}],"total_ex_taxes":33.28,"delivery_fees":4.22,"tax_rate":0.2,"taxes":7.5,"total":45,"status":"delivered","returned":false},{"id":404,"reference":"fzkdxm","date":"2016-10-20T18:33:49.043Z","customer_id":389,"basket":[{"product_id":85,"quantity":3},{"product_id":73,"quantity":4},{"product_id":102,"quantity":2},{"product_id":107,"quantity":2},{"product_id":2,"quantity":1},{"product_id":98,"quantity":5},{"product_id":91,"quantity":4},{"product_id":111,"quantity":1},{"product_id":7,"quantity":3}],"total_ex_taxes":955.83,"delivery_fees":4.18,"tax_rate":0.17,"taxes":163.2,"total":1123.21,"status":"delivered","returned":false},{"id":405,"reference":"6f4gkb","date":"2016-10-27T20:15:43.973Z","customer_id":31,"basket":[{"product_id":94,"quantity":4}],"total_ex_taxes":159.52,"delivery_fees":6.89,"tax_rate":0.17,"taxes":28.29,"total":194.7,"status":"delivered","returned":false},{"id":406,"reference":"cqleo1","date":"2016-08-24T15:03:03.642Z","customer_id":111,"basket":[{"product_id":129,"quantity":4},{"product_id":113,"quantity":1},{"product_id":24,"quantity":2},{"product_id":55,"quantity":2},{"product_id":97,"quantity":2},{"product_id":44,"quantity":1},{"product_id":121,"quantity":1}],"total_ex_taxes":527.26,"delivery_fees":4.07,"tax_rate":0.17,"taxes":90.33,"total":621.66,"status":"delivered","returned":false},{"id":407,"reference":"buaos8","date":"2015-05-07T22:24:19.669Z","customer_id":59,"basket":[{"product_id":26,"quantity":1},{"product_id":75,"quantity":2},{"product_id":43,"quantity":1},{"product_id":23,"quantity":2},{"product_id":38,"quantity":4}],"total_ex_taxes":393.28,"delivery_fees":7.23,"tax_rate":0.2,"taxes":80.1,"total":480.61,"status":"delivered","returned":false},{"id":408,"reference":"hqisbr","date":"2015-10-01T23:23:35.581Z","customer_id":401,"basket":[{"product_id":5,"quantity":3}],"total_ex_taxes":117.69,"delivery_fees":5.56,"tax_rate":0.17,"taxes":20.95,"total":144.2,"status":"delivered","returned":false},{"id":409,"reference":"emtcfa","date":"2016-10-30T03:07:28.032Z","customer_id":838,"basket":[{"product_id":44,"quantity":2},{"product_id":3,"quantity":1}],"total_ex_taxes":175.65,"delivery_fees":4.94,"tax_rate":0.2,"taxes":36.12,"total":216.71,"status":"delivered","returned":false},{"id":410,"reference":"196jtp","date":"2016-12-07T20:27:01.126Z","customer_id":554,"basket":[{"product_id":112,"quantity":3},{"product_id":80,"quantity":1},{"product_id":50,"quantity":3},{"product_id":102,"quantity":2},{"product_id":104,"quantity":1},{"product_id":119,"quantity":2},{"product_id":83,"quantity":1},{"product_id":118,"quantity":1}],"total_ex_taxes":529.01,"delivery_fees":3.01,"tax_rate":0.17,"taxes":90.44,"total":622.46,"status":"ordered","returned":false},{"id":411,"reference":"rg0nq4","date":"2016-11-01T07:18:45.959Z","customer_id":296,"basket":[{"product_id":59,"quantity":1}],"total_ex_taxes":38.08,"delivery_fees":3.13,"tax_rate":0.12,"taxes":4.95,"total":46.16,"status":"delivered","returned":false},{"id":412,"reference":"si0bxj","date":"2016-04-09T22:53:42.810Z","customer_id":863,"basket":[{"product_id":17,"quantity":4}],"total_ex_taxes":240.48,"delivery_fees":5.25,"tax_rate":0.17,"taxes":41.77,"total":287.5,"status":"delivered","returned":false},{"id":413,"reference":"9zkynm","date":"2016-11-20T21:39:42.913Z","customer_id":389,"basket":[{"product_id":39,"quantity":1}],"total_ex_taxes":32.9,"delivery_fees":5.86,"tax_rate":0.2,"taxes":7.75,"total":46.51,"status":"delivered","returned":false},{"id":414,"reference":"rr0zy1","date":"2016-08-15T07:04:17.766Z","customer_id":484,"basket":[{"product_id":116,"quantity":4}],"total_ex_taxes":265.84,"delivery_fees":4.64,"tax_rate":0.2,"taxes":54.1,"total":324.58,"status":"delivered","returned":false},{"id":415,"reference":"343u39","date":"2016-01-08T03:42:07.274Z","customer_id":845,"basket":[{"product_id":66,"quantity":2},{"product_id":2,"quantity":2}],"total_ex_taxes":171.72,"delivery_fees":4.19,"tax_rate":0.2,"taxes":35.18,"total":211.09,"status":"delivered","returned":false},{"id":416,"reference":"p50edt","date":"2016-01-13T23:24:44.046Z","customer_id":558,"basket":[{"product_id":35,"quantity":5},{"product_id":38,"quantity":1}],"total_ex_taxes":179.94,"delivery_fees":4.06,"tax_rate":0.2,"taxes":36.8,"total":220.8,"status":"delivered","returned":false},{"id":417,"reference":"hhnyuy","date":"2015-11-04T01:12:40.641Z","customer_id":229,"basket":[{"product_id":23,"quantity":1},{"product_id":8,"quantity":3}],"total_ex_taxes":144.37,"delivery_fees":5.56,"tax_rate":0.12,"taxes":17.99,"total":167.92,"status":"delivered","returned":false},{"id":418,"reference":"kokrbk","date":"2016-06-11T06:17:51.010Z","customer_id":195,"basket":[{"product_id":60,"quantity":2},{"product_id":100,"quantity":1},{"product_id":36,"quantity":4}],"total_ex_taxes":261.75,"delivery_fees":6.31,"tax_rate":0.12,"taxes":32.17,"total":300.23,"status":"delivered","returned":false},{"id":419,"reference":"7nlpcz","date":"2016-10-06T07:52:29.404Z","customer_id":840,"basket":[{"product_id":124,"quantity":1}],"total_ex_taxes":21.33,"delivery_fees":3.36,"tax_rate":0.17,"taxes":4.2,"total":28.89,"status":"delivered","returned":true},{"id":420,"reference":"xe255o","date":"2016-08-28T23:26:38.167Z","customer_id":183,"basket":[{"product_id":9,"quantity":1},{"product_id":27,"quantity":1}],"total_ex_taxes":53.23,"delivery_fees":7.63,"tax_rate":0.17,"taxes":10.35,"total":71.21,"status":"delivered","returned":false},{"id":421,"reference":"g2sz1j","date":"2015-12-30T01:23:42.961Z","customer_id":126,"basket":[{"product_id":59,"quantity":5},{"product_id":88,"quantity":1}],"total_ex_taxes":232.34999999999997,"delivery_fees":7.98,"tax_rate":0.12,"taxes":28.84,"total":269.17,"status":"delivered","returned":false},{"id":422,"reference":"axv27i","date":"2016-04-25T02:43:45.226Z","customer_id":599,"basket":[{"product_id":30,"quantity":1},{"product_id":102,"quantity":4},{"product_id":80,"quantity":2},{"product_id":102,"quantity":1},{"product_id":31,"quantity":1},{"product_id":6,"quantity":3},{"product_id":69,"quantity":2}],"total_ex_taxes":494.04999999999995,"delivery_fees":4.48,"tax_rate":0.2,"taxes":99.71,"total":598.24,"status":"delivered","returned":false},{"id":423,"reference":"09ti8v","date":"2016-10-13T08:19:57.791Z","customer_id":433,"basket":[{"product_id":10,"quantity":2}],"total_ex_taxes":44.04,"delivery_fees":3.97,"tax_rate":0.17,"taxes":8.16,"total":56.17,"status":"delivered","returned":false},{"id":424,"reference":"7w877a","date":"2013-01-11T12:47:18.123Z","customer_id":498,"basket":[{"product_id":126,"quantity":3},{"product_id":25,"quantity":1}],"total_ex_taxes":156.95000000000002,"delivery_fees":4.59,"tax_rate":0.12,"taxes":19.38,"total":180.92,"status":"cancelled","returned":false},{"id":425,"reference":"ask1ug","date":"2017-01-03T14:23:41.115Z","customer_id":554,"basket":[{"product_id":111,"quantity":1}],"total_ex_taxes":18.5,"delivery_fees":3.5,"tax_rate":0.2,"taxes":4.4,"total":26.4,"status":"delivered","returned":false},{"id":426,"reference":"ovshld","date":"2016-04-03T21:45:53.003Z","customer_id":763,"basket":[{"product_id":34,"quantity":4}],"total_ex_taxes":127.04,"delivery_fees":7.17,"tax_rate":0.17,"taxes":22.82,"total":157.03,"status":"delivered","returned":false},{"id":427,"reference":"25almb","date":"2016-02-09T17:28:29.009Z","customer_id":627,"basket":[{"product_id":28,"quantity":1},{"product_id":47,"quantity":2},{"product_id":121,"quantity":1},{"product_id":108,"quantity":1},{"product_id":110,"quantity":5},{"product_id":43,"quantity":1},{"product_id":107,"quantity":2},{"product_id":3,"quantity":1},{"product_id":112,"quantity":3},{"product_id":67,"quantity":1}],"total_ex_taxes":669.79,"delivery_fees":3.72,"tax_rate":0.12,"taxes":80.82,"total":754.33,"status":"delivered","returned":false},{"id":428,"reference":"yeoz6m","date":"2015-08-26T07:49:15.015Z","customer_id":130,"basket":[{"product_id":59,"quantity":2},{"product_id":35,"quantity":3},{"product_id":92,"quantity":3},{"product_id":56,"quantity":3}],"total_ex_taxes":288.32,"delivery_fees":4.57,"tax_rate":0.2,"taxes":58.58,"total":351.47,"status":"delivered","returned":false},{"id":429,"reference":"hmzhfw","date":"2015-06-12T04:07:46.728Z","customer_id":845,"basket":[{"product_id":25,"quantity":3}],"total_ex_taxes":91.94999999999999,"delivery_fees":5.43,"tax_rate":0.2,"taxes":19.48,"total":116.86,"status":"delivered","returned":false},{"id":430,"reference":"bvhk8j","date":"2015-02-07T23:08:10.778Z","customer_id":540,"basket":[{"product_id":27,"quantity":1}],"total_ex_taxes":13.58,"delivery_fees":6.64,"tax_rate":0.2,"taxes":4.04,"total":24.26,"status":"delivered","returned":false},{"id":431,"reference":"rgfon4","date":"2016-02-22T00:52:00.715Z","customer_id":359,"basket":[{"product_id":12,"quantity":5}],"total_ex_taxes":262.8,"delivery_fees":7.61,"tax_rate":0.2,"taxes":54.08,"total":324.49,"status":"delivered","returned":false},{"id":432,"reference":"jw6539","date":"2015-04-12T10:15:05.801Z","customer_id":887,"basket":[{"product_id":75,"quantity":1},{"product_id":0,"quantity":2},{"product_id":40,"quantity":1},{"product_id":5,"quantity":2},{"product_id":60,"quantity":1},{"product_id":29,"quantity":1},{"product_id":8,"quantity":2},{"product_id":47,"quantity":2}],"total_ex_taxes":358.92999999999995,"delivery_fees":4.14,"tax_rate":0.17,"taxes":61.72,"total":424.79,"status":"delivered","returned":false},{"id":433,"reference":"5krems","date":"2015-12-06T04:55:49.686Z","customer_id":866,"basket":[{"product_id":19,"quantity":1},{"product_id":10,"quantity":2},{"product_id":91,"quantity":3},{"product_id":129,"quantity":1},{"product_id":55,"quantity":1},{"product_id":70,"quantity":4},{"product_id":54,"quantity":3}],"total_ex_taxes":805.03,"delivery_fees":3.77,"tax_rate":0.17,"taxes":137.5,"total":946.3,"status":"delivered","returned":false},{"id":434,"reference":"vqggo4","date":"2014-08-08T08:45:35.199Z","customer_id":735,"basket":[{"product_id":35,"quantity":1},{"product_id":112,"quantity":3},{"product_id":4,"quantity":5}],"total_ex_taxes":317.01,"delivery_fees":5.85,"tax_rate":0.12,"taxes":38.74,"total":361.6,"status":"delivered","returned":false},{"id":435,"reference":"v0rnm9","date":"2016-11-10T23:51:17.206Z","customer_id":237,"basket":[{"product_id":28,"quantity":4},{"product_id":117,"quantity":2}],"total_ex_taxes":106.88,"delivery_fees":7.85,"tax_rate":0.2,"taxes":22.95,"total":137.68,"status":"delivered","returned":true},{"id":436,"reference":"iwnhti","date":"2016-09-19T05:02:27.845Z","customer_id":253,"basket":[{"product_id":3,"quantity":1}],"total_ex_taxes":13.43,"delivery_fees":5.79,"tax_rate":0.17,"taxes":3.27,"total":22.49,"status":"cancelled","returned":false},{"id":437,"reference":"qei8aw","date":"2016-11-29T13:02:09.591Z","customer_id":31,"basket":[{"product_id":13,"quantity":3},{"product_id":34,"quantity":1}],"total_ex_taxes":219.82999999999998,"delivery_fees":3.44,"tax_rate":0.17,"taxes":37.96,"total":261.23,"status":"delivered","returned":false},{"id":438,"reference":"xlx93q","date":"2016-07-25T09:49:39.688Z","customer_id":289,"basket":[{"product_id":80,"quantity":2}],"total_ex_taxes":140.1,"delivery_fees":5.84,"tax_rate":0.2,"taxes":29.19,"total":175.13,"status":"delivered","returned":false},{"id":439,"reference":"r2hn7b","date":"2016-10-12T01:24:53.085Z","customer_id":511,"basket":[{"product_id":13,"quantity":4}],"total_ex_taxes":250.76,"delivery_fees":7.98,"tax_rate":0.12,"taxes":31.05,"total":289.79,"status":"cancelled","returned":false},{"id":440,"reference":"ai0o2o","date":"2015-06-25T17:08:57.464Z","customer_id":825,"basket":[{"product_id":5,"quantity":5}],"total_ex_taxes":196.14999999999998,"delivery_fees":6.65,"tax_rate":0.17,"taxes":34.48,"total":237.28,"status":"delivered","returned":false},{"id":441,"reference":"2yh5an","date":"2014-01-01T18:05:10.836Z","customer_id":729,"basket":[{"product_id":90,"quantity":1}],"total_ex_taxes":39.91,"delivery_fees":6.89,"tax_rate":0.17,"taxes":7.96,"total":54.76,"status":"delivered","returned":false},{"id":442,"reference":"b2jn7o","date":"2016-03-01T19:24:06.908Z","customer_id":823,"basket":[{"product_id":123,"quantity":3}],"total_ex_taxes":142.38,"delivery_fees":3.38,"tax_rate":0.17,"taxes":24.78,"total":170.54,"status":"delivered","returned":false},{"id":443,"reference":"kzrgb4","date":"2014-04-30T22:32:02.714Z","customer_id":391,"basket":[{"product_id":17,"quantity":1}],"total_ex_taxes":60.12,"delivery_fees":7.48,"tax_rate":0.17,"taxes":11.49,"total":79.09,"status":"delivered","returned":false},{"id":444,"reference":"q5p2nf","date":"2016-10-06T20:11:31.824Z","customer_id":651,"basket":[{"product_id":76,"quantity":1},{"product_id":43,"quantity":1}],"total_ex_taxes":49.8,"delivery_fees":6.94,"tax_rate":0.17,"taxes":9.65,"total":66.39,"status":"delivered","returned":false},{"id":445,"reference":"bjpwno","date":"2016-07-19T15:13:21.450Z","customer_id":95,"basket":[{"product_id":31,"quantity":3},{"product_id":4,"quantity":2},{"product_id":76,"quantity":1},{"product_id":6,"quantity":2},{"product_id":47,"quantity":5}],"total_ex_taxes":623.32,"delivery_fees":7.85,"tax_rate":0.17,"taxes":107.3,"total":738.47,"status":"delivered","returned":false},{"id":446,"reference":"b04ueh","date":"2016-08-19T00:03:13.741Z","customer_id":500,"basket":[{"product_id":94,"quantity":2},{"product_id":82,"quantity":1}],"total_ex_taxes":108.47,"delivery_fees":3.95,"tax_rate":0.12,"taxes":13.49,"total":125.91,"status":"delivered","returned":true},{"id":447,"reference":"sgdnq0","date":"2016-04-11T04:36:20.503Z","customer_id":718,"basket":[{"product_id":65,"quantity":2}],"total_ex_taxes":24.48,"delivery_fees":7.63,"tax_rate":0.2,"taxes":6.42,"total":38.53,"status":"delivered","returned":false},{"id":448,"reference":"sc0pz1","date":"2014-09-02T02:27:35.118Z","customer_id":797,"basket":[{"product_id":70,"quantity":2}],"total_ex_taxes":168.66,"delivery_fees":5.87,"tax_rate":0.2,"taxes":34.91,"total":209.44,"status":"delivered","returned":false},{"id":449,"reference":"oaxidy","date":"2016-12-23T23:41:29.629Z","customer_id":585,"basket":[{"product_id":24,"quantity":1},{"product_id":112,"quantity":1},{"product_id":70,"quantity":1},{"product_id":78,"quantity":3},{"product_id":11,"quantity":2},{"product_id":75,"quantity":2},{"product_id":60,"quantity":2},{"product_id":68,"quantity":1},{"product_id":46,"quantity":1}],"total_ex_taxes":506.21999999999997,"delivery_fees":4.32,"tax_rate":0.2,"taxes":102.11,"total":612.65,"status":"delivered","returned":false},{"id":450,"reference":"25lyen","date":"2016-03-31T18:18:41.451Z","customer_id":693,"basket":[{"product_id":42,"quantity":2},{"product_id":2,"quantity":3}],"total_ex_taxes":249.09,"delivery_fees":7.61,"tax_rate":0.2,"taxes":51.34,"total":308.04,"status":"delivered","returned":false},{"id":451,"reference":"498v9m","date":"2016-11-29T21:00:03.502Z","customer_id":85,"basket":[{"product_id":58,"quantity":5},{"product_id":30,"quantity":2}],"total_ex_taxes":391.97999999999996,"delivery_fees":5.24,"tax_rate":0.17,"taxes":67.53,"total":464.75,"status":"delivered","returned":false},{"id":452,"reference":"eonq45","date":"2016-12-13T13:26:25.524Z","customer_id":61,"basket":[{"product_id":118,"quantity":1},{"product_id":55,"quantity":5}],"total_ex_taxes":262.28,"delivery_fees":3.36,"tax_rate":0.12,"taxes":31.88,"total":297.52,"status":"ordered","returned":false},{"id":453,"reference":"64yqul","date":"2014-08-14T19:11:35.143Z","customer_id":37,"basket":[{"product_id":53,"quantity":2},{"product_id":19,"quantity":4},{"product_id":39,"quantity":1}],"total_ex_taxes":303.71999999999997,"delivery_fees":3.07,"tax_rate":0.2,"taxes":61.36,"total":368.15,"status":"delivered","returned":false},{"id":454,"reference":"7jo1tm","date":"2014-12-29T08:12:08.508Z","customer_id":550,"basket":[{"product_id":16,"quantity":2}],"total_ex_taxes":58.34,"delivery_fees":5.71,"tax_rate":0.17,"taxes":10.89,"total":74.94,"status":"cancelled","returned":false},{"id":455,"reference":"3lvu5m","date":"2016-11-02T17:45:16.472Z","customer_id":707,"basket":[{"product_id":53,"quantity":1}],"total_ex_taxes":41.17,"delivery_fees":6.67,"tax_rate":0.12,"taxes":5.74,"total":53.58,"status":"delivered","returned":false},{"id":456,"reference":"yiayhx","date":"2016-11-08T04:38:41.651Z","customer_id":533,"basket":[{"product_id":80,"quantity":2},{"product_id":26,"quantity":2}],"total_ex_taxes":206.42,"delivery_fees":5.58,"tax_rate":0.17,"taxes":36.04,"total":248.04,"status":"delivered","returned":false},{"id":457,"reference":"peixe7","date":"2016-06-02T09:33:36.595Z","customer_id":41,"basket":[{"product_id":128,"quantity":1}],"total_ex_taxes":78.63,"delivery_fees":7.07,"tax_rate":0.12,"taxes":10.28,"total":95.98,"status":"delivered","returned":false},{"id":458,"reference":"y14pm1","date":"2016-04-03T15:09:26.950Z","customer_id":390,"basket":[{"product_id":125,"quantity":1},{"product_id":2,"quantity":2},{"product_id":79,"quantity":4},{"product_id":101,"quantity":1},{"product_id":120,"quantity":1},{"product_id":69,"quantity":2},{"product_id":115,"quantity":2},{"product_id":23,"quantity":1},{"product_id":116,"quantity":3},{"product_id":12,"quantity":1}],"total_ex_taxes":614.79,"delivery_fees":3.38,"tax_rate":0.17,"taxes":105.09,"total":723.26,"status":"delivered","returned":false},{"id":459,"reference":"jm1t99","date":"2015-12-02T00:06:45.713Z","customer_id":550,"basket":[{"product_id":109,"quantity":3},{"product_id":87,"quantity":1},{"product_id":37,"quantity":1},{"product_id":21,"quantity":1}],"total_ex_taxes":247.43,"delivery_fees":5.26,"tax_rate":0.17,"taxes":42.96,"total":295.65,"status":"delivered","returned":false},{"id":460,"reference":"4hme2w","date":"2016-10-10T04:26:53.160Z","customer_id":90,"basket":[{"product_id":116,"quantity":2},{"product_id":36,"quantity":3},{"product_id":35,"quantity":2},{"product_id":45,"quantity":3},{"product_id":55,"quantity":1},{"product_id":8,"quantity":1},{"product_id":60,"quantity":1}],"total_ex_taxes":470.61000000000007,"delivery_fees":3.75,"tax_rate":0.2,"taxes":94.87,"total":569.23,"status":"delivered","returned":false},{"id":461,"reference":"h215nb","date":"2016-11-25T01:53:23.815Z","customer_id":277,"basket":[{"product_id":123,"quantity":2}],"total_ex_taxes":94.92,"delivery_fees":5.28,"tax_rate":0.17,"taxes":17.03,"total":117.23,"status":"delivered","returned":false},{"id":462,"reference":"alfk8s","date":"2016-05-16T20:02:52.180Z","customer_id":567,"basket":[{"product_id":1,"quantity":1}],"total_ex_taxes":56.23,"delivery_fees":5.63,"tax_rate":0.2,"taxes":12.37,"total":74.23,"status":"delivered","returned":false},{"id":463,"reference":"ds3crf","date":"2015-04-13T06:12:57.119Z","customer_id":529,"basket":[{"product_id":72,"quantity":2}],"total_ex_taxes":33.56,"delivery_fees":4.44,"tax_rate":0.17,"taxes":6.46,"total":44.46,"status":"delivered","returned":true},{"id":464,"reference":"ns03wm","date":"2016-02-23T17:27:15.163Z","customer_id":7,"basket":[{"product_id":61,"quantity":2},{"product_id":24,"quantity":2}],"total_ex_taxes":140.8,"delivery_fees":7.33,"tax_rate":0.17,"taxes":25.18,"total":173.31,"status":"cancelled","returned":false},{"id":465,"reference":"ynrusa","date":"2014-12-16T16:45:28.143Z","customer_id":317,"basket":[{"product_id":126,"quantity":2}],"total_ex_taxes":84.2,"delivery_fees":5.57,"tax_rate":0.2,"taxes":17.95,"total":107.72,"status":"delivered","returned":false},{"id":466,"reference":"4482ny","date":"2016-10-08T01:59:09.851Z","customer_id":792,"basket":[{"product_id":110,"quantity":1},{"product_id":122,"quantity":4},{"product_id":116,"quantity":5},{"product_id":93,"quantity":5}],"total_ex_taxes":1004.7399999999999,"delivery_fees":6.01,"tax_rate":0.12,"taxes":121.29,"total":1132.04,"status":"delivered","returned":false},{"id":467,"reference":"qohows","date":"2016-07-01T22:13:57.785Z","customer_id":390,"basket":[{"product_id":16,"quantity":1},{"product_id":112,"quantity":2}],"total_ex_taxes":99.89,"delivery_fees":3.72,"tax_rate":0.12,"taxes":12.43,"total":116.04,"status":"delivered","returned":false},{"id":468,"reference":"cguhy4","date":"2015-12-13T19:32:02.508Z","customer_id":693,"basket":[{"product_id":113,"quantity":1}],"total_ex_taxes":56.94,"delivery_fees":7.92,"tax_rate":0.12,"taxes":7.78,"total":72.64,"status":"delivered","returned":false},{"id":469,"reference":"xq8w55","date":"2016-09-12T17:33:46.035Z","customer_id":502,"basket":[{"product_id":114,"quantity":2}],"total_ex_taxes":53.52,"delivery_fees":6.26,"tax_rate":0.17,"taxes":10.16,"total":69.94,"status":"cancelled","returned":false},{"id":470,"reference":"91jusm","date":"2016-12-16T08:46:26.976Z","customer_id":359,"basket":[{"product_id":115,"quantity":1}],"total_ex_taxes":13.05,"delivery_fees":5.51,"tax_rate":0.17,"taxes":3.16,"total":21.72,"status":"ordered","returned":false},{"id":471,"reference":"zrwzwu","date":"2016-01-23T17:31:22.105Z","customer_id":326,"basket":[{"product_id":121,"quantity":2}],"total_ex_taxes":31.06,"delivery_fees":7.38,"tax_rate":0.12,"taxes":4.61,"total":43.05,"status":"cancelled","returned":false},{"id":472,"reference":"plqk89","date":"2016-08-06T15:51:47.538Z","customer_id":605,"basket":[{"product_id":29,"quantity":1}],"total_ex_taxes":34.83,"delivery_fees":7.28,"tax_rate":0.12,"taxes":5.05,"total":47.16,"status":"delivered","returned":false},{"id":473,"reference":"5g5z43","date":"2016-05-31T13:21:41.023Z","customer_id":315,"basket":[{"product_id":4,"quantity":1}],"total_ex_taxes":37.06,"delivery_fees":5.85,"tax_rate":0.2,"taxes":8.58,"total":51.49,"status":"delivered","returned":true},{"id":474,"reference":"0vaxar","date":"2016-10-09T02:53:15.487Z","customer_id":801,"basket":[{"product_id":0,"quantity":1}],"total_ex_taxes":28.65,"delivery_fees":5.15,"tax_rate":0.2,"taxes":6.76,"total":40.56,"status":"delivered","returned":false},{"id":475,"reference":"tl6oju","date":"2016-01-04T04:23:56.079Z","customer_id":185,"basket":[{"product_id":8,"quantity":1},{"product_id":92,"quantity":1}],"total_ex_taxes":53.41,"delivery_fees":3.32,"tax_rate":0.2,"taxes":11.35,"total":68.08,"status":"delivered","returned":true},{"id":476,"reference":"at3yj6","date":"2016-04-27T18:39:19.200Z","customer_id":97,"basket":[{"product_id":113,"quantity":1},{"product_id":55,"quantity":2}],"total_ex_taxes":150.88,"delivery_fees":6.79,"tax_rate":0.12,"taxes":18.92,"total":176.59,"status":"delivered","returned":false},{"id":477,"reference":"f5iipn","date":"2015-11-17T09:13:08.637Z","customer_id":50,"basket":[{"product_id":112,"quantity":2}],"total_ex_taxes":70.72,"delivery_fees":6.25,"tax_rate":0.2,"taxes":15.39,"total":92.36,"status":"delivered","returned":false},{"id":478,"reference":"g375l9","date":"2014-05-28T20:23:53.977Z","customer_id":114,"basket":[{"product_id":58,"quantity":1},{"product_id":51,"quantity":1},{"product_id":86,"quantity":2},{"product_id":39,"quantity":1},{"product_id":121,"quantity":3},{"product_id":33,"quantity":1}],"total_ex_taxes":310.93,"delivery_fees":5.15,"tax_rate":0.2,"taxes":63.22,"total":379.3,"status":"delivered","returned":false},{"id":479,"reference":"lc7axm","date":"2016-05-29T09:54:30.126Z","customer_id":121,"basket":[{"product_id":85,"quantity":2},{"product_id":26,"quantity":2},{"product_id":60,"quantity":5}],"total_ex_taxes":297.9,"delivery_fees":5.54,"tax_rate":0.12,"taxes":36.41,"total":339.85,"status":"cancelled","returned":false},{"id":480,"reference":"vg09ac","date":"2016-11-10T16:16:41.343Z","customer_id":421,"basket":[{"product_id":32,"quantity":1},{"product_id":43,"quantity":4}],"total_ex_taxes":90.32000000000001,"delivery_fees":4.22,"tax_rate":0.17,"taxes":16.07,"total":110.61,"status":"delivered","returned":false},{"id":481,"reference":"it34m1","date":"2016-12-11T23:17:27.098Z","customer_id":840,"basket":[{"product_id":46,"quantity":2}],"total_ex_taxes":130.42,"delivery_fees":4.33,"tax_rate":0.2,"taxes":26.95,"total":161.7,"status":"ordered","returned":false},{"id":482,"reference":"cayhun","date":"2016-10-22T14:40:51.512Z","customer_id":459,"basket":[{"product_id":30,"quantity":1},{"product_id":72,"quantity":3}],"total_ex_taxes":70.53,"delivery_fees":5.28,"tax_rate":0.2,"taxes":15.16,"total":90.97,"status":"cancelled","returned":false},{"id":483,"reference":"kggeq6","date":"2015-12-30T01:22:51.890Z","customer_id":126,"basket":[{"product_id":36,"quantity":2}],"total_ex_taxes":83.8,"delivery_fees":4.75,"tax_rate":0.17,"taxes":15.05,"total":103.6,"status":"delivered","returned":false},{"id":484,"reference":"rfkow5","date":"2016-12-08T20:53:56.431Z","customer_id":389,"basket":[{"product_id":103,"quantity":2},{"product_id":117,"quantity":3}],"total_ex_taxes":69.82,"delivery_fees":3.83,"tax_rate":0.2,"taxes":14.73,"total":88.38,"status":"ordered","returned":false},{"id":485,"reference":"v3hbjb","date":"2016-07-07T12:08:32.854Z","customer_id":566,"basket":[{"product_id":45,"quantity":2},{"product_id":118,"quantity":4},{"product_id":13,"quantity":2},{"product_id":53,"quantity":2},{"product_id":53,"quantity":3}],"total_ex_taxes":480.53,"delivery_fees":5.9,"tax_rate":0.12,"taxes":58.37,"total":544.8,"status":"delivered","returned":false},{"id":486,"reference":"we1rjf","date":"2016-07-27T05:28:22.491Z","customer_id":741,"basket":[{"product_id":124,"quantity":2},{"product_id":14,"quantity":1}],"total_ex_taxes":73.28,"delivery_fees":4.07,"tax_rate":0.2,"taxes":15.47,"total":92.82,"status":"delivered","returned":false},{"id":487,"reference":"g6z99c","date":"2016-11-19T07:29:16.115Z","customer_id":893,"basket":[{"product_id":121,"quantity":3}],"total_ex_taxes":46.589999999999996,"delivery_fees":5.24,"tax_rate":0.2,"taxes":10.37,"total":62.2,"status":"delivered","returned":false},{"id":488,"reference":"9vb46i","date":"2015-07-30T18:16:35.856Z","customer_id":364,"basket":[{"product_id":86,"quantity":1},{"product_id":38,"quantity":1},{"product_id":33,"quantity":1}],"total_ex_taxes":114.99,"delivery_fees":6.94,"tax_rate":0.12,"taxes":14.63,"total":136.56,"status":"delivered","returned":false},{"id":489,"reference":"wlqacu","date":"2016-12-08T07:00:08.622Z","customer_id":197,"basket":[{"product_id":10,"quantity":3},{"product_id":122,"quantity":2},{"product_id":105,"quantity":2},{"product_id":34,"quantity":4}],"total_ex_taxes":355.56,"delivery_fees":7.85,"tax_rate":0.2,"taxes":72.68,"total":436.09,"status":"ordered","returned":false},{"id":490,"reference":"s9an5t","date":"2014-03-12T14:38:24.831Z","customer_id":315,"basket":[{"product_id":104,"quantity":4},{"product_id":83,"quantity":3}],"total_ex_taxes":380.30999999999995,"delivery_fees":6.74,"tax_rate":0.12,"taxes":46.45,"total":433.5,"status":"delivered","returned":false},{"id":491,"reference":"bmq6ao","date":"2014-10-23T11:53:45.486Z","customer_id":462,"basket":[{"product_id":15,"quantity":3},{"product_id":65,"quantity":1},{"product_id":33,"quantity":1}],"total_ex_taxes":139.83,"delivery_fees":6.89,"tax_rate":0.17,"taxes":24.94,"total":171.66,"status":"cancelled","returned":false},{"id":492,"reference":"r7qf7s","date":"2016-06-18T00:40:04.332Z","customer_id":693,"basket":[{"product_id":58,"quantity":5}],"total_ex_taxes":351.59999999999997,"delivery_fees":3.98,"tax_rate":0.2,"taxes":71.12,"total":426.7,"status":"delivered","returned":false},{"id":493,"reference":"67rrkb","date":"2015-12-31T21:47:50.148Z","customer_id":140,"basket":[{"product_id":89,"quantity":2}],"total_ex_taxes":46.72,"delivery_fees":5.57,"tax_rate":0.12,"taxes":6.27,"total":58.56,"status":"delivered","returned":false},{"id":494,"reference":"6hyn75","date":"2015-04-12T10:11:12.852Z","customer_id":878,"basket":[{"product_id":125,"quantity":3}],"total_ex_taxes":52.019999999999996,"delivery_fees":6.96,"tax_rate":0.17,"taxes":10.03,"total":69.01,"status":"delivered","returned":false},{"id":495,"reference":"mrrjy2","date":"2016-01-06T05:42:53.199Z","customer_id":132,"basket":[{"product_id":118,"quantity":1}],"total_ex_taxes":27.43,"delivery_fees":7.53,"tax_rate":0.2,"taxes":6.99,"total":41.95,"status":"delivered","returned":false},{"id":496,"reference":"yabaoi","date":"2015-01-12T22:30:04.795Z","customer_id":315,"basket":[{"product_id":126,"quantity":1},{"product_id":81,"quantity":3}],"total_ex_taxes":190.48,"delivery_fees":4.59,"tax_rate":0.12,"taxes":23.41,"total":218.48,"status":"delivered","returned":true},{"id":497,"reference":"61p9s7","date":"2016-05-12T19:44:30.760Z","customer_id":491,"basket":[{"product_id":52,"quantity":1}],"total_ex_taxes":7.42,"delivery_fees":6.65,"tax_rate":0.12,"taxes":1.69,"total":15.76,"status":"delivered","returned":false},{"id":498,"reference":"9i3lee","date":"2016-12-31T21:32:58.956Z","customer_id":257,"basket":[{"product_id":120,"quantity":5}],"total_ex_taxes":103.55000000000001,"delivery_fees":5.34,"tax_rate":0.12,"taxes":13.07,"total":121.96,"status":"ordered","returned":false},{"id":499,"reference":"biypyy","date":"2016-05-07T11:36:25.901Z","customer_id":63,"basket":[{"product_id":69,"quantity":1}],"total_ex_taxes":12.81,"delivery_fees":3.49,"tax_rate":0.2,"taxes":3.26,"total":19.56,"status":"delivered","returned":false},{"id":500,"reference":"ya954n","date":"2016-12-09T15:05:45.131Z","customer_id":459,"basket":[{"product_id":12,"quantity":2},{"product_id":56,"quantity":1},{"product_id":5,"quantity":1}],"total_ex_taxes":166.76,"delivery_fees":5.95,"tax_rate":0.17,"taxes":29.36,"total":202.07,"status":"delivered","returned":true},{"id":501,"reference":"wzeady","date":"2016-10-14T14:56:38.444Z","customer_id":137,"basket":[{"product_id":76,"quantity":1}],"total_ex_taxes":33.66,"delivery_fees":6.36,"tax_rate":0.2,"taxes":8,"total":48.02,"status":"delivered","returned":false},{"id":502,"reference":"6p0urh","date":"2016-04-10T16:57:12.250Z","customer_id":689,"basket":[{"product_id":87,"quantity":1}],"total_ex_taxes":52.03,"delivery_fees":6.29,"tax_rate":0.2,"taxes":11.66,"total":69.98,"status":"delivered","returned":false},{"id":503,"reference":"9drna6","date":"2016-08-25T00:09:46.375Z","customer_id":90,"basket":[{"product_id":123,"quantity":1},{"product_id":70,"quantity":1},{"product_id":51,"quantity":2},{"product_id":84,"quantity":1},{"product_id":71,"quantity":3},{"product_id":121,"quantity":3},{"product_id":82,"quantity":1},{"product_id":73,"quantity":2},{"product_id":78,"quantity":1}],"total_ex_taxes":590.43,"delivery_fees":3.19,"tax_rate":0.12,"taxes":71.23,"total":664.85,"status":"delivered","returned":false},{"id":504,"reference":"0ot8jx","date":"2016-12-25T02:39:24.999Z","customer_id":350,"basket":[{"product_id":7,"quantity":1}],"total_ex_taxes":11.5,"delivery_fees":5.3,"tax_rate":0.2,"taxes":3.36,"total":20.16,"status":"ordered","returned":false},{"id":505,"reference":"ndqswc","date":"2015-03-14T09:40:38.199Z","customer_id":799,"basket":[{"product_id":122,"quantity":2}],"total_ex_taxes":119.16,"delivery_fees":3.38,"tax_rate":0.17,"taxes":20.83,"total":143.37,"status":"cancelled","returned":false},{"id":506,"reference":"pizlfb","date":"2016-05-17T01:06:31.953Z","customer_id":898,"basket":[{"product_id":56,"quantity":1},{"product_id":33,"quantity":1}],"total_ex_taxes":41.07,"delivery_fees":5.72,"tax_rate":0.2,"taxes":9.36,"total":56.15,"status":"delivered","returned":false},{"id":507,"reference":"fml0so","date":"2016-12-11T10:04:44.691Z","customer_id":360,"basket":[{"product_id":59,"quantity":3}],"total_ex_taxes":114.24,"delivery_fees":7.15,"tax_rate":0.17,"taxes":20.64,"total":142.03,"status":"delivered","returned":false},{"id":508,"reference":"2o26s3","date":"2015-07-07T20:57:49.869Z","customer_id":189,"basket":[{"product_id":69,"quantity":2},{"product_id":71,"quantity":1},{"product_id":75,"quantity":2},{"product_id":30,"quantity":3},{"product_id":99,"quantity":1},{"product_id":8,"quantity":2},{"product_id":60,"quantity":3}],"total_ex_taxes":316.75,"delivery_fees":4.37,"tax_rate":0.2,"taxes":64.22,"total":385.34,"status":"delivered","returned":false},{"id":509,"reference":"5bp8jj","date":"2016-12-07T00:47:54.007Z","customer_id":610,"basket":[{"product_id":120,"quantity":3},{"product_id":83,"quantity":1}],"total_ex_taxes":87.62,"delivery_fees":5.14,"tax_rate":0.17,"taxes":15.77,"total":108.53,"status":"ordered","returned":false},{"id":510,"reference":"14rheq","date":"2015-01-09T16:20:59.034Z","customer_id":658,"basket":[{"product_id":129,"quantity":3},{"product_id":42,"quantity":4}],"total_ex_taxes":222.35999999999999,"delivery_fees":5.03,"tax_rate":0.2,"taxes":45.48,"total":272.87,"status":"delivered","returned":false},{"id":511,"reference":"ybec2n","date":"2016-04-02T19:10:57.997Z","customer_id":265,"basket":[{"product_id":69,"quantity":2},{"product_id":89,"quantity":2},{"product_id":4,"quantity":1},{"product_id":78,"quantity":1},{"product_id":48,"quantity":1},{"product_id":123,"quantity":1}],"total_ex_taxes":271.58,"delivery_fees":6.86,"tax_rate":0.17,"taxes":47.33,"total":325.77,"status":"delivered","returned":false},{"id":512,"reference":"qc439w","date":"2017-01-01T02:43:00.547Z","customer_id":141,"basket":[{"product_id":29,"quantity":3}],"total_ex_taxes":104.49,"delivery_fees":4.67,"tax_rate":0.17,"taxes":18.56,"total":127.72,"status":"delivered","returned":false},{"id":513,"reference":"2tjw7e","date":"2015-11-16T10:49:22.884Z","customer_id":596,"basket":[{"product_id":93,"quantity":2},{"product_id":34,"quantity":2}],"total_ex_taxes":219.36,"delivery_fees":6.42,"tax_rate":0.2,"taxes":45.16,"total":270.94,"status":"delivered","returned":false},{"id":514,"reference":"1r6zb5","date":"2013-12-29T16:07:26.905Z","customer_id":391,"basket":[{"product_id":6,"quantity":1},{"product_id":15,"quantity":3}],"total_ex_taxes":168.17000000000002,"delivery_fees":6.34,"tax_rate":0.17,"taxes":29.67,"total":204.18,"status":"cancelled","returned":false},{"id":515,"reference":"s0q9q2","date":"2015-09-14T00:49:43.082Z","customer_id":799,"basket":[{"product_id":122,"quantity":1}],"total_ex_taxes":59.58,"delivery_fees":4.16,"tax_rate":0.17,"taxes":10.84,"total":74.58,"status":"delivered","returned":false},{"id":516,"reference":"q3e962","date":"2016-11-01T02:18:30.494Z","customer_id":533,"basket":[{"product_id":64,"quantity":1}],"total_ex_taxes":41.19,"delivery_fees":4.75,"tax_rate":0.12,"taxes":5.51,"total":51.45,"status":"delivered","returned":false},{"id":517,"reference":"yue6fq","date":"2016-06-02T11:22:04.934Z","customer_id":380,"basket":[{"product_id":86,"quantity":1}],"total_ex_taxes":44.54,"delivery_fees":7.77,"tax_rate":0.2,"taxes":10.46,"total":62.77,"status":"delivered","returned":false},{"id":518,"reference":"4yyeu0","date":"2016-06-28T20:38:23.692Z","customer_id":564,"basket":[{"product_id":112,"quantity":1},{"product_id":60,"quantity":4},{"product_id":12,"quantity":3},{"product_id":12,"quantity":1}],"total_ex_taxes":340.24,"delivery_fees":6.97,"tax_rate":0.17,"taxes":59.03,"total":406.24,"status":"delivered","returned":false},{"id":519,"reference":"s7pn5p","date":"2016-05-28T04:00:18.635Z","customer_id":878,"basket":[{"product_id":59,"quantity":1}],"total_ex_taxes":38.08,"delivery_fees":5.43,"tax_rate":0.2,"taxes":8.7,"total":52.21,"status":"delivered","returned":false},{"id":520,"reference":"kda38i","date":"2016-12-22T19:19:25.840Z","customer_id":485,"basket":[{"product_id":65,"quantity":1},{"product_id":81,"quantity":2},{"product_id":27,"quantity":3},{"product_id":76,"quantity":2},{"product_id":74,"quantity":1},{"product_id":123,"quantity":2},{"product_id":15,"quantity":4},{"product_id":85,"quantity":4},{"product_id":72,"quantity":1},{"product_id":124,"quantity":2}],"total_ex_taxes":780.9499999999999,"delivery_fees":5.77,"tax_rate":0.2,"taxes":157.34,"total":944.06,"status":"delivered","returned":false},{"id":521,"reference":"55lbo8","date":"2015-11-23T00:57:49.741Z","customer_id":229,"basket":[{"product_id":26,"quantity":1}],"total_ex_taxes":33.16,"delivery_fees":7.5,"tax_rate":0.2,"taxes":8.13,"total":48.79,"status":"delivered","returned":false},{"id":522,"reference":"thzmc2","date":"2015-10-14T18:55:31.454Z","customer_id":834,"basket":[{"product_id":125,"quantity":1},{"product_id":10,"quantity":1},{"product_id":57,"quantity":1},{"product_id":45,"quantity":2},{"product_id":50,"quantity":1},{"product_id":73,"quantity":4},{"product_id":6,"quantity":2},{"product_id":23,"quantity":4}],"total_ex_taxes":760.0500000000001,"delivery_fees":5.41,"tax_rate":0.12,"taxes":91.86,"total":857.32,"status":"delivered","returned":false},{"id":523,"reference":"14hhhy","date":"2016-05-18T04:38:13.918Z","customer_id":804,"basket":[{"product_id":4,"quantity":1}],"total_ex_taxes":37.06,"delivery_fees":6.86,"tax_rate":0.2,"taxes":8.78,"total":52.7,"status":"delivered","returned":false},{"id":524,"reference":"wzwnbu","date":"2015-11-18T04:31:23.878Z","customer_id":541,"basket":[{"product_id":77,"quantity":3}],"total_ex_taxes":52.29,"delivery_fees":6.78,"tax_rate":0.2,"taxes":11.81,"total":70.88,"status":"delivered","returned":false},{"id":525,"reference":"efgc6g","date":"2016-12-20T03:35:28.106Z","customer_id":541,"basket":[{"product_id":45,"quantity":3},{"product_id":51,"quantity":1},{"product_id":95,"quantity":1},{"product_id":11,"quantity":1}],"total_ex_taxes":147.22,"delivery_fees":5.42,"tax_rate":0.2,"taxes":30.53,"total":183.17,"status":"ordered","returned":false},{"id":526,"reference":"mf8ocm","date":"2016-10-11T05:05:24.133Z","customer_id":163,"basket":[{"product_id":69,"quantity":2}],"total_ex_taxes":25.62,"delivery_fees":4.22,"tax_rate":0.12,"taxes":3.58,"total":33.42,"status":"delivered","returned":false},{"id":527,"reference":"hjv5fh","date":"2015-06-01T14:24:55.747Z","customer_id":503,"basket":[{"product_id":92,"quantity":1},{"product_id":43,"quantity":4}],"total_ex_taxes":87.24000000000001,"delivery_fees":5.03,"tax_rate":0.12,"taxes":11.07,"total":103.34,"status":"delivered","returned":false},{"id":528,"reference":"z4oowv","date":"2016-01-16T14:16:14.139Z","customer_id":265,"basket":[{"product_id":8,"quantity":1},{"product_id":109,"quantity":1}],"total_ex_taxes":75.93,"delivery_fees":6.68,"tax_rate":0.17,"taxes":14.04,"total":96.65,"status":"delivered","returned":false},{"id":529,"reference":"7dkyy8","date":"2013-11-17T10:11:41.849Z","customer_id":884,"basket":[{"product_id":77,"quantity":4},{"product_id":18,"quantity":4},{"product_id":75,"quantity":2},{"product_id":14,"quantity":3},{"product_id":96,"quantity":1},{"product_id":129,"quantity":1},{"product_id":59,"quantity":1},{"product_id":57,"quantity":2},{"product_id":84,"quantity":1}],"total_ex_taxes":581.3,"delivery_fees":3.31,"tax_rate":0.12,"taxes":70.15,"total":654.76,"status":"delivered","returned":false},{"id":530,"reference":"cjljh6","date":"2015-07-15T16:23:25.848Z","customer_id":363,"basket":[{"product_id":98,"quantity":1},{"product_id":99,"quantity":1},{"product_id":21,"quantity":1},{"product_id":110,"quantity":2}],"total_ex_taxes":190.94,"delivery_fees":5.83,"tax_rate":0.17,"taxes":33.45,"total":230.22,"status":"delivered","returned":false},{"id":531,"reference":"gopa78","date":"2016-04-02T13:43:50.189Z","customer_id":434,"basket":[{"product_id":114,"quantity":1},{"product_id":85,"quantity":3}],"total_ex_taxes":196.68,"delivery_fees":4.72,"tax_rate":0.12,"taxes":24.17,"total":225.57,"status":"delivered","returned":false},{"id":532,"reference":"jaaa2j","date":"2016-05-01T23:59:35.291Z","customer_id":763,"basket":[{"product_id":100,"quantity":1}],"total_ex_taxes":46.83,"delivery_fees":6.78,"tax_rate":0.2,"taxes":10.72,"total":64.33,"status":"cancelled","returned":false},{"id":533,"reference":"5wg6qg","date":"2016-12-28T13:06:38.409Z","customer_id":840,"basket":[{"product_id":41,"quantity":2},{"product_id":60,"quantity":4}],"total_ex_taxes":178.51999999999998,"delivery_fees":4.82,"tax_rate":0.2,"taxes":36.67,"total":220.01,"status":"ordered","returned":false},{"id":534,"reference":"ome8ew","date":"2016-09-15T08:33:50.996Z","customer_id":90,"basket":[{"product_id":80,"quantity":2}],"total_ex_taxes":140.1,"delivery_fees":4.02,"tax_rate":0.2,"taxes":28.82,"total":172.94,"status":"delivered","returned":false},{"id":535,"reference":"i7oec9","date":"2016-10-11T02:46:25.517Z","customer_id":741,"basket":[{"product_id":5,"quantity":1},{"product_id":33,"quantity":5},{"product_id":105,"quantity":1},{"product_id":125,"quantity":1}],"total_ex_taxes":171.52,"delivery_fees":4.17,"tax_rate":0.12,"taxes":21.08,"total":196.77,"status":"delivered","returned":false},{"id":536,"reference":"eklfow","date":"2016-01-04T04:58:44.615Z","customer_id":566,"basket":[{"product_id":21,"quantity":3},{"product_id":109,"quantity":2}],"total_ex_taxes":239.59,"delivery_fees":7.8,"tax_rate":0.17,"taxes":42.06,"total":289.45,"status":"delivered","returned":true},{"id":537,"reference":"3rxgy8","date":"2016-09-03T15:23:16.893Z","customer_id":421,"basket":[{"product_id":124,"quantity":1}],"total_ex_taxes":21.33,"delivery_fees":5.48,"tax_rate":0.2,"taxes":5.36,"total":32.17,"status":"delivered","returned":false},{"id":538,"reference":"lkkvnf","date":"2016-10-16T05:08:50.510Z","customer_id":792,"basket":[{"product_id":112,"quantity":1},{"product_id":95,"quantity":3},{"product_id":70,"quantity":5},{"product_id":115,"quantity":4},{"product_id":48,"quantity":5},{"product_id":78,"quantity":2},{"product_id":37,"quantity":1}],"total_ex_taxes":1021.5400000000001,"delivery_fees":6.7,"tax_rate":0.17,"taxes":174.8,"total":1203.04,"status":"cancelled","returned":false},{"id":539,"reference":"ecqvpf","date":"2014-07-24T11:31:41.494Z","customer_id":59,"basket":[{"product_id":24,"quantity":4},{"product_id":52,"quantity":1},{"product_id":111,"quantity":1},{"product_id":77,"quantity":1},{"product_id":20,"quantity":2},{"product_id":36,"quantity":3},{"product_id":61,"quantity":2},{"product_id":47,"quantity":2},{"product_id":82,"quantity":3}],"total_ex_taxes":574.74,"delivery_fees":4.97,"tax_rate":0.17,"taxes":98.55,"total":678.26,"status":"delivered","returned":false},{"id":540,"reference":"yrlux6","date":"2016-02-03T05:11:43.778Z","customer_id":431,"basket":[{"product_id":115,"quantity":2}],"total_ex_taxes":26.1,"delivery_fees":7.34,"tax_rate":0.17,"taxes":5.68,"total":39.12,"status":"delivered","returned":false},{"id":541,"reference":"ekequl","date":"2016-04-05T06:32:04.232Z","customer_id":41,"basket":[{"product_id":10,"quantity":4}],"total_ex_taxes":88.08,"delivery_fees":6.9,"tax_rate":0.17,"taxes":16.15,"total":111.13,"status":"cancelled","returned":false},{"id":542,"reference":"rtnax9","date":"2015-03-23T04:50:10.065Z","customer_id":363,"basket":[{"product_id":65,"quantity":1},{"product_id":108,"quantity":1},{"product_id":83,"quantity":1}],"total_ex_taxes":69.77,"delivery_fees":4.29,"tax_rate":0.12,"taxes":8.89,"total":82.95,"status":"delivered","returned":false},{"id":543,"reference":"qcgy9k","date":"2014-10-17T10:16:01.618Z","customer_id":40,"basket":[{"product_id":74,"quantity":3},{"product_id":29,"quantity":4}],"total_ex_taxes":246.03,"delivery_fees":3.85,"tax_rate":0.12,"taxes":29.99,"total":279.87,"status":"cancelled","returned":false},{"id":544,"reference":"4z9azq","date":"2014-02-18T13:13:42.810Z","customer_id":86,"basket":[{"product_id":44,"quantity":1},{"product_id":62,"quantity":3},{"product_id":52,"quantity":2}],"total_ex_taxes":247.84,"delivery_fees":4.54,"tax_rate":0.2,"taxes":50.48,"total":302.86,"status":"cancelled","returned":false},{"id":545,"reference":"90e6b3","date":"2016-10-04T04:59:35.061Z","customer_id":718,"basket":[{"product_id":38,"quantity":1},{"product_id":38,"quantity":2}],"total_ex_taxes":155.37,"delivery_fees":5.39,"tax_rate":0.12,"taxes":19.29,"total":180.05,"status":"delivered","returned":false},{"id":546,"reference":"4zwzh4","date":"2014-12-31T22:28:34.877Z","customer_id":592,"basket":[{"product_id":86,"quantity":1},{"product_id":86,"quantity":1}],"total_ex_taxes":89.08,"delivery_fees":4.38,"tax_rate":0.12,"taxes":11.22,"total":104.68,"status":"delivered","returned":false},{"id":547,"reference":"3x33eq","date":"2014-10-12T23:19:23.205Z","customer_id":437,"basket":[{"product_id":77,"quantity":2},{"product_id":65,"quantity":2}],"total_ex_taxes":59.34,"delivery_fees":3.34,"tax_rate":0.2,"taxes":12.54,"total":75.22,"status":"delivered","returned":false},{"id":548,"reference":"y927v7","date":"2014-10-01T22:58:27.686Z","customer_id":514,"basket":[{"product_id":94,"quantity":3}],"total_ex_taxes":119.64000000000001,"delivery_fees":5.4,"tax_rate":0.12,"taxes":15,"total":140.04,"status":"delivered","returned":false},{"id":549,"reference":"oqf62i","date":"2015-12-07T15:13:57.367Z","customer_id":280,"basket":[{"product_id":34,"quantity":1},{"product_id":83,"quantity":3},{"product_id":112,"quantity":1},{"product_id":47,"quantity":2},{"product_id":128,"quantity":1},{"product_id":31,"quantity":1}],"total_ex_taxes":365.99,"delivery_fees":4.71,"tax_rate":0.17,"taxes":63.02,"total":433.72,"status":"delivered","returned":false},{"id":550,"reference":"jvfbxb","date":"2016-12-01T03:05:02.293Z","customer_id":744,"basket":[{"product_id":67,"quantity":4},{"product_id":78,"quantity":1},{"product_id":94,"quantity":4},{"product_id":98,"quantity":2}],"total_ex_taxes":263.19,"delivery_fees":4.21,"tax_rate":0.12,"taxes":32.09,"total":299.49,"status":"delivered","returned":false},{"id":551,"reference":"tz76ul","date":"2015-05-22T08:16:50.685Z","customer_id":624,"basket":[{"product_id":106,"quantity":1}],"total_ex_taxes":65.33,"delivery_fees":6.82,"tax_rate":0.17,"taxes":12.27,"total":84.42,"status":"delivered","returned":false},{"id":552,"reference":"jvy6ka","date":"2016-03-26T08:26:30.726Z","customer_id":284,"basket":[{"product_id":62,"quantity":2}],"total_ex_taxes":101.26,"delivery_fees":7.2,"tax_rate":0.12,"taxes":13.02,"total":121.48,"status":"delivered","returned":false},{"id":553,"reference":"msvj0e","date":"2016-07-15T01:13:23.802Z","customer_id":144,"basket":[{"product_id":113,"quantity":1}],"total_ex_taxes":56.94,"delivery_fees":5.38,"tax_rate":0.12,"taxes":7.48,"total":69.8,"status":"delivered","returned":false},{"id":554,"reference":"gqqts3","date":"2016-12-13T16:17:57.619Z","customer_id":236,"basket":[{"product_id":86,"quantity":1},{"product_id":70,"quantity":1}],"total_ex_taxes":128.87,"delivery_fees":5.64,"tax_rate":0.17,"taxes":22.87,"total":157.38,"status":"ordered","returned":false},{"id":555,"reference":"b8r30s","date":"2014-05-15T12:19:42.068Z","customer_id":514,"basket":[{"product_id":110,"quantity":5},{"product_id":23,"quantity":1}],"total_ex_taxes":274.78000000000003,"delivery_fees":3.66,"tax_rate":0.12,"taxes":33.41,"total":311.85,"status":"delivered","returned":false},{"id":556,"reference":"ahhfmf","date":"2015-10-12T09:12:24.888Z","customer_id":663,"basket":[{"product_id":66,"quantity":2},{"product_id":61,"quantity":2}],"total_ex_taxes":124.22,"delivery_fees":3.81,"tax_rate":0.2,"taxes":25.61,"total":153.64,"status":"delivered","returned":true},{"id":557,"reference":"v0eeiu","date":"2016-03-19T11:58:23.044Z","customer_id":289,"basket":[{"product_id":48,"quantity":1},{"product_id":32,"quantity":3},{"product_id":112,"quantity":1}],"total_ex_taxes":177.20999999999998,"delivery_fees":3.08,"tax_rate":0.17,"taxes":30.65,"total":210.94,"status":"delivered","returned":false},{"id":558,"reference":"2k39fh","date":"2016-07-27T07:37:57.815Z","customer_id":708,"basket":[{"product_id":86,"quantity":2},{"product_id":14,"quantity":1}],"total_ex_taxes":119.7,"delivery_fees":4.46,"tax_rate":0.12,"taxes":14.9,"total":139.06,"status":"delivered","returned":false},{"id":559,"reference":"1swabo","date":"2016-04-14T18:54:47.143Z","customer_id":599,"basket":[{"product_id":80,"quantity":1}],"total_ex_taxes":70.05,"delivery_fees":6.7,"tax_rate":0.12,"taxes":9.21,"total":85.96,"status":"delivered","returned":false},{"id":560,"reference":"9lnecs","date":"2016-06-24T19:33:35.444Z","customer_id":41,"basket":[{"product_id":83,"quantity":1}],"total_ex_taxes":25.49,"delivery_fees":7.54,"tax_rate":0.12,"taxes":3.96,"total":36.99,"status":"delivered","returned":false},{"id":561,"reference":"cmgzzx","date":"2015-07-07T17:44:45.450Z","customer_id":363,"basket":[{"product_id":127,"quantity":3}],"total_ex_taxes":72.6,"delivery_fees":5.15,"tax_rate":0.17,"taxes":13.22,"total":90.97,"status":"cancelled","returned":false},{"id":562,"reference":"y0p53e","date":"2015-09-09T10:26:03.809Z","customer_id":157,"basket":[{"product_id":125,"quantity":4},{"product_id":1,"quantity":3}],"total_ex_taxes":238.05,"delivery_fees":5.14,"tax_rate":0.12,"taxes":29.18,"total":272.37,"status":"delivered","returned":false},{"id":563,"reference":"z9ljgf","date":"2015-11-27T04:37:42.573Z","customer_id":503,"basket":[{"product_id":106,"quantity":5},{"product_id":41,"quantity":1},{"product_id":16,"quantity":1},{"product_id":47,"quantity":1},{"product_id":24,"quantity":3},{"product_id":69,"quantity":1},{"product_id":21,"quantity":2}],"total_ex_taxes":650.3,"delivery_fees":7.56,"tax_rate":0.12,"taxes":78.94,"total":736.8,"status":"delivered","returned":false},{"id":564,"reference":"kjdcv8","date":"2015-09-15T09:03:27.249Z","customer_id":401,"basket":[{"product_id":81,"quantity":1}],"total_ex_taxes":49.46,"delivery_fees":7.95,"tax_rate":0.2,"taxes":11.48,"total":68.89,"status":"delivered","returned":true},{"id":565,"reference":"patpae","date":"2015-01-18T20:49:48.748Z","customer_id":558,"basket":[{"product_id":28,"quantity":5}],"total_ex_taxes":101.85000000000001,"delivery_fees":7.35,"tax_rate":0.2,"taxes":21.84,"total":131.04,"status":"delivered","returned":false},{"id":566,"reference":"9kasdl","date":"2016-07-12T04:12:01.246Z","customer_id":97,"basket":[{"product_id":128,"quantity":2},{"product_id":0,"quantity":1},{"product_id":42,"quantity":4},{"product_id":108,"quantity":1},{"product_id":29,"quantity":1},{"product_id":51,"quantity":1},{"product_id":29,"quantity":1},{"product_id":121,"quantity":1},{"product_id":94,"quantity":2}],"total_ex_taxes":581.6,"delivery_fees":3.5,"tax_rate":0.12,"taxes":70.21,"total":655.31,"status":"delivered","returned":false},{"id":567,"reference":"ph7qie","date":"2016-11-29T11:21:54.705Z","customer_id":61,"basket":[{"product_id":49,"quantity":2}],"total_ex_taxes":26.16,"delivery_fees":8,"tax_rate":0.2,"taxes":6.83,"total":40.99,"status":"delivered","returned":false},{"id":568,"reference":"5fodpp","date":"2016-10-27T17:05:47.265Z","customer_id":564,"basket":[{"product_id":3,"quantity":4}],"total_ex_taxes":53.72,"delivery_fees":6.8,"tax_rate":0.12,"taxes":7.26,"total":67.78,"status":"delivered","returned":false},{"id":569,"reference":"zj5xec","date":"2015-04-19T06:43:19.770Z","customer_id":363,"basket":[{"product_id":38,"quantity":1}],"total_ex_taxes":51.79,"delivery_fees":7.86,"tax_rate":0.17,"taxes":10.14,"total":69.79,"status":"delivered","returned":false},{"id":570,"reference":"98shha","date":"2014-12-29T12:19:09.065Z","customer_id":45,"basket":[{"product_id":91,"quantity":5}],"total_ex_taxes":211.9,"delivery_fees":6.45,"tax_rate":0.12,"taxes":26.2,"total":244.55,"status":"delivered","returned":false},{"id":571,"reference":"ppz6g4","date":"2015-11-28T03:02:02.036Z","customer_id":816,"basket":[{"product_id":80,"quantity":3},{"product_id":77,"quantity":2}],"total_ex_taxes":245.01,"delivery_fees":4.29,"tax_rate":0.12,"taxes":29.92,"total":279.22,"status":"delivered","returned":false},{"id":572,"reference":"llmhf2","date":"2014-08-24T16:47:22.718Z","customer_id":108,"basket":[{"product_id":96,"quantity":1}],"total_ex_taxes":38.08,"delivery_fees":6.22,"tax_rate":0.2,"taxes":8.86,"total":53.16,"status":"delivered","returned":false},{"id":573,"reference":"y538qm","date":"2015-01-14T22:24:55.940Z","customer_id":797,"basket":[{"product_id":93,"quantity":1},{"product_id":45,"quantity":4},{"product_id":84,"quantity":1},{"product_id":49,"quantity":2},{"product_id":88,"quantity":3}],"total_ex_taxes":332.57,"delivery_fees":7.22,"tax_rate":0.12,"taxes":40.77,"total":380.56,"status":"delivered","returned":false},{"id":574,"reference":"a4yznf","date":"2016-04-24T14:16:41.888Z","customer_id":301,"basket":[{"product_id":119,"quantity":2},{"product_id":48,"quantity":4}],"total_ex_taxes":312.14,"delivery_fees":7.47,"tax_rate":0.2,"taxes":63.92,"total":383.53,"status":"delivered","returned":false},{"id":575,"reference":"8gywfv","date":"2015-09-01T05:20:33.938Z","customer_id":240,"basket":[{"product_id":74,"quantity":2}],"total_ex_taxes":71.14,"delivery_fees":3.98,"tax_rate":0.12,"taxes":9.01,"total":84.13,"status":"delivered","returned":false},{"id":576,"reference":"ka6pex","date":"2016-11-11T17:10:10.213Z","customer_id":61,"basket":[{"product_id":89,"quantity":1}],"total_ex_taxes":23.36,"delivery_fees":7.81,"tax_rate":0.17,"taxes":5.3,"total":36.47,"status":"delivered","returned":false},{"id":577,"reference":"28a8xd","date":"2015-08-29T10:01:32.743Z","customer_id":229,"basket":[{"product_id":17,"quantity":4},{"product_id":0,"quantity":1},{"product_id":96,"quantity":5},{"product_id":55,"quantity":3},{"product_id":80,"quantity":3},{"product_id":42,"quantity":2},{"product_id":69,"quantity":1},{"product_id":3,"quantity":1}],"total_ex_taxes":909.4899999999998,"delivery_fees":6.58,"tax_rate":0.2,"taxes":183.21,"total":1099.28,"status":"delivered","returned":false},{"id":578,"reference":"mu8jr4","date":"2016-11-09T02:27:26.388Z","customer_id":144,"basket":[{"product_id":125,"quantity":2},{"product_id":87,"quantity":4}],"total_ex_taxes":242.8,"delivery_fees":3.02,"tax_rate":0.12,"taxes":29.5,"total":275.32,"status":"delivered","returned":false},{"id":579,"reference":"p8op1u","date":"2016-03-23T14:03:13.621Z","customer_id":311,"basket":[{"product_id":81,"quantity":1},{"product_id":101,"quantity":2}],"total_ex_taxes":142.9,"delivery_fees":4.84,"tax_rate":0.2,"taxes":29.55,"total":177.29,"status":"delivered","returned":false},{"id":580,"reference":"99vcom","date":"2016-06-26T15:07:38.655Z","customer_id":244,"basket":[{"product_id":81,"quantity":1}],"total_ex_taxes":49.46,"delivery_fees":5.34,"tax_rate":0.2,"taxes":10.96,"total":65.76,"status":"delivered","returned":false},{"id":581,"reference":"wjj1v2","date":"2016-10-25T01:45:33.899Z","customer_id":801,"basket":[{"product_id":49,"quantity":1},{"product_id":26,"quantity":1}],"total_ex_taxes":46.239999999999995,"delivery_fees":7.2,"tax_rate":0.2,"taxes":10.69,"total":64.13,"status":"delivered","returned":false},{"id":582,"reference":"852bod","date":"2016-07-07T21:05:08.638Z","customer_id":496,"basket":[{"product_id":43,"quantity":1},{"product_id":118,"quantity":1}],"total_ex_taxes":43.57,"delivery_fees":3.03,"tax_rate":0.2,"taxes":9.32,"total":55.92,"status":"delivered","returned":false},{"id":583,"reference":"drxl5u","date":"2015-12-20T20:22:59.327Z","customer_id":853,"basket":[{"product_id":93,"quantity":1},{"product_id":115,"quantity":2}],"total_ex_taxes":104.02000000000001,"delivery_fees":7.07,"tax_rate":0.17,"taxes":18.89,"total":129.98,"status":"cancelled","returned":false},{"id":584,"reference":"lizbzi","date":"2016-06-07T11:13:15.846Z","customer_id":35,"basket":[{"product_id":13,"quantity":1}],"total_ex_taxes":62.69,"delivery_fees":6.45,"tax_rate":0.17,"taxes":11.75,"total":80.89,"status":"delivered","returned":false},{"id":585,"reference":"g3qhep","date":"2014-04-28T18:08:43.585Z","customer_id":315,"basket":[{"product_id":56,"quantity":4},{"product_id":118,"quantity":1}],"total_ex_taxes":117.07,"delivery_fees":7.08,"tax_rate":0.2,"taxes":24.83,"total":148.98,"status":"delivered","returned":true},{"id":586,"reference":"3hamzl","date":"2016-04-16T03:32:36.428Z","customer_id":693,"basket":[{"product_id":91,"quantity":2}],"total_ex_taxes":84.76,"delivery_fees":3.94,"tax_rate":0.12,"taxes":10.64,"total":99.34,"status":"delivered","returned":false},{"id":587,"reference":"er99wd","date":"2015-12-25T09:40:04.265Z","customer_id":540,"basket":[{"product_id":72,"quantity":1}],"total_ex_taxes":16.78,"delivery_fees":6.61,"tax_rate":0.12,"taxes":2.81,"total":26.2,"status":"delivered","returned":true},{"id":588,"reference":"tryfwk","date":"2016-12-28T23:38:06.472Z","customer_id":196,"basket":[{"product_id":25,"quantity":2},{"product_id":4,"quantity":1},{"product_id":50,"quantity":5},{"product_id":76,"quantity":1},{"product_id":115,"quantity":1},{"product_id":79,"quantity":1},{"product_id":7,"quantity":4}],"total_ex_taxes":452.01000000000005,"delivery_fees":4.82,"tax_rate":0.2,"taxes":91.37,"total":548.2,"status":"ordered","returned":false},{"id":589,"reference":"81k77b","date":"2015-08-23T04:23:41.380Z","customer_id":892,"basket":[{"product_id":57,"quantity":5}],"total_ex_taxes":147.55,"delivery_fees":7.01,"tax_rate":0.2,"taxes":30.91,"total":185.47,"status":"delivered","returned":false},{"id":590,"reference":"0d2tp9","date":"2016-04-26T04:50:59.628Z","customer_id":301,"basket":[{"product_id":73,"quantity":2},{"product_id":72,"quantity":1}],"total_ex_taxes":154.3,"delivery_fees":3.07,"tax_rate":0.17,"taxes":26.75,"total":184.12,"status":"delivered","returned":false},{"id":591,"reference":"u0emay","date":"2015-04-09T11:12:38.405Z","customer_id":363,"basket":[{"product_id":61,"quantity":1},{"product_id":105,"quantity":1}],"total_ex_taxes":56.71,"delivery_fees":4.49,"tax_rate":0.2,"taxes":12.24,"total":73.44,"status":"delivered","returned":false},{"id":592,"reference":"r2rc7e","date":"2014-07-23T04:08:58.679Z","customer_id":40,"basket":[{"product_id":14,"quantity":5}],"total_ex_taxes":153.1,"delivery_fees":4.6,"tax_rate":0.12,"taxes":18.92,"total":176.62,"status":"delivered","returned":false},{"id":593,"reference":"5e8ash","date":"2015-08-19T08:27:08.209Z","customer_id":51,"basket":[{"product_id":111,"quantity":1}],"total_ex_taxes":18.5,"delivery_fees":6.95,"tax_rate":0.2,"taxes":5.09,"total":30.54,"status":"delivered","returned":false},{"id":594,"reference":"fkmx93","date":"2016-07-24T20:58:42.114Z","customer_id":675,"basket":[{"product_id":57,"quantity":1}],"total_ex_taxes":29.51,"delivery_fees":3.98,"tax_rate":0.12,"taxes":4.02,"total":37.51,"status":"delivered","returned":false},{"id":595,"reference":"8cyb6n","date":"2015-09-15T02:08:11.091Z","customer_id":157,"basket":[{"product_id":56,"quantity":1}],"total_ex_taxes":22.41,"delivery_fees":3.19,"tax_rate":0.2,"taxes":5.12,"total":30.72,"status":"delivered","returned":false},{"id":596,"reference":"vh38kd","date":"2016-12-09T04:33:36.952Z","customer_id":144,"basket":[{"product_id":70,"quantity":5},{"product_id":48,"quantity":2}],"total_ex_taxes":550.79,"delivery_fees":5.27,"tax_rate":0.17,"taxes":94.53,"total":650.59,"status":"ordered","returned":false},{"id":597,"reference":"i9k6ox","date":"2016-07-27T02:32:59.991Z","customer_id":708,"basket":[{"product_id":110,"quantity":2}],"total_ex_taxes":89.04,"delivery_fees":7.61,"tax_rate":0.12,"taxes":11.6,"total":108.25,"status":"delivered","returned":false},{"id":598,"reference":"t45i39","date":"2016-10-29T03:22:42.127Z","customer_id":892,"basket":[{"product_id":85,"quantity":3},{"product_id":15,"quantity":4},{"product_id":0,"quantity":1}],"total_ex_taxes":343.81,"delivery_fees":5.27,"tax_rate":0.12,"taxes":41.89,"total":390.97,"status":"delivered","returned":false},{"id":599,"reference":"dihhg3","date":"2016-10-06T09:36:21.534Z","customer_id":487,"basket":[{"product_id":47,"quantity":2}],"total_ex_taxes":68.5,"delivery_fees":7.54,"tax_rate":0.12,"taxes":9.12,"total":85.16,"status":"delivered","returned":false}],"reviews":[{"id":0,"date":"2015-10-01T09:15:47.351Z","status":"accepted","command_id":3,"product_id":31,"customer_id":688,"rating":5,"comment":"Hahira folve raewogeh koge bojacwe gis ribsivek owifih obosiup pab mad lufwo funnerto orejuil zovejca. Dacof pu am tatguj difpi togna ru serzubir bapave nurezu ikusi ohekaep. Tizunu nukozes er wultumjeg caz mone wa jacpib jep hacnotehu levzofas hitozbeb. De gudi jol ihiro ow kogbakan gum zikupto afvit hunze ohurodi fo ijwule do ekaiz ca. Koaco zabig cotdon lugtog bipkup hof cohi poce utvamur genicnuc ziksi suh. Wak im hubup va wuhdoni mupmuwnar ledevec os tunihuun omo ede itu locmujdah."},{"id":1,"date":"2016-07-24T03:34:55.131Z","status":"rejected","command_id":5,"product_id":74,"customer_id":567,"rating":1,"comment":"Sublet ubguka tilbup wasi putuwbo mi ozo doebouk jip opiv la ohlejeg. Mubheghab gew picatcel beg hazlu dicpekvid ofcalow loha go pa oro ehasupu ewciseja. Ci ju sa lorsih zadu fer wimcu ipfuvdo jih torguz refna videhaf. Disnoebi bu afueho larowru sipzera vehe gerco ne ekdirap nuz liaka sozudud tecfeke piamuusu maeb mogave. Hicbib nihizohut ubi ero ra huedkuc wosew eke nimmaoha veez mepav juwasju he fotwecam ko umoce."},{"id":2,"date":"2016-12-24T09:19:53.331Z","status":"pending","command_id":7,"product_id":95,"customer_id":830,"rating":1,"comment":"Fulbo dueke va eca mompu amutamni rajnodhuc pibibi wo cihvef vo si piv saol ihu worlada cuf. Kup du hirzofu si uzoillof fi vic jalzi hebmubne bi ze wina mekwemsoc fifihwo. Nomhifa heseg wo bomo mem esacego gatzijap fotdonu uluvepi ji rodjeh buat paw bimbucgi nuuldon. Bo cicikewi wop ur ka loburme gogli bijlel li umupefde war ilade ifofa. Jezoheg cedum tutpurev se zefidsa mam manluzuz defe mave nilimi tog dobor ewe lemtif joub. Rij fuem kemeaju kielubop osebo rethagta vakeka bap tahdub zeddi ca zivipfak egaedugi cabogulu. Gi fo igi beceavo bueci hat jeiku ana sobho wedit kanpobi buvzej nawawo egoumu an zejgug akakodte badhedu."},{"id":3,"date":"2016-12-23T05:55:12.368Z","status":"accepted","command_id":7,"product_id":42,"customer_id":830,"rating":5,"comment":"Sovemuv pidajvu okavajval urahajvuf peke wevmu ciliga da anruk miz ukhom hahti piaw dofe un. Eguuvoepi cihovjog fuwpovab se zopuzuh okurac winamwe upidug joje nuk tabala rus arcuko veb pe ig. Ti suj reru sodufit bafonwop mufdi rekro bizvo cipuipo kosepar muzogto dedesad egwevfop cudeehi bufjumse kidnerogo ipcaar pa. Leca rif ciblodpev uh oce sefdaal na dos solikmo hu conepo zanuwkic ho oviwaz cacu fuhmiad fekajre. Tu igu jig cir emvetupo apocuwdu ra lakfa azatel hoc ivi bum lat ob. Pepre vi egu pe dilatoh jam uwot titam kil tezzo moh jemu."},{"id":4,"date":"2016-12-24T22:57:56.806Z","status":"accepted","command_id":9,"product_id":126,"customer_id":217,"rating":4,"comment":"Hopucjaz eb af radeche agcuz ebodim hewudowi vac lu dohevsoz cunu wohaik. Lugmos nuhoz fe esra jek evmulog jurga gevta kusi pazo vahhu ohiceraj pojahko pighiw nabfek. Pethij vuz he fum vu gi vi go wilob se ka kumijesiw oha. Zavgi dupib duvjom hu gu mepe nu saw zam zizizadov mit soekori dorca zimvemses."},{"id":5,"date":"2016-11-26T13:55:00.235Z","status":"accepted","command_id":11,"product_id":100,"customer_id":801,"rating":5,"comment":"Pouzo jical beh niz hevpa gorzum zefca nal gih udbichu wokehhi pipkuzi padtokip legeh rowmem ke. Wiztoij gatnuh ezebe docme pe seztam vek reca gon eg go vazih cegbo jij wipbasuvi se da nowuja. Pur selewda ciot zumlu newu ruzwojif bic ukrecvur lug nepivsup waipu azukikgug kocluzu pofni."},{"id":6,"date":"2016-11-21T09:24:49.626Z","status":"accepted","command_id":11,"product_id":101,"customer_id":801,"rating":3,"comment":"Lidoz doh tajlilnen rifumnoc pih zo lete dum ku pemo arhulfu kebuali sor genda. Jub an rabpebno rabhuv molcodum lop favratih va gaidufe romsokiti di roucu ajueza ab juhjowot iv fefi. Rebjoz nosu wemsu boiro fibofeane jofeme neoka jel osi nece luzlaopu lekje robugah uvjoez. Zohebmih rawvudze zobera ritepe tufadin va fu uswu bi fol zun kaka guvzoh."},{"id":7,"date":"2016-12-11T00:51:05.388Z","status":"accepted","command_id":12,"product_id":50,"customer_id":144,"rating":1,"comment":"Gu cefci cacabo wuuwutej niubu hawu hajo sase biamo ifuofsum ag kome nez. Lubuklu pisruf nenmi picte sidfura gobme avajoc up iplelhan omsow arufu pefowo luvitan zowajubu cafez wiargo ohzejdo. Vansu degsu zijpac pibetfec ficihi guges hobu misnuw hedopji de puvvun du tuggubul. Ubmic omoju dam cek ne vavaupa vohapa ki abeze foso mecwoc lo kizev puzu ehowab mabizeg sa nacaziko."},{"id":8,"date":"2016-11-13T17:10:14.238Z","status":"accepted","command_id":15,"product_id":101,"customer_id":90,"rating":5,"comment":"Fitdig nilvo nivanvih pi injumwog el cipuras zatejid tarso gacfo tesewan ba iv de zacudec zoaze sehormuc uko. Ce ijrup bowmavid kirli zuf jef him gunbacsaj ruzdosamo me tunu hit eg pu tejol numom. Im nid nel tiddum nacus ruugukog jajit raged im agi kog hejwovjiz veoku. Efpi larezo tes wurivon upba fi pobjajeg ubaki mujimuvoj ed uf wagoj aphuz nun culu. Notulku zo metuf bujifo emhizit dohsoozu je viifaguz mu nu tez pelu cib."},{"id":9,"date":"2016-09-11T03:27:26.935Z","status":"accepted","command_id":16,"product_id":62,"customer_id":157,"rating":2,"comment":"Masbuvoj toptuje nudow ji sokid gujudueh hag owudi kag be dica zunaccoh wejgi kifrophi nagge wujhi burgab imedi. Ugha mofivezi zekhe ugi ka hav oheese cop bowpoaki heficu hi witoh. Tevag koizedop uvosapi udwi name potzej binol oze ovre nirfewwi bakeju livohi. Ode lokiot nicog mullu duri jelguv lejrevoz iti do oboace id pi wez fi. Obmi ji juf ni cer rugu fuzoftif ir ratowuw acdurdu cepanwi pudi hot ja irukukkol. Cenhejoh hukibuc lefej arofo mob libuces ibaso lenjafup umu zi pijuohe zu bu. Amku belso digaep pek bejlu nikok kewmisfu kuh kebiw rivduzzu go fol gorluzmed zuron epu iwnajti."},{"id":10,"date":"2016-12-30T12:18:14.250Z","status":"pending","command_id":20,"product_id":75,"customer_id":830,"rating":1,"comment":"Oclit tonud gamseg tukomlut pucdeur wudsezo evedivlu miwudovo monfuwaj ka bek latiwe buh nearebo ogo jodi koh viv. Libupgu ki zasremrun nuzbu itiromvij en pecfa jil satpi edejufef dahtef wazi ar com sewi fuk jemeb hidba. Dujaeza foijodor om fal ilokabhig ozjuh hihekita cugak hoboc ro ze zijtid ese jutwuf viivufi apuiceca. Fe pifeg amrela gojusi fuslu nosdub eju lo oge ezgiara do otier ir pug fugduhiw ke zukzow tarha. Dil dab dedu muz rosuhow wupor wefwisu fuwovnu bol wu hi vonrezvu geasu hol."},{"id":11,"date":"2017-01-03T21:49:53.443Z","status":"pending","command_id":20,"product_id":38,"customer_id":830,"rating":4,"comment":"Dak hiwbeeji dac cahwoc suziprid ur lugeca wav luhbo fe tois vodasa. Vadpijkuz sot nitujan vislo tik ebo mi rezaw wuce tubogob wiulunul sa kufwofmu tif iceheffi awa saziv kacof. Ali badbim rifauwi kegago peetve vid vod veho ekpuv zid enjupife nagisumi badgew je. Ur anojibu ubselulo lawon togjecew zezof wucpiac sicnuzo bifsovoju mapro duzelif ac wootig vo ucvulik zule."},{"id":12,"date":"2016-06-13T15:45:18.419Z","status":"accepted","command_id":21,"product_id":61,"customer_id":108,"rating":2,"comment":"Bac fin gurocat en febuora ku viazepo jowlibsid kigtaz lejibto pevavuhe wudih jumzagim narnevaf. Tahavsi joput vejgo pekmu fojcaweci ule mehifgut zasjuav fuivam golu sif ca. Govnip pi jiz baan ugikka sul jib zarukijid kajon feume owpikoh ge. Fohlug mazbaike ven puwdata dutra ik winier uk didkuoh fihcokcu jeabefo diwiddi zilwo wallu vew guw osenal vubabone. Ro um co zel mop livimwik bec ewini gunam jefacauh gephehta sew efe ovakoz an mam. To nasiz ubsul fozuj oh hovvieda jimkiace rozke esnov ziv pib tef. Otjiv few lof ol kapgaso kokoug vum jeleh efkanbe su iwcukip heoku wur so pam hizozcap."},{"id":13,"date":"2015-09-11T03:16:52.952Z","status":"rejected","command_id":23,"product_id":40,"customer_id":317,"rating":3,"comment":"Mebitem podmewu bewuwok nimo tatut fufafi ba icpaked lab hizoco miavehan ki kun cavtuf. Buhalin tebbupajo pit pilo ufokoow nojeluz vejacgi lag cejnihula purvo ancek sumolu. Tijopu owo mahozis lodaube zakem botzef sudid fohek owalijic ijamu cih or oboav. Uwi ignal ku jumujof ecahuiku lilme ja fendik kizece sejra vodda nojzonih hiluge poc wacid asreba ne moez. Gel gotcon kazupavoc ivi linminvi idheika lavomu resbuj seiw tawilkil se adakadiz rekupda dupfi. Ugjo kevade omwod tiw babcuf ci jat ukuha woulga hip jos zaanu mi ki. Evuja kun ogaepo jaudi rinhi diwuz mel cojo na belde zet etuwapuw zutebho am vivo ozusoop mehoac."},{"id":14,"date":"2016-01-19T16:50:13.046Z","status":"rejected","command_id":28,"product_id":5,"customer_id":644,"rating":5,"comment":"Nawwip cim ka ad ejalef udral jofigiko ve cojfu zuira bon tokfewi di fe pup rufceh. Voh nizot gefvepnec jiihu ga beganop zurtu se sovtob odoti kozi jofcohum azpuvzuc. Pomhenbi ri courin fej luwe othen nuwpi zoj zilepwe he ileesi fewud asujeave vo bamo soono ifki. Gomeme jaju butub ve ene juer sucdilkik gozicfi hivmap bopepag adawulok ov goris mu hakus. Fohutci jo hipce suggebti veleh izaobe badikgut joc ibnahuse pusa jegiwgi gakeid feeromac pec. Ba lovkokpuf pojcowab rikoptof purmiv woubi ba alirogut tupoc refifbi vitor bosuf."},{"id":15,"date":"2016-12-24T16:11:26.676Z","status":"accepted","command_id":32,"product_id":47,"customer_id":651,"rating":5,"comment":"Fajvi gehoga sonez nihzesdeh horad de ce ekimop bu jij beboibo udtunwa efi. Re eh jud varpez mifha poclij zijifno goh hofnedoh fosbed awula zaivvo zuti utaric munufen usi edaem. Pug herheug gatfagcot ji kiwwultam wa ro nik re odamideh afuz divubah. Avoutouri ziifoba monivjak buhef onjo cumakgup dubaeb piuciro sob ujga tivtushel kuve zekpuppu gisu fifgos cajozu. Ufekok tunu fe ucihafo eb ludlujziw sorigem gu ihpe lejvujo lipju uzle wetatures hopije ocu cugga lilrogla. Hetjer netmal amerap zarbosu kojegto epumatzim vule em irafugo akuresa emisel mog osafu saic fozil ri zagvi. Touzuow sanko rodhefseb hiszar aho irfa fipsut azdoj deoje guv zi pian fiavole con gucvukmi bohomnol hehussuz fetzugu."},{"id":16,"date":"2016-07-20T10:15:56.529Z","status":"accepted","command_id":37,"product_id":96,"customer_id":185,"rating":2,"comment":"Eti voholad hi befwo boldav fe omu gekih jevilwib baketo fedav it zo. Zewjacop nualu miso elasinid sehu itinali gim maga mokafow ih osli litkizse hewgeh gikul gide. Reragbud edorohej vofo ote lohjuwuv eco dukep amri hili ta mactagene bamupmok lemcez zeog ra vusuticic. Gujtow lomov opa talfiltan ne ketikawot paupnaw nod si nibesip erval civogo mohatfo divahul. Suvhulgej buwme nuspab ukvevhug ripcuvid po wo fot kofublo ducoj cajesuv os elam lage."},{"id":17,"date":"2016-12-21T17:31:04.115Z","status":"pending","command_id":39,"product_id":36,"customer_id":90,"rating":5,"comment":"Ekuku pu larod wum du inep vikego nopog icwon tuushe sif co risuscaj elafes. Ce aksu jasle vicenuz pis wa usobus res wadfe hafonbuf duf re vu johjik iha. Niwivkar domcosig se wo ce mapoffaj duzcun rib cuvorbic ziffe abzifdas vaosuba nerusi deh zuzib inarko kip fo. Ecaute mirimam jurisug upo dedfawdit wel pakaj rofijilu biiceate na arlal ucojdo. Vaj mo oni bukeud ze kumni wakbewad vazigzo kuhada im vi ik vicwofuju. Canen rubbi civirag durmasa tudusehok ni babpo taiwzug gihfacan avi ajrij nadup fiki kiucora newik luab fap. Ecu weubib vic vata no van rovo hibhed zi zafo sudvus diccilup lezma jedo."},{"id":18,"date":"2016-06-03T11:24:55.218Z","status":"accepted","command_id":40,"product_id":52,"customer_id":541,"rating":1,"comment":"Ovuriv puzku bokmepu to epuulotu roumaad rub gus iglilo vawfewtu zih eg voej. Mup acusu cenni nez cap raseki bogwebu mo co jipocav ilsoku pa gafagkuv rokdi zejic azlaf suhipo dac. Tuez buzkaimo kavekoca ote mofcu zo na isekpek nurnew ati noggalike sawma mehikni. Joj iw ve lekbumrir ajfanuw tiva okooznil radad unzaf mivu bielu lespe niv usabe. Rohezelev mavemco agotag edme uf jebluma wumvon cazdop vowise tito vi aza odtolba bopehajo aglum. Vu heehogu gisimhi fokuk oh hokmuup ucagupip dapdel jus zawiuke rempu uvu ivuweszu muwunah sadi pacenbu va."},{"id":19,"date":"2016-07-20T21:48:37.045Z","status":"accepted","command_id":42,"product_id":124,"customer_id":335,"rating":5,"comment":"Pab jes gu or icieboze tofwe ta jibaew cuw idonarpis adeh su vop ha foc wojora ovu. Ni ponrottes di rom ej kocfudben nilocuf nauhusaf fowar zegnecje cam life baw cikfuhin foupiba. Rezsashoj tibrozki jabnapeja nitopva cobpa tijefew noitco pinoztiv imu titvu fijcefu tug wofip reoz. Gumuhu pot osi zah rikiasu par zanaic joztaski fo urohufsa nozudel nesfiz mo. Jiwfebat oru rit fuasuto roete kagakuj puzgad wi zunebile poztilkib et uwcoef kojgig puosunob ejmar aka wozug. Uvowe ducligib sebuvrek vuljes iguricipi wi ke we fodzucab gusutwas rismu osigap mijjes usavomud hefjara."},{"id":20,"date":"2016-12-27T05:45:31.267Z","status":"accepted","command_id":44,"product_id":13,"customer_id":784,"rating":5,"comment":"Zuk ofah tamfovavi duzhewov sefibeci tuutihu fabsu vak luzuvsef sitvuf de ov ruccu depin ka ininupbun purimev eco. Nocwi uri luw jurhalnob aruaduhiz mupso nu oh pimipuk hule hiwomla pizela ho suah otofuac vug vod ijebabaz. Guabhe huvud gafre to nilozlal nahu amnibo cineco pimnemuv vep ungo lihded rote heajelok cado. Ihuabbo neci av tuglacu fek korzij la mo lifado refukop dahihake mu bedaawa. Uce vactucad ecsonre pe vusselif foziguc bak sa elmab cel wa zirow. Raalido ewogegpe vut epi pe bikocbe konanib bagtiiwe rot iniwi eru ruz avlumme jowtewez goluj mapzujo."},{"id":21,"date":"2016-09-17T13:55:14.351Z","status":"accepted","command_id":45,"product_id":120,"customer_id":317,"rating":4,"comment":"Pobi emuf zajejdem mi aji mu nino opdop mem uvli eli notfah ceisi wepave jupra. Zevkapcez rocma tem zej pilubote diw dijac kesi comha eto zinubke nenmuen viz kifum padu os ewpu. Nahhoz kep nuarvad jiikejo pofowe vifecbij uggu enraf caipuuve caf zirilus lure bowaku janebgul vimzut juk ti."},{"id":22,"date":"2016-07-18T18:18:05.355Z","status":"accepted","command_id":45,"product_id":122,"customer_id":317,"rating":5,"comment":"Adunola guhi worubi wi we ja vomdav vewaj soc ve leb cupawig noec nen bavargad nobi wiunodo wowip. Zi bipo esutaim bomsaat kafo ce amu geik gek fuw umehef bu le zip fe wenacik ci ja. Sotum bop ve pajnas rihimmol wemot kuda pom jit vahiv lumfumewi pugulog hon otbol."},{"id":23,"date":"2016-01-19T07:57:20.105Z","status":"accepted","command_id":45,"product_id":49,"customer_id":317,"rating":3,"comment":"Egoobhe anuta sudo jikzuv vobib aknaddaw icomebek panodci den zebsussic giitofu kalu nujzivmok pac polsema obkud. Vedjis dom pa ci tejjo wofetu de detlewfa gobohekoc digfepwa ufrew da war ve zo ewo adafo tuerob. Enedepu wiubliz zi defne ba ju jaki upo cuknacsik delciup sucufapo fuhom lol zew nefedapu pulvid socaec hecaj. Tabak parzu amuemfih agi saf heoj jodlujren omehup kakdu kegig citfoc hugav poumovo ge. Minulba rubiw vij gik horeskop gulmon se orvuil wiccop fu fe zo mohjer."},{"id":24,"date":"2017-01-03T12:36:01.722Z","status":"pending","command_id":46,"product_id":51,"customer_id":651,"rating":1,"comment":"Tinikev gafufuh towocnuz te ganvevipa azu fufi soz now zuvikewa cele kez woefefe varog ron egeocice. Ru et fepom alpa pis te lal take akwo ro biil agesetdad pime. Hipada kebuwul puwzo no ivkivu mafi cowado kouse azaugdi naved vosam ohe."},{"id":25,"date":"2017-01-04T21:43:32.310Z","status":"pending","command_id":48,"product_id":118,"customer_id":554,"rating":1,"comment":"Mobo vioke icipul jolse to codduvsam rin tuvsa ade dabjiozi oputotow hubiciem nedhabe jabwa savsozezi. Koppuh zevno boj ruftapal hatsire soitese ut vepafe namkas ko ek opavahisa he haza zimugo. No ub udziso mekva nijcahe ave zuokolu iwu cujnike wa mirsun hewavegah avudsub zozu ew huafve."},{"id":26,"date":"2016-12-13T13:12:36.643Z","status":"pending","command_id":52,"product_id":42,"customer_id":784,"rating":3,"comment":"Jiduga amoami neg iweavve lo kewecpug vajib likifo gilga rozvev kepiscan kaozo wehlohet ezube. Ca fovcipsac dasar voad nisbiru jadagaw zajhoj sum novime cipocit ni wehuz tewrot ka. Boguf ogewih hon zicibug eheja epativofa ala buvilozo orfi hohu mu po ro sotzeb nekwa ujdej."},{"id":27,"date":"2016-11-18T01:36:21.507Z","status":"rejected","command_id":53,"product_id":70,"customer_id":762,"rating":3,"comment":"Etuer kuhti si pa nuj ehfebza zeb ot pugduw wab so tukguel so mep gepoj ikraat. Rawhuci koneim jiwe iplolse irafozmiz zovkipnok zahu su tabpiz zo jewwuw egu cumood gonfegar. Ve ro umtalgi bo tugpasum vajire jetalge pahegra uwdin beto pu cu zujaka zeli bafi ithagra bikbuc menir. Filuzza hacug lu nujjiem umcukweh viragi memig riod vas akesom ziefvo oki am zowfabja fib ifugugej. Velhogjen vi mowcepa soj measocet relaloc numanoba ri ti ah veccarut iwa awi di tu kir."},{"id":28,"date":"2016-09-27T15:36:01.322Z","status":"accepted","command_id":53,"product_id":50,"customer_id":762,"rating":3,"comment":"Kaso edibo ope weemki jaosus za cot lasi zencaec mefup rodgole pu. Balgevul pigake ti focobupo oruju ece dempof mutel vuwcas hiznawki pokgi raw cugpazuta. Manbi nevodip ju kow lazadup ne izdapi corave zecfasu toflejado fo mam gohovav cibkake vajon. Luci pod nut pa kegire vegine notew dupho nolevsa tututis zub nu cave evecep bemnob ivi vo. Nevihase men fapme su ar tal hehoc zumoc zihuco ozofave jottabveg asleh ipbipno zibekuhim akwut. Ce ta zufojcok bivi eti ob rowmer ujifjad dub hap cu jumipa ripen pagih do udo ir lakpevma."},{"id":29,"date":"2016-10-24T04:14:15.116Z","status":"accepted","command_id":53,"product_id":107,"customer_id":762,"rating":3,"comment":"Ce zefucro nomaw hod vuv sudcofi kikip wofep iri urisesis huje acniknu jedihi imudi jadgu ruzpusede asjut. Cus asohihuz li adkubfu zopajuk lor heribuv ral buc culud fopbesut ho. Ecgo uvpuwruh avuma om fe utamez ci icukuac pitak zakvavis he wome juper kev irodofud anaw. Sef iv uslum lijitvor bahem wifehu aditu macog bod ifi poma dace wat diwkor veboriizi rir."},{"id":30,"date":"2016-12-07T02:06:19.196Z","status":"pending","command_id":56,"product_id":95,"customer_id":801,"rating":1,"comment":"Har jon zazoc ibsol jaeji cim ruvozmu pa fuvi uviivaag ujopu cif ce lefpur efhomcas pemafep rive. Faifaulo fapidu as mopov eli zito la hog det kafedne mu fi vo romo du ihuzulciw movi. Ti akaahaf sum zakti dan koucelek ma jom fogcoapi voh ulola elo focoj use imama vu femwefil zoowejet. Witzabij bozda rova ehebro tuopu duzbirez co of pammiv navowe sevceme omo du. Nibodbi cu evbu hereg hirtug mupar gi oso ludamuhew fa urojepba aj lidzivtir egpig vakbuw."},{"id":31,"date":"2016-12-21T00:49:31.551Z","status":"pending","command_id":56,"product_id":89,"customer_id":801,"rating":3,"comment":"Forho arwicdiz koh cil hojgeefo fasnenwe zekib cufheg fipogo uji ricoz vol hu uw. Sum ebobub ipabu osoj cucarak divhop fegoida ti cecbe vugsoev ocpabo dijzo sawnozno ujefobdu suwcesu. Ebluckup lu ni ceapkiz jez ile lod tu denavav ugvat it hocuze roju fodmav biva lekare. Kodajsub dulpa fujiz aroide sacogi ocipav pi turazud ge gemhuze rarla tojace. Wamudfu utez ocuribse bop esjoajo ejo atupoptim cih rutke durdobo dihupud halpa dousi meve me uveum ro tek."},{"id":32,"date":"2016-12-13T01:03:39.527Z","status":"pending","command_id":56,"product_id":16,"customer_id":801,"rating":3,"comment":"Lo ahwo dut numtapok gupola sopi duc salpopar wavgeko uhihkir modo fo ranef lu rin dolalmoh as zuwa. Cugta no zuhfo ombi ibpanaw haru hira joaha orhipra lat emi zunfa guwi riz kufoup sufovib biuwvac. Ofoz cinugvi ti zah jodopus puab nejfal ulu igcol appiw opoel mir momzil uti vimeba gis. Ese iralarek nofe hodeg civugihaj voltevsi ceg buwna cih hu kus pejlogfe. Fombuh hahipur hopvogroj huj gahu se emu ga niz motmej islamev uginupfe safajozoh ega poef alke. Sajucof cijgida adoeba zerfug eccofef nev fek fec tol lifuelu lorar eb. Juligej gavzaus enazacor giwaf hucozse kugetjog ozne kucoha najitze soc du ti eteral ege se zozzic kisfi ostacup."},{"id":33,"date":"2016-12-14T05:42:29.210Z","status":"pending","command_id":57,"product_id":129,"customer_id":576,"rating":1,"comment":"Feb cumobop ma fes waroh kidav livet lapzu ritel ko piseveg piribef. Ini avuvifib ceroja hewu ta hiv jibelwat sugaoh esri nacufo ha ato pijlivgig wud asedevcas alusi nu. Wun vasinwa iremoker soze goltatus wesemi buslaib dinecwat natugop gub numgoti vur. Rahihjuw puhbe cuso uzacit vuvobibov puz wawate kadonu gezanik nannut wizokezo cujlo. Tekjeeza ile aguw ku ho adiane nik samupzol pave of babgu ji pidded avazir. Vupwam cupu fa wagugvi jafro hurhiv erecif kujhi weczimiw kehkoca wooce kemwi galfob wejti bosrod gak siid woji."},{"id":34,"date":"2016-10-01T09:15:45.683Z","status":"accepted","command_id":57,"product_id":84,"customer_id":576,"rating":2,"comment":"Su mavaij rap idkoz teezu ivaderil gugiic jizapauza manonvi nuhnok zuku wiw uhojumos odtekcac vise kas pe jukial. Ro updewas gieze josommo he citka foctut vapiase nule vur gukpob gu jilowvor saku ganegnof. Kolja ha pu sogukdas sotme besovot vozooc noljofof jubsa azobepa dazfej lapolu wupuwuk degi fil nuhiblo."},{"id":35,"date":"2017-01-01T22:11:18.470Z","status":"rejected","command_id":58,"product_id":64,"customer_id":85,"rating":2,"comment":"Ehubdo dodir rez osoco cupebige jehli nezoma wapap wowef jimceg gi han. Zib ovoloktep abeam tag ufuzli tatizpum gagiwa wevzib vamev ragiweva tajoga siitibu. Vo ej ke do ofbegji zari kifehwek feigodok wusubamec ho feji rutazog suda rup. Masenev cacunuisi kek afede bidwe gu li pam rawom po touw buj bokpoz evvedfor zuruba jotof."},{"id":36,"date":"2016-12-28T22:17:23.799Z","status":"pending","command_id":60,"product_id":16,"customer_id":774,"rating":5,"comment":"Okopuzop osbic ri biba aplivog re pu bi hebi go emo kih okorew zoij ceodu. Gip vilnental awiadfa vap nogobnu sebika ivohac vazuski jo vukidupu ozomiv kiku udoez wiroz mo anfidde. Bahmicul we nawtegbu iwak mi bilicze awalarih ma ovgaoso voluk mimavud wi. Lulkolha wu rapifuvo bemhotdi jinumtu zeceneh veb anlesut koznu honsuzo doj agpajuz jovgu wu soutefi. Jo lucis rizzewki mama ju rub fokgeezu ru woz rakahe fojgud hizba mucom po nol zapgip wovtajone."},{"id":37,"date":"2016-12-13T15:07:30.955Z","status":"accepted","command_id":67,"product_id":36,"customer_id":217,"rating":5,"comment":"Fegowum wa di bamne gi mu wenfepak ga owoibid jo alciwzur loddew zico. Huoho siuho legele zohzuhi ra tuf lafa be zihnam mutosi ip hipodful ruokadu ahnam le kul igrekdi mo. Tunhowo zighuf fuzeri po ihe isaef wo nuphep age nuh ki mofeslov cak tujegri on. Ar jafucu liep hezunak viwmas evogerdub motpen bot pu ra cobcipi jaklor ruwzudjik maci. Dihoje vav jebbipge ub ol geeribu jekmo izliub parrut limohizep gagudmu igepez on je ubiruha maz opatec enuowlot. Cictad meowubot jubbod ewlasumo wa mofdes gukgodme lo guf ta nudihu dinowgip utanosmo aw gijzol. Bo his movmim vemi kusik koptanag cos vizob zusmub rufen kahfevned elojak mubes muwaoze."},{"id":38,"date":"2016-05-21T06:23:09.415Z","status":"rejected","command_id":68,"product_id":129,"customer_id":280,"rating":4,"comment":"Narewni we kepofo mogizfuv tivmopda calomem movjigure akoera tijfuruc ekakapaca tob kapzo. Gapam namuni jas di robcisu rubocbu vap ug epdil kuhhiujo elakel bin zo maggu mokmo. Tugpuruf sogip cow wakomubew kiowe nugilid jupobu ig ajulidez laodohij fe tececades uzkam gepomi ekawus vomad. Pulurom imegeiv lezdodi lu mo bosne igi pabem rirje el tuwgel ul jet ildijcu."},{"id":39,"date":"2016-03-04T19:26:42.047Z","status":"accepted","command_id":68,"product_id":36,"customer_id":280,"rating":2,"comment":"Juecda luru muadsuv furwo edeuli dek du gebitu zur vabheute gov ga heg zad ubijur. Za mo fosabiv nosma otu awatakak ata mube uwufatu mahiruto vic hurogfon rujowve tingo ko. Zidzucnog fetah wuwwis hilecfus oc mi wiefa cec apim waw naiduki ibdunu potkecna ari vi wa kiasji."},{"id":40,"date":"2016-12-30T20:11:00.713Z","status":"accepted","command_id":75,"product_id":89,"customer_id":428,"rating":4,"comment":"Rukwodo bar beofiga ho jo paguchi gis goh sahzi oce fubap cepo. Lidec niheb ruckus pah sohliv ha puak kejfu gi fipemraw sa gismih. Wa cif pejik vaebupa soat mafa hasmem ojsa suzsi bihzebo necadeh wowah urulif ojenbi ijbu kezzud wamonubob."},{"id":41,"date":"2017-01-01T01:50:05.631Z","status":"accepted","command_id":75,"product_id":2,"customer_id":428,"rating":3,"comment":"Opu upigo so se ducmugno cirat giemohoc megarowe iz lus wez vehlo sa kiano. Pukoc zisojmet hotfoave birunor hel pezviow hiusulor ewmab sogefe ulaicgi omdal se catief lib hamul foj mogeiw. Jebi mog pumu juduute un muh obi gu tow wi corewot peknew hinlefga zusgaoro riahu ilejipzi gicivu. Viam cubano wipirve ejoaze vapfic ucotira mek tegta jobap do zapustid usiku tuamo sakkale. Rus fazetpat ok dawi lo fizefas dave kuodet batubu romib to joogofem imu pidik eri. Owoej gozvokta reagaseh gigifu amew kob utba gecsurlar toj re waciju ene paewamip."},{"id":42,"date":"2016-09-06T21:18:27.991Z","status":"accepted","command_id":76,"product_id":74,"customer_id":381,"rating":2,"comment":"Tubga ra uv hino picebino li cun cidve jubvuwpob veveg metehbud ip si sirinet. Doj duhke hilbadap ke pudutba cocitaat se wi ednadi riwawu tifna ma hos wud anu. Jegkondur ven gahnuga kizifzud ate tap bu ogjodcoc winufket ohjiwsuc li agamnok rowtus didu. Hoz nepwi somgaf obo taf az bekowhi oztu johirivin bi dap cek jub. Eveh zuolova ine man pazode kavip haave ha ikidase weli vud zu othiv rawsof. Udowajow cesik awnilvef uk po wow hokkidoli ribbez jondaohe diketa fuzike sofev tajarida. Sojzo ko kapa ipa obogoir emu etomahbi lokufub ju ujewi zu ako deturan ololem wirugu vudze je."},{"id":43,"date":"2016-06-14T16:19:18.933Z","status":"rejected","command_id":77,"product_id":20,"customer_id":394,"rating":1,"comment":"Pifocine hipimi sumonasa eknihdi ripu batolu wigi amaf hisizah cijtezsab tegve zo ipi. Ceipwak ru jaguel fe fatok afediwih veg dasidhib bup evuwojec pijgogir pocogmaw lewe ni havica fosifko. Baj ireojoucu kaewe tu siso vep tu ah pah aloduflof nuuvege esi. Wi ne liofo okzoap kamomat vahed bu bilachaz hocarez jijvoge fow febnoj uvadipdu. Az zo hakkisto no seiz ki erlicuf cawzi vuvwil nerjob ej ti azubomfe gefwefrec oba cenek ni. Ceda uriim opisa caklifpi em ranupva rohgi nu ekaozde re vanu uvi vu hom mib wufhipti das."},{"id":44,"date":"2016-10-23T14:22:45.249Z","status":"accepted","command_id":78,"product_id":39,"customer_id":718,"rating":2,"comment":"Dietunol kulok icfohef fo mokoar jacvaub wizabcok witu osita gaj ulijla jifi bawek jokarpa. Uvevi budcaah da na ca evuuwiku de mib mi uma kasdet gewzosuv. Heruwlu kace heuvodi ogoimu veslituzu nanvoddek fire wuw upju te mawe wicabda eszobge em bec teej roz afe. Geducoofo ef irbuda bapewvev huzef emuziak aw buoku sunu zetpeh biego sotjat ivofaavi. Immeze ihlochi guc walerkem rilahear jidbowew leguan zafol hot ha hudga bir. Jecev kioto ik novo locharsu oloru wij joahuher ne sanuvzig ecefaki hoolo."},{"id":45,"date":"2016-10-08T12:11:58.355Z","status":"accepted","command_id":78,"product_id":99,"customer_id":718,"rating":3,"comment":"Otonejo puzenu fa vib ahti futkit copa vahusa nugpiv umovocjo rodilog pal ze usa kojufke fo pe vibto. Zaezo gad kooc ka ijtitom re sofoflew hoznunu ho esabu rowadnih ifikeihi alkile junzokar rew of. Dikiz ahe mapahovi efawe pokum jotima fo fabate gaaga usidibec rojkala ratmi wacecej gosihuh fun utuakle nohki opo. Pahkoc irjof jonful eb jolnic fej sir je iwiiksa sevorumad ga nozasa vihiki rehan acuroito luztu. Wawa afoegdas rogwab bozez og aci iku gakug ceg lozib zojivfi dachakaza icratcer."},{"id":46,"date":"2016-10-06T00:42:53.237Z","status":"rejected","command_id":85,"product_id":83,"customer_id":538,"rating":5,"comment":"Vokpuw hif up sib zupena ziil lerwod pu lifliwba pat atvawi pesawa tojsuil mugjungep. Jo cioggo dekelkon zahfu si ubalov ehducfid cegezi onazim fan inajati jafpiru looju dupramvac. Jo sewa emweli pet ranzaklu owapov pop puwvoba vedhi bowbeper lire ku sunud umvup du."},{"id":47,"date":"2016-10-22T19:10:39.442Z","status":"accepted","command_id":86,"product_id":12,"customer_id":481,"rating":5,"comment":"Dizi owbi sogfa gaenu li mi homisun lutekmo guroazi moduhaj loraz nukagbit. Recil jiwol wes nicpas ucipil rucawab ka kippiuf boba pu bilobi uc cacujo ga haguwwic. Vog kin rini wenoki cutpuh ofa odunuf aha levmi seew mi norgegfej teowuho. Kaw dujez piibduf ogoconej egdu gioj kiw wewi uc gov zitape fo berbutih vegeov giwepe jetromok nawigu. Jicwidic uwbupi mebuluvu zuz wewo rofjinon upezida zew gugcu adiziw tecozohi tipaje pofubvo oven."},{"id":48,"date":"2016-12-30T05:24:32.111Z","status":"pending","command_id":86,"product_id":90,"customer_id":481,"rating":5,"comment":"Zelmor zot vu mitiz cokaples fih sago ar wivilogud buran rehgokvih beon. Sel ed otu vas loupinom bawpivdit alubag noadebe ikuso jor li iw batekzu am feuzu nisoik towven. Ge tuucaem du vepijfi wi ledmurgel pa sakud anof vouj di fuwkiaf lurjosker nudniav. Iv jaj dim cavi cukes zegujvo duse ale diso cimpolzu zuf dup sidreg. Teh migwoseki pewjuv nokafu wino feeb febefu wuize cunu no peasoof safej ces rercitlot cefti. Ha ma wupiw no po cabhedul panohmid zokkaman vivbor ihremfov mup pofichi."},{"id":49,"date":"2016-10-23T11:12:47.082Z","status":"accepted","command_id":86,"product_id":24,"customer_id":481,"rating":4,"comment":"Jeplima kaveto ohco gecip tevnere ah buploru itaz vog igizija dic lubpifma wuf nitujroc ec zimudpu. Romireh jairbu jeliceoke alauc ub tec dalhuj elitu bemdel elmiwe winmup teghe wi cuv. Ob uvhican pamvavi naj mo ibeas secvaum imzez itdig maguoj keki mapuh vokecze. Uw simpadez som kej ufi iwsu pe liflij arazugza kul haswa ope virfig rik. Ujinoako cij tizmebkip ic nirioho lahatec zuli nupal giuc zuzsol rir lutimu du ririrhug. Facfawpa pokel od repci caplumad meefi joka omivudgo tiogo dozaftog iluca us eri cosabzi be rosono ca kotefu. Ovijarum jenlew voiwi nacdelbig sislip fut eli haucta hubtobvub papnow kewhef gebhuh hewralu kovwom tizzev."},{"id":50,"date":"2017-01-03T02:24:49.113Z","status":"pending","command_id":94,"product_id":54,"customer_id":533,"rating":2,"comment":"Vifbahgic kakjab zeg rat pesishop sigiduk munob poh bucur inuwe arulic fe lef nijtur vohu. Efe posifmok heew zahi lurrok huzpihbi made pa wuhi besiz juglamnod moku ne ovu tiukdo kisugu orkasse. Waw vicvur mek asebunuw feab juap bezitu ruwalre baggec dodabi zopisujok ubsoler nogvosef wovtu."},{"id":51,"date":"2016-11-05T21:55:23.691Z","status":"accepted","command_id":95,"product_id":97,"customer_id":152,"rating":3,"comment":"Sihuphep zira cev ejnivjec itugofok ceb zeh ranoh todjiiz ecoecki humo robpimew. Ti uvi vu ute da etobijmon bu ubuaja ubwure ciricifiw emijaoze juc ipima. Nonwor bevdirza aporis nummoh aw ula zarmedo uhuwacpu puahe igufufi urafucut ivun fot. Bapa dirilre vigaaro os apumugok ob gewa ogpi mik wukacec apgu imfe lufa ri gathu. De woit rabbilcu turivwig liokewe lowa fu fojgowuj kefipe ahsos goj rof ipo nokgucgun vahewoemo ehsa."},{"id":52,"date":"2016-12-21T15:29:56.380Z","status":"pending","command_id":96,"product_id":43,"customer_id":351,"rating":4,"comment":"Wugalo ejju nenebu nepnaobu kad sebun imo jo eh ugu aknulul kilafgo. Pum egirizun zu zo ukita icawejca odu ic cusebe fodug pekuvwu noculga no tunir. Testuh ec emjof upeta odo ekoujire luswuw jembanug tulu aze ruhbi vit luuf acijub. Arajavav semdasin cafapbot dip gapor haufiga fericbi tu ma ras jazfewu he zo. Zac hofsa ov jihamimu nanop wasi nitto gearu bupeno ipekelik adudi zefhok wutbosa awpetgo. Avino has so nicfib gikig ve hi afo tunwav dimuh ukulen acawi fasivuwil rattak tomowi oca mezvim nuz. Za cedjevo inali letawevot suthes luvodiuf wiri odowa futkicko cefesautu ipouku ne."},{"id":53,"date":"2016-08-03T06:59:58.829Z","status":"accepted","command_id":99,"product_id":70,"customer_id":114,"rating":5,"comment":"Sum ro pemsebrim nine okged jed niakiwoc vosal va jabom dar his ijibo. Osefegav dappisic nez wevju otkojig ce buer abonum la mih bootzi koji hutwamuf munruh ovrob afa hob. Ufuil ro uptis fekin custur edan vebut teun wummerwa uji onicijdim zodma. Usaksu oci fuwino sih jitesu tilace dug epik pidhap bachogcic vadet adse sopa danofrab."},{"id":54,"date":"2015-03-15T10:12:20.840Z","status":"accepted","command_id":99,"product_id":41,"customer_id":114,"rating":1,"comment":"Va ot nadohvi ulmig ehakir bagaefo pe ha kevoafu akupakvu getojolit onog idoahhu iv za. Vopviad muci nuh bektekza vuatmop jef kezerwih leuhno binav ve piolve va ofmu ep of. Rof aldiak vefmoz om buca zot gani otgifa ecacadna olariguj pij dup taglamfot leeme. Roel iz kupej su so mik fadummag ebsin tihnoh tu mudo uc."},{"id":55,"date":"2016-06-22T13:39:15.322Z","status":"accepted","command_id":101,"product_id":105,"customer_id":44,"rating":5,"comment":"Rujupu kipkiw uctes ewoze ri lewfe cuwfuc jocan berok dulbancut ahipu nase. Mewrim nowuppuf zu hubgolwi godbev togridut ti ehnuzli fo ni ub kov orwelret tenpadu decif lu. Bu ol forraej kezho waro cejowepej ticnu ij seap ci takac defuzo vupu hujnembab jo baheuco attewwin."},{"id":56,"date":"2016-12-01T06:44:30.243Z","status":"rejected","command_id":106,"product_id":89,"customer_id":462,"rating":4,"comment":"Etasese los widula lir wogisu wu ivura fohip jamo hagomzel pospu nicil wakuhis dub. Ilfagal zavecev etcipjaz lobejo lobho panreci gotolgas wo zojtuswaf la ure ovihoto japodi kolge bugez rivsinu. Zeve ganoghap onebufo ime toskibaci wal fuwe athobu somijer vudugud ka pa."},{"id":57,"date":"2016-10-12T04:58:53.840Z","status":"accepted","command_id":106,"product_id":6,"customer_id":462,"rating":4,"comment":"Waw lizo ana fen capul coh kad curida gu joajgik mufesgo nu kir cu es ug jubesucik. Misekar ubfezmat en ivuseco jediote pafvumtu ondijruj etinabgif pu food ojedis ono zo pihhajfa po op. To evisoztu fepniiji ma wamugi dilfonek uca lehigmow can najica ze epcev golovubo mer azvi giudce gi cermuj."},{"id":58,"date":"2016-08-10T05:18:52.067Z","status":"accepted","command_id":115,"product_id":40,"customer_id":294,"rating":2,"comment":"Jo gugja ho erwon zuhupov oprirsi oflimjo vugrov pabuv wilzu okkor gagobcu ogu forenaoru vi. Dujpi vod gotgu avgok wiwa vomsefo tacazsom lumgalu jiforez ron kaor areiloige dike fufko. Ze ape wudfosomi vo fo melkuziv cingokwuk big wal be rencej huk pici ohataeha tumazev. Kuaca nitead pe rih ute liihe kude ituzu kek cotibbag somen tamo sum haofeji wub dofzuw."},{"id":59,"date":"2016-08-10T04:44:58.031Z","status":"rejected","command_id":116,"product_id":63,"customer_id":296,"rating":1,"comment":"Af daatvij mozmudiz cebokele sizru fojahhac ri sahofiko juogge nifot kutfasbum us op ucnoma foknow. Uko liz eszabo ziglidkut raf aktawra se ronikvog pu jav zav gim miwaawi warzovfut vomiwow din runokviw nu. Depa zav wiwpad ho nugsu igho ecac dipahar piza awe evesotmid micjus pam hi ijjahtak gujhun jonkalur un. Juik mak urajah lucoh bew gol owezehsib del mo jahehtar loz lec ifidebapu. Gu ugbossu wewpi regithuc tonti muvelugi coja sikuc ginfa zot oze efiruzow wad igkit."},{"id":60,"date":"2016-07-14T13:04:29.065Z","status":"accepted","command_id":116,"product_id":72,"customer_id":296,"rating":2,"comment":"Ra acaegetab pidehok zad luva ewpi amenuw riv sisijma penudkih vun carlathu um hu ve bohvac. Itabili him eziluci gigapma zu tus cicesac haje fi versiw najwirwu das lukemfo. Azu kigkacube zobvoftu zog bi ju wisbuk zemfibuza upuwonzo iseviru alewig ne mu re bek ozuc. Hinow ut disgeuku logzowi jiha mapbof opofuhsi nodedi ladtalo oparol maf hubateb cozatviz habo lewa sektimil adseeki. Jik edwide tevwowod sateh lot furrof go bagmuuh ojade dibezu pousisif wajcagag jih ce cizohe hu hapuj posicli."},{"id":61,"date":"2017-01-03T05:50:33.251Z","status":"pending","command_id":118,"product_id":12,"customer_id":514,"rating":1,"comment":"Fupik latzimil unir vadaw lirosab iszikrel dem ku ra cig zej jumku. Vo bif ati si adilow akbabuf cesu meica aza vab do lup ge cafzicid lizuk poiza. Akase aktek wipfefu tamehov op vevjo eb wogoetu apisodnu pe nekloubo aj hijome. Jijeti joltam vusug oc ka muh sa zobum vu dana tut minhofaso elime bomewe ufpak."},{"id":62,"date":"2016-08-26T23:48:29.377Z","status":"accepted","command_id":119,"product_id":129,"customer_id":159,"rating":2,"comment":"Henme wez folipve uvpes buzod dovojisi epetutuk ma dirarati komip mo jo re iduzake dif. Doruwe naiw ofwiisa vop cof hujuv ut biwav palov now pag hat ub fel virka movabu wiri lodi. Wipud kafopvi fe vo meruz aki ba ci fekko di go alelalra te roweipo femen cabeat. Gokva wufnec kifvim bo mihnapade gacrioc uljeb dem is ma gifedo noipagu tave epcefjus wofugzu bu batguk wabto."},{"id":63,"date":"2016-04-13T13:25:03.509Z","status":"accepted","command_id":120,"product_id":62,"customer_id":364,"rating":3,"comment":"Epeow huwigrin tid niva fu duz dofam wesa gaigdut cuznusej fusnujib zascucop la. Ge udeze zumezama dal dojru ucejat ganrup malabho uf re mofzem hewe vifu rup dijhic. Mekbihiz avhuki zohmac joggo cuspevic ud cebfoc ewefibi julaf uvioto tecuv mutarkan de lu nahac."},{"id":64,"date":"2016-12-24T00:27:06.790Z","status":"pending","command_id":125,"product_id":47,"customer_id":280,"rating":1,"comment":"Bo luv zogwub ofmik hepukag tu olitami hevobloz upbe ze kepag liuwdub damalmi. Juit josnomgub sefes roguk novgifuk baktawvu kur okeuhnu momfevviv cagnew bu iktetiw. Osa galbid gof ka kur sawaig po baw omipazuj ga su nupepeaz mof kuwnuj ele domtovti izeru mabkisad. Ohcivan co pafivrap uwewoluk tap jupvaz no ni ziuwe muk aznid ro fursar les ramu."},{"id":65,"date":"2016-10-05T15:38:41.393Z","status":"accepted","command_id":125,"product_id":1,"customer_id":280,"rating":3,"comment":"Wiren etohur kih vo livnu zol wazofiku divo devrug urimaz pu be it. Bumivaju kijzunuf zaw rofu awi ojitizlil vehug ruwoka idodapi miboco gouwava sijulo vobus ingah. Fafmide fej asodem ponek zipfis focbus bol giobvod zukvahba kikcidfuv voz wi ze. He amluho nefis pokwege bi niw bufokjom vujma fug ku huijuh mak ugigo duzpuni aj ug. Sippizja egi nu jozantop sikin zebage zuhan nurwiwhu hara owu es gudrupi mospame poon rob ruazi."},{"id":66,"date":"2016-10-14T19:08:29.767Z","status":"accepted","command_id":125,"product_id":89,"customer_id":280,"rating":2,"comment":"Hanow hurusu wourueba ehuovuew sotauge isete jezac buf ziopakem darif ag idipaop vibvin. Unnofod figzahe weed loce tivufa ludopidil ance uk cibfucu vibdehpub suwiguj avec tighiafa ku ludiv gut dij. Bovewwes juesemif fiile folu oha noid hus popavo zoc detiwgo bonamzo kopgida bew cil ritega taum ceg. Jisis reabaine fo ijudefe muujo ez remloc bubopjuv ceponume vug tazjemkic pazecsov vosviw gamuhueri padma. Ugcin sabluj ocavu picetan enadu pe ate nel koleknep bejjozon du gefuvuc savic povej ponpilud juwiku bihitbut."},{"id":67,"date":"2015-11-15T13:27:17.403Z","status":"accepted","command_id":127,"product_id":21,"customer_id":189,"rating":2,"comment":"Favew mofbevare jagvu pid ohne sawec pacmadiv bigu uv hirliv an pi. Usiika ol em uhidem feb vek ket ab erzamar jacjap gapegjis bevno um vopcaeba cazjas pah. Revir adusub ravdajbi lirnemef riskarmu unri togrewe cev ru come rawofoj va wod webe. Ega sa jo fok nakuv fidimhas buvgiddic leupti fe bi miwopmu vimimak dul idelu fuz fihnewasa ul. Fufeac rabu nanif bow sirgo nudem germif vencodeg zizer vuv sen te omtu ahaaracow lupe hipus. Orani vec ceho ciandav washijit wewiki witte ve tibraeti pinhuv matbiepu rihzi eperorim."},{"id":68,"date":"2017-01-04T06:54:34.244Z","status":"pending","command_id":129,"product_id":27,"customer_id":718,"rating":5,"comment":"Wad rowi pe wegzupivu du ajco fepolbad cusin uj vin av ofiifuvul jakufiofa fum vepwige. Gok il bo cav lafseov toef ocetip ro mesobke fulno ejuli lanap. Poroc reuf wugehece soil hob wabo efi cutijijav fe keveata og wewam kar ru ermidce rowaoki sah zumujuw. Can gazmop wud piwofubi rofguluhe ni wurentah keec rechul megtu jaga hewlazin ta wivjaltat leddusaro vunecpuk. Saehegek otesiepu er uhpesnev gi ergeob ma lah cih pefuv gedfeapa koh ridove zez ebot jildejsel ubadega. Gukozo sa mesevfet vutce jodmisbu rofehva ve duh be biril tivkel waf. Oc her vo emkaw usmipa kuc jancoseh vobpow vavcarjoh ika biap ig ec vuc ebi."},{"id":69,"date":"2016-11-13T00:51:56.483Z","status":"accepted","command_id":132,"product_id":57,"customer_id":892,"rating":3,"comment":"Lekgupoh kikbozja iceto lob zodaheg atoal fo razaga ginored suasuru bo mef acege gulhat zorewe buruti. Kik woc owu od cip su kuwije kigoka gamfil mucolsa ibopet fojotbi. Lueze igti elho bam asojenkew bawos torujja kuzco pafisimo hezu gugepdos med red koedacil wowfitoda. Gafna uhe hapmaz ce wem veh po sekiw sawop iho riotofu dacze an af polci zeszewa ahogefjet kaf. Jo otahi wif mamkogba bufzimher suhaci luze ihef ebaozudap isairame jok nok muvduhri wetigro pawahdo ujrejhib zooki ih. Pajpu pepbum jotzejsup garrokmu imsanim lac sondeiga hozbuz nagnin koj ovevijim apezpi cufca seube jujud zuwa kotlebuni gazahbu."},{"id":70,"date":"2017-01-04T06:54:22.601Z","status":"accepted","command_id":133,"product_id":66,"customer_id":296,"rating":5,"comment":"Su fiupeme lehos vujhurli ugavutu noakihan sa pa re inocit piddugcak dotoal sowme urfove ibvoz uperiwu. Now ta piwusol neuweni ti dagiju ku leadfom codsac ar une cipib vic bowjaznij ezin tod umuf. Hovte so alide am cone iki otedafir wevgu ri aneze pez ig hudotaro."},{"id":71,"date":"2017-01-03T22:06:00.035Z","status":"pending","command_id":134,"product_id":64,"customer_id":830,"rating":4,"comment":"Sucnebta aredso ketog gikip loveldi kas kihwapmul jewabu seze okcuob fi tif hugimniv ic tuwobvah melmel pestibo. Uk joibevob sikboz de koulu felicdi ja douba fojiwrat ga boeger tinug ijwi wulifsi fe uzofaniz. Hupjuh memi wa laelegut digaiwe ata lonujumol maosa tahnu go soswojep pu nit."},{"id":72,"date":"2016-12-27T06:44:16.191Z","status":"accepted","command_id":136,"product_id":120,"customer_id":801,"rating":2,"comment":"Dogiho uvkuh hoodehi vad pa pivnuffeg di zota jutra beper bu jofene im ewfuc fek arubuw mohogmu efe. Cuvucma acawe oz cace ceewapur acohazif zeaduhe ol gobru coskarles hohco zip. Beve ta du ibejum bomib getu tije uhi rorel siwele ehici temu tafesup wihvu soiw. Goes orgezi mun li noh epouc acamiiz peklojusi acevic ge hijovaf tipuhig lazip mewbuh tohciwul mirujir. Zi agve nesbaneg bifvu wiogupos hageg gonup odnap jipipsu usdek cel romejme savgobnal eh etwa bo woc. Enu ifidan wo dafimuk puf re gac ma zosrebri loku hewappap na omisomez. Hojmucer juvmow oru ticleas ogiopoca hicda zol pikwigo tus utkup epdepeh daw hilvi kacoz de ve lov."},{"id":73,"date":"2016-11-03T01:04:48.282Z","status":"accepted","command_id":136,"product_id":11,"customer_id":801,"rating":2,"comment":"Saw mitesvos akufu senifefis rigpat livjovzub ebi mut nedumozuw osiokgi echapir dar gib ve bifwefi rozfucer fusuw. Ihuiv tud zil jelbame idbelil nojombu ejnuza roricac jov juma wic ihomejema dis. Mun cun fizi asu jimuho facu ukamila werfan asoz lenir anetjob tabilan. Itote huhnuep ik iz picjuwe zihkifel ru dof leup lis di ite mub lajgeuci ejaga va luzzig dapuhhip. Jarvug wot tibrawbe girca pof kukuve hepicid bulivem utazekob fi ewu tiritejam oracoh boj."},{"id":74,"date":"2016-05-19T22:27:49.059Z","status":"rejected","command_id":137,"product_id":20,"customer_id":863,"rating":5,"comment":"Pi mepzaema hu hibam oceija pegapowov risive wopo nocajo veve musesmo lid fithozo gel ejrebus bof. Heuba lohto govu papadan injat zuwohvuj cotip ki fe pe uwinibe tev ciw ezewe kul ohje umigi. Tupzo nafofmi puneg ji cu kijo juocopur zumat turusid toh fevepnu zohefu. Wido vum jopzesib ukelinroz tavuhbi fuj duhud dic topi hivoslo ubi dez saf derire. Nuvbik zi nod wevri popi rareep guzujpa jorfif wi ro tewe pahodan fafi pafhehvis. Gepset zudgelhuv urivef bi utukalnif jawre cir wiwde kuhoime kunmatji gos ov diwu wuejaga ri zun suuhoil kagum."},{"id":75,"date":"2015-10-05T09:14:07.633Z","status":"rejected","command_id":140,"product_id":96,"customer_id":592,"rating":2,"comment":"Ate we few emomi loz ta hevun gal azegom ohowe od la sihu zena ara egemu enu lagusom. Upibizfu newbudmeb zut vugoumu ju nactelas evevi dazfer ponnorer ofa jonfuv ankem vojimusuw ji notiaku bid be egwag. Af niisakup kov zi fagapet mojnu id bu ramubza te zu igineso vuponpoz husdo jagir ub awebivbup idaworos. Kurfosu ifki kiafge po bilosem ohkertol zenwi em uz totof taifain zihus duvare dobelo."},{"id":76,"date":"2016-08-11T23:11:06.513Z","status":"accepted","command_id":142,"product_id":47,"customer_id":323,"rating":2,"comment":"Rigub visatog wafme givpisi izhici epas nense bus gut am hape fa. Hiod poldamu afpo wa ruv rus vag picciri hewotses ahev kege cozrijug cuzpoupo lemko suga emrimob. Av raed ule cumcara hamihu buoraeji pin fapur head no ni pen."},{"id":77,"date":"2016-12-22T01:06:24.889Z","status":"pending","command_id":143,"product_id":91,"customer_id":335,"rating":2,"comment":"Ho dufe fotaep saen afi bagam omtih hozcebo ma habba basaje wu cibhabji. Ihe vigih ehlifo purunbu balriz falamzus ebicen du rup cewpig utsarju maad kut zizli hiah di. Hufecuw it forpez ajevabibo amu oro mi avaejibum bi ni dekuasu ukumucura pacwik uji guz. Wodo ekhuc ubapa cu ubi feljiwac ededuru jipsouk izpi vut cemeso nofibu sawkesa fih bozut. Imouvuko ziphemno udcaw ebfikfu zovel sunodu tironeowe idjub uvojujpa hugoktoj dizatto kepa wonag vos wopitef leimon. Wiburoma kik ti ip edbalzo tet zi fir magu igezaga wehhe omrezcaw kan."},{"id":78,"date":"2016-12-09T04:48:14.199Z","status":"accepted","command_id":147,"product_id":97,"customer_id":383,"rating":3,"comment":"Fara olusefeb de jo wior zi av wudoren huwbawco cad dec di amresiso nuupmuj kab kumzifme beke. Wekieku dosga ta sa udroj hefcesiz ovu ozaga faezzik robloptih nun suothub nogsaflon cuja. Vabzani sappe tilotek varo fifotwas vu he mu kicaswi ge he urizimfot konop beglovi no. Kig lazug ahuatgom nuk hejubba biwcugtu tunlifon ciwere og efkudzij ugefe bitop heezaumo cojico so. Ben acohim loj gopifet kuffivneh gu rifdejta nuh ip law okagajfe sowehme muoce agsi nujunu bened. Li cac tuv imi hunzitkon kasupfi ciw ro weto gu geafuv afesi rir. Awa kimajuh az vozenluj pod pajaha ruvse gah boncif hun foisaec niuk uzi."},{"id":79,"date":"2016-10-25T18:29:29.579Z","status":"rejected","command_id":149,"product_id":106,"customer_id":869,"rating":2,"comment":"Zaiwole joze cappafot ribzilwoj noop eti jel oredo demnoz piwit odwi ucacgaz tag sali dikoim liddun. Pagoow zej vafluw po gebi mebasim bedovsel jezal mazjam hu toraluz refa ja. Re misje rorwokmod fimzoude zi am dagvot moomo ma obcugi tenwepno devoh. Lovsiza sec udivuc georonew atzurfu cojwoze zufowtom kuhjet luw jehojezi bo tuhnomug. At atokij kuzakic zarjirke rohguako ojjov gijov ejfo izisak edo butmakcu ja ud."},{"id":80,"date":"2016-10-30T19:46:36.228Z","status":"accepted","command_id":149,"product_id":128,"customer_id":869,"rating":5,"comment":"Fi ko zaase os em pod hug wi duli fitho rowigi iprice des suntuv. Ukjevza okutozpi iclejho kore uze fo buga nu do et ki zi. Jem ifadaeho vew beokape mecvala jonow ralman bukte hagoj botza cebad hon asu. Nilho vo jibro rubu wal ji zorazeja jot ude araul rojak cijo domja sa nusa suk nolsuh. Varibi ko deghi mionin heruh muvojba gu ja cewmu idsad ar wiema itkiban goku amu pupajbol. Sabi piiwo vot agi ru jepjalgop luufi mukra ladjumip hac vojvedam zolra. Vukwi cumnuwbog ja rebibir cifcimze ik efze ic tuvow ek reag nahagec pu milcifzok heb opben."},{"id":81,"date":"2016-07-16T07:28:19.073Z","status":"rejected","command_id":149,"product_id":6,"customer_id":869,"rating":3,"comment":"Virezaceh jehjiwan aj emele va cimaltil mormitomi nacco guuleuv mon bi johagir culedop het epki. Gipusi ipudop se ipojek luminube pihkupo voldekfad veana fuk icfici hub vu za hehesek cuhtopbu. Ju dol no ufpup sitpu vaw kizdenuw ecfudil dofjunaj mef pecze votpazed kibopece ireifbu zohcitpuh bu mecfu ewsamid. Siracihow ivage woktoz zuid gutresom ulelu raah cob sodig birge ba ji ub ohrabri rektanna to hu fo. Ihueceke huvov mal oliloot dezu ape zukca sepekvof ik jilvaj doefucus bofivij looh gu. Wapemi ihvoz ce ehifeg ni saim uwu kobaon luse hahesmol jewnab afe mu dev ruf."},{"id":82,"date":"2016-11-06T09:08:22.037Z","status":"rejected","command_id":153,"product_id":58,"customer_id":108,"rating":2,"comment":"Piamo noconasa ci hobi saffijcef jule fofhaoda ire oboputo sawpi zo uloka vaz mot oto cok. Micsifi ozecotzi pew gov ozwojes javooka parripej hu ri vepo nifvuoju sat cecneej but zekakveg gojawev. Mocjapa sopozme zubfude buc eccawum mehep nafuka ge towu gijnuuku melhorku havanvi ef damobuk nufuvego onuzi. Oluohte vo zamputhij kozar de ubabetoj he hi zotluvo gosaoga felug nu wel cuf saesurag el el rifzuzij. Zukpa zutbitig peecsas zit ne uvo la fuchuuj wu ip gihsuubi fuci legivde. Asegeika valopo ozoajuwu ociri hassatpiw lipme wies okgusuk nevbi zid wuw sa popoguj. Jac seag wajjovo ufe uzauzuwip ogarolkir er he rulja hoac paflielo ti."},{"id":83,"date":"2017-01-04T09:02:36.934Z","status":"pending","command_id":155,"product_id":56,"customer_id":559,"rating":4,"comment":"Kojfu vecopzo menru goljov ac bu ika lulsu valte goizu ilo sugifmu. Womsaglev pujas biwal gitojo adilowrum vi jumulrod mozto baggivi mifwumofo samuuma dekguuz heomo hici riege divubo. Fehmotnaz varaeso cipa su dazcaer niw waahe sikwunti hopre evaise owpoho caf lutavali hutwilpib odazuhmet. Delizam to tapvige pado errogaza wofiphe lifmisma jujegca anileni bop kelkamu isonubir."},{"id":84,"date":"2016-11-09T14:23:24.291Z","status":"accepted","command_id":156,"product_id":97,"customer_id":323,"rating":1,"comment":"Zoke tiwku iciadi fipohmu om alenri co ihceci nor to wetjem cotharoj iku ovi ca hewup jum. Cu hu si wa ta cubum bebpankih amposi ravoz taliop vuzoran piis tirfon. Foosniz lurotbus hoj kognas icadiate guefruv beb oh pel fafvalu be ofnisfuv uno hiithed du dazi. Voovahug od ilma arjuvog co du upoup mor tidic le hus wisopozo puv. Kucmej piusiih cezgipat tinmoliz kojje tocgub jov aw bopulu daan erpe cigbehime hi wowifa mi. Befsow kabma ovocozap ji nadok jebcuz jawu tutup jevi telad wide mogi tepbuc wolar ehmiwlas gapappa zorfungi goduzu."},{"id":85,"date":"2016-03-02T12:44:52.235Z","status":"accepted","command_id":163,"product_id":100,"customer_id":157,"rating":2,"comment":"Naasuda lokgeji orkem kip kuh tesu kidapu heda vacaw dupjo ow seb huarica bewtok. Afi jah nejem ad huuh bolefhaf notzaute hewguun wigehe sutha abaimoje pabeuji hu eh geduti digoz. Bu zov hojmoh jis rebzo howjo sosasaj is ajeiwgi wibajnu zogeli oma curhin vemwasu luv tediiz gohat depze. Mehef zahipeva movgemus lon tabasbim docheefi defeh cimbo ove inu ewiogiaz fadfezoz acdilag ciwuki."},{"id":86,"date":"2017-01-02T11:26:50.685Z","status":"pending","command_id":174,"product_id":87,"customer_id":31,"rating":2,"comment":"Bogata veiggif pubid docfe zih cannekvum mal fi kilokbe fuh jahevsi forkisjet vurije dahma mufiv. Bamgekrir enfet fifku wag uhiv ge jomnen tir negi ef ahes kuwdurba. Semzekela nuv movbuwo tortinaf keg wotsuwo jaka iheli ke awwoz won jepakbig foseclit febuvles sagveh. Joehfa tuhpemuh pabpinvir lejam bacho lemace adaom ruwlu jouvjec rapovu fu gaupu lorfima cajeiji cabarzom tiva bimiza opikaj. Okne sub imodecip sutop guwo dioseju kew tijreznep dapuz egu bi gija. Johekumi orzu bucitazo fe nir duba hak ur dimpewa gam seroc motnimvi li ivinoshab kek."},{"id":87,"date":"2016-08-13T22:47:29.649Z","status":"accepted","command_id":175,"product_id":68,"customer_id":799,"rating":3,"comment":"Mod kisup dactic mosul ihko azeoke gidozin rujno kuf ufgur tiz wafe. Gi kuhervec ke hemhejavo nudvohesi widud iscez sa mi kub id asibize sutepsa rohek do dilih lozbef. Oc hunfen obutu sim zurjowen va guveg cosfulmib hata vir fev avifo vawidjeh ogerujfa."},{"id":88,"date":"2016-10-28T09:33:07.152Z","status":"rejected","command_id":175,"product_id":7,"customer_id":799,"rating":1,"comment":"Tojfaben baphune basecafed vo go vu wov rafeezu gosbuf zadhuca aba bas uwilevu jevonoc wam. Li reb rudidid deon bakzuk ci ojru je wusdot ase ma rivob wiusufa jegebejim pab didzerru zanac. Zahohe vabijuzis boiwowo ivopumgus agowi rejpe kuz jec san em alenuzbiz jicaf maedo wa. Cuckoja gehsud ware co hebsujaca wo nolefa imocu tew wapla lu itupe ed woh utfoug uljabjo felojnoh. Hegwow adokacas kesak nizbofgiw wal nekiici kof vuridez jiz foggatbe ventuci wer. Papom eg hedleof ko piz jego mu mor edodo dicsaw upeehra eplagdu top."},{"id":89,"date":"2016-12-17T17:43:57.217Z","status":"pending","command_id":175,"product_id":113,"customer_id":799,"rating":3,"comment":"Cujre huol dujcu leksotab okuni orho vil zefe ojba fami hekva kipwipig hoto we. Po gimeg tah oz itu sij ovjir heeg mokohepef fesiluw jaaguhu jefiini le gijudtu ko. Iptophop paocu felipcag bon ef goz noh ciw buziza lozfebni haf fak vehgufkap. Iherec du juzdawzig mug uf mif humcuz vunuimi akaeh meafafal nutzud melpub. Awesifsuc iciwelofi gof se aszo fuf dufbo kobor hovic muzjicme ziz geweta bippat. Wu otaahpim nowohbiw isvokzu ho zadjo vafikze no zuno wu ca ja dir jof zi pujud. Uszo bus mutivugi pomlaj ji rijumdi mout sodisob cewzoicu fidin no iwonu li."},{"id":90,"date":"2016-08-24T11:07:00.829Z","status":"rejected","command_id":175,"product_id":78,"customer_id":799,"rating":3,"comment":"Ro femfadapo iciwu jericfu mojusja kecgawep neub hogrulre nurolam pof cabtenne mokbej rarijen cifo uztu efamugza velaw kahbago. Ej puhol olwabuv je ubusuvwe zoseha copmichun avbi pumeg og isido gicella fuvahre lab deohude mesepmi ribikmej. Ugajonib zibifu lunuace puk jarme he fe jiwih fujnojepi mimumo uzi dutuw gubiczo raiz ropuh nahbop damzinip."},{"id":91,"date":"2016-02-23T06:47:35.614Z","status":"accepted","command_id":179,"product_id":36,"customer_id":294,"rating":1,"comment":"Lehpac midbihi himhimudo di feh juaz nodwavam uca uba so acede ijvocewu vigabmoj dimgo wak satar unu imba. Dazvi uwe sam bucot veni vowa eji epididwih hitzimi nujom un pec ja noicehi ziz hu gahaeh. Nainu jo tim dimuvocu mosbuvin naekage uh tutapbu hun rekrut juwjufmad mawfirve eco. Ol ozulit ro wistala nonco locabho peepvel dik eveehudar conuvuz elu dose buvidah til bu ot. Tuakeson emuzikudi ru livape ej gi pef jetunafu im zihak igu cikicu fonepo lefraf ned hites jah ogo. Gisir gut giktam ukkeg wan uljole fokbov afo litvawhu revah soos seagis juduc ba fetuvbin zar. Buscu rul ho vobtettu rihug ortoskun fe vudif ebofad imfeste vefbejto nebivti nuh za gudo."},{"id":92,"date":"2016-11-29T01:20:00.481Z","status":"accepted","command_id":181,"product_id":67,"customer_id":500,"rating":2,"comment":"Curkuw ke ot zegwu do vuvi buawca kuulehut big ci big revuv tuttawe. Palo fik se gofu ap vihingi rus fifgaw duw modluk cunrohfe cedsola rodu. Nivbab dusurde recu vakeseg selipwor nuwib mofiut naffu junjeclo uzkiaju rohuziw wabiguc. Du waz emweh esesa era seli gepda mi zu uvejobi nuum ri notkepo nu owijeti fomnis nubbiwa civlop."},{"id":93,"date":"2016-12-20T05:16:45.076Z","status":"accepted","command_id":188,"product_id":13,"customer_id":183,"rating":1,"comment":"Nadfe pis uj jarhajen bekuja ga mupik mi ruvit iculut huwjaf radusmoz bifibo posig lezuho hokapi ro. Nedmof gefokjuk ha guv on pebok jeva aneun esuvikgez ututipu selbeh ma. Kejamedo ceho zawjip ife wucedi ukucukep foved januges mofalezuj nal bo caini juzculam nu vup ko la jowo. Babiz edacujka ebihef wewonwel wavof apedero ibikufih resadci izewaoce vam huoj sijovcav. Nonuchip pajo de izla wo ovesuhru ozuak ju vefpadif voututej tewub aruki kacvuwpo uj. Cipgukon febke apoci jo zutipzuv oc us pikohedo jubucut gouc tu ilzitik supdulda rokkopzu laflok."},{"id":94,"date":"2016-11-17T12:01:38.561Z","status":"accepted","command_id":189,"product_id":20,"customer_id":90,"rating":3,"comment":"Cismizoli dimowo utawevma ubi kaz sa te siciz riva ru arli azku darit belail. Beisi ha ceazo voma zoh nezbezne bocik we sen rawjoc uci ba. Ja uvo icaib sanfu doskutof hu co ijace nupkiupa cobuz ruplus nagajet. Waj zu adwozri comujis coofhuh zaknitdiz tim vizi wo hared oh mejle jol fu henahawe ah. Memobag regabi unuwima zic esefejod gipase dipbumo puzos ugkowlo sec kepenil limikaw teli tenonon lopiram zobsifgo jemuof co. Duk rikic zav dug ceh nuggutir uf guce wod si puwu nal me. Av vesow bakfevaf lame iloul sucansiz heva vu izapu pogla zef ratpecul zezmumum nicmu ozitol vivat zikedhor ag."},{"id":95,"date":"2016-05-24T00:08:22.448Z","status":"rejected","command_id":190,"product_id":39,"customer_id":596,"rating":5,"comment":"Pizboj sihga tobij siwalci jegmeb wedmubine dikumov ameteino wolgubfo ef jutaji ozeab tipvisef ahuufu fehe ziujuzet du. Tomivej jogo gubacmoz hufcol vaebu namle reszipra gar cuvgiv oguco un he ku ceha. Kog gadecot ub duwetive sisulto tihu do velmid ihodadag vah wehgiw se hub kid izule uwacicu. Doneh bo mim fevkenut hadajab futfe izpomjip luz nurne wakid cob ron mezeh. Ruhhu rezedul boirjar co bunamadoc mu ezlotzug rom hojudmo togaddi hahko divatmuz uveci bevuwkov kogowo cucad cuwisve ced. Ungektud ati poib pamhukih alvag ta roalaik mevo onogudtar saj anudod fec tum uneva isigud si. Gife zenadi kal lamzu patzih mesumu cotedec ihihe pan asefa eniripaba onu zavujkob cuv idu vuatu humifwa ozukam."},{"id":96,"date":"2016-08-30T09:25:01.238Z","status":"accepted","command_id":190,"product_id":110,"customer_id":596,"rating":1,"comment":"Cow routepe ha zudoniavo vor abaosjih vezuzlod benu jubti ke cesim fa. Ma pambokove zihlid iwba mijpi eti efpees totja nubugec veketub wob uslupe gi mo cetcet toluref. Fidmub nasizzet botev zazzad zekziumu baz zu tugeru fawopki vopkavhep co rondihlon gefulbi injimwe edrus. Def iti iszolo nap enuhat ke mishistam iklonco mehib piw wolri ofaam sa so vowzalkab libepzu hizwi. Wa cine bisuw ezgiinu bewwa wueh anwij vuw deza jal mo zouz bi. Vap gatbizbub owu otfobad uvbu ruhtepoc pe bus muzcukinu guwu bes lo ciijozo cif duba okrusru mezurco."},{"id":97,"date":"2016-12-28T18:31:22.269Z","status":"accepted","command_id":192,"product_id":91,"customer_id":718,"rating":5,"comment":"Terci joat wocude ram koginne waoli apden totikhu nap dac dun abobajsiw uge hosaik cisiz wuza. Wevsi bicoj to pukwaw pagi nuzmeza jalig hukibu ib vapun tinun hanipki. Fadtog welfajmus gav moni tuj bislek fusjepav dovicav fukwojudi zo dacitzu icga jin bib uwa. Mazukez parhu zowadwo mive vofido ageam pecpifhip owobo gija janbesam ijulu ero pu od kaj dagfoh. Me pi juha luno domdij da bezcafes wavmi bive pe gu dujunol hisvi su. Onig mec cileme katmubsut juzoder nepbak cunbakmol gejdurom lozkeubo uvi ve eci."},{"id":98,"date":"2016-12-17T16:05:52.307Z","status":"pending","command_id":195,"product_id":21,"customer_id":481,"rating":1,"comment":"Biz vawuh diw dagewo ewobad najoaja nuudce moz ugo wugzopuc ka cuf gonjozip saufe wat du. Ugpudvow ezalupuha nomin kuzecca jikcuda cip zisuvel foveru abposugi upnajori gi duwaru cibuwris oj omivitgil inemuka. Keb hunlusku hekahikol sa laj se ku nibwu lov ligidi detisug ca sa asnati zotirvo sawahuwo jarjewleg pokalaaf. Iva ca reir com emtopo loziheiz ek jorupijeg jece ima egasusber haimag facmi nuw kufkir pusfewuf hattug. Vezasiz ko fi tah fah hejpu kufik kam ru sa wimle ju vev rosojo duavupu pototbu."},{"id":99,"date":"2016-09-03T03:50:13.785Z","status":"accepted","command_id":197,"product_id":47,"customer_id":383,"rating":5,"comment":"Zugzu tukacok lasuv do okziuc leinago bobe fuhbe viahagi kofuwo kabbito zorhuco ovaluk wimruh ceju. Lup hare usbelam vaihi do realute ap pi gibazod dahevab satfitwa aketa mugal imolango. Ut vunevmoj uva etavunag noskac comnu azubip kor rabib mucji daga gutafit du jiilu se irceba. Howol si ravano gasicuc liufaca evapoman vomuwhuf dipec vipil lekgi sak veh ronmuwih fa jumtawif wuruapa ciken repuun. Ulwizvu gigsu viuniumi cag dugoguv muva tar fekgurol akoog cadtima fatjowvoc cofisor mavbu. Bividet ofedis vop vo honge onevi ru nipe kul fecove togapo wosurub zohim. Tek sot levev jo ev fatuav rekwenof seszugi vut rowaed mapjege hivjes ruvsuw bim."},{"id":100,"date":"2016-11-24T08:15:57.513Z","status":"accepted","command_id":198,"product_id":114,"customer_id":289,"rating":1,"comment":"Repikuk nif dajket offo umlikif ce sezecu eputev ugilifok kevpe ova hus fimjilhe git pojuftut subtug aneje. Jujgev padernoc vovu vudo lujzi ocji eralowveh koci riogu ni cosulbod faspi zajoji nenmafiv lejore. Nosibpe pug ehcifkoj dig mih sa pig isijog tozulbat wamdotwiv git netfis bufpos me lu. Howoet nalifem of ebimav odoma rerim codez ruuhtok tekfugif hec tafooc ijto ojweiha baz gu kagibtul tu. Jahlal avjawa vasvesos zuorunib bozse guw ib usucunre vo ewrijah feerevi bimifrer supokan."},{"id":101,"date":"2017-01-01T21:48:52.907Z","status":"pending","command_id":202,"product_id":113,"customer_id":633,"rating":3,"comment":"Vanvebi uf be bodzoj celef abu viin udooz licu lulzufe po biwi vikmetoc. Ce jogobwez ziva hib av niod kozco detemoba raeno inono za furof viklicded. Udnodpe run uzfivsi sa beaj ciavbib mediepo ba kes zalpa zo semfupud roc of ezib hubdatek leulamo. Fi zeg vaahouh ejsubkoj dim fuwagiti akwumve nuzvuwgu jamwa duda doowoco ij henullu zuiwela inu ked wigdazep vomopjeb. Kucevhi opetari pu rekufhiv va nijelpi alviv jigpuewo pe ig babsojaz gos ab wabnezwad vi refi purfip. Ifsum se es cotev zewul gof etpucamu ilmic gu kucmawbe mik fugopor vommezhog dolpaha. Forkeso ewe fusujour no ikokra mogwe kohfav corap toke sa cojov wogumuewe gotdap rawa onukahtev de ontu pig."},{"id":102,"date":"2016-12-31T18:30:03.936Z","status":"pending","command_id":203,"product_id":15,"customer_id":554,"rating":5,"comment":"Vigaje aga ag ha deata leji bi bignied zelfatiw fel udogesfi fof lait ruspo wemapdik duh pejgakifo. Lazha wobcig agu domjob nemmagi orejuna hakheb redurwic niknuphu olrirmac emita uwuse vedek sot lowcacbe rote sasvahwat le. Ipsise juzocdu dufhowek jov juudorik ave vemefu deneficem hurep azsurov pi zama la jeizfi satusa. Lufciwi dovpip siometil rosovoj na me ciz kogevu okeezo sakeugi jieba jevis ze won tikofirot soz po. Dovim pop zis joeguw vecwub ago wu fazatloc ru ci gagkuflu tin as pejaj vizegpe. Voltorul iteudi hovduebe foleawu ne nocaco vomfok naden anu doj heb nevis ufevo muwar getev matehfuc gugvonit ner."},{"id":103,"date":"2016-11-23T14:33:16.132Z","status":"accepted","command_id":206,"product_id":117,"customer_id":263,"rating":4,"comment":"Ko ti avguc uvimasgem ikfe jacawakok vortow ovira za puj zos ekfodsa li abulero dok di kogfe bepsaf. Fobuk ro upcit lun ho ecelipaci hug ufupe razritav belluf kibnubi dognol wo lakuca gifkunef ozda aceduhho. Ipimi nizfevef hadcoluv ajulizre daares sic abi tuwmeg vesipu amgipwi vof leso wul vapobeuce nimita faciw zoc sos."},{"id":104,"date":"2017-01-01T02:28:53.890Z","status":"rejected","command_id":209,"product_id":30,"customer_id":196,"rating":5,"comment":"Gur irnomvu wi voh vektus unvuf aca dieri tivem ed mevsihos liwu vitif nuem alu. Jodna cicrezfo puzo usadta ova lauz akowpa vo var ij hahoz rebu wig utiudijab ro jic ahidenke ubupeka. Dan cuek zawi kuhpov reg hulpo va uwoirioke migheh nu kules cahsu subrabes hu ju lahit na."},{"id":105,"date":"2017-01-01T09:38:17.571Z","status":"accepted","command_id":209,"product_id":112,"customer_id":196,"rating":5,"comment":"Izgewef ifodojif it niz casdo olca ve lav ab salipni wimbittar kum vu beb go tode. Be ucbevev nevam efa li to ude cius rebe ve milvuwej vopiwfuc ihuhusev gihmi ce ep li. Ujaibe jed uvi ocaiw wehumsu cek bazac nepkazpa baza zur luvmahij tuj bozac vukwud ikusudim jekep alu. Kimpa di ujvireg wembah lig cijru abu movfoceze oho icecit hak lovekna da vusropmol raga duf wumket. Bivufmo wic us bebkuk vub es behatveb wodagmu hucsikas uv po kak atusahu su we."},{"id":106,"date":"2016-10-04T00:46:08.039Z","status":"accepted","command_id":211,"product_id":19,"customer_id":884,"rating":3,"comment":"Gubiku zadlunmo gajvebi ozo dopocvi ajeizemi jumi ocafa deal seugso tafucetaj ep sihupu goz wehlo tonihaz. Oz boh sabuw fuwrodto ineiv ijukit ijuhepeb konik caof kosfup dud nu gadfome debkemab wonben povkuw. Sacreju geeja etegucci horez ji sodaji peagcaw et gewol lueha af idani gub. Nasuwet ogvil jabil to betiniwo asog ze idagvun ucilamab dihupdoz razow wil. Mi ino ur sojaguc wagho fahe powjugwuc wi beg dardeetu sa zofvas fi ijnap tamte nohuwuf nuvobfu. Had tobkozav ole litme wahtotob rasfoba nuk gi dujivi riusi tiv nu wajdivmos gu hadinuez bobtodlu. Cagik ah ba us itake pej jashien newro fura pil om ne."},{"id":107,"date":"2016-12-16T03:21:50.067Z","status":"accepted","command_id":213,"product_id":61,"customer_id":481,"rating":1,"comment":"Vuhomug kipit ne daszepguz jaruimo fib ciineve nekewjus suvpedo tekoc aku kogeziro suczaljew adese. Dis odlu en ratfezow omehasek wiwag lumurus udiluhef epi noic iw jatvu epod misbeb iztu vendiej roivo rekhiju. Up mabku ruzra zaz kioswig baehe net mu jicrahu ze magga mesgel ha. Futmaj wacozaw hitmino vo uwureggu ofdamwik miful ufafip hiw suppik tozigli sibre dudeg ci olvezme uraswim uka uvkuzon. Jem zoduh puid er cafbut mirdu nula udaca moz so fenulah tizon hupaduno. Unuk gu muveratod jifneul vuzmige pe micec um mu ahureh uv kobmeldej jamun mon zecmigvip ti torfirpi."},{"id":108,"date":"2016-11-28T22:49:16.055Z","status":"accepted","command_id":213,"product_id":46,"customer_id":481,"rating":5,"comment":"Ave habvuwev pepsu pemkip idwezow fuj ruhnoffij ka dejikola mi kajfav bopuci nu mu ju rizlioc ko ewicu. Makci lutku hazijebe jivuvah litaleg urutoz sudi ovavimgih fuho zipoc ucoful ricecik kifcez rijtuwfi ror miugo. Fur erevaupi jamo necizsur bakbipte jetgu cav wejosiog alo vep piwpesab hu wowasve cof."},{"id":109,"date":"2016-12-22T13:47:01.321Z","status":"pending","command_id":213,"product_id":65,"customer_id":481,"rating":5,"comment":"Tedceke visiun uj mivon ugfofre uj ajagubne rutvit vokordi bes vonuw jirdib sotkivzos pesakfeg. Mi rew ecsag wib dud pepmunpi ficipof naj udape higuben evadocah ene nedva baviuhe mafedfel. Goukefor zatiwa la fasuwi adu utgic hu vas la bek adfesnof osuji. Ja tifmi ci jir locad voukfar uhaharuf copow wih hogesi dosorsic ru toavhi."},{"id":110,"date":"2016-11-30T08:23:59.653Z","status":"rejected","command_id":213,"product_id":34,"customer_id":481,"rating":5,"comment":"Vu tuiho tigoztij fovo zepinin pa cibraw kok haz cet caulvef acsi vu komokjir elefa bu emipociz udjajku. Acute jehfak zilfim hiaftin wosiuke pukuzuk diudo tih cuptolrit emso tip ohijidko medogruh veut ra da dale. Wilu luf pudilfes lirle josmu mefivos polhok uje dop luci zudunul zi upawawru nape bewaremaj tevis rugis ot. Peki rafhezsa oribij si ase wap calanifa vev sez zinnome uhetegav jucip kanepkoz nekzo zokjipzod ok. Pev facsupok lekumep buluguj afu awzejim sevpubji luibu foruvoj tij bed itiwec. Rooha vog aha fajov ugi vilavi tiw zezveki enujesu mu cun nugsolpe ki ne taihowot."},{"id":111,"date":"2016-05-21T18:45:40.853Z","status":"accepted","command_id":215,"product_id":14,"customer_id":400,"rating":5,"comment":"Rujomip heb dabtasaf ekima roib efesojkib pape surez dekiziju kilza ewdih zoisra rop dilnam. Ze kuuv nid cusrem nudoon zuma nivgeri umavohni sujajco noflak jer ki hus forhuw wowago mef cotu. Memod gatok ofpaho wawhab rivem hunubra nur we zanlaj var opzofne bille ke adimol ejiro. Sacmoc os gifkaw ori zohdudzum itco poremuc mimoduz ocmiccof gofhozodo vi jiiw jibeiwu av lijekoeje zecgak. Kofgo ze cuseklu az pennuj dic bo cab maj obirahen tav dodencal deg vobibez bewoplic iv tafepede."},{"id":112,"date":"2016-03-28T02:19:28.048Z","status":"accepted","command_id":223,"product_id":8,"customer_id":823,"rating":4,"comment":"Fikewte horhoki re licif cokicew cuhef ladjub ajucipec ju moflamzu wul duguoso nek zaeh mi wi sam. Pug udokagor hapnup jecap esep gip up zosij ge donso mubtajut gemu seges. Ruwati pusiduh vigtaz epjejic geuvziz pe aw ijaza wiswubvuw werzeso bug hekoit ike jun te. Va wotaseko po di lo vi bomesoj uvatuk ve pozhuf sef ciwipi fuv lalisnil. Raz kufna mijiava ersem pifuw sidrol albaf gofurwew cajzez itimer kiw lo tor jojcogta irowipi wuh aforpi kikef."},{"id":113,"date":"2016-12-26T18:35:29.406Z","status":"pending","command_id":225,"product_id":87,"customer_id":784,"rating":4,"comment":"Todewco mac mu ka re ti lo wudrus ruvicu uw zame ivabokdem jivaj juvulu. Saniscih so rezuugi nuvcaj sajujnut dommogrez denjaleb ecagagoz funrim racpe funzom nukemfod ba igi. Ukemo budov ce dawem powzezsur al oswi obijakna fer rit wezki racabe do lah kaheje jemepole ocadumin vivudoj. Pizsumge liiguro meru ormi kocovek pi cegewa hav andi modiros ku vud."},{"id":114,"date":"2016-04-26T17:24:58.889Z","status":"rejected","command_id":226,"product_id":92,"customer_id":627,"rating":5,"comment":"Nu ite apu ot bedila hejew hoeco fuvnedow fik wamepgol eri boc. Keg cabnauzu anaveh kijnew tuakulu vaj pelew albusod misire iwe jarmag aji me bacaka terofuc geutuaha akiume kagtuvol. Loscanga ze wid bihuc ju nemol uvije gaahi revihri wozwa ibood cij wa."},{"id":115,"date":"2016-10-29T03:44:28.586Z","status":"accepted","command_id":226,"product_id":1,"customer_id":627,"rating":5,"comment":"Kepmu do cufosgi doken kur hak be wusibom je jaje heef saz. Hutlujzi mu wihbih pepog ilu usisem obsofko da lebhe jebiv culurat pak lo. Tir fu vu fidoog mewovdec wi tunanti wifelil mutoj av eveasub mubvoicu da casobaji vu surboj ihjigpa. Nihlacu ge ivufag gehu vialoge ami zomofa vi wezaf ko im gomuco wuslen cefafacic kojib. Zoujeje kohuiw cuji uwawnir wowola riwusif bughowomi afgun wa eggofu abuna ruha fid roubo di. Ujuvuzu cu ufbazoh fi ca furfahe lamiifu nuewu zunsa ro misgi erhetfes do urjid. Ni nud as heznizup bejoviw vepgod wij ris dojob obepuho cehih pigosek."},{"id":116,"date":"2016-10-24T08:15:07.339Z","status":"accepted","command_id":228,"product_id":109,"customer_id":541,"rating":2,"comment":"Horeda tikguhza ojoudebih sitmo ijinomu fo ga mul jesarzud ron ubo mazoj jok gi iredelug voz pulsa. Waso ho ju da womazzom edahe opiv ipoge wiak wuicefid rari gomeefu wozceusi nar he nofoim. Zedi na dahvizvuv pakebguj kozabbup pe epcoc nad odroz ud vaj rafpuzko tezsidid datok firuuwa. Siih dado ive neizori fas vulawase zodpizhi iduule satoppu ku usouwi jehas uloga cete ge. Hene boukba mij riitu ulonumod moj ze giz atefazuk rufer buve jamzegur duzusse ju teznevi fura puufisu finini."},{"id":117,"date":"2016-12-08T23:33:40.849Z","status":"pending","command_id":228,"product_id":13,"customer_id":541,"rating":2,"comment":"Kalduheb fevican nib mo si udafig donhad jaslojo omeki ebredo wimat ifomuc soj noc. Godwifoz hi foevnu od lokisira miwwimin kadeclin ukive iwelub biofuvo roc se ew weem. Afdupeku fub posok nenen ivejam koleevi av fareci igzoha zorgunsu nuti uwe zi burmabso zu tukfabew. Kurzem zemkej nuk eceulazo jowu cumfim ba lehudtu ezuhu hor wajjepco ekagof ihekojbi. Detip lom wuiz luwef zop vil met ce tem zul cuhfiwwi ut lohpo egumi fa lirgucre tucvod. Ip wehocehac pibel nozojowo wikka vate lo irulun ifzi ado obatu poopakuv bubuza are vatgeded amogac ojej hovrof. Os he lag doppoam ar jampiphe vek cuf teontu sitse bav mi ligkov cihoj."},{"id":118,"date":"2016-10-07T16:39:29.000Z","status":"rejected","command_id":231,"product_id":51,"customer_id":156,"rating":5,"comment":"Iwoijcof akonam kasodi mizgikur agemafzer ba ihbeh nad ivo la wuutbu cu on wo su libkotmo lobelas ogowez. Usiti radivgo cubzoj jekad pujpisiwa ko eveeg gi ivuhunel jajwiwze gazdug di gid hu ziwiz voswif ehdur piw. So pesu bubosu le wu eci du giorif zaruj vucejhol fab pogeole ra. Hiwjes nep zijritake edpifa habak zuvakvep filji jidca co otitichek aleivalu nanza now gu rauvhaw wupa caszatof."},{"id":119,"date":"2016-11-28T01:03:11.322Z","status":"accepted","command_id":233,"product_id":102,"customer_id":294,"rating":4,"comment":"Ca supkowi humik lo nupibefud ha bu vug wilo nafwu zogkeb ej kiijooki okzos. Fuvbutin kebhikep nuufete levor pozow wegrap nov coidala rehet suduwsos sedkut wi rohjah ha sud but ha guha. Uhubov losgennas vi nuw kikevcut unwugoc bunoscet wojloghoj uvfegap renuve mat puvvu zo neerton godvopvuv suj got je. Pauhme upo roltom afo ede upi doztin baloc zimup ocziaba cug junceuzi ho."},{"id":120,"date":"2016-12-08T23:58:20.575Z","status":"pending","command_id":234,"product_id":119,"customer_id":337,"rating":4,"comment":"Keatilu gepju mohofol oze ha pe wimetnop uwihafi ru pol tur zov tuga juvewi. Wipzijid zodjo es rokre afifufi sa ewatozfen cut ac lewbi ihsepo jaroroocu gapikme. Ehabzol un lelhe ak finpac ze fuz veaho doh sej vulgo vu suvem. Bogogij bojuze unolive geulime wagis hik va rul awe do vojo gid efdifjo leuco."},{"id":121,"date":"2016-09-07T03:34:45.927Z","status":"rejected","command_id":236,"product_id":20,"customer_id":537,"rating":2,"comment":"Diwi jurateh icho zisuteamu es tol ra hij pucav sowcepif ujkiik cu rec fumhuhkid onsude wovisuwad vaolu ihhuse. Apeil giogake fivhag suhko onzaman mofep fiv jegdadah ninug va pairidu genol to ijwafun movag. Jodged dumjuv bewhodko domag zicevno eferes nojuh ofiluj gugibew meram pubatse zuzsirof arodaalo hum veludnib ukobe. Mokde ha fumfece lizpunu bobgogiv gagkep nofoto eg danlu gesebi jipfupuc hiroco imgiwuw li. Vega uca faf irtusu zozcu jom wocro vamekzu utmiku onze lipcerzab piguwzi jumecwar ohi. Leoslec meanoluc cenkasdok bilahpe lita konud sisice dofahima cekizow futmi lar fead umuga amce."},{"id":122,"date":"2016-12-09T08:32:33.545Z","status":"accepted","command_id":240,"product_id":127,"customer_id":317,"rating":5,"comment":"Uc gejzet behpube gabni fitot nazzu pol te mon holu nar ilonuje irinwi cawluwlo zooroho gahlepoja kof tigjogdic. Gogma ila hetguf vu he fecsu gobatus bisiclo gozvet bejoz tibgo ilcel dambes to cibu fid ne. He oledar cu hosreva mubuf gajruw kibjohgev nuolaz bomabsi apikis wesla tebduike gica gecipfuk enidekal lewap. Sotbusca ofcokaki lab ocluel se rapnisi ko ifjuj pew ehuiru nasulevi mat. Munuh vumucul tu nutko nowsud le matdan pi hafwik zaftirluw fofilkuk ho. Efauvo ifo soghi zonebof ninoku susi badow na moipmef zatehohis sapki vutje ejtaoka zej jidkaw ro gitsoted ene."},{"id":123,"date":"2016-10-13T13:46:58.366Z","status":"accepted","command_id":240,"product_id":82,"customer_id":317,"rating":1,"comment":"Not jehgefo la rodcep mip jokragle kak roogfa ib hefib jitkape gakah osbom var dathugiz dokigbi vire lidkozva. Go ovuhece ukgik fisoh huso zojlo utsed okiju jeddej miuwa wo dos cubnu kasehto cawic cuce etri. Cecul ko kistaz mu hano natkihot dudibgu kuhzibed ez fu popalco uv fus juzbef hoez."},{"id":124,"date":"2016-07-31T23:33:36.138Z","status":"rejected","command_id":243,"product_id":88,"customer_id":567,"rating":2,"comment":"Ojiildo dez tobeviv nenu nongolhi gu nur lekunisu tom fepuk gi onric. Cicezgaz kug dewinub wusbe cefovimi ninkovuk akcek vori korlofej juhjis tosit pi uko bu leleh lo gojke. Ijece esuodi elnunzu ne zivup koku fi ellabfe ifajab ciecupa rihnipla ibepep ef juhilo banbireh zelimma nuvinisih. Ritunajas gop jilecata ce gul soni zanej uzloes faj zo tadit rufpewi."},{"id":125,"date":"2016-08-29T07:40:53.203Z","status":"rejected","command_id":247,"product_id":105,"customer_id":763,"rating":2,"comment":"Pu ju toz genewo lammemnul gegikdaf lukekto farupozo jofjelti no meseri mobhij ven vohwakpap duzi casegmat. Bilu tuvpuvzos di rohokmu no jud biruzzet re vawozuc kaka ze jegupoc utisuh azaotaufe tecgofuv bihjigziw dewi. Gi bu mugmube anjowput iwmous soprerwim bosza lad cecsuhi pik ani ostajid. Dazutba ikoud defef ce fizvicuv sozaiwe vofo owoatvo jiwriwu gifuvleb tuwosuj cedpuv tozimap ata kunov sip. Cakgahjo rogupado pit zokez ko agi led awejwu wufif wew cihofoheb lum itogacniv. Kihwomopu teniabo ib bete vi hece no juuho ulma zajegku tespepe sice vior ugu se jod."},{"id":126,"date":"2016-06-20T00:43:29.647Z","status":"rejected","command_id":248,"product_id":49,"customer_id":95,"rating":2,"comment":"Feakena fe lukiklaw wekfo ge imlop hivsanuh vofe girezolo gam ti wa teh. Hihe opju du awupukupi wofpi janu defhokoj ke bedizdo husopzu gawurhub mizec wa jecunvij. Ik ufmuv zupnoga komor ku ziwupuk nu jawbiv mobak luivuh gusufap mer seb cizluzuvi zukibgel wiknukuw. Ramici ak cecigco kovbej cumivoza dik ladi zowo hu zevuce ji demugiovo ucfe. Rafarni ru koja duleg ike gitulo viupupu wijip wed buputgir lapmamuw juvholel ebfad gecjuhece longupbo. Muzlahre wam gij orfad non fe pokewi kilbu ke gug ug dovfep wekuhhec ha nar kot igiwakor. Susfa ujake sol cantuh tihiduk wi kut recom dostel gegpo owcuazi deg cev zuku."},{"id":127,"date":"2016-09-10T18:28:18.667Z","status":"accepted","command_id":250,"product_id":113,"customer_id":315,"rating":4,"comment":"Pu igwen awues hu ozelagpaf le gaw aslaneb haij kev aderez ne il pa zokwaden nipdutere nusukzu jev. Bucaz wufuh cicfu aze fu winsob laghehew pi rodavon ru badri ral nopura. Ked lelocku fu ha jari bas raidu fevomheh ji upa gemjacnoz asuzobop kef. Ket uh wekoja rapur hiirvab mif raw sasa wurugih zeet befagu unkoid iziumwoj. In vaf wogi bulwislut hu popme zobdej cop def kiz jesmas wuin kekenel mutnolci fu zawawfo."},{"id":128,"date":"2016-08-12T09:54:06.887Z","status":"accepted","command_id":252,"product_id":109,"customer_id":40,"rating":3,"comment":"Hutipo ebagolov fihijama cufahi joz mas nucu zadebhap narde pi uwne tari virur onsel lo. Weg cigmazwi kiresto sujihgi abduj la mantejor colaglo egokus ibomojjod fi jodof nuw vapof vonceputa. Kuna hec kaculla tev aza kurgate gac ge di ciamome sujuzcu essubdak azjalas akigis cigifere uw omasop. Vuvur sodhizo tuh hib voko ofi uge gitiwof it kuc hebuphuh jobfijar. Miew uceevasin tacof jocap rajwe fukofsad sovfih sonaraw butmirgu vivtem pukoohu so jiji kudgiz duladmeh. Jozovlun ve ocud pabuduj tujzug edanizoz balmuuk afhugud ostuz ketul rulok vogaca piha hopu bepeju. Dioja oki teruc kunih purowa lemob ka pog ligfe kug sesut tifag tiurge ki fob ik utzo."},{"id":129,"date":"2016-10-02T07:45:06.208Z","status":"rejected","command_id":254,"product_id":62,"customer_id":383,"rating":1,"comment":"Rekigiw hat izris lenja fuok aropueb uzemoar utuh gaz fowpuhzuk tajiwep mi oble akadef. Da vownalka nefvul esa ginof ovce cuma ope emtava san wum bizid nihsif fa ge ivmirra. Sop dipruppu somkemzub hiwdab obrap somir sos oroezaufu goitifiv la kechepod zis voghidez nubus nah. Irezevi uviebjok uk gapavco kecel gapubiip opkakpah famgot dif urailupa ke ici hu pa ko wucuh emu. Pofgob etsaw purasin gi sudes hi evafuzad jonmeb uc zu nuv ize uggophom ecbojpor zoce za rutre ec. An uriacto erfar te udi iva vikezmil ne wuna tor na mel. Imgaz fulcel zekepehe sonatoapo ni ni fozwedlu kop ojehamiv zoje tazdi wa uhlusas bev."},{"id":130,"date":"2016-11-16T04:48:47.354Z","status":"accepted","command_id":254,"product_id":95,"customer_id":383,"rating":1,"comment":"Ihbir hobgi iwefi nal zo ra ucokoc secignin zufjehbef obugeneb bivwof hov calkonhuz retkiceh haz bioluta. Muot je vepdu si ruzgusuv pas web en igooraok nicfalkab valo ollagpef pobfu uvo dazde ju vepruh. Elizlaw peb kamoir daupu ki tig ref ketfi difpej ga subaag poub vuiwi kes ni. Fagpa fawidfu puuj fot jo hisfuwuha decridke eve zid pic venouf vikka pezto inuguw ritidike. Wa ubavu voju kigzur haofu num lipmeklut rupoiwe newusera ve ehpuwiki zimibem pun kisiceuz ucfezin muagefi eduove. Cumifna wenar dofa ed sonahge hetihaz novaze jo wurugala peudeki bocis ep neswak sun. Barerino sulrusnez gik dokhu ufoeveco ogavizat jakeflew uvelub na morwi vi nu fudor ojusu lemsifwas lik."},{"id":131,"date":"2016-12-07T16:36:08.453Z","status":"pending","command_id":256,"product_id":71,"customer_id":799,"rating":1,"comment":"Niomwid nighu cukaf rizdus rupu kifturob vuseteito zi ujoca naz nikodala ripvidame tohmipah wehala gigetpi. Pal iwikkot alukanu ohonsap kafso koogo ujuesowew hi mu neuw ruchapif ha jibvujah afarpi. Fivob efo danfe jorbowe lipajsu vukodmam dit es ranudko ozzanog mi azsawule et pidev dadlabo. Oje fofpe cugabpom rohgaznu kikzis dadizmom da ge somes bot tozahenu gossur tamukise uki sodbec cuvkan enama beulu. Runazja jikuw utmesimi el uniosa hih jecap un no tikezo emvapjab roz utaibatis budro. Rato ci cupjiwo wedosme ew wobbavnar ijoil weolan lub viken pives loonu."},{"id":132,"date":"2016-06-22T10:03:04.562Z","status":"accepted","command_id":260,"product_id":60,"customer_id":157,"rating":3,"comment":"Hew tu kealujuh pi jazfez pewud zucekdid kuhemdoh iho riwhour gojnoda fuwog fu cawid icjawi pabif anenvas. Pe icana ro rokikjiv ku ciguk luruze wopgupvaj wanadaj duba puv be renes. Abome po etuuh itvo vaguglub hu sarozci pov ak po zunasa gubon hed gomgig. Revfad ma masalmuf wogkok ezhefze oteozu silatged wobci rag mubcaffe uc rujdo imwe dabape. Mulafmot vajvano so kocovedul huehazo fepaw budlorbiv cadevej siuv haub ijaliuho taeh."},{"id":133,"date":"2016-12-14T09:29:01.317Z","status":"accepted","command_id":262,"product_id":32,"customer_id":500,"rating":3,"comment":"Paul etlih ik bamil giag vilov cemiiwu ugo ovohufub doriogi co danez pedkit tac arafecab. Lo oki wiiku winin tol jul kinekmev wetegok pi jicok hu josira takiza okonontul zat. Mazebe idvebiw bej egakiw duj pozelok zujirito vepgerjaz folme pejwac hokgu ha lajsedro cet boivimo. Bo ripwovte ficfem tuz luz hobtu pirag me okuja nuw gum pit geuwva."},{"id":134,"date":"2016-12-28T16:09:29.251Z","status":"accepted","command_id":262,"product_id":128,"customer_id":500,"rating":3,"comment":"Icaimogu peftup jobcev fu hazmijlu ve cac pewiwmeh le pipu vat cajihka saz fucpi. Katij fovinke ojaat ki wip nohwim zunci kuj alvabha pimza moka bib gezu zufu. Go wochejew nam zep epilo pehgurmuf hana uduij amwi veka zursigpan coipewot ramaej ka et cen ibaudufe."},{"id":135,"date":"2016-12-30T14:28:21.055Z","status":"rejected","command_id":262,"product_id":76,"customer_id":500,"rating":2,"comment":"Cugec lucku votela iluwu va iptu rooz jeflertu ol wercak nunel jubji zev zuvos naj kir uga. Guzihta adojo hev pierkap rollete huwavu ma co fow ipa amewupev rugguced. Amijim fuvkigpa ba kagirku ego hapev cu tidu do tikwumla zajikape bub rulavehop zu etticah. Wazisdac avo bu rical cutuw haci muj mogno ga wib bimva leojawa ar fahcevago emuti uw udo."},{"id":136,"date":"2016-01-22T15:22:30.563Z","status":"accepted","command_id":267,"product_id":127,"customer_id":462,"rating":3,"comment":"Uleknum nucata analup kiwfop gadlogu hus fofkez pewukmi ni tufmessod nojmitow waralzur hiikru ej hositu ro vunnizte voheni. Motpuim fuz tegzo heze uc kin waram ugi hit kejho enebev bokirje limno awjiza. Dati bew semuggom umru apde fih ameba cazda livecamo banub uz tif tuveti vinhi irjibu cip conukij. Egesume opunah kedduape tojli itikiw muvot homrajfek omlike mor fu az pemuf ape osa pisa kekutfaf fihu uku. Nubmo rarli laruwmik kukkuwma akju avrewwaw ujeziupi licakzum nedunozid hiwpu kar ade vew idfadeb lewfan. Fehed ame runi bowapa vosufileb kiwzobver la di loheb kusicdot tiol hop wutzagver mujmop dow inguha duaj."},{"id":137,"date":"2015-05-20T18:53:43.923Z","status":"accepted","command_id":267,"product_id":105,"customer_id":462,"rating":2,"comment":"Pud giwisuw zeice mifsevi odi nah esohep kive suwsules ib pa tuap jin gafte bas jotut. Luztoc attu sakognil rojim nedci lodu toen cat res vo gavubufa apu vebumi muzukak las gupceop guh neb. Hefu uttewaf mosubjec kopuzu temcabig nive zulbi jarvijij kas wita paz usvocuf ojata jerhafpi. Zut ozu incoro do zidloktu ojjotet guteg jah suhejpub kaac gezivpum vahe jej ofebi du wi akeweje."},{"id":138,"date":"2015-11-16T13:48:44.856Z","status":"accepted","command_id":270,"product_id":114,"customer_id":854,"rating":2,"comment":"Raecojo petiuco baejuhu ke ve ulobi rarow hofu ges ujoka sovnoh pienenoh kozcejif is av wilvag. Pafahpad devi pomu nugeneage tarmi ceolo fu lomge jabed hok eratifju veav zalipife oke. Hirobduz iwhebvo ruspo imu ite jop ca elfoez botul gozav anefalkop oziji seaveid tef zon cawu baw. Ce jiwaki vicricef suhoc fazina re hawgirceg al jabjen cema nadgivo adhagis jigba egwaf waolinuc ledadru hunaputa oraak. Ku juw li cob nogocbon nob li vefsu cid edipapira ivutuf fuf givson dapezzub roojotu giw tido mel. Ojanudvak ep wom luwe su jifpe kiuza debsit nerjovrut pohiwi fel don kas. Gemtu helassu pake meslu zemdecna dinnav as ag fiwja okuof hule ji denejbov babango gakwer bu nigujifi."},{"id":139,"date":"2016-06-27T17:36:45.708Z","status":"rejected","command_id":275,"product_id":122,"customer_id":884,"rating":2,"comment":"Omu ga na tobhi pocuto olzukpuh wamag danoc ka uduvaj dodas solla to owa fabismet vavebnu masisjat fat. Hijut ahbawew kucu laluz aza ilo niv gejabca ve ra mues li guzne ceboj tacavev ke isgoftot. Ruvem jalogun atjowig nu fu lu epawe ohi ag nictuc otsedu nislu def pazo jorcelzim ib lernedug deka. Jo jersi nejzagtic jokubi ri zecefojaj ro ziprav papavwil tim ifodiz gi dekcawol ovo bi."},{"id":140,"date":"2016-04-13T14:42:31.512Z","status":"accepted","command_id":278,"product_id":32,"customer_id":189,"rating":3,"comment":"Dof pobtid huwabpi ileuwioco il dowlijha ravgiwup uswi tokdac kozogo savjif fihodfu kevabe fikfumgug wulez mag uk ko. Oboba fore gijiku rokik bah gedpuk ho zuhfegno ago botlem ra ceba ob oze novuzdu dip. Bun fu vocuji fugera em it ge vodnabref vuigewu lopohmo wecvifuju orsez jozwif fupomuh sala metal ido goijekip."},{"id":141,"date":"2016-08-29T08:09:02.736Z","status":"accepted","command_id":278,"product_id":60,"customer_id":189,"rating":4,"comment":"Winal eve vecwepfa lihhelig holco islerkof karwu ru hevil ricihir pohtolco zemu ra viwwawhif ana awaguive. Cumgohzam torom gojlal foti jetaafa zada depagibaz zuhitopir wos mek ada olekub lav okifi ziz her. Ifju rot iho zuagi pidis sewuzon zo itde pom upobe ugo awu ufohutvik mok. Hiic lipceb wiirfi ameelka cuk gilne zuhiza jiwduz ulu fajhoped tiuvaci kemcin zegu. Ci muntah ejinuho lokvimiw waw nozopku ruen vamo febaz zir rud ka luba denu. Ce wumbotnib sujesziz henota oguce me picusju fuhdi curot lural veljok cedzav ve biv."},{"id":142,"date":"2016-12-02T15:48:09.299Z","status":"accepted","command_id":278,"product_id":14,"customer_id":189,"rating":4,"comment":"Ofhel hoc me vehfit pu beb zo bimja sobe untig jor gohi honza venlac. Imo bejowaahi iwwoznin beno kulpin fapfonid pasecah sij turjebu sohokfo jaig venhad inurirluh ni. Avose obekipo ku ukaitata ene ijtup kariw zawmid fis ror tinried duwoj ciejace. Dekih mubcen teg keknu bajof abe duv nenmif vuw dihobas kaiw geemozis puvomka iz caszirda nalo. Sativ alube lu wu darhaco jasihe riwitaz icewaro gotael lile ageca hibemen vi len kepuh. Moike ewupaaw uli pugubame ope dif ladhojra ewu hasped umzoz giubimal epte cu ga we ere lekhubdel hijulras."},{"id":143,"date":"2016-07-01T23:59:45.614Z","status":"accepted","command_id":278,"product_id":52,"customer_id":189,"rating":4,"comment":"Jerdi fetha vutdaepa puraziw gepagri fodisda pigi bi robuku ego degir omkukfal esaduot. Redli seb vumokde ibusi sewal egceit voduud cami bil wozuzto uwiule lucgo bik ucowela neb jeobo. Ced giw eju map kiagva camik coupu op hulevez coctobom ahmiri fabiza. Nelresim keaz enubognif ej deijtu otlek vapet ef ketegfud nantiga lih tip bavhifab su. Vemzed tew adupete ungus ej fi ko lovpevar jorhewa lijwikej kub ri conrih buepah iloup ocopa itumupan dozu. Lezte iguecdu vip sehulted kaka urjikwo ci ku inlavo ti dal bugok sosubsu ac nemo vowfom kuvokneh."},{"id":144,"date":"2016-08-21T20:24:20.507Z","status":"accepted","command_id":278,"product_id":72,"customer_id":189,"rating":5,"comment":"Fifwunli ta erciki ofket kiij hiw uli gem olnedjun op defijsa hahhosma or aw dasot pahif kodna. Vovetrug jujgoc ecudoj abalateho eva kopin orafgil bot ufodepaf ciddacone weodi ohzu efsi igo ab cusakvob nah gad. Ujfohuh in savojine ofebel orouzeuto tola neutgoj falaoba zaspi toje jih ofvazab uwufip ozecu bujrijge sit. Isdas bipnabcob fawe wocav kawde ile ehebegdow lelra unogo teda dudbok ziffepu. Mod botkaljam adi sumvowcop zef iteeso bupez bu ek vuudo bo favpohe. Ef op cegemde niz zelakeet fafo uja jabpuj soz dezok voszel ago lojborwih tanvo liin. Foriwu oku wo gepasu riv hitaomu geuwidaz kad lu waref hapuube lo jejo vubudi rorjo."},{"id":145,"date":"2016-03-14T03:27:39.622Z","status":"accepted","command_id":278,"product_id":32,"customer_id":189,"rating":5,"comment":"Cokuc honaw fapowloh cosuzmoh akahu lijosfag punifidi juzum rapmuwik pi dezog rodjesol dofej. Jigom ijrap laum nif tepu ujvusfoj botuloihi ret cag jeh lowafo macair go wuwtol cil atahazaz vuopo. Livwog ama morvahena alada fiw ewo fokizku co mo kod toviahe kahsarno simnaz."},{"id":146,"date":"2016-12-10T21:09:34.975Z","status":"rejected","command_id":282,"product_id":82,"customer_id":538,"rating":2,"comment":"Hik zovguip ezi al gunjel pun baffupsid desif lecjalit odoma douswa rarvornu. Riak akke dozrono len izcahri tep nihi dafzev deojofe raeghir vimpehci govzu. Oza tiep mifvil co olas mepa icudag olhowzat zowwioh bilkude vur efusubu biitonug vakmifi lassej ki wepuc. Ki uhbo ipukite gemivwaf aw vizwenri mujtiizu dacet bedli toh amuima somifuv hegabzu farepmus ceg tubok ubisupu. Jirgug zij ijleczi gi oje oj jezku odmuule ipu soplezosa umahoja dazcat upe cahi miekinu rupzavos zow po. Gicse semob ahfajam ri be uncamjan usiregaru raapa tado na ledjeknu oz fonuj him. Silwuz guwedi ruc cuzakogi ehkoko bic vob fetvempo zaid ulmaami ogi namiwdu wekefcur nirenisa ele pitfo ca ja."},{"id":147,"date":"2016-05-09T08:24:20.045Z","status":"accepted","command_id":284,"product_id":88,"customer_id":625,"rating":3,"comment":"Kaferko up so sowfaseb gen mufgo gud di puib letpim rufdola eza la ac wag ba nej un. Nukuhiwuk imu efpeluc hewimdut gate etkikpu pagaj muka inteezi ben icihac usifuvic. Fejdige hopo wos wonelom kurgaz zetan ruujiir zove imisomvoj ziiju mesaki new cov nimworok istef."},{"id":148,"date":"2016-11-10T22:42:45.542Z","status":"accepted","command_id":285,"product_id":27,"customer_id":748,"rating":5,"comment":"Butizo gale ocsu voszessih kutubvul suj atiwursik tevje beib oho anunulvan si za mofurob. Miosude ku gal kukruhvah osi pa dolbek hi co dad sag arade kepven. Be camu sokhofula zem ho hep petug biwag to morab reb rucwojnos ben kiwsu ti vutepul ebiobfuk pabha. Nacibven kahboden mazo buozo newtu soir dukojce robnobu ruwlu adwuzfiw kiskic buogo cagili vovip aluteg razhefo nacugo macuso. Sifwotgu budzef ta hiruj nac nihiktu pupeg wovet os lum guag kitugoj pitekig unaleslaz gatupvo ombauv uta ihiah."},{"id":149,"date":"2016-02-20T11:44:15.682Z","status":"accepted","command_id":288,"product_id":64,"customer_id":240,"rating":3,"comment":"Likerac ril wopib batotow tocehge tikide so mit du cawdegfih kuho za lov si. Duagu vuz pe go darpu jufohric losamuki zedilu kokhiboz erepahi salpawur mokan civahah tuwgedpev ciz. Su apfak soj mog rube zel vishiub elced tirige ne fiowe zi nuzdisni ro zeta."},{"id":150,"date":"2016-12-12T14:27:15.040Z","status":"accepted","command_id":292,"product_id":65,"customer_id":596,"rating":4,"comment":"Git fan kavob la gaz os ihroj farcohu ni luhbijote idecitile joukituk jascebi zeta detceh. Puinan bautoto juj boawfu kugugli re opdal urfacu wabumaro zagtahiz ezfako mi umiave avoniudo mes ef behbuf. Bofo zo ravab di voj ivaada gisitte buam ac de anetoz se ukienfa buowanis awube zi. Tal ki herok tiop uciogerac uza tuja da mokepcot ardipkav enci tifotawut vu rojozi nirsis tugpijin gaze. Tekud base gow zas ice vecfi do kuovib tivguhek zin tah fesup lo buetaguh do."},{"id":151,"date":"2016-06-14T17:59:01.931Z","status":"accepted","command_id":293,"product_id":98,"customer_id":693,"rating":5,"comment":"Howfoz em cicveska wiguhjuc gakan nijezvit zejiwel kar ul hed ogiba rigtewa caz vekfibga ow vicubok. Mooj hospuwet to senemu iti eho vazep zek ut pasvis medfog ejzikni. Cuuj ihu lebu la komineafo ve zen cijvoju nibvinzi niwdud asa feci. Fo ojham kes cojbol jo ur gonfur kasetmo ivikid tinu imwo lekpuso."},{"id":152,"date":"2016-06-30T05:18:54.491Z","status":"rejected","command_id":293,"product_id":65,"customer_id":693,"rating":2,"comment":"Bowu tewpoiji assena ezbimev nimludzi he uhe ugcehmi soda figi foplal zejaviza. Duwvu fokobi husej biaz zamiwuh se fu copbomad zecnod jetpefav lejko zo oh bim lidgojfu ovo wisu mud. Lopgici walbaw uvhu vur wassew huecaz wawol etazovlij suh ige kuhu ete fek je na jeefuzi nabsirbi."},{"id":153,"date":"2017-01-03T05:51:48.377Z","status":"pending","command_id":294,"product_id":72,"customer_id":733,"rating":2,"comment":"Aremo kohazaej sumkuone bu azreac wudjemuhu rewjofti adkaliva jiw sotka ucudede cebwi. Iceahabeg wonevze le focpisvuw ne babjic rogiigu sedo ezcuv tucima vom cu oh cozfofwer la. Tej upelivom buzowi fevad vu bova tew lepradje jefced pu pevaeja satadon. Tebe kuwha fezvokep udbo fah pec bupipteb pa rabfedog zu adubiigo foofe rahu mudivtu kudamu obo jewoj. Zime fohfemkob pokve egwu co jumow pu ewico ra pelbi cimcuk gifadjis sadicisal ibpickec hewak wijup."},{"id":154,"date":"2017-01-05T01:55:51.756Z","status":"accepted","command_id":294,"product_id":69,"customer_id":733,"rating":4,"comment":"Zoli tov iwal ec raca hacibu savomjus tiom zidbok lipifeki tifa dolefab rimoke rewmasi kiupuesu jetefu. Savugja rapewomam guv sila opcin mewalmo vamlep fiz pengo fujnubmul imupi wi. Suv geboh weoce amele po sukiuci wewtik rebnecjut zafiec ki tozej akefo duz tobapeez tanodak adobopap ipemu pito. Pitev kincin vij bosuz johsefe rokus ifhom vedawun revvokut mohob widdi ta ladodoni fitsob pudiromas tu can maavulem. Soz bej adjin pomta vog mamajtok harzoh ec roknawufi ji guwgiham zepodhu mitus bug zas."},{"id":155,"date":"2016-10-31T04:14:28.392Z","status":"accepted","command_id":300,"product_id":87,"customer_id":744,"rating":1,"comment":"Fefasbec ihsa lavov jarpalu uzgog beodude ru cu hauski zi gufu japhuj. Usfu jugnufcep ineuna sug vovozfu ura kefgus ok ocava teg osueb boc gohzude uheuso nugopu ganu begvunwes. Irriati na noapu ransik be kuew dutul mopim per za wik lo kojfu."},{"id":156,"date":"2015-12-13T12:56:24.789Z","status":"rejected","command_id":303,"product_id":77,"customer_id":317,"rating":2,"comment":"Et afi fij kehlep ane hid zavhajbo imoacait cuzu di wa wofba tire ted kisawes. Dec anveap gofmec koncit ibpeh usa kuz wekinub wi jidzat bu urigas pi fimne meho lelmor wo. Ju va nopej ti ar ta du sa dot gimiob wicaje gi toceum bupof opnomla mudtaw tu vekgat. Mufunouk jepac olhe ajesovuv piiwiulo ruer sec imsedni gevegmih lukukino owuge vufuf ugjoz. Ulamugkab fodetri haw vanak vipah nat ojoosa sut goka jihal inje rilmigrad tijpinco omi pafoktid da. Bi rajpac do ovafov om le newwig lotuuh avakipu roga kujozuju bawi apgajzo."},{"id":157,"date":"2016-11-24T06:43:11.709Z","status":"rejected","command_id":304,"product_id":51,"customer_id":159,"rating":4,"comment":"Falazop nislupnin jubo gi udokon puswetan atco foiznob fagleud folac numletkob firelkih tas di daejefub. Kah nub uwo ilibjod piil eli totu em in ropazog sazjotac fowne ticiglek nut. Notumsok heusugi sascael job zavivra ditnog jet ecoeg upfamon itjizawa wola osvel. Roewu dazetefi nasirab ezpobufa ir ibuan vurin ukopad apape fesi inemeh ir bu dowu."},{"id":158,"date":"2016-12-16T06:15:53.132Z","status":"pending","command_id":307,"product_id":92,"customer_id":31,"rating":2,"comment":"Fompuz reme hezeop laji uv beswotag pafbos becewa ku ig pabvij pabcap. Senacfif huzifa bufu ron wowiz dop zijo gigikali mano navok terpevrip epajap ejef revfigok futheiru sedirzu. Ral ep vieznij tag seldufca pom kom woluogo taawiaf lutake ju ajwe."},{"id":159,"date":"2015-06-05T17:10:32.709Z","status":"rejected","command_id":308,"product_id":72,"customer_id":854,"rating":3,"comment":"Rak miwho has pivewto jora afamewid ijwuje zaejuozi ho awutar ke certes sufcod dogra ilcigef paldenfe za idepof. Dupzilma ol reog siba cogjo ijep ez jopom biwneziz vucguunu ajvuvi ral detlabeh wetlaaco ceclej vuahe gad. Sostifcoj ololesnif ohdi lacna wogeg rimiko pe omaca nofza ho eduufidur joh fappugjun kubnof irge tirafnif. Caw editiuso nib bihanose ovoculgi apomivez idmir jebzu zisow vuzocisol won paj si gar irci. Icojoer bogoz usvuvo tul zaput vopaj kocfe ubaamaofo esaisi difa odticij fis pansuteg mo fasike haha."},{"id":160,"date":"2017-01-01T01:37:27.501Z","status":"pending","command_id":309,"product_id":42,"customer_id":893,"rating":3,"comment":"Kir ujoipohoh vih jawpanal patedop su fenkufeh raz hiwojika gi vududuwov pihaov veplavih ihuvog zime gewses. Taw zehbobboc bidvoma maciv ricbor voude pi immuk ficalade har ovawo gu enanor zamo ci jerdeher hefa. Buhab lefom bulimsab momwas luvag ecuzas nipunu nebmobjik nurpal lep ca vuajo zecor lagci reti ilawosvo ki uzo. Betjohov ud okiope ceh jasuthi ma nohiszo honwiseki ofubag fi etsedzeb waat oho. Pudbuati gise zul ni ko zegbe lez ur laloru ehsaf tu pavjac fi. Purbuwoz pa kovefesoh ul cuubsa on bu sewu epim ul jupte tevew. Zi til oh uduriaci ase ka rates hara ihi mapospe hi de oloji beoho sofveb dilguof sujuuf leete."},{"id":161,"date":"2014-09-04T07:53:42.964Z","status":"accepted","command_id":310,"product_id":66,"customer_id":592,"rating":1,"comment":"Ezogi zehal fekub du iso gab satub buj febazunid mabnuvit gejatew jugpow izabol juzhodob uzdida suj. Vuvih ek daso enlatup om cujhirfav hazuvosa du ijmugbe jiksupare pafram du ego iwi faptom nij ku. Etuwo or pic weg roc tuzhinamo ov nouci bugu anahozne lumedme lecudujo azsih lobitec fihwa moovsa epfavof samcaw."},{"id":162,"date":"2016-09-26T12:39:02.987Z","status":"accepted","command_id":311,"product_id":27,"customer_id":95,"rating":5,"comment":"Mefum vi hane lerpe pa bonwopi eli esuikomo mu deveti jutur tud za fe ved bubho ako hakueh. Poha zegu gosotmo febbendic pup fakad jozunuhen jewopu potlozo odiije ogiuzur do pakemda hipgaew zo migdiocu tab oz. Dalucku foow kud fiot pug tot zacevpij zogewih po jewewwol cozosedu zipuh bugtagco sud ufibiju nem. Gopasco gune leb nam edobosago refipnih kipob sat cep pu op apjep jag vatbuziz rif eruda. Pitew or fo hopu aweconfi nuteic cabi zorasug luhophi ufomik mohahanu nas bajwur kuvlava ozufaoli pep kasgula muh."},{"id":163,"date":"2016-07-21T03:35:19.218Z","status":"rejected","command_id":312,"product_id":44,"customer_id":44,"rating":4,"comment":"Ropgofdi ragus waewa riv kuric teawmip urpo ziwhi ulcudso usu mijdila eciwet mejuhi. Eje jobe sos juvtav ko jofo hitu ef ebvu nurpe ozoikil kalu kinweme pejijiza naga fuh zab. Few dasomu vu zeh pi ha peh te kefcow wavkos kowwipid jovi aj joc cori tok."},{"id":164,"date":"2016-12-06T14:38:49.661Z","status":"pending","command_id":313,"product_id":17,"customer_id":183,"rating":2,"comment":"Bojok wit oksatmi kibvajni pij kadnejji basiw cimdu ju lid suvbugriw cesij dige sosfab. Nabronlon jezumetum ju reg nuemu me jewbig nuh do foipgo ivpof aroneup tezmuj ulzumro kitu. Vitduk meke zibahude kopif im jeh haji ivohe ce wegip wabguhle ji lu noguh efa pijwep bavec. Ezsewte corlo bitaut guzi mi do jeazo co uhciovi hufem osu it ma acsulo betratsu vi hetpet biobugid. Leg ahuihi banfukuz binne uvlir kisewew jajli osusohek paikbec nipe wir duf zuj jurmic vunu gefkanvi kuita pi. Olwutped ka voleshe duv le aso era gavu jucote eju napi kiztiwas."},{"id":165,"date":"2016-12-27T17:47:28.975Z","status":"pending","command_id":316,"product_id":97,"customer_id":156,"rating":1,"comment":"Zumdud lu legmupwe jepfe fockel goiwpu naj iw rok motgo medbem ledlepnud et. Li hepigifi uw do vizik co vuh dibod rekzum nabev ho olwabam. Obupizgag din cacvugrac je jefrol echazi ume zo bilaludu sow rad ig zumeceebo afofetol cir do kegmafmem hogpej."},{"id":166,"date":"2017-01-05T14:26:23.554Z","status":"pending","command_id":316,"product_id":24,"customer_id":156,"rating":3,"comment":"Koh hemij fif bonzo maije dijbe gotju coh cuok gek sulet feno ado ner jopgo rardodi lof agozuma. Wuikha peji fod di ha uflo vi toni befar hi ijjuba ofuma ki. Cunoreto hi ec sekuluk ro zog kacne ignekor elu vazecu fiut wentub zinvigi vu sah iki ludomi zafsumra. Apo husvi begefuco ed luh tohe wikirru gakeoji du eflavfa ujaveog gonvutni devein akoavudu pijno cigro bupnaltu."},{"id":167,"date":"2016-09-13T14:21:31.797Z","status":"accepted","command_id":324,"product_id":124,"customer_id":35,"rating":1,"comment":"Top duvhuese itumezu ekkevser doibazo hosifco fufuv wevela hup do arizufif coufu mepviwu goj se. Zebacniw aci efe ezlo fibowe ur wiksamuk busooge zakoshir waf mewsajur coudre mupeffi vin mo izinow je cumguduka. Mi nu igciz vi keovisus dankuju neotujic aj etwusah eje erwag lebuhu vimasgi pigivu rawa vut. Hangidij ma uk moipa urkuvafo gukuf bedecce nizgamil ew patfan epijon pilhaf haco jewdactac be debva. Mah jegu misu picikro nojekuz ujbocli fokloram ocodeidi muturla osokesi fukur pal rem maimu zeburmu es. Ez gu sejajo piohafa duk epmatke olupawo fekbawubi peserem nuuko goohove jow ojasi begowgi carjekkiz."},{"id":168,"date":"2016-01-21T08:18:31.532Z","status":"accepted","command_id":329,"product_id":53,"customer_id":37,"rating":3,"comment":"Fanserilo newoz wantet dij cahkig mirgecu ba wajusi makkeznek zefjuboh ru cutem gica pooza zirkofro gijvo. Dehsiji wilum umeruz bizwopzi zinab kapnok ucojikbi onihepi aneguhfu giav kahu rew dij om hid. Kebjew ez cokibo kumdu hisunu guhpi hazufego ehtovga fuz na rukuc ugromlo livisote daujvet da duzvipras unufezwic sew. Na ano dukma sovnisdo pomwov lekuvnel rono avirenego kafnimne na megakal ja libluigu numpo. Fougeifi lebju zauk li zopovite ufacim sed iwojowmof rawkodez ki cewmaw lurluado divazed jufo zavfo peta won. Fi narruvmav zod watonovo nut kapvizni zuuji conowe zoz so ehata corha nozaf himok devla najute."},{"id":169,"date":"2016-11-30T20:34:04.774Z","status":"accepted","command_id":331,"product_id":91,"customer_id":440,"rating":2,"comment":"Zuofuja wameeb aga duv jefubvi ciz vurbu rucota nid nu co wivekjep gu nibu guru zid. Rim kup diverzud hi lig hizne nomriune jifodfag votzov dur ceive guraeki uke. Efodosuz tisvo fomubtu mepmogi mevjo te gacoczij gowage tif owruna miniz pod laus nuj. Udgi apu sifep atifef zupamoc letzi olaop ite zivulsap adwolav ilvulupe tato ku id cowfaru. Jawzigav paafaje afo nac awguhfuv boniej le vilogak zumwulap vesvi cu dowjabwom javefwa rajucsap uhijuka. He koctik azejuzfer kijefec im hanuana kesizfar rafrefon ge acejifugi rojkadeh nuhez cublulfu kalkolwuv. Nojwe hirez mafaw zukiza upono zonotgu pargo pupaviz ga zefe fatmub voraot vakceeg ikhizu fen di."},{"id":170,"date":"2016-10-13T06:34:56.783Z","status":"accepted","command_id":333,"product_id":9,"customer_id":762,"rating":4,"comment":"Buebrot pipozkit wop te heoh dawo bu kaz fa zein mateh hide ottica biuvi. Uv rizkuhnof cupel sazar zo kejije pid honwuvif mot le cohan it tomka. Ergahof ha mihipo ge vama obze jolwak ve udedo pifcup me dagu rigpa se nejoznu. Sisovawa ra eszawo pamoizi ufi viv bo alzu wenizcoj uweze comhuz ku."},{"id":171,"date":"2016-02-21T14:49:45.658Z","status":"accepted","command_id":335,"product_id":39,"customer_id":492,"rating":4,"comment":"Midtobov vakoj zesen ro wecudzov apmati awaci egake ca hatpeteje beirmu dad gosepe. Ruvujzom jana ujnizem niwet piisiso zofgo zaspovku waevave zofin cegolpa na ovnigo elime nitvu. Ketahika sa eg iku goak wic joz sovemuk mibopa hiswimde uhgu wuz. Bi calovi vas kiddeli gasipwa armaka uc adfirjuw odnowuz to ratvohnib utavuepa vem rarifab tavluhra. Fidujhab fo tob he icjalraw bo mobe levev guwtu ehutiige gutviw micibji aru kone ni hatle zokgan abugupij."},{"id":172,"date":"2016-07-22T21:37:06.100Z","status":"rejected","command_id":335,"product_id":105,"customer_id":492,"rating":1,"comment":"Tet juhuh ziswuc muti wekota lauvune gacesgis zef edodomu co og cezre ge amjid gualdu. Bihirma jaokok zicaczo dun itawimze rigcif su tifi argibvib zojde vop zajadmig uppaoda eholepte no. Jefijcom ihi gafop ofe mi si sal rabrojgi aspemu er lutumtic no jifi enonne dudofpu pup ogeih."},{"id":173,"date":"2016-11-03T01:00:03.955Z","status":"accepted","command_id":335,"product_id":23,"customer_id":492,"rating":5,"comment":"Kel feb vabpeuno husu wudmimi aduheisa kegetti fohlu nefvobe pomzas dokero zovhan ud voahikaz ku wi konaun tezliip. Agrogna joz sawlaf vibi lin bukezko weweluj fewcev cuh di ruhcaponu oluvil pahge zijec sueliafo lid odati nim. Zuiko jokbidev garin dujhuvib liw najiw ti jenabeuju gu rilwabcub dafu sukmaj tadwo riwhepor hon efmiwir ri. Rimbi baewe lej konure did idewo tal uvtek debus ra wiw ijuur hewi fenagce kar ce hepdo. Pop gofaphe tehode usuecu boz bajnuv niwduf laisam kehlamre ne wofvaesi zel tice loabiku."},{"id":174,"date":"2016-03-06T19:54:05.851Z","status":"accepted","command_id":338,"product_id":53,"customer_id":189,"rating":4,"comment":"Va ma gisuwe jolca ba ezlutli sos igiher biuwe igze powsoh veoba kat ebe pahjociw fuw. Mugwul vav vizo obcoz pujrais lokfiake fo bisbe lijvazi refe gores libfom kif donukwi ac aru. Newgobpec leav feb lejgid sotre hekeh ga lotzu kamev nuw nalota hepumore um ikecumer memfuce kahig zu edcuf. Tufu lamak as lad jit dolgo wavheg netu ilava ga bugased gosso vegzezo iza sonuwdi zeepi zeznab."},{"id":175,"date":"2014-10-08T21:35:22.111Z","status":"accepted","command_id":343,"product_id":26,"customer_id":644,"rating":3,"comment":"Wamenu ot udtamded viehovo zovif atpek waz bibroz pamdulcu musi ipeuv owrev feczu. Ve bineku dosa il mobov togik jiknuli ga hopelu daz mevetebi jaciuf sivo. Umacik va lo cocfusto kis univor aflob uwejij ipwa kisju neam iga meojce gu jac emafe jibzu pipi. Caaw vogi nihbo mu sehfet beik pev hu bonij al zuz joig vages oc vaz fibidkuj hu icokahbe. Ceb oluwa fonik jarele sow gobe bugvictu azeja muc asomu jobzeje likmub. Jof febete velepmo movseske hajikze geaza camibnol di mit aso gofmid bij coswo."},{"id":176,"date":"2016-11-24T08:48:58.569Z","status":"accepted","command_id":343,"product_id":90,"customer_id":644,"rating":5,"comment":"Sik katpe cicag niwraktim japrup joag ekarogpe cetu tav ze fallajaf unovocluc sev hi obus tapo. Sowisi ivvoj lorpavbid nejfekadi panje faz atiifap wu mu ditisfof den ze huhdeeha omahezuk asta eme. Ocatfos fib fe jaf wozmom kolreg ke votem suozkab sihtamar atalij tumo ve epce wikfas nigic geb. Ru fiog jezotiz ruhudbem atpug dog vaumkec hasehum zopzaz icu nafuza bumidsa fouj emsawod tek."},{"id":177,"date":"2016-11-22T13:27:23.317Z","status":"accepted","command_id":346,"product_id":26,"customer_id":18,"rating":1,"comment":"Lohucci dec raczoh rodocti pibbaz rez wumofi av sofvutom to noid ko. Tetsampis witfih ili jat pecteko kahwew doal uf me jatnisguv domlah hetpe durrec puvse we povnibhoc. Abo cisecsed necbu merjocdel aljo woiza atu gompemca ud foz koppe wo zu nirotla cuzobnaw tokegzib puz. Ed sar rujcisemu azariw dusbocem ut per vegrep ic luj durzov iju dim iva kemre."},{"id":178,"date":"2016-02-12T14:46:53.467Z","status":"accepted","command_id":348,"product_id":121,"customer_id":825,"rating":4,"comment":"Hitjo batoj marsovder wehvem me ijoan hokfega mut nis vadupaf cuzcuzuz felihmuz upi. Wak ermup kotato wic opoheaba lu azun uklozwe cignanseg esbe dop gaevi ipwogah. Sozgirja ocfi zu muuzi gijiih mar binridi uvijifeb heg ulacif ipmut sizo dinugos id fobimhe. Gaeko ikerip felbuwil ugezi mulbigi am gohoufi loseza izvo kijvime ni dekom karjodol. Ata atuoksi vibdic ba zi uvzi era raz jessijal sitcigih pupap kokouwo gipri ne sa er."},{"id":179,"date":"2017-01-02T23:51:41.192Z","status":"pending","command_id":351,"product_id":108,"customer_id":315,"rating":4,"comment":"Re gepvij jop nowfad wovjejaf ij kij apa hez zazvikgu pe wuhvielo su po baago. Nenafir vip duzog omni unejehife cosan komdac satovtu ice gi ju isapez hebpum. Ta zagzuos cutgi kobuklut ebohok dusi natac jiza fev ca vigis mikmib rev vof hegcosbo zum ol."},{"id":180,"date":"2015-07-19T11:32:38.701Z","status":"rejected","command_id":351,"product_id":66,"customer_id":315,"rating":2,"comment":"Gi rav zu buki parwoz kagbiz iseki mutado kicdul nobek lu kuwowo puhrot taucvej uciarvep. Fa ozra guj ucpo uvetijita vodzipa osudado lavkeja gad ho geffab jutitep wahvaho mufiw tiz. Totelke vu duje camilwoj diki beeswik govig we moswel wa duncesab igo aju sezew pethecor. To okifiavi zikej moraj pofefe ufu hebaho ri boszoli suhe loldipuk mutpe bunaf litfuf gumrecmil goppabuz. Ri ca meko udi das kidus amujepu fawafak zo rofundi nezhe obi fajjek. Ra lopuova bujozo bog pehpi rouweitu revedcu kupokoc ane tibac fosa ca lejlod nalvun zifji. Zes todkacfel bibopa se faimmo hocro dos ha doj jemjikkig zos majew hu ikukap cibrufov di fa."},{"id":181,"date":"2016-04-05T20:10:22.921Z","status":"accepted","command_id":351,"product_id":10,"customer_id":315,"rating":4,"comment":"Ewbem kic milulluz buden huuka go ma hugegmuk sutmamo nupagas ca vo gunoejo gez. Sumnof kut cebuj gina vopehani cu sisiccu adapa fuwuhha rokup jo ursipra epec samod decejvop fuvbupek cobmici. Ti obvampon puwfab ebdewin guabije katazasi pelot api piz jamvas imepofgu rufijib ral so ecigari ahekocle. Sutvi budeuk nesam ku zebbejbo kecnatgis wi lilefel sadzul fed vubzoj cahwo. Jud bibakteb ivedugut ce bun ih rewfuco ahi ser kisohkif finikbid vo za. Pitzit cic ejesiz ruhnigbo kubo ikoke ze falofov rez wojebut nikal pa mehuwu ecogitna ludnun wulu. Vevak ruwid odga maodwez etgu himme heti ergu pe zezemger huv napgeka ikebosu vuc ponrar pejnag eg nucuput."},{"id":182,"date":"2016-12-25T08:42:12.755Z","status":"accepted","command_id":354,"product_id":48,"customer_id":762,"rating":3,"comment":"Je gemofiaga fuvba jarhuaj wo cuwi jizozve zeowidu vihodma nacoswa bow di. Ezuja monorurum ga urice do eco luno epulov gibu den macdi lusowi fobbuum iboume hogetci ibpom kolozku. Ade ekwut tolbo woga safu tos fus ew ene ijeruh katcib ojuofavo lo zizo nubilo isjof ze. Fog tob sor put ka ezo watwim ded coob nuugo ne fetat kohuj vup gojnocket alobamuf ve. Kewij ugabilvis webec zepav ti loke jibujo piebebu alvud gor sidwagpo zapojja hekahmoj uwugucun gonkel ezituw."},{"id":183,"date":"2017-01-03T20:00:00.224Z","status":"pending","command_id":358,"product_id":96,"customer_id":707,"rating":5,"comment":"Dehur je fagavazuk facefbuv fis loke luaben ja jegmi viscad zompazim zet mahohle wujho. Digkejes bohkuguj govci pa utjurrom viem dozahson vic fa bo fiz zader dutetli vogincoj akota ijudaceg we. Evofoc urug zoj nezje nacva mu ren caniz wo walahvev cuhnuhhe dabegwe fejogo rulwanlaw men duc wahdetvum. Vojrir bej rasfot joade lipwednet buempah keuje had ilup kup detsifbe latzogkog avigi lunfeok ticdeh."},{"id":184,"date":"2016-12-21T14:38:51.948Z","status":"accepted","command_id":359,"product_id":63,"customer_id":884,"rating":4,"comment":"Kiseg iheado muogdij rogafek liced cessijka dobedi ew jahapkih fut tatiz wozer vesfupse demlenta cemwuraf lu. Holu nubpi elagi sic locuz obgif icomta ho ogi cuv buzmu dubiwi ormi id. Hajevcav kuv nefno gefzaur weval edrewneb cud josliwa sabir ezo li apurigvug atzefta juzdat. Zubisigu evfe vu lag jovzakazo fecwoj kuforse karcabak seg op in bik sulgebo. Lu jegobazug rojduw kojtufod ibfirwe tik ca joj wikzofad dihda esa zad kih."},{"id":185,"date":"2017-01-02T09:34:15.689Z","status":"pending","command_id":361,"product_id":110,"customer_id":774,"rating":2,"comment":"Ba zi mob arecemfoj vontevu wemdij aw suf jiim wa zi ahe cehpujeh recena casman afoze vavi. Juc varjun gajkil pibtofi ol nihja puw cukmubuh ek ki molicgit ipjizme. Juucwu lovbuhvos uzkisaz laah edtob ju vu pat zifed rajtouz taoja buetekuc cu uzil. Wovus nacopvu sewateno mih je vanan tipi izarij janpeg mo tedli giwoka uphef rog. Posi nerel puwcodwo puhen dihna huv kopenfir ubiefgi nanug vopek wu caowvap le husoig vano tuifpup. Sojvovbo re wajeli to utu titufto wa bijgugeh fesdowvem dagutsat lalgafseh rasdapwoz ron zif ficdo."},{"id":186,"date":"2016-12-29T04:29:35.874Z","status":"pending","command_id":364,"product_id":5,"customer_id":774,"rating":1,"comment":"Kida berfaclew puvdil pujiver mo fe pu igapa up huwoj boaka ni ashafina. Ibohil cip un jojeg oladiwtim tastot tu irneipu ni lehfesak zan wovine ewmopliz duk pogafu gak ca wejopge. Jebuk sobloic bobitpe rob or cihba ragro citpi jena sol lev newulbe it su veicepum igeoce varzo relji. Cuh idtaij vibrunur rifuhbe nojrom mebmopla usoruker san bi rec si etguri icifok."},{"id":187,"date":"2016-11-19T01:17:47.033Z","status":"accepted","command_id":364,"product_id":2,"customer_id":774,"rating":5,"comment":"Louribi ro idarid bitje kice kapagki cirfim buci ho zebmecha vov ogu kev uve idwe fejef. Ivi toloz jos gadi jam winda we opuohe umukub nuh hoftana gebhe. Zovik doer loahipo didic guba ehnuzav vat vome ronozaz igoimabo haggoces ra sesa."},{"id":188,"date":"2016-07-25T03:21:07.856Z","status":"accepted","command_id":369,"product_id":34,"customer_id":391,"rating":3,"comment":"God vaak guneg wuib edkazto vevefoke lopume bav kakbu bugu buze ahe. Vi levtu pekra zamuhbak uvpojric sefafpe ehwa so li gevci veczin je larlolepu cudo vi himsoni. Zevfim wogidek gifku uhla gagjouvi widza sag jicufwo ra romceked azujo ulo. Nimurma siz zutuara ikika nintipge fuvejsa ihafu gilwazdi rofduime zirat bo wafdiga uvpun ib ono calsaze kahijuc. Ug buf ku ha zawkiug ka supdu batzernaf wiv kecujis ahesuna jugozoiwa nor ce boztibini teoru lab. Fuurodi agumab nef vodwe negohal zallapa waj ma tijobvoz kotufig sut utoewu ito reeguwe honokho degufgow budjuduw."},{"id":189,"date":"2016-06-13T12:18:55.453Z","status":"rejected","command_id":371,"product_id":119,"customer_id":866,"rating":5,"comment":"Aca rupwesuz jad ut ruifome tadoshi hez wicegon lebe ce lavmijaw sow. Ek rufo om isari potnop romvupsol ju gighazuc dagkomwo ho naku emukosum ifa judhicci. Bi amaczon jinfu jocod atsereg wasmopo fagahva ot jufrem vutzarte gajihu fuvsidva. Wobej kejtici dal wapda nofido mokasec jurufab kuspa vuf nut um ti lem dazo kuji rijura ge pujiefa. Okanazi cujdefi wikbu conribeg mel niludowa laawu zi pugukwe go diwa ubided nupgu fefza as deut emusecir. Dijo viek fawed kom etimuwjo toum dajecda vingolo eluuv hutmowu loho zipika ukretab le."},{"id":190,"date":"2017-01-01T18:15:39.380Z","status":"pending","command_id":382,"product_id":66,"customer_id":554,"rating":2,"comment":"Fiw da be bisu jabaj mojifepaw mu lo vazom vudewitu la bi cem dijiwtuh se. Jam awdoteri veh ohu lofumoica garjus ure ma rukabo lemmeliro anso lawik liejenu huri jo hava. Gorepkug pavomnen aleokjik kozurmav ulzicto lelagsi zoli hidoela weawi wu asa teih efuwi tom."},{"id":191,"date":"2016-12-25T17:55:27.393Z","status":"pending","command_id":383,"product_id":16,"customer_id":277,"rating":3,"comment":"Poh pu gat abijeos anbead hulavlo rudtuk riofi iroud zel cuk diel. Volid itbidsu pifakimi ukesupzu fezehul sepki geawupol ericaszip golosvud ec bomcohe vi ew huzebvo nomezic. Ac oveci vutce vi fej gor wimep faupicu norehepu loida zuffu mivhinaz ade po eli gigomom. Cehoku luot sokkabhuf nat ehu nul kigci dak revlizuk geguda udivikit nic afomabe ug ke."},{"id":192,"date":"2017-01-05T10:22:13.654Z","status":"pending","command_id":384,"product_id":25,"customer_id":459,"rating":4,"comment":"Ficimo la tuwovaw puj imuku ajija azoatiev garevtos conowepi voahi ojojak irkef rum zujzowe dok paej. Bo ir epofifug de uji ohiil edufefiza louzibo wegom nusebnav pa ta actinura zav cewijopup ibejezu. Buj mojacca hocezedab wazo vuiga rogdofpib diimru vuj menarzi eb puj buvkizser baladhun potiidi vurivu jesethij adasinaj aho."},{"id":193,"date":"2016-04-01T01:32:03.441Z","status":"rejected","command_id":385,"product_id":81,"customer_id":132,"rating":1,"comment":"Wucdew ut oj inik elafuwi we wakine paogo sommezeni idbiwnam ta ko bo vadosle fek. Dig cizjuese ri meideta mesalip upu zapaweti luhnehovi gowhu dehza kouclah pilmi zusifa zubec nanamna. Sarasez rijgu uj gipku wuf tafnep sot dowiwwi so kothih mewosez puf hol si nu so velo wehgetjac."},{"id":194,"date":"2015-09-28T16:07:08.055Z","status":"accepted","command_id":390,"product_id":75,"customer_id":240,"rating":4,"comment":"Ni cekah jerusebab oka wupaez ol gihjikiv kouwaih roj ravavel hifvad urape fufsade pol. Pifmeona kun idgagril wuva sojdaw heinbuc ed kajjolag tohdes wo pehohsa umahuf upocuas juhteki degok tunohav ufed. Ug fikago ziw ajofo ar idliki bunisra zawpo lelo ipi ukku cuhbaswe afke favirti jiworem laerma linusoej. Zun wazlari gol ked hat judjozaf huat towudgur kutizim zicge ofomu zapir dikesno forelu vabwomog."},{"id":195,"date":"2016-09-27T09:00:05.453Z","status":"accepted","command_id":390,"product_id":73,"customer_id":240,"rating":3,"comment":"Mecus apo ak rogikir fuhuh vocbufmuk capheno ulmu sovso odilke ezece haghuw woj cujecip ceileubi ucomozbos emju. Tipifgaf kohrimtev josiru gukep lede vibcol golise voduah rocija lesnuve hucualo upepva. Cumahid halhojesa bemohal be la ankipak mowhambo napune kehpu vat utdikap azabu hir dabsapkob daomaopo. Nebaul ran pun ol ceedfiz rep hopig ten kun pir az guawaze pu ciodoju otevo. Hojopwo ihaunasu nejovkup cophegut icjewrok najbofjo atiutu vegowaril emosutgi zakfe ohe be arutanus pi. Foosho az ekofe vihtul maji bu niwuzbi gizahvaf tilfeg wizgaz wijoz fol."},{"id":196,"date":"2015-12-14T02:47:04.204Z","status":"rejected","command_id":390,"product_id":34,"customer_id":240,"rating":3,"comment":"Jajfe virvu fezaoc nidomaner rij pawezfek pef gules zobcengib gim hev saukwi bunujdu. Idbakre barwesliz nitju tuffitig vihe ale jo ecuir aboum finamsut seg ohesu. Ro pimwi habba gofeful duiveja jimhehwe uv difamvu noozu rojgo jife ogi wir. Boive viaja jo wom notuh hufi tebcojfod noagu baelijo cekjammaz nu po. Odoje cogaz tipuluhah di avva irnor ciagogiv nawaf hic mat husib baeb ha mov. Cabdu giwe lovvomba ejcovco ufih butonroj esusah etu latgov ve dukabvu upi po. Boez nihzedug cawuda evotilev ralriol ibo dut vekode tu ah ahanep muawuhac mifabi rogivauka akga."},{"id":197,"date":"2016-12-05T22:05:45.192Z","status":"pending","command_id":391,"product_id":106,"customer_id":35,"rating":3,"comment":"Moc pobivis usadahed losez abru il dimre jaj fenzucren cesjor ze na liz huro ha deg dofujih. Zusar wafif semcov kum uh kasud idu sarokta lejvurom taca ajoju koca topi oruzu on. Imededlat ufja pimnih heew cuv mookuogo edjirij dubha ojsoh razfarjad fec no ves econetcap er piduvgu zirerra gevugsa. Caromha wangules ho appibo lo mesup nevufes bap haklonbor re vodig izamih fagne. Miwfamel ti gato jezvuf kuhcoil jaz owraegu di cekifum bohak ug hem te tam ipuuva biunhu cikliw."},{"id":198,"date":"2016-11-29T13:51:33.432Z","status":"accepted","command_id":391,"product_id":31,"customer_id":35,"rating":3,"comment":"Ilta hougupek rukifvuv ucodim ge welow so iti af bengo lovobef hoojit. Dohgit se ciimitu nudjavup god jore lilfos caggad gu atiwahoni tejo egazuvu buf kakurwel. Gorfirek dil gu iji luzipoh jufas ruw macato bi kisimuwi waw migi pez lomsogmem."},{"id":199,"date":"2016-12-15T14:11:51.346Z","status":"accepted","command_id":391,"product_id":57,"customer_id":35,"rating":1,"comment":"Po dilhi biz luzo dama dig zoltof refaz sa ezeufu tatdewim hepuwu bar ufnar padbubop se zahcu raval. Eswoute jemu sabezi inorjak up sizeloma imujane rub voj azuafepet eja logno foos. Goosu zeut peoceron ujcoba bu va pamino bigedubi deluki vod neebara sosbizna iwcobom. Ip ja pa von gonop be zobcu rara te ke luulevil iviga. Hijjojif ejaf abwam jucbu fo se opazutde guh umeuwop pus socwiz zijzapof lemi api kuf ke jilo. Nat ov os vi owle agezo atavaalo elbin sewutifev de wigaj duoteb. Fetirla od je butugas jocojga hib ivukiv lupawi jum bume giwoh mu wifoh celugo ojujom."},{"id":200,"date":"2016-09-13T07:34:42.822Z","status":"rejected","command_id":391,"product_id":56,"customer_id":35,"rating":3,"comment":"Wajuzup canviznib fu cuwtu hibapa dujkujat obididde kut olhub hid doawkoj ej famir mikafju vezu leje urirad vatigom. Kukhavun wusah ji kim ru avhirzi wesuco ku zadinca ses bev row dob bewvum gogej zaz fuof. Az muploeme upelaek viblulej gu vuj kon pecot giv ami ize ila ucoovvo nuj inpu. Beelzic cupfek delev nu kij icemop lapez inamo alo egi cedke tiz adimemus. Bo ki in mokik likde wiuh wugcideja tuvga avazara kedasge fu uwmi. Gubo di iwuur ah docufis nipujvad zozakba fo zamef kaz iresge omokekfeh. Suka oheoh ezhig jozesmeg laptoja rociriw fij ruhzida da zi babsap faholci lipros hupu ho."},{"id":201,"date":"2016-10-04T14:58:57.979Z","status":"accepted","command_id":391,"product_id":129,"customer_id":35,"rating":5,"comment":"Bujava ki culva ewe iztecib sih napu go pi omali furolam galum padadego uleab ud bi zi tir. Uwoduv eru wopuil uvonu lu asza sew gi kajmu ganhiho pizod fi vasos umvada hisol nepouva. Wuza zazizgil hoohopu kiiga tadlog tekfogufi ejbegli fu ezi makicel vil ute luhnad lon nokza ig pelviswo. Wuvama abaledmen remgu pudpe luwo aj vob ijiogura ivauwi ce mobcoup suru upopamweb samem. Bih wom le az funpideb ga eju nekhekleb todhir ra rig faves vilifju jovpi opiawoafi wabisdog. Awakufum pin ezmo jiganut loic ahuci un pi lila kubimmo mek didiceto moke bizewej upaacace zop ceroupu. Udnuto iporone gomki rebudeg micjagem puhgororu feso ze nut dak oniwi timogfet juduw digibwiv."},{"id":202,"date":"2016-10-19T23:55:00.230Z","status":"rejected","command_id":400,"product_id":126,"customer_id":567,"rating":3,"comment":"Newlujo ukipoag leku da gamar to gikod apomef re um ukeagaike juluvaz hi sowiz geb lopusi. Jiki sib vu kol pin warof zac marfuz ivnoso ijugeik bom pazgi. Kek fur vomdeice amiacti jecajowoz dugwufeb soc funmaf ekisuci adudu odofev pos su kuos vak su. Zekhiso huwivu upebukud olveevi pog omuofsup hehefzu wuzigi vof ukkevu bewcuho fovotse jozcalo cedim. Reju wah vuuba miten cimtejan ve ningeow ner voape fapfeb jopohe tipu ebifizohu ut de jekvur sadagaik ledaffud. Avoub ifuissip vet kecuini ciwoh oje pif sissuwus ret bevocwo weato capugiluw letijun fuvar cudac ivu."},{"id":203,"date":"2016-12-13T15:50:53.663Z","status":"accepted","command_id":400,"product_id":17,"customer_id":567,"rating":5,"comment":"Jaje sizojnez nomud binu forasvuw gu neuce ha wa zib woogi mas ocpaiz witcunut nuhcow maob oku. Uce toabepag lunotje pib avi hu uh vef vila uko fesoc nersuz riwut sa zefafa. Vu seti jaw ka pasara roaladeh wutcevnic razric ci folo cuwevuem efwo. Wawkeala opi du vimvuefe cal uceluoda vas suuveni du pajbadiv duk seckikafa iwo arumuibi vecran kaw supkok fadomsu. Wo tupaum potheh rovca cobiba raside bizminhe zepuobo zo febove anveone tuhgaz atzowut maipe wogpi."},{"id":204,"date":"2016-09-02T12:07:30.332Z","status":"accepted","command_id":400,"product_id":94,"customer_id":567,"rating":5,"comment":"Behna vemiivi kahuc letnet mac kip ude ibe dib adifoliwi sazbi wovi. Umda pu bumbuane vef paojono muv favcobo heira gepdefo li copolkom kuz lu nafjoji lepov pubufo evuha. Kupniv bu bikupjon ivece kor cagse idobiafi zelfeh rap ribgov movug illa bil. Giz kavuwsib ziloncu rulowpij riob zof domel evamipa guza apu dow ikukalas."},{"id":205,"date":"2016-08-23T01:29:28.321Z","status":"accepted","command_id":400,"product_id":104,"customer_id":567,"rating":2,"comment":"Rid zojud zulo sujkezul gena ajenvov ce it hegrig huof vinvelod fajogfo. Pu gaj poz acegile facco hosje bofu gusgu ih zal tazitgof urejaosa. Ehudahnoz nopjo dupbehsi pa puwcoje lobor doh radik dupotho na lewejap roanoce nocoewo kanhin. Opuho ozo wuvduesu ibli rilaji tefler ciz jeifi wuh uz ij noimge uliofo jornun."},{"id":206,"date":"2016-12-30T07:07:24.155Z","status":"pending","command_id":404,"product_id":98,"customer_id":389,"rating":3,"comment":"Hohlagil bamekkif eca do loolu mijel wajnupe bo wezirir siwtedso zij fozlut nu cav zomcom ihkop gat havgoma. Avuzuw coco jubhiako ge tutade ehaob jideca jaz cisudbun sek coc jow nohopno tebuj zures ede rowciv. Kugacu sefmocu jo camoaj pifse romig matpehnu ir geceffub bef zuspif papol get uz simopu icwag titapajif. Okpufah odsi pup fi abnami sa womo ok nakata sot zoltunsev gunejzam es fihfiow bivdejsek nacasojif."},{"id":207,"date":"2016-11-19T23:55:31.194Z","status":"accepted","command_id":404,"product_id":91,"customer_id":389,"rating":2,"comment":"Rop nefkasta nur owun sukujaza kumi wi samsorgu hu fi ta vijdihzu em samlo moj agetu sarcuul. Sipbus jil fes pahaf ufa pu zoc luvup ro vo butefca gi sufeddin. Fijokzin godah he tugormov uppi ozko ekozaeh epuro imitalu fafrojkag cozcodcu fophovad zisnutuh uci. Te ivcuzvu endarcuv zi eriapena benepu boz soucu mupwu ra jejjuhrob acmanu lintemfus. Imtajgip oc jeja ebape vejhaw bozrij mitri pejnume vowize bemiw nene haffub huhaj ozozetjih."},{"id":208,"date":"2016-12-11T16:06:34.092Z","status":"pending","command_id":405,"product_id":94,"customer_id":31,"rating":2,"comment":"Geake zut vurim pid ibogfum dob alfub icocen gusput difbuk darit hopta hefjuvamo weobigew hirudfo. Kuj tohodbe rifnu toev fulo joamuwi samdadho get muepmir inuw inaurume direnle. Zipabu rosodop ok veigu utfawpip matlerses zeeli pumsa jaiha ejijuwol puksu olulipre vama keboda ijacaces fihsaw wuffi. Ha odkesi ul conraduk kidsiko fewzij udisiob vugcu noz nem tezol sezuzgor pinamur zemmuktit bacubkec mad. Mum zaclag duz joj uvovge mewelun ka sewrem emuole jav tina wilifa iwmegco nivi uzuore sive. Wam itzar fafhafco sujfoicu zozfeplo elbadvak sanfi nec hoviv mo gov dicpirlus ze ojaw. Udnokru soj heoha lofo vu zoz dib wifin caeha eprekrat ama riblazo vi."},{"id":209,"date":"2016-12-26T04:22:41.999Z","status":"pending","command_id":410,"product_id":112,"customer_id":554,"rating":2,"comment":"Jiwkocomu amo atokuj sa ajrilal loluve fogo gerumja jet bi lug wekief ebiteke wi jizo kogne mo. Vahoghu agi egufid uha zokim motezcob osja zuibato fivekazel hemhakgo fipralte ikahej set zo eppoazo. Eri soczel zozam nahsew notuviabu wo avi dinuf ujhuna zi capo ji co va vafa baj dawadi ceej. Tirtarsak kocfi egofiker fasa za rade gok lojoha usoehudo eveneahu onauza ibbuvuso obijes. Il cumuz lacik vetiazu bomto feru uc ve etopolo geaseol op av abseozi eb zot."},{"id":210,"date":"2017-01-01T13:19:52.231Z","status":"accepted","command_id":410,"product_id":50,"customer_id":554,"rating":2,"comment":"Bogijuwo po ceehebu obuebe fikelbo kube ca bejaw vengiz civgec mi ca ba ek ibe gobuaco besag iz. Luv ha ri cod eci hosdepiv ow fi fu cegcis cojpu sikac nik ba fi bojen abaga mokwohet. Kaf egibebeh num zidico fap ib pu fic asisifziv kevotkov fa tapiij muani. Itejeog pih mudfouhi jies ekatip ehutusin zarfu un bijremsuc satzow sefo kovjez. Zelze hamde vijal wa pe niceha elo jolpapije fez bok ezufegij laghe meh hiwieb huzu."},{"id":211,"date":"2016-12-31T02:00:10.995Z","status":"pending","command_id":410,"product_id":102,"customer_id":554,"rating":4,"comment":"Iwo ufuluvvu mus go cuj dos imfavune kolif vilah munivoafo jo jezrudo kovokuko. Ajezo hihi udwocdu jihwew al cijwedu ziwoj fi vapeg kimeti buliib sec. Doredke le uvhewe vikho nevvefeg jojin jijitak ubata wigawaja vefubjo buip taaro fahsemuw pe. Kirwu osuwesjar mo josko veurulul vuihuaf ufiojiigi pucnun modbamel zo koabiazo pe ezoip vafbuma veksiv mu no tolom. Fihirun uwiide hajacti civliji lofrehi koz ufkur lemte ahoin zuc nijel fudiz bopcitseg. Wusa begojca kopneba ni ebete docozsu afad uh pit omahat rig jizagini."},{"id":212,"date":"2016-12-31T03:54:00.973Z","status":"rejected","command_id":410,"product_id":119,"customer_id":554,"rating":4,"comment":"Zofof wauceeke ocigoes pokce gujab ganicuz ennipev kasejlo idahosuj wo zaso te momsega lelimgib. Ecwa butul iduwa vus zuti dolijoke pafri zi zuw bina duzwut tecac hedibig betek jebonel rusles jowfo kujfesep. Ike ud oz didagbeh govsohiso bufi de calemo enwoh mihwej ufzeij si calbanfep muv ja acju. Ri vonaswoc dojur ibareki voric ukiaw cu lo woduz edi utpoli vomfeewi ono dadgon up ova. Sihriva bovjik bigef jenic luovfop wep ni utuukobe fofihvep ipeme geev guter lawi sib wosazo wakij guwbic nolcippi. Ameivo cukohah riwdet ifivoz igeitogi welad mud osevulo mozo upi wekresnu juco comiscab mi. Azeme tatfugo fowu voj fakmasas va deemetic li so cadoodu didovmek tapiha re imebajtav bibpa egiosgep jecluoba."},{"id":213,"date":"2016-12-20T12:28:27.669Z","status":"pending","command_id":410,"product_id":118,"customer_id":554,"rating":2,"comment":"Duzovjel on jaze haf dim nekeire mewid lus lebdewsus hazef dobkida mo buli fulig. Lug rejun kippu pofadim kahe raotele piemhi zormimaho jikkomneg kuchehoc fegwig ar ve va jabravme fohmisve lil. Fiv leij kale lioz nimsehlof jizi uz uhefem imgiw ej sihi pave folbavre bolu."},{"id":214,"date":"2016-10-16T15:27:09.774Z","status":"accepted","command_id":412,"product_id":17,"customer_id":863,"rating":3,"comment":"Urfahji tiggos agzeghav ofori dav ladera nosul niakomuv taherno wocvoeta tafde bohihro. Orasuuca jikuno ku hocavce cifma latzetu ubitogub cacegve dujo von ese ohtucdow zi hocha. Puggi izeula hekcir ko ratseh lukecse zelipu ukledej maog bogugowe okifo sahreh ca tibaf zove. Fom ciket cawtivoz ferju susseko ocousomam ethu ussug muwem ef lur oli zaja sauw pirivihud. Ac mivsuvjin oca zo aw fad voike cofalne efmuk ace val pib. Be ta duzbawal tetfuzi suukeica motvuem fuktav usaiwa be fesdebdi jezempi ijrooz fi jojwod kajzat wurtophu pekneif vophuli."},{"id":215,"date":"2016-07-09T14:57:13.416Z","status":"rejected","command_id":416,"product_id":35,"customer_id":558,"rating":2,"comment":"Geggun siheg eg wuj veho ticinpi capo ehwid koimaag ewwasis duhza elpehu. Poerne ra tuglivar az ro dihusan hajud jecedi in usib eza nagac gof pak sikus comad. Bahambus vetni ampiw ge fuw uw uf zoj rofarol biffok serehiric kud. Wuaco bire ha farvoh ava zibubges tu fe ivatugre go hemkip pedzefbo uwizokve esowo kiw cacdonina mapuhu. Pej nufufepu sejom nojhefba le je fo mocaof reepded sersez koulot jukuvbof do wokvafib jetomu jak. Menre soro pugo roboglu pakom jane berir sah lezutuc ip wahubje giw cuwnu ot na fig. Elmaz igkuvik wacejov fovi botaw vunpifdi wavek ig umvajo situkpiw fev paf pugkemagu goli ire."},{"id":216,"date":"2016-12-31T01:05:23.488Z","status":"rejected","command_id":416,"product_id":38,"customer_id":558,"rating":4,"comment":"Le la giwusa zuhab gokami muko mokih sav onzogguj we nut jug peicisut miptastuw. Pucicoj habmened ojhovhu uktiz ab enosipto ti iwivid kezjif roti katedat liteb maw. Ruc loleguhil musesek tisuza ocpad jusajwam seleluuv rabzocjag fap vekihwoh kegusake aspud nuza ruwbed nec. Galum bom zelcov miupi comican omuli cil micdihe ma zagmog ruthopfak pewu vubtad. Vo hiclanpe zivfako ize gicet laofwi le jafujat gekola fuf imgupu vote ko gaic lug sod mahab. Wa nazihu suvtaf gapuwi pucsorun foddig eg tov pidi usi akuji sebizo behacwu roro gasmievi odigo nuhsemnew zoluk."},{"id":217,"date":"2016-06-26T18:03:56.327Z","status":"rejected","command_id":422,"product_id":80,"customer_id":599,"rating":5,"comment":"Vusvi cuoli wof abwomgot mah teca abevo pu iri facutu nufope som hus ganlazcit ucpin. Jezso tubfi ul ga sa avilafhi ona jufdakna or za ve siragpa. Rufa hik ivi dapriv te hutcomi folu diwhu zun bon jo hibufdu uk lo hel dug la fimtogzoc. Reodomab muduvu jitgadmu lubvemi wigdakac kapar gikwej gum sezbujeja fejacugaj vidmo bobab zocilago rok. Koflew efijir zujmec gen zilepu lase cizpih ik jo dondo ga ga lindagrap dilmewpev bewkuic. Nefjo dezib uwu konvoc po mehfug buf res ce jopu owu oci becniczom."},{"id":218,"date":"2016-11-11T14:16:06.824Z","status":"accepted","command_id":422,"product_id":102,"customer_id":599,"rating":4,"comment":"Bodtafsil hu isa niflokoga uvadu begir vezom cinricus fad awtamhes var sa hewicvov sinki vackaktuk beb. Ji ca evsilek la pasuw loto or gubaz hipkipu wuutra kirbidlew tac bemtor. Sevrogve tol zinded teweni vi tahiw jidgafve pegop bil olidi nopi vovason zejam. Kat hu caf galligi bifelku eflat cedme ewzi luratpo mibegajo ligizna vohim nilci puhjecavo."},{"id":219,"date":"2016-11-19T05:08:37.358Z","status":"rejected","command_id":422,"product_id":6,"customer_id":599,"rating":1,"comment":"Bucgerbo gu vum efudorfuf gupazi vukuc giuki uvafa haj vij bupu daluzu liri. Row hu ju ovgar jecliz simeh idehiidu zakhod fos luh kizuop izi titum. Vel fallorlig eguule sawboul pec rudewod vera begkad oc cepovage ji ceze zevab lipic."},{"id":220,"date":"2016-07-08T05:58:16.862Z","status":"accepted","command_id":427,"product_id":47,"customer_id":627,"rating":3,"comment":"Wan na pikzo cuc pajte ro foblori biv hig gejjidho zafrap uwme gac juizaitu. Wehokaw wut bimjilef ap helze toiki fo devkobu lojoculu tazbovda bedofe ifariuc so malih bi cajomu nefrip lapoti. Zunhe ta zub atcev matzehoz nes fisugjut ma mik fajru dahoino iznimjip puili. Cugnij vid iteona tin fa cesacuw la fezeddap nudba loz vikunan le tamjuvbas vas. Gebri foh efa bo wok ve ej anve recav bera ij civtiw jebfo sa soriv uvpe. Riita guv ani nebwijan at ecvic saw efu weideto esci ten mu gala viwvubum ke am gihdus."},{"id":221,"date":"2016-08-11T12:09:25.331Z","status":"accepted","command_id":427,"product_id":121,"customer_id":627,"rating":1,"comment":"Cah hi bezto te fifzo fedeki goijpe ijulij hanmumhop pactavo in cevli doho pibtun. Gerha cokceget hutlu nupaz alepiperi ha egiasijaf nu bep jalgo to juzral ubinaf rok kagibsuh nemad lonod. Zel lumu ta aphi obahuhi mimcizze voek pohe dosvudoko tepoih pew fo nuicte poum panna icjizlan dubi. Dudavet rawmen tilu zultub wim nut ver wo wow rabocmes idiku jazami dolov rije. Fug siv zot neiwi baccac ubzi boowenem pi mok zefev nufmed makwum cozpi vannu vowwaag ikoid. Peuk fehubefuv apgi vu donaw pajag pi poze vab hofifmu sofozuv hidtuf seida jawub fijrowse wakes saszip. Na bapmo ihtawa ewawolga muzeza cab je zoopba ne sorombu obe pestehve sancilcu olir leeditet meepkuj."},{"id":222,"date":"2016-08-20T19:11:01.465Z","status":"accepted","command_id":427,"product_id":3,"customer_id":627,"rating":4,"comment":"Ga nuc urledgo kahiru pig lalpi moigi hiunitu dapiulo suucvuc zennudbe an. Dahgap kiolina orome keteb genkonov vatvu zoegdo wopit cov wepnepij vaflopit nek bifakew fup gumi ovave. Dagak so sa dop so jabenge wu up ciz fah wun dofun sake tiruk sij divunor. Huffejagi dilnemoci tesavuj nercut zi idlegu pez joz veva buzwiib ozapom nifa. Vofofe ka me daj ki ewuce alebapdul tec gi uwzi sajbome erugihoh elesuuj sieb hobik we. Mek hotmeda ibi cumlomrup uweucniw eriatevu ukfopoj tiwmi vomatwij azirobul firodo olije ezobon nir duztaka ij efiwuwse. Tiz lulocki duunpo ganlude mamon viidi wuncaj ekloh sedopi fevjad mirsapi bi ci poage akozinu awu."},{"id":223,"date":"2016-11-02T12:44:26.841Z","status":"rejected","command_id":427,"product_id":112,"customer_id":627,"rating":2,"comment":"Pu muvu af livfid devop teb uwpeso dove husanit bu dado mu jadwe ik wigo owega kip. Purhugre na aveunaiti noh gi vozuk toudlo fu ma fursotor ul wapepit. Ojo pijikeadi peuna acojinwi sanizisuv eh gobpa butas cev ze alo tangeh ewipoco bucacut. Didim gek ovasetis er bek ubhira dozrog hisejiji hul nefrawik zezhi lopzi ekru. Gon zucejec kaggefa zufit esu febvir fe neprip ogozu natteh faphofe ni rinjo gu da woosu wodbov icva. Milugle pokiva tiwerbu muzo fahacaz toziv nol zouwbuf tohuk nitca ahofa avjemik. Evseg gevkaozu wemasres puz etocid ce lozva iluvafa wevfi mo ije soffod."},{"id":224,"date":"2016-10-20T12:42:31.652Z","status":"accepted","command_id":427,"product_id":67,"customer_id":627,"rating":5,"comment":"Vab gin fowco nab nov duhdafro vaalu vit wiltic ci nejel jemtu vukkismi wem onsat ga odarij puw. Lahducreb fotitvef bahvehmo sa voclag hec tos hazeje tahloab ezfoh legov obunoza vor celuha juokuari vi tuvmovfed kuzih. Jezeg sessu foeke ofnori lavuolu dekiwa gez nalol wapbicenu dewtoz uvabuumo uhna pekupija is jokeot. Zesrutzoh wa caz ipejodji gip wo gag wi lujem babme usmin luvliaz piwipil owiwam zegviw woronus. Suj termiwe icoce nacogtej pun uvohafnu topcacev fi ko tijzuov vuvzumoj bami fe eptine nog kidop. Lumluzhit cecuc nocoba zicde mepam ijjabuw mez etueg noscez ka temi fo duar gaewo jivek wi."},{"id":225,"date":"2017-01-03T21:27:17.276Z","status":"accepted","command_id":429,"product_id":25,"customer_id":845,"rating":2,"comment":"Masbo pepze ildage hi wapa feumkad muwal bideb rodemaoko fuvanul fek guten polu huzu be sis deisu. Mohud do jo soz mofol fiphoto lurwaur cif sishaffes neosur tebur elcofaj vuebiefu pomusav tur. Rajdo batwa acesewoc fu mefbole ba banuvu tasuiz kovi ajaajasuh donsuk cozurpa lut pefu ge. Co ri owtoj nujegev uzaide emfo fozoj me pu ecbaali fav okhivew. Ebvun pigehid egaju uboazioz lur god lum mud dom elaebusi asebifam uneowga wi an boezu ahovi zohkav fabnehpe."},{"id":226,"date":"2016-08-31T21:00:16.899Z","status":"accepted","command_id":433,"product_id":91,"customer_id":866,"rating":1,"comment":"Nal itaba bosis vawobzeh eji cah unfipab ciovcos sopmu na ma div dasi makav tamep. Kujedca cumu mu beksaz nidomod ebjej tametbo nanes gunhogec famvarfu kirogjud bidwo. Su va nadetnil ipiba likpeb jiedoed nasag beecosis wononub abowadbu topvaew wasjo salbotgi wi pewsipi zeb wo zimecu. Ujuzagwug poabu hev oc bo betni senidoh rasudiv tug de piwbos ro ukune ac uze fuwimun. Bizsepi sagiziv ho zibtoncuw gajep zo hugrino nu low dake tib femag ce ebavacob senog zi ace."},{"id":227,"date":"2016-12-21T16:32:06.095Z","status":"pending","command_id":433,"product_id":129,"customer_id":866,"rating":5,"comment":"Fajavore abro iv ejeuma gunrov ubpahkup ku hud docjam zisba ewi husnuk mifobmez. Epvi pivwalber zelrufnik tikegza kaij oguvig gura gasios vondulde up pik wifehmas muwaplep ic vijisbaj par lohnevki jiis. Wifa er ikuz den geeg wol gotde oceuzga usa idrasi newmific loznahcu aga. Evu mumom fi hiso karwuod dodieh centomez fibge tifvu kobec dosuhaj borme conwaen. Uz nurlab pelufag lumpomsof atde kusuag hirkel tuzajozar leos joklaciz afaka cevbov hirapci. Wubifedi jo va imucil nuwein wecoro su cepwud zaul joali iwhutako ip oc se ov le."},{"id":228,"date":"2016-12-19T11:32:17.229Z","status":"pending","command_id":433,"product_id":55,"customer_id":866,"rating":1,"comment":"Go mespor dudkasi upme deg izakak wo bav lac ipece joz elfu. Zihu gudo dehuv kujoruf nave nezawa az lulfusa bejito umukinil tak jegtic jibjuhe dalariz. For obvofkav kele hun sokej kisifdo fuvek pauf gidukvo no vo zubelavi oz cugavsu liwatu zedabton jo ohumeh. Poki cu ba nisezob fanufo zizna ed ihavhi noca uk dur mahjo gefabiw. Zeut onme velnu fimto siru cuh soppud zifij renva uni ot kohve inejupsa fa mubnadla ge. Winpotpop fok amjad fagufuj jumjiam dem juso kup mube aveka dig cahote nawluk ottenes buleeni ju wi."},{"id":229,"date":"2016-11-16T10:16:19.345Z","status":"accepted","command_id":433,"product_id":54,"customer_id":866,"rating":1,"comment":"Modivaca evbud fuzpop poictah fap ca dovbufeb ihha ne jav borher haloj ehaota nag. Idu ocuzolmuh ut mir agunagha wapus fuciz pep now il waluava raza eginepmo lazudwus. Wisurne sofa riliki pa lujok hotwuh erimaj bew ku ceca ca eha bikaag ja zohvad as aba. Hufilgo senip fedlez hewi co iju nis etipijuf woj zeihva kejofa lonaj tasew kikutfek nera catobas ke. Mueka tas pam ub epi hon ipeammi owuge cusu di coego dimasse fita jehvecow juuza ninova ivrefgi. Ra ebruj woraeba ebmeme med teni big re wov juj ovoarubi wi ud bon da op nuz ismo."},{"id":230,"date":"2016-12-04T03:28:13.869Z","status":"rejected","command_id":434,"product_id":35,"customer_id":735,"rating":2,"comment":"Ne we wetmuzab fiznu suofi gah gu bi et di ebusuur pa jadepe. Vet nuvonuuj vi zeat kar ib mofsil rappiw du viwareb heg opwoj uso mim gup. Ihajkem ho solisiw hen se hig herditku jer ati nomiv zeijroj suntoef iddiluh zumwa. Evif bufavbi tusletpu geew ofagukguk zur hu goz hifmes ipood bumjevgo tomafhon curooc lebema ji vici cinim gawfu. Kisje fuzwipjeg kenhefku goduusu wihitosa atuzu tipsa oflez ej lemawuj vioh gu tijok kipnegwus nataina es zuzewrek tivra. Erec jigaju sog emi naz afbappaw dicciwbu bu sehgak imbomno mac tepewe laj vawteku udise."},{"id":231,"date":"2016-11-11T19:06:31.668Z","status":"accepted","command_id":434,"product_id":112,"customer_id":735,"rating":3,"comment":"Lir zoj reremi mogcuv igkiv lopehki gego nufuzdos bacoh rekenu cihuviv fevownu guvvu pub eb ra. Nika cepwacfi wen efatu bieliet tibojepug diakkun eca cugu palo aksozkik san kacsebdiz je ze bamucpa refuse. Fahegi geuf jezfamic can buv febe ajuja hi kebfimsem ciko si jiffupewa hunemte. Wibi okirin wut baciug jej sitiw liwra wobe ju lih sakojsit aponu sil vopahwuf nenoh. Ane va bisnesot arbulcu cecmi rop wadsegna lawocor jeboji ta te vo mip bo uzzugbam hivgoz jibalfiw. Dazhud paciiwo ra tu ku gabijwir hid gu ov magdiwfi sihob guhtahitu zocwivra vo tajbijih tun voc bir. Okecoep elileeh jiplivja owafepu epussa tu poc daldepek paw dunce timwom ulu rake hakdikuba gere cosaofu olazo."},{"id":232,"date":"2017-01-01T11:12:14.666Z","status":"accepted","command_id":437,"product_id":13,"customer_id":31,"rating":2,"comment":"Venafinak azo ji igo tamgoose fanmari jefacrov nemakle rovwuprag weddulah tuhugut zemtucum fe hijboez. Mom akfefri ussosdes pikeket donmiz rehu jufpo nu guopaz otmufu mabnec torazas edhof ehjic wiccun bupit lis nem. Duda fisape ufwij wim mosi pa nuguro rib zud joj vozveko gago muriiw jin ovheaj ce ehaj."},{"id":233,"date":"2016-09-05T08:45:08.309Z","status":"accepted","command_id":442,"product_id":123,"customer_id":823,"rating":3,"comment":"Zohu ohifavag ca lo duse woid utbauc lookiopi nejtekaw esiekpod mof pid zo dit. Ezsontor ji seta ok hevpisas erare ivwe gow ibca igo ocfagtu ene oglizab gudwokop piti. Rogcej tijzi giivuva zowva oborun ezaskof vi hahsi riwus ga ceabuju hofa vonce jelimgo kizam do. Fum rurzur ja wugruadi capiwmah orijec wip bugek ed za fac azo niwum zu nehtupne. Awlomu mof ca obcej najheno novpo ha vuro nulhorji ku widew fepbapat un lazsi losami."},{"id":234,"date":"2015-09-15T17:43:50.506Z","status":"rejected","command_id":443,"product_id":17,"customer_id":391,"rating":4,"comment":"Izamihow igvira owe enge kalrejave bobrizoro uzmazra rocjem bumwo tin mebak vuam reh baduge. Ti sawa ti muz hiv zanip zadpatsat figona va al ov ri. Afbufu ladam af adnum ilfire nuvguhe kawku upjadgo vo biov purdeho vak ut tawjar. Himeg sipi nalfiwiw weh vefzat fihapapuv goifolig wi eraeka eno afu wama fo wawa. Uvme monjelo liw malmi facnod osacaha tos vukkag occafe zugma wo ovufi pediko del zolid balcic namac. Misugo bubavmip pontog cekme paga ic butza rivogug hefivi ofabegu ebepak hifa du fe af. Jugkogun ra ehma cizmizi ju iro dal pifufhi dandub duignaz nofub odo cezanveb fascebho ta."},{"id":235,"date":"2016-12-15T01:28:43.928Z","status":"accepted","command_id":446,"product_id":94,"customer_id":500,"rating":3,"comment":"Ijbub bagehevaz ziku pekcosuk sonkel roh malokej iccun ca sofzovce ej side. Uhoso ludwes hon tifge soj haj zivibog utetubo uha mo dulmivak lesowig himetuge zegrijso hogo suanuev saen. Kija ojiukepo konne vifta vut reziru nan wuwok tihwiho fe vottup nevarki fafnaw. Cohirhud oh bodjidge rehodvu mosigi fe ra lolacu mom ac ipo soj ne vacvoskuk iwcoaho jozguk deobu diimo. Fujoja ehla wolduw uzsinina dis atu ez mawetapi ilohono sem doje jevvi nostuf da fiob maslot hunu cimmi. Ku ipmufvuz tep okalogew mepe kodcuw edopa muna vi norojbip vofiznuj nilah nerreg."},{"id":236,"date":"2017-01-01T10:08:48.489Z","status":"accepted","command_id":450,"product_id":2,"customer_id":693,"rating":4,"comment":"Fovaduc edi coule velaipe vawma amomih meucu ep espugjal aza wiran nufug be nikhec raj fizoji he lomjub. Gitwevbu liw ni abake ube ze jiagte bavborlet fe ko amibam hasouk fese zuwviwur ce kimjiazu omuzon. Vuvlodom ilu ruwvazum piwode ecelo up dagsu agijawi rica rumagbu paovuje ohice kijtu hudmembo ju jo fictec wub. Umiammab jawen nizihevo huilo zin kev ez hoej jerawomu weivi errihfi am jirvu lilopgun cehinsof. Vepgic le ki koehbej virwaz naforuc do is bo uzi kis padopviv vujkin."},{"id":237,"date":"2016-12-18T03:55:02.866Z","status":"pending","command_id":451,"product_id":58,"customer_id":85,"rating":2,"comment":"Doc dogacule zog loemni jikcok rer ac vo wohnahas ucupil ma bisja uvi alalu mop do posuk zarkido. Ni ahjavha juzhi kod aru sufeje oliozoda ow jef runi va wagamad dorluwmuc boc. Riguno zanpog vermi pobo hira etuezuawe rinle ofvo pedero wa boncoj tungu kaviwa ca luzev. Wi ro pazjeivo gufve gewudhi new kal uroteew rim cojuhpan kag bid socegipi tasewuj veluc ta. Puj er ta udepoccew cerorahip vop uz nobgenzi eroelava faf cugje laghados. Malipku jer cidotu petijatun ocavu nitca mucato imcu bi se vedal hegaah zufe. Emugi zu huwih jo ec izine fuj witlozuz ajowu temalo cavluhu zec dolemir cutaseub kicobu tasogwe jogogpa."},{"id":238,"date":"2016-11-02T18:36:20.665Z","status":"accepted","command_id":454,"product_id":16,"customer_id":550,"rating":3,"comment":"Kovnefi vuwitgat fupon pacvelgah dog toofepuv ilima zaltad zizwas sozed tuf nuzefsob farirdo mugo juvoago he kezaw. Hiv manaz daduz im nokte ke goitce de jojeb huzpu ubeneig widga intar sulab kuf guz. Ojiji aheaf butir verig lu sileni fam weswodek vu muf hi pe cokejsu nadu uwi jumow ledfed ud."},{"id":239,"date":"2016-11-28T06:52:18.326Z","status":"accepted","command_id":455,"product_id":53,"customer_id":707,"rating":3,"comment":"Pucefu joc dasih digzecnot viwumbo nir soin kok foj ehuogahoz egi saj nuh rohe ahuri. Da zimariv gebnucbem sadic wig mufnitset uvfa de koz hu wijuwjis liz. Zoha oja tag hob nezevo nadive lavjaki sivejfe acuorawil pete up sa cid fam liniw isapu."},{"id":240,"date":"2016-12-19T07:11:00.234Z","status":"pending","command_id":456,"product_id":80,"customer_id":533,"rating":2,"comment":"Venpaze sogo echese cegci las aruelacu fufsujev civo acre rim veho sohfo huvap poohil. Ume kefus radcaj ikus telcinot bun jucoge sodkonvos huf nejjunjil bikadoc wufuv ovoermaz petti ku zerviz olcetag. Ilipe zojuvzug ufedaaco ucijitzo emo ba apa ifhedhik rodigkaj kewra ebugo vunew jubivoro map oviotmi pogkar. Iwukov naruj ezatute bewevocu jazofa imowiela harpegas weseemu bislumbel citeuj mates uspilof ogjej wa."},{"id":241,"date":"2016-12-02T13:19:18.935Z","status":"rejected","command_id":456,"product_id":26,"customer_id":533,"rating":4,"comment":"Uwo ab zaavunuf peridbu evu den la zofego jedograt wo goj beb hanewuc nu hi sipej. Ime mu rurnu pudoguk fuezarof gub cewuare ivezawuv ufowidcih wemimul bupa reclego rukeaz mofe sibpuipi regwipub gub falovu. Le no biuvgi uwo zursamon kihieku hom rokgeto mapopfaj musco ki onutu he kap rigdejoj ziwuljij ikbu. Kop orze zorpusor takvek uh fiho bongede wezfoep od vicni tozbi bego vilifje nokdiguhu. Atveobu comhina odduto mi suhuw jer japvod kuzuj niniuh famontu fawopsej watsiew torhejzoz ni jowba pacor ozhe."},{"id":242,"date":"2017-01-03T17:23:07.018Z","status":"pending","command_id":460,"product_id":45,"customer_id":90,"rating":5,"comment":"Okvoc aduom dofki su covjez kir de vavaaf juvak du ci ihuci. Zi peomurus udapug dopu fer betelnoc kulnoha isoladcom pulsagop fosoj gosjes tiz vukawac rojuv pugu vuwuje. Emjirjiv tera be kutobanoz li duc ivokaaka ibito rugu ozde dinogo do. Ceccuvuh wewwim sogzivwe ih dupo ze edfu benkikbe goarofe ijeso acmine iw vom se. Loznol boref akure vicifnoj suuzso rigojji esket atfu id mecvo sap biude civapem."},{"id":243,"date":"2016-11-04T11:43:53.280Z","status":"accepted","command_id":466,"product_id":122,"customer_id":792,"rating":5,"comment":"Os ilujuheh bivmuav umifi gulef po ef hewo zehuv udu popebvep hazew mud reetge ukco nadelo ibufibun. Rihov vap va guehe dimtiab kef garzej now jiitoaj howej rebofof tewah faneki fo onugej go. Da doj galfouke huwegobu kiz bu go kikevsuv hote le ajhuah fagip ze ezopani paltibceh mo leos. Jidegwog hulso avuezbu gice wuti bihapuki te fapcona gizdiwgo vuilo lokedobo tav."},{"id":244,"date":"2016-12-17T01:09:00.968Z","status":"pending","command_id":466,"product_id":93,"customer_id":792,"rating":3,"comment":"Iraudbo du vudbovu monsucab ta osu hilpauw vul hogip nema uj ov ureluvub. Efju bateham ic pibje noema fitsisav iw dehav ligi fibfuja fadsevda mibfihve cevmitur miwor moh wihowu je. Dih opuwe nuckipi obnisej ubafar te tezfe odnoane eluojo onecip can mici wi. Zolbomaz rol ewaiw bedmek sugpufdi aj kik pe cunrasit jajuh azlupmo jahvenhuh."},{"id":245,"date":"2016-12-02T05:29:35.122Z","status":"accepted","command_id":474,"product_id":0,"customer_id":801,"rating":4,"comment":"Wuca do saseb okutumi jovnein innobag bume kila kitcivo onno tuvaj bumanahoz vuonfe cewrog dos jom. Dursahma wirwo ez evki nod et undo lari fumsi oggipcit fap kez pic bofcuw muba aliwa. Wemok no ti orovarkun sezjemgev fijada ifu mifosi imu fufona ha asvirid mugivgu gim otoik zugwu zuecoc. Tiw jizipa poaj zojog puum metkicrep uctih tieh ed keoje jel wufeb umisocmu fub vibolwof sulve karu. Zoectud hughuguc ikkes owfugip bewami araatomi ma mudfonfu dud wizcu ov hi abzogji behminko mag va pad ji. Pu dewca pahuw up manene migobazit vetfibjic feef za ino ih izfe git hibriteg mihdifidi tajkodo. Hi mirihe vadpugis zibgoheh dahilna gudmi kutob dova bi mibi fu fus hagpacvef."},{"id":246,"date":"2016-09-07T12:46:14.952Z","status":"accepted","command_id":476,"product_id":113,"customer_id":97,"rating":4,"comment":"Jevsirus zizgi uk kocli hal sovran dejmek citrigsa teupa mijo fat wam co ocopoc oghe nekogdur fih ul. Bosutka cagucnut kib ek uzanig fut hevov uhwutic fod nibnitwa ededirura bobseg de guzuzito riida. Vipe nelar sor ritrocwit zofe tef buribok iruwi wa te takebun cov vuzhu zaebaha kol."},{"id":247,"date":"2016-12-02T12:51:01.605Z","status":"accepted","command_id":477,"product_id":112,"customer_id":50,"rating":1,"comment":"Cojcimak rok zi rukucub apelu lidvif sazte wezuvlo isi wigis mo zomenfo ovula vojevho fa wag corutgul. Fe usi ruikkup julcoal omeesulu me vinuwhub nitovta huhlaw lubte ato rubu tom ah li rucni. Fivwu on lejsukbe vevvupjiv ibka huli giv sabeb punkobufa bodag dij wal dilo vaz hikoves."},{"id":248,"date":"2016-12-26T04:43:41.513Z","status":"pending","command_id":478,"product_id":86,"customer_id":114,"rating":3,"comment":"Eb celo fa ralipuku vafzisobe la pupewoan ogsetaru god sule kogdokwi izha tajote vutgad menkafdon. Ser dijzi wovivoziw jurzofo ki ralonoapo gibbujuv mef diezebel ilpete kez eweku revfarlo migovak. Zo ekpep toir ze ceki gobe ecapem omu agezwes hanceheg beodvow irenogdeb jonbifah lemtic foh legomug pi."},{"id":249,"date":"2015-12-07T05:07:54.643Z","status":"accepted","command_id":478,"product_id":121,"customer_id":114,"rating":4,"comment":"Ozejuzol vag mudru poli pe sen ihsuwzi ezo mav go kir hucihjo ilu cam meki tobgug. Ekanid jommumof covsu wurimi go fe fovef obmotow ced gahrufo pat vujuffo mic. Nivrirnew ohtige jefolgek ecuhi tekigdup cakzital uticev atsil pic tov cudincup neawwo wa vow kilidzo hevnuwom capwudak orgafog. Nip fim pasdur tunna mo ufetza pobnupki onedij vuw homo lol becaj id. Fog ta tugruw lagzojka bebu lifef gihfuj irabeh famjo wafa do opagacmoz ced. Nofperem tutvobke rifizgar letiab ikwuza hijgezmiz ajiwovu egcel pud asrihfu busse hupuge kirrotohe to moj bebe kifutaure doj."},{"id":250,"date":"2016-11-22T06:02:26.051Z","status":"accepted","command_id":478,"product_id":33,"customer_id":114,"rating":5,"comment":"Umpoh guk jadec vid inudurvij ispuini asa vahotev bew kunejom mucotsiv fit upina owigow ti dog cof. Kaufved pelawse jivtemef gav no it bog agagaodo latasna unowilve cojaeme mubfus je os. Cez fef kuh nut ci ufometmij vaco veddu fozenned pam ituez jin sumuj. Tewagwu cu de jefkudca ujmu umu bej papegpih wotpit ahose nadavakig rize cawi ju eculara rem pu."},{"id":251,"date":"2016-12-06T10:28:16.618Z","status":"pending","command_id":482,"product_id":72,"customer_id":459,"rating":4,"comment":"Ubesewec ofo ora kuj eca iz juri semek iwu veejo taito et parazijez oriiwet edzergac dusduho. Re kilasvi odasason eguajo ca ve piwiweh tovupwes buvpud da sijifuge bap sobanfog lotde. Ne jaha home cuj lejic ojeoco iw janvum hutwurke esuri libvecte civija dukeg men woj buj bu. If doro weg iratip avo of viezihu noiwi zuzmu icokog rorcif faojne eb ushuvoc bujor na juzbive."},{"id":252,"date":"2017-01-05T11:37:15.614Z","status":"accepted","command_id":484,"product_id":117,"customer_id":389,"rating":2,"comment":"Purdavu ajtaomi ub ubwaroc mu cup ep carsid he cizer befijah bokwobe kensum. Lon wimvonbi ki fo nuivauli wukzo bo homit gudobro coppa tucdiik cej zin sicej sopepco ho be. Fe mow va ifmawso no dimrar paforfuv gulseuh ul adetbef osde kof eh. Gigu ut cefiipe zedwo ke agu gifvor jevib una temilubi kasi toroham ak wipizu. Ik feler fijde bo cefison tuled veludwo uco ko juurutew ja jilalsi pidho nituun."},{"id":253,"date":"2016-04-13T10:31:31.175Z","status":"accepted","command_id":488,"product_id":38,"customer_id":364,"rating":4,"comment":"Cizhi ma ihiisfo riokbad zemhuc seebe doc bucbot cehnac jalet figic ri lo kajoj bepif vubfiwju cimu. Reen foid afiwawi osunet wepik oma sawo dob wad wamop tiv mo. Erkocu ged wa pofva red daglimob jufrok juznore tewaj egevekaf kebo olnuw zioru mewleme gu mupotre sotuapu. Seregusu budeizi icoako zekeb ala hengosafa sitcum is ze dec inaveh delakwi ipehec sifpijle vufwih. Wavpuw tabifohav ceba ka cu wi pisirat wekumo gu kus ebeheh fu cesmo."},{"id":254,"date":"2015-08-04T11:56:05.078Z","status":"accepted","command_id":491,"product_id":65,"customer_id":462,"rating":3,"comment":"Rijamrut uwwe fehjabreg genez feciw ulejoduh darbi segod tuble dikbug tafihoz lahdihher fej emum jep. Celiwec hite cewe abhuba wez zeiwid uli wofil za wankepif riw gate. Tuvbaseh manka doef so jesov sinpu ziwe pimuc opmid wabozoj fircojrag kiz zeglimpu. Ote nakizan feuhiuc mulmarij tofa wuulji tufjaama vofse si laseku ha tavza meker bezdacaz ju hardabnem hirugmol. Fa ditvoret rapbow caol bevjowuc bo hihah re rana ni lok turziw fo ir fappuslu nikjihvig gimazut."},{"id":255,"date":"2016-11-09T00:23:41.106Z","status":"rejected","command_id":495,"product_id":118,"customer_id":132,"rating":1,"comment":"Ko odka orva cogosvu vifa wab na uluhifo liveziga ivogoom roklir sewsice junudi izcof mudveoj gipemkes. Hihzeibi apod mokwizlor kisfac romela basote ozajfad gi nuzlesan je anat luj hoewzoz. Denhu te wohu levheh tervu duhpef uputakvi amuwohgiw gaznos juzcik hot heta covwebiw nioji kolaj afvewu."},{"id":256,"date":"2016-12-09T00:33:13.846Z","status":"accepted","command_id":496,"product_id":81,"customer_id":315,"rating":4,"comment":"Lajkil to lisivois fi howloizi po ukubu sulnasi bajlode lejajavof acman sopif. Abido hekej bagelu be petbukfi wo pageluc isvozel zon wutmevji kadiwbon ke eblubac zufomi. Idarom upeku tasvaej bu du elfa pinfu aglusbir bimludul hic dalrun ifpasses uzetad. Pe efapi pazduvic kosoj sikuv tahzu hidur jurtuf rageza ofeja zoda edofagmij. Did up ij japur caj ziknaetu ner nelowol gifu fok nize wic lof lu. Mowiase nig tu pentulu di nimi put tim caleh tuglalzec mivusor irajco. Ivupu jumcel nit bautsi coepu apa retup te ma sig nuf beajed."},{"id":257,"date":"2016-12-14T18:27:30.284Z","status":"pending","command_id":503,"product_id":123,"customer_id":90,"rating":4,"comment":"Nuspop buvu tengaba kagon he ed emuf figi ho ijuagvu verrapsu be unuto uvtimfeb otuukke daddurla. Zate doffi jegiri kikiava ida zepooba rofguhe tumge bijafwe hodopta os cu oji jochilri tezuovi. Ebeisece umeni ecuwame nujweguw pi fimejmo bumepku uceke dirijik paroc pimteohu va eje adaro wewijes egutidu. Ajogo owa dolbaowo ipu pecic da tup himkingi wilut ohewiaz map pahzor. Ceob timzedru puno eg ba zimada amceowe log ko sa getgomguv kovju cuevo vuz jumal ednak ivhon."},{"id":258,"date":"2016-12-16T14:25:19.946Z","status":"accepted","command_id":503,"product_id":70,"customer_id":90,"rating":5,"comment":"Zosvap so ab wavdirni miva toso zehgo fodnevhu orzumep hizo ri dile essam sih iwhakon bi. Bipun wuc nisfugwas zunje laneze cacmiv datoj hisulza fehi akjajru mewponef gawrewo umubo ihela ca naep. Ozamobzat seku za wulunnu omi agido vab ap zebas si four bamda ki tekgozu kaoke gi. Fif ir hi meama genbuga tebcab wivovge votsebiw doz bizeab pi lujotij."},{"id":259,"date":"2016-11-22T02:43:17.474Z","status":"accepted","command_id":503,"product_id":84,"customer_id":90,"rating":5,"comment":"Luwowke uvhu covan efeenove eskaz meco san janikba nuhehu pe re taponajiv. Fim cencuici lozkusme zej jici ul puhepzoc wupecpan veb nifke bemwejow didaw. Zare su daizmos pos bevdusrah veatcu upobo ew ah zici fob lo biggo paccu vaf lez uf gevobo. Ijokobmi rapguk hu hicez hawtisus hu vasvo zot ecut obosuwi fam bidzel wikcen mevru mafu."},{"id":260,"date":"2016-12-11T10:11:32.786Z","status":"accepted","command_id":503,"product_id":121,"customer_id":90,"rating":2,"comment":"Hikafbi tirala ah onha ce li sut kulig tu opuweh fug ivhiceba iwuuwne zero ewvobroc. Ah fan daisa awzotca pul vipvipo rewfic mitdi dussal hupsa febrobjot gompu. Lene uzrapwe nomnuplof coh bu lazi jazforoh turun oparuba varzef la fut tiwuzun. Uk balbucon insus wuvo vongag potib fomsip pijeuj vi geri lurci ab cupog ruw anililrat junnuwmi refroh agjo. Rik gebilfu vofus raboslo ra hic go parmutet gotmotat tattozra laplis ate. Tu zi jo poh miv nontehru mirjotini ju magec nu elorelse isu ri cihon roson otbapa. Kucobwel zuwilge be ti bajura usegu fa redkis ote paume suuzo ohahothu."},{"id":261,"date":"2016-11-02T03:53:07.617Z","status":"accepted","command_id":503,"product_id":82,"customer_id":90,"rating":4,"comment":"Hauzkov go somizo ta ehak lursakub buzdut ujra cokisuka ja ji leinba an. Mihwaaru haj revvoho tuviwga ge wukibge nomavewe zu mo oba ze kam cutovu purula bigtaw daezput dik. Fugap fekat jecu ulguwom im li seinuho for mi ce gifo is mibsu azfi ke cimadiza sev."},{"id":262,"date":"2016-10-01T02:47:48.640Z","status":"rejected","command_id":503,"product_id":73,"customer_id":90,"rating":3,"comment":"Ho koonehah ece petdawide je vuhlus ani sod bu ov waser zaoriegi ogoga ladpo. Mikru ij polucvu ja lusedon bajolute udaholil gecdudor ebaize nuj owa okazir tig emmicin vejlaz. Tofo mimuful bugad korurew riira idtav fe keav zun li jadjeze las jipevi. Muke uli dak sugkec kep nulaga je rosuppo bebadak iz watafran et hozi narrelvu. Jujhusvif odopu helekew he bohe tiwoleku ji eti buhi wet zuwuraz at."},{"id":263,"date":"2016-11-23T18:07:56.357Z","status":"accepted","command_id":508,"product_id":69,"customer_id":189,"rating":5,"comment":"Bi zone oc oneku sev zag buruje gavibu eka zo uzile urev fevzedfe ocojum jaicegu. Ejhidi pe zoffisado disfo mobopje go wophigor rumfaklez ug eceson luvsagki turriwob sas pitba ciehoko zofufu. Belosawu womocjo im zofceslez ken moma darol bipudor esitu urotejime goz ajriva eho ugpab haec epidu hundaj. Pa mi dugen licoita simde judi ebo pe wecusuf goimesec wozufup meukezo. Pun mafot wes lejuoce ror ufona jod noskiet kefen bungub ifvewdeb gibob ku. Orjapte fij egpa jel fifo sa cuw tidnep appave fe cela cejihfi bes zeubhi ho iw obopode. Rithuhit mewupemo ahnefe av eh ca nab lo pap wavoh kozjoluma ihzov piraf."},{"id":264,"date":"2016-03-13T14:50:04.496Z","status":"accepted","command_id":508,"product_id":75,"customer_id":189,"rating":4,"comment":"Muzpej ervu tu dom ge rac mu wisijwa zofawogo gav cup huju fuggor ipuske. Vacako nuk birpom nusrubez lojkoh winiha zu icifoted jujovos bo sata benbonfi neb. Eclofug arzeoju aregac wa gufboga ho um sikozsi bi gim puscaj gi cit juklawton uguwi muom keorhem."},{"id":265,"date":"2016-04-18T03:30:57.399Z","status":"accepted","command_id":508,"product_id":99,"customer_id":189,"rating":4,"comment":"Iv gega corzowe zoozohi tizni wiroru ifahimbud tipi giecamo biev bofo korju ecezef mahose lom pumtetapa racwa pij. Reojiz pah uj ohujir jovok tu mev lov amjibmed zog vamzuc bejed wah tizma ve vozkeel jiofelup peera. Aknoc iveed bihrewvu sicek bessecge haddag guefmib su peos cauwvol ipcob tom oh huoh zi vocwi ziguveta. Ba wif ufu le vucud sohcovuw pehe topo vas zerneuho cehba duuwa gi owrug."},{"id":266,"date":"2016-05-18T11:55:53.061Z","status":"accepted","command_id":508,"product_id":8,"customer_id":189,"rating":4,"comment":"Sod wagguin doc seg mobawak ak ac tosginug wicakili zevoaba goekzaw ficuj anrehva zuzveko javgosaw zos osepon fa. Emho bawaw osnu zohacbog vucbe rejep suw diebco ucwekvuh fo bu cotiwoci bebow no vurdeda gemuiti duh ejejol. Cupale ne ozougeaf gi fi jihmebu peigta epaic uwiosme posizvis kianige dobku vulro zop pewab."},{"id":267,"date":"2016-10-15T00:57:06.056Z","status":"rejected","command_id":508,"product_id":60,"customer_id":189,"rating":3,"comment":"Ve uraulwuf it vulumdoc ul cim gacevew ner uhcompu johete vu ba zuvogofo na keza ugi. Erlu cimot or minwuoz kihnewup kacopur ukhe le siv laham vejoaja rupot wo ippaj. Mecwiw ofupi le kiritdof mur tihimi uka ebfel pawvedeto ku awmifco sowtasoh len wezepnu dazor. Heca hebsethe ditgab tafmo bowfijige ag el pon ovsi fikadte dap heosisek wop."},{"id":268,"date":"2016-09-19T12:41:58.360Z","status":"accepted","command_id":510,"product_id":129,"customer_id":658,"rating":1,"comment":"Okune utohe binsiiz ladfulla bot javuwus zeputode badijdol hovru rev mus epsit godduva hihoha. Kamjot jar bagca rujtebti ijo lidiwmi zer hu ico inpat zopbe bilij veadrag ehikotig fu bafu jiznurer. Dumka kav jaafda vusot ofuwutih cisawhip funazto sugure cih fahneki dumziwfi pohvuno parowwe fojkoma unufavva. Muphek inna wul bevo kew cu wit upoozaiz wubon pappat lab holbagalo per rusosde. Ehmuvi cu safubru mawnanil ru hakado fu wug ohco mahurrad ji pebwud besepuz elogac imweb we to ot."},{"id":269,"date":"2016-07-12T03:48:14.093Z","status":"accepted","command_id":513,"product_id":93,"customer_id":596,"rating":1,"comment":"Objegif webuuw wawo ombobduf joti tu poh edded eziubo kariz gispu hekufero lirifo ujicaovi lowah karida efupangi. Tumfu amde wu nuuca iroilan lec hiparhol tomeskut puibeaci jewbur towihi nu zuubpud ces otiedcu jajwo deb. Fauf mi kawez tuececi jaz buekza titgis nijkib vahev cepkevu ku sajirol ak. Ecavezzig pobka budnibu ipezedraz lu rapepfi nutohwa oribikzeh puw sino zilzodpag nohaf ita curnizmob uhuwaf biprab. Gupoceb neogne hoajeci dabin geectat muttuw gokuug ut boz atuhoozo itriwetu obotokef. Anvenga cowmizigu ruhorin sa po tic ekaupuhuv tewaw po camda solu mil kuw vo etasar mibof. Ludhig ol kihuhu ip esrebov sauf zuehubi kihki palek fabi du ucufoh."},{"id":270,"date":"2016-10-20T06:16:32.812Z","status":"accepted","command_id":513,"product_id":34,"customer_id":596,"rating":3,"comment":"Sal ehi pihmul ablo bojel likupa peskihup kumzo lisupwir koj dihip jaok cot lif. Biavpah vatlo tinahcig milek tik ovsa maarfu puhruka lenu tijmagese ze cer nupotel afa moglu zu gogumha ujmalji. Iktuto wim gik vihejbo boc tihelupij ev vi guddu uni doma ve pikpehe bacamwe. Rongege zobilef bucgi fi og omde haludi bugep cavcu penmef hofel apofe ap po. Iweva da epalejem vugvoniva ukvek hizpiwu hucagla voehu lakseho pode ziwmus oba ficef pecaidu."},{"id":271,"date":"2016-11-25T13:10:39.514Z","status":"accepted","command_id":516,"product_id":64,"customer_id":533,"rating":1,"comment":"Lu liici ozebo ahomof up dej ogacune ri sirohev ujmec ohaeccaz ta hulegcet sevic bag sotubev ni akkap. Mepconap jejpe rage raelogo sis iwibazen jaf aho pep vejru iw opgo terno. Di faclavo nikabhil lem daupigik nekvero kak pupeoza nepjogwuz gadoz wu asabem pampeud. Fe sowle nowasnos ujuerfoc wu sehze zojeb havmoho dejtemzu liselo izu udnelce zil gut wogpokro korap bod. Pur niahi betupawo ruwitvu begiwzus honohvo ziupliz womek buhroklof loz koiwu doku fifepos puf. Kipledki zovol deju su gaicba id lur onudasev fanirzec zatecru se muvop kodi nodu."},{"id":272,"date":"2016-08-19T13:01:34.450Z","status":"accepted","command_id":518,"product_id":60,"customer_id":564,"rating":2,"comment":"Bu lutehol inun dibantin muj wej itzel vim utnu fojato gagba ahieraru kel oh bu hacci uf siumoge. Uzalas pefpi niipad igvas et al wesinneb top sec ikzajoh lunorob otoco obege sihub ak gob jinzo hozehbo. Po nuwzovu ikvetke no paoz suzu sinon usauvo epuij nertejdif ta vemu zin wukso bik."},{"id":273,"date":"2016-12-21T08:07:51.664Z","status":"accepted","command_id":518,"product_id":12,"customer_id":564,"rating":4,"comment":"Dibrefsu ugovodwed butibo fe ilereije rer piwmuj di ubdap remug fibru zad sum. Dowu peviz rakiki ocjirwep secvusi hok par hevmuvuf gecehorov suzcuaj logoz pebu. Nalad fabsut voru pu pev bentoivi uv of idiku bebve im gipsifa hujzis. Tu zasmi nudjauhu wekwe te zuiju be aneojpaf paj uma vowoj obi fen. Kubili wab sud rosouc co osuta zavazi zop walusasa jo zep eb. Ulaka orizaav ujinocol vu jabag ewoudukov diket nub jon ake rakel tirah."},{"id":274,"date":"2016-09-05T04:20:58.800Z","status":"accepted","command_id":522,"product_id":125,"customer_id":834,"rating":2,"comment":"Ahaopa os kov ufbe fo eva wis laituone cuh pivjowe loakete vujuvi rawagcad rauba du jinoec. We lac nunozoj jorzun ropsi uwzed doisi ca bo jag fazal ur lozpafdo jeneofi. Aru nutatci siphasmo kov ubsag hajublid li juni camacec zewapi nu fewja. Le wi viw kema pavbo edtumdis zuwe le mel ofizis fatid ewitet ute komebe bivsom fom hahpebhur zis."},{"id":275,"date":"2016-12-07T23:07:43.968Z","status":"pending","command_id":522,"product_id":50,"customer_id":834,"rating":1,"comment":"Di evwuv ral reuhwul bare nup co febheca doloc pamdekda nu tijvos ikoojire ifi. Jooja dija ewheto gogetwa eh akbiir orwucva nithek rogmovjuv rug vas ojihu. Zed boz owokafral mehzito isbuwul reped si hi pu kiwipnah otihaci luvtona rig vikle. Binviv ubutil ujoga kuero fatwizkif ebofonaha dazsazi koc vevikco za peredasup lubhu zidawefub zaro."},{"id":276,"date":"2016-09-10T20:26:25.501Z","status":"accepted","command_id":524,"product_id":77,"customer_id":541,"rating":1,"comment":"Jalmu tin gezkofin we cobbe gevgel jo hutbef ve zijwewi tiwow vewuci kub ga. Alejarga ifolis rommuipe lelavbiw mu pahag lun zogsohvon pig ap weov us bo kicero. Ufzotwar kuw wut codwa ikesa zin opgiwlo fo zueci wo ugarotzil iso ohijoppiz kolol. Efulic gowbop jojipwu esumovaw gohcen soopez pem vehokuh ojzesgef kebi upujilaw ef cumra tu. Zoro ujenu bi simik boc kunje necamof hivfub jooz la pos nev. Wuwavu orsobel ba ukaageha dedar vivguvluz mijib une cedvo ceke peeravi jiniod jowulus zuw irodat mupte sevug givivow. Tiwkaglin rulirij huesbiw ag bu jemeej amrofzen rofoti vi zef iwo ruacoigu wo paze."},{"id":277,"date":"2017-01-04T14:40:53.827Z","status":"accepted","command_id":525,"product_id":11,"customer_id":541,"rating":4,"comment":"Mipti jutumefim biz unalinol sav fakoreato rogbuzo wavu zu mi geze amube. Re jaj jassefkih dewvar ideug farik zonpa sofnub lukusu tiaza zovukiw voigri gabocnur. Un dojpec feumla larliztiw wi mi sezlijcu kosicta as sud zuwfocpa daduab."},{"id":278,"date":"2015-11-17T09:02:08.576Z","status":"accepted","command_id":529,"product_id":77,"customer_id":884,"rating":4,"comment":"Lahzuma sowamal pavi lefbigede ensidus rezcen wojgubuto una lobdi meefeti ocuuv cowizi du rifofa pev telanig gek tovotfuc. Kuv ku danmuso nimdalmiw rarafli ke iti arobi enomu meldandi en igotul ha ago ce bah. Vogispef omuaha jodug wecedere ic lo tefel kairuati ibedaw ud fosguhul du tadgo ekior ure veldako."},{"id":279,"date":"2015-08-05T07:00:50.062Z","status":"rejected","command_id":529,"product_id":75,"customer_id":884,"rating":3,"comment":"Ukbaw ki keopjo nut pade poceh ki zic baopowa so tefazi ze nakawi. We wefvesfe pehkuket lipsuh kogo gaeko owa risuj mek zojjan bive je tuhaj kupsi godde dotuabe sep. Hulabum jeti cotow vunrigif jeev jucalejo mit ezubif nufpejviw ju zujaib mipiov. Ne moros dobuma imono ef em fuwmi libe nelvez rew zini ifru cob ti. Kuc tinopoge de sizana caigjov kuvra ge igesimtin rihbo nuvlog hahuwe eciz cuvola uni. Papsakico uhkiuta cap eki ifotag wocse japuap cun fe je jef huvaez los. Jekur bej ofudum nelavat owapevi nemge hufhu ponhorra ciuhi ihodijdu tesopim faj."},{"id":280,"date":"2016-02-28T11:40:24.186Z","status":"accepted","command_id":529,"product_id":96,"customer_id":884,"rating":2,"comment":"Hi zihum unuvingi widef eme fewivhi sumijali esuficoj mi imerut tawmiclap cusfumdod vapran hibhet. Otu jebik jokjo oftovzit ehpawha og ivun jidra sop zoanutuj ka ba le zeeswod ujevagtij lito ufe. Sel za fov guzahpim ma mibemag ohe hanhu jimu new uro ucauj zujbiz. Rad ujugej pof zagduwwiv ulicurpu feropwas ogutka er ag zah igivcot ogemedzi."},{"id":281,"date":"2016-10-25T17:50:19.783Z","status":"accepted","command_id":529,"product_id":129,"customer_id":884,"rating":2,"comment":"Suz avbafzaj sukuma badruh to wukiva ba mogic ojjul apa wiztina ji boona cevhasem hoawetib. Fegjilrid nojruv ejutarow muceok fu pako kek jo naew osu ogavef sinhoban. Bu rawivac gop co essa kedki anuudauci cok uzutorle cen vupcadre cipa aje mir oszoh raari. Diflescoz nekag ri nide ludeghu mu ticor wa vup wiv bujdi jipuvpiv."},{"id":282,"date":"2016-05-16T19:58:25.413Z","status":"accepted","command_id":529,"product_id":57,"customer_id":884,"rating":1,"comment":"Wus zetenbi kebos belo nojreoko fi hag ne co zu oleam dak motus pigik ga tedag li. Zogi jo ruwwuwo zu kolzimac cal ugedesfi iduwu wu dogom ijvu iwoba. Deut rorlopoz juvafo uhesueki ip cos ufpi zewa fooleji uz bagu sa timifguw felgof dacvizge zigedo cutofij nimulfis."},{"id":283,"date":"2015-11-07T22:09:29.365Z","status":"accepted","command_id":529,"product_id":84,"customer_id":884,"rating":5,"comment":"Oh lomvih bav akepu oksizir oproepe zem dukiso sup om sahkem movsofi zuecamar. Cemap gufamga doz erieb nolzarbi gu obeli zacum fo gu jasedno tidbuwmo so. Fe ufebinli boz lihavovo ba zim cefihzo soro tekjoas ruhase ces imket caguc so ukpuk ma ose jemwatvih. Lef dowmodhu gebnulmes mukuha ofuteruje dogve ficictaw koh faji uc munzaalo mocacbi. Gekki gitjub inkanut apeacibom wustezfo iwkonel ko rud vol fa ri ew bez pavijap wocidi ca podfowil nub. Asuzuol bavbu ikusog umsi waznelpor toji datepujo het wulgi vebfumig mivkac losric le ju. Izecup rupacu vemvu ikta fisufa cegti jizon eceriwte bor fu fi facelebuc vajaza pa terag wemabre."},{"id":284,"date":"2016-09-13T20:08:21.664Z","status":"accepted","command_id":530,"product_id":99,"customer_id":363,"rating":4,"comment":"Vimesam lit kaz ohkag ibmas fituzu viped bu gufako tukidru opega zorreju pic vovkaco dorcic. Pehce tu ah delzul ane gijta etzasiz di vuh cebijru ejagi va la luh roirmew. Mupe uweub fami mohkoc tumkodti naclizvit kal gucvojsed up peva nesemku doj va fokpeir fiobca. Ta gogpohdi he we wiporo maccasce dordufhu rakapaip ifuwa zoguhi ralipi lopvehel sus civaw hid. Waf dif tuv ewigocima ip netid ti cor iwaredfa diwotuvu vam mappel. Remum wimtes cikku sojtimaf fuelahi sop fosopfap gogekho uguvasa cucoti si porug. Epanifa haafa ro bic tu tubez lej kok hadki tifninze buczi bian eco."},{"id":285,"date":"2016-12-01T18:48:08.600Z","status":"rejected","command_id":534,"product_id":80,"customer_id":90,"rating":1,"comment":"Zouciga van aca ne inu jiwuz sahaewe muzroegi jikladon kupregkoj gadsaju ula peguas ju ud waj de. Dafu fikdov butilcij riob nanok leh fosoca to gacpen pasebow jure sihu carvoka ke kozigibej ore ciplulu. Pi re feoni pa mu ivfazhu ku ejuteh ota iwekacum teoktub lifwe dujvijpoj bej kijmahe tu. Burniki foumirim gunfodi ri duifloh fegibke vadcopni munek hegilo ubial jiganeiwo uzuhameh selbujdul daajegus ibokigheb lozobo kupti uvinuwvu. Ci zoc da zuggacmul ziejoda caljulman bov op liv sum av ve. Zo vocvaew feg ka goneed lamsavof armeizi giebo ifo kinu lutega jehmoab livzauf sakel haro ene si ze. Vos rommaveh nip ub su ravi zerbor ofijomket fuc dorwu nodpukod fimle sobno nob viimu."},{"id":286,"date":"2016-12-23T10:36:43.540Z","status":"accepted","command_id":538,"product_id":112,"customer_id":792,"rating":1,"comment":"Gigeve huwose nobuwwum ubnu jap jarnad ohuji foluces vo ijusakog me kevviuw. Afka bikkofwo tosvukiz geg caztitin waj mumgin obatek cok gagehwi iloepu zo duuco wuk atiuj hudul. Ne waji lec ziwar fi ij ravte neot seholnaj alsopa mehte rovzo nozgip ku ed lojak pacujew. Ez sahipite duispac ebeetse dap jekik nuomu pekvir wot fi decu kolepeh bodoom gufu esu ajuiw bopukohiv. Jalare ez maggehzoj malid tokarap ke kejoheb nev in ke usasuf okodawomo kivwif fomar gadfa ti. Inedub gib sufdi davla uh edo gunka fe vuvupe pelot pagusur re fehiregej dag veponjo."},{"id":287,"date":"2016-11-22T21:26:36.255Z","status":"accepted","command_id":538,"product_id":95,"customer_id":792,"rating":3,"comment":"Zizlah ru gipidu tibdip awo mig lutmuber vulho seken bivibiz himlitle cev ivkaeha. Jiocosif ewehazip je talaga da win emi ze cetnum mufaguj kecrozip cak terfouho. Jashi ir covetiva malzefol va beiwo hu sesko raghad cu afe ol. Fejiv oli meukpe ma cat faviju jaid sok egeno nibma zaged liptolca dehesal hadagol anaikewa wibgot megru. Ik nacume es webip laloav ugtamta ri gaehon ligujazat tazijo kantocnap to to ismo zet. Detoc fumcolwaj uhse cebmon wafidolon nu fudosote rijugahew kokije repgud tu babila efbaliv nerkeb one rur. Ucah gosamuf mennel uf uwizoz wuikako dokuweuvi kekensik mesvu zuohwe zi ih ki fu."},{"id":288,"date":"2016-12-31T09:21:03.992Z","status":"accepted","command_id":538,"product_id":115,"customer_id":792,"rating":3,"comment":"Nev pa rajzeweg losi bofcuk bagzukok gugvih oscuk kip lizjif vodo hik coorhu ab ab sotmota mul. Rof macoew ukvu uw donu obizufgah cokawheg wuufe hej pouw willikwev orlanow. Borfear oweogoleg miri vasas welde ara linel edubeb wumwe hij fa fu kolki maogpu ko efti. Gawedkic wud wurginuv gu nopes paruj bavvog fisiej la ebaiv dumodote lufduto sokzi jezpurmik vazehunel oga peam kepufo."},{"id":289,"date":"2016-12-12T07:56:07.095Z","status":"pending","command_id":538,"product_id":48,"customer_id":792,"rating":3,"comment":"Mev warote soc piz sugtel no sari desov eji zet mu gocsa wap fesfer ca jesu. Ce agjine ahudubi giccip tov ezjisip fevhaisi andudca mu cum pibiite mecpadeca rucfezi kinoczi sik hepi obi tupdig. Puvavlef netilub bufsunis vakvikto rejdifor ma oniwemecu vigukgi itufus hok noc agdusak weodvo ca kiavbag nileh rotilar. Movuvud uv co dojhagla rosad ivre tehjumgo egifodme zasni ru ge ho bodo boekipoz. Zo egware lowehig kohusoovi hi uzemha cazed beop lozerpe rutjib nu wike. Japobnil wa je womharcih je liipe vuevo gisuf sahla pufawwe apeni afa me epakih."},{"id":290,"date":"2016-09-09T16:16:50.493Z","status":"accepted","command_id":541,"product_id":10,"customer_id":41,"rating":4,"comment":"Sahud mar wev ke cer ri ugu wehudi erias nud um je luihori sazid irage. Mibjagveg owsat hiz kejo hec cukemuw kijlizo zepedce no pimehuw vama onsuttiv vi bimerla mapopa epanug gu rictud. Hipi pavir mof bup givtub nidatej odewegek hirbeb zufomow pabtan hiefaga keezmu colo oforok. Bat lewkiso ab zavkufve evufega ufsab udeofu giotin dic medufo rekfofdo voutiuce naoba bur. Hekutil voukunow uksokmu fobiteliz gi wacpassi pimire tezdo oswu egaus dol hel depo god. Goerzag jahic redmamtet henwe vosona wot zubpe bumdi su pipdenev jucazew dithij ganaf apeuci bawcibit mup subhuk. Etpa wel vo re gifjine inuolu la vogub dapahu odegi cetmeluto ufa jimbuc ow pisewiov jarge etsik ononi."},{"id":291,"date":"2016-01-17T14:44:33.349Z","status":"accepted","command_id":542,"product_id":65,"customer_id":363,"rating":3,"comment":"Ce afmef vujaffe ziroj taarowa verheag pagro ikehafol karosine ceg nitikde pag tarmunti kicuhak. Bosez cuep nigonpaj rogiga ibga nuzine nuw rotek tomvenuc vekov di fomo hi fupir noahozu ma. Neulu imajo ariiw samo okebogtu pipisoh tecja ibpi ga ivipah zo vog warewer nuvuhsor taufbi. Vibuco mobofi fasho tuhi pukhu ucu poeruja ov gafbubbaw buazo ojgodud kawi dorujsuc bazod ili cakdoz hisa ni. Zo ijgebdo wiedek leof wik gu wesgur cuebiz zone uhe go wodu fo holavovap zabkauv tem viba fe. Do bo ke opga bun pis enzejuk gig coris la rijbe tu jinow. Zeffeku lo ernios vetedi biwohi bajbif teegahar ob iv vantuv tigbi kilnarpop etomuur ipaf."},{"id":292,"date":"2016-03-17T10:47:20.071Z","status":"accepted","command_id":542,"product_id":108,"customer_id":363,"rating":1,"comment":"Tevamaz en ziprugkib li lupo vol to zogiil puzewpe sarewfil jitenno dekdab. La pomogal jucujhe efuros cemmuh bul fakrozhaj ro tuh puf tokeudo wo agzop lakbakwo sun baw. Pebi ogba hutaz diz luavu gumo sumtih fa pimdehip dimor fawi jehziid. Fofag az bir nediv loasla leszian nordiclu temomri bas nazzu lodereota nisnug tahbiaju nefnuvup biwazawel. Akmugawi zirzih ede jovpu ta carlale oc vasu amo nuhew gatezi ced selimamin. Cacar sol bad liwkep upoojru sopmikgel ra pajdera nu jilhe zibumo gusujtum uj macwo vap. Dezumu rittuw tolmuvwap wazda ze hunehgug cadogabo iweve ze zug cutac ebukovi pagbupah rimajav."},{"id":293,"date":"2015-12-26T04:20:35.304Z","status":"rejected","command_id":542,"product_id":83,"customer_id":363,"rating":1,"comment":"Ebotihe aveto em wos ofujwe ocpisiji ipo hi hezfak iko rukdof tis mo tikpe ce edoruh. Dez opgaj wugbertu pecvebme cakreznep vovfi numjagcu lag fempolji utu ovelo lohille. Lolipikih pumek em faz jahuil oferfe wasulhu hikgig kinon zi niucowuj ozni em gojti zecemif ku. Piadodib levnon wi tomabla utbo vubapar jeboc guwi badafa ir nohawbeg nesaz imi. Hiswiv ocu tokmag esi cali nicfev uwkowalu hir vowan mutufso ramrazu av. Vamimo kiej fek vegjondi wofas bizi gevre ugodifaj luridu mebkok umodobub vesimhuw zez de kofan regu."},{"id":294,"date":"2016-11-02T10:31:00.898Z","status":"rejected","command_id":545,"product_id":38,"customer_id":718,"rating":5,"comment":"Tuuluifa nocipa deh waviraw woghum vaburkos zeel zecvac fatte cem zojpu ansinhid kugac ih kizuk ufi hona rir. Zom luz silamic pere ufoti guz nagravge za ne ukap la zogunoh wuifu vatbur ehoto mapgila ha. Fa idhu li tul belu felaafu baj tumac ujopojug zufmutro ja fateg eke pulvuddes alvof."},{"id":295,"date":"2017-01-01T17:55:27.504Z","status":"accepted","command_id":549,"product_id":34,"customer_id":280,"rating":5,"comment":"Vi gih pus judaz cikaf mi tazjuv map kiupa zav ho daganoc sobej nik suhaccib. Siduzdo povab fajehatez lorovam cukwi jockiwpog fipo bef lokmuhe fir ipa fat mevoc jo. Fum bak pizbum zif jubuf ca ji du mosizrah bubiji camha zurmid ezam. Vepizvo arodubgij fi gepini uhu vav pevel kir him rilwuguk nievi kibajip ohun cet mazjujtez livfik. Etfe sug ju kupunhol cirzajbe do gasroz iwininid cohuvnut ahake wazzup gabbitmo upafi suwuh gelig fo fi."},{"id":296,"date":"2016-08-31T19:34:43.398Z","status":"accepted","command_id":549,"product_id":112,"customer_id":280,"rating":5,"comment":"Agajuz owaw sawihzed bifjef tovti vak hi ratgir fuphoppe cametjov obigibsis hak ez lut oculizwu perreij fug. Uci wi lap ceuh pogemi kigju rotpav rowiehu endik faf enoreget daihe osacihan. Owuhot arweid kiij suhonwu riv lev liw aluhulu oroco doduleaza ilhe tubnofu not wa sah evidameh."},{"id":297,"date":"2016-11-13T02:37:33.420Z","status":"rejected","command_id":553,"product_id":113,"customer_id":144,"rating":5,"comment":"Mohnina tirduhajo upalug wosmutdiz wiwje bihupif paug widivo vahtuifa gowigzu wunulre jaleloj tovgohhab. Kawbifa jezufimic jif soz finsep wezogdi woigowi pufulol danomzo bow weaji gugha otcuowa juve fe tates ni kanle. Jacigil jel ocogebtoj bag rigur pes omoofetu cocobsow jakcabfaf ridjal jefe cazikerip piszemle god gavoz nibacure bapdowihe mi. Fu wiomo cahgabi su osjih olmu apikic tileg caglah kevsev cec geweju pav. Ti iruugi durug hemi hi lekul soihrik li velikiru puldev labe wikegir vahoh rekat gakoka musav pavub."},{"id":298,"date":"2016-10-31T23:56:44.365Z","status":"accepted","command_id":557,"product_id":48,"customer_id":289,"rating":5,"comment":"Litispu bal helavid genvo keg lumbe zal dujotun ekwun heb zeer baaba onateim fi. Mikinduc zufgom keninoda vu ewofusdak viti pabrueb il zufku komceiw nusovif feh hoam atnuj ve laca fucpeb gevwagmiv. Kuwnemmek efbef ap wapug hularanow wafu oto ar nic jewu ja memun arsewha advakdo vowimri."},{"id":299,"date":"2016-10-22T01:23:13.659Z","status":"accepted","command_id":557,"product_id":32,"customer_id":289,"rating":1,"comment":"Jawsieri fuebesom jolieh havuh lozavi pepoet pasvov gitwifedo pego okuvisi omesawur dusro ruw. Tu rolvew ijalagva surdaah docfej mutjibin rul nib matwo kukukvo olvib idedoj uhahufimo ro vicec luhomu zoefetiw la. Newmudnos cer getos posejafi di fuvo behutopew ron wefhi fobjavap gerohik apfakpu jiiza. Manzoh bokinbi fob malmah urga me tuzig moevoke kus kacej jezuhel hi igi. Op puvpuga ijiitwi dibef vamawhow wa urataaza mac go jan civ ar fuv sehka lutporor na rovualu lol. Bihoh tajalgu rottup wuneeg vi jijvo galsi duwusfar ivoecusuj uwovoho vaawoov katamkur tuna ig ahjuh fav nura. Sabaduk ucfadol banimi ilranin obfepnom saupde bahwujki pupiat horekejo rezitfa dijim runbakpiw lier."},{"id":300,"date":"2016-12-31T04:50:59.345Z","status":"pending","command_id":559,"product_id":80,"customer_id":599,"rating":4,"comment":"Firwan ive hu olehiw niuti mig karuw ac ziz anton niv laojabil. Ihtokan bosnaret koipgo mo velisboc wajitato fupoc katgo jihaduza ogu no zirinpa fow pegatduc pozbede hazufa va ahude. Sepcarazu mo ta tukuplo abafab ma mag soz hoego mihi aj vinupseh teppew sofoli ofusafe si surlor. Zu pom rifarih viezega zi fopureat to obegi goz kivserse tab atem hisiut buhiav hagi kum wez pale."},{"id":301,"date":"2016-06-24T15:23:29.058Z","status":"accepted","command_id":562,"product_id":1,"customer_id":157,"rating":3,"comment":"Segbipe jojef mosadwej ja po dekdoja didru betor dagebcin tacfuedo kuwma ijokir. Mohefi sorgu so gej larup moszalesu goniehe vuvu jodiledi pihowal udbi ka. Sizepo kulaiv wupura idevas ajku izakucoz fopgud bosnif nebuz cuk wajno lidni uga enip. Wepugo veofnos ve giltazbi daniras weeru saima ajun ahiludtog efidecrob bem zaclorev. Lopub wompomcab zojese paezause jakvupebe duz dogefom ocob gajvuek avunkot radagsu zaote licrezkag."},{"id":302,"date":"2016-08-04T20:19:30.046Z","status":"accepted","command_id":566,"product_id":128,"customer_id":97,"rating":1,"comment":"Bile ziwtoja edu hilcom kapaal lavep mugtikdi pir ufe tov onehe vohmi reb jefjor naloma pip. Tiresaj mec verrile mokoju re fob hu cogjomaze aldelnew zizfait nun olu usadol ditolun ta cibulgip. God kiwah obeamda befe inu igcez ponsu noz uliwuje lofaoz hefuwieza ehipi. Zil dup evut niasu deip jeggor vabine revzawfuf daejase adiv kokdow gu atuhbin bakguktep zet sukak."},{"id":303,"date":"2016-11-18T02:10:51.013Z","status":"accepted","command_id":566,"product_id":42,"customer_id":97,"rating":1,"comment":"Nefowzaf mirkaehe gewurzus re fopeh zutuvhus pi vofa fo zudiputo ac cuviblah fezkorjit kaciw sunfumom cu pe. Osowit su don buupe ne we hi liesvo nikebucik ov sen moc ujnize jehu cazoni. Milan tofacga zuwpa derus zidipje isku davawseg re ruvew met mo pip jopogo duze luluji vezuviot aleeroajo goh."},{"id":304,"date":"2016-09-01T17:06:38.364Z","status":"accepted","command_id":566,"product_id":108,"customer_id":97,"rating":2,"comment":"Bopizlu tueptal ozvogbud ivoikuun werbi ifi vockaj gohiju sigez um polu guh lunok zuzbob zosve. Cezub komupile ge evrace pad arrapawa lawdadin topaud pibco guluva awegaba mec lirpiho. Ujfet madnawnin sat ginizum ubrujlif fogu golmedobi rucniek suvu dav kekirom lu ahimihmeg evegomin. Jeba dobtivil jurtibe esepot is todhoruha nudbimel olkojkev ul nuvim bolo pigattaw haf ipu."},{"id":305,"date":"2016-12-04T05:52:20.546Z","status":"accepted","command_id":566,"product_id":29,"customer_id":97,"rating":2,"comment":"Lumehun wumta gunofoj pe og nuzbufhiv tazien timvap tun fufu ce ihapav. Degmopes jivojal fo nihbeh tefozaaso akolufmi sulnaezo uzojivuh ehsir rimijof uhekop dafni bozospa ot cerjo kumiwiw far. Dodasagok vaevhu zu owhasaw ki liwkiczil indu nired ta ibion ifri masin zas afhoed. Kog giota izveg deskamke kozwim huvsa suflazce wezuguoda lugim hesawar fijkore koz du rahinu."},{"id":306,"date":"2016-10-02T19:15:58.168Z","status":"accepted","command_id":566,"product_id":121,"customer_id":97,"rating":1,"comment":"Ru odno du fi nijalhu viholped fu nac hehhu pah jupajaw pa. Nit epiru cif zapdirugu gag zu rumogu kopec dojed be re ko poc mujaz vitajus relhuita. Setak mudjofzog zudib metu sagehsi sod buzgil zukcuvdo adnusit run cag gufi hode ebirce ro."},{"id":307,"date":"2016-09-28T18:43:17.827Z","status":"accepted","command_id":566,"product_id":94,"customer_id":97,"rating":4,"comment":"Bum arbujimu te femzazuz savifrag wene caplozfi igupud ahi matur su but wulujli hida mitible us. Nev bigwituh nek vechut fe vofgazo jul nomwec ag vieg nep soszolni ta kiwrooro hise havumkar. Ha dov neja zamerut hecek mabes womvoca or deksuzpo huz farieb rat ajati. Sogke veresfe manmalag suoge jehedoh malzak vekleg kimpafa su por bebamdel gulo ma ewafi micdizjuj. Lo eteozuive sohucas ko tomadap ipisi citpen teluz pu to hab re tunub. Fib ec zoozu he coltib lunzemcap us idfaj ji te eswom zaehoune vancumfe as eva waksawib ednu."},{"id":308,"date":"2016-12-10T00:40:57.706Z","status":"accepted","command_id":567,"product_id":49,"customer_id":61,"rating":2,"comment":"Ufoj ihibe sil awnow zulikho memge ame lowcu japob das uhi ab heehug. Zepobpu ehzeti wi wirzidvej bufuv etuz tukiwfi lutojje itefehwu lirziv ohwo ra maitait wivu cuv emomohha. Zehfu ezbu gi huso tonhof uhcibga fob fuhe fa pudjev kuzakge luzodug ade itihefza."},{"id":309,"date":"2017-01-03T04:18:50.275Z","status":"accepted","command_id":568,"product_id":3,"customer_id":564,"rating":5,"comment":"Buza sidvu ig ud fu mu caumkij dopev di are goz sas us jej zi heivbo. Sivup parvop uwfazeh napnal week se ze poav efuma rushawe liuma huzse. Agevoaw kefebna sep vekka vunlotmo wif aguzozir kimvehibi edulebba dadoszib cuw cab lofu. Cizujig ora dojvuv uca atewu latura taucoji jo cobop kiketu rursa nucalebel offih papsoh calah asi."},{"id":310,"date":"2016-02-03T07:31:41.078Z","status":"accepted","command_id":573,"product_id":88,"customer_id":797,"rating":3,"comment":"Hihtakuv pev ebarul ce pipow sezep fa hapba opni nion vappapu zofpiv utunij huahga vil we vumra linkip. Vuelavi egedut virsodko sirawiza abzi miv rusbetan uchankos tiv rif pupke jicuitu leji cuzsu inivo efo. Midac gi pi wus nudlu sohizni savfafce emafezug jujij fa odtotke oz bi epuec geginlo gofgusmid."},{"id":311,"date":"2016-07-07T21:07:25.047Z","status":"rejected","command_id":577,"product_id":0,"customer_id":229,"rating":2,"comment":"Uge uk behinwoh onu bakgerebi pirvamge donita nu volip erudub ki cukupe foubahak donpuc jelfoboz abushu. Tajjo siwparva rofsam ras pajbeva asog la wihoduvo metmom vece akielew jefolsi atcez hujibilov vevir. Les cozit nabeele abifor jeaca jepodeki wuwnep eda er tecbej og nupci. Iwuul domsoj su rosenuuko jiran hikeper sidama hoh ehi wipusa ojagoruv jiomoge ni. Ocmevut sa la jebap ro bow iterepeg oru ogbi wo pepecdij omosa amudal jiclej pad ernof tu."},{"id":312,"date":"2016-10-01T02:05:41.931Z","status":"accepted","command_id":577,"product_id":96,"customer_id":229,"rating":2,"comment":"Ol og bezivsi cuhfi ejaaz gewo jejnavkus acopor lunut uha mi vafzos wego huhafraj ig. Nobfus cipjunus ne pitohrig faulsu go tuw howgit caj agcovzu ezejupu man mat jacojet pu ba cohwok. Basif zembab nipeb wobim namcas mosaje kiebo ruple fifi husoselo diigig teowu ehesitpus uwabupes nokgiri."},{"id":313,"date":"2016-08-30T13:52:51.527Z","status":"rejected","command_id":586,"product_id":91,"customer_id":693,"rating":4,"comment":"Zaib jiodfar laso du da bup kacinke ane resko ivta nivur taja hisol tojeica zus. Mi udaoj bano topi lubura itica rawzefi fus keglofen weeda ziwdo oba ibgantiz ratas. Ufajaova junis nukhe tev bucih ledli ohu nor tum nef daja bowachec mone uf."},{"id":314,"date":"2016-10-25T08:59:57.519Z","status":"accepted","command_id":587,"product_id":72,"customer_id":540,"rating":2,"comment":"Ferucec gebe wofopo lawacal pugahar jub fa nigib uszeco hahjed biba zecbe kusme pozajpe tilgu unrud vemre. Ajher cuwawek keras tifafa li efa wof zofriw ilev vejpa tahgezi morumkuk gekubfab fesa nev vacdoswaw jalwijo. Pad pafrezor razhobzaz hivu raz jecehiw ki gizizjo dip zig hupokfi pe ogu jitot ed. Uj lognom rogasvot cekon ceagsu selami kejhow fo uzlowri fogofec imziohu lit ihbuve."},{"id":315,"date":"2017-01-02T07:37:34.542Z","status":"pending","command_id":588,"product_id":25,"customer_id":196,"rating":4,"comment":"Ugu ipelarwak ta togat mekmazuj eri viwiduw roozo ak gigos huruh ocve kuf ocezedhi bono ok. Gaz jucfenu fa logpezvo feboase an ju tenimi naveva uzzi lurrarma mufzec doomo mate pus. Fijfa wav beroroce tisjaz vo tewazdos re lel kol nipug tudvar oneujaus."},{"id":316,"date":"2017-01-02T09:50:24.462Z","status":"rejected","command_id":588,"product_id":4,"customer_id":196,"rating":1,"comment":"Dehuwa ipakeov wuriw itener du nordan poceeza omagideh to vepzel pa afujelhur tid. Naf muizi hiz uwe uhukidube nubuf bar licev iravu bur tinles aj pupec oku puanmek mukek gul sih. Ojeogo an norelku nipkub telusuwa wut na nijonmo eweoh baezru tef cuti apoaz bemejik ufcuc. Je poh ogiuro fe bujwowbo ru camcirip pogace odofe japufu dewtop facpet ehi jawvego. Sub ropudeco abe lewcoz ruliobu muh tuftu obe tuzceofi dupmabi kufkiti cimor owoduep zujcef demzeb nutezezuw sunsab. Pu morcu sod ucsomuw juhe ujogjik bu om biksag nukvanlij ce temij fed mo sevazto wikuw. Fu hubwafuz vuultu na mofle suog cedodir an acku rowomnej iddap wa ebezumaw dopbosu miclunul se widiko."},{"id":317,"date":"2017-01-02T11:20:22.811Z","status":"rejected","command_id":588,"product_id":50,"customer_id":196,"rating":2,"comment":"Iga tuvil pocca po duejujif tuhbonoh ajaviir pepifwuz vemlo buvmeak wafguiba tihtaunu ave bonic. Fu ricdu usewe lori sevu hu bo ar sodilus zoza toow jagpe. Retucuuwu tuzliruj paz al sabe alkeh bibgide tagebula bo ne dehdaite wo gij hi wabejvej dukjeffus nesfev. Pecmodas rac mogwir kafavivic fape li acucili rof eken diwim linvinvik ov ceomla nug ficdaf pajihefu now kosgi."},{"id":318,"date":"2017-01-03T17:14:44.653Z","status":"pending","command_id":588,"product_id":115,"customer_id":196,"rating":4,"comment":"Ceezzer zif uva vowa jovpesej sigaow nuk va wef zo gizhilgo ifjuene mejijar ranvave ce wefala. Omassob lucava ekohijlof veh si osi zazruwdin lu wihsugatu rubmawes sohmamo zoem tiz jusijbor agajaz iwe nu. Keb nipguh hijbe doszo lonesi an azdud emre peebpu cugtiwmow onic tofba nefit kodava wujide kepov."},{"id":319,"date":"2017-01-02T06:17:44.783Z","status":"accepted","command_id":588,"product_id":7,"customer_id":196,"rating":5,"comment":"Ostam vuottu ac caba regbit bad kacpicho topges kef ocose het zudu. Ovuilzik miw ujehothi fewufe zo upizu olnucceh owmape hoafdal nehfufkov nu sod cuv uzazme. Im opozehip goglof dapsunof kid imme ji ukujidzo wi ameuwte va dosnu ili juta vu cec keja tiziek. Vu puhikius luguk pok vupnoji wizumigud zokuj lom uwisotid ku vejpono jur leafu lirfotjeh wediro vice jamuf jura. Gacuce vibdi ta gunwugo nicceb wugrepnan lu hi muw pijwioda va fowlebuj icajalag acerouco licju oj wucsu igil."},{"id":320,"date":"2016-10-26T16:41:31.506Z","status":"accepted","command_id":589,"product_id":57,"customer_id":892,"rating":3,"comment":"Funig setadevug cemtihapo bupiz fesgactol po lazhi nem homdib pe rivigmo omrezero poenju faglab elacecwe cuvuav ihi. Fodesiro co lu uhrif lic mecfuw gohhoh tojhar nujip ginhefek mauma vun ufe jul. Cofpod hu burjobral nifruwvic wufihkes gol dubib tapabej duobovec gobicage ti goewi hunar. Jiri bofuv evibofke bot etedivug akoriw ar wup gescuwol leg temuk lisu nowcolruw danmovam. Keoc ebuir kupefce se verporzu ifegah kifbo burol riloza usakigmed reb wi nidpe pecuvodu edwabifo rinegfa. Ecesu fasra dumavi ilevuzhet etujega woshat mez do sakdavam vamet bagvucin nifajado agu kaimitaj vecudbi jaf. Jerum pirov pisapocer dutce con lup dezof wa in nolij dazozim akmot fabu."},{"id":321,"date":"2016-10-04T12:05:49.640Z","status":"accepted","command_id":590,"product_id":72,"customer_id":301,"rating":5,"comment":"Ufuejgi kacej panzosdic aksicta be utenupek galedezi jersucra fejeji neb ful iti iwiuleej namurir zeh woriw erourki hikrevi. Beivhi jobu mikijze rup jucap kefarek mimlishis vim debwohi hacikose we akhozvuh. Tepizod am fi to sed wokopgas epihi woj vifcori dafun voztahit na. Jajah rema kawegupo pizumow ibapout fabriate zupul vupowmu rososo sowa lejhih cadtib. Jo nufidel diowde womutbec opacam modzon upolol wahkoljo huvciwa du jib getej oweji upo wo socejpi rizi hu. Cavata ipka kicri gegnejdu ij tukir tumi zezibzo atnokzun dodokasi ugobir jotote koroib cuwzuwu isukmul zo arduv gimco. Ve uhazek ubvinej sawu zenhir cod bavi areri se hinufahu jew ge saza cej jizadje piw ver ofawi."},{"id":322,"date":"2016-12-23T19:24:23.563Z","status":"accepted","command_id":591,"product_id":105,"customer_id":363,"rating":1,"comment":"Ehigu cidgazto cohu vi ves geno ildakolo kahtuk ol imlogaf zulok no ochapu durizud semu raw wiba consisun. Kididri eha hazoc koltu os bocutiwu bamew zajret kiimifig puwno witwutomu sikaz. Buf tan mezogu uw vip ipuso ezi tessob kapuki kisiul ma vabip. Fu gumwuv cidtizer tonba namib basarva vimut ho izabedu gubka je evpi wujsap. Daikkab nefsohe gogacal cadmas uftu tuhgujbi cupwus hus tajval obigefdo veme urulaca ale wiliheib ubmugo su. Nurpu fegosik udowu tewuso vefdo fen zicseh waluas kenzehe po dul of pufu gilka seweh ipoike wi jiupekof."},{"id":323,"date":"2016-02-16T14:37:02.230Z","status":"accepted","command_id":592,"product_id":14,"customer_id":40,"rating":2,"comment":"Dodpuphaf ros ige gojwuc tifuvge viwasu evobanda po fasdeha ja vij fo ejecu. Aduili wakunuba ligpa ubkib owe ka za nolal ug siteha migon lip ignu daz. Bo iveja nihagi me efo vuceka lam ma gusub sohmi lupagolek solwimro ronhig rus. Dit ikajaw ze ul se elafa tile os ziuw nu neb ecvecgur tir gezu rat. Ogular pedu kezwilsa usfese met esevenpiv retvozka zuahja no modpufa bodog jituksu tuumse keina ti. Lu bi nosbo sacputsa ged mivacgag vo nohapris jocdahni piretuk cel urbabu. Ju bomodlo roeki lad vaczuro belajre uge wilgojpan labekwij je wifronaze detod pomivsuz julzo momzu ihdih ku ka."},{"id":324,"date":"2016-08-16T23:56:44.133Z","status":"accepted","command_id":595,"product_id":56,"customer_id":157,"rating":3,"comment":"Bagsuzaj ralcumip wezji negak liihnol wil vigsa owefoc wojiote sofovase bur uloijah nutu. Kir fa pi lu ki kek potoleh tiabata rohoze waj duipa urohaspe lepkeja bozo urjak cif. Honamule pabbozfel haseime beto sa kalfem vocoima zoluigo zajewce sulad uvijaf deke gibpocat teduw morob tezofpe. Lece apiliop cadi nuwi rikrol kimuke ubaavozeg pekahira zeb mupofe eneju tehegu un. Huzuc wa datlakdob gioz ipoojce cuhaif guhbat fuvrif wa galu ve heh wucu. Ho tedic ruwi vob te tageb wuuwalu buso wiena wauz panej fu hifweruf huwcosu rat. Isne wo fa helu ed corenpeb levedgas codovve sismikuf ferwudoh cotlic emcud."},{"id":325,"date":"2017-01-04T13:30:31.072Z","status":"pending","command_id":596,"product_id":70,"customer_id":144,"rating":5,"comment":"Agotaw jajsiil hebiw mitopiofe tileto to neh ve urwirzet selo hug wireca fa vu rohawi ja. Ijnohem hi jabo orufo eko voejili maacisec le saulo zefad najba muw jel rin be. Za os sahafguw telbeicu tisuot zawginanu obu honolok ho upezigik sonvafaz vifih hon taro mekaafe gilofe ceb pedne. Cuzim isfabces fajrade oc vuceda ewe aw seredof newawug bu it bin isjuwda duwo tetes zetatfi ikofih revjubra. Tikgejbiv koreg foloc lovi uba menkuc sigud jahtepid zihi gulgadras pulzarji ret ewogud kuos ve nok boatil tohwud. Bozutu hemgiw sekewof me tah pegnu al diop emocmu hek guw leged tijlo wifsigju. Lu jiobawem ebekemnu gimo na jimuzer dumouvo oduitijez ke abumu erozeke diuj fapog vikvisos icu gotaz."},{"id":326,"date":"2016-12-15T01:18:50.620Z","status":"pending","command_id":596,"product_id":48,"customer_id":144,"rating":1,"comment":"Ru nu fidungi lakarom jamok pesbal cas nikzu ibo heszues cacu temoncos as. Kekaz jezfuzi geowopu ivurid cor fuw lo egno gifmi nuafrid hez temejwo rawon waofede neeguud lesbobil sijobir. Pelode lawe tutur iwegehga bafbup betgiz zuzfeuwi wejapbe apdoes ma kaveta zuheat unapul do. Wev ruchicem hu wan jihupum fof aduipalu vapadteh evaje cabverve terwi de olnira rot. Ta hufbunav diko etenowil hu mizev ni mega muaso loggimuk vehki no tepe rahep. Ha dac nujifaro rupubmud mesmazut zamo wucuili tof ros vitnad tairuce se bahuh invib godawiw tonsutar."},{"id":327,"date":"2016-12-19T02:24:58.094Z","status":"pending","command_id":598,"product_id":85,"customer_id":892,"rating":1,"comment":"Ravsi et bo be juvgod rewevow elobre fud juzuv huwpipmo seh vegauw iz ura bobik dejvo poj gupatek. Nud wut hedfokuh zedet lawdes dawag les otagi wo itwadsoc luzhipele rekwapzoj puizo da uzsus. Fu toutfo fejgegefi ofa mab ke izsa mipronluc unuwompug rufec cef tibene dupfudan odijihoz gikfabga pizok. Sazev petenos duhihup homi ewugfa fimelboj bog jub tan erbocike mivnaave gi duutmis wiwurij ikiin hovcet se. Ijpa bevga du uhe boofaun gotdugije veznu fernurebu doh wirnohas sa adoloble lonoka gadvacjek etdo. Luk amji zida ipizimpul kum re boc igsup wowziv aplovu wip ihi wukawip di."},{"id":328,"date":"2016-12-28T04:29:33.224Z","status":"pending","command_id":598,"product_id":15,"customer_id":892,"rating":3,"comment":"Aruha uchujew berumha comgubob sizva rail ataikuav us izucu zudvat piwhuf bo. Dudod dozufhag lef teguremo juccos ihe cof luuh bohu ov oh pi vahakuj. Anjed buleoze vadca fokow heuriali zioderi ubige wompungof tu pakmi leiba miokac. He etsibja pijuesu ga ilheeme ukavave wamos dedus job beh ervu mo fun puap lila vauzo mug oznifbuz."},{"id":329,"date":"2016-12-13T23:42:07.553Z","status":"pending","command_id":598,"product_id":0,"customer_id":892,"rating":4,"comment":"Zolwa nuwimeze beves dedal ze rubgu fegeem apicukvo cujbifi anorih tak ato etcioka igi ruapma mis. Vilcom cobfetu ji ce erdozja bizsasme lug sejgejhi veraruweh woj ad voz. Duhunjo pindij nifmivog nitinogi cog toced jih to ajujej te pit tekoj tuwi. Colah jeku opeuh decohheh mirki noicaode menteebo mece ujevesi ekvi afteame aliwujif pa modaif fudage hetun ni. Egekiv bezmesrik nera feewze veccosit calnadbi zajug de hocokuw cape kik gum gizju rac sojmab karluc."},{"id":330,"date":"2016-11-17T20:08:27.261Z","status":"rejected","command_id":599,"product_id":47,"customer_id":487,"rating":5,"comment":"Jezpo gitupsu bitoj civwe ugimo amsap hidib dobgeuro ka ifiti vo as pal uculep facab tempal ku. Re wevbab techaz egowiote rus coni jocvaw evwatdoj epa ledot gehpo okow ewiza. Iru werih keijoh nojopog pot kup murvawa re ze kekugi tav tegceg guuwu wozibi zem kuvpij umobu cu. Tevdoje irolucov pu zi dinumwu caahinu ol hak go fejatkak hevfap jefuf wu suni enuzedmi wut jiwil wopeh. Muam natsi gaemo cesla pisoiz rit de pokek wohadla halze heac lifmune buati paputad izfuv fepsi ve guwije. Johu cizwupges saigi ziji imaigoub fogap agaabolar relbaup eto bab dedpu ruhenecip poted sebjibuce sujlu."}],"settings":[{"id":1,"configuration":{"url":"http://posters-galore.com/","mail":{"sender":"julio@posters-galore.com","transport":{"service":"fakemail","auth":{"user":"fake@mail.com","pass":"f00b@r"}}},"file_type_whiltelist":["txt","doc","docx","xls","xlsx","pdf","png","jpg"]}}]};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var angular = __webpack_require__(6);
	
	__webpack_require__(144);
	
	var myApp = angular.module('myApp', [__webpack_require__(188)]);
	
	// custom API flavor
	var apiFlavor = __webpack_require__(145);
	myApp.config(['RestangularProvider', apiFlavor.requestInterceptor]);
	myApp.config(['RestangularProvider', apiFlavor.responseInterceptor]);
	
	// custom 'amount' type
	myApp.config(['NgAdminConfigurationProvider', 'FieldViewConfigurationProvider', function (nga, fvp) {
	    nga.registerFieldType('amount', __webpack_require__(163));
	    fvp.registerFieldView('amount', __webpack_require__(164));
	}]);
	
	// custom directives
	myApp.directive('approveReview', __webpack_require__(157));
	myApp.directive('batchApprove', __webpack_require__(158));
	myApp.directive('starRating', __webpack_require__(160));
	myApp.directive('basket', __webpack_require__(147));
	myApp.directive('dashboardSummary', __webpack_require__(151));
	myApp.directive('zoomInModal', __webpack_require__(156));
	
	// custom controllers
	myApp.controller('username', ['$scope', '$window', function ($scope, $window) {
	    // used in header.html
	    $scope.username = $window.localStorage.getItem('posters_galore_login');
	}]);
	
	// custom states (pages)
	myApp.config(['$stateProvider', __webpack_require__(161)]);
	
	myApp.config(['NgAdminConfigurationProvider', function (nga) {
	    // create the admin application
	    var admin = nga.application('My First Admin').baseApiUrl('/');
	
	    // add entities
	    admin.addEntity(nga.entity('customers'));
	    admin.addEntity(nga.entity('categories'));
	    admin.addEntity(nga.entity('products'));
	    admin.addEntity(nga.entity('reviews'));
	    admin.addEntity(nga.entity('commands'));
	    admin.addEntity(nga.entity('settings'));
	
	    // configure entities
	    __webpack_require__(149)(nga, admin);
	    __webpack_require__(146)(nga, admin);
	    __webpack_require__(155)(nga, admin);
	    __webpack_require__(159)(nga, admin);
	    __webpack_require__(148)(nga, admin);
	    __webpack_require__(162)(nga, admin);
	
	    admin.dashboard(__webpack_require__(150)(nga, admin));
	    admin.header(__webpack_require__(346));
	    admin.menu(__webpack_require__(154)(nga, admin));
	
	    // attach the admin application to the DOM and execute it
	    nga.configure(admin);
	}]);

/***/ },
/* 154 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    return nga.menu().addChild(nga.menu().title('Visitors').icon('<span class="fa fa-users fa-fw"></span>').active(function (path) {
	        return path.indexOf('/customers') === 0;
	    }) // active() is the function that determines if the menu is active
	    .addChild(nga.menu().title('Leads').link('/customers/list?search={"has_ordered":false}') // use the same entity list for several menu items
	    .icon('<span class="fa fa-user-times fa-fw"></span>')) // no active() function => will never appear active
	    .addChild(nga.menu().title('Customers').link('/customers/list?search={"has_ordered":true}') // use the same entity list for several menu items
	    .icon('<span class="fa fa-user fa-fw"></span>')).addChild(nga.menu().title('Segments').link('/segments') // this state isn't handled by ng-admin - no problem
	    .active(function (path) {
	        return path == '/segments';
	    }).icon('<span class="fa fa-scissors fa-fw"></span>'))).addChild(nga.menu().title('Sales').icon('<span class="fa fa-shopping-cart fa-fw"></span>').active(function (path) {
	        return path.indexOf('/commands') === 0;
	    }).addChild(nga.menu().title('Orders').link('/commands/list?search={"status":"ordered"}').icon('<span class="fa fa-credit-card fa-fw"></span>')).addChild(nga.menu().title('Invoices').link('/commands/list?search={"status":"delivered"}').icon('<span class="fa fa-usd fa-fw"></span>')).addChild(nga.menu().title('Cancels').link('/commands/list?search={"status":"cancelled"}').icon('<span class="fa fa-hand-o-left fa-fw"></span>'))).addChild(nga.menu().title('Catalog').icon('<span class="fa fa-th-list fa-fw"></span>').addChild(nga.menu(admin.getEntity('products')) // nga.menu(entity) sets defaults title, link and active values correctly
	    .icon('<span class="fa fa-picture-o fa-fw"></span>')).addChild(nga.menu(admin.getEntity('categories')).icon('<span class="fa fa-tags fa-fw"></span>'))).addChild(nga.menu(admin.getEntity('reviews')).icon('<span class="fa fa-comments fa-fw"></span>')).addChild(nga.menu().title('Configuration').icon('<span class="fa fa-cog fa-fw"></span>').link('/settings/show/1').active(function (path) {
	        return path.indexOf('/settings') === 0;
	    }));
	};
	
	module.exports = exports['default'];

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	
	    var products = admin.getEntity('products').label('Posters');
	    products.listView().title('All Posters').fields([nga.field('i', 'template').label('').template('<zoom-in-modal thumbnail="{{ entry.values.thumbnail }}" image="{{ entry.values.image }}"></zoom-in-modal>'), nga.field('reference').isDetailLink(true), nga.field('price', 'amount').cssClasses('hidden-xs'), nga.field('width', 'float').format('0.00').cssClasses('hidden-xs'), nga.field('height', 'float').format('0.00').cssClasses('hidden-xs'), nga.field('category_id', 'reference').label('Category').targetEntity(admin.getEntity('categories')).targetField(nga.field('name')).singleApiCall(function (ids) {
	        return { 'id': ids };
	    }).cssClasses('hidden-xs'), nga.field('stock', 'number').cssClasses('hidden-xs')]).filters([nga.field('q', 'template').label('').pinned(true).template('<div class="input-group"><input type="text" ng-model="value" placeholder="Search" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>'), nga.field('category_id', 'reference').label('Category').targetEntity(admin.getEntity('categories')).targetField(nga.field('name')), nga.field('width_gte', 'number').label('Min width'), nga.field('width_lte', 'number').label('Max width'), nga.field('height_gte', 'number').label('Min height'), nga.field('height_lte', 'number').label('Max height'), nga.field('stock_lte', 'template').label('Low stock').defaultValue(10)]).listActions(['edit', 'delete']);
	    products.creationView().title('Create new Poster').fields([nga.field('reference').validation({ required: true }).cssClasses('col-sm-4'), nga.field('price', 'amount').validation({ required: true }).cssClasses('col-sm-4'), nga.field('width', 'float').validation({ required: true }).cssClasses('col-sm-2'), nga.field('height', 'float').validation({ required: true }).cssClasses('col-sm-2'), nga.field('category_id', 'reference').label('Category').targetEntity(admin.getEntity('categories')).targetField(nga.field('name')).validation({ required: true }).cssClasses('col-sm-4'), nga.field('stock', 'number').validation({ required: true, min: 2 }).cssClasses('col-sm-2'), nga.field('thumbnail').validation({ required: true }).cssClasses('col-sm-4'), nga.field('image').validation({ required: true }).cssClasses('col-sm-4'), nga.field('description', 'wysiwyg')]);
	    products.editionView().template(_productsEditionTemplate2.default).fields(products.creationView().fields(), nga.field('reviews', 'referenced_list').targetEntity(admin.getEntity('reviews')).targetReferenceField('product_id').permanentFilters({ status: 'accepted' }).targetFields([nga.field('date').label('Posted').map(fromNow).isDetailLink(true), nga.field('customer_id', 'reference').label('Customer').targetEntity(admin.getEntity('customers')).targetField(nga.field('last_name').map(function (v, e) {
	        return e.first_name + ' ' + e.last_name;
	    })).cssClasses('hidden-xs'), nga.field('rating', 'template').template('<star-rating stars="{{ entry.values.rating }}"></star-rating>'), nga.field('comment').map(function truncate(value) {
	        if (!value) {
	            return '';
	        }
	        return value.length > 50 ? value.substr(0, 50) + '...' : value;
	    })]).listActions(['<ma-edit-button entry="::entry" entity="::entity" size="xs" label="Details"></ma-edit-button>']).sortField('date').sortDir('DESC'));
	
	    return products;
	};
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _productsEditionTemplate = __webpack_require__(347);
	
	var _productsEditionTemplate2 = _interopRequireDefault(_productsEditionTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fromNow = function fromNow(v) {
	    return (0, _moment2.default)(v).fromNow();
	};
	
	module.exports = exports['default'];

/***/ },
/* 156 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var zoomInModal = function zoomInModal($uibModal) {
	    return {
	        restrict: 'E',
	        scope: {
	            thumbnail: "@",
	            image: "@"
	        },
	        link: function link(scope) {
	            scope.zoomThumbnail = function ($event) {
	                $event.preventDefault();
	                $uibModal.open({
	                    backdrop: true,
	                    scope: scope,
	                    controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
	                        $scope.close = function () {
	                            return $uibModalInstance.close();
	                        };
	                    }],
	                    template: "<div class=\"modal-header\"><h4>Zoom</h4></div>\n                        <div class=\"modal-body\">\n                            <img ng-src=\"{{ image }}\" class=\"img-thumbnail img-responsive\"/>\n                        </div>\n                        <div class=\"modal-footer\">\n                            <button ng-click=\"close()\" class=\"btn btn-success\" >\n                                Close\n                            </button>\n                        </div>"
	                });
	            };
	        },
	        template: "<img src=\"{{ thumbnail }}\" class=\"poster_mini_thumbnail\" ng-click=\"zoomThumbnail($event)\"/>"
	    };
	};
	
	zoomInModal.$inject = ['$uibModal'];
	
	exports.default = zoomInModal;
	module.exports = exports["default"];

/***/ },
/* 157 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function approveReview(Restangular, $state, notification) {
	    'use strict';
	
	    return {
	        restrict: 'E',
	        scope: {
	            review: "&",
	            size: "@"
	        },
	        link: function link(scope, element, attrs) {
	            scope.review = scope.review();
	            scope.type = attrs.type;
	            scope.approve = function (status) {
	                Restangular.one('reviews', scope.review.values.id).get().then(function (review) {
	                    review.data.status = status;
	                    return review.data.put();
	                }).then(function () {
	                    return $state.reload();
	                }).then(function () {
	                    return notification.log('Review ' + status, { addnCls: 'humane-flatty-success' });
	                }).catch(function (e) {
	                    return notification.log('A problem occurred, please try again', { addnCls: 'humane-flatty-error' }) && console.error(e);
	                });
	            };
	        },
	        template: ' <a ng-if="review.values.status == \'pending\'" class="btn btn-outline btn-success" ng-class="size ? \'btn-\' + size : \'\'" ng-click="approve(\'accepted\')">\n    <span class="glyphicon glyphicon-thumbs-up" aria-hidden="true"></span>&nbsp;Accept\n</a>\n<a ng-if="review.values.status == \'pending\'" class="btn btn-outline btn-danger" ng-class="size ? \'btn-\' + size : \'\'" ng-click="approve(\'rejected\')">\n    <span class="glyphicon glyphicon-thumbs-down" aria-hidden="true"></span>&nbspReject\n</a>'
	    };
	}
	
	approveReview.$inject = ['Restangular', '$state', 'notification'];
	
	exports.default = approveReview;
	module.exports = exports['default'];

/***/ },
/* 158 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function batchApprove(Restangular, $q, notification, $state) {
	    'use strict';
	
	    return {
	        restrict: 'E',
	        scope: {
	            selection: '=',
	            type: '@'
	        },
	        link: function link(scope, element, attrs) {
	            var status = attrs.type == 'accept' ? 'accepted' : 'rejected';
	            scope.icon = attrs.type == 'accept' ? 'glyphicon-thumbs-up' : 'glyphicon-thumbs-down';
	            scope.label = attrs.type == 'accept' ? 'Accept' : 'Reject';
	            scope.updateStatus = function () {
	                $q.all(scope.selection.map(function (e) {
	                    return Restangular.one('reviews', e.values.id).get();
	                })).then(function (reviewReponses) {
	                    return reviewReponses.map(function (r) {
	                        return r.data;
	                    });
	                }).then(function (reviews) {
	                    return reviews.map(function (review) {
	                        // your API my support batch updates, this one doesn't, so we iterate
	                        review.status = status;
	                        return review.put(); // review.put() is a promise
	                    });
	                }) // this executes all put() promises in parallel and returns
	                .then(function () {
	                    return $state.reload();
	                }).then(function () {
	                    return notification.log(scope.selection.length + ' reviews ' + status, { addnCls: 'humane-flatty-success' });
	                }).catch(function (e) {
	                    return notification.log('A problem occurred, please try again', { addnCls: 'humane-flatty-error' }) && console.error(e);
	                });
	            };
	        },
	        template: ' <span ng-click="updateStatus()"><span class="glyphicon {{ icon }}" aria-hidden="true"></span>&nbsp;{{ label }}</span>'
	    };
	}
	
	batchApprove.$inject = ['Restangular', '$q', 'notification', '$state'];
	
	exports.default = batchApprove;
	module.exports = exports['default'];

/***/ },
/* 159 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var statuses = ['pending', 'accepted', 'rejected'];
	    var statusChoices = statuses.map(function (status) {
	        return { label: status, value: status };
	    });
	
	    var reviews = admin.getEntity('reviews');
	    reviews.listView().sortField('date').sortDir('DESC').fields([nga.field('date', 'datetime'), nga.field('customer_id', 'reference').label('Customer').targetEntity(admin.getEntity('customers')).targetField(nga.field('last_name').map(function (v, e) {
	        return e.first_name + ' ' + e.last_name;
	    })).singleApiCall(function (ids) {
	        return { 'id': ids };
	    }).cssClasses('hidden-xs'), nga.field('product_id', 'reference').label('Product').targetEntity(admin.getEntity('products')).targetField(nga.field('reference')).singleApiCall(function (ids) {
	        return { 'id': ids };
	    }).cssClasses('hidden-xs'), nga.field('rating', 'template').template(function (entry) {
	        return '<star-rating stars="' + entry.values.rating + '"></star-rating>';
	    }), nga.field('comment').map(function truncate(value) {
	        if (!value) {
	            return '';
	        }
	        return value.length > 50 ? value.substr(0, 50) + '...' : value;
	    }).cssClasses('hidden-xs'), nga.field('status', 'choice').choices(statusChoices).cssClasses(function (entry) {
	        // add custom CSS classes to inputs and columns
	        if (!entry) return;
	        if (entry.values.status == 'accepted') {
	            return 'text-center bg-success';
	        }
	        if (entry.values.status == 'rejected') {
	            return 'text-center bg-danger';
	        }
	        return 'text-center bg-warning';
	    })]).filters([nga.field('q', 'template').label('').pinned(true).template('<div class="input-group"><input type="text" ng-model="value" placeholder="Search" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>'), nga.field('status', 'choice').choices(statusChoices), nga.field('customer_id', 'reference').label('Customer').targetEntity(admin.getEntity('customers')).targetField(nga.field('last_name').map(function (v, e) {
	        return e.first_name + ' ' + e.last_name;
	    })).remoteComplete(true, {
	        searchQuery: function searchQuery(search) {
	            return { q: search };
	        }
	    }), nga.field('product_id', 'reference').label('Product').targetEntity(admin.getEntity('products')).targetField(nga.field('reference')).remoteComplete(true, {
	        searchQuery: function searchQuery(search) {
	            return { q: search };
	        }
	    }), nga.field('date_gte', 'datetime').label('Posted since'), nga.field('date_lte', 'datetime').label('Posted before')]).listActions(['<ma-edit-button entry="::entry" entity="::entity" size="xs" label="Details"></ma-edit-button>', '<approve-review size="xs" review="entry"></approve-review>']).batchActions(['<batch-approve type="accept" selection="selection"></batch-approve>', '<batch-approve type="reject" selection="selection"></batch-approve>', 'delete']);
	
	    reviews.editionView().fields([nga.field('date', 'datetime').editable(false), nga.field('customer_id', 'reference').label('Customer').targetEntity(admin.getEntity('customers')).targetField(nga.field('last_name').map(function (v, e) {
	        return e.first_name + ' ' + e.last_name;
	    })).editable(false), nga.field('command_id', 'reference').label('Command').targetEntity(admin.getEntity('commands')).targetField(nga.field('reference')).editable(false), nga.field('product_id', 'reference').label('Product').targetEntity(admin.getEntity('products')).targetField(nga.field('reference')).editable(false), nga.field('rating', 'template').template('<star-rating stars="{{ entry.values.rating }}"></star-rating>').editable(false), nga.field('comment', 'text'), nga.field('status', 'choice').choices(statusChoices)]).actions(['<approve-review review="entry"></approve-review>', 'list', 'delete']);
	
	    return reviews;
	};
	
	module.exports = exports['default'];

/***/ },
/* 160 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function starRating() {
	    'use strict';
	
	    return {
	        restrict: 'E',
	        scope: {
	            stars: '@'
	        },
	        link: function link(scope, elm, attrs, ctrl) {
	            scope.starsArray = Array.apply(null, { length: parseInt(scope.stars) }).map(Number.call, Number);
	        },
	        template: '<i ng-repeat="star in starsArray" class="glyphicon glyphicon-star"></i>'
	    };
	}
	
	starRating.$inject = [];
	
	exports.default = starRating;
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($stateProvider) {
	    $stateProvider.state('segments', {
	        parent: 'ng-admin',
	        url: '/segments',
	        params: {},
	        controller: ['$scope', function ($scope) {
	            $scope.segments = _segments2.default.values;
	        }],
	        template: _segmentsTemplate2.default
	    });
	};
	
	var _segmentsTemplate = __webpack_require__(348);
	
	var _segmentsTemplate2 = _interopRequireDefault(_segmentsTemplate);
	
	var _segments = __webpack_require__(37);
	
	var _segments2 = _interopRequireDefault(_segments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	module.exports = exports['default'];

/***/ },
/* 162 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	
	    var settings = admin.getEntity('settings');
	
	    settings.editionView().title('Site Configuration').fields([nga.field('configuration', 'json').label('')]).actions(['show']);
	
	    settings.showView().title('Site Configuration').fields(settings.editionView().fields()).actions(['edit']);;
	
	    return settings;
	};
	
	module.exports = exports['default'];

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _NumberField2 = __webpack_require__(166);
	
	var _NumberField3 = _interopRequireDefault(_NumberField2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AmountField = function (_NumberField) {
	    _inherits(AmountField, _NumberField);
	
	    function AmountField(name) {
	        _classCallCheck(this, AmountField);
	
	        var _this = _possibleConstructorReturn(this, (AmountField.__proto__ || Object.getPrototypeOf(AmountField)).call(this, name));
	
	        _this._currency = '$';
	        _this._type = "amount";
	        _this._baseFormat = '0.00';
	        _this._format = _this._currency + _this._baseFormat;
	        return _this;
	    }
	
	    _createClass(AmountField, [{
	        key: "currency",
	        value: function currency(_currency) {
	            if (!arguments.length) return this._currency;
	            this._currency = _currency;
	            this._format = _currency + this._baseFormat;
	            return this;
	        }
	    }]);
	
	    return AmountField;
	}(_NumberField3.default);
	
	exports.default = AmountField;
	module.exports = exports["default"];

/***/ },
/* 164 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-number-column field="::field" value="::entry.values[field.name()]"></ma-number-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ng-click="gotoDetail()">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field type="number" step="any" field="::field" value="values[field.name()]"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="input-group"><span class="input-group-addon">{{ field.currency() }}</span><ma-input-field type="number" step="any" field="::field" value="entry.values[field.name()]"></ma-input-field></div>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _stringUtils = __webpack_require__(167);
	
	var _stringUtils2 = _interopRequireDefault(_stringUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Field = function () {
	    function Field(name) {
	        _classCallCheck(this, Field);
	
	        this._name = name || Math.random().toString(36).substring(7);
	        this._detailLink = name === 'id';
	        this._type = "string";
	        this._order = null;
	        this._label = null;
	        this._maps = [];
	        this._transforms = [];
	        this._attributes = {};
	        this._cssClasses = null;
	        this._validation = { required: false, minlength: 0, maxlength: 99999 };
	        this._defaultValue = null;
	        this._editable = true;
	        this._detailLinkRoute = 'edit';
	        this._pinned = false;
	        this._flattenable = true;
	        this.dashboard = true;
	        this.list = true;
	        this._template = function () {
	            return '';
	        };
	    }
	
	    _createClass(Field, [{
	        key: "label",
	        value: function label() {
	            if (arguments.length) {
	                this._label = arguments[0];
	                return this;
	            }
	
	            if (this._label === null) {
	                return _stringUtils2.default.camelCase(this._name);
	            }
	
	            return this._label;
	        }
	    }, {
	        key: "type",
	        value: function type() {
	            return this._type;
	        }
	    }, {
	        key: "name",
	        value: function name() {
	            if (arguments.length) {
	                this._name = arguments[0];
	                return this;
	            }
	
	            return this._name;
	        }
	    }, {
	        key: "order",
	        value: function order() {
	            if (arguments.length) {
	                if (arguments[1] !== true) {
	                    console.warn('Setting order with Field.order is deprecated, order directly in fields array');
	                }
	                this._order = arguments[0];
	                return this;
	            }
	
	            return this._order;
	        }
	    }, {
	        key: "isDetailLink",
	        value: function isDetailLink(detailLink) {
	            if (arguments.length) {
	                this._detailLink = arguments[0];
	                return this;
	            }
	
	            if (this._detailLink === null) {
	                return this._name === 'id';
	            }
	
	            return this._detailLink;
	        }
	    }, {
	        key: "map",
	
	
	        /**
	         * Add a function to be applied to the response object to turn it into an entry
	         */
	        value: function map(fn) {
	            if (!fn) return this._maps;
	            if (typeof fn !== "function") {
	                var type = typeof fn === "undefined" ? "undefined" : _typeof(fn);
	                throw new Error("Map argument should be a function, " + type + " given.");
	            }
	
	            this._maps.push(fn);
	
	            return this;
	        }
	    }, {
	        key: "hasMaps",
	        value: function hasMaps() {
	            return !!this._maps.length;
	        }
	    }, {
	        key: "getMappedValue",
	        value: function getMappedValue(value, entry) {
	            for (var i in this._maps) {
	                value = this._maps[i](value, entry);
	            }
	
	            return value;
	        }
	
	        /**
	         * Add a function to be applied to the entry to turn it into a response object
	         */
	
	    }, {
	        key: "transform",
	        value: function transform(fn) {
	            if (!fn) return this._transforms;
	            if (typeof fn !== "function") {
	                var type = typeof fn === "undefined" ? "undefined" : _typeof(fn);
	                throw new Error("transform argument should be a function, " + type + " given.");
	            }
	
	            this._transforms.push(fn);
	
	            return this;
	        }
	    }, {
	        key: "hasTranforms",
	        value: function hasTranforms() {
	            return !!this._transforms.length;
	        }
	    }, {
	        key: "getTransformedValue",
	        value: function getTransformedValue(value, entry) {
	            for (var i in this._transforms) {
	                value = this._transforms[i](value, entry);
	            }
	
	            return value;
	        }
	    }, {
	        key: "attributes",
	        value: function attributes(_attributes) {
	            if (!arguments.length) {
	                return this._attributes;
	            }
	
	            this._attributes = _attributes;
	
	            return this;
	        }
	    }, {
	        key: "cssClasses",
	        value: function cssClasses(classes) {
	            if (!arguments.length) return this._cssClasses;
	            this._cssClasses = classes;
	            return this;
	        }
	    }, {
	        key: "getCssClasses",
	        value: function getCssClasses(entry) {
	            if (!this._cssClasses) {
	                return '';
	            }
	
	            if (this._cssClasses.constructor === Array) {
	                return this._cssClasses.join(' ');
	            }
	
	            if (typeof this._cssClasses === 'function') {
	                return this._cssClasses(entry);
	            }
	
	            return this._cssClasses;
	        }
	    }, {
	        key: "validation",
	        value: function validation(_validation) {
	            if (!arguments.length) {
	                return this._validation;
	            }
	
	            for (var property in _validation) {
	                if (!_validation.hasOwnProperty(property)) continue;
	                if (_validation[property] === null) {
	                    delete this._validation[property];
	                } else {
	                    this._validation[property] = _validation[property];
	                }
	            }
	
	            return this;
	        }
	    }, {
	        key: "defaultValue",
	        value: function defaultValue(_defaultValue) {
	            if (!arguments.length) return this._defaultValue;
	            this._defaultValue = _defaultValue;
	            return this;
	        }
	    }, {
	        key: "editable",
	        value: function editable(_editable) {
	            if (!arguments.length) return this._editable;
	            this._editable = _editable;
	            return this;
	        }
	    }, {
	        key: "detailLinkRoute",
	        value: function detailLinkRoute(route) {
	            if (!arguments.length) return this._detailLinkRoute;
	            this._detailLinkRoute = route;
	            return this;
	        }
	    }, {
	        key: "pinned",
	        value: function pinned(_pinned) {
	            if (!arguments.length) return this._pinned;
	            this._pinned = _pinned;
	            return this;
	        }
	    }, {
	        key: "flattenable",
	        value: function flattenable() {
	            return this._flattenable;
	        }
	    }, {
	        key: "getTemplateValue",
	        value: function getTemplateValue(data) {
	            if (typeof this._template === 'function') {
	                return this._template(data);
	            }
	
	            return this._template;
	        }
	    }, {
	        key: "template",
	        value: function template(_template) {
	            if (!arguments.length) return this._template;
	            this._template = _template;
	            return this;
	        }
	    }, {
	        key: "detailLink",
	        set: function set(isDetailLink) {
	            return this._detailLink = isDetailLink;
	        }
	    }]);
	
	    return Field;
	}();
	
	exports.default = Field;
	module.exports = exports["default"];

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Field2 = __webpack_require__(165);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NumberField = function (_Field) {
	    _inherits(NumberField, _Field);
	
	    function NumberField(name) {
	        _classCallCheck(this, NumberField);
	
	        var _this = _possibleConstructorReturn(this, (NumberField.__proto__ || Object.getPrototypeOf(NumberField)).call(this, name));
	
	        _this._type = "number";
	        _this._format = undefined;
	        return _this;
	    }
	
	    /**
	     * Specify format pattern for number to string conversion. 
	     *
	     * Based on NumeralJs, which uses a syntax similar to Excel.
	     *
	     * {@link} http://numeraljs.com/
	     * {@link} https://github.com/baumandm/angular-numeraljs
	     * {@example}
	     *
	     *     nga.field('height', 'number').format('$0,0.00');
	     */
	
	
	    _createClass(NumberField, [{
	        key: "format",
	        value: function format(value) {
	            if (!arguments.length) return this._format;
	            this._format = value;
	            return this;
	        }
	    }, {
	        key: "fractionSize",
	        value: function fractionSize(decimals) {
	            console.warn('NumberField.fractionSize() is deprecated, use NumberField.format() instead');
	            this.format('0.' + '0'.repeat(decimals));
	            return this;
	        }
	    }]);
	
	    return NumberField;
	}(_Field3.default);
	
	exports.default = NumberField;
	module.exports = exports["default"];

/***/ },
/* 167 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    /**
	     * @see http://stackoverflow.com/questions/10425287/convert-string-to-camelcase-with-regular-expression
	     * @see http://phpjs.org/functions/ucfirst/
	     */
	    camelCase: function camelCase(text) {
	        if (!text) {
	            return text;
	        }
	
	        var f = text.charAt(0).toUpperCase();
	        text = f + text.substr(1);
	
	        return text.replace(/[-_.\s](.)/g, function (match, group1) {
	            return ' ' + group1.toUpperCase();
	        });
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * AngularJS filter for Numeral.js: number formatting as a filter
	 * @version v1.3.2 - 2016-12-27
	 * @link https://github.com/baumandm/angular-numeraljs
	 * @author Dave Bauman <baumandm@gmail.com>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (root, factory) {
	    if (( false ? 'undefined' : _typeof(exports)) === 'object') {
	        // CommonJS
	        module.exports = factory(__webpack_require__(31));
	    } else if (true) {
	        // AMD
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_RESULT__ = function (numeral) {
	            return root.ngNumeraljs = factory(numeral);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        // Global Variables
	        root.ngNumeraljs = factory(root.numeral);
	    }
	})(undefined, function (numeral) {
	    return angular.module('ngNumeraljs', []).provider('$numeraljsConfig', function () {
	        var formats = {};
	
	        this.setFormat = function (name, format) {
	            formats[name] = format;
	        };
	
	        this.setDefaultFormat = function (format) {
	            numeral.defaultFormat(format);
	        };
	
	        this.setLanguage = function (lang, def) {
	            numeral.language(lang, def);
	        };
	
	        this.setCurrentLanguage = function (lang) {
	            numeral.language(lang);
	        };
	
	        this.$get = function () {
	            return {
	                customFormat: function customFormat(name) {
	                    return formats[name] || name;
	                },
	
	                setCurrentLanguage: this.setCurrentLanguage,
	
	                setDefaultFormat: this.setDefaultFormat,
	
	                setFormat: this.setFormat,
	
	                setLanguage: this.setLanguage
	            };
	        };
	    }).filter('numeraljs', ['$numeraljsConfig', function ($numeraljsConfig) {
	        return function (input, format) {
	            if (input == null) {
	                return input;
	            }
	
	            format = $numeraljsConfig.customFormat(format);
	
	            return numeral(input).format(format);
	        };
	    }]);
	});

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*!
	 * angular-translate - v2.13.1 - 2016-12-06
	 * 
	 * Copyright (c) 2016 The angular-translate team, Pascal Precht; Licensed MIT
	 */(function(root,factory){if(true){// AMD. Register as an anonymous module unless amdModuleId is set
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return factory();}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else if((typeof exports==='undefined'?'undefined':_typeof(exports))==='object'){// Node. Does not work with strict CommonJS, but
	// only CommonJS-like environments that support module.exports,
	// like Node.
	module.exports=factory();}else{factory();}})(undefined,function(){/**
	 * @ngdoc overview
	 * @name pascalprecht.translate
	 *
	 * @description
	 * The main module which holds everything together.
	 */runTranslate.$inject=['$translate'];$translate.$inject=['$STORAGE_KEY','$windowProvider','$translateSanitizationProvider','pascalprechtTranslateOverrider'];$translateDefaultInterpolation.$inject=['$interpolate','$translateSanitization'];translateDirective.$inject=['$translate','$interpolate','$compile','$parse','$rootScope'];translateAttrDirective.$inject=['$translate','$rootScope'];translateCloakDirective.$inject=['$translate','$rootScope'];translateFilterFactory.$inject=['$parse','$translate'];$translationCache.$inject=['$cacheFactory'];angular.module('pascalprecht.translate',['ng']).run(runTranslate);function runTranslate($translate){'use strict';var key=$translate.storageKey(),storage=$translate.storage();var fallbackFromIncorrectStorageValue=function fallbackFromIncorrectStorageValue(){var preferred=$translate.preferredLanguage();if(angular.isString(preferred)){$translate.use(preferred);// $translate.use() will also remember the language.
	// So, we don't need to call storage.put() here.
	}else{storage.put(key,$translate.use());}};fallbackFromIncorrectStorageValue.displayName='fallbackFromIncorrectStorageValue';if(storage){if(!storage.get(key)){fallbackFromIncorrectStorageValue();}else{$translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);}}else if(angular.isString($translate.preferredLanguage())){$translate.use($translate.preferredLanguage());}}runTranslate.displayName='runTranslate';/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateSanitizationProvider
	 *
	 * @description
	 *
	 * Configurations for $translateSanitization
	 */angular.module('pascalprecht.translate').provider('$translateSanitization',$translateSanitizationProvider);function $translateSanitizationProvider(){'use strict';var $sanitize,$sce,currentStrategy=null,// TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
	hasConfiguredStrategy=false,hasShownNoStrategyConfiguredWarning=false,strategies;/**
	   * Definition of a sanitization strategy function
	   * @callback StrategyFunction
	   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
	   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
	   * @return {string|object}
	   *//**
	   * @ngdoc property
	   * @name strategies
	   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Following strategies are built-in:
	   * <dl>
	   *   <dt>sanitize</dt>
	   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
	   *   <dt>escape</dt>
	   *   <dd>Escapes HTML in the translation</dd>
	   *   <dt>sanitizeParameters</dt>
	   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
	   *   <dt>escapeParameters</dt>
	   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
	   *   <dt>escaped</dt>
	   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
	   * </dl>
	   *
	   */strategies={sanitize:function sanitize(value,mode/*, context*/){if(mode==='text'){value=htmlSanitizeValue(value);}return value;},escape:function escape(value,mode/*, context*/){if(mode==='text'){value=htmlEscapeValue(value);}return value;},sanitizeParameters:function sanitizeParameters(value,mode/*, context*/){if(mode==='params'){value=mapInterpolationParameters(value,htmlSanitizeValue);}return value;},escapeParameters:function escapeParameters(value,mode/*, context*/){if(mode==='params'){value=mapInterpolationParameters(value,htmlEscapeValue);}return value;},sce:function sce(value,mode,context){if(mode==='text'){value=htmlTrustValue(value);}else if(mode==='params'){if(context!=='filter'){// do html escape in filter context #1101
	value=mapInterpolationParameters(value,htmlEscapeValue);}}return value;},sceParameters:function sceParameters(value,mode/*, context*/){if(mode==='params'){value=mapInterpolationParameters(value,htmlTrustValue);}return value;}};// Support legacy strategy name 'escaped' for backwards compatibility.
	// TODO should be removed in 3.0
	strategies.escaped=strategies.escapeParameters;/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Adds a sanitization strategy to the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @param {StrategyFunction} strategyFunction - strategy function
	   * @returns {object} this
	   */this.addStrategy=function(strategyName,strategyFunction){strategies[strategyName]=strategyFunction;return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Removes a sanitization strategy from the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @returns {object} this
	   */this.removeStrategy=function(strategyName){delete strategies[strategyName];return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	   *
	   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	   * @returns {object} this
	   */this.useStrategy=function(strategy){hasConfiguredStrategy=true;currentStrategy=strategy;return this;};/**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateSanitization
	   * @requires $injector
	   * @requires $log
	   *
	   * @description
	   * Sanitizes interpolation parameters and translated texts.
	   *
	   */this.$get=['$injector','$log',function($injector,$log){var cachedStrategyMap={};var applyStrategies=function applyStrategies(value,mode,context,selectedStrategies){angular.forEach(selectedStrategies,function(selectedStrategy){if(angular.isFunction(selectedStrategy)){value=selectedStrategy(value,mode,context);}else if(angular.isFunction(strategies[selectedStrategy])){value=strategies[selectedStrategy](value,mode,context);}else if(angular.isString(strategies[selectedStrategy])){if(!cachedStrategyMap[strategies[selectedStrategy]]){try{cachedStrategyMap[strategies[selectedStrategy]]=$injector.get(strategies[selectedStrategy]);}catch(e){cachedStrategyMap[strategies[selectedStrategy]]=function(){};throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \''+selectedStrategy+'\'');}}value=cachedStrategyMap[strategies[selectedStrategy]](value,mode,context);}else{throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \''+selectedStrategy+'\'');}});return value;};// TODO: should be removed in 3.0
	var showNoStrategyConfiguredWarning=function showNoStrategyConfiguredWarning(){if(!hasConfiguredStrategy&&!hasShownNoStrategyConfiguredWarning){$log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');hasShownNoStrategyConfiguredWarning=true;}};if($injector.has('$sanitize')){$sanitize=$injector.get('$sanitize');}if($injector.has('$sce')){$sce=$injector.get('$sce');}return{/**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#useStrategy
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	       *
	       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	       */useStrategy:function(self){return function(strategy){self.useStrategy(strategy);};}(this),/**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#sanitize
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Sanitizes a value.
	       *
	       * @param {string|object} value The value which should be sanitized.
	       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
	       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
	       * @param {string} [context] The context of this call: filter, service. Default is service
	       * @returns {string|object} sanitized value
	       */sanitize:function sanitize(value,mode,strategy,context){if(!currentStrategy){showNoStrategyConfiguredWarning();}if(!strategy&&strategy!==null){strategy=currentStrategy;}if(!strategy){return value;}if(!context){context='service';}var selectedStrategies=angular.isArray(strategy)?strategy:[strategy];return applyStrategies(value,mode,context,selectedStrategies);}};}];var htmlEscapeValue=function htmlEscapeValue(value){var element=angular.element('<div></div>');element.text(value);// not chainable, see #1044
	return element.html();};var htmlSanitizeValue=function htmlSanitizeValue(value){if(!$sanitize){throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');}return $sanitize(value);};var htmlTrustValue=function htmlTrustValue(value){if(!$sce){throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');}return $sce.trustAsHtml(value);};var mapInterpolationParameters=function mapInterpolationParameters(value,iteratee,stack){if(angular.isDate(value)){return value;}else if(angular.isObject(value)){var result=angular.isArray(value)?[]:{};if(!stack){stack=[];}else{if(stack.indexOf(value)>-1){throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');}}stack.push(value);angular.forEach(value,function(propertyValue,propertyKey){/* Skipping function properties. */if(angular.isFunction(propertyValue)){return;}result[propertyKey]=mapInterpolationParameters(propertyValue,iteratee,stack);});stack.splice(-1,1);// remove last
	return result;}else if(angular.isNumber(value)){return value;}else{return iteratee(value);}};}/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateProvider
	 * @description
	 *
	 * $translateProvider allows developers to register translation-tables, asynchronous loaders
	 * and similar to configure translation behavior directly inside of a module.
	 *
	 */angular.module('pascalprecht.translate').constant('pascalprechtTranslateOverrider',{}).provider('$translate',$translate);function $translate($STORAGE_KEY,$windowProvider,$translateSanitizationProvider,pascalprechtTranslateOverrider){'use strict';var $translationTable={},$preferredLanguage,$availableLanguageKeys=[],$languageKeyAliases,$fallbackLanguage,$fallbackWasString,$uses,$nextLang,$storageFactory,$storageKey=$STORAGE_KEY,$storagePrefix,$missingTranslationHandlerFactory,$interpolationFactory,$interpolatorFactories=[],$loaderFactory,$cloakClassName='translate-cloak',$loaderOptions,$notFoundIndicatorLeft,$notFoundIndicatorRight,$postCompilingEnabled=false,$forceAsyncReloadEnabled=false,$nestedObjectDelimeter='.',$isReady=false,$keepContent=false,loaderCache,directivePriority=0,statefulFilter=true,postProcessFn,uniformLanguageTagResolver='default',languageTagResolver={'default':function _default(tag){return(tag||'').split('-').join('_');},java:function java(tag){var temp=(tag||'').split('-').join('_');var parts=temp.split('_');return parts.length>1?parts[0].toLowerCase()+'_'+parts[1].toUpperCase():temp;},bcp47:function bcp47(tag){var temp=(tag||'').split('_').join('-');var parts=temp.split('-');return parts.length>1?parts[0].toLowerCase()+'-'+parts[1].toUpperCase():temp;},'iso639-1':function iso6391(tag){var temp=(tag||'').split('_').join('-');var parts=temp.split('-');return parts[0].toLowerCase();}};var version='2.13.1';// tries to determine the browsers language
	var getFirstBrowserLanguage=function getFirstBrowserLanguage(){// internal purpose only
	if(angular.isFunction(pascalprechtTranslateOverrider.getLocale)){return pascalprechtTranslateOverrider.getLocale();}var nav=$windowProvider.$get().navigator,browserLanguagePropertyKeys=['language','browserLanguage','systemLanguage','userLanguage'],i,language;// support for HTML 5.1 "navigator.languages"
	if(angular.isArray(nav.languages)){for(i=0;i<nav.languages.length;i++){language=nav.languages[i];if(language&&language.length){return language;}}}// support for other well known properties in browsers
	for(i=0;i<browserLanguagePropertyKeys.length;i++){language=nav[browserLanguagePropertyKeys[i]];if(language&&language.length){return language;}}return null;};getFirstBrowserLanguage.displayName='angular-translate/service: getFirstBrowserLanguage';// tries to determine the browsers locale
	var getLocale=function getLocale(){var locale=getFirstBrowserLanguage()||'';if(languageTagResolver[uniformLanguageTagResolver]){locale=languageTagResolver[uniformLanguageTagResolver](locale);}return locale;};getLocale.displayName='angular-translate/service: getLocale';/**
	   * @name indexOf
	   * @private
	   *
	   * @description
	   * indexOf polyfill. Kinda sorta.
	   *
	   * @param {array} array Array to search in.
	   * @param {string} searchElement Element to search for.
	   *
	   * @returns {int} Index of search element.
	   */var indexOf=function indexOf(array,searchElement){for(var i=0,len=array.length;i<len;i++){if(array[i]===searchElement){return i;}}return-1;};/**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */var trim=function trim(){return this.toString().replace(/^\s+|\s+$/g,'');};var negotiateLocale=function negotiateLocale(preferred){if(!preferred){return;}var avail=[],locale=angular.lowercase(preferred),i=0,n=$availableLanguageKeys.length;for(;i<n;i++){avail.push(angular.lowercase($availableLanguageKeys[i]));}// Check for an exact match in our list of available keys
	if(indexOf(avail,locale)>-1){return preferred;}if($languageKeyAliases){var alias;for(var langKeyAlias in $languageKeyAliases){if($languageKeyAliases.hasOwnProperty(langKeyAlias)){var hasWildcardKey=false;var hasExactKey=Object.prototype.hasOwnProperty.call($languageKeyAliases,langKeyAlias)&&angular.lowercase(langKeyAlias)===angular.lowercase(preferred);if(langKeyAlias.slice(-1)==='*'){hasWildcardKey=langKeyAlias.slice(0,-1)===preferred.slice(0,langKeyAlias.length-1);}if(hasExactKey||hasWildcardKey){alias=$languageKeyAliases[langKeyAlias];if(indexOf(avail,angular.lowercase(alias))>-1){return alias;}}}}}// Check for a language code without region
	var parts=preferred.split('_');if(parts.length>1&&indexOf(avail,angular.lowercase(parts[0]))>-1){return parts[0];}// If everything fails, return undefined.
	return;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translations
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a new translation table for specific language key.
	   *
	   * To register a translation table for specific language, pass a defined language
	   * key as first parameter.
	   *
	   * <pre>
	   *  // register translation table for language: 'de_DE'
	   *  $translateProvider.translations('de_DE', {
	   *    'GREETING': 'Hallo Welt!'
	   *  });
	   *
	   *  // register another one
	   *  $translateProvider.translations('en_US', {
	   *    'GREETING': 'Hello world!'
	   *  });
	   * </pre>
	   *
	   * When registering multiple translation tables for for the same language key,
	   * the actual translation table gets extended. This allows you to define module
	   * specific translation which only get added, once a specific module is loaded in
	   * your app.
	   *
	   * Invoking this method with no arguments returns the translation table which was
	   * registered with no language key. Invoking it with a language key returns the
	   * related translation table.
	   *
	   * @param {string} langKey A language key.
	   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
	   *
	   */var translations=function translations(langKey,translationTable){if(!langKey&&!translationTable){return $translationTable;}if(langKey&&!translationTable){if(angular.isString(langKey)){return $translationTable[langKey];}}else{if(!angular.isObject($translationTable[langKey])){$translationTable[langKey]={};}angular.extend($translationTable[langKey],flatObject(translationTable));}return this;};this.translations=translations;/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#cloakClassName
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the class name for `translate-cloak` directive.
	   * Default class name is `translate-cloak`.
	   *
	   * @param {string} name translate-cloak class name
	   */this.cloakClassName=function(name){if(!name){return $cloakClassName;}$cloakClassName=name;return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the delimiter for namespaced translations.
	   * Default delimiter is `.`.
	   *
	   * @param {string} delimiter namespace separator
	   */this.nestedObjectDelimeter=function(delimiter){if(!delimiter){return $nestedObjectDelimeter;}$nestedObjectDelimeter=delimiter;return this;};/**
	   * @name flatObject
	   * @private
	   *
	   * @description
	   * Flats an object. This function is used to flatten given translation data with
	   * namespaces, so they are later accessible via dot notation.
	   */var flatObject=function flatObject(data,path,result,prevKey){var key,keyWithPath,keyWithShortPath,val;if(!path){path=[];}if(!result){result={};}for(key in data){if(!Object.prototype.hasOwnProperty.call(data,key)){continue;}val=data[key];if(angular.isObject(val)){flatObject(val,path.concat(key),result,key);}else{keyWithPath=path.length?''+path.join($nestedObjectDelimeter)+$nestedObjectDelimeter+key:key;if(path.length&&key===prevKey){// Create shortcut path (foo.bar == foo.bar.bar)
	keyWithShortPath=''+path.join($nestedObjectDelimeter);// Link it to original path
	result[keyWithShortPath]='@:'+keyWithPath;}result[keyWithPath]=val;}}return result;};flatObject.displayName='flatObject';/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#addInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Adds interpolation services to angular-translate, so it can manage them.
	   *
	   * @param {object} factory Interpolation service factory
	   */this.addInterpolation=function(factory){$interpolatorFactories.push(factory);return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use interpolation functionality of messageformat.js.
	   * This is useful when having high level pluralization and gender selection.
	   */this.useMessageFormatInterpolation=function(){return this.useInterpolation('$translateMessageFormatInterpolation');};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which interpolation style to use as default, application-wide.
	   * Simply pass a factory/service name. The interpolation service has to implement
	   * the correct interface.
	   *
	   * @param {string} factory Interpolation service name.
	   */this.useInterpolation=function(factory){$interpolationFactory=factory;return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Simply sets a sanitation strategy type.
	   *
	   * @param {string} value Strategy type.
	   */this.useSanitizeValueStrategy=function(value){$translateSanitizationProvider.useStrategy(value);return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#preferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use for translation
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **prefer**.
	   *
	   * @param {string} langKey A language key.
	   */this.preferredLanguage=function(langKey){if(langKey){setupPreferredLanguage(langKey);return this;}return $preferredLanguage;};var setupPreferredLanguage=function setupPreferredLanguage(langKey){if(langKey){$preferredLanguage=langKey;}return $preferredLanguage;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found. E.g. when
	   * setting the indicator as 'X' and one tries to translate a translation id
	   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
	   *
	   * Internally this methods sets a left indicator and a right indicator using
	   * `$translateProvider.translationNotFoundIndicatorLeft()` and
	   * `$translateProvider.translationNotFoundIndicatorRight()`.
	   *
	   * **Note**: These methods automatically add a whitespace between the indicators
	   * and the translation id.
	   *
	   * @param {string} indicator An indicator, could be any string.
	   */this.translationNotFoundIndicator=function(indicator){this.translationNotFoundIndicatorLeft(indicator);this.translationNotFoundIndicatorRight(indicator);return this;};/**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found left to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */this.translationNotFoundIndicatorLeft=function(indicator){if(!indicator){return $notFoundIndicatorLeft;}$notFoundIndicatorLeft=indicator;return this;};/**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found right to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */this.translationNotFoundIndicatorRight=function(indicator){if(!indicator){return $notFoundIndicatorRight;}$notFoundIndicatorRight=indicator;return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use when missing translations
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **fallback**.
	   *
	   * @param {string||array} langKey A language key.
	   *
	   */this.fallbackLanguage=function(langKey){fallbackStack(langKey);return this;};var fallbackStack=function fallbackStack(langKey){if(langKey){if(angular.isString(langKey)){$fallbackWasString=true;$fallbackLanguage=[langKey];}else if(angular.isArray(langKey)){$fallbackWasString=false;$fallbackLanguage=langKey;}if(angular.isString($preferredLanguage)&&indexOf($fallbackLanguage,$preferredLanguage)<0){$fallbackLanguage.push($preferredLanguage);}return this;}else{if($fallbackWasString){return $fallbackLanguage[0];}else{return $fallbackLanguage;}}};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#use
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Set which translation table to use for translation by given language key. When
	   * trying to 'use' a language which isn't provided, it'll throw an error.
	   *
	   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
	   * does the job too.
	   *
	   * @param {string} langKey A language key.
	   */this.use=function(langKey){if(langKey){if(!$translationTable[langKey]&&!$loaderFactory){// only throw an error, when not loading translation data asynchronously
	throw new Error('$translateProvider couldn\'t find translationTable for langKey: \''+langKey+'\'');}$uses=langKey;return this;}return $uses;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	   *
	   * @returns {string} the current client/browser language key
	   */this.resolveClientLocale=function(){return getLocale();};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storageKey
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which key must represent the choosed language by a user in the storage.
	   *
	   * @param {string} key A key for the storage.
	   */var storageKey=function storageKey(key){if(!key){if($storagePrefix){return $storagePrefix+$storageKey;}return $storageKey;}$storageKey=key;return this;};this.storageKey=storageKey;/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useUrlLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
	   *
	   * @param {string} url Url
	   * @param {Object=} options Optional configuration object
	   */this.useUrlLoader=function(url,options){return this.useLoader('$translateUrlLoader',angular.extend({url:url},options));};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
	   *
	   * @param {Object=} options Optional configuration object
	   */this.useStaticFilesLoader=function(options){return this.useLoader('$translateStaticFilesLoader',options);};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use any other service as loader.
	   *
	   * @param {string} loaderFactory Factory name to use
	   * @param {Object=} options Optional configuration object
	   */this.useLoader=function(loaderFactory,options){$loaderFactory=loaderFactory;$loaderOptions=options||{};return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLocalStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
	   *
	   */this.useLocalStorage=function(){return this.useStorage('$translateLocalStorage');};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useCookieStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
	   */this.useCookieStorage=function(){return this.useStorage('$translateCookieStorage');};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use custom service as storage layer.
	   */this.useStorage=function(storageFactory){$storageFactory=storageFactory;return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storagePrefix
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets prefix for storage key.
	   *
	   * @param {string} prefix Storage key prefix
	   */this.storagePrefix=function(prefix){if(!prefix){return prefix;}$storagePrefix=prefix;return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use built-in log handler when trying to translate
	   * a translation Id which doesn't exist.
	   *
	   * This is actually a shortcut method for `useMissingTranslationHandler()`.
	   *
	   */this.useMissingTranslationHandlerLog=function(){return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Expects a factory name which later gets instantiated with `$injector`.
	   * This method can be used to tell angular-translate to use a custom
	   * missingTranslationHandler. Just build a factory which returns a function
	   * and expects a translation id as argument.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.useMissingTranslationHandler('customHandler');
	   *  });
	   *
	   *  app.factory('customHandler', function (dep1, dep2) {
	   *    return function (translationId) {
	   *      // something with translationId and dep1 and dep2
	   *    };
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */this.useMissingTranslationHandler=function(factory){$missingTranslationHandlerFactory=factory;return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#usePostCompiling
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If post compiling is enabled, all translated values will be processed
	   * again with AngularJS' $compile.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.usePostCompiling(true);
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */this.usePostCompiling=function(value){$postCompilingEnabled=!!value;return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If force async reload is enabled, async loader will always be called
	   * even if $translationTable already contains the language key, adding
	   * possible new entries to the $translationTable.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.forceAsyncReload(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */this.forceAsyncReload=function(value){$forceAsyncReloadEnabled=!!value;return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which language tag should be used as a result when determining
	   * the current browser language.
	   *
	   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
	   *
	   * <pre>
	   * $translateProvider
	   *   .uniformLanguageTag('bcp47')
	   *   .determinePreferredLanguage()
	   * </pre>
	   *
	   * The resolver currently supports:
	   * * default
	   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_us
	   * * java
	   *     like default, but the second part will be always in uppercase
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_US
	   * * BCP 47 (RFC 4646 & 4647)
	   *     en-US => en-US
	   *     en_US => en-US
	   *     en-us => en-US
	   *
	   * See also:
	   * * http://en.wikipedia.org/wiki/IETF_language_tag
	   * * http://www.w3.org/International/core/langtags/
	   * * http://tools.ietf.org/html/bcp47
	   *
	   * @param {string|object} options - options (or standard)
	   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
	   */this.uniformLanguageTag=function(options){if(!options){options={};}else if(angular.isString(options)){options={standard:options};}uniformLanguageTagResolver=options.standard;return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to try to determine on its own which language key
	   * to set as preferred language. When `fn` is given, angular-translate uses it
	   * to determine a language key, otherwise it uses the built-in `getLocale()`
	   * method.
	   *
	   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
	   * `[lang]` depending on what the browser provides.
	   *
	   * Use this method at your own risk, since not all browsers return a valid
	   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
	   *
	   * @param {Function=} fn Function to determine a browser's locale
	   */this.determinePreferredLanguage=function(fn){var locale=fn&&angular.isFunction(fn)?fn():getLocale();if(!$availableLanguageKeys.length){$preferredLanguage=locale;}else{$preferredLanguage=negotiateLocale(locale)||locale;}return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a set of language keys the app will work with. Use this method in
	   * combination with
	   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	   * When available languages keys are registered, angular-translate
	   * tries to find the best fitting language key depending on the browsers locale,
	   * considering your language key convention.
	   *
	   * @param {object} languageKeys Array of language keys the your app will use
	   * @param {object=} aliases Alias map.
	   */this.registerAvailableLanguageKeys=function(languageKeys,aliases){if(languageKeys){$availableLanguageKeys=languageKeys;if(aliases){$languageKeyAliases=aliases;}return this;}return $availableLanguageKeys;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoaderCache
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a cache for internal $http based loaders.
	   * {@link pascalprecht.translate.$translationCache $translationCache}.
	   * When false the cache will be disabled (default). When true or undefined
	   * the cache will be a default (see $cacheFactory). When an object it will
	   * be treat as a cache object itself: the usage is $http({cache: cache})
	   *
	   * @param {object} cache boolean, string or cache-object
	   */this.useLoaderCache=function(cache){if(cache===false){// disable cache
	loaderCache=undefined;}else if(cache===true){// enable cache using AJS defaults
	loaderCache=true;}else if(typeof cache==='undefined'){// enable cache using default
	loaderCache='$translationCache';}else if(cache){// enable cache using given one (see $cacheFactory)
	loaderCache=cache;}return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#directivePriority
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets the default priority of the translate directive. The standard value is `0`.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {number} priority for the translate-directive
	   */this.directivePriority=function(priority){if(priority===undefined){// getter
	return directivePriority;}else{// setter with chaining
	directivePriority=priority;return this;}};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#statefulFilter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	   * have to explicit define this behavior.
	   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
	   * meaning being stateful.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {boolean} state - defines the state of the filter
	   */this.statefulFilter=function(state){if(state===undefined){// getter
	return statefulFilter;}else{// setter with chaining
	statefulFilter=state;return this;}};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#postProcess
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * The post processor will be intercept right after the translation result. It can modify the result.
	   *
	   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
	   */this.postProcess=function(fn){if(fn){postProcessFn=fn;}else{postProcessFn=undefined;}return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#keepContent
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If keepContent is set to true than translate directive will always use innerHTML
	   * as a default translation
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.keepContent(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */this.keepContent=function(value){$keepContent=!!value;return this;};/**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translate
	   * @requires $interpolate
	   * @requires $log
	   * @requires $rootScope
	   * @requires $q
	   *
	   * @description
	   * The `$translate` service is the actual core of angular-translate. It expects a translation id
	   * and optional interpolate parameters to translate contents.
	   *
	   * <pre>
	   *  $translate('HEADLINE_TEXT').then(function (translation) {
	   *    $scope.translatedText = translation;
	   *  });
	   * </pre>
	   *
	   * @param {string|array} translationId A token which represents a translation id
	   *                                     This can be optionally an array of translation ids which
	   *                                     results that the function returns an object where each key
	   *                                     is the translation id and the value the translation.
	   * @param {object=} interpolateParams An object hash for dynamic values
	   * @param {string} interpolationId The id of the interpolation to use
	   * @param {string} defaultTranslationText the optional default translation text that is written as
	   *                                        as default text in case it is not found in any configured language
	   * @param {string} forceLanguage A language to be used instead of the current language
	   * @returns {object} promise
	   */this.$get=['$log','$injector','$rootScope','$q',function($log,$injector,$rootScope,$q){var Storage,defaultInterpolator=$injector.get($interpolationFactory||'$translateDefaultInterpolation'),pendingLoader=false,interpolatorHashMap={},langPromises={},fallbackIndex,startFallbackIteration;var $translate=function $translate(translationId,interpolateParams,interpolationId,defaultTranslationText,forceLanguage){if(!$uses&&$preferredLanguage){$uses=$preferredLanguage;}var uses=forceLanguage&&forceLanguage!==$uses?// we don't want to re-negotiate $uses
	negotiateLocale(forceLanguage)||forceLanguage:$uses;// Check forceLanguage is present
	if(forceLanguage){loadTranslationsIfMissing(forceLanguage);}// Duck detection: If the first argument is an array, a bunch of translations was requested.
	// The result is an object.
	if(angular.isArray(translationId)){// Inspired by Q.allSettled by Kris Kowal
	// https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
	// This transforms all promises regardless resolved or rejected
	var translateAll=function translateAll(translationIds){var results={};// storing the actual results
	var promises=[];// promises to wait for
	// Wraps the promise a) being always resolved and b) storing the link id->value
	var translate=function translate(translationId){var deferred=$q.defer();var regardless=function regardless(value){results[translationId]=value;deferred.resolve([translationId,value]);};// we don't care whether the promise was resolved or rejected; just store the values
	$translate(translationId,interpolateParams,interpolationId,defaultTranslationText,forceLanguage).then(regardless,regardless);return deferred.promise;};for(var i=0,c=translationIds.length;i<c;i++){promises.push(translate(translationIds[i]));}// wait for all (including storing to results)
	return $q.all(promises).then(function(){// return the results
	return results;});};return translateAll(translationId);}var deferred=$q.defer();// trim off any whitespace
	if(translationId){translationId=trim.apply(translationId);}var promiseToWaitFor=function(){var promise=$preferredLanguage?langPromises[$preferredLanguage]:langPromises[uses];fallbackIndex=0;if($storageFactory&&!promise){// looks like there's no pending promise for $preferredLanguage or
	// $uses. Maybe there's one pending for a language that comes from
	// storage.
	var langKey=Storage.get($storageKey);promise=langPromises[langKey];if($fallbackLanguage&&$fallbackLanguage.length){var index=indexOf($fallbackLanguage,langKey);// maybe the language from storage is also defined as fallback language
	// we increase the fallback language index to not search in that language
	// as fallback, since it's probably the first used language
	// in that case the index starts after the first element
	fallbackIndex=index===0?1:0;// but we can make sure to ALWAYS fallback to preferred language at least
	if(indexOf($fallbackLanguage,$preferredLanguage)<0){$fallbackLanguage.push($preferredLanguage);}}}return promise;}();if(!promiseToWaitFor){// no promise to wait for? okay. Then there's no loader registered
	// nor is a one pending for language that comes from storage.
	// We can just translate.
	determineTranslation(translationId,interpolateParams,interpolationId,defaultTranslationText,uses).then(deferred.resolve,deferred.reject);}else{var promiseResolved=function promiseResolved(){// $uses may have changed while waiting
	if(!forceLanguage){uses=$uses;}determineTranslation(translationId,interpolateParams,interpolationId,defaultTranslationText,uses).then(deferred.resolve,deferred.reject);};promiseResolved.displayName='promiseResolved';promiseToWaitFor['finally'](promiseResolved);}return deferred.promise;};/**
	     * @name applyNotFoundIndicators
	     * @private
	     *
	     * @description
	     * Applies not fount indicators to given translation id, if needed.
	     * This function gets only executed, if a translation id doesn't exist,
	     * which is why a translation id is expected as argument.
	     *
	     * @param {string} translationId Translation id.
	     * @returns {string} Same as given translation id but applied with not found
	     * indicators.
	     */var applyNotFoundIndicators=function applyNotFoundIndicators(translationId){// applying notFoundIndicators
	if($notFoundIndicatorLeft){translationId=[$notFoundIndicatorLeft,translationId].join(' ');}if($notFoundIndicatorRight){translationId=[translationId,$notFoundIndicatorRight].join(' ');}return translationId;};/**
	     * @name useLanguage
	     * @private
	     *
	     * @description
	     * Makes actual use of a language by setting a given language key as used
	     * language and informs registered interpolators to also use the given
	     * key as locale.
	     *
	     * @param {string} key Locale key.
	     */var useLanguage=function useLanguage(key){$uses=key;// make sure to store new language key before triggering success event
	if($storageFactory){Storage.put($translate.storageKey(),$uses);}$rootScope.$emit('$translateChangeSuccess',{language:key});// inform default interpolator
	defaultInterpolator.setLocale($uses);var eachInterpolator=function eachInterpolator(interpolator,id){interpolatorHashMap[id].setLocale($uses);};eachInterpolator.displayName='eachInterpolatorLocaleSetter';// inform all others too!
	angular.forEach(interpolatorHashMap,eachInterpolator);$rootScope.$emit('$translateChangeEnd',{language:key});};/**
	     * @name loadAsync
	     * @private
	     *
	     * @description
	     * Kicks of registered async loader using `$injector` and applies existing
	     * loader options. When resolved, it updates translation tables accordingly
	     * or rejects with given language key.
	     *
	     * @param {string} key Language key.
	     * @return {Promise} A promise.
	     */var loadAsync=function loadAsync(key){if(!key){throw'No language key specified for loading.';}var deferred=$q.defer();$rootScope.$emit('$translateLoadingStart',{language:key});pendingLoader=true;var cache=loaderCache;if(typeof cache==='string'){// getting on-demand instance of loader
	cache=$injector.get(cache);}var loaderOptions=angular.extend({},$loaderOptions,{key:key,$http:angular.extend({},{cache:cache},$loaderOptions.$http)});var onLoaderSuccess=function onLoaderSuccess(data){var translationTable={};$rootScope.$emit('$translateLoadingSuccess',{language:key});if(angular.isArray(data)){angular.forEach(data,function(table){angular.extend(translationTable,flatObject(table));});}else{angular.extend(translationTable,flatObject(data));}pendingLoader=false;deferred.resolve({key:key,table:translationTable});$rootScope.$emit('$translateLoadingEnd',{language:key});};onLoaderSuccess.displayName='onLoaderSuccess';var onLoaderError=function onLoaderError(key){$rootScope.$emit('$translateLoadingError',{language:key});deferred.reject(key);$rootScope.$emit('$translateLoadingEnd',{language:key});};onLoaderError.displayName='onLoaderError';$injector.get($loaderFactory)(loaderOptions).then(onLoaderSuccess,onLoaderError);return deferred.promise;};if($storageFactory){Storage=$injector.get($storageFactory);if(!Storage.get||!Storage.put){throw new Error('Couldn\'t use storage \''+$storageFactory+'\', missing get() or put() method!');}}// if we have additional interpolations that were added via
	// $translateProvider.addInterpolation(), we have to map'em
	if($interpolatorFactories.length){var eachInterpolationFactory=function eachInterpolationFactory(interpolatorFactory){var interpolator=$injector.get(interpolatorFactory);// setting initial locale for each interpolation service
	interpolator.setLocale($preferredLanguage||$uses);// make'em recognizable through id
	interpolatorHashMap[interpolator.getInterpolationIdentifier()]=interpolator;};eachInterpolationFactory.displayName='interpolationFactoryAdder';angular.forEach($interpolatorFactories,eachInterpolationFactory);}/**
	     * @name getTranslationTable
	     * @private
	     *
	     * @description
	     * Returns a promise that resolves to the translation table
	     * or is rejected if an error occurred.
	     *
	     * @param langKey
	     * @returns {Q.promise}
	     */var getTranslationTable=function getTranslationTable(langKey){var deferred=$q.defer();if(Object.prototype.hasOwnProperty.call($translationTable,langKey)){deferred.resolve($translationTable[langKey]);}else if(langPromises[langKey]){var onResolve=function onResolve(data){translations(data.key,data.table);deferred.resolve(data.table);};onResolve.displayName='translationTableResolver';langPromises[langKey].then(onResolve,deferred.reject);}else{deferred.reject();}return deferred.promise;};/**
	     * @name getFallbackTranslation
	     * @private
	     *
	     * @description
	     * Returns a promise that will resolve to the translation
	     * or be rejected if no translation was found for the language.
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @returns {Q.promise}
	     */var getFallbackTranslation=function getFallbackTranslation(langKey,translationId,interpolateParams,Interpolator){var deferred=$q.defer();var onResolve=function onResolve(translationTable){if(Object.prototype.hasOwnProperty.call(translationTable,translationId)){Interpolator.setLocale(langKey);var translation=translationTable[translationId];if(translation.substr(0,2)==='@:'){getFallbackTranslation(langKey,translation.substr(2),interpolateParams,Interpolator).then(deferred.resolve,deferred.reject);}else{var interpolatedValue=Interpolator.interpolate(translationTable[translationId],interpolateParams,'service');interpolatedValue=applyPostProcessing(translationId,translationTable[translationId],interpolatedValue,interpolateParams,langKey);deferred.resolve(interpolatedValue);}Interpolator.setLocale($uses);}else{deferred.reject();}};onResolve.displayName='fallbackTranslationResolver';getTranslationTable(langKey).then(onResolve,deferred.reject);return deferred.promise;};/**
	     * @name getFallbackTranslationInstant
	     * @private
	     *
	     * @description
	     * Returns a translation
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns {string} translation
	     */var getFallbackTranslationInstant=function getFallbackTranslationInstant(langKey,translationId,interpolateParams,Interpolator,sanitizeStrategy){var result,translationTable=$translationTable[langKey];if(translationTable&&Object.prototype.hasOwnProperty.call(translationTable,translationId)){Interpolator.setLocale(langKey);result=Interpolator.interpolate(translationTable[translationId],interpolateParams,'filter',sanitizeStrategy);result=applyPostProcessing(translationId,translationTable[translationId],result,interpolateParams,langKey,sanitizeStrategy);// workaround for TrustedValueHolderType
	if(!angular.isString(result)&&angular.isFunction(result.$$unwrapTrustedValue)){var result2=result.$$unwrapTrustedValue();if(result2.substr(0,2)==='@:'){return getFallbackTranslationInstant(langKey,result2.substr(2),interpolateParams,Interpolator,sanitizeStrategy);}}else if(result.substr(0,2)==='@:'){return getFallbackTranslationInstant(langKey,result.substr(2),interpolateParams,Interpolator,sanitizeStrategy);}Interpolator.setLocale($uses);}return result;};/**
	     * @name translateByHandler
	     * @private
	     *
	     * Translate by missing translation handler.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param defaultTranslationText
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
	     * absent
	     */var translateByHandler=function translateByHandler(translationId,interpolateParams,defaultTranslationText,sanitizeStrategy){// If we have a handler factory - we might also call it here to determine if it provides
	// a default text for a translationid that can't be found anywhere in our tables
	if($missingTranslationHandlerFactory){return $injector.get($missingTranslationHandlerFactory)(translationId,$uses,interpolateParams,defaultTranslationText,sanitizeStrategy);}else{return translationId;}};/**
	     * @name resolveForFallbackLanguage
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @returns {Q.promise} Promise that will resolve to the translation.
	     */var resolveForFallbackLanguage=function resolveForFallbackLanguage(fallbackLanguageIndex,translationId,interpolateParams,Interpolator,defaultTranslationText){var deferred=$q.defer();if(fallbackLanguageIndex<$fallbackLanguage.length){var langKey=$fallbackLanguage[fallbackLanguageIndex];getFallbackTranslation(langKey,translationId,interpolateParams,Interpolator).then(function(data){deferred.resolve(data);},function(){// Look in the next fallback language for a translation.
	// It delays the resolving by passing another promise to resolve.
	return resolveForFallbackLanguage(fallbackLanguageIndex+1,translationId,interpolateParams,Interpolator,defaultTranslationText).then(deferred.resolve,deferred.reject);});}else{// No translation found in any fallback language
	// if a default translation text is set in the directive, then return this as a result
	if(defaultTranslationText){deferred.resolve(defaultTranslationText);}else{var missingTranslationHandlerTranslation=translateByHandler(translationId,interpolateParams,defaultTranslationText);// if no default translation is set and an error handler is defined, send it to the handler
	// and then return the result if it isn't undefined
	if($missingTranslationHandlerFactory&&missingTranslationHandlerTranslation){deferred.resolve(missingTranslationHandlerTranslation);}else{deferred.reject(applyNotFoundIndicators(translationId));}}}return deferred.promise;};/**
	     * @name resolveForFallbackLanguageInstant
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {string} translation
	     */var resolveForFallbackLanguageInstant=function resolveForFallbackLanguageInstant(fallbackLanguageIndex,translationId,interpolateParams,Interpolator,sanitizeStrategy){var result;if(fallbackLanguageIndex<$fallbackLanguage.length){var langKey=$fallbackLanguage[fallbackLanguageIndex];result=getFallbackTranslationInstant(langKey,translationId,interpolateParams,Interpolator,sanitizeStrategy);if(!result&&result!==''){result=resolveForFallbackLanguageInstant(fallbackLanguageIndex+1,translationId,interpolateParams,Interpolator);}}return result;};/**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @returns {Q.promise} Promise, that resolves to the translation.
	     */var fallbackTranslation=function fallbackTranslation(translationId,interpolateParams,Interpolator,defaultTranslationText){// Start with the fallbackLanguage with index 0
	return resolveForFallbackLanguage(startFallbackIteration>0?startFallbackIteration:fallbackIndex,translationId,interpolateParams,Interpolator,defaultTranslationText);};/**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @returns {String} translation
	     */var fallbackTranslationInstant=function fallbackTranslationInstant(translationId,interpolateParams,Interpolator,sanitizeStrategy){// Start with the fallbackLanguage with index 0
	return resolveForFallbackLanguageInstant(startFallbackIteration>0?startFallbackIteration:fallbackIndex,translationId,interpolateParams,Interpolator,sanitizeStrategy);};var determineTranslation=function determineTranslation(translationId,interpolateParams,interpolationId,defaultTranslationText,uses){var deferred=$q.defer();var table=uses?$translationTable[uses]:$translationTable,Interpolator=interpolationId?interpolatorHashMap[interpolationId]:defaultInterpolator;// if the translation id exists, we can just interpolate it
	if(table&&Object.prototype.hasOwnProperty.call(table,translationId)){var translation=table[translationId];// If using link, rerun $translate with linked translationId and return it
	if(translation.substr(0,2)==='@:'){$translate(translation.substr(2),interpolateParams,interpolationId,defaultTranslationText,uses).then(deferred.resolve,deferred.reject);}else{//
	var resolvedTranslation=Interpolator.interpolate(translation,interpolateParams,'service');resolvedTranslation=applyPostProcessing(translationId,translation,resolvedTranslation,interpolateParams,uses);deferred.resolve(resolvedTranslation);}}else{var missingTranslationHandlerTranslation;// for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	if($missingTranslationHandlerFactory&&!pendingLoader){missingTranslationHandlerTranslation=translateByHandler(translationId,interpolateParams,defaultTranslationText);}// since we couldn't translate the inital requested translation id,
	// we try it now with one or more fallback languages, if fallback language(s) is
	// configured.
	if(uses&&$fallbackLanguage&&$fallbackLanguage.length){fallbackTranslation(translationId,interpolateParams,Interpolator,defaultTranslationText).then(function(translation){deferred.resolve(translation);},function(_translationId){deferred.reject(applyNotFoundIndicators(_translationId));});}else if($missingTranslationHandlerFactory&&!pendingLoader&&missingTranslationHandlerTranslation){// looks like the requested translation id doesn't exists.
	// Now, if there is a registered handler for missing translations and no
	// asyncLoader is pending, we execute the handler
	if(defaultTranslationText){deferred.resolve(defaultTranslationText);}else{deferred.resolve(missingTranslationHandlerTranslation);}}else{if(defaultTranslationText){deferred.resolve(defaultTranslationText);}else{deferred.reject(applyNotFoundIndicators(translationId));}}}return deferred.promise;};var determineTranslationInstant=function determineTranslationInstant(translationId,interpolateParams,interpolationId,uses,sanitizeStrategy){var result,table=uses?$translationTable[uses]:$translationTable,Interpolator=defaultInterpolator;// if the interpolation id exists use custom interpolator
	if(interpolatorHashMap&&Object.prototype.hasOwnProperty.call(interpolatorHashMap,interpolationId)){Interpolator=interpolatorHashMap[interpolationId];}// if the translation id exists, we can just interpolate it
	if(table&&Object.prototype.hasOwnProperty.call(table,translationId)){var translation=table[translationId];// If using link, rerun $translate with linked translationId and return it
	if(translation.substr(0,2)==='@:'){result=determineTranslationInstant(translation.substr(2),interpolateParams,interpolationId,uses,sanitizeStrategy);}else{result=Interpolator.interpolate(translation,interpolateParams,'filter',sanitizeStrategy);result=applyPostProcessing(translationId,translation,result,interpolateParams,uses,sanitizeStrategy);}}else{var missingTranslationHandlerTranslation;// for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	if($missingTranslationHandlerFactory&&!pendingLoader){missingTranslationHandlerTranslation=translateByHandler(translationId,interpolateParams,sanitizeStrategy);}// since we couldn't translate the inital requested translation id,
	// we try it now with one or more fallback languages, if fallback language(s) is
	// configured.
	if(uses&&$fallbackLanguage&&$fallbackLanguage.length){fallbackIndex=0;result=fallbackTranslationInstant(translationId,interpolateParams,Interpolator,sanitizeStrategy);}else if($missingTranslationHandlerFactory&&!pendingLoader&&missingTranslationHandlerTranslation){// looks like the requested translation id doesn't exists.
	// Now, if there is a registered handler for missing translations and no
	// asyncLoader is pending, we execute the handler
	result=missingTranslationHandlerTranslation;}else{result=applyNotFoundIndicators(translationId);}}return result;};var clearNextLangAndPromise=function clearNextLangAndPromise(key){if($nextLang===key){$nextLang=undefined;}langPromises[key]=undefined;};var applyPostProcessing=function applyPostProcessing(translationId,translation,resolvedTranslation,interpolateParams,uses,sanitizeStrategy){var fn=postProcessFn;if(fn){if(typeof fn==='string'){// getting on-demand instance
	fn=$injector.get(fn);}if(fn){return fn(translationId,translation,resolvedTranslation,interpolateParams,uses,sanitizeStrategy);}}return resolvedTranslation;};var loadTranslationsIfMissing=function loadTranslationsIfMissing(key){if(!$translationTable[key]&&$loaderFactory&&!langPromises[key]){langPromises[key]=loadAsync(key).then(function(translation){translations(translation.key,translation.table);return translation;});}};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#preferredLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the preferred language.
	     *
	     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
	     *
	     * @return {string} preferred language key
	     */$translate.preferredLanguage=function(langKey){if(langKey){setupPreferredLanguage(langKey);}return $preferredLanguage;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#cloakClassName
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured class name for `translate-cloak` directive.
	     *
	     * @return {string} cloakClassName
	     */$translate.cloakClassName=function(){return $cloakClassName;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured delimiter for nested namespaces.
	     *
	     * @return {string} nestedObjectDelimeter
	     */$translate.nestedObjectDelimeter=function(){return $nestedObjectDelimeter;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#fallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the fallback languages or sets a new fallback stack.
	     *
	     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
	     *
	     * @return {string||array} fallback language key
	     */$translate.fallbackLanguage=function(langKey){if(langKey!==undefined&&langKey!==null){fallbackStack(langKey);// as we might have an async loader initiated and a new translation language might have been defined
	// we need to add the promise to the stack also. So - iterate.
	if($loaderFactory){if($fallbackLanguage&&$fallbackLanguage.length){for(var i=0,len=$fallbackLanguage.length;i<len;i++){if(!langPromises[$fallbackLanguage[i]]){langPromises[$fallbackLanguage[i]]=loadAsync($fallbackLanguage[i]);}}}}$translate.use($translate.use());}if($fallbackWasString){return $fallbackLanguage[0];}else{return $fallbackLanguage;}};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#useFallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Sets the first key of the fallback language stack to be used for translation.
	     * Therefore all languages in the fallback array BEFORE this key will be skipped!
	     *
	     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
	     * get back to the whole stack
	     */$translate.useFallbackLanguage=function(langKey){if(langKey!==undefined&&langKey!==null){if(!langKey){startFallbackIteration=0;}else{var langKeyPosition=indexOf($fallbackLanguage,langKey);if(langKeyPosition>-1){startFallbackIteration=langKeyPosition;}}}};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#proposedLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key of language that is currently loaded asynchronously.
	     *
	     * @return {string} language key
	     */$translate.proposedLanguage=function(){return $nextLang;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns registered storage.
	     *
	     * @return {object} Storage
	     */$translate.storage=function(){return Storage;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#negotiateLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a language key based on available languages and language aliases. If a
	     * language key cannot be resolved, returns undefined.
	     *
	     * If no or a falsy key is given, returns undefined.
	     *
	     * @param {string} [key] Language key
	     * @return {string|undefined} Language key or undefined if no language key is found.
	     */$translate.negotiateLocale=negotiateLocale;/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#use
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Tells angular-translate which language to use by given language key. This method is
	     * used to change language at runtime. It also takes care of storing the language
	     * key in a configured store to let your app remember the choosed language.
	     *
	     * When trying to 'use' a language which isn't available it tries to load it
	     * asynchronously with registered loaders.
	     *
	     * Returns promise object with loaded language file data or string of the currently used language.
	     *
	     * If no or a falsy key is given it returns the currently used language key.
	     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
	     * @example
	     * $translate.use("en_US").then(function(data){
	       *   $scope.text = $translate("HELLO");
	       * });
	     *
	     * @param {string} [key] Language key
	     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
	     */$translate.use=function(key){if(!key){return $uses;}var deferred=$q.defer();$rootScope.$emit('$translateChangeStart',{language:key});// Try to get the aliased language key
	var aliasedKey=negotiateLocale(key);// Ensure only registered language keys will be loaded
	if($availableLanguageKeys.length>0&&!aliasedKey){return $q.reject(key);}if(aliasedKey){key=aliasedKey;}// if there isn't a translation table for the language we've requested,
	// we load it asynchronously
	$nextLang=key;if(($forceAsyncReloadEnabled||!$translationTable[key])&&$loaderFactory&&!langPromises[key]){langPromises[key]=loadAsync(key).then(function(translation){translations(translation.key,translation.table);deferred.resolve(translation.key);if($nextLang===key){useLanguage(translation.key);}return translation;},function(key){$rootScope.$emit('$translateChangeError',{language:key});deferred.reject(key);$rootScope.$emit('$translateChangeEnd',{language:key});return $q.reject(key);});langPromises[key]['finally'](function(){clearNextLangAndPromise(key);});}else if(langPromises[key]){// we are already loading this asynchronously
	// resolve our new deferred when the old langPromise is resolved
	langPromises[key].then(function(translation){if($nextLang===translation.key){useLanguage(translation.key);}deferred.resolve(translation.key);return translation;},function(key){// find first available fallback language if that request has failed
	if(!$uses&&$fallbackLanguage&&$fallbackLanguage.length>0&&$fallbackLanguage[0]!==key){return $translate.use($fallbackLanguage[0]).then(deferred.resolve,deferred.reject);}else{return deferred.reject(key);}});}else{deferred.resolve(key);useLanguage(key);}return deferred.promise;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#resolveClientLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	     *
	     * @returns {string} the current client/browser language key
	     */$translate.resolveClientLocale=function(){return getLocale();};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storageKey
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the key for the storage.
	     *
	     * @return {string} storage key
	     */$translate.storageKey=function(){return storageKey();};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether post compiling is enabled or not
	     *
	     * @return {bool} storage key
	     */$translate.isPostCompilingEnabled=function(){return $postCompilingEnabled;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether force async reload is enabled or not
	     *
	     * @return {boolean} forceAsyncReload value
	     */$translate.isForceAsyncReloadEnabled=function(){return $forceAsyncReloadEnabled;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isKeepContent
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether keepContent or not
	     *
	     * @return {boolean} keepContent value
	     */$translate.isKeepContent=function(){return $keepContent;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#refresh
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
	     * the module will drop all existent translation tables and load new version of those which
	     * are currently in use.
	     *
	     * Refresh means that the module will drop target translation table and try to load it again.
	     *
	     * In case there are no loaders registered the refresh() method will throw an Error.
	     *
	     * If the module is able to refresh translation tables refresh() method will broadcast
	     * $translateRefreshStart and $translateRefreshEnd events.
	     *
	     * @example
	     * // this will drop all currently existent translation tables and reload those which are
	     * // currently in use
	     * $translate.refresh();
	     * // this will refresh a translation table for the en_US language
	     * $translate.refresh('en_US');
	     *
	     * @param {string} langKey A language key of the table, which has to be refreshed
	     *
	     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
	     * process is finished successfully, and reject if not.
	     */$translate.refresh=function(langKey){if(!$loaderFactory){throw new Error('Couldn\'t refresh translation table, no loader registered!');}var deferred=$q.defer();function resolve(){deferred.resolve();$rootScope.$emit('$translateRefreshEnd',{language:langKey});}function reject(){deferred.reject();$rootScope.$emit('$translateRefreshEnd',{language:langKey});}$rootScope.$emit('$translateRefreshStart',{language:langKey});if(!langKey){// if there's no language key specified we refresh ALL THE THINGS!
	var tables=[],loadingKeys={};// reload registered fallback languages
	if($fallbackLanguage&&$fallbackLanguage.length){for(var i=0,len=$fallbackLanguage.length;i<len;i++){tables.push(loadAsync($fallbackLanguage[i]));loadingKeys[$fallbackLanguage[i]]=true;}}// reload currently used language
	if($uses&&!loadingKeys[$uses]){tables.push(loadAsync($uses));}var allTranslationsLoaded=function allTranslationsLoaded(tableData){$translationTable={};angular.forEach(tableData,function(data){translations(data.key,data.table);});if($uses){useLanguage($uses);}resolve();};allTranslationsLoaded.displayName='refreshPostProcessor';$q.all(tables).then(allTranslationsLoaded,reject);}else if($translationTable[langKey]){var oneTranslationsLoaded=function oneTranslationsLoaded(data){translations(data.key,data.table);if(langKey===$uses){useLanguage($uses);}resolve();return data;};oneTranslationsLoaded.displayName='refreshPostProcessor';loadAsync(langKey).then(oneTranslationsLoaded,reject);}else{reject();}return deferred.promise;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#instant
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a translation instantly from the internal state of loaded translation. All rules
	     * regarding the current language, the preferred language of even fallback languages will be
	     * used except any promise handling. If a language was not found, an asynchronous loading
	     * will be invoked in the background.
	     *
	     * @param {string|array} translationId A token which represents a translation id
	     *                                     This can be optionally an array of translation ids which
	     *                                     results that the function's promise returns an object where
	     *                                     each key is the translation id and the value the translation.
	     * @param {object} interpolateParams Params
	     * @param {string} interpolationId The id of the interpolation to use
	     * @param {string} forceLanguage A language to be used instead of the current language
	     * @param {string} sanitizeStrategy force sanitize strategy for this call instead of using the configured one
	     *
	     * @return {string|object} translation
	     */$translate.instant=function(translationId,interpolateParams,interpolationId,forceLanguage,sanitizeStrategy){// we don't want to re-negotiate $uses
	var uses=forceLanguage&&forceLanguage!==$uses?// we don't want to re-negotiate $uses
	negotiateLocale(forceLanguage)||forceLanguage:$uses;// Detect undefined and null values to shorten the execution and prevent exceptions
	if(translationId===null||angular.isUndefined(translationId)){return translationId;}// Check forceLanguage is present
	if(forceLanguage){loadTranslationsIfMissing(forceLanguage);}// Duck detection: If the first argument is an array, a bunch of translations was requested.
	// The result is an object.
	if(angular.isArray(translationId)){var results={};for(var i=0,c=translationId.length;i<c;i++){results[translationId[i]]=$translate.instant(translationId[i],interpolateParams,interpolationId,forceLanguage,sanitizeStrategy);}return results;}// We discarded unacceptable values. So we just need to verify if translationId is empty String
	if(angular.isString(translationId)&&translationId.length<1){return translationId;}// trim off any whitespace
	if(translationId){translationId=trim.apply(translationId);}var result,possibleLangKeys=[];if($preferredLanguage){possibleLangKeys.push($preferredLanguage);}if(uses){possibleLangKeys.push(uses);}if($fallbackLanguage&&$fallbackLanguage.length){possibleLangKeys=possibleLangKeys.concat($fallbackLanguage);}for(var j=0,d=possibleLangKeys.length;j<d;j++){var possibleLangKey=possibleLangKeys[j];if($translationTable[possibleLangKey]){if(typeof $translationTable[possibleLangKey][translationId]!=='undefined'){result=determineTranslationInstant(translationId,interpolateParams,interpolationId,uses,sanitizeStrategy);}}if(typeof result!=='undefined'){break;}}if(!result&&result!==''){if($notFoundIndicatorLeft||$notFoundIndicatorRight){result=applyNotFoundIndicators(translationId);}else{// Return translation of default interpolator if not found anything.
	result=defaultInterpolator.interpolate(translationId,interpolateParams,'filter',sanitizeStrategy);// looks like the requested translation id doesn't exists.
	// Now, if there is a registered handler for missing translations and no
	// asyncLoader is pending, we execute the handler
	var missingTranslationHandlerTranslation;if($missingTranslationHandlerFactory&&!pendingLoader){missingTranslationHandlerTranslation=translateByHandler(translationId,interpolateParams,sanitizeStrategy);}if($missingTranslationHandlerFactory&&!pendingLoader&&missingTranslationHandlerTranslation){result=missingTranslationHandlerTranslation;}}}return result;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#versionInfo
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the current version information for the angular-translate library
	     *
	     * @return {string} angular-translate version
	     */$translate.versionInfo=function(){return version;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#loaderCache
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the defined loaderCache.
	     *
	     * @return {boolean|string|object} current value of loaderCache
	     */$translate.loaderCache=function(){return loaderCache;};// internal purpose only
	$translate.directivePriority=function(){return directivePriority;};// internal purpose only
	$translate.statefulFilter=function(){return statefulFilter;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
	     *
	     * @return {boolean} current value of ready
	     */$translate.isReady=function(){return $isReady;};var $onReadyDeferred=$q.defer();$onReadyDeferred.promise.then(function(){$isReady=true;});/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#onReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
	     *
	     * @param {Function=} fn Function to invoke when service is ready
	     * @return {object} Promise resolved when service is ready
	     */$translate.onReady=function(fn){var deferred=$q.defer();if(angular.isFunction(fn)){deferred.promise.then(fn);}if($isReady){deferred.resolve();}else{$onReadyDeferred.promise.then(deferred.resolve);}return deferred.promise;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This function simply returns the registered language keys being defined before in the config phase
	     * With this, an application can use the array to provide a language selection dropdown or similar
	     * without any additional effort
	     *
	     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
	     */$translate.getAvailableLanguageKeys=function(){if($availableLanguageKeys.length>0){return $availableLanguageKeys;}return null;};/**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getTranslationTable
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns translation table by the given language key.
	     *
	     * Unless a language is provided it returns a translation table of the current one.
	     * Note: If translation dictionary is currently downloading or in progress
	     * it will return null.
	     *
	     * @param {string} langKey A token which represents a translation id
	     *
	     * @return {object} a copy of angular-translate $translationTable
	     */$translate.getTranslationTable=function(langKey){langKey=langKey||$translate.use();if(langKey&&$translationTable[langKey]){return angular.copy($translationTable[langKey]);}return null;};// Whenever $translateReady is being fired, this will ensure the state of $isReady
	var globalOnReadyListener=$rootScope.$on('$translateReady',function(){$onReadyDeferred.resolve();globalOnReadyListener();// one time only
	globalOnReadyListener=null;});var globalOnChangeListener=$rootScope.$on('$translateChangeEnd',function(){$onReadyDeferred.resolve();globalOnChangeListener();// one time only
	globalOnChangeListener=null;});if($loaderFactory){// If at least one async loader is defined and there are no
	// (default) translations available we should try to load them.
	if(angular.equals($translationTable,{})){if($translate.use()){$translate.use($translate.use());}}// Also, if there are any fallback language registered, we start
	// loading them asynchronously as soon as we can.
	if($fallbackLanguage&&$fallbackLanguage.length){var processAsyncResult=function processAsyncResult(translation){translations(translation.key,translation.table);$rootScope.$emit('$translateChangeEnd',{language:translation.key});return translation;};for(var i=0,len=$fallbackLanguage.length;i<len;i++){var fallbackLanguageId=$fallbackLanguage[i];if($forceAsyncReloadEnabled||!$translationTable[fallbackLanguageId]){langPromises[fallbackLanguageId]=loadAsync(fallbackLanguageId).then(processAsyncResult);}}}}else{$rootScope.$emit('$translateReady',{language:$translate.use()});}return $translate;}];}$translate.displayName='displayName';/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateDefaultInterpolation
	 * @requires $interpolate
	 *
	 * @description
	 * Uses angular's `$interpolate` services to interpolate strings against some values.
	 *
	 * Be aware to configure a proper sanitization strategy.
	 *
	 * See also:
	 * * {@link pascalprecht.translate.$translateSanitization}
	 *
	 * @return {object} $translateDefaultInterpolation Interpolator service
	 */angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation',$translateDefaultInterpolation);function $translateDefaultInterpolation($interpolate,$translateSanitization){'use strict';var $translateInterpolator={},$locale,$identifier='default';/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Sets current locale (this is currently not use in this interpolation).
	   *
	   * @param {string} locale Language key or locale.
	   */$translateInterpolator.setLocale=function(locale){$locale=locale;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Returns an identifier for this interpolation service.
	   *
	   * @returns {string} $identifier
	   */$translateInterpolator.getInterpolationIdentifier=function(){return $identifier;};/**
	   * @deprecated will be removed in 3.0
	   * @see {@link pascalprecht.translate.$translateSanitization}
	   */$translateInterpolator.useSanitizeValueStrategy=function(value){$translateSanitization.useStrategy(value);return this;};/**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Interpolates given value agains given interpolate params using angulars
	   * `$interpolate` service.
	   *
	   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
	   *
	   * @returns {string} interpolated string.
	   */$translateInterpolator.interpolate=function(value,interpolationParams,context,sanitizeStrategy){interpolationParams=interpolationParams||{};interpolationParams=$translateSanitization.sanitize(interpolationParams,'params',sanitizeStrategy,context);var interpolatedText;if(angular.isNumber(value)){// numbers are safe
	interpolatedText=''+value;}else if(angular.isString(value)){// strings must be interpolated (that's the job here)
	interpolatedText=$interpolate(value)(interpolationParams);interpolatedText=$translateSanitization.sanitize(interpolatedText,'text',sanitizeStrategy,context);}else{// neither a number or a string, cant interpolate => empty string
	interpolatedText='';}return interpolatedText;};return $translateInterpolator;}$translateDefaultInterpolation.displayName='$translateDefaultInterpolation';angular.module('pascalprecht.translate').constant('$STORAGE_KEY','NG_TRANSLATE_LANG_KEY');angular.module('pascalprecht.translate')/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate
	 * @requires $interpolate, 
	 * @requires $compile, 
	 * @requires $parse, 
	 * @requires $rootScope
	 * @restrict AE
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses $translate service to translate the translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate Translation id which could be either string or interpolated string.
	 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
	 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
	 * @param {string=} translate-default will be used unless translation was successful
	 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
	 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre translate="TRANSLATION_ID"></pre>
	        <pre translate>TRANSLATION_ID</pre>
	        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
	        <pre translate="{{translationId}}"></pre>
	        <pre translate>{{translationId}}</pre>
	        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
	        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
	        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
	        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('title')).toBe('Hello there!');
	
	          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
	        });
	      });
	    </file>
	   </example>
	 */.directive('translate',translateDirective);function translateDirective($translate,$interpolate,$compile,$parse,$rootScope){'use strict';/**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */var trim=function trim(){return this.toString().replace(/^\s+|\s+$/g,'');};return{restrict:'AE',scope:true,priority:$translate.directivePriority(),compile:function compile(tElement,tAttr){var translateValuesExist=tAttr.translateValues?tAttr.translateValues:undefined;var translateInterpolation=tAttr.translateInterpolation?tAttr.translateInterpolation:undefined;var translateValueExist=tElement[0].outerHTML.match(/translate-value-+/i);var interpolateRegExp='^(.*)('+$interpolate.startSymbol()+'.*'+$interpolate.endSymbol()+')(.*)',watcherRegExp='^(.*)'+$interpolate.startSymbol()+'(.*)'+$interpolate.endSymbol()+'(.*)';return function linkFn(scope,iElement,iAttr){scope.interpolateParams={};scope.preText='';scope.postText='';scope.translateNamespace=getTranslateNamespace(scope);var translationIds={};var initInterpolationParams=function initInterpolationParams(interpolateParams,iAttr,tAttr){// initial setup
	if(iAttr.translateValues){angular.extend(interpolateParams,$parse(iAttr.translateValues)(scope.$parent));}// initially fetch all attributes if existing and fill the params
	if(translateValueExist){for(var attr in tAttr){if(Object.prototype.hasOwnProperty.call(iAttr,attr)&&attr.substr(0,14)==='translateValue'&&attr!=='translateValues'){var attributeName=angular.lowercase(attr.substr(14,1))+attr.substr(15);interpolateParams[attributeName]=tAttr[attr];}}}};// Ensures any change of the attribute "translate" containing the id will
	// be re-stored to the scope's "translationId".
	// If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
	var observeElementTranslation=function observeElementTranslation(translationId){// Remove any old watcher
	if(angular.isFunction(observeElementTranslation._unwatchOld)){observeElementTranslation._unwatchOld();observeElementTranslation._unwatchOld=undefined;}if(angular.equals(translationId,'')||!angular.isDefined(translationId)){var iElementText=trim.apply(iElement.text());// Resolve translation id by inner html if required
	var interpolateMatches=iElementText.match(interpolateRegExp);// Interpolate translation id if required
	if(angular.isArray(interpolateMatches)){scope.preText=interpolateMatches[1];scope.postText=interpolateMatches[3];translationIds.translate=$interpolate(interpolateMatches[2])(scope.$parent);var watcherMatches=iElementText.match(watcherRegExp);if(angular.isArray(watcherMatches)&&watcherMatches[2]&&watcherMatches[2].length){observeElementTranslation._unwatchOld=scope.$watch(watcherMatches[2],function(newValue){translationIds.translate=newValue;updateTranslations();});}}else{// do not assigne the translation id if it is empty.
	translationIds.translate=!iElementText?undefined:iElementText;}}else{translationIds.translate=translationId;}updateTranslations();};var observeAttributeTranslation=function observeAttributeTranslation(translateAttr){iAttr.$observe(translateAttr,function(translationId){translationIds[translateAttr]=translationId;updateTranslations();});};// initial setup with values
	initInterpolationParams(scope.interpolateParams,iAttr,tAttr);var firstAttributeChangedEvent=true;iAttr.$observe('translate',function(translationId){if(typeof translationId==='undefined'){// case of element "<translate>xyz</translate>"
	observeElementTranslation('');}else{// case of regular attribute
	if(translationId!==''||!firstAttributeChangedEvent){translationIds.translate=translationId;updateTranslations();}}firstAttributeChangedEvent=false;});for(var translateAttr in iAttr){if(iAttr.hasOwnProperty(translateAttr)&&translateAttr.substr(0,13)==='translateAttr'&&translateAttr.length>13){observeAttributeTranslation(translateAttr);}}iAttr.$observe('translateDefault',function(value){scope.defaultText=value;updateTranslations();});if(translateValuesExist){iAttr.$observe('translateValues',function(interpolateParams){if(interpolateParams){scope.$parent.$watch(function(){angular.extend(scope.interpolateParams,$parse(interpolateParams)(scope.$parent));});}});}if(translateValueExist){var observeValueAttribute=function observeValueAttribute(attrName){iAttr.$observe(attrName,function(value){var attributeName=angular.lowercase(attrName.substr(14,1))+attrName.substr(15);scope.interpolateParams[attributeName]=value;});};for(var attr in iAttr){if(Object.prototype.hasOwnProperty.call(iAttr,attr)&&attr.substr(0,14)==='translateValue'&&attr!=='translateValues'){observeValueAttribute(attr);}}}// Master update function
	var updateTranslations=function updateTranslations(){for(var key in translationIds){if(translationIds.hasOwnProperty(key)&&translationIds[key]!==undefined){updateTranslation(key,translationIds[key],scope,scope.interpolateParams,scope.defaultText,scope.translateNamespace);}}};// Put translation processing function outside loop
	var updateTranslation=function updateTranslation(translateAttr,translationId,scope,interpolateParams,defaultTranslationText,translateNamespace){if(translationId){// if translation id starts with '.' and translateNamespace given, prepend namespace
	if(translateNamespace&&translationId.charAt(0)==='.'){translationId=translateNamespace+translationId;}$translate(translationId,interpolateParams,translateInterpolation,defaultTranslationText,scope.translateLanguage).then(function(translation){applyTranslation(translation,scope,true,translateAttr);},function(translationId){applyTranslation(translationId,scope,false,translateAttr);});}else{// as an empty string cannot be translated, we can solve this using successful=false
	applyTranslation(translationId,scope,false,translateAttr);}};var applyTranslation=function applyTranslation(value,scope,successful,translateAttr){if(!successful){if(typeof scope.defaultText!=='undefined'){value=scope.defaultText;}}if(translateAttr==='translate'){// default translate into innerHTML
	if(successful||!successful&&!$translate.isKeepContent()&&typeof iAttr.translateKeepContent==='undefined'){iElement.empty().append(scope.preText+value+scope.postText);}var globallyEnabled=$translate.isPostCompilingEnabled();var locallyDefined=typeof tAttr.translateCompile!=='undefined';var locallyEnabled=locallyDefined&&tAttr.translateCompile!=='false';if(globallyEnabled&&!locallyDefined||locallyEnabled){$compile(iElement.contents())(scope);}}else{// translate attribute
	var attributeName=iAttr.$attr[translateAttr];if(attributeName.substr(0,5)==='data-'){// ensure html5 data prefix is stripped
	attributeName=attributeName.substr(5);}attributeName=attributeName.substr(15);iElement.attr(attributeName,value);}};if(translateValuesExist||translateValueExist||iAttr.translateDefault){scope.$watch('interpolateParams',updateTranslations,true);}// Replaced watcher on translateLanguage with event listener
	scope.$on('translateLanguageChanged',updateTranslations);// Ensures the text will be refreshed after the current language was changed
	// w/ $translate.use(...)
	var unbind=$rootScope.$on('$translateChangeSuccess',updateTranslations);// ensure translation will be looked up at least one
	if(iElement.text().length){if(iAttr.translate){observeElementTranslation(iAttr.translate);}else{observeElementTranslation('');}}else if(iAttr.translate){// ensure attribute will be not skipped
	observeElementTranslation(iAttr.translate);}updateTranslations();scope.$on('$destroy',unbind);};}};}/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */function getTranslateNamespace(scope){'use strict';if(scope.translateNamespace){return scope.translateNamespace;}if(scope.$parent){return getTranslateNamespace(scope.$parent);}}translateDirective.displayName='translateDirective';angular.module('pascalprecht.translate')/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate-attr
	 * @restrict A
	 *
	 * @description
	 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
	 * Internally it uses `translate` service to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
	 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('placeholder)).toBe('Hello there!');
	          expect(element.attr('title)).toBe('The following value is dynamic: 5');
	        });
	      });
	    </file>
	   </example>
	 */.directive('translateAttr',translateAttrDirective);function translateAttrDirective($translate,$rootScope){'use strict';return{restrict:'A',priority:$translate.directivePriority(),link:function linkFn(scope,element,attr){var translateAttr,translateValues,previousAttributes={};// Main update translations function
	var updateTranslations=function updateTranslations(){angular.forEach(translateAttr,function(translationId,attributeName){if(!translationId){return;}previousAttributes[attributeName]=true;// if translation id starts with '.' and translateNamespace given, prepend namespace
	if(scope.translateNamespace&&translationId.charAt(0)==='.'){translationId=scope.translateNamespace+translationId;}$translate(translationId,translateValues,attr.translateInterpolation,undefined,scope.translateLanguage).then(function(translation){element.attr(attributeName,translation);},function(translationId){element.attr(attributeName,translationId);});});// Removing unused attributes that were previously used
	angular.forEach(previousAttributes,function(flag,attributeName){if(!translateAttr[attributeName]){element.removeAttr(attributeName);delete previousAttributes[attributeName];}});};// Watch for attribute changes
	watchAttribute(scope,attr.translateAttr,function(newValue){translateAttr=newValue;},updateTranslations);// Watch for value changes
	watchAttribute(scope,attr.translateValues,function(newValue){translateValues=newValue;},updateTranslations);if(attr.translateValues){scope.$watch(attr.translateValues,updateTranslations,true);}// Replaced watcher on translateLanguage with event listener
	scope.$on('translateLanguageChanged',updateTranslations);// Ensures the text will be refreshed after the current language was changed
	// w/ $translate.use(...)
	var unbind=$rootScope.$on('$translateChangeSuccess',updateTranslations);updateTranslations();scope.$on('$destroy',unbind);}};}function watchAttribute(scope,attribute,valueCallback,changeCallback){'use strict';if(!attribute){return;}if(attribute.substr(0,2)==='::'){attribute=attribute.substr(2);}else{scope.$watch(attribute,function(newValue){valueCallback(newValue);changeCallback();},true);}valueCallback(scope.$eval(attribute));}translateAttrDirective.displayName='translateAttrDirective';angular.module('pascalprecht.translate')/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateCloak
	 * @requires $rootScope
	 * @requires $translate
	 * @restrict A
	 *
	 * $description
	 * Adds a `translate-cloak` class name to the given element where this directive
	 * is applied initially and removes it, once a loader has finished loading.
	 *
	 * This directive can be used to prevent initial flickering when loading translation
	 * data asynchronously.
	 *
	 * The class name is defined in
	 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
	 *
	 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
	 *                                  or hiding the cloak. Basically it relies on the translation
	 *                                  resolve.
	 */.directive('translateCloak',translateCloakDirective);function translateCloakDirective($translate,$rootScope){'use strict';return{compile:function compile(tElement){var applyCloak=function applyCloak(){tElement.addClass($translate.cloakClassName());},removeCloak=function removeCloak(){tElement.removeClass($translate.cloakClassName());};$translate.onReady(function(){removeCloak();});applyCloak();return function linkFn(scope,iElement,iAttr){if(iAttr.translateCloak&&iAttr.translateCloak.length){// Register a watcher for the defined translation allowing a fine tuned cloak
	iAttr.$observe('translateCloak',function(translationId){$translate(translationId).then(removeCloak,applyCloak);});// Register for change events as this is being another indicicator revalidating the cloak)
	$rootScope.$on('$translateChangeSuccess',function(){$translate(iAttr.translateCloak).then(removeCloak,applyCloak);});}};}};}translateCloakDirective.displayName='translateCloakDirective';angular.module('pascalprecht.translate')/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateNamespace
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate namespace name which could be either string or interpolated string.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div translate-namespace="CONTENT">
	
	        <div>
	            <h1 translate>.HEADERS.TITLE</h1>
	            <h1 translate>.HEADERS.WELCOME</h1>
	        </div>
	
	        <div translate-namespace=".HEADERS">
	            <h1 translate>.TITLE</h1>
	            <h1 translate>.WELCOME</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'CONTENT': {
	            'HEADERS': {
	                TITLE: 'Title'
	            }
	          },
	          'CONTENT.HEADERS.WELCOME': 'Welcome'
	        }).preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */.directive('translateNamespace',translateNamespaceDirective);function translateNamespaceDirective(){'use strict';return{restrict:'A',scope:true,compile:function compile(){return{pre:function pre(scope,iElement,iAttrs){scope.translateNamespace=getTranslateNamespace(scope);if(scope.translateNamespace&&iAttrs.translateNamespace.charAt(0)==='.'){scope.translateNamespace+=iAttrs.translateNamespace;}else{scope.translateNamespace=iAttrs.translateNamespace;}}};}};}/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */function getTranslateNamespace(scope){'use strict';if(scope.translateNamespace){return scope.translateNamespace;}if(scope.$parent){return getTranslateNamespace(scope.$parent);}}translateNamespaceDirective.displayName='translateNamespaceDirective';angular.module('pascalprecht.translate')/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateLanguage
	 * @restrict A
	 *
	 * @description
	 * Forces the language to the directives in the underlying scope.
	 *
	 * @param {string=} translate language that will be negotiated.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div>
	
	        <div>
	            <h1 translate>HELLO</h1>
	        </div>
	
	        <div translate-language="de">
	            <h1 translate>HELLO</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider
	          .translations('en',{
	            'HELLO': 'Hello world!'
	          })
	          .translations('de',{
	            'HELLO': 'Hallo Welt!'
	          })
	          .preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */.directive('translateLanguage',translateLanguageDirective);function translateLanguageDirective(){'use strict';return{restrict:'A',scope:true,compile:function compile(){return function linkFn(scope,iElement,iAttrs){iAttrs.$observe('translateLanguage',function(newTranslateLanguage){scope.translateLanguage=newTranslateLanguage;});scope.$watch('translateLanguage',function(){scope.$broadcast('translateLanguageChanged');});};}};}translateLanguageDirective.displayName='translateLanguageDirective';angular.module('pascalprecht.translate')/**
	 * @ngdoc filter
	 * @name pascalprecht.translate.filter:translate
	 * @requires $parse
	 * @requires pascalprecht.translate.$translate
	 * @function
	 *
	 * @description
	 * Uses `$translate` service to translate contents. Accepts interpolate parameters
	 * to pass dynamized values though translation.
	 *
	 * @param {string} translationId A translation id to be translated.
	 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
	 *
	 * @returns {string} Translated text.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
	        <pre>{{ translationId | translate }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en', {
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        });
	        $translateProvider.preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	   </example>
	 */.filter('translate',translateFilterFactory);function translateFilterFactory($parse,$translate){'use strict';var translateFilter=function translateFilter(translationId,interpolateParams,interpolation,forceLanguage){if(!angular.isObject(interpolateParams)){interpolateParams=$parse(interpolateParams)(this);}return $translate.instant(translationId,interpolateParams,interpolation,forceLanguage);};if($translate.statefulFilter()){translateFilter.$stateful=true;}return translateFilter;}translateFilterFactory.displayName='translateFilterFactory';angular.module('pascalprecht.translate')/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translationCache
	 * @requires $cacheFactory
	 *
	 * @description
	 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
	 * can load translation tables directly into the cache by consuming the
	 * `$translationCache` service directly.
	 *
	 * @return {object} $cacheFactory object.
	 */.factory('$translationCache',$translationCache);function $translationCache($cacheFactory){'use strict';return $cacheFactory('translations');}$translationCache.displayName='$translationCache';return'pascalprecht.translate';});

/***/ },
/* 170 */
/***/ function(module, exports) {

	"use strict";/*
	 * angular-ui-bootstrap
	 * http://angular-ui.github.io/bootstrap/
	
	 * Version: 1.2.5 - 2016-03-20
	 * License: MIT
	 */angular.module("ui.bootstrap",["ui.bootstrap.tpls","ui.bootstrap.collapse","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.position","ui.bootstrap.datepicker","ui.bootstrap.debounce","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.paging","ui.bootstrap.pager","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);angular.module("ui.bootstrap.tpls",["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html","uib/template/alert/alert.html","uib/template/carousel/carousel.html","uib/template/carousel/slide.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/popup.html","uib/template/datepicker/year.html","uib/template/modal/backdrop.html","uib/template/modal/window.html","uib/template/pager/pager.html","uib/template/pagination/pagination.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/progressbar/bar.html","uib/template/progressbar/progress.html","uib/template/progressbar/progressbar.html","uib/template/rating/rating.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/timepicker/timepicker.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]);angular.module('ui.bootstrap.collapse',[]).directive('uibCollapse',['$animate','$q','$parse','$injector',function($animate,$q,$parse,$injector){var $animateCss=$injector.has('$animateCss')?$injector.get('$animateCss'):null;return{link:function link(scope,element,attrs){var expandingExpr=$parse(attrs.expanding),expandedExpr=$parse(attrs.expanded),collapsingExpr=$parse(attrs.collapsing),collapsedExpr=$parse(attrs.collapsed);if(!scope.$eval(attrs.uibCollapse)){element.addClass('in').addClass('collapse').attr('aria-expanded',true).attr('aria-hidden',false).css({height:'auto'});}function expand(){if(element.hasClass('collapse')&&element.hasClass('in')){return;}$q.resolve(expandingExpr(scope)).then(function(){element.removeClass('collapse').addClass('collapsing').attr('aria-expanded',true).attr('aria-hidden',false);if($animateCss){$animateCss(element,{addClass:'in',easing:'ease',to:{height:element[0].scrollHeight+'px'}}).start()['finally'](expandDone);}else{$animate.addClass(element,'in',{to:{height:element[0].scrollHeight+'px'}}).then(expandDone);}});}function expandDone(){element.removeClass('collapsing').addClass('collapse').css({height:'auto'});expandedExpr(scope);}function collapse(){if(!element.hasClass('collapse')&&!element.hasClass('in')){return collapseDone();}$q.resolve(collapsingExpr(scope)).then(function(){element// IMPORTANT: The height must be set before adding "collapsing" class.
	// Otherwise, the browser attempts to animate from height 0 (in
	// collapsing class) to the given height here.
	.css({height:element[0].scrollHeight+'px'})// initially all panel collapse have the collapse class, this removal
	// prevents the animation from jumping to collapsed state
	.removeClass('collapse').addClass('collapsing').attr('aria-expanded',false).attr('aria-hidden',true);if($animateCss){$animateCss(element,{removeClass:'in',to:{height:'0'}}).start()['finally'](collapseDone);}else{$animate.removeClass(element,'in',{to:{height:'0'}}).then(collapseDone);}});}function collapseDone(){element.css({height:'0'});// Required so that collapse works when animation is disabled
	element.removeClass('collapsing').addClass('collapse');collapsedExpr(scope);}scope.$watch(attrs.uibCollapse,function(shouldCollapse){if(shouldCollapse){collapse();}else{expand();}});}};}]);angular.module('ui.bootstrap.accordion',['ui.bootstrap.collapse']).constant('uibAccordionConfig',{closeOthers:true}).controller('UibAccordionController',['$scope','$attrs','uibAccordionConfig',function($scope,$attrs,accordionConfig){// This array keeps track of the accordion groups
	this.groups=[];// Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	this.closeOthers=function(openGroup){var closeOthers=angular.isDefined($attrs.closeOthers)?$scope.$eval($attrs.closeOthers):accordionConfig.closeOthers;if(closeOthers){angular.forEach(this.groups,function(group){if(group!==openGroup){group.isOpen=false;}});}};// This is called from the accordion-group directive to add itself to the accordion
	this.addGroup=function(groupScope){var that=this;this.groups.push(groupScope);groupScope.$on('$destroy',function(event){that.removeGroup(groupScope);});};// This is called from the accordion-group directive when to remove itself
	this.removeGroup=function(group){var index=this.groups.indexOf(group);if(index!==-1){this.groups.splice(index,1);}};}])// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	.directive('uibAccordion',function(){return{controller:'UibAccordionController',controllerAs:'accordion',transclude:true,templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||'uib/template/accordion/accordion.html';}};})// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	.directive('uibAccordionGroup',function(){return{require:'^uibAccordion',// We need this directive to be inside an accordion
	transclude:true,// It transcludes the contents of the directive into the template
	replace:true,// The element containing the directive will be replaced with the template
	templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||'uib/template/accordion/accordion-group.html';},scope:{heading:'@',// Interpolate the heading attribute onto this scope
	panelClass:'@?',// Ditto with panelClass
	isOpen:'=?',isDisabled:'=?'},controller:function controller(){this.setHeading=function(element){this.heading=element;};},link:function link(scope,element,attrs,accordionCtrl){accordionCtrl.addGroup(scope);scope.openClass=attrs.openClass||'panel-open';scope.panelClass=attrs.panelClass||'panel-default';scope.$watch('isOpen',function(value){element.toggleClass(scope.openClass,!!value);if(value){accordionCtrl.closeOthers(scope);}});scope.toggleOpen=function($event){if(!scope.isDisabled){if(!$event||$event.which===32){scope.isOpen=!scope.isOpen;}}};var id='accordiongroup-'+scope.$id+'-'+Math.floor(Math.random()*10000);scope.headingId=id+'-tab';scope.panelId=id+'-panel';}};})// Use accordion-heading below an accordion-group to provide a heading containing HTML
	.directive('uibAccordionHeading',function(){return{transclude:true,// Grab the contents to be used as the heading
	template:'',// In effect remove this element!
	replace:true,require:'^uibAccordionGroup',link:function link(scope,element,attrs,accordionGroupCtrl,transclude){// Pass the heading to the accordion-group controller
	// so that it can be transcluded into the right place in the template
	// [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	accordionGroupCtrl.setHeading(transclude(scope,angular.noop));}};})// Use in the accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the accordion-group controller that will hold the transcluded element
	.directive('uibAccordionTransclude',function(){return{require:'^uibAccordionGroup',link:function link(scope,element,attrs,controller){scope.$watch(function(){return controller[attrs.uibAccordionTransclude];},function(heading){if(heading){var elem=angular.element(element[0].querySelector('[uib-accordion-header]'));elem.html('');elem.append(heading);}});}};});angular.module('ui.bootstrap.alert',[]).controller('UibAlertController',['$scope','$attrs','$interpolate','$timeout',function($scope,$attrs,$interpolate,$timeout){$scope.closeable=!!$attrs.close;var dismissOnTimeout=angular.isDefined($attrs.dismissOnTimeout)?$interpolate($attrs.dismissOnTimeout)($scope.$parent):null;if(dismissOnTimeout){$timeout(function(){$scope.close();},parseInt(dismissOnTimeout,10));}}]).directive('uibAlert',function(){return{controller:'UibAlertController',controllerAs:'alert',templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||'uib/template/alert/alert.html';},transclude:true,replace:true,scope:{type:'@',close:'&'}};});angular.module('ui.bootstrap.buttons',[]).constant('uibButtonConfig',{activeClass:'active',toggleEvent:'click'}).controller('UibButtonsController',['uibButtonConfig',function(buttonConfig){this.activeClass=buttonConfig.activeClass||'active';this.toggleEvent=buttonConfig.toggleEvent||'click';}]).directive('uibBtnRadio',['$parse',function($parse){return{require:['uibBtnRadio','ngModel'],controller:'UibButtonsController',controllerAs:'buttons',link:function link(scope,element,attrs,ctrls){var buttonsCtrl=ctrls[0],ngModelCtrl=ctrls[1];var uncheckableExpr=$parse(attrs.uibUncheckable);element.find('input').css({display:'none'});//model -> UI
	ngModelCtrl.$render=function(){element.toggleClass(buttonsCtrl.activeClass,angular.equals(ngModelCtrl.$modelValue,scope.$eval(attrs.uibBtnRadio)));};//ui->model
	element.on(buttonsCtrl.toggleEvent,function(){if(attrs.disabled){return;}var isActive=element.hasClass(buttonsCtrl.activeClass);if(!isActive||angular.isDefined(attrs.uncheckable)){scope.$apply(function(){ngModelCtrl.$setViewValue(isActive?null:scope.$eval(attrs.uibBtnRadio));ngModelCtrl.$render();});}});if(attrs.uibUncheckable){scope.$watch(uncheckableExpr,function(uncheckable){attrs.$set('uncheckable',uncheckable?'':undefined);});}}};}]).directive('uibBtnCheckbox',function(){return{require:['uibBtnCheckbox','ngModel'],controller:'UibButtonsController',controllerAs:'button',link:function link(scope,element,attrs,ctrls){var buttonsCtrl=ctrls[0],ngModelCtrl=ctrls[1];element.find('input').css({display:'none'});function getTrueValue(){return getCheckboxValue(attrs.btnCheckboxTrue,true);}function getFalseValue(){return getCheckboxValue(attrs.btnCheckboxFalse,false);}function getCheckboxValue(attribute,defaultValue){return angular.isDefined(attribute)?scope.$eval(attribute):defaultValue;}//model -> UI
	ngModelCtrl.$render=function(){element.toggleClass(buttonsCtrl.activeClass,angular.equals(ngModelCtrl.$modelValue,getTrueValue()));};//ui->model
	element.on(buttonsCtrl.toggleEvent,function(){if(attrs.disabled){return;}scope.$apply(function(){ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass)?getFalseValue():getTrueValue());ngModelCtrl.$render();});});}};});angular.module('ui.bootstrap.carousel',[]).controller('UibCarouselController',['$scope','$element','$interval','$timeout','$animate',function($scope,$element,$interval,$timeout,$animate){var self=this,slides=self.slides=$scope.slides=[],SLIDE_DIRECTION='uib-slideDirection',currentIndex=$scope.active,currentInterval,isPlaying,bufferedTransitions=[];var destroyed=false;self.addSlide=function(slide,element){slides.push({slide:slide,element:element});slides.sort(function(a,b){return+a.slide.index>+b.slide.index;});//if this is the first slide or the slide is set to active, select it
	if(slide.index===$scope.active||slides.length===1&&!angular.isNumber($scope.active)){if($scope.$currentTransition){$scope.$currentTransition=null;}currentIndex=slide.index;$scope.active=slide.index;setActive(currentIndex);self.select(slides[findSlideIndex(slide)]);if(slides.length===1){$scope.play();}}};self.getCurrentIndex=function(){for(var i=0;i<slides.length;i++){if(slides[i].slide.index===currentIndex){return i;}}};self.next=$scope.next=function(){var newIndex=(self.getCurrentIndex()+1)%slides.length;if(newIndex===0&&$scope.noWrap()){$scope.pause();return;}return self.select(slides[newIndex],'next');};self.prev=$scope.prev=function(){var newIndex=self.getCurrentIndex()-1<0?slides.length-1:self.getCurrentIndex()-1;if($scope.noWrap()&&newIndex===slides.length-1){$scope.pause();return;}return self.select(slides[newIndex],'prev');};self.removeSlide=function(slide){var index=findSlideIndex(slide);var bufferedIndex=bufferedTransitions.indexOf(slides[index]);if(bufferedIndex!==-1){bufferedTransitions.splice(bufferedIndex,1);}//get the index of the slide inside the carousel
	slides.splice(index,1);if(slides.length>0&&currentIndex===index){if(index>=slides.length){currentIndex=slides.length-1;$scope.active=currentIndex;setActive(currentIndex);self.select(slides[slides.length-1]);}else{currentIndex=index;$scope.active=currentIndex;setActive(currentIndex);self.select(slides[index]);}}else if(currentIndex>index){currentIndex--;$scope.active=currentIndex;}//clean the active value when no more slide
	if(slides.length===0){currentIndex=null;$scope.active=null;clearBufferedTransitions();}};/* direction: "prev" or "next" */self.select=$scope.select=function(nextSlide,direction){var nextIndex=findSlideIndex(nextSlide.slide);//Decide direction if it's not given
	if(direction===undefined){direction=nextIndex>self.getCurrentIndex()?'next':'prev';}//Prevent this user-triggered transition from occurring if there is already one in progress
	if(nextSlide.slide.index!==currentIndex&&!$scope.$currentTransition){goNext(nextSlide.slide,nextIndex,direction);}else if(nextSlide&&nextSlide.slide.index!==currentIndex&&$scope.$currentTransition){bufferedTransitions.push(slides[nextIndex]);}};/* Allow outside people to call indexOf on slides array */$scope.indexOfSlide=function(slide){return+slide.slide.index;};$scope.isActive=function(slide){return $scope.active===slide.slide.index;};$scope.pause=function(){if(!$scope.noPause){isPlaying=false;resetTimer();}};$scope.play=function(){if(!isPlaying){isPlaying=true;restartTimer();}};$scope.$on('$destroy',function(){destroyed=true;resetTimer();});$scope.$watch('noTransition',function(noTransition){$animate.enabled($element,!noTransition);});$scope.$watch('interval',restartTimer);$scope.$watchCollection('slides',resetTransition);$scope.$watch('active',function(index){if(angular.isNumber(index)&&currentIndex!==index){for(var i=0;i<slides.length;i++){if(slides[i].slide.index===index){index=i;break;}}var slide=slides[index];if(slide){currentIndex=index;setActive(index);self.select(slides[index]);}}});function clearBufferedTransitions(){while(bufferedTransitions.length){bufferedTransitions.shift();}}function getSlideByIndex(index){for(var i=0,l=slides.length;i<l;++i){if(slides[i].index===index){return slides[i];}}}function setActive(index){for(var i=0;i<slides.length;i++){slides[i].slide.active=i===index;}}function goNext(slide,index,direction){if(destroyed){return;}angular.extend(slide,{direction:direction});angular.extend(slides[currentIndex].slide||{},{direction:direction});if($animate.enabled($element)&&!$scope.$currentTransition&&slides[index].element&&self.slides.length>1){slides[index].element.data(SLIDE_DIRECTION,slide.direction);var currentIdx=self.getCurrentIndex();if(angular.isNumber(currentIdx)&&slides[currentIdx].element){slides[currentIdx].element.data(SLIDE_DIRECTION,slide.direction);}$scope.$currentTransition=true;$animate.on('addClass',slides[index].element,function(element,phase){if(phase==='close'){$scope.$currentTransition=null;$animate.off('addClass',element);if(bufferedTransitions.length){var nextSlide=bufferedTransitions.pop().slide;var nextIndex=nextSlide.index;var nextDirection=nextIndex>self.getCurrentIndex()?'next':'prev';clearBufferedTransitions();goNext(nextSlide,nextIndex,nextDirection);}}});}$scope.active=slide.index;currentIndex=slide.index;setActive(index);//every time you change slides, reset the timer
	restartTimer();}function findSlideIndex(slide){for(var i=0;i<slides.length;i++){if(slides[i].slide===slide){return i;}}}function resetTimer(){if(currentInterval){$interval.cancel(currentInterval);currentInterval=null;}}function resetTransition(slides){if(!slides.length){$scope.$currentTransition=null;clearBufferedTransitions();}}function restartTimer(){resetTimer();var interval=+$scope.interval;if(!isNaN(interval)&&interval>0){currentInterval=$interval(timerFn,interval);}}function timerFn(){var interval=+$scope.interval;if(isPlaying&&!isNaN(interval)&&interval>0&&slides.length){$scope.next();}else{$scope.pause();}}}]).directive('uibCarousel',function(){return{transclude:true,replace:true,controller:'UibCarouselController',controllerAs:'carousel',templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||'uib/template/carousel/carousel.html';},scope:{active:'=',interval:'=',noTransition:'=',noPause:'=',noWrap:'&'}};}).directive('uibSlide',function(){return{require:'^uibCarousel',transclude:true,replace:true,templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||'uib/template/carousel/slide.html';},scope:{actual:'=?',index:'=?'},link:function link(scope,element,attrs,carouselCtrl){carouselCtrl.addSlide(scope,element);//when the scope is destroyed then remove the slide from the current slides array
	scope.$on('$destroy',function(){carouselCtrl.removeSlide(scope);});}};}).animation('.item',['$animateCss',function($animateCss){var SLIDE_DIRECTION='uib-slideDirection';function removeClass(element,className,callback){element.removeClass(className);if(callback){callback();}}return{beforeAddClass:function beforeAddClass(element,className,done){if(className==='active'){var stopped=false;var direction=element.data(SLIDE_DIRECTION);var directionClass=direction==='next'?'left':'right';var removeClassFn=removeClass.bind(this,element,directionClass+' '+direction,done);element.addClass(direction);$animateCss(element,{addClass:directionClass}).start().done(removeClassFn);return function(){stopped=true;};}done();},beforeRemoveClass:function beforeRemoveClass(element,className,done){if(className==='active'){var stopped=false;var direction=element.data(SLIDE_DIRECTION);var directionClass=direction==='next'?'left':'right';var removeClassFn=removeClass.bind(this,element,directionClass,done);$animateCss(element,{addClass:directionClass}).start().done(removeClassFn);return function(){stopped=true;};}done();}};}]);angular.module('ui.bootstrap.dateparser',[]).service('uibDateParser',['$log','$locale','dateFilter','orderByFilter',function($log,$locale,dateFilter,orderByFilter){// Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
	var SPECIAL_CHARACTERS_REGEXP=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;var localeId;var formatCodeToRegex;this.init=function(){localeId=$locale.id;this.parsers={};this.formatters={};formatCodeToRegex=[{key:'yyyy',regex:'\\d{4}',apply:function apply(value){this.year=+value;},formatter:function formatter(date){var _date=new Date();_date.setFullYear(Math.abs(date.getFullYear()));return dateFilter(_date,'yyyy');}},{key:'yy',regex:'\\d{2}',apply:function apply(value){this.year=+value+2000;},formatter:function formatter(date){var _date=new Date();_date.setFullYear(Math.abs(date.getFullYear()));return dateFilter(_date,'yy');}},{key:'y',regex:'\\d{1,4}',apply:function apply(value){this.year=+value;},formatter:function formatter(date){var _date=new Date();_date.setFullYear(Math.abs(date.getFullYear()));return dateFilter(_date,'y');}},{key:'M!',regex:'0?[1-9]|1[0-2]',apply:function apply(value){this.month=value-1;},formatter:function formatter(date){var value=date.getMonth();if(/^[0-9]$/.test(value)){return dateFilter(date,'MM');}return dateFilter(date,'M');}},{key:'MMMM',regex:$locale.DATETIME_FORMATS.MONTH.join('|'),apply:function apply(value){this.month=$locale.DATETIME_FORMATS.MONTH.indexOf(value);},formatter:function formatter(date){return dateFilter(date,'MMMM');}},{key:'MMM',regex:$locale.DATETIME_FORMATS.SHORTMONTH.join('|'),apply:function apply(value){this.month=$locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);},formatter:function formatter(date){return dateFilter(date,'MMM');}},{key:'MM',regex:'0[1-9]|1[0-2]',apply:function apply(value){this.month=value-1;},formatter:function formatter(date){return dateFilter(date,'MM');}},{key:'M',regex:'[1-9]|1[0-2]',apply:function apply(value){this.month=value-1;},formatter:function formatter(date){return dateFilter(date,'M');}},{key:'d!',regex:'[0-2]?[0-9]{1}|3[0-1]{1}',apply:function apply(value){this.date=+value;},formatter:function formatter(date){var value=date.getDate();if(/^[1-9]$/.test(value)){return dateFilter(date,'dd');}return dateFilter(date,'d');}},{key:'dd',regex:'[0-2][0-9]{1}|3[0-1]{1}',apply:function apply(value){this.date=+value;},formatter:function formatter(date){return dateFilter(date,'dd');}},{key:'d',regex:'[1-2]?[0-9]{1}|3[0-1]{1}',apply:function apply(value){this.date=+value;},formatter:function formatter(date){return dateFilter(date,'d');}},{key:'EEEE',regex:$locale.DATETIME_FORMATS.DAY.join('|'),formatter:function formatter(date){return dateFilter(date,'EEEE');}},{key:'EEE',regex:$locale.DATETIME_FORMATS.SHORTDAY.join('|'),formatter:function formatter(date){return dateFilter(date,'EEE');}},{key:'HH',regex:'(?:0|1)[0-9]|2[0-3]',apply:function apply(value){this.hours=+value;},formatter:function formatter(date){return dateFilter(date,'HH');}},{key:'hh',regex:'0[0-9]|1[0-2]',apply:function apply(value){this.hours=+value;},formatter:function formatter(date){return dateFilter(date,'hh');}},{key:'H',regex:'1?[0-9]|2[0-3]',apply:function apply(value){this.hours=+value;},formatter:function formatter(date){return dateFilter(date,'H');}},{key:'h',regex:'[0-9]|1[0-2]',apply:function apply(value){this.hours=+value;},formatter:function formatter(date){return dateFilter(date,'h');}},{key:'mm',regex:'[0-5][0-9]',apply:function apply(value){this.minutes=+value;},formatter:function formatter(date){return dateFilter(date,'mm');}},{key:'m',regex:'[0-9]|[1-5][0-9]',apply:function apply(value){this.minutes=+value;},formatter:function formatter(date){return dateFilter(date,'m');}},{key:'sss',regex:'[0-9][0-9][0-9]',apply:function apply(value){this.milliseconds=+value;},formatter:function formatter(date){return dateFilter(date,'sss');}},{key:'ss',regex:'[0-5][0-9]',apply:function apply(value){this.seconds=+value;},formatter:function formatter(date){return dateFilter(date,'ss');}},{key:'s',regex:'[0-9]|[1-5][0-9]',apply:function apply(value){this.seconds=+value;},formatter:function formatter(date){return dateFilter(date,'s');}},{key:'a',regex:$locale.DATETIME_FORMATS.AMPMS.join('|'),apply:function apply(value){if(this.hours===12){this.hours=0;}if(value==='PM'){this.hours+=12;}},formatter:function formatter(date){return dateFilter(date,'a');}},{key:'Z',regex:'[+-]\\d{4}',apply:function apply(value){var matches=value.match(/([+-])(\d{2})(\d{2})/),sign=matches[1],hours=matches[2],minutes=matches[3];this.hours+=toInt(sign+hours);this.minutes+=toInt(sign+minutes);},formatter:function formatter(date){return dateFilter(date,'Z');}},{key:'ww',regex:'[0-4][0-9]|5[0-3]',formatter:function formatter(date){return dateFilter(date,'ww');}},{key:'w',regex:'[0-9]|[1-4][0-9]|5[0-3]',formatter:function formatter(date){return dateFilter(date,'w');}},{key:'GGGG',regex:$locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g,'\\s'),formatter:function formatter(date){return dateFilter(date,'GGGG');}},{key:'GGG',regex:$locale.DATETIME_FORMATS.ERAS.join('|'),formatter:function formatter(date){return dateFilter(date,'GGG');}},{key:'GG',regex:$locale.DATETIME_FORMATS.ERAS.join('|'),formatter:function formatter(date){return dateFilter(date,'GG');}},{key:'G',regex:$locale.DATETIME_FORMATS.ERAS.join('|'),formatter:function formatter(date){return dateFilter(date,'G');}}];};this.init();function createParser(format,func){var map=[],regex=format.split('');// check for literal values
	var quoteIndex=format.indexOf('\'');if(quoteIndex>-1){var inLiteral=false;format=format.split('');for(var i=quoteIndex;i<format.length;i++){if(inLiteral){if(format[i]==='\''){if(i+1<format.length&&format[i+1]==='\''){// escaped single quote
	format[i+1]='$';regex[i+1]='';}else{// end of literal
	regex[i]='';inLiteral=false;}}format[i]='$';}else{if(format[i]==='\''){// start of literal
	format[i]='$';regex[i]='';inLiteral=true;}}}format=format.join('');}angular.forEach(formatCodeToRegex,function(data){var index=format.indexOf(data.key);if(index>-1){format=format.split('');regex[index]='('+data.regex+')';format[index]='$';// Custom symbol to define consumed part of format
	for(var i=index+1,n=index+data.key.length;i<n;i++){regex[i]='';format[i]='$';}format=format.join('');map.push({index:index,key:data.key,apply:data[func],matcher:data.regex});}});return{regex:new RegExp('^'+regex.join('')+'$'),map:orderByFilter(map,'index')};}this.filter=function(date,format){if(!angular.isDate(date)||isNaN(date)||!format){return'';}format=$locale.DATETIME_FORMATS[format]||format;if($locale.id!==localeId){this.init();}if(!this.formatters[format]){this.formatters[format]=createParser(format,'formatter');}var parser=this.formatters[format],map=parser.map;var _format=format;return map.reduce(function(str,mapper,i){var match=_format.match(new RegExp('(.*)'+mapper.key));if(match&&angular.isString(match[1])){str+=match[1];_format=_format.replace(match[1]+mapper.key,'');}var endStr=i===map.length-1?_format:'';if(mapper.apply){return str+mapper.apply.call(null,date)+endStr;}return str+endStr;},'');};this.parse=function(input,format,baseDate){if(!angular.isString(input)||!format){return input;}format=$locale.DATETIME_FORMATS[format]||format;format=format.replace(SPECIAL_CHARACTERS_REGEXP,'\\$&');if($locale.id!==localeId){this.init();}if(!this.parsers[format]){this.parsers[format]=createParser(format,'apply');}var parser=this.parsers[format],regex=parser.regex,map=parser.map,results=input.match(regex),tzOffset=false;if(results&&results.length){var fields,dt;if(angular.isDate(baseDate)&&!isNaN(baseDate.getTime())){fields={year:baseDate.getFullYear(),month:baseDate.getMonth(),date:baseDate.getDate(),hours:baseDate.getHours(),minutes:baseDate.getMinutes(),seconds:baseDate.getSeconds(),milliseconds:baseDate.getMilliseconds()};}else{if(baseDate){$log.warn('dateparser:','baseDate is not a valid date');}fields={year:1900,month:0,date:1,hours:0,minutes:0,seconds:0,milliseconds:0};}for(var i=1,n=results.length;i<n;i++){var mapper=map[i-1];if(mapper.matcher==='Z'){tzOffset=true;}if(mapper.apply){mapper.apply.call(fields,results[i]);}}var datesetter=tzOffset?Date.prototype.setUTCFullYear:Date.prototype.setFullYear;var timesetter=tzOffset?Date.prototype.setUTCHours:Date.prototype.setHours;if(isValid(fields.year,fields.month,fields.date)){if(angular.isDate(baseDate)&&!isNaN(baseDate.getTime())&&!tzOffset){dt=new Date(baseDate);datesetter.call(dt,fields.year,fields.month,fields.date);timesetter.call(dt,fields.hours,fields.minutes,fields.seconds,fields.milliseconds);}else{dt=new Date(0);datesetter.call(dt,fields.year,fields.month,fields.date);timesetter.call(dt,fields.hours||0,fields.minutes||0,fields.seconds||0,fields.milliseconds||0);}}return dt;}};// Check if date is valid for specific month (and year for February).
	// Month: 0 = Jan, 1 = Feb, etc
	function isValid(year,month,date){if(date<1){return false;}if(month===1&&date>28){return date===29&&(year%4===0&&year%100!==0||year%400===0);}if(month===3||month===5||month===8||month===10){return date<31;}return true;}function toInt(str){return parseInt(str,10);}this.toTimezone=toTimezone;this.fromTimezone=fromTimezone;this.timezoneToOffset=timezoneToOffset;this.addDateMinutes=addDateMinutes;this.convertTimezoneToLocal=convertTimezoneToLocal;function toTimezone(date,timezone){return date&&timezone?convertTimezoneToLocal(date,timezone):date;}function fromTimezone(date,timezone){return date&&timezone?convertTimezoneToLocal(date,timezone,true):date;}//https://github.com/angular/angular.js/blob/4daafd3dbe6a80d578f5a31df1bb99c77559543e/src/Angular.js#L1207
	function timezoneToOffset(timezone,fallback){var requestedTimezoneOffset=Date.parse('Jan 01, 1970 00:00:00 '+timezone)/60000;return isNaN(requestedTimezoneOffset)?fallback:requestedTimezoneOffset;}function addDateMinutes(date,minutes){date=new Date(date.getTime());date.setMinutes(date.getMinutes()+minutes);return date;}function convertTimezoneToLocal(date,timezone,reverse){reverse=reverse?-1:1;var timezoneOffset=timezoneToOffset(timezone,date.getTimezoneOffset());return addDateMinutes(date,reverse*(timezoneOffset-date.getTimezoneOffset()));}}]);// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
	// at most one element.
	angular.module('ui.bootstrap.isClass',[]).directive('uibIsClass',['$animate',function($animate){//                    11111111          22222222
	var ON_REGEXP=/^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;//                    11111111           22222222
	var IS_REGEXP=/^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;var dataPerTracked={};return{restrict:'A',compile:function compile(tElement,tAttrs){var linkedScopes=[];var instances=[];var expToData={};var lastActivated=null;var onExpMatches=tAttrs.uibIsClass.match(ON_REGEXP);var onExp=onExpMatches[2];var expsStr=onExpMatches[1];var exps=expsStr.split(',');return linkFn;function linkFn(scope,element,attrs){linkedScopes.push(scope);instances.push({scope:scope,element:element});exps.forEach(function(exp,k){addForExp(exp,scope);});scope.$on('$destroy',removeScope);}function addForExp(exp,scope){var matches=exp.match(IS_REGEXP);var clazz=scope.$eval(matches[1]);var compareWithExp=matches[2];var data=expToData[exp];if(!data){var watchFn=function watchFn(compareWithVal){var newActivated=null;instances.some(function(instance){var thisVal=instance.scope.$eval(onExp);if(thisVal===compareWithVal){newActivated=instance;return true;}});if(data.lastActivated!==newActivated){if(data.lastActivated){$animate.removeClass(data.lastActivated.element,clazz);}if(newActivated){$animate.addClass(newActivated.element,clazz);}data.lastActivated=newActivated;}};expToData[exp]=data={lastActivated:null,scope:scope,watchFn:watchFn,compareWithExp:compareWithExp,watcher:scope.$watch(compareWithExp,watchFn)};}data.watchFn(scope.$eval(compareWithExp));}function removeScope(e){var removedScope=e.targetScope;var index=linkedScopes.indexOf(removedScope);linkedScopes.splice(index,1);instances.splice(index,1);if(linkedScopes.length){var newWatchScope=linkedScopes[0];angular.forEach(expToData,function(data){if(data.scope===removedScope){data.watcher=newWatchScope.$watch(data.compareWithExp,data.watchFn);data.scope=newWatchScope;}});}else{expToData={};}}}};}]);angular.module('ui.bootstrap.position',[])/**
	 * A set of utility methods for working with the DOM.
	 * It is meant to be used where we need to absolute-position elements in
	 * relation to another element (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */.factory('$uibPosition',['$document','$window',function($document,$window){/**
	     * Used by scrollbarWidth() function to cache scrollbar's width.
	     * Do not access this variable directly, use scrollbarWidth() instead.
	     */var SCROLLBAR_WIDTH;var OVERFLOW_REGEX={normal:/(auto|scroll)/,hidden:/(auto|scroll|hidden)/};var PLACEMENT_REGEX={auto:/\s?auto?\s?/i,primary:/^(top|bottom|left|right)$/,secondary:/^(top|bottom|left|right|center)$/,vertical:/^(top|bottom)$/};return{/**
	       * Provides a raw DOM element from a jQuery/jQLite element.
	       *
	       * @param {element} elem - The element to convert.
	       *
	       * @returns {element} A HTML element.
	       */getRawNode:function getRawNode(elem){return elem.nodeName?elem:elem[0]||elem;},/**
	       * Provides a parsed number for a style property.  Strips
	       * units and casts invalid numbers to 0.
	       *
	       * @param {string} value - The style value to parse.
	       *
	       * @returns {number} A valid number.
	       */parseStyle:function parseStyle(value){value=parseFloat(value);return isFinite(value)?value:0;},/**
	       * Provides the closest positioned ancestor.
	       *
	       * @param {element} element - The element to get the offest parent for.
	       *
	       * @returns {element} The closest positioned ancestor.
	       */offsetParent:function offsetParent(elem){elem=this.getRawNode(elem);var offsetParent=elem.offsetParent||$document[0].documentElement;function isStaticPositioned(el){return($window.getComputedStyle(el).position||'static')==='static';}while(offsetParent&&offsetParent!==$document[0].documentElement&&isStaticPositioned(offsetParent)){offsetParent=offsetParent.offsetParent;}return offsetParent||$document[0].documentElement;},/**
	       * Provides the scrollbar width, concept from TWBS measureScrollbar()
	       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
	       *
	       * @returns {number} The width of the browser scollbar.
	       */scrollbarWidth:function scrollbarWidth(){if(angular.isUndefined(SCROLLBAR_WIDTH)){var scrollElem=angular.element('<div class="uib-position-scrollbar-measure"></div>');$document.find('body').append(scrollElem);SCROLLBAR_WIDTH=scrollElem[0].offsetWidth-scrollElem[0].clientWidth;SCROLLBAR_WIDTH=isFinite(SCROLLBAR_WIDTH)?SCROLLBAR_WIDTH:0;scrollElem.remove();}return SCROLLBAR_WIDTH;},/**
	       * Checks to see if the element is scrollable.
	       *
	       * @param {element} elem - The element to check.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       *
	       * @returns {boolean} Whether the element is scrollable.
	       */isScrollable:function isScrollable(elem,includeHidden){elem=this.getRawNode(elem);var overflowRegex=includeHidden?OVERFLOW_REGEX.hidden:OVERFLOW_REGEX.normal;var elemStyle=$window.getComputedStyle(elem);return overflowRegex.test(elemStyle.overflow+elemStyle.overflowY+elemStyle.overflowX);},/**
	       * Provides the closest scrollable ancestor.
	       * A port of the jQuery UI scrollParent method:
	       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
	       *
	       * @param {element} elem - The element to find the scroll parent of.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       *
	       * @returns {element} A HTML element.
	       */scrollParent:function scrollParent(elem,includeHidden){elem=this.getRawNode(elem);var overflowRegex=includeHidden?OVERFLOW_REGEX.hidden:OVERFLOW_REGEX.normal;var documentEl=$document[0].documentElement;var elemStyle=$window.getComputedStyle(elem);var excludeStatic=elemStyle.position==='absolute';var scrollParent=elem.parentElement||documentEl;if(scrollParent===documentEl||elemStyle.position==='fixed'){return documentEl;}while(scrollParent.parentElement&&scrollParent!==documentEl){var spStyle=$window.getComputedStyle(scrollParent);if(excludeStatic&&spStyle.position!=='static'){excludeStatic=false;}if(!excludeStatic&&overflowRegex.test(spStyle.overflow+spStyle.overflowY+spStyle.overflowX)){break;}scrollParent=scrollParent.parentElement;}return scrollParent;},/**
	       * Provides read-only equivalent of jQuery's position function:
	       * http://api.jquery.com/position/ - distance to closest positioned
	       * ancestor.  Does not account for margins by default like jQuery position.
	       *
	       * @param {element} elem - The element to caclulate the position on.
	       * @param {boolean=} [includeMargins=false] - Should margins be accounted
	       * for, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of offset parent</li>
	       *     <li>**left**: distance to left edge of offset parent</li>
	       *   </ul>
	       */position:function position(elem,includeMagins){elem=this.getRawNode(elem);var elemOffset=this.offset(elem);if(includeMagins){var elemStyle=$window.getComputedStyle(elem);elemOffset.top-=this.parseStyle(elemStyle.marginTop);elemOffset.left-=this.parseStyle(elemStyle.marginLeft);}var parent=this.offsetParent(elem);var parentOffset={top:0,left:0};if(parent!==$document[0].documentElement){parentOffset=this.offset(parent);parentOffset.top+=parent.clientTop-parent.scrollTop;parentOffset.left+=parent.clientLeft-parent.scrollLeft;}return{width:Math.round(angular.isNumber(elemOffset.width)?elemOffset.width:elem.offsetWidth),height:Math.round(angular.isNumber(elemOffset.height)?elemOffset.height:elem.offsetHeight),top:Math.round(elemOffset.top-parentOffset.top),left:Math.round(elemOffset.left-parentOffset.left)};},/**
	       * Provides read-only equivalent of jQuery's offset function:
	       * http://api.jquery.com/offset/ - distance to viewport.  Does
	       * not account for borders, margins, or padding on the body
	       * element.
	       *
	       * @param {element} elem - The element to calculate the offset on.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of viewport</li>
	       *     <li>**right**: distance to bottom edge of viewport</li>
	       *   </ul>
	       */offset:function offset(elem){elem=this.getRawNode(elem);var elemBCR=elem.getBoundingClientRect();return{width:Math.round(angular.isNumber(elemBCR.width)?elemBCR.width:elem.offsetWidth),height:Math.round(angular.isNumber(elemBCR.height)?elemBCR.height:elem.offsetHeight),top:Math.round(elemBCR.top+($window.pageYOffset||$document[0].documentElement.scrollTop)),left:Math.round(elemBCR.left+($window.pageXOffset||$document[0].documentElement.scrollLeft))};},/**
	       * Provides offset distance to the closest scrollable ancestor
	       * or viewport.  Accounts for border and scrollbar width.
	       *
	       * Right and bottom dimensions represent the distance to the
	       * respective edge of the viewport element.  If the element
	       * edge extends beyond the viewport, a negative value will be
	       * reported.
	       *
	       * @param {element} elem - The element to get the viewport offset for.
	       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
	       * of the first scrollable element, default is false.
	       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
	       * be accounted for, default is true.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: distance to the top content edge of viewport element</li>
	       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
	       *     <li>**left**: distance to the left content edge of viewport element</li>
	       *     <li>**right**: distance to the right content edge of viewport element</li>
	       *   </ul>
	       */viewportOffset:function viewportOffset(elem,useDocument,includePadding){elem=this.getRawNode(elem);includePadding=includePadding!==false?true:false;var elemBCR=elem.getBoundingClientRect();var offsetBCR={top:0,left:0,bottom:0,right:0};var offsetParent=useDocument?$document[0].documentElement:this.scrollParent(elem);var offsetParentBCR=offsetParent.getBoundingClientRect();offsetBCR.top=offsetParentBCR.top+offsetParent.clientTop;offsetBCR.left=offsetParentBCR.left+offsetParent.clientLeft;if(offsetParent===$document[0].documentElement){offsetBCR.top+=$window.pageYOffset;offsetBCR.left+=$window.pageXOffset;}offsetBCR.bottom=offsetBCR.top+offsetParent.clientHeight;offsetBCR.right=offsetBCR.left+offsetParent.clientWidth;if(includePadding){var offsetParentStyle=$window.getComputedStyle(offsetParent);offsetBCR.top+=this.parseStyle(offsetParentStyle.paddingTop);offsetBCR.bottom-=this.parseStyle(offsetParentStyle.paddingBottom);offsetBCR.left+=this.parseStyle(offsetParentStyle.paddingLeft);offsetBCR.right-=this.parseStyle(offsetParentStyle.paddingRight);}return{top:Math.round(elemBCR.top-offsetBCR.top),bottom:Math.round(offsetBCR.bottom-elemBCR.bottom),left:Math.round(elemBCR.left-offsetBCR.left),right:Math.round(offsetBCR.right-elemBCR.right)};},/**
	       * Provides an array of placement values parsed from a placement string.
	       * Along with the 'auto' indicator, supported placement strings are:
	       *   <ul>
	       *     <li>top: element on top, horizontally centered on host element.</li>
	       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
	       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
	       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
	       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
	       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
	       *     <li>left: element on left, vertically centered on host element.</li>
	       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
	       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
	       *     <li>right: element on right, vertically centered on host element.</li>
	       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
	       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
	       *   </ul>
	       * A placement string with an 'auto' indicator is expected to be
	       * space separated from the placement, i.e: 'auto bottom-left'  If
	       * the primary and secondary placement values do not match 'top,
	       * bottom, left, right' then 'top' will be the primary placement and
	       * 'center' will be the secondary placement.  If 'auto' is passed, true
	       * will be returned as the 3rd value of the array.
	       *
	       * @param {string} placement - The placement string to parse.
	       *
	       * @returns {array} An array with the following values
	       * <ul>
	       *   <li>**[0]**: The primary placement.</li>
	       *   <li>**[1]**: The secondary placement.</li>
	       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
	       * </ul>
	       */parsePlacement:function parsePlacement(placement){var autoPlace=PLACEMENT_REGEX.auto.test(placement);if(autoPlace){placement=placement.replace(PLACEMENT_REGEX.auto,'');}placement=placement.split('-');placement[0]=placement[0]||'top';if(!PLACEMENT_REGEX.primary.test(placement[0])){placement[0]='top';}placement[1]=placement[1]||'center';if(!PLACEMENT_REGEX.secondary.test(placement[1])){placement[1]='center';}if(autoPlace){placement[2]=true;}else{placement[2]=false;}return placement;},/**
	       * Provides coordinates for an element to be positioned relative to
	       * another element.  Passing 'auto' as part of the placement parameter
	       * will enable smart placement - where the element fits. i.e:
	       * 'auto left-top' will check to see if there is enough space to the left
	       * of the hostElem to fit the targetElem, if not place right (same for secondary
	       * top placement).  Available space is calculated using the viewportOffset
	       * function.
	       *
	       * @param {element} hostElem - The element to position against.
	       * @param {element} targetElem - The element to position.
	       * @param {string=} [placement=top] - The placement for the targetElem,
	       *   default is 'top'. 'center' is assumed as secondary placement for
	       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
	       *   <ul>
	       *     <li>top</li>
	       *     <li>top-right</li>
	       *     <li>top-left</li>
	       *     <li>bottom</li>
	       *     <li>bottom-left</li>
	       *     <li>bottom-right</li>
	       *     <li>left</li>
	       *     <li>left-top</li>
	       *     <li>left-bottom</li>
	       *     <li>right</li>
	       *     <li>right-top</li>
	       *     <li>right-bottom</li>
	       *   </ul>
	       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
	       *   be calculated from the body element, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: Value for targetElem top.</li>
	       *     <li>**left**: Value for targetElem left.</li>
	       *     <li>**placement**: The resolved placement.</li>
	       *   </ul>
	       */positionElements:function positionElements(hostElem,targetElem,placement,appendToBody){hostElem=this.getRawNode(hostElem);targetElem=this.getRawNode(targetElem);// need to read from prop to support tests.
	var targetWidth=angular.isDefined(targetElem.offsetWidth)?targetElem.offsetWidth:targetElem.prop('offsetWidth');var targetHeight=angular.isDefined(targetElem.offsetHeight)?targetElem.offsetHeight:targetElem.prop('offsetHeight');placement=this.parsePlacement(placement);var hostElemPos=appendToBody?this.offset(hostElem):this.position(hostElem);var targetElemPos={top:0,left:0,placement:''};if(placement[2]){var viewportOffset=this.viewportOffset(hostElem,appendToBody);var targetElemStyle=$window.getComputedStyle(targetElem);var adjustedSize={width:targetWidth+Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft)+this.parseStyle(targetElemStyle.marginRight))),height:targetHeight+Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop)+this.parseStyle(targetElemStyle.marginBottom)))};placement[0]=placement[0]==='top'&&adjustedSize.height>viewportOffset.top&&adjustedSize.height<=viewportOffset.bottom?'bottom':placement[0]==='bottom'&&adjustedSize.height>viewportOffset.bottom&&adjustedSize.height<=viewportOffset.top?'top':placement[0]==='left'&&adjustedSize.width>viewportOffset.left&&adjustedSize.width<=viewportOffset.right?'right':placement[0]==='right'&&adjustedSize.width>viewportOffset.right&&adjustedSize.width<=viewportOffset.left?'left':placement[0];placement[1]=placement[1]==='top'&&adjustedSize.height-hostElemPos.height>viewportOffset.bottom&&adjustedSize.height-hostElemPos.height<=viewportOffset.top?'bottom':placement[1]==='bottom'&&adjustedSize.height-hostElemPos.height>viewportOffset.top&&adjustedSize.height-hostElemPos.height<=viewportOffset.bottom?'top':placement[1]==='left'&&adjustedSize.width-hostElemPos.width>viewportOffset.right&&adjustedSize.width-hostElemPos.width<=viewportOffset.left?'right':placement[1]==='right'&&adjustedSize.width-hostElemPos.width>viewportOffset.left&&adjustedSize.width-hostElemPos.width<=viewportOffset.right?'left':placement[1];if(placement[1]==='center'){if(PLACEMENT_REGEX.vertical.test(placement[0])){var xOverflow=hostElemPos.width/2-targetWidth/2;if(viewportOffset.left+xOverflow<0&&adjustedSize.width-hostElemPos.width<=viewportOffset.right){placement[1]='left';}else if(viewportOffset.right+xOverflow<0&&adjustedSize.width-hostElemPos.width<=viewportOffset.left){placement[1]='right';}}else{var yOverflow=hostElemPos.height/2-adjustedSize.height/2;if(viewportOffset.top+yOverflow<0&&adjustedSize.height-hostElemPos.height<=viewportOffset.bottom){placement[1]='top';}else if(viewportOffset.bottom+yOverflow<0&&adjustedSize.height-hostElemPos.height<=viewportOffset.top){placement[1]='bottom';}}}}switch(placement[0]){case'top':targetElemPos.top=hostElemPos.top-targetHeight;break;case'bottom':targetElemPos.top=hostElemPos.top+hostElemPos.height;break;case'left':targetElemPos.left=hostElemPos.left-targetWidth;break;case'right':targetElemPos.left=hostElemPos.left+hostElemPos.width;break;}switch(placement[1]){case'top':targetElemPos.top=hostElemPos.top;break;case'bottom':targetElemPos.top=hostElemPos.top+hostElemPos.height-targetHeight;break;case'left':targetElemPos.left=hostElemPos.left;break;case'right':targetElemPos.left=hostElemPos.left+hostElemPos.width-targetWidth;break;case'center':if(PLACEMENT_REGEX.vertical.test(placement[0])){targetElemPos.left=hostElemPos.left+hostElemPos.width/2-targetWidth/2;}else{targetElemPos.top=hostElemPos.top+hostElemPos.height/2-targetHeight/2;}break;}targetElemPos.top=Math.round(targetElemPos.top);targetElemPos.left=Math.round(targetElemPos.left);targetElemPos.placement=placement[1]==='center'?placement[0]:placement[0]+'-'+placement[1];return targetElemPos;},/**
	      * Provides a way for positioning tooltip & dropdown
	      * arrows when using placement options beyond the standard
	      * left, right, top, or bottom.
	      *
	      * @param {element} elem - The tooltip/dropdown element.
	      * @param {string} placement - The placement for the elem.
	      */positionArrow:function positionArrow(elem,placement){elem=this.getRawNode(elem);var innerElem=elem.querySelector('.tooltip-inner, .popover-inner');if(!innerElem){return;}var isTooltip=angular.element(innerElem).hasClass('tooltip-inner');var arrowElem=isTooltip?elem.querySelector('.tooltip-arrow'):elem.querySelector('.arrow');if(!arrowElem){return;}var arrowCss={top:'',bottom:'',left:'',right:''};placement=this.parsePlacement(placement);if(placement[1]==='center'){// no adjustment necessary - just reset styles
	angular.element(arrowElem).css(arrowCss);return;}var borderProp='border-'+placement[0]+'-width';var borderWidth=$window.getComputedStyle(arrowElem)[borderProp];var borderRadiusProp='border-';if(PLACEMENT_REGEX.vertical.test(placement[0])){borderRadiusProp+=placement[0]+'-'+placement[1];}else{borderRadiusProp+=placement[1]+'-'+placement[0];}borderRadiusProp+='-radius';var borderRadius=$window.getComputedStyle(isTooltip?innerElem:elem)[borderRadiusProp];switch(placement[0]){case'top':arrowCss.bottom=isTooltip?'0':'-'+borderWidth;break;case'bottom':arrowCss.top=isTooltip?'0':'-'+borderWidth;break;case'left':arrowCss.right=isTooltip?'0':'-'+borderWidth;break;case'right':arrowCss.left=isTooltip?'0':'-'+borderWidth;break;}arrowCss[placement[1]]=borderRadius;angular.element(arrowElem).css(arrowCss);}};}]);angular.module('ui.bootstrap.datepicker',['ui.bootstrap.dateparser','ui.bootstrap.isClass','ui.bootstrap.position']).value('$datepickerSuppressError',false).value('uibDatepickerAttributeWarning',true).constant('uibDatepickerConfig',{datepickerMode:'day',formatDay:'dd',formatMonth:'MMMM',formatYear:'yyyy',formatDayHeader:'EEE',formatDayTitle:'MMMM yyyy',formatMonthTitle:'yyyy',maxDate:null,maxMode:'year',minDate:null,minMode:'day',ngModelOptions:{},shortcutPropagation:false,showWeeks:true,yearColumns:5,yearRows:4}).controller('UibDatepickerController',['$scope','$attrs','$parse','$interpolate','$locale','$log','dateFilter','uibDatepickerConfig','$datepickerSuppressError','uibDatepickerAttributeWarning','uibDateParser',function($scope,$attrs,$parse,$interpolate,$locale,$log,dateFilter,datepickerConfig,$datepickerSuppressError,datepickerAttributeWarning,dateParser){var self=this,ngModelCtrl={$setViewValue:angular.noop},// nullModelCtrl;
	ngModelOptions={},watchListeners=[],optionsUsed=!!$attrs.datepickerOptions;// Modes chain
	this.modes=['day','month','year'];if(optionsUsed){['customClass','dateDisabled','datepickerMode','formatDay','formatDayHeader','formatDayTitle','formatMonth','formatMonthTitle','formatYear','initDate','maxDate','maxMode','minDate','minMode','showWeeks','shortcutPropagation','startingDay','yearColumns','yearRows'].forEach(function(key){switch(key){case'customClass':case'dateDisabled':$scope[key]=$scope.datepickerOptions[key]||angular.noop;break;case'datepickerMode':$scope.datepickerMode=angular.isDefined($scope.datepickerOptions.datepickerMode)?$scope.datepickerOptions.datepickerMode:datepickerConfig.datepickerMode;break;case'formatDay':case'formatDayHeader':case'formatDayTitle':case'formatMonth':case'formatMonthTitle':case'formatYear':self[key]=angular.isDefined($scope.datepickerOptions[key])?$interpolate($scope.datepickerOptions[key])($scope.$parent):datepickerConfig[key];break;case'showWeeks':case'shortcutPropagation':case'yearColumns':case'yearRows':self[key]=angular.isDefined($scope.datepickerOptions[key])?$scope.datepickerOptions[key]:datepickerConfig[key];break;case'startingDay':if(angular.isDefined($scope.datepickerOptions.startingDay)){self.startingDay=$scope.datepickerOptions.startingDay;}else if(angular.isNumber(datepickerConfig.startingDay)){self.startingDay=datepickerConfig.startingDay;}else{self.startingDay=($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK+8)%7;}break;case'maxDate':case'minDate':if($scope.datepickerOptions[key]){$scope.$watch(function(){return $scope.datepickerOptions[key];},function(value){if(value){if(angular.isDate(value)){self[key]=dateParser.fromTimezone(new Date(value),ngModelOptions.timezone);}else{self[key]=new Date(dateFilter(value,'medium'));}}else{self[key]=null;}self.refreshView();});}else{self[key]=datepickerConfig[key]?dateParser.fromTimezone(new Date(datepickerConfig[key]),ngModelOptions.timezone):null;}break;case'maxMode':case'minMode':if($scope.datepickerOptions[key]){$scope.$watch(function(){return $scope.datepickerOptions[key];},function(value){self[key]=$scope[key]=angular.isDefined(value)?value:datepickerOptions[key];if(key==='minMode'&&self.modes.indexOf($scope.datepickerOptions.datepickerMode)<self.modes.indexOf(self[key])||key==='maxMode'&&self.modes.indexOf($scope.datepickerOptions.datepickerMode)>self.modes.indexOf(self[key])){$scope.datepickerMode=self[key];$scope.datepickerOptions.datepickerMode=self[key];}});}else{self[key]=$scope[key]=datepickerConfig[key]||null;}break;case'initDate':if($scope.datepickerOptions.initDate){self.activeDate=dateParser.fromTimezone($scope.datepickerOptions.initDate,ngModelOptions.timezone)||new Date();$scope.$watch(function(){return $scope.datepickerOptions.initDate;},function(initDate){if(initDate&&(ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue)||ngModelCtrl.$invalid)){self.activeDate=dateParser.fromTimezone(initDate,ngModelOptions.timezone);self.refreshView();}});}else{self.activeDate=new Date();}}});}else{// Interpolated configuration attributes
	angular.forEach(['formatDay','formatMonth','formatYear','formatDayHeader','formatDayTitle','formatMonthTitle'],function(key){self[key]=angular.isDefined($attrs[key])?$interpolate($attrs[key])($scope.$parent):datepickerConfig[key];if(angular.isDefined($attrs[key])&&datepickerAttributeWarning){$log.warn('uib-datepicker '+key+' attribute usage is deprecated, use datepicker-options attribute instead');}});// Evaled configuration attributes
	angular.forEach(['showWeeks','yearRows','yearColumns','shortcutPropagation'],function(key){self[key]=angular.isDefined($attrs[key])?$scope.$parent.$eval($attrs[key]):datepickerConfig[key];if(angular.isDefined($attrs[key])&&datepickerAttributeWarning){$log.warn('uib-datepicker '+key+' attribute usage is deprecated, use datepicker-options attribute instead');}});angular.forEach(['dateDisabled','customClass'],function(key){if(angular.isDefined($attrs[key])&&datepickerAttributeWarning){$log.warn('uib-datepicker '+key+' attribute usage is deprecated, use datepicker-options attribute instead');}});if(angular.isDefined($attrs.startingDay)){if(datepickerAttributeWarning){$log.warn('uib-datepicker startingDay attribute usage is deprecated, use datepicker-options attribute instead');}self.startingDay=$scope.$parent.$eval($attrs.startingDay);}else if(angular.isNumber(datepickerConfig.startingDay)){self.startingDay=datepickerConfig.startingDay;}else{self.startingDay=($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK+8)%7;}// Watchable date attributes
	angular.forEach(['minDate','maxDate'],function(key){if($attrs[key]){if(datepickerAttributeWarning){$log.warn('uib-datepicker '+key+' attribute usage is deprecated, use datepicker-options attribute instead');}watchListeners.push($scope.$parent.$watch($attrs[key],function(value){if(value){if(angular.isDate(value)){self[key]=dateParser.fromTimezone(new Date(value),ngModelOptions.timezone);}else{self[key]=new Date(dateFilter(value,'medium'));}}else{self[key]=null;}self.refreshView();}));}else{self[key]=datepickerConfig[key]?dateParser.fromTimezone(new Date(datepickerConfig[key]),ngModelOptions.timezone):null;}});angular.forEach(['minMode','maxMode'],function(key){if($attrs[key]){if(datepickerAttributeWarning){$log.warn('uib-datepicker '+key+' attribute usage is deprecated, use datepicker-options attribute instead');}watchListeners.push($scope.$parent.$watch($attrs[key],function(value){self[key]=$scope[key]=angular.isDefined(value)?value:$attrs[key];if(key==='minMode'&&self.modes.indexOf($scope.datepickerMode)<self.modes.indexOf(self[key])||key==='maxMode'&&self.modes.indexOf($scope.datepickerMode)>self.modes.indexOf(self[key])){$scope.datepickerMode=self[key];}}));}else{self[key]=$scope[key]=datepickerConfig[key]||null;}});if(angular.isDefined($attrs.initDate)){if(datepickerAttributeWarning){$log.warn('uib-datepicker initDate attribute usage is deprecated, use datepicker-options attribute instead');}var initDate=dateParser.fromTimezone($scope.$parent.$eval($attrs.initDate),ngModelOptions.timezone);this.activeDate=!isNaN(initDate)?initDate:new Date();watchListeners.push($scope.$parent.$watch($attrs.initDate,function(initDate){if(initDate&&(ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue)||ngModelCtrl.$invalid)){initDate=dateParser.fromTimezone(initDate,ngModelOptions.timezone);self.activeDate=!isNaN(initDate)?initDate:new Date();self.refreshView();}}));}else{this.activeDate=new Date();}if($attrs.datepickerMode&&datepickerAttributeWarning){$log.warn('uib-datepicker datepickerMode attribute usage is deprecated, use datepicker-options attribute instead');}$scope.datepickerMode=$scope.datepickerMode||datepickerConfig.datepickerMode;}$scope.uniqueId='datepicker-'+$scope.$id+'-'+Math.floor(Math.random()*10000);$scope.disabled=angular.isDefined($attrs.disabled)||false;if(angular.isDefined($attrs.ngDisabled)){watchListeners.push($scope.$parent.$watch($attrs.ngDisabled,function(disabled){$scope.disabled=disabled;self.refreshView();}));}$scope.isActive=function(dateObject){if(self.compare(dateObject.date,self.activeDate)===0){$scope.activeDateId=dateObject.uid;return true;}return false;};this.init=function(ngModelCtrl_){ngModelCtrl=ngModelCtrl_;ngModelOptions=ngModelCtrl_.$options||datepickerConfig.ngModelOptions;this.activeDate=ngModelCtrl.$modelValue?dateParser.fromTimezone(new Date(ngModelCtrl.$modelValue),ngModelOptions.timezone):dateParser.fromTimezone(new Date(),ngModelOptions.timezone);ngModelCtrl.$render=function(){self.render();};};this.render=function(){if(ngModelCtrl.$viewValue){var date=new Date(ngModelCtrl.$viewValue),isValid=!isNaN(date);if(isValid){this.activeDate=dateParser.fromTimezone(date,ngModelOptions.timezone);}else if(!$datepickerSuppressError){$log.error('Datepicker directive: "ng-model" value must be a Date object');}}this.refreshView();};this.refreshView=function(){if(this.element){$scope.selectedDt=null;this._refreshView();if($scope.activeDt){$scope.activeDateId=$scope.activeDt.uid;}var date=ngModelCtrl.$viewValue?new Date(ngModelCtrl.$viewValue):null;date=dateParser.fromTimezone(date,ngModelOptions.timezone);ngModelCtrl.$setValidity('dateDisabled',!date||this.element&&!this.isDisabled(date));}};this.createDateObject=function(date,format){var model=ngModelCtrl.$viewValue?new Date(ngModelCtrl.$viewValue):null;model=dateParser.fromTimezone(model,ngModelOptions.timezone);var today=new Date();today=dateParser.fromTimezone(today,ngModelOptions.timezone);var time=this.compare(date,today);var dt={date:date,label:dateParser.filter(date,format),selected:model&&this.compare(date,model)===0,disabled:this.isDisabled(date),past:time<0,current:time===0,future:time>0,customClass:this.customClass(date)||null};if(model&&this.compare(date,model)===0){$scope.selectedDt=dt;}if(self.activeDate&&this.compare(dt.date,self.activeDate)===0){$scope.activeDt=dt;}return dt;};this.isDisabled=function(date){return $scope.disabled||this.minDate&&this.compare(date,this.minDate)<0||this.maxDate&&this.compare(date,this.maxDate)>0||$scope.dateDisabled&&$scope.dateDisabled({date:date,mode:$scope.datepickerMode});};this.customClass=function(date){return $scope.customClass({date:date,mode:$scope.datepickerMode});};// Split array into smaller arrays
	this.split=function(arr,size){var arrays=[];while(arr.length>0){arrays.push(arr.splice(0,size));}return arrays;};$scope.select=function(date){if($scope.datepickerMode===self.minMode){var dt=ngModelCtrl.$viewValue?dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue),ngModelOptions.timezone):new Date(0,0,0,0,0,0,0);dt.setFullYear(date.getFullYear(),date.getMonth(),date.getDate());dt=dateParser.toTimezone(dt,ngModelOptions.timezone);ngModelCtrl.$setViewValue(dt);ngModelCtrl.$render();}else{self.activeDate=date;setMode(self.modes[self.modes.indexOf($scope.datepickerMode)-1]);$scope.$emit('uib:datepicker.mode');}};$scope.move=function(direction){var year=self.activeDate.getFullYear()+direction*(self.step.years||0),month=self.activeDate.getMonth()+direction*(self.step.months||0);self.activeDate.setFullYear(year,month,1);self.refreshView();};$scope.toggleMode=function(direction){direction=direction||1;if($scope.datepickerMode===self.maxMode&&direction===1||$scope.datepickerMode===self.minMode&&direction===-1){return;}setMode(self.modes[self.modes.indexOf($scope.datepickerMode)+direction]);$scope.$emit('uib:datepicker.mode');};// Key event mapper
	$scope.keys={13:'enter',32:'space',33:'pageup',34:'pagedown',35:'end',36:'home',37:'left',38:'up',39:'right',40:'down'};var focusElement=function focusElement(){self.element[0].focus();};// Listen for focus requests from popup directive
	$scope.$on('uib:datepicker.focus',focusElement);$scope.keydown=function(evt){var key=$scope.keys[evt.which];if(!key||evt.shiftKey||evt.altKey||$scope.disabled){return;}evt.preventDefault();if(!self.shortcutPropagation){evt.stopPropagation();}if(key==='enter'||key==='space'){if(self.isDisabled(self.activeDate)){return;// do nothing
	}$scope.select(self.activeDate);}else if(evt.ctrlKey&&(key==='up'||key==='down')){$scope.toggleMode(key==='up'?1:-1);}else{self.handleKeyDown(key,evt);self.refreshView();}};$scope.$on("$destroy",function(){//Clear all watch listeners on destroy
	while(watchListeners.length){watchListeners.shift()();}});function setMode(mode){$scope.datepickerMode=mode;if(optionsUsed){$scope.datepickerOptions.datepickerMode=mode;}}}]).controller('UibDaypickerController',['$scope','$element','dateFilter',function(scope,$element,dateFilter){var DAYS_IN_MONTH=[31,28,31,30,31,30,31,31,30,31,30,31];this.step={months:1};this.element=$element;function getDaysInMonth(year,month){return month===1&&year%4===0&&(year%100!==0||year%400===0)?29:DAYS_IN_MONTH[month];}this.init=function(ctrl){angular.extend(ctrl,this);scope.showWeeks=ctrl.showWeeks;ctrl.refreshView();};this.getDates=function(startDate,n){var dates=new Array(n),current=new Date(startDate),i=0,date;while(i<n){date=new Date(current);dates[i++]=date;current.setDate(current.getDate()+1);}return dates;};this._refreshView=function(){var year=this.activeDate.getFullYear(),month=this.activeDate.getMonth(),firstDayOfMonth=new Date(this.activeDate);firstDayOfMonth.setFullYear(year,month,1);var difference=this.startingDay-firstDayOfMonth.getDay(),numDisplayedFromPreviousMonth=difference>0?7-difference:-difference,firstDate=new Date(firstDayOfMonth);if(numDisplayedFromPreviousMonth>0){firstDate.setDate(-numDisplayedFromPreviousMonth+1);}// 42 is the number of days on a six-week calendar
	var days=this.getDates(firstDate,42);for(var i=0;i<42;i++){days[i]=angular.extend(this.createDateObject(days[i],this.formatDay),{secondary:days[i].getMonth()!==month,uid:scope.uniqueId+'-'+i});}scope.labels=new Array(7);for(var j=0;j<7;j++){scope.labels[j]={abbr:dateFilter(days[j].date,this.formatDayHeader),full:dateFilter(days[j].date,'EEEE')};}scope.title=dateFilter(this.activeDate,this.formatDayTitle);scope.rows=this.split(days,7);if(scope.showWeeks){scope.weekNumbers=[];var thursdayIndex=(4+7-this.startingDay)%7,numWeeks=scope.rows.length;for(var curWeek=0;curWeek<numWeeks;curWeek++){scope.weekNumbers.push(getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));}}};this.compare=function(date1,date2){var _date1=new Date(date1.getFullYear(),date1.getMonth(),date1.getDate());var _date2=new Date(date2.getFullYear(),date2.getMonth(),date2.getDate());_date1.setFullYear(date1.getFullYear());_date2.setFullYear(date2.getFullYear());return _date1-_date2;};function getISO8601WeekNumber(date){var checkDate=new Date(date);checkDate.setDate(checkDate.getDate()+4-(checkDate.getDay()||7));// Thursday
	var time=checkDate.getTime();checkDate.setMonth(0);// Compare with Jan 1
	checkDate.setDate(1);return Math.floor(Math.round((time-checkDate)/86400000)/7)+1;}this.handleKeyDown=function(key,evt){var date=this.activeDate.getDate();if(key==='left'){date=date-1;}else if(key==='up'){date=date-7;}else if(key==='right'){date=date+1;}else if(key==='down'){date=date+7;}else if(key==='pageup'||key==='pagedown'){var month=this.activeDate.getMonth()+(key==='pageup'?-1:1);this.activeDate.setMonth(month,1);date=Math.min(getDaysInMonth(this.activeDate.getFullYear(),this.activeDate.getMonth()),date);}else if(key==='home'){date=1;}else if(key==='end'){date=getDaysInMonth(this.activeDate.getFullYear(),this.activeDate.getMonth());}this.activeDate.setDate(date);};}]).controller('UibMonthpickerController',['$scope','$element','dateFilter',function(scope,$element,dateFilter){this.step={years:1};this.element=$element;this.init=function(ctrl){angular.extend(ctrl,this);ctrl.refreshView();};this._refreshView=function(){var months=new Array(12),year=this.activeDate.getFullYear(),date;for(var i=0;i<12;i++){date=new Date(this.activeDate);date.setFullYear(year,i,1);months[i]=angular.extend(this.createDateObject(date,this.formatMonth),{uid:scope.uniqueId+'-'+i});}scope.title=dateFilter(this.activeDate,this.formatMonthTitle);scope.rows=this.split(months,3);};this.compare=function(date1,date2){var _date1=new Date(date1.getFullYear(),date1.getMonth());var _date2=new Date(date2.getFullYear(),date2.getMonth());_date1.setFullYear(date1.getFullYear());_date2.setFullYear(date2.getFullYear());return _date1-_date2;};this.handleKeyDown=function(key,evt){var date=this.activeDate.getMonth();if(key==='left'){date=date-1;}else if(key==='up'){date=date-3;}else if(key==='right'){date=date+1;}else if(key==='down'){date=date+3;}else if(key==='pageup'||key==='pagedown'){var year=this.activeDate.getFullYear()+(key==='pageup'?-1:1);this.activeDate.setFullYear(year);}else if(key==='home'){date=0;}else if(key==='end'){date=11;}this.activeDate.setMonth(date);};}]).controller('UibYearpickerController',['$scope','$element','dateFilter',function(scope,$element,dateFilter){var columns,range;this.element=$element;function getStartingYear(year){return parseInt((year-1)/range,10)*range+1;}this.yearpickerInit=function(){columns=this.yearColumns;range=this.yearRows*columns;this.step={years:range};};this._refreshView=function(){var years=new Array(range),date;for(var i=0,start=getStartingYear(this.activeDate.getFullYear());i<range;i++){date=new Date(this.activeDate);date.setFullYear(start+i,0,1);years[i]=angular.extend(this.createDateObject(date,this.formatYear),{uid:scope.uniqueId+'-'+i});}scope.title=[years[0].label,years[range-1].label].join(' - ');scope.rows=this.split(years,columns);scope.columns=columns;};this.compare=function(date1,date2){return date1.getFullYear()-date2.getFullYear();};this.handleKeyDown=function(key,evt){var date=this.activeDate.getFullYear();if(key==='left'){date=date-1;}else if(key==='up'){date=date-columns;}else if(key==='right'){date=date+1;}else if(key==='down'){date=date+columns;}else if(key==='pageup'||key==='pagedown'){date+=(key==='pageup'?-1:1)*range;}else if(key==='home'){date=getStartingYear(this.activeDate.getFullYear());}else if(key==='end'){date=getStartingYear(this.activeDate.getFullYear())+range-1;}this.activeDate.setFullYear(date);};}]).directive('uibDatepicker',function(){return{replace:true,templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||'uib/template/datepicker/datepicker.html';},scope:{datepickerMode:'=?',datepickerOptions:'=?',dateDisabled:'&',customClass:'&',shortcutPropagation:'&?'},require:['uibDatepicker','^ngModel'],controller:'UibDatepickerController',controllerAs:'datepicker',link:function link(scope,element,attrs,ctrls){var datepickerCtrl=ctrls[0],ngModelCtrl=ctrls[1];datepickerCtrl.init(ngModelCtrl);}};}).directive('uibDaypicker',function(){return{replace:true,templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||'uib/template/datepicker/day.html';},require:['^uibDatepicker','uibDaypicker'],controller:'UibDaypickerController',link:function link(scope,element,attrs,ctrls){var datepickerCtrl=ctrls[0],daypickerCtrl=ctrls[1];daypickerCtrl.init(datepickerCtrl);}};}).directive('uibMonthpicker',function(){return{replace:true,templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||'uib/template/datepicker/month.html';},require:['^uibDatepicker','uibMonthpicker'],controller:'UibMonthpickerController',link:function link(scope,element,attrs,ctrls){var datepickerCtrl=ctrls[0],monthpickerCtrl=ctrls[1];monthpickerCtrl.init(datepickerCtrl);}};}).directive('uibYearpicker',function(){return{replace:true,templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||'uib/template/datepicker/year.html';},require:['^uibDatepicker','uibYearpicker'],controller:'UibYearpickerController',link:function link(scope,element,attrs,ctrls){var ctrl=ctrls[0];angular.extend(ctrl,ctrls[1]);ctrl.yearpickerInit();ctrl.refreshView();}};}).value('uibDatepickerPopupAttributeWarning',true).constant('uibDatepickerPopupConfig',{altInputFormats:[],appendToBody:false,clearText:'Clear',closeOnDateSelection:true,closeText:'Done',currentText:'Today',datepickerPopup:'yyyy-MM-dd',datepickerPopupTemplateUrl:'uib/template/datepicker/popup.html',datepickerTemplateUrl:'uib/template/datepicker/datepicker.html',html5Types:{date:'yyyy-MM-dd','datetime-local':'yyyy-MM-ddTHH:mm:ss.sss','month':'yyyy-MM'},onOpenFocus:true,showButtonBar:true,placement:'auto bottom-left'}).controller('UibDatepickerPopupController',['$scope','$element','$attrs','$compile','$log','$parse','$window','$document','$rootScope','$uibPosition','dateFilter','uibDateParser','uibDatepickerPopupConfig','$timeout','uibDatepickerConfig','uibDatepickerPopupAttributeWarning',function($scope,$element,$attrs,$compile,$log,$parse,$window,$document,$rootScope,$position,dateFilter,dateParser,datepickerPopupConfig,$timeout,datepickerConfig,datepickerPopupAttributeWarning){var cache={},isHtml5DateInput=false;var dateFormat,closeOnDateSelection,appendToBody,onOpenFocus,datepickerPopupTemplateUrl,datepickerTemplateUrl,popupEl,datepickerEl,scrollParentEl,ngModel,ngModelOptions,$popup,altInputFormats,watchListeners=[];$scope.watchData={};this.init=function(_ngModel_){ngModel=_ngModel_;ngModelOptions=_ngModel_.$options||datepickerConfig.ngModelOptions;closeOnDateSelection=angular.isDefined($attrs.closeOnDateSelection)?$scope.$parent.$eval($attrs.closeOnDateSelection):datepickerPopupConfig.closeOnDateSelection;appendToBody=angular.isDefined($attrs.datepickerAppendToBody)?$scope.$parent.$eval($attrs.datepickerAppendToBody):datepickerPopupConfig.appendToBody;onOpenFocus=angular.isDefined($attrs.onOpenFocus)?$scope.$parent.$eval($attrs.onOpenFocus):datepickerPopupConfig.onOpenFocus;datepickerPopupTemplateUrl=angular.isDefined($attrs.datepickerPopupTemplateUrl)?$attrs.datepickerPopupTemplateUrl:datepickerPopupConfig.datepickerPopupTemplateUrl;datepickerTemplateUrl=angular.isDefined($attrs.datepickerTemplateUrl)?$attrs.datepickerTemplateUrl:datepickerPopupConfig.datepickerTemplateUrl;altInputFormats=angular.isDefined($attrs.altInputFormats)?$scope.$parent.$eval($attrs.altInputFormats):datepickerPopupConfig.altInputFormats;$scope.showButtonBar=angular.isDefined($attrs.showButtonBar)?$scope.$parent.$eval($attrs.showButtonBar):datepickerPopupConfig.showButtonBar;if(datepickerPopupConfig.html5Types[$attrs.type]){dateFormat=datepickerPopupConfig.html5Types[$attrs.type];isHtml5DateInput=true;}else{dateFormat=$attrs.uibDatepickerPopup||datepickerPopupConfig.datepickerPopup;$attrs.$observe('uibDatepickerPopup',function(value,oldValue){var newDateFormat=value||datepickerPopupConfig.datepickerPopup;// Invalidate the $modelValue to ensure that formatters re-run
	// FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
	if(newDateFormat!==dateFormat){dateFormat=newDateFormat;ngModel.$modelValue=null;if(!dateFormat){throw new Error('uibDatepickerPopup must have a date format specified.');}}});}if(!dateFormat){throw new Error('uibDatepickerPopup must have a date format specified.');}if(isHtml5DateInput&&$attrs.uibDatepickerPopup){throw new Error('HTML5 date input types do not support custom formats.');}// popup element used to display calendar
	popupEl=angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');$scope.ngModelOptions=angular.copy(ngModelOptions);$scope.ngModelOptions.timezone=null;if($scope.ngModelOptions.updateOnDefault===true){$scope.ngModelOptions.updateOn=$scope.ngModelOptions.updateOn?$scope.ngModelOptions.updateOn+' default':'default';}popupEl.attr({'ng-model':'date','ng-model-options':'ngModelOptions','ng-change':'dateSelection(date)','template-url':datepickerPopupTemplateUrl});// datepicker element
	datepickerEl=angular.element(popupEl.children()[0]);datepickerEl.attr('template-url',datepickerTemplateUrl);if(isHtml5DateInput){if($attrs.type==='month'){datepickerEl.attr('datepicker-mode','"month"');datepickerEl.attr('min-mode','month');}}if($scope.datepickerOptions){datepickerEl.attr('datepicker-options','datepickerOptions');}angular.forEach(['minMode','maxMode','datepickerMode','shortcutPropagation'],function(key){if($attrs[key]){if(datepickerPopupAttributeWarning){$log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');}var getAttribute=$parse($attrs[key]);var propConfig={get:function get(){return getAttribute($scope.$parent);}};datepickerEl.attr(cameltoDash(key),'watchData.'+key);// Propagate changes from datepicker to outside
	if(key==='datepickerMode'){var setAttribute=getAttribute.assign;propConfig.set=function(v){setAttribute($scope.$parent,v);};}Object.defineProperty($scope.watchData,key,propConfig);}});angular.forEach(['minDate','maxDate','initDate'],function(key){if($attrs[key]){if(datepickerPopupAttributeWarning){$log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');}var getAttribute=$parse($attrs[key]);watchListeners.push($scope.$parent.$watch(getAttribute,function(value){if(key==='minDate'||key==='maxDate'){if(value===null){cache[key]=null;}else if(angular.isDate(value)){cache[key]=dateParser.fromTimezone(new Date(value),ngModelOptions.timezone);}else{cache[key]=new Date(dateFilter(value,'medium'));}$scope.watchData[key]=value===null?null:cache[key];}else{var date=value?new Date(value):new Date();$scope.watchData[key]=dateParser.fromTimezone(date,ngModelOptions.timezone);}}));datepickerEl.attr(cameltoDash(key),'watchData.'+key);}});if($attrs.dateDisabled){if(datepickerPopupAttributeWarning){$log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');}datepickerEl.attr('date-disabled','dateDisabled({ date: date, mode: mode })');}angular.forEach(['formatDay','formatMonth','formatYear','formatDayHeader','formatDayTitle','formatMonthTitle','showWeeks','startingDay','yearRows','yearColumns'],function(key){if(angular.isDefined($attrs[key])){if(datepickerPopupAttributeWarning){$log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');}datepickerEl.attr(cameltoDash(key),$attrs[key]);}});if($attrs.customClass){if(datepickerPopupAttributeWarning){$log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');}datepickerEl.attr('custom-class','customClass({ date: date, mode: mode })');}if(!isHtml5DateInput){// Internal API to maintain the correct ng-invalid-[key] class
	ngModel.$$parserName='date';ngModel.$validators.date=validator;ngModel.$parsers.unshift(parseDate);ngModel.$formatters.push(function(value){if(ngModel.$isEmpty(value)){$scope.date=value;return value;}$scope.date=dateParser.fromTimezone(value,ngModelOptions.timezone);if(angular.isNumber($scope.date)){$scope.date=new Date($scope.date);}return dateParser.filter($scope.date,dateFormat);});}else{ngModel.$formatters.push(function(value){$scope.date=dateParser.fromTimezone(value,ngModelOptions.timezone);return value;});}// Detect changes in the view from the text box
	ngModel.$viewChangeListeners.push(function(){$scope.date=parseDateString(ngModel.$viewValue);});$element.on('keydown',inputKeydownBind);$popup=$compile(popupEl)($scope);// Prevent jQuery cache memory leak (template is now redundant after linking)
	popupEl.remove();if(appendToBody){$document.find('body').append($popup);}else{$element.after($popup);}$scope.$on('$destroy',function(){if($scope.isOpen===true){if(!$rootScope.$$phase){$scope.$apply(function(){$scope.isOpen=false;});}}$popup.remove();$element.off('keydown',inputKeydownBind);$document.off('click',documentClickBind);if(scrollParentEl){scrollParentEl.off('scroll',positionPopup);}angular.element($window).off('resize',positionPopup);//Clear all watch listeners on destroy
	while(watchListeners.length){watchListeners.shift()();}});};$scope.getText=function(key){return $scope[key+'Text']||datepickerPopupConfig[key+'Text'];};$scope.isDisabled=function(date){if(date==='today'){date=dateParser.fromTimezone(new Date(),ngModelOptions.timezone);}if($scope.datepickerOptions){return $scope.datepickerOptions&&$scope.datepickerOptions.minDate&&$scope.compare(date,$scope.datepickerOptions.minDate)<0||$scope.datepickerOptions.maxDate&&$scope.compare(date,$scope.datepickerOptions.maxDate)>0;}return $scope.watchData.minDate&&$scope.compare(date,cache.minDate)<0||$scope.watchData.maxDate&&$scope.compare(date,cache.maxDate)>0;};$scope.compare=function(date1,date2){return new Date(date1.getFullYear(),date1.getMonth(),date1.getDate())-new Date(date2.getFullYear(),date2.getMonth(),date2.getDate());};// Inner change
	$scope.dateSelection=function(dt){if(angular.isDefined(dt)){$scope.date=dt;}var date=$scope.date?dateParser.filter($scope.date,dateFormat):null;// Setting to NULL is necessary for form validators to function
	$element.val(date);ngModel.$setViewValue(date);if(closeOnDateSelection){$scope.isOpen=false;$element[0].focus();}};$scope.keydown=function(evt){if(evt.which===27){evt.stopPropagation();$scope.isOpen=false;$element[0].focus();}};$scope.select=function(date,evt){evt.stopPropagation();if(date==='today'){var today=new Date();if(angular.isDate($scope.date)){date=new Date($scope.date);date.setFullYear(today.getFullYear(),today.getMonth(),today.getDate());}else{date=new Date(today.setHours(0,0,0,0));}}$scope.dateSelection(date);};$scope.close=function(evt){evt.stopPropagation();$scope.isOpen=false;$element[0].focus();};$scope.disabled=angular.isDefined($attrs.disabled)||false;if($attrs.ngDisabled){watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled),function(disabled){$scope.disabled=disabled;}));}$scope.$watch('isOpen',function(value){if(value){if(!$scope.disabled){$timeout(function(){positionPopup();if(onOpenFocus){$scope.$broadcast('uib:datepicker.focus');}$document.on('click',documentClickBind);var placement=$attrs.popupPlacement?$attrs.popupPlacement:datepickerPopupConfig.placement;if(appendToBody||$position.parsePlacement(placement)[2]){scrollParentEl=scrollParentEl||angular.element($position.scrollParent($element));if(scrollParentEl){scrollParentEl.on('scroll',positionPopup);}}else{scrollParentEl=null;}angular.element($window).on('resize',positionPopup);},0,false);}else{$scope.isOpen=false;}}else{$document.off('click',documentClickBind);if(scrollParentEl){scrollParentEl.off('scroll',positionPopup);}angular.element($window).off('resize',positionPopup);}});function cameltoDash(string){return string.replace(/([A-Z])/g,function($1){return'-'+$1.toLowerCase();});}function parseDateString(viewValue){var date=dateParser.parse(viewValue,dateFormat,$scope.date);if(isNaN(date)){for(var i=0;i<altInputFormats.length;i++){date=dateParser.parse(viewValue,altInputFormats[i],$scope.date);if(!isNaN(date)){return date;}}}return date;}function parseDate(viewValue){if(angular.isNumber(viewValue)){// presumably timestamp to date object
	viewValue=new Date(viewValue);}if(!viewValue){return null;}if(angular.isDate(viewValue)&&!isNaN(viewValue)){return viewValue;}if(angular.isString(viewValue)){var date=parseDateString(viewValue);if(!isNaN(date)){return dateParser.toTimezone(date,ngModelOptions.timezone);}}return ngModel.$options&&ngModel.$options.allowInvalid?viewValue:undefined;}function validator(modelValue,viewValue){var value=modelValue||viewValue;if(!$attrs.ngRequired&&!value){return true;}if(angular.isNumber(value)){value=new Date(value);}if(!value){return true;}if(angular.isDate(value)&&!isNaN(value)){return true;}if(angular.isString(value)){return!isNaN(parseDateString(viewValue));}return false;}function documentClickBind(event){if(!$scope.isOpen&&$scope.disabled){return;}var popup=$popup[0];var dpContainsTarget=$element[0].contains(event.target);// The popup node may not be an element node
	// In some browsers (IE) only element nodes have the 'contains' function
	var popupContainsTarget=popup.contains!==undefined&&popup.contains(event.target);if($scope.isOpen&&!(dpContainsTarget||popupContainsTarget)){$scope.$apply(function(){$scope.isOpen=false;});}}function inputKeydownBind(evt){if(evt.which===27&&$scope.isOpen){evt.preventDefault();evt.stopPropagation();$scope.$apply(function(){$scope.isOpen=false;});$element[0].focus();}else if(evt.which===40&&!$scope.isOpen){evt.preventDefault();evt.stopPropagation();$scope.$apply(function(){$scope.isOpen=true;});}}function positionPopup(){if($scope.isOpen){var dpElement=angular.element($popup[0].querySelector('.uib-datepicker-popup'));var placement=$attrs.popupPlacement?$attrs.popupPlacement:datepickerPopupConfig.placement;var position=$position.positionElements($element,dpElement,placement,appendToBody);dpElement.css({top:position.top+'px',left:position.left+'px'});if(dpElement.hasClass('uib-position-measure')){dpElement.removeClass('uib-position-measure');}}}$scope.$on('uib:datepicker.mode',function(){$timeout(positionPopup,0,false);});}]).directive('uibDatepickerPopup',function(){return{require:['ngModel','uibDatepickerPopup'],controller:'UibDatepickerPopupController',scope:{datepickerOptions:'=?',isOpen:'=?',currentText:'@',clearText:'@',closeText:'@',dateDisabled:'&',customClass:'&'},link:function link(scope,element,attrs,ctrls){var ngModel=ctrls[0],ctrl=ctrls[1];ctrl.init(ngModel);}};}).directive('uibDatepickerPopupWrap',function(){return{replace:true,transclude:true,templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||'uib/template/datepicker/popup.html';}};});angular.module('ui.bootstrap.debounce',[])/**
	 * A helper, internal service that debounces a function
	 */.factory('$$debounce',['$timeout',function($timeout){return function(callback,debounceTime){var timeoutPromise;return function(){var self=this;var args=Array.prototype.slice.call(arguments);if(timeoutPromise){$timeout.cancel(timeoutPromise);}timeoutPromise=$timeout(function(){callback.apply(self,args);},debounceTime);};};}]);angular.module('ui.bootstrap.dropdown',['ui.bootstrap.position']).constant('uibDropdownConfig',{appendToOpenClass:'uib-dropdown-open',openClass:'open'}).service('uibDropdownService',['$document','$rootScope',function($document,$rootScope){var openScope=null;this.open=function(dropdownScope){if(!openScope){$document.on('click',closeDropdown);$document.on('keydown',keybindFilter);}if(openScope&&openScope!==dropdownScope){openScope.isOpen=false;}openScope=dropdownScope;};this.close=function(dropdownScope){if(openScope===dropdownScope){openScope=null;$document.off('click',closeDropdown);$document.off('keydown',keybindFilter);}};var closeDropdown=function closeDropdown(evt){// This method may still be called during the same mouse event that
	// unbound this event handler. So check openScope before proceeding.
	if(!openScope){return;}if(evt&&openScope.getAutoClose()==='disabled'){return;}if(evt&&evt.which===3){return;}var toggleElement=openScope.getToggleElement();if(evt&&toggleElement&&toggleElement[0].contains(evt.target)){return;}var dropdownElement=openScope.getDropdownElement();if(evt&&openScope.getAutoClose()==='outsideClick'&&dropdownElement&&dropdownElement[0].contains(evt.target)){return;}openScope.isOpen=false;if(!$rootScope.$$phase){openScope.$apply();}};var keybindFilter=function keybindFilter(evt){if(evt.which===27){openScope.focusToggleElement();closeDropdown();}else if(openScope.isKeynavEnabled()&&[38,40].indexOf(evt.which)!==-1&&openScope.isOpen){evt.preventDefault();evt.stopPropagation();openScope.focusDropdownEntry(evt.which);}};}]).controller('UibDropdownController',['$scope','$element','$attrs','$parse','uibDropdownConfig','uibDropdownService','$animate','$uibPosition','$document','$compile','$templateRequest',function($scope,$element,$attrs,$parse,dropdownConfig,uibDropdownService,$animate,$position,$document,$compile,$templateRequest){var self=this,scope=$scope.$new(),// create a child scope so we are not polluting original one
	templateScope,appendToOpenClass=dropdownConfig.appendToOpenClass,openClass=dropdownConfig.openClass,getIsOpen,setIsOpen=angular.noop,toggleInvoker=$attrs.onToggle?$parse($attrs.onToggle):angular.noop,appendToBody=false,appendTo=null,keynavEnabled=false,selectedOption=null,body=$document.find('body');$element.addClass('dropdown');this.init=function(){if($attrs.isOpen){getIsOpen=$parse($attrs.isOpen);setIsOpen=getIsOpen.assign;$scope.$watch(getIsOpen,function(value){scope.isOpen=!!value;});}if(angular.isDefined($attrs.dropdownAppendTo)){var appendToEl=$parse($attrs.dropdownAppendTo)(scope);if(appendToEl){appendTo=angular.element(appendToEl);}}appendToBody=angular.isDefined($attrs.dropdownAppendToBody);keynavEnabled=angular.isDefined($attrs.keyboardNav);if(appendToBody&&!appendTo){appendTo=body;}if(appendTo&&self.dropdownMenu){appendTo.append(self.dropdownMenu);$element.on('$destroy',function handleDestroyEvent(){self.dropdownMenu.remove();});}};this.toggle=function(open){scope.isOpen=arguments.length?!!open:!scope.isOpen;if(angular.isFunction(setIsOpen)){setIsOpen(scope,scope.isOpen);}return scope.isOpen;};// Allow other directives to watch status
	this.isOpen=function(){return scope.isOpen;};scope.getToggleElement=function(){return self.toggleElement;};scope.getAutoClose=function(){return $attrs.autoClose||'always';//or 'outsideClick' or 'disabled'
	};scope.getElement=function(){return $element;};scope.isKeynavEnabled=function(){return keynavEnabled;};scope.focusDropdownEntry=function(keyCode){var elems=self.dropdownMenu?//If append to body is used.
	angular.element(self.dropdownMenu).find('a'):$element.find('ul').eq(0).find('a');switch(keyCode){case 40:{if(!angular.isNumber(self.selectedOption)){self.selectedOption=0;}else{self.selectedOption=self.selectedOption===elems.length-1?self.selectedOption:self.selectedOption+1;}break;}case 38:{if(!angular.isNumber(self.selectedOption)){self.selectedOption=elems.length-1;}else{self.selectedOption=self.selectedOption===0?0:self.selectedOption-1;}break;}}elems[self.selectedOption].focus();};scope.getDropdownElement=function(){return self.dropdownMenu;};scope.focusToggleElement=function(){if(self.toggleElement){self.toggleElement[0].focus();}};scope.$watch('isOpen',function(isOpen,wasOpen){if(appendTo&&self.dropdownMenu){var pos=$position.positionElements($element,self.dropdownMenu,'bottom-left',true),css,rightalign;css={top:pos.top+'px',display:isOpen?'block':'none'};rightalign=self.dropdownMenu.hasClass('dropdown-menu-right');if(!rightalign){css.left=pos.left+'px';css.right='auto';}else{css.left='auto';css.right=window.innerWidth-(pos.left+$element.prop('offsetWidth'))+'px';}// Need to adjust our positioning to be relative to the appendTo container
	// if it's not the body element
	if(!appendToBody){var appendOffset=$position.offset(appendTo);css.top=pos.top-appendOffset.top+'px';if(!rightalign){css.left=pos.left-appendOffset.left+'px';}else{css.right=window.innerWidth-(pos.left-appendOffset.left+$element.prop('offsetWidth'))+'px';}}self.dropdownMenu.css(css);}var openContainer=appendTo?appendTo:$element;var hasOpenClass=openContainer.hasClass(appendTo?appendToOpenClass:openClass);if(hasOpenClass===!isOpen){$animate[isOpen?'addClass':'removeClass'](openContainer,appendTo?appendToOpenClass:openClass).then(function(){if(angular.isDefined(isOpen)&&isOpen!==wasOpen){toggleInvoker($scope,{open:!!isOpen});}});}if(isOpen){if(self.dropdownMenuTemplateUrl){$templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent){templateScope=scope.$new();$compile(tplContent.trim())(templateScope,function(dropdownElement){var newEl=dropdownElement;self.dropdownMenu.replaceWith(newEl);self.dropdownMenu=newEl;});});}scope.focusToggleElement();uibDropdownService.open(scope);}else{if(self.dropdownMenuTemplateUrl){if(templateScope){templateScope.$destroy();}var newEl=angular.element('<ul class="dropdown-menu"></ul>');self.dropdownMenu.replaceWith(newEl);self.dropdownMenu=newEl;}uibDropdownService.close(scope);self.selectedOption=null;}if(angular.isFunction(setIsOpen)){setIsOpen($scope,isOpen);}});$scope.$on('$locationChangeSuccess',function(){if(scope.getAutoClose()!=='disabled'){scope.isOpen=false;}});}]).directive('uibDropdown',function(){return{controller:'UibDropdownController',link:function link(scope,element,attrs,dropdownCtrl){dropdownCtrl.init();}};}).directive('uibDropdownMenu',function(){return{restrict:'A',require:'?^uibDropdown',link:function link(scope,element,attrs,dropdownCtrl){if(!dropdownCtrl||angular.isDefined(attrs.dropdownNested)){return;}element.addClass('dropdown-menu');var tplUrl=attrs.templateUrl;if(tplUrl){dropdownCtrl.dropdownMenuTemplateUrl=tplUrl;}if(!dropdownCtrl.dropdownMenu){dropdownCtrl.dropdownMenu=element;}}};}).directive('uibDropdownToggle',function(){return{require:'?^uibDropdown',link:function link(scope,element,attrs,dropdownCtrl){if(!dropdownCtrl){return;}element.addClass('dropdown-toggle');dropdownCtrl.toggleElement=element;var toggleDropdown=function toggleDropdown(event){event.preventDefault();if(!element.hasClass('disabled')&&!attrs.disabled){scope.$apply(function(){dropdownCtrl.toggle();});}};element.bind('click',toggleDropdown);// WAI-ARIA
	element.attr({'aria-haspopup':true,'aria-expanded':false});scope.$watch(dropdownCtrl.isOpen,function(isOpen){element.attr('aria-expanded',!!isOpen);});scope.$on('$destroy',function(){element.unbind('click',toggleDropdown);});}};});angular.module('ui.bootstrap.stackedMap',[])/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */.factory('$$stackedMap',function(){return{createNew:function createNew(){var stack=[];return{add:function add(key,value){stack.push({key:key,value:value});},get:function get(key){for(var i=0;i<stack.length;i++){if(key===stack[i].key){return stack[i];}}},keys:function keys(){var keys=[];for(var i=0;i<stack.length;i++){keys.push(stack[i].key);}return keys;},top:function top(){return stack[stack.length-1];},remove:function remove(key){var idx=-1;for(var i=0;i<stack.length;i++){if(key===stack[i].key){idx=i;break;}}return stack.splice(idx,1)[0];},removeTop:function removeTop(){return stack.splice(stack.length-1,1)[0];},length:function length(){return stack.length;}};}};});angular.module('ui.bootstrap.modal',['ui.bootstrap.stackedMap'])/**
	 * A helper, internal data structure that stores all references attached to key
	 */.factory('$$multiMap',function(){return{createNew:function createNew(){var map={};return{entries:function entries(){return Object.keys(map).map(function(key){return{key:key,value:map[key]};});},get:function get(key){return map[key];},hasKey:function hasKey(key){return!!map[key];},keys:function keys(){return Object.keys(map);},put:function put(key,value){if(!map[key]){map[key]=[];}map[key].push(value);},remove:function remove(key,value){var values=map[key];if(!values){return;}var idx=values.indexOf(value);if(idx!==-1){values.splice(idx,1);}if(!values.length){delete map[key];}}};}};})/**
	 * Pluggable resolve mechanism for the modal resolve resolution
	 * Supports UI Router's $resolve service
	 */.provider('$uibResolve',function(){var resolve=this;this.resolver=null;this.setResolver=function(resolver){this.resolver=resolver;};this.$get=['$injector','$q',function($injector,$q){var resolver=resolve.resolver?$injector.get(resolve.resolver):null;return{resolve:function resolve(invocables,locals,parent,self){if(resolver){return resolver.resolve(invocables,locals,parent,self);}var promises=[];angular.forEach(invocables,function(value){if(angular.isFunction(value)||angular.isArray(value)){promises.push($q.resolve($injector.invoke(value)));}else if(angular.isString(value)){promises.push($q.resolve($injector.get(value)));}else{promises.push($q.resolve(value));}});return $q.all(promises).then(function(resolves){var resolveObj={};var resolveIter=0;angular.forEach(invocables,function(value,key){resolveObj[key]=resolves[resolveIter++];});return resolveObj;});}};}];})/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */.directive('uibModalBackdrop',['$animate','$injector','$uibModalStack',function($animate,$injector,$modalStack){return{replace:true,templateUrl:'uib/template/modal/backdrop.html',compile:function compile(tElement,tAttrs){tElement.addClass(tAttrs.backdropClass);return linkFn;}};function linkFn(scope,element,attrs){if(attrs.modalInClass){$animate.addClass(element,attrs.modalInClass);scope.$on($modalStack.NOW_CLOSING_EVENT,function(e,setIsAsync){var done=setIsAsync();if(scope.modalOptions.animation){$animate.removeClass(element,attrs.modalInClass).then(done);}else{done();}});}}}]).directive('uibModalWindow',['$uibModalStack','$q','$animateCss','$document',function($modalStack,$q,$animateCss,$document){return{scope:{index:'@'},replace:true,transclude:true,templateUrl:function templateUrl(tElement,tAttrs){return tAttrs.templateUrl||'uib/template/modal/window.html';},link:function link(scope,element,attrs){element.addClass(attrs.windowClass||'');element.addClass(attrs.windowTopClass||'');scope.size=attrs.size;scope.close=function(evt){var modal=$modalStack.getTop();if(modal&&modal.value.backdrop&&modal.value.backdrop!=='static'&&evt.target===evt.currentTarget){evt.preventDefault();evt.stopPropagation();$modalStack.dismiss(modal.key,'backdrop click');}};// moved from template to fix issue #2280
	element.on('click',scope.close);// This property is only added to the scope for the purpose of detecting when this directive is rendered.
	// We can detect that by using this property in the template associated with this directive and then use
	// {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	scope.$isRendered=true;// Deferred object that will be resolved when this modal is render.
	var modalRenderDeferObj=$q.defer();// Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
	// In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
	attrs.$observe('modalRender',function(value){if(value==='true'){modalRenderDeferObj.resolve();}});modalRenderDeferObj.promise.then(function(){var animationPromise=null;if(attrs.modalInClass){animationPromise=$animateCss(element,{addClass:attrs.modalInClass}).start();scope.$on($modalStack.NOW_CLOSING_EVENT,function(e,setIsAsync){var done=setIsAsync();$animateCss(element,{removeClass:attrs.modalInClass}).start().then(done);});}$q.when(animationPromise).then(function(){// Notify {@link $modalStack} that modal is rendered.
	var modal=$modalStack.getTop();if(modal){$modalStack.modalRendered(modal.key);}/**
	             * If something within the freshly-opened modal already has focus (perhaps via a
	             * directive that causes focus). then no need to try and focus anything.
	             */if(!($document[0].activeElement&&element[0].contains($document[0].activeElement))){var inputWithAutofocus=element[0].querySelector('[autofocus]');/**
	               * Auto-focusing of a freshly-opened modal element causes any child elements
	               * with the autofocus attribute to lose focus. This is an issue on touch
	               * based devices which will show and then hide the onscreen keyboard.
	               * Attempts to refocus the autofocus element via JavaScript will not reopen
	               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	               * the modal element if the modal does not contain an autofocus element.
	               */if(inputWithAutofocus){inputWithAutofocus.focus();}else{element[0].focus();}}});});}};}]).directive('uibModalAnimationClass',function(){return{compile:function compile(tElement,tAttrs){if(tAttrs.modalAnimation){tElement.addClass(tAttrs.uibModalAnimationClass);}}};}).directive('uibModalTransclude',function(){return{link:function link(scope,element,attrs,controller,transclude){transclude(scope.$parent,function(clone){element.empty();element.append(clone);});}};}).factory('$uibModalStack',['$animate','$animateCss','$document','$compile','$rootScope','$q','$$multiMap','$$stackedMap',function($animate,$animateCss,$document,$compile,$rootScope,$q,$$multiMap,$$stackedMap){var OPENED_MODAL_CLASS='modal-open';var backdropDomEl,backdropScope;var openedWindows=$$stackedMap.createNew();var openedClasses=$$multiMap.createNew();var $modalStack={NOW_CLOSING_EVENT:'modal.stack.now-closing'};//Modal focus behavior
	var tabableSelector='a[href], area[href], input:not([disabled]), '+'button:not([disabled]),select:not([disabled]), textarea:not([disabled]), '+'iframe, object, embed, *[tabindex], *[contenteditable=true]';function isVisible(element){return!!(element.offsetWidth||element.offsetHeight||element.getClientRects().length);}function backdropIndex(){var topBackdropIndex=-1;var opened=openedWindows.keys();for(var i=0;i<opened.length;i++){if(openedWindows.get(opened[i]).value.backdrop){topBackdropIndex=i;}}return topBackdropIndex;}$rootScope.$watch(backdropIndex,function(newBackdropIndex){if(backdropScope){backdropScope.index=newBackdropIndex;}});function removeModalWindow(modalInstance,elementToReceiveFocus){var modalWindow=openedWindows.get(modalInstance).value;var appendToElement=modalWindow.appendTo;//clean up the stack
	openedWindows.remove(modalInstance);removeAfterAnimate(modalWindow.modalDomEl,modalWindow.modalScope,function(){var modalBodyClass=modalWindow.openedClass||OPENED_MODAL_CLASS;openedClasses.remove(modalBodyClass,modalInstance);appendToElement.toggleClass(modalBodyClass,openedClasses.hasKey(modalBodyClass));toggleTopWindowClass(true);},modalWindow.closedDeferred);checkRemoveBackdrop();//move focus to specified element if available, or else to body
	if(elementToReceiveFocus&&elementToReceiveFocus.focus){elementToReceiveFocus.focus();}else if(appendToElement.focus){appendToElement.focus();}}// Add or remove "windowTopClass" from the top window in the stack
	function toggleTopWindowClass(toggleSwitch){var modalWindow;if(openedWindows.length()>0){modalWindow=openedWindows.top().value;modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass||'',toggleSwitch);}}function checkRemoveBackdrop(){//remove backdrop if no longer needed
	if(backdropDomEl&&backdropIndex()===-1){var backdropScopeRef=backdropScope;removeAfterAnimate(backdropDomEl,backdropScope,function(){backdropScopeRef=null;});backdropDomEl=undefined;backdropScope=undefined;}}function removeAfterAnimate(domEl,scope,done,closedDeferred){var asyncDeferred;var asyncPromise=null;var setIsAsync=function setIsAsync(){if(!asyncDeferred){asyncDeferred=$q.defer();asyncPromise=asyncDeferred.promise;}return function asyncDone(){asyncDeferred.resolve();};};scope.$broadcast($modalStack.NOW_CLOSING_EVENT,setIsAsync);// Note that it's intentional that asyncPromise might be null.
	// That's when setIsAsync has not been called during the
	// NOW_CLOSING_EVENT broadcast.
	return $q.when(asyncPromise).then(afterAnimating);function afterAnimating(){if(afterAnimating.done){return;}afterAnimating.done=true;$animate.leave(domEl).then(function(){domEl.remove();if(closedDeferred){closedDeferred.resolve();}});scope.$destroy();if(done){done();}}}$document.on('keydown',keydownListener);$rootScope.$on('$destroy',function(){$document.off('keydown',keydownListener);});function keydownListener(evt){if(evt.isDefaultPrevented()){return evt;}var modal=openedWindows.top();if(modal){switch(evt.which){case 27:{if(modal.value.keyboard){evt.preventDefault();$rootScope.$apply(function(){$modalStack.dismiss(modal.key,'escape key press');});}break;}case 9:{var list=$modalStack.loadFocusElementList(modal);var focusChanged=false;if(evt.shiftKey){if($modalStack.isFocusInFirstItem(evt,list)||$modalStack.isModalFocused(evt,modal)){focusChanged=$modalStack.focusLastFocusableElement(list);}}else{if($modalStack.isFocusInLastItem(evt,list)){focusChanged=$modalStack.focusFirstFocusableElement(list);}}if(focusChanged){evt.preventDefault();evt.stopPropagation();}break;}}}}$modalStack.open=function(modalInstance,modal){var modalOpener=$document[0].activeElement,modalBodyClass=modal.openedClass||OPENED_MODAL_CLASS;toggleTopWindowClass(false);openedWindows.add(modalInstance,{deferred:modal.deferred,renderDeferred:modal.renderDeferred,closedDeferred:modal.closedDeferred,modalScope:modal.scope,backdrop:modal.backdrop,keyboard:modal.keyboard,openedClass:modal.openedClass,windowTopClass:modal.windowTopClass,animation:modal.animation,appendTo:modal.appendTo});openedClasses.put(modalBodyClass,modalInstance);var appendToElement=modal.appendTo,currBackdropIndex=backdropIndex();if(!appendToElement.length){throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');}if(currBackdropIndex>=0&&!backdropDomEl){backdropScope=$rootScope.$new(true);backdropScope.modalOptions=modal;backdropScope.index=currBackdropIndex;backdropDomEl=angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');backdropDomEl.attr('backdrop-class',modal.backdropClass);if(modal.animation){backdropDomEl.attr('modal-animation','true');}$compile(backdropDomEl)(backdropScope);$animate.enter(backdropDomEl,appendToElement);}var angularDomEl=angular.element('<div uib-modal-window="modal-window"></div>');angularDomEl.attr({'template-url':modal.windowTemplateUrl,'window-class':modal.windowClass,'window-top-class':modal.windowTopClass,'size':modal.size,'index':openedWindows.length()-1,'animate':'animate'}).html(modal.content);if(modal.animation){angularDomEl.attr('modal-animation','true');}$animate.enter($compile(angularDomEl)(modal.scope),appendToElement).then(function(){if(!modal.scope.$$uibDestructionScheduled){$animate.addClass(appendToElement,modalBodyClass);}});openedWindows.top().value.modalDomEl=angularDomEl;openedWindows.top().value.modalOpener=modalOpener;};function broadcastClosing(modalWindow,resultOrReason,closing){return!modalWindow.value.modalScope.$broadcast('modal.closing',resultOrReason,closing).defaultPrevented;}$modalStack.close=function(modalInstance,result){var modalWindow=openedWindows.get(modalInstance);if(modalWindow&&broadcastClosing(modalWindow,result,true)){modalWindow.value.modalScope.$$uibDestructionScheduled=true;modalWindow.value.deferred.resolve(result);removeModalWindow(modalInstance,modalWindow.value.modalOpener);return true;}return!modalWindow;};$modalStack.dismiss=function(modalInstance,reason){var modalWindow=openedWindows.get(modalInstance);if(modalWindow&&broadcastClosing(modalWindow,reason,false)){modalWindow.value.modalScope.$$uibDestructionScheduled=true;modalWindow.value.deferred.reject(reason);removeModalWindow(modalInstance,modalWindow.value.modalOpener);return true;}return!modalWindow;};$modalStack.dismissAll=function(reason){var topModal=this.getTop();while(topModal&&this.dismiss(topModal.key,reason)){topModal=this.getTop();}};$modalStack.getTop=function(){return openedWindows.top();};$modalStack.modalRendered=function(modalInstance){var modalWindow=openedWindows.get(modalInstance);if(modalWindow){modalWindow.value.renderDeferred.resolve();}};$modalStack.focusFirstFocusableElement=function(list){if(list.length>0){list[0].focus();return true;}return false;};$modalStack.focusLastFocusableElement=function(list){if(list.length>0){list[list.length-1].focus();return true;}return false;};$modalStack.isModalFocused=function(evt,modalWindow){if(evt&&modalWindow){var modalDomEl=modalWindow.value.modalDomEl;if(modalDomEl&&modalDomEl.length){return(evt.target||evt.srcElement)===modalDomEl[0];}}return false;};$modalStack.isFocusInFirstItem=function(evt,list){if(list.length>0){return(evt.target||evt.srcElement)===list[0];}return false;};$modalStack.isFocusInLastItem=function(evt,list){if(list.length>0){return(evt.target||evt.srcElement)===list[list.length-1];}return false;};$modalStack.loadFocusElementList=function(modalWindow){if(modalWindow){var modalDomE1=modalWindow.value.modalDomEl;if(modalDomE1&&modalDomE1.length){var elements=modalDomE1[0].querySelectorAll(tabableSelector);return elements?Array.prototype.filter.call(elements,function(element){return isVisible(element);}):elements;}}};return $modalStack;}]).provider('$uibModal',function(){var $modalProvider={options:{animation:true,backdrop:true,//can also be false or 'static'
	keyboard:true},$get:['$rootScope','$q','$document','$templateRequest','$controller','$uibResolve','$uibModalStack',function($rootScope,$q,$document,$templateRequest,$controller,$uibResolve,$modalStack){var $modal={};function getTemplatePromise(options){return options.template?$q.when(options.template):$templateRequest(angular.isFunction(options.templateUrl)?options.templateUrl():options.templateUrl);}var promiseChain=null;$modal.getPromiseChain=function(){return promiseChain;};$modal.open=function(modalOptions){var modalResultDeferred=$q.defer();var modalOpenedDeferred=$q.defer();var modalClosedDeferred=$q.defer();var modalRenderDeferred=$q.defer();//prepare an instance of a modal to be injected into controllers and returned to a caller
	var modalInstance={result:modalResultDeferred.promise,opened:modalOpenedDeferred.promise,closed:modalClosedDeferred.promise,rendered:modalRenderDeferred.promise,close:function close(result){return $modalStack.close(modalInstance,result);},dismiss:function dismiss(reason){return $modalStack.dismiss(modalInstance,reason);}};//merge and clean up options
	modalOptions=angular.extend({},$modalProvider.options,modalOptions);modalOptions.resolve=modalOptions.resolve||{};modalOptions.appendTo=modalOptions.appendTo||$document.find('body').eq(0);//verify options
	if(!modalOptions.template&&!modalOptions.templateUrl){throw new Error('One of template or templateUrl options is required.');}var templateAndResolvePromise=$q.all([getTemplatePromise(modalOptions),$uibResolve.resolve(modalOptions.resolve,{},null,null)]);function resolveWithTemplate(){return templateAndResolvePromise;}// Wait for the resolution of the existing promise chain.
	// Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	// Then add to $modalStack and resolve opened.
	// Finally clean up the chain variable if no subsequent modal has overwritten it.
	var samePromise;samePromise=promiseChain=$q.all([promiseChain]).then(resolveWithTemplate,resolveWithTemplate).then(function resolveSuccess(tplAndVars){var providedScope=modalOptions.scope||$rootScope;var modalScope=providedScope.$new();modalScope.$close=modalInstance.close;modalScope.$dismiss=modalInstance.dismiss;modalScope.$on('$destroy',function(){if(!modalScope.$$uibDestructionScheduled){modalScope.$dismiss('$uibUnscheduledDestruction');}});var ctrlInstance,ctrlInstantiate,ctrlLocals={};//controllers
	if(modalOptions.controller){ctrlLocals.$scope=modalScope;ctrlLocals.$uibModalInstance=modalInstance;angular.forEach(tplAndVars[1],function(value,key){ctrlLocals[key]=value;});// the third param will make the controller instantiate later,private api
	// @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
	ctrlInstantiate=$controller(modalOptions.controller,ctrlLocals,true);if(modalOptions.controllerAs){ctrlInstance=ctrlInstantiate.instance;if(modalOptions.bindToController){ctrlInstance.$close=modalScope.$close;ctrlInstance.$dismiss=modalScope.$dismiss;angular.extend(ctrlInstance,providedScope);}ctrlInstance=ctrlInstantiate();modalScope[modalOptions.controllerAs]=ctrlInstance;}else{ctrlInstance=ctrlInstantiate();}if(angular.isFunction(ctrlInstance.$onInit)){ctrlInstance.$onInit();}}$modalStack.open(modalInstance,{scope:modalScope,deferred:modalResultDeferred,renderDeferred:modalRenderDeferred,closedDeferred:modalClosedDeferred,content:tplAndVars[0],animation:modalOptions.animation,backdrop:modalOptions.backdrop,keyboard:modalOptions.keyboard,backdropClass:modalOptions.backdropClass,windowTopClass:modalOptions.windowTopClass,windowClass:modalOptions.windowClass,windowTemplateUrl:modalOptions.windowTemplateUrl,size:modalOptions.size,openedClass:modalOptions.openedClass,appendTo:modalOptions.appendTo});modalOpenedDeferred.resolve(true);},function resolveError(reason){modalOpenedDeferred.reject(reason);modalResultDeferred.reject(reason);})['finally'](function(){if(promiseChain===samePromise){promiseChain=null;}});return modalInstance;};return $modal;}]};return $modalProvider;});angular.module('ui.bootstrap.paging',[])/**
	 * Helper internal service for generating common controller code between the
	 * pager and pagination components
	 */.factory('uibPaging',['$parse',function($parse){return{create:function create(ctrl,$scope,$attrs){ctrl.setNumPages=$attrs.numPages?$parse($attrs.numPages).assign:angular.noop;ctrl.ngModelCtrl={$setViewValue:angular.noop};// nullModelCtrl
	ctrl._watchers=[];ctrl.init=function(ngModelCtrl,config){ctrl.ngModelCtrl=ngModelCtrl;ctrl.config=config;ngModelCtrl.$render=function(){ctrl.render();};if($attrs.itemsPerPage){ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage,function(value){ctrl.itemsPerPage=parseInt(value,10);$scope.totalPages=ctrl.calculateTotalPages();ctrl.updatePage();}));}else{ctrl.itemsPerPage=config.itemsPerPage;}$scope.$watch('totalItems',function(newTotal,oldTotal){if(angular.isDefined(newTotal)||newTotal!==oldTotal){$scope.totalPages=ctrl.calculateTotalPages();ctrl.updatePage();}});};ctrl.calculateTotalPages=function(){var totalPages=ctrl.itemsPerPage<1?1:Math.ceil($scope.totalItems/ctrl.itemsPerPage);return Math.max(totalPages||0,1);};ctrl.render=function(){$scope.page=parseInt(ctrl.ngModelCtrl.$viewValue,10)||1;};$scope.selectPage=function(page,evt){if(evt){evt.preventDefault();}var clickAllowed=!$scope.ngDisabled||!evt;if(clickAllowed&&$scope.page!==page&&page>0&&page<=$scope.totalPages){if(evt&&evt.target){evt.target.blur();}ctrl.ngModelCtrl.$setViewValue(page);ctrl.ngModelCtrl.$render();}};$scope.getText=function(key){return $scope[key+'Text']||ctrl.config[key+'Text'];};$scope.noPrevious=function(){return $scope.page===1;};$scope.noNext=function(){return $scope.page===$scope.totalPages;};ctrl.updatePage=function(){ctrl.setNumPages($scope.$parent,$scope.totalPages);// Readonly variable
	if($scope.page>$scope.totalPages){$scope.selectPage($scope.totalPages);}else{ctrl.ngModelCtrl.$render();}};$scope.$on('$destroy',function(){while(ctrl._watchers.length){ctrl._watchers.shift()();}});}};}]);angular.module('ui.bootstrap.pager',['ui.bootstrap.paging']).controller('UibPagerController',['$scope','$attrs','uibPaging','uibPagerConfig',function($scope,$attrs,uibPaging,uibPagerConfig){$scope.align=angular.isDefined($attrs.align)?$scope.$parent.$eval($attrs.align):uibPagerConfig.align;uibPaging.create(this,$scope,$attrs);}]).constant('uibPagerConfig',{itemsPerPage:10,previousText:'« Previous',nextText:'Next »',align:true}).directive('uibPager',['uibPagerConfig',function(uibPagerConfig){return{scope:{totalItems:'=',previousText:'@',nextText:'@',ngDisabled:'='},require:['uibPager','?ngModel'],controller:'UibPagerController',controllerAs:'pager',templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||'uib/template/pager/pager.html';},replace:true,link:function link(scope,element,attrs,ctrls){var paginationCtrl=ctrls[0],ngModelCtrl=ctrls[1];if(!ngModelCtrl){return;// do nothing if no ng-model
	}paginationCtrl.init(ngModelCtrl,uibPagerConfig);}};}]);angular.module('ui.bootstrap.pagination',['ui.bootstrap.paging']).controller('UibPaginationController',['$scope','$attrs','$parse','uibPaging','uibPaginationConfig',function($scope,$attrs,$parse,uibPaging,uibPaginationConfig){var ctrl=this;// Setup configuration parameters
	var maxSize=angular.isDefined($attrs.maxSize)?$scope.$parent.$eval($attrs.maxSize):uibPaginationConfig.maxSize,rotate=angular.isDefined($attrs.rotate)?$scope.$parent.$eval($attrs.rotate):uibPaginationConfig.rotate,forceEllipses=angular.isDefined($attrs.forceEllipses)?$scope.$parent.$eval($attrs.forceEllipses):uibPaginationConfig.forceEllipses,boundaryLinkNumbers=angular.isDefined($attrs.boundaryLinkNumbers)?$scope.$parent.$eval($attrs.boundaryLinkNumbers):uibPaginationConfig.boundaryLinkNumbers,pageLabel=angular.isDefined($attrs.pageLabel)?function(idx){return $scope.$parent.$eval($attrs.pageLabel,{$page:idx});}:angular.identity;$scope.boundaryLinks=angular.isDefined($attrs.boundaryLinks)?$scope.$parent.$eval($attrs.boundaryLinks):uibPaginationConfig.boundaryLinks;$scope.directionLinks=angular.isDefined($attrs.directionLinks)?$scope.$parent.$eval($attrs.directionLinks):uibPaginationConfig.directionLinks;uibPaging.create(this,$scope,$attrs);if($attrs.maxSize){ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize),function(value){maxSize=parseInt(value,10);ctrl.render();}));}// Create page object used in template
	function makePage(number,text,isActive){return{number:number,text:text,active:isActive};}function getPages(currentPage,totalPages){var pages=[];// Default page limits
	var startPage=1,endPage=totalPages;var isMaxSized=angular.isDefined(maxSize)&&maxSize<totalPages;// recompute if maxSize
	if(isMaxSized){if(rotate){// Current page is displayed in the middle of the visible ones
	startPage=Math.max(currentPage-Math.floor(maxSize/2),1);endPage=startPage+maxSize-1;// Adjust if limit is exceeded
	if(endPage>totalPages){endPage=totalPages;startPage=endPage-maxSize+1;}}else{// Visible pages are paginated with maxSize
	startPage=(Math.ceil(currentPage/maxSize)-1)*maxSize+1;// Adjust last page if limit is exceeded
	endPage=Math.min(startPage+maxSize-1,totalPages);}}// Add page number links
	for(var number=startPage;number<=endPage;number++){var page=makePage(number,pageLabel(number),number===currentPage);pages.push(page);}// Add links to move between page sets
	if(isMaxSized&&maxSize>0&&(!rotate||forceEllipses||boundaryLinkNumbers)){if(startPage>1){if(!boundaryLinkNumbers||startPage>3){//need ellipsis for all options unless range is too close to beginning
	var previousPageSet=makePage(startPage-1,'...',false);pages.unshift(previousPageSet);}if(boundaryLinkNumbers){if(startPage===3){//need to replace ellipsis when the buttons would be sequential
	var secondPageLink=makePage(2,'2',false);pages.unshift(secondPageLink);}//add the first page
	var firstPageLink=makePage(1,'1',false);pages.unshift(firstPageLink);}}if(endPage<totalPages){if(!boundaryLinkNumbers||endPage<totalPages-2){//need ellipsis for all options unless range is too close to end
	var nextPageSet=makePage(endPage+1,'...',false);pages.push(nextPageSet);}if(boundaryLinkNumbers){if(endPage===totalPages-2){//need to replace ellipsis when the buttons would be sequential
	var secondToLastPageLink=makePage(totalPages-1,totalPages-1,false);pages.push(secondToLastPageLink);}//add the last page
	var lastPageLink=makePage(totalPages,totalPages,false);pages.push(lastPageLink);}}}return pages;}var originalRender=this.render;this.render=function(){originalRender();if($scope.page>0&&$scope.page<=$scope.totalPages){$scope.pages=getPages($scope.page,$scope.totalPages);}};}]).constant('uibPaginationConfig',{itemsPerPage:10,boundaryLinks:false,boundaryLinkNumbers:false,directionLinks:true,firstText:'First',previousText:'Previous',nextText:'Next',lastText:'Last',rotate:true,forceEllipses:false}).directive('uibPagination',['$parse','uibPaginationConfig',function($parse,uibPaginationConfig){return{scope:{totalItems:'=',firstText:'@',previousText:'@',nextText:'@',lastText:'@',ngDisabled:'='},require:['uibPagination','?ngModel'],controller:'UibPaginationController',controllerAs:'pagination',templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||'uib/template/pagination/pagination.html';},replace:true,link:function link(scope,element,attrs,ctrls){var paginationCtrl=ctrls[0],ngModelCtrl=ctrls[1];if(!ngModelCtrl){return;// do nothing if no ng-model
	}paginationCtrl.init(ngModelCtrl,uibPaginationConfig);}};}]);/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */angular.module('ui.bootstrap.tooltip',['ui.bootstrap.position','ui.bootstrap.stackedMap'])/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */.provider('$uibTooltip',function(){// The default options tooltip and popover.
	var defaultOptions={placement:'top',placementClassPrefix:'',animation:true,popupDelay:0,popupCloseDelay:0,useContentExp:false};// Default hide triggers for each show trigger
	var triggerMap={'mouseenter':'mouseleave','click':'click','outsideClick':'outsideClick','focus':'blur','none':''};// The options specified to the provider globally.
	var globalOptions={};/**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */this.options=function(value){angular.extend(globalOptions,value);};/**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
	   */this.setTriggers=function setTriggers(triggers){angular.extend(triggerMap,triggers);};/**
	   * This is a helper function for translating camel-case to snake_case.
	   */function snake_case(name){var regexp=/[A-Z]/g;var separator='-';return name.replace(regexp,function(letter,pos){return(pos?separator:'')+letter.toLowerCase();});}/**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */this.$get=['$window','$compile','$timeout','$document','$uibPosition','$interpolate','$rootScope','$parse','$$stackedMap',function($window,$compile,$timeout,$document,$position,$interpolate,$rootScope,$parse,$$stackedMap){var openedTooltips=$$stackedMap.createNew();$document.on('keypress',keypressListener);$rootScope.$on('$destroy',function(){$document.off('keypress',keypressListener);});function keypressListener(e){if(e.which===27){var last=openedTooltips.top();if(last){last.value.close();openedTooltips.removeTop();last=null;}}}return function $tooltip(ttType,prefix,defaultTriggerShow,options){options=angular.extend({},defaultOptions,globalOptions,options);/**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */function getTriggers(trigger){var show=(trigger||options.trigger||defaultTriggerShow).split(' ');var hide=show.map(function(trigger){return triggerMap[trigger]||trigger;});return{show:show,hide:hide};}var directiveName=snake_case(ttType);var startSym=$interpolate.startSymbol();var endSym=$interpolate.endSymbol();var template='<div '+directiveName+'-popup '+'title="'+startSym+'title'+endSym+'" '+(options.useContentExp?'content-exp="contentExp()" ':'content="'+startSym+'content'+endSym+'" ')+'placement="'+startSym+'placement'+endSym+'" '+'popup-class="'+startSym+'popupClass'+endSym+'" '+'animation="animation" '+'is-open="isOpen"'+'origin-scope="origScope" '+'class="uib-position-measure"'+'>'+'</div>';return{compile:function compile(tElem,tAttrs){var tooltipLinker=$compile(template);return function link(scope,element,attrs,tooltipCtrl){var tooltip;var tooltipLinkedScope;var transitionTimeout;var showTimeout;var hideTimeout;var positionTimeout;var appendToBody=angular.isDefined(options.appendToBody)?options.appendToBody:false;var triggers=getTriggers(undefined);var hasEnableExp=angular.isDefined(attrs[prefix+'Enable']);var ttScope=scope.$new(true);var repositionScheduled=false;var isOpenParse=angular.isDefined(attrs[prefix+'IsOpen'])?$parse(attrs[prefix+'IsOpen']):false;var contentParse=options.useContentExp?$parse(attrs[ttType]):false;var observers=[];var lastPlacement;var positionTooltip=function positionTooltip(){// check if tooltip exists and is not empty
	if(!tooltip||!tooltip.html()){return;}if(!positionTimeout){positionTimeout=$timeout(function(){var ttPosition=$position.positionElements(element,tooltip,ttScope.placement,appendToBody);tooltip.css({top:ttPosition.top+'px',left:ttPosition.left+'px'});if(!tooltip.hasClass(ttPosition.placement.split('-')[0])){tooltip.removeClass(lastPlacement.split('-')[0]);tooltip.addClass(ttPosition.placement.split('-')[0]);}if(!tooltip.hasClass(options.placementClassPrefix+ttPosition.placement)){tooltip.removeClass(options.placementClassPrefix+lastPlacement);tooltip.addClass(options.placementClassPrefix+ttPosition.placement);}// first time through tt element will have the
	// uib-position-measure class or if the placement
	// has changed we need to position the arrow.
	if(tooltip.hasClass('uib-position-measure')){$position.positionArrow(tooltip,ttPosition.placement);tooltip.removeClass('uib-position-measure');}else if(lastPlacement!==ttPosition.placement){$position.positionArrow(tooltip,ttPosition.placement);}lastPlacement=ttPosition.placement;positionTimeout=null;},0,false);}};// Set up the correct scope to allow transclusion later
	ttScope.origScope=scope;// By default, the tooltip is not open.
	// TODO add ability to start tooltip opened
	ttScope.isOpen=false;openedTooltips.add(ttScope,{close:hide});function toggleTooltipBind(){if(!ttScope.isOpen){showTooltipBind();}else{hideTooltipBind();}}// Show the tooltip with delay if specified, otherwise show it immediately
	function showTooltipBind(){if(hasEnableExp&&!scope.$eval(attrs[prefix+'Enable'])){return;}cancelHide();prepareTooltip();if(ttScope.popupDelay){// Do nothing if the tooltip was already scheduled to pop-up.
	// This happens if show is triggered multiple times before any hide is triggered.
	if(!showTimeout){showTimeout=$timeout(show,ttScope.popupDelay,false);}}else{show();}}function hideTooltipBind(){cancelShow();if(ttScope.popupCloseDelay){if(!hideTimeout){hideTimeout=$timeout(hide,ttScope.popupCloseDelay,false);}}else{hide();}}// Show the tooltip popup element.
	function show(){cancelShow();cancelHide();// Don't show empty tooltips.
	if(!ttScope.content){return angular.noop;}createTooltip();// And show the tooltip.
	ttScope.$evalAsync(function(){ttScope.isOpen=true;assignIsOpen(true);positionTooltip();});}function cancelShow(){if(showTimeout){$timeout.cancel(showTimeout);showTimeout=null;}if(positionTimeout){$timeout.cancel(positionTimeout);positionTimeout=null;}}// Hide the tooltip popup element.
	function hide(){if(!ttScope){return;}// First things first: we don't show it anymore.
	ttScope.$evalAsync(function(){if(ttScope){ttScope.isOpen=false;assignIsOpen(false);// And now we remove it from the DOM. However, if we have animation, we
	// need to wait for it to expire beforehand.
	// FIXME: this is a placeholder for a port of the transitions library.
	// The fade transition in TWBS is 150ms.
	if(ttScope.animation){if(!transitionTimeout){transitionTimeout=$timeout(removeTooltip,150,false);}}else{removeTooltip();}}});}function cancelHide(){if(hideTimeout){$timeout.cancel(hideTimeout);hideTimeout=null;}if(transitionTimeout){$timeout.cancel(transitionTimeout);transitionTimeout=null;}}function createTooltip(){// There can only be one tooltip element per directive shown at once.
	if(tooltip){return;}tooltipLinkedScope=ttScope.$new();tooltip=tooltipLinker(tooltipLinkedScope,function(tooltip){if(appendToBody){$document.find('body').append(tooltip);}else{element.after(tooltip);}});prepObservers();}function removeTooltip(){cancelShow();cancelHide();unregisterObservers();if(tooltip){tooltip.remove();tooltip=null;}if(tooltipLinkedScope){tooltipLinkedScope.$destroy();tooltipLinkedScope=null;}}/**
	             * Set the initial scope values. Once
	             * the tooltip is created, the observers
	             * will be added to keep things in sync.
	             */function prepareTooltip(){ttScope.title=attrs[prefix+'Title'];if(contentParse){ttScope.content=contentParse(scope);}else{ttScope.content=attrs[ttType];}ttScope.popupClass=attrs[prefix+'Class'];ttScope.placement=angular.isDefined(attrs[prefix+'Placement'])?attrs[prefix+'Placement']:options.placement;var placement=$position.parsePlacement(ttScope.placement);lastPlacement=placement[1]?placement[0]+'-'+placement[1]:placement[0];var delay=parseInt(attrs[prefix+'PopupDelay'],10);var closeDelay=parseInt(attrs[prefix+'PopupCloseDelay'],10);ttScope.popupDelay=!isNaN(delay)?delay:options.popupDelay;ttScope.popupCloseDelay=!isNaN(closeDelay)?closeDelay:options.popupCloseDelay;}function assignIsOpen(isOpen){if(isOpenParse&&angular.isFunction(isOpenParse.assign)){isOpenParse.assign(scope,isOpen);}}ttScope.contentExp=function(){return ttScope.content;};/**
	             * Observe the relevant attributes.
	             */attrs.$observe('disabled',function(val){if(val){cancelShow();}if(val&&ttScope.isOpen){hide();}});if(isOpenParse){scope.$watch(isOpenParse,function(val){if(ttScope&&!val===ttScope.isOpen){toggleTooltipBind();}});}function prepObservers(){observers.length=0;if(contentParse){observers.push(scope.$watch(contentParse,function(val){ttScope.content=val;if(!val&&ttScope.isOpen){hide();}}));observers.push(tooltipLinkedScope.$watch(function(){if(!repositionScheduled){repositionScheduled=true;tooltipLinkedScope.$$postDigest(function(){repositionScheduled=false;if(ttScope&&ttScope.isOpen){positionTooltip();}});}}));}else{observers.push(attrs.$observe(ttType,function(val){ttScope.content=val;if(!val&&ttScope.isOpen){hide();}else{positionTooltip();}}));}observers.push(attrs.$observe(prefix+'Title',function(val){ttScope.title=val;if(ttScope.isOpen){positionTooltip();}}));observers.push(attrs.$observe(prefix+'Placement',function(val){ttScope.placement=val?val:options.placement;var placement=$position.parsePlacement(ttScope.placement);lastPlacement=placement[1]?placement[0]+'-'+placement[1]:placement[0];if(ttScope.isOpen){positionTooltip();}}));}function unregisterObservers(){if(observers.length){angular.forEach(observers,function(observer){observer();});observers.length=0;}}// hide tooltips/popovers for outsideClick trigger
	function bodyHideTooltipBind(e){if(!ttScope||!ttScope.isOpen||!tooltip){return;}// make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
	if(!element[0].contains(e.target)&&!tooltip[0].contains(e.target)){hideTooltipBind();}}var unregisterTriggers=function unregisterTriggers(){triggers.show.forEach(function(trigger){if(trigger==='outsideClick'){element.off('click',toggleTooltipBind);}else{element.off(trigger,showTooltipBind);element.off(trigger,toggleTooltipBind);}});triggers.hide.forEach(function(trigger){if(trigger==='outsideClick'){$document.off('click',bodyHideTooltipBind);}else{element.off(trigger,hideTooltipBind);}});};function prepTriggers(){var val=attrs[prefix+'Trigger'];unregisterTriggers();triggers=getTriggers(val);if(triggers.show!=='none'){triggers.show.forEach(function(trigger,idx){if(trigger==='outsideClick'){element.on('click',toggleTooltipBind);$document.on('click',bodyHideTooltipBind);}else if(trigger===triggers.hide[idx]){element.on(trigger,toggleTooltipBind);}else if(trigger){element.on(trigger,showTooltipBind);element.on(triggers.hide[idx],hideTooltipBind);}element.on('keypress',function(e){if(e.which===27){hideTooltipBind();}});});}}prepTriggers();var animation=scope.$eval(attrs[prefix+'Animation']);ttScope.animation=angular.isDefined(animation)?!!animation:options.animation;var appendToBodyVal;var appendKey=prefix+'AppendToBody';if(appendKey in attrs&&attrs[appendKey]===undefined){appendToBodyVal=true;}else{appendToBodyVal=scope.$eval(attrs[appendKey]);}appendToBody=angular.isDefined(appendToBodyVal)?appendToBodyVal:appendToBody;// Make sure tooltip is destroyed and removed.
	scope.$on('$destroy',function onDestroyTooltip(){unregisterTriggers();removeTooltip();openedTooltips.remove(ttScope);ttScope=null;});};}};};}];})// This is mostly ngInclude code but with a custom scope
	.directive('uibTooltipTemplateTransclude',['$animate','$sce','$compile','$templateRequest',function($animate,$sce,$compile,$templateRequest){return{link:function link(scope,elem,attrs){var origScope=scope.$eval(attrs.tooltipTemplateTranscludeScope);var changeCounter=0,currentScope,previousElement,currentElement;var cleanupLastIncludeContent=function cleanupLastIncludeContent(){if(previousElement){previousElement.remove();previousElement=null;}if(currentScope){currentScope.$destroy();currentScope=null;}if(currentElement){$animate.leave(currentElement).then(function(){previousElement=null;});previousElement=currentElement;currentElement=null;}};scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude),function(src){var thisChangeId=++changeCounter;if(src){//set the 2nd param to true to ignore the template request error so that the inner
	//contents and scope can be cleaned up.
	$templateRequest(src,true).then(function(response){if(thisChangeId!==changeCounter){return;}var newScope=origScope.$new();var template=response;var clone=$compile(template)(newScope,function(clone){cleanupLastIncludeContent();$animate.enter(clone,elem);});currentScope=newScope;currentElement=clone;currentScope.$emit('$includeContentLoaded',src);},function(){if(thisChangeId===changeCounter){cleanupLastIncludeContent();scope.$emit('$includeContentError',src);}});scope.$emit('$includeContentRequested',src);}else{cleanupLastIncludeContent();}});scope.$on('$destroy',cleanupLastIncludeContent);}};}])/**
	 * Note that it's intentional that these classes are *not* applied through $animate.
	 * They must not be animated as they're expected to be present on the tooltip on
	 * initialization.
	 */.directive('uibTooltipClasses',['$uibPosition',function($uibPosition){return{restrict:'A',link:function link(scope,element,attrs){// need to set the primary position so the
	// arrow has space during position measure.
	// tooltip.positionTooltip()
	if(scope.placement){// // There are no top-left etc... classes
	// // in TWBS, so we need the primary position.
	var position=$uibPosition.parsePlacement(scope.placement);element.addClass(position[0]);}if(scope.popupClass){element.addClass(scope.popupClass);}if(scope.animation()){element.addClass(attrs.tooltipAnimationClass);}}};}]).directive('uibTooltipPopup',function(){return{replace:true,scope:{content:'@',placement:'@',popupClass:'@',animation:'&',isOpen:'&'},templateUrl:'uib/template/tooltip/tooltip-popup.html'};}).directive('uibTooltip',['$uibTooltip',function($uibTooltip){return $uibTooltip('uibTooltip','tooltip','mouseenter');}]).directive('uibTooltipTemplatePopup',function(){return{replace:true,scope:{contentExp:'&',placement:'@',popupClass:'@',animation:'&',isOpen:'&',originScope:'&'},templateUrl:'uib/template/tooltip/tooltip-template-popup.html'};}).directive('uibTooltipTemplate',['$uibTooltip',function($uibTooltip){return $uibTooltip('uibTooltipTemplate','tooltip','mouseenter',{useContentExp:true});}]).directive('uibTooltipHtmlPopup',function(){return{replace:true,scope:{contentExp:'&',placement:'@',popupClass:'@',animation:'&',isOpen:'&'},templateUrl:'uib/template/tooltip/tooltip-html-popup.html'};}).directive('uibTooltipHtml',['$uibTooltip',function($uibTooltip){return $uibTooltip('uibTooltipHtml','tooltip','mouseenter',{useContentExp:true});}]);/**
	 * The following features are still outstanding: popup delay, animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, and selector delegatation.
	 */angular.module('ui.bootstrap.popover',['ui.bootstrap.tooltip']).directive('uibPopoverTemplatePopup',function(){return{replace:true,scope:{title:'@',contentExp:'&',placement:'@',popupClass:'@',animation:'&',isOpen:'&',originScope:'&'},templateUrl:'uib/template/popover/popover-template.html'};}).directive('uibPopoverTemplate',['$uibTooltip',function($uibTooltip){return $uibTooltip('uibPopoverTemplate','popover','click',{useContentExp:true});}]).directive('uibPopoverHtmlPopup',function(){return{replace:true,scope:{contentExp:'&',title:'@',placement:'@',popupClass:'@',animation:'&',isOpen:'&'},templateUrl:'uib/template/popover/popover-html.html'};}).directive('uibPopoverHtml',['$uibTooltip',function($uibTooltip){return $uibTooltip('uibPopoverHtml','popover','click',{useContentExp:true});}]).directive('uibPopoverPopup',function(){return{replace:true,scope:{title:'@',content:'@',placement:'@',popupClass:'@',animation:'&',isOpen:'&'},templateUrl:'uib/template/popover/popover.html'};}).directive('uibPopover',['$uibTooltip',function($uibTooltip){return $uibTooltip('uibPopover','popover','click');}]);angular.module('ui.bootstrap.progressbar',[]).constant('uibProgressConfig',{animate:true,max:100}).controller('UibProgressController',['$scope','$attrs','uibProgressConfig',function($scope,$attrs,progressConfig){var self=this,animate=angular.isDefined($attrs.animate)?$scope.$parent.$eval($attrs.animate):progressConfig.animate;this.bars=[];$scope.max=getMaxOrDefault();this.addBar=function(bar,element,attrs){if(!animate){element.css({'transition':'none'});}this.bars.push(bar);bar.max=getMaxOrDefault();bar.title=attrs&&angular.isDefined(attrs.title)?attrs.title:'progressbar';bar.$watch('value',function(value){bar.recalculatePercentage();});bar.recalculatePercentage=function(){var totalPercentage=self.bars.reduce(function(total,bar){bar.percent=+(100*bar.value/bar.max).toFixed(2);return total+bar.percent;},0);if(totalPercentage>100){bar.percent-=totalPercentage-100;}};bar.$on('$destroy',function(){element=null;self.removeBar(bar);});};this.removeBar=function(bar){this.bars.splice(this.bars.indexOf(bar),1);this.bars.forEach(function(bar){bar.recalculatePercentage();});};//$attrs.$observe('maxParam', function(maxParam) {
	$scope.$watch('maxParam',function(maxParam){self.bars.forEach(function(bar){bar.max=getMaxOrDefault();bar.recalculatePercentage();});});function getMaxOrDefault(){return angular.isDefined($scope.maxParam)?$scope.maxParam:progressConfig.max;}}]).directive('uibProgress',function(){return{replace:true,transclude:true,controller:'UibProgressController',require:'uibProgress',scope:{maxParam:'=?max'},templateUrl:'uib/template/progressbar/progress.html'};}).directive('uibBar',function(){return{replace:true,transclude:true,require:'^uibProgress',scope:{value:'=',type:'@'},templateUrl:'uib/template/progressbar/bar.html',link:function link(scope,element,attrs,progressCtrl){progressCtrl.addBar(scope,element,attrs);}};}).directive('uibProgressbar',function(){return{replace:true,transclude:true,controller:'UibProgressController',scope:{value:'=',maxParam:'=?max',type:'@'},templateUrl:'uib/template/progressbar/progressbar.html',link:function link(scope,element,attrs,progressCtrl){progressCtrl.addBar(scope,angular.element(element.children()[0]),{title:attrs.title});}};});angular.module('ui.bootstrap.rating',[]).constant('uibRatingConfig',{max:5,stateOn:null,stateOff:null,enableReset:true,titles:['one','two','three','four','five']}).controller('UibRatingController',['$scope','$attrs','uibRatingConfig',function($scope,$attrs,ratingConfig){var ngModelCtrl={$setViewValue:angular.noop},self=this;this.init=function(ngModelCtrl_){ngModelCtrl=ngModelCtrl_;ngModelCtrl.$render=this.render;ngModelCtrl.$formatters.push(function(value){if(angular.isNumber(value)&&value<<0!==value){value=Math.round(value);}return value;});this.stateOn=angular.isDefined($attrs.stateOn)?$scope.$parent.$eval($attrs.stateOn):ratingConfig.stateOn;this.stateOff=angular.isDefined($attrs.stateOff)?$scope.$parent.$eval($attrs.stateOff):ratingConfig.stateOff;this.enableReset=angular.isDefined($attrs.enableReset)?$scope.$parent.$eval($attrs.enableReset):ratingConfig.enableReset;var tmpTitles=angular.isDefined($attrs.titles)?$scope.$parent.$eval($attrs.titles):ratingConfig.titles;this.titles=angular.isArray(tmpTitles)&&tmpTitles.length>0?tmpTitles:ratingConfig.titles;var ratingStates=angular.isDefined($attrs.ratingStates)?$scope.$parent.$eval($attrs.ratingStates):new Array(angular.isDefined($attrs.max)?$scope.$parent.$eval($attrs.max):ratingConfig.max);$scope.range=this.buildTemplateObjects(ratingStates);};this.buildTemplateObjects=function(states){for(var i=0,n=states.length;i<n;i++){states[i]=angular.extend({index:i},{stateOn:this.stateOn,stateOff:this.stateOff,title:this.getTitle(i)},states[i]);}return states;};this.getTitle=function(index){if(index>=this.titles.length){return index+1;}return this.titles[index];};$scope.rate=function(value){if(!$scope.readonly&&value>=0&&value<=$scope.range.length){var newViewValue=self.enableReset&&ngModelCtrl.$viewValue===value?0:value;ngModelCtrl.$setViewValue(newViewValue);ngModelCtrl.$render();}};$scope.enter=function(value){if(!$scope.readonly){$scope.value=value;}$scope.onHover({value:value});};$scope.reset=function(){$scope.value=ngModelCtrl.$viewValue;$scope.onLeave();};$scope.onKeydown=function(evt){if(/(37|38|39|40)/.test(evt.which)){evt.preventDefault();evt.stopPropagation();$scope.rate($scope.value+(evt.which===38||evt.which===39?1:-1));}};this.render=function(){$scope.value=ngModelCtrl.$viewValue;$scope.title=self.getTitle($scope.value-1);};}]).directive('uibRating',function(){return{require:['uibRating','ngModel'],scope:{readonly:'=?readOnly',onHover:'&',onLeave:'&'},controller:'UibRatingController',templateUrl:'uib/template/rating/rating.html',replace:true,link:function link(scope,element,attrs,ctrls){var ratingCtrl=ctrls[0],ngModelCtrl=ctrls[1];ratingCtrl.init(ngModelCtrl);}};});angular.module('ui.bootstrap.tabs',[]).controller('UibTabsetController',['$scope',function($scope){var ctrl=this,oldIndex;ctrl.tabs=[];ctrl.select=function(index,evt){if(!destroyed){var previousIndex=findTabIndex(oldIndex);var previousSelected=ctrl.tabs[previousIndex];if(previousSelected){previousSelected.tab.onDeselect({$event:evt});previousSelected.tab.active=false;}var selected=ctrl.tabs[index];if(selected){selected.tab.onSelect({$event:evt});selected.tab.active=true;ctrl.active=selected.index;oldIndex=selected.index;}else if(!selected&&angular.isNumber(oldIndex)){ctrl.active=null;oldIndex=null;}}};ctrl.addTab=function addTab(tab){ctrl.tabs.push({tab:tab,index:tab.index});ctrl.tabs.sort(function(t1,t2){if(t1.index>t2.index){return 1;}if(t1.index<t2.index){return-1;}return 0;});if(tab.index===ctrl.active||!angular.isNumber(ctrl.active)&&ctrl.tabs.length===1){var newActiveIndex=findTabIndex(tab.index);ctrl.select(newActiveIndex);}};ctrl.removeTab=function removeTab(tab){var index=findTabIndex(tab.index);if(tab.index===ctrl.active){var newActiveTabIndex=index===ctrl.tabs.length-1?index-1:index+1%ctrl.tabs.length;ctrl.select(newActiveTabIndex);}ctrl.tabs.splice(index,1);};$scope.$watch('tabset.active',function(val){if(angular.isNumber(val)&&val!==oldIndex){ctrl.select(findTabIndex(val));}});var destroyed;$scope.$on('$destroy',function(){destroyed=true;});function findTabIndex(index){for(var i=0;i<ctrl.tabs.length;i++){if(ctrl.tabs[i].index===index){return i;}}}}]).directive('uibTabset',function(){return{transclude:true,replace:true,scope:{},bindToController:{active:'=?',type:'@'},controller:'UibTabsetController',controllerAs:'tabset',templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||'uib/template/tabs/tabset.html';},link:function link(scope,element,attrs){scope.vertical=angular.isDefined(attrs.vertical)?scope.$parent.$eval(attrs.vertical):false;scope.justified=angular.isDefined(attrs.justified)?scope.$parent.$eval(attrs.justified):false;if(angular.isUndefined(attrs.active)){scope.active=0;}}};}).directive('uibTab',['$parse',function($parse){return{require:'^uibTabset',replace:true,templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||'uib/template/tabs/tab.html';},transclude:true,scope:{heading:'@',index:'=?',classes:'@?',onSelect:'&select',//This callback is called in contentHeadingTransclude
	//once it inserts the tab's content into the dom
	onDeselect:'&deselect'},controller:function controller(){//Empty controller so other directives can require being 'under' a tab
	},controllerAs:'tab',link:function link(scope,elm,attrs,tabsetCtrl,transclude){scope.disabled=false;if(attrs.disable){scope.$parent.$watch($parse(attrs.disable),function(value){scope.disabled=!!value;});}if(angular.isUndefined(attrs.index)){if(tabsetCtrl.tabs&&tabsetCtrl.tabs.length){scope.index=Math.max.apply(null,tabsetCtrl.tabs.map(function(t){return t.index;}))+1;}else{scope.index=0;}}if(angular.isUndefined(attrs.classes)){scope.classes='';}scope.select=function(evt){if(!scope.disabled){var index;for(var i=0;i<tabsetCtrl.tabs.length;i++){if(tabsetCtrl.tabs[i].tab===scope){index=i;break;}}tabsetCtrl.select(index,evt);}};tabsetCtrl.addTab(scope);scope.$on('$destroy',function(){tabsetCtrl.removeTab(scope);});//We need to transclude later, once the content container is ready.
	//when this link happens, we're inside a tab heading.
	scope.$transcludeFn=transclude;}};}]).directive('uibTabHeadingTransclude',function(){return{restrict:'A',require:'^uibTab',link:function link(scope,elm){scope.$watch('headingElement',function updateHeadingElement(heading){if(heading){elm.html('');elm.append(heading);}});}};}).directive('uibTabContentTransclude',function(){return{restrict:'A',require:'^uibTabset',link:function link(scope,elm,attrs){var tab=scope.$eval(attrs.uibTabContentTransclude).tab;//Now our tab is ready to be transcluded: both the tab heading area
	//and the tab content area are loaded.  Transclude 'em both.
	tab.$transcludeFn(tab.$parent,function(contents){angular.forEach(contents,function(node){if(isTabHeading(node)){//Let tabHeadingTransclude know.
	tab.headingElement=node;}else{elm.append(node);}});});}};function isTabHeading(node){return node.tagName&&(node.hasAttribute('uib-tab-heading')||node.hasAttribute('data-uib-tab-heading')||node.hasAttribute('x-uib-tab-heading')||node.tagName.toLowerCase()==='uib-tab-heading'||node.tagName.toLowerCase()==='data-uib-tab-heading'||node.tagName.toLowerCase()==='x-uib-tab-heading'||node.tagName.toLowerCase()==='uib:tab-heading');}});angular.module('ui.bootstrap.timepicker',[]).constant('uibTimepickerConfig',{hourStep:1,minuteStep:1,secondStep:1,showMeridian:true,showSeconds:false,meridians:null,readonlyInput:false,mousewheel:true,arrowkeys:true,showSpinners:true,templateUrl:'uib/template/timepicker/timepicker.html'}).controller('UibTimepickerController',['$scope','$element','$attrs','$parse','$log','$locale','uibTimepickerConfig',function($scope,$element,$attrs,$parse,$log,$locale,timepickerConfig){var selected=new Date(),watchers=[],ngModelCtrl={$setViewValue:angular.noop},// nullModelCtrl
	meridians=angular.isDefined($attrs.meridians)?$scope.$parent.$eval($attrs.meridians):timepickerConfig.meridians||$locale.DATETIME_FORMATS.AMPMS,padHours=angular.isDefined($attrs.padHours)?$scope.$parent.$eval($attrs.padHours):true;$scope.tabindex=angular.isDefined($attrs.tabindex)?$attrs.tabindex:0;$element.removeAttr('tabindex');this.init=function(ngModelCtrl_,inputs){ngModelCtrl=ngModelCtrl_;ngModelCtrl.$render=this.render;ngModelCtrl.$formatters.unshift(function(modelValue){return modelValue?new Date(modelValue):null;});var hoursInputEl=inputs.eq(0),minutesInputEl=inputs.eq(1),secondsInputEl=inputs.eq(2);var mousewheel=angular.isDefined($attrs.mousewheel)?$scope.$parent.$eval($attrs.mousewheel):timepickerConfig.mousewheel;if(mousewheel){this.setupMousewheelEvents(hoursInputEl,minutesInputEl,secondsInputEl);}var arrowkeys=angular.isDefined($attrs.arrowkeys)?$scope.$parent.$eval($attrs.arrowkeys):timepickerConfig.arrowkeys;if(arrowkeys){this.setupArrowkeyEvents(hoursInputEl,minutesInputEl,secondsInputEl);}$scope.readonlyInput=angular.isDefined($attrs.readonlyInput)?$scope.$parent.$eval($attrs.readonlyInput):timepickerConfig.readonlyInput;this.setupInputEvents(hoursInputEl,minutesInputEl,secondsInputEl);};var hourStep=timepickerConfig.hourStep;if($attrs.hourStep){watchers.push($scope.$parent.$watch($parse($attrs.hourStep),function(value){hourStep=+value;}));}var minuteStep=timepickerConfig.minuteStep;if($attrs.minuteStep){watchers.push($scope.$parent.$watch($parse($attrs.minuteStep),function(value){minuteStep=+value;}));}var min;watchers.push($scope.$parent.$watch($parse($attrs.min),function(value){var dt=new Date(value);min=isNaN(dt)?undefined:dt;}));var max;watchers.push($scope.$parent.$watch($parse($attrs.max),function(value){var dt=new Date(value);max=isNaN(dt)?undefined:dt;}));var disabled=false;if($attrs.ngDisabled){watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled),function(value){disabled=value;}));}$scope.noIncrementHours=function(){var incrementedSelected=addMinutes(selected,hourStep*60);return disabled||incrementedSelected>max||incrementedSelected<selected&&incrementedSelected<min;};$scope.noDecrementHours=function(){var decrementedSelected=addMinutes(selected,-hourStep*60);return disabled||decrementedSelected<min||decrementedSelected>selected&&decrementedSelected>max;};$scope.noIncrementMinutes=function(){var incrementedSelected=addMinutes(selected,minuteStep);return disabled||incrementedSelected>max||incrementedSelected<selected&&incrementedSelected<min;};$scope.noDecrementMinutes=function(){var decrementedSelected=addMinutes(selected,-minuteStep);return disabled||decrementedSelected<min||decrementedSelected>selected&&decrementedSelected>max;};$scope.noIncrementSeconds=function(){var incrementedSelected=addSeconds(selected,secondStep);return disabled||incrementedSelected>max||incrementedSelected<selected&&incrementedSelected<min;};$scope.noDecrementSeconds=function(){var decrementedSelected=addSeconds(selected,-secondStep);return disabled||decrementedSelected<min||decrementedSelected>selected&&decrementedSelected>max;};$scope.noToggleMeridian=function(){if(selected.getHours()<12){return disabled||addMinutes(selected,12*60)>max;}return disabled||addMinutes(selected,-12*60)<min;};var secondStep=timepickerConfig.secondStep;if($attrs.secondStep){watchers.push($scope.$parent.$watch($parse($attrs.secondStep),function(value){secondStep=+value;}));}$scope.showSeconds=timepickerConfig.showSeconds;if($attrs.showSeconds){watchers.push($scope.$parent.$watch($parse($attrs.showSeconds),function(value){$scope.showSeconds=!!value;}));}// 12H / 24H mode
	$scope.showMeridian=timepickerConfig.showMeridian;if($attrs.showMeridian){watchers.push($scope.$parent.$watch($parse($attrs.showMeridian),function(value){$scope.showMeridian=!!value;if(ngModelCtrl.$error.time){// Evaluate from template
	var hours=getHoursFromTemplate(),minutes=getMinutesFromTemplate();if(angular.isDefined(hours)&&angular.isDefined(minutes)){selected.setHours(hours);refresh();}}else{updateTemplate();}}));}// Get $scope.hours in 24H mode if valid
	function getHoursFromTemplate(){var hours=+$scope.hours;var valid=$scope.showMeridian?hours>0&&hours<13:hours>=0&&hours<24;if(!valid){return undefined;}if($scope.showMeridian){if(hours===12){hours=0;}if($scope.meridian===meridians[1]){hours=hours+12;}}return hours;}function getMinutesFromTemplate(){var minutes=+$scope.minutes;return minutes>=0&&minutes<60?minutes:undefined;}function getSecondsFromTemplate(){var seconds=+$scope.seconds;return seconds>=0&&seconds<60?seconds:undefined;}function pad(value,noPad){if(value===null){return'';}return angular.isDefined(value)&&value.toString().length<2&&!noPad?'0'+value:value.toString();}// Respond on mousewheel spin
	this.setupMousewheelEvents=function(hoursInputEl,minutesInputEl,secondsInputEl){var isScrollingUp=function isScrollingUp(e){if(e.originalEvent){e=e.originalEvent;}//pick correct delta variable depending on event
	var delta=e.wheelDelta?e.wheelDelta:-e.deltaY;return e.detail||delta>0;};hoursInputEl.bind('mousewheel wheel',function(e){if(!disabled){$scope.$apply(isScrollingUp(e)?$scope.incrementHours():$scope.decrementHours());}e.preventDefault();});minutesInputEl.bind('mousewheel wheel',function(e){if(!disabled){$scope.$apply(isScrollingUp(e)?$scope.incrementMinutes():$scope.decrementMinutes());}e.preventDefault();});secondsInputEl.bind('mousewheel wheel',function(e){if(!disabled){$scope.$apply(isScrollingUp(e)?$scope.incrementSeconds():$scope.decrementSeconds());}e.preventDefault();});};// Respond on up/down arrowkeys
	this.setupArrowkeyEvents=function(hoursInputEl,minutesInputEl,secondsInputEl){hoursInputEl.bind('keydown',function(e){if(!disabled){if(e.which===38){// up
	e.preventDefault();$scope.incrementHours();$scope.$apply();}else if(e.which===40){// down
	e.preventDefault();$scope.decrementHours();$scope.$apply();}}});minutesInputEl.bind('keydown',function(e){if(!disabled){if(e.which===38){// up
	e.preventDefault();$scope.incrementMinutes();$scope.$apply();}else if(e.which===40){// down
	e.preventDefault();$scope.decrementMinutes();$scope.$apply();}}});secondsInputEl.bind('keydown',function(e){if(!disabled){if(e.which===38){// up
	e.preventDefault();$scope.incrementSeconds();$scope.$apply();}else if(e.which===40){// down
	e.preventDefault();$scope.decrementSeconds();$scope.$apply();}}});};this.setupInputEvents=function(hoursInputEl,minutesInputEl,secondsInputEl){if($scope.readonlyInput){$scope.updateHours=angular.noop;$scope.updateMinutes=angular.noop;$scope.updateSeconds=angular.noop;return;}var invalidate=function invalidate(invalidHours,invalidMinutes,invalidSeconds){ngModelCtrl.$setViewValue(null);ngModelCtrl.$setValidity('time',false);if(angular.isDefined(invalidHours)){$scope.invalidHours=invalidHours;}if(angular.isDefined(invalidMinutes)){$scope.invalidMinutes=invalidMinutes;}if(angular.isDefined(invalidSeconds)){$scope.invalidSeconds=invalidSeconds;}};$scope.updateHours=function(){var hours=getHoursFromTemplate(),minutes=getMinutesFromTemplate();ngModelCtrl.$setDirty();if(angular.isDefined(hours)&&angular.isDefined(minutes)){selected.setHours(hours);selected.setMinutes(minutes);if(selected<min||selected>max){invalidate(true);}else{refresh('h');}}else{invalidate(true);}};hoursInputEl.bind('blur',function(e){ngModelCtrl.$setTouched();if($scope.hours===null||$scope.hours===''){invalidate(true);}else if(!$scope.invalidHours&&$scope.hours<10){$scope.$apply(function(){$scope.hours=pad($scope.hours,!padHours);});}});$scope.updateMinutes=function(){var minutes=getMinutesFromTemplate(),hours=getHoursFromTemplate();ngModelCtrl.$setDirty();if(angular.isDefined(minutes)&&angular.isDefined(hours)){selected.setHours(hours);selected.setMinutes(minutes);if(selected<min||selected>max){invalidate(undefined,true);}else{refresh('m');}}else{invalidate(undefined,true);}};minutesInputEl.bind('blur',function(e){ngModelCtrl.$setTouched();if($scope.minutes===null){invalidate(undefined,true);}else if(!$scope.invalidMinutes&&$scope.minutes<10){$scope.$apply(function(){$scope.minutes=pad($scope.minutes);});}});$scope.updateSeconds=function(){var seconds=getSecondsFromTemplate();ngModelCtrl.$setDirty();if(angular.isDefined(seconds)){selected.setSeconds(seconds);refresh('s');}else{invalidate(undefined,undefined,true);}};secondsInputEl.bind('blur',function(e){if(!$scope.invalidSeconds&&$scope.seconds<10){$scope.$apply(function(){$scope.seconds=pad($scope.seconds);});}});};this.render=function(){var date=ngModelCtrl.$viewValue;if(isNaN(date)){ngModelCtrl.$setValidity('time',false);$log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');}else{if(date){selected=date;}if(selected<min||selected>max){ngModelCtrl.$setValidity('time',false);$scope.invalidHours=true;$scope.invalidMinutes=true;}else{makeValid();}updateTemplate();}};// Call internally when we know that model is valid.
	function refresh(keyboardChange){makeValid();ngModelCtrl.$setViewValue(new Date(selected));updateTemplate(keyboardChange);}function makeValid(){ngModelCtrl.$setValidity('time',true);$scope.invalidHours=false;$scope.invalidMinutes=false;$scope.invalidSeconds=false;}function updateTemplate(keyboardChange){if(!ngModelCtrl.$modelValue){$scope.hours=null;$scope.minutes=null;$scope.seconds=null;$scope.meridian=meridians[0];}else{var hours=selected.getHours(),minutes=selected.getMinutes(),seconds=selected.getSeconds();if($scope.showMeridian){hours=hours===0||hours===12?12:hours%12;// Convert 24 to 12 hour system
	}$scope.hours=keyboardChange==='h'?hours:pad(hours,!padHours);if(keyboardChange!=='m'){$scope.minutes=pad(minutes);}$scope.meridian=selected.getHours()<12?meridians[0]:meridians[1];if(keyboardChange!=='s'){$scope.seconds=pad(seconds);}$scope.meridian=selected.getHours()<12?meridians[0]:meridians[1];}}function addSecondsToSelected(seconds){selected=addSeconds(selected,seconds);refresh();}function addMinutes(selected,minutes){return addSeconds(selected,minutes*60);}function addSeconds(date,seconds){var dt=new Date(date.getTime()+seconds*1000);var newDate=new Date(date);newDate.setHours(dt.getHours(),dt.getMinutes(),dt.getSeconds());return newDate;}$scope.showSpinners=angular.isDefined($attrs.showSpinners)?$scope.$parent.$eval($attrs.showSpinners):timepickerConfig.showSpinners;$scope.incrementHours=function(){if(!$scope.noIncrementHours()){addSecondsToSelected(hourStep*60*60);}};$scope.decrementHours=function(){if(!$scope.noDecrementHours()){addSecondsToSelected(-hourStep*60*60);}};$scope.incrementMinutes=function(){if(!$scope.noIncrementMinutes()){addSecondsToSelected(minuteStep*60);}};$scope.decrementMinutes=function(){if(!$scope.noDecrementMinutes()){addSecondsToSelected(-minuteStep*60);}};$scope.incrementSeconds=function(){if(!$scope.noIncrementSeconds()){addSecondsToSelected(secondStep);}};$scope.decrementSeconds=function(){if(!$scope.noDecrementSeconds()){addSecondsToSelected(-secondStep);}};$scope.toggleMeridian=function(){var minutes=getMinutesFromTemplate(),hours=getHoursFromTemplate();if(!$scope.noToggleMeridian()){if(angular.isDefined(minutes)&&angular.isDefined(hours)){addSecondsToSelected(12*60*(selected.getHours()<12?60:-60));}else{$scope.meridian=$scope.meridian===meridians[0]?meridians[1]:meridians[0];}}};$scope.blur=function(){ngModelCtrl.$setTouched();};$scope.$on('$destroy',function(){while(watchers.length){watchers.shift()();}});}]).directive('uibTimepicker',['uibTimepickerConfig',function(uibTimepickerConfig){return{require:['uibTimepicker','?^ngModel'],controller:'UibTimepickerController',controllerAs:'timepicker',replace:true,scope:{},templateUrl:function templateUrl(element,attrs){return attrs.templateUrl||uibTimepickerConfig.templateUrl;},link:function link(scope,element,attrs,ctrls){var timepickerCtrl=ctrls[0],ngModelCtrl=ctrls[1];if(ngModelCtrl){timepickerCtrl.init(ngModelCtrl,element.find('input'));}}};}]);angular.module('ui.bootstrap.typeahead',['ui.bootstrap.debounce','ui.bootstrap.position'])/**
	 * A helper service that can parse typeahead's syntax (string provided by users)
	 * Extracted to a separate service for ease of unit testing
	 */.factory('uibTypeaheadParser',['$parse',function($parse){//                      00000111000000000000022200000000000000003333333333333330000000000044000
	var TYPEAHEAD_REGEXP=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;return{parse:function parse(input){var match=input.match(TYPEAHEAD_REGEXP);if(!match){throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"'+' but got "'+input+'".');}return{itemName:match[3],source:$parse(match[4]),viewMapper:$parse(match[2]||match[1]),modelMapper:$parse(match[1])};}};}]).controller('UibTypeaheadController',['$scope','$element','$attrs','$compile','$parse','$q','$timeout','$document','$window','$rootScope','$$debounce','$uibPosition','uibTypeaheadParser',function(originalScope,element,attrs,$compile,$parse,$q,$timeout,$document,$window,$rootScope,$$debounce,$position,typeaheadParser){var HOT_KEYS=[9,13,27,38,40];var eventDebounceTime=200;var modelCtrl,ngModelOptions;//SUPPORTED ATTRIBUTES (OPTIONS)
	//minimal no of characters that needs to be entered before typeahead kicks-in
	var minLength=originalScope.$eval(attrs.typeaheadMinLength);if(!minLength&&minLength!==0){minLength=1;}originalScope.$watch(attrs.typeaheadMinLength,function(newVal){minLength=!newVal&&newVal!==0?1:newVal;});//minimal wait time after last character typed before typeahead kicks-in
	var waitTime=originalScope.$eval(attrs.typeaheadWaitMs)||0;//should it restrict model values to the ones selected from the popup only?
	var isEditable=originalScope.$eval(attrs.typeaheadEditable)!==false;originalScope.$watch(attrs.typeaheadEditable,function(newVal){isEditable=newVal!==false;});//binding to a variable that indicates if matches are being retrieved asynchronously
	var isLoadingSetter=$parse(attrs.typeaheadLoading).assign||angular.noop;//a callback executed when a match is selected
	var onSelectCallback=$parse(attrs.typeaheadOnSelect);//should it select highlighted popup value when losing focus?
	var isSelectOnBlur=angular.isDefined(attrs.typeaheadSelectOnBlur)?originalScope.$eval(attrs.typeaheadSelectOnBlur):false;//binding to a variable that indicates if there were no results after the query is completed
	var isNoResultsSetter=$parse(attrs.typeaheadNoResults).assign||angular.noop;var inputFormatter=attrs.typeaheadInputFormatter?$parse(attrs.typeaheadInputFormatter):undefined;var appendToBody=attrs.typeaheadAppendToBody?originalScope.$eval(attrs.typeaheadAppendToBody):false;var appendTo=attrs.typeaheadAppendTo?originalScope.$eval(attrs.typeaheadAppendTo):null;var focusFirst=originalScope.$eval(attrs.typeaheadFocusFirst)!==false;//If input matches an item of the list exactly, select it automatically
	var selectOnExact=attrs.typeaheadSelectOnExact?originalScope.$eval(attrs.typeaheadSelectOnExact):false;//binding to a variable that indicates if dropdown is open
	var isOpenSetter=$parse(attrs.typeaheadIsOpen).assign||angular.noop;var showHint=originalScope.$eval(attrs.typeaheadShowHint)||false;//INTERNAL VARIABLES
	//model setter executed upon match selection
	var parsedModel=$parse(attrs.ngModel);var invokeModelSetter=$parse(attrs.ngModel+'($$$p)');var $setModelValue=function $setModelValue(scope,newValue){if(angular.isFunction(parsedModel(originalScope))&&ngModelOptions&&ngModelOptions.$options&&ngModelOptions.$options.getterSetter){return invokeModelSetter(scope,{$$$p:newValue});}return parsedModel.assign(scope,newValue);};//expressions used by typeahead
	var parserResult=typeaheadParser.parse(attrs.uibTypeahead);var hasFocus;//Used to avoid bug in iOS webview where iOS keyboard does not fire
	//mousedown & mouseup events
	//Issue #3699
	var selected;//create a child scope for the typeahead directive so we are not polluting original scope
	//with typeahead-specific data (matches, query etc.)
	var scope=originalScope.$new();var offDestroy=originalScope.$on('$destroy',function(){scope.$destroy();});scope.$on('$destroy',offDestroy);// WAI-ARIA
	var popupId='typeahead-'+scope.$id+'-'+Math.floor(Math.random()*10000);element.attr({'aria-autocomplete':'list','aria-expanded':false,'aria-owns':popupId});var inputsContainer,hintInputElem;//add read-only input to show hint
	if(showHint){inputsContainer=angular.element('<div></div>');inputsContainer.css('position','relative');element.after(inputsContainer);hintInputElem=element.clone();hintInputElem.attr('placeholder','');hintInputElem.attr('tabindex','-1');hintInputElem.val('');hintInputElem.css({'position':'absolute','top':'0px','left':'0px','border-color':'transparent','box-shadow':'none','opacity':1,'background':'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)','color':'#999'});element.css({'position':'relative','vertical-align':'top','background-color':'transparent'});inputsContainer.append(hintInputElem);hintInputElem.after(element);}//pop-up element used to display matches
	var popUpEl=angular.element('<div uib-typeahead-popup></div>');popUpEl.attr({id:popupId,matches:'matches',active:'activeIdx',select:'select(activeIdx, evt)','move-in-progress':'moveInProgress',query:'query',position:'position','assign-is-open':'assignIsOpen(isOpen)',debounce:'debounceUpdate'});//custom item template
	if(angular.isDefined(attrs.typeaheadTemplateUrl)){popUpEl.attr('template-url',attrs.typeaheadTemplateUrl);}if(angular.isDefined(attrs.typeaheadPopupTemplateUrl)){popUpEl.attr('popup-template-url',attrs.typeaheadPopupTemplateUrl);}var resetHint=function resetHint(){if(showHint){hintInputElem.val('');}};var resetMatches=function resetMatches(){scope.matches=[];scope.activeIdx=-1;element.attr('aria-expanded',false);resetHint();};var getMatchId=function getMatchId(index){return popupId+'-option-'+index;};// Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
	// This attribute is added or removed automatically when the `activeIdx` changes.
	scope.$watch('activeIdx',function(index){if(index<0){element.removeAttr('aria-activedescendant');}else{element.attr('aria-activedescendant',getMatchId(index));}});var inputIsExactMatch=function inputIsExactMatch(inputValue,index){if(scope.matches.length>index&&inputValue){return inputValue.toUpperCase()===scope.matches[index].label.toUpperCase();}return false;};var getMatchesAsync=function getMatchesAsync(inputValue,evt){var locals={$viewValue:inputValue};isLoadingSetter(originalScope,true);isNoResultsSetter(originalScope,false);$q.when(parserResult.source(originalScope,locals)).then(function(matches){//it might happen that several async queries were in progress if a user were typing fast
	//but we are interested only in responses that correspond to the current view value
	var onCurrentRequest=inputValue===modelCtrl.$viewValue;if(onCurrentRequest&&hasFocus){if(matches&&matches.length>0){scope.activeIdx=focusFirst?0:-1;isNoResultsSetter(originalScope,false);scope.matches.length=0;//transform labels
	for(var i=0;i<matches.length;i++){locals[parserResult.itemName]=matches[i];scope.matches.push({id:getMatchId(i),label:parserResult.viewMapper(scope,locals),model:matches[i]});}scope.query=inputValue;//position pop-up with matches - we need to re-calculate its position each time we are opening a window
	//with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
	//due to other elements being rendered
	recalculatePosition();element.attr('aria-expanded',true);//Select the single remaining option if user input matches
	if(selectOnExact&&scope.matches.length===1&&inputIsExactMatch(inputValue,0)){if(angular.isNumber(scope.debounceUpdate)||angular.isObject(scope.debounceUpdate)){$$debounce(function(){scope.select(0,evt);},angular.isNumber(scope.debounceUpdate)?scope.debounceUpdate:scope.debounceUpdate['default']);}else{scope.select(0,evt);}}if(showHint){var firstLabel=scope.matches[0].label;if(angular.isString(inputValue)&&inputValue.length>0&&firstLabel.slice(0,inputValue.length).toUpperCase()===inputValue.toUpperCase()){hintInputElem.val(inputValue+firstLabel.slice(inputValue.length));}else{hintInputElem.val('');}}}else{resetMatches();isNoResultsSetter(originalScope,true);}}if(onCurrentRequest){isLoadingSetter(originalScope,false);}},function(){resetMatches();isLoadingSetter(originalScope,false);isNoResultsSetter(originalScope,true);});};// bind events only if appendToBody params exist - performance feature
	if(appendToBody){angular.element($window).on('resize',fireRecalculating);$document.find('body').on('scroll',fireRecalculating);}// Declare the debounced function outside recalculating for
	// proper debouncing
	var debouncedRecalculate=$$debounce(function(){// if popup is visible
	if(scope.matches.length){recalculatePosition();}scope.moveInProgress=false;},eventDebounceTime);// Default progress type
	scope.moveInProgress=false;function fireRecalculating(){if(!scope.moveInProgress){scope.moveInProgress=true;scope.$digest();}debouncedRecalculate();}// recalculate actual position and set new values to scope
	// after digest loop is popup in right position
	function recalculatePosition(){scope.position=appendToBody?$position.offset(element):$position.position(element);scope.position.top+=element.prop('offsetHeight');}//we need to propagate user's query so we can higlight matches
	scope.query=undefined;//Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	var timeoutPromise;var scheduleSearchWithTimeout=function scheduleSearchWithTimeout(inputValue){timeoutPromise=$timeout(function(){getMatchesAsync(inputValue);},waitTime);};var cancelPreviousTimeout=function cancelPreviousTimeout(){if(timeoutPromise){$timeout.cancel(timeoutPromise);}};resetMatches();scope.assignIsOpen=function(isOpen){isOpenSetter(originalScope,isOpen);};scope.select=function(activeIdx,evt){//called from within the $digest() cycle
	var locals={};var model,item;selected=true;locals[parserResult.itemName]=item=scope.matches[activeIdx].model;model=parserResult.modelMapper(originalScope,locals);$setModelValue(originalScope,model);modelCtrl.$setValidity('editable',true);modelCtrl.$setValidity('parse',true);onSelectCallback(originalScope,{$item:item,$model:model,$label:parserResult.viewMapper(originalScope,locals),$event:evt});resetMatches();//return focus to the input element if a match was selected via a mouse click event
	// use timeout to avoid $rootScope:inprog error
	if(scope.$eval(attrs.typeaheadFocusOnSelect)!==false){$timeout(function(){element[0].focus();},0,false);}};//bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
	element.on('keydown',function(evt){//typeahead is open and an "interesting" key was pressed
	if(scope.matches.length===0||HOT_KEYS.indexOf(evt.which)===-1){return;}/**
	       * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
	       * or
	       * shift + tab is pressed to bring focus to the previous element
	       * then clear the results
	       */if(scope.activeIdx===-1&&(evt.which===9||evt.which===13)||evt.which===9&&!!evt.shiftKey){resetMatches();scope.$digest();return;}evt.preventDefault();var target;switch(evt.which){case 9:case 13:scope.$apply(function(){if(angular.isNumber(scope.debounceUpdate)||angular.isObject(scope.debounceUpdate)){$$debounce(function(){scope.select(scope.activeIdx,evt);},angular.isNumber(scope.debounceUpdate)?scope.debounceUpdate:scope.debounceUpdate['default']);}else{scope.select(scope.activeIdx,evt);}});break;case 27:evt.stopPropagation();resetMatches();originalScope.$digest();break;case 38:scope.activeIdx=(scope.activeIdx>0?scope.activeIdx:scope.matches.length)-1;scope.$digest();target=popUpEl.find('li')[scope.activeIdx];target.parentNode.scrollTop=target.offsetTop;break;case 40:scope.activeIdx=(scope.activeIdx+1)%scope.matches.length;scope.$digest();target=popUpEl.find('li')[scope.activeIdx];target.parentNode.scrollTop=target.offsetTop;break;}});element.bind('focus',function(evt){hasFocus=true;if(minLength===0&&!modelCtrl.$viewValue){$timeout(function(){getMatchesAsync(modelCtrl.$viewValue,evt);},0);}});element.bind('blur',function(evt){if(isSelectOnBlur&&scope.matches.length&&scope.activeIdx!==-1&&!selected){selected=true;scope.$apply(function(){if(angular.isObject(scope.debounceUpdate)&&angular.isNumber(scope.debounceUpdate.blur)){$$debounce(function(){scope.select(scope.activeIdx,evt);},scope.debounceUpdate.blur);}else{scope.select(scope.activeIdx,evt);}});}if(!isEditable&&modelCtrl.$error.editable){modelCtrl.$viewValue='';// Reset validity as we are clearing
	modelCtrl.$setValidity('editable',true);modelCtrl.$setValidity('parse',true);element.val('');}hasFocus=false;selected=false;});// Keep reference to click handler to unbind it.
	var dismissClickHandler=function dismissClickHandler(evt){// Issue #3973
	// Firefox treats right click as a click on document
	if(element[0]!==evt.target&&evt.which!==3&&scope.matches.length!==0){resetMatches();if(!$rootScope.$$phase){originalScope.$digest();}}};$document.on('click',dismissClickHandler);originalScope.$on('$destroy',function(){$document.off('click',dismissClickHandler);if(appendToBody||appendTo){$popup.remove();}if(appendToBody){angular.element($window).off('resize',fireRecalculating);$document.find('body').off('scroll',fireRecalculating);}// Prevent jQuery cache memory leak
	popUpEl.remove();if(showHint){inputsContainer.remove();}});var $popup=$compile(popUpEl)(scope);if(appendToBody){$document.find('body').append($popup);}else if(appendTo){angular.element(appendTo).eq(0).append($popup);}else{element.after($popup);}this.init=function(_modelCtrl,_ngModelOptions){modelCtrl=_modelCtrl;ngModelOptions=_ngModelOptions;scope.debounceUpdate=modelCtrl.$options&&$parse(modelCtrl.$options.debounce)(originalScope);//plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
	//$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
	modelCtrl.$parsers.unshift(function(inputValue){hasFocus=true;if(minLength===0||inputValue&&inputValue.length>=minLength){if(waitTime>0){cancelPreviousTimeout();scheduleSearchWithTimeout(inputValue);}else{getMatchesAsync(inputValue);}}else{isLoadingSetter(originalScope,false);cancelPreviousTimeout();resetMatches();}if(isEditable){return inputValue;}if(!inputValue){// Reset in case user had typed something previously.
	modelCtrl.$setValidity('editable',true);return null;}modelCtrl.$setValidity('editable',false);return undefined;});modelCtrl.$formatters.push(function(modelValue){var candidateViewValue,emptyViewValue;var locals={};// The validity may be set to false via $parsers (see above) if
	// the model is restricted to selected values. If the model
	// is set manually it is considered to be valid.
	if(!isEditable){modelCtrl.$setValidity('editable',true);}if(inputFormatter){locals.$model=modelValue;return inputFormatter(originalScope,locals);}//it might happen that we don't have enough info to properly render input value
	//we need to check for this situation and simply return model value if we can't apply custom formatting
	locals[parserResult.itemName]=modelValue;candidateViewValue=parserResult.viewMapper(originalScope,locals);locals[parserResult.itemName]=undefined;emptyViewValue=parserResult.viewMapper(originalScope,locals);return candidateViewValue!==emptyViewValue?candidateViewValue:modelValue;});};}]).directive('uibTypeahead',function(){return{controller:'UibTypeaheadController',require:['ngModel','^?ngModelOptions','uibTypeahead'],link:function link(originalScope,element,attrs,ctrls){ctrls[2].init(ctrls[0],ctrls[1]);}};}).directive('uibTypeaheadPopup',['$$debounce',function($$debounce){return{scope:{matches:'=',query:'=',active:'=',position:'&',moveInProgress:'=',select:'&',assignIsOpen:'&',debounce:'&'},replace:true,templateUrl:function templateUrl(element,attrs){return attrs.popupTemplateUrl||'uib/template/typeahead/typeahead-popup.html';},link:function link(scope,element,attrs){scope.templateUrl=attrs.templateUrl;scope.isOpen=function(){var isDropdownOpen=scope.matches.length>0;scope.assignIsOpen({isOpen:isDropdownOpen});return isDropdownOpen;};scope.isActive=function(matchIdx){return scope.active===matchIdx;};scope.selectActive=function(matchIdx){scope.active=matchIdx;};scope.selectMatch=function(activeIdx,evt){var debounce=scope.debounce();if(angular.isNumber(debounce)||angular.isObject(debounce)){$$debounce(function(){scope.select({activeIdx:activeIdx,evt:evt});},angular.isNumber(debounce)?debounce:debounce['default']);}else{scope.select({activeIdx:activeIdx,evt:evt});}};}};}]).directive('uibTypeaheadMatch',['$templateRequest','$compile','$parse',function($templateRequest,$compile,$parse){return{scope:{index:'=',match:'=',query:'='},link:function link(scope,element,attrs){var tplUrl=$parse(attrs.templateUrl)(scope.$parent)||'uib/template/typeahead/typeahead-match.html';$templateRequest(tplUrl).then(function(tplContent){var tplEl=angular.element(tplContent.trim());element.replaceWith(tplEl);$compile(tplEl)(scope);});}};}]).filter('uibTypeaheadHighlight',['$sce','$injector','$log',function($sce,$injector,$log){var isSanitizePresent;isSanitizePresent=$injector.has('$sanitize');function escapeRegexp(queryToEscape){// Regex: capture the whole query string and replace it with the string that will be used to match
	// the results, for example if the capture is "a" the result will be \a
	return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g,'\\$1');}function containsHtml(matchItem){return /<.*>/g.test(matchItem);}return function(matchItem,query){if(!isSanitizePresent&&containsHtml(matchItem)){$log.warn('Unsafe use of typeahead please use ngSanitize');// Warn the user about the danger
	}matchItem=query?(''+matchItem).replace(new RegExp(escapeRegexp(query),'gi'),'<strong>$&</strong>'):matchItem;// Replaces the capture string with a the same string inside of a "strong" tag
	if(!isSanitizePresent){matchItem=$sce.trustAsHtml(matchItem);// If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
	}return matchItem;};}]);angular.module("uib/template/accordion/accordion-group.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/accordion/accordion-group.html","<div class=\"panel\" ng-class=\"panelClass || 'panel-default'\">\n"+"  <div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n"+"    <h4 class=\"panel-title\">\n"+"      <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\"><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n"+"    </h4>\n"+"  </div>\n"+"  <div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n"+"    <div class=\"panel-body\" ng-transclude></div>\n"+"  </div>\n"+"</div>\n"+"");}]);angular.module("uib/template/accordion/accordion.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/accordion/accordion.html","<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");}]);angular.module("uib/template/alert/alert.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/alert/alert.html","<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissible' : null]\" role=\"alert\">\n"+"    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n"+"        <span aria-hidden=\"true\">&times;</span>\n"+"        <span class=\"sr-only\">Close</span>\n"+"    </button>\n"+"    <div ng-transclude></div>\n"+"</div>\n"+"");}]);angular.module("uib/template/carousel/carousel.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/carousel/carousel.html","<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n"+"  <div class=\"carousel-inner\" ng-transclude></div>\n"+"  <a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\">\n"+"    <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n"+"    <span class=\"sr-only\">previous</span>\n"+"  </a>\n"+"  <a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\">\n"+"    <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n"+"    <span class=\"sr-only\">next</span>\n"+"  </a>\n"+"  <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n"+"    <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n"+"      <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n"+"    </li>\n"+"  </ol>\n"+"</div>\n"+"");}]);angular.module("uib/template/carousel/slide.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/carousel/slide.html","<div ng-class=\"{\n"+"    'active': active\n"+"  }\" class=\"item text-center\" ng-transclude></div>\n"+"");}]);angular.module("uib/template/datepicker/datepicker.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/datepicker/datepicker.html","<div class=\"uib-datepicker\" ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n"+"  <uib-daypicker ng-switch-when=\"day\" tabindex=\"0\"></uib-daypicker>\n"+"  <uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\"></uib-monthpicker>\n"+"  <uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\"></uib-yearpicker>\n"+"</div>\n"+"");}]);angular.module("uib/template/datepicker/day.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/datepicker/day.html","<table class=\"uib-daypicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n"+"  <thead>\n"+"    <tr>\n"+"      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n"+"      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n"+"      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n"+"    </tr>\n"+"    <tr>\n"+"      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n"+"      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n"+"    </tr>\n"+"  </thead>\n"+"  <tbody>\n"+"    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\">\n"+"      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n"+"      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n"+"        id=\"{{::dt.uid}}\"\n"+"        ng-class=\"::dt.customClass\">\n"+"        <button type=\"button\" class=\"btn btn-default btn-sm\"\n"+"          uib-is-class=\"\n"+"            'btn-info' for selectedDt,\n"+"            'active' for activeDt\n"+"            on dt\"\n"+"          ng-click=\"select(dt.date)\"\n"+"          ng-disabled=\"::dt.disabled\"\n"+"          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n"+"      </td>\n"+"    </tr>\n"+"  </tbody>\n"+"</table>\n"+"");}]);angular.module("uib/template/datepicker/month.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/datepicker/month.html","<table class=\"uib-monthpicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n"+"  <thead>\n"+"    <tr>\n"+"      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n"+"      <th><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n"+"      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n"+"    </tr>\n"+"  </thead>\n"+"  <tbody>\n"+"    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\">\n"+"      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n"+"        id=\"{{::dt.uid}}\"\n"+"        ng-class=\"::dt.customClass\">\n"+"        <button type=\"button\" class=\"btn btn-default\"\n"+"          uib-is-class=\"\n"+"            'btn-info' for selectedDt,\n"+"            'active' for activeDt\n"+"            on dt\"\n"+"          ng-click=\"select(dt.date)\"\n"+"          ng-disabled=\"::dt.disabled\"\n"+"          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n"+"      </td>\n"+"    </tr>\n"+"  </tbody>\n"+"</table>\n"+"");}]);angular.module("uib/template/datepicker/popup.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/datepicker/popup.html","<div>\n"+"  <ul class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n"+"    <li ng-transclude></li>\n"+"    <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n"+"      <span class=\"btn-group pull-left\">\n"+"        <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n"+"        <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n"+"      </span>\n"+"      <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n"+"    </li>\n"+"  </ul>\n"+"</div>\n"+"");}]);angular.module("uib/template/datepicker/year.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/datepicker/year.html","<table class=\"uib-yearpicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n"+"  <thead>\n"+"    <tr>\n"+"      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n"+"      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n"+"      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n"+"    </tr>\n"+"  </thead>\n"+"  <tbody>\n"+"    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\">\n"+"      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n"+"        id=\"{{::dt.uid}}\"\n"+"        ng-class=\"::dt.customClass\">\n"+"        <button type=\"button\" class=\"btn btn-default\"\n"+"          uib-is-class=\"\n"+"            'btn-info' for selectedDt,\n"+"            'active' for activeDt\n"+"            on dt\"\n"+"          ng-click=\"select(dt.date)\"\n"+"          ng-disabled=\"::dt.disabled\"\n"+"          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n"+"      </td>\n"+"    </tr>\n"+"  </tbody>\n"+"</table>\n"+"");}]);angular.module("uib/template/modal/backdrop.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/modal/backdrop.html","<div class=\"modal-backdrop\"\n"+"     uib-modal-animation-class=\"fade\"\n"+"     modal-in-class=\"in\"\n"+"     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n"+"></div>\n"+"");}]);angular.module("uib/template/modal/window.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/modal/window.html","<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n"+"    uib-modal-animation-class=\"fade\"\n"+"    modal-in-class=\"in\"\n"+"    ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\">\n"+"    <div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n"+"</div>\n"+"");}]);angular.module("uib/template/pager/pager.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/pager/pager.html","<ul class=\"pager\">\n"+"  <li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n"+"  <li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n"+"</ul>\n"+"");}]);angular.module("uib/template/pagination/pager.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/pagination/pager.html","<ul class=\"pager\">\n"+"  <li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n"+"  <li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n"+"</ul>\n"+"");}]);angular.module("uib/template/pagination/pagination.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/pagination/pagination.html","<ul class=\"pagination\">\n"+"  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\">{{::getText('first')}}</a></li>\n"+"  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n"+"  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\">{{page.text}}</a></li>\n"+"  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n"+"  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\">{{::getText('last')}}</a></li>\n"+"</ul>\n"+"");}]);angular.module("uib/template/tooltip/tooltip-html-popup.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/tooltip/tooltip-html-popup.html","<div class=\"tooltip\"\n"+"  tooltip-animation-class=\"fade\"\n"+"  uib-tooltip-classes\n"+"  ng-class=\"{ in: isOpen() }\">\n"+"  <div class=\"tooltip-arrow\"></div>\n"+"  <div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n"+"</div>\n"+"");}]);angular.module("uib/template/tooltip/tooltip-popup.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/tooltip/tooltip-popup.html","<div class=\"tooltip\"\n"+"  tooltip-animation-class=\"fade\"\n"+"  uib-tooltip-classes\n"+"  ng-class=\"{ in: isOpen() }\">\n"+"  <div class=\"tooltip-arrow\"></div>\n"+"  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n"+"</div>\n"+"");}]);angular.module("uib/template/tooltip/tooltip-template-popup.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/tooltip/tooltip-template-popup.html","<div class=\"tooltip\"\n"+"  tooltip-animation-class=\"fade\"\n"+"  uib-tooltip-classes\n"+"  ng-class=\"{ in: isOpen() }\">\n"+"  <div class=\"tooltip-arrow\"></div>\n"+"  <div class=\"tooltip-inner\"\n"+"    uib-tooltip-template-transclude=\"contentExp()\"\n"+"    tooltip-template-transclude-scope=\"originScope()\"></div>\n"+"</div>\n"+"");}]);angular.module("uib/template/popover/popover-html.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/popover/popover-html.html","<div class=\"popover\"\n"+"  tooltip-animation-class=\"fade\"\n"+"  uib-tooltip-classes\n"+"  ng-class=\"{ in: isOpen() }\">\n"+"  <div class=\"arrow\"></div>\n"+"\n"+"  <div class=\"popover-inner\">\n"+"      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n"+"      <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n"+"  </div>\n"+"</div>\n"+"");}]);angular.module("uib/template/popover/popover-template.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/popover/popover-template.html","<div class=\"popover\"\n"+"  tooltip-animation-class=\"fade\"\n"+"  uib-tooltip-classes\n"+"  ng-class=\"{ in: isOpen() }\">\n"+"  <div class=\"arrow\"></div>\n"+"\n"+"  <div class=\"popover-inner\">\n"+"      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n"+"      <div class=\"popover-content\"\n"+"        uib-tooltip-template-transclude=\"contentExp()\"\n"+"        tooltip-template-transclude-scope=\"originScope()\"></div>\n"+"  </div>\n"+"</div>\n"+"");}]);angular.module("uib/template/popover/popover.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/popover/popover.html","<div class=\"popover\"\n"+"  tooltip-animation-class=\"fade\"\n"+"  uib-tooltip-classes\n"+"  ng-class=\"{ in: isOpen() }\">\n"+"  <div class=\"arrow\"></div>\n"+"\n"+"  <div class=\"popover-inner\">\n"+"      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n"+"      <div class=\"popover-content\" ng-bind=\"content\"></div>\n"+"  </div>\n"+"</div>\n"+"");}]);angular.module("uib/template/progressbar/bar.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/progressbar/bar.html","<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n"+"");}]);angular.module("uib/template/progressbar/progress.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/progressbar/progress.html","<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");}]);angular.module("uib/template/progressbar/progressbar.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/progressbar/progressbar.html","<div class=\"progress\">\n"+"  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n"+"</div>\n"+"");}]);angular.module("uib/template/rating/rating.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/rating/rating.html","<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n"+"    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n"+"    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n"+"</span>\n"+"");}]);angular.module("uib/template/tabs/tab.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/tabs/tab.html","<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n"+"  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n"+"</li>\n"+"");}]);angular.module("uib/template/tabs/tabset.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/tabs/tabset.html","<div>\n"+"  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n"+"  <div class=\"tab-content\">\n"+"    <div class=\"tab-pane\"\n"+"         ng-repeat=\"tab in tabset.tabs\"\n"+"         ng-class=\"{active: tabset.active === tab.index}\"\n"+"         uib-tab-content-transclude=\"tab\">\n"+"    </div>\n"+"  </div>\n"+"</div>\n"+"");}]);angular.module("uib/template/timepicker/timepicker.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/timepicker/timepicker.html","<table class=\"uib-timepicker\">\n"+"  <tbody>\n"+"    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n"+"      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n"+"      <td>&nbsp;</td>\n"+"      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n"+"      <td ng-show=\"showSeconds\">&nbsp;</td>\n"+"      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n"+"      <td ng-show=\"showMeridian\"></td>\n"+"    </tr>\n"+"    <tr>\n"+"      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n"+"        <input style=\"width:50px;\" type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n"+"      </td>\n"+"      <td class=\"uib-separator\">:</td>\n"+"      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n"+"        <input style=\"width:50px;\" type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n"+"      </td>\n"+"      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n"+"      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n"+"        <input style=\"width:50px;\" type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n"+"      </td>\n"+"      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n"+"    </tr>\n"+"    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n"+"      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n"+"      <td>&nbsp;</td>\n"+"      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n"+"      <td ng-show=\"showSeconds\">&nbsp;</td>\n"+"      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n"+"      <td ng-show=\"showMeridian\"></td>\n"+"    </tr>\n"+"  </tbody>\n"+"</table>\n"+"");}]);angular.module("uib/template/typeahead/typeahead-match.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/typeahead/typeahead-match.html","<a href\n"+"   tabindex=\"-1\"\n"+"   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n"+"   ng-attr-title=\"{{match.label}}\"></a>\n"+"");}]);angular.module("uib/template/typeahead/typeahead-popup.html",[]).run(["$templateCache",function($templateCache){$templateCache.put("uib/template/typeahead/typeahead-popup.html","<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n"+"    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n"+"        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n"+"    </li>\n"+"</ul>\n"+"");}]);angular.module('ui.bootstrap.carousel').run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibCarouselCss&&angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');angular.$$uibCarouselCss=true;});angular.module('ui.bootstrap.position').run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibPositionCss&&angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll;}</style>');angular.$$uibPositionCss=true;});angular.module('ui.bootstrap.datepicker').run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibDatepickerCss&&angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}.uib-left,.uib-right{width:100%}</style>');angular.$$uibDatepickerCss=true;});angular.module('ui.bootstrap.tooltip').run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibTooltipCss&&angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>');angular.$$uibTooltipCss=true;});angular.module('ui.bootstrap.timepicker').run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibTimepickerCss&&angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>');angular.$$uibTimepickerCss=true;});angular.module('ui.bootstrap.typeahead').run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibTypeaheadCss&&angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>');angular.$$uibTypeaheadCss=true;});

/***/ },
/* 171 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Binds a CodeMirror widget to a <textarea> element.
	 */
	
	angular.module('ui.codemirror', []).constant('uiCodemirrorConfig', {}).directive('uiCodemirror', ['$timeout', 'uiCodemirrorConfig', uiCodemirrorDirective]);
	
	/**
	 * @ngInject
	 */
	function uiCodemirrorDirective($timeout, uiCodemirrorConfig) {
	
	  return {
	    restrict: 'EA',
	    require: '?ngModel',
	    compile: function compile() {
	
	      // Require CodeMirror
	      if (angular.isUndefined(window.CodeMirror)) {
	        throw new Error('ui-codemirror needs CodeMirror to work... (o rly?)');
	      }
	
	      return postLink;
	    }
	  };
	
	  function postLink(scope, iElement, iAttrs, ngModel) {
	
	    var codemirrorOptions = angular.extend({ value: iElement.text() }, uiCodemirrorConfig.codemirror || {}, scope.$eval(iAttrs.uiCodemirror), scope.$eval(iAttrs.uiCodemirrorOpts));
	
	    var codemirror = newCodemirrorEditor(iElement, codemirrorOptions);
	
	    configOptionsWatcher(codemirror, iAttrs.uiCodemirror || iAttrs.uiCodemirrorOpts, scope);
	
	    configNgModelLink(codemirror, ngModel, scope);
	
	    configUiRefreshAttribute(codemirror, iAttrs.uiRefresh, scope);
	
	    // Allow access to the CodeMirror instance through a broadcasted event
	    // eg: $broadcast('CodeMirror', function(cm){...});
	    scope.$on('CodeMirror', function (event, callback) {
	      if (angular.isFunction(callback)) {
	        callback(codemirror);
	      } else {
	        throw new Error('the CodeMirror event requires a callback function');
	      }
	    });
	
	    // onLoad callback
	    if (angular.isFunction(codemirrorOptions.onLoad)) {
	      codemirrorOptions.onLoad(codemirror);
	    }
	  }
	
	  function newCodemirrorEditor(iElement, codemirrorOptions) {
	    var codemirrot;
	
	    if (iElement[0].tagName === 'TEXTAREA') {
	      // Might bug but still ...
	      codemirrot = window.CodeMirror.fromTextArea(iElement[0], codemirrorOptions);
	    } else {
	      iElement.html('');
	      codemirrot = new window.CodeMirror(function (cm_el) {
	        iElement.append(cm_el);
	      }, codemirrorOptions);
	    }
	
	    return codemirrot;
	  }
	
	  function configOptionsWatcher(codemirrot, uiCodemirrorAttr, scope) {
	    if (!uiCodemirrorAttr) {
	      return;
	    }
	
	    var codemirrorDefaultsKeys = Object.keys(window.CodeMirror.defaults);
	    scope.$watch(uiCodemirrorAttr, updateOptions, true);
	    function updateOptions(newValues, oldValue) {
	      if (!angular.isObject(newValues)) {
	        return;
	      }
	      codemirrorDefaultsKeys.forEach(function (key) {
	        if (newValues.hasOwnProperty(key)) {
	
	          if (oldValue && newValues[key] === oldValue[key]) {
	            return;
	          }
	
	          codemirrot.setOption(key, newValues[key]);
	        }
	      });
	    }
	  }
	
	  function configNgModelLink(codemirror, ngModel, scope) {
	    if (!ngModel) {
	      return;
	    }
	    // CodeMirror expects a string, so make sure it gets one.
	    // This does not change the model.
	    ngModel.$formatters.push(function (value) {
	      if (angular.isUndefined(value) || value === null) {
	        return '';
	      } else if (angular.isObject(value) || angular.isArray(value)) {
	        throw new Error('ui-codemirror cannot use an object or an array as a model');
	      }
	      return value;
	    });
	
	    // Override the ngModelController $render method, which is what gets called when the model is updated.
	    // This takes care of the synchronizing the codeMirror element with the underlying model, in the case that it is changed by something else.
	    ngModel.$render = function () {
	      //Code mirror expects a string so make sure it gets one
	      //Although the formatter have already done this, it can be possible that another formatter returns undefined (for example the required directive)
	      var safeViewValue = ngModel.$viewValue || '';
	      codemirror.setValue(safeViewValue);
	    };
	
	    // Keep the ngModel in sync with changes from CodeMirror
	    codemirror.on('change', function (instance) {
	      var newValue = instance.getValue();
	      if (newValue !== ngModel.$viewValue) {
	        scope.$evalAsync(function () {
	          ngModel.$setViewValue(newValue);
	        });
	      }
	    });
	  }
	
	  function configUiRefreshAttribute(codeMirror, uiRefreshAttr, scope) {
	    if (!uiRefreshAttr) {
	      return;
	    }
	
	    scope.$watch(uiRefreshAttr, function (newVal, oldVal) {
	      // Skip the initial watch firing
	      if (newVal !== oldVal) {
	        $timeout(function () {
	          codeMirror.refresh();
	        });
	      }
	    });
	  }
	}

/***/ },
/* 172 */
/***/ function(module, exports) {

	'use strict';var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/**
	 * @license AngularJS v1.4.12
	 * (c) 2010-2015 Google, Inc. http://angularjs.org
	 * License: MIT
	 */(function(window,document,undefined){'use strict';/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */function minErr(module,ErrorConstructor){ErrorConstructor=ErrorConstructor||Error;return function(){var SKIP_INDEXES=2;var templateArgs=arguments,code=templateArgs[0],message='['+(module?module+':':'')+code+'] ',template=templateArgs[1],paramPrefix,i;message+=template.replace(/\{\d+\}/g,function(match){var index=+match.slice(1,-1),shiftedIndex=index+SKIP_INDEXES;if(shiftedIndex<templateArgs.length){return toDebugString(templateArgs[shiftedIndex]);}return match;});message+='\nhttp://errors.angularjs.org/1.4.12/'+(module?module+'/':'')+code;for(i=SKIP_INDEXES,paramPrefix='?';i<templateArgs.length;i++,paramPrefix='&'){message+=paramPrefix+'p'+(i-SKIP_INDEXES)+'='+encodeURIComponent(toDebugString(templateArgs[i]));}return new ErrorConstructor(message);};}/* We need to tell jshint what variables are being exported *//* global angular: true,
	  msie: true,
	  jqLite: true,
	  jQuery: true,
	  slice: true,
	  splice: true,
	  push: true,
	  toString: true,
	  ngMinErr: true,
	  angularModule: true,
	  uid: true,
	  REGEX_STRING_REGEXP: true,
	  VALIDITY_STATE_PROPERTY: true,
	
	  lowercase: true,
	  uppercase: true,
	  manualLowercase: true,
	  manualUppercase: true,
	  nodeName_: true,
	  isArrayLike: true,
	  forEach: true,
	  forEachSorted: true,
	  reverseParams: true,
	  nextUid: true,
	  setHashKey: true,
	  extend: true,
	  toInt: true,
	  inherit: true,
	  merge: true,
	  noop: true,
	  identity: true,
	  valueFn: true,
	  isUndefined: true,
	  isDefined: true,
	  isObject: true,
	  isBlankObject: true,
	  isString: true,
	  isNumber: true,
	  isDate: true,
	  isArray: true,
	  isFunction: true,
	  isRegExp: true,
	  isWindow: true,
	  isScope: true,
	  isFile: true,
	  isFormData: true,
	  isBlob: true,
	  isBoolean: true,
	  isPromiseLike: true,
	  trim: true,
	  escapeForRegexp: true,
	  isElement: true,
	  makeMap: true,
	  includes: true,
	  arrayRemove: true,
	  copy: true,
	  shallowCopy: true,
	  equals: true,
	  csp: true,
	  jq: true,
	  concat: true,
	  sliceArgs: true,
	  bind: true,
	  toJsonReplacer: true,
	  toJson: true,
	  fromJson: true,
	  convertTimezoneToLocal: true,
	  timezoneToOffset: true,
	  startingTag: true,
	  tryDecodeURIComponent: true,
	  parseKeyValue: true,
	  toKeyValue: true,
	  encodeUriSegment: true,
	  encodeUriQuery: true,
	  angularInit: true,
	  bootstrap: true,
	  getTestability: true,
	  snake_case: true,
	  bindJQuery: true,
	  assertArg: true,
	  assertArgFn: true,
	  assertNotHasOwnProperty: true,
	  getter: true,
	  getBlockNodes: true,
	  hasOwnProperty: true,
	  createMap: true,
	
	  NODE_TYPE_ELEMENT: true,
	  NODE_TYPE_ATTRIBUTE: true,
	  NODE_TYPE_TEXT: true,
	  NODE_TYPE_COMMENT: true,
	  NODE_TYPE_DOCUMENT: true,
	  NODE_TYPE_DOCUMENT_FRAGMENT: true,
	*/////////////////////////////////////
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */var REGEX_STRING_REGEXP=/^\/(.+)\/([a-z]*)$/;// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY='validity';/**
	 * @ngdoc function
	 * @name angular.lowercase
	 * @module ng
	 * @kind function
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */var lowercase=function lowercase(string){return isString(string)?string.toLowerCase():string;};var hasOwnProperty=Object.prototype.hasOwnProperty;/**
	 * @ngdoc function
	 * @name angular.uppercase
	 * @module ng
	 * @kind function
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */var uppercase=function uppercase(string){return isString(string)?string.toUpperCase():string;};var manualLowercase=function manualLowercase(s){/* jshint bitwise: false */return isString(s)?s.replace(/[A-Z]/g,function(ch){return String.fromCharCode(ch.charCodeAt(0)|32);}):s;};var manualUppercase=function manualUppercase(s){/* jshint bitwise: false */return isString(s)?s.replace(/[a-z]/g,function(ch){return String.fromCharCode(ch.charCodeAt(0)&~32);}):s;};// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives.
	if('i'!=='I'.toLowerCase()){lowercase=manualLowercase;uppercase=manualUppercase;}var msie,// holds major version number for IE, or NaN if UA is not IE.
	jqLite,// delay binding since jQuery could be loaded after us.
	jQuery,// delay binding
	slice=[].slice,splice=[].splice,push=[].push,toString=Object.prototype.toString,getPrototypeOf=Object.getPrototypeOf,ngMinErr=minErr('ng'),/** @name angular */angular=window.angular||(window.angular={}),angularModule,uid=0;/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */msie=document.documentMode;/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */function isArrayLike(obj){// `null`, `undefined` and `window` are not array-like
	if(obj==null||isWindow(obj))return false;// arrays, strings and jQuery/jqLite objects are array like
	// * jqLite is either the jQuery or jqLite constructor function
	// * we have to check the existance of jqLite first as this method is called
	//   via the forEach method when constructing the jqLite object in the first place
	if(isArray(obj)||isString(obj)||jqLite&&obj instanceof jqLite)return true;// Support: iOS 8.2 (not reproducible in simulator)
	// "length" in obj used to prevent JIT error (gh-11508)
	var length="length"in Object(obj)&&obj.length;// NodeList objects (with `item` method) and
	// other objects with suitable length characteristics are array-like
	return isNumber(length)&&(length>=0&&(length-1 in obj||obj instanceof Array)||typeof obj.item=='function');}/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */function forEach(obj,iterator,context){var key,length;if(obj){if(isFunction(obj)){for(key in obj){// Need to check if hasOwnProperty exists,
	// as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
	if(key!='prototype'&&key!='length'&&key!='name'&&(!obj.hasOwnProperty||obj.hasOwnProperty(key))){iterator.call(context,obj[key],key,obj);}}}else if(isArray(obj)||isArrayLike(obj)){var isPrimitive=(typeof obj==='undefined'?'undefined':_typeof(obj))!=='object';for(key=0,length=obj.length;key<length;key++){if(isPrimitive||key in obj){iterator.call(context,obj[key],key,obj);}}}else if(obj.forEach&&obj.forEach!==forEach){obj.forEach(iterator,context,obj);}else if(isBlankObject(obj)){// createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	for(key in obj){iterator.call(context,obj[key],key,obj);}}else if(typeof obj.hasOwnProperty==='function'){// Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	for(key in obj){if(obj.hasOwnProperty(key)){iterator.call(context,obj[key],key,obj);}}}else{// Slow path for objects which do not have a method `hasOwnProperty`
	for(key in obj){if(hasOwnProperty.call(obj,key)){iterator.call(context,obj[key],key,obj);}}}}return obj;}function forEachSorted(obj,iterator,context){var keys=Object.keys(obj).sort();for(var i=0;i<keys.length;i++){iterator.call(context,obj[keys[i]],keys[i]);}return keys;}/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */function reverseParams(iteratorFn){return function(value,key){iteratorFn(key,value);};}/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */function nextUid(){return++uid;}/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */function setHashKey(obj,h){if(h){obj.$$hashKey=h;}else{delete obj.$$hashKey;}}function baseExtend(dst,objs,deep){var h=dst.$$hashKey;for(var i=0,ii=objs.length;i<ii;++i){var obj=objs[i];if(!isObject(obj)&&!isFunction(obj))continue;var keys=Object.keys(obj);for(var j=0,jj=keys.length;j<jj;j++){var key=keys[j];var src=obj[key];if(deep&&isObject(src)){if(isDate(src)){dst[key]=new Date(src.valueOf());}else if(isRegExp(src)){dst[key]=new RegExp(src);}else if(src.nodeName){dst[key]=src.cloneNode(true);}else if(isElement(src)){dst[key]=src.clone();}else{if(!isObject(dst[key]))dst[key]=isArray(src)?[]:{};baseExtend(dst[key],[src],true);}}else{dst[key]=src;}}}setHashKey(dst,h);return dst;}/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */function extend(dst){return baseExtend(dst,slice.call(arguments,1),false);}/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/function merge(dst){return baseExtend(dst,slice.call(arguments,1),true);}function toInt(str){return parseInt(str,10);}function inherit(parent,extra){return extend(Object.create(parent),extra);}/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */function noop(){}noop.$inject=[];/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */function identity($){return $;}identity.$inject=[];function valueFn(value){return function(){return value;};}function hasCustomToString(obj){return isFunction(obj.toString)&&obj.toString!==toString;}/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */function isUndefined(value){return typeof value==='undefined';}/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */function isDefined(value){return typeof value!=='undefined';}/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */function isObject(value){// http://jsperf.com/isobject4
	return value!==null&&(typeof value==='undefined'?'undefined':_typeof(value))==='object';}/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */function isBlankObject(value){return value!==null&&(typeof value==='undefined'?'undefined':_typeof(value))==='object'&&!getPrototypeOf(value);}/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */function isString(value){return typeof value==='string';}/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */function isNumber(value){return typeof value==='number';}/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */function isDate(value){return toString.call(value)==='[object Date]';}/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */var isArray=Array.isArray;/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */function isFunction(value){return typeof value==='function';}/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */function isRegExp(value){return toString.call(value)==='[object RegExp]';}/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */function isWindow(obj){return obj&&obj.window===obj;}function isScope(obj){return obj&&obj.$evalAsync&&obj.$watch;}function isFile(obj){return toString.call(obj)==='[object File]';}function isFormData(obj){return toString.call(obj)==='[object FormData]';}function isBlob(obj){return toString.call(obj)==='[object Blob]';}function isBoolean(value){return typeof value==='boolean';}function isPromiseLike(obj){return obj&&isFunction(obj.then);}var TYPED_ARRAY_REGEXP=/^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array\]$/;function isTypedArray(value){return value&&isNumber(value.length)&&TYPED_ARRAY_REGEXP.test(toString.call(value));}var trim=function trim(value){return isString(value)?value.trim():value;};// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp=function escapeForRegexp(s){return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g,'\\$1').replace(/\x08/g,'\\x08');};/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */function isElement(node){return!!(node&&(node.nodeName// we are a direct element
	||node.prop&&node.attr&&node.find));// we have an on and find method part of jQuery API
	}/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */function makeMap(str){var obj={},items=str.split(','),i;for(i=0;i<items.length;i++){obj[items[i]]=true;}return obj;}function nodeName_(element){return lowercase(element.nodeName||element[0]&&element[0].nodeName);}function includes(array,obj){return Array.prototype.indexOf.call(array,obj)!=-1;}function arrayRemove(array,value){var index=array.indexOf(value);if(index>=0){array.splice(index,1);}return index;}/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to 'destination' an exception will be thrown.
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	 <example module="copyExample">
	 <file name="index.html">
	 <div ng-controller="ExampleController">
	 <form novalidate class="simple-form">
	 Name: <input type="text" ng-model="user.name" /><br />
	 E-mail: <input type="email" ng-model="user.email" /><br />
	 Gender: <input type="radio" ng-model="user.gender" value="male" />male
	 <input type="radio" ng-model="user.gender" value="female" />female<br />
	 <button ng-click="reset()">RESET</button>
	 <button ng-click="update(user)">SAVE</button>
	 </form>
	 <pre>form = {{user | json}}</pre>
	 <pre>master = {{master | json}}</pre>
	 </div>
	
	 <script>
	  angular.module('copyExample', [])
	    .controller('ExampleController', ['$scope', function($scope) {
	      $scope.master= {};
	
	      $scope.update = function(user) {
	        // Example with 1 argument
	        $scope.master= angular.copy(user);
	      };
	
	      $scope.reset = function() {
	        // Example with 2 arguments
	        angular.copy($scope.master, $scope.user);
	      };
	
	      $scope.reset();
	    }]);
	 </script>
	 </file>
	 </example>
	 */function copy(source,destination){var stackSource=[];var stackDest=[];if(destination){if(isTypedArray(destination)){throw ngMinErr('cpta',"Can't copy! TypedArray destination cannot be mutated.");}if(source===destination){throw ngMinErr('cpi',"Can't copy! Source and destination are identical.");}// Empty the destination object
	if(isArray(destination)){destination.length=0;}else{forEach(destination,function(value,key){if(key!=='$$hashKey'){delete destination[key];}});}stackSource.push(source);stackDest.push(destination);return copyRecurse(source,destination);}return copyElement(source);function copyRecurse(source,destination){var h=destination.$$hashKey;var result,key;if(isArray(source)){for(var i=0,ii=source.length;i<ii;i++){destination.push(copyElement(source[i]));}}else if(isBlankObject(source)){// createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	for(key in source){destination[key]=copyElement(source[key]);}}else if(source&&typeof source.hasOwnProperty==='function'){// Slow path, which must rely on hasOwnProperty
	for(key in source){if(source.hasOwnProperty(key)){destination[key]=copyElement(source[key]);}}}else{// Slowest path --- hasOwnProperty can't be called as a method
	for(key in source){if(hasOwnProperty.call(source,key)){destination[key]=copyElement(source[key]);}}}setHashKey(destination,h);return destination;}function copyElement(source){// Simple values
	if(!isObject(source)){return source;}// Already copied values
	var index=stackSource.indexOf(source);if(index!==-1){return stackDest[index];}if(isWindow(source)||isScope(source)){throw ngMinErr('cpws',"Can't copy! Making copies of Window or Scope instances is not supported.");}var needsRecurse=false;var destination;if(isArray(source)){destination=[];needsRecurse=true;}else if(isTypedArray(source)){destination=new source.constructor(source);}else if(isDate(source)){destination=new Date(source.getTime());}else if(isRegExp(source)){destination=new RegExp(source.source,source.toString().match(/[^\/]*$/)[0]);destination.lastIndex=source.lastIndex;}else if(isBlob(source)){destination=new source.constructor([source],{type:source.type});}else if(isFunction(source.cloneNode)){destination=source.cloneNode(true);}else{destination=Object.create(getPrototypeOf(source));needsRecurse=true;}stackSource.push(source);stackDest.push(destination);return needsRecurse?copyRecurse(source,destination):destination;}}/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */function shallowCopy(src,dst){if(isArray(src)){dst=dst||[];for(var i=0,ii=src.length;i<ii;i++){dst[i]=src[i];}}else if(isObject(src)){dst=dst||{};for(var key in src){if(!(key.charAt(0)==='$'&&key.charAt(1)==='$')){dst[key]=src[key];}}}return dst||src;}/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 */function equals(o1,o2){if(o1===o2)return true;if(o1===null||o2===null)return false;if(o1!==o1&&o2!==o2)return true;// NaN === NaN
	var t1=typeof o1==='undefined'?'undefined':_typeof(o1),t2=typeof o2==='undefined'?'undefined':_typeof(o2),length,key,keySet;if(t1==t2){if(t1=='object'){if(isArray(o1)){if(!isArray(o2))return false;if((length=o1.length)==o2.length){for(key=0;key<length;key++){if(!equals(o1[key],o2[key]))return false;}return true;}}else if(isDate(o1)){if(!isDate(o2))return false;return equals(o1.getTime(),o2.getTime());}else if(isRegExp(o1)){return isRegExp(o2)?o1.toString()==o2.toString():false;}else{if(isScope(o1)||isScope(o2)||isWindow(o1)||isWindow(o2)||isArray(o2)||isDate(o2)||isRegExp(o2))return false;keySet=createMap();for(key in o1){if(key.charAt(0)==='$'||isFunction(o1[key]))continue;if(!equals(o1[key],o2[key]))return false;keySet[key]=true;}for(key in o2){if(!(key in keySet)&&key.charAt(0)!=='$'&&isDefined(o2[key])&&!isFunction(o2[key]))return false;}return true;}}}return false;}var csp=function csp(){if(!isDefined(csp.rules)){var ngCspElement=document.querySelector('[ng-csp]')||document.querySelector('[data-ng-csp]');if(ngCspElement){var ngCspAttribute=ngCspElement.getAttribute('ng-csp')||ngCspElement.getAttribute('data-ng-csp');csp.rules={noUnsafeEval:!ngCspAttribute||ngCspAttribute.indexOf('no-unsafe-eval')!==-1,noInlineStyle:!ngCspAttribute||ngCspAttribute.indexOf('no-inline-style')!==-1};}else{csp.rules={noUnsafeEval:noUnsafeEval(),noInlineStyle:false};}}return csp.rules;function noUnsafeEval(){try{/* jshint -W031, -W054 */new Function('');/* jshint +W031, +W054 */return false;}catch(e){return true;}}};/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since angular looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */var jq=function jq(){if(isDefined(jq.name_))return jq.name_;var el;var i,ii=ngAttrPrefixes.length,prefix,name;for(i=0;i<ii;++i){prefix=ngAttrPrefixes[i];if(el=document.querySelector('['+prefix.replace(':','\\:')+'jq]')){name=el.getAttribute(prefix+'jq');break;}}return jq.name_=name;};function concat(array1,array2,index){return array1.concat(slice.call(array2,index));}function sliceArgs(args,startIndex){return slice.call(args,startIndex||0);}/* jshint -W101 *//**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 *//* jshint +W101 */function bind(self,fn){var curryArgs=arguments.length>2?sliceArgs(arguments,2):[];if(isFunction(fn)&&!(fn instanceof RegExp)){return curryArgs.length?function(){return arguments.length?fn.apply(self,concat(curryArgs,arguments,0)):fn.apply(self,curryArgs);}:function(){return arguments.length?fn.apply(self,arguments):fn.call(self);};}else{// in IE, native methods are not functions so they cannot be bound (note: they don't need to be)
	return fn;}}function toJsonReplacer(key,value){var val=value;if(typeof key==='string'&&key.charAt(0)==='$'&&key.charAt(1)==='$'){val=undefined;}else if(isWindow(value)){val='$WINDOW';}else if(value&&document===value){val='$DOCUMENT';}else if(isScope(value)){val='$SCOPE';}return val;}/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 */function toJson(obj,pretty){if(isUndefined(obj))return undefined;if(!isNumber(pretty)){pretty=pretty?2:null;}return JSON.stringify(obj,toJsonReplacer,pretty);}/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */function fromJson(json){return isString(json)?JSON.parse(json):json;}var ALL_COLONS=/:/g;function timezoneToOffset(timezone,fallback){// IE/Edge do not "understand" colon (`:`) in timezone
	timezone=timezone.replace(ALL_COLONS,'');var requestedTimezoneOffset=Date.parse('Jan 01, 1970 00:00:00 '+timezone)/60000;return isNaN(requestedTimezoneOffset)?fallback:requestedTimezoneOffset;}function addDateMinutes(date,minutes){date=new Date(date.getTime());date.setMinutes(date.getMinutes()+minutes);return date;}function convertTimezoneToLocal(date,timezone,reverse){reverse=reverse?-1:1;var dateTimezoneOffset=date.getTimezoneOffset();var timezoneOffset=timezoneToOffset(timezone,dateTimezoneOffset);return addDateMinutes(date,reverse*(timezoneOffset-dateTimezoneOffset));}/**
	 * @returns {string} Returns the string representation of the element.
	 */function startingTag(element){element=jqLite(element).clone();try{// turns out IE does not let you set .html() on elements which
	// are not allowed to have children. So we just ignore it.
	element.empty();}catch(e){}var elemHtml=jqLite('<div>').append(element).html();try{return element[0].nodeType===NODE_TYPE_TEXT?lowercase(elemHtml):elemHtml.match(/^(<[^>]+>)/)[1].replace(/^<([\w\-]+)/,function(match,nodeName){return'<'+lowercase(nodeName);});}catch(e){return lowercase(elemHtml);}}/////////////////////////////////////////////////
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */function tryDecodeURIComponent(value){try{return decodeURIComponent(value);}catch(e){// Ignore any invalid uri component
	}}/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */function parseKeyValue(/**string*/keyValue){var obj={};forEach((keyValue||"").split('&'),function(keyValue){var splitPoint,key,val;if(keyValue){key=keyValue=keyValue.replace(/\+/g,'%20');splitPoint=keyValue.indexOf('=');if(splitPoint!==-1){key=keyValue.substring(0,splitPoint);val=keyValue.substring(splitPoint+1);}key=tryDecodeURIComponent(key);if(isDefined(key)){val=isDefined(val)?tryDecodeURIComponent(val):true;if(!hasOwnProperty.call(obj,key)){obj[key]=val;}else if(isArray(obj[key])){obj[key].push(val);}else{obj[key]=[obj[key],val];}}}});return obj;}function toKeyValue(obj){var parts=[];forEach(obj,function(value,key){if(isArray(value)){forEach(value,function(arrayValue){parts.push(encodeUriQuery(key,true)+(arrayValue===true?'':'='+encodeUriQuery(arrayValue,true)));});}else{parts.push(encodeUriQuery(key,true)+(value===true?'':'='+encodeUriQuery(value,true)));}});return parts.length?parts.join('&'):'';}/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */function encodeUriSegment(val){return encodeUriQuery(val,true).replace(/%26/gi,'&').replace(/%3D/gi,'=').replace(/%2B/gi,'+');}/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query       = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */function encodeUriQuery(val,pctEncodeSpaces){return encodeURIComponent(val).replace(/%40/gi,'@').replace(/%3A/gi,':').replace(/%24/g,'$').replace(/%2C/gi,',').replace(/%3B/gi,';').replace(/%20/g,pctEncodeSpaces?'%20':'+');}var ngAttrPrefixes=['ng-','data-ng-','ng:','x-ng-'];function getNgAttribute(element,ngAttr){var attr,i,ii=ngAttrPrefixes.length;for(i=0;i<ii;++i){attr=ngAttrPrefixes[i]+ngAttr;if(isString(attr=element.getAttribute(attr))){return attr;}}return null;}/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * Only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 * found in the document will be used to define the root element to auto-bootstrap as an
	 * application. To run multiple applications in an HTML document you must manually bootstrap them using
	 * {@link angular.bootstrap} instead. AngularJS applications cannot be nested within each other.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = "World";
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */function angularInit(element,bootstrap){var appElement,module,config={};// The element `element` has priority over any other element
	forEach(ngAttrPrefixes,function(prefix){var name=prefix+'app';if(!appElement&&element.hasAttribute&&element.hasAttribute(name)){appElement=element;module=element.getAttribute(name);}});forEach(ngAttrPrefixes,function(prefix){var name=prefix+'app';var candidate;if(!appElement&&(candidate=element.querySelector('['+name.replace(':','\\:')+']'))){appElement=candidate;module=candidate.getAttribute(name);}});if(appElement){config.strictDi=getNgAttribute(appElement,"strict-di")!==null;bootstrap(appElement,module?[module]:[],config);}}/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * See: {@link guide/bootstrap Bootstrap}
	 *
	 * Note that Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */function bootstrap(element,modules,config){if(!isObject(config))config={};var defaultConfig={strictDi:false};config=extend(defaultConfig,config);var doBootstrap=function doBootstrap(){element=jqLite(element);if(element.injector()){var tag=element[0]===document?'document':startingTag(element);//Encode angle brackets to prevent input from being sanitized to empty string #8683
	throw ngMinErr('btstrpd',"App already bootstrapped with this element '{0}'",tag.replace(/</,'&lt;').replace(/>/,'&gt;'));}modules=modules||[];modules.unshift(['$provide',function($provide){$provide.value('$rootElement',element);}]);if(config.debugInfoEnabled){// Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	modules.push(['$compileProvider',function($compileProvider){$compileProvider.debugInfoEnabled(true);}]);}modules.unshift('ng');var injector=createInjector(modules,config.strictDi);injector.invoke(['$rootScope','$rootElement','$compile','$injector',function bootstrapApply(scope,element,compile,injector){scope.$apply(function(){element.data('$injector',injector);compile(element)(scope);});}]);return injector;};var NG_ENABLE_DEBUG_INFO=/^NG_ENABLE_DEBUG_INFO!/;var NG_DEFER_BOOTSTRAP=/^NG_DEFER_BOOTSTRAP!/;if(window&&NG_ENABLE_DEBUG_INFO.test(window.name)){config.debugInfoEnabled=true;window.name=window.name.replace(NG_ENABLE_DEBUG_INFO,'');}if(window&&!NG_DEFER_BOOTSTRAP.test(window.name)){return doBootstrap();}window.name=window.name.replace(NG_DEFER_BOOTSTRAP,'');angular.resumeBootstrap=function(extraModules){forEach(extraModules,function(module){modules.push(module);});return doBootstrap();};if(isFunction(angular.resumeDeferredBootstrap)){angular.resumeDeferredBootstrap();}}/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */function reloadWithDebugInfo(){window.name='NG_ENABLE_DEBUG_INFO!'+window.name;window.location.reload();}/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */function getTestability(rootElement){var injector=angular.element(rootElement).injector();if(!injector){throw ngMinErr('test','no injector found for element argument to getTestability');}return injector.get('$$testability');}var SNAKE_CASE_REGEXP=/[A-Z]/g;function snake_case(name,separator){separator=separator||'_';return name.replace(SNAKE_CASE_REGEXP,function(letter,pos){return(pos?separator:'')+letter.toLowerCase();});}var bindJQueryFired=false;var skipDestroyOnNextJQueryCleanData;function bindJQuery(){var originalCleanData;if(bindJQueryFired){return;}// bind to jQuery if present;
	var jqName=jq();jQuery=isUndefined(jqName)?window.jQuery:// use jQuery (if present)
	!jqName?undefined:// use jqLite
	window[jqName];// use jQuery specified by `ngJq`
	// Use jQuery if it exists with proper functionality, otherwise default to us.
	// Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	// Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	// versions. It will not work for sure with jQuery <1.7, though.
	if(jQuery&&jQuery.fn.on){jqLite=jQuery;extend(jQuery.fn,{scope:JQLitePrototype.scope,isolateScope:JQLitePrototype.isolateScope,controller:JQLitePrototype.controller,injector:JQLitePrototype.injector,inheritedData:JQLitePrototype.inheritedData});// All nodes removed from the DOM via various jQuery APIs like .remove()
	// are passed through jQuery.cleanData. Monkey-patch this method to fire
	// the $destroy event on all removed nodes.
	originalCleanData=jQuery.cleanData;jQuery.cleanData=function(elems){var events;if(!skipDestroyOnNextJQueryCleanData){for(var i=0,elem;(elem=elems[i])!=null;i++){events=jQuery._data(elem,"events");if(events&&events.$destroy){jQuery(elem).triggerHandler('$destroy');}}}else{skipDestroyOnNextJQueryCleanData=false;}originalCleanData(elems);};}else{jqLite=JQLite;}angular.element=jqLite;// Prevent double-proxying.
	bindJQueryFired=true;}/**
	 * throw error if the argument is falsy.
	 */function assertArg(arg,name,reason){if(!arg){throw ngMinErr('areq',"Argument '{0}' is {1}",name||'?',reason||"required");}return arg;}function assertArgFn(arg,name,acceptArrayAnnotation){if(acceptArrayAnnotation&&isArray(arg)){arg=arg[arg.length-1];}assertArg(isFunction(arg),name,'not a function, got '+(arg&&(typeof arg==='undefined'?'undefined':_typeof(arg))==='object'?arg.constructor.name||'Object':typeof arg==='undefined'?'undefined':_typeof(arg)));return arg;}/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */function assertNotHasOwnProperty(name,context){if(name==='hasOwnProperty'){throw ngMinErr('badname',"hasOwnProperty is not a valid {0} name",context);}}/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 *///TODO(misko): this function needs to be removed
	function getter(obj,path,bindFnToScope){if(!path)return obj;var keys=path.split('.');var key;var lastInstance=obj;var len=keys.length;for(var i=0;i<len;i++){key=keys[i];if(obj){obj=(lastInstance=obj)[key];}}if(!bindFnToScope&&isFunction(obj)){return bind(lastInstance,obj);}return obj;}/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */function getBlockNodes(nodes){// TODO(perf): update `nodes` instead of creating a new object?
	var node=nodes[0];var endNode=nodes[nodes.length-1];var blockNodes;for(var i=1;node!==endNode&&(node=node.nextSibling);i++){if(blockNodes||nodes[i]!==node){if(!blockNodes){blockNodes=jqLite(slice.call(nodes,0,i));}blockNodes.push(node);}}return blockNodes||nodes;}/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */function createMap(){return Object.create(null);}var NODE_TYPE_ELEMENT=1;var NODE_TYPE_ATTRIBUTE=2;var NODE_TYPE_TEXT=3;var NODE_TYPE_COMMENT=8;var NODE_TYPE_DOCUMENT=9;var NODE_TYPE_DOCUMENT_FRAGMENT=11;/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */function setupModuleLoader(window){var $injectorMinErr=minErr('$injector');var ngMinErr=minErr('ng');function ensure(obj,name,factory){return obj[name]||(obj[name]=factory());}var angular=ensure(window,'angular',Object);// We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	angular.$$minErr=angular.$$minErr||minErr;return ensure(angular,'module',function(){/** @type {Object.<string, angular.Module>} */var modules={};/**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */return function module(name,requires,configFn){var assertNotHasOwnProperty=function assertNotHasOwnProperty(name,context){if(name==='hasOwnProperty'){throw ngMinErr('badname','hasOwnProperty is not a valid {0} name',context);}};assertNotHasOwnProperty(name,'module');if(requires&&modules.hasOwnProperty(name)){modules[name]=null;}return ensure(modules,name,function(){if(!requires){throw $injectorMinErr('nomod',"Module '{0}' is not available! You either misspelled "+"the module name or forgot to load it. If registering a module ensure that you "+"specify the dependencies as the second argument.",name);}/** @type {!Array.<Array.<*>>} */var invokeQueue=[];/** @type {!Array.<Function>} */var configBlocks=[];/** @type {!Array.<Function>} */var runBlocks=[];var config=invokeLater('$injector','invoke','push',configBlocks);/** @type {angular.Module} */var moduleInstance={// Private state
	_invokeQueue:invokeQueue,_configBlocks:configBlocks,_runBlocks:runBlocks,/**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */requires:requires,/**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */name:name,/**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */provider:invokeLaterAndSetModuleName('$provide','provider'),/**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */factory:invokeLaterAndSetModuleName('$provide','factory'),/**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */service:invokeLaterAndSetModuleName('$provide','service'),/**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */value:invokeLater('$provide','value'),/**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */constant:invokeLater('$provide','constant','unshift'),/**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */decorator:invokeLaterAndSetModuleName('$provide','decorator'),/**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */animation:invokeLaterAndSetModuleName('$animateProvider','register'),/**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */filter:invokeLaterAndSetModuleName('$filterProvider','register'),/**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */controller:invokeLaterAndSetModuleName('$controllerProvider','register'),/**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */directive:invokeLaterAndSetModuleName('$compileProvider','directive'),/**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */config:config,/**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */run:function run(block){runBlocks.push(block);return this;}};if(configFn){config(configFn);}return moduleInstance;/**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */function invokeLater(provider,method,insertMethod,queue){if(!queue)queue=invokeQueue;return function(){queue[insertMethod||'push']([provider,method,arguments]);return moduleInstance;};}/**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */function invokeLaterAndSetModuleName(provider,method){return function(recipeName,factoryFunction){if(factoryFunction&&isFunction(factoryFunction))factoryFunction.$$moduleName=name;invokeQueue.push([provider,method,arguments]);return moduleInstance;};}});};});}/* global: toDebugString: true */function serializeObject(obj){var seen=[];return JSON.stringify(obj,function(key,val){val=toJsonReplacer(key,val);if(isObject(val)){if(seen.indexOf(val)>=0)return'...';seen.push(val);}return val;});}function toDebugString(obj){if(typeof obj==='function'){return obj.toString().replace(/ \{[\s\S]*$/,'');}else if(isUndefined(obj)){return'undefined';}else if(typeof obj!=='string'){return serializeObject(obj);}return obj;}/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  styleDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DocumentProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $$HashMapProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $LocationProvider,
	  $LogProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*//**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */var version={full:'1.4.12',// all of these placeholder strings will be replaced by grunt's
	major:1,// package task
	minor:4,dot:12,codeName:'cultural-conservation'};function publishExternalAPI(angular){extend(angular,{'bootstrap':bootstrap,'copy':copy,'extend':extend,'merge':merge,'equals':equals,'element':jqLite,'forEach':forEach,'injector':createInjector,'noop':noop,'bind':bind,'toJson':toJson,'fromJson':fromJson,'identity':identity,'isUndefined':isUndefined,'isDefined':isDefined,'isString':isString,'isFunction':isFunction,'isObject':isObject,'isNumber':isNumber,'isElement':isElement,'isArray':isArray,'version':version,'isDate':isDate,'lowercase':lowercase,'uppercase':uppercase,'callbacks':{counter:0},'getTestability':getTestability,'$$minErr':minErr,'$$csp':csp,'reloadWithDebugInfo':reloadWithDebugInfo});angularModule=setupModuleLoader(window);angularModule('ng',['ngLocale'],['$provide',function ngModule($provide){// $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	$provide.provider({$$sanitizeUri:$$SanitizeUriProvider});$provide.provider('$compile',$CompileProvider).directive({a:htmlAnchorDirective,input:inputDirective,textarea:inputDirective,form:formDirective,script:scriptDirective,select:selectDirective,style:styleDirective,option:optionDirective,ngBind:ngBindDirective,ngBindHtml:ngBindHtmlDirective,ngBindTemplate:ngBindTemplateDirective,ngClass:ngClassDirective,ngClassEven:ngClassEvenDirective,ngClassOdd:ngClassOddDirective,ngCloak:ngCloakDirective,ngController:ngControllerDirective,ngForm:ngFormDirective,ngHide:ngHideDirective,ngIf:ngIfDirective,ngInclude:ngIncludeDirective,ngInit:ngInitDirective,ngNonBindable:ngNonBindableDirective,ngPluralize:ngPluralizeDirective,ngRepeat:ngRepeatDirective,ngShow:ngShowDirective,ngStyle:ngStyleDirective,ngSwitch:ngSwitchDirective,ngSwitchWhen:ngSwitchWhenDirective,ngSwitchDefault:ngSwitchDefaultDirective,ngOptions:ngOptionsDirective,ngTransclude:ngTranscludeDirective,ngModel:ngModelDirective,ngList:ngListDirective,ngChange:ngChangeDirective,pattern:patternDirective,ngPattern:patternDirective,required:requiredDirective,ngRequired:requiredDirective,minlength:minlengthDirective,ngMinlength:minlengthDirective,maxlength:maxlengthDirective,ngMaxlength:maxlengthDirective,ngValue:ngValueDirective,ngModelOptions:ngModelOptionsDirective}).directive({ngInclude:ngIncludeFillContentDirective}).directive(ngAttributeAliasDirectives).directive(ngEventDirectives);$provide.provider({$anchorScroll:$AnchorScrollProvider,$animate:$AnimateProvider,$animateCss:$CoreAnimateCssProvider,$$animateJs:$$CoreAnimateJsProvider,$$animateQueue:$$CoreAnimateQueueProvider,$$AnimateRunner:$$AnimateRunnerFactoryProvider,$$animateAsyncRun:$$AnimateAsyncRunFactoryProvider,$browser:$BrowserProvider,$cacheFactory:$CacheFactoryProvider,$controller:$ControllerProvider,$document:$DocumentProvider,$exceptionHandler:$ExceptionHandlerProvider,$filter:$FilterProvider,$$forceReflow:$$ForceReflowProvider,$interpolate:$InterpolateProvider,$interval:$IntervalProvider,$http:$HttpProvider,$httpParamSerializer:$HttpParamSerializerProvider,$httpParamSerializerJQLike:$HttpParamSerializerJQLikeProvider,$httpBackend:$HttpBackendProvider,$xhrFactory:$xhrFactoryProvider,$location:$LocationProvider,$log:$LogProvider,$parse:$ParseProvider,$rootScope:$RootScopeProvider,$q:$QProvider,$$q:$$QProvider,$sce:$SceProvider,$sceDelegate:$SceDelegateProvider,$sniffer:$SnifferProvider,$templateCache:$TemplateCacheProvider,$templateRequest:$TemplateRequestProvider,$$testability:$$TestabilityProvider,$timeout:$TimeoutProvider,$window:$WindowProvider,$$rAF:$$RAFProvider,$$jqLite:$$jqLiteProvider,$$HashMap:$$HashMapProvider,$$cookieReader:$$CookieReaderProvider});}]);}/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *//* global JQLitePrototype: true,
	  addEventListenerFn: true,
	  removeEventListenerFn: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true,
	*///////////////////////////////////
	//JQLite
	//////////////////////////////////
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/)
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/)
	 * - [`removeClass()`](http://api.jquery.com/removeClass/)
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/)
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers.
	 * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */JQLite.expando='ng339';var jqCache=JQLite.cache={},jqId=1,addEventListenerFn=function addEventListenerFn(element,type,fn){element.addEventListener(type,fn,false);},removeEventListenerFn=function removeEventListenerFn(element,type,fn){element.removeEventListener(type,fn,false);};/*
	 * !!! This is an undocumented "private" function !!!
	 */JQLite._data=function(node){//jQuery always returns an object on cache miss
	return this.cache[node[this.expando]]||{};};function jqNextId(){return++jqId;}var SPECIAL_CHARS_REGEXP=/([\:\-\_]+(.))/g;var MOZ_HACK_REGEXP=/^moz([A-Z])/;var MOUSE_EVENT_MAP={mouseleave:"mouseout",mouseenter:"mouseover"};var jqLiteMinErr=minErr('jqLite');/**
	 * Converts snake_case to camelCase.
	 * Also there is special case for Moz prefix starting with upper case letter.
	 * @param name Name to normalize
	 */function camelCase(name){return name.replace(SPECIAL_CHARS_REGEXP,function(_,separator,letter,offset){return offset?letter.toUpperCase():letter;}).replace(MOZ_HACK_REGEXP,'Moz$1');}var SINGLE_TAG_REGEXP=/^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;var HTML_REGEXP=/<|&#?\w+;/;var TAG_NAME_REGEXP=/<([\w:-]+)/;var XHTML_TAG_REGEXP=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;var wrapMap={'option':[1,'<select multiple="multiple">','</select>'],'thead':[1,'<table>','</table>'],'col':[2,'<table><colgroup>','</colgroup></table>'],'tr':[2,'<table><tbody>','</tbody></table>'],'td':[3,'<table><tbody><tr>','</tr></tbody></table>'],'_default':[0,"",""]};wrapMap.optgroup=wrapMap.option;wrapMap.tbody=wrapMap.tfoot=wrapMap.colgroup=wrapMap.caption=wrapMap.thead;wrapMap.th=wrapMap.td;function jqLiteIsTextNode(html){return!HTML_REGEXP.test(html);}function jqLiteAcceptsData(node){// The window object can accept data but has no nodeType
	// Otherwise we are only interested in elements (1) and documents (9)
	var nodeType=node.nodeType;return nodeType===NODE_TYPE_ELEMENT||!nodeType||nodeType===NODE_TYPE_DOCUMENT;}function jqLiteHasData(node){for(var key in jqCache[node.ng339]){return true;}return false;}function jqLiteBuildFragment(html,context){var tmp,tag,wrap,fragment=context.createDocumentFragment(),nodes=[],i;if(jqLiteIsTextNode(html)){// Convert non-html into a text node
	nodes.push(context.createTextNode(html));}else{// Convert html into DOM nodes
	tmp=tmp||fragment.appendChild(context.createElement("div"));tag=(TAG_NAME_REGEXP.exec(html)||["",""])[1].toLowerCase();wrap=wrapMap[tag]||wrapMap._default;tmp.innerHTML=wrap[1]+html.replace(XHTML_TAG_REGEXP,"<$1></$2>")+wrap[2];// Descend through wrappers to the right content
	i=wrap[0];while(i--){tmp=tmp.lastChild;}nodes=concat(nodes,tmp.childNodes);tmp=fragment.firstChild;tmp.textContent="";}// Remove wrapper from fragment
	fragment.textContent="";fragment.innerHTML="";// Clear inner HTML
	forEach(nodes,function(node){fragment.appendChild(node);});return fragment;}function jqLiteParseHTML(html,context){context=context||document;var parsed;if(parsed=SINGLE_TAG_REGEXP.exec(html)){return[context.createElement(parsed[1])];}if(parsed=jqLiteBuildFragment(html,context)){return parsed.childNodes;}return[];}function jqLiteWrapNode(node,wrapper){var parent=node.parentNode;if(parent){parent.replaceChild(wrapper,node);}wrapper.appendChild(node);}// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains=Node.prototype.contains||function(arg){// jshint bitwise: false
	return!!(this.compareDocumentPosition(arg)&16);// jshint bitwise: true
	};/////////////////////////////////////////////
	function JQLite(element){if(element instanceof JQLite){return element;}var argIsString;if(isString(element)){element=trim(element);argIsString=true;}if(!(this instanceof JQLite)){if(argIsString&&element.charAt(0)!='<'){throw jqLiteMinErr('nosel','Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');}return new JQLite(element);}if(argIsString){jqLiteAddNodes(this,jqLiteParseHTML(element));}else{jqLiteAddNodes(this,element);}}function jqLiteClone(element){return element.cloneNode(true);}function jqLiteDealoc(element,onlyDescendants){if(!onlyDescendants)jqLiteRemoveData(element);if(element.querySelectorAll){var descendants=element.querySelectorAll('*');for(var i=0,l=descendants.length;i<l;i++){jqLiteRemoveData(descendants[i]);}}}function jqLiteOff(element,type,fn,unsupported){if(isDefined(unsupported))throw jqLiteMinErr('offargs','jqLite#off() does not support the `selector` argument');var expandoStore=jqLiteExpandoStore(element);var events=expandoStore&&expandoStore.events;var handle=expandoStore&&expandoStore.handle;if(!handle)return;//no listeners registered
	if(!type){for(type in events){if(type!=='$destroy'){removeEventListenerFn(element,type,handle);}delete events[type];}}else{var removeHandler=function removeHandler(type){var listenerFns=events[type];if(isDefined(fn)){arrayRemove(listenerFns||[],fn);}if(!(isDefined(fn)&&listenerFns&&listenerFns.length>0)){removeEventListenerFn(element,type,handle);delete events[type];}};forEach(type.split(' '),function(type){removeHandler(type);if(MOUSE_EVENT_MAP[type]){removeHandler(MOUSE_EVENT_MAP[type]);}});}}function jqLiteRemoveData(element,name){var expandoId=element.ng339;var expandoStore=expandoId&&jqCache[expandoId];if(expandoStore){if(name){delete expandoStore.data[name];return;}if(expandoStore.handle){if(expandoStore.events.$destroy){expandoStore.handle({},'$destroy');}jqLiteOff(element);}delete jqCache[expandoId];element.ng339=undefined;// don't delete DOM expandos. IE and Chrome don't like it
	}}function jqLiteExpandoStore(element,createIfNecessary){var expandoId=element.ng339,expandoStore=expandoId&&jqCache[expandoId];if(createIfNecessary&&!expandoStore){element.ng339=expandoId=jqNextId();expandoStore=jqCache[expandoId]={events:{},data:{},handle:undefined};}return expandoStore;}function jqLiteData(element,key,value){if(jqLiteAcceptsData(element)){var isSimpleSetter=isDefined(value);var isSimpleGetter=!isSimpleSetter&&key&&!isObject(key);var massGetter=!key;var expandoStore=jqLiteExpandoStore(element,!isSimpleGetter);var data=expandoStore&&expandoStore.data;if(isSimpleSetter){// data('key', value)
	data[key]=value;}else{if(massGetter){// data()
	return data;}else{if(isSimpleGetter){// data('key')
	// don't force creation of expandoStore if it doesn't exist yet
	return data&&data[key];}else{// mass-setter: data({key1: val1, key2: val2})
	extend(data,key);}}}}}function jqLiteHasClass(element,selector){if(!element.getAttribute)return false;return(" "+(element.getAttribute('class')||'')+" ").replace(/[\n\t]/g," ").indexOf(" "+selector+" ")>-1;}function jqLiteRemoveClass(element,cssClasses){if(cssClasses&&element.setAttribute){forEach(cssClasses.split(' '),function(cssClass){element.setAttribute('class',trim((" "+(element.getAttribute('class')||'')+" ").replace(/[\n\t]/g," ").replace(" "+trim(cssClass)+" "," ")));});}}function jqLiteAddClass(element,cssClasses){if(cssClasses&&element.setAttribute){var existingClasses=(' '+(element.getAttribute('class')||'')+' ').replace(/[\n\t]/g," ");forEach(cssClasses.split(' '),function(cssClass){cssClass=trim(cssClass);if(existingClasses.indexOf(' '+cssClass+' ')===-1){existingClasses+=cssClass+' ';}});element.setAttribute('class',trim(existingClasses));}}function jqLiteAddNodes(root,elements){// THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	if(elements){// if a Node (the most common case)
	if(elements.nodeType){root[root.length++]=elements;}else{var length=elements.length;// if an Array or NodeList and not a Window
	if(typeof length==='number'&&elements.window!==elements){if(length){for(var i=0;i<length;i++){root[root.length++]=elements[i];}}}else{root[root.length++]=elements;}}}}function jqLiteController(element,name){return jqLiteInheritedData(element,'$'+(name||'ngController')+'Controller');}function jqLiteInheritedData(element,name,value){// if element is the document object work with the html element instead
	// this makes $(document).scope() possible
	if(element.nodeType==NODE_TYPE_DOCUMENT){element=element.documentElement;}var names=isArray(name)?name:[name];while(element){for(var i=0,ii=names.length;i<ii;i++){if(isDefined(value=jqLite.data(element,names[i])))return value;}// If dealing with a document fragment node with a host element, and no parent, use the host
	// element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	// to lookup parent controllers.
	element=element.parentNode||element.nodeType===NODE_TYPE_DOCUMENT_FRAGMENT&&element.host;}}function jqLiteEmpty(element){jqLiteDealoc(element,true);while(element.firstChild){element.removeChild(element.firstChild);}}function jqLiteRemove(element,keepData){if(!keepData)jqLiteDealoc(element);var parent=element.parentNode;if(parent)parent.removeChild(element);}function jqLiteDocumentLoaded(action,win){win=win||window;if(win.document.readyState==='complete'){// Force the action to be run async for consistent behaviour
	// from the action's point of view
	// i.e. it will definitely not be in a $apply
	win.setTimeout(action);}else{// No need to unbind this handler as load is only ever called once
	jqLite(win).on('load',action);}}//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype=JQLite.prototype={ready:function ready(fn){var fired=false;function trigger(){if(fired)return;fired=true;fn();}// check if document is already loaded
	if(document.readyState==='complete'){setTimeout(trigger);}else{this.on('DOMContentLoaded',trigger);// works for modern browsers and IE9
	// we can not use jqLite since we are not done loading and jQuery could be loaded later.
	// jshint -W064
	JQLite(window).on('load',trigger);// fallback to window.onload for others
	// jshint +W064
	}},toString:function toString(){var value=[];forEach(this,function(e){value.push(''+e);});return'['+value.join(', ')+']';},eq:function eq(index){return index>=0?jqLite(this[index]):jqLite(this[this.length+index]);},length:0,push:push,sort:[].sort,splice:[].splice};//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR={};forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','),function(value){BOOLEAN_ATTR[lowercase(value)]=value;});var BOOLEAN_ELEMENTS={};forEach('input,select,option,textarea,button,form,details'.split(','),function(value){BOOLEAN_ELEMENTS[value]=true;});var ALIASED_ATTR={'ngMinlength':'minlength','ngMaxlength':'maxlength','ngMin':'min','ngMax':'max','ngPattern':'pattern'};function getBooleanAttrName(element,name){// check dom last since we will most likely fail on name
	var booleanAttr=BOOLEAN_ATTR[name.toLowerCase()];// booleanAttr is here twice to minimize DOM access
	return booleanAttr&&BOOLEAN_ELEMENTS[nodeName_(element)]&&booleanAttr;}function getAliasedAttrName(name){return ALIASED_ATTR[name];}forEach({data:jqLiteData,removeData:jqLiteRemoveData,hasData:jqLiteHasData},function(fn,name){JQLite[name]=fn;});forEach({data:jqLiteData,inheritedData:jqLiteInheritedData,scope:function scope(element){// Can't use jqLiteData here directly so we stay compatible with jQuery!
	return jqLite.data(element,'$scope')||jqLiteInheritedData(element.parentNode||element,['$isolateScope','$scope']);},isolateScope:function isolateScope(element){// Can't use jqLiteData here directly so we stay compatible with jQuery!
	return jqLite.data(element,'$isolateScope')||jqLite.data(element,'$isolateScopeNoTemplate');},controller:jqLiteController,injector:function injector(element){return jqLiteInheritedData(element,'$injector');},removeAttr:function removeAttr(element,name){element.removeAttribute(name);},hasClass:jqLiteHasClass,css:function css(element,name,value){name=camelCase(name);if(isDefined(value)){element.style[name]=value;}else{return element.style[name];}},attr:function attr(element,name,value){var nodeType=element.nodeType;if(nodeType===NODE_TYPE_TEXT||nodeType===NODE_TYPE_ATTRIBUTE||nodeType===NODE_TYPE_COMMENT){return;}var lowercasedName=lowercase(name);if(BOOLEAN_ATTR[lowercasedName]){if(isDefined(value)){if(!!value){element[name]=true;element.setAttribute(name,lowercasedName);}else{element[name]=false;element.removeAttribute(lowercasedName);}}else{return element[name]||(element.attributes.getNamedItem(name)||noop).specified?lowercasedName:undefined;}}else if(isDefined(value)){element.setAttribute(name,value);}else if(element.getAttribute){// the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
	// some elements (e.g. Document) don't have get attribute, so return undefined
	var ret=element.getAttribute(name,2);// normalize non-existing attributes to undefined (as jQuery)
	return ret===null?undefined:ret;}},prop:function prop(element,name,value){if(isDefined(value)){element[name]=value;}else{return element[name];}},text:function(){getText.$dv='';return getText;function getText(element,value){if(isUndefined(value)){var nodeType=element.nodeType;return nodeType===NODE_TYPE_ELEMENT||nodeType===NODE_TYPE_TEXT?element.textContent:'';}element.textContent=value;}}(),val:function val(element,value){if(isUndefined(value)){if(element.multiple&&nodeName_(element)==='select'){var result=[];forEach(element.options,function(option){if(option.selected){result.push(option.value||option.text);}});return result.length===0?null:result;}return element.value;}element.value=value;},html:function html(element,value){if(isUndefined(value)){return element.innerHTML;}jqLiteDealoc(element,true);element.innerHTML=value;},empty:jqLiteEmpty},function(fn,name){/**
	   * Properties: writes return selection, reads return first value
	   */JQLite.prototype[name]=function(arg1,arg2){var i,key;var nodeCount=this.length;// jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	// in a way that survives minification.
	// jqLiteEmpty takes no arguments but is a setter.
	if(fn!==jqLiteEmpty&&isUndefined(fn.length==2&&fn!==jqLiteHasClass&&fn!==jqLiteController?arg1:arg2)){if(isObject(arg1)){// we are a write, but the object properties are the key/values
	for(i=0;i<nodeCount;i++){if(fn===jqLiteData){// data() takes the whole object in jQuery
	fn(this[i],arg1);}else{for(key in arg1){fn(this[i],key,arg1[key]);}}}// return self for chaining
	return this;}else{// we are a read, so read the first child.
	// TODO: do we still need this?
	var value=fn.$dv;// Only if we have $dv do we iterate over all, otherwise it is just the first element.
	var jj=isUndefined(value)?Math.min(nodeCount,1):nodeCount;for(var j=0;j<jj;j++){var nodeValue=fn(this[j],arg1,arg2);value=value?value+nodeValue:nodeValue;}return value;}}else{// we are a write, so apply to all children
	for(i=0;i<nodeCount;i++){fn(this[i],arg1,arg2);}// return self for chaining
	return this;}};});function createEventHandler(element,events){var eventHandler=function eventHandler(event,type){// jQuery specific api
	event.isDefaultPrevented=function(){return event.defaultPrevented;};var eventFns=events[type||event.type];var eventFnsLength=eventFns?eventFns.length:0;if(!eventFnsLength)return;if(isUndefined(event.immediatePropagationStopped)){var originalStopImmediatePropagation=event.stopImmediatePropagation;event.stopImmediatePropagation=function(){event.immediatePropagationStopped=true;if(event.stopPropagation){event.stopPropagation();}if(originalStopImmediatePropagation){originalStopImmediatePropagation.call(event);}};}event.isImmediatePropagationStopped=function(){return event.immediatePropagationStopped===true;};// Some events have special handlers that wrap the real handler
	var handlerWrapper=eventFns.specialHandlerWrapper||defaultHandlerWrapper;// Copy event handlers in case event handlers array is modified during execution.
	if(eventFnsLength>1){eventFns=shallowCopy(eventFns);}for(var i=0;i<eventFnsLength;i++){if(!event.isImmediatePropagationStopped()){handlerWrapper(element,event,eventFns[i]);}}};// TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	//       events on `element`
	eventHandler.elem=element;return eventHandler;}function defaultHandlerWrapper(element,event,handler){handler.call(element,event);}function specialMouseHandlerWrapper(target,event,handler){// Refer to jQuery's implementation of mouseenter & mouseleave
	// Read about mouseenter and mouseleave:
	// http://www.quirksmode.org/js/events_mouse.html#link8
	var related=event.relatedTarget;// For mousenter/leave call the handler if related is outside the target.
	// NB: No relatedTarget if the mouse left/entered the browser window
	if(!related||related!==target&&!jqLiteContains.call(target,related)){handler.call(target,event);}}//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({removeData:jqLiteRemoveData,on:function jqLiteOn(element,type,fn,unsupported){if(isDefined(unsupported))throw jqLiteMinErr('onargs','jqLite#on() does not support the `selector` or `eventData` parameters');// Do not add event handlers to non-elements because they will not be cleaned up.
	if(!jqLiteAcceptsData(element)){return;}var expandoStore=jqLiteExpandoStore(element,true);var events=expandoStore.events;var handle=expandoStore.handle;if(!handle){handle=expandoStore.handle=createEventHandler(element,events);}// http://jsperf.com/string-indexof-vs-split
	var types=type.indexOf(' ')>=0?type.split(' '):[type];var i=types.length;var addHandler=function addHandler(type,specialHandlerWrapper,noEventListener){var eventFns=events[type];if(!eventFns){eventFns=events[type]=[];eventFns.specialHandlerWrapper=specialHandlerWrapper;if(type!=='$destroy'&&!noEventListener){addEventListenerFn(element,type,handle);}}eventFns.push(fn);};while(i--){type=types[i];if(MOUSE_EVENT_MAP[type]){addHandler(MOUSE_EVENT_MAP[type],specialMouseHandlerWrapper);addHandler(type,undefined,true);}else{addHandler(type);}}},off:jqLiteOff,one:function one(element,type,fn){element=jqLite(element);//add the listener twice so that when it is called
	//you can remove the original function and still be
	//able to call element.off(ev, fn) normally
	element.on(type,function onFn(){element.off(type,fn);element.off(type,onFn);});element.on(type,fn);},replaceWith:function replaceWith(element,replaceNode){var index,parent=element.parentNode;jqLiteDealoc(element);forEach(new JQLite(replaceNode),function(node){if(index){parent.insertBefore(node,index.nextSibling);}else{parent.replaceChild(node,element);}index=node;});},children:function children(element){var children=[];forEach(element.childNodes,function(element){if(element.nodeType===NODE_TYPE_ELEMENT){children.push(element);}});return children;},contents:function contents(element){return element.contentDocument||element.childNodes||[];},append:function append(element,node){var nodeType=element.nodeType;if(nodeType!==NODE_TYPE_ELEMENT&&nodeType!==NODE_TYPE_DOCUMENT_FRAGMENT)return;node=new JQLite(node);for(var i=0,ii=node.length;i<ii;i++){var child=node[i];element.appendChild(child);}},prepend:function prepend(element,node){if(element.nodeType===NODE_TYPE_ELEMENT){var index=element.firstChild;forEach(new JQLite(node),function(child){element.insertBefore(child,index);});}},wrap:function wrap(element,wrapNode){jqLiteWrapNode(element,jqLite(wrapNode).eq(0).clone()[0]);},remove:jqLiteRemove,detach:function detach(element){jqLiteRemove(element,true);},after:function after(element,newElement){var index=element,parent=element.parentNode;newElement=new JQLite(newElement);for(var i=0,ii=newElement.length;i<ii;i++){var node=newElement[i];parent.insertBefore(node,index.nextSibling);index=node;}},addClass:jqLiteAddClass,removeClass:jqLiteRemoveClass,toggleClass:function toggleClass(element,selector,condition){if(selector){forEach(selector.split(' '),function(className){var classCondition=condition;if(isUndefined(classCondition)){classCondition=!jqLiteHasClass(element,className);}(classCondition?jqLiteAddClass:jqLiteRemoveClass)(element,className);});}},parent:function parent(element){var parent=element.parentNode;return parent&&parent.nodeType!==NODE_TYPE_DOCUMENT_FRAGMENT?parent:null;},next:function next(element){return element.nextElementSibling;},find:function find(element,selector){if(element.getElementsByTagName){return element.getElementsByTagName(selector);}else{return[];}},clone:jqLiteClone,triggerHandler:function triggerHandler(element,event,extraParameters){var dummyEvent,eventFnsCopy,handlerArgs;var eventName=event.type||event;var expandoStore=jqLiteExpandoStore(element);var events=expandoStore&&expandoStore.events;var eventFns=events&&events[eventName];if(eventFns){// Create a dummy event to pass to the handlers
	dummyEvent={preventDefault:function preventDefault(){this.defaultPrevented=true;},isDefaultPrevented:function isDefaultPrevented(){return this.defaultPrevented===true;},stopImmediatePropagation:function stopImmediatePropagation(){this.immediatePropagationStopped=true;},isImmediatePropagationStopped:function isImmediatePropagationStopped(){return this.immediatePropagationStopped===true;},stopPropagation:noop,type:eventName,target:element};// If a custom event was provided then extend our dummy event with it
	if(event.type){dummyEvent=extend(dummyEvent,event);}// Copy event handlers in case event handlers array is modified during execution.
	eventFnsCopy=shallowCopy(eventFns);handlerArgs=extraParameters?[dummyEvent].concat(extraParameters):[dummyEvent];forEach(eventFnsCopy,function(fn){if(!dummyEvent.isImmediatePropagationStopped()){fn.apply(element,handlerArgs);}});}}},function(fn,name){/**
	   * chaining functions
	   */JQLite.prototype[name]=function(arg1,arg2,arg3){var value;for(var i=0,ii=this.length;i<ii;i++){if(isUndefined(value)){value=fn(this[i],arg1,arg2,arg3);if(isDefined(value)){// any function which returns a value needs to be wrapped
	value=jqLite(value);}}else{jqLiteAddNodes(value,fn(this[i],arg1,arg2,arg3));}}return isDefined(value)?value:this;};// bind legacy bind/unbind to on/off
	JQLite.prototype.bind=JQLite.prototype.on;JQLite.prototype.unbind=JQLite.prototype.off;});// Provider for private $$jqLite service
	function $$jqLiteProvider(){this.$get=function $$jqLite(){return extend(JQLite,{hasClass:function hasClass(node,classes){if(node.attr)node=node[0];return jqLiteHasClass(node,classes);},addClass:function addClass(node,classes){if(node.attr)node=node[0];return jqLiteAddClass(node,classes);},removeClass:function removeClass(node,classes){if(node.attr)node=node[0];return jqLiteRemoveClass(node,classes);}});};}/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */function hashKey(obj,nextUidFn){var key=obj&&obj.$$hashKey;if(key){if(typeof key==='function'){key=obj.$$hashKey();}return key;}var objType=typeof obj==='undefined'?'undefined':_typeof(obj);if(objType=='function'||objType=='object'&&obj!==null){key=obj.$$hashKey=objType+':'+(nextUidFn||nextUid)();}else{key=objType+':'+obj;}return key;}/**
	 * HashMap which can use objects as keys
	 */function HashMap(array,isolatedUid){if(isolatedUid){var uid=0;this.nextUid=function(){return++uid;};}forEach(array,this.put,this);}HashMap.prototype={/**
	   * Store key value pair
	   * @param key key to store can be any type
	   * @param value value to store can be any type
	   */put:function put(key,value){this[hashKey(key,this.nextUid)]=value;},/**
	   * @param key
	   * @returns {Object} the value for the key
	   */get:function get(key){return this[hashKey(key,this.nextUid)];},/**
	   * Remove the key/value pair
	   * @param key
	   */remove:function remove(key){var value=this[key=hashKey(key,this.nextUid)];delete this[key];return value;}};var $$HashMapProvider=[function(){this.$get=[function(){return HashMap;}];}];/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 *//**
	 * @ngdoc module
	 * @name auto
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */var FN_ARGS=/^[^\(]*\(\s*([^\)]*)\)/m;var FN_ARG_SPLIT=/,/;var FN_ARG=/^\s*(_?)(\S+?)\1\s*$/;var STRIP_COMMENTS=/((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;var $injectorMinErr=minErr('$injector');function anonFn(fn){// For anonymous functions, showing at the very least the function signature can help in
	// debugging.
	var fnText=fn.toString().replace(STRIP_COMMENTS,''),args=fnText.match(FN_ARGS);if(args){return'function('+(args[1]||'').replace(/[\s\r\n]+/,' ')+')';}return'fn';}function annotate(fn,strictDi,name){var $inject,fnText,argDecl,last;if(typeof fn==='function'){if(!($inject=fn.$inject)){$inject=[];if(fn.length){if(strictDi){if(!isString(name)||!name){name=fn.name||anonFn(fn);}throw $injectorMinErr('strictdi','{0} is not using explicit annotation and cannot be invoked in strict mode',name);}fnText=fn.toString().replace(STRIP_COMMENTS,'');argDecl=fnText.match(FN_ARGS);forEach(argDecl[1].split(FN_ARG_SPLIT),function(arg){arg.replace(FN_ARG,function(all,underscore,name){$inject.push(name);});});}fn.$inject=$inject;}}else if(isArray(fn)){last=fn.length-1;assertArgFn(fn[last],'fn');$inject=fn.slice(0,last);}else{assertArgFn(fn,'fn',true);}return $inject;}///////////////////////////////////////
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 *//**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 *//**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 *//**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 *//**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 *//**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 *//**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(fn)} - registers a service **factory function**, `fn`,
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(class)} - registers a **constructor function**, `class`
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 *
	 * See the individual methods for more information and examples.
	 *//**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 *//**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 *//**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 *//**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 *//**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 *//**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **service decorator** with the {@link auto.$injector $injector}. A service decorator
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The object returned by the decorator may be the original service, or a new service
	 * object which replaces or wraps and delegates to the original service.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    instantiated and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */function createInjector(modulesToLoad,strictDi){strictDi=strictDi===true;var INSTANTIATING={},providerSuffix='Provider',path=[],loadedModules=new HashMap([],true),providerCache={$provide:{provider:supportObject(provider),factory:supportObject(factory),service:supportObject(service),value:supportObject(value),constant:supportObject(constant),decorator:decorator}},providerInjector=providerCache.$injector=createInternalInjector(providerCache,function(serviceName,caller){if(angular.isString(caller)){path.push(caller);}throw $injectorMinErr('unpr',"Unknown provider: {0}",path.join(' <- '));}),instanceCache={},instanceInjector=instanceCache.$injector=createInternalInjector(instanceCache,function(serviceName,caller){var provider=providerInjector.get(serviceName+providerSuffix,caller);return instanceInjector.invoke(provider.$get,provider,undefined,serviceName);});forEach(loadModules(modulesToLoad),function(fn){if(fn)instanceInjector.invoke(fn);});return instanceInjector;////////////////////////////////////
	// $provider
	////////////////////////////////////
	function supportObject(delegate){return function(key,value){if(isObject(key)){forEach(key,reverseParams(delegate));}else{return delegate(key,value);}};}function provider(name,provider_){assertNotHasOwnProperty(name,'service');if(isFunction(provider_)||isArray(provider_)){provider_=providerInjector.instantiate(provider_);}if(!provider_.$get){throw $injectorMinErr('pget',"Provider '{0}' must define $get factory method.",name);}return providerCache[name+providerSuffix]=provider_;}function enforceReturnValue(name,factory){return function enforcedReturnValue(){var result=instanceInjector.invoke(factory,this);if(isUndefined(result)){throw $injectorMinErr('undef',"Provider '{0}' must return a value from $get factory method.",name);}return result;};}function factory(name,factoryFn,enforce){return provider(name,{$get:enforce!==false?enforceReturnValue(name,factoryFn):factoryFn});}function service(name,constructor){return factory(name,['$injector',function($injector){return $injector.instantiate(constructor);}]);}function value(name,val){return factory(name,valueFn(val),false);}function constant(name,value){assertNotHasOwnProperty(name,'constant');providerCache[name]=value;instanceCache[name]=value;}function decorator(serviceName,decorFn){var origProvider=providerInjector.get(serviceName+providerSuffix),orig$get=origProvider.$get;origProvider.$get=function(){var origInstance=instanceInjector.invoke(orig$get,origProvider);return instanceInjector.invoke(decorFn,null,{$delegate:origInstance});};}////////////////////////////////////
	// Module Loading
	////////////////////////////////////
	function loadModules(modulesToLoad){assertArg(isUndefined(modulesToLoad)||isArray(modulesToLoad),'modulesToLoad','not an array');var runBlocks=[],moduleFn;forEach(modulesToLoad,function(module){if(loadedModules.get(module))return;loadedModules.put(module,true);function runInvokeQueue(queue){var i,ii;for(i=0,ii=queue.length;i<ii;i++){var invokeArgs=queue[i],provider=providerInjector.get(invokeArgs[0]);provider[invokeArgs[1]].apply(provider,invokeArgs[2]);}}try{if(isString(module)){moduleFn=angularModule(module);runBlocks=runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);runInvokeQueue(moduleFn._invokeQueue);runInvokeQueue(moduleFn._configBlocks);}else if(isFunction(module)){runBlocks.push(providerInjector.invoke(module));}else if(isArray(module)){runBlocks.push(providerInjector.invoke(module));}else{assertArgFn(module,'module');}}catch(e){if(isArray(module)){module=module[module.length-1];}if(e.message&&e.stack&&e.stack.indexOf(e.message)==-1){// Safari & FF's stack traces don't contain error.message content
	// unlike those of Chrome and IE
	// So if stack doesn't contain message, we create a new string that contains both.
	// Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	/* jshint -W022 */e=e.message+'\n'+e.stack;}throw $injectorMinErr('modulerr',"Failed to instantiate module {0} due to:\n{1}",module,e.stack||e.message||e);}});return runBlocks;}////////////////////////////////////
	// internal Injector
	////////////////////////////////////
	function createInternalInjector(cache,factory){function getService(serviceName,caller){if(cache.hasOwnProperty(serviceName)){if(cache[serviceName]===INSTANTIATING){throw $injectorMinErr('cdep','Circular dependency found: {0}',serviceName+' <- '+path.join(' <- '));}return cache[serviceName];}else{try{path.unshift(serviceName);cache[serviceName]=INSTANTIATING;return cache[serviceName]=factory(serviceName,caller);}catch(err){if(cache[serviceName]===INSTANTIATING){delete cache[serviceName];}throw err;}finally{path.shift();}}}function invoke(fn,self,locals,serviceName){if(typeof locals==='string'){serviceName=locals;locals=null;}var args=[],$inject=createInjector.$$annotate(fn,strictDi,serviceName),length,i,key;for(i=0,length=$inject.length;i<length;i++){key=$inject[i];if(typeof key!=='string'){throw $injectorMinErr('itkn','Incorrect injection token! Expected service name as string, got {0}',key);}args.push(locals&&locals.hasOwnProperty(key)?locals[key]:getService(key,serviceName));}if(isArray(fn)){fn=fn[length];}// http://jsperf.com/angularjs-invoke-apply-vs-switch
	// #5388
	return fn.apply(self,args);}function instantiate(Type,locals,serviceName){// Check if Type is annotated and use just the given function at n-1 as parameter
	// e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	// Object creation: http://jsperf.com/create-constructor/2
	var instance=Object.create((isArray(Type)?Type[Type.length-1]:Type).prototype||null);var returnedValue=invoke(Type,instance,locals,serviceName);return isObject(returnedValue)||isFunction(returnedValue)?returnedValue:instance;}return{invoke:invoke,instantiate:instantiate,get:getService,annotate:createInjector.$$annotate,has:function has(name){return providerCache.hasOwnProperty(name+providerSuffix)||cache.hasOwnProperty(name);}};}}createInjector.$$annotate=annotate;/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */function $AnchorScrollProvider(){var autoScrollingEnabled=true;/**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */this.disableAutoScrolling=function(){autoScrollingEnabled=false;};/**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function ($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function ($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */this.$get=['$window','$location','$rootScope',function($window,$location,$rootScope){var document=$window.document;// Helper function to get first anchor from a NodeList
	// (using `Array#some()` instead of `angular#forEach()` since it's more performant
	//  and working in all supported browsers.)
	function getFirstAnchor(list){var result=null;Array.prototype.some.call(list,function(element){if(nodeName_(element)==='a'){result=element;return true;}});return result;}function getYOffset(){var offset=scroll.yOffset;if(isFunction(offset)){offset=offset();}else if(isElement(offset)){var elem=offset[0];var style=$window.getComputedStyle(elem);if(style.position!=='fixed'){offset=0;}else{offset=elem.getBoundingClientRect().bottom;}}else if(!isNumber(offset)){offset=0;}return offset;}function scrollTo(elem){if(elem){elem.scrollIntoView();var offset=getYOffset();if(offset){// `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	// This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	// top of the viewport.
	//
	// IF the number of pixels from the top of `elem` to the end of the page's content is less
	// than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	// way down the page.
	//
	// This is often the case for elements near the bottom of the page.
	//
	// In such cases we do not need to scroll the whole `offset` up, just the difference between
	// the top of the element and the offset, which is enough to align the top of `elem` at the
	// desired position.
	var elemTop=elem.getBoundingClientRect().top;$window.scrollBy(0,elemTop-offset);}}else{$window.scrollTo(0,0);}}function scroll(hash){hash=isString(hash)?hash:$location.hash();var elm;// empty hash, scroll to the top of the page
	if(!hash)scrollTo(null);// element with given id
	else if(elm=document.getElementById(hash))scrollTo(elm);// first anchor with given name :-D
	else if(elm=getFirstAnchor(document.getElementsByName(hash)))scrollTo(elm);// no element and hash == 'top', scroll to the top of the page
	else if(hash==='top')scrollTo(null);}// does not scroll when user clicks on anchor link that is currently on
	// (no url change, no $location.hash() change), browser native does scroll
	if(autoScrollingEnabled){$rootScope.$watch(function autoScrollWatch(){return $location.hash();},function autoScrollWatchAction(newVal,oldVal){// skip the initial scroll if $location.hash is empty
	if(newVal===oldVal&&newVal==='')return;jqLiteDocumentLoaded(function(){$rootScope.$evalAsync(scroll);});});}return scroll;}];}var $animateMinErr=minErr('$animate');var ELEMENT_NODE=1;var NG_ANIMATE_CLASSNAME='ng-animate';function mergeClasses(a,b){if(!a&&!b)return'';if(!a)return b;if(!b)return a;if(isArray(a))a=a.join(' ');if(isArray(b))b=b.join(' ');return a+' '+b;}function extractElementNode(element){for(var i=0;i<element.length;i++){var elm=element[i];if(elm.nodeType===ELEMENT_NODE){return elm;}}}function splitClasses(classes){if(isString(classes)){classes=classes.split(' ');}// Use createMap() to prevent class assumptions involving property names in
	// Object.prototype
	var obj=createMap();forEach(classes,function(klass){// sometimes the split leaves empty string values
	// incase extra spaces were applied to the options
	if(klass.length){obj[klass]=true;}});return obj;}// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options){return isObject(options)?options:{};}var $$CoreAnimateJsProvider=function $$CoreAnimateJsProvider(){this.$get=function(){};};// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider=function $$CoreAnimateQueueProvider(){var postDigestQueue=new HashMap();var postDigestElements=[];this.$get=['$$AnimateRunner','$rootScope',function($$AnimateRunner,$rootScope){return{enabled:noop,on:noop,off:noop,pin:noop,push:function push(element,event,options,domOperation){domOperation&&domOperation();options=options||{};options.from&&element.css(options.from);options.to&&element.css(options.to);if(options.addClass||options.removeClass){addRemoveClassesPostDigest(element,options.addClass,options.removeClass);}var runner=new $$AnimateRunner();// jshint ignore:line
	// since there are no animations to run the runner needs to be
	// notified that the animation call is complete.
	runner.complete();return runner;}};function updateData(data,classes,value){var changed=false;if(classes){classes=isString(classes)?classes.split(' '):isArray(classes)?classes:[];forEach(classes,function(className){if(className){changed=true;data[className]=value;}});}return changed;}function handleCSSClassChanges(){forEach(postDigestElements,function(element){var data=postDigestQueue.get(element);if(data){var existing=splitClasses(element.attr('class'));var toAdd='';var toRemove='';forEach(data,function(status,className){var hasClass=!!existing[className];if(status!==hasClass){if(status){toAdd+=(toAdd.length?' ':'')+className;}else{toRemove+=(toRemove.length?' ':'')+className;}}});forEach(element,function(elm){toAdd&&jqLiteAddClass(elm,toAdd);toRemove&&jqLiteRemoveClass(elm,toRemove);});postDigestQueue.remove(element);}});postDigestElements.length=0;}function addRemoveClassesPostDigest(element,add,remove){var data=postDigestQueue.get(element)||{};var classesAdded=updateData(data,add,true);var classesRemoved=updateData(data,remove,false);if(classesAdded||classesRemoved){postDigestQueue.put(element,data);postDigestElements.push(element);if(postDigestElements.length===1){$rootScope.$$postDigest(handleCSSClassChanges);}}}}];};/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */var $AnimateProvider=['$provide',function($provide){var provider=this;this.$$registeredAnimations=Object.create(null);/**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */this.register=function(name,factory){if(name&&name.charAt(0)!=='.'){throw $animateMinErr('notcsel',"Expecting class selector starting with '.' got '{0}'.",name);}var key=name+'-animation';provider.$$registeredAnimations[name.substr(1)]=key;$provide.factory(key,factory);};/**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */this.classNameFilter=function(expression){if(arguments.length===1){this.$$classNameFilter=expression instanceof RegExp?expression:null;if(this.$$classNameFilter){var reservedRegex=new RegExp("(\\s+|\\/)"+NG_ANIMATE_CLASSNAME+"(\\s+|\\/)");if(reservedRegex.test(this.$$classNameFilter.toString())){throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.',NG_ANIMATE_CLASSNAME);}}}return this.$$classNameFilter;};this.$get=['$$animateQueue',function($$animateQueue){function domInsert(element,parentElement,afterElement){// if for some reason the previous element was removed
	// from the dom sometime before this code runs then let's
	// just stick to using the parent element as the anchor
	if(afterElement){var afterNode=extractElementNode(afterElement);if(afterNode&&!afterNode.parentNode&&!afterNode.previousElementSibling){afterElement=null;}}afterElement?afterElement.after(element):parentElement.prepend(element);}/**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */return{// we don't call it directly since non-existant arguments may
	// be interpreted as null within the sub enabled function
	/**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */on:$$animateQueue.on,/**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `listenerFn` that is set
	       * // to listen for `enter` on the given `element` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string} event the animation event (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */off:$$animateQueue.off,/**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */pin:$$animateQueue.pin,/**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */enabled:$$animateQueue.enabled,/**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */cancel:function cancel(runner){runner.end&&runner.end();},/**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */enter:function enter(element,parent,after,options){parent=parent&&jqLite(parent);after=after&&jqLite(after);parent=parent||after.parent();domInsert(element,parent,after);return $$animateQueue.push(element,'enter',prepareAnimateOptions(options));},/**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */move:function move(element,parent,after,options){parent=parent&&jqLite(parent);after=after&&jqLite(after);parent=parent||after.parent();domInsert(element,parent,after);return $$animateQueue.push(element,'move',prepareAnimateOptions(options));},/**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */leave:function leave(element,options){return $$animateQueue.push(element,'leave',prepareAnimateOptions(options),function(){element.remove();});},/**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */addClass:function addClass(element,className,options){options=prepareAnimateOptions(options);options.addClass=mergeClasses(options.addclass,className);return $$animateQueue.push(element,'addClass',options);},/**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */removeClass:function removeClass(element,className,options){options=prepareAnimateOptions(options);options.removeClass=mergeClasses(options.removeClass,className);return $$animateQueue.push(element,'removeClass',options);},/**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */setClass:function setClass(element,add,remove,options){options=prepareAnimateOptions(options);options.addClass=mergeClasses(options.addClass,add);options.removeClass=mergeClasses(options.removeClass,remove);return $$animateQueue.push(element,'setClass',options);},/**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be appplied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */animate:function animate(element,from,to,className,options){options=prepareAnimateOptions(options);options.from=options.from?extend(options.from,from):from;options.to=options.to?extend(options.to,to):to;className=className||'ng-inline-animate';options.tempClasses=mergeClasses(options.tempClasses,className);return $$animateQueue.push(element,'animate',options);}};}];}];var $$AnimateAsyncRunFactoryProvider=function $$AnimateAsyncRunFactoryProvider(){this.$get=['$$rAF',function($$rAF){var waitQueue=[];function waitForTick(fn){waitQueue.push(fn);if(waitQueue.length>1)return;$$rAF(function(){for(var i=0;i<waitQueue.length;i++){waitQueue[i]();}waitQueue=[];});}return function(){var passed=false;waitForTick(function(){passed=true;});return function(callback){passed?callback():waitForTick(callback);};};}];};var $$AnimateRunnerFactoryProvider=function $$AnimateRunnerFactoryProvider(){this.$get=['$q','$sniffer','$$animateAsyncRun','$document','$timeout',function($q,$sniffer,$$animateAsyncRun,$document,$timeout){var INITIAL_STATE=0;var DONE_PENDING_STATE=1;var DONE_COMPLETE_STATE=2;AnimateRunner.chain=function(chain,callback){var index=0;next();function next(){if(index===chain.length){callback(true);return;}chain[index](function(response){if(response===false){callback(false);return;}index++;next();});}};AnimateRunner.all=function(runners,callback){var count=0;var status=true;forEach(runners,function(runner){runner.done(onProgress);});function onProgress(response){status=status&&response;if(++count===runners.length){callback(status);}}};function AnimateRunner(host){this.setHost(host);var rafTick=$$animateAsyncRun();var timeoutTick=function timeoutTick(fn){$timeout(fn,0,false);};this._doneCallbacks=[];this._tick=function(fn){var doc=$document[0];// the document may not be ready or attached
	// to the module for some internal tests
	if(doc&&doc.hidden){timeoutTick(fn);}else{rafTick(fn);}};this._state=0;}AnimateRunner.prototype={setHost:function setHost(host){this.host=host||{};},done:function done(fn){if(this._state===DONE_COMPLETE_STATE){fn();}else{this._doneCallbacks.push(fn);}},progress:noop,getPromise:function getPromise(){if(!this.promise){var self=this;this.promise=$q(function(resolve,reject){self.done(function(status){status===false?reject():resolve();});});}return this.promise;},then:function then(resolveHandler,rejectHandler){return this.getPromise().then(resolveHandler,rejectHandler);},'catch':function _catch(handler){return this.getPromise()['catch'](handler);},'finally':function _finally(handler){return this.getPromise()['finally'](handler);},pause:function pause(){if(this.host.pause){this.host.pause();}},resume:function resume(){if(this.host.resume){this.host.resume();}},end:function end(){if(this.host.end){this.host.end();}this._resolve(true);},cancel:function cancel(){if(this.host.cancel){this.host.cancel();}this._resolve(false);},complete:function complete(response){var self=this;if(self._state===INITIAL_STATE){self._state=DONE_PENDING_STATE;self._tick(function(){self._resolve(response);});}},_resolve:function _resolve(response){if(this._state!==DONE_COMPLETE_STATE){forEach(this._doneCallbacks,function(fn){fn(response);});this._doneCallbacks.length=0;this._state=DONE_COMPLETE_STATE;}}};return AnimateRunner;}];};/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */var $CoreAnimateCssProvider=function $CoreAnimateCssProvider(){this.$get=['$$rAF','$q','$$AnimateRunner',function($$rAF,$q,$$AnimateRunner){return function(element,initialOptions){// all of the animation functions should create
	// a copy of the options data, however, if a
	// parent service has already created a copy then
	// we should stick to using that
	var options=initialOptions||{};if(!options.$$prepared){options=copy(options);}// there is no point in applying the styles since
	// there is no animation that goes on at all in
	// this version of $animateCss.
	if(options.cleanupStyles){options.from=options.to=null;}if(options.from){element.css(options.from);options.from=null;}/* jshint newcap: false*/var closed,runner=new $$AnimateRunner();return{start:run,end:run};function run(){$$rAF(function(){applyAnimationContents();if(!closed){runner.complete();}closed=true;});return runner;}function applyAnimationContents(){if(options.addClass){element.addClass(options.addClass);options.addClass=null;}if(options.removeClass){element.removeClass(options.removeClass);options.removeClass=null;}if(options.to){element.css(options.to);options.to=null;}}};}];};/* global stripHash: true *//**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 *//**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */function Browser(window,document,$log,$sniffer){var self=this,rawDocument=document[0],location=window.location,history=window.history,setTimeout=window.setTimeout,clearTimeout=window.clearTimeout,pendingDeferIds={};self.isMock=false;var outstandingRequestCount=0;var outstandingRequestCallbacks=[];// TODO(vojta): remove this temporary api
	self.$$completeOutstandingRequest=completeOutstandingRequest;self.$$incOutstandingRequestCount=function(){outstandingRequestCount++;};/**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */function completeOutstandingRequest(fn){try{fn.apply(null,sliceArgs(arguments,1));}finally{outstandingRequestCount--;if(outstandingRequestCount===0){while(outstandingRequestCallbacks.length){try{outstandingRequestCallbacks.pop()();}catch(e){$log.error(e);}}}}}function getHash(url){var index=url.indexOf('#');return index===-1?'':url.substr(index);}/**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */self.notifyWhenNoOutstandingRequests=function(callback){if(outstandingRequestCount===0){callback();}else{outstandingRequestCallbacks.push(callback);}};//////////////////////////////////////////////////////////////
	// URL API
	//////////////////////////////////////////////////////////////
	var cachedState,lastHistoryState,lastBrowserUrl=location.href,baseElement=document.find('base'),pendingLocation=null;cacheState();lastHistoryState=cachedState;/**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */self.url=function(url,replace,state){// In modern browsers `history.state` is `null` by default; treating it separately
	// from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	// to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	if(isUndefined(state)){state=null;}// Android Browser BFCache causes location, history reference to become stale.
	if(location!==window.location)location=window.location;if(history!==window.history)history=window.history;// setter
	if(url){var sameState=lastHistoryState===state;// Don't change anything if previous and current URLs and states match. This also prevents
	// IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	// See https://github.com/angular/angular.js/commit/ffb2701
	if(lastBrowserUrl===url&&(!$sniffer.history||sameState)){return self;}var sameBase=lastBrowserUrl&&stripHash(lastBrowserUrl)===stripHash(url);lastBrowserUrl=url;lastHistoryState=state;// Don't use history API if only the hash changed
	// due to a bug in IE10/IE11 which leads
	// to not firing a `hashchange` nor `popstate` event
	// in some cases (see #9143).
	if($sniffer.history&&(!sameBase||!sameState)){history[replace?'replaceState':'pushState'](state,'',url);cacheState();// Do the assignment again so that those two variables are referentially identical.
	lastHistoryState=cachedState;}else{if(!sameBase||pendingLocation){pendingLocation=url;}if(replace){location.replace(url);}else if(!sameBase){location.href=url;}else{location.hash=getHash(url);}if(location.href!==url){pendingLocation=url;}}return self;// getter
	}else{// - pendingLocation is needed as browsers don't allow to read out
	//   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	//   https://openradar.appspot.com/22186109).
	// - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	return pendingLocation||location.href.replace(/%27/g,"'");}};/**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */self.state=function(){return cachedState;};var urlChangeListeners=[],urlChangeInit=false;function cacheStateAndFireUrlChange(){pendingLocation=null;cacheState();fireUrlChange();}function getCurrentState(){try{return history.state;}catch(e){// MSIE can reportedly throw when there is no state (UNCONFIRMED).
	}}// This variable should be used *only* inside the cacheState function.
	var lastCachedState=null;function cacheState(){// This should be the only place in $browser where `history.state` is read.
	cachedState=getCurrentState();cachedState=isUndefined(cachedState)?null:cachedState;// Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	if(equals(cachedState,lastCachedState)){cachedState=lastCachedState;}lastCachedState=cachedState;}function fireUrlChange(){if(lastBrowserUrl===self.url()&&lastHistoryState===cachedState){return;}lastBrowserUrl=self.url();lastHistoryState=cachedState;forEach(urlChangeListeners,function(listener){listener(self.url(),cachedState);});}/**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */self.onUrlChange=function(callback){// TODO(vojta): refactor to use node's syntax for events
	if(!urlChangeInit){// We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
	// don't fire popstate when user change the address bar and don't fire hashchange when url
	// changed by push/replaceState
	// html5 history api - popstate event
	if($sniffer.history)jqLite(window).on('popstate',cacheStateAndFireUrlChange);// hashchange event
	jqLite(window).on('hashchange',cacheStateAndFireUrlChange);urlChangeInit=true;}urlChangeListeners.push(callback);return callback;};/**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */self.$$applicationDestroyed=function(){jqLite(window).off('hashchange popstate',cacheStateAndFireUrlChange);};/**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */self.$$checkUrlChange=fireUrlChange;//////////////////////////////////////////////////////////////
	// Misc API
	//////////////////////////////////////////////////////////////
	/**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */self.baseHref=function(){var href=baseElement.attr('href');return href?href.replace(/^(https?\:)?\/\/[^\/]*/,''):'';};/**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */self.defer=function(fn,delay){var timeoutId;outstandingRequestCount++;timeoutId=setTimeout(function(){delete pendingDeferIds[timeoutId];completeOutstandingRequest(fn);},delay||0);pendingDeferIds[timeoutId]=true;return timeoutId;};/**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */self.defer.cancel=function(deferId){if(pendingDeferIds[deferId]){delete pendingDeferIds[deferId];clearTimeout(deferId);completeOutstandingRequest(noop);return true;}return false;};}function $BrowserProvider(){this.$get=['$window','$log','$sniffer','$document',function($window,$log,$sniffer,$document){return new Browser($window,$document,$log,$sniffer);}];}/**
	 * @ngdoc service
	 * @name $cacheFactory
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */function $CacheFactoryProvider(){this.$get=function(){var caches={};function cacheFactory(cacheId,options){if(cacheId in caches){throw minErr('$cacheFactory')('iid',"CacheId '{0}' is already taken!",cacheId);}var size=0,stats=extend({},options,{id:cacheId}),data=createMap(),capacity=options&&options.capacity||Number.MAX_VALUE,lruHash=createMap(),freshEnd=null,staleEnd=null;/**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */return caches[cacheId]={/**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */put:function put(key,value){if(isUndefined(value))return;if(capacity<Number.MAX_VALUE){var lruEntry=lruHash[key]||(lruHash[key]={key:key});refresh(lruEntry);}if(!(key in data))size++;data[key]=value;if(size>capacity){this.remove(staleEnd.key);}return value;},/**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */get:function get(key){if(capacity<Number.MAX_VALUE){var lruEntry=lruHash[key];if(!lruEntry)return;refresh(lruEntry);}return data[key];},/**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */remove:function remove(key){if(capacity<Number.MAX_VALUE){var lruEntry=lruHash[key];if(!lruEntry)return;if(lruEntry==freshEnd)freshEnd=lruEntry.p;if(lruEntry==staleEnd)staleEnd=lruEntry.n;link(lruEntry.n,lruEntry.p);delete lruHash[key];}if(!(key in data))return;delete data[key];size--;},/**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */removeAll:function removeAll(){data=createMap();size=0;lruHash=createMap();freshEnd=staleEnd=null;},/**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */destroy:function destroy(){data=null;stats=null;lruHash=null;delete caches[cacheId];},/**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */info:function info(){return extend({},stats,{size:size});}};/**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */function refresh(entry){if(entry!=freshEnd){if(!staleEnd){staleEnd=entry;}else if(staleEnd==entry){staleEnd=entry.n;}link(entry.n,entry.p);link(entry,freshEnd);freshEnd=entry;freshEnd.n=null;}}/**
	       * bidirectionally links two entries of the LRU linked list
	       */function link(nextEntry,prevEntry){if(nextEntry!=prevEntry){if(nextEntry)nextEntry.p=prevEntry;//p stands for previous, 'prev' didn't minify
	if(prevEntry)prevEntry.n=nextEntry;//n stands for next, 'next' didn't minify
	}}}/**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */cacheFactory.info=function(){var info={};forEach(caches,function(cache,cacheId){info[cacheId]=cache.info();});return info;};/**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */cacheFactory.get=function(cacheId){return caches[cacheId];};return cacheFactory;};}/**
	 * @ngdoc service
	 * @name $templateCache
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your HTML:
	 * ```html
	 * <div ng-include=" 'templateId.html' "></div>
	 * ```
	 *
	 * or get it via Javascript:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */function $TemplateCacheProvider(){this.$get=['$cacheFactory',function($cacheFactory){return $cacheFactory('templates');}];}/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *//* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 *//**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a "Directive Definition Object" (see below) that defines the directive properties,
	 * or just the `postLink` function (all other properties will have the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       priority: 0,
	 *       template: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // templateUrl: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       transclude: false,
	 *       restrict: 'A',
	 *       templateNamespace: 'html',
	 *       scope: false,
	 *       controller: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       controllerAs: 'stringIdentifier',
	 *       bindToController: false,
	 *       require: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       compile: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *           pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *           post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // link: {
	 *       //  pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // link: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true, the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioural (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `true`, an object or a falsy value:
	 *
	 * * **falsy:** No scope will be created for the directive. The directive will use its parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created. The new scope rule does not apply for the root of the template
	 * since the root of the template always gets a new scope.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's element. The
	 * 'isolate' scope differs from normal scope in that it does not prototypically inherit from its parent
	 * scope. This is useful when creating reusable components, which should not accidentally read or modify
	 * data in the parent scope.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property. Additionally, a controller
	 * alias must be set, either by using `controllerAs: 'myAlias'` or by specifying the alias in the controller
	 * definition: `controller: 'myCtrl as myAlias'`.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope. When the controller
	 * is instantiated, the initial values of the isolate scope bindings are already available.
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement)`.
	 *    * `scope`: optional argument to override the scope.
	 *    * `cloneLinkingFn`: optional argument to create clones of the original transcluded content.
	 *    * `futureParentElement`:
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkinFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` takes a string name (or array of strings) of the directive(s) to pass in. If an array is used, the
	 * injected argument will be an array in corresponding order. If no such directive can be
	 * found, or if the directive does not have a controller, then an error is raised (unless no link function
	 * is specified, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 * There are two kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element or the entire element:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude`
	 *     parameter of directive controllers, see there for details.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, to which the clone is bound.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a translude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 */var $compileMinErr=minErr('$compile');/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */$CompileProvider.$inject=['$provide','$$sanitizeUriProvider'];function $CompileProvider($provide,$$sanitizeUriProvider){var hasDirectives={},Suffix='Directive',COMMENT_DIRECTIVE_REGEXP=/^\s*directive\:\s*([\w\-]+)\s+(.*)$/,CLASS_DIRECTIVE_REGEXP=/(([\w\-]+)(?:\:([^;]+))?;?)/,ALL_OR_NOTHING_ATTRS=makeMap('ngSrc,ngSrcset,src,srcset'),REQUIRE_PREFIX_REGEXP=/^(?:(\^\^?)?(\?)?(\^\^?)?)?/;// Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	// The assumption is that future DOM event attribute names will begin with
	// 'on' and be composed of only English letters.
	var EVENT_HANDLER_ATTR_REGEXP=/^(on[a-z]+|formaction)$/;var bindingCache=createMap();function parseIsolateBindings(scope,directiveName,isController){var LOCAL_REGEXP=/^\s*([@&]|=(\*?))(\??)\s*(\w*)\s*$/;var bindings=createMap();forEach(scope,function(definition,scopeName){if(definition in bindingCache){bindings[scopeName]=bindingCache[definition];return;}var match=definition.match(LOCAL_REGEXP);if(!match){throw $compileMinErr('iscp',"Invalid {3} for directive '{0}'."+" Definition: {... {1}: '{2}' ...}",directiveName,scopeName,definition,isController?"controller bindings definition":"isolate scope definition");}bindings[scopeName]={mode:match[1][0],collection:match[2]==='*',optional:match[3]==='?',attrName:match[4]||scopeName};if(match[4]){bindingCache[definition]=bindings[scopeName];}});return bindings;}function parseDirectiveBindings(directive,directiveName){var bindings={isolateScope:null,bindToController:null};if(isObject(directive.scope)){if(directive.bindToController===true){bindings.bindToController=parseIsolateBindings(directive.scope,directiveName,true);bindings.isolateScope={};}else{bindings.isolateScope=parseIsolateBindings(directive.scope,directiveName,false);}}if(isObject(directive.bindToController)){bindings.bindToController=parseIsolateBindings(directive.bindToController,directiveName,true);}if(isObject(bindings.bindToController)){var controller=directive.controller;var controllerAs=directive.controllerAs;if(!controller){// There is no controller, there may or may not be a controllerAs property
	throw $compileMinErr('noctrl',"Cannot bind to controller without directive '{0}'s controller.",directiveName);}else if(!identifierForController(controller,controllerAs)){// There is a controller, but no identifier or controllerAs property
	throw $compileMinErr('noident',"Cannot bind to controller without identifier for directive '{0}'.",directiveName);}}return bindings;}function assertValidDirectiveName(name){var letter=name.charAt(0);if(!letter||letter!==lowercase(letter)){throw $compileMinErr('baddir',"Directive name '{0}' is invalid. The first character must be a lowercase letter",name);}if(name!==name.trim()){throw $compileMinErr('baddir',"Directive name '{0}' is invalid. The name should not contain leading or trailing whitespaces",name);}}/**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See
	   *    {@link guide/directive} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */this.directive=function registerDirective(name,directiveFactory){assertNotHasOwnProperty(name,'directive');if(isString(name)){assertValidDirectiveName(name);assertArg(directiveFactory,'directiveFactory');if(!hasDirectives.hasOwnProperty(name)){hasDirectives[name]=[];$provide.factory(name+Suffix,['$injector','$exceptionHandler',function($injector,$exceptionHandler){var directives=[];forEach(hasDirectives[name],function(directiveFactory,index){try{var directive=$injector.invoke(directiveFactory);if(isFunction(directive)){directive={compile:valueFn(directive)};}else if(!directive.compile&&directive.link){directive.compile=valueFn(directive.link);}directive.priority=directive.priority||0;directive.index=index;directive.name=directive.name||name;directive.require=directive.require||directive.controller&&directive.name;directive.restrict=directive.restrict||'EA';directive.$$moduleName=directiveFactory.$$moduleName;directives.push(directive);}catch(e){$exceptionHandler(e);}});return directives;}]);}hasDirectives[name].push(directiveFactory);}else{forEach(name,reverseParams(registerDirective));}return this;};/**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */this.aHrefSanitizationWhitelist=function(regexp){if(isDefined(regexp)){$$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);return this;}else{return $$sanitizeUriProvider.aHrefSanitizationWhitelist();}};/**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */this.imgSrcSanitizationWhitelist=function(regexp){if(isDefined(regexp)){$$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);return this;}else{return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();}};/**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */var debugInfoEnabled=true;this.debugInfoEnabled=function(enabled){if(isDefined(enabled)){debugInfoEnabled=enabled;return this;}return debugInfoEnabled;};this.$get=['$injector','$interpolate','$exceptionHandler','$templateRequest','$parse','$controller','$rootScope','$sce','$animate','$$sanitizeUri',function($injector,$interpolate,$exceptionHandler,$templateRequest,$parse,$controller,$rootScope,$sce,$animate,$$sanitizeUri){var Attributes=function Attributes(element,attributesToCopy){if(attributesToCopy){var keys=Object.keys(attributesToCopy);var i,l,key;for(i=0,l=keys.length;i<l;i++){key=keys[i];this[key]=attributesToCopy[key];}}else{this.$attr={};}this.$$element=element;};Attributes.prototype={/**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */$normalize:directiveNormalize,/**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */$addClass:function $addClass(classVal){if(classVal&&classVal.length>0){$animate.addClass(this.$$element,classVal);}},/**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */$removeClass:function $removeClass(classVal){if(classVal&&classVal.length>0){$animate.removeClass(this.$$element,classVal);}},/**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */$updateClass:function $updateClass(newClasses,oldClasses){var toAdd=tokenDifference(newClasses,oldClasses);if(toAdd&&toAdd.length){$animate.addClass(this.$$element,toAdd);}var toRemove=tokenDifference(oldClasses,newClasses);if(toRemove&&toRemove.length){$animate.removeClass(this.$$element,toRemove);}},/**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */$set:function $set(key,value,writeAttr,attrName){// TODO: decide whether or not to throw an error if "class"
	//is set through this function since it may cause $updateClass to
	//become unstable.
	var node=this.$$element[0],booleanKey=getBooleanAttrName(node,key),aliasedKey=getAliasedAttrName(key),observer=key,nodeName;if(booleanKey){this.$$element.prop(key,value);attrName=booleanKey;}else if(aliasedKey){this[aliasedKey]=value;observer=aliasedKey;}this[key]=value;// translate normalized key to actual key
	if(attrName){this.$attr[key]=attrName;}else{attrName=this.$attr[key];if(!attrName){this.$attr[key]=attrName=snake_case(key,'-');}}nodeName=nodeName_(this.$$element);if(nodeName==='a'&&key==='href'||nodeName==='img'&&key==='src'){// sanitize a[href] and img[src] values
	this[key]=value=$$sanitizeUri(value,key==='src');}else if(nodeName==='img'&&key==='srcset'&&isDefined(value)){// sanitize img[srcset] values
	var result="";// first check if there are spaces because it's not the same pattern
	var trimmedSrcset=trim(value);//                (   999x   ,|   999w   ,|   ,|,   )
	var srcPattern=/(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;var pattern=/\s/.test(trimmedSrcset)?srcPattern:/(,)/;// split srcset into tuple of uri and descriptor except for the last item
	var rawUris=trimmedSrcset.split(pattern);// for each tuples
	var nbrUrisWith2parts=Math.floor(rawUris.length/2);for(var i=0;i<nbrUrisWith2parts;i++){var innerIdx=i*2;// sanitize the uri
	result+=$$sanitizeUri(trim(rawUris[innerIdx]),true);// add the descriptor
	result+=" "+trim(rawUris[innerIdx+1]);}// split the last item into uri and descriptor
	var lastTuple=trim(rawUris[i*2]).split(/\s/);// sanitize the last uri
	result+=$$sanitizeUri(trim(lastTuple[0]),true);// and add the last descriptor if any
	if(lastTuple.length===2){result+=" "+trim(lastTuple[1]);}this[key]=value=result;}if(writeAttr!==false){if(value===null||isUndefined(value)){this.$$element.removeAttr(attrName);}else{this.$$element.attr(attrName,value);}}// fire observers
	var $$observers=this.$$observers;$$observers&&forEach($$observers[observer],function(fn){try{fn(value);}catch(e){$exceptionHandler(e);}});},/**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */$observe:function $observe(key,fn){var attrs=this,$$observers=attrs.$$observers||(attrs.$$observers=createMap()),listeners=$$observers[key]||($$observers[key]=[]);listeners.push(fn);$rootScope.$evalAsync(function(){if(!listeners.$$inter&&attrs.hasOwnProperty(key)&&!isUndefined(attrs[key])){// no one registered attribute interpolation function, so lets call it manually
	fn(attrs[key]);}});return function(){arrayRemove(listeners,fn);};}};function safeAddClass($element,className){try{$element.addClass(className);}catch(e){// ignore, since it means that we are trying to set class on
	// SVG element, where class name is read-only.
	}}var startSymbol=$interpolate.startSymbol(),endSymbol=$interpolate.endSymbol(),denormalizeTemplate=startSymbol=='{{'&&endSymbol=='}}'?identity:function denormalizeTemplate(template){return template.replace(/\{\{/g,startSymbol).replace(/}}/g,endSymbol);},NG_ATTR_BINDING=/^ngAttr[A-Z]/;var MULTI_ELEMENT_DIR_RE=/^(.+)Start$/;compile.$$addBindingInfo=debugInfoEnabled?function $$addBindingInfo($element,binding){var bindings=$element.data('$binding')||[];if(isArray(binding)){bindings=bindings.concat(binding);}else{bindings.push(binding);}$element.data('$binding',bindings);}:noop;compile.$$addBindingClass=debugInfoEnabled?function $$addBindingClass($element){safeAddClass($element,'ng-binding');}:noop;compile.$$addScopeInfo=debugInfoEnabled?function $$addScopeInfo($element,scope,isolated,noTemplate){var dataName=isolated?noTemplate?'$isolateScopeNoTemplate':'$isolateScope':'$scope';$element.data(dataName,scope);}:noop;compile.$$addScopeClass=debugInfoEnabled?function $$addScopeClass($element,isolated){safeAddClass($element,isolated?'ng-isolate-scope':'ng-scope');}:noop;return compile;//================================
	function compile($compileNodes,transcludeFn,maxPriority,ignoreDirective,previousCompileContext){if(!($compileNodes instanceof jqLite)){// jquery always rewraps, whereas we need to preserve the original selector so that we can
	// modify it.
	$compileNodes=jqLite($compileNodes);}var NOT_EMPTY=/\S+/;// We can not compile top level text elements since text nodes can be merged and we will
	// not be able to attach scope data to them, so we will wrap them in <span>
	for(var i=0,len=$compileNodes.length;i<len;i++){var domNode=$compileNodes[i];if(domNode.nodeType===NODE_TYPE_TEXT&&domNode.nodeValue.match(NOT_EMPTY)/* non-empty */){jqLiteWrapNode(domNode,$compileNodes[i]=document.createElement('span'));}}var compositeLinkFn=compileNodes($compileNodes,transcludeFn,$compileNodes,maxPriority,ignoreDirective,previousCompileContext);compile.$$addScopeClass($compileNodes);var namespace=null;return function publicLinkFn(scope,cloneConnectFn,options){assertArg(scope,'scope');if(previousCompileContext&&previousCompileContext.needsNewScope){// A parent directive did a replace and a directive on this element asked
	// for transclusion, which caused us to lose a layer of element on which
	// we could hold the new transclusion scope, so we will create it manually
	// here.
	scope=scope.$parent.$new();}options=options||{};var parentBoundTranscludeFn=options.parentBoundTranscludeFn,transcludeControllers=options.transcludeControllers,futureParentElement=options.futureParentElement;// When `parentBoundTranscludeFn` is passed, it is a
	// `controllersBoundTransclude` function (it was previously passed
	// as `transclude` to directive.link) so we must unwrap it to get
	// its `boundTranscludeFn`
	if(parentBoundTranscludeFn&&parentBoundTranscludeFn.$$boundTransclude){parentBoundTranscludeFn=parentBoundTranscludeFn.$$boundTransclude;}if(!namespace){namespace=detectNamespaceForChildElements(futureParentElement);}var $linkNode;if(namespace!=='html'){// When using a directive with replace:true and templateUrl the $compileNodes
	// (or a child element inside of them)
	// might change, so we need to recreate the namespace adapted compileNodes
	// for call to the link function.
	// Note: This will already clone the nodes...
	$linkNode=jqLite(wrapTemplate(namespace,jqLite('<div>').append($compileNodes).html()));}else if(cloneConnectFn){// important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	// and sometimes changes the structure of the DOM.
	$linkNode=JQLitePrototype.clone.call($compileNodes);}else{$linkNode=$compileNodes;}if(transcludeControllers){for(var controllerName in transcludeControllers){$linkNode.data('$'+controllerName+'Controller',transcludeControllers[controllerName].instance);}}compile.$$addScopeInfo($linkNode,scope);if(cloneConnectFn)cloneConnectFn($linkNode,scope);if(compositeLinkFn)compositeLinkFn(scope,$linkNode,$linkNode,parentBoundTranscludeFn);return $linkNode;};}function detectNamespaceForChildElements(parentElement){// TODO: Make this detect MathML as well...
	var node=parentElement&&parentElement[0];if(!node){return'html';}else{return nodeName_(node)!=='foreignobject'&&node.toString().match(/SVG/)?'svg':'html';}}/**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */function compileNodes(nodeList,transcludeFn,$rootElement,maxPriority,ignoreDirective,previousCompileContext){var linkFns=[],attrs,directives,nodeLinkFn,childNodes,childLinkFn,linkFnFound,nodeLinkFnFound;for(var i=0;i<nodeList.length;i++){attrs=new Attributes();// we must always refer to nodeList[i] since the nodes can be replaced underneath us.
	directives=collectDirectives(nodeList[i],[],attrs,i===0?maxPriority:undefined,ignoreDirective);nodeLinkFn=directives.length?applyDirectivesToNode(directives,nodeList[i],attrs,transcludeFn,$rootElement,null,[],[],previousCompileContext):null;if(nodeLinkFn&&nodeLinkFn.scope){compile.$$addScopeClass(attrs.$$element);}childLinkFn=nodeLinkFn&&nodeLinkFn.terminal||!(childNodes=nodeList[i].childNodes)||!childNodes.length?null:compileNodes(childNodes,nodeLinkFn?(nodeLinkFn.transcludeOnThisElement||!nodeLinkFn.templateOnThisElement)&&nodeLinkFn.transclude:transcludeFn);if(nodeLinkFn||childLinkFn){linkFns.push(i,nodeLinkFn,childLinkFn);linkFnFound=true;nodeLinkFnFound=nodeLinkFnFound||nodeLinkFn;}//use the previous context only for the first element in the virtual group
	previousCompileContext=null;}// return a linking function if we have found anything, null otherwise
	return linkFnFound?compositeLinkFn:null;function compositeLinkFn(scope,nodeList,$rootElement,parentBoundTranscludeFn){var nodeLinkFn,childLinkFn,node,childScope,i,ii,idx,childBoundTranscludeFn;var stableNodeList;if(nodeLinkFnFound){// copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	// offsets don't get screwed up
	var nodeListLength=nodeList.length;stableNodeList=new Array(nodeListLength);// create a sparse array by only copying the elements which have a linkFn
	for(i=0;i<linkFns.length;i+=3){idx=linkFns[i];stableNodeList[idx]=nodeList[idx];}}else{stableNodeList=nodeList;}for(i=0,ii=linkFns.length;i<ii;){node=stableNodeList[linkFns[i++]];nodeLinkFn=linkFns[i++];childLinkFn=linkFns[i++];if(nodeLinkFn){if(nodeLinkFn.scope){childScope=scope.$new();compile.$$addScopeInfo(jqLite(node),childScope);}else{childScope=scope;}if(nodeLinkFn.transcludeOnThisElement){childBoundTranscludeFn=createBoundTranscludeFn(scope,nodeLinkFn.transclude,parentBoundTranscludeFn);}else if(!nodeLinkFn.templateOnThisElement&&parentBoundTranscludeFn){childBoundTranscludeFn=parentBoundTranscludeFn;}else if(!parentBoundTranscludeFn&&transcludeFn){childBoundTranscludeFn=createBoundTranscludeFn(scope,transcludeFn);}else{childBoundTranscludeFn=null;}nodeLinkFn(childLinkFn,childScope,node,$rootElement,childBoundTranscludeFn);}else if(childLinkFn){childLinkFn(scope,node.childNodes,undefined,parentBoundTranscludeFn);}}}}function createBoundTranscludeFn(scope,transcludeFn,previousBoundTranscludeFn){var boundTranscludeFn=function boundTranscludeFn(transcludedScope,cloneFn,controllers,futureParentElement,containingScope){if(!transcludedScope){transcludedScope=scope.$new(false,containingScope);transcludedScope.$$transcluded=true;}return transcludeFn(transcludedScope,cloneFn,{parentBoundTranscludeFn:previousBoundTranscludeFn,transcludeControllers:controllers,futureParentElement:futureParentElement});};return boundTranscludeFn;}/**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */function collectDirectives(node,directives,attrs,maxPriority,ignoreDirective){var nodeType=node.nodeType,attrsMap=attrs.$attr,match,className;switch(nodeType){case NODE_TYPE_ELEMENT:/* Element */// use the node name: <directive>
	addDirective(directives,directiveNormalize(nodeName_(node)),'E',maxPriority,ignoreDirective);// iterate over the attributes
	for(var attr,name,nName,ngAttrName,value,isNgAttr,nAttrs=node.attributes,j=0,jj=nAttrs&&nAttrs.length;j<jj;j++){var attrStartName=false;var attrEndName=false;attr=nAttrs[j];name=attr.name;value=trim(attr.value);// support ngAttr attribute binding
	ngAttrName=directiveNormalize(name);if(isNgAttr=NG_ATTR_BINDING.test(ngAttrName)){name=name.replace(PREFIX_REGEXP,'').substr(8).replace(/_(.)/g,function(match,letter){return letter.toUpperCase();});}var multiElementMatch=ngAttrName.match(MULTI_ELEMENT_DIR_RE);if(multiElementMatch&&directiveIsMultiElement(multiElementMatch[1])){attrStartName=name;attrEndName=name.substr(0,name.length-5)+'end';name=name.substr(0,name.length-6);}nName=directiveNormalize(name.toLowerCase());attrsMap[nName]=name;if(isNgAttr||!attrs.hasOwnProperty(nName)){attrs[nName]=value;if(getBooleanAttrName(node,nName)){attrs[nName]=true;// presence means true
	}}addAttrInterpolateDirective(node,directives,value,nName,isNgAttr);addDirective(directives,nName,'A',maxPriority,ignoreDirective,attrStartName,attrEndName);}// use class as directive
	className=node.className;if(isObject(className)){// Maybe SVGAnimatedString
	className=className.animVal;}if(isString(className)&&className!==''){while(match=CLASS_DIRECTIVE_REGEXP.exec(className)){nName=directiveNormalize(match[2]);if(addDirective(directives,nName,'C',maxPriority,ignoreDirective)){attrs[nName]=trim(match[3]);}className=className.substr(match.index+match[0].length);}}break;case NODE_TYPE_TEXT:/* Text Node */if(msie===11){// Workaround for #11781
	while(node.parentNode&&node.nextSibling&&node.nextSibling.nodeType===NODE_TYPE_TEXT){node.nodeValue=node.nodeValue+node.nextSibling.nodeValue;node.parentNode.removeChild(node.nextSibling);}}addTextInterpolateDirective(directives,node.nodeValue);break;case NODE_TYPE_COMMENT:/* Comment */try{match=COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);if(match){nName=directiveNormalize(match[1]);if(addDirective(directives,nName,'M',maxPriority,ignoreDirective)){attrs[nName]=trim(match[2]);}}}catch(e){// turns out that under some circumstances IE9 throws errors when one attempts to read
	// comment's node value.
	// Just ignore it and continue. (Can't seem to reproduce in test case.)
	}break;}directives.sort(byPriority);return directives;}/**
	     * Given a node with an directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */function groupScan(node,attrStart,attrEnd){var nodes=[];var depth=0;if(attrStart&&node.hasAttribute&&node.hasAttribute(attrStart)){do{if(!node){throw $compileMinErr('uterdir',"Unterminated attribute, found '{0}' but no matching '{1}' found.",attrStart,attrEnd);}if(node.nodeType==NODE_TYPE_ELEMENT){if(node.hasAttribute(attrStart))depth++;if(node.hasAttribute(attrEnd))depth--;}nodes.push(node);node=node.nextSibling;}while(depth>0);}else{nodes.push(node);}return jqLite(nodes);}/**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */function groupElementsLinkFnWrapper(linkFn,attrStart,attrEnd){return function(scope,element,attrs,controllers,transcludeFn){element=groupScan(element[0],attrStart,attrEnd);return linkFn(scope,element,attrs,controllers,transcludeFn);};}/**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */function applyDirectivesToNode(directives,compileNode,templateAttrs,transcludeFn,jqCollection,originalReplaceDirective,preLinkFns,postLinkFns,previousCompileContext){previousCompileContext=previousCompileContext||{};var terminalPriority=-Number.MAX_VALUE,newScopeDirective=previousCompileContext.newScopeDirective,controllerDirectives=previousCompileContext.controllerDirectives,newIsolateScopeDirective=previousCompileContext.newIsolateScopeDirective,templateDirective=previousCompileContext.templateDirective,nonTlbTranscludeDirective=previousCompileContext.nonTlbTranscludeDirective,hasTranscludeDirective=false,hasTemplate=false,hasElementTranscludeDirective=previousCompileContext.hasElementTranscludeDirective,$compileNode=templateAttrs.$$element=jqLite(compileNode),directive,directiveName,$template,replaceDirective=originalReplaceDirective,childTranscludeFn=transcludeFn,linkFn,directiveValue;// executes all directives on the current element
	for(var i=0,ii=directives.length;i<ii;i++){directive=directives[i];var attrStart=directive.$$start;var attrEnd=directive.$$end;// collect multiblock sections
	if(attrStart){$compileNode=groupScan(compileNode,attrStart,attrEnd);}$template=undefined;if(terminalPriority>directive.priority){break;// prevent further processing of directives
	}if(directiveValue=directive.scope){// skip the check for directives with async templates, we'll check the derived sync
	// directive when the template arrives
	if(!directive.templateUrl){if(isObject(directiveValue)){// This directive is trying to add an isolated scope.
	// Check that there is no scope of any kind already
	assertNoDuplicate('new/isolated scope',newIsolateScopeDirective||newScopeDirective,directive,$compileNode);newIsolateScopeDirective=directive;}else{// This directive is trying to add a child scope.
	// Check that there is no isolated scope already
	assertNoDuplicate('new/isolated scope',newIsolateScopeDirective,directive,$compileNode);}}newScopeDirective=newScopeDirective||directive;}directiveName=directive.name;if(!directive.templateUrl&&directive.controller){directiveValue=directive.controller;controllerDirectives=controllerDirectives||createMap();assertNoDuplicate("'"+directiveName+"' controller",controllerDirectives[directiveName],directive,$compileNode);controllerDirectives[directiveName]=directive;}if(directiveValue=directive.transclude){hasTranscludeDirective=true;// Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	// This option should only be used by directives that know how to safely handle element transclusion,
	// where the transcluded nodes are added or replaced after linking.
	if(!directive.$$tlb){assertNoDuplicate('transclusion',nonTlbTranscludeDirective,directive,$compileNode);nonTlbTranscludeDirective=directive;}if(directiveValue=='element'){hasElementTranscludeDirective=true;terminalPriority=directive.priority;$template=$compileNode;$compileNode=templateAttrs.$$element=jqLite(document.createComment(' '+directiveName+': '+templateAttrs[directiveName]+' '));compileNode=$compileNode[0];replaceWith(jqCollection,sliceArgs($template),compileNode);childTranscludeFn=compile($template,transcludeFn,terminalPriority,replaceDirective&&replaceDirective.name,{// Don't pass in:
	// - controllerDirectives - otherwise we'll create duplicates controllers
	// - newIsolateScopeDirective or templateDirective - combining templates with
	//   element transclusion doesn't make sense.
	//
	// We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	// on the same element more than once.
	nonTlbTranscludeDirective:nonTlbTranscludeDirective});}else{$template=jqLite(jqLiteClone(compileNode)).contents();$compileNode.empty();// clear contents
	childTranscludeFn=compile($template,transcludeFn,undefined,undefined,{needsNewScope:directive.$$isolateScope||directive.$$newScope});}}if(directive.template){hasTemplate=true;assertNoDuplicate('template',templateDirective,directive,$compileNode);templateDirective=directive;directiveValue=isFunction(directive.template)?directive.template($compileNode,templateAttrs):directive.template;directiveValue=denormalizeTemplate(directiveValue);if(directive.replace){replaceDirective=directive;if(jqLiteIsTextNode(directiveValue)){$template=[];}else{$template=removeComments(wrapTemplate(directive.templateNamespace,trim(directiveValue)));}compileNode=$template[0];if($template.length!=1||compileNode.nodeType!==NODE_TYPE_ELEMENT){throw $compileMinErr('tplrt',"Template for directive '{0}' must have exactly one root element. {1}",directiveName,'');}replaceWith(jqCollection,$compileNode,compileNode);var newTemplateAttrs={$attr:{}};// combine directives from the original node and from the template:
	// - take the array of directives for this element
	// - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	// - collect directives from the template and sort them by priority
	// - combine directives as: processed + template + unprocessed
	var templateDirectives=collectDirectives(compileNode,[],newTemplateAttrs);var unprocessedDirectives=directives.splice(i+1,directives.length-(i+1));if(newIsolateScopeDirective||newScopeDirective){// The original directive caused the current element to be replaced but this element
	// also needs to have a new scope, so we need to tell the template directives
	// that they would need to get their scope from further up, if they require transclusion
	markDirectiveScope(templateDirectives,newIsolateScopeDirective,newScopeDirective);}directives=directives.concat(templateDirectives).concat(unprocessedDirectives);mergeTemplateAttributes(templateAttrs,newTemplateAttrs);ii=directives.length;}else{$compileNode.html(directiveValue);}}if(directive.templateUrl){hasTemplate=true;assertNoDuplicate('template',templateDirective,directive,$compileNode);templateDirective=directive;if(directive.replace){replaceDirective=directive;}nodeLinkFn=compileTemplateUrl(directives.splice(i,directives.length-i),$compileNode,templateAttrs,jqCollection,hasTranscludeDirective&&childTranscludeFn,preLinkFns,postLinkFns,{controllerDirectives:controllerDirectives,newScopeDirective:newScopeDirective!==directive&&newScopeDirective,newIsolateScopeDirective:newIsolateScopeDirective,templateDirective:templateDirective,nonTlbTranscludeDirective:nonTlbTranscludeDirective});ii=directives.length;}else if(directive.compile){try{linkFn=directive.compile($compileNode,templateAttrs,childTranscludeFn);if(isFunction(linkFn)){addLinkFns(null,linkFn,attrStart,attrEnd);}else if(linkFn){addLinkFns(linkFn.pre,linkFn.post,attrStart,attrEnd);}}catch(e){$exceptionHandler(e,startingTag($compileNode));}}if(directive.terminal){nodeLinkFn.terminal=true;terminalPriority=Math.max(terminalPriority,directive.priority);}}nodeLinkFn.scope=newScopeDirective&&newScopeDirective.scope===true;nodeLinkFn.transcludeOnThisElement=hasTranscludeDirective;nodeLinkFn.templateOnThisElement=hasTemplate;nodeLinkFn.transclude=childTranscludeFn;previousCompileContext.hasElementTranscludeDirective=hasElementTranscludeDirective;// might be normal or delayed nodeLinkFn depending on if templateUrl is present
	return nodeLinkFn;////////////////////
	function addLinkFns(pre,post,attrStart,attrEnd){if(pre){if(attrStart)pre=groupElementsLinkFnWrapper(pre,attrStart,attrEnd);pre.require=directive.require;pre.directiveName=directiveName;if(newIsolateScopeDirective===directive||directive.$$isolateScope){pre=cloneAndAnnotateFn(pre,{isolateScope:true});}preLinkFns.push(pre);}if(post){if(attrStart)post=groupElementsLinkFnWrapper(post,attrStart,attrEnd);post.require=directive.require;post.directiveName=directiveName;if(newIsolateScopeDirective===directive||directive.$$isolateScope){post=cloneAndAnnotateFn(post,{isolateScope:true});}postLinkFns.push(post);}}function getControllers(directiveName,require,$element,elementControllers){var value;if(isString(require)){var match=require.match(REQUIRE_PREFIX_REGEXP);var name=require.substring(match[0].length);var inheritType=match[1]||match[3];var optional=match[2]==='?';//If only parents then start at the parent element
	if(inheritType==='^^'){$element=$element.parent();//Otherwise attempt getting the controller from elementControllers in case
	//the element is transcluded (and has no data) and to avoid .data if possible
	}else{value=elementControllers&&elementControllers[name];value=value&&value.instance;}if(!value){var dataName='$'+name+'Controller';value=inheritType?$element.inheritedData(dataName):$element.data(dataName);}if(!value&&!optional){throw $compileMinErr('ctreq',"Controller '{0}', required by directive '{1}', can't be found!",name,directiveName);}}else if(isArray(require)){value=[];for(var i=0,ii=require.length;i<ii;i++){value[i]=getControllers(directiveName,require[i],$element,elementControllers);}}return value||null;}function setupControllers($element,attrs,transcludeFn,controllerDirectives,isolateScope,scope){var elementControllers=createMap();for(var controllerKey in controllerDirectives){var directive=controllerDirectives[controllerKey];var locals={$scope:directive===newIsolateScopeDirective||directive.$$isolateScope?isolateScope:scope,$element:$element,$attrs:attrs,$transclude:transcludeFn};var controller=directive.controller;if(controller=='@'){controller=attrs[directive.name];}var controllerInstance=$controller(controller,locals,true,directive.controllerAs);// For directives with element transclusion the element is a comment.
	// In this case .data will not attach any data.
	// Instead, we save the controllers for the element in a local hash and attach to .data
	// later, once we have the actual element.
	elementControllers[directive.name]=controllerInstance;$element.data('$'+directive.name+'Controller',controllerInstance.instance);}return elementControllers;}function nodeLinkFn(childLinkFn,scope,linkNode,$rootElement,boundTranscludeFn){var linkFn,isolateScope,controllerScope,elementControllers,transcludeFn,$element,attrs,removeScopeBindingWatches,removeControllerBindingWatches;if(compileNode===linkNode){attrs=templateAttrs;$element=templateAttrs.$$element;}else{$element=jqLite(linkNode);attrs=new Attributes($element,templateAttrs);}controllerScope=scope;if(newIsolateScopeDirective){isolateScope=scope.$new(true);}else if(newScopeDirective){controllerScope=scope.$parent;}if(boundTranscludeFn){// track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	// is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	transcludeFn=controllersBoundTransclude;transcludeFn.$$boundTransclude=boundTranscludeFn;}if(controllerDirectives){elementControllers=setupControllers($element,attrs,transcludeFn,controllerDirectives,isolateScope,scope);}if(newIsolateScopeDirective){// Initialize isolate scope bindings for new isolate scope directive.
	compile.$$addScopeInfo($element,isolateScope,true,!(templateDirective&&(templateDirective===newIsolateScopeDirective||templateDirective===newIsolateScopeDirective.$$originalDirective)));compile.$$addScopeClass($element,true);isolateScope.$$isolateBindings=newIsolateScopeDirective.$$isolateBindings;removeScopeBindingWatches=initializeDirectiveBindings(scope,attrs,isolateScope,isolateScope.$$isolateBindings,newIsolateScopeDirective);if(removeScopeBindingWatches){isolateScope.$on('$destroy',removeScopeBindingWatches);}}// Initialize bindToController bindings
	for(var name in elementControllers){var controllerDirective=controllerDirectives[name];var controller=elementControllers[name];var bindings=controllerDirective.$$bindings.bindToController;if(controller.identifier&&bindings){removeControllerBindingWatches=initializeDirectiveBindings(controllerScope,attrs,controller.instance,bindings,controllerDirective);}var controllerResult=controller();if(controllerResult!==controller.instance){// If the controller constructor has a return value, overwrite the instance
	// from setupControllers
	controller.instance=controllerResult;$element.data('$'+controllerDirective.name+'Controller',controllerResult);removeControllerBindingWatches&&removeControllerBindingWatches();removeControllerBindingWatches=initializeDirectiveBindings(controllerScope,attrs,controller.instance,bindings,controllerDirective);}}// PRELINKING
	for(i=0,ii=preLinkFns.length;i<ii;i++){linkFn=preLinkFns[i];invokeLinkFn(linkFn,linkFn.isolateScope?isolateScope:scope,$element,attrs,linkFn.require&&getControllers(linkFn.directiveName,linkFn.require,$element,elementControllers),transcludeFn);}// RECURSION
	// We only pass the isolate scope, if the isolate directive has a template,
	// otherwise the child elements do not belong to the isolate directive.
	var scopeToChild=scope;if(newIsolateScopeDirective&&(newIsolateScopeDirective.template||newIsolateScopeDirective.templateUrl===null)){scopeToChild=isolateScope;}childLinkFn&&childLinkFn(scopeToChild,linkNode.childNodes,undefined,boundTranscludeFn);// POSTLINKING
	for(i=postLinkFns.length-1;i>=0;i--){linkFn=postLinkFns[i];invokeLinkFn(linkFn,linkFn.isolateScope?isolateScope:scope,$element,attrs,linkFn.require&&getControllers(linkFn.directiveName,linkFn.require,$element,elementControllers),transcludeFn);}// This is the function that is injected as `$transclude`.
	// Note: all arguments are optional!
	function controllersBoundTransclude(scope,cloneAttachFn,futureParentElement){var transcludeControllers;// No scope passed in:
	if(!isScope(scope)){futureParentElement=cloneAttachFn;cloneAttachFn=scope;scope=undefined;}if(hasElementTranscludeDirective){transcludeControllers=elementControllers;}if(!futureParentElement){futureParentElement=hasElementTranscludeDirective?$element.parent():$element;}return boundTranscludeFn(scope,cloneAttachFn,transcludeControllers,futureParentElement,scopeToChild);}}}// Depending upon the context in which a directive finds itself it might need to have a new isolated
	// or child scope created. For instance:
	// * if the directive has been pulled into a template because another directive with a higher priority
	// asked for element transclusion
	// * if the directive itself asks for transclusion but it is at the root of a template and the original
	// element was replaced. See https://github.com/angular/angular.js/issues/12936
	function markDirectiveScope(directives,isolateScope,newScope){for(var j=0,jj=directives.length;j<jj;j++){directives[j]=inherit(directives[j],{$$isolateScope:isolateScope,$$newScope:newScope});}}/**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */function addDirective(tDirectives,name,location,maxPriority,ignoreDirective,startAttrName,endAttrName){if(name===ignoreDirective)return null;var match=null;if(hasDirectives.hasOwnProperty(name)){for(var directive,directives=$injector.get(name+Suffix),i=0,ii=directives.length;i<ii;i++){try{directive=directives[i];if((isUndefined(maxPriority)||maxPriority>directive.priority)&&directive.restrict.indexOf(location)!=-1){if(startAttrName){directive=inherit(directive,{$$start:startAttrName,$$end:endAttrName});}if(!directive.$$bindings){var bindings=directive.$$bindings=parseDirectiveBindings(directive,directive.name);if(isObject(bindings.isolateScope)){directive.$$isolateBindings=bindings.isolateScope;}}tDirectives.push(directive);match=directive;}}catch(e){$exceptionHandler(e);}}}return match;}/**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */function directiveIsMultiElement(name){if(hasDirectives.hasOwnProperty(name)){for(var directive,directives=$injector.get(name+Suffix),i=0,ii=directives.length;i<ii;i++){directive=directives[i];if(directive.multiElement){return true;}}}return false;}/**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */function mergeTemplateAttributes(dst,src){var srcAttr=src.$attr,dstAttr=dst.$attr,$element=dst.$$element;// reapply the old attributes to the new element
	forEach(dst,function(value,key){if(key.charAt(0)!='$'){if(src[key]&&src[key]!==value){value+=(key==='style'?';':' ')+src[key];}dst.$set(key,value,true,srcAttr[key]);}});// copy the new attributes on the old attrs object
	forEach(src,function(value,key){if(key=='class'){safeAddClass($element,value);dst['class']=(dst['class']?dst['class']+' ':'')+value;}else if(key=='style'){$element.attr('style',$element.attr('style')+';'+value);dst['style']=(dst['style']?dst['style']+';':'')+value;// `dst` will never contain hasOwnProperty as DOM parser won't let it.
	// You will get an "InvalidCharacterError: DOM Exception 5" error if you
	// have an attribute like "has-own-property" or "data-has-own-property", etc.
	}else if(key.charAt(0)!='$'&&!dst.hasOwnProperty(key)){dst[key]=value;dstAttr[key]=srcAttr[key];}});}function compileTemplateUrl(directives,$compileNode,tAttrs,$rootElement,childTranscludeFn,preLinkFns,postLinkFns,previousCompileContext){var linkQueue=[],afterTemplateNodeLinkFn,afterTemplateChildLinkFn,beforeTemplateCompileNode=$compileNode[0],origAsyncDirective=directives.shift(),derivedSyncDirective=inherit(origAsyncDirective,{templateUrl:null,transclude:null,replace:null,$$originalDirective:origAsyncDirective}),templateUrl=isFunction(origAsyncDirective.templateUrl)?origAsyncDirective.templateUrl($compileNode,tAttrs):origAsyncDirective.templateUrl,templateNamespace=origAsyncDirective.templateNamespace;$compileNode.empty();$templateRequest(templateUrl).then(function(content){var compileNode,tempTemplateAttrs,$template,childBoundTranscludeFn;content=denormalizeTemplate(content);if(origAsyncDirective.replace){if(jqLiteIsTextNode(content)){$template=[];}else{$template=removeComments(wrapTemplate(templateNamespace,trim(content)));}compileNode=$template[0];if($template.length!=1||compileNode.nodeType!==NODE_TYPE_ELEMENT){throw $compileMinErr('tplrt',"Template for directive '{0}' must have exactly one root element. {1}",origAsyncDirective.name,templateUrl);}tempTemplateAttrs={$attr:{}};replaceWith($rootElement,$compileNode,compileNode);var templateDirectives=collectDirectives(compileNode,[],tempTemplateAttrs);if(isObject(origAsyncDirective.scope)){// the original directive that caused the template to be loaded async required
	// an isolate scope
	markDirectiveScope(templateDirectives,true);}directives=templateDirectives.concat(directives);mergeTemplateAttributes(tAttrs,tempTemplateAttrs);}else{compileNode=beforeTemplateCompileNode;$compileNode.html(content);}directives.unshift(derivedSyncDirective);afterTemplateNodeLinkFn=applyDirectivesToNode(directives,compileNode,tAttrs,childTranscludeFn,$compileNode,origAsyncDirective,preLinkFns,postLinkFns,previousCompileContext);forEach($rootElement,function(node,i){if(node==compileNode){$rootElement[i]=$compileNode[0];}});afterTemplateChildLinkFn=compileNodes($compileNode[0].childNodes,childTranscludeFn);while(linkQueue.length){var scope=linkQueue.shift(),beforeTemplateLinkNode=linkQueue.shift(),linkRootElement=linkQueue.shift(),boundTranscludeFn=linkQueue.shift(),linkNode=$compileNode[0];if(scope.$$destroyed)continue;if(beforeTemplateLinkNode!==beforeTemplateCompileNode){var oldClasses=beforeTemplateLinkNode.className;if(!(previousCompileContext.hasElementTranscludeDirective&&origAsyncDirective.replace)){// it was cloned therefore we have to clone as well.
	linkNode=jqLiteClone(compileNode);}replaceWith(linkRootElement,jqLite(beforeTemplateLinkNode),linkNode);// Copy in CSS classes from original node
	safeAddClass(jqLite(linkNode),oldClasses);}if(afterTemplateNodeLinkFn.transcludeOnThisElement){childBoundTranscludeFn=createBoundTranscludeFn(scope,afterTemplateNodeLinkFn.transclude,boundTranscludeFn);}else{childBoundTranscludeFn=boundTranscludeFn;}afterTemplateNodeLinkFn(afterTemplateChildLinkFn,scope,linkNode,$rootElement,childBoundTranscludeFn);}linkQueue=null;});return function delayedNodeLinkFn(ignoreChildLinkFn,scope,node,rootElement,boundTranscludeFn){var childBoundTranscludeFn=boundTranscludeFn;if(scope.$$destroyed)return;if(linkQueue){linkQueue.push(scope,node,rootElement,childBoundTranscludeFn);}else{if(afterTemplateNodeLinkFn.transcludeOnThisElement){childBoundTranscludeFn=createBoundTranscludeFn(scope,afterTemplateNodeLinkFn.transclude,boundTranscludeFn);}afterTemplateNodeLinkFn(afterTemplateChildLinkFn,scope,node,rootElement,childBoundTranscludeFn);}};}/**
	     * Sorting function for bound directives.
	     */function byPriority(a,b){var diff=b.priority-a.priority;if(diff!==0)return diff;if(a.name!==b.name)return a.name<b.name?-1:1;return a.index-b.index;}function assertNoDuplicate(what,previousDirective,directive,element){function wrapModuleNameIfDefined(moduleName){return moduleName?' (module: '+moduleName+')':'';}if(previousDirective){throw $compileMinErr('multidir','Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',previousDirective.name,wrapModuleNameIfDefined(previousDirective.$$moduleName),directive.name,wrapModuleNameIfDefined(directive.$$moduleName),what,startingTag(element));}}function addTextInterpolateDirective(directives,text){var interpolateFn=$interpolate(text,true);if(interpolateFn){directives.push({priority:0,compile:function textInterpolateCompileFn(templateNode){var templateNodeParent=templateNode.parent(),hasCompileParent=!!templateNodeParent.length;// When transcluding a template that has bindings in the root
	// we don't have a parent and thus need to add the class during linking fn.
	if(hasCompileParent)compile.$$addBindingClass(templateNodeParent);return function textInterpolateLinkFn(scope,node){var parent=node.parent();if(!hasCompileParent)compile.$$addBindingClass(parent);compile.$$addBindingInfo(parent,interpolateFn.expressions);scope.$watch(interpolateFn,function interpolateFnWatchAction(value){node[0].nodeValue=value;});};}});}}function wrapTemplate(type,template){type=lowercase(type||'html');switch(type){case'svg':case'math':var wrapper=document.createElement('div');wrapper.innerHTML='<'+type+'>'+template+'</'+type+'>';return wrapper.childNodes[0].childNodes;default:return template;}}function getTrustedContext(node,attrNormalizedName){if(attrNormalizedName=="srcdoc"){return $sce.HTML;}var tag=nodeName_(node);// maction[xlink:href] can source SVG.  It's not limited to <maction>.
	if(attrNormalizedName=="xlinkHref"||tag=="form"&&attrNormalizedName=="action"||tag!="img"&&(attrNormalizedName=="src"||attrNormalizedName=="ngSrc")){return $sce.RESOURCE_URL;}}function addAttrInterpolateDirective(node,directives,value,name,allOrNothing){var trustedContext=getTrustedContext(node,name);allOrNothing=ALL_OR_NOTHING_ATTRS[name]||allOrNothing;var interpolateFn=$interpolate(value,true,trustedContext,allOrNothing);// no interpolation found -> ignore
	if(!interpolateFn)return;if(name==="multiple"&&nodeName_(node)==="select"){throw $compileMinErr("selmulti","Binding to the 'multiple' attribute is not supported. Element: {0}",startingTag(node));}directives.push({priority:100,compile:function compile(){return{pre:function attrInterpolatePreLinkFn(scope,element,attr){var $$observers=attr.$$observers||(attr.$$observers=createMap());if(EVENT_HANDLER_ATTR_REGEXP.test(name)){throw $compileMinErr('nodomevents',"Interpolations for HTML DOM event attributes are disallowed.  Please use the "+"ng- versions (such as ng-click instead of onclick) instead.");}// If the attribute has changed since last $interpolate()ed
	var newValue=attr[name];if(newValue!==value){// we need to interpolate again since the attribute value has been updated
	// (e.g. by another directive's compile function)
	// ensure unset/empty values make interpolateFn falsy
	interpolateFn=newValue&&$interpolate(newValue,true,trustedContext,allOrNothing);value=newValue;}// if attribute was updated so that there is no interpolation going on we don't want to
	// register any observers
	if(!interpolateFn)return;// initialize attr object so that it's ready in case we need the value for isolate
	// scope initialization, otherwise the value would not be available from isolate
	// directive's linking fn during linking phase
	attr[name]=interpolateFn(scope);($$observers[name]||($$observers[name]=[])).$$inter=true;(attr.$$observers&&attr.$$observers[name].$$scope||scope).$watch(interpolateFn,function interpolateFnWatchAction(newValue,oldValue){//special case for class attribute addition + removal
	//so that class changes can tap into the animation
	//hooks provided by the $animate service. Be sure to
	//skip animations when the first digest occurs (when
	//both the new and the old values are the same) since
	//the CSS classes are the non-interpolated values
	if(name==='class'&&newValue!=oldValue){attr.$updateClass(newValue,oldValue);}else{attr.$set(name,newValue);}});}};}});}/**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */function replaceWith($rootElement,elementsToRemove,newNode){var firstElementToRemove=elementsToRemove[0],removeCount=elementsToRemove.length,parent=firstElementToRemove.parentNode,i,ii;if($rootElement){for(i=0,ii=$rootElement.length;i<ii;i++){if($rootElement[i]==firstElementToRemove){$rootElement[i++]=newNode;for(var j=i,j2=j+removeCount-1,jj=$rootElement.length;j<jj;j++,j2++){if(j2<jj){$rootElement[j]=$rootElement[j2];}else{delete $rootElement[j];}}$rootElement.length-=removeCount-1;// If the replaced element is also the jQuery .context then replace it
	// .context is a deprecated jQuery api, so we should set it only when jQuery set it
	// http://api.jquery.com/context/
	if($rootElement.context===firstElementToRemove){$rootElement.context=newNode;}break;}}}if(parent){parent.replaceChild(newNode,firstElementToRemove);}// TODO(perf): what's this document fragment for? is it needed? can we at least reuse it?
	var fragment=document.createDocumentFragment();fragment.appendChild(firstElementToRemove);if(jqLite.hasData(firstElementToRemove)){// Copy over user data (that includes Angular's $scope etc.). Don't copy private
	// data here because there's no public interface in jQuery to do that and copying over
	// event listeners (which is the main use of private data) wouldn't work anyway.
	jqLite.data(newNode,jqLite.data(firstElementToRemove));// Remove data of the replaced element. We cannot just call .remove()
	// on the element it since that would deallocate scope that is needed
	// for the new node. Instead, remove the data "manually".
	if(!jQuery){delete jqLite.cache[firstElementToRemove[jqLite.expando]];}else{// jQuery 2.x doesn't expose the data storage. Use jQuery.cleanData to clean up after
	// the replaced element. The cleanData version monkey-patched by Angular would cause
	// the scope to be trashed and we do need the very same scope to work with the new
	// element. However, we cannot just cache the non-patched version and use it here as
	// that would break if another library patches the method after Angular does (one
	// example is jQuery UI). Instead, set a flag indicating scope destroying should be
	// skipped this one time.
	skipDestroyOnNextJQueryCleanData=true;jQuery.cleanData([firstElementToRemove]);}}for(var k=1,kk=elementsToRemove.length;k<kk;k++){var element=elementsToRemove[k];jqLite(element).remove();// must do this way to clean up expando
	fragment.appendChild(element);delete elementsToRemove[k];}elementsToRemove[0]=newNode;elementsToRemove.length=1;}function cloneAndAnnotateFn(fn,annotation){return extend(function(){return fn.apply(null,arguments);},fn,annotation);}function invokeLinkFn(linkFn,scope,$element,attrs,controllers,transcludeFn){try{linkFn(scope,$element,attrs,controllers,transcludeFn);}catch(e){$exceptionHandler(e,startingTag($element));}}// Set up $watches for isolate scope and controller bindings. This process
	// only occurs for isolate scopes and new scopes with controllerAs.
	function initializeDirectiveBindings(scope,attrs,destination,bindings,directive){var removeWatchCollection=[];forEach(bindings,function(definition,scopeName){var attrName=definition.attrName,optional=definition.optional,mode=definition.mode,// @, =, or &
	lastValue,parentGet,parentSet,compare;switch(mode){case'@':if(!optional&&!hasOwnProperty.call(attrs,attrName)){destination[scopeName]=attrs[attrName]=void 0;}attrs.$observe(attrName,function(value){if(isString(value)){destination[scopeName]=value;}});attrs.$$observers[attrName].$$scope=scope;lastValue=attrs[attrName];if(isString(lastValue)){// If the attribute has been provided then we trigger an interpolation to ensure
	// the value is there for use in the link fn
	destination[scopeName]=$interpolate(lastValue)(scope);}else if(isBoolean(lastValue)){// If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
	// the value to boolean rather than a string, so we special case this situation
	destination[scopeName]=lastValue;}break;case'=':if(!hasOwnProperty.call(attrs,attrName)){if(optional)break;attrs[attrName]=void 0;}if(optional&&!attrs[attrName])break;parentGet=$parse(attrs[attrName]);if(parentGet.literal){compare=equals;}else{compare=function compare(a,b){return a===b||a!==a&&b!==b;};}parentSet=parentGet.assign||function(){// reset the change, or we will throw this exception on every $digest
	lastValue=destination[scopeName]=parentGet(scope);throw $compileMinErr('nonassign',"Expression '{0}' in attribute '{1}' used with directive '{2}' is non-assignable!",attrs[attrName],attrName,directive.name);};lastValue=destination[scopeName]=parentGet(scope);var parentValueWatch=function parentValueWatch(parentValue){if(!compare(parentValue,destination[scopeName])){// we are out of sync and need to copy
	if(!compare(parentValue,lastValue)){// parent changed and it has precedence
	destination[scopeName]=parentValue;}else{// if the parent can be assigned then do so
	parentSet(scope,parentValue=destination[scopeName]);}}return lastValue=parentValue;};parentValueWatch.$stateful=true;var removeWatch;if(definition.collection){removeWatch=scope.$watchCollection(attrs[attrName],parentValueWatch);}else{removeWatch=scope.$watch($parse(attrs[attrName],parentValueWatch),null,parentGet.literal);}removeWatchCollection.push(removeWatch);break;case'&':// Don't assign Object.prototype method to scope
	parentGet=attrs.hasOwnProperty(attrName)?$parse(attrs[attrName]):noop;// Don't assign noop to destination if expression is not valid
	if(parentGet===noop&&optional)break;destination[scopeName]=function(locals){return parentGet(scope,locals);};break;}});return removeWatchCollection.length&&function removeWatches(){for(var i=0,ii=removeWatchCollection.length;i<ii;++i){removeWatchCollection[i]();}};}}];}var PREFIX_REGEXP=/^((?:x|data)[\:\-_])/i;/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */function directiveNormalize(name){return camelCase(name.replace(PREFIX_REGEXP,''));}/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 *//**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 *//**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 *//**
	 * Closure compiler type information
	 */function nodesetLinkingFn(/* angular.Scope */scope,/* NodeList */nodeList,/* Element */rootElement,/* function(Function) */boundTranscludeFn){}function directiveLinkingFn(/* nodesetLinkingFn */nodesetLinkingFn,/* angular.Scope */scope,/* Node */node,/* Element */rootElement,/* function(Function) */boundTranscludeFn){}function tokenDifference(str1,str2){var values='',tokens1=str1.split(/\s+/),tokens2=str2.split(/\s+/);outer:for(var i=0;i<tokens1.length;i++){var token=tokens1[i];for(var j=0;j<tokens2.length;j++){if(token==tokens2[j])continue outer;}values+=(values.length>0?' ':'')+token;}return values;}function removeComments(jqNodes){jqNodes=jqLite(jqNodes);var i=jqNodes.length;if(i<=1){return jqNodes;}while(i--){var node=jqNodes[i];if(node.nodeType===NODE_TYPE_COMMENT){splice.call(jqNodes,i,1);}}return jqNodes;}var $controllerMinErr=minErr('$controller');var CNTRL_REG=/^(\S+)(\s+as\s+([\w$]+))?$/;function identifierForController(controller,ident){if(ident&&isString(ident))return ident;if(isString(controller)){var match=CNTRL_REG.exec(controller);if(match)return match[3];}}/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */function $ControllerProvider(){var controllers={},globals=false;/**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */this.register=function(name,constructor){assertNotHasOwnProperty(name,'controller');if(isObject(name)){extend(controllers,name);}else{controllers[name]=constructor;}};/**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   */this.allowGlobals=function(){globals=true;};this.$get=['$injector','$window',function($injector,$window){/**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */return function(expression,locals,later,ident){// PRIVATE API:
	//   param `later` --- indicates that the controller's constructor is invoked at a later time.
	//                     If true, $controller will allocate the object with the correct
	//                     prototype chain, but will not invoke the controller until a returned
	//                     callback is invoked.
	//   param `ident` --- An optional label which overrides the label parsed from the controller
	//                     expression, if any.
	var instance,match,constructor,identifier;later=later===true;if(ident&&isString(ident)){identifier=ident;}if(isString(expression)){match=expression.match(CNTRL_REG);if(!match){throw $controllerMinErr('ctrlfmt',"Badly formed controller string '{0}'. "+"Must match `__name__ as __id__` or `__name__`.",expression);}constructor=match[1],identifier=identifier||match[3];expression=controllers.hasOwnProperty(constructor)?controllers[constructor]:getter(locals.$scope,constructor,true)||(globals?getter($window,constructor,true):undefined);assertArgFn(expression,constructor,true);}if(later){// Instantiate controller later:
	// This machinery is used to create an instance of the object before calling the
	// controller's constructor itself.
	//
	// This allows properties to be added to the controller before the constructor is
	// invoked. Primarily, this is used for isolate scope bindings in $compile.
	//
	// This feature is not intended for use by applications, and is thus not documented
	// publicly.
	// Object creation: http://jsperf.com/create-constructor/2
	var controllerPrototype=(isArray(expression)?expression[expression.length-1]:expression).prototype;instance=Object.create(controllerPrototype||null);if(identifier){addIdentifier(locals,identifier,instance,constructor||expression.name);}var instantiate;return instantiate=extend(function(){var result=$injector.invoke(expression,instance,locals,constructor);if(result!==instance&&(isObject(result)||isFunction(result))){instance=result;if(identifier){// If result changed, re-assign controllerAs value to scope.
	addIdentifier(locals,identifier,instance,constructor||expression.name);}}return instance;},{instance:instance,identifier:identifier});}instance=$injector.instantiate(expression,locals,constructor);if(identifier){addIdentifier(locals,identifier,instance,constructor||expression.name);}return instance;};function addIdentifier(locals,identifier,instance,name){if(!(locals&&isObject(locals.$scope))){throw minErr('$controller')('noscp',"Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",name,identifier);}locals.$scope[identifier]=instance;}}];}/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */function $DocumentProvider(){this.$get=['$window',function(window){return jqLite(window.document);}];}/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * ```js
	 *   angular.module('exceptionOverride', []).factory('$exceptionHandler', function() {
	 *     return function(exception, cause) {
	 *       exception.message += ' (caused by "' + cause + '")';
	 *       throw exception;
	 *     };
	 *   });
	 * ```
	 *
	 * This example will override the normal action of `$exceptionHandler`, to make angular
	 * exceptions fail hard when they happen, instead of just logging to the console.
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause optional information about the context in which
	 *       the error was thrown.
	 *
	 */function $ExceptionHandlerProvider(){this.$get=['$log',function($log){return function(exception,cause){$log.error.apply($log,arguments);};}];}var $$ForceReflowProvider=function $$ForceReflowProvider(){this.$get=['$document',function($document){return function(domNode){//the line below will force the browser to perform a repaint so
	//that all the animated elements within the animation frame will
	//be properly updated and drawn on screen. This is required to
	//ensure that the preparation animation is properly flushed so that
	//the active state picks up from there. DO NOT REMOVE THIS LINE.
	//DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	//WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	//WILL TAKE YEARS AWAY FROM YOUR LIFE.
	if(domNode){if(!domNode.nodeType&&domNode instanceof jqLite){domNode=domNode[0];}}else{domNode=$document[0].body;}return domNode.offsetWidth+1;};}];};var APPLICATION_JSON='application/json';var CONTENT_TYPE_APPLICATION_JSON={'Content-Type':APPLICATION_JSON+';charset=utf-8'};var JSON_START=/^\[|^\{(?!\{)/;var JSON_ENDS={'[':/]$/,'{':/}$/};var JSON_PROTECTION_PREFIX=/^\)\]\}',?\n/;var $httpMinErr=minErr('$http');var $httpMinErrLegacyFn=function $httpMinErrLegacyFn(method){return function(){throw $httpMinErr('legacy','The method `{0}` on the promise returned from `$http` has been disabled.',method);};};function serializeValue(v){if(isObject(v)){return isDate(v)?v.toISOString():toJson(v);}return v;}function $HttpParamSerializerProvider(){/**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D"` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */this.$get=function(){return function ngParamSerializer(params){if(!params)return'';var parts=[];forEachSorted(params,function(value,key){if(value===null||isUndefined(value))return;if(isArray(value)){forEach(value,function(v,k){parts.push(encodeUriQuery(key)+'='+encodeUriQuery(serializeValue(v)));});}else{parts.push(encodeUriQuery(key)+'='+encodeUriQuery(serializeValue(value)));}});return parts.join('&');};};}function $HttpParamSerializerJQLikeProvider(){/**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */this.$get=function(){return function jQueryLikeParamSerializer(params){if(!params)return'';var parts=[];serialize(params,'',true);return parts.join('&');function serialize(toSerialize,prefix,topLevel){if(toSerialize===null||isUndefined(toSerialize))return;if(isArray(toSerialize)){forEach(toSerialize,function(value,index){serialize(value,prefix+'['+(isObject(value)?index:'')+']');});}else if(isObject(toSerialize)&&!isDate(toSerialize)){forEachSorted(toSerialize,function(value,key){serialize(value,prefix+(topLevel?'':'[')+key+(topLevel?'':']'));});}else{parts.push(encodeUriQuery(prefix)+'='+encodeUriQuery(serializeValue(toSerialize)));}}};};}function defaultHttpResponseTransform(data,headers){if(isString(data)){// Strip json vulnerability protection prefix and trim whitespace
	var tempData=data.replace(JSON_PROTECTION_PREFIX,'').trim();if(tempData){var contentType=headers('Content-Type');if(contentType&&contentType.indexOf(APPLICATION_JSON)===0||isJsonLike(tempData)){data=fromJson(tempData);}}}return data;}function isJsonLike(str){var jsonStart=str.match(JSON_START);return jsonStart&&JSON_ENDS[jsonStart[0]].test(str);}/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */function parseHeaders(headers){var parsed=createMap(),i;function fillInParsed(key,val){if(key){parsed[key]=parsed[key]?parsed[key]+', '+val:val;}}if(isString(headers)){forEach(headers.split('\n'),function(line){i=line.indexOf(':');fillInParsed(lowercase(trim(line.substr(0,i))),trim(line.substr(i+1)));});}else if(isObject(headers)){forEach(headers,function(headerVal,headerKey){fillInParsed(lowercase(headerKey),trim(headerVal));});}return parsed;}/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with single an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */function headersGetter(headers){var headersObj;return function(name){if(!headersObj)headersObj=parseHeaders(headers);if(name){var value=headersObj[lowercase(name)];if(value===void 0){value=null;}return value;}return headersObj;};}/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */function transformData(data,headers,status,fns){if(isFunction(fns)){return fns(data,headers,status);}forEach(fns,function(fn){data=fn(data,headers,status);});return data;}function isSuccess(status){return 200<=status&&status<300;}/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */function $HttpProvider(){/**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   **/var defaults=this.defaults={// transform incoming response data
	transformResponse:[defaultHttpResponseTransform],// transform outgoing request data
	transformRequest:[function(d){return isObject(d)&&!isFile(d)&&!isBlob(d)&&!isFormData(d)?toJson(d):d;}],// default headers
	headers:{common:{'Accept':'application/json, text/plain, */*'},post:shallowCopy(CONTENT_TYPE_APPLICATION_JSON),put:shallowCopy(CONTENT_TYPE_APPLICATION_JSON),patch:shallowCopy(CONTENT_TYPE_APPLICATION_JSON)},xsrfCookieName:'XSRF-TOKEN',xsrfHeaderName:'X-XSRF-TOKEN',paramSerializer:'$httpParamSerializer'};var useApplyAsync=false;/**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/this.useApplyAsync=function(value){if(isDefined(value)){useApplyAsync=!!value;return this;}return useApplyAsync;};var useLegacyPromise=true;/**
	   * @ngdoc method
	   * @name $httpProvider#useLegacyPromiseExtensions
	   * @description
	   *
	   * Configure `$http` service to return promises without the shorthand methods `success` and `error`.
	   * This should be used to make sure that applications work without these methods.
	   *
	   * Defaults to true. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, `$http` will return a promise with the deprecated legacy `success` and `error` methods.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/this.useLegacyPromiseExtensions=function(value){if(isDefined(value)){useLegacyPromise=!!value;return this;}return useLegacyPromise;};/**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/var interceptorFactories=this.interceptors=[];this.$get=['$httpBackend','$$cookieReader','$cacheFactory','$rootScope','$q','$injector',function($httpBackend,$$cookieReader,$cacheFactory,$rootScope,$q,$injector){var defaultCache=$cacheFactory('$http');/**
	     * Make sure that default param serializer is exposed as a function
	     */defaults.paramSerializer=isString(defaults.paramSerializer)?$injector.get(defaults.paramSerializer):defaults.paramSerializer;/**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */var reversedInterceptors=[];forEach(interceptorFactories,function(interceptorFactory){reversedInterceptors.unshift(isString(interceptorFactory)?$injector.get(interceptorFactory):$injector.invoke(interceptorFactory));});/**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *
	     * A response status code between 200 and 299 is considered a success status and
	     * will result in the success callback being called. Note that if the response is a redirect,
	     * XMLHttpRequest will transparently follow it, meaning that the error callback will not be
	     * called for such responses.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Deprecation Notice
	     * <div class="alert alert-danger">
	     *   The `$http` legacy promise methods `success` and `error` have been deprecated.
	     *   Use the standard `then` method instead.
	     *   If {@link $httpProvider#useLegacyPromiseExtensions `$httpProvider.useLegacyPromiseExtensions`} is set to
	     *   `false` then these methods will throw {@link $http:legacy `$http/legacy`} error.
	     * </div>
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - `Accept: application/json, text/plain, * / *`
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w'
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If JSON response is detected, deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory($http)` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple Angular apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || "Request failed";
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */function $http(requestConfig){if(!angular.isObject(requestConfig)){throw minErr('$http')('badreq','Http request configuration must be an object.  Received: {0}',requestConfig);}if(!isString(requestConfig.url)){throw minErr('$http')('badreq','Http request configuration url must be a string.  Received: {0}',requestConfig.url);}var config=extend({method:'get',transformRequest:defaults.transformRequest,transformResponse:defaults.transformResponse,paramSerializer:defaults.paramSerializer},requestConfig);config.headers=mergeHeaders(requestConfig);config.method=uppercase(config.method);config.paramSerializer=isString(config.paramSerializer)?$injector.get(config.paramSerializer):config.paramSerializer;var serverRequest=function serverRequest(config){var headers=config.headers;var reqData=transformData(config.data,headersGetter(headers),undefined,config.transformRequest);// strip content-type if data is undefined
	if(isUndefined(reqData)){forEach(headers,function(value,header){if(lowercase(header)==='content-type'){delete headers[header];}});}if(isUndefined(config.withCredentials)&&!isUndefined(defaults.withCredentials)){config.withCredentials=defaults.withCredentials;}// send request
	return sendReq(config,reqData).then(transformResponse,transformResponse);};var chain=[serverRequest,undefined];var promise=$q.when(config);// apply interceptors
	forEach(reversedInterceptors,function(interceptor){if(interceptor.request||interceptor.requestError){chain.unshift(interceptor.request,interceptor.requestError);}if(interceptor.response||interceptor.responseError){chain.push(interceptor.response,interceptor.responseError);}});while(chain.length){var thenFn=chain.shift();var rejectFn=chain.shift();promise=promise.then(thenFn,rejectFn);}if(useLegacyPromise){promise.success=function(fn){assertArgFn(fn,'fn');promise.then(function(response){fn(response.data,response.status,response.headers,config);});return promise;};promise.error=function(fn){assertArgFn(fn,'fn');promise.then(null,function(response){fn(response.data,response.status,response.headers,config);});return promise;};}else{promise.success=$httpMinErrLegacyFn('success');promise.error=$httpMinErrLegacyFn('error');}return promise;function transformResponse(response){// make a copy since the response must be cacheable
	var resp=extend({},response);resp.data=transformData(response.data,response.headers,response.status,config.transformResponse);return isSuccess(response.status)?resp:$q.reject(resp);}function executeHeaderFns(headers,config){var headerContent,processedHeaders={};forEach(headers,function(headerFn,header){if(isFunction(headerFn)){headerContent=headerFn(config);if(headerContent!=null){processedHeaders[header]=headerContent;}}else{processedHeaders[header]=headerFn;}});return processedHeaders;}function mergeHeaders(config){var defHeaders=defaults.headers,reqHeaders=extend({},config.headers),defHeaderName,lowercaseDefHeaderName,reqHeaderName;defHeaders=extend({},defHeaders.common,defHeaders[lowercase(config.method)]);// using for-in instead of forEach to avoid unecessary iteration after header has been found
	defaultHeadersIteration:for(defHeaderName in defHeaders){lowercaseDefHeaderName=lowercase(defHeaderName);for(reqHeaderName in reqHeaders){if(lowercase(reqHeaderName)===lowercaseDefHeaderName){continue defaultHeadersIteration;}}reqHeaders[defHeaderName]=defHeaders[defHeaderName];}// execute if header value is a function for merged headers
	return executeHeaderFns(reqHeaders,shallowCopy(config));}}$http.pendingRequests=[];/**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     *//**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     *//**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     *//**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request.
	     *                     The name of the callback should be the string `JSON_CALLBACK`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */createShortMethods('get','delete','head','jsonp');/**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     *//**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     *//**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */createShortMethodsWithData('post','put','patch');/**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */$http.defaults=defaults;return $http;function createShortMethods(names){forEach(arguments,function(name){$http[name]=function(url,config){return $http(extend({},config||{},{method:name,url:url}));};});}function createShortMethodsWithData(name){forEach(arguments,function(name){$http[name]=function(url,data,config){return $http(extend({},config||{},{method:name,url:url,data:data}));};});}/**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */function sendReq(config,reqData){var deferred=$q.defer(),promise=deferred.promise,cache,cachedResp,reqHeaders=config.headers,url=buildUrl(config.url,config.paramSerializer(config.params));$http.pendingRequests.push(config);promise.then(removePendingReq,removePendingReq);if((config.cache||defaults.cache)&&config.cache!==false&&(config.method==='GET'||config.method==='JSONP')){cache=isObject(config.cache)?config.cache:isObject(defaults.cache)?defaults.cache:defaultCache;}if(cache){cachedResp=cache.get(url);if(isDefined(cachedResp)){if(isPromiseLike(cachedResp)){// cached request has already been sent, but there is no response yet
	cachedResp.then(resolvePromiseWithResult,resolvePromiseWithResult);}else{// serving from cache
	if(isArray(cachedResp)){resolvePromise(cachedResp[1],cachedResp[0],shallowCopy(cachedResp[2]),cachedResp[3]);}else{resolvePromise(cachedResp,200,{},'OK');}}}else{// put the promise for the non-transformed response into cache as a placeholder
	cache.put(url,promise);}}// if we won't have the response in cache, set the xsrf headers and
	// send the request to the backend
	if(isUndefined(cachedResp)){var xsrfValue=urlIsSameOrigin(config.url)?$$cookieReader()[config.xsrfCookieName||defaults.xsrfCookieName]:undefined;if(xsrfValue){reqHeaders[config.xsrfHeaderName||defaults.xsrfHeaderName]=xsrfValue;}$httpBackend(config.method,url,reqData,done,reqHeaders,config.timeout,config.withCredentials,config.responseType);}return promise;/**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */function done(status,response,headersString,statusText){if(cache){if(isSuccess(status)){cache.put(url,[status,response,parseHeaders(headersString),statusText]);}else{// remove promise from the cache
	cache.remove(url);}}function resolveHttpPromise(){resolvePromise(response,status,headersString,statusText);}if(useApplyAsync){$rootScope.$applyAsync(resolveHttpPromise);}else{resolveHttpPromise();if(!$rootScope.$$phase)$rootScope.$apply();}}/**
	       * Resolves the raw $http promise.
	       */function resolvePromise(response,status,headers,statusText){//status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	status=status>=-1?status:0;(isSuccess(status)?deferred.resolve:deferred.reject)({data:response,status:status,headers:headersGetter(headers),config:config,statusText:statusText});}function resolvePromiseWithResult(result){resolvePromise(result.data,result.status,shallowCopy(result.headers()),result.statusText);}function removePendingReq(){var idx=$http.pendingRequests.indexOf(config);if(idx!==-1)$http.pendingRequests.splice(idx,1);}}function buildUrl(url,serializedParams){if(serializedParams.length>0){url+=(url.indexOf('?')==-1?'?':'&')+serializedParams;}return url;}}];}/**
	 * @ngdoc service
	 * @name $xhrFactory
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */function $xhrFactoryProvider(){this.$get=function(){return function createXhr(){return new window.XMLHttpRequest();};};}/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $window
	 * @requires $document
	 * @requires $xhrFactory
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */function $HttpBackendProvider(){this.$get=['$browser','$window','$document','$xhrFactory',function($browser,$window,$document,$xhrFactory){return createHttpBackend($browser,$xhrFactory,$browser.defer,$window.angular.callbacks,$document[0]);}];}function createHttpBackend($browser,createXhr,$browserDefer,callbacks,rawDocument){// TODO(vojta): fix the signature
	return function(method,url,post,callback,headers,timeout,withCredentials,responseType){$browser.$$incOutstandingRequestCount();url=url||$browser.url();if(lowercase(method)=='jsonp'){var callbackId='_'+(callbacks.counter++).toString(36);callbacks[callbackId]=function(data){callbacks[callbackId].data=data;callbacks[callbackId].called=true;};var jsonpDone=jsonpReq(url.replace('JSON_CALLBACK','angular.callbacks.'+callbackId),callbackId,function(status,text){completeRequest(callback,status,callbacks[callbackId].data,"",text);callbacks[callbackId]=noop;});}else{var xhr=createXhr(method,url);xhr.open(method,url,true);forEach(headers,function(value,key){if(isDefined(value)){xhr.setRequestHeader(key,value);}});xhr.onload=function requestLoaded(){var statusText=xhr.statusText||'';// responseText is the old-school way of retrieving response (supported by IE9)
	// response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	var response='response'in xhr?xhr.response:xhr.responseText;// normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	var status=xhr.status===1223?204:xhr.status;// fix status code when it is 0 (0 status is undocumented).
	// Occurs when accessing file resources or on Android 4.1 stock browser
	// while retrieving files from application cache.
	if(status===0){status=response?200:urlResolve(url).protocol=='file'?404:0;}completeRequest(callback,status,response,xhr.getAllResponseHeaders(),statusText);};var requestError=function requestError(){// The response is always empty
	// See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	completeRequest(callback,-1,null,null,'');};xhr.onerror=requestError;xhr.onabort=requestError;if(withCredentials){xhr.withCredentials=true;}if(responseType){try{xhr.responseType=responseType;}catch(e){// WebKit added support for the json responseType value on 09/03/2013
	// https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	// known to throw when setting the value "json" as the response type. Other older
	// browsers implementing the responseType
	//
	// The json response type can be ignored if not supported, because JSON payloads are
	// parsed on the client-side regardless.
	if(responseType!=='json'){throw e;}}}xhr.send(isUndefined(post)?null:post);}if(timeout>0){var timeoutId=$browserDefer(timeoutRequest,timeout);}else if(isPromiseLike(timeout)){timeout.then(timeoutRequest);}function timeoutRequest(){jsonpDone&&jsonpDone();xhr&&xhr.abort();}function completeRequest(callback,status,response,headersString,statusText){// cancel timeout and subsequent timeout promise resolution
	if(isDefined(timeoutId)){$browserDefer.cancel(timeoutId);}jsonpDone=xhr=null;callback(status,response,headersString,statusText);$browser.$$completeOutstandingRequest(noop);}};function jsonpReq(url,callbackId,done){// we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	// - fetches local scripts via XHR and evals them
	// - adds and immediately removes script elements from the document
	var script=rawDocument.createElement('script'),_callback=null;script.type="text/javascript";script.src=url;script.async=true;_callback=function callback(event){removeEventListenerFn(script,"load",_callback);removeEventListenerFn(script,"error",_callback);rawDocument.body.removeChild(script);script=null;var status=-1;var text="unknown";if(event){if(event.type==="load"&&!callbacks[callbackId].called){event={type:"error"};}text=event.type;status=event.type==="error"?404:200;}if(done){done(status,text);}};addEventListenerFn(script,"load",_callback);addEventListenerFn(script,"error",_callback);rawDocument.body.appendChild(script);return _callback;}}var $interpolateMinErr=angular.$interpolateMinErr=minErr('$interpolate');$interpolateMinErr.throwNoconcat=function(text){throw $interpolateMinErr('noconcat',"Error while interpolating: {0}\nStrict Contextual Escaping disallows "+"interpolations that concatenate multiple expressions when a trusted value is "+"required.  See http://docs.angularjs.org/api/ng.$sce",text);};$interpolateMinErr.interr=function(text,err){return $interpolateMinErr('interr',"Can't interpolate: {0}\n{1}",text,err.toString());};/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */function $InterpolateProvider(){var startSymbol='{{';var endSymbol='}}';/**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */this.startSymbol=function(value){if(value){startSymbol=value;return this;}else{return startSymbol;}};/**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */this.endSymbol=function(value){if(value){endSymbol=value;return this;}else{return endSymbol;}};this.$get=['$parse','$exceptionHandler','$sce',function($parse,$exceptionHandler,$sce){var startSymbolLength=startSymbol.length,endSymbolLength=endSymbol.length,escapedStartRegexp=new RegExp(startSymbol.replace(/./g,escape),'g'),escapedEndRegexp=new RegExp(endSymbol.replace(/./g,escape),'g');function escape(ch){return'\\\\\\'+ch;}function unescapeText(text){return text.replace(escapedStartRegexp,startSymbol).replace(escapedEndRegexp,endSymbol);}function stringify(value){if(value==null){// null || undefined
	return'';}switch(typeof value==='undefined'?'undefined':_typeof(value)){case'string':break;case'number':value=''+value;break;default:value=toJson(value);}return value;}/**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * ####Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example>
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */function $interpolate(text,mustHaveExpression,trustedContext,allOrNothing){allOrNothing=!!allOrNothing;var startIndex,endIndex,index=0,expressions=[],parseFns=[],textLength=text.length,exp,concat=[],expressionPositions=[];while(index<textLength){if((startIndex=text.indexOf(startSymbol,index))!=-1&&(endIndex=text.indexOf(endSymbol,startIndex+startSymbolLength))!=-1){if(index!==startIndex){concat.push(unescapeText(text.substring(index,startIndex)));}exp=text.substring(startIndex+startSymbolLength,endIndex);expressions.push(exp);parseFns.push($parse(exp,parseStringifyInterceptor));index=endIndex+endSymbolLength;expressionPositions.push(concat.length);concat.push('');}else{// we did not find an interpolation, so we have to add the remainder to the separators array
	if(index!==textLength){concat.push(unescapeText(text.substring(index)));}break;}}// Concatenating expressions makes it hard to reason about whether some combination of
	// concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	// single expression be used for iframe[src], object[src], etc., we ensure that the value
	// that's used is assigned or constructed by some JS code somewhere that is more testable or
	// make it obvious that you bound the value to some user controlled value.  This helps reduce
	// the load when auditing for XSS issues.
	if(trustedContext&&concat.length>1){$interpolateMinErr.throwNoconcat(text);}if(!mustHaveExpression||expressions.length){var compute=function compute(values){for(var i=0,ii=expressions.length;i<ii;i++){if(allOrNothing&&isUndefined(values[i]))return;concat[expressionPositions[i]]=values[i];}return concat.join('');};var getValue=function getValue(value){return trustedContext?$sce.getTrusted(trustedContext,value):$sce.valueOf(value);};return extend(function interpolationFn(context){var i=0;var ii=expressions.length;var values=new Array(ii);try{for(;i<ii;i++){values[i]=parseFns[i](context);}return compute(values);}catch(err){$exceptionHandler($interpolateMinErr.interr(text,err));}},{// all of these properties are undocumented for now
	exp:text,//just for compatibility with regular watchers created via $watch
	expressions:expressions,$$watchDelegate:function $$watchDelegate(scope,listener){var lastValue;return scope.$watchGroup(parseFns,function interpolateFnWatcher(values,oldValues){var currValue=compute(values);if(isFunction(listener)){listener.call(this,currValue,values!==oldValues?lastValue:currValue,scope);}lastValue=currValue;});}});}function parseStringifyInterceptor(value){try{value=getValue(value);return allOrNothing&&!isDefined(value)?value:stringify(value);}catch(err){$exceptionHandler($interpolateMinErr.interr(text,err));}}}/**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */$interpolate.startSymbol=function(){return startSymbol;};/**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */$interpolate.endSymbol=function(){return endSymbol;};return $interpolate;}];}function $IntervalProvider(){this.$get=['$rootScope','$window','$q','$$q',function($rootScope,$window,$q,$$q){var intervals={};/**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration.
	      *
	      * @example
	      * <example module="intervalExample">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */function interval(fn,delay,count,invokeApply){var hasParams=arguments.length>4,args=hasParams?sliceArgs(arguments,4):[],setInterval=$window.setInterval,clearInterval=$window.clearInterval,iteration=0,skipApply=isDefined(invokeApply)&&!invokeApply,deferred=(skipApply?$$q:$q).defer(),promise=deferred.promise;count=isDefined(count)?count:0;promise.then(null,null,!hasParams?fn:function(){fn.apply(null,args);});promise.$$intervalId=setInterval(function tick(){deferred.notify(iteration++);if(count>0&&iteration>=count){deferred.resolve(iteration);clearInterval(promise.$$intervalId);delete intervals[promise.$$intervalId];}if(!skipApply)$rootScope.$apply();},delay);intervals[promise.$$intervalId]=deferred;return promise;}/**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */interval.cancel=function(promise){if(promise&&promise.$$intervalId in intervals){intervals[promise.$$intervalId].reject('canceled');$window.clearInterval(promise.$$intervalId);delete intervals[promise.$$intervalId];return true;}return false;};return interval;}];}/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */var PATH_MATCH=/^([^\?#]*)(\?([^#]*))?(#(.*))?$/,DEFAULT_PORTS={'http':80,'https':443,'ftp':21};var $locationMinErr=minErr('$location');/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */function encodePath(path){var segments=path.split('/'),i=segments.length;while(i--){segments[i]=encodeUriSegment(segments[i]);}return segments.join('/');}function parseAbsoluteUrl(absoluteUrl,locationObj){var parsedUrl=urlResolve(absoluteUrl);locationObj.$$protocol=parsedUrl.protocol;locationObj.$$host=parsedUrl.hostname;locationObj.$$port=toInt(parsedUrl.port)||DEFAULT_PORTS[parsedUrl.protocol]||null;}function parseAppUrl(relativeUrl,locationObj){var prefixed=relativeUrl.charAt(0)!=='/';if(prefixed){relativeUrl='/'+relativeUrl;}var match=urlResolve(relativeUrl);locationObj.$$path=decodeURIComponent(prefixed&&match.pathname.charAt(0)==='/'?match.pathname.substring(1):match.pathname);locationObj.$$search=parseKeyValue(match.search);locationObj.$$hash=decodeURIComponent(match.hash);// make sure path starts with '/';
	if(locationObj.$$path&&locationObj.$$path.charAt(0)!='/'){locationObj.$$path='/'+locationObj.$$path;}}/**
	 *
	 * @param {string} begin
	 * @param {string} whole
	 * @returns {string} returns text from whole after begin or undefined if it does not begin with
	 *                   expected string.
	 */function beginsWith(begin,whole){if(whole.indexOf(begin)===0){return whole.substr(begin.length);}}function stripHash(url){var index=url.indexOf('#');return index==-1?url:url.substr(0,index);}function trimEmptyHash(url){return url.replace(/(#.+)|#$/,'$1');}function stripFile(url){return url.substr(0,stripHash(url).lastIndexOf('/')+1);}/* return the server only (scheme://host:port) */function serverBase(url){return url.substring(0,url.indexOf('/',url.indexOf('//')+2));}/**
	 * LocationHtml5Url represents an url
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix url path prefix
	 */function LocationHtml5Url(appBase,appBaseNoFile,basePrefix){this.$$html5=true;basePrefix=basePrefix||'';parseAbsoluteUrl(appBase,this);/**
	   * Parse given html5 (regular) url string into properties
	   * @param {string} url HTML5 url
	   * @private
	   */this.$$parse=function(url){var pathUrl=beginsWith(appBaseNoFile,url);if(!isString(pathUrl)){throw $locationMinErr('ipthprfx','Invalid url "{0}", missing path prefix "{1}".',url,appBaseNoFile);}parseAppUrl(pathUrl,this);if(!this.$$path){this.$$path='/';}this.$$compose();};/**
	   * Compose url and update `absUrl` property
	   * @private
	   */this.$$compose=function(){var search=toKeyValue(this.$$search),hash=this.$$hash?'#'+encodeUriSegment(this.$$hash):'';this.$$url=encodePath(this.$$path)+(search?'?'+search:'')+hash;this.$$absUrl=appBaseNoFile+this.$$url.substr(1);// first char is always '/'
	};this.$$parseLinkUrl=function(url,relHref){if(relHref&&relHref[0]==='#'){// special case for links to hash fragments:
	// keep the old url and only replace the hash fragment
	this.hash(relHref.slice(1));return true;}var appUrl,prevAppUrl;var rewrittenUrl;if(isDefined(appUrl=beginsWith(appBase,url))){prevAppUrl=appUrl;if(isDefined(appUrl=beginsWith(basePrefix,appUrl))){rewrittenUrl=appBaseNoFile+(beginsWith('/',appUrl)||appUrl);}else{rewrittenUrl=appBase+prevAppUrl;}}else if(isDefined(appUrl=beginsWith(appBaseNoFile,url))){rewrittenUrl=appBaseNoFile+appUrl;}else if(appBaseNoFile==url+'/'){rewrittenUrl=appBaseNoFile;}if(rewrittenUrl){this.$$parse(rewrittenUrl);}return!!rewrittenUrl;};}/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */function LocationHashbangUrl(appBase,appBaseNoFile,hashPrefix){parseAbsoluteUrl(appBase,this);/**
	   * Parse given hashbang url into properties
	   * @param {string} url Hashbang url
	   * @private
	   */this.$$parse=function(url){var withoutBaseUrl=beginsWith(appBase,url)||beginsWith(appBaseNoFile,url);var withoutHashUrl;if(!isUndefined(withoutBaseUrl)&&withoutBaseUrl.charAt(0)==='#'){// The rest of the url starts with a hash so we have
	// got either a hashbang path or a plain hash fragment
	withoutHashUrl=beginsWith(hashPrefix,withoutBaseUrl);if(isUndefined(withoutHashUrl)){// There was no hashbang prefix so we just have a hash fragment
	withoutHashUrl=withoutBaseUrl;}}else{// There was no hashbang path nor hash fragment:
	// If we are in HTML5 mode we use what is left as the path;
	// Otherwise we ignore what is left
	if(this.$$html5){withoutHashUrl=withoutBaseUrl;}else{withoutHashUrl='';if(isUndefined(withoutBaseUrl)){appBase=url;this.replace();}}}parseAppUrl(withoutHashUrl,this);this.$$path=removeWindowsDriveName(this.$$path,withoutHashUrl,appBase);this.$$compose();/*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */function removeWindowsDriveName(path,url,base){/*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */var windowsFilePathExp=/^\/[A-Z]:(\/.*)/;var firstPathSegmentMatch;//Get the relative path from the input URL.
	if(url.indexOf(base)===0){url=url.replace(base,'');}// The input URL intentionally contains a first path segment that ends with a colon.
	if(windowsFilePathExp.exec(url)){return path;}firstPathSegmentMatch=windowsFilePathExp.exec(path);return firstPathSegmentMatch?firstPathSegmentMatch[1]:path;}};/**
	   * Compose hashbang url and update `absUrl` property
	   * @private
	   */this.$$compose=function(){var search=toKeyValue(this.$$search),hash=this.$$hash?'#'+encodeUriSegment(this.$$hash):'';this.$$url=encodePath(this.$$path)+(search?'?'+search:'')+hash;this.$$absUrl=appBase+(this.$$url?hashPrefix+this.$$url:'');};this.$$parseLinkUrl=function(url,relHref){if(stripHash(appBase)==stripHash(url)){this.$$parse(url);return true;}return false;};}/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */function LocationHashbangInHtml5Url(appBase,appBaseNoFile,hashPrefix){this.$$html5=true;LocationHashbangUrl.apply(this,arguments);this.$$parseLinkUrl=function(url,relHref){if(relHref&&relHref[0]==='#'){// special case for links to hash fragments:
	// keep the old url and only replace the hash fragment
	this.hash(relHref.slice(1));return true;}var rewrittenUrl;var appUrl;if(appBase==stripHash(url)){rewrittenUrl=url;}else if(appUrl=beginsWith(appBaseNoFile,url)){rewrittenUrl=appBase+hashPrefix+appUrl;}else if(appBaseNoFile===url+'/'){rewrittenUrl=appBaseNoFile;}if(rewrittenUrl){this.$$parse(rewrittenUrl);}return!!rewrittenUrl;};this.$$compose=function(){var search=toKeyValue(this.$$search),hash=this.$$hash?'#'+encodeUriSegment(this.$$hash):'';this.$$url=encodePath(this.$$path)+(search?'?'+search:'')+hash;// include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	this.$$absUrl=appBase+hashPrefix+this.$$url;};}var locationPrototype={/**
	   * Are we in html5 mode?
	   * @private
	   */$$html5:false,/**
	   * Has any change been replacing?
	   * @private
	   */$$replace:false,/**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full url representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full url
	   */absUrl:locationGetter('$$absUrl'),/**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return url (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New url without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */url:function url(_url){if(isUndefined(_url)){return this.$$url;}var match=PATH_MATCH.exec(_url);if(match[1]||_url==='')this.path(decodeURIComponent(match[1]));if(match[2]||match[1]||_url==='')this.search(match[3]||'');this.hash(match[5]||'');return this;},/**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current url
	   */protocol:locationGetter('$$protocol'),/**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current url.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given url http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current url.
	   */host:locationGetter('$$host'),/**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */port:locationGetter('$$port'),/**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current url when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */path:locationGetterSetter('$$path',function(path){path=path!==null?path.toString():'';return path.charAt(0)=='/'?path:'/'+path;}),/**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current url when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the url.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */search:function search(_search,paramValue){switch(arguments.length){case 0:return this.$$search;case 1:if(isString(_search)||isNumber(_search)){_search=_search.toString();this.$$search=parseKeyValue(_search);}else if(isObject(_search)){_search=copy(_search,{});// remove object undefined or null properties
	forEach(_search,function(value,key){if(value==null)delete _search[key];});this.$$search=_search;}else{throw $locationMinErr('isrcharg','The first argument of the `$location#search()` call must be a string or an object.');}break;default:if(isUndefined(paramValue)||paramValue===null){delete this.$$search[_search];}else{this.$$search[_search]=paramValue;}}this.$$compose();return this;},/**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */hash:locationGetterSetter('$$hash',function(hash){return hash!==null?hash.toString():'';}),/**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */replace:function replace(){this.$$replace=true;return this;}};forEach([LocationHashbangInHtml5Url,LocationHashbangUrl,LocationHtml5Url],function(Location){Location.prototype=Object.create(locationPrototype);/**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */Location.prototype.state=function(state){if(!arguments.length){return this.$$state;}if(Location!==LocationHtml5Url||!this.$$html5){throw $locationMinErr('nostate','History API state support is available only '+'in HTML5 mode and only in browsers supporting HTML5 History API');}// The user might modify `stateObject` after invoking `$location.state(stateObject)`
	// but we're changing the $$state reference to $browser.state() during the $digest
	// so the modification window is narrow.
	this.$$state=isUndefined(state)?null:state;return this;};});function locationGetter(property){return function(){return this[property];};}function locationGetterSetter(property,preprocess){return function(value){if(isUndefined(value)){return this[property];}this[property]=preprocess(value);this.$$compose();return this;};}/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 *//**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */function $LocationProvider(){var hashPrefix='',html5Mode={enabled:false,requireBase:true,rewriteLinks:true};/**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */this.hashPrefix=function(prefix){if(isDefined(prefix)){hashPrefix=prefix;return this;}else{return hashPrefix;}};/**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables url rewriting for relative links.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */this.html5Mode=function(mode){if(isBoolean(mode)){html5Mode.enabled=mode;return this;}else if(isObject(mode)){if(isBoolean(mode.enabled)){html5Mode.enabled=mode.enabled;}if(isBoolean(mode.requireBase)){html5Mode.requireBase=mode.requireBase;}if(isBoolean(mode.rewriteLinks)){html5Mode.rewriteLinks=mode.rewriteLinks;}return this;}else{return html5Mode;}};/**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   *//**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */this.$get=['$rootScope','$browser','$sniffer','$rootElement','$window',function($rootScope,$browser,$sniffer,$rootElement,$window){var $location,LocationMode,baseHref=$browser.baseHref(),// if base[href] is undefined, it defaults to ''
	initialUrl=$browser.url(),appBase;if(html5Mode.enabled){if(!baseHref&&html5Mode.requireBase){throw $locationMinErr('nobase',"$location in HTML5 mode requires a <base> tag to be present!");}appBase=serverBase(initialUrl)+(baseHref||'/');LocationMode=$sniffer.history?LocationHtml5Url:LocationHashbangInHtml5Url;}else{appBase=stripHash(initialUrl);LocationMode=LocationHashbangUrl;}var appBaseNoFile=stripFile(appBase);$location=new LocationMode(appBase,appBaseNoFile,'#'+hashPrefix);$location.$$parseLinkUrl(initialUrl,initialUrl);$location.$$state=$browser.state();var IGNORE_URI_REGEXP=/^\s*(javascript|mailto):/i;function setBrowserUrlWithFallback(url,replace,state){var oldUrl=$location.url();var oldState=$location.$$state;try{$browser.url(url,replace,state);// Make sure $location.state() returns referentially identical (not just deeply equal)
	// state object; this makes possible quick checking if the state changed in the digest
	// loop. Checking deep equality would be too expensive.
	$location.$$state=$browser.state();}catch(e){// Restore old values if pushState fails
	$location.url(oldUrl);$location.$$state=oldState;throw e;}}$rootElement.on('click',function(event){// TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	// currently we open nice url link and redirect then
	if(!html5Mode.rewriteLinks||event.ctrlKey||event.metaKey||event.shiftKey||event.which==2||event.button==2)return;var elm=jqLite(event.target);// traverse the DOM up to find first A tag
	while(nodeName_(elm[0])!=='a'){// ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	if(elm[0]===$rootElement[0]||!(elm=elm.parent())[0])return;}var absHref=elm.prop('href');// get the actual href attribute - see
	// http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	var relHref=elm.attr('href')||elm.attr('xlink:href');if(isObject(absHref)&&absHref.toString()==='[object SVGAnimatedString]'){// SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	// an animation.
	absHref=urlResolve(absHref.animVal).href;}// Ignore when url is started with javascript: or mailto:
	if(IGNORE_URI_REGEXP.test(absHref))return;if(absHref&&!elm.attr('target')&&!event.isDefaultPrevented()){if($location.$$parseLinkUrl(absHref,relHref)){// We do a preventDefault for all urls that are part of the angular application,
	// in html5mode and also without, so that we are able to abort navigation without
	// getting double entries in the location history.
	event.preventDefault();// update location manually
	if($location.absUrl()!=$browser.url()){$rootScope.$apply();// hack to work around FF6 bug 684208 when scenario runner clicks on links
	$window.angular['ff-684208-preventDefault']=true;}}}});// rewrite hashbang url <> html5 url
	if(trimEmptyHash($location.absUrl())!=trimEmptyHash(initialUrl)){$browser.url($location.absUrl(),true);}var initializing=true;// update $location when $browser url changes
	$browser.onUrlChange(function(newUrl,newState){if(isUndefined(beginsWith(appBaseNoFile,newUrl))){// If we are navigating outside of the app then force a reload
	$window.location.href=newUrl;return;}$rootScope.$evalAsync(function(){var oldUrl=$location.absUrl();var oldState=$location.$$state;var defaultPrevented;newUrl=trimEmptyHash(newUrl);$location.$$parse(newUrl);$location.$$state=newState;defaultPrevented=$rootScope.$broadcast('$locationChangeStart',newUrl,oldUrl,newState,oldState).defaultPrevented;// if the location was changed by a `$locationChangeStart` handler then stop
	// processing this location change
	if($location.absUrl()!==newUrl)return;if(defaultPrevented){$location.$$parse(oldUrl);$location.$$state=oldState;setBrowserUrlWithFallback(oldUrl,false,oldState);}else{initializing=false;afterLocationChange(oldUrl,oldState);}});if(!$rootScope.$$phase)$rootScope.$digest();});// update browser
	$rootScope.$watch(function $locationWatch(){var oldUrl=trimEmptyHash($browser.url());var newUrl=trimEmptyHash($location.absUrl());var oldState=$browser.state();var currentReplace=$location.$$replace;var urlOrStateChanged=oldUrl!==newUrl||$location.$$html5&&$sniffer.history&&oldState!==$location.$$state;if(initializing||urlOrStateChanged){initializing=false;$rootScope.$evalAsync(function(){var newUrl=$location.absUrl();var defaultPrevented=$rootScope.$broadcast('$locationChangeStart',newUrl,oldUrl,$location.$$state,oldState).defaultPrevented;// if the location was changed by a `$locationChangeStart` handler then stop
	// processing this location change
	if($location.absUrl()!==newUrl)return;if(defaultPrevented){$location.$$parse(oldUrl);$location.$$state=oldState;}else{if(urlOrStateChanged){setBrowserUrlWithFallback(newUrl,currentReplace,oldState===$location.$$state?null:$location.$$state);}afterLocationChange(oldUrl,oldState);}});}$location.$$replace=false;// we don't need to return anything because $evalAsync will make the digest loop dirty when
	// there is a change
	});return $location;function afterLocationChange(oldUrl,oldState){$rootScope.$broadcast('$locationChangeSuccess',$location.absUrl(),oldUrl,$location.$$state,oldState);}}];}/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 *//**
	 * @ngdoc provider
	 * @name $logProvider
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */function $LogProvider(){var debug=true,self=this;/**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */this.debugEnabled=function(flag){if(isDefined(flag)){debug=flag;return this;}else{return debug;}};this.$get=['$window',function($window){return{/**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */log:consoleLog('log'),/**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */info:consoleLog('info'),/**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */warn:consoleLog('warn'),/**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */error:consoleLog('error'),/**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */debug:function(){var fn=consoleLog('debug');return function(){if(debug){fn.apply(self,arguments);}};}()};function formatError(arg){if(arg instanceof Error){if(arg.stack){arg=arg.message&&arg.stack.indexOf(arg.message)===-1?'Error: '+arg.message+'\n'+arg.stack:arg.stack;}else if(arg.sourceURL){arg=arg.message+'\n'+arg.sourceURL+':'+arg.line;}}return arg;}function consoleLog(type){var console=$window.console||{},logFn=console[type]||console.log||noop,hasApply=false;// Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
	// The reason behind this is that console.log has type "object" in IE8...
	try{hasApply=!!logFn.apply;}catch(e){}if(hasApply){return function(){var args=[];forEach(arguments,function(arg){args.push(formatError(arg));});return logFn.apply(console,args);};}// we are IE which either doesn't have window.console => this is noop and we do nothing,
	// or we are IE where console.log doesn't have apply so we log at least first 2 args
	return function(arg1,arg2){logFn(arg1,arg2==null?'':arg2);};}}];}/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */var $parseMinErr=minErr('$parse');// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are generally considered safe because these expressions only have direct
	// access to `$scope` and locals. However, one can obtain the ability to execute arbitrary JS code by
	// obtaining a reference to native JS functions such as the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
	// against the expression language, but not to prevent exploits that were enabled by exposing
	// sensitive JavaScript or browser APIs on Scope. Exposing such objects on a Scope is never a good
	// practice and therefore we are not even trying to protect against interaction with an object
	// explicitly exposed in this way.
	//
	// In general, it is not possible to access a Window object from an angular expression unless a
	// window or some DOM object that has a reference to window is published onto a Scope.
	// Similarly we prevent invocations of function known to be dangerous, as well as assignments to
	// native objects.
	//
	// See https://docs.angularjs.org/guide/security
	function ensureSafeMemberName(name,fullExpression){if(name==="__defineGetter__"||name==="__defineSetter__"||name==="__lookupGetter__"||name==="__lookupSetter__"||name==="__proto__"){throw $parseMinErr('isecfld','Attempting to access a disallowed field in Angular expressions! '+'Expression: {0}',fullExpression);}return name;}function getStringValue(name,fullExpression){// From the JavaScript docs:
	// Property names must be strings. This means that non-string objects cannot be used
	// as keys in an object. Any non-string object, including a number, is typecasted
	// into a string via the toString method.
	//
	// So, to ensure that we are checking the same `name` that JavaScript would use,
	// we cast it to a string, if possible.
	// Doing `name + ''` can cause a repl error if the result to `toString` is not a string,
	// this is, this will handle objects that misbehave.
	name=name+'';if(!isString(name)){throw $parseMinErr('iseccst','Cannot convert object to primitive value! '+'Expression: {0}',fullExpression);}return name;}function ensureSafeObject(obj,fullExpression){// nifty check if obj is Function that is fast and works across iframes and other contexts
	if(obj){if(obj.constructor===obj){throw $parseMinErr('isecfn','Referencing Function in Angular expressions is disallowed! Expression: {0}',fullExpression);}else if(// isWindow(obj)
	obj.window===obj){throw $parseMinErr('isecwindow','Referencing the Window in Angular expressions is disallowed! Expression: {0}',fullExpression);}else if(// isElement(obj)
	obj.children&&(obj.nodeName||obj.prop&&obj.attr&&obj.find)){throw $parseMinErr('isecdom','Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}',fullExpression);}else if(// block Object so that we can't get hold of dangerous Object.* methods
	obj===Object){throw $parseMinErr('isecobj','Referencing Object in Angular expressions is disallowed! Expression: {0}',fullExpression);}}return obj;}var CALL=Function.prototype.call;var APPLY=Function.prototype.apply;var BIND=Function.prototype.bind;function ensureSafeFunction(obj,fullExpression){if(obj){if(obj.constructor===obj){throw $parseMinErr('isecfn','Referencing Function in Angular expressions is disallowed! Expression: {0}',fullExpression);}else if(obj===CALL||obj===APPLY||obj===BIND){throw $parseMinErr('isecff','Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}',fullExpression);}}}function ensureSafeAssignContext(obj,fullExpression){if(obj){if(obj===0 .constructor||obj===false.constructor||obj===''.constructor||obj==={}.constructor||obj===[].constructor||obj===Function.constructor){throw $parseMinErr('isecaf','Assigning to a constructor is disallowed! Expression: {0}',fullExpression);}}}var OPERATORS=createMap();forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '),function(operator){OPERATORS[operator]=true;});var ESCAPE={"n":"\n","f":"\f","r":"\r","t":"\t","v":"\v","'":"'",'"':'"'};/////////////////////////////////////////
	/**
	 * @constructor
	 */var Lexer=function Lexer(options){this.options=options;};Lexer.prototype={constructor:Lexer,lex:function lex(text){this.text=text;this.index=0;this.tokens=[];while(this.index<this.text.length){var ch=this.text.charAt(this.index);if(ch==='"'||ch==="'"){this.readString(ch);}else if(this.isNumber(ch)||ch==='.'&&this.isNumber(this.peek())){this.readNumber();}else if(this.isIdent(ch)){this.readIdent();}else if(this.is(ch,'(){}[].,;:?')){this.tokens.push({index:this.index,text:ch});this.index++;}else if(this.isWhitespace(ch)){this.index++;}else{var ch2=ch+this.peek();var ch3=ch2+this.peek(2);var op1=OPERATORS[ch];var op2=OPERATORS[ch2];var op3=OPERATORS[ch3];if(op1||op2||op3){var token=op3?ch3:op2?ch2:ch;this.tokens.push({index:this.index,text:token,operator:true});this.index+=token.length;}else{this.throwError('Unexpected next character ',this.index,this.index+1);}}}return this.tokens;},is:function is(ch,chars){return chars.indexOf(ch)!==-1;},peek:function peek(i){var num=i||1;return this.index+num<this.text.length?this.text.charAt(this.index+num):false;},isNumber:function isNumber(ch){return'0'<=ch&&ch<='9'&&typeof ch==="string";},isWhitespace:function isWhitespace(ch){// IE treats non-breaking space as \u00A0
	return ch===' '||ch==='\r'||ch==='\t'||ch==='\n'||ch==='\v'||ch==='\xA0';},isIdent:function isIdent(ch){return'a'<=ch&&ch<='z'||'A'<=ch&&ch<='Z'||'_'===ch||ch==='$';},isExpOperator:function isExpOperator(ch){return ch==='-'||ch==='+'||this.isNumber(ch);},throwError:function throwError(error,start,end){end=end||this.index;var colStr=isDefined(start)?'s '+start+'-'+this.index+' ['+this.text.substring(start,end)+']':' '+end;throw $parseMinErr('lexerr','Lexer Error: {0} at column{1} in expression [{2}].',error,colStr,this.text);},readNumber:function readNumber(){var number='';var start=this.index;while(this.index<this.text.length){var ch=lowercase(this.text.charAt(this.index));if(ch=='.'||this.isNumber(ch)){number+=ch;}else{var peekCh=this.peek();if(ch=='e'&&this.isExpOperator(peekCh)){number+=ch;}else if(this.isExpOperator(ch)&&peekCh&&this.isNumber(peekCh)&&number.charAt(number.length-1)=='e'){number+=ch;}else if(this.isExpOperator(ch)&&(!peekCh||!this.isNumber(peekCh))&&number.charAt(number.length-1)=='e'){this.throwError('Invalid exponent');}else{break;}}this.index++;}this.tokens.push({index:start,text:number,constant:true,value:Number(number)});},readIdent:function readIdent(){var start=this.index;while(this.index<this.text.length){var ch=this.text.charAt(this.index);if(!(this.isIdent(ch)||this.isNumber(ch))){break;}this.index++;}this.tokens.push({index:start,text:this.text.slice(start,this.index),identifier:true});},readString:function readString(quote){var start=this.index;this.index++;var string='';var rawString=quote;var escape=false;while(this.index<this.text.length){var ch=this.text.charAt(this.index);rawString+=ch;if(escape){if(ch==='u'){var hex=this.text.substring(this.index+1,this.index+5);if(!hex.match(/[\da-f]{4}/i)){this.throwError('Invalid unicode escape [\\u'+hex+']');}this.index+=4;string+=String.fromCharCode(parseInt(hex,16));}else{var rep=ESCAPE[ch];string=string+(rep||ch);}escape=false;}else if(ch==='\\'){escape=true;}else if(ch===quote){this.index++;this.tokens.push({index:start,text:rawString,constant:true,value:string});return;}else{string+=ch;}this.index++;}this.throwError('Unterminated quote',start);}};var AST=function AST(lexer,options){this.lexer=lexer;this.options=options;};AST.Program='Program';AST.ExpressionStatement='ExpressionStatement';AST.AssignmentExpression='AssignmentExpression';AST.ConditionalExpression='ConditionalExpression';AST.LogicalExpression='LogicalExpression';AST.BinaryExpression='BinaryExpression';AST.UnaryExpression='UnaryExpression';AST.CallExpression='CallExpression';AST.MemberExpression='MemberExpression';AST.Identifier='Identifier';AST.Literal='Literal';AST.ArrayExpression='ArrayExpression';AST.Property='Property';AST.ObjectExpression='ObjectExpression';AST.ThisExpression='ThisExpression';// Internal use only
	AST.NGValueParameter='NGValueParameter';AST.prototype={ast:function ast(text){this.text=text;this.tokens=this.lexer.lex(text);var value=this.program();if(this.tokens.length!==0){this.throwError('is an unexpected token',this.tokens[0]);}return value;},program:function program(){var body=[];while(true){if(this.tokens.length>0&&!this.peek('}',')',';',']'))body.push(this.expressionStatement());if(!this.expect(';')){return{type:AST.Program,body:body};}}},expressionStatement:function expressionStatement(){return{type:AST.ExpressionStatement,expression:this.filterChain()};},filterChain:function filterChain(){var left=this.expression();var token;while(token=this.expect('|')){left=this.filter(left);}return left;},expression:function expression(){return this.assignment();},assignment:function assignment(){var result=this.ternary();if(this.expect('=')){result={type:AST.AssignmentExpression,left:result,right:this.assignment(),operator:'='};}return result;},ternary:function ternary(){var test=this.logicalOR();var alternate;var consequent;if(this.expect('?')){alternate=this.expression();if(this.consume(':')){consequent=this.expression();return{type:AST.ConditionalExpression,test:test,alternate:alternate,consequent:consequent};}}return test;},logicalOR:function logicalOR(){var left=this.logicalAND();while(this.expect('||')){left={type:AST.LogicalExpression,operator:'||',left:left,right:this.logicalAND()};}return left;},logicalAND:function logicalAND(){var left=this.equality();while(this.expect('&&')){left={type:AST.LogicalExpression,operator:'&&',left:left,right:this.equality()};}return left;},equality:function equality(){var left=this.relational();var token;while(token=this.expect('==','!=','===','!==')){left={type:AST.BinaryExpression,operator:token.text,left:left,right:this.relational()};}return left;},relational:function relational(){var left=this.additive();var token;while(token=this.expect('<','>','<=','>=')){left={type:AST.BinaryExpression,operator:token.text,left:left,right:this.additive()};}return left;},additive:function additive(){var left=this.multiplicative();var token;while(token=this.expect('+','-')){left={type:AST.BinaryExpression,operator:token.text,left:left,right:this.multiplicative()};}return left;},multiplicative:function multiplicative(){var left=this.unary();var token;while(token=this.expect('*','/','%')){left={type:AST.BinaryExpression,operator:token.text,left:left,right:this.unary()};}return left;},unary:function unary(){var token;if(token=this.expect('+','-','!')){return{type:AST.UnaryExpression,operator:token.text,prefix:true,argument:this.unary()};}else{return this.primary();}},primary:function primary(){var primary;if(this.expect('(')){primary=this.filterChain();this.consume(')');}else if(this.expect('[')){primary=this.arrayDeclaration();}else if(this.expect('{')){primary=this.object();}else if(this.constants.hasOwnProperty(this.peek().text)){primary=copy(this.constants[this.consume().text]);}else if(this.peek().identifier){primary=this.identifier();}else if(this.peek().constant){primary=this.constant();}else{this.throwError('not a primary expression',this.peek());}var next;while(next=this.expect('(','[','.')){if(next.text==='('){primary={type:AST.CallExpression,callee:primary,arguments:this.parseArguments()};this.consume(')');}else if(next.text==='['){primary={type:AST.MemberExpression,object:primary,property:this.expression(),computed:true};this.consume(']');}else if(next.text==='.'){primary={type:AST.MemberExpression,object:primary,property:this.identifier(),computed:false};}else{this.throwError('IMPOSSIBLE');}}return primary;},filter:function filter(baseExpression){var args=[baseExpression];var result={type:AST.CallExpression,callee:this.identifier(),arguments:args,filter:true};while(this.expect(':')){args.push(this.expression());}return result;},parseArguments:function parseArguments(){var args=[];if(this.peekToken().text!==')'){do{args.push(this.expression());}while(this.expect(','));}return args;},identifier:function identifier(){var token=this.consume();if(!token.identifier){this.throwError('is not a valid identifier',token);}return{type:AST.Identifier,name:token.text};},constant:function constant(){// TODO check that it is a constant
	return{type:AST.Literal,value:this.consume().value};},arrayDeclaration:function arrayDeclaration(){var elements=[];if(this.peekToken().text!==']'){do{if(this.peek(']')){// Support trailing commas per ES5.1.
	break;}elements.push(this.expression());}while(this.expect(','));}this.consume(']');return{type:AST.ArrayExpression,elements:elements};},object:function object(){var properties=[],property;if(this.peekToken().text!=='}'){do{if(this.peek('}')){// Support trailing commas per ES5.1.
	break;}property={type:AST.Property,kind:'init'};if(this.peek().constant){property.key=this.constant();}else if(this.peek().identifier){property.key=this.identifier();}else{this.throwError("invalid key",this.peek());}this.consume(':');property.value=this.expression();properties.push(property);}while(this.expect(','));}this.consume('}');return{type:AST.ObjectExpression,properties:properties};},throwError:function throwError(msg,token){throw $parseMinErr('syntax','Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',token.text,msg,token.index+1,this.text,this.text.substring(token.index));},consume:function consume(e1){if(this.tokens.length===0){throw $parseMinErr('ueoe','Unexpected end of expression: {0}',this.text);}var token=this.expect(e1);if(!token){this.throwError('is unexpected, expecting ['+e1+']',this.peek());}return token;},peekToken:function peekToken(){if(this.tokens.length===0){throw $parseMinErr('ueoe','Unexpected end of expression: {0}',this.text);}return this.tokens[0];},peek:function peek(e1,e2,e3,e4){return this.peekAhead(0,e1,e2,e3,e4);},peekAhead:function peekAhead(i,e1,e2,e3,e4){if(this.tokens.length>i){var token=this.tokens[i];var t=token.text;if(t===e1||t===e2||t===e3||t===e4||!e1&&!e2&&!e3&&!e4){return token;}}return false;},expect:function expect(e1,e2,e3,e4){var token=this.peek(e1,e2,e3,e4);if(token){this.tokens.shift();return token;}return false;},/* `undefined` is not a constant, it is an identifier,
	   * but using it as an identifier is not supported
	   */constants:{'true':{type:AST.Literal,value:true},'false':{type:AST.Literal,value:false},'null':{type:AST.Literal,value:null},'undefined':{type:AST.Literal,value:undefined},'this':{type:AST.ThisExpression}}};function ifDefined(v,d){return typeof v!=='undefined'?v:d;}function plusFn(l,r){if(typeof l==='undefined')return r;if(typeof r==='undefined')return l;return l+r;}function isStateless($filter,filterName){var fn=$filter(filterName);return!fn.$stateful;}function findConstantAndWatchExpressions(ast,$filter){var allConstants;var argsToWatch;switch(ast.type){case AST.Program:allConstants=true;forEach(ast.body,function(expr){findConstantAndWatchExpressions(expr.expression,$filter);allConstants=allConstants&&expr.expression.constant;});ast.constant=allConstants;break;case AST.Literal:ast.constant=true;ast.toWatch=[];break;case AST.UnaryExpression:findConstantAndWatchExpressions(ast.argument,$filter);ast.constant=ast.argument.constant;ast.toWatch=ast.argument.toWatch;break;case AST.BinaryExpression:findConstantAndWatchExpressions(ast.left,$filter);findConstantAndWatchExpressions(ast.right,$filter);ast.constant=ast.left.constant&&ast.right.constant;ast.toWatch=ast.left.toWatch.concat(ast.right.toWatch);break;case AST.LogicalExpression:findConstantAndWatchExpressions(ast.left,$filter);findConstantAndWatchExpressions(ast.right,$filter);ast.constant=ast.left.constant&&ast.right.constant;ast.toWatch=ast.constant?[]:[ast];break;case AST.ConditionalExpression:findConstantAndWatchExpressions(ast.test,$filter);findConstantAndWatchExpressions(ast.alternate,$filter);findConstantAndWatchExpressions(ast.consequent,$filter);ast.constant=ast.test.constant&&ast.alternate.constant&&ast.consequent.constant;ast.toWatch=ast.constant?[]:[ast];break;case AST.Identifier:ast.constant=false;ast.toWatch=[ast];break;case AST.MemberExpression:findConstantAndWatchExpressions(ast.object,$filter);if(ast.computed){findConstantAndWatchExpressions(ast.property,$filter);}ast.constant=ast.object.constant&&(!ast.computed||ast.property.constant);ast.toWatch=[ast];break;case AST.CallExpression:allConstants=ast.filter?isStateless($filter,ast.callee.name):false;argsToWatch=[];forEach(ast.arguments,function(expr){findConstantAndWatchExpressions(expr,$filter);allConstants=allConstants&&expr.constant;if(!expr.constant){argsToWatch.push.apply(argsToWatch,expr.toWatch);}});ast.constant=allConstants;ast.toWatch=ast.filter&&isStateless($filter,ast.callee.name)?argsToWatch:[ast];break;case AST.AssignmentExpression:findConstantAndWatchExpressions(ast.left,$filter);findConstantAndWatchExpressions(ast.right,$filter);ast.constant=ast.left.constant&&ast.right.constant;ast.toWatch=[ast];break;case AST.ArrayExpression:allConstants=true;argsToWatch=[];forEach(ast.elements,function(expr){findConstantAndWatchExpressions(expr,$filter);allConstants=allConstants&&expr.constant;if(!expr.constant){argsToWatch.push.apply(argsToWatch,expr.toWatch);}});ast.constant=allConstants;ast.toWatch=argsToWatch;break;case AST.ObjectExpression:allConstants=true;argsToWatch=[];forEach(ast.properties,function(property){findConstantAndWatchExpressions(property.value,$filter);allConstants=allConstants&&property.value.constant;if(!property.value.constant){argsToWatch.push.apply(argsToWatch,property.value.toWatch);}});ast.constant=allConstants;ast.toWatch=argsToWatch;break;case AST.ThisExpression:ast.constant=false;ast.toWatch=[];break;}}function getInputs(body){if(body.length!=1)return;var lastExpression=body[0].expression;var candidate=lastExpression.toWatch;if(candidate.length!==1)return candidate;return candidate[0]!==lastExpression?candidate:undefined;}function isAssignable(ast){return ast.type===AST.Identifier||ast.type===AST.MemberExpression;}function assignableAST(ast){if(ast.body.length===1&&isAssignable(ast.body[0].expression)){return{type:AST.AssignmentExpression,left:ast.body[0].expression,right:{type:AST.NGValueParameter},operator:'='};}}function isLiteral(ast){return ast.body.length===0||ast.body.length===1&&(ast.body[0].expression.type===AST.Literal||ast.body[0].expression.type===AST.ArrayExpression||ast.body[0].expression.type===AST.ObjectExpression);}function isConstant(ast){return ast.constant;}function ASTCompiler(astBuilder,$filter){this.astBuilder=astBuilder;this.$filter=$filter;}ASTCompiler.prototype={compile:function compile(expression,expensiveChecks){var self=this;var ast=this.astBuilder.ast(expression);this.state={nextId:0,filters:{},expensiveChecks:expensiveChecks,fn:{vars:[],body:[],own:{}},assign:{vars:[],body:[],own:{}},inputs:[]};findConstantAndWatchExpressions(ast,self.$filter);var extra='';var assignable;this.stage='assign';if(assignable=assignableAST(ast)){this.state.computing='assign';var result=this.nextId();this.recurse(assignable,result);this.return_(result);extra='fn.assign='+this.generateFunction('assign','s,v,l');}var toWatch=getInputs(ast.body);self.stage='inputs';forEach(toWatch,function(watch,key){var fnKey='fn'+key;self.state[fnKey]={vars:[],body:[],own:{}};self.state.computing=fnKey;var intoId=self.nextId();self.recurse(watch,intoId);self.return_(intoId);self.state.inputs.push(fnKey);watch.watchId=key;});this.state.computing='fn';this.stage='main';this.recurse(ast);var fnString=// The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	// This is a workaround for this until we do a better job at only removing the prefix only when we should.
	'"'+this.USE+' '+this.STRICT+'";\n'+this.filterPrefix()+'var fn='+this.generateFunction('fn','s,l,a,i')+extra+this.watchFns()+'return fn;';/* jshint -W054 */var fn=new Function('$filter','ensureSafeMemberName','ensureSafeObject','ensureSafeFunction','getStringValue','ensureSafeAssignContext','ifDefined','plus','text',fnString)(this.$filter,ensureSafeMemberName,ensureSafeObject,ensureSafeFunction,getStringValue,ensureSafeAssignContext,ifDefined,plusFn,expression);/* jshint +W054 */this.state=this.stage=undefined;fn.literal=isLiteral(ast);fn.constant=isConstant(ast);return fn;},USE:'use',STRICT:'strict',watchFns:function watchFns(){var result=[];var fns=this.state.inputs;var self=this;forEach(fns,function(name){result.push('var '+name+'='+self.generateFunction(name,'s'));});if(fns.length){result.push('fn.inputs=['+fns.join(',')+'];');}return result.join('');},generateFunction:function generateFunction(name,params){return'function('+params+'){'+this.varsPrefix(name)+this.body(name)+'};';},filterPrefix:function filterPrefix(){var parts=[];var self=this;forEach(this.state.filters,function(id,filter){parts.push(id+'=$filter('+self.escape(filter)+')');});if(parts.length)return'var '+parts.join(',')+';';return'';},varsPrefix:function varsPrefix(section){return this.state[section].vars.length?'var '+this.state[section].vars.join(',')+';':'';},body:function body(section){return this.state[section].body.join('');},recurse:function recurse(ast,intoId,nameId,recursionFn,create,skipWatchIdCheck){var left,right,self=this,args,expression;recursionFn=recursionFn||noop;if(!skipWatchIdCheck&&isDefined(ast.watchId)){intoId=intoId||this.nextId();this.if_('i',this.lazyAssign(intoId,this.computedMember('i',ast.watchId)),this.lazyRecurse(ast,intoId,nameId,recursionFn,create,true));return;}switch(ast.type){case AST.Program:forEach(ast.body,function(expression,pos){self.recurse(expression.expression,undefined,undefined,function(expr){right=expr;});if(pos!==ast.body.length-1){self.current().body.push(right,';');}else{self.return_(right);}});break;case AST.Literal:expression=this.escape(ast.value);this.assign(intoId,expression);recursionFn(expression);break;case AST.UnaryExpression:this.recurse(ast.argument,undefined,undefined,function(expr){right=expr;});expression=ast.operator+'('+this.ifDefined(right,0)+')';this.assign(intoId,expression);recursionFn(expression);break;case AST.BinaryExpression:this.recurse(ast.left,undefined,undefined,function(expr){left=expr;});this.recurse(ast.right,undefined,undefined,function(expr){right=expr;});if(ast.operator==='+'){expression=this.plus(left,right);}else if(ast.operator==='-'){expression=this.ifDefined(left,0)+ast.operator+this.ifDefined(right,0);}else{expression='('+left+')'+ast.operator+'('+right+')';}this.assign(intoId,expression);recursionFn(expression);break;case AST.LogicalExpression:intoId=intoId||this.nextId();self.recurse(ast.left,intoId);self.if_(ast.operator==='&&'?intoId:self.not(intoId),self.lazyRecurse(ast.right,intoId));recursionFn(intoId);break;case AST.ConditionalExpression:intoId=intoId||this.nextId();self.recurse(ast.test,intoId);self.if_(intoId,self.lazyRecurse(ast.alternate,intoId),self.lazyRecurse(ast.consequent,intoId));recursionFn(intoId);break;case AST.Identifier:intoId=intoId||this.nextId();if(nameId){nameId.context=self.stage==='inputs'?'s':this.assign(this.nextId(),this.getHasOwnProperty('l',ast.name)+'?l:s');nameId.computed=false;nameId.name=ast.name;}ensureSafeMemberName(ast.name);self.if_(self.stage==='inputs'||self.not(self.getHasOwnProperty('l',ast.name)),function(){self.if_(self.stage==='inputs'||'s',function(){if(create&&create!==1){self.if_(self.not(self.nonComputedMember('s',ast.name)),self.lazyAssign(self.nonComputedMember('s',ast.name),'{}'));}self.assign(intoId,self.nonComputedMember('s',ast.name));});},intoId&&self.lazyAssign(intoId,self.nonComputedMember('l',ast.name)));if(self.state.expensiveChecks||isPossiblyDangerousMemberName(ast.name)){self.addEnsureSafeObject(intoId);}recursionFn(intoId);break;case AST.MemberExpression:left=nameId&&(nameId.context=this.nextId())||this.nextId();intoId=intoId||this.nextId();self.recurse(ast.object,left,undefined,function(){self.if_(self.notNull(left),function(){if(create&&create!==1){self.addEnsureSafeAssignContext(left);}if(ast.computed){right=self.nextId();self.recurse(ast.property,right);self.getStringValue(right);self.addEnsureSafeMemberName(right);if(create&&create!==1){self.if_(self.not(self.computedMember(left,right)),self.lazyAssign(self.computedMember(left,right),'{}'));}expression=self.ensureSafeObject(self.computedMember(left,right));self.assign(intoId,expression);if(nameId){nameId.computed=true;nameId.name=right;}}else{ensureSafeMemberName(ast.property.name);if(create&&create!==1){self.if_(self.not(self.nonComputedMember(left,ast.property.name)),self.lazyAssign(self.nonComputedMember(left,ast.property.name),'{}'));}expression=self.nonComputedMember(left,ast.property.name);if(self.state.expensiveChecks||isPossiblyDangerousMemberName(ast.property.name)){expression=self.ensureSafeObject(expression);}self.assign(intoId,expression);if(nameId){nameId.computed=false;nameId.name=ast.property.name;}}},function(){self.assign(intoId,'undefined');});recursionFn(intoId);},!!create);break;case AST.CallExpression:intoId=intoId||this.nextId();if(ast.filter){right=self.filter(ast.callee.name);args=[];forEach(ast.arguments,function(expr){var argument=self.nextId();self.recurse(expr,argument);args.push(argument);});expression=right+'('+args.join(',')+')';self.assign(intoId,expression);recursionFn(intoId);}else{right=self.nextId();left={};args=[];self.recurse(ast.callee,right,left,function(){self.if_(self.notNull(right),function(){self.addEnsureSafeFunction(right);forEach(ast.arguments,function(expr){self.recurse(expr,self.nextId(),undefined,function(argument){args.push(self.ensureSafeObject(argument));});});if(left.name){if(!self.state.expensiveChecks){self.addEnsureSafeObject(left.context);}expression=self.member(left.context,left.name,left.computed)+'('+args.join(',')+')';}else{expression=right+'('+args.join(',')+')';}expression=self.ensureSafeObject(expression);self.assign(intoId,expression);},function(){self.assign(intoId,'undefined');});recursionFn(intoId);});}break;case AST.AssignmentExpression:right=this.nextId();left={};if(!isAssignable(ast.left)){throw $parseMinErr('lval','Trying to assign a value to a non l-value');}this.recurse(ast.left,undefined,left,function(){self.if_(self.notNull(left.context),function(){self.recurse(ast.right,right);self.addEnsureSafeObject(self.member(left.context,left.name,left.computed));self.addEnsureSafeAssignContext(left.context);expression=self.member(left.context,left.name,left.computed)+ast.operator+right;self.assign(intoId,expression);recursionFn(intoId||expression);});},1);break;case AST.ArrayExpression:args=[];forEach(ast.elements,function(expr){self.recurse(expr,self.nextId(),undefined,function(argument){args.push(argument);});});expression='['+args.join(',')+']';this.assign(intoId,expression);recursionFn(expression);break;case AST.ObjectExpression:args=[];forEach(ast.properties,function(property){self.recurse(property.value,self.nextId(),undefined,function(expr){args.push(self.escape(property.key.type===AST.Identifier?property.key.name:''+property.key.value)+':'+expr);});});expression='{'+args.join(',')+'}';this.assign(intoId,expression);recursionFn(expression);break;case AST.ThisExpression:this.assign(intoId,'s');recursionFn('s');break;case AST.NGValueParameter:this.assign(intoId,'v');recursionFn('v');break;}},getHasOwnProperty:function getHasOwnProperty(element,property){var key=element+'.'+property;var own=this.current().own;if(!own.hasOwnProperty(key)){own[key]=this.nextId(false,element+'&&('+this.escape(property)+' in '+element+')');}return own[key];},assign:function assign(id,value){if(!id)return;this.current().body.push(id,'=',value,';');return id;},filter:function filter(filterName){if(!this.state.filters.hasOwnProperty(filterName)){this.state.filters[filterName]=this.nextId(true);}return this.state.filters[filterName];},ifDefined:function ifDefined(id,defaultValue){return'ifDefined('+id+','+this.escape(defaultValue)+')';},plus:function plus(left,right){return'plus('+left+','+right+')';},return_:function return_(id){this.current().body.push('return ',id,';');},if_:function if_(test,alternate,consequent){if(test===true){alternate();}else{var body=this.current().body;body.push('if(',test,'){');alternate();body.push('}');if(consequent){body.push('else{');consequent();body.push('}');}}},not:function not(expression){return'!('+expression+')';},notNull:function notNull(expression){return expression+'!=null';},nonComputedMember:function nonComputedMember(left,right){return left+'.'+right;},computedMember:function computedMember(left,right){return left+'['+right+']';},member:function member(left,right,computed){if(computed)return this.computedMember(left,right);return this.nonComputedMember(left,right);},addEnsureSafeObject:function addEnsureSafeObject(item){this.current().body.push(this.ensureSafeObject(item),';');},addEnsureSafeMemberName:function addEnsureSafeMemberName(item){this.current().body.push(this.ensureSafeMemberName(item),';');},addEnsureSafeFunction:function addEnsureSafeFunction(item){this.current().body.push(this.ensureSafeFunction(item),';');},addEnsureSafeAssignContext:function addEnsureSafeAssignContext(item){this.current().body.push(this.ensureSafeAssignContext(item),';');},ensureSafeObject:function ensureSafeObject(item){return'ensureSafeObject('+item+',text)';},ensureSafeMemberName:function ensureSafeMemberName(item){return'ensureSafeMemberName('+item+',text)';},ensureSafeFunction:function ensureSafeFunction(item){return'ensureSafeFunction('+item+',text)';},getStringValue:function getStringValue(item){this.assign(item,'getStringValue('+item+',text)');},ensureSafeAssignContext:function ensureSafeAssignContext(item){return'ensureSafeAssignContext('+item+',text)';},lazyRecurse:function lazyRecurse(ast,intoId,nameId,recursionFn,create,skipWatchIdCheck){var self=this;return function(){self.recurse(ast,intoId,nameId,recursionFn,create,skipWatchIdCheck);};},lazyAssign:function lazyAssign(id,value){var self=this;return function(){self.assign(id,value);};},stringEscapeRegex:/[^ a-zA-Z0-9]/g,stringEscapeFn:function stringEscapeFn(c){return'\\u'+('0000'+c.charCodeAt(0).toString(16)).slice(-4);},escape:function escape(value){if(isString(value))return"'"+value.replace(this.stringEscapeRegex,this.stringEscapeFn)+"'";if(isNumber(value))return value.toString();if(value===true)return'true';if(value===false)return'false';if(value===null)return'null';if(typeof value==='undefined')return'undefined';throw $parseMinErr('esc','IMPOSSIBLE');},nextId:function nextId(skip,init){var id='v'+this.state.nextId++;if(!skip){this.current().vars.push(id+(init?'='+init:''));}return id;},current:function current(){return this.state[this.state.computing];}};function ASTInterpreter(astBuilder,$filter){this.astBuilder=astBuilder;this.$filter=$filter;}ASTInterpreter.prototype={compile:function compile(expression,expensiveChecks){var self=this;var ast=this.astBuilder.ast(expression);this.expression=expression;this.expensiveChecks=expensiveChecks;findConstantAndWatchExpressions(ast,self.$filter);var assignable;var assign;if(assignable=assignableAST(ast)){assign=this.recurse(assignable);}var toWatch=getInputs(ast.body);var inputs;if(toWatch){inputs=[];forEach(toWatch,function(watch,key){var input=self.recurse(watch);watch.input=input;inputs.push(input);watch.watchId=key;});}var expressions=[];forEach(ast.body,function(expression){expressions.push(self.recurse(expression.expression));});var fn=ast.body.length===0?function(){}:ast.body.length===1?expressions[0]:function(scope,locals){var lastValue;forEach(expressions,function(exp){lastValue=exp(scope,locals);});return lastValue;};if(assign){fn.assign=function(scope,value,locals){return assign(scope,locals,value);};}if(inputs){fn.inputs=inputs;}fn.literal=isLiteral(ast);fn.constant=isConstant(ast);return fn;},recurse:function recurse(ast,context,create){var left,right,self=this,args,expression;if(ast.input){return this.inputs(ast.input,ast.watchId);}switch(ast.type){case AST.Literal:return this.value(ast.value,context);case AST.UnaryExpression:right=this.recurse(ast.argument);return this['unary'+ast.operator](right,context);case AST.BinaryExpression:left=this.recurse(ast.left);right=this.recurse(ast.right);return this['binary'+ast.operator](left,right,context);case AST.LogicalExpression:left=this.recurse(ast.left);right=this.recurse(ast.right);return this['binary'+ast.operator](left,right,context);case AST.ConditionalExpression:return this['ternary?:'](this.recurse(ast.test),this.recurse(ast.alternate),this.recurse(ast.consequent),context);case AST.Identifier:ensureSafeMemberName(ast.name,self.expression);return self.identifier(ast.name,self.expensiveChecks||isPossiblyDangerousMemberName(ast.name),context,create,self.expression);case AST.MemberExpression:left=this.recurse(ast.object,false,!!create);if(!ast.computed){ensureSafeMemberName(ast.property.name,self.expression);right=ast.property.name;}if(ast.computed)right=this.recurse(ast.property);return ast.computed?this.computedMember(left,right,context,create,self.expression):this.nonComputedMember(left,right,self.expensiveChecks,context,create,self.expression);case AST.CallExpression:args=[];forEach(ast.arguments,function(expr){args.push(self.recurse(expr));});if(ast.filter)right=this.$filter(ast.callee.name);if(!ast.filter)right=this.recurse(ast.callee,true);return ast.filter?function(scope,locals,assign,inputs){var values=[];for(var i=0;i<args.length;++i){values.push(args[i](scope,locals,assign,inputs));}var value=right.apply(undefined,values,inputs);return context?{context:undefined,name:undefined,value:value}:value;}:function(scope,locals,assign,inputs){var rhs=right(scope,locals,assign,inputs);var value;if(rhs.value!=null){ensureSafeObject(rhs.context,self.expression);ensureSafeFunction(rhs.value,self.expression);var values=[];for(var i=0;i<args.length;++i){values.push(ensureSafeObject(args[i](scope,locals,assign,inputs),self.expression));}value=ensureSafeObject(rhs.value.apply(rhs.context,values),self.expression);}return context?{value:value}:value;};case AST.AssignmentExpression:left=this.recurse(ast.left,true,1);right=this.recurse(ast.right);return function(scope,locals,assign,inputs){var lhs=left(scope,locals,assign,inputs);var rhs=right(scope,locals,assign,inputs);ensureSafeObject(lhs.value,self.expression);ensureSafeAssignContext(lhs.context);lhs.context[lhs.name]=rhs;return context?{value:rhs}:rhs;};case AST.ArrayExpression:args=[];forEach(ast.elements,function(expr){args.push(self.recurse(expr));});return function(scope,locals,assign,inputs){var value=[];for(var i=0;i<args.length;++i){value.push(args[i](scope,locals,assign,inputs));}return context?{value:value}:value;};case AST.ObjectExpression:args=[];forEach(ast.properties,function(property){args.push({key:property.key.type===AST.Identifier?property.key.name:''+property.key.value,value:self.recurse(property.value)});});return function(scope,locals,assign,inputs){var value={};for(var i=0;i<args.length;++i){value[args[i].key]=args[i].value(scope,locals,assign,inputs);}return context?{value:value}:value;};case AST.ThisExpression:return function(scope){return context?{value:scope}:scope;};case AST.NGValueParameter:return function(scope,locals,assign,inputs){return context?{value:assign}:assign;};}},'unary+':function unary(argument,context){return function(scope,locals,assign,inputs){var arg=argument(scope,locals,assign,inputs);if(isDefined(arg)){arg=+arg;}else{arg=0;}return context?{value:arg}:arg;};},'unary-':function unary(argument,context){return function(scope,locals,assign,inputs){var arg=argument(scope,locals,assign,inputs);if(isDefined(arg)){arg=-arg;}else{arg=0;}return context?{value:arg}:arg;};},'unary!':function unary(argument,context){return function(scope,locals,assign,inputs){var arg=!argument(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary+':function binary(left,right,context){return function(scope,locals,assign,inputs){var lhs=left(scope,locals,assign,inputs);var rhs=right(scope,locals,assign,inputs);var arg=plusFn(lhs,rhs);return context?{value:arg}:arg;};},'binary-':function binary(left,right,context){return function(scope,locals,assign,inputs){var lhs=left(scope,locals,assign,inputs);var rhs=right(scope,locals,assign,inputs);var arg=(isDefined(lhs)?lhs:0)-(isDefined(rhs)?rhs:0);return context?{value:arg}:arg;};},'binary*':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)*right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary/':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)/right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary%':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)%right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary===':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)===right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary!==':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)!==right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary==':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)==right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary!=':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)!=right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary<':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)<right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary>':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)>right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary<=':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)<=right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary>=':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)>=right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary&&':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)&&right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary||':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)||right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'ternary?:':function ternary(test,alternate,consequent,context){return function(scope,locals,assign,inputs){var arg=test(scope,locals,assign,inputs)?alternate(scope,locals,assign,inputs):consequent(scope,locals,assign,inputs);return context?{value:arg}:arg;};},value:function value(_value2,context){return function(){return context?{context:undefined,name:undefined,value:_value2}:_value2;};},identifier:function identifier(name,expensiveChecks,context,create,expression){return function(scope,locals,assign,inputs){var base=locals&&name in locals?locals:scope;if(create&&create!==1&&base&&!base[name]){base[name]={};}var value=base?base[name]:undefined;if(expensiveChecks){ensureSafeObject(value,expression);}if(context){return{context:base,name:name,value:value};}else{return value;}};},computedMember:function computedMember(left,right,context,create,expression){return function(scope,locals,assign,inputs){var lhs=left(scope,locals,assign,inputs);var rhs;var value;if(lhs!=null){rhs=right(scope,locals,assign,inputs);rhs=getStringValue(rhs);ensureSafeMemberName(rhs,expression);if(create&&create!==1){ensureSafeAssignContext(lhs);if(lhs&&!lhs[rhs]){lhs[rhs]={};}}value=lhs[rhs];ensureSafeObject(value,expression);}if(context){return{context:lhs,name:rhs,value:value};}else{return value;}};},nonComputedMember:function nonComputedMember(left,right,expensiveChecks,context,create,expression){return function(scope,locals,assign,inputs){var lhs=left(scope,locals,assign,inputs);if(create&&create!==1){ensureSafeAssignContext(lhs);if(lhs&&!lhs[right]){lhs[right]={};}}var value=lhs!=null?lhs[right]:undefined;if(expensiveChecks||isPossiblyDangerousMemberName(right)){ensureSafeObject(value,expression);}if(context){return{context:lhs,name:right,value:value};}else{return value;}};},inputs:function inputs(input,watchId){return function(scope,value,locals,inputs){if(inputs)return inputs[watchId];return input(scope,value,locals);};}};/**
	 * @constructor
	 */var Parser=function Parser(lexer,$filter,options){this.lexer=lexer;this.$filter=$filter;this.options=options;this.ast=new AST(this.lexer);this.astCompiler=options.csp?new ASTInterpreter(this.ast,$filter):new ASTCompiler(this.ast,$filter);};Parser.prototype={constructor:Parser,parse:function parse(text){return this.astCompiler.compile(text,this.options.expensiveChecks);}};function isPossiblyDangerousMemberName(name){return name=='constructor';}var objectValueOf=Object.prototype.valueOf;function getValueOf(value){return isFunction(value.valueOf)?value.valueOf():objectValueOf.call(value);}///////////////////////////////////
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 *//**
	 * @ngdoc provider
	 * @name $parseProvider
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */function $ParseProvider(){var cacheDefault=createMap();var cacheExpensive=createMap();this.$get=['$filter',function($filter){var noUnsafeEval=csp().noUnsafeEval;var $parseOptions={csp:noUnsafeEval,expensiveChecks:false},$parseOptionsExpensive={csp:noUnsafeEval,expensiveChecks:true};var runningChecksEnabled=false;$parse.$$runningExpensiveChecks=function(){return runningChecksEnabled;};return $parse;function $parse(exp,interceptorFn,expensiveChecks){var parsedExpression,oneTime,cacheKey;expensiveChecks=expensiveChecks||runningChecksEnabled;switch(typeof exp==='undefined'?'undefined':_typeof(exp)){case'string':exp=exp.trim();cacheKey=exp;var cache=expensiveChecks?cacheExpensive:cacheDefault;parsedExpression=cache[cacheKey];if(!parsedExpression){if(exp.charAt(0)===':'&&exp.charAt(1)===':'){oneTime=true;exp=exp.substring(2);}var parseOptions=expensiveChecks?$parseOptionsExpensive:$parseOptions;var lexer=new Lexer(parseOptions);var parser=new Parser(lexer,$filter,parseOptions);parsedExpression=parser.parse(exp);if(parsedExpression.constant){parsedExpression.$$watchDelegate=constantWatchDelegate;}else if(oneTime){parsedExpression.$$watchDelegate=parsedExpression.literal?oneTimeLiteralWatchDelegate:oneTimeWatchDelegate;}else if(parsedExpression.inputs){parsedExpression.$$watchDelegate=inputsWatchDelegate;}if(expensiveChecks){parsedExpression=expensiveChecksInterceptor(parsedExpression);}cache[cacheKey]=parsedExpression;}return addInterceptor(parsedExpression,interceptorFn);case'function':return addInterceptor(exp,interceptorFn);default:return addInterceptor(noop,interceptorFn);}}function expensiveChecksInterceptor(fn){if(!fn)return fn;expensiveCheckFn.$$watchDelegate=fn.$$watchDelegate;expensiveCheckFn.assign=expensiveChecksInterceptor(fn.assign);expensiveCheckFn.constant=fn.constant;expensiveCheckFn.literal=fn.literal;for(var i=0;fn.inputs&&i<fn.inputs.length;++i){fn.inputs[i]=expensiveChecksInterceptor(fn.inputs[i]);}expensiveCheckFn.inputs=fn.inputs;return expensiveCheckFn;function expensiveCheckFn(scope,locals,assign,inputs){var expensiveCheckOldValue=runningChecksEnabled;runningChecksEnabled=true;try{return fn(scope,locals,assign,inputs);}finally{runningChecksEnabled=expensiveCheckOldValue;}}}function expressionInputDirtyCheck(newValue,oldValueOfValue){if(newValue==null||oldValueOfValue==null){// null/undefined
	return newValue===oldValueOfValue;}if((typeof newValue==='undefined'?'undefined':_typeof(newValue))==='object'){// attempt to convert the value to a primitive type
	// TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	//             be cheaply dirty-checked
	newValue=getValueOf(newValue);if((typeof newValue==='undefined'?'undefined':_typeof(newValue))==='object'){// objects/arrays are not supported - deep-watching them would be too expensive
	return false;}// fall-through to the primitive equality check
	}//Primitive or NaN
	return newValue===oldValueOfValue||newValue!==newValue&&oldValueOfValue!==oldValueOfValue;}function inputsWatchDelegate(scope,listener,objectEquality,parsedExpression,prettyPrintExpression){var inputExpressions=parsedExpression.inputs;var lastResult;if(inputExpressions.length===1){var oldInputValueOf=expressionInputDirtyCheck;// init to something unique so that equals check fails
	inputExpressions=inputExpressions[0];return scope.$watch(function expressionInputWatch(scope){var newInputValue=inputExpressions(scope);if(!expressionInputDirtyCheck(newInputValue,oldInputValueOf)){lastResult=parsedExpression(scope,undefined,undefined,[newInputValue]);oldInputValueOf=newInputValue&&getValueOf(newInputValue);}return lastResult;},listener,objectEquality,prettyPrintExpression);}var oldInputValueOfValues=[];var oldInputValues=[];for(var i=0,ii=inputExpressions.length;i<ii;i++){oldInputValueOfValues[i]=expressionInputDirtyCheck;// init to something unique so that equals check fails
	oldInputValues[i]=null;}return scope.$watch(function expressionInputsWatch(scope){var changed=false;for(var i=0,ii=inputExpressions.length;i<ii;i++){var newInputValue=inputExpressions[i](scope);if(changed||(changed=!expressionInputDirtyCheck(newInputValue,oldInputValueOfValues[i]))){oldInputValues[i]=newInputValue;oldInputValueOfValues[i]=newInputValue&&getValueOf(newInputValue);}}if(changed){lastResult=parsedExpression(scope,undefined,undefined,oldInputValues);}return lastResult;},listener,objectEquality,prettyPrintExpression);}function oneTimeWatchDelegate(scope,listener,objectEquality,parsedExpression){var unwatch,lastValue;return unwatch=scope.$watch(function oneTimeWatch(scope){return parsedExpression(scope);},function oneTimeListener(value,old,scope){lastValue=value;if(isFunction(listener)){listener.apply(this,arguments);}if(isDefined(value)){scope.$$postDigest(function(){if(isDefined(lastValue)){unwatch();}});}},objectEquality);}function oneTimeLiteralWatchDelegate(scope,listener,objectEquality,parsedExpression){var unwatch,lastValue;return unwatch=scope.$watch(function oneTimeWatch(scope){return parsedExpression(scope);},function oneTimeListener(value,old,scope){lastValue=value;if(isFunction(listener)){listener.call(this,value,old,scope);}if(isAllDefined(value)){scope.$$postDigest(function(){if(isAllDefined(lastValue))unwatch();});}},objectEquality);function isAllDefined(value){var allDefined=true;forEach(value,function(val){if(!isDefined(val))allDefined=false;});return allDefined;}}function constantWatchDelegate(scope,listener,objectEquality,parsedExpression){var unwatch;return unwatch=scope.$watch(function constantWatch(scope){return parsedExpression(scope);},function constantListener(value,old,scope){if(isFunction(listener)){listener.apply(this,arguments);}unwatch();},objectEquality);}function addInterceptor(parsedExpression,interceptorFn){if(!interceptorFn)return parsedExpression;var watchDelegate=parsedExpression.$$watchDelegate;var useInputs=false;var regularWatch=watchDelegate!==oneTimeLiteralWatchDelegate&&watchDelegate!==oneTimeWatchDelegate;var fn=regularWatch?function regularInterceptedExpression(scope,locals,assign,inputs){var value=useInputs&&inputs?inputs[0]:parsedExpression(scope,locals,assign,inputs);return interceptorFn(value,scope,locals);}:function oneTimeInterceptedExpression(scope,locals,assign,inputs){var value=parsedExpression(scope,locals,assign,inputs);var result=interceptorFn(value,scope,locals);// we only return the interceptor's result if the
	// initial value is defined (for bind-once)
	return isDefined(value)?result:value;};// Propagate $$watchDelegates other then inputsWatchDelegate
	if(parsedExpression.$$watchDelegate&&parsedExpression.$$watchDelegate!==inputsWatchDelegate){fn.$$watchDelegate=parsedExpression.$$watchDelegate;}else if(!interceptorFn.$stateful){// If there is an interceptor, but no watchDelegate then treat the interceptor like
	// we treat filters - it is assumed to be a pure function unless flagged with $stateful
	fn.$$watchDelegate=inputsWatchDelegate;useInputs=!parsedExpression.inputs;fn.inputs=parsedExpression.inputs?parsedExpression.inputs:[parsedExpression];}return fn;}}];}/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is an implementation of promises/deferred objects inspired by
	 * [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behaviour, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, errorCallback, notifyCallback)` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 *  # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */function $QProvider(){this.$get=['$rootScope','$exceptionHandler',function($rootScope,$exceptionHandler){return qFactory(function(callback){$rootScope.$evalAsync(callback);},$exceptionHandler);}];}function $$QProvider(){this.$get=['$browser','$exceptionHandler',function($browser,$exceptionHandler){return qFactory(function(callback){$browser.defer(callback);},$exceptionHandler);}];}/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @returns {object} Promise manager.
	 */function qFactory(nextTick,exceptionHandler){var $qMinErr=minErr('$q',TypeError);function callOnce(self,resolveFn,rejectFn){var called=false;function wrap(fn){return function(value){if(called)return;called=true;fn.call(self,value);};}return[wrap(resolveFn),wrap(rejectFn)];}/**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */var defer=function defer(){return new Deferred();};function Promise(){this.$$state={status:0};}extend(Promise.prototype,{then:function then(onFulfilled,onRejected,progressBack){if(isUndefined(onFulfilled)&&isUndefined(onRejected)&&isUndefined(progressBack)){return this;}var result=new Deferred();this.$$state.pending=this.$$state.pending||[];this.$$state.pending.push([result,onFulfilled,onRejected,progressBack]);if(this.$$state.status>0)scheduleProcessQueue(this.$$state);return result.promise;},"catch":function _catch(callback){return this.then(null,callback);},"finally":function _finally(callback,progressBack){return this.then(function(value){return handleCallback(value,true,callback);},function(error){return handleCallback(error,false,callback);},progressBack);}});//Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
	function simpleBind(context,fn){return function(value){fn.call(context,value);};}function processQueue(state){var fn,deferred,pending;pending=state.pending;state.processScheduled=false;state.pending=undefined;for(var i=0,ii=pending.length;i<ii;++i){deferred=pending[i][0];fn=pending[i][state.status];try{if(isFunction(fn)){deferred.resolve(fn(state.value));}else if(state.status===1){deferred.resolve(state.value);}else{deferred.reject(state.value);}}catch(e){deferred.reject(e);exceptionHandler(e);}}}function scheduleProcessQueue(state){if(state.processScheduled||!state.pending)return;state.processScheduled=true;nextTick(function(){processQueue(state);});}function Deferred(){this.promise=new Promise();//Necessary to support unbound execution :/
	this.resolve=simpleBind(this,this.resolve);this.reject=simpleBind(this,this.reject);this.notify=simpleBind(this,this.notify);}extend(Deferred.prototype,{resolve:function resolve(val){if(this.promise.$$state.status)return;if(val===this.promise){this.$$reject($qMinErr('qcycle',"Expected promise to be resolved with value other than itself '{0}'",val));}else{this.$$resolve(val);}},$$resolve:function $$resolve(val){var then,fns;fns=callOnce(this,this.$$resolve,this.$$reject);try{if(isObject(val)||isFunction(val))then=val&&val.then;if(isFunction(then)){this.promise.$$state.status=-1;then.call(val,fns[0],fns[1],this.notify);}else{this.promise.$$state.value=val;this.promise.$$state.status=1;scheduleProcessQueue(this.promise.$$state);}}catch(e){fns[1](e);exceptionHandler(e);}},reject:function reject(reason){if(this.promise.$$state.status)return;this.$$reject(reason);},$$reject:function $$reject(reason){this.promise.$$state.value=reason;this.promise.$$state.status=2;scheduleProcessQueue(this.promise.$$state);},notify:function notify(progress){var callbacks=this.promise.$$state.pending;if(this.promise.$$state.status<=0&&callbacks&&callbacks.length){nextTick(function(){var callback,result;for(var i=0,ii=callbacks.length;i<ii;i++){result=callbacks[i][0];callback=callbacks[i][3];try{result.notify(isFunction(callback)?callback(progress):progress);}catch(e){exceptionHandler(e);}}});}}});/**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */var reject=function reject(reason){var result=new Deferred();result.reject(reason);return result.promise;};var makePromise=function makePromise(value,resolved){var result=new Deferred();if(resolved){result.resolve(value);}else{result.reject(value);}return result.promise;};var handleCallback=function handleCallback(value,isResolved,callback){var callbackOutput=null;try{if(isFunction(callback))callbackOutput=callback();}catch(e){return makePromise(e,false);}if(isPromiseLike(callbackOutput)){return callbackOutput.then(function(){return makePromise(value,isResolved);},function(error){return makePromise(error,false);});}else{return makePromise(value,isResolved);}};/**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */var when=function when(value,callback,errback,progressBack){var result=new Deferred();result.resolve(value);return result.promise.then(callback,errback,progressBack);};/**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */var resolve=when;/**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */function all(promises){var deferred=new Deferred(),counter=0,results=isArray(promises)?[]:{};forEach(promises,function(promise,key){counter++;when(promise).then(function(value){if(results.hasOwnProperty(key))return;results[key]=value;if(! --counter)deferred.resolve(results);},function(reason){if(results.hasOwnProperty(key))return;deferred.reject(reason);});});if(counter===0){deferred.resolve(results);}return deferred.promise;}var $Q=function Q(resolver){if(!isFunction(resolver)){throw $qMinErr('norslvr',"Expected resolverFn, got '{0}'",resolver);}if(!(this instanceof Q)){// More useful when $Q is the Promise itself.
	return new Q(resolver);}var deferred=new Deferred();function resolveFn(value){deferred.resolve(value);}function rejectFn(reason){deferred.reject(reason);}resolver(resolveFn,rejectFn);return deferred.promise;};$Q.defer=defer;$Q.reject=reject;$Q.when=when;$Q.resolve=resolve;$Q.all=all;return $Q;}function $$RAFProvider(){//rAF
	this.$get=['$window','$timeout',function($window,$timeout){var requestAnimationFrame=$window.requestAnimationFrame||$window.webkitRequestAnimationFrame;var cancelAnimationFrame=$window.cancelAnimationFrame||$window.webkitCancelAnimationFrame||$window.webkitCancelRequestAnimationFrame;var rafSupported=!!requestAnimationFrame;var raf=rafSupported?function(fn){var id=requestAnimationFrame(fn);return function(){cancelAnimationFrame(id);};}:function(fn){var timer=$timeout(fn,16.66,false);// 1000 / 60 = 16.666
	return function(){$timeout.cancel(timer);};};raf.supported=rafSupported;return raf;}];}/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 *//**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 *//**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 *//**
	 * @ngdoc service
	 * @name $rootScope
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */function $RootScopeProvider(){var TTL=10;var $rootScopeMinErr=minErr('$rootScope');var lastDirtyWatch=null;var applyAsyncId=null;this.digestTtl=function(value){if(arguments.length){TTL=value;}return TTL;};function createChildScopeClass(parent){function ChildScope(){this.$$watchers=this.$$nextSibling=this.$$childHead=this.$$childTail=null;this.$$listeners={};this.$$listenerCount={};this.$$watchersCount=0;this.$id=nextUid();this.$$ChildScope=null;}ChildScope.prototype=parent;return ChildScope;}this.$get=['$injector','$exceptionHandler','$parse','$browser',function($injector,$exceptionHandler,$parse,$browser){function destroyChildScope($event){$event.currentScope.$$destroyed=true;}function cleanUpScope($scope){if(msie===9){// There is a memory leak in IE9 if all child scopes are not disconnected
	// completely when a scope is destroyed. So this code will recurse up through
	// all this scopes children
	//
	// See issue https://github.com/angular/angular.js/issues/10706
	$scope.$$childHead&&cleanUpScope($scope.$$childHead);$scope.$$nextSibling&&cleanUpScope($scope.$$nextSibling);}// The code below works around IE9 and V8's memory leaks
	//
	// See:
	// - https://code.google.com/p/v8/issues/detail?id=2073#c26
	// - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	// - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	$scope.$parent=$scope.$$nextSibling=$scope.$$prevSibling=$scope.$$childHead=$scope.$$childTail=$scope.$root=$scope.$$watchers=null;}/**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */function Scope(){this.$id=nextUid();this.$$phase=this.$parent=this.$$watchers=this.$$nextSibling=this.$$prevSibling=this.$$childHead=this.$$childTail=null;this.$root=this;this.$$destroyed=false;this.$$listeners={};this.$$listenerCount={};this.$$watchersCount=0;this.$$isolateBindings=null;}/**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     *//**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      *//**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */Scope.prototype={constructor:Scope,/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */$new:function $new(isolate,parent){var child;parent=parent||this;if(isolate){child=new Scope();child.$root=this.$root;}else{// Only create a child scope class if somebody asks for one,
	// but cache it to allow the VM to optimize lookups.
	if(!this.$$ChildScope){this.$$ChildScope=createChildScopeClass(this);}child=new this.$$ChildScope();}child.$parent=parent;child.$$prevSibling=parent.$$childTail;if(parent.$$childHead){parent.$$childTail.$$nextSibling=child;parent.$$childTail=child;}else{parent.$$childHead=parent.$$childTail=child;}// When the new scope is not isolated or we inherit from `this`, and
	// the parent scope is destroyed, the property `$$destroyed` is inherited
	// prototypically. In all other cases, this property needs to be set
	// when the parent scope is destroyed.
	// The listener needs to be added after the parent is set
	if(isolate||parent!=this)child.$on('$destroy',destroyChildScope);return child;},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} objectEquality Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */$watch:function $watch(watchExp,listener,objectEquality,prettyPrintExpression){var get=$parse(watchExp);if(get.$$watchDelegate){return get.$$watchDelegate(this,listener,objectEquality,get,watchExp);}var scope=this,array=scope.$$watchers,watcher={fn:listener,last:initWatchVal,get:get,exp:prettyPrintExpression||watchExp,eq:!!objectEquality};lastDirtyWatch=null;if(!isFunction(listener)){watcher.fn=noop;}if(!array){array=scope.$$watchers=[];}// we use unshift since we use a while loop in $digest for speed.
	// the while loop reads in reverse order.
	array.unshift(watcher);incrementWatchersCount(this,1);return function deregisterWatch(){if(arrayRemove(array,watcher)>=0){incrementWatchersCount(scope,-1);}lastDirtyWatch=null;};},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via standard $watch operation and are examined on every
	       *   call to $digest() to see if any items changes.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */$watchGroup:function $watchGroup(watchExpressions,listener){var oldValues=new Array(watchExpressions.length);var newValues=new Array(watchExpressions.length);var deregisterFns=[];var self=this;var changeReactionScheduled=false;var firstRun=true;if(!watchExpressions.length){// No expressions means we call the listener ASAP
	var shouldCall=true;self.$evalAsync(function(){if(shouldCall)listener(newValues,newValues,self);});return function deregisterWatchGroup(){shouldCall=false;};}if(watchExpressions.length===1){// Special case size of one
	return this.$watch(watchExpressions[0],function watchGroupAction(value,oldValue,scope){newValues[0]=value;oldValues[0]=oldValue;listener(newValues,value===oldValue?newValues:oldValues,scope);});}forEach(watchExpressions,function(expr,i){var unwatchFn=self.$watch(expr,function watchGroupSubAction(value,oldValue){newValues[i]=value;oldValues[i]=oldValue;if(!changeReactionScheduled){changeReactionScheduled=true;self.$evalAsync(watchGroupAction);}});deregisterFns.push(unwatchFn);});function watchGroupAction(){changeReactionScheduled=false;if(firstRun){firstRun=false;listener(newValues,newValues,self);}else{listener(newValues,oldValues,self);}}return function deregisterWatchGroup(){while(deregisterFns.length){deregisterFns.shift()();}};},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */$watchCollection:function $watchCollection(obj,listener){$watchCollectionInterceptor.$stateful=true;var self=this;// the current value, updated on each dirty-check run
	var newValue;// a shallow copy of the newValue from the last dirty-check run,
	// updated to match newValue during dirty-check run
	var oldValue;// a shallow copy of the newValue from when the last change happened
	var veryOldValue;// only track veryOldValue if the listener is asking for it
	var trackVeryOldValue=listener.length>1;var changeDetected=0;var changeDetector=$parse(obj,$watchCollectionInterceptor);var internalArray=[];var internalObject={};var initRun=true;var oldLength=0;function $watchCollectionInterceptor(_value){newValue=_value;var newLength,key,bothNaN,newItem,oldItem;// If the new value is undefined, then return undefined as the watch may be a one-time watch
	if(isUndefined(newValue))return;if(!isObject(newValue)){// if primitive
	if(oldValue!==newValue){oldValue=newValue;changeDetected++;}}else if(isArrayLike(newValue)){if(oldValue!==internalArray){// we are transitioning from something which was not an array into array.
	oldValue=internalArray;oldLength=oldValue.length=0;changeDetected++;}newLength=newValue.length;if(oldLength!==newLength){// if lengths do not match we need to trigger change notification
	changeDetected++;oldValue.length=oldLength=newLength;}// copy the items to oldValue and look for changes.
	for(var i=0;i<newLength;i++){oldItem=oldValue[i];newItem=newValue[i];bothNaN=oldItem!==oldItem&&newItem!==newItem;if(!bothNaN&&oldItem!==newItem){changeDetected++;oldValue[i]=newItem;}}}else{if(oldValue!==internalObject){// we are transitioning from something which was not an object into object.
	oldValue=internalObject={};oldLength=0;changeDetected++;}// copy the items to oldValue and look for changes.
	newLength=0;for(key in newValue){if(hasOwnProperty.call(newValue,key)){newLength++;newItem=newValue[key];oldItem=oldValue[key];if(key in oldValue){bothNaN=oldItem!==oldItem&&newItem!==newItem;if(!bothNaN&&oldItem!==newItem){changeDetected++;oldValue[key]=newItem;}}else{oldLength++;oldValue[key]=newItem;changeDetected++;}}}if(oldLength>newLength){// we used to have more keys, need to find them and destroy them.
	changeDetected++;for(key in oldValue){if(!hasOwnProperty.call(newValue,key)){oldLength--;delete oldValue[key];}}}}return changeDetected;}function $watchCollectionAction(){if(initRun){initRun=false;listener(newValue,newValue,self);}else{listener(newValue,veryOldValue,self);}// make a copy for the next time a collection is changed
	if(trackVeryOldValue){if(!isObject(newValue)){//primitive
	veryOldValue=newValue;}else if(isArrayLike(newValue)){veryOldValue=new Array(newValue.length);for(var i=0;i<newValue.length;i++){veryOldValue[i]=newValue[i];}}else{// if object
	veryOldValue={};for(var key in newValue){if(hasOwnProperty.call(newValue,key)){veryOldValue[key]=newValue[key];}}}}}return this.$watch(changeDetector,$watchCollectionAction);},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */$digest:function $digest(){var watch,value,last,fn,get,watchers,length,dirty,ttl=TTL,next,current,target=this,watchLog=[],logIdx,logMsg,asyncTask;beginPhase('$digest');// Check for changes to browser url that happened in sync before the call to $digest
	$browser.$$checkUrlChange();if(this===$rootScope&&applyAsyncId!==null){// If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	// cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	$browser.defer.cancel(applyAsyncId);flushApplyAsync();}lastDirtyWatch=null;do{// "while dirty" loop
	dirty=false;current=target;while(asyncQueue.length){try{asyncTask=asyncQueue.shift();asyncTask.scope.$eval(asyncTask.expression,asyncTask.locals);}catch(e){$exceptionHandler(e);}lastDirtyWatch=null;}traverseScopesLoop:do{// "traverse the scopes" loop
	if(watchers=current.$$watchers){// process our watches
	length=watchers.length;while(length--){try{watch=watchers[length];// Most common watches are on primitives, in which case we can short
	// circuit it with === operator, only when === fails do we use .equals
	if(watch){get=watch.get;if((value=get(current))!==(last=watch.last)&&!(watch.eq?equals(value,last):typeof value==='number'&&typeof last==='number'&&isNaN(value)&&isNaN(last))){dirty=true;lastDirtyWatch=watch;watch.last=watch.eq?copy(value,null):value;fn=watch.fn;fn(value,last===initWatchVal?value:last,current);if(ttl<5){logIdx=4-ttl;if(!watchLog[logIdx])watchLog[logIdx]=[];watchLog[logIdx].push({msg:isFunction(watch.exp)?'fn: '+(watch.exp.name||watch.exp.toString()):watch.exp,newVal:value,oldVal:last});}}else if(watch===lastDirtyWatch){// If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	// have already been tested.
	dirty=false;break traverseScopesLoop;}}}catch(e){$exceptionHandler(e);}}}// Insanity Warning: scope depth-first traversal
	// yes, this code is a bit crazy, but it works and we have tests to prove it!
	// this piece should be kept in sync with the traversal in $broadcast
	if(!(next=current.$$watchersCount&&current.$$childHead||current!==target&&current.$$nextSibling)){while(current!==target&&!(next=current.$$nextSibling)){current=current.$parent;}}}while(current=next);// `break traverseScopesLoop;` takes us to here
	if((dirty||asyncQueue.length)&&!ttl--){clearPhase();throw $rootScopeMinErr('infdig','{0} $digest() iterations reached. Aborting!\n'+'Watchers fired in the last 5 iterations: {1}',TTL,watchLog);}}while(dirty||asyncQueue.length);clearPhase();while(postDigestQueue.length){try{postDigestQueue.shift()();}catch(e){$exceptionHandler(e);}}},/**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       *//**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */$destroy:function $destroy(){// We can't destroy a scope that has been already destroyed.
	if(this.$$destroyed)return;var parent=this.$parent;this.$broadcast('$destroy');this.$$destroyed=true;if(this===$rootScope){//Remove handlers attached to window when $rootScope is removed
	$browser.$$applicationDestroyed();}incrementWatchersCount(this,-this.$$watchersCount);for(var eventName in this.$$listenerCount){decrementListenerCount(this,this.$$listenerCount[eventName],eventName);}// sever all the references to parent scopes (after this cleanup, the current scope should
	// not be retained by any of our references and should be eligible for garbage collection)
	if(parent&&parent.$$childHead==this)parent.$$childHead=this.$$nextSibling;if(parent&&parent.$$childTail==this)parent.$$childTail=this.$$prevSibling;if(this.$$prevSibling)this.$$prevSibling.$$nextSibling=this.$$nextSibling;if(this.$$nextSibling)this.$$nextSibling.$$prevSibling=this.$$prevSibling;// Disable listeners, watchers and apply/digest methods
	this.$destroy=this.$digest=this.$apply=this.$evalAsync=this.$applyAsync=noop;this.$on=this.$watch=this.$watchGroup=function(){return noop;};this.$$listeners={};// Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	this.$$nextSibling=null;cleanUpScope(this);},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */$eval:function $eval(expr,locals){return $parse(expr)(this,locals);},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */$evalAsync:function $evalAsync(expr,locals){// if we are outside of an $digest loop and this is the first time we are scheduling async
	// task also schedule async auto-flush
	if(!$rootScope.$$phase&&!asyncQueue.length){$browser.defer(function(){if(asyncQueue.length){$rootScope.$digest();}});}asyncQueue.push({scope:this,expression:$parse(expr),locals:locals});},$$postDigest:function $$postDigest(fn){postDigestQueue.push(fn);},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */$apply:function $apply(expr){try{beginPhase('$apply');try{return this.$eval(expr);}finally{clearPhase();}}catch(e){$exceptionHandler(e);}finally{try{$rootScope.$digest();}catch(e){$exceptionHandler(e);throw e;}}},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */$applyAsync:function $applyAsync(expr){var scope=this;expr&&applyAsyncQueue.push($applyAsyncExpression);expr=$parse(expr);scheduleApplyAsync();function $applyAsyncExpression(){scope.$eval(expr);}},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */$on:function $on(name,listener){var namedListeners=this.$$listeners[name];if(!namedListeners){this.$$listeners[name]=namedListeners=[];}namedListeners.push(listener);var current=this;do{if(!current.$$listenerCount[name]){current.$$listenerCount[name]=0;}current.$$listenerCount[name]++;}while(current=current.$parent);var self=this;return function(){var indexOfListener=namedListeners.indexOf(listener);if(indexOfListener!==-1){namedListeners[indexOfListener]=null;decrementListenerCount(self,1,name);}};},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */$emit:function $emit(name,args){var empty=[],namedListeners,scope=this,_stopPropagation=false,event={name:name,targetScope:scope,stopPropagation:function stopPropagation(){_stopPropagation=true;},preventDefault:function preventDefault(){event.defaultPrevented=true;},defaultPrevented:false},listenerArgs=concat([event],arguments,1),i,length;do{namedListeners=scope.$$listeners[name]||empty;event.currentScope=scope;for(i=0,length=namedListeners.length;i<length;i++){// if listeners were deregistered, defragment the array
	if(!namedListeners[i]){namedListeners.splice(i,1);i--;length--;continue;}try{//allow all listeners attached to the current scope to run
	namedListeners[i].apply(null,listenerArgs);}catch(e){$exceptionHandler(e);}}//if any listener on the current scope stops propagation, prevent bubbling
	if(_stopPropagation){event.currentScope=null;return event;}//traverse upwards
	scope=scope.$parent;}while(scope);event.currentScope=null;return event;},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */$broadcast:function $broadcast(name,args){var target=this,current=target,next=target,event={name:name,targetScope:target,preventDefault:function preventDefault(){event.defaultPrevented=true;},defaultPrevented:false};if(!target.$$listenerCount[name])return event;var listenerArgs=concat([event],arguments,1),listeners,i,length;//down while you can, then up and next sibling or up and next sibling until back at root
	while(current=next){event.currentScope=current;listeners=current.$$listeners[name]||[];for(i=0,length=listeners.length;i<length;i++){// if listeners were deregistered, defragment the array
	if(!listeners[i]){listeners.splice(i,1);i--;length--;continue;}try{listeners[i].apply(null,listenerArgs);}catch(e){$exceptionHandler(e);}}// Insanity Warning: scope depth-first traversal
	// yes, this code is a bit crazy, but it works and we have tests to prove it!
	// this piece should be kept in sync with the traversal in $digest
	// (though it differs due to having the extra check for $$listenerCount)
	if(!(next=current.$$listenerCount[name]&&current.$$childHead||current!==target&&current.$$nextSibling)){while(current!==target&&!(next=current.$$nextSibling)){current=current.$parent;}}}event.currentScope=null;return event;}};var $rootScope=new Scope();//The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	var asyncQueue=$rootScope.$$asyncQueue=[];var postDigestQueue=$rootScope.$$postDigestQueue=[];var applyAsyncQueue=$rootScope.$$applyAsyncQueue=[];return $rootScope;function beginPhase(phase){if($rootScope.$$phase){throw $rootScopeMinErr('inprog','{0} already in progress',$rootScope.$$phase);}$rootScope.$$phase=phase;}function clearPhase(){$rootScope.$$phase=null;}function incrementWatchersCount(current,count){do{current.$$watchersCount+=count;}while(current=current.$parent);}function decrementListenerCount(current,count,name){do{current.$$listenerCount[name]-=count;if(current.$$listenerCount[name]===0){delete current.$$listenerCount[name];}}while(current=current.$parent);}/**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */function initWatchVal(){}function flushApplyAsync(){while(applyAsyncQueue.length){try{applyAsyncQueue.shift()();}catch(e){$exceptionHandler(e);}}applyAsyncId=null;}function scheduleApplyAsync(){if(applyAsyncId===null){applyAsyncId=$browser.defer(function(){$rootScope.$apply(flushApplyAsync);});}}}];}/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of Angular application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */// the implementation is in angular.bootstrap
	/**
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */function $$SanitizeUriProvider(){var aHrefSanitizationWhitelist=/^\s*(https?|ftp|mailto|tel|file):/,imgSrcSanitizationWhitelist=/^\s*((https?|ftp|file|blob):|data:image\/)/;/**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */this.aHrefSanitizationWhitelist=function(regexp){if(isDefined(regexp)){aHrefSanitizationWhitelist=regexp;return this;}return aHrefSanitizationWhitelist;};/**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */this.imgSrcSanitizationWhitelist=function(regexp){if(isDefined(regexp)){imgSrcSanitizationWhitelist=regexp;return this;}return imgSrcSanitizationWhitelist;};this.$get=function(){return function sanitizeUri(uri,isImage){var regex=isImage?imgSrcSanitizationWhitelist:aHrefSanitizationWhitelist;var normalizedVal;normalizedVal=urlResolve(uri).href;if(normalizedVal!==''&&!normalizedVal.match(regex)){return'unsafe:'+normalizedVal;}return uri;};};}/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */var $sceMinErr=minErr('$sce');var SCE_CONTEXTS={HTML:'html',CSS:'css',URL:'url',// RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
	// url.  (e.g. ng-include, script src, templateUrl)
	RESOURCE_URL:'resourceUrl',JS:'js'};// Helper functions follow.
	function adjustMatcher(matcher){if(matcher==='self'){return matcher;}else if(isString(matcher)){// Strings match exactly except for 2 wildcards - '*' and '**'.
	// '*' matches any character except those from the set ':/.?&'.
	// '**' matches any character (like .* in a RegExp).
	// More than 2 *'s raises an error as it's ill defined.
	if(matcher.indexOf('***')>-1){throw $sceMinErr('iwcard','Illegal sequence *** in string matcher.  String: {0}',matcher);}matcher=escapeForRegexp(matcher).replace('\\*\\*','.*').replace('\\*','[^:/.?&;]*');return new RegExp('^'+matcher+'$');}else if(isRegExp(matcher)){// The only other type of matcher allowed is a Regexp.
	// Match entire URL / disallow partial matches.
	// Flags are reset (i.e. no global, ignoreCase or multiline)
	return new RegExp('^'+matcher.source+'$');}else{throw $sceMinErr('imatcher','Matchers may only be "self", string patterns or RegExp objects');}}function adjustMatchers(matchers){var adjustedMatchers=[];if(isDefined(matchers)){forEach(matchers,function(matcher){adjustedMatchers.push(adjustMatcher(matcher));});}return adjustedMatchers;}/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 *//**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`,  `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 */function $SceDelegateProvider(){this.SCE_CONTEXTS=SCE_CONTEXTS;// Resource URLs can also be trusted by policy.
	var resourceUrlWhitelist=['self'],resourceUrlBlacklist=[];/**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** an empty whitelist array will block all URLs!
	   *    </div>
	   *
	   * @return {Array} the currently set whitelist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   */this.resourceUrlWhitelist=function(value){if(arguments.length){resourceUrlWhitelist=adjustMatchers(value);}return resourceUrlWhitelist;};/**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    The typical usage for the blacklist is to **block
	   *    [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *    these would otherwise be trusted but actually return content from the redirected domain.
	   *
	   *    Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} the currently set blacklist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   */this.resourceUrlBlacklist=function(value){if(arguments.length){resourceUrlBlacklist=adjustMatchers(value);}return resourceUrlBlacklist;};this.$get=['$injector',function($injector){var htmlSanitizer=function htmlSanitizer(html){throw $sceMinErr('unsafe','Attempting to use an unsafe value in a safe context.');};if($injector.has('$sanitize')){htmlSanitizer=$injector.get('$sanitize');}function matchUrl(matcher,parsedUrl){if(matcher==='self'){return urlIsSameOrigin(parsedUrl);}else{// definitely a regex.  See adjustMatchers()
	return!!matcher.exec(parsedUrl.href);}}function isResourceUrlAllowedByPolicy(url){var parsedUrl=urlResolve(url.toString());var i,n,allowed=false;// Ensure that at least one item from the whitelist allows this url.
	for(i=0,n=resourceUrlWhitelist.length;i<n;i++){if(matchUrl(resourceUrlWhitelist[i],parsedUrl)){allowed=true;break;}}if(allowed){// Ensure that no item from the blacklist blocked this url.
	for(i=0,n=resourceUrlBlacklist.length;i<n;i++){if(matchUrl(resourceUrlBlacklist[i],parsedUrl)){allowed=false;break;}}}return allowed;}function generateHolderType(Base){var holderType=function TrustedValueHolderType(trustedValue){this.$$unwrapTrustedValue=function(){return trustedValue;};};if(Base){holderType.prototype=new Base();}holderType.prototype.valueOf=function sceValueOf(){return this.$$unwrapTrustedValue();};holderType.prototype.toString=function sceToString(){return this.$$unwrapTrustedValue().toString();};return holderType;}var trustedValueHolderBase=generateHolderType(),byType={};byType[SCE_CONTEXTS.HTML]=generateHolderType(trustedValueHolderBase);byType[SCE_CONTEXTS.CSS]=generateHolderType(trustedValueHolderBase);byType[SCE_CONTEXTS.URL]=generateHolderType(trustedValueHolderBase);byType[SCE_CONTEXTS.JS]=generateHolderType(trustedValueHolderBase);byType[SCE_CONTEXTS.RESOURCE_URL]=generateHolderType(byType[SCE_CONTEXTS.URL]);/**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns an object that is trusted by angular for use in specified strict
	     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
	     * attribute interpolation, any dom event binding attribute interpolation
	     * such as for onclick,  etc.) that uses the provided value.
	     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */function trustAs(type,trustedValue){var Constructor=byType.hasOwnProperty(type)?byType[type]:null;if(!Constructor){throw $sceMinErr('icontext','Attempted to trust a value in invalid context. Context: {0}; Value: {1}',type,trustedValue);}if(trustedValue===null||isUndefined(trustedValue)||trustedValue===''){return trustedValue;}// All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	// mutable objects, we ensure here that the value passed in is actually a string.
	if(typeof trustedValue!=='string'){throw $sceMinErr('itype','Attempted to trust a non-string value in a content requiring a string: Context: {0}',type);}return new Constructor(trustedValue);}/**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *      call or anything else.
	     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */function valueOf(maybeTrusted){if(maybeTrusted instanceof trustedValueHolderBase){return maybeTrusted.$$unwrapTrustedValue();}else{return maybeTrusted;}}/**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
	     * returns the originally supplied value if the queried context type is a supertype of the
	     * created type.  If this condition isn't satisfied, throws an exception.
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call.
	     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
	     */function getTrusted(type,maybeTrusted){if(maybeTrusted===null||isUndefined(maybeTrusted)||maybeTrusted===''){return maybeTrusted;}var constructor=byType.hasOwnProperty(type)?byType[type]:null;if(constructor&&maybeTrusted instanceof constructor){return maybeTrusted.$$unwrapTrustedValue();}// If we get here, then we may only take one of two actions.
	// 1. sanitize the value for the requested type, or
	// 2. throw an exception.
	if(type===SCE_CONTEXTS.RESOURCE_URL){if(isResourceUrlAllowedByPolicy(maybeTrusted)){return maybeTrusted;}else{throw $sceMinErr('insecurl','Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',maybeTrusted.toString());}}else if(type===SCE_CONTEXTS.HTML){return htmlSanitizer(maybeTrusted);}throw $sceMinErr('unsafe','Attempting to use an unsafe value in a safe context.');}return{trustAs:trustAs,getTrusted:getTrusted,valueOf:valueOf};}];}/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *//* jshint maxlen: false*//**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
	 * contexts to result in a value that is marked as safe to use for that context.  One example of
	 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
	 * to these contexts as privileged or SCE contexts.
	 *
	 * As of version 1.2, Angular ships with SCE enabled by default.
	 *
	 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
	 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
	 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
	 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
	 * to the top of your HTML document.
	 *
	 * SCE assists in writing code in way that (a) is secure by default and (b) makes auditing for
	 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV.
	 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
	 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
	 * security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
	 * determine that something explicitly says it's safe to use a value for binding in that
	 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
	 * for those values that you can easily tell are safe - because they were received from your server,
	 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
	 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
	 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * obtain values that will be accepted by SCE / privileged contexts.
	 *
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
	 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
	 *
	 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get("test_data.json", {cache: $templateCache}).success(function(userComments) {
	 *           self.userComments = userComments;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getInnerHtml())
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getInnerHtml()).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 *//* jshint maxlen: 100 */function $SceProvider(){var enabled=true;/**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE.
	   * @return {boolean} true if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */this.enabled=function(value){if(arguments.length){enabled=!!value;}return enabled;};/* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way.  In some future, we
	   * may not use inheritance anymore.  That is OK because no code outside of
	   * sce.js and sceSpecs.js would need to be aware of this detail.
	   */this.$get=['$parse','$sceDelegate',function($parse,$sceDelegate){// Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	// the "expression(javascript expression)" syntax which is insecure.
	if(enabled&&msie<8){throw $sceMinErr('iequirks','Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks '+'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML '+'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');}var sce=shallowCopy(SCE_CONTEXTS);/**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
	     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */sce.isEnabled=function(){return enabled;};sce.trustAs=$sceDelegate.trustAs;sce.getTrusted=$sceDelegate.getTrusted;sce.valueOf=$sceDelegate.valueOf;if(!enabled){sce.trustAs=sce.getTrusted=function(type,value){return value;};sce.valueOf=identity;}/**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The kind of SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */sce.parseAs=function sceParseAs(type,expr){var parsed=$parse(expr);if(parsed.literal&&parsed.constant){return parsed;}else{return $parse(expr,function(value){return sce.getTrusted(type,value);});}};/**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
	     * returns an object that is trusted by angular for use in specified strict contextual
	     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
	     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
	     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
	     * escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     *//**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
	     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     *//**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
	     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     *//**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
	     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the return
	     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     *//**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
	     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     *//**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
	     * originally supplied value if the queried context type is a supertype of the created type.
	     * If this condition isn't satisfied, throws an exception.
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
	     *                         call.
	     * @returns {*} The value the was originally provided to
	     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
	     *              Otherwise, throws an exception.
	     *//**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     *//**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     *//**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     *//**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     *//**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     *//**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     *//**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     *//**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     *//**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     *//**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */// Shorthand delegations.
	var parse=sce.parseAs,getTrusted=sce.getTrusted,trustAs=sce.trustAs;forEach(SCE_CONTEXTS,function(enumValue,name){var lName=lowercase(name);sce[camelCase("parse_as_"+lName)]=function(expr){return parse(enumValue,expr);};sce[camelCase("get_trusted_"+lName)]=function(value){return getTrusted(enumValue,value);};sce[camelCase("trust_as_"+lName)]=function(value){return trustAs(enumValue,value);};});return sce;}];}/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */function $SnifferProvider(){this.$get=['$window','$document',function($window,$document){var eventSupport={},android=toInt((/android (\d+)/.exec(lowercase(($window.navigator||{}).userAgent))||[])[1]),boxee=/Boxee/i.test(($window.navigator||{}).userAgent),document=$document[0]||{},vendorPrefix,vendorRegex=/^(Moz|webkit|ms)(?=[A-Z])/,bodyStyle=document.body&&document.body.style,transitions=false,animations=false,match;if(bodyStyle){for(var prop in bodyStyle){if(match=vendorRegex.exec(prop)){vendorPrefix=match[0];vendorPrefix=vendorPrefix.substr(0,1).toUpperCase()+vendorPrefix.substr(1);break;}}if(!vendorPrefix){vendorPrefix='WebkitOpacity'in bodyStyle&&'webkit';}transitions=!!('transition'in bodyStyle||vendorPrefix+'Transition'in bodyStyle);animations=!!('animation'in bodyStyle||vendorPrefix+'Animation'in bodyStyle);if(android&&(!transitions||!animations)){transitions=isString(bodyStyle.webkitTransition);animations=isString(bodyStyle.webkitAnimation);}}return{// Android has history.pushState, but it does not update location correctly
	// so let's not use the history API at all.
	// http://code.google.com/p/android/issues/detail?id=17471
	// https://github.com/angular/angular.js/issues/904
	// older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	// so let's not use the history API also
	// We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	// jshint -W018
	history:!!($window.history&&$window.history.pushState&&!(android<4)&&!boxee),// jshint +W018
	hasEvent:function hasEvent(event){// IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	// it. In particular the event is not fired when backspace or delete key are pressed or
	// when cut operation is performed.
	// IE10+ implements 'input' event but it erroneously fires under various situations,
	// e.g. when placeholder changes, or a form is focused.
	if(event==='input'&&msie<=11)return false;if(isUndefined(eventSupport[event])){var divElm=document.createElement('div');eventSupport[event]='on'+event in divElm;}return eventSupport[event];},csp:csp(),vendorPrefix:vendorPrefix,transitions:transitions,animations:animations,android:android};}];}var $compileMinErr=minErr('$compile');/**
	 * @ngdoc service
	 * @name $templateRequest
	 *
	 * @description
	 * The `$templateRequest` service runs security checks then downloads the provided template using
	 * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	 * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	 * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	 * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	 * when `tpl` is of type string and `$templateCache` has the matching entry.
	 *
	 * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	 * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	 *
	 * @return {Promise} a promise for the HTTP response data of the given URL.
	 *
	 * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	 */function $TemplateRequestProvider(){this.$get=['$templateCache','$http','$q','$sce',function($templateCache,$http,$q,$sce){function handleRequestFn(tpl,ignoreRequestError){handleRequestFn.totalPendingRequests++;// We consider the template cache holds only trusted templates, so
	// there's no need to go through whitelisting again for keys that already
	// are included in there. This also makes Angular accept any script
	// directive, no matter its name. However, we still need to unwrap trusted
	// types.
	if(!isString(tpl)||isUndefined($templateCache.get(tpl))){tpl=$sce.getTrustedResourceUrl(tpl);}var transformResponse=$http.defaults&&$http.defaults.transformResponse;if(isArray(transformResponse)){transformResponse=transformResponse.filter(function(transformer){return transformer!==defaultHttpResponseTransform;});}else if(transformResponse===defaultHttpResponseTransform){transformResponse=null;}var httpOptions={cache:$templateCache,transformResponse:transformResponse};return $http.get(tpl,httpOptions)['finally'](function(){handleRequestFn.totalPendingRequests--;}).then(function(response){$templateCache.put(tpl,response.data);return response.data;},handleError);function handleError(resp){if(!ignoreRequestError){throw $compileMinErr('tpload','Failed to load template: {0} (HTTP status: {1} {2})',tpl,resp.status,resp.statusText);}return $q.reject(resp);}}handleRequestFn.totalPendingRequests=0;return handleRequestFn;}];}function $$TestabilityProvider(){this.$get=['$rootScope','$browser','$location',function($rootScope,$browser,$location){/**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */var testability={};/**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */testability.findBindings=function(element,expression,opt_exactMatch){var bindings=element.getElementsByClassName('ng-binding');var matches=[];forEach(bindings,function(binding){var dataBinding=angular.element(binding).data('$binding');if(dataBinding){forEach(dataBinding,function(bindingName){if(opt_exactMatch){var matcher=new RegExp('(^|\\s)'+escapeForRegexp(expression)+'(\\s|\\||$)');if(matcher.test(bindingName)){matches.push(binding);}}else{if(bindingName.indexOf(expression)!=-1){matches.push(binding);}}});}});return matches;};/**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */testability.findModels=function(element,expression,opt_exactMatch){var prefixes=['ng-','data-ng-','ng\\:'];for(var p=0;p<prefixes.length;++p){var attributeEquals=opt_exactMatch?'=':'*=';var selector='['+prefixes[p]+'model'+attributeEquals+'"'+expression+'"]';var elements=element.querySelectorAll(selector);if(elements.length){return elements;}}};/**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */testability.getLocation=function(){return $location.url();};/**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */testability.setLocation=function(url){if(url!==$location.url()){$location.url(url);$rootScope.$digest();}};/**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */testability.whenStable=function(callback){$browser.notifyWhenNoOutstandingRequests(callback);};return testability;}];}function $TimeoutProvider(){this.$get=['$rootScope','$browser','$q','$$q','$exceptionHandler',function($rootScope,$browser,$q,$$q,$exceptionHandler){var deferreds={};/**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */function timeout(fn,delay,invokeApply){if(!isFunction(fn)){invokeApply=delay;delay=fn;fn=noop;}var args=sliceArgs(arguments,3),skipApply=isDefined(invokeApply)&&!invokeApply,deferred=(skipApply?$$q:$q).defer(),promise=deferred.promise,timeoutId;timeoutId=$browser.defer(function(){try{deferred.resolve(fn.apply(null,args));}catch(e){deferred.reject(e);$exceptionHandler(e);}finally{delete deferreds[promise.$$timeoutId];}if(!skipApply)$rootScope.$apply();},delay);promise.$$timeoutId=timeoutId;deferreds[timeoutId]=deferred;return promise;}/**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */timeout.cancel=function(promise){if(promise&&promise.$$timeoutId in deferreds){deferreds[promise.$$timeoutId].reject('canceled');delete deferreds[promise.$$timeoutId];return $browser.defer.cancel(promise.$$timeoutId);}return false;};return timeout;}];}// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode=document.createElement("a");var originUrl=urlResolve(window.location.href);/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */function urlResolve(url){var href=url;if(msie){// Normalize before parse.  Refer Implementation Notes on why this is
	// done in two steps on IE.
	urlParsingNode.setAttribute("href",href);href=urlParsingNode.href;}urlParsingNode.setAttribute('href',href);// urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	return{href:urlParsingNode.href,protocol:urlParsingNode.protocol?urlParsingNode.protocol.replace(/:$/,''):'',host:urlParsingNode.host,search:urlParsingNode.search?urlParsingNode.search.replace(/^\?/,''):'',hash:urlParsingNode.hash?urlParsingNode.hash.replace(/^#/,''):'',hostname:urlParsingNode.hostname,port:urlParsingNode.port,pathname:urlParsingNode.pathname.charAt(0)==='/'?urlParsingNode.pathname:'/'+urlParsingNode.pathname};}/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */function urlIsSameOrigin(requestUrl){var parsed=isString(requestUrl)?urlResolve(requestUrl):requestUrl;return parsed.protocol===originUrl.protocol&&parsed.host===originUrl.host;}/**
	 * @ngdoc service
	 * @name $window
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */function $WindowProvider(){this.$get=valueFn(window);}/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */function $$CookieReader($document){var rawDocument=$document[0]||{};var lastCookies={};var lastCookieString='';function safeDecodeURIComponent(str){try{return decodeURIComponent(str);}catch(e){return str;}}return function(){var cookieArray,cookie,i,index,name;var currentCookieString=rawDocument.cookie||'';if(currentCookieString!==lastCookieString){lastCookieString=currentCookieString;cookieArray=lastCookieString.split('; ');lastCookies={};for(i=0;i<cookieArray.length;i++){cookie=cookieArray[i];index=cookie.indexOf('=');if(index>0){//ignore nameless cookies
	name=safeDecodeURIComponent(cookie.substring(0,index));// the first value that is seen for a cookie is the most
	// specific one.  values for the same cookie name that
	// follow are for less specific paths.
	if(isUndefined(lastCookies[name])){lastCookies[name]=safeDecodeURIComponent(cookie.substring(index+1));}}}}return lastCookies;};}$$CookieReader.$inject=['$document'];function $$CookieReaderProvider(){this.$get=$$CookieReader;}/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 *//**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 *//**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * The general syntax in templates is as follows:
	 *
	 *         {{ expression [| filter_name[:parameter_value] ... ] }}
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */$FilterProvider.$inject=['$provide'];function $FilterProvider($provide){var suffix='Filter';/**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */function register(name,factory){if(isObject(name)){var filters={};forEach(name,function(filter,key){filters[key]=register(key,filter);});return filters;}else{return $provide.factory(name+suffix,factory);}}this.register=register;this.$get=['$injector',function($injector){return function(name){return $injector.get(name+suffix);};}];////////////////////////////////////////
	/* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false,
	  */register('currency',currencyFilter);register('date',dateFilter);register('filter',filterFilter);register('json',jsonFilter);register('limitTo',limitToFilter);register('lowercase',lowercaseFilter);register('number',numberFilter);register('orderBy',orderByFilter);register('uppercase',uppercaseFilter);}/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name `$` can be used (as in `{$:"text"}`) to accept a match against any
	 *     property of the object or its nested object properties. That's equivalent to the simple
	 *     substring match with a `string` as described above. The predicate can be negated by prefixing
	 *     the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|undefined} comparator Comparator which is used in
	 *     determining if the expected value (from the filter expression) and actual value (from
	 *     the object in the array) should be considered a match.
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false|undefined`: A short hand for a function which will look for a substring match in case
	 *     insensitive way.
	 *
	 *     Primitive values are converted to strings. Objects are not compared against primitives,
	 *     unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */function filterFilter(){return function(array,expression,comparator){if(!isArrayLike(array)){if(array==null){return array;}else{throw minErr('filter')('notarray','Expected array but received: {0}',array);}}var expressionType=getTypeForFilter(expression);var predicateFn;var matchAgainstAnyProp;switch(expressionType){case'function':predicateFn=expression;break;case'boolean':case'null':case'number':case'string':matchAgainstAnyProp=true;//jshint -W086
	case'object'://jshint +W086
	predicateFn=createPredicateFn(expression,comparator,matchAgainstAnyProp);break;default:return array;}return Array.prototype.filter.call(array,predicateFn);};}// Helper functions for `filterFilter`
	function createPredicateFn(expression,comparator,matchAgainstAnyProp){var shouldMatchPrimitives=isObject(expression)&&'$'in expression;var predicateFn;if(comparator===true){comparator=equals;}else if(!isFunction(comparator)){comparator=function comparator(actual,expected){if(isUndefined(actual)){// No substring matching against `undefined`
	return false;}if(actual===null||expected===null){// No substring matching against `null`; only match against `null`
	return actual===expected;}if(isObject(expected)||isObject(actual)&&!hasCustomToString(actual)){// Should not compare primitives against objects, unless they have custom `toString` method
	return false;}actual=lowercase(''+actual);expected=lowercase(''+expected);return actual.indexOf(expected)!==-1;};}predicateFn=function predicateFn(item){if(shouldMatchPrimitives&&!isObject(item)){return deepCompare(item,expression.$,comparator,false);}return deepCompare(item,expression,comparator,matchAgainstAnyProp);};return predicateFn;}function deepCompare(actual,expected,comparator,matchAgainstAnyProp,dontMatchWholeObject){var actualType=getTypeForFilter(actual);var expectedType=getTypeForFilter(expected);if(expectedType==='string'&&expected.charAt(0)==='!'){return!deepCompare(actual,expected.substring(1),comparator,matchAgainstAnyProp);}else if(isArray(actual)){// In case `actual` is an array, consider it a match
	// if ANY of it's items matches `expected`
	return actual.some(function(item){return deepCompare(item,expected,comparator,matchAgainstAnyProp);});}switch(actualType){case'object':var key;if(matchAgainstAnyProp){for(key in actual){if(key.charAt(0)!=='$'&&deepCompare(actual[key],expected,comparator,true)){return true;}}return dontMatchWholeObject?false:deepCompare(actual,expected,comparator,false);}else if(expectedType==='object'){for(key in expected){var expectedVal=expected[key];if(isFunction(expectedVal)||isUndefined(expectedVal)){continue;}var matchAnyProperty=key==='$';var actualVal=matchAnyProperty?actual:actual[key];if(!deepCompare(actualVal,expectedVal,comparator,matchAnyProperty,matchAnyProperty)){return false;}}return true;}else{return comparator(actual,expected);}break;case'function':return false;default:return comparator(actual,expected);}}// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val){return val===null?'null':typeof val==='undefined'?'undefined':_typeof(val);}var MAX_DIGITS=22;var DECIMAL_SEP='.';var ZERO_CHAR='0';/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser == 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */currencyFilter.$inject=['$locale'];function currencyFilter($locale){var formats=$locale.NUMBER_FORMATS;return function(amount,currencySymbol,fractionSize){if(isUndefined(currencySymbol)){currencySymbol=formats.CURRENCY_SYM;}if(isUndefined(fractionSize)){fractionSize=formats.PATTERNS[1].maxFrac;}// if null or undefined pass it through
	return amount==null?amount:formatNumber(amount,formats.PATTERNS[1],formats.GROUP_SEP,formats.DECIMAL_SEP,fractionSize).replace(/\u00A4/g,currencySymbol);};}/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */numberFilter.$inject=['$locale'];function numberFilter($locale){var formats=$locale.NUMBER_FORMATS;return function(number,fractionSize){// if null or undefined pass it through
	return number==null?number:formatNumber(number,formats.PATTERNS[0],formats.GROUP_SEP,formats.DECIMAL_SEP,fractionSize);};}/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */function parse(numStr){var exponent=0,digits,numberOfIntegerDigits;var i,j,zeros;// Decimal point?
	if((numberOfIntegerDigits=numStr.indexOf(DECIMAL_SEP))>-1){numStr=numStr.replace(DECIMAL_SEP,'');}// Exponential form?
	if((i=numStr.search(/e/i))>0){// Work out the exponent.
	if(numberOfIntegerDigits<0)numberOfIntegerDigits=i;numberOfIntegerDigits+=+numStr.slice(i+1);numStr=numStr.substring(0,i);}else if(numberOfIntegerDigits<0){// There was no decimal point or exponent so it is an integer.
	numberOfIntegerDigits=numStr.length;}// Count the number of leading zeros.
	for(i=0;numStr.charAt(i)==ZERO_CHAR;i++){/* jshint noempty: false */}if(i==(zeros=numStr.length)){// The digits are all zero.
	digits=[0];numberOfIntegerDigits=1;}else{// Count the number of trailing zeros
	zeros--;while(numStr.charAt(zeros)==ZERO_CHAR){zeros--;}// Trailing zeros are insignificant so ignore them
	numberOfIntegerDigits-=i;digits=[];// Convert string to array of digits without leading/trailing zeros.
	for(j=0;i<=zeros;i++,j++){digits[j]=+numStr.charAt(i);}}// If the number overflows the maximum allowed digits then use an exponent.
	if(numberOfIntegerDigits>MAX_DIGITS){digits=digits.splice(0,MAX_DIGITS-1);exponent=numberOfIntegerDigits-1;numberOfIntegerDigits=1;}return{d:digits,e:exponent,i:numberOfIntegerDigits};}/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */function roundNumber(parsedNumber,fractionSize,minFrac,maxFrac){var digits=parsedNumber.d;var fractionLen=digits.length-parsedNumber.i;// determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	fractionSize=isUndefined(fractionSize)?Math.min(Math.max(minFrac,fractionLen),maxFrac):+fractionSize;// The index of the digit to where rounding is to occur
	var roundAt=fractionSize+parsedNumber.i;var digit=digits[roundAt];if(roundAt>0){digits.splice(roundAt);}else{// We rounded to zero so reset the parsedNumber
	parsedNumber.i=1;digits.length=roundAt=fractionSize+1;for(var i=0;i<roundAt;i++){digits[i]=0;}}if(digit>=5)digits[roundAt-1]++;// Pad out with zeros to get the required fraction length
	for(;fractionLen<fractionSize;fractionLen++){digits.push(0);}// Do any carrying, e.g. a digit was rounded up to 10
	var carry=digits.reduceRight(function(carry,d,i,digits){d=d+carry;digits[i]=d%10;return Math.floor(d/10);},0);if(carry){digits.unshift(carry);parsedNumber.i++;}}/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */function formatNumber(number,pattern,groupSep,decimalSep,fractionSize){if(!(isString(number)||isNumber(number))||isNaN(number))return'';var isInfinity=!isFinite(number);var isZero=false;var numStr=Math.abs(number)+'',formattedText='',parsedNumber;if(isInfinity){formattedText='\u221E';}else{parsedNumber=parse(numStr);roundNumber(parsedNumber,fractionSize,pattern.minFrac,pattern.maxFrac);var digits=parsedNumber.d;var integerLen=parsedNumber.i;var exponent=parsedNumber.e;var decimals=[];isZero=digits.reduce(function(isZero,d){return isZero&&!d;},true);// pad zeros for small numbers
	while(integerLen<0){digits.unshift(0);integerLen++;}// extract decimals digits
	if(integerLen>0){decimals=digits.splice(integerLen,digits.length);}else{decimals=digits;digits=[0];}// format the integer digits with grouping separators
	var groups=[];if(digits.length>=pattern.lgSize){groups.unshift(digits.splice(-pattern.lgSize,digits.length).join(''));}while(digits.length>pattern.gSize){groups.unshift(digits.splice(-pattern.gSize,digits.length).join(''));}if(digits.length){groups.unshift(digits.join(''));}formattedText=groups.join(groupSep);// append the decimal digits
	if(decimals.length){formattedText+=decimalSep+decimals.join('');}if(exponent){formattedText+='e+'+exponent;}}if(number<0&&!isZero){return pattern.negPre+formattedText+pattern.negSuf;}else{return pattern.posPre+formattedText+pattern.posSuf;}}function padNumber(num,digits,trim){var neg='';if(num<0){neg='-';num=-num;}num=''+num;while(num.length<digits){num=ZERO_CHAR+num;}if(trim){num=num.substr(num.length-digits);}return neg+num;}function dateGetter(name,size,offset,trim){offset=offset||0;return function(date){var value=date['get'+name]();if(offset>0||value>-offset){value+=offset;}if(value===0&&offset==-12)value=12;return padNumber(value,size,trim);};}function dateStrGetter(name,shortForm){return function(date,formats){var value=date['get'+name]();var get=uppercase(shortForm?'SHORT'+name:name);return formats[get][value];};}function timeZoneGetter(date,formats,offset){var zone=-1*offset;var paddedZone=zone>=0?"+":"";paddedZone+=padNumber(Math[zone>0?'floor':'ceil'](zone/60),2)+padNumber(Math.abs(zone%60),2);return paddedZone;}function getFirstThursdayOfYear(year){// 0 = index of January
	var dayOfWeekOnFirst=new Date(year,0,1).getDay();// 4 = index of Thursday (+1 to account for 1st = 5)
	// 11 = index of *next* Thursday (+1 account for 1st = 12)
	return new Date(year,0,(dayOfWeekOnFirst<=4?5:12)-dayOfWeekOnFirst);}function getThursdayThisWeek(datetime){return new Date(datetime.getFullYear(),datetime.getMonth(),// 4 = index of Thursday
	datetime.getDate()+(4-datetime.getDay()));}function weekGetter(size){return function(date){var firstThurs=getFirstThursdayOfYear(date.getFullYear()),thisThurs=getThursdayThisWeek(date);var diff=+thisThurs-+firstThurs,result=1+Math.round(diff/6.048e8);// 6.048e8 ms per week
	return padNumber(result,size);};}function ampmGetter(date,formats){return date.getHours()<12?formats.AMPMS[0]:formats.AMPMS[1];}function eraGetter(date,formats){return date.getFullYear()<=0?formats.ERAS[0]:formats.ERAS[1];}function longEraGetter(date,formats){return date.getFullYear()<=0?formats.ERANAMES[0]:formats.ERANAMES[1];}var DATE_FORMATS={yyyy:dateGetter('FullYear',4),yy:dateGetter('FullYear',2,0,true),y:dateGetter('FullYear',1),MMMM:dateStrGetter('Month'),MMM:dateStrGetter('Month',true),MM:dateGetter('Month',2,1),M:dateGetter('Month',1,1),dd:dateGetter('Date',2),d:dateGetter('Date',1),HH:dateGetter('Hours',2),H:dateGetter('Hours',1),hh:dateGetter('Hours',2,-12),h:dateGetter('Hours',1,-12),mm:dateGetter('Minutes',2),m:dateGetter('Minutes',1),ss:dateGetter('Seconds',2),s:dateGetter('Seconds',1),// while ISO 8601 requires fractions to be prefixed with `.` or `,`
	// we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	sss:dateGetter('Milliseconds',3),EEEE:dateStrGetter('Day'),EEE:dateStrGetter('Day',true),a:ampmGetter,Z:timeZoneGetter,ww:weekGetter(2),w:weekGetter(1),G:eraGetter,GG:eraGetter,GGG:eraGetter,GGGG:longEraGetter};var DATE_FORMATS_SPLIT=/((?:[^yMdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,NUMBER_STRING=/^\-?\d+$/;/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010\-10\-2\d \d{2}:\d{2}:\d{2} (\-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */dateFilter.$inject=['$locale'];function dateFilter($locale){var R_ISO8601_STR=/^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;// 1        2       3         4          5          6          7          8  9     10      11
	function jsonStringToDate(string){var match;if(match=string.match(R_ISO8601_STR)){var date=new Date(0),tzHour=0,tzMin=0,dateSetter=match[8]?date.setUTCFullYear:date.setFullYear,timeSetter=match[8]?date.setUTCHours:date.setHours;if(match[9]){tzHour=toInt(match[9]+match[10]);tzMin=toInt(match[9]+match[11]);}dateSetter.call(date,toInt(match[1]),toInt(match[2])-1,toInt(match[3]));var h=toInt(match[4]||0)-tzHour;var m=toInt(match[5]||0)-tzMin;var s=toInt(match[6]||0);var ms=Math.round(parseFloat('0.'+(match[7]||0))*1000);timeSetter.call(date,h,m,s,ms);return date;}return string;}return function(date,format,timezone){var text='',parts=[],fn,match;format=format||'mediumDate';format=$locale.DATETIME_FORMATS[format]||format;if(isString(date)){date=NUMBER_STRING.test(date)?toInt(date):jsonStringToDate(date);}if(isNumber(date)){date=new Date(date);}if(!isDate(date)||!isFinite(date.getTime())){return date;}while(format){match=DATE_FORMATS_SPLIT.exec(format);if(match){parts=concat(parts,match,1);format=parts.pop();}else{parts.push(format);format=null;}}var dateTimezoneOffset=date.getTimezoneOffset();if(timezone){dateTimezoneOffset=timezoneToOffset(timezone,dateTimezoneOffset);date=convertTimezoneToLocal(date,timezone,true);}forEach(parts,function(value){fn=DATE_FORMATS[value];text+=fn?fn(date,$locale.DATETIME_FORMATS,dateTimezoneOffset):value==="''"?"'":value.replace(/(^'|'$)/g,'').replace(/''/g,"'");});return text;};}/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n  "name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n    "name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */function jsonFilter(){return function(object,spacing){if(isUndefined(spacing)){spacing=2;}return toJson(object,spacing);};}/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 * @see angular.lowercase
	 */var lowercaseFilter=valueFn(lowercase);/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @see angular.uppercase
	 */var uppercaseFilter=valueFn(uppercase);/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements
	 * are taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. If a number is used as input, it is
	 * converted to a string.
	 *
	 * @param {Array|string|number} input Source array, string or number to be limited.
	 * @param {string|number} limit The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin Index at which to begin limitation. As a negative index, `begin`
	 *     indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if input array
	 *     had less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/function limitToFilter(){return function(input,limit,begin){if(Math.abs(Number(limit))===Infinity){limit=Number(limit);}else{limit=toInt(limit);}if(isNaN(limit))return input;if(isNumber(input))input=input.toString();if(!isArray(input)&&!isString(input))return input;begin=!begin||isNaN(begin)?0:toInt(begin);begin=begin<0?Math.max(0,input.length+begin):begin;if(limit>=0){return input.slice(begin,begin+limit);}else{if(begin===0){return input.slice(limit,input.length);}else{return input.slice(Math.max(0,begin+limit),begin);}}};}/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Orders a specified `array` by the `expression` predicate. It is ordered alphabetically
	 * for strings and numerically for numbers. Note: if you notice numbers are not being sorted
	 * as expected, make sure they are actually being saved as numbers and not strings.
	 *
	 * @param {Array} array The array to sort.
	 * @param {function(*)|string|Array.<(function(*)|string)>=} expression A predicate to be
	 *    used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `function`: Getter function. The result of this function will be sorted using the
	 *      `<`, `===`, `>` operator.
	 *    - `string`: An Angular expression. The result of this expression is used to compare elements
	 *      (for example `name` to sort by a property called `name` or `name.substr(0, 3)` to sort by
	 *      3 first characters of a property called `name`). The result of a constant expression
	 *      is interpreted as a property name to be used in comparisons (for example `"special name"`
	 *      to sort object by the value of their `special name` property). An expression can be
	 *      optionally prefixed with `+` or `-` to control ascending or descending sort order
	 *      (for example, `+name` or `-name`). If no property is provided, (e.g. `'+'`) then the array
	 *      element itself is used to compare where sorting.
	 *    - `Array`: An array of function or string predicates. The first predicate in the array
	 *      is used for sorting, but when two items are equivalent, the next predicate is used.
	 *
	 *    If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse Reverse the order of the array.
	 * @returns {Array} Sorted copy of the source array.
	 *
	 *
	 * @example
	 * The example below demonstrates a simple ngRepeat, where the data is sorted
	 * by age in descending order (predicate is set to `'-age'`).
	 * `reverse` is not set, which means it defaults to `false`.
	   <example module="orderByExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friend">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends =
	               [{name:'John', phone:'555-1212', age:10},
	                {name:'Mary', phone:'555-9876', age:19},
	                {name:'Mike', phone:'555-4321', age:21},
	                {name:'Adam', phone:'555-5678', age:35},
	                {name:'Julie', phone:'555-8765', age:29}];
	         }]);
	     </file>
	   </example>
	 *
	 * The predicate and reverse parameters can be controlled dynamically through scope properties,
	 * as shown in the next example.
	 * @example
	   <example module="orderByExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sorting predicate = {{predicate}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="predicate=''">Set to unsorted</button>
	         <table class="friend">
	           <tr>
	            <th>
	                <button ng-click="order('name')">Name</button>
	                <span class="sortorder" ng-show="predicate === 'name'" ng-class="{reverse:reverse}"></span>
	            </th>
	            <th>
	                <button ng-click="order('phone')">Phone Number</button>
	                <span class="sortorder" ng-show="predicate === 'phone'" ng-class="{reverse:reverse}"></span>
	            </th>
	            <th>
	                <button ng-click="order('age')">Age</button>
	                <span class="sortorder" ng-show="predicate === 'age'" ng-class="{reverse:reverse}"></span>
	            </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:predicate:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends =
	               [{name:'John', phone:'555-1212', age:10},
	                {name:'Mary', phone:'555-9876', age:19},
	                {name:'Mike', phone:'555-4321', age:21},
	                {name:'Adam', phone:'555-5678', age:35},
	                {name:'Julie', phone:'555-8765', age:29}];
	           $scope.predicate = 'age';
	           $scope.reverse = true;
	           $scope.order = function(predicate) {
	             $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
	             $scope.predicate = predicate;
	           };
	         }]);
	      </file>
	     <file name="style.css">
	       .sortorder:after {
	         content: '\25b2';
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';
	       }
	     </file>
	   </example>
	 *
	 * It's also possible to call the orderBy filter manually, by injecting `$filter`, retrieving the
	 * filter routine with `$filter('orderBy')`, and calling the returned filter routine with the
	 * desired parameters.
	 *
	 * Example:
	 *
	 * @example
	  <example module="orderByExample">
	    <file name="index.html">
	    <div ng-controller="ExampleController">
	      <pre>Sorting predicate = {{predicate}}; reverse = {{reverse}}</pre>
	      <table class="friend">
	        <tr>
	          <th>
	              <button ng-click="order('name')">Name</button>
	              <span class="sortorder" ng-show="predicate === 'name'" ng-class="{reverse:reverse}"></span>
	          </th>
	          <th>
	              <button ng-click="order('phone')">Phone Number</button>
	              <span class="sortorder" ng-show="predicate === 'phone'" ng-class="{reverse:reverse}"></span>
	          </th>
	          <th>
	              <button ng-click="order('age')">Age</button>
	              <span class="sortorder" ng-show="predicate === 'age'" ng-class="{reverse:reverse}"></span>
	          </th>
	        </tr>
	        <tr ng-repeat="friend in friends">
	          <td>{{friend.name}}</td>
	          <td>{{friend.phone}}</td>
	          <td>{{friend.age}}</td>
	        </tr>
	      </table>
	    </div>
	    </file>
	
	    <file name="script.js">
	      angular.module('orderByExample', [])
	        .controller('ExampleController', ['$scope', '$filter', function($scope, $filter) {
	          var orderBy = $filter('orderBy');
	          $scope.friends = [
	            { name: 'John',    phone: '555-1212',    age: 10 },
	            { name: 'Mary',    phone: '555-9876',    age: 19 },
	            { name: 'Mike',    phone: '555-4321',    age: 21 },
	            { name: 'Adam',    phone: '555-5678',    age: 35 },
	            { name: 'Julie',   phone: '555-8765',    age: 29 }
	          ];
	          $scope.order = function(predicate) {
	            $scope.predicate = predicate;
	            $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
	            $scope.friends = orderBy($scope.friends, predicate, $scope.reverse);
	          };
	          $scope.order('age', true);
	        }]);
	    </file>
	
	    <file name="style.css">
	       .sortorder:after {
	         content: '\25b2';
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';
	       }
	    </file>
	</example>
	 */orderByFilter.$inject=['$parse'];function orderByFilter($parse){return function(array,sortPredicate,reverseOrder){if(!isArrayLike(array))return array;if(!isArray(sortPredicate)){sortPredicate=[sortPredicate];}if(sortPredicate.length===0){sortPredicate=['+'];}var predicates=processPredicates(sortPredicate,reverseOrder);// Add a predicate at the end that evaluates to the element index. This makes the
	// sort stable as it works as a tie-breaker when all the input predicates cannot
	// distinguish between two elements.
	predicates.push({get:function get(){return{};},descending:reverseOrder?-1:1});// The next three lines are a version of a Swartzian Transform idiom from Perl
	// (sometimes called the Decorate-Sort-Undecorate idiom)
	// See https://en.wikipedia.org/wiki/Schwartzian_transform
	var compareValues=Array.prototype.map.call(array,getComparisonObject);compareValues.sort(doComparison);array=compareValues.map(function(item){return item.value;});return array;function getComparisonObject(value,index){return{value:value,predicateValues:predicates.map(function(predicate){return getPredicateValue(predicate.get(value),index);})};}function doComparison(v1,v2){var result=0;for(var index=0,length=predicates.length;index<length;++index){result=compare(v1.predicateValues[index],v2.predicateValues[index])*predicates[index].descending;if(result)break;}return result;}};function processPredicates(sortPredicate,reverseOrder){reverseOrder=reverseOrder?-1:1;return sortPredicate.map(function(predicate){var descending=1,get=identity;if(isFunction(predicate)){get=predicate;}else if(isString(predicate)){if(predicate.charAt(0)=='+'||predicate.charAt(0)=='-'){descending=predicate.charAt(0)=='-'?-1:1;predicate=predicate.substring(1);}if(predicate!==''){get=$parse(predicate);if(get.constant){var key=get();get=function get(value){return value[key];};}}}return{get:get,descending:descending*reverseOrder};});}function isPrimitive(value){switch(typeof value==='undefined'?'undefined':_typeof(value)){case'number':/* falls through */case'boolean':/* falls through */case'string':return true;default:return false;}}function objectValue(value,index){// If `valueOf` is a valid function use that
	if(typeof value.valueOf==='function'){value=value.valueOf();if(isPrimitive(value))return value;}// If `toString` is a valid function and not the one from `Object.prototype` use that
	if(hasCustomToString(value)){value=value.toString();if(isPrimitive(value))return value;}// We have a basic object so we use the position of the object in the collection
	return index;}function getPredicateValue(value,index){var type=typeof value==='undefined'?'undefined':_typeof(value);if(value===null){type='string';value='null';}else if(type==='string'){value=value.toLowerCase();}else if(type==='object'){value=objectValue(value,index);}return{value:value,type:type};}function compare(v1,v2){var result=0;if(v1.type===v2.type){if(v1.value!==v2.value){result=v1.value<v2.value?-1:1;}}else{result=v1.type<v2.type?-1:1;}return result;}}function ngDirective(directive){if(isFunction(directive)){directive={link:directive};}directive.restrict=directive.restrict||'AC';return valueFn(directive);}/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html A tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * This change permits the easy creation of action links with the `ngClick` directive
	 * without changing the location or causing page reloads, e.g.:
	 * `<a href="" ng-click="list.addItem()">Add Item</a>`
	 */var htmlAnchorDirective=valueFn({restrict:'E',compile:function compile(element,attr){if(!attr.href&&!attr.xlinkHref){return function(scope,element){// If the linked element is not an anchor tag anymore, do nothing
	if(element[0].nodeName.toLowerCase()!=='a')return;// SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	var href=toString.call(element.prop('href'))==='[object SVGAnimatedString]'?'xlink:href':'href';element.on('click',function(event){// if we have no href url, then don't navigate anywhere.
	if(!element.attr(href)){event.preventDefault();}});};}}});/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example>
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 *//**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 *//**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 *//**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 *//**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 *//**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readOnly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readOnly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 *//**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 *//**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	     <example>
	       <file name="index.html">
	         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>Show/Hide me</summary>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */var ngAttributeAliasDirectives={};// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR,function(propName,attrName){// binding to multiple is not supported
	if(propName=="multiple")return;function defaultLinkFn(scope,element,attr){scope.$watch(attr[normalized],function ngBooleanAttrWatchAction(value){attr.$set(attrName,!!value);});}var normalized=directiveNormalize('ng-'+attrName);var linkFn=defaultLinkFn;if(propName==='checked'){linkFn=function linkFn(scope,element,attr){// ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	if(attr.ngModel!==attr[normalized]){defaultLinkFn(scope,element,attr);}};}ngAttributeAliasDirectives[normalized]=function(){return{restrict:'A',priority:100,link:linkFn};};});// aliased input attrs are evaluated
	forEach(ALIASED_ATTR,function(htmlAttr,ngAttr){ngAttributeAliasDirectives[ngAttr]=function(){return{priority:100,link:function link(scope,element,attr){//special case ngPattern when a literal regular expression value
	//is used as the expression (this way we don't have to watch anything).
	if(ngAttr==="ngPattern"&&attr.ngPattern.charAt(0)=="/"){var match=attr.ngPattern.match(REGEX_STRING_REGEXP);if(match){attr.$set("ngPattern",new RegExp(match[1],match[2]));return;}}scope.$watch(attr[ngAttr],function ngAttrAliasWatchAction(value){attr.$set(ngAttr,value);});}};};});// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src','srcset','href'],function(attrName){var normalized=directiveNormalize('ng-'+attrName);ngAttributeAliasDirectives[normalized]=function(){return{priority:99,// it needs to run after the attributes are interpolated
	link:function link(scope,element,attr){var propName=attrName,name=attrName;if(attrName==='href'&&toString.call(element.prop('href'))==='[object SVGAnimatedString]'){name='xlinkHref';attr.$attr[name]='xlink:href';propName=null;}attr.$observe(normalized,function(value){if(!value){if(attrName==='href'){attr.$set(name,null);}return;}attr.$set(name,value);// on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	// then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	// to set the property as well to achieve the desired effect.
	// we use attr[attrName] value since $set can sanitize the url.
	if(msie&&propName)element.prop(propName,attr[name]);});}};};});/* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
	 */var nullFormCtrl={$addControl:noop,$$renameControl:nullFormRenameControl,$removeControl:noop,$setValidity:noop,$setDirty:noop,$setPristine:noop,$setSubmitted:noop},SUBMITTED_CLASS='ng-submitted';function nullFormRenameControl(control,name){control.$name=name;}/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $pending True if at least one containing control or form is pending.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $error Is an object hash, containing references to controls or
	 *  forms with failing validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for given error name.
	 *
	 *  Built-in validation tokens:
	 *
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 *///asks for $scope to fool the BC controller module
	FormController.$inject=['$element','$attrs','$scope','$animate','$interpolate'];function FormController(element,attrs,$scope,$animate,$interpolate){var form=this,controls=[];// init state
	form.$error={};form.$$success={};form.$pending=undefined;form.$name=$interpolate(attrs.name||attrs.ngForm||'')($scope);form.$dirty=false;form.$pristine=true;form.$valid=true;form.$invalid=false;form.$submitted=false;form.$$parentForm=nullFormCtrl;/**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */form.$rollbackViewValue=function(){forEach(controls,function(control){control.$rollbackViewValue();});};/**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */form.$commitViewValue=function(){forEach(controls,function(control){control.$commitViewValue();});};/**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsiblity to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */form.$addControl=function(control){// Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	// and not added to the scope.  Now we throw an error.
	assertNotHasOwnProperty(control.$name,'input');controls.push(control);if(control.$name){form[control.$name]=control;}control.$$parentForm=form;};// Private API: rename a form control
	form.$$renameControl=function(control,newName){var oldName=control.$name;if(form[oldName]===control){delete form[oldName];}form[newName]=control;control.$name=newName;};/**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */form.$removeControl=function(control){if(control.$name&&form[control.$name]===control){delete form[control.$name];}forEach(form.$pending,function(value,name){form.$setValidity(name,null,control);});forEach(form.$error,function(value,name){form.$setValidity(name,null,control);});forEach(form.$$success,function(value,name){form.$setValidity(name,null,control);});arrayRemove(controls,control);control.$$parentForm=nullFormCtrl;};/**
	   * @ngdoc method
	   * @name form.FormController#$setValidity
	   *
	   * @description
	   * Sets the validity of a form control.
	   *
	   * This method will also propagate to parent forms.
	   */addSetValidityMethod({ctrl:this,$element:element,set:function set(object,property,controller){var list=object[property];if(!list){object[property]=[controller];}else{var index=list.indexOf(controller);if(index===-1){list.push(controller);}}},unset:function unset(object,property,controller){var list=object[property];if(!list){return;}arrayRemove(list,controller);if(list.length===0){delete object[property];}},$animate:$animate});/**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */form.$setDirty=function(){$animate.removeClass(element,PRISTINE_CLASS);$animate.addClass(element,DIRTY_CLASS);form.$dirty=true;form.$pristine=false;form.$$parentForm.$setDirty();};/**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method can be called to remove the 'ng-dirty' class and set the form to its pristine
	   * state (ng-pristine class). This method will also propagate to all the controls contained
	   * in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */form.$setPristine=function(){$animate.setClass(element,PRISTINE_CLASS,DIRTY_CLASS+' '+SUBMITTED_CLASS);form.$dirty=false;form.$pristine=true;form.$submitted=false;forEach(controls,function(control){control.$setPristine();});};/**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */form.$setUntouched=function(){forEach(controls,function(control){control.$setUntouched();});};/**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */form.$setSubmitted=function(){$animate.addClass(element,SUBMITTED_CLASS);form.$submitted=true;form.$$parentForm.$setSubmitted();};}/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 *//**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */var formDirectiveFactory=function formDirectiveFactory(isNgForm){return['$timeout','$parse',function($timeout,$parse){var formDirective={name:'form',restrict:isNgForm?'EAC':'E',require:['form','^^?form'],//first is the form's own ctrl, second is an optional parent form
	controller:FormController,compile:function ngFormCompile(formElement,attr){// Setup initial state of the control
	formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);var nameAttr=attr.name?'name':isNgForm&&attr.ngForm?'ngForm':false;return{pre:function ngFormPreLink(scope,formElement,attr,ctrls){var controller=ctrls[0];// if `action` attr is not present on the form, prevent the default action (submission)
	if(!('action'in attr)){// we can't use jq events because if a form is destroyed during submission the default
	// action is not prevented. see #1238
	//
	// IE 9 is not affected because it doesn't fire a submit event and try to do a full
	// page reload if the form was destroyed by submission of the form via a click handler
	// on a button in the form. Looks like an IE9 specific bug.
	var handleFormSubmission=function handleFormSubmission(event){scope.$apply(function(){controller.$commitViewValue();controller.$setSubmitted();});event.preventDefault();};addEventListenerFn(formElement[0],'submit',handleFormSubmission);// unregister the preventDefault listener so that we don't not leak memory but in a
	// way that will achieve the prevention of the default action.
	formElement.on('$destroy',function(){$timeout(function(){removeEventListenerFn(formElement[0],'submit',handleFormSubmission);},0,false);});}var parentFormCtrl=ctrls[1]||controller.$$parentForm;parentFormCtrl.$addControl(controller);var setter=nameAttr?getSetter(controller.$name):noop;if(nameAttr){setter(scope,controller);attr.$observe(nameAttr,function(newValue){if(controller.$name===newValue)return;setter(scope,undefined);controller.$$parentForm.$$renameControl(controller,newValue);setter=getSetter(controller.$name);setter(scope,controller);});}formElement.on('$destroy',function(){controller.$$parentForm.$removeControl(controller);setter(scope,undefined);extend(controller,nullFormCtrl);//stop propagating child destruction handlers upwards
	});}};}};return formDirective;function getSetter(expression){if(expression===''){//create an assignable expression, so forms with an empty name can be renamed later
	return $parse('this[""]').assign;}return $parse(expression).assign||noop;}}];};var formDirective=formDirectiveFactory();var ngFormDirective=formDirectiveFactory(true);/* global VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  UNTOUCHED_CLASS: false,
	  TOUCHED_CLASS: false,
	  ngModelMinErr: false,
	*/// Regex code is obtained from SO: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP=/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        555555555555555555555555    666     77777777     8888888     999
	var URL_REGEXP=/^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+\])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;var EMAIL_REGEXP=/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;var NUMBER_REGEXP=/^\s*(\-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;var DATE_REGEXP=/^(\d{4})-(\d{2})-(\d{2})$/;var DATETIMELOCAL_REGEXP=/^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;var WEEK_REGEXP=/^(\d{4})-W(\d\d)$/;var MONTH_REGEXP=/^(\d{4})-(\d\d)$/;var TIME_REGEXP=/^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;var PARTIAL_VALIDATION_EVENTS='keydown wheel mousedown';var PARTIAL_VALIDATION_TYPES=createMap();forEach('date,datetime-local,month,time,week'.split(','),function(type){PARTIAL_VALIDATION_TYPES[type]=true;});var inputType={/**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	   *    a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <tt>text = {{example.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */'text':textInputType,/**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	        var input = element(by.model('example.value'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */'date':createDateInputType('date',DATE_REGEXP,createDateParser(DATE_REGEXP,['yyyy','MM','dd']),'yyyy-MM-dd'),/**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */'datetime-local':createDateInputType('datetimelocal',DATETIMELOCAL_REGEXP,createDateParser(DATETIMELOCAL_REGEXP,['yyyy','MM','dd','HH','mm','ss','sss']),'yyyy-MM-ddTHH:mm:ss.sss'),/**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */'time':createDateInputType('time',TIME_REGEXP,createDateParser(TIME_REGEXP,['HH','mm','ss','sss']),'HH:mm:ss.sss'),/**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */'week':createDateInputType('week',WEEK_REGEXP,weekParser,'yyyy-Www'),/**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */'month':createDateInputType('month',MONTH_REGEXP,createDateParser(MONTH_REGEXP,['yyyy','MM']),'yyyy-MM'),/**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	   *    a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */'number':numberInputType,/**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	   *    a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */'url':urlInputType,/**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	   *    a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */'email':emailInputType,/**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            element.all(by.model('color.name')).get(0).click();
	
	            expect(color.getText()).toContain('red');
	          });
	        </file>
	      </example>
	   */'radio':radioInputType,/**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */'checkbox':checkboxInputType,'hidden':noop,'button':noop,'submit':noop,'reset':noop,'file':noop};function stringBasedInputType(ctrl){ctrl.$formatters.push(function(value){return ctrl.$isEmpty(value)?value:value.toString();});}function textInputType(scope,element,attr,ctrl,$sniffer,$browser){baseInputType(scope,element,attr,ctrl,$sniffer,$browser);stringBasedInputType(ctrl);}function baseInputType(scope,element,attr,ctrl,$sniffer,$browser){var type=lowercase(element[0].type);// In composition mode, users are still inputing intermediate text buffer,
	// hold the listener until composition is done.
	// More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	if(!$sniffer.android){var composing=false;element.on('compositionstart',function(data){composing=true;});element.on('compositionend',function(){composing=false;listener();});}var timeout;var listener=function listener(ev){if(timeout){$browser.defer.cancel(timeout);timeout=null;}if(composing)return;var value=element.val(),event=ev&&ev.type;// By default we will trim the value
	// If the attribute ng-trim exists we will avoid trimming
	// If input type is 'password', the value is never trimmed
	if(type!=='password'&&(!attr.ngTrim||attr.ngTrim!=='false')){value=trim(value);}// If a control is suffering from bad input (due to native validators), browsers discard its
	// value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	// control's value is the same empty value twice in a row.
	if(ctrl.$viewValue!==value||value===''&&ctrl.$$hasNativeValidators){ctrl.$setViewValue(value,event);}};// if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	// input event on backspace, delete or cut
	if($sniffer.hasEvent('input')){element.on('input',listener);}else{var deferListener=function deferListener(ev,input,origValue){if(!timeout){timeout=$browser.defer(function(){timeout=null;if(!input||input.value!==origValue){listener(ev);}});}};element.on('keydown',function(event){var key=event.keyCode;// ignore
	//    command            modifiers                   arrows
	if(key===91||15<key&&key<19||37<=key&&key<=40)return;deferListener(event,this,this.value);});// if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	if($sniffer.hasEvent('paste')){element.on('paste cut',deferListener);}}// if user paste into input using mouse on older browser
	// or form autocomplete on newer browser, we need "change" event to catch it
	element.on('change',listener);// Some native input types (date-family) have the ability to change validity without
	// firing any input/change events.
	// For these event types, when native validators are present and the browser supports the type,
	// check for validity changes on various DOM events.
	if(PARTIAL_VALIDATION_TYPES[type]&&ctrl.$$hasNativeValidators&&type===attr.type){element.on(PARTIAL_VALIDATION_EVENTS,function(ev){if(!timeout){var validity=this[VALIDITY_STATE_PROPERTY];var origBadInput=validity.badInput;var origTypeMismatch=validity.typeMismatch;timeout=$browser.defer(function(){timeout=null;if(validity.badInput!==origBadInput||validity.typeMismatch!==origTypeMismatch){listener(ev);}});}});}ctrl.$render=function(){// Workaround for Firefox validation #12102.
	var value=ctrl.$isEmpty(ctrl.$viewValue)?'':ctrl.$viewValue;if(element.val()!==value){element.val(value);}};}function weekParser(isoWeek,existingDate){if(isDate(isoWeek)){return isoWeek;}if(isString(isoWeek)){WEEK_REGEXP.lastIndex=0;var parts=WEEK_REGEXP.exec(isoWeek);if(parts){var year=+parts[1],week=+parts[2],hours=0,minutes=0,seconds=0,milliseconds=0,firstThurs=getFirstThursdayOfYear(year),addDays=(week-1)*7;if(existingDate){hours=existingDate.getHours();minutes=existingDate.getMinutes();seconds=existingDate.getSeconds();milliseconds=existingDate.getMilliseconds();}return new Date(year,0,firstThurs.getDate()+addDays,hours,minutes,seconds,milliseconds);}}return NaN;}function createDateParser(regexp,mapping){return function(iso,date){var parts,map;if(isDate(iso)){return iso;}if(isString(iso)){// When a date is JSON'ified to wraps itself inside of an extra
	// set of double quotes. This makes the date parsing code unable
	// to match the date string and parse it as a date.
	if(iso.charAt(0)=='"'&&iso.charAt(iso.length-1)=='"'){iso=iso.substring(1,iso.length-1);}if(ISO_DATE_REGEXP.test(iso)){return new Date(iso);}regexp.lastIndex=0;parts=regexp.exec(iso);if(parts){parts.shift();if(date){map={yyyy:date.getFullYear(),MM:date.getMonth()+1,dd:date.getDate(),HH:date.getHours(),mm:date.getMinutes(),ss:date.getSeconds(),sss:date.getMilliseconds()/1000};}else{map={yyyy:1970,MM:1,dd:1,HH:0,mm:0,ss:0,sss:0};}forEach(parts,function(part,index){if(index<mapping.length){map[mapping[index]]=+part;}});return new Date(map.yyyy,map.MM-1,map.dd,map.HH,map.mm,map.ss||0,map.sss*1000||0);}}return NaN;};}function createDateInputType(type,regexp,parseDate,format){return function dynamicDateInputType(scope,element,attr,ctrl,$sniffer,$browser,$filter){badInputChecker(scope,element,attr,ctrl);baseInputType(scope,element,attr,ctrl,$sniffer,$browser);var timezone=ctrl&&ctrl.$options&&ctrl.$options.timezone;var previousDate;ctrl.$$parserName=type;ctrl.$parsers.push(function(value){if(ctrl.$isEmpty(value))return null;if(regexp.test(value)){// Note: We cannot read ctrl.$modelValue, as there might be a different
	// parser/formatter in the processing chain so that the model
	// contains some different data format!
	var parsedDate=parseDate(value,previousDate);if(timezone){parsedDate=convertTimezoneToLocal(parsedDate,timezone);}return parsedDate;}return undefined;});ctrl.$formatters.push(function(value){if(value&&!isDate(value)){throw ngModelMinErr('datefmt','Expected `{0}` to be a date',value);}if(isValidDate(value)){previousDate=value;if(previousDate&&timezone){previousDate=convertTimezoneToLocal(previousDate,timezone,true);}return $filter('date')(value,format,timezone);}else{previousDate=null;return'';}});if(isDefined(attr.min)||attr.ngMin){var minVal;ctrl.$validators.min=function(value){return!isValidDate(value)||isUndefined(minVal)||parseDate(value)>=minVal;};attr.$observe('min',function(val){minVal=parseObservedDateValue(val);ctrl.$validate();});}if(isDefined(attr.max)||attr.ngMax){var maxVal;ctrl.$validators.max=function(value){return!isValidDate(value)||isUndefined(maxVal)||parseDate(value)<=maxVal;};attr.$observe('max',function(val){maxVal=parseObservedDateValue(val);ctrl.$validate();});}function isValidDate(value){// Invalid Date: getTime() returns NaN
	return value&&!(value.getTime&&value.getTime()!==value.getTime());}function parseObservedDateValue(val){return isDefined(val)&&!isDate(val)?parseDate(val)||undefined:val;}};}function badInputChecker(scope,element,attr,ctrl){var node=element[0];var nativeValidation=ctrl.$$hasNativeValidators=isObject(node.validity);if(nativeValidation){ctrl.$parsers.push(function(value){var validity=element.prop(VALIDITY_STATE_PROPERTY)||{};// Detect bug in FF35 for input[email] (https://bugzilla.mozilla.org/show_bug.cgi?id=1064430):
	// - also sets validity.badInput (should only be validity.typeMismatch).
	// - see http://www.whatwg.org/specs/web-apps/current-work/multipage/forms.html#e-mail-state-(type=email)
	// - can ignore this case as we can still read out the erroneous email...
	return validity.badInput&&!validity.typeMismatch?undefined:value;});}}function numberInputType(scope,element,attr,ctrl,$sniffer,$browser){badInputChecker(scope,element,attr,ctrl);baseInputType(scope,element,attr,ctrl,$sniffer,$browser);ctrl.$$parserName='number';ctrl.$parsers.push(function(value){if(ctrl.$isEmpty(value))return null;if(NUMBER_REGEXP.test(value))return parseFloat(value);return undefined;});ctrl.$formatters.push(function(value){if(!ctrl.$isEmpty(value)){if(!isNumber(value)){throw ngModelMinErr('numfmt','Expected `{0}` to be a number',value);}value=value.toString();}return value;});if(isDefined(attr.min)||attr.ngMin){var minVal;ctrl.$validators.min=function(value){return ctrl.$isEmpty(value)||isUndefined(minVal)||value>=minVal;};attr.$observe('min',function(val){if(isDefined(val)&&!isNumber(val)){val=parseFloat(val,10);}minVal=isNumber(val)&&!isNaN(val)?val:undefined;// TODO(matsko): implement validateLater to reduce number of validations
	ctrl.$validate();});}if(isDefined(attr.max)||attr.ngMax){var maxVal;ctrl.$validators.max=function(value){return ctrl.$isEmpty(value)||isUndefined(maxVal)||value<=maxVal;};attr.$observe('max',function(val){if(isDefined(val)&&!isNumber(val)){val=parseFloat(val,10);}maxVal=isNumber(val)&&!isNaN(val)?val:undefined;// TODO(matsko): implement validateLater to reduce number of validations
	ctrl.$validate();});}}function urlInputType(scope,element,attr,ctrl,$sniffer,$browser){// Note: no badInputChecker here by purpose as `url` is only a validation
	// in browsers, i.e. we can always read out input.value even if it is not valid!
	baseInputType(scope,element,attr,ctrl,$sniffer,$browser);stringBasedInputType(ctrl);ctrl.$$parserName='url';ctrl.$validators.url=function(modelValue,viewValue){var value=modelValue||viewValue;return ctrl.$isEmpty(value)||URL_REGEXP.test(value);};}function emailInputType(scope,element,attr,ctrl,$sniffer,$browser){// Note: no badInputChecker here by purpose as `url` is only a validation
	// in browsers, i.e. we can always read out input.value even if it is not valid!
	baseInputType(scope,element,attr,ctrl,$sniffer,$browser);stringBasedInputType(ctrl);ctrl.$$parserName='email';ctrl.$validators.email=function(modelValue,viewValue){var value=modelValue||viewValue;return ctrl.$isEmpty(value)||EMAIL_REGEXP.test(value);};}function radioInputType(scope,element,attr,ctrl){// make the name unique, if not defined
	if(isUndefined(attr.name)){element.attr('name',nextUid());}var listener=function listener(ev){if(element[0].checked){ctrl.$setViewValue(attr.value,ev&&ev.type);}};element.on('click',listener);ctrl.$render=function(){var value=attr.value;element[0].checked=value==ctrl.$viewValue;};attr.$observe('value',ctrl.$render);}function parseConstantExpr($parse,context,name,expression,fallback){var parseFn;if(isDefined(expression)){parseFn=$parse(expression);if(!parseFn.constant){throw ngModelMinErr('constexpr','Expected constant expression for `{0}`, but saw '+'`{1}`.',name,expression);}return parseFn(context);}return fallback;}function checkboxInputType(scope,element,attr,ctrl,$sniffer,$browser,$filter,$parse){var trueValue=parseConstantExpr($parse,scope,'ngTrueValue',attr.ngTrueValue,true);var falseValue=parseConstantExpr($parse,scope,'ngFalseValue',attr.ngFalseValue,false);var listener=function listener(ev){ctrl.$setViewValue(element[0].checked,ev&&ev.type);};element.on('click',listener);ctrl.$render=function(){element[0].checked=ctrl.$viewValue;};// Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	// This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	// it to a boolean.
	ctrl.$isEmpty=function(value){return value===false;};ctrl.$formatters.push(function(value){return equals(value,trueValue);});ctrl.$parsers.push(function(value){return value?trueValue:falseValue;});}/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	 *    a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *//**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	 *    a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */var inputDirective=['$browser','$sniffer','$filter','$parse',function($browser,$sniffer,$filter,$parse){return{restrict:'E',require:['?ngModel'],link:{pre:function pre(scope,element,attr,ctrls){if(ctrls[0]){(inputType[lowercase(attr.type)]||inputType.text)(scope,element,attr,ctrls[0],$sniffer,$browser,$filter,$parse);}}}};}];var CONSTANT_VALUE_REGEXP=/^(true|false|\d+)$/;/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of `<option>` or {@link input[radio] `input[radio]`},
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element is set to
	 * the bound value.
	 *
	 * `ngValue` is useful when dynamically generating lists of radio buttons using
	 * {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * Likewise, `ngValue` can be used to generate `<option>` elements for
	 * the {@link select `select`} element. In that case however, only strings are supported
	 * for the `value `attribute, so the resulting `ngModel` will always be a string.
	 * Support for `select` models with non-string values is available via `ngOptions`.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 *   of the `input` element
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */var ngValueDirective=function ngValueDirective(){return{restrict:'A',priority:100,compile:function compile(tpl,tplAttr){if(CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)){return function ngValueConstantLink(scope,elm,attr){attr.$set('value',scope.$eval(attr.ngValue));};}else{return function ngValueLink(scope,elm,attr){scope.$watch(attr.ngValue,function valueWatchAction(value){attr.$set('value',value);});};}}};};/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */var ngBindDirective=['$compile',function($compile){return{restrict:'AC',compile:function ngBindCompile(templateElement){$compile.$$addBindingClass(templateElement);return function ngBindLink(scope,element,attr){$compile.$$addBindingInfo(element,attr.ngBind);element=element[0];scope.$watch(attr.ngBind,function ngBindWatchAction(value){element.textContent=isUndefined(value)?'':value;});};}};}];/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */var ngBindTemplateDirective=['$interpolate','$compile',function($interpolate,$compile){return{compile:function ngBindTemplateCompile(templateElement){$compile.$$addBindingClass(templateElement);return function ngBindTemplateLink(scope,element,attr){var interpolateFn=$interpolate(element.attr(attr.$attr.ngBindTemplate));$compile.$$addBindingInfo(element,interpolateFn.expressions);element=element[0];attr.$observe('ngBindTemplate',function(value){element.textContent=isUndefined(value)?'':value;});};}};}];/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */var ngBindHtmlDirective=['$sce','$parse','$compile',function($sce,$parse,$compile){return{restrict:'A',compile:function ngBindHtmlCompile(tElement,tAttrs){var ngBindHtmlGetter=$parse(tAttrs.ngBindHtml);var ngBindHtmlWatch=$parse(tAttrs.ngBindHtml,function sceValueOf(val){// Unwrap the value to compare the actual inner safe value, not the wrapper object.
	return $sce.valueOf(val);});$compile.$$addBindingClass(tElement);return function ngBindHtmlLink(scope,element,attr){$compile.$$addBindingInfo(element,attr.ngBindHtml);scope.$watch(ngBindHtmlWatch,function ngBindHtmlWatchAction(){// The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	var value=ngBindHtmlGetter(scope);element.html($sce.getTrustedHtml(value)||'');});};}};}];/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */var ngChangeDirective=valueFn({restrict:'A',require:'ngModel',link:function link(scope,element,attr,ctrl){ctrl.$viewChangeListeners.push(function(){scope.$eval(attr.ngChange);});}});function classDirective(name,selector){name='ngClass'+name;return['$animate',function($animate){return{restrict:'AC',link:function link(scope,element,attr){var oldVal;scope.$watch(attr[name],ngClassWatchAction,true);attr.$observe('class',function(value){ngClassWatchAction(scope.$eval(attr[name]));});if(name!=='ngClass'){scope.$watch('$index',function($index,old$index){// jshint bitwise: false
	var mod=$index&1;if(mod!==(old$index&1)){var classes=arrayClasses(scope.$eval(attr[name]));mod===selector?addClasses(classes):removeClasses(classes);}});}function addClasses(classes){var newClasses=digestClassCounts(classes,1);attr.$addClass(newClasses);}function removeClasses(classes){var newClasses=digestClassCounts(classes,-1);attr.$removeClass(newClasses);}function digestClassCounts(classes,count){// Use createMap() to prevent class assumptions involving property
	// names in Object.prototype
	var classCounts=element.data('$classCounts')||createMap();var classesToUpdate=[];forEach(classes,function(className){if(count>0||classCounts[className]){classCounts[className]=(classCounts[className]||0)+count;if(classCounts[className]===+(count>0)){classesToUpdate.push(className);}}});element.data('$classCounts',classCounts);return classesToUpdate.join(' ');}function updateClasses(oldClasses,newClasses){var toAdd=arrayDifference(newClasses,oldClasses);var toRemove=arrayDifference(oldClasses,newClasses);toAdd=digestClassCounts(toAdd,1);toRemove=digestClassCounts(toRemove,-1);if(toAdd&&toAdd.length){$animate.addClass(element,toAdd);}if(toRemove&&toRemove.length){$animate.removeClass(element,toRemove);}}function ngClassWatchAction(newVal){if(selector===true||scope.$index%2===selector){var newClasses=arrayClasses(newVal||[]);if(!oldVal){addClasses(newClasses);}else if(!equals(newVal,oldVal)){var oldClasses=arrayClasses(oldVal);updateClasses(oldClasses,newClasses);}}if(isArray(newVal)){oldVal=newVal.map(function(v){return shallowCopy(v);});}else{oldVal=shallowCopy(newVal);}}}};function arrayDifference(tokens1,tokens2){var values=[];outer:for(var i=0;i<tokens1.length;i++){var token=tokens1[i];for(var j=0;j<tokens2.length;j++){if(token==tokens2[j])continue outer;}values.push(token);}return values;}function arrayClasses(classVal){var classes=[];if(isArray(classVal)){forEach(classVal,function(v){classes=classes.concat(arrayClasses(v));});return classes;}else if(isString(classVal)){return classVal.split(' ');}else if(isObject(classVal)){forEach(classVal,function(v,k){if(v){classes=classes.concat(k.split(' '));}});return classes;}return classVal;}}];}/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @animations
	 * **add** - happens just before the class is applied to the elements
	 *
	 * **remove** - happens just before the class is removed from the element
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example>
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 */var ngClassDirective=classDirective('',true);/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */var ngClassOddDirective=classDirective('Odd',0);/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */var ngClassEvenDirective=classDirective('Even',1);/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */var ngCloakDirective=ngDirective({compile:function compile(element,attr){attr.$set('ngCloak',undefined);element.removeClass('ng-cloak');}});/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = "John Smith";
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'} ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = "John Smith";
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'} ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */var ngControllerDirective=[function(){return{restrict:'A',scope:true,controller:'@',priority:500};}];/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @element html
	 * @description
	 *
	 * Angular has some features that can break certain
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement these rules then you must tell Angular not to use these features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following rules affect Angular:
	 *
	 * * `unsafe-eval`: this rule forbids apps to use `eval` or `Function(string)` generated functions
	 * (among other things). Angular makes use of this in the {@link $parse} service to provide a 30%
	 * increase in the speed of evaluating Angular expressions.
	 *
	 * * `unsafe-inline`: this rule forbids apps from inject custom styles into the document. Angular
	 * makes use of this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}).
	 * To make these directives work when a CSP rule is blocking inline styles, you must link to the
	 * `angular-csp.css` in your HTML manually.
	 *
	 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking unsafe-eval
	 * and automatically deactivates this feature in the {@link $parse} service. This autodetection,
	 * however, triggers a CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related Angular features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops Angular from optimising $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that Angular will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous versions
	 * of Angular.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous versions
	 * of Angular.
	 *
	 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can inject
	 * inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	 * run eval - no automcatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      // Note: the suffix `.csp` in the example name triggers
	      // csp mode in our http server!
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  // jshint evil:true
	                  try {
	                    eval('1+2');
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('protractor/node_modules/selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */// ngCsp is not implemented as a proper directive any more, because we need it be processed while we
	// bootstrap the system (before $parse is instantiated), for this reason we just have
	// the csp() fn that looks for the `ng-csp` attribute anywhere in the current doc
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 *//*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */var ngEventDirectives={};// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents={'blur':true,'focus':true};forEach('click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),function(eventName){var directiveName=directiveNormalize('ng-'+eventName);ngEventDirectives[directiveName]=['$parse','$rootScope',function($parse,$rootScope){return{restrict:'A',compile:function compile($element,attr){// We expose the powerful $event object on the scope that provides access to the Window,
	// etc. that isn't protected by the fast paths in $parse.  We explicitly request better
	// checks at the cost of speed since event handler expressions are not executed as
	// frequently as regular change detection.
	var fn=$parse(attr[directiveName],/* interceptorFn */null,/* expensiveChecks */true);return function ngEventHandler(scope,element){element.on(eventName,function(event){var callback=function callback(){fn(scope,{$event:event});};if(forceAsyncEvents[eventName]&&$rootScope.$$phase){scope.$evalAsync(callback);}else{scope.$apply(callback);}});};}};}];});/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 *//**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 *//**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * enter - happens just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container
	 * leave - happens just before the `ngIf` contents are removed from the DOM
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */var ngIfDirective=['$animate',function($animate){return{multiElement:true,transclude:'element',priority:600,terminal:true,restrict:'A',$$tlb:true,link:function link($scope,$element,$attr,ctrl,$transclude){var block,childScope,previousElements;$scope.$watch($attr.ngIf,function ngIfWatchAction(value){if(value){if(!childScope){$transclude(function(clone,newScope){childScope=newScope;clone[clone.length++]=document.createComment(' end ngIf: '+$attr.ngIf+' ');// Note: We only need the first/last node of the cloned nodes.
	// However, we need to keep the reference to the jqlite wrapper as it might be changed later
	// by a directive with templateUrl when its template arrives.
	block={clone:clone};$animate.enter(clone,$element.parent(),$element);});}}else{if(previousElements){previousElements.remove();previousElements=null;}if(childScope){childScope.$destroy();childScope=null;}if(block){previousElements=getBlockNodes(block.clone);$animate.leave(previousElements).then(function(){previousElements=null;});block=null;}}});}};}];/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * enter - animation is used to bring new content into the browser.
	 * leave - animation is used to animate existing content away.
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [ { name: 'template1.html', url: 'template1.html'},
	              { name: 'template2.html', url: 'template2.html'} ];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 *//**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 *//**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 *//**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */var ngIncludeDirective=['$templateRequest','$anchorScroll','$animate',function($templateRequest,$anchorScroll,$animate){return{restrict:'ECA',priority:400,terminal:true,transclude:'element',controller:angular.noop,compile:function compile(element,attr){var srcExp=attr.ngInclude||attr.src,onloadExp=attr.onload||'',autoScrollExp=attr.autoscroll;return function(scope,$element,$attr,ctrl,$transclude){var changeCounter=0,currentScope,previousElement,currentElement;var cleanupLastIncludeContent=function cleanupLastIncludeContent(){if(previousElement){previousElement.remove();previousElement=null;}if(currentScope){currentScope.$destroy();currentScope=null;}if(currentElement){$animate.leave(currentElement).then(function(){previousElement=null;});previousElement=currentElement;currentElement=null;}};scope.$watch(srcExp,function ngIncludeWatchAction(src){var afterAnimation=function afterAnimation(){if(isDefined(autoScrollExp)&&(!autoScrollExp||scope.$eval(autoScrollExp))){$anchorScroll();}};var thisChangeId=++changeCounter;if(src){//set the 2nd param to true to ignore the template request error so that the inner
	//contents and scope can be cleaned up.
	$templateRequest(src,true).then(function(response){if(scope.$$destroyed)return;if(thisChangeId!==changeCounter)return;var newScope=scope.$new();ctrl.template=response;// Note: This will also link all children of ng-include that were contained in the original
	// html. If that content contains controllers, ... they could pollute/change the scope.
	// However, using ng-include on an element with additional content does not make sense...
	// Note: We can't remove them in the cloneAttchFn of $transclude as that
	// function is called before linking the content, which would apply child
	// directives to non existing elements.
	var clone=$transclude(newScope,function(clone){cleanupLastIncludeContent();$animate.enter(clone,null,$element).then(afterAnimation);});currentScope=newScope;currentElement=clone;currentScope.$emit('$includeContentLoaded',src);scope.$eval(onloadExp);},function(){if(scope.$$destroyed)return;if(thisChangeId===changeCounter){cleanupLastIncludeContent();scope.$emit('$includeContentError',src);}});scope.$emit('$includeContentRequested',src);}else{cleanupLastIncludeContent();ctrl.template=null;}});};}};}];// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective=['$compile',function($compile){return{restrict:'ECA',priority:-400,require:'ngInclude',link:function link(scope,$element,$attr,ctrl){if(/SVG/.test($element[0].toString())){// WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	// support innerHTML, so detect this here and try to generate the contents
	// specially.
	$element.empty();$compile(jqLiteBuildFragment(ctrl.template,document).childNodes)(scope,function namespaceAdaptedClone(clone){$element.append(clone);},{futureParentElement:$element});return;}$element.html(ctrl.template);$compile($element.contents())(scope);}};}];/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
	 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
	 * rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */var ngInitDirective=ngDirective({priority:450,compile:function compile(){return{pre:function pre(scope,element,attrs){scope.$eval(attrs.ngInit);}};}});/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on newline
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */var ngListDirective=function ngListDirective(){return{restrict:'A',priority:100,require:'ngModel',link:function link(scope,element,attr,ctrl){// We want to control whitespace trimming so we use this convoluted approach
	// to access the ngList attribute, which doesn't pre-trim the attribute
	var ngList=element.attr(attr.$attr.ngList)||', ';var trimValues=attr.ngTrim!=='false';var separator=trimValues?trim(ngList):ngList;var parse=function parse(viewValue){// If the viewValue is invalid (say required but empty) it will be `undefined`
	if(isUndefined(viewValue))return;var list=[];if(viewValue){forEach(viewValue.split(separator),function(value){if(value)list.push(trimValues?trim(value):value);});}return list;};ctrl.$parsers.push(parse);ctrl.$formatters.push(function(value){if(isArray(value)){return value.join(ngList);}return undefined;});// Override the standard $isEmpty because an empty array means the input is empty.
	ctrl.$isEmpty=function(value){return!value||!value.length;};}};};/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	*/var VALID_CLASS='ng-valid',INVALID_CLASS='ng-invalid',PRISTINE_CLASS='ng-pristine',DIRTY_CLASS='ng-dirty',UNTOUCHED_CLASS='ng-untouched',TOUCHED_CLASS='ng-touched',PENDING_CLASS='ng-pending';var ngModelMinErr=minErr('ngModel');/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	       the control reads value from the DOM. The functions are called in array order, each passing
	       its return value through to the next. The last return value is forwarded to the
	       {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	`$viewValue`}.
	
	Returning `undefined` from a parser means a parse error occurred. In that case,
	no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	       the model value changes. The functions are called in reverse array order, each passing the value through to the
	       next. The last return value is used as the actual DOM value.
	       Used to format / convert values for display in the control.
	 * ```js
	 * function formatter(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(formatter);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if ( attrs.stripBr && html == '<br>' ) {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser == 'safari' || browser.params.browser == 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */var NgModelController=['$scope','$exceptionHandler','$attrs','$element','$parse','$animate','$timeout','$rootScope','$q','$interpolate',function($scope,$exceptionHandler,$attr,$element,$parse,$animate,$timeout,$rootScope,$q,$interpolate){this.$viewValue=Number.NaN;this.$modelValue=Number.NaN;this.$$rawModelValue=undefined;// stores the parsed modelValue / model set from scope regardless of validity.
	this.$validators={};this.$asyncValidators={};this.$parsers=[];this.$formatters=[];this.$viewChangeListeners=[];this.$untouched=true;this.$touched=false;this.$pristine=true;this.$dirty=false;this.$valid=true;this.$invalid=false;this.$error={};// keep invalid keys here
	this.$$success={};// keep valid keys here
	this.$pending=undefined;// keep pending keys here
	this.$name=$interpolate($attr.name||'',false)($scope);this.$$parentForm=nullFormCtrl;var parsedNgModel=$parse($attr.ngModel),parsedNgModelAssign=parsedNgModel.assign,ngModelGet=parsedNgModel,ngModelSet=parsedNgModelAssign,pendingDebounce=null,parserValid,ctrl=this;this.$$setOptions=function(options){ctrl.$options=options;if(options&&options.getterSetter){var invokeModelGetter=$parse($attr.ngModel+'()'),invokeModelSetter=$parse($attr.ngModel+'($$$p)');ngModelGet=function ngModelGet($scope){var modelValue=parsedNgModel($scope);if(isFunction(modelValue)){modelValue=invokeModelGetter($scope);}return modelValue;};ngModelSet=function ngModelSet($scope,newValue){if(isFunction(parsedNgModel($scope))){invokeModelSetter($scope,{$$$p:ctrl.$modelValue});}else{parsedNgModelAssign($scope,ctrl.$modelValue);}};}else if(!parsedNgModel.assign){throw ngModelMinErr('nonassign',"Expression '{0}' is non-assignable. Element: {1}",$attr.ngModel,startingTag($element));}};/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous value. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */this.$render=noop;/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */this.$isEmpty=function(value){return isUndefined(value)||value===''||value===null||value!==value;};var currentValidationRunId=0;/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setValidity
	   *
	   * @description
	   * Change the validity state, and notify the form.
	   *
	   * This method can be called within $parsers/$formatters or a custom validation implementation.
	   * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	   * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	   *
	   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	   *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	   *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	   *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
	   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	   *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	   *                          Skipped is used by Angular when validators do not run because of parse errors and
	   *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	   */addSetValidityMethod({ctrl:this,$element:$element,set:function set(object,property){object[property]=true;},unset:function unset(object,property){delete object[property];},$animate:$animate});/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */this.$setPristine=function(){ctrl.$dirty=false;ctrl.$pristine=true;$animate.removeClass($element,DIRTY_CLASS);$animate.addClass($element,PRISTINE_CLASS);};/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */this.$setDirty=function(){ctrl.$dirty=true;ctrl.$pristine=false;$animate.removeClass($element,PRISTINE_CLASS);$animate.addClass($element,DIRTY_CLASS);ctrl.$$parentForm.$setDirty();};/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */this.$setUntouched=function(){ctrl.$touched=false;ctrl.$untouched=true;$animate.setClass($element,UNTOUCHED_CLASS,TOUCHED_CLASS);};/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */this.$setTouched=function(){ctrl.$touched=true;ctrl.$untouched=false;$animate.setClass($element,TOUCHED_CLASS,UNTOUCHED_CLASS);};/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for a some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as blur, you can have a situation where there is a period when
	   * the `$viewValue` is out of sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode == 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *        <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *        empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *        <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *         <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                ng-keydown="setEmpty($event, 'value1')">
	   *         value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *        <p id="inputDescription2">With $rollbackViewValue():</p>
	   *         <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                ng-keydown="setEmpty($event, 'value2', true)">
	   *         value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */this.$rollbackViewValue=function(){$timeout.cancel(pendingDebounce);ctrl.$viewValue=ctrl.$$lastCommittedViewValue;ctrl.$render();};/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */this.$validate=function(){// ignore $validate before model is initialized
	if(isNumber(ctrl.$modelValue)&&isNaN(ctrl.$modelValue)){return;}var viewValue=ctrl.$$lastCommittedViewValue;// Note: we use the $$rawModelValue as $modelValue might have been
	// set to undefined during a view -> model update that found validation
	// errors. We can't parse the view here, since that could change
	// the model although neither viewValue nor the model on the scope changed
	var modelValue=ctrl.$$rawModelValue;var prevValid=ctrl.$valid;var prevModelValue=ctrl.$modelValue;var allowInvalid=ctrl.$options&&ctrl.$options.allowInvalid;ctrl.$$runValidators(modelValue,viewValue,function(allValid){// If there was no change in validity, don't update the model
	// This prevents changing an invalid modelValue to undefined
	if(!allowInvalid&&prevValid!==allValid){// Note: Don't check ctrl.$valid here, as we could have
	// external validators (e.g. calculated on the server),
	// that just call $setValidity and need the model value
	// to calculate their validity.
	ctrl.$modelValue=allValid?modelValue:undefined;if(ctrl.$modelValue!==prevModelValue){ctrl.$$writeModelToScope();}}});};this.$$runValidators=function(modelValue,viewValue,doneCallback){currentValidationRunId++;var localValidationRunId=currentValidationRunId;// check parser error
	if(!processParseErrors()){validationDone(false);return;}if(!processSyncValidators()){validationDone(false);return;}processAsyncValidators();function processParseErrors(){var errorKey=ctrl.$$parserName||'parse';if(isUndefined(parserValid)){setValidity(errorKey,null);}else{if(!parserValid){forEach(ctrl.$validators,function(v,name){setValidity(name,null);});forEach(ctrl.$asyncValidators,function(v,name){setValidity(name,null);});}// Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	setValidity(errorKey,parserValid);return parserValid;}return true;}function processSyncValidators(){var syncValidatorsValid=true;forEach(ctrl.$validators,function(validator,name){var result=validator(modelValue,viewValue);syncValidatorsValid=syncValidatorsValid&&result;setValidity(name,result);});if(!syncValidatorsValid){forEach(ctrl.$asyncValidators,function(v,name){setValidity(name,null);});return false;}return true;}function processAsyncValidators(){var validatorPromises=[];var allValid=true;forEach(ctrl.$asyncValidators,function(validator,name){var promise=validator(modelValue,viewValue);if(!isPromiseLike(promise)){throw ngModelMinErr('nopromise',"Expected asynchronous validator to return a promise but got '{0}' instead.",promise);}setValidity(name,undefined);validatorPromises.push(promise.then(function(){setValidity(name,true);},function(error){allValid=false;setValidity(name,false);}));});if(!validatorPromises.length){validationDone(true);}else{$q.all(validatorPromises).then(function(){validationDone(allValid);},noop);}}function setValidity(name,isValid){if(localValidationRunId===currentValidationRunId){ctrl.$setValidity(name,isValid);}}function validationDone(allValid){if(localValidationRunId===currentValidationRunId){doneCallback(allValid);}}};/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */this.$commitViewValue=function(){var viewValue=ctrl.$viewValue;$timeout.cancel(pendingDebounce);// If the view value has not changed then we should just exit, except in the case where there is
	// a native validator on the element. In this case the validation state may have changed even though
	// the viewValue has stayed empty.
	if(ctrl.$$lastCommittedViewValue===viewValue&&(viewValue!==''||!ctrl.$$hasNativeValidators)){return;}ctrl.$$lastCommittedViewValue=viewValue;// change to dirty
	if(ctrl.$pristine){this.$setDirty();}this.$$parseAndValidate();};this.$$parseAndValidate=function(){var viewValue=ctrl.$$lastCommittedViewValue;var modelValue=viewValue;parserValid=isUndefined(modelValue)?undefined:true;if(parserValid){for(var i=0;i<ctrl.$parsers.length;i++){modelValue=ctrl.$parsers[i](modelValue);if(isUndefined(modelValue)){parserValid=false;break;}}}if(isNumber(ctrl.$modelValue)&&isNaN(ctrl.$modelValue)){// ctrl.$modelValue has not been touched yet...
	ctrl.$modelValue=ngModelGet($scope);}var prevModelValue=ctrl.$modelValue;var allowInvalid=ctrl.$options&&ctrl.$options.allowInvalid;ctrl.$$rawModelValue=modelValue;if(allowInvalid){ctrl.$modelValue=modelValue;writeToModelIfNeeded();}// Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	// This can happen if e.g. $setViewValue is called from inside a parser
	ctrl.$$runValidators(modelValue,ctrl.$$lastCommittedViewValue,function(allValid){if(!allowInvalid){// Note: Don't check ctrl.$valid here, as we could have
	// external validators (e.g. calculated on the server),
	// that just call $setValidity and need the model value
	// to calculate their validity.
	ctrl.$modelValue=allValid?modelValue:undefined;writeToModelIfNeeded();}});function writeToModelIfNeeded(){if(ctrl.$modelValue!==prevModelValue){ctrl.$$writeModelToScope();}}};this.$$writeModelToScope=function(){ngModelSet($scope,ctrl.$modelValue);forEach(ctrl.$viewChangeListeners,function(listener){try{listener();}catch(e){$exceptionHandler(e);}});};/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value sent directly for processing, finally to be applied to `$modelValue` and then the
	   * **expression** specified in the `ng-model` attribute. Lastly, all the registered change listeners,
	   * in the `$viewChangeListeners` list, are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realise that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */this.$setViewValue=function(value,trigger){ctrl.$viewValue=value;if(!ctrl.$options||ctrl.$options.updateOnDefault){ctrl.$$debounceViewValueCommit(trigger);}};this.$$debounceViewValueCommit=function(trigger){var debounceDelay=0,options=ctrl.$options,debounce;if(options&&isDefined(options.debounce)){debounce=options.debounce;if(isNumber(debounce)){debounceDelay=debounce;}else if(isNumber(debounce[trigger])){debounceDelay=debounce[trigger];}else if(isNumber(debounce['default'])){debounceDelay=debounce['default'];}}$timeout.cancel(pendingDebounce);if(debounceDelay){pendingDebounce=$timeout(function(){ctrl.$commitViewValue();},debounceDelay);}else if($rootScope.$$phase){ctrl.$commitViewValue();}else{$scope.$apply(function(){ctrl.$commitViewValue();});}};// model -> value
	// Note: we cannot use a normal scope.$watch as we want to detect the following:
	// 1. scope value is 'a'
	// 2. user enters 'b'
	// 3. ng-change kicks in and reverts scope value to 'a'
	//    -> scope value did not change since the last digest as
	//       ng-change executes in apply phase
	// 4. view should be changed back to 'a'
	$scope.$watch(function ngModelWatch(){var modelValue=ngModelGet($scope);// if scope model value and ngModel value are out of sync
	// TODO(perf): why not move this to the action fn?
	if(modelValue!==ctrl.$modelValue&&(// checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	ctrl.$modelValue===ctrl.$modelValue||modelValue===modelValue)){ctrl.$modelValue=ctrl.$$rawModelValue=modelValue;parserValid=undefined;var formatters=ctrl.$formatters,idx=formatters.length;var viewValue=modelValue;while(idx--){viewValue=formatters[idx](viewValue);}if(ctrl.$viewValue!==viewValue){ctrl.$viewValue=ctrl.$$lastCommittedViewValue=viewValue;ctrl.$render();ctrl.$$runValidators(modelValue,viewValue,noop);}}return modelValue;});}];/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`, `ng-untouched`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes are: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */var ngModelDirective=['$rootScope',function($rootScope){return{restrict:'A',require:['ngModel','^?form','^?ngModelOptions'],controller:NgModelController,// Prelink needs to run before any input directive
	// so that we can set the NgModelOptions in NgModelController
	// before anyone else uses it.
	priority:1,compile:function ngModelCompile(element){// Setup initial state of the control
	element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);return{pre:function ngModelPreLink(scope,element,attr,ctrls){var modelCtrl=ctrls[0],formCtrl=ctrls[1]||modelCtrl.$$parentForm;modelCtrl.$$setOptions(ctrls[2]&&ctrls[2].$options);// notify others, especially parent forms
	formCtrl.$addControl(modelCtrl);attr.$observe('name',function(newValue){if(modelCtrl.$name!==newValue){modelCtrl.$$parentForm.$$renameControl(modelCtrl,newValue);}});scope.$on('$destroy',function(){modelCtrl.$$parentForm.$removeControl(modelCtrl);});},post:function ngModelPostLink(scope,element,attr,ctrls){var modelCtrl=ctrls[0];if(modelCtrl.$options&&modelCtrl.$options.updateOn){element.on(modelCtrl.$options.updateOn,function(ev){modelCtrl.$$debounceViewValueCommit(ev&&ev.type);});}element.on('blur',function(ev){if(modelCtrl.$touched)return;if($rootScope.$$phase){scope.$evalAsync(modelCtrl.$setTouched);}else{scope.$apply(modelCtrl.$setTouched);}});}};}};}];var DEFAULT_REGEXP=/(\s+|^)default(\s+|$)/;/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
	 * events that will trigger a model update and/or a debouncing delay so that the actual update only
	 * takes place when a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * `ngModelOptions` has an effect on the element it's declared on and its descendants.
	 *
	 * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging of the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     `ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }"`
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	       `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date">`, `<input type="time">`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 * @example
	
	  The following example shows how to override immediate updates. Changes on the inputs within the
	  form will update the model only when the control loses focus (blur event). If `escape` key is
	  pressed while the input field is focused, the value is reset to the value in the current model.
	
	  <example name="ngModelOptions-directive-blur" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ updateOn: 'blur' }"
	                   ng-keyup="cancel($event)" />
	          </label><br />
	          <label>Other data:
	            <input type="text" ng-model="user.data" />
	          </label><br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	        <pre>user.data = <span ng-bind="user.data"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'John', data: '' };
	
	          $scope.cancel = function(e) {
	            if (e.keyCode == 27) {
	              $scope.userForm.userName.$rollbackViewValue();
	            }
	          };
	        }]);
	    </file>
	    <file name="protractor.js" type="protractor">
	      var model = element(by.binding('user.name'));
	      var input = element(by.model('user.name'));
	      var other = element(by.model('user.data'));
	
	      it('should allow custom events', function() {
	        input.sendKeys(' Doe');
	        input.click();
	        expect(model.getText()).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John Doe');
	      });
	
	      it('should $rollbackViewValue when model changes', function() {
	        input.sendKeys(' Doe');
	        expect(input.getAttribute('value')).toEqual('John Doe');
	        input.sendKeys(protractor.Key.ESCAPE);
	        expect(input.getAttribute('value')).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John');
	      });
	    </file>
	  </example>
	
	  This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
	  If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	
	  <example name="ngModelOptions-directive-debounce" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ debounce: 1000 }" />
	          </label>
	          <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button>
	          <br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'Igor' };
	        }]);
	    </file>
	  </example>
	
	  This one shows how to bind to getter/setters:
	
	  <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ getterSetter: true }" />
	          </label>
	        </form>
	        <pre>user.name = <span ng-bind="user.name()"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('getterSetterExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          var _name = 'Brian';
	          $scope.user = {
	            name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	            }
	          };
	        }]);
	    </file>
	  </example>
	 */var ngModelOptionsDirective=function ngModelOptionsDirective(){return{restrict:'A',controller:['$scope','$attrs',function($scope,$attrs){var that=this;this.$options=copy($scope.$eval($attrs.ngModelOptions));// Allow adding/overriding bound events
	if(isDefined(this.$options.updateOn)){this.$options.updateOnDefault=false;// extract "default" pseudo-event from list of events that can trigger a model update
	this.$options.updateOn=trim(this.$options.updateOn.replace(DEFAULT_REGEXP,function(){that.$options.updateOnDefault=true;return' ';}));}else{this.$options.updateOnDefault=true;}}]};};// helper methods
	function addSetValidityMethod(context){var ctrl=context.ctrl,$element=context.$element,classCache={},set=context.set,unset=context.unset,$animate=context.$animate;classCache[INVALID_CLASS]=!(classCache[VALID_CLASS]=$element.hasClass(VALID_CLASS));ctrl.$setValidity=setValidity;function setValidity(validationErrorKey,state,controller){if(isUndefined(state)){createAndSet('$pending',validationErrorKey,controller);}else{unsetAndCleanup('$pending',validationErrorKey,controller);}if(!isBoolean(state)){unset(ctrl.$error,validationErrorKey,controller);unset(ctrl.$$success,validationErrorKey,controller);}else{if(state){unset(ctrl.$error,validationErrorKey,controller);set(ctrl.$$success,validationErrorKey,controller);}else{set(ctrl.$error,validationErrorKey,controller);unset(ctrl.$$success,validationErrorKey,controller);}}if(ctrl.$pending){cachedToggleClass(PENDING_CLASS,true);ctrl.$valid=ctrl.$invalid=undefined;toggleValidationCss('',null);}else{cachedToggleClass(PENDING_CLASS,false);ctrl.$valid=isObjectEmpty(ctrl.$error);ctrl.$invalid=!ctrl.$valid;toggleValidationCss('',ctrl.$valid);}// re-read the state as the set/unset methods could have
	// combined state in ctrl.$error[validationError] (used for forms),
	// where setting/unsetting only increments/decrements the value,
	// and does not replace it.
	var combinedState;if(ctrl.$pending&&ctrl.$pending[validationErrorKey]){combinedState=undefined;}else if(ctrl.$error[validationErrorKey]){combinedState=false;}else if(ctrl.$$success[validationErrorKey]){combinedState=true;}else{combinedState=null;}toggleValidationCss(validationErrorKey,combinedState);ctrl.$$parentForm.$setValidity(validationErrorKey,combinedState,ctrl);}function createAndSet(name,value,controller){if(!ctrl[name]){ctrl[name]={};}set(ctrl[name],value,controller);}function unsetAndCleanup(name,value,controller){if(ctrl[name]){unset(ctrl[name],value,controller);}if(isObjectEmpty(ctrl[name])){ctrl[name]=undefined;}}function cachedToggleClass(className,switchValue){if(switchValue&&!classCache[className]){$animate.addClass($element,className);classCache[className]=true;}else if(!switchValue&&classCache[className]){$animate.removeClass($element,className);classCache[className]=false;}}function toggleValidationCss(validationErrorKey,isValid){validationErrorKey=validationErrorKey?'-'+snake_case(validationErrorKey,'-'):'';cachedToggleClass(VALID_CLASS+validationErrorKey,isValid===true);cachedToggleClass(INVALID_CLASS+validationErrorKey,isValid===false);}}function isObjectEmpty(obj){if(obj){for(var prop in obj){if(obj.hasOwnProperty(prop)){return false;}}}return true;}/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */var ngNonBindableDirective=ngDirective({terminal:true,priority:1000});/* global jqLiteRemove */var ngOptionsMinErr=minErr('ngOptions');/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of `ngOptions` to achieve a
	 * similar result. However, `ngOptions` provides some benefits such as reducing memory and
	 * increasing speed by not creating a new scope for each repeated instance, as well as providing
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression. `ngOptions` should be used when the `<select>` model needs to be bound
	 *  to a non-string value. This is because an option element can only be bound to string values at
	 * present.
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {comprehension_expression=} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 *
	 * @example
	    <example module="selectExample">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */// jshint maxlen: false
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555550000000006666666666666660000000777777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;// 1: value expression (valueFn)
	// 2: label expression (displayFn)
	// 3: group by expression (groupByFn)
	// 4: disable when expression (disableWhenFn)
	// 5: array item variable name
	// 6: object item key variable name
	// 7: object item value variable name
	// 8: collection expression
	// 9: track by expression
	// jshint maxlen: 100
	var ngOptionsDirective=['$compile','$parse',function($compile,$parse){function parseOptionsExpression(optionsExp,selectElement,scope){var match=optionsExp.match(NG_OPTIONS_REGEXP);if(!match){throw ngOptionsMinErr('iexp',"Expected expression in form of "+"'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'"+" but got '{0}'. Element: {1}",optionsExp,startingTag(selectElement));}// Extract the parts from the ngOptions expression
	// The variable name for the value of the item in the collection
	var valueName=match[5]||match[7];// The variable name for the key of the item in the collection
	var keyName=match[6];// An expression that generates the viewValue for an option if there is a label expression
	var selectAs=/ as /.test(match[0])&&match[1];// An expression that is used to track the id of each object in the options collection
	var trackBy=match[9];// An expression that generates the viewValue for an option if there is no label expression
	var valueFn=$parse(match[2]?match[1]:valueName);var selectAsFn=selectAs&&$parse(selectAs);var viewValueFn=selectAsFn||valueFn;var trackByFn=trackBy&&$parse(trackBy);// Get the value by which we are going to track the option
	// if we have a trackFn then use that (passing scope and locals)
	// otherwise just hash the given viewValue
	var getTrackByValueFn=trackBy?function(value,locals){return trackByFn(scope,locals);}:function getHashOfValue(value){return hashKey(value);};var getTrackByValue=function getTrackByValue(value,key){return getTrackByValueFn(value,getLocals(value,key));};var displayFn=$parse(match[2]||match[1]);var groupByFn=$parse(match[3]||'');var disableWhenFn=$parse(match[4]||'');var valuesFn=$parse(match[8]);var locals={};var getLocals=keyName?function(value,key){locals[keyName]=key;locals[valueName]=value;return locals;}:function(value){locals[valueName]=value;return locals;};function Option(selectValue,viewValue,label,group,disabled){this.selectValue=selectValue;this.viewValue=viewValue;this.label=label;this.group=group;this.disabled=disabled;}function getOptionValuesKeys(optionValues){var optionValuesKeys;if(!keyName&&isArrayLike(optionValues)){optionValuesKeys=optionValues;}else{// if object, extract keys, in enumeration order, unsorted
	optionValuesKeys=[];for(var itemKey in optionValues){if(optionValues.hasOwnProperty(itemKey)&&itemKey.charAt(0)!=='$'){optionValuesKeys.push(itemKey);}}}return optionValuesKeys;}return{trackBy:trackBy,getTrackByValue:getTrackByValue,getWatchables:$parse(valuesFn,function(optionValues){// Create a collection of things that we would like to watch (watchedArray)
	// so that they can all be watched using a single $watchCollection
	// that only runs the handler once if anything changes
	var watchedArray=[];optionValues=optionValues||[];var optionValuesKeys=getOptionValuesKeys(optionValues);var optionValuesLength=optionValuesKeys.length;for(var index=0;index<optionValuesLength;index++){var key=optionValues===optionValuesKeys?index:optionValuesKeys[index];var value=optionValues[key];var locals=getLocals(optionValues[key],key);var selectValue=getTrackByValueFn(optionValues[key],locals);watchedArray.push(selectValue);// Only need to watch the displayFn if there is a specific label expression
	if(match[2]||match[1]){var label=displayFn(scope,locals);watchedArray.push(label);}// Only need to watch the disableWhenFn if there is a specific disable expression
	if(match[4]){var disableWhen=disableWhenFn(scope,locals);watchedArray.push(disableWhen);}}return watchedArray;}),getOptions:function getOptions(){var optionItems=[];var selectValueMap={};// The option values were already computed in the `getWatchables` fn,
	// which must have been called to trigger `getOptions`
	var optionValues=valuesFn(scope)||[];var optionValuesKeys=getOptionValuesKeys(optionValues);var optionValuesLength=optionValuesKeys.length;for(var index=0;index<optionValuesLength;index++){var key=optionValues===optionValuesKeys?index:optionValuesKeys[index];var value=optionValues[key];var locals=getLocals(value,key);var viewValue=viewValueFn(scope,locals);var selectValue=getTrackByValueFn(viewValue,locals);var label=displayFn(scope,locals);var group=groupByFn(scope,locals);var disabled=disableWhenFn(scope,locals);var optionItem=new Option(selectValue,viewValue,label,group,disabled);optionItems.push(optionItem);selectValueMap[selectValue]=optionItem;}return{items:optionItems,selectValueMap:selectValueMap,getOptionFromViewValue:function getOptionFromViewValue(value){return selectValueMap[getTrackByValue(value)];},getViewValueFromOption:function getViewValueFromOption(option){// If the viewValue could be an object that may be mutated by the application,
	// we need to make a copy and not return the reference to the value on the option.
	return trackBy?angular.copy(option.viewValue):option.viewValue;}};}};}// we can't just jqLite('<option>') since jqLite is not smart enough
	// to create it in <select> and IE barfs otherwise.
	var optionTemplate=document.createElement('option'),optGroupTemplate=document.createElement('optgroup');function ngOptionsPostLink(scope,selectElement,attr,ctrls){// if ngModel is not defined, we don't need to do anything
	var ngModelCtrl=ctrls[1];if(!ngModelCtrl)return;var selectCtrl=ctrls[0];var multiple=attr.multiple;// The emptyOption allows the application developer to provide their own custom "empty"
	// option when the viewValue does not match any of the option values.
	var emptyOption;for(var i=0,children=selectElement.children(),ii=children.length;i<ii;i++){if(children[i].value===''){emptyOption=children.eq(i);break;}}var providedEmptyOption=!!emptyOption;var unknownOption=jqLite(optionTemplate.cloneNode(false));unknownOption.val('?');var options;var ngOptions=parseOptionsExpression(attr.ngOptions,selectElement,scope);var renderEmptyOption=function renderEmptyOption(){if(!providedEmptyOption){selectElement.prepend(emptyOption);}selectElement.val('');emptyOption.prop('selected',true);// needed for IE
	emptyOption.attr('selected',true);};var removeEmptyOption=function removeEmptyOption(){if(!providedEmptyOption){emptyOption.remove();}};var renderUnknownOption=function renderUnknownOption(){selectElement.prepend(unknownOption);selectElement.val('?');unknownOption.prop('selected',true);// needed for IE
	unknownOption.attr('selected',true);};var removeUnknownOption=function removeUnknownOption(){unknownOption.remove();};// Update the controller methods for multiple selectable options
	if(!multiple){selectCtrl.writeValue=function writeNgOptionsValue(value){var option=options.getOptionFromViewValue(value);if(option&&!option.disabled){// Don't update the option when it is already selected.
	// For example, the browser will select the first option by default. In that case,
	// most properties are set automatically - except the `selected` attribute, which we
	// set always
	if(selectElement[0].value!==option.selectValue){removeUnknownOption();removeEmptyOption();selectElement[0].value=option.selectValue;option.element.selected=true;}option.element.setAttribute('selected','selected');}else{if(value===null||providedEmptyOption){removeUnknownOption();renderEmptyOption();}else{removeEmptyOption();renderUnknownOption();}}};selectCtrl.readValue=function readNgOptionsValue(){var selectedOption=options.selectValueMap[selectElement.val()];if(selectedOption&&!selectedOption.disabled){removeEmptyOption();removeUnknownOption();return options.getViewValueFromOption(selectedOption);}return null;};// If we are using `track by` then we must watch the tracked value on the model
	// since ngModel only watches for object identity change
	if(ngOptions.trackBy){scope.$watch(function(){return ngOptions.getTrackByValue(ngModelCtrl.$viewValue);},function(){ngModelCtrl.$render();});}}else{ngModelCtrl.$isEmpty=function(value){return!value||value.length===0;};selectCtrl.writeValue=function writeNgOptionsMultiple(value){options.items.forEach(function(option){option.element.selected=false;});if(value){value.forEach(function(item){var option=options.getOptionFromViewValue(item);if(option&&!option.disabled)option.element.selected=true;});}};selectCtrl.readValue=function readNgOptionsMultiple(){var selectedValues=selectElement.val()||[],selections=[];forEach(selectedValues,function(value){var option=options.selectValueMap[value];if(option&&!option.disabled)selections.push(options.getViewValueFromOption(option));});return selections;};// If we are using `track by` then we must watch these tracked values on the model
	// since ngModel only watches for object identity change
	if(ngOptions.trackBy){scope.$watchCollection(function(){if(isArray(ngModelCtrl.$viewValue)){return ngModelCtrl.$viewValue.map(function(value){return ngOptions.getTrackByValue(value);});}},function(){ngModelCtrl.$render();});}}if(providedEmptyOption){// we need to remove it before calling selectElement.empty() because otherwise IE will
	// remove the label from the element. wtf?
	emptyOption.remove();// compile the element since there might be bindings in it
	$compile(emptyOption)(scope);// remove the class, which is added automatically because we recompile the element and it
	// becomes the compilation root
	emptyOption.removeClass('ng-scope');}else{emptyOption=jqLite(optionTemplate.cloneNode(false));}// We need to do this here to ensure that the options object is defined
	// when we first hit it in writeNgOptionsValue
	updateOptions();// We will re-render the option elements if the option values or labels change
	scope.$watchCollection(ngOptions.getWatchables,updateOptions);// ------------------------------------------------------------------ //
	function updateOptionElement(option,element){option.element=element;element.disabled=option.disabled;// NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
	// selects in certain circumstances when multiple selects are next to each other and display
	// the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	// See https://github.com/angular/angular.js/issues/11314 for more info.
	// This is unfortunately untestable with unit / e2e tests
	if(option.label!==element.label){element.label=option.label;element.textContent=option.label;}if(option.value!==element.value)element.value=option.selectValue;}function addOrReuseElement(parent,current,type,templateElement){var element;// Check whether we can reuse the next element
	if(current&&lowercase(current.nodeName)===type){// The next element is the right type so reuse it
	element=current;}else{// The next element is not the right type so create a new one
	element=templateElement.cloneNode(false);if(!current){// There are no more elements so just append it to the select
	parent.appendChild(element);}else{// The next element is not a group so insert the new one
	parent.insertBefore(element,current);}}return element;}function removeExcessElements(current){var next;while(current){next=current.nextSibling;jqLiteRemove(current);current=next;}}function skipEmptyAndUnknownOptions(current){var emptyOption_=emptyOption&&emptyOption[0];var unknownOption_=unknownOption&&unknownOption[0];// We cannot rely on the extracted empty option being the same as the compiled empty option,
	// because the compiled empty option might have been replaced by a comment because
	// it had an "element" transclusion directive on it (such as ngIf)
	if(emptyOption_||unknownOption_){while(current&&(current===emptyOption_||current===unknownOption_||current.nodeType===NODE_TYPE_COMMENT||nodeName_(current)==='option'&&current.value==='')){current=current.nextSibling;}}return current;}function updateOptions(){var previousValue=options&&selectCtrl.readValue();options=ngOptions.getOptions();var groupMap={};var currentElement=selectElement[0].firstChild;// Ensure that the empty option is always there if it was explicitly provided
	if(providedEmptyOption){selectElement.prepend(emptyOption);}currentElement=skipEmptyAndUnknownOptions(currentElement);options.items.forEach(function updateOption(option){var group;var groupElement;var optionElement;if(option.group){// This option is to live in a group
	// See if we have already created this group
	group=groupMap[option.group];if(!group){// We have not already created this group
	groupElement=addOrReuseElement(selectElement[0],currentElement,'optgroup',optGroupTemplate);// Move to the next element
	currentElement=groupElement.nextSibling;// Update the label on the group element
	groupElement.label=option.group;// Store it for use later
	group=groupMap[option.group]={groupElement:groupElement,currentOptionElement:groupElement.firstChild};}// So now we have a group for this option we add the option to the group
	optionElement=addOrReuseElement(group.groupElement,group.currentOptionElement,'option',optionTemplate);updateOptionElement(option,optionElement);// Move to the next element
	group.currentOptionElement=optionElement.nextSibling;}else{// This option is not in a group
	optionElement=addOrReuseElement(selectElement[0],currentElement,'option',optionTemplate);updateOptionElement(option,optionElement);// Move to the next element
	currentElement=optionElement.nextSibling;}});// Now remove all excess options and group
	Object.keys(groupMap).forEach(function(key){removeExcessElements(groupMap[key].currentOptionElement);});removeExcessElements(currentElement);ngModelCtrl.$render();// Check to see if the value has changed due to the update to the options
	if(!ngModelCtrl.$isEmpty(previousValue)){var nextValue=selectCtrl.readValue();var isNotPrimitive=ngOptions.trackBy||multiple;if(isNotPrimitive?!equals(previousValue,nextValue):previousValue!==nextValue){ngModelCtrl.$setViewValue(nextValue);ngModelCtrl.$render();}}}}return{restrict:'A',terminal:true,require:['select','?ngModel'],link:{pre:function ngOptionsPreLink(scope,selectElement,attr,ctrls){// Deactivate the SelectController.register method to prevent
	// option directives from accidentally registering themselves
	// (and unwanted $destroy handlers etc.)
	ctrls[0].registerOption=noop;},post:ngOptionsPostLink}};}];/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */var ngPluralizeDirective=['$locale','$interpolate','$log',function($locale,$interpolate,$log){var BRACE=/{}/g,IS_WHEN=/^when(Minus)?(.+)$/;return{link:function link(scope,element,attr){var numberExp=attr.count,whenExp=attr.$attr.when&&element.attr(attr.$attr.when),// we have {{}} in attrs
	offset=attr.offset||0,whens=scope.$eval(whenExp)||{},whensExpFns={},startSymbol=$interpolate.startSymbol(),endSymbol=$interpolate.endSymbol(),braceReplacement=startSymbol+numberExp+'-'+offset+endSymbol,watchRemover=angular.noop,lastCount;forEach(attr,function(expression,attributeName){var tmpMatch=IS_WHEN.exec(attributeName);if(tmpMatch){var whenKey=(tmpMatch[1]?'-':'')+lowercase(tmpMatch[2]);whens[whenKey]=element.attr(attr.$attr[attributeName]);}});forEach(whens,function(expression,key){whensExpFns[key]=$interpolate(expression.replace(BRACE,braceReplacement));});scope.$watch(numberExp,function ngPluralizeWatchAction(newVal){var count=parseFloat(newVal);var countIsNaN=isNaN(count);if(!countIsNaN&&!(count in whens)){// If an explicit number rule such as 1, 2, 3... is defined, just use it.
	// Otherwise, check it against pluralization rules in $locale service.
	count=$locale.pluralCat(count-offset);}// If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	// In JS `NaN !== NaN`, so we have to exlicitly check.
	if(count!==lastCount&&!(countIsNaN&&isNumber(lastCount)&&isNaN(lastCount))){watchRemover();var whenExpFn=whensExpFns[count];if(isUndefined(whenExpFn)){if(newVal!=null){$log.debug("ngPluralize: no rule defined for '"+count+"' in "+whenExp);}watchRemover=noop;updateElementText();}else{watchRemover=scope.$watch(whenExpFn,updateElementText);}lastCount=count;}});function updateElementText(newText){element.text(newText||'');}}};}];/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * You need to be aware that the JavaScript specification does not define the order of keys
	 * returned for an object. (To mitigate this in Angular 1.3 the `ngRepeat` directive
	 * used to sort the keys alphabetically.)
	 *
	 * Version 1.4 removed the alphabetic sorting. We now rely on the order returned by the browser
	 * when running `for key in myObj`. It seems that browsers generally follow the strategy of providing
	 * keys in the order in which they were defined, although there are exceptions when keys are deleted
	 * and reinstated. See the [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * If this is not desired, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`.  You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, ngRepeat then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, ngRepeat will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * The default tracking function (which tracks items by their identity) does not allow
	 * duplicate items in arrays. This is because when there are duplicates, it is not possible
	 * to maintain a one-to-one mapping between collection items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may also use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-success">
	 * If you are working with objects that have an identifier property, you should track
	 * by the identifier instead of the whole object. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones. For large collections,
	 * this signifincantly improves rendering performance. If you don't have a unique identifier,
	 * `track by $index` can also provide a performance boost.
	 * </div>
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** `track by` must always be the last expression:
	 * </div>
	 * ```
	 * <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	 *     {{model.name}}
	 * </div>
	 * ```
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * **.enter** - when a new item is added to the list or when an item is revealed after a filter
	 *
	 * **.leave** - when an item is removed from the list or when an item is filtered out
	 *
	 * **.move** - when an adjacent item is filtered out causing a reorder or when the item contents are reordered
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     Note that the tracking expression must come last, after any filters, and the alias expression.
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	 *     (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	 *
	 * @example
	 * This example initializes the scope to a list of names and
	 * then uses `ngRepeat` to display every person:
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-init="friends = [
	        {name:'John', age:25, gender:'boy'},
	        {name:'Jessie', age:30, gender:'girl'},
	        {name:'Johanna', age:28, gender:'girl'},
	        {name:'Joy', age:15, gender:'girl'},
	        {name:'Mary', age:28, gender:'girl'},
	        {name:'Peter', age:95, gender:'boy'},
	        {name:'Sebastian', age:50, gender:'boy'},
	        {name:'Erika', age:27, gender:'girl'},
	        {name:'Patrick', age:40, gender:'boy'},
	        {name:'Samantha', age:60, gender:'girl'}
	      ]">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length == 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:40px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:40px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */var ngRepeatDirective=['$parse','$animate',function($parse,$animate){var NG_REMOVED='$$NG_REMOVED';var ngRepeatMinErr=minErr('ngRepeat');var updateScope=function updateScope(scope,index,valueIdentifier,value,keyIdentifier,key,arrayLength){// TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	scope[valueIdentifier]=value;if(keyIdentifier)scope[keyIdentifier]=key;scope.$index=index;scope.$first=index===0;scope.$last=index===arrayLength-1;scope.$middle=!(scope.$first||scope.$last);// jshint bitwise: false
	scope.$odd=!(scope.$even=(index&1)===0);// jshint bitwise: true
	};var getBlockStart=function getBlockStart(block){return block.clone[0];};var getBlockEnd=function getBlockEnd(block){return block.clone[block.clone.length-1];};return{restrict:'A',multiElement:true,transclude:'element',priority:1000,terminal:true,$$tlb:true,compile:function ngRepeatCompile($element,$attr){var expression=$attr.ngRepeat;var ngRepeatEndComment=document.createComment(' end ngRepeat: '+expression+' ');var match=expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);if(!match){throw ngRepeatMinErr('iexp',"Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",expression);}var lhs=match[1];var rhs=match[2];var aliasAs=match[3];var trackByExp=match[4];match=lhs.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);if(!match){throw ngRepeatMinErr('iidexp',"'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",lhs);}var valueIdentifier=match[3]||match[1];var keyIdentifier=match[2];if(aliasAs&&(!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs)||/^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))){throw ngRepeatMinErr('badident',"alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",aliasAs);}var trackByExpGetter,trackByIdExpFn,trackByIdArrayFn,trackByIdObjFn;var hashFnLocals={$id:hashKey};if(trackByExp){trackByExpGetter=$parse(trackByExp);}else{trackByIdArrayFn=function trackByIdArrayFn(key,value){return hashKey(value);};trackByIdObjFn=function trackByIdObjFn(key){return key;};}return function ngRepeatLink($scope,$element,$attr,ctrl,$transclude){if(trackByExpGetter){trackByIdExpFn=function trackByIdExpFn(key,value,index){// assign key, value, and $index to the locals so that they can be used in hash functions
	if(keyIdentifier)hashFnLocals[keyIdentifier]=key;hashFnLocals[valueIdentifier]=value;hashFnLocals.$index=index;return trackByExpGetter($scope,hashFnLocals);};}// Store a list of elements from previous run. This is a hash where key is the item from the
	// iterator, and the value is objects with following properties.
	//   - scope: bound scope
	//   - element: previous element.
	//   - index: position
	//
	// We are using no-proto object so that we don't need to guard against inherited props via
	// hasOwnProperty.
	var lastBlockMap=createMap();//watch props
	$scope.$watchCollection(rhs,function ngRepeatAction(collection){var index,length,previousNode=$element[0],// node that cloned nodes should be inserted after
	// initialized to the comment node anchor
	nextNode,// Same as lastBlockMap but it has the current state. It will become the
	// lastBlockMap on the next iteration.
	nextBlockMap=createMap(),collectionLength,key,value,// key/value of iteration
	trackById,trackByIdFn,collectionKeys,block,// last object information {scope, element, id}
	nextBlockOrder,elementsToRemove;if(aliasAs){$scope[aliasAs]=collection;}if(isArrayLike(collection)){collectionKeys=collection;trackByIdFn=trackByIdExpFn||trackByIdArrayFn;}else{trackByIdFn=trackByIdExpFn||trackByIdObjFn;// if object, extract keys, in enumeration order, unsorted
	collectionKeys=[];for(var itemKey in collection){if(hasOwnProperty.call(collection,itemKey)&&itemKey.charAt(0)!=='$'){collectionKeys.push(itemKey);}}}collectionLength=collectionKeys.length;nextBlockOrder=new Array(collectionLength);// locate existing items
	for(index=0;index<collectionLength;index++){key=collection===collectionKeys?index:collectionKeys[index];value=collection[key];trackById=trackByIdFn(key,value,index);if(lastBlockMap[trackById]){// found previously seen block
	block=lastBlockMap[trackById];delete lastBlockMap[trackById];nextBlockMap[trackById]=block;nextBlockOrder[index]=block;}else if(nextBlockMap[trackById]){// if collision detected. restore lastBlockMap and throw an error
	forEach(nextBlockOrder,function(block){if(block&&block.scope)lastBlockMap[block.id]=block;});throw ngRepeatMinErr('dupes',"Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",expression,trackById,value);}else{// new never before seen block
	nextBlockOrder[index]={id:trackById,scope:undefined,clone:undefined};nextBlockMap[trackById]=true;}}// remove leftover items
	for(var blockKey in lastBlockMap){block=lastBlockMap[blockKey];elementsToRemove=getBlockNodes(block.clone);$animate.leave(elementsToRemove);if(elementsToRemove[0].parentNode){// if the element was not removed yet because of pending animation, mark it as deleted
	// so that we can ignore it later
	for(index=0,length=elementsToRemove.length;index<length;index++){elementsToRemove[index][NG_REMOVED]=true;}}block.scope.$destroy();}// we are not using forEach for perf reasons (trying to avoid #call)
	for(index=0;index<collectionLength;index++){key=collection===collectionKeys?index:collectionKeys[index];value=collection[key];block=nextBlockOrder[index];if(block.scope){// if we have already seen this object, then we need to reuse the
	// associated scope/element
	nextNode=previousNode;// skip nodes that are already pending removal via leave animation
	do{nextNode=nextNode.nextSibling;}while(nextNode&&nextNode[NG_REMOVED]);if(getBlockStart(block)!=nextNode){// existing item which got moved
	$animate.move(getBlockNodes(block.clone),null,previousNode);}previousNode=getBlockEnd(block);updateScope(block.scope,index,valueIdentifier,value,keyIdentifier,key,collectionLength);}else{// new item which we don't know about
	$transclude(function ngRepeatTransclude(clone,scope){block.scope=scope;// http://jsperf.com/clone-vs-createcomment
	var endNode=ngRepeatEndComment.cloneNode(false);clone[clone.length++]=endNode;$animate.enter(clone,null,previousNode);previousNode=endNode;// Note: We only need the first/last node of the cloned nodes.
	// However, we need to keep the reference to the jqlite wrapper as it might be changed later
	// by a directive with templateUrl when its template arrives.
	block.clone=clone;nextBlockMap[block.id]=block;updateScope(block.scope,index,valueIdentifier,value,keyIdentifier,key,collectionLength);});}}lastBlockMap=nextBlockMap;});};}};}];var NG_HIDE_CLASS='ng-hide';var NG_HIDE_IN_PROGRESS_CLASS='ng-hide-animate';/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
	 * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class CSS. Note that the selector that needs to be used is actually `.ng-hide:not(.ng-hide-animate)` to cope
	 * with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass except that
	 * you must also include the !important flag to override the display property
	 * so that you can perform an animation when the element is hidden during the time of the animation.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   /&#42; this is required as of 1.3x to properly
	 *      apply all styling in a show/hide animation &#42;/
	 *   transition: 0s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add-active,
	 * .my-element.ng-hide-remove-active {
	 *   /&#42; the transition is defined in the active class &#42;/
	 *   transition: 1s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3.0-beta.11, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * addClass: `.ng-hide` - happens after the `ngShow` expression evaluates to a truthy value and the just before contents are set to visible
	 * removeClass: `.ng-hide` - happens after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy
	 *     then the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-show" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-show" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-show {
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-show.ng-hide-add, .animate-show.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .animate-show.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */var ngShowDirective=['$animate',function($animate){return{restrict:'A',multiElement:true,link:function link(scope,element,attr){scope.$watch(attr.ngShow,function ngShowWatchAction(value){// we're adding a temporary, animation-specific class for ng-hide since this way
	// we can control when the element is actually displayed on screen without having
	// to have a global/greedy CSS selector that breaks when other animations are run.
	// Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	$animate[value?'removeClass':'addClass'](element,NG_HIDE_CLASS,{tempClasses:NG_HIDE_IN_PROGRESS_CLASS});});}};}];/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
	 * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class in CSS:
	 *
	 * ```css
	 * .ng-hide {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
	 * CSS class is added and removed for you instead of your own CSS class.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: 0.5s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3.0-beta.11, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * removeClass: `.ng-hide` - happens after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden
	 * addClass: `.ng-hide` - happens after the `ngHide` expression evaluates to a non truthy value and just before the contents are set to visible
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
	 *     the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-hide" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-hide" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-hide {
	        transition: all linear 0.5s;
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-hide.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */var ngHideDirective=['$animate',function($animate){return{restrict:'A',multiElement:true,link:function link(scope,element,attr){scope.$watch(attr.ngHide,function ngHideWatchAction(value){// The comment inside of the ngShowDirective explains why we add and
	// remove a temporary class for the show/hide animation
	$animate[value?'addClass':'removeClass'](element,NG_HIDE_CLASS,{tempClasses:NG_HIDE_IN_PROGRESS_CLASS});});}};}];/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */var ngStyleDirective=ngDirective(function(scope,element,attr){scope.$watch(attr.ngStyle,function ngStyleWatchAction(newStyles,oldStyles){if(oldStyles&&newStyles!==oldStyles){forEach(oldStyles,function(val,style){element.css(style,'');});}if(newStyles)element.css(newStyles);},true);});/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * enter - happens after the ngSwitch contents change and the matched child element is placed inside the container
	 * leave - happens just after the ngSwitch contents change and just before the former contents are removed from the DOM
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */var ngSwitchDirective=['$animate',function($animate){return{require:'ngSwitch',// asks for $scope to fool the BC controller module
	controller:['$scope',function ngSwitchController(){this.cases={};}],link:function link(scope,element,attr,ngSwitchController){var watchExpr=attr.ngSwitch||attr.on,selectedTranscludes=[],selectedElements=[],previousLeaveAnimations=[],selectedScopes=[];var spliceFactory=function spliceFactory(array,index){return function(){array.splice(index,1);};};scope.$watch(watchExpr,function ngSwitchWatchAction(value){var i,ii;for(i=0,ii=previousLeaveAnimations.length;i<ii;++i){$animate.cancel(previousLeaveAnimations[i]);}previousLeaveAnimations.length=0;for(i=0,ii=selectedScopes.length;i<ii;++i){var selected=getBlockNodes(selectedElements[i].clone);selectedScopes[i].$destroy();var promise=previousLeaveAnimations[i]=$animate.leave(selected);promise.then(spliceFactory(previousLeaveAnimations,i));}selectedElements.length=0;selectedScopes.length=0;if(selectedTranscludes=ngSwitchController.cases['!'+value]||ngSwitchController.cases['?']){forEach(selectedTranscludes,function(selectedTransclude){selectedTransclude.transclude(function(caseElement,selectedScope){selectedScopes.push(selectedScope);var anchor=selectedTransclude.element;caseElement[caseElement.length++]=document.createComment(' end ngSwitchWhen: ');var block={clone:caseElement};selectedElements.push(block);$animate.enter(caseElement,anchor.parent(),anchor);});});}});}};}];var ngSwitchWhenDirective=ngDirective({transclude:'element',priority:1200,require:'^ngSwitch',multiElement:true,link:function link(scope,element,attrs,ctrl,$transclude){ctrl.cases['!'+attrs.ngSwitchWhen]=ctrl.cases['!'+attrs.ngSwitchWhen]||[];ctrl.cases['!'+attrs.ngSwitchWhen].push({transclude:$transclude,element:element});}});var ngSwitchDefaultDirective=ngDirective({transclude:'element',priority:1200,require:'^ngSwitch',multiElement:true,link:function link(scope,element,attr,ctrl,$transclude){ctrl.cases['?']=ctrl.cases['?']||[];ctrl.cases['?'].push({transclude:$transclude,element:element});}});/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * Any existing content of the element that this directive is placed on will be removed before the transcluded content is inserted.
	 *
	 * @element ANY
	 *
	 * @example
	   <example module="transcludeExample">
	     <file name="index.html">
	       <script>
	         angular.module('transcludeExample', [])
	          .directive('pane', function(){
	             return {
	               restrict: 'E',
	               transclude: true,
	               scope: { title:'@' },
	               template: '<div style="border: 1px solid black;">' +
	                           '<div style="background-color: gray">{{title}}</div>' +
	                           '<ng-transclude></ng-transclude>' +
	                         '</div>'
	             };
	         })
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.title = 'Lorem Ipsum';
	           $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	         }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input ng-model="title" aria-label="title"> <br/>
	         <textarea ng-model="text" aria-label="text"></textarea> <br/>
	         <pane title="{{title}}">{{text}}</pane>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	        it('should have transcluded', function() {
	          var titleElement = element(by.model('title'));
	          titleElement.clear();
	          titleElement.sendKeys('TITLE');
	          var textElement = element(by.model('text'));
	          textElement.clear();
	          textElement.sendKeys('TEXT');
	          expect(element(by.binding('title')).getText()).toEqual('TITLE');
	          expect(element(by.binding('text')).getText()).toEqual('TEXT');
	        });
	     </file>
	   </example>
	 *
	 */var ngTranscludeDirective=ngDirective({restrict:'EAC',link:function link($scope,$element,$attrs,controller,$transclude){if(!$transclude){throw minErr('ngTransclude')('orphan','Illegal use of ngTransclude directive in the template! '+'No parent directive that requires a transclusion found. '+'Element: {0}',startingTag($element));}$transclude(function(clone){$element.empty();$element.append(clone);});}});/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example>
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */var scriptDirective=['$templateCache',function($templateCache){return{restrict:'E',terminal:true,compile:function compile(element,attr){if(attr.type=='text/ng-template'){var templateUrl=attr.id,text=element[0].text;$templateCache.put(templateUrl,text);}}};}];var noopNgModelController={$setViewValue:noop,$render:noop};function chromeHack(optionElement){// Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
	// Adding an <option selected="selected"> element to a <select required="required"> should
	// automatically select the new element
	if(optionElement[0].hasAttribute('selected')){optionElement[0].selected=true;}}/**
	 * @ngdoc type
	 * @name  select.SelectController
	 * @description
	 * The controller for the `<select>` directive. This provides support for reading
	 * and writing the selected value(s) of the control and also coordinates dynamically
	 * added `<option>` elements, perhaps by an `ngRepeat` directive.
	 */var SelectController=['$element','$scope','$attrs',function($element,$scope,$attrs){var self=this,optionsMap=new HashMap();// If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	self.ngModelCtrl=noopNgModelController;// The "unknown" option is one that is prepended to the list if the viewValue
	// does not match any of the options. When it is rendered the value of the unknown
	// option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	//
	// We can't just jqLite('<option>') since jqLite is not smart enough
	// to create it in <select> and IE barfs otherwise.
	self.unknownOption=jqLite(document.createElement('option'));self.renderUnknownOption=function(val){var unknownVal='? '+hashKey(val)+' ?';self.unknownOption.val(unknownVal);$element.prepend(self.unknownOption);$element.val(unknownVal);};$scope.$on('$destroy',function(){// disable unknown option so that we don't do work when the whole select is being destroyed
	self.renderUnknownOption=noop;});self.removeUnknownOption=function(){if(self.unknownOption.parent())self.unknownOption.remove();};// Read the value of the select control, the implementation of this changes depending
	// upon whether the select can have multiple values and whether ngOptions is at work.
	self.readValue=function readSingleValue(){self.removeUnknownOption();return $element.val();};// Write the value to the select control, the implementation of this changes depending
	// upon whether the select can have multiple values and whether ngOptions is at work.
	self.writeValue=function writeSingleValue(value){if(self.hasOption(value)){self.removeUnknownOption();$element.val(value);if(value==='')self.emptyOption.prop('selected',true);// to make IE9 happy
	}else{if(value==null&&self.emptyOption){self.removeUnknownOption();$element.val('');}else{self.renderUnknownOption(value);}}};// Tell the select control that an option, with the given value, has been added
	self.addOption=function(value,element){// Skip comment nodes, as they only pollute the `optionsMap`
	if(element[0].nodeType===NODE_TYPE_COMMENT)return;assertNotHasOwnProperty(value,'"option value"');if(value===''){self.emptyOption=element;}var count=optionsMap.get(value)||0;optionsMap.put(value,count+1);self.ngModelCtrl.$render();chromeHack(element);};// Tell the select control that an option, with the given value, has been removed
	self.removeOption=function(value){var count=optionsMap.get(value);if(count){if(count===1){optionsMap.remove(value);if(value===''){self.emptyOption=undefined;}}else{optionsMap.put(value,count-1);}}};// Check whether the select control has an option matching the given value
	self.hasOption=function(value){return!!optionsMap.get(value);};self.registerOption=function(optionScope,optionElement,optionAttrs,interpolateValueFn,interpolateTextFn){if(interpolateValueFn){// The value attribute is interpolated
	var oldVal;optionAttrs.$observe('value',function valueAttributeObserveAction(newVal){if(isDefined(oldVal)){self.removeOption(oldVal);}oldVal=newVal;self.addOption(newVal,optionElement);});}else if(interpolateTextFn){// The text content is interpolated
	optionScope.$watch(interpolateTextFn,function interpolateWatchAction(newVal,oldVal){optionAttrs.$set('value',newVal);if(oldVal!==newVal){self.removeOption(oldVal);}self.addOption(newVal,optionElement);});}else{// The value attribute is static
	self.addOption(optionAttrs.value,optionElement);}optionElement.on('$destroy',function(){self.removeOption(optionAttrs.value);self.ngModelCtrl.$render();});};}];/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `SELECT` element with angular data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * If you want dynamic value attributes, you can use interpolation inside the value attribute.
	 *
	 * <div class="alert alert-warning">
	 * Note that the value of a `select` directive used without `ngOptions` is always a string.
	 * When the model needs to be bound to a non-string value, you must either explictly convert it
	 * using a directive (see example below) or use `ngOptions` to specify the set of options.
	 * This is because an option element can only be bound to string values at present.
	 * </div>
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * <div class="alert alert-info">
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits, such as
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression, and additionally in reducing memory and increasing speed by not creating
	 * a new scope for each repeated instance.
	 * </div>
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1',
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="ngrepeat-select" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.repeatSelect">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>repeatSelect = {{data.repeatSelect}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       repeatSelect: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       var select = element(by.css('select'));
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */var selectDirective=function selectDirective(){return{restrict:'E',require:['select','?ngModel'],controller:SelectController,priority:1,link:{pre:selectPreLink,post:selectPostLink}};function selectPreLink(scope,element,attr,ctrls){// if ngModel is not defined, we don't need to do anything
	var ngModelCtrl=ctrls[1];if(!ngModelCtrl)return;var selectCtrl=ctrls[0];selectCtrl.ngModelCtrl=ngModelCtrl;// When the selected item(s) changes we delegate getting the value of the select control
	// to the `readValue` method, which can be changed if the select can have multiple
	// selected values or if the options are being generated by `ngOptions`
	element.on('change',function(){scope.$apply(function(){ngModelCtrl.$setViewValue(selectCtrl.readValue());});});// If the select allows multiple values then we need to modify how we read and write
	// values from and to the control; also what it means for the value to be empty and
	// we have to add an extra watch since ngModel doesn't work well with arrays - it
	// doesn't trigger rendering if only an item in the array changes.
	if(attr.multiple){// Read value now needs to check each option to see if it is selected
	selectCtrl.readValue=function readMultipleValue(){var array=[];forEach(element.find('option'),function(option){if(option.selected){array.push(option.value);}});return array;};// Write value now needs to set the selected property of each matching option
	selectCtrl.writeValue=function writeMultipleValue(value){var items=new HashMap(value);forEach(element.find('option'),function(option){option.selected=isDefined(items.get(option.value));});};// we have to do it on each watch since ngModel watches reference, but
	// we need to work of an array, so we need to see if anything was inserted/removed
	var lastView,lastViewRef=NaN;scope.$watch(function selectMultipleWatch(){if(lastViewRef===ngModelCtrl.$viewValue&&!equals(lastView,ngModelCtrl.$viewValue)){lastView=shallowCopy(ngModelCtrl.$viewValue);ngModelCtrl.$render();}lastViewRef=ngModelCtrl.$viewValue;});// If we are a multiple select then value is now a collection
	// so the meaning of $isEmpty changes
	ngModelCtrl.$isEmpty=function(value){return!value||value.length===0;};}}function selectPostLink(scope,element,attrs,ctrls){// if ngModel is not defined, we don't need to do anything
	var ngModelCtrl=ctrls[1];if(!ngModelCtrl)return;var selectCtrl=ctrls[0];// We delegate rendering to the `writeValue` method, which can be changed
	// if the select can have multiple selected values or if the options are being
	// generated by `ngOptions`.
	// This must be done in the postLink fn to prevent $render to be called before
	// all nodes have been linked correctly.
	ngModelCtrl.$render=function(){selectCtrl.writeValue(ngModelCtrl.$viewValue);};}};// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective=['$interpolate',function($interpolate){return{restrict:'E',priority:100,compile:function compile(element,attr){if(isDefined(attr.value)){// If the value attribute is defined, check if it contains an interpolation
	var interpolateValueFn=$interpolate(attr.value,true);}else{// If the value attribute is not defined then we fall back to the
	// text content of the option element, which may be interpolated
	var interpolateTextFn=$interpolate(element.text(),true);if(!interpolateTextFn){attr.$set('value',element.text());}}return function(scope,element,attr){// This is an optimization over using ^^ since we don't want to have to search
	// all the way to the root of the DOM for every single option element
	var selectCtrlName='$selectController',parent=element.parent(),selectCtrl=parent.data(selectCtrlName)||parent.parent().data(selectCtrlName);// in case we are in optgroup
	if(selectCtrl){selectCtrl.registerOption(scope,element,attr,interpolateValueFn,interpolateTextFn);}};}};}];var styleDirective=valueFn({restrict:'E',terminal:false});/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the Angular expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */var requiredDirective=function requiredDirective(){return{restrict:'A',require:'?ngModel',link:function link(scope,elm,attr,ctrl){if(!ctrl)return;attr.required=true;// force truthy in case we are on non input element
	ctrl.$validators.required=function(modelValue,viewValue){return!attr.required||!ctrl.$isEmpty(viewValue);};attr.$observe('required',function(){ctrl.$validate();});}};};/**
	 * @ngdoc directive
	 * @name ngPattern
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
	 * `ngPattern` attribute value:
	 * * If the expression evaluates to a RegExp object, then this is used directly.
	 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */var patternDirective=function patternDirective(){return{restrict:'A',require:'?ngModel',link:function link(scope,elm,attr,ctrl){if(!ctrl)return;var regexp,patternExp=attr.ngPattern||attr.pattern;attr.$observe('pattern',function(regex){if(isString(regex)&&regex.length>0){regex=new RegExp('^'+regex+'$');}if(regex&&!regex.test){throw minErr('ngPattern')('noregexp','Expected {0} to be a RegExp but was {1}. Element: {2}',patternExp,regex,startingTag(elm));}regexp=regex||undefined;ctrl.$validate();});ctrl.$validators.pattern=function(modelValue,viewValue){// HTML5 pattern constraint validates the input value, so we validate the viewValue
	return ctrl.$isEmpty(viewValue)||isUndefined(regexp)||regexp.test(viewValue);};}};};/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the Angular expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */var maxlengthDirective=function maxlengthDirective(){return{restrict:'A',require:'?ngModel',link:function link(scope,elm,attr,ctrl){if(!ctrl)return;var maxlength=-1;attr.$observe('maxlength',function(value){var intVal=toInt(value);maxlength=isNaN(intVal)?-1:intVal;ctrl.$validate();});ctrl.$validators.maxlength=function(modelValue,viewValue){return maxlength<0||ctrl.$isEmpty(viewValue)||viewValue.length<=maxlength;};}};};/**
	 * @ngdoc directive
	 * @name ngMinlength
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the Angular expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */var minlengthDirective=function minlengthDirective(){return{restrict:'A',require:'?ngModel',link:function link(scope,elm,attr,ctrl){if(!ctrl)return;var minlength=0;attr.$observe('minlength',function(value){minlength=toInt(value)||0;ctrl.$validate();});ctrl.$validators.minlength=function(modelValue,viewValue){return ctrl.$isEmpty(viewValue)||viewValue.length>=minlength;};}};};if(window.angular.bootstrap){//AngularJS is already loaded, so we can return here...
	if(window.console){console.log('WARNING: Tried to load angular more than once.');}return;}//try to bind to jquery now so that one can write jqLite(document).ready()
	//but we will rebind on bootstrap again.
	bindJQuery();publishExternalAPI(angular);angular.module("ngLocale",[],["$provide",function($provide){var PLURAL_CATEGORY={ZERO:"zero",ONE:"one",TWO:"two",FEW:"few",MANY:"many",OTHER:"other"};function getDecimals(n){n=n+'';var i=n.indexOf('.');return i==-1?0:n.length-i-1;}function getVF(n,opt_precision){var v=opt_precision;if(undefined===v){v=Math.min(getDecimals(n),3);}var base=Math.pow(10,v);var f=(n*base|0)%base;return{v:v,f:f};}$provide.value("$locale",{"DATETIME_FORMATS":{"AMPMS":["AM","PM"],"DAY":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],"ERANAMES":["Before Christ","Anno Domini"],"ERAS":["BC","AD"],"FIRSTDAYOFWEEK":6,"MONTH":["January","February","March","April","May","June","July","August","September","October","November","December"],"SHORTDAY":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"SHORTMONTH":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"STANDALONEMONTH":["January","February","March","April","May","June","July","August","September","October","November","December"],"WEEKENDRANGE":[5,6],"fullDate":"EEEE, MMMM d, y","longDate":"MMMM d, y","medium":"MMM d, y h:mm:ss a","mediumDate":"MMM d, y","mediumTime":"h:mm:ss a","short":"M/d/yy h:mm a","shortDate":"M/d/yy","shortTime":"h:mm a"},"NUMBER_FORMATS":{"CURRENCY_SYM":"$","DECIMAL_SEP":".","GROUP_SEP":",","PATTERNS":[{"gSize":3,"lgSize":3,"maxFrac":3,"minFrac":0,"minInt":1,"negPre":"-","negSuf":"","posPre":"","posSuf":""},{"gSize":3,"lgSize":3,"maxFrac":2,"minFrac":2,"minInt":1,"negPre":'-\xA4',"negSuf":"","posPre":'\xA4',"posSuf":""}]},"id":"en-us","localeID":"en_US","pluralCat":function pluralCat(n,opt_precision){var i=n|0;var vf=getVF(n,opt_precision);if(i==1&&vf.v==0){return PLURAL_CATEGORY.ONE;}return PLURAL_CATEGORY.OTHER;}});}]);jqLite(document).ready(function(){angularInit(document,bootstrap);});})(window,document);!window.angular.$$csp().noInlineStyle&&window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(3));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  var defaults = {
	    pairs: "()[]{}''\"\"",
	    triples: "",
	    explode: "[]{}"
	  };
	
	  var Pos = CodeMirror.Pos;
	
	  CodeMirror.defineOption("autoCloseBrackets", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      cm.removeKeyMap(keyMap);
	      cm.state.closeBrackets = null;
	    }
	    if (val) {
	      cm.state.closeBrackets = val;
	      cm.addKeyMap(keyMap);
	    }
	  });
	
	  function getOption(conf, name) {
	    if (name == "pairs" && typeof conf == "string") return conf;
	    if ((typeof conf === "undefined" ? "undefined" : _typeof(conf)) == "object" && conf[name] != null) return conf[name];
	    return defaults[name];
	  }
	
	  var bind = defaults.pairs + "`";
	  var keyMap = { Backspace: handleBackspace, Enter: handleEnter };
	  for (var i = 0; i < bind.length; i++) {
	    keyMap["'" + bind.charAt(i) + "'"] = handler(bind.charAt(i));
	  }function handler(ch) {
	    return function (cm) {
	      return handleChar(cm, ch);
	    };
	  }
	
	  function getConfig(cm) {
	    var deflt = cm.state.closeBrackets;
	    if (!deflt) return null;
	    var mode = cm.getModeAt(cm.getCursor());
	    return mode.closeBrackets || deflt;
	  }
	
	  function handleBackspace(cm) {
	    var conf = getConfig(cm);
	    if (!conf || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var pairs = getOption(conf, "pairs");
	    var ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      if (!ranges[i].empty()) return CodeMirror.Pass;
	      var around = charsAround(cm, ranges[i].head);
	      if (!around || pairs.indexOf(around) % 2 != 0) return CodeMirror.Pass;
	    }
	    for (var i = ranges.length - 1; i >= 0; i--) {
	      var cur = ranges[i].head;
	      cm.replaceRange("", Pos(cur.line, cur.ch - 1), Pos(cur.line, cur.ch + 1), "+delete");
	    }
	  }
	
	  function handleEnter(cm) {
	    var conf = getConfig(cm);
	    var explode = conf && getOption(conf, "explode");
	    if (!explode || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      if (!ranges[i].empty()) return CodeMirror.Pass;
	      var around = charsAround(cm, ranges[i].head);
	      if (!around || explode.indexOf(around) % 2 != 0) return CodeMirror.Pass;
	    }
	    cm.operation(function () {
	      cm.replaceSelection("\n\n", null);
	      cm.execCommand("goCharLeft");
	      ranges = cm.listSelections();
	      for (var i = 0; i < ranges.length; i++) {
	        var line = ranges[i].head.line;
	        cm.indentLine(line, null, true);
	        cm.indentLine(line + 1, null, true);
	      }
	    });
	  }
	
	  function contractSelection(sel) {
	    var inverted = CodeMirror.cmpPos(sel.anchor, sel.head) > 0;
	    return { anchor: new Pos(sel.anchor.line, sel.anchor.ch + (inverted ? -1 : 1)),
	      head: new Pos(sel.head.line, sel.head.ch + (inverted ? 1 : -1)) };
	  }
	
	  function handleChar(cm, ch) {
	    var conf = getConfig(cm);
	    if (!conf || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var pairs = getOption(conf, "pairs");
	    var pos = pairs.indexOf(ch);
	    if (pos == -1) return CodeMirror.Pass;
	    var triples = getOption(conf, "triples");
	
	    var identical = pairs.charAt(pos + 1) == ch;
	    var ranges = cm.listSelections();
	    var opening = pos % 2 == 0;
	
	    var type;
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i],
	          cur = range.head,
	          curType;
	      var next = cm.getRange(cur, Pos(cur.line, cur.ch + 1));
	      if (opening && !range.empty()) {
	        curType = "surround";
	      } else if ((identical || !opening) && next == ch) {
	        if (identical && stringStartsAfter(cm, cur)) curType = "both";else if (triples.indexOf(ch) >= 0 && cm.getRange(cur, Pos(cur.line, cur.ch + 3)) == ch + ch + ch) curType = "skipThree";else curType = "skip";
	      } else if (identical && cur.ch > 1 && triples.indexOf(ch) >= 0 && cm.getRange(Pos(cur.line, cur.ch - 2), cur) == ch + ch && (cur.ch <= 2 || cm.getRange(Pos(cur.line, cur.ch - 3), Pos(cur.line, cur.ch - 2)) != ch)) {
	        curType = "addFour";
	      } else if (identical) {
	        if (!CodeMirror.isWordChar(next) && enteringString(cm, cur, ch)) curType = "both";else return CodeMirror.Pass;
	      } else if (opening && (cm.getLine(cur.line).length == cur.ch || isClosingBracket(next, pairs) || /\s/.test(next))) {
	        curType = "both";
	      } else {
	        return CodeMirror.Pass;
	      }
	      if (!type) type = curType;else if (type != curType) return CodeMirror.Pass;
	    }
	
	    var left = pos % 2 ? pairs.charAt(pos - 1) : ch;
	    var right = pos % 2 ? ch : pairs.charAt(pos + 1);
	    cm.operation(function () {
	      if (type == "skip") {
	        cm.execCommand("goCharRight");
	      } else if (type == "skipThree") {
	        for (var i = 0; i < 3; i++) {
	          cm.execCommand("goCharRight");
	        }
	      } else if (type == "surround") {
	        var sels = cm.getSelections();
	        for (var i = 0; i < sels.length; i++) {
	          sels[i] = left + sels[i] + right;
	        }cm.replaceSelections(sels, "around");
	        sels = cm.listSelections().slice();
	        for (var i = 0; i < sels.length; i++) {
	          sels[i] = contractSelection(sels[i]);
	        }cm.setSelections(sels);
	      } else if (type == "both") {
	        cm.replaceSelection(left + right, null);
	        cm.triggerElectric(left + right);
	        cm.execCommand("goCharLeft");
	      } else if (type == "addFour") {
	        cm.replaceSelection(left + left + left + left, "before");
	        cm.execCommand("goCharRight");
	      }
	    });
	  }
	
	  function isClosingBracket(ch, pairs) {
	    var pos = pairs.lastIndexOf(ch);
	    return pos > -1 && pos % 2 == 1;
	  }
	
	  function charsAround(cm, pos) {
	    var str = cm.getRange(Pos(pos.line, pos.ch - 1), Pos(pos.line, pos.ch + 1));
	    return str.length == 2 ? str : null;
	  }
	
	  // Project the token type that will exists after the given char is
	  // typed, and use it to determine whether it would cause the start
	  // of a string token.
	  function enteringString(cm, pos, ch) {
	    var line = cm.getLine(pos.line);
	    var token = cm.getTokenAt(pos);
	    if (/\bstring2?\b/.test(token.type)) return false;
	    var stream = new CodeMirror.StringStream(line.slice(0, pos.ch) + ch + line.slice(pos.ch), 4);
	    stream.pos = stream.start = token.start;
	    for (;;) {
	      var type1 = cm.getMode().token(stream, token.state);
	      if (stream.pos >= pos.ch + 1) return (/\bstring2?\b/.test(type1)
	      );
	      stream.start = stream.pos;
	    }
	  }
	
	  function stringStartsAfter(cm, pos) {
	    var token = cm.getTokenAt(Pos(pos.line, pos.ch + 1));
	    return (/\bstring/.test(token.type) && token.start == pos.ch
	    );
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(3));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  var ie_lt8 = /MSIE \d/.test(navigator.userAgent) && (document.documentMode == null || document.documentMode < 8);
	
	  var Pos = CodeMirror.Pos;
	
	  var matching = { "(": ")>", ")": "(<", "[": "]>", "]": "[<", "{": "}>", "}": "{<" };
	
	  function findMatchingBracket(cm, where, strict, config) {
	    var line = cm.getLineHandle(where.line),
	        pos = where.ch - 1;
	    var match = pos >= 0 && matching[line.text.charAt(pos)] || matching[line.text.charAt(++pos)];
	    if (!match) return null;
	    var dir = match.charAt(1) == ">" ? 1 : -1;
	    if (strict && dir > 0 != (pos == where.ch)) return null;
	    var style = cm.getTokenTypeAt(Pos(where.line, pos + 1));
	
	    var found = scanForBracket(cm, Pos(where.line, pos + (dir > 0 ? 1 : 0)), dir, style || null, config);
	    if (found == null) return null;
	    return { from: Pos(where.line, pos), to: found && found.pos,
	      match: found && found.ch == match.charAt(0), forward: dir > 0 };
	  }
	
	  // bracketRegex is used to specify which type of bracket to scan
	  // should be a regexp, e.g. /[[\]]/
	  //
	  // Note: If "where" is on an open bracket, then this bracket is ignored.
	  //
	  // Returns false when no bracket was found, null when it reached
	  // maxScanLines and gave up
	  function scanForBracket(cm, where, dir, style, config) {
	    var maxScanLen = config && config.maxScanLineLength || 10000;
	    var maxScanLines = config && config.maxScanLines || 1000;
	
	    var stack = [];
	    var re = config && config.bracketRegex ? config.bracketRegex : /[(){}[\]]/;
	    var lineEnd = dir > 0 ? Math.min(where.line + maxScanLines, cm.lastLine() + 1) : Math.max(cm.firstLine() - 1, where.line - maxScanLines);
	    for (var lineNo = where.line; lineNo != lineEnd; lineNo += dir) {
	      var line = cm.getLine(lineNo);
	      if (!line) continue;
	      var pos = dir > 0 ? 0 : line.length - 1,
	          end = dir > 0 ? line.length : -1;
	      if (line.length > maxScanLen) continue;
	      if (lineNo == where.line) pos = where.ch - (dir < 0 ? 1 : 0);
	      for (; pos != end; pos += dir) {
	        var ch = line.charAt(pos);
	        if (re.test(ch) && (style === undefined || cm.getTokenTypeAt(Pos(lineNo, pos + 1)) == style)) {
	          var match = matching[ch];
	          if (match.charAt(1) == ">" == dir > 0) stack.push(ch);else if (!stack.length) return { pos: Pos(lineNo, pos), ch: ch };else stack.pop();
	        }
	      }
	    }
	    return lineNo - dir == (dir > 0 ? cm.lastLine() : cm.firstLine()) ? false : null;
	  }
	
	  function matchBrackets(cm, autoclear, config) {
	    // Disable brace matching in long lines, since it'll cause hugely slow updates
	    var maxHighlightLen = cm.state.matchBrackets.maxHighlightLineLength || 1000;
	    var marks = [],
	        ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      var match = ranges[i].empty() && findMatchingBracket(cm, ranges[i].head, false, config);
	      if (match && cm.getLine(match.from.line).length <= maxHighlightLen) {
	        var style = match.match ? "CodeMirror-matchingbracket" : "CodeMirror-nonmatchingbracket";
	        marks.push(cm.markText(match.from, Pos(match.from.line, match.from.ch + 1), { className: style }));
	        if (match.to && cm.getLine(match.to.line).length <= maxHighlightLen) marks.push(cm.markText(match.to, Pos(match.to.line, match.to.ch + 1), { className: style }));
	      }
	    }
	
	    if (marks.length) {
	      // Kludge to work around the IE bug from issue #1193, where text
	      // input stops going to the textare whever this fires.
	      if (ie_lt8 && cm.state.focused) cm.focus();
	
	      var clear = function clear() {
	        cm.operation(function () {
	          for (var i = 0; i < marks.length; i++) {
	            marks[i].clear();
	          }
	        });
	      };
	      if (autoclear) setTimeout(clear, 800);else return clear;
	    }
	  }
	
	  var currentlyHighlighted = null;
	  function doMatchBrackets(cm) {
	    cm.operation(function () {
	      if (currentlyHighlighted) {
	        currentlyHighlighted();currentlyHighlighted = null;
	      }
	      currentlyHighlighted = matchBrackets(cm, false, cm.state.matchBrackets);
	    });
	  }
	
	  CodeMirror.defineOption("matchBrackets", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      cm.off("cursorActivity", doMatchBrackets);
	      if (currentlyHighlighted) {
	        currentlyHighlighted();currentlyHighlighted = null;
	      }
	    }
	    if (val) {
	      cm.state.matchBrackets = (typeof val === "undefined" ? "undefined" : _typeof(val)) == "object" ? val : {};
	      cm.on("cursorActivity", doMatchBrackets);
	    }
	  });
	
	  CodeMirror.defineExtension("matchBrackets", function () {
	    matchBrackets(this, true);
	  });
	  CodeMirror.defineExtension("findMatchingBracket", function (pos, strict, config) {
	    return findMatchingBracket(this, pos, strict, config);
	  });
	  CodeMirror.defineExtension("scanForBracket", function (pos, dir, style, config) {
	    return scanForBracket(this, pos, dir, style, config);
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Depends on jsonlint.js from https://github.com/zaach/jsonlint
	
	// declare global: jsonlint
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(3));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.registerHelper("lint", "json", function (text) {
	    var found = [];
	    jsonlint.parseError = function (str, hash) {
	      var loc = hash.loc;
	      found.push({ from: CodeMirror.Pos(loc.first_line - 1, loc.first_column),
	        to: CodeMirror.Pos(loc.last_line - 1, loc.last_column),
	        message: str });
	    };
	    try {
	      jsonlint.parse(text);
	    } catch (e) {}
	    return found;
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(3));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  var GUTTER_ID = "CodeMirror-lint-markers";
	
	  function showTooltip(e, content) {
	    var tt = document.createElement("div");
	    tt.className = "CodeMirror-lint-tooltip";
	    tt.appendChild(content.cloneNode(true));
	    document.body.appendChild(tt);
	
	    function position(e) {
	      if (!tt.parentNode) return CodeMirror.off(document, "mousemove", position);
	      tt.style.top = Math.max(0, e.clientY - tt.offsetHeight - 5) + "px";
	      tt.style.left = e.clientX + 5 + "px";
	    }
	    CodeMirror.on(document, "mousemove", position);
	    position(e);
	    if (tt.style.opacity != null) tt.style.opacity = 1;
	    return tt;
	  }
	  function rm(elt) {
	    if (elt.parentNode) elt.parentNode.removeChild(elt);
	  }
	  function hideTooltip(tt) {
	    if (!tt.parentNode) return;
	    if (tt.style.opacity == null) rm(tt);
	    tt.style.opacity = 0;
	    setTimeout(function () {
	      rm(tt);
	    }, 600);
	  }
	
	  function showTooltipFor(e, content, node) {
	    var tooltip = showTooltip(e, content);
	    function hide() {
	      CodeMirror.off(node, "mouseout", hide);
	      if (tooltip) {
	        hideTooltip(tooltip);tooltip = null;
	      }
	    }
	    var poll = setInterval(function () {
	      if (tooltip) for (var n = node;; n = n.parentNode) {
	        if (n && n.nodeType == 11) n = n.host;
	        if (n == document.body) return;
	        if (!n) {
	          hide();break;
	        }
	      }
	      if (!tooltip) return clearInterval(poll);
	    }, 400);
	    CodeMirror.on(node, "mouseout", hide);
	  }
	
	  function LintState(cm, options, hasGutter) {
	    this.marked = [];
	    this.options = options;
	    this.timeout = null;
	    this.hasGutter = hasGutter;
	    this.onMouseOver = function (e) {
	      onMouseOver(cm, e);
	    };
	    this.waitingFor = 0;
	  }
	
	  function parseOptions(_cm, options) {
	    if (options instanceof Function) return { getAnnotations: options };
	    if (!options || options === true) options = {};
	    return options;
	  }
	
	  function clearMarks(cm) {
	    var state = cm.state.lint;
	    if (state.hasGutter) cm.clearGutter(GUTTER_ID);
	    for (var i = 0; i < state.marked.length; ++i) {
	      state.marked[i].clear();
	    }state.marked.length = 0;
	  }
	
	  function makeMarker(labels, severity, multiple, tooltips) {
	    var marker = document.createElement("div"),
	        inner = marker;
	    marker.className = "CodeMirror-lint-marker-" + severity;
	    if (multiple) {
	      inner = marker.appendChild(document.createElement("div"));
	      inner.className = "CodeMirror-lint-marker-multiple";
	    }
	
	    if (tooltips != false) CodeMirror.on(inner, "mouseover", function (e) {
	      showTooltipFor(e, labels, inner);
	    });
	
	    return marker;
	  }
	
	  function getMaxSeverity(a, b) {
	    if (a == "error") return a;else return b;
	  }
	
	  function groupByLine(annotations) {
	    var lines = [];
	    for (var i = 0; i < annotations.length; ++i) {
	      var ann = annotations[i],
	          line = ann.from.line;
	      (lines[line] || (lines[line] = [])).push(ann);
	    }
	    return lines;
	  }
	
	  function annotationTooltip(ann) {
	    var severity = ann.severity;
	    if (!severity) severity = "error";
	    var tip = document.createElement("div");
	    tip.className = "CodeMirror-lint-message-" + severity;
	    tip.appendChild(document.createTextNode(ann.message));
	    return tip;
	  }
	
	  function lintAsync(cm, getAnnotations, passOptions) {
	    var state = cm.state.lint;
	    var id = ++state.waitingFor;
	    function abort() {
	      id = -1;
	      cm.off("change", abort);
	    }
	    cm.on("change", abort);
	    getAnnotations(cm.getValue(), function (annotations, arg2) {
	      cm.off("change", abort);
	      if (state.waitingFor != id) return;
	      if (arg2 && annotations instanceof CodeMirror) annotations = arg2;
	      updateLinting(cm, annotations);
	    }, passOptions, cm);
	  }
	
	  function startLinting(cm) {
	    var state = cm.state.lint,
	        options = state.options;
	    var passOptions = options.options || options; // Support deprecated passing of `options` property in options
	    var getAnnotations = options.getAnnotations || cm.getHelper(CodeMirror.Pos(0, 0), "lint");
	    if (!getAnnotations) return;
	    if (options.async || getAnnotations.async) {
	      lintAsync(cm, getAnnotations, passOptions);
	    } else {
	      updateLinting(cm, getAnnotations(cm.getValue(), passOptions, cm));
	    }
	  }
	
	  function updateLinting(cm, annotationsNotSorted) {
	    clearMarks(cm);
	    var state = cm.state.lint,
	        options = state.options;
	
	    var annotations = groupByLine(annotationsNotSorted);
	
	    for (var line = 0; line < annotations.length; ++line) {
	      var anns = annotations[line];
	      if (!anns) continue;
	
	      var maxSeverity = null;
	      var tipLabel = state.hasGutter && document.createDocumentFragment();
	
	      for (var i = 0; i < anns.length; ++i) {
	        var ann = anns[i];
	        var severity = ann.severity;
	        if (!severity) severity = "error";
	        maxSeverity = getMaxSeverity(maxSeverity, severity);
	
	        if (options.formatAnnotation) ann = options.formatAnnotation(ann);
	        if (state.hasGutter) tipLabel.appendChild(annotationTooltip(ann));
	
	        if (ann.to) state.marked.push(cm.markText(ann.from, ann.to, {
	          className: "CodeMirror-lint-mark-" + severity,
	          __annotation: ann
	        }));
	      }
	
	      if (state.hasGutter) cm.setGutterMarker(line, GUTTER_ID, makeMarker(tipLabel, maxSeverity, anns.length > 1, state.options.tooltips));
	    }
	    if (options.onUpdateLinting) options.onUpdateLinting(annotationsNotSorted, annotations, cm);
	  }
	
	  function onChange(cm) {
	    var state = cm.state.lint;
	    if (!state) return;
	    clearTimeout(state.timeout);
	    state.timeout = setTimeout(function () {
	      startLinting(cm);
	    }, state.options.delay || 500);
	  }
	
	  function popupTooltips(annotations, e) {
	    var target = e.target || e.srcElement;
	    var tooltip = document.createDocumentFragment();
	    for (var i = 0; i < annotations.length; i++) {
	      var ann = annotations[i];
	      tooltip.appendChild(annotationTooltip(ann));
	    }
	    showTooltipFor(e, tooltip, target);
	  }
	
	  function onMouseOver(cm, e) {
	    var target = e.target || e.srcElement;
	    if (!/\bCodeMirror-lint-mark-/.test(target.className)) return;
	    var box = target.getBoundingClientRect(),
	        x = (box.left + box.right) / 2,
	        y = (box.top + box.bottom) / 2;
	    var spans = cm.findMarksAt(cm.coordsChar({ left: x, top: y }, "client"));
	
	    var annotations = [];
	    for (var i = 0; i < spans.length; ++i) {
	      var ann = spans[i].__annotation;
	      if (ann) annotations.push(ann);
	    }
	    if (annotations.length) popupTooltips(annotations, e);
	  }
	
	  CodeMirror.defineOption("lint", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      clearMarks(cm);
	      if (cm.state.lint.options.lintOnChange !== false) cm.off("change", onChange);
	      CodeMirror.off(cm.getWrapperElement(), "mouseover", cm.state.lint.onMouseOver);
	      clearTimeout(cm.state.lint.timeout);
	      delete cm.state.lint;
	    }
	
	    if (val) {
	      var gutters = cm.getOption("gutters"),
	          hasLintGutter = false;
	      for (var i = 0; i < gutters.length; ++i) {
	        if (gutters[i] == GUTTER_ID) hasLintGutter = true;
	      }var state = cm.state.lint = new LintState(cm, parseOptions(cm, val), hasLintGutter);
	      if (state.options.lintOnChange !== false) cm.on("change", onChange);
	      if (state.options.tooltips != false && state.options.tooltips != "gutter") CodeMirror.on(cm.getWrapperElement(), "mouseover", state.onMouseOver);
	
	      startLinting(cm);
	    }
	  });
	
	  CodeMirror.defineExtension("performLint", function () {
	    if (this.state.lint) startLinting(this);
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(3));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  var WRAP_CLASS = "CodeMirror-activeline";
	  var BACK_CLASS = "CodeMirror-activeline-background";
	  var GUTT_CLASS = "CodeMirror-activeline-gutter";
	
	  CodeMirror.defineOption("styleActiveLine", false, function (cm, val, old) {
	    var prev = old == CodeMirror.Init ? false : old;
	    if (val == prev) return;
	    if (prev) {
	      cm.off("beforeSelectionChange", selectionChange);
	      clearActiveLines(cm);
	      delete cm.state.activeLines;
	    }
	    if (val) {
	      cm.state.activeLines = [];
	      updateActiveLines(cm, cm.listSelections());
	      cm.on("beforeSelectionChange", selectionChange);
	    }
	  });
	
	  function clearActiveLines(cm) {
	    for (var i = 0; i < cm.state.activeLines.length; i++) {
	      cm.removeLineClass(cm.state.activeLines[i], "wrap", WRAP_CLASS);
	      cm.removeLineClass(cm.state.activeLines[i], "background", BACK_CLASS);
	      cm.removeLineClass(cm.state.activeLines[i], "gutter", GUTT_CLASS);
	    }
	  }
	
	  function sameArray(a, b) {
	    if (a.length != b.length) return false;
	    for (var i = 0; i < a.length; i++) {
	      if (a[i] != b[i]) return false;
	    }return true;
	  }
	
	  function updateActiveLines(cm, ranges) {
	    var active = [];
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i];
	      var option = cm.getOption("styleActiveLine");
	      if ((typeof option === "undefined" ? "undefined" : _typeof(option)) == "object" && option.nonEmpty ? range.anchor.line != range.head.line : !range.empty()) continue;
	      var line = cm.getLineHandleVisualStart(range.head.line);
	      if (active[active.length - 1] != line) active.push(line);
	    }
	    if (sameArray(cm.state.activeLines, active)) return;
	    cm.operation(function () {
	      clearActiveLines(cm);
	      for (var i = 0; i < active.length; i++) {
	        cm.addLineClass(active[i], "wrap", WRAP_CLASS);
	        cm.addLineClass(active[i], "background", BACK_CLASS);
	        cm.addLineClass(active[i], "gutter", GUTT_CLASS);
	      }
	      cm.state.activeLines = active;
	    });
	  }
	
	  function selectionChange(cm, sel) {
	    updateActiveLines(cm, sel.ranges);
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(3));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  function expressionAllowed(stream, state, backUp) {
	    return (/^(?:operator|sof|keyword c|case|new|export|default|[\[{}\(,;:]|=>)$/.test(state.lastType) || state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0)))
	    );
	  }
	
	  CodeMirror.defineMode("javascript", function (config, parserConfig) {
	    var indentUnit = config.indentUnit;
	    var statementIndent = parserConfig.statementIndent;
	    var jsonldMode = parserConfig.jsonld;
	    var jsonMode = parserConfig.json || jsonldMode;
	    var isTS = parserConfig.typescript;
	    var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;
	
	    // Tokenizer
	
	    var keywords = function () {
	      function kw(type) {
	        return { type: type, style: "keyword" };
	      }
	      var A = kw("keyword a"),
	          B = kw("keyword b"),
	          C = kw("keyword c");
	      var operator = kw("operator"),
	          atom = { type: "atom", style: "atom" };
	
	      var jsKeywords = {
	        "if": kw("if"), "while": A, "with": A, "else": B, "do": B, "try": B, "finally": B,
	        "return": C, "break": C, "continue": C, "new": kw("new"), "delete": C, "throw": C, "debugger": C,
	        "var": kw("var"), "const": kw("var"), "let": kw("var"),
	        "function": kw("function"), "catch": kw("catch"),
	        "for": kw("for"), "switch": kw("switch"), "case": kw("case"), "default": kw("default"),
	        "in": operator, "typeof": operator, "instanceof": operator,
	        "true": atom, "false": atom, "null": atom, "undefined": atom, "NaN": atom, "Infinity": atom,
	        "this": kw("this"), "class": kw("class"), "super": kw("atom"),
	        "yield": C, "export": kw("export"), "import": kw("import"), "extends": C,
	        "await": C, "async": kw("async")
	      };
	
	      // Extend the 'normal' keywords with the TypeScript language extensions
	      if (isTS) {
	        var type = { type: "variable", style: "variable-3" };
	        var tsKeywords = {
	          // object-like things
	          "interface": kw("class"),
	          "implements": C,
	          "namespace": C,
	          "module": kw("module"),
	          "enum": kw("module"),
	          "type": kw("type"),
	
	          // scope modifiers
	          "public": kw("modifier"),
	          "private": kw("modifier"),
	          "protected": kw("modifier"),
	          "abstract": kw("modifier"),
	
	          // operators
	          "as": operator,
	
	          // types
	          "string": type, "number": type, "boolean": type, "any": type
	        };
	
	        for (var attr in tsKeywords) {
	          jsKeywords[attr] = tsKeywords[attr];
	        }
	      }
	
	      return jsKeywords;
	    }();
	
	    var isOperatorChar = /[+\-*&%=<>!?|~^]/;
	    var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
	
	    function readRegexp(stream) {
	      var escaped = false,
	          next,
	          inSet = false;
	      while ((next = stream.next()) != null) {
	        if (!escaped) {
	          if (next == "/" && !inSet) return;
	          if (next == "[") inSet = true;else if (inSet && next == "]") inSet = false;
	        }
	        escaped = !escaped && next == "\\";
	      }
	    }
	
	    // Used as scratch variables to communicate multiple values without
	    // consing up tons of objects.
	    var type, content;
	    function ret(tp, style, cont) {
	      type = tp;content = cont;
	      return style;
	    }
	    function tokenBase(stream, state) {
	      var ch = stream.next();
	      if (ch == '"' || ch == "'") {
	        state.tokenize = tokenString(ch);
	        return state.tokenize(stream, state);
	      } else if (ch == "." && stream.match(/^\d+(?:[eE][+\-]?\d+)?/)) {
	        return ret("number", "number");
	      } else if (ch == "." && stream.match("..")) {
	        return ret("spread", "meta");
	      } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	        return ret(ch);
	      } else if (ch == "=" && stream.eat(">")) {
	        return ret("=>", "operator");
	      } else if (ch == "0" && stream.eat(/x/i)) {
	        stream.eatWhile(/[\da-f]/i);
	        return ret("number", "number");
	      } else if (ch == "0" && stream.eat(/o/i)) {
	        stream.eatWhile(/[0-7]/i);
	        return ret("number", "number");
	      } else if (ch == "0" && stream.eat(/b/i)) {
	        stream.eatWhile(/[01]/i);
	        return ret("number", "number");
	      } else if (/\d/.test(ch)) {
	        stream.match(/^\d*(?:\.\d*)?(?:[eE][+\-]?\d+)?/);
	        return ret("number", "number");
	      } else if (ch == "/") {
	        if (stream.eat("*")) {
	          state.tokenize = tokenComment;
	          return tokenComment(stream, state);
	        } else if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ret("comment", "comment");
	        } else if (expressionAllowed(stream, state, 1)) {
	          readRegexp(stream);
	          stream.match(/^\b(([gimyu])(?![gimyu]*\2))+\b/);
	          return ret("regexp", "string-2");
	        } else {
	          stream.eatWhile(isOperatorChar);
	          return ret("operator", "operator", stream.current());
	        }
	      } else if (ch == "`") {
	        state.tokenize = tokenQuasi;
	        return tokenQuasi(stream, state);
	      } else if (ch == "#") {
	        stream.skipToEnd();
	        return ret("error", "error");
	      } else if (isOperatorChar.test(ch)) {
	        if (ch != ">" || !state.lexical || state.lexical.type != ">") stream.eatWhile(isOperatorChar);
	        return ret("operator", "operator", stream.current());
	      } else if (wordRE.test(ch)) {
	        stream.eatWhile(wordRE);
	        var word = stream.current(),
	            known = keywords.propertyIsEnumerable(word) && keywords[word];
	        return known && state.lastType != "." ? ret(known.type, known.style, word) : ret("variable", "variable", word);
	      }
	    }
	
	    function tokenString(quote) {
	      return function (stream, state) {
	        var escaped = false,
	            next;
	        if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)) {
	          state.tokenize = tokenBase;
	          return ret("jsonld-keyword", "meta");
	        }
	        while ((next = stream.next()) != null) {
	          if (next == quote && !escaped) break;
	          escaped = !escaped && next == "\\";
	        }
	        if (!escaped) state.tokenize = tokenBase;
	        return ret("string", "string");
	      };
	    }
	
	    function tokenComment(stream, state) {
	      var maybeEnd = false,
	          ch;
	      while (ch = stream.next()) {
	        if (ch == "/" && maybeEnd) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        maybeEnd = ch == "*";
	      }
	      return ret("comment", "comment");
	    }
	
	    function tokenQuasi(stream, state) {
	      var escaped = false,
	          next;
	      while ((next = stream.next()) != null) {
	        if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        escaped = !escaped && next == "\\";
	      }
	      return ret("quasi", "string-2", stream.current());
	    }
	
	    var brackets = "([{}])";
	    // This is a crude lookahead trick to try and notice that we're
	    // parsing the argument patterns for a fat-arrow function before we
	    // actually hit the arrow token. It only works if the arrow is on
	    // the same line as the arguments and there's no strange noise
	    // (comments) in between. Fallback is to only notice when we hit the
	    // arrow, and not declare the arguments as locals for the arrow
	    // body.
	    function findFatArrow(stream, state) {
	      if (state.fatArrowAt) state.fatArrowAt = null;
	      var arrow = stream.string.indexOf("=>", stream.start);
	      if (arrow < 0) return;
	
	      if (isTS) {
	        // Try to skip TypeScript return type declarations after the arguments
	        var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow));
	        if (m) arrow = m.index;
	      }
	
	      var depth = 0,
	          sawSomething = false;
	      for (var pos = arrow - 1; pos >= 0; --pos) {
	        var ch = stream.string.charAt(pos);
	        var bracket = brackets.indexOf(ch);
	        if (bracket >= 0 && bracket < 3) {
	          if (!depth) {
	            ++pos;break;
	          }
	          if (--depth == 0) {
	            if (ch == "(") sawSomething = true;break;
	          }
	        } else if (bracket >= 3 && bracket < 6) {
	          ++depth;
	        } else if (wordRE.test(ch)) {
	          sawSomething = true;
	        } else if (/["'\/]/.test(ch)) {
	          return;
	        } else if (sawSomething && !depth) {
	          ++pos;
	          break;
	        }
	      }
	      if (sawSomething && !depth) state.fatArrowAt = pos;
	    }
	
	    // Parser
	
	    var atomicTypes = { "atom": true, "number": true, "variable": true, "string": true, "regexp": true, "this": true, "jsonld-keyword": true };
	
	    function JSLexical(indented, column, type, align, prev, info) {
	      this.indented = indented;
	      this.column = column;
	      this.type = type;
	      this.prev = prev;
	      this.info = info;
	      if (align != null) this.align = align;
	    }
	
	    function inScope(state, varname) {
	      for (var v = state.localVars; v; v = v.next) {
	        if (v.name == varname) return true;
	      }for (var cx = state.context; cx; cx = cx.prev) {
	        for (var v = cx.vars; v; v = v.next) {
	          if (v.name == varname) return true;
	        }
	      }
	    }
	
	    function parseJS(state, style, type, content, stream) {
	      var cc = state.cc;
	      // Communicate our context to the combinators.
	      // (Less wasteful than consing up a hundred closures on every call.)
	      cx.state = state;cx.stream = stream;cx.marked = null, cx.cc = cc;cx.style = style;
	
	      if (!state.lexical.hasOwnProperty("align")) state.lexical.align = true;
	
	      while (true) {
	        var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
	        if (combinator(type, content)) {
	          while (cc.length && cc[cc.length - 1].lex) {
	            cc.pop()();
	          }if (cx.marked) return cx.marked;
	          if (type == "variable" && inScope(state, content)) return "variable-2";
	          return style;
	        }
	      }
	    }
	
	    // Combinator utils
	
	    var cx = { state: null, column: null, marked: null, cc: null };
	    function pass() {
	      for (var i = arguments.length - 1; i >= 0; i--) {
	        cx.cc.push(arguments[i]);
	      }
	    }
	    function cont() {
	      pass.apply(null, arguments);
	      return true;
	    }
	    function register(varname) {
	      function inList(list) {
	        for (var v = list; v; v = v.next) {
	          if (v.name == varname) return true;
	        }return false;
	      }
	      var state = cx.state;
	      cx.marked = "def";
	      if (state.context) {
	        if (inList(state.localVars)) return;
	        state.localVars = { name: varname, next: state.localVars };
	      } else {
	        if (inList(state.globalVars)) return;
	        if (parserConfig.globalVars) state.globalVars = { name: varname, next: state.globalVars };
	      }
	    }
	
	    // Combinators
	
	    var defaultVars = { name: "this", next: { name: "arguments" } };
	    function pushcontext() {
	      cx.state.context = { prev: cx.state.context, vars: cx.state.localVars };
	      cx.state.localVars = defaultVars;
	    }
	    function popcontext() {
	      cx.state.localVars = cx.state.context.vars;
	      cx.state.context = cx.state.context.prev;
	    }
	    function pushlex(type, info) {
	      var result = function result() {
	        var state = cx.state,
	            indent = state.indented;
	        if (state.lexical.type == "stat") indent = state.lexical.indented;else for (var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev) {
	          indent = outer.indented;
	        }state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
	      };
	      result.lex = true;
	      return result;
	    }
	    function poplex() {
	      var state = cx.state;
	      if (state.lexical.prev) {
	        if (state.lexical.type == ")") state.indented = state.lexical.indented;
	        state.lexical = state.lexical.prev;
	      }
	    }
	    poplex.lex = true;
	
	    function expect(wanted) {
	      function exp(type) {
	        if (type == wanted) return cont();else if (wanted == ";") return pass();else return cont(exp);
	      };
	      return exp;
	    }
	
	    function statement(type, value) {
	      if (type == "var") return cont(pushlex("vardef", value.length), vardef, expect(";"), poplex);
	      if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
	      if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
	      if (type == "{") return cont(pushlex("}"), block, poplex);
	      if (type == ";") return cont();
	      if (type == "if") {
	        if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex) cx.state.cc.pop()();
	        return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
	      }
	      if (type == "function") return cont(functiondef);
	      if (type == "for") return cont(pushlex("form"), forspec, statement, poplex);
	      if (type == "variable") return cont(pushlex("stat"), maybelabel);
	      if (type == "switch") return cont(pushlex("form"), parenExpr, pushlex("}", "switch"), expect("{"), block, poplex, poplex);
	      if (type == "case") return cont(expression, expect(":"));
	      if (type == "default") return cont(expect(":"));
	      if (type == "catch") return cont(pushlex("form"), pushcontext, expect("("), funarg, expect(")"), statement, poplex, popcontext);
	      if (type == "class") return cont(pushlex("form"), className, poplex);
	      if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
	      if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
	      if (type == "module") return cont(pushlex("form"), pattern, pushlex("}"), expect("{"), block, poplex, poplex);
	      if (type == "type") return cont(typeexpr, expect("operator"), typeexpr, expect(";"));
	      if (type == "async") return cont(statement);
	      return pass(pushlex("stat"), expression, expect(";"), poplex);
	    }
	    function expression(type) {
	      return expressionInner(type, false);
	    }
	    function expressionNoComma(type) {
	      return expressionInner(type, true);
	    }
	    function parenExpr(type) {
	      if (type != "(") return pass();
	      return cont(pushlex(")"), expression, expect(")"), poplex);
	    }
	    function expressionInner(type, noComma) {
	      if (cx.state.fatArrowAt == cx.stream.start) {
	        var body = noComma ? arrowBodyNoComma : arrowBody;
	        if (type == "(") return cont(pushcontext, pushlex(")"), commasep(pattern, ")"), poplex, expect("=>"), body, popcontext);else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
	      }
	
	      var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
	      if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
	      if (type == "function") return cont(functiondef, maybeop);
	      if (type == "class") return cont(pushlex("form"), classExpression, poplex);
	      if (type == "keyword c" || type == "async") return cont(noComma ? maybeexpressionNoComma : maybeexpression);
	      if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
	      if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
	      if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
	      if (type == "{") return contCommasep(objprop, "}", null, maybeop);
	      if (type == "quasi") return pass(quasi, maybeop);
	      if (type == "new") return cont(maybeTarget(noComma));
	      return cont();
	    }
	    function maybeexpression(type) {
	      if (type.match(/[;\}\)\],]/)) return pass();
	      return pass(expression);
	    }
	    function maybeexpressionNoComma(type) {
	      if (type.match(/[;\}\)\],]/)) return pass();
	      return pass(expressionNoComma);
	    }
	
	    function maybeoperatorComma(type, value) {
	      if (type == ",") return cont(expression);
	      return maybeoperatorNoComma(type, value, false);
	    }
	    function maybeoperatorNoComma(type, value, noComma) {
	      var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
	      var expr = noComma == false ? expression : expressionNoComma;
	      if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
	      if (type == "operator") {
	        if (/\+\+|--/.test(value)) return cont(me);
	        if (value == "?") return cont(expression, expect(":"), expr);
	        return cont(expr);
	      }
	      if (type == "quasi") {
	        return pass(quasi, me);
	      }
	      if (type == ";") return;
	      if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
	      if (type == ".") return cont(property, me);
	      if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
	    }
	    function quasi(type, value) {
	      if (type != "quasi") return pass();
	      if (value.slice(value.length - 2) != "${") return cont(quasi);
	      return cont(expression, continueQuasi);
	    }
	    function continueQuasi(type) {
	      if (type == "}") {
	        cx.marked = "string-2";
	        cx.state.tokenize = tokenQuasi;
	        return cont(quasi);
	      }
	    }
	    function arrowBody(type) {
	      findFatArrow(cx.stream, cx.state);
	      return pass(type == "{" ? statement : expression);
	    }
	    function arrowBodyNoComma(type) {
	      findFatArrow(cx.stream, cx.state);
	      return pass(type == "{" ? statement : expressionNoComma);
	    }
	    function maybeTarget(noComma) {
	      return function (type) {
	        if (type == ".") return cont(noComma ? targetNoComma : target);else return pass(noComma ? expressionNoComma : expression);
	      };
	    }
	    function target(_, value) {
	      if (value == "target") {
	        cx.marked = "keyword";return cont(maybeoperatorComma);
	      }
	    }
	    function targetNoComma(_, value) {
	      if (value == "target") {
	        cx.marked = "keyword";return cont(maybeoperatorNoComma);
	      }
	    }
	    function maybelabel(type) {
	      if (type == ":") return cont(poplex, statement);
	      return pass(maybeoperatorComma, expect(";"), poplex);
	    }
	    function property(type) {
	      if (type == "variable") {
	        cx.marked = "property";return cont();
	      }
	    }
	    function objprop(type, value) {
	      if (type == "async") {
	        cx.marked = "property";
	        return cont(objprop);
	      } else if (type == "variable" || cx.style == "keyword") {
	        cx.marked = "property";
	        if (value == "get" || value == "set") return cont(getterSetter);
	        return cont(afterprop);
	      } else if (type == "number" || type == "string") {
	        cx.marked = jsonldMode ? "property" : cx.style + " property";
	        return cont(afterprop);
	      } else if (type == "jsonld-keyword") {
	        return cont(afterprop);
	      } else if (type == "modifier") {
	        return cont(objprop);
	      } else if (type == "[") {
	        return cont(expression, expect("]"), afterprop);
	      } else if (type == "spread") {
	        return cont(expression);
	      } else if (type == ":") {
	        return pass(afterprop);
	      }
	    }
	    function getterSetter(type) {
	      if (type != "variable") return pass(afterprop);
	      cx.marked = "property";
	      return cont(functiondef);
	    }
	    function afterprop(type) {
	      if (type == ":") return cont(expressionNoComma);
	      if (type == "(") return pass(functiondef);
	    }
	    function commasep(what, end) {
	      function proceed(type, value) {
	        if (type == ",") {
	          var lex = cx.state.lexical;
	          if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
	          return cont(function (type, value) {
	            if (type == end || value == end) return pass();
	            return pass(what);
	          }, proceed);
	        }
	        if (type == end || value == end) return cont();
	        return cont(expect(end));
	      }
	      return function (type, value) {
	        if (type == end || value == end) return cont();
	        return pass(what, proceed);
	      };
	    }
	    function contCommasep(what, end, info) {
	      for (var i = 3; i < arguments.length; i++) {
	        cx.cc.push(arguments[i]);
	      }return cont(pushlex(end, info), commasep(what, end), poplex);
	    }
	    function block(type) {
	      if (type == "}") return cont();
	      return pass(statement, block);
	    }
	    function maybetype(type, value) {
	      if (isTS) {
	        if (type == ":") return cont(typeexpr);
	        if (value == "?") return cont(maybetype);
	      }
	    }
	    function typeexpr(type) {
	      if (type == "variable") {
	        cx.marked = "variable-3";return cont(afterType);
	      }
	      if (type == "string" || type == "number" || type == "atom") return cont(afterType);
	      if (type == "{") return cont(commasep(typeprop, "}"));
	      if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType);
	    }
	    function maybeReturnType(type) {
	      if (type == "=>") return cont(typeexpr);
	    }
	    function typeprop(type) {
	      if (type == "variable" || cx.style == "keyword") {
	        cx.marked = "property";
	        return cont(typeprop);
	      } else if (type == ":") {
	        return cont(typeexpr);
	      }
	    }
	    function typearg(type) {
	      if (type == "variable") return cont(typearg);else if (type == ":") return cont(typeexpr);
	    }
	    function afterType(type, value) {
	      if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
	      if (value == "|" || type == ".") return cont(typeexpr);
	      if (type == "[") return cont(expect("]"), afterType);
	    }
	    function vardef() {
	      return pass(pattern, maybetype, maybeAssign, vardefCont);
	    }
	    function pattern(type, value) {
	      if (type == "modifier") return cont(pattern);
	      if (type == "variable") {
	        register(value);return cont();
	      }
	      if (type == "spread") return cont(pattern);
	      if (type == "[") return contCommasep(pattern, "]");
	      if (type == "{") return contCommasep(proppattern, "}");
	    }
	    function proppattern(type, value) {
	      if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
	        register(value);
	        return cont(maybeAssign);
	      }
	      if (type == "variable") cx.marked = "property";
	      if (type == "spread") return cont(pattern);
	      if (type == "}") return pass();
	      return cont(expect(":"), pattern, maybeAssign);
	    }
	    function maybeAssign(_type, value) {
	      if (value == "=") return cont(expressionNoComma);
	    }
	    function vardefCont(type) {
	      if (type == ",") return cont(vardef);
	    }
	    function maybeelse(type, value) {
	      if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
	    }
	    function forspec(type) {
	      if (type == "(") return cont(pushlex(")"), forspec1, expect(")"), poplex);
	    }
	    function forspec1(type) {
	      if (type == "var") return cont(vardef, expect(";"), forspec2);
	      if (type == ";") return cont(forspec2);
	      if (type == "variable") return cont(formaybeinof);
	      return pass(expression, expect(";"), forspec2);
	    }
	    function formaybeinof(_type, value) {
	      if (value == "in" || value == "of") {
	        cx.marked = "keyword";return cont(expression);
	      }
	      return cont(maybeoperatorComma, forspec2);
	    }
	    function forspec2(type, value) {
	      if (type == ";") return cont(forspec3);
	      if (value == "in" || value == "of") {
	        cx.marked = "keyword";return cont(expression);
	      }
	      return pass(expression, expect(";"), forspec3);
	    }
	    function forspec3(type) {
	      if (type != ")") cont(expression);
	    }
	    function functiondef(type, value) {
	      if (value == "*") {
	        cx.marked = "keyword";return cont(functiondef);
	      }
	      if (type == "variable") {
	        register(value);return cont(functiondef);
	      }
	      if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, maybetype, statement, popcontext);
	    }
	    function funarg(type) {
	      if (type == "spread") return cont(funarg);
	      return pass(pattern, maybetype, maybeAssign);
	    }
	    function classExpression(type, value) {
	      // Class expressions may have an optional name.
	      if (type == "variable") return className(type, value);
	      return classNameAfter(type, value);
	    }
	    function className(type, value) {
	      if (type == "variable") {
	        register(value);return cont(classNameAfter);
	      }
	    }
	    function classNameAfter(type, value) {
	      if (value == "extends" || value == "implements") return cont(isTS ? typeexpr : expression, classNameAfter);
	      if (type == "{") return cont(pushlex("}"), classBody, poplex);
	    }
	    function classBody(type, value) {
	      if (type == "variable" || cx.style == "keyword") {
	        if ((value == "static" || value == "get" || value == "set" || isTS && (value == "public" || value == "private" || value == "protected" || value == "readonly" || value == "abstract")) && cx.stream.match(/^\s+[\w$\xa1-\uffff]/, false)) {
	          cx.marked = "keyword";
	          return cont(classBody);
	        }
	        cx.marked = "property";
	        return cont(isTS ? classfield : functiondef, classBody);
	      }
	      if (value == "*") {
	        cx.marked = "keyword";
	        return cont(classBody);
	      }
	      if (type == ";") return cont(classBody);
	      if (type == "}") return cont();
	    }
	    function classfield(type, value) {
	      if (value == "?") return cont(classfield);
	      if (type == ":") return cont(typeexpr, maybeAssign);
	      return pass(functiondef);
	    }
	    function afterExport(type, value) {
	      if (value == "*") {
	        cx.marked = "keyword";return cont(maybeFrom, expect(";"));
	      }
	      if (value == "default") {
	        cx.marked = "keyword";return cont(expression, expect(";"));
	      }
	      if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
	      return pass(statement);
	    }
	    function exportField(type, value) {
	      if (value == "as") {
	        cx.marked = "keyword";return cont(expect("variable"));
	      }
	      if (type == "variable") return pass(expressionNoComma, exportField);
	    }
	    function afterImport(type) {
	      if (type == "string") return cont();
	      return pass(importSpec, maybeMoreImports, maybeFrom);
	    }
	    function importSpec(type, value) {
	      if (type == "{") return contCommasep(importSpec, "}");
	      if (type == "variable") register(value);
	      if (value == "*") cx.marked = "keyword";
	      return cont(maybeAs);
	    }
	    function maybeMoreImports(type) {
	      if (type == ",") return cont(importSpec, maybeMoreImports);
	    }
	    function maybeAs(_type, value) {
	      if (value == "as") {
	        cx.marked = "keyword";return cont(importSpec);
	      }
	    }
	    function maybeFrom(_type, value) {
	      if (value == "from") {
	        cx.marked = "keyword";return cont(expression);
	      }
	    }
	    function arrayLiteral(type) {
	      if (type == "]") return cont();
	      return pass(commasep(expressionNoComma, "]"));
	    }
	
	    function isContinuedStatement(state, textAfter) {
	      return state.lastType == "operator" || state.lastType == "," || isOperatorChar.test(textAfter.charAt(0)) || /[,.]/.test(textAfter.charAt(0));
	    }
	
	    // Interface
	
	    return {
	      startState: function startState(basecolumn) {
	        var state = {
	          tokenize: tokenBase,
	          lastType: "sof",
	          cc: [],
	          lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
	          localVars: parserConfig.localVars,
	          context: parserConfig.localVars && { vars: parserConfig.localVars },
	          indented: basecolumn || 0
	        };
	        if (parserConfig.globalVars && _typeof(parserConfig.globalVars) == "object") state.globalVars = parserConfig.globalVars;
	        return state;
	      },
	
	      token: function token(stream, state) {
	        if (stream.sol()) {
	          if (!state.lexical.hasOwnProperty("align")) state.lexical.align = false;
	          state.indented = stream.indentation();
	          findFatArrow(stream, state);
	        }
	        if (state.tokenize != tokenComment && stream.eatSpace()) return null;
	        var style = state.tokenize(stream, state);
	        if (type == "comment") return style;
	        state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
	        return parseJS(state, style, type, content, stream);
	      },
	
	      indent: function indent(state, textAfter) {
	        if (state.tokenize == tokenComment) return CodeMirror.Pass;
	        if (state.tokenize != tokenBase) return 0;
	        var firstChar = textAfter && textAfter.charAt(0),
	            lexical = state.lexical,
	            top;
	        // Kludge to prevent 'maybelse' from blocking lexical scope pops
	        if (!/^\s*else\b/.test(textAfter)) for (var i = state.cc.length - 1; i >= 0; --i) {
	          var c = state.cc[i];
	          if (c == poplex) lexical = lexical.prev;else if (c != maybeelse) break;
	        }
	        while ((lexical.type == "stat" || lexical.type == "form") && (firstChar == "}" || (top = state.cc[state.cc.length - 1]) && (top == maybeoperatorComma || top == maybeoperatorNoComma) && !/^[,\.=+\-*:?[\(]/.test(textAfter))) {
	          lexical = lexical.prev;
	        }if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat") lexical = lexical.prev;
	        var type = lexical.type,
	            closing = firstChar == type;
	
	        if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info + 1 : 0);else if (type == "form" && firstChar == "{") return lexical.indented;else if (type == "form") return lexical.indented + indentUnit;else if (type == "stat") return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false) return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);else if (lexical.align) return lexical.column + (closing ? 0 : 1);else return lexical.indented + (closing ? 0 : indentUnit);
	      },
	
	      electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
	      blockCommentStart: jsonMode ? null : "/*",
	      blockCommentEnd: jsonMode ? null : "*/",
	      lineComment: jsonMode ? null : "//",
	      fold: "brace",
	      closeBrackets: "()[]{}''\"\"``",
	
	      helperType: jsonMode ? "json" : "javascript",
	      jsonldMode: jsonldMode,
	      jsonMode: jsonMode,
	
	      expressionAllowed: expressionAllowed,
	      skipExpression: function skipExpression(state) {
	        var top = state.cc[state.cc.length - 1];
	        if (top == expression || top == expressionNoComma) state.cc.pop();
	      }
	    };
	  });
	
	  CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);
	
	  CodeMirror.defineMIME("text/javascript", "javascript");
	  CodeMirror.defineMIME("text/ecmascript", "javascript");
	  CodeMirror.defineMIME("application/javascript", "javascript");
	  CodeMirror.defineMIME("application/x-javascript", "javascript");
	  CodeMirror.defineMIME("application/ecmascript", "javascript");
	  CodeMirror.defineMIME("application/json", { name: "javascript", json: true });
	  CodeMirror.defineMIME("application/x-json", { name: "javascript", json: true });
	  CodeMirror.defineMIME("application/ld+json", { name: "javascript", jsonld: true });
	  CodeMirror.defineMIME("text/typescript", { name: "javascript", typescript: true });
	  CodeMirror.defineMIME("application/typescript", { name: "javascript", typescript: true });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var require;var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, setImmediate, global, module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
	 * @version   2.3.0
	 */
	
	(function () {
	  "use strict";
	
	  function lib$es6$promise$utils$$objectOrFunction(x) {
	    return typeof x === 'function' || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null;
	  }
	
	  function lib$es6$promise$utils$$isFunction(x) {
	    return typeof x === 'function';
	  }
	
	  function lib$es6$promise$utils$$isMaybeThenable(x) {
	    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null;
	  }
	
	  var lib$es6$promise$utils$$_isArray;
	  if (!Array.isArray) {
	    lib$es6$promise$utils$$_isArray = function lib$es6$promise$utils$$_isArray(x) {
	      return Object.prototype.toString.call(x) === '[object Array]';
	    };
	  } else {
	    lib$es6$promise$utils$$_isArray = Array.isArray;
	  }
	
	  var lib$es6$promise$utils$$isArray = lib$es6$promise$utils$$_isArray;
	  var lib$es6$promise$asap$$len = 0;
	  var lib$es6$promise$asap$$toString = {}.toString;
	  var lib$es6$promise$asap$$vertxNext;
	  var lib$es6$promise$asap$$customSchedulerFn;
	
	  var lib$es6$promise$asap$$asap = function asap(callback, arg) {
	    lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len] = callback;
	    lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len + 1] = arg;
	    lib$es6$promise$asap$$len += 2;
	    if (lib$es6$promise$asap$$len === 2) {
	      // If len is 2, that means that we need to schedule an async flush.
	      // If additional callbacks are queued before the queue is flushed, they
	      // will be processed by this flush that we are scheduling.
	      if (lib$es6$promise$asap$$customSchedulerFn) {
	        lib$es6$promise$asap$$customSchedulerFn(lib$es6$promise$asap$$flush);
	      } else {
	        lib$es6$promise$asap$$scheduleFlush();
	      }
	    }
	  };
	
	  function lib$es6$promise$asap$$setScheduler(scheduleFn) {
	    lib$es6$promise$asap$$customSchedulerFn = scheduleFn;
	  }
	
	  function lib$es6$promise$asap$$setAsap(asapFn) {
	    lib$es6$promise$asap$$asap = asapFn;
	  }
	
	  var lib$es6$promise$asap$$browserWindow = typeof window !== 'undefined' ? window : undefined;
	  var lib$es6$promise$asap$$browserGlobal = lib$es6$promise$asap$$browserWindow || {};
	  var lib$es6$promise$asap$$BrowserMutationObserver = lib$es6$promise$asap$$browserGlobal.MutationObserver || lib$es6$promise$asap$$browserGlobal.WebKitMutationObserver;
	  var lib$es6$promise$asap$$isNode = typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	  // test for web worker but not in IE10
	  var lib$es6$promise$asap$$isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	  // node
	  function lib$es6$promise$asap$$useNextTick() {
	    var nextTick = process.nextTick;
	    // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	    // setImmediate should be used instead instead
	    var version = process.versions.node.match(/^(?:(\d+)\.)?(?:(\d+)\.)?(\*|\d+)$/);
	    if (Array.isArray(version) && version[1] === '0' && version[2] === '10') {
	      nextTick = setImmediate;
	    }
	    return function () {
	      nextTick(lib$es6$promise$asap$$flush);
	    };
	  }
	
	  // vertx
	  function lib$es6$promise$asap$$useVertxTimer() {
	    return function () {
	      lib$es6$promise$asap$$vertxNext(lib$es6$promise$asap$$flush);
	    };
	  }
	
	  function lib$es6$promise$asap$$useMutationObserver() {
	    var iterations = 0;
	    var observer = new lib$es6$promise$asap$$BrowserMutationObserver(lib$es6$promise$asap$$flush);
	    var node = document.createTextNode('');
	    observer.observe(node, { characterData: true });
	
	    return function () {
	      node.data = iterations = ++iterations % 2;
	    };
	  }
	
	  // web worker
	  function lib$es6$promise$asap$$useMessageChannel() {
	    var channel = new MessageChannel();
	    channel.port1.onmessage = lib$es6$promise$asap$$flush;
	    return function () {
	      channel.port2.postMessage(0);
	    };
	  }
	
	  function lib$es6$promise$asap$$useSetTimeout() {
	    return function () {
	      setTimeout(lib$es6$promise$asap$$flush, 1);
	    };
	  }
	
	  var lib$es6$promise$asap$$queue = new Array(1000);
	  function lib$es6$promise$asap$$flush() {
	    for (var i = 0; i < lib$es6$promise$asap$$len; i += 2) {
	      var callback = lib$es6$promise$asap$$queue[i];
	      var arg = lib$es6$promise$asap$$queue[i + 1];
	
	      callback(arg);
	
	      lib$es6$promise$asap$$queue[i] = undefined;
	      lib$es6$promise$asap$$queue[i + 1] = undefined;
	    }
	
	    lib$es6$promise$asap$$len = 0;
	  }
	
	  function lib$es6$promise$asap$$attemptVertex() {
	    try {
	      var r = require;
	      var vertx = __webpack_require__(364);
	      lib$es6$promise$asap$$vertxNext = vertx.runOnLoop || vertx.runOnContext;
	      return lib$es6$promise$asap$$useVertxTimer();
	    } catch (e) {
	      return lib$es6$promise$asap$$useSetTimeout();
	    }
	  }
	
	  var lib$es6$promise$asap$$scheduleFlush;
	  // Decide what async method to use to triggering processing of queued callbacks:
	  if (lib$es6$promise$asap$$isNode) {
	    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useNextTick();
	  } else if (lib$es6$promise$asap$$BrowserMutationObserver) {
	    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMutationObserver();
	  } else if (lib$es6$promise$asap$$isWorker) {
	    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMessageChannel();
	  } else if (lib$es6$promise$asap$$browserWindow === undefined && "function" === 'function') {
	    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$attemptVertex();
	  } else {
	    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useSetTimeout();
	  }
	
	  function lib$es6$promise$$internal$$noop() {}
	
	  var lib$es6$promise$$internal$$PENDING = void 0;
	  var lib$es6$promise$$internal$$FULFILLED = 1;
	  var lib$es6$promise$$internal$$REJECTED = 2;
	
	  var lib$es6$promise$$internal$$GET_THEN_ERROR = new lib$es6$promise$$internal$$ErrorObject();
	
	  function lib$es6$promise$$internal$$selfFullfillment() {
	    return new TypeError("You cannot resolve a promise with itself");
	  }
	
	  function lib$es6$promise$$internal$$cannotReturnOwn() {
	    return new TypeError('A promises callback cannot return that same promise.');
	  }
	
	  function lib$es6$promise$$internal$$getThen(promise) {
	    try {
	      return promise.then;
	    } catch (error) {
	      lib$es6$promise$$internal$$GET_THEN_ERROR.error = error;
	      return lib$es6$promise$$internal$$GET_THEN_ERROR;
	    }
	  }
	
	  function lib$es6$promise$$internal$$tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	    try {
	      then.call(value, fulfillmentHandler, rejectionHandler);
	    } catch (e) {
	      return e;
	    }
	  }
	
	  function lib$es6$promise$$internal$$handleForeignThenable(promise, thenable, then) {
	    lib$es6$promise$asap$$asap(function (promise) {
	      var sealed = false;
	      var error = lib$es6$promise$$internal$$tryThen(then, thenable, function (value) {
	        if (sealed) {
	          return;
	        }
	        sealed = true;
	        if (thenable !== value) {
	          lib$es6$promise$$internal$$resolve(promise, value);
	        } else {
	          lib$es6$promise$$internal$$fulfill(promise, value);
	        }
	      }, function (reason) {
	        if (sealed) {
	          return;
	        }
	        sealed = true;
	
	        lib$es6$promise$$internal$$reject(promise, reason);
	      }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	      if (!sealed && error) {
	        sealed = true;
	        lib$es6$promise$$internal$$reject(promise, error);
	      }
	    }, promise);
	  }
	
	  function lib$es6$promise$$internal$$handleOwnThenable(promise, thenable) {
	    if (thenable._state === lib$es6$promise$$internal$$FULFILLED) {
	      lib$es6$promise$$internal$$fulfill(promise, thenable._result);
	    } else if (thenable._state === lib$es6$promise$$internal$$REJECTED) {
	      lib$es6$promise$$internal$$reject(promise, thenable._result);
	    } else {
	      lib$es6$promise$$internal$$subscribe(thenable, undefined, function (value) {
	        lib$es6$promise$$internal$$resolve(promise, value);
	      }, function (reason) {
	        lib$es6$promise$$internal$$reject(promise, reason);
	      });
	    }
	  }
	
	  function lib$es6$promise$$internal$$handleMaybeThenable(promise, maybeThenable) {
	    if (maybeThenable.constructor === promise.constructor) {
	      lib$es6$promise$$internal$$handleOwnThenable(promise, maybeThenable);
	    } else {
	      var then = lib$es6$promise$$internal$$getThen(maybeThenable);
	
	      if (then === lib$es6$promise$$internal$$GET_THEN_ERROR) {
	        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$GET_THEN_ERROR.error);
	      } else if (then === undefined) {
	        lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	      } else if (lib$es6$promise$utils$$isFunction(then)) {
	        lib$es6$promise$$internal$$handleForeignThenable(promise, maybeThenable, then);
	      } else {
	        lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	      }
	    }
	  }
	
	  function lib$es6$promise$$internal$$resolve(promise, value) {
	    if (promise === value) {
	      lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$selfFullfillment());
	    } else if (lib$es6$promise$utils$$objectOrFunction(value)) {
	      lib$es6$promise$$internal$$handleMaybeThenable(promise, value);
	    } else {
	      lib$es6$promise$$internal$$fulfill(promise, value);
	    }
	  }
	
	  function lib$es6$promise$$internal$$publishRejection(promise) {
	    if (promise._onerror) {
	      promise._onerror(promise._result);
	    }
	
	    lib$es6$promise$$internal$$publish(promise);
	  }
	
	  function lib$es6$promise$$internal$$fulfill(promise, value) {
	    if (promise._state !== lib$es6$promise$$internal$$PENDING) {
	      return;
	    }
	
	    promise._result = value;
	    promise._state = lib$es6$promise$$internal$$FULFILLED;
	
	    if (promise._subscribers.length !== 0) {
	      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, promise);
	    }
	  }
	
	  function lib$es6$promise$$internal$$reject(promise, reason) {
	    if (promise._state !== lib$es6$promise$$internal$$PENDING) {
	      return;
	    }
	    promise._state = lib$es6$promise$$internal$$REJECTED;
	    promise._result = reason;
	
	    lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publishRejection, promise);
	  }
	
	  function lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection) {
	    var subscribers = parent._subscribers;
	    var length = subscribers.length;
	
	    parent._onerror = null;
	
	    subscribers[length] = child;
	    subscribers[length + lib$es6$promise$$internal$$FULFILLED] = onFulfillment;
	    subscribers[length + lib$es6$promise$$internal$$REJECTED] = onRejection;
	
	    if (length === 0 && parent._state) {
	      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, parent);
	    }
	  }
	
	  function lib$es6$promise$$internal$$publish(promise) {
	    var subscribers = promise._subscribers;
	    var settled = promise._state;
	
	    if (subscribers.length === 0) {
	      return;
	    }
	
	    var child,
	        callback,
	        detail = promise._result;
	
	    for (var i = 0; i < subscribers.length; i += 3) {
	      child = subscribers[i];
	      callback = subscribers[i + settled];
	
	      if (child) {
	        lib$es6$promise$$internal$$invokeCallback(settled, child, callback, detail);
	      } else {
	        callback(detail);
	      }
	    }
	
	    promise._subscribers.length = 0;
	  }
	
	  function lib$es6$promise$$internal$$ErrorObject() {
	    this.error = null;
	  }
	
	  var lib$es6$promise$$internal$$TRY_CATCH_ERROR = new lib$es6$promise$$internal$$ErrorObject();
	
	  function lib$es6$promise$$internal$$tryCatch(callback, detail) {
	    try {
	      return callback(detail);
	    } catch (e) {
	      lib$es6$promise$$internal$$TRY_CATCH_ERROR.error = e;
	      return lib$es6$promise$$internal$$TRY_CATCH_ERROR;
	    }
	  }
	
	  function lib$es6$promise$$internal$$invokeCallback(settled, promise, callback, detail) {
	    var hasCallback = lib$es6$promise$utils$$isFunction(callback),
	        value,
	        error,
	        succeeded,
	        failed;
	
	    if (hasCallback) {
	      value = lib$es6$promise$$internal$$tryCatch(callback, detail);
	
	      if (value === lib$es6$promise$$internal$$TRY_CATCH_ERROR) {
	        failed = true;
	        error = value.error;
	        value = null;
	      } else {
	        succeeded = true;
	      }
	
	      if (promise === value) {
	        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$cannotReturnOwn());
	        return;
	      }
	    } else {
	      value = detail;
	      succeeded = true;
	    }
	
	    if (promise._state !== lib$es6$promise$$internal$$PENDING) {
	      // noop
	    } else if (hasCallback && succeeded) {
	      lib$es6$promise$$internal$$resolve(promise, value);
	    } else if (failed) {
	      lib$es6$promise$$internal$$reject(promise, error);
	    } else if (settled === lib$es6$promise$$internal$$FULFILLED) {
	      lib$es6$promise$$internal$$fulfill(promise, value);
	    } else if (settled === lib$es6$promise$$internal$$REJECTED) {
	      lib$es6$promise$$internal$$reject(promise, value);
	    }
	  }
	
	  function lib$es6$promise$$internal$$initializePromise(promise, resolver) {
	    try {
	      resolver(function resolvePromise(value) {
	        lib$es6$promise$$internal$$resolve(promise, value);
	      }, function rejectPromise(reason) {
	        lib$es6$promise$$internal$$reject(promise, reason);
	      });
	    } catch (e) {
	      lib$es6$promise$$internal$$reject(promise, e);
	    }
	  }
	
	  function lib$es6$promise$enumerator$$Enumerator(Constructor, input) {
	    var enumerator = this;
	
	    enumerator._instanceConstructor = Constructor;
	    enumerator.promise = new Constructor(lib$es6$promise$$internal$$noop);
	
	    if (enumerator._validateInput(input)) {
	      enumerator._input = input;
	      enumerator.length = input.length;
	      enumerator._remaining = input.length;
	
	      enumerator._init();
	
	      if (enumerator.length === 0) {
	        lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
	      } else {
	        enumerator.length = enumerator.length || 0;
	        enumerator._enumerate();
	        if (enumerator._remaining === 0) {
	          lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
	        }
	      }
	    } else {
	      lib$es6$promise$$internal$$reject(enumerator.promise, enumerator._validationError());
	    }
	  }
	
	  lib$es6$promise$enumerator$$Enumerator.prototype._validateInput = function (input) {
	    return lib$es6$promise$utils$$isArray(input);
	  };
	
	  lib$es6$promise$enumerator$$Enumerator.prototype._validationError = function () {
	    return new Error('Array Methods must be provided an Array');
	  };
	
	  lib$es6$promise$enumerator$$Enumerator.prototype._init = function () {
	    this._result = new Array(this.length);
	  };
	
	  var lib$es6$promise$enumerator$$default = lib$es6$promise$enumerator$$Enumerator;
	
	  lib$es6$promise$enumerator$$Enumerator.prototype._enumerate = function () {
	    var enumerator = this;
	
	    var length = enumerator.length;
	    var promise = enumerator.promise;
	    var input = enumerator._input;
	
	    for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
	      enumerator._eachEntry(input[i], i);
	    }
	  };
	
	  lib$es6$promise$enumerator$$Enumerator.prototype._eachEntry = function (entry, i) {
	    var enumerator = this;
	    var c = enumerator._instanceConstructor;
	
	    if (lib$es6$promise$utils$$isMaybeThenable(entry)) {
	      if (entry.constructor === c && entry._state !== lib$es6$promise$$internal$$PENDING) {
	        entry._onerror = null;
	        enumerator._settledAt(entry._state, i, entry._result);
	      } else {
	        enumerator._willSettleAt(c.resolve(entry), i);
	      }
	    } else {
	      enumerator._remaining--;
	      enumerator._result[i] = entry;
	    }
	  };
	
	  lib$es6$promise$enumerator$$Enumerator.prototype._settledAt = function (state, i, value) {
	    var enumerator = this;
	    var promise = enumerator.promise;
	
	    if (promise._state === lib$es6$promise$$internal$$PENDING) {
	      enumerator._remaining--;
	
	      if (state === lib$es6$promise$$internal$$REJECTED) {
	        lib$es6$promise$$internal$$reject(promise, value);
	      } else {
	        enumerator._result[i] = value;
	      }
	    }
	
	    if (enumerator._remaining === 0) {
	      lib$es6$promise$$internal$$fulfill(promise, enumerator._result);
	    }
	  };
	
	  lib$es6$promise$enumerator$$Enumerator.prototype._willSettleAt = function (promise, i) {
	    var enumerator = this;
	
	    lib$es6$promise$$internal$$subscribe(promise, undefined, function (value) {
	      enumerator._settledAt(lib$es6$promise$$internal$$FULFILLED, i, value);
	    }, function (reason) {
	      enumerator._settledAt(lib$es6$promise$$internal$$REJECTED, i, reason);
	    });
	  };
	  function lib$es6$promise$promise$all$$all(entries) {
	    return new lib$es6$promise$enumerator$$default(this, entries).promise;
	  }
	  var lib$es6$promise$promise$all$$default = lib$es6$promise$promise$all$$all;
	  function lib$es6$promise$promise$race$$race(entries) {
	    /*jshint validthis:true */
	    var Constructor = this;
	
	    var promise = new Constructor(lib$es6$promise$$internal$$noop);
	
	    if (!lib$es6$promise$utils$$isArray(entries)) {
	      lib$es6$promise$$internal$$reject(promise, new TypeError('You must pass an array to race.'));
	      return promise;
	    }
	
	    var length = entries.length;
	
	    function onFulfillment(value) {
	      lib$es6$promise$$internal$$resolve(promise, value);
	    }
	
	    function onRejection(reason) {
	      lib$es6$promise$$internal$$reject(promise, reason);
	    }
	
	    for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
	      lib$es6$promise$$internal$$subscribe(Constructor.resolve(entries[i]), undefined, onFulfillment, onRejection);
	    }
	
	    return promise;
	  }
	  var lib$es6$promise$promise$race$$default = lib$es6$promise$promise$race$$race;
	  function lib$es6$promise$promise$resolve$$resolve(object) {
	    /*jshint validthis:true */
	    var Constructor = this;
	
	    if (object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object.constructor === Constructor) {
	      return object;
	    }
	
	    var promise = new Constructor(lib$es6$promise$$internal$$noop);
	    lib$es6$promise$$internal$$resolve(promise, object);
	    return promise;
	  }
	  var lib$es6$promise$promise$resolve$$default = lib$es6$promise$promise$resolve$$resolve;
	  function lib$es6$promise$promise$reject$$reject(reason) {
	    /*jshint validthis:true */
	    var Constructor = this;
	    var promise = new Constructor(lib$es6$promise$$internal$$noop);
	    lib$es6$promise$$internal$$reject(promise, reason);
	    return promise;
	  }
	  var lib$es6$promise$promise$reject$$default = lib$es6$promise$promise$reject$$reject;
	
	  var lib$es6$promise$promise$$counter = 0;
	
	  function lib$es6$promise$promise$$needsResolver() {
	    throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	  }
	
	  function lib$es6$promise$promise$$needsNew() {
	    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	  }
	
	  var lib$es6$promise$promise$$default = lib$es6$promise$promise$$Promise;
	  /**
	    Promise objects represent the eventual result of an asynchronous operation. The
	    primary way of interacting with a promise is through its `then` method, which
	    registers callbacks to receive either a promise's eventual value or the reason
	    why the promise cannot be fulfilled.
	     Terminology
	    -----------
	     - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	    - `thenable` is an object or function that defines a `then` method.
	    - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	    - `exception` is a value that is thrown using the throw statement.
	    - `reason` is a value that indicates why a promise was rejected.
	    - `settled` the final resting state of a promise, fulfilled or rejected.
	     A promise can be in one of three states: pending, fulfilled, or rejected.
	     Promises that are fulfilled have a fulfillment value and are in the fulfilled
	    state.  Promises that are rejected have a rejection reason and are in the
	    rejected state.  A fulfillment value is never a thenable.
	     Promises can also be said to *resolve* a value.  If this value is also a
	    promise, then the original promise's settled state will match the value's
	    settled state.  So a promise that *resolves* a promise that rejects will
	    itself reject, and a promise that *resolves* a promise that fulfills will
	    itself fulfill.
	      Basic Usage:
	    ------------
	     ```js
	    var promise = new Promise(function(resolve, reject) {
	      // on success
	      resolve(value);
	       // on failure
	      reject(reason);
	    });
	     promise.then(function(value) {
	      // on fulfillment
	    }, function(reason) {
	      // on rejection
	    });
	    ```
	     Advanced Usage:
	    ---------------
	     Promises shine when abstracting away asynchronous interactions such as
	    `XMLHttpRequest`s.
	     ```js
	    function getJSON(url) {
	      return new Promise(function(resolve, reject){
	        var xhr = new XMLHttpRequest();
	         xhr.open('GET', url);
	        xhr.onreadystatechange = handler;
	        xhr.responseType = 'json';
	        xhr.setRequestHeader('Accept', 'application/json');
	        xhr.send();
	         function handler() {
	          if (this.readyState === this.DONE) {
	            if (this.status === 200) {
	              resolve(this.response);
	            } else {
	              reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	            }
	          }
	        };
	      });
	    }
	     getJSON('/posts.json').then(function(json) {
	      // on fulfillment
	    }, function(reason) {
	      // on rejection
	    });
	    ```
	     Unlike callbacks, promises are great composable primitives.
	     ```js
	    Promise.all([
	      getJSON('/posts'),
	      getJSON('/comments')
	    ]).then(function(values){
	      values[0] // => postsJSON
	      values[1] // => commentsJSON
	       return values;
	    });
	    ```
	     @class Promise
	    @param {function} resolver
	    Useful for tooling.
	    @constructor
	  */
	  function lib$es6$promise$promise$$Promise(resolver) {
	    this._id = lib$es6$promise$promise$$counter++;
	    this._state = undefined;
	    this._result = undefined;
	    this._subscribers = [];
	
	    if (lib$es6$promise$$internal$$noop !== resolver) {
	      if (!lib$es6$promise$utils$$isFunction(resolver)) {
	        lib$es6$promise$promise$$needsResolver();
	      }
	
	      if (!(this instanceof lib$es6$promise$promise$$Promise)) {
	        lib$es6$promise$promise$$needsNew();
	      }
	
	      lib$es6$promise$$internal$$initializePromise(this, resolver);
	    }
	  }
	
	  lib$es6$promise$promise$$Promise.all = lib$es6$promise$promise$all$$default;
	  lib$es6$promise$promise$$Promise.race = lib$es6$promise$promise$race$$default;
	  lib$es6$promise$promise$$Promise.resolve = lib$es6$promise$promise$resolve$$default;
	  lib$es6$promise$promise$$Promise.reject = lib$es6$promise$promise$reject$$default;
	  lib$es6$promise$promise$$Promise._setScheduler = lib$es6$promise$asap$$setScheduler;
	  lib$es6$promise$promise$$Promise._setAsap = lib$es6$promise$asap$$setAsap;
	  lib$es6$promise$promise$$Promise._asap = lib$es6$promise$asap$$asap;
	
	  lib$es6$promise$promise$$Promise.prototype = {
	    constructor: lib$es6$promise$promise$$Promise,
	
	    /**
	      The primary way of interacting with a promise is through its `then` method,
	      which registers callbacks to receive either a promise's eventual value or the
	      reason why the promise cannot be fulfilled.
	       ```js
	      findUser().then(function(user){
	        // user is available
	      }, function(reason){
	        // user is unavailable, and you are given the reason why
	      });
	      ```
	       Chaining
	      --------
	       The return value of `then` is itself a promise.  This second, 'downstream'
	      promise is resolved with the return value of the first promise's fulfillment
	      or rejection handler, or rejected if the handler throws an exception.
	       ```js
	      findUser().then(function (user) {
	        return user.name;
	      }, function (reason) {
	        return 'default name';
	      }).then(function (userName) {
	        // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	        // will be `'default name'`
	      });
	       findUser().then(function (user) {
	        throw new Error('Found user, but still unhappy');
	      }, function (reason) {
	        throw new Error('`findUser` rejected and we're unhappy');
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	        // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	      });
	      ```
	      If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	       ```js
	      findUser().then(function (user) {
	        throw new PedagogicalException('Upstream error');
	      }).then(function (value) {
	        // never reached
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // The `PedgagocialException` is propagated all the way down to here
	      });
	      ```
	       Assimilation
	      ------------
	       Sometimes the value you want to propagate to a downstream promise can only be
	      retrieved asynchronously. This can be achieved by returning a promise in the
	      fulfillment or rejection handler. The downstream promise will then be pending
	      until the returned promise is settled. This is called *assimilation*.
	       ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // The user's comments are now available
	      });
	      ```
	       If the assimliated promise rejects, then the downstream promise will also reject.
	       ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // If `findCommentsByAuthor` fulfills, we'll have the value here
	      }, function (reason) {
	        // If `findCommentsByAuthor` rejects, we'll have the reason here
	      });
	      ```
	       Simple Example
	      --------------
	       Synchronous Example
	       ```javascript
	      var result;
	       try {
	        result = findResult();
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	       Errback Example
	       ```js
	      findResult(function(result, err){
	        if (err) {
	          // failure
	        } else {
	          // success
	        }
	      });
	      ```
	       Promise Example;
	       ```javascript
	      findResult().then(function(result){
	        // success
	      }, function(reason){
	        // failure
	      });
	      ```
	       Advanced Example
	      --------------
	       Synchronous Example
	       ```javascript
	      var author, books;
	       try {
	        author = findAuthor();
	        books  = findBooksByAuthor(author);
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	       Errback Example
	       ```js
	       function foundBooks(books) {
	       }
	       function failure(reason) {
	       }
	       findAuthor(function(author, err){
	        if (err) {
	          failure(err);
	          // failure
	        } else {
	          try {
	            findBoooksByAuthor(author, function(books, err) {
	              if (err) {
	                failure(err);
	              } else {
	                try {
	                  foundBooks(books);
	                } catch(reason) {
	                  failure(reason);
	                }
	              }
	            });
	          } catch(error) {
	            failure(err);
	          }
	          // success
	        }
	      });
	      ```
	       Promise Example;
	       ```javascript
	      findAuthor().
	        then(findBooksByAuthor).
	        then(function(books){
	          // found books
	      }).catch(function(reason){
	        // something went wrong
	      });
	      ```
	       @method then
	      @param {Function} onFulfilled
	      @param {Function} onRejected
	      Useful for tooling.
	      @return {Promise}
	    */
	    then: function then(onFulfillment, onRejection) {
	      var parent = this;
	      var state = parent._state;
	
	      if (state === lib$es6$promise$$internal$$FULFILLED && !onFulfillment || state === lib$es6$promise$$internal$$REJECTED && !onRejection) {
	        return this;
	      }
	
	      var child = new this.constructor(lib$es6$promise$$internal$$noop);
	      var result = parent._result;
	
	      if (state) {
	        var callback = arguments[state - 1];
	        lib$es6$promise$asap$$asap(function () {
	          lib$es6$promise$$internal$$invokeCallback(state, child, callback, result);
	        });
	      } else {
	        lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection);
	      }
	
	      return child;
	    },
	
	    /**
	      `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	      as the catch block of a try/catch statement.
	       ```js
	      function findAuthor(){
	        throw new Error('couldn't find that author');
	      }
	       // synchronous
	      try {
	        findAuthor();
	      } catch(reason) {
	        // something went wrong
	      }
	       // async with promises
	      findAuthor().catch(function(reason){
	        // something went wrong
	      });
	      ```
	       @method catch
	      @param {Function} onRejection
	      Useful for tooling.
	      @return {Promise}
	    */
	    'catch': function _catch(onRejection) {
	      return this.then(null, onRejection);
	    }
	  };
	  function lib$es6$promise$polyfill$$polyfill() {
	    var local;
	
	    if (typeof global !== 'undefined') {
	      local = global;
	    } else if (typeof self !== 'undefined') {
	      local = self;
	    } else {
	      try {
	        local = Function('return this')();
	      } catch (e) {
	        throw new Error('polyfill failed because global object is unavailable in this environment');
	      }
	    }
	
	    var P = local.Promise;
	
	    if (P && Object.prototype.toString.call(P.resolve()) === '[object Promise]' && !P.cast) {
	      return;
	    }
	
	    local.Promise = lib$es6$promise$promise$$default;
	  }
	  var lib$es6$promise$polyfill$$default = lib$es6$promise$polyfill$$polyfill;
	
	  var lib$es6$promise$umd$$ES6Promise = {
	    'Promise': lib$es6$promise$promise$$default,
	    'polyfill': lib$es6$promise$polyfill$$default
	  };
	
	  /* global define:true module:true window: true */
	  if ("function" === 'function' && __webpack_require__(362)['amd']) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return lib$es6$promise$umd$$ES6Promise;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== 'undefined' && module['exports']) {
	    module['exports'] = lib$es6$promise$umd$$ES6Promise;
	  } else if (typeof this !== 'undefined') {
	    this['ES6Promise'] = lib$es6$promise$umd$$ES6Promise;
	  }
	
	  lib$es6$promise$polyfill$$default();
	}).call(undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(14).setImmediate, (function() { return this; }()), __webpack_require__(4)(module)))

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!function (t, e) {
	  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = e() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (e), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.FakeRest = e() : t.FakeRest = e();
	}(undefined, function () {
	  return function (t) {
	    function e(n) {
	      if (r[n]) return r[n].exports;var o = r[n] = { exports: {}, id: n, loaded: !1 };return t[n].call(o.exports, o, o.exports, e), o.loaded = !0, o.exports;
	    }var r = {};return e.m = t, e.c = r, e.p = "", e(0);
	  }([function (t, e, r) {
	    "use strict";
	    var n = r(3)["default"];Object.defineProperty(e, "__esModule", { value: !0 });var o = r(1),
	        i = n(o),
	        u = r(2),
	        c = n(u);e["default"] = { Server: i["default"], Collection: c["default"] }, t.exports = e["default"];
	  }, function (t, e, r) {
	    "use strict";
	    function n(t) {
	      if (!t) return {};var e = {},
	          r = t.split("&");return r.map(function (t) {
	        if (-1 === t.indexOf("=")) e[t] = !0;else {
	          var r = t.split("="),
	              n = u(r, 2),
	              o = n[0],
	              i = n[1];(0 === i.indexOf("[") || 0 === i.indexOf("{")) && (i = JSON.parse(i)), e[o.trim()] = i;
	        }
	      }), e;
	    }var o = r(4)["default"],
	        i = r(5)["default"],
	        u = r(6)["default"],
	        c = r(7)["default"],
	        a = r(8)["default"],
	        s = r(3)["default"];Object.defineProperty(e, "__esModule", { value: !0 });var f = r(9),
	        l = s(f),
	        p = r(2),
	        d = s(p),
	        h = l["default"].getPolyfill(),
	        y = function () {
	      function t() {
	        var e = arguments.length <= 0 || void 0 === arguments[0] ? "" : arguments[0];i(this, t), this.baseUrl = e, this.loggingEnabled = !1, this.defaultQuery = function () {}, this.batchUrl = null, this.collections = {}, this.requestInterceptors = [], this.responseInterceptors = [];
	      }return o(t, [{ key: "init", value: function value(t) {
	          for (var e in t) {
	            this.addCollection(e, new d["default"](t[e], "id"));
	          }
	        } }, { key: "toggleLogging", value: function value() {
	          this.loggingEnabled = !this.loggingEnabled;
	        } }, { key: "setDefaultQuery", value: function value(t) {
	          this.defaultQuery = t;
	        } }, { key: "setBatchUrl", value: function value(t) {
	          this.batchUrl = t;
	        } }, { key: "setBatch", value: function value(t) {
	          console.warn("Server.setBatch() is deprecated, use Server.setBatchUrl() instead"), this.batchUrl = t;
	        } }, { key: "addCollection", value: function value(t, e) {
	          this.collections[t] = e, e.setServer(this), e.setName(t);
	        } }, { key: "getCollection", value: function value(t) {
	          return this.collections[t];
	        } }, { key: "getCollectionNames", value: function value() {
	          return c(this.collections);
	        } }, { key: "addRequestInterceptor", value: function value(t) {
	          this.requestInterceptors.push(t);
	        } }, { key: "addResponseInterceptor", value: function value(t) {
	          this.responseInterceptors.push(t);
	        } }, { key: "getCount", value: function value(t, e) {
	          return this.collections[t].getCount(e);
	        } }, { key: "getAll", value: function value(t, e) {
	          return this.collections[t].getAll(e);
	        } }, { key: "getOne", value: function value(t, e, r) {
	          return this.collections[t].getOne(e, r);
	        } }, { key: "addOne", value: function value(t, e) {
	          return this.collections[t].addOne(e);
	        } }, { key: "updateOne", value: function value(t, e, r) {
	          return this.collections[t].updateOne(e, r);
	        } }, { key: "removeOne", value: function value(t, e) {
	          return this.collections[t].removeOne(e);
	        } }, { key: "decode", value: function value(t) {
	          if (t.queryString = decodeURIComponent(t.url.slice(t.url.indexOf("?") + 1)), t.params = n(t.queryString), t.requestBody) try {
	            t.json = JSON.parse(t.requestBody);
	          } catch (e) {}return this.requestInterceptors.reduce(function (t, e) {
	            return e(t);
	          }, t);
	        } }, { key: "respond", value: function value(t, e, r) {
	          var n = arguments.length <= 3 || void 0 === arguments[3] ? 200 : arguments[3];e || (e = {}), e["Content-Type"] || (e["Content-Type"] = "application/json");var o = { status: n, headers: e, body: t };return o = this.responseInterceptors.reduce(function (t, e) {
	            return e(t, r);
	          }, o), this.log(r, o), r.respond(o.status, o.headers, JSON.stringify(o.body));
	        } }, { key: "log", value: function value(t, e) {
	          this.loggingEnabled && (console.group ? (console.groupCollapsed(t.method, t.url, "(FakeRest)"), console.group("request"), console.log(t.method, t.url), console.log("headers", t.requestHeaders), console.log("body   ", t.requestBody), console.groupEnd(), console.group("response", e.status), console.log("headers", e.headers), console.log("body   ", e.body), console.groupEnd(), console.groupEnd()) : (console.log("FakeRest request ", t.method, t.url, "headers", t.requestHeaders, "body", t.requestBody), console.log("FakeRest response", e.status, "headers", e.headers, "body", e.body)));
	        } }, { key: "batch", value: function value(t) {
	          var e = t.json,
	              r = this.handle.bind(this),
	              n = c(e).reduce(function (t, n) {
	            var o,
	                i = { url: e[n], method: "GET", params: {}, respond: function respond(t, e, r) {
	                o = { code: t, headers: c(e || {}).map(function (t) {
	                    return { name: t, value: e[t] };
	                  }), body: r || {} };
	              } };return r(i), t[n] = o || { code: 404, headers: [], body: {} }, t;
	          }, {});return this.respond(n, {}, t, 200);
	        } }, { key: "handle", value: function value(t) {
	          if (t = this.decode(t), this.batchUrl && this.batchUrl === t.url && "POST" === t.method) return this.batch(t);var e = !0,
	              r = !1,
	              n = void 0;try {
	            for (var o, i = a(this.getCollectionNames()); !(e = (o = i.next()).done); e = !0) {
	              var u = o.value,
	                  c = t.url.match(new RegExp("^" + this.baseUrl + "\\/(" + u + ")(\\/(\\d+))?(\\?.*)?$"));if (c) {
	                var s = h({}, this.defaultQuery(u), t.params);if (c[2]) {
	                  var f = c[3];if ("GET" == t.method) try {
	                    var l = this.getOne(u, f, s);return this.respond(l, null, t);
	                  } catch (p) {
	                    return t.respond(404);
	                  }if ("PUT" == t.method) try {
	                    var l = this.updateOne(u, f, t.json);return this.respond(l, null, t);
	                  } catch (p) {
	                    return t.respond(404);
	                  }if ("PATCH" == t.method) try {
	                    var l = this.updateOne(u, f, t.json);return this.respond(l, null, t);
	                  } catch (p) {
	                    return t.respond(404);
	                  }if ("DELETE" == t.method) try {
	                    var l = this.removeOne(u, f);return this.respond(l, null, t);
	                  } catch (p) {
	                    return t.respond(404);
	                  }
	                } else {
	                  if ("GET" == t.method) {
	                    var d = this.getCount(u, s.filter ? { filter: s.filter } : {}),
	                        y = void 0,
	                        v = void 0,
	                        g = void 0;if (d > 0) {
	                      y = this.getAll(u, s);var b = s.range ? s.range[0] : 0,
	                          m = s.range ? Math.min(y.length - 1 + b, s.range[1]) : y.length - 1;v = "items " + b + "-" + m + "/" + d, g = y.length == d ? 200 : 206;
	                    } else y = [], v = "items */0", g = 200;return this.respond(y, { "Content-Range": v }, t, g);
	                  }if ("POST" == t.method) {
	                    var O = this.addOne(u, t.json),
	                        j = this.baseUrl + "/" + u + "/" + O[this.getCollection(u).identifierName];return this.respond(O, { Location: j }, t, 201);
	                  }
	                }
	              }
	            }
	          } catch (w) {
	            r = !0, n = w;
	          } finally {
	            try {
	              !e && i["return"] && i["return"]();
	            } finally {
	              if (r) throw n;
	            }
	          }
	        } }, { key: "getHandler", value: function value() {
	          return this.handle.bind(this);
	        } }]), t;
	    }();e["default"] = y, t.exports = e["default"];
	  }, function (t, e, r) {
	    "use strict";
	    function n(t, e) {
	      if ("function" == typeof e) return t.filter(e);if (e instanceof Object) {
	        var r = a(e).map(function (t) {
	          if ("q" === t) {
	            var r = function () {
	              var t = new RegExp(e.q, "i");return { v: function v(e) {
	                  for (var r in e) {
	                    if (e[r] && e[r].match && null !== e[r].match(t)) return !0;
	                  }return !1;
	                } };
	            }();if ("object" == (typeof r === "undefined" ? "undefined" : _typeof(r))) return r.v;
	          }var n = e[t];if (-1 !== t.indexOf("_lte")) {
	            var o = function () {
	              var e = t.replace(/(_lte)$/, "");return { v: function v(t) {
	                  return t[e] <= n;
	                } };
	            }();if ("object" == (typeof o === "undefined" ? "undefined" : _typeof(o))) return o.v;
	          }if (-1 !== t.indexOf("_gte")) {
	            var i = function () {
	              var e = t.replace(/(_gte)$/, "");return { v: function v(t) {
	                  return t[e] >= n;
	                } };
	            }();if ("object" == (typeof i === "undefined" ? "undefined" : _typeof(i))) return i.v;
	          }if (-1 !== t.indexOf("_lt")) {
	            var u = function () {
	              var e = t.replace(/(_lt)$/, "");return { v: function v(t) {
	                  return t[e] < n;
	                } };
	            }();if ("object" == (typeof u === "undefined" ? "undefined" : _typeof(u))) return u.v;
	          }if (-1 !== t.indexOf("_gt")) {
	            var c = function () {
	              var e = t.replace(/(_gt)$/, "");return { v: function v(t) {
	                  return t[e] > n;
	                } };
	            }();if ("object" == (typeof c === "undefined" ? "undefined" : _typeof(c))) return c.v;
	          }return Array.isArray(n) ? function (e) {
	            return n.filter(function (r) {
	              return r == e[t];
	            }).length > 0;
	          } : function (e) {
	            return Array.isArray(e[t]) && "string" == typeof n ? -1 !== e[t].indexOf(n) : "boolean" == typeof e[t] && "string" == typeof n ? e[t] == ("true" === n ? !0 : !1) : e[t] == n;
	          };
	        });return t.filter(function (t) {
	          return r.reduce(function (e, r) {
	            return e && r(t);
	          }, !0);
	        });
	      }throw new Error("Unsupported filter type");
	    }function o(t, e) {
	      if ("function" == typeof e) return t.sort(e);if ("string" == typeof e) return t.sort(function (t, r) {
	        return t[e] > r[e] ? 1 : t[e] < r[e] ? -1 : 0;
	      });if (Array.isArray(e)) {
	        var r = function () {
	          var r = e[0],
	              n = "asc" == e[1].toLowerCase() ? 1 : -1;return { v: t.sort(function (t, e) {
	              return t[r] > e[r] ? n : t[r] < e[r] ? -1 * n : 0;
	            }) };
	        }();if ("object" == (typeof r === "undefined" ? "undefined" : _typeof(r))) return r.v;
	      }throw new Error("Unsupported sort type");
	    }function i(t, e) {
	      if (Array.isArray(e)) return t.slice(e[0], void 0 !== e[1] ? e[1] + 1 : void 0);throw new Error("Unsupported range type");
	    }var u = r(4)["default"],
	        c = r(5)["default"],
	        a = r(7)["default"],
	        s = r(3)["default"];Object.defineProperty(e, "__esModule", { value: !0 });var f = r(9),
	        l = s(f);r(10), r(11);var p = function () {
	      function t() {
	        var e = arguments.length <= 0 || void 0 === arguments[0] ? [] : arguments[0],
	            r = arguments.length <= 1 || void 0 === arguments[1] ? "id" : arguments[1];if (c(this, t), !Array.isArray(e)) throw new Error("Can't initialize a Collection with anything else than an array of items");this.sequence = 0, this.identifierName = r, this.items = [], this.server = null, this.name = null, e.map(this.addOne.bind(this));
	      }return u(t, [{ key: "setServer", value: function value(t) {
	          this.server = t;
	        } }, { key: "setName", value: function value(t) {
	          this.name = t;
	        } }, { key: "_oneToManyEmbedder", value: function value(t) {
	          var e = this,
	              r = this.name.slice(0, -1),
	              n = r + "_id";return function (r) {
	            var o = e.server.collections[t];if (!o) throw new Error("Can't embed a non-existing collection " + t);return r[t] = o.getAll(Array.isArray(r[t]) ? { filter: function filter(e) {
	                return -1 !== r[t].indexOf(e[o.identifierName]);
	              } } : { filter: function filter(t) {
	                return t[n] == r[e.identifierName];
	              } }), r;
	          };
	        } }, { key: "_manyToOneEmbedder", value: function value(t) {
	          var e = this,
	              r = t + "s",
	              n = t + "_id";return function (o) {
	            var i = e.server.collections[r];if (!i) throw new Error("Can't embed a non-existing collection " + t);try {
	              o[t] = i.getOne(o[n]);
	            } catch (u) {}return o;
	          };
	        } }, { key: "_itemEmbedder", value: function value(t) {
	          var e = this,
	              r = Array.isArray(t) ? t : [t],
	              n = r.map(function (t) {
	            return t.endsWith("s") ? e._oneToManyEmbedder(t) : e._manyToOneEmbedder(t);
	          });return function (t) {
	            return n.reduce(function (t, e) {
	              return e(t);
	            }, t);
	          };
	        } }, { key: "getCount", value: function value(t) {
	          return this.getAll(t).length;
	        } }, { key: "getAll", value: function value(t) {
	          var e = this.items.slice(0);return t && (t.filter && (e = n(e, t.filter)), t.sort && (e = o(e, t.sort)), t.range && (e = i(e, t.range)), t.embed && this.server && (e = e.map(function (t) {
	            return l["default"]({}, t);
	          }).map(this._itemEmbedder(t.embed)))), e;
	        } }, { key: "getIndex", value: function value(t) {
	          var e = this;return this.items.findIndex(function (r) {
	            return r[e.identifierName] == t;
	          });
	        } }, { key: "getOne", value: function value(t, e) {
	          var r = this.getIndex(t);if (-1 === r) throw new Error("No item with identifier " + t);var n = this.items[r];return e && e.embed && this.server && (n = l["default"]({}, n), n = this._itemEmbedder(e.embed)(n)), n;
	        } }, { key: "addOne", value: function value(t) {
	          var e = t[this.identifierName];if (void 0 !== e) {
	            if (-1 !== this.getIndex(e)) throw new Error("An item with the identifier " + e + " already exists");this.sequence = Math.max(this.sequence, e) + 1;
	          } else t[this.identifierName] = this.sequence++;return this.items.push(t), t;
	        } }, { key: "updateOne", value: function value(t, e) {
	          var r = this.getIndex(t);if (-1 === r) throw new Error("No item with identifier " + t);for (var n in e) {
	            this.items[r][n] = e[n];
	          }return this.items[r];
	        } }, { key: "removeOne", value: function value(t) {
	          var e = this.getIndex(t);if (-1 === e) throw new Error("No item with identifier " + t);var r = this.items[e];return this.items.splice(e, 1), t == this.sequence - 1 && this.sequence--, r;
	        } }]), t;
	    }();e["default"] = p, t.exports = e["default"];
	  }, function (t, e) {
	    "use strict";
	    e["default"] = function (t) {
	      return t && t.__esModule ? t : { "default": t };
	    }, e.__esModule = !0;
	  }, function (t, e, r) {
	    "use strict";
	    var n = r(12)["default"];e["default"] = function () {
	      function t(t, e) {
	        for (var r = 0; r < e.length; r++) {
	          var o = e[r];o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), n(t, o.key, o);
	        }
	      }return function (e, r, n) {
	        return r && t(e.prototype, r), n && t(e, n), e;
	      };
	    }(), e.__esModule = !0;
	  }, function (t, e) {
	    "use strict";
	    e["default"] = function (t, e) {
	      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
	    }, e.__esModule = !0;
	  }, function (t, e, r) {
	    "use strict";
	    var n = r(8)["default"],
	        o = r(13)["default"];e["default"] = function () {
	      function t(t, e) {
	        var r = [],
	            o = !0,
	            i = !1,
	            u = void 0;try {
	          for (var c, a = n(t); !(o = (c = a.next()).done) && (r.push(c.value), !e || r.length !== e); o = !0) {}
	        } catch (s) {
	          i = !0, u = s;
	        } finally {
	          try {
	            !o && a["return"] && a["return"]();
	          } finally {
	            if (i) throw u;
	          }
	        }return r;
	      }return function (e, r) {
	        if (Array.isArray(e)) return e;if (o(Object(e))) return t(e, r);throw new TypeError("Invalid attempt to destructure non-iterable instance");
	      };
	    }(), e.__esModule = !0;
	  }, function (t, e, r) {
	    t.exports = { "default": r(18), __esModule: !0 };
	  }, function (t, e, r) {
	    t.exports = { "default": r(17), __esModule: !0 };
	  }, function (t, e, r) {
	    "use strict";
	    var n = r(21),
	        o = r(14),
	        i = r(15),
	        u = r(16);n(o, { implementation: o, getPolyfill: i, shim: u }), t.exports = o;
	  }, function () {
	    !function () {
	      if (!Array.prototype.findIndex) {
	        var t = function t(_t) {
	          var e = Object(this),
	              r = Math.max(0, e.length) >>> 0;if (0 === r) return -1;if ("function" != typeof _t || "[object Function]" !== Object.prototype.toString.call(_t)) throw new TypeError("Array#findIndex: predicate must be a function");for (var n = arguments.length > 1 ? arguments[1] : void 0, o = 0; r > o; o++) {
	            if (_t.call(n, e[o], o, e)) return o;
	          }return -1;
	        };if (Object.defineProperty) try {
	          Object.defineProperty(Array.prototype, "findIndex", { value: t, configurable: !0, writable: !0 });
	        } catch (e) {}Array.prototype.findIndex || (Array.prototype.findIndex = t);
	      }
	    }(this);
	  }, function () {
	    /*! http://mths.be/endswith v0.2.0 by @mathias */
	    String.prototype.endsWith || !function () {
	      "use strict";
	      var t = function () {
	        try {
	          var t = {},
	              e = Object.defineProperty,
	              r = e(t, t, t) && e;
	        } catch (n) {}return r;
	      }(),
	          e = {}.toString,
	          r = function r(t) {
	        if (null == this) throw TypeError();var r = String(this);if (t && "[object RegExp]" == e.call(t)) throw TypeError();var n = r.length,
	            o = String(t),
	            i = o.length,
	            u = n;if (arguments.length > 1) {
	          var c = arguments[1];void 0 !== c && (u = c ? Number(c) : 0, u != u && (u = 0));
	        }var a = Math.min(Math.max(u, 0), n),
	            s = a - i;if (0 > s) return !1;for (var f = -1; ++f < i;) {
	          if (r.charCodeAt(s + f) != o.charCodeAt(f)) return !1;
	        }return !0;
	      };t ? t(String.prototype, "endsWith", { value: r, configurable: !0, writable: !0 }) : String.prototype.endsWith = r;
	    }();
	  }, function (t, e, r) {
	    t.exports = { "default": r(20), __esModule: !0 };
	  }, function (t, e, r) {
	    t.exports = { "default": r(19), __esModule: !0 };
	  }, function (t, e, r) {
	    "use strict";
	    var n = r(23),
	        o = r(24),
	        i = function i(t) {
	      return "undefined" != typeof t && null !== t;
	    },
	        u = r(22)(),
	        c = Object,
	        a = o.call(Function.call, Array.prototype.push),
	        s = o.call(Function.call, Object.prototype.propertyIsEnumerable);t.exports = function (t) {
	      if (!i(t)) throw new TypeError("target must be an object");var e,
	          r,
	          o,
	          f,
	          l,
	          p = c(t);for (e = 1; e < arguments.length; ++e) {
	        if (r = c(arguments[e]), f = n(r), u && Object.getOwnPropertySymbols) for (l = Object.getOwnPropertySymbols(r), o = 0; o < l.length; ++o) {
	          s(r, l[o]) && a(f, l[o]);
	        }for (o = 0; o < f.length; ++o) {
	          p[f[o]] = r[f[o]];
	        }
	      }return p;
	    };
	  }, function (t, e, r) {
	    "use strict";
	    var n = r(14),
	        o = function o() {
	      if (!Object.assign || !Object.preventExtensions) return !1;var t = Object.preventExtensions({ 1: 2 });try {
	        Object.assign(t, "xy");
	      } catch (e) {
	        return "y" === t[1];
	      }
	    };t.exports = function () {
	      return !Object.assign || o() ? n : Object.assign;
	    };
	  }, function (t, e, r) {
	    "use strict";
	    var n = r(21),
	        o = r(15);t.exports = function () {
	      var t = o();return Object.assign !== t && n(Object, { assign: t }), t;
	    };
	  }, function (t, e, r) {
	    r(25), r(26), r(27), t.exports = r(28).core.getIterator;
	  }, function (t, e, r) {
	    r(29), t.exports = r(28).core.Object.keys;
	  }, function (t, e, r) {
	    r(25), r(26), r(27), t.exports = r(28).core.isIterable;
	  }, function (t, e, r) {
	    var n = r(28);t.exports = function (t, e, r) {
	      return n.setDesc(t, e, r);
	    };
	  }, function (t, e, r) {
	    "use strict";
	    var n = r(23),
	        o = r(30),
	        i = "function" == typeof Symbol && "symbol" == _typeof(Symbol()),
	        u = Object.prototype.toString,
	        c = function c(t) {
	      return "function" == typeof t && "[object Function]" === u.call(t);
	    },
	        a = function a() {
	      var t = {};try {
	        Object.defineProperty(t, "x", { value: t, enumerable: !1 });for (var e in t) {
	          return !1;
	        }return t.x === t;
	      } catch (r) {
	        return !1;
	      }
	    },
	        s = Object.defineProperty && a(),
	        f = function f(t, e, r, n) {
	      (!(e in t) || c(n) && n()) && (s ? Object.defineProperty(t, e, { configurable: !0, enumerable: !1, writable: !0, value: r }) : t[e] = r);
	    },
	        l = function l(t, e) {
	      var r = arguments.length > 2 ? arguments[2] : {},
	          u = n(e);i && (u = u.concat(Object.getOwnPropertySymbols(e))), o(u, function (n) {
	        f(t, n, e[n], r[n]);
	      });
	    };l.supportsDescriptors = !!s, t.exports = l;
	  }, function (t, e, r) {
	    "use strict";
	    var n = r(23);t.exports = function () {
	      if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;if ("symbol" == _typeof(Symbol.iterator)) return !0;var t = {},
	          e = Symbol("test");if ("string" == typeof e) return !1;if (e instanceof Symbol) return !1;t[e] = 42;for (e in t) {
	        return !1;
	      }if (0 !== n(t).length) return !1;if ("function" == typeof Object.keys && 0 !== Object.keys(t).length) return !1;if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(t).length) return !1;var r = Object.getOwnPropertySymbols(t);if (1 !== r.length || r[0] !== e) return !1;if (!Object.prototype.propertyIsEnumerable.call(t, e)) return !1;if ("function" == typeof Object.getOwnPropertyDescriptor) {
	        var o = Object.getOwnPropertyDescriptor(t, e);if (42 !== o.value || o.enumerable !== !0) return !1;
	      }return !0;
	    };
	  }, function (t, e, r) {
	    "use strict";
	    var n = Object.prototype.hasOwnProperty,
	        o = Object.prototype.toString,
	        i = Array.prototype.slice,
	        u = r(31),
	        c = !{ toString: null }.propertyIsEnumerable("toString"),
	        a = function () {}.propertyIsEnumerable("prototype"),
	        s = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"],
	        f = function f(t) {
	      var e = t.constructor;return e && e.prototype === t;
	    },
	        l = { $window: !0, $console: !0, $parent: !0, $self: !0, $frames: !0, $webkitIndexedDB: !0, $webkitStorageInfo: !0 },
	        p = function () {
	      if ("undefined" == typeof window) return !1;for (var t in window) {
	        if (!l["$" + t] && n.call(window, t) && null !== window[t] && "object" == _typeof(window[t])) try {
	          f(window[t]);
	        } catch (e) {
	          return !0;
	        }
	      }return !1;
	    }(),
	        d = function d(t) {
	      if ("undefined" == typeof window && !p) return f(t);try {
	        return f(t);
	      } catch (e) {
	        return !1;
	      }
	    },
	        h = function h(t) {
	      var e = null !== t && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)),
	          r = "[object Function]" === o.call(t),
	          i = u(t),
	          f = e && "[object String]" === o.call(t),
	          l = [];if (!e && !r && !i) throw new TypeError("Object.keys called on a non-object");var p = a && r;if (f && t.length > 0 && !n.call(t, 0)) for (var h = 0; h < t.length; ++h) {
	        l.push(String(h));
	      }if (i && t.length > 0) for (var y = 0; y < t.length; ++y) {
	        l.push(String(y));
	      } else for (var v in t) {
	        p && "prototype" === v || !n.call(t, v) || l.push(String(v));
	      }if (c) for (var g = d(t), b = 0; b < s.length; ++b) {
	        g && "constructor" === s[b] || !n.call(t, s[b]) || l.push(s[b]);
	      }return l;
	    };h.shim = function () {
	      if (Object.keys) {
	        var t = function () {
	          return 2 === (Object.keys(arguments) || "").length;
	        }(1, 2);if (!t) {
	          var e = Object.keys;Object.keys = function (t) {
	            return e(u(t) ? i.call(t) : t);
	          };
	        }
	      } else Object.keys = h;return Object.keys || h;
	    }, t.exports = h;
	  }, function (t) {
	    var e = "Function.prototype.bind called on incompatible ",
	        r = Array.prototype.slice,
	        n = Object.prototype.toString,
	        o = "[object Function]";t.exports = function (t) {
	      var i = this;if ("function" != typeof i || n.call(i) !== o) throw new TypeError(e + i);for (var u = r.call(arguments, 1), c = function c() {
	        if (this instanceof l) {
	          var e = i.apply(this, u.concat(r.call(arguments)));return Object(e) === e ? e : this;
	        }return i.apply(t, u.concat(r.call(arguments)));
	      }, a = Math.max(0, i.length - u.length), s = [], f = 0; a > f; f++) {
	        s.push("$" + f);
	      }var l = Function("binder", "return function (" + s.join(",") + "){ return binder.apply(this,arguments); }")(c);if (i.prototype) {
	        var p = function p() {};p.prototype = i.prototype, l.prototype = new p(), p.prototype = null;
	      }return l;
	    };
	  }, function (t, e, r) {
	    r(32);var n = r(28),
	        o = r(33).Iterators,
	        i = r(34)("iterator"),
	        u = o.Array,
	        c = n.g.NodeList,
	        a = n.g.HTMLCollection,
	        s = c && c.prototype,
	        f = a && a.prototype;n.FW && (!c || i in s || n.hide(s, i, u), !a || i in f || n.hide(f, i, u)), o.NodeList = o.HTMLCollection = u;
	  }, function (t, e, r) {
	    var n = r(28).set,
	        o = r(35)(!0),
	        i = r(36).safe("iter"),
	        u = r(33),
	        c = u.step;r(37)(String, "String", function (t) {
	      n(this, i, { o: String(t), i: 0 });
	    }, function () {
	      var t,
	          e = this[i],
	          r = e.o,
	          n = e.i;return n >= r.length ? c(1) : (t = o(r, n), e.i += t.length, c(0, t));
	    });
	  }, function (t, e, r) {
	    var n = r(28).core,
	        o = r(33);n.isIterable = o.is, n.getIterator = o.get;
	  }, function (t, e, r) {
	    "use strict";
	    function n(t) {
	      return isNaN(t = +t) ? 0 : (t > 0 ? y : h)(t);
	    }function o(t, e) {
	      return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e };
	    }function i(t, e, r) {
	      return t[e] = r, t;
	    }function u(t) {
	      return b ? function (e, r, n) {
	        return O.setDesc(e, r, o(t, n));
	      } : i;
	    }function c(t) {
	      return null !== t && ("object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) || "function" == typeof t);
	    }function a(t) {
	      return "function" == typeof t;
	    }function s(t) {
	      if (void 0 == t) throw TypeError("Can't call method on  " + t);return t;
	    }var f = "undefined" != typeof self ? self : Function("return this")(),
	        l = {},
	        p = Object.defineProperty,
	        d = {}.hasOwnProperty,
	        h = Math.ceil,
	        y = Math.floor,
	        v = Math.max,
	        g = Math.min,
	        b = !!function () {
	      try {
	        return 2 == p({}, "a", { get: function get() {
	            return 2;
	          } }).a;
	      } catch (t) {}
	    }(),
	        m = u(1),
	        O = t.exports = r(38)({ g: f, core: l, html: f.document && document.documentElement, isObject: c, isFunction: a, that: function that() {
	        return this;
	      }, toInteger: n, toLength: function toLength(t) {
	        return t > 0 ? g(n(t), 9007199254740991) : 0;
	      }, toIndex: function toIndex(t, e) {
	        return t = n(t), 0 > t ? v(t + e, 0) : g(t, e);
	      }, has: function has(t, e) {
	        return d.call(t, e);
	      }, create: Object.create, getProto: Object.getPrototypeOf, DESC: b, desc: o, getDesc: Object.getOwnPropertyDescriptor, setDesc: p, setDescs: Object.defineProperties, getKeys: Object.keys, getNames: Object.getOwnPropertyNames, getSymbols: Object.getOwnPropertySymbols, assertDefined: s, ES5Object: Object, toObject: function toObject(t) {
	        return O.ES5Object(s(t));
	      }, hide: m, def: u(0), set: f.Symbol ? i : m, each: [].forEach });"undefined" != typeof __e && (__e = l), "undefined" != typeof __g && (__g = f);
	  }, function (t, e, r) {
	    var n = r(28),
	        o = r(39),
	        i = n.isObject,
	        u = n.toObject;n.each.call("freeze,seal,preventExtensions,isFrozen,isSealed,isExtensible,getOwnPropertyDescriptor,getPrototypeOf,keys,getOwnPropertyNames".split(","), function (t, e) {
	      var c = (n.core.Object || {})[t] || Object[t],
	          a = 0,
	          s = {};s[t] = 0 == e ? function (t) {
	        return i(t) ? c(t) : t;
	      } : 1 == e ? function (t) {
	        return i(t) ? c(t) : t;
	      } : 2 == e ? function (t) {
	        return i(t) ? c(t) : t;
	      } : 3 == e ? function (t) {
	        return i(t) ? c(t) : !0;
	      } : 4 == e ? function (t) {
	        return i(t) ? c(t) : !0;
	      } : 5 == e ? function (t) {
	        return i(t) ? c(t) : !1;
	      } : 6 == e ? function (t, e) {
	        return c(u(t), e);
	      } : 7 == e ? function (t) {
	        return c(Object(n.assertDefined(t)));
	      } : 8 == e ? function (t) {
	        return c(u(t));
	      } : r(40).get;try {
	        c("z");
	      } catch (f) {
	        a = 1;
	      }o(o.S + o.F * a, "Object", s);
	    });
	  }, function (t) {
	    var e = Object.prototype.hasOwnProperty,
	        r = Object.prototype.toString;t.exports = function (t, n, o) {
	      if ("[object Function]" !== r.call(n)) throw new TypeError("iterator must be a function");var i = t.length;if (i === +i) for (var u = 0; i > u; u++) {
	        n.call(o, t[u], u, t);
	      } else for (var c in t) {
	        e.call(t, c) && n.call(o, t[c], c, t);
	      }
	    };
	  }, function (t) {
	    "use strict";
	    var e = Object.prototype.toString;t.exports = function (t) {
	      var r = e.call(t),
	          n = "[object Arguments]" === r;return n || (n = "[object Array]" !== r && null !== t && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && "number" == typeof t.length && t.length >= 0 && "[object Function]" === e.call(t.callee)), n;
	    };
	  }, function (t, e, r) {
	    var n = r(28),
	        o = r(41),
	        i = r(36).safe("iter"),
	        u = r(33),
	        c = u.step,
	        a = u.Iterators;r(37)(Array, "Array", function (t, e) {
	      n.set(this, i, { o: n.toObject(t), i: 0, k: e });
	    }, function () {
	      var t = this[i],
	          e = t.o,
	          r = t.k,
	          n = t.i++;return !e || n >= e.length ? (t.o = void 0, c(1)) : "keys" == r ? c(0, n) : "values" == r ? c(0, e[n]) : c(0, [n, e[n]]);
	    }, "values"), a.Arguments = a.Array, o("keys"), o("values"), o("entries");
	  }, function (t, e, r) {
	    "use strict";
	    function n(t, e) {
	      o.hide(t, s, e), f in [] && o.hide(t, f, e);
	    }var o = r(28),
	        i = r(42),
	        u = i.classof,
	        c = r(43),
	        a = c.obj,
	        s = r(34)("iterator"),
	        f = "@@iterator",
	        l = r(44)("iterators"),
	        p = {};n(p, o.that), t.exports = { BUGGY: "keys" in [] && !("next" in [].keys()), Iterators: l, step: function step(t, e) {
	        return { value: e, done: !!t };
	      }, is: function is(t) {
	        var e = Object(t),
	            r = o.g.Symbol;return (r && r.iterator || f) in e || s in e || o.has(l, u(e));
	      }, get: function get(t) {
	        var e,
	            r = o.g.Symbol;return void 0 != t && (e = t[r && r.iterator || f] || t[s] || l[u(t)]), c(o.isFunction(e), t, " is not iterable!"), a(e.call(t));
	      }, set: n, create: function create(t, e, r, n) {
	        t.prototype = o.create(n || p, { next: o.desc(1, r) }), i.set(t, e + " Iterator");
	      } };
	  }, function (t, e, r) {
	    var n = r(28).g,
	        o = r(44)("wks");t.exports = function (t) {
	      return o[t] || (o[t] = n.Symbol && n.Symbol[t] || r(36).safe("Symbol." + t));
	    };
	  }, function (t, e, r) {
	    var n = r(28);t.exports = function (t) {
	      return function (e, r) {
	        var o,
	            i,
	            u = String(n.assertDefined(e)),
	            c = n.toInteger(r),
	            a = u.length;return 0 > c || c >= a ? t ? "" : void 0 : (o = u.charCodeAt(c), 55296 > o || o > 56319 || c + 1 === a || (i = u.charCodeAt(c + 1)) < 56320 || i > 57343 ? t ? u.charAt(c) : o : t ? u.slice(c, c + 2) : (o - 55296 << 10) + (i - 56320) + 65536);
	      };
	    };
	  }, function (t, e, r) {
	    function n(t) {
	      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++o + Math.random()).toString(36));
	    }var o = 0;n.safe = r(28).g.Symbol || n, t.exports = n;
	  }, function (t, e, r) {
	    var n = r(39),
	        o = r(45),
	        i = r(28),
	        u = r(42),
	        c = r(33),
	        a = r(34)("iterator"),
	        s = "@@iterator",
	        f = "keys",
	        l = "values",
	        p = c.Iterators;t.exports = function (t, e, r, d, h, y, v) {
	      function g(t) {
	        function e(e) {
	          return new r(e, t);
	        }switch (t) {case f:
	            return function () {
	              return e(this);
	            };case l:
	            return function () {
	              return e(this);
	            };}return function () {
	          return e(this);
	        };
	      }c.create(r, e, d);var b,
	          m,
	          O = e + " Iterator",
	          j = t.prototype,
	          w = j[a] || j[s] || h && j[h],
	          x = w || g(h);if (w) {
	        var S = i.getProto(x.call(new t()));u.set(S, O, !0), i.FW && i.has(j, s) && c.set(S, i.that);
	      }if ((i.FW || v) && c.set(j, x), p[e] = x, p[O] = i.that, h) if (b = { keys: y ? x : g(f), values: h == l ? x : g(l), entries: h != l ? x : g("entries") }, v) for (m in b) {
	        m in j || o(j, m, b[m]);
	      } else n(n.P + n.F * c.BUGGY, e, b);
	    };
	  }, function (t) {
	    t.exports = function (t) {
	      return t.FW = !1, t.path = t.core, t;
	    };
	  }, function (t, e, r) {
	    function n(t, e) {
	      return function () {
	        return t.apply(e, arguments);
	      };
	    }function o(t, e, r) {
	      var i,
	          s,
	          f,
	          l,
	          p = t & o.G,
	          d = t & o.P,
	          h = p ? u : t & o.S ? u[e] : (u[e] || {}).prototype,
	          y = p ? c : c[e] || (c[e] = {});p && (r = e);for (i in r) {
	        s = !(t & o.F) && h && i in h, s && i in y || (f = s ? h[i] : r[i], p && !a(h[i]) ? l = r[i] : t & o.B && s ? l = n(f, u) : t & o.W && h[i] == f ? !function (t) {
	          l = function l(e) {
	            return this instanceof t ? new t(e) : t(e);
	          }, l.prototype = t.prototype;
	        }(f) : l = d && a(f) ? n(Function.call, f) : f, y[i] = l, d && ((y.prototype || (y.prototype = {}))[i] = f));
	      }
	    }var i = r(28),
	        u = i.g,
	        c = i.core,
	        a = i.isFunction;o.F = 1, o.G = 2, o.S = 4, o.P = 8, o.B = 16, o.W = 32, t.exports = o;
	  }, function (t, e, r) {
	    function n(t) {
	      try {
	        return u(t);
	      } catch (e) {
	        return c.slice();
	      }
	    }var o = r(28),
	        i = {}.toString,
	        u = o.getNames,
	        c = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];t.exports.get = function (t) {
	      return c && "[object Window]" == i.call(t) ? n(t) : u(o.toObject(t));
	    };
	  }, function (t) {
	    t.exports = function () {};
	  }, function (t, e, r) {
	    function n(t) {
	      return u.call(t).slice(8, -1);
	    }var o = r(28),
	        i = r(34)("toStringTag"),
	        u = {}.toString;n.classof = function (t) {
	      var e, r;return void 0 == t ? void 0 === t ? "Undefined" : "Null" : "string" == typeof (r = (e = Object(t))[i]) ? r : n(e);
	    }, n.set = function (t, e, r) {
	      t && !o.has(t = r ? t : t.prototype, i) && o.hide(t, i, e);
	    }, t.exports = n;
	  }, function (t, e, r) {
	    function n(t, e, r) {
	      if (!t) throw TypeError(r ? e + r : e);
	    }var o = r(28);n.def = o.assertDefined, n.fn = function (t) {
	      if (!o.isFunction(t)) throw TypeError(t + " is not a function!");return t;
	    }, n.obj = function (t) {
	      if (!o.isObject(t)) throw TypeError(t + " is not an object!");return t;
	    }, n.inst = function (t, e, r) {
	      if (!(t instanceof e)) throw TypeError(r + ": use the 'new' operator!");return t;
	    }, t.exports = n;
	  }, function (t, e, r) {
	    var n = r(28),
	        o = "__core-js_shared__",
	        i = n.g[o] || (n.g[o] = {});t.exports = function (t) {
	      return i[t] || (i[t] = {});
	    };
	  }, function (t, e, r) {
	    t.exports = r(28).hide;
	  }]);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	("function" === "function" && __webpack_require__(26) && function (m) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(39)], __WEBPACK_AMD_DEFINE_FACTORY__ = (m), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} || ( false ? "undefined" : _typeof(module)) === "object" && function (m) {
	    module.exports = m(__webpack_require__(39));
	} || function (m) {
	    this.formatio = m(this.samsam);
	})(function (samsam) {
	    "use strict";
	
	    var formatio = {
	        excludeConstructors: ["Object", /^.$/],
	        quoteStrings: true,
	        limitChildrenCount: 0
	    };
	
	    var hasOwn = Object.prototype.hasOwnProperty;
	
	    var specialObjects = [];
	    if (typeof global !== "undefined") {
	        specialObjects.push({ object: global, value: "[object global]" });
	    }
	    if (typeof document !== "undefined") {
	        specialObjects.push({
	            object: document,
	            value: "[object HTMLDocument]"
	        });
	    }
	    if (typeof window !== "undefined") {
	        specialObjects.push({ object: window, value: "[object Window]" });
	    }
	
	    function functionName(func) {
	        if (!func) {
	            return "";
	        }
	        if (func.displayName) {
	            return func.displayName;
	        }
	        if (func.name) {
	            return func.name;
	        }
	        var matches = func.toString().match(/function\s+([^\(]+)/m);
	        return matches && matches[1] || "";
	    }
	
	    function _constructorName(f, object) {
	        var name = functionName(object && object.constructor);
	        var excludes = f.excludeConstructors || formatio.excludeConstructors || [];
	
	        var i, l;
	        for (i = 0, l = excludes.length; i < l; ++i) {
	            if (typeof excludes[i] === "string" && excludes[i] === name) {
	                return "";
	            } else if (excludes[i].test && excludes[i].test(name)) {
	                return "";
	            }
	        }
	
	        return name;
	    }
	
	    function isCircular(object, objects) {
	        if ((typeof object === "undefined" ? "undefined" : _typeof(object)) !== "object") {
	            return false;
	        }
	        var i, l;
	        for (i = 0, l = objects.length; i < l; ++i) {
	            if (objects[i] === object) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function _ascii(f, object, processed, indent) {
	        if (typeof object === "string") {
	            var qs = f.quoteStrings;
	            var quote = typeof qs !== "boolean" || qs;
	            return processed || quote ? '"' + object + '"' : object;
	        }
	
	        if (typeof object === "function" && !(object instanceof RegExp)) {
	            return _ascii.func(object);
	        }
	
	        processed = processed || [];
	
	        if (isCircular(object, processed)) {
	            return "[Circular]";
	        }
	
	        if (Object.prototype.toString.call(object) === "[object Array]") {
	            return _ascii.array.call(f, object, processed);
	        }
	
	        if (!object) {
	            return String(1 / object === -Infinity ? "-0" : object);
	        }
	        if (samsam.isElement(object)) {
	            return _ascii.element(object);
	        }
	
	        if (typeof object.toString === "function" && object.toString !== Object.prototype.toString) {
	            return object.toString();
	        }
	
	        var i, l;
	        for (i = 0, l = specialObjects.length; i < l; i++) {
	            if (object === specialObjects[i].object) {
	                return specialObjects[i].value;
	            }
	        }
	
	        return _ascii.object.call(f, object, processed, indent);
	    }
	
	    _ascii.func = function (func) {
	        return "function " + functionName(func) + "() {}";
	    };
	
	    _ascii.array = function (array, processed) {
	        processed = processed || [];
	        processed.push(array);
	        var pieces = [];
	        var i, l;
	        l = this.limitChildrenCount > 0 ? Math.min(this.limitChildrenCount, array.length) : array.length;
	
	        for (i = 0; i < l; ++i) {
	            pieces.push(_ascii(this, array[i], processed));
	        }
	
	        if (l < array.length) pieces.push("[... " + (array.length - l) + " more elements]");
	
	        return "[" + pieces.join(", ") + "]";
	    };
	
	    _ascii.object = function (object, processed, indent) {
	        processed = processed || [];
	        processed.push(object);
	        indent = indent || 0;
	        var pieces = [],
	            properties = samsam.keys(object).sort();
	        var length = 3;
	        var prop, str, obj, i, k, l;
	        l = this.limitChildrenCount > 0 ? Math.min(this.limitChildrenCount, properties.length) : properties.length;
	
	        for (i = 0; i < l; ++i) {
	            prop = properties[i];
	            obj = object[prop];
	
	            if (isCircular(obj, processed)) {
	                str = "[Circular]";
	            } else {
	                str = _ascii(this, obj, processed, indent + 2);
	            }
	
	            str = (/\s/.test(prop) ? '"' + prop + '"' : prop) + ": " + str;
	            length += str.length;
	            pieces.push(str);
	        }
	
	        var cons = _constructorName(this, object);
	        var prefix = cons ? "[" + cons + "] " : "";
	        var is = "";
	        for (i = 0, k = indent; i < k; ++i) {
	            is += " ";
	        }
	
	        if (l < properties.length) pieces.push("[... " + (properties.length - l) + " more elements]");
	
	        if (length + indent > 80) {
	            return prefix + "{\n  " + is + pieces.join(",\n  " + is) + "\n" + is + "}";
	        }
	        return prefix + "{ " + pieces.join(", ") + " }";
	    };
	
	    _ascii.element = function (element) {
	        var tagName = element.tagName.toLowerCase();
	        var attrs = element.attributes,
	            attr,
	            pairs = [],
	            attrName,
	            i,
	            l,
	            val;
	
	        for (i = 0, l = attrs.length; i < l; ++i) {
	            attr = attrs.item(i);
	            attrName = attr.nodeName.toLowerCase().replace("html:", "");
	            val = attr.nodeValue;
	            if (attrName !== "contenteditable" || val !== "inherit") {
	                if (!!val) {
	                    pairs.push(attrName + "=\"" + val + "\"");
	                }
	            }
	        }
	
	        var formatted = "<" + tagName + (pairs.length > 0 ? " " : "");
	        var content = element.innerHTML;
	
	        if (content.length > 20) {
	            content = content.substr(0, 20) + "[...]";
	        }
	
	        var res = formatted + pairs.join(" ") + ">" + content + "</" + tagName + ">";
	
	        return res.replace(/ contentEditable="inherit"/, "");
	    };
	
	    function Formatio(options) {
	        for (var opt in options) {
	            this[opt] = options[opt];
	        }
	    }
	
	    Formatio.prototype = {
	        functionName: functionName,
	
	        configure: function configure(options) {
	            return new Formatio(options);
	        },
	
	        constructorName: function constructorName(object) {
	            return _constructorName(this, object);
	        },
	
	        ascii: function ascii(object, processed, indent) {
	            return _ascii(this, object, processed, indent);
	        }
	    };
	
	    return Formatio.prototype;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module), (function() { return this; }())))

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * humane.js
	 * Humanized Messages for Notifications
	 * @author Marc Harter (@wavded)
	 * @example
	 *   humane.log('hello world');
	 * @license MIT
	 * See more usage examples at: http://wavded.github.com/humane-js/
	 */
	
	;!function (name, context, definition) {
	   if (true) module.exports = definition(name, context);else if (typeof define === 'function' && _typeof(define.amd) === 'object') define(definition);else context[name] = definition(name, context);
	}('humane', undefined, function (name, context) {
	   var win = window;
	   var doc = document;
	
	   var ENV = {
	      on: function on(el, type, cb) {
	         'addEventListener' in win ? el.addEventListener(type, cb, false) : el.attachEvent('on' + type, cb);
	      },
	      off: function off(el, type, cb) {
	         'removeEventListener' in win ? el.removeEventListener(type, cb, false) : el.detachEvent('on' + type, cb);
	      },
	      bind: function bind(fn, ctx) {
	         return function () {
	            fn.apply(ctx, arguments);
	         };
	      },
	      isArray: Array.isArray || function (obj) {
	         return Object.prototype.toString.call(obj) === '[object Array]';
	      },
	      config: function config(preferred, fallback) {
	         return preferred != null ? preferred : fallback;
	      },
	      transSupport: false,
	      useFilter: /msie [678]/i.test(navigator.userAgent), // sniff, sniff
	      _checkTransition: function _checkTransition() {
	         var el = doc.createElement('div');
	         var vendors = { webkit: 'webkit', Moz: '', O: 'o', ms: 'MS' };
	
	         for (var vendor in vendors) {
	            if (vendor + 'Transition' in el.style) {
	               this.vendorPrefix = vendors[vendor];
	               this.transSupport = true;
	            }
	         }
	      }
	   };
	   ENV._checkTransition();
	
	   var Humane = function Humane(o) {
	      o || (o = {});
	      this.queue = [];
	      this.baseCls = o.baseCls || 'humane';
	      this.addnCls = o.addnCls || '';
	      this.timeout = 'timeout' in o ? o.timeout : 2500;
	      this.waitForMove = o.waitForMove || false;
	      this.clickToClose = o.clickToClose || false;
	      this.timeoutAfterMove = o.timeoutAfterMove || false;
	      this.container = o.container;
	
	      try {
	         this._setupEl();
	      } // attempt to setup elements
	      catch (e) {
	         ENV.on(win, 'load', ENV.bind(this._setupEl, this)); // dom wasn't ready, wait till ready
	      }
	   };
	
	   Humane.prototype = {
	      constructor: Humane,
	      _setupEl: function _setupEl() {
	         var el = doc.createElement('div');
	         el.style.display = 'none';
	         if (!this.container) {
	            if (doc.body) this.container = doc.body;else throw 'document.body is null';
	         }
	         this.container.appendChild(el);
	         this.el = el;
	         this.removeEvent = ENV.bind(function () {
	            var timeoutAfterMove = ENV.config(this.currentMsg.timeoutAfterMove, this.timeoutAfterMove);
	            if (!timeoutAfterMove) {
	               this.remove();
	            } else {
	               setTimeout(ENV.bind(this.remove, this), timeoutAfterMove);
	            }
	         }, this);
	
	         this.transEvent = ENV.bind(this._afterAnimation, this);
	         this._run();
	      },
	      _afterTimeout: function _afterTimeout() {
	         if (!ENV.config(this.currentMsg.waitForMove, this.waitForMove)) this.remove();else if (!this.removeEventsSet) {
	            ENV.on(doc.body, 'mousemove', this.removeEvent);
	            ENV.on(doc.body, 'click', this.removeEvent);
	            ENV.on(doc.body, 'keypress', this.removeEvent);
	            ENV.on(doc.body, 'touchstart', this.removeEvent);
	            this.removeEventsSet = true;
	         }
	      },
	      _run: function _run() {
	         if (this._animating || !this.queue.length || !this.el) return;
	
	         this._animating = true;
	         if (this.currentTimer) {
	            clearTimeout(this.currentTimer);
	            this.currentTimer = null;
	         }
	
	         var msg = this.queue.shift();
	         var clickToClose = ENV.config(msg.clickToClose, this.clickToClose);
	
	         if (clickToClose) {
	            ENV.on(this.el, 'click', this.removeEvent);
	            ENV.on(this.el, 'touchstart', this.removeEvent);
	         }
	
	         var timeout = ENV.config(msg.timeout, this.timeout);
	
	         if (timeout > 0) this.currentTimer = setTimeout(ENV.bind(this._afterTimeout, this), timeout);
	
	         if (ENV.isArray(msg.html)) msg.html = '<ul><li>' + msg.html.join('<li>') + '</ul>';
	
	         this.el.innerHTML = msg.html;
	         this.currentMsg = msg;
	         this.el.className = this.baseCls;
	         if (ENV.transSupport) {
	            this.el.style.display = 'block';
	            setTimeout(ENV.bind(this._showMsg, this), 50);
	         } else {
	            this._showMsg();
	         }
	      },
	      _setOpacity: function _setOpacity(opacity) {
	         if (ENV.useFilter) {
	            try {
	               this.el.filters.item('DXImageTransform.Microsoft.Alpha').Opacity = opacity * 100;
	            } catch (err) {}
	         } else {
	            this.el.style.opacity = String(opacity);
	         }
	      },
	      _showMsg: function _showMsg() {
	         var addnCls = ENV.config(this.currentMsg.addnCls, this.addnCls);
	         if (ENV.transSupport) {
	            this.el.className = this.baseCls + ' ' + addnCls + ' ' + this.baseCls + '-animate';
	         } else {
	            var opacity = 0;
	            this.el.className = this.baseCls + ' ' + addnCls + ' ' + this.baseCls + '-js-animate';
	            this._setOpacity(0); // reset value so hover states work
	            this.el.style.display = 'block';
	
	            var self = this;
	            var interval = setInterval(function () {
	               if (opacity < 1) {
	                  opacity += 0.1;
	                  if (opacity > 1) opacity = 1;
	                  self._setOpacity(opacity);
	               } else clearInterval(interval);
	            }, 30);
	         }
	      },
	      _hideMsg: function _hideMsg() {
	         var addnCls = ENV.config(this.currentMsg.addnCls, this.addnCls);
	         if (ENV.transSupport) {
	            this.el.className = this.baseCls + ' ' + addnCls;
	            ENV.on(this.el, ENV.vendorPrefix ? ENV.vendorPrefix + 'TransitionEnd' : 'transitionend', this.transEvent);
	         } else {
	            var opacity = 1;
	            var self = this;
	            var interval = setInterval(function () {
	               if (opacity > 0) {
	                  opacity -= 0.1;
	                  if (opacity < 0) opacity = 0;
	                  self._setOpacity(opacity);
	               } else {
	                  self.el.className = self.baseCls + ' ' + addnCls;
	                  clearInterval(interval);
	                  self._afterAnimation();
	               }
	            }, 30);
	         }
	      },
	      _afterAnimation: function _afterAnimation() {
	         if (ENV.transSupport) ENV.off(this.el, ENV.vendorPrefix ? ENV.vendorPrefix + 'TransitionEnd' : 'transitionend', this.transEvent);
	
	         if (this.currentMsg.cb) this.currentMsg.cb();
	         this.el.style.display = 'none';
	
	         this._animating = false;
	         this._run();
	      },
	      remove: function remove(e) {
	         var cb = typeof e == 'function' ? e : null;
	
	         ENV.off(doc.body, 'mousemove', this.removeEvent);
	         ENV.off(doc.body, 'click', this.removeEvent);
	         ENV.off(doc.body, 'keypress', this.removeEvent);
	         ENV.off(doc.body, 'touchstart', this.removeEvent);
	         ENV.off(this.el, 'click', this.removeEvent);
	         ENV.off(this.el, 'touchstart', this.removeEvent);
	         this.removeEventsSet = false;
	
	         if (cb && this.currentMsg) this.currentMsg.cb = cb;
	         if (this._animating) this._hideMsg();else if (cb) cb();
	      },
	      log: function log(html, o, cb, defaults) {
	         var msg = {};
	         if (defaults) for (var opt in defaults) {
	            msg[opt] = defaults[opt];
	         }if (typeof o == 'function') cb = o;else if (o) for (var opt in o) {
	            msg[opt] = o[opt];
	         }msg.html = html;
	         if (cb) msg.cb = cb;
	         this.queue.push(msg);
	         this._run();
	         return this;
	      },
	      spawn: function spawn(defaults) {
	         var self = this;
	         return function (html, o, cb) {
	            self.log.call(self, html, o, cb, defaults);
	            return self;
	         };
	      },
	      create: function create(o) {
	         return new Humane(o);
	      }
	   };
	   return new Humane();
	});

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * inflection
	 * Copyright(c) 2011 Ben Lin <ben@dreamerslab.com>
	 * MIT Licensed
	 *
	 * @fileoverview
	 * A port of inflection-js to node.js module.
	 */
	
	(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	    module.exports = factory();
	  } else {
	    root.inflection = factory();
	  }
	})(undefined, function () {
	
	  /**
	   * @description This is a list of nouns that use the same form for both singular and plural.
	   *              This list should remain entirely in lower case to correctly match Strings.
	   * @private
	   */
	  var uncountable_words = ['equipment', 'information', 'rice', 'money', 'species', 'series', 'fish', 'sheep', 'moose', 'deer', 'news'];
	
	  /**
	   * @description These rules translate from the singular form of a noun to its plural form.
	   * @private
	   */
	  var plural_rules = [
	
	  // do not replace if its already a plural word
	  [new RegExp('(m)en$', 'gi')], [new RegExp('(pe)ople$', 'gi')], [new RegExp('(child)ren$', 'gi')], [new RegExp('([ti])a$', 'gi')], [new RegExp('((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$', 'gi')], [new RegExp('(hive)s$', 'gi')], [new RegExp('(tive)s$', 'gi')], [new RegExp('(curve)s$', 'gi')], [new RegExp('([lr])ves$', 'gi')], [new RegExp('([^fo])ves$', 'gi')], [new RegExp('([^aeiouy]|qu)ies$', 'gi')], [new RegExp('(s)eries$', 'gi')], [new RegExp('(m)ovies$', 'gi')], [new RegExp('(x|ch|ss|sh)es$', 'gi')], [new RegExp('([m|l])ice$', 'gi')], [new RegExp('(bus)es$', 'gi')], [new RegExp('(o)es$', 'gi')], [new RegExp('(shoe)s$', 'gi')], [new RegExp('(cris|ax|test)es$', 'gi')], [new RegExp('(octop|vir)i$', 'gi')], [new RegExp('(alias|status)es$', 'gi')], [new RegExp('^(ox)en', 'gi')], [new RegExp('(vert|ind)ices$', 'gi')], [new RegExp('(matr)ices$', 'gi')], [new RegExp('^feet$', 'gi')], [new RegExp('^teeth$', 'gi')], [new RegExp('^geese$', 'gi')], [new RegExp('(quiz)zes$', 'gi')],
	
	  // original rule
	  [new RegExp('(m)an$', 'gi'), '$1en'], [new RegExp('(pe)rson$', 'gi'), '$1ople'], [new RegExp('(child)$', 'gi'), '$1ren'], [new RegExp('^(ox)$', 'gi'), '$1en'], [new RegExp('(ax|test)is$', 'gi'), '$1es'], [new RegExp('(octop|vir)us$', 'gi'), '$1i'], [new RegExp('(alias|status)$', 'gi'), '$1es'], [new RegExp('(bu)s$', 'gi'), '$1ses'], [new RegExp('(buffal|tomat|potat)o$', 'gi'), '$1oes'], [new RegExp('([ti])um$', 'gi'), '$1a'], [new RegExp('sis$', 'gi'), 'ses'], [new RegExp('(?:([^f])fe|([lr])f)$', 'gi'), '$1$2ves'], [new RegExp('(hive)$', 'gi'), '$1s'], [new RegExp('([^aeiouy]|qu)y$', 'gi'), '$1ies'], [new RegExp('(x|ch|ss|sh)$', 'gi'), '$1es'], [new RegExp('(matr|vert|ind)ix|ex$', 'gi'), '$1ices'], [new RegExp('([m|l])ouse$', 'gi'), '$1ice'], [new RegExp('^foot$', 'gi'), 'feet'], [new RegExp('^tooth$', 'gi'), 'teeth'], [new RegExp('^goose$', 'gi'), 'geese'], [new RegExp('(quiz)$', 'gi'), '$1zes'], [new RegExp('s$', 'gi'), 's'], [new RegExp('$', 'gi'), 's']];
	
	  /**
	   * @description These rules translate from the plural form of a noun to its singular form.
	   * @private
	   */
	  var singular_rules = [
	
	  // do not replace if its already a singular word
	  [new RegExp('(m)an$', 'gi')], [new RegExp('(pe)rson$', 'gi')], [new RegExp('(child)$', 'gi')], [new RegExp('^(ox)$', 'gi')], [new RegExp('(ax|test)is$', 'gi')], [new RegExp('(octop|vir)us$', 'gi')], [new RegExp('(alias|status)$', 'gi')], [new RegExp('(bu)s$', 'gi')], [new RegExp('(buffal|tomat|potat)o$', 'gi')], [new RegExp('([ti])um$', 'gi')], [new RegExp('sis$', 'gi')], [new RegExp('(?:([^f])fe|([lr])f)$', 'gi')], [new RegExp('(hive)$', 'gi')], [new RegExp('([^aeiouy]|qu)y$', 'gi')], [new RegExp('(x|ch|ss|sh)$', 'gi')], [new RegExp('(matr|vert|ind)ix|ex$', 'gi')], [new RegExp('([m|l])ouse$', 'gi')], [new RegExp('^foot$', 'gi')], [new RegExp('^tooth$', 'gi')], [new RegExp('^goose$', 'gi')], [new RegExp('(quiz)$', 'gi')],
	
	  // original rule
	  [new RegExp('(m)en$', 'gi'), '$1an'], [new RegExp('(pe)ople$', 'gi'), '$1rson'], [new RegExp('(child)ren$', 'gi'), '$1'], [new RegExp('([ti])a$', 'gi'), '$1um'], [new RegExp('((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$', 'gi'), '$1$2sis'], [new RegExp('(hive)s$', 'gi'), '$1'], [new RegExp('(tive)s$', 'gi'), '$1'], [new RegExp('(curve)s$', 'gi'), '$1'], [new RegExp('([lr])ves$', 'gi'), '$1f'], [new RegExp('([^fo])ves$', 'gi'), '$1fe'], [new RegExp('(m)ovies$', 'gi'), '$1ovie'], [new RegExp('([^aeiouy]|qu)ies$', 'gi'), '$1y'], [new RegExp('(s)eries$', 'gi'), '$1eries'], [new RegExp('(x|ch|ss|sh)es$', 'gi'), '$1'], [new RegExp('([m|l])ice$', 'gi'), '$1ouse'], [new RegExp('(bus)es$', 'gi'), '$1'], [new RegExp('(o)es$', 'gi'), '$1'], [new RegExp('(shoe)s$', 'gi'), '$1'], [new RegExp('(cris|ax|test)es$', 'gi'), '$1is'], [new RegExp('(octop|vir)i$', 'gi'), '$1us'], [new RegExp('(alias|status)es$', 'gi'), '$1'], [new RegExp('^(ox)en', 'gi'), '$1'], [new RegExp('(vert|ind)ices$', 'gi'), '$1ex'], [new RegExp('(matr)ices$', 'gi'), '$1ix'], [new RegExp('^feet$', 'gi'), 'foot'], [new RegExp('^teeth$', 'gi'), 'tooth'], [new RegExp('^geese$', 'gi'), 'goose'], [new RegExp('(quiz)zes$', 'gi'), '$1'], [new RegExp('ss$', 'gi'), 'ss'], [new RegExp('s$', 'gi'), '']];
	
	  /**
	   * @description This is a list of words that should not be capitalized for title case.
	   * @private
	   */
	  var non_titlecased_words = ['and', 'or', 'nor', 'a', 'an', 'the', 'so', 'but', 'to', 'of', 'at', 'by', 'from', 'into', 'on', 'onto', 'off', 'out', 'in', 'over', 'with', 'for'];
	
	  /**
	   * @description These are regular expressions used for converting between String formats.
	   * @private
	   */
	  var id_suffix = new RegExp('(_ids|_id)$', 'g');
	  var underbar = new RegExp('_', 'g');
	  var space_or_underbar = new RegExp('[\ _]', 'g');
	  var uppercase = new RegExp('([A-Z])', 'g');
	  var underbar_prefix = new RegExp('^_');
	
	  var inflector = {
	
	    /**
	     * A helper method that applies rules based replacement to a String.
	     * @private
	     * @function
	     * @param {String} str String to modify and return based on the passed rules.
	     * @param {Array: [RegExp, String]} rules Regexp to match paired with String to use for replacement
	     * @param {Array: [String]} skip Strings to skip if they match
	     * @param {String} override String to return as though this method succeeded (used to conform to APIs)
	     * @returns {String} Return passed String modified by passed rules.
	     * @example
	     *
	     *     this._apply_rules( 'cows', singular_rules ); // === 'cow'
	     */
	    _apply_rules: function _apply_rules(str, rules, skip, override) {
	      if (override) {
	        str = override;
	      } else {
	        var ignore = inflector.indexOf(skip, str.toLowerCase()) > -1;
	
	        if (!ignore) {
	          var i = 0;
	          var j = rules.length;
	
	          for (; i < j; i++) {
	            if (str.match(rules[i][0])) {
	              if (rules[i][1] !== undefined) {
	                str = str.replace(rules[i][0], rules[i][1]);
	              }
	              break;
	            }
	          }
	        }
	      }
	
	      return str;
	    },
	
	    /**
	     * This lets us detect if an Array contains a given element.
	     * @public
	     * @function
	     * @param {Array} arr The subject array.
	     * @param {Object} item Object to locate in the Array.
	     * @param {Number} from_index Starts checking from this position in the Array.(optional)
	     * @param {Function} compare_func Function used to compare Array item vs passed item.(optional)
	     * @returns {Number} Return index position in the Array of the passed item.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.indexOf([ 'hi','there' ], 'guys' ); // === -1
	     *     inflection.indexOf([ 'hi','there' ], 'hi' ); // === 0
	     */
	    indexOf: function indexOf(arr, item, from_index, compare_func) {
	      if (!from_index) {
	        from_index = -1;
	      }
	
	      var index = -1;
	      var i = from_index;
	      var j = arr.length;
	
	      for (; i < j; i++) {
	        if (arr[i] === item || compare_func && compare_func(arr[i], item)) {
	          index = i;
	          break;
	        }
	      }
	
	      return index;
	    },
	
	    /**
	     * This function adds pluralization support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {String} plural Overrides normal output with said String.(optional)
	     * @returns {String} Singular English language nouns are returned in plural form.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.pluralize( 'person' ); // === 'people'
	     *     inflection.pluralize( 'octopus' ); // === 'octopi'
	     *     inflection.pluralize( 'Hat' ); // === 'Hats'
	     *     inflection.pluralize( 'person', 'guys' ); // === 'guys'
	     */
	    pluralize: function pluralize(str, plural) {
	      return inflector._apply_rules(str, plural_rules, uncountable_words, plural);
	    },
	
	    /**
	     * This function adds singularization support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {String} singular Overrides normal output with said String.(optional)
	     * @returns {String} Plural English language nouns are returned in singular form.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.singularize( 'people' ); // === 'person'
	     *     inflection.singularize( 'octopi' ); // === 'octopus'
	     *     inflection.singularize( 'Hats' ); // === 'Hat'
	     *     inflection.singularize( 'guys', 'person' ); // === 'person'
	     */
	    singularize: function singularize(str, singular) {
	      return inflector._apply_rules(str, singular_rules, uncountable_words, singular);
	    },
	
	    /**
	     * This function will pluralize or singularlize a String appropriately based on an integer value
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {Number} count The number to base pluralization off of.
	     * @param {String} singular Overrides normal output with said String.(optional)
	     * @param {String} plural Overrides normal output with said String.(optional)
	     * @returns {String} English language nouns are returned in the plural or singular form based on the count.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.inflect( 'people' 1 ); // === 'person'
	     *     inflection.inflect( 'octopi' 1 ); // === 'octopus'
	     *     inflection.inflect( 'Hats' 1 ); // === 'Hat'
	     *     inflection.inflect( 'guys', 1 , 'person' ); // === 'person'
	     *     inflection.inflect( 'person', 2 ); // === 'people'
	     *     inflection.inflect( 'octopus', 2 ); // === 'octopi'
	     *     inflection.inflect( 'Hat', 2 ); // === 'Hats'
	     *     inflection.inflect( 'person', 2, null, 'guys' ); // === 'guys'
	     */
	    inflect: function inflect(str, count, singular, plural) {
	      count = parseInt(count, 10);
	
	      if (isNaN(count)) return str;
	
	      if (count === 0 || count > 1) {
	        return inflector._apply_rules(str, plural_rules, uncountable_words, plural);
	      } else {
	        return inflector._apply_rules(str, singular_rules, uncountable_words, singular);
	      }
	    },
	
	    /**
	     * This function adds camelization support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {Boolean} low_first_letter Default is to capitalize the first letter of the results.(optional)
	     *                                 Passing true will lowercase it.
	     * @returns {String} Lower case underscored words will be returned in camel case.
	     *                  additionally '/' is translated to '::'
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.camelize( 'message_properties' ); // === 'MessageProperties'
	     *     inflection.camelize( 'message_properties', true ); // === 'messageProperties'
	     */
	    camelize: function camelize(str, low_first_letter) {
	      var str_path = str.split('/');
	      var i = 0;
	      var j = str_path.length;
	      var str_arr, init_x, k, l, first;
	
	      for (; i < j; i++) {
	        str_arr = str_path[i].split('_');
	        k = 0;
	        l = str_arr.length;
	
	        for (; k < l; k++) {
	          if (k !== 0) {
	            str_arr[k] = str_arr[k].toLowerCase();
	          }
	
	          first = str_arr[k].charAt(0);
	          first = low_first_letter && i === 0 && k === 0 ? first.toLowerCase() : first.toUpperCase();
	          str_arr[k] = first + str_arr[k].substring(1);
	        }
	
	        str_path[i] = str_arr.join('');
	      }
	
	      return str_path.join('::');
	    },
	
	    /**
	     * This function adds underscore support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {Boolean} all_upper_case Default is to lowercase and add underscore prefix.(optional)
	     *                  Passing true will return as entered.
	     * @returns {String} Camel cased words are returned as lower cased and underscored.
	     *                  additionally '::' is translated to '/'.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.underscore( 'MessageProperties' ); // === 'message_properties'
	     *     inflection.underscore( 'messageProperties' ); // === 'message_properties'
	     *     inflection.underscore( 'MP', true ); // === 'MP'
	     */
	    underscore: function underscore(str, all_upper_case) {
	      if (all_upper_case && str === str.toUpperCase()) return str;
	
	      var str_path = str.split('::');
	      var i = 0;
	      var j = str_path.length;
	
	      for (; i < j; i++) {
	        str_path[i] = str_path[i].replace(uppercase, '_$1');
	        str_path[i] = str_path[i].replace(underbar_prefix, '');
	      }
	
	      return str_path.join('/').toLowerCase();
	    },
	
	    /**
	     * This function adds humanize support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {Boolean} low_first_letter Default is to capitalize the first letter of the results.(optional)
	     *                                 Passing true will lowercase it.
	     * @returns {String} Lower case underscored words will be returned in humanized form.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.humanize( 'message_properties' ); // === 'Message properties'
	     *     inflection.humanize( 'message_properties', true ); // === 'message properties'
	     */
	    humanize: function humanize(str, low_first_letter) {
	      str = str.toLowerCase();
	      str = str.replace(id_suffix, '');
	      str = str.replace(underbar, ' ');
	
	      if (!low_first_letter) {
	        str = inflector.capitalize(str);
	      }
	
	      return str;
	    },
	
	    /**
	     * This function adds capitalization support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @returns {String} All characters will be lower case and the first will be upper.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.capitalize( 'message_properties' ); // === 'Message_properties'
	     *     inflection.capitalize( 'message properties', true ); // === 'Message properties'
	     */
	    capitalize: function capitalize(str) {
	      str = str.toLowerCase();
	
	      return str.substring(0, 1).toUpperCase() + str.substring(1);
	    },
	
	    /**
	     * This function adds dasherization support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @returns {String} Replaces all spaces or underbars with dashes.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.dasherize( 'message_properties' ); // === 'message-properties'
	     *     inflection.dasherize( 'Message Properties' ); // === 'Message-Properties'
	     */
	    dasherize: function dasherize(str) {
	      return str.replace(space_or_underbar, '-');
	    },
	
	    /**
	     * This function adds titleize support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @returns {String} Capitalizes words as you would for a book title.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.titleize( 'message_properties' ); // === 'Message Properties'
	     *     inflection.titleize( 'message properties to keep' ); // === 'Message Properties to Keep'
	     */
	    titleize: function titleize(str) {
	      str = str.toLowerCase().replace(underbar, ' ');
	      var str_arr = str.split(' ');
	      var i = 0;
	      var j = str_arr.length;
	      var d, k, l;
	
	      for (; i < j; i++) {
	        d = str_arr[i].split('-');
	        k = 0;
	        l = d.length;
	
	        for (; k < l; k++) {
	          if (inflector.indexOf(non_titlecased_words, d[k].toLowerCase()) < 0) {
	            d[k] = inflector.capitalize(d[k]);
	          }
	        }
	
	        str_arr[i] = d.join('-');
	      }
	
	      str = str_arr.join(' ');
	      str = str.substring(0, 1).toUpperCase() + str.substring(1);
	
	      return str;
	    },
	
	    /**
	     * This function adds demodulize support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @returns {String} Removes module names leaving only class names.(Ruby style)
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.demodulize( 'Message::Bus::Properties' ); // === 'Properties'
	     */
	    demodulize: function demodulize(str) {
	      var str_arr = str.split('::');
	
	      return str_arr[str_arr.length - 1];
	    },
	
	    /**
	     * This function adds tableize support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @returns {String} Return camel cased words into their underscored plural form.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.tableize( 'MessageBusProperty' ); // === 'message_bus_properties'
	     */
	    tableize: function tableize(str) {
	      str = inflector.underscore(str);
	      str = inflector.pluralize(str);
	
	      return str;
	    },
	
	    /**
	     * This function adds classification support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @returns {String} Underscored plural nouns become the camel cased singular form.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.classify( 'message_bus_properties' ); // === 'MessageBusProperty'
	     */
	    classify: function classify(str) {
	      str = inflector.camelize(str);
	      str = inflector.singularize(str);
	
	      return str;
	    },
	
	    /**
	     * This function adds foreign key support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {Boolean} drop_id_ubar Default is to seperate id with an underbar at the end of the class name,
	                                   you can pass true to skip it.(optional)
	     * @returns {String} Underscored plural nouns become the camel cased singular form.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.foreign_key( 'MessageBusProperty' ); // === 'message_bus_property_id'
	     *     inflection.foreign_key( 'MessageBusProperty', true ); // === 'message_bus_propertyid'
	     */
	    foreign_key: function foreign_key(str, drop_id_ubar) {
	      str = inflector.demodulize(str);
	      str = inflector.underscore(str) + (drop_id_ubar ? '' : '_') + 'id';
	
	      return str;
	    },
	
	    /**
	     * This function adds ordinalize support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @returns {String} Return all found numbers their sequence like '22nd'.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.ordinalize( 'the 1 pitch' ); // === 'the 1st pitch'
	     */
	    ordinalize: function ordinalize(str) {
	      var str_arr = str.split(' ');
	      var i = 0;
	      var j = str_arr.length;
	
	      for (; i < j; i++) {
	        var k = parseInt(str_arr[i], 10);
	
	        if (!isNaN(k)) {
	          var ltd = str_arr[i].substring(str_arr[i].length - 2);
	          var ld = str_arr[i].substring(str_arr[i].length - 1);
	          var suf = 'th';
	
	          if (ltd != '11' && ltd != '12' && ltd != '13') {
	            if (ld === '1') {
	              suf = 'st';
	            } else if (ld === '2') {
	              suf = 'nd';
	            } else if (ld === '3') {
	              suf = 'rd';
	            }
	          }
	
	          str_arr[i] += suf;
	        }
	      }
	
	      return str_arr.join(' ');
	    },
	
	    /**
	     * This function performs multiple inflection methods on a string
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {Array} arr An array of inflection methods.
	     * @returns {String}
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.transform( 'all job', [ 'pluralize', 'capitalize', 'dasherize' ]); // === 'All-jobs'
	     */
	    transform: function transform(str, arr) {
	      var i = 0;
	      var j = arr.length;
	
	      for (; i < j; i++) {
	        var method = arr[i];
	
	        if (this.hasOwnProperty(method)) {
	          str = this[method](str);
	        }
	      }
	
	      return str;
	    }
	  };
	
	  /**
	   * @public
	   */
	  inflector.version = '1.4.2';
	
	  return inflector;
	});

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	var jsonlint = function () {
	  var a = !0,
	      b = !1,
	      c = {},
	      d = function () {
	    var a = { trace: function trace() {}, yy: {}, symbols_: { error: 2, JSONString: 3, STRING: 4, JSONNumber: 5, NUMBER: 6, JSONNullLiteral: 7, NULL: 8, JSONBooleanLiteral: 9, TRUE: 10, FALSE: 11, JSONText: 12, JSONValue: 13, EOF: 14, JSONObject: 15, JSONArray: 16, "{": 17, "}": 18, JSONMemberList: 19, JSONMember: 20, ":": 21, ",": 22, "[": 23, "]": 24, JSONElementList: 25, $accept: 0, $end: 1 }, terminals_: { 2: "error", 4: "STRING", 6: "NUMBER", 8: "NULL", 10: "TRUE", 11: "FALSE", 14: "EOF", 17: "{", 18: "}", 21: ":", 22: ",", 23: "[", 24: "]" }, productions_: [0, [3, 1], [5, 1], [7, 1], [9, 1], [9, 1], [12, 2], [13, 1], [13, 1], [13, 1], [13, 1], [13, 1], [13, 1], [15, 2], [15, 3], [20, 3], [19, 1], [19, 3], [16, 2], [16, 3], [25, 1], [25, 3]], performAction: function performAction(b, c, d, e, f, g, h) {
	        var i = g.length - 1;switch (f) {case 1:
	            this.$ = b.replace(/\\(\\|")/g, "$1").replace(/\\n/g, "\n").replace(/\\r/g, "\r").replace(/\\t/g, "	").replace(/\\v/g, "").replace(/\\f/g, "\f").replace(/\\b/g, "\b");break;case 2:
	            this.$ = Number(b);break;case 3:
	            this.$ = null;break;case 4:
	            this.$ = !0;break;case 5:
	            this.$ = !1;break;case 6:
	            return this.$ = g[i - 1];case 13:
	            this.$ = {};break;case 14:
	            this.$ = g[i - 1];break;case 15:
	            this.$ = [g[i - 2], g[i]];break;case 16:
	            this.$ = {}, this.$[g[i][0]] = g[i][1];break;case 17:
	            this.$ = g[i - 2], g[i - 2][g[i][0]] = g[i][1];break;case 18:
	            this.$ = [];break;case 19:
	            this.$ = g[i - 1];break;case 20:
	            this.$ = [g[i]];break;case 21:
	            this.$ = g[i - 2], g[i - 2].push(g[i]);}
	      }, table: [{ 3: 5, 4: [1, 12], 5: 6, 6: [1, 13], 7: 3, 8: [1, 9], 9: 4, 10: [1, 10], 11: [1, 11], 12: 1, 13: 2, 15: 7, 16: 8, 17: [1, 14], 23: [1, 15] }, { 1: [3] }, { 14: [1, 16] }, { 14: [2, 7], 18: [2, 7], 22: [2, 7], 24: [2, 7] }, { 14: [2, 8], 18: [2, 8], 22: [2, 8], 24: [2, 8] }, { 14: [2, 9], 18: [2, 9], 22: [2, 9], 24: [2, 9] }, { 14: [2, 10], 18: [2, 10], 22: [2, 10], 24: [2, 10] }, { 14: [2, 11], 18: [2, 11], 22: [2, 11], 24: [2, 11] }, { 14: [2, 12], 18: [2, 12], 22: [2, 12], 24: [2, 12] }, { 14: [2, 3], 18: [2, 3], 22: [2, 3], 24: [2, 3] }, { 14: [2, 4], 18: [2, 4], 22: [2, 4], 24: [2, 4] }, { 14: [2, 5], 18: [2, 5], 22: [2, 5], 24: [2, 5] }, { 14: [2, 1], 18: [2, 1], 21: [2, 1], 22: [2, 1], 24: [2, 1] }, { 14: [2, 2], 18: [2, 2], 22: [2, 2], 24: [2, 2] }, { 3: 20, 4: [1, 12], 18: [1, 17], 19: 18, 20: 19 }, { 3: 5, 4: [1, 12], 5: 6, 6: [1, 13], 7: 3, 8: [1, 9], 9: 4, 10: [1, 10], 11: [1, 11], 13: 23, 15: 7, 16: 8, 17: [1, 14], 23: [1, 15], 24: [1, 21], 25: 22 }, { 1: [2, 6] }, { 14: [2, 13], 18: [2, 13], 22: [2, 13], 24: [2, 13] }, { 18: [1, 24], 22: [1, 25] }, { 18: [2, 16], 22: [2, 16] }, { 21: [1, 26] }, { 14: [2, 18], 18: [2, 18], 22: [2, 18], 24: [2, 18] }, { 22: [1, 28], 24: [1, 27] }, { 22: [2, 20], 24: [2, 20] }, { 14: [2, 14], 18: [2, 14], 22: [2, 14], 24: [2, 14] }, { 3: 20, 4: [1, 12], 20: 29 }, { 3: 5, 4: [1, 12], 5: 6, 6: [1, 13], 7: 3, 8: [1, 9], 9: 4, 10: [1, 10], 11: [1, 11], 13: 30, 15: 7, 16: 8, 17: [1, 14], 23: [1, 15] }, { 14: [2, 19], 18: [2, 19], 22: [2, 19], 24: [2, 19] }, { 3: 5, 4: [1, 12], 5: 6, 6: [1, 13], 7: 3, 8: [1, 9], 9: 4, 10: [1, 10], 11: [1, 11], 13: 31, 15: 7, 16: 8, 17: [1, 14], 23: [1, 15] }, { 18: [2, 17], 22: [2, 17] }, { 18: [2, 15], 22: [2, 15] }, { 22: [2, 21], 24: [2, 21] }], defaultActions: { 16: [2, 6] }, parseError: function parseError(b, c) {
	        throw new Error(b);
	      }, parse: function parse(b) {
	        function o(a) {
	          d.length = d.length - 2 * a, e.length = e.length - a, f.length = f.length - a;
	        }function p() {
	          var a;return a = c.lexer.lex() || 1, typeof a != "number" && (a = c.symbols_[a] || a), a;
	        }var c = this,
	            d = [0],
	            e = [null],
	            f = [],
	            g = this.table,
	            h = "",
	            i = 0,
	            j = 0,
	            k = 0,
	            l = 2,
	            m = 1;this.lexer.setInput(b), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, typeof this.lexer.yylloc == "undefined" && (this.lexer.yylloc = {});var n = this.lexer.yylloc;f.push(n), typeof this.yy.parseError == "function" && (this.parseError = this.yy.parseError);var q,
	            r,
	            s,
	            t,
	            u,
	            v,
	            w = {},
	            x,
	            y,
	            z,
	            A;for (;;) {
	          s = d[d.length - 1], this.defaultActions[s] ? t = this.defaultActions[s] : (q == null && (q = p()), t = g[s] && g[s][q]);if (typeof t == "undefined" || !t.length || !t[0]) {
	            if (!k) {
	              A = [];for (x in g[s]) {
	                this.terminals_[x] && x > 2 && A.push("'" + this.terminals_[x] + "'");
	              }var B = "";this.lexer.showPosition ? B = "Parse error on line " + (i + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + this.terminals_[q] + "'" : B = "Parse error on line " + (i + 1) + ": Unexpected " + (q == 1 ? "end of input" : "'" + (this.terminals_[q] || q) + "'"), this.parseError(B, { text: this.lexer.match, token: this.terminals_[q] || q, line: this.lexer.yylineno, loc: n, expected: A });
	            }if (k == 3) {
	              if (q == m) throw new Error(B || "Parsing halted.");j = this.lexer.yyleng, h = this.lexer.yytext, i = this.lexer.yylineno, n = this.lexer.yylloc, q = p();
	            }for (;;) {
	              if (l.toString() in g[s]) break;if (s == 0) throw new Error(B || "Parsing halted.");o(1), s = d[d.length - 1];
	            }r = q, q = l, s = d[d.length - 1], t = g[s] && g[s][l], k = 3;
	          }if (t[0] instanceof Array && t.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + s + ", token: " + q);switch (t[0]) {case 1:
	              d.push(q), e.push(this.lexer.yytext), f.push(this.lexer.yylloc), d.push(t[1]), q = null, r ? (q = r, r = null) : (j = this.lexer.yyleng, h = this.lexer.yytext, i = this.lexer.yylineno, n = this.lexer.yylloc, k > 0 && k--);break;case 2:
	              y = this.productions_[t[1]][1], w.$ = e[e.length - y], w._$ = { first_line: f[f.length - (y || 1)].first_line, last_line: f[f.length - 1].last_line, first_column: f[f.length - (y || 1)].first_column, last_column: f[f.length - 1].last_column }, v = this.performAction.call(w, h, j, i, this.yy, t[1], e, f);if (typeof v != "undefined") return v;y && (d = d.slice(0, -1 * y * 2), e = e.slice(0, -1 * y), f = f.slice(0, -1 * y)), d.push(this.productions_[t[1]][0]), e.push(w.$), f.push(w._$), z = g[d[d.length - 2]][d[d.length - 1]], d.push(z);break;case 3:
	              return !0;}
	        }return !0;
	      } },
	        b = function () {
	      var a = { EOF: 1, parseError: function parseError(b, c) {
	          if (!this.yy.parseError) throw new Error(b);this.yy.parseError(b, c);
	        }, setInput: function setInput(a) {
	          return this._input = a, this._more = this._less = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 }, this;
	        }, input: function input() {
	          var a = this._input[0];this.yytext += a, this.yyleng++, this.match += a, this.matched += a;var b = a.match(/\n/);return b && this.yylineno++, this._input = this._input.slice(1), a;
	        }, unput: function unput(a) {
	          return this._input = a + this._input, this;
	        }, more: function more() {
	          return this._more = !0, this;
	        }, less: function less(a) {
	          this._input = this.match.slice(a) + this._input;
	        }, pastInput: function pastInput() {
	          var a = this.matched.substr(0, this.matched.length - this.match.length);return (a.length > 20 ? "..." : "") + a.substr(-20).replace(/\n/g, "");
	        }, upcomingInput: function upcomingInput() {
	          var a = this.match;return a.length < 20 && (a += this._input.substr(0, 20 - a.length)), (a.substr(0, 20) + (a.length > 20 ? "..." : "")).replace(/\n/g, "");
	        }, showPosition: function showPosition() {
	          var a = this.pastInput(),
	              b = new Array(a.length + 1).join("-");return a + this.upcomingInput() + "\n" + b + "^";
	        }, next: function next() {
	          if (this.done) return this.EOF;this._input || (this.done = !0);var a, b, c, d, e, f;this._more || (this.yytext = "", this.match = "");var g = this._currentRules();for (var h = 0; h < g.length; h++) {
	            c = this._input.match(this.rules[g[h]]);if (c && (!b || c[0].length > b[0].length)) {
	              b = c, d = h;if (!this.options.flex) break;
	            }
	          }if (b) {
	            f = b[0].match(/\n.*/g), f && (this.yylineno += f.length), this.yylloc = { first_line: this.yylloc.last_line, last_line: this.yylineno + 1, first_column: this.yylloc.last_column, last_column: f ? f[f.length - 1].length - 1 : this.yylloc.last_column + b[0].length }, this.yytext += b[0], this.match += b[0], this.yyleng = this.yytext.length, this._more = !1, this._input = this._input.slice(b[0].length), this.matched += b[0], a = this.performAction.call(this, this.yy, this, g[d], this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1);if (a) return a;return;
	          }if (this._input === "") return this.EOF;this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), { text: "", token: null, line: this.yylineno });
	        }, lex: function lex() {
	          var b = this.next();return typeof b != "undefined" ? b : this.lex();
	        }, begin: function begin(b) {
	          this.conditionStack.push(b);
	        }, popState: function popState() {
	          return this.conditionStack.pop();
	        }, _currentRules: function _currentRules() {
	          return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
	        }, topState: function topState() {
	          return this.conditionStack[this.conditionStack.length - 2];
	        }, pushState: function pushState(b) {
	          this.begin(b);
	        } };return a.options = {}, a.performAction = function (b, c, d, e) {
	        var f = e;switch (d) {case 0:
	            break;case 1:
	            return 6;case 2:
	            return c.yytext = c.yytext.substr(1, c.yyleng - 2), 4;case 3:
	            return 17;case 4:
	            return 18;case 5:
	            return 23;case 6:
	            return 24;case 7:
	            return 22;case 8:
	            return 21;case 9:
	            return 10;case 10:
	            return 11;case 11:
	            return 8;case 12:
	            return 14;case 13:
	            return "INVALID";}
	      }, a.rules = [/^(?:\s+)/, /^(?:(-?([0-9]|[1-9][0-9]+))(\.[0-9]+)?([eE][-+]?[0-9]+)?\b)/, /^(?:"(?:\\[\\"bfnrt/]|\\u[a-fA-F0-9]{4}|[^\\\0-\x09\x0a-\x1f"])*")/, /^(?:\{)/, /^(?:\})/, /^(?:\[)/, /^(?:\])/, /^(?:,)/, /^(?::)/, /^(?:true\b)/, /^(?:false\b)/, /^(?:null\b)/, /^(?:$)/, /^(?:.)/], a.conditions = { INITIAL: { rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13], inclusive: !0 } }, a;
	    }();return a.lexer = b, a;
	  }();return typeof a != "undefined" && typeof c != "undefined" && (c.parser = d, c.parse = function () {
	    return d.parse.apply(d, arguments);
	  }, c.main = function (d) {
	    if (!d[1]) throw new Error("Usage: " + d[0] + " FILE");if (typeof process != "undefined") var e = a("fs").readFileSync(a("path").join(process.cwd(), d[1]), "utf8");else var f = a("file").path(a("file").cwd()),
	        e = f.join(d[1]).read({ charset: "utf-8" });return c.parser.parse(e);
	  }, typeof b != "undefined" && a.main === b && c.main(typeof process != "undefined" ? process.argv.slice(1) : a("system").args)), c;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ },
/* 185 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function now() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? other + '' : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
	}
	
	module.exports = debounce;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/**
	 * @license
	 * lodash <https://lodash.com/>
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */;(function(){/** Used as a safe reference for `undefined` in pre-ES5 environments. */var undefined;/** Used as the semantic version number. */var VERSION='4.16.4';/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/** Error message constants. */var CORE_ERROR_TEXT='Unsupported core-js use. Try https://github.com/es-shims.',FUNC_ERROR_TEXT='Expected a function';/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used as the maximum memoize cache size. */var MAX_MEMOIZE_SIZE=500;/** Used as the internal argument placeholder. */var PLACEHOLDER='__lodash_placeholder__';/** Used to compose bitmasks for function metadata. */var BIND_FLAG=1,BIND_KEY_FLAG=2,CURRY_BOUND_FLAG=4,CURRY_FLAG=8,CURRY_RIGHT_FLAG=16,PARTIAL_FLAG=32,PARTIAL_RIGHT_FLAG=64,ARY_FLAG=128,REARG_FLAG=256,FLIP_FLAG=512;/** Used to compose bitmasks for comparison styles. */var UNORDERED_COMPARE_FLAG=1,PARTIAL_COMPARE_FLAG=2;/** Used as default options for `_.truncate`. */var DEFAULT_TRUNC_LENGTH=30,DEFAULT_TRUNC_OMISSION='...';/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=500,HOT_SPAN=16;/** Used to indicate the type of lazy iteratees. */var LAZY_FILTER_FLAG=1,LAZY_MAP_FLAG=2,LAZY_WHILE_FLAG=3;/** Used as references for various `Number` constants. */var INFINITY=1/0,MAX_SAFE_INTEGER=9007199254740991,MAX_INTEGER=1.7976931348623157e+308,NAN=0/0;/** Used as references for the maximum length and index of an array. */var MAX_ARRAY_LENGTH=4294967295,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;/** Used to associate wrap methods with their bit flags. */var wrapFlags=[['ary',ARY_FLAG],['bind',BIND_FLAG],['bindKey',BIND_KEY_FLAG],['curry',CURRY_FLAG],['curryRight',CURRY_RIGHT_FLAG],['flip',FLIP_FLAG],['partial',PARTIAL_FLAG],['partialRight',PARTIAL_RIGHT_FLAG],['rearg',REARG_FLAG]];/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',boolTag='[object Boolean]',dateTag='[object Date]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',objectTag='[object Object]',promiseTag='[object Promise]',proxyTag='[object Proxy]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',weakMapTag='[object WeakMap]',weakSetTag='[object WeakSet]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to match empty string literals in compiled template source. */var reEmptyStringLeading=/\b__p \+= '';/g,reEmptyStringMiddle=/\b(__p \+=) '' \+/g,reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;/** Used to match HTML entities and HTML characters. */var reEscapedHtml=/&(?:amp|lt|gt|quot|#39);/g,reUnescapedHtml=/[&<>"']/g,reHasEscapedHtml=RegExp(reEscapedHtml.source),reHasUnescapedHtml=RegExp(reUnescapedHtml.source);/** Used to match template delimiters. */var reEscape=/<%-([\s\S]+?)%>/g,reEvaluate=/<%([\s\S]+?)%>/g,reInterpolate=/<%=([\s\S]+?)%>/g;/** Used to match property names within property paths. */var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/,reLeadingDot=/^\./,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;/**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/** Used to match leading and trailing whitespace. */var reTrim=/^\s+|\s+$/g,reTrimStart=/^\s+/,reTrimEnd=/\s+$/;/** Used to match wrap detail comments. */var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,reSplitDetails=/,? & /;/** Used to match words composed of alphanumeric characters. */var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;/** Used to match backslashes in property paths. */var reEscapeChar=/\\(\\)?/g;/**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary=/^0b[01]+$/i;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used to detect octal string values. */var reIsOctal=/^0o[0-7]+$/i;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/** Used to match Latin Unicode letters (excluding mathematical operators). */var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;/** Used to ensure capturing order of template delimiters. */var reNoMatch=/($^)/;/** Used to match unescaped characters in compiled string literals. */var reUnescapedString=/['\n\r\u2028\u2029\\]/g;/** Used to compose unicode character classes. */var rsAstralRange='\\ud800-\\udfff',rsComboMarksRange='\\u0300-\\u036f\\ufe20-\\ufe23',rsComboSymbolsRange='\\u20d0-\\u20f0',rsDingbatRange='\\u2700-\\u27bf',rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',rsMathOpRange='\\xac\\xb1\\xd7\\xf7',rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',rsPunctuationRange='\\u2000-\\u206f',rsSpaceRange=' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',rsVarRange='\\ufe0e\\ufe0f',rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;/** Used to compose unicode capture groups. */var rsApos='[\'\u2019]',rsAstral='['+rsAstralRange+']',rsBreak='['+rsBreakRange+']',rsCombo='['+rsComboMarksRange+rsComboSymbolsRange+']',rsDigits='\\d+',rsDingbat='['+rsDingbatRange+']',rsLower='['+rsLowerRange+']',rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',rsFitz='\\ud83c[\\udffb-\\udfff]',rsModifier='(?:'+rsCombo+'|'+rsFitz+')',rsNonAstral='[^'+rsAstralRange+']',rsRegional='(?:\\ud83c[\\udde6-\\uddff]){2}',rsSurrPair='[\\ud800-\\udbff][\\udc00-\\udfff]',rsUpper='['+rsUpperRange+']',rsZWJ='\\u200d';/** Used to compose unicode regexes. */var rsLowerMisc='(?:'+rsLower+'|'+rsMisc+')',rsUpperMisc='(?:'+rsUpper+'|'+rsMisc+')',rsOptLowerContr='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',rsOptUpperContr='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',reOptMod=rsModifier+'?',rsOptVar='['+rsVarRange+']?',rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',rsSeq=rsOptVar+reOptMod+rsOptJoin,rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';/** Used to match apostrophes. */var reApos=RegExp(rsApos,'g');/**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */var reComboMark=RegExp(rsCombo,'g');/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');/** Used to match complex or compound words. */var reUnicodeWord=RegExp([rsUpper+'?'+rsLower+'+'+rsOptLowerContr+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',rsUpperMisc+'+'+rsOptUpperContr+'(?='+[rsBreak,rsUpper+rsLowerMisc,'$'].join('|')+')',rsUpper+'?'+rsLowerMisc+'+'+rsOptLowerContr,rsUpper+'+'+rsOptUpperContr,rsDigits,rsEmoji].join('|'),'g');/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboMarksRange+rsComboSymbolsRange+rsVarRange+']');/** Used to detect strings that need a more robust regexp to match words. */var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;/** Used to assign default `context` object properties. */var contextProps=['Array','Buffer','DataView','Date','Error','Float32Array','Float64Array','Function','Int8Array','Int16Array','Int32Array','Map','Math','Object','Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array','Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap','_','clearTimeout','isFinite','parseInt','setTimeout'];/** Used to make template sourceURLs easier to identify. */var templateCounter=-1;/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/** Used to map Latin Unicode letters to basic Latin letters. */var deburredLetters={// Latin-1 Supplement block.
	'\xc0':'A','\xc1':'A','\xc2':'A','\xc3':'A','\xc4':'A','\xc5':'A','\xe0':'a','\xe1':'a','\xe2':'a','\xe3':'a','\xe4':'a','\xe5':'a','\xc7':'C','\xe7':'c','\xd0':'D','\xf0':'d','\xc8':'E','\xc9':'E','\xca':'E','\xcb':'E','\xe8':'e','\xe9':'e','\xea':'e','\xeb':'e','\xcc':'I','\xcd':'I','\xce':'I','\xcf':'I','\xec':'i','\xed':'i','\xee':'i','\xef':'i','\xd1':'N','\xf1':'n','\xd2':'O','\xd3':'O','\xd4':'O','\xd5':'O','\xd6':'O','\xd8':'O','\xf2':'o','\xf3':'o','\xf4':'o','\xf5':'o','\xf6':'o','\xf8':'o','\xd9':'U','\xda':'U','\xdb':'U','\xdc':'U','\xf9':'u','\xfa':'u','\xfb':'u','\xfc':'u','\xdd':'Y','\xfd':'y','\xff':'y','\xc6':'Ae','\xe6':'ae','\xde':'Th','\xfe':'th','\xdf':'ss',// Latin Extended-A block.
	'\u0100':'A','\u0102':'A','\u0104':'A','\u0101':'a','\u0103':'a','\u0105':'a','\u0106':'C','\u0108':'C','\u010A':'C','\u010C':'C','\u0107':'c','\u0109':'c','\u010B':'c','\u010D':'c','\u010E':'D','\u0110':'D','\u010F':'d','\u0111':'d','\u0112':'E','\u0114':'E','\u0116':'E','\u0118':'E','\u011A':'E','\u0113':'e','\u0115':'e','\u0117':'e','\u0119':'e','\u011B':'e','\u011C':'G','\u011E':'G','\u0120':'G','\u0122':'G','\u011D':'g','\u011F':'g','\u0121':'g','\u0123':'g','\u0124':'H','\u0126':'H','\u0125':'h','\u0127':'h','\u0128':'I','\u012A':'I','\u012C':'I','\u012E':'I','\u0130':'I','\u0129':'i','\u012B':'i','\u012D':'i','\u012F':'i','\u0131':'i','\u0134':'J','\u0135':'j','\u0136':'K','\u0137':'k','\u0138':'k','\u0139':'L','\u013B':'L','\u013D':'L','\u013F':'L','\u0141':'L','\u013A':'l','\u013C':'l','\u013E':'l','\u0140':'l','\u0142':'l','\u0143':'N','\u0145':'N','\u0147':'N','\u014A':'N','\u0144':'n','\u0146':'n','\u0148':'n','\u014B':'n','\u014C':'O','\u014E':'O','\u0150':'O','\u014D':'o','\u014F':'o','\u0151':'o','\u0154':'R','\u0156':'R','\u0158':'R','\u0155':'r','\u0157':'r','\u0159':'r','\u015A':'S','\u015C':'S','\u015E':'S','\u0160':'S','\u015B':'s','\u015D':'s','\u015F':'s','\u0161':'s','\u0162':'T','\u0164':'T','\u0166':'T','\u0163':'t','\u0165':'t','\u0167':'t','\u0168':'U','\u016A':'U','\u016C':'U','\u016E':'U','\u0170':'U','\u0172':'U','\u0169':'u','\u016B':'u','\u016D':'u','\u016F':'u','\u0171':'u','\u0173':'u','\u0174':'W','\u0175':'w','\u0176':'Y','\u0177':'y','\u0178':'Y','\u0179':'Z','\u017B':'Z','\u017D':'Z','\u017A':'z','\u017C':'z','\u017E':'z','\u0132':'IJ','\u0133':'ij','\u0152':'Oe','\u0153':'oe','\u0149':"'n",'\u017F':'s'};/** Used to map characters to HTML entities. */var htmlEscapes={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};/** Used to map HTML entities to characters. */var htmlUnescapes={'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'"};/** Used to escape characters for inclusion in compiled string literals. */var stringEscapes={'\\':'\\',"'":"'",'\n':'n','\r':'r','\u2028':'u2028','\u2029':'u2029'};/** Built-in method references without a dependency on `root`. */var freeParseFloat=parseFloat,freeParseInt=parseInt;/** Detect free variable `global` from Node.js. */var freeGlobal=(typeof global==='undefined'?'undefined':_typeof(global))=='object'&&global&&global.Object===Object&&global;/** Detect free variable `self`. */var freeSelf=(typeof self==='undefined'?'undefined':_typeof(self))=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();/** Detect free variable `exports`. */var freeExports=( false?'undefined':_typeof(exports))=='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&( false?'undefined':_typeof(module))=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{return freeProcess&&freeProcess.binding('util');}catch(e){}}();/* Node.js helper references. */var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,nodeIsDate=nodeUtil&&nodeUtil.isDate,nodeIsMap=nodeUtil&&nodeUtil.isMap,nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,nodeIsSet=nodeUtil&&nodeUtil.isSet,nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/*--------------------------------------------------------------------------*//**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */function addMapEntry(map,pair){// Don't return `map.set` because it's not chainable in IE 11.
	map.set(pair[0],pair[1]);return map;}/**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */function addSetEntry(set,value){// Don't return `set.add` because it's not chainable in IE 11.
	set.add(value);return set;}/**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}/**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */function arrayAggregator(array,setter,iteratee,accumulator){var index=-1,length=array?array.length:0;while(++index<length){var value=array[index];setter(accumulator,value,iteratee(value),array);}return accumulator;}/**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */function arrayEach(array,iteratee){var index=-1,length=array?array.length:0;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}/**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */function arrayEachRight(array,iteratee){var length=array?array.length:0;while(length--){if(iteratee(array[length],length,array)===false){break;}}return array;}/**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */function arrayEvery(array,predicate){var index=-1,length=array?array.length:0;while(++index<length){if(!predicate(array[index],index,array)){return false;}}return true;}/**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */function arrayFilter(array,predicate){var index=-1,length=array?array.length:0,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}/**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */function arrayIncludes(array,value){var length=array?array.length:0;return!!length&&baseIndexOf(array,value,0)>-1;}/**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */function arrayIncludesWith(array,value,comparator){var index=-1,length=array?array.length:0;while(++index<length){if(comparator(value,array[index])){return true;}}return false;}/**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */function arrayMap(array,iteratee){var index=-1,length=array?array.length:0,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}/**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}/**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */function arrayReduce(array,iteratee,accumulator,initAccum){var index=-1,length=array?array.length:0;if(initAccum&&length){accumulator=array[++index];}while(++index<length){accumulator=iteratee(accumulator,array[index],index,array);}return accumulator;}/**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */function arrayReduceRight(array,iteratee,accumulator,initAccum){var length=array?array.length:0;if(initAccum&&length){accumulator=array[--length];}while(length--){accumulator=iteratee(accumulator,array[length],length,array);}return accumulator;}/**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */function arraySome(array,predicate){var index=-1,length=array?array.length:0;while(++index<length){if(predicate(array[index],index,array)){return true;}}return false;}/**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */var asciiSize=baseProperty('length');/**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function asciiToArray(string){return string.split('');}/**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */function asciiWords(string){return string.match(reAsciiWord)||[];}/**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */function baseFindKey(collection,predicate,eachFunc){var result;eachFunc(collection,function(value,key,collection){if(predicate(value,key,collection)){result=key;return false;}});return result;}/**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseFindIndex(array,predicate,fromIndex,fromRight){var length=array.length,index=fromIndex+(fromRight?1:-1);while(fromRight?index--:++index<length){if(predicate(array[index],index,array)){return index;}}return-1;}/**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseIndexOf(array,value,fromIndex){return value===value?strictIndexOf(array,value,fromIndex):baseFindIndex(array,baseIsNaN,fromIndex);}/**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseIndexOfWith(array,value,fromIndex,comparator){var index=fromIndex-1,length=array.length;while(++index<length){if(comparator(array[index],value)){return index;}}return-1;}/**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */function baseIsNaN(value){return value!==value;}/**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */function baseMean(array,iteratee){var length=array?array.length:0;return length?baseSum(array,iteratee)/length:NAN;}/**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */function baseProperty(key){return function(object){return object==null?undefined:object[key];};}/**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */function basePropertyOf(object){return function(key){return object==null?undefined:object[key];};}/**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){eachFunc(collection,function(value,index,collection){accumulator=initAccum?(initAccum=false,value):iteratee(accumulator,value,index,collection);});return accumulator;}/**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */function baseSortBy(array,comparer){var length=array.length;array.sort(comparer);while(length--){array[length]=array[length].value;}return array;}/**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */function baseSum(array,iteratee){var result,index=-1,length=array.length;while(++index<length){var current=iteratee(array[index]);if(current!==undefined){result=result===undefined?current:result+current;}}return result;}/**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}/**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */function baseToPairs(object,props){return arrayMap(props,function(key){return[key,object[key]];});}/**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */function baseUnary(func){return function(value){return func(value);};}/**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */function baseValues(object,props){return arrayMap(props,function(key){return object[key];});}/**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */function cacheHas(cache,key){return cache.has(key);}/**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */function charsStartIndex(strSymbols,chrSymbols){var index=-1,length=strSymbols.length;while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */function charsEndIndex(strSymbols,chrSymbols){var index=strSymbols.length;while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */function countHolders(array,placeholder){var length=array.length,result=0;while(length--){if(array[length]===placeholder){++result;}}return result;}/**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */var deburrLetter=basePropertyOf(deburredLetters);/**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */var escapeHtmlChar=basePropertyOf(htmlEscapes);/**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */function escapeStringChar(chr){return'\\'+stringEscapes[chr];}/**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */function getValue(object,key){return object==null?undefined:object[key];}/**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */function hasUnicode(string){return reHasUnicode.test(string);}/**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */function hasUnicodeWord(string){return reHasUnicodeWord.test(string);}/**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */function iteratorToArray(iterator){var data,result=[];while(!(data=iterator.next()).done){result.push(data.value);}return result;}/**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */function mapToArray(map){var index=-1,result=Array(map.size);map.forEach(function(value,key){result[++index]=[key,value];});return result;}/**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */function overArg(func,transform){return function(arg){return func(transform(arg));};}/**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */function replaceHolders(array,placeholder){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value===placeholder||value===PLACEHOLDER){array[index]=PLACEHOLDER;result[resIndex++]=index;}}return result;}/**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */function setToArray(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=value;});return result;}/**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */function setToPairs(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=[value,value];});return result;}/**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function strictIndexOf(array,value,fromIndex){var index=fromIndex-1,length=array.length;while(++index<length){if(array[index]===value){return index;}}return-1;}/**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function strictLastIndexOf(array,value,fromIndex){var index=fromIndex+1;while(index--){if(array[index]===value){return index;}}return index;}/**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */function stringSize(string){return hasUnicode(string)?unicodeSize(string):asciiSize(string);}/**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}/**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */var unescapeHtmlChar=basePropertyOf(htmlUnescapes);/**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */function unicodeSize(string){var result=reUnicode.lastIndex=0;while(reUnicode.test(string)){++result;}return result;}/**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function unicodeToArray(string){return string.match(reUnicode)||[];}/**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */function unicodeWords(string){return string.match(reUnicodeWord)||[];}/*--------------------------------------------------------------------------*//**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */var runInContext=function runInContext(context){context=context?_.defaults(root.Object(),context,_.pick(root,contextProps)):root;/** Built-in constructor references. */var Array=context.Array,Date=context.Date,Error=context.Error,Function=context.Function,Math=context.Math,Object=context.Object,RegExp=context.RegExp,String=context.String,TypeError=context.TypeError;/** Used for built-in method references. */var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;/** Used to detect overreaching core-js shims. */var coreJsData=context['__core-js_shared__'];/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to generate unique IDs. */var idCounter=0;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */var objectToString=objectProto.toString;/** Used to restore the original `_` reference in `_.noConflict`. */var oldDash=root._;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/** Built-in value references. */var Buffer=moduleExports?context.Buffer:undefined,_Symbol=context.Symbol,Uint8Array=context.Uint8Array,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined,getPrototype=overArg(Object.getPrototypeOf,Object),iteratorSymbol=_Symbol?_Symbol.iterator:undefined,objectCreate=Object.create,propertyIsEnumerable=objectProto.propertyIsEnumerable,splice=arrayProto.splice,spreadableSymbol=_Symbol?_Symbol.isConcatSpreadable:undefined;var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();/** Mocked built-ins. */var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,ctxNow=Date&&Date.now!==root.Date.now&&Date.now,ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeCeil=Math.ceil,nativeFloor=Math.floor,nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer?Buffer.isBuffer:undefined,nativeIsFinite=context.isFinite,nativeJoin=arrayProto.join,nativeKeys=overArg(Object.keys,Object),nativeMax=Math.max,nativeMin=Math.min,nativeNow=Date.now,nativeParseInt=context.parseInt,nativeRandom=Math.random,nativeReverse=arrayProto.reverse;/* Built-in method references that are verified to be native. */var DataView=getNative(context,'DataView'),Map=getNative(context,'Map'),Promise=getNative(context,'Promise'),Set=getNative(context,'Set'),WeakMap=getNative(context,'WeakMap'),nativeCreate=getNative(Object,'create');/** Used to store function metadata. */var metaMap=WeakMap&&new WeakMap();/** Used to lookup unminified function names. */var realNames={};/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/** Used to convert symbols to primitives and strings. */var symbolProto=_Symbol?_Symbol.prototype:undefined,symbolValueOf=symbolProto?symbolProto.valueOf:undefined,symbolToString=symbolProto?symbolProto.toString:undefined;/*------------------------------------------------------------------------*//**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array of at least `200` elements
	     * and any iteratees accept only one argument. The heuristic for whether a
	     * section qualifies for shortcut fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */function lodash(value){if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){if(value instanceof LodashWrapper){return value;}if(hasOwnProperty.call(value,'__wrapped__')){return wrapperClone(value);}}return new LodashWrapper(value);}/**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return{};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined;return result;};}();/**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */function baseLodash(){}// No operation performed.
	/**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */function LodashWrapper(value,chainAll){this.__wrapped__=value;this.__actions__=[];this.__chain__=!!chainAll;this.__index__=0;this.__values__=undefined;}/**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */lodash.templateSettings={/**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'escape':reEscape,/**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'evaluate':reEvaluate,/**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'interpolate':reInterpolate,/**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */'variable':'',/**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */'imports':{/**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */'_':lodash}};// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype=baseLodash.prototype;lodash.prototype.constructor=lodash;LodashWrapper.prototype=baseCreate(baseLodash.prototype);LodashWrapper.prototype.constructor=LodashWrapper;/*------------------------------------------------------------------------*//**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */function LazyWrapper(value){this.__wrapped__=value;this.__actions__=[];this.__dir__=1;this.__filtered__=false;this.__iteratees__=[];this.__takeCount__=MAX_ARRAY_LENGTH;this.__views__=[];}/**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */function lazyClone(){var result=new LazyWrapper(this.__wrapped__);result.__actions__=copyArray(this.__actions__);result.__dir__=this.__dir__;result.__filtered__=this.__filtered__;result.__iteratees__=copyArray(this.__iteratees__);result.__takeCount__=this.__takeCount__;result.__views__=copyArray(this.__views__);return result;}/**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */function lazyReverse(){if(this.__filtered__){var result=new LazyWrapper(this);result.__dir__=-1;result.__filtered__=true;}else{result=this.clone();result.__dir__*=-1;}return result;}/**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */function lazyValue(){var array=this.__wrapped__.value(),dir=this.__dir__,isArr=isArray(array),isRight=dir<0,arrLength=isArr?array.length:0,view=getView(0,arrLength,this.__views__),start=view.start,end=view.end,length=end-start,index=isRight?end:start-1,iteratees=this.__iteratees__,iterLength=iteratees.length,resIndex=0,takeCount=nativeMin(length,this.__takeCount__);if(!isArr||arrLength<LARGE_ARRAY_SIZE||arrLength==length&&takeCount==length){return baseWrapperValue(array,this.__actions__);}var result=[];outer:while(length--&&resIndex<takeCount){index+=dir;var iterIndex=-1,value=array[index];while(++iterIndex<iterLength){var data=iteratees[iterIndex],iteratee=data.iteratee,type=data.type,computed=iteratee(value);if(type==LAZY_MAP_FLAG){value=computed;}else if(!computed){if(type==LAZY_FILTER_FLAG){continue outer;}else{break outer;}}}result[resIndex++]=value;}return result;}// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype=baseCreate(baseLodash.prototype);LazyWrapper.prototype.constructor=LazyWrapper;/*------------------------------------------------------------------------*//**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function Hash(entries){var index=-1,length=entries?entries.length:0;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}/**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}/**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined:result;}return hasOwnProperty.call(data,key)?data[key]:undefined;}/**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined:hasOwnProperty.call(data,key);}/**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined?HASH_UNDEFINED:value;return this;}// Add methods to `Hash`.
	Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;/*------------------------------------------------------------------------*//**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function ListCache(entries){var index=-1,length=entries?entries.length:0;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */function listCacheClear(){this.__data__=[];this.size=0;}/**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else{splice.call(data,index,1);}--this.size;return true;}/**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined:data[index][1];}/**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}/**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else{data[index][1]=value;}return this;}// Add methods to `ListCache`.
	ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;/*------------------------------------------------------------------------*//**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function MapCache(entries){var index=-1,length=entries?entries.length:0;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */function mapCacheClear(){this.size=0;this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}/**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}/**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function mapCacheGet(key){return getMapData(this,key).get(key);}/**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function mapCacheHas(key){return getMapData(this,key).has(key);}/**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}// Add methods to `MapCache`.
	MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;/*------------------------------------------------------------------------*//**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */function SetCache(values){var index=-1,length=values?values.length:0;this.__data__=new MapCache();while(++index<length){this.add(values[index]);}}/**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */function setCacheAdd(value){this.__data__.set(value,HASH_UNDEFINED);return this;}/**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */function setCacheHas(value){return this.__data__.has(value);}// Add methods to `SetCache`.
	SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;SetCache.prototype.has=setCacheHas;/*------------------------------------------------------------------------*//**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}/**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */function stackClear(){this.__data__=new ListCache();this.size=0;}/**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}/**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function stackGet(key){return this.__data__.get(key);}/**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function stackHas(key){return this.__data__.has(key);}/**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}// Add methods to `Stack`.
	Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;/*------------------------------------------------------------------------*//**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
	key=='length'||// Node.js 0.10 has enumerable non-index properties on buffers.
	isBuff&&(key=='offset'||key=='parent')||// PhantomJS 2 has enumerable non-index properties on typed arrays.
	isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
	isIndex(key,length)))){result.push(key);}}return result;}/**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */function arraySample(array){var length=array.length;return length?array[baseRandom(0,length-1)]:undefined;}/**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */function arraySampleSize(array,n){return shuffleSelf(copyArray(array),baseClamp(n,0,array.length));}/**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */function arrayShuffle(array){return shuffleSelf(copyArray(array));}/**
	     * Used by `_.defaults` to customize its `_.assignIn` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */function assignInDefaults(objValue,srcValue,key,object){if(objValue===undefined||eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){return srcValue;}return objValue;}/**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function assignMergeValue(object,key,value){if(value!==undefined&&!eq(object[key],value)||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return-1;}/**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */function baseAggregator(collection,setter,iteratee,accumulator){baseEach(collection,function(value,key,collection){setter(accumulator,value,iteratee(value),collection);});return accumulator;}/**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}/**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{'configurable':true,'enumerable':true,'value':value,'writable':true});}else{object[key]=value;}}/**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths of elements to pick.
	     * @returns {Array} Returns the picked elements.
	     */function baseAt(object,paths){var index=-1,isNil=object==null,length=paths.length,result=Array(length);while(++index<length){result[index]=isNil?undefined:get(object,paths[index]);}return result;}/**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */function baseClamp(number,lower,upper){if(number===number){if(upper!==undefined){number=number<=upper?number:upper;}if(lower!==undefined){number=number>=lower?number:lower;}}return number;}/**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {boolean} [isFull] Specify a clone including symbols.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */function baseClone(value,isDeep,isFull,customizer,key,object,stack){var result;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=initCloneObject(isFunc?{}:value);if(!isDeep){return copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,baseClone,isDeep);}}// Check for circular references and return its corresponding clone.
	stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);var props=isArr?undefined:(isFull?getAllKeys:keys)(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
	assignValue(result,key,baseClone(subValue,isDeep,isFull,customizer,key,value,stack));});return result;}/**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */function baseConforms(source){var props=keys(source);return function(object){return baseConformsTo(object,source,props);};}/**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */function baseConformsTo(object,source,props){var length=props.length;if(object==null){return!length;}object=Object(object);while(length--){var key=props[length],predicate=source[key],value=object[key];if(value===undefined&&!(key in object)||!predicate(value)){return false;}}return true;}/**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */function baseDelay(func,wait,args){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return setTimeout(function(){func.apply(undefined,args);},wait);}/**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */function baseDifference(array,values,iteratee,comparator){var index=-1,includes=arrayIncludes,isCommon=true,length=array.length,result=[],valuesLength=values.length;if(!length){return result;}if(iteratee){values=arrayMap(values,baseUnary(iteratee));}if(comparator){includes=arrayIncludesWith;isCommon=false;}else if(values.length>=LARGE_ARRAY_SIZE){includes=cacheHas;isCommon=false;values=new SetCache(values);}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var valuesIndex=valuesLength;while(valuesIndex--){if(values[valuesIndex]===computed){continue outer;}}result.push(value);}else if(!includes(values,computed,comparator)){result.push(value);}}return result;}/**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */var baseEach=createBaseEach(baseForOwn);/**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */var baseEachRight=createBaseEach(baseForOwnRight,true);/**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */function baseEvery(collection,predicate){var result=true;baseEach(collection,function(value,index,collection){result=!!predicate(value,index,collection);return result;});return result;}/**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */function baseExtremum(array,iteratee,comparator){var index=-1,length=array.length;while(++index<length){var value=array[index],current=iteratee(value);if(current!=null&&(computed===undefined?current===current&&!isSymbol(current):comparator(current,computed))){var computed=current,result=value;}}return result;}/**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */function baseFill(array,value,start,end){var length=array.length;start=toInteger(start);if(start<0){start=-start>length?0:length+start;}end=end===undefined||end>length?length:toInteger(end);if(end<0){end+=length;}end=start>end?0:toLength(end);while(start<end){array[start++]=value;}return array;}/**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */function baseFilter(collection,predicate){var result=[];baseEach(collection,function(value,index,collection){if(predicate(value,index,collection)){result.push(value);}});return result;}/**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */function baseFlatten(array,depth,predicate,isStrict,result){var index=-1,length=array.length;predicate||(predicate=isFlattenable);result||(result=[]);while(++index<length){var value=array[index];if(depth>0&&predicate(value)){if(depth>1){// Recursively flatten arrays (susceptible to call stack limits).
	baseFlatten(value,depth-1,predicate,isStrict,result);}else{arrayPush(result,value);}}else if(!isStrict){result[result.length]=value;}}return result;}/**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */var baseFor=createBaseFor();/**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */var baseForRight=createBaseFor(true);/**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */function baseForOwn(object,iteratee){return object&&baseFor(object,iteratee,keys);}/**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */function baseForOwnRight(object,iteratee){return object&&baseForRight(object,iteratee,keys);}/**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */function baseFunctions(object,props){return arrayFilter(props,function(key){return isFunction(object[key]);});}/**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */function baseGet(object,path){path=isKey(path,object)?[path]:castPath(path);var index=0,length=path.length;while(object!=null&&index<length){object=object[toKey(path[index++])];}return index&&index==length?object:undefined;}/**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}/**
	     * The base implementation of `getTag`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */function baseGetTag(value){return objectToString.call(value);}/**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */function baseGt(value,other){return value>other;}/**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */function baseHas(object,key){return object!=null&&hasOwnProperty.call(object,key);}/**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */function baseHasIn(object,key){return object!=null&&key in Object(object);}/**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */function baseInRange(number,start,end){return number>=nativeMin(start,end)&&number<nativeMax(start,end);}/**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */function baseIntersection(arrays,iteratee,comparator){var includes=comparator?arrayIncludesWith:arrayIncludes,length=arrays[0].length,othLength=arrays.length,othIndex=othLength,caches=Array(othLength),maxLength=Infinity,result=[];while(othIndex--){var array=arrays[othIndex];if(othIndex&&iteratee){array=arrayMap(array,baseUnary(iteratee));}maxLength=nativeMin(array.length,maxLength);caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?new SetCache(othIndex&&array):undefined;}array=arrays[0];var index=-1,seen=caches[0];outer:while(++index<length&&result.length<maxLength){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(!(seen?cacheHas(seen,computed):includes(result,computed,comparator))){othIndex=othLength;while(--othIndex){var cache=caches[othIndex];if(!(cache?cacheHas(cache,computed):includes(arrays[othIndex],computed,comparator))){continue outer;}}if(seen){seen.push(computed);}result.push(value);}}return result;}/**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */function baseInverter(object,setter,iteratee,accumulator){baseForOwn(object,function(value,key,object){setter(accumulator,iteratee(value),key,object);});return accumulator;}/**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */function baseInvoke(object,path,args){if(!isKey(path,object)){path=castPath(path);object=parent(object,path);path=last(path);}var func=object==null?object:object[toKey(path)];return func==null?undefined:apply(func,object,args);}/**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */function baseIsArguments(value){return isObjectLike(value)&&objectToString.call(value)==argsTag;}/**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */function baseIsArrayBuffer(value){return isObjectLike(value)&&objectToString.call(value)==arrayBufferTag;}/**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */function baseIsDate(value){return isObjectLike(value)&&objectToString.call(value)==dateTag;}/**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {boolean} [bitmask] The bitmask of comparison flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - Unordered comparison
	     *     2 - Partial comparison
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */function baseIsEqual(value,other,customizer,bitmask,stack){if(value===other){return true;}if(value==null||other==null||!isObject(value)&&!isObjectLike(other)){return value!==value&&other!==other;}return baseIsEqualDeep(value,other,baseIsEqual,customizer,bitmask,stack);}/**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function baseIsEqualDeep(object,other,equalFunc,customizer,bitmask,stack){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=arrayTag,othTag=arrayTag;if(!objIsArr){objTag=getTag(object);objTag=objTag==argsTag?objectTag:objTag;}if(!othIsArr){othTag=getTag(other);othTag=othTag==argsTag?objectTag:othTag;}var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&isBuffer(object)){if(!isBuffer(other)){return false;}objIsArr=true;objIsObj=false;}if(isSameTag&&!objIsObj){stack||(stack=new Stack());return objIsArr||isTypedArray(object)?equalArrays(object,other,equalFunc,customizer,bitmask,stack):equalByTag(object,other,objTag,equalFunc,customizer,bitmask,stack);}if(!(bitmask&PARTIAL_COMPARE_FLAG)){var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');if(objIsWrapped||othIsWrapped){var objUnwrapped=objIsWrapped?object.value():object,othUnwrapped=othIsWrapped?other.value():other;stack||(stack=new Stack());return equalFunc(objUnwrapped,othUnwrapped,customizer,bitmask,stack);}}if(!isSameTag){return false;}stack||(stack=new Stack());return equalObjects(object,other,equalFunc,customizer,bitmask,stack);}/**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}/**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */function baseIsMatch(object,source,matchData,customizer){var index=matchData.length,length=index,noCustomizer=!customizer;if(object==null){return!length;}object=Object(object);while(index--){var data=matchData[index];if(noCustomizer&&data[2]?data[1]!==object[data[0]]:!(data[0]in object)){return false;}}while(++index<length){data=matchData[index];var key=data[0],objValue=object[key],srcValue=data[1];if(noCustomizer&&data[2]){if(objValue===undefined&&!(key in object)){return false;}}else{var stack=new Stack();if(customizer){var result=customizer(objValue,srcValue,key,object,source,stack);}if(!(result===undefined?baseIsEqual(srcValue,objValue,customizer,UNORDERED_COMPARE_FLAG|PARTIAL_COMPARE_FLAG,stack):result)){return false;}}}return true;}/**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}/**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */function baseIsRegExp(value){return isObject(value)&&objectToString.call(value)==regexpTag;}/**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}/**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[objectToString.call(value)];}/**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */function baseIteratee(value){// Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	// See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	if(typeof value=='function'){return value;}if(value==null){return identity;}if((typeof value==='undefined'?'undefined':_typeof(value))=='object'){return isArray(value)?baseMatchesProperty(value[0],value[1]):baseMatches(value);}return property(value);}/**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}/**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}/**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */function baseLt(value,other){return value<other;}/**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */function baseMap(collection,iteratee){var index=-1,result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value,key,collection){result[++index]=iteratee(value,key,collection);});return result;}/**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */function baseMatches(source){var matchData=getMatchData(source);if(matchData.length==1&&matchData[0][2]){return matchesStrictComparable(matchData[0][0],matchData[0][1]);}return function(object){return object===source||baseIsMatch(object,source,matchData);};}/**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */function baseMatchesProperty(path,srcValue){if(isKey(path)&&isStrictComparable(srcValue)){return matchesStrictComparable(toKey(path),srcValue);}return function(object){var objValue=get(object,path);return objValue===undefined&&objValue===srcValue?hasIn(object,path):baseIsEqual(srcValue,objValue,undefined,UNORDERED_COMPARE_FLAG|PARTIAL_COMPARE_FLAG);};}/**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){if(isObject(srcValue)){stack||(stack=new Stack());baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else{var newValue=customizer?customizer(object[key],srcValue,key+'',object,source,stack):undefined;if(newValue===undefined){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}/**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=object[key],srcValue=source[key],stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined;var isCommon=newValue===undefined;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else{newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||srcIndex&&isFunction(objValue)){newValue=initCloneObject(srcValue);}}else{isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
	stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}/**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */function baseNth(array,n){var length=array.length;if(!length){return;}n+=n<0?length:0;return isIndex(n,length)?array[n]:undefined;}/**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */function baseOrderBy(collection,iteratees,orders){var index=-1;iteratees=arrayMap(iteratees.length?iteratees:[identity],baseUnary(getIteratee()));var result=baseMap(collection,function(value,key,collection){var criteria=arrayMap(iteratees,function(iteratee){return iteratee(value);});return{'criteria':criteria,'index':++index,'value':value};});return baseSortBy(result,function(object,other){return compareMultiple(object,other,orders);});}/**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     */function basePick(object,props){object=Object(object);return basePickBy(object,props,function(value,key){return key in object;});}/**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick from.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */function basePickBy(object,props,predicate){var index=-1,length=props.length,result={};while(++index<length){var key=props[index],value=object[key];if(predicate(value,key)){baseAssignValue(result,key,value);}}return result;}/**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */function basePropertyDeep(path){return function(object){return baseGet(object,path);};}/**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */function basePullAll(array,values,iteratee,comparator){var indexOf=comparator?baseIndexOfWith:baseIndexOf,index=-1,length=values.length,seen=array;if(array===values){values=copyArray(values);}if(iteratee){seen=arrayMap(array,baseUnary(iteratee));}while(++index<length){var fromIndex=0,value=values[index],computed=iteratee?iteratee(value):value;while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){if(seen!==array){splice.call(seen,fromIndex,1);}splice.call(array,fromIndex,1);}}return array;}/**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */function basePullAt(array,indexes){var length=array?indexes.length:0,lastIndex=length-1;while(length--){var index=indexes[length];if(length==lastIndex||index!==previous){var previous=index;if(isIndex(index)){splice.call(array,index,1);}else if(!isKey(index,array)){var path=castPath(index),object=parent(array,path);if(object!=null){delete object[toKey(last(path))];}}else{delete array[toKey(index)];}}}return array;}/**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */function baseRandom(lower,upper){return lower+nativeFloor(nativeRandom()*(upper-lower+1));}/**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */function baseRange(start,end,step,fromRight){var index=-1,length=nativeMax(nativeCeil((end-start)/(step||1)),0),result=Array(length);while(length--){result[fromRight?length:++index]=start;start+=step;}return result;}/**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */function baseRepeat(string,n){var result='';if(!string||n<1||n>MAX_SAFE_INTEGER){return result;}// Leverage the exponentiation by squaring algorithm for a faster repeat.
	// See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	do{if(n%2){result+=string;}n=nativeFloor(n/2);if(n){string+=string;}}while(n);return result;}/**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}/**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */function baseSample(collection){return arraySample(values(collection));}/**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */function baseSampleSize(collection,n){var array=values(collection);return shuffleSelf(array,baseClamp(n,0,array.length));}/**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */function baseSet(object,path,value,customizer){if(!isObject(object)){return object;}path=isKey(path,object)?[path]:castPath(path);var index=-1,length=path.length,lastIndex=length-1,nested=object;while(nested!=null&&++index<length){var key=toKey(path[index]),newValue=value;if(index!=lastIndex){var objValue=nested[key];newValue=customizer?customizer(objValue,key,nested):undefined;if(newValue===undefined){newValue=isObject(objValue)?objValue:isIndex(path[index+1])?[]:{};}}assignValue(nested,key,newValue);nested=nested[key];}return object;}/**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */var baseSetData=!metaMap?identity:function(func,data){metaMap.set(func,data);return func;};/**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{'configurable':true,'enumerable':false,'value':constant(string),'writable':true});};/**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */function baseShuffle(collection){return shuffleSelf(values(collection));}/**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */function baseSlice(array,start,end){var index=-1,length=array.length;if(start<0){start=-start>length?0:length+start;}end=end>length?length:end;if(end<0){end+=length;}length=start>end?0:end-start>>>0;start>>>=0;var result=Array(length);while(++index<length){result[index]=array[index+start];}return result;}/**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */function baseSome(collection,predicate){var result;baseEach(collection,function(value,index,collection){result=predicate(value,index,collection);return!result;});return!!result;}/**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */function baseSortedIndex(array,value,retHighest){var low=0,high=array?array.length:low;if(typeof value=='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){while(low<high){var mid=low+high>>>1,computed=array[mid];if(computed!==null&&!isSymbol(computed)&&(retHighest?computed<=value:computed<value)){low=mid+1;}else{high=mid;}}return high;}return baseSortedIndexBy(array,value,identity,retHighest);}/**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */function baseSortedIndexBy(array,value,iteratee,retHighest){value=iteratee(value);var low=0,high=array?array.length:0,valIsNaN=value!==value,valIsNull=value===null,valIsSymbol=isSymbol(value),valIsUndefined=value===undefined;while(low<high){var mid=nativeFloor((low+high)/2),computed=iteratee(array[mid]),othIsDefined=computed!==undefined,othIsNull=computed===null,othIsReflexive=computed===computed,othIsSymbol=isSymbol(computed);if(valIsNaN){var setLow=retHighest||othIsReflexive;}else if(valIsUndefined){setLow=othIsReflexive&&(retHighest||othIsDefined);}else if(valIsNull){setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);}else if(valIsSymbol){setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);}else if(othIsNull||othIsSymbol){setLow=false;}else{setLow=retHighest?computed<=value:computed<value;}if(setLow){low=mid+1;}else{high=mid;}}return nativeMin(high,MAX_ARRAY_INDEX);}/**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */function baseSortedUniq(array,iteratee){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;if(!index||!eq(computed,seen)){var seen=computed;result[resIndex++]=value===0?0:value;}}return result;}/**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */function baseToNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}return+value;}/**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
	if(typeof value=='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
	return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */function baseUniq(array,iteratee,comparator){var index=-1,includes=arrayIncludes,length=array.length,isCommon=true,result=[],seen=result;if(comparator){isCommon=false;includes=arrayIncludesWith;}else if(length>=LARGE_ARRAY_SIZE){var set=iteratee?null:createSet(array);if(set){return setToArray(set);}isCommon=false;includes=cacheHas;seen=new SetCache();}else{seen=iteratee?[]:result;}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var seenIndex=seen.length;while(seenIndex--){if(seen[seenIndex]===computed){continue outer;}}if(iteratee){seen.push(computed);}result.push(value);}else if(!includes(seen,computed,comparator)){if(seen!==result){seen.push(computed);}result.push(value);}}return result;}/**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */function baseUnset(object,path){path=isKey(path,object)?[path]:castPath(path);object=parent(object,path);var key=toKey(last(path));return!(object!=null&&hasOwnProperty.call(object,key))||delete object[key];}/**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */function baseUpdate(object,path,updater,customizer){return baseSet(object,path,updater(baseGet(object,path)),customizer);}/**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */function baseWhile(array,predicate,isDrop,fromRight){var length=array.length,index=fromRight?length:-1;while((fromRight?index--:++index<length)&&predicate(array[index],index,array)){}return isDrop?baseSlice(array,fromRight?0:index,fromRight?index+1:length):baseSlice(array,fromRight?index+1:0,fromRight?length:index);}/**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */function baseWrapperValue(value,actions){var result=value;if(result instanceof LazyWrapper){result=result.value();}return arrayReduce(actions,function(result,action){return action.func.apply(action.thisArg,arrayPush([result],action.args));},result);}/**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */function baseXor(arrays,iteratee,comparator){var index=-1,length=arrays.length;while(++index<length){var result=result?arrayPush(baseDifference(result,arrays[index],iteratee,comparator),baseDifference(arrays[index],result,iteratee,comparator)):arrays[index];}return result&&result.length?baseUniq(result,iteratee,comparator):[];}/**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */function baseZipObject(props,values,assignFunc){var index=-1,length=props.length,valsLength=values.length,result={};while(++index<length){var value=index<valsLength?values[index]:undefined;assignFunc(result,props[index],value);}return result;}/**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */function castArrayLikeObject(value){return isArrayLikeObject(value)?value:[];}/**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */function castFunction(value){return typeof value=='function'?value:identity;}/**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast property path array.
	     */function castPath(value){return isArray(value)?value:stringToPath(value);}/**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */var castRest=baseRest;/**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */function castSlice(array,start,end){var length=array.length;end=end===undefined?length:end;return!start&&end>=length?array:baseSlice(array,start,end);}/**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */var clearTimeout=ctxClearTimeout||function(id){return root.clearTimeout(id);};/**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}/**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}/**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}/**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */function cloneMap(map,isDeep,cloneFunc){var array=isDeep?cloneFunc(mapToArray(map),true):mapToArray(map);return arrayReduce(array,addMapEntry,new map.constructor());}/**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}/**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */function cloneSet(set,isDeep,cloneFunc){var array=isDeep?cloneFunc(setToArray(set),true):setToArray(set);return arrayReduce(array,addSetEntry,new set.constructor());}/**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}/**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}/**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */function compareAscending(value,other){if(value!==other){var valIsDefined=value!==undefined,valIsNull=value===null,valIsReflexive=value===value,valIsSymbol=isSymbol(value);var othIsDefined=other!==undefined,othIsNull=other===null,othIsReflexive=other===other,othIsSymbol=isSymbol(other);if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||valIsNull&&othIsDefined&&othIsReflexive||!valIsDefined&&othIsReflexive||!valIsReflexive){return 1;}if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||othIsNull&&valIsDefined&&valIsReflexive||!othIsDefined&&valIsReflexive||!othIsReflexive){return-1;}}return 0;}/**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */function compareMultiple(object,other,orders){var index=-1,objCriteria=object.criteria,othCriteria=other.criteria,length=objCriteria.length,ordersLength=orders.length;while(++index<length){var result=compareAscending(objCriteria[index],othCriteria[index]);if(result){if(index>=ordersLength){return result;}var order=orders[index];return result*(order=='desc'?-1:1);}}// Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	// that causes it, under certain circumstances, to provide the same value for
	// `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	// for more details.
	//
	// This also ensures a stable sort in V8 and other engines.
	// See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	return object.index-other.index;}/**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */function composeArgs(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersLength=holders.length,leftIndex=-1,leftLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(leftLength+rangeLength),isUncurried=!isCurried;while(++leftIndex<leftLength){result[leftIndex]=partials[leftIndex];}while(++argsIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[holders[argsIndex]]=args[argsIndex];}}while(rangeLength--){result[leftIndex++]=args[argsIndex++];}return result;}/**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */function composeArgsRight(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersIndex=-1,holdersLength=holders.length,rightIndex=-1,rightLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(rangeLength+rightLength),isUncurried=!isCurried;while(++argsIndex<rangeLength){result[argsIndex]=args[argsIndex];}var offset=argsIndex;while(++rightIndex<rightLength){result[offset+rightIndex]=partials[rightIndex];}while(++holdersIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[offset+holders[holdersIndex]]=args[argsIndex++];}}return result;}/**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}/**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined;if(newValue===undefined){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else{assignValue(object,key,newValue);}}return object;}/**
	     * Copies own symbol properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}/**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */function createAggregator(setter,initializer){return function(collection,iteratee){var func=isArray(collection)?arrayAggregator:baseAggregator,accumulator=initializer?initializer():{};return func(collection,setter,getIteratee(iteratee,2),accumulator);};}/**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined,guard=length>2?sources[2]:undefined;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}/**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){if(collection==null){return collection;}if(!isArrayLike(collection)){return eachFunc(collection,iteratee);}var length=collection.length,index=fromRight?length:-1,iterable=Object(collection);while(fromRight?index--:++index<length){if(iteratee(iterable[index],index,iterable)===false){break;}}return collection;};}/**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}/**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createBind(func,bitmask,thisArg){var isBind=bitmask&BIND_FLAG,Ctor=createCtor(func);function wrapper(){var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return fn.apply(isBind?thisArg:this,arguments);}return wrapper;}/**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */function createCaseFirst(methodName){return function(string){string=toString(string);var strSymbols=hasUnicode(string)?stringToArray(string):undefined;var chr=strSymbols?strSymbols[0]:string.charAt(0);var trailing=strSymbols?castSlice(strSymbols,1).join(''):string.slice(1);return chr[methodName]()+trailing;};}/**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */function createCompounder(callback){return function(string){return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');};}/**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */function createCtor(Ctor){return function(){// Use a `switch` statement to work with class constructors. See
	// http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	// for more details.
	var args=arguments;switch(args.length){case 0:return new Ctor();case 1:return new Ctor(args[0]);case 2:return new Ctor(args[0],args[1]);case 3:return new Ctor(args[0],args[1],args[2]);case 4:return new Ctor(args[0],args[1],args[2],args[3]);case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}var thisBinding=baseCreate(Ctor.prototype),result=Ctor.apply(thisBinding,args);// Mimic the constructor's `return` behavior.
	// See https://es5.github.io/#x13.2.2 for more details.
	return isObject(result)?result:thisBinding;};}/**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createCurry(func,bitmask,arity){var Ctor=createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length,placeholder=getHolder(wrapper);while(index--){args[index]=arguments[index];}var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?[]:replaceHolders(args,placeholder);length-=holders.length;if(length<arity){return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,undefined,args,holders,undefined,undefined,arity-length);}var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return apply(fn,this,args);}return wrapper;}/**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */function createFind(findIndexFunc){return function(collection,predicate,fromIndex){var iterable=Object(collection);if(!isArrayLike(collection)){var iteratee=getIteratee(predicate,3);collection=keys(collection);predicate=function predicate(key){return iteratee(iterable[key],key,iterable);};}var index=findIndexFunc(collection,predicate,fromIndex);return index>-1?iterable[iteratee?collection[index]:index]:undefined;};}/**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */function createFlow(fromRight){return flatRest(function(funcs){var length=funcs.length,index=length,prereq=LodashWrapper.prototype.thru;if(fromRight){funcs.reverse();}while(index--){var func=funcs[index];if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){var wrapper=new LodashWrapper([],true);}}index=wrapper?index:length;while(++index<length){func=funcs[index];var funcName=getFuncName(func),data=funcName=='wrapper'?getData(func):undefined;if(data&&isLaziable(data[0])&&data[1]==(ARY_FLAG|CURRY_FLAG|PARTIAL_FLAG|REARG_FLAG)&&!data[4].length&&data[9]==1){wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);}else{wrapper=func.length==1&&isLaziable(func)?wrapper[funcName]():wrapper.thru(func);}}return function(){var args=arguments,value=args[0];if(wrapper&&args.length==1&&isArray(value)&&value.length>=LARGE_ARRAY_SIZE){return wrapper.plant(value).value();}var index=0,result=length?funcs[index].apply(this,args):value;while(++index<length){result=funcs[index].call(this,result);}return result;};});}/**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){var isAry=bitmask&ARY_FLAG,isBind=bitmask&BIND_FLAG,isBindKey=bitmask&BIND_KEY_FLAG,isCurried=bitmask&(CURRY_FLAG|CURRY_RIGHT_FLAG),isFlip=bitmask&FLIP_FLAG,Ctor=isBindKey?undefined:createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length;while(index--){args[index]=arguments[index];}if(isCurried){var placeholder=getHolder(wrapper),holdersCount=countHolders(args,placeholder);}if(partials){args=composeArgs(args,partials,holders,isCurried);}if(partialsRight){args=composeArgsRight(args,partialsRight,holdersRight,isCurried);}length-=holdersCount;if(isCurried&&length<arity){var newHolders=replaceHolders(args,placeholder);return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,thisArg,args,newHolders,argPos,ary,arity-length);}var thisBinding=isBind?thisArg:this,fn=isBindKey?thisBinding[func]:func;length=args.length;if(argPos){args=reorder(args,argPos);}else if(isFlip&&length>1){args.reverse();}if(isAry&&ary<length){args.length=ary;}if(this&&this!==root&&this instanceof wrapper){fn=Ctor||createCtor(fn);}return fn.apply(thisBinding,args);}return wrapper;}/**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */function createInverter(setter,toIteratee){return function(object,iteratee){return baseInverter(object,setter,toIteratee(iteratee),{});};}/**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */function createMathOperation(operator,defaultValue){return function(value,other){var result;if(value===undefined&&other===undefined){return defaultValue;}if(value!==undefined){result=value;}if(other!==undefined){if(result===undefined){return other;}if(typeof value=='string'||typeof other=='string'){value=baseToString(value);other=baseToString(other);}else{value=baseToNumber(value);other=baseToNumber(other);}result=operator(value,other);}return result;};}/**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */function createOver(arrayFunc){return flatRest(function(iteratees){iteratees=arrayMap(iteratees,baseUnary(getIteratee()));return baseRest(function(args){var thisArg=this;return arrayFunc(iteratees,function(iteratee){return apply(iteratee,thisArg,args);});});});}/**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */function createPadding(length,chars){chars=chars===undefined?' ':baseToString(chars);var charsLength=chars.length;if(charsLength<2){return charsLength?baseRepeat(chars,length):chars;}var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));return hasUnicode(chars)?castSlice(stringToArray(result),0,length).join(''):result.slice(0,length);}/**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */function createPartial(func,bitmask,thisArg,partials){var isBind=bitmask&BIND_FLAG,Ctor=createCtor(func);function wrapper(){var argsIndex=-1,argsLength=arguments.length,leftIndex=-1,leftLength=partials.length,args=Array(leftLength+argsLength),fn=this&&this!==root&&this instanceof wrapper?Ctor:func;while(++leftIndex<leftLength){args[leftIndex]=partials[leftIndex];}while(argsLength--){args[leftIndex++]=arguments[++argsIndex];}return apply(fn,isBind?thisArg:this,args);}return wrapper;}/**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */function createRange(fromRight){return function(start,end,step){if(step&&typeof step!='number'&&isIterateeCall(start,end,step)){end=step=undefined;}// Ensure the sign of `-0` is preserved.
	start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}step=step===undefined?start<end?1:-1:toFinite(step);return baseRange(start,end,step,fromRight);};}/**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */function createRelationalOperation(operator){return function(value,other){if(!(typeof value=='string'&&typeof other=='string')){value=toNumber(value);other=toNumber(other);}return operator(value,other);};}/**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){var isCurry=bitmask&CURRY_FLAG,newHolders=isCurry?holders:undefined,newHoldersRight=isCurry?undefined:holders,newPartials=isCurry?partials:undefined,newPartialsRight=isCurry?undefined:partials;bitmask|=isCurry?PARTIAL_FLAG:PARTIAL_RIGHT_FLAG;bitmask&=~(isCurry?PARTIAL_RIGHT_FLAG:PARTIAL_FLAG);if(!(bitmask&CURRY_BOUND_FLAG)){bitmask&=~(BIND_FLAG|BIND_KEY_FLAG);}var newData=[func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,newHoldersRight,argPos,ary,arity];var result=wrapFunc.apply(undefined,newData);if(isLaziable(func)){setData(result,newData);}result.placeholder=placeholder;return setWrapToString(result,func,bitmask);}/**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */function createRound(methodName){var func=Math[methodName];return function(number,precision){number=toNumber(number);precision=nativeMin(toInteger(precision),292);if(precision){// Shift with exponential notation to avoid floating-point issues.
	// See [MDN](https://mdn.io/round#Examples) for more details.
	var pair=(toString(number)+'e').split('e'),value=func(pair[0]+'e'+(+pair[1]+precision));pair=(toString(value)+'e').split('e');return+(pair[0]+'e'+(+pair[1]-precision));}return func(number);};}/**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){return new Set(values);};/**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */function createToPairs(keysFunc){return function(object){var tag=getTag(object);if(tag==mapTag){return mapToArray(object);}if(tag==setTag){return setToPairs(object);}return baseToPairs(object,keysFunc(object));};}/**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     *   512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){var isBindKey=bitmask&BIND_KEY_FLAG;if(!isBindKey&&typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var length=partials?partials.length:0;if(!length){bitmask&=~(PARTIAL_FLAG|PARTIAL_RIGHT_FLAG);partials=holders=undefined;}ary=ary===undefined?ary:nativeMax(toInteger(ary),0);arity=arity===undefined?arity:toInteger(arity);length-=holders?holders.length:0;if(bitmask&PARTIAL_RIGHT_FLAG){var partialsRight=partials,holdersRight=holders;partials=holders=undefined;}var data=isBindKey?undefined:getData(func);var newData=[func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity];if(data){mergeData(newData,data);}func=newData[0];bitmask=newData[1];thisArg=newData[2];partials=newData[3];holders=newData[4];arity=newData[9]=newData[9]==null?isBindKey?0:func.length:nativeMax(newData[9]-length,0);if(!arity&&bitmask&(CURRY_FLAG|CURRY_RIGHT_FLAG)){bitmask&=~(CURRY_FLAG|CURRY_RIGHT_FLAG);}if(!bitmask||bitmask==BIND_FLAG){var result=createBind(func,bitmask,thisArg);}else if(bitmask==CURRY_FLAG||bitmask==CURRY_RIGHT_FLAG){result=createCurry(func,bitmask,arity);}else if((bitmask==PARTIAL_FLAG||bitmask==(BIND_FLAG|PARTIAL_FLAG))&&!holders.length){result=createPartial(func,bitmask,thisArg,partials);}else{result=createHybrid.apply(undefined,newData);}var setter=data?baseSetData:setData;return setWrapToString(setter(result,newData),func,bitmask);}/**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */function equalArrays(array,other,equalFunc,customizer,bitmask,stack){var isPartial=bitmask&PARTIAL_COMPARE_FLAG,arrLength=array.length,othLength=other.length;if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){return false;}// Assume cyclic values are equal.
	var stacked=stack.get(array);if(stacked&&stack.get(other)){return stacked==other;}var index=-1,result=true,seen=bitmask&UNORDERED_COMPARE_FLAG?new SetCache():undefined;stack.set(array,other);stack.set(other,array);// Ignore non-index properties.
	while(++index<arrLength){var arrValue=array[index],othValue=other[index];if(customizer){var compared=isPartial?customizer(othValue,arrValue,index,other,array,stack):customizer(arrValue,othValue,index,array,other,stack);}if(compared!==undefined){if(compared){continue;}result=false;break;}// Recursively compare arrays (susceptible to call stack limits).
	if(seen){if(!arraySome(other,function(othValue,othIndex){if(!cacheHas(seen,othIndex)&&(arrValue===othValue||equalFunc(arrValue,othValue,customizer,bitmask,stack))){return seen.push(othIndex);}})){result=false;break;}}else if(!(arrValue===othValue||equalFunc(arrValue,othValue,customizer,bitmask,stack))){result=false;break;}}stack['delete'](array);stack['delete'](other);return result;}/**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function equalByTag(object,other,tag,equalFunc,customizer,bitmask,stack){switch(tag){case dataViewTag:if(object.byteLength!=other.byteLength||object.byteOffset!=other.byteOffset){return false;}object=object.buffer;other=other.buffer;case arrayBufferTag:if(object.byteLength!=other.byteLength||!equalFunc(new Uint8Array(object),new Uint8Array(other))){return false;}return true;case boolTag:case dateTag:case numberTag:// Coerce booleans to `1` or `0` and dates to milliseconds.
	// Invalid dates are coerced to `NaN`.
	return eq(+object,+other);case errorTag:return object.name==other.name&&object.message==other.message;case regexpTag:case stringTag:// Coerce regexes to strings and treat strings, primitives and objects,
	// as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	// for more details.
	return object==other+'';case mapTag:var convert=mapToArray;case setTag:var isPartial=bitmask&PARTIAL_COMPARE_FLAG;convert||(convert=setToArray);if(object.size!=other.size&&!isPartial){return false;}// Assume cyclic values are equal.
	var stacked=stack.get(object);if(stacked){return stacked==other;}bitmask|=UNORDERED_COMPARE_FLAG;// Recursively compare objects (susceptible to call stack limits).
	stack.set(object,other);var result=equalArrays(convert(object),convert(other),equalFunc,customizer,bitmask,stack);stack['delete'](object);return result;case symbolTag:if(symbolValueOf){return symbolValueOf.call(object)==symbolValueOf.call(other);}}return false;}/**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function equalObjects(object,other,equalFunc,customizer,bitmask,stack){var isPartial=bitmask&PARTIAL_COMPARE_FLAG,objProps=keys(object),objLength=objProps.length,othProps=keys(other),othLength=othProps.length;if(objLength!=othLength&&!isPartial){return false;}var index=objLength;while(index--){var key=objProps[index];if(!(isPartial?key in other:hasOwnProperty.call(other,key))){return false;}}// Assume cyclic values are equal.
	var stacked=stack.get(object);if(stacked&&stack.get(other)){return stacked==other;}var result=true;stack.set(object,other);stack.set(other,object);var skipCtor=isPartial;while(++index<objLength){key=objProps[index];var objValue=object[key],othValue=other[key];if(customizer){var compared=isPartial?customizer(othValue,objValue,key,other,object,stack):customizer(objValue,othValue,key,object,other,stack);}// Recursively compare objects (susceptible to call stack limits).
	if(!(compared===undefined?objValue===othValue||equalFunc(objValue,othValue,customizer,bitmask,stack):compared)){result=false;break;}skipCtor||(skipCtor=key=='constructor');}if(result&&!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;// Non `Object` object instances with different constructors are not equal.
	if(objCtor!=othCtor&&'constructor'in object&&'constructor'in other&&!(typeof objCtor=='function'&&objCtor instanceof objCtor&&typeof othCtor=='function'&&othCtor instanceof othCtor)){result=false;}}stack['delete'](object);stack['delete'](other);return result;}/**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */function flatRest(func){return setToString(overRest(func,undefined,flatten),func+'');}/**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}/**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}/**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */var getData=!metaMap?noop:function(func){return metaMap.get(func);};/**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */function getFuncName(func){var result=func.name+'',array=realNames[result],length=hasOwnProperty.call(realNames,result)?array.length:0;while(length--){var data=array[length],otherFunc=data.func;if(otherFunc==null||otherFunc==func){return data.name;}}return result;}/**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */function getHolder(func){var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;return object.placeholder;}/**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */function getIteratee(){var result=lodash.iteratee||iteratee;result=result===iteratee?baseIteratee:result;return arguments.length?result(arguments[0],arguments[1]):result;}/**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}/**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */function getMatchData(object){var result=keys(object),length=result.length;while(length--){var key=result[length],value=object[key];result[length]=[key,value,isStrictComparable(value)];}return result;}/**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined;}/**
	     * Creates an array of the own enumerable symbol properties of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */var getSymbols=nativeGetSymbols?overArg(nativeGetSymbols,Object):stubArray;/**
	     * Creates an array of the own and inherited enumerable symbol properties
	     * of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};/**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function getTag(value){var result=objectToString.call(value),Ctor=result==objectTag?value.constructor:undefined,ctorString=Ctor?toSource(Ctor):undefined;if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}/**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */function getView(start,end,transforms){var index=-1,length=transforms.length;while(++index<length){var data=transforms[index],size=data.size;switch(data.type){case'drop':start+=size;break;case'dropRight':end-=size;break;case'take':end=nativeMin(end,start+size);break;case'takeRight':start=nativeMax(start,end-size);break;}}return{'start':start,'end':end};}/**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */function getWrapDetails(source){var match=source.match(reWrapDetails);return match?match[1].split(reSplitDetails):[];}/**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */function hasPath(object,path,hasFunc){path=isKey(path,object)?[path]:castPath(path);var index=-1,length=path.length,result=false;while(++index<length){var key=toKey(path[index]);if(!(result=object!=null&&hasFunc(object,key))){break;}object=object[key];}if(result||++index!=length){return result;}length=object?object.length:0;return!!length&&isLength(length)&&isIndex(key,length)&&(isArray(object)||isArguments(object));}/**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */function initCloneArray(array){var length=array.length,result=array.constructor(length);// Add properties assigned by `RegExp#exec`.
	if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}/**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}/**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */function initCloneByTag(object,tag,cloneFunc,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return cloneMap(object,isDeep,cloneFunc);case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return cloneSet(object,isDeep,cloneFunc);case symbolTag:return cloneSymbol(object);}}/**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */function insertWrapDetails(source,details){var length=details.length;if(!length){return source;}var lastIndex=length-1;details[lastIndex]=(length>1?'& ':'')+details[lastIndex];details=details.join(length>2?', ':' ');return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');}/**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */function isFlattenable(value){return isArray(value)||isArguments(value)||!!(spreadableSymbol&&value&&value[spreadableSymbol]);}/**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */function isIndex(value,length){length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(typeof value=='number'||reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}/**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=typeof index==='undefined'?'undefined':_typeof(index);if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}/**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */function isKey(value,object){if(isArray(value)){return false;}var type=typeof value==='undefined'?'undefined':_typeof(value);if(type=='number'||type=='symbol'||type=='boolean'||value==null||isSymbol(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}/**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */function isKeyable(value){var type=typeof value==='undefined'?'undefined':_typeof(value);return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}/**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */function isLaziable(func){var funcName=getFuncName(func),other=lodash[funcName];if(typeof other!='function'||!(funcName in LazyWrapper.prototype)){return false;}if(func===other){return true;}var data=getData(other);return!!data&&func===data[0];}/**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}/**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */var isMaskable=coreJsData?isFunction:stubFalse;/**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}/**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */function isStrictComparable(value){return value===value&&!isObject(value);}/**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */function matchesStrictComparable(key,srcValue){return function(object){if(object==null){return false;}return object[key]===srcValue&&(srcValue!==undefined||key in Object(object));};}/**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */function memoizeCapped(func){var result=memoize(func,function(key){if(cache.size===MAX_MEMOIZE_SIZE){cache.clear();}return key;});var cache=result.cache;return result;}/**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */function mergeData(data,source){var bitmask=data[1],srcBitmask=source[1],newBitmask=bitmask|srcBitmask,isCommon=newBitmask<(BIND_FLAG|BIND_KEY_FLAG|ARY_FLAG);var isCombo=srcBitmask==ARY_FLAG&&bitmask==CURRY_FLAG||srcBitmask==ARY_FLAG&&bitmask==REARG_FLAG&&data[7].length<=source[8]||srcBitmask==(ARY_FLAG|REARG_FLAG)&&source[7].length<=source[8]&&bitmask==CURRY_FLAG;// Exit early if metadata can't be merged.
	if(!(isCommon||isCombo)){return data;}// Use source `thisArg` if available.
	if(srcBitmask&BIND_FLAG){data[2]=source[2];// Set when currying a bound function.
	newBitmask|=bitmask&BIND_FLAG?0:CURRY_BOUND_FLAG;}// Compose partial arguments.
	var value=source[3];if(value){var partials=data[3];data[3]=partials?composeArgs(partials,value,source[4]):value;data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];}// Compose partial right arguments.
	value=source[5];if(value){partials=data[5];data[5]=partials?composeArgsRight(partials,value,source[6]):value;data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];}// Use source `argPos` if available.
	value=source[7];if(value){data[7]=value;}// Use source `ary` if it's smaller.
	if(srcBitmask&ARY_FLAG){data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);}// Use source `arity` if one is not provided.
	if(data[9]==null){data[9]=source[9];}// Use source `func` and merge bitmasks.
	data[0]=source[0];data[1]=newBitmask;return data;}/**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */function mergeDefaults(objValue,srcValue,key,object,source,stack){if(isObject(objValue)&&isObject(srcValue)){// Recursively merge objects and arrays (susceptible to call stack limits).
	stack.set(srcValue,objValue);baseMerge(objValue,srcValue,undefined,mergeDefaults,stack);stack['delete'](srcValue);}return objValue;}/**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}/**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */function overRest(func,start,transform){start=nativeMax(start===undefined?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}/**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */function parent(object,path){return path.length==1?object:baseGet(object,baseSlice(path,0,-1));}/**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */function reorder(array,indexes){var arrLength=array.length,length=nativeMin(indexes.length,arrLength),oldArray=copyArray(array);while(length--){var index=indexes[length];array[length]=isIndex(index,arrLength)?oldArray[index]:undefined;}return array;}/**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */var setData=shortOut(baseSetData);/**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */var setTimeout=ctxSetTimeout||function(func,wait){return root.setTimeout(func,wait);};/**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */var setToString=shortOut(baseSetToString);/**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */function setWrapToString(wrapper,reference,bitmask){var source=reference+'';return setToString(wrapper,insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)));}/**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else{count=0;}return func.apply(undefined,arguments);};}/**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */function shuffleSelf(array,size){var index=-1,length=array.length,lastIndex=length-1;size=size===undefined?length:size;while(++index<size){var rand=baseRandom(index,lastIndex),value=array[rand];array[rand]=array[index];array[index]=value;}array.length=size;return array;}/**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */var stringToPath=memoizeCapped(function(string){string=toString(string);var result=[];if(reLeadingDot.test(string)){result.push('');}string.replace(rePropName,function(match,number,quote,string){result.push(quote?string.replace(reEscapeChar,'$1'):number||match);});return result;});/**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */function toKey(value){if(typeof value=='string'||isSymbol(value)){return value;}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to process.
	     * @returns {string} Returns the source code.
	     */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return'';}/**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */function updateWrapDetails(details,bitmask){arrayEach(wrapFlags,function(pair){var value='_.'+pair[0];if(bitmask&pair[1]&&!arrayIncludes(details,value)){details.push(value);}});return details.sort();}/**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */function wrapperClone(wrapper){if(wrapper instanceof LazyWrapper){return wrapper.clone();}var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);result.__actions__=copyArray(wrapper.__actions__);result.__index__=wrapper.__index__;result.__values__=wrapper.__values__;return result;}/*------------------------------------------------------------------------*//**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */function chunk(array,size,guard){if(guard?isIterateeCall(array,size,guard):size===undefined){size=1;}else{size=nativeMax(toInteger(size),0);}var length=array?array.length:0;if(!length||size<1){return[];}var index=0,resIndex=0,result=Array(nativeCeil(length/size));while(index<length){result[resIndex++]=baseSlice(array,index,index+=size);}return result;}/**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */function compact(array){var index=-1,length=array?array.length:0,resIndex=0,result=[];while(++index<length){var value=array[index];if(value){result[resIndex++]=value;}}return result;}/**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */function concat(){var length=arguments.length;if(!length){return[];}var args=Array(length-1),array=arguments[0],index=length;while(index--){args[index-1]=arguments[index];}return arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1));}/**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */var difference=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):[];});/**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */var differenceBy=baseRest(function(array,values){var iteratee=last(values);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):[];});/**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */var differenceWith=baseRest(function(array,values){var comparator=last(values);if(isArrayLikeObject(comparator)){comparator=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined,comparator):[];});/**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */function drop(array,n,guard){var length=array?array.length:0;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,n<0?0:n,length);}/**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */function dropRight(array,n,guard){var length=array?array.length:0;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,0,n<0?0:n);}/**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */function dropRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true,true):[];}/**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */function dropWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true):[];}/**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */function fill(array,value,start,end){var length=array?array.length:0;if(!length){return[];}if(start&&typeof start!='number'&&isIterateeCall(array,value,start)){start=0;end=length;}return baseFill(array,value,start,end);}/**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */function findIndex(array,predicate,fromIndex){var length=array?array.length:0;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseFindIndex(array,getIteratee(predicate,3),index);}/**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */function findLastIndex(array,predicate,fromIndex){var length=array?array.length:0;if(!length){return-1;}var index=length-1;if(fromIndex!==undefined){index=toInteger(fromIndex);index=fromIndex<0?nativeMax(length+index,0):nativeMin(index,length-1);}return baseFindIndex(array,getIteratee(predicate,3),index,true);}/**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */function flatten(array){var length=array?array.length:0;return length?baseFlatten(array,1):[];}/**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */function flattenDeep(array){var length=array?array.length:0;return length?baseFlatten(array,INFINITY):[];}/**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */function flattenDepth(array,depth){var length=array?array.length:0;if(!length){return[];}depth=depth===undefined?1:toInteger(depth);return baseFlatten(array,depth);}/**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */function fromPairs(pairs){var index=-1,length=pairs?pairs.length:0,result={};while(++index<length){var pair=pairs[index];result[pair[0]]=pair[1];}return result;}/**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */function head(array){return array&&array.length?array[0]:undefined;}/**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */function indexOf(array,value,fromIndex){var length=array?array.length:0;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseIndexOf(array,value,index);}/**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */function initial(array){var length=array?array.length:0;return length?baseSlice(array,0,-1):[];}/**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */var intersection=baseRest(function(arrays){var mapped=arrayMap(arrays,castArrayLikeObject);return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped):[];});/**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */var intersectionBy=baseRest(function(arrays){var iteratee=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(iteratee===last(mapped)){iteratee=undefined;}else{mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,getIteratee(iteratee,2)):[];});/**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */var intersectionWith=baseRest(function(arrays){var comparator=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(comparator===last(mapped)){comparator=undefined;}else{mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,undefined,comparator):[];});/**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */function join(array,separator){return array?nativeJoin.call(array,separator):'';}/**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */function last(array){var length=array?array.length:0;return length?array[length-1]:undefined;}/**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */function lastIndexOf(array,value,fromIndex){var length=array?array.length:0;if(!length){return-1;}var index=length;if(fromIndex!==undefined){index=toInteger(fromIndex);index=index<0?nativeMax(length+index,0):nativeMin(index,length-1);}return value===value?strictLastIndexOf(array,value,index):baseFindIndex(array,baseIsNaN,index,true);}/**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */function nth(array,n){return array&&array.length?baseNth(array,toInteger(n)):undefined;}/**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */var pull=baseRest(pullAll);/**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */function pullAll(array,values){return array&&array.length&&values&&values.length?basePullAll(array,values):array;}/**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */function pullAllBy(array,values,iteratee){return array&&array.length&&values&&values.length?basePullAll(array,values,getIteratee(iteratee,2)):array;}/**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */function pullAllWith(array,values,comparator){return array&&array.length&&values&&values.length?basePullAll(array,values,undefined,comparator):array;}/**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */var pullAt=flatRest(function(array,indexes){var length=array?array.length:0,result=baseAt(array,indexes);basePullAt(array,arrayMap(indexes,function(index){return isIndex(index,length)?+index:index;}).sort(compareAscending));return result;});/**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */function remove(array,predicate){var result=[];if(!(array&&array.length)){return result;}var index=-1,indexes=[],length=array.length;predicate=getIteratee(predicate,3);while(++index<length){var value=array[index];if(predicate(value,index,array)){result.push(value);indexes.push(index);}}basePullAt(array,indexes);return result;}/**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */function reverse(array){return array?nativeReverse.call(array):array;}/**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */function slice(array,start,end){var length=array?array.length:0;if(!length){return[];}if(end&&typeof end!='number'&&isIterateeCall(array,start,end)){start=0;end=length;}else{start=start==null?0:toInteger(start);end=end===undefined?length:toInteger(end);}return baseSlice(array,start,end);}/**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */function sortedIndex(array,value){return baseSortedIndex(array,value);}/**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */function sortedIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2));}/**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */function sortedIndexOf(array,value){var length=array?array.length:0;if(length){var index=baseSortedIndex(array,value);if(index<length&&eq(array[index],value)){return index;}}return-1;}/**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */function sortedLastIndex(array,value){return baseSortedIndex(array,value,true);}/**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */function sortedLastIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);}/**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */function sortedLastIndexOf(array,value){var length=array?array.length:0;if(length){var index=baseSortedIndex(array,value,true)-1;if(eq(array[index],value)){return index;}}return-1;}/**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */function sortedUniq(array){return array&&array.length?baseSortedUniq(array):[];}/**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */function sortedUniqBy(array,iteratee){return array&&array.length?baseSortedUniq(array,getIteratee(iteratee,2)):[];}/**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */function tail(array){var length=array?array.length:0;return length?baseSlice(array,1,length):[];}/**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */function take(array,n,guard){if(!(array&&array.length)){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,0,n<0?0:n);}/**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */function takeRight(array,n,guard){var length=array?array.length:0;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,n<0?0:n,length);}/**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */function takeRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),false,true):[];}/**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */function takeWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3)):[];}/**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */var union=baseRest(function(arrays){return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));});/**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */var unionBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));});/**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */var unionWith=baseRest(function(arrays){var comparator=last(arrays);if(isArrayLikeObject(comparator)){comparator=undefined;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined,comparator);});/**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */function uniq(array){return array&&array.length?baseUniq(array):[];}/**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */function uniqBy(array,iteratee){return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];}/**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */function uniqWith(array,comparator){return array&&array.length?baseUniq(array,undefined,comparator):[];}/**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */function unzip(array){if(!(array&&array.length)){return[];}var length=0;array=arrayFilter(array,function(group){if(isArrayLikeObject(group)){length=nativeMax(group.length,length);return true;}});return baseTimes(length,function(index){return arrayMap(array,baseProperty(index));});}/**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */function unzipWith(array,iteratee){if(!(array&&array.length)){return[];}var result=unzip(array);if(iteratee==null){return result;}return arrayMap(result,function(group){return apply(iteratee,undefined,group);});}/**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */var without=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,values):[];});/**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */var xor=baseRest(function(arrays){return baseXor(arrayFilter(arrays,isArrayLikeObject));});/**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */var xorBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));});/**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */var xorWith=baseRest(function(arrays){var comparator=last(arrays);if(isArrayLikeObject(comparator)){comparator=undefined;}return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined,comparator);});/**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */var zip=baseRest(unzip);/**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */function zipObject(props,values){return baseZipObject(props||[],values||[],assignValue);}/**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */function zipObjectDeep(props,values){return baseZipObject(props||[],values||[],baseSet);}/**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */var zipWith=baseRest(function(arrays){var length=arrays.length,iteratee=length>1?arrays[length-1]:undefined;iteratee=typeof iteratee=='function'?(arrays.pop(),iteratee):undefined;return unzipWith(arrays,iteratee);});/*------------------------------------------------------------------------*//**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */function chain(value){var result=lodash(value);result.__chain__=true;return result;}/**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */function tap(value,interceptor){interceptor(value);return value;}/**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */function thru(value,interceptor){return interceptor(value);}/**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */var wrapperAt=flatRest(function(paths){var length=paths.length,start=length?paths[0]:0,value=this.__wrapped__,interceptor=function interceptor(object){return baseAt(object,paths);};if(length>1||this.__actions__.length||!(value instanceof LazyWrapper)||!isIndex(start)){return this.thru(interceptor);}value=value.slice(start,+start+(length?1:0));value.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(value,this.__chain__).thru(function(array){if(length&&!array.length){array.push(undefined);}return array;});});/**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */function wrapperChain(){return chain(this);}/**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */function wrapperCommit(){return new LodashWrapper(this.value(),this.__chain__);}/**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */function wrapperNext(){if(this.__values__===undefined){this.__values__=toArray(this.value());}var done=this.__index__>=this.__values__.length,value=done?undefined:this.__values__[this.__index__++];return{'done':done,'value':value};}/**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */function wrapperToIterator(){return this;}/**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */function wrapperPlant(value){var result,parent=this;while(parent instanceof baseLodash){var clone=wrapperClone(parent);clone.__index__=0;clone.__values__=undefined;if(result){previous.__wrapped__=clone;}else{result=clone;}var previous=clone;parent=parent.__wrapped__;}previous.__wrapped__=value;return result;}/**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */function wrapperReverse(){var value=this.__wrapped__;if(value instanceof LazyWrapper){var wrapped=value;if(this.__actions__.length){wrapped=new LazyWrapper(this);}wrapped=wrapped.reverse();wrapped.__actions__.push({'func':thru,'args':[reverse],'thisArg':undefined});return new LodashWrapper(wrapped,this.__chain__);}return this.thru(reverse);}/**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */function wrapperValue(){return baseWrapperValue(this.__wrapped__,this.__actions__);}/*------------------------------------------------------------------------*//**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */var countBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){++result[key];}else{baseAssignValue(result,key,1);}});/**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */function every(collection,predicate,guard){var func=isArray(collection)?arrayEvery:baseEvery;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */function filter(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,getIteratee(predicate,3));}/**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */var find=createFind(findIndex);/**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */var findLast=createFind(findLastIndex);/**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */function flatMap(collection,iteratee){return baseFlatten(map(collection,iteratee),1);}/**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */function flatMapDeep(collection,iteratee){return baseFlatten(map(collection,iteratee),INFINITY);}/**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */function flatMapDepth(collection,iteratee,depth){depth=depth===undefined?1:toInteger(depth);return baseFlatten(map(collection,iteratee),depth);}/**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */function forEach(collection,iteratee){var func=isArray(collection)?arrayEach:baseEach;return func(collection,getIteratee(iteratee,3));}/**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */function forEachRight(collection,iteratee){var func=isArray(collection)?arrayEachRight:baseEachRight;return func(collection,getIteratee(iteratee,3));}/**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */var groupBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){result[key].push(value);}else{baseAssignValue(result,key,[value]);}});/**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */function includes(collection,value,fromIndex,guard){collection=isArrayLike(collection)?collection:values(collection);fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;var length=collection.length;if(fromIndex<0){fromIndex=nativeMax(length+fromIndex,0);}return isString(collection)?fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:!!length&&baseIndexOf(collection,value,fromIndex)>-1;}/**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */var invokeMap=baseRest(function(collection,path,args){var index=-1,isFunc=typeof path=='function',isProp=isKey(path),result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value){var func=isFunc?path:isProp&&value!=null?value[path]:undefined;result[++index]=func?apply(func,value,args):baseInvoke(value,path,args);});return result;});/**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */var keyBy=createAggregator(function(result,value,key){baseAssignValue(result,key,value);});/**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */function map(collection,iteratee){var func=isArray(collection)?arrayMap:baseMap;return func(collection,getIteratee(iteratee,3));}/**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */function orderBy(collection,iteratees,orders,guard){if(collection==null){return[];}if(!isArray(iteratees)){iteratees=iteratees==null?[]:[iteratees];}orders=guard?undefined:orders;if(!isArray(orders)){orders=orders==null?[]:[orders];}return baseOrderBy(collection,iteratees,orders);}/**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */var partition=createAggregator(function(result,value,key){result[key?0:1].push(value);},function(){return[[],[]];});/**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */function reduce(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduce:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);}/**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */function reduceRight(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduceRight:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);}/**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */function reject(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,negate(getIteratee(predicate,3)));}/**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */function sample(collection){var func=isArray(collection)?arraySample:baseSample;return func(collection);}/**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */function sampleSize(collection,n,guard){if(guard?isIterateeCall(collection,n,guard):n===undefined){n=1;}else{n=toInteger(n);}var func=isArray(collection)?arraySampleSize:baseSampleSize;return func(collection,n);}/**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */function shuffle(collection){var func=isArray(collection)?arrayShuffle:baseShuffle;return func(collection);}/**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */function size(collection){if(collection==null){return 0;}if(isArrayLike(collection)){return isString(collection)?stringSize(collection):collection.length;}var tag=getTag(collection);if(tag==mapTag||tag==setTag){return collection.size;}return baseKeys(collection).length;}/**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */function some(collection,predicate,guard){var func=isArray(collection)?arraySome:baseSome;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */var sortBy=baseRest(function(collection,iteratees){if(collection==null){return[];}var length=iteratees.length;if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){iteratees=[];}else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){iteratees=[iteratees[0]];}return baseOrderBy(collection,baseFlatten(iteratees,1),[]);});/*------------------------------------------------------------------------*//**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */var now=ctxNow||function(){return root.Date.now();};/*------------------------------------------------------------------------*//**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */function after(n,func){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n<1){return func.apply(this,arguments);}};}/**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */function ary(func,n,guard){n=guard?undefined:n;n=func&&n==null?func.length:n;return createWrap(func,ARY_FLAG,undefined,undefined,undefined,undefined,n);}/**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */function before(n,func){var result;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n>0){result=func.apply(this,arguments);}if(n<=1){func=undefined;}return result;};}/**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */var bind=baseRest(function(func,thisArg,partials){var bitmask=BIND_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bind));bitmask|=PARTIAL_FLAG;}return createWrap(func,bitmask,thisArg,partials,holders);});/**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */var bindKey=baseRest(function(object,key,partials){var bitmask=BIND_FLAG|BIND_KEY_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bindKey));bitmask|=PARTIAL_FLAG;}return createWrap(key,bitmask,object,partials,holders);});/**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */function curry(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,CURRY_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curry.placeholder;return result;}/**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */function curryRight(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,CURRY_RIGHT_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curryRight.placeholder;return result;}/**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */function debounce(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}wait=toNumber(wait)||0;if(isObject(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
	lastInvokeTime=time;// Start the timer for the trailing edge.
	timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
	return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,result=wait-timeSinceLastCall;return maxing?nativeMin(result,maxWait-timeSinceLastInvoke):result;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
	// trailing edge, the system time has gone backwards and we're treating
	// it as the trailing edge, or we've hit the `maxWait` limit.
	return lastCallTime===undefined||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
	timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined;// Only invoke if we have `lastArgs` which means `func` has been
	// debounced at least once.
	if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined;return result;}function cancel(){if(timerId!==undefined){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined;}function flush(){return timerId===undefined?result:trailingEdge(now());}function debounced(){var time=now(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
	timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}/**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */var defer=baseRest(function(func,args){return baseDelay(func,1,args);});/**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */var delay=baseRest(function(func,wait,args){return baseDelay(func,toNumber(wait)||0,args);});/**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */function flip(func){return createWrap(func,FLIP_FLAG);}/**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */function memoize(func,resolver){if(typeof func!='function'||resolver&&typeof resolver!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var memoized=function memoized(){var args=arguments,key=resolver?resolver.apply(this,args):args[0],cache=memoized.cache;if(cache.has(key)){return cache.get(key);}var result=func.apply(this,args);memoized.cache=cache.set(key,result)||cache;return result;};memoized.cache=new(memoize.Cache||MapCache)();return memoized;}// Expose `MapCache`.
	memoize.Cache=MapCache;/**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */function negate(predicate){if(typeof predicate!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return function(){var args=arguments;switch(args.length){case 0:return!predicate.call(this);case 1:return!predicate.call(this,args[0]);case 2:return!predicate.call(this,args[0],args[1]);case 3:return!predicate.call(this,args[0],args[1],args[2]);}return!predicate.apply(this,args);};}/**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */function once(func){return before(2,func);}/**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */var overArgs=castRest(function(func,transforms){transforms=transforms.length==1&&isArray(transforms[0])?arrayMap(transforms[0],baseUnary(getIteratee())):arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));var funcsLength=transforms.length;return baseRest(function(args){var index=-1,length=nativeMin(args.length,funcsLength);while(++index<length){args[index]=transforms[index].call(this,args[index]);}return apply(func,this,args);});});/**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */var partial=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partial));return createWrap(func,PARTIAL_FLAG,undefined,partials,holders);});/**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */var partialRight=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partialRight));return createWrap(func,PARTIAL_RIGHT_FLAG,undefined,partials,holders);});/**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */var rearg=flatRest(function(func,indexes){return createWrap(func,REARG_FLAG,undefined,undefined,undefined,indexes);});/**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */function rest(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined?start:toInteger(start);return baseRest(func,start);}/**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */function spread(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined?0:nativeMax(toInteger(start),0);return baseRest(function(args){var array=args[start],otherArgs=castSlice(args,0,start);if(array){arrayPush(otherArgs,array);}return apply(func,this,otherArgs);});}/**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */function throttle(func,wait,options){var leading=true,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(isObject(options)){leading='leading'in options?!!options.leading:leading;trailing='trailing'in options?!!options.trailing:trailing;}return debounce(func,wait,{'leading':leading,'maxWait':wait,'trailing':trailing});}/**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */function unary(func){return ary(func,1);}/**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */function wrap(value,wrapper){wrapper=wrapper==null?identity:wrapper;return partial(wrapper,value);}/*------------------------------------------------------------------------*//**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */function castArray(){if(!arguments.length){return[];}var value=arguments[0];return isArray(value)?value:[value];}/**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */function clone(value){return baseClone(value,false,true);}/**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */function cloneWith(value,customizer){return baseClone(value,false,true,customizer);}/**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */function cloneDeep(value){return baseClone(value,true,true);}/**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */function cloneDeepWith(value,customizer){return baseClone(value,true,true,customizer);}/**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */function conformsTo(object,source){return source==null||baseConformsTo(object,source,keys(source));}/**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */function eq(value,other){return value===other||value!==value&&other!==other;}/**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */var gt=createRelationalOperation(baseGt);/**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */var gte=createRelationalOperation(function(value,other){return value>=other;});/**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};/**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */var isArray=Array.isArray;/**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;/**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}/**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}/**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */function isBoolean(value){return value===true||value===false||isObjectLike(value)&&objectToString.call(value)==boolTag;}/**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */var isBuffer=nativeIsBuffer||stubFalse;/**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;/**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */function isElement(value){return value!=null&&value.nodeType===1&&isObjectLike(value)&&!isPlainObject(value);}/**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */function isEmpty(value){if(isArrayLike(value)&&(isArray(value)||typeof value=='string'||typeof value.splice=='function'||isBuffer(value)||isTypedArray(value)||isArguments(value))){return!value.length;}var tag=getTag(value);if(tag==mapTag||tag==setTag){return!value.size;}if(isPrototype(value)){return!baseKeys(value).length;}for(var key in value){if(hasOwnProperty.call(value,key)){return false;}}return true;}/**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are **not** supported.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */function isEqual(value,other){return baseIsEqual(value,other);}/**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */function isEqualWith(value,other,customizer){customizer=typeof customizer=='function'?customizer:undefined;var result=customizer?customizer(value,other):undefined;return result===undefined?baseIsEqual(value,other,customizer):!!result;}/**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */function isError(value){if(!isObjectLike(value)){return false;}return objectToString.call(value)==errorTag||typeof value.message=='string'&&typeof value.name=='string';}/**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */function isFinite(value){return typeof value=='number'&&nativeIsFinite(value);}/**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */function isFunction(value){// The use of `Object#toString` avoids issues with the `typeof` operator
	// in Safari 9 which returns 'object' for typed array and other constructors.
	var tag=isObject(value)?objectToString.call(value):'';return tag==funcTag||tag==genTag||tag==proxyTag;}/**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */function isInteger(value){return typeof value=='number'&&value==toInteger(value);}/**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}/**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */function isObject(value){var type=typeof value==='undefined'?'undefined':_typeof(value);return value!=null&&(type=='object'||type=='function');}/**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */function isObjectLike(value){return value!=null&&(typeof value==='undefined'?'undefined':_typeof(value))=='object';}/**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;/**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */function isMatch(object,source){return object===source||baseIsMatch(object,source,getMatchData(source));}/**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */function isMatchWith(object,source,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseIsMatch(object,source,getMatchData(source),customizer);}/**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */function isNaN(value){// An `NaN` primitive is the only value that is not equal to itself.
	// Perform the `toStringTag` check first to avoid errors with some
	// ActiveX objects in IE.
	return isNumber(value)&&value!=+value;}/**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */function isNative(value){if(isMaskable(value)){throw new Error(CORE_ERROR_TEXT);}return baseIsNative(value);}/**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */function isNull(value){return value===null;}/**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */function isNil(value){return value==null;}/**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */function isNumber(value){return typeof value=='number'||isObjectLike(value)&&objectToString.call(value)==numberTag;}/**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */function isPlainObject(value){if(!isObjectLike(value)||objectToString.call(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}/**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;/**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */function isSafeInteger(value){return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;}/**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;/**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&objectToString.call(value)==stringTag;}/**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */function isSymbol(value){return(typeof value==='undefined'?'undefined':_typeof(value))=='symbol'||isObjectLike(value)&&objectToString.call(value)==symbolTag;}/**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;/**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */function isUndefined(value){return value===undefined;}/**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */function isWeakMap(value){return isObjectLike(value)&&getTag(value)==weakMapTag;}/**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */function isWeakSet(value){return isObjectLike(value)&&objectToString.call(value)==weakSetTag;}/**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */var lt=createRelationalOperation(baseLt);/**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */var lte=createRelationalOperation(function(value,other){return value<=other;});/**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */function toArray(value){if(!value){return[];}if(isArrayLike(value)){return isString(value)?stringToArray(value):copyArray(value);}if(iteratorSymbol&&value[iteratorSymbol]){return iteratorToArray(value[iteratorSymbol]());}var tag=getTag(value),func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;return func(value);}/**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */function toFinite(value){if(!value){return value===0?value:0;}value=toNumber(value);if(value===INFINITY||value===-INFINITY){var sign=value<0?-1:1;return sign*MAX_INTEGER;}return value===value?value:0;}/**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */function toInteger(value){var result=toFinite(value),remainder=result%1;return result===result?remainder?result-remainder:result:0;}/**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */function toLength(value){return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;}/**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */function toNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}if(isObject(value)){var other=typeof value.valueOf=='function'?value.valueOf():value;value=isObject(other)?other+'':other;}if(typeof value!='string'){return value===0?value:+value;}value=value.replace(reTrim,'');var isBinary=reIsBinary.test(value);return isBinary||reIsOctal.test(value)?freeParseInt(value.slice(2),isBinary?2:8):reIsBadHex.test(value)?NAN:+value;}/**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */function toPlainObject(value){return copyObject(value,keysIn(value));}/**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */function toSafeInteger(value){return baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER);}/**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */function toString(value){return value==null?'':baseToString(value);}/*------------------------------------------------------------------------*//**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */var assign=createAssigner(function(object,source){if(isPrototype(source)||isArrayLike(source)){copyObject(source,keys(source),object);return;}for(var key in source){if(hasOwnProperty.call(source,key)){assignValue(object,key,source[key]);}}});/**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */var assignIn=createAssigner(function(object,source){copyObject(source,keysIn(source),object);});/**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var assignInWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keysIn(source),object,customizer);});/**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var assignWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keys(source),object,customizer);});/**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */var at=flatRest(baseAt);/**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */function create(prototype,properties){var result=baseCreate(prototype);return properties?baseAssign(result,properties):result;}/**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var defaults=baseRest(function(args){args.push(undefined,assignInDefaults);return apply(assignInWith,undefined,args);});/**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */var defaultsDeep=baseRest(function(args){args.push(undefined,mergeDefaults);return apply(mergeWith,undefined,args);});/**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */function findKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwn);}/**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */function findLastKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);}/**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */function forIn(object,iteratee){return object==null?object:baseFor(object,getIteratee(iteratee,3),keysIn);}/**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */function forInRight(object,iteratee){return object==null?object:baseForRight(object,getIteratee(iteratee,3),keysIn);}/**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */function forOwn(object,iteratee){return object&&baseForOwn(object,getIteratee(iteratee,3));}/**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */function forOwnRight(object,iteratee){return object&&baseForOwnRight(object,getIteratee(iteratee,3));}/**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */function functions(object){return object==null?[]:baseFunctions(object,keys(object));}/**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */function functionsIn(object){return object==null?[]:baseFunctions(object,keysIn(object));}/**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */function get(object,path,defaultValue){var result=object==null?undefined:baseGet(object,path);return result===undefined?defaultValue:result;}/**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */function has(object,path){return object!=null&&hasPath(object,path,baseHas);}/**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */function hasIn(object,path){return object!=null&&hasPath(object,path,baseHasIn);}/**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */var invert=createInverter(function(result,value,key){result[value]=key;},constant(identity));/**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */var invertBy=createInverter(function(result,value,key){if(hasOwnProperty.call(result,value)){result[value].push(key);}else{result[value]=[key];}},getIteratee);/**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */var invoke=baseRest(baseInvoke);/**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}/**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}/**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */function mapKeys(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,iteratee(value,key,object),value);});return result;}/**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */function mapValues(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,key,iteratee(value,key,object));});return result;}/**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */var merge=createAssigner(function(object,source,srcIndex){baseMerge(object,source,srcIndex);});/**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});/**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable string keyed properties of `object` that are
	     * not omitted.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */var omit=flatRest(function(object,props){if(object==null){return{};}props=arrayMap(props,toKey);return basePick(object,baseDifference(getAllKeysIn(object),props));});/**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */function omitBy(object,predicate){return pickBy(object,negate(getIteratee(predicate)));}/**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */var pick=flatRest(function(object,props){return object==null?{}:basePick(object,arrayMap(props,toKey));});/**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */function pickBy(object,predicate){return object==null?{}:basePickBy(object,getAllKeysIn(object),getIteratee(predicate));}/**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */function result(object,path,defaultValue){path=isKey(path,object)?[path]:castPath(path);var index=-1,length=path.length;// Ensure the loop is entered when path is empty.
	if(!length){object=undefined;length=1;}while(++index<length){var value=object==null?undefined:object[toKey(path[index])];if(value===undefined){index=length;value=defaultValue;}object=isFunction(value)?value.call(object):value;}return object;}/**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */function set(object,path,value){return object==null?object:baseSet(object,path,value);}/**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */function setWith(object,path,value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseSet(object,path,value,customizer);}/**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */var toPairs=createToPairs(keys);/**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */var toPairsIn=createToPairs(keysIn);/**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */function transform(object,iteratee,accumulator){var isArr=isArray(object),isArrLike=isArr||isBuffer(object)||isTypedArray(object);iteratee=getIteratee(iteratee,4);if(accumulator==null){var Ctor=object&&object.constructor;if(isArrLike){accumulator=isArr?new Ctor():[];}else if(isObject(object)){accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};}else{accumulator={};}}(isArrLike?arrayEach:baseForOwn)(object,function(value,index,object){return iteratee(accumulator,value,index,object);});return accumulator;}/**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */function unset(object,path){return object==null?true:baseUnset(object,path);}/**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */function update(object,path,updater){return object==null?object:baseUpdate(object,path,castFunction(updater));}/**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */function updateWith(object,path,updater,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);}/**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */function values(object){return object?baseValues(object,keys(object)):[];}/**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */function valuesIn(object){return object==null?[]:baseValues(object,keysIn(object));}/*------------------------------------------------------------------------*//**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */function clamp(number,lower,upper){if(upper===undefined){upper=lower;lower=undefined;}if(upper!==undefined){upper=toNumber(upper);upper=upper===upper?upper:0;}if(lower!==undefined){lower=toNumber(lower);lower=lower===lower?lower:0;}return baseClamp(toNumber(number),lower,upper);}/**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */function inRange(number,start,end){start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}number=toNumber(number);return baseInRange(number,start,end);}/**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */function random(lower,upper,floating){if(floating&&typeof floating!='boolean'&&isIterateeCall(lower,upper,floating)){upper=floating=undefined;}if(floating===undefined){if(typeof upper=='boolean'){floating=upper;upper=undefined;}else if(typeof lower=='boolean'){floating=lower;lower=undefined;}}if(lower===undefined&&upper===undefined){lower=0;upper=1;}else{lower=toFinite(lower);if(upper===undefined){upper=lower;lower=0;}else{upper=toFinite(upper);}}if(lower>upper){var temp=lower;lower=upper;upper=temp;}if(floating||lower%1||upper%1){var rand=nativeRandom();return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);}return baseRandom(lower,upper);}/*------------------------------------------------------------------------*//**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */var camelCase=createCompounder(function(result,word,index){word=word.toLowerCase();return result+(index?capitalize(word):word);});/**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */function capitalize(string){return upperFirst(toString(string).toLowerCase());}/**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */function deburr(string){string=toString(string);return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');}/**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */function endsWith(string,target,position){string=toString(string);target=baseToString(target);var length=string.length;position=position===undefined?length:baseClamp(toInteger(position),0,length);var end=position;position-=target.length;return position>=0&&string.slice(position,end)==target;}/**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */function escape(string){string=toString(string);return string&&reHasUnescapedHtml.test(string)?string.replace(reUnescapedHtml,escapeHtmlChar):string;}/**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}/**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */var kebabCase=createCompounder(function(result,word,index){return result+(index?'-':'')+word.toLowerCase();});/**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */var lowerCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toLowerCase();});/**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */var lowerFirst=createCaseFirst('toLowerCase');/**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */function pad(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;if(!length||strLength>=length){return string;}var mid=(length-strLength)/2;return createPadding(nativeFloor(mid),chars)+string+createPadding(nativeCeil(mid),chars);}/**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */function padEnd(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?string+createPadding(length-strLength,chars):string;}/**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */function padStart(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?createPadding(length-strLength,chars)+string:string;}/**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */function parseInt(string,radix,guard){if(guard||radix==null){radix=0;}else if(radix){radix=+radix;}return nativeParseInt(toString(string).replace(reTrimStart,''),radix||0);}/**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */function repeat(string,n,guard){if(guard?isIterateeCall(string,n,guard):n===undefined){n=1;}else{n=toInteger(n);}return baseRepeat(toString(string),n);}/**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */function replace(){var args=arguments,string=toString(args[0]);return args.length<3?string:string.replace(args[1],args[2]);}/**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */var snakeCase=createCompounder(function(result,word,index){return result+(index?'_':'')+word.toLowerCase();});/**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */function split(string,separator,limit){if(limit&&typeof limit!='number'&&isIterateeCall(string,separator,limit)){separator=limit=undefined;}limit=limit===undefined?MAX_ARRAY_LENGTH:limit>>>0;if(!limit){return[];}string=toString(string);if(string&&(typeof separator=='string'||separator!=null&&!isRegExp(separator))){separator=baseToString(separator);if(!separator&&hasUnicode(string)){return castSlice(stringToArray(string),0,limit);}}return string.split(separator,limit);}/**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */var startCase=createCompounder(function(result,word,index){return result+(index?' ':'')+upperFirst(word);});/**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */function startsWith(string,target,position){string=toString(string);position=baseClamp(toInteger(position),0,string.length);target=baseToString(target);return string.slice(position,position+target.length)==target;}/**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */function template(string,options,guard){// Based on John Resig's `tmpl` implementation
	// (http://ejohn.org/blog/javascript-micro-templating/)
	// and Laura Doktorova's doT.js (https://github.com/olado/doT).
	var settings=lodash.templateSettings;if(guard&&isIterateeCall(string,options,guard)){options=undefined;}string=toString(string);options=assignInWith({},options,settings,assignInDefaults);var imports=assignInWith({},options.imports,settings.imports,assignInDefaults),importsKeys=keys(imports),importsValues=baseValues(imports,importsKeys);var isEscaping,isEvaluating,index=0,interpolate=options.interpolate||reNoMatch,source="__p += '";// Compile the regexp to match each delimiter.
	var reDelimiters=RegExp((options.escape||reNoMatch).source+'|'+interpolate.source+'|'+(interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+(options.evaluate||reNoMatch).source+'|$','g');// Use a sourceURL for easier debugging.
	var sourceURL='//# sourceURL='+('sourceURL'in options?options.sourceURL:'lodash.templateSources['+ ++templateCounter+']')+'\n';string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){interpolateValue||(interpolateValue=esTemplateValue);// Escape characters that can't be included in string literals.
	source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);// Replace delimiters with snippets.
	if(escapeValue){isEscaping=true;source+="' +\n__e("+escapeValue+") +\n'";}if(evaluateValue){isEvaluating=true;source+="';\n"+evaluateValue+";\n__p += '";}if(interpolateValue){source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";}index=offset+match.length;// The JS engine embedded in Adobe products needs `match` returned in
	// order to produce the correct `offset` value.
	return match;});source+="';\n";// If `variable` is not specified wrap a with-statement around the generated
	// code to add the data object to the top of the scope chain.
	var variable=options.variable;if(!variable){source='with (obj) {\n'+source+'\n}\n';}// Cleanup code by stripping empty strings.
	source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).replace(reEmptyStringMiddle,'$1').replace(reEmptyStringTrailing,'$1;');// Frame code as the function body.
	source='function('+(variable||'obj')+') {\n'+(variable?'':'obj || (obj = {});\n')+"var __t, __p = ''"+(isEscaping?', __e = _.escape':'')+(isEvaluating?', __j = Array.prototype.join;\n'+"function print() { __p += __j.call(arguments, '') }\n":';\n')+source+'return __p\n}';var result=attempt(function(){return Function(importsKeys,sourceURL+'return '+source).apply(undefined,importsValues);});// Provide the compiled function's source by its `toString` method or
	// the `source` property as a convenience for inlining compiled templates.
	result.source=source;if(isError(result)){throw result;}return result;}/**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */function toLower(value){return toString(value).toLowerCase();}/**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */function toUpper(value){return toString(value).toUpperCase();}/**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */function trim(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrim,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),chrSymbols=stringToArray(chars),start=charsStartIndex(strSymbols,chrSymbols),end=charsEndIndex(strSymbols,chrSymbols)+1;return castSlice(strSymbols,start,end).join('');}/**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */function trimEnd(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimEnd,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),end=charsEndIndex(strSymbols,stringToArray(chars))+1;return castSlice(strSymbols,0,end).join('');}/**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */function trimStart(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimStart,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),start=charsStartIndex(strSymbols,stringToArray(chars));return castSlice(strSymbols,start).join('');}/**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */function truncate(string,options){var length=DEFAULT_TRUNC_LENGTH,omission=DEFAULT_TRUNC_OMISSION;if(isObject(options)){var separator='separator'in options?options.separator:separator;length='length'in options?toInteger(options.length):length;omission='omission'in options?baseToString(options.omission):omission;}string=toString(string);var strLength=string.length;if(hasUnicode(string)){var strSymbols=stringToArray(string);strLength=strSymbols.length;}if(length>=strLength){return string;}var end=length-stringSize(omission);if(end<1){return omission;}var result=strSymbols?castSlice(strSymbols,0,end).join(''):string.slice(0,end);if(separator===undefined){return result+omission;}if(strSymbols){end+=result.length-end;}if(isRegExp(separator)){if(string.slice(end).search(separator)){var match,substring=result;if(!separator.global){separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');}separator.lastIndex=0;while(match=separator.exec(substring)){var newEnd=match.index;}result=result.slice(0,newEnd===undefined?end:newEnd);}}else if(string.indexOf(baseToString(separator),end)!=end){var index=result.lastIndexOf(separator);if(index>-1){result=result.slice(0,index);}}return result+omission;}/**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */function unescape(string){string=toString(string);return string&&reHasEscapedHtml.test(string)?string.replace(reEscapedHtml,unescapeHtmlChar):string;}/**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */var upperCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toUpperCase();});/**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */var upperFirst=createCaseFirst('toUpperCase');/**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */function words(string,pattern,guard){string=toString(string);pattern=guard?undefined:pattern;if(pattern===undefined){return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);}return string.match(pattern)||[];}/*------------------------------------------------------------------------*//**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */var attempt=baseRest(function(func,args){try{return apply(func,undefined,args);}catch(e){return isError(e)?e:new Error(e);}});/**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */var bindAll=flatRest(function(object,methodNames){arrayEach(methodNames,function(key){key=toKey(key);baseAssignValue(object,key,bind(object[key],object));});return object;});/**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */function cond(pairs){var length=pairs?pairs.length:0,toIteratee=getIteratee();pairs=!length?[]:arrayMap(pairs,function(pair){if(typeof pair[1]!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return[toIteratee(pair[0]),pair[1]];});return baseRest(function(args){var index=-1;while(++index<length){var pair=pairs[index];if(apply(pair[0],this,args)){return apply(pair[1],this,args);}}});}/**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */function conforms(source){return baseConforms(baseClone(source,true));}/**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */function constant(value){return function(){return value;};}/**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */function defaultTo(value,defaultValue){return value==null||value!==value?defaultValue:value;}/**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */var flow=createFlow();/**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */var flowRight=createFlow(true);/**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */function identity(value){return value;}/**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */function iteratee(func){return baseIteratee(typeof func=='function'?func:baseClone(func,true));}/**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */function matches(source){return baseMatches(baseClone(source,true));}/**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */function matchesProperty(path,srcValue){return baseMatchesProperty(path,baseClone(srcValue,true));}/**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */var method=baseRest(function(path,args){return function(object){return baseInvoke(object,path,args);};});/**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */var methodOf=baseRest(function(object,args){return function(path){return baseInvoke(object,path,args);};});/**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */function mixin(object,source,options){var props=keys(source),methodNames=baseFunctions(source,props);if(options==null&&!(isObject(source)&&(methodNames.length||!props.length))){options=source;source=object;object=this;methodNames=baseFunctions(source,keys(source));}var chain=!(isObject(options)&&'chain'in options)||!!options.chain,isFunc=isFunction(object);arrayEach(methodNames,function(methodName){var func=source[methodName];object[methodName]=func;if(isFunc){object.prototype[methodName]=function(){var chainAll=this.__chain__;if(chain||chainAll){var result=object(this.__wrapped__),actions=result.__actions__=copyArray(this.__actions__);actions.push({'func':func,'args':arguments,'thisArg':object});result.__chain__=chainAll;return result;}return func.apply(object,arrayPush([this.value()],arguments));};}});return object;}/**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */function noConflict(){if(root._===this){root._=oldDash;}return this;}/**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */function noop(){}// No operation performed.
	/**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */function nthArg(n){n=toInteger(n);return baseRest(function(args){return baseNth(args,n);});}/**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */var over=createOver(arrayMap);/**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */var overEvery=createOver(arrayEvery);/**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */var overSome=createOver(arraySome);/**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */function property(path){return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);}/**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */function propertyOf(object){return function(path){return object==null?undefined:baseGet(object,path);};}/**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */var range=createRange();/**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */var rangeRight=createRange(true);/**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */function stubArray(){return[];}/**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */function stubFalse(){return false;}/**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */function stubObject(){return{};}/**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */function stubString(){return'';}/**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */function stubTrue(){return true;}/**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */function times(n,iteratee){n=toInteger(n);if(n<1||n>MAX_SAFE_INTEGER){return[];}var index=MAX_ARRAY_LENGTH,length=nativeMin(n,MAX_ARRAY_LENGTH);iteratee=getIteratee(iteratee);n-=MAX_ARRAY_LENGTH;var result=baseTimes(length,iteratee);while(++index<n){iteratee(index);}return result;}/**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */function toPath(value){if(isArray(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(value));}/**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */function uniqueId(prefix){var id=++idCounter;return toString(prefix)+id;}/*------------------------------------------------------------------------*//**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */var add=createMathOperation(function(augend,addend){return augend+addend;},0);/**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */var ceil=createRound('ceil');/**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */var divide=createMathOperation(function(dividend,divisor){return dividend/divisor;},1);/**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */var floor=createRound('floor');/**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */function max(array){return array&&array.length?baseExtremum(array,identity,baseGt):undefined;}/**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */function maxBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseGt):undefined;}/**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */function mean(array){return baseMean(array,identity);}/**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */function meanBy(array,iteratee){return baseMean(array,getIteratee(iteratee,2));}/**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */function min(array){return array&&array.length?baseExtremum(array,identity,baseLt):undefined;}/**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */function minBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseLt):undefined;}/**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */var multiply=createMathOperation(function(multiplier,multiplicand){return multiplier*multiplicand;},1);/**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */var round=createRound('round');/**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */var subtract=createMathOperation(function(minuend,subtrahend){return minuend-subtrahend;},0);/**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */function sum(array){return array&&array.length?baseSum(array,identity):0;}/**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */function sumBy(array,iteratee){return array&&array.length?baseSum(array,getIteratee(iteratee,2)):0;}/*------------------------------------------------------------------------*/// Add methods that return wrapped values in chain sequences.
	lodash.after=after;lodash.ary=ary;lodash.assign=assign;lodash.assignIn=assignIn;lodash.assignInWith=assignInWith;lodash.assignWith=assignWith;lodash.at=at;lodash.before=before;lodash.bind=bind;lodash.bindAll=bindAll;lodash.bindKey=bindKey;lodash.castArray=castArray;lodash.chain=chain;lodash.chunk=chunk;lodash.compact=compact;lodash.concat=concat;lodash.cond=cond;lodash.conforms=conforms;lodash.constant=constant;lodash.countBy=countBy;lodash.create=create;lodash.curry=curry;lodash.curryRight=curryRight;lodash.debounce=debounce;lodash.defaults=defaults;lodash.defaultsDeep=defaultsDeep;lodash.defer=defer;lodash.delay=delay;lodash.difference=difference;lodash.differenceBy=differenceBy;lodash.differenceWith=differenceWith;lodash.drop=drop;lodash.dropRight=dropRight;lodash.dropRightWhile=dropRightWhile;lodash.dropWhile=dropWhile;lodash.fill=fill;lodash.filter=filter;lodash.flatMap=flatMap;lodash.flatMapDeep=flatMapDeep;lodash.flatMapDepth=flatMapDepth;lodash.flatten=flatten;lodash.flattenDeep=flattenDeep;lodash.flattenDepth=flattenDepth;lodash.flip=flip;lodash.flow=flow;lodash.flowRight=flowRight;lodash.fromPairs=fromPairs;lodash.functions=functions;lodash.functionsIn=functionsIn;lodash.groupBy=groupBy;lodash.initial=initial;lodash.intersection=intersection;lodash.intersectionBy=intersectionBy;lodash.intersectionWith=intersectionWith;lodash.invert=invert;lodash.invertBy=invertBy;lodash.invokeMap=invokeMap;lodash.iteratee=iteratee;lodash.keyBy=keyBy;lodash.keys=keys;lodash.keysIn=keysIn;lodash.map=map;lodash.mapKeys=mapKeys;lodash.mapValues=mapValues;lodash.matches=matches;lodash.matchesProperty=matchesProperty;lodash.memoize=memoize;lodash.merge=merge;lodash.mergeWith=mergeWith;lodash.method=method;lodash.methodOf=methodOf;lodash.mixin=mixin;lodash.negate=negate;lodash.nthArg=nthArg;lodash.omit=omit;lodash.omitBy=omitBy;lodash.once=once;lodash.orderBy=orderBy;lodash.over=over;lodash.overArgs=overArgs;lodash.overEvery=overEvery;lodash.overSome=overSome;lodash.partial=partial;lodash.partialRight=partialRight;lodash.partition=partition;lodash.pick=pick;lodash.pickBy=pickBy;lodash.property=property;lodash.propertyOf=propertyOf;lodash.pull=pull;lodash.pullAll=pullAll;lodash.pullAllBy=pullAllBy;lodash.pullAllWith=pullAllWith;lodash.pullAt=pullAt;lodash.range=range;lodash.rangeRight=rangeRight;lodash.rearg=rearg;lodash.reject=reject;lodash.remove=remove;lodash.rest=rest;lodash.reverse=reverse;lodash.sampleSize=sampleSize;lodash.set=set;lodash.setWith=setWith;lodash.shuffle=shuffle;lodash.slice=slice;lodash.sortBy=sortBy;lodash.sortedUniq=sortedUniq;lodash.sortedUniqBy=sortedUniqBy;lodash.split=split;lodash.spread=spread;lodash.tail=tail;lodash.take=take;lodash.takeRight=takeRight;lodash.takeRightWhile=takeRightWhile;lodash.takeWhile=takeWhile;lodash.tap=tap;lodash.throttle=throttle;lodash.thru=thru;lodash.toArray=toArray;lodash.toPairs=toPairs;lodash.toPairsIn=toPairsIn;lodash.toPath=toPath;lodash.toPlainObject=toPlainObject;lodash.transform=transform;lodash.unary=unary;lodash.union=union;lodash.unionBy=unionBy;lodash.unionWith=unionWith;lodash.uniq=uniq;lodash.uniqBy=uniqBy;lodash.uniqWith=uniqWith;lodash.unset=unset;lodash.unzip=unzip;lodash.unzipWith=unzipWith;lodash.update=update;lodash.updateWith=updateWith;lodash.values=values;lodash.valuesIn=valuesIn;lodash.without=without;lodash.words=words;lodash.wrap=wrap;lodash.xor=xor;lodash.xorBy=xorBy;lodash.xorWith=xorWith;lodash.zip=zip;lodash.zipObject=zipObject;lodash.zipObjectDeep=zipObjectDeep;lodash.zipWith=zipWith;// Add aliases.
	lodash.entries=toPairs;lodash.entriesIn=toPairsIn;lodash.extend=assignIn;lodash.extendWith=assignInWith;// Add methods to `lodash.prototype`.
	mixin(lodash,lodash);/*------------------------------------------------------------------------*/// Add methods that return unwrapped values in chain sequences.
	lodash.add=add;lodash.attempt=attempt;lodash.camelCase=camelCase;lodash.capitalize=capitalize;lodash.ceil=ceil;lodash.clamp=clamp;lodash.clone=clone;lodash.cloneDeep=cloneDeep;lodash.cloneDeepWith=cloneDeepWith;lodash.cloneWith=cloneWith;lodash.conformsTo=conformsTo;lodash.deburr=deburr;lodash.defaultTo=defaultTo;lodash.divide=divide;lodash.endsWith=endsWith;lodash.eq=eq;lodash.escape=escape;lodash.escapeRegExp=escapeRegExp;lodash.every=every;lodash.find=find;lodash.findIndex=findIndex;lodash.findKey=findKey;lodash.findLast=findLast;lodash.findLastIndex=findLastIndex;lodash.findLastKey=findLastKey;lodash.floor=floor;lodash.forEach=forEach;lodash.forEachRight=forEachRight;lodash.forIn=forIn;lodash.forInRight=forInRight;lodash.forOwn=forOwn;lodash.forOwnRight=forOwnRight;lodash.get=get;lodash.gt=gt;lodash.gte=gte;lodash.has=has;lodash.hasIn=hasIn;lodash.head=head;lodash.identity=identity;lodash.includes=includes;lodash.indexOf=indexOf;lodash.inRange=inRange;lodash.invoke=invoke;lodash.isArguments=isArguments;lodash.isArray=isArray;lodash.isArrayBuffer=isArrayBuffer;lodash.isArrayLike=isArrayLike;lodash.isArrayLikeObject=isArrayLikeObject;lodash.isBoolean=isBoolean;lodash.isBuffer=isBuffer;lodash.isDate=isDate;lodash.isElement=isElement;lodash.isEmpty=isEmpty;lodash.isEqual=isEqual;lodash.isEqualWith=isEqualWith;lodash.isError=isError;lodash.isFinite=isFinite;lodash.isFunction=isFunction;lodash.isInteger=isInteger;lodash.isLength=isLength;lodash.isMap=isMap;lodash.isMatch=isMatch;lodash.isMatchWith=isMatchWith;lodash.isNaN=isNaN;lodash.isNative=isNative;lodash.isNil=isNil;lodash.isNull=isNull;lodash.isNumber=isNumber;lodash.isObject=isObject;lodash.isObjectLike=isObjectLike;lodash.isPlainObject=isPlainObject;lodash.isRegExp=isRegExp;lodash.isSafeInteger=isSafeInteger;lodash.isSet=isSet;lodash.isString=isString;lodash.isSymbol=isSymbol;lodash.isTypedArray=isTypedArray;lodash.isUndefined=isUndefined;lodash.isWeakMap=isWeakMap;lodash.isWeakSet=isWeakSet;lodash.join=join;lodash.kebabCase=kebabCase;lodash.last=last;lodash.lastIndexOf=lastIndexOf;lodash.lowerCase=lowerCase;lodash.lowerFirst=lowerFirst;lodash.lt=lt;lodash.lte=lte;lodash.max=max;lodash.maxBy=maxBy;lodash.mean=mean;lodash.meanBy=meanBy;lodash.min=min;lodash.minBy=minBy;lodash.stubArray=stubArray;lodash.stubFalse=stubFalse;lodash.stubObject=stubObject;lodash.stubString=stubString;lodash.stubTrue=stubTrue;lodash.multiply=multiply;lodash.nth=nth;lodash.noConflict=noConflict;lodash.noop=noop;lodash.now=now;lodash.pad=pad;lodash.padEnd=padEnd;lodash.padStart=padStart;lodash.parseInt=parseInt;lodash.random=random;lodash.reduce=reduce;lodash.reduceRight=reduceRight;lodash.repeat=repeat;lodash.replace=replace;lodash.result=result;lodash.round=round;lodash.runInContext=runInContext;lodash.sample=sample;lodash.size=size;lodash.snakeCase=snakeCase;lodash.some=some;lodash.sortedIndex=sortedIndex;lodash.sortedIndexBy=sortedIndexBy;lodash.sortedIndexOf=sortedIndexOf;lodash.sortedLastIndex=sortedLastIndex;lodash.sortedLastIndexBy=sortedLastIndexBy;lodash.sortedLastIndexOf=sortedLastIndexOf;lodash.startCase=startCase;lodash.startsWith=startsWith;lodash.subtract=subtract;lodash.sum=sum;lodash.sumBy=sumBy;lodash.template=template;lodash.times=times;lodash.toFinite=toFinite;lodash.toInteger=toInteger;lodash.toLength=toLength;lodash.toLower=toLower;lodash.toNumber=toNumber;lodash.toSafeInteger=toSafeInteger;lodash.toString=toString;lodash.toUpper=toUpper;lodash.trim=trim;lodash.trimEnd=trimEnd;lodash.trimStart=trimStart;lodash.truncate=truncate;lodash.unescape=unescape;lodash.uniqueId=uniqueId;lodash.upperCase=upperCase;lodash.upperFirst=upperFirst;// Add aliases.
	lodash.each=forEach;lodash.eachRight=forEachRight;lodash.first=head;mixin(lodash,function(){var source={};baseForOwn(lodash,function(func,methodName){if(!hasOwnProperty.call(lodash.prototype,methodName)){source[methodName]=func;}});return source;}(),{'chain':false});/*------------------------------------------------------------------------*//**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */lodash.VERSION=VERSION;// Assign default placeholders.
	arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){lodash[methodName].placeholder=lodash;});// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	arrayEach(['drop','take'],function(methodName,index){LazyWrapper.prototype[methodName]=function(n){var filtered=this.__filtered__;if(filtered&&!index){return new LazyWrapper(this);}n=n===undefined?1:nativeMax(toInteger(n),0);var result=this.clone();if(filtered){result.__takeCount__=nativeMin(n,result.__takeCount__);}else{result.__views__.push({'size':nativeMin(n,MAX_ARRAY_LENGTH),'type':methodName+(result.__dir__<0?'Right':'')});}return result;};LazyWrapper.prototype[methodName+'Right']=function(n){return this.reverse()[methodName](n).reverse();};});// Add `LazyWrapper` methods that accept an `iteratee` value.
	arrayEach(['filter','map','takeWhile'],function(methodName,index){var type=index+1,isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;LazyWrapper.prototype[methodName]=function(iteratee){var result=this.clone();result.__iteratees__.push({'iteratee':getIteratee(iteratee,3),'type':type});result.__filtered__=result.__filtered__||isFilter;return result;};});// Add `LazyWrapper` methods for `_.head` and `_.last`.
	arrayEach(['head','last'],function(methodName,index){var takeName='take'+(index?'Right':'');LazyWrapper.prototype[methodName]=function(){return this[takeName](1).value()[0];};});// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	arrayEach(['initial','tail'],function(methodName,index){var dropName='drop'+(index?'':'Right');LazyWrapper.prototype[methodName]=function(){return this.__filtered__?new LazyWrapper(this):this[dropName](1);};});LazyWrapper.prototype.compact=function(){return this.filter(identity);};LazyWrapper.prototype.find=function(predicate){return this.filter(predicate).head();};LazyWrapper.prototype.findLast=function(predicate){return this.reverse().find(predicate);};LazyWrapper.prototype.invokeMap=baseRest(function(path,args){if(typeof path=='function'){return new LazyWrapper(this);}return this.map(function(value){return baseInvoke(value,path,args);});});LazyWrapper.prototype.reject=function(predicate){return this.filter(negate(getIteratee(predicate)));};LazyWrapper.prototype.slice=function(start,end){start=toInteger(start);var result=this;if(result.__filtered__&&(start>0||end<0)){return new LazyWrapper(result);}if(start<0){result=result.takeRight(-start);}else if(start){result=result.drop(start);}if(end!==undefined){end=toInteger(end);result=end<0?result.dropRight(-end):result.take(end-start);}return result;};LazyWrapper.prototype.takeRightWhile=function(predicate){return this.reverse().takeWhile(predicate).reverse();};LazyWrapper.prototype.toArray=function(){return this.take(MAX_ARRAY_LENGTH);};// Add `LazyWrapper` methods to `lodash.prototype`.
	baseForOwn(LazyWrapper.prototype,function(func,methodName){var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),isTaker=/^(?:head|last)$/.test(methodName),lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],retUnwrapped=isTaker||/^find/.test(methodName);if(!lodashFunc){return;}lodash.prototype[methodName]=function(){var value=this.__wrapped__,args=isTaker?[1]:arguments,isLazy=value instanceof LazyWrapper,iteratee=args[0],useLazy=isLazy||isArray(value);var interceptor=function interceptor(value){var result=lodashFunc.apply(lodash,arrayPush([value],args));return isTaker&&chainAll?result[0]:result;};if(useLazy&&checkIteratee&&typeof iteratee=='function'&&iteratee.length!=1){// Avoid lazy use if the iteratee has a "length" value other than `1`.
	isLazy=useLazy=false;}var chainAll=this.__chain__,isHybrid=!!this.__actions__.length,isUnwrapped=retUnwrapped&&!chainAll,onlyLazy=isLazy&&!isHybrid;if(!retUnwrapped&&useLazy){value=onlyLazy?value:new LazyWrapper(this);var result=func.apply(value,args);result.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(result,chainAll);}if(isUnwrapped&&onlyLazy){return func.apply(this,args);}result=this.thru(interceptor);return isUnwrapped?isTaker?result.value()[0]:result.value():result;};});// Add `Array` methods to `lodash.prototype`.
	arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){var func=arrayProto[methodName],chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',retUnwrapped=/^(?:pop|shift)$/.test(methodName);lodash.prototype[methodName]=function(){var args=arguments;if(retUnwrapped&&!this.__chain__){var value=this.value();return func.apply(isArray(value)?value:[],args);}return this[chainName](function(value){return func.apply(isArray(value)?value:[],args);});};});// Map minified method names to their real names.
	baseForOwn(LazyWrapper.prototype,function(func,methodName){var lodashFunc=lodash[methodName];if(lodashFunc){var key=lodashFunc.name+'',names=realNames[key]||(realNames[key]=[]);names.push({'name':methodName,'func':lodashFunc});}});realNames[createHybrid(undefined,BIND_KEY_FLAG).name]=[{'name':'wrapper','func':undefined}];// Add methods to `LazyWrapper`.
	LazyWrapper.prototype.clone=lazyClone;LazyWrapper.prototype.reverse=lazyReverse;LazyWrapper.prototype.value=lazyValue;// Add chain sequence methods to the `lodash` wrapper.
	lodash.prototype.at=wrapperAt;lodash.prototype.chain=wrapperChain;lodash.prototype.commit=wrapperCommit;lodash.prototype.next=wrapperNext;lodash.prototype.plant=wrapperPlant;lodash.prototype.reverse=wrapperReverse;lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;// Add lazy aliases.
	lodash.prototype.first=lodash.prototype.head;if(iteratorSymbol){lodash.prototype[iteratorSymbol]=wrapperToIterator;}return lodash;};/*--------------------------------------------------------------------------*/// Export lodash.
	var _=runInContext();// Some AMD build optimizers, like r.js, check for condition patterns like:
	if("function"=='function'&&_typeof(__webpack_require__(26))=='object'&&__webpack_require__(26)){// Expose Lodash on the global object to prevent errors when Lodash is
	// loaded by a script tag in the presence of an AMD loader.
	// See http://requirejs.org/docs/errors.html#mismatch for more details.
	// Use `_.noConflict` to remove Lodash from the global object.
	root._=_;// Define as an anonymous module so, through path mapping, it can be
	// referenced as the "underscore" module.
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return _;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}// Check for `exports` after `define` in case a build optimizer adds it.
	else if(freeModule){// Export for Node.js.
	(freeModule.exports=_)._=_;// Export for CommonJS support.
	freeExports._=_;}else{// Export to the global object.
	root._=_;}}).call(undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(4)(module)))

/***/ },
/* 187 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*global global, window*/
	/**
	 * @author Christian Johansen (christian@cjohansen.no) and contributors
	 * @license BSD
	 *
	 * Copyright (c) 2010-2014 Christian Johansen
	 */
	
	(function (global) {
	    "use strict";
	
	    // Make properties writable in IE, as per
	    // http://www.adequatelygood.com/Replacing-setTimeout-Globally.html
	
	    global.setTimeout = global.setTimeout;
	    global.clearTimeout = global.clearTimeout;
	    global.setInterval = global.setInterval;
	    global.clearInterval = global.clearInterval;
	    global.Date = global.Date;
	
	    // setImmediate is not a standard function
	    // avoid adding the prop to the window object if not present
	    if (global.setImmediate !== undefined) {
	        global.setImmediate = global.setImmediate;
	        global.clearImmediate = global.clearImmediate;
	    }
	
	    // node expects setTimeout/setInterval to return a fn object w/ .ref()/.unref()
	    // browsers, a number.
	    // see https://github.com/cjohansen/Sinon.JS/pull/436
	
	    var NOOP = function NOOP() {
	        return undefined;
	    };
	    var timeoutResult = setTimeout(NOOP, 0);
	    var addTimerReturnsObject = (typeof timeoutResult === "undefined" ? "undefined" : _typeof(timeoutResult)) === "object";
	    var hrtimePresent = global.process && typeof global.process.hrtime === "function";
	    clearTimeout(timeoutResult);
	
	    var NativeDate = Date;
	    var uniqueTimerId = 1;
	
	    /**
	     * Parse strings like "01:10:00" (meaning 1 hour, 10 minutes, 0 seconds) into
	     * number of milliseconds. This is used to support human-readable strings passed
	     * to clock.tick()
	     */
	    function parseTime(str) {
	        if (!str) {
	            return 0;
	        }
	
	        var strings = str.split(":");
	        var l = strings.length,
	            i = l;
	        var ms = 0,
	            parsed;
	
	        if (l > 3 || !/^(\d\d:){0,2}\d\d?$/.test(str)) {
	            throw new Error("tick only understands numbers, 'm:s' and 'h:m:s'. Each part must be two digits");
	        }
	
	        while (i--) {
	            parsed = parseInt(strings[i], 10);
	
	            if (parsed >= 60) {
	                throw new Error("Invalid time " + str);
	            }
	
	            ms += parsed * Math.pow(60, l - i - 1);
	        }
	
	        return ms * 1000;
	    }
	
	    /**
	     * Floor function that also works for negative numbers
	     */
	    function fixedFloor(n) {
	        return n >= 0 ? Math.floor(n) : Math.ceil(n);
	    }
	
	    /**
	     * % operator that also works for negative numbers
	     */
	    function fixedModulo(n, m) {
	        return (n % m + m) % m;
	    }
	
	    /**
	     * Used to grok the `now` parameter to createClock.
	     */
	    function getEpoch(epoch) {
	        if (!epoch) {
	            return 0;
	        }
	        if (typeof epoch.getTime === "function") {
	            return epoch.getTime();
	        }
	        if (typeof epoch === "number") {
	            return epoch;
	        }
	        throw new TypeError("now should be milliseconds since UNIX epoch");
	    }
	
	    function inRange(from, to, timer) {
	        return timer && timer.callAt >= from && timer.callAt <= to;
	    }
	
	    function mirrorDateProperties(target, source) {
	        var prop;
	        for (prop in source) {
	            if (source.hasOwnProperty(prop)) {
	                target[prop] = source[prop];
	            }
	        }
	
	        // set special now implementation
	        if (source.now) {
	            target.now = function now() {
	                return target.clock.now;
	            };
	        } else {
	            delete target.now;
	        }
	
	        // set special toSource implementation
	        if (source.toSource) {
	            target.toSource = function toSource() {
	                return source.toSource();
	            };
	        } else {
	            delete target.toSource;
	        }
	
	        // set special toString implementation
	        target.toString = function toString() {
	            return source.toString();
	        };
	
	        target.prototype = source.prototype;
	        target.parse = source.parse;
	        target.UTC = source.UTC;
	        target.prototype.toUTCString = source.prototype.toUTCString;
	
	        return target;
	    }
	
	    function createDate() {
	        function ClockDate(year, month, date, hour, minute, second, ms) {
	            // Defensive and verbose to avoid potential harm in passing
	            // explicit undefined when user does not pass argument
	            switch (arguments.length) {
	                case 0:
	                    return new NativeDate(ClockDate.clock.now);
	                case 1:
	                    return new NativeDate(year);
	                case 2:
	                    return new NativeDate(year, month);
	                case 3:
	                    return new NativeDate(year, month, date);
	                case 4:
	                    return new NativeDate(year, month, date, hour);
	                case 5:
	                    return new NativeDate(year, month, date, hour, minute);
	                case 6:
	                    return new NativeDate(year, month, date, hour, minute, second);
	                default:
	                    return new NativeDate(year, month, date, hour, minute, second, ms);
	            }
	        }
	
	        return mirrorDateProperties(ClockDate, NativeDate);
	    }
	
	    function addTimer(clock, timer) {
	        if (timer.func === undefined) {
	            throw new Error("Callback must be provided to timer calls");
	        }
	
	        if (!clock.timers) {
	            clock.timers = {};
	        }
	
	        timer.id = uniqueTimerId++;
	        timer.createdAt = clock.now;
	        timer.callAt = clock.now + (parseInt(timer.delay) || (clock.duringTick ? 1 : 0));
	
	        clock.timers[timer.id] = timer;
	
	        if (addTimerReturnsObject) {
	            return {
	                id: timer.id,
	                ref: NOOP,
	                unref: NOOP
	            };
	        }
	
	        return timer.id;
	    }
	
	    /* eslint consistent-return: "off" */
	    function compareTimers(a, b) {
	        // Sort first by absolute timing
	        if (a.callAt < b.callAt) {
	            return -1;
	        }
	        if (a.callAt > b.callAt) {
	            return 1;
	        }
	
	        // Sort next by immediate, immediate timers take precedence
	        if (a.immediate && !b.immediate) {
	            return -1;
	        }
	        if (!a.immediate && b.immediate) {
	            return 1;
	        }
	
	        // Sort next by creation time, earlier-created timers take precedence
	        if (a.createdAt < b.createdAt) {
	            return -1;
	        }
	        if (a.createdAt > b.createdAt) {
	            return 1;
	        }
	
	        // Sort next by id, lower-id timers take precedence
	        if (a.id < b.id) {
	            return -1;
	        }
	        if (a.id > b.id) {
	            return 1;
	        }
	
	        // As timer ids are unique, no fallback `0` is necessary
	    }
	
	    function firstTimerInRange(clock, from, to) {
	        var timers = clock.timers,
	            timer = null,
	            id,
	            isInRange;
	
	        for (id in timers) {
	            if (timers.hasOwnProperty(id)) {
	                isInRange = inRange(from, to, timers[id]);
	
	                if (isInRange && (!timer || compareTimers(timer, timers[id]) === 1)) {
	                    timer = timers[id];
	                }
	            }
	        }
	
	        return timer;
	    }
	
	    function firstTimer(clock) {
	        var timers = clock.timers,
	            timer = null,
	            id;
	
	        for (id in timers) {
	            if (timers.hasOwnProperty(id)) {
	                if (!timer || compareTimers(timer, timers[id]) === 1) {
	                    timer = timers[id];
	                }
	            }
	        }
	
	        return timer;
	    }
	
	    function lastTimer(clock) {
	        var timers = clock.timers,
	            timer = null,
	            id;
	
	        for (id in timers) {
	            if (timers.hasOwnProperty(id)) {
	                if (!timer || compareTimers(timer, timers[id]) === -1) {
	                    timer = timers[id];
	                }
	            }
	        }
	
	        return timer;
	    }
	
	    function callTimer(clock, timer) {
	        var exception;
	
	        if (typeof timer.interval === "number") {
	            clock.timers[timer.id].callAt += timer.interval;
	        } else {
	            delete clock.timers[timer.id];
	        }
	
	        try {
	            if (typeof timer.func === "function") {
	                timer.func.apply(null, timer.args);
	            } else {
	                /* eslint no-eval: "off" */
	                eval(timer.func);
	            }
	        } catch (e) {
	            exception = e;
	        }
	
	        if (!clock.timers[timer.id]) {
	            if (exception) {
	                throw exception;
	            }
	            return;
	        }
	
	        if (exception) {
	            throw exception;
	        }
	    }
	
	    function timerType(timer) {
	        if (timer.immediate) {
	            return "Immediate";
	        }
	        if (timer.interval !== undefined) {
	            return "Interval";
	        }
	        return "Timeout";
	    }
	
	    function clearTimer(clock, timerId, ttype) {
	        if (!timerId) {
	            // null appears to be allowed in most browsers, and appears to be
	            // relied upon by some libraries, like Bootstrap carousel
	            return;
	        }
	
	        if (!clock.timers) {
	            clock.timers = [];
	        }
	
	        // in Node, timerId is an object with .ref()/.unref(), and
	        // its .id field is the actual timer id.
	        if ((typeof timerId === "undefined" ? "undefined" : _typeof(timerId)) === "object") {
	            timerId = timerId.id;
	        }
	
	        if (clock.timers.hasOwnProperty(timerId)) {
	            // check that the ID matches a timer of the correct type
	            var timer = clock.timers[timerId];
	            if (timerType(timer) === ttype) {
	                delete clock.timers[timerId];
	            } else {
	                throw new Error("Cannot clear timer: timer created with set" + timerType(timer) + "() but cleared with clear" + ttype + "()");
	            }
	        }
	    }
	
	    function uninstall(clock, target) {
	        var method, i, l;
	        var installedHrTime = "_hrtime";
	
	        for (i = 0, l = clock.methods.length; i < l; i++) {
	            method = clock.methods[i];
	            if (method === "hrtime" && target.process) {
	                target.process.hrtime = clock[installedHrTime];
	            } else {
	                if (target[method] && target[method].hadOwnProperty) {
	                    target[method] = clock["_" + method];
	                } else {
	                    try {
	                        delete target[method];
	                    } catch (ignore) {/* eslint empty-block: "off" */}
	                }
	            }
	        }
	
	        // Prevent multiple executions which will completely remove these props
	        clock.methods = [];
	    }
	
	    function hijackMethod(target, method, clock) {
	        var prop;
	
	        clock[method].hadOwnProperty = Object.prototype.hasOwnProperty.call(target, method);
	        clock["_" + method] = target[method];
	
	        if (method === "Date") {
	            var date = mirrorDateProperties(clock[method], target[method]);
	            target[method] = date;
	        } else {
	            target[method] = function () {
	                return clock[method].apply(clock, arguments);
	            };
	
	            for (prop in clock[method]) {
	                if (clock[method].hasOwnProperty(prop)) {
	                    target[method][prop] = clock[method][prop];
	                }
	            }
	        }
	
	        target[method].clock = clock;
	    }
	
	    var timers = {
	        setTimeout: setTimeout,
	        clearTimeout: clearTimeout,
	        setImmediate: global.setImmediate,
	        clearImmediate: global.clearImmediate,
	        setInterval: setInterval,
	        clearInterval: clearInterval,
	        Date: Date
	    };
	
	    if (hrtimePresent) {
	        timers.hrtime = global.process.hrtime;
	    }
	
	    var keys = Object.keys || function (obj) {
	        var ks = [],
	            key;
	
	        for (key in obj) {
	            if (obj.hasOwnProperty(key)) {
	                ks.push(key);
	            }
	        }
	
	        return ks;
	    };
	
	    exports.timers = timers;
	
	    function createClock(now, loopLimit) {
	        loopLimit = loopLimit || 1000;
	
	        var clock = {
	            now: getEpoch(now),
	            hrNow: 0,
	            timeouts: {},
	            Date: createDate(),
	            loopLimit: loopLimit
	        };
	
	        clock.Date.clock = clock;
	
	        clock.setTimeout = function setTimeout(func, timeout) {
	            return addTimer(clock, {
	                func: func,
	                args: Array.prototype.slice.call(arguments, 2),
	                delay: timeout
	            });
	        };
	
	        clock.clearTimeout = function clearTimeout(timerId) {
	            return clearTimer(clock, timerId, "Timeout");
	        };
	
	        clock.setInterval = function setInterval(func, timeout) {
	            return addTimer(clock, {
	                func: func,
	                args: Array.prototype.slice.call(arguments, 2),
	                delay: timeout,
	                interval: timeout
	            });
	        };
	
	        clock.clearInterval = function clearInterval(timerId) {
	            return clearTimer(clock, timerId, "Interval");
	        };
	
	        clock.setImmediate = function setImmediate(func) {
	            return addTimer(clock, {
	                func: func,
	                args: Array.prototype.slice.call(arguments, 1),
	                immediate: true
	            });
	        };
	
	        clock.clearImmediate = function clearImmediate(timerId) {
	            return clearTimer(clock, timerId, "Immediate");
	        };
	
	        clock.tick = function tick(ms) {
	            ms = typeof ms === "number" ? ms : parseTime(ms);
	            var tickFrom = clock.now,
	                tickTo = clock.now + ms,
	                previous = clock.now;
	            var timer = firstTimerInRange(clock, tickFrom, tickTo);
	            var oldNow;
	
	            clock.duringTick = true;
	
	            function updateHrTime(newNow) {
	                clock.hrNow += newNow - clock.now;
	            }
	
	            var firstException;
	            while (timer && tickFrom <= tickTo) {
	                if (clock.timers[timer.id]) {
	                    updateHrTime(timer.callAt);
	                    tickFrom = timer.callAt;
	                    clock.now = timer.callAt;
	                    try {
	                        oldNow = clock.now;
	                        callTimer(clock, timer);
	                        // compensate for any setSystemTime() call during timer callback
	                        if (oldNow !== clock.now) {
	                            tickFrom += clock.now - oldNow;
	                            tickTo += clock.now - oldNow;
	                            previous += clock.now - oldNow;
	                        }
	                    } catch (e) {
	                        firstException = firstException || e;
	                    }
	                }
	
	                timer = firstTimerInRange(clock, previous, tickTo);
	                previous = tickFrom;
	            }
	
	            clock.duringTick = false;
	            updateHrTime(tickTo);
	            clock.now = tickTo;
	
	            if (firstException) {
	                throw firstException;
	            }
	
	            return clock.now;
	        };
	
	        clock.next = function next() {
	            var timer = firstTimer(clock);
	            if (!timer) {
	                return clock.now;
	            }
	
	            clock.duringTick = true;
	            try {
	                clock.now = timer.callAt;
	                callTimer(clock, timer);
	                return clock.now;
	            } finally {
	                clock.duringTick = false;
	            }
	        };
	
	        clock.runAll = function runAll() {
	            var numTimers, i;
	            for (i = 0; i < clock.loopLimit; i++) {
	                if (!clock.timers) {
	                    return clock.now;
	                }
	
	                numTimers = Object.keys(clock.timers).length;
	                if (numTimers === 0) {
	                    return clock.now;
	                }
	
	                clock.next();
	            }
	
	            throw new Error("Aborting after running " + clock.loopLimit + "timers, assuming an infinite loop!");
	        };
	
	        clock.runToLast = function runToLast() {
	            var timer = lastTimer(clock);
	            if (!timer) {
	                return clock.now;
	            }
	
	            return clock.tick(timer.callAt);
	        };
	
	        clock.reset = function reset() {
	            clock.timers = {};
	        };
	
	        clock.setSystemTime = function setSystemTime(now) {
	            // determine time difference
	            var newNow = getEpoch(now);
	            var difference = newNow - clock.now;
	            var id, timer;
	
	            // update 'system clock'
	            clock.now = newNow;
	
	            // update timers and intervals to keep them stable
	            for (id in clock.timers) {
	                if (clock.timers.hasOwnProperty(id)) {
	                    timer = clock.timers[id];
	                    timer.createdAt += difference;
	                    timer.callAt += difference;
	                }
	            }
	        };
	
	        if (hrtimePresent) {
	            clock.hrtime = function (prev) {
	                if (Array.isArray(prev)) {
	                    var oldSecs = prev[0] + prev[1] / 1e9;
	                    var newSecs = clock.hrNow / 1000;
	                    var difference = newSecs - oldSecs;
	                    var secs = fixedFloor(difference);
	                    var nanosecs = fixedModulo(difference * 1e9, 1e9);
	                    return [secs, nanosecs];
	                }
	                return [fixedFloor(clock.hrNow / 1000), fixedModulo(clock.hrNow * 1e6, 1e9)];
	            };
	        }
	
	        return clock;
	    }
	    exports.createClock = createClock;
	
	    exports.install = function install(target, now, toFake, loopLimit) {
	        var i, l;
	
	        if (typeof target === "number") {
	            toFake = now;
	            now = target;
	            target = null;
	        }
	
	        if (!target) {
	            target = global;
	        }
	
	        var clock = createClock(now, loopLimit);
	
	        clock.uninstall = function () {
	            uninstall(clock, target);
	        };
	
	        clock.methods = toFake || [];
	
	        if (clock.methods.length === 0) {
	            clock.methods = keys(timers);
	        }
	
	        for (i = 0, l = clock.methods.length; i < l; i++) {
	            if (clock.methods[i] === "hrtime") {
	                if (target.process && typeof target.process.hrtime === "function") {
	                    hijackMethod(target.process, clock.methods[i], clock);
	                }
	            } else {
	                hijackMethod(target, clock.methods[i], clock);
	            }
	        }
	
	        return clock;
	    };
	})(global || undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Factory = __webpack_require__(297);
	
	var _Factory2 = _interopRequireDefault(_Factory);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	__webpack_require__(179).polyfill(); // for IE
	
	__webpack_require__(295);
	__webpack_require__(281);
	__webpack_require__(189);
	
	var moduleName = 'ng-admin';
	var factory = angular.module('AdminDescriptionModule', []);
	factory.constant('AdminDescription', new _Factory2.default());
	
	var ngadmin = angular.module(moduleName, ['ui.select', 'main', 'crud', 'AdminDescriptionModule']);
	
	ngadmin.config(['NgAdminConfigurationProvider', 'AdminDescription', function (NgAdminConfigurationProvider, AdminDescription) {
	    NgAdminConfigurationProvider.setAdminDescription(AdminDescription);
	}]);
	
	ngadmin.config(['uiSelectConfig', function (uiSelectConfig) {
	    uiSelectConfig.theme = 'bootstrap';
	}]);
	
	exports.default = moduleName;
	module.exports = exports['default'];
	//# sourceMappingURL=ng-admin.js.map

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(6);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	__webpack_require__(339);
	__webpack_require__(341);
	__webpack_require__(340);
	
	__webpack_require__(171);
	
	var CrudModule = _angular2.default.module('crud', ['ui.router', 'ui.bootstrap', 'ui.codemirror', 'ngSanitize', 'textAngular', 'ngInflection', 'ngFileUpload', 'ngNumeraljs']);
	
	CrudModule.controller('ListLayoutController', __webpack_require__(260));
	CrudModule.controller('ListController', __webpack_require__(259));
	CrudModule.controller('ShowController', __webpack_require__(278));
	CrudModule.controller('FormController', __webpack_require__(258));
	CrudModule.controller('DeleteController', __webpack_require__(219));
	CrudModule.controller('BatchDeleteController', __webpack_require__(218));
	
	CrudModule.service('EntryFormatter', __webpack_require__(270));
	CrudModule.service('PromisesResolver', __webpack_require__(271));
	CrudModule.service('ReadQueries', __webpack_require__(274));
	CrudModule.service('ReferenceRefresher', __webpack_require__(275));
	CrudModule.service('WriteQueries', __webpack_require__(276));
	
	CrudModule.service('RestWrapper', __webpack_require__(272));
	
	CrudModule.directive('maJsonValidator', __webpack_require__(280));
	
	CrudModule.directive('maField', __webpack_require__(226));
	CrudModule.directive('maButtonField', __webpack_require__(220));
	CrudModule.directive('maChoiceField', __webpack_require__(222));
	CrudModule.directive('maChoicesField', __webpack_require__(223));
	CrudModule.directive('maDateField', __webpack_require__(224));
	CrudModule.directive('maEmbeddedListField', __webpack_require__(225));
	CrudModule.directive('maInputField', __webpack_require__(228));
	CrudModule.directive('maJsonField', __webpack_require__(229));
	CrudModule.directive('maFileField', __webpack_require__(227));
	CrudModule.directive('maCheckboxField', __webpack_require__(221));
	CrudModule.directive('maReferenceField', __webpack_require__(230));
	CrudModule.directive('maReferenceManyField', __webpack_require__(231));
	CrudModule.directive('maTextField', __webpack_require__(233));
	CrudModule.directive('maWysiwygField', __webpack_require__(234));
	CrudModule.directive('maTemplateField', __webpack_require__(232));
	CrudModule.directive('uiSelectRequired', __webpack_require__(235));
	
	CrudModule.provider('FieldViewConfiguration', __webpack_require__(243));
	
	CrudModule.directive('maListActions', __webpack_require__(268));
	CrudModule.directive('maDatagrid', __webpack_require__(261));
	CrudModule.directive('maDatagridPagination', __webpack_require__(266));
	CrudModule.directive('maDatagridInfinitePagination', __webpack_require__(263));
	CrudModule.directive('maDatagridItemSelector', __webpack_require__(264));
	CrudModule.directive('maDatagridMultiSelector', __webpack_require__(265));
	CrudModule.directive('maFilterForm', __webpack_require__(257));
	CrudModule.directive('maFilter', __webpack_require__(256));
	
	CrudModule.directive('maColumn', __webpack_require__(204));
	CrudModule.directive('maBooleanColumn', __webpack_require__(202));
	CrudModule.directive('maChoicesColumn', __webpack_require__(203));
	CrudModule.directive('maDateColumn', __webpack_require__(205));
	CrudModule.directive('maEmbeddedListColumn', __webpack_require__(206));
	CrudModule.directive('maJsonColumn', __webpack_require__(207));
	CrudModule.directive('maNumberColumn', __webpack_require__(208));
	CrudModule.directive('maReferenceColumn', __webpack_require__(209));
	CrudModule.directive('maReferencedListColumn', __webpack_require__(213));
	CrudModule.directive('maReferenceLinkColumn', __webpack_require__(210));
	CrudModule.directive('maReferenceManyColumn', __webpack_require__(211));
	CrudModule.directive('maReferenceManyLinkColumn', __webpack_require__(212));
	CrudModule.directive('maStringColumn', __webpack_require__(214));
	CrudModule.directive('maTemplateColumn', __webpack_require__(215));
	CrudModule.directive('maWysiwygColumn', __webpack_require__(216));
	
	CrudModule.directive('maBackButton', __webpack_require__(190));
	CrudModule.directive('maCreateButton', __webpack_require__(192));
	CrudModule.directive('maEditButton', __webpack_require__(194));
	CrudModule.directive('maFilterButton', __webpack_require__(196));
	CrudModule.directive('maFilteredListButton', __webpack_require__(197));
	CrudModule.directive('maShowButton', __webpack_require__(199));
	CrudModule.directive('maListButton', __webpack_require__(198));
	CrudModule.directive('maDeleteButton', __webpack_require__(193));
	CrudModule.directive('maBatchDeleteButton', __webpack_require__(191));
	CrudModule.directive('maExportToCsvButton', __webpack_require__(195));
	CrudModule.directive('maSubmitButton', __webpack_require__(200));
	CrudModule.directive('maViewBatchActions', __webpack_require__(201));
	
	CrudModule.directive('maShowItem', __webpack_require__(279));
	CrudModule.directive('maViewActions', __webpack_require__(273));
	CrudModule.directive('compile', __webpack_require__(269));
	
	CrudModule.config(__webpack_require__(277));
	CrudModule.config(__webpack_require__(217));
	
	CrudModule.factory('Papa', function () {
	    return __webpack_require__(327);
	});
	
	CrudModule.factory('notification', function () {
	    var humane = __webpack_require__(182);
	    humane.timeout = 5000;
	    humane.clickToClose = true;
	    return humane;
	});
	
	CrudModule.factory('progression', function () {
	    return __webpack_require__(326);
	});
	
	CrudModule.run(['Restangular', 'NgAdminConfiguration', function (Restangular, NgAdminConfiguration) {
	    Restangular.setBaseUrl(NgAdminConfiguration().baseApiUrl());
	}]);
	
	exports.default = CrudModule;
	module.exports = exports['default'];
	//# sourceMappingURL=CrudModule.js.map

/***/ },
/* 190 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maBackButtonDirective;
	/**
	 * Link to previous page
	 *
	 * Usage:
	 * <ma-back-button entry="entry" size="xs"></ma-back-button>
	 */
	function maBackButtonDirective($window) {
	    return {
	        restrict: 'E',
	        scope: {
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope) {
	            scope.label = scope.label || 'BACK';
	            scope.back = function () {
	                return $window.history.back();
	            };
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ng-click="back()">\n<span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	maBackButtonDirective.$inject = ['$window'];
	module.exports = exports['default'];
	//# sourceMappingURL=maBackButton.js.map

/***/ },
/* 191 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maBatchDeleteButtonDirective;
	function maBatchDeleteButtonDirective($state) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            selection: '&',
	            label: '@'
	        },
	        link: function link($scope) {
	            $scope.label = $scope.label || 'DELETE';
	            $scope.gotoBatchDelete = function () {
	                var ids = $scope.selection().map(function (entry) {
	                    return entry.identifierValue;
	                });
	
	                $state.go('batchDelete', angular.extend({
	                    ids: ids,
	                    entity: $scope.entity().name()
	                }, $state.params));
	            };
	        },
	        template: '<span ng-click="gotoBatchDelete()">\n<span class="glyphicon glyphicon-trash" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</span>'
	    };
	}
	
	maBatchDeleteButtonDirective.$inject = ['$state'];
	module.exports = exports['default'];
	//# sourceMappingURL=maBatchDeleteButton.js.map

/***/ },
/* 192 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	exports.default = maCreateButtonDirective;
	/**
	 * Link to create
	 *
	 * Usage:
	 * <ma-create-button entity="entity" default-values="{}" size="xs"></ma-create-button>
	 */
	function maCreateButtonDirective($state) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            entityName: '@',
	            defaultValues: '&',
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope, element, attrs) {
	            scope.label = scope.label || 'CREATE';
	            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
	            var stateParams = entityName == $state.params.entity ? _extends({}, $state.params) : {};
	            stateParams.entity = entityName;
	            stateParams.defaultValues = scope.defaultValues();
	            scope.stateParams = stateParams;
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ui-sref="create(stateParams)">\n<span class="glyphicon glyphicon-plus" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	maCreateButtonDirective.$inject = ['$state'];
	module.exports = exports['default'];
	//# sourceMappingURL=maCreateButton.js.map

/***/ },
/* 193 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	exports.default = maDeleteButtonDirective;
	/**
	 * Link to delete
	 *
	 * Usage:
	 * <ma-delete-button entity="entity" entry="entry" size="xs"></ma-delete-button>
	 */
	function maDeleteButtonDirective($state) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            entityName: '@',
	            entry: '&',
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope, element, attrs) {
	            scope.label = scope.label || 'DELETE';
	            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
	            var stateParams = entityName == $state.params.entity ? _extends({}, $state.params) : {};
	            stateParams.entity = entityName;
	            stateParams.id = scope.entry().identifierValue;
	            scope.stateParams = stateParams;
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ui-sref="delete(stateParams)">\n<span class="glyphicon glyphicon-trash" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	maDeleteButtonDirective.$inject = ['$state'];
	module.exports = exports['default'];
	//# sourceMappingURL=maDeleteButton.js.map

/***/ },
/* 194 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	exports.default = maEditButtonDirective;
	/**
	 * Link to edit
	 *
	 * Usage:
	 * <ma-edit-button entity="entity" entry="entry" size="xs"></ma-edit-button>
	 */
	function maEditButtonDirective($state) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            entityName: '@',
	            entry: '&',
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope, element, attrs) {
	            scope.label = scope.label || 'EDIT';
	            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
	            var stateParams = entityName == $state.params.entity ? _extends({}, $state.params) : {};
	            stateParams.entity = entityName;
	            stateParams.id = scope.entry().identifierValue;
	            scope.stateParams = stateParams;
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ui-sref="edit(stateParams)">\n<span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	maEditButtonDirective.$inject = ['$state'];
	module.exports = exports['default'];
	//# sourceMappingURL=maEditButton.js.map

/***/ },
/* 195 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maExportToCsvButton;
	function maExportToCsvButton($stateParams, Papa, notification, AdminDescription, entryFormatter, ReadQueries) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            label: '@',
	            datastore: '&'
	        },
	        link: function link(scope) {
	            scope.label = scope.label || 'EXPORT';
	            scope.datastore = scope.datastore();
	            scope.entity = scope.entity();
	            var exportView = scope.entity.exportView();
	            var listView = scope.entity.listView();
	            if (exportView.fields().length === 0) {
	                var exportFields = listView.exportFields();
	                if (exportFields === null) {
	                    exportFields = listView.fields();
	                }
	                exportView.fields(exportFields);
	                exportView.filters(listView.filters());
	                exportView.name(listView.name()); // to enable reuse of sortField
	            }
	            scope.has_export = exportView.fields().length > 0;
	            var formatEntry = entryFormatter.getFormatter(exportView.fields());
	
	            scope.exportToCsv = function () {
	                var rawEntries;
	
	                ReadQueries.getAll(exportView, -1, $stateParams.search, $stateParams.sortField, $stateParams.sortDir).then(function (response) {
	                    rawEntries = response.data;
	                    return rawEntries;
	                }).then(function (rawEntries) {
	                    return ReadQueries.getReferenceData(exportView.fields(), rawEntries);
	                }).then(function (referenceData) {
	                    var references = exportView.getReferences();
	                    for (var name in referenceData) {
	                        AdminDescription.getEntryConstructor().createArrayFromRest(referenceData[name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                            return scope.datastore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                        });
	                    }
	                }).then(function () {
	                    var entries = exportView.mapEntries(rawEntries);
	
	                    // shortcut to diplay collection of entry with included referenced values
	                    scope.datastore.fillReferencesValuesFromCollection(entries, exportView.getReferences(), true);
	
	                    var results = [];
	                    for (var i = entries.length - 1; i >= 0; i--) {
	                        results[i] = formatEntry(entries[i]);
	                    }
	                    var csv = Papa.unparse(results, listView.exportOptions());
	                    var fakeLink = document.createElement('a');
	                    document.body.appendChild(fakeLink);
	
	                    var blobName = scope.entity.name() + '.csv';
	
	                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	                        // Manage IE11+ & Edge
	                        var blob = new Blob([csv], { type: 'text/csv' });
	                        window.navigator.msSaveOrOpenBlob(blob, blobName);
	                    } else {
	                        fakeLink.setAttribute('href', 'data:application/octet-stream;charset=utf-8,' + encodeURIComponent(csv));
	                        fakeLink.setAttribute('download', blobName);
	                        fakeLink.click();
	                    }
	                }, function (error) {
	                    notification.log(error.message, { addnCls: 'humane-flatty-error' });
	                });
	            };
	        },
	        template: '<span ng-if="has_export">\n    <a class="btn btn-default" ng-click="exportToCsv()">\n        <span class="glyphicon glyphicon-download" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n    </a>\n</span>'
	    };
	}
	
	maExportToCsvButton.$inject = ['$stateParams', 'Papa', 'notification', 'AdminDescription', 'EntryFormatter', 'ReadQueries'];
	module.exports = exports['default'];
	//# sourceMappingURL=maExportToCsvButton.js.map

/***/ },
/* 196 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maFilterButton;
	function maFilterButton() {
	    return {
	        restrict: 'E',
	        scope: {
	            filters: '&',
	            enabledFilters: '=',
	            enableFilter: '&',
	            label: "@"
	        },
	        link: function link(scope) {
	            scope.label = scope.label || 'ADD_FILTER';
	            scope.notYetEnabledFilters = function () {
	                return scope.filters().filter(function (filter) {
	                    return scope.enabledFilters.indexOf(filter) === -1;
	                });
	            };
	            scope.hasFilters = function () {
	                return scope.notYetEnabledFilters().length > 0;
	            };
	        },
	        template: '<span class="btn-group" uib-dropdown is-open="isopen" ng-if="hasFilters()">\n    <button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle >\n        <span class="glyphicon glyphicon-filter" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>&nbsp;<span class="caret"></span>\n    </button>\n    <ul class="dropdown-menu" role="menu">\n        <li ng-repeat="filter in notYetEnabledFilters()" ng-switch="button">\n            <a ng-click="enableFilter()(filter)">{{ filter.label() | translate }}</a>\n        </li>\n    </ul>\n</span>'
	    };
	}
	
	maFilterButton.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maFilterButton.js.map

/***/ },
/* 197 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maFilteredListButtonDirective;
	/**
	 * Link to filtered list
	 *
	 * Usage:
	 *
	 *     <!-- In a scope where the current entry is a post, link tio the related comments -->
	 *     <ma-filtered-list-button
	 *       entity-name="comments"
	 *       filter="{ post_id: entry.values.id }"
	 *       text="See related comments"
	 *       size="xs">
	 *     </ma-filtered-list-button>')
	 *
	 * Usage as a template field:
	 *
	 * nga.field('', 'template')
	 *   .label('')
	 *   .template('<ma-filtered-list-button entity-name="comments" filter="{ post_id: entry.values.id }"></ma-filtered-list-button>')
	 */
	function maFilteredListButtonDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            entityName: '@',
	            filter: '&',
	            label: '@',
	            size: '@'
	        },
	        link: function link(scope) {
	            scope.label = scope.label || 'SEE_RELATED';
	            scope.stateParams = { 'entity': scope.entityName, 'search': scope.filter() };
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ui-sref="list(stateParams)">\n    <span class="glyphicon glyphicon-list" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}" translate-values="{ entityName: entityName }"></span>\n</a>'
	    };
	}
	
	maFilteredListButtonDirective.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maFilteredListButton.js.map

/***/ },
/* 198 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	exports.default = maListButtonDirective;
	/**
	 * Link to list
	 *
	 * Usage:
	 * <ma-list-button entity="entity" size="xs"></ma-list-button>
	 */
	function maListButtonDirective($state) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            entityName: '@',
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope, element, attrs) {
	            scope.label = scope.label || 'LIST';
	            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
	            var stateParams = entityName == $state.params.entity ? _extends({}, $state.params) : {};
	            stateParams.entity = entityName;
	            scope.stateParams = stateParams;
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ui-sref="list(stateParams)">\n<span class="glyphicon glyphicon-list" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	maListButtonDirective.$inject = ['$state'];
	module.exports = exports['default'];
	//# sourceMappingURL=maListButton.js.map

/***/ },
/* 199 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	exports.default = maShowButtonDirective;
	/**
	 * Link to show
	 *
	 * Usage:
	 * <ma-show-button entity="entity" entry="entry" size="xs"></ma-show-button>
	 */
	function maShowButtonDirective($state) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            entityName: '@',
	            entry: '&',
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope, element, attrs) {
	            scope.label = scope.label || 'SHOW';
	            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
	            var stateParams = entityName == $state.params.entity ? _extends({}, $state.params) : {};
	            stateParams.entity = entityName;
	            stateParams.id = scope.entry().identifierValue;
	            scope.stateParams = stateParams;
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ui-sref="show(stateParams)">\n<span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	maShowButtonDirective.$inject = ['$state'];
	module.exports = exports['default'];
	//# sourceMappingURL=maShowButton.js.map

/***/ },
/* 200 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maSubmitButtonDirective;
	/**
	 * Save button
	 *
	 * Usage:
	 * <ma-submit-button label="Save changes"></ma-submit-button>
	 */
	function maSubmitButtonDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            label: '@'
	        },
	        link: function link(scope) {
	            scope.label = scope.label || 'SAVE';
	        },
	        template: '<button type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span></button>'
	    };
	}
	
	maSubmitButtonDirective.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maSubmitButton.js.map

/***/ },
/* 201 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maViewBatchActionsDirective;
	function maViewBatchActionsDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            'entity': '=',
	            'selection': '=',
	            'buttons': '&',
	            'label': '@'
	        },
	        link: function link(scope) {
	            scope.label = scope.label || 'N_SELECTED';
	            scope.isopen = false;
	            scope.toggleDropdown = function ($event) {
	                $event.preventDefault();
	                $event.stopPropagation();
	                scope.isopen = !scope.isopen;
	            };
	            scope.buttons = scope.buttons();
	            if (typeof scope.buttons === 'string') {
	                scope.customTemplate = scope.buttons;
	                scope.buttons = null;
	            }
	        },
	        // the ng-class hidden is necessary to hide the inner blank space used for spacing buttons when the selection is not empty
	        template: '<span ng-if="selection" ng-class="{hidden:!selection || selection.length==0}"> <span class="btn-group" uib-dropdown is-open="isopen"><button type="button" ng-if="selection.length" class="btn btn-default dropdown-toggle" uib-dropdown-toggle >\n            <span translate="{{ ::label }}" translate-values="{ length: selection.length }"></span>&nbsp;<span class="caret"></span>\n        </button>\n        <ul class="dropdown-menu" role="menu">\n            <li ng-repeat="button in buttons" ng-switch="button">\n                <a ng-switch-when="delete">\n                    <ma-batch-delete-button selection="selection" entity="entity"/>\n                </a>\n                <a ng-switch-default>\n                    <span compile="button"></span>\n                </a>\n            </li>\n        </ul>\n    </span>\n</span>'
	    };
	}
	
	maViewBatchActionsDirective.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maViewBatchActions.js.map

/***/ },
/* 202 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maBooleanColumn;
	function maBooleanColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&'
	        },
	        link: function link(scope) {
	            scope.value = scope.value();
	        },
	        template: '<span class="glyphicon" ng-class="{\'glyphicon-ok\': !!value, \'glyphicon-remove\': !value }"></span>'
	    };
	}
	
	maBooleanColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maBooleanColumn.js.map

/***/ },
/* 203 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maChoicesColumn;
	function maChoicesColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            values: '&'
	        },
	        template: '<span ng-repeat="ref in values() track by $index" class="label label-default">{{ ref }}</span>'
	    };
	}
	
	maChoicesColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maChoicesColumn.js.map

/***/ },
/* 204 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	exports.default = maColumn;
	function maColumn($state, $anchorScroll, $compile, Configuration, FieldViewConfiguration) {
	
	    function getDetailLinkRouteName(field, entity) {
	        if (entity.isReadOnly) {
	            return entity.showView().enabled ? 'show' : false;
	        }
	        if (field.detailLinkRoute() == 'edit' && entity.editionView().enabled) {
	            return 'edit';
	        }
	        return entity.showView().enabled ? 'show' : false;
	    }
	
	    function isDetailLink(field, entity) {
	        if (field.isDetailLink() === false) {
	            return false;
	        }
	        if (field.type() == 'reference' || field.type() == 'reference_many') {
	            var relatedEntity = Configuration().getEntity(field.targetEntity().name());
	            if (!relatedEntity) {
	                return false;
	            }
	            return getDetailLinkRouteName(field, relatedEntity) !== false;
	        }
	        return getDetailLinkRouteName(field, entity) !== false;
	    }
	
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            entry: '&',
	            entity: '&',
	            datastore: '&'
	        },
	        link: function link(scope, element) {
	            scope.datastore = scope.datastore();
	            scope.field = scope.field();
	            scope.entry = scope.entry();
	            scope.value = typeof scope.entry === 'undefined' ? '' : scope.entry.values[scope.field.name()];
	            scope.entity = scope.entity();
	            var customTemplate = scope.field.getTemplateValue(scope.entry);
	            if (customTemplate && !scope.field.templateIncludesLabel()) {
	                element.append(customTemplate);
	            } else {
	                var type = scope.field.type();
	                if (isDetailLink(scope.field, scope.entity)) {
	                    element.append(FieldViewConfiguration[type].getLinkWidget());
	                } else {
	                    element.append(FieldViewConfiguration[type].getReadWidget());
	                }
	            }
	            scope.detailState = false;
	            scope.detailStateParams = {};
	            if (typeof scope.entry !== 'undefined') {
	                scope.detailState = getDetailLinkRouteName(scope.field, scope.entity);
	                scope.detailStateParams = _extends({}, $state.params, {
	                    entity: scope.entry.entityName,
	                    id: scope.entry.identifierValue
	                });
	            }
	            $compile(element.contents())(scope);
	        }
	    };
	}
	
	maColumn.$inject = ['$state', '$anchorScroll', '$compile', 'NgAdminConfiguration', 'FieldViewConfiguration'];
	module.exports = exports['default'];
	//# sourceMappingURL=maColumn.js.map

/***/ },
/* 205 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDateColumn;
	function maDateColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&',
	            field: '&'
	        },
	        link: function link(scope) {
	            var field = scope.field();
	            scope.format = field.format();
	            if (!scope.format) {
	                scope.format = field.type() === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss';
	            }
	        },
	        template: '<span>{{ value() | date:format }}</span>'
	    };
	}
	
	maDateColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maDateColumn.js.map

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maEmbeddedListColumn;
	
	var _Entry = __webpack_require__(8);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function sorter(sortField, sortDir) {
	    return function (entry1, entry2) {
	        // use < and > instead of substraction to sort strings properly
	        var sortFactor = sortDir === 'DESC' ? -1 : 1;
	        if (entry1.values[sortField] > entry2.values[sortField]) {
	            return sortFactor;
	        }
	        if (entry1.values[sortField] < entry2.values[sortField]) {
	            return -1 * sortFactor;
	        }
	        return 0;
	    };
	}
	
	function maEmbeddedListColumn(NgAdminConfiguration) {
	    var application = NgAdminConfiguration(); // jshint ignore:line
	    return {
	        scope: {
	            'field': '&',
	            'value': '&',
	            'datastore': '&'
	        },
	        restrict: 'E',
	        link: {
	            pre: function pre(scope) {
	                var field = scope.field();
	                var targetEntity = field.targetEntity();
	                var targetEntityName = targetEntity.name();
	                var targetFields = field.targetFields();
	                var sortField = field.sortField();
	                var sortDir = field.sortDir();
	                var filterFunc;
	                if (field.permanentFilters()) {
	                    (function () {
	                        var filters = field.permanentFilters();
	                        var filterKeys = Object.keys(filters);
	                        filterFunc = function filterFunc(entry) {
	                            return filterKeys.reduce(function (isFiltered, key) {
	                                return isFiltered && entry.values[key] === filters[key];
	                            }, true);
	                        };
	                    })();
	                } else {
	                    filterFunc = function filterFunc() {
	                        return true;
	                    };
	                }
	                var entries = _Entry2.default.createArrayFromRest(scope.value() || [], targetFields, targetEntityName, targetEntity.identifier().name()).sort(sorter(sortField, sortDir)).filter(filterFunc);
	                if (!targetEntityName) {
	                    (function () {
	                        var index = 0;
	                        entries = entries.map(function (e) {
	                            e._identifierValue = index++;
	                            return e;
	                        });
	                    })();
	                }
	                scope.field = field;
	                scope.targetFields = targetFields;
	                scope.entries = entries;
	                scope.entity = targetEntityName ? application.getEntity(targetEntityName) : targetEntity;
	                scope.sortField = sortField;
	                scope.sortDir = sortDir;
	                scope.sort = function (field) {
	                    var sortDir = 'ASC';
	                    var sortField = field.name();
	                    if (scope.sortField === sortField) {
	                        // inverse sort dir
	                        sortDir = scope.sortDir === 'ASC' ? 'DESC' : 'ASC';
	                    }
	                    scope.entries = scope.entries.sort(sorter(sortField, sortDir));
	                    scope.sortField = sortField;
	                    scope.sortDir = sortDir;
	                };
	            }
	        },
	        template: '\n<ma-datagrid ng-if="::entries.length > 0"\n    entries="entries"\n    fields="::targetFields"\n    list-actions="::field.listActions()"\n    entity="::entity"\n    datastore="::datastore()"\n    sort-field="sortField"\n    sort-dir="sortDir"\n    sort="::sort">\n</ma-datagrid>'
	    };
	}
	
	maEmbeddedListColumn.$inject = ['NgAdminConfiguration'];
	module.exports = exports['default'];
	//# sourceMappingURL=maEmbeddedListColumn.js.map

/***/ },
/* 207 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maJsonColumn;
	function maJsonColumn($compile) {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&'
	        },
	        link: function link(scope, element) {
	            scope.guessType = function (obj) {
	                var type = Object.prototype.toString.call(obj);
	
	                if (type === "[object Object]") {
	                    return "Object";
	                }
	
	                if (type === "[object Array]") {
	                    return "Array";
	                }
	
	                return "Literal";
	            };
	
	            var template = '<span ng-switch="guessType(value())">\n    <table class="table table-condensed" ng-switch-when="Array">\n        <tbody>\n            <tr ng-repeat="val in value() track by $index">\n                <td ng-switch="guessType(val)">\n                    <ma-json-column ng-switch-when="Object" value="::val"></ma-json-column>\n                    <ma-json-column ng-switch-when="Array" value="::val"></ma-json-column>\n                    <span ng-switch-when="Literal">{{ val }}</span>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n    <table class="table table-condensed table-bordered" ng-switch-when="Object">\n        <tbody>\n            <tr ng-repeat="(key, val) in value() track by key">\n                <th class="active">{{ key }}</th>\n                <td ng-switch="guessType(val)">\n                    <ma-json-column ng-switch-when="Object" value="::val"></ma-json-column>\n                    <ma-json-column ng-switch-when="Array" value="::val"></ma-json-column>\n                    <span ng-switch-when="Literal">{{ val }}</span>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n</span>';
	
	            var newElement = angular.element(template);
	            $compile(newElement)(scope);
	            element.replaceWith(newElement);
	        }
	    };
	}
	
	maJsonColumn.$inject = ['$compile'];
	module.exports = exports['default'];
	//# sourceMappingURL=maJsonColumn.js.map

/***/ },
/* 208 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maNumberColumn;
	function maNumberColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&',
	            field: '&'
	        },
	        template: '<span>{{ value() | numeraljs:field().format() }}</span>'
	    };
	}
	
	maNumberColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maNumberColumn.js.map

/***/ },
/* 209 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maReferenceColumn;
	function maReferenceColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            value: '&',
	            datastore: '&'
	        },
	        link: {
	            pre: function pre(scope) {
	                var value = scope.value();
	                scope.field = scope.field();
	                scope.targetEntity = scope.field.targetEntity();
	                scope.targetField = scope.field.targetField();
	                var identifierName = scope.targetEntity.identifier().name();
	                scope.referencedEntry = scope.datastore().getFirstEntry(scope.targetEntity.uniqueId + '_values', function (entry) {
	                    return entry.values[identifierName] == value;
	                });
	            }
	        },
	        template: '<ma-column field="::targetField" entry="::referencedEntry" entity="::targetEntity" datastore="::datastore()"></ma-column>'
	    };
	}
	
	maReferenceColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maReferenceColumn.js.map

/***/ },
/* 210 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maReferenceLinkColumn;
	function getDetailLinkRouteName(field, entity) {
	    if (entity.isReadOnly) {
	        return entity.showView().enabled ? 'show' : false;
	    }
	    if (field.detailLinkRoute() == 'edit' && entity.editionView().enabled) {
	        return 'edit';
	    }
	    return entity.showView().enabled ? 'show' : false;
	}
	
	function maReferenceLinkColumn(NgAdminConfiguration) {
	    return {
	        restrict: 'E',
	        scope: {
	            entry: '&',
	            field: '&',
	            value: '&',
	            datastore: '&'
	        },
	        link: {
	            pre: function pre(scope) {
	                var field = scope.field();
	                var referenceEntity = field.targetEntity().name();
	                var relatedEntity = NgAdminConfiguration().getEntity(referenceEntity);
	                var referenceId = scope.entry().values[field.name()];
	                scope.route = getDetailLinkRouteName(field, relatedEntity);
	                scope.stateParams = {
	                    entity: referenceEntity,
	                    id: referenceId
	                };
	                scope.field = field;
	            }
	        },
	        template: '<a ui-sref="{{route}}(stateParams)"><ma-reference-column field="::field" value="::value()" datastore="::datastore()"></ma-reference-column></a>'
	    };
	}
	
	maReferenceLinkColumn.$inject = ['NgAdminConfiguration'];
	module.exports = exports['default'];
	//# sourceMappingURL=maReferenceLinkColumn.js.map

/***/ },
/* 211 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maReferenceManyColumn;
	function maReferenceManyColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            values: '&'
	        },
	        template: '<span ng-repeat="ref in values() track by $index">\n    <span class="label label-default">{{ ref }}</span>\n</span>'
	    };
	}
	
	maReferenceManyColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maReferenceManyColumn.js.map

/***/ },
/* 212 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maReferenceManyLinkColumn;
	function maReferenceManyLinkColumn(NgAdminConfiguration) {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            values: '&',
	            ids: '&'
	        },
	        link: function link(scope) {
	            scope.field = scope.field();
	            scope.values = scope.values();
	            scope.ids = scope.ids();
	            scope.referenceEntity = scope.field.targetEntity().name();
	            scope.route = NgAdminConfiguration().getEntity(scope.referenceEntity).isReadOnly ? 'show' : 'edit';
	        },
	        template: '<a ng-repeat="ref in values track by $index" ui-sref="{{route}}({ entity: referenceEntity, id: ids[$index] })" class="multiple">\n    <span class="label label-default">{{ ref }}</span>\n</a>'
	    };
	}
	
	maReferenceManyLinkColumn.$inject = ['NgAdminConfiguration'];
	module.exports = exports['default'];
	//# sourceMappingURL=maReferenceManyLinkColumn.js.map

/***/ },
/* 213 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maReferencedListColumn;
	function isSortFieldForMe(sortField, field) {
	    if (!sortField) return false;
	    return sortField.split('.')[0] == field.targetEntity().name() + '_ListView';
	}
	
	function maReferencedListColumn(NgAdminConfiguration, $stateParams) {
	    return {
	        scope: {
	            'field': '&',
	            'datastore': '&'
	        },
	        restrict: 'E',
	        link: {
	            pre: function pre(scope) {
	                scope.field = scope.field();
	                var targetEntity = scope.field.targetEntity();
	                scope.entries = scope.datastore().getEntries(targetEntity.uniqueId + '_list');
	                scope.entity = NgAdminConfiguration().getEntity(targetEntity.name());
	                scope.sortField = isSortFieldForMe($stateParams.sortField, scope.field) ? $stateParams.sortField : scope.field.getSortFieldName();
	                scope.sortDir = $stateParams.sortDir || scope.field.sortDir();
	            }
	        },
	        template: '\n<ma-datagrid ng-if="::entries.length > 0" name="{{ field.datagridName() }}"\n    entries="::entries"\n    fields="::field.targetFields()"\n    list-actions="::field.listActions()"\n    entity="::entity"\n    sort-field="::sortField"\n    sort-dir="::sortDir"\n    datastore="::datastore()"\n    entry-css-classes="::field.entryCssClasses()">\n</ma-datagrid>'
	    };
	}
	
	maReferencedListColumn.$inject = ['NgAdminConfiguration', '$stateParams'];
	module.exports = exports['default'];
	//# sourceMappingURL=maReferencedListColumn.js.map

/***/ },
/* 214 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maStringColumn;
	function maStringColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&'
	        },
	        template: '<span>{{ value() | translate }}</span>'
	    };
	}
	
	maStringColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maStringColumn.js.map

/***/ },
/* 215 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maTemplateColumn;
	function maTemplateColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            entry: '&',
	            entity: '&'
	        },
	        link: function link(scope) {
	            scope.field = scope.field();
	            scope.entry = scope.entry();
	            scope.entity = scope.entity();
	        },
	        template: '<span compile="field.getTemplateValue(entry)"></span>'
	    };
	}
	
	maTemplateColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maTemplateColumn.js.map

/***/ },
/* 216 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maWysiwygColumn;
	function maWysiwygColumn($filter) {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&',
	            field: '&'
	        },
	        link: function link(scope) {
	            var value = scope.value();
	            if (scope.field().stripTags()) {
	                value = $filter('stripTags')(value);
	            }
	            scope.htmlValue = value;
	        },
	        template: '<span ng-bind-html="htmlValue"></span>'
	    };
	}
	
	maWysiwygColumn.$inject = ['$filter'];
	module.exports = exports['default'];
	//# sourceMappingURL=maWysiwygColumn.js.map

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = factories;
	function factories(fvp) {
	    fvp.registerFieldView('boolean', __webpack_require__(236));
	    fvp.registerFieldView('choice', __webpack_require__(237));
	    fvp.registerFieldView('choices', __webpack_require__(238));
	    fvp.registerFieldView('date', __webpack_require__(239));
	    fvp.registerFieldView('datetime', __webpack_require__(240));
	    fvp.registerFieldView('email', __webpack_require__(241));
	    fvp.registerFieldView('embedded_list', __webpack_require__(242));
	    fvp.registerFieldView('file', __webpack_require__(244));
	    fvp.registerFieldView('float', __webpack_require__(245));
	    fvp.registerFieldView('json', __webpack_require__(246));
	    fvp.registerFieldView('number', __webpack_require__(247));
	    fvp.registerFieldView('password', __webpack_require__(248));
	    fvp.registerFieldView('referenced_list', __webpack_require__(251));
	    fvp.registerFieldView('reference', __webpack_require__(249));
	    fvp.registerFieldView('reference_many', __webpack_require__(250));
	    fvp.registerFieldView('string', __webpack_require__(252));
	    fvp.registerFieldView('template', __webpack_require__(253));
	    fvp.registerFieldView('text', __webpack_require__(254));
	    fvp.registerFieldView('wysiwyg', __webpack_require__(255));
	}
	
	factories.$inject = ['FieldViewConfigurationProvider'];
	module.exports = exports['default'];
	//# sourceMappingURL=factories.js.map

/***/ },
/* 218 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var BatchDeleteController = function () {
	    function BatchDeleteController($scope, $state, $translate, WriteQueries, progression, notification, view) {
	        _classCallCheck(this, BatchDeleteController);
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$translate = $translate;
	        this.WriteQueries = WriteQueries;
	        this.progression = progression;
	        this.notification = notification;
	        this.view = view;
	        this.entity = view.getEntity();
	        this.entityIds = $state.params.ids;
	        this.selection = []; // fixme: query db to get selection
	        this.title = view.title();
	        this.description = view.description();
	        this.actions = view.actions();
	        this.loadingPage = false;
	        this.fields = view.fields();
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    _createClass(BatchDeleteController, [{
	        key: 'batchDelete',
	        value: function batchDelete() {
	            var _this = this;
	
	            var entityName = this.entity.name();
	            var $translate = this.$translate;
	            var $state = this.$state;
	            var progression = this.progression;
	            var notification = this.notification;
	
	            progression.start();
	            return this.WriteQueries.batchDelete(this.view, this.entityIds).then(function () {
	                return $state.go($state.get('list'), angular.extend({ entity: entityName }, $state.params));
	            })
	            // no need to call progression.done() in case of success, as it's called by the view dislayed afterwards
	            .then(function () {
	                return $translate('BATCH_DELETE_SUCCESS');
	            }).then(function (text) {
	                return notification.log(text, { addnCls: 'humane-flatty-success' });
	            }).catch(function (error) {
	                var errorMessage = _this.config.getErrorMessageFor(_this.view, error) || 'ERROR_MESSAGE';
	                progression.done();
	
	                $translate(errorMessage, {
	                    status: error && error.status,
	                    details: error && error.data && _typeof(error.data) === 'object' ? JSON.stringify(error.data) : {}
	                }).catch(angular.identity) // See https://github.com/angular-translate/angular-translate/issues/1516
	                .then(function (text) {
	                    return notification.log(text, { addnCls: 'humane-flatty-error' });
	                });
	            });
	        }
	    }, {
	        key: 'back',
	        value: function back() {
	            this.$state.go(this.$state.get('list'), angular.extend({
	                entity: this.entity.name()
	            }, this.$state.params));
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	            this.$state = undefined;
	            this.$translate = undefined;
	            this.WriteQueries = undefined;
	            this.progression = undefined;
	            this.notification = undefined;
	        }
	    }]);
	
	    return BatchDeleteController;
	}();
	
	exports.default = BatchDeleteController;
	
	BatchDeleteController.$inject = ['$scope', '$state', '$translate', 'WriteQueries', 'progression', 'notification', 'view'];
	module.exports = exports['default'];
	//# sourceMappingURL=BatchDeleteController.js.map

/***/ },
/* 219 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var DeleteController = function () {
	    function DeleteController($scope, $window, $state, $q, $translate, WriteQueries, Configuration, progression, notification, params, view, entry) {
	        var _this = this;
	
	        _classCallCheck(this, DeleteController);
	
	        this.$scope = $scope;
	        this.$window = $window;
	        this.$state = $state;
	        this.$translate = $translate;
	        this.WriteQueries = WriteQueries;
	        this.config = Configuration();
	        this.entityLabel = params.entity;
	        this.entityId = params.id;
	        this.view = view;
	        this.title = view.title();
	        this.description = view.description();
	        this.actions = view.actions();
	        this.entity = view.getEntity();
	        this.progression = progression;
	        this.notification = notification;
	        this.$scope.entry = entry;
	        this.$scope.view = view;
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	
	        this.previousStateParametersDeferred = $q.defer();
	        $scope.$on('$stateChangeSuccess', function (event, to, toParams, from, fromParams) {
	            _this.previousStateParametersDeferred.resolve(fromParams);
	        });
	    }
	
	    _createClass(DeleteController, [{
	        key: 'deleteOne',
	        value: function deleteOne() {
	            var _this2 = this;
	
	            var entityName = this.entity.name();
	            var $translate = this.$translate;
	            var notification = this.notification;
	            var progression = this.progression;
	
	            progression.start();
	            return this.WriteQueries.deleteOne(this.view, this.entityId).then(function () {
	                return _this2.previousStateParametersDeferred.promise;
	            }).then(function (previousStateParameters) {
	                // if previous page was related to deleted entity, redirect to list
	                if (previousStateParameters.entity === entityName && previousStateParameters.id === _this2.entityId) {
	                    return _this2.$state.go(_this2.$state.get('list'), angular.extend({
	                        entity: entityName
	                    }, _this2.$state.params));
	                }
	                return _this2.back();
	            })
	            // no need to call progression.done() in case of success, as it's called by the view dislayed afterwards
	            .then(function () {
	                return $translate('DELETE_SUCCESS');
	            }).then(function (text) {
	                return notification.log(text, { addnCls: 'humane-flatty-success' });
	            }).catch(function (error) {
	                var errorMessage = _this2.config.getErrorMessageFor(_this2.view, error) || 'ERROR_MESSAGE';
	                progression.done();
	                $translate(errorMessage, {
	                    status: error && error.status,
	                    details: error && error.data && _typeof(error.data) === 'object' ? JSON.stringify(error.data) : {}
	                }).catch(angular.identity) // See https://github.com/angular-translate/angular-translate/issues/1516
	                .then(function (text) {
	                    return notification.log(text, { addnCls: 'humane-flatty-error' });
	                });
	            });
	        }
	    }, {
	        key: 'back',
	        value: function back() {
	            this.$window.history.back();
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	            this.$window = undefined;
	            this.$state = undefined;
	            this.$translate = undefined;
	            this.WriteQueries = undefined;
	            this.view = undefined;
	            this.entity = undefined;
	            this.progression = undefined;
	            this.notification = undefined;
	        }
	    }]);
	
	    return DeleteController;
	}();
	
	exports.default = DeleteController;
	
	DeleteController.$inject = ['$scope', '$window', '$state', '$q', '$translate', 'WriteQueries', 'NgAdminConfiguration', 'progression', 'notification', 'params', 'view', 'entry'];
	module.exports = exports['default'];
	//# sourceMappingURL=DeleteController.js.map

/***/ },
/* 220 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maButtonField;
	/**
	 * Toggle input
	 *
	 * @example <ma-button-field type="text" field="field" value="value"></ma-button-field>
	 */
	function maButtonField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: function link(scope, element) {
	            var field = scope.field();
	            scope.name = field.name();
	            scope.label = field.label();
	            scope.value = !!scope.value;
	            var a = element.children()[0];
	            var attributes = field.attributes();
	            for (var name in attributes) {
	                a.setAttribute(name, attributes[name]);
	            }
	            scope.toggle = function () {
	                this.value = !this.value;
	            };
	            scope.isActive = function () {
	                return !!this.value;
	            };
	        },
	        template: '<a class="btn btn-default" ng-click="toggle()" id="{{ name }}" ng-class="{active: isActive()}" >{{ label | translate }}</a>'
	    };
	}
	
	maButtonField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maButtonField.js.map

/***/ },
/* 221 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maCheckboxField;
	/**
	 * Generic edition field
	 *
	 * @example <ma-checkbox-field type="text" field="field" value="value"></ma-checkbox-field>
	 */
	function maCheckboxField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: function link(scope, element) {
	            var field = scope.field();
	            scope.name = field.name();
	            scope.v = field.validation();
	            scope.value = !!scope.value;
	            var input = element.children()[0];
	            var attributes = field.attributes();
	            for (var name in attributes) {
	                input.setAttribute(name, attributes[name]);
	            }
	        },
	        template: '<input type="checkbox" ng-model="value" id="{{ name }}" name="{{ name }}" class="form-control" />'
	    };
	}
	
	maCheckboxField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maCheckboxField.js.map

/***/ },
/* 222 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maChoiceField;
	function updateChoices(scope, choices) {
	    scope.choices = choices;
	    scope.$root.$$phase || scope.$digest();
	}
	
	function maChoiceField($compile) {
	    return {
	        scope: {
	            'field': '&',
	            'value': '=',
	            'entry': '=?',
	            'datastore': '&?',
	            'refresh': '&',
	            'choices': '&?'
	        },
	        restrict: 'E',
	        compile: function compile() {
	            return {
	                pre: function pre(scope, element) {
	                    var field = scope.field();
	                    var attributes = field.attributes();
	                    scope.placeholder = attributes && attributes.placeholder || 'FILTER_VALUES';
	                    scope.name = field.name();
	                    scope.v = field.validation();
	                    scope.$watch('value', function (newValue, oldValue) {
	                        if (newValue !== oldValue && newValue === undefined) {
	                            // fix for https://github.com/angular-ui/ui-select/issues/863
	                            scope.value = null;
	                        }
	                    });
	
	                    var refreshAttributes = '';
	                    var itemsFilter = '| filter: {label: $select.search}';
	                    if (field.type().indexOf('reference') === 0 && field.remoteComplete()) {
	                        // FIXME wrong place to do that
	                        scope.refreshDelay = field.remoteCompleteOptions().refreshDelay;
	                        refreshAttributes = 'refresh-delay="refreshDelay" refresh="refresh({ $search: $select.search })"';
	                        itemsFilter = '';
	                    }
	
	                    var choices = scope.choices ? scope.choices : field.choices ? field.choices() : [];
	                    var choicesFactory = void 0;
	
	                    if (typeof choices === 'function' && choices(scope.entry)) {
	                        choicesFactory = choices;
	                        scope.choices = choicesFactory(scope.entry);
	                    } else {
	                        scope.choices = choices ? choices : [];
	                    }
	
	                    var template = '\n                        <ui-select ng-model="$parent.value" ng-required="v.required" id="{{ name }}" name="{{ name }}">\n                            <ui-select-match allow-clear="{{ !v.required }}" placeholder="{{ placeholder | translate }}">{{ $select.selected.label | translate }}</ui-select-match>\n                            <ui-select-choices ' + refreshAttributes + ' repeat="item.value as item in choices ' + itemsFilter + ' track by $index">\n                                {{ item.label | translate }}\n                            </ui-select-choices>\n                        </ui-select>';
	
	                    // as choices may be a function depending of another entry field, we need to watch the whole entry
	                    scope.$watch('entry', function (newEntry, oldEntry) {
	                        if (!choicesFactory) {
	                            return;
	                        }
	
	                        var oldChoices = scope.choices;
	                        scope.choices = choicesFactory(newEntry);
	                        if (!angular.equals(scope.choices, oldChoices)) {
	                            scope.value = null;
	                        }
	                    }, true);
	
	                    element.html(template);
	
	                    var select = element.children()[0];
	                    for (var name in attributes) {
	                        select.setAttribute(name, attributes[name]);
	                    }
	
	                    $compile(element.contents())(scope);
	                },
	                post: function post(scope) {
	                    scope.$on('choices:update', function (e, data) {
	                        updateChoices(scope, data.choices);
	                    });
	                }
	            };
	        }
	    };
	}
	
	maChoiceField.$inject = ['$compile'];
	module.exports = exports['default'];
	//# sourceMappingURL=maChoiceField.js.map

/***/ },
/* 223 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maChoicesField;
	/**
	 * Edition field for a selection of elements in a list - a multiple select.
	 *
	 * @example <ma-choices-field entry="entry" field="field" value="value"></ma-choices-field>
	 */
	function maChoicesField($compile) {
	    'use strict';
	
	    return {
	        scope: {
	            'field': '&',
	            'value': '=',
	            'entry': '=?',
	            'datastore': '&?',
	            'refresh': '&'
	        },
	        restrict: 'E',
	        compile: function compile() {
	            return {
	                pre: function pre(scope, element) {
	                    var field = scope.field();
	                    var attributes = field.attributes();
	                    scope.placeholder = attributes && attributes.placeholder || 'FILTER_VALUES';
	                    scope.name = field.name();
	                    scope.v = field.validation();
	
	                    var refreshAttributes = '';
	                    var itemsFilter = '| filter: {label: $select.search}';
	                    if (field.type().indexOf('reference') === 0 && field.remoteComplete()) {
	                        scope.refreshDelay = field.remoteCompleteOptions().refreshDelay;
	                        refreshAttributes = 'refresh-delay="refreshDelay" refresh="refresh({ $search: $select.search })"';
	                        itemsFilter = '';
	                    }
	
	                    var choices = field.choices ? field.choices() : [];
	
	                    scope.onRemove = function () {
	                        scope.refresh({ $search: this.$select.search });
	                    };
	
	                    var template = '\n                        <ui-select ' + (scope.v.required ? 'ui-select-required' : '') + ' multiple on-remove="onRemove()" ng-model="$parent.value" ng-required="v.required" id="{{ name }}" name="{{ name }}">\n                            <ui-select-match placeholder="{{ placeholder | translate }}">{{ $item.label | translate }}</ui-select-match>\n                            <ui-select-choices ' + refreshAttributes + ' repeat="item.value as item in choices ' + itemsFilter + '">\n                                {{ item.label | translate }}\n                            </ui-select-choices>\n                        </ui-select>';
	
	                    scope.choices = typeof choices === 'function' ? choices(scope.entry) : choices;
	                    element.html(template);
	
	                    var select = element.children()[0];
	
	                    for (var name in attributes) {
	                        select.setAttribute(name, attributes[name]);
	                    }
	
	                    $compile(element.contents())(scope);
	                },
	                post: function post(scope) {
	                    scope.$on('choices:update', function (e, data) {
	                        scope.choices = data.choices;
	                        scope.$root.$$phase || scope.$digest();
	                    });
	                }
	            };
	        }
	    };
	}
	
	maChoicesField.$inject = ['$compile'];
	module.exports = exports['default'];
	//# sourceMappingURL=maChoicesField.js.map

/***/ },
/* 224 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDateField;
	/**
	 * Edition field for a date - a text input with a datepicker.
	 *
	 * @example <ma-date-field field="field" value="value"></ma-date-field>
	 */
	function maDateField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: function link(scope, element) {
	            var field = scope.field();
	            scope.name = field.name();
	            scope.rawValue = scope.value == null ? null : scope.value instanceof Date ? scope.value : new Date(scope.value);
	
	            scope.$watch('rawValue', function (newValue) {
	                scope.value = field.parse()(newValue);
	            });
	
	            scope.$watch('value', function (newValue, oldValue) {
	                if (newValue === oldValue) {
	                    return;
	                }
	
	                if (!newValue) {
	                    scope.rawValue = null;
	                    return;
	                }
	
	                scope.rawValue = scope.value instanceof Date ? scope.value : new Date(scope.value);
	            });
	
	            scope.format = field.format();
	            if (!scope.format) {
	                scope.format = field.type() === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss';
	            }
	
	            scope.v = field.validation();
	            scope.isOpen = false;
	            var input = element.find('input').eq(0);
	            var attributes = field.attributes();
	            for (var name in attributes) {
	                input.attr(name, attributes[name]);
	            }
	            scope.toggleDatePicker = function ($event) {
	                $event.preventDefault();
	                $event.stopPropagation();
	                scope.isOpen = !scope.isOpen;
	            };
	        },
	        template: '<div class="input-group datepicker">\n    <input\n        type="text" ng-model="rawValue" id="{{ name }}" name="{{ name }}" class="form-control"\n        uib-datepicker-popup="{{ format }}" is-open="isOpen" ng-required="v.required"\n        close-text="{{ \'CLOSE\' | translate }}" clear-text="{{ \'CLEAR\' | translate }}" current-text="{{ \'CURRENT\' | translate }}"/>\n    <span class="input-group-btn">\n        <button type="button" class="btn btn-default" ng-click="toggleDatePicker($event)">\n            <i class="glyphicon glyphicon-calendar"></i>\n        </button>\n    </span>\n</div>'
	    };
	}
	
	maDateField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maDateField.js.map

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maEmbeddedListField;
	
	var _Entry = __webpack_require__(8);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function maEmbeddedListField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '=',
	            'datastore': '&'
	        },
	        restrict: 'E',
	        link: {
	            pre: function pre(scope) {
	                var field = scope.field();
	                var targetEntity = field.targetEntity();
	                var targetEntityName = targetEntity.name();
	                var targetFields = field.targetFields();
	                var sortField = field.sortField();
	                var sortDir = field.sortDir() === 'DESC' ? -1 : 1;
	                var filterFunc;
	                if (field.permanentFilters()) {
	                    (function () {
	                        var filters = field.permanentFilters();
	                        var filterKeys = Object.keys(filters);
	                        filterFunc = function filterFunc(entry) {
	                            return filterKeys.reduce(function (isFiltered, key) {
	                                return isFiltered && entry.values[key] === filters[key];
	                            }, true);
	                        };
	                    })();
	                } else {
	                    filterFunc = function filterFunc() {
	                        return true;
	                    };
	                }
	                scope.fields = targetFields;
	                scope.targetEntity = targetEntity;
	                scope.entries = _Entry2.default.createArrayFromRest(scope.value || [], targetFields, targetEntityName, targetEntity.identifier().name()).sort(function (entry1, entry2) {
	                    // use < and > instead of substraction to sort strings properly
	                    if (entry1.values[sortField] > entry2.values[sortField]) {
	                        return sortDir;
	                    }
	                    if (entry1.values[sortField] < entry2.values[sortField]) {
	                        return -1 * sortDir;
	                    }
	                    return 0;
	                }).filter(filterFunc);
	                scope.addNew = function () {
	                    return scope.entries.push(_Entry2.default.createForFields(targetFields));
	                };
	                scope.remove = function (entry) {
	                    scope.entries = scope.entries.filter(function (e) {
	                        return e !== entry;
	                    });
	                };
	                scope.$watch('entries', function (newEntries, oldEntries) {
	                    if (newEntries === oldEntries) {
	                        return;
	                    }
	                    scope.value = newEntries.map(function (e) {
	                        return e.transformToRest(targetFields);
	                    });
	                }, true);
	            }
	        },
	        template: '\n<div class="row"><div class="col-sm-12">\n    <ng-form ng-repeat="entry in entries track by $index" class="subentry" name="subform_{{$index}}" ng-init="formName = \'subform_\' + $index">\n        <div class="remove_button_container">\n            <a class="btn btn-default btn-sm" ng-click="remove(entry)"><span class="glyphicon glyphicon-minus-sign" aria-hidden="true"></span>&nbsp;<span translate="REMOVE"></span></a>\n        </div>\n        <div class="form-field form-group" ng-repeat="field in ::fields track by $index">\n            <ma-field field="::field" value="entry.values[field.name()]" entry="entry" entity="::targetEntity" form="formName" datastore="::datastore()"></ma-field>\n        </div>\n        <hr/>\n    </ng-form>\n    <div class="form-group">\n        <div class="col-sm-offset-2 col-sm-10">\n            <a class="btn btn-default btn-sm" ng-click="addNew()"><span class="glyphicon glyphicon-plus-sign" aria-hidden="true"></span>&nbsp;<span translate="ADD_NEW" translate-values="{ name: field().label().toLowerCase() }"></span></a>\n        </div>\n    </div>\n</div></div>'
	    };
	}
	
	maEmbeddedListField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maEmbeddedListField.js.map

/***/ },
/* 226 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maField;
	function maField(FieldViewConfiguration, $compile) {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            entry: '=',
	            value: '=',
	            entity: '&',
	            form: '&',
	            datastore: '&'
	        },
	        link: function link(scope, element) {
	            var field = scope.field();
	            var type = field.type();
	            scope.field = field;
	            scope.type = type;
	            scope.entity = scope.entity();
	            scope.form = scope.form();
	            scope.datastore = scope.datastore();
	            scope.getCssClasses = function (entry) {
	                return 'ng-admin-field-' + field.name().replace('.', '_') + ' ng-admin-type-' + type + ' ' + (field.getCssClasses(entry) || 'col-sm-10 col-md-8 col-lg-7');
	            };
	
	            scope.getInput = function () {
	                return scope.form[field.name()];
	            };
	
	            /**
	             * Should validation status be displayed for a given field?
	             *
	             * - No for non-editable fields, or template fields which not have a corresponding input
	             * - No for non-altered input
	             * - Yes otherwise
	             */
	            scope.fieldHasValidation = function () {
	                var input = this.getInput();
	                return input && input.$dirty;
	            };
	
	            scope.fieldIsValid = function () {
	                var input = this.getInput();
	                return input && input.$valid;
	            };
	
	            scope.getFieldValidationClass = function () {
	                if (this.fieldHasValidation()) {
	                    return this.fieldIsValid() ? 'has-success' : 'has-error';
	                }
	            };
	
	            var fieldTemplate;
	            if (scope.field.editable()) {
	                fieldTemplate = '<div ng-class="getCssClasses(entry)">\n    ' + (!field.templateIncludesLabel() && field.getTemplateValue(scope.entry) || FieldViewConfiguration[type].getWriteWidget()) + '\n    <span ng-show="fieldHasValidation()" class="glyphicon form-control-feedback" ng-class="fieldIsValid() ? \'glyphicon-ok\' : \'glyphicon-remove\'"></span>\n</div>';
	            } else {
	                fieldTemplate = '<div ng-class="field.getCssClasses(entry)||\'col-sm-10\'">\n    <p class="form-control-static">\n        <ma-column field="::field" entry="::entry" entity="::entity" datastore="::datastore"></ma-column>\n    </p>\n</div>';
	            }
	
	            var template = '<div id="row-{{ field.name() }}" class="form-field form-group has-feedback" ng-class="getFieldValidationClass()">\n    <label for="{{ field.name() }}" class="col-sm-2 control-label">\n        {{ field.label() | translate }}<span ng-if="field.validation().required">&nbsp;*</span>&nbsp;\n    </label>\n    ' + fieldTemplate + '\n</div>';
	
	            element.append(template);
	            $compile(element.contents())(scope);
	        }
	    };
	}
	
	maField.$inject = ['FieldViewConfiguration', '$compile'];
	module.exports = exports['default'];
	//# sourceMappingURL=maField.js.map

/***/ },
/* 227 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maFileField;
	/**
	 * Edition field for a file - a file uploader.
	 *
	 * @example <ma-file-field field="field"></ma-file-field>
	 */
	function maFileField(Upload) {
	    return {
	        scope: {
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: {
	            pre: function pre(scope) {
	                var uploadInformation = scope.field().uploadInformation();
	                if (!uploadInformation.hasOwnProperty('url')) {
	                    throw new Error('You must provide a URL property to allow the upload of files.');
	                }
	
	                scope.multiple = uploadInformation.hasOwnProperty('multiple') ? uploadInformation.multiple : false;
	                scope.accept = "*";
	                if (uploadInformation.hasOwnProperty('accept')) {
	                    scope.accept = uploadInformation.accept;
	                }
	                scope.apifilename = uploadInformation.hasOwnProperty('apifilename') ? uploadInformation.apifilename : false;
	
	                var files = scope.value ? scope.value.split(',') : [];
	                scope.files = {};
	                for (var file in files) {
	                    scope.files[files[file]] = {
	                        "name": files[file],
	                        "progress": 0
	                    };
	                }
	            },
	            post: function post(scope, element) {
	                var field = scope.field();
	                scope.name = field.name();
	                scope.v = field.validation();
	                if (scope.value) {
	                    scope.v.required = false;
	                }
	                var input = element.find('input')[0];
	                var attributes = field.attributes();
	                for (var name in attributes) {
	                    input.setAttribute(name, attributes[name]);
	                }
	
	                scope.fileSelected = function (selectedFiles) {
	                    if (!selectedFiles || !selectedFiles.length) {
	                        return;
	                    }
	
	                    var uploadParams;
	
	                    scope.files = {};
	                    for (var file in selectedFiles) {
	                        uploadParams = angular.copy(scope.field().uploadInformation());
	                        uploadParams.file = selectedFiles[file];
	                        Upload.upload(uploadParams).progress(function (evt) {
	                            scope.files[evt.config.file.name] = {
	                                "name": evt.config.file.name,
	                                "progress": Math.min(100, parseInt(100.0 * evt.loaded / evt.total))
	                            };
	                        }).success(function (data, status, headers, config) {
	                            scope.files[config.file.name] = {
	                                "name": scope.apifilename ? data[scope.apifilename] : config.file.name,
	                                "progress": 0
	                            };
	                            if (scope.apifilename) {
	                                var apiNames = Object.keys(scope.files).map(function (fileindex) {
	                                    return scope.files[fileindex].name;
	                                });
	                                scope.value = apiNames.join(',');
	                            } else {
	                                scope.value = Object.keys(scope.files).join(',');
	                            }
	                        }).error(function (data, status, headers, config) {
	                            delete scope.files[config.file.name];
	
	                            scope.value = Object.keys(scope.files).join(',');
	                        });
	                    }
	                };
	
	                scope.selectFile = function () {
	                    input.click();
	                };
	            }
	        },
	        template: '<div class="row">\n    <div class="col-md-2">\n        <a class="btn btn-default" ng-click="selectFile()">\n            <span translate="BROWSE"></span>\n        </a>\n    </div>\n    <div class="col-md-10">\n        <div class="row" ng-repeat="file in files track by $index">\n            <div class="col-md-3" style="padding-top: 6px;">\n                <div class="progress" style="margin-bottom: 0;" ng-if="file.progress">\n                    <div class="progress-bar" role="progressbar" aria-valuenow="{{ file.progress }}" aria-valuemin="0" aria-valuemax="100" style="width: {{ file.progress }}%;">\n                        <span class="sr-only" translate="N_COMPLETE" translate-values="{ progress: file.progress }"></span>\n                    </div>\n                </div>\n            </div>\n            <div class="col-md-9" style="padding-top: 6px;"><small><em>{{ file.name }}<em><small></div>\n        </div>\n    </div>\n</div>\n<input type="file" ngf-multiple="multiple" accept="{{ accept }}" ngf-select="fileSelected($files)"\n       id="{{ name }}" name="{{ name }}" ng-required="v.required" style="display:none" />'
	    };
	}
	
	maFileField.$inject = ['Upload'];
	module.exports = exports['default'];
	//# sourceMappingURL=maFileField.js.map

/***/ },
/* 228 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maInputField;
	/**
	 * Generic edition field
	 *
	 * @example <ma-input-field type="text" field="field" value="value"></ma-input-field>
	 */
	function maInputField() {
	    return {
	        scope: {
	            'type': '@',
	            'step': '@?',
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: function link(scope, element) {
	            var field = scope.field();
	            scope.name = field.name();
	            scope.v = field.validation();
	            var input = element.children()[0];
	            var attributes = field.attributes();
	            for (var name in attributes) {
	                if (name === 'step') {
	                    // allow to use `step` attribute instead of `scope.step`
	                    scope.step = attributes[name];
	                    continue;
	                }
	
	                input.setAttribute(name, attributes[name]);
	            }
	        },
	        template: '<input type="{{ type || \'text\' }}" ng-attr-step="{{ step }}" ng-model="value"\n    id="{{ name }}" name="{{ name }}" class="form-control"\n    ng-required="v.required" ng-minlength="v.minlength" ng-maxlength="v.maxlength" ng-pattern="v.pattern" />'
	    };
	}
	
	maInputField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maInputField.js.map

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maJsonField;
	var codemirror = __webpack_require__(3);
	
	global.jsonlint = __webpack_require__(184);
	
	__webpack_require__(173);
	__webpack_require__(174);
	__webpack_require__(176);
	__webpack_require__(175);
	__webpack_require__(177);
	__webpack_require__(178);
	
	codemirror.defineOption("matchBrackets", true);
	codemirror.defineOption("autoCloseBrackets", true);
	codemirror.defineOption("lineWrapping", true);
	codemirror.defineOption("tabSize", 2);
	codemirror.defineOption("mode", "application/json");
	codemirror.defineOption("gutters", ["CodeMirror-lint-markers"]);
	codemirror.defineOption("lint", true);
	codemirror.defineOption("styleActiveLine", true);
	
	global.CodeMirror = codemirror;
	
	/**
	 * Edition field for a JSON string in a textarea.
	 *
	 * @example <ma-json-field field="field" value="value"></ma-json-field>
	 */
	function maJsonField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: function link(scope, element) {
	            var field = scope.field();
	            scope.name = field.name();
	            scope.v = field.validation();
	            scope.jsonValue = scope.value === null ? '' : angular.toJson(scope.value, true);
	            var input = element.children()[0];
	            var attributes = field.attributes();
	            for (var name in attributes) {
	                input.setAttribute(name, attributes[name]);
	            }
	            scope.$watch('jsonValue', function (jsonValue) {
	                if (jsonValue == '' || typeof jsonValue === 'undefined') {
	                    scope.value = null;
	
	                    return;
	                }
	                try {
	                    var value = angular.fromJson(jsonValue);
	                    scope.value = value;
	                } catch (e) {
	                    // incorrect JSON, do not convert back to value
	                }
	            });
	        },
	        template: '<textarea ui-codemirror ng-model="jsonValue" id="{{ name }}" name="{{ name }}" ng-required="v.required" ma-json-validator>' + '</textarea>'
	    };
	}
	
	maJsonField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maJsonField.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 230 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maReferenceField;
	function maReferenceField(ReferenceRefresher) {
	    return {
	        scope: {
	            'field': '&',
	            'value': '=',
	            'entry': '=?',
	            'datastore': '&?'
	        },
	        restrict: 'E',
	        link: function link(scope) {
	            var field = scope.field();
	            var identifierName = field.targetEntity().identifier().name();
	            scope.name = field.name();
	            scope.v = field.validation();
	
	            if (!field.remoteComplete()) {
	                // fetch choices from the datastore, populated during routing resolve
	                var initialEntries = scope.datastore().getEntries(field.targetEntity().uniqueId + '_choices');
	                if (scope.value) {
	                    var isCurrentValueInInitialEntries = initialEntries.filter(function (e) {
	                        return e.identifierValue === scope.value;
	                    }).length > 0;
	                    if (!isCurrentValueInInitialEntries) {
	                        initialEntries.unshift(scope.datastore().getEntries(field.targetEntity().uniqueId + '_values').find(function (entry) {
	                            return entry.values[identifierName] == scope.value;
	                        }));
	                    }
	                }
	                var initialChoices = initialEntries.map(function (entry) {
	                    return {
	                        value: entry.values[identifierName],
	                        label: entry.values[field.targetField().name()]
	                    };
	                });
	                scope.$broadcast('choices:update', { choices: initialChoices });
	            } else {
	                // ui-select doesn't allow to prepopulate autocomplete selects, see https://github.com/angular-ui/ui-select/issues/1197
	                // let ui-select fetch the options using the ReferenceRefresher
	                scope.refresh = function refresh(search) {
	                    return ReferenceRefresher.refresh(field, scope.value, search).then(function addCurrentChoice(results) {
	                        if (!search && scope.value) {
	                            var isCurrentValueInEntries = results.filter(function (e) {
	                                return e.value === scope.value;
	                            }).length > 0;
	                            if (!isCurrentValueInEntries) {
	                                var currentEntry = scope.datastore().getEntries(field.targetEntity().uniqueId + '_values').find(function (entry) {
	                                    return entry.values[identifierName] == scope.value;
	                                });
	                                results.unshift({
	                                    value: currentEntry.values[identifierName],
	                                    label: currentEntry.values[field.targetField().name()]
	                                });
	                            }
	                        }
	                        return results;
	                    }).then(function (formattedResults) {
	                        scope.$broadcast('choices:update', { choices: formattedResults });
	                    });
	                };
	            }
	        },
	        template: '<ma-choice-field\n                field="field()"\n                datastore="datastore()"\n                refresh="refresh($search)"\n                value="value">\n            </ma-choice-field>'
	    };
	}
	
	maReferenceField.$inject = ['ReferenceRefresher'];
	module.exports = exports['default'];
	//# sourceMappingURL=maReferenceField.js.map

/***/ },
/* 231 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maReferenceManyField;
	function maReferenceManyField(ReferenceRefresher) {
	    return {
	        scope: {
	            'field': '&',
	            'value': '=',
	            'entry': '=?',
	            'datastore': '&?'
	        },
	        restrict: 'E',
	        link: function link(scope) {
	            var field = scope.field();
	            var identifierName = field.targetEntity().identifier().name();
	            scope.name = field.name();
	            scope.v = field.validation();
	            scope.choices = [];
	
	            var setInitialChoices = function setInitialChoices(initialEntries) {
	                if (scope.value && scope.value.length) {
	                    scope.value.map(function (value) {
	                        var isCurrentValueInInitialEntries = initialEntries.filter(function (e) {
	                            return e.identifierValue === value;
	                        }).length > 0;
	                        if (value && !isCurrentValueInInitialEntries) {
	                            initialEntries.push(scope.datastore().getEntries(field.targetEntity().uniqueId + '_values').filter(function (entry) {
	                                return entry.values[identifierName] == value;
	                            }).pop());
	                        }
	                    });
	                }
	                var initialChoices = initialEntries.map(function (entry) {
	                    return {
	                        value: entry.values[identifierName],
	                        label: entry.values[field.targetField().name()]
	                    };
	                });
	                scope.$broadcast('choices:update', { choices: initialChoices });
	            };
	
	            if (!field.remoteComplete()) {
	                // fetch choices from the datastore
	                var initialEntries = scope.datastore().getEntries(field.targetEntity().uniqueId + '_choices');
	                setInitialChoices(initialEntries);
	            } else {
	                var _initialEntries = [];
	                setInitialChoices(_initialEntries);
	
	                // ui-select doesn't allow to prepopulate autocomplete selects, see https://github.com/angular-ui/ui-select/issues/1197
	                // let ui-select fetch the options using the ReferenceRefresher
	                scope.refresh = function (search) {
	                    return ReferenceRefresher.refresh(field, scope.value, search).then(function (formattedResults) {
	                        scope.$broadcast('choices:update', { choices: formattedResults });
	                    });
	                };
	            }
	        },
	        template: '<ma-choices-field\n                field="field()"\n                datastore="datastore()"\n                refresh="refresh($search)"\n                value="value">\n            </ma-choices-field>'
	    };
	}
	
	maReferenceManyField.$inject = ['ReferenceRefresher'];
	module.exports = exports['default'];
	//# sourceMappingURL=maReferenceManyField.js.map

/***/ },
/* 232 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maTemplateField;
	function maTemplateField() {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            entry: '&',
	            entity: '&',
	            value: '=',
	            values: '='
	        },
	        link: function link(scope) {
	            scope.field = scope.field();
	            scope.entry = scope.entry();
	            scope.entity = scope.entity();
	        },
	        template: '<span compile="field.getTemplateValue(entry)"></span>'
	    };
	}
	
	maTemplateField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maTemplateField.js.map

/***/ },
/* 233 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maTextField;
	/**
	 * Edition field for a multiline string - a textarea.
	 *
	 * @example <ma-text-field field="field" value="value"></ma-text-field>
	 */
	function maTextField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: function link(scope, element) {
	            var field = scope.field();
	            scope.name = field.name();
	            scope.v = field.validation();
	            var input = element.children()[0];
	            var attributes = field.attributes();
	            for (var name in attributes) {
	                input.setAttribute(name, attributes[name]);
	            }
	        },
	        template: '<textarea ng-model="value" id="{{ name }}" name="{{ name }}" class="form-control"\n    ng-required="v.required" ng-minlength="v.minlength" ng-maxlength="v.maxlength" ng-pattern="v.pattern">\n</textarea>'
	    };
	}
	
	maTextField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maTextField.js.map

/***/ },
/* 234 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maWysiwygField;
	/**
	 * Edition field for a multiline HTML string - a rich text editor.
	 *
	 * @example <ma-wysiwyg-field field="field" value="value"></ma-wysiwyg-field>
	 */
	function maWysiwygField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: function link(scope, element) {
	            var field = scope.field();
	            scope.name = field.name();
	        },
	        template: '<div text-angular ta-unsafe-sanitizer="{{ !field.sanitize() }}" ng-model="value" id="{{ name }}" name="{{ name }}" ' + 'ta-text-editor-class="border-around" ta-html-editor-class="border-around">' + '</div>'
	    };
	}
	
	maWysiwygField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maWysiwygField.js.map

/***/ },
/* 235 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = uiSelectRequired;
	/**
	 * Directive created to fix a bug with ui-select and multiple required values.
	 * @see https://github.com/angular-ui/ui-select/issues/258
	 */
	function uiSelectRequired() {
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function link(scope, elm, attrs, ctrl) {
	            ctrl.$validators.uiSelectRequired = function (modelValue, viewValue) {
	                var determineVal;
	                if (angular.isArray(modelValue)) {
	                    determineVal = modelValue;
	                } else if (angular.isArray(viewValue)) {
	                    determineVal = viewValue;
	                } else {
	                    return false;
	                }
	
	                return determineVal.length > 0;
	            };
	        }
	    };
	}
	
	uiSelectRequired.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=uiSelectRequired.js.map

/***/ },
/* 236 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-boolean-column value="::value"></ma-boolean-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-choice-field field="::field" value="value" choices="::field.filterChoices()"></ma-choice-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="row">\n        <ma-choice-field class="col-sm-4 col-md-3" ng-if="!field.validation().required" field="::field" value="$parent.value"></ma-choice-field>\n        <ma-checkbox-field class="col-sm-4 col-md-3" ng-if="!!field.validation().required" field="::field" value="$parent.value"></ma-checkbox-field>\n    </div>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=BooleanFieldView.js.map

/***/ },
/* 237 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-string-column value="::field.getLabelForChoice(value, entry)"></ma-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-choice-field field="::field" value="value"></ma-choice-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-choice-field field="::field" entry="entry" value="value"></ma-choice-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=ChoiceFieldView.js.map

/***/ },
/* 238 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-choices-column values="::value"></ma-choices-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-choices-field field="::field" value="value"></ma-choices-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-choices-field field="::field" entry="::entry" value="value"></ma-choices-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=ChoicesFieldView.js.map

/***/ },
/* 239 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-date-column field="::field" value="::value"></ma-date-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-date-field field="::field" value="value"></ma-date-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="date_widget"><ma-date-field field="::field" value="value"></ma-date-field></div>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=DateFieldView.js.map

/***/ },
/* 240 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-date-column field="::field" value="::value"></ma-date-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-date-field field="::field" value="value"></ma-date-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="datetime_widget"><ma-date-field field="::field" value="value"></ma-date-field></div>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=DateTimeFieldView.js.map

/***/ },
/* 241 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-string-column value="::value"></ma-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="email" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=EmailFieldView.js.map

/***/ },
/* 242 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-embedded-list-column field="::field" value="::value" datastore="::datastore"></ma-embedded-list-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display referenced_list field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display referenced_list field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-embedded-list-field field="::field" value="value" datastore="::datastore"></ma-embedded-list-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=EmbeddedListFieldView.js.map

/***/ },
/* 243 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var FieldViewConfiguration = function () {
	    function FieldViewConfiguration() {
	        _classCallCheck(this, FieldViewConfiguration);
	
	        this.fieldViews = {};
	    }
	
	    _createClass(FieldViewConfiguration, [{
	        key: "registerFieldView",
	        value: function registerFieldView(type, FieldView) {
	            this.fieldViews[type] = FieldView;
	        }
	    }, {
	        key: "$get",
	        value: function $get() {
	            return this.fieldViews;
	        }
	    }]);
	
	    return FieldViewConfiguration;
	}();
	
	exports.default = FieldViewConfiguration;
	
	FieldViewConfiguration.$inject = [];
	module.exports = exports["default"];
	//# sourceMappingURL=FieldViewConfiguration.js.map

/***/ },
/* 244 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return 'error: cannot display file field as readable';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display file field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display file field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-file-field field="::field" value="value"></ma-file-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=FileFieldView.js.map

/***/ },
/* 245 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-number-column field="::field" value="::value"></ma-number-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field type="number" step="any" field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="number" step="any" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=FloatFieldView.js.map

/***/ },
/* 246 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-json-column value="::value"></ma-json-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display a json field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-json-field field="::field" value="value"></ma-json-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=JsonFieldView.js.map

/***/ },
/* 247 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-number-column field="::field" value="::value"></ma-number-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field type="number" field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="number" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=NumberFieldView.js.map

/***/ },
/* 248 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return 'error: cannot display password field as readable';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display password field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display password field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="password" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=PasswordFieldView.js.map

/***/ },
/* 249 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-reference-column field="::field" value="::value" datastore="::datastore"></ma-reference-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<ma-reference-link-column entry="::entry" field="::field" value="::value" datastore="::datastore"></ma-reference-link-column>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-reference-field field="::field" value="value" datastore="::datastore"></ma-reference-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-reference-field field="::field" value="value" datastore="::datastore"></ma-reference-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=ReferenceFieldView.js.map

/***/ },
/* 250 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-choices-column values="::entry.listValues[field.name()]"></ma-choices-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<ma-reference-many-link-column ids="::value" values="::entry.listValues[field.name()]" field="::field"></ma-reference-many-link-column>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-reference-many-field field="::field" value="value" datastore="::datastore"></ma-reference-many-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-reference-many-field field="::field" value="value" datastore="::datastore"></ma-reference-many-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=ReferenceManyFieldView.js.map

/***/ },
/* 251 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-referenced-list-column field="::field" datastore="::datastore"></ma-referenced-list-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display referenced_list field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display referenced_list field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-referenced-list-column field="::field" datastore="::datastore"></ma-referenced-list-column>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=ReferencedListFieldView.js.map

/***/ },
/* 252 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-string-column value="::value"></ma-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=StringFieldView.js.map

/***/ },
/* 253 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-template-column entry="::entry" field="::field" entity="::entity"></ma-template-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-template-field field="::field" value="value" values="values" filters="filters"></ma-template-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-template-field field="::field" value="value" entry="entry" entity="::entity"></ma-template-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=TemplateFieldView.js.map

/***/ },
/* 254 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-string-column value="::value"></ma-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-text-field field="::field" value="value"></ma-text-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=TextFieldView.js.map

/***/ },
/* 255 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-wysiwyg-column field="::field" value="::value"></ma-wysiwyg-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-wysiwyg-field field="::field" value="value"></ma-wysiwyg-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=WysiwygFieldView.js.map

/***/ },
/* 256 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maFilter;
	function maFilter(FieldViewConfiguration, $compile) {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '=',
	            datastore: '&',
	            values: '=',
	            value: '='
	        },
	        link: function link(scope, element) {
	            scope.datastore = scope.datastore();
	            element.append(scope.field.getTemplateValue(scope.values) || FieldViewConfiguration[scope.field.type()].getFilterWidget());
	            $compile(element.contents())(scope);
	        }
	    };
	}
	
	maFilter.$inject = ['FieldViewConfiguration', '$compile'];
	module.exports = exports['default'];
	//# sourceMappingURL=maFilter.js.map

/***/ },
/* 257 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maFilterForm;
	function maFilterForm() {
	    return {
	        restrict: 'E',
	        scope: {
	            filters: '=',
	            datastore: '&',
	            values: '=',
	            removeFilter: '&'
	        },
	        link: function link(scope) {
	            scope.datastore = scope.datastore();
	            scope.removeFilter = scope.removeFilter();
	            scope.shouldFilter = function () {
	                return Object.keys(scope.filters).length;
	            };
	        },
	        template: '<div class="row">\n    <form class="filters col-md-offset-6 col-md-6 form-horizontal" ng-if="shouldFilter()">\n        <div class="filter {{ field.name() }} form-group input-{{ field.type() }}" ng-repeat="field in filters track by field.name()">\n            <div class="col-sm-1 col-xs-1 remove_filter">\n                <a ng-if="!field.pinned()" ng-click="removeFilter(field)"><span class="glyphicon glyphicon-remove"></span></a>\n            </div>\n            <label for="{{ field.name() }}" class="col-sm-4 col-xs-11 control-label">\n                {{ field.label() | translate }}<span ng-if="field.validation().required">&nbsp;*</span>&nbsp;\n            </label>\n            <div class="col-sm-7" ng-switch="field.type()" ng-class="field.getCssClasses(entry)">\n                <ma-filter field="::field" value="values[field.name()]" values="values" datastore="datastore"></ma-filter>\n            </div>\n        </div>\n    </form>\n</div>'
	    };
	}
	
	maFilterForm.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maFilterForm.js.map

/***/ },
/* 258 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var FormController = function () {
	    function FormController($scope, $state, $injector, $translate, previousState, WriteQueries, Configuration, progression, notification, view, dataStore) {
	        _classCallCheck(this, FormController);
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$injector = $injector;
	        this.$translate = $translate;
	        this.previousState = previousState;
	        this.WriteQueries = WriteQueries;
	        this.dataStore = dataStore;
	        this.progression = progression;
	        this.notification = notification;
	        this.title = view.title();
	        this.description = view.description();
	        this.actions = view.actions();
	        this.fields = view.fields();
	        this.config = Configuration();
	        this.view = view;
	        this.entity = this.view.getEntity();
	        this.$scope.entry = dataStore.getFirstEntry(this.entity.uniqueId);
	        this.$scope.view = view;
	        this.$scope.entity = this.entity;
	
	        // in case of entity identifier being modified
	        this.originEntityId = this.$scope.entry.values[this.entity.identifier().name()];
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    _createClass(FormController, [{
	        key: 'validateEntry',
	        value: function validateEntry() {
	            var _this = this;
	
	            if (!this.form.$valid) {
	                this.$translate('INVALID_FORM').then(function (text) {
	                    return _this.notification.log(text, { addnCls: 'humane-flatty-error' });
	                });
	                return false;
	            }
	
	            try {
	                this.view.validate(this.$scope.entry);
	            } catch (error) {
	                this.notification.log(error, { addnCls: 'humane-flatty-error' });
	                return false;
	            }
	
	            return true;
	        }
	    }, {
	        key: 'submitCreation',
	        value: function submitCreation($event) {
	            var _this2 = this;
	
	            $event.preventDefault();
	            if (!this.validateEntry()) {
	                return;
	            }
	            var entity = this.entity;
	            var view = this.view;
	            var $state = this.$state;
	            var progression = this.progression;
	            var notification = this.notification;
	            var $translate = this.$translate;
	
	            var route = entity.showView().enabled ? 'show' : 'list';
	            var restEntry = this.$scope.entry.transformToRest(view.fields());
	            var entry = null;
	            progression.start();
	            this.WriteQueries.createOne(view, restEntry).then(function (rawEntry) {
	                entry = view.mapEntry(rawEntry);
	                return entry;
	            }).then(function (entry) {
	                return view.onSubmitSuccess() && _this2.$injector.invoke(view.onSubmitSuccess(), view, { $event: $event, entity: entity, entry: entry, route: route, controller: _this2, form: _this2.form, progression: progression, notification: notification });
	            }).then(function (customHandlerReturnValue) {
	                return customHandlerReturnValue === false ? new Promise(function (resolve) {
	                    return resolve();
	                }) : $state.go(_this2.$state.get(route), { entity: entity.name(), id: entry.identifierValue });
	            }).then(function () {
	                return progression.done();
	            }).then(function () {
	                return $translate('CREATION_SUCCESS');
	            }).then(function (text) {
	                return notification.log(text, { addnCls: 'humane-flatty-success' });
	            }).catch(function (error) {
	                var errorMessage = _this2.config.getErrorMessageFor(_this2.view, error) || 'ERROR_MESSAGE';
	                var customHandlerReturnValue = view.onSubmitError() && _this2.$injector.invoke(view.onSubmitError(), view, { $event: $event, error: error, errorMessage: errorMessage, entity: entity, entry: entry, route: route, controller: _this2, form: _this2.form, progression: progression, notification: notification });
	                if (customHandlerReturnValue === false) return;
	                progression.done();
	                $translate(errorMessage, {
	                    status: error && error.status,
	                    details: error && error.data && _typeof(error.data) === 'object' ? JSON.stringify(error.data) : {}
	                }).catch(angular.identity) // See https://github.com/angular-translate/angular-translate/issues/1516
	                .then(function (text) {
	                    return notification.log(text, { addnCls: 'humane-flatty-error' });
	                });
	            });
	        }
	    }, {
	        key: 'submitEdition',
	        value: function submitEdition($event) {
	            var _this3 = this;
	
	            $event.preventDefault();
	            if (!this.validateEntry()) {
	                return;
	            }
	            var view = this.view;
	            var $state = this.$state;
	            var previousState = this.previousState;
	            var progression = this.progression;
	            var notification = this.notification;
	            var $translate = this.$translate;
	
	            var restEntry = this.$scope.entry.transformToRest(view.fields());
	            var entry = null;
	            progression.start();
	            this.WriteQueries.updateOne(view, restEntry, this.originEntityId).then(function (rawEntry) {
	                entry = view.mapEntry(rawEntry);
	                return entry;
	            }).then(function (entry) {
	                return view.onSubmitSuccess() && _this3.$injector.invoke(view.onSubmitSuccess(), view, { $event: $event, entity: _this3.entity, entry: entry, controller: _this3, form: _this3.form, progression: progression, notification: notification });
	            }).then(function (customHandlerReturnValue) {
	                if (customHandlerReturnValue === false) return;
	                $state.go(previousState.name, previousState.params).then(function () {
	                    return progression.done();
	                }).then(function () {
	                    return $translate('EDITION_SUCCESS');
	                }).then(function (text) {
	                    return notification.log(text, { addnCls: 'humane-flatty-success' });
	                });
	            }).catch(function (error) {
	                var errorMessage = _this3.config.getErrorMessageFor(_this3.view, error) || 'ERROR_MESSAGE';
	                var customHandlerReturnValue = view.onSubmitError() && _this3.$injector.invoke(view.onSubmitError(), view, { $event: $event, error: error, errorMessage: errorMessage, entity: _this3.entity, entry: entry, controller: _this3, form: _this3.form, progression: progression, notification: notification });
	                if (customHandlerReturnValue === false) return;
	                progression.done();
	                $translate(errorMessage, {
	                    status: error && error.status,
	                    details: error && error.data && _typeof(error.data) === 'object' ? JSON.stringify(error.data) : {}
	                }).catch(angular.identity) // See https://github.com/angular-translate/angular-translate/issues/1516
	                .then(function (text) {
	                    return notification.log(text, { addnCls: 'humane-flatty-error' });
	                });
	            });
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	            this.$state = undefined;
	            this.$injector = undefined;
	            this.$translate = undefined;
	            this.previousState = undefined;
	            this.WriteQueries = undefined;
	            this.dataStore = undefined;
	            this.view = undefined;
	            this.entity = undefined;
	        }
	    }]);
	
	    return FormController;
	}();
	
	exports.default = FormController;
	
	FormController.$inject = ['$scope', '$state', '$injector', '$translate', 'previousState', 'WriteQueries', 'NgAdminConfiguration', 'progression', 'notification', 'view', 'dataStore'];
	module.exports = exports['default'];
	//# sourceMappingURL=FormController.js.map

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _Entry = __webpack_require__(8);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var ListController = function () {
	    function ListController($scope, $stateParams, $location, $anchorScroll, ReadQueries, progression, view, dataStore, totalItems) {
	        _classCallCheck(this, ListController);
	
	        this.$scope = $scope;
	        this.$stateParams = $stateParams;
	        this.$location = $location;
	        this.$anchorScroll = $anchorScroll;
	        this.ReadQueries = ReadQueries;
	        this.progression = progression;
	        this.view = view;
	        this.entity = view.getEntity();
	        this.loadingPage = false;
	        this.search = $stateParams.search;
	        this.dataStore = dataStore;
	        this.fields = view.fields();
	        this.listActions = view.listActions();
	        this.totalItems = totalItems;
	        this.page = $stateParams.page || 1;
	        this.infinitePagination = this.view.infinitePagination();
	        this.entryCssClasses = this.view.getEntryCssClasses.bind(this.view);
	        this.nextPageCallback = this.nextPage.bind(this);
	        this.setPageCallback = this.setPage.bind(this);
	        this.sortField = this.$stateParams.sortField || this.view.getSortFieldName();
	        this.sortDir = this.$stateParams.sortDir || this.view.sortDir();
	        this.queryPromises = [];
	
	        if ($scope.selectionUpdater) {
	            $scope.selection = $scope.selection || [];
	            $scope.$watch('selection', $scope.selectionUpdater);
	        } else {
	            $scope.selection = null;
	        }
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    _createClass(ListController, [{
	        key: 'nextPage',
	        value: function nextPage(page) {
	            var _this = this;
	
	            if (this.loadingPage) {
	                return;
	            }
	
	            var view = this.view,
	                dataStore = this.dataStore;
	
	            this.progression.start();
	
	            var references = view.getReferences();
	            var data = void 0;
	
	            var queryPromise = this.ReadQueries.getAll(view, page, this.search, this.sortField, this.sortDir).then(function (response) {
	                data = response.data;
	                return _this.ReadQueries.getReferenceData(view.fields(), data);
	            }).then(function (referenceData) {
	                _this.progression.done();
	
	                for (var name in referenceData) {
	                    _Entry2.default.createArrayFromRest(referenceData[name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                    });
	                }
	            });
	            this.queryPromises.push(queryPromise);
	            // make sure all preceding promises complete before loading data into store
	            Promise.all(this.queryPromises).then(function () {
	                view.mapEntries(data).map(function (entry) {
	                    dataStore.fillReferencesValuesFromEntry(entry, references, true);
	                    dataStore.addEntry(_this.entity.uniqueId, entry);
	                });
	
	                _this.loadingPage = false;
	            });
	        }
	    }, {
	        key: 'setPage',
	        value: function setPage(number) {
	            this.$location.search('page', number);
	            this.$anchorScroll(0);
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	            this.$stateParams = undefined;
	            this.$location = undefined;
	            this.$anchorScroll = undefined;
	            this.dataStore = undefined;
	        }
	    }]);
	
	    return ListController;
	}();
	
	exports.default = ListController;
	
	ListController.$inject = ['$scope', '$stateParams', '$location', '$anchorScroll', 'ReadQueries', 'progression', 'view', 'dataStore', 'totalItems'];
	module.exports = exports['default'];
	//# sourceMappingURL=ListController.js.map

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _defineProperty(obj, key, value) {
	    if (key in obj) {
	        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	    } else {
	        obj[key] = value;
	    }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var debounce = __webpack_require__(185);
	
	var ListLayoutController = function () {
	    function ListLayoutController($scope, $stateParams, $state, $location, $timeout, view, dataStore) {
	        var _this = this;
	
	        _classCallCheck(this, ListLayoutController);
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.$timeout = $timeout;
	        this.view = view;
	        this.dataStore = dataStore;
	        this.entity = view.getEntity();
	        this.actions = view.actions();
	        this.batchActions = view.batchActions();
	        this.loadingPage = false;
	        this.filters = view.filters();
	        this.search = ListLayoutController.getCurrentSearchParam($location, this.filters);
	        this.path = $location.path();
	        // since search isn't a $stateParam of the listLayout state,
	        // the controller doesn't change when the search changes
	        // so we must update filter values manually when the location changes
	        $scope.$watch(function () {
	            return $location.search() && $location.search().search;
	        }, function (newval, oldval) {
	            if (newval === oldval) {
	                return;
	            }
	            if ($location.path() !== _this.path) {
	                return; // already transitioned to another page
	            }
	            _this.enabledFilters = _this.getEnabledFilters();
	        });
	        // apply filters when filter values change
	        $scope.$watch(function () {
	            return _this.search;
	        }, debounce(function (newValues, oldValues) {
	            if (newValues != oldValues) {
	                _this.updateFilters();
	            }
	        }, 500), true);
	        this.filters = view.filters();
	        this.enabledFilters = this.getEnabledFilters();
	        this.hasFilters = Object.keys(this.filters).length > 0;
	        this.focusedFilterId = null;
	        this.enableFilter = this.enableFilter.bind(this);
	        this.removeFilter = this.removeFilter.bind(this);
	        if (this.batchActions.length) {
	            // required in scope to communicate with listView
	            $scope.selectionUpdater = function (selection) {
	                return $scope.selection = selection;
	            };
	            $scope.selection = [];
	        }
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    _createClass(ListLayoutController, [{
	        key: 'enableFilter',
	        value: function enableFilter(filter) {
	            var _this2 = this;
	
	            var defaultValue = filter.defaultValue();
	            if (defaultValue !== null) {
	                this.search[filter.name()] = defaultValue;
	            }
	            this.enabledFilters.push(filter);
	            this.focusedFilterId = filter.name();
	            this.$timeout(function () {
	                var el = window.document.getElementById(_this2.focusedFilterId);
	                if (el && el.focus) {
	                    el.focus();
	                }
	            }, 200, false);
	        }
	    }, {
	        key: 'getEnabledFilters',
	        value: function getEnabledFilters() {
	            var _this3 = this;
	
	            return this.filters.filter(function (filter) {
	                if (filter.pinned()) {
	                    return true;
	                }
	                return _this3.search && filter.name() in _this3.search;
	            });
	        }
	    }, {
	        key: 'updateFilters',
	        value: function updateFilters() {
	            var values = {},
	                filters = this.enabledFilters,
	                fieldName,
	                field,
	                i;
	            for (i in filters) {
	                field = filters[i];
	                fieldName = field.name();
	                if (this.search[fieldName] === '') {
	                    delete this.search[fieldName];
	                    continue;
	                }
	
	                if (field.type() === 'boolean' && fieldName in this.search || // for boolean false is the same as null
	                field.type() !== 'boolean' && this.search[fieldName] !== null) {
	                    values[fieldName] = field.getTransformedValue(this.search[fieldName]);
	                }
	            }
	            this.$stateParams.search = values;
	            this.$stateParams.page = 1;
	            this.$state.go('list', this.$stateParams);
	        }
	    }, {
	        key: 'removeFilter',
	        value: function removeFilter(filter) {
	            delete this.search[filter.name()];
	            this.enabledFilters = this.enabledFilters.filter(function (f) {
	                return f !== filter;
	            });
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	            this.$state = undefined;
	            this.$stateParams = undefined;
	            this.$timeout = undefined;
	            this.dataStore = undefined;
	        }
	    }], [{
	        key: 'getCurrentSearchParam',
	        value: function getCurrentSearchParam(location, filters) {
	            var baseSearch = location.search().search ? JSON.parse(location.search().search) : {};
	
	            return filters.reduce(function (search, filter) {
	                if (typeof search[filter.name()] !== 'undefined') {
	                    return _extends({}, search, _defineProperty({}, filter.name(), filter.getMappedValue(search[filter.name()])));
	                }
	                if (filter.pinned() && !search[filter.name()] && filter.defaultValue()) {
	                    return _extends({}, search, _defineProperty({}, filter.name(), filter.getMappedValue(filter.defaultValue())));
	                }
	                return search;
	            }, baseSearch);
	        }
	    }]);
	
	    return ListLayoutController;
	}();
	
	exports.default = ListLayoutController;
	
	ListLayoutController.$inject = ['$scope', '$stateParams', '$state', '$location', '$timeout', 'view', 'dataStore'];
	module.exports = exports['default'];
	//# sourceMappingURL=ListLayoutController.js.map

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDatagrid;
	
	var _maDatagridController = __webpack_require__(262);
	
	var _maDatagridController2 = _interopRequireDefault(_maDatagridController);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function maDatagrid() {
	    return {
	        restrict: 'E',
	        scope: {
	            name: '@',
	            entries: '=',
	            selection: '=',
	            fields: '&',
	            listActions: '&',
	            entity: '&',
	            entryCssClasses: '&?',
	            datastore: '&',
	            sortField: '&',
	            sortDir: '&',
	            sort: '&'
	        },
	        controllerAs: 'datagrid',
	        controller: _maDatagridController2.default,
	        template: '<table class="grid table table-condensed table-hover table-striped">\n    <thead>\n        <tr>\n            <th ng-if="selection">\n                <ma-datagrid-multi-selector toggle-select-all="toggleSelectAll()" selection="selection" entries="entries"/>\n            </th>\n            <th ng-repeat="field in fields() track by $index" ng-class="field.getCssClasses()" class="ng-admin-column-{{ ::field.name() }} ng-admin-type-{{ ::field.type() }}">\n                <a ng-if="field.sortable()" ng-click="datagrid.sortCallback(field)">\n                    <span class="glyphicon {{ sortDir() === \'DESC\' ? \'glyphicon-chevron-up\': \'glyphicon-chevron-down\' }}" ng-if="datagrid.isSorting(field)"></span>\n                    {{ field.label() | translate }}\n                </a>\n                <span ng-if="!field.sortable()">\n                    {{ field.label() | translate }}\n                </span>\n            </th>\n            <th ng-if="datagrid.shouldDisplayActions" class="ng-admin-column-actions" translate="ACTIONS"></th>\n        </tr>\n    </thead>\n\n    <tbody>\n        <tr ng-repeat="entry in entries track by entry.identifierValue" ng-class="getEntryCssClasses(entry)">\n            <td ng-if="selection">\n                <ma-datagrid-item-selector toggle-select="toggleSelect(entry)" selection="selection" entry="entry"/>\n            </td>\n            <td ng-repeat="field in fields() track by $index" ng-class="field.getCssClasses(entry)" class="ng-admin-column-{{ ::field.name() }} ng-admin-type-{{ ::field.type() }}">\n                <ma-column field="::field" entry="::entry" entity="::entity" datastore="datagrid.datastore"></ma-column>\n            </td>\n            <td ng-if="datagrid.shouldDisplayActions" class="ng-admin-column-actions">\n                <ma-list-actions entry="::entry" entity="::entity" buttons="listActions()"></ma-list-actions>\n            </td>\n        </tr>\n    </tbody>\n</table>'
	    };
	}
	
	maDatagrid.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maDatagrid.js.map

/***/ },
/* 262 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var DatagridController = function () {
	    function DatagridController($scope, $location, $stateParams, $anchorScroll) {
	        _classCallCheck(this, DatagridController);
	
	        $scope.entity = $scope.entity();
	        this.$scope = $scope;
	        this.$location = $location;
	        this.$anchorScroll = $anchorScroll;
	        this.datastore = this.$scope.datastore();
	        this.filters = {};
	        this.shouldDisplayActions = this.$scope.listActions() && this.$scope.listActions().length > 0;
	        $scope.getEntryCssClasses = this.getEntryCssClasses.bind(this);
	        $scope.toggleSelect = this.toggleSelect.bind(this);
	        $scope.toggleSelectAll = this.toggleSelectAll.bind(this);
	        this.sortField = $scope.sortField();
	        this.sortDir = $scope.sortDir();
	        this.sortCallback = $scope.sort() ? $scope.sort() : this.sort.bind(this);
	    }
	
	    /**
	     * Return true if a column is being sorted
	     *
	     * @param {Field} field
	     *
	     * @returns {Boolean}
	     */
	
	    _createClass(DatagridController, [{
	        key: 'isSorting',
	        value: function isSorting(field) {
	            return this.$scope.sortField() === this.getSortName(field);
	        }
	
	        /**
	         * Return 'even'|'odd' based on the index parameter
	         *
	         * @param {Number} index
	         * @returns {string}
	         */
	
	    }, {
	        key: 'itemClass',
	        value: function itemClass(index) {
	            return index % 2 === 0 ? 'even' : 'odd';
	        }
	
	        /**
	         *
	         * @param {Field} field
	         */
	
	    }, {
	        key: 'sort',
	        value: function sort(field) {
	            var dir = 'ASC',
	                fieldName = this.getSortName(field);
	
	            if (this.sortField === fieldName) {
	                dir = this.sortDir === 'ASC' ? 'DESC' : 'ASC';
	            }
	
	            this.$location.search('sortField', fieldName);
	            this.$location.search('sortDir', dir);
	        }
	
	        /**
	         * Return fieldName like (view.fieldName) to sort
	         *
	         * @param {Field} field
	         *
	         * @returns {String}
	         */
	
	    }, {
	        key: 'getSortName',
	        value: function getSortName(field) {
	            return this.$scope.name ? this.$scope.name + '.' + field.name() : field.name();
	        }
	    }, {
	        key: 'getEntryCssClasses',
	        value: function getEntryCssClasses(entry) {
	            var entryCssClasses = this.$scope.entryCssClasses;
	            if (typeof entryCssClasses !== 'function') {
	                return;
	            }
	            var getEntryCssClasses = entryCssClasses();
	            if (typeof getEntryCssClasses !== 'function') {
	                return;
	            }
	            return getEntryCssClasses(entry.values);
	        }
	    }, {
	        key: 'toggleSelect',
	        value: function toggleSelect(entry) {
	            var selection = this.$scope.selection.slice();
	
	            var index = selection.indexOf(entry);
	
	            if (index === -1) {
	                this.$scope.selection = selection.concat(entry);
	                return;
	            }
	            selection.splice(index, 1);
	            this.$scope.selection = selection;
	        }
	    }, {
	        key: 'toggleSelectAll',
	        value: function toggleSelectAll() {
	
	            if (this.$scope.selection.length < this.$scope.entries.length) {
	                this.$scope.selection = this.$scope.entries;
	                return;
	            }
	
	            this.$scope.selection = [];
	        }
	    }]);
	
	    return DatagridController;
	}();
	
	exports.default = DatagridController;
	
	DatagridController.$inject = ['$scope', '$location', '$stateParams', '$anchorScroll'];
	module.exports = exports['default'];
	//# sourceMappingURL=maDatagridController.js.map

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDatagridInfinitePagination;
	
	var _angular = __webpack_require__(6);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function maDatagridInfinitePagination($window, $document) {
	
	    var windowElement = _angular2.default.element($window);
	    var offset = 100,
	        body = $document[0].body;
	
	    return {
	        restrict: 'E',
	        scope: {
	            perPage: '@',
	            totalItems: '@',
	            nextPage: '&'
	        },
	        link: function link(scope) {
	            var perPage = parseInt(scope.perPage, 10) || 1,
	                totalItems = parseInt(scope.totalItems, 10),
	                nbPages = Math.ceil(totalItems / perPage) || 1,
	                page = 1,
	                loadedPages = [];
	            function handler() {
	                if (body.offsetHeight - $window.innerHeight - $window.scrollY < offset) {
	                    if (page >= nbPages) {
	                        return;
	                    }
	                    page++;
	                    if (page in loadedPages) {
	                        return;
	                    }
	                    loadedPages.push(page);
	                    scope.nextPage()(page);
	                }
	            }
	            windowElement.bind('scroll', handler);
	            scope.$on('$destroy', function destroy() {
	                windowElement.unbind('scroll', handler);
	            });
	        }
	    };
	}
	
	maDatagridInfinitePagination.$inject = ['$window', '$document'];
	module.exports = exports['default'];
	//# sourceMappingURL=maDatagridInfinitePagination.js.map

/***/ },
/* 264 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDatagridItemSelector;
	function maDatagridItemSelector() {
	    return {
	        restrict: 'E',
	        scope: {
	            entry: '=',
	            selection: '=',
	            toggleSelect: '&'
	        },
	        template: '<input type="checkbox" ng-click="toggle(entry)" ng-checked="isInSelection()"/>',
	        link: function link(scope) {
	            scope.toggle = function (entry) {
	                return scope.toggleSelect({ entry: entry });
	            };
	            var e = scope.entry;
	            scope.isInSelection = function () {
	                return scope.selection.filter(function (s) {
	                    return s._entityName == e._entityName && s._identifierValue == e._identifierValue;
	                }).length > 0;
	            };
	        }
	    };
	}
	
	maDatagridItemSelector.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maDatagridItemSelector.js.map

/***/ },
/* 265 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDatagridMultiSelector;
	function maDatagridMultiSelector() {
	    return {
	        restrict: 'E',
	        scope: {
	            entries: '=',
	            selection: '=',
	            toggleSelectAll: '&'
	        },
	        template: '<input type="checkbox" ng-click="toggleSelectAll()" ng-checked="selection.length == entries.length" />',
	        link: function link(scope, element) {
	            scope.$watch('selection', function (selection) {
	                element.children()[0].indeterminate = selection.length > 0 && selection.length != scope.entries.length;
	            });
	            scope.$watch('entries', function (entries) {
	                element.children()[0].indeterminate = scope.selection.length > 0 && scope.selection.length != entries.length;
	            });
	        }
	    };
	}
	
	maDatagridMultiSelector.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maDatagridMultiSelector.js.map

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDatagridPagination;
	
	var _maDatagridPagination = __webpack_require__(355);
	
	var _maDatagridPagination2 = _interopRequireDefault(_maDatagridPagination);
	
	var _maDatagridPaginationController = __webpack_require__(267);
	
	var _maDatagridPaginationController2 = _interopRequireDefault(_maDatagridPaginationController);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function maDatagridPagination() {
	    return {
	        restrict: 'E',
	        scope: {
	            page: '@',
	            perPage: '@',
	            totalItems: '@',
	            setPage: '&'
	        },
	        template: _maDatagridPagination2.default,
	        controllerAs: 'paginationCtrl',
	        controller: _maDatagridPaginationController2.default
	    };
	}
	
	maDatagridPagination.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maDatagridPagination.js.map

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _angular = __webpack_require__(6);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var DatagridPaginationController = function () {
	    function DatagridPaginationController($scope) {
	        _classCallCheck(this, DatagridPaginationController);
	
	        this.$scope = $scope;
	        var perPage = parseInt(this.$scope.perPage, 10) || 1,
	            totalItems = parseInt(this.$scope.totalItems, 10),
	            page = Math.max(parseInt(this.$scope.page, 10), 1);
	
	        this.nbPages = Math.ceil(totalItems / perPage) || 1;
	        this.page = Math.min(this.nbPages, page);
	        this.offsetEnd = Math.min(this.page * perPage, totalItems);
	        this.offsetBegin = Math.min((this.page - 1) * perPage + 1, this.offsetEnd);
	        this.totalItems = totalItems;
	        this.displayPagination = perPage < totalItems;
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    /**
	     * Return an array with the range between min & max, useful for pagination
	     *
	     * @param {int} min
	     * @param {int} max
	     * @returns {Array}
	     */
	
	    _createClass(DatagridPaginationController, [{
	        key: 'range',
	        value: function range(page) {
	            var input = [],
	                nbPages = this.nbPages;
	
	            // display page links around the current page
	            if (page > 2) {
	                input.push('1');
	            }
	            if (page == 4) {
	                input.push('2');
	            }
	            if (page > 4) {
	                input.push('.');
	            }
	            if (page > 1) {
	                input.push(page - 1);
	            }
	            input.push(page);
	            if (page < nbPages) {
	                input.push(page + 1);
	            }
	            if (page == nbPages - 3) {
	                input.push(nbPages - 1);
	            }
	            if (page < nbPages - 3) {
	                input.push('.');
	            }
	            if (page < nbPages - 1) {
	                input.push(nbPages);
	            }
	
	            return input;
	        }
	
	        /**
	         * Link to page number of the list
	         *
	         * @param {int} number
	         */
	
	    }, {
	        key: 'setPage',
	        value: function setPage(number) {
	            if (number <= 0 || number > this.nbPages) {
	                return;
	            }
	            this.$scope.setPage()(number);
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	        }
	    }]);
	
	    return DatagridPaginationController;
	}();
	
	exports.default = DatagridPaginationController;
	
	DatagridPaginationController.$inject = ['$scope'];
	module.exports = exports['default'];
	//# sourceMappingURL=maDatagridPaginationController.js.map

/***/ },
/* 268 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maListActions;
	function maListActions() {
	    return {
	        restrict: 'E',
	        transclude: true,
	        scope: {
	            'buttons': '&',
	            'entry': '&',
	            'entity': '&'
	        },
	        link: function link($scope) {
	            $scope.buttons = $scope.buttons();
	            $scope.entry = $scope.entry();
	            $scope.entity = $scope.entity();
	            $scope.customTemplate = false;
	            if (typeof $scope.buttons === 'string') {
	                $scope.customTemplate = $scope.buttons;
	                $scope.buttons = null;
	            }
	        },
	        template: '<span compile="customTemplate">\n    <span ng-repeat="button in ::buttons" ng-switch="button">\n        <ma-show-button ng-switch-when="show" entry="::entry" entity="::entity" size="xs"></ma-show-button>\n        <ma-edit-button ng-switch-when="edit" ng-if="::entity.editionView().enabled" entry="::entry" entity="::entity" size="xs"></ma-edit-button>\n        <ma-delete-button ng-switch-when="delete" ng-if="::entity.deletionView().enabled" entry="::entry" entity="::entity" size="xs"></ma-delete-button>\n        <span ng-switch-default><span compile="button"></span></span>\n    </span>\n</span>'
	    };
	}
	
	maListActions.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maListActions.js.map

/***/ },
/* 269 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Compile;
	// @see https://docs.angularjs.org/api/ng/service/$compile
	function Compile($injector) {
	    var $compile = $injector.get('$compile');
	
	    return {
	        transclude: true,
	        link: function link(scope, element, attrs, controller, transcludeFn) {
	            var unbindWatcher = scope.$watch(function (scope) {
	                // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	            }, function (value) {
	                if (false === value) {
	                    // use the default tag content
	                    transcludeFn(scope, function (clone) {
	                        element.append(clone);
	                    });
	                    return;
	                }
	                // when the 'compile' expression changes assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current scope.
	                $compile(element.contents())(scope);
	
	                if (attrs.compileOnce == 'true') {
	                    unbindWatcher();
	                }
	            });
	        }
	    };
	}
	
	Compile.$inject = ['$injector'];
	module.exports = exports['default'];
	//# sourceMappingURL=Compile.js.map

/***/ },
/* 270 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var EntryFormatter = function () {
	    function EntryFormatter($filter) {
	        _classCallCheck(this, EntryFormatter);
	
	        this.formatDate = function (format) {
	            return function (date) {
	                return $filter('date')(date, format);
	            };
	        };
	        this.formatNumber = function (format) {
	            return function (number) {
	                return $filter('numeraljs')(number, format);
	            };
	        };
	    }
	
	    _createClass(EntryFormatter, [{
	        key: 'formatField',
	        value: function formatField(field) {
	            var label = field.label() || field.name();
	            var type = field.type();
	            switch (type) {
	                case 'boolean':
	                case 'choice':
	                case 'choices':
	                case 'string':
	                case 'text':
	                case 'wysiwyg':
	                case 'email':
	                case 'json':
	                case 'file':
	                    return function (entry) {
	                        return {
	                            name: label,
	                            value: entry.values[field.name()]
	                        };
	                    };
	                case 'template':
	                    return function (entry) {
	                        return {
	                            name: label,
	                            value: field.getTemplateValue(entry)
	                        };
	                    };
	                case 'number':
	                case 'float':
	                    var formatNumber = this.formatNumber(field.format());
	                    return function (entry) {
	                        return {
	                            name: label,
	                            value: formatNumber(entry.values[field.name()])
	                        };
	                    };
	                case 'date':
	                case 'datetime':
	                    var format = field.format();
	                    if (!format) {
	                        format = type === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss';
	                    }
	
	                    var formatDate = this.formatDate(format);
	                    return function (entry) {
	                        return {
	                            name: label,
	                            value: formatDate(entry.values[field.name()])
	                        };
	                    };
	                case 'reference':
	                    return function (entry) {
	                        return {
	                            name: label,
	                            value: entry.listValues[field.name()]
	                        };
	                    };
	                case 'reference_many':
	                    return function (entry) {
	                        return {
	                            name: label,
	                            value: entry.listValues[field.name()].join(', ')
	                        };
	                    };
	                case 'referenced_list':
	                    return; //ignored
	            }
	        }
	    }, {
	        key: 'getFormatter',
	        value: function getFormatter(fields) {
	            var fieldsFormatters = fields.map(this.formatField.bind(this));
	
	            return function formatEntry(entry) {
	                var result = {};
	                fieldsFormatters.map(function (formatter) {
	                    if (!formatter) {
	                        return;
	                    }
	                    return formatter(entry);
	                }).forEach(function (field) {
	                    if (!field) {
	                        return;
	                    }
	                    result[field.name] = field.value;
	                });
	
	                return result;
	            };
	        }
	    }]);
	
	    return EntryFormatter;
	}();
	
	exports.default = EntryFormatter;
	
	EntryFormatter.$inject = ['$filter'];
	module.exports = exports['default'];
	//# sourceMappingURL=EntryFormatter.js.map

/***/ },
/* 271 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PromisesResolver;
	function PromisesResolver(AdminDescription) {
	    return AdminDescription.getPromisesResolver();
	}
	
	PromisesResolver.$inject = ['AdminDescription'];
	module.exports = exports['default'];
	//# sourceMappingURL=PromisesResolver.js.map

/***/ },
/* 272 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var RestWrapper = function () {
	    function RestWrapper(Restangular) {
	        _classCallCheck(this, RestWrapper);
	
	        this.Restangular = Restangular;
	
	        Restangular.setFullResponse(true);
	    }
	
	    /**
	     * Returns the promise of one resource by URL
	     *
	     * @param {String} entityName
	     * @param {String} url
	     *
	     * @returns {promise}
	     */
	
	    _createClass(RestWrapper, [{
	        key: 'getOne',
	        value: function getOne(entityName, url) {
	            return this.Restangular.oneUrl(entityName, url).get().then(function (response) {
	                return response.data;
	            });
	        }
	
	        /**
	         * Returns the promise of a list of resources
	         *
	         * @param {Object} params
	         * @param {String} entityName
	         * @param {String} url
	         *
	         * @returns {promise}
	         */
	
	    }, {
	        key: 'getList',
	        value: function getList(params, entityName, url) {
	            return this.Restangular.allUrl(entityName, url).getList(params);
	        }
	    }, {
	        key: 'createOne',
	        value: function createOne(rawEntity, entityName, url, method) {
	            var resource = this.Restangular.oneUrl(entityName, url),
	                operation = method ? resource.customOperation(method, null, {}, {}, rawEntity) : resource.customPOST(rawEntity);
	
	            return operation.then(function (response) {
	                return response.data;
	            });
	        }
	    }, {
	        key: 'updateOne',
	        value: function updateOne(rawEntity, entityName, url, method) {
	            var resource = this.Restangular.oneUrl(entityName, url),
	                operation = method ? resource.customOperation(method, null, {}, {}, rawEntity) : resource.customPUT(rawEntity);
	
	            return operation.then(function (response) {
	                return response.data;
	            });
	        }
	    }, {
	        key: 'deleteOne',
	        value: function deleteOne(entityName, url) {
	            return this.Restangular.oneUrl(entityName, url).customDELETE();
	        }
	    }]);
	
	    return RestWrapper;
	}();
	
	exports.default = RestWrapper;
	
	RestWrapper.$inject = ['Restangular'];
	module.exports = exports['default'];
	//# sourceMappingURL=RestWrapper.js.map

/***/ },
/* 273 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ViewActions;
	function ViewActions($injector) {
	    var $compile = $injector.get('$compile');
	
	    return {
	        restrict: 'E',
	        transclude: true,
	        scope: {
	            override: '&',
	            entry: '=',
	            entity: '=',
	            selection: '=',
	            batchButtons: '&',
	            datastore: '=',
	            search: '=',
	            filters: '&',
	            enabledFilters: '=',
	            enableFilter: '&'
	        },
	        link: function link($scope, element, attrs, controller, transcludeFn) {
	            var override = $scope.override();
	            if (!override) {
	                // use the default tag content
	                transcludeFn($scope, function (clone) {
	                    element.append(clone);
	                });
	                return;
	            }
	            if (typeof override === 'string') {
	                // custom template, use it instead of default template
	                element.html(override);
	                $compile(element.contents())($scope);
	                return;
	            }
	            // list of buttons - default template
	            $scope.buttons = override;
	        },
	        template: '<span ng-repeat="button in buttons" ng-switch="button" class="view_actions">\n    <ma-filter-button ng-switch-when="filter" filters="filters()" enabled-filters="enabledFilters" enable-filter="enableFilter()"></ma-filter-button>\n    <ma-view-batch-actions ng-switch-when="batch" buttons="batchButtons()" selection="selection" entity="entity"></ma-view-batch-actions>\n    <ma-back-button ng-switch-when="back"></ma-back-button>\n    <ma-list-button ng-switch-when="list" entity="entity"></ma-list-button>\n    <ma-create-button ng-switch-when="create" entity="entity"></ma-create-button>\n    <ma-show-button ng-switch-when="show" entry="entry" entity="entity"></ma-show-button>\n    <ma-edit-button ng-switch-when="edit" entry="entry" entity="entity"></ma-edit-button>\n    <ma-delete-button ng-switch-when="delete" entry="entry" entity="entity"></ma-delete-button>\n    <ma-export-to-csv-button ng-switch-when="export" datastore="datastore" entity="entity"></ma-export-to-csv-button>\n    <span ng-switch-default><span compile="button"></span></span>\n</span>'
	    };
	}
	
	ViewActions.$inject = ['$injector'];
	module.exports = exports['default'];
	//# sourceMappingURL=ViewActions.js.map

/***/ },
/* 274 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ReadQueries;
	/**
	 * @param {RestWrapper} RestWrapper
	 * @param {Configuration} Configuration
	 * @param {AdminDescription} AdminDescription
	 * @param {PromisesResolver} PromisesResolver
	 *
	 * @returns {ReadQueries}
	 * @constructor
	 */
	function ReadQueries(RestWrapper, Configuration, AdminDescription, PromisesResolver) {
	  return AdminDescription.getReadQueries(RestWrapper, PromisesResolver, Configuration());
	}
	
	ReadQueries.$inject = ['RestWrapper', 'NgAdminConfiguration', 'AdminDescription', 'PromisesResolver'];
	module.exports = exports['default'];
	//# sourceMappingURL=ReadQueries.js.map

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _Entry = __webpack_require__(8);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var ReferenceRefresher = function () {
	    function ReferenceRefresher(ReadQueries) {
	        _classCallCheck(this, ReferenceRefresher);
	
	        this.ReadQueries = ReadQueries;
	    }
	
	    _createClass(ReferenceRefresher, [{
	        key: 'refresh',
	        value: function refresh(field, currentValue, search) {
	            var _this = this;
	
	            var referenceFields = {};
	            referenceFields[field.name()] = field;
	
	            var promise = this.ReadQueries.getAllReferencedData(referenceFields, search).then(function (r) {
	                return r[field.name()];
	            }).then(function (results) {
	                return _this._transformRecords(field, results);
	            });
	
	            if (field.type() === 'reference_many' || field.type() === 'choices') {
	                promise = promise.then(function (formattedResults) {
	                    return _this._removeDuplicates(formattedResults, currentValue);
	                });
	            }
	
	            return promise;
	        }
	    }, {
	        key: '_removeDuplicates',
	        value: function _removeDuplicates(results, currentValue) {
	            // remove already assigned values: ui-select still return them if multiple
	            if (!currentValue) {
	                return results;
	            }
	
	            if (!Array.isArray(currentValue)) {
	                currentValue = [currentValue];
	            }
	
	            return results.filter(function (fr) {
	                return currentValue.indexOf(fr.value) === -1;
	            });
	        }
	    }, {
	        key: '_transformRecords',
	        value: function _transformRecords(field, records) {
	            var targetEntity = field.targetEntity();
	            var targetField = field.targetField();
	            var valueFieldName = targetEntity.identifier().name();
	            var labelFieldName = targetField.name();
	            return _Entry2.default.createArrayFromRest(records, [targetField], targetEntity.name(), valueFieldName).map(function (r) {
	                return {
	                    value: r.values[valueFieldName],
	                    label: r.values[labelFieldName]
	                };
	            });
	        }
	    }]);
	
	    return ReferenceRefresher;
	}();
	
	exports.default = ReferenceRefresher;
	
	ReferenceRefresher.$inject = ['ReadQueries'];
	module.exports = exports['default'];
	//# sourceMappingURL=ReferenceRefresher.js.map

/***/ },
/* 276 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = WriteQueries;
	/**
	 * @param {RestWrapper} RestWrapper
	 * @param {Configuration} Configuration
	 * @param {AdminDescription} AdminDescription
	 * @param {PromisesResolver} PromisesResolver
	 *
	 * @returns {ReadQueries}
	 * @constructor
	 */
	function WriteQueries(RestWrapper, Configuration, AdminDescription, PromisesResolver) {
	  return AdminDescription.getWriteQueries(RestWrapper, PromisesResolver, Configuration());
	}
	
	WriteQueries.$inject = ['RestWrapper', 'NgAdminConfiguration', 'AdminDescription', 'PromisesResolver'];
	module.exports = exports['default'];
	//# sourceMappingURL=WriteQueries.js.map

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _DataStore = __webpack_require__(127);
	
	var _DataStore2 = _interopRequireDefault(_DataStore);
	
	var _Entry = __webpack_require__(8);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	var _batchDelete = __webpack_require__(349);
	
	var _batchDelete2 = _interopRequireDefault(_batchDelete);
	
	var _delete = __webpack_require__(350);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _create = __webpack_require__(351);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _edit = __webpack_require__(352);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _list = __webpack_require__(353);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _listLayout = __webpack_require__(354);
	
	var _listLayout2 = _interopRequireDefault(_listLayout);
	
	var _show = __webpack_require__(356);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function templateProvider(viewName, defaultView) {
	    return ['$stateParams', 'NgAdminConfiguration', function ($stateParams, Configuration) {
	        var customTemplate;
	        var view = Configuration().getViewByEntityAndType($stateParams.entity, viewName);
	        customTemplate = view.template();
	        if (customTemplate) {
	            return customTemplate;
	        }
	        customTemplate = Configuration().customTemplate()(viewName);
	        if (customTemplate) {
	            return customTemplate;
	        }
	        return defaultView;
	    }];
	}
	
	function viewProvider(viewName) {
	    return ['$stateParams', 'NgAdminConfiguration', function ($stateParams, Configuration) {
	        var view;
	        try {
	            view = Configuration().getViewByEntityAndType($stateParams.entity, viewName);
	        } catch (e) {
	            var error404 = new Error('Unknown view or entity name');
	            error404.status = 404; // trigger the 404 error
	            throw error404;
	        }
	        if (!view.enabled) {
	            throw new Error('The ' + viewName + ' is disabled for this entity');
	        }
	        return view;
	    }];
	}
	
	function routing($stateProvider) {
	
	    $stateProvider.state('listLayout', {
	        abstract: true,
	        url: '/:entity/list',
	        params: {
	            entity: null
	        },
	        parent: 'ng-admin',
	        controller: 'ListLayoutController',
	        controllerAs: 'llCtrl',
	        templateProvider: templateProvider('ListView', _listLayout2.default),
	        resolve: {
	            dataStore: function dataStore() {
	                return new _DataStore2.default();
	            },
	            view: viewProvider('ListView'),
	            filterData: ['ReadQueries', 'view', function (ReadQueries, view) {
	                return ReadQueries.getAllReferencedData(view.getFilterReferences(false));
	            }],
	            filterEntries: ['dataStore', 'view', 'filterData', function (dataStore, view, filterData) {
	                var filters = view.getFilterReferences(false);
	                for (var name in filterData) {
	                    _Entry2.default.createArrayFromRest(filterData[name], [filters[name].targetField()], filters[name].targetEntity().name(), filters[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(filters[name].targetEntity().uniqueId + '_choices', entry);
	                    });
	                }
	            }]
	        }
	    }).state('list', {
	        url: '?{search:json}&{page:int}&sortField&sortDir',
	        params: {
	            page: { value: 1, squash: true },
	            search: { value: {}, squash: true },
	            sortField: null,
	            sortDir: null
	        },
	        parent: 'listLayout',
	        views: {
	            grid: {
	                controller: 'ListController',
	                controllerAs: 'listController',
	                template: _list2.default,
	                resolve: {
	                    dataStore: function dataStore() {
	                        return new _DataStore2.default();
	                    },
	                    view: viewProvider('ListView'),
	                    response: ['$stateParams', 'ReadQueries', 'view', function ($stateParams, ReadQueries, view) {
	                        var page = $stateParams.page,
	                            filters = $stateParams.search,
	                            sortField = $stateParams.sortField,
	                            sortDir = $stateParams.sortDir;
	
	                        return ReadQueries.getAll(view, page, filters, sortField, sortDir);
	                    }],
	                    totalItems: ['response', function (response) {
	                        return response.totalItems;
	                    }],
	                    referenceData: ['ReadQueries', 'view', 'response', function (ReadQueries, view, response) {
	                        return ReadQueries.getReferenceData(view.fields(), response.data);
	                    }],
	                    referenceEntries: ['dataStore', 'view', 'referenceData', function (dataStore, view, referenceData) {
	                        var references = view.getReferences();
	                        for (var name in referenceData) {
	                            _Entry2.default.createArrayFromRest(referenceData[name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                                return dataStore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                            });
	                        }
	                    }],
	                    entries: ['dataStore', 'view', 'response', 'referenceEntries', function (dataStore, view, response, referenceEntries) {
	                        var entries = view.mapEntries(response.data);
	
	                        // shortcut to diplay collection of entry with included referenced values
	                        dataStore.fillReferencesValuesFromCollection(entries, view.getReferences(), true);
	
	                        // set entries here ???
	                        dataStore.setEntries(view.getEntity().uniqueId, entries);
	
	                        return entries;
	                    }],
	                    prepare: ['view', '$stateParams', 'dataStore', 'entries', '$window', '$injector', function (view, $stateParams, dataStore, entries, $window, $injector) {
	                        return view.prepare() && $injector.invoke(view.prepare(), view, {
	                            query: $stateParams,
	                            datastore: dataStore,
	                            view: view,
	                            Entry: _Entry2.default,
	                            entries: entries,
	                            window: $window
	                        });
	                    }]
	                }
	            }
	        }
	    });
	
	    $stateProvider.state('show', {
	        parent: 'ng-admin',
	        url: '/:entity/show/:id?sortField&sortDir',
	        controller: 'ShowController',
	        controllerAs: 'showController',
	        templateProvider: templateProvider('ShowView', _show2.default),
	        params: {
	            entity: null,
	            id: null,
	            page: { value: 1, squash: true },
	            search: { value: {}, squash: true },
	            sortField: null,
	            sortDir: null
	        },
	        resolve: {
	            dataStore: function dataStore() {
	                return new _DataStore2.default();
	            },
	            view: viewProvider('ShowView'),
	            rawEntry: ['$stateParams', 'ReadQueries', 'view', function ($stateParams, ReadQueries, view) {
	                return ReadQueries.getOne(view.getEntity(), view.type, $stateParams.id, view.identifier(), view.getUrl());
	            }],
	            entry: ['view', 'rawEntry', function (view, rawEntry) {
	                return view.mapEntry(rawEntry);
	            }],
	            referenceData: ['ReadQueries', 'view', 'entry', function (ReadQueries, view, entry) {
	                return ReadQueries.getReferenceData(view.fields(), [entry.values]);
	            }],
	            referenceEntries: ['dataStore', 'view', 'referenceData', function (dataStore, view, referenceData) {
	                var references = view.getReferences();
	                for (var name in referenceData) {
	                    _Entry2.default.createArrayFromRest(referenceData[name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                    });
	                }
	            }],
	            referencedListData: ['$stateParams', 'ReadQueries', 'view', 'entry', function ($stateParams, ReadQueries, view, entry) {
	                return ReadQueries.getReferencedListData(view.getReferencedLists(), $stateParams.sortField, $stateParams.sortDir, entry.identifierValue);
	            }],
	            referencedListEntries: ['dataStore', 'view', 'referencedListData', function (dataStore, view, referencedListData) {
	                var referencedLists = view.getReferencedLists();
	                for (var name in referencedLists) {
	                    _Entry2.default.createArrayFromRest(referencedListData[name], referencedLists[name].targetFields(), referencedLists[name].targetEntity().name(), referencedLists[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(referencedLists[name].targetEntity().uniqueId + '_list', entry);
	                    });
	                }
	            }],
	            entryWithReferences: ['dataStore', 'view', 'entry', 'referenceEntries', function (dataStore, view, entry, referenceEntries) {
	                dataStore.fillReferencesValuesFromEntry(entry, view.getReferences(), true);
	                dataStore.addEntry(view.getEntity().uniqueId, entry);
	            }],
	            referenceDataForReferencedLists: ['$q', 'ReadQueries', 'view', 'referencedListData', function ($q, ReadQueries, view, referencedListData) {
	                var referencedLists = view.getReferencedLists();
	                var promises = {};
	                Object.keys(referencedLists).map(function (name) {
	                    promises[name] = ReadQueries.getReferenceData(referencedLists[name].targetFields(), referencedListData[name]);
	                });
	                return $q.all(promises);
	            }],
	            referenceEntriesForReferencedLists: ['dataStore', 'view', 'referenceDataForReferencedLists', function (dataStore, view, referenceDataForReferencedLists) {
	                var referencedLists = view.getReferencedLists();
	                Object.keys(referencedLists).map(function (referencedListName) {
	                    var references = referencedLists[referencedListName].getReferences();
	                    for (var name in references) {
	                        if (!referenceDataForReferencedLists[referencedListName][name]) {
	                            continue;
	                        }
	                        _Entry2.default.createArrayFromRest(referenceDataForReferencedLists[referencedListName][name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                            return dataStore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                        });
	                    }
	                });
	                return true;
	            }],
	            prepare: ['view', '$stateParams', 'dataStore', 'entry', 'entryWithReferences', 'referencedListEntries', 'referenceEntriesForReferencedLists', '$window', '$injector', function (view, $stateParams, dataStore, entry, entryWithReferences, referencedListEntries, referenceEntriesForReferencedLists, $window, $injector) {
	                return view.prepare() && $injector.invoke(view.prepare(), view, {
	                    query: $stateParams,
	                    datastore: dataStore,
	                    view: view,
	                    Entry: _Entry2.default,
	                    entry: entry,
	                    window: $window
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('create', {
	        parent: 'ng-admin',
	        url: '/:entity/create?{defaultValues:json}',
	        controller: 'FormController',
	        controllerAs: 'formController',
	        templateProvider: templateProvider('CreateView', _create2.default),
	        params: {
	            page: { value: 1, squash: true },
	            search: { value: {}, squash: true },
	            defaultValues: { value: {}, squash: true },
	            sortField: null,
	            sortDir: null
	        },
	        resolve: {
	            dataStore: function dataStore() {
	                return new _DataStore2.default();
	            },
	            previousState: ['$state', '$stateParams', function ($state, $stateParams) {
	                return {
	                    name: $state.current.name || 'edit',
	                    params: Object.keys($state.params).length > 0 ? $state.params : $stateParams
	                };
	            }],
	            view: viewProvider('CreateView'),
	            entry: ['$stateParams', 'dataStore', 'view', function ($stateParams, dataStore, view) {
	                var entry = _Entry2.default.createForFields(view.getFields(), view.entity.name());
	                Object.keys($stateParams.defaultValues).forEach(function (key) {
	                    return entry.values[key] = $stateParams.defaultValues[key];
	                });
	                dataStore.addEntry(view.getEntity().uniqueId, entry);
	
	                return entry;
	            }],
	            choiceData: ['ReadQueries', 'view', function (ReadQueries, view) {
	                return ReadQueries.getAllReferencedData(view.getReferences(false));
	            }],
	            choiceEntries: ['dataStore', 'view', 'choiceData', function (dataStore, view, filterData) {
	                var choices = view.getReferences(false);
	                for (var name in filterData) {
	                    _Entry2.default.createArrayFromRest(filterData[name], [choices[name].targetField()], choices[name].targetEntity().name(), choices[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(choices[name].targetEntity().uniqueId + '_choices', entry);
	                    });
	                }
	            }],
	            prepare: ['view', '$stateParams', 'dataStore', 'entry', 'choiceEntries', '$window', '$injector', function (view, $stateParams, dataStore, entry, choiceEntries, $window, $injector) {
	                return view.prepare() && $injector.invoke(view.prepare(), view, {
	                    query: $stateParams,
	                    datastore: dataStore,
	                    view: view,
	                    Entry: _Entry2.default,
	                    entry: entry,
	                    window: $window
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('edit', {
	        parent: 'ng-admin',
	        url: '/:entity/edit/:id?sortField&sortDir',
	        controller: 'FormController',
	        controllerAs: 'formController',
	        templateProvider: templateProvider('EditView', _edit2.default),
	        params: {
	            entity: null,
	            id: null,
	            page: { value: 1, squash: true },
	            search: { value: {}, squash: true },
	            sortField: null,
	            sortDir: null
	        },
	        resolve: {
	            dataStore: function dataStore() {
	                return new _DataStore2.default();
	            },
	            previousState: ['$state', '$stateParams', function ($state, $stateParams) {
	                return {
	                    name: $state.current.name || 'edit',
	                    params: Object.keys($state.params).length > 0 ? $state.params : $stateParams
	                };
	            }],
	            view: viewProvider('EditView'),
	            rawEntry: ['$stateParams', 'ReadQueries', 'view', function ($stateParams, ReadQueries, view) {
	                return ReadQueries.getOne(view.getEntity(), view.type, $stateParams.id, view.identifier(), view.getUrl($stateParams.id));
	            }],
	            entry: ['view', 'rawEntry', function (view, rawEntry) {
	                return view.mapEntry(rawEntry);
	            }],
	            referenceData: ['ReadQueries', 'view', 'entry', function (ReadQueries, view, entry) {
	                return ReadQueries.getReferenceData(view.fields(), [entry.values]);
	            }],
	            referenceEntries: ['dataStore', 'view', 'referenceData', function (dataStore, view, referenceData) {
	                var references = view.getReferences();
	                for (var name in referenceData) {
	                    _Entry2.default.createArrayFromRest(referenceData[name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                    });
	                }
	            }],
	            referencedListData: ['$stateParams', 'ReadQueries', 'view', 'entry', function ($stateParams, ReadQueries, view, entry) {
	                return ReadQueries.getReferencedListData(view.getReferencedLists(), $stateParams.sortField, $stateParams.sortDir, entry.identifierValue);
	            }],
	            referencedListEntries: ['dataStore', 'view', 'referencedListData', function (dataStore, view, referencedListData) {
	                var referencedLists = view.getReferencedLists();
	                for (var name in referencedLists) {
	                    _Entry2.default.createArrayFromRest(referencedListData[name], referencedLists[name].targetFields(), referencedLists[name].targetEntity().name(), referencedLists[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(referencedLists[name].targetEntity().uniqueId + '_list', entry);
	                    });
	                }
	            }],
	            entryWithReferences: ['dataStore', 'view', 'entry', 'referenceEntries', function (dataStore, view, entry, referenceEntries) {
	                dataStore.fillReferencesValuesFromEntry(entry, view.getReferences(), true);
	                dataStore.addEntry(view.getEntity().uniqueId, entry);
	            }],
	            choiceData: ['ReadQueries', 'view', function (ReadQueries, view) {
	                return ReadQueries.getAllReferencedData(view.getReferences(false));
	            }],
	            choiceEntries: ['dataStore', 'view', 'choiceData', function (dataStore, view, filterData) {
	                var choices = view.getReferences(false);
	                for (var name in filterData) {
	                    _Entry2.default.createArrayFromRest(filterData[name], [choices[name].targetField()], choices[name].targetEntity().name(), choices[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(choices[name].targetEntity().uniqueId + '_choices', entry);
	                    });
	                }
	            }],
	            referenceDataForReferencedLists: ['$q', 'ReadQueries', 'view', 'referencedListData', function ($q, ReadQueries, view, referencedListData) {
	                var referencedLists = view.getReferencedLists();
	                var promises = {};
	                Object.keys(referencedLists).map(function (name) {
	                    promises[name] = ReadQueries.getReferenceData(referencedLists[name].targetFields(), referencedListData[name]);
	                });
	                return $q.all(promises);
	            }],
	            referenceEntriesForReferencedLists: ['dataStore', 'view', 'referenceDataForReferencedLists', function (dataStore, view, referenceDataForReferencedLists) {
	                var referencedLists = view.getReferencedLists();
	                Object.keys(referencedLists).map(function (referencedListName) {
	                    var references = referencedLists[referencedListName].getReferences();
	                    for (var name in references) {
	                        if (!referenceDataForReferencedLists[referencedListName][name]) {
	                            continue;
	                        }
	                        _Entry2.default.createArrayFromRest(referenceDataForReferencedLists[referencedListName][name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                            return dataStore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                        });
	                    }
	                });
	                return true;
	            }],
	            prepare: ['view', '$stateParams', 'dataStore', 'entry', 'referenceEntriesForReferencedLists', 'choiceEntries', 'entryWithReferences', '$window', '$injector', function (view, $stateParams, dataStore, entry, referenceEntriesForReferencedLists, choiceEntries, entryWithReferences, $window, $injector) {
	                return view.prepare() && $injector.invoke(view.prepare(), view, {
	                    query: $stateParams,
	                    datastore: dataStore,
	                    view: view,
	                    Entry: _Entry2.default,
	                    entry: entry,
	                    window: $window
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('delete', {
	        parent: 'ng-admin',
	        url: '/:entity/delete/:id',
	        controller: 'DeleteController',
	        controllerAs: 'deleteController',
	        templateProvider: templateProvider('DeleteView', _delete2.default),
	        params: {
	            page: { value: 1, squash: true },
	            search: { value: {}, squash: true },
	            sortField: null,
	            sortDir: null
	        },
	        resolve: {
	            dataStore: function dataStore() {
	                return new _DataStore2.default();
	            },
	            view: viewProvider('DeleteView'),
	            params: ['$stateParams', function ($stateParams) {
	                return $stateParams;
	            }],
	            rawEntry: ['$stateParams', 'ReadQueries', 'view', function ($stateParams, ReadQueries, view) {
	                return ReadQueries.getOne(view.getEntity(), view.type, $stateParams.id, view.identifier(), view.getUrl());
	            }],
	            entry: ['view', 'rawEntry', function (view, rawEntry) {
	                return view.mapEntry(rawEntry);
	            }],
	            prepare: ['view', '$stateParams', 'dataStore', 'entry', '$window', '$injector', function (view, $stateParams, dataStore, entry, $window, $injector) {
	                return view.prepare() && $injector.invoke(view.prepare(), view, {
	                    query: $stateParams,
	                    datastore: dataStore,
	                    view: view,
	                    Entry: _Entry2.default,
	                    entry: entry,
	                    window: $window
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('batchDelete', {
	        parent: 'ng-admin',
	        url: '/:entity/batch-delete/{ids:json}',
	        controller: 'BatchDeleteController',
	        controllerAs: 'batchDeleteController',
	        templateProvider: templateProvider('BatchDeleteView', _batchDelete2.default),
	        params: {
	            entity: null,
	            ids: [],
	            page: { value: 1, squash: true },
	            search: { value: {}, squash: true },
	            sortField: null,
	            sortDir: null
	        },
	        resolve: {
	            view: viewProvider('BatchDeleteView'),
	            params: ['$stateParams', function ($stateParams) {
	                return $stateParams;
	            }]
	        }
	    });
	}
	
	routing.$inject = ['$stateProvider'];
	
	exports.default = routing;
	module.exports = exports['default'];
	//# sourceMappingURL=routing.js.map

/***/ },
/* 278 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var ShowController = function () {
	    function ShowController($scope, $location, view, dataStore) {
	        _classCallCheck(this, ShowController);
	
	        this.$scope = $scope;
	        this.$location = $location;
	        this.title = view.title();
	        this.description = view.description();
	        this.actions = view.actions();
	
	        this.fields = view.fields();
	        this.$scope.entry = dataStore.getFirstEntry(view.getEntity().uniqueId);
	        this.$scope.view = view;
	        this.view = view;
	        this.entity = this.view.getEntity();
	        this.dataStore = dataStore;
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    _createClass(ShowController, [{
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	            this.$location = undefined;
	            this.view = undefined;
	            this.entity = undefined;
	            this.dataStore = undefined;
	        }
	    }]);
	
	    return ShowController;
	}();
	
	exports.default = ShowController;
	
	ShowController.$inject = ['$scope', '$location', 'view', 'dataStore'];
	module.exports = exports['default'];
	//# sourceMappingURL=ShowController.js.map

/***/ },
/* 279 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maShowItem;
	/**
	 * A directive containing a label and a column
	 *
	 * To be used in the showView
	 */
	function maShowItem() {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            entry: '&',
	            entity: '&',
	            datastore: '&'
	        },
	        link: {
	            pre: function pre(scope) {
	                scope.field = scope.field();
	                scope.entry = scope.entry();
	                scope.entity = scope.entity();
	                scope.datastore = scope.datastore();
	            }
	        },
	        template: '<div class="col-lg-12 form-group">\n    <label class="col-sm-2 control-label">{{ field.label() | translate }}</label>\n    <div class="show-value" ng-class="(field.getCssClasses(entry) || \'col-sm-10 col-md-8 col-lg-7\')">\n        <div ng-class="::\'ng-admin-field-\' + field.name() + \' \' + \'ng-admin-type-\' + field.type()">\n            <ma-column field="::field" entry="::entry" entity="::entity" datastore="::datastore"></ma-column>\n        </div>\n    </div>\n</div>'
	    };
	}
	
	maShowItem.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maShowItem.js.map

/***/ },
/* 280 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maJsonValidator;
	function maJsonValidator() {
	    return {
	        require: 'ngModel',
	        link: function link(scope, elm, attr, ctrl) {
	            ctrl.$validators.json = function (value) {
	                if (ctrl.$isEmpty(value)) {
	                    return true;
	                }
	
	                try {
	                    angular.fromJson(value);
	
	                    return true;
	                } catch (e) {
	                    return false;
	                }
	            };
	        }
	    };
	}
	
	maJsonValidator.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maJsonValidator.js.map

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(6);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	__webpack_require__(38);
	__webpack_require__(329);
	
	var MainModule = _angular2.default.module('main', ['ui.router', 'restangular', 'pascalprecht.translate']);
	
	MainModule.controller('AppController', __webpack_require__(282));
	MainModule.controller('DashboardController', __webpack_require__(283));
	MainModule.provider('NgAdminConfiguration', __webpack_require__(289));
	MainModule.provider('HttpErrorService', __webpack_require__(288));
	
	MainModule.filter('orderElement', __webpack_require__(286));
	MainModule.filter('stripTags', __webpack_require__(287));
	
	MainModule.directive('maDashboardPanel', __webpack_require__(284));
	MainModule.directive('maMenuBar', __webpack_require__(285));
	
	MainModule.config(__webpack_require__(290));
	MainModule.config(__webpack_require__(291));
	MainModule.config(__webpack_require__(292));
	
	MainModule.run(__webpack_require__(293));
	MainModule.run(__webpack_require__(294));
	//# sourceMappingURL=MainModule.js.map

/***/ },
/* 282 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	/**
	 * @param {$scope}  $scope
	 * @param {$state}  $state
	 * @param {NgAdmin} Configuration
	 * @constructor
	 */
	var AppController = function () {
	    function AppController($scope, $state, Configuration) {
	        _classCallCheck(this, AppController);
	
	        var application = Configuration();
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$scope.isCollapsed = true;
	        this.menu = application.menu();
	        this.applicationName = application.title();
	        this.header = application.header();
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    _createClass(AppController, [{
	        key: 'displayHome',
	        value: function displayHome() {
	            this.$state.go(this.$state.get('dashboard'));
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	            this.$state = undefined;
	        }
	    }]);
	
	    return AppController;
	}();
	
	exports.default = AppController;
	
	AppController.$inject = ['$scope', '$state', 'NgAdminConfiguration'];
	module.exports = exports['default'];
	//# sourceMappingURL=AppController.js.map

/***/ },
/* 283 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	/**
	 * @param {$scope} $scope
	 * @param {$state} $state
	 * @param {PanelBuilder} PanelBuilder
	 * @constructor
	 */
	var DashboardController = function () {
	    function DashboardController($scope, $state, collections, entries, hasEntities, dataStore) {
	        _classCallCheck(this, DashboardController);
	
	        this.$state = $state;
	        this.collections = collections;
	        this.entries = entries;
	        this.hasEntities = hasEntities;
	        this.datastore = dataStore;
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    _createClass(DashboardController, [{
	        key: 'gotoList',
	        value: function gotoList(entityName) {
	            this.$state.go(this.$state.get('list'), { entity: entityName });
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$state = undefined;
	        }
	    }]);
	
	    return DashboardController;
	}();
	
	exports.default = DashboardController;
	
	DashboardController.$inject = ['$scope', '$state', 'collections', 'entries', 'hasEntities', 'dataStore'];
	module.exports = exports['default'];
	//# sourceMappingURL=DashboardController.js.map

/***/ },
/* 284 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDashboardPanel;
	function maDashboardPanel($state) {
	    return {
	        restrict: 'E',
	        scope: {
	            collection: '&',
	            entries: '&',
	            datastore: '&'
	        },
	        link: function link(scope) {
	            scope.gotoList = function () {
	                $state.go($state.get('list'), { entity: scope.collection().entity.name() });
	            };
	        },
	        template: '<div class="panel-heading">\n    <a ng-click="gotoList()">{{ (collection().title() || collection().entity.label()) | translate }}</a>\n</div>\n<ma-datagrid name="{{ collection().name() }}"\n    entries="entries()"\n    fields="::collection().fields()"\n    entity="::collection().entity"\n    list-actions="::collection().listActions()"\n    datastore="datastore()">\n</ma-datagrid>'
	    };
	}
	
	maDashboardPanel.$inject = ['$state'];
	module.exports = exports['default'];
	//# sourceMappingURL=maDashboardPanel.js.map

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maMenuBar;
	
	var _menuBar = __webpack_require__(360);
	
	var _menuBar2 = _interopRequireDefault(_menuBar);
	
	var _angular = __webpack_require__(6);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function maMenuBar($location, $rootScope, $compile) {
	    return {
	        restrict: 'E',
	        scope: {
	            'menu': '&'
	        },
	        link: function link(scope, element) {
	            scope.menu = scope.menu();
	            scope.path = $location.path();
	            // initialize openMenus
	            var openMenus = scope.menu.children().filter(function (menu) {
	                return menu.isChildActive(scope.path);
	            });
	            // manually render on change to avoid checking menu.isActive at each dirty check
	            var listener = $rootScope.$on('$locationChangeSuccess', function () {
	                scope.path = $location.path();
	                render();
	            });
	            $rootScope.$on('$destroy', listener);
	            scope.toggleMenu = function (menu) {
	                // handle click on parent menu manually
	                // because we chose bindOnce in the template for performance reasons
	                if (openMenus.indexOf(menu) !== -1) {
	                    // menu is already open, the click closes it
	                    // except if a submenu is open
	                    if (menu.isChildActive(scope.path)) {
	                        return;
	                    }
	                    openMenus.splice(openMenus.indexOf(menu), 1);
	                    closeMenu(menu);
	                } else {
	                    // menu is closed, the click opens it
	                    openMenus.push(menu);
	                    openMenu(menu);
	                }
	                // we don't render() in that case because it would cut the animation
	                return;
	            };
	            scope.activateLink = function (menu) {
	                if (!menu.link()) {
	                    return;
	                }
	                // close all open menus
	                // no need to close the menus with animation using closeMenu(),
	                // the menu will rerender anyway because of the listener on $locationChangeSuccess
	                // so the animation don't work in that case
	                if (menu.autoClose()) {
	                    openMenus = [];
	                }
	            };
	            scope.isOpen = function (menu) {
	                return menu.isChildActive(scope.path) || openMenus.indexOf(menu) !== -1;
	            };
	            render();
	
	            function render() {
	                element.html(_menuBar2.default);
	                $compile(element.contents())(scope);
	            }
	            function closeMenu(menu) {
	                var elements = getElementsForMenu(menu);
	                elements.ul.addClass('collapsed');
	                elements.arrow.removeClass('glyphicon-menu-down');
	                elements.arrow.addClass('glyphicon-menu-right');
	            }
	            function openMenu(menu) {
	                var elements = getElementsForMenu(menu);
	                elements.ul.removeClass('collapsed');
	                elements.arrow.removeClass('glyphicon-menu-right');
	                elements.arrow.addClass('glyphicon-menu-down');
	            }
	            function getElementsForMenu(menu) {
	                var parentLi;
	                _angular2.default.forEach(element.find('li'), function (li) {
	                    var liElement = _angular2.default.element(li);
	                    if (liElement.attr('data-menu-id') == menu.uuid) {
	                        parentLi = liElement;
	                    }
	                });
	                return {
	                    arrow: _angular2.default.element(parentLi.find('a')[0].getElementsByClassName('arrow')[0]),
	                    ul: parentLi.find('ul').eq(0)
	                };
	            }
	        }
	    };
	}
	
	maMenuBar.$inject = ['$location', '$rootScope', '$compile'];
	module.exports = exports['default'];
	//# sourceMappingURL=maMenuBar.js.map

/***/ },
/* 286 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = OrderElement;
	function OrderElement() {
	    return function (input) {
	        var results = [],
	            objectKey;
	
	        for (objectKey in input) {
	            results.push(input[objectKey]);
	        }
	
	        results.sort(function (field1, field2) {
	            return typeof field1.order === 'function' ? field1.order() - field2.order() : field1.order - field2.order;
	        });
	
	        return results;
	    };
	}
	
	OrderElement.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=OrderElement.js.map

/***/ },
/* 287 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = stripTags;
	function stripTags() {
	    return function (input) {
	        return input.replace(/(<([^>]+)>)/ig, '');
	    };
	}
	
	stripTags.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=StripTags.js.map

/***/ },
/* 288 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var HttpErrorService = function HttpErrorService($state, $translate, notification) {
	    return {
	        handleError: function handleError(event, toState, toParams, fromState, fromParams, error) {
	            switch (error.status) {
	                case 404:
	                    this.handle404Error(event, error);
	                    break;
	                case 403:
	                    this.handle403Error(error);
	                    break;
	                default:
	                    this.handleDefaultError(error);
	                    break;
	            }
	        },
	
	        handle404Error: function handle404Error(event) {
	            event.preventDefault();
	            $state.go('ma-404');
	        },
	
	        handle403Error: function handle403Error(error) {
	            $translate('STATE_FORBIDDEN_ERROR', { message: error.data.message }).then(this.displayError);
	            throw error;
	        },
	
	        handleDefaultError: function handleDefaultError(error) {
	            $translate('STATE_CHANGE_ERROR', { message: error.data.message }).then(this.displayError);
	            throw error;
	        },
	
	        displayError: function displayError(text) {
	            return notification.log(text, { addnCls: 'humane-flatty-error' });
	        }
	    };
	};
	
	HttpErrorService.$inject = ['$state', '$translate', 'notification'];
	
	exports.default = { $get: HttpErrorService };
	module.exports = exports['default'];
	//# sourceMappingURL=HttpErrorService.js.map

/***/ },
/* 289 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var NgAdminConfiguration = function () {
	    function NgAdminConfiguration($compileProvider) {
	        _classCallCheck(this, NgAdminConfiguration);
	
	        this.config = null;
	        this.adminDescription = null;
	        this.$compileProvider = $compileProvider;
	    }
	
	    _createClass(NgAdminConfiguration, [{
	        key: 'setAdminDescription',
	        value: function setAdminDescription(adminDescription) {
	            this.adminDescription = adminDescription;
	        }
	    }, {
	        key: 'configure',
	        value: function configure(config) {
	            this.config = config;
	
	            this.$compileProvider.debugInfoEnabled(this.config.debug());
	        }
	    }, {
	        key: '$get',
	        value: function $get() {
	            var config = this.config;
	            return function () {
	                return config;
	            };
	        }
	    }, {
	        key: 'application',
	        value: function application(name, debug) {
	            return this.adminDescription.application(name, debug);
	        }
	    }, {
	        key: 'entity',
	        value: function entity(name) {
	            return this.adminDescription.entity(name);
	        }
	    }, {
	        key: 'field',
	        value: function field(name, type) {
	            return this.adminDescription.field(name, type);
	        }
	    }, {
	        key: 'registerFieldType',
	        value: function registerFieldType(name, type) {
	            return this.adminDescription.registerFieldType(name, type);
	        }
	    }, {
	        key: 'getFieldConstructor',
	        value: function getFieldConstructor(name) {
	            return this.adminDescription.getFieldConstructor(name);
	        }
	    }, {
	        key: 'menu',
	        value: function menu(entity) {
	            return this.adminDescription.menu(entity);
	        }
	    }, {
	        key: 'collection',
	        value: function collection(_collection) {
	            return this.adminDescription.collection(_collection);
	        }
	    }, {
	        key: 'dashboard',
	        value: function dashboard(_dashboard) {
	            return this.adminDescription.dashboard(_dashboard);
	        }
	    }]);
	
	    return NgAdminConfiguration;
	}();
	
	exports.default = NgAdminConfiguration;
	
	NgAdminConfiguration.$inject = ['$compileProvider'];
	module.exports = exports['default'];
	//# sourceMappingURL=NgAdminConfiguration.js.map

/***/ },
/* 290 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = http;
	function http($httpProvider) {
	    $httpProvider.useApplyAsync(true);
	}
	
	http.$inject = ['$httpProvider'];
	module.exports = exports['default'];
	//# sourceMappingURL=http.js.map

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _layout = __webpack_require__(359);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _dashboard = __webpack_require__(358);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _ = __webpack_require__(357);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function dataStoreProvider() {
	    return ['AdminDescription', function (AdminDescription) {
	        return AdminDescription.getDataStore();
	    }];
	}
	
	function entryConstructorProvider() {
	    return ['AdminDescription', function (AdminDescription) {
	        return AdminDescription.getEntryConstructor();
	    }];
	}
	
	function routing($stateProvider, $urlRouterProvider) {
	
	    $stateProvider.state('ng-admin', {
	        abstract: true,
	        views: {
	            'ng-admin': {
	                controller: 'AppController',
	                controllerAs: 'appController',
	                templateProvider: ['NgAdminConfiguration', function (Configuration) {
	                    return Configuration().layout() || _layout2.default;
	                }]
	            }
	        }
	    });
	
	    $stateProvider.state('dashboard', {
	        parent: 'ng-admin',
	        url: '/dashboard?sortField&sortDir',
	        params: {
	            sortField: null,
	            sortDir: null
	        },
	        controller: 'DashboardController',
	        controllerAs: 'dashboardController',
	        templateProvider: ['NgAdminConfiguration', function (Configuration) {
	            return Configuration().dashboard().template() || _dashboard2.default;
	        }],
	        resolve: {
	            dataStore: dataStoreProvider(),
	            Entry: entryConstructorProvider(),
	            hasEntities: ['NgAdminConfiguration', function (Configuration) {
	                return Configuration().entities.length > 0;
	            }],
	            collections: ['NgAdminConfiguration', function (Configuration) {
	                return Configuration().dashboard().collections();
	            }],
	            responses: ['$stateParams', '$q', 'collections', 'dataStore', 'Entry', 'ReadQueries', function ($stateParams, $q, collections, dataStore, Entry, ReadQueries) {
	                var sortField = 'sortField' in $stateParams ? $stateParams.sortField : null;
	                var sortDir = 'sortDir' in $stateParams ? $stateParams.sortDir : null;
	
	                var promises = {},
	                    collection,
	                    collectionSortField,
	                    collectionSortDir,
	                    collectionName;
	
	                for (collectionName in collections) {
	                    collection = collections[collectionName];
	                    collectionSortField = collection.getSortFieldName();
	                    collectionSortDir = collection.sortDir();
	                    if (sortField && sortField.split('.')[0] === collection.name()) {
	                        collectionSortField = sortField;
	                        collectionSortDir = sortDir;
	                    }
	                    promises[collectionName] = function (collection, collectionSortField, collectionSortDir) {
	                        var rawEntries;
	
	                        return ReadQueries.getAll(collection, 1, {}, collectionSortField, collectionSortDir).then(function (response) {
	                            rawEntries = response.data;
	                            return rawEntries;
	                        }).then(function (rawEntries) {
	                            return ReadQueries.getReferenceData(collection.fields(), rawEntries);
	                        }).then(function (referenceData) {
	                            var references = collection.getReferences();
	                            for (var name in referenceData) {
	                                Entry.createArrayFromRest(referenceData[name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                                    return dataStore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                                });
	                            }
	                        }).then(function () {
	                            var entries = collection.mapEntries(rawEntries);
	
	                            // shortcut to display collection of entry with included referenced values
	                            dataStore.fillReferencesValuesFromCollection(entries, collection.getReferences(), true);
	
	                            return entries;
	                        });
	                    }(collection, collectionSortField, collectionSortDir);
	                }
	
	                return $q.all(promises);
	            }],
	            entries: ['responses', 'collections', function (responses, collections) {
	                var collectionName,
	                    entries = {};
	
	                for (collectionName in responses) {
	                    entries[collections[collectionName].name()] = responses[collectionName];
	                }
	
	                return entries;
	            }]
	        }
	    });
	
	    $stateProvider.state('ma-404', {
	        parent: 'ng-admin',
	        template: _2.default
	    });
	
	    $urlRouterProvider.when('', '/dashboard');
	
	    $urlRouterProvider.otherwise(function ($injector, $location) {
	        var state = $injector.get('$state');
	        state.go('ma-404');
	        return $location.path();
	    });
	}
	
	routing.$inject = ['$stateProvider', '$urlRouterProvider'];
	
	exports.default = routing;
	module.exports = exports['default'];
	//# sourceMappingURL=routing.js.map

/***/ },
/* 292 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = translate;
	function translate($translateProvider) {
	  $translateProvider.translations('en', {
	    'BACK': 'Back',
	    'DELETE': 'Delete',
	    'CREATE': 'Create',
	    'EDIT': 'Edit',
	    'EXPORT': 'Export',
	    'ADD_FILTER': 'Add filter',
	    'SEE_RELATED': 'See all related {{ entityName }}',
	    'LIST': 'List',
	    'SHOW': 'Show',
	    'SAVE': 'Save',
	    'N_SELECTED': '{{ length }} Selected',
	    'ARE_YOU_SURE': 'Are you sure?',
	    'YES': 'Yes',
	    'NO': 'No',
	    'FILTER_VALUES': 'Filter values',
	    'CLOSE': 'Close',
	    'CLEAR': 'Clear',
	    'CURRENT': 'Current',
	    'REMOVE': 'Remove',
	    'ADD_NEW': 'Add new {{ name }}',
	    'BROWSE': 'Browse',
	    'N_COMPLETE': '{{ progress }}% Complete',
	    'CREATE_NEW': 'Create new',
	    'SUBMIT': 'Submit',
	    'SAVE_CHANGES': 'Save changes',
	    'BATCH_DELETE_SUCCESS': 'Elements successfully deleted',
	    'DELETE_SUCCESS': 'Element successfully deleted',
	    'ERROR_MESSAGE': 'Oops, an error occurred (code: {{ status }})',
	    'INVALID_FORM': 'Invalid form',
	    'CREATION_SUCCESS': 'Element successfully created',
	    'EDITION_SUCCESS': 'Changes successfully saved',
	    'ACTIONS': 'Actions',
	    'PAGINATION': '<strong>{{ begin }}</strong> - <strong>{{ end }}</strong> of <strong>{{ total }}</strong>',
	    'NO_PAGINATION': 'No record found',
	    'PREVIOUS': '« Prev',
	    'NEXT': 'Next »',
	    'DETAIL': 'Detail',
	    'STATE_CHANGE_ERROR': 'State change error: {{ message }}',
	    'STATE_FORBIDDEN_ERROR': 'A server 403 error occured: {{ message }}',
	    'NOT_FOUND': 'Not Found',
	    'NOT_FOUND_DETAILS': 'The page you are looking for cannot be found. Take a break before trying again.'
	  });
	  $translateProvider.preferredLanguage('en');
	  $translateProvider.useSanitizeValueStrategy(null);
	}
	
	translate.$inject = ['$translateProvider'];
	module.exports = exports['default'];
	//# sourceMappingURL=translate.js.map

/***/ },
/* 293 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = HttpErrorHandler;
	function HttpErrorHandler($rootScope, HttpErrorService) {
	    $rootScope.$on("$stateChangeError", function (event, toState, toParams, fromState, fromParams, error) {
	        HttpErrorService.handleError(event, toState, toParams, fromState, fromParams, error);
	    });
	}
	
	HttpErrorHandler.$inject = ['$rootScope', 'HttpErrorService'];
	module.exports = exports['default'];
	//# sourceMappingURL=HttpErrorHandler.js.map

/***/ },
/* 294 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = loader;
	/**
	 * Display loader on each route change
	 *
	 * @param {$rootScope}  $rootScope
	 * @param {$window}     $window
	 * @param {progression} progression
	 */
	function loader($rootScope, $window, progression) {
	    $rootScope.$on('$stateChangeStart', function () {
	        progression.start();
	    });
	
	    $rootScope.$on('$stateChangeSuccess', function () {
	        progression.done();
	        $window.scrollTo(0, 0);
	    });
	
	    $rootScope.$on("$stateChangeError", function () {
	        progression.done();
	    });
	}
	
	loader.$inject = ['$rootScope', '$window', 'progression'];
	module.exports = exports['default'];
	//# sourceMappingURL=Loader.js.map

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	global.rangy = __webpack_require__(135);
	global.rangy = __webpack_require__(328);
	global.numeral = __webpack_require__(31);
	
	__webpack_require__(6);
	__webpack_require__(38);
	__webpack_require__(325);
	__webpack_require__(343);
	__webpack_require__(169);
	
	__webpack_require__(168);
	__webpack_require__(170);
	__webpack_require__(324);
	
	global._ = __webpack_require__(186);
	//# sourceMappingURL=vendors.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	var _MenuMenu = __webpack_require__(130);
	
	var _MenuMenu2 = _interopRequireDefault(_MenuMenu);
	
	var _Collection = __webpack_require__(125);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	var _Dashboard = __webpack_require__(126);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _UtilsOrderElement = __webpack_require__(133);
	
	var _UtilsOrderElement2 = _interopRequireDefault(_UtilsOrderElement);
	
	var Application = function () {
	    function Application() {
	        var title = arguments[0] === undefined ? 'ng-admin' : arguments[0];
	        var debug = arguments[1] === undefined ? true : arguments[1];
	
	        _classCallCheck(this, Application);
	
	        this._baseApiUrl = '';
	        this._customTemplate = function (viewName) {};
	        this._title = title;
	        this._menu = null;
	        this._dashboard = null;
	        this._layout = false;
	        this._header = false;
	        this._entities = [];
	        this._errorMessage = this.defaultErrorMessage;
	        this._debug = debug;
	    }
	
	    _createClass(Application, [{
	        key: 'defaultErrorMessage',
	        value: function defaultErrorMessage(response) {
	            var body = response.data;
	
	            if ((typeof body === 'undefined' ? 'undefined' : _typeof(body)) === 'object') {
	                body = JSON.stringify(body);
	            }
	
	            return 'Oops, an error occured : (code: ' + response.status + ') ' + body;
	        }
	    }, {
	        key: 'getViewsOfType',
	        value: function getViewsOfType(type) {
	            return _UtilsOrderElement2['default'].order(this.entities.map(function (entity) {
	                return entity.views[type];
	            }).filter(function (view) {
	                return view.enabled;
	            }));
	        }
	    }, {
	        key: 'getRouteFor',
	        value: function getRouteFor(entity, viewUrl, viewType, identifierValue, identifierName) {
	            var baseApiUrl = entity.baseApiUrl() || this.baseApiUrl(),
	                url = viewUrl || entity.getUrl(viewType, identifierValue, identifierName);
	
	            // If the view or the entity don't define the url, retrieve it from the baseURL of the entity or the app
	            if (!url) {
	                url = baseApiUrl + encodeURIComponent(entity.name());
	                if (identifierValue != null) {
	                    url += '/' + encodeURIComponent(identifierValue);
	                }
	            } else if (!/^(?:[a-z]+:)?\/\//.test(url)) {
	                // Add baseUrl for relative URL
	                url = baseApiUrl + url;
	            }
	
	            return url;
	        }
	    }, {
	        key: 'debug',
	        value: function debug(_debug) {
	            if (!arguments.length) return this._debug;
	            this._debug = _debug;
	            return this;
	        }
	    }, {
	        key: 'layout',
	        value: function layout(_layout) {
	            if (!arguments.length) return this._layout;
	            this._layout = _layout;
	            return this;
	        }
	    }, {
	        key: 'header',
	        value: function header(_header) {
	            if (!arguments.length) return this._header;
	            this._header = _header;
	            return this;
	        }
	    }, {
	        key: 'title',
	        value: function title(_title) {
	            if (!arguments.length) return this._title;
	            this._title = _title;
	            return this;
	        }
	    }, {
	        key: 'menu',
	
	        /**
	         * Getter/Setter for the main application menu
	         *
	         * If the getter is called first, it will return a menu based on entities.
	         *
	         *     application.addEntity(new Entity('posts'));
	         *     application.addEntity(new Entity('comments'));
	         *     application.menu(); // Menu { children: [ Menu { title: "Posts" }, Menu { title: "Comments" } ]}
	         *
	         * If the setter is called first, all subsequent calls to the getter will return the set menu.
	         *
	         *     application.addEntity(new Entity('posts'));
	         *     application.addEntity(new Entity('comments'));
	         *     application.menu(new Menu().addChild(new Menu().title('Foo')));
	         *     application.menu(); // Menu { children: [ Menu { title: "Foo" } ]}
	         *
	         * @see Menu
	         */
	        value: function menu(_menu) {
	            if (!arguments.length) {
	                if (!this._menu) {
	                    this._menu = this.buildMenuFromEntities();
	                }
	                return this._menu;
	            }
	
	            this._menu = _menu;
	            return this;
	        }
	    }, {
	        key: 'buildMenuFromEntities',
	        value: function buildMenuFromEntities() {
	            return new _MenuMenu2['default']().children(this.entities.filter(function (entity) {
	                return entity.menuView().enabled;
	            }).sort(function (e1, e2) {
	                return e1.menuView().order() - e2.menuView().order();
	            }).map(function (entity) {
	                return new _MenuMenu2['default']().populateFromEntity(entity);
	            }));
	        }
	    }, {
	        key: 'dashboard',
	        value: function dashboard(_dashboard) {
	            if (!arguments.length) {
	                if (!this._dashboard) {
	                    this._dashboard = this.buildDashboardFromEntities();
	                }
	                return this._dashboard;
	            }
	            this._dashboard = _dashboard;
	            return this;
	        }
	    }, {
	        key: 'buildDashboardFromEntities',
	        value: function buildDashboardFromEntities() {
	            var dashboard = new _Dashboard2['default']();
	            this.entities.filter(function (entity) {
	                return entity.dashboardView().enabled;
	            }).map(function (entity) {
	                dashboard.addCollection(entity.dashboardView()); // yep, a collection is a ListView, and so is a DashboardView - forgive this duck typing for BC sake
	            });
	            if (!dashboard.hasCollections()) {
	                // still no collection from dashboardViews, let's use listViews instead
	                this.entities.filter(function (entity) {
	                    return entity.listView().enabled;
	                }).map(function (entity, index) {
	                    var collection = new _Collection2['default']();
	                    var listView = entity.listView();
	                    collection.setEntity(entity);
	                    collection.perPage(listView.perPage());
	                    collection.sortField(listView.sortField());
	                    collection.sortDir(listView.sortDir());
	                    collection.order(index);
	                    // use only the first 3 cols
	                    collection.fields(listView.fields().filter(function (el, index) {
	                        return index < 3;
	                    }));
	                    dashboard.addCollection(collection);
	                });
	            }
	            return dashboard;
	        }
	    }, {
	        key: 'customTemplate',
	        value: function customTemplate(_customTemplate) {
	            if (!arguments.length) return this._customTemplate;
	            this._customTemplate = _customTemplate;
	            return this;
	        }
	    }, {
	        key: 'baseApiUrl',
	        value: function baseApiUrl(url) {
	            if (!arguments.length) return this._baseApiUrl;
	            this._baseApiUrl = url;
	            return this;
	        }
	    }, {
	        key: 'addEntity',
	        value: function addEntity(entity) {
	            if (!entity) {
	                throw new Error('No entity given');
	            }
	
	            this._entities.push(entity);
	
	            return this;
	        }
	    }, {
	        key: 'getEntity',
	        value: function getEntity(entityName) {
	            var foundEntity = this._entities.filter(function (e) {
	                return e.name() === entityName;
	            })[0];
	            if (!foundEntity) {
	                throw new Error('Unable to find entity "' + entityName + '"');
	            }
	
	            return foundEntity;
	        }
	    }, {
	        key: 'hasEntity',
	        value: function hasEntity(fieldName) {
	            return !!this._entities.filter(function (f) {
	                return f.name() === fieldName;
	            }).length;
	        }
	    }, {
	        key: 'getViewByEntityAndType',
	        value: function getViewByEntityAndType(entityName, type) {
	            return this._entities.filter(function (e) {
	                return e.name() === entityName;
	            })[0].views[type];
	        }
	    }, {
	        key: 'getErrorMessage',
	        value: function getErrorMessage(response) {
	            if (typeof this._errorMessage === 'function') {
	                return this._errorMessage(response);
	            }
	
	            return this._errorMessage;
	        }
	    }, {
	        key: 'errorMessage',
	        value: function errorMessage(_errorMessage) {
	            if (!arguments.length) return this._errorMessage;
	            this._errorMessage = _errorMessage;
	            return this;
	        }
	    }, {
	        key: 'getErrorMessageFor',
	        value: function getErrorMessageFor(view, response) {
	            return view.getErrorMessage(response) || view.getEntity().getErrorMessage(response) || this.getErrorMessage(response);
	        }
	    }, {
	        key: 'getEntityNames',
	        value: function getEntityNames() {
	            return this.entities.map(function (f) {
	                return f.name();
	            });
	        }
	    }, {
	        key: 'entities',
	        get: function get() {
	            return this._entities;
	        }
	    }]);
	
	    return Application;
	}();
	
	exports['default'] = Application;
	module.exports = exports['default'];
	//# sourceMappingURL=Application.js.map

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var _Application = __webpack_require__(296);
	
	var _Application2 = _interopRequireDefault(_Application);
	
	var _EntityEntity = __webpack_require__(27);
	
	var _EntityEntity2 = _interopRequireDefault(_EntityEntity);
	
	var _DataStoreDataStore = __webpack_require__(127);
	
	var _DataStoreDataStore2 = _interopRequireDefault(_DataStoreDataStore);
	
	var _UtilsPromisesResolver = __webpack_require__(314);
	
	var _UtilsPromisesResolver2 = _interopRequireDefault(_UtilsPromisesResolver);
	
	var _QueriesReadQueries = __webpack_require__(312);
	
	var _QueriesReadQueries2 = _interopRequireDefault(_QueriesReadQueries);
	
	var _QueriesWriteQueries = __webpack_require__(313);
	
	var _QueriesWriteQueries2 = _interopRequireDefault(_QueriesWriteQueries);
	
	var _FieldField = __webpack_require__(2);
	
	var _FieldField2 = _interopRequireDefault(_FieldField);
	
	var _FieldBooleanField = __webpack_require__(298);
	
	var _FieldBooleanField2 = _interopRequireDefault(_FieldBooleanField);
	
	var _FieldChoiceField = __webpack_require__(28);
	
	var _FieldChoiceField2 = _interopRequireDefault(_FieldChoiceField);
	
	var _FieldChoicesField = __webpack_require__(299);
	
	var _FieldChoicesField2 = _interopRequireDefault(_FieldChoicesField);
	
	var _FieldDateField = __webpack_require__(128);
	
	var _FieldDateField2 = _interopRequireDefault(_FieldDateField);
	
	var _FieldDateTimeField = __webpack_require__(300);
	
	var _FieldDateTimeField2 = _interopRequireDefault(_FieldDateTimeField);
	
	var _FieldEmailField = __webpack_require__(301);
	
	var _FieldEmailField2 = _interopRequireDefault(_FieldEmailField);
	
	var _FieldEmbeddedListField = __webpack_require__(302);
	
	var _FieldEmbeddedListField2 = _interopRequireDefault(_FieldEmbeddedListField);
	
	var _FieldFloatFieldJs = __webpack_require__(304);
	
	var _FieldFloatFieldJs2 = _interopRequireDefault(_FieldFloatFieldJs);
	
	var _FieldFileField = __webpack_require__(303);
	
	var _FieldFileField2 = _interopRequireDefault(_FieldFileField);
	
	var _FieldJsonField = __webpack_require__(305);
	
	var _FieldJsonField2 = _interopRequireDefault(_FieldJsonField);
	
	var _FieldNumberField = __webpack_require__(129);
	
	var _FieldNumberField2 = _interopRequireDefault(_FieldNumberField);
	
	var _FieldPasswordField = __webpack_require__(306);
	
	var _FieldPasswordField2 = _interopRequireDefault(_FieldPasswordField);
	
	var _FieldReferenceField = __webpack_require__(29);
	
	var _FieldReferenceField2 = _interopRequireDefault(_FieldReferenceField);
	
	var _FieldReferencedListField = __webpack_require__(308);
	
	var _FieldReferencedListField2 = _interopRequireDefault(_FieldReferencedListField);
	
	var _FieldReferenceManyField = __webpack_require__(307);
	
	var _FieldReferenceManyField2 = _interopRequireDefault(_FieldReferenceManyField);
	
	var _FieldTemplateField = __webpack_require__(309);
	
	var _FieldTemplateField2 = _interopRequireDefault(_FieldTemplateField);
	
	var _FieldTextField = __webpack_require__(310);
	
	var _FieldTextField2 = _interopRequireDefault(_FieldTextField);
	
	var _FieldWysiwygField = __webpack_require__(311);
	
	var _FieldWysiwygField2 = _interopRequireDefault(_FieldWysiwygField);
	
	var _MenuMenu = __webpack_require__(130);
	
	var _MenuMenu2 = _interopRequireDefault(_MenuMenu);
	
	var _Collection = __webpack_require__(125);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	var _Dashboard = __webpack_require__(126);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Entry = __webpack_require__(8);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	var Factory = function () {
	    function Factory() {
	        _classCallCheck(this, Factory);
	
	        this._fieldTypes = [];
	        this._init();
	    }
	
	    _createClass(Factory, [{
	        key: "application",
	        value: function application(name, debug) {
	            return new _Application2["default"](name, debug);
	        }
	    }, {
	        key: "entity",
	        value: function entity(name) {
	            return new _EntityEntity2["default"](name);
	        }
	    }, {
	        key: "field",
	        value: function field(name, type) {
	            type = type || "string";
	
	            if (!(type in this._fieldTypes)) {
	                throw new Error("Unknown field type \"" + type + "\".");
	            }
	
	            return new this._fieldTypes[type](name);
	        }
	    }, {
	        key: "registerFieldType",
	        value: function registerFieldType(name, constructor) {
	            this._fieldTypes[name] = constructor;
	        }
	    }, {
	        key: "getFieldConstructor",
	        value: function getFieldConstructor(name) {
	            return this._fieldTypes[name];
	        }
	    }, {
	        key: "menu",
	        value: function menu(entity) {
	            var menu = new _MenuMenu2["default"]();
	            if (entity) {
	                menu.populateFromEntity(entity);
	            }
	            return menu;
	        }
	    }, {
	        key: "dashboard",
	        value: function dashboard() {
	            return new _Dashboard2["default"]();
	        }
	    }, {
	        key: "collection",
	        value: function collection(entity) {
	            var collection = new _Collection2["default"]();
	            if (entity) {
	                collection.setEntity(entity);
	            }
	            return collection;
	        }
	    }, {
	        key: "getEntryConstructor",
	        value: function getEntryConstructor() {
	            return _Entry2["default"];
	        }
	    }, {
	        key: "getDataStore",
	        value: function getDataStore() {
	            return new _DataStoreDataStore2["default"]();
	        }
	    }, {
	        key: "getReadQueries",
	        value: function getReadQueries(RestWrapper, PromisesResolver, Application) {
	            return new _QueriesReadQueries2["default"](RestWrapper, PromisesResolver, Application);
	        }
	    }, {
	        key: "getWriteQueries",
	        value: function getWriteQueries(RestWrapper, PromisesResolver, Application) {
	            return new _QueriesWriteQueries2["default"](RestWrapper, PromisesResolver, Application);
	        }
	    }, {
	        key: "getPromisesResolver",
	        value: function getPromisesResolver() {
	            return _UtilsPromisesResolver2["default"];
	        }
	    }, {
	        key: "_init",
	        value: function _init() {
	            this.registerFieldType("boolean", _FieldBooleanField2["default"]);
	            this.registerFieldType("choice", _FieldChoiceField2["default"]);
	            this.registerFieldType("choices", _FieldChoicesField2["default"]);
	            this.registerFieldType("date", _FieldDateField2["default"]);
	            this.registerFieldType("datetime", _FieldDateTimeField2["default"]);
	            this.registerFieldType("email", _FieldEmailField2["default"]);
	            this.registerFieldType("embedded_list", _FieldEmbeddedListField2["default"]);
	            this.registerFieldType("float", _FieldFloatFieldJs2["default"]);
	            this.registerFieldType("string", _FieldField2["default"]);
	            this.registerFieldType("file", _FieldFileField2["default"]);
	            this.registerFieldType("json", _FieldJsonField2["default"]);
	            this.registerFieldType("number", _FieldNumberField2["default"]);
	            this.registerFieldType("password", _FieldPasswordField2["default"]);
	            this.registerFieldType("reference", _FieldReferenceField2["default"]);
	            this.registerFieldType("reference_many", _FieldReferenceManyField2["default"]);
	            this.registerFieldType("referenced_list", _FieldReferencedListField2["default"]);
	            this.registerFieldType("template", _FieldTemplateField2["default"]);
	            this.registerFieldType("text", _FieldTextField2["default"]);
	            this.registerFieldType("wysiwyg", _FieldWysiwygField2["default"]);
	        }
	    }]);
	
	    return Factory;
	}();
	
	exports["default"] = Factory;
	module.exports = exports["default"];
	//# sourceMappingURL=Factory.js.map

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _ChoiceField2 = __webpack_require__(28);
	
	var _ChoiceField3 = _interopRequireDefault(_ChoiceField2);
	
	var BooleanField = function (_ChoiceField) {
	    function BooleanField(name) {
	        _classCallCheck(this, BooleanField);
	
	        _get(Object.getPrototypeOf(BooleanField.prototype), "constructor", this).call(this, name);
	        this._type = "boolean";
	        this._choices = [{ value: null, label: "undefined" }, { value: true, label: "true" }, { value: false, label: "false" }];
	        this._filterChoices = [{ value: true, label: "true" }, { value: false, label: "false" }];
	    }
	
	    _inherits(BooleanField, _ChoiceField);
	
	    _createClass(BooleanField, [{
	        key: "filterChoices",
	        value: function filterChoices(_filterChoices) {
	            if (!arguments.length) return this._filterChoices;
	            this._filterChoices = _filterChoices;
	
	            return this;
	        }
	    }]);
	
	    return BooleanField;
	}(_ChoiceField3["default"]);
	
	exports["default"] = BooleanField;
	module.exports = exports["default"];
	//# sourceMappingURL=BooleanField.js.map

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _ChoiceField2 = __webpack_require__(28);
	
	var _ChoiceField3 = _interopRequireDefault(_ChoiceField2);
	
	var ChoicesField = function (_ChoiceField) {
	    function ChoicesField(name) {
	        _classCallCheck(this, ChoicesField);
	
	        _get(Object.getPrototypeOf(ChoicesField.prototype), "constructor", this).call(this, name);
	        this._type = "choices";
	    }
	
	    _inherits(ChoicesField, _ChoiceField);
	
	    return ChoicesField;
	}(_ChoiceField3["default"]);
	
	exports["default"] = ChoicesField;
	module.exports = exports["default"];
	//# sourceMappingURL=ChoicesField.js.map

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _DateField2 = __webpack_require__(128);
	
	var _DateField3 = _interopRequireDefault(_DateField2);
	
	var DateTimeField = function (_DateField) {
	    function DateTimeField(name) {
	        _classCallCheck(this, DateTimeField);
	
	        _get(Object.getPrototypeOf(DateTimeField.prototype), "constructor", this).call(this, name);
	
	        this._format = null;
	        this._parse = function (date) {
	            return date;
	        };
	
	        this._type = "datetime";
	    }
	
	    _inherits(DateTimeField, _DateField);
	
	    return DateTimeField;
	}(_DateField3["default"]);
	
	exports["default"] = DateTimeField;
	module.exports = exports["default"];
	//# sourceMappingURL=DateTimeField.js.map

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var EmailField = function (_Field) {
	    function EmailField(name) {
	        _classCallCheck(this, EmailField);
	
	        _get(Object.getPrototypeOf(EmailField.prototype), "constructor", this).call(this, name);
	        this._type = "email";
	    }
	
	    _inherits(EmailField, _Field);
	
	    return EmailField;
	}(_Field3["default"]);
	
	exports["default"] = EmailField;
	module.exports = exports["default"];
	//# sourceMappingURL=EmailField.js.map

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var _EntityEntity = __webpack_require__(27);
	
	var _EntityEntity2 = _interopRequireDefault(_EntityEntity);
	
	/**
	 * Map an embedded list in the entry
	 *
	 * @example
	 *
	 *     {
	 *        id: 123,
	 *        title: "hello, world",
	 *        comments: [
	 *          { date: "2015-09-30", author: "John Doe", body: "Lorem Ipsum" },
	 *          { date: "2015-10-02", author: "Jane Doe", body: "Sic dolor amet" }
	 *        ]
	 *     }
	 *
	 *     let commentsField = new EmbeddedListField('comments')
	 *        .targetFields([
	 *          new DateField('date'),
	 *          new StringField('author'),
	 *          new StringField('body')
	 *        ])
	 */
	
	var EmbeddedListField = function (_Field) {
	    function EmbeddedListField(name) {
	        _classCallCheck(this, EmbeddedListField);
	
	        _get(Object.getPrototypeOf(EmbeddedListField.prototype), "constructor", this).call(this, name);
	        this._type = "embedded_list";
	        this._flattenable = false;
	        this._targetEntity = new _EntityEntity2["default"](); // link to an empty entity by default
	        this._targetFields = [];
	        this._sortField = null;
	        this._sortDir = null;
	        this._permanentFilters = null;
	        this._listActions = [];
	    }
	
	    _inherits(EmbeddedListField, _Field);
	
	    _createClass(EmbeddedListField, [{
	        key: "targetEntity",
	
	        /**
	         * Optionally set the target Entity
	         *
	         * Useful if the embedded entries can be edited in standalone
	         */
	        value: function targetEntity(entity) {
	            if (!arguments.length) {
	                return this._targetEntity;
	            }
	            this._targetEntity = entity;
	
	            return this;
	        }
	    }, {
	        key: "targetFields",
	
	        /**
	         * List the fields to map in the embedded entries
	         *
	         * @example
	         *
	         *     embeddedListField.targetFields([
	         *       new DateField('date'),
	         *       new StringField('author'),
	         *       new StringField('body')
	         *     ])
	         */
	        value: function targetFields(value) {
	            if (!arguments.length) return this._targetFields;
	            this._targetFields = value;
	
	            return this;
	        }
	    }, {
	        key: "sortField",
	
	        /**
	         * Name of the field used for sorting.
	         *
	         * @param string
	         */
	        value: function sortField() {
	            if (arguments.length) {
	                this._sortField = arguments[0];
	                return this;
	            }
	
	            return this._sortField ? this._sortField : this.targetEntity().identifier().name();
	        }
	    }, {
	        key: "sortDir",
	
	        /**
	         * Direction used for sorting.
	         *
	         * @param String either 'ASC' or 'DESC'
	         */
	        value: function sortDir() {
	            if (arguments.length) {
	                this._sortDir = arguments[0];
	                return this;
	            }
	
	            return this._sortDir;
	        }
	    }, {
	        key: "listActions",
	        value: function listActions(actions) {
	            if (!arguments.length) {
	                return this._listActions;
	            }
	
	            this._listActions = actions;
	
	            return this;
	        }
	    }, {
	        key: "permanentFilters",
	
	        /**
	         * Define permanent filters to be added to the REST API calls
	         *
	         *     nga.field('post_id', 'reference').permanentFilters({
	         *        published: true
	         *     });
	         *     // related API call will be /posts/:id?published=true
	         *
	         * @param {Object} filters list of filters to apply to the call
	         */
	        value: function permanentFilters(filters) {
	            if (!arguments.length) {
	                return this._permanentFilters;
	            }
	
	            this._permanentFilters = filters;
	
	            return this;
	        }
	    }]);
	
	    return EmbeddedListField;
	}(_Field3["default"]);
	
	exports["default"] = EmbeddedListField;
	module.exports = exports["default"];
	//# sourceMappingURL=EmbeddedListField.js.map

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var FileField = function (_Field) {
	    function FileField(name) {
	        _classCallCheck(this, FileField);
	
	        _get(Object.getPrototypeOf(FileField.prototype), "constructor", this).call(this, name);
	        this._type = "file";
	        this._uploadInformation = {
	            url: "/upload",
	            accept: "*"
	        };
	    }
	
	    _inherits(FileField, _Field);
	
	    _createClass(FileField, [{
	        key: "uploadInformation",
	        value: function uploadInformation(information) {
	            if (!arguments.length) return this._uploadInformation;
	            this._uploadInformation = information;
	            return this;
	        }
	    }]);
	
	    return FileField;
	}(_Field3["default"]);
	
	exports["default"] = FileField;
	module.exports = exports["default"];
	//# sourceMappingURL=FileField.js.map

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _NumberField2 = __webpack_require__(129);
	
	var _NumberField3 = _interopRequireDefault(_NumberField2);
	
	var FloatField = function (_NumberField) {
	    function FloatField(name) {
	        _classCallCheck(this, FloatField);
	
	        _get(Object.getPrototypeOf(FloatField.prototype), 'constructor', this).call(this, name);
	        this._type = 'float';
	        this._format = '0.000';
	    }
	
	    _inherits(FloatField, _NumberField);
	
	    return FloatField;
	}(_NumberField3['default']);
	
	exports['default'] = FloatField;
	module.exports = exports['default'];
	//# sourceMappingURL=FloatField.js.map

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var JsonField = function (_Field) {
	    function JsonField(name) {
	        _classCallCheck(this, JsonField);
	
	        _get(Object.getPrototypeOf(JsonField.prototype), "constructor", this).call(this, name);
	        this._type = "json";
	        this._flattenable = false;
	    }
	
	    _inherits(JsonField, _Field);
	
	    return JsonField;
	}(_Field3["default"]);
	
	exports["default"] = JsonField;
	module.exports = exports["default"];
	//# sourceMappingURL=JsonField.js.map

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var PasswordField = function (_Field) {
	    function PasswordField(name) {
	        _classCallCheck(this, PasswordField);
	
	        _get(Object.getPrototypeOf(PasswordField.prototype), "constructor", this).call(this, name);
	        this._type = "password";
	    }
	
	    _inherits(PasswordField, _Field);
	
	    return PasswordField;
	}(_Field3["default"]);
	
	exports["default"] = PasswordField;
	module.exports = exports["default"];
	//# sourceMappingURL=PasswordField.js.map

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _ReferenceField2 = __webpack_require__(29);
	
	var _ReferenceField3 = _interopRequireDefault(_ReferenceField2);
	
	var ReferenceManyField = function (_ReferenceField) {
	    function ReferenceManyField(name) {
	        _classCallCheck(this, ReferenceManyField);
	
	        _get(Object.getPrototypeOf(ReferenceManyField.prototype), "constructor", this).call(this, name);
	        this._type = "reference_many";
	    }
	
	    _inherits(ReferenceManyField, _ReferenceField);
	
	    return ReferenceManyField;
	}(_ReferenceField3["default"]);
	
	exports["default"] = ReferenceManyField;
	module.exports = exports["default"];
	//# sourceMappingURL=ReferenceManyField.js.map

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _ReferenceField2 = __webpack_require__(29);
	
	var _ReferenceField3 = _interopRequireDefault(_ReferenceField2);
	
	var _UtilsReferenceExtractor = __webpack_require__(30);
	
	var _UtilsReferenceExtractor2 = _interopRequireDefault(_UtilsReferenceExtractor);
	
	var ReferencedListField = function (_ReferenceField) {
	    function ReferencedListField(name) {
	        _classCallCheck(this, ReferencedListField);
	
	        _get(Object.getPrototypeOf(ReferencedListField.prototype), 'constructor', this).call(this, name);
	        this._type = 'referenced_list';
	        this._targetReferenceField = null;
	        this._targetFields = [];
	        this._detailLink = false;
	        this._listActions = [];
	        this._entryCssClasses = null;
	    }
	
	    _inherits(ReferencedListField, _ReferenceField);
	
	    _createClass(ReferencedListField, [{
	        key: 'targetReferenceField',
	        value: function targetReferenceField(value) {
	            if (!arguments.length) return this._targetReferenceField;
	            this._targetReferenceField = value;
	            return this;
	        }
	    }, {
	        key: 'targetFields',
	        value: function targetFields(value) {
	            if (!arguments.length) return this._targetFields;
	            this._targetFields = value;
	
	            return this;
	        }
	    }, {
	        key: 'getGridColumns',
	        value: function getGridColumns() {
	            var columns = [];
	            for (var i = 0, l = this._targetFields.length; i < l; i++) {
	                var field = this._targetFields[i];
	                columns.push({
	                    field: field,
	                    label: field.label()
	                });
	            }
	
	            return columns;
	        }
	    }, {
	        key: 'getSortFieldName',
	        value: function getSortFieldName() {
	            if (!this.sortField()) {
	                return null;
	            }
	
	            return this._targetEntity.name() + '_ListView.' + this.sortField();
	        }
	    }, {
	        key: 'listActions',
	        value: function listActions(actions) {
	            if (!arguments.length) {
	                return this._listActions;
	            }
	
	            this._listActions = actions;
	
	            return this;
	        }
	    }, {
	        key: 'entryCssClasses',
	        value: function entryCssClasses(classes) {
	            if (!arguments.length) {
	                return this._entryCssClasses;
	            }
	
	            this._entryCssClasses = classes;
	
	            return this;
	        }
	    }, {
	        key: 'getReferences',
	        value: function getReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getReferences(this._targetFields, withRemoteComplete);
	        }
	    }, {
	        key: 'getNonOptimizedReferences',
	        value: function getNonOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getNonOptimizedReferences(this._targetFields, withRemoteComplete);
	        }
	    }, {
	        key: 'getOptimizedReferences',
	        value: function getOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getOptimizedReferences(this._targetFields, withRemoteComplete);
	        }
	    }]);
	
	    return ReferencedListField;
	}(_ReferenceField3['default']);
	
	exports['default'] = ReferencedListField;
	module.exports = exports['default'];
	//# sourceMappingURL=ReferencedListField.js.map

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var TemplateField = function (_Field) {
	    function TemplateField(name) {
	        _classCallCheck(this, TemplateField);
	
	        _get(Object.getPrototypeOf(TemplateField.prototype), "constructor", this).call(this, name);
	        this._type = "template";
	        this._flattenable = false;
	    }
	
	    _inherits(TemplateField, _Field);
	
	    return TemplateField;
	}(_Field3["default"]);
	
	exports["default"] = TemplateField;
	module.exports = exports["default"];
	//# sourceMappingURL=TemplateField.js.map

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var TextField = function (_Field) {
	    function TextField(name) {
	        _classCallCheck(this, TextField);
	
	        _get(Object.getPrototypeOf(TextField.prototype), "constructor", this).call(this, name);
	        this._type = "text";
	    }
	
	    _inherits(TextField, _Field);
	
	    return TextField;
	}(_Field3["default"]);
	
	exports["default"] = TextField;
	module.exports = exports["default"];
	//# sourceMappingURL=TextField.js.map

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var WysiwygField = function (_Field) {
	    function WysiwygField(name) {
	        _classCallCheck(this, WysiwygField);
	
	        _get(Object.getPrototypeOf(WysiwygField.prototype), "constructor", this).call(this, name);
	        this._type = "wysiwyg";
	        this._stripTags = false;
	        this._sanitize = true;
	    }
	
	    _inherits(WysiwygField, _Field);
	
	    _createClass(WysiwygField, [{
	        key: "stripTags",
	        value: function stripTags(value) {
	            if (!arguments.length) return this._stripTags;
	            this._stripTags = value;
	            return this;
	        }
	    }, {
	        key: "sanitize",
	        value: function sanitize(value) {
	            if (!arguments.length) return this._sanitize;
	            this._sanitize = value;
	            return this;
	        }
	    }]);
	
	    return WysiwygField;
	}(_Field3["default"]);
	
	exports["default"] = WysiwygField;
	module.exports = exports["default"];
	//# sourceMappingURL=WysiwygField.js.map

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _Queries2 = __webpack_require__(131);
	
	var _Queries3 = _interopRequireDefault(_Queries2);
	
	var _UtilsReferenceExtractor = __webpack_require__(30);
	
	var _UtilsReferenceExtractor2 = _interopRequireDefault(_UtilsReferenceExtractor);
	
	var ReadQueries = function (_Queries) {
	    function ReadQueries() {
	        _classCallCheck(this, ReadQueries);
	
	        if (_Queries != null) {
	            _Queries.apply(this, arguments);
	        }
	    }
	
	    _inherits(ReadQueries, _Queries);
	
	    _createClass(ReadQueries, [{
	        key: 'getOne',
	
	        /**
	         * Get one entity
	         *
	         * @param {Entity}   entity
	         * @param {String}   viewType
	         * @param {mixed}    identifierValue
	         * @param {String}   identifierName
	         * @param {String}   url
	         *
	         * @returns {promise} (list of fields (with their values if set) & the entity name, label & id-
	         */
	        value: function getOne(entity, viewType, identifierValue, identifierName, url) {
	            return this._restWrapper.getOne(entity.name(), this._application.getRouteFor(entity, url, viewType, identifierValue, identifierName), entity.retrieveMethod());
	        }
	    }, {
	        key: 'getAll',
	
	        /**
	         * Return the list of all object of entityName type
	         * Get all the object from the API
	         *
	         * @param {ListView} view                the view associated to the entity
	         * @param {Number}   page                the page number
	         * @param {Object}   filterValues        searchQuery to filter elements
	         * @param {String}   sortField           the field to be sorted ex: entity.fieldName
	         * @param {String}   sortDir             the direction of the sort
	         *
	         * @returns {promise} the entity config & the list of objects
	         */
	        value: function getAll(view, page, filterValues, sortField, sortDir) {
	            page = page || 1;
	            filterValues = filterValues || {};
	            var url = view.getUrl();
	
	            if (sortField && sortField.split('.')[0] === view.name()) {
	                sortField = sortField;
	                sortDir = sortDir;
	            } else {
	                sortField = view.getSortFieldName();
	                sortDir = view.sortDir();
	            }
	
	            var allFilterValues = {};
	            var permanentFilters = view.permanentFilters();
	            Object.keys(filterValues).forEach(function (key) {
	                allFilterValues[key] = filterValues[key];
	            });
	            Object.keys(permanentFilters).forEach(function (key) {
	                allFilterValues[key] = permanentFilters[key];
	            });
	
	            return this.getRawValues(view.entity, view.name(), view.type, page, view.perPage(), allFilterValues, view.filters(), sortField, sortDir, url).then(function (values) {
	                return {
	                    data: values.data,
	                    totalItems: values.totalCount || values.headers('X-Total-Count') || values.data.length
	                };
	            });
	        }
	    }, {
	        key: 'getRawValues',
	
	        /**
	         * Return the list of all object of entityName type
	         * Get all the object from the API
	         *
	         * @param {Entity}   entity
	         * @param {String}   viewName
	         * @param {String}   viewType
	         * @param {Number}   page
	         * @param {Number}   perPage
	         * @param {Object}   filterValues
	         * @param {Object}   filterFields
	         * @param {String}   sortField
	         * @param {String}   sortDir
	         * @param {String}   url
	         *
	         * @returns {promise} the entity config & the list of objects
	         */
	        value: function getRawValues(entity, viewName, viewType, page, perPage, filterValues, filterFields, sortField, sortDir, url) {
	            var params = {};
	
	            // Compute pagination
	            if (page !== -1) {
	                params._page = typeof page === 'undefined' ? 1 : parseInt(page, 10);
	                params._perPage = perPage;
	            }
	
	            // Compute sorting
	            if (sortField && sortField.split('.')[0] === viewName) {
	                params._sortField = sortField.substr(sortField.indexOf('.') + 1);
	                params._sortDir = sortDir;
	            }
	
	            // Compute filtering
	            if (filterValues && Object.keys(filterValues).length !== 0) {
	                (function () {
	                    params._filters = {};
	                    var filterName = undefined,
	                        mappedValue = undefined;
	                    for (filterName in filterValues) {
	                        if (filterFields.hasOwnProperty(filterName) && filterFields[filterName].hasMaps()) {
	                            mappedValue = filterFields[filterName].getMappedValue(filterValues[filterName]);
	                            Object.keys(mappedValue).forEach(function (key) {
	                                params._filters[key] = mappedValue[key];
	                            });
	                            continue;
	                        }
	
	                        // It's weird to not map, but why not.
	                        params._filters[filterName] = filterValues[filterName];
	                    }
	                })();
	            }
	
	            // Get grid data
	            return this._restWrapper.getList(params, entity.name(), this._application.getRouteFor(entity, url, viewType), entity.retrieveMethod());
	        }
	    }, {
	        key: 'getReferenceData',
	        value: function getReferenceData(references, rawValues) {
	            var nonOptimizedReferencedData = this.getFilteredReferenceData(_UtilsReferenceExtractor2['default'].getNonOptimizedReferences(references), rawValues);
	            var optimizedReferencedData = this.getOptimizedReferenceData(_UtilsReferenceExtractor2['default'].getOptimizedReferences(references), rawValues);
	            return Promise.all([nonOptimizedReferencedData, optimizedReferencedData]).then(function (results) {
	                var data = {};
	                var name = undefined;
	                for (name in results[0]) {
	                    data[name] = results[0][name];
	                }
	                for (name in results[1]) {
	                    data[name] = results[1][name];
	                }
	                return data;
	            });
	        }
	    }, {
	        key: 'getFilteredReferenceData',
	
	        /**
	         * Returns all References for an entity with associated values [{targetEntity.identifier: targetLabel}, ...]
	         * by calling the API for each entries
	         *
	         * @param {ReferenceField} references A hash of Reference and ReferenceMany objects
	         * @param {Array} rawValues
	         *
	         * @returns {Promise}
	         */
	        value: function getFilteredReferenceData(references, rawValues) {
	            if (!references || !Object.keys(references).length) {
	                return this._promisesResolver.empty({});
	            }
	
	            var getOne = this.getOne.bind(this),
	                calls = [];
	
	            for (var i in references) {
	                var reference = references[i],
	                    targetEntity = reference.targetEntity(),
	                    identifiers = reference.getIdentifierValues(rawValues);
	
	                for (var k in identifiers) {
	                    calls.push(getOne(targetEntity, 'listView', identifiers[k], reference.name()));
	                }
	            }
	
	            return this.fillFilteredReferencedData(calls, references, rawValues);
	        }
	    }, {
	        key: 'getOptimizedReferenceData',
	
	        /**
	         * Returns all References for an entity with associated values [{targetEntity.identifier: targetLabel}, ...]
	         * by calling the API once
	         *
	         * @param {[ReferenceField]} references A hash of Reference and ReferenceMany objects
	         * @param {Array} rawValues
	         *
	         * @returns {Promise}
	         */
	        value: function getOptimizedReferenceData(references, rawValues) {
	            if (!references || !Object.keys(references).length) {
	                return this._promisesResolver.empty({});
	            }
	
	            var getRawValues = this.getRawValues.bind(this),
	                calls = [];
	
	            for (var i in references) {
	                var reference = references[i],
	                    targetEntity = reference.targetEntity(),
	                    identifiers = reference.getIdentifierValues(rawValues);
	
	                // Check if we should retrieve values with 1 or multiple requests
	                var singleCallFilters = reference.getSingleApiCall(identifiers);
	                calls.push(getRawValues(targetEntity, targetEntity.name() + '_ListView', 'listView', 1, reference.perPage(), singleCallFilters, {}, reference.sortField(), reference.sortDir()));
	            }
	
	            return this.fillOptimizedReferencedData(calls, references);
	        }
	    }, {
	        key: 'getAllReferencedData',
	
	        /**
	         * Returns all References for an entity with associated values [{targetEntity.identifier: targetLabel}, ...]
	         * without filters on an entity
	         *
	         * @param {[ReferenceField]} references A hash of Reference and ReferenceMany objects
	         *
	         * @returns {Promise}
	         */
	        value: function getAllReferencedData(references, search) {
	            if (!references || !Object.keys(references).length) {
	                return this._promisesResolver.empty({});
	            }
	
	            var calls = [],
	                getRawValues = this.getRawValues.bind(this);
	
	            var _loop = function _loop(i) {
	                var reference = references[i];
	                var targetEntity = reference.targetEntity();
	
	                var permanentFilters = reference.permanentFilters();
	                var filterValues = permanentFilters || {};
	
	                if (typeof permanentFilters === 'function') {
	                    console.warn('Reference.permanentFilters() called with a function is deprecated. Use the searchQuery option for remoteComplete() instead');
	                    filterValues = permanentFilters(search);
	                }
	
	                if (search) {
	                    // remote complete situation
	                    var options = reference.remoteCompleteOptions();
	                    if (options.searchQuery) {
	                        (function () {
	                            var filterValuesFromRemoteComplete = options.searchQuery(search);
	                            Object.keys(filterValuesFromRemoteComplete).forEach(function (key) {
	                                filterValues[key] = filterValuesFromRemoteComplete[key];
	                            });
	                        })();
	                    } else {
	                        // by default, filter the list by the referenceField name
	                        filterValues[reference.targetField().name()] = search;
	                    }
	                }
	
	                var filterFields = {};
	                filterFields[reference.name()] = reference;
	
	                calls.push(getRawValues(targetEntity, targetEntity.name() + '_ListView', 'listView', 1, reference.perPage(), filterValues, filterFields, reference.getSortFieldName(), reference.sortDir()));
	            };
	
	            for (var i in references) {
	                _loop(i);
	            }
	
	            return this.fillOptimizedReferencedData(calls, references);
	        }
	    }, {
	        key: 'fillOptimizedReferencedData',
	
	        /**
	         * Fill all reference entries to return [{targetEntity.identifier: targetLabel}, ...]
	         *
	         * @param {[Promise]} apiCalls
	         * @param {[Reference]} references
	         * @returns {Promise}
	         */
	        value: function fillOptimizedReferencedData(apiCalls, references) {
	            return this._promisesResolver.allEvenFailed(apiCalls).then(function (responses) {
	                if (responses.length === 0) {
	                    return {};
	                }
	
	                var referencedData = {},
	                    i = 0;
	
	                for (var j in references) {
	                    var reference = references[j],
	                        response = responses[i++];
	
	                    // Retrieve entries depending on 1 or many request was done
	                    if (response.status == 'error') {
	                        // the response failed
	                        continue;
	                    }
	
	                    referencedData[reference.name()] = response.result.data;
	                }
	
	                return referencedData;
	            });
	        }
	    }, {
	        key: 'fillFilteredReferencedData',
	
	        /**
	         * Fill all reference entries to return [{targetEntity.identifier: targetLabel}, ...]
	         *
	         * @param {[Promise]} apiCalls
	         * @param {[Reference]} references
	         * @param {[Object]} rawValues
	         * @returns {Promise}
	         */
	        value: function fillFilteredReferencedData(apiCalls, references, rawValues) {
	            return this._promisesResolver.allEvenFailed(apiCalls).then(function (responses) {
	                if (responses.length === 0) {
	                    return {};
	                }
	
	                var referencedData = {},
	                    response = undefined,
	                    i = 0;
	
	                for (var j in references) {
	                    var data = [],
	                        reference = references[j],
	                        identifiers = reference.getIdentifierValues(rawValues);
	
	                    for (var k in identifiers) {
	                        response = responses[i++];
	                        if (response.status == 'error') {
	                            // one of the responses failed
	                            continue;
	                        }
	                        data.push(response.result);
	                    }
	
	                    if (!data.length) {
	                        continue;
	                    }
	
	                    referencedData[reference.name()] = data;
	                }
	
	                return referencedData;
	            });
	        }
	    }, {
	        key: 'getReferencedListData',
	
	        /**
	         * Returns all ReferencedList for an entity for associated values [{targetEntity.identifier: [targetFields, ...]}}
	         *
	         * @param {View}   referencedLists
	         * @param {String} sortField
	         * @param {String} sortDir
	         * @param {*} entityId
	         *
	         * @returns {promise}
	         */
	        value: function getReferencedListData(referencedLists, sortField, sortDir, entityId) {
	            var getRawValues = this.getRawValues.bind(this),
	                calls = [];
	
	            var _loop2 = function _loop2(i) {
	                var referencedList = referencedLists[i],
	                    targetEntity = referencedList.targetEntity(),
	                    viewName = referencedList.datagridName(),
	                    currentSortField = referencedList.getSortFieldName(),
	                    currentSortDir = referencedList.sortDir(),
	                    filter = {};
	
	                if (sortField && sortField.split('.')[0] === viewName) {
	                    currentSortField = sortField;
	                    currentSortDir = sortDir || 'ASC';
	                }
	
	                var permanentFilters = referencedList.permanentFilters() || {};
	                Object.keys(permanentFilters).forEach(function (key) {
	                    filter[key] = permanentFilters[key];
	                });
	                filter[referencedList.targetReferenceField()] = entityId;
	
	                calls.push(getRawValues(targetEntity, viewName, 'listView', 1, referencedList.perPage(), filter, {}, currentSortField, currentSortDir));
	            };
	
	            for (var i in referencedLists) {
	                _loop2(i);
	            }
	
	            return this._promisesResolver.allEvenFailed(calls).then(function (responses) {
	                var j = 0,
	                    entries = {};
	
	                for (var i in referencedLists) {
	                    var response = responses[j++];
	                    if (response.status == 'error') {
	                        // If a response fail, skip it
	                        continue;
	                    }
	
	                    entries[i] = response.result.data;
	                }
	
	                return entries;
	            });
	        }
	    }, {
	        key: 'getRecordsByIds',
	        value: function getRecordsByIds(entity, ids) {
	            var _this = this;
	
	            if (!ids || !ids.length) {
	                return this._promisesResolver.empty();
	            }
	
	            var calls = ids.map(function (id) {
	                return _this.getOne(entity, 'listView', id, entity.identifier().name());
	            });
	
	            return this._promisesResolver.allEvenFailed(calls).then(function (responses) {
	                return responses.filter(function (r) {
	                    return r.status != 'error';
	                }).map(function (r) {
	                    return r.result;
	                });
	            });
	        }
	    }]);
	
	    return ReadQueries;
	}(_Queries3['default']);
	
	exports['default'] = ReadQueries;
	module.exports = exports['default'];
	//# sourceMappingURL=ReadQueries.js.map

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _Queries2 = __webpack_require__(131);
	
	var _Queries3 = _interopRequireDefault(_Queries2);
	
	var WriteQueries = function (_Queries) {
	    function WriteQueries() {
	        _classCallCheck(this, WriteQueries);
	
	        if (_Queries != null) {
	            _Queries.apply(this, arguments);
	        }
	    }
	
	    _inherits(WriteQueries, _Queries);
	
	    _createClass(WriteQueries, [{
	        key: 'createOne',
	
	        /**
	         * Create a new entity
	         * Post the data to the API to create the new object
	         *
	         * @param {View}   view      the formView related to the entity
	         * @param {Object} rawEntity the entity's object
	         *
	         * @returns {promise}  the new object
	         */
	        value: function createOne(view, rawEntity) {
	            return this._restWrapper.createOne(rawEntity, view.entity.name(), this._application.getRouteFor(view.entity, view.getUrl(), view.type), view.entity.createMethod());
	        }
	    }, {
	        key: 'updateOne',
	
	        /**
	         * Update an entity
	         * Put the data to the API to create the new object
	         *
	         * @param {View}   view             the formView related to the entity
	         * @param {Object} rawEntity        the entity's object
	         * @param {String} originEntityId   if entity identifier is modified
	         *
	         * @returns {promise} the updated object
	         */
	        value: function updateOne(view, rawEntity, originEntityId) {
	            var entityId = originEntityId || rawEntity[view.entity.identifier().name()];
	
	            // Update element data
	            return this._restWrapper.updateOne(rawEntity, view.entity.name(), this._application.getRouteFor(view.entity, view.getUrl(entityId), view.type, entityId, view.identifier()), view.entity.updateMethod());
	        }
	    }, {
	        key: 'deleteOne',
	
	        /**
	         * Delete an entity
	         * Delete the data to the API
	         *
	         * @param {String} view     the formView related to the entity
	         * @param {*}      entityId the entity's id
	         *
	         * @returns {promise}
	         */
	        value: function deleteOne(view, entityId) {
	            return this._restWrapper.deleteOne(view.entity.name(), this._application.getRouteFor(view.entity, view.getUrl(entityId), view.type, entityId, view.identifier()), view.entity.deleteMethod());
	        }
	    }, {
	        key: 'batchDelete',
	
	        /**
	         * Delete a batch of entity
	         * Delete the data to the API
	         *
	         * @param {String} view     the formView related to the entity
	         * @param {*}      entityIds the entities ids
	         *
	         * @returns {promise}
	         */
	        value: function batchDelete(view, entityIds) {
	            var deleteOne = this.deleteOne.bind(this);
	            var promises = entityIds.map(function (id) {
	                return deleteOne(view, id);
	            });
	
	            return this._promisesResolver.allEvenFailed(promises);
	        }
	    }]);
	
	    return WriteQueries;
	}(_Queries3['default']);
	
	exports['default'] = WriteQueries;
	module.exports = exports['default'];
	//# sourceMappingURL=WriteQueries.js.map

/***/ },
/* 314 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	var PromisesResolver = function () {
	    function PromisesResolver() {
	        _classCallCheck(this, PromisesResolver);
	    }
	
	    _createClass(PromisesResolver, null, [{
	        key: 'empty',
	        value: function empty(value) {
	            return new Promise(function (resolve) {
	                resolve(value);
	            });
	        }
	    }, {
	        key: 'allEvenFailed',
	        value: function allEvenFailed(promises) {
	            if (!Array.isArray(promises)) {
	                throw Error('allEvenFailed can only handle an array of promises');
	            }
	
	            return new Promise(function (resolve, reject) {
	                if (promises.length === 0) {
	                    return resolve([]);
	                }
	
	                var states = [],
	                    results = [];
	
	                promises.forEach(function (promise, key) {
	                    states[key] = false; // promises are not resolved by default
	                });
	
	                promises.forEach(function (promise, key) {
	                    function resolveState(result) {
	                        states[key] = true;
	                        results[key] = result; // result may be an error
	                        for (var i in states) {
	                            if (!states[i]) {
	                                return;
	                            }
	                        }
	
	                        resolve(results);
	                    }
	
	                    function resolveSuccess(result) {
	                        return resolveState({ status: 'success', result: result });
	                    }
	
	                    function resolveError(result) {
	                        return resolveState({ status: 'error', error: result });
	                    }
	
	                    // whether the promise ends with success or error, consider it done
	                    promise.then(resolveSuccess, resolveError);
	                });
	            });
	        }
	    }]);
	
	    return PromisesResolver;
	}();
	
	exports['default'] = PromisesResolver;
	module.exports = exports['default'];
	//# sourceMappingURL=PromisesResolver.js.map

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _View2 = __webpack_require__(9);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var BatchDeleteView = function (_View) {
	    function BatchDeleteView(name) {
	        _classCallCheck(this, BatchDeleteView);
	
	        _get(Object.getPrototypeOf(BatchDeleteView.prototype), 'constructor', this).call(this, name);
	
	        this._type = 'BatchDeleteView';
	        this._enabled = true;
	    }
	
	    _inherits(BatchDeleteView, _View);
	
	    return BatchDeleteView;
	}(_View3['default']);
	
	exports['default'] = BatchDeleteView;
	module.exports = exports['default'];
	//# sourceMappingURL=BatchDeleteView.js.map

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _View2 = __webpack_require__(9);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var CreateView = function (_View) {
	    function CreateView(name) {
	        _classCallCheck(this, CreateView);
	
	        _get(Object.getPrototypeOf(CreateView.prototype), 'constructor', this).call(this, name);
	        this._type = 'CreateView';
	        this._submitCreationSuccess = null;
	        this._submitCreationError = null;
	    }
	
	    _inherits(CreateView, _View);
	
	    _createClass(CreateView, [{
	        key: 'onSubmitSuccess',
	
	        /**
	         * Add a function to be executed after the creation succeeds.
	         *
	         * This is the ideal place to use the response to update the entry, or
	         * redirect to another view.
	         *
	         * If the function returns false, the default execution workflow is stopped.
	         * This means that the function must provide a custom workflow.
	         *
	         * If the function throws an exception, the onSubmitError callback will
	         * execute.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - $event: the form submission event
	         *  - entry: the current Entry instance
	         *  - entity: the current entity
	         *  - form: the form object (for form validation and errors)
	         *  - progression: the controller for the loading indicator
	         *  - notification: the controller for top notifications
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.creationView().onSubmitSuccess(['progression', 'notification', '$state', 'entry', 'entity', function(progression, notification, $state, entry, entity) {
	         *         // stop the progress bar
	         *         progression.done();
	         *         // add a notification
	         *         notification.log(`Element #${entry._identifierValue} successfully created.`, { addnCls: 'humane-flatty-success' });
	         *         // redirect to the list view
	         *         $state.go($state.get('list'), { entity: entity.name() });
	         *         // cancel the default action (redirect to the edition view)
	         *         return false;
	         *      }])
	         *
	         */
	        value: function onSubmitSuccess(_onSubmitSuccess) {
	            if (!arguments.length) return this._onSubmitSuccess;
	            this._onSubmitSuccess = _onSubmitSuccess;
	            return this;
	        }
	    }, {
	        key: 'onSubmitError',
	
	        /**
	         * Add a function to be executed after the creation request receives a
	         * failed http response from the server.
	         *
	         * This is the ideal place to use the response to update the entry, display
	         * server-side validation error, or redirect to another view.
	         *
	         * If the function returns false, the default execution workflow is stopped.
	         * This means that the function must provide a custom workflow.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - $event: the form submission event
	         *  - error: the response from the server
	         *  - errorMessage: the error message based on the response
	         *  - entry: the current Entry instance
	         *  - entity: the current entity
	         *  - form: the form object (for form validation and errors)
	         *  - progression: the controller for the loading indicator
	         *  - notification: the controller for top notifications
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.creationView().onSubmitError(['error', 'form', 'progression', 'notification', function(error, form, progression, notification) {
	         *         // mark fields based on errors from the response
	         *         error.violations.forEach(violation => {
	         *             if (form[violation.propertyPath]) {
	         *                 form[violation.propertyPath].$valid = false;
	         *             }
	         *         });
	         *         // stop the progress bar
	         *         progression.done();
	         *         // add a notification
	         *         notification.log(`Some values are invalid, see details in the form`, { addnCls: 'humane-flatty-error' });
	         *         // cancel the default action (default error messages)
	         *         return false;
	         *     }]);
	         */
	        value: function onSubmitError(_onSubmitError) {
	            if (!arguments.length) return this._onSubmitError;
	            this._onSubmitError = _onSubmitError;
	            return this;
	        }
	    }]);
	
	    return CreateView;
	}(_View3['default']);
	
	exports['default'] = CreateView;
	module.exports = exports['default'];
	//# sourceMappingURL=CreateView.js.map

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _ListView2 = __webpack_require__(17);
	
	var _ListView3 = _interopRequireDefault(_ListView2);
	
	var DashboardView = function (_ListView) {
	    function DashboardView() {
	        _classCallCheck(this, DashboardView);
	
	        if (_ListView != null) {
	            _ListView.apply(this, arguments);
	        }
	    }
	
	    _inherits(DashboardView, _ListView);
	
	    _createClass(DashboardView, [{
	        key: 'setEntity',
	        value: function setEntity(entity) {
	            this.entity = entity;
	            if (!this._name) {
	                this._name = entity.name();
	            }
	            return this;
	        }
	    }]);
	
	    return DashboardView;
	}(_ListView3['default']);
	
	exports['default'] = DashboardView;
	module.exports = exports['default'];
	//# sourceMappingURL=DashboardView.js.map

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _View2 = __webpack_require__(9);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var DeleteView = function (_View) {
	    function DeleteView(name) {
	        _classCallCheck(this, DeleteView);
	
	        _get(Object.getPrototypeOf(DeleteView.prototype), 'constructor', this).call(this, name);
	        this._type = 'DeleteView';
	        this._enabled = true;
	    }
	
	    _inherits(DeleteView, _View);
	
	    return DeleteView;
	}(_View3['default']);
	
	exports['default'] = DeleteView;
	module.exports = exports['default'];
	//# sourceMappingURL=DeleteView.js.map

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _View2 = __webpack_require__(9);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var EditView = function (_View) {
	    function EditView(name) {
	        _classCallCheck(this, EditView);
	
	        _get(Object.getPrototypeOf(EditView.prototype), 'constructor', this).call(this, name);
	        this._type = 'EditView';
	        this._submitCreationSuccess = null;
	        this._submitCreationError = null;
	    }
	
	    _inherits(EditView, _View);
	
	    _createClass(EditView, [{
	        key: 'onSubmitSuccess',
	
	        /**
	         * Add a function to be executed after the update succeeds.
	         *
	         * This is the ideal place to use the response to update the entry, or
	         * redirect to another view.
	         *
	         * If the function returns false, the default execution workflow is stopped.
	         * This means that the function must provide a custom workflow.
	         *
	         * If the function throws an exception, the onSubmitError callback will
	         * execute.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - $event: the form submission event
	         *  - entry: the current Entry instance
	         *  - entity: the current entity
	         *  - form: the form object (for form validation and errors)
	         *  - progression: the controller for the loading indicator
	         *  - notification: the controller for top notifications
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.editionView().onSubmitSuccess(['progression', 'notification', '$state', 'entry', 'entity', function(progression, notification, $state, entry, entity) {
	         *         // stop the progress bar
	         *         progression.done();
	         *         // add a notification
	         *         notification.log(`Element #${entry._identifierValue} successfully edited.`, { addnCls: 'humane-flatty-success' });
	         *         // redirect to the list view
	         *         $state.go($state.get('list'), { entity: entity.name() });
	         *         // cancel the default action (redirect to the edition view)
	         *         return false;
	         *      }])
	         */
	        value: function onSubmitSuccess(_onSubmitSuccess) {
	            if (!arguments.length) return this._onSubmitSuccess;
	            this._onSubmitSuccess = _onSubmitSuccess;
	            return this;
	        }
	    }, {
	        key: 'onSubmitError',
	
	        /**
	         * Add a function to be executed after the update request receives a failed
	         * http response from the server.
	         *
	         * This is the ideal place to use the response to update the entry, display
	         * server-side validation error, or redirect to another view.
	         *
	         * If the function returns false, the default execution workflow is stopped.
	         * This means that the function must provide a custom workflow.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - $event: the form submission event
	         *  - error: the response from the server
	         *  - errorMessage: the error message based on the response
	         *  - entry: the current Entry instance
	         *  - entity: the current entity
	         *  - form: the form object (for form validation and errors)
	         *  - progression: the controller for the loading indicator
	         *  - notification: the controller for top notifications
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.editionView().onSubmitError(['error', 'form', 'progression', 'notification', function(error, form, progression, notification) {
	         *         // mark fields based on errors from the response
	         *         error.violations.forEach(violation => {
	         *             if (form[violation.propertyPath]) {
	         *                 form[violation.propertyPath].$valid = false;
	         *             }
	         *         });
	         *         // stop the progress bar
	         *         progression.done();
	         *         // add a notification
	         *         notification.log(`Some values are invalid, see details in the form`, { addnCls: 'humane-flatty-error' });
	         *         // cancel the default action (default error messages)
	         *         return false;
	         *     }]);
	         */
	        value: function onSubmitError(_onSubmitError) {
	            if (!arguments.length) return this._onSubmitError;
	            this._onSubmitError = _onSubmitError;
	            return this;
	        }
	    }]);
	
	    return EditView;
	}(_View3['default']);
	
	exports['default'] = EditView;
	module.exports = exports['default'];
	//# sourceMappingURL=EditView.js.map

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _ListView2 = __webpack_require__(17);
	
	var _ListView3 = _interopRequireDefault(_ListView2);
	
	var ExportView = function (_ListView) {
	    function ExportView(name) {
	        _classCallCheck(this, ExportView);
	
	        _get(Object.getPrototypeOf(ExportView.prototype), 'constructor', this).call(this, name);
	        this._fields = [];
	        this._type = 'ExportView';
	    }
	
	    _inherits(ExportView, _ListView);
	
	    return ExportView;
	}(_ListView3['default']);
	
	exports['default'] = ExportView;
	module.exports = exports['default'];
	//# sourceMappingURL=ExportView.js.map

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _View2 = __webpack_require__(9);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var MenuView = function (_View) {
	    function MenuView(name) {
	        _classCallCheck(this, MenuView);
	
	        _get(Object.getPrototypeOf(MenuView.prototype), 'constructor', this).call(this, name);
	        this._type = 'MenuView';
	        this._icon = null;
	    }
	
	    _inherits(MenuView, _View);
	
	    _createClass(MenuView, [{
	        key: 'icon',
	        value: function icon() {
	            if (arguments.length) {
	                console.warn('entity.menuView() is deprecated. Please use the Menu class instead');
	                this._icon = arguments[0];
	                return this;
	            }
	
	            if (this._icon === null) {
	                return '<span class="glyphicon glyphicon-list"></span>';
	            }
	
	            return this._icon;
	        }
	    }, {
	        key: 'enabled',
	        get: function get() {
	            return this._enabled || this.entity.views['ListView'].enabled;
	        }
	    }]);
	
	    return MenuView;
	}(_View3['default']);
	
	exports['default'] = MenuView;
	module.exports = exports['default'];
	//# sourceMappingURL=MenuView.js.map

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;desc = parent = getter = undefined;_again = false;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	}
	
	var _View2 = __webpack_require__(9);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var ShowView = function (_View) {
	    function ShowView(name) {
	        _classCallCheck(this, ShowView);
	
	        _get(Object.getPrototypeOf(ShowView.prototype), 'constructor', this).call(this, name);
	        this._type = 'ShowView';
	    }
	
	    _inherits(ShowView, _View);
	
	    return ShowView;
	}(_View3['default']);
	
	exports['default'] = ShowView;
	module.exports = exports['default'];
	//# sourceMappingURL=ShowView.js.map

/***/ },
/* 323 */
/***/ function(module, exports) {

	'use strict';
	
	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * FileAPI Flash shim for old browsers not supporting FormData
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 7.3.9
	 */
	
	(function () {
	  /** @namespace FileAPI.noContentTimeout */
	
	  function patchXHR(fnName, newFn) {
	    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
	  }
	
	  function redefineProp(xhr, prop, fn) {
	    try {
	      Object.defineProperty(xhr, prop, { get: fn });
	    } catch (e) {/*ignore*/
	    }
	  }
	
	  if (!window.FileAPI) {
	    window.FileAPI = {};
	  }
	
	  FileAPI.shouldLoad = window.XMLHttpRequest && !window.FormData || FileAPI.forceLoad;
	  if (FileAPI.shouldLoad) {
	    var initializeUploadListener = function initializeUploadListener(xhr) {
	      if (!xhr.__listeners) {
	        if (!xhr.upload) xhr.upload = {};
	        xhr.__listeners = [];
	        var origAddEventListener = xhr.upload.addEventListener;
	        xhr.upload.addEventListener = function (t, fn) {
	          xhr.__listeners[t] = fn;
	          if (origAddEventListener) origAddEventListener.apply(this, arguments);
	        };
	      }
	    };
	
	    patchXHR('open', function (orig) {
	      return function (m, url, b) {
	        initializeUploadListener(this);
	        this.__url = url;
	        try {
	          orig.apply(this, [m, url, b]);
	        } catch (e) {
	          if (e.message.indexOf('Access is denied') > -1) {
	            this.__origError = e;
	            orig.apply(this, [m, '_fix_for_ie_crossdomain__', b]);
	          }
	        }
	      };
	    });
	
	    patchXHR('getResponseHeader', function (orig) {
	      return function (h) {
	        return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(h) : orig == null ? null : orig.apply(this, [h]);
	      };
	    });
	
	    patchXHR('getAllResponseHeaders', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : orig == null ? null : orig.apply(this);
	      };
	    });
	
	    patchXHR('abort', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : orig == null ? null : orig.apply(this);
	      };
	    });
	
	    patchXHR('setRequestHeader', function (orig) {
	      return function (header, value) {
	        if (header === '__setXHR_') {
	          initializeUploadListener(this);
	          var val = value(this);
	          // fix for angular < 1.2.0
	          if (val instanceof Function) {
	            val(this);
	          }
	        } else {
	          this.__requestHeaders = this.__requestHeaders || {};
	          this.__requestHeaders[header] = value;
	          orig.apply(this, arguments);
	        }
	      };
	    });
	
	    patchXHR('send', function (orig) {
	      return function () {
	        var xhr = this;
	        if (arguments[0] && arguments[0].__isFileAPIShim) {
	          var formData = arguments[0];
	          var config = {
	            url: xhr.__url,
	            jsonp: false, //removes the callback form param
	            cache: true, //removes the ?fileapiXXX in the url
	            complete: function complete(err, fileApiXHR) {
	              if (err && angular.isString(err) && err.indexOf('#2174') !== -1) {
	                // this error seems to be fine the file is being uploaded properly.
	                err = null;
	              }
	              xhr.__completed = true;
	              if (!err && xhr.__listeners.load) xhr.__listeners.load({
	                type: 'load',
	                loaded: xhr.__loaded,
	                total: xhr.__total,
	                target: xhr,
	                lengthComputable: true
	              });
	              if (!err && xhr.__listeners.loadend) xhr.__listeners.loadend({
	                type: 'loadend',
	                loaded: xhr.__loaded,
	                total: xhr.__total,
	                target: xhr,
	                lengthComputable: true
	              });
	              if (err === 'abort' && xhr.__listeners.abort) xhr.__listeners.abort({
	                type: 'abort',
	                loaded: xhr.__loaded,
	                total: xhr.__total,
	                target: xhr,
	                lengthComputable: true
	              });
	              if (fileApiXHR.status !== undefined) redefineProp(xhr, 'status', function () {
	                return fileApiXHR.status === 0 && err && err !== 'abort' ? 500 : fileApiXHR.status;
	              });
	              if (fileApiXHR.statusText !== undefined) redefineProp(xhr, 'statusText', function () {
	                return fileApiXHR.statusText;
	              });
	              redefineProp(xhr, 'readyState', function () {
	                return 4;
	              });
	              if (fileApiXHR.response !== undefined) redefineProp(xhr, 'response', function () {
	                return fileApiXHR.response;
	              });
	              var resp = fileApiXHR.responseText || (err && fileApiXHR.status === 0 && err !== 'abort' ? err : undefined);
	              redefineProp(xhr, 'responseText', function () {
	                return resp;
	              });
	              redefineProp(xhr, 'response', function () {
	                return resp;
	              });
	              if (err) redefineProp(xhr, 'err', function () {
	                return err;
	              });
	              xhr.__fileApiXHR = fileApiXHR;
	              if (xhr.onreadystatechange) xhr.onreadystatechange();
	              if (xhr.onload) xhr.onload();
	            },
	            progress: function progress(e) {
	              e.target = xhr;
	              if (xhr.__listeners.progress) xhr.__listeners.progress(e);
	              xhr.__total = e.total;
	              xhr.__loaded = e.loaded;
	              if (e.total === e.loaded) {
	                // fix flash issue that doesn't call complete if there is no response text from the server
	                var _this = this;
	                setTimeout(function () {
	                  if (!xhr.__completed) {
	                    xhr.getAllResponseHeaders = function () {};
	                    _this.complete(null, { status: 204, statusText: 'No Content' });
	                  }
	                }, FileAPI.noContentTimeout || 10000);
	              }
	            },
	            headers: xhr.__requestHeaders
	          };
	          config.data = {};
	          config.files = {};
	          for (var i = 0; i < formData.data.length; i++) {
	            var item = formData.data[i];
	            if (item.val != null && item.val.name != null && item.val.size != null && item.val.type != null) {
	              config.files[item.key] = item.val;
	            } else {
	              config.data[item.key] = item.val;
	            }
	          }
	
	          setTimeout(function () {
	            if (!FileAPI.hasFlash) {
	              throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	            }
	            xhr.__fileApiXHR = FileAPI.upload(config);
	          }, 1);
	        } else {
	          if (this.__origError) {
	            throw this.__origError;
	          }
	          orig.apply(xhr, arguments);
	        }
	      };
	    });
	    window.XMLHttpRequest.__isFileAPIShim = true;
	    window.FormData = FormData = function FormData() {
	      return {
	        append: function append(key, val, name) {
	          if (val.__isFileAPIBlobShim) {
	            val = val.data[0];
	          }
	          this.data.push({
	            key: key,
	            val: val,
	            name: name
	          });
	        },
	        data: [],
	        __isFileAPIShim: true
	      };
	    };
	
	    window.Blob = Blob = function Blob(b) {
	      return {
	        data: b,
	        __isFileAPIBlobShim: true
	      };
	    };
	  }
	})();
	
	(function () {
	  /** @namespace FileAPI.forceLoad */
	  /** @namespace window.FileAPI.jsUrl */
	  /** @namespace window.FileAPI.jsPath */
	
	  function isInputTypeFile(elem) {
	    return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
	  }
	
	  function hasFlash() {
	    try {
	      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
	      if (fo) return true;
	    } catch (e) {
	      if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined) return true;
	    }
	    return false;
	  }
	
	  function getOffset(obj) {
	    var left = 0,
	        top = 0;
	
	    if (window.jQuery) {
	      return jQuery(obj).offset();
	    }
	
	    if (obj.offsetParent) {
	      do {
	        left += obj.offsetLeft - obj.scrollLeft;
	        top += obj.offsetTop - obj.scrollTop;
	        obj = obj.offsetParent;
	      } while (obj);
	    }
	    return {
	      left: left,
	      top: top
	    };
	  }
	
	  if (FileAPI.shouldLoad) {
	
	    //load FileAPI
	    if (FileAPI.forceLoad) {
	      FileAPI.html5 = false;
	    }
	
	    if (!FileAPI.upload) {
	      var jsUrl,
	          basePath,
	          script = document.createElement('script'),
	          allScripts = document.getElementsByTagName('script'),
	          i,
	          index,
	          src;
	      if (window.FileAPI.jsUrl) {
	        jsUrl = window.FileAPI.jsUrl;
	      } else if (window.FileAPI.jsPath) {
	        basePath = window.FileAPI.jsPath;
	      } else {
	        for (i = 0; i < allScripts.length; i++) {
	          src = allScripts[i].src;
	          index = src.search(/\/ng\-file\-upload[\-a-zA-z0-9\.]*\.js/);
	          if (index > -1) {
	            basePath = src.substring(0, index + 1);
	            break;
	          }
	        }
	      }
	
	      if (FileAPI.staticPath == null) FileAPI.staticPath = basePath;
	      script.setAttribute('src', jsUrl || basePath + 'FileAPI.min.js');
	      document.getElementsByTagName('head')[0].appendChild(script);
	
	      FileAPI.hasFlash = hasFlash();
	    }
	
	    FileAPI.ngfFixIE = function (elem, fileElem, changeFn) {
	      if (!hasFlash()) {
	        throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	      }
	      var fixInputStyle = function fixInputStyle() {
	        if (elem.attr('disabled')) {
	          if (fileElem) fileElem.removeClass('js-fileapi-wrapper');
	        } else {
	          if (!fileElem.attr('__ngf_flash_')) {
	            fileElem.unbind('change');
	            fileElem.unbind('click');
	            fileElem.bind('change', function (evt) {
	              fileApiChangeFn.apply(this, [evt]);
	              changeFn.apply(this, [evt]);
	            });
	            fileElem.attr('__ngf_flash_', 'true');
	          }
	          fileElem.addClass('js-fileapi-wrapper');
	          if (!isInputTypeFile(elem)) {
	            fileElem.css('position', 'absolute').css('top', getOffset(elem[0]).top + 'px').css('left', getOffset(elem[0]).left + 'px').css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px').css('filter', 'alpha(opacity=0)').css('display', elem.css('display')).css('overflow', 'hidden').css('z-index', '900000').css('visibility', 'visible');
	          }
	        }
	      };
	
	      elem.bind('mouseenter', fixInputStyle);
	
	      var fileApiChangeFn = function fileApiChangeFn(evt) {
	        var files = FileAPI.getFiles(evt);
	        //just a double check for #233
	        for (var i = 0; i < files.length; i++) {
	          if (files[i].size === undefined) files[i].size = 0;
	          if (files[i].name === undefined) files[i].name = 'file';
	          if (files[i].type === undefined) files[i].type = 'undefined';
	        }
	        if (!evt.target) {
	          evt.target = {};
	        }
	        evt.target.files = files;
	        // if evt.target.files is not writable use helper field
	        if (evt.target.files !== files) {
	          evt.__files_ = files;
	        }
	        (evt.__files_ || evt.target.files).item = function (i) {
	          return (evt.__files_ || evt.target.files)[i] || null;
	        };
	      };
	    };
	
	    FileAPI.disableFileInput = function (elem, disable) {
	      if (disable) {
	        elem.removeClass('js-fileapi-wrapper');
	      } else {
	        elem.addClass('js-fileapi-wrapper');
	      }
	    };
	  }
	})();
	
	if (!window.FileReader) {
	  window.FileReader = function () {
	    var _this = this,
	        loadStarted = false;
	    this.listeners = {};
	    this.addEventListener = function (type, fn) {
	      _this.listeners[type] = _this.listeners[type] || [];
	      _this.listeners[type].push(fn);
	    };
	    this.removeEventListener = function (type, fn) {
	      if (_this.listeners[type]) _this.listeners[type].splice(_this.listeners[type].indexOf(fn), 1);
	    };
	    this.dispatchEvent = function (evt) {
	      var list = _this.listeners[evt.type];
	      if (list) {
	        for (var i = 0; i < list.length; i++) {
	          list[i].call(_this, evt);
	        }
	      }
	    };
	    this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;
	
	    var constructEvent = function constructEvent(type, evt) {
	      var e = { type: type, target: _this, loaded: evt.loaded, total: evt.total, error: evt.error };
	      if (evt.result != null) e.target.result = evt.result;
	      return e;
	    };
	    var listener = function listener(evt) {
	      if (!loadStarted) {
	        loadStarted = true;
	        if (_this.onloadstart) _this.onloadstart(constructEvent('loadstart', evt));
	      }
	      var e;
	      if (evt.type === 'load') {
	        if (_this.onloadend) _this.onloadend(constructEvent('loadend', evt));
	        e = constructEvent('load', evt);
	        if (_this.onload) _this.onload(e);
	        _this.dispatchEvent(e);
	      } else if (evt.type === 'progress') {
	        e = constructEvent('progress', evt);
	        if (_this.onprogress) _this.onprogress(e);
	        _this.dispatchEvent(e);
	      } else {
	        e = constructEvent('error', evt);
	        if (_this.onerror) _this.onerror(e);
	        _this.dispatchEvent(e);
	      }
	    };
	    this.readAsArrayBuffer = function (file) {
	      FileAPI.readAsBinaryString(file, listener);
	    };
	    this.readAsBinaryString = function (file) {
	      FileAPI.readAsBinaryString(file, listener);
	    };
	    this.readAsDataURL = function (file) {
	      FileAPI.readAsDataURL(file, listener);
	    };
	    this.readAsText = function (file) {
	      FileAPI.readAsText(file, listener);
	    };
	  };
	}
	
	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 7.3.9
	 */
	
	if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
	  window.XMLHttpRequest.prototype.setRequestHeader = function (orig) {
	    return function (header, value) {
	      if (header === '__setXHR_') {
	        var val = value(this);
	        // fix for angular < 1.2.0
	        if (val instanceof Function) {
	          val(this);
	        }
	      } else {
	        orig.apply(this, arguments);
	      }
	    };
	  }(window.XMLHttpRequest.prototype.setRequestHeader);
	}
	
	var ngFileUpload = angular.module('ngFileUpload', []);
	
	ngFileUpload.version = '7.3.9';
	
	ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  var upload = this;
	
	  this.isResumeSupported = function () {
	    return window.Blob && new Blob().slice;
	  };
	
	  var resumeSupported = this.isResumeSupported();
	
	  function sendHttp(config) {
	    config.method = config.method || 'POST';
	    config.headers = config.headers || {};
	
	    var deferred = config._deferred = config._deferred || $q.defer();
	    var promise = deferred.promise;
	
	    function notifyProgress(e) {
	      if (deferred.notify) {
	        deferred.notify(e);
	      }
	      if (promise.progressFunc) {
	        $timeout(function () {
	          promise.progressFunc(e);
	        });
	      }
	    }
	
	    function getNotifyEvent(n) {
	      if (config._start != null && resumeSupported) {
	        return {
	          loaded: n.loaded + config._start, total: config._file.size, type: n.type, config: config,
	          lengthComputable: true, target: n.target
	        };
	      } else {
	        return n;
	      }
	    }
	
	    config.headers.__setXHR_ = function () {
	      return function (xhr) {
	        if (!xhr) return;
	        config.__XHR = xhr;
	        if (config.xhrFn) config.xhrFn(xhr);
	        xhr.upload.addEventListener('progress', function (e) {
	          e.config = config;
	          notifyProgress(getNotifyEvent(e));
	        }, false);
	        //fix for firefox not firing upload progress end, also IE8-9
	        xhr.upload.addEventListener('load', function (e) {
	          if (e.lengthComputable) {
	            e.config = config;
	            notifyProgress(getNotifyEvent(e));
	          }
	        }, false);
	      };
	    };
	
	    function uploadWithAngular() {
	      $http(config).then(function (r) {
	        if (resumeSupported && config._chunkSize && !config._finished) {
	          notifyProgress({ loaded: config._end, total: config._file.size, config: config, type: 'progress' });
	          upload.upload(config);
	        } else {
	          if (config._finished) delete config._finished;
	          deferred.resolve(r);
	        }
	      }, function (e) {
	        deferred.reject(e);
	      }, function (n) {
	        deferred.notify(n);
	      });
	    }
	
	    if (!resumeSupported) {
	      uploadWithAngular();
	    } else if (config._chunkSize && config._end && !config._finished) {
	      config._start = config._end;
	      config._end += config._chunkSize;
	      uploadWithAngular();
	    } else if (config.resumeSizeUrl) {
	      $http.get(config.resumeSizeUrl).then(function (resp) {
	        if (config.resumeSizeResponseReader) {
	          config._start = config.resumeSizeResponseReader(resp.data);
	        } else {
	          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
	        }
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else if (config.resumeSize) {
	      config.resumeSize().then(function (size) {
	        config._start = size;
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else {
	      uploadWithAngular();
	    }
	
	    promise.success = function (fn) {
	      promise.then(function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.error = function (fn) {
	      promise.then(null, function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.progress = function (fn) {
	      promise.progressFunc = fn;
	      promise.then(null, null, function (n) {
	        fn(n);
	      });
	      return promise;
	    };
	    promise.abort = promise.pause = function () {
	      if (config.__XHR) {
	        $timeout(function () {
	          config.__XHR.abort();
	        });
	      }
	      return promise;
	    };
	    promise.xhr = function (fn) {
	      config.xhrFn = function (origXhrFn) {
	        return function () {
	          if (origXhrFn) origXhrFn.apply(promise, arguments);
	          fn.apply(promise, arguments);
	        };
	      }(config.xhrFn);
	      return promise;
	    };
	
	    return promise;
	  }
	
	  this.upload = function (config) {
	    function addFieldToFormData(formData, val, key) {
	      if (val !== undefined) {
	        if (angular.isDate(val)) {
	          val = val.toISOString();
	        }
	        if (angular.isString(val)) {
	          formData.append(key, val);
	        } else if (config.sendFieldsAs === 'form') {
	          if (angular.isObject(val)) {
	            for (var k in val) {
	              if (val.hasOwnProperty(k)) {
	                addFieldToFormData(formData, val[k], key + '[' + k + ']');
	              }
	            }
	          } else {
	            formData.append(key, val);
	          }
	        } else {
	          val = angular.isString(val) ? val : angular.toJson(val);
	          if (config.sendFieldsAs === 'json-blob') {
	            formData.append(key, new Blob([val], { type: 'application/json' }));
	          } else {
	            formData.append(key, val);
	          }
	        }
	      }
	    }
	
	    function isFile(file) {
	      return file instanceof Blob || file.flashId && file.name && file.size;
	    }
	
	    function addFileToFormData(formData, file, key) {
	      if (isFile(file)) {
	        config._file = config._file || file;
	        if (config._start != null && resumeSupported) {
	          if (config._end && config._end >= file.size) {
	            config._finished = true;
	            config._end = file.size;
	          }
	          var slice = file.slice(config._start, config._end || file.size);
	          slice.name = file.name;
	          file = slice;
	          if (config._chunkSize) {
	            formData.append('chunkSize', config._end - config._start);
	            formData.append('chunkNumber', Math.floor(config._start / config._chunkSize));
	            formData.append('totalSize', config._file.size);
	          }
	        }
	        formData.append(key, file, file.fileName || file.name);
	      } else if (angular.isObject(file)) {
	        for (var k in file) {
	          if (file.hasOwnProperty(k)) {
	            var split = k.split(',');
	            if (split[1]) {
	              file[k].fileName = split[1].replace(/^\s+|\s+$/g, '');
	            }
	            addFileToFormData(formData, file[k], split[0]);
	          }
	        }
	      } else {
	        throw 'Expected file object in Upload.upload file option: ' + file.toString();
	      }
	    }
	
	    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	    config.headers = config.headers || {};
	    config.headers['Content-Type'] = undefined;
	    config.transformRequest = config.transformRequest ? angular.isArray(config.transformRequest) ? config.transformRequest : [config.transformRequest] : [];
	    config.transformRequest.push(function (data) {
	      var formData = new FormData(),
	          allFields = {},
	          key;
	      for (key in config.fields) {
	        if (config.fields.hasOwnProperty(key)) {
	          allFields[key] = config.fields[key];
	        }
	      }
	      if (data) allFields.data = data;
	      for (key in allFields) {
	        if (allFields.hasOwnProperty(key)) {
	          var val = allFields[key];
	          if (config.formDataAppender) {
	            config.formDataAppender(formData, key, val);
	          } else {
	            addFieldToFormData(formData, val, key);
	          }
	        }
	      }
	
	      if (config.file != null) {
	        if (angular.isArray(config.file)) {
	          for (var i = 0; i < config.file.length; i++) {
	            addFileToFormData(formData, config.file[i], 'file');
	          }
	        } else {
	          addFileToFormData(formData, config.file, 'file');
	        }
	      }
	      return formData;
	    });
	
	    return sendHttp(config);
	  };
	
	  this.http = function (config) {
	    config.transformRequest = config.transformRequest || function (data) {
	      if (window.ArrayBuffer && data instanceof window.ArrayBuffer || data instanceof Blob) {
	        return data;
	      }
	      return $http.defaults.transformRequest[0].apply(this, arguments);
	    };
	    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	    return sendHttp(config);
	  };
	
	  this.translateScalars = function (str) {
	    if (angular.isString(str)) {
	      if (str.search(/kb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1000);
	      } else if (str.search(/mb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1000000);
	      } else if (str.search(/gb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1000000000);
	      } else if (str.search(/b/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/s/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/m/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 60);
	      } else if (str.search(/h/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 3600);
	      }
	    }
	    return str;
	  };
	
	  this.setDefaults = function (defaults) {
	    this.defaults = defaults || {};
	  };
	
	  this.defaults = {};
	  this.version = ngFileUpload.version;
	}]);
	
	ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', 'UploadResize', function ($parse, $timeout, $compile, UploadResize) {
	  var upload = UploadResize;
	  upload.getAttrWithDefaults = function (attr, name) {
	    return attr[name] != null ? attr[name] : upload.defaults[name] == null ? upload.defaults[name] : upload.defaults[name].toString();
	  };
	
	  upload.attrGetter = function (name, attr, scope, params) {
	    if (scope) {
	      try {
	        if (params) {
	          return $parse(this.getAttrWithDefaults(attr, name))(scope, params);
	        } else {
	          return $parse(this.getAttrWithDefaults(attr, name))(scope);
	        }
	      } catch (e) {
	        // hangle string value without single qoute
	        if (name.search(/min|max|pattern/i)) {
	          return this.getAttrWithDefaults(attr, name);
	        } else {
	          throw e;
	        }
	      }
	    } else {
	      return this.getAttrWithDefaults(attr, name);
	    }
	  };
	
	  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
	    var newFiles = files,
	        dupFiles = [];
	
	    function update() {
	      var file = files && files.length ? files[0] : null;
	      if (ngModel) {
	        var singleModel = !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr) && !keep;
	        $parse(upload.attrGetter('ngModel', attr)).assign(scope, singleModel ? file : files);
	      }
	      var ngfModel = upload.attrGetter('ngfModel', attr);
	      if (ngfModel) {
	        $parse(ngfModel).assign(scope, files);
	      }
	
	      if (fileChange) {
	        $parse(fileChange)(scope, {
	          $files: files,
	          $file: file,
	          $newFiles: newFiles,
	          $duplicateFiles: dupFiles,
	          $event: evt
	        });
	      }
	      // scope apply changes
	      $timeout(function () {});
	    }
	
	    var prevFiles = (ngModel && ngModel.$modelValue || attr.$$ngfPrevFiles || []).slice(0);
	
	    var keep = upload.attrGetter('ngfKeep', attr, scope);
	    if (keep === true) {
	      if (!files || !files.length) return;
	
	      var hasNew = false;
	
	      if (upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
	        var len = prevFiles.length;
	        for (var i = 0; i < files.length; i++) {
	          for (var j = 0; j < len; j++) {
	            if (files[i].name === prevFiles[j].name) {
	              dupFiles.push(files[i]);
	              break;
	            }
	          }
	          if (j === len) {
	            prevFiles.push(files[i]);
	            hasNew = true;
	          }
	        }
	        if (!hasNew) return;
	        files = prevFiles;
	      } else {
	        files = prevFiles.concat(files);
	      }
	    }
	
	    attr.$$ngfPrevFiles = files;
	
	    function resize(files, callback) {
	      var param = upload.attrGetter('ngfResize', attr, scope);
	      if (!param || !upload.isResizeSupported()) return callback();
	      var count = files.length;
	      var checkCallback = function checkCallback() {
	        count--;
	        if (count === 0) callback();
	      };
	      var success = function success(index) {
	        return function (resizedFile) {
	          files.splice(index, 1, resizedFile);
	          checkCallback();
	        };
	      };
	      var error = function error(f) {
	        return function (e) {
	          checkCallback();
	          f.$error = 'resize';
	          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
	        };
	      };
	      for (var i = 0; i < files.length; i++) {
	        var f = files[i];
	        if (!f.$error && f.type.indexOf('image') === 0) {
	          upload.resize(f, param.width, param.height, param.quality).then(success(i), error(f));
	        } else {
	          checkCallback();
	        }
	      }
	    }
	
	    if (noDelay) {
	      update();
	    } else if (upload.validate(files, ngModel, attr, scope, upload.attrGetter('ngfValidateLater', attr), function () {
	      resize(files, function () {
	        $timeout(function () {
	          update();
	        });
	      });
	    })) ;
	
	    // cleaning object url memories
	    var l = prevFiles.length;
	    while (l--) {
	      var prevFile = prevFiles[l];
	      if (window.URL && prevFile.blobUrl) {
	        URL.revokeObjectURL(prevFile.blobUrl);
	        delete prevFile.blobUrl;
	      }
	    }
	  };
	
	  return upload;
	}]);
	
	ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
	  var generatedElems = [];
	
	  function isDelayedClickSupported(ua) {
	    // fix for android native browser < 4.4 and safari windows
	    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
	    if (m && m.length > 2) {
	      var v = Upload.defaults.androidFixMinorVersion || 4;
	      return parseInt(m[1]) < 4 || parseInt(m[1]) === v && parseInt(m[2]) < v;
	    }
	
	    // safari on windows
	    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
	  }
	
	  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
	    /** @namespace attr.ngfSelect */
	    /** @namespace attr.ngfChange */
	    /** @namespace attr.ngModel */
	    /** @namespace attr.ngfModel */
	    /** @namespace attr.ngfMultiple */
	    /** @namespace attr.ngfCapture */
	    /** @namespace attr.ngfValidate */
	    /** @namespace attr.ngfKeep */
	    /** @namespace attr.ngfKeepDistinct */
	    var attrGetter = function attrGetter(name, scope) {
	      return upload.attrGetter(name, attr, scope);
	    };
	
	    function isInputTypeFile() {
	      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
	    }
	
	    function fileChangeAttr() {
	      return attrGetter('ngfChange') || attrGetter('ngfSelect');
	    }
	
	    function changeFn(evt) {
	      var fileList = evt.__files_ || evt.target && evt.target.files,
	          files = [];
	      for (var i = 0; i < fileList.length; i++) {
	        files.push(fileList[i]);
	      }
	      upload.updateModel(ngModel, attr, scope, fileChangeAttr(), files.length ? files : null, evt);
	    }
	
	    var unwatches = [];
	    unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
	      fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
	    }));
	    unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
	      fileElem.attr('capture', attrGetter('ngfCapture', scope));
	    }));
	    attr.$observe('accept', function () {
	      fileElem.attr('accept', attrGetter('accept'));
	    });
	    unwatches.push(function () {
	      if (attr.$$observers) delete attr.$$observers.accept;
	    });
	    function bindAttrToFileInput(fileElem) {
	      if (elem !== fileElem) {
	        for (var i = 0; i < elem[0].attributes.length; i++) {
	          var attribute = elem[0].attributes[i];
	          if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'id' && attribute.name !== 'style') {
	            if (attribute.value == null || attribute.value === '') {
	              if (attribute.name === 'required') attribute.value = 'required';
	              if (attribute.name === 'multiple') attribute.value = 'multiple';
	            }
	            fileElem.attr(attribute.name, attribute.value);
	          }
	        }
	      }
	    }
	
	    function createFileInput() {
	      if (isInputTypeFile()) {
	        return elem;
	      }
	
	      var fileElem = angular.element('<input type="file">');
	      bindAttrToFileInput(fileElem);
	
	      fileElem.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden').css('width', '0px').css('height', '0px').css('border', 'none').css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
	      generatedElems.push({ el: elem, ref: fileElem });
	      document.body.appendChild(fileElem[0]);
	
	      return fileElem;
	    }
	
	    var initialTouchStartY = 0;
	
	    function clickHandler(evt) {
	      if (elem.attr('disabled') || attrGetter('ngfSelectDisabled', scope)) return false;
	
	      var r = handleTouch(evt);
	      if (r != null) return r;
	
	      resetModel(evt);
	
	      if (isDelayedClickSupported(navigator.userAgent)) {
	        setTimeout(function () {
	          fileElem[0].click();
	        }, 0);
	      } else {
	        fileElem[0].click();
	      }
	
	      return false;
	    }
	
	    function handleTouch(evt) {
	      var touches = evt.changedTouches || evt.originalEvent && evt.originalEvent.changedTouches;
	      if (evt.type === 'touchstart') {
	        initialTouchStartY = touches ? touches[0].clientY : 0;
	        return true; // don't block event default
	      } else {
	        evt.stopPropagation();
	        evt.preventDefault();
	
	        // prevent scroll from triggering event
	        if (evt.type === 'touchend') {
	          var currentLocation = touches ? touches[0].clientY : 0;
	          if (Math.abs(currentLocation - initialTouchStartY) > 20) return false;
	        }
	      }
	    }
	
	    var fileElem = elem;
	
	    function resetModel(evt) {
	      if (fileElem.val()) {
	        fileElem.val(null);
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
	      }
	    }
	
	    if (!isInputTypeFile()) {
	      fileElem = createFileInput();
	    }
	    fileElem.bind('change', changeFn);
	
	    if (!isInputTypeFile()) {
	      elem.bind('click touchstart touchend', clickHandler);
	    } else {
	      elem.bind('click', resetModel);
	    }
	
	    upload.registerValidators(ngModel, fileElem, attr, scope);
	
	    function ie10SameFileSelectFix(evt) {
	      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
	        if (!fileElem[0].parentNode) {
	          fileElem = null;
	          return;
	        }
	        evt.preventDefault();
	        evt.stopPropagation();
	        fileElem.unbind('click');
	        var clone = fileElem.clone();
	        fileElem.replaceWith(clone);
	        fileElem = clone;
	        fileElem.attr('__ngf_ie10_Fix_', 'true');
	        fileElem.bind('change', changeFn);
	        fileElem.bind('click', ie10SameFileSelectFix);
	        fileElem[0].click();
	        return false;
	      } else {
	        fileElem.removeAttr('__ngf_ie10_Fix_');
	      }
	    }
	
	    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
	      fileElem.bind('click', ie10SameFileSelectFix);
	    }
	
	    scope.$on('$destroy', function () {
	      if (!isInputTypeFile()) fileElem.remove();
	      angular.forEach(unwatches, function (unwatch) {
	        unwatch();
	      });
	    });
	
	    $timeout(function () {
	      for (var i = 0; i < generatedElems.length; i++) {
	        var g = generatedElems[i];
	        if (!document.body.contains(g.el[0])) {
	          generatedElems.splice(i, 1);
	          g.ref.remove();
	        }
	      }
	    });
	
	    if (window.FileAPI && window.FileAPI.ngfFixIE) {
	      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
	    }
	  }
	
	  return {
	    restrict: 'AEC',
	    require: '?ngModel',
	    link: function link(scope, elem, attr, ngModel) {
	      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
	    }
	  };
	}]);
	
	(function () {
	
	  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
	    var upload = UploadBase;
	    upload.dataUrl = function (file, disallowObjectUrl) {
	      if (disallowObjectUrl && file.dataUrl != null || !disallowObjectUrl && file.blobUrl != null) {
	        var d = $q.defer();
	        $timeout(function () {
	          d.resolve(disallowObjectUrl ? file.dataUrl : file.blobUrl);
	        });
	        return d.promise;
	      }
	      var p = disallowObjectUrl ? file.$ngfDataUrlPromise : file.$ngfBlobUrlPromise;
	      if (p) return p;
	
	      var deferred = $q.defer();
	      $timeout(function () {
	        if (window.FileReader && file && (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) && (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
	          //prefer URL.createObjectURL for handling refrences to files of all sizes
	          //since it doesn´t build a large string in memory
	          var URL = window.URL || window.webkitURL;
	          if (URL && URL.createObjectURL && !disallowObjectUrl) {
	            var url;
	            try {
	              url = URL.createObjectURL(file);
	            } catch (e) {
	              $timeout(function () {
	                file.blobUrl = '';
	                deferred.reject();
	              });
	              return;
	            }
	            $timeout(function () {
	              file.blobUrl = url;
	              if (url) deferred.resolve(url);
	            });
	          } else {
	            var fileReader = new FileReader();
	            fileReader.onload = function (e) {
	              $timeout(function () {
	                file.dataUrl = e.target.result;
	                deferred.resolve(e.target.result);
	              });
	            };
	            fileReader.onerror = function () {
	              $timeout(function () {
	                file.dataUrl = '';
	                deferred.reject();
	              });
	            };
	            fileReader.readAsDataURL(file);
	          }
	        } else {
	          $timeout(function () {
	            file[disallowObjectUrl ? 'dataUrl' : 'blobUrl'] = '';
	            deferred.reject();
	          });
	        }
	      });
	
	      if (disallowObjectUrl) {
	        p = file.$ngfDataUrlPromise = deferred.promise;
	      } else {
	        p = file.$ngfBlobUrlPromise = deferred.promise;
	      }
	      p['finally'](function () {
	        delete file[disallowObjectUrl ? '$ngfDataUrlPromise' : '$ngfBlobUrlPromise'];
	      });
	      return p;
	    };
	    return upload;
	  }]);
	
	  function getTagType(el) {
	    if (el.tagName.toLowerCase() === 'img') return 'image';
	    if (el.tagName.toLowerCase() === 'audio') return 'audio';
	    if (el.tagName.toLowerCase() === 'video') return 'video';
	    return (/./
	    );
	  }
	
	  var style = angular.element('<style>.ngf-hide{display:none !important}</style>');
	  document.getElementsByTagName('head')[0].appendChild(style[0]);
	
	  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
	    function constructDataUrl(file) {
	      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
	      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
	        $timeout(function () {
	          var src = (disallowObjectUrl ? file.dataUrl : file.blobUrl) || file.dataUrl;
	          if (isBackground) {
	            elem.css('background-image', 'url(\'' + (src || '') + '\')');
	          } else {
	            elem.attr('src', src);
	          }
	          if (src) {
	            elem.removeClass('ngf-hide');
	          } else {
	            elem.addClass('ngf-hide');
	          }
	        });
	      });
	    }
	
	    $timeout(function () {
	      var unwatch = scope.$watch(attr[directiveName], function (file) {
	        var size = resizeParams;
	        if (directiveName === 'ngfThumbnail') {
	          if (!size) {
	            size = { width: elem[0].clientWidth, height: elem[0].clientHeight };
	          }
	          if (size.width === 0 && window.getComputedStyle) {
	            var style = getComputedStyle(elem[0]);
	            size = { width: parseInt(style.width.slice(0, -2)),
	              height: parseInt(style.height.slice(0, -2)) };
	          }
	        }
	
	        if (angular.isString(file)) {
	          elem.removeClass('ngf-hide');
	          if (isBackground) {
	            return elem.css('background-image', 'url(\'' + file + '\')');
	          } else {
	            return elem.attr('src', file);
	          }
	        }
	        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 && (!isBackground || file.type.indexOf('image') === 0)) {
	          if (size && Upload.isResizeSupported()) {
	            Upload.resize(file, size.width, size.height, size.quality).then(function (f) {
	              constructDataUrl(f);
	            }, function (e) {
	              throw e;
	            });
	          } else {
	            constructDataUrl(file);
	          }
	        } else {
	          elem.addClass('ngf-hide');
	        }
	      });
	
	      scope.$on('$destroy', function () {
	        unwatch();
	      });
	    });
	  }
	
	  /** @namespace attr.ngfSrc */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function link(scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc', Upload.attrGetter('ngfResize', attr, scope), false);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfBackground */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function link(scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground', Upload.attrGetter('ngfResize', attr, scope), true);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfThumbnail */
	  /** @namespace attr.ngfAsBackground */
	  /** @namespace attr.ngfSize */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function link(scope, elem, attr) {
	        var size = Upload.attrGetter('ngfSize', attr, scope);
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size, Upload.attrGetter('ngfAsBackground', attr, scope));
	      }
	    };
	  }]);
	
	  //ngFileUpload.config(['$compileProvider', function ($compileProvider) {
	  //  if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|local|file|data|blob):/);
	  //  if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|local|file|data|blob):/);
	  //}]);
	  //
	  //ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
	  //  return function (file, disallowObjectUrl) {
	  //    if (angular.isString(file)) {
	  //      return $sce.trustAsResourceUrl(file);
	  //    }
	  //    if (file && !file.dataUrl) {
	  //      if (file.dataUrl === undefined && angular.isObject(file)) {
	  //        file.dataUrl = null;
	  //        UploadDataUrl.dataUrl(file, disallowObjectUrl);
	  //      }
	  //      return '';
	  //    }
	  //    return (file && file.dataUrl ? $sce.trustAsResourceUrl(file.dataUrl) : file) || '';
	  //  };
	  //}]);
	})();
	
	ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
	  var upload = UploadDataUrl;
	
	  function globStringToRegex(str) {
	    var regexp = '',
	        excludes = [];
	    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
	      regexp = str.substring(1, str.length - 1);
	    } else {
	      var split = str.split(',');
	      if (split.length > 1) {
	        for (var i = 0; i < split.length; i++) {
	          var r = globStringToRegex(split[i]);
	          if (r.regexp) {
	            regexp += '(' + r.regexp + ')';
	            if (i < split.length - 1) {
	              regexp += '|';
	            }
	          } else {
	            excludes = excludes.concat(r.excludes);
	          }
	        }
	      } else {
	        if (str.indexOf('!') === 0) {
	          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
	        } else {
	          if (str.indexOf('.') === 0) {
	            str = '*' + str;
	          }
	          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
	          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
	        }
	      }
	    }
	    return { regexp: regexp, excludes: excludes };
	  }
	
	  upload.registerValidators = function (ngModel, elem, attr, scope) {
	    if (!ngModel) return;
	
	    ngModel.$ngfValidations = [];
	    function setValidities(ngModel) {
	      angular.forEach(ngModel.$ngfValidations, function (validation) {
	        ngModel.$setValidity(validation.name, validation.valid);
	      });
	    }
	
	    ngModel.$formatters.push(function (val) {
	      if (upload.attrGetter('ngfValidateLater', attr, scope) || !ngModel.$$ngfValidated) {
	        upload.validate(val, ngModel, attr, scope, false, function () {
	          setValidities(ngModel);
	          ngModel.$$ngfValidated = false;
	        });
	        if (val && val.length === 0) {
	          val = null;
	        }
	        if (elem && (val == null || val.length === 0)) {
	          if (elem.val()) {
	            elem.val(null);
	          }
	        }
	      } else {
	        setValidities(ngModel);
	        ngModel.$$ngfValidated = false;
	      }
	      return val;
	    });
	  };
	
	  upload.validatePattern = function (file, val) {
	    if (!val) {
	      return true;
	    }
	    var pattern = globStringToRegex(val),
	        valid = true;
	    if (pattern.regexp && pattern.regexp.length) {
	      var regexp = new RegExp(pattern.regexp, 'i');
	      valid = file.type != null && regexp.test(file.type) || file.name != null && regexp.test(file.name);
	    }
	    var len = pattern.excludes.length;
	    while (len--) {
	      var exclude = new RegExp(pattern.excludes[len], 'i');
	      valid = valid && (file.type == null || exclude.test(file.type)) && (file.name == null || exclude.test(file.name));
	    }
	    return valid;
	  };
	
	  upload.validate = function (files, ngModel, attr, scope, later, callback) {
	    ngModel = ngModel || {};
	    ngModel.$ngfValidations = ngModel.$ngfValidations || [];
	
	    angular.forEach(ngModel.$ngfValidations, function (v) {
	      v.valid = true;
	    });
	
	    var attrGetter = function attrGetter(name, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (later) {
	      callback.call(ngModel);
	      return;
	    }
	    ngModel.$$ngfValidated = true;
	
	    if (files == null || files.length === 0) {
	      callback.call(ngModel);
	      return;
	    }
	
	    files = files.length === undefined ? [files] : files.slice(0);
	
	    function validateSync(name, validatorVal, fn) {
	      if (files) {
	        var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	        var i = files.length,
	            valid = null;
	
	        while (i--) {
	          var file = files[i];
	          var val = attrGetter(dName, { '$file': file });
	          if (val == null) {
	            val = validatorVal(attrGetter('ngfValidate') || {});
	            valid = valid == null ? true : valid;
	          }
	          if (val != null) {
	            if (!fn(file, val)) {
	              file.$error = name;
	              file.$errorParam = val;
	              files.splice(i, 1);
	              valid = false;
	            }
	          }
	        }
	        if (valid !== null) {
	          ngModel.$ngfValidations.push({ name: name, valid: valid });
	        }
	      }
	    }
	
	    validateSync('pattern', function (cons) {
	      return cons.pattern;
	    }, upload.validatePattern);
	    validateSync('minSize', function (cons) {
	      return cons.size && cons.size.min;
	    }, function (file, val) {
	      return file.size >= upload.translateScalars(val);
	    });
	    validateSync('maxSize', function (cons) {
	      return cons.size && cons.size.max;
	    }, function (file, val) {
	      return file.size <= upload.translateScalars(val);
	    });
	
	    validateSync('validateFn', function () {
	      return null;
	    }, function (file, r) {
	      return r === true || r === null || r === '';
	    });
	
	    if (!files.length) {
	      callback.call(ngModel, ngModel.$ngfValidations);
	      return;
	    }
	
	    var pendings = 0;
	
	    function validateAsync(name, validatorVal, type, asyncFn, fn) {
	      if (files) {
	        var thisPendings = 0,
	            hasError = false,
	            dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	        files = files.length === undefined ? [files] : files;
	        angular.forEach(files, function (file) {
	          if (file.type.search(type) !== 0) {
	            return true;
	          }
	          var val = attrGetter(dName, { '$file': file }) || validatorVal(attrGetter('ngfValidate', { '$file': file }) || {});
	          if (val) {
	            pendings++;
	            thisPendings++;
	            asyncFn(file, val).then(function (d) {
	              if (!fn(d, val)) {
	                file.$error = name;
	                file.$errorParam = val;
	                hasError = true;
	              }
	            }, function () {
	              if (attrGetter('ngfValidateForce', { '$file': file })) {
	                file.$error = name;
	                file.$errorParam = val;
	                hasError = true;
	              }
	            })['finally'](function () {
	              pendings--;
	              thisPendings--;
	              if (!thisPendings) {
	                ngModel.$ngfValidations.push({ name: name, valid: !hasError });
	              }
	              if (!pendings) {
	                callback.call(ngModel, ngModel.$ngfValidations);
	              }
	            });
	          }
	        });
	      }
	    }
	
	    validateAsync('maxHeight', function (cons) {
	      return cons.height && cons.height.max;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.height <= val;
	    });
	    validateAsync('minHeight', function (cons) {
	      return cons.height && cons.height.min;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.height >= val;
	    });
	    validateAsync('maxWidth', function (cons) {
	      return cons.width && cons.width.max;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.width <= val;
	    });
	    validateAsync('minWidth', function (cons) {
	      return cons.width && cons.width.min;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.width >= val;
	    });
	    validateAsync('ratio', function (cons) {
	      return cons.ratio;
	    }, /image/, this.imageDimensions, function (d, val) {
	      var split = val.toString().split(','),
	          valid = false;
	
	      for (var i = 0; i < split.length; i++) {
	        var r = split[i],
	            xIndex = r.search(/x/i);
	        if (xIndex > -1) {
	          r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
	        } else {
	          r = parseFloat(r);
	        }
	        if (Math.abs(d.width / d.height - r) < 0.0001) {
	          valid = true;
	        }
	      }
	      return valid;
	    });
	    validateAsync('maxDuration', function (cons) {
	      return cons.duration && cons.duration.max;
	    }, /audio|video/, this.mediaDuration, function (d, val) {
	      return d <= upload.translateScalars(val);
	    });
	    validateAsync('minDuration', function (cons) {
	      return cons.duration && cons.duration.min;
	    }, /audio|video/, this.mediaDuration, function (d, val) {
	      return d >= upload.translateScalars(val);
	    });
	
	    validateAsync('validateAsyncFn', function () {
	      return null;
	    }, /./, function (file, val) {
	      return val;
	    }, function (r) {
	      return r === true || r === null || r === '';
	    });
	
	    if (!pendings) {
	      callback.call(ngModel, ngModel.$ngfValidations);
	    }
	  };
	
	  upload.imageDimensions = function (file) {
	    if (file.width && file.height) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve({ width: file.width, height: file.height });
	      });
	      return d.promise;
	    }
	    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('image') !== 0) {
	        deferred.reject('not image');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var img = angular.element('<img>').attr('src', dataUrl).css('visibility', 'hidden').css('position', 'fixed');
	
	        function success() {
	          var width = img[0].clientWidth;
	          var height = img[0].clientHeight;
	          img.remove();
	          file.width = width;
	          file.height = height;
	          deferred.resolve({ width: width, height: height });
	        }
	
	        function error() {
	          img.remove();
	          deferred.reject('load error');
	        }
	
	        img.on('load', success);
	        img.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (img[0].parentNode) {
	              if (img[0].clientWidth) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.getElementsByTagName('body')[0]).append(img);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDimensionPromise = deferred.promise;
	    file.$ngfDimensionPromise['finally'](function () {
	      delete file.$ngfDimensionPromise;
	    });
	    return file.$ngfDimensionPromise;
	  };
	
	  upload.mediaDuration = function (file) {
	    if (file.duration) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve(file.duration);
	      });
	      return d.promise;
	    }
	    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
	        deferred.reject('not media');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>').attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');
	
	        function success() {
	          var duration = el[0].duration;
	          file.duration = duration;
	          el.remove();
	          deferred.resolve(duration);
	        }
	
	        function error() {
	          el.remove();
	          deferred.reject('load error');
	        }
	
	        el.on('loadedmetadata', success);
	        el.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (el[0].parentNode) {
	              if (el[0].duration) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.body).append(el);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDurationPromise = deferred.promise;
	    file.$ngfDurationPromise['finally'](function () {
	      delete file.$ngfDurationPromise;
	    });
	    return file.$ngfDurationPromise;
	  };
	  return upload;
	}]);
	
	// source: Source: https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
	
	ngFileUpload.service('UploadResize', ['UploadValidate', '$q', '$timeout', function (UploadValidate, $q, $timeout) {
	  var upload = UploadValidate;
	
	  /**
	   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
	   * images to fit into a certain area.
	   * Source:  http://stackoverflow.com/a/14731922
	   *
	   * @param {Number} srcWidth Source area width
	   * @param {Number} srcHeight Source area height
	   * @param {Number} maxWidth Nestable area maximum available width
	   * @param {Number} maxHeight Nestable area maximum available height
	   * @return {Object} { width, height }
	   */
	  var calculateAspectRatioFit = function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
	    var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	    return { width: srcWidth * ratio, height: srcHeight * ratio };
	  };
	
	  /**
	   Reduce imagen size and quality.
	   @param {String} imagen is a base64 string
	   @param {Number} width
	   @param {Number} height
	   @param {Number} quality from 0.1 to 1.0
	   @return Promise.<String>
	   **/
	  var resize = function resize(imagen, width, height, quality, type) {
	    var deferred = $q.defer();
	    var canvasElement = document.createElement('canvas');
	    var imagenElement = document.createElement('img');
	    if (width === 0) {
	      width = imagenElement.width;
	      height = imagenElement.height;
	    }
	    imagenElement.onload = function () {
	      try {
	        var dimensions = calculateAspectRatioFit(imagenElement.width, imagenElement.height, width, height);
	        canvasElement.width = dimensions.width;
	        canvasElement.height = dimensions.height;
	        var context = canvasElement.getContext('2d');
	        context.drawImage(imagenElement, 0, 0, dimensions.width, dimensions.height);
	        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 1.0));
	      } catch (e) {
	        deferred.reject(e);
	      }
	    };
	    imagenElement.onerror = function () {
	      deferred.reject();
	    };
	    imagenElement.src = imagen;
	    return deferred.promise;
	  };
	
	  var dataURLtoBlob = function dataURLtoBlob(dataurl) {
	    var arr = dataurl.split(','),
	        mime = arr[0].match(/:(.*?);/)[1],
	        bstr = atob(arr[1]),
	        n = bstr.length,
	        u8arr = new Uint8Array(n);
	    while (n--) {
	      u8arr[n] = bstr.charCodeAt(n);
	    }
	    return new Blob([u8arr], { type: mime });
	  };
	
	  upload.isResizeSupported = function () {
	    var elem = document.createElement('canvas');
	    return window.atob && elem.getContext && elem.getContext('2d');
	  };
	
	  upload.resize = function (file, width, height, quality) {
	    var deferred = $q.defer();
	    if (file.type.indexOf('image') !== 0) {
	      $timeout(function () {
	        deferred.resolve('Only images are allowed for resizing!');
	      });
	      return deferred.promise;
	    }
	
	    upload.dataUrl(file, true).then(function (url) {
	      resize(url, width, height, quality, file.type).then(function (dataUrl) {
	        var blob = dataURLtoBlob(dataUrl);
	        blob.name = file.name;
	        deferred.resolve(blob);
	      }, function () {
	        deferred.reject();
	      });
	    }, function () {
	      deferred.reject();
	    });
	    return deferred.promise;
	  };
	
	  return upload;
	}]);
	
	(function () {
	  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$location', 'Upload', function ($parse, $timeout, $location, Upload) {
	    return {
	      restrict: 'AEC',
	      require: '?ngModel',
	      link: function link(scope, elem, attr, ngModel) {
	        linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $location, Upload);
	      }
	    };
	  }]);
	
	  ngFileUpload.directive('ngfNoFileDrop', function () {
	    return function (scope, elem) {
	      if (dropAvailable()) elem.css('display', 'none');
	    };
	  });
	
	  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
	    return function (scope, elem, attr) {
	      if (dropAvailable()) {
	        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
	        $timeout(function () {
	          model(scope);
	          if (model.assign) {
	            model.assign(scope, true);
	          }
	        });
	      }
	    };
	  }]);
	
	  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $location, upload) {
	    var available = dropAvailable();
	
	    var attrGetter = function attrGetter(name, scope, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (attrGetter('dropAvailable')) {
	      $timeout(function () {
	        if (scope[attrGetter('dropAvailable')]) {
	          scope[attrGetter('dropAvailable')].value = available;
	        } else {
	          scope[attrGetter('dropAvailable')] = available;
	        }
	      });
	    }
	    if (!available) {
	      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
	        elem.css('display', 'none');
	      }
	      return;
	    }
	
	    function isDisabled() {
	      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
	    }
	
	    upload.registerValidators(ngModel, null, attr, scope);
	
	    var leaveTimeout = null;
	    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
	    var dragOverDelay = 1;
	    var actualDragOverClass;
	
	    elem[0].addEventListener('dragover', function (evt) {
	      if (isDisabled()) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      // handling dragover events from the Chrome download bar
	      if (navigator.userAgent.indexOf('Chrome') > -1) {
	        var b = evt.dataTransfer.effectAllowed;
	        evt.dataTransfer.dropEffect = 'move' === b || 'linkMove' === b ? 'move' : 'copy';
	      }
	      $timeout.cancel(leaveTimeout);
	      if (!actualDragOverClass) {
	        actualDragOverClass = 'C';
	        calculateDragOverClass(scope, attr, evt, function (clazz) {
	          actualDragOverClass = clazz;
	          elem.addClass(actualDragOverClass);
	        });
	      }
	    }, false);
	    elem[0].addEventListener('dragenter', function (evt) {
	      if (isDisabled()) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	    }, false);
	    elem[0].addEventListener('dragleave', function () {
	      if (isDisabled()) return;
	      leaveTimeout = $timeout(function () {
	        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	        actualDragOverClass = null;
	      }, dragOverDelay || 1);
	    }, false);
	    elem[0].addEventListener('drop', function (evt) {
	      if (isDisabled()) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	      actualDragOverClass = null;
	      extractFiles(evt, function (files) {
	        upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	      }, attrGetter('ngfAllowDir', scope) !== false, attrGetter('multiple') || attrGetter('ngfMultiple', scope));
	    }, false);
	    elem[0].addEventListener('paste', function (evt) {
	      if (isDisabled()) return;
	      var files = [];
	      var clipboard = evt.clipboardData || evt.originalEvent.clipboardData;
	      if (clipboard && clipboard.items) {
	        for (var k = 0; k < clipboard.items.length; k++) {
	          if (clipboard.items[k].type.indexOf('image') !== -1) {
	            files.push(clipboard.items[k].getAsFile());
	          }
	        }
	        upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	      }
	    }, false);
	
	    function calculateDragOverClass(scope, attr, evt, callback) {
	      var clazz = attrGetter('ngfDragOverClass', scope, { $event: evt }),
	          dClass = attrGetter('ngfDragOverClass') || 'dragover';
	      if (angular.isString(clazz)) {
	        callback(clazz);
	        return;
	      }
	      if (clazz) {
	        if (clazz.delay) dragOverDelay = clazz.delay;
	        if (clazz.accept || clazz.reject) {
	          var items = evt.dataTransfer.items;
	          if (items != null) {
	            var pattern = attrGetter('ngfPattern', scope, { $event: evt });
	            for (var i = 0; i < items.length; i++) {
	              if (items[i].kind === 'file' || items[i].kind === '') {
	                if (!upload.validatePattern(items[i], pattern)) {
	                  dClass = clazz.reject;
	                  break;
	                } else {
	                  dClass = clazz.accept;
	                }
	              }
	            }
	          }
	        }
	      }
	      callback(dClass);
	    }
	
	    function extractFiles(evt, callback, allowDir, multiple) {
	      var files = [],
	          processing = 0;
	
	      function traverseFileTree(files, entry, path) {
	        if (entry != null) {
	          if (entry.isDirectory) {
	            var filePath = (path || '') + entry.name;
	            files.push({ name: entry.name, type: 'directory', path: filePath });
	            var dirReader = entry.createReader();
	            var entries = [];
	            processing++;
	            var readEntries = function readEntries() {
	              dirReader.readEntries(function (results) {
	                try {
	                  if (!results.length) {
	                    for (var i = 0; i < entries.length; i++) {
	                      traverseFileTree(files, entries[i], (path ? path : '') + entry.name + '/');
	                    }
	                    processing--;
	                  } else {
	                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
	                    readEntries();
	                  }
	                } catch (e) {
	                  processing--;
	                  console.error(e);
	                }
	              }, function () {
	                processing--;
	              });
	            };
	            readEntries();
	          } else {
	            processing++;
	            entry.file(function (file) {
	              try {
	                processing--;
	                file.path = (path ? path : '') + file.name;
	                files.push(file);
	              } catch (e) {
	                processing--;
	                console.error(e);
	              }
	            }, function () {
	              processing--;
	            });
	          }
	        }
	      }
	
	      var items = evt.dataTransfer.items;
	
	      if (items && items.length > 0 && $location.protocol() !== 'file') {
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
	            var entry = items[i].webkitGetAsEntry();
	            if (entry.isDirectory && !allowDir) {
	              continue;
	            }
	            if (entry != null) {
	              traverseFileTree(files, entry);
	            }
	          } else {
	            var f = items[i].getAsFile();
	            if (f != null) files.push(f);
	          }
	          if (!multiple && files.length > 0) break;
	        }
	      } else {
	        var fileList = evt.dataTransfer.files;
	        if (fileList != null) {
	          for (var j = 0; j < fileList.length; j++) {
	            files.push(fileList.item(j));
	            if (!multiple && files.length > 0) {
	              break;
	            }
	          }
	        }
	      }
	      var delays = 0;
	      (function waitForProcess(delay) {
	        $timeout(function () {
	          if (!processing) {
	            if (!multiple && files.length > 1) {
	              i = 0;
	              while (files[i].type === 'directory') {
	                i++;
	              }files = [files[i]];
	            }
	            callback(files);
	          } else {
	            if (delays++ * 10 < 20 * 1000) {
	              waitForProcess(10);
	            }
	          }
	        }, delay || 0);
	      })();
	    }
	  }
	
	  function dropAvailable() {
	    var div = document.createElement('div');
	    return 'draggable' in div && 'ondrop' in div && !/Edge\/12./i.test(navigator.userAgent);
	  }
	})();

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(323);
	module.exports = 'ngFileUpload';

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function () {
	  var inflection = window && window.inflection ? window.inflection : __webpack_require__(183);
	  var angular = window && window.angular ? window.angular : __webpack_require__(6);
	  var app = angular.module('ngInflection', []);
	
	  function wrap(op) {
	    return function () {
	      return function (inp) {
	        if (inp) {
	          return inflection[op].apply(this, arguments);
	        }
	      };
	    };
	  }
	
	  var ops = ['indexOf', 'pluralize', 'singularize', 'inflect', 'camelize', 'underscore', 'humanize', 'capitalize', 'dasherize', 'titleize', 'demodulize', 'tableize', 'classify', 'foreign_key', 'ordinalize'];
	
	  for (var i in ops) {
	    app.filter(ops[i], wrap(ops[i]));
	  }
	
	  app.filter('transform', function () {
	    return function (string, arr) {
	      if (string && arr) {
	        return inflection.transform(string, arr);
	      }
	    };
	  });
	};
	
	module.exports();

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
	 * @license MIT */
	
	;(function (root, factory) {
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	    module.exports = factory();
	  } else {
	    root.NProgress = factory();
	  }
	})(undefined, function () {
	  var NProgress = {};
	
	  NProgress.version = '0.2.0';
	
	  var Settings = NProgress.settings = {
	    minimum: 0.08,
	    easing: 'ease',
	    positionUsing: '',
	    speed: 200,
	    trickle: true,
	    trickleRate: 0.02,
	    trickleSpeed: 800,
	    showSpinner: true,
	    barSelector: '[role="bar"]',
	    spinnerSelector: '[role="spinner"]',
	    parent: 'body',
	    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
	  };
	
	  /**
	   * Updates configuration.
	   *
	   *     NProgress.configure({
	   *       minimum: 0.1
	   *     });
	   */
	  NProgress.configure = function (options) {
	    var key, value;
	    for (key in options) {
	      value = options[key];
	      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
	    }
	
	    return this;
	  };
	
	  /**
	   * Last number.
	   */
	
	  NProgress.status = null;
	
	  /**
	   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
	   *
	   *     NProgress.set(0.4);
	   *     NProgress.set(1.0);
	   */
	
	  NProgress.set = function (n) {
	    var started = NProgress.isStarted();
	
	    n = clamp(n, Settings.minimum, 1);
	    NProgress.status = n === 1 ? null : n;
	
	    var progress = NProgress.render(!started),
	        bar = progress.querySelector(Settings.barSelector),
	        speed = Settings.speed,
	        ease = Settings.easing;
	
	    progress.offsetWidth; /* Repaint */
	
	    queue(function (next) {
	      // Set positionUsing if it hasn't already been set
	      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();
	
	      // Add transition
	      css(bar, barPositionCSS(n, speed, ease));
	
	      if (n === 1) {
	        // Fade out
	        css(progress, {
	          transition: 'none',
	          opacity: 1
	        });
	        progress.offsetWidth; /* Repaint */
	
	        setTimeout(function () {
	          css(progress, {
	            transition: 'all ' + speed + 'ms linear',
	            opacity: 0
	          });
	          setTimeout(function () {
	            NProgress.remove();
	            next();
	          }, speed);
	        }, speed);
	      } else {
	        setTimeout(next, speed);
	      }
	    });
	
	    return this;
	  };
	
	  NProgress.isStarted = function () {
	    return typeof NProgress.status === 'number';
	  };
	
	  /**
	   * Shows the progress bar.
	   * This is the same as setting the status to 0%, except that it doesn't go backwards.
	   *
	   *     NProgress.start();
	   *
	   */
	  NProgress.start = function () {
	    if (!NProgress.status) NProgress.set(0);
	
	    var work = function work() {
	      setTimeout(function () {
	        if (!NProgress.status) return;
	        NProgress.trickle();
	        work();
	      }, Settings.trickleSpeed);
	    };
	
	    if (Settings.trickle) work();
	
	    return this;
	  };
	
	  /**
	   * Hides the progress bar.
	   * This is the *sort of* the same as setting the status to 100%, with the
	   * difference being `done()` makes some placebo effect of some realistic motion.
	   *
	   *     NProgress.done();
	   *
	   * If `true` is passed, it will show the progress bar even if its hidden.
	   *
	   *     NProgress.done(true);
	   */
	
	  NProgress.done = function (force) {
	    if (!force && !NProgress.status) return this;
	
	    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
	  };
	
	  /**
	   * Increments by a random amount.
	   */
	
	  NProgress.inc = function (amount) {
	    var n = NProgress.status;
	
	    if (!n) {
	      return NProgress.start();
	    } else {
	      if (typeof amount !== 'number') {
	        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
	      }
	
	      n = clamp(n + amount, 0, 0.994);
	      return NProgress.set(n);
	    }
	  };
	
	  NProgress.trickle = function () {
	    return NProgress.inc(Math.random() * Settings.trickleRate);
	  };
	
	  /**
	   * Waits for all supplied jQuery promises and
	   * increases the progress as the promises resolve.
	   *
	   * @param $promise jQUery Promise
	   */
	  (function () {
	    var initial = 0,
	        current = 0;
	
	    NProgress.promise = function ($promise) {
	      if (!$promise || $promise.state() === "resolved") {
	        return this;
	      }
	
	      if (current === 0) {
	        NProgress.start();
	      }
	
	      initial++;
	      current++;
	
	      $promise.always(function () {
	        current--;
	        if (current === 0) {
	          initial = 0;
	          NProgress.done();
	        } else {
	          NProgress.set((initial - current) / initial);
	        }
	      });
	
	      return this;
	    };
	  })();
	
	  /**
	   * (Internal) renders the progress bar markup based on the `template`
	   * setting.
	   */
	
	  NProgress.render = function (fromStart) {
	    if (NProgress.isRendered()) return document.getElementById('nprogress');
	
	    addClass(document.documentElement, 'nprogress-busy');
	
	    var progress = document.createElement('div');
	    progress.id = 'nprogress';
	    progress.innerHTML = Settings.template;
	
	    var bar = progress.querySelector(Settings.barSelector),
	        perc = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
	        parent = document.querySelector(Settings.parent),
	        spinner;
	
	    css(bar, {
	      transition: 'all 0 linear',
	      transform: 'translate3d(' + perc + '%,0,0)'
	    });
	
	    if (!Settings.showSpinner) {
	      spinner = progress.querySelector(Settings.spinnerSelector);
	      spinner && removeElement(spinner);
	    }
	
	    if (parent != document.body) {
	      addClass(parent, 'nprogress-custom-parent');
	    }
	
	    parent.appendChild(progress);
	    return progress;
	  };
	
	  /**
	   * Removes the element. Opposite of render().
	   */
	
	  NProgress.remove = function () {
	    removeClass(document.documentElement, 'nprogress-busy');
	    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
	    var progress = document.getElementById('nprogress');
	    progress && removeElement(progress);
	  };
	
	  /**
	   * Checks if the progress bar is rendered.
	   */
	
	  NProgress.isRendered = function () {
	    return !!document.getElementById('nprogress');
	  };
	
	  /**
	   * Determine which positioning CSS rule to use.
	   */
	
	  NProgress.getPositioningCSS = function () {
	    // Sniff on document.body.style
	    var bodyStyle = document.body.style;
	
	    // Sniff prefixes
	    var vendorPrefix = 'WebkitTransform' in bodyStyle ? 'Webkit' : 'MozTransform' in bodyStyle ? 'Moz' : 'msTransform' in bodyStyle ? 'ms' : 'OTransform' in bodyStyle ? 'O' : '';
	
	    if (vendorPrefix + 'Perspective' in bodyStyle) {
	      // Modern browsers with 3D support, e.g. Webkit, IE10
	      return 'translate3d';
	    } else if (vendorPrefix + 'Transform' in bodyStyle) {
	      // Browsers without 3D support, e.g. IE9
	      return 'translate';
	    } else {
	      // Browsers without translate() support, e.g. IE7-8
	      return 'margin';
	    }
	  };
	
	  /**
	   * Helpers
	   */
	
	  function clamp(n, min, max) {
	    if (n < min) return min;
	    if (n > max) return max;
	    return n;
	  }
	
	  /**
	   * (Internal) converts a percentage (`0..1`) to a bar translateX
	   * percentage (`-100%..0%`).
	   */
	
	  function toBarPerc(n) {
	    return (-1 + n) * 100;
	  }
	
	  /**
	   * (Internal) returns the correct CSS for changing the bar's
	   * position given an n percentage, and speed and ease from Settings
	   */
	
	  function barPositionCSS(n, speed, ease) {
	    var barCSS;
	
	    if (Settings.positionUsing === 'translate3d') {
	      barCSS = { transform: 'translate3d(' + toBarPerc(n) + '%,0,0)' };
	    } else if (Settings.positionUsing === 'translate') {
	      barCSS = { transform: 'translate(' + toBarPerc(n) + '%,0)' };
	    } else {
	      barCSS = { 'margin-left': toBarPerc(n) + '%' };
	    }
	
	    barCSS.transition = 'all ' + speed + 'ms ' + ease;
	
	    return barCSS;
	  }
	
	  /**
	   * (Internal) Queues a function to be executed.
	   */
	
	  var queue = function () {
	    var pending = [];
	
	    function next() {
	      var fn = pending.shift();
	      if (fn) {
	        fn(next);
	      }
	    }
	
	    return function (fn) {
	      pending.push(fn);
	      if (pending.length == 1) next();
	    };
	  }();
	
	  /**
	   * (Internal) Applies css properties to an element, similar to the jQuery 
	   * css method.
	   *
	   * While this helper does assist with vendor prefixed property names, it 
	   * does not perform any manipulation of values prior to setting styles.
	   */
	
	  var css = function () {
	    var cssPrefixes = ['Webkit', 'O', 'Moz', 'ms'],
	        cssProps = {};
	
	    function camelCase(string) {
	      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function (match, letter) {
	        return letter.toUpperCase();
	      });
	    }
	
	    function getVendorProp(name) {
	      var style = document.body.style;
	      if (name in style) return name;
	
	      var i = cssPrefixes.length,
	          capName = name.charAt(0).toUpperCase() + name.slice(1),
	          vendorName;
	      while (i--) {
	        vendorName = cssPrefixes[i] + capName;
	        if (vendorName in style) return vendorName;
	      }
	
	      return name;
	    }
	
	    function getStyleProp(name) {
	      name = camelCase(name);
	      return cssProps[name] || (cssProps[name] = getVendorProp(name));
	    }
	
	    function applyCss(element, prop, value) {
	      prop = getStyleProp(prop);
	      element.style[prop] = value;
	    }
	
	    return function (element, properties) {
	      var args = arguments,
	          prop,
	          value;
	
	      if (args.length == 2) {
	        for (prop in properties) {
	          value = properties[prop];
	          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
	        }
	      } else {
	        applyCss(element, args[1], args[2]);
	      }
	    };
	  }();
	
	  /**
	   * (Internal) Determines if an element or space separated list of class names contains a class name.
	   */
	
	  function hasClass(element, name) {
	    var list = typeof element == 'string' ? element : classList(element);
	    return list.indexOf(' ' + name + ' ') >= 0;
	  }
	
	  /**
	   * (Internal) Adds a class to an element.
	   */
	
	  function addClass(element, name) {
	    var oldList = classList(element),
	        newList = oldList + name;
	
	    if (hasClass(oldList, name)) return;
	
	    // Trim the opening space.
	    element.className = newList.substring(1);
	  }
	
	  /**
	   * (Internal) Removes a class from an element.
	   */
	
	  function removeClass(element, name) {
	    var oldList = classList(element),
	        newList;
	
	    if (!hasClass(element, name)) return;
	
	    // Replace the class name.
	    newList = oldList.replace(' ' + name + ' ', ' ');
	
	    // Trim the opening and closing spaces.
	    element.className = newList.substring(1, newList.length - 1);
	  }
	
	  /**
	   * (Internal) Gets a space separated list of the class names on the element. 
	   * The list is wrapped with a single space on each end to facilitate finding 
	   * matches within the list.
	   */
	
	  function classList(element) {
	    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
	  }
	
	  /**
	   * (Internal) Removes an element from the DOM.
	   */
	
	  function removeElement(element) {
	    element && element.parentNode && element.parentNode.removeChild(element);
	  }
	
	  return NProgress;
	});

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
		Papa Parse
		v4.1.2
		https://github.com/mholt/PapaParse
	*/
	(function (global) {
		"use strict";
	
		var IS_WORKER = !global.document && !!global.postMessage,
		    IS_PAPA_WORKER = IS_WORKER && /(\?|&)papaworker(=|&|$)/.test(global.location.search),
		    LOADED_SYNC = false,
		    AUTO_SCRIPT_PATH;
		var workers = {},
		    workerIdCounter = 0;
	
		var Papa = {};
	
		Papa.parse = CsvToJson;
		Papa.unparse = JsonToCsv;
	
		Papa.RECORD_SEP = String.fromCharCode(30);
		Papa.UNIT_SEP = String.fromCharCode(31);
		Papa.BYTE_ORDER_MARK = "\uFEFF";
		Papa.BAD_DELIMITERS = ["\r", "\n", "\"", Papa.BYTE_ORDER_MARK];
		Papa.WORKERS_SUPPORTED = !IS_WORKER && !!global.Worker;
		Papa.SCRIPT_PATH = null; // Must be set by your code if you use workers and this lib is loaded asynchronously
	
		// Configurable chunk sizes for local and remote files, respectively
		Papa.LocalChunkSize = 1024 * 1024 * 10; // 10 MB
		Papa.RemoteChunkSize = 1024 * 1024 * 5; // 5 MB
		Papa.DefaultDelimiter = ","; // Used if not specified and detection fails
	
		// Exposed for testing and development only
		Papa.Parser = Parser;
		Papa.ParserHandle = ParserHandle;
		Papa.NetworkStreamer = NetworkStreamer;
		Papa.FileStreamer = FileStreamer;
		Papa.StringStreamer = StringStreamer;
	
		if (typeof module !== 'undefined' && module.exports) {
			// Export to Node...
			module.exports = Papa;
		} else if (isFunction(global.define) && global.define.amd) {
			// Wireup with RequireJS
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return Papa;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// ...or as browser global
			global.Papa = Papa;
		}
	
		if (global.jQuery) {
			var $ = global.jQuery;
			$.fn.parse = function (options) {
				var config = options.config || {};
				var queue = [];
	
				this.each(function (idx) {
					var supported = $(this).prop('tagName').toUpperCase() == "INPUT" && $(this).attr('type').toLowerCase() == "file" && global.FileReader;
	
					if (!supported || !this.files || this.files.length == 0) return true; // continue to next input element
	
					for (var i = 0; i < this.files.length; i++) {
						queue.push({
							file: this.files[i],
							inputElem: this,
							instanceConfig: $.extend({}, config)
						});
					}
				});
	
				parseNextFile(); // begin parsing
				return this; // maintains chainability
	
	
				function parseNextFile() {
					if (queue.length == 0) {
						if (isFunction(options.complete)) options.complete();
						return;
					}
	
					var f = queue[0];
	
					if (isFunction(options.before)) {
						var returned = options.before(f.file, f.inputElem);
	
						if ((typeof returned === "undefined" ? "undefined" : _typeof(returned)) === 'object') {
							if (returned.action == "abort") {
								error("AbortError", f.file, f.inputElem, returned.reason);
								return; // Aborts all queued files immediately
							} else if (returned.action == "skip") {
								fileComplete(); // parse the next file in the queue, if any
								return;
							} else if (_typeof(returned.config) === 'object') f.instanceConfig = $.extend(f.instanceConfig, returned.config);
						} else if (returned == "skip") {
							fileComplete(); // parse the next file in the queue, if any
							return;
						}
					}
	
					// Wrap up the user's complete callback, if any, so that ours also gets executed
					var userCompleteFunc = f.instanceConfig.complete;
					f.instanceConfig.complete = function (results) {
						if (isFunction(userCompleteFunc)) userCompleteFunc(results, f.file, f.inputElem);
						fileComplete();
					};
	
					Papa.parse(f.file, f.instanceConfig);
				}
	
				function error(name, file, elem, reason) {
					if (isFunction(options.error)) options.error({ name: name }, file, elem, reason);
				}
	
				function fileComplete() {
					queue.splice(0, 1);
					parseNextFile();
				}
			};
		}
	
		if (IS_PAPA_WORKER) {
			global.onmessage = workerThreadReceivedMessage;
		} else if (Papa.WORKERS_SUPPORTED) {
			AUTO_SCRIPT_PATH = getScriptPath();
	
			// Check if the script was loaded synchronously
			if (!document.body) {
				// Body doesn't exist yet, must be synchronous
				LOADED_SYNC = true;
			} else {
				document.addEventListener('DOMContentLoaded', function () {
					LOADED_SYNC = true;
				}, true);
			}
		}
	
		function CsvToJson(_input, _config) {
			_config = _config || {};
	
			if (_config.worker && Papa.WORKERS_SUPPORTED) {
				var w = newWorker();
	
				w.userStep = _config.step;
				w.userChunk = _config.chunk;
				w.userComplete = _config.complete;
				w.userError = _config.error;
	
				_config.step = isFunction(_config.step);
				_config.chunk = isFunction(_config.chunk);
				_config.complete = isFunction(_config.complete);
				_config.error = isFunction(_config.error);
				delete _config.worker; // prevent infinite loop
	
				w.postMessage({
					input: _input,
					config: _config,
					workerId: w.id
				});
	
				return;
			}
	
			var streamer = null;
			if (typeof _input === 'string') {
				if (_config.download) streamer = new NetworkStreamer(_config);else streamer = new StringStreamer(_config);
			} else if (global.File && _input instanceof File || _input instanceof Object) // ...Safari. (see issue #106)
				streamer = new FileStreamer(_config);
	
			return streamer.stream(_input);
		}
	
		function JsonToCsv(_input, _config) {
			var _output = "";
			var _fields = [];
	
			// Default configuration
	
			/** whether to surround every datum with quotes */
			var _quotes = false;
	
			/** delimiting character */
			var _delimiter = ",";
	
			/** newline character(s) */
			var _newline = "\r\n";
	
			unpackConfig();
	
			if (typeof _input === 'string') _input = JSON.parse(_input);
	
			if (_input instanceof Array) {
				if (!_input.length || _input[0] instanceof Array) return serialize(null, _input);else if (_typeof(_input[0]) === 'object') return serialize(objectKeys(_input[0]), _input);
			} else if ((typeof _input === "undefined" ? "undefined" : _typeof(_input)) === 'object') {
				if (typeof _input.data === 'string') _input.data = JSON.parse(_input.data);
	
				if (_input.data instanceof Array) {
					if (!_input.fields) _input.fields = _input.data[0] instanceof Array ? _input.fields : objectKeys(_input.data[0]);
	
					if (!(_input.data[0] instanceof Array) && _typeof(_input.data[0]) !== 'object') _input.data = [_input.data]; // handles input like [1,2,3] or ["asdf"]
				}
	
				return serialize(_input.fields || [], _input.data || []);
			}
	
			// Default (any valid paths should return before this)
			throw "exception: Unable to serialize unrecognized input";
	
			function unpackConfig() {
				if ((typeof _config === "undefined" ? "undefined" : _typeof(_config)) !== 'object') return;
	
				if (typeof _config.delimiter === 'string' && _config.delimiter.length == 1 && Papa.BAD_DELIMITERS.indexOf(_config.delimiter) == -1) {
					_delimiter = _config.delimiter;
				}
	
				if (typeof _config.quotes === 'boolean' || _config.quotes instanceof Array) _quotes = _config.quotes;
	
				if (typeof _config.newline === 'string') _newline = _config.newline;
			}
	
			/** Turns an object's keys into an array */
			function objectKeys(obj) {
				if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) !== 'object') return [];
				var keys = [];
				for (var key in obj) {
					keys.push(key);
				}return keys;
			}
	
			/** The double for loop that iterates the data and writes out a CSV string including header row */
			function serialize(fields, data) {
				var csv = "";
	
				if (typeof fields === 'string') fields = JSON.parse(fields);
				if (typeof data === 'string') data = JSON.parse(data);
	
				var hasHeader = fields instanceof Array && fields.length > 0;
				var dataKeyedByField = !(data[0] instanceof Array);
	
				// If there a header row, write it first
				if (hasHeader) {
					for (var i = 0; i < fields.length; i++) {
						if (i > 0) csv += _delimiter;
						csv += safe(fields[i], i);
					}
					if (data.length > 0) csv += _newline;
				}
	
				// Then write out the data
				for (var row = 0; row < data.length; row++) {
					var maxCol = hasHeader ? fields.length : data[row].length;
	
					for (var col = 0; col < maxCol; col++) {
						if (col > 0) csv += _delimiter;
						var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
						csv += safe(data[row][colIdx], col);
					}
	
					if (row < data.length - 1) csv += _newline;
				}
	
				return csv;
			}
	
			/** Encloses a value around quotes if needed (makes a value safe for CSV insertion) */
			function safe(str, col) {
				if (typeof str === "undefined" || str === null) return "";
	
				str = str.toString().replace(/"/g, '""');
	
				var needsQuotes = typeof _quotes === 'boolean' && _quotes || _quotes instanceof Array && _quotes[col] || hasAny(str, Papa.BAD_DELIMITERS) || str.indexOf(_delimiter) > -1 || str.charAt(0) == ' ' || str.charAt(str.length - 1) == ' ';
	
				return needsQuotes ? '"' + str + '"' : str;
			}
	
			function hasAny(str, substrings) {
				for (var i = 0; i < substrings.length; i++) {
					if (str.indexOf(substrings[i]) > -1) return true;
				}return false;
			}
		}
	
		/** ChunkStreamer is the base prototype for various streamer implementations. */
		function ChunkStreamer(config) {
			this._handle = null;
			this._paused = false;
			this._finished = false;
			this._input = null;
			this._baseIndex = 0;
			this._partialLine = "";
			this._rowCount = 0;
			this._start = 0;
			this._nextChunk = null;
			this.isFirstChunk = true;
			this._completeResults = {
				data: [],
				errors: [],
				meta: {}
			};
			replaceConfig.call(this, config);
	
			this.parseChunk = function (chunk) {
				// First chunk pre-processing
				if (this.isFirstChunk && isFunction(this._config.beforeFirstChunk)) {
					var modifiedChunk = this._config.beforeFirstChunk(chunk);
					if (modifiedChunk !== undefined) chunk = modifiedChunk;
				}
				this.isFirstChunk = false;
	
				// Rejoin the line we likely just split in two by chunking the file
				var aggregate = this._partialLine + chunk;
				this._partialLine = "";
	
				var results = this._handle.parse(aggregate, this._baseIndex, !this._finished);
	
				if (this._handle.paused() || this._handle.aborted()) return;
	
				var lastIndex = results.meta.cursor;
	
				if (!this._finished) {
					this._partialLine = aggregate.substring(lastIndex - this._baseIndex);
					this._baseIndex = lastIndex;
				}
	
				if (results && results.data) this._rowCount += results.data.length;
	
				var finishedIncludingPreview = this._finished || this._config.preview && this._rowCount >= this._config.preview;
	
				if (IS_PAPA_WORKER) {
					global.postMessage({
						results: results,
						workerId: Papa.WORKER_ID,
						finished: finishedIncludingPreview
					});
				} else if (isFunction(this._config.chunk)) {
					this._config.chunk(results, this._handle);
					if (this._paused) return;
					results = undefined;
					this._completeResults = undefined;
				}
	
				if (!this._config.step && !this._config.chunk) {
					this._completeResults.data = this._completeResults.data.concat(results.data);
					this._completeResults.errors = this._completeResults.errors.concat(results.errors);
					this._completeResults.meta = results.meta;
				}
	
				if (finishedIncludingPreview && isFunction(this._config.complete) && (!results || !results.meta.aborted)) this._config.complete(this._completeResults);
	
				if (!finishedIncludingPreview && (!results || !results.meta.paused)) this._nextChunk();
	
				return results;
			};
	
			this._sendError = function (error) {
				if (isFunction(this._config.error)) this._config.error(error);else if (IS_PAPA_WORKER && this._config.error) {
					global.postMessage({
						workerId: Papa.WORKER_ID,
						error: error,
						finished: false
					});
				}
			};
	
			function replaceConfig(config) {
				// Deep-copy the config so we can edit it
				var configCopy = copy(config);
				configCopy.chunkSize = parseInt(configCopy.chunkSize); // parseInt VERY important so we don't concatenate strings!
				if (!config.step && !config.chunk) configCopy.chunkSize = null; // disable Range header if not streaming; bad values break IIS - see issue #196
				this._handle = new ParserHandle(configCopy);
				this._handle.streamer = this;
				this._config = configCopy; // persist the copy to the caller
			}
		}
	
		function NetworkStreamer(config) {
			config = config || {};
			if (!config.chunkSize) config.chunkSize = Papa.RemoteChunkSize;
			ChunkStreamer.call(this, config);
	
			var xhr;
	
			if (IS_WORKER) {
				this._nextChunk = function () {
					this._readChunk();
					this._chunkLoaded();
				};
			} else {
				this._nextChunk = function () {
					this._readChunk();
				};
			}
	
			this.stream = function (url) {
				this._input = url;
				this._nextChunk(); // Starts streaming
			};
	
			this._readChunk = function () {
				if (this._finished) {
					this._chunkLoaded();
					return;
				}
	
				xhr = new XMLHttpRequest();
	
				if (!IS_WORKER) {
					xhr.onload = bindFunction(this._chunkLoaded, this);
					xhr.onerror = bindFunction(this._chunkError, this);
				}
	
				xhr.open("GET", this._input, !IS_WORKER);
	
				if (this._config.chunkSize) {
					var end = this._start + this._config.chunkSize - 1; // minus one because byte range is inclusive
					xhr.setRequestHeader("Range", "bytes=" + this._start + "-" + end);
					xhr.setRequestHeader("If-None-Match", "webkit-no-cache"); // https://bugs.webkit.org/show_bug.cgi?id=82672
				}
	
				try {
					xhr.send();
				} catch (err) {
					this._chunkError(err.message);
				}
	
				if (IS_WORKER && xhr.status == 0) this._chunkError();else this._start += this._config.chunkSize;
			};
	
			this._chunkLoaded = function () {
				if (xhr.readyState != 4) return;
	
				if (xhr.status < 200 || xhr.status >= 400) {
					this._chunkError();
					return;
				}
	
				this._finished = !this._config.chunkSize || this._start > getFileSize(xhr);
				this.parseChunk(xhr.responseText);
			};
	
			this._chunkError = function (errorMessage) {
				var errorText = xhr.statusText || errorMessage;
				this._sendError(errorText);
			};
	
			function getFileSize(xhr) {
				var contentRange = xhr.getResponseHeader("Content-Range");
				return parseInt(contentRange.substr(contentRange.lastIndexOf("/") + 1));
			}
		}
		NetworkStreamer.prototype = Object.create(ChunkStreamer.prototype);
		NetworkStreamer.prototype.constructor = NetworkStreamer;
	
		function FileStreamer(config) {
			config = config || {};
			if (!config.chunkSize) config.chunkSize = Papa.LocalChunkSize;
			ChunkStreamer.call(this, config);
	
			var reader, slice;
	
			// FileReader is better than FileReaderSync (even in worker) - see http://stackoverflow.com/q/24708649/1048862
			// But Firefox is a pill, too - see issue #76: https://github.com/mholt/PapaParse/issues/76
			var usingAsyncReader = typeof FileReader !== 'undefined'; // Safari doesn't consider it a function - see issue #105
	
			this.stream = function (file) {
				this._input = file;
				slice = file.slice || file.webkitSlice || file.mozSlice;
	
				if (usingAsyncReader) {
					reader = new FileReader(); // Preferred method of reading files, even in workers
					reader.onload = bindFunction(this._chunkLoaded, this);
					reader.onerror = bindFunction(this._chunkError, this);
				} else reader = new FileReaderSync(); // Hack for running in a web worker in Firefox
	
				this._nextChunk(); // Starts streaming
			};
	
			this._nextChunk = function () {
				if (!this._finished && (!this._config.preview || this._rowCount < this._config.preview)) this._readChunk();
			};
	
			this._readChunk = function () {
				var input = this._input;
				if (this._config.chunkSize) {
					var end = Math.min(this._start + this._config.chunkSize, this._input.size);
					input = slice.call(input, this._start, end);
				}
				var txt = reader.readAsText(input, this._config.encoding);
				if (!usingAsyncReader) this._chunkLoaded({ target: { result: txt } }); // mimic the async signature
			};
	
			this._chunkLoaded = function (event) {
				// Very important to increment start each time before handling results
				this._start += this._config.chunkSize;
				this._finished = !this._config.chunkSize || this._start >= this._input.size;
				this.parseChunk(event.target.result);
			};
	
			this._chunkError = function () {
				this._sendError(reader.error);
			};
		}
		FileStreamer.prototype = Object.create(ChunkStreamer.prototype);
		FileStreamer.prototype.constructor = FileStreamer;
	
		function StringStreamer(config) {
			config = config || {};
			ChunkStreamer.call(this, config);
	
			var string;
			var remaining;
			this.stream = function (s) {
				string = s;
				remaining = s;
				return this._nextChunk();
			};
			this._nextChunk = function () {
				if (this._finished) return;
				var size = this._config.chunkSize;
				var chunk = size ? remaining.substr(0, size) : remaining;
				remaining = size ? remaining.substr(size) : '';
				this._finished = !remaining;
				return this.parseChunk(chunk);
			};
		}
		StringStreamer.prototype = Object.create(StringStreamer.prototype);
		StringStreamer.prototype.constructor = StringStreamer;
	
		// Use one ParserHandle per entire CSV file or string
		function ParserHandle(_config) {
			// One goal is to minimize the use of regular expressions...
			var FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;
	
			var self = this;
			var _stepCounter = 0; // Number of times step was called (number of rows parsed)
			var _input; // The input being parsed
			var _parser; // The core parser being used
			var _paused = false; // Whether we are paused or not
			var _aborted = false; // Whether the parser has aborted or not
			var _delimiterError; // Temporary state between delimiter detection and processing results
			var _fields = []; // Fields are from the header row of the input, if there is one
			var _results = { // The last results returned from the parser
				data: [],
				errors: [],
				meta: {}
			};
	
			if (isFunction(_config.step)) {
				var userStep = _config.step;
				_config.step = function (results) {
					_results = results;
	
					if (needsHeaderRow()) processResults();else // only call user's step function after header row
						{
							processResults();
	
							// It's possbile that this line was empty and there's no row here after all
							if (_results.data.length == 0) return;
	
							_stepCounter += results.data.length;
							if (_config.preview && _stepCounter > _config.preview) _parser.abort();else userStep(_results, self);
						}
				};
			}
	
			/**
	   * Parses input. Most users won't need, and shouldn't mess with, the baseIndex
	   * and ignoreLastRow parameters. They are used by streamers (wrapper functions)
	   * when an input comes in multiple chunks, like from a file.
	   */
			this.parse = function (input, baseIndex, ignoreLastRow) {
				if (!_config.newline) _config.newline = guessLineEndings(input);
	
				_delimiterError = false;
				if (!_config.delimiter) {
					var delimGuess = guessDelimiter(input);
					if (delimGuess.successful) _config.delimiter = delimGuess.bestDelimiter;else {
						_delimiterError = true; // add error after parsing (otherwise it would be overwritten)
						_config.delimiter = Papa.DefaultDelimiter;
					}
					_results.meta.delimiter = _config.delimiter;
				}
	
				var parserConfig = copy(_config);
				if (_config.preview && _config.header) parserConfig.preview++; // to compensate for header row
	
				_input = input;
				_parser = new Parser(parserConfig);
				_results = _parser.parse(_input, baseIndex, ignoreLastRow);
				processResults();
				return _paused ? { meta: { paused: true } } : _results || { meta: { paused: false } };
			};
	
			this.paused = function () {
				return _paused;
			};
	
			this.pause = function () {
				_paused = true;
				_parser.abort();
				_input = _input.substr(_parser.getCharIndex());
			};
	
			this.resume = function () {
				_paused = false;
				self.streamer.parseChunk(_input);
			};
	
			this.aborted = function () {
				return _aborted;
			};
	
			this.abort = function () {
				_aborted = true;
				_parser.abort();
				_results.meta.aborted = true;
				if (isFunction(_config.complete)) _config.complete(_results);
				_input = "";
			};
	
			function processResults() {
				if (_results && _delimiterError) {
					addError("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + Papa.DefaultDelimiter + "'");
					_delimiterError = false;
				}
	
				if (_config.skipEmptyLines) {
					for (var i = 0; i < _results.data.length; i++) {
						if (_results.data[i].length == 1 && _results.data[i][0] == "") _results.data.splice(i--, 1);
					}
				}
	
				if (needsHeaderRow()) fillHeaderFields();
	
				return applyHeaderAndDynamicTyping();
			}
	
			function needsHeaderRow() {
				return _config.header && _fields.length == 0;
			}
	
			function fillHeaderFields() {
				if (!_results) return;
				for (var i = 0; needsHeaderRow() && i < _results.data.length; i++) {
					for (var j = 0; j < _results.data[i].length; j++) {
						_fields.push(_results.data[i][j]);
					}
				}_results.data.splice(0, 1);
			}
	
			function applyHeaderAndDynamicTyping() {
				if (!_results || !_config.header && !_config.dynamicTyping) return _results;
	
				for (var i = 0; i < _results.data.length; i++) {
					var row = {};
	
					for (var j = 0; j < _results.data[i].length; j++) {
						if (_config.dynamicTyping) {
							var value = _results.data[i][j];
							if (value == "true" || value == "TRUE") _results.data[i][j] = true;else if (value == "false" || value == "FALSE") _results.data[i][j] = false;else _results.data[i][j] = tryParseFloat(value);
						}
	
						if (_config.header) {
							if (j >= _fields.length) {
								if (!row["__parsed_extra"]) row["__parsed_extra"] = [];
								row["__parsed_extra"].push(_results.data[i][j]);
							} else row[_fields[j]] = _results.data[i][j];
						}
					}
	
					if (_config.header) {
						_results.data[i] = row;
						if (j > _fields.length) addError("FieldMismatch", "TooManyFields", "Too many fields: expected " + _fields.length + " fields but parsed " + j, i);else if (j < _fields.length) addError("FieldMismatch", "TooFewFields", "Too few fields: expected " + _fields.length + " fields but parsed " + j, i);
					}
				}
	
				if (_config.header && _results.meta) _results.meta.fields = _fields;
				return _results;
			}
	
			function guessDelimiter(input) {
				var delimChoices = [",", "\t", "|", ";", Papa.RECORD_SEP, Papa.UNIT_SEP];
				var bestDelim, bestDelta, fieldCountPrevRow;
	
				for (var i = 0; i < delimChoices.length; i++) {
					var delim = delimChoices[i];
					var delta = 0,
					    avgFieldCount = 0;
					fieldCountPrevRow = undefined;
	
					var preview = new Parser({
						delimiter: delim,
						preview: 10
					}).parse(input);
	
					for (var j = 0; j < preview.data.length; j++) {
						var fieldCount = preview.data[j].length;
						avgFieldCount += fieldCount;
	
						if (typeof fieldCountPrevRow === 'undefined') {
							fieldCountPrevRow = fieldCount;
							continue;
						} else if (fieldCount > 1) {
							delta += Math.abs(fieldCount - fieldCountPrevRow);
							fieldCountPrevRow = fieldCount;
						}
					}
	
					if (preview.data.length > 0) avgFieldCount /= preview.data.length;
	
					if ((typeof bestDelta === 'undefined' || delta < bestDelta) && avgFieldCount > 1.99) {
						bestDelta = delta;
						bestDelim = delim;
					}
				}
	
				_config.delimiter = bestDelim;
	
				return {
					successful: !!bestDelim,
					bestDelimiter: bestDelim
				};
			}
	
			function guessLineEndings(input) {
				input = input.substr(0, 1024 * 1024); // max length 1 MB
	
				var r = input.split('\r');
	
				if (r.length == 1) return '\n';
	
				var numWithN = 0;
				for (var i = 0; i < r.length; i++) {
					if (r[i][0] == '\n') numWithN++;
				}
	
				return numWithN >= r.length / 2 ? '\r\n' : '\r';
			}
	
			function tryParseFloat(val) {
				var isNumber = FLOAT.test(val);
				return isNumber ? parseFloat(val) : val;
			}
	
			function addError(type, code, msg, row) {
				_results.errors.push({
					type: type,
					code: code,
					message: msg,
					row: row
				});
			}
		}
	
		/** The core parser implements speedy and correct CSV parsing */
		function Parser(config) {
			// Unpack the config object
			config = config || {};
			var delim = config.delimiter;
			var newline = config.newline;
			var comments = config.comments;
			var step = config.step;
			var preview = config.preview;
			var fastMode = config.fastMode;
	
			// Delimiter must be valid
			if (typeof delim !== 'string' || Papa.BAD_DELIMITERS.indexOf(delim) > -1) delim = ",";
	
			// Comment character must be valid
			if (comments === delim) throw "Comment character same as delimiter";else if (comments === true) comments = "#";else if (typeof comments !== 'string' || Papa.BAD_DELIMITERS.indexOf(comments) > -1) comments = false;
	
			// Newline must be valid: \r, \n, or \r\n
			if (newline != '\n' && newline != '\r' && newline != '\r\n') newline = '\n';
	
			// We're gonna need these at the Parser scope
			var cursor = 0;
			var aborted = false;
	
			this.parse = function (input, baseIndex, ignoreLastRow) {
				// For some reason, in Chrome, this speeds things up (!?)
				if (typeof input !== 'string') throw "Input must be a string";
	
				// We don't need to compute some of these every time parse() is called,
				// but having them in a more local scope seems to perform better
				var inputLen = input.length,
				    delimLen = delim.length,
				    newlineLen = newline.length,
				    commentsLen = comments.length;
				var stepIsFunction = typeof step === 'function';
	
				// Establish starting state
				cursor = 0;
				var data = [],
				    errors = [],
				    row = [],
				    lastCursor = 0;
	
				if (!input) return returnable();
	
				if (fastMode || fastMode !== false && input.indexOf('"') === -1) {
					var rows = input.split(newline);
					for (var i = 0; i < rows.length; i++) {
						var row = rows[i];
						cursor += row.length;
						if (i !== rows.length - 1) cursor += newline.length;else if (ignoreLastRow) return returnable();
						if (comments && row.substr(0, commentsLen) == comments) continue;
						if (stepIsFunction) {
							data = [];
							pushRow(row.split(delim));
							doStep();
							if (aborted) return returnable();
						} else pushRow(row.split(delim));
						if (preview && i >= preview) {
							data = data.slice(0, preview);
							return returnable(true);
						}
					}
					return returnable();
				}
	
				var nextDelim = input.indexOf(delim, cursor);
				var nextNewline = input.indexOf(newline, cursor);
	
				// Parser loop
				for (;;) {
					// Field has opening quote
					if (input[cursor] == '"') {
						// Start our search for the closing quote where the cursor is
						var quoteSearch = cursor;
	
						// Skip the opening quote
						cursor++;
	
						for (;;) {
							// Find closing quote
							var quoteSearch = input.indexOf('"', quoteSearch + 1);
	
							if (quoteSearch === -1) {
								if (!ignoreLastRow) {
									// No closing quote... what a pity
									errors.push({
										type: "Quotes",
										code: "MissingQuotes",
										message: "Quoted field unterminated",
										row: data.length, // row has yet to be inserted
										index: cursor
									});
								}
								return finish();
							}
	
							if (quoteSearch === inputLen - 1) {
								// Closing quote at EOF
								var value = input.substring(cursor, quoteSearch).replace(/""/g, '"');
								return finish(value);
							}
	
							// If this quote is escaped, it's part of the data; skip it
							if (input[quoteSearch + 1] == '"') {
								quoteSearch++;
								continue;
							}
	
							if (input[quoteSearch + 1] == delim) {
								// Closing quote followed by delimiter
								row.push(input.substring(cursor, quoteSearch).replace(/""/g, '"'));
								cursor = quoteSearch + 1 + delimLen;
								nextDelim = input.indexOf(delim, cursor);
								nextNewline = input.indexOf(newline, cursor);
								break;
							}
	
							if (input.substr(quoteSearch + 1, newlineLen) === newline) {
								// Closing quote followed by newline
								row.push(input.substring(cursor, quoteSearch).replace(/""/g, '"'));
								saveRow(quoteSearch + 1 + newlineLen);
								nextDelim = input.indexOf(delim, cursor); // because we may have skipped the nextDelim in the quoted field
	
								if (stepIsFunction) {
									doStep();
									if (aborted) return returnable();
								}
	
								if (preview && data.length >= preview) return returnable(true);
	
								break;
							}
						}
	
						continue;
					}
	
					// Comment found at start of new line
					if (comments && row.length === 0 && input.substr(cursor, commentsLen) === comments) {
						if (nextNewline == -1) // Comment ends at EOF
							return returnable();
						cursor = nextNewline + newlineLen;
						nextNewline = input.indexOf(newline, cursor);
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// Next delimiter comes before next newline, so we've reached end of field
					if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1)) {
						row.push(input.substring(cursor, nextDelim));
						cursor = nextDelim + delimLen;
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// End of row
					if (nextNewline !== -1) {
						row.push(input.substring(cursor, nextNewline));
						saveRow(nextNewline + newlineLen);
	
						if (stepIsFunction) {
							doStep();
							if (aborted) return returnable();
						}
	
						if (preview && data.length >= preview) return returnable(true);
	
						continue;
					}
	
					break;
				}
	
				return finish();
	
				function pushRow(row) {
					data.push(row);
					lastCursor = cursor;
				}
	
				/**
	    * Appends the remaining input from cursor to the end into
	    * row, saves the row, calls step, and returns the results.
	    */
				function finish(value) {
					if (ignoreLastRow) return returnable();
					if (typeof value === 'undefined') value = input.substr(cursor);
					row.push(value);
					cursor = inputLen; // important in case parsing is paused
					pushRow(row);
					if (stepIsFunction) doStep();
					return returnable();
				}
	
				/**
	    * Appends the current row to the results. It sets the cursor
	    * to newCursor and finds the nextNewline. The caller should
	    * take care to execute user's step function and check for
	    * preview and end parsing if necessary.
	    */
				function saveRow(newCursor) {
					cursor = newCursor;
					pushRow(row);
					row = [];
					nextNewline = input.indexOf(newline, cursor);
				}
	
				/** Returns an object with the results, errors, and meta. */
				function returnable(stopped) {
					return {
						data: data,
						errors: errors,
						meta: {
							delimiter: delim,
							linebreak: newline,
							aborted: aborted,
							truncated: !!stopped,
							cursor: lastCursor + (baseIndex || 0)
						}
					};
				}
	
				/** Executes the user's step function and resets data & errors. */
				function doStep() {
					step(returnable());
					data = [], errors = [];
				}
			};
	
			/** Sets the abort flag */
			this.abort = function () {
				aborted = true;
			};
	
			/** Gets the cursor position */
			this.getCharIndex = function () {
				return cursor;
			};
		}
	
		// If you need to load Papa Parse asynchronously and you also need worker threads, hard-code
		// the script path here. See: https://github.com/mholt/PapaParse/issues/87#issuecomment-57885358
		function getScriptPath() {
			var scripts = document.getElementsByTagName('script');
			return scripts.length ? scripts[scripts.length - 1].src : '';
		}
	
		function newWorker() {
			if (!Papa.WORKERS_SUPPORTED) return false;
			if (!LOADED_SYNC && Papa.SCRIPT_PATH === null) throw new Error('Script path cannot be determined automatically when Papa Parse is loaded asynchronously. ' + 'You need to set Papa.SCRIPT_PATH manually.');
			var workerUrl = Papa.SCRIPT_PATH || AUTO_SCRIPT_PATH;
			// Append "papaworker" to the search string to tell papaparse that this is our worker.
			workerUrl += (workerUrl.indexOf('?') !== -1 ? '&' : '?') + 'papaworker';
			var w = new global.Worker(workerUrl);
			w.onmessage = mainThreadReceivedMessage;
			w.id = workerIdCounter++;
			workers[w.id] = w;
			return w;
		}
	
		/** Callback when main thread receives a message */
		function mainThreadReceivedMessage(e) {
			var msg = e.data;
			var worker = workers[msg.workerId];
			var aborted = false;
	
			if (msg.error) worker.userError(msg.error, msg.file);else if (msg.results && msg.results.data) {
				var abort = function abort() {
					aborted = true;
					completeWorker(msg.workerId, { data: [], errors: [], meta: { aborted: true } });
				};
	
				var handle = {
					abort: abort,
					pause: notImplemented,
					resume: notImplemented
				};
	
				if (isFunction(worker.userStep)) {
					for (var i = 0; i < msg.results.data.length; i++) {
						worker.userStep({
							data: [msg.results.data[i]],
							errors: msg.results.errors,
							meta: msg.results.meta
						}, handle);
						if (aborted) break;
					}
					delete msg.results; // free memory ASAP
				} else if (isFunction(worker.userChunk)) {
					worker.userChunk(msg.results, handle, msg.file);
					delete msg.results;
				}
			}
	
			if (msg.finished && !aborted) completeWorker(msg.workerId, msg.results);
		}
	
		function completeWorker(workerId, results) {
			var worker = workers[workerId];
			if (isFunction(worker.userComplete)) worker.userComplete(results);
			worker.terminate();
			delete workers[workerId];
		}
	
		function notImplemented() {
			throw "Not implemented.";
		}
	
		/** Callback when worker thread receives a message */
		function workerThreadReceivedMessage(e) {
			var msg = e.data;
	
			if (typeof Papa.WORKER_ID === 'undefined' && msg) Papa.WORKER_ID = msg.workerId;
	
			if (typeof msg.input === 'string') {
				global.postMessage({
					workerId: Papa.WORKER_ID,
					results: Papa.parse(msg.input, msg.config),
					finished: true
				});
			} else if (global.File && msg.input instanceof File || msg.input instanceof Object) // thank you, Safari (see issue #106)
				{
					var results = Papa.parse(msg.input, msg.config);
					if (results) global.postMessage({
						workerId: Papa.WORKER_ID,
						results: results,
						finished: true
					});
				}
		}
	
		/** Makes a deep copy of an array or object (mostly) */
		function copy(obj) {
			if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) !== 'object') return obj;
			var cpy = obj instanceof Array ? [] : {};
			for (var key in obj) {
				cpy[key] = copy(obj[key]);
			}return cpy;
		}
	
		function bindFunction(f, self) {
			return function () {
				f.apply(self, arguments);
			};
		}
	
		function isFunction(func) {
			return typeof func === 'function';
		}
	})(typeof window !== 'undefined' ? window : undefined);

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Selection save and restore module for Rangy.
	 * Saves and restores user selections using marker invisible elements in the DOM.
	 *
	 * Part of Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Depends on Rangy core.
	 *
	 * Copyright 2015, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.0
	 * Build date: 10 May 2015
	 */
	(function (factory, root) {
	    if (true) {
	        // AMD. Register as an anonymous module with a dependency on Rangy.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(135)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module != "undefined" && (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == "object") {
	        // Node/CommonJS style
	        module.exports = factory(require("rangy"));
	    } else {
	        // No AMD or CommonJS support so we use the rangy property of root (probably the global variable)
	        factory(root.rangy);
	    }
	})(function (rangy) {
	    rangy.createModule("SaveRestore", ["WrappedRange"], function (api, module) {
	        var dom = api.dom;
	        var removeNode = dom.removeNode;
	        var isDirectionBackward = api.Selection.isDirectionBackward;
	        var markerTextChar = "\uFEFF";
	
	        function gEBI(id, doc) {
	            return (doc || document).getElementById(id);
	        }
	
	        function insertRangeBoundaryMarker(range, atStart) {
	            var markerId = "selectionBoundary_" + +new Date() + "_" + ("" + Math.random()).slice(2);
	            var markerEl;
	            var doc = dom.getDocument(range.startContainer);
	
	            // Clone the Range and collapse to the appropriate boundary point
	            var boundaryRange = range.cloneRange();
	            boundaryRange.collapse(atStart);
	
	            // Create the marker element containing a single invisible character using DOM methods and insert it
	            markerEl = doc.createElement("span");
	            markerEl.id = markerId;
	            markerEl.style.lineHeight = "0";
	            markerEl.style.display = "none";
	            markerEl.className = "rangySelectionBoundary";
	            markerEl.appendChild(doc.createTextNode(markerTextChar));
	
	            boundaryRange.insertNode(markerEl);
	            return markerEl;
	        }
	
	        function setRangeBoundary(doc, range, markerId, atStart) {
	            var markerEl = gEBI(markerId, doc);
	            if (markerEl) {
	                range[atStart ? "setStartBefore" : "setEndBefore"](markerEl);
	                removeNode(markerEl);
	            } else {
	                module.warn("Marker element has been removed. Cannot restore selection.");
	            }
	        }
	
	        function compareRanges(r1, r2) {
	            return r2.compareBoundaryPoints(r1.START_TO_START, r1);
	        }
	
	        function saveRange(range, direction) {
	            var startEl,
	                endEl,
	                doc = api.DomRange.getRangeDocument(range),
	                text = range.toString();
	            var backward = isDirectionBackward(direction);
	
	            if (range.collapsed) {
	                endEl = insertRangeBoundaryMarker(range, false);
	                return {
	                    document: doc,
	                    markerId: endEl.id,
	                    collapsed: true
	                };
	            } else {
	                endEl = insertRangeBoundaryMarker(range, false);
	                startEl = insertRangeBoundaryMarker(range, true);
	
	                return {
	                    document: doc,
	                    startMarkerId: startEl.id,
	                    endMarkerId: endEl.id,
	                    collapsed: false,
	                    backward: backward,
	                    toString: function toString() {
	                        return "original text: '" + text + "', new text: '" + range.toString() + "'";
	                    }
	                };
	            }
	        }
	
	        function restoreRange(rangeInfo, normalize) {
	            var doc = rangeInfo.document;
	            if (typeof normalize == "undefined") {
	                normalize = true;
	            }
	            var range = api.createRange(doc);
	            if (rangeInfo.collapsed) {
	                var markerEl = gEBI(rangeInfo.markerId, doc);
	                if (markerEl) {
	                    markerEl.style.display = "inline";
	                    var previousNode = markerEl.previousSibling;
	
	                    // Workaround for issue 17
	                    if (previousNode && previousNode.nodeType == 3) {
	                        removeNode(markerEl);
	                        range.collapseToPoint(previousNode, previousNode.length);
	                    } else {
	                        range.collapseBefore(markerEl);
	                        removeNode(markerEl);
	                    }
	                } else {
	                    module.warn("Marker element has been removed. Cannot restore selection.");
	                }
	            } else {
	                setRangeBoundary(doc, range, rangeInfo.startMarkerId, true);
	                setRangeBoundary(doc, range, rangeInfo.endMarkerId, false);
	            }
	
	            if (normalize) {
	                range.normalizeBoundaries();
	            }
	
	            return range;
	        }
	
	        function saveRanges(ranges, direction) {
	            var rangeInfos = [],
	                range,
	                doc;
	            var backward = isDirectionBackward(direction);
	
	            // Order the ranges by position within the DOM, latest first, cloning the array to leave the original untouched
	            ranges = ranges.slice(0);
	            ranges.sort(compareRanges);
	
	            for (var i = 0, len = ranges.length; i < len; ++i) {
	                rangeInfos[i] = saveRange(ranges[i], backward);
	            }
	
	            // Now that all the markers are in place and DOM manipulation over, adjust each range's boundaries to lie
	            // between its markers
	            for (i = len - 1; i >= 0; --i) {
	                range = ranges[i];
	                doc = api.DomRange.getRangeDocument(range);
	                if (range.collapsed) {
	                    range.collapseAfter(gEBI(rangeInfos[i].markerId, doc));
	                } else {
	                    range.setEndBefore(gEBI(rangeInfos[i].endMarkerId, doc));
	                    range.setStartAfter(gEBI(rangeInfos[i].startMarkerId, doc));
	                }
	            }
	
	            return rangeInfos;
	        }
	
	        function saveSelection(win) {
	            if (!api.isSelectionValid(win)) {
	                module.warn("Cannot save selection. This usually happens when the selection is collapsed and the selection document has lost focus.");
	                return null;
	            }
	            var sel = api.getSelection(win);
	            var ranges = sel.getAllRanges();
	            var backward = ranges.length == 1 && sel.isBackward();
	
	            var rangeInfos = saveRanges(ranges, backward);
	
	            // Ensure current selection is unaffected
	            if (backward) {
	                sel.setSingleRange(ranges[0], backward);
	            } else {
	                sel.setRanges(ranges);
	            }
	
	            return {
	                win: win,
	                rangeInfos: rangeInfos,
	                restored: false
	            };
	        }
	
	        function restoreRanges(rangeInfos) {
	            var ranges = [];
	
	            // Ranges are in reverse order of appearance in the DOM. We want to restore earliest first to avoid
	            // normalization affecting previously restored ranges.
	            var rangeCount = rangeInfos.length;
	
	            for (var i = rangeCount - 1; i >= 0; i--) {
	                ranges[i] = restoreRange(rangeInfos[i], true);
	            }
	
	            return ranges;
	        }
	
	        function restoreSelection(savedSelection, preserveDirection) {
	            if (!savedSelection.restored) {
	                var rangeInfos = savedSelection.rangeInfos;
	                var sel = api.getSelection(savedSelection.win);
	                var ranges = restoreRanges(rangeInfos),
	                    rangeCount = rangeInfos.length;
	
	                if (rangeCount == 1 && preserveDirection && api.features.selectionHasExtend && rangeInfos[0].backward) {
	                    sel.removeAllRanges();
	                    sel.addRange(ranges[0], true);
	                } else {
	                    sel.setRanges(ranges);
	                }
	
	                savedSelection.restored = true;
	            }
	        }
	
	        function removeMarkerElement(doc, markerId) {
	            var markerEl = gEBI(markerId, doc);
	            if (markerEl) {
	                removeNode(markerEl);
	            }
	        }
	
	        function removeMarkers(savedSelection) {
	            var rangeInfos = savedSelection.rangeInfos;
	            for (var i = 0, len = rangeInfos.length, rangeInfo; i < len; ++i) {
	                rangeInfo = rangeInfos[i];
	                if (rangeInfo.collapsed) {
	                    removeMarkerElement(savedSelection.doc, rangeInfo.markerId);
	                } else {
	                    removeMarkerElement(savedSelection.doc, rangeInfo.startMarkerId);
	                    removeMarkerElement(savedSelection.doc, rangeInfo.endMarkerId);
	                }
	            }
	        }
	
	        api.util.extend(api, {
	            saveRange: saveRange,
	            restoreRange: restoreRange,
	            saveRanges: saveRanges,
	            restoreRanges: restoreRanges,
	            saveSelection: saveSelection,
	            restoreSelection: restoreSelection,
	            removeMarkerElement: removeMarkerElement,
	            removeMarkers: removeMarkers
	        });
	    });
	
	    return rangy;
	}, undefined);

/***/ },
/* 329 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Restful Resources service for AngularJS apps
	 * @version v1.5.2 - 2016-02-08 * @link https://github.com/mgonto/restangular
	 * @author Martin Gontovnikas <martin@gon.to>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */!function () {
	  var a = angular.module("restangular", []);a.provider("Restangular", function () {
	    var a = {};a.init = function (a, b) {
	      function c(a, b, c, d) {
	        var e = {};return _.each(_.keys(d), function (f) {
	          var g = d[f];g.params = _.extend({}, g.params, a.defaultRequestParams[g.method.toLowerCase()]), _.isEmpty(g.params) && delete g.params, a.isSafe(g.method) ? e[f] = function () {
	            return b(_.extend(g, { url: c }));
	          } : e[f] = function (a) {
	            return b(_.extend(g, { url: c, data: a }));
	          };
	        }), e;
	      }a.configuration = b;var d = ["get", "head", "options", "trace", "getlist"];b.isSafe = function (a) {
	        return _.includes(d, a.toLowerCase());
	      };var e = /^https?:\/\//i;b.isAbsoluteUrl = function (a) {
	        return _.isUndefined(b.absoluteUrl) || _.isNull(b.absoluteUrl) ? a && e.test(a) : b.absoluteUrl;
	      }, b.absoluteUrl = _.isUndefined(b.absoluteUrl) ? !0 : b.absoluteUrl, a.setSelfLinkAbsoluteUrl = function (a) {
	        b.absoluteUrl = a;
	      }, b.baseUrl = _.isUndefined(b.baseUrl) ? "" : b.baseUrl, a.setBaseUrl = function (a) {
	        return b.baseUrl = /\/$/.test(a) ? a.substring(0, a.length - 1) : a, this;
	      }, b.extraFields = b.extraFields || [], a.setExtraFields = function (a) {
	        return b.extraFields = a, this;
	      }, b.defaultHttpFields = b.defaultHttpFields || {}, a.setDefaultHttpFields = function (a) {
	        return b.defaultHttpFields = a, this;
	      }, b.withHttpValues = function (a, c) {
	        return _.defaults(c, a, b.defaultHttpFields);
	      }, b.encodeIds = _.isUndefined(b.encodeIds) ? !0 : b.encodeIds, a.setEncodeIds = function (a) {
	        b.encodeIds = a;
	      }, b.defaultRequestParams = b.defaultRequestParams || { get: {}, post: {}, put: {}, remove: {}, common: {} }, a.setDefaultRequestParams = function (a, c) {
	        var d = [],
	            e = c || a;return _.isUndefined(c) ? d.push("common") : _.isArray(a) ? d = a : d.push(a), _.each(d, function (a) {
	          b.defaultRequestParams[a] = e;
	        }), this;
	      }, a.requestParams = b.defaultRequestParams, b.defaultHeaders = b.defaultHeaders || {}, a.setDefaultHeaders = function (c) {
	        return b.defaultHeaders = c, a.defaultHeaders = b.defaultHeaders, this;
	      }, a.defaultHeaders = b.defaultHeaders, b.methodOverriders = b.methodOverriders || [], a.setMethodOverriders = function (a) {
	        var c = _.extend([], a);return b.isOverridenMethod("delete", c) && c.push("remove"), b.methodOverriders = c, this;
	      }, b.jsonp = _.isUndefined(b.jsonp) ? !1 : b.jsonp, a.setJsonp = function (a) {
	        b.jsonp = a;
	      }, b.isOverridenMethod = function (a, c) {
	        var d = c || b.methodOverriders;return !_.isUndefined(_.find(d, function (b) {
	          return b.toLowerCase() === a.toLowerCase();
	        }));
	      }, b.urlCreator = b.urlCreator || "path", a.setUrlCreator = function (a) {
	        if (!_.has(b.urlCreatorFactory, a)) throw new Error("URL Path selected isn't valid");return b.urlCreator = a, this;
	      }, b.restangularFields = b.restangularFields || { id: "id", route: "route", parentResource: "parentResource", restangularCollection: "restangularCollection", cannonicalId: "__cannonicalId", etag: "restangularEtag", selfLink: "href", get: "get", getList: "getList", put: "put", post: "post", remove: "remove", head: "head", trace: "trace", options: "options", patch: "patch", getRestangularUrl: "getRestangularUrl", getRequestedUrl: "getRequestedUrl", putElement: "putElement", addRestangularMethod: "addRestangularMethod", getParentList: "getParentList", clone: "clone", ids: "ids", httpConfig: "_$httpConfig", reqParams: "reqParams", one: "one", all: "all", several: "several", oneUrl: "oneUrl", allUrl: "allUrl", customPUT: "customPUT", customPOST: "customPOST", customDELETE: "customDELETE", customGET: "customGET", customGETLIST: "customGETLIST", customOperation: "customOperation", doPUT: "doPUT", doPOST: "doPOST", doDELETE: "doDELETE", doGET: "doGET", doGETLIST: "doGETLIST", fromServer: "fromServer", withConfig: "withConfig", withHttpConfig: "withHttpConfig", singleOne: "singleOne", plain: "plain", save: "save", restangularized: "restangularized" }, a.setRestangularFields = function (a) {
	        return b.restangularFields = _.extend(b.restangularFields, a), this;
	      }, b.isRestangularized = function (a) {
	        return !!a[b.restangularFields.restangularized];
	      }, b.setFieldToElem = function (a, b, c) {
	        var d = a.split("."),
	            e = b;return _.each(_.initial(d), function (a) {
	          e[a] = {}, e = e[a];
	        }), e[_.last(d)] = c, this;
	      }, b.getFieldFromElem = function (a, b) {
	        var c = a.split("."),
	            d = b;return _.each(c, function (a) {
	          d && (d = d[a]);
	        }), angular.copy(d);
	      }, b.setIdToElem = function (a, c) {
	        return b.setFieldToElem(b.restangularFields.id, a, c), this;
	      }, b.getIdFromElem = function (a) {
	        return b.getFieldFromElem(b.restangularFields.id, a);
	      }, b.isValidId = function (a) {
	        return "" !== a && !_.isUndefined(a) && !_.isNull(a);
	      }, b.setUrlToElem = function (a, c) {
	        return b.setFieldToElem(b.restangularFields.selfLink, a, c), this;
	      }, b.getUrlFromElem = function (a) {
	        return b.getFieldFromElem(b.restangularFields.selfLink, a);
	      }, b.useCannonicalId = _.isUndefined(b.useCannonicalId) ? !1 : b.useCannonicalId, a.setUseCannonicalId = function (a) {
	        return b.useCannonicalId = a, this;
	      }, b.getCannonicalIdFromElem = function (a) {
	        var c = a[b.restangularFields.cannonicalId],
	            d = b.isValidId(c) ? c : b.getIdFromElem(a);return d;
	      }, b.responseInterceptors = b.responseInterceptors || [], b.defaultResponseInterceptor = function (a) {
	        return a;
	      }, b.responseExtractor = function (a, c, d, e, f, g) {
	        var h = angular.copy(b.responseInterceptors);h.push(b.defaultResponseInterceptor);var i = a;return _.each(h, function (a) {
	          i = a(i, c, d, e, f, g);
	        }), i;
	      }, a.addResponseInterceptor = function (a) {
	        return b.responseInterceptors.push(a), this;
	      }, b.errorInterceptors = b.errorInterceptors || [], a.addErrorInterceptor = function (a) {
	        return b.errorInterceptors.push(a), this;
	      }, a.setResponseInterceptor = a.addResponseInterceptor, a.setResponseExtractor = a.addResponseInterceptor, a.setErrorInterceptor = a.addErrorInterceptor, b.requestInterceptors = b.requestInterceptors || [], b.defaultInterceptor = function (a, b, c, d, e, f, g) {
	        return { element: a, headers: e, params: f, httpConfig: g };
	      }, b.fullRequestInterceptor = function (a, c, d, e, f, g, h) {
	        var i = angular.copy(b.requestInterceptors),
	            j = b.defaultInterceptor(a, c, d, e, f, g, h);return _.reduce(i, function (a, b) {
	          return _.extend(a, b(a.element, c, d, e, a.headers, a.params, a.httpConfig));
	        }, j);
	      }, a.addRequestInterceptor = function (a) {
	        return b.requestInterceptors.push(function (b, c, d, e, f, g, h) {
	          return { headers: f, params: g, element: a(b, c, d, e), httpConfig: h };
	        }), this;
	      }, a.setRequestInterceptor = a.addRequestInterceptor, a.addFullRequestInterceptor = function (a) {
	        return b.requestInterceptors.push(a), this;
	      }, a.setFullRequestInterceptor = a.addFullRequestInterceptor, b.onBeforeElemRestangularized = b.onBeforeElemRestangularized || function (a) {
	        return a;
	      }, a.setOnBeforeElemRestangularized = function (a) {
	        return b.onBeforeElemRestangularized = a, this;
	      }, a.setRestangularizePromiseInterceptor = function (a) {
	        return b.restangularizePromiseInterceptor = a, this;
	      }, b.onElemRestangularized = b.onElemRestangularized || function (a) {
	        return a;
	      }, a.setOnElemRestangularized = function (a) {
	        return b.onElemRestangularized = a, this;
	      }, b.shouldSaveParent = b.shouldSaveParent || function () {
	        return !0;
	      }, a.setParentless = function (a) {
	        return _.isArray(a) ? b.shouldSaveParent = function (b) {
	          return !_.includes(a, b);
	        } : _.isBoolean(a) && (b.shouldSaveParent = function () {
	          return !a;
	        }), this;
	      }, b.suffix = _.isUndefined(b.suffix) ? null : b.suffix, a.setRequestSuffix = function (a) {
	        return b.suffix = a, this;
	      }, b.transformers = b.transformers || {}, a.addElementTransformer = function (c, d, e) {
	        var f = null,
	            g = null;2 === arguments.length ? g = d : (g = e, f = d);var h = b.transformers[c];return h || (h = b.transformers[c] = []), h.push(function (a, b) {
	          return _.isNull(f) || a === f ? g(b) : b;
	        }), a;
	      }, a.extendCollection = function (b, c) {
	        return a.addElementTransformer(b, !0, c);
	      }, a.extendModel = function (b, c) {
	        return a.addElementTransformer(b, !1, c);
	      }, b.transformElem = function (a, c, d, e, f) {
	        if (!f && !b.transformLocalElements && !a[b.restangularFields.fromServer]) return a;var g = b.transformers[d],
	            h = a;return g && _.each(g, function (a) {
	          h = a(c, h);
	        }), b.onElemRestangularized(h, c, d, e);
	      }, b.transformLocalElements = _.isUndefined(b.transformLocalElements) ? !1 : b.transformLocalElements, a.setTransformOnlyServerElements = function (a) {
	        b.transformLocalElements = !a;
	      }, b.fullResponse = _.isUndefined(b.fullResponse) ? !1 : b.fullResponse, a.setFullResponse = function (a) {
	        return b.fullResponse = a, this;
	      }, b.urlCreatorFactory = {};var f = function f() {};f.prototype.setConfig = function (a) {
	        return this.config = a, this;
	      }, f.prototype.parentsArray = function (a) {
	        for (var b = []; a;) {
	          b.push(a), a = a[this.config.restangularFields.parentResource];
	        }return b.reverse();
	      }, f.prototype.resource = function (a, d, e, f, g, h, i, j) {
	        var k = _.defaults(g || {}, this.config.defaultRequestParams.common),
	            l = _.defaults(f || {}, this.config.defaultHeaders);i && (b.isSafe(j) ? l["If-None-Match"] = i : l["If-Match"] = i);var m = this.base(a);if (h) {
	          var n = "";/\/$/.test(m) || (n += "/"), n += h, m += n;
	        }return this.config.suffix && -1 === m.indexOf(this.config.suffix, m.length - this.config.suffix.length) && !this.config.getUrlFromElem(a) && (m += this.config.suffix), a[this.config.restangularFields.httpConfig] = void 0, c(this.config, d, m, { getList: this.config.withHttpValues(e, { method: "GET", params: k, headers: l }), get: this.config.withHttpValues(e, { method: "GET", params: k, headers: l }), jsonp: this.config.withHttpValues(e, { method: "jsonp", params: k, headers: l }), put: this.config.withHttpValues(e, { method: "PUT", params: k, headers: l }), post: this.config.withHttpValues(e, { method: "POST", params: k, headers: l }), remove: this.config.withHttpValues(e, { method: "DELETE", params: k, headers: l }), head: this.config.withHttpValues(e, { method: "HEAD", params: k, headers: l }), trace: this.config.withHttpValues(e, { method: "TRACE", params: k, headers: l }), options: this.config.withHttpValues(e, { method: "OPTIONS", params: k, headers: l }), patch: this.config.withHttpValues(e, { method: "PATCH", params: k, headers: l }) });
	      };var g = function g() {};g.prototype = new f(), g.prototype.normalizeUrl = function (a) {
	        var b = /(http[s]?:\/\/)?(.*)?/.exec(a);return b[2] = b[2].replace(/[\\\/]+/g, "/"), "undefined" != typeof b[1] ? b[1] + b[2] : b[2];
	      }, g.prototype.base = function (a) {
	        var c = this;return _.reduce(this.parentsArray(a), function (a, d) {
	          var e,
	              f = c.config.getUrlFromElem(d);if (f) {
	            if (c.config.isAbsoluteUrl(f)) return f;e = f;
	          } else if (e = d[c.config.restangularFields.route], d[c.config.restangularFields.restangularCollection]) {
	            var g = d[c.config.restangularFields.ids];g && (e += "/" + g.join(","));
	          } else {
	            var h;h = c.config.useCannonicalId ? c.config.getCannonicalIdFromElem(d) : c.config.getIdFromElem(d), b.isValidId(h) && !d.singleOne && (e += "/" + (c.config.encodeIds ? encodeURIComponent(h) : h));
	          }return a = a.replace(/\/$/, "") + "/" + e, c.normalizeUrl(a);
	        }, this.config.baseUrl);
	      }, g.prototype.fetchUrl = function (a, b) {
	        var c = this.base(a);return b && (c += "/" + b), c;
	      }, g.prototype.fetchRequestedUrl = function (a, c) {
	        function d(a) {
	          var b = [];for (var c in a) {
	            a.hasOwnProperty(c) && b.push(c);
	          }return b.sort();
	        }function e(a, b, c) {
	          for (var e = d(a), f = 0; f < e.length; f++) {
	            b.call(c, a[e[f]], e[f]);
	          }return e;
	        }function f(a, b) {
	          return encodeURIComponent(a).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, b ? "%20" : "+");
	        }var g = this.fetchUrl(a, c),
	            h = a[b.restangularFields.reqParams];if (!h) return g + (this.config.suffix || "");var i = [];return e(h, function (a, b) {
	          null !== a && void 0 !== a && (angular.isArray(a) || (a = [a]), angular.forEach(a, function (a) {
	            angular.isObject(a) && (a = angular.toJson(a)), i.push(f(b) + "=" + f(a));
	          }));
	        }), g + (this.config.suffix || "") + (-1 === g.indexOf("?") ? "?" : "&") + i.join("&");
	      }, b.urlCreatorFactory.path = g;
	    };var b = {};a.init(this, b), this.$get = ["$http", "$q", function (c, d) {
	      function e(b) {
	        function f(a, c, d, e, f) {
	          if (c[b.restangularFields.route] = d, c[b.restangularFields.getRestangularUrl] = _.bind(P.fetchUrl, P, c), c[b.restangularFields.getRequestedUrl] = _.bind(P.fetchRequestedUrl, P, c), c[b.restangularFields.addRestangularMethod] = _.bind(L, c), c[b.restangularFields.clone] = _.bind(r, c, c), c[b.restangularFields.reqParams] = _.isEmpty(e) ? null : e, c[b.restangularFields.withHttpConfig] = _.bind(z, c), c[b.restangularFields.plain] = _.bind(p, c, c), c[b.restangularFields.restangularized] = !0, c[b.restangularFields.one] = _.bind(g, c, c), c[b.restangularFields.all] = _.bind(h, c, c), c[b.restangularFields.several] = _.bind(i, c, c), c[b.restangularFields.oneUrl] = _.bind(j, c, c), c[b.restangularFields.allUrl] = _.bind(k, c, c), c[b.restangularFields.fromServer] = !!f, a && b.shouldSaveParent(d)) {
	            var l = b.getIdFromElem(a),
	                m = b.getUrlFromElem(a),
	                n = _.union(_.values(_.pick(b.restangularFields, ["route", "singleOne", "parentResource"])), b.extraFields),
	                o = _.pick(a, n);b.isValidId(l) && b.setIdToElem(o, l, d), b.isValidId(m) && b.setUrlToElem(o, m, d), c[b.restangularFields.parentResource] = o;
	          } else c[b.restangularFields.parentResource] = null;return c;
	        }function g(a, c, d, e) {
	          var f;if (_.isNumber(c) || _.isNumber(a)) throw f = "You're creating a Restangular entity with the number ", f += "instead of the route or the parent. For example, you can't call .one(12).", new Error(f);if (_.isUndefined(c)) throw f = "You're creating a Restangular entity either without the path. ", f += "For example you can't call .one(). Please check if your arguments are valid.", new Error(f);var g = {};return b.setIdToElem(g, d, c), b.setFieldToElem(b.restangularFields.singleOne, g, e), s(a, g, c, !1);
	        }function h(a, b) {
	          return t(a, [], b, !1);
	        }function i(a, c) {
	          var d = [];return d[b.restangularFields.ids] = Array.prototype.splice.call(arguments, 2), t(a, d, c, !1);
	        }function j(a, c, d) {
	          if (!c) throw new Error("Route is mandatory when creating new Restangular objects.");var e = {};return b.setUrlToElem(e, d, c), s(a, e, c, !1);
	        }function k(a, c, d) {
	          if (!c) throw new Error("Route is mandatory when creating new Restangular objects.");var e = {};return b.setUrlToElem(e, d, c), t(a, e, c, !1);
	        }function l(a, c, d) {
	          return a.call = _.bind(m, a), a.get = _.bind(n, a), a[b.restangularFields.restangularCollection] = c, c && (a.push = _.bind(m, a, "push")), a.$object = d, b.restangularizePromiseInterceptor && b.restangularizePromiseInterceptor(a), a;
	        }function m(a) {
	          var c = d.defer(),
	              e = arguments,
	              f = {};return this.then(function (b) {
	            var d = Array.prototype.slice.call(e, 1),
	                g = b[a];g.apply(b, d), f = b, c.resolve(b);
	          }), l(c.promise, this[b.restangularFields.restangularCollection], f);
	        }function n(a) {
	          var c = d.defer(),
	              e = {};return this.then(function (b) {
	            e = b[a], c.resolve(e);
	          }), l(c.promise, this[b.restangularFields.restangularCollection], e);
	        }function o(a, c, d, e) {
	          return _.extend(e, d), b.fullResponse ? a.resolve(_.extend(c, { data: d })) : void a.resolve(d);
	        }function p(a) {
	          if (_.isArray(a)) {
	            var c = [];return _.each(a, function (a) {
	              c.push(b.isRestangularized(a) ? p(a) : a);
	            }), c;
	          }return _.omit(a, _.values(_.omit(b.restangularFields, "id")));
	        }function q(a) {
	          a[b.restangularFields.customOperation] = _.bind(K, a), _.each(["put", "post", "get", "delete"], function (b) {
	            _.each(["do", "custom"], function (c) {
	              var d,
	                  e = "delete" === b ? "remove" : b,
	                  f = c + b.toUpperCase();d = "put" !== e && "post" !== e ? K : function (a, b, c, d, e) {
	                return _.bind(K, this)(a, c, d, e, b);
	              }, a[f] = _.bind(d, a, e);
	            });
	          }), a[b.restangularFields.customGETLIST] = _.bind(y, a), a[b.restangularFields.doGETLIST] = a[b.restangularFields.customGETLIST];
	        }function r(a, c) {
	          var d = angular.copy(a, c);return s(d[b.restangularFields.parentResource], d, d[b.restangularFields.route], !0);
	        }function s(a, c, d, e, g, h) {
	          var i = b.onBeforeElemRestangularized(c, !1, d),
	              j = f(a, i, d, h, e);return b.useCannonicalId && (j[b.restangularFields.cannonicalId] = b.getIdFromElem(j)), g && (j[b.restangularFields.getParentList] = function () {
	            return g;
	          }), j[b.restangularFields.restangularCollection] = !1, j[b.restangularFields.get] = _.bind(C, j), j[b.restangularFields.getList] = _.bind(y, j), j[b.restangularFields.put] = _.bind(E, j), j[b.restangularFields.post] = _.bind(F, j), j[b.restangularFields.remove] = _.bind(D, j), j[b.restangularFields.head] = _.bind(G, j), j[b.restangularFields.trace] = _.bind(H, j), j[b.restangularFields.options] = _.bind(I, j), j[b.restangularFields.patch] = _.bind(J, j), j[b.restangularFields.save] = _.bind(A, j), q(j), b.transformElem(j, !1, d, O, !0);
	        }function t(a, c, d, e, g) {
	          var h = b.onBeforeElemRestangularized(c, !0, d),
	              i = f(a, h, d, g, e);return i[b.restangularFields.restangularCollection] = !0, i[b.restangularFields.post] = _.bind(F, i, null), i[b.restangularFields.remove] = _.bind(D, i), i[b.restangularFields.head] = _.bind(G, i), i[b.restangularFields.trace] = _.bind(H, i), i[b.restangularFields.putElement] = _.bind(w, i), i[b.restangularFields.options] = _.bind(I, i), i[b.restangularFields.patch] = _.bind(J, i), i[b.restangularFields.get] = _.bind(v, i), i[b.restangularFields.getList] = _.bind(y, i, null), q(i), b.transformElem(i, !0, d, O, !0);
	        }function u(a, b, c) {
	          var d = t(a, b, c, !1);return _.each(d, function (b) {
	            s(a, b, c, !1);
	          }), d;
	        }function v(a, b, c) {
	          return this.customGET(a.toString(), b, c);
	        }function w(a, c, e) {
	          var f = this,
	              g = this[a],
	              h = d.defer(),
	              i = [];return i = b.transformElem(i, !0, g[b.restangularFields.route], O), g.put(c, e).then(function (b) {
	            var c = r(f);c[a] = b, i = c, h.resolve(c);
	          }, function (a) {
	            h.reject(a);
	          }), l(h.promise, !0, i);
	        }function x(a, c, d, e, f, g) {
	          var h = b.responseExtractor(a, c, d, e, f, g),
	              i = f.headers("ETag");return h && i && (h[b.restangularFields.etag] = i), h;
	        }function y(a, e, f) {
	          var g = this,
	              h = d.defer(),
	              i = "getList",
	              j = P.fetchUrl(this, a),
	              k = a || g[b.restangularFields.route],
	              m = b.fullRequestInterceptor(null, i, k, j, f || {}, e || {}, this[b.restangularFields.httpConfig] || {}),
	              n = [];n = b.transformElem(n, !0, k, O);var p = "getList";b.jsonp && (p = "jsonp");var q = function q(c) {
	            var d = c.data,
	                e = c.config.params,
	                f = x(d, i, k, j, c, h);if ((_.isUndefined(f) || "" === f) && (f = []), !_.isArray(f)) throw new Error("Response for getList SHOULD be an array and not an object or something else");var l = _.map(f, function (c) {
	              return g[b.restangularFields.restangularCollection] ? s(g[b.restangularFields.parentResource], c, g[b.restangularFields.route], !0, f) : s(g, c, a, !0, f);
	            });l = _.extend(f, l), g[b.restangularFields.restangularCollection] ? o(h, c, t(g[b.restangularFields.parentResource], l, g[b.restangularFields.route], !0, e), n) : o(h, c, t(g, l, a, !0, e), n);
	          };return P.resource(this, c, m.httpConfig, m.headers, m.params, a, this[b.restangularFields.etag], i)[p]().then(q, function (a) {
	            304 === a.status && g[b.restangularFields.restangularCollection] ? o(h, a, g, n) : _.every(b.errorInterceptors, function (b) {
	              return b(a, h, q) !== !1;
	            }) && h.reject(a);
	          }), l(h.promise, !0, n);
	        }function z(a) {
	          return this[b.restangularFields.httpConfig] = a, this;
	        }function A(a, c) {
	          return this[b.restangularFields.fromServer] ? this[b.restangularFields.put](a, c) : _.bind(B, this)("post", void 0, a, void 0, c);
	        }function B(a, e, f, g, h) {
	          var i = this,
	              j = d.defer(),
	              k = f || {},
	              m = e || this[b.restangularFields.route],
	              n = P.fetchUrl(this, e),
	              q = g || this,
	              r = q[b.restangularFields.etag] || ("post" !== a ? this[b.restangularFields.etag] : null);_.isObject(q) && b.isRestangularized(q) && (q = p(q));var t = b.fullRequestInterceptor(q, a, m, n, h || {}, k || {}, this[b.restangularFields.httpConfig] || {}),
	              u = {};u = b.transformElem(u, !1, m, O);var v = function v(c) {
	            var d = c.data,
	                e = c.config.params,
	                f = x(d, a, m, n, c, j);if (f) {
	              var g;"post" !== a || i[b.restangularFields.restangularCollection] ? (g = s(i[b.restangularFields.parentResource], f, i[b.restangularFields.route], !0, null, e), g[b.restangularFields.singleOne] = i[b.restangularFields.singleOne], o(j, c, g, u)) : (g = s(i[b.restangularFields.parentResource], f, m, !0, null, e), o(j, c, g, u));
	            } else o(j, c, void 0, u);
	          },
	              w = function w(c) {
	            304 === c.status && b.isSafe(a) ? o(j, c, i, u) : _.every(b.errorInterceptors, function (a) {
	              return a(c, j, v) !== !1;
	            }) && j.reject(c);
	          },
	              y = a,
	              z = _.extend({}, t.headers),
	              A = b.isOverridenMethod(a);return A ? (y = "post", z = _.extend(z, { "X-HTTP-Method-Override": "remove" === a ? "DELETE" : a.toUpperCase() })) : b.jsonp && "get" === y && (y = "jsonp"), b.isSafe(a) ? A ? P.resource(this, c, t.httpConfig, z, t.params, e, r, y)[y]({}).then(v, w) : P.resource(this, c, t.httpConfig, z, t.params, e, r, y)[y]().then(v, w) : P.resource(this, c, t.httpConfig, z, t.params, e, r, y)[y](t.element).then(v, w), l(j.promise, !1, u);
	        }function C(a, b) {
	          return _.bind(B, this)("get", void 0, a, void 0, b);
	        }function D(a, b) {
	          return _.bind(B, this)("remove", void 0, a, void 0, b);
	        }function E(a, b) {
	          return _.bind(B, this)("put", void 0, a, void 0, b);
	        }function F(a, b, c, d) {
	          return _.bind(B, this)("post", a, c, b, d);
	        }function G(a, b) {
	          return _.bind(B, this)("head", void 0, a, void 0, b);
	        }function H(a, b) {
	          return _.bind(B, this)("trace", void 0, a, void 0, b);
	        }function I(a, b) {
	          return _.bind(B, this)("options", void 0, a, void 0, b);
	        }function J(a, b, c) {
	          return _.bind(B, this)("patch", void 0, b, a, c);
	        }function K(a, b, c, d, e) {
	          return _.bind(B, this)(a, b, c, e, d);
	        }function L(a, c, d, e, f, g) {
	          var h;h = "getList" === c ? _.bind(y, this, d) : _.bind(K, this, c, d);var i = function i(a, b, c) {
	            var d = _.defaults({ params: a, headers: b, elem: c }, { params: e, headers: f, elem: g });return h(d.params, d.headers, d.elem);
	          };b.isSafe(c) ? this[a] = i : this[a] = function (a, b, c) {
	            return i(b, c, a);
	          };
	        }function M(c) {
	          var d = angular.copy(_.omit(b, "configuration"));return a.init(d, d), c(d), e(d);
	        }function N(a, c) {
	          var d = _.values(b.restangularFields),
	              e = {},
	              f = (c || O).all(a);e.one = _.bind(g, c || O, c, a), e.post = _.bind(f.post, f), e.getList = _.bind(f.getList, f);for (var h in f) {
	            f.hasOwnProperty(h) && _.isFunction(f[h]) && !_.includes(d, h) && (e[h] = _.bind(f[h], f));
	          }return e;
	        }var O = {},
	            P = new b.urlCreatorFactory[b.urlCreator]();return P.setConfig(b), a.init(O, b), O.copy = _.bind(r, O), O.service = _.bind(N, O), O.withConfig = _.bind(M, O), O.one = _.bind(g, O, null), O.all = _.bind(h, O, null), O.several = _.bind(i, O, null), O.oneUrl = _.bind(j, O, null), O.allUrl = _.bind(k, O, null), O.stripRestangular = _.bind(p, O), O.restangularizeElement = _.bind(s, O), O.restangularizeCollection = _.bind(u, O), O;
	      }return e(b);
	    }];
	  });
	}();

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Sinon core utilities. For internal use only.
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2013 Christian Johansen
	 */
	"use strict";
	
	var match = __webpack_require__(10);
	
	module.exports = exports = __webpack_require__(21);
	
	exports.assert = __webpack_require__(32);
	exports.collection = __webpack_require__(136);
	exports.extend = __webpack_require__(5);
	exports.match = match;
	exports.spy = __webpack_require__(20);
	exports.spyCall = __webpack_require__(19);
	exports.stub = __webpack_require__(33);
	exports.mock = __webpack_require__(332);
	exports.sandbox = __webpack_require__(333);
	exports.expectation = __webpack_require__(137);
	exports.createStubInstance = __webpack_require__(33).createStubInstance;
	exports.typeOf = __webpack_require__(138);
	
	var event = __webpack_require__(36);
	exports.Event = event.Event;
	exports.CustomEvent = event.CustomEvent;
	exports.ProgressEvent = event.ProgressEvent;
	exports.EventTarget = event.EventTarget;
	
	var fakeTimers = __webpack_require__(143);
	exports.useFakeTimers = fakeTimers.useFakeTimers;
	exports.clock = fakeTimers.clock;
	exports.timers = fakeTimers.timers;
	
	var fakeXdr = __webpack_require__(337);
	exports.xdr = fakeXdr.xdr;
	exports.FakeXDomainRequest = fakeXdr.FakeXDomainRequest;
	exports.useFakeXDomainRequest = fakeXdr.useFakeXDomainRequest;
	
	var fakeXhr = __webpack_require__(338);
	exports.xhr = fakeXhr.xhr;
	exports.FakeXMLHttpRequest = fakeXhr.FakeXMLHttpRequest;
	exports.useFakeXMLHttpRequest = fakeXhr.useFakeXMLHttpRequest;
	
	exports.fakeServer = __webpack_require__(142);
	exports.fakeServerWithClock = __webpack_require__(336);
	
	/*
	 * allow deepEqual to check equality of matchers through
	 * dependency injection. Otherwise we get a circular
	 * dependency
	 */
	exports.deepEqual = exports.deepEqual.use(match);

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/**
	 * Stub behavior
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @author Tim Fischbach (mail@timfischbach.de)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2013 Christian Johansen
	 */
	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var extend = __webpack_require__(5);
	var functionName = __webpack_require__(15);
	var valueToString = __webpack_require__(7);
	
	var slice = Array.prototype.slice;
	var join = Array.prototype.join;
	var useLeftMostCallback = -1;
	var useRightMostCallback = -2;
	
	var nextTick = function () {
	    if ((typeof process === "undefined" ? "undefined" : _typeof(process)) === "object" && typeof process.nextTick === "function") {
	        return process.nextTick;
	    }
	
	    if (typeof setImmediate === "function") {
	        return setImmediate;
	    }
	
	    return function (callback) {
	        setTimeout(callback, 0);
	    };
	}();
	
	function throwsException(error, message) {
	    if (typeof error === "string") {
	        this.exception = new Error(message || "");
	        this.exception.name = error;
	    } else if (!error) {
	        this.exception = new Error("Error");
	    } else {
	        this.exception = error;
	    }
	
	    return this;
	}
	
	function getCallback(behavior, args) {
	    var callArgAt = behavior.callArgAt;
	
	    if (callArgAt >= 0) {
	        return args[callArgAt];
	    }
	
	    var argumentList;
	
	    if (callArgAt === useLeftMostCallback) {
	        argumentList = args;
	    }
	
	    if (callArgAt === useRightMostCallback) {
	        argumentList = slice.call(args).reverse();
	    }
	
	    var callArgProp = behavior.callArgProp;
	
	    for (var i = 0, l = argumentList.length; i < l; ++i) {
	        if (!callArgProp && typeof argumentList[i] === "function") {
	            return argumentList[i];
	        }
	
	        if (callArgProp && argumentList[i] && typeof argumentList[i][callArgProp] === "function") {
	            return argumentList[i][callArgProp];
	        }
	    }
	
	    return null;
	}
	
	function getCallbackError(behavior, func, args) {
	    if (behavior.callArgAt < 0) {
	        var msg;
	
	        if (behavior.callArgProp) {
	            msg = functionName(behavior.stub) + " expected to yield to '" + valueToString(behavior.callArgProp) + "', but no object with such a property was passed.";
	        } else {
	            msg = functionName(behavior.stub) + " expected to yield, but no callback was passed.";
	        }
	
	        if (args.length > 0) {
	            msg += " Received [" + join.call(args, ", ") + "]";
	        }
	
	        return msg;
	    }
	
	    return "argument at index " + behavior.callArgAt + " is not a function: " + func;
	}
	
	function callCallback(behavior, args) {
	    if (typeof behavior.callArgAt === "number") {
	        var func = getCallback(behavior, args);
	
	        if (typeof func !== "function") {
	            throw new TypeError(getCallbackError(behavior, func, args));
	        }
	
	        if (behavior.callbackAsync) {
	            nextTick(function () {
	                func.apply(behavior.callbackContext, behavior.callbackArguments);
	            });
	        } else {
	            func.apply(behavior.callbackContext, behavior.callbackArguments);
	        }
	    }
	}
	
	var proto = {
	    create: function create(stub) {
	        var behavior = extend({}, proto);
	        delete behavior.create;
	        behavior.stub = stub;
	
	        return behavior;
	    },
	
	    isPresent: function isPresent() {
	        return typeof this.callArgAt === "number" || this.exception || typeof this.returnArgAt === "number" || this.returnThis || this.returnValueDefined;
	    },
	
	    invoke: function invoke(context, args) {
	        callCallback(this, args);
	
	        if (this.exception) {
	            throw this.exception;
	        } else if (typeof this.returnArgAt === "number") {
	            return args[this.returnArgAt];
	        } else if (this.returnThis) {
	            return context;
	        }
	
	        return this.returnValue;
	    },
	
	    onCall: function onCall(index) {
	        return this.stub.onCall(index);
	    },
	
	    onFirstCall: function onFirstCall() {
	        return this.stub.onFirstCall();
	    },
	
	    onSecondCall: function onSecondCall() {
	        return this.stub.onSecondCall();
	    },
	
	    onThirdCall: function onThirdCall() {
	        return this.stub.onThirdCall();
	    },
	
	    withArgs: function withArgs() /* arguments */{
	        throw new Error("Defining a stub by invoking \"stub.onCall(...).withArgs(...)\" " + "is not supported. Use \"stub.withArgs(...).onCall(...)\" " + "to define sequential behavior for calls with certain arguments.");
	    },
	
	    callsArg: function callsArg(pos) {
	        if (typeof pos !== "number") {
	            throw new TypeError("argument index is not number");
	        }
	
	        this.callArgAt = pos;
	        this.callbackArguments = [];
	        this.callbackContext = undefined;
	        this.callArgProp = undefined;
	        this.callbackAsync = false;
	
	        return this;
	    },
	
	    callsArgOn: function callsArgOn(pos, context) {
	        if (typeof pos !== "number") {
	            throw new TypeError("argument index is not number");
	        }
	
	        this.callArgAt = pos;
	        this.callbackArguments = [];
	        this.callbackContext = context;
	        this.callArgProp = undefined;
	        this.callbackAsync = false;
	
	        return this;
	    },
	
	    callsArgWith: function callsArgWith(pos) {
	        if (typeof pos !== "number") {
	            throw new TypeError("argument index is not number");
	        }
	
	        this.callArgAt = pos;
	        this.callbackArguments = slice.call(arguments, 1);
	        this.callbackContext = undefined;
	        this.callArgProp = undefined;
	        this.callbackAsync = false;
	
	        return this;
	    },
	
	    callsArgOnWith: function callsArgWith(pos, context) {
	        if (typeof pos !== "number") {
	            throw new TypeError("argument index is not number");
	        }
	
	        this.callArgAt = pos;
	        this.callbackArguments = slice.call(arguments, 2);
	        this.callbackContext = context;
	        this.callArgProp = undefined;
	        this.callbackAsync = false;
	
	        return this;
	    },
	
	    yields: function yields() {
	        this.callArgAt = useLeftMostCallback;
	        this.callbackArguments = slice.call(arguments, 0);
	        this.callbackContext = undefined;
	        this.callArgProp = undefined;
	        this.callbackAsync = false;
	
	        return this;
	    },
	
	    yieldsRight: function yieldsRight() {
	        this.callArgAt = useRightMostCallback;
	        this.callbackArguments = slice.call(arguments, 0);
	        this.callbackContext = undefined;
	        this.callArgProp = undefined;
	        this.callbackAsync = false;
	
	        return this;
	    },
	
	    yieldsOn: function yieldsOn(context) {
	        this.callArgAt = useLeftMostCallback;
	        this.callbackArguments = slice.call(arguments, 1);
	        this.callbackContext = context;
	        this.callArgProp = undefined;
	        this.callbackAsync = false;
	
	        return this;
	    },
	
	    yieldsTo: function yieldsTo(prop) {
	        this.callArgAt = useLeftMostCallback;
	        this.callbackArguments = slice.call(arguments, 1);
	        this.callbackContext = undefined;
	        this.callArgProp = prop;
	        this.callbackAsync = false;
	
	        return this;
	    },
	
	    yieldsToOn: function yieldsToOn(prop, context) {
	        this.callArgAt = useLeftMostCallback;
	        this.callbackArguments = slice.call(arguments, 2);
	        this.callbackContext = context;
	        this.callArgProp = prop;
	        this.callbackAsync = false;
	
	        return this;
	    },
	
	    throws: throwsException,
	    throwsException: throwsException,
	
	    returns: function returns(value) {
	        this.returnValue = value;
	        this.returnValueDefined = true;
	        this.exception = undefined;
	
	        return this;
	    },
	
	    returnsArg: function returnsArg(pos) {
	        if (typeof pos !== "number") {
	            throw new TypeError("argument index is not number");
	        }
	
	        this.returnArgAt = pos;
	
	        return this;
	    },
	
	    returnsThis: function returnsThis() {
	        this.returnThis = true;
	
	        return this;
	    }
	};
	
	function createAsyncVersion(syncFnName) {
	    return function () {
	        var result = this[syncFnName].apply(this, arguments);
	        this.callbackAsync = true;
	        return result;
	    };
	}
	
	// create asynchronous versions of callsArg* and yields* methods
	for (var method in proto) {
	    // need to avoid creating anotherasync versions of the newly added async methods
	    if (proto.hasOwnProperty(method) && method.match(/^(callsArg|yields)/) && !method.match(/Async/)) {
	        proto[method + "Async"] = createAsyncVersion(method);
	    }
	}
	
	module.exports = proto;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(14).setImmediate))

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Mock functions.
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2013 Christian Johansen
	 */
	"use strict";
	
	var mockExpectation = __webpack_require__(137);
	var spyCallToString = __webpack_require__(19).toString;
	var extend = __webpack_require__(5);
	var match = __webpack_require__(10);
	var deepEqual = __webpack_require__(12).use(match);
	var wrapMethod = __webpack_require__(25);
	
	var push = Array.prototype.push;
	
	function mock(object) {
	    // if (typeof console !== undefined && console.warn) {
	    //     console.warn("mock will be removed from Sinon.JS v2.0");
	    // }
	
	    if (!object) {
	        return mockExpectation.create("Anonymous mock");
	    }
	
	    return mock.create(object);
	}
	
	function each(collection, callback) {
	    if (!collection) {
	        return;
	    }
	
	    for (var i = 0, l = collection.length; i < l; i += 1) {
	        callback(collection[i]);
	    }
	}
	
	function arrayEquals(arr1, arr2, compareLength) {
	    if (compareLength && arr1.length !== arr2.length) {
	        return false;
	    }
	
	    for (var i = 0, l = arr1.length; i < l; i++) {
	        if (!deepEqual(arr1[i], arr2[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	extend(mock, {
	    create: function create(object) {
	        if (!object) {
	            throw new TypeError("object is null");
	        }
	
	        var mockObject = extend({}, mock);
	        mockObject.object = object;
	        delete mockObject.create;
	
	        return mockObject;
	    },
	
	    expects: function expects(method) {
	        if (!method) {
	            throw new TypeError("method is falsy");
	        }
	
	        if (!this.expectations) {
	            this.expectations = {};
	            this.proxies = [];
	        }
	
	        if (!this.expectations[method]) {
	            this.expectations[method] = [];
	            var mockObject = this;
	
	            wrapMethod(this.object, method, function () {
	                return mockObject.invokeMethod(method, this, arguments);
	            });
	
	            push.call(this.proxies, method);
	        }
	
	        var expectation = mockExpectation.create(method);
	        push.call(this.expectations[method], expectation);
	
	        return expectation;
	    },
	
	    restore: function restore() {
	        var object = this.object;
	
	        each(this.proxies, function (proxy) {
	            if (typeof object[proxy].restore === "function") {
	                object[proxy].restore();
	            }
	        });
	    },
	
	    verify: function verify() {
	        var expectations = this.expectations || {};
	        var messages = [];
	        var met = [];
	
	        each(this.proxies, function (proxy) {
	            each(expectations[proxy], function (expectation) {
	                if (!expectation.met()) {
	                    push.call(messages, expectation.toString());
	                } else {
	                    push.call(met, expectation.toString());
	                }
	            });
	        });
	
	        this.restore();
	
	        if (messages.length > 0) {
	            mockExpectation.fail(messages.concat(met).join("\n"));
	        } else if (met.length > 0) {
	            mockExpectation.pass(messages.concat(met).join("\n"));
	        }
	
	        return true;
	    },
	
	    invokeMethod: function invokeMethod(method, thisValue, args) {
	        var expectations = this.expectations && this.expectations[method] ? this.expectations[method] : [];
	        var expectationsWithMatchingArgs = [];
	        var currentArgs = args || [];
	        var i, available;
	
	        for (i = 0; i < expectations.length; i += 1) {
	            var expectedArgs = expectations[i].expectedArguments || [];
	            if (arrayEquals(expectedArgs, currentArgs, expectations[i].expectsExactArgCount)) {
	                expectationsWithMatchingArgs.push(expectations[i]);
	            }
	        }
	
	        for (i = 0; i < expectationsWithMatchingArgs.length; i += 1) {
	            if (!expectationsWithMatchingArgs[i].met() && expectationsWithMatchingArgs[i].allowsCall(thisValue, args)) {
	                return expectationsWithMatchingArgs[i].apply(thisValue, args);
	            }
	        }
	
	        var messages = [];
	        var exhausted = 0;
	
	        for (i = 0; i < expectationsWithMatchingArgs.length; i += 1) {
	            if (expectationsWithMatchingArgs[i].allowsCall(thisValue, args)) {
	                available = available || expectationsWithMatchingArgs[i];
	            } else {
	                exhausted += 1;
	            }
	        }
	
	        if (available && exhausted === 0) {
	            return available.apply(thisValue, args);
	        }
	
	        for (i = 0; i < expectations.length; i += 1) {
	            push.call(messages, "    " + expectations[i].toString());
	        }
	
	        messages.unshift("Unexpected call: " + spyCallToString.call({
	            proxy: method,
	            args: args
	        }));
	
	        mockExpectation.fail(messages.join("\n"));
	    }
	});
	
	module.exports = mock;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Manages fake collections as well as fake utilities such as Sinon's
	 * timers and fake XHR implementation in one convenient object.
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2013 Christian Johansen
	 */
	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var sinon = __webpack_require__(21);
	
	var extend = __webpack_require__(5);
	var createInstance = __webpack_require__(11);
	var sinonCollection = __webpack_require__(136);
	var sinonMatch = __webpack_require__(10);
	var sinonAssert = __webpack_require__(32);
	
	var push = [].push;
	
	var sinonSandbox = createInstance(sinonCollection);
	
	function exposeValue(sandbox, config, key, value) {
	    if (!value) {
	        return;
	    }
	
	    if (config.injectInto && !(key in config.injectInto)) {
	        config.injectInto[key] = value;
	        sandbox.injectedKeys.push(key);
	    } else {
	        push.call(sandbox.args, value);
	    }
	}
	
	function prepareSandboxFromConfig(config) {
	    var sandbox = createInstance(sinonSandbox);
	
	    if (config.useFakeServer) {
	        if (_typeof(config.useFakeServer) === "object") {
	            sandbox.serverPrototype = config.useFakeServer;
	        }
	
	        sandbox.useFakeServer();
	    }
	
	    if (config.useFakeTimers) {
	        if (_typeof(config.useFakeTimers) === "object") {
	            sandbox.useFakeTimers.apply(sandbox, config.useFakeTimers);
	        } else {
	            sandbox.useFakeTimers();
	        }
	    }
	
	    return sandbox;
	}
	
	extend(sinonSandbox, {
	    useFakeTimers: function useFakeTimers() {
	        this.clock = sinon.useFakeTimers.apply(sinon, arguments);
	
	        return this.add(this.clock);
	    },
	
	    serverPrototype: sinon.fakeServerWithClock,
	
	    useFakeServer: function useFakeServer() {
	        var proto = this.serverPrototype || sinon.fakeServer;
	
	        if (!proto || !proto.create) {
	            return null;
	        }
	
	        this.server = proto.create();
	        return this.add(this.server);
	    },
	
	    inject: function inject(obj) {
	        sinonCollection.inject.call(this, obj);
	
	        if (this.clock) {
	            obj.clock = this.clock;
	        }
	
	        if (this.server) {
	            obj.server = this.server;
	            obj.requests = this.server.requests;
	        }
	
	        obj.match = sinonMatch;
	
	        return obj;
	    },
	
	    restore: function restore() {
	        sinonCollection.restore.apply(this, arguments);
	        this.restoreContext();
	    },
	
	    restoreContext: function restoreContext() {
	        if (this.injectedKeys) {
	            for (var i = 0, j = this.injectedKeys.length; i < j; i++) {
	                delete this.injectInto[this.injectedKeys[i]];
	            }
	            this.injectedKeys = [];
	        }
	    },
	
	    create: function create(config) {
	        if (!config) {
	            return createInstance(sinonSandbox);
	        }
	
	        var sandbox = prepareSandboxFromConfig(config);
	        sandbox.args = sandbox.args || [];
	        sandbox.injectedKeys = [];
	        sandbox.injectInto = config.injectInto;
	        var prop, value;
	        var exposed = sandbox.inject({});
	
	        if (config.properties) {
	            for (var i = 0, l = config.properties.length; i < l; i++) {
	                prop = config.properties[i];
	                value = exposed[prop] || prop === "sandbox" && sandbox;
	                exposeValue(sandbox, config, prop, value);
	            }
	        } else {
	            exposeValue(sandbox, config, "sandbox", value);
	        }
	
	        return sandbox;
	    },
	
	    match: sinonMatch,
	
	    assert: sinonAssert
	});
	
	sinonSandbox.useFakeXMLHttpRequest = sinonSandbox.useFakeServer;
	
	module.exports = sinonSandbox;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var defaultConfig = __webpack_require__(140);
	
	module.exports = function getConfig(custom) {
	    var config = {};
	    var prop;
	
	    custom = custom || {};
	
	    for (prop in defaultConfig) {
	        if (defaultConfig.hasOwnProperty(prop)) {
	            config[prop] = custom.hasOwnProperty(prop) ? custom[prop] : defaultConfig[prop];
	        }
	    }
	
	    return config;
	};

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var walk = __webpack_require__(24);
	
	function isRestorable(obj) {
	    return typeof obj === "function" && typeof obj.restore === "function" && obj.restore.sinon;
	}
	
	module.exports = function restore(object) {
	    if (object !== null && (typeof object === "undefined" ? "undefined" : _typeof(object)) === "object") {
	        walk(object, function (prop) {
	            if (isRestorable(object[prop])) {
	                object[prop].restore();
	            }
	        });
	    } else if (isRestorable(object)) {
	        object.restore();
	    }
	};

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Add-on for sinon.fakeServer that automatically handles a fake timer along with
	 * the FakeXMLHttpRequest. The direct inspiration for this add-on is jQuery
	 * 1.3.x, which does not use xhr object's onreadystatehandler at all - instead,
	 * it polls the object for completion with setInterval. Despite the direct
	 * motivation, there is nothing jQuery-specific in this file, so it can be used
	 * in any environment where the ajax implementation depends on setInterval or
	 * setTimeout.
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2013 Christian Johansen
	 */
	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var fakeServer = __webpack_require__(142);
	var fakeTimers = __webpack_require__(143);
	
	function Server() {}
	Server.prototype = fakeServer;
	
	var fakeServerWithClock = new Server();
	
	fakeServerWithClock.addRequest = function addRequest(xhr) {
	    if (xhr.async) {
	        if (_typeof(setTimeout.clock) === "object") {
	            this.clock = setTimeout.clock;
	        } else {
	            this.clock = fakeTimers.useFakeTimers();
	            this.resetClock = true;
	        }
	
	        if (!this.longestTimeout) {
	            var clockSetTimeout = this.clock.setTimeout;
	            var clockSetInterval = this.clock.setInterval;
	            var server = this;
	
	            this.clock.setTimeout = function (fn, timeout) {
	                server.longestTimeout = Math.max(timeout, server.longestTimeout || 0);
	
	                return clockSetTimeout.apply(this, arguments);
	            };
	
	            this.clock.setInterval = function (fn, timeout) {
	                server.longestTimeout = Math.max(timeout, server.longestTimeout || 0);
	
	                return clockSetInterval.apply(this, arguments);
	            };
	        }
	    }
	
	    return fakeServer.addRequest.call(this, xhr);
	};
	
	fakeServerWithClock.respond = function respond() {
	    var returnVal = fakeServer.respond.apply(this, arguments);
	
	    if (this.clock) {
	        this.clock.tick(this.longestTimeout || 0);
	        this.longestTimeout = 0;
	
	        if (this.resetClock) {
	            this.clock.restore();
	            this.resetClock = false;
	        }
	    }
	
	    return returnVal;
	};
	
	fakeServerWithClock.restore = function restore() {
	    if (this.clock) {
	        this.clock.restore();
	    }
	
	    return fakeServer.restore.apply(this, arguments);
	};
	
	module.exports = fakeServerWithClock;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Fake XDomainRequest object
	 */
	
	"use strict";
	
	var event = __webpack_require__(36);
	var extend = __webpack_require__(5);
	var configureLogError = __webpack_require__(22);
	
	var xdr = { XDomainRequest: global.XDomainRequest };
	xdr.GlobalXDomainRequest = global.XDomainRequest;
	xdr.supportsXDR = typeof xdr.GlobalXDomainRequest !== "undefined";
	xdr.workingXDR = xdr.supportsXDR ? xdr.GlobalXDomainRequest : false;
	
	function FakeXDomainRequest(config) {
	    this.readyState = FakeXDomainRequest.UNSENT;
	    this.requestBody = null;
	    this.requestHeaders = {};
	    this.status = 0;
	    this.timeout = null;
	    this.logError = configureLogError(config);
	
	    if (typeof FakeXDomainRequest.onCreate === "function") {
	        FakeXDomainRequest.onCreate(this);
	    }
	}
	
	function verifyState(x) {
	    if (x.readyState !== FakeXDomainRequest.OPENED) {
	        throw new Error("INVALID_STATE_ERR");
	    }
	
	    if (x.sendFlag) {
	        throw new Error("INVALID_STATE_ERR");
	    }
	}
	
	function verifyRequestSent(x) {
	    if (x.readyState === FakeXDomainRequest.UNSENT) {
	        throw new Error("Request not sent");
	    }
	    if (x.readyState === FakeXDomainRequest.DONE) {
	        throw new Error("Request done");
	    }
	}
	
	function verifyResponseBodyType(body) {
	    if (typeof body !== "string") {
	        var error = new Error("Attempted to respond to fake XDomainRequest with " + body + ", which is not a string.");
	        error.name = "InvalidBodyException";
	        throw error;
	    }
	}
	
	extend(FakeXDomainRequest.prototype, event.EventTarget, {
	    open: function open(method, url) {
	        this.method = method;
	        this.url = url;
	
	        this.responseText = null;
	        this.sendFlag = false;
	
	        this.readyStateChange(FakeXDomainRequest.OPENED);
	    },
	
	    readyStateChange: function readyStateChange(state) {
	        this.readyState = state;
	        var eventName = "";
	        switch (this.readyState) {
	            case FakeXDomainRequest.UNSENT:
	                break;
	            case FakeXDomainRequest.OPENED:
	                break;
	            case FakeXDomainRequest.LOADING:
	                if (this.sendFlag) {
	                    //raise the progress event
	                    eventName = "onprogress";
	                }
	                break;
	            case FakeXDomainRequest.DONE:
	                if (this.isTimeout) {
	                    eventName = "ontimeout";
	                } else if (this.errorFlag || this.status < 200 || this.status > 299) {
	                    eventName = "onerror";
	                } else {
	                    eventName = "onload";
	                }
	                break;
	            default:
	                throw new Error("Unhandled state");
	        }
	
	        // raising event (if defined)
	        if (eventName) {
	            if (typeof this[eventName] === "function") {
	                try {
	                    this[eventName]();
	                } catch (e) {
	                    this.logError("Fake XHR " + eventName + " handler", e);
	                }
	            }
	        }
	    },
	
	    send: function send(data) {
	        verifyState(this);
	
	        if (!/^(head)$/i.test(this.method)) {
	            this.requestBody = data;
	        }
	        this.requestHeaders["Content-Type"] = "text/plain;charset=utf-8";
	
	        this.errorFlag = false;
	        this.sendFlag = true;
	        this.readyStateChange(FakeXDomainRequest.OPENED);
	
	        if (typeof this.onSend === "function") {
	            this.onSend(this);
	        }
	    },
	
	    abort: function abort() {
	        this.aborted = true;
	        this.responseText = null;
	        this.errorFlag = true;
	
	        if (this.readyState > FakeXDomainRequest.UNSENT && this.sendFlag) {
	            this.readyStateChange(FakeXDomainRequest.DONE);
	            this.sendFlag = false;
	        }
	    },
	
	    setResponseBody: function setResponseBody(body) {
	        verifyRequestSent(this);
	        verifyResponseBodyType(body);
	
	        var chunkSize = this.chunkSize || 10;
	        var index = 0;
	        this.responseText = "";
	
	        do {
	            this.readyStateChange(FakeXDomainRequest.LOADING);
	            this.responseText += body.substring(index, index + chunkSize);
	            index += chunkSize;
	        } while (index < body.length);
	
	        this.readyStateChange(FakeXDomainRequest.DONE);
	    },
	
	    respond: function respond(status, contentType, body) {
	        // content-type ignored, since XDomainRequest does not carry this
	        // we keep the same syntax for respond(...) as for FakeXMLHttpRequest to ease
	        // test integration across browsers
	        this.status = typeof status === "number" ? status : 200;
	        this.setResponseBody(body || "");
	    },
	
	    simulatetimeout: function simulatetimeout() {
	        this.status = 0;
	        this.isTimeout = true;
	        // Access to this should actually throw an error
	        this.responseText = undefined;
	        this.readyStateChange(FakeXDomainRequest.DONE);
	    }
	});
	
	extend(FakeXDomainRequest, {
	    UNSENT: 0,
	    OPENED: 1,
	    LOADING: 3,
	    DONE: 4
	});
	
	function useFakeXDomainRequest() {
	    FakeXDomainRequest.restore = function restore(keepOnCreate) {
	        if (xdr.supportsXDR) {
	            global.XDomainRequest = xdr.GlobalXDomainRequest;
	        }
	
	        delete FakeXDomainRequest.restore;
	
	        if (keepOnCreate !== true) {
	            delete FakeXDomainRequest.onCreate;
	        }
	    };
	    if (xdr.supportsXDR) {
	        global.XDomainRequest = FakeXDomainRequest;
	    }
	    return FakeXDomainRequest;
	}
	
	module.exports = {
	    xdr: xdr,
	    FakeXDomainRequest: FakeXDomainRequest,
	    useFakeXDomainRequest: useFakeXDomainRequest
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Fake XMLHttpRequest object
	 *
	 * @author Christian Johansen (christian@cjohansen.no)
	 * @license BSD
	 *
	 * Copyright (c) 2010-2013 Christian Johansen
	 */
	"use strict";
	
	var TextEncoder = __webpack_require__(363).TextEncoder;
	
	var configureLogError = __webpack_require__(22);
	var sinonEvent = __webpack_require__(36);
	var extend = __webpack_require__(5);
	
	function getWorkingXHR(globalScope) {
	    var supportsXHR = typeof globalScope.XMLHttpRequest !== "undefined";
	    if (supportsXHR) {
	        return globalScope.XMLHttpRequest;
	    }
	
	    var supportsActiveX = typeof globalScope.ActiveXObject !== "undefined";
	    if (supportsActiveX) {
	        return function () {
	            return new globalScope.ActiveXObject("MSXML2.XMLHTTP.3.0");
	        };
	    }
	
	    return false;
	}
	
	var supportsProgress = typeof ProgressEvent !== "undefined";
	var supportsCustomEvent = typeof CustomEvent !== "undefined";
	var supportsFormData = typeof FormData !== "undefined";
	var supportsArrayBuffer = typeof ArrayBuffer !== "undefined";
	var supportsBlob = function () {
	    try {
	        return !!new Blob();
	    } catch (e) {
	        return false;
	    }
	}();
	var isReactNative = global.navigator && global.navigator.product === "ReactNative";
	var sinonXhr = { XMLHttpRequest: global.XMLHttpRequest };
	sinonXhr.GlobalXMLHttpRequest = global.XMLHttpRequest;
	sinonXhr.GlobalActiveXObject = global.ActiveXObject;
	sinonXhr.supportsActiveX = typeof sinonXhr.GlobalActiveXObject !== "undefined";
	sinonXhr.supportsXHR = typeof sinonXhr.GlobalXMLHttpRequest !== "undefined";
	sinonXhr.workingXHR = getWorkingXHR(global);
	sinonXhr.supportsCORS = isReactNative || sinonXhr.supportsXHR && "withCredentials" in new sinonXhr.GlobalXMLHttpRequest();
	
	var unsafeHeaders = {
	    "Accept-Charset": true,
	    "Accept-Encoding": true,
	    Connection: true,
	    "Content-Length": true,
	    Cookie: true,
	    Cookie2: true,
	    "Content-Transfer-Encoding": true,
	    Date: true,
	    Expect: true,
	    Host: true,
	    "Keep-Alive": true,
	    Referer: true,
	    TE: true,
	    Trailer: true,
	    "Transfer-Encoding": true,
	    Upgrade: true,
	    "User-Agent": true,
	    Via: true
	};
	
	// An upload object is created for each
	// FakeXMLHttpRequest and allows upload
	// events to be simulated using uploadProgress
	// and uploadError.
	function UploadProgress() {
	    this.eventListeners = {
	        abort: [],
	        error: [],
	        load: [],
	        loadend: [],
	        progress: []
	    };
	}
	
	UploadProgress.prototype.addEventListener = function addEventListener(event, listener) {
	    this.eventListeners[event].push(listener);
	};
	
	UploadProgress.prototype.removeEventListener = function removeEventListener(event, listener) {
	    var listeners = this.eventListeners[event] || [];
	
	    for (var i = 0, l = listeners.length; i < l; ++i) {
	        if (listeners[i] === listener) {
	            return listeners.splice(i, 1);
	        }
	    }
	};
	
	UploadProgress.prototype.dispatchEvent = function dispatchEvent(event) {
	    var listeners = this.eventListeners[event.type] || [];
	
	    for (var i = 0, listener; (listener = listeners[i]) != null; i++) {
	        listener(event);
	    }
	};
	
	// Note that for FakeXMLHttpRequest to work pre ES5
	// we lose some of the alignment with the spec.
	// To ensure as close a match as possible,
	// set responseType before calling open, send or respond;
	function FakeXMLHttpRequest(config) {
	    this.readyState = FakeXMLHttpRequest.UNSENT;
	    this.requestHeaders = {};
	    this.requestBody = null;
	    this.status = 0;
	    this.statusText = "";
	    this.upload = new UploadProgress();
	    this.responseType = "";
	    this.response = "";
	    this.logError = configureLogError(config);
	    if (sinonXhr.supportsCORS) {
	        this.withCredentials = false;
	    }
	
	    var xhr = this;
	    var events = ["loadstart", "load", "abort", "error", "loadend"];
	
	    function addEventListener(eventName) {
	        xhr.addEventListener(eventName, function (event) {
	            var listener = xhr["on" + eventName];
	
	            if (listener && typeof listener === "function") {
	                listener.call(this, event);
	            }
	        });
	    }
	
	    for (var i = events.length - 1; i >= 0; i--) {
	        addEventListener(events[i]);
	    }
	
	    if (typeof FakeXMLHttpRequest.onCreate === "function") {
	        FakeXMLHttpRequest.onCreate(this);
	    }
	}
	
	function verifyState(xhr) {
	    if (xhr.readyState !== FakeXMLHttpRequest.OPENED) {
	        throw new Error("INVALID_STATE_ERR");
	    }
	
	    if (xhr.sendFlag) {
	        throw new Error("INVALID_STATE_ERR");
	    }
	}
	
	function getHeader(headers, header) {
	    header = header.toLowerCase();
	
	    for (var h in headers) {
	        if (h.toLowerCase() === header) {
	            return h;
	        }
	    }
	
	    return null;
	}
	
	// filtering to enable a white-list version of Sinon FakeXhr,
	// where whitelisted requests are passed through to real XHR
	function each(collection, callback) {
	    if (!collection) {
	        return;
	    }
	
	    for (var i = 0, l = collection.length; i < l; i += 1) {
	        callback(collection[i]);
	    }
	}
	function some(collection, callback) {
	    for (var index = 0; index < collection.length; index++) {
	        if (callback(collection[index]) === true) {
	            return true;
	        }
	    }
	    return false;
	}
	// largest arity in XHR is 5 - XHR#open
	var apply = function apply(obj, method, args) {
	    switch (args.length) {
	        case 0:
	            return obj[method]();
	        case 1:
	            return obj[method](args[0]);
	        case 2:
	            return obj[method](args[0], args[1]);
	        case 3:
	            return obj[method](args[0], args[1], args[2]);
	        case 4:
	            return obj[method](args[0], args[1], args[2], args[3]);
	        case 5:
	            return obj[method](args[0], args[1], args[2], args[3], args[4]);
	        default:
	            throw new Error("Unhandled case");
	    }
	};
	
	FakeXMLHttpRequest.filters = [];
	FakeXMLHttpRequest.addFilter = function addFilter(fn) {
	    this.filters.push(fn);
	};
	var IE6Re = /MSIE 6/;
	FakeXMLHttpRequest.defake = function defake(fakeXhr, xhrArgs) {
	    var xhr = new sinonXhr.workingXHR(); // eslint-disable-line new-cap
	
	    each(["open", "setRequestHeader", "send", "abort", "getResponseHeader", "getAllResponseHeaders", "addEventListener", "overrideMimeType", "removeEventListener"], function (method) {
	        fakeXhr[method] = function () {
	            return apply(xhr, method, arguments);
	        };
	    });
	
	    var copyAttrs = function copyAttrs(args) {
	        each(args, function (attr) {
	            try {
	                fakeXhr[attr] = xhr[attr];
	            } catch (e) {
	                if (!IE6Re.test(navigator.userAgent)) {
	                    throw e;
	                }
	            }
	        });
	    };
	
	    var stateChange = function stateChange() {
	        fakeXhr.readyState = xhr.readyState;
	        if (xhr.readyState >= FakeXMLHttpRequest.HEADERS_RECEIVED) {
	            copyAttrs(["status", "statusText"]);
	        }
	        if (xhr.readyState >= FakeXMLHttpRequest.LOADING) {
	            copyAttrs(["responseText", "response"]);
	        }
	        if (xhr.readyState === FakeXMLHttpRequest.DONE) {
	            copyAttrs(["responseXML"]);
	        }
	        if (fakeXhr.onreadystatechange) {
	            fakeXhr.onreadystatechange.call(fakeXhr, { target: fakeXhr });
	        }
	    };
	
	    if (xhr.addEventListener) {
	        for (var event in fakeXhr.eventListeners) {
	            if (fakeXhr.eventListeners.hasOwnProperty(event)) {
	
	                /*eslint-disable no-loop-func*/
	                each(fakeXhr.eventListeners[event], function (handler) {
	                    xhr.addEventListener(event, handler);
	                });
	                /*eslint-enable no-loop-func*/
	            }
	        }
	        xhr.addEventListener("readystatechange", stateChange);
	    } else {
	        xhr.onreadystatechange = stateChange;
	    }
	    apply(xhr, "open", xhrArgs);
	};
	FakeXMLHttpRequest.useFilters = false;
	
	function verifyRequestOpened(xhr) {
	    if (xhr.readyState !== FakeXMLHttpRequest.OPENED) {
	        throw new Error("INVALID_STATE_ERR - " + xhr.readyState);
	    }
	}
	
	function verifyRequestSent(xhr) {
	    if (xhr.readyState === FakeXMLHttpRequest.DONE) {
	        throw new Error("Request done");
	    }
	}
	
	function verifyHeadersReceived(xhr) {
	    if (xhr.async && xhr.readyState !== FakeXMLHttpRequest.HEADERS_RECEIVED) {
	        throw new Error("No headers received");
	    }
	}
	
	function verifyResponseBodyType(body) {
	    if (typeof body !== "string") {
	        var error = new Error("Attempted to respond to fake XMLHttpRequest with " + body + ", which is not a string.");
	        error.name = "InvalidBodyException";
	        throw error;
	    }
	}
	
	function convertToArrayBuffer(body, encoding) {
	    return new TextEncoder(encoding || "utf-8").encode(body).buffer;
	}
	
	function isXmlContentType(contentType) {
	    return !contentType || /(text\/xml)|(application\/xml)|(\+xml)/.test(contentType);
	}
	
	function convertResponseBody(responseType, contentType, body) {
	    if (responseType === "" || responseType === "text") {
	        return body;
	    } else if (supportsArrayBuffer && responseType === "arraybuffer") {
	        return convertToArrayBuffer(body);
	    } else if (responseType === "json") {
	        try {
	            return JSON.parse(body);
	        } catch (e) {
	            // Return parsing failure as null
	            return null;
	        }
	    } else if (supportsBlob && responseType === "blob") {
	        var blobOptions = {};
	        if (contentType) {
	            blobOptions.type = contentType;
	        }
	        return new Blob([convertToArrayBuffer(body)], blobOptions);
	    } else if (responseType === "document") {
	        if (isXmlContentType(contentType)) {
	            return FakeXMLHttpRequest.parseXML(body);
	        }
	        return null;
	    }
	    throw new Error("Invalid responseType " + responseType);
	}
	
	function clearResponse(xhr) {
	    if (xhr.responseType === "" || xhr.responseType === "text") {
	        xhr.response = xhr.responseText = "";
	    } else {
	        xhr.response = xhr.responseText = null;
	    }
	    xhr.responseXML = null;
	}
	
	FakeXMLHttpRequest.parseXML = function parseXML(text) {
	    // Treat empty string as parsing failure
	    if (text !== "") {
	        try {
	            if (typeof DOMParser !== "undefined") {
	                var parser = new DOMParser();
	                return parser.parseFromString(text, "text/xml");
	            }
	            var xmlDoc = new window.ActiveXObject("Microsoft.XMLDOM");
	            xmlDoc.async = "false";
	            xmlDoc.loadXML(text);
	            return xmlDoc;
	        } catch (e) {
	            // Unable to parse XML - no biggie
	        }
	    }
	
	    return null;
	};
	
	FakeXMLHttpRequest.statusCodes = {
	    100: "Continue",
	    101: "Switching Protocols",
	    200: "OK",
	    201: "Created",
	    202: "Accepted",
	    203: "Non-Authoritative Information",
	    204: "No Content",
	    205: "Reset Content",
	    206: "Partial Content",
	    207: "Multi-Status",
	    300: "Multiple Choice",
	    301: "Moved Permanently",
	    302: "Found",
	    303: "See Other",
	    304: "Not Modified",
	    305: "Use Proxy",
	    307: "Temporary Redirect",
	    400: "Bad Request",
	    401: "Unauthorized",
	    402: "Payment Required",
	    403: "Forbidden",
	    404: "Not Found",
	    405: "Method Not Allowed",
	    406: "Not Acceptable",
	    407: "Proxy Authentication Required",
	    408: "Request Timeout",
	    409: "Conflict",
	    410: "Gone",
	    411: "Length Required",
	    412: "Precondition Failed",
	    413: "Request Entity Too Large",
	    414: "Request-URI Too Long",
	    415: "Unsupported Media Type",
	    416: "Requested Range Not Satisfiable",
	    417: "Expectation Failed",
	    422: "Unprocessable Entity",
	    500: "Internal Server Error",
	    501: "Not Implemented",
	    502: "Bad Gateway",
	    503: "Service Unavailable",
	    504: "Gateway Timeout",
	    505: "HTTP Version Not Supported"
	};
	
	extend(FakeXMLHttpRequest.prototype, sinonEvent.EventTarget, {
	    async: true,
	
	    open: function open(method, url, async, username, password) {
	        this.method = method;
	        this.url = url;
	        this.async = typeof async === "boolean" ? async : true;
	        this.username = username;
	        this.password = password;
	        clearResponse(this);
	        this.requestHeaders = {};
	        this.sendFlag = false;
	
	        if (FakeXMLHttpRequest.useFilters === true) {
	            var xhrArgs = arguments;
	            var defake = some(FakeXMLHttpRequest.filters, function (filter) {
	                return filter.apply(this, xhrArgs);
	            });
	            if (defake) {
	                return FakeXMLHttpRequest.defake(this, arguments);
	            }
	        }
	        this.readyStateChange(FakeXMLHttpRequest.OPENED);
	    },
	
	    readyStateChange: function readyStateChange(state) {
	        this.readyState = state;
	
	        var readyStateChangeEvent = new sinonEvent.Event("readystatechange", false, false, this);
	        var event, progress;
	
	        if (typeof this.onreadystatechange === "function") {
	            try {
	                this.onreadystatechange(readyStateChangeEvent);
	            } catch (e) {
	                this.logError("Fake XHR onreadystatechange handler", e);
	            }
	        }
	
	        if (this.readyState === FakeXMLHttpRequest.DONE) {
	            if (this.aborted || this.status === 0) {
	                progress = { loaded: 0, total: 0 };
	                event = this.aborted ? "abort" : "error";
	            } else {
	                progress = { loaded: 100, total: 100 };
	                event = "load";
	            }
	
	            if (supportsProgress) {
	                this.upload.dispatchEvent(new sinonEvent.ProgressEvent("progress", progress, this));
	                this.upload.dispatchEvent(new sinonEvent.ProgressEvent(event, progress, this));
	                this.upload.dispatchEvent(new sinonEvent.ProgressEvent("loadend", progress, this));
	            }
	
	            this.dispatchEvent(new sinonEvent.ProgressEvent("progress", progress, this));
	            this.dispatchEvent(new sinonEvent.ProgressEvent(event, progress, this));
	            this.dispatchEvent(new sinonEvent.ProgressEvent("loadend", progress, this));
	        }
	
	        this.dispatchEvent(readyStateChangeEvent);
	    },
	
	    setRequestHeader: function setRequestHeader(header, value) {
	        verifyState(this);
	
	        if (unsafeHeaders[header] || /^(Sec-|Proxy-)/.test(header)) {
	            throw new Error("Refused to set unsafe header \"" + header + "\"");
	        }
	
	        if (this.requestHeaders[header]) {
	            this.requestHeaders[header] += "," + value;
	        } else {
	            this.requestHeaders[header] = value;
	        }
	    },
	
	    // Helps testing
	    setResponseHeaders: function setResponseHeaders(headers) {
	        verifyRequestOpened(this);
	        this.responseHeaders = {};
	
	        for (var header in headers) {
	            if (headers.hasOwnProperty(header)) {
	                this.responseHeaders[header] = headers[header];
	            }
	        }
	
	        if (this.async) {
	            this.readyStateChange(FakeXMLHttpRequest.HEADERS_RECEIVED);
	        } else {
	            this.readyState = FakeXMLHttpRequest.HEADERS_RECEIVED;
	        }
	    },
	
	    // Currently treats ALL data as a DOMString (i.e. no Document)
	    send: function send(data) {
	        verifyState(this);
	
	        if (!/^(head)$/i.test(this.method)) {
	            var contentType = getHeader(this.requestHeaders, "Content-Type");
	            if (this.requestHeaders[contentType]) {
	                var value = this.requestHeaders[contentType].split(";");
	                this.requestHeaders[contentType] = value[0] + ";charset=utf-8";
	            } else if (supportsFormData && !(data instanceof FormData)) {
	                this.requestHeaders["Content-Type"] = "text/plain;charset=utf-8";
	            }
	
	            this.requestBody = data;
	        }
	
	        this.errorFlag = false;
	        this.sendFlag = this.async;
	        clearResponse(this);
	        this.readyStateChange(FakeXMLHttpRequest.OPENED);
	
	        if (typeof this.onSend === "function") {
	            this.onSend(this);
	        }
	
	        this.dispatchEvent(new sinonEvent.Event("loadstart", false, false, this));
	    },
	
	    abort: function abort() {
	        this.aborted = true;
	        clearResponse(this);
	        this.errorFlag = true;
	        this.requestHeaders = {};
	        this.responseHeaders = {};
	
	        if (this.readyState > FakeXMLHttpRequest.UNSENT && this.sendFlag) {
	            this.readyStateChange(FakeXMLHttpRequest.DONE);
	            this.sendFlag = false;
	        }
	
	        this.readyState = FakeXMLHttpRequest.UNSENT;
	    },
	
	    error: function error() {
	        clearResponse(this);
	        this.errorFlag = true;
	        this.requestHeaders = {};
	        this.responseHeaders = {};
	
	        this.readyStateChange(FakeXMLHttpRequest.DONE);
	    },
	
	    getResponseHeader: function getResponseHeader(header) {
	        if (this.readyState < FakeXMLHttpRequest.HEADERS_RECEIVED) {
	            return null;
	        }
	
	        if (/^Set-Cookie2?$/i.test(header)) {
	            return null;
	        }
	
	        header = getHeader(this.responseHeaders, header);
	
	        return this.responseHeaders[header] || null;
	    },
	
	    getAllResponseHeaders: function getAllResponseHeaders() {
	        if (this.readyState < FakeXMLHttpRequest.HEADERS_RECEIVED) {
	            return "";
	        }
	
	        var headers = "";
	
	        for (var header in this.responseHeaders) {
	            if (this.responseHeaders.hasOwnProperty(header) && !/^Set-Cookie2?$/i.test(header)) {
	                headers += header + ": " + this.responseHeaders[header] + "\r\n";
	            }
	        }
	
	        return headers;
	    },
	
	    setResponseBody: function setResponseBody(body) {
	        verifyRequestSent(this);
	        verifyHeadersReceived(this);
	        verifyResponseBodyType(body);
	        var contentType = this.getResponseHeader("Content-Type");
	
	        var isTextResponse = this.responseType === "" || this.responseType === "text";
	        clearResponse(this);
	        if (this.async) {
	            var chunkSize = this.chunkSize || 10;
	            var index = 0;
	
	            do {
	                this.readyStateChange(FakeXMLHttpRequest.LOADING);
	
	                if (isTextResponse) {
	                    this.responseText = this.response += body.substring(index, index + chunkSize);
	                }
	                index += chunkSize;
	            } while (index < body.length);
	        }
	
	        this.response = convertResponseBody(this.responseType, contentType, body);
	        if (isTextResponse) {
	            this.responseText = this.response;
	        }
	
	        if (this.responseType === "document") {
	            this.responseXML = this.response;
	        } else if (this.responseType === "" && isXmlContentType(contentType)) {
	            this.responseXML = FakeXMLHttpRequest.parseXML(this.responseText);
	        }
	        this.readyStateChange(FakeXMLHttpRequest.DONE);
	    },
	
	    respond: function respond(status, headers, body) {
	        this.status = typeof status === "number" ? status : 200;
	        this.statusText = FakeXMLHttpRequest.statusCodes[this.status];
	        this.setResponseHeaders(headers || {});
	        this.setResponseBody(body || "");
	    },
	
	    uploadProgress: function uploadProgress(progressEventRaw) {
	        if (supportsProgress) {
	            this.upload.dispatchEvent(new sinonEvent.ProgressEvent("progress", progressEventRaw));
	        }
	    },
	
	    downloadProgress: function downloadProgress(progressEventRaw) {
	        if (supportsProgress) {
	            this.dispatchEvent(new sinonEvent.ProgressEvent("progress", progressEventRaw));
	        }
	    },
	
	    uploadError: function uploadError(error) {
	        if (supportsCustomEvent) {
	            this.upload.dispatchEvent(new sinonEvent.CustomEvent("error", { detail: error }));
	        }
	    }
	});
	
	extend(FakeXMLHttpRequest, {
	    UNSENT: 0,
	    OPENED: 1,
	    HEADERS_RECEIVED: 2,
	    LOADING: 3,
	    DONE: 4
	});
	
	function useFakeXMLHttpRequest() {
	    FakeXMLHttpRequest.restore = function restore(keepOnCreate) {
	        if (sinonXhr.supportsXHR) {
	            global.XMLHttpRequest = sinonXhr.GlobalXMLHttpRequest;
	        }
	
	        if (sinonXhr.supportsActiveX) {
	            global.ActiveXObject = sinonXhr.GlobalActiveXObject;
	        }
	
	        delete FakeXMLHttpRequest.restore;
	
	        if (keepOnCreate !== true) {
	            delete FakeXMLHttpRequest.onCreate;
	        }
	    };
	    if (sinonXhr.supportsXHR) {
	        global.XMLHttpRequest = FakeXMLHttpRequest;
	    }
	
	    if (sinonXhr.supportsActiveX) {
	        global.ActiveXObject = function ActiveXObject(objId) {
	            if (objId === "Microsoft.XMLHTTP" || /^Msxml2\.XMLHTTP/i.test(objId)) {
	
	                return new FakeXMLHttpRequest();
	            }
	
	            return new sinonXhr.GlobalActiveXObject(objId);
	        };
	    }
	
	    return FakeXMLHttpRequest;
	}
	
	module.exports = {
	    xhr: sinonXhr,
	    FakeXMLHttpRequest: FakeXMLHttpRequest,
	    useFakeXMLHttpRequest: useFakeXMLHttpRequest
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 339 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * @license AngularJS v1.3.10
	 * (c) 2010-2014 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function (window, angular, undefined) {
	  'use strict';
	
	  var $sanitizeMinErr = angular.$$minErr('$sanitize');
	
	  /**
	   * @ngdoc module
	   * @name ngSanitize
	   * @description
	   *
	   * # ngSanitize
	   *
	   * The `ngSanitize` module provides functionality to sanitize HTML.
	   *
	   *
	   * <div doc-module-components="ngSanitize"></div>
	   *
	   * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	   */
	
	  /*
	   * HTML Parser By Misko Hevery (misko@hevery.com)
	   * based on:  HTML Parser By John Resig (ejohn.org)
	   * Original code by Erik Arvidsson, Mozilla Public License
	   * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	   *
	   * // Use like so:
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs, unary) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   */
	
	  /**
	   * @ngdoc service
	   * @name $sanitize
	   * @kind function
	   *
	   * @description
	   *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	   *   then serialized back to properly escaped html string. This means that no unsafe input can make
	   *   it into the returned string, however, since our parser is more strict than a typical browser
	   *   parser, it's possible that some obscure input, which would be recognized as valid HTML by a
	   *   browser, won't make it through the sanitizer. The input may also contain SVG markup.
	   *   The whitelist is configured using the functions `aHrefSanitizationWhitelist` and
	   *   `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider `$compileProvider`}.
	   *
	   * @param {string} html HTML input.
	   * @returns {string} Sanitized HTML.
	   *
	   * @example
	     <example module="sanitizeExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <script>
	           angular.module('sanitizeExample', ['ngSanitize'])
	             .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	               $scope.snippet =
	                 '<p style="color:blue">an html\n' +
	                 '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	                 'snippet</p>';
	               $scope.deliberatelyTrustDangerousSnippet = function() {
	                 return $sce.trustAsHtml($scope.snippet);
	               };
	             }]);
	       </script>
	       <div ng-controller="ExampleController">
	          Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	         <table>
	           <tr>
	             <td>Directive</td>
	             <td>How</td>
	             <td>Source</td>
	             <td>Rendered</td>
	           </tr>
	           <tr id="bind-html-with-sanitize">
	             <td>ng-bind-html</td>
	             <td>Automatically uses $sanitize</td>
	             <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	             <td><div ng-bind-html="snippet"></div></td>
	           </tr>
	           <tr id="bind-html-with-trust">
	             <td>ng-bind-html</td>
	             <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	             <td>
	             <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	  &lt;/div&gt;</pre>
	             </td>
	             <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	           </tr>
	           <tr id="bind-default">
	             <td>ng-bind</td>
	             <td>Automatically escapes</td>
	             <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	             <td><div ng-bind="snippet"></div></td>
	           </tr>
	         </table>
	         </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should sanitize the html snippet by default', function() {
	         expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	           toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	       });
	  
	       it('should inline raw snippet if bound to a trusted value', function() {
	         expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	           toBe("<p style=\"color:blue\">an html\n" +
	                "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	                "snippet</p>");
	       });
	  
	       it('should escape snippet without any filter', function() {
	         expect(element(by.css('#bind-default div')).getInnerHtml()).
	           toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	                "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	                "snippet&lt;/p&gt;");
	       });
	  
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	         expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	           toBe('new <b>text</b>');
	         expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	           'new <b onclick="alert(1)">text</b>');
	         expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	           "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	       });
	     </file>
	     </example>
	   */
	  function $SanitizeProvider() {
	    this.$get = ['$$sanitizeUri', function ($$sanitizeUri) {
	      return function (html) {
	        if (typeof arguments[1] != 'undefined') {
	          arguments[1].version = 'taSanitize';
	        }
	        var buf = [];
	        htmlParser(html, htmlSanitizeWriter(buf, function (uri, isImage) {
	          return !/^unsafe/.test($$sanitizeUri(uri, isImage));
	        }));
	        return buf.join('');
	      };
	    }];
	  }
	
	  function sanitizeText(chars) {
	    var buf = [];
	    var writer = htmlSanitizeWriter(buf, angular.noop);
	    writer.chars(chars);
	    return buf.join('');
	  }
	
	  // Regular Expressions for parsing tags and attributes
	  var START_TAG_REGEXP = /^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,
	      END_TAG_REGEXP = /^<\/\s*([\w:-]+)[^>]*>/,
	      ATTR_REGEXP = /([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,
	      BEGIN_TAG_REGEXP = /^</,
	      BEGING_END_TAGE_REGEXP = /^<\//,
	      COMMENT_REGEXP = /<!--(.*?)-->/g,
	      DOCTYPE_REGEXP = /<!DOCTYPE([^>]*?)>/i,
	      CDATA_REGEXP = /<!\[CDATA\[(.*?)]]>/g,
	      SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	
	  // Match everything outside of normal chars and " (quote character)
	  NON_ALPHANUMERIC_REGEXP = /([^\#-~| |!])/g;
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = makeMap("area,br,col,hr,img,wbr,input");
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = makeMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	      optionalEndTagInlineElements = makeMap("rp,rt"),
	      optionalEndTagElements = angular.extend({}, optionalEndTagInlineElements, optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = angular.extend({}, optionalEndTagBlockElements, makeMap("address,article," + "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," + "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul"));
	
	  // Inline Elements - HTML5
	  var inlineElements = angular.extend({}, optionalEndTagInlineElements, makeMap("a,abbr,acronym,b," + "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," + "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  var svgElements = makeMap("animate,animateColor,animateMotion,animateTransform,circle,defs," + "desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient," + "line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,set," + "stop,svg,switch,text,title,tspan,use");
	
	  // Special Elements (can contain anything)
	  var specialElements = makeMap("script,style");
	
	  var validElements = angular.extend({}, voidElements, blockElements, inlineElements, optionalEndTagElements, svgElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = makeMap("background,cite,href,longdesc,src,usemap,xlink:href");
	
	  var htmlAttrs = makeMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' + 'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' + 'id,ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' + 'scope,scrolling,shape,size,span,start,summary,target,title,type,' + 'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = makeMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' + 'attributeName,attributeType,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,' + 'color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,' + 'font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,' + 'gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,' + 'keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,' + 'markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,' + 'overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,' + 'repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,' + 'stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,' + 'stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,' + 'stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,' + 'underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,' + 'viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,' + 'xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,' + 'zoomAndPan');
	
	  var validAttrs = angular.extend({}, uriAttrs, svgAttrs, htmlAttrs);
	
	  function makeMap(str) {
	    var obj = {},
	        items = str.split(','),
	        i;
	    for (i = 0; i < items.length; i++) {
	      obj[items[i]] = true;
	    }return obj;
	  }
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs, unary) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParser(html, handler) {
	    if (typeof html !== 'string') {
	      if (html === null || typeof html === 'undefined') {
	        html = '';
	      } else {
	        html = '' + html;
	      }
	    }
	    var index,
	        chars,
	        match,
	        stack = [],
	        last = html,
	        text;
	    stack.last = function () {
	      return stack[stack.length - 1];
	    };
	
	    while (html) {
	      text = '';
	      chars = true;
	
	      // Make sure we're not in a script or style element
	      if (!stack.last() || !specialElements[stack.last()]) {
	
	        // Comment
	        if (html.indexOf("<!--") === 0) {
	          // comments containing -- are not allowed unless they terminate the comment
	          index = html.indexOf("--", 4);
	
	          if (index >= 0 && html.lastIndexOf("-->", index) === index) {
	            if (handler.comment) handler.comment(html.substring(4, index));
	            html = html.substring(index + 3);
	            chars = false;
	          }
	          // DOCTYPE
	        } else if (DOCTYPE_REGEXP.test(html)) {
	          match = html.match(DOCTYPE_REGEXP);
	
	          if (match) {
	            html = html.replace(match[0], '');
	            chars = false;
	          }
	          // end tag
	        } else if (BEGING_END_TAGE_REGEXP.test(html)) {
	          match = html.match(END_TAG_REGEXP);
	
	          if (match) {
	            html = html.substring(match[0].length);
	            match[0].replace(END_TAG_REGEXP, parseEndTag);
	            chars = false;
	          }
	
	          // start tag
	        } else if (BEGIN_TAG_REGEXP.test(html)) {
	          match = html.match(START_TAG_REGEXP);
	
	          if (match) {
	            // We only have a valid start-tag if there is a '>'.
	            if (match[4]) {
	              html = html.substring(match[0].length);
	              match[0].replace(START_TAG_REGEXP, parseStartTag);
	            }
	            chars = false;
	          } else {
	            // no ending tag found --- this piece should be encoded as an entity.
	            text += '<';
	            html = html.substring(1);
	          }
	        }
	
	        if (chars) {
	          index = html.indexOf("<");
	
	          text += index < 0 ? html : html.substring(0, index);
	          html = index < 0 ? "" : html.substring(index);
	
	          if (handler.chars) handler.chars(decodeEntities(text));
	        }
	      } else {
	        html = html.replace(new RegExp("([^]*)<\\s*\\/\\s*" + stack.last() + "[^>]*>", 'i'), function (all, text) {
	          text = text.replace(COMMENT_REGEXP, "$1").replace(CDATA_REGEXP, "$1");
	
	          if (handler.chars) handler.chars(decodeEntities(text));
	
	          return "";
	        });
	
	        parseEndTag("", stack.last());
	      }
	
	      if (html == last) {
	        throw $sanitizeMinErr('badparse', "The sanitizer was unable to parse the following block " + "of html: {0}", html);
	      }
	      last = html;
	    }
	
	    // Clean up any remaining tags
	    parseEndTag();
	
	    function parseStartTag(tag, tagName, rest, unary) {
	      tagName = angular.lowercase(tagName);
	      if (blockElements[tagName]) {
	        while (stack.last() && inlineElements[stack.last()]) {
	          parseEndTag("", stack.last());
	        }
	      }
	
	      if (optionalEndTagElements[tagName] && stack.last() == tagName) {
	        parseEndTag("", tagName);
	      }
	
	      unary = voidElements[tagName] || !!unary;
	
	      if (!unary) stack.push(tagName);
	
	      var attrs = {};
	
	      rest.replace(ATTR_REGEXP, function (match, name, doubleQuotedValue, singleQuotedValue, unquotedValue) {
	        var value = doubleQuotedValue || singleQuotedValue || unquotedValue || '';
	
	        attrs[name] = decodeEntities(value);
	      });
	      if (handler.start) handler.start(tagName, attrs, unary);
	    }
	
	    function parseEndTag(tag, tagName) {
	      var pos = 0,
	          i;
	      tagName = angular.lowercase(tagName);
	      if (tagName)
	        // Find the closest opened tag of the same type
	        for (pos = stack.length - 1; pos >= 0; pos--) {
	          if (stack[pos] == tagName) break;
	        }if (pos >= 0) {
	        // Close all the open elements, up the stack
	        for (i = stack.length - 1; i >= pos; i--) {
	          if (handler.end) handler.end(stack[i]);
	        } // Remove the open elements from the stack
	        stack.length = pos;
	      }
	    }
	  }
	
	  var hiddenPre = document.createElement("pre");
	  var spaceRe = /^(\s*)([\s\S]*?)(\s*)$/;
	  /**
	   * decodes all entities into regular string
	   * @param value
	   * @returns {string} A string with decoded entities.
	   */
	  function decodeEntities(value) {
	    if (!value) {
	      return '';
	    }
	
	    // Note: IE8 does not preserve spaces at the start/end of innerHTML
	    // so we must capture them and reattach them afterward
	    var parts = spaceRe.exec(value);
	    var spaceBefore = parts[1];
	    var spaceAfter = parts[3];
	    var content = parts[2];
	    if (content) {
	      hiddenPre.innerHTML = content.replace(/</g, "&lt;");
	      // innerText depends on styling as it doesn't display hidden elements.
	      // Therefore, it's better to use textContent not to cause unnecessary
	      // reflows. However, IE<9 don't support textContent so the innerText
	      // fallback is necessary.
	      content = 'textContent' in hiddenPre ? hiddenPre.textContent : hiddenPre.innerText;
	    }
	    return spaceBefore + content + spaceAfter;
	  }
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.replace(/&/g, '&amp;').replace(SURROGATE_PAIR_REGEXP, function (value) {
	      var hi = value.charCodeAt(0);
	      var low = value.charCodeAt(1);
	      return '&#' + ((hi - 0xD800) * 0x400 + (low - 0xDC00) + 0x10000) + ';';
	    }).replace(NON_ALPHANUMERIC_REGEXP, function (value) {
	      // unsafe chars are: \u0000-\u001f \u007f-\u009f \u00ad \u0600-\u0604 \u070f \u17b4 \u17b5 \u200c-\u200f \u2028-\u202f \u2060-\u206f \ufeff \ufff0-\uffff from jslint.com/lint.html
	      // decimal values are: 0-31, 127-159, 173, 1536-1540, 1807, 6068, 6069, 8204-8207, 8232-8239, 8288-8303, 65279, 65520-65535
	      var c = value.charCodeAt(0);
	      // if unsafe character encode
	      if (c <= 159 || c == 173 || c >= 1536 && c <= 1540 || c == 1807 || c == 6068 || c == 6069 || c >= 8204 && c <= 8207 || c >= 8232 && c <= 8239 || c >= 8288 && c <= 8303 || c == 65279 || c >= 65520 && c <= 65535) return '&#' + c + ';';
	      return value; // avoids multilingual issues
	    }).replace(/</g, '&lt;').replace(/>/g, '&gt;');
	  }
	
	  var trim = function () {
	    // native trim is way faster: http://jsperf.com/angular-trim-test
	    // but IE doesn't have it... :-(
	    // TODO: we should move this into IE/ES5 polyfill
	    if (!String.prototype.trim) {
	      return function (value) {
	        return angular.isString(value) ? value.replace(/^\s\s*/, '').replace(/\s\s*$/, '') : value;
	      };
	    }
	    return function (value) {
	      return angular.isString(value) ? value.trim() : value;
	    };
	  }();
	
	  // Custom logic for accepting certain style options only - textAngular
	  // Currently allows only the color, background-color, text-align, float, width and height attributes
	  // all other attributes should be easily done through classes.
	  function validStyles(styleAttr) {
	    var result = '';
	    var styleArray = styleAttr.split(';');
	    angular.forEach(styleArray, function (value) {
	      var v = value.split(':');
	      if (v.length == 2) {
	        var key = trim(angular.lowercase(v[0]));
	        var value = trim(angular.lowercase(v[1]));
	        if ((key === 'color' || key === 'background-color') && (value.match(/^rgb\([0-9%,\. ]*\)$/i) || value.match(/^rgba\([0-9%,\. ]*\)$/i) || value.match(/^hsl\([0-9%,\. ]*\)$/i) || value.match(/^hsla\([0-9%,\. ]*\)$/i) || value.match(/^#[0-9a-f]{3,6}$/i) || value.match(/^[a-z]*$/i)) || key === 'text-align' && (value === 'left' || value === 'right' || value === 'center' || value === 'justify') || key === 'float' && (value === 'left' || value === 'right' || value === 'none') || (key === 'width' || key === 'height') && value.match(/[0-9\.]*(px|em|rem|%)/) || // Reference #520
	        key === 'direction' && value.match(/^ltr|rtl|initial|inherit$/)) result += key + ': ' + value + ';';
	      }
	    });
	    return result;
	  }
	
	  // this function is used to manually allow specific attributes on specific tags with certain prerequisites
	  function validCustomTag(tag, attrs, lkey, value) {
	    // catch the div placeholder for the iframe replacement
	    if (tag === 'img' && attrs['ta-insert-video']) {
	      if (lkey === 'ta-insert-video' || lkey === 'allowfullscreen' || lkey === 'frameborder' || lkey === 'contenteditable' && value === 'false') return true;
	    }
	    return false;
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.jain('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs, unary) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriter(buf, uriValidator) {
	    var ignore = false;
	    var out = angular.bind(buf, buf.push);
	    return {
	      start: function start(tag, attrs, unary) {
	        tag = angular.lowercase(tag);
	        if (!ignore && specialElements[tag]) {
	          ignore = tag;
	        }
	        if (!ignore && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          angular.forEach(attrs, function (value, key) {
	            var lkey = angular.lowercase(key);
	            var isImage = tag === 'img' && lkey === 'src' || lkey === 'background';
	            if (lkey === 'style' && (value = validStyles(value)) !== '' || validCustomTag(tag, attrs, lkey, value) || validAttrs[lkey] === true && (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out(unary ? '/>' : '>');
	        }
	      },
	      end: function end(tag) {
	        tag = angular.lowercase(tag);
	        if (!ignore && validElements[tag] === true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        if (tag == ignore) {
	          ignore = false;
	        }
	      },
	      chars: function chars(_chars) {
	        if (!ignore) {
	          out(encodeEntities(_chars));
	        }
	      }
	    };
	  }
	
	  // define ngSanitize module and register $sanitize service
	  angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	  /* global sanitizeText: false */
	
	  /**
	   * @ngdoc filter
	   * @name linky
	   * @kind function
	   *
	   * @description
	   * Finds links in text input and turns them into html links. Supports http/https/ftp/mailto and
	   * plain email address links.
	   *
	   * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	   *
	   * @param {string} text Input text.
	   * @param {string} target Window (_blank|_self|_parent|_top) or named frame to open links in.
	   * @returns {string} Html-linkified text.
	   *
	   * @usage
	     <span ng-bind-html="linky_expression | linky"></span>
	   *
	   * @example
	     <example module="linkyExample" deps="angular-sanitize.js">
	       <file name="index.html">
	         <script>
	           angular.module('linkyExample', ['ngSanitize'])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.snippet =
	                 'Pretty text with some links:\n'+
	                 'http://angularjs.org/,\n'+
	                 'mailto:us@somewhere.org,\n'+
	                 'another@somewhere.org,\n'+
	                 'and one more: ftp://127.0.0.1/.';
	               $scope.snippetWithTarget = 'http://angularjs.org/';
	             }]);
	         </script>
	         <div ng-controller="ExampleController">
	         Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	         <table>
	           <tr>
	             <td>Filter</td>
	             <td>Source</td>
	             <td>Rendered</td>
	           </tr>
	           <tr id="linky-filter">
	             <td>linky filter</td>
	             <td>
	               <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	             </td>
	             <td>
	               <div ng-bind-html="snippet | linky"></div>
	             </td>
	           </tr>
	           <tr id="linky-target">
	            <td>linky target</td>
	            <td>
	              <pre>&lt;div ng-bind-html="snippetWithTarget | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	            </td>
	            <td>
	              <div ng-bind-html="snippetWithTarget | linky:'_blank'"></div>
	            </td>
	           </tr>
	           <tr id="escaped-html">
	             <td>no filter</td>
	             <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	             <td><div ng-bind="snippet"></div></td>
	           </tr>
	         </table>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should linkify the snippet with urls', function() {
	           expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	               toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                    'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	           expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	         });
	  
	         it('should not linkify snippet without the linky filter', function() {
	           expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	               toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                    'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	           expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	         });
	  
	         it('should update', function() {
	           element(by.model('snippet')).clear();
	           element(by.model('snippet')).sendKeys('new http://link.');
	           expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	               toBe('new http://link.');
	           expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	           expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	               .toBe('new http://link.');
	         });
	  
	         it('should work with the target property', function() {
	          expect(element(by.id('linky-target')).
	              element(by.binding("snippetWithTarget | linky:'_blank'")).getText()).
	              toBe('http://angularjs.org/');
	          expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	         });
	       </file>
	     </example>
	   */
	  angular.module('ngSanitize').filter('linky', ['$sanitize', function ($sanitize) {
	    var LINKY_URL_REGEXP = /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"”’]/,
	        MAILTO_REGEXP = /^mailto:/;
	
	    return function (text, target) {
	      if (!text) return text;
	      var match;
	      var raw = text;
	      var html = [];
	      var url;
	      var i;
	      while (match = raw.match(LINKY_URL_REGEXP)) {
	        // We can not end in these as they are sometimes found at the end of the sentence
	        url = match[0];
	        // if we did not match ftp/http/www/mailto then assume mailto
	        if (!match[2] && !match[4]) {
	          url = (match[3] ? 'http://' : 'mailto:') + url;
	        }
	        i = match.index;
	        addText(raw.substr(0, i));
	        addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	        raw = raw.substring(i + match[0].length);
	      }
	      addText(raw);
	      return $sanitize(html.join(''));
	
	      function addText(text) {
	        if (!text) {
	          return;
	        }
	        html.push(sanitizeText(text));
	      }
	
	      function addLink(url, text) {
	        html.push('<a ');
	        if (angular.isDefined(target)) {
	          html.push('target="', target, '" ');
	        }
	        html.push('href="', url.replace(/"/g, '&quot;'), '">');
	        addText(text);
	        html.push('</a>');
	      }
	    };
	  }]);
	})(window, window.angular);

/***/ },
/* 340 */
/***/ function(module, exports) {

	'use strict';/*
	@license textAngular
	Author : Austin Anderson
	License : 2013 MIT
	Version 1.4.3
	
	See README.md or https://github.com/fraywing/textAngular/wiki for requirements and use.
	*/(function(){// encapsulate all variables so they don't become global vars
	"use strict";// IE version detection - http://stackoverflow.com/questions/4169160/javascript-ie-detection-why-not-use-simple-conditional-comments
	// We need this as IE sometimes plays funny tricks with the contenteditable.
	// ----------------------------------------------------------
	// If you're not in IE (or IE version is less than 5) then:
	// ie === undefined
	// If you're in IE (>=5) then you can determine which version:
	// ie === 7; // IE7
	// Thus, to detect IE:
	// if (ie) {}
	// And to detect the version:
	// ie === 6 // IE6
	// ie > 7 // IE8, IE9, IE10 ...
	// ie < 9 // Anything less than IE9
	// ----------------------------------------------------------
	/* istanbul ignore next: untestable browser check */var _browserDetect={ie:function(){var undef,v=3,div=document.createElement('div'),all=div.getElementsByTagName('i');while(div.innerHTML='<!--[if gt IE '+ ++v+']><i></i><![endif]-->',all[0]){}return v>4?v:undef;}(),webkit:/AppleWebKit\/([\d.]+)/i.test(navigator.userAgent)};// fix a webkit bug, see: https://gist.github.com/shimondoodkin/1081133
	// this is set true when a blur occurs as the blur of the ta-bind triggers before the click
	var globalContentEditableBlur=false;/* istanbul ignore next: Browser Un-Focus fix for webkit */if(_browserDetect.webkit){document.addEventListener("mousedown",function(_event){var e=_event||window.event;var curelement=e.target;if(globalContentEditableBlur&&curelement!==null){var isEditable=false;var tempEl=curelement;while(tempEl!==null&&tempEl.tagName.toLowerCase()!=='html'&&!isEditable){isEditable=tempEl.contentEditable==='true';tempEl=tempEl.parentNode;}if(!isEditable){document.getElementById('textAngular-editableFix-010203040506070809').setSelectionRange(0,0);// set caret focus to an element that handles caret focus correctly.
	curelement.focus();// focus the wanted element.
	if(curelement.select){curelement.select();// use select to place cursor for input elements.
	}}}globalContentEditableBlur=false;},false);// add global click handler
	angular.element(document).ready(function(){angular.element(document.body).append(angular.element('<input id="textAngular-editableFix-010203040506070809" class="ta-hidden-input" aria-hidden="true" unselectable="on" tabIndex="-1">'));});}// Gloabl to textAngular REGEXP vars for block and list elements.
	var BLOCKELEMENTS=/^(address|article|aside|audio|blockquote|canvas|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video)$/i;var LISTELEMENTS=/^(ul|li|ol)$/i;var VALIDELEMENTS=/^(address|article|aside|audio|blockquote|canvas|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video|li)$/i;// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Compatibility
	/* istanbul ignore next: trim shim for older browsers */if(!String.prototype.trim){String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,'');};}// tests against the current jqLite/jquery implementation if this can be an element
	function validElementString(string){try{return angular.element(string).length!==0;}catch(any){return false;}}/*
		Custom stylesheet for the placeholders rules.
		Credit to: http://davidwalsh.name/add-rules-stylesheets
	*/var sheet,addCSSRule,removeCSSRule,_addCSSRule,_removeCSSRule,_getRuleIndex;/* istanbul ignore else: IE <8 test*/if(_browserDetect.ie>8||_browserDetect.ie===undefined){var _sheets=document.styleSheets;/* istanbul ignore next: preference for stylesheet loaded externally */for(var i=0;i<_sheets.length;i++){if(_sheets[i].media.length===0||_sheets[i].media.mediaText.match(/(all|screen)/ig)){if(_sheets[i].href){if(_sheets[i].href.match(/textangular\.(min\.|)css/ig)){sheet=_sheets[i];break;}}}}/* istanbul ignore next: preference for stylesheet loaded externally */if(!sheet){// this sheet is used for the placeholders later on.
	sheet=function(){// Create the <style> tag
	var style=document.createElement("style");/* istanbul ignore else : WebKit hack :( */if(_browserDetect.webkit)style.appendChild(document.createTextNode(""));// Add the <style> element to the page, add as first so the styles can be overridden by custom stylesheets
	document.getElementsByTagName('head')[0].appendChild(style);return style.sheet;}();}// use as: addCSSRule("header", "float: left");
	addCSSRule=function addCSSRule(selector,rules){return _addCSSRule(sheet,selector,rules);};_addCSSRule=function _addCSSRule(_sheet,selector,rules){var insertIndex;var insertedRule;// This order is important as IE 11 has both cssRules and rules but they have different lengths - cssRules is correct, rules gives an error in IE 11
	/* istanbul ignore next: browser catches */if(_sheet.cssRules)insertIndex=Math.max(_sheet.cssRules.length-1,0);else if(_sheet.rules)insertIndex=Math.max(_sheet.rules.length-1,0);/* istanbul ignore else: untestable IE option */if(_sheet.insertRule){_sheet.insertRule(selector+"{"+rules+"}",insertIndex);}else{_sheet.addRule(selector,rules,insertIndex);}/* istanbul ignore next: browser catches */if(sheet.rules)insertedRule=sheet.rules[insertIndex];else if(sheet.cssRules)insertedRule=sheet.cssRules[insertIndex];// return the inserted stylesheet rule
	return insertedRule;};_getRuleIndex=function _getRuleIndex(rule,rules){var i,ruleIndex;for(i=0;i<rules.length;i++){/* istanbul ignore else: check for correct rule */if(rules[i].cssText===rule.cssText){ruleIndex=i;break;}}return ruleIndex;};removeCSSRule=function removeCSSRule(rule){_removeCSSRule(sheet,rule);};/* istanbul ignore next: tests are browser specific */_removeCSSRule=function _removeCSSRule(sheet,rule){var rules=sheet.cssRules||sheet.rules;if(!rules||rules.length===0)return;var ruleIndex=_getRuleIndex(rule,rules);if(sheet.removeRule){sheet.removeRule(ruleIndex);}else{sheet.deleteRule(ruleIndex);}};}angular.module('textAngular.factories',[]).factory('taBrowserTag',[function(){return function(tag){/* istanbul ignore next: ie specific test */if(!tag)return _browserDetect.ie<=8?'P':'p';else if(tag==='')return _browserDetect.ie===undefined?'div':_browserDetect.ie<=8?'P':'p';else return _browserDetect.ie<=8?tag.toUpperCase():tag;};}]).factory('taApplyCustomRenderers',['taCustomRenderers','taDOM',function(taCustomRenderers,taDOM){return function(val){var element=angular.element('<div></div>');element[0].innerHTML=val;angular.forEach(taCustomRenderers,function(renderer){var elements=[];// get elements based on what is defined. If both defined do secondary filter in the forEach after using selector string
	if(renderer.selector&&renderer.selector!=='')elements=element.find(renderer.selector);/* istanbul ignore else: shouldn't fire, if it does we're ignoring everything */else if(renderer.customAttribute&&renderer.customAttribute!=='')elements=taDOM.getByAttribute(element,renderer.customAttribute);// process elements if any found
	angular.forEach(elements,function(_element){_element=angular.element(_element);if(renderer.selector&&renderer.selector!==''&&renderer.customAttribute&&renderer.customAttribute!==''){if(_element.attr(renderer.customAttribute)!==undefined)renderer.renderLogic(_element);}else renderer.renderLogic(_element);});});return element[0].innerHTML;};}]).factory('taFixChrome',function(){// get whaterever rubbish is inserted in chrome
	// should be passed an html string, returns an html string
	var taFixChrome=function taFixChrome(html){if(!html||!angular.isString(html)||html.length<=0)return html;// grab all elements with a style attibute
	var spanMatch=/<([^>\/]+?)style=("([^"]+)"|'([^']+)')([^>]*)>/ig;var match,styleVal,newTag,finalHtml='',lastIndex=0;while(match=spanMatch.exec(html)){// one of the quoted values ' or "
	/* istanbul ignore next: quotations match */styleVal=match[3]||match[4];// test for chrome inserted junk
	if(styleVal&&styleVal.match(/line-height: 1.[0-9]{3,12};|color: inherit; line-height: 1.1;/i)){// replace original tag with new tag
	styleVal=styleVal.replace(/( |)font-family: inherit;|( |)line-height: 1.[0-9]{3,12};|( |)color: inherit;/ig,'');newTag='<'+match[1].trim();if(styleVal.trim().length>0)newTag+=' style='+match[2].substring(0,1)+styleVal+match[2].substring(0,1);newTag+=match[5].trim()+">";finalHtml+=html.substring(lastIndex,match.index)+newTag;lastIndex=match.index+match[0].length;}}finalHtml+=html.substring(lastIndex);// only replace when something has changed, else we get focus problems on inserting lists
	if(lastIndex>0){// replace all empty strings
	return finalHtml.replace(/<span\s?>(.*?)<\/span>(<br(\/|)>|)/ig,'$1');}else return html;};return taFixChrome;}).factory('taSanitize',['$sanitize',function taSanitizeFactory($sanitize){var convert_infos=[{property:'font-weight',values:['bold'],tag:'b'},{property:'font-style',values:['italic'],tag:'i'}];var styleMatch=[];for(var i=0;i<convert_infos.length;i++){var _partialStyle='('+convert_infos[i].property+':\\s*(';for(var j=0;j<convert_infos[i].values.length;j++){/* istanbul ignore next: not needed to be tested yet */if(j>0)_partialStyle+='|';_partialStyle+=convert_infos[i].values[j];}_partialStyle+=');)';styleMatch.push(_partialStyle);}var styleRegexString='('+styleMatch.join('|')+')';function wrapNested(html,wrapTag){var depth=0;var lastIndex=0;var match;var tagRegex=/<[^>]*>/ig;while(match=tagRegex.exec(html)){lastIndex=match.index;if(match[0].substr(1,1)==='/'){if(depth===0)break;else depth--;}else depth++;}return wrapTag+html.substring(0,lastIndex)+// get the start tags reversed - this is safe as we construct the strings with no content except the tags
	angular.element(wrapTag)[0].outerHTML.substring(wrapTag.length)+html.substring(lastIndex);}function transformLegacyStyles(html){if(!html||!angular.isString(html)||html.length<=0)return html;var i;var styleElementMatch=/<([^>\/]+?)style=("([^"]+)"|'([^']+)')([^>]*)>/ig;var match,subMatch,styleVal,newTag,lastNewTag='',newHtml,finalHtml='',lastIndex=0;while(match=styleElementMatch.exec(html)){// one of the quoted values ' or "
	/* istanbul ignore next: quotations match */styleVal=match[3]||match[4];var styleRegex=new RegExp(styleRegexString,'i');// test for style values to change
	if(angular.isString(styleVal)&&styleRegex.test(styleVal)){// remove build tag list
	newTag='';// init regex here for exec
	var styleRegexExec=new RegExp(styleRegexString,'ig');// find relevand tags and build a string of them
	while(subMatch=styleRegexExec.exec(styleVal)){for(i=0;i<convert_infos.length;i++){if(!!subMatch[i*2+2]){newTag+='<'+convert_infos[i].tag+'>';}}}// recursively find more legacy styles in html before this tag and after the previous match (if any)
	newHtml=transformLegacyStyles(html.substring(lastIndex,match.index));// build up html
	if(lastNewTag.length>0){finalHtml+=wrapNested(newHtml,lastNewTag);}else finalHtml+=newHtml;// grab the style val without the transformed values
	styleVal=styleVal.replace(new RegExp(styleRegexString,'ig'),'');// build the html tag
	finalHtml+='<'+match[1].trim();if(styleVal.length>0)finalHtml+=' style="'+styleVal+'"';finalHtml+=match[5]+'>';// update the start index to after this tag
	lastIndex=match.index+match[0].length;lastNewTag=newTag;}}if(lastNewTag.length>0){finalHtml+=wrapNested(html.substring(lastIndex),lastNewTag);}else finalHtml+=html.substring(lastIndex);return finalHtml;}function transformLegacyAttributes(html){if(!html||!angular.isString(html)||html.length<=0)return html;// replace all align='...' tags with text-align attributes
	var attrElementMatch=/<([^>\/]+?)align=("([^"]+)"|'([^']+)')([^>]*)>/ig;var match,finalHtml='',lastIndex=0;// match all attr tags
	while(match=attrElementMatch.exec(html)){// add all html before this tag
	finalHtml+=html.substring(lastIndex,match.index);// record last index after this tag
	lastIndex=match.index+match[0].length;// construct tag without the align attribute
	var newTag='<'+match[1]+match[5];// add the style attribute
	if(/style=("([^"]+)"|'([^']+)')/ig.test(newTag)){/* istanbul ignore next: quotations match */newTag=newTag.replace(/style=("([^"]+)"|'([^']+)')/i,'style="$2$3 text-align:'+(match[3]||match[4])+';"');}else{/* istanbul ignore next: quotations match */newTag+=' style="text-align:'+(match[3]||match[4])+';"';}newTag+='>';// add to html
	finalHtml+=newTag;}// return with remaining html
	return finalHtml+html.substring(lastIndex);}return function taSanitize(unsafe,oldsafe,ignore){// unsafe html should NEVER built into a DOM object via angular.element. This allows XSS to be inserted and run.
	if(!ignore){try{unsafe=transformLegacyStyles(unsafe);}catch(e){}}// unsafe and oldsafe should be valid HTML strings
	// any exceptions (lets say, color for example) should be made here but with great care
	// setup unsafe element for modification
	unsafe=transformLegacyAttributes(unsafe);var safe;try{safe=$sanitize(unsafe);// do this afterwards, then the $sanitizer should still throw for bad markup
	if(ignore)safe=unsafe;}catch(e){safe=oldsafe||'';}// Do processing for <pre> tags, removing tabs and return carriages outside of them
	var _preTags=safe.match(/(<pre[^>]*>.*?<\/pre[^>]*>)/ig);var processedSafe=safe.replace(/(&#(9|10);)*/ig,'');var re=/<pre[^>]*>.*?<\/pre[^>]*>/ig;var index=0;var lastIndex=0;var origTag;safe='';while((origTag=re.exec(processedSafe))!==null&&index<_preTags.length){safe+=processedSafe.substring(lastIndex,origTag.index)+_preTags[index];lastIndex=origTag.index+origTag[0].length;index++;}return safe+processedSafe.substring(lastIndex);};}]).factory('taToolExecuteAction',['$q','$log',function($q,$log){// this must be called on a toolScope or instance
	return function(editor){if(editor!==undefined)this.$editor=function(){return editor;};var deferred=$q.defer(),promise=deferred.promise,_editor=this.$editor();// pass into the action the deferred function and also the function to reload the current selection if rangy available
	var result;try{result=this.action(deferred,_editor.startAction());// We set the .finally callback here to make sure it doesn't get executed before any other .then callback.
	promise['finally'](function(){_editor.endAction.call(_editor);});}catch(exc){$log.error(exc);}if(result||result===undefined){// if true or undefined is returned then the action has finished. Otherwise the deferred action will be resolved manually.
	deferred.resolve();}};}]);angular.module('textAngular.DOM',['textAngular.factories']).factory('taExecCommand',['taSelection','taBrowserTag','$document',function(taSelection,taBrowserTag,$document){var listToDefault=function listToDefault(listElement,defaultWrap){var $target,i;// if all selected then we should remove the list
	// grab all li elements and convert to taDefaultWrap tags
	var children=listElement.find('li');for(i=children.length-1;i>=0;i--){$target=angular.element('<'+defaultWrap+'>'+children[i].innerHTML+'</'+defaultWrap+'>');listElement.after($target);}listElement.remove();taSelection.setSelectionToElementEnd($target[0]);};var selectLi=function selectLi(liElement){if(/(<br(|\/)>)$/i.test(liElement.innerHTML.trim()))taSelection.setSelectionBeforeElement(angular.element(liElement).find("br")[0]);else taSelection.setSelectionToElementEnd(liElement);};var listToList=function listToList(listElement,newListTag){var $target=angular.element('<'+newListTag+'>'+listElement[0].innerHTML+'</'+newListTag+'>');listElement.after($target);listElement.remove();selectLi($target.find('li')[0]);};var childElementsToList=function childElementsToList(elements,listElement,newListTag){var html='';for(var i=0;i<elements.length;i++){html+='<'+taBrowserTag('li')+'>'+elements[i].innerHTML+'</'+taBrowserTag('li')+'>';}var $target=angular.element('<'+newListTag+'>'+html+'</'+newListTag+'>');listElement.after($target);listElement.remove();selectLi($target.find('li')[0]);};return function(taDefaultWrap,topNode){taDefaultWrap=taBrowserTag(taDefaultWrap);return function(command,showUI,options,defaultTagAttributes){var i,$target,html,_nodes,next,optionsTagName,selectedElement;var defaultWrapper=angular.element('<'+taDefaultWrap+'>');try{selectedElement=taSelection.getSelectionElement();}catch(e){}var $selected=angular.element(selectedElement);if(selectedElement!==undefined){var tagName=selectedElement.tagName.toLowerCase();if(command.toLowerCase()==='insertorderedlist'||command.toLowerCase()==='insertunorderedlist'){var selfTag=taBrowserTag(command.toLowerCase()==='insertorderedlist'?'ol':'ul');if(tagName===selfTag){// if all selected then we should remove the list
	// grab all li elements and convert to taDefaultWrap tags
	return listToDefault($selected,taDefaultWrap);}else if(tagName==='li'&&$selected.parent()[0].tagName.toLowerCase()===selfTag&&$selected.parent().children().length===1){// catch for the previous statement if only one li exists
	return listToDefault($selected.parent(),taDefaultWrap);}else if(tagName==='li'&&$selected.parent()[0].tagName.toLowerCase()!==selfTag&&$selected.parent().children().length===1){// catch for the previous statement if only one li exists
	return listToList($selected.parent(),selfTag);}else if(tagName.match(BLOCKELEMENTS)&&!$selected.hasClass('ta-bind')){// if it's one of those block elements we have to change the contents
	// if it's a ol/ul we are changing from one to the other
	if(tagName==='ol'||tagName==='ul'){return listToList($selected,selfTag);}else{var childBlockElements=false;angular.forEach($selected.children(),function(elem){if(elem.tagName.match(BLOCKELEMENTS)){childBlockElements=true;}});if(childBlockElements){return childElementsToList($selected.children(),$selected,selfTag);}else{return childElementsToList([angular.element('<div>'+selectedElement.innerHTML+'</div>')[0]],$selected,selfTag);}}}else if(tagName.match(BLOCKELEMENTS)){// if we get here then all the contents of the ta-bind are selected
	_nodes=taSelection.getOnlySelectedElements();if(_nodes.length===0){// here is if there is only text in ta-bind ie <div ta-bind>test content</div>
	$target=angular.element('<'+selfTag+'><li>'+selectedElement.innerHTML+'</li></'+selfTag+'>');$selected.html('');$selected.append($target);}else if(_nodes.length===1&&(_nodes[0].tagName.toLowerCase()==='ol'||_nodes[0].tagName.toLowerCase()==='ul')){if(_nodes[0].tagName.toLowerCase()===selfTag){// remove
	return listToDefault(angular.element(_nodes[0]),taDefaultWrap);}else{return listToList(angular.element(_nodes[0]),selfTag);}}else{html='';var $nodes=[];for(i=0;i<_nodes.length;i++){/* istanbul ignore else: catch for real-world can't make it occur in testing */if(_nodes[i].nodeType!==3){var $n=angular.element(_nodes[i]);/* istanbul ignore if: browser check only, phantomjs doesn't return children nodes but chrome at least does */if(_nodes[i].tagName.toLowerCase()==='li')continue;else if(_nodes[i].tagName.toLowerCase()==='ol'||_nodes[i].tagName.toLowerCase()==='ul'){html+=$n[0].innerHTML;// if it's a list, add all it's children
	}else if(_nodes[i].tagName.toLowerCase()==='span'&&(_nodes[i].childNodes[0].tagName.toLowerCase()==='ol'||_nodes[i].childNodes[0].tagName.toLowerCase()==='ul')){html+=$n[0].childNodes[0].innerHTML;// if it's a list, add all it's children
	}else{html+='<'+taBrowserTag('li')+'>'+$n[0].innerHTML+'</'+taBrowserTag('li')+'>';}$nodes.unshift($n);}}$target=angular.element('<'+selfTag+'>'+html+'</'+selfTag+'>');$nodes.pop().replaceWith($target);angular.forEach($nodes,function($node){$node.remove();});}taSelection.setSelectionToElementEnd($target[0]);return;}}else if(command.toLowerCase()==='formatblock'){optionsTagName=options.toLowerCase().replace(/[<>]/ig,'');if(optionsTagName.trim()==='default'){optionsTagName=taDefaultWrap;options='<'+taDefaultWrap+'>';}if(tagName==='li')$target=$selected.parent();else $target=$selected;// find the first blockElement
	while(!$target[0].tagName||!$target[0].tagName.match(BLOCKELEMENTS)&&!$target.parent().attr('contenteditable')){$target=$target.parent();/* istanbul ignore next */tagName=($target[0].tagName||'').toLowerCase();}if(tagName===optionsTagName){// $target is wrap element
	_nodes=$target.children();var hasBlock=false;for(i=0;i<_nodes.length;i++){hasBlock=hasBlock||_nodes[i].tagName.match(BLOCKELEMENTS);}if(hasBlock){$target.after(_nodes);next=$target.next();$target.remove();$target=next;}else{defaultWrapper.append($target[0].childNodes);$target.after(defaultWrapper);$target.remove();$target=defaultWrapper;}}else if($target.parent()[0].tagName.toLowerCase()===optionsTagName&&!$target.parent().hasClass('ta-bind')){//unwrap logic for parent
	var blockElement=$target.parent();var contents=blockElement.contents();for(i=0;i<contents.length;i++){/* istanbul ignore next: can't test - some wierd thing with how phantomjs works */if(blockElement.parent().hasClass('ta-bind')&&contents[i].nodeType===3){defaultWrapper=angular.element('<'+taDefaultWrap+'>');defaultWrapper[0].innerHTML=contents[i].outerHTML;contents[i]=defaultWrapper[0];}blockElement.parent()[0].insertBefore(contents[i],blockElement[0]);}blockElement.remove();}else if(tagName.match(LISTELEMENTS)){// wrapping a list element
	$target.wrap(options);}else{// default wrap behaviour
	_nodes=taSelection.getOnlySelectedElements();if(_nodes.length===0)_nodes=[$target[0]];// find the parent block element if any of the nodes are inline or text
	for(i=0;i<_nodes.length;i++){if(_nodes[i].nodeType===3||!_nodes[i].tagName.match(BLOCKELEMENTS)){while(_nodes[i].nodeType===3||!_nodes[i].tagName||!_nodes[i].tagName.match(BLOCKELEMENTS)){_nodes[i]=_nodes[i].parentNode;}}}if(angular.element(_nodes[0]).hasClass('ta-bind')){$target=angular.element(options);$target[0].innerHTML=_nodes[0].innerHTML;_nodes[0].innerHTML=$target[0].outerHTML;}else if(optionsTagName==='blockquote'){// blockquotes wrap other block elements
	html='';for(i=0;i<_nodes.length;i++){html+=_nodes[i].outerHTML;}$target=angular.element(options);$target[0].innerHTML=html;_nodes[0].parentNode.insertBefore($target[0],_nodes[0]);for(i=_nodes.length-1;i>=0;i--){/* istanbul ignore else:  */if(_nodes[i].parentNode)_nodes[i].parentNode.removeChild(_nodes[i]);}}else{// regular block elements replace other block elements
	for(i=0;i<_nodes.length;i++){$target=angular.element(options);$target[0].innerHTML=_nodes[i].innerHTML;_nodes[i].parentNode.insertBefore($target[0],_nodes[i]);_nodes[i].parentNode.removeChild(_nodes[i]);}}}taSelection.setSelectionToElementEnd($target[0]);return;}else if(command.toLowerCase()==='createlink'){var tagBegin='<a href="'+options+'" target="'+(defaultTagAttributes.a.target?defaultTagAttributes.a.target:'')+'">',tagEnd='</a>',_selection=taSelection.getSelection();if(_selection.collapsed){// insert text at selection, then select then just let normal exec-command run
	taSelection.insertHtml(tagBegin+options+tagEnd,topNode);}else if(rangy.getSelection().getRangeAt(0).canSurroundContents()){var node=angular.element(tagBegin+tagEnd)[0];rangy.getSelection().getRangeAt(0).surroundContents(node);}return;}else if(command.toLowerCase()==='inserthtml'){taSelection.insertHtml(options,topNode);return;}}try{$document[0].execCommand(command,showUI,options);}catch(e){}};};}]).service('taSelection',['$window','$document','taDOM',/* istanbul ignore next: all browser specifics and PhantomJS dosen't seem to support half of it */function($window,$document,taDOM){// need to dereference the document else the calls don't work correctly
	var _document=$document[0];var rangy=$window.rangy;var brException=function brException(element,offset){/* check if selection is a BR element at the beginning of a container. If so, get
			* the parentNode instead.
			* offset should be zero in this case. Otherwise, return the original
			* element.
			*/if(element.tagName&&element.tagName.match(/^br$/i)&&offset===0&&!element.previousSibling){return{element:element.parentNode,offset:0};}else{return{element:element,offset:offset};}};var api={getSelection:function getSelection(){var range=rangy.getSelection().getRangeAt(0);var container=range.commonAncestorContainer;var selection={start:brException(range.startContainer,range.startOffset),end:brException(range.endContainer,range.endOffset),collapsed:range.collapsed};// Check if the container is a text node and return its parent if so
	container=container.nodeType===3?container.parentNode:container;if(container.parentNode===selection.start.element||container.parentNode===selection.end.element){selection.container=container.parentNode;}else{selection.container=container;}return selection;},getOnlySelectedElements:function getOnlySelectedElements(){var range=rangy.getSelection().getRangeAt(0);var container=range.commonAncestorContainer;// Check if the container is a text node and return its parent if so
	container=container.nodeType===3?container.parentNode:container;return range.getNodes([1],function(node){return node.parentNode===container;});},// Some basic selection functions
	getSelectionElement:function getSelectionElement(){return api.getSelection().container;},setSelection:function setSelection(el,start,end){var range=rangy.createRange();range.setStart(el,start);range.setEnd(el,end);rangy.getSelection().setSingleRange(range);},setSelectionBeforeElement:function setSelectionBeforeElement(el){var range=rangy.createRange();range.selectNode(el);range.collapse(true);rangy.getSelection().setSingleRange(range);},setSelectionAfterElement:function setSelectionAfterElement(el){var range=rangy.createRange();range.selectNode(el);range.collapse(false);rangy.getSelection().setSingleRange(range);},setSelectionToElementStart:function setSelectionToElementStart(el){var range=rangy.createRange();range.selectNodeContents(el);range.collapse(true);rangy.getSelection().setSingleRange(range);},setSelectionToElementEnd:function setSelectionToElementEnd(el){var range=rangy.createRange();range.selectNodeContents(el);range.collapse(false);if(el.childNodes&&el.childNodes[el.childNodes.length-1]&&el.childNodes[el.childNodes.length-1].nodeName==='br'){range.startOffset=range.endOffset=range.startOffset-1;}rangy.getSelection().setSingleRange(range);},// from http://stackoverflow.com/questions/6690752/insert-html-at-caret-in-a-contenteditable-div
	// topNode is the contenteditable normally, all manipulation MUST be inside this.
	insertHtml:function insertHtml(html,topNode){var parent,secondParent,_childI,nodes,i,lastNode,_tempFrag;var element=angular.element("<div>"+html+"</div>");var range=rangy.getSelection().getRangeAt(0);var frag=_document.createDocumentFragment();var children=element[0].childNodes;var isInline=true;if(children.length>0){// NOTE!! We need to do the following:
	// check for blockelements - if they exist then we have to split the current element in half (and all others up to the closest block element) and insert all children in-between.
	// If there are no block elements, or there is a mixture we need to create textNodes for the non wrapped text (we don't want them spans messing up the picture).
	nodes=[];for(_childI=0;_childI<children.length;_childI++){if(!(children[_childI].nodeName.toLowerCase()==='p'&&children[_childI].innerHTML.trim()===''||// empty p element
	children[_childI].nodeType===3&&children[_childI].nodeValue.trim()===''// empty text node
	)){isInline=isInline&&!BLOCKELEMENTS.test(children[_childI].nodeName);nodes.push(children[_childI]);}}for(var _n=0;_n<nodes.length;_n++){lastNode=frag.appendChild(nodes[_n]);}if(!isInline&&range.collapsed&&/^(|<br(|\/)>)$/i.test(range.startContainer.innerHTML))range.selectNode(range.startContainer);}else{isInline=true;// paste text of some sort
	lastNode=frag=_document.createTextNode(html);}// Other Edge case - selected data spans multiple blocks.
	if(isInline){range.deleteContents();}else{// not inline insert
	if(range.collapsed&&range.startContainer!==topNode){if(range.startContainer.innerHTML&&range.startContainer.innerHTML.match(/^<[^>]*>$/i)){// this log is to catch when innerHTML is something like `<img ...>`
	parent=range.startContainer;if(range.startOffset===1){// before single tag
	range.setStartAfter(parent);range.setEndAfter(parent);}else{// after single tag
	range.setStartBefore(parent);range.setEndBefore(parent);}}else{// split element into 2 and insert block element in middle
	if(range.startContainer.nodeType===3&&range.startContainer.parentNode!==topNode){// if text node
	parent=range.startContainer.parentNode;secondParent=parent.cloneNode();// split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
	taDOM.splitNodes(parent.childNodes,parent,secondParent,range.startContainer,range.startOffset);// Escape out of the inline tags like b
	while(!VALIDELEMENTS.test(parent.nodeName)){angular.element(parent).after(secondParent);parent=parent.parentNode;var _lastSecondParent=secondParent;secondParent=parent.cloneNode();// split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
	taDOM.splitNodes(parent.childNodes,parent,secondParent,_lastSecondParent);}}else{parent=range.startContainer;secondParent=parent.cloneNode();taDOM.splitNodes(parent.childNodes,parent,secondParent,undefined,undefined,range.startOffset);}angular.element(parent).after(secondParent);// put cursor to end of inserted content
	range.setStartAfter(parent);range.setEndAfter(parent);if(/^(|<br(|\/)>)$/i.test(parent.innerHTML.trim())){range.setStartBefore(parent);range.setEndBefore(parent);angular.element(parent).remove();}if(/^(|<br(|\/)>)$/i.test(secondParent.innerHTML.trim()))angular.element(secondParent).remove();if(parent.nodeName.toLowerCase()==='li'){_tempFrag=_document.createDocumentFragment();for(i=0;i<frag.childNodes.length;i++){element=angular.element('<li>');taDOM.transferChildNodes(frag.childNodes[i],element[0]);taDOM.transferNodeAttributes(frag.childNodes[i],element[0]);_tempFrag.appendChild(element[0]);}frag=_tempFrag;if(lastNode){lastNode=frag.childNodes[frag.childNodes.length-1];lastNode=lastNode.childNodes[lastNode.childNodes.length-1];}}}}else{range.deleteContents();}}range.insertNode(frag);if(lastNode){api.setSelectionToElementEnd(lastNode);}}};return api;}]).service('taDOM',function(){var taDOM={// recursive function that returns an array of angular.elements that have the passed attribute set on them
	getByAttribute:function getByAttribute(element,attribute){var resultingElements=[];var childNodes=element.children();if(childNodes.length){angular.forEach(childNodes,function(child){resultingElements=resultingElements.concat(taDOM.getByAttribute(angular.element(child),attribute));});}if(element.attr(attribute)!==undefined)resultingElements.push(element);return resultingElements;},transferChildNodes:function transferChildNodes(source,target){// clear out target
	target.innerHTML='';while(source.childNodes.length>0){target.appendChild(source.childNodes[0]);}return target;},splitNodes:function splitNodes(nodes,target1,target2,splitNode,subSplitIndex,splitIndex){if(!splitNode&&isNaN(splitIndex))throw new Error('taDOM.splitNodes requires a splitNode or splitIndex');var startNodes=document.createDocumentFragment();var endNodes=document.createDocumentFragment();var index=0;while(nodes.length>0&&(isNaN(splitIndex)||splitIndex!==index)&&nodes[0]!==splitNode){startNodes.appendChild(nodes[0]);// this removes from the nodes array (if proper childNodes object.
	index++;}if(!isNaN(subSplitIndex)&&subSplitIndex>=0&&nodes[0]){startNodes.appendChild(document.createTextNode(nodes[0].nodeValue.substring(0,subSplitIndex)));nodes[0].nodeValue=nodes[0].nodeValue.substring(subSplitIndex);}while(nodes.length>0){endNodes.appendChild(nodes[0]);}taDOM.transferChildNodes(startNodes,target1);taDOM.transferChildNodes(endNodes,target2);},transferNodeAttributes:function transferNodeAttributes(source,target){for(var i=0;i<source.attributes.length;i++){target.setAttribute(source.attributes[i].name,source.attributes[i].value);}return target;}};return taDOM;});angular.module('textAngular.validators',[]).directive('taMaxText',function(){return{restrict:'A',require:'ngModel',link:function link(scope,elem,attrs,ctrl){var max=parseInt(scope.$eval(attrs.taMaxText));if(isNaN(max)){throw'Max text must be an integer';}attrs.$observe('taMaxText',function(value){max=parseInt(value);if(isNaN(max)){throw'Max text must be an integer';}if(ctrl.$dirty){ctrl.$validate();}});ctrl.$validators.taMaxText=function(viewValue){var source=angular.element('<div/>');source.html(viewValue);return source.text().length<=max;};}};}).directive('taMinText',function(){return{restrict:'A',require:'ngModel',link:function link(scope,elem,attrs,ctrl){var min=parseInt(scope.$eval(attrs.taMinText));if(isNaN(min)){throw'Min text must be an integer';}attrs.$observe('taMinText',function(value){min=parseInt(value);if(isNaN(min)){throw'Min text must be an integer';}if(ctrl.$dirty){ctrl.$validate();}});ctrl.$validators.taMinText=function(viewValue){var source=angular.element('<div/>');source.html(viewValue);return!source.text().length||source.text().length>=min;};}};});angular.module('textAngular.taBind',['textAngular.factories','textAngular.DOM']).service('_taBlankTest',[function(){var INLINETAGS_NONBLANK=/<(a|abbr|acronym|bdi|bdo|big|cite|code|del|dfn|img|ins|kbd|label|map|mark|q|ruby|rp|rt|s|samp|time|tt|var)[^>]*(>|$)/i;return function(_defaultTest){return function(_blankVal){if(!_blankVal)return true;// find first non-tag match - ie start of string or after tag that is not whitespace
	var _firstMatch=/(^[^<]|>)[^<]/i.exec(_blankVal);var _firstTagIndex;if(!_firstMatch){// find the end of the first tag removing all the
	// Don't do a global replace as that would be waaayy too long, just replace the first 4 occurences should be enough
	_blankVal=_blankVal.toString().replace(/="[^"]*"/i,'').replace(/="[^"]*"/i,'').replace(/="[^"]*"/i,'').replace(/="[^"]*"/i,'');_firstTagIndex=_blankVal.indexOf('>');}else{_firstTagIndex=_firstMatch.index;}_blankVal=_blankVal.trim().substring(_firstTagIndex,_firstTagIndex+100);// check for no tags entry
	if(/^[^<>]+$/i.test(_blankVal))return false;// this regex is to match any number of whitespace only between two tags
	if(_blankVal.length===0||_blankVal===_defaultTest||/^>(\s|&nbsp;)*<\/[^>]+>$/ig.test(_blankVal))return true;// this regex tests if there is a tag followed by some optional whitespace and some text after that
	else if(/>\s*[^\s<]/i.test(_blankVal)||INLINETAGS_NONBLANK.test(_blankVal))return false;else return true;};};}]).directive('taButton',[function(){return{link:function link(scope,element,attrs){element.attr('unselectable','on');element.on('mousedown',function(e,eventData){/* istanbul ignore else: this is for catching the jqLite testing*/if(eventData)angular.extend(e,eventData);// this prevents focusout from firing on the editor when clicking toolbar buttons
	e.preventDefault();return false;});}};}]).directive('taBind',['taSanitize','$timeout','$window','$document','taFixChrome','taBrowserTag','taSelection','taSelectableElements','taApplyCustomRenderers','taOptions','_taBlankTest','$parse','taDOM','textAngularManager',function(taSanitize,$timeout,$window,$document,taFixChrome,taBrowserTag,taSelection,taSelectableElements,taApplyCustomRenderers,taOptions,_taBlankTest,$parse,taDOM,textAngularManager){// Uses for this are textarea or input with ng-model and ta-bind='text'
	// OR any non-form element with contenteditable="contenteditable" ta-bind="html|text" ng-model
	return{priority:2,// So we override validators correctly
	require:['ngModel','?ngModelOptions'],link:function link(scope,element,attrs,controller){var ngModel=controller[0];var ngModelOptions=controller[1]||{};// the option to use taBind on an input or textarea is required as it will sanitize all input into it correctly.
	var _isContentEditable=element.attr('contenteditable')!==undefined&&element.attr('contenteditable');var _isInputFriendly=_isContentEditable||element[0].tagName.toLowerCase()==='textarea'||element[0].tagName.toLowerCase()==='input';var _isReadonly=false;var _focussed=false;var _skipRender=false;var _disableSanitizer=attrs.taUnsafeSanitizer||taOptions.disableSanitizer;var _lastKey;// see http://www.javascripter.net/faq/keycodes.htm for good information
	// NOTE Mute On|Off 173 (Opera MSIE Safari Chrome) 181 (Firefox)
	// BLOCKED_KEYS are special keys...
	// Tab, pause/break, CapsLock, Esc, Page Up, End, Home,
	// Left arrow, Up arrow, Right arrow, Down arrow, Insert, Delete,
	// f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11, f12
	// NumLock, ScrollLock
	var BLOCKED_KEYS=/^(9|19|20|27|33|34|35|36|37|38|39|40|45|112|113|114|115|116|117|118|119|120|121|122|123|144|145)$/i;// UNDO_TRIGGER_KEYS - spaces, enter, delete, backspace, all punctuation
	// Backspace, Enter, Space, Delete, (; :) (Firefox), (= +) (Firefox),
	// Numpad +, Numpad -, (; :), (= +),
	// (, <), (- _), (. >), (/ ?), (` ~), ([ {), (\ |), (] }), (' ")
	// NOTE - Firefox: 173 = (- _) -- adding this to UNDO_TRIGGER_KEYS
	var UNDO_TRIGGER_KEYS=/^(8|13|32|46|59|61|107|109|173|186|187|188|189|190|191|192|219|220|221|222)$/i;var _pasteHandler;// defaults to the paragraph element, but we need the line-break or it doesn't allow you to type into the empty element
	// non IE is '<p><br/></p>', ie is '<p></p>' as for once IE gets it correct...
	var _defaultVal,_defaultTest;var _CTRL_KEY=0x0001;var _META_KEY=0x0002;var _ALT_KEY=0x0004;var _SHIFT_KEY=0x0008;// map events to special keys...
	// mappings is an array of maps from events to specialKeys as declared in textAngularSetup
	var _keyMappings=[//		ctrl/command + z
	{specialKey:'UndoKey',forbiddenModifiers:_ALT_KEY+_SHIFT_KEY,mustHaveModifiers:[_META_KEY+_CTRL_KEY],keyCode:90},//		ctrl/command + shift + z
	{specialKey:'RedoKey',forbiddenModifiers:_ALT_KEY,mustHaveModifiers:[_META_KEY+_CTRL_KEY,_SHIFT_KEY],keyCode:90},//		ctrl/command + y
	{specialKey:'RedoKey',forbiddenModifiers:_ALT_KEY+_SHIFT_KEY,mustHaveModifiers:[_META_KEY+_CTRL_KEY],keyCode:89},//		TabKey
	{specialKey:'TabKey',forbiddenModifiers:_META_KEY+_SHIFT_KEY+_ALT_KEY+_CTRL_KEY,mustHaveModifiers:[],keyCode:9},//		shift + TabKey
	{specialKey:'ShiftTabKey',forbiddenModifiers:_META_KEY+_ALT_KEY+_CTRL_KEY,mustHaveModifiers:[_SHIFT_KEY],keyCode:9}];function _mapKeys(event){var specialKey;_keyMappings.forEach(function(map){if(map.keyCode===event.keyCode){var netModifiers=(event.metaKey?_META_KEY:0)+(event.ctrlKey?_CTRL_KEY:0)+(event.shiftKey?_SHIFT_KEY:0)+(event.altKey?_ALT_KEY:0);if(map.forbiddenModifiers&netModifiers)return;if(map.mustHaveModifiers.every(function(modifier){return netModifiers&modifier;})){specialKey=map.specialKey;}}});return specialKey;}// set the default to be a paragraph value
	if(attrs.taDefaultWrap===undefined)attrs.taDefaultWrap='p';/* istanbul ignore next: ie specific test */if(attrs.taDefaultWrap===''){_defaultVal='';_defaultTest=_browserDetect.ie===undefined?'<div><br></div>':_browserDetect.ie>=11?'<p><br></p>':_browserDetect.ie<=8?'<P>&nbsp;</P>':'<p>&nbsp;</p>';}else{_defaultVal=_browserDetect.ie===undefined||_browserDetect.ie>=11?'<'+attrs.taDefaultWrap+'><br></'+attrs.taDefaultWrap+'>':_browserDetect.ie<=8?'<'+attrs.taDefaultWrap.toUpperCase()+'></'+attrs.taDefaultWrap.toUpperCase()+'>':'<'+attrs.taDefaultWrap+'></'+attrs.taDefaultWrap+'>';_defaultTest=_browserDetect.ie===undefined||_browserDetect.ie>=11?'<'+attrs.taDefaultWrap+'><br></'+attrs.taDefaultWrap+'>':_browserDetect.ie<=8?'<'+attrs.taDefaultWrap.toUpperCase()+'>&nbsp;</'+attrs.taDefaultWrap.toUpperCase()+'>':'<'+attrs.taDefaultWrap+'>&nbsp;</'+attrs.taDefaultWrap+'>';}/* istanbul ignore else */if(!ngModelOptions.$options)ngModelOptions.$options={};// ng-model-options support
	var _blankTest=_taBlankTest(_defaultTest);var _ensureContentWrapped=function _ensureContentWrapped(value){if(_blankTest(value))return value;var domTest=angular.element("<div>"+value+"</div>");if(domTest.children().length===0){value="<"+attrs.taDefaultWrap+">"+value+"</"+attrs.taDefaultWrap+">";}else{var _children=domTest[0].childNodes;var i;var _foundBlockElement=false;for(i=0;i<_children.length;i++){if(_foundBlockElement=_children[i].nodeName.toLowerCase().match(BLOCKELEMENTS))break;}if(!_foundBlockElement){value="<"+attrs.taDefaultWrap+">"+value+"</"+attrs.taDefaultWrap+">";}else{value="";for(i=0;i<_children.length;i++){if(!_children[i].nodeName.toLowerCase().match(BLOCKELEMENTS)){var _subVal=_children[i].outerHTML||_children[i].nodeValue;/* istanbul ignore else: Doesn't seem to trigger on tests, is tested though */if(_subVal.trim()!=='')value+="<"+attrs.taDefaultWrap+">"+_subVal+"</"+attrs.taDefaultWrap+">";else value+=_subVal;}else{value+=_children[i].outerHTML;}}}}return value;};if(attrs.taPaste)_pasteHandler=$parse(attrs.taPaste);element.addClass('ta-bind');var _undoKeyupTimeout;scope['$undoManager'+(attrs.id||'')]=ngModel.$undoManager={_stack:[],_index:0,_max:1000,push:function push(value){if(typeof value==="undefined"||value===null||typeof this.current()!=="undefined"&&this.current()!==null&&value===this.current())return value;if(this._index<this._stack.length-1){this._stack=this._stack.slice(0,this._index+1);}this._stack.push(value);if(_undoKeyupTimeout)$timeout.cancel(_undoKeyupTimeout);if(this._stack.length>this._max)this._stack.shift();this._index=this._stack.length-1;return value;},undo:function undo(){return this.setToIndex(this._index-1);},redo:function redo(){return this.setToIndex(this._index+1);},setToIndex:function setToIndex(index){if(index<0||index>this._stack.length-1){return undefined;}this._index=index;return this.current();},current:function current(){return this._stack[this._index];}};var _redoUndoTimeout;var _undo=scope['$undoTaBind'+(attrs.id||'')]=function(){/* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */if(!_isReadonly&&_isContentEditable){var content=ngModel.$undoManager.undo();if(typeof content!=="undefined"&&content!==null){_setInnerHTML(content);_setViewValue(content,false);if(_redoUndoTimeout)$timeout.cancel(_redoUndoTimeout);_redoUndoTimeout=$timeout(function(){element[0].focus();taSelection.setSelectionToElementEnd(element[0]);},1);}}};var _redo=scope['$redoTaBind'+(attrs.id||'')]=function(){/* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */if(!_isReadonly&&_isContentEditable){var content=ngModel.$undoManager.redo();if(typeof content!=="undefined"&&content!==null){_setInnerHTML(content);_setViewValue(content,false);/* istanbul ignore next */if(_redoUndoTimeout)$timeout.cancel(_redoUndoTimeout);_redoUndoTimeout=$timeout(function(){element[0].focus();taSelection.setSelectionToElementEnd(element[0]);},1);}}};// in here we are undoing the converts used elsewhere to prevent the < > and & being displayed when they shouldn't in the code.
	var _compileHtml=function _compileHtml(){if(_isContentEditable)return element[0].innerHTML;if(_isInputFriendly)return element.val();throw'textAngular Error: attempting to update non-editable taBind';};var _setViewValue=function _setViewValue(_val,triggerUndo,skipRender){_skipRender=skipRender||false;if(typeof triggerUndo==="undefined"||triggerUndo===null)triggerUndo=true&&_isContentEditable;// if not contentEditable then the native undo/redo is fine
	if(typeof _val==="undefined"||_val===null)_val=_compileHtml();if(_blankTest(_val)){// this avoids us from tripping the ng-pristine flag if we click in and out with out typing
	if(ngModel.$viewValue!=='')ngModel.$setViewValue('');if(triggerUndo&&ngModel.$undoManager.current()!=='')ngModel.$undoManager.push('');}else{_reApplyOnSelectorHandlers();if(ngModel.$viewValue!==_val){ngModel.$setViewValue(_val);if(triggerUndo)ngModel.$undoManager.push(_val);}}ngModel.$render();};//used for updating when inserting wrapped elements
	scope['updateTaBind'+(attrs.id||'')]=function(){if(!_isReadonly)_setViewValue(undefined,undefined,true);};// catch DOM XSS via taSanitize
	// Sanitizing both ways is identical
	var _sanitize=function _sanitize(unsafe){return ngModel.$oldViewValue=taSanitize(taFixChrome(unsafe),ngModel.$oldViewValue,_disableSanitizer);};// trigger the validation calls
	if(element.attr('required'))ngModel.$validators.required=function(modelValue,viewValue){return!_blankTest(modelValue||viewValue);};// parsers trigger from the above keyup function or any other time that the viewValue is updated and parses it for storage in the ngModel
	ngModel.$parsers.push(_sanitize);ngModel.$parsers.unshift(_ensureContentWrapped);// because textAngular is bi-directional (which is awesome) we need to also sanitize values going in from the server
	ngModel.$formatters.push(_sanitize);ngModel.$formatters.unshift(_ensureContentWrapped);ngModel.$formatters.unshift(function(value){return ngModel.$undoManager.push(value||'');});//this code is used to update the models when data is entered/deleted
	if(_isInputFriendly){scope.events={};if(!_isContentEditable){// if a textarea or input just add in change and blur handlers, everything else is done by angulars input directive
	element.on('change blur',scope.events.change=scope.events.blur=function(){if(!_isReadonly)ngModel.$setViewValue(_compileHtml());});element.on('keydown',scope.events.keydown=function(event,eventData){/* istanbul ignore else: this is for catching the jqLite testing*/if(eventData)angular.extend(event,eventData);// Reference to http://stackoverflow.com/questions/6140632/how-to-handle-tab-in-textarea
	/* istanbul ignore else: otherwise normal functionality */if(event.keyCode===9){// tab was pressed
	// get caret position/selection
	var start=this.selectionStart;var end=this.selectionEnd;var value=element.val();if(event.shiftKey){// find \t
	var _linebreak=value.lastIndexOf('\n',start),_tab=value.lastIndexOf('\t',start);if(_tab!==-1&&_tab>=_linebreak){// set textarea value to: text before caret + tab + text after caret
	element.val(value.substring(0,_tab)+value.substring(_tab+1));// put caret at right position again (add one for the tab)
	this.selectionStart=this.selectionEnd=start-1;}}else{// set textarea value to: text before caret + tab + text after caret
	element.val(value.substring(0,start)+"\t"+value.substring(end));// put caret at right position again (add one for the tab)
	this.selectionStart=this.selectionEnd=start+1;}// prevent the focus lose
	event.preventDefault();}});var _repeat=function _repeat(string,n){var result='';for(var _n=0;_n<n;_n++){result+=string;}return result;};var recursiveListFormat=function recursiveListFormat(listNode,tablevel){var _html='',_children=listNode.childNodes;tablevel++;_html+=_repeat('\t',tablevel-1)+listNode.outerHTML.substring(0,listNode.outerHTML.indexOf('<li'));for(var _i=0;_i<_children.length;_i++){/* istanbul ignore next: browser catch */if(!_children[_i].outerHTML)continue;if(_children[_i].nodeName.toLowerCase()==='ul'||_children[_i].nodeName.toLowerCase()==='ol')_html+='\n'+recursiveListFormat(_children[_i],tablevel);else _html+='\n'+_repeat('\t',tablevel)+_children[_i].outerHTML;}_html+='\n'+_repeat('\t',tablevel-1)+listNode.outerHTML.substring(listNode.outerHTML.lastIndexOf('<'));return _html;};ngModel.$formatters.unshift(function(htmlValue){// tabulate the HTML so it looks nicer
	var _children=angular.element('<div>'+htmlValue+'</div>')[0].childNodes;if(_children.length>0){htmlValue='';for(var i=0;i<_children.length;i++){/* istanbul ignore next: browser catch */if(!_children[i].outerHTML)continue;if(htmlValue.length>0)htmlValue+='\n';if(_children[i].nodeName.toLowerCase()==='ul'||_children[i].nodeName.toLowerCase()==='ol')htmlValue+=''+recursiveListFormat(_children[i],0);else htmlValue+=''+_children[i].outerHTML;}}return htmlValue;});}else{// all the code specific to contenteditable divs
	var _processingPaste=false;/* istanbul ignore next: phantom js cannot test this for some reason */var processpaste=function processpaste(text){/* istanbul ignore else: don't care if nothing pasted */if(text&&text.trim().length){// test paste from word/microsoft product
	if(text.match(/class=["']*Mso(Normal|List)/i)){var textFragment=text.match(/<!--StartFragment-->([\s\S]*?)<!--EndFragment-->/i);if(!textFragment)textFragment=text;else textFragment=textFragment[1];textFragment=textFragment.replace(/<o:p>[\s\S]*?<\/o:p>/ig,'').replace(/class=(["']|)MsoNormal(["']|)/ig,'');var dom=angular.element("<div>"+textFragment+"</div>");var targetDom=angular.element("<div></div>");var _list={element:null,lastIndent:[],lastLi:null,isUl:false};_list.lastIndent.peek=function(){var n=this.length;if(n>0)return this[n-1];};var _resetList=function _resetList(isUl){_list.isUl=isUl;_list.element=angular.element(isUl?"<ul>":"<ol>");_list.lastIndent=[];_list.lastIndent.peek=function(){var n=this.length;if(n>0)return this[n-1];};_list.lastLevelMatch=null;};for(var i=0;i<=dom[0].childNodes.length;i++){if(!dom[0].childNodes[i]||dom[0].childNodes[i].nodeName==="#text"||dom[0].childNodes[i].tagName.toLowerCase()!=="p")continue;var el=angular.element(dom[0].childNodes[i]);var _listMatch=(el.attr('class')||'').match(/MsoList(Bullet|Number|Paragraph)(CxSp(First|Middle|Last)|)/i);if(_listMatch){if(el[0].childNodes.length<2||el[0].childNodes[1].childNodes.length<1){continue;}var isUl=_listMatch[1].toLowerCase()==="bullet"||_listMatch[1].toLowerCase()!=="number"&&!(/^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].innerHTML)||/^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].childNodes[0].innerHTML));var _indentMatch=(el.attr('style')||'').match(/margin-left:([\-\.0-9]*)/i);var indent=parseFloat(_indentMatch?_indentMatch[1]:0);var _levelMatch=(el.attr('style')||'').match(/mso-list:l([0-9]+) level([0-9]+) lfo[0-9+]($|;)/i);// prefers the mso-list syntax
	if(_levelMatch&&_levelMatch[2])indent=parseInt(_levelMatch[2]);if(_levelMatch&&(!_list.lastLevelMatch||_levelMatch[1]!==_list.lastLevelMatch[1])||!_listMatch[3]||_listMatch[3].toLowerCase()==="first"||_list.lastIndent.peek()===null||_list.isUl!==isUl&&_list.lastIndent.peek()===indent){_resetList(isUl);targetDom.append(_list.element);}else if(_list.lastIndent.peek()!=null&&_list.lastIndent.peek()<indent){_list.element=angular.element(isUl?"<ul>":"<ol>");_list.lastLi.append(_list.element);}else if(_list.lastIndent.peek()!=null&&_list.lastIndent.peek()>indent){while(_list.lastIndent.peek()!=null&&_list.lastIndent.peek()>indent){if(_list.element.parent()[0].tagName.toLowerCase()==='li'){_list.element=_list.element.parent();continue;}else if(/[uo]l/i.test(_list.element.parent()[0].tagName.toLowerCase())){_list.element=_list.element.parent();}else{// else it's it should be a sibling
	break;}_list.lastIndent.pop();}_list.isUl=_list.element[0].tagName.toLowerCase()==="ul";if(isUl!==_list.isUl){_resetList(isUl);targetDom.append(_list.element);}}_list.lastLevelMatch=_levelMatch;if(indent!==_list.lastIndent.peek())_list.lastIndent.push(indent);_list.lastLi=angular.element("<li>");_list.element.append(_list.lastLi);_list.lastLi.html(el.html().replace(/<!(--|)\[if !supportLists\](--|)>[\s\S]*?<!(--|)\[endif\](--|)>/ig,''));el.remove();}else{_resetList(false);targetDom.append(el);}}var _unwrapElement=function _unwrapElement(node){node=angular.element(node);for(var _n=node[0].childNodes.length-1;_n>=0;_n--){node.after(node[0].childNodes[_n]);}node.remove();};angular.forEach(targetDom.find('span'),function(node){node.removeAttribute('lang');if(node.attributes.length<=0)_unwrapElement(node);});angular.forEach(targetDom.find('font'),_unwrapElement);text=targetDom.html();}else{// remove unnecessary chrome insert
	text=text.replace(/<(|\/)meta[^>]*?>/ig,'');if(text.match(/<[^>]*?(ta-bind)[^>]*?>/)){// entire text-angular or ta-bind has been pasted, REMOVE AT ONCE!!
	if(text.match(/<[^>]*?(text-angular)[^>]*?>/)){var _el=angular.element("<div>"+text+"</div>");_el.find('textarea').remove();var binds=taDOM.getByAttribute(_el,'ta-bind');for(var _b=0;_b<binds.length;_b++){var _target=binds[_b][0].parentNode.parentNode;for(var _c=0;_c<binds[_b][0].childNodes.length;_c++){_target.parentNode.insertBefore(binds[_b][0].childNodes[_c],_target);}_target.parentNode.removeChild(_target);}text=_el.html().replace('<br class="Apple-interchange-newline">','');}}else if(text.match(/^<span/)){// in case of pasting only a span - chrome paste, remove them. THis is just some wierd formatting
	text=text.replace(/<(|\/)span[^>]*?>/ig,'');}// Webkit on Apple tags
	text=text.replace(/<br class="Apple-interchange-newline"[^>]*?>/ig,'').replace(/<span class="Apple-converted-space">( |&nbsp;)<\/span>/ig,'&nbsp;');}if(/<li(\s.*)?>/i.test(text)&&/(<ul(\s.*)?>|<ol(\s.*)?>).*<li(\s.*)?>/i.test(text)===false){// insert missing parent of li element
	text=text.replace(/<li(\s.*)?>.*<\/li(\s.*)?>/i,'<ul>$&</ul>');}if(_pasteHandler)text=_pasteHandler(scope,{$html:text})||text;text=taSanitize(text,'',_disableSanitizer);taSelection.insertHtml(text,element[0]);$timeout(function(){ngModel.$setViewValue(_compileHtml());_processingPaste=false;element.removeClass('processing-paste');},0);}else{_processingPaste=false;element.removeClass('processing-paste');}};element.on('paste',scope.events.paste=function(e,eventData){/* istanbul ignore else: this is for catching the jqLite testing*/if(eventData)angular.extend(e,eventData);if(_isReadonly||_processingPaste){e.stopPropagation();e.preventDefault();return false;}// Code adapted from http://stackoverflow.com/questions/2176861/javascript-get-clipboard-data-on-paste-event-cross-browser/6804718#6804718
	_processingPaste=true;element.addClass('processing-paste');var pastedContent;var clipboardData=(e.originalEvent||e).clipboardData;if(clipboardData&&clipboardData.getData&&clipboardData.types.length>0){// Webkit - get data from clipboard, put into editdiv, cleanup, then cancel event
	var _types="";for(var _t=0;_t<clipboardData.types.length;_t++){_types+=" "+clipboardData.types[_t];}/* istanbul ignore next: browser tests */if(/text\/html/i.test(_types)){pastedContent=clipboardData.getData('text/html');}else if(/text\/plain/i.test(_types)){pastedContent=clipboardData.getData('text/plain');}processpaste(pastedContent);e.stopPropagation();e.preventDefault();return false;}else{// Everything else - empty editdiv and allow browser to paste content into it, then cleanup
	var _savedSelection=$window.rangy.saveSelection(),_tempDiv=angular.element('<div class="ta-hidden-input" contenteditable="true"></div>');$document.find('body').append(_tempDiv);_tempDiv[0].focus();$timeout(function(){// restore selection
	$window.rangy.restoreSelection(_savedSelection);processpaste(_tempDiv[0].innerHTML);element[0].focus();_tempDiv.remove();},0);}});element.on('cut',scope.events.cut=function(e){// timeout to next is needed as otherwise the paste/cut event has not finished actually changing the display
	if(!_isReadonly)$timeout(function(){ngModel.$setViewValue(_compileHtml());},0);else e.preventDefault();});element.on('keydown',scope.events.keydown=function(event,eventData){/* istanbul ignore else: this is for catching the jqLite testing*/if(eventData)angular.extend(event,eventData);event.specialKey=_mapKeys(event);var userSpecialKey;/* istanbul ignore next: difficult to test */taOptions.keyMappings.forEach(function(mapping){if(event.specialKey===mapping.commandKeyCode){// taOptions has remapped this binding... so
	// we disable our own
	event.specialKey=undefined;}if(mapping.testForKey(event)){userSpecialKey=mapping.commandKeyCode;}if(mapping.commandKeyCode==='UndoKey'||mapping.commandKeyCode==='RedoKey'){// this is necessary to fully stop the propagation.
	if(!mapping.enablePropagation){event.preventDefault();}}});/* istanbul ignore next: difficult to test */if(typeof userSpecialKey!=='undefined'){event.specialKey=userSpecialKey;}/* istanbul ignore next: difficult to test as can't seem to select */if(typeof event.specialKey!=='undefined'&&(event.specialKey!=='UndoKey'||event.specialKey!=='RedoKey')){event.preventDefault();textAngularManager.sendKeyCommand(scope,event);}/* istanbul ignore else: readonly check */if(!_isReadonly){if(event.specialKey==='UndoKey'){_undo();event.preventDefault();}if(event.specialKey==='RedoKey'){_redo();event.preventDefault();}/* istanbul ignore next: difficult to test as can't seem to select */if(event.keyCode===13&&!event.shiftKey){var $selection;var selection=taSelection.getSelectionElement();if(!selection.tagName.match(VALIDELEMENTS))return;var _new=angular.element(_defaultVal);if(/^<br(|\/)>$/i.test(selection.innerHTML.trim())&&selection.parentNode.tagName.toLowerCase()==='blockquote'&&!selection.nextSibling){// if last element in blockquote and element is blank, pull element outside of blockquote.
	$selection=angular.element(selection);var _parent=$selection.parent();_parent.after(_new);$selection.remove();if(_parent.children().length===0)_parent.remove();taSelection.setSelectionToElementStart(_new[0]);event.preventDefault();}else if(/^<[^>]+><br(|\/)><\/[^>]+>$/i.test(selection.innerHTML.trim())&&selection.tagName.toLowerCase()==='blockquote'){$selection=angular.element(selection);$selection.after(_new);$selection.remove();taSelection.setSelectionToElementStart(_new[0]);event.preventDefault();}}}});var _keyupTimeout;element.on('keyup',scope.events.keyup=function(event,eventData){/* istanbul ignore else: this is for catching the jqLite testing*/if(eventData)angular.extend(event,eventData);/* istanbul ignore next: FF specific bug fix */if(event.keyCode===9){var _selection=taSelection.getSelection();if(_selection.start.element===element[0]&&element.children().length)taSelection.setSelectionToElementStart(element.children()[0]);return;}if(_undoKeyupTimeout)$timeout.cancel(_undoKeyupTimeout);if(!_isReadonly&&!BLOCKED_KEYS.test(event.keyCode)){// if enter - insert new taDefaultWrap, if shift+enter insert <br/>
	if(_defaultVal!==''&&event.keyCode===13){if(!event.shiftKey){// new paragraph, br should be caught correctly
	var selection=taSelection.getSelectionElement();while(!selection.tagName.match(VALIDELEMENTS)&&selection!==element[0]){selection=selection.parentNode;}if(selection.tagName.toLowerCase()!==attrs.taDefaultWrap&&selection.tagName.toLowerCase()!=='li'&&(selection.innerHTML.trim()===''||selection.innerHTML.trim()==='<br>')){var _new=angular.element(_defaultVal);angular.element(selection).replaceWith(_new);taSelection.setSelectionToElementStart(_new[0]);}}}var val=_compileHtml();if(_defaultVal!==''&&val.trim()===''){_setInnerHTML(_defaultVal);taSelection.setSelectionToElementStart(element.children()[0]);}else if(val.substring(0,1)!=='<'&&attrs.taDefaultWrap!==''){var _savedSelection=$window.rangy.saveSelection();val=_compileHtml();val="<"+attrs.taDefaultWrap+">"+val+"</"+attrs.taDefaultWrap+">";_setInnerHTML(val);$window.rangy.restoreSelection(_savedSelection);}var triggerUndo=_lastKey!==event.keyCode&&UNDO_TRIGGER_KEYS.test(event.keyCode);if(_keyupTimeout)$timeout.cancel(_keyupTimeout);_keyupTimeout=$timeout(function(){_setViewValue(val,triggerUndo,true);},ngModelOptions.$options.debounce||400);if(!triggerUndo)_undoKeyupTimeout=$timeout(function(){ngModel.$undoManager.push(val);},250);_lastKey=event.keyCode;}});element.on('blur',scope.events.blur=function(){_focussed=false;/* istanbul ignore else: if readonly don't update model */if(!_isReadonly){_setViewValue(undefined,undefined,true);}else{_skipRender=true;// don't redo the whole thing, just check the placeholder logic
	ngModel.$render();}});// Placeholders not supported on ie 8 and below
	if(attrs.placeholder&&(_browserDetect.ie>8||_browserDetect.ie===undefined)){var rule;if(attrs.id)rule=addCSSRule('#'+attrs.id+'.placeholder-text:before','content: "'+attrs.placeholder+'"');else throw'textAngular Error: An unique ID is required for placeholders to work';scope.$on('$destroy',function(){removeCSSRule(rule);});}element.on('focus',scope.events.focus=function(){_focussed=true;element.removeClass('placeholder-text');_reApplyOnSelectorHandlers();});element.on('mouseup',scope.events.mouseup=function(){var _selection=taSelection.getSelection();if(_selection.start.element===element[0]&&element.children().length)taSelection.setSelectionToElementStart(element.children()[0]);});// prevent propagation on mousedown in editor, see #206
	element.on('mousedown',scope.events.mousedown=function(event,eventData){/* istanbul ignore else: this is for catching the jqLite testing*/if(eventData)angular.extend(event,eventData);event.stopPropagation();});}}var selectorClickHandler=function selectorClickHandler(event){// emit the element-select event, pass the element
	scope.$emit('ta-element-select',this);event.preventDefault();return false;};var fileDropHandler=function fileDropHandler(event,eventData){/* istanbul ignore else: this is for catching the jqLite testing*/if(eventData)angular.extend(event,eventData);// emit the drop event, pass the element, preventing should be done elsewhere
	if(!dropFired&&!_isReadonly){dropFired=true;var dataTransfer;if(event.originalEvent)dataTransfer=event.originalEvent.dataTransfer;else dataTransfer=event.dataTransfer;scope.$emit('ta-drop-event',this,event,dataTransfer);$timeout(function(){dropFired=false;_setViewValue(undefined,undefined,true);},100);}};//used for updating when inserting wrapped elements
	var _reApplyOnSelectorHandlers=scope['reApplyOnSelectorHandlers'+(attrs.id||'')]=function(){/* istanbul ignore else */if(!_isReadonly)angular.forEach(taSelectableElements,function(selector){// check we don't apply the handler twice
	element.find(selector).off('click',selectorClickHandler).on('click',selectorClickHandler);});};var _setInnerHTML=function _setInnerHTML(newval){element[0].innerHTML=newval;};var _renderTimeout;var _renderInProgress=false;// changes to the model variable from outside the html/text inputs
	ngModel.$render=function(){/* istanbul ignore if: Catches rogue renders, hard to replicate in tests */if(_renderInProgress)return;else _renderInProgress=true;// catch model being null or undefined
	var val=ngModel.$viewValue||'';// if the editor isn't focused it needs to be updated, otherwise it's receiving user input
	if(!_skipRender){/* istanbul ignore else: in other cases we don't care */if(_isContentEditable&&_focussed){// update while focussed
	element.removeClass('placeholder-text');if(_renderTimeout)$timeout.cancel(_renderTimeout);_renderTimeout=$timeout(function(){/* istanbul ignore if: Can't be bothered testing this... */if(!_focussed){element[0].focus();taSelection.setSelectionToElementEnd(element.children()[element.children().length-1]);}_renderTimeout=undefined;},1);}if(_isContentEditable){// WYSIWYG Mode
	if(attrs.placeholder){if(val===''){// blank
	_setInnerHTML(_defaultVal);}else{// not-blank
	_setInnerHTML(val);}}else{_setInnerHTML(val===''?_defaultVal:val);}// if in WYSIWYG and readOnly we kill the use of links by clicking
	if(!_isReadonly){_reApplyOnSelectorHandlers();element.on('drop',fileDropHandler);}else{element.off('drop',fileDropHandler);}}else if(element[0].tagName.toLowerCase()!=='textarea'&&element[0].tagName.toLowerCase()!=='input'){// make sure the end user can SEE the html code as a display. This is a read-only display element
	_setInnerHTML(taApplyCustomRenderers(val));}else{// only for input and textarea inputs
	element.val(val);}}if(_isContentEditable&&attrs.placeholder){if(val===''){if(_focussed)element.removeClass('placeholder-text');else element.addClass('placeholder-text');}else{element.removeClass('placeholder-text');}}_renderInProgress=_skipRender=false;};if(attrs.taReadonly){//set initial value
	_isReadonly=scope.$eval(attrs.taReadonly);if(_isReadonly){element.addClass('ta-readonly');// we changed to readOnly mode (taReadonly='true')
	if(element[0].tagName.toLowerCase()==='textarea'||element[0].tagName.toLowerCase()==='input'){element.attr('disabled','disabled');}if(element.attr('contenteditable')!==undefined&&element.attr('contenteditable')){element.removeAttr('contenteditable');}}else{element.removeClass('ta-readonly');// we changed to NOT readOnly mode (taReadonly='false')
	if(element[0].tagName.toLowerCase()==='textarea'||element[0].tagName.toLowerCase()==='input'){element.removeAttr('disabled');}else if(_isContentEditable){element.attr('contenteditable','true');}}// taReadonly only has an effect if the taBind element is an input or textarea or has contenteditable='true' on it.
	// Otherwise it is readonly by default
	scope.$watch(attrs.taReadonly,function(newVal,oldVal){if(oldVal===newVal)return;if(newVal){element.addClass('ta-readonly');// we changed to readOnly mode (taReadonly='true')
	if(element[0].tagName.toLowerCase()==='textarea'||element[0].tagName.toLowerCase()==='input'){element.attr('disabled','disabled');}if(element.attr('contenteditable')!==undefined&&element.attr('contenteditable')){element.removeAttr('contenteditable');}// turn ON selector click handlers
	angular.forEach(taSelectableElements,function(selector){element.find(selector).on('click',selectorClickHandler);});element.off('drop',fileDropHandler);}else{element.removeClass('ta-readonly');// we changed to NOT readOnly mode (taReadonly='false')
	if(element[0].tagName.toLowerCase()==='textarea'||element[0].tagName.toLowerCase()==='input'){element.removeAttr('disabled');}else if(_isContentEditable){element.attr('contenteditable','true');}// remove the selector click handlers
	angular.forEach(taSelectableElements,function(selector){element.find(selector).off('click',selectorClickHandler);});element.on('drop',fileDropHandler);}_isReadonly=newVal;});}// Initialise the selectableElements
	// if in WYSIWYG and readOnly we kill the use of links by clicking
	if(_isContentEditable&&!_isReadonly){angular.forEach(taSelectableElements,function(selector){element.find(selector).on('click',selectorClickHandler);});element.on('drop',fileDropHandler);element.on('blur',function(){/* istanbul ignore next: webkit fix */if(_browserDetect.webkit){// detect webkit
	globalContentEditableBlur=true;}});}}};}]);// this global var is used to prevent multiple fires of the drop event. Needs to be global to the textAngular file.
	var dropFired=false;var textAngular=angular.module("textAngular",['ngSanitize','textAngularSetup','textAngular.factories','textAngular.DOM','textAngular.validators','textAngular.taBind']);//This makes ngSanitize required
	// setup the global contstant functions for setting up the toolbar
	// all tool definitions
	var taTools={};/*
		A tool definition is an object with the following key/value parameters:
			action: [function(deferred, restoreSelection)]
					a function that is executed on clicking on the button - this will allways be executed using ng-click and will
					overwrite any ng-click value in the display attribute.
					The function is passed a deferred object ($q.defer()), if this is wanted to be used `return false;` from the action and
					manually call `deferred.resolve();` elsewhere to notify the editor that the action has finished.
					restoreSelection is only defined if the rangy library is included and it can be called as `restoreSelection()` to restore the users
					selection in the WYSIWYG editor.
			display: [string]?
					Optional, an HTML element to be displayed as the button. The `scope` of the button is the tool definition object with some additional functions
					If set this will cause buttontext and iconclass to be ignored
			class: [string]?
					Optional, if set will override the taOptions.classes.toolbarButton class.
			buttontext: [string]?
					if this is defined it will replace the contents of the element contained in the `display` element
			iconclass: [string]?
					if this is defined an icon (<i>) will be appended to the `display` element with this string as it's class
			tooltiptext: [string]?
					Optional, a plain text description of the action, used for the title attribute of the action button in the toolbar by default.
			activestate: [function(commonElement)]?
					this function is called on every caret movement, if it returns true then the class taOptions.classes.toolbarButtonActive
					will be applied to the `display` element, else the class will be removed
			disabled: [function()]?
					if this function returns true then the tool will have the class taOptions.classes.disabled applied to it, else it will be removed
		Other functions available on the scope are:
			name: [string]
					the name of the tool, this is the first parameter passed into taRegisterTool
			isDisabled: [function()]
					returns true if the tool is disabled, false if it isn't
			displayActiveToolClass: [function(boolean)]
					returns true if the tool is 'active' in the currently focussed toolbar
			onElementSelect: [Object]
					This object contains the following key/value pairs and is used to trigger the ta-element-select event
					element: [String]
						an element name, will only trigger the onElementSelect action if the tagName of the element matches this string
					filter: [function(element)]?
						an optional filter that returns a boolean, if true it will trigger the onElementSelect.
					action: [function(event, element, editorScope)]
						the action that should be executed if the onElementSelect function runs
	*/// name and toolDefinition to add into the tools available to be added on the toolbar
	function registerTextAngularTool(name,toolDefinition){if(!name||name===''||taTools.hasOwnProperty(name))throw'textAngular Error: A unique name is required for a Tool Definition';if(toolDefinition.display&&(toolDefinition.display===''||!validElementString(toolDefinition.display))||!toolDefinition.display&&!toolDefinition.buttontext&&!toolDefinition.iconclass)throw'textAngular Error: Tool Definition for "'+name+'" does not have a valid display/iconclass/buttontext value';taTools[name]=toolDefinition;}textAngular.constant('taRegisterTool',registerTextAngularTool);textAngular.value('taTools',taTools);textAngular.config([function(){// clear taTools variable. Just catches testing and any other time that this config may run multiple times...
	angular.forEach(taTools,function(value,key){delete taTools[key];});}]);textAngular.run([function(){/* istanbul ignore next: not sure how to test this */// Require Rangy and rangy savedSelection module.
	if(!window.rangy){throw"rangy-core.js and rangy-selectionsaverestore.js are required for textAngular to work correctly, rangy-core is not yet loaded.";}else{window.rangy.init();if(!window.rangy.saveSelection){throw"rangy-selectionsaverestore.js is required for textAngular to work correctly.";}}}]);textAngular.directive("textAngular",['$compile','$timeout','taOptions','taSelection','taExecCommand','textAngularManager','$window','$document','$animate','$log','$q','$parse',function($compile,$timeout,taOptions,taSelection,taExecCommand,textAngularManager,$window,$document,$animate,$log,$q,$parse){return{require:'?ngModel',scope:{},restrict:"EA",priority:2,// So we override validators correctly
	link:function link(scope,element,attrs,ngModel){// all these vars should not be accessable outside this directive
	var _keydown,_keyup,_keypress,_mouseup,_focusin,_focusout,_originalContents,_toolbars,_serial=attrs.serial?attrs.serial:Math.floor(Math.random()*10000000000000000),_taExecCommand,_resizeMouseDown,_updateSelectedStylesTimeout;scope._name=attrs.name?attrs.name:'textAngularEditor'+_serial;var oneEvent=function oneEvent(_element,event,action){$timeout(function(){// shim the .one till fixed
	var _func=function _func(){_element.off(event,_func);action.apply(this,arguments);};_element.on(event,_func);},100);};_taExecCommand=taExecCommand(attrs.taDefaultWrap);// get the settings from the defaults and add our specific functions that need to be on the scope
	angular.extend(scope,angular.copy(taOptions),{// wraps the selection in the provided tag / execCommand function. Should only be called in WYSIWYG mode.
	wrapSelection:function wrapSelection(command,opt,isSelectableElementTool){if(command.toLowerCase()==="undo"){scope['$undoTaBindtaTextElement'+_serial]();}else if(command.toLowerCase()==="redo"){scope['$redoTaBindtaTextElement'+_serial]();}else{// catch errors like FF erroring when you try to force an undo with nothing done
	_taExecCommand(command,false,opt,scope.defaultTagAttributes);if(isSelectableElementTool){// re-apply the selectable tool events
	scope['reApplyOnSelectorHandlerstaTextElement'+_serial]();}// refocus on the shown display element, this fixes a display bug when using :focus styles to outline the box.
	// You still have focus on the text/html input it just doesn't show up
	scope.displayElements.text[0].focus();}},showHtml:scope.$eval(attrs.taShowHtml)||false});// setup the options from the optional attributes
	if(attrs.taFocussedClass)scope.classes.focussed=attrs.taFocussedClass;if(attrs.taTextEditorClass)scope.classes.textEditor=attrs.taTextEditorClass;if(attrs.taHtmlEditorClass)scope.classes.htmlEditor=attrs.taHtmlEditorClass;if(attrs.taDefaultTagAttributes){try{//	TODO: This should use angular.merge to enhance functionality once angular 1.4 is required
	angular.extend(scope.defaultTagAttributes,angular.fromJson(attrs.taDefaultTagAttributes));}catch(error){$log.error(error);}}// optional setup functions
	if(attrs.taTextEditorSetup)scope.setup.textEditorSetup=scope.$parent.$eval(attrs.taTextEditorSetup);if(attrs.taHtmlEditorSetup)scope.setup.htmlEditorSetup=scope.$parent.$eval(attrs.taHtmlEditorSetup);// optional fileDropHandler function
	if(attrs.taFileDrop)scope.fileDropHandler=scope.$parent.$eval(attrs.taFileDrop);else scope.fileDropHandler=scope.defaultFileDropHandler;_originalContents=element[0].innerHTML;// clear the original content
	element[0].innerHTML='';// Setup the HTML elements as variable references for use later
	scope.displayElements={// we still need the hidden input even with a textarea as the textarea may have invalid/old input in it,
	// wheras the input will ALLWAYS have the correct value.
	forminput:angular.element("<input type='hidden' tabindex='-1' style='display: none;'>"),html:angular.element("<textarea></textarea>"),text:angular.element("<div></div>"),// other toolbased elements
	scrollWindow:angular.element("<div class='ta-scroll-window'></div>"),popover:angular.element('<div class="popover fade bottom" style="max-width: none; width: 305px;"></div>'),popoverArrow:angular.element('<div class="arrow"></div>'),popoverContainer:angular.element('<div class="popover-content"></div>'),resize:{overlay:angular.element('<div class="ta-resizer-handle-overlay"></div>'),background:angular.element('<div class="ta-resizer-handle-background"></div>'),anchors:[angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tl"></div>'),angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tr"></div>'),angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-bl"></div>'),angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-br"></div>')],info:angular.element('<div class="ta-resizer-handle-info"></div>')}};// Setup the popover
	scope.displayElements.popover.append(scope.displayElements.popoverArrow);scope.displayElements.popover.append(scope.displayElements.popoverContainer);scope.displayElements.scrollWindow.append(scope.displayElements.popover);scope.displayElements.popover.on('mousedown',function(e,eventData){/* istanbul ignore else: this is for catching the jqLite testing*/if(eventData)angular.extend(e,eventData);// this prevents focusout from firing on the editor when clicking anything in the popover
	e.preventDefault();return false;});// define the popover show and hide functions
	scope.showPopover=function(_el){scope.displayElements.popover.css('display','block');scope.reflowPopover(_el);$animate.addClass(scope.displayElements.popover,'in');oneEvent($document.find('body'),'click keyup',function(){scope.hidePopover();});};scope.reflowPopover=function(_el){/* istanbul ignore if: catches only if near bottom of editor */if(scope.displayElements.text[0].offsetHeight-51>_el[0].offsetTop){scope.displayElements.popover.css('top',_el[0].offsetTop+_el[0].offsetHeight+scope.displayElements.scrollWindow[0].scrollTop+'px');scope.displayElements.popover.removeClass('top').addClass('bottom');}else{scope.displayElements.popover.css('top',_el[0].offsetTop-54+scope.displayElements.scrollWindow[0].scrollTop+'px');scope.displayElements.popover.removeClass('bottom').addClass('top');}var _maxLeft=scope.displayElements.text[0].offsetWidth-scope.displayElements.popover[0].offsetWidth;var _targetLeft=_el[0].offsetLeft+_el[0].offsetWidth/2.0-scope.displayElements.popover[0].offsetWidth/2.0;scope.displayElements.popover.css('left',Math.max(0,Math.min(_maxLeft,_targetLeft))+'px');scope.displayElements.popoverArrow.css('margin-left',Math.min(_targetLeft,Math.max(0,_targetLeft-_maxLeft))-11+'px');};scope.hidePopover=function(){/* istanbul ignore next: dosen't test with mocked animate */var doneCb=function doneCb(){scope.displayElements.popover.css('display','');scope.displayElements.popoverContainer.attr('style','');scope.displayElements.popoverContainer.attr('class','popover-content');};$q.when($animate.removeClass(scope.displayElements.popover,'in',doneCb)).then(doneCb);};// setup the resize overlay
	scope.displayElements.resize.overlay.append(scope.displayElements.resize.background);angular.forEach(scope.displayElements.resize.anchors,function(anchor){scope.displayElements.resize.overlay.append(anchor);});scope.displayElements.resize.overlay.append(scope.displayElements.resize.info);scope.displayElements.scrollWindow.append(scope.displayElements.resize.overlay);// define the show and hide events
	scope.reflowResizeOverlay=function(_el){_el=angular.element(_el)[0];scope.displayElements.resize.overlay.css({'display':'block','left':_el.offsetLeft-5+'px','top':_el.offsetTop-5+'px','width':_el.offsetWidth+10+'px','height':_el.offsetHeight+10+'px'});scope.displayElements.resize.info.text(_el.offsetWidth+' x '+_el.offsetHeight);};/* istanbul ignore next: pretty sure phantomjs won't test this */scope.showResizeOverlay=function(_el){var _body=$document.find('body');_resizeMouseDown=function _resizeMouseDown(event){var startPosition={width:parseInt(_el.attr('width')),height:parseInt(_el.attr('height')),x:event.clientX,y:event.clientY};if(startPosition.width===undefined||isNaN(startPosition.width))startPosition.width=_el[0].offsetWidth;if(startPosition.height===undefined||isNaN(startPosition.height))startPosition.height=_el[0].offsetHeight;scope.hidePopover();var ratio=startPosition.height/startPosition.width;var mousemove=function mousemove(event){// calculate new size
	var pos={x:Math.max(0,startPosition.width+(event.clientX-startPosition.x)),y:Math.max(0,startPosition.height+(event.clientY-startPosition.y))};// DEFAULT: the aspect ratio is not locked unless the Shift key is pressed.
	//
	// attribute: ta-resize-force-aspect-ratio -- locks resize into maintaing the aspect ratio
	var bForceAspectRatio=attrs.taResizeForceAspectRatio!==undefined;// attribute: ta-resize-maintain-aspect-ratio=true causes the space ratio to remain locked
	// unless the Shift key is pressed
	var bFlipKeyBinding=attrs.taResizeMaintainAspectRatio;var bKeepRatio=bForceAspectRatio||bFlipKeyBinding&&!event.shiftKey;if(bKeepRatio){var newRatio=pos.y/pos.x;pos.x=ratio>newRatio?pos.x:pos.y/ratio;pos.y=ratio>newRatio?pos.x*ratio:pos.y;}var el=angular.element(_el);el.css('height',Math.round(Math.max(0,pos.y)+'px'));el.css('width',Math.round(Math.max(0,pos.x)+'px'));// reflow the popover tooltip
	scope.reflowResizeOverlay(_el);};_body.on('mousemove',mousemove);oneEvent(_body,'mouseup',function(event){event.preventDefault();event.stopPropagation();_body.off('mousemove',mousemove);scope.showPopover(_el);});event.stopPropagation();event.preventDefault();};scope.displayElements.resize.anchors[3].off('mousedown');scope.displayElements.resize.anchors[3].on('mousedown',_resizeMouseDown);scope.reflowResizeOverlay(_el);oneEvent(_body,'click',function(){scope.hideResizeOverlay();});};/* istanbul ignore next: pretty sure phantomjs won't test this */scope.hideResizeOverlay=function(){scope.displayElements.resize.anchors[3].off('mousedown',_resizeMouseDown);scope.displayElements.resize.overlay.css('display','');};// allow for insertion of custom directives on the textarea and div
	scope.setup.htmlEditorSetup(scope.displayElements.html);scope.setup.textEditorSetup(scope.displayElements.text);scope.displayElements.html.attr({'id':'taHtmlElement'+_serial,'ng-show':'showHtml','ta-bind':'ta-bind','ng-model':'html','ng-model-options':element.attr('ng-model-options')});scope.displayElements.text.attr({'id':'taTextElement'+_serial,'contentEditable':'true','ta-bind':'ta-bind','ng-model':'html','ng-model-options':element.attr('ng-model-options')});scope.displayElements.scrollWindow.attr({'ng-hide':'showHtml'});if(attrs.taDefaultWrap)scope.displayElements.text.attr('ta-default-wrap',attrs.taDefaultWrap);if(attrs.taUnsafeSanitizer){scope.displayElements.text.attr('ta-unsafe-sanitizer',attrs.taUnsafeSanitizer);scope.displayElements.html.attr('ta-unsafe-sanitizer',attrs.taUnsafeSanitizer);}// add the main elements to the origional element
	scope.displayElements.scrollWindow.append(scope.displayElements.text);element.append(scope.displayElements.scrollWindow);element.append(scope.displayElements.html);scope.displayElements.forminput.attr('name',scope._name);element.append(scope.displayElements.forminput);if(attrs.tabindex){element.removeAttr('tabindex');scope.displayElements.text.attr('tabindex',attrs.tabindex);scope.displayElements.html.attr('tabindex',attrs.tabindex);}if(attrs.placeholder){scope.displayElements.text.attr('placeholder',attrs.placeholder);scope.displayElements.html.attr('placeholder',attrs.placeholder);}if(attrs.taDisabled){scope.displayElements.text.attr('ta-readonly','disabled');scope.displayElements.html.attr('ta-readonly','disabled');scope.disabled=scope.$parent.$eval(attrs.taDisabled);scope.$parent.$watch(attrs.taDisabled,function(newVal){scope.disabled=newVal;if(scope.disabled){element.addClass(scope.classes.disabled);}else{element.removeClass(scope.classes.disabled);}});}if(attrs.taPaste){scope._pasteHandler=function(_html){return $parse(attrs.taPaste)(scope.$parent,{$html:_html});};scope.displayElements.text.attr('ta-paste','_pasteHandler($html)');}// compile the scope with the text and html elements only - if we do this with the main element it causes a compile loop
	$compile(scope.displayElements.scrollWindow)(scope);$compile(scope.displayElements.html)(scope);scope.updateTaBindtaTextElement=scope['updateTaBindtaTextElement'+_serial];scope.updateTaBindtaHtmlElement=scope['updateTaBindtaHtmlElement'+_serial];// add the classes manually last
	element.addClass("ta-root");scope.displayElements.scrollWindow.addClass("ta-text ta-editor "+scope.classes.textEditor);scope.displayElements.html.addClass("ta-html ta-editor "+scope.classes.htmlEditor);// used in the toolbar actions
	scope._actionRunning=false;var _savedSelection=false;scope.startAction=function(){scope._actionRunning=true;// if rangy library is loaded return a function to reload the current selection
	_savedSelection=$window.rangy.saveSelection();return function(){if(_savedSelection)$window.rangy.restoreSelection(_savedSelection);};};scope.endAction=function(){scope._actionRunning=false;if(_savedSelection){if(scope.showHtml){scope.displayElements.html[0].focus();}else{scope.displayElements.text[0].focus();}// $window.rangy.restoreSelection(_savedSelection);
	$window.rangy.removeMarkers(_savedSelection);}_savedSelection=false;scope.updateSelectedStyles();// only update if in text or WYSIWYG mode
	if(!scope.showHtml)scope['updateTaBindtaTextElement'+_serial]();};// note that focusout > focusin is called everytime we click a button - except bad support: http://www.quirksmode.org/dom/events/blurfocus.html
	// cascades to displayElements.text and displayElements.html automatically.
	_focusin=function _focusin(){scope.focussed=true;element.addClass(scope.classes.focussed);_toolbars.focus();element.triggerHandler('focus');};scope.displayElements.html.on('focus',_focusin);scope.displayElements.text.on('focus',_focusin);_focusout=function _focusout(e){// if we are NOT runnig an action and have NOT focussed again on the text etc then fire the blur events
	if(!scope._actionRunning&&$document[0].activeElement!==scope.displayElements.html[0]&&$document[0].activeElement!==scope.displayElements.text[0]){element.removeClass(scope.classes.focussed);_toolbars.unfocus();// to prevent multiple apply error defer to next seems to work.
	$timeout(function(){scope._bUpdateSelectedStyles=false;element.triggerHandler('blur');scope.focussed=false;},0);}e.preventDefault();return false;};scope.displayElements.html.on('blur',_focusout);scope.displayElements.text.on('blur',_focusout);scope.displayElements.text.on('paste',function(event){element.triggerHandler('paste',event);});// Setup the default toolbar tools, this way allows the user to add new tools like plugins.
	// This is on the editor for future proofing if we find a better way to do this.
	scope.queryFormatBlockState=function(command){// $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
	return!scope.showHtml&&command.toLowerCase()===$document[0].queryCommandValue('formatBlock').toLowerCase();};scope.queryCommandState=function(command){// $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
	return!scope.showHtml?$document[0].queryCommandState(command):'';};scope.switchView=function(){scope.showHtml=!scope.showHtml;$animate.enabled(false,scope.displayElements.html);$animate.enabled(false,scope.displayElements.text);//Show the HTML view
	if(scope.showHtml){//defer until the element is visible
	$timeout(function(){$animate.enabled(true,scope.displayElements.html);$animate.enabled(true,scope.displayElements.text);// [0] dereferences the DOM object from the angular.element
	return scope.displayElements.html[0].focus();},100);}else{//Show the WYSIWYG view
	//defer until the element is visible
	$timeout(function(){$animate.enabled(true,scope.displayElements.html);$animate.enabled(true,scope.displayElements.text);// [0] dereferences the DOM object from the angular.element
	return scope.displayElements.text[0].focus();},100);}};// changes to the model variable from outside the html/text inputs
	// if no ngModel, then the only input is from inside text-angular
	if(attrs.ngModel){var _firstRun=true;ngModel.$render=function(){if(_firstRun){// we need this firstRun to set the originalContents otherwise it gets overrided by the setting of ngModel to undefined from NaN
	_firstRun=false;// if view value is null or undefined initially and there was original content, set to the original content
	var _initialValue=scope.$parent.$eval(attrs.ngModel);if((_initialValue===undefined||_initialValue===null)&&_originalContents&&_originalContents!==''){// on passing through to taBind it will be sanitised
	ngModel.$setViewValue(_originalContents);}}scope.displayElements.forminput.val(ngModel.$viewValue);// if the editors aren't focused they need to be updated, otherwise they are doing the updating
	scope.html=ngModel.$viewValue||'';};// trigger the validation calls
	if(element.attr('required'))ngModel.$validators.required=function(modelValue,viewValue){var value=modelValue||viewValue;return!(!value||value.trim()==='');};}else{// if no ngModel then update from the contents of the origional html.
	scope.displayElements.forminput.val(_originalContents);scope.html=_originalContents;}// changes from taBind back up to here
	scope.$watch('html',function(newValue,oldValue){if(newValue!==oldValue){if(attrs.ngModel&&ngModel.$viewValue!==newValue)ngModel.$setViewValue(newValue);scope.displayElements.forminput.val(newValue);}});if(attrs.taTargetToolbars)_toolbars=textAngularManager.registerEditor(scope._name,scope,attrs.taTargetToolbars.split(','));else{var _toolbar=angular.element('<div text-angular-toolbar name="textAngularToolbar'+_serial+'">');// passthrough init of toolbar options
	if(attrs.taToolbar)_toolbar.attr('ta-toolbar',attrs.taToolbar);if(attrs.taToolbarClass)_toolbar.attr('ta-toolbar-class',attrs.taToolbarClass);if(attrs.taToolbarGroupClass)_toolbar.attr('ta-toolbar-group-class',attrs.taToolbarGroupClass);if(attrs.taToolbarButtonClass)_toolbar.attr('ta-toolbar-button-class',attrs.taToolbarButtonClass);if(attrs.taToolbarActiveButtonClass)_toolbar.attr('ta-toolbar-active-button-class',attrs.taToolbarActiveButtonClass);if(attrs.taFocussedClass)_toolbar.attr('ta-focussed-class',attrs.taFocussedClass);element.prepend(_toolbar);$compile(_toolbar)(scope.$parent);_toolbars=textAngularManager.registerEditor(scope._name,scope,['textAngularToolbar'+_serial]);}scope.$on('$destroy',function(){textAngularManager.unregisterEditor(scope._name);});// catch element select event and pass to toolbar tools
	scope.$on('ta-element-select',function(event,element){if(_toolbars.triggerElementSelect(event,element)){scope['reApplyOnSelectorHandlerstaTextElement'+_serial]();}});scope.$on('ta-drop-event',function(event,element,dropEvent,dataTransfer){scope.displayElements.text[0].focus();if(dataTransfer&&dataTransfer.files&&dataTransfer.files.length>0){angular.forEach(dataTransfer.files,function(file){// taking advantage of boolean execution, if the fileDropHandler returns true, nothing else after it is executed
	// If it is false then execute the defaultFileDropHandler if the fileDropHandler is NOT the default one
	// Once one of these has been executed wrap the result as a promise, if undefined or variable update the taBind, else we should wait for the promise
	try{$q.when(scope.fileDropHandler(file,scope.wrapSelection)||scope.fileDropHandler!==scope.defaultFileDropHandler&&$q.when(scope.defaultFileDropHandler(file,scope.wrapSelection))).then(function(){scope['updateTaBindtaTextElement'+_serial]();});}catch(error){$log.error(error);}});dropEvent.preventDefault();dropEvent.stopPropagation();/* istanbul ignore else, the updates if moved text */}else{$timeout(function(){scope['updateTaBindtaTextElement'+_serial]();},0);}});// the following is for applying the active states to the tools that support it
	scope._bUpdateSelectedStyles=false;/* istanbul ignore next: browser window/tab leave check */angular.element(window).on('blur',function(){scope._bUpdateSelectedStyles=false;scope.focussed=false;});// loop through all the tools polling their activeState function if it exists
	scope.updateSelectedStyles=function(){var _selection;/* istanbul ignore next: This check is to ensure multiple timeouts don't exist */if(_updateSelectedStylesTimeout)$timeout.cancel(_updateSelectedStylesTimeout);// test if the common element ISN'T the root ta-text node
	if((_selection=taSelection.getSelectionElement())!==undefined&&_selection.parentNode!==scope.displayElements.text[0]){_toolbars.updateSelectedStyles(angular.element(_selection));}else _toolbars.updateSelectedStyles();// used to update the active state when a key is held down, ie the left arrow
	/* istanbul ignore else: browser only check */if(scope._bUpdateSelectedStyles)_updateSelectedStylesTimeout=$timeout(scope.updateSelectedStyles,200);};// start updating on keydown
	_keydown=function _keydown(){/* istanbul ignore next: ie catch */if(!scope.focussed){scope._bUpdateSelectedStyles=false;return;}/* istanbul ignore else: don't run if already running */if(!scope._bUpdateSelectedStyles){scope._bUpdateSelectedStyles=true;scope.$apply(function(){scope.updateSelectedStyles();});}};scope.displayElements.html.on('keydown',_keydown);scope.displayElements.text.on('keydown',_keydown);// stop updating on key up and update the display/model
	_keyup=function _keyup(){scope._bUpdateSelectedStyles=false;};scope.displayElements.html.on('keyup',_keyup);scope.displayElements.text.on('keyup',_keyup);// stop updating on key up and update the display/model
	_keypress=function _keypress(event,eventData){/* istanbul ignore else: this is for catching the jqLite testing*/if(eventData)angular.extend(event,eventData);scope.$apply(function(){if(_toolbars.sendKeyCommand(event)){/* istanbul ignore else: don't run if already running */if(!scope._bUpdateSelectedStyles){scope.updateSelectedStyles();}event.preventDefault();return false;}});};scope.displayElements.html.on('keypress',_keypress);scope.displayElements.text.on('keypress',_keypress);// update the toolbar active states when we click somewhere in the text/html boxed
	_mouseup=function _mouseup(){// ensure only one execution of updateSelectedStyles()
	scope._bUpdateSelectedStyles=false;scope.$apply(function(){scope.updateSelectedStyles();});};scope.displayElements.html.on('mouseup',_mouseup);scope.displayElements.text.on('mouseup',_mouseup);}};}]);textAngular.service('textAngularManager',['taToolExecuteAction','taTools','taRegisterTool',function(taToolExecuteAction,taTools,taRegisterTool){// this service is used to manage all textAngular editors and toolbars.
	// All publicly published functions that modify/need to access the toolbar or editor scopes should be in here
	// these contain references to all the editors and toolbars that have been initialised in this app
	var toolbars={},editors={};// when we focus into a toolbar, we need to set the TOOLBAR's $parent to be the toolbars it's linked to.
	// We also need to set the tools to be updated to be the toolbars...
	return{// register an editor and the toolbars that it is affected by
	registerEditor:function registerEditor(name,scope,targetToolbars){// targetToolbars are optional, we don't require a toolbar to function
	if(!name||name==='')throw'textAngular Error: An editor requires a name';if(!scope)throw'textAngular Error: An editor requires a scope';if(editors[name])throw'textAngular Error: An Editor with name "'+name+'" already exists';// _toolbars is an ARRAY of toolbar scopes
	var _toolbars=[];angular.forEach(targetToolbars,function(_name){if(toolbars[_name])_toolbars.push(toolbars[_name]);// if it doesn't exist it may not have been compiled yet and it will be added later
	});editors[name]={scope:scope,toolbars:targetToolbars,_registerToolbar:function _registerToolbar(toolbarScope){// add to the list late
	if(this.toolbars.indexOf(toolbarScope.name)>=0)_toolbars.push(toolbarScope);},// this is a suite of functions the editor should use to update all it's linked toolbars
	editorFunctions:{disable:function disable(){// disable all linked toolbars
	angular.forEach(_toolbars,function(toolbarScope){toolbarScope.disabled=true;});},enable:function enable(){// enable all linked toolbars
	angular.forEach(_toolbars,function(toolbarScope){toolbarScope.disabled=false;});},focus:function focus(){// this should be called when the editor is focussed
	angular.forEach(_toolbars,function(toolbarScope){toolbarScope._parent=scope;toolbarScope.disabled=false;toolbarScope.focussed=true;scope.focussed=true;});},unfocus:function unfocus(){// this should be called when the editor becomes unfocussed
	angular.forEach(_toolbars,function(toolbarScope){toolbarScope.disabled=true;toolbarScope.focussed=false;});scope.focussed=false;},updateSelectedStyles:function updateSelectedStyles(selectedElement){// update the active state of all buttons on liked toolbars
	angular.forEach(_toolbars,function(toolbarScope){angular.forEach(toolbarScope.tools,function(toolScope){if(toolScope.activeState){toolbarScope._parent=scope;toolScope.active=toolScope.activeState(selectedElement);}});});},sendKeyCommand:function sendKeyCommand(event){// we return true if we applied an action, false otherwise
	var result=false;if(event.ctrlKey||event.metaKey||event.specialKey)angular.forEach(taTools,function(tool,name){if(tool.commandKeyCode&&(tool.commandKeyCode===event.which||tool.commandKeyCode===event.specialKey)){for(var _t=0;_t<_toolbars.length;_t++){if(_toolbars[_t].tools[name]!==undefined){taToolExecuteAction.call(_toolbars[_t].tools[name],scope);result=true;break;}}}});return result;},triggerElementSelect:function triggerElementSelect(event,element){// search through the taTools to see if a match for the tag is made.
	// if there is, see if the tool is on a registered toolbar and not disabled.
	// NOTE: This can trigger on MULTIPLE tools simultaneously.
	var elementHasAttrs=function elementHasAttrs(_element,attrs){var result=true;for(var i=0;i<attrs.length;i++){result=result&&_element.attr(attrs[i]);}return result;};var workerTools=[];var unfilteredTools={};var result=false;element=angular.element(element);// get all valid tools by element name, keep track if one matches the
	var onlyWithAttrsFilter=false;angular.forEach(taTools,function(tool,name){if(tool.onElementSelect&&tool.onElementSelect.element&&tool.onElementSelect.element.toLowerCase()===element[0].tagName.toLowerCase()&&(!tool.onElementSelect.filter||tool.onElementSelect.filter(element))){// this should only end up true if the element matches the only attributes
	onlyWithAttrsFilter=onlyWithAttrsFilter||angular.isArray(tool.onElementSelect.onlyWithAttrs)&&elementHasAttrs(element,tool.onElementSelect.onlyWithAttrs);if(!tool.onElementSelect.onlyWithAttrs||elementHasAttrs(element,tool.onElementSelect.onlyWithAttrs))unfilteredTools[name]=tool;}});// if we matched attributes to filter on, then filter, else continue
	if(onlyWithAttrsFilter){angular.forEach(unfilteredTools,function(tool,name){if(tool.onElementSelect.onlyWithAttrs&&elementHasAttrs(element,tool.onElementSelect.onlyWithAttrs))workerTools.push({'name':name,'tool':tool});});// sort most specific (most attrs to find) first
	workerTools.sort(function(a,b){return b.tool.onElementSelect.onlyWithAttrs.length-a.tool.onElementSelect.onlyWithAttrs.length;});}else{angular.forEach(unfilteredTools,function(tool,name){workerTools.push({'name':name,'tool':tool});});}// Run the actions on the first visible filtered tool only
	if(workerTools.length>0){for(var _i=0;_i<workerTools.length;_i++){var tool=workerTools[_i].tool;var name=workerTools[_i].name;for(var _t=0;_t<_toolbars.length;_t++){if(_toolbars[_t].tools[name]!==undefined){tool.onElementSelect.action.call(_toolbars[_t].tools[name],event,element,scope);result=true;break;}}if(result)break;}}return result;}}};return editors[name].editorFunctions;},// retrieve editor by name, largely used by testing suites only
	retrieveEditor:function retrieveEditor(name){return editors[name];},unregisterEditor:function unregisterEditor(name){delete editors[name];},// registers a toolbar such that it can be linked to editors
	registerToolbar:function registerToolbar(scope){if(!scope)throw'textAngular Error: A toolbar requires a scope';if(!scope.name||scope.name==='')throw'textAngular Error: A toolbar requires a name';if(toolbars[scope.name])throw'textAngular Error: A toolbar with name "'+scope.name+'" already exists';toolbars[scope.name]=scope;angular.forEach(editors,function(_editor){_editor._registerToolbar(scope);});},// retrieve toolbar by name, largely used by testing suites only
	retrieveToolbar:function retrieveToolbar(name){return toolbars[name];},// retrieve toolbars by editor name, largely used by testing suites only
	retrieveToolbarsViaEditor:function retrieveToolbarsViaEditor(name){var result=[],_this=this;angular.forEach(this.retrieveEditor(name).toolbars,function(name){result.push(_this.retrieveToolbar(name));});return result;},unregisterToolbar:function unregisterToolbar(name){delete toolbars[name];},// functions for updating the toolbar buttons display
	updateToolsDisplay:function updateToolsDisplay(newTaTools){// pass a partial struct of the taTools, this allows us to update the tools on the fly, will not change the defaults.
	var _this=this;angular.forEach(newTaTools,function(_newTool,key){_this.updateToolDisplay(key,_newTool);});},// this function resets all toolbars to their default tool definitions
	resetToolsDisplay:function resetToolsDisplay(){var _this=this;angular.forEach(taTools,function(_newTool,key){_this.resetToolDisplay(key);});},// update a tool on all toolbars
	updateToolDisplay:function updateToolDisplay(toolKey,_newTool){var _this=this;angular.forEach(toolbars,function(toolbarScope,toolbarKey){_this.updateToolbarToolDisplay(toolbarKey,toolKey,_newTool);});},// resets a tool to the default/starting state on all toolbars
	resetToolDisplay:function resetToolDisplay(toolKey){var _this=this;angular.forEach(toolbars,function(toolbarScope,toolbarKey){_this.resetToolbarToolDisplay(toolbarKey,toolKey);});},// update a tool on a specific toolbar
	updateToolbarToolDisplay:function updateToolbarToolDisplay(toolbarKey,toolKey,_newTool){if(toolbars[toolbarKey])toolbars[toolbarKey].updateToolDisplay(toolKey,_newTool);else throw'textAngular Error: No Toolbar with name "'+toolbarKey+'" exists';},// reset a tool on a specific toolbar to it's default starting value
	resetToolbarToolDisplay:function resetToolbarToolDisplay(toolbarKey,toolKey){if(toolbars[toolbarKey])toolbars[toolbarKey].updateToolDisplay(toolKey,taTools[toolKey],true);else throw'textAngular Error: No Toolbar with name "'+toolbarKey+'" exists';},// removes a tool from all toolbars and it's definition
	removeTool:function removeTool(toolKey){delete taTools[toolKey];angular.forEach(toolbars,function(toolbarScope){delete toolbarScope.tools[toolKey];for(var i=0;i<toolbarScope.toolbar.length;i++){var toolbarIndex;for(var j=0;j<toolbarScope.toolbar[i].length;j++){if(toolbarScope.toolbar[i][j]===toolKey){toolbarIndex={group:i,index:j};break;}if(toolbarIndex!==undefined)break;}if(toolbarIndex!==undefined){toolbarScope.toolbar[toolbarIndex.group].slice(toolbarIndex.index,1);toolbarScope._$element.children().eq(toolbarIndex.group).children().eq(toolbarIndex.index).remove();}}});},// toolkey, toolDefinition are required. If group is not specified will pick the last group, if index isnt defined will append to group
	addTool:function addTool(toolKey,toolDefinition,group,index){taRegisterTool(toolKey,toolDefinition);angular.forEach(toolbars,function(toolbarScope){toolbarScope.addTool(toolKey,toolDefinition,group,index);});},// adds a Tool but only to one toolbar not all
	addToolToToolbar:function addToolToToolbar(toolKey,toolDefinition,toolbarKey,group,index){taRegisterTool(toolKey,toolDefinition);toolbars[toolbarKey].addTool(toolKey,toolDefinition,group,index);},// this is used when externally the html of an editor has been changed and textAngular needs to be notified to update the model.
	// this will call a $digest if not already happening
	refreshEditor:function refreshEditor(name){if(editors[name]){editors[name].scope.updateTaBindtaTextElement();/* istanbul ignore else: phase catch */if(!editors[name].scope.$$phase)editors[name].scope.$digest();}else throw'textAngular Error: No Editor with name "'+name+'" exists';},// this is used by taBind to send a key command in response to a special key event
	sendKeyCommand:function sendKeyCommand(scope,event){angular.forEach(editors,function(_editor){/* istanbul ignore else: if nothing to do, do nothing */if(_editor.editorFunctions.sendKeyCommand(event)){/* istanbul ignore else: don't run if already running */if(!scope._bUpdateSelectedStyles){scope.updateSelectedStyles();}event.preventDefault();return false;}});}};}]);textAngular.directive('textAngularToolbar',['$compile','textAngularManager','taOptions','taTools','taToolExecuteAction','$window',function($compile,textAngularManager,taOptions,taTools,taToolExecuteAction,$window){return{scope:{name:'@'// a name IS required
	},restrict:"EA",link:function link(scope,element,attrs){if(!scope.name||scope.name==='')throw'textAngular Error: A toolbar requires a name';angular.extend(scope,angular.copy(taOptions));if(attrs.taToolbar)scope.toolbar=scope.$parent.$eval(attrs.taToolbar);if(attrs.taToolbarClass)scope.classes.toolbar=attrs.taToolbarClass;if(attrs.taToolbarGroupClass)scope.classes.toolbarGroup=attrs.taToolbarGroupClass;if(attrs.taToolbarButtonClass)scope.classes.toolbarButton=attrs.taToolbarButtonClass;if(attrs.taToolbarActiveButtonClass)scope.classes.toolbarButtonActive=attrs.taToolbarActiveButtonClass;if(attrs.taFocussedClass)scope.classes.focussed=attrs.taFocussedClass;scope.disabled=true;scope.focussed=false;scope._$element=element;element[0].innerHTML='';element.addClass("ta-toolbar "+scope.classes.toolbar);scope.$watch('focussed',function(){if(scope.focussed)element.addClass(scope.classes.focussed);else element.removeClass(scope.classes.focussed);});var setupToolElement=function setupToolElement(toolDefinition,toolScope){var toolElement;if(toolDefinition&&toolDefinition.display){toolElement=angular.element(toolDefinition.display);}else toolElement=angular.element("<button type='button'>");if(toolDefinition&&toolDefinition["class"])toolElement.addClass(toolDefinition["class"]);else toolElement.addClass(scope.classes.toolbarButton);toolElement.attr('name',toolScope.name);// important to not take focus from the main text/html entry
	toolElement.attr('ta-button','ta-button');toolElement.attr('ng-disabled','isDisabled()');toolElement.attr('tabindex','-1');toolElement.attr('ng-click','executeAction()');toolElement.attr('ng-class','displayActiveToolClass(active)');if(toolDefinition&&toolDefinition.tooltiptext){toolElement.attr('title',toolDefinition.tooltiptext);}if(toolDefinition&&!toolDefinition.display&&!toolScope._display){// first clear out the current contents if any
	toolElement[0].innerHTML='';// add the buttonText
	if(toolDefinition.buttontext)toolElement[0].innerHTML=toolDefinition.buttontext;// add the icon to the front of the button if there is content
	if(toolDefinition.iconclass){var icon=angular.element('<i>'),content=toolElement[0].innerHTML;icon.addClass(toolDefinition.iconclass);toolElement[0].innerHTML='';toolElement.append(icon);if(content&&content!=='')toolElement.append('&nbsp;'+content);}}toolScope._lastToolDefinition=angular.copy(toolDefinition);return $compile(toolElement)(toolScope);};// Keep a reference for updating the active states later
	scope.tools={};// create the tools in the toolbar
	// default functions and values to prevent errors in testing and on init
	scope._parent={disabled:true,showHtml:false,queryFormatBlockState:function queryFormatBlockState(){return false;},queryCommandState:function queryCommandState(){return false;}};var defaultChildScope={$window:$window,$editor:function $editor(){// dynamically gets the editor as it is set
	return scope._parent;},isDisabled:function isDisabled(){// to set your own disabled logic set a function or boolean on the tool called 'disabled'
	return(// this bracket is important as without it it just returns the first bracket and ignores the rest
	// when the button's disabled function/value evaluates to true
	typeof this.$eval('disabled')!=='function'&&this.$eval('disabled')||this.$eval('disabled()')||// all buttons except the HTML Switch button should be disabled in the showHtml (RAW html) mode
	this.name!=='html'&&this.$editor().showHtml||// if the toolbar is disabled
	this.$parent.disabled||// if the current editor is disabled
	this.$editor().disabled);},displayActiveToolClass:function displayActiveToolClass(active){return active?scope.classes.toolbarButtonActive:'';},executeAction:taToolExecuteAction};angular.forEach(scope.toolbar,function(group){// setup the toolbar group
	var groupElement=angular.element("<div>");groupElement.addClass(scope.classes.toolbarGroup);angular.forEach(group,function(tool){// init and add the tools to the group
	// a tool name (key name from taTools struct)
	//creates a child scope of the main angularText scope and then extends the childScope with the functions of this particular tool
	// reference to the scope and element kept
	scope.tools[tool]=angular.extend(scope.$new(true),taTools[tool],defaultChildScope,{name:tool});scope.tools[tool].$element=setupToolElement(taTools[tool],scope.tools[tool]);// append the tool compiled with the childScope to the group element
	groupElement.append(scope.tools[tool].$element);});// append the group to the toolbar
	element.append(groupElement);});// update a tool
	// if a value is set to null, remove from the display
	// when forceNew is set to true it will ignore all previous settings, used to reset to taTools definition
	// to reset to defaults pass in taTools[key] as _newTool and forceNew as true, ie `updateToolDisplay(key, taTools[key], true);`
	scope.updateToolDisplay=function(key,_newTool,forceNew){var toolInstance=scope.tools[key];if(toolInstance){// get the last toolDefinition, then override with the new definition
	if(toolInstance._lastToolDefinition&&!forceNew)_newTool=angular.extend({},toolInstance._lastToolDefinition,_newTool);if(_newTool.buttontext===null&&_newTool.iconclass===null&&_newTool.display===null)throw'textAngular Error: Tool Definition for updating "'+key+'" does not have a valid display/iconclass/buttontext value';// if tool is defined on this toolbar, update/redo the tool
	if(_newTool.buttontext===null){delete _newTool.buttontext;}if(_newTool.iconclass===null){delete _newTool.iconclass;}if(_newTool.display===null){delete _newTool.display;}var toolElement=setupToolElement(_newTool,toolInstance);toolInstance.$element.replaceWith(toolElement);toolInstance.$element=toolElement;}};// we assume here that all values passed are valid and correct
	scope.addTool=function(key,_newTool,groupIndex,index){scope.tools[key]=angular.extend(scope.$new(true),taTools[key],defaultChildScope,{name:key});scope.tools[key].$element=setupToolElement(taTools[key],scope.tools[key]);var group;if(groupIndex===undefined)groupIndex=scope.toolbar.length-1;group=angular.element(element.children()[groupIndex]);if(index===undefined){group.append(scope.tools[key].$element);scope.toolbar[groupIndex][scope.toolbar[groupIndex].length-1]=key;}else{group.children().eq(index).after(scope.tools[key].$element);scope.toolbar[groupIndex][index]=key;}};textAngularManager.registerToolbar(scope);scope.$on('$destroy',function(){textAngularManager.unregisterToolbar(scope.name);});}};}]);})();

/***/ },
/* 341 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	@license textAngular
	Author : Austin Anderson
	License : 2013 MIT
	Version 1.3.7
	
	See README.md or https://github.com/fraywing/textAngular/wiki for requirements and use.
	*/
	
	angular.module('textAngularSetup', [])
	// Here we set up the global display defaults, to set your own use a angular $provider#decorator.
	.value('taOptions', {
		//////////////////////////////////////////////////////////////////////////////////////
		// forceTextAngularSanitize
		// set false to allow the textAngular-sanitize provider to be replaced
		// with angular-sanitize or a custom provider.
		forceTextAngularSanitize: true,
		///////////////////////////////////////////////////////////////////////////////////////
		// keyMappings
		// allow customizable keyMappings for specialized key boards or languages
		//
		// keyMappings provides key mappings that are attached to a given commandKeyCode.
		// To modify a specific keyboard binding, simply provide function which returns true
		// for the event you wish to map to.
		// Or to disable a specific keyboard binding, provide a function which returns false.
		// Note: 'RedoKey' and 'UndoKey' are internally bound to the redo and undo functionality.
		// At present, the following commandKeyCodes are in use:
		// 98, 'TabKey', 'ShiftTabKey', 105, 117, 'UndoKey', 'RedoKey'
		//
		// To map to an new commandKeyCode, add a new key mapping such as:
		// {commandKeyCode: 'CustomKey', testForKey: function (event) {
		//  if (event.keyCode=57 && event.ctrlKey && !event.shiftKey && !event.altKey) return true;
		// } }
		// to the keyMappings. This example maps ctrl+9 to 'CustomKey'
		// Then where taRegisterTool(...) is called, add a commandKeyCode: 'CustomKey' and your
		// tool will be bound to ctrl+9.
		//
		// To disble one of the already bound commandKeyCodes such as 'RedoKey' or 'UndoKey' add:
		// {commandKeyCode: 'RedoKey', testForKey: function (event) { return false; } },
		// {commandKeyCode: 'UndoKey', testForKey: function (event) { return false; } },
		// to disable them.
		//
		keyMappings: [],
		toolbar: [['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'], ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'], ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'], ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']],
		classes: {
			focussed: "focussed",
			toolbar: "btn-toolbar",
			toolbarGroup: "btn-group",
			toolbarButton: "btn btn-default",
			toolbarButtonActive: "active",
			disabled: "disabled",
			textEditor: 'form-control',
			htmlEditor: 'form-control'
		},
		defaultTagAttributes: {
			a: { target: "" }
		},
		setup: {
			// wysiwyg mode
			textEditorSetup: function textEditorSetup($element) {/* Do some processing here */},
			// raw html
			htmlEditorSetup: function htmlEditorSetup($element) {/* Do some processing here */}
		},
		defaultFileDropHandler:
		/* istanbul ignore next: untestable image processing */
		function defaultFileDropHandler(file, insertAction) {
			var reader = new FileReader();
			if (file.type.substring(0, 5) === 'image') {
				reader.onload = function () {
					if (reader.result !== '') insertAction('insertImage', reader.result, true);
				};
	
				reader.readAsDataURL(file);
				// NOTE: For async procedures return a promise and resolve it when the editor should update the model.
				return true;
			}
			return false;
		}
	})
	
	// This is the element selector string that is used to catch click events within a taBind, prevents the default and $emits a 'ta-element-select' event
	// these are individually used in an angular.element().find() call. What can go here depends on whether you have full jQuery loaded or just jQLite with angularjs.
	// div is only used as div.ta-insert-video caught in filter.
	.value('taSelectableElements', ['a', 'img'])
	
	// This is an array of objects with the following options:
	//				selector: <string> a jqLite or jQuery selector string
	//				customAttribute: <string> an attribute to search for
	//				renderLogic: <function(element)>
	// Both or one of selector and customAttribute must be defined.
	.value('taCustomRenderers', [{
		// Parse back out: '<div class="ta-insert-video" ta-insert-video src="' + urlLink + '" allowfullscreen="true" width="300" frameborder="0" height="250"></div>'
		// To correct video element. For now only support youtube
		selector: 'img',
		customAttribute: 'ta-insert-video',
		renderLogic: function renderLogic(element) {
			var iframe = angular.element('<iframe></iframe>');
			var attributes = element.prop("attributes");
			// loop through element attributes and apply them on iframe
			angular.forEach(attributes, function (attr) {
				iframe.attr(attr.name, attr.value);
			});
			iframe.attr('src', iframe.attr('ta-insert-video'));
			element.replaceWith(iframe);
		}
	}]).value('taTranslations', {
		// moved to sub-elements
		//toggleHTML: "Toggle HTML",
		//insertImage: "Please enter a image URL to insert",
		//insertLink: "Please enter a URL to insert",
		//insertVideo: "Please enter a youtube URL to embed",
		html: {
			tooltip: 'Toggle html / Rich Text'
		},
		// tooltip for heading - might be worth splitting
		heading: {
			tooltip: 'Heading '
		},
		p: {
			tooltip: 'Paragraph'
		},
		pre: {
			tooltip: 'Preformatted text'
		},
		ul: {
			tooltip: 'Unordered List'
		},
		ol: {
			tooltip: 'Ordered List'
		},
		quote: {
			tooltip: 'Quote/unquote selection or paragraph'
		},
		undo: {
			tooltip: 'Undo'
		},
		redo: {
			tooltip: 'Redo'
		},
		bold: {
			tooltip: 'Bold'
		},
		italic: {
			tooltip: 'Italic'
		},
		underline: {
			tooltip: 'Underline'
		},
		strikeThrough: {
			tooltip: 'Strikethrough'
		},
		justifyLeft: {
			tooltip: 'Align text left'
		},
		justifyRight: {
			tooltip: 'Align text right'
		},
		justifyFull: {
			tooltip: 'Justify text'
		},
		justifyCenter: {
			tooltip: 'Center'
		},
		indent: {
			tooltip: 'Increase indent'
		},
		outdent: {
			tooltip: 'Decrease indent'
		},
		clear: {
			tooltip: 'Clear formatting'
		},
		insertImage: {
			dialogPrompt: 'Please enter an image URL to insert',
			tooltip: 'Insert image',
			hotkey: 'the - possibly language dependent hotkey ... for some future implementation'
		},
		insertVideo: {
			tooltip: 'Insert video',
			dialogPrompt: 'Please enter a youtube URL to embed'
		},
		insertLink: {
			tooltip: 'Insert / edit link',
			dialogPrompt: "Please enter a URL to insert"
		},
		editLink: {
			reLinkButton: {
				tooltip: "Relink"
			},
			unLinkButton: {
				tooltip: "Unlink"
			},
			targetToggle: {
				buttontext: "Open in New Window"
			}
		},
		wordcount: {
			tooltip: 'Display words Count'
		},
		charcount: {
			tooltip: 'Display characters Count'
		}
	}).factory('taToolFunctions', ['$window', 'taTranslations', function ($window, taTranslations) {
		return {
			imgOnSelectAction: function imgOnSelectAction(event, $element, editorScope) {
				// setup the editor toolbar
				// Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic/display
				var finishEdit = function finishEdit() {
					editorScope.updateTaBindtaTextElement();
					editorScope.hidePopover();
				};
				event.preventDefault();
				editorScope.displayElements.popover.css('width', '375px');
				var container = editorScope.displayElements.popoverContainer;
				container.empty();
				var buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
				var fullButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">100% </button>');
				fullButton.on('click', function (event) {
					event.preventDefault();
					$element.css({
						'width': '100%',
						'height': ''
					});
					finishEdit();
				});
				var halfButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">50% </button>');
				halfButton.on('click', function (event) {
					event.preventDefault();
					$element.css({
						'width': '50%',
						'height': ''
					});
					finishEdit();
				});
				var quartButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">25% </button>');
				quartButton.on('click', function (event) {
					event.preventDefault();
					$element.css({
						'width': '25%',
						'height': ''
					});
					finishEdit();
				});
				var resetButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">Reset</button>');
				resetButton.on('click', function (event) {
					event.preventDefault();
					$element.css({
						width: '',
						height: ''
					});
					finishEdit();
				});
				buttonGroup.append(fullButton);
				buttonGroup.append(halfButton);
				buttonGroup.append(quartButton);
				buttonGroup.append(resetButton);
				container.append(buttonGroup);
	
				buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
				var floatLeft = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-left"></i></button>');
				floatLeft.on('click', function (event) {
					event.preventDefault();
					// webkit
					$element.css('float', 'left');
					// firefox
					$element.css('cssFloat', 'left');
					// IE < 8
					$element.css('styleFloat', 'left');
					finishEdit();
				});
				var floatRight = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-right"></i></button>');
				floatRight.on('click', function (event) {
					event.preventDefault();
					// webkit
					$element.css('float', 'right');
					// firefox
					$element.css('cssFloat', 'right');
					// IE < 8
					$element.css('styleFloat', 'right');
					finishEdit();
				});
				var floatNone = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-justify"></i></button>');
				floatNone.on('click', function (event) {
					event.preventDefault();
					// webkit
					$element.css('float', '');
					// firefox
					$element.css('cssFloat', '');
					// IE < 8
					$element.css('styleFloat', '');
					finishEdit();
				});
				buttonGroup.append(floatLeft);
				buttonGroup.append(floatNone);
				buttonGroup.append(floatRight);
				container.append(buttonGroup);
	
				buttonGroup = angular.element('<div class="btn-group">');
				var remove = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-trash-o"></i></button>');
				remove.on('click', function (event) {
					event.preventDefault();
					$element.remove();
					finishEdit();
				});
				buttonGroup.append(remove);
				container.append(buttonGroup);
	
				editorScope.showPopover($element);
				editorScope.showResizeOverlay($element);
			},
			aOnSelectAction: function aOnSelectAction(event, $element, editorScope) {
				// setup the editor toolbar
				// Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic
				event.preventDefault();
				editorScope.displayElements.popover.css('width', '436px');
				var container = editorScope.displayElements.popoverContainer;
				container.empty();
				container.css('line-height', '28px');
				var link = angular.element('<a href="' + $element.attr('href') + '" target="_blank">' + $element.attr('href') + '</a>');
				link.css({
					'display': 'inline-block',
					'max-width': '200px',
					'overflow': 'hidden',
					'text-overflow': 'ellipsis',
					'white-space': 'nowrap',
					'vertical-align': 'middle'
				});
				container.append(link);
				var buttonGroup = angular.element('<div class="btn-group pull-right">');
				var reLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.reLinkButton.tooltip + '"><i class="fa fa-edit icon-edit"></i></button>');
				reLinkButton.on('click', function (event) {
					event.preventDefault();
					var urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, $element.attr('href'));
					if (urlLink && urlLink !== '' && urlLink !== 'http://') {
						$element.attr('href', urlLink);
						editorScope.updateTaBindtaTextElement();
					}
					editorScope.hidePopover();
				});
				buttonGroup.append(reLinkButton);
				var unLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.unLinkButton.tooltip + '"><i class="fa fa-unlink icon-unlink"></i></button>');
				// directly before this click event is fired a digest is fired off whereby the reference to $element is orphaned off
				unLinkButton.on('click', function (event) {
					event.preventDefault();
					$element.replaceWith($element.contents());
					editorScope.updateTaBindtaTextElement();
					editorScope.hidePopover();
				});
				buttonGroup.append(unLinkButton);
				var targetToggle = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on">' + taTranslations.editLink.targetToggle.buttontext + '</button>');
				if ($element.attr('target') === '_blank') {
					targetToggle.addClass('active');
				}
				targetToggle.on('click', function (event) {
					event.preventDefault();
					$element.attr('target', $element.attr('target') === '_blank' ? '' : '_blank');
					targetToggle.toggleClass('active');
					editorScope.updateTaBindtaTextElement();
				});
				buttonGroup.append(targetToggle);
				container.append(buttonGroup);
				editorScope.showPopover($element);
			},
			extractYoutubeVideoId: function extractYoutubeVideoId(url) {
				var re = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
				var match = url.match(re);
				return match && match[1] || null;
			}
		};
	}]).run(['taRegisterTool', '$window', 'taTranslations', 'taSelection', 'taToolFunctions', '$sanitize', 'taOptions', function (taRegisterTool, $window, taTranslations, taSelection, taToolFunctions, $sanitize, taOptions) {
		// test for the version of $sanitize that is in use
		// You can disable this check by setting taOptions.textAngularSanitize == false
		var gv = {};$sanitize('', gv);
		/* istanbul ignore next, throws error */
		if (taOptions.forceTextAngularSanitize === true && gv.version !== 'taSanitize') {
			throw angular.$$minErr('textAngular')("textAngularSetup", "The textAngular-sanitize provider has been replaced by another -- have you included angular-sanitize by mistake?");
		}
		taRegisterTool("html", {
			iconclass: 'fa fa-code',
			tooltiptext: taTranslations.html.tooltip,
			action: function action() {
				this.$editor().switchView();
			},
			activeState: function activeState() {
				return this.$editor().showHtml;
			}
		});
		// add the Header tools
		// convenience functions so that the loop works correctly
		var _retActiveStateFunction = function _retActiveStateFunction(q) {
			return function () {
				return this.$editor().queryFormatBlockState(q);
			};
		};
		var headerAction = function headerAction() {
			return this.$editor().wrapSelection("formatBlock", "<" + this.name.toUpperCase() + ">");
		};
		angular.forEach(['h1', 'h2', 'h3', 'h4', 'h5', 'h6'], function (h) {
			taRegisterTool(h.toLowerCase(), {
				buttontext: h.toUpperCase(),
				tooltiptext: taTranslations.heading.tooltip + h.charAt(1),
				action: headerAction,
				activeState: _retActiveStateFunction(h.toLowerCase())
			});
		});
		taRegisterTool('p', {
			buttontext: 'P',
			tooltiptext: taTranslations.p.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("formatBlock", "<P>");
			},
			activeState: function activeState() {
				return this.$editor().queryFormatBlockState('p');
			}
		});
		// key: pre -> taTranslations[key].tooltip, taTranslations[key].buttontext
		taRegisterTool('pre', {
			buttontext: 'pre',
			tooltiptext: taTranslations.pre.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("formatBlock", "<PRE>");
			},
			activeState: function activeState() {
				return this.$editor().queryFormatBlockState('pre');
			}
		});
		taRegisterTool('ul', {
			iconclass: 'fa fa-list-ul',
			tooltiptext: taTranslations.ul.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("insertUnorderedList", null);
			},
			activeState: function activeState() {
				return this.$editor().queryCommandState('insertUnorderedList');
			}
		});
		taRegisterTool('ol', {
			iconclass: 'fa fa-list-ol',
			tooltiptext: taTranslations.ol.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("insertOrderedList", null);
			},
			activeState: function activeState() {
				return this.$editor().queryCommandState('insertOrderedList');
			}
		});
		taRegisterTool('quote', {
			iconclass: 'fa fa-quote-right',
			tooltiptext: taTranslations.quote.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("formatBlock", "<BLOCKQUOTE>");
			},
			activeState: function activeState() {
				return this.$editor().queryFormatBlockState('blockquote');
			}
		});
		taRegisterTool('undo', {
			iconclass: 'fa fa-undo',
			tooltiptext: taTranslations.undo.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("undo", null);
			}
		});
		taRegisterTool('redo', {
			iconclass: 'fa fa-repeat',
			tooltiptext: taTranslations.redo.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("redo", null);
			}
		});
		taRegisterTool('bold', {
			iconclass: 'fa fa-bold',
			tooltiptext: taTranslations.bold.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("bold", null);
			},
			activeState: function activeState() {
				return this.$editor().queryCommandState('bold');
			},
			commandKeyCode: 98
		});
		taRegisterTool('justifyLeft', {
			iconclass: 'fa fa-align-left',
			tooltiptext: taTranslations.justifyLeft.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("justifyLeft", null);
			},
			activeState: function activeState(commonElement) {
				/* istanbul ignore next: */
				if (commonElement && commonElement.nodeName === '#document') return false;
				var result = false;
				if (commonElement) result = commonElement.css('text-align') === 'left' || commonElement.attr('align') === 'left' || commonElement.css('text-align') !== 'right' && commonElement.css('text-align') !== 'center' && commonElement.css('text-align') !== 'justify' && !this.$editor().queryCommandState('justifyRight') && !this.$editor().queryCommandState('justifyCenter') && !this.$editor().queryCommandState('justifyFull');
				result = result || this.$editor().queryCommandState('justifyLeft');
				return result;
			}
		});
		taRegisterTool('justifyRight', {
			iconclass: 'fa fa-align-right',
			tooltiptext: taTranslations.justifyRight.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("justifyRight", null);
			},
			activeState: function activeState(commonElement) {
				/* istanbul ignore next: */
				if (commonElement && commonElement.nodeName === '#document') return false;
				var result = false;
				if (commonElement) result = commonElement.css('text-align') === 'right';
				result = result || this.$editor().queryCommandState('justifyRight');
				return result;
			}
		});
		taRegisterTool('justifyFull', {
			iconclass: 'fa fa-align-justify',
			tooltiptext: taTranslations.justifyFull.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("justifyFull", null);
			},
			activeState: function activeState(commonElement) {
				var result = false;
				if (commonElement) result = commonElement.css('text-align') === 'justify';
				result = result || this.$editor().queryCommandState('justifyFull');
				return result;
			}
		});
		taRegisterTool('justifyCenter', {
			iconclass: 'fa fa-align-center',
			tooltiptext: taTranslations.justifyCenter.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("justifyCenter", null);
			},
			activeState: function activeState(commonElement) {
				/* istanbul ignore next: */
				if (commonElement && commonElement.nodeName === '#document') return false;
				var result = false;
				if (commonElement) result = commonElement.css('text-align') === 'center';
				result = result || this.$editor().queryCommandState('justifyCenter');
				return result;
			}
		});
		taRegisterTool('indent', {
			iconclass: 'fa fa-indent',
			tooltiptext: taTranslations.indent.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("indent", null);
			},
			activeState: function activeState() {
				return this.$editor().queryFormatBlockState('blockquote');
			},
			commandKeyCode: 'TabKey'
		});
		taRegisterTool('outdent', {
			iconclass: 'fa fa-outdent',
			tooltiptext: taTranslations.outdent.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("outdent", null);
			},
			activeState: function activeState() {
				return false;
			},
			commandKeyCode: 'ShiftTabKey'
		});
		taRegisterTool('italics', {
			iconclass: 'fa fa-italic',
			tooltiptext: taTranslations.italic.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("italic", null);
			},
			activeState: function activeState() {
				return this.$editor().queryCommandState('italic');
			},
			commandKeyCode: 105
		});
		taRegisterTool('underline', {
			iconclass: 'fa fa-underline',
			tooltiptext: taTranslations.underline.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("underline", null);
			},
			activeState: function activeState() {
				return this.$editor().queryCommandState('underline');
			},
			commandKeyCode: 117
		});
		taRegisterTool('strikeThrough', {
			iconclass: 'fa fa-strikethrough',
			tooltiptext: taTranslations.strikeThrough.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("strikeThrough", null);
			},
			activeState: function activeState() {
				return document.queryCommandState('strikeThrough');
			}
		});
		taRegisterTool('clear', {
			iconclass: 'fa fa-ban',
			tooltiptext: taTranslations.clear.tooltip,
			action: function action(deferred, restoreSelection) {
				var i;
				this.$editor().wrapSelection("removeFormat", null);
				var possibleNodes = angular.element(taSelection.getSelectionElement());
				// remove lists
				var removeListElements = function removeListElements(list) {
					list = angular.element(list);
					var prevElement = list;
					angular.forEach(list.children(), function (liElem) {
						var newElem = angular.element('<p></p>');
						newElem.html(angular.element(liElem).html());
						prevElement.after(newElem);
						prevElement = newElem;
					});
					list.remove();
				};
				angular.forEach(possibleNodes.find("ul"), removeListElements);
				angular.forEach(possibleNodes.find("ol"), removeListElements);
				if (possibleNodes[0].tagName.toLowerCase() === 'li') {
					var _list = possibleNodes[0].parentNode.childNodes;
					var _preLis = [],
					    _postLis = [],
					    _found = false;
					for (i = 0; i < _list.length; i++) {
						if (_list[i] === possibleNodes[0]) {
							_found = true;
						} else if (!_found) _preLis.push(_list[i]);else _postLis.push(_list[i]);
					}
					var _parent = angular.element(possibleNodes[0].parentNode);
					var newElem = angular.element('<p></p>');
					newElem.html(angular.element(possibleNodes[0]).html());
					if (_preLis.length === 0 || _postLis.length === 0) {
						if (_postLis.length === 0) _parent.after(newElem);else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);
	
						if (_preLis.length === 0 && _postLis.length === 0) _parent.remove();else angular.element(possibleNodes[0]).remove();
					} else {
						var _firstList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
						var _secondList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
						for (i = 0; i < _preLis.length; i++) {
							_firstList.append(angular.element(_preLis[i]));
						}for (i = 0; i < _postLis.length; i++) {
							_secondList.append(angular.element(_postLis[i]));
						}_parent.after(_secondList);
						_parent.after(newElem);
						_parent.after(_firstList);
						_parent.remove();
					}
					taSelection.setSelectionToElementEnd(newElem[0]);
				}
				// clear out all class attributes. These do not seem to be cleared via removeFormat
				var $editor = this.$editor();
				var recursiveRemoveClass = function recursiveRemoveClass(node) {
					node = angular.element(node);
					if (node[0] !== $editor.displayElements.text[0]) node.removeAttr('class');
					angular.forEach(node.children(), recursiveRemoveClass);
				};
				angular.forEach(possibleNodes, recursiveRemoveClass);
				// check if in list. If not in list then use formatBlock option
				if (possibleNodes[0].tagName.toLowerCase() !== 'li' && possibleNodes[0].tagName.toLowerCase() !== 'ol' && possibleNodes[0].tagName.toLowerCase() !== 'ul') this.$editor().wrapSelection("formatBlock", "default");
				restoreSelection();
			}
		});
	
		taRegisterTool('insertImage', {
			iconclass: 'fa fa-picture-o',
			tooltiptext: taTranslations.insertImage.tooltip,
			action: function action() {
				var imageLink;
				imageLink = $window.prompt(taTranslations.insertImage.dialogPrompt, 'http://');
				if (imageLink && imageLink !== '' && imageLink !== 'http://') {
					return this.$editor().wrapSelection('insertImage', imageLink, true);
				}
			},
			onElementSelect: {
				element: 'img',
				action: taToolFunctions.imgOnSelectAction
			}
		});
		taRegisterTool('insertVideo', {
			iconclass: 'fa fa-youtube-play',
			tooltiptext: taTranslations.insertVideo.tooltip,
			action: function action() {
				var urlPrompt;
				urlPrompt = $window.prompt(taTranslations.insertVideo.dialogPrompt, 'https://');
				if (urlPrompt && urlPrompt !== '' && urlPrompt !== 'https://') {
	
					videoId = taToolFunctions.extractYoutubeVideoId(urlPrompt);
	
					/* istanbul ignore else: if it's invalid don't worry - though probably should show some kind of error message */
					if (videoId) {
						// create the embed link
						var urlLink = "https://www.youtube.com/embed/" + videoId;
						// create the HTML
						// for all options see: http://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
						// maxresdefault.jpg seems to be undefined on some.
						var embed = '<img class="ta-insert-video" src="https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg" ta-insert-video="' + urlLink + '" contenteditable="false" allowfullscreen="true" frameborder="0" />';
						// insert
						return this.$editor().wrapSelection('insertHTML', embed, true);
					}
				}
			},
			onElementSelect: {
				element: 'img',
				onlyWithAttrs: ['ta-insert-video'],
				action: taToolFunctions.imgOnSelectAction
			}
		});
		taRegisterTool('insertLink', {
			tooltiptext: taTranslations.insertLink.tooltip,
			iconclass: 'fa fa-link',
			action: function action() {
				var urlLink;
				urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, 'http://');
				if (urlLink && urlLink !== '' && urlLink !== 'http://') {
					return this.$editor().wrapSelection('createLink', urlLink, true);
				}
			},
			activeState: function activeState(commonElement) {
				if (commonElement) return commonElement[0].tagName === 'A';
				return false;
			},
			onElementSelect: {
				element: 'a',
				action: taToolFunctions.aOnSelectAction
			}
		});
		taRegisterTool('wordcount', {
			display: '<div id="toolbarWC" style="display:block; min-width:100px;">Words: <span ng-bind="wordcount"></span></div>',
			disabled: true,
			wordcount: 0,
			activeState: function activeState() {
				// this fires on keyup
				var textElement = this.$editor().displayElements.text;
				/* istanbul ignore next: will default to '' when undefined */
				var workingHTML = textElement[0].innerHTML || '';
				var noOfWords = 0;
	
				/* istanbul ignore if: will default to '' when undefined */
				if (workingHTML.replace(/\s*<[^>]*?>\s*/g, '') !== '') {
					noOfWords = workingHTML.replace(/<\/?(b|i|em|strong|span|u|strikethrough|a|img|small|sub|sup|label)( [^>*?])?>/gi, '') // remove inline tags without adding spaces
					.replace(/(<[^>]*?>\s*<[^>]*?>)/ig, ' ') // replace adjacent tags with possible space between with a space
					.replace(/(<[^>]*?>)/ig, '') // remove any singular tags
					.replace(/\s+/ig, ' ') // condense spacing
					.match(/\S+/g).length; // count remaining non-space strings
				}
	
				//Set current scope
				this.wordcount = noOfWords;
				//Set editor scope
				this.$editor().wordcount = noOfWords;
	
				return false;
			}
		});
		taRegisterTool('charcount', {
			display: '<div id="toolbarCC" style="display:block; min-width:120px;">Characters: <span ng-bind="charcount"></span></div>',
			disabled: true,
			charcount: 0,
			activeState: function activeState() {
				// this fires on keyup
				var textElement = this.$editor().displayElements.text;
				var sourceText = textElement[0].innerText || textElement[0].textContent; // to cover the non-jquery use case.
	
				// Caculate number of chars
				var noOfChars = sourceText.replace(/(\r\n|\n|\r)/gm, "").replace(/^\s+/g, ' ').replace(/\s+$/g, ' ').length;
				//Set current scope
				this.charcount = noOfChars;
				//Set editor scope
				this.$editor().charcount = noOfChars;
				return false;
			}
		});
	}]);

/***/ },
/* 342 */
/***/ function(module, exports) {

	"use strict";
	
	/*!
	 * ui-select
	 * http://github.com/angular-ui/ui-select
	 * Version: 0.18.1 - 2016-07-10T00:30:49.391Z
	 * License: MIT
	 */
	
	(function () {
	  "use strict";
	
	  var KEY = {
	    TAB: 9,
	    ENTER: 13,
	    ESC: 27,
	    SPACE: 32,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    HOME: 36,
	    END: 35,
	    BACKSPACE: 8,
	    DELETE: 46,
	    COMMAND: 91,
	
	    MAP: { 91: "COMMAND", 8: "BACKSPACE", 9: "TAB", 13: "ENTER", 16: "SHIFT", 17: "CTRL", 18: "ALT", 19: "PAUSEBREAK", 20: "CAPSLOCK", 27: "ESC", 32: "SPACE", 33: "PAGE_UP", 34: "PAGE_DOWN", 35: "END", 36: "HOME", 37: "LEFT", 38: "UP", 39: "RIGHT", 40: "DOWN", 43: "+", 44: "PRINTSCREEN", 45: "INSERT", 46: "DELETE", 48: "0", 49: "1", 50: "2", 51: "3", 52: "4", 53: "5", 54: "6", 55: "7", 56: "8", 57: "9", 59: ";", 61: "=", 65: "A", 66: "B", 67: "C", 68: "D", 69: "E", 70: "F", 71: "G", 72: "H", 73: "I", 74: "J", 75: "K", 76: "L", 77: "M", 78: "N", 79: "O", 80: "P", 81: "Q", 82: "R", 83: "S", 84: "T", 85: "U", 86: "V", 87: "W", 88: "X", 89: "Y", 90: "Z", 96: "0", 97: "1", 98: "2", 99: "3", 100: "4", 101: "5", 102: "6", 103: "7", 104: "8", 105: "9", 106: "*", 107: "+", 109: "-", 110: ".", 111: "/", 112: "F1", 113: "F2", 114: "F3", 115: "F4", 116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NUMLOCK", 145: "SCROLLLOCK", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\", 221: "]", 222: "'"
	    },
	
	    isControl: function isControl(e) {
	      var k = e.which;
	      switch (k) {
	        case KEY.COMMAND:
	        case KEY.SHIFT:
	        case KEY.CTRL:
	        case KEY.ALT:
	          return true;
	      }
	
	      if (e.metaKey || e.ctrlKey || e.altKey) return true;
	
	      return false;
	    },
	    isFunctionKey: function isFunctionKey(k) {
	      k = k.which ? k.which : k;
	      return k >= 112 && k <= 123;
	    },
	    isVerticalMovement: function isVerticalMovement(k) {
	      return ~[KEY.UP, KEY.DOWN].indexOf(k);
	    },
	    isHorizontalMovement: function isHorizontalMovement(k) {
	      return ~[KEY.LEFT, KEY.RIGHT, KEY.BACKSPACE, KEY.DELETE].indexOf(k);
	    },
	    toSeparator: function toSeparator(k) {
	      var sep = { ENTER: "\n", TAB: "\t", SPACE: " " }[k];
	      if (sep) return sep;
	      // return undefined for special keys other than enter, tab or space.
	      // no way to use them to cut strings.
	      return KEY[k] ? undefined : k;
	    }
	  };
	
	  /**
	   * Add querySelectorAll() to jqLite.
	   *
	   * jqLite find() is limited to lookups by tag name.
	   * TODO This will change with future versions of AngularJS, to be removed when this happens
	   *
	   * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
	   * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
	   */
	  if (angular.element.prototype.querySelectorAll === undefined) {
	    angular.element.prototype.querySelectorAll = function (selector) {
	      return angular.element(this[0].querySelectorAll(selector));
	    };
	  }
	
	  /**
	   * Add closest() to jqLite.
	   */
	  if (angular.element.prototype.closest === undefined) {
	    angular.element.prototype.closest = function (selector) {
	      var elem = this[0];
	      var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
	
	      while (elem) {
	        if (matchesSelector.bind(elem)(selector)) {
	          return elem;
	        } else {
	          elem = elem.parentElement;
	        }
	      }
	      return false;
	    };
	  }
	
	  var latestId = 0;
	
	  var uis = angular.module('ui.select', []).constant('uiSelectConfig', {
	    theme: 'bootstrap',
	    searchEnabled: true,
	    sortable: false,
	    placeholder: '', // Empty by default, like HTML tag <select>
	    refreshDelay: 1000, // In milliseconds
	    closeOnSelect: true,
	    skipFocusser: false,
	    dropdownPosition: 'auto',
	    removeSelected: true,
	    generateId: function generateId() {
	      return latestId++;
	    },
	    appendToBody: false
	  })
	
	  // See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
	  .service('uiSelectMinErr', function () {
	    var minErr = angular.$$minErr('ui.select');
	    return function () {
	      var error = minErr.apply(this, arguments);
	      var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
	      return new Error(message);
	    };
	  })
	
	  // Recreates old behavior of ng-transclude. Used internally.
	  .directive('uisTranscludeAppend', function () {
	    return {
	      link: function link(scope, element, attrs, ctrl, transclude) {
	        transclude(scope, function (clone) {
	          element.append(clone);
	        });
	      }
	    };
	  })
	
	  /**
	   * Highlights text that matches $select.search.
	   *
	   * Taken from AngularUI Bootstrap Typeahead
	   * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
	   */
	  .filter('highlight', function () {
	    function escapeRegexp(queryToEscape) {
	      return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    return function (matchItem, query) {
	      return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
	    };
	  })
	
	  /**
	   * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
	   *
	   * Taken from AngularUI Bootstrap Position:
	   * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
	   */
	  .factory('uisOffset', ['$document', '$window', function ($document, $window) {
	
	    return function (element) {
	      var boundingClientRect = element[0].getBoundingClientRect();
	      return {
	        width: boundingClientRect.width || element.prop('offsetWidth'),
	        height: boundingClientRect.height || element.prop('offsetHeight'),
	        top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	        left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	      };
	    };
	  }]);
	
	  uis.directive('uiSelectChoices', ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window', function (uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {
	
	    return {
	      restrict: 'EA',
	      require: '^uiSelect',
	      replace: true,
	      transclude: true,
	      templateUrl: function templateUrl(tElement) {
	        // Needed so the uiSelect can detect the transcluded content
	        tElement.addClass('ui-select-choices');
	
	        // Gets theme attribute from parent (ui-select)
	        var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	        return theme + '/choices.tpl.html';
	      },
	
	      compile: function compile(tElement, tAttrs) {
	
	        if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");
	
	        // var repeat = RepeatParser.parse(attrs.repeat);
	        var groupByExp = tAttrs.groupBy;
	        var groupFilterExp = tAttrs.groupFilter;
	
	        if (groupByExp) {
	          var groups = tElement.querySelectorAll('.ui-select-choices-group');
	          if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
	          groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
	        }
	
	        var parserResult = RepeatParser.parse(tAttrs.repeat);
	
	        var choices = tElement.querySelectorAll('.ui-select-choices-row');
	        if (choices.length !== 1) {
	          throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
	        }
	
	        choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp)).attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed
	
	
	        var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
	        if (rowsInner.length !== 1) {
	          throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
	        }
	        rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat
	
	        // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event. 
	        var clickTarget = $window.document.addEventListener ? choices : rowsInner;
	        clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');
	
	        return function link(scope, element, attrs, $select) {
	
	          $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
	
	          $select.disableChoiceExpression = attrs.uiDisableChoice;
	          $select.onHighlightCallback = attrs.onHighlight;
	
	          $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;
	
	          scope.$on('$destroy', function () {
	            choices.remove();
	          });
	
	          scope.$watch('$select.search', function (newValue) {
	            if (newValue && !$select.open && $select.multiple) $select.activate(false, true);
	            $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
	            if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
	              $select.refresh(attrs.refresh);
	            } else {
	              $select.items = [];
	            }
	          });
	
	          attrs.$observe('refreshDelay', function () {
	            // $eval() is needed otherwise we get a string instead of a number
	            var refreshDelay = scope.$eval(attrs.refreshDelay);
	            $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
	          });
	        };
	      }
	    };
	  }]);
	
	  /**
	   * Contains ui-select "intelligence".
	   *
	   * The goal is to limit dependency on the DOM whenever possible and
	   * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
	   */
	  uis.controller('uiSelectCtrl', ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window', function ($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {
	
	    var ctrl = this;
	
	    var EMPTY_SEARCH = '';
	
	    ctrl.placeholder = uiSelectConfig.placeholder;
	    ctrl.searchEnabled = uiSelectConfig.searchEnabled;
	    ctrl.sortable = uiSelectConfig.sortable;
	    ctrl.refreshDelay = uiSelectConfig.refreshDelay;
	    ctrl.paste = uiSelectConfig.paste;
	
	    ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
	    ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
	    ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
	    ctrl.search = EMPTY_SEARCH;
	
	    ctrl.activeIndex = 0; //Dropdown of choices
	    ctrl.items = []; //All available choices
	
	    ctrl.open = false;
	    ctrl.focus = false;
	    ctrl.disabled = false;
	    ctrl.selected = undefined;
	
	    ctrl.dropdownPosition = 'auto';
	
	    ctrl.focusser = undefined; //Reference to input element used to handle focus events
	    ctrl.resetSearchInput = true;
	    ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
	    ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
	    ctrl.tagging = { isActivated: false, fct: undefined };
	    ctrl.taggingTokens = { isActivated: false, tokens: undefined };
	    ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
	    ctrl.clickTriggeredSelect = false;
	    ctrl.$filter = $filter;
	    ctrl.$element = $element;
	
	    // Use $injector to check for $animate and store a reference to it
	    ctrl.$animate = function () {
	      try {
	        return $injector.get('$animate');
	      } catch (err) {
	        // $animate does not exist
	        return null;
	      }
	    }();
	
	    ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
	    if (ctrl.searchInput.length !== 1) {
	      throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
	    }
	
	    ctrl.isEmpty = function () {
	      return angular.isUndefined(ctrl.selected) || ctrl.selected === null || ctrl.selected === '' || ctrl.multiple && ctrl.selected.length === 0;
	    };
	
	    function _findIndex(collection, predicate, thisArg) {
	      if (collection.findIndex) {
	        return collection.findIndex(predicate, thisArg);
	      } else {
	        var list = Object(collection);
	        var length = list.length >>> 0;
	        var value;
	
	        for (var i = 0; i < length; i++) {
	          value = list[i];
	          if (predicate.call(thisArg, value, i, list)) {
	            return i;
	          }
	        }
	        return -1;
	      }
	    }
	
	    // Most of the time the user does not want to empty the search input when in typeahead mode
	    function _resetSearchInput() {
	      if (ctrl.resetSearchInput || ctrl.resetSearchInput === undefined && uiSelectConfig.resetSearchInput) {
	        ctrl.search = EMPTY_SEARCH;
	        //reset activeIndex
	        if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
	          ctrl.activeIndex = _findIndex(ctrl.items, function (item) {
	            return angular.equals(this, item);
	          }, ctrl.selected);
	        }
	      }
	    }
	
	    function _groupsFilter(groups, groupNames) {
	      var i,
	          j,
	          result = [];
	      for (i = 0; i < groupNames.length; i++) {
	        for (j = 0; j < groups.length; j++) {
	          if (groups[j].name == [groupNames[i]]) {
	            result.push(groups[j]);
	          }
	        }
	      }
	      return result;
	    }
	
	    // When the user clicks on ui-select, displays the dropdown list
	    ctrl.activate = function (initSearchValue, avoidReset) {
	      if (!ctrl.disabled && !ctrl.open) {
	        if (!avoidReset) _resetSearchInput();
	
	        $scope.$broadcast('uis:activate');
	
	        ctrl.open = true;
	
	        ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
	
	        // ensure that the index is set to zero for tagging variants
	        // that where first option is auto-selected
	        if (ctrl.activeIndex === -1 && ctrl.taggingLabel !== false) {
	          ctrl.activeIndex = 0;
	        }
	
	        var container = $element.querySelectorAll('.ui-select-choices-content');
	        var searchInput = $element.querySelectorAll('.ui-select-search');
	        if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
	          var animateHandler = function animateHandler(elem, phase) {
	            if (phase === 'start' && ctrl.items.length === 0) {
	              // Only focus input after the animation has finished
	              ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
	              $timeout(function () {
	                ctrl.focusSearchInput(initSearchValue);
	              });
	            } else if (phase === 'close') {
	              // Only focus input after the animation has finished
	              ctrl.$animate.off('enter', container[0], animateHandler);
	              $timeout(function () {
	                ctrl.focusSearchInput(initSearchValue);
	              });
	            }
	          };
	
	          if (ctrl.items.length > 0) {
	            ctrl.$animate.on('enter', container[0], animateHandler);
	          } else {
	            ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
	          }
	        } else {
	          $timeout(function () {
	            ctrl.focusSearchInput(initSearchValue);
	            if (!ctrl.tagging.isActivated && ctrl.items.length > 1) {
	              _ensureHighlightVisible();
	            }
	          });
	        }
	      }
	    };
	
	    ctrl.focusSearchInput = function (initSearchValue) {
	      ctrl.search = initSearchValue || ctrl.search;
	      ctrl.searchInput[0].focus();
	    };
	
	    ctrl.findGroupByName = function (name) {
	      return ctrl.groups && ctrl.groups.filter(function (group) {
	        return group.name === name;
	      })[0];
	    };
	
	    ctrl.parseRepeatAttr = function (repeatAttr, groupByExp, groupFilterExp) {
	      function updateGroups(items) {
	        var groupFn = $scope.$eval(groupByExp);
	        ctrl.groups = [];
	        angular.forEach(items, function (item) {
	          var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
	          var group = ctrl.findGroupByName(groupName);
	          if (group) {
	            group.items.push(item);
	          } else {
	            ctrl.groups.push({ name: groupName, items: [item] });
	          }
	        });
	        if (groupFilterExp) {
	          var groupFilterFn = $scope.$eval(groupFilterExp);
	          if (angular.isFunction(groupFilterFn)) {
	            ctrl.groups = groupFilterFn(ctrl.groups);
	          } else if (angular.isArray(groupFilterFn)) {
	            ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
	          }
	        }
	        ctrl.items = [];
	        ctrl.groups.forEach(function (group) {
	          ctrl.items = ctrl.items.concat(group.items);
	        });
	      }
	
	      function setPlainItems(items) {
	        ctrl.items = items;
	      }
	
	      ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
	
	      ctrl.parserResult = RepeatParser.parse(repeatAttr);
	
	      ctrl.isGrouped = !!groupByExp;
	      ctrl.itemProperty = ctrl.parserResult.itemName;
	
	      //If collection is an Object, convert it to Array
	
	      var originalSource = ctrl.parserResult.source;
	
	      //When an object is used as source, we better create an array and use it as 'source'
	      var createArrayFromObject = function createArrayFromObject() {
	        var origSrc = originalSource($scope);
	        $scope.$uisSource = Object.keys(origSrc).map(function (v) {
	          var result = {};
	          result[ctrl.parserResult.keyName] = v;
	          result.value = origSrc[v];
	          return result;
	        });
	      };
	
	      if (ctrl.parserResult.keyName) {
	        // Check for (key,value) syntax
	        createArrayFromObject();
	        ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
	        $scope.$watch(originalSource, function (newVal, oldVal) {
	          if (newVal !== oldVal) createArrayFromObject();
	        }, true);
	      }
	
	      ctrl.refreshItems = function (data) {
	        data = data || ctrl.parserResult.source($scope);
	        var selectedItems = ctrl.selected;
	        //TODO should implement for single mode removeSelected
	        if (ctrl.isEmpty() || angular.isArray(selectedItems) && !selectedItems.length || !ctrl.multiple || !ctrl.removeSelected) {
	          ctrl.setItemsFn(data);
	        } else {
	          if (data !== undefined && data !== null) {
	            var filteredItems = data.filter(function (i) {
	              return angular.isArray(selectedItems) ? selectedItems.every(function (selectedItem) {
	                return !angular.equals(i, selectedItem);
	              }) : !angular.equals(i, selectedItems);
	            });
	            ctrl.setItemsFn(filteredItems);
	          }
	        }
	        if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up') {
	          $scope.calculateDropdownPos();
	        }
	
	        $scope.$broadcast('uis:refresh');
	      };
	
	      // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
	      $scope.$watchCollection(ctrl.parserResult.source, function (items) {
	        if (items === undefined || items === null) {
	          // If the user specifies undefined or null => reset the collection
	          // Special case: items can be undefined if the user did not initialized the collection on the scope
	          // i.e $scope.addresses = [] is missing
	          ctrl.items = [];
	        } else {
	          if (!angular.isArray(items)) {
	            throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
	          } else {
	            //Remove already selected items (ex: while searching)
	            //TODO Should add a test
	            ctrl.refreshItems(items);
	
	            //update the view value with fresh data from items, if there is a valid model value
	            if (angular.isDefined(ctrl.ngModel.$modelValue)) {
	              ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	            }
	          }
	        }
	      });
	    };
	
	    var _refreshDelayPromise;
	
	    /**
	     * Typeahead mode: lets the user refresh the collection using his own function.
	     *
	     * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
	     */
	    ctrl.refresh = function (refreshAttr) {
	      if (refreshAttr !== undefined) {
	
	        // Debounce
	        // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
	        // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
	        if (_refreshDelayPromise) {
	          $timeout.cancel(_refreshDelayPromise);
	        }
	        _refreshDelayPromise = $timeout(function () {
	          $scope.$eval(refreshAttr);
	        }, ctrl.refreshDelay);
	      }
	    };
	
	    ctrl.isActive = function (itemScope) {
	      if (!ctrl.open) {
	        return false;
	      }
	      var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
	      var isActive = itemIndex == ctrl.activeIndex;
	
	      if (!isActive || itemIndex < 0) {
	        return false;
	      }
	
	      if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
	        itemScope.$eval(ctrl.onHighlightCallback);
	      }
	
	      return isActive;
	    };
	
	    var _isItemSelected = function _isItemSelected(item) {
	      return ctrl.selected && angular.isArray(ctrl.selected) && ctrl.selected.filter(function (selection) {
	        return angular.equals(selection, item);
	      }).length > 0;
	    };
	
	    var disabledItems = [];
	
	    function _updateItemDisabled(item, isDisabled) {
	      var disabledItemIndex = disabledItems.indexOf(item);
	      if (isDisabled && disabledItemIndex === -1) {
	        disabledItems.push(item);
	      }
	
	      if (!isDisabled && disabledItemIndex > -1) {
	        disabledItems.splice(disabledItemIndex, 0);
	      }
	    }
	
	    function _isItemDisabled(item) {
	      return disabledItems.indexOf(item) > -1;
	    }
	
	    ctrl.isDisabled = function (itemScope) {
	
	      if (!ctrl.open) return;
	
	      var item = itemScope[ctrl.itemProperty];
	      var itemIndex = ctrl.items.indexOf(item);
	      var isDisabled = false;
	
	      if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {
	
	        if (item.isTag) return false;
	
	        if (ctrl.multiple) {
	          isDisabled = _isItemSelected(item);
	        }
	
	        if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
	          isDisabled = !!itemScope.$eval(ctrl.disableChoiceExpression);
	        }
	
	        _updateItemDisabled(item, isDisabled);
	      }
	
	      return isDisabled;
	    };
	
	    // When the user selects an item with ENTER or clicks the dropdown
	    ctrl.select = function (item, skipFocusser, $event) {
	      if (item === undefined || !_isItemDisabled(item)) {
	
	        if (!ctrl.items && !ctrl.search && !ctrl.tagging.isActivated) return;
	
	        if (!item || !_isItemDisabled(item)) {
	          if (ctrl.tagging.isActivated) {
	            // if taggingLabel is disabled and item is undefined we pull from ctrl.search
	            if (ctrl.taggingLabel === false) {
	              if (ctrl.activeIndex < 0) {
	                if (item === undefined) {
	                  item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
	                }
	                if (!item || angular.equals(ctrl.items[0], item)) {
	                  return;
	                }
	              } else {
	                // keyboard nav happened first, user selected from dropdown
	                item = ctrl.items[ctrl.activeIndex];
	              }
	            } else {
	              // tagging always operates at index zero, taggingLabel === false pushes
	              // the ctrl.search value without having it injected
	              if (ctrl.activeIndex === 0) {
	                // ctrl.tagging pushes items to ctrl.items, so we only have empty val
	                // for `item` if it is a detected duplicate
	                if (item === undefined) return;
	
	                // create new item on the fly if we don't already have one;
	                // use tagging function if we have one
	                if (ctrl.tagging.fct !== undefined && typeof item === 'string') {
	                  item = ctrl.tagging.fct(item);
	                  if (!item) return;
	                  // if item type is 'string', apply the tagging label
	                } else if (typeof item === 'string') {
	                  // trim the trailing space
	                  item = item.replace(ctrl.taggingLabel, '').trim();
	                }
	              }
	            }
	            // search ctrl.selected for dupes potentially caused by tagging and return early if found
	            if (_isItemSelected(item)) {
	              ctrl.close(skipFocusser);
	              return;
	            }
	          }
	
	          $scope.$broadcast('uis:select', item);
	
	          var locals = {};
	          locals[ctrl.parserResult.itemName] = item;
	
	          $timeout(function () {
	            ctrl.onSelectCallback($scope, {
	              $item: item,
	              $model: ctrl.parserResult.modelMapper($scope, locals)
	            });
	          });
	
	          if (ctrl.closeOnSelect) {
	            ctrl.close(skipFocusser);
	          }
	          if ($event && $event.type === 'click') {
	            ctrl.clickTriggeredSelect = true;
	          }
	        }
	      }
	    };
	
	    // Closes the dropdown
	    ctrl.close = function (skipFocusser) {
	      if (!ctrl.open) return;
	      if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
	      _resetSearchInput();
	      ctrl.open = false;
	
	      $scope.$broadcast('uis:close', skipFocusser);
	    };
	
	    ctrl.setFocus = function () {
	      if (!ctrl.focus) ctrl.focusInput[0].focus();
	    };
	
	    ctrl.clear = function ($event) {
	      ctrl.select(undefined);
	      $event.stopPropagation();
	      $timeout(function () {
	        ctrl.focusser[0].focus();
	      }, 0, false);
	    };
	
	    // Toggle dropdown
	    ctrl.toggle = function (e) {
	      if (ctrl.open) {
	        ctrl.close();
	        e.preventDefault();
	        e.stopPropagation();
	      } else {
	        ctrl.activate();
	      }
	    };
	
	    // Set default function for locked choices - avoids unnecessary 
	    // logic if functionality is not being used
	    ctrl.isLocked = function () {
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== "";
	    }, _initaliseLockedChoices);
	
	    function _initaliseLockedChoices(doInitalise) {
	      if (!doInitalise) return;
	
	      var lockedItems = [];
	
	      function _updateItemLocked(item, isLocked) {
	        var lockedItemIndex = lockedItems.indexOf(item);
	        if (isLocked && lockedItemIndex === -1) {
	          lockedItems.push(item);
	        }
	
	        if (!isLocked && lockedItemIndex > -1) {
	          lockedItems.splice(lockedItemIndex, 0);
	        }
	      }
	
	      function _isItemlocked(item) {
	        return lockedItems.indexOf(item) > -1;
	      }
	
	      ctrl.isLocked = function (itemScope, itemIndex) {
	        var isLocked = false,
	            item = ctrl.selected[itemIndex];
	
	        if (item) {
	          if (itemScope) {
	            isLocked = !!itemScope.$eval(ctrl.lockChoiceExpression);
	            _updateItemLocked(item, isLocked);
	          } else {
	            isLocked = _isItemlocked(item);
	          }
	        }
	
	        return isLocked;
	      };
	    }
	
	    var sizeWatch = null;
	    var updaterScheduled = false;
	    ctrl.sizeSearchInput = function () {
	
	      var input = ctrl.searchInput[0],
	          container = ctrl.searchInput.parent().parent()[0],
	          calculateContainerWidth = function calculateContainerWidth() {
	        // Return the container width only if the search input is visible
	        return container.clientWidth * !!input.offsetParent;
	      },
	          updateIfVisible = function updateIfVisible(containerWidth) {
	        if (containerWidth === 0) {
	          return false;
	        }
	        var inputWidth = containerWidth - input.offsetLeft - 10;
	        if (inputWidth < 50) inputWidth = containerWidth;
	        ctrl.searchInput.css('width', inputWidth + 'px');
	        return true;
	      };
	
	      ctrl.searchInput.css('width', '10px');
	      $timeout(function () {
	        //Give tags time to render correctly
	        if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
	          sizeWatch = $scope.$watch(function () {
	            if (!updaterScheduled) {
	              updaterScheduled = true;
	              $scope.$$postDigest(function () {
	                updaterScheduled = false;
	                if (updateIfVisible(calculateContainerWidth())) {
	                  sizeWatch();
	                  sizeWatch = null;
	                }
	              });
	            }
	          }, angular.noop);
	        }
	      });
	    };
	
	    function _handleDropDownSelection(key) {
	      var processed = true;
	      switch (key) {
	        case KEY.DOWN:
	          if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	          else if (ctrl.activeIndex < ctrl.items.length - 1) {
	              ctrl.activeIndex++;
	            }
	          break;
	        case KEY.UP:
	          if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	          else if (ctrl.activeIndex > 0 || ctrl.search.length === 0 && ctrl.tagging.isActivated && ctrl.activeIndex > -1) {
	              ctrl.activeIndex--;
	            }
	          break;
	        case KEY.TAB:
	          if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
	          break;
	        case KEY.ENTER:
	          if (ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)) {
	            ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
	          } else {
	            ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	          }
	          break;
	        case KEY.ESC:
	          ctrl.close();
	          break;
	        default:
	          processed = false;
	      }
	      return processed;
	    }
	
	    // Bind to keyboard shortcuts
	    ctrl.searchInput.on('keydown', function (e) {
	
	      var key = e.which;
	
	      if (~[KEY.ENTER, KEY.ESC].indexOf(key)) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	
	      // if(~[KEY.ESC,KEY.TAB].indexOf(key)){
	      //   //TODO: SEGURO?
	      //   ctrl.close();
	      // }
	
	      $scope.$apply(function () {
	
	        var tagged = false;
	
	        if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
	          _handleDropDownSelection(key);
	          if (ctrl.taggingTokens.isActivated) {
	            for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	              if (ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode]) {
	                // make sure there is a new value to push via tagging
	                if (ctrl.search.length > 0) {
	                  tagged = true;
	                }
	              }
	            }
	            if (tagged) {
	              $timeout(function () {
	                ctrl.searchInput.triggerHandler('tagged');
	                var newItem = ctrl.search.replace(KEY.MAP[e.keyCode], '').trim();
	                if (ctrl.tagging.fct) {
	                  newItem = ctrl.tagging.fct(newItem);
	                }
	                if (newItem) ctrl.select(newItem, true);
	              });
	            }
	          }
	        }
	      });
	
	      if (KEY.isVerticalMovement(key) && ctrl.items.length > 0) {
	        _ensureHighlightVisible();
	      }
	
	      if (key === KEY.ENTER || key === KEY.ESC) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    });
	
	    ctrl.searchInput.on('paste', function (e) {
	      var data;
	
	      if (window.clipboardData && window.clipboardData.getData) {
	        // IE
	        data = window.clipboardData.getData('Text');
	      } else {
	        data = (e.originalEvent || e).clipboardData.getData('text/plain');
	      }
	
	      // Prepend the current input field text to the paste buffer.
	      data = ctrl.search + data;
	
	      if (data && data.length > 0) {
	        // If tagging try to split by tokens and add items
	        if (ctrl.taggingTokens.isActivated) {
	          var items = [];
	          for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	            // split by first token that is contained in data
	            var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
	            if (data.indexOf(separator) > -1) {
	              items = data.split(separator);
	              break; // only split by one token
	            }
	          }
	          if (items.length === 0) {
	            items = [data];
	          }
	          var oldsearch = ctrl.search;
	          angular.forEach(items, function (item) {
	            var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
	            if (newItem) {
	              ctrl.select(newItem, true);
	            }
	          });
	          ctrl.search = oldsearch || EMPTY_SEARCH;
	          e.preventDefault();
	          e.stopPropagation();
	        } else if (ctrl.paste) {
	          ctrl.paste(data);
	          ctrl.search = EMPTY_SEARCH;
	          e.preventDefault();
	          e.stopPropagation();
	        }
	      }
	    });
	
	    ctrl.searchInput.on('tagged', function () {
	      $timeout(function () {
	        _resetSearchInput();
	      });
	    });
	
	    // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
	    function _ensureHighlightVisible() {
	      var container = $element.querySelectorAll('.ui-select-choices-content');
	      var choices = container.querySelectorAll('.ui-select-choices-row');
	      if (choices.length < 1) {
	        throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
	      }
	
	      if (ctrl.activeIndex < 0) {
	        return;
	      }
	
	      var highlighted = choices[ctrl.activeIndex];
	      var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
	      var height = container[0].offsetHeight;
	
	      if (posY > height) {
	        container[0].scrollTop += posY - height;
	      } else if (posY < highlighted.clientHeight) {
	        if (ctrl.isGrouped && ctrl.activeIndex === 0) container[0].scrollTop = 0; //To make group header visible when going all the way up
	        else container[0].scrollTop -= highlighted.clientHeight - posY;
	      }
	    }
	
	    var onResize = $$uisDebounce(function () {
	      ctrl.sizeSearchInput();
	    }, 50);
	
	    angular.element($window).bind('resize', onResize);
	
	    $scope.$on('$destroy', function () {
	      ctrl.searchInput.off('keyup keydown tagged blur paste');
	      angular.element($window).off('resize', onResize);
	    });
	  }]);
	
	  uis.directive('uiSelect', ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout', function ($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {
	
	    return {
	      restrict: 'EA',
	      templateUrl: function templateUrl(tElement, tAttrs) {
	        var theme = tAttrs.theme || uiSelectConfig.theme;
	        return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
	      },
	      replace: true,
	      transclude: true,
	      require: ['uiSelect', '^ngModel'],
	      scope: true,
	
	      controller: 'uiSelectCtrl',
	      controllerAs: '$select',
	      compile: function compile(tElement, tAttrs) {
	
	        // Allow setting ngClass on uiSelect
	        var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
	        if (match) {
	          var combined = '{' + match[1] + ', ' + match[2] + '}';
	          tAttrs.ngClass = combined;
	          tElement.attr('ng-class', combined);
	        }
	
	        //Multiple or Single depending if multiple attribute presence
	        if (angular.isDefined(tAttrs.multiple)) tElement.append('<ui-select-multiple/>').removeAttr('multiple');else tElement.append('<ui-select-single/>');
	
	        if (tAttrs.inputId) tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;
	
	        return function (scope, element, attrs, ctrls, transcludeFn) {
	
	          var $select = ctrls[0];
	          var ngModel = ctrls[1];
	
	          $select.generatedId = uiSelectConfig.generateId();
	          $select.baseTitle = attrs.title || 'Select box';
	          $select.focusserTitle = $select.baseTitle + ' focus';
	          $select.focusserId = 'focusser-' + $select.generatedId;
	
	          $select.closeOnSelect = function () {
	            if (angular.isDefined(attrs.closeOnSelect)) {
	              return $parse(attrs.closeOnSelect)();
	            } else {
	              return uiSelectConfig.closeOnSelect;
	            }
	          }();
	
	          scope.$watch('skipFocusser', function () {
	            var skipFocusser = scope.$eval(attrs.skipFocusser);
	            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
	          });
	
	          $select.onSelectCallback = $parse(attrs.onSelect);
	          $select.onRemoveCallback = $parse(attrs.onRemove);
	
	          //Set reference to ngModel from uiSelectCtrl
	          $select.ngModel = ngModel;
	
	          $select.choiceGrouped = function (group) {
	            return $select.isGrouped && group && group.name;
	          };
	
	          if (attrs.tabindex) {
	            attrs.$observe('tabindex', function (value) {
	              $select.focusInput.attr('tabindex', value);
	              element.removeAttr('tabindex');
	            });
	          }
	
	          scope.$watch(function () {
	            return scope.$eval(attrs.searchEnabled);
	          }, function (newVal) {
	            $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
	          });
	
	          scope.$watch('sortable', function () {
	            var sortable = scope.$eval(attrs.sortable);
	            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
	          });
	
	          attrs.$observe('limit', function () {
	            //Limit the number of selections allowed
	            $select.limit = angular.isDefined(attrs.limit) ? parseInt(attrs.limit, 10) : undefined;
	          });
	
	          scope.$watch('removeSelected', function () {
	            var removeSelected = scope.$eval(attrs.removeSelected);
	            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
	          });
	
	          attrs.$observe('disabled', function () {
	            // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
	            $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
	          });
	
	          attrs.$observe('resetSearchInput', function () {
	            // $eval() is needed otherwise we get a string instead of a boolean
	            var resetSearchInput = scope.$eval(attrs.resetSearchInput);
	            $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
	          });
	
	          attrs.$observe('paste', function () {
	            $select.paste = scope.$eval(attrs.paste);
	          });
	
	          attrs.$observe('tagging', function () {
	            if (attrs.tagging !== undefined) {
	              // $eval() is needed otherwise we get a string instead of a boolean
	              var taggingEval = scope.$eval(attrs.tagging);
	              $select.tagging = { isActivated: true, fct: taggingEval !== true ? taggingEval : undefined };
	            } else {
	              $select.tagging = { isActivated: false, fct: undefined };
	            }
	          });
	
	          attrs.$observe('taggingLabel', function () {
	            if (attrs.tagging !== undefined) {
	              // check eval for FALSE, in this case, we disable the labels
	              // associated with tagging
	              if (attrs.taggingLabel === 'false') {
	                $select.taggingLabel = false;
	              } else {
	                $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
	              }
	            }
	          });
	
	          attrs.$observe('taggingTokens', function () {
	            if (attrs.tagging !== undefined) {
	              var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',', 'ENTER'];
	              $select.taggingTokens = { isActivated: true, tokens: tokens };
	            }
	          });
	
	          //Automatically gets focus when loaded
	          if (angular.isDefined(attrs.autofocus)) {
	            $timeout(function () {
	              $select.setFocus();
	            });
	          }
	
	          //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
	          if (angular.isDefined(attrs.focusOn)) {
	            scope.$on(attrs.focusOn, function () {
	              $timeout(function () {
	                $select.setFocus();
	              });
	            });
	          }
	
	          function onDocumentClick(e) {
	            if (!$select.open) return; //Skip it if dropdown is close
	
	            var contains = false;
	
	            if (window.jQuery) {
	              // Firefox 3.6 does not support element.contains()
	              // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
	              contains = window.jQuery.contains(element[0], e.target);
	            } else {
	              contains = element[0].contains(e.target);
	            }
	
	            if (!contains && !$select.clickTriggeredSelect) {
	              var skipFocusser;
	              if (!$select.skipFocusser) {
	                //Will lose focus only with certain targets
	                var focusableControls = ['input', 'button', 'textarea', 'select'];
	                var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
	                skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
	                if (!skipFocusser) skipFocusser = ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
	              } else {
	                skipFocusser = true;
	              }
	              $select.close(skipFocusser);
	              scope.$digest();
	            }
	            $select.clickTriggeredSelect = false;
	          }
	
	          // See Click everywhere but here event http://stackoverflow.com/questions/12931369
	          $document.on('click', onDocumentClick);
	
	          scope.$on('$destroy', function () {
	            $document.off('click', onDocumentClick);
	          });
	
	          // Move transcluded elements to their correct position in main template
	          transcludeFn(scope, function (clone) {
	            // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html
	
	            // One day jqLite will be replaced by jQuery and we will be able to write:
	            // var transcludedElement = clone.filter('.my-class')
	            // instead of creating a hackish DOM element:
	            var transcluded = angular.element('<div>').append(clone);
	
	            var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
	            transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
	            transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
	            if (transcludedMatch.length !== 1) {
	              throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
	            }
	            element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);
	
	            var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
	            transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
	            transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
	            if (transcludedChoices.length !== 1) {
	              throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
	            }
	            element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);
	
	            var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
	            transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
	            transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
	            if (transcludedNoChoice.length == 1) {
	              element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
	            }
	          });
	
	          // Support for appending the select field to the body when its open
	          var appendToBody = scope.$eval(attrs.appendToBody);
	          if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
	            scope.$watch('$select.open', function (isOpen) {
	              if (isOpen) {
	                positionDropdown();
	              } else {
	                resetDropdown();
	              }
	            });
	
	            // Move the dropdown back to its original location when the scope is destroyed. Otherwise
	            // it might stick around when the user routes away or the select field is otherwise removed
	            scope.$on('$destroy', function () {
	              resetDropdown();
	            });
	          }
	
	          // Hold on to a reference to the .ui-select-container element for appendToBody support
	          var placeholder = null,
	              originalWidth = '';
	
	          function positionDropdown() {
	            // Remember the absolute position of the element
	            var offset = uisOffset(element);
	
	            // Clone the element into a placeholder element to take its original place in the DOM
	            placeholder = angular.element('<div class="ui-select-placeholder"></div>');
	            placeholder[0].style.width = offset.width + 'px';
	            placeholder[0].style.height = offset.height + 'px';
	            element.after(placeholder);
	
	            // Remember the original value of the element width inline style, so it can be restored
	            // when the dropdown is closed
	            originalWidth = element[0].style.width;
	
	            // Now move the actual dropdown element to the end of the body
	            $document.find('body').append(element);
	
	            element[0].style.position = 'absolute';
	            element[0].style.left = offset.left + 'px';
	            element[0].style.top = offset.top + 'px';
	            element[0].style.width = offset.width + 'px';
	          }
	
	          function resetDropdown() {
	            if (placeholder === null) {
	              // The dropdown has not actually been display yet, so there's nothing to reset
	              return;
	            }
	
	            // Move the dropdown element back to its original location in the DOM
	            placeholder.replaceWith(element);
	            placeholder = null;
	
	            element[0].style.position = '';
	            element[0].style.left = '';
	            element[0].style.top = '';
	            element[0].style.width = originalWidth;
	
	            // Set focus back on to the moved element
	            $select.setFocus();
	          }
	
	          // Hold on to a reference to the .ui-select-dropdown element for direction support.
	          var dropdown = null,
	              directionUpClassName = 'direction-up';
	
	          // Support changing the direction of the dropdown if there isn't enough space to render it.
	          scope.$watch('$select.open', function () {
	
	            if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up') {
	              scope.calculateDropdownPos();
	            }
	          });
	
	          var setDropdownPosUp = function setDropdownPosUp(offset, offsetDropdown) {
	
	            offset = offset || uisOffset(element);
	            offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	            dropdown[0].style.position = 'absolute';
	            dropdown[0].style.top = offsetDropdown.height * -1 + 'px';
	            element.addClass(directionUpClassName);
	          };
	
	          var setDropdownPosDown = function setDropdownPosDown(offset, offsetDropdown) {
	
	            element.removeClass(directionUpClassName);
	
	            offset = offset || uisOffset(element);
	            offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	            dropdown[0].style.position = '';
	            dropdown[0].style.top = '';
	          };
	
	          var calculateDropdownPosAfterAnimation = function calculateDropdownPosAfterAnimation() {
	            // Delay positioning the dropdown until all choices have been added so its height is correct.
	            $timeout(function () {
	              if ($select.dropdownPosition === 'up') {
	                //Go UP
	                setDropdownPosUp();
	              } else {
	                //AUTO
	                element.removeClass(directionUpClassName);
	
	                var offset = uisOffset(element);
	                var offsetDropdown = uisOffset(dropdown);
	
	                //https://code.google.com/p/chromium/issues/detail?id=342307#c4
	                var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).
	
	                // Determine if the direction of the dropdown needs to be changed.
	                if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
	                  //Go UP
	                  setDropdownPosUp(offset, offsetDropdown);
	                } else {
	                  //Go DOWN
	                  setDropdownPosDown(offset, offsetDropdown);
	                }
	              }
	
	              // Display the dropdown once it has been positioned.
	              dropdown[0].style.opacity = 1;
	            });
	          };
	
	          scope.calculateDropdownPos = function () {
	            if ($select.open) {
	              dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');
	
	              if (dropdown.length === 0) {
	                return;
	              }
	
	              // Hide the dropdown so there is no flicker until $timeout is done executing.
	              dropdown[0].style.opacity = 0;
	
	              if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
	                var needsCalculated = true;
	
	                $select.$animate.on('enter', dropdown, function (elem, phase) {
	                  if (phase === 'close' && needsCalculated) {
	                    calculateDropdownPosAfterAnimation();
	                    needsCalculated = false;
	                  }
	                });
	              } else {
	                calculateDropdownPosAfterAnimation();
	              }
	            } else {
	              if (dropdown === null || dropdown.length === 0) {
	                return;
	              }
	
	              // Reset the position of the dropdown.
	              dropdown[0].style.opacity = 0;
	              dropdown[0].style.position = '';
	              dropdown[0].style.top = '';
	              element.removeClass(directionUpClassName);
	            }
	          };
	        };
	      }
	    };
	  }]);
	
	  uis.directive('uiSelectMatch', ['uiSelectConfig', function (uiSelectConfig) {
	    return {
	      restrict: 'EA',
	      require: '^uiSelect',
	      replace: true,
	      transclude: true,
	      templateUrl: function templateUrl(tElement) {
	        // Needed so the uiSelect can detect the transcluded content
	        tElement.addClass('ui-select-match');
	
	        var parent = tElement.parent();
	        // Gets theme attribute from parent (ui-select)
	        var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
	        var multi = angular.isDefined(getAttribute(parent, 'multiple'));
	
	        return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');
	      },
	      link: function link(scope, element, attrs, $select) {
	        $select.lockChoiceExpression = attrs.uiLockChoice;
	        attrs.$observe('placeholder', function (placeholder) {
	          $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
	        });
	
	        function setAllowClear(allow) {
	          $select.allowClear = angular.isDefined(allow) ? allow === '' ? true : allow.toLowerCase() === 'true' : false;
	        }
	
	        attrs.$observe('allowClear', setAllowClear);
	        setAllowClear(attrs.allowClear);
	
	        if ($select.multiple) {
	          $select.sizeSearchInput();
	        }
	      }
	    };
	
	    function getAttribute(elem, attribute) {
	      if (elem[0].hasAttribute(attribute)) return elem.attr(attribute);
	
	      if (elem[0].hasAttribute('data-' + attribute)) return elem.attr('data-' + attribute);
	
	      if (elem[0].hasAttribute('x-' + attribute)) return elem.attr('x-' + attribute);
	    }
	  }]);
	
	  uis.directive('uiSelectMultiple', ['uiSelectMinErr', '$timeout', function (uiSelectMinErr, $timeout) {
	    return {
	      restrict: 'EA',
	      require: ['^uiSelect', '^ngModel'],
	
	      controller: ['$scope', '$timeout', function ($scope, $timeout) {
	
	        var ctrl = this,
	            $select = $scope.$select,
	            ngModel;
	
	        if (angular.isUndefined($select.selected)) $select.selected = [];
	
	        //Wait for link fn to inject it
	        $scope.$evalAsync(function () {
	          ngModel = $scope.ngModel;
	        });
	
	        ctrl.activeMatchIndex = -1;
	
	        ctrl.updateModel = function () {
	          ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
	          ctrl.refreshComponent();
	        };
	
	        ctrl.refreshComponent = function () {
	          //Remove already selected items
	          //e.g. When user clicks on a selection, the selected array changes and
	          //the dropdown should remove that item
	          if ($select.refreshItems) {
	            $select.refreshItems();
	          }
	          if ($select.sizeSearchInput) {
	            $select.sizeSearchInput();
	          }
	        };
	
	        // Remove item from multiple select
	        ctrl.removeChoice = function (index) {
	
	          // if the choice is locked, don't remove it
	          if ($select.isLocked(null, index)) return false;
	
	          var removedChoice = $select.selected[index];
	
	          var locals = {};
	          locals[$select.parserResult.itemName] = removedChoice;
	
	          $select.selected.splice(index, 1);
	          ctrl.activeMatchIndex = -1;
	          $select.sizeSearchInput();
	
	          // Give some time for scope propagation.
	          $timeout(function () {
	            $select.onRemoveCallback($scope, {
	              $item: removedChoice,
	              $model: $select.parserResult.modelMapper($scope, locals)
	            });
	          });
	
	          ctrl.updateModel();
	
	          return true;
	        };
	
	        ctrl.getPlaceholder = function () {
	          //Refactor single?
	          if ($select.selected && $select.selected.length) return;
	          return $select.placeholder;
	        };
	      }],
	      controllerAs: '$selectMultiple',
	
	      link: function link(scope, element, attrs, ctrls) {
	
	        var $select = ctrls[0];
	        var ngModel = scope.ngModel = ctrls[1];
	        var $selectMultiple = scope.$selectMultiple;
	
	        //$select.selected = raw selected objects (ignoring any property binding)
	
	        $select.multiple = true;
	
	        //Input that will handle focus
	        $select.focusInput = $select.searchInput;
	
	        //Properly check for empty if set to multiple
	        ngModel.$isEmpty = function (value) {
	          return !value || value.length === 0;
	        };
	
	        //From view --> model
	        ngModel.$parsers.unshift(function () {
	          var locals = {},
	              result,
	              resultMultiple = [];
	          for (var j = $select.selected.length - 1; j >= 0; j--) {
	            locals = {};
	            locals[$select.parserResult.itemName] = $select.selected[j];
	            result = $select.parserResult.modelMapper(scope, locals);
	            resultMultiple.unshift(result);
	          }
	          return resultMultiple;
	        });
	
	        // From model --> view
	        ngModel.$formatters.unshift(function (inputValue) {
	          var data = $select.parserResult && $select.parserResult.source(scope, { $select: { search: '' } }),
	              //Overwrite $search
	          locals = {},
	              result;
	          if (!data) return inputValue;
	          var resultMultiple = [];
	          var checkFnMultiple = function checkFnMultiple(list, value) {
	            if (!list || !list.length) return;
	            for (var p = list.length - 1; p >= 0; p--) {
	              locals[$select.parserResult.itemName] = list[p];
	              result = $select.parserResult.modelMapper(scope, locals);
	              if ($select.parserResult.trackByExp) {
	                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
	                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
	                if (propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName) {
	                  if (matches && matches.length > 0 && result[matches[1]] == value[matches[1]]) {
	                    resultMultiple.unshift(list[p]);
	                    return true;
	                  }
	                }
	              }
	              if (angular.equals(result, value)) {
	                resultMultiple.unshift(list[p]);
	                return true;
	              }
	            }
	            return false;
	          };
	          if (!inputValue) return resultMultiple; //If ngModel was undefined
	          for (var k = inputValue.length - 1; k >= 0; k--) {
	            //Check model array of currently selected items
	            if (!checkFnMultiple($select.selected, inputValue[k])) {
	              //Check model array of all items available
	              if (!checkFnMultiple(data, inputValue[k])) {
	                //If not found on previous lists, just add it directly to resultMultiple
	                resultMultiple.unshift(inputValue[k]);
	              }
	            }
	          }
	          return resultMultiple;
	        });
	
	        //Watch for external model changes
	        scope.$watchCollection(function () {
	          return ngModel.$modelValue;
	        }, function (newValue, oldValue) {
	          if (oldValue != newValue) {
	            //update the view value with fresh data from items, if there is a valid model value
	            if (angular.isDefined(ngModel.$modelValue)) {
	              ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	            }
	            $selectMultiple.refreshComponent();
	          }
	        });
	
	        ngModel.$render = function () {
	          // Make sure that model value is array
	          if (!angular.isArray(ngModel.$viewValue)) {
	            // Have tolerance for null or undefined values
	            if (angular.isUndefined(ngModel.$viewValue) || ngModel.$viewValue === null) {
	              ngModel.$viewValue = [];
	            } else {
	              throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
	            }
	          }
	          $select.selected = ngModel.$viewValue;
	          $selectMultiple.refreshComponent();
	          scope.$evalAsync(); //To force $digest
	        };
	
	        scope.$on('uis:select', function (event, item) {
	          if ($select.selected.length >= $select.limit) {
	            return;
	          }
	          $select.selected.push(item);
	          $selectMultiple.updateModel();
	        });
	
	        scope.$on('uis:activate', function () {
	          $selectMultiple.activeMatchIndex = -1;
	        });
	
	        scope.$watch('$select.disabled', function (newValue, oldValue) {
	          // As the search input field may now become visible, it may be necessary to recompute its size
	          if (oldValue && !newValue) $select.sizeSearchInput();
	        });
	
	        $select.searchInput.on('keydown', function (e) {
	          var key = e.which;
	          scope.$apply(function () {
	            var processed = false;
	            // var tagged = false; //Checkme
	            if (KEY.isHorizontalMovement(key)) {
	              processed = _handleMatchSelection(key);
	            }
	            if (processed && key != KEY.TAB) {
	              //TODO Check si el tab selecciona aun correctamente
	              //Crear test
	              e.preventDefault();
	              e.stopPropagation();
	            }
	          });
	        });
	        function _getCaretPosition(el) {
	          if (angular.isNumber(el.selectionStart)) return el.selectionStart;
	          // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
	          else return el.value.length;
	        }
	        // Handles selected options in "multiple" mode
	        function _handleMatchSelection(key) {
	          var caretPosition = _getCaretPosition($select.searchInput[0]),
	              length = $select.selected.length,
	
	          // none  = -1,
	          first = 0,
	              last = length - 1,
	              curr = $selectMultiple.activeMatchIndex,
	              next = $selectMultiple.activeMatchIndex + 1,
	              prev = $selectMultiple.activeMatchIndex - 1,
	              newIndex = curr;
	
	          if (caretPosition > 0 || $select.search.length && key == KEY.RIGHT) return false;
	
	          $select.close();
	
	          function getNewActiveMatchIndex() {
	            switch (key) {
	              case KEY.LEFT:
	                // Select previous/first item
	                if (~$selectMultiple.activeMatchIndex) return prev;
	                // Select last item
	                else return last;
	                break;
	              case KEY.RIGHT:
	                // Open drop-down
	                if (!~$selectMultiple.activeMatchIndex || curr === last) {
	                  $select.activate();
	                  return false;
	                }
	                // Select next/last item
	                else return next;
	                break;
	              case KEY.BACKSPACE:
	                // Remove selected item and select previous/first
	                if (~$selectMultiple.activeMatchIndex) {
	                  if ($selectMultiple.removeChoice(curr)) {
	                    return prev;
	                  } else {
	                    return curr;
	                  }
	                } else {
	                  // If nothing yet selected, select last item
	                  return last;
	                }
	                break;
	              case KEY.DELETE:
	                // Remove selected item and select next item
	                if (~$selectMultiple.activeMatchIndex) {
	                  $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
	                  return curr;
	                } else return false;
	            }
	          }
	
	          newIndex = getNewActiveMatchIndex();
	
	          if (!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;else $selectMultiple.activeMatchIndex = Math.min(last, Math.max(first, newIndex));
	
	          return true;
	        }
	
	        $select.searchInput.on('keyup', function (e) {
	
	          if (!KEY.isVerticalMovement(e.which)) {
	            scope.$evalAsync(function () {
	              $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	            });
	          }
	          // Push a "create new" item into array if there is a search string
	          if ($select.tagging.isActivated && $select.search.length > 0) {
	
	            // return early with these keys
	            if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which)) {
	              return;
	            }
	            // always reset the activeIndex to the first item when tagging
	            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	            // taggingLabel === false bypasses all of this
	            if ($select.taggingLabel === false) return;
	
	            var items = angular.copy($select.items);
	            var stashArr = angular.copy($select.items);
	            var newItem;
	            var item;
	            var hasTag = false;
	            var dupeIndex = -1;
	            var tagItems;
	            var tagItem;
	
	            // case for object tagging via transform `$select.tagging.fct` function
	            if ($select.tagging.fct !== undefined) {
	              tagItems = $select.$filter('filter')(items, { 'isTag': true });
	              if (tagItems.length > 0) {
	                tagItem = tagItems[0];
	              }
	              // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
	              if (items.length > 0 && tagItem) {
	                hasTag = true;
	                items = items.slice(1, items.length);
	                stashArr = stashArr.slice(1, stashArr.length);
	              }
	              newItem = $select.tagging.fct($select.search);
	              // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
	              if (stashArr.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              }) || $select.selected.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              })) {
	                scope.$evalAsync(function () {
	                  $select.activeIndex = 0;
	                  $select.items = items;
	                });
	                return;
	              }
	              if (newItem) newItem.isTag = true;
	              // handle newItem string and stripping dupes in tagging string context
	            } else {
	              // find any tagging items already in the $select.items array and store them
	              tagItems = $select.$filter('filter')(items, function (item) {
	                return item.match($select.taggingLabel);
	              });
	              if (tagItems.length > 0) {
	                tagItem = tagItems[0];
	              }
	              item = items[0];
	              // remove existing tag item if found (should only ever be one tag item)
	              if (item !== undefined && items.length > 0 && tagItem) {
	                hasTag = true;
	                items = items.slice(1, items.length);
	                stashArr = stashArr.slice(1, stashArr.length);
	              }
	              newItem = $select.search + ' ' + $select.taggingLabel;
	              if (_findApproxDupe($select.selected, $select.search) > -1) {
	                return;
	              }
	              // verify the the tag doesn't match the value of an existing item from
	              // the searched data set or the items already selected
	              if (_findCaseInsensitiveDupe(stashArr.concat($select.selected))) {
	                // if there is a tag from prev iteration, strip it / queue the change
	                // and return early
	                if (hasTag) {
	                  items = stashArr;
	                  scope.$evalAsync(function () {
	                    $select.activeIndex = 0;
	                    $select.items = items;
	                  });
	                }
	                return;
	              }
	              if (_findCaseInsensitiveDupe(stashArr)) {
	                // if there is a tag from prev iteration, strip it
	                if (hasTag) {
	                  $select.items = stashArr.slice(1, stashArr.length);
	                }
	                return;
	              }
	            }
	            if (hasTag) dupeIndex = _findApproxDupe($select.selected, newItem);
	            // dupe found, shave the first item
	            if (dupeIndex > -1) {
	              items = items.slice(dupeIndex + 1, items.length - 1);
	            } else {
	              items = [];
	              if (newItem) items.push(newItem);
	              items = items.concat(stashArr);
	            }
	            scope.$evalAsync(function () {
	              $select.activeIndex = 0;
	              $select.items = items;
	
	              if ($select.isGrouped) {
	                // update item references in groups, so that indexOf will work after angular.copy
	                var itemsWithoutTag = newItem ? items.slice(1) : items;
	                $select.setItemsFn(itemsWithoutTag);
	                if (newItem) {
	                  // add tag item as a new group
	                  $select.items.unshift(newItem);
	                  $select.groups.unshift({ name: '', items: [newItem], tagging: true });
	                }
	              }
	            });
	          }
	        });
	        function _findCaseInsensitiveDupe(arr) {
	          if (arr === undefined || $select.search === undefined) {
	            return false;
	          }
	          var hasDupe = arr.filter(function (origItem) {
	            if ($select.search.toUpperCase() === undefined || origItem === undefined) {
	              return false;
	            }
	            return origItem.toUpperCase() === $select.search.toUpperCase();
	          }).length > 0;
	
	          return hasDupe;
	        }
	        function _findApproxDupe(haystack, needle) {
	          var dupeIndex = -1;
	          if (angular.isArray(haystack)) {
	            var tempArr = angular.copy(haystack);
	            for (var i = 0; i < tempArr.length; i++) {
	              // handle the simple string version of tagging
	              if ($select.tagging.fct === undefined) {
	                // search the array for the match
	                if (tempArr[i] + ' ' + $select.taggingLabel === needle) {
	                  dupeIndex = i;
	                }
	                // handle the object tagging implementation
	              } else {
	                var mockObj = tempArr[i];
	                if (angular.isObject(mockObj)) {
	                  mockObj.isTag = true;
	                }
	                if (angular.equals(mockObj, needle)) {
	                  dupeIndex = i;
	                }
	              }
	            }
	          }
	          return dupeIndex;
	        }
	
	        $select.searchInput.on('blur', function () {
	          $timeout(function () {
	            $selectMultiple.activeMatchIndex = -1;
	          });
	        });
	      }
	    };
	  }]);
	
	  uis.directive('uiSelectNoChoice', ['uiSelectConfig', function (uiSelectConfig) {
	    return {
	      restrict: 'EA',
	      require: '^uiSelect',
	      replace: true,
	      transclude: true,
	      templateUrl: function templateUrl(tElement) {
	        // Needed so the uiSelect can detect the transcluded content
	        tElement.addClass('ui-select-no-choice');
	
	        // Gets theme attribute from parent (ui-select)
	        var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	        return theme + '/no-choice.tpl.html';
	      }
	    };
	  }]);
	
	  uis.directive('uiSelectSingle', ['$timeout', '$compile', function ($timeout, $compile) {
	    return {
	      restrict: 'EA',
	      require: ['^uiSelect', '^ngModel'],
	      link: function link(scope, element, attrs, ctrls) {
	
	        var $select = ctrls[0];
	        var ngModel = ctrls[1];
	
	        //From view --> model
	        ngModel.$parsers.unshift(function (inputValue) {
	          var locals = {},
	              result;
	          locals[$select.parserResult.itemName] = inputValue;
	          result = $select.parserResult.modelMapper(scope, locals);
	          return result;
	        });
	
	        //From model --> view
	        ngModel.$formatters.unshift(function (inputValue) {
	          var data = $select.parserResult && $select.parserResult.source(scope, { $select: { search: '' } }),
	              //Overwrite $search
	          locals = {},
	              result;
	          if (data) {
	            var checkFnSingle = function checkFnSingle(d) {
	              locals[$select.parserResult.itemName] = d;
	              result = $select.parserResult.modelMapper(scope, locals);
	              return result === inputValue;
	            };
	            //If possible pass same object stored in $select.selected
	            if ($select.selected && checkFnSingle($select.selected)) {
	              return $select.selected;
	            }
	            for (var i = data.length - 1; i >= 0; i--) {
	              if (checkFnSingle(data[i])) return data[i];
	            }
	          }
	          return inputValue;
	        });
	
	        //Update viewValue if model change
	        scope.$watch('$select.selected', function (newValue) {
	          if (ngModel.$viewValue !== newValue) {
	            ngModel.$setViewValue(newValue);
	          }
	        });
	
	        ngModel.$render = function () {
	          $select.selected = ngModel.$viewValue;
	        };
	
	        scope.$on('uis:select', function (event, item) {
	          $select.selected = item;
	        });
	
	        scope.$on('uis:close', function (event, skipFocusser) {
	          $timeout(function () {
	            $select.focusser.prop('disabled', false);
	            if (!skipFocusser) $select.focusser[0].focus();
	          }, 0, false);
	        });
	
	        scope.$on('uis:activate', function () {
	          focusser.prop('disabled', true); //Will reactivate it on .close()
	        });
	
	        //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
	        var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
	        $compile(focusser)(scope);
	        $select.focusser = focusser;
	
	        //Input that will handle focus
	        $select.focusInput = focusser;
	
	        element.parent().append(focusser);
	        focusser.bind("focus", function () {
	          scope.$evalAsync(function () {
	            $select.focus = true;
	          });
	        });
	        focusser.bind("blur", function () {
	          scope.$evalAsync(function () {
	            $select.focus = false;
	          });
	        });
	        focusser.bind("keydown", function (e) {
	
	          if (e.which === KEY.BACKSPACE) {
	            e.preventDefault();
	            e.stopPropagation();
	            $select.select(undefined);
	            scope.$apply();
	            return;
	          }
	
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	            return;
	          }
	
	          if (e.which == KEY.DOWN || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE) {
	            e.preventDefault();
	            e.stopPropagation();
	            $select.activate();
	          }
	
	          scope.$digest();
	        });
	
	        focusser.bind("keyup input", function (e) {
	
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
	            return;
	          }
	
	          $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
	          focusser.val('');
	          scope.$digest();
	        });
	      }
	    };
	  }]);
	
	  // Make multiple matches sortable
	  uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function ($timeout, uiSelectConfig, uiSelectMinErr) {
	    return {
	      require: ['^^uiSelect', '^ngModel'],
	      link: function link(scope, element, attrs, ctrls) {
	        if (scope[attrs.uiSelectSort] === null) {
	          throw uiSelectMinErr('sort', 'Expected a list to sort');
	        }
	
	        var $select = ctrls[0];
	        var $ngModel = ctrls[1];
	
	        var options = angular.extend({
	          axis: 'horizontal'
	        }, scope.$eval(attrs.uiSelectSortOptions));
	
	        var axis = options.axis;
	        var draggingClassName = 'dragging';
	        var droppingClassName = 'dropping';
	        var droppingBeforeClassName = 'dropping-before';
	        var droppingAfterClassName = 'dropping-after';
	
	        scope.$watch(function () {
	          return $select.sortable;
	        }, function (newValue) {
	          if (newValue) {
	            element.attr('draggable', true);
	          } else {
	            element.removeAttr('draggable');
	          }
	        });
	
	        element.on('dragstart', function (event) {
	          element.addClass(draggingClassName);
	
	          (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
	        });
	
	        element.on('dragend', function () {
	          removeClass(draggingClassName);
	        });
	
	        var move = function move(from, to) {
	          /*jshint validthis: true */
	          this.splice(to, 0, this.splice(from, 1)[0]);
	        };
	
	        var removeClass = function removeClass(className) {
	          angular.forEach($select.$element.querySelectorAll('.' + className), function (el) {
	            angular.element(el).removeClass(className);
	          });
	        };
	
	        var dragOverHandler = function dragOverHandler(event) {
	          event.preventDefault();
	
	          var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);
	
	          if (offset < this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2) {
	            removeClass(droppingAfterClassName);
	            element.addClass(droppingBeforeClassName);
	          } else {
	            removeClass(droppingBeforeClassName);
	            element.addClass(droppingAfterClassName);
	          }
	        };
	
	        var dropTimeout;
	
	        var dropHandler = function dropHandler(event) {
	          event.preventDefault();
	
	          var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);
	
	          // prevent event firing multiple times in firefox
	          $timeout.cancel(dropTimeout);
	          dropTimeout = $timeout(function () {
	            _dropHandler(droppedItemIndex);
	          }, 20);
	        };
	
	        var _dropHandler = function _dropHandler(droppedItemIndex) {
	          var theList = scope.$eval(attrs.uiSelectSort);
	          var itemToMove = theList[droppedItemIndex];
	          var newIndex = null;
	
	          if (element.hasClass(droppingBeforeClassName)) {
	            if (droppedItemIndex < scope.$index) {
	              newIndex = scope.$index - 1;
	            } else {
	              newIndex = scope.$index;
	            }
	          } else {
	            if (droppedItemIndex < scope.$index) {
	              newIndex = scope.$index;
	            } else {
	              newIndex = scope.$index + 1;
	            }
	          }
	
	          move.apply(theList, [droppedItemIndex, newIndex]);
	
	          $ngModel.$setViewValue(Date.now());
	
	          scope.$apply(function () {
	            scope.$emit('uiSelectSort:change', {
	              array: theList,
	              item: itemToMove,
	              from: droppedItemIndex,
	              to: newIndex
	            });
	          });
	
	          removeClass(droppingClassName);
	          removeClass(droppingBeforeClassName);
	          removeClass(droppingAfterClassName);
	
	          element.off('drop', dropHandler);
	        };
	
	        element.on('dragenter', function () {
	          if (element.hasClass(draggingClassName)) {
	            return;
	          }
	
	          element.addClass(droppingClassName);
	
	          element.on('dragover', dragOverHandler);
	          element.on('drop', dropHandler);
	        });
	
	        element.on('dragleave', function (event) {
	          if (event.target != element) {
	            return;
	          }
	
	          removeClass(droppingClassName);
	          removeClass(droppingBeforeClassName);
	          removeClass(droppingAfterClassName);
	
	          element.off('dragover', dragOverHandler);
	          element.off('drop', dropHandler);
	        });
	      }
	    };
	  }]);
	
	  /**
	   * Debounces functions
	   *
	   * Taken from UI Bootstrap $$debounce source code
	   * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
	   *
	   */
	  uis.factory('$$uisDebounce', ['$timeout', function ($timeout) {
	    return function (callback, debounceTime) {
	      var timeoutPromise;
	
	      return function () {
	        var self = this;
	        var args = Array.prototype.slice.call(arguments);
	        if (timeoutPromise) {
	          $timeout.cancel(timeoutPromise);
	        }
	
	        timeoutPromise = $timeout(function () {
	          callback.apply(self, args);
	        }, debounceTime);
	      };
	    };
	  }]);
	
	  /**
	   * Parses "repeat" attribute.
	   *
	   * Taken from AngularJS ngRepeat source code
	   * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
	   *
	   * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
	   * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
	   */
	
	  uis.service('uisRepeatParser', ['uiSelectMinErr', '$parse', function (uiSelectMinErr, $parse) {
	    var self = this;
	
	    /**
	     * Example:
	     * expression = "address in addresses | filter: {street: $select.search} track by $index"
	     * itemName = "address",
	     * source = "addresses | filter: {street: $select.search}",
	     * trackByExp = "$index",
	     */
	    self.parse = function (expression) {
	
	      var match;
	      //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
	      // If an array is used as collection
	
	      // if (isObjectCollection){
	      // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
	      match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      // 1 Alias
	      // 2 Item
	      // 3 Key on (key,value)
	      // 4 Value on (key,value)
	      // 5 Source expression (including filters)
	      // 6 Track by
	
	      if (!match) {
	        throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.", expression);
	      }
	
	      var source = match[5],
	          filters = '';
	
	      // When using (key,value) ui-select requires filters to be extracted, since the object
	      // is converted to an array for $select.items 
	      // (in which case the filters need to be reapplied)
	      if (match[3]) {
	        // Remove any enclosing parenthesis
	        source = match[5].replace(/(^\()|(\)$)/g, '');
	        // match all after | but not after ||
	        var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
	        if (filterMatch && filterMatch[1].trim()) {
	          filters = filterMatch[1];
	          source = source.replace(filters, '');
	        }
	      }
	
	      return {
	        itemName: match[4] || match[2], // (lhs) Left-hand side,
	        keyName: match[3], //for (key, value) syntax
	        source: $parse(source),
	        filters: filters,
	        trackByExp: match[6],
	        modelMapper: $parse(match[1] || match[4] || match[2]),
	        repeatExpression: function repeatExpression(grouped) {
	          var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
	          if (this.trackByExp) {
	            expression += ' track by ' + this.trackByExp;
	          }
	          return expression;
	        }
	      };
	    };
	
	    self.getGroupNgRepeatExpression = function () {
	      return '$group in $select.groups';
	    };
	  }]);
	})();
	angular.module("ui.select").run(["$templateCache", function ($templateCache) {
	  $templateCache.put("bootstrap/choices.tpl.html", "<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" role=\"listbox\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><a href=\"\" class=\"ui-select-choices-row-inner\"></a></div></li></ul>");
	  $templateCache.put("bootstrap/match-multiple.tpl.html", "<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
	  $templateCache.put("bootstrap/match.tpl.html", "<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
	  $templateCache.put("bootstrap/no-choice.tpl.html", "<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
	  $templateCache.put("bootstrap/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	  $templateCache.put("bootstrap/select.tpl.html", "<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"form-control ui-select-search\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.searchEnabled && $select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	  $templateCache.put("select2/choices.tpl.html", "<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul role=\"listbox\" id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
	  $templateCache.put("select2/match-multiple.tpl.html", "<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
	  $templateCache.put("select2/match.tpl.html", "<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
	  $templateCache.put("select2/no-choice.tpl.html", "<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	  $templateCache.put("select2/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
	  $templateCache.put("select2/select.tpl.html", "<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"select2-search\" ng-show=\"$select.searchEnabled\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");
	  $templateCache.put("selectize/choices.tpl.html", "<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown single\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\" role=\"listbox\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
	  $templateCache.put("selectize/match.tpl.html", "<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\" ng-transclude=\"\"></div>");
	  $templateCache.put("selectize/no-choice.tpl.html", "<div class=\"ui-select-no-choice selectize-dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"selectize-dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	  $templateCache.put("selectize/select.tpl.html", "<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.searchEnabled || (!$select.isEmpty() && !$select.open)\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	}]);

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(342);
	module.exports = 'ui.select';

/***/ },
/* 344 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 345 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><uib-alert type=info close=dismissAlert() ng-show=!has_seen_alert>Welcome to the <a href=https://github.com/marmelab/ng-admin>ng-admin</a> demo! Fell free to explore and modify the data - it's local to your computer, and will reset each time you reload.</uib-alert></div></div><div class=row><div class=col-lg-3><div class=\"panel panel-primary\"><div class=panel-heading><div class=row><div class=col-xs-3><i class=\"fa fa-usd fa-5x\"></i></div><div class=\"col-xs-9 text-right\"><div class=huge>{{ stats.commands.revenue | number:0 }}</div><div>Monthly revenue</div></div></div></div><a ui-sref=\"list({entity:'commands'})\"><div class=panel-footer><span class=pull-left>View Details</span> <span class=pull-right><i class=\"fa fa-arrow-circle-right\"></i></span><div class=clearfix></div></div></a></div></div><div class=col-lg-3><div class=\"panel panel-green\"><div class=panel-heading><div class=row><div class=col-xs-3><i class=\"fa fa-shopping-cart fa-5x\"></i></div><div class=\"col-xs-9 text-right\"><div class=huge>{{ stats.commands.pending_orders }}</div><div>Pending orders</div></div></div></div><a ui-sref=\"list({entity:'commands',search:{status:'ordered'}})\"><div class=panel-footer><span class=pull-left>View Details</span> <span class=pull-right><i class=\"fa fa-arrow-circle-right\"></i></span><div class=clearfix></div></div></a></div></div><div class=col-lg-3><div class=\"panel panel-yellow\"><div class=panel-heading><div class=row><div class=col-xs-3><i class=\"fa fa-comments fa-5x\"></i></div><div class=\"col-xs-9 text-right\"><div class=huge>{{ stats.reviews }}</div><div>Pending reviews</div></div></div></div><a ui-sref=\"list({entity:'reviews', search:{status:'pending'}})\"><div class=panel-footer><span class=pull-left>View Details</span> <span class=pull-right><i class=\"fa fa-arrow-circle-right\"></i></span><div class=clearfix></div></div></a></div></div><div class=col-lg-3><div class=\"panel panel-red\"><div class=panel-heading><div class=row><div class=col-xs-3><i class=\"fa fa-user-plus fa-5x\"></i></div><div class=\"col-xs-9 text-right\"><div class=huge>{{ stats.customers }}</div><div>New customers</div></div></div></div><a ui-sref=\"list({entity:'customers',search:{has_ordered:true}})\"><div class=panel-footer><span class=pull-left>View Details</span> <span class=pull-right><i class=\"fa fa-arrow-circle-right\"></i></span><div class=clearfix></div></div></a></div></div></div>";

/***/ },
/* 346 */
/***/ function(module, exports) {

	module.exports = "<div class=navbar-header><button type=button class=navbar-toggle ng-click=\"isCollapsed = !isCollapsed\"><span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand href=# ng-click=appController.displayHome()>Posters Galore Backend</a></div><ul class=\"nav navbar-top-links navbar-right hidden-xs\"><li><a href=https://github.com/marmelab/ng-admin-demo><i class=\"fa fa-github fa-lg\"></i>&nbsp;Source</a></li><li uib-dropdown><a uib-dropdown-toggle href=# aria-expanded=true ng-controller=username><i class=\"fa fa-user fa-lg\"></i>&nbsp;{{ username }}&nbsp;<i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-user\" role=menu><li><a href=# onclick=logout()><i class=\"fa fa-sign-out fa-fw\"></i> Logout</a></li></ul></li></ul>";

/***/ },
/* 347 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div class=page-header><ma-view-actions entry=entry entity=::formController.entity><ma-list-button entity=::entity></ma-list-button><ma-delete-button entry=entry entity=::entity></ma-delete-button></ma-view-actions><h1>Poster #{{ ::entry.values.reference }}</h1></div></div></div><div class=\"row ng-admin-entity-products\" id=edit-view><form class=\"col-lg-12 form-horizontal\" name=formController.form ng-submit=formController.submitEdition($event)><div class=row><div class=col-lg-6><div ng-init=\"field=formController.fields[0]\" id=row-reference class=\"form-group has-feedback\" ng-class=\"formController.form.reference.$dirty ? (formController.form.reference.$valid ? 'has-success' : 'has-error') : ''\"><label for=reference class=\"col-sm-4 control-label\">Reference&nbsp;*&nbsp;</label><div class=col-sm-8><ma-input-field field=::field value=entry.values.reference></ma-input-field><span ng-show=formController.form.reference.$dirty class=\"glyphicon form-control-feedback\" ng-class=\"formController.form.reference.$valid ? 'glyphicon-ok' : 'glyphicon-remove'\"></span></div></div><div ng-init=\"field=formController.fields[1]\" id=row-price class=\"form-group has-feedback\" ng-class=\"formController.form.price.$dirty ? (formController.form.price.$valid ? 'has-success' : 'has-error') : ''\"><label for=price class=\"col-sm-4 control-label\">Price&nbsp;*&nbsp;</label><div class=col-sm-8><div class=input-group><span class=input-group-addon>$</span><ma-input-field type=number step=any field=::field value=entry.values.price></ma-input-field></div><span ng-show=formController.form.price.$dirty class=\"glyphicon form-control-feedback\" ng-class=\"formController.form.price.$valid ? 'glyphicon-ok' : 'glyphicon-remove'\"></span></div></div><div ng-init=\"field=formController.fields[2]\" id=row-width class=\"form-group has-feedback\" ng-class=\"formController.form.width.$dirty ? (formController.form.width.$valid ? 'has-success' : 'has-error') : ''\"><label for=width class=\"col-sm-4 control-label\">Width&nbsp;*&nbsp;</label><div class=col-sm-4><ma-input-field type=number step=any field=::field value=entry.values.width></ma-input-field><span ng-show=formController.form.width.$dirty class=\"glyphicon form-control-feedback\" ng-class=\"formController.form.width.$valid ? 'glyphicon-ok' : 'glyphicon-remove'\"></span></div></div><div ng-init=\"field=formController.fields[3]\" id=row-height class=\"form-group has-feedback\" ng-class=\"formController.form.height.$dirty ? (formController.form.height.$valid ? 'has-success' : 'has-error') : ''\"><label for=height class=\"col-sm-4 control-label\">Height&nbsp;*&nbsp;</label><div class=col-sm-4><ma-input-field type=number step=any field=::field value=entry.values.height></ma-input-field><span ng-show=formController.form.height.$dirty class=\"glyphicon form-control-feedback\" ng-class=\"formController.form.height.$valid ? 'glyphicon-ok' : 'glyphicon-remove'\"></span></div></div><div ng-init=\"field=formController.fields[4]\" id=row-category_id class=\"form-group has-feedback\" ng-class=\"formController.form.category.$dirty ? (formController.form.category.$valid ? 'has-success' : 'has-error') : ''\"><label for=category_id class=\"col-sm-4 control-label\">Category&nbsp;*&nbsp;</label><div class=col-sm-8><ma-reference-field field=::field value=entry.values.category_id datastore=::formController.dataStore></ma-reference-field><span ng-show=formController.form.category_id.$dirty class=\"glyphicon form-control-feedback\" ng-class=\"formController.form.category_id.$valid ? 'glyphicon-ok' : 'glyphicon-remove'\"></span></div></div><div ng-init=\"field=formController.fields[5]\" id=row-stock class=\"form-group has-feedback\" ng-class=\"formController.form.stock.$dirty ? (formController.form.stock.$valid ? 'has-success' : 'has-error') : ''\"><label for=stock class=\"col-sm-4 control-label\">Stock&nbsp;*&nbsp;</label><div class=col-sm-4><ma-input-field type=number step=1 field=::field value=entry.values.stock></ma-input-field><span ng-show=formController.form.stock.$dirty class=\"glyphicon form-control-feedback\" ng-class=\"formController.form.stock.$valid ? 'glyphicon-ok' : 'glyphicon-remove'\"></span></div></div><div ng-init=\"field=formController.fields[6]\" id=row-thumbnail class=\"form-group has-feedback\" ng-class=\"formController.form.thumbnail.$dirty ? (formController.form.thumbnail.$valid ? 'has-success' : 'has-error') : ''\"><label for=thumbnail class=\"col-sm-4 control-label\">thumbnail&nbsp;*&nbsp;</label><div class=col-sm-8><ma-input-field field=::field value=entry.values.thumbnail></ma-input-field><span ng-show=formController.form.thumbnail.$dirty class=\"glyphicon form-control-feedback\" ng-class=\"formController.form.thumbnail.$valid ? 'glyphicon-ok' : 'glyphicon-remove'\"></span></div></div><div ng-init=\"field=formController.fields[7]\" id=row-image class=\"form-group has-feedback\" ng-class=\"formController.form.image.$dirty ? (formController.form.image.$valid ? 'has-success' : 'has-error') : ''\"><label for=image class=\"col-sm-4 control-label\">Image&nbsp;*&nbsp;</label><div class=col-sm-8><ma-input-field field=::field value=entry.values.image></ma-input-field><span ng-show=formController.form.image.$dirty class=\"glyphicon form-control-feedback\" ng-class=\"formController.form.image.$valid ? 'glyphicon-ok' : 'glyphicon-remove'\"></span></div></div><div ng-init=\"field=formController.fields[8]\" id=row-image class=form-group><div class=col-sm-12><ma-wysiwyg-field field=::field value=entry.values.description></ma-wysiwyg-field></div></div><div class=form-group><div class=\"col-sm-offset-4 col-sm-8\"><button type=submit class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-ok\"></span> Save Changes</button></div></div></div><div class=col-lg-6><img src=\"{{ entry.values.image }}\" class=\"img-thumbnail img-responsive\"></div></div><div class=row><div class=col-lg-12><div ng-init=\"field=formController.fields[9]\" id=row-reviews class=\"form-group has-feedback\" ng-class=getFieldValidationClass(field)><label for=reviews class=\"col-sm-2 control-label\">Reviews</label><div class=col-sm-10><ma-referenced-list-column field=::field datastore=::formController.dataStore></ma-referenced-list-column><ma-filtered-list-button entity-name=reviews filter=\"{ product_id: entry.values.id }\"></ma-filtered-list-button></div></div></div></div></form></div>";

/***/ },
/* 348 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row list-header\"><div class=col-lg-12><div class=page-header><h1>Customers Segments</h1></div></div></div><div class=\"row list-view\"><div class=col-lg-12><table class=\"grid table table-condensed table-hover table-striped\"><thead><tr><th>Name<th class=ng-admin-column-actions>Actions<tbody><tr ng-repeat=\"segment in segments\"><td>{{ segment }}<td class=ng-admin-column-actions><ma-filtered-list-button entity-name=customers filter=\"{ groups: segment }\" size=xs></ma-filtered-list-button></table></div></div>";

/***/ },
/* 349 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row list-header\"><div class=col-lg-12><div class=page-header><ma-view-actions override=::batchDeleteController.actions selection=batchDeleteController.selection entity=::batchDeleteController.entity><ma-list-button ng-if=::entity.listView().enabled entity=::entity></ma-list-button></ma-view-actions><h1 compile=::batchDeleteController.title>{{ 'DELETE' | translate }} {{ ::batchDeleteController.entityIds.length }} {{ ::batchDeleteController.view.entity.name() | humanize | pluralize | translate }}</h1></div></div></div><div class=row><div class=col-lg-12><p translate=ARE_YOU_SURE></p><button class=\"btn btn-danger\" ng-click=batchDeleteController.batchDelete() translate=YES></button> <button class=\"btn btn-default\" ng-click=batchDeleteController.back() translate=NO></button></div></div><div ng-if=selection class=\"row list-view\" ng-class=\"::'ng-admin-entity-' + batchDeleteController.entity.name()\"><div class=col-lg-12><ma-datagrid name=\"{{ ::batchDeleteController.view.name() }}\" entries=batchDeleteController.selection fields=::batchDeleteController.fields entity=::batchDeleteController.entity></ma-datagrid></div></div>";

/***/ },
/* 350 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div class=page-header><ma-view-actions override=::deleteController.actions entry=::entry entity=::deleteController.entity><ma-list-button ng-if=::entity.listView().enabled entity=::entity></ma-list-button></ma-view-actions><h1 compile=::deleteController.title>{{ 'DELETE' | translate }} {{ ::deleteController.view.entity.label() | humanize:true | singularize | translate }} #{{ ::entry.identifierValue }}</h1><p class=lead ng-if=::deleteController.description compile=::deleteController.description>{{ ::deleteController.description }}</p></div></div></div><div class=row id=delete-view><div class=col-lg-12><p translate=ARE_YOU_SURE></p><button class=\"btn btn-danger\" ng-click=deleteController.deleteOne() translate=YES></button> <button class=\"btn btn-default\" ng-click=deleteController.back() translate=NO></button></div></div>";

/***/ },
/* 351 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div class=page-header><ma-view-actions override=::formController.actions entry=entry entity=::formController.entity><ma-list-button ng-if=::entity.listView().enabled entity=::entity></ma-list-button></ma-view-actions><h1 compile=::formController.title>{{ 'CREATE_NEW' | translate }} {{ ::formController.view.entity.label() | humanize:true | singularize | translate }}</h1><p class=lead ng-if=::formController.description compile=::formController.description>{{ ::formController.description }}</p></div></div></div><div class=row id=create-view ng-class=\"::'ng-admin-entity-' + formController.entity.name()\"><form class=\"col-lg-12 form-horizontal\" name=formController.form ng-submit=formController.submitCreation($event)><div ng-repeat=\"field in ::formController.fields track by $index\" compile=::field.getTemplateValueWithLabel(entry)><ma-field field=::field value=entry.values[field.name()] entry=entry entity=::entity form=formController.form datastore=::formController.dataStore></ma-field></div><div class=form-group><div class=\"col-sm-offset-2 col-sm-10\"><ma-submit-button label=SUBMIT></ma-submit-button></div></div></form></div>";

/***/ },
/* 352 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div class=page-header><ma-view-actions override=::formController.actions entry=entry entity=::formController.entity><ma-list-button ng-if=::entity.listView().enabled entity=::entity></ma-list-button><ma-delete-button ng-if=::entity.deletionView().enabled entry=entry entity=::entity></ma-delete-button></ma-view-actions><h1 compile=::formController.title>{{ 'EDIT' | translate }} {{ ::formController.entity.label() | humanize:true | singularize | translate }} #{{ ::entry.identifierValue }}</h1><p class=lead ng-if=::formController.description compile=::formController.description>{{ ::formController.description }}</p></div></div></div><div class=row id=edit-view ng-class=\"::'ng-admin-entity-' + formController.entity.name()\"><form class=\"col-lg-12 form-horizontal\" name=formController.form ng-submit=formController.submitEdition($event)><div ng-repeat=\"field in ::formController.fields track by $index\" compile=::field.getTemplateValueWithLabel(entry)><ma-field field=::field value=entry.values[field.name()] entry=entry entity=::entity form=formController.form datastore=::formController.dataStore></ma-field></div><div class=form-group><div class=\"col-sm-offset-2 col-sm-10\"><ma-submit-button label=SAVE_CHANGES></ma-submit-button></div></div></form></div>";

/***/ },
/* 353 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row list-view\" ng-class=\"::'ng-admin-entity-' + listController.entity.name()\"><div class=col-lg-12><ma-datagrid name=\"{{ ::listController.view.name() }}\" entries=listController.dataStore.getEntries(listController.entity.uniqueId) selection=selection fields=::listController.fields list-actions=::listController.listActions entity=::listController.entity sort-field=::listController.sortField sort-dir=::listController.sortDir entry-css-classes=::listController.entryCssClasses datastore=listController.dataStore></ma-datagrid></div></div><div class=row ng-if=::!listController.infinitePagination><div class=col-lg-12><ma-datagrid-pagination page=\"{{ listController.page }}\" per-page=\"{{ ::listController.view.perPage() }}\" total-items=\"{{ listController.totalItems }}\" set-page=::listController.setPageCallback></ma-datagrid-pagination></div></div><ma-datagrid-infinite-pagination ng-if=::listController.infinitePagination per-page=\"{{ ::listController.view.perPage() }}\" total-items=\"{{ ::listController.totalItems }}\" next-page=::listController.nextPageCallback></ma-datagrid-infinite-pagination>";

/***/ },
/* 354 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row list-header\"><div class=col-lg-12><div class=page-header><ma-view-actions override=::llCtrl.actions selection=selection batch-buttons=::llCtrl.batchActions entity=::llCtrl.entity datastore=::llCtrl.dataStore search=::llCtrl.search filters=::llCtrl.filters enabled-filters=llCtrl.enabledFilters enable-filter=llCtrl.enableFilter><ma-filter-button filters=filters() enabled-filters=enabledFilters enable-filter=enableFilter()></ma-filter-button><ma-view-batch-actions buttons=::batchButtons() selection=selection entity=::entity></ma-view-batch-actions><ma-export-to-csv-button entity=::entity datastore=::datastore></ma-export-to-csv-button><ma-create-button ng-if=::entity.creationView().enabled entity=::entity></ma-create-button></ma-view-actions><h1 compile=::llCtrl.view.title()>{{ ::llCtrl.view.entity.label() | humanize | pluralize | translate }} {{ 'LIST' | translate }}</h1><p class=lead ng-if=::llCtrl.view.description() compile=::llCtrl.view.description()>{{ ::llCtrl.view.description() }}</p></div><ma-filter-form ng-if=llCtrl.hasFilters filters=llCtrl.enabledFilters values=llCtrl.search datastore=::llCtrl.dataStore remove-filter=::llCtrl.removeFilter></ma-filter-form></div></div><div ui-view=grid></div>";

/***/ },
/* 355 */
/***/ function(module, exports) {

	module.exports = "<nav class=pagination-bar><div class=total ng-if=\"paginationCtrl.totalItems > 0\" translate=PAGINATION translate-values=\"{ begin: paginationCtrl.offsetBegin, end: paginationCtrl.offsetEnd, total: paginationCtrl.totalItems }\"></div><div class=\"total no-record\" ng-if=\"paginationCtrl.totalItems == 0\"><strong translate=NO_PAGINATION></strong></div><ul class=\"pagination pagination-sm pull-right\" role=group aria-label=pagination ng-if=paginationCtrl.displayPagination><li><a href ng-if=\"paginationCtrl.page != 1\" ng-click=\"paginationCtrl.setPage(paginationCtrl.page - 1)\" translate=PREVIOUS></a></li><li ng-repeat=\"n in paginationCtrl.range(paginationCtrl.page) track by $index\" ng-class=\"{'active': n == paginationCtrl.page}\"><a href ng-if=\"n != '.'\" ng-click=paginationCtrl.setPage(n)>{{ n }}</a> <span ng-if=\"n == '.'\">&hellip;</span></li><li><a href ng-if=\"paginationCtrl.page != paginationCtrl.nbPages\" ng-click=\"paginationCtrl.setPage(paginationCtrl.page + 1)\" translate=NEXT></a></li></ul></nav>";

/***/ },
/* 356 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div class=page-header><ma-view-actions override=::showController.actions entry=entry entity=::showController.entity><ma-list-button ng-if=::entity.listView().enabled entity=::entity></ma-list-button><ma-edit-button ng-if=::entity.editionView().enabled entry=entry entity=::entity></ma-edit-button><ma-delete-button ng-if=::entity.deletionView().enabled entry=entry entity=::entity></ma-delete-button></ma-view-actions><h1 compile=::showController.title>{{ ::showController.view.entity.label() | humanize | singularize | translate }} #{{ ::entry.identifierValue }} {{ 'DETAIL' | translate }}</h1><p class=lead ng-if=::showController.description compile=::showController.description>{{ ::showController.description }}</p></div></div></div><div class=\"row form-horizontal\" id=show-view><div ng-repeat=\"field in ::showController.fields track by $index\" compile=::field.getTemplateValueWithLabel(entry)><ma-show-item field=::field entry=::entry entity=::showController.entity datastore=::showController.dataStore></ma-show-item></div></div>";

/***/ },
/* 357 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div class=page-header><h1>{{ 'NOT_FOUND' | translate }}</h1></div></div></div><div class=\"row dashboard-content\"><div class=col-lg-12>{{ 'NOT_FOUND_DETAILS' | translate }}<br><br><br><br></div><pre class=\"ascii col-lg-offset-4 col-lg-4 col-md-offset-3 col-md-6 col-sm-offset-2 col-sm-8 col-cs-offset-1 col-xs-10\">\n\n       |\\      _,,,---,,_\n       /,`.-'`'    -.  ;-;;,_\n      |,4-  ) )-,_..;\\ (  `'-'\n     '---''(_/--'  `-'\\_)\n\n    </pre></div>";

/***/ },
/* 358 */
/***/ function(module, exports) {

	module.exports = "<div class=row ng-if=dashboardController.hasEntities><div class=col-lg-12><div class=page-header><h1>{{ 'Dashboard' | translate }}</h1></div></div></div><div class=\"row dashboard-content\"><div class=col-lg-6><div class=\"panel panel-default\" ng-repeat=\"collection in dashboardController.collections | orderElement\" ng-if=$even><ma-dashboard-panel collection=collection entries=dashboardController.entries[collection.name()] datastore=dashboardController.datastore></ma-dashboard-panel></div></div><div class=col-lg-6><div class=\"panel panel-default\" ng-repeat=\"collection in dashboardController.collections | orderElement\" ng-if=$odd><ma-dashboard-panel collection=collection entries=dashboardController.entries[collection.name()] datastore=dashboardController.datastore></ma-dashboard-panel></div></div></div><div class=row ng-if=!dashboardController.hasEntities><div class=col-lg-12><div class=dashboard-invite><p>All dependencies are set, ng-admin is ready to run!</p><p>Now you can <a href=https://github.com/marmelab/ng-admin/blob/master/README.md#configuring-ng-admin>update the configuration</a>: add entities to the admin, then refresh.</p></div></div></div>";

/***/ },
/* 359 */
/***/ function(module, exports) {

	module.exports = "<div id=wrapper><nav id=header-nav class=\"navbar navbar-default navbar-static-top\" role=navigation><span compile=::appController.header><div class=navbar-header><button type=button class=navbar-toggle ng-click=\"isCollapsed = !isCollapsed\"><span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a href=# ng-click=appController.displayHome() class=navbar-brand>{{ ::appController.applicationName }}</a></div></span><ma-menu-bar menu=::appController.menu></ma-menu-bar></nav><div id=page-wrapper><div ui-view></div></div><div id=loader></div></div>";

/***/ },
/* 360 */
/***/ function(module, exports) {

	module.exports = "<div class=\"navbar-default sidebar\" role=navigation compile=menu.template()><div class=\"sidebar-nav navbar-collapse collapse\" uib-collapse=$parent.isCollapsed><ul class=nav id=side-menu><li class=entities-repeat ng-repeat=\"(key, menu) in ::menu.children()\" data-menu-id=\"{{ ::menu.uuid }}\" compile=menu.template()><a ng-if=::menu.hasChild() ng-click=toggleMenu(menu) ng-class=\"::{'active': menu.isActive(path)}\"><span compile=::menu.icon()><span class=\"glyphicon glyphicon-list\"></span></span> {{ menu.title() | translate }} <span class=\"glyphicon arrow\" ng-class=\"::{'glyphicon-menu-down': isOpen(menu), 'glyphicon-menu-right': !isOpen(menu) }\"></span></a> <a ng-if=::!menu.hasChild() href=\"#{{ menu.link() }}\" ng-click=activateLink(menu) ng-class=\"::{'active': menu.isActive(path)}\"><span compile=::menu.icon()><span class=\"glyphicon glyphicon-list\"></span></span> {{ menu.title() | translate }}</a><ul ng-if=::menu.hasChild() class=\"nav nav-second-level collapsible\" ng-class=\"::{'collapsed': !isOpen(menu) }\"><li ng-repeat=\"menu in ::menu.children()\" data-menu-id=\"{{ ::menu.uuid }}\" compile=menu.template()><a href=#{{menu.link()}} ng-click=activateLink(menu) ng-class=\"::{'active': menu.isActive(path)}\"><span compile=::menu.icon()><span class=\"glyphicon glyphicon-list\"></span></span> {{ menu.title() | translate }}</a></li></ul></li></ul></div></div>";

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 40,
		"./af.js": 40,
		"./ar": 44,
		"./ar-ma": 41,
		"./ar-ma.js": 41,
		"./ar-sa": 42,
		"./ar-sa.js": 42,
		"./ar-tn": 43,
		"./ar-tn.js": 43,
		"./ar.js": 44,
		"./az": 45,
		"./az.js": 45,
		"./be": 46,
		"./be.js": 46,
		"./bg": 47,
		"./bg.js": 47,
		"./bn": 48,
		"./bn.js": 48,
		"./bo": 49,
		"./bo.js": 49,
		"./br": 50,
		"./br.js": 50,
		"./bs": 51,
		"./bs.js": 51,
		"./ca": 52,
		"./ca.js": 52,
		"./cs": 53,
		"./cs.js": 53,
		"./cv": 54,
		"./cv.js": 54,
		"./cy": 55,
		"./cy.js": 55,
		"./da": 56,
		"./da.js": 56,
		"./de": 58,
		"./de-at": 57,
		"./de-at.js": 57,
		"./de.js": 58,
		"./el": 59,
		"./el.js": 59,
		"./en-au": 60,
		"./en-au.js": 60,
		"./en-ca": 61,
		"./en-ca.js": 61,
		"./en-gb": 62,
		"./en-gb.js": 62,
		"./eo": 63,
		"./eo.js": 63,
		"./es": 64,
		"./es.js": 64,
		"./et": 65,
		"./et.js": 65,
		"./eu": 66,
		"./eu.js": 66,
		"./fa": 67,
		"./fa.js": 67,
		"./fi": 68,
		"./fi.js": 68,
		"./fo": 69,
		"./fo.js": 69,
		"./fr": 71,
		"./fr-ca": 70,
		"./fr-ca.js": 70,
		"./fr.js": 71,
		"./fy": 72,
		"./fy.js": 72,
		"./gl": 73,
		"./gl.js": 73,
		"./he": 74,
		"./he.js": 74,
		"./hi": 75,
		"./hi.js": 75,
		"./hr": 76,
		"./hr.js": 76,
		"./hu": 77,
		"./hu.js": 77,
		"./hy-am": 78,
		"./hy-am.js": 78,
		"./id": 79,
		"./id.js": 79,
		"./is": 80,
		"./is.js": 80,
		"./it": 81,
		"./it.js": 81,
		"./ja": 82,
		"./ja.js": 82,
		"./jv": 83,
		"./jv.js": 83,
		"./ka": 84,
		"./ka.js": 84,
		"./km": 85,
		"./km.js": 85,
		"./ko": 86,
		"./ko.js": 86,
		"./lb": 87,
		"./lb.js": 87,
		"./lt": 88,
		"./lt.js": 88,
		"./lv": 89,
		"./lv.js": 89,
		"./me": 90,
		"./me.js": 90,
		"./mk": 91,
		"./mk.js": 91,
		"./ml": 92,
		"./ml.js": 92,
		"./mr": 93,
		"./mr.js": 93,
		"./ms": 95,
		"./ms-my": 94,
		"./ms-my.js": 94,
		"./ms.js": 95,
		"./my": 96,
		"./my.js": 96,
		"./nb": 97,
		"./nb.js": 97,
		"./ne": 98,
		"./ne.js": 98,
		"./nl": 99,
		"./nl.js": 99,
		"./nn": 100,
		"./nn.js": 100,
		"./pl": 101,
		"./pl.js": 101,
		"./pt": 103,
		"./pt-br": 102,
		"./pt-br.js": 102,
		"./pt.js": 103,
		"./ro": 104,
		"./ro.js": 104,
		"./ru": 105,
		"./ru.js": 105,
		"./si": 106,
		"./si.js": 106,
		"./sk": 107,
		"./sk.js": 107,
		"./sl": 108,
		"./sl.js": 108,
		"./sq": 109,
		"./sq.js": 109,
		"./sr": 111,
		"./sr-cyrl": 110,
		"./sr-cyrl.js": 110,
		"./sr.js": 111,
		"./sv": 112,
		"./sv.js": 112,
		"./ta": 113,
		"./ta.js": 113,
		"./th": 114,
		"./th.js": 114,
		"./tl-ph": 115,
		"./tl-ph.js": 115,
		"./tr": 116,
		"./tr.js": 116,
		"./tzl": 117,
		"./tzl.js": 117,
		"./tzm": 119,
		"./tzm-latn": 118,
		"./tzm-latn.js": 118,
		"./tzm.js": 119,
		"./uk": 120,
		"./uk.js": 120,
		"./uz": 121,
		"./uz.js": 121,
		"./vi": 122,
		"./vi.js": 122,
		"./zh-cn": 123,
		"./zh-cn.js": 123,
		"./zh-tw": 124,
		"./zh-tw.js": 124
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 361;


/***/ },
/* 362 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 363 */
/***/ function(module, exports) {

	module.exports = window;

/***/ },
/* 364 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** main.js
 **/